(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("StreamrClient", [], factory);
	else if(typeof exports === 'object')
		exports["StreamrClient"] = factory();
	else
		root["StreamrClient"] = factory();
})(globalThis, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "../../node_modules/@ethersproject/abi/lib.esm/_version.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: () => (/* binding */ version)
/* harmony export */ });
const version = "abi/5.7.0";
//# sourceMappingURL=_version.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/abi/lib.esm/abi-coder.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  R: () => (/* binding */ AbiCoder),
  $: () => (/* binding */ defaultAbiCoder)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var properties_lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abi/lib.esm/_version.js
var _version = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/_version.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/abstract-coder.js
var abstract_coder = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/coders/abstract-coder.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/address/lib.esm/index.js + 1 modules
var address_lib_esm = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/address.js




class AddressCoder extends abstract_coder/* Coder */.XI {
    constructor(localName) {
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0,address_lib_esm.getAddress)(value);
        }
        catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0,address_lib_esm.getAddress)((0,lib_esm.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
}
//# sourceMappingURL=address.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/anonymous.js


// Clones the functionality of an existing Coder, but without a localName
class AnonymousCoder extends abstract_coder/* Coder */.XI {
    constructor(coder) {
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}
//# sourceMappingURL=anonymous.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/array.js



const logger = new logger_lib_esm.Logger(_version/* version */.i);


function pack(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) {
        arrayValues = values;
    }
    else if (values && typeof (values) === "object") {
        let unique = {};
        arrayValues = coders.map((coder) => {
            const name = coder.localName;
            if (!name) {
                logger.throwError("cannot encode object for signature with missing names", logger_lib_esm.Logger.errors.INVALID_ARGUMENT, {
                    argument: "values",
                    coder: coder,
                    value: values
                });
            }
            if (unique[name]) {
                logger.throwError("cannot encode object for signature with duplicate names", logger_lib_esm.Logger.errors.INVALID_ARGUMENT, {
                    argument: "values",
                    coder: coder,
                    value: values
                });
            }
            unique[name] = true;
            return values[name];
        });
    }
    else {
        logger.throwArgumentError("invalid tuple value", "tuple", values);
    }
    if (coders.length !== arrayValues.length) {
        logger.throwArgumentError("types/value length mismatch", "tuple", values);
    }
    let staticWriter = new abstract_coder/* Writer */.QV(writer.wordSize);
    let dynamicWriter = new abstract_coder/* Writer */.QV(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index) => {
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset) => {
                updateFunc(baseOffset + dynamicOffset);
            });
        }
        else {
            coder.encode(staticWriter, value);
        }
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func) => { func(staticWriter.length); });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function unpack(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder) => {
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            }
            catch (error) {
                // Cannot recover from this
                if (error.code === logger_lib_esm.Logger.errors.BUFFER_OVERRUN) {
                    throw error;
                }
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        }
        else {
            try {
                value = coder.decode(reader);
            }
            catch (error) {
                // Cannot recover from this
                if (error.code === logger_lib_esm.Logger.errors.BUFFER_OVERRUN) {
                    throw error;
                }
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        }
        if (value != undefined) {
            values.push(value);
        }
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder) => {
        const name = coder.localName;
        if (name) {
            if (!accum[name]) {
                accum[name] = 0;
            }
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index) => {
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) {
            return;
        }
        if (name === "length") {
            name = "_length";
        }
        if (values[name] != null) {
            return;
        }
        const value = values[index];
        if (value instanceof Error) {
            Object.defineProperty(values, name, {
                enumerable: true,
                get: () => { throw value; }
            });
        }
        else {
            values[name] = value;
        }
    });
    for (let i = 0; i < values.length; i++) {
        const value = values[i];
        if (value instanceof Error) {
            Object.defineProperty(values, i, {
                enumerable: true,
                get: () => { throw value; }
            });
        }
    }
    return Object.freeze(values);
}
class ArrayCoder extends abstract_coder/* Coder */.XI {
    constructor(coder, length, localName) {
        const type = (coder.type + "[" + (length >= 0 ? length : "") + "]");
        const dynamic = (length === -1 || coder.dynamic);
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for (let i = 0; i < this.length; i++) {
            result.push(defaultChild);
        }
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) {
            this._throwError("expected array value", value);
        }
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? (" " + this.localName) : ""));
        let coders = [];
        for (let i = 0; i < value.length; i++) {
            coders.push(this.coder);
        }
        return pack(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) {
                logger.throwError("insufficient data length", logger_lib_esm.Logger.errors.BUFFER_OVERRUN, {
                    length: reader._data.length,
                    count: count
                });
            }
        }
        let coders = [];
        for (let i = 0; i < count; i++) {
            coders.push(new AnonymousCoder(this.coder));
        }
        return reader.coerce(this.name, unpack(reader, coders));
    }
}
//# sourceMappingURL=array.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/boolean.js


class BooleanCoder extends abstract_coder/* Coder */.XI {
    constructor(localName) {
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}
//# sourceMappingURL=boolean.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/bytes.js



class DynamicBytesCoder extends abstract_coder/* Coder */.XI {
    constructor(type, localName) {
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0,lib_esm.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class BytesCoder extends DynamicBytesCoder {
    constructor(localName) {
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0,lib_esm.hexlify)(super.decode(reader)));
    }
}
//# sourceMappingURL=bytes.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/fixed-bytes.js



// @TODO: Merge this with bytes
class FixedBytesCoder extends abstract_coder/* Coder */.XI {
    constructor(size, localName) {
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return ("0x0000000000000000000000000000000000000000000000000000000000000000").substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0,lib_esm.arrayify)(value);
        if (data.length !== this.size) {
            this._throwError("incorrect data length", value);
        }
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0,lib_esm.hexlify)(reader.readBytes(this.size)));
    }
}
//# sourceMappingURL=fixed-bytes.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/null.js


class NullCoder extends abstract_coder/* Coder */.XI {
    constructor(localName) {
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) {
            this._throwError("not null", value);
        }
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}
//# sourceMappingURL=null.js.map
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__("../../node_modules/@ethersproject/constants/lib.esm/bignumbers.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/number.js




class NumberCoder extends abstract_coder/* Coder */.XI {
    constructor(size, signed, localName) {
        const name = ((signed ? "int" : "uint") + (size * 8));
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = bignumber/* BigNumber.from */.O$.from(value);
        // Check bounds are safe for encoding
        let maxUintValue = bignumbers/* MaxUint256.mask */.Bz.mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add(bignumbers/* One */.fh).mul(bignumbers/* NegativeOne */.tL))) {
                this._throwError("value out-of-bounds", value);
            }
        }
        else if (v.lt(bignumbers/* Zero */._Y) || v.gt(maxUintValue.mask(this.size * 8))) {
            this._throwError("value out-of-bounds", value);
        }
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) {
            v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        }
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) {
            value = value.fromTwos(this.size * 8);
        }
        return reader.coerce(this.name, value);
    }
}
//# sourceMappingURL=number.js.map
// EXTERNAL MODULE: ../../node_modules/@ethersproject/strings/lib.esm/utf8.js + 1 modules
var utf8 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/string.js



class StringCoder extends DynamicBytesCoder {
    constructor(localName) {
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0,utf8/* toUtf8Bytes */.Y0)(value));
    }
    decode(reader) {
        return (0,utf8/* toUtf8String */.ZN)(super.decode(reader));
    }
}
//# sourceMappingURL=string.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/tuple.js



class TupleCoder extends abstract_coder/* Coder */.XI {
    constructor(coders, localName) {
        let dynamic = false;
        const types = [];
        coders.forEach((coder) => {
            if (coder.dynamic) {
                dynamic = true;
            }
            types.push(coder.type);
        });
        const type = ("tuple(" + types.join(",") + ")");
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder) => {
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder) => {
            const name = coder.localName;
            if (name) {
                if (!accum[name]) {
                    accum[name] = 0;
                }
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index) => {
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) {
                return;
            }
            if (name === "length") {
                name = "_length";
            }
            if (values[name] != null) {
                return;
            }
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return pack(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, unpack(reader, this.coders));
    }
}
//# sourceMappingURL=tuple.js.map
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abi/lib.esm/fragments.js
var fragments = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/fragments.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abi/lib.esm/abi-coder.js

// See: https://github.com/ethereum/wiki/wiki/Ethereum-Contract-ABI




const abi_coder_logger = new logger_lib_esm.Logger(_version/* version */.i);











const paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class AbiCoder {
    constructor(coerceFunc) {
        (0,properties_lib_esm.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch (param.baseType) {
            case "address":
                return new AddressCoder(param.name);
            case "bool":
                return new BooleanCoder(param.name);
            case "string":
                return new StringCoder(param.name);
            case "bytes":
                return new BytesCoder(param.name);
            case "array":
                return new ArrayCoder(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new TupleCoder((param.components || []).map((component) => {
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new NullCoder(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match(paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || (size % 8) !== 0) {
                abi_coder_logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            }
            return new NumberCoder(size / 8, (match[1] === "int"), param.name);
        }
        // bytes[0-9]+
        match = param.type.match(paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) {
                abi_coder_logger.throwArgumentError("invalid bytes length", "param", param);
            }
            return new FixedBytesCoder(size, param.name);
        }
        return abi_coder_logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() { return 32; }
    _getReader(data, allowLoose) {
        return new abstract_coder/* Reader */.Ej(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new abstract_coder/* Writer */.QV(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type) => this._getCoder(fragments/* ParamType.from */._R.from(type)));
        const coder = new TupleCoder(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) {
            abi_coder_logger.throwError("types/values length mismatch", logger_lib_esm.Logger.errors.INVALID_ARGUMENT, {
                count: { types: types.length, values: values.length },
                value: { types: types, values: values }
            });
        }
        const coders = types.map((type) => this._getCoder(fragments/* ParamType.from */._R.from(type)));
        const coder = (new TupleCoder(coders, "_"));
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type) => this._getCoder(fragments/* ParamType.from */._R.from(type)));
        const coder = new TupleCoder(coders, "_");
        return coder.decode(this._getReader((0,lib_esm.arrayify)(data), loose));
    }
}
const defaultAbiCoder = new AbiCoder();
//# sourceMappingURL=abi-coder.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/abi/lib.esm/coders/abstract-coder.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BR: () => (/* binding */ checkResultErrors),
/* harmony export */   Ej: () => (/* binding */ Reader),
/* harmony export */   QV: () => (/* binding */ Writer),
/* harmony export */   XI: () => (/* binding */ Coder)
/* harmony export */ });
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
/* harmony import */ var _ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
/* harmony import */ var _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
/* harmony import */ var _version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/_version.js");






const logger = new _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger(_version__WEBPACK_IMPORTED_MODULE_1__/* .version */ .i);
function checkResultErrors(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function (path, object) {
        if (!Array.isArray(object)) {
            return;
        }
        for (let key in object) {
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            }
            catch (error) {
                errors.push({ path: childPath, error: error });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class Coder {
    constructor(name, type, localName, dynamic) {
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        logger.throwArgumentError(message, this.localName, value);
    }
}
class Writer {
    constructor(wordSize) {
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexConcat)(this._data);
    }
    get length() { return this._dataLength; }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) {
            bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.concat)([bytes, this._padding.slice(paddingOffset)]);
        }
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.arrayify)(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_4__/* .BigNumber.from */ .O$.from(value));
        if (bytes.length > this.wordSize) {
            logger.throwError("value out-of-bounds", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.BUFFER_OVERRUN, {
                length: this.wordSize,
                offset: bytes.length
            });
        }
        if (bytes.length % this.wordSize) {
            bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.concat)([this._padding.slice(bytes.length % this.wordSize), bytes]);
        }
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value) => {
            this._data[offset] = this._getValue(value);
        };
    }
}
class Reader {
    constructor(data, wordSize, coerceFunc, allowLoose) {
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "_data", (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.arrayify)(data));
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() { return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexlify)(this._data); }
    get consumed() { return this._offset; }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) {
            value = value.toNumber();
        }
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) {
            return this._coerceFunc(name, value);
        }
        return Reader.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) {
                alignedLength = length;
            }
            else {
                logger.throwError("data out-of-bounds", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.BUFFER_OVERRUN, {
                    length: this._data.length,
                    offset: this._offset + alignedLength
                });
            }
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new Reader(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_4__/* .BigNumber.from */ .O$.from(this.readBytes(this.wordSize));
    }
}
//# sourceMappingURL=abstract-coder.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/abi/lib.esm/fragments.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HY: () => (/* binding */ Fragment),
/* harmony export */   IC: () => (/* binding */ ErrorFragment),
/* harmony export */   QV: () => (/* binding */ EventFragment),
/* harmony export */   Xg: () => (/* binding */ ConstructorFragment),
/* harmony export */   YW: () => (/* binding */ FunctionFragment),
/* harmony export */   _R: () => (/* binding */ ParamType),
/* harmony export */   pc: () => (/* binding */ FormatTypes)
/* harmony export */ });
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
/* harmony import */ var _ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
/* harmony import */ var _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
/* harmony import */ var _version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/_version.js");





const logger = new _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger(_version__WEBPACK_IMPORTED_MODULE_1__/* .version */ .i);
;
const _constructorGuard = {};
let ModifiersBytes = { calldata: true, memory: true, storage: true };
let ModifiersNest = { calldata: true, memory: true };
function checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if (ModifiersBytes[name]) {
            return true;
        }
    }
    else if (type === "address") {
        if (name === "payable") {
            return true;
        }
    }
    else if (type.indexOf("[") >= 0 || type === "tuple") {
        if (ModifiersNest[name]) {
            return true;
        }
    }
    if (ModifiersBytes[name] || name === "payable") {
        logger.throwArgumentError("invalid modifier", "name", name);
    }
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = { type: "", name: "", parent: parent, state: { allowType: true } };
        if (allowIndexed) {
            node.indexed = false;
        }
        return node;
    }
    let parent = { type: "", name: "", state: { allowType: true } };
    let node = parent;
    for (let i = 0; i < param.length; i++) {
        let c = param[i];
        switch (c) {
            case "(":
                if (node.state.allowType && node.type === "") {
                    node.type = "tuple";
                }
                else if (!node.state.allowParams) {
                    throwError(i);
                }
                node.state.allowType = false;
                node.type = verifyType(node.type);
                node.components = [newNode(node)];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) {
                        throwError(i);
                    }
                    node.indexed = true;
                    node.name = "";
                }
                if (checkModifier(node.type, node.name)) {
                    node.name = "";
                }
                node.type = verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) {
                    throwError(i);
                }
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) {
                        throwError(i);
                    }
                    node.indexed = true;
                    node.name = "";
                }
                if (checkModifier(node.type, node.name)) {
                    node.name = "";
                }
                node.type = verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) {
                                throwError(i);
                            }
                            if (node.indexed) {
                                throwError(i);
                            }
                            node.indexed = true;
                            node.name = "";
                        }
                        else if (checkModifier(node.type, node.name)) {
                            node.name = "";
                        }
                        else {
                            node.state.allowName = false;
                        }
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) {
                    throwError(i);
                }
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) {
                    throwError(i);
                }
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                }
                else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                }
                else if (node.state.readArray) {
                    node.type += c;
                }
                else {
                    throwError(i);
                }
        }
    }
    if (node.parent) {
        logger.throwArgumentError("unexpected eof", "param", param);
    }
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) {
            throwError(originalParam.length - 7);
        }
        if (node.indexed) {
            throwError(originalParam.length - 7);
        }
        node.indexed = true;
        node.name = "";
    }
    else if (checkModifier(node.type, node.name)) {
        node.name = "";
    }
    parent.type = verifyType(parent.type);
    return parent;
}
function populate(object, params) {
    for (let key in params) {
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(object, key, params[key]);
    }
}
const FormatTypes = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class ParamType {
    constructor(constructorGuard, params) {
        if (constructorGuard !== _constructorGuard) {
            logger.throwError("use fromString", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "new ParamType()"
            });
        }
        populate(this, params);
        let match = this.type.match(paramTypeArray);
        if (match) {
            populate(this, {
                arrayLength: parseInt(match[2] || "-1"),
                arrayChildren: ParamType.fromObject({
                    type: match[1],
                    components: this.components
                }),
                baseType: "array"
            });
        }
        else {
            populate(this, {
                arrayLength: null,
                arrayChildren: null,
                baseType: ((this.components != null) ? "tuple" : this.type)
            });
        }
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            logger.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            let result = {
                type: ((this.baseType === "tuple") ? "tuple" : this.type),
                name: (this.name || undefined)
            };
            if (typeof (this.indexed) === "boolean") {
                result.indexed = this.indexed;
            }
            if (this.components) {
                result.components = this.components.map((comp) => JSON.parse(comp.format(format)));
            }
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        }
        else {
            if (this.baseType === "tuple") {
                if (format !== FormatTypes.sighash) {
                    result += this.type;
                }
                result += "(" + this.components.map((comp) => comp.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ")";
            }
            else {
                result += this.type;
            }
        }
        if (format !== FormatTypes.sighash) {
            if (this.indexed === true) {
                result += " indexed";
            }
            if (format === FormatTypes.full && this.name) {
                result += " " + this.name;
            }
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof (value) === "string") {
            return ParamType.fromString(value, allowIndexed);
        }
        return ParamType.fromObject(value);
    }
    static fromObject(value) {
        if (ParamType.isParamType(value)) {
            return value;
        }
        return new ParamType(_constructorGuard, {
            name: (value.name || null),
            type: verifyType(value.type),
            indexed: ((value.indexed == null) ? null : !!value.indexed),
            components: (value.components ? value.components.map(ParamType.fromObject) : null)
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return ParamType.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify(parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
;
function parseParams(value, allowIndex) {
    return splitNesting(value).map((param) => ParamType.fromString(param, allowIndex));
}
class Fragment {
    constructor(constructorGuard, params) {
        if (constructorGuard !== _constructorGuard) {
            logger.throwError("use a static from method", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "new Fragment()"
            });
        }
        populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if (Fragment.isFragment(value)) {
            return value;
        }
        if (typeof (value) === "string") {
            return Fragment.fromString(value);
        }
        return Fragment.fromObject(value);
    }
    static fromObject(value) {
        if (Fragment.isFragment(value)) {
            return value;
        }
        switch (value.type) {
            case "function":
                return FunctionFragment.fromObject(value);
            case "event":
                return EventFragment.fromObject(value);
            case "constructor":
                return ConstructorFragment.fromObject(value);
            case "error":
                return ErrorFragment.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") {
            return EventFragment.fromString(value.substring(5).trim());
        }
        else if (value.split(" ")[0] === "function") {
            return FunctionFragment.fromString(value.substring(8).trim());
        }
        else if (value.split("(")[0].trim() === "constructor") {
            return ConstructorFragment.fromString(value.trim());
        }
        else if (value.split(" ")[0] === "error") {
            return ErrorFragment.fromString(value.substring(5).trim());
        }
        return logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class EventFragment extends Fragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            logger.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "event",
                anonymous: this.anonymous,
                name: this.name,
                inputs: this.inputs.map((input) => JSON.parse(input.format(format)))
            });
        }
        let result = "";
        if (format !== FormatTypes.sighash) {
            result += "event ";
        }
        result += this.name + "(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        if (format !== FormatTypes.sighash) {
            if (this.anonymous) {
                result += "anonymous ";
            }
        }
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return EventFragment.fromString(value);
        }
        return EventFragment.fromObject(value);
    }
    static fromObject(value) {
        if (EventFragment.isEventFragment(value)) {
            return value;
        }
        if (value.type !== "event") {
            logger.throwArgumentError("invalid event object", "value", value);
        }
        const params = {
            name: verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : []),
            type: "event"
        };
        return new EventFragment(_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match(regexParen);
        if (!match) {
            logger.throwArgumentError("invalid event string", "value", value);
        }
        let anonymous = false;
        match[3].split(" ").forEach((modifier) => {
            switch (modifier.trim()) {
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    logger.warn("unknown modifier: " + modifier);
            }
        });
        return EventFragment.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return (value && value._isFragment && value.type === "event");
    }
}
function parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) {
            logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        }
        if (!comps[1].match(/^[0-9]+$/)) {
            logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        }
        params.gas = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_3__/* .BigNumber.from */ .O$.from(comps[1]);
        return comps[0];
    }
    return value;
}
function parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier) => {
        switch (modifier.trim()) {
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = (result.stateMutability === "view" || result.stateMutability === "pure");
        if (value.constant != null) {
            if ((!!value.constant) !== result.constant) {
                logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
            }
        }
        // Set (and check things are consistent) the payable property
        result.payable = (result.stateMutability === "payable");
        if (value.payable != null) {
            if ((!!value.payable) !== result.payable) {
                logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
            }
        }
    }
    else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") {
            logger.throwArgumentError("unable to determine stateMutability", "value", value);
        }
        result.constant = !!value.constant;
        if (result.constant) {
            result.stateMutability = "view";
        }
        else {
            result.stateMutability = (result.payable ? "payable" : "nonpayable");
        }
        if (result.payable && result.constant) {
            logger.throwArgumentError("cannot have constant payable function", "value", value);
        }
    }
    else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = (result.constant ? "view" : "payable");
    }
    else if (value.type !== "constructor") {
        logger.throwArgumentError("unable to determine stateMutability", "value", value);
    }
    return result;
}
class ConstructorFragment extends Fragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            logger.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "constructor",
                stateMutability: ((this.stateMutability !== "nonpayable") ? this.stateMutability : undefined),
                payable: this.payable,
                gas: (this.gas ? this.gas.toNumber() : undefined),
                inputs: this.inputs.map((input) => JSON.parse(input.format(format)))
            });
        }
        if (format === FormatTypes.sighash) {
            logger.throwError("cannot format a constructor for sighash", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "format(sighash)"
            });
        }
        let result = "constructor(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") {
            result += this.stateMutability + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return ConstructorFragment.fromString(value);
        }
        return ConstructorFragment.fromObject(value);
    }
    static fromObject(value) {
        if (ConstructorFragment.isConstructorFragment(value)) {
            return value;
        }
        if (value.type !== "constructor") {
            logger.throwArgumentError("invalid constructor object", "value", value);
        }
        let state = verifyState(value);
        if (state.constant) {
            logger.throwArgumentError("constructor cannot be constant", "value", value);
        }
        const params = {
            name: null,
            type: value.type,
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : []),
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: (value.gas ? _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_3__/* .BigNumber.from */ .O$.from(value.gas) : null)
        };
        return new ConstructorFragment(_constructorGuard, params);
    }
    static fromString(value) {
        let params = { type: "constructor" };
        value = parseGas(value, params);
        let parens = value.match(regexParen);
        if (!parens || parens[1].trim() !== "constructor") {
            logger.throwArgumentError("invalid constructor string", "value", value);
        }
        params.inputs = parseParams(parens[2].trim(), false);
        parseModifiers(parens[3].trim(), params);
        return ConstructorFragment.fromObject(params);
    }
    static isConstructorFragment(value) {
        return (value && value._isFragment && value.type === "constructor");
    }
}
class FunctionFragment extends ConstructorFragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            logger.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "function",
                name: this.name,
                constant: this.constant,
                stateMutability: ((this.stateMutability !== "nonpayable") ? this.stateMutability : undefined),
                payable: this.payable,
                gas: (this.gas ? this.gas.toNumber() : undefined),
                inputs: this.inputs.map((input) => JSON.parse(input.format(format))),
                outputs: this.outputs.map((output) => JSON.parse(output.format(format))),
            });
        }
        let result = "";
        if (format !== FormatTypes.sighash) {
            result += "function ";
        }
        result += this.name + "(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        if (format !== FormatTypes.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") {
                    result += (this.stateMutability + " ");
                }
            }
            else if (this.constant) {
                result += "view ";
            }
            if (this.outputs && this.outputs.length) {
                result += "returns (" + this.outputs.map((output) => output.format(format)).join(", ") + ") ";
            }
            if (this.gas != null) {
                result += "@" + this.gas.toString() + " ";
            }
        }
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return FunctionFragment.fromString(value);
        }
        return FunctionFragment.fromObject(value);
    }
    static fromObject(value) {
        if (FunctionFragment.isFunctionFragment(value)) {
            return value;
        }
        if (value.type !== "function") {
            logger.throwArgumentError("invalid function object", "value", value);
        }
        let state = verifyState(value);
        const params = {
            type: value.type,
            name: verifyIdentifier(value.name),
            constant: state.constant,
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : []),
            outputs: (value.outputs ? value.outputs.map(ParamType.fromObject) : []),
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: (value.gas ? _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_3__/* .BigNumber.from */ .O$.from(value.gas) : null)
        };
        return new FunctionFragment(_constructorGuard, params);
    }
    static fromString(value) {
        let params = { type: "function" };
        value = parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) {
            logger.throwArgumentError("invalid function string", "value", value);
        }
        let parens = comps[0].match(regexParen);
        if (!parens) {
            logger.throwArgumentError("invalid function signature", "value", value);
        }
        params.name = parens[1].trim();
        if (params.name) {
            verifyIdentifier(params.name);
        }
        params.inputs = parseParams(parens[2], false);
        parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match(regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") {
                logger.throwArgumentError("unexpected tokens", "value", value);
            }
            params.outputs = parseParams(returns[2], false);
        }
        else {
            params.outputs = [];
        }
        return FunctionFragment.fromObject(params);
    }
    static isFunctionFragment(value) {
        return (value && value._isFragment && value.type === "function");
    }
}
//export class StructFragment extends Fragment {
//}
function checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") {
        logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    }
    return fragment;
}
class ErrorFragment extends Fragment {
    format(format) {
        if (!format) {
            format = FormatTypes.sighash;
        }
        if (!FormatTypes[format]) {
            logger.throwArgumentError("invalid format type", "format", format);
        }
        if (format === FormatTypes.json) {
            return JSON.stringify({
                type: "error",
                name: this.name,
                inputs: this.inputs.map((input) => JSON.parse(input.format(format))),
            });
        }
        let result = "";
        if (format !== FormatTypes.sighash) {
            result += "error ";
        }
        result += this.name + "(" + this.inputs.map((input) => input.format(format)).join((format === FormatTypes.full) ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof (value) === "string") {
            return ErrorFragment.fromString(value);
        }
        return ErrorFragment.fromObject(value);
    }
    static fromObject(value) {
        if (ErrorFragment.isErrorFragment(value)) {
            return value;
        }
        if (value.type !== "error") {
            logger.throwArgumentError("invalid error object", "value", value);
        }
        const params = {
            type: value.type,
            name: verifyIdentifier(value.name),
            inputs: (value.inputs ? value.inputs.map(ParamType.fromObject) : [])
        };
        return checkForbidden(new ErrorFragment(_constructorGuard, params));
    }
    static fromString(value) {
        let params = { type: "error" };
        let parens = value.match(regexParen);
        if (!parens) {
            logger.throwArgumentError("invalid error signature", "value", value);
        }
        params.name = parens[1].trim();
        if (params.name) {
            verifyIdentifier(params.name);
        }
        params.inputs = parseParams(parens[2], false);
        return checkForbidden(ErrorFragment.fromObject(params));
    }
    static isErrorFragment(value) {
        return (value && value._isFragment && value.type === "error");
    }
}
function verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) {
        type = "uint256" + type.substring(4);
    }
    else if (type.match(/^int($|[^1-9])/)) {
        type = "int256" + type.substring(3);
    }
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function verifyIdentifier(value) {
    if (!value || !value.match(regexIdentifier)) {
        logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    }
    return value;
}
const regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for (let offset = 0; offset < value.length; offset++) {
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        }
        else {
            accum += c;
            if (c === "(") {
                depth++;
            }
            else if (c === ")") {
                depth--;
                if (depth === -1) {
                    logger.throwArgumentError("unbalanced parenthesis", "value", value);
                }
            }
        }
    }
    if (accum) {
        result.push(accum);
    }
    return result;
}
//# sourceMappingURL=fragments.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/abi/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AbiCoder: () => (/* reexport safe */ _abi_coder__WEBPACK_IMPORTED_MODULE_1__.R),
/* harmony export */   ConstructorFragment: () => (/* reexport safe */ _fragments__WEBPACK_IMPORTED_MODULE_0__.Xg),
/* harmony export */   ErrorFragment: () => (/* reexport safe */ _fragments__WEBPACK_IMPORTED_MODULE_0__.IC),
/* harmony export */   EventFragment: () => (/* reexport safe */ _fragments__WEBPACK_IMPORTED_MODULE_0__.QV),
/* harmony export */   FormatTypes: () => (/* reexport safe */ _fragments__WEBPACK_IMPORTED_MODULE_0__.pc),
/* harmony export */   Fragment: () => (/* reexport safe */ _fragments__WEBPACK_IMPORTED_MODULE_0__.HY),
/* harmony export */   FunctionFragment: () => (/* reexport safe */ _fragments__WEBPACK_IMPORTED_MODULE_0__.YW),
/* harmony export */   Indexed: () => (/* reexport safe */ _interface__WEBPACK_IMPORTED_MODULE_2__.Hk),
/* harmony export */   Interface: () => (/* reexport safe */ _interface__WEBPACK_IMPORTED_MODULE_2__.vU),
/* harmony export */   LogDescription: () => (/* reexport safe */ _interface__WEBPACK_IMPORTED_MODULE_2__.CC),
/* harmony export */   ParamType: () => (/* reexport safe */ _fragments__WEBPACK_IMPORTED_MODULE_0__._R),
/* harmony export */   TransactionDescription: () => (/* reexport safe */ _interface__WEBPACK_IMPORTED_MODULE_2__.vk),
/* harmony export */   checkResultErrors: () => (/* reexport safe */ _interface__WEBPACK_IMPORTED_MODULE_3__.BR),
/* harmony export */   defaultAbiCoder: () => (/* reexport safe */ _abi_coder__WEBPACK_IMPORTED_MODULE_1__.$)
/* harmony export */ });
/* harmony import */ var _fragments__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/fragments.js");
/* harmony import */ var _abi_coder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/abi-coder.js");
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/interface.js");
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/coders/abstract-coder.js");





//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/abi/lib.esm/interface.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CC: () => (/* binding */ LogDescription),
/* harmony export */   Hk: () => (/* binding */ Indexed),
/* harmony export */   vU: () => (/* binding */ Interface),
/* harmony export */   vk: () => (/* binding */ TransactionDescription)
/* harmony export */ });
/* unused harmony export ErrorDescription */
/* harmony import */ var _ethersproject_address__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _ethersproject_hash__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/id.js");
/* harmony import */ var _ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
/* harmony import */ var _ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
/* harmony import */ var _abi_coder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/abi-coder.js");
/* harmony import */ var _fragments__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/fragments.js");
/* harmony import */ var _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
/* harmony import */ var _version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/_version.js");












const logger = new _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger(_version__WEBPACK_IMPORTED_MODULE_1__/* .version */ .i);

class LogDescription extends _ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.Description {
}
class TransactionDescription extends _ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.Description {
}
class ErrorDescription extends _ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.Description {
}
class Indexed extends _ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.Description {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const BuiltinErrors = {
    "0x08c379a0": { signature: "Error(string)", name: "Error", inputs: ["string"], reason: true },
    "0x4e487b71": { signature: "Panic(uint256)", name: "Panic", inputs: ["uint256"] }
};
function wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
/*
function checkNames(fragment: Fragment, type: "input" | "output", params: Array<ParamType>): void {
    params.reduce((accum, param) => {
        if (param.name) {
            if (accum[param.name]) {
                logger.throwArgumentError(`duplicate ${ type } parameter ${ JSON.stringify(param.name) } in ${ fragment.format("full") }`, "fragment", fragment);
            }
            accum[param.name] = true;
        }
        return accum;
    }, <{ [ name: string ]: boolean }>{ });
}
*/
class Interface {
    constructor(fragments) {
        let abi = [];
        if (typeof (fragments) === "string") {
            abi = JSON.parse(fragments);
        }
        else {
            abi = fragments;
        }
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "fragments", abi.map((fragment) => {
            return _fragments__WEBPACK_IMPORTED_MODULE_3__/* .Fragment.from */ .HY.from(fragment);
        }).filter((fragment) => (fragment != null)));
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "_abiCoder", (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.getStatic)(new.target, "getAbiCoder")());
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "functions", {});
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "errors", {});
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "events", {});
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment) => {
            let bucket = null;
            switch (fragment.type) {
                case "constructor":
                    if (this.deploy) {
                        logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) {
            (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "deploy", _fragments__WEBPACK_IMPORTED_MODULE_3__/* .ConstructorFragment.from */ .Xg.from({
                payable: false,
                type: "constructor"
            }));
        }
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) {
            format = _fragments__WEBPACK_IMPORTED_MODULE_3__/* .FormatTypes.full */ .pc.full;
        }
        if (format === _fragments__WEBPACK_IMPORTED_MODULE_3__/* .FormatTypes.sighash */ .pc.sighash) {
            logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        }
        const abi = this.fragments.map((fragment) => fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === _fragments__WEBPACK_IMPORTED_MODULE_3__/* .FormatTypes.json */ .pc.json) {
            return JSON.stringify(abi.map((j) => JSON.parse(j)));
        }
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return _abi_coder__WEBPACK_IMPORTED_MODULE_4__/* .defaultAbiCoder */ .$;
    }
    static getAddress(address) {
        return (0,_ethersproject_address__WEBPACK_IMPORTED_MODULE_5__.getAddress)(address);
    }
    static getSighash(fragment) {
        return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexDataSlice)((0,_ethersproject_hash__WEBPACK_IMPORTED_MODULE_7__.id)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0,_ethersproject_hash__WEBPACK_IMPORTED_MODULE_7__.id)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.isHexString)(nameOrSignatureOrSighash)) {
            for (const name in this.functions) {
                if (nameOrSignatureOrSighash === this.getSighash(name)) {
                    return this.functions[name];
                }
            }
            logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f) => (f.split("(" /* fix:) */)[0] === name));
            if (matching.length === 0) {
                logger.throwArgumentError("no matching function", "name", name);
            }
            else if (matching.length > 1) {
                logger.throwArgumentError("multiple matching functions", "name", name);
            }
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[_fragments__WEBPACK_IMPORTED_MODULE_3__/* .FunctionFragment.fromString */ .YW.fromString(nameOrSignatureOrSighash).format()];
        if (!result) {
            logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        }
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for (const name in this.events) {
                if (topichash === this.getEventTopic(name)) {
                    return this.events[name];
                }
            }
            logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f) => (f.split("(" /* fix:) */)[0] === name));
            if (matching.length === 0) {
                logger.throwArgumentError("no matching event", "name", name);
            }
            else if (matching.length > 1) {
                logger.throwArgumentError("multiple matching events", "name", name);
            }
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[_fragments__WEBPACK_IMPORTED_MODULE_3__/* .EventFragment.fromString */ .QV.fromString(nameOrSignatureOrTopic).format()];
        if (!result) {
            logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        }
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.isHexString)(nameOrSignatureOrSighash)) {
            const getSighash = (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.getStatic)(this.constructor, "getSighash");
            for (const name in this.errors) {
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) {
                    return this.errors[name];
                }
            }
            logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f) => (f.split("(" /* fix:) */)[0] === name));
            if (matching.length === 0) {
                logger.throwArgumentError("no matching error", "name", name);
            }
            else if (matching.length > 1) {
                logger.throwArgumentError("multiple matching errors", "name", name);
            }
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[_fragments__WEBPACK_IMPORTED_MODULE_3__/* .FunctionFragment.fromString */ .YW.fromString(nameOrSignatureOrSighash).format()];
        if (!result) {
            logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        }
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof (fragment) === "string") {
            try {
                fragment = this.getFunction(fragment);
            }
            catch (error) {
                try {
                    fragment = this.getError(fragment);
                }
                catch (_) {
                    throw error;
                }
            }
        }
        return (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        return (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_2__.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof (fragment) === "string") {
            fragment = this.getError(fragment);
        }
        const bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(data);
        if ((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) {
            logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(bytes));
        }
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof (fragment) === "string") {
            fragment = this.getError(fragment);
        }
        return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.concat)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        const bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(data);
        if ((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) {
            logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(bytes));
        }
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        let bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch (bytes.length % this._abiCoder._getWordSize()) {
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                }
                catch (error) { }
                break;
            case 4: {
                const selector = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(bytes.slice(0, 4));
                const builtin = BuiltinErrors[selector];
                if (builtin) {
                    errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                    errorName = builtin.name;
                    errorSignature = builtin.signature;
                    if (builtin.reason) {
                        reason = errorArgs[0];
                    }
                    if (errorName === "Error") {
                        message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                    }
                    else if (errorName === "Panic") {
                        message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    }
                }
                else {
                    try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    }
                    catch (error) { }
                }
                break;
            }
        }
        return logger.throwError("call revert exception" + message, _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(data), errorArgs, errorName, errorSignature, reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof (functionFragment) === "string") {
            functionFragment = this.getFunction(functionFragment);
        }
        return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        if (values.length > eventFragment.inputs.length) {
            logger.throwError("too many arguments for " + eventFragment.format(), _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.UNEXPECTED_ARGUMENT, {
                argument: "values",
                value: values
            });
        }
        let topics = [];
        if (!eventFragment.anonymous) {
            topics.push(this.getEventTopic(eventFragment));
        }
        const encodeTopic = (param, value) => {
            if (param.type === "string") {
                return (0,_ethersproject_hash__WEBPACK_IMPORTED_MODULE_7__.id)(value);
            }
            else if (param.type === "bytes") {
                return (0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_8__.keccak256)((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(value));
            }
            if (param.type === "bool" && typeof (value) === "boolean") {
                value = (value ? "0x01" : "0x00");
            }
            if (param.type.match(/^u?int/)) {
                value = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_9__/* .BigNumber.from */ .O$.from(value).toHexString();
            }
            // Check addresses are valid
            if (param.type === "address") {
                this._abiCoder.encode(["address"], [value]);
            }
            return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexZeroPad)((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(value), 32);
        };
        values.forEach((value, index) => {
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) {
                    logger.throwArgumentError("cannot filter non-indexed parameters; must be null", ("contract." + param.name), value);
                }
                return;
            }
            if (value == null) {
                topics.push(null);
            }
            else if (param.baseType === "array" || param.baseType === "tuple") {
                logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
            }
            else if (Array.isArray(value)) {
                topics.push(value.map((value) => encodeTopic(param, value)));
            }
            else {
                topics.push(encodeTopic(param, value));
            }
        });
        // Trim off trailing nulls
        while (topics.length && topics[topics.length - 1] === null) {
            topics.pop();
        }
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) {
            topics.push(this.getEventTopic(eventFragment));
        }
        if (values.length !== eventFragment.inputs.length) {
            logger.throwArgumentError("event arguments/values mismatch", "values", values);
        }
        eventFragment.inputs.forEach((param, index) => {
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") {
                    topics.push((0,_ethersproject_hash__WEBPACK_IMPORTED_MODULE_7__.id)(value));
                }
                else if (param.type === "bytes") {
                    topics.push((0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_8__.keccak256)(value));
                }
                else if (param.baseType === "tuple" || param.baseType === "array") {
                    // @TODO
                    throw new Error("not implemented");
                }
                else {
                    topics.push(this._abiCoder.encode([param.type], [value]));
                }
            }
            else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof (eventFragment) === "string") {
            eventFragment = this.getEvent(eventFragment);
        }
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) {
                logger.throwError("fragment/topic mismatch", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.INVALID_ARGUMENT, { argument: "topics[0]", expected: topicHash, value: topics[0] });
            }
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index) => {
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push(_fragments__WEBPACK_IMPORTED_MODULE_3__/* .ParamType.fromObject */ ._R.fromObject({ type: "bytes32", name: param.name }));
                    dynamic.push(true);
                }
                else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            }
            else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = (topics != null) ? this._abiCoder.decode(indexed, (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index) => {
            if (param.indexed) {
                if (resultIndexed == null) {
                    result[index] = new Indexed({ _isIndexed: true, hash: null });
                }
                else if (dynamic[index]) {
                    result[index] = new Indexed({ _isIndexed: true, hash: resultIndexed[indexedIndex++] });
                }
                else {
                    try {
                        result[index] = resultIndexed[indexedIndex++];
                    }
                    catch (error) {
                        result[index] = error;
                    }
                }
            }
            else {
                try {
                    result[index] = resultNonIndexed[nonIndexedIndex++];
                }
                catch (error) {
                    result[index] = error;
                }
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) {
                    Object.defineProperty(result, param.name, {
                        enumerable: true,
                        get: () => { throw wrapAccessError(`property ${JSON.stringify(param.name)}`, value); }
                    });
                }
                else {
                    result[param.name] = value;
                }
            }
        });
        // Make all error indexed values throw on access
        for (let i = 0; i < result.length; i++) {
            const value = result[i];
            if (value instanceof Error) {
                Object.defineProperty(result, i, {
                    enumerable: true,
                    get: () => { throw wrapAccessError(`index ${i}`, value); }
                });
            }
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) {
            return null;
        }
        return new TransactionDescription({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_9__/* .BigNumber.from */ .O$.from(tx.value || "0"),
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) {
            return null;
        }
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new LogDescription({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) {
            return null;
        }
        return new ErrorDescription({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */
    static isInterface(value) {
        return !!(value && value._isInterface);
    }
}
//# sourceMappingURL=interface.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/abstract-provider/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Sg: () => (/* binding */ ForkEvent),
  zt: () => (/* binding */ Provider)
});

// UNUSED EXPORTS: BlockForkEvent, TransactionForkEvent, TransactionOrderForkEvent

// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abstract-provider/lib.esm/_version.js
const version = "abstract-provider/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abstract-provider/lib.esm/index.js

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





const logger = new logger_lib_esm.Logger(version);
;
;
//export type CallTransactionable = {
//    call(transaction: TransactionRequest): Promise<TransactionResponse>;
//};
class ForkEvent extends lib_esm.Description {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class BlockForkEvent extends (/* unused pure expression or super */ null && (ForkEvent)) {
    constructor(blockHash, expiry) {
        if (!isHexString(blockHash, 32)) {
            logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        }
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: (expiry || 0),
            blockHash: blockHash
        });
    }
}
class TransactionForkEvent extends (/* unused pure expression or super */ null && (ForkEvent)) {
    constructor(hash, expiry) {
        if (!isHexString(hash, 32)) {
            logger.throwArgumentError("invalid transaction hash", "hash", hash);
        }
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: (expiry || 0),
            hash: hash
        });
    }
}
class TransactionOrderForkEvent extends (/* unused pure expression or super */ null && (ForkEvent)) {
    constructor(beforeHash, afterHash, expiry) {
        if (!isHexString(beforeHash, 32)) {
            logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        }
        if (!isHexString(afterHash, 32)) {
            logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        }
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: (expiry || 0),
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
///////////////////////////////
// Exported Abstracts
class Provider {
    constructor() {
        logger.checkAbstract(new.target, Provider);
        (0,lib_esm.defineReadOnly)(this, "_isProvider", true);
    }
    getFeeData() {
        return __awaiter(this, void 0, void 0, function* () {
            const { block, gasPrice } = yield (0,lib_esm.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error) => {
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = bignumber/* BigNumber.from */.O$.from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return { lastBaseFeePerGas, maxFeePerGas, maxPriorityFeePerGas, gasPrice };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/abstract-signer/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  E: () => (/* binding */ Signer),
  b: () => (/* binding */ VoidSigner)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abstract-signer/lib.esm/_version.js
const version = "abstract-signer/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/abstract-signer/lib.esm/index.js

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const logger = new logger_lib_esm.Logger(version);
const allowedTransactionKeys = [
    "accessList", "ccipReadEnabled", "chainId", "customData", "data", "from", "gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "to", "type", "value"
];
const forwardErrors = [
    logger_lib_esm.Logger.errors.INSUFFICIENT_FUNDS,
    logger_lib_esm.Logger.errors.NONCE_EXPIRED,
    logger_lib_esm.Logger.errors.REPLACEMENT_UNDERPRICED,
];
;
;
class Signer {
    ///////////////////
    // Sub-classes MUST call super
    constructor() {
        logger.checkAbstract(new.target, Signer);
        (0,lib_esm.defineReadOnly)(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkProvider("estimateGas");
            const tx = yield (0,lib_esm.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkProvider("call");
            const tx = yield (0,lib_esm.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for (const key in transaction) {
            if (allowedTransactionKeys.indexOf(key) === -1) {
                logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
            }
        }
        const tx = (0,lib_esm.shallowCopy)(transaction);
        if (tx.from == null) {
            tx.from = this.getAddress();
        }
        else {
            // Make sure any provided address matches this signer
            tx.from = Promise.all([
                Promise.resolve(tx.from),
                this.getAddress()
            ]).then((result) => {
                if (result[0].toLowerCase() !== result[1].toLowerCase()) {
                    logger.throwArgumentError("from address mismatch", "transaction", transaction);
                }
                return result[0];
            });
        }
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = yield (0,lib_esm.resolveProperties)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to) => __awaiter(this, void 0, void 0, function* () {
                    if (to == null) {
                        return null;
                    }
                    const address = yield this.resolveName(to);
                    if (address == null) {
                        logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                    }
                    return address;
                }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error) => { });
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = (tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null);
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) {
                logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            }
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) {
                logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            }
            if ((tx.type === 2 || tx.type == null) && (tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null)) {
                // Fully-formed EIP-1559 transaction (skip getFeeData)
                tx.type = 2;
            }
            else if (tx.type === 0 || tx.type === 1) {
                // Explicit Legacy or EIP-2930 transaction
                // Populate missing gasPrice
                if (tx.gasPrice == null) {
                    tx.gasPrice = this.getGasPrice();
                }
            }
            else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        }
                        else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) {
                                tx.maxFeePerGas = feeData.maxFeePerGas;
                            }
                            if (tx.maxPriorityFeePerGas == null) {
                                tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                            }
                        }
                    }
                    else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) {
                            logger.throwError("network does not support EIP-1559", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                                operation: "populateTransaction"
                            });
                        }
                        // Populate missing fee data
                        if (tx.gasPrice == null) {
                            tx.gasPrice = feeData.gasPrice;
                        }
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    }
                    else {
                        // getFeeData has failed us.
                        logger.throwError("failed to get consistent fee data", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                            operation: "signer.getFeeData"
                        });
                    }
                }
                else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) {
                        tx.maxFeePerGas = feeData.maxFeePerGas;
                    }
                    if (tx.maxPriorityFeePerGas == null) {
                        tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                    }
                }
            }
            if (tx.nonce == null) {
                tx.nonce = this.getTransactionCount("pending");
            }
            if (tx.gasLimit == null) {
                tx.gasLimit = this.estimateGas(tx).catch((error) => {
                    if (forwardErrors.indexOf(error.code) >= 0) {
                        throw error;
                    }
                    return logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", logger_lib_esm.Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
                        error: error,
                        tx: tx
                    });
                });
            }
            if (tx.chainId == null) {
                tx.chainId = this.getChainId();
            }
            else {
                tx.chainId = Promise.all([
                    Promise.resolve(tx.chainId),
                    this.getChainId()
                ]).then((results) => {
                    if (results[1] !== 0 && results[0] !== results[1]) {
                        logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                    }
                    return results[0];
                });
            }
            return yield (0,lib_esm.resolveProperties)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) {
            logger.throwError("missing provider", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: (operation || "_checkProvider")
            });
        }
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class VoidSigner extends Signer {
    constructor(address, provider) {
        super();
        (0,lib_esm.defineReadOnly)(this, "address", address);
        (0,lib_esm.defineReadOnly)(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(() => {
            logger.throwError(message, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, { operation: operation });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new VoidSigner(this.address, provider);
    }
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/address/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  getAddress: () => (/* binding */ getAddress),
  getContractAddress: () => (/* binding */ getContractAddress),
  getCreate2Address: () => (/* binding */ getCreate2Address),
  getIcapAddress: () => (/* binding */ getIcapAddress),
  isAddress: () => (/* binding */ isAddress)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/keccak256/lib.esm/index.js
var keccak256_lib_esm = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/rlp/lib.esm/index.js + 1 modules
var rlp_lib_esm = __webpack_require__("../../node_modules/@ethersproject/rlp/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/address/lib.esm/_version.js
const version = "address/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/address/lib.esm/index.js







const logger = new logger_lib_esm.Logger(version);
function getChecksumAddress(address) {
    if (!(0,lib_esm.isHexString)(address, 20)) {
        logger.throwArgumentError("invalid address", "address", address);
    }
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for (let i = 0; i < 40; i++) {
        expanded[i] = chars[i].charCodeAt(0);
    }
    const hashed = (0,lib_esm.arrayify)((0,keccak256_lib_esm.keccak256)(expanded));
    for (let i = 0; i < 40; i += 2) {
        if ((hashed[i >> 1] >> 4) >= 8) {
            chars[i] = chars[i].toUpperCase();
        }
        if ((hashed[i >> 1] & 0x0f) >= 8) {
            chars[i + 1] = chars[i + 1].toUpperCase();
        }
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const MAX_SAFE_INTEGER = 0x1fffffffffffff;
function log10(x) {
    if (Math.log10) {
        return Math.log10(x);
    }
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const ibanLookup = {};
for (let i = 0; i < 10; i++) {
    ibanLookup[String(i)] = String(i);
}
for (let i = 0; i < 26; i++) {
    ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
}
// How many decimal digits can we process? (for 64-bit float, this is 15)
const safeDigits = Math.floor(log10(MAX_SAFE_INTEGER));
function ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c) => { return ibanLookup[c]; }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while (expanded.length >= safeDigits) {
        let block = expanded.substring(0, safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - (parseInt(expanded, 10) % 97));
    while (checksum.length < 2) {
        checksum = "0" + checksum;
    }
    return checksum;
}
;
function getAddress(address) {
    let result = null;
    if (typeof (address) !== "string") {
        logger.throwArgumentError("invalid address", "address", address);
    }
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") {
            address = "0x" + address;
        }
        result = getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) {
            logger.throwArgumentError("bad address checksum", "address", address);
        }
        // Maybe ICAP? (we only support direct mode)
    }
    else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== ibanChecksum(address)) {
            logger.throwArgumentError("bad icap checksum", "address", address);
        }
        result = (0,bignumber/* _base36To16 */.g$)(address.substring(4));
        while (result.length < 40) {
            result = "0" + result;
        }
        result = getChecksumAddress("0x" + result);
    }
    else {
        logger.throwArgumentError("invalid address", "address", address);
    }
    return result;
}
function isAddress(address) {
    try {
        getAddress(address);
        return true;
    }
    catch (error) { }
    return false;
}
function getIcapAddress(address) {
    let base36 = (0,bignumber/* _base16To36 */.t2)(getAddress(address).substring(2)).toUpperCase();
    while (base36.length < 30) {
        base36 = "0" + base36;
    }
    return "XE" + ibanChecksum("XE00" + base36) + base36;
}
// http://ethereum.stackexchange.com/questions/760/how-is-the-address-of-an-ethereum-contract-computed
function getContractAddress(transaction) {
    let from = null;
    try {
        from = getAddress(transaction.from);
    }
    catch (error) {
        logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0,lib_esm.stripZeros)((0,lib_esm.arrayify)(bignumber/* BigNumber.from */.O$.from(transaction.nonce).toHexString()));
    return getAddress((0,lib_esm.hexDataSlice)((0,keccak256_lib_esm.keccak256)((0,rlp_lib_esm.encode)([from, nonce])), 12));
}
function getCreate2Address(from, salt, initCodeHash) {
    if ((0,lib_esm.hexDataLength)(salt) !== 32) {
        logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    }
    if ((0,lib_esm.hexDataLength)(initCodeHash) !== 32) {
        logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    }
    return getAddress((0,lib_esm.hexDataSlice)((0,keccak256_lib_esm.keccak256)((0,lib_esm.concat)(["0xff", getAddress(from), salt, initCodeHash])), 12));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/base64/lib.esm/base64.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   J: () => (/* binding */ decode),
/* harmony export */   c: () => (/* binding */ encode)
/* harmony export */ });
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");


function decode(textData) {
    textData = atob(textData);
    const data = [];
    for (let i = 0; i < textData.length; i++) {
        data.push(textData.charCodeAt(i));
    }
    return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.arrayify)(data);
}
function encode(data) {
    data = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.arrayify)(data);
    let textData = "";
    for (let i = 0; i < data.length; i++) {
        textData += String.fromCharCode(data[i]);
    }
    return btoa(textData);
}
//# sourceMappingURL=base64.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/base64/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   decode: () => (/* reexport safe */ _base64__WEBPACK_IMPORTED_MODULE_0__.J),
/* harmony export */   encode: () => (/* reexport safe */ _base64__WEBPACK_IMPORTED_MODULE_0__.c)
/* harmony export */ });
/* harmony import */ var _base64__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/base64/lib.esm/base64.js");


//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/basex/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Base32: () => (/* binding */ Base32),
/* harmony export */   Base58: () => (/* binding */ Base58),
/* harmony export */   BaseX: () => (/* binding */ BaseX)
/* harmony export */ });
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _ethersproject_properties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */


class BaseX {
    constructor(alphabet) {
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_0__.defineReadOnly)(this, "alphabet", alphabet);
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_0__.defineReadOnly)(this, "base", alphabet.length);
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_0__.defineReadOnly)(this, "_alphabetMap", {});
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_0__.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for (let i = 0; i < alphabet.length; i++) {
            this._alphabetMap[alphabet.charAt(i)] = i;
        }
    }
    encode(value) {
        let source = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_1__.arrayify)(value);
        if (source.length === 0) {
            return "";
        }
        let digits = [0];
        for (let i = 0; i < source.length; ++i) {
            let carry = source[i];
            for (let j = 0; j < digits.length; ++j) {
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = (carry / this.base) | 0;
            }
            while (carry > 0) {
                digits.push(carry % this.base);
                carry = (carry / this.base) | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for (let k = 0; source[k] === 0 && k < source.length - 1; ++k) {
            string += this._leader;
        }
        // convert digits to a string
        for (let q = digits.length - 1; q >= 0; --q) {
            string += this.alphabet[digits[q]];
        }
        return string;
    }
    decode(value) {
        if (typeof (value) !== "string") {
            throw new TypeError("Expected String");
        }
        let bytes = [];
        if (value.length === 0) {
            return new Uint8Array(bytes);
        }
        bytes.push(0);
        for (let i = 0; i < value.length; i++) {
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) {
                throw new Error("Non-base" + this.base + " character");
            }
            let carry = byte;
            for (let j = 0; j < bytes.length; ++j) {
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while (carry > 0) {
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for (let k = 0; value[k] === this._leader && k < value.length - 1; ++k) {
            bytes.push(0);
        }
        return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_1__.arrayify)(new Uint8Array(bytes.reverse()));
    }
}
const Base32 = new BaseX("abcdefghijklmnopqrstuvwxyz234567");
const Base58 = new BaseX("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");

//console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
//console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/bignumber/lib.esm/_version.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: () => (/* binding */ version)
/* harmony export */ });
const version = "bignumber/5.7.0";
//# sourceMappingURL=_version.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   O$: () => (/* binding */ BigNumber),
/* harmony export */   Zm: () => (/* binding */ isBigNumberish),
/* harmony export */   g$: () => (/* binding */ _base36To16),
/* harmony export */   t2: () => (/* binding */ _base16To36)
/* harmony export */ });
/* harmony import */ var bn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/bn.js/lib/bn.js");
/* harmony import */ var bn_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bn_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _ethersproject_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
/* harmony import */ var _version__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/_version.js");

/**
 *  BigNumber
 *
 *  A wrapper around the BN.js object. We use the BN.js library
 *  because it is used by elliptic, so it is required regardless.
 *
 */

var BN = (bn_js__WEBPACK_IMPORTED_MODULE_0___default().BN);



const logger = new _ethersproject_logger__WEBPACK_IMPORTED_MODULE_1__.Logger(_version__WEBPACK_IMPORTED_MODULE_2__/* .version */ .i);
const _constructorGuard = {};
const MAX_SAFE = 0x1fffffffffffff;
function isBigNumberish(value) {
    return (value != null) && (BigNumber.isBigNumber(value) ||
        (typeof (value) === "number" && (value % 1) === 0) ||
        (typeof (value) === "string" && !!value.match(/^-?[0-9]+$/)) ||
        (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.isHexString)(value) ||
        (typeof (value) === "bigint") ||
        (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.isBytes)(value));
}
// Only warn about passing 10 into radix once
let _warnedToStringRadix = false;
class BigNumber {
    constructor(constructorGuard, hex) {
        if (constructorGuard !== _constructorGuard) {
            logger.throwError("cannot call constructor directly; use BigNumber.from", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_1__.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "new (BigNumber)"
            });
        }
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return toBigNumber(toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return toBigNumber(toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") {
            return BigNumber.from(this._hex.substring(1));
        }
        return this;
    }
    add(other) {
        return toBigNumber(toBN(this).add(toBN(other)));
    }
    sub(other) {
        return toBigNumber(toBN(this).sub(toBN(other)));
    }
    div(other) {
        const o = BigNumber.from(other);
        if (o.isZero()) {
            throwFault("division-by-zero", "div");
        }
        return toBigNumber(toBN(this).div(toBN(other)));
    }
    mul(other) {
        return toBigNumber(toBN(this).mul(toBN(other)));
    }
    mod(other) {
        const value = toBN(other);
        if (value.isNeg()) {
            throwFault("division-by-zero", "mod");
        }
        return toBigNumber(toBN(this).umod(value));
    }
    pow(other) {
        const value = toBN(other);
        if (value.isNeg()) {
            throwFault("negative-power", "pow");
        }
        return toBigNumber(toBN(this).pow(value));
    }
    and(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault("unbound-bitwise-result", "and");
        }
        return toBigNumber(toBN(this).and(value));
    }
    or(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault("unbound-bitwise-result", "or");
        }
        return toBigNumber(toBN(this).or(value));
    }
    xor(other) {
        const value = toBN(other);
        if (this.isNegative() || value.isNeg()) {
            throwFault("unbound-bitwise-result", "xor");
        }
        return toBigNumber(toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) {
            throwFault("negative-width", "mask");
        }
        return toBigNumber(toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) {
            throwFault("negative-width", "shl");
        }
        return toBigNumber(toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) {
            throwFault("negative-width", "shr");
        }
        return toBigNumber(toBN(this).shrn(value));
    }
    eq(other) {
        return toBN(this).eq(toBN(other));
    }
    lt(other) {
        return toBN(this).lt(toBN(other));
    }
    lte(other) {
        return toBN(this).lte(toBN(other));
    }
    gt(other) {
        return toBN(this).gt(toBN(other));
    }
    gte(other) {
        return toBN(this).gte(toBN(other));
    }
    isNegative() {
        return (this._hex[0] === "-");
    }
    isZero() {
        return toBN(this).isZero();
    }
    toNumber() {
        try {
            return toBN(this).toNumber();
        }
        catch (error) {
            throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        }
        catch (e) { }
        return logger.throwError("this platform does not support BigInt", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_1__.Logger.errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!_warnedToStringRadix) {
                    _warnedToStringRadix = true;
                    logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            }
            else if (arguments[0] === 16) {
                logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_1__.Logger.errors.UNEXPECTED_ARGUMENT, {});
            }
            else {
                logger.throwError("BigNumber.toString does not accept parameters", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_1__.Logger.errors.UNEXPECTED_ARGUMENT, {});
            }
        }
        return toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return { type: "BigNumber", hex: this.toHexString() };
    }
    static from(value) {
        if (value instanceof BigNumber) {
            return value;
        }
        if (typeof (value) === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) {
                return new BigNumber(_constructorGuard, toHex(value));
            }
            if (value.match(/^-?[0-9]+$/)) {
                return new BigNumber(_constructorGuard, toHex(new BN(value)));
            }
            return logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof (value) === "number") {
            if (value % 1) {
                throwFault("underflow", "BigNumber.from", value);
            }
            if (value >= MAX_SAFE || value <= -MAX_SAFE) {
                throwFault("overflow", "BigNumber.from", value);
            }
            return BigNumber.from(String(value));
        }
        const anyValue = value;
        if (typeof (anyValue) === "bigint") {
            return BigNumber.from(anyValue.toString());
        }
        if ((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.isBytes)(anyValue)) {
            return BigNumber.from((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexlify)(anyValue));
        }
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof (hex) === "string") {
                    return BigNumber.from(hex);
                }
            }
            else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") {
                    hex = anyValue.hex;
                }
                if (typeof (hex) === "string") {
                    if ((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.isHexString)(hex) || (hex[0] === "-" && (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.isHexString)(hex.substring(1)))) {
                        return BigNumber.from(hex);
                    }
                }
            }
        }
        return logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function toHex(value) {
    // For BN, call on the hex string
    if (typeof (value) !== "string") {
        return toHex(value.toString(16));
    }
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") {
            logger.throwArgumentError("invalid hex", "value", value);
        }
        // Call toHex on the positive component
        value = toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") {
            return value;
        }
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    // Normalize zero
    if (value === "0x") {
        return "0x00";
    }
    // Make the string even length
    if (value.length % 2) {
        value = "0x0" + value.substring(2);
    }
    // Trim to smallest even-length string
    while (value.length > 4 && value.substring(0, 4) === "0x00") {
        value = "0x" + value.substring(4);
    }
    return value;
}
function toBigNumber(value) {
    return BigNumber.from(toHex(value));
}
function toBN(value) {
    const hex = BigNumber.from(value).toHexString();
    if (hex[0] === "-") {
        return (new BN("-" + hex.substring(3), 16));
    }
    return new BN(hex.substring(2), 16);
}
function throwFault(fault, operation, value) {
    const params = { fault: fault, operation: operation };
    if (value != null) {
        params.value = value;
    }
    return logger.throwError(fault, _ethersproject_logger__WEBPACK_IMPORTED_MODULE_1__.Logger.errors.NUMERIC_FAULT, params);
}
// value should have no prefix
function _base36To16(value) {
    return (new BN(value, 36)).toString(16);
}
// value should have no prefix
function _base16To36(value) {
    return (new BN(value, 16)).toString(36);
}
//# sourceMappingURL=bignumber.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ox: () => (/* binding */ parseFixed),
/* harmony export */   S5: () => (/* binding */ formatFixed),
/* harmony export */   xO: () => (/* binding */ FixedFormat),
/* harmony export */   xs: () => (/* binding */ FixedNumber)
/* harmony export */ });
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
/* harmony import */ var _version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/_version.js");
/* harmony import */ var _bignumber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");




const logger = new _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger(_version__WEBPACK_IMPORTED_MODULE_1__/* .version */ .i);

const _constructorGuard = {};
const Zero = _bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(0);
const NegativeOne = _bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(-1);
function throwFault(message, fault, operation, value) {
    const params = { fault: fault, operation: operation };
    if (value !== undefined) {
        params.value = value;
    }
    return logger.throwError(message, _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let zeros = "0";
while (zeros.length < 256) {
    zeros += zeros;
}
// Returns a string "1" followed by decimal "0"s
function getMultiplier(decimals) {
    if (typeof (decimals) !== "number") {
        try {
            decimals = _bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(decimals).toNumber();
        }
        catch (e) { }
    }
    if (typeof (decimals) === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) {
        return ("1" + zeros.substring(0, decimals));
    }
    return logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function formatFixed(value, decimals) {
    if (decimals == null) {
        decimals = 0;
    }
    const multiplier = getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = _bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(value);
    const negative = value.lt(Zero);
    if (negative) {
        value = value.mul(NegativeOne);
    }
    let fraction = value.mod(multiplier).toString();
    while (fraction.length < multiplier.length - 1) {
        fraction = "0" + fraction;
    }
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) {
        value = whole;
    }
    else {
        value = whole + "." + fraction;
    }
    if (negative) {
        value = "-" + value;
    }
    return value;
}
function parseFixed(value, decimals) {
    if (decimals == null) {
        decimals = 0;
    }
    const multiplier = getMultiplier(decimals);
    if (typeof (value) !== "string" || !value.match(/^-?[0-9.]+$/)) {
        logger.throwArgumentError("invalid decimal value", "value", value);
    }
    // Is it negative?
    const negative = (value.substring(0, 1) === "-");
    if (negative) {
        value = value.substring(1);
    }
    if (value === ".") {
        logger.throwArgumentError("missing value", "value", value);
    }
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) {
        logger.throwArgumentError("too many decimal points", "value", value);
    }
    let whole = comps[0], fraction = comps[1];
    if (!whole) {
        whole = "0";
    }
    if (!fraction) {
        fraction = "0";
    }
    // Trim trailing zeros
    while (fraction[fraction.length - 1] === "0") {
        fraction = fraction.substring(0, fraction.length - 1);
    }
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) {
        throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    }
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") {
        fraction = "0";
    }
    // Fully pad the string with zeros to get to wei
    while (fraction.length < multiplier.length - 1) {
        fraction += "0";
    }
    const wholeValue = _bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(whole);
    const fractionValue = _bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(fraction);
    let wei = (wholeValue.mul(multiplier)).add(fractionValue);
    if (negative) {
        wei = wei.mul(NegativeOne);
    }
    return wei;
}
class FixedFormat {
    constructor(constructorGuard, signed, width, decimals) {
        if (constructorGuard !== _constructorGuard) {
            logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "new FixedFormat"
            });
        }
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof FixedFormat) {
            return value;
        }
        if (typeof (value) === "number") {
            value = `fixed128x${value}`;
        }
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof (value) === "string") {
            if (value === "fixed") {
                // defaults...
            }
            else if (value === "ufixed") {
                signed = false;
            }
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) {
                    logger.throwArgumentError("invalid fixed format", "format", value);
                }
                signed = (match[1] !== "u");
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        }
        else if (value) {
            const check = (key, type, defaultValue) => {
                if (value[key] == null) {
                    return defaultValue;
                }
                if (typeof (value[key]) !== type) {
                    logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                }
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) {
            logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        }
        if (decimals > 80) {
            logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        }
        return new FixedFormat(_constructorGuard, signed, width, decimals);
    }
}
class FixedNumber {
    constructor(constructorGuard, hex, value, format) {
        if (constructorGuard !== _constructorGuard) {
            logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "new FixedFormat"
            });
        }
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) {
            logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
        }
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = parseFixed(this._value, this.format.decimals);
        const b = parseFixed(other._value, other.format.decimals);
        return FixedNumber.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        let result = FixedNumber.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) {
            result = result.subUnsafe(ONE.toFormat(result.format));
        }
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        let result = FixedNumber.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) {
            result = result.addUnsafe(ONE.toFormat(result.format));
        }
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) {
            decimals = 0;
        }
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) {
            comps.push("0");
        }
        if (decimals < 0 || decimals > 80 || (decimals % 1)) {
            logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        }
        if (comps[1].length <= decimals) {
            return this;
        }
        const factor = FixedNumber.from("1" + zeros.substring(0, decimals), this.format);
        const bump = BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return (this._value === "0.0" || this._value === "0");
    }
    isNegative() {
        return (this._value[0] === "-");
    }
    toString() { return this._value; }
    toHexString(width) {
        if (width == null) {
            return this._hex;
        }
        if (width % 8) {
            logger.throwArgumentError("invalid byte width", "width", width);
        }
        const hex = _bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexZeroPad)(hex, width / 8);
    }
    toUnsafeFloat() { return parseFloat(this.toString()); }
    toFormat(format) {
        return FixedNumber.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0,_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .isBigNumberish */ .Zm)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) {
            decimals = 0;
        }
        if (format == null) {
            format = "fixed";
        }
        return FixedNumber.fromString(formatFixed(value, decimals), FixedFormat.from(format));
    }
    static fromString(value, format) {
        if (format == null) {
            format = "fixed";
        }
        const fixedFormat = FixedFormat.from(format);
        const numeric = parseFixed(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt(Zero)) {
            throwFault("unsigned value cannot be negative", "overflow", "value", value);
        }
        let hex = null;
        if (fixedFormat.signed) {
            hex = numeric.toTwos(fixedFormat.width).toHexString();
        }
        else {
            hex = numeric.toHexString();
            hex = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexZeroPad)(hex, fixedFormat.width / 8);
        }
        const decimal = formatFixed(numeric, fixedFormat.decimals);
        return new FixedNumber(_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) {
            format = "fixed";
        }
        const fixedFormat = FixedFormat.from(format);
        if ((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.arrayify)(value).length > fixedFormat.width / 8) {
            throw new Error("overflow");
        }
        let numeric = _bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(value);
        if (fixedFormat.signed) {
            numeric = numeric.fromTwos(fixedFormat.width);
        }
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = formatFixed(numeric, fixedFormat.decimals);
        return new FixedNumber(_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof (value) === "string") {
            return FixedNumber.fromString(value, format);
        }
        if ((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.isBytes)(value)) {
            return FixedNumber.fromBytes(value, format);
        }
        try {
            return FixedNumber.fromValue(value, 0, format);
        }
        catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger.errors.INVALID_ARGUMENT) {
                throw error;
            }
        }
        return logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const ONE = FixedNumber.from(1);
const BUMP = FixedNumber.from("0.5");
//# sourceMappingURL=fixednumber.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/bignumber/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BigNumber: () => (/* reexport safe */ _bignumber__WEBPACK_IMPORTED_MODULE_0__.O$),
/* harmony export */   FixedFormat: () => (/* reexport safe */ _fixednumber__WEBPACK_IMPORTED_MODULE_1__.xO),
/* harmony export */   FixedNumber: () => (/* reexport safe */ _fixednumber__WEBPACK_IMPORTED_MODULE_1__.xs),
/* harmony export */   _base16To36: () => (/* reexport safe */ _bignumber__WEBPACK_IMPORTED_MODULE_0__.t2),
/* harmony export */   _base36To16: () => (/* reexport safe */ _bignumber__WEBPACK_IMPORTED_MODULE_0__.g$),
/* harmony export */   formatFixed: () => (/* reexport safe */ _fixednumber__WEBPACK_IMPORTED_MODULE_1__.S5),
/* harmony export */   parseFixed: () => (/* reexport safe */ _fixednumber__WEBPACK_IMPORTED_MODULE_1__.Ox)
/* harmony export */ });
/* harmony import */ var _bignumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
/* harmony import */ var _fixednumber__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js");


// Internal methods used by address

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/bytes/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  arrayify: () => (/* binding */ arrayify),
  concat: () => (/* binding */ concat),
  hexConcat: () => (/* binding */ hexConcat),
  hexDataLength: () => (/* binding */ hexDataLength),
  hexDataSlice: () => (/* binding */ hexDataSlice),
  hexStripZeros: () => (/* binding */ hexStripZeros),
  hexValue: () => (/* binding */ hexValue),
  hexZeroPad: () => (/* binding */ hexZeroPad),
  hexlify: () => (/* binding */ hexlify),
  isBytes: () => (/* binding */ isBytes),
  isBytesLike: () => (/* binding */ isBytesLike),
  isHexString: () => (/* binding */ isHexString),
  joinSignature: () => (/* binding */ joinSignature),
  splitSignature: () => (/* binding */ splitSignature),
  stripZeros: () => (/* binding */ stripZeros),
  zeroPad: () => (/* binding */ zeroPad)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/_version.js
const version = "bytes/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js



const logger = new lib_esm.Logger(version);
///////////////////////////////
function isHexable(value) {
    return !!(value.toHexString);
}
function addSlice(array) {
    if (array.slice) {
        return array;
    }
    array.slice = function () {
        const args = Array.prototype.slice.call(arguments);
        return addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function isBytesLike(value) {
    return ((isHexString(value) && !(value.length % 2)) || isBytes(value));
}
function isInteger(value) {
    return (typeof (value) === "number" && value == value && (value % 1) === 0);
}
function isBytes(value) {
    if (value == null) {
        return false;
    }
    if (value.constructor === Uint8Array) {
        return true;
    }
    if (typeof (value) === "string") {
        return false;
    }
    if (!isInteger(value.length) || value.length < 0) {
        return false;
    }
    for (let i = 0; i < value.length; i++) {
        const v = value[i];
        if (!isInteger(v) || v < 0 || v >= 256) {
            return false;
        }
    }
    return true;
}
function arrayify(value, options) {
    if (!options) {
        options = {};
    }
    if (typeof (value) === "number") {
        logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while (value) {
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) {
            result.push(0);
        }
        return addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof (value) === "string" && value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    if (isHexable(value)) {
        value = value.toHexString();
    }
    if (isHexString(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") {
                hex = "0" + hex;
            }
            else if (options.hexPad === "right") {
                hex += "0";
            }
            else {
                logger.throwArgumentError("hex data is odd-length", "value", value);
            }
        }
        const result = [];
        for (let i = 0; i < hex.length; i += 2) {
            result.push(parseInt(hex.substring(i, i + 2), 16));
        }
        return addSlice(new Uint8Array(result));
    }
    if (isBytes(value)) {
        return addSlice(new Uint8Array(value));
    }
    return logger.throwArgumentError("invalid arrayify value", "value", value);
}
function concat(items) {
    const objects = items.map(item => arrayify(item));
    const length = objects.reduce((accum, item) => (accum + item.length), 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object) => {
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return addSlice(result);
}
function stripZeros(value) {
    let result = arrayify(value);
    if (result.length === 0) {
        return result;
    }
    // Find the first non-zero entry
    let start = 0;
    while (start < result.length && result[start] === 0) {
        start++;
    }
    // If we started with zeros, strip them
    if (start) {
        result = result.slice(start);
    }
    return result;
}
function zeroPad(value, length) {
    value = arrayify(value);
    if (value.length > length) {
        logger.throwArgumentError("value out of range", "value", arguments[0]);
    }
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return addSlice(result);
}
function isHexString(value, length) {
    if (typeof (value) !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) {
        return false;
    }
    if (length && value.length !== 2 + 2 * length) {
        return false;
    }
    return true;
}
const HexCharacters = "0123456789abcdef";
function hexlify(value, options) {
    if (!options) {
        options = {};
    }
    if (typeof (value) === "number") {
        logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while (value) {
            hex = HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) {
                hex = "0" + hex;
            }
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof (value) === "bigint") {
        value = value.toString(16);
        if (value.length % 2) {
            return ("0x0" + value);
        }
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof (value) === "string" && value.substring(0, 2) !== "0x") {
        value = "0x" + value;
    }
    if (isHexable(value)) {
        return value.toHexString();
    }
    if (isHexString(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") {
                value = "0x0" + value.substring(2);
            }
            else if (options.hexPad === "right") {
                value += "0";
            }
            else {
                logger.throwArgumentError("hex data is odd-length", "value", value);
            }
        }
        return value.toLowerCase();
    }
    if (isBytes(value)) {
        let result = "0x";
        for (let i = 0; i < value.length; i++) {
            let v = value[i];
            result += HexCharacters[(v & 0xf0) >> 4] + HexCharacters[v & 0x0f];
        }
        return result;
    }
    return logger.throwArgumentError("invalid hexlify value", "value", value);
}
/*
function unoddify(value: BytesLike | Hexable | number): BytesLike | Hexable | number {
    if (typeof(value) === "string" && value.length % 2 && value.substring(0, 2) === "0x") {
        return "0x0" + value.substring(2);
    }
    return value;
}
*/
function hexDataLength(data) {
    if (typeof (data) !== "string") {
        data = hexlify(data);
    }
    else if (!isHexString(data) || (data.length % 2)) {
        return null;
    }
    return (data.length - 2) / 2;
}
function hexDataSlice(data, offset, endOffset) {
    if (typeof (data) !== "string") {
        data = hexlify(data);
    }
    else if (!isHexString(data) || (data.length % 2)) {
        logger.throwArgumentError("invalid hexData", "value", data);
    }
    offset = 2 + 2 * offset;
    if (endOffset != null) {
        return "0x" + data.substring(offset, 2 + 2 * endOffset);
    }
    return "0x" + data.substring(offset);
}
function hexConcat(items) {
    let result = "0x";
    items.forEach((item) => {
        result += hexlify(item).substring(2);
    });
    return result;
}
function hexValue(value) {
    const trimmed = hexStripZeros(hexlify(value, { hexPad: "left" }));
    if (trimmed === "0x") {
        return "0x0";
    }
    return trimmed;
}
function hexStripZeros(value) {
    if (typeof (value) !== "string") {
        value = hexlify(value);
    }
    if (!isHexString(value)) {
        logger.throwArgumentError("invalid hex string", "value", value);
    }
    value = value.substring(2);
    let offset = 0;
    while (offset < value.length && value[offset] === "0") {
        offset++;
    }
    return "0x" + value.substring(offset);
}
function hexZeroPad(value, length) {
    if (typeof (value) !== "string") {
        value = hexlify(value);
    }
    else if (!isHexString(value)) {
        logger.throwArgumentError("invalid hex string", "value", value);
    }
    if (value.length > 2 * length + 2) {
        logger.throwArgumentError("value out of range", "value", arguments[1]);
    }
    while (value.length < 2 * length + 2) {
        value = "0x0" + value.substring(2);
    }
    return value;
}
function splitSignature(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if (isBytesLike(signature)) {
        let bytes = arrayify(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = hexlify(bytes.slice(0, 32));
            result.s = hexlify(bytes.slice(32, 64));
        }
        else if (bytes.length === 65) {
            result.r = hexlify(bytes.slice(0, 32));
            result.s = hexlify(bytes.slice(32, 64));
            result.v = bytes[64];
        }
        else {
            logger.throwArgumentError("invalid signature string", "signature", signature);
        }
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) {
                result.v += 27;
            }
            else {
                logger.throwArgumentError("signature invalid v byte", "signature", signature);
            }
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - (result.v % 2);
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) {
            bytes[32] |= 0x80;
        }
        result._vs = hexlify(bytes.slice(32, 64));
    }
    else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = zeroPad(arrayify(result._vs), 32);
            result._vs = hexlify(vs);
            // Set or check the recid
            const recoveryParam = ((vs[0] >= 128) ? 1 : 0);
            if (result.recoveryParam == null) {
                result.recoveryParam = recoveryParam;
            }
            else if (result.recoveryParam !== recoveryParam) {
                logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            }
            // Set or check the s
            vs[0] &= 0x7f;
            const s = hexlify(vs);
            if (result.s == null) {
                result.s = s;
            }
            else if (result.s !== s) {
                logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
            }
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) {
                logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            }
            else if (result.v === 0 || result.v === 1) {
                result.recoveryParam = result.v;
            }
            else {
                result.recoveryParam = 1 - (result.v % 2);
            }
        }
        else {
            if (result.v == null) {
                result.v = 27 + result.recoveryParam;
            }
            else {
                const recId = (result.v === 0 || result.v === 1) ? result.v : (1 - (result.v % 2));
                if (result.recoveryParam !== recId) {
                    logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
                }
            }
        }
        if (result.r == null || !isHexString(result.r)) {
            logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        }
        else {
            result.r = hexZeroPad(result.r, 32);
        }
        if (result.s == null || !isHexString(result.s)) {
            logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        }
        else {
            result.s = hexZeroPad(result.s, 32);
        }
        const vs = arrayify(result.s);
        if (vs[0] >= 128) {
            logger.throwArgumentError("signature s out of range", "signature", signature);
        }
        if (result.recoveryParam) {
            vs[0] |= 0x80;
        }
        const _vs = hexlify(vs);
        if (result._vs) {
            if (!isHexString(result._vs)) {
                logger.throwArgumentError("signature invalid _vs", "signature", signature);
            }
            result._vs = hexZeroPad(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) {
            result._vs = _vs;
        }
        else if (result._vs !== _vs) {
            logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
        }
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function joinSignature(signature) {
    signature = splitSignature(signature);
    return hexlify(concat([
        signature.r,
        signature.s,
        (signature.recoveryParam ? "0x1c" : "0x1b")
    ]));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/constants/lib.esm/addresses.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   d: () => (/* binding */ AddressZero)
/* harmony export */ });
const AddressZero = "0x0000000000000000000000000000000000000000";
//# sourceMappingURL=addresses.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/constants/lib.esm/bignumbers.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $B: () => (/* binding */ MinInt256),
/* harmony export */   Bz: () => (/* binding */ MaxUint256),
/* harmony export */   Ce: () => (/* binding */ WeiPerEther),
/* harmony export */   PS: () => (/* binding */ MaxInt256),
/* harmony export */   Py: () => (/* binding */ Two),
/* harmony export */   _Y: () => (/* binding */ Zero),
/* harmony export */   fh: () => (/* binding */ One),
/* harmony export */   tL: () => (/* binding */ NegativeOne)
/* harmony export */ });
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");

const NegativeOne = ( /*#__PURE__*/_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber.from */ .O$.from(-1));
const Zero = ( /*#__PURE__*/_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber.from */ .O$.from(0));
const One = ( /*#__PURE__*/_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber.from */ .O$.from(1));
const Two = ( /*#__PURE__*/_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber.from */ .O$.from(2));
const WeiPerEther = ( /*#__PURE__*/_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber.from */ .O$.from("1000000000000000000"));
const MaxUint256 = ( /*#__PURE__*/_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber.from */ .O$.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"));
const MinInt256 = ( /*#__PURE__*/_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber.from */ .O$.from("-0x8000000000000000000000000000000000000000000000000000000000000000"));
const MaxInt256 = ( /*#__PURE__*/_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_0__/* .BigNumber.from */ .O$.from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"));

//# sourceMappingURL=bignumbers.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/constants/lib.esm/hashes.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: () => (/* binding */ HashZero)
/* harmony export */ });
const HashZero = "0x0000000000000000000000000000000000000000000000000000000000000000";
//# sourceMappingURL=hashes.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/constants/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AddressZero: () => (/* reexport */ addresses/* AddressZero */.d),
  EtherSymbol: () => (/* reexport */ EtherSymbol),
  HashZero: () => (/* reexport */ hashes/* HashZero */.R),
  MaxInt256: () => (/* reexport */ bignumbers/* MaxInt256 */.PS),
  MaxUint256: () => (/* reexport */ bignumbers/* MaxUint256 */.Bz),
  MinInt256: () => (/* reexport */ bignumbers/* MinInt256 */.$B),
  NegativeOne: () => (/* reexport */ bignumbers/* NegativeOne */.tL),
  One: () => (/* reexport */ bignumbers/* One */.fh),
  Two: () => (/* reexport */ bignumbers/* Two */.Py),
  WeiPerEther: () => (/* reexport */ bignumbers/* WeiPerEther */.Ce),
  Zero: () => (/* reexport */ bignumbers/* Zero */._Y)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/constants/lib.esm/addresses.js
var addresses = __webpack_require__("../../node_modules/@ethersproject/constants/lib.esm/addresses.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__("../../node_modules/@ethersproject/constants/lib.esm/bignumbers.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/constants/lib.esm/hashes.js
var hashes = __webpack_require__("../../node_modules/@ethersproject/constants/lib.esm/hashes.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/constants/lib.esm/strings.js
// NFKC (composed)             // (decomposed)
const EtherSymbol = "\u039e"; // "\uD835\uDF63";
//# sourceMappingURL=strings.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/constants/lib.esm/index.js





//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/contracts/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  BaseContract: () => (/* binding */ BaseContract),
  Contract: () => (/* binding */ Contract),
  ContractFactory: () => (/* binding */ ContractFactory)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/abstract-coder.js
var abstract_coder = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/coders/abstract-coder.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abi/lib.esm/interface.js
var lib_esm_interface = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/interface.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abstract-provider/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/abstract-provider/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abstract-signer/lib.esm/index.js + 1 modules
var abstract_signer_lib_esm = __webpack_require__("../../node_modules/@ethersproject/abstract-signer/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/address/lib.esm/index.js + 1 modules
var address_lib_esm = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var bytes_lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var properties_lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/transactions/lib.esm/index.js + 1 modules
var transactions_lib_esm = __webpack_require__("../../node_modules/@ethersproject/transactions/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/contracts/lib.esm/_version.js
const version = "contracts/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/contracts/lib.esm/index.js

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const logger = new logger_lib_esm.Logger(version);
;
;
///////////////////////////////
const allowedTransactionKeys = {
    chainId: true, data: true, from: true, gasLimit: true, gasPrice: true, nonce: true, to: true, value: true,
    type: true, accessList: true,
    maxFeePerGas: true, maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function resolveName(resolver, nameOrPromise) {
    return __awaiter(this, void 0, void 0, function* () {
        const name = yield nameOrPromise;
        if (typeof (name) !== "string") {
            logger.throwArgumentError("invalid address or ENS name", "name", name);
        }
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0,address_lib_esm.getAddress)(name);
        }
        catch (error) { }
        if (!resolver) {
            logger.throwError("a provider or signer is needed to resolve ENS names", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "resolveName"
            });
        }
        const address = yield resolver.resolveName(name);
        if (address == null) {
            logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        }
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function resolveAddresses(resolver, value, paramType) {
    return __awaiter(this, void 0, void 0, function* () {
        if (Array.isArray(paramType)) {
            return yield Promise.all(paramType.map((paramType, index) => {
                return resolveAddresses(resolver, ((Array.isArray(value)) ? value[index] : value[paramType.name]), paramType);
            }));
        }
        if (paramType.type === "address") {
            return yield resolveName(resolver, value);
        }
        if (paramType.type === "tuple") {
            return yield resolveAddresses(resolver, value, paramType.components);
        }
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) {
                return Promise.reject(logger.makeError("invalid value for array", logger_lib_esm.Logger.errors.INVALID_ARGUMENT, {
                    argument: "value",
                    value
                }));
            }
            return yield Promise.all(value.map((v) => resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function populateTransaction(contract, fragment, args) {
    return __awaiter(this, void 0, void 0, function* () {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof (args[args.length - 1]) === "object") {
            overrides = (0,properties_lib_esm.shallowCopy)(args.pop());
        }
        // Make sure the parameter count matches
        logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) {
                // Contracts with a Signer are from the Signer's frame-of-reference;
                // but we allow overriding "from" if it matches the signer
                overrides.from = (0,properties_lib_esm.resolveProperties)({
                    override: resolveName(contract.signer, overrides.from),
                    signer: contract.signer.getAddress()
                }).then((check) => __awaiter(this, void 0, void 0, function* () {
                    if ((0,address_lib_esm.getAddress)(check.signer) !== check.override) {
                        logger.throwError("Contract with a Signer cannot override from", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                            operation: "overrides.from"
                        });
                    }
                    return check.override;
                }));
            }
            else {
                overrides.from = contract.signer.getAddress();
            }
        }
        else if (overrides.from) {
            overrides.from = resolveName(contract.provider, overrides.from);
            //} else {
            // Contracts without a signer can override "from", and if
            // unspecified the zero address is used
            //overrides.from = AddressZero;
        }
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0,properties_lib_esm.resolveProperties)({
            args: resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: ((0,properties_lib_esm.resolveProperties)(overrides) || {})
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) {
            tx.nonce = bignumber/* BigNumber.from */.O$.from(ro.nonce).toNumber();
        }
        if (ro.gasLimit != null) {
            tx.gasLimit = bignumber/* BigNumber.from */.O$.from(ro.gasLimit);
        }
        if (ro.gasPrice != null) {
            tx.gasPrice = bignumber/* BigNumber.from */.O$.from(ro.gasPrice);
        }
        if (ro.maxFeePerGas != null) {
            tx.maxFeePerGas = bignumber/* BigNumber.from */.O$.from(ro.maxFeePerGas);
        }
        if (ro.maxPriorityFeePerGas != null) {
            tx.maxPriorityFeePerGas = bignumber/* BigNumber.from */.O$.from(ro.maxPriorityFeePerGas);
        }
        if (ro.from != null) {
            tx.from = ro.from;
        }
        if (ro.type != null) {
            tx.type = ro.type;
        }
        if (ro.accessList != null) {
            tx.accessList = (0,transactions_lib_esm.accessListify)(ro.accessList);
        }
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0,bytes_lib_esm.arrayify)(data);
            for (let i = 0; i < bytes.length; i++) {
                intrinsic += 4;
                if (bytes[i]) {
                    intrinsic += 64;
                }
            }
            tx.gasLimit = bignumber/* BigNumber.from */.O$.from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = bignumber/* BigNumber.from */.O$.from(ro.value);
            if (!roValue.isZero() && !fragment.payable) {
                logger.throwError("non-payable method cannot override value", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "overrides.value",
                    value: overrides.value
                });
            }
            tx.value = roValue;
        }
        if (ro.customData) {
            tx.customData = (0,properties_lib_esm.shallowCopy)(ro.customData);
        }
        if (ro.ccipReadEnabled) {
            tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        }
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key) => (overrides[key] != null));
        if (leftovers.length) {
            logger.throwError(`cannot override ${leftovers.map((l) => JSON.stringify(l)).join(",")}`, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "overrides",
                overrides: leftovers
            });
        }
        return tx;
    });
}
function buildPopulate(contract, fragment) {
    return function (...args) {
        return populateTransaction(contract, fragment, args);
    };
}
function buildEstimate(contract, fragment) {
    const signerOrProvider = (contract.signer || contract.provider);
    return function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!signerOrProvider) {
                logger.throwError("estimate require a provider or signer", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "estimateGas"
                });
            }
            const tx = yield populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations) => {
        return wait(confirmations).then((receipt) => {
            receipt.events = receipt.logs.map((log) => {
                let event = (0,properties_lib_esm.deepCopy)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                }
                catch (e) { }
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics) => {
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = () => { return contract.provider; };
                event.getBlock = () => {
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = () => {
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = () => {
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = (contract.signer || contract.provider);
    return function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof (args[args.length - 1]) === "object") {
                const overrides = (0,properties_lib_esm.shallowCopy)(args.pop());
                if (overrides.blockTag != null) {
                    blockTag = yield overrides.blockTag;
                }
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) {
                yield contract._deployed(blockTag);
            }
            // Call a node and get the result
            const tx = yield populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) {
                    value = value[0];
                }
                return value;
            }
            catch (error) {
                if (error.code === logger_lib_esm.Logger.errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function buildSend(contract, fragment) {
    return function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!contract.signer) {
                logger.throwError("sending a transaction requires a signer", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "sendTransaction"
                });
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) {
                yield contract._deployed();
            }
            const txRequest = yield populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            addContractWait(contract, tx);
            return tx;
        });
    };
}
function buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) {
        return buildCall(contract, fragment, collapseSimple);
    }
    return buildSend(contract, fragment);
}
function getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) {
        return "*";
    }
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic) => {
        if (Array.isArray(topic)) {
            return topic.join("|");
        }
        return topic;
    }).join(":") : "");
}
class RunningEvent {
    constructor(tag, filter) {
        (0,properties_lib_esm.defineReadOnly)(this, "tag", tag);
        (0,properties_lib_esm.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({ listener: listener, once: once });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item) => {
            if (done || item.listener !== listener) {
                return true;
            }
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i) => i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item) => {
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(() => {
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !(item.once);
        });
        return listenerCount;
    }
    prepareEvent(event) {
    }
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [event];
    }
}
class ErrorRunningEvent extends RunningEvent {
    constructor() {
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class FragmentRunningEvent extends RunningEvent {
    constructor(address, contractInterface, fragment, topics) {
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) {
                logger.throwArgumentError("topic mismatch", "topics", topics);
            }
            filter.topics = topics.slice();
        }
        else {
            filter.topics = [topic];
        }
        super(getEventTag(filter), filter);
        (0,properties_lib_esm.defineReadOnly)(this, "address", address);
        (0,properties_lib_esm.defineReadOnly)(this, "interface", contractInterface);
        (0,properties_lib_esm.defineReadOnly)(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics) => {
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        }
        catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0,abstract_coder/* checkResultErrors */.BR)(event.args);
        if (errors.length) {
            throw errors[0].error;
        }
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class WildcardRunningEvent extends RunningEvent {
    constructor(address, contractInterface) {
        super("*", { address: address });
        (0,properties_lib_esm.defineReadOnly)(this, "address", address);
        (0,properties_lib_esm.defineReadOnly)(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics) => {
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        }
        catch (error) {
            // No matching event
        }
    }
}
class BaseContract {
    constructor(addressOrName, contractInterface, signerOrProvider) {
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0,properties_lib_esm.defineReadOnly)(this, "interface", (0,properties_lib_esm.getStatic)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0,properties_lib_esm.defineReadOnly)(this, "provider", null);
            (0,properties_lib_esm.defineReadOnly)(this, "signer", null);
        }
        else if (abstract_signer_lib_esm/* Signer.isSigner */.E.isSigner(signerOrProvider)) {
            (0,properties_lib_esm.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0,properties_lib_esm.defineReadOnly)(this, "signer", signerOrProvider);
        }
        else if (lib_esm/* Provider.isProvider */.zt.isProvider(signerOrProvider)) {
            (0,properties_lib_esm.defineReadOnly)(this, "provider", signerOrProvider);
            (0,properties_lib_esm.defineReadOnly)(this, "signer", null);
        }
        else {
            logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        }
        (0,properties_lib_esm.defineReadOnly)(this, "callStatic", {});
        (0,properties_lib_esm.defineReadOnly)(this, "estimateGas", {});
        (0,properties_lib_esm.defineReadOnly)(this, "functions", {});
        (0,properties_lib_esm.defineReadOnly)(this, "populateTransaction", {});
        (0,properties_lib_esm.defineReadOnly)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature) => {
                const event = this.interface.events[eventSignature];
                (0,properties_lib_esm.defineReadOnly)(this.filters, eventSignature, (...args) => {
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) {
                    uniqueFilters[event.name] = [];
                }
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name) => {
                const filters = uniqueFilters[name];
                if (filters.length === 1) {
                    (0,properties_lib_esm.defineReadOnly)(this.filters, name, this.filters[filters[0]]);
                }
                else {
                    logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
                }
            });
        }
        (0,properties_lib_esm.defineReadOnly)(this, "_runningEvents", {});
        (0,properties_lib_esm.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) {
            logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        }
        (0,properties_lib_esm.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) {
            (0,properties_lib_esm.defineReadOnly)(this, "resolvedAddress", resolveName(this.provider, addressOrName));
        }
        else {
            try {
                (0,properties_lib_esm.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0,address_lib_esm.getAddress)(addressOrName)));
            }
            catch (error) {
                // Without a provider, we cannot use ENS names
                logger.throwError("provider is required to use ENS name as contract address", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "new Contract"
                });
            }
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e) => { });
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature) => {
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) {
                    uniqueNames[`%${name}`] = [];
                }
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) {
                (0,properties_lib_esm.defineReadOnly)(this, signature, buildDefault(this, fragment, true));
            }
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) {
                (0,properties_lib_esm.defineReadOnly)(this.functions, signature, buildDefault(this, fragment, false));
            }
            if (this.callStatic[signature] == null) {
                (0,properties_lib_esm.defineReadOnly)(this.callStatic, signature, buildCall(this, fragment, true));
            }
            if (this.populateTransaction[signature] == null) {
                (0,properties_lib_esm.defineReadOnly)(this.populateTransaction, signature, buildPopulate(this, fragment));
            }
            if (this.estimateGas[signature] == null) {
                (0,properties_lib_esm.defineReadOnly)(this.estimateGas, signature, buildEstimate(this, fragment));
            }
        });
        Object.keys(uniqueNames).forEach((name) => {
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) {
                return;
            }
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) {
                    (0,properties_lib_esm.defineReadOnly)(this, name, this[signature]);
                }
            }
            catch (e) { }
            if (this.functions[name] == null) {
                (0,properties_lib_esm.defineReadOnly)(this.functions, name, this.functions[signature]);
            }
            if (this.callStatic[name] == null) {
                (0,properties_lib_esm.defineReadOnly)(this.callStatic, name, this.callStatic[signature]);
            }
            if (this.populateTransaction[name] == null) {
                (0,properties_lib_esm.defineReadOnly)(this.populateTransaction, name, this.populateTransaction[signature]);
            }
            if (this.estimateGas[name] == null) {
                (0,properties_lib_esm.defineReadOnly)(this.estimateGas, name, this.estimateGas[signature]);
            }
        });
    }
    static getContractAddress(transaction) {
        return (0,address_lib_esm.getContractAddress)(transaction);
    }
    static getInterface(contractInterface) {
        if (lib_esm_interface/* Interface.isInterface */.vU.isInterface(contractInterface)) {
            return contractInterface;
        }
        return new lib_esm_interface/* Interface */.vU(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) {
                this._deployedPromise = this.deployTransaction.wait().then(() => {
                    return this;
                });
            }
            else {
                // @TODO: Once we allow a timeout to be passed in, we will wait
                // up to that many blocks for getCode
                // Otherwise, poll for our code to be deployed
                this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code) => {
                    if (code === "0x") {
                        logger.throwError("contract not deployed", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                            contractAddress: this.address,
                            operation: "getDeployed"
                        });
                    }
                    return this;
                });
            }
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) {
            logger.throwError("sending a transactions require a signer", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, { operation: "sendTransaction(fallback)" });
        }
        const tx = (0,properties_lib_esm.shallowCopy)(overrides || {});
        ["from", "to"].forEach(function (key) {
            if (tx[key] == null) {
                return;
            }
            logger.throwError("cannot override " + key, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, { operation: key });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(() => {
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof (signerOrProvider) === "string") {
            signerOrProvider = new abstract_signer_lib_esm/* VoidSigner */.b(signerOrProvider, this.provider);
        }
        const contract = new (this.constructor)(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) {
            (0,properties_lib_esm.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
        }
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new (this.constructor)(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return lib_esm_interface/* Indexed.isIndexed */.Hk.isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) {
            return this._runningEvents[runningEvent.tag];
        }
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof (eventName) === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") {
                return this._normalizeRunningEvent(new ErrorRunningEvent());
            }
            // Listen for any event that is registered
            if (eventName === "event") {
                return this._normalizeRunningEvent(new RunningEvent("event", null));
            }
            // Listen for any event
            if (eventName === "*") {
                return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
            }
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof (topic) !== "string") {
                    throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                }
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            }
            catch (error) { }
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new RunningEvent(getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0,properties_lib_esm.deepCopy)(log);
        event.removeListener = () => {
            if (!listener) {
                return;
            }
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = () => { return this.provider.getBlock(log.blockHash); };
        event.getTransaction = () => { return this.provider.getTransaction(log.transactionHash); };
        event.getTransactionReceipt = () => { return this.provider.getTransactionReceipt(log.transactionHash); };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) {
            logger.throwError("events require a provider or a signer with a provider", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, { operation: "once" });
        }
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log) => {
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) {
                    try {
                        const args = runningEvent.getEmit(event);
                        this.emit(runningEvent.filter, ...args);
                    }
                    catch (error) {
                        event.decodeError = error.error;
                    }
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) {
                    this.emit("event", event);
                }
                // Emit "error" if there was an error
                if (event.decodeError != null) {
                    this.emit("error", event.decodeError, event);
                }
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) {
                this.provider.on(runningEvent.filter, wrappedEmit);
            }
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0,properties_lib_esm.shallowCopy)(runningEvent.filter);
        if (typeof (fromBlockOrBlockhash) === "string" && (0,bytes_lib_esm.isHexString)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) {
                logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            }
            filter.blockHash = fromBlockOrBlockhash;
        }
        else {
            filter.fromBlock = ((fromBlockOrBlockhash != null) ? fromBlockOrBlockhash : 0);
            filter.toBlock = ((toBlock != null) ? toBlock : "latest");
        }
        return this.provider.getLogs(filter).then((logs) => {
            return logs.map((log) => this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) {
            return false;
        }
        const runningEvent = this._getRunningEvent(eventName);
        const result = (runningEvent.run(args) > 0);
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) {
            return 0;
        }
        if (eventName == null) {
            return Object.keys(this._runningEvents).reduce((accum, key) => {
                return accum + this._runningEvents[key].listenerCount();
            }, 0);
        }
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) {
            return [];
        }
        if (eventName == null) {
            const result = [];
            for (let tag in this._runningEvents) {
                this._runningEvents[tag].listeners().forEach((listener) => {
                    result.push(listener);
                });
            }
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) {
            return this;
        }
        if (eventName == null) {
            for (const tag in this._runningEvents) {
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) {
            return this;
        }
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class Contract extends BaseContract {
}
class ContractFactory {
    constructor(contractInterface, bytecode, signer) {
        let bytecodeHex = null;
        if (typeof (bytecode) === "string") {
            bytecodeHex = bytecode;
        }
        else if ((0,bytes_lib_esm.isBytes)(bytecode)) {
            bytecodeHex = (0,bytes_lib_esm.hexlify)(bytecode);
        }
        else if (bytecode && typeof (bytecode.object) === "string") {
            // Allow the bytecode object from the Solidity compiler
            bytecodeHex = bytecode.object;
        }
        else {
            // Crash in the next verification step
            bytecodeHex = "!";
        }
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") {
            bytecodeHex = "0x" + bytecodeHex;
        }
        // Make sure the final result is valid bytecode
        if (!(0,bytes_lib_esm.isHexString)(bytecodeHex) || (bytecodeHex.length % 2)) {
            logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        }
        // If we have a signer, make sure it is valid
        if (signer && !abstract_signer_lib_esm/* Signer.isSigner */.E.isSigner(signer)) {
            logger.throwArgumentError("invalid signer", "signer", signer);
        }
        (0,properties_lib_esm.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0,properties_lib_esm.defineReadOnly)(this, "interface", (0,properties_lib_esm.getStatic)(new.target, "getInterface")(contractInterface));
        (0,properties_lib_esm.defineReadOnly)(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof (args[args.length - 1]) === "object") {
            tx = (0,properties_lib_esm.shallowCopy)(args.pop());
            for (const key in tx) {
                if (!allowedTransactionKeys[key]) {
                    throw new Error("unknown transaction override " + key);
                }
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        ["data", "from", "to"].forEach((key) => {
            if (tx[key] == null) {
                return;
            }
            logger.throwError("cannot override " + key, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, { operation: key });
        });
        if (tx.value) {
            const value = bignumber/* BigNumber.from */.O$.from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) {
                logger.throwError("non-payable constructor cannot override value", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "overrides.value",
                    value: tx.value
                });
            }
        }
        // Make sure the call matches the constructor signature
        logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0,bytes_lib_esm.hexlify)((0,bytes_lib_esm.concat)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return __awaiter(this, void 0, void 0, function* () {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) {
                overrides = args.pop();
            }
            // Make sure the call matches the constructor signature
            logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0,properties_lib_esm.getStatic)(this.constructor, "getContractAddress")(tx);
            const contract = (0,properties_lib_esm.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            addContractWait(contract, tx);
            (0,properties_lib_esm.defineReadOnly)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return (this.constructor).getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new (this.constructor)(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) {
            logger.throwError("missing compiler output", logger_lib_esm.Logger.errors.MISSING_ARGUMENT, { argument: "compilerOutput" });
        }
        if (typeof (compilerOutput) === "string") {
            compilerOutput = JSON.parse(compilerOutput);
        }
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) {
            bytecode = compilerOutput.bytecode;
        }
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) {
            bytecode = compilerOutput.evm.bytecode;
        }
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return Contract.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0,address_lib_esm.getContractAddress)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new Contract(address, contractInterface, signer);
    }
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/hash/lib.esm/_version.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: () => (/* binding */ version)
/* harmony export */ });
const version = "hash/5.7.0";
//# sourceMappingURL=_version.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/hash/lib.esm/id.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   id: () => (/* binding */ id)
/* harmony export */ });
/* harmony import */ var _ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
/* harmony import */ var _ethersproject_strings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");


function id(text) {
    return (0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_0__.keccak256)((0,_ethersproject_strings__WEBPACK_IMPORTED_MODULE_1__/* .toUtf8Bytes */ .Y0)(text));
}
//# sourceMappingURL=id.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/hash/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _TypedDataEncoder: () => (/* reexport safe */ _typed_data__WEBPACK_IMPORTED_MODULE_3__.E),
/* harmony export */   dnsEncode: () => (/* reexport safe */ _namehash__WEBPACK_IMPORTED_MODULE_1__.Kn),
/* harmony export */   ensNormalize: () => (/* reexport safe */ _namehash__WEBPACK_IMPORTED_MODULE_1__.w3),
/* harmony export */   hashMessage: () => (/* reexport safe */ _message__WEBPACK_IMPORTED_MODULE_2__.r),
/* harmony export */   id: () => (/* reexport safe */ _id__WEBPACK_IMPORTED_MODULE_0__.id),
/* harmony export */   isValidName: () => (/* reexport safe */ _namehash__WEBPACK_IMPORTED_MODULE_1__.r1),
/* harmony export */   messagePrefix: () => (/* reexport safe */ _message__WEBPACK_IMPORTED_MODULE_2__.B),
/* harmony export */   namehash: () => (/* reexport safe */ _namehash__WEBPACK_IMPORTED_MODULE_1__.VM)
/* harmony export */ });
/* harmony import */ var _id__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/id.js");
/* harmony import */ var _namehash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/namehash.js");
/* harmony import */ var _message__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/message.js");
/* harmony import */ var _typed_data__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/typed-data.js");







//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/hash/lib.esm/message.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: () => (/* binding */ messagePrefix),
/* harmony export */   r: () => (/* binding */ hashMessage)
/* harmony export */ });
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
/* harmony import */ var _ethersproject_strings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");



const messagePrefix = "\x19Ethereum Signed Message:\n";
function hashMessage(message) {
    if (typeof (message) === "string") {
        message = (0,_ethersproject_strings__WEBPACK_IMPORTED_MODULE_0__/* .toUtf8Bytes */ .Y0)(message);
    }
    return (0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_1__.keccak256)((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_2__.concat)([
        (0,_ethersproject_strings__WEBPACK_IMPORTED_MODULE_0__/* .toUtf8Bytes */ .Y0)(messagePrefix),
        (0,_ethersproject_strings__WEBPACK_IMPORTED_MODULE_0__/* .toUtf8Bytes */ .Y0)(String(message.length)),
        message
    ]));
}
//# sourceMappingURL=message.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/hash/lib.esm/namehash.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Kn: () => (/* binding */ dnsEncode),
  w3: () => (/* binding */ ensNormalize),
  r1: () => (/* binding */ isValidName),
  VM: () => (/* binding */ namehash)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/strings/lib.esm/utf8.js + 1 modules
var utf8 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/keccak256/lib.esm/index.js
var keccak256_lib_esm = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hash/lib.esm/_version.js
var _version = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/_version.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/base64/lib.esm/base64.js
var base64 = __webpack_require__("../../node_modules/@ethersproject/base64/lib.esm/base64.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/hash/lib.esm/ens-normalize/decoder.js
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */
// https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function flat(array, depth) {
    if (depth == null) {
        depth = 1;
    }
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function (arr, depth) {
        forEach.call(arr, function (val) {
            if (depth > 0 && Array.isArray(val)) {
                flatDeep(val, depth - 1);
            }
            else {
                result.push(val);
            }
        });
    };
    flatDeep(array, depth);
    return result;
}
function fromEntries(array) {
    const result = {};
    for (let i = 0; i < array.length; i++) {
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function decode_arithmetic(bytes) {
    let pos = 0;
    function u16() { return (bytes[pos++] << 8) | bytes[pos++]; }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [0, 1]; // first symbol has frequency 1
    for (let i = 1; i < symbol_count; i++) {
        acc.push(total += u16());
    }
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = (read_buffer << 8) | bytes[pos++];
            read_width = 8;
        }
        return (read_buffer >> --read_width) & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for (let i = 0; i < N; i++)
        register = (register << 1) | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while (true) {
        let value = Math.floor((((register - low + 1) * total) - 1) / range);
        let start = 0;
        let end = symbol_count;
        while (end - start > 1) { // binary search
            let mid = (start + end) >>> 1;
            if (value < acc[mid]) {
                end = mid;
            }
            else {
                start = mid;
            }
        }
        if (start == 0)
            break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while (((a ^ b) & HALF) == 0) {
            register = (register << 1) & MASK | read_bit();
            a = (a << 1) & MASK;
            b = (b << 1) & MASK | 1;
        }
        while (a & ~b & QRTR) {
            register = (register & HALF) | ((register << 1) & (MASK >>> 1)) | read_bit();
            a = (a << 1) ^ HALF;
            b = ((b ^ HALF) << 1) | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map(x => {
        switch (x - offset) {
            case 3: return offset + 0x10100 + ((bytes[pos_payload++] << 16) | (bytes[pos_payload++] << 8) | bytes[pos_payload++]);
            case 2: return offset + 0x100 + ((bytes[pos_payload++] << 8) | bytes[pos_payload++]);
            case 1: return offset + bytes[pos_payload++];
            default: return x - 1;
        }
    });
}
// returns an iterator which returns the next symbol
function read_payload(v) {
    let pos = 0;
    return () => v[pos++];
}
function read_compressed_payload(bytes) {
    return read_payload(decode_arithmetic(bytes));
}
// eg. [0,1,2,3...] => [0,-1,1,-2,...]
function signed(i) {
    return (i & 1) ? (~i >> 1) : (i >> 1);
}
function read_counts(n, next) {
    let v = Array(n);
    for (let i = 0; i < n; i++)
        v[i] = 1 + next();
    return v;
}
function read_ascending(n, next) {
    let v = Array(n);
    for (let i = 0, x = -1; i < n; i++)
        v[i] = x += 1 + next();
    return v;
}
function read_deltas(n, next) {
    let v = Array(n);
    for (let i = 0, x = 0; i < n; i++)
        v[i] = x += signed(next());
    return v;
}
function read_member_array(next, lookup) {
    let v = read_ascending(next(), next);
    let n = next();
    let vX = read_ascending(n, next);
    let vN = read_counts(n, next);
    for (let i = 0; i < n; i++) {
        for (let j = 0; j < vN[i]; j++) {
            v.push(vX[i] + j);
        }
    }
    return lookup ? v.map(x => lookup[x]) : v;
}
// returns array of 
// [x, ys] => single replacement rule
// [x, ys, n, dx, dx] => linear map
function read_mapped_map(next) {
    let ret = [];
    while (true) {
        let w = next();
        if (w == 0)
            break;
        ret.push(read_linear_table(w, next));
    }
    while (true) {
        let w = next() - 1;
        if (w < 0)
            break;
        ret.push(read_replacement_table(w, next));
    }
    return fromEntries(flat(ret));
}
function read_zero_terminated_array(next) {
    let v = [];
    while (true) {
        let i = next();
        if (i == 0)
            break;
        v.push(i);
    }
    return v;
}
function read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(() => []);
    for (let i = 0; i < w; i++) {
        read_deltas(n, next).forEach((x, j) => m[j].push(x));
    }
    return m;
}
function read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = read_zero_terminated_array(next);
    let m = read_transposed(vN.length, 1 + w, next);
    return flat(m.map((v, i) => {
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j) => {
            let j_dy = j * dy;
            return [x + j * dx, ys.map(y => y + j_dy)];
        });
    }));
}
function read_replacement_table(w, next) {
    let n = 1 + next();
    let m = read_transposed(n, 1 + w, next);
    return m.map(v => [v[0], v.slice(1)]);
}
function read_emoji_trie(next) {
    let sorted = read_member_array(next).sort((a, b) => a - b);
    return read();
    function read() {
        let branches = [];
        while (true) {
            let keys = read_member_array(next, sorted);
            if (keys.length == 0)
                break;
            branches.push({ set: new Set(keys), node: read() });
        }
        branches.sort((a, b) => b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = (temp / 3) | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return { branches, valid, fe0f, save, check };
    }
}
//# sourceMappingURL=decoder.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/hash/lib.esm/ens-normalize/include.js
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */


function getData() {
    return read_compressed_payload((0,base64/* decode */.J)('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'));
}
//# sourceMappingURL=include.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/hash/lib.esm/ens-normalize/lib.js
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */


const r = getData();

// @TODO: This should be lazily loaded
const VALID = new Set(read_member_array(r));
const IGNORED = new Set(read_member_array(r));
const MAPPED = read_mapped_map(r);
const EMOJI_ROOT = read_emoji_trie(r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const HYPHEN = 0x2D;
const UNDERSCORE = 0x5F;
function explode_cp(name) {
    return (0,utf8/* toUtf8CodePoints */.XL)(name);
}
function filter_fe0f(cps) {
    return cps.filter(cp => cp != 0xFE0F);
}
function ens_normalize_post_check(name) {
    for (let label of name.split('.')) {
        let cps = explode_cp(label);
        try {
            for (let i = cps.lastIndexOf(UNDERSCORE) - 1; i >= 0; i--) {
                if (cps[i] !== UNDERSCORE) {
                    throw new Error(`underscore only allowed at start`);
                }
            }
            if (cps.length >= 4 && cps.every(cp => cp < 0x80) && cps[2] === HYPHEN && cps[3] === HYPHEN) {
                throw new Error(`invalid label extension`);
            }
        }
        catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function ens_normalize(name) {
    return ens_normalize_post_check(normalize(name, filter_fe0f));
}
function normalize(name, emoji_filter) {
    let input = explode_cp(name).reverse(); // flip for pop
    let output = [];
    while (input.length) {
        let emoji = consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if (VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if (IGNORED.has(cp)) {
            continue;
        }
        let cps = MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return ens_normalize_post_check(nfc(String.fromCodePoint(...output)));
}
function nfc(s) {
    return s.normalize('NFC');
}
function consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten)
        eaten.length = 0; // clear input buffer (if needed)
    while (pos) {
        let cp = cps[--pos];
        node = (_a = node.branches.find(x => x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node)
            break;
        if (node.save) { // remember
            saved = cp;
        }
        else if (node.check) { // check exclusion
            if (cp === saved)
                break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F)
                pos--; // consume optional FE0F
        }
        if (node.valid) { // this is a valid emoji (so far)
            emoji = stack.slice(); // copy stack
            if (node.valid == 2)
                emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten)
                eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}
//# sourceMappingURL=lib.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/hash/lib.esm/namehash.js





const logger = new logger_lib_esm.Logger(_version/* version */.i);

const Zeros = new Uint8Array(32);
Zeros.fill(0);
function checkComponent(comp) {
    if (comp.length === 0) {
        throw new Error("invalid ENS name; empty component");
    }
    return comp;
}
function ensNameSplit(name) {
    const bytes = (0,utf8/* toUtf8Bytes */.Y0)(ens_normalize(name));
    const comps = [];
    if (name.length === 0) {
        return comps;
    }
    let last = 0;
    for (let i = 0; i < bytes.length; i++) {
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push(checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) {
        throw new Error("invalid ENS name; empty component");
    }
    comps.push(checkComponent(bytes.slice(last)));
    return comps;
}
function ensNormalize(name) {
    return ensNameSplit(name).map((comp) => (0,utf8/* toUtf8String */.ZN)(comp)).join(".");
}
function isValidName(name) {
    try {
        return (ensNameSplit(name).length !== 0);
    }
    catch (error) { }
    return false;
}
function namehash(name) {
    /* istanbul ignore if */
    if (typeof (name) !== "string") {
        logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    }
    let result = Zeros;
    const comps = ensNameSplit(name);
    while (comps.length) {
        result = (0,keccak256_lib_esm.keccak256)((0,lib_esm.concat)([result, (0,keccak256_lib_esm.keccak256)(comps.pop())]));
    }
    return (0,lib_esm.hexlify)(result);
}
function dnsEncode(name) {
    return (0,lib_esm.hexlify)((0,lib_esm.concat)(ensNameSplit(name).map((comp) => {
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) {
            throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        }
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}
//# sourceMappingURL=namehash.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/hash/lib.esm/typed-data.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E: () => (/* binding */ TypedDataEncoder)
/* harmony export */ });
/* harmony import */ var _ethersproject_address__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
/* harmony import */ var _ethersproject_properties__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
/* harmony import */ var _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
/* harmony import */ var _version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/_version.js");
/* harmony import */ var _id__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/id.js");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







const logger = new _ethersproject_logger__WEBPACK_IMPORTED_MODULE_0__.Logger(_version__WEBPACK_IMPORTED_MODULE_1__/* .version */ .i);

const padding = new Uint8Array(32);
padding.fill(0);
const NegativeOne = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(-1);
const Zero = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(0);
const One = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(1);
const MaxUint256 = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function hexPadRight(value) {
    const bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.arrayify)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) {
        return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexConcat)([bytes, padding.slice(padOffset)]);
    }
    return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexlify)(bytes);
}
const hexTrue = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexZeroPad)(One.toHexString(), 32);
const hexFalse = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexZeroPad)(Zero.toHexString(), 32);
const domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const domainFieldNames = [
    "name", "version", "chainId", "verifyingContract", "salt"
];
function checkString(key) {
    return function (value) {
        if (typeof (value) !== "string") {
            logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        }
        return value;
    };
}
const domainChecks = {
    name: checkString("name"),
    version: checkString("version"),
    chainId: function (value) {
        try {
            return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(value).toString();
        }
        catch (error) { }
        return logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function (value) {
        try {
            return (0,_ethersproject_address__WEBPACK_IMPORTED_MODULE_4__.getAddress)(value).toLowerCase();
        }
        catch (error) { }
        return logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function (value) {
        try {
            const bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.arrayify)(value);
            if (bytes.length !== 32) {
                throw new Error("bad length");
            }
            return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexlify)(bytes);
        }
        catch (error) { }
        return logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = (match[1] === "");
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || (match[2] && match[2] !== String(width))) {
                logger.throwArgumentError("invalid numeric width", "type", type);
            }
            const boundsUpper = MaxUint256.mask(signed ? (width - 1) : width);
            const boundsLower = signed ? boundsUpper.add(One).mul(NegativeOne) : Zero;
            return function (value) {
                const v = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) {
                    logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                }
                return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) {
                logger.throwArgumentError("invalid bytes width", "type", type);
            }
            return function (value) {
                const bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.arrayify)(value);
                if (bytes.length !== width) {
                    logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                }
                return hexPadRight(value);
            };
        }
    }
    switch (type) {
        case "address": return function (value) {
            return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexZeroPad)((0,_ethersproject_address__WEBPACK_IMPORTED_MODULE_4__.getAddress)(value), 32);
        };
        case "bool": return function (value) {
            return ((!value) ? hexFalse : hexTrue);
        };
        case "bytes": return function (value) {
            return (0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_5__.keccak256)(value);
        };
        case "string": return function (value) {
            return (0,_id__WEBPACK_IMPORTED_MODULE_6__.id)(value);
        };
    }
    return null;
}
function encodeType(name, fields) {
    return `${name}(${fields.map(({ name, type }) => (type + " " + name)).join(",")})`;
}
class TypedDataEncoder {
    constructor(types) {
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_7__.defineReadOnly)(this, "types", Object.freeze((0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_7__.deepCopy)(types)));
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_7__.defineReadOnly)(this, "_encoderCache", {});
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_7__.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type) => {
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for (const name in types) {
            const uniqueNames = {};
            types[name].forEach((field) => {
                // Check each field has a unique name
                if (uniqueNames[field.name]) {
                    logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                }
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) {
                    logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                }
                // Is this a base encoding type?
                const encoder = getBaseEncoder(baseType);
                if (encoder) {
                    return;
                }
                if (!parents[baseType]) {
                    logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                }
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n) => (parents[n].length === 0));
        if (primaryTypes.length === 0) {
            logger.throwArgumentError("missing primary type", "types", types);
        }
        else if (primaryTypes.length > 1) {
            logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t) => (JSON.stringify(t))).join(", ")}`, "types", types);
        }
        (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_7__.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) {
                logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            }
            found[type] = true;
            Object.keys(links[type]).forEach((child) => {
                if (!parents[child]) {
                    return;
                }
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype) => {
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for (const name in subtypes) {
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = encodeType(name, types[name]) + st.map((t) => encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) {
            encoder = this._encoderCache[type] = this._getEncoder(type);
        }
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = getBaseEncoder(type);
            if (encoder) {
                return encoder;
            }
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value) => {
                if (length >= 0 && value.length !== length) {
                    logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                }
                let result = value.map(subEncoder);
                if (this._types[subtype]) {
                    result = result.map(_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_5__.keccak256);
                }
                return (0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_5__.keccak256)((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexConcat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0,_id__WEBPACK_IMPORTED_MODULE_6__.id)(this._types[type]);
            return (value) => {
                const values = fields.map(({ name, type }) => {
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) {
                        return (0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_5__.keccak256)(result);
                    }
                    return result;
                });
                values.unshift(encodedType);
                return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexConcat)(values);
            };
        }
        return logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) {
            logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        }
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_5__.keccak256)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = getBaseEncoder(type);
            if (encoder) {
                return callback(type, value);
            }
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) {
                logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            }
            return value.map((v) => this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            return fields.reduce((accum, { name, type }) => {
                accum[name] = this._visit(type, value[name], callback);
                return accum;
            }, {});
        }
        return logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new TypedDataEncoder(types);
    }
    static getPrimaryType(types) {
        return TypedDataEncoder.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return TypedDataEncoder.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for (const name in domain) {
            const type = domainFieldTypes[name];
            if (!type) {
                logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            }
            domainFields.push({ name, type });
        }
        domainFields.sort((a, b) => {
            return domainFieldNames.indexOf(a.name) - domainFieldNames.indexOf(b.name);
        });
        return TypedDataEncoder.hashStruct("EIP712Domain", { EIP712Domain: domainFields }, domain);
    }
    static encode(domain, types, value) {
        return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexConcat)([
            "0x1901",
            TypedDataEncoder.hashDomain(domain),
            TypedDataEncoder.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_5__.keccak256)(TypedDataEncoder.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return __awaiter(this, void 0, void 0, function* () {
            // Make a copy to isolate it from the object passed in
            domain = (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_7__.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.isHexString)(domain.verifyingContract, 20)) {
                ensCache[domain.verifyingContract] = "0x";
            }
            // We are going to use the encoder to visit all the base values
            const encoder = TypedDataEncoder.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value) => {
                if (type === "address" && !(0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.isHexString)(value, 20)) {
                    ensCache[value] = "0x";
                }
                return value;
            });
            // Lookup each name
            for (const name in ensCache) {
                ensCache[name] = yield resolveName(name);
            }
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) {
                domain.verifyingContract = ensCache[domain.verifyingContract];
            }
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value) => {
                if (type === "address" && ensCache[value]) {
                    return ensCache[value];
                }
                return value;
            });
            return { domain, value };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        TypedDataEncoder.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        domainFieldNames.forEach((name) => {
            const value = domain[name];
            if (value == null) {
                return;
            }
            domainValues[name] = domainChecks[name](value);
            domainTypes.push({ name, type: domainFieldTypes[name] });
        });
        const encoder = TypedDataEncoder.from(types);
        const typesWithDomain = (0,_ethersproject_properties__WEBPACK_IMPORTED_MODULE_7__.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) {
            logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        }
        else {
            typesWithDomain.EIP712Domain = domainTypes;
        }
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value) => {
                // bytes
                if (type.match(/^bytes(\d*)/)) {
                    return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.hexlify)((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_3__.arrayify)(value));
                }
                // uint or int
                if (type.match(/^u?int/)) {
                    return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_2__/* .BigNumber.from */ .O$.from(value).toString();
                }
                switch (type) {
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof (value) !== "string") {
                            logger.throwArgumentError(`invalid string`, "value", value);
                        }
                        return value;
                }
                return logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}
//# sourceMappingURL=typed-data.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/hdnode/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  HDNode: () => (/* binding */ HDNode),
  defaultPath: () => (/* binding */ defaultPath),
  entropyToMnemonic: () => (/* binding */ entropyToMnemonic),
  getAccountPath: () => (/* binding */ getAccountPath),
  isValidMnemonic: () => (/* binding */ isValidMnemonic),
  mnemonicToEntropy: () => (/* binding */ mnemonicToEntropy),
  mnemonicToSeed: () => (/* binding */ mnemonicToSeed)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/basex/lib.esm/index.js
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/basex/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var bytes_lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/strings/lib.esm/utf8.js + 1 modules
var utf8 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/pbkdf2/lib.esm/pbkdf2.js
var pbkdf2 = __webpack_require__("../../node_modules/@ethersproject/pbkdf2/lib.esm/pbkdf2.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var properties_lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/signing-key/lib.esm/index.js + 2 modules
var signing_key_lib_esm = __webpack_require__("../../node_modules/@ethersproject/signing-key/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/sha2/lib.esm/sha2.js + 1 modules
var sha2 = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/sha2.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/sha2/lib.esm/types.js
var types = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/types.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/transactions/lib.esm/index.js + 1 modules
var transactions_lib_esm = __webpack_require__("../../node_modules/@ethersproject/transactions/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/wordlists/lib/browser-wordlists.js
var browser_wordlists = __webpack_require__("../../node_modules/@ethersproject/wordlists/lib/browser-wordlists.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/hdnode/lib.esm/_version.js
const version = "hdnode/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/hdnode/lib.esm/index.js













const logger = new logger_lib_esm.Logger(version);
const N = bignumber/* BigNumber.from */.O$.from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const MasterSecret = (0,utf8/* toUtf8Bytes */.Y0)("Bitcoin seed");
const HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function getUpperMask(bits) {
    return ((1 << bits) - 1) << (8 - bits);
}
// Returns a byte with the LSB bits set
function getLowerMask(bits) {
    return (1 << bits) - 1;
}
function bytes32(value) {
    return (0,bytes_lib_esm.hexZeroPad)((0,bytes_lib_esm.hexlify)(value), 32);
}
function base58check(data) {
    return lib_esm.Base58.encode((0,bytes_lib_esm.concat)([data, (0,bytes_lib_esm.hexDataSlice)((0,sha2/* sha256 */.JQ)((0,sha2/* sha256 */.JQ)(data)), 0, 4)]));
}
function getWordlist(wordlist) {
    if (wordlist == null) {
        return browser_wordlists/* wordlists.en */.E.en;
    }
    if (typeof (wordlist) === "string") {
        const words = browser_wordlists/* wordlists */.E[wordlist];
        if (words == null) {
            logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        }
        return words;
    }
    return wordlist;
}
const _constructorGuard = {};
const defaultPath = "m/44'/60'/0'/0/0";
;
class HDNode {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */
    constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath) {
        /* istanbul ignore if */
        if (constructorGuard !== _constructorGuard) {
            throw new Error("HDNode constructor cannot be called directly");
        }
        if (privateKey) {
            const signingKey = new signing_key_lib_esm.SigningKey(privateKey);
            (0,properties_lib_esm.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0,properties_lib_esm.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        }
        else {
            (0,properties_lib_esm.defineReadOnly)(this, "privateKey", null);
            (0,properties_lib_esm.defineReadOnly)(this, "publicKey", (0,bytes_lib_esm.hexlify)(publicKey));
        }
        (0,properties_lib_esm.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0,properties_lib_esm.defineReadOnly)(this, "fingerprint", (0,bytes_lib_esm.hexDataSlice)((0,sha2/* ripemd160 */.bP)((0,sha2/* sha256 */.JQ)(this.publicKey)), 0, 4));
        (0,properties_lib_esm.defineReadOnly)(this, "address", (0,transactions_lib_esm.computeAddress)(this.publicKey));
        (0,properties_lib_esm.defineReadOnly)(this, "chainCode", chainCode);
        (0,properties_lib_esm.defineReadOnly)(this, "index", index);
        (0,properties_lib_esm.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0,properties_lib_esm.defineReadOnly)(this, "mnemonic", null);
            (0,properties_lib_esm.defineReadOnly)(this, "path", null);
        }
        else if (typeof (mnemonicOrPath) === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0,properties_lib_esm.defineReadOnly)(this, "mnemonic", null);
            (0,properties_lib_esm.defineReadOnly)(this, "path", mnemonicOrPath);
        }
        else {
            // From a fully qualified source
            (0,properties_lib_esm.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0,properties_lib_esm.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) {
            throw new Error("Depth too large!");
        }
        return base58check((0,bytes_lib_esm.concat)([
            ((this.privateKey != null) ? "0x0488ADE4" : "0x0488B21E"),
            (0,bytes_lib_esm.hexlify)(this.depth),
            this.parentFingerprint,
            (0,bytes_lib_esm.hexZeroPad)((0,bytes_lib_esm.hexlify)(this.index), 4),
            this.chainCode,
            ((this.privateKey != null) ? (0,bytes_lib_esm.concat)(["0x00", this.privateKey]) : this.publicKey),
        ]));
    }
    neuter() {
        return new HDNode(_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) {
            throw new Error("invalid index - " + String(index));
        }
        // Base path
        let path = this.path;
        if (path) {
            path += "/" + (index & ~HardenedBit);
        }
        const data = new Uint8Array(37);
        if (index & HardenedBit) {
            if (!this.privateKey) {
                throw new Error("cannot derive child of neutered node");
            }
            // Data = 0x00 || ser_256(k_par)
            data.set((0,bytes_lib_esm.arrayify)(this.privateKey), 1);
            // Hardened path
            if (path) {
                path += "'";
            }
        }
        else {
            // Data = ser_p(point(k_par))
            data.set((0,bytes_lib_esm.arrayify)(this.publicKey));
        }
        // Data += ser_32(i)
        for (let i = 24; i >= 0; i -= 8) {
            data[33 + (i >> 3)] = ((index >> (24 - i)) & 0xff);
        }
        const I = (0,bytes_lib_esm.arrayify)((0,sha2/* computeHmac */.Gy)(types/* SupportedAlgorithm.sha512 */.p.sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) {
            ki = bytes32(bignumber/* BigNumber.from */.O$.from(IL).add(this.privateKey).mod(N));
        }
        else {
            const ek = new signing_key_lib_esm.SigningKey((0,bytes_lib_esm.hexlify)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) {
            mnemonicOrPath = Object.freeze({
                phrase: srcMnemonic.phrase,
                path: path,
                locale: (srcMnemonic.locale || "en")
            });
        }
        return new HDNode(_constructorGuard, ki, Ki, this.fingerprint, bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || (components[0] === "m" && this.depth !== 0)) {
            throw new Error("invalid path - " + path);
        }
        if (components[0] === "m") {
            components.shift();
        }
        let result = this;
        for (let i = 0; i < components.length; i++) {
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= HardenedBit) {
                    throw new Error("invalid path index - " + component);
                }
                result = result._derive(HardenedBit + index);
            }
            else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= HardenedBit) {
                    throw new Error("invalid path index - " + component);
                }
                result = result._derive(index);
            }
            else {
                throw new Error("invalid path component - " + component);
            }
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0,bytes_lib_esm.arrayify)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) {
            throw new Error("invalid seed");
        }
        const I = (0,bytes_lib_esm.arrayify)((0,sha2/* computeHmac */.Gy)(types/* SupportedAlgorithm.sha512 */.p.sha512, MasterSecret, seedArray));
        return new HDNode(_constructorGuard, bytes32(I.slice(0, 32)), null, "0x00000000", bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = entropyToMnemonic(mnemonicToEntropy(mnemonic, wordlist), wordlist);
        return HDNode._fromSeed(mnemonicToSeed(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return HDNode._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = lib_esm.Base58.decode(extendedKey);
        if (bytes.length !== 82 || base58check(bytes.slice(0, 78)) !== extendedKey) {
            logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        }
        const depth = bytes[4];
        const parentFingerprint = (0,bytes_lib_esm.hexlify)(bytes.slice(5, 9));
        const index = parseInt((0,bytes_lib_esm.hexlify)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0,bytes_lib_esm.hexlify)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch ((0,bytes_lib_esm.hexlify)(bytes.slice(0, 4))) {
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new HDNode(_constructorGuard, null, (0,bytes_lib_esm.hexlify)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) {
                    break;
                }
                return new HDNode(_constructorGuard, (0,bytes_lib_esm.hexlify)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function mnemonicToSeed(mnemonic, password) {
    if (!password) {
        password = "";
    }
    const salt = (0,utf8/* toUtf8Bytes */.Y0)("mnemonic" + password, utf8/* UnicodeNormalizationForm.NFKD */.Uj.NFKD);
    return (0,pbkdf2/* pbkdf2 */.n)((0,utf8/* toUtf8Bytes */.Y0)(mnemonic, utf8/* UnicodeNormalizationForm.NFKD */.Uj.NFKD), salt, 2048, 64, "sha512");
}
function mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = getWordlist(wordlist);
    logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if ((words.length % 3) !== 0) {
        throw new Error("invalid mnemonic");
    }
    const entropy = (0,bytes_lib_esm.arrayify)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for (let i = 0; i < words.length; i++) {
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) {
            throw new Error("invalid mnemonic");
        }
        for (let bit = 0; bit < 11; bit++) {
            if (index & (1 << (10 - bit))) {
                entropy[offset >> 3] |= (1 << (7 - (offset % 8)));
            }
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = getUpperMask(checksumBits);
    const checksum = (0,bytes_lib_esm.arrayify)((0,sha2/* sha256 */.JQ)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) {
        throw new Error("invalid checksum");
    }
    return (0,bytes_lib_esm.hexlify)(entropy.slice(0, entropyBits / 8));
}
function entropyToMnemonic(entropy, wordlist) {
    wordlist = getWordlist(wordlist);
    entropy = (0,bytes_lib_esm.arrayify)(entropy);
    if ((entropy.length % 4) !== 0 || entropy.length < 16 || entropy.length > 32) {
        throw new Error("invalid entropy");
    }
    const indices = [0];
    let remainingBits = 11;
    for (let i = 0; i < entropy.length; i++) {
        // Consume the whole byte (with still more to go)
        if (remainingBits > 8) {
            indices[indices.length - 1] <<= 8;
            indices[indices.length - 1] |= entropy[i];
            remainingBits -= 8;
            // This byte will complete an 11-bit index
        }
        else {
            indices[indices.length - 1] <<= remainingBits;
            indices[indices.length - 1] |= entropy[i] >> (8 - remainingBits);
            // Start the next word
            indices.push(entropy[i] & getLowerMask(8 - remainingBits));
            remainingBits += 3;
        }
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0,bytes_lib_esm.arrayify)((0,sha2/* sha256 */.JQ)(entropy))[0] & getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= (checksum >> (8 - checksumBits));
    return wordlist.join(indices.map((index) => wordlist.getWord(index)));
}
function isValidMnemonic(mnemonic, wordlist) {
    try {
        mnemonicToEntropy(mnemonic, wordlist);
        return true;
    }
    catch (error) { }
    return false;
}
function getAccountPath(index) {
    if (typeof (index) !== "number" || index < 0 || index >= HardenedBit || index % 1) {
        logger.throwArgumentError("invalid account index", "index", index);
    }
    return `m/44'/60'/${index}'/0/0`;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/json-wallets/lib.esm/_version.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: () => (/* binding */ version)
/* harmony export */ });
const version = "json-wallets/5.7.0";
//# sourceMappingURL=_version.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/json-wallets/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  decryptCrowdsale: () => (/* reexport */ decrypt),
  decryptJsonWallet: () => (/* binding */ decryptJsonWallet),
  decryptJsonWalletSync: () => (/* binding */ decryptJsonWalletSync),
  decryptKeystore: () => (/* reexport */ keystore/* decrypt */.pe),
  decryptKeystoreSync: () => (/* reexport */ keystore/* decryptSync */.hb),
  encryptKeystore: () => (/* reexport */ keystore/* encrypt */.HI),
  getJsonWalletAddress: () => (/* reexport */ inspect/* getJsonWalletAddress */.Rb),
  isCrowdsaleWallet: () => (/* reexport */ inspect/* isCrowdsaleWallet */.LW),
  isKeystoreWallet: () => (/* reexport */ inspect/* isKeystoreWallet */.aO)
});

// EXTERNAL MODULE: ../../node_modules/aes-js/index.js
var aes_js = __webpack_require__("../../node_modules/aes-js/index.js");
var aes_js_default = /*#__PURE__*/__webpack_require__.n(aes_js);
// EXTERNAL MODULE: ../../node_modules/@ethersproject/address/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var bytes_lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/keccak256/lib.esm/index.js
var keccak256_lib_esm = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/pbkdf2/lib.esm/pbkdf2.js
var pbkdf2 = __webpack_require__("../../node_modules/@ethersproject/pbkdf2/lib.esm/pbkdf2.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/strings/lib.esm/utf8.js + 1 modules
var utf8 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var properties_lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/json-wallets/lib.esm/_version.js
var _version = __webpack_require__("../../node_modules/@ethersproject/json-wallets/lib.esm/_version.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/json-wallets/lib.esm/utils.js
var utils = __webpack_require__("../../node_modules/@ethersproject/json-wallets/lib.esm/utils.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/json-wallets/lib.esm/crowdsale.js










const logger = new logger_lib_esm.Logger(_version/* version */.i);

class CrowdsaleAccount extends properties_lib_esm.Description {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
// See: https://github.com/ethereum/pyethsaletool
function decrypt(json, password) {
    const data = JSON.parse(json);
    password = (0,utils/* getPassword */.Ij)(password);
    // Ethereum Address
    const ethaddr = (0,lib_esm.getAddress)((0,utils/* searchPath */.gx)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0,utils/* looseArrayify */.p3)((0,utils/* searchPath */.gx)(data, "encseed"));
    if (!encseed || (encseed.length % 16) !== 0) {
        logger.throwArgumentError("invalid encseed", "json", json);
    }
    const key = (0,bytes_lib_esm.arrayify)((0,pbkdf2/* pbkdf2 */.n)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (aes_js_default()).ModeOfOperation.cbc(key, iv);
    const seed = aes_js_default().padding.pkcs7.strip((0,bytes_lib_esm.arrayify)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for (let i = 0; i < seed.length; i++) {
        seedHex += String.fromCharCode(seed[i]);
    }
    const seedHexBytes = (0,utf8/* toUtf8Bytes */.Y0)(seedHex);
    const privateKey = (0,keccak256_lib_esm.keccak256)(seedHexBytes);
    return new CrowdsaleAccount({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}
//# sourceMappingURL=crowdsale.js.map
// EXTERNAL MODULE: ../../node_modules/@ethersproject/json-wallets/lib.esm/inspect.js
var inspect = __webpack_require__("../../node_modules/@ethersproject/json-wallets/lib.esm/inspect.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/json-wallets/lib.esm/keystore.js
var keystore = __webpack_require__("../../node_modules/@ethersproject/json-wallets/lib.esm/keystore.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/json-wallets/lib.esm/index.js




function decryptJsonWallet(json, password, progressCallback) {
    if ((0,inspect/* isCrowdsaleWallet */.LW)(json)) {
        if (progressCallback) {
            progressCallback(0);
        }
        const account = decrypt(json, password);
        if (progressCallback) {
            progressCallback(1);
        }
        return Promise.resolve(account);
    }
    if ((0,inspect/* isKeystoreWallet */.aO)(json)) {
        return (0,keystore/* decrypt */.pe)(json, password, progressCallback);
    }
    return Promise.reject(new Error("invalid JSON wallet"));
}
function decryptJsonWalletSync(json, password) {
    if ((0,inspect/* isCrowdsaleWallet */.LW)(json)) {
        return decrypt(json, password);
    }
    if ((0,inspect/* isKeystoreWallet */.aO)(json)) {
        return (0,keystore/* decryptSync */.hb)(json, password);
    }
    throw new Error("invalid JSON wallet");
}

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/json-wallets/lib.esm/inspect.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LW: () => (/* binding */ isCrowdsaleWallet),
/* harmony export */   Rb: () => (/* binding */ getJsonWalletAddress),
/* harmony export */   aO: () => (/* binding */ isKeystoreWallet)
/* harmony export */ });
/* harmony import */ var _ethersproject_address__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");


function isCrowdsaleWallet(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    }
    catch (error) {
        return false;
    }
    return (data.encseed && data.ethaddr);
}
function isKeystoreWallet(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    }
    catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) {
        return false;
    }
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
//export function isJsonWallet(json: string): boolean {
//    return (isSecretStorageWallet(json) || isCrowdsaleWallet(json));
//}
function getJsonWalletAddress(json) {
    if (isCrowdsaleWallet(json)) {
        try {
            return (0,_ethersproject_address__WEBPACK_IMPORTED_MODULE_0__.getAddress)(JSON.parse(json).ethaddr);
        }
        catch (error) {
            return null;
        }
    }
    if (isKeystoreWallet(json)) {
        try {
            return (0,_ethersproject_address__WEBPACK_IMPORTED_MODULE_0__.getAddress)(JSON.parse(json).address);
        }
        catch (error) {
            return null;
        }
    }
    return null;
}
//# sourceMappingURL=inspect.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/json-wallets/lib.esm/keystore.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HI: () => (/* binding */ encrypt),
/* harmony export */   hb: () => (/* binding */ decryptSync),
/* harmony export */   pe: () => (/* binding */ decrypt)
/* harmony export */ });
/* unused harmony export KeystoreAccount */
/* harmony import */ var aes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/aes-js/index.js");
/* harmony import */ var aes_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(aes_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var scrypt_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/scrypt-js/scrypt.js");
/* harmony import */ var scrypt_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(scrypt_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ethersproject_address__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _ethersproject_hdnode__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("../../node_modules/@ethersproject/hdnode/lib.esm/index.js");
/* harmony import */ var _ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
/* harmony import */ var _ethersproject_pbkdf2__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("../../node_modules/@ethersproject/pbkdf2/lib.esm/pbkdf2.js");
/* harmony import */ var _ethersproject_random__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("../../node_modules/@ethersproject/random/lib.esm/random.js");
/* harmony import */ var _ethersproject_properties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
/* harmony import */ var _ethersproject_transactions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("../../node_modules/@ethersproject/transactions/lib.esm/index.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("../../node_modules/@ethersproject/json-wallets/lib.esm/utils.js");
/* harmony import */ var _ethersproject_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
/* harmony import */ var _version__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../../node_modules/@ethersproject/json-wallets/lib.esm/_version.js");

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};













const logger = new _ethersproject_logger__WEBPACK_IMPORTED_MODULE_2__.Logger(_version__WEBPACK_IMPORTED_MODULE_3__/* .version */ .i);
// Exported Types
function hasMnemonic(value) {
    return (value != null && value.mnemonic && value.mnemonic.phrase);
}
class KeystoreAccount extends _ethersproject_properties__WEBPACK_IMPORTED_MODULE_4__.Description {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function _decrypt(data, key, ciphertext) {
    const cipher = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .looseArrayify */ .p3)((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/cipherparams/iv"));
        const counter = new (aes_js__WEBPACK_IMPORTED_MODULE_0___default().Counter)(iv);
        const aesCtr = new (aes_js__WEBPACK_IMPORTED_MODULE_0___default().ModeOfOperation.ctr)(key, counter);
        return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function _getAccount(data, key) {
    const ciphertext = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .looseArrayify */ .p3)((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/ciphertext"));
    const computedMAC = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)((0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_7__.keccak256)((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.concat)([key.slice(16, 32), ciphertext]))).substring(2);
    if (computedMAC !== (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/mac").toLowerCase()) {
        throw new Error("invalid password");
    }
    const privateKey = _decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) {
        logger.throwError("unsupported cipher", _ethersproject_logger__WEBPACK_IMPORTED_MODULE_2__.Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "decrypt"
        });
    }
    const mnemonicKey = key.slice(32, 64);
    const address = (0,_ethersproject_transactions__WEBPACK_IMPORTED_MODULE_8__.computeAddress)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") {
            check = "0x" + check;
        }
        if ((0,_ethersproject_address__WEBPACK_IMPORTED_MODULE_9__.getAddress)(check) !== address) {
            throw new Error("address mismatch");
        }
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .looseArrayify */ .p3)((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .looseArrayify */ .p3)((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (aes_js__WEBPACK_IMPORTED_MODULE_0___default().Counter)(mnemonicIv);
        const mnemonicAesCtr = new (aes_js__WEBPACK_IMPORTED_MODULE_0___default().ModeOfOperation.ctr)(mnemonicKey, mnemonicCounter);
        const path = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "x-ethers/path") || _ethersproject_hdnode__WEBPACK_IMPORTED_MODULE_10__.defaultPath;
        const locale = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "x-ethers/locale") || "en";
        const entropy = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0,_ethersproject_hdnode__WEBPACK_IMPORTED_MODULE_10__.entropyToMnemonic)(entropy, locale);
            const node = _ethersproject_hdnode__WEBPACK_IMPORTED_MODULE_10__.HDNode.fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) {
                throw new Error("mnemonic mismatch");
            }
            account.mnemonic = node.mnemonic;
        }
        catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== _ethersproject_logger__WEBPACK_IMPORTED_MODULE_2__.Logger.errors.INVALID_ARGUMENT || error.argument !== "wordlist") {
                throw error;
            }
        }
    }
    return new KeystoreAccount(account);
}
function pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)((0,_ethersproject_pbkdf2__WEBPACK_IMPORTED_MODULE_11__/* .pbkdf2 */ .n)(passwordBytes, salt, count, dkLen, prfFunc));
}
function pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve(pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function _computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getPassword */ .Ij)(password);
    const kdf = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/kdf");
    if (kdf && typeof (kdf) === "string") {
        const throwError = function (name, value) {
            return logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .looseArrayify */ .p3)((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/kdfparams/n"));
            const r = parseInt((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/kdfparams/r"));
            const p = parseInt((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) {
                throwError("kdf", kdf);
            }
            // Make sure N is a power of 2
            if ((N & (N - 1)) !== 0) {
                throwError("N", N);
            }
            const dkLen = parseInt((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) {
                throwError("dklen", dkLen);
            }
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        }
        else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .looseArrayify */ .p3)((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") {
                prfFunc = "sha256";
            }
            else if (prf === "hmac-sha512") {
                prfFunc = "sha512";
            }
            else {
                throwError("prf", prf);
            }
            const count = parseInt((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .searchPath */ .gx)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) {
                throwError("dklen", dkLen);
            }
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function decryptSync(json, password) {
    const data = JSON.parse(json);
    const key = _computeKdfKey(data, password, pbkdf2Sync, (scrypt_js__WEBPACK_IMPORTED_MODULE_1___default().syncScrypt));
    return _getAccount(data, key);
}
function decrypt(json, password, progressCallback) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = JSON.parse(json);
        const key = yield _computeKdfKey(data, password, pbkdf2, (scrypt_js__WEBPACK_IMPORTED_MODULE_1___default().scrypt), progressCallback);
        return _getAccount(data, key);
    });
}
function encrypt(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0,_ethersproject_address__WEBPACK_IMPORTED_MODULE_9__.getAddress)(account.address) !== (0,_ethersproject_transactions__WEBPACK_IMPORTED_MODULE_8__.computeAddress)(account.privateKey)) {
            throw new Error("address/privateKey mismatch");
        }
        // Check the mnemonic (if any) matches the private key
        if (hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = _ethersproject_hdnode__WEBPACK_IMPORTED_MODULE_10__.HDNode.fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || _ethersproject_hdnode__WEBPACK_IMPORTED_MODULE_10__.defaultPath);
            if (node.privateKey != account.privateKey) {
                throw new Error("mnemonic mismatch");
            }
        }
    }
    catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof (options) === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) {
        options = {};
    }
    const privateKey = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(account.privateKey);
    const passwordBytes = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getPassword */ .Ij)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if (hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)((0,_ethersproject_hdnode__WEBPACK_IMPORTED_MODULE_10__.mnemonicToEntropy)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || _ethersproject_hdnode__WEBPACK_IMPORTED_MODULE_10__.defaultPath;
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) {
        client = "ethers.js";
    }
    // Check/generate the salt
    let salt = null;
    if (options.salt) {
        salt = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(options.salt);
    }
    else {
        salt = (0,_ethersproject_random__WEBPACK_IMPORTED_MODULE_12__/* .randomBytes */ .O)(32);
        ;
    }
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(options.iv);
        if (iv.length !== 16) {
            throw new Error("invalid iv");
        }
    }
    else {
        iv = (0,_ethersproject_random__WEBPACK_IMPORTED_MODULE_12__/* .randomBytes */ .O)(16);
    }
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(options.uuid);
        if (uuidRandom.length !== 16) {
            throw new Error("invalid uuid");
        }
    }
    else {
        uuidRandom = (0,_ethersproject_random__WEBPACK_IMPORTED_MODULE_12__/* .randomBytes */ .O)(16);
    }
    // Override the scrypt password-based key derivation function parameters
    let N = (1 << 17), r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) {
            N = options.scrypt.N;
        }
        if (options.scrypt.r) {
            r = options.scrypt.r;
        }
        if (options.scrypt.p) {
            p = options.scrypt.p;
        }
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return scrypt_js__WEBPACK_IMPORTED_MODULE_1___default().scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key) => {
        key = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (aes_js__WEBPACK_IMPORTED_MODULE_0___default().Counter)(iv);
        const aesCtr = new (aes_js__WEBPACK_IMPORTED_MODULE_0___default().ModeOfOperation.ctr)(derivedKey, counter);
        const ciphertext = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0,_ethersproject_keccak256__WEBPACK_IMPORTED_MODULE_7__.keccak256)((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.concat)([macPrefix, ciphertext]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuidV4 */ .EH)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(iv).substring(2),
                },
                ciphertext: (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0,_ethersproject_random__WEBPACK_IMPORTED_MODULE_12__/* .randomBytes */ .O)(16);
            const mnemonicCounter = new (aes_js__WEBPACK_IMPORTED_MODULE_0___default().Counter)(mnemonicIv);
            const mnemonicAesCtr = new (aes_js__WEBPACK_IMPORTED_MODULE_0___default().ModeOfOperation.ctr)(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.arrayify)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = (now.getUTCFullYear() + "-" +
                (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .zpad */ .VP)(now.getUTCMonth() + 1, 2) + "-" +
                (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .zpad */ .VP)(now.getUTCDate(), 2) + "T" +
                (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .zpad */ .VP)(now.getUTCHours(), 2) + "-" +
                (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .zpad */ .VP)(now.getUTCMinutes(), 2) + "-" +
                (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .zpad */ .VP)(now.getUTCSeconds(), 2) + ".0Z");
            data["x-ethers"] = {
                client: client,
                gethFilename: ("UTC--" + timestamp + "--" + data.address),
                mnemonicCounter: (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_6__.hexlify)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}
//# sourceMappingURL=keystore.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/json-wallets/lib.esm/utils.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EH: () => (/* binding */ uuidV4),
/* harmony export */   Ij: () => (/* binding */ getPassword),
/* harmony export */   VP: () => (/* binding */ zpad),
/* harmony export */   gx: () => (/* binding */ searchPath),
/* harmony export */   p3: () => (/* binding */ looseArrayify)
/* harmony export */ });
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _ethersproject_strings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");



function looseArrayify(hexString) {
    if (typeof (hexString) === 'string' && hexString.substring(0, 2) !== '0x') {
        hexString = '0x' + hexString;
    }
    return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.arrayify)(hexString);
}
function zpad(value, length) {
    value = String(value);
    while (value.length < length) {
        value = '0' + value;
    }
    return value;
}
function getPassword(password) {
    if (typeof (password) === 'string') {
        return (0,_ethersproject_strings__WEBPACK_IMPORTED_MODULE_1__/* .toUtf8Bytes */ .Y0)(password, _ethersproject_strings__WEBPACK_IMPORTED_MODULE_1__/* .UnicodeNormalizationForm.NFKC */ .Uj.NFKC);
    }
    return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.arrayify)(password);
}
function searchPath(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split('/');
    for (let i = 0; i < comps.length; i++) {
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for (const key in currentChild) {
            if (key.toLowerCase() === comps[i]) {
                matchingChild = currentChild[key];
                break;
            }
        }
        // Didn't find one. :'(
        if (matchingChild === null) {
            return null;
        }
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
// See: https://www.ietf.org/rfc/rfc4122.txt (Section 4.4)
function uuidV4(randomBytes) {
    const bytes = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.arrayify)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const value = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34),
    ].join("-");
}
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/keccak256/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   keccak256: () => (/* binding */ keccak256)
/* harmony export */ });
/* harmony import */ var js_sha3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/js-sha3/src/sha3.js");
/* harmony import */ var js_sha3__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_sha3__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");



function keccak256(data) {
    return '0x' + js_sha3__WEBPACK_IMPORTED_MODULE_0___default().keccak_256((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_1__.arrayify)(data));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/logger/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ErrorCode: () => (/* binding */ ErrorCode),
  LogLevel: () => (/* binding */ LogLevel),
  Logger: () => (/* binding */ Logger)
});

;// CONCATENATED MODULE: ../../node_modules/@ethersproject/logger/lib.esm/_version.js
const version = "logger/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js

let _permanentCensorErrors = false;
let _censorErrors = false;
const LogLevels = { debug: 1, "default": 2, info: 2, warning: 3, error: 4, off: 5 };
let _logLevel = LogLevels["default"];

let _globalLogger = null;
function _checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        ["NFD", "NFC", "NFKD", "NFKC"].forEach((form) => {
            try {
                if ("test".normalize(form) !== "test") {
                    throw new Error("bad normalize");
                }
                ;
            }
            catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) {
            throw new Error("missing " + missing.join(", "));
        }
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) {
            throw new Error("broken implementation");
        }
    }
    catch (error) {
        return error.message;
    }
    return null;
}
const _normalizeError = _checkNormalize();
var LogLevel;
(function (LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})(LogLevel || (LogLevel = {}));
var ErrorCode;
(function (ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})(ErrorCode || (ErrorCode = {}));
;
const HEX = "0123456789abcdef";
class Logger {
    constructor(version) {
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if (LogLevels[level] == null) {
            this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        }
        if (_logLevel > LogLevels[level]) {
            return;
        }
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log(Logger.levels.DEBUG, args);
    }
    info(...args) {
        this._log(Logger.levels.INFO, args);
    }
    warn(...args) {
        this._log(Logger.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if (_censorErrors) {
            return this.makeError("censored error", code, {});
        }
        if (!code) {
            code = Logger.errors.UNKNOWN_ERROR;
        }
        if (!params) {
            params = {};
        }
        const messageDetails = [];
        Object.keys(params).forEach((key) => {
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for (let i = 0; i < value.length; i++) {
                        hex += HEX[value[i] >> 4];
                        hex += HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                }
                else {
                    messageDetails.push(key + "=" + JSON.stringify(value));
                }
            }
            catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch (code) {
            case ErrorCode.NUMERIC_FAULT: {
                url = "NUMERIC_FAULT";
                const fault = message;
                switch (fault) {
                    case "overflow":
                    case "underflow":
                    case "division-by-zero":
                        url += "-" + fault;
                        break;
                    case "negative-power":
                    case "negative-width":
                        url += "-unsupported";
                        break;
                    case "unbound-bitwise-result":
                        url += "-unbound-result";
                        break;
                }
                break;
            }
            case ErrorCode.CALL_EXCEPTION:
            case ErrorCode.INSUFFICIENT_FUNDS:
            case ErrorCode.MISSING_NEW:
            case ErrorCode.NONCE_EXPIRED:
            case ErrorCode.REPLACEMENT_UNDERPRICED:
            case ErrorCode.TRANSACTION_REPLACED:
            case ErrorCode.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) {
            message += " [ See: https:/\/links.ethers.org/v5-errors-" + url + " ]";
        }
        if (messageDetails.length) {
            message += " (" + messageDetails.join(", ") + ")";
        }
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function (key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, Logger.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) {
            return;
        }
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) {
            return;
        }
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) {
            message = "platform missing String.prototype.normalize";
        }
        if (_normalizeError) {
            this.throwError("platform missing String.prototype.normalize", Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "String.prototype.normalize", form: _normalizeError
            });
        }
    }
    checkSafeUint53(value, message) {
        if (typeof (value) !== "number") {
            return;
        }
        if (message == null) {
            message = "value not safe";
        }
        if (value < 0 || value >= 0x1fffffffffffff) {
            this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                operation: "checkSafeInteger",
                fault: "out-of-safe-range",
                value: value
            });
        }
        if (value % 1) {
            this.throwError(message, Logger.errors.NUMERIC_FAULT, {
                operation: "checkSafeInteger",
                fault: "non-integer",
                value: value
            });
        }
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) {
            message = ": " + message;
        }
        else {
            message = "";
        }
        if (count < expectedCount) {
            this.throwError("missing argument" + message, Logger.errors.MISSING_ARGUMENT, {
                count: count,
                expectedCount: expectedCount
            });
        }
        if (count > expectedCount) {
            this.throwError("too many arguments" + message, Logger.errors.UNEXPECTED_ARGUMENT, {
                count: count,
                expectedCount: expectedCount
            });
        }
    }
    checkNew(target, kind) {
        if (target === Object || target == null) {
            this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
        }
    }
    checkAbstract(target, kind) {
        if (target === kind) {
            this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", Logger.errors.UNSUPPORTED_OPERATION, { name: target.name, operation: "new" });
        }
        else if (target === Object || target == null) {
            this.throwError("missing new", Logger.errors.MISSING_NEW, { name: kind.name });
        }
    }
    static globalLogger() {
        if (!_globalLogger) {
            _globalLogger = new Logger(version);
        }
        return _globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) {
            this.globalLogger().throwError("cannot permanently disable censorship", Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        if (_permanentCensorErrors) {
            if (!censorship) {
                return;
            }
            this.globalLogger().throwError("error censorship permanent", Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        _censorErrors = !!censorship;
        _permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            Logger.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        _logLevel = level;
    }
    static from(version) {
        return new Logger(version);
    }
}
Logger.errors = ErrorCode;
Logger.levels = LogLevel;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/pbkdf2/lib.esm/pbkdf2.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   n: () => (/* binding */ pbkdf2)
/* harmony export */ });
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _ethersproject_sha2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/sha2.js");



function pbkdf2(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.arrayify)(password);
    salt = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.arrayify)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for (let i = 1; i <= l; i++) {
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = (i >> 24) & 0xff;
        block1[salt.length + 1] = (i >> 16) & 0xff;
        block1[salt.length + 2] = (i >> 8) & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.arrayify)((0,_ethersproject_sha2__WEBPACK_IMPORTED_MODULE_1__/* .computeHmac */ .Gy)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for (let j = 1; j < iterations; j++) {
            //U = createHmac(password).update(U).digest();
            U = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.arrayify)((0,_ethersproject_sha2__WEBPACK_IMPORTED_MODULE_1__/* .computeHmac */ .Gy)(hashAlgorithm, password, U));
            for (let k = 0; k < hLen; k++)
                T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = (i === l ? r : hLen);
        //T.copy(DK, destPos, 0, len)
        DK.set((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.arrayify)(T).slice(0, len), destPos);
    }
    return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_0__.hexlify)(DK);
}
//# sourceMappingURL=pbkdf2.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/properties/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Description: () => (/* binding */ Description),
  checkProperties: () => (/* binding */ checkProperties),
  deepCopy: () => (/* binding */ deepCopy),
  defineReadOnly: () => (/* binding */ defineReadOnly),
  getStatic: () => (/* binding */ getStatic),
  resolveProperties: () => (/* binding */ resolveProperties),
  shallowCopy: () => (/* binding */ shallowCopy)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/properties/lib.esm/_version.js
const version = "properties/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


const logger = new lib_esm.Logger(version);
function defineReadOnly(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false,
    });
}
// Crawl up the constructor chain to find a static method
function getStatic(ctor, key) {
    for (let i = 0; i < 32; i++) {
        if (ctor[key]) {
            return ctor[key];
        }
        if (!ctor.prototype || typeof (ctor.prototype) !== "object") {
            break;
        }
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function resolveProperties(object) {
    return __awaiter(this, void 0, void 0, function* () {
        const promises = Object.keys(object).map((key) => {
            const value = object[key];
            return Promise.resolve(value).then((v) => ({ key: key, value: v }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result) => {
            accum[(result.key)] = result.value;
            return accum;
        }, {});
    });
}
function checkProperties(object, properties) {
    if (!object || typeof (object) !== "object") {
        logger.throwArgumentError("invalid object", "object", object);
    }
    Object.keys(object).forEach((key) => {
        if (!properties[key]) {
            logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
        }
    });
}
function shallowCopy(object) {
    const result = {};
    for (const key in object) {
        result[key] = object[key];
    }
    return result;
}
const opaque = { bigint: true, boolean: true, "function": true, number: true, string: true };
function _isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || opaque[typeof (object)]) {
        return true;
    }
    if (Array.isArray(object) || typeof (object) === "object") {
        if (!Object.isFrozen(object)) {
            return false;
        }
        const keys = Object.keys(object);
        for (let i = 0; i < keys.length; i++) {
            let value = null;
            try {
                value = object[keys[i]];
            }
            catch (error) {
                // If accessing a value triggers an error, it is a getter
                // designed to do so (e.g. Result) and is therefore "frozen"
                continue;
            }
            if (!_isFrozen(value)) {
                return false;
            }
        }
        return true;
    }
    return logger.throwArgumentError(`Cannot deepCopy ${typeof (object)}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function _deepCopy(object) {
    if (_isFrozen(object)) {
        return object;
    }
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) {
        return Object.freeze(object.map((item) => deepCopy(item)));
    }
    if (typeof (object) === "object") {
        const result = {};
        for (const key in object) {
            const value = object[key];
            if (value === undefined) {
                continue;
            }
            defineReadOnly(result, key, deepCopy(value));
        }
        return result;
    }
    return logger.throwArgumentError(`Cannot deepCopy ${typeof (object)}`, "object", object);
}
function deepCopy(object) {
    return _deepCopy(object);
}
class Description {
    constructor(info) {
        for (const key in info) {
            this[key] = deepCopy(info[key]);
        }
    }
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/providers/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AlchemyProvider: () => (/* reexport */ AlchemyProvider),
  AlchemyWebSocketProvider: () => (/* reexport */ AlchemyWebSocketProvider),
  AnkrProvider: () => (/* reexport */ AnkrProvider),
  BaseProvider: () => (/* reexport */ BaseProvider),
  CloudflareProvider: () => (/* reexport */ CloudflareProvider),
  EtherscanProvider: () => (/* reexport */ EtherscanProvider),
  FallbackProvider: () => (/* reexport */ FallbackProvider),
  Formatter: () => (/* reexport */ Formatter),
  InfuraProvider: () => (/* reexport */ InfuraProvider),
  InfuraWebSocketProvider: () => (/* reexport */ InfuraWebSocketProvider),
  IpcProvider: () => (/* reexport */ IpcProvider),
  JsonRpcBatchProvider: () => (/* reexport */ JsonRpcBatchProvider),
  JsonRpcProvider: () => (/* reexport */ JsonRpcProvider),
  JsonRpcSigner: () => (/* reexport */ JsonRpcSigner),
  NodesmithProvider: () => (/* reexport */ NodesmithProvider),
  PocketProvider: () => (/* reexport */ PocketProvider),
  Provider: () => (/* reexport */ lib_esm/* Provider */.zt),
  Resolver: () => (/* reexport */ Resolver),
  StaticJsonRpcProvider: () => (/* reexport */ StaticJsonRpcProvider),
  UrlJsonRpcProvider: () => (/* reexport */ UrlJsonRpcProvider),
  Web3Provider: () => (/* reexport */ Web3Provider),
  WebSocketProvider: () => (/* reexport */ WebSocketProvider),
  getDefaultProvider: () => (/* binding */ getDefaultProvider),
  getNetwork: () => (/* reexport */ getNetwork),
  isCommunityResourcable: () => (/* reexport */ isCommunityResourcable),
  isCommunityResource: () => (/* reexport */ isCommunityResource),
  showThrottleMessage: () => (/* reexport */ showThrottleMessage)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/abstract-provider/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/abstract-provider/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/networks/lib.esm/_version.js
const version = "networks/5.7.1";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/networks/lib.esm/index.js



const logger = new logger_lib_esm.Logger(version);
;
function isRenetworkable(value) {
    return (value && typeof (value.renetwork) === "function");
}
function ethDefaultProvider(network) {
    const func = function (providers, options) {
        if (options == null) {
            options = {};
        }
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") {
            try {
                providerList.push(new providers.InfuraProvider(network, options.infura));
            }
            catch (error) { }
        }
        if (providers.EtherscanProvider && options.etherscan !== "-") {
            try {
                providerList.push(new providers.EtherscanProvider(network, options.etherscan));
            }
            catch (error) { }
        }
        if (providers.AlchemyProvider && options.alchemy !== "-") {
            try {
                providerList.push(new providers.AlchemyProvider(network, options.alchemy));
            }
            catch (error) { }
        }
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = ["goerli", "ropsten", "rinkeby", "sepolia"];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) {
                    providerList.push(provider);
                }
            }
            catch (error) { }
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") {
            try {
                providerList.push(new providers.CloudflareProvider(network));
            }
            catch (error) { }
        }
        if (providers.AnkrProvider && options.ankr !== "-") {
            try {
                const skip = ["ropsten"];
                const provider = new providers.AnkrProvider(network, options.ankr);
                if (provider.network && skip.indexOf(provider.network.name) === -1) {
                    providerList.push(provider);
                }
            }
            catch (error) { }
        }
        if (providerList.length === 0) {
            return null;
        }
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) {
                quorum = options.quorum;
            }
            else if (network === "homestead") {
                quorum = 2;
            }
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function (network) {
        return ethDefaultProvider(network);
    };
    return func;
}
function etcDefaultProvider(url, network) {
    const func = function (providers, options) {
        if (providers.JsonRpcProvider) {
            return new providers.JsonRpcProvider(url, network);
        }
        return null;
    };
    func.renetwork = function (network) {
        return etcDefaultProvider(url, network);
    };
    return func;
}
const homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: ethDefaultProvider("homestead")
};
const ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: ethDefaultProvider("ropsten")
};
const classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const networks = {
    unspecified: { chainId: 0, name: "unspecified" },
    homestead: homestead,
    mainnet: homestead,
    morden: { chainId: 2, name: "morden" },
    ropsten: ropsten,
    testnet: ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: ethDefaultProvider("goerli")
    },
    kintsugi: { chainId: 1337702, name: "kintsugi" },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: etcDefaultProvider("https:/\/www.ethercluster.com/etc", "classic")
    },
    classicMorden: { chainId: 62, name: "classicMorden" },
    classicMordor: classicMordor,
    classicTestnet: classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: etcDefaultProvider("https:/\/www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: { chainId: 100, name: "xdai" },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: ethDefaultProvider("matic")
    },
    maticmum: { chainId: 80001, name: "maticmum" },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: ethDefaultProvider("optimism")
    },
    "optimism-kovan": { chainId: 69, name: "optimism-kovan" },
    "optimism-goerli": { chainId: 420, name: "optimism-goerli" },
    arbitrum: { chainId: 42161, name: "arbitrum" },
    "arbitrum-rinkeby": { chainId: 421611, name: "arbitrum-rinkeby" },
    "arbitrum-goerli": { chainId: 421613, name: "arbitrum-goerli" },
    bnb: { chainId: 56, name: "bnb" },
    bnbt: { chainId: 97, name: "bnbt" },
};
/**
 *  getNetwork
 *
 *  Converts a named common networks or chain ID (network ID) to a Network
 *  and verifies a network is a valid Network..
 */
function getNetwork(network) {
    // No network (null)
    if (network == null) {
        return null;
    }
    if (typeof (network) === "number") {
        for (const name in networks) {
            const standard = networks[name];
            if (standard.chainId === network) {
                return {
                    name: standard.name,
                    chainId: standard.chainId,
                    ensAddress: (standard.ensAddress || null),
                    _defaultProvider: (standard._defaultProvider || null)
                };
            }
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof (network) === "string") {
        const standard = networks[network];
        if (standard == null) {
            return null;
        }
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: (standard._defaultProvider || null)
        };
    }
    const standard = networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof (network.chainId) !== "number") {
            logger.throwArgumentError("invalid network chainId", "network", network);
        }
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) {
        logger.throwArgumentError("network chainId mismatch", "network", network);
    }
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if (isRenetworkable(standard._defaultProvider)) {
            defaultProvider = standard._defaultProvider.renetwork(network);
        }
        else {
            defaultProvider = standard._defaultProvider;
        }
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: (network.ensAddress || standard.ensAddress || null),
        _defaultProvider: defaultProvider
    };
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/@ethersproject/base64/lib.esm/base64.js
var base64 = __webpack_require__("../../node_modules/@ethersproject/base64/lib.esm/base64.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/basex/lib.esm/index.js
var basex_lib_esm = __webpack_require__("../../node_modules/@ethersproject/basex/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var bytes_lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/constants/lib.esm/hashes.js
var hashes = __webpack_require__("../../node_modules/@ethersproject/constants/lib.esm/hashes.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hash/lib.esm/namehash.js + 3 modules
var namehash = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/namehash.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var properties_lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/sha2/lib.esm/sha2.js + 1 modules
var sha2 = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/sha2.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/strings/lib.esm/utf8.js + 1 modules
var utf8 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/web/lib.esm/index.js + 2 modules
var web_lib_esm = __webpack_require__("../../node_modules/@ethersproject/web/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/bech32/index.js
var bech32 = __webpack_require__("../../node_modules/bech32/index.js");
var bech32_default = /*#__PURE__*/__webpack_require__.n(bech32);
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/_version.js
const _version_version = "providers/5.7.2";
//# sourceMappingURL=_version.js.map
// EXTERNAL MODULE: ../../node_modules/@ethersproject/address/lib.esm/index.js + 1 modules
var address_lib_esm = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/constants/lib.esm/addresses.js
var addresses = __webpack_require__("../../node_modules/@ethersproject/constants/lib.esm/addresses.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/transactions/lib.esm/index.js + 1 modules
var transactions_lib_esm = __webpack_require__("../../node_modules/@ethersproject/transactions/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/formatter.js









const formatter_logger = new logger_lib_esm.Logger(_version_version);
class Formatter {
    constructor() {
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = ({});
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v) => { return this.data(v, true); };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: Formatter.allowNull(this.accessList.bind(this), null),
            blockHash: Formatter.allowNull(hash, null),
            blockNumber: Formatter.allowNull(number, null),
            transactionIndex: Formatter.allowNull(number, null),
            confirmations: Formatter.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: Formatter.allowNull(bigNumber),
            maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
            maxFeePerGas: Formatter.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: Formatter.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: Formatter.allowNull(this.uint256),
            s: Formatter.allowNull(this.uint256),
            v: Formatter.allowNull(number),
            creates: Formatter.allowNull(address, null),
            raw: Formatter.allowNull(data),
        };
        formats.transactionRequest = {
            from: Formatter.allowNull(address),
            nonce: Formatter.allowNull(number),
            gasLimit: Formatter.allowNull(bigNumber),
            gasPrice: Formatter.allowNull(bigNumber),
            maxPriorityFeePerGas: Formatter.allowNull(bigNumber),
            maxFeePerGas: Formatter.allowNull(bigNumber),
            to: Formatter.allowNull(address),
            value: Formatter.allowNull(bigNumber),
            data: Formatter.allowNull(strictData),
            type: Formatter.allowNull(number),
            accessList: Formatter.allowNull(this.accessList.bind(this), null),
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: Formatter.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash,
        };
        formats.receipt = {
            to: Formatter.allowNull(this.address, null),
            from: Formatter.allowNull(this.address, null),
            contractAddress: Formatter.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: Formatter.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: Formatter.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: Formatter.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: Formatter.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: Formatter.allowNull(bigNumber),
            status: Formatter.allowNull(number),
            type: type
        };
        formats.block = {
            hash: Formatter.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: Formatter.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: Formatter.allowNull(address),
            extraData: data,
            transactions: Formatter.allowNull(Formatter.arrayOf(hash)),
            baseFeePerGas: Formatter.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0,properties_lib_esm.shallowCopy)(formats.block);
        formats.blockWithTransactions.transactions = Formatter.allowNull(Formatter.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: Formatter.allowNull(blockTag, undefined),
            toBlock: Formatter.allowNull(blockTag, undefined),
            blockHash: Formatter.allowNull(hash, undefined),
            address: Formatter.allowNull(address, undefined),
            topics: Formatter.allowNull(this.topics.bind(this), undefined),
        };
        formats.filterLog = {
            blockNumber: Formatter.allowNull(number),
            blockHash: Formatter.allowNull(hash),
            transactionIndex: number,
            removed: Formatter.allowNull(this.boolean.bind(this)),
            address: address,
            data: Formatter.allowFalsish(data, "0x"),
            topics: Formatter.arrayOf(hash),
            transactionHash: hash,
            logIndex: number,
        };
        return formats;
    }
    accessList(accessList) {
        return (0,transactions_lib_esm.accessListify)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") {
            return 0;
        }
        return bignumber/* BigNumber.from */.O$.from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) {
            return 0;
        }
        return bignumber/* BigNumber.from */.O$.from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return bignumber/* BigNumber.from */.O$.from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof (value) === "boolean") {
            return value;
        }
        if (typeof (value) === "string") {
            value = value.toLowerCase();
            if (value === "true") {
                return true;
            }
            if (value === "false") {
                return false;
            }
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof (value) === "string") {
            if (!strict && value.substring(0, 2) !== "0x") {
                value = "0x" + value;
            }
            if ((0,bytes_lib_esm.isHexString)(value)) {
                return value.toLowerCase();
            }
        }
        return formatter_logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if ((result.length % 2) !== 0) {
            throw new Error("invalid data; odd-length - " + value);
        }
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0,address_lib_esm.getAddress)(value);
    }
    callAddress(value) {
        if (!(0,bytes_lib_esm.isHexString)(value, 32)) {
            return null;
        }
        const address = (0,address_lib_esm.getAddress)((0,bytes_lib_esm.hexDataSlice)(value, 12));
        return (address === addresses/* AddressZero */.d) ? null : address;
    }
    contractAddress(value) {
        return (0,address_lib_esm.getContractAddress)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) {
            return "latest";
        }
        if (blockTag === "earliest") {
            return "0x0";
        }
        switch (blockTag) {
            case "earliest": return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof (blockTag) === "number" || (0,bytes_lib_esm.isHexString)(blockTag)) {
            return (0,bytes_lib_esm.hexValue)(blockTag);
        }
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0,bytes_lib_esm.hexDataLength)(result) !== 32) {
            return formatter_logger.throwArgumentError("invalid hash", "value", value);
        }
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) {
            return null;
        }
        const v = bignumber/* BigNumber.from */.O$.from(value);
        try {
            return v.toNumber();
        }
        catch (error) { }
        return null;
    }
    uint256(value) {
        if (!(0,bytes_lib_esm.isHexString)(value)) {
            throw new Error("invalid uint256");
        }
        return (0,bytes_lib_esm.hexZeroPad)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) {
            value.miner = value.author;
        }
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = (value._difficulty != null) ? value._difficulty : value.difficulty;
        const result = Formatter.check(format, value);
        result._difficulty = ((difficulty == null) ? null : bignumber/* BigNumber.from */.O$.from(difficulty));
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return Formatter.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) {
            transaction.gasLimit = transaction.gas;
        }
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && bignumber/* BigNumber.from */.O$.from(transaction.to).isZero()) {
            transaction.to = "0x0000000000000000000000000000000000000000";
        }
        // Rename input to data
        if (transaction.input != null && transaction.data == null) {
            transaction.data = transaction.input;
        }
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) {
            transaction.creates = this.contractAddress(transaction);
        }
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) {
            transaction.accessList = [];
        }
        const result = Formatter.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0,bytes_lib_esm.isHexString)(chainId)) {
                chainId = bignumber/* BigNumber.from */.O$.from(chainId).toNumber();
            }
            result.chainId = chainId;
        }
        else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) {
                chainId = transaction.chainId;
            }
            if ((0,bytes_lib_esm.isHexString)(chainId)) {
                chainId = bignumber/* BigNumber.from */.O$.from(chainId).toNumber();
            }
            if (typeof (chainId) !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) {
                    chainId = 0;
                }
                chainId = parseInt(chainId);
            }
            if (typeof (chainId) !== "number") {
                chainId = 0;
            }
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") {
            result.blockHash = null;
        }
        return result;
    }
    transaction(value) {
        return (0,transactions_lib_esm.parse)(value);
    }
    receiptLog(value) {
        return Formatter.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = Formatter.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = bignumber/* BigNumber.from */.O$.from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && (result.status !== value)) {
                        formatter_logger.throwArgumentError("alt-root-status/status mismatch", "value", { root: result.root, status: result.status });
                    }
                    result.status = value;
                    delete result.root;
                }
                else {
                    formatter_logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
                }
            }
            else if (result.root.length !== 66) {
                // Must be a valid bytes32
                formatter_logger.throwArgumentError("invalid root hash", "value.root", result.root);
            }
        }
        if (result.status != null) {
            result.byzantium = true;
        }
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) {
            return value.map((v) => this.topics(v));
        }
        else if (value != null) {
            return this.hash(value, true);
        }
        return null;
    }
    filter(value) {
        return Formatter.check(this.formats.filter, value);
    }
    filterLog(value) {
        return Formatter.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for (const key in format) {
            try {
                const value = format[key](object[key]);
                if (value !== undefined) {
                    result[key] = value;
                }
            }
            catch (error) {
                error.checkKey = key;
                error.checkValue = object[key];
                throw error;
            }
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return (function (value) {
            if (value == null) {
                return nullValue;
            }
            return format(value);
        });
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return (function (value) {
            if (!value) {
                return replaceValue;
            }
            return format(value);
        });
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return (function (array) {
            if (!Array.isArray(array)) {
                throw new Error("not an array");
            }
            const result = [];
            array.forEach(function (value) {
                result.push(format(value));
            });
            return result;
        });
    }
}
function isCommunityResourcable(value) {
    return (value && typeof (value.isCommunityResource) === "function");
}
function isCommunityResource(value) {
    return (isCommunityResourcable(value) && value.isCommunityResource());
}
// Show the throttle message only once
let throttleMessage = false;
function showThrottleMessage() {
    if (throttleMessage) {
        return;
    }
    throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https:/\/docs.ethers.io/api-keys/");
    console.log("==========================");
}
//# sourceMappingURL=formatter.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/base-provider.js

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};















const base_provider_logger = new logger_lib_esm.Logger(_version_version);

const MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function checkTopic(topic) {
    if (topic == null) {
        return "null";
    }
    if ((0,bytes_lib_esm.hexDataLength)(topic) !== 32) {
        base_provider_logger.throwArgumentError("invalid topic", "topic", topic);
    }
    return topic.toLowerCase();
}
function serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while (topics.length > 0 && topics[topics.length - 1] == null) {
        topics.pop();
    }
    return topics.map((topic) => {
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic) => {
                unique[checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        }
        else {
            return checkTopic(topic);
        }
    }).join("&");
}
function deserializeTopics(data) {
    if (data === "") {
        return [];
    }
    return data.split(/&/g).map((topic) => {
        if (topic === "") {
            return [];
        }
        const comps = topic.split("|").map((topic) => {
            return ((topic === "null") ? null : topic);
        });
        return ((comps.length === 1) ? comps[0] : comps);
    });
}
function getEventTag(eventName) {
    if (typeof (eventName) === "string") {
        eventName = eventName.toLowerCase();
        if ((0,bytes_lib_esm.hexDataLength)(eventName) === 32) {
            return "tx:" + eventName;
        }
        if (eventName.indexOf(":") === -1) {
            return eventName;
        }
    }
    else if (Array.isArray(eventName)) {
        return "filter:*:" + serializeTopics(eventName);
    }
    else if (lib_esm/* ForkEvent.isForkEvent */.Sg.isForkEvent(eventName)) {
        base_provider_logger.warn("not implemented");
        throw new Error("not implemented");
    }
    else if (eventName && typeof (eventName) === "object") {
        return "filter:" + (eventName.address || "*") + ":" + serializeTopics(eventName.topics || []);
    }
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function getTime() {
    return (new Date()).getTime();
}
function stall(duration) {
    return new Promise((resolve) => {
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */
const PollableEvents = ["block", "network", "pending", "poll"];
class Event {
    constructor(tag, listener, once) {
        (0,properties_lib_esm.defineReadOnly)(this, "tag", tag);
        (0,properties_lib_esm.defineReadOnly)(this, "listener", listener);
        (0,properties_lib_esm.defineReadOnly)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch (this.type) {
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") {
            return null;
        }
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") {
            return null;
        }
        const address = comps[1];
        const topics = deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) {
            filter.topics = topics;
        }
        if (address && address !== "*") {
            filter.address = address;
        }
        return filter;
    }
    pollable() {
        return (this.tag.indexOf(":") >= 0 || PollableEvents.indexOf(this.tag) >= 0);
    }
}
;
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const coinInfos = {
    "0": { symbol: "btc", p2pkh: 0x00, p2sh: 0x05, prefix: "bc" },
    "2": { symbol: "ltc", p2pkh: 0x30, p2sh: 0x32, prefix: "ltc" },
    "3": { symbol: "doge", p2pkh: 0x1e, p2sh: 0x16 },
    "60": { symbol: "eth", ilk: "eth" },
    "61": { symbol: "etc", ilk: "eth" },
    "700": { symbol: "xdai", ilk: "eth" },
};
function bytes32ify(value) {
    return (0,bytes_lib_esm.hexZeroPad)(bignumber/* BigNumber.from */.O$.from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function base58Encode(data) {
    return basex_lib_esm.Base58.encode((0,bytes_lib_esm.concat)([data, (0,bytes_lib_esm.hexDataSlice)((0,sha2/* sha256 */.JQ)((0,sha2/* sha256 */.JQ)(data)), 0, 4)]));
}
const matcherIpfs = new RegExp("^(ipfs):/\/(.*)$", "i");
const matchers = [
    new RegExp("^(https):/\/(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i"),
];
function _parseString(result, start) {
    try {
        return (0,utf8/* toUtf8String */.ZN)(_parseBytes(result, start));
    }
    catch (error) { }
    return null;
}
function _parseBytes(result, start) {
    if (result === "0x") {
        return null;
    }
    const offset = bignumber/* BigNumber.from */.O$.from((0,bytes_lib_esm.hexDataSlice)(result, start, start + 32)).toNumber();
    const length = bignumber/* BigNumber.from */.O$.from((0,bytes_lib_esm.hexDataSlice)(result, offset, offset + 32)).toNumber();
    return (0,bytes_lib_esm.hexDataSlice)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) {
        link = link.substring(12);
    }
    else if (link.match(/^ipfs:\/\//i)) {
        link = link.substring(7);
    }
    else {
        base_provider_logger.throwArgumentError("unsupported IPFS format", "link", link);
    }
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function numPad(value) {
    const result = (0,bytes_lib_esm.arrayify)(value);
    if (result.length > 32) {
        throw new Error("internal; should not happen");
    }
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function bytesPad(value) {
    if ((value.length % 32) === 0) {
        return value;
    }
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for (let i = 0; i < datas.length; i++) {
        result.push(null);
        byteCount += 32;
    }
    for (let i = 0; i < datas.length; i++) {
        const data = (0,bytes_lib_esm.arrayify)(datas[i]);
        // Update the bytes offset
        result[i] = numPad(byteCount);
        // The length and padded value of data
        result.push(numPad(data.length));
        result.push(bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0,bytes_lib_esm.hexConcat)(result);
}
class Resolver {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress) {
        (0,properties_lib_esm.defineReadOnly)(this, "provider", provider);
        (0,properties_lib_esm.defineReadOnly)(this, "name", name);
        (0,properties_lib_esm.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0,properties_lib_esm.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) {
            // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
            this._supportsEip2544 = this.provider.call({
                to: this.address,
                data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
            }).then((result) => {
                return bignumber/* BigNumber.from */.O$.from(result).eq(1);
            }).catch((error) => {
                if (error.code === logger_lib_esm.Logger.errors.CALL_EXCEPTION) {
                    return false;
                }
                // Rethrow the error: link is down, etc. Let future attempts retry.
                this._supportsEip2544 = null;
                throw error;
            });
        }
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0,bytes_lib_esm.hexConcat)([selector, (0,namehash/* namehash */.VM)(this.name), (parameters || "0x")])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0,bytes_lib_esm.hexConcat)(["0x9061b923", encodeBytes([(0,namehash/* dnsEncode */.Kn)(this.name), tx.data])]);
            }
            try {
                let result = yield this.provider.call(tx);
                if (((0,bytes_lib_esm.arrayify)(result).length % 32) === 4) {
                    base_provider_logger.throwError("resolver threw error", logger_lib_esm.Logger.errors.CALL_EXCEPTION, {
                        transaction: tx, data: result
                    });
                }
                if (parseBytes) {
                    result = _parseBytes(result, 0);
                }
                return result;
            }
            catch (error) {
                if (error.code === logger_lib_esm.Logger.errors.CALL_EXCEPTION) {
                    return null;
                }
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._fetch(selector, parameters);
            if (result != null) {
                return _parseBytes(result, 0);
            }
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = coinInfos[String(coinType)];
        if (coinInfo == null) {
            base_provider_logger.throwError(`unsupported coin type: ${coinType}`, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`
            });
        }
        if (coinInfo.ilk === "eth") {
            return this.provider.formatter.address(hexBytes);
        }
        const bytes = (0,bytes_lib_esm.arrayify)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) {
                    return base58Encode((0,bytes_lib_esm.concat)([[coinInfo.p2pkh], ("0x" + p2pkh[2])]));
                }
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) {
                    return base58Encode((0,bytes_lib_esm.concat)([[coinInfo.p2sh], ("0x" + p2sh[2])]));
                }
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) {
                    version = -1;
                }
            }
            else {
                version = -1;
            }
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = bech32_default().toWords(bytes.slice(2));
                words.unshift(version);
                return bech32_default().encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return __awaiter(this, void 0, void 0, function* () {
            if (coinType == null) {
                coinType = 60;
            }
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) {
                try {
                    // keccak256("addr(bytes32)")
                    const result = yield this._fetch("0x3b3b57de");
                    // No address
                    if (result === "0x" || result === hashes/* HashZero */.R) {
                        return null;
                    }
                    return this.provider.formatter.callAddress(result);
                }
                catch (error) {
                    if (error.code === logger_lib_esm.Logger.errors.CALL_EXCEPTION) {
                        return null;
                    }
                    throw error;
                }
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") {
                return null;
            }
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) {
                base_provider_logger.throwError(`invalid or unsupported coin data`, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: `getAddress(${coinType})`,
                    coinType: coinType,
                    data: hexBytes
                });
            }
            return address;
        });
    }
    getAvatar() {
        return __awaiter(this, void 0, void 0, function* () {
            const linkage = [{ type: "name", content: this.name }];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) {
                    return null;
                }
                for (let i = 0; i < matchers.length; i++) {
                    const match = avatar.match(matchers[i]);
                    if (match == null) {
                        continue;
                    }
                    const scheme = match[1].toLowerCase();
                    switch (scheme) {
                        case "https":
                            linkage.push({ type: "url", content: avatar });
                            return { linkage, url: avatar };
                        case "data":
                            linkage.push({ type: "data", content: avatar });
                            return { linkage, url: avatar };
                        case "ipfs":
                            linkage.push({ type: "ipfs", content: avatar });
                            return { linkage, url: getIpfsLink(avatar) };
                        case "erc721":
                        case "erc1155": {
                            // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                            const selector = (scheme === "erc721") ? "0xc87b56dd" : "0x0e89341c";
                            linkage.push({ type: scheme, content: avatar });
                            // The owner of this name
                            const owner = (this._resolvedAddress || (yield this.getAddress()));
                            const comps = (match[2] || "").split("/");
                            if (comps.length !== 2) {
                                return null;
                            }
                            const addr = yield this.provider.formatter.address(comps[0]);
                            const tokenId = (0,bytes_lib_esm.hexZeroPad)(bignumber/* BigNumber.from */.O$.from(comps[1]).toHexString(), 32);
                            // Check that this account owns the token
                            if (scheme === "erc721") {
                                // ownerOf(uint256 tokenId)
                                const tokenOwner = this.provider.formatter.callAddress(yield this.provider.call({
                                    to: addr, data: (0,bytes_lib_esm.hexConcat)(["0x6352211e", tokenId])
                                }));
                                if (owner !== tokenOwner) {
                                    return null;
                                }
                                linkage.push({ type: "owner", content: tokenOwner });
                            }
                            else if (scheme === "erc1155") {
                                // balanceOf(address owner, uint256 tokenId)
                                const balance = bignumber/* BigNumber.from */.O$.from(yield this.provider.call({
                                    to: addr, data: (0,bytes_lib_esm.hexConcat)(["0x00fdd58e", (0,bytes_lib_esm.hexZeroPad)(owner, 32), tokenId])
                                }));
                                if (balance.isZero()) {
                                    return null;
                                }
                                linkage.push({ type: "balance", content: balance.toString() });
                            }
                            // Call the token contract for the metadata URL
                            const tx = {
                                to: this.provider.formatter.address(comps[0]),
                                data: (0,bytes_lib_esm.hexConcat)([selector, tokenId])
                            };
                            let metadataUrl = _parseString(yield this.provider.call(tx), 0);
                            if (metadataUrl == null) {
                                return null;
                            }
                            linkage.push({ type: "metadata-url-base", content: metadataUrl });
                            // ERC-1155 allows a generic {id} in the URL
                            if (scheme === "erc1155") {
                                metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                linkage.push({ type: "metadata-url-expanded", content: metadataUrl });
                            }
                            // Transform IPFS metadata links
                            if (metadataUrl.match(/^ipfs:/i)) {
                                metadataUrl = getIpfsLink(metadataUrl);
                            }
                            linkage.push({ type: "metadata-url", content: metadataUrl });
                            // Get the token metadata
                            const metadata = yield (0,web_lib_esm.fetchJson)(metadataUrl);
                            if (!metadata) {
                                return null;
                            }
                            linkage.push({ type: "metadata", content: JSON.stringify(metadata) });
                            // Pull the image URL out
                            let imageUrl = metadata.image;
                            if (typeof (imageUrl) !== "string") {
                                return null;
                            }
                            if (imageUrl.match(/^(https:\/\/|data:)/i)) {
                                // Allow
                            }
                            else {
                                // Transform IPFS link to gateway
                                const ipfs = imageUrl.match(matcherIpfs);
                                if (ipfs == null) {
                                    return null;
                                }
                                linkage.push({ type: "url-ipfs", content: imageUrl });
                                imageUrl = getIpfsLink(imageUrl);
                            }
                            linkage.push({ type: "url", content: imageUrl });
                            return { linkage, url: imageUrl };
                        }
                    }
                }
            }
            catch (error) { }
            return null;
        });
    }
    getContentHash() {
        return __awaiter(this, void 0, void 0, function* () {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") {
                return null;
            }
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) {
                    return "ipfs:/\/" + basex_lib_esm.Base58.encode("0x" + ipfs[1]);
                }
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) {
                    return "ipns:/\/" + basex_lib_esm.Base58.encode("0x" + ipns[1]);
                }
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === (32 * 2)) {
                    return "bzz:/\/" + swarm[1];
                }
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === (34 * 2)) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = { "=": "", "+": "-", "/": "_" };
                    const hash = (0,base64/* encode */.c)("0x" + skynet[1]).replace(/[=+\/]/g, (a) => (urlSafe[a]));
                    return "sia:/\/" + hash;
                }
            }
            return base_provider_logger.throwError(`invalid or unsupported content hash data`, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return __awaiter(this, void 0, void 0, function* () {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0,utf8/* toUtf8Bytes */.Y0)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0,bytes_lib_esm.concat)([bytes32ify(64), bytes32ify(keyBytes.length), keyBytes]);
            // Pad to word-size (32 bytes)
            if ((keyBytes.length % 32) !== 0) {
                keyBytes = (0,bytes_lib_esm.concat)([keyBytes, (0,bytes_lib_esm.hexZeroPad)("0x", 32 - (key.length % 32))]);
            }
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0,bytes_lib_esm.hexlify)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") {
                return null;
            }
            return (0,utf8/* toUtf8String */.ZN)(hexBytes);
        });
    }
}
let defaultFormatter = null;
let nextPollId = 1;
class BaseProvider extends lib_esm/* Provider */.zt {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */
    constructor(network) {
        super();
        // Events being listened to
        this._events = [];
        this._emitted = { block: -2 };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0,properties_lib_esm.defineReadOnly)(this, "anyNetwork", (network === "any"));
        if (this.anyNetwork) {
            network = this.detectNetwork();
        }
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error) => { });
            // Trigger initial network setting (async)
            this._ready().catch((error) => { });
        }
        else {
            const knownNetwork = (0,properties_lib_esm.getStatic)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0,properties_lib_esm.defineReadOnly)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            }
            else {
                base_provider_logger.throwArgumentError("invalid network", "network", network);
            }
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) {
                    try {
                        network = yield this._networkPromise;
                    }
                    catch (error) { }
                }
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) {
                    network = yield this.detectNetwork();
                }
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) {
                    base_provider_logger.throwError("no network detected", logger_lib_esm.Logger.errors.UNKNOWN_ERROR, {});
                }
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) {
                        this._network = network;
                    }
                    else {
                        (0,properties_lib_esm.defineReadOnly)(this, "_network", network);
                    }
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0,web_lib_esm.poll)(() => {
            return this._ready().then((network) => {
                return network;
            }, (error) => {
                // If the network isn't running yet, we will wait
                if (error.code === logger_lib_esm.Logger.errors.NETWORK_ERROR && error.event === "noNetwork") {
                    return undefined;
                }
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if (defaultFormatter == null) {
            defaultFormatter = new Formatter();
        }
        return defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return getNetwork((network == null) ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.disableCcipRead || urls.length === 0) {
                return null;
            }
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for (let i = 0; i < urls.length; i++) {
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = (url.indexOf("{data}") >= 0) ? null : JSON.stringify({ data, sender });
                const result = yield (0,web_lib_esm.fetchJson)({ url: href, errorPassThrough: true }, json, (value, response) => {
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) {
                    return result.data;
                }
                const errorMessage = (result.message || "unknown error");
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) {
                    return base_provider_logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, logger_lib_esm.Logger.errors.SERVER_ERROR, { url, errorMessage });
                }
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return base_provider_logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m) => JSON.stringify(m)).join(", ")}`, logger_lib_esm.Logger.errors.SERVER_ERROR, {
                urls, errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) {
                // While there are pending internal block requests...
                while (this._internalBlockNumber) {
                    // ..."remember" which fetch we started with
                    const internalBlockNumber = this._internalBlockNumber;
                    try {
                        // Check the result is not too stale
                        const result = yield internalBlockNumber;
                        if ((getTime() - result.respTime) <= maxAge) {
                            return result.blockNumber;
                        }
                        // Too old; fetch a new value
                        break;
                    }
                    catch (error) {
                        // The fetch rejected; if we are the first to get the
                        // rejection, drop through so we replace it with a new
                        // fetch; all others blocked will then get that fetch
                        // which won't match the one they "remembered" and loop
                        if (this._internalBlockNumber === internalBlockNumber) {
                            break;
                        }
                    }
                }
            }
            const reqTime = getTime();
            const checkInternalBlockNumber = (0,properties_lib_esm.resolveProperties)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network) => (null), (error) => (error))
            }).then(({ blockNumber, networkError }) => {
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) {
                        this._internalBlockNumber = null;
                    }
                    throw networkError;
                }
                const respTime = getTime();
                blockNumber = bignumber/* BigNumber.from */.O$.from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) {
                    blockNumber = this._maxInternalBlockNumber;
                }
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return { blockNumber, reqTime, respTime };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error) => {
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) {
                    this._internalBlockNumber = null;
                }
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return __awaiter(this, void 0, void 0, function* () {
            const pollId = nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            }
            catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) {
                this._emitted.block = blockNumber - 1;
            }
            if (Math.abs((this._emitted.block) - blockNumber) > 1000) {
                base_provider_logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", base_provider_logger.makeError("network block skew detected", logger_lib_esm.Logger.errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            }
            else {
                // Notify all listener for each block that has passed
                for (let i = this._emitted.block + 1; i <= blockNumber; i++) {
                    this.emit("block", i);
                }
            }
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key) => {
                    // The block event does not expire
                    if (key === "block") {
                        return;
                    }
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") {
                        return;
                    }
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) {
                        delete this._emitted[key];
                    }
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) {
                this._lastBlockNumber = blockNumber - 1;
            }
            // Find all transaction hashes we are waiting on
            this._events.forEach((event) => {
                switch (event.type) {
                    case "tx": {
                        const hash = event.hash;
                        let runner = this.getTransactionReceipt(hash).then((receipt) => {
                            if (!receipt || receipt.blockNumber == null) {
                                return null;
                            }
                            this._emitted["t:" + hash] = receipt.blockNumber;
                            this.emit(hash, receipt);
                            return null;
                        }).catch((error) => { this.emit("error", error); });
                        runners.push(runner);
                        break;
                    }
                    case "filter": {
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) {
                                event._lastBlockNumber = blockNumber - 1;
                            }
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) {
                                filter.fromBlock = minFromBlock;
                            }
                            if (filter.fromBlock < 0) {
                                filter.fromBlock = 0;
                            }
                            const runner = this.getLogs(filter).then((logs) => {
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) {
                                    return;
                                }
                                logs.forEach((log) => {
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) {
                                        event._lastBlockNumber = log.blockNumber;
                                    }
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error) => {
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                    }
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(() => {
                this.emit("didPoll", pollId);
            }).catch((error) => { this.emit("error", error); });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) {
            this.poll();
        }
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            return base_provider_logger.throwError("provider does not support network detection", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return __awaiter(this, void 0, void 0, function* () {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield stall(0);
                    return this._network;
                }
                const error = base_provider_logger.makeError("underlying network changed", logger_lib_esm.Logger.errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber) => {
            this._setFastBlockNumber(blockNumber);
        }, (error) => { });
        return (this._fastBlockNumber != null) ? this._fastBlockNumber : -1;
    }
    get polling() {
        return (this._poller != null);
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(() => { this.poll(); }, this.pollingInterval);
            if (!this._bootstrapPoll) {
                this._bootstrapPoll = setTimeout(() => {
                    this.poll();
                    // We block additional polls until the polling interval
                    // is done, to prevent overwhelming the poll function
                    this._bootstrapPoll = setTimeout(() => {
                        // If polling was disabled, something may require a poke
                        // since starting the bootstrap poll and it was disabled
                        if (!this._poller) {
                            this.poll();
                        }
                        // Clear out the bootstrap so we can do another
                        this._bootstrapPoll = null;
                    }, this.pollingInterval);
                }, 0);
            }
        }
        else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof (value) !== "number" || value <= 0 || parseInt(String(value)) != value) {
            throw new Error("invalid polling interval");
        }
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(() => { this.poll(); }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = getTime();
        // Stale block number, request a newer value
        if ((now - this._fastQueryDate) > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber) => {
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
                    this._fastBlockNumber = blockNumber;
                }
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) {
            return;
        }
        // Update the time we updated the blocknumber
        this._fastQueryDate = getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._waitForTransaction(transactionHash, (confirmations == null) ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return __awaiter(this, void 0, void 0, function* () {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) {
                return receipt;
            }
            // Poll until the receipt is good...
            return new Promise((resolve, reject) => {
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function () {
                    if (done) {
                        return true;
                    }
                    done = true;
                    cancelFuncs.forEach((func) => { func(); });
                    return false;
                };
                const minedHandler = (receipt) => {
                    if (receipt.confirmations < confirmations) {
                        return;
                    }
                    if (alreadyDone()) {
                        return;
                    }
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(() => { this.removeListener(transactionHash, minedHandler); });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber) => __awaiter(this, void 0, void 0, function* () {
                        if (done) {
                            return;
                        }
                        // Wait 1 second; this is only used in the case of a fault, so
                        // we will trade off a little bit of latency for more consistent
                        // results and fewer JSON-RPC calls
                        yield stall(1000);
                        this.getTransactionCount(replaceable.from).then((nonce) => __awaiter(this, void 0, void 0, function* () {
                            if (done) {
                                return;
                            }
                            if (nonce <= replaceable.nonce) {
                                lastBlockNumber = blockNumber;
                            }
                            else {
                                // First check if the transaction was mined
                                {
                                    const mined = yield this.getTransaction(transactionHash);
                                    if (mined && mined.blockNumber != null) {
                                        return;
                                    }
                                }
                                // First time scanning. We start a little earlier for some
                                // wiggle room here to handle the eventually consistent nature
                                // of blockchain (e.g. the getTransactionCount was for a
                                // different block)
                                if (scannedBlock == null) {
                                    scannedBlock = lastBlockNumber - 3;
                                    if (scannedBlock < replaceable.startBlock) {
                                        scannedBlock = replaceable.startBlock;
                                    }
                                }
                                while (scannedBlock <= blockNumber) {
                                    if (done) {
                                        return;
                                    }
                                    const block = yield this.getBlockWithTransactions(scannedBlock);
                                    for (let ti = 0; ti < block.transactions.length; ti++) {
                                        const tx = block.transactions[ti];
                                        // Successfully mined!
                                        if (tx.hash === transactionHash) {
                                            return;
                                        }
                                        // Matches our transaction from and nonce; its a replacement
                                        if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                            if (done) {
                                                return;
                                            }
                                            // Get the receipt of the replacement
                                            const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                            // Already resolved or rejected (prolly a timeout)
                                            if (alreadyDone()) {
                                                return;
                                            }
                                            // The reason we were replaced
                                            let reason = "replaced";
                                            if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) {
                                                reason = "repriced";
                                            }
                                            else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) {
                                                reason = "cancelled";
                                            }
                                            // Explain why we were replaced
                                            reject(base_provider_logger.makeError("transaction was replaced", logger_lib_esm.Logger.errors.TRANSACTION_REPLACED, {
                                                cancelled: (reason === "replaced" || reason === "cancelled"),
                                                reason,
                                                replacement: this._wrapTransaction(tx),
                                                hash: transactionHash,
                                                receipt
                                            }));
                                            return;
                                        }
                                    }
                                    scannedBlock++;
                                }
                            }
                            if (done) {
                                return;
                            }
                            this.once("block", replaceHandler);
                        }), (error) => {
                            if (done) {
                                return;
                            }
                            this.once("block", replaceHandler);
                        });
                    });
                    if (done) {
                        return;
                    }
                    this.once("block", replaceHandler);
                    cancelFuncs.push(() => {
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof (timeout) === "number" && timeout > 0) {
                    const timer = setTimeout(() => {
                        if (alreadyDone()) {
                            return;
                        }
                        reject(base_provider_logger.makeError("timeout exceeded", logger_lib_esm.Logger.errors.TIMEOUT, { timeout: timeout }));
                    }, timeout);
                    if (timer.unref) {
                        timer.unref();
                    }
                    cancelFuncs.push(() => { clearTimeout(timer); });
                }
            });
        });
    }
    getBlockNumber() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return bignumber/* BigNumber.from */.O$.from(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result, error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield (0,properties_lib_esm.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return bignumber/* BigNumber.from */.O$.from(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                    method: "getBalance",
                    params, result, error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield (0,properties_lib_esm.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return bignumber/* BigNumber.from */.O$.from(result).toNumber();
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params, result, error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield (0,properties_lib_esm.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0,bytes_lib_esm.hexlify)(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                    method: "getCode",
                    params, result, error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield (0,properties_lib_esm.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p) => (0,bytes_lib_esm.hexValue)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0,bytes_lib_esm.hexlify)(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params, result, error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0,bytes_lib_esm.hexDataLength)(hash) !== 32) {
            throw new Error("invalid response - sendTransaction");
        }
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) {
            base_provider_logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", logger_lib_esm.Logger.errors.UNKNOWN_ERROR, { expectedHash: tx.hash, returnedHash: hash });
        }
        result.wait = (confirms, timeout) => __awaiter(this, void 0, void 0, function* () {
            if (confirms == null) {
                confirms = 1;
            }
            if (timeout == null) {
                timeout = 0;
            }
            // Get the details to detect replacement
            let replacement = undefined;
            if (confirms !== 0 && startBlock != null) {
                replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock
                };
            }
            const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
            if (receipt == null && confirms === 0) {
                return null;
            }
            // No longer pending, allow the polling loop to garbage collect this
            this._emitted["t:" + tx.hash] = receipt.blockNumber;
            if (receipt.status === 0) {
                base_provider_logger.throwError("transaction failed", logger_lib_esm.Logger.errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
            }
            return receipt;
        });
        return result;
    }
    sendTransaction(signedTransaction) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then(t => (0,bytes_lib_esm.hexlify)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) {
                tx.confirmations = 0;
            }
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", { signedTransaction: hexTx });
                return this._wrapTransaction(tx, hash, blockNumber);
            }
            catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            const values = yield transaction;
            const tx = {};
            ["from", "to"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => (v ? this._getAddress(v) : null));
            });
            ["gasLimit", "gasPrice", "maxFeePerGas", "maxPriorityFeePerGas", "value"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => (v ? bignumber/* BigNumber.from */.O$.from(v) : null));
            });
            ["type"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => ((v != null) ? v : null));
            });
            if (values.accessList) {
                tx.accessList = this.formatter.accessList(values.accessList);
            }
            ["data"].forEach((key) => {
                if (values[key] == null) {
                    return;
                }
                tx[key] = Promise.resolve(values[key]).then((v) => (v ? (0,bytes_lib_esm.hexlify)(v) : null));
            });
            return this.formatter.transactionRequest(yield (0,properties_lib_esm.resolveProperties)(tx));
        });
    }
    _getFilter(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            filter = yield filter;
            const result = {};
            if (filter.address != null) {
                result.address = this._getAddress(filter.address);
            }
            ["blockHash", "topics"].forEach((key) => {
                if (filter[key] == null) {
                    return;
                }
                result[key] = filter[key];
            });
            ["fromBlock", "toBlock"].forEach((key) => {
                if (filter[key] == null) {
                    return;
                }
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter(yield (0,properties_lib_esm.resolveProperties)(result));
        });
    }
    _call(transaction, blockTag, attempt) {
        return __awaiter(this, void 0, void 0, function* () {
            if (attempt >= MAX_CCIP_REDIRECTS) {
                base_provider_logger.throwError("CCIP read exceeded maximum redirections", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                    redirects: attempt, transaction
                });
            }
            const txSender = transaction.to;
            const result = yield this.perform("call", { transaction, blockTag });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && ((0,bytes_lib_esm.hexDataLength)(result) % 32 === 4)) {
                try {
                    const data = (0,bytes_lib_esm.hexDataSlice)(result, 4);
                    // Check the sender of the OffchainLookup matches the transaction
                    const sender = (0,bytes_lib_esm.hexDataSlice)(data, 0, 32);
                    if (!bignumber/* BigNumber.from */.O$.from(sender).eq(txSender)) {
                        base_provider_logger.throwError("CCIP Read sender did not match", logger_lib_esm.Logger.errors.CALL_EXCEPTION, {
                            name: "OffchainLookup",
                            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                            transaction, data: result
                        });
                    }
                    // Read the URLs from the response
                    const urls = [];
                    const urlsOffset = bignumber/* BigNumber.from */.O$.from((0,bytes_lib_esm.hexDataSlice)(data, 32, 64)).toNumber();
                    const urlsLength = bignumber/* BigNumber.from */.O$.from((0,bytes_lib_esm.hexDataSlice)(data, urlsOffset, urlsOffset + 32)).toNumber();
                    const urlsData = (0,bytes_lib_esm.hexDataSlice)(data, urlsOffset + 32);
                    for (let u = 0; u < urlsLength; u++) {
                        const url = _parseString(urlsData, u * 32);
                        if (url == null) {
                            base_provider_logger.throwError("CCIP Read contained corrupt URL string", logger_lib_esm.Logger.errors.CALL_EXCEPTION, {
                                name: "OffchainLookup",
                                signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                                transaction, data: result
                            });
                        }
                        urls.push(url);
                    }
                    // Get the CCIP calldata to forward
                    const calldata = _parseBytes(data, 64);
                    // Get the callbackSelector (bytes4)
                    if (!bignumber/* BigNumber.from */.O$.from((0,bytes_lib_esm.hexDataSlice)(data, 100, 128)).isZero()) {
                        base_provider_logger.throwError("CCIP Read callback selector included junk", logger_lib_esm.Logger.errors.CALL_EXCEPTION, {
                            name: "OffchainLookup",
                            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                            transaction, data: result
                        });
                    }
                    const callbackSelector = (0,bytes_lib_esm.hexDataSlice)(data, 96, 100);
                    // Get the extra data to send back to the contract as context
                    const extraData = _parseBytes(data, 128);
                    const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                    if (ccipResult == null) {
                        base_provider_logger.throwError("CCIP Read disabled or provided no URLs", logger_lib_esm.Logger.errors.CALL_EXCEPTION, {
                            name: "OffchainLookup",
                            signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                            transaction, data: result
                        });
                    }
                    const tx = {
                        to: txSender,
                        data: (0,bytes_lib_esm.hexConcat)([callbackSelector, encodeBytes([ccipResult, extraData])])
                    };
                    return this._call(tx, blockTag, attempt + 1);
                }
                catch (error) {
                    if (error.code === logger_lib_esm.Logger.errors.SERVER_ERROR) {
                        throw error;
                    }
                }
            }
            try {
                return (0,bytes_lib_esm.hexlify)(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                    method: "call",
                    params: { transaction, blockTag }, result, error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const resolved = yield (0,properties_lib_esm.resolveProperties)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield (0,properties_lib_esm.resolveProperties)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return bignumber/* BigNumber.from */.O$.from(result);
            }
            catch (error) {
                return base_provider_logger.throwError("bad result from backend", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params, result, error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return __awaiter(this, void 0, void 0, function* () {
            addressOrName = yield addressOrName;
            if (typeof (addressOrName) !== "string") {
                base_provider_logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            }
            const address = yield this.resolveName(addressOrName);
            if (address == null) {
                base_provider_logger.throwError("ENS name not configured", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: `resolveName(${JSON.stringify(addressOrName)})`
                });
            }
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0,bytes_lib_esm.isHexString)(blockHashOrBlockTag, 32)) {
                params.blockHash = blockHashOrBlockTag;
            }
            else {
                try {
                    params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                    if ((0,bytes_lib_esm.isHexString)(params.blockTag)) {
                        blockNumber = parseInt(params.blockTag.substring(2), 16);
                    }
                }
                catch (error) {
                    base_provider_logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
                }
            }
            return (0,web_lib_esm.poll)(() => __awaiter(this, void 0, void 0, function* () {
                const block = yield this.perform("getBlock", params);
                // Block was not found
                if (block == null) {
                    // For blockhashes, if we didn't say it existed, that blockhash may
                    // not exist. If we did see it though, perhaps from a log, we know
                    // it exists, and this node is just not caught up yet.
                    if (params.blockHash != null) {
                        if (this._emitted["b:" + params.blockHash] == null) {
                            return null;
                        }
                    }
                    // For block tags, if we are asking for a future block, we return null
                    if (params.blockTag != null) {
                        if (blockNumber > this._emitted.block) {
                            return null;
                        }
                    }
                    // Retry on the next block
                    return undefined;
                }
                // Add transactions
                if (includeTransactions) {
                    let blockNumber = null;
                    for (let i = 0; i < block.transactions.length; i++) {
                        const tx = block.transactions[i];
                        if (tx.blockNumber == null) {
                            tx.confirmations = 0;
                        }
                        else if (tx.confirmations == null) {
                            if (blockNumber == null) {
                                blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                            }
                            // Add the confirmations using the fast block number (pessimistic)
                            let confirmations = (blockNumber - tx.blockNumber) + 1;
                            if (confirmations <= 0) {
                                confirmations = 1;
                            }
                            tx.confirmations = confirmations;
                        }
                    }
                    const blockWithTxs = this.formatter.blockWithTransactions(block);
                    blockWithTxs.transactions = blockWithTxs.transactions.map((tx) => this._wrapTransaction(tx));
                    return blockWithTxs;
                }
                return this.formatter.block(block);
            }), { oncePoll: this });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return (this._getBlock(blockHashOrBlockTag, false));
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return (this._getBlock(blockHashOrBlockTag, true));
    }
    getTransaction(transactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = { transactionHash: this.formatter.hash(transactionHash, true) };
            return (0,web_lib_esm.poll)(() => __awaiter(this, void 0, void 0, function* () {
                const result = yield this.perform("getTransaction", params);
                if (result == null) {
                    if (this._emitted["t:" + transactionHash] == null) {
                        return null;
                    }
                    return undefined;
                }
                const tx = this.formatter.transactionResponse(result);
                if (tx.blockNumber == null) {
                    tx.confirmations = 0;
                }
                else if (tx.confirmations == null) {
                    const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                    // Add the confirmations using the fast block number (pessimistic)
                    let confirmations = (blockNumber - tx.blockNumber) + 1;
                    if (confirmations <= 0) {
                        confirmations = 1;
                    }
                    tx.confirmations = confirmations;
                }
                return this._wrapTransaction(tx);
            }), { oncePoll: this });
        });
    }
    getTransactionReceipt(transactionHash) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = { transactionHash: this.formatter.hash(transactionHash, true) };
            return (0,web_lib_esm.poll)(() => __awaiter(this, void 0, void 0, function* () {
                const result = yield this.perform("getTransactionReceipt", params);
                if (result == null) {
                    if (this._emitted["t:" + transactionHash] == null) {
                        return null;
                    }
                    return undefined;
                }
                // "geth-etc" returns receipts before they are ready
                if (result.blockHash == null) {
                    return undefined;
                }
                const receipt = this.formatter.receipt(result);
                if (receipt.blockNumber == null) {
                    receipt.confirmations = 0;
                }
                else if (receipt.confirmations == null) {
                    const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                    // Add the confirmations using the fast block number (pessimistic)
                    let confirmations = (blockNumber - receipt.blockNumber) + 1;
                    if (confirmations <= 0) {
                        confirmations = 1;
                    }
                    receipt.confirmations = confirmations;
                }
                return receipt;
            }), { oncePoll: this });
        });
    }
    getLogs(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            const params = yield (0,properties_lib_esm.resolveProperties)({ filter: this._getFilter(filter) });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log) => {
                if (log.removed == null) {
                    log.removed = false;
                }
            });
            return Formatter.arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return __awaiter(this, void 0, void 0, function* () {
            blockTag = yield blockTag;
            if (typeof (blockTag) === "number" && blockTag < 0) {
                if (blockTag % 1) {
                    base_provider_logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                }
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) {
                    blockNumber = 0;
                }
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return __awaiter(this, void 0, void 0, function* () {
            let currentName = name;
            while (true) {
                if (currentName === "" || currentName === ".") {
                    return null;
                }
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") {
                    return null;
                }
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new Resolver(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) {
                        return null;
                    }
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return __awaiter(this, void 0, void 0, function* () {
            if (operation == null) {
                operation = "ENS";
            }
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) {
                base_provider_logger.throwError("network does not support ENS", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, { operation, network: network.name });
            }
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: ("0x0178b8bf" + (0,namehash/* namehash */.VM)(name).substring(2))
                });
                return this.formatter.callAddress(addrData);
            }
            catch (error) {
                // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            }
            catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0,bytes_lib_esm.isHexString)(name)) {
                    throw error;
                }
            }
            if (typeof (name) !== "string") {
                base_provider_logger.throwArgumentError("invalid ENS name", "name", name);
            }
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) {
                return null;
            }
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) {
                return null;
            }
            // keccak("name(bytes32)")
            const name = _parseString(yield this.call({
                to: resolverAddr,
                data: ("0x691f3431" + (0,namehash/* namehash */.VM)(node).substring(2))
            }), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) {
                return null;
            }
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            let resolver = null;
            if ((0,bytes_lib_esm.isHexString)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) {
                    return null;
                }
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new Resolver(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) {
                        return avatar.url;
                    }
                }
                catch (error) {
                    if (error.code !== logger_lib_esm.Logger.errors.CALL_EXCEPTION) {
                        throw error;
                    }
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = _parseString(yield this.call({
                        to: resolverAddress,
                        data: ("0x691f3431" + (0,namehash/* namehash */.VM)(node).substring(2))
                    }), 0);
                    resolver = yield this.getResolver(name);
                }
                catch (error) {
                    if (error.code !== logger_lib_esm.Logger.errors.CALL_EXCEPTION) {
                        throw error;
                    }
                    return null;
                }
            }
            else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) {
                    return null;
                }
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) {
                return null;
            }
            return avatar.url;
        });
    }
    perform(method, params) {
        return base_provider_logger.throwError(method + " not implemented", logger_lib_esm.Logger.errors.NOT_IMPLEMENTED, { operation: method });
    }
    _startEvent(event) {
        this.polling = (this._events.filter((e) => e.pollable()).length > 0);
    }
    _stopEvent(event) {
        this.polling = (this._events.filter((e) => e.pollable()).length > 0);
    }
    _addEventListener(eventName, listener, once) {
        const event = new Event(getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = getEventTag(eventName);
        this._events = this._events.filter((event) => {
            if (event.tag !== eventTag) {
                return true;
            }
            setTimeout(() => {
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event) => { this._stopEvent(event); });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) {
            return this._events.length;
        }
        let eventTag = getEventTag(eventName);
        return this._events.filter((event) => {
            return (event.tag === eventTag);
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) {
            return this._events.map((event) => event.listener);
        }
        let eventTag = getEventTag(eventName);
        return this._events
            .filter((event) => (event.tag === eventTag))
            .map((event) => event.listener);
    }
    off(eventName, listener) {
        if (listener == null) {
            return this.removeAllListeners(eventName);
        }
        const stopped = [];
        let found = false;
        let eventTag = getEventTag(eventName);
        this._events = this._events.filter((event) => {
            if (event.tag !== eventTag || event.listener != listener) {
                return true;
            }
            if (found) {
                return true;
            }
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event) => { this._stopEvent(event); });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        }
        else {
            const eventTag = getEventTag(eventName);
            this._events = this._events.filter((event) => {
                if (event.tag !== eventTag) {
                    return true;
                }
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event) => { this._stopEvent(event); });
        return this;
    }
}
//# sourceMappingURL=base-provider.js.map
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abstract-signer/lib.esm/index.js + 1 modules
var abstract_signer_lib_esm = __webpack_require__("../../node_modules/@ethersproject/abstract-signer/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hash/lib.esm/typed-data.js
var typed_data = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/typed-data.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/json-rpc-provider.js

var json_rpc_provider_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const json_rpc_provider_logger = new logger_lib_esm.Logger(_version_version);

const errorGas = ["call", "estimateGas"];
function spelunk(value, requireData) {
    if (value == null) {
        return null;
    }
    // These *are* the droids we're looking for.
    if (typeof (value.message) === "string" && value.message.match("reverted")) {
        const data = (0,bytes_lib_esm.isHexString)(value.data) ? value.data : null;
        if (!requireData || data) {
            return { message: value.message, data };
        }
    }
    // Spelunk further...
    if (typeof (value) === "object") {
        for (const key in value) {
            const result = spelunk(value[key], requireData);
            if (result) {
                return result;
            }
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof (value) === "string") {
        try {
            return spelunk(JSON.parse(value), requireData);
        }
        catch (error) { }
    }
    return null;
}
function checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = spelunk(error, true);
        if (result) {
            return result.data;
        }
        // Nothing descriptive..
        json_rpc_provider_logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", logger_lib_esm.Logger.errors.CALL_EXCEPTION, {
            data: "0x", transaction, error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = spelunk(error.body, false);
        if (result == null) {
            result = spelunk(error, false);
        }
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) {
            json_rpc_provider_logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", logger_lib_esm.Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
                reason: result.message, method, transaction, error
            });
        }
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === logger_lib_esm.Logger.errors.SERVER_ERROR && error.error && typeof (error.error.message) === "string") {
        message = error.error.message;
    }
    else if (typeof (error.body) === "string") {
        message = error.body;
    }
    else if (typeof (error.responseText) === "string") {
        message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) {
        json_rpc_provider_logger.throwError("insufficient funds for intrinsic transaction cost", logger_lib_esm.Logger.errors.INSUFFICIENT_FUNDS, {
            error, method, transaction
        });
    }
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) {
        json_rpc_provider_logger.throwError("nonce has already been used", logger_lib_esm.Logger.errors.NONCE_EXPIRED, {
            error, method, transaction
        });
    }
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) {
        json_rpc_provider_logger.throwError("replacement fee too low", logger_lib_esm.Logger.errors.REPLACEMENT_UNDERPRICED, {
            error, method, transaction
        });
    }
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) {
        json_rpc_provider_logger.throwError("legacy pre-eip-155 transactions not supported", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
            error, method, transaction
        });
    }
    if (errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) {
        json_rpc_provider_logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", logger_lib_esm.Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
            error, method, transaction
        });
    }
    throw error;
}
function timer(timeout) {
    return new Promise(function (resolve) {
        setTimeout(resolve, timeout);
    });
}
function getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function getLowerCase(value) {
    if (value) {
        return value.toLowerCase();
    }
    return value;
}
const _constructorGuard = {};
class JsonRpcSigner extends abstract_signer_lib_esm/* Signer */.E {
    constructor(constructorGuard, provider, addressOrIndex) {
        super();
        if (constructorGuard !== _constructorGuard) {
            throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        }
        (0,properties_lib_esm.defineReadOnly)(this, "provider", provider);
        if (addressOrIndex == null) {
            addressOrIndex = 0;
        }
        if (typeof (addressOrIndex) === "string") {
            (0,properties_lib_esm.defineReadOnly)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0,properties_lib_esm.defineReadOnly)(this, "_index", null);
        }
        else if (typeof (addressOrIndex) === "number") {
            (0,properties_lib_esm.defineReadOnly)(this, "_index", addressOrIndex);
            (0,properties_lib_esm.defineReadOnly)(this, "_address", null);
        }
        else {
            json_rpc_provider_logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
        }
    }
    connect(provider) {
        return json_rpc_provider_logger.throwError("cannot alter JSON-RPC Signer connection", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new UncheckedJsonRpcSigner(_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) {
            return Promise.resolve(this._address);
        }
        return this.provider.send("eth_accounts", []).then((accounts) => {
            if (accounts.length <= this._index) {
                json_rpc_provider_logger.throwError("unknown account #" + this._index, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                    operation: "getAddress"
                });
            }
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0,properties_lib_esm.shallowCopy)(transaction);
        const fromAddress = this.getAddress().then((address) => {
            if (address) {
                address = address.toLowerCase();
            }
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0,properties_lib_esm.shallowCopy)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) {
            transaction.to = Promise.resolve(transaction.to).then((to) => json_rpc_provider_awaiter(this, void 0, void 0, function* () {
                if (to == null) {
                    return null;
                }
                const address = yield this.provider.resolveName(to);
                if (address == null) {
                    json_rpc_provider_logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                }
                return address;
            }));
        }
        return (0,properties_lib_esm.resolveProperties)({
            tx: (0,properties_lib_esm.resolveProperties)(transaction),
            sender: fromAddress
        }).then(({ tx, sender }) => {
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) {
                    json_rpc_provider_logger.throwArgumentError("from address mismatch", "transaction", transaction);
                }
            }
            else {
                tx.from = sender;
            }
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, { from: true });
            return this.provider.send("eth_sendTransaction", [hexTx]).then((hash) => {
                return hash;
            }, (error) => {
                if (typeof (error.message) === "string" && error.message.match(/user denied/i)) {
                    json_rpc_provider_logger.throwError("user rejected transaction", logger_lib_esm.Logger.errors.ACTION_REJECTED, {
                        action: "sendTransaction",
                        transaction: tx
                    });
                }
                return checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return json_rpc_provider_logger.throwError("signing transactions is unsupported", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0,web_lib_esm.poll)(() => json_rpc_provider_awaiter(this, void 0, void 0, function* () {
                    const tx = yield this.provider.getTransaction(hash);
                    if (tx === null) {
                        return undefined;
                    }
                    return this.provider._wrapTransaction(tx, hash, blockNumber);
                }), { oncePoll: this.provider });
            }
            catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            const data = ((typeof (message) === "string") ? (0,utf8/* toUtf8Bytes */.Y0)(message) : message);
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [(0,bytes_lib_esm.hexlify)(data), address.toLowerCase()]);
            }
            catch (error) {
                if (typeof (error.message) === "string" && error.message.match(/user denied/i)) {
                    json_rpc_provider_logger.throwError("user rejected signing", logger_lib_esm.Logger.errors.ACTION_REJECTED, {
                        action: "signMessage",
                        from: address,
                        messageData: message
                    });
                }
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            const data = ((typeof (message) === "string") ? (0,utf8/* toUtf8Bytes */.Y0)(message) : message);
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [address.toLowerCase(), (0,bytes_lib_esm.hexlify)(data)]);
            }
            catch (error) {
                if (typeof (error.message) === "string" && error.message.match(/user denied/i)) {
                    json_rpc_provider_logger.throwError("user rejected signing", logger_lib_esm.Logger.errors.ACTION_REJECTED, {
                        action: "_legacySignMessage",
                        from: address,
                        messageData: message
                    });
                }
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            // Populate any ENS names (in-place)
            const populated = yield typed_data/* TypedDataEncoder.resolveNames */.E.resolveNames(domain, types, value, (name) => {
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify(typed_data/* TypedDataEncoder.getPayload */.E.getPayload(populated.domain, types, populated.value))
                ]);
            }
            catch (error) {
                if (typeof (error.message) === "string" && error.message.match(/user denied/i)) {
                    json_rpc_provider_logger.throwError("user rejected signing", logger_lib_esm.Logger.errors.ACTION_REJECTED, {
                        action: "_signTypedData",
                        from: address,
                        messageData: { domain: populated.domain, types, value: populated.value }
                    });
                }
                throw error;
            }
        });
    }
    unlock(password) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [address.toLowerCase(), password, null]);
        });
    }
}
class UncheckedJsonRpcSigner extends JsonRpcSigner {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash) => {
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations) => { return this.provider.waitForTransaction(hash, confirmations); }
            };
        });
    }
}
const allowedTransactionKeys = {
    chainId: true, data: true, gasLimit: true, gasPrice: true, nonce: true, to: true, value: true,
    type: true, accessList: true,
    maxFeePerGas: true, maxPriorityFeePerGas: true
};
class JsonRpcProvider extends BaseProvider {
    constructor(url, network) {
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) {
            networkOrReady = new Promise((resolve, reject) => {
                setTimeout(() => {
                    this.detectNetwork().then((network) => {
                        resolve(network);
                    }, (error) => {
                        reject(error);
                    });
                }, 0);
            });
        }
        super(networkOrReady);
        // Default URL
        if (!url) {
            url = (0,properties_lib_esm.getStatic)(this.constructor, "defaultUrl")();
        }
        if (typeof (url) === "string") {
            (0,properties_lib_esm.defineReadOnly)(this, "connection", Object.freeze({
                url: url
            }));
        }
        else {
            (0,properties_lib_esm.defineReadOnly)(this, "connection", Object.freeze((0,properties_lib_esm.shallowCopy)(url)));
        }
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) {
            this._eventLoopCache = {};
        }
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http:/\/localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(() => {
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            yield timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            }
            catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                }
                catch (error) { }
            }
            if (chainId != null) {
                const getNetwork = (0,properties_lib_esm.getStatic)(this.constructor, "getNetwork");
                try {
                    return getNetwork(bignumber/* BigNumber.from */.O$.from(chainId).toNumber());
                }
                catch (error) {
                    return json_rpc_provider_logger.throwError("could not detect network", logger_lib_esm.Logger.errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return json_rpc_provider_logger.throwError("could not detect network", logger_lib_esm.Logger.errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new JsonRpcSigner(_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts) => {
            return accounts.map((a) => this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: (this._nextId++),
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0,properties_lib_esm.deepCopy)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = (["eth_chainId", "eth_blockNumber"].indexOf(method) >= 0);
        if (cache && this._cache[method]) {
            return this._cache[method];
        }
        const result = (0,web_lib_esm.fetchJson)(this.connection, JSON.stringify(request), getResult).then((result) => {
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error) => {
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(() => {
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch (method) {
            case "getBlockNumber":
                return ["eth_blockNumber", []];
            case "getGasPrice":
                return ["eth_gasPrice", []];
            case "getBalance":
                return ["eth_getBalance", [getLowerCase(params.address), params.blockTag]];
            case "getTransactionCount":
                return ["eth_getTransactionCount", [getLowerCase(params.address), params.blockTag]];
            case "getCode":
                return ["eth_getCode", [getLowerCase(params.address), params.blockTag]];
            case "getStorageAt":
                return ["eth_getStorageAt", [getLowerCase(params.address), (0,bytes_lib_esm.hexZeroPad)(params.position, 32), params.blockTag]];
            case "sendTransaction":
                return ["eth_sendRawTransaction", [params.signedTransaction]];
            case "getBlock":
                if (params.blockTag) {
                    return ["eth_getBlockByNumber", [params.blockTag, !!params.includeTransactions]];
                }
                else if (params.blockHash) {
                    return ["eth_getBlockByHash", [params.blockHash, !!params.includeTransactions]];
                }
                return null;
            case "getTransaction":
                return ["eth_getTransactionByHash", [params.transactionHash]];
            case "getTransactionReceipt":
                return ["eth_getTransactionReceipt", [params.transactionHash]];
            case "call": {
                const hexlifyTransaction = (0,properties_lib_esm.getStatic)(this.constructor, "hexlifyTransaction");
                return ["eth_call", [hexlifyTransaction(params.transaction, { from: true }), params.blockTag]];
            }
            case "estimateGas": {
                const hexlifyTransaction = (0,properties_lib_esm.getStatic)(this.constructor, "hexlifyTransaction");
                return ["eth_estimateGas", [hexlifyTransaction(params.transaction, { from: true })]];
            }
            case "getLogs":
                if (params.filter && params.filter.address != null) {
                    params.filter.address = getLowerCase(params.filter.address);
                }
                return ["eth_getLogs", [params.filter]];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && bignumber/* BigNumber.from */.O$.from(tx.type).isZero()) {
                    // If there are no EIP-1559 properties, it might be non-EIP-1559
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0,properties_lib_esm.shallowCopy)(params);
                            params.transaction = (0,properties_lib_esm.shallowCopy)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) {
                json_rpc_provider_logger.throwError(method + " not implemented", logger_lib_esm.Logger.errors.NOT_IMPLEMENTED, { operation: method });
            }
            try {
                return yield this.send(args[0], args[1]);
            }
            catch (error) {
                return checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") {
            this._startPending();
        }
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) {
            return;
        }
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function (filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [filterId]).then(function (hashes) {
                    if (self._pendingFilter != pendingFilter) {
                        return null;
                    }
                    let seq = Promise.resolve();
                    hashes.forEach(function (hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function () {
                            return self.getTransaction(hash).then(function (tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function () {
                        return timer(1000);
                    });
                }).then(function () {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [filterId]);
                        return;
                    }
                    setTimeout(function () { poll(); }, 0);
                    return null;
                }).catch((error) => { });
            }
            poll();
            return filterId;
        }).catch((error) => { });
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) {
            this._pendingFilter = null;
        }
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0,properties_lib_esm.shallowCopy)(allowedTransactionKeys);
        if (allowExtra) {
            for (const key in allowExtra) {
                if (allowExtra[key]) {
                    allowed[key] = true;
                }
            }
        }
        (0,properties_lib_esm.checkProperties)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        ["chainId", "gasLimit", "gasPrice", "type", "maxFeePerGas", "maxPriorityFeePerGas", "nonce", "value"].forEach(function (key) {
            if (transaction[key] == null) {
                return;
            }
            const value = (0,bytes_lib_esm.hexValue)(bignumber/* BigNumber.from */.O$.from(transaction[key]));
            if (key === "gasLimit") {
                key = "gas";
            }
            result[key] = value;
        });
        ["from", "to", "data"].forEach(function (key) {
            if (transaction[key] == null) {
                return;
            }
            result[key] = (0,bytes_lib_esm.hexlify)(transaction[key]);
        });
        if (transaction.accessList) {
            result["accessList"] = (0,transactions_lib_esm.accessListify)(transaction.accessList);
        }
        return result;
    }
}
//# sourceMappingURL=json-rpc-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/ws.js



let WS = null;
try {
    WS = WebSocket;
    if (WS == null) {
        throw new Error("inject please");
    }
}
catch (error) {
    const logger = new logger_lib_esm.Logger(_version_version);
    WS = function () {
        logger.throwError("WebSockets not supported in this environment", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}
//export default WS;
//module.exports = WS;

//# sourceMappingURL=ws.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/websocket-provider.js

var websocket_provider_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






const websocket_provider_logger = new logger_lib_esm.Logger(_version_version);
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */
let NextId = 1;
// For more info about the Real-time Event API see:
//   https://geth.ethereum.org/docs/rpc/pubsub
class WebSocketProvider extends JsonRpcProvider {
    constructor(url, network) {
        // This will be added in the future; please open an issue to expedite
        if (network === "any") {
            websocket_provider_logger.throwError("WebSocketProvider does not support 'any' network yet", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "network:any"
            });
        }
        if (typeof (url) === "string") {
            super(url, network);
        }
        else {
            super("_websocket", network);
        }
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof (url) === "string") {
            (0,properties_lib_esm.defineReadOnly)(this, "_websocket", new WS(this.connection.url));
        }
        else {
            (0,properties_lib_esm.defineReadOnly)(this, "_websocket", url);
        }
        (0,properties_lib_esm.defineReadOnly)(this, "_requests", {});
        (0,properties_lib_esm.defineReadOnly)(this, "_subs", {});
        (0,properties_lib_esm.defineReadOnly)(this, "_subIds", {});
        (0,properties_lib_esm.defineReadOnly)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = () => {
            this._wsReady = true;
            Object.keys(this._requests).forEach((id) => {
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent) => {
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                }
                else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0,properties_lib_esm.defineReadOnly)(error, "code", result.error.code || null);
                        (0,properties_lib_esm.defineReadOnly)(error, "response", data);
                    }
                    else {
                        error = new Error("unknown error");
                    }
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            }
            else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) {
                    //this.emit.apply(this,                  );
                    sub.processFunc(result.params.result);
                }
            }
            else {
                console.warn("this should not happen");
            }
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(() => {
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) {
            fauxPoll.unref();
        }
    }
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() { return this._websocket; }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        websocket_provider_logger.throwError("cannot reset events block on WebSocketProvider", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        websocket_provider_logger.throwError("cannot set polling interval on WebSocketProvider", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return websocket_provider_awaiter(this, void 0, void 0, function* () {
            return null;
        });
    }
    set polling(value) {
        if (!value) {
            return;
        }
        websocket_provider_logger.throwError("cannot set polling on WebSocketProvider", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = NextId++;
        return new Promise((resolve, reject) => {
            function callback(error, result) {
                if (error) {
                    return reject(error);
                }
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = { callback, payload };
            if (this._wsReady) {
                this.websocket.send(payload);
            }
        });
    }
    static defaultUrl() {
        return "ws:/\/localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return websocket_provider_awaiter(this, void 0, void 0, function* () {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param) => {
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = { tag, processFunc };
        });
    }
    _startEvent(event) {
        switch (event.type) {
            case "block":
                this._subscribe("block", ["newHeads"], (result) => {
                    const blockNumber = bignumber/* BigNumber.from */.O$.from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", ["newPendingTransactions"], (result) => {
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, ["logs", this._getFilter(event.filter)], (result) => {
                    if (result.removed == null) {
                        result.removed = false;
                    }
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx": {
                const emitReceipt = (event) => {
                    const hash = event.hash;
                    this.getTransactionReceipt(hash).then((receipt) => {
                        if (!receipt) {
                            return;
                        }
                        this.emit(hash, receipt);
                    });
                };
                // In case it is already mined
                emitReceipt(event);
                // To keep things simple, we start up a single newHeads subscription
                // to keep an eye out for transactions we are watching for.
                // Starting a subscription for an event (i.e. "tx") that is already
                // running is (basically) a nop.
                this._subscribe("tx", ["newHeads"], (result) => {
                    this._events.filter((e) => (e.type === "tx")).forEach(emitReceipt);
                });
                break;
            }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e) => (e.type === "tx")).length) {
                return;
            }
            tag = "tx";
        }
        else if (this.listenerCount(event.event)) {
            // There are remaining event listeners
            return;
        }
        const subId = this._subIds[tag];
        if (!subId) {
            return;
        }
        delete this._subIds[tag];
        subId.then((subId) => {
            if (!this._subs[subId]) {
                return;
            }
            delete this._subs[subId];
            this.send("eth_unsubscribe", [subId]);
        });
    }
    destroy() {
        return websocket_provider_awaiter(this, void 0, void 0, function* () {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === WS.CONNECTING) {
                yield (new Promise((resolve) => {
                    this.websocket.onopen = function () {
                        resolve(true);
                    };
                    this.websocket.onerror = function () {
                        resolve(false);
                    };
                }));
            }
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
}
//# sourceMappingURL=websocket-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/url-json-rpc-provider.js

var url_json_rpc_provider_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const url_json_rpc_provider_logger = new logger_lib_esm.Logger(_version_version);

// A StaticJsonRpcProvider is useful when you *know* for certain that
// the backend will never change, as it never calls eth_chainId to
// verify its backend. However, if the backend does change, the effects
// are undefined and may include:
// - inconsistent results
// - locking up the UI
// - block skew warnings
// - wrong results
// If the network is not explicit (i.e. auto-detection is expected), the
// node MUST be running and available to respond to requests BEFORE this
// is instantiated.
class StaticJsonRpcProvider extends JsonRpcProvider {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: { get: () => super.detectNetwork }
        });
        return url_json_rpc_provider_awaiter(this, void 0, void 0, function* () {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) {
                    url_json_rpc_provider_logger.throwError("no network detected", logger_lib_esm.Logger.errors.UNKNOWN_ERROR, {});
                }
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0,properties_lib_esm.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class UrlJsonRpcProvider extends StaticJsonRpcProvider {
    constructor(network, apiKey) {
        url_json_rpc_provider_logger.checkAbstract(new.target, UrlJsonRpcProvider);
        // Normalize the Network and API Key
        network = (0,properties_lib_esm.getStatic)(new.target, "getNetwork")(network);
        apiKey = (0,properties_lib_esm.getStatic)(new.target, "getApiKey")(apiKey);
        const connection = (0,properties_lib_esm.getStatic)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof (apiKey) === "string") {
            (0,properties_lib_esm.defineReadOnly)(this, "apiKey", apiKey);
        }
        else if (apiKey != null) {
            Object.keys(apiKey).forEach((key) => {
                (0,properties_lib_esm.defineReadOnly)(this, key, apiKey[key]);
            });
        }
    }
    _startPending() {
        url_json_rpc_provider_logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return url_json_rpc_provider_logger.throwError("API provider does not support signing", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, { operation: "getSigner" });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return url_json_rpc_provider_logger.throwError("not implemented; sub-classes must override getUrl", logger_lib_esm.Logger.errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
}
//# sourceMappingURL=url-json-rpc-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/alchemy-provider.js






const alchemy_provider_logger = new logger_lib_esm.Logger(_version_version);

// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class AlchemyWebSocketProvider extends WebSocketProvider {
    constructor(network, apiKey) {
        const provider = new AlchemyProvider(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws")
            .replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0,properties_lib_esm.defineReadOnly)(this, "apiKey", provider.apiKey);
    }
    isCommunityResource() {
        return (this.apiKey === defaultApiKey);
    }
}
class AlchemyProvider extends UrlJsonRpcProvider {
    static getWebSocketProvider(network, apiKey) {
        return new AlchemyWebSocketProvider(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) {
            return defaultApiKey;
        }
        if (apiKey && typeof (apiKey) !== "string") {
            alchemy_provider_logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        }
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch (network.name) {
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.g.alchemy.com/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-goerli":
                host = "arb-goerli.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-goerli":
                host = "opt-goerli.g.alchemy.com/v2/";
                break;
            default:
                alchemy_provider_logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: ("https:/" + "/" + host + apiKey),
            throttleCallback: (attempt, url) => {
                if (apiKey === defaultApiKey) {
                    showThrottleMessage();
                }
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return (this.apiKey === defaultApiKey);
    }
}
//# sourceMappingURL=alchemy-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/ankr-provider.js




const ankr_provider_logger = new logger_lib_esm.Logger(_version_version);
const ankr_provider_defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function getHost(name) {
    switch (name) {
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return ankr_provider_logger.throwArgumentError("unsupported network", "name", name);
}
class AnkrProvider extends UrlJsonRpcProvider {
    isCommunityResource() {
        return (this.apiKey === ankr_provider_defaultApiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) {
            return ankr_provider_defaultApiKey;
        }
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) {
            apiKey = ankr_provider_defaultApiKey;
        }
        const connection = {
            allowGzip: true,
            url: ("https:/\/" + getHost(network.name) + apiKey),
            throttleCallback: (attempt, url) => {
                if (apiKey.apiKey === ankr_provider_defaultApiKey) {
                    showThrottleMessage();
                }
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}
//# sourceMappingURL=ankr-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/cloudflare-provider.js

var cloudflare_provider_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



const cloudflare_provider_logger = new logger_lib_esm.Logger(_version_version);
class CloudflareProvider extends UrlJsonRpcProvider {
    static getApiKey(apiKey) {
        if (apiKey != null) {
            cloudflare_provider_logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        }
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch (network.name) {
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                cloudflare_provider_logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: { get: () => super.perform }
        });
        return cloudflare_provider_awaiter(this, void 0, void 0, function* () {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", { blockTag: "latest" });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}
//# sourceMappingURL=cloudflare-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/etherscan-provider.js

var etherscan_provider_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};







const etherscan_provider_logger = new logger_lib_esm.Logger(_version_version);

// The transaction has already been sanitized by the calls in Provider
function getTransactionPostData(transaction) {
    const result = {};
    for (let key in transaction) {
        if (transaction[key] == null) {
            continue;
        }
        let value = transaction[key];
        if (key === "type" && value === 0) {
            continue;
        }
        // Quantity-types require no leading zero, unless 0
        if ({ type: true, gasLimit: true, gasPrice: true, maxFeePerGs: true, maxPriorityFeePerGas: true, nonce: true, value: true }[key]) {
            value = (0,bytes_lib_esm.hexValue)((0,bytes_lib_esm.hexlify)(value));
        }
        else if (key === "accessList") {
            value = "[" + (0,transactions_lib_esm.accessListify)(value).map((set) => {
                return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
            }).join(",") + "]";
        }
        else {
            value = (0,bytes_lib_esm.hexlify)(value);
        }
        result[key] = value;
    }
    return result;
}
function etherscan_provider_getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) {
        return result.result;
    }
    if (result.status != 1 || typeof (result.message) !== "string" || !result.message.match(/^OK/)) {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
            error.throttleRetry = true;
        }
        throw error;
    }
    return result.result;
}
function getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) {
            error.code = result.error.code;
        }
        if (result.error.data) {
            error.data = result.error.data;
        }
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function checkLogTag(blockTag) {
    if (blockTag === "pending") {
        throw new Error("pending not supported");
    }
    if (blockTag === "latest") {
        return blockTag;
    }
    return parseInt(blockTag.substring(2), 16);
}
function etherscan_provider_checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === logger_lib_esm.Logger.errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) {
                data = "0x" + data.replace(/^.*0x/i, "");
            }
            if ((0,bytes_lib_esm.isHexString)(data)) {
                return data;
            }
            etherscan_provider_logger.throwError("missing revert data in call exception", logger_lib_esm.Logger.errors.CALL_EXCEPTION, {
                error, data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === logger_lib_esm.Logger.errors.SERVER_ERROR) {
        if (error.error && typeof (error.error.message) === "string") {
            message = error.error.message;
        }
        else if (typeof (error.body) === "string") {
            message = error.body;
        }
        else if (typeof (error.responseText) === "string") {
            message = error.responseText;
        }
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) {
        etherscan_provider_logger.throwError("insufficient funds for intrinsic transaction cost", logger_lib_esm.Logger.errors.INSUFFICIENT_FUNDS, {
            error, method, transaction
        });
    }
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) {
        etherscan_provider_logger.throwError("nonce has already been used", logger_lib_esm.Logger.errors.NONCE_EXPIRED, {
            error, method, transaction
        });
    }
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) {
        etherscan_provider_logger.throwError("replacement fee too low", logger_lib_esm.Logger.errors.REPLACEMENT_UNDERPRICED, {
            error, method, transaction
        });
    }
    if (message.match(/execution failed due to an exception|execution reverted/)) {
        etherscan_provider_logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", logger_lib_esm.Logger.errors.UNPREDICTABLE_GAS_LIMIT, {
            error, method, transaction
        });
    }
    throw error;
}
class EtherscanProvider extends BaseProvider {
    constructor(network, apiKey) {
        super(network);
        (0,properties_lib_esm.defineReadOnly)(this, "baseUrl", this.getBaseUrl());
        (0,properties_lib_esm.defineReadOnly)(this, "apiKey", apiKey || null);
    }
    getBaseUrl() {
        switch (this.network ? this.network.name : "invalid") {
            case "homestead":
                return "https:/\/api.etherscan.io";
            case "goerli":
                return "https:/\/api-goerli.etherscan.io";
            case "sepolia":
                return "https:/\/api-sepolia.etherscan.io";
            case "matic":
                return "https:/\/api.polygonscan.com";
            case "maticmum":
                return "https:/\/api-testnet.polygonscan.com";
            case "arbitrum":
                return "https:/\/api.arbiscan.io";
            case "arbitrum-goerli":
                return "https:/\/api-goerli.arbiscan.io";
            case "optimism":
                return "https:/\/api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https:/\/api-goerli-optimistic.etherscan.io";
            default:
        }
        return etherscan_provider_logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key) => {
            const value = params[key];
            if (value != null) {
                accum += `&${key}=${value}`;
            }
            return accum;
        }, "");
        const apiKey = ((this.apiKey) ? `&apikey=${this.apiKey}` : "");
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return etherscan_provider_awaiter(this, void 0, void 0, function* () {
            const url = (post ? this.getPostUrl() : this.getUrl(module, params));
            const payload = (post ? this.getPostData(module, params) : null);
            const procFunc = (module === "proxy") ? getJsonResult : etherscan_provider_getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url) => {
                    if (this.isCommunityResource()) {
                        showThrottleMessage();
                    }
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = { "content-type": "application/x-www-form-urlencoded; charset=UTF-8" };
                payloadStr = Object.keys(payload).map((key) => {
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0,web_lib_esm.fetchJson)(connection, payloadStr, procFunc || getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0,properties_lib_esm.deepCopy)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return etherscan_provider_awaiter(this, void 0, void 0, function* () {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: { get: () => super.perform }
        });
        return etherscan_provider_awaiter(this, void 0, void 0, function* () {
            switch (method) {
                case "getBlockNumber":
                    return this.fetch("proxy", { action: "eth_blockNumber" });
                case "getGasPrice":
                    return this.fetch("proxy", { action: "eth_gasPrice" });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error) => {
                        return etherscan_provider_checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) {
                        return this.fetch("proxy", {
                            action: "eth_getBlockByNumber",
                            tag: params.blockTag,
                            boolean: (params.includeTransactions ? "true" : "false")
                        });
                    }
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call": {
                    if (params.blockTag !== "latest") {
                        throw new Error("EtherscanProvider does not support blockTag for call");
                    }
                    const postData = getTransactionPostData(params.transaction);
                    postData.module = "proxy";
                    postData.action = "eth_call";
                    try {
                        return yield this.fetch("proxy", postData, true);
                    }
                    catch (error) {
                        return etherscan_provider_checkError("call", error, params.transaction);
                    }
                }
                case "estimateGas": {
                    const postData = getTransactionPostData(params.transaction);
                    postData.module = "proxy";
                    postData.action = "eth_estimateGas";
                    try {
                        return yield this.fetch("proxy", postData, true);
                    }
                    catch (error) {
                        return etherscan_provider_checkError("estimateGas", error, params.transaction);
                    }
                }
                case "getLogs": {
                    const args = { action: "getLogs" };
                    if (params.filter.fromBlock) {
                        args.fromBlock = checkLogTag(params.filter.fromBlock);
                    }
                    if (params.filter.toBlock) {
                        args.toBlock = checkLogTag(params.filter.toBlock);
                    }
                    if (params.filter.address) {
                        args.address = params.filter.address;
                    }
                    // @TODO: We can handle slightly more complicated logs using the logs API
                    if (params.filter.topics && params.filter.topics.length > 0) {
                        if (params.filter.topics.length > 1) {
                            etherscan_provider_logger.throwError("unsupported topic count", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, { topics: params.filter.topics });
                        }
                        if (params.filter.topics.length === 1) {
                            const topic0 = params.filter.topics[0];
                            if (typeof (topic0) !== "string" || topic0.length !== 66) {
                                etherscan_provider_logger.throwError("unsupported topic format", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, { topic0: topic0 });
                            }
                            args.topic0 = topic0;
                        }
                    }
                    const logs = yield this.fetch("logs", args);
                    // Cache txHash => blockHash
                    let blocks = {};
                    // Add any missing blockHash to the logs
                    for (let i = 0; i < logs.length; i++) {
                        const log = logs[i];
                        if (log.blockHash != null) {
                            continue;
                        }
                        if (blocks[log.blockNumber] == null) {
                            const block = yield this.getBlock(log.blockNumber);
                            if (block) {
                                blocks[log.blockNumber] = block.hash;
                            }
                        }
                        log.blockHash = blocks[log.blockNumber];
                    }
                    return logs;
                }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") {
                        return 0.0;
                    }
                    return parseFloat((yield this.fetch("stats", { action: "ethprice" })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return etherscan_provider_awaiter(this, void 0, void 0, function* () {
            const params = {
                action: "txlist",
                address: (yield this.resolveName(addressOrName)),
                startblock: ((startBlock == null) ? 0 : startBlock),
                endblock: ((endBlock == null) ? 99999999 : endBlock),
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx) => {
                ["contractAddress", "to"].forEach(function (key) {
                    if (tx[key] == "") {
                        delete tx[key];
                    }
                });
                if (tx.creates == null && tx.contractAddress != null) {
                    tx.creates = tx.contractAddress;
                }
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) {
                    item.timestamp = parseInt(tx.timeStamp);
                }
                return item;
            });
        });
    }
    isCommunityResource() {
        return (this.apiKey == null);
    }
}
//# sourceMappingURL=etherscan-provider.js.map
// EXTERNAL MODULE: ../../node_modules/@ethersproject/random/lib.esm/shuffle.js
var shuffle = __webpack_require__("../../node_modules/@ethersproject/random/lib.esm/shuffle.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/fallback-provider.js

var fallback_provider_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};










const fallback_provider_logger = new logger_lib_esm.Logger(_version_version);
function now() { return (new Date()).getTime(); }
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function checkNetworks(networks) {
    let result = null;
    for (let i = 0; i < networks.length; i++) {
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) {
            return null;
        }
        if (result) {
            // Make sure the network matches the previous networks
            if (!(result.name === network.name && result.chainId === network.chainId &&
                ((result.ensAddress === network.ensAddress) || (result.ensAddress == null && network.ensAddress == null)))) {
                fallback_provider_logger.throwArgumentError("provider mismatch", "networks", networks);
            }
        }
        else {
            result = network;
        }
    }
    return result;
}
function median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) {
        return values[middle];
    }
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) {
        return null;
    }
    return (a + b) / 2;
}
function serialize(value) {
    if (value === null) {
        return "null";
    }
    else if (typeof (value) === "number" || typeof (value) === "boolean") {
        return JSON.stringify(value);
    }
    else if (typeof (value) === "string") {
        return value;
    }
    else if (bignumber/* BigNumber.isBigNumber */.O$.isBigNumber(value)) {
        return value.toString();
    }
    else if (Array.isArray(value)) {
        return JSON.stringify(value.map((i) => serialize(i)));
    }
    else if (typeof (value) === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key) => {
            let v = value[key];
            if (typeof (v) === "function") {
                v = "[function]";
            }
            else {
                v = serialize(v);
            }
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof (value));
}
// Next request ID to use for emitting debug info
let nextRid = 1;
;
function fallback_provider_stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = (new Promise((resolve) => {
        cancel = function () {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    }));
    const wait = (func) => {
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return { cancel, getPromise, wait };
}
const ForwardErrors = [
    logger_lib_esm.Logger.errors.CALL_EXCEPTION,
    logger_lib_esm.Logger.errors.INSUFFICIENT_FUNDS,
    logger_lib_esm.Logger.errors.NONCE_EXPIRED,
    logger_lib_esm.Logger.errors.REPLACEMENT_UNDERPRICED,
    logger_lib_esm.Logger.errors.UNPREDICTABLE_GAS_LIMIT
];
const ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction",
];
;
function exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", { get: () => config.provider });
    if (config.start) {
        result.start = config.start;
    }
    if (now) {
        result.duration = (now - config.start);
    }
    if (config.done) {
        if (config.error) {
            result.error = config.error;
        }
        else {
            result.result = config.result || null;
        }
    }
    return result;
}
function normalizedTally(normalize, quorum) {
    return function (configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c) => {
            const value = normalize(c.result);
            if (!tally[value]) {
                tally[value] = { count: 0, result: c.result };
            }
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for (let i = 0; i < keys.length; i++) {
            const check = tally[keys[i]];
            if (check.count >= quorum) {
                return check.result;
            }
        }
        // No quroum
        return undefined;
    };
}
function getProcessFunc(provider, method, params) {
    let normalize = serialize;
    switch (method) {
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function (configs) {
                const values = configs.map((c) => c.result);
                // Get the median block number
                let blockNumber = median(configs.map((c) => c.result), 2);
                if (blockNumber == null) {
                    return undefined;
                }
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) {
                    blockNumber++;
                }
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) {
                    provider._highestBlockNumber = blockNumber;
                }
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function (configs) {
                const values = configs.map((c) => c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function (configs) {
                return median(configs.map((c) => c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function (tx) {
                if (tx == null) {
                    return null;
                }
                tx = (0,properties_lib_esm.shallowCopy)(tx);
                tx.confirmations = -1;
                return serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) {
                normalize = function (block) {
                    if (block == null) {
                        return null;
                    }
                    block = (0,properties_lib_esm.shallowCopy)(block);
                    block.transactions = block.transactions.map((tx) => {
                        tx = (0,properties_lib_esm.shallowCopy)(tx);
                        tx.confirmations = -1;
                        return tx;
                    });
                    return serialize(block);
                };
            }
            else {
                normalize = function (block) {
                    if (block == null) {
                        return null;
                    }
                    return serialize(block);
                };
            }
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function waitForSync(config, blockNumber) {
    return fallback_provider_awaiter(this, void 0, void 0, function* () {
        const provider = (config.provider);
        if ((provider.blockNumber != null && provider.blockNumber >= blockNumber) || blockNumber === -1) {
            return provider;
        }
        return (0,web_lib_esm.poll)(() => {
            return new Promise((resolve, reject) => {
                setTimeout(function () {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) {
                        return resolve(provider);
                    }
                    // We're done; just quit
                    if (config.cancelled) {
                        return resolve(null);
                    }
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, { oncePoll: provider });
    });
}
function getRunner(config, currentBlockNumber, method, params) {
    return fallback_provider_awaiter(this, void 0, void 0, function* () {
        let provider = config.provider;
        switch (method) {
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) {
                    return provider.getEtherPrice();
                }
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0,bytes_lib_esm.isHexString)(params.blockTag)) {
                    provider = yield waitForSync(config, currentBlockNumber);
                }
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0,bytes_lib_esm.isHexString)(params.blockTag)) {
                    provider = yield waitForSync(config, currentBlockNumber);
                }
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0,bytes_lib_esm.isHexString)(params.blockTag)) {
                    provider = yield waitForSync(config, currentBlockNumber);
                }
                return provider[(params.includeTransactions ? "getBlockWithTransactions" : "getBlock")](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0,bytes_lib_esm.isHexString)(params.blockTag)) {
                    provider = yield waitForSync(config, currentBlockNumber);
                }
                if (method === "call" && params.blockTag) {
                    return provider[method](params.transaction, params.blockTag);
                }
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs": {
                let filter = params.filter;
                if ((filter.fromBlock && (0,bytes_lib_esm.isHexString)(filter.fromBlock)) || (filter.toBlock && (0,bytes_lib_esm.isHexString)(filter.toBlock))) {
                    provider = yield waitForSync(config, currentBlockNumber);
                }
                return provider.getLogs(filter);
            }
        }
        return fallback_provider_logger.throwError("unknown method error", logger_lib_esm.Logger.errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class FallbackProvider extends BaseProvider {
    constructor(providers, quorum) {
        if (providers.length === 0) {
            fallback_provider_logger.throwArgumentError("missing providers", "providers", providers);
        }
        const providerConfigs = providers.map((configOrProvider, index) => {
            if (lib_esm/* Provider.isProvider */.zt.isProvider(configOrProvider)) {
                const stallTimeout = isCommunityResource(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({ provider: configOrProvider, weight: 1, stallTimeout, priority });
            }
            const config = (0,properties_lib_esm.shallowCopy)(configOrProvider);
            if (config.priority == null) {
                config.priority = 1;
            }
            if (config.stallTimeout == null) {
                config.stallTimeout = isCommunityResource(configOrProvider) ? 2000 : 750;
            }
            if (config.weight == null) {
                config.weight = 1;
            }
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) {
                fallback_provider_logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            }
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c) => (accum + c.weight), 0);
        if (quorum == null) {
            quorum = total / 2;
        }
        else if (quorum > total) {
            fallback_provider_logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        }
        // Are all providers' networks are known
        let networkOrReady = checkNetworks(providerConfigs.map((c) => (c.provider).network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) {
            networkOrReady = new Promise((resolve, reject) => {
                setTimeout(() => {
                    this.detectNetwork().then(resolve, reject);
                }, 0);
            });
        }
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0,properties_lib_esm.defineReadOnly)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0,properties_lib_esm.defineReadOnly)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
    detectNetwork() {
        return fallback_provider_awaiter(this, void 0, void 0, function* () {
            const networks = yield Promise.all(this.providerConfigs.map((c) => c.provider.getNetwork()));
            return checkNetworks(networks);
        });
    }
    perform(method, params) {
        return fallback_provider_awaiter(this, void 0, void 0, function* () {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c) => {
                    return c.provider.sendTransaction(params.signedTransaction).then((result) => {
                        return result.hash;
                    }, (error) => {
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for (let i = 0; i < results.length; i++) {
                    const result = results[i];
                    if (typeof (result) === "string") {
                        return result;
                    }
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") {
                yield this.getBlockNumber();
            }
            const processFunc = getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0,shuffle/* shuffled */.y)(this.providerConfigs.map(properties_lib_esm.shallowCopy));
            configs.sort((a, b) => (a.priority - b.priority));
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while (true) {
                const t0 = now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c) => (c.runner && ((t0 - c.start) < c.stallTimeout)))
                    .reduce((accum, c) => (accum + c.weight), 0);
                // Start running enough to meet quorum
                while (inflightWeight < this.quorum && i < configs.length) {
                    const config = configs[i++];
                    const rid = nextRid++;
                    config.start = now();
                    config.staller = fallback_provider_stall(config.stallTimeout);
                    config.staller.wait(() => { config.staller = null; });
                    config.runner = getRunner(config, currentBlockNumber, method, params).then((result) => {
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) {
                            this.emit("debug", {
                                action: "request",
                                rid: rid,
                                backend: exposeDebugConfig(config, now()),
                                request: { method: method, params: (0,properties_lib_esm.deepCopy)(params) },
                                provider: this
                            });
                        }
                    }, (error) => {
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) {
                            this.emit("debug", {
                                action: "request",
                                rid: rid,
                                backend: exposeDebugConfig(config, now()),
                                request: { method: method, params: (0,properties_lib_esm.deepCopy)(params) },
                                provider: this
                            });
                        }
                    });
                    if (this.listenerCount("debug")) {
                        this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: exposeDebugConfig(config, null),
                            request: { method: method, params: (0,properties_lib_esm.deepCopy)(params) },
                            provider: this
                        });
                    }
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c) => {
                    if (c.done || !c.runner) {
                        return;
                    }
                    waiting.push(c.runner);
                    if (c.staller) {
                        waiting.push(c.staller.getPromise());
                    }
                });
                if (waiting.length) {
                    yield Promise.race(waiting);
                }
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c) => (c.done && c.error == null));
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach(c => {
                            if (c.staller) {
                                c.staller.cancel();
                            }
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) {
                        yield fallback_provider_stall(100).getPromise();
                    }
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c) => {
                    if (!c.done || c.error == null) {
                        return accum;
                    }
                    const code = (c.error).code;
                    if (ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) {
                            accum[code] = { error: c.error, weight: 0 };
                        }
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, ({}));
                Object.keys(errors).forEach((errorCode) => {
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) {
                        return;
                    }
                    // Shut down any stallers
                    configs.forEach(c => {
                        if (c.staller) {
                            c.staller.cancel();
                        }
                        c.cancelled = true;
                    });
                    const e = (tally.error);
                    const props = {};
                    ForwardProperties.forEach((name) => {
                        if (e[name] == null) {
                            return;
                        }
                        props[name] = e[name];
                    });
                    fallback_provider_logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c) => !c.done).length === 0) {
                    break;
                }
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach(c => {
                if (c.staller) {
                    c.staller.cancel();
                }
                c.cancelled = true;
            });
            return fallback_provider_logger.throwError("failed to meet quorum", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c) => exposeDebugConfig(c)),
                provider: this
            });
        });
    }
}
//# sourceMappingURL=fallback-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/ipc-provider.js

const IpcProvider = null;

//# sourceMappingURL=ipc-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/infura-provider.js






const infura_provider_logger = new logger_lib_esm.Logger(_version_version);

const defaultProjectId = "84842078b09946638c03157f83405213";
class InfuraWebSocketProvider extends WebSocketProvider {
    constructor(network, apiKey) {
        const provider = new InfuraProvider(network, apiKey);
        const connection = provider.connection;
        if (connection.password) {
            infura_provider_logger.throwError("INFURA WebSocket project secrets unsupported", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "InfuraProvider.getWebSocketProvider()"
            });
        }
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0,properties_lib_esm.defineReadOnly)(this, "apiKey", provider.projectId);
        (0,properties_lib_esm.defineReadOnly)(this, "projectId", provider.projectId);
        (0,properties_lib_esm.defineReadOnly)(this, "projectSecret", provider.projectSecret);
    }
    isCommunityResource() {
        return (this.projectId === defaultProjectId);
    }
}
class InfuraProvider extends UrlJsonRpcProvider {
    static getWebSocketProvider(network, apiKey) {
        return new InfuraWebSocketProvider(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: defaultProjectId,
            projectId: defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) {
            return apiKeyObj;
        }
        if (typeof (apiKey) === "string") {
            apiKeyObj.projectId = apiKey;
        }
        else if (apiKey.projectSecret != null) {
            infura_provider_logger.assertArgument((typeof (apiKey.projectId) === "string"), "projectSecret requires a projectId", "projectId", apiKey.projectId);
            infura_provider_logger.assertArgument((typeof (apiKey.projectSecret) === "string"), "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        }
        else if (apiKey.projectId) {
            apiKeyObj.projectId = apiKey.projectId;
        }
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch (network ? network.name : "unknown") {
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "sepolia":
                host = "sepolia.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-goerli":
                host = "optimism-goerli.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-goerli":
                host = "arbitrum-goerli.infura.io";
                break;
            default:
                infura_provider_logger.throwError("unsupported network", logger_lib_esm.Logger.errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: ("https:/" + "/" + host + "/v3/" + apiKey.projectId),
            throttleCallback: (attempt, url) => {
                if (apiKey.projectId === defaultProjectId) {
                    showThrottleMessage();
                }
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return (this.projectId === defaultProjectId);
    }
}
//# sourceMappingURL=infura-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/json-rpc-batch-provider.js



// Experimental
class JsonRpcBatchProvider extends JsonRpcProvider {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: (this._nextId++),
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) {
            this._pendingBatch = [];
        }
        const inflightRequest = { request, resolve: null, reject: null };
        const promise = new Promise((resolve, reject) => {
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) {
            // Schedule batch for next event loop + short duration
            this._pendingBatchAggregator = setTimeout(() => {
                // Get teh current batch and clear it, so new requests
                // go into the next batch
                const batch = this._pendingBatch;
                this._pendingBatch = null;
                this._pendingBatchAggregator = null;
                // Get the request as an array of requests
                const request = batch.map((inflight) => inflight.request);
                this.emit("debug", {
                    action: "requestBatch",
                    request: (0,properties_lib_esm.deepCopy)(request),
                    provider: this
                });
                return (0,web_lib_esm.fetchJson)(this.connection, JSON.stringify(request)).then((result) => {
                    this.emit("debug", {
                        action: "response",
                        request: request,
                        response: result,
                        provider: this
                    });
                    // For each result, feed it to the correct Promise, depending
                    // on whether it was a success or error
                    batch.forEach((inflightRequest, index) => {
                        const payload = result[index];
                        if (payload.error) {
                            const error = new Error(payload.error.message);
                            error.code = payload.error.code;
                            error.data = payload.error.data;
                            inflightRequest.reject(error);
                        }
                        else {
                            inflightRequest.resolve(payload.result);
                        }
                    });
                }, (error) => {
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: request,
                        provider: this
                    });
                    batch.forEach((inflightRequest) => {
                        inflightRequest.reject(error);
                    });
                });
            }, 10);
        }
        return promise;
    }
}
//# sourceMappingURL=json-rpc-batch-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/nodesmith-provider.js
/* istanbul ignore file */




const nodesmith_provider_logger = new logger_lib_esm.Logger(_version_version);
// Special API key provided by Nodesmith for ethers.js
const nodesmith_provider_defaultApiKey = "ETHERS_JS_SHARED";
class NodesmithProvider extends UrlJsonRpcProvider {
    static getApiKey(apiKey) {
        if (apiKey && typeof (apiKey) !== "string") {
            nodesmith_provider_logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        }
        return apiKey || nodesmith_provider_defaultApiKey;
    }
    static getUrl(network, apiKey) {
        nodesmith_provider_logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch (network.name) {
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                nodesmith_provider_logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return (host + "?apiKey=" + apiKey);
    }
}
//# sourceMappingURL=nodesmith-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/pocket-provider.js



const pocket_provider_logger = new logger_lib_esm.Logger(_version_version);

const defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class PocketProvider extends UrlJsonRpcProvider {
    static getApiKey(apiKey) {
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: true,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (apiKey == null) {
            apiKeyObj.applicationId = defaultApplicationId;
        }
        else if (typeof (apiKey) === "string") {
            apiKeyObj.applicationId = apiKey;
        }
        else if (apiKey.applicationSecretKey != null) {
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
        }
        else if (apiKey.applicationId) {
            apiKeyObj.applicationId = apiKey.applicationId;
        }
        else {
            pocket_provider_logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        }
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch (network ? network.name : "unknown") {
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "kovan":
                host = "poa-kovan.gateway.pokt.network";
                break;
            case "matic":
                host = "poly-mainnet.gateway.pokt.network";
                break;
            case "maticmum":
                host = "polygon-mumbai-rpc.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            default:
                pocket_provider_logger.throwError("unsupported network", logger_lib_esm.Logger.errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        const connection = { headers: {}, url };
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return (this.applicationId === defaultApplicationId);
    }
}
//# sourceMappingURL=pocket-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/web3-provider.js




const web3_provider_logger = new logger_lib_esm.Logger(_version_version);

let _nextId = 1;
function buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function (method, params) {
        const request = {
            method: method,
            params: params,
            id: (_nextId++),
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject) => {
            this.emit("debug", {
                action: "request",
                fetcher,
                request: (0,properties_lib_esm.deepCopy)(request),
                provider: this
            });
            sendFunc(request, (error, response) => {
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher,
                        error,
                        request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher,
                    request,
                    response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function buildEip1193Fetcher(provider) {
    return function (method, params) {
        if (params == null) {
            params = [];
        }
        const request = { method, params };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0,properties_lib_esm.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then((response) => {
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request,
                response,
                provider: this
            });
            return response;
        }, (error) => {
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request,
                error,
                provider: this
            });
            throw error;
        });
    };
}
class Web3Provider extends JsonRpcProvider {
    constructor(provider, network) {
        if (provider == null) {
            web3_provider_logger.throwArgumentError("missing provider", "provider", provider);
        }
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof (provider) === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        }
        else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) {
                path = "metamask";
            }
            subprovider = provider;
            if (provider.request) {
                if (path === "") {
                    path = "eip-1193:";
                }
                jsonRpcFetchFunc = buildEip1193Fetcher(provider);
            }
            else if (provider.sendAsync) {
                jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            }
            else if (provider.send) {
                jsonRpcFetchFunc = buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            }
            else {
                web3_provider_logger.throwArgumentError("unsupported provider", "provider", provider);
            }
            if (!path) {
                path = "unknown:";
            }
        }
        super(path, network);
        (0,properties_lib_esm.defineReadOnly)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0,properties_lib_esm.defineReadOnly)(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}
//# sourceMappingURL=web3-provider.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/providers/lib.esm/index.js





















const lib_esm_logger = new logger_lib_esm.Logger(_version_version);
////////////////////////
// Helper Functions
function getDefaultProvider(network, options) {
    if (network == null) {
        network = "homestead";
    }
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof (network) === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) {
            switch (match[1].toLowerCase()) {
                case "http":
                case "https":
                    return new JsonRpcProvider(network);
                case "ws":
                case "wss":
                    return new WebSocketProvider(network);
                default:
                    lib_esm_logger.throwArgumentError("unsupported URL scheme", "network", network);
            }
        }
    }
    const n = getNetwork(network);
    if (!n || !n._defaultProvider) {
        lib_esm_logger.throwError("unsupported getDefaultProvider network", logger_lib_esm.Logger.errors.NETWORK_ERROR, {
            operation: "getDefaultProvider",
            network: network
        });
    }
    return n._defaultProvider({
        FallbackProvider: FallbackProvider,
        AlchemyProvider: AlchemyProvider,
        AnkrProvider: AnkrProvider,
        CloudflareProvider: CloudflareProvider,
        EtherscanProvider: EtherscanProvider,
        InfuraProvider: InfuraProvider,
        JsonRpcProvider: JsonRpcProvider,
        NodesmithProvider: NodesmithProvider,
        PocketProvider: PocketProvider,
        Web3Provider: Web3Provider,
        IpcProvider: IpcProvider,
    }, options);
}
////////////////////////
// Exports

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/random/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   randomBytes: () => (/* reexport safe */ _random__WEBPACK_IMPORTED_MODULE_0__.O),
/* harmony export */   shuffled: () => (/* reexport safe */ _shuffle__WEBPACK_IMPORTED_MODULE_1__.y)
/* harmony export */ });
/* harmony import */ var _random__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/random/lib.esm/random.js");
/* harmony import */ var _shuffle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/random/lib.esm/shuffle.js");



//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/random/lib.esm/random.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  O: () => (/* binding */ randomBytes)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/random/lib.esm/_version.js
const version = "random/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/random/lib.esm/random.js




const logger = new logger_lib_esm.Logger(version);
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    throw new Error('unable to locate global object');
}
;
const anyGlobal = getGlobal();
let random_crypto = anyGlobal.crypto || anyGlobal.msCrypto;
if (!random_crypto || !random_crypto.getRandomValues) {
    logger.warn("WARNING: Missing strong random number source");
    random_crypto = {
        getRandomValues: function (buffer) {
            return logger.throwError("no secure random source avaialble", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function randomBytes(length) {
    if (length <= 0 || length > 1024 || (length % 1) || length != length) {
        logger.throwArgumentError("invalid length", "length", length);
    }
    const result = new Uint8Array(length);
    random_crypto.getRandomValues(result);
    return (0,lib_esm.arrayify)(result);
}
;
//# sourceMappingURL=random.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/random/lib.esm/shuffle.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   y: () => (/* binding */ shuffled)
/* harmony export */ });

function shuffled(array) {
    array = array.slice();
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}
//# sourceMappingURL=shuffle.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/rlp/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  decode: () => (/* binding */ decode),
  encode: () => (/* binding */ encode)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/rlp/lib.esm/_version.js
const version = "rlp/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/rlp/lib.esm/index.js

//See: https://github.com/ethereum/wiki/wiki/RLP



const logger = new logger_lib_esm.Logger(version);
function arrayifyInteger(value) {
    const result = [];
    while (value) {
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function unarrayifyInteger(data, offset, length) {
    let result = 0;
    for (let i = 0; i < length; i++) {
        result = (result * 256) + data[offset + i];
    }
    return result;
}
function _encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function (child) {
            payload = payload.concat(_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0,lib_esm.isBytesLike)(object)) {
        logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    }
    const data = Array.prototype.slice.call((0,lib_esm.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) {
        return data;
    }
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function encode(object) {
    return (0,lib_esm.hexlify)(_encode(object));
}
function _decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while (childOffset < offset + 1 + length) {
        const decoded = _decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) {
            logger.throwError("child data too short", logger_lib_esm.Logger.errors.BUFFER_OVERRUN, {});
        }
    }
    return { consumed: (1 + length), result: result };
}
// returns { consumed: number, result: Object }
function _decode(data, offset) {
    if (data.length === 0) {
        logger.throwError("data too short", logger_lib_esm.Logger.errors.BUFFER_OVERRUN, {});
    }
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) {
            logger.throwError("data short segment too short", logger_lib_esm.Logger.errors.BUFFER_OVERRUN, {});
        }
        const length = unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) {
            logger.throwError("data long segment too short", logger_lib_esm.Logger.errors.BUFFER_OVERRUN, {});
        }
        return _decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    }
    else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) {
            logger.throwError("data array too short", logger_lib_esm.Logger.errors.BUFFER_OVERRUN, {});
        }
        return _decodeChildren(data, offset, offset + 1, length);
    }
    else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) {
            logger.throwError("data array too short", logger_lib_esm.Logger.errors.BUFFER_OVERRUN, {});
        }
        const length = unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) {
            logger.throwError("data array too short", logger_lib_esm.Logger.errors.BUFFER_OVERRUN, {});
        }
        const result = (0,lib_esm.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return { consumed: (1 + lengthLength + length), result: result };
    }
    else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) {
            logger.throwError("data too short", logger_lib_esm.Logger.errors.BUFFER_OVERRUN, {});
        }
        const result = (0,lib_esm.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return { consumed: (1 + length), result: result };
    }
    return { consumed: 1, result: (0,lib_esm.hexlify)(data[offset]) };
}
function decode(data) {
    const bytes = (0,lib_esm.arrayify)(data);
    const decoded = _decode(bytes, 0);
    if (decoded.consumed !== bytes.length) {
        logger.throwArgumentError("invalid rlp data", "data", data);
    }
    return decoded.result;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/sha2/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SupportedAlgorithm: () => (/* reexport safe */ _types__WEBPACK_IMPORTED_MODULE_1__.p),
/* harmony export */   computeHmac: () => (/* reexport safe */ _sha2__WEBPACK_IMPORTED_MODULE_0__.Gy),
/* harmony export */   ripemd160: () => (/* reexport safe */ _sha2__WEBPACK_IMPORTED_MODULE_0__.bP),
/* harmony export */   sha256: () => (/* reexport safe */ _sha2__WEBPACK_IMPORTED_MODULE_0__.JQ),
/* harmony export */   sha512: () => (/* reexport safe */ _sha2__WEBPACK_IMPORTED_MODULE_0__.o)
/* harmony export */ });
/* harmony import */ var _sha2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/sha2.js");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/types.js");



//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/sha2/lib.esm/sha2.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Gy: () => (/* binding */ computeHmac),
  bP: () => (/* binding */ ripemd160),
  JQ: () => (/* binding */ sha256),
  o: () => (/* binding */ sha512)
});

// EXTERNAL MODULE: ../../node_modules/hash.js/lib/hash.js
var hash = __webpack_require__("../../node_modules/hash.js/lib/hash.js");
var hash_default = /*#__PURE__*/__webpack_require__.n(hash);
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/sha2/lib.esm/types.js
var types = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/types.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/sha2/lib.esm/_version.js
const version = "sha2/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/sha2/lib.esm/sha2.js


//const _ripemd160 = _hash.ripemd160;




const logger = new logger_lib_esm.Logger(version);
function ripemd160(data) {
    return "0x" + (hash_default().ripemd160().update((0,lib_esm.arrayify)(data)).digest("hex"));
}
function sha256(data) {
    return "0x" + (hash_default().sha256().update((0,lib_esm.arrayify)(data)).digest("hex"));
}
function sha512(data) {
    return "0x" + (hash_default().sha512().update((0,lib_esm.arrayify)(data)).digest("hex"));
}
function computeHmac(algorithm, key, data) {
    if (!types/* SupportedAlgorithm */.p[algorithm]) {
        logger.throwError("unsupported algorithm " + algorithm, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
            operation: "hmac",
            algorithm: algorithm
        });
    }
    return "0x" + hash_default().hmac((hash_default())[algorithm], (0,lib_esm.arrayify)(key)).update((0,lib_esm.arrayify)(data)).digest("hex");
}
//# sourceMappingURL=sha2.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/sha2/lib.esm/types.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   p: () => (/* binding */ SupportedAlgorithm)
/* harmony export */ });
var SupportedAlgorithm;
(function (SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})(SupportedAlgorithm || (SupportedAlgorithm = {}));
;
//# sourceMappingURL=types.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/signing-key/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  SigningKey: () => (/* binding */ SigningKey),
  computePublicKey: () => (/* binding */ computePublicKey),
  recoverPublicKey: () => (/* binding */ recoverPublicKey)
});

// EXTERNAL MODULE: ../../node_modules/bn.js/lib/bn.js
var bn = __webpack_require__("../../node_modules/bn.js/lib/bn.js");
var bn_default = /*#__PURE__*/__webpack_require__.n(bn);
// EXTERNAL MODULE: ../../node_modules/hash.js/lib/hash.js
var hash = __webpack_require__("../../node_modules/hash.js/lib/hash.js");
var hash_default = /*#__PURE__*/__webpack_require__.n(hash);
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/signing-key/lib.esm/elliptic.js



var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function getDefaultExportFromNamespaceIfPresent (n) {
	return n && Object.prototype.hasOwnProperty.call(n, 'default') ? n['default'] : n;
}

function getDefaultExportFromNamespaceIfNotNamed (n) {
	return n && Object.prototype.hasOwnProperty.call(n, 'default') && Object.keys(n).length === 1 ? n['default'] : n;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var minimalisticAssert = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};

var utils_1 = createCommonjsModule(function (module, exports) {
'use strict';

var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};
});

var utils_1$1 = createCommonjsModule(function (module, exports) {
'use strict';

var utils = exports;




utils.assert = minimalisticAssert;
utils.toArray = utils_1.toArray;
utils.zero2 = utils_1.zero2;
utils.toHex = utils_1.toHex;
utils.encode = utils_1.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new (bn_default())(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;
});

'use strict';



var getNAF = utils_1$1.getNAF;
var getJSF = utils_1$1.getJSF;
var assert$1 = utils_1$1.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new (bn_default())(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? bn_default().red(conf.prime) : bn_default().mont(this.p);

  // Useful for many curves
  this.zero = new (bn_default())(0).toRed(this.red);
  this.one = new (bn_default())(1).toRed(this.red);
  this.two = new (bn_default())(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new (bn_default())(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
var base = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert$1(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert$1(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils_1$1.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert$1(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert$1(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils_1$1.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};

var inherits_browser = createCommonjsModule(function (module) {
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function () {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
  };
}
});

'use strict';






var assert$2 = utils_1$1.assert;

function ShortCurve(conf) {
  base.call(this, 'short', conf);

  this.a = new (bn_default())(conf.a, 16).toRed(this.red);
  this.b = new (bn_default())(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits_browser(ShortCurve, base);
var short_1 = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new (bn_default())(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new (bn_default())(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new (bn_default())(vec.a, 16),
        b: new (bn_default())(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : bn_default().mont(num);
  var tinv = new (bn_default())(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new (bn_default())(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new (bn_default())(1);
  var y1 = new (bn_default())(0);
  var x2 = new (bn_default())(0);
  var y2 = new (bn_default())(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new (bn_default())(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new (bn_default())(x, 16);
    this.y = new (bn_default())(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits_browser(Point, base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new (bn_default())(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new (bn_default())(0);
  } else {
    this.x = new (bn_default())(x, 16);
    this.y = new (bn_default())(y, 16);
    this.z = new (bn_default())(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits_browser(JPoint, base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new (bn_default())(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

var curve_1 = createCommonjsModule(function (module, exports) {
'use strict';

var curve = exports;

curve.base = base;
curve.short = short_1;
curve.mont = /*RicMoo:ethers:require(./mont)*/(null);
curve.edwards = /*RicMoo:ethers:require(./edwards)*/(null);
});

var curves_1 = createCommonjsModule(function (module, exports) {
'use strict';

var curves = exports;





var assert = utils_1$1.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve_1.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve_1.edwards(options);
  else
    this.curve = new curve_1.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: (hash_default()).sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: (hash_default()).sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: (hash_default()).sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: (hash_default()).sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: (hash_default()).sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: (hash_default()).sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: (hash_default()).sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/(null).crash();
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: (hash_default()).sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});
});

'use strict';





function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils_1.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils_1.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils_1.toArray(options.pers, options.persEnc || 'hex');
  minimalisticAssert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
var hmacDrbg = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new (hash_default()).hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils_1.toArray(entropy, entropyEnc);
  add = utils_1.toArray(add, addEnc);

  minimalisticAssert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils_1.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils_1.encode(res, enc);
};

'use strict';



var assert$3 = utils_1$1.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
var key = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new (bn_default())(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert$3(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert$3(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert$3(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

'use strict';




var assert$4 = utils_1$1.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert$4(options.r && options.s, 'Signature without r or s');
  this.r = new (bn_default())(options.r, 16);
  this.s = new (bn_default())(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
var signature = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils_1$1.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new (bn_default())(r);
  this.s = new (bn_default())(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils_1$1.encode(res, enc);
};

'use strict';





var rand = /*RicMoo:ethers:require(brorand)*/(function() { throw new Error('unsupported'); });
var assert$5 = utils_1$1.assert;




function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert$5(Object.prototype.hasOwnProperty.call(curves_1, options),
      'Unknown curve ' + options);

    options = curves_1[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves_1.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
var ec = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new key(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return key.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return key.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new hmacDrbg({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new (bn_default())(2));
  for (;;) {
    var priv = new (bn_default())(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new (bn_default())(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new hmacDrbg({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new (bn_default())(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new (bn_default())(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature$1, key, enc) {
  msg = this._truncateToN(new (bn_default())(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature$1 = new signature(signature$1, 'hex');

  // Perform primitive values validation
  var r = signature$1.r;
  var s = signature$1.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
  assert$5((3 & j) === j, 'The recovery param is more than two bits');
  signature$1 = new signature(signature$1, enc);

  var n = this.n;
  var e = new (bn_default())(msg);
  var r = signature$1.r;
  var s = signature$1.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature$1.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
  signature$1 = new signature(signature$1, enc);
  if (signature$1.recoveryParam !== null)
    return signature$1.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature$1, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};

var elliptic_1 = createCommonjsModule(function (module, exports) {
'use strict';

var elliptic = exports;

elliptic.version = /*RicMoo:ethers*/{ version: "6.5.4" }.version;
elliptic.utils = utils_1$1;
elliptic.rand = /*RicMoo:ethers:require(brorand)*/(function() { throw new Error('unsupported'); });
elliptic.curve = curve_1;
elliptic.curves = curves_1;

// Protocols
elliptic.ec = ec;
elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/(null);
});

var EC$1 = elliptic_1.ec;


//# sourceMappingURL=elliptic.js.map

// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var properties_lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/signing-key/lib.esm/_version.js
const version = "signing-key/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/signing-key/lib.esm/index.js






const logger = new logger_lib_esm.Logger(version);
let _curve = null;
function getCurve() {
    if (!_curve) {
        _curve = new EC$1("secp256k1");
    }
    return _curve;
}
class SigningKey {
    constructor(privateKey) {
        (0,properties_lib_esm.defineReadOnly)(this, "curve", "secp256k1");
        (0,properties_lib_esm.defineReadOnly)(this, "privateKey", (0,lib_esm.hexlify)(privateKey));
        if ((0,lib_esm.hexDataLength)(this.privateKey) !== 32) {
            logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        }
        const keyPair = getCurve().keyFromPrivate((0,lib_esm.arrayify)(this.privateKey));
        (0,properties_lib_esm.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0,properties_lib_esm.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0,properties_lib_esm.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = getCurve().keyFromPublic((0,lib_esm.arrayify)(this.publicKey));
        const p1 = getCurve().keyFromPublic((0,lib_esm.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = getCurve().keyFromPrivate((0,lib_esm.arrayify)(this.privateKey));
        const digestBytes = (0,lib_esm.arrayify)(digest);
        if (digestBytes.length !== 32) {
            logger.throwArgumentError("bad digest length", "digest", digest);
        }
        const signature = keyPair.sign(digestBytes, { canonical: true });
        return (0,lib_esm.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0,lib_esm.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0,lib_esm.hexZeroPad)("0x" + signature.s.toString(16), 32),
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = getCurve().keyFromPrivate((0,lib_esm.arrayify)(this.privateKey));
        const otherKeyPair = getCurve().keyFromPublic((0,lib_esm.arrayify)(computePublicKey(otherKey)));
        return (0,lib_esm.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function recoverPublicKey(digest, signature) {
    const sig = (0,lib_esm.splitSignature)(signature);
    const rs = { r: (0,lib_esm.arrayify)(sig.r), s: (0,lib_esm.arrayify)(sig.s) };
    return "0x" + getCurve().recoverPubKey((0,lib_esm.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function computePublicKey(key, compressed) {
    const bytes = (0,lib_esm.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new SigningKey(bytes);
        if (compressed) {
            return "0x" + getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        }
        return signingKey.publicKey;
    }
    else if (bytes.length === 33) {
        if (compressed) {
            return (0,lib_esm.hexlify)(bytes);
        }
        return "0x" + getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    }
    else if (bytes.length === 65) {
        if (!compressed) {
            return (0,lib_esm.hexlify)(bytes);
        }
        return "0x" + getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/solidity/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  keccak256: () => (/* binding */ keccak256),
  pack: () => (/* binding */ pack),
  sha256: () => (/* binding */ sha256)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/keccak256/lib.esm/index.js
var keccak256_lib_esm = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/sha2/lib.esm/sha2.js + 1 modules
var sha2 = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/sha2.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/strings/lib.esm/utf8.js + 1 modules
var utf8 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/solidity/lib.esm/_version.js
const version = "solidity/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/solidity/lib.esm/index.js






const regexBytes = new RegExp("^bytes([0-9]+)$");
const regexNumber = new RegExp("^(u?int)([0-9]*)$");
const regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const Zeros = "0000000000000000000000000000000000000000000000000000000000000000";


const logger = new logger_lib_esm.Logger(version);
function _pack(type, value, isArray) {
    switch (type) {
        case "address":
            if (isArray) {
                return (0,lib_esm.zeroPad)(value, 32);
            }
            return (0,lib_esm.arrayify)(value);
        case "string":
            return (0,utf8/* toUtf8Bytes */.Y0)(value);
        case "bytes":
            return (0,lib_esm.arrayify)(value);
        case "bool":
            value = (value ? "0x01" : "0x00");
            if (isArray) {
                return (0,lib_esm.zeroPad)(value, 32);
            }
            return (0,lib_esm.arrayify)(value);
    }
    let match = type.match(regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if ((match[2] && String(size) !== match[2]) || (size % 8 !== 0) || size === 0 || size > 256) {
            logger.throwArgumentError("invalid number type", "type", type);
        }
        if (isArray) {
            size = 256;
        }
        value = bignumber/* BigNumber.from */.O$.from(value).toTwos(size);
        return (0,lib_esm.zeroPad)(value, size / 8);
    }
    match = type.match(regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) {
            logger.throwArgumentError("invalid bytes type", "type", type);
        }
        if ((0,lib_esm.arrayify)(value).byteLength !== size) {
            logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        }
        if (isArray) {
            return (0,lib_esm.arrayify)((value + Zeros).substring(0, 66));
        }
        return value;
    }
    match = type.match(regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) {
            logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        }
        const result = [];
        value.forEach(function (value) {
            result.push(_pack(baseType, value, true));
        });
        return (0,lib_esm.concat)(result);
    }
    return logger.throwArgumentError("invalid type", "type", type);
}
// @TODO: Array Enum
function pack(types, values) {
    if (types.length != values.length) {
        logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    }
    const tight = [];
    types.forEach(function (type, index) {
        tight.push(_pack(type, values[index]));
    });
    return (0,lib_esm.hexlify)((0,lib_esm.concat)(tight));
}
function keccak256(types, values) {
    return (0,keccak256_lib_esm.keccak256)(pack(types, values));
}
function sha256(types, values) {
    return (0,sha2/* sha256 */.JQ)(pack(types, values));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/strings/lib.esm/bytes32.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: () => (/* binding */ parseBytes32String),
/* harmony export */   s: () => (/* binding */ formatBytes32String)
/* harmony export */ });
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/constants/lib.esm/hashes.js");
/* harmony import */ var _ethersproject_bytes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
/* harmony import */ var _utf8__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");




function formatBytes32String(text) {
    // Get the bytes
    const bytes = (0,_utf8__WEBPACK_IMPORTED_MODULE_0__/* .toUtf8Bytes */ .Y0)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) {
        throw new Error("bytes32 string must be less than 32 bytes");
    }
    // Zero-pad (implicitly null-terminates)
    return (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_1__.hexlify)((0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_1__.concat)([bytes, _ethersproject_constants__WEBPACK_IMPORTED_MODULE_2__/* .HashZero */ .R]).slice(0, 32));
}
function parseBytes32String(bytes) {
    const data = (0,_ethersproject_bytes__WEBPACK_IMPORTED_MODULE_1__.arrayify)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) {
        throw new Error("invalid bytes32 - not 32 bytes long");
    }
    if (data[31] !== 0) {
        throw new Error("invalid bytes32 string - no null terminator");
    }
    // Find the null termination
    let length = 31;
    while (data[length - 1] === 0) {
        length--;
    }
    // Determine the string value
    return (0,_utf8__WEBPACK_IMPORTED_MODULE_0__/* .toUtf8String */ .ZN)(data.slice(0, length));
}
//# sourceMappingURL=bytes32.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/strings/lib.esm/idna.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ll: () => (/* binding */ nameprep)
/* harmony export */ });
/* unused harmony exports _nameprepTableA1, _nameprepTableB2, _nameprepTableC */
/* harmony import */ var _utf8__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");


function bytes2(data) {
    if ((data.length % 4) !== 0) {
        throw new Error("bad data");
    }
    let result = [];
    for (let i = 0; i < data.length; i += 4) {
        result.push(parseInt(data.substring(i, i + 4), 16));
    }
    return result;
}
function createTable(data, func) {
    if (!func) {
        func = function (value) { return [parseInt(value, 16)]; };
    }
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair) => {
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v) => {
        let comps = v.split("-");
        if (comps.length === 1) {
            comps[1] = "0";
        }
        else if (comps[1] === "") {
            comps[1] = "1";
        }
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return { l: lo, h: hi };
    });
}
function matchMap(value, ranges) {
    let lo = 0;
    for (let i = 0; i < ranges.length; i++) {
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && ((value - lo) % (range.d || 1)) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) {
                continue;
            }
            return range;
        }
    }
    return null;
}
const Table_A_1_ranges = createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v) => parseInt(v, 16));
const Table_B_2_ranges = [
    { h: 25, s: 32, l: 65 },
    { h: 30, s: 32, e: [23], l: 127 },
    { h: 54, s: 1, e: [48], l: 64, d: 2 },
    { h: 14, s: 1, l: 57, d: 2 },
    { h: 44, s: 1, l: 17, d: 2 },
    { h: 10, s: 1, e: [2, 6, 8], l: 61, d: 2 },
    { h: 16, s: 1, l: 68, d: 2 },
    { h: 84, s: 1, e: [18, 24, 66], l: 19, d: 2 },
    { h: 26, s: 32, e: [17], l: 435 },
    { h: 22, s: 1, l: 71, d: 2 },
    { h: 15, s: 80, l: 40 },
    { h: 31, s: 32, l: 16 },
    { h: 32, s: 1, l: 80, d: 2 },
    { h: 52, s: 1, l: 42, d: 2 },
    { h: 12, s: 1, l: 55, d: 2 },
    { h: 40, s: 1, e: [38], l: 15, d: 2 },
    { h: 14, s: 1, l: 48, d: 2 },
    { h: 37, s: 48, l: 49 },
    { h: 148, s: 1, l: 6351, d: 2 },
    { h: 88, s: 1, l: 160, d: 2 },
    { h: 15, s: 16, l: 704 },
    { h: 25, s: 26, l: 854 },
    { h: 25, s: 32, l: 55915 },
    { h: 37, s: 40, l: 1247 },
    { h: 25, s: -119711, l: 53248 },
    { h: 25, s: -119763, l: 52 },
    { h: 25, s: -119815, l: 52 },
    { h: 25, s: -119867, e: [1, 4, 5, 7, 8, 11, 12, 17], l: 52 },
    { h: 25, s: -119919, l: 52 },
    { h: 24, s: -119971, e: [2, 7, 8, 17], l: 52 },
    { h: 24, s: -120023, e: [2, 7, 13, 15, 16, 17], l: 52 },
    { h: 25, s: -120075, l: 52 },
    { h: 25, s: -120127, l: 52 },
    { h: 25, s: -120179, l: 52 },
    { h: 25, s: -120231, l: 52 },
    { h: 25, s: -120283, l: 52 },
    { h: 25, s: -120335, l: 52 },
    { h: 24, s: -119543, e: [17], l: 56 },
    { h: 24, s: -119601, e: [17], l: 58 },
    { h: 24, s: -119659, e: [17], l: 58 },
    { h: 24, s: -119717, e: [17], l: 58 },
    { h: 24, s: -119775, e: [17], l: 58 }
];
const Table_B_2_lut_abs = createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const Table_B_2_lut_rel = createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const Table_B_2_complex = createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", bytes2);
const Table_C_ranges = createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function flatten(values) {
    return values.reduce((accum, value) => {
        value.forEach((value) => { accum.push(value); });
        return accum;
    }, []);
}
function _nameprepTableA1(codepoint) {
    return !!matchMap(codepoint, Table_A_1_ranges);
}
function _nameprepTableB2(codepoint) {
    let range = matchMap(codepoint, Table_B_2_ranges);
    if (range) {
        return [codepoint + range.s];
    }
    let codes = Table_B_2_lut_abs[codepoint];
    if (codes) {
        return codes;
    }
    let shift = Table_B_2_lut_rel[codepoint];
    if (shift) {
        return [codepoint + shift[0]];
    }
    let complex = Table_B_2_complex[codepoint];
    if (complex) {
        return complex;
    }
    return null;
}
function _nameprepTableC(codepoint) {
    return !!matchMap(codepoint, Table_C_ranges);
}
function nameprep(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) {
        return value.toLowerCase();
    }
    // Get the code points (keeping the current normalization)
    let codes = (0,_utf8__WEBPACK_IMPORTED_MODULE_0__/* .toUtf8CodePoints */ .XL)(value);
    codes = flatten(codes.map((code) => {
        // Substitute Table B.1 (Maps to Nothing)
        if (Table_B_1_flags.indexOf(code) >= 0) {
            return [];
        }
        if (code >= 0xfe00 && code <= 0xfe0f) {
            return [];
        }
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = _nameprepTableB2(code);
        if (codesTableB2) {
            return codesTableB2;
        }
        // No Substitution
        return [code];
    }));
    // Normalize using form KC
    codes = (0,_utf8__WEBPACK_IMPORTED_MODULE_0__/* .toUtf8CodePoints */ .XL)((0,_utf8__WEBPACK_IMPORTED_MODULE_0__/* ._toUtf8String */ .uu)(codes), _utf8__WEBPACK_IMPORTED_MODULE_0__/* .UnicodeNormalizationForm.NFKC */ .Uj.NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code) => {
        if (_nameprepTableC(code)) {
            throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
        }
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code) => {
        if (_nameprepTableA1(code)) {
            throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
        }
    });
    // IDNA extras
    let name = (0,_utf8__WEBPACK_IMPORTED_MODULE_0__/* ._toUtf8String */ .uu)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") {
        throw new Error("invalid hyphen");
    }
    return name;
}
//# sourceMappingURL=idna.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/strings/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UnicodeNormalizationForm: () => (/* reexport safe */ _utf8__WEBPACK_IMPORTED_MODULE_0__.Uj),
/* harmony export */   Utf8ErrorFuncs: () => (/* reexport safe */ _utf8__WEBPACK_IMPORTED_MODULE_0__.te),
/* harmony export */   Utf8ErrorReason: () => (/* reexport safe */ _utf8__WEBPACK_IMPORTED_MODULE_0__.Uw),
/* harmony export */   _toEscapedUtf8String: () => (/* reexport safe */ _utf8__WEBPACK_IMPORTED_MODULE_0__.U$),
/* harmony export */   formatBytes32String: () => (/* reexport safe */ _bytes32__WEBPACK_IMPORTED_MODULE_1__.s),
/* harmony export */   nameprep: () => (/* reexport safe */ _idna__WEBPACK_IMPORTED_MODULE_2__.Ll),
/* harmony export */   parseBytes32String: () => (/* reexport safe */ _bytes32__WEBPACK_IMPORTED_MODULE_1__.F),
/* harmony export */   toUtf8Bytes: () => (/* reexport safe */ _utf8__WEBPACK_IMPORTED_MODULE_0__.Y0),
/* harmony export */   toUtf8CodePoints: () => (/* reexport safe */ _utf8__WEBPACK_IMPORTED_MODULE_0__.XL),
/* harmony export */   toUtf8String: () => (/* reexport safe */ _utf8__WEBPACK_IMPORTED_MODULE_0__.ZN)
/* harmony export */ });
/* harmony import */ var _bytes32__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/bytes32.js");
/* harmony import */ var _idna__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/idna.js");
/* harmony import */ var _utf8__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");





//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/strings/lib.esm/utf8.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Uj: () => (/* binding */ UnicodeNormalizationForm),
  te: () => (/* binding */ Utf8ErrorFuncs),
  Uw: () => (/* binding */ Utf8ErrorReason),
  U$: () => (/* binding */ _toEscapedUtf8String),
  uu: () => (/* binding */ _toUtf8String),
  Y0: () => (/* binding */ toUtf8Bytes),
  XL: () => (/* binding */ toUtf8CodePoints),
  ZN: () => (/* binding */ toUtf8String)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/strings/lib.esm/_version.js
const version = "strings/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/strings/lib.esm/utf8.js




const logger = new logger_lib_esm.Logger(version);
///////////////////////////////
var UnicodeNormalizationForm;
(function (UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})(UnicodeNormalizationForm || (UnicodeNormalizationForm = {}));
;
var Utf8ErrorReason;
(function (Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})(Utf8ErrorReason || (Utf8ErrorReason = {}));
;
function errorFunc(reason, offset, bytes, output, badCodepoint) {
    return logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === Utf8ErrorReason.BAD_PREFIX || reason === Utf8ErrorReason.UNEXPECTED_CONTINUE) {
        let i = 0;
        for (let o = offset + 1; o < bytes.length; o++) {
            if (bytes[o] >> 6 !== 0x02) {
                break;
            }
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === Utf8ErrorReason.OVERRUN) {
        return bytes.length - offset - 1;
    }
    // Nothing to skip
    return 0;
}
function replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === Utf8ErrorReason.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
// Common error handing strategies
const Utf8ErrorFuncs = Object.freeze({
    error: errorFunc,
    ignore: ignoreFunc,
    replace: replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function getUtf8CodePoints(bytes, onError) {
    if (onError == null) {
        onError = Utf8ErrorFuncs.error;
    }
    bytes = (0,lib_esm.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while (i < bytes.length) {
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
            // 1110 xxxx 10xx xxxx 10xx xxxx
        }
        else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
            // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        }
        else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        }
        else {
            if ((c & 0xc0) === 0x80) {
                i += onError(Utf8ErrorReason.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            }
            else {
                i += onError(Utf8ErrorReason.BAD_PREFIX, i - 1, bytes, result);
            }
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError(Utf8ErrorReason.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & ((1 << (8 - extraLength - 1)) - 1);
        for (let j = 0; j < extraLength; j++) {
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError(Utf8ErrorReason.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            ;
            res = (res << 6) | (nextChar & 0x3f);
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) {
            continue;
        }
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError(Utf8ErrorReason.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError(Utf8ErrorReason.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError(Utf8ErrorReason.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
// http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
function toUtf8Bytes(str, form = UnicodeNormalizationForm.current) {
    if (form != UnicodeNormalizationForm.current) {
        logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for (let i = 0; i < str.length; i++) {
        const c = str.charCodeAt(i);
        if (c < 0x80) {
            result.push(c);
        }
        else if (c < 0x800) {
            result.push((c >> 6) | 0xc0);
            result.push((c & 0x3f) | 0x80);
        }
        else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) {
                throw new Error("invalid utf-8 string");
            }
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push((pair >> 18) | 0xf0);
            result.push(((pair >> 12) & 0x3f) | 0x80);
            result.push(((pair >> 6) & 0x3f) | 0x80);
            result.push((pair & 0x3f) | 0x80);
        }
        else {
            result.push((c >> 12) | 0xe0);
            result.push(((c >> 6) & 0x3f) | 0x80);
            result.push((c & 0x3f) | 0x80);
        }
    }
    return (0,lib_esm.arrayify)(result);
}
;
function escapeChar(value) {
    const hex = ("0000" + value.toString(16));
    return "\\u" + hex.substring(hex.length - 4);
}
function _toEscapedUtf8String(bytes, onError) {
    return '"' + getUtf8CodePoints(bytes, onError).map((codePoint) => {
        if (codePoint < 256) {
            switch (codePoint) {
                case 8: return "\\b";
                case 9: return "\\t";
                case 10: return "\\n";
                case 13: return "\\r";
                case 34: return "\\\"";
                case 92: return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) {
                return String.fromCharCode(codePoint);
            }
        }
        if (codePoint <= 0xffff) {
            return escapeChar(codePoint);
        }
        codePoint -= 0x10000;
        return escapeChar(((codePoint >> 10) & 0x3ff) + 0xd800) + escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function _toUtf8String(codePoints) {
    return codePoints.map((codePoint) => {
        if (codePoint <= 0xffff) {
            return String.fromCharCode(codePoint);
        }
        codePoint -= 0x10000;
        return String.fromCharCode((((codePoint >> 10) & 0x3ff) + 0xd800), ((codePoint & 0x3ff) + 0xdc00));
    }).join("");
}
function toUtf8String(bytes, onError) {
    return _toUtf8String(getUtf8CodePoints(bytes, onError));
}
function toUtf8CodePoints(str, form = UnicodeNormalizationForm.current) {
    return getUtf8CodePoints(toUtf8Bytes(str, form));
}
//# sourceMappingURL=utf8.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/transactions/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  TransactionTypes: () => (/* binding */ TransactionTypes),
  accessListify: () => (/* binding */ accessListify),
  computeAddress: () => (/* binding */ computeAddress),
  parse: () => (/* binding */ parse),
  recoverAddress: () => (/* binding */ recoverAddress),
  serialize: () => (/* binding */ serialize)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/address/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var bytes_lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__("../../node_modules/@ethersproject/constants/lib.esm/bignumbers.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/keccak256/lib.esm/index.js
var keccak256_lib_esm = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var properties_lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/rlp/lib.esm/index.js + 1 modules
var rlp_lib_esm = __webpack_require__("../../node_modules/@ethersproject/rlp/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/signing-key/lib.esm/index.js + 2 modules
var signing_key_lib_esm = __webpack_require__("../../node_modules/@ethersproject/signing-key/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/transactions/lib.esm/_version.js
const version = "transactions/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/transactions/lib.esm/index.js











const logger = new logger_lib_esm.Logger(version);
var TransactionTypes;
(function (TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})(TransactionTypes || (TransactionTypes = {}));
;
///////////////////////////////
function handleAddress(value) {
    if (value === "0x") {
        return null;
    }
    return (0,lib_esm.getAddress)(value);
}
function handleNumber(value) {
    if (value === "0x") {
        return bignumbers/* Zero */._Y;
    }
    return bignumber/* BigNumber.from */.O$.from(value);
}
// Legacy Transaction Fields
const transactionFields = [
    { name: "nonce", maxLength: 32, numeric: true },
    { name: "gasPrice", maxLength: 32, numeric: true },
    { name: "gasLimit", maxLength: 32, numeric: true },
    { name: "to", length: 20 },
    { name: "value", maxLength: 32, numeric: true },
    { name: "data" },
];
const allowedTransactionKeys = {
    chainId: true, data: true, gasLimit: true, gasPrice: true, nonce: true, to: true, type: true, value: true
};
function computeAddress(key) {
    const publicKey = (0,signing_key_lib_esm.computePublicKey)(key);
    return (0,lib_esm.getAddress)((0,bytes_lib_esm.hexDataSlice)((0,keccak256_lib_esm.keccak256)((0,bytes_lib_esm.hexDataSlice)(publicKey, 1)), 12));
}
function recoverAddress(digest, signature) {
    return computeAddress((0,signing_key_lib_esm.recoverPublicKey)((0,bytes_lib_esm.arrayify)(digest), signature));
}
function formatNumber(value, name) {
    const result = (0,bytes_lib_esm.stripZeros)(bignumber/* BigNumber.from */.O$.from(value).toHexString());
    if (result.length > 32) {
        logger.throwArgumentError("invalid length for " + name, ("transaction:" + name), value);
    }
    return result;
}
function accessSetify(addr, storageKeys) {
    return {
        address: (0,lib_esm.getAddress)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index) => {
            if ((0,bytes_lib_esm.hexDataLength)(storageKey) !== 32) {
                logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            }
            return storageKey.toLowerCase();
        })
    };
}
function accessListify(value) {
    if (Array.isArray(value)) {
        return value.map((set, index) => {
            if (Array.isArray(set)) {
                if (set.length > 2) {
                    logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
                }
                return accessSetify(set[0], set[1]);
            }
            return accessSetify(set.address, set.storageKeys);
        });
    }
    const result = Object.keys(value).map((addr) => {
        const storageKeys = value[addr].reduce((accum, storageKey) => {
            accum[storageKey] = true;
            return accum;
        }, {});
        return accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b) => (a.address.localeCompare(b.address)));
    return result;
}
function formatAccessList(value) {
    return accessListify(value).map((set) => [set.address, set.storageKeys]);
}
function _serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = bignumber/* BigNumber.from */.O$.from(transaction.gasPrice);
        const maxFeePerGas = bignumber/* BigNumber.from */.O$.from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) {
            logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
                gasPrice, maxFeePerGas
            });
        }
    }
    const fields = [
        formatNumber(transaction.chainId || 0, "chainId"),
        formatNumber(transaction.nonce || 0, "nonce"),
        formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        formatNumber(transaction.gasLimit || 0, "gasLimit"),
        ((transaction.to != null) ? (0,lib_esm.getAddress)(transaction.to) : "0x"),
        formatNumber(transaction.value || 0, "value"),
        (transaction.data || "0x"),
        (formatAccessList(transaction.accessList || []))
    ];
    if (signature) {
        const sig = (0,bytes_lib_esm.splitSignature)(signature);
        fields.push(formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0,bytes_lib_esm.stripZeros)(sig.r));
        fields.push((0,bytes_lib_esm.stripZeros)(sig.s));
    }
    return (0,bytes_lib_esm.hexConcat)(["0x02", rlp_lib_esm.encode(fields)]);
}
function _serializeEip2930(transaction, signature) {
    const fields = [
        formatNumber(transaction.chainId || 0, "chainId"),
        formatNumber(transaction.nonce || 0, "nonce"),
        formatNumber(transaction.gasPrice || 0, "gasPrice"),
        formatNumber(transaction.gasLimit || 0, "gasLimit"),
        ((transaction.to != null) ? (0,lib_esm.getAddress)(transaction.to) : "0x"),
        formatNumber(transaction.value || 0, "value"),
        (transaction.data || "0x"),
        (formatAccessList(transaction.accessList || []))
    ];
    if (signature) {
        const sig = (0,bytes_lib_esm.splitSignature)(signature);
        fields.push(formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0,bytes_lib_esm.stripZeros)(sig.r));
        fields.push((0,bytes_lib_esm.stripZeros)(sig.s));
    }
    return (0,bytes_lib_esm.hexConcat)(["0x01", rlp_lib_esm.encode(fields)]);
}
// Legacy Transactions and EIP-155
function _serialize(transaction, signature) {
    (0,properties_lib_esm.checkProperties)(transaction, allowedTransactionKeys);
    const raw = [];
    transactionFields.forEach(function (fieldInfo) {
        let value = transaction[fieldInfo.name] || ([]);
        const options = {};
        if (fieldInfo.numeric) {
            options.hexPad = "left";
        }
        value = (0,bytes_lib_esm.arrayify)((0,bytes_lib_esm.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) {
            logger.throwArgumentError("invalid length for " + fieldInfo.name, ("transaction:" + fieldInfo.name), value);
        }
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0,bytes_lib_esm.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) {
                logger.throwArgumentError("invalid length for " + fieldInfo.name, ("transaction:" + fieldInfo.name), value);
            }
        }
        raw.push((0,bytes_lib_esm.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof (chainId) !== "number") {
            logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
        }
    }
    else if (signature && !(0,bytes_lib_esm.isBytesLike)(signature) && signature.v > 28) {
        // No chainId provided, but the signature is signing with EIP-155; derive chainId
        chainId = Math.floor((signature.v - 35) / 2);
    }
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0,bytes_lib_esm.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) {
        return rlp_lib_esm.encode(raw);
    }
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0,bytes_lib_esm.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) {
            logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
        }
    }
    else if (sig.v !== v) {
        logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    }
    raw.push((0,bytes_lib_esm.hexlify)(v));
    raw.push((0,bytes_lib_esm.stripZeros)((0,bytes_lib_esm.arrayify)(sig.r)));
    raw.push((0,bytes_lib_esm.stripZeros)((0,bytes_lib_esm.arrayify)(sig.s)));
    return rlp_lib_esm.encode(raw);
}
function serialize(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) {
            logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        }
        return _serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch (transaction.type) {
        case 1:
            return _serializeEip2930(transaction, signature);
        case 2:
            return _serializeEip1559(transaction, signature);
        default:
            break;
    }
    return logger.throwError(`unsupported transaction type: ${transaction.type}`, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function _parseEipSignature(tx, fields, serialize) {
    try {
        const recid = handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) {
            throw new Error("bad recid");
        }
        tx.v = recid;
    }
    catch (error) {
        logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0,bytes_lib_esm.hexZeroPad)(fields[1], 32);
    tx.s = (0,bytes_lib_esm.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0,keccak256_lib_esm.keccak256)(serialize(tx));
        tx.from = recoverAddress(digest, { r: tx.r, s: tx.s, recoveryParam: tx.v });
    }
    catch (error) { }
}
function _parseEip1559(payload) {
    const transaction = rlp_lib_esm.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) {
        logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0,bytes_lib_esm.hexlify)(payload));
    }
    const maxPriorityFeePerGas = handleNumber(transaction[2]);
    const maxFeePerGas = handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: handleNumber(transaction[0]).toNumber(),
        nonce: handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: handleNumber(transaction[4]),
        to: handleAddress(transaction[5]),
        value: handleNumber(transaction[6]),
        data: transaction[7],
        accessList: accessListify(transaction[8]),
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) {
        return tx;
    }
    tx.hash = (0,keccak256_lib_esm.keccak256)(payload);
    _parseEipSignature(tx, transaction.slice(9), _serializeEip1559);
    return tx;
}
function _parseEip2930(payload) {
    const transaction = rlp_lib_esm.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) {
        logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0,bytes_lib_esm.hexlify)(payload));
    }
    const tx = {
        type: 1,
        chainId: handleNumber(transaction[0]).toNumber(),
        nonce: handleNumber(transaction[1]).toNumber(),
        gasPrice: handleNumber(transaction[2]),
        gasLimit: handleNumber(transaction[3]),
        to: handleAddress(transaction[4]),
        value: handleNumber(transaction[5]),
        data: transaction[6],
        accessList: accessListify(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) {
        return tx;
    }
    tx.hash = (0,keccak256_lib_esm.keccak256)(payload);
    _parseEipSignature(tx, transaction.slice(8), _serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function _parse(rawTransaction) {
    const transaction = rlp_lib_esm.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) {
        logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    }
    const tx = {
        nonce: handleNumber(transaction[0]).toNumber(),
        gasPrice: handleNumber(transaction[1]),
        gasLimit: handleNumber(transaction[2]),
        to: handleAddress(transaction[3]),
        value: handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) {
        return tx;
    }
    try {
        tx.v = bignumber/* BigNumber.from */.O$.from(transaction[6]).toNumber();
    }
    catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0,bytes_lib_esm.hexZeroPad)(transaction[7], 32);
    tx.s = (0,bytes_lib_esm.hexZeroPad)(transaction[8], 32);
    if (bignumber/* BigNumber.from */.O$.from(tx.r).isZero() && bignumber/* BigNumber.from */.O$.from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    }
    else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) {
            tx.chainId = 0;
        }
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0,bytes_lib_esm.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0,keccak256_lib_esm.keccak256)(rlp_lib_esm.encode(raw));
        try {
            tx.from = recoverAddress(digest, { r: (0,bytes_lib_esm.hexlify)(tx.r), s: (0,bytes_lib_esm.hexlify)(tx.s), recoveryParam: recoveryParam });
        }
        catch (error) { }
        tx.hash = (0,keccak256_lib_esm.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function parse(rawTransaction) {
    const payload = (0,bytes_lib_esm.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) {
        return _parse(payload);
    }
    // Typed Transaction (EIP-2718)
    switch (payload[0]) {
        case 1:
            return _parseEip2930(payload);
        case 2:
            return _parseEip1559(payload);
        default:
            break;
    }
    return logger.throwError(`unsupported transaction type: ${payload[0]}`, logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/units/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  commify: () => (/* binding */ commify),
  formatEther: () => (/* binding */ formatEther),
  formatUnits: () => (/* binding */ formatUnits),
  parseEther: () => (/* binding */ parseEther),
  parseUnits: () => (/* binding */ parseUnits)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js
var fixednumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/units/lib.esm/_version.js
const version = "units/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/units/lib.esm/index.js




const logger = new lib_esm.Logger(version);
const names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether",
];
// Some environments have issues with RegEx that contain back-tracking, so we cannot
// use them.
function commify(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || (comps[1] && !comps[1].match(/^[0-9]*$/)) || value === "." || value === "-.") {
        logger.throwArgumentError("invalid value", "value", value);
    }
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while (whole.substring(0, 1) === "0") {
        whole = whole.substring(1);
    }
    if (whole === "") {
        whole = "0";
    }
    let suffix = "";
    if (comps.length === 2) {
        suffix = "." + (comps[1] || "0");
    }
    while (suffix.length > 2 && suffix[suffix.length - 1] === "0") {
        suffix = suffix.substring(0, suffix.length - 1);
    }
    const formatted = [];
    while (whole.length) {
        if (whole.length <= 3) {
            formatted.unshift(whole);
            break;
        }
        else {
            const index = whole.length - 3;
            formatted.unshift(whole.substring(index));
            whole = whole.substring(0, index);
        }
    }
    return negative + formatted.join(",") + suffix;
}
function formatUnits(value, unitName) {
    if (typeof (unitName) === "string") {
        const index = names.indexOf(unitName);
        if (index !== -1) {
            unitName = 3 * index;
        }
    }
    return (0,fixednumber/* formatFixed */.S5)(value, (unitName != null) ? unitName : 18);
}
function parseUnits(value, unitName) {
    if (typeof (value) !== "string") {
        logger.throwArgumentError("value must be a string", "value", value);
    }
    if (typeof (unitName) === "string") {
        const index = names.indexOf(unitName);
        if (index !== -1) {
            unitName = 3 * index;
        }
    }
    return (0,fixednumber/* parseFixed */.Ox)(value, (unitName != null) ? unitName : 18);
}
function formatEther(wei) {
    return formatUnits(wei, 18);
}
function parseEther(ether) {
    return parseUnits(ether, 18);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/wallet/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Wallet: () => (/* binding */ Wallet),
  verifyMessage: () => (/* binding */ verifyMessage),
  verifyTypedData: () => (/* binding */ verifyTypedData)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/address/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abstract-provider/lib.esm/index.js + 1 modules
var abstract_provider_lib_esm = __webpack_require__("../../node_modules/@ethersproject/abstract-provider/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abstract-signer/lib.esm/index.js + 1 modules
var abstract_signer_lib_esm = __webpack_require__("../../node_modules/@ethersproject/abstract-signer/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var bytes_lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hash/lib.esm/message.js
var lib_esm_message = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/message.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hash/lib.esm/typed-data.js
var typed_data = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/typed-data.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hdnode/lib.esm/index.js + 1 modules
var hdnode_lib_esm = __webpack_require__("../../node_modules/@ethersproject/hdnode/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/keccak256/lib.esm/index.js
var keccak256_lib_esm = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var properties_lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/random/lib.esm/random.js + 1 modules
var random = __webpack_require__("../../node_modules/@ethersproject/random/lib.esm/random.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/signing-key/lib.esm/index.js + 2 modules
var signing_key_lib_esm = __webpack_require__("../../node_modules/@ethersproject/signing-key/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/json-wallets/lib.esm/keystore.js
var keystore = __webpack_require__("../../node_modules/@ethersproject/json-wallets/lib.esm/keystore.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/json-wallets/lib.esm/index.js + 1 modules
var json_wallets_lib_esm = __webpack_require__("../../node_modules/@ethersproject/json-wallets/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/transactions/lib.esm/index.js + 1 modules
var transactions_lib_esm = __webpack_require__("../../node_modules/@ethersproject/transactions/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/wallet/lib.esm/_version.js
const version = "wallet/5.7.0";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/wallet/lib.esm/index.js

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};














const logger = new logger_lib_esm.Logger(version);
function isAccount(value) {
    return (value != null && (0,bytes_lib_esm.isHexString)(value.privateKey, 32) && value.address != null);
}
function hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return (mnemonic && mnemonic.phrase);
}
class Wallet extends abstract_signer_lib_esm/* Signer */.E {
    constructor(privateKey, provider) {
        super();
        if (isAccount(privateKey)) {
            const signingKey = new signing_key_lib_esm.SigningKey(privateKey.privateKey);
            (0,properties_lib_esm.defineReadOnly)(this, "_signingKey", () => signingKey);
            (0,properties_lib_esm.defineReadOnly)(this, "address", (0,transactions_lib_esm.computeAddress)(this.publicKey));
            if (this.address !== (0,lib_esm.getAddress)(privateKey.address)) {
                logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            }
            if (hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0,properties_lib_esm.defineReadOnly)(this, "_mnemonic", () => ({
                    phrase: srcMnemonic.phrase,
                    path: srcMnemonic.path || hdnode_lib_esm.defaultPath,
                    locale: srcMnemonic.locale || "en"
                }));
                const mnemonic = this.mnemonic;
                const node = hdnode_lib_esm.HDNode.fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0,transactions_lib_esm.computeAddress)(node.privateKey) !== this.address) {
                    logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
                }
            }
            else {
                (0,properties_lib_esm.defineReadOnly)(this, "_mnemonic", () => null);
            }
        }
        else {
            if (signing_key_lib_esm.SigningKey.isSigningKey(privateKey)) {
                /* istanbul ignore if */
                if (privateKey.curve !== "secp256k1") {
                    logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                }
                (0,properties_lib_esm.defineReadOnly)(this, "_signingKey", () => privateKey);
            }
            else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof (privateKey) === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) {
                        privateKey = "0x" + privateKey;
                    }
                }
                const signingKey = new signing_key_lib_esm.SigningKey(privateKey);
                (0,properties_lib_esm.defineReadOnly)(this, "_signingKey", () => signingKey);
            }
            (0,properties_lib_esm.defineReadOnly)(this, "_mnemonic", () => null);
            (0,properties_lib_esm.defineReadOnly)(this, "address", (0,transactions_lib_esm.computeAddress)(this.publicKey));
        }
        /* istanbul ignore if */
        if (provider && !abstract_provider_lib_esm/* Provider.isProvider */.zt.isProvider(provider)) {
            logger.throwArgumentError("invalid provider", "provider", provider);
        }
        (0,properties_lib_esm.defineReadOnly)(this, "provider", provider || null);
    }
    get mnemonic() { return this._mnemonic(); }
    get privateKey() { return this._signingKey().privateKey; }
    get publicKey() { return this._signingKey().publicKey; }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new Wallet(this, provider);
    }
    signTransaction(transaction) {
        return (0,properties_lib_esm.resolveProperties)(transaction).then((tx) => {
            if (tx.from != null) {
                if ((0,lib_esm.getAddress)(tx.from) !== this.address) {
                    logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                }
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0,keccak256_lib_esm.keccak256)((0,transactions_lib_esm.serialize)(tx)));
            return (0,transactions_lib_esm.serialize)(tx, signature);
        });
    }
    signMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0,bytes_lib_esm.joinSignature)(this._signingKey().signDigest((0,lib_esm_message/* hashMessage */.r)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return __awaiter(this, void 0, void 0, function* () {
            // Populate any ENS names
            const populated = yield typed_data/* TypedDataEncoder.resolveNames */.E.resolveNames(domain, types, value, (name) => {
                if (this.provider == null) {
                    logger.throwError("cannot resolve ENS names without a provider", logger_lib_esm.Logger.errors.UNSUPPORTED_OPERATION, {
                        operation: "resolveName",
                        value: name
                    });
                }
                return this.provider.resolveName(name);
            });
            return (0,bytes_lib_esm.joinSignature)(this._signingKey().signDigest(typed_data/* TypedDataEncoder.hash */.E.hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof (options) === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof (progressCallback) !== "function") {
            throw new Error("invalid callback");
        }
        if (!options) {
            options = {};
        }
        return (0,keystore/* encrypt */.HI)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */
    static createRandom(options) {
        let entropy = (0,random/* randomBytes */.O)(16);
        if (!options) {
            options = {};
        }
        if (options.extraEntropy) {
            entropy = (0,bytes_lib_esm.arrayify)((0,bytes_lib_esm.hexDataSlice)((0,keccak256_lib_esm.keccak256)((0,bytes_lib_esm.concat)([entropy, options.extraEntropy])), 0, 16));
        }
        const mnemonic = (0,hdnode_lib_esm.entropyToMnemonic)(entropy, options.locale);
        return Wallet.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0,json_wallets_lib_esm.decryptJsonWallet)(json, password, progressCallback).then((account) => {
            return new Wallet(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new Wallet((0,json_wallets_lib_esm.decryptJsonWalletSync)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) {
            path = hdnode_lib_esm.defaultPath;
        }
        return new Wallet(hdnode_lib_esm.HDNode.fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function verifyMessage(message, signature) {
    return (0,transactions_lib_esm.recoverAddress)((0,lib_esm_message/* hashMessage */.r)(message), signature);
}
function verifyTypedData(domain, types, value, signature) {
    return (0,transactions_lib_esm.recoverAddress)(typed_data/* TypedDataEncoder.hash */.E.hash(domain, types, value), signature);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/web/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  _fetchData: () => (/* binding */ _fetchData),
  fetchJson: () => (/* binding */ fetchJson),
  poll: () => (/* binding */ poll)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/base64/lib.esm/base64.js
var base64 = __webpack_require__("../../node_modules/@ethersproject/base64/lib.esm/base64.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var properties_lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/strings/lib.esm/utf8.js + 1 modules
var utf8 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/web/lib.esm/_version.js
const version = "web/5.7.1";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/web/lib.esm/geturl.js

var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

function getUrl(href, options) {
    return __awaiter(this, void 0, void 0, function* () {
        if (options == null) {
            options = {};
        }
        const request = {
            method: (options.method || "GET"),
            headers: (options.headers || {}),
            body: (options.body || undefined),
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        ;
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) {
                request.mode = (opts.mode);
            }
            if (opts.cache) {
                request.cache = (opts.cache);
            }
            if (opts.credentials) {
                request.credentials = (opts.credentials);
            }
            if (opts.redirect) {
                request.redirect = (opts.redirect);
            }
            if (opts.referrer) {
                request.referrer = opts.referrer;
            }
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) {
            response.headers.forEach((value, key) => {
                headers[key.toLowerCase()] = value;
            });
        }
        else {
            ((response.headers).keys)().forEach((key) => {
                headers[key.toLowerCase()] = response.headers.get(key);
            });
        }
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0,lib_esm.arrayify)(new Uint8Array(body)),
        };
    });
}
//# sourceMappingURL=geturl.js.map
;// CONCATENATED MODULE: ../../node_modules/@ethersproject/web/lib.esm/index.js

var lib_esm_awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






const logger = new logger_lib_esm.Logger(version);

function staller(duration) {
    return new Promise((resolve) => {
        setTimeout(resolve, duration);
    });
}
function bodyify(value, type) {
    if (value == null) {
        return null;
    }
    if (typeof (value) === "string") {
        return value;
    }
    if ((0,lib_esm.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) {
            try {
                return (0,utf8/* toUtf8String */.ZN)(value);
            }
            catch (error) { }
            ;
        }
        return (0,lib_esm.hexlify)(value);
    }
    return value;
}
function unpercent(value) {
    return (0,utf8/* toUtf8Bytes */.Y0)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code) => {
        return String.fromCharCode(parseInt(code, 16));
    }));
}
// This API is still a work in progress; the future changes will likely be:
// - ConnectionInfo => FetchDataRequest<T = any>
// - FetchDataRequest.body? = string | Uint8Array | { contentType: string, data: string | Uint8Array }
//   - If string => text/plain, Uint8Array => application/octet-stream (if content-type unspecified)
// - FetchDataRequest.processFunc = (body: Uint8Array, response: FetchDataResponse) => T
// For this reason, it should be considered internal until the API is finalized
function _fetchData(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = (typeof (connection) === "object" && connection.throttleLimit != null) ? connection.throttleLimit : 12;
    logger.assertArgument((attemptLimit > 0 && (attemptLimit % 1) === 0), "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = ((typeof (connection) === "object") ? connection.throttleCallback : null);
    const throttleSlotInterval = ((typeof (connection) === "object" && typeof (connection.throttleSlotInterval) === "number") ? connection.throttleSlotInterval : 100);
    logger.assertArgument((throttleSlotInterval > 0 && (throttleSlotInterval % 1) === 0), "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = ((typeof (connection) === "object") ? !!(connection.errorPassThrough) : false);
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET",
    };
    let allow304 = false;
    let timeout = 2 * 60 * 1000;
    if (typeof (connection) === "string") {
        url = connection;
    }
    else if (typeof (connection) === "object") {
        if (connection == null || connection.url == null) {
            logger.throwArgumentError("missing URL", "connection.url", connection);
        }
        url = connection.url;
        if (typeof (connection.timeout) === "number" && connection.timeout > 0) {
            timeout = connection.timeout;
        }
        if (connection.headers) {
            for (const key in connection.headers) {
                headers[key.toLowerCase()] = { key: key, value: String(connection.headers[key]) };
                if (["if-none-match", "if-modified-since"].indexOf(key.toLowerCase()) >= 0) {
                    allow304 = true;
                }
            }
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) {
                logger.throwError("basic authentication requires a secure https url", logger_lib_esm.Logger.errors.INVALID_ARGUMENT, { argument: "url", url: url, user: connection.user, password: "[REDACTED]" });
            }
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0,base64/* encode */.c)((0,utf8/* toUtf8Bytes */.Y0)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) {
            options.skipFetchSetup = !!connection.skipFetchSetup;
        }
        if (connection.fetchOptions != null) {
            options.fetchOptions = (0,properties_lib_esm.shallowCopy)(connection.fetchOptions);
        }
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = ((url) ? url.match(reData) : null);
    if (dataMatch) {
        try {
            const response = {
                statusCode: 200,
                statusMessage: "OK",
                headers: { "content-type": (dataMatch[1] || "text/plain") },
                body: (dataMatch[2] ? (0,base64/* decode */.J)(dataMatch[3]) : unpercent(dataMatch[3]))
            };
            let result = response.body;
            if (processFunc) {
                result = processFunc(response.body, response);
            }
            return Promise.resolve(result);
        }
        catch (error) {
            logger.throwError("processing response error", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                body: bodyify(dataMatch[1], dataMatch[2]),
                error: error,
                requestBody: null,
                requestMethod: "GET",
                url: url
            });
        }
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) {
            headers["content-type"] = { key: "Content-Type", value: "application/octet-stream" };
        }
        if (headers["content-length"] == null) {
            headers["content-length"] = { key: "Content-Length", value: String(body.length) };
        }
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key) => {
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = (function () {
        let timer = null;
        const promise = new Promise(function (resolve, reject) {
            if (timeout) {
                timer = setTimeout(() => {
                    if (timer == null) {
                        return;
                    }
                    timer = null;
                    reject(logger.makeError("timeout", logger_lib_esm.Logger.errors.TIMEOUT, {
                        requestBody: bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        timeout: timeout,
                        url: url
                    }));
                }, timeout);
            }
        });
        const cancel = function () {
            if (timer == null) {
                return;
            }
            clearTimeout(timer);
            timer = null;
        };
        return { promise, cancel };
    })();
    const runningFetch = (function () {
        return lib_esm_awaiter(this, void 0, void 0, function* () {
            for (let attempt = 0; attempt < attemptLimit; attempt++) {
                let response = null;
                try {
                    response = yield getUrl(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        }
                        else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) {
                                tryAgain = yield throttleCallback(attempt, url);
                            }
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof (retryAfter) === "string" && retryAfter.match(/^[1-9][0-9]*$/)) {
                                    stall = parseInt(retryAfter) * 1000;
                                }
                                else {
                                    stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                }
                                //console.log("Stalling 429");
                                yield staller(stall);
                                continue;
                            }
                        }
                    }
                }
                catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        logger.throwError("missing response", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                            requestBody: bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) {
                    body = null;
                }
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    logger.throwError("bad response", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: bodyify(body, ((response.headers) ? response.headers["content-type"] : null)),
                        requestBody: bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) {
                    try {
                        const result = yield processFunc(body, response);
                        runningTimeout.cancel();
                        return result;
                    }
                    catch (error) {
                        // Allow the processFunc to trigger a throttle
                        if (error.throttleRetry && attempt < attemptLimit) {
                            let tryAgain = true;
                            if (throttleCallback) {
                                tryAgain = yield throttleCallback(attempt, url);
                            }
                            if (tryAgain) {
                                const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling callback");
                                yield staller(timeout);
                                continue;
                            }
                        }
                        runningTimeout.cancel();
                        logger.throwError("processing response error", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                            body: bodyify(body, ((response.headers) ? response.headers["content-type"] : null)),
                            error: error,
                            requestBody: bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            url: url
                        });
                    }
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return logger.throwError("failed response", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                requestBody: bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    })();
    return Promise.race([runningTimeout.promise, runningFetch]);
}
function fetchJson(connection, json, processFunc) {
    let processJsonFunc = (value, response) => {
        let result = null;
        if (value != null) {
            try {
                result = JSON.parse((0,utf8/* toUtf8String */.ZN)(value));
            }
            catch (error) {
                logger.throwError("invalid JSON", logger_lib_esm.Logger.errors.SERVER_ERROR, {
                    body: value,
                    error: error
                });
            }
        }
        if (processFunc) {
            result = processFunc(result, response);
        }
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0,utf8/* toUtf8Bytes */.Y0)(json);
        // Create a connection with the content-type set for JSON
        const updated = (typeof (connection) === "string") ? ({ url: connection }) : (0,properties_lib_esm.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = (Object.keys(updated.headers).filter((k) => (k.toLowerCase() === "content-type")).length) !== 0;
            if (!hasContentType) {
                updated.headers = (0,properties_lib_esm.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        }
        else {
            updated.headers = { "content-type": "application/json" };
        }
        connection = updated;
    }
    return _fetchData(connection, body, processJsonFunc);
}
function poll(func, options) {
    if (!options) {
        options = {};
    }
    options = (0,properties_lib_esm.shallowCopy)(options);
    if (options.floor == null) {
        options.floor = 0;
    }
    if (options.ceiling == null) {
        options.ceiling = 10000;
    }
    if (options.interval == null) {
        options.interval = 250;
    }
    return new Promise(function (resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = () => {
            if (done) {
                return false;
            }
            done = true;
            if (timer) {
                clearTimeout(timer);
            }
            return true;
        };
        if (options.timeout) {
            timer = setTimeout(() => {
                if (cancel()) {
                    reject(new Error("timeout"));
                }
            }, options.timeout);
        }
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function (result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) {
                        resolve(result);
                    }
                }
                else if (options.oncePoll) {
                    options.oncePoll.once("poll", check);
                }
                else if (options.onceBlock) {
                    options.onceBlock.once("block", check);
                    // Otherwise, exponential back-off (up to 10s) our next request
                }
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) {
                            reject(new Error("retry limit reached"));
                        }
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) {
                        timeout = options.floor;
                    }
                    if (timeout > options.ceiling) {
                        timeout = options.ceiling;
                    }
                    setTimeout(check, timeout);
                }
                return null;
            }, function (error) {
                if (cancel()) {
                    reject(error);
                }
            });
        }
        check();
    });
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/wordlists/lib/_version.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.version = void 0;
exports.version = "wordlists/5.7.0";
//# sourceMappingURL=_version.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/wordlists/lib/browser-wordlists.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
exports.E = void 0;
var lang_en_1 = __webpack_require__("../../node_modules/@ethersproject/wordlists/lib/lang-en.js");
exports.E = {
    en: lang_en_1.langEn
};
//# sourceMappingURL=browser-wordlists.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/wordlists/lib/lang-en.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.langEn = void 0;
var wordlist_1 = __webpack_require__("../../node_modules/@ethersproject/wordlists/lib/wordlist.js");
var words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
var wordlist = null;
function loadWords(lang) {
    if (wordlist != null) {
        return;
    }
    wordlist = words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */
    if (wordlist_1.Wordlist.check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
var LangEn = /** @class */ (function (_super) {
    __extends(LangEn, _super);
    function LangEn() {
        return _super.call(this, "en") || this;
    }
    LangEn.prototype.getWord = function (index) {
        loadWords(this);
        return wordlist[index];
    };
    LangEn.prototype.getWordIndex = function (word) {
        loadWords(this);
        return wordlist.indexOf(word);
    };
    return LangEn;
}(wordlist_1.Wordlist));
var langEn = new LangEn();
exports.langEn = langEn;
wordlist_1.Wordlist.register(langEn);
//# sourceMappingURL=lang-en.js.map

/***/ }),

/***/ "../../node_modules/@ethersproject/wordlists/lib/wordlist.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Wordlist = exports.logger = void 0;
// This gets overridden by rollup
var exportWordlist = false;
var hash_1 = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/index.js");
var properties_1 = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
var logger_1 = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
var _version_1 = __webpack_require__("../../node_modules/@ethersproject/wordlists/lib/_version.js");
exports.logger = new logger_1.Logger(_version_1.version);
var Wordlist = /** @class */ (function () {
    function Wordlist(locale) {
        var _newTarget = this.constructor;
        exports.logger.checkAbstract(_newTarget, Wordlist);
        (0, properties_1.defineReadOnly)(this, "locale", locale);
    }
    // Subclasses may override this
    Wordlist.prototype.split = function (mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    };
    // Subclasses may override this
    Wordlist.prototype.join = function (words) {
        return words.join(" ");
    };
    Wordlist.check = function (wordlist) {
        var words = [];
        for (var i = 0; i < 2048; i++) {
            var word = wordlist.getWord(i);
            /* istanbul ignore if */
            if (i !== wordlist.getWordIndex(word)) {
                return "0x";
            }
            words.push(word);
        }
        return (0, hash_1.id)(words.join("\n") + "\n");
    };
    Wordlist.register = function (lang, name) {
        if (!name) {
            name = lang.locale;
        }
        /* istanbul ignore if */
        if (exportWordlist) {
            try {
                var anyGlobal = window;
                if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                    if (!anyGlobal._ethers.wordlists[name]) {
                        (0, properties_1.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
                    }
                }
            }
            catch (error) { }
        }
    };
    return Wordlist;
}());
exports.Wordlist = Wordlist;
//# sourceMappingURL=wordlist.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/auth-browser/node_modules/tweetnacl-util/nacl-util.js":
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];
// Written in 2014-2016 by Dmitry Chestnykh and Devi Mandiri.
// Public domain.
(function(root, f) {
  'use strict';
  if ( true && module.exports) module.exports = f();
  else if (root.nacl) root.nacl.util = f();
  else {
    root.nacl = {};
    root.nacl.util = f();
  }
}(this, function() {
  'use strict';

  var util = {};

  util.decodeUTF8 = function(s) {
    var i, d = unescape(encodeURIComponent(s)), b = new Uint8Array(d.length);
    for (i = 0; i < d.length; i++) b[i] = d.charCodeAt(i);
    return b;
  };

  util.encodeUTF8 = function(arr) {
    var i, s = [];
    for (i = 0; i < arr.length; i++) s.push(String.fromCharCode(arr[i]));
    return decodeURIComponent(escape(s.join('')));
  };

  util.encodeBase64 = function(arr) {
    if (typeof btoa === 'undefined') {
      return (new Buffer(arr)).toString('base64');
    } else {
      var i, s = [], len = arr.length;
      for (i = 0; i < len; i++) s.push(String.fromCharCode(arr[i]));
      return btoa(s.join(''));
    }
  };

  util.decodeBase64 = function(s) {
    if (typeof atob === 'undefined') {
      return new Uint8Array(Array.prototype.slice.call(new Buffer(s, 'base64'), 0));
    } else {
      var i, d = atob(s), b = new Uint8Array(d.length);
      for (i = 0; i < d.length; i++) b[i] = d.charCodeAt(i);
      return b;
    }
  };

  return util;

}));


/***/ }),

/***/ "../../node_modules/@lit-protocol/constants/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ABI_ERC20 = exports.ABI_LIT = void 0;
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
// ----------- Version -----------
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/constants/src/lib/version.js"), exports);
// ----------- Constants -----------
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/constants/src/lib/constants/constants.js"), exports);
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/constants/src/lib/constants/defaultLitNodeClientConfig.js"), exports);
// ----------- Interfaces -----------
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/constants/src/lib/interfaces/i-errors.js"), exports);
// ----------- ENUMS -----------
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/constants/src/lib/enums.js"), exports);
// ----------- Errors -----------
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/constants/src/lib/errors.js"), exports);
// ----------- Utils -----------
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/constants/src/lib/utils/utils.js"), exports);
// ----------- ABIs -----------
const ABI_LIT = Promise.resolve().then(() => __webpack_require__("../../node_modules/@lit-protocol/constants/src/lib/abis/LIT.json"));
exports.ABI_LIT = ABI_LIT;
const ABI_ERC20 = Promise.resolve().then(() => __webpack_require__("../../node_modules/@lit-protocol/constants/src/lib/abis/ERC20.json"));
exports.ABI_ERC20 = ABI_ERC20;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/constants/src/lib/constants/constants.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PKP_CLIENT_SUPPORTED_CHAINS = exports.AUTH_METHOD_TYPE_IDS = exports.LIT_SESSION_KEY_URI = exports.LIT_NETWORKS = exports.SYMM_KEY_ALGO_PARAMS = exports.LOCAL_STORAGE_KEYS = exports.ALL_LIT_CHAINS = exports.LIT_COSMOS_CHAINS = exports.LIT_SVM_CHAINS = exports.LIT_EVM_CHAINS = exports.LIT_CHAINS = exports.AUTH_SIGNATURE_BODY = exports.LIT_AUTH_SIG_CHAIN_KEYS = exports.NETWORK_PUB_KEY = void 0;
/**
 * Lit Protocol Network Public Key
 */
exports.NETWORK_PUB_KEY = '9971e835a1fe1a4d78e381eebbe0ddc84fde5119169db816900de796d10187f3c53d65c1202ac083d099a517f34a9b62';
// you can either pass a "chain" param to lit functions, which it uses to tell which network your sig came from.
// or, you can pass a authSig that has and of these keys in it to tell which network your sig came from.
exports.LIT_AUTH_SIG_CHAIN_KEYS = [
    'ethereum',
    'solana',
    'cosmos',
    'kyve',
];
exports.AUTH_SIGNATURE_BODY = 'I am creating an account to use Lit Protocol at {{timestamp}}';
/**
 * EVM Chains supported by the LIT protocol.  Each chain includes an optional pre-deployed token contract that you may use for minting LITs.  These are ERC1155 contracts that let you mint any quantity of a given token.  Use the chain name as a key in this object.
 * @constant
 * @type { LITEVMChain }
 * @default
 */
exports.LIT_CHAINS = {
    ethereum: {
        contractAddress: '0xA54F7579fFb3F98bd8649fF02813F575f9b3d353',
        chainId: 1,
        name: 'Ethereum',
        symbol: 'ETH',
        decimals: 18,
        type: 'ERC1155',
        rpcUrls: [
            'https://eth-mainnet.alchemyapi.io/v2/EuGnkVlzVoEkzdg0lpCarhm8YHOxWVxE',
        ],
        blockExplorerUrls: ['https://etherscan.io'],
        vmType: 'EVM',
    },
    polygon: {
        contractAddress: '0x7C7757a9675f06F3BE4618bB68732c4aB25D2e88',
        chainId: 137,
        name: 'Polygon',
        symbol: 'MATIC',
        decimals: 18,
        rpcUrls: ['https://polygon-rpc.com'],
        blockExplorerUrls: ['https://explorer.matic.network'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    fantom: {
        contractAddress: '0x5bD3Fe8Ab542f0AaBF7552FAAf376Fd8Aa9b3869',
        chainId: 250,
        name: 'Fantom',
        symbol: 'FTM',
        decimals: 18,
        rpcUrls: ['https://rpcapi.fantom.network'],
        blockExplorerUrls: ['https://ftmscan.com'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    xdai: {
        contractAddress: '0xDFc2Fd83dFfD0Dafb216F412aB3B18f2777406aF',
        chainId: 100,
        name: 'xDai',
        symbol: 'xDai',
        decimals: 18,
        rpcUrls: ['https://rpc.gnosischain.com'],
        blockExplorerUrls: [' https://blockscout.com/xdai/mainnet'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    bsc: {
        contractAddress: '0xc716950e5DEae248160109F562e1C9bF8E0CA25B',
        chainId: 56,
        name: 'Binance Smart Chain',
        symbol: 'BNB',
        decimals: 18,
        rpcUrls: ['https://bsc-dataseed.binance.org/'],
        blockExplorerUrls: [' https://bscscan.com/'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    arbitrum: {
        contractAddress: '0xc716950e5DEae248160109F562e1C9bF8E0CA25B',
        chainId: 42161,
        name: 'Arbitrum',
        symbol: 'AETH',
        decimals: 18,
        type: 'ERC1155',
        rpcUrls: ['https://arb1.arbitrum.io/rpc'],
        blockExplorerUrls: ['https://arbiscan.io/'],
        vmType: 'EVM',
    },
    avalanche: {
        contractAddress: '0xBB118507E802D17ECDD4343797066dDc13Cde7C6',
        chainId: 43114,
        name: 'Avalanche',
        symbol: 'AVAX',
        decimals: 18,
        type: 'ERC1155',
        rpcUrls: ['https://api.avax.network/ext/bc/C/rpc'],
        blockExplorerUrls: ['https://snowtrace.io/'],
        vmType: 'EVM',
    },
    fuji: {
        contractAddress: '0xc716950e5DEae248160109F562e1C9bF8E0CA25B',
        chainId: 43113,
        name: 'Avalanche FUJI Testnet',
        symbol: 'AVAX',
        decimals: 18,
        type: 'ERC1155',
        rpcUrls: ['https://api.avax-test.network/ext/bc/C/rpc'],
        blockExplorerUrls: ['https://testnet.snowtrace.io/'],
        vmType: 'EVM',
    },
    harmony: {
        contractAddress: '0xBB118507E802D17ECDD4343797066dDc13Cde7C6',
        chainId: 1666600000,
        name: 'Harmony',
        symbol: 'ONE',
        decimals: 18,
        type: 'ERC1155',
        rpcUrls: ['https://api.harmony.one'],
        blockExplorerUrls: ['https://explorer.harmony.one/'],
        vmType: 'EVM',
    },
    kovan: {
        contractAddress: '0x9dB60Db3Dd9311861D87D33B0463AaD9fB4bb0E6',
        chainId: 42,
        name: 'Kovan',
        symbol: 'ETH',
        decimals: 18,
        rpcUrls: ['https://kovan.infura.io/v3/ddf1ca3700f34497bca2bf03607fde38'],
        blockExplorerUrls: ['https://kovan.etherscan.io'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    mumbai: {
        contractAddress: '0xc716950e5DEae248160109F562e1C9bF8E0CA25B',
        chainId: 80001,
        name: 'Mumbai',
        symbol: 'MATIC',
        decimals: 18,
        rpcUrls: [
            'https://rpc-mumbai.maticvigil.com/v1/96bf5fa6e03d272fbd09de48d03927b95633726c',
        ],
        blockExplorerUrls: ['https://mumbai.polygonscan.com'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    goerli: {
        contractAddress: '0xc716950e5DEae248160109F562e1C9bF8E0CA25B',
        chainId: 5,
        name: 'Goerli',
        symbol: 'ETH',
        decimals: 18,
        rpcUrls: ['https://goerli.infura.io/v3/96dffb3d8c084dec952c61bd6230af34'],
        blockExplorerUrls: ['https://goerli.etherscan.io'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    ropsten: {
        contractAddress: '0x61544f0AE85f8fed6Eb315c406644eb58e15A1E7',
        chainId: 3,
        name: 'Ropsten',
        symbol: 'ETH',
        decimals: 18,
        rpcUrls: ['https://ropsten.infura.io/v3/96dffb3d8c084dec952c61bd6230af34'],
        blockExplorerUrls: ['https://ropsten.etherscan.io'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    rinkeby: {
        contractAddress: '0xc716950e5deae248160109f562e1c9bf8e0ca25b',
        chainId: 4,
        name: 'Rinkeby',
        symbol: 'ETH',
        decimals: 18,
        rpcUrls: ['https://rinkeby.infura.io/v3/96dffb3d8c084dec952c61bd6230af34'],
        blockExplorerUrls: ['https://rinkeby.etherscan.io'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    cronos: {
        contractAddress: '0xc716950e5DEae248160109F562e1C9bF8E0CA25B',
        chainId: 25,
        name: 'Cronos',
        symbol: 'CRO',
        decimals: 18,
        rpcUrls: ['https://evm-cronos.org'],
        blockExplorerUrls: ['https://cronos.org/explorer/'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    optimism: {
        contractAddress: '0xbF68B4c9aCbed79278465007f20a08Fa045281E0',
        chainId: 10,
        name: 'Optimism',
        symbol: 'ETH',
        decimals: 18,
        rpcUrls: ['https://mainnet.optimism.io'],
        blockExplorerUrls: ['https://optimistic.etherscan.io'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    celo: {
        contractAddress: '0xBB118507E802D17ECDD4343797066dDc13Cde7C6',
        chainId: 42220,
        name: 'Celo',
        symbol: 'CELO',
        decimals: 18,
        rpcUrls: ['https://forno.celo.org'],
        blockExplorerUrls: ['https://explorer.celo.org'],
        type: 'ERC1155',
        vmType: 'EVM',
    },
    aurora: {
        contractAddress: null,
        chainId: 1313161554,
        name: 'Aurora',
        symbol: 'ETH',
        decimals: 18,
        rpcUrls: ['https://mainnet.aurora.dev'],
        blockExplorerUrls: ['https://aurorascan.dev'],
        type: null,
        vmType: 'EVM',
    },
    eluvio: {
        contractAddress: null,
        chainId: 955305,
        name: 'Eluvio',
        symbol: 'ELV',
        decimals: 18,
        rpcUrls: ['https://host-76-74-28-226.contentfabric.io/eth'],
        blockExplorerUrls: ['https://explorer.eluv.io'],
        type: null,
        vmType: 'EVM',
    },
    alfajores: {
        contractAddress: null,
        chainId: 44787,
        name: 'Alfajores',
        symbol: 'CELO',
        decimals: 18,
        rpcUrls: ['https://alfajores-forno.celo-testnet.org'],
        blockExplorerUrls: ['https://alfajores-blockscout.celo-testnet.org'],
        type: null,
        vmType: 'EVM',
    },
    xdc: {
        contractAddress: null,
        chainId: 50,
        name: 'XDC Blockchain',
        symbol: 'XDC',
        decimals: 18,
        rpcUrls: ['https://rpc.xinfin.network'],
        blockExplorerUrls: ['https://explorer.xinfin.network'],
        type: null,
        vmType: 'EVM',
    },
    evmos: {
        contractAddress: null,
        chainId: 9001,
        name: 'EVMOS',
        symbol: 'EVMOS',
        decimals: 18,
        rpcUrls: ['https://eth.bd.evmos.org:8545'],
        blockExplorerUrls: ['https://evm.evmos.org'],
        type: null,
        vmType: 'EVM',
    },
    evmosTestnet: {
        contractAddress: null,
        chainId: 9000,
        name: 'EVMOS Testnet',
        symbol: 'EVMOS',
        decimals: 18,
        rpcUrls: ['https://eth.bd.evmos.dev:8545'],
        blockExplorerUrls: ['https://evm.evmos.dev'],
        type: null,
        vmType: 'EVM',
    },
    bscTestnet: {
        contractAddress: null,
        chainId: 97,
        name: 'BSC Testnet',
        symbol: 'BNB',
        decimals: 18,
        rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545'],
        blockExplorerUrls: ['https://testnet.bscscan.com/'],
        type: null,
        vmType: 'EVM',
    },
    baseGoerli: {
        contractAddress: null,
        chainId: 84531,
        name: 'Base Goerli',
        symbol: 'ETH',
        decimals: 18,
        rpcUrls: ['https://goerli.base.org'],
        blockExplorerUrls: ['https://goerli.basescan.org'],
        type: null,
        vmType: 'EVM',
    },
    moonbeam: {
        contractAddress: null,
        chainId: 1284,
        name: 'Moonbeam',
        symbol: 'GLMR',
        decimals: 18,
        rpcUrls: ['https://rpc.api.moonbeam.network'],
        blockExplorerUrls: ['https://moonscan.io'],
        type: null,
        vmType: 'EVM',
    },
    moonriver: {
        contractAddress: null,
        chainId: 1285,
        name: 'Moonriver',
        symbol: 'MOVR',
        decimals: 18,
        rpcUrls: ['https://rpc.api.moonriver.moonbeam.network'],
        blockExplorerUrls: ['https://moonriver.moonscan.io'],
        type: null,
        vmType: 'EVM',
    },
    moonbaseAlpha: {
        contractAddress: null,
        chainId: 1287,
        name: 'Moonbase Alpha',
        symbol: 'DEV',
        decimals: 18,
        rpcUrls: ['https://rpc.api.moonbase.moonbeam.network'],
        blockExplorerUrls: ['https://moonbase.moonscan.io/'],
        type: null,
        vmType: 'EVM',
    },
    filecoin: {
        contractAddress: null,
        chainId: 314,
        name: 'Filecoin',
        symbol: 'FIL',
        decimals: 18,
        rpcUrls: ['https://api.node.glif.io/rpc/v1'],
        blockExplorerUrls: ['https://filfox.info/'],
        type: null,
        vmType: 'EVM',
    },
    hyperspace: {
        contractAddress: null,
        chainId: 3141,
        name: 'Filecoin Hyperspace testnet',
        symbol: 'tFIL',
        decimals: 18,
        rpcUrls: ['https://api.hyperspace.node.glif.io/rpc/v1'],
        blockExplorerUrls: ['https://hyperspace.filscan.io/'],
        type: null,
        vmType: 'EVM',
    },
    scrollAlphaTestnet: {
        contractAddress: null,
        chainId: 534353,
        name: 'Scroll Alpha Testnet',
        symbol: 'ETH',
        decimals: 18,
        rpcUrls: ['https://alpha-rpc.scroll.io/l2'],
        blockExplorerUrls: ['https://blockscout.scroll.io/'],
        type: null,
        vmType: 'EVM',
    },
    zksync: {
        contractAddress: null,
        chainId: 324,
        name: 'zkSync Era Mainnet',
        symbol: 'ETH',
        decimals: 18,
        rpcUrls: ['https://mainnet.era.zksync.io'],
        blockExplorerUrls: ['https://explorer.zksync.io/'],
        type: null,
        vmType: 'EVM',
    },
    litprotocol: {
        contractAddress: null,
        chainId: 175177,
        name: 'Chronicle - Lit Protocol Testnet',
        symbol: 'LIT',
        decimals: 18,
        rpcUrls: ['https://chain-rpc.litprotocol.com/http'],
        blockExplorerUrls: ['https://chain.litprotocol.com/'],
        type: null,
        vmType: 'EVM',
    },
};
exports.LIT_EVM_CHAINS = exports.LIT_CHAINS;
/**
 * Solana Chains supported by the LIT protocol.  Use the chain name as a key in this object.
 * @constant
 * @type { LITSVMChain }
 * @default
 */
exports.LIT_SVM_CHAINS = {
    solana: {
        name: 'Solana',
        symbol: 'SOL',
        decimals: 9,
        rpcUrls: ['https://api.mainnet-beta.solana.com'],
        blockExplorerUrls: ['https://explorer.solana.com/'],
        vmType: 'SVM',
    },
    solanaDevnet: {
        name: 'Solana Devnet',
        symbol: 'SOL',
        decimals: 9,
        rpcUrls: ['https://api.devnet.solana.com'],
        blockExplorerUrls: ['https://explorer.solana.com/'],
        vmType: 'SVM',
    },
    solanaTestnet: {
        name: 'Solana Testnet',
        symbol: 'SOL',
        decimals: 9,
        rpcUrls: ['https://api.testnet.solana.com'],
        blockExplorerUrls: ['https://explorer.solana.com/'],
        vmType: 'SVM',
    },
};
/**
 * Cosmos Chains supported by the LIT protocol.  Use the chain name as a key in this object.
 * @constant
 * @type { LITCosmosChain }
 * @default
 */
exports.LIT_COSMOS_CHAINS = {
    cosmos: {
        name: 'Cosmos',
        symbol: 'ATOM',
        decimals: 6,
        chainId: 'cosmoshub-4',
        rpcUrls: ['https://lcd-cosmoshub.keplr.app'],
        blockExplorerUrls: ['https://atomscan.com/'],
        vmType: 'CVM',
    },
    kyve: {
        name: 'Kyve',
        symbol: 'KYVE',
        decimals: 6,
        chainId: 'korellia',
        rpcUrls: ['https://api.korellia.kyve.network'],
        blockExplorerUrls: ['https://explorer.kyve.network/'],
        vmType: 'CVM',
    },
    evmosCosmos: {
        name: 'EVMOS Cosmos',
        symbol: 'EVMOS',
        decimals: 18,
        chainId: 'evmos_9001-2',
        rpcUrls: ['https://rest.bd.evmos.org:1317'],
        blockExplorerUrls: ['https://evmos.bigdipper.live'],
        vmType: 'CVM',
    },
    evmosCosmosTestnet: {
        name: 'Evmos Cosmos Testnet',
        symbol: 'EVMOS',
        decimals: 18,
        chainId: 'evmos_9000-4',
        rpcUrls: ['https://rest.bd.evmos.dev:1317'],
        blockExplorerUrls: ['https://testnet.bigdipper.live'],
        vmType: 'CVM',
    },
    cheqdMainnet: {
        name: 'Cheqd Mainnet',
        symbol: 'CHEQ',
        decimals: 9,
        chainId: 'cheqd-mainnet-1',
        rpcUrls: ['https://api.cheqd.net'],
        blockExplorerUrls: ['https://explorer.cheqd.io'],
        vmType: 'CVM',
    },
    cheqdTestnet: {
        name: 'Cheqd Testnet',
        symbol: 'CHEQ',
        decimals: 9,
        chainId: 'cheqd-testnet-6',
        rpcUrls: ['https://api.cheqd.network'],
        blockExplorerUrls: ['https://testnet-explorer.cheqd.io'],
        vmType: 'CVM',
    },
    juno: {
        name: 'Juno',
        symbol: 'JUNO',
        decimals: 6,
        chainId: 'juno-1',
        rpcUrls: ['https://rest.cosmos.directory/juno'],
        blockExplorerUrls: ['https://www.mintscan.io/juno'],
        vmType: 'CVM',
    },
};
/**
 * All Chains supported by the LIT protocol.  Use the chain name as a key in this object.
 * @type { LITChain<LITEVMChain | LITSVMChain | LITCosmosChain> }
 */
exports.ALL_LIT_CHAINS = {
    ...exports.LIT_CHAINS,
    ...exports.LIT_SVM_CHAINS,
    ...exports.LIT_COSMOS_CHAINS,
};
/**
 * Local storage key constants
 */
exports.LOCAL_STORAGE_KEYS = {
    AUTH_COSMOS_SIGNATURE: 'lit-auth-cosmos-signature',
    WALLET_CONNECT: 'walletconnect',
    AUTH_SIGNATURE: 'lit-auth-signature',
    AUTH_SOL_SIGNATURE: 'lit-auth-sol-signature',
    WEB3_PROVIDER: 'lit-web3-provider',
    KEY_PAIR: 'lit-comms-keypair',
    SESSION_KEY: 'lit-session-key',
    WALLET_SIGNATURE: 'lit-wallet-sig',
};
/**
 * Symmetric key algorithm parameters
 */
exports.SYMM_KEY_ALGO_PARAMS = {
    name: 'AES-CBC',
    length: 256,
};
/**
 *
 * ALL LIT NETWORKS
 *
 */
exports.LIT_NETWORKS = {
    jalapeno: [
        'https://node2.litgateway.com:7370',
        'https://node2.litgateway.com:7371',
        'https://node2.litgateway.com:7372',
        'https://node2.litgateway.com:7373',
        'https://node2.litgateway.com:7374',
        'https://node2.litgateway.com:7375',
        'https://node2.litgateway.com:7376',
        'https://node2.litgateway.com:7377',
        'https://node2.litgateway.com:7378',
        'https://node2.litgateway.com:7379',
    ],
    serrano: [
        'https://serrano.litgateway.com:7370',
        'https://serrano.litgateway.com:7371',
        'https://serrano.litgateway.com:7372',
        'https://serrano.litgateway.com:7373',
        'https://serrano.litgateway.com:7374',
        'https://serrano.litgateway.com:7375',
        'https://serrano.litgateway.com:7376',
        'https://serrano.litgateway.com:7377',
        'https://serrano.litgateway.com:7378',
        'https://serrano.litgateway.com:7379',
    ],
    localhost: [
        'http://localhost:7470',
        'http://localhost:7471',
        'http://localhost:7472',
        'http://localhost:7473',
        'http://localhost:7474',
        'http://localhost:7475',
        'http://localhost:7476',
        'http://localhost:7477',
        'http://localhost:7478',
        'http://localhost:7479',
    ],
    custom: [],
};
// ========== Lit Sessions ==========
exports.LIT_SESSION_KEY_URI = 'lit:session:';
// ========== Lit Auth Methods ==========
exports.AUTH_METHOD_TYPE_IDS = {
    WEBAUTHN: 3,
    DISCORD: 4,
    GOOGLE: 5,
    GOOGLE_JWT: 6,
};
// ========== PKP Client ==========
exports.PKP_CLIENT_SUPPORTED_CHAINS = ['eth', 'cosmos'];
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/constants/src/lib/constants/defaultLitNodeClientConfig.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultLitnodeClientConfig = void 0;
exports.defaultLitnodeClientConfig = {
    alertWhenUnauthorized: true,
    minNodeCount: 6,
    debug: true,
    bootstrapUrls: [
        'https://node2.litgateway.com:7370',
        'https://node2.litgateway.com:7371',
        'https://node2.litgateway.com:7372',
        'https://node2.litgateway.com:7373',
        'https://node2.litgateway.com:7374',
        'https://node2.litgateway.com:7375',
        'https://node2.litgateway.com:7376',
        'https://node2.litgateway.com:7377',
        'https://node2.litgateway.com:7378',
        'https://node2.litgateway.com:7379',
    ],
    litNetwork: 'jalapeno',
    connectTimeout: 20000,
};
//# sourceMappingURL=defaultLitNodeClientConfig.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/constants/src/lib/enums.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ProviderType = exports.AuthMethodType = exports.SIGTYPE = exports.VMTYPE = void 0;
/** ---------- Chains ---------- */
var VMTYPE;
(function (VMTYPE) {
    VMTYPE["EVM"] = "EVM";
    VMTYPE["SVM"] = "SVM";
    VMTYPE["CVM"] = "CVM";
})(VMTYPE = exports.VMTYPE || (exports.VMTYPE = {}));
var SIGTYPE;
(function (SIGTYPE) {
    SIGTYPE["BLS"] = "BLS";
    SIGTYPE["ECDSA"] = "ECDSA";
})(SIGTYPE = exports.SIGTYPE || (exports.SIGTYPE = {}));
/**
 * Supported PKP auth method types
 */
var AuthMethodType;
(function (AuthMethodType) {
    AuthMethodType[AuthMethodType["EthWallet"] = 1] = "EthWallet";
    AuthMethodType[AuthMethodType["LitAction"] = 2] = "LitAction";
    AuthMethodType[AuthMethodType["WebAuthn"] = 3] = "WebAuthn";
    AuthMethodType[AuthMethodType["Discord"] = 4] = "Discord";
    AuthMethodType[AuthMethodType["Google"] = 5] = "Google";
    AuthMethodType[AuthMethodType["GoogleJwt"] = 6] = "GoogleJwt";
})(AuthMethodType = exports.AuthMethodType || (exports.AuthMethodType = {}));
/**
 * Supported provider types
 */
var ProviderType;
(function (ProviderType) {
    ProviderType["Discord"] = "discord";
    ProviderType["Google"] = "google";
    ProviderType["EthWallet"] = "ethwallet";
    ProviderType["WebAuthn"] = "webauthn";
})(ProviderType = exports.ProviderType || (exports.ProviderType = {}));
//# sourceMappingURL=enums.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/constants/src/lib/errors.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LIT_ERROR_CODE = exports.LIT_ERROR = exports.LitErrorKind = void 0;
var LitErrorKind;
(function (LitErrorKind) {
    LitErrorKind["Unknown"] = "Unknown";
    LitErrorKind["Unexpected"] = "Unexpected";
    LitErrorKind["Generic"] = "Generic";
    LitErrorKind["Config"] = "Config";
    LitErrorKind["Validation"] = "Validation";
    LitErrorKind["Conversion"] = "Conversion";
    LitErrorKind["Parser"] = "Parser";
    LitErrorKind["Serializer"] = "Serializer";
    LitErrorKind["Timeout"] = "Timeout";
})(LitErrorKind = exports.LitErrorKind || (exports.LitErrorKind = {}));
exports.LIT_ERROR = {
    INVALID_PARAM_TYPE: {
        name: 'InvalidParamType',
        code: 'invalid_param_type',
        kind: LitErrorKind.Validation,
    },
    INVALID_ACCESS_CONTROL_CONDITIONS: {
        name: 'InvalidAccessControlConditions',
        code: 'invalid_access_control_conditions',
        kind: LitErrorKind.Validation,
    },
    WRONG_NETWORK_EXCEPTION: {
        name: 'WrongNetworkException',
        code: 'wrong_network_exception',
        kind: LitErrorKind.Validation,
    },
    MINTING_NOT_SUPPORTED: {
        name: 'MintingNotSupported',
        code: 'minting_not_supported',
        kind: LitErrorKind.Validation,
    },
    UNSUPPORTED_CHAIN_EXCEPTION: {
        name: 'UnsupportedChainException',
        code: 'unsupported_chain_exception',
        kind: LitErrorKind.Validation,
    },
    INVALID_UNIFIED_CONDITION_TYPE: {
        name: 'InvalidUnifiedConditionType',
        code: 'invalid_unified_condition_type',
        kind: LitErrorKind.Validation,
    },
    LIT_NODE_CLIENT_NOT_READY_ERROR: {
        name: 'LitNodeClientNotReadyError',
        code: 'lit_node_client_not_ready_error',
        kind: LitErrorKind.Unexpected,
    },
    UNAUTHROZIED_EXCEPTION: {
        name: 'UnauthroziedException',
        code: 'unauthrozied_exception',
        kind: LitErrorKind.Validation,
    },
    INVALID_ARGUMENT_EXCEPTION: {
        name: 'InvalidArgumentException',
        code: 'invalid_argument_exception',
        kind: LitErrorKind.Validation,
    },
    UNKNOWN_ERROR: {
        name: 'UnknownError',
        code: 'unknown_error',
        kind: LitErrorKind.Unknown,
    },
    NO_WALLET_EXCEPTION: {
        name: 'NoWalletException',
        code: 'no_wallet_exception',
        kind: LitErrorKind.Validation,
    },
    WRONG_PARAM_FORMAT: {
        name: 'WrongParamFormat',
        code: 'wrong_param_format',
        kind: LitErrorKind.Validation,
    },
    LOCAL_STORAGE_ITEM_NOT_FOUND_EXCEPTION: {
        name: 'LocalStorageItemNotFoundException',
        code: 'local_storage_item_not_found_exception',
        kind: LitErrorKind.Unexpected,
    },
    REMOVED_FUNCTION_ERROR: {
        name: 'RemovedFunctionError',
        code: 'removed_function_error',
        kind: LitErrorKind.Validation,
    },
    LIT_NODE_CLIENT_BAD_CONFIG_ERROR: {
        name: 'LitNodeClientBadConfigError',
        code: 'lit_node_client_bad_config_error',
        kind: LitErrorKind.Config,
    },
    PARAMS_MISSING_ERROR: {
        name: 'ParamsMissingError',
        code: 'params_missing_error',
        kind: LitErrorKind.Validation,
    },
    UNKNOWN_SIGNATURE_TYPE: {
        name: 'UnknownSignatureType',
        code: 'unknown_signature_type',
        kind: LitErrorKind.Validation,
    },
    PARAM_NULL_ERROR: {
        name: 'ParamNullError',
        code: 'param_null_error',
        kind: LitErrorKind.Validation,
    },
    UNKNOWN_DECRYPTION_ALGORITHM_TYPE_ERROR: {
        name: 'UnknownDecryptionAlgorithmTypeError',
        code: 'unknown_decryption_algorithm_type_error',
        kind: LitErrorKind.Validation,
    },
    WASM_INIT_ERROR: {
        name: 'WasmInitError',
        code: 'wasm_init_error',
        kind: LitErrorKind.Unexpected,
    },
    NODEJS_EXCEPTION: {
        name: 'NodejsException',
        code: 'nodejs_exception',
        kind: LitErrorKind.Unexpected,
    },
    WALLET_SIGNATURE_NOT_FOUND_ERROR: {
        name: 'WalletSignatureNotFoundError',
        code: 'wallet_signature_not_found_error',
        kind: LitErrorKind.Validation,
    },
    NO_VALID_SHARES: {
        name: 'NoValidShares',
        code: 'no_valid_shares',
        kind: LitErrorKind.Unexpected,
    },
};
exports.LIT_ERROR_CODE = {
    NODE_NOT_AUTHORIZED: 'NodeNotAuthorized',
};
//# sourceMappingURL=errors.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/constants/src/lib/interfaces/i-errors.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=i-errors.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/constants/src/lib/utils/utils.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ERight = exports.ELeft = void 0;
/**
 *
 * This method should be used when there's an expected error
 *
 * @param { any } result
 * @returns { IEither }
 */
const ELeft = (result) => {
    return {
        type: "ERROR" /* EITHER_TYPE.ERROR */,
        result: result,
    };
};
exports.ELeft = ELeft;
/**
 *
 * This method should be used when there's an expected success outcome
 *
 * @param result
 * @returns
 */
const ERight = (result) => {
    return {
        type: "SUCCESS" /* EITHER_TYPE.SUCCESS */,
        result: result,
    };
};
exports.ERight = ERight;
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/constants/src/lib/version.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.version = void 0;
exports.version = '2.1.161';
//# sourceMappingURL=version.js.map

/***/ }),

/***/ "../../node_modules/@spruceid/siwe-parser/dist/abnf.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ParsedMessage = void 0;
const api_1 = __importDefault(__webpack_require__("../../node_modules/apg-js/src/apg-api/api.js"));
const node_exports_1 = __importDefault(__webpack_require__("../../node_modules/apg-js/src/apg-lib/node-exports.js"));
const GRAMMAR = `
sign-in-with-ethereum =
    domain %s" wants you to sign in with your Ethereum account:" LF
    address LF
    LF
    [ statement LF ]
    LF
    %s"URI: " URI LF
    %s"Version: " version LF
    %s"Chain ID: " chain-id LF
    %s"Nonce: " nonce LF
    %s"Issued At: " issued-at
    [ LF %s"Expiration Time: " expiration-time ]
    [ LF %s"Not Before: " not-before ]
    [ LF %s"Request ID: " request-id ]
    [ LF %s"Resources:"
    resources ]

domain = authority

address = "0x" 40*40HEXDIG
    ; Must also conform to captilization
    ; checksum encoding specified in EIP-55
    ; where applicable (EOAs).

statement = 1*( reserved / unreserved / " " )
    ; The purpose is to exclude LF (line breaks).

version = "1"

nonce = 8*( ALPHA / DIGIT )

issued-at = date-time
expiration-time = date-time
not-before = date-time

request-id = *pchar

chain-id = 1*DIGIT
    ; See EIP-155 for valid CHAIN_IDs.

resources = *( LF resource )

resource = "- " URI

; ------------------------------------------------------------------------------
; RFC 3986

URI           = scheme ":" hier-part [ "?" query ] [ "#" fragment ]

hier-part     = "//" authority path-abempty
              / path-absolute
              / path-rootless
              / path-empty

scheme        = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )

authority     = [ userinfo "@" ] host [ ":" port ]
userinfo      = *( unreserved / pct-encoded / sub-delims / ":" )
host          = IP-literal / IPv4address / reg-name
port          = *DIGIT

IP-literal    = "[" ( IPv6address / IPvFuture  ) "]"

IPvFuture     = "v" 1*HEXDIG "." 1*( unreserved / sub-delims / ":" )

IPv6address   =                            6( h16 ":" ) ls32
              /                       "::" 5( h16 ":" ) ls32
              / [               h16 ] "::" 4( h16 ":" ) ls32
              / [ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
              / [ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
              / [ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
              / [ *4( h16 ":" ) h16 ] "::"              ls32
              / [ *5( h16 ":" ) h16 ] "::"              h16
              / [ *6( h16 ":" ) h16 ] "::"

h16           = 1*4HEXDIG
ls32          = ( h16 ":" h16 ) / IPv4address
IPv4address   = dec-octet "." dec-octet "." dec-octet "." dec-octet
dec-octet     = DIGIT                 ; 0-9
                 / %x31-39 DIGIT         ; 10-99
                 / "1" 2DIGIT            ; 100-199
                 / "2" %x30-34 DIGIT     ; 200-249
                 / "25" %x30-35          ; 250-255

reg-name      = *( unreserved / pct-encoded / sub-delims )

path-abempty  = *( "/" segment )
path-absolute = "/" [ segment-nz *( "/" segment ) ]
path-rootless = segment-nz *( "/" segment )
path-empty    = 0pchar

segment       = *pchar
segment-nz    = 1*pchar

pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"

query         = *( pchar / "/" / "?" )

fragment      = *( pchar / "/" / "?" )

pct-encoded   = "%" HEXDIG HEXDIG

unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
reserved      = gen-delims / sub-delims
gen-delims    = ":" / "/" / "?" / "#" / "[" / "]" / "@"
sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
              / "*" / "+" / "," / ";" / "="

; ------------------------------------------------------------------------------
; RFC 3339

date-fullyear   = 4DIGIT
date-month      = 2DIGIT  ; 01-12
date-mday       = 2DIGIT  ; 01-28, 01-29, 01-30, 01-31 based on
                          ; month/year
time-hour       = 2DIGIT  ; 00-23
time-minute     = 2DIGIT  ; 00-59
time-second     = 2DIGIT  ; 00-58, 00-59, 00-60 based on leap second
                          ; rules
time-secfrac    = "." 1*DIGIT
time-numoffset  = ("+" / "-") time-hour ":" time-minute
time-offset     = "Z" / time-numoffset

partial-time    = time-hour ":" time-minute ":" time-second
                  [time-secfrac]
full-date       = date-fullyear "-" date-month "-" date-mday
full-time       = partial-time time-offset

date-time       = full-date "T" full-time

; ------------------------------------------------------------------------------
; RFC 5234

ALPHA          =  %x41-5A / %x61-7A   ; A-Z / a-z
LF             =  %x0A
                  ; linefeed
DIGIT          =  %x30-39
                  ; 0-9
HEXDIG         =  DIGIT / "A" / "B" / "C" / "D" / "E" / "F"
`;
class ParsedMessage {
    constructor(msg) {
        const api = new api_1.default(GRAMMAR);
        api.generate();
        if (api.errors.length) {
            console.error(api.errorsToAscii());
            console.error(api.linesToAscii());
            console.log(api.displayAttributeErrors());
            throw new Error(`ABNF grammar has errors`);
        }
        const grammarObj = api.toObject();
        const parser = new node_exports_1.default.parser();
        parser.ast = new node_exports_1.default.ast();
        const id = node_exports_1.default.ids;
        const domain = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.domain = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks.domain = domain;
        const address = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.address = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks.address = address;
        const statement = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.statement = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks.statement = statement;
        const uri = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                if (!data.uri) {
                    data.uri = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
                }
            }
            return ret;
        };
        parser.ast.callbacks.uri = uri;
        const version = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.version = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks.version = version;
        const chainId = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.chainId = parseInt(node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength));
            }
            return ret;
        };
        parser.ast.callbacks['chain-id'] = chainId;
        const nonce = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.nonce = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks.nonce = nonce;
        const issuedAt = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.issuedAt = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks['issued-at'] = issuedAt;
        const expirationTime = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.expirationTime = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks['expiration-time'] = expirationTime;
        const notBefore = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.notBefore = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks['not-before'] = notBefore;
        const requestId = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.requestId = node_exports_1.default.utils.charsToString(chars, phraseIndex, phraseLength);
            }
            return ret;
        };
        parser.ast.callbacks['request-id'] = requestId;
        const resources = function (state, chars, phraseIndex, phraseLength, data) {
            const ret = id.SEM_OK;
            if (state === id.SEM_PRE) {
                data.resources = node_exports_1.default.utils
                    .charsToString(chars, phraseIndex, phraseLength)
                    .slice(3)
                    .split('\n- ');
            }
            return ret;
        };
        parser.ast.callbacks.resources = resources;
        const result = parser.parse(grammarObj, 'sign-in-with-ethereum', msg);
        if (!result.success) {
            throw new Error(`Invalid message: ${JSON.stringify(result)}`);
        }
        const elements = {};
        parser.ast.translate(elements);
        for (const [key, value] of Object.entries(elements)) {
            this[key] = value;
        }
    }
}
exports.ParsedMessage = ParsedMessage;


/***/ }),

/***/ "../../node_modules/@spruceid/siwe-parser/dist/parsers.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ParsedMessageRegExp = exports.ParsedMessage = void 0;
const abnf_1 = __webpack_require__("../../node_modules/@spruceid/siwe-parser/dist/abnf.js");
Object.defineProperty(exports, "ParsedMessage", ({ enumerable: true, get: function () { return abnf_1.ParsedMessage; } }));
const regex_1 = __webpack_require__("../../node_modules/@spruceid/siwe-parser/dist/regex.js");
Object.defineProperty(exports, "ParsedMessageRegExp", ({ enumerable: true, get: function () { return regex_1.ParsedMessage; } }));


/***/ }),

/***/ "../../node_modules/@spruceid/siwe-parser/dist/regex.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ParsedMessage = void 0;
const DOMAIN = '(?<domain>([^?#]*)) wants you to sign in with your Ethereum account:';
const ADDRESS = '\\n(?<address>0x[a-zA-Z0-9]{40})\\n\\n';
const STATEMENT = '((?<statement>[^\\n]+)\\n)?';
const URI = '(([^:?#]+):)?(([^?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))';
const URI_LINE = `\\nURI: (?<uri>${URI}?)`;
const VERSION = '\\nVersion: (?<version>1)';
const CHAIN_ID = '\\nChain ID: (?<chainId>[0-9]+)';
const NONCE = '\\nNonce: (?<nonce>[a-zA-Z0-9]{8,})';
const DATETIME = `([0-9]+)-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])[Tt]([01][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9]|60)(\.[0-9]+)?(([Zz])|([\+|\-]([01][0-9]|2[0-3]):[0-5][0-9]))`;
const ISSUED_AT = `\\nIssued At: (?<issuedAt>${DATETIME})`;
const EXPIRATION_TIME = `(\\nExpiration Time: (?<expirationTime>${DATETIME}))?`;
const NOT_BEFORE = `(\\nNot Before: (?<notBefore>${DATETIME}))?`;
const REQUEST_ID = "(\\nRequest ID: (?<requestId>[-._~!$&'()*+,;=:@%a-zA-Z0-9]*))?";
const RESOURCES = `(\\nResources:(?<resources>(\\n- ${URI}?)+))?`;
const MESSAGE = `^${DOMAIN}${ADDRESS}${STATEMENT}${URI_LINE}${VERSION}${CHAIN_ID}${NONCE}${ISSUED_AT}${EXPIRATION_TIME}${NOT_BEFORE}${REQUEST_ID}${RESOURCES}$`;
class ParsedMessage {
    constructor(msg) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        const REGEX = new RegExp(MESSAGE, 'g');
        let match = REGEX.exec(msg);
        if (!match) {
            throw new Error('Message did not match the regular expression.');
        }
        this.match = match;
        this.domain = (_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.domain;
        this.address = (_b = match === null || match === void 0 ? void 0 : match.groups) === null || _b === void 0 ? void 0 : _b.address;
        this.statement = (_c = match === null || match === void 0 ? void 0 : match.groups) === null || _c === void 0 ? void 0 : _c.statement;
        this.uri = (_d = match === null || match === void 0 ? void 0 : match.groups) === null || _d === void 0 ? void 0 : _d.uri;
        this.version = (_e = match === null || match === void 0 ? void 0 : match.groups) === null || _e === void 0 ? void 0 : _e.version;
        this.nonce = (_f = match === null || match === void 0 ? void 0 : match.groups) === null || _f === void 0 ? void 0 : _f.nonce;
        this.chainId = parseInt((_g = match === null || match === void 0 ? void 0 : match.groups) === null || _g === void 0 ? void 0 : _g.chainId);
        this.issuedAt = (_h = match === null || match === void 0 ? void 0 : match.groups) === null || _h === void 0 ? void 0 : _h.issuedAt;
        this.expirationTime = (_j = match === null || match === void 0 ? void 0 : match.groups) === null || _j === void 0 ? void 0 : _j.expirationTime;
        this.notBefore = (_k = match === null || match === void 0 ? void 0 : match.groups) === null || _k === void 0 ? void 0 : _k.notBefore;
        this.requestId = (_l = match === null || match === void 0 ? void 0 : match.groups) === null || _l === void 0 ? void 0 : _l.requestId;
        this.resources = (_o = (_m = match === null || match === void 0 ? void 0 : match.groups) === null || _m === void 0 ? void 0 : _m.resources) === null || _o === void 0 ? void 0 : _o.split('\n- ').slice(1);
    }
}
exports.ParsedMessage = ParsedMessage;


/***/ }),

/***/ "../../node_modules/@stablelib/binary/lib/binary.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Package binary provides functions for encoding and decoding numbers in byte arrays.
 */
var int_1 = __webpack_require__("../../node_modules/@stablelib/int/lib/int.js");
// TODO(dchest): add asserts for correct value ranges and array offsets.
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * signed 16-bit integer and returns it.
 */
function readInt16BE(array, offset) {
    if (offset === void 0) { offset = 0; }
    return (((array[offset + 0] << 8) | array[offset + 1]) << 16) >> 16;
}
exports.readInt16BE = readInt16BE;
/**
 * Reads 2 bytes from array starting at offset as big-endian
 * unsigned 16-bit integer and returns it.
 */
function readUint16BE(array, offset) {
    if (offset === void 0) { offset = 0; }
    return ((array[offset + 0] << 8) | array[offset + 1]) >>> 0;
}
exports.readUint16BE = readUint16BE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * signed 16-bit integer and returns it.
 */
function readInt16LE(array, offset) {
    if (offset === void 0) { offset = 0; }
    return (((array[offset + 1] << 8) | array[offset]) << 16) >> 16;
}
exports.readInt16LE = readInt16LE;
/**
 * Reads 2 bytes from array starting at offset as little-endian
 * unsigned 16-bit integer and returns it.
 */
function readUint16LE(array, offset) {
    if (offset === void 0) { offset = 0; }
    return ((array[offset + 1] << 8) | array[offset]) >>> 0;
}
exports.readUint16LE = readUint16LE;
/**
 * Writes 2-byte big-endian representation of 16-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */
function writeUint16BE(value, out, offset) {
    if (out === void 0) { out = new Uint8Array(2); }
    if (offset === void 0) { offset = 0; }
    out[offset + 0] = value >>> 8;
    out[offset + 1] = value >>> 0;
    return out;
}
exports.writeUint16BE = writeUint16BE;
exports.writeInt16BE = writeUint16BE;
/**
 * Writes 2-byte little-endian representation of 16-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 2-byte one.
 *
 * Returns the output byte array.
 */
function writeUint16LE(value, out, offset) {
    if (out === void 0) { out = new Uint8Array(2); }
    if (offset === void 0) { offset = 0; }
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    return out;
}
exports.writeUint16LE = writeUint16LE;
exports.writeInt16LE = writeUint16LE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * signed 32-bit integer and returns it.
 */
function readInt32BE(array, offset) {
    if (offset === void 0) { offset = 0; }
    return (array[offset] << 24) |
        (array[offset + 1] << 16) |
        (array[offset + 2] << 8) |
        array[offset + 3];
}
exports.readInt32BE = readInt32BE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * unsigned 32-bit integer and returns it.
 */
function readUint32BE(array, offset) {
    if (offset === void 0) { offset = 0; }
    return ((array[offset] << 24) |
        (array[offset + 1] << 16) |
        (array[offset + 2] << 8) |
        array[offset + 3]) >>> 0;
}
exports.readUint32BE = readUint32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * signed 32-bit integer and returns it.
 */
function readInt32LE(array, offset) {
    if (offset === void 0) { offset = 0; }
    return (array[offset + 3] << 24) |
        (array[offset + 2] << 16) |
        (array[offset + 1] << 8) |
        array[offset];
}
exports.readInt32LE = readInt32LE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * unsigned 32-bit integer and returns it.
 */
function readUint32LE(array, offset) {
    if (offset === void 0) { offset = 0; }
    return ((array[offset + 3] << 24) |
        (array[offset + 2] << 16) |
        (array[offset + 1] << 8) |
        array[offset]) >>> 0;
}
exports.readUint32LE = readUint32LE;
/**
 * Writes 4-byte big-endian representation of 32-bit unsigned
 * value to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */
function writeUint32BE(value, out, offset) {
    if (out === void 0) { out = new Uint8Array(4); }
    if (offset === void 0) { offset = 0; }
    out[offset + 0] = value >>> 24;
    out[offset + 1] = value >>> 16;
    out[offset + 2] = value >>> 8;
    out[offset + 3] = value >>> 0;
    return out;
}
exports.writeUint32BE = writeUint32BE;
exports.writeInt32BE = writeUint32BE;
/**
 * Writes 4-byte little-endian representation of 32-bit unsigned
 * value to array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */
function writeUint32LE(value, out, offset) {
    if (out === void 0) { out = new Uint8Array(4); }
    if (offset === void 0) { offset = 0; }
    out[offset + 0] = value >>> 0;
    out[offset + 1] = value >>> 8;
    out[offset + 2] = value >>> 16;
    out[offset + 3] = value >>> 24;
    return out;
}
exports.writeUint32LE = writeUint32LE;
exports.writeInt32LE = writeUint32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */
function readInt64BE(array, offset) {
    if (offset === void 0) { offset = 0; }
    var hi = readInt32BE(array, offset);
    var lo = readInt32BE(array, offset + 4);
    return hi * 0x100000000 + lo - ((lo >> 31) * 0x100000000);
}
exports.readInt64BE = readInt64BE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */
function readUint64BE(array, offset) {
    if (offset === void 0) { offset = 0; }
    var hi = readUint32BE(array, offset);
    var lo = readUint32BE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
exports.readUint64BE = readUint64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * signed 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports exact
 * numbers in range -9007199254740991 to 9007199254740991.
 * If the number stored in the byte array is outside this range,
 * the result is not exact.
 */
function readInt64LE(array, offset) {
    if (offset === void 0) { offset = 0; }
    var lo = readInt32LE(array, offset);
    var hi = readInt32LE(array, offset + 4);
    return hi * 0x100000000 + lo - ((lo >> 31) * 0x100000000);
}
exports.readInt64LE = readInt64LE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * unsigned 64-bit integer and returns it.
 *
 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
 */
function readUint64LE(array, offset) {
    if (offset === void 0) { offset = 0; }
    var lo = readUint32LE(array, offset);
    var hi = readUint32LE(array, offset + 4);
    return hi * 0x100000000 + lo;
}
exports.readUint64LE = readUint64LE;
/**
 * Writes 8-byte big-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */
function writeUint64BE(value, out, offset) {
    if (out === void 0) { out = new Uint8Array(8); }
    if (offset === void 0) { offset = 0; }
    writeUint32BE(value / 0x100000000 >>> 0, out, offset);
    writeUint32BE(value >>> 0, out, offset + 4);
    return out;
}
exports.writeUint64BE = writeUint64BE;
exports.writeInt64BE = writeUint64BE;
/**
 * Writes 8-byte little-endian representation of 64-bit unsigned
 * value to byte array starting at offset.
 *
 * Due to JavaScript limitation, supports values up to 2^53-1.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */
function writeUint64LE(value, out, offset) {
    if (out === void 0) { out = new Uint8Array(8); }
    if (offset === void 0) { offset = 0; }
    writeUint32LE(value >>> 0, out, offset);
    writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
    return out;
}
exports.writeUint64LE = writeUint64LE;
exports.writeInt64LE = writeUint64LE;
/**
 * Reads bytes from array starting at offset as big-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */
function readUintBE(bitLength, array, offset) {
    if (offset === void 0) { offset = 0; }
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) {
        throw new Error("readUintBE supports only bitLengths divisible by 8");
    }
    if (bitLength / 8 > array.length - offset) {
        throw new Error("readUintBE: array is too short for the given bitLength");
    }
    var result = 0;
    var mul = 1;
    for (var i = bitLength / 8 + offset - 1; i >= offset; i--) {
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
exports.readUintBE = readUintBE;
/**
 * Reads bytes from array starting at offset as little-endian
 * unsigned bitLen-bit integer and returns it.
 *
 * Supports bit lengths divisible by 8, up to 48.
 */
function readUintLE(bitLength, array, offset) {
    if (offset === void 0) { offset = 0; }
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) {
        throw new Error("readUintLE supports only bitLengths divisible by 8");
    }
    if (bitLength / 8 > array.length - offset) {
        throw new Error("readUintLE: array is too short for the given bitLength");
    }
    var result = 0;
    var mul = 1;
    for (var i = offset; i < offset + bitLength / 8; i++) {
        result += array[i] * mul;
        mul *= 256;
    }
    return result;
}
exports.readUintLE = readUintLE;
/**
 * Writes a big-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */
function writeUintBE(bitLength, value, out, offset) {
    if (out === void 0) { out = new Uint8Array(bitLength / 8); }
    if (offset === void 0) { offset = 0; }
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) {
        throw new Error("writeUintBE supports only bitLengths divisible by 8");
    }
    if (!int_1.isSafeInteger(value)) {
        throw new Error("writeUintBE value must be an integer");
    }
    var div = 1;
    for (var i = bitLength / 8 + offset - 1; i >= offset; i--) {
        out[i] = (value / div) & 0xff;
        div *= 256;
    }
    return out;
}
exports.writeUintBE = writeUintBE;
/**
 * Writes a little-endian representation of bitLen-bit unsigned
 * value to array starting at offset.
 *
 * Supports bit lengths divisible by 8, up to 48.
 *
 * If byte array is not given, creates a new one.
 *
 * Returns the output byte array.
 */
function writeUintLE(bitLength, value, out, offset) {
    if (out === void 0) { out = new Uint8Array(bitLength / 8); }
    if (offset === void 0) { offset = 0; }
    // TODO(dchest): implement support for bitLengths non-divisible by 8
    if (bitLength % 8 !== 0) {
        throw new Error("writeUintLE supports only bitLengths divisible by 8");
    }
    if (!int_1.isSafeInteger(value)) {
        throw new Error("writeUintLE value must be an integer");
    }
    var div = 1;
    for (var i = offset; i < offset + bitLength / 8; i++) {
        out[i] = (value / div) & 0xff;
        div *= 256;
    }
    return out;
}
exports.writeUintLE = writeUintLE;
/**
 * Reads 4 bytes from array starting at offset as big-endian
 * 32-bit floating-point number and returns it.
 */
function readFloat32BE(array, offset) {
    if (offset === void 0) { offset = 0; }
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset);
}
exports.readFloat32BE = readFloat32BE;
/**
 * Reads 4 bytes from array starting at offset as little-endian
 * 32-bit floating-point number and returns it.
 */
function readFloat32LE(array, offset) {
    if (offset === void 0) { offset = 0; }
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat32(offset, true);
}
exports.readFloat32LE = readFloat32LE;
/**
 * Reads 8 bytes from array starting at offset as big-endian
 * 64-bit floating-point number ("double") and returns it.
 */
function readFloat64BE(array, offset) {
    if (offset === void 0) { offset = 0; }
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset);
}
exports.readFloat64BE = readFloat64BE;
/**
 * Reads 8 bytes from array starting at offset as little-endian
 * 64-bit floating-point number ("double") and returns it.
 */
function readFloat64LE(array, offset) {
    if (offset === void 0) { offset = 0; }
    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
    return view.getFloat64(offset, true);
}
exports.readFloat64LE = readFloat64LE;
/**
 * Writes 4-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */
function writeFloat32BE(value, out, offset) {
    if (out === void 0) { out = new Uint8Array(4); }
    if (offset === void 0) { offset = 0; }
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value);
    return out;
}
exports.writeFloat32BE = writeFloat32BE;
/**
 * Writes 4-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 4-byte one.
 *
 * Returns the output byte array.
 */
function writeFloat32LE(value, out, offset) {
    if (out === void 0) { out = new Uint8Array(4); }
    if (offset === void 0) { offset = 0; }
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat32(offset, value, true);
    return out;
}
exports.writeFloat32LE = writeFloat32LE;
/**
 * Writes 8-byte big-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */
function writeFloat64BE(value, out, offset) {
    if (out === void 0) { out = new Uint8Array(8); }
    if (offset === void 0) { offset = 0; }
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value);
    return out;
}
exports.writeFloat64BE = writeFloat64BE;
/**
 * Writes 8-byte little-endian floating-point representation of value
 * to byte array starting at offset.
 *
 * If byte array is not given, creates a new 8-byte one.
 *
 * Returns the output byte array.
 */
function writeFloat64LE(value, out, offset) {
    if (out === void 0) { out = new Uint8Array(8); }
    if (offset === void 0) { offset = 0; }
    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
    view.setFloat64(offset, value, true);
    return out;
}
exports.writeFloat64LE = writeFloat64LE;
//# sourceMappingURL=binary.js.map

/***/ }),

/***/ "../../node_modules/@stablelib/int/lib/int.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Package int provides helper functions for integerss.
 */
// Shim using 16-bit pieces.
function imulShim(a, b) {
    var ah = (a >>> 16) & 0xffff, al = a & 0xffff;
    var bh = (b >>> 16) & 0xffff, bl = b & 0xffff;
    return ((al * bl) + (((ah * bl + al * bh) << 16) >>> 0) | 0);
}
/** 32-bit integer multiplication.  */
// Use system Math.imul if available, otherwise use our shim.
exports.mul = Math.imul || imulShim;
/** 32-bit integer addition.  */
function add(a, b) {
    return (a + b) | 0;
}
exports.add = add;
/**  32-bit integer subtraction.  */
function sub(a, b) {
    return (a - b) | 0;
}
exports.sub = sub;
/** 32-bit integer left rotation */
function rotl(x, n) {
    return x << n | x >>> (32 - n);
}
exports.rotl = rotl;
/** 32-bit integer left rotation */
function rotr(x, n) {
    return x << (32 - n) | x >>> n;
}
exports.rotr = rotr;
function isIntegerShim(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
}
/**
 * Returns true if the argument is an integer number.
 *
 * In ES2015, Number.isInteger.
 */
exports.isInteger = Number.isInteger || isIntegerShim;
/**
 *  Math.pow(2, 53) - 1
 *
 *  In ES2015 Number.MAX_SAFE_INTEGER.
 */
exports.MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Returns true if the argument is a safe integer number
 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
 *
 * In ES2015, Number.isSafeInteger.
 */
exports.isSafeInteger = function (n) {
    return exports.isInteger(n) && (n >= -exports.MAX_SAFE_INTEGER && n <= exports.MAX_SAFE_INTEGER);
};
//# sourceMappingURL=int.js.map

/***/ }),

/***/ "../../node_modules/@stablelib/random/lib/random.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.randomStringForEntropy = exports.randomString = exports.randomUint32 = exports.randomBytes = exports.defaultRandomSource = void 0;
const system_1 = __webpack_require__("../../node_modules/@stablelib/random/lib/source/system.js");
const binary_1 = __webpack_require__("../../node_modules/@stablelib/binary/lib/binary.js");
const wipe_1 = __webpack_require__("../../node_modules/@stablelib/wipe/lib/wipe.js");
exports.defaultRandomSource = new system_1.SystemRandomSource();
function randomBytes(length, prng = exports.defaultRandomSource) {
    return prng.randomBytes(length);
}
exports.randomBytes = randomBytes;
/**
 * Returns a uniformly random unsigned 32-bit integer.
 */
function randomUint32(prng = exports.defaultRandomSource) {
    // Generate 4-byte random buffer.
    const buf = randomBytes(4, prng);
    // Convert bytes from buffer into a 32-bit integer.
    // It's not important which byte order to use, since
    // the result is random.
    const result = (0, binary_1.readUint32LE)(buf);
    // Clean the buffer.
    (0, wipe_1.wipe)(buf);
    return result;
}
exports.randomUint32 = randomUint32;
/** 62 alphanumeric characters for default charset of randomString() */
const ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
/**
 * Returns a uniform random string of the given length
 * with characters from the given charset.
 *
 * Charset must not have more than 256 characters.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */
function randomString(length, charset = ALPHANUMERIC, prng = exports.defaultRandomSource) {
    if (charset.length < 2) {
        throw new Error("randomString charset is too short");
    }
    if (charset.length > 256) {
        throw new Error("randomString charset is too long");
    }
    let out = '';
    const charsLen = charset.length;
    const maxByte = 256 - (256 % charsLen);
    while (length > 0) {
        const buf = randomBytes(Math.ceil(length * 256 / maxByte), prng);
        for (let i = 0; i < buf.length && length > 0; i++) {
            const randomByte = buf[i];
            if (randomByte < maxByte) {
                out += charset.charAt(randomByte % charsLen);
                length--;
            }
        }
        (0, wipe_1.wipe)(buf);
    }
    return out;
}
exports.randomString = randomString;
/**
 * Returns uniform random string containing at least the given
 * number of bits of entropy.
 *
 * For example, randomStringForEntropy(128) will return a 22-character
 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
 * will return a 39-character numeric string, both will contain at
 * least 128 bits of entropy.
 *
 * Default charset generates case-sensitive alphanumeric
 * strings (0-9, A-Z, a-z).
 */
function randomStringForEntropy(bits, charset = ALPHANUMERIC, prng = exports.defaultRandomSource) {
    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
    return randomString(length, charset, prng);
}
exports.randomStringForEntropy = randomStringForEntropy;
//# sourceMappingURL=random.js.map

/***/ }),

/***/ "../../node_modules/@stablelib/random/lib/source/browser.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.BrowserRandomSource = void 0;
const QUOTA = 65536;
class BrowserRandomSource {
    constructor() {
        this.isAvailable = false;
        this.isInstantiated = false;
        const browserCrypto = typeof self !== 'undefined'
            ? (self.crypto || self.msCrypto) // IE11 has msCrypto
            : null;
        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
            this._crypto = browserCrypto;
            this.isAvailable = true;
            this.isInstantiated = true;
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) {
            throw new Error("Browser random byte generator is not available.");
        }
        const out = new Uint8Array(length);
        for (let i = 0; i < out.length; i += QUOTA) {
            this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, QUOTA)));
        }
        return out;
    }
}
exports.BrowserRandomSource = BrowserRandomSource;
//# sourceMappingURL=browser.js.map

/***/ }),

/***/ "../../node_modules/@stablelib/random/lib/source/node.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NodeRandomSource = void 0;
const wipe_1 = __webpack_require__("../../node_modules/@stablelib/wipe/lib/wipe.js");
class NodeRandomSource {
    constructor() {
        this.isAvailable = false;
        this.isInstantiated = false;
        if (true) {
            const nodeCrypto = __webpack_require__("../../node_modules/crypto-browserify/index.js");
            if (nodeCrypto && nodeCrypto.randomBytes) {
                this._crypto = nodeCrypto;
                this.isAvailable = true;
                this.isInstantiated = true;
            }
        }
    }
    randomBytes(length) {
        if (!this.isAvailable || !this._crypto) {
            throw new Error("Node.js random byte generator is not available.");
        }
        // Get random bytes (result is Buffer).
        let buffer = this._crypto.randomBytes(length);
        // Make sure we got the length that we requested.
        if (buffer.length !== length) {
            throw new Error("NodeRandomSource: got fewer bytes than requested");
        }
        // Allocate output array.
        const out = new Uint8Array(length);
        // Copy bytes from buffer to output.
        for (let i = 0; i < out.length; i++) {
            out[i] = buffer[i];
        }
        // Cleanup.
        (0, wipe_1.wipe)(buffer);
        return out;
    }
}
exports.NodeRandomSource = NodeRandomSource;
//# sourceMappingURL=node.js.map

/***/ }),

/***/ "../../node_modules/@stablelib/random/lib/source/system.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SystemRandomSource = void 0;
const browser_1 = __webpack_require__("../../node_modules/@stablelib/random/lib/source/browser.js");
const node_1 = __webpack_require__("../../node_modules/@stablelib/random/lib/source/node.js");
class SystemRandomSource {
    constructor() {
        this.isAvailable = false;
        this.name = "";
        // Try browser.
        this._source = new browser_1.BrowserRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Browser";
            return;
        }
        // If no browser source, try Node.
        this._source = new node_1.NodeRandomSource();
        if (this._source.isAvailable) {
            this.isAvailable = true;
            this.name = "Node";
            return;
        }
        // No sources, we're out of options.
    }
    randomBytes(length) {
        if (!this.isAvailable) {
            throw new Error("System random byte generator is not available.");
        }
        return this._source.randomBytes(length);
    }
}
exports.SystemRandomSource = SystemRandomSource;
//# sourceMappingURL=system.js.map

/***/ }),

/***/ "../../node_modules/@stablelib/wipe/lib/wipe.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

// Copyright (C) 2016 Dmitry Chestnykh
// MIT License. See LICENSE file for details.
Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * Sets all values in the given array to zero and returns it.
 *
 * The fact that it sets bytes to zero can be relied on.
 *
 * There is no guarantee that this function makes data disappear from memory,
 * as runtime implementation can, for example, have copying garbage collector
 * that will make copies of sensitive data before we wipe it. Or that an
 * operating system will write our data to swap or sleep image. Another thing
 * is that an optimizing compiler can remove calls to this function or make it
 * no-op. There's nothing we can do with it, so we just do our best and hope
 * that everything will be okay and good will triumph over evil.
 */
function wipe(array) {
    // Right now it's similar to array.fill(0). If it turns
    // out that runtimes optimize this call away, maybe
    // we can try something else.
    for (var i = 0; i < array.length; i++) {
        array[i] = 0;
    }
    return array;
}
exports.wipe = wipe;
//# sourceMappingURL=wipe.js.map

/***/ }),

/***/ "../../node_modules/abort-controller/browser.js":
/***/ ((module) => {

"use strict";
/*globals self, window */


/*eslint-disable @mysticatea/prettier */
const { AbortController, AbortSignal } =
    typeof self !== "undefined" ? self :
    typeof window !== "undefined" ? window :
    /* otherwise */ undefined
/*eslint-enable @mysticatea/prettier */

module.exports = AbortController
module.exports.AbortSignal = AbortSignal
module.exports["default"] = AbortController


/***/ }),

/***/ "../../node_modules/aes-js/index.js":
/***/ (function(module) {

"use strict";


(function(root) {

    function checkInt(value) {
        return (parseInt(value) === value);
    }

    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) { return false; }

        for (var i = 0; i < arrayish.length; i++) {
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) {
                return false;
            }
        }

        return true;
    }

    function coerceArray(arg, copy) {

        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === 'Uint8Array') {

            if (copy) {
                if (arg.slice) {
                    arg = arg.slice();
                } else {
                    arg = Array.prototype.slice.call(arg);
                }
            }

            return arg;
        }

        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) {
                throw new Error('Array contains invalid value: ' + arg);
            }

            return new Uint8Array(arg);
        }

        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) {
            return new Uint8Array(arg);
        }

        throw new Error('unsupported array-like object');
    }

    function createArray(length) {
        return new Uint8Array(length);
    }

    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) {
                sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            } else {
                sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
            }
        }
        targetArray.set(sourceArray, targetStart);
    }



    var convertUtf8 = (function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while (i < text.length) {
                var c = text.charCodeAt(i++);

                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16))
                    i += 2;

                // otherwise, just the actual byte
                } else {
                    result.push(c)
                }
            }

            return coerceArray(result);
        }

        function fromBytes(bytes) {
            var result = [], i = 0;

            while (i < bytes.length) {
                var c = bytes[i];

                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode(((c & 0x1f) << 6) | (bytes[i + 1] & 0x3f)));
                    i += 2;
                } else {
                    result.push(String.fromCharCode(((c & 0x0f) << 12) | ((bytes[i + 1] & 0x3f) << 6) | (bytes[i + 2] & 0x3f)));
                    i += 3;
                }
            }

            return result.join('');
        }

        return {
            toBytes: toBytes,
            fromBytes: fromBytes,
        }
    })();

    var convertHex = (function() {
        function toBytes(text) {
            var result = [];
            for (var i = 0; i < text.length; i += 2) {
                result.push(parseInt(text.substr(i, 2), 16));
            }

            return result;
        }

        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = '0123456789abcdef';

        function fromBytes(bytes) {
                var result = [];
                for (var i = 0; i < bytes.length; i++) {
                    var v = bytes[i];
                    result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
                }
                return result.join('');
        }

        return {
            toBytes: toBytes,
            fromBytes: fromBytes,
        }
    })();


    // Number of rounds by keysize
    var numberOfRounds = {16: 10, 24: 12, 32: 14}

    // Round constant words
    var rcon = [0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36, 0x6c, 0xd8, 0xab, 0x4d, 0x9a, 0x2f, 0x5e, 0xbc, 0x63, 0xc6, 0x97, 0x35, 0x6a, 0xd4, 0xb3, 0x7d, 0xfa, 0xef, 0xc5, 0x91];

    // S-box and Inverse S-box (S is for Substitution)
    var S = [0x63, 0x7c, 0x77, 0x7b, 0xf2, 0x6b, 0x6f, 0xc5, 0x30, 0x01, 0x67, 0x2b, 0xfe, 0xd7, 0xab, 0x76, 0xca, 0x82, 0xc9, 0x7d, 0xfa, 0x59, 0x47, 0xf0, 0xad, 0xd4, 0xa2, 0xaf, 0x9c, 0xa4, 0x72, 0xc0, 0xb7, 0xfd, 0x93, 0x26, 0x36, 0x3f, 0xf7, 0xcc, 0x34, 0xa5, 0xe5, 0xf1, 0x71, 0xd8, 0x31, 0x15, 0x04, 0xc7, 0x23, 0xc3, 0x18, 0x96, 0x05, 0x9a, 0x07, 0x12, 0x80, 0xe2, 0xeb, 0x27, 0xb2, 0x75, 0x09, 0x83, 0x2c, 0x1a, 0x1b, 0x6e, 0x5a, 0xa0, 0x52, 0x3b, 0xd6, 0xb3, 0x29, 0xe3, 0x2f, 0x84, 0x53, 0xd1, 0x00, 0xed, 0x20, 0xfc, 0xb1, 0x5b, 0x6a, 0xcb, 0xbe, 0x39, 0x4a, 0x4c, 0x58, 0xcf, 0xd0, 0xef, 0xaa, 0xfb, 0x43, 0x4d, 0x33, 0x85, 0x45, 0xf9, 0x02, 0x7f, 0x50, 0x3c, 0x9f, 0xa8, 0x51, 0xa3, 0x40, 0x8f, 0x92, 0x9d, 0x38, 0xf5, 0xbc, 0xb6, 0xda, 0x21, 0x10, 0xff, 0xf3, 0xd2, 0xcd, 0x0c, 0x13, 0xec, 0x5f, 0x97, 0x44, 0x17, 0xc4, 0xa7, 0x7e, 0x3d, 0x64, 0x5d, 0x19, 0x73, 0x60, 0x81, 0x4f, 0xdc, 0x22, 0x2a, 0x90, 0x88, 0x46, 0xee, 0xb8, 0x14, 0xde, 0x5e, 0x0b, 0xdb, 0xe0, 0x32, 0x3a, 0x0a, 0x49, 0x06, 0x24, 0x5c, 0xc2, 0xd3, 0xac, 0x62, 0x91, 0x95, 0xe4, 0x79, 0xe7, 0xc8, 0x37, 0x6d, 0x8d, 0xd5, 0x4e, 0xa9, 0x6c, 0x56, 0xf4, 0xea, 0x65, 0x7a, 0xae, 0x08, 0xba, 0x78, 0x25, 0x2e, 0x1c, 0xa6, 0xb4, 0xc6, 0xe8, 0xdd, 0x74, 0x1f, 0x4b, 0xbd, 0x8b, 0x8a, 0x70, 0x3e, 0xb5, 0x66, 0x48, 0x03, 0xf6, 0x0e, 0x61, 0x35, 0x57, 0xb9, 0x86, 0xc1, 0x1d, 0x9e, 0xe1, 0xf8, 0x98, 0x11, 0x69, 0xd9, 0x8e, 0x94, 0x9b, 0x1e, 0x87, 0xe9, 0xce, 0x55, 0x28, 0xdf, 0x8c, 0xa1, 0x89, 0x0d, 0xbf, 0xe6, 0x42, 0x68, 0x41, 0x99, 0x2d, 0x0f, 0xb0, 0x54, 0xbb, 0x16];
    var Si =[0x52, 0x09, 0x6a, 0xd5, 0x30, 0x36, 0xa5, 0x38, 0xbf, 0x40, 0xa3, 0x9e, 0x81, 0xf3, 0xd7, 0xfb, 0x7c, 0xe3, 0x39, 0x82, 0x9b, 0x2f, 0xff, 0x87, 0x34, 0x8e, 0x43, 0x44, 0xc4, 0xde, 0xe9, 0xcb, 0x54, 0x7b, 0x94, 0x32, 0xa6, 0xc2, 0x23, 0x3d, 0xee, 0x4c, 0x95, 0x0b, 0x42, 0xfa, 0xc3, 0x4e, 0x08, 0x2e, 0xa1, 0x66, 0x28, 0xd9, 0x24, 0xb2, 0x76, 0x5b, 0xa2, 0x49, 0x6d, 0x8b, 0xd1, 0x25, 0x72, 0xf8, 0xf6, 0x64, 0x86, 0x68, 0x98, 0x16, 0xd4, 0xa4, 0x5c, 0xcc, 0x5d, 0x65, 0xb6, 0x92, 0x6c, 0x70, 0x48, 0x50, 0xfd, 0xed, 0xb9, 0xda, 0x5e, 0x15, 0x46, 0x57, 0xa7, 0x8d, 0x9d, 0x84, 0x90, 0xd8, 0xab, 0x00, 0x8c, 0xbc, 0xd3, 0x0a, 0xf7, 0xe4, 0x58, 0x05, 0xb8, 0xb3, 0x45, 0x06, 0xd0, 0x2c, 0x1e, 0x8f, 0xca, 0x3f, 0x0f, 0x02, 0xc1, 0xaf, 0xbd, 0x03, 0x01, 0x13, 0x8a, 0x6b, 0x3a, 0x91, 0x11, 0x41, 0x4f, 0x67, 0xdc, 0xea, 0x97, 0xf2, 0xcf, 0xce, 0xf0, 0xb4, 0xe6, 0x73, 0x96, 0xac, 0x74, 0x22, 0xe7, 0xad, 0x35, 0x85, 0xe2, 0xf9, 0x37, 0xe8, 0x1c, 0x75, 0xdf, 0x6e, 0x47, 0xf1, 0x1a, 0x71, 0x1d, 0x29, 0xc5, 0x89, 0x6f, 0xb7, 0x62, 0x0e, 0xaa, 0x18, 0xbe, 0x1b, 0xfc, 0x56, 0x3e, 0x4b, 0xc6, 0xd2, 0x79, 0x20, 0x9a, 0xdb, 0xc0, 0xfe, 0x78, 0xcd, 0x5a, 0xf4, 0x1f, 0xdd, 0xa8, 0x33, 0x88, 0x07, 0xc7, 0x31, 0xb1, 0x12, 0x10, 0x59, 0x27, 0x80, 0xec, 0x5f, 0x60, 0x51, 0x7f, 0xa9, 0x19, 0xb5, 0x4a, 0x0d, 0x2d, 0xe5, 0x7a, 0x9f, 0x93, 0xc9, 0x9c, 0xef, 0xa0, 0xe0, 0x3b, 0x4d, 0xae, 0x2a, 0xf5, 0xb0, 0xc8, 0xeb, 0xbb, 0x3c, 0x83, 0x53, 0x99, 0x61, 0x17, 0x2b, 0x04, 0x7e, 0xba, 0x77, 0xd6, 0x26, 0xe1, 0x69, 0x14, 0x63, 0x55, 0x21, 0x0c, 0x7d];

    // Transformations for encryption
    var T1 = [0xc66363a5, 0xf87c7c84, 0xee777799, 0xf67b7b8d, 0xfff2f20d, 0xd66b6bbd, 0xde6f6fb1, 0x91c5c554, 0x60303050, 0x02010103, 0xce6767a9, 0x562b2b7d, 0xe7fefe19, 0xb5d7d762, 0x4dababe6, 0xec76769a, 0x8fcaca45, 0x1f82829d, 0x89c9c940, 0xfa7d7d87, 0xeffafa15, 0xb25959eb, 0x8e4747c9, 0xfbf0f00b, 0x41adadec, 0xb3d4d467, 0x5fa2a2fd, 0x45afafea, 0x239c9cbf, 0x53a4a4f7, 0xe4727296, 0x9bc0c05b, 0x75b7b7c2, 0xe1fdfd1c, 0x3d9393ae, 0x4c26266a, 0x6c36365a, 0x7e3f3f41, 0xf5f7f702, 0x83cccc4f, 0x6834345c, 0x51a5a5f4, 0xd1e5e534, 0xf9f1f108, 0xe2717193, 0xabd8d873, 0x62313153, 0x2a15153f, 0x0804040c, 0x95c7c752, 0x46232365, 0x9dc3c35e, 0x30181828, 0x379696a1, 0x0a05050f, 0x2f9a9ab5, 0x0e070709, 0x24121236, 0x1b80809b, 0xdfe2e23d, 0xcdebeb26, 0x4e272769, 0x7fb2b2cd, 0xea75759f, 0x1209091b, 0x1d83839e, 0x582c2c74, 0x341a1a2e, 0x361b1b2d, 0xdc6e6eb2, 0xb45a5aee, 0x5ba0a0fb, 0xa45252f6, 0x763b3b4d, 0xb7d6d661, 0x7db3b3ce, 0x5229297b, 0xdde3e33e, 0x5e2f2f71, 0x13848497, 0xa65353f5, 0xb9d1d168, 0x00000000, 0xc1eded2c, 0x40202060, 0xe3fcfc1f, 0x79b1b1c8, 0xb65b5bed, 0xd46a6abe, 0x8dcbcb46, 0x67bebed9, 0x7239394b, 0x944a4ade, 0x984c4cd4, 0xb05858e8, 0x85cfcf4a, 0xbbd0d06b, 0xc5efef2a, 0x4faaaae5, 0xedfbfb16, 0x864343c5, 0x9a4d4dd7, 0x66333355, 0x11858594, 0x8a4545cf, 0xe9f9f910, 0x04020206, 0xfe7f7f81, 0xa05050f0, 0x783c3c44, 0x259f9fba, 0x4ba8a8e3, 0xa25151f3, 0x5da3a3fe, 0x804040c0, 0x058f8f8a, 0x3f9292ad, 0x219d9dbc, 0x70383848, 0xf1f5f504, 0x63bcbcdf, 0x77b6b6c1, 0xafdada75, 0x42212163, 0x20101030, 0xe5ffff1a, 0xfdf3f30e, 0xbfd2d26d, 0x81cdcd4c, 0x180c0c14, 0x26131335, 0xc3ecec2f, 0xbe5f5fe1, 0x359797a2, 0x884444cc, 0x2e171739, 0x93c4c457, 0x55a7a7f2, 0xfc7e7e82, 0x7a3d3d47, 0xc86464ac, 0xba5d5de7, 0x3219192b, 0xe6737395, 0xc06060a0, 0x19818198, 0x9e4f4fd1, 0xa3dcdc7f, 0x44222266, 0x542a2a7e, 0x3b9090ab, 0x0b888883, 0x8c4646ca, 0xc7eeee29, 0x6bb8b8d3, 0x2814143c, 0xa7dede79, 0xbc5e5ee2, 0x160b0b1d, 0xaddbdb76, 0xdbe0e03b, 0x64323256, 0x743a3a4e, 0x140a0a1e, 0x924949db, 0x0c06060a, 0x4824246c, 0xb85c5ce4, 0x9fc2c25d, 0xbdd3d36e, 0x43acacef, 0xc46262a6, 0x399191a8, 0x319595a4, 0xd3e4e437, 0xf279798b, 0xd5e7e732, 0x8bc8c843, 0x6e373759, 0xda6d6db7, 0x018d8d8c, 0xb1d5d564, 0x9c4e4ed2, 0x49a9a9e0, 0xd86c6cb4, 0xac5656fa, 0xf3f4f407, 0xcfeaea25, 0xca6565af, 0xf47a7a8e, 0x47aeaee9, 0x10080818, 0x6fbabad5, 0xf0787888, 0x4a25256f, 0x5c2e2e72, 0x381c1c24, 0x57a6a6f1, 0x73b4b4c7, 0x97c6c651, 0xcbe8e823, 0xa1dddd7c, 0xe874749c, 0x3e1f1f21, 0x964b4bdd, 0x61bdbddc, 0x0d8b8b86, 0x0f8a8a85, 0xe0707090, 0x7c3e3e42, 0x71b5b5c4, 0xcc6666aa, 0x904848d8, 0x06030305, 0xf7f6f601, 0x1c0e0e12, 0xc26161a3, 0x6a35355f, 0xae5757f9, 0x69b9b9d0, 0x17868691, 0x99c1c158, 0x3a1d1d27, 0x279e9eb9, 0xd9e1e138, 0xebf8f813, 0x2b9898b3, 0x22111133, 0xd26969bb, 0xa9d9d970, 0x078e8e89, 0x339494a7, 0x2d9b9bb6, 0x3c1e1e22, 0x15878792, 0xc9e9e920, 0x87cece49, 0xaa5555ff, 0x50282878, 0xa5dfdf7a, 0x038c8c8f, 0x59a1a1f8, 0x09898980, 0x1a0d0d17, 0x65bfbfda, 0xd7e6e631, 0x844242c6, 0xd06868b8, 0x824141c3, 0x299999b0, 0x5a2d2d77, 0x1e0f0f11, 0x7bb0b0cb, 0xa85454fc, 0x6dbbbbd6, 0x2c16163a];
    var T2 = [0xa5c66363, 0x84f87c7c, 0x99ee7777, 0x8df67b7b, 0x0dfff2f2, 0xbdd66b6b, 0xb1de6f6f, 0x5491c5c5, 0x50603030, 0x03020101, 0xa9ce6767, 0x7d562b2b, 0x19e7fefe, 0x62b5d7d7, 0xe64dabab, 0x9aec7676, 0x458fcaca, 0x9d1f8282, 0x4089c9c9, 0x87fa7d7d, 0x15effafa, 0xebb25959, 0xc98e4747, 0x0bfbf0f0, 0xec41adad, 0x67b3d4d4, 0xfd5fa2a2, 0xea45afaf, 0xbf239c9c, 0xf753a4a4, 0x96e47272, 0x5b9bc0c0, 0xc275b7b7, 0x1ce1fdfd, 0xae3d9393, 0x6a4c2626, 0x5a6c3636, 0x417e3f3f, 0x02f5f7f7, 0x4f83cccc, 0x5c683434, 0xf451a5a5, 0x34d1e5e5, 0x08f9f1f1, 0x93e27171, 0x73abd8d8, 0x53623131, 0x3f2a1515, 0x0c080404, 0x5295c7c7, 0x65462323, 0x5e9dc3c3, 0x28301818, 0xa1379696, 0x0f0a0505, 0xb52f9a9a, 0x090e0707, 0x36241212, 0x9b1b8080, 0x3ddfe2e2, 0x26cdebeb, 0x694e2727, 0xcd7fb2b2, 0x9fea7575, 0x1b120909, 0x9e1d8383, 0x74582c2c, 0x2e341a1a, 0x2d361b1b, 0xb2dc6e6e, 0xeeb45a5a, 0xfb5ba0a0, 0xf6a45252, 0x4d763b3b, 0x61b7d6d6, 0xce7db3b3, 0x7b522929, 0x3edde3e3, 0x715e2f2f, 0x97138484, 0xf5a65353, 0x68b9d1d1, 0x00000000, 0x2cc1eded, 0x60402020, 0x1fe3fcfc, 0xc879b1b1, 0xedb65b5b, 0xbed46a6a, 0x468dcbcb, 0xd967bebe, 0x4b723939, 0xde944a4a, 0xd4984c4c, 0xe8b05858, 0x4a85cfcf, 0x6bbbd0d0, 0x2ac5efef, 0xe54faaaa, 0x16edfbfb, 0xc5864343, 0xd79a4d4d, 0x55663333, 0x94118585, 0xcf8a4545, 0x10e9f9f9, 0x06040202, 0x81fe7f7f, 0xf0a05050, 0x44783c3c, 0xba259f9f, 0xe34ba8a8, 0xf3a25151, 0xfe5da3a3, 0xc0804040, 0x8a058f8f, 0xad3f9292, 0xbc219d9d, 0x48703838, 0x04f1f5f5, 0xdf63bcbc, 0xc177b6b6, 0x75afdada, 0x63422121, 0x30201010, 0x1ae5ffff, 0x0efdf3f3, 0x6dbfd2d2, 0x4c81cdcd, 0x14180c0c, 0x35261313, 0x2fc3ecec, 0xe1be5f5f, 0xa2359797, 0xcc884444, 0x392e1717, 0x5793c4c4, 0xf255a7a7, 0x82fc7e7e, 0x477a3d3d, 0xacc86464, 0xe7ba5d5d, 0x2b321919, 0x95e67373, 0xa0c06060, 0x98198181, 0xd19e4f4f, 0x7fa3dcdc, 0x66442222, 0x7e542a2a, 0xab3b9090, 0x830b8888, 0xca8c4646, 0x29c7eeee, 0xd36bb8b8, 0x3c281414, 0x79a7dede, 0xe2bc5e5e, 0x1d160b0b, 0x76addbdb, 0x3bdbe0e0, 0x56643232, 0x4e743a3a, 0x1e140a0a, 0xdb924949, 0x0a0c0606, 0x6c482424, 0xe4b85c5c, 0x5d9fc2c2, 0x6ebdd3d3, 0xef43acac, 0xa6c46262, 0xa8399191, 0xa4319595, 0x37d3e4e4, 0x8bf27979, 0x32d5e7e7, 0x438bc8c8, 0x596e3737, 0xb7da6d6d, 0x8c018d8d, 0x64b1d5d5, 0xd29c4e4e, 0xe049a9a9, 0xb4d86c6c, 0xfaac5656, 0x07f3f4f4, 0x25cfeaea, 0xafca6565, 0x8ef47a7a, 0xe947aeae, 0x18100808, 0xd56fbaba, 0x88f07878, 0x6f4a2525, 0x725c2e2e, 0x24381c1c, 0xf157a6a6, 0xc773b4b4, 0x5197c6c6, 0x23cbe8e8, 0x7ca1dddd, 0x9ce87474, 0x213e1f1f, 0xdd964b4b, 0xdc61bdbd, 0x860d8b8b, 0x850f8a8a, 0x90e07070, 0x427c3e3e, 0xc471b5b5, 0xaacc6666, 0xd8904848, 0x05060303, 0x01f7f6f6, 0x121c0e0e, 0xa3c26161, 0x5f6a3535, 0xf9ae5757, 0xd069b9b9, 0x91178686, 0x5899c1c1, 0x273a1d1d, 0xb9279e9e, 0x38d9e1e1, 0x13ebf8f8, 0xb32b9898, 0x33221111, 0xbbd26969, 0x70a9d9d9, 0x89078e8e, 0xa7339494, 0xb62d9b9b, 0x223c1e1e, 0x92158787, 0x20c9e9e9, 0x4987cece, 0xffaa5555, 0x78502828, 0x7aa5dfdf, 0x8f038c8c, 0xf859a1a1, 0x80098989, 0x171a0d0d, 0xda65bfbf, 0x31d7e6e6, 0xc6844242, 0xb8d06868, 0xc3824141, 0xb0299999, 0x775a2d2d, 0x111e0f0f, 0xcb7bb0b0, 0xfca85454, 0xd66dbbbb, 0x3a2c1616];
    var T3 = [0x63a5c663, 0x7c84f87c, 0x7799ee77, 0x7b8df67b, 0xf20dfff2, 0x6bbdd66b, 0x6fb1de6f, 0xc55491c5, 0x30506030, 0x01030201, 0x67a9ce67, 0x2b7d562b, 0xfe19e7fe, 0xd762b5d7, 0xabe64dab, 0x769aec76, 0xca458fca, 0x829d1f82, 0xc94089c9, 0x7d87fa7d, 0xfa15effa, 0x59ebb259, 0x47c98e47, 0xf00bfbf0, 0xadec41ad, 0xd467b3d4, 0xa2fd5fa2, 0xafea45af, 0x9cbf239c, 0xa4f753a4, 0x7296e472, 0xc05b9bc0, 0xb7c275b7, 0xfd1ce1fd, 0x93ae3d93, 0x266a4c26, 0x365a6c36, 0x3f417e3f, 0xf702f5f7, 0xcc4f83cc, 0x345c6834, 0xa5f451a5, 0xe534d1e5, 0xf108f9f1, 0x7193e271, 0xd873abd8, 0x31536231, 0x153f2a15, 0x040c0804, 0xc75295c7, 0x23654623, 0xc35e9dc3, 0x18283018, 0x96a13796, 0x050f0a05, 0x9ab52f9a, 0x07090e07, 0x12362412, 0x809b1b80, 0xe23ddfe2, 0xeb26cdeb, 0x27694e27, 0xb2cd7fb2, 0x759fea75, 0x091b1209, 0x839e1d83, 0x2c74582c, 0x1a2e341a, 0x1b2d361b, 0x6eb2dc6e, 0x5aeeb45a, 0xa0fb5ba0, 0x52f6a452, 0x3b4d763b, 0xd661b7d6, 0xb3ce7db3, 0x297b5229, 0xe33edde3, 0x2f715e2f, 0x84971384, 0x53f5a653, 0xd168b9d1, 0x00000000, 0xed2cc1ed, 0x20604020, 0xfc1fe3fc, 0xb1c879b1, 0x5bedb65b, 0x6abed46a, 0xcb468dcb, 0xbed967be, 0x394b7239, 0x4ade944a, 0x4cd4984c, 0x58e8b058, 0xcf4a85cf, 0xd06bbbd0, 0xef2ac5ef, 0xaae54faa, 0xfb16edfb, 0x43c58643, 0x4dd79a4d, 0x33556633, 0x85941185, 0x45cf8a45, 0xf910e9f9, 0x02060402, 0x7f81fe7f, 0x50f0a050, 0x3c44783c, 0x9fba259f, 0xa8e34ba8, 0x51f3a251, 0xa3fe5da3, 0x40c08040, 0x8f8a058f, 0x92ad3f92, 0x9dbc219d, 0x38487038, 0xf504f1f5, 0xbcdf63bc, 0xb6c177b6, 0xda75afda, 0x21634221, 0x10302010, 0xff1ae5ff, 0xf30efdf3, 0xd26dbfd2, 0xcd4c81cd, 0x0c14180c, 0x13352613, 0xec2fc3ec, 0x5fe1be5f, 0x97a23597, 0x44cc8844, 0x17392e17, 0xc45793c4, 0xa7f255a7, 0x7e82fc7e, 0x3d477a3d, 0x64acc864, 0x5de7ba5d, 0x192b3219, 0x7395e673, 0x60a0c060, 0x81981981, 0x4fd19e4f, 0xdc7fa3dc, 0x22664422, 0x2a7e542a, 0x90ab3b90, 0x88830b88, 0x46ca8c46, 0xee29c7ee, 0xb8d36bb8, 0x143c2814, 0xde79a7de, 0x5ee2bc5e, 0x0b1d160b, 0xdb76addb, 0xe03bdbe0, 0x32566432, 0x3a4e743a, 0x0a1e140a, 0x49db9249, 0x060a0c06, 0x246c4824, 0x5ce4b85c, 0xc25d9fc2, 0xd36ebdd3, 0xacef43ac, 0x62a6c462, 0x91a83991, 0x95a43195, 0xe437d3e4, 0x798bf279, 0xe732d5e7, 0xc8438bc8, 0x37596e37, 0x6db7da6d, 0x8d8c018d, 0xd564b1d5, 0x4ed29c4e, 0xa9e049a9, 0x6cb4d86c, 0x56faac56, 0xf407f3f4, 0xea25cfea, 0x65afca65, 0x7a8ef47a, 0xaee947ae, 0x08181008, 0xbad56fba, 0x7888f078, 0x256f4a25, 0x2e725c2e, 0x1c24381c, 0xa6f157a6, 0xb4c773b4, 0xc65197c6, 0xe823cbe8, 0xdd7ca1dd, 0x749ce874, 0x1f213e1f, 0x4bdd964b, 0xbddc61bd, 0x8b860d8b, 0x8a850f8a, 0x7090e070, 0x3e427c3e, 0xb5c471b5, 0x66aacc66, 0x48d89048, 0x03050603, 0xf601f7f6, 0x0e121c0e, 0x61a3c261, 0x355f6a35, 0x57f9ae57, 0xb9d069b9, 0x86911786, 0xc15899c1, 0x1d273a1d, 0x9eb9279e, 0xe138d9e1, 0xf813ebf8, 0x98b32b98, 0x11332211, 0x69bbd269, 0xd970a9d9, 0x8e89078e, 0x94a73394, 0x9bb62d9b, 0x1e223c1e, 0x87921587, 0xe920c9e9, 0xce4987ce, 0x55ffaa55, 0x28785028, 0xdf7aa5df, 0x8c8f038c, 0xa1f859a1, 0x89800989, 0x0d171a0d, 0xbfda65bf, 0xe631d7e6, 0x42c68442, 0x68b8d068, 0x41c38241, 0x99b02999, 0x2d775a2d, 0x0f111e0f, 0xb0cb7bb0, 0x54fca854, 0xbbd66dbb, 0x163a2c16];
    var T4 = [0x6363a5c6, 0x7c7c84f8, 0x777799ee, 0x7b7b8df6, 0xf2f20dff, 0x6b6bbdd6, 0x6f6fb1de, 0xc5c55491, 0x30305060, 0x01010302, 0x6767a9ce, 0x2b2b7d56, 0xfefe19e7, 0xd7d762b5, 0xababe64d, 0x76769aec, 0xcaca458f, 0x82829d1f, 0xc9c94089, 0x7d7d87fa, 0xfafa15ef, 0x5959ebb2, 0x4747c98e, 0xf0f00bfb, 0xadadec41, 0xd4d467b3, 0xa2a2fd5f, 0xafafea45, 0x9c9cbf23, 0xa4a4f753, 0x727296e4, 0xc0c05b9b, 0xb7b7c275, 0xfdfd1ce1, 0x9393ae3d, 0x26266a4c, 0x36365a6c, 0x3f3f417e, 0xf7f702f5, 0xcccc4f83, 0x34345c68, 0xa5a5f451, 0xe5e534d1, 0xf1f108f9, 0x717193e2, 0xd8d873ab, 0x31315362, 0x15153f2a, 0x04040c08, 0xc7c75295, 0x23236546, 0xc3c35e9d, 0x18182830, 0x9696a137, 0x05050f0a, 0x9a9ab52f, 0x0707090e, 0x12123624, 0x80809b1b, 0xe2e23ddf, 0xebeb26cd, 0x2727694e, 0xb2b2cd7f, 0x75759fea, 0x09091b12, 0x83839e1d, 0x2c2c7458, 0x1a1a2e34, 0x1b1b2d36, 0x6e6eb2dc, 0x5a5aeeb4, 0xa0a0fb5b, 0x5252f6a4, 0x3b3b4d76, 0xd6d661b7, 0xb3b3ce7d, 0x29297b52, 0xe3e33edd, 0x2f2f715e, 0x84849713, 0x5353f5a6, 0xd1d168b9, 0x00000000, 0xeded2cc1, 0x20206040, 0xfcfc1fe3, 0xb1b1c879, 0x5b5bedb6, 0x6a6abed4, 0xcbcb468d, 0xbebed967, 0x39394b72, 0x4a4ade94, 0x4c4cd498, 0x5858e8b0, 0xcfcf4a85, 0xd0d06bbb, 0xefef2ac5, 0xaaaae54f, 0xfbfb16ed, 0x4343c586, 0x4d4dd79a, 0x33335566, 0x85859411, 0x4545cf8a, 0xf9f910e9, 0x02020604, 0x7f7f81fe, 0x5050f0a0, 0x3c3c4478, 0x9f9fba25, 0xa8a8e34b, 0x5151f3a2, 0xa3a3fe5d, 0x4040c080, 0x8f8f8a05, 0x9292ad3f, 0x9d9dbc21, 0x38384870, 0xf5f504f1, 0xbcbcdf63, 0xb6b6c177, 0xdada75af, 0x21216342, 0x10103020, 0xffff1ae5, 0xf3f30efd, 0xd2d26dbf, 0xcdcd4c81, 0x0c0c1418, 0x13133526, 0xecec2fc3, 0x5f5fe1be, 0x9797a235, 0x4444cc88, 0x1717392e, 0xc4c45793, 0xa7a7f255, 0x7e7e82fc, 0x3d3d477a, 0x6464acc8, 0x5d5de7ba, 0x19192b32, 0x737395e6, 0x6060a0c0, 0x81819819, 0x4f4fd19e, 0xdcdc7fa3, 0x22226644, 0x2a2a7e54, 0x9090ab3b, 0x8888830b, 0x4646ca8c, 0xeeee29c7, 0xb8b8d36b, 0x14143c28, 0xdede79a7, 0x5e5ee2bc, 0x0b0b1d16, 0xdbdb76ad, 0xe0e03bdb, 0x32325664, 0x3a3a4e74, 0x0a0a1e14, 0x4949db92, 0x06060a0c, 0x24246c48, 0x5c5ce4b8, 0xc2c25d9f, 0xd3d36ebd, 0xacacef43, 0x6262a6c4, 0x9191a839, 0x9595a431, 0xe4e437d3, 0x79798bf2, 0xe7e732d5, 0xc8c8438b, 0x3737596e, 0x6d6db7da, 0x8d8d8c01, 0xd5d564b1, 0x4e4ed29c, 0xa9a9e049, 0x6c6cb4d8, 0x5656faac, 0xf4f407f3, 0xeaea25cf, 0x6565afca, 0x7a7a8ef4, 0xaeaee947, 0x08081810, 0xbabad56f, 0x787888f0, 0x25256f4a, 0x2e2e725c, 0x1c1c2438, 0xa6a6f157, 0xb4b4c773, 0xc6c65197, 0xe8e823cb, 0xdddd7ca1, 0x74749ce8, 0x1f1f213e, 0x4b4bdd96, 0xbdbddc61, 0x8b8b860d, 0x8a8a850f, 0x707090e0, 0x3e3e427c, 0xb5b5c471, 0x6666aacc, 0x4848d890, 0x03030506, 0xf6f601f7, 0x0e0e121c, 0x6161a3c2, 0x35355f6a, 0x5757f9ae, 0xb9b9d069, 0x86869117, 0xc1c15899, 0x1d1d273a, 0x9e9eb927, 0xe1e138d9, 0xf8f813eb, 0x9898b32b, 0x11113322, 0x6969bbd2, 0xd9d970a9, 0x8e8e8907, 0x9494a733, 0x9b9bb62d, 0x1e1e223c, 0x87879215, 0xe9e920c9, 0xcece4987, 0x5555ffaa, 0x28287850, 0xdfdf7aa5, 0x8c8c8f03, 0xa1a1f859, 0x89898009, 0x0d0d171a, 0xbfbfda65, 0xe6e631d7, 0x4242c684, 0x6868b8d0, 0x4141c382, 0x9999b029, 0x2d2d775a, 0x0f0f111e, 0xb0b0cb7b, 0x5454fca8, 0xbbbbd66d, 0x16163a2c];

    // Transformations for decryption
    var T5 = [0x51f4a750, 0x7e416553, 0x1a17a4c3, 0x3a275e96, 0x3bab6bcb, 0x1f9d45f1, 0xacfa58ab, 0x4be30393, 0x2030fa55, 0xad766df6, 0x88cc7691, 0xf5024c25, 0x4fe5d7fc, 0xc52acbd7, 0x26354480, 0xb562a38f, 0xdeb15a49, 0x25ba1b67, 0x45ea0e98, 0x5dfec0e1, 0xc32f7502, 0x814cf012, 0x8d4697a3, 0x6bd3f9c6, 0x038f5fe7, 0x15929c95, 0xbf6d7aeb, 0x955259da, 0xd4be832d, 0x587421d3, 0x49e06929, 0x8ec9c844, 0x75c2896a, 0xf48e7978, 0x99583e6b, 0x27b971dd, 0xbee14fb6, 0xf088ad17, 0xc920ac66, 0x7dce3ab4, 0x63df4a18, 0xe51a3182, 0x97513360, 0x62537f45, 0xb16477e0, 0xbb6bae84, 0xfe81a01c, 0xf9082b94, 0x70486858, 0x8f45fd19, 0x94de6c87, 0x527bf8b7, 0xab73d323, 0x724b02e2, 0xe31f8f57, 0x6655ab2a, 0xb2eb2807, 0x2fb5c203, 0x86c57b9a, 0xd33708a5, 0x302887f2, 0x23bfa5b2, 0x02036aba, 0xed16825c, 0x8acf1c2b, 0xa779b492, 0xf307f2f0, 0x4e69e2a1, 0x65daf4cd, 0x0605bed5, 0xd134621f, 0xc4a6fe8a, 0x342e539d, 0xa2f355a0, 0x058ae132, 0xa4f6eb75, 0x0b83ec39, 0x4060efaa, 0x5e719f06, 0xbd6e1051, 0x3e218af9, 0x96dd063d, 0xdd3e05ae, 0x4de6bd46, 0x91548db5, 0x71c45d05, 0x0406d46f, 0x605015ff, 0x1998fb24, 0xd6bde997, 0x894043cc, 0x67d99e77, 0xb0e842bd, 0x07898b88, 0xe7195b38, 0x79c8eedb, 0xa17c0a47, 0x7c420fe9, 0xf8841ec9, 0x00000000, 0x09808683, 0x322bed48, 0x1e1170ac, 0x6c5a724e, 0xfd0efffb, 0x0f853856, 0x3daed51e, 0x362d3927, 0x0a0fd964, 0x685ca621, 0x9b5b54d1, 0x24362e3a, 0x0c0a67b1, 0x9357e70f, 0xb4ee96d2, 0x1b9b919e, 0x80c0c54f, 0x61dc20a2, 0x5a774b69, 0x1c121a16, 0xe293ba0a, 0xc0a02ae5, 0x3c22e043, 0x121b171d, 0x0e090d0b, 0xf28bc7ad, 0x2db6a8b9, 0x141ea9c8, 0x57f11985, 0xaf75074c, 0xee99ddbb, 0xa37f60fd, 0xf701269f, 0x5c72f5bc, 0x44663bc5, 0x5bfb7e34, 0x8b432976, 0xcb23c6dc, 0xb6edfc68, 0xb8e4f163, 0xd731dcca, 0x42638510, 0x13972240, 0x84c61120, 0x854a247d, 0xd2bb3df8, 0xaef93211, 0xc729a16d, 0x1d9e2f4b, 0xdcb230f3, 0x0d8652ec, 0x77c1e3d0, 0x2bb3166c, 0xa970b999, 0x119448fa, 0x47e96422, 0xa8fc8cc4, 0xa0f03f1a, 0x567d2cd8, 0x223390ef, 0x87494ec7, 0xd938d1c1, 0x8ccaa2fe, 0x98d40b36, 0xa6f581cf, 0xa57ade28, 0xdab78e26, 0x3fadbfa4, 0x2c3a9de4, 0x5078920d, 0x6a5fcc9b, 0x547e4662, 0xf68d13c2, 0x90d8b8e8, 0x2e39f75e, 0x82c3aff5, 0x9f5d80be, 0x69d0937c, 0x6fd52da9, 0xcf2512b3, 0xc8ac993b, 0x10187da7, 0xe89c636e, 0xdb3bbb7b, 0xcd267809, 0x6e5918f4, 0xec9ab701, 0x834f9aa8, 0xe6956e65, 0xaaffe67e, 0x21bccf08, 0xef15e8e6, 0xbae79bd9, 0x4a6f36ce, 0xea9f09d4, 0x29b07cd6, 0x31a4b2af, 0x2a3f2331, 0xc6a59430, 0x35a266c0, 0x744ebc37, 0xfc82caa6, 0xe090d0b0, 0x33a7d815, 0xf104984a, 0x41ecdaf7, 0x7fcd500e, 0x1791f62f, 0x764dd68d, 0x43efb04d, 0xccaa4d54, 0xe49604df, 0x9ed1b5e3, 0x4c6a881b, 0xc12c1fb8, 0x4665517f, 0x9d5eea04, 0x018c355d, 0xfa877473, 0xfb0b412e, 0xb3671d5a, 0x92dbd252, 0xe9105633, 0x6dd64713, 0x9ad7618c, 0x37a10c7a, 0x59f8148e, 0xeb133c89, 0xcea927ee, 0xb761c935, 0xe11ce5ed, 0x7a47b13c, 0x9cd2df59, 0x55f2733f, 0x1814ce79, 0x73c737bf, 0x53f7cdea, 0x5ffdaa5b, 0xdf3d6f14, 0x7844db86, 0xcaaff381, 0xb968c43e, 0x3824342c, 0xc2a3405f, 0x161dc372, 0xbce2250c, 0x283c498b, 0xff0d9541, 0x39a80171, 0x080cb3de, 0xd8b4e49c, 0x6456c190, 0x7bcb8461, 0xd532b670, 0x486c5c74, 0xd0b85742];
    var T6 = [0x5051f4a7, 0x537e4165, 0xc31a17a4, 0x963a275e, 0xcb3bab6b, 0xf11f9d45, 0xabacfa58, 0x934be303, 0x552030fa, 0xf6ad766d, 0x9188cc76, 0x25f5024c, 0xfc4fe5d7, 0xd7c52acb, 0x80263544, 0x8fb562a3, 0x49deb15a, 0x6725ba1b, 0x9845ea0e, 0xe15dfec0, 0x02c32f75, 0x12814cf0, 0xa38d4697, 0xc66bd3f9, 0xe7038f5f, 0x9515929c, 0xebbf6d7a, 0xda955259, 0x2dd4be83, 0xd3587421, 0x2949e069, 0x448ec9c8, 0x6a75c289, 0x78f48e79, 0x6b99583e, 0xdd27b971, 0xb6bee14f, 0x17f088ad, 0x66c920ac, 0xb47dce3a, 0x1863df4a, 0x82e51a31, 0x60975133, 0x4562537f, 0xe0b16477, 0x84bb6bae, 0x1cfe81a0, 0x94f9082b, 0x58704868, 0x198f45fd, 0x8794de6c, 0xb7527bf8, 0x23ab73d3, 0xe2724b02, 0x57e31f8f, 0x2a6655ab, 0x07b2eb28, 0x032fb5c2, 0x9a86c57b, 0xa5d33708, 0xf2302887, 0xb223bfa5, 0xba02036a, 0x5ced1682, 0x2b8acf1c, 0x92a779b4, 0xf0f307f2, 0xa14e69e2, 0xcd65daf4, 0xd50605be, 0x1fd13462, 0x8ac4a6fe, 0x9d342e53, 0xa0a2f355, 0x32058ae1, 0x75a4f6eb, 0x390b83ec, 0xaa4060ef, 0x065e719f, 0x51bd6e10, 0xf93e218a, 0x3d96dd06, 0xaedd3e05, 0x464de6bd, 0xb591548d, 0x0571c45d, 0x6f0406d4, 0xff605015, 0x241998fb, 0x97d6bde9, 0xcc894043, 0x7767d99e, 0xbdb0e842, 0x8807898b, 0x38e7195b, 0xdb79c8ee, 0x47a17c0a, 0xe97c420f, 0xc9f8841e, 0x00000000, 0x83098086, 0x48322bed, 0xac1e1170, 0x4e6c5a72, 0xfbfd0eff, 0x560f8538, 0x1e3daed5, 0x27362d39, 0x640a0fd9, 0x21685ca6, 0xd19b5b54, 0x3a24362e, 0xb10c0a67, 0x0f9357e7, 0xd2b4ee96, 0x9e1b9b91, 0x4f80c0c5, 0xa261dc20, 0x695a774b, 0x161c121a, 0x0ae293ba, 0xe5c0a02a, 0x433c22e0, 0x1d121b17, 0x0b0e090d, 0xadf28bc7, 0xb92db6a8, 0xc8141ea9, 0x8557f119, 0x4caf7507, 0xbbee99dd, 0xfda37f60, 0x9ff70126, 0xbc5c72f5, 0xc544663b, 0x345bfb7e, 0x768b4329, 0xdccb23c6, 0x68b6edfc, 0x63b8e4f1, 0xcad731dc, 0x10426385, 0x40139722, 0x2084c611, 0x7d854a24, 0xf8d2bb3d, 0x11aef932, 0x6dc729a1, 0x4b1d9e2f, 0xf3dcb230, 0xec0d8652, 0xd077c1e3, 0x6c2bb316, 0x99a970b9, 0xfa119448, 0x2247e964, 0xc4a8fc8c, 0x1aa0f03f, 0xd8567d2c, 0xef223390, 0xc787494e, 0xc1d938d1, 0xfe8ccaa2, 0x3698d40b, 0xcfa6f581, 0x28a57ade, 0x26dab78e, 0xa43fadbf, 0xe42c3a9d, 0x0d507892, 0x9b6a5fcc, 0x62547e46, 0xc2f68d13, 0xe890d8b8, 0x5e2e39f7, 0xf582c3af, 0xbe9f5d80, 0x7c69d093, 0xa96fd52d, 0xb3cf2512, 0x3bc8ac99, 0xa710187d, 0x6ee89c63, 0x7bdb3bbb, 0x09cd2678, 0xf46e5918, 0x01ec9ab7, 0xa8834f9a, 0x65e6956e, 0x7eaaffe6, 0x0821bccf, 0xe6ef15e8, 0xd9bae79b, 0xce4a6f36, 0xd4ea9f09, 0xd629b07c, 0xaf31a4b2, 0x312a3f23, 0x30c6a594, 0xc035a266, 0x37744ebc, 0xa6fc82ca, 0xb0e090d0, 0x1533a7d8, 0x4af10498, 0xf741ecda, 0x0e7fcd50, 0x2f1791f6, 0x8d764dd6, 0x4d43efb0, 0x54ccaa4d, 0xdfe49604, 0xe39ed1b5, 0x1b4c6a88, 0xb8c12c1f, 0x7f466551, 0x049d5eea, 0x5d018c35, 0x73fa8774, 0x2efb0b41, 0x5ab3671d, 0x5292dbd2, 0x33e91056, 0x136dd647, 0x8c9ad761, 0x7a37a10c, 0x8e59f814, 0x89eb133c, 0xeecea927, 0x35b761c9, 0xede11ce5, 0x3c7a47b1, 0x599cd2df, 0x3f55f273, 0x791814ce, 0xbf73c737, 0xea53f7cd, 0x5b5ffdaa, 0x14df3d6f, 0x867844db, 0x81caaff3, 0x3eb968c4, 0x2c382434, 0x5fc2a340, 0x72161dc3, 0x0cbce225, 0x8b283c49, 0x41ff0d95, 0x7139a801, 0xde080cb3, 0x9cd8b4e4, 0x906456c1, 0x617bcb84, 0x70d532b6, 0x74486c5c, 0x42d0b857];
    var T7 = [0xa75051f4, 0x65537e41, 0xa4c31a17, 0x5e963a27, 0x6bcb3bab, 0x45f11f9d, 0x58abacfa, 0x03934be3, 0xfa552030, 0x6df6ad76, 0x769188cc, 0x4c25f502, 0xd7fc4fe5, 0xcbd7c52a, 0x44802635, 0xa38fb562, 0x5a49deb1, 0x1b6725ba, 0x0e9845ea, 0xc0e15dfe, 0x7502c32f, 0xf012814c, 0x97a38d46, 0xf9c66bd3, 0x5fe7038f, 0x9c951592, 0x7aebbf6d, 0x59da9552, 0x832dd4be, 0x21d35874, 0x692949e0, 0xc8448ec9, 0x896a75c2, 0x7978f48e, 0x3e6b9958, 0x71dd27b9, 0x4fb6bee1, 0xad17f088, 0xac66c920, 0x3ab47dce, 0x4a1863df, 0x3182e51a, 0x33609751, 0x7f456253, 0x77e0b164, 0xae84bb6b, 0xa01cfe81, 0x2b94f908, 0x68587048, 0xfd198f45, 0x6c8794de, 0xf8b7527b, 0xd323ab73, 0x02e2724b, 0x8f57e31f, 0xab2a6655, 0x2807b2eb, 0xc2032fb5, 0x7b9a86c5, 0x08a5d337, 0x87f23028, 0xa5b223bf, 0x6aba0203, 0x825ced16, 0x1c2b8acf, 0xb492a779, 0xf2f0f307, 0xe2a14e69, 0xf4cd65da, 0xbed50605, 0x621fd134, 0xfe8ac4a6, 0x539d342e, 0x55a0a2f3, 0xe132058a, 0xeb75a4f6, 0xec390b83, 0xefaa4060, 0x9f065e71, 0x1051bd6e, 0x8af93e21, 0x063d96dd, 0x05aedd3e, 0xbd464de6, 0x8db59154, 0x5d0571c4, 0xd46f0406, 0x15ff6050, 0xfb241998, 0xe997d6bd, 0x43cc8940, 0x9e7767d9, 0x42bdb0e8, 0x8b880789, 0x5b38e719, 0xeedb79c8, 0x0a47a17c, 0x0fe97c42, 0x1ec9f884, 0x00000000, 0x86830980, 0xed48322b, 0x70ac1e11, 0x724e6c5a, 0xfffbfd0e, 0x38560f85, 0xd51e3dae, 0x3927362d, 0xd9640a0f, 0xa621685c, 0x54d19b5b, 0x2e3a2436, 0x67b10c0a, 0xe70f9357, 0x96d2b4ee, 0x919e1b9b, 0xc54f80c0, 0x20a261dc, 0x4b695a77, 0x1a161c12, 0xba0ae293, 0x2ae5c0a0, 0xe0433c22, 0x171d121b, 0x0d0b0e09, 0xc7adf28b, 0xa8b92db6, 0xa9c8141e, 0x198557f1, 0x074caf75, 0xddbbee99, 0x60fda37f, 0x269ff701, 0xf5bc5c72, 0x3bc54466, 0x7e345bfb, 0x29768b43, 0xc6dccb23, 0xfc68b6ed, 0xf163b8e4, 0xdccad731, 0x85104263, 0x22401397, 0x112084c6, 0x247d854a, 0x3df8d2bb, 0x3211aef9, 0xa16dc729, 0x2f4b1d9e, 0x30f3dcb2, 0x52ec0d86, 0xe3d077c1, 0x166c2bb3, 0xb999a970, 0x48fa1194, 0x642247e9, 0x8cc4a8fc, 0x3f1aa0f0, 0x2cd8567d, 0x90ef2233, 0x4ec78749, 0xd1c1d938, 0xa2fe8cca, 0x0b3698d4, 0x81cfa6f5, 0xde28a57a, 0x8e26dab7, 0xbfa43fad, 0x9de42c3a, 0x920d5078, 0xcc9b6a5f, 0x4662547e, 0x13c2f68d, 0xb8e890d8, 0xf75e2e39, 0xaff582c3, 0x80be9f5d, 0x937c69d0, 0x2da96fd5, 0x12b3cf25, 0x993bc8ac, 0x7da71018, 0x636ee89c, 0xbb7bdb3b, 0x7809cd26, 0x18f46e59, 0xb701ec9a, 0x9aa8834f, 0x6e65e695, 0xe67eaaff, 0xcf0821bc, 0xe8e6ef15, 0x9bd9bae7, 0x36ce4a6f, 0x09d4ea9f, 0x7cd629b0, 0xb2af31a4, 0x23312a3f, 0x9430c6a5, 0x66c035a2, 0xbc37744e, 0xcaa6fc82, 0xd0b0e090, 0xd81533a7, 0x984af104, 0xdaf741ec, 0x500e7fcd, 0xf62f1791, 0xd68d764d, 0xb04d43ef, 0x4d54ccaa, 0x04dfe496, 0xb5e39ed1, 0x881b4c6a, 0x1fb8c12c, 0x517f4665, 0xea049d5e, 0x355d018c, 0x7473fa87, 0x412efb0b, 0x1d5ab367, 0xd25292db, 0x5633e910, 0x47136dd6, 0x618c9ad7, 0x0c7a37a1, 0x148e59f8, 0x3c89eb13, 0x27eecea9, 0xc935b761, 0xe5ede11c, 0xb13c7a47, 0xdf599cd2, 0x733f55f2, 0xce791814, 0x37bf73c7, 0xcdea53f7, 0xaa5b5ffd, 0x6f14df3d, 0xdb867844, 0xf381caaf, 0xc43eb968, 0x342c3824, 0x405fc2a3, 0xc372161d, 0x250cbce2, 0x498b283c, 0x9541ff0d, 0x017139a8, 0xb3de080c, 0xe49cd8b4, 0xc1906456, 0x84617bcb, 0xb670d532, 0x5c74486c, 0x5742d0b8];
    var T8 = [0xf4a75051, 0x4165537e, 0x17a4c31a, 0x275e963a, 0xab6bcb3b, 0x9d45f11f, 0xfa58abac, 0xe303934b, 0x30fa5520, 0x766df6ad, 0xcc769188, 0x024c25f5, 0xe5d7fc4f, 0x2acbd7c5, 0x35448026, 0x62a38fb5, 0xb15a49de, 0xba1b6725, 0xea0e9845, 0xfec0e15d, 0x2f7502c3, 0x4cf01281, 0x4697a38d, 0xd3f9c66b, 0x8f5fe703, 0x929c9515, 0x6d7aebbf, 0x5259da95, 0xbe832dd4, 0x7421d358, 0xe0692949, 0xc9c8448e, 0xc2896a75, 0x8e7978f4, 0x583e6b99, 0xb971dd27, 0xe14fb6be, 0x88ad17f0, 0x20ac66c9, 0xce3ab47d, 0xdf4a1863, 0x1a3182e5, 0x51336097, 0x537f4562, 0x6477e0b1, 0x6bae84bb, 0x81a01cfe, 0x082b94f9, 0x48685870, 0x45fd198f, 0xde6c8794, 0x7bf8b752, 0x73d323ab, 0x4b02e272, 0x1f8f57e3, 0x55ab2a66, 0xeb2807b2, 0xb5c2032f, 0xc57b9a86, 0x3708a5d3, 0x2887f230, 0xbfa5b223, 0x036aba02, 0x16825ced, 0xcf1c2b8a, 0x79b492a7, 0x07f2f0f3, 0x69e2a14e, 0xdaf4cd65, 0x05bed506, 0x34621fd1, 0xa6fe8ac4, 0x2e539d34, 0xf355a0a2, 0x8ae13205, 0xf6eb75a4, 0x83ec390b, 0x60efaa40, 0x719f065e, 0x6e1051bd, 0x218af93e, 0xdd063d96, 0x3e05aedd, 0xe6bd464d, 0x548db591, 0xc45d0571, 0x06d46f04, 0x5015ff60, 0x98fb2419, 0xbde997d6, 0x4043cc89, 0xd99e7767, 0xe842bdb0, 0x898b8807, 0x195b38e7, 0xc8eedb79, 0x7c0a47a1, 0x420fe97c, 0x841ec9f8, 0x00000000, 0x80868309, 0x2bed4832, 0x1170ac1e, 0x5a724e6c, 0x0efffbfd, 0x8538560f, 0xaed51e3d, 0x2d392736, 0x0fd9640a, 0x5ca62168, 0x5b54d19b, 0x362e3a24, 0x0a67b10c, 0x57e70f93, 0xee96d2b4, 0x9b919e1b, 0xc0c54f80, 0xdc20a261, 0x774b695a, 0x121a161c, 0x93ba0ae2, 0xa02ae5c0, 0x22e0433c, 0x1b171d12, 0x090d0b0e, 0x8bc7adf2, 0xb6a8b92d, 0x1ea9c814, 0xf1198557, 0x75074caf, 0x99ddbbee, 0x7f60fda3, 0x01269ff7, 0x72f5bc5c, 0x663bc544, 0xfb7e345b, 0x4329768b, 0x23c6dccb, 0xedfc68b6, 0xe4f163b8, 0x31dccad7, 0x63851042, 0x97224013, 0xc6112084, 0x4a247d85, 0xbb3df8d2, 0xf93211ae, 0x29a16dc7, 0x9e2f4b1d, 0xb230f3dc, 0x8652ec0d, 0xc1e3d077, 0xb3166c2b, 0x70b999a9, 0x9448fa11, 0xe9642247, 0xfc8cc4a8, 0xf03f1aa0, 0x7d2cd856, 0x3390ef22, 0x494ec787, 0x38d1c1d9, 0xcaa2fe8c, 0xd40b3698, 0xf581cfa6, 0x7ade28a5, 0xb78e26da, 0xadbfa43f, 0x3a9de42c, 0x78920d50, 0x5fcc9b6a, 0x7e466254, 0x8d13c2f6, 0xd8b8e890, 0x39f75e2e, 0xc3aff582, 0x5d80be9f, 0xd0937c69, 0xd52da96f, 0x2512b3cf, 0xac993bc8, 0x187da710, 0x9c636ee8, 0x3bbb7bdb, 0x267809cd, 0x5918f46e, 0x9ab701ec, 0x4f9aa883, 0x956e65e6, 0xffe67eaa, 0xbccf0821, 0x15e8e6ef, 0xe79bd9ba, 0x6f36ce4a, 0x9f09d4ea, 0xb07cd629, 0xa4b2af31, 0x3f23312a, 0xa59430c6, 0xa266c035, 0x4ebc3774, 0x82caa6fc, 0x90d0b0e0, 0xa7d81533, 0x04984af1, 0xecdaf741, 0xcd500e7f, 0x91f62f17, 0x4dd68d76, 0xefb04d43, 0xaa4d54cc, 0x9604dfe4, 0xd1b5e39e, 0x6a881b4c, 0x2c1fb8c1, 0x65517f46, 0x5eea049d, 0x8c355d01, 0x877473fa, 0x0b412efb, 0x671d5ab3, 0xdbd25292, 0x105633e9, 0xd647136d, 0xd7618c9a, 0xa10c7a37, 0xf8148e59, 0x133c89eb, 0xa927eece, 0x61c935b7, 0x1ce5ede1, 0x47b13c7a, 0xd2df599c, 0xf2733f55, 0x14ce7918, 0xc737bf73, 0xf7cdea53, 0xfdaa5b5f, 0x3d6f14df, 0x44db8678, 0xaff381ca, 0x68c43eb9, 0x24342c38, 0xa3405fc2, 0x1dc37216, 0xe2250cbc, 0x3c498b28, 0x0d9541ff, 0xa8017139, 0x0cb3de08, 0xb4e49cd8, 0x56c19064, 0xcb84617b, 0x32b670d5, 0x6c5c7448, 0xb85742d0];

    // Transformations for decryption key expansion
    var U1 = [0x00000000, 0x0e090d0b, 0x1c121a16, 0x121b171d, 0x3824342c, 0x362d3927, 0x24362e3a, 0x2a3f2331, 0x70486858, 0x7e416553, 0x6c5a724e, 0x62537f45, 0x486c5c74, 0x4665517f, 0x547e4662, 0x5a774b69, 0xe090d0b0, 0xee99ddbb, 0xfc82caa6, 0xf28bc7ad, 0xd8b4e49c, 0xd6bde997, 0xc4a6fe8a, 0xcaaff381, 0x90d8b8e8, 0x9ed1b5e3, 0x8ccaa2fe, 0x82c3aff5, 0xa8fc8cc4, 0xa6f581cf, 0xb4ee96d2, 0xbae79bd9, 0xdb3bbb7b, 0xd532b670, 0xc729a16d, 0xc920ac66, 0xe31f8f57, 0xed16825c, 0xff0d9541, 0xf104984a, 0xab73d323, 0xa57ade28, 0xb761c935, 0xb968c43e, 0x9357e70f, 0x9d5eea04, 0x8f45fd19, 0x814cf012, 0x3bab6bcb, 0x35a266c0, 0x27b971dd, 0x29b07cd6, 0x038f5fe7, 0x0d8652ec, 0x1f9d45f1, 0x119448fa, 0x4be30393, 0x45ea0e98, 0x57f11985, 0x59f8148e, 0x73c737bf, 0x7dce3ab4, 0x6fd52da9, 0x61dc20a2, 0xad766df6, 0xa37f60fd, 0xb16477e0, 0xbf6d7aeb, 0x955259da, 0x9b5b54d1, 0x894043cc, 0x87494ec7, 0xdd3e05ae, 0xd33708a5, 0xc12c1fb8, 0xcf2512b3, 0xe51a3182, 0xeb133c89, 0xf9082b94, 0xf701269f, 0x4de6bd46, 0x43efb04d, 0x51f4a750, 0x5ffdaa5b, 0x75c2896a, 0x7bcb8461, 0x69d0937c, 0x67d99e77, 0x3daed51e, 0x33a7d815, 0x21bccf08, 0x2fb5c203, 0x058ae132, 0x0b83ec39, 0x1998fb24, 0x1791f62f, 0x764dd68d, 0x7844db86, 0x6a5fcc9b, 0x6456c190, 0x4e69e2a1, 0x4060efaa, 0x527bf8b7, 0x5c72f5bc, 0x0605bed5, 0x080cb3de, 0x1a17a4c3, 0x141ea9c8, 0x3e218af9, 0x302887f2, 0x223390ef, 0x2c3a9de4, 0x96dd063d, 0x98d40b36, 0x8acf1c2b, 0x84c61120, 0xaef93211, 0xa0f03f1a, 0xb2eb2807, 0xbce2250c, 0xe6956e65, 0xe89c636e, 0xfa877473, 0xf48e7978, 0xdeb15a49, 0xd0b85742, 0xc2a3405f, 0xccaa4d54, 0x41ecdaf7, 0x4fe5d7fc, 0x5dfec0e1, 0x53f7cdea, 0x79c8eedb, 0x77c1e3d0, 0x65daf4cd, 0x6bd3f9c6, 0x31a4b2af, 0x3fadbfa4, 0x2db6a8b9, 0x23bfa5b2, 0x09808683, 0x07898b88, 0x15929c95, 0x1b9b919e, 0xa17c0a47, 0xaf75074c, 0xbd6e1051, 0xb3671d5a, 0x99583e6b, 0x97513360, 0x854a247d, 0x8b432976, 0xd134621f, 0xdf3d6f14, 0xcd267809, 0xc32f7502, 0xe9105633, 0xe7195b38, 0xf5024c25, 0xfb0b412e, 0x9ad7618c, 0x94de6c87, 0x86c57b9a, 0x88cc7691, 0xa2f355a0, 0xacfa58ab, 0xbee14fb6, 0xb0e842bd, 0xea9f09d4, 0xe49604df, 0xf68d13c2, 0xf8841ec9, 0xd2bb3df8, 0xdcb230f3, 0xcea927ee, 0xc0a02ae5, 0x7a47b13c, 0x744ebc37, 0x6655ab2a, 0x685ca621, 0x42638510, 0x4c6a881b, 0x5e719f06, 0x5078920d, 0x0a0fd964, 0x0406d46f, 0x161dc372, 0x1814ce79, 0x322bed48, 0x3c22e043, 0x2e39f75e, 0x2030fa55, 0xec9ab701, 0xe293ba0a, 0xf088ad17, 0xfe81a01c, 0xd4be832d, 0xdab78e26, 0xc8ac993b, 0xc6a59430, 0x9cd2df59, 0x92dbd252, 0x80c0c54f, 0x8ec9c844, 0xa4f6eb75, 0xaaffe67e, 0xb8e4f163, 0xb6edfc68, 0x0c0a67b1, 0x02036aba, 0x10187da7, 0x1e1170ac, 0x342e539d, 0x3a275e96, 0x283c498b, 0x26354480, 0x7c420fe9, 0x724b02e2, 0x605015ff, 0x6e5918f4, 0x44663bc5, 0x4a6f36ce, 0x587421d3, 0x567d2cd8, 0x37a10c7a, 0x39a80171, 0x2bb3166c, 0x25ba1b67, 0x0f853856, 0x018c355d, 0x13972240, 0x1d9e2f4b, 0x47e96422, 0x49e06929, 0x5bfb7e34, 0x55f2733f, 0x7fcd500e, 0x71c45d05, 0x63df4a18, 0x6dd64713, 0xd731dcca, 0xd938d1c1, 0xcb23c6dc, 0xc52acbd7, 0xef15e8e6, 0xe11ce5ed, 0xf307f2f0, 0xfd0efffb, 0xa779b492, 0xa970b999, 0xbb6bae84, 0xb562a38f, 0x9f5d80be, 0x91548db5, 0x834f9aa8, 0x8d4697a3];
    var U2 = [0x00000000, 0x0b0e090d, 0x161c121a, 0x1d121b17, 0x2c382434, 0x27362d39, 0x3a24362e, 0x312a3f23, 0x58704868, 0x537e4165, 0x4e6c5a72, 0x4562537f, 0x74486c5c, 0x7f466551, 0x62547e46, 0x695a774b, 0xb0e090d0, 0xbbee99dd, 0xa6fc82ca, 0xadf28bc7, 0x9cd8b4e4, 0x97d6bde9, 0x8ac4a6fe, 0x81caaff3, 0xe890d8b8, 0xe39ed1b5, 0xfe8ccaa2, 0xf582c3af, 0xc4a8fc8c, 0xcfa6f581, 0xd2b4ee96, 0xd9bae79b, 0x7bdb3bbb, 0x70d532b6, 0x6dc729a1, 0x66c920ac, 0x57e31f8f, 0x5ced1682, 0x41ff0d95, 0x4af10498, 0x23ab73d3, 0x28a57ade, 0x35b761c9, 0x3eb968c4, 0x0f9357e7, 0x049d5eea, 0x198f45fd, 0x12814cf0, 0xcb3bab6b, 0xc035a266, 0xdd27b971, 0xd629b07c, 0xe7038f5f, 0xec0d8652, 0xf11f9d45, 0xfa119448, 0x934be303, 0x9845ea0e, 0x8557f119, 0x8e59f814, 0xbf73c737, 0xb47dce3a, 0xa96fd52d, 0xa261dc20, 0xf6ad766d, 0xfda37f60, 0xe0b16477, 0xebbf6d7a, 0xda955259, 0xd19b5b54, 0xcc894043, 0xc787494e, 0xaedd3e05, 0xa5d33708, 0xb8c12c1f, 0xb3cf2512, 0x82e51a31, 0x89eb133c, 0x94f9082b, 0x9ff70126, 0x464de6bd, 0x4d43efb0, 0x5051f4a7, 0x5b5ffdaa, 0x6a75c289, 0x617bcb84, 0x7c69d093, 0x7767d99e, 0x1e3daed5, 0x1533a7d8, 0x0821bccf, 0x032fb5c2, 0x32058ae1, 0x390b83ec, 0x241998fb, 0x2f1791f6, 0x8d764dd6, 0x867844db, 0x9b6a5fcc, 0x906456c1, 0xa14e69e2, 0xaa4060ef, 0xb7527bf8, 0xbc5c72f5, 0xd50605be, 0xde080cb3, 0xc31a17a4, 0xc8141ea9, 0xf93e218a, 0xf2302887, 0xef223390, 0xe42c3a9d, 0x3d96dd06, 0x3698d40b, 0x2b8acf1c, 0x2084c611, 0x11aef932, 0x1aa0f03f, 0x07b2eb28, 0x0cbce225, 0x65e6956e, 0x6ee89c63, 0x73fa8774, 0x78f48e79, 0x49deb15a, 0x42d0b857, 0x5fc2a340, 0x54ccaa4d, 0xf741ecda, 0xfc4fe5d7, 0xe15dfec0, 0xea53f7cd, 0xdb79c8ee, 0xd077c1e3, 0xcd65daf4, 0xc66bd3f9, 0xaf31a4b2, 0xa43fadbf, 0xb92db6a8, 0xb223bfa5, 0x83098086, 0x8807898b, 0x9515929c, 0x9e1b9b91, 0x47a17c0a, 0x4caf7507, 0x51bd6e10, 0x5ab3671d, 0x6b99583e, 0x60975133, 0x7d854a24, 0x768b4329, 0x1fd13462, 0x14df3d6f, 0x09cd2678, 0x02c32f75, 0x33e91056, 0x38e7195b, 0x25f5024c, 0x2efb0b41, 0x8c9ad761, 0x8794de6c, 0x9a86c57b, 0x9188cc76, 0xa0a2f355, 0xabacfa58, 0xb6bee14f, 0xbdb0e842, 0xd4ea9f09, 0xdfe49604, 0xc2f68d13, 0xc9f8841e, 0xf8d2bb3d, 0xf3dcb230, 0xeecea927, 0xe5c0a02a, 0x3c7a47b1, 0x37744ebc, 0x2a6655ab, 0x21685ca6, 0x10426385, 0x1b4c6a88, 0x065e719f, 0x0d507892, 0x640a0fd9, 0x6f0406d4, 0x72161dc3, 0x791814ce, 0x48322bed, 0x433c22e0, 0x5e2e39f7, 0x552030fa, 0x01ec9ab7, 0x0ae293ba, 0x17f088ad, 0x1cfe81a0, 0x2dd4be83, 0x26dab78e, 0x3bc8ac99, 0x30c6a594, 0x599cd2df, 0x5292dbd2, 0x4f80c0c5, 0x448ec9c8, 0x75a4f6eb, 0x7eaaffe6, 0x63b8e4f1, 0x68b6edfc, 0xb10c0a67, 0xba02036a, 0xa710187d, 0xac1e1170, 0x9d342e53, 0x963a275e, 0x8b283c49, 0x80263544, 0xe97c420f, 0xe2724b02, 0xff605015, 0xf46e5918, 0xc544663b, 0xce4a6f36, 0xd3587421, 0xd8567d2c, 0x7a37a10c, 0x7139a801, 0x6c2bb316, 0x6725ba1b, 0x560f8538, 0x5d018c35, 0x40139722, 0x4b1d9e2f, 0x2247e964, 0x2949e069, 0x345bfb7e, 0x3f55f273, 0x0e7fcd50, 0x0571c45d, 0x1863df4a, 0x136dd647, 0xcad731dc, 0xc1d938d1, 0xdccb23c6, 0xd7c52acb, 0xe6ef15e8, 0xede11ce5, 0xf0f307f2, 0xfbfd0eff, 0x92a779b4, 0x99a970b9, 0x84bb6bae, 0x8fb562a3, 0xbe9f5d80, 0xb591548d, 0xa8834f9a, 0xa38d4697];
    var U3 = [0x00000000, 0x0d0b0e09, 0x1a161c12, 0x171d121b, 0x342c3824, 0x3927362d, 0x2e3a2436, 0x23312a3f, 0x68587048, 0x65537e41, 0x724e6c5a, 0x7f456253, 0x5c74486c, 0x517f4665, 0x4662547e, 0x4b695a77, 0xd0b0e090, 0xddbbee99, 0xcaa6fc82, 0xc7adf28b, 0xe49cd8b4, 0xe997d6bd, 0xfe8ac4a6, 0xf381caaf, 0xb8e890d8, 0xb5e39ed1, 0xa2fe8cca, 0xaff582c3, 0x8cc4a8fc, 0x81cfa6f5, 0x96d2b4ee, 0x9bd9bae7, 0xbb7bdb3b, 0xb670d532, 0xa16dc729, 0xac66c920, 0x8f57e31f, 0x825ced16, 0x9541ff0d, 0x984af104, 0xd323ab73, 0xde28a57a, 0xc935b761, 0xc43eb968, 0xe70f9357, 0xea049d5e, 0xfd198f45, 0xf012814c, 0x6bcb3bab, 0x66c035a2, 0x71dd27b9, 0x7cd629b0, 0x5fe7038f, 0x52ec0d86, 0x45f11f9d, 0x48fa1194, 0x03934be3, 0x0e9845ea, 0x198557f1, 0x148e59f8, 0x37bf73c7, 0x3ab47dce, 0x2da96fd5, 0x20a261dc, 0x6df6ad76, 0x60fda37f, 0x77e0b164, 0x7aebbf6d, 0x59da9552, 0x54d19b5b, 0x43cc8940, 0x4ec78749, 0x05aedd3e, 0x08a5d337, 0x1fb8c12c, 0x12b3cf25, 0x3182e51a, 0x3c89eb13, 0x2b94f908, 0x269ff701, 0xbd464de6, 0xb04d43ef, 0xa75051f4, 0xaa5b5ffd, 0x896a75c2, 0x84617bcb, 0x937c69d0, 0x9e7767d9, 0xd51e3dae, 0xd81533a7, 0xcf0821bc, 0xc2032fb5, 0xe132058a, 0xec390b83, 0xfb241998, 0xf62f1791, 0xd68d764d, 0xdb867844, 0xcc9b6a5f, 0xc1906456, 0xe2a14e69, 0xefaa4060, 0xf8b7527b, 0xf5bc5c72, 0xbed50605, 0xb3de080c, 0xa4c31a17, 0xa9c8141e, 0x8af93e21, 0x87f23028, 0x90ef2233, 0x9de42c3a, 0x063d96dd, 0x0b3698d4, 0x1c2b8acf, 0x112084c6, 0x3211aef9, 0x3f1aa0f0, 0x2807b2eb, 0x250cbce2, 0x6e65e695, 0x636ee89c, 0x7473fa87, 0x7978f48e, 0x5a49deb1, 0x5742d0b8, 0x405fc2a3, 0x4d54ccaa, 0xdaf741ec, 0xd7fc4fe5, 0xc0e15dfe, 0xcdea53f7, 0xeedb79c8, 0xe3d077c1, 0xf4cd65da, 0xf9c66bd3, 0xb2af31a4, 0xbfa43fad, 0xa8b92db6, 0xa5b223bf, 0x86830980, 0x8b880789, 0x9c951592, 0x919e1b9b, 0x0a47a17c, 0x074caf75, 0x1051bd6e, 0x1d5ab367, 0x3e6b9958, 0x33609751, 0x247d854a, 0x29768b43, 0x621fd134, 0x6f14df3d, 0x7809cd26, 0x7502c32f, 0x5633e910, 0x5b38e719, 0x4c25f502, 0x412efb0b, 0x618c9ad7, 0x6c8794de, 0x7b9a86c5, 0x769188cc, 0x55a0a2f3, 0x58abacfa, 0x4fb6bee1, 0x42bdb0e8, 0x09d4ea9f, 0x04dfe496, 0x13c2f68d, 0x1ec9f884, 0x3df8d2bb, 0x30f3dcb2, 0x27eecea9, 0x2ae5c0a0, 0xb13c7a47, 0xbc37744e, 0xab2a6655, 0xa621685c, 0x85104263, 0x881b4c6a, 0x9f065e71, 0x920d5078, 0xd9640a0f, 0xd46f0406, 0xc372161d, 0xce791814, 0xed48322b, 0xe0433c22, 0xf75e2e39, 0xfa552030, 0xb701ec9a, 0xba0ae293, 0xad17f088, 0xa01cfe81, 0x832dd4be, 0x8e26dab7, 0x993bc8ac, 0x9430c6a5, 0xdf599cd2, 0xd25292db, 0xc54f80c0, 0xc8448ec9, 0xeb75a4f6, 0xe67eaaff, 0xf163b8e4, 0xfc68b6ed, 0x67b10c0a, 0x6aba0203, 0x7da71018, 0x70ac1e11, 0x539d342e, 0x5e963a27, 0x498b283c, 0x44802635, 0x0fe97c42, 0x02e2724b, 0x15ff6050, 0x18f46e59, 0x3bc54466, 0x36ce4a6f, 0x21d35874, 0x2cd8567d, 0x0c7a37a1, 0x017139a8, 0x166c2bb3, 0x1b6725ba, 0x38560f85, 0x355d018c, 0x22401397, 0x2f4b1d9e, 0x642247e9, 0x692949e0, 0x7e345bfb, 0x733f55f2, 0x500e7fcd, 0x5d0571c4, 0x4a1863df, 0x47136dd6, 0xdccad731, 0xd1c1d938, 0xc6dccb23, 0xcbd7c52a, 0xe8e6ef15, 0xe5ede11c, 0xf2f0f307, 0xfffbfd0e, 0xb492a779, 0xb999a970, 0xae84bb6b, 0xa38fb562, 0x80be9f5d, 0x8db59154, 0x9aa8834f, 0x97a38d46];
    var U4 = [0x00000000, 0x090d0b0e, 0x121a161c, 0x1b171d12, 0x24342c38, 0x2d392736, 0x362e3a24, 0x3f23312a, 0x48685870, 0x4165537e, 0x5a724e6c, 0x537f4562, 0x6c5c7448, 0x65517f46, 0x7e466254, 0x774b695a, 0x90d0b0e0, 0x99ddbbee, 0x82caa6fc, 0x8bc7adf2, 0xb4e49cd8, 0xbde997d6, 0xa6fe8ac4, 0xaff381ca, 0xd8b8e890, 0xd1b5e39e, 0xcaa2fe8c, 0xc3aff582, 0xfc8cc4a8, 0xf581cfa6, 0xee96d2b4, 0xe79bd9ba, 0x3bbb7bdb, 0x32b670d5, 0x29a16dc7, 0x20ac66c9, 0x1f8f57e3, 0x16825ced, 0x0d9541ff, 0x04984af1, 0x73d323ab, 0x7ade28a5, 0x61c935b7, 0x68c43eb9, 0x57e70f93, 0x5eea049d, 0x45fd198f, 0x4cf01281, 0xab6bcb3b, 0xa266c035, 0xb971dd27, 0xb07cd629, 0x8f5fe703, 0x8652ec0d, 0x9d45f11f, 0x9448fa11, 0xe303934b, 0xea0e9845, 0xf1198557, 0xf8148e59, 0xc737bf73, 0xce3ab47d, 0xd52da96f, 0xdc20a261, 0x766df6ad, 0x7f60fda3, 0x6477e0b1, 0x6d7aebbf, 0x5259da95, 0x5b54d19b, 0x4043cc89, 0x494ec787, 0x3e05aedd, 0x3708a5d3, 0x2c1fb8c1, 0x2512b3cf, 0x1a3182e5, 0x133c89eb, 0x082b94f9, 0x01269ff7, 0xe6bd464d, 0xefb04d43, 0xf4a75051, 0xfdaa5b5f, 0xc2896a75, 0xcb84617b, 0xd0937c69, 0xd99e7767, 0xaed51e3d, 0xa7d81533, 0xbccf0821, 0xb5c2032f, 0x8ae13205, 0x83ec390b, 0x98fb2419, 0x91f62f17, 0x4dd68d76, 0x44db8678, 0x5fcc9b6a, 0x56c19064, 0x69e2a14e, 0x60efaa40, 0x7bf8b752, 0x72f5bc5c, 0x05bed506, 0x0cb3de08, 0x17a4c31a, 0x1ea9c814, 0x218af93e, 0x2887f230, 0x3390ef22, 0x3a9de42c, 0xdd063d96, 0xd40b3698, 0xcf1c2b8a, 0xc6112084, 0xf93211ae, 0xf03f1aa0, 0xeb2807b2, 0xe2250cbc, 0x956e65e6, 0x9c636ee8, 0x877473fa, 0x8e7978f4, 0xb15a49de, 0xb85742d0, 0xa3405fc2, 0xaa4d54cc, 0xecdaf741, 0xe5d7fc4f, 0xfec0e15d, 0xf7cdea53, 0xc8eedb79, 0xc1e3d077, 0xdaf4cd65, 0xd3f9c66b, 0xa4b2af31, 0xadbfa43f, 0xb6a8b92d, 0xbfa5b223, 0x80868309, 0x898b8807, 0x929c9515, 0x9b919e1b, 0x7c0a47a1, 0x75074caf, 0x6e1051bd, 0x671d5ab3, 0x583e6b99, 0x51336097, 0x4a247d85, 0x4329768b, 0x34621fd1, 0x3d6f14df, 0x267809cd, 0x2f7502c3, 0x105633e9, 0x195b38e7, 0x024c25f5, 0x0b412efb, 0xd7618c9a, 0xde6c8794, 0xc57b9a86, 0xcc769188, 0xf355a0a2, 0xfa58abac, 0xe14fb6be, 0xe842bdb0, 0x9f09d4ea, 0x9604dfe4, 0x8d13c2f6, 0x841ec9f8, 0xbb3df8d2, 0xb230f3dc, 0xa927eece, 0xa02ae5c0, 0x47b13c7a, 0x4ebc3774, 0x55ab2a66, 0x5ca62168, 0x63851042, 0x6a881b4c, 0x719f065e, 0x78920d50, 0x0fd9640a, 0x06d46f04, 0x1dc37216, 0x14ce7918, 0x2bed4832, 0x22e0433c, 0x39f75e2e, 0x30fa5520, 0x9ab701ec, 0x93ba0ae2, 0x88ad17f0, 0x81a01cfe, 0xbe832dd4, 0xb78e26da, 0xac993bc8, 0xa59430c6, 0xd2df599c, 0xdbd25292, 0xc0c54f80, 0xc9c8448e, 0xf6eb75a4, 0xffe67eaa, 0xe4f163b8, 0xedfc68b6, 0x0a67b10c, 0x036aba02, 0x187da710, 0x1170ac1e, 0x2e539d34, 0x275e963a, 0x3c498b28, 0x35448026, 0x420fe97c, 0x4b02e272, 0x5015ff60, 0x5918f46e, 0x663bc544, 0x6f36ce4a, 0x7421d358, 0x7d2cd856, 0xa10c7a37, 0xa8017139, 0xb3166c2b, 0xba1b6725, 0x8538560f, 0x8c355d01, 0x97224013, 0x9e2f4b1d, 0xe9642247, 0xe0692949, 0xfb7e345b, 0xf2733f55, 0xcd500e7f, 0xc45d0571, 0xdf4a1863, 0xd647136d, 0x31dccad7, 0x38d1c1d9, 0x23c6dccb, 0x2acbd7c5, 0x15e8e6ef, 0x1ce5ede1, 0x07f2f0f3, 0x0efffbfd, 0x79b492a7, 0x70b999a9, 0x6bae84bb, 0x62a38fb5, 0x5d80be9f, 0x548db591, 0x4f9aa883, 0x4697a38d];

    function convertToInt32(bytes) {
        var result = [];
        for (var i = 0; i < bytes.length; i += 4) {
            result.push(
                (bytes[i    ] << 24) |
                (bytes[i + 1] << 16) |
                (bytes[i + 2] <<  8) |
                 bytes[i + 3]
            );
        }
        return result;
    }

    var AES = function(key) {
        if (!(this instanceof AES)) {
            throw Error('AES must be instanitated with `new`');
        }

        Object.defineProperty(this, 'key', {
            value: coerceArray(key, true)
        });

        this._prepare();
    }


    AES.prototype._prepare = function() {

        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) {
            throw new Error('invalid key size (must be 16, 24 or 32 bytes)');
        }

        // encryption round keys
        this._Ke = [];

        // decryption round keys
        this._Kd = [];

        for (var i = 0; i <= rounds; i++) {
            this._Ke.push([0, 0, 0, 0]);
            this._Kd.push([0, 0, 0, 0]);
        }

        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;

        // convert the key into ints
        var tk = convertToInt32(this.key);

        // copy values into round key arrays
        var index;
        for (var i = 0; i < KC; i++) {
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }

        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while (t < roundKeyCount) {
            tt = tk[KC - 1];
            tk[0] ^= ((S[(tt >> 16) & 0xFF] << 24) ^
                      (S[(tt >>  8) & 0xFF] << 16) ^
                      (S[ tt        & 0xFF] <<  8) ^
                       S[(tt >> 24) & 0xFF]        ^
                      (rcon[rconpointer] << 24));
            rconpointer += 1;

            // key expansion (for non-256 bit)
            if (KC != 8) {
                for (var i = 1; i < KC; i++) {
                    tk[i] ^= tk[i - 1];
                }

            // key expansion for 256-bit keys is "slightly different" (fips-197)
            } else {
                for (var i = 1; i < (KC / 2); i++) {
                    tk[i] ^= tk[i - 1];
                }
                tt = tk[(KC / 2) - 1];

                tk[KC / 2] ^= (S[ tt        & 0xFF]        ^
                              (S[(tt >>  8) & 0xFF] <<  8) ^
                              (S[(tt >> 16) & 0xFF] << 16) ^
                              (S[(tt >> 24) & 0xFF] << 24));

                for (var i = (KC / 2) + 1; i < KC; i++) {
                    tk[i] ^= tk[i - 1];
                }
            }

            // copy values into round key arrays
            var i = 0, r, c;
            while (i < KC && t < roundKeyCount) {
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }

        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for (var r = 1; r < rounds; r++) {
            for (var c = 0; c < 4; c++) {
                tt = this._Kd[r][c];
                this._Kd[r][c] = (U1[(tt >> 24) & 0xFF] ^
                                  U2[(tt >> 16) & 0xFF] ^
                                  U3[(tt >>  8) & 0xFF] ^
                                  U4[ tt        & 0xFF]);
            }
        }
    }

    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) {
            throw new Error('invalid plaintext size (must be 16 bytes)');
        }

        var rounds = this._Ke.length - 1;
        var a = [0, 0, 0, 0];

        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for (var i = 0; i < 4; i++) {
            t[i] ^= this._Ke[0][i];
        }

        // apply round transforms
        for (var r = 1; r < rounds; r++) {
            for (var i = 0; i < 4; i++) {
                a[i] = (T1[(t[ i         ] >> 24) & 0xff] ^
                        T2[(t[(i + 1) % 4] >> 16) & 0xff] ^
                        T3[(t[(i + 2) % 4] >>  8) & 0xff] ^
                        T4[ t[(i + 3) % 4]        & 0xff] ^
                        this._Ke[r][i]);
            }
            t = a.slice();
        }

        // the last round is special
        var result = createArray(16), tt;
        for (var i = 0; i < 4; i++) {
            tt = this._Ke[rounds][i];
            result[4 * i    ] = (S[(t[ i         ] >> 24) & 0xff] ^ (tt >> 24)) & 0xff;
            result[4 * i + 1] = (S[(t[(i + 1) % 4] >> 16) & 0xff] ^ (tt >> 16)) & 0xff;
            result[4 * i + 2] = (S[(t[(i + 2) % 4] >>  8) & 0xff] ^ (tt >>  8)) & 0xff;
            result[4 * i + 3] = (S[ t[(i + 3) % 4]        & 0xff] ^  tt       ) & 0xff;
        }

        return result;
    }

    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) {
            throw new Error('invalid ciphertext size (must be 16 bytes)');
        }

        var rounds = this._Kd.length - 1;
        var a = [0, 0, 0, 0];

        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for (var i = 0; i < 4; i++) {
            t[i] ^= this._Kd[0][i];
        }

        // apply round transforms
        for (var r = 1; r < rounds; r++) {
            for (var i = 0; i < 4; i++) {
                a[i] = (T5[(t[ i          ] >> 24) & 0xff] ^
                        T6[(t[(i + 3) % 4] >> 16) & 0xff] ^
                        T7[(t[(i + 2) % 4] >>  8) & 0xff] ^
                        T8[ t[(i + 1) % 4]        & 0xff] ^
                        this._Kd[r][i]);
            }
            t = a.slice();
        }

        // the last round is special
        var result = createArray(16), tt;
        for (var i = 0; i < 4; i++) {
            tt = this._Kd[rounds][i];
            result[4 * i    ] = (Si[(t[ i         ] >> 24) & 0xff] ^ (tt >> 24)) & 0xff;
            result[4 * i + 1] = (Si[(t[(i + 3) % 4] >> 16) & 0xff] ^ (tt >> 16)) & 0xff;
            result[4 * i + 2] = (Si[(t[(i + 2) % 4] >>  8) & 0xff] ^ (tt >>  8)) & 0xff;
            result[4 * i + 3] = (Si[ t[(i + 1) % 4]        & 0xff] ^  tt       ) & 0xff;
        }

        return result;
    }


    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */
    var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Electronic Code Block";
        this.name = "ecb";

        this._aes = new AES(key);
    }

    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);

        if ((plaintext.length % 16) !== 0) {
            throw new Error('invalid plaintext size (must be multiple of 16 bytes)');
        }

        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);

        for (var i = 0; i < plaintext.length; i += 16) {
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }

        return ciphertext;
    }

    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);

        if ((ciphertext.length % 16) !== 0) {
            throw new Error('invalid ciphertext size (must be multiple of 16 bytes)');
        }

        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);

        for (var i = 0; i < ciphertext.length; i += 16) {
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }

        return plaintext;
    }


    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */
    var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Cipher Block Chaining";
        this.name = "cbc";

        if (!iv) {
            iv = createArray(16);

        } else if (iv.length != 16) {
            throw new Error('invalid initialation vector size (must be 16 bytes)');
        }

        this._lastCipherblock = coerceArray(iv, true);

        this._aes = new AES(key);
    }

    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);

        if ((plaintext.length % 16) !== 0) {
            throw new Error('invalid plaintext size (must be multiple of 16 bytes)');
        }

        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);

        for (var i = 0; i < plaintext.length; i += 16) {
            copyArray(plaintext, block, 0, i, i + 16);

            for (var j = 0; j < 16; j++) {
                block[j] ^= this._lastCipherblock[j];
            }

            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }

        return ciphertext;
    }

    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);

        if ((ciphertext.length % 16) !== 0) {
            throw new Error('invalid ciphertext size (must be multiple of 16 bytes)');
        }

        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);

        for (var i = 0; i < ciphertext.length; i += 16) {
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);

            for (var j = 0; j < 16; j++) {
                plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            }

            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }

        return plaintext;
    }


    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */
    var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Cipher Feedback";
        this.name = "cfb";

        if (!iv) {
            iv = createArray(16);

        } else if (iv.length != 16) {
            throw new Error('invalid initialation vector size (must be 16 size)');
        }

        if (!segmentSize) { segmentSize = 1; }

        this.segmentSize = segmentSize;

        this._shiftRegister = coerceArray(iv, true);

        this._aes = new AES(key);
    }

    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if ((plaintext.length % this.segmentSize) != 0) {
            throw new Error('invalid plaintext size (must be segmentSize bytes)');
        }

        var encrypted = coerceArray(plaintext, true);

        var xorSegment;
        for (var i = 0; i < encrypted.length; i += this.segmentSize) {
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for (var j = 0; j < this.segmentSize; j++) {
                encrypted[i + j] ^= xorSegment[j];
            }

            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }

        return encrypted;
    }

    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if ((ciphertext.length % this.segmentSize) != 0) {
            throw new Error('invalid ciphertext size (must be segmentSize bytes)');
        }

        var plaintext = coerceArray(ciphertext, true);

        var xorSegment;
        for (var i = 0; i < plaintext.length; i += this.segmentSize) {
            xorSegment = this._aes.encrypt(this._shiftRegister);

            for (var j = 0; j < this.segmentSize; j++) {
                plaintext[i + j] ^= xorSegment[j];
            }

            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }

        return plaintext;
    }

    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */
    var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Output Feedback";
        this.name = "ofb";

        if (!iv) {
            iv = createArray(16);

        } else if (iv.length != 16) {
            throw new Error('invalid initialation vector size (must be 16 bytes)');
        }

        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;

        this._aes = new AES(key);
    }

    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);

        for (var i = 0; i < encrypted.length; i++) {
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }

        return encrypted;
    }

    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;


    /**
     *  Counter object for CTR common mode of operation
     */
    var Counter = function(initialValue) {
        if (!(this instanceof Counter)) {
            throw Error('Counter must be instanitated with `new`');
        }

        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) { initialValue = 1; }

        if (typeof(initialValue) === 'number') {
            this._counter = createArray(16);
            this.setValue(initialValue);

        } else {
            this.setBytes(initialValue);
        }
    }

    Counter.prototype.setValue = function(value) {
        if (typeof(value) !== 'number' || parseInt(value) != value) {
            throw new Error('invalid counter value (must be an integer)');
        }

        for (var index = 15; index >= 0; --index) {
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    }

    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);

        if (bytes.length != 16) {
            throw new Error('invalid counter bytes size (must be 16 bytes)');
        }

        this._counter = bytes;
    };

    Counter.prototype.increment = function() {
        for (var i = 15; i >= 0; i--) {
            if (this._counter[i] === 255) {
                this._counter[i] = 0;
            } else {
                this._counter[i]++;
                break;
            }
        }
    }


    /**
     *  Mode Of Operation - Counter (CTR)
     */
    var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) {
            throw Error('AES must be instanitated with `new`');
        }

        this.description = "Counter";
        this.name = "ctr";

        if (!(counter instanceof Counter)) {
            counter = new Counter(counter)
        }

        this._counter = counter;

        this._remainingCounter = null;
        this._remainingCounterIndex = 16;

        this._aes = new AES(key);
    }

    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);

        for (var i = 0; i < encrypted.length; i++) {
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }

        return encrypted;
    }

    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;


    ///////////////////////
    // Padding

    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - (data.length % 16);
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for (var i = data.length; i < result.length; i++) {
            result[i] = padder;
        }
        return result;
    }

    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) { throw new Error('PKCS#7 invalid length'); }

        var padder = data[data.length - 1];
        if (padder > 16) { throw new Error('PKCS#7 padding byte out of range'); }

        var length = data.length - padder;
        for (var i = 0; i < padder; i++) {
            if (data[length + i] !== padder) {
                throw new Error('PKCS#7 invalid padding byte');
            }
        }

        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }

    ///////////////////////
    // Exporting


    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,

        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },

        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },

        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },

        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray,
        }
    };


    // node.js
    if (true) {
        module.exports = aesjs

    // RequireJS/AMD
    // http://www.requirejs.org/docs/api.html
    // https://github.com/amdjs/amdjs-api/wiki/AMD
    } else {}


})(this);


/***/ }),

/***/ "../../node_modules/ajv-formats/dist/formats.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatNames = exports.fastFormats = exports.fullFormats = void 0;
function fmtDef(validate, compare) {
    return { validate, compare };
}
exports.fullFormats = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: fmtDef(date, compareDate),
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: fmtDef(time, compareTime),
    "date-time": fmtDef(date_time, compareDateTime),
    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
    uri,
    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // uri-template: https://tools.ietf.org/html/rfc6570
    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
    // For the source: https://gist.github.com/dperini/729294
    // For test cases: https://mathiasbynens.be/demo/url-regex
    url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
    regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
    // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
    // byte: https://github.com/miguelmota/is-base64
    byte,
    // signed 32 bit integer
    int32: { type: "number", validate: validateInt32 },
    // signed 64 bit integer
    int64: { type: "number", validate: validateInt64 },
    // C-type float
    float: { type: "number", validate: validateNumber },
    // C-type double
    double: { type: "number", validate: validateNumber },
    // hint to the UI to hide input strings
    password: true,
    // unchecked string payload
    binary: true,
};
exports.fastFormats = {
    ...exports.fullFormats,
    date: fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, compareDate),
    time: fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareTime),
    "date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareDateTime),
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
};
exports.formatNames = Object.keys(exports.fullFormats);
function isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
const DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const DAYS = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    const matches = DATE.exec(str);
    if (!matches)
        return false;
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return (month >= 1 &&
        month <= 12 &&
        day >= 1 &&
        day <= (month === 2 && isLeapYear(year) ? 29 : DAYS[month]));
}
function compareDate(d1, d2) {
    if (!(d1 && d2))
        return undefined;
    if (d1 > d2)
        return 1;
    if (d1 < d2)
        return -1;
    return 0;
}
const TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
function time(str, withTimeZone) {
    const matches = TIME.exec(str);
    if (!matches)
        return false;
    const hour = +matches[1];
    const minute = +matches[2];
    const second = +matches[3];
    const timeZone = matches[5];
    return (((hour <= 23 && minute <= 59 && second <= 59) ||
        (hour === 23 && minute === 59 && second === 60)) &&
        (!withTimeZone || timeZone !== ""));
}
function compareTime(t1, t2) {
    if (!(t1 && t2))
        return undefined;
    const a1 = TIME.exec(t1);
    const a2 = TIME.exec(t2);
    if (!(a1 && a2))
        return undefined;
    t1 = a1[1] + a1[2] + a1[3] + (a1[4] || "");
    t2 = a2[1] + a2[2] + a2[3] + (a2[4] || "");
    if (t1 > t2)
        return 1;
    if (t1 < t2)
        return -1;
    return 0;
}
const DATE_TIME_SEPARATOR = /t|\s/i;
function date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    const dateTime = str.split(DATE_TIME_SEPARATOR);
    return dateTime.length === 2 && date(dateTime[0]) && time(dateTime[1], true);
}
function compareDateTime(dt1, dt2) {
    if (!(dt1 && dt2))
        return undefined;
    const [d1, t1] = dt1.split(DATE_TIME_SEPARATOR);
    const [d2, t2] = dt2.split(DATE_TIME_SEPARATOR);
    const res = compareDate(d1, d2);
    if (res === undefined)
        return undefined;
    return res || compareTime(t1, t2);
}
const NOT_URI_FRAGMENT = /\/|:/;
const URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return NOT_URI_FRAGMENT.test(str) && URI.test(str);
}
const BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
function byte(str) {
    BYTE.lastIndex = 0;
    return BYTE.test(str);
}
const MIN_INT32 = -(2 ** 31);
const MAX_INT32 = 2 ** 31 - 1;
function validateInt32(value) {
    return Number.isInteger(value) && value <= MAX_INT32 && value >= MIN_INT32;
}
function validateInt64(value) {
    // JSON and javascript max Int is 2**53, so any int that passes isInteger is valid for Int64
    return Number.isInteger(value);
}
function validateNumber() {
    return true;
}
const Z_ANCHOR = /[^\\]\\Z/;
function regex(str) {
    if (Z_ANCHOR.test(str))
        return false;
    try {
        new RegExp(str);
        return true;
    }
    catch (e) {
        return false;
    }
}
//# sourceMappingURL=formats.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/dist/index.js":
/***/ ((module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const formats_1 = __webpack_require__("../../node_modules/ajv-formats/dist/formats.js");
const limit_1 = __webpack_require__("../../node_modules/ajv-formats/dist/limit.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const fullName = new codegen_1.Name("fullFormats");
const fastName = new codegen_1.Name("fastFormats");
const formatsPlugin = (ajv, opts = { keywords: true }) => {
    if (Array.isArray(opts)) {
        addFormats(ajv, opts, formats_1.fullFormats, fullName);
        return ajv;
    }
    const [formats, exportName] = opts.mode === "fast" ? [formats_1.fastFormats, fastName] : [formats_1.fullFormats, fullName];
    const list = opts.formats || formats_1.formatNames;
    addFormats(ajv, list, formats, exportName);
    if (opts.keywords)
        limit_1.default(ajv);
    return ajv;
};
formatsPlugin.get = (name, mode = "full") => {
    const formats = mode === "fast" ? formats_1.fastFormats : formats_1.fullFormats;
    const f = formats[name];
    if (!f)
        throw new Error(`Unknown format "${name}"`);
    return f;
};
function addFormats(ajv, list, fs, exportName) {
    var _a;
    var _b;
    (_a = (_b = ajv.opts.code).formats) !== null && _a !== void 0 ? _a : (_b.formats = codegen_1._ `require("ajv-formats/dist/formats").${exportName}`);
    for (const f of list)
        ajv.addFormat(f, fs[f]);
}
module.exports = exports = formatsPlugin;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = formatsPlugin;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/dist/limit.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatLimitDefinition = void 0;
const ajv_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/ajv.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const ops = codegen_1.operators;
const KWDs = {
    formatMaximum: { okStr: "<=", ok: ops.LTE, fail: ops.GT },
    formatMinimum: { okStr: ">=", ok: ops.GTE, fail: ops.LT },
    formatExclusiveMaximum: { okStr: "<", ok: ops.LT, fail: ops.GTE },
    formatExclusiveMinimum: { okStr: ">", ok: ops.GT, fail: ops.LTE },
};
const error = {
    message: ({ keyword, schemaCode }) => codegen_1.str `should be ${KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword, schemaCode }) => codegen_1._ `{comparison: ${KWDs[keyword].okStr}, limit: ${schemaCode}}`,
};
exports.formatLimitDefinition = {
    keyword: Object.keys(KWDs),
    type: "string",
    schemaType: "string",
    $data: true,
    error,
    code(cxt) {
        const { gen, data, schemaCode, keyword, it } = cxt;
        const { opts, self } = it;
        if (!opts.validateFormats)
            return;
        const fCxt = new ajv_1.KeywordCxt(it, self.RULES.all.format.definition, "format");
        if (fCxt.$data)
            validate$DataFormat();
        else
            validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats,
            });
            const fmt = gen.const("fmt", codegen_1._ `${fmts}[${fCxt.schemaCode}]`);
            cxt.fail$data(codegen_1.or(codegen_1._ `typeof ${fmt} != "object"`, codegen_1._ `${fmt} instanceof RegExp`, codegen_1._ `typeof ${fmt}.compare != "function"`, compareCode(fmt)));
        }
        function validateFormat() {
            const format = fCxt.schema;
            const fmtDef = self.formats[format];
            if (!fmtDef || fmtDef === true)
                return;
            if (typeof fmtDef != "object" ||
                fmtDef instanceof RegExp ||
                typeof fmtDef.compare != "function") {
                throw new Error(`"${keyword}": format "${format}" does not define "compare" function`);
            }
            const fmt = gen.scopeValue("formats", {
                key: format,
                ref: fmtDef,
                code: opts.code.formats ? codegen_1._ `${opts.code.formats}${codegen_1.getProperty(format)}` : undefined,
            });
            cxt.fail$data(compareCode(fmt));
        }
        function compareCode(fmt) {
            return codegen_1._ `${fmt}.compare(${data}, ${schemaCode}) ${KWDs[keyword].fail} 0`;
        }
    },
    dependencies: ["format"],
};
const formatLimitPlugin = (ajv) => {
    ajv.addKeyword(exports.formatLimitDefinition);
    return ajv;
};
exports["default"] = formatLimitPlugin;
//# sourceMappingURL=limit.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/ajv.js":
/***/ ((module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;
const core_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/core.js");
const draft7_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/draft7.js");
const discriminator_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/discriminator/index.js");
const draft7MetaSchema = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/refs/json-schema-draft-07.json");
const META_SUPPORT_DATA = ["/properties"];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends core_1.default {
    _addVocabularies() {
        super._addVocabularies();
        draft7_1.default.forEach((v) => this.addVocabulary(v));
        if (this.opts.discriminator)
            this.addKeyword(discriminator_1.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta)
            return;
        const metaSchema = this.opts.$data
            ? this.$dataMetaSchema(draft7MetaSchema, META_SUPPORT_DATA)
            : draft7MetaSchema;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return (this.opts.defaultMeta =
            super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined));
    }
}
module.exports = exports = Ajv;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = Ajv;
var validate_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/index.js");
Object.defineProperty(exports, "KeywordCxt", ({ enumerable: true, get: function () { return validate_1.KeywordCxt; } }));
var codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
Object.defineProperty(exports, "_", ({ enumerable: true, get: function () { return codegen_1._; } }));
Object.defineProperty(exports, "str", ({ enumerable: true, get: function () { return codegen_1.str; } }));
Object.defineProperty(exports, "stringify", ({ enumerable: true, get: function () { return codegen_1.stringify; } }));
Object.defineProperty(exports, "nil", ({ enumerable: true, get: function () { return codegen_1.nil; } }));
Object.defineProperty(exports, "Name", ({ enumerable: true, get: function () { return codegen_1.Name; } }));
Object.defineProperty(exports, "CodeGen", ({ enumerable: true, get: function () { return codegen_1.CodeGen; } }));
var validation_error_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/validation_error.js");
Object.defineProperty(exports, "ValidationError", ({ enumerable: true, get: function () { return validation_error_1.default; } }));
var ref_error_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/ref_error.js");
Object.defineProperty(exports, "MissingRefError", ({ enumerable: true, get: function () { return ref_error_1.default; } }));
//# sourceMappingURL=ajv.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/code.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.regexpCode = exports.getEsmExportName = exports.getProperty = exports.safeStringify = exports.stringify = exports.strConcat = exports.addCodeArg = exports.str = exports._ = exports.nil = exports._Code = exports.Name = exports.IDENTIFIER = exports._CodeOrName = void 0;
class _CodeOrName {
}
exports._CodeOrName = _CodeOrName;
exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class Name extends _CodeOrName {
    constructor(s) {
        super();
        if (!exports.IDENTIFIER.test(s))
            throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return { [this.str]: 1 };
    }
}
exports.Name = Name;
class _Code extends _CodeOrName {
    constructor(code) {
        super();
        this._items = typeof code === "string" ? [code] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1)
            return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return ((_a = this._str) !== null && _a !== void 0 ? _a : (this._str = this._items.reduce((s, c) => `${s}${c}`, "")));
    }
    get names() {
        var _a;
        return ((_a = this._names) !== null && _a !== void 0 ? _a : (this._names = this._items.reduce((names, c) => {
            if (c instanceof Name)
                names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {})));
    }
}
exports._Code = _Code;
exports.nil = new _Code("");
function _(strs, ...args) {
    const code = [strs[0]];
    let i = 0;
    while (i < args.length) {
        addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new _Code(code);
}
exports._ = _;
const plus = new _Code("+");
function str(strs, ...args) {
    const expr = [safeStringify(strs[0])];
    let i = 0;
    while (i < args.length) {
        expr.push(plus);
        addCodeArg(expr, args[i]);
        expr.push(plus, safeStringify(strs[++i]));
    }
    optimize(expr);
    return new _Code(expr);
}
exports.str = str;
function addCodeArg(code, arg) {
    if (arg instanceof _Code)
        code.push(...arg._items);
    else if (arg instanceof Name)
        code.push(arg);
    else
        code.push(interpolate(arg));
}
exports.addCodeArg = addCodeArg;
function optimize(expr) {
    let i = 1;
    while (i < expr.length - 1) {
        if (expr[i] === plus) {
            const res = mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function mergeExprItems(a, b) {
    if (b === '""')
        return a;
    if (a === '""')
        return b;
    if (typeof a == "string") {
        if (b instanceof Name || a[a.length - 1] !== '"')
            return;
        if (typeof b != "string")
            return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"')
            return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof Name))
        return `"${a}${b.slice(1)}`;
    return;
}
function strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : str `${c1}${c2}`;
}
exports.strConcat = strConcat;
// TODO do not allow arrays here
function interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null
        ? x
        : safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function stringify(x) {
    return new _Code(safeStringify(x));
}
exports.stringify = stringify;
function safeStringify(x) {
    return JSON.stringify(x)
        .replace(/\u2028/g, "\\u2028")
        .replace(/\u2029/g, "\\u2029");
}
exports.safeStringify = safeStringify;
function getProperty(key) {
    return typeof key == "string" && exports.IDENTIFIER.test(key) ? new _Code(`.${key}`) : _ `[${key}]`;
}
exports.getProperty = getProperty;
//Does best effort to format the name properly
function getEsmExportName(key) {
    if (typeof key == "string" && exports.IDENTIFIER.test(key)) {
        return new _Code(`${key}`);
    }
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
exports.getEsmExportName = getEsmExportName;
function regexpCode(rx) {
    return new _Code(rx.toString());
}
exports.regexpCode = regexpCode;
//# sourceMappingURL=code.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.or = exports.and = exports.not = exports.CodeGen = exports.operators = exports.varKinds = exports.ValueScopeName = exports.ValueScope = exports.Scope = exports.Name = exports.regexpCode = exports.stringify = exports.getProperty = exports.nil = exports.strConcat = exports.str = exports._ = void 0;
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/code.js");
const scope_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/scope.js");
var code_2 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/code.js");
Object.defineProperty(exports, "_", ({ enumerable: true, get: function () { return code_2._; } }));
Object.defineProperty(exports, "str", ({ enumerable: true, get: function () { return code_2.str; } }));
Object.defineProperty(exports, "strConcat", ({ enumerable: true, get: function () { return code_2.strConcat; } }));
Object.defineProperty(exports, "nil", ({ enumerable: true, get: function () { return code_2.nil; } }));
Object.defineProperty(exports, "getProperty", ({ enumerable: true, get: function () { return code_2.getProperty; } }));
Object.defineProperty(exports, "stringify", ({ enumerable: true, get: function () { return code_2.stringify; } }));
Object.defineProperty(exports, "regexpCode", ({ enumerable: true, get: function () { return code_2.regexpCode; } }));
Object.defineProperty(exports, "Name", ({ enumerable: true, get: function () { return code_2.Name; } }));
var scope_2 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/scope.js");
Object.defineProperty(exports, "Scope", ({ enumerable: true, get: function () { return scope_2.Scope; } }));
Object.defineProperty(exports, "ValueScope", ({ enumerable: true, get: function () { return scope_2.ValueScope; } }));
Object.defineProperty(exports, "ValueScopeName", ({ enumerable: true, get: function () { return scope_2.ValueScopeName; } }));
Object.defineProperty(exports, "varKinds", ({ enumerable: true, get: function () { return scope_2.varKinds; } }));
exports.operators = {
    GT: new code_1._Code(">"),
    GTE: new code_1._Code(">="),
    LT: new code_1._Code("<"),
    LTE: new code_1._Code("<="),
    EQ: new code_1._Code("==="),
    NEQ: new code_1._Code("!=="),
    NOT: new code_1._Code("!"),
    OR: new code_1._Code("||"),
    AND: new code_1._Code("&&"),
    ADD: new code_1._Code("+"),
};
class Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class Def extends Node {
    constructor(varKind, name, rhs) {
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5, _n }) {
        const varKind = es5 ? scope_1.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str])
            return;
        if (this.rhs)
            this.rhs = optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof code_1._CodeOrName ? this.rhs.names : {};
    }
}
class Assign extends Node {
    constructor(lhs, rhs, sideEffects) {
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof code_1.Name && !names[this.lhs.str] && !this.sideEffects)
            return;
        this.rhs = optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof code_1.Name ? {} : { ...this.lhs.names };
        return addExprNames(names, this.rhs);
    }
}
class AssignOp extends Assign {
    constructor(lhs, op, rhs, sideEffects) {
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class Label extends Node {
    constructor(label) {
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n }) {
        return `${this.label}:` + _n;
    }
}
class Break extends Node {
    constructor(label) {
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class Throw extends Node {
    constructor(error) {
        super();
        this.error = error;
    }
    render({ _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class AnyCode extends Node {
    constructor(code) {
        super();
        this.code = code;
    }
    render({ _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof code_1._CodeOrName ? this.code.names : {};
    }
}
class ParentNode extends Node {
    constructor(nodes = []) {
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n) => code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes } = this;
        let i = nodes.length;
        while (i--) {
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n))
                nodes.splice(i, 1, ...n);
            else if (n)
                nodes[i] = n;
            else
                nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes } = this;
        let i = nodes.length;
        while (i--) {
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants))
                continue;
            subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n) => addNames(names, n.names), {});
    }
}
class BlockNode extends ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class Root extends ParentNode {
}
class Else extends BlockNode {
}
Else.kind = "else";
class If extends BlockNode {
    constructor(condition, nodes) {
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else)
            code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true)
            return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new Else(ns) : ns;
        }
        if (e) {
            if (cond === false)
                return e instanceof If ? e : e.nodes;
            if (this.nodes.length)
                return this;
            return new If(not(cond), e instanceof If ? [e] : e.nodes);
        }
        if (cond === false || !this.nodes.length)
            return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else))
            return;
        this.condition = optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        addExprNames(names, this.condition);
        if (this.else)
            addNames(names, this.else.names);
        return names;
    }
}
If.kind = "if";
class For extends BlockNode {
}
For.kind = "for";
class ForLoop extends For {
    constructor(iteration) {
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants))
            return;
        this.iteration = optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return addNames(super.names, this.iteration.names);
    }
}
class ForRange extends For {
    constructor(varKind, name, from, to) {
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? scope_1.varKinds.var : this.varKind;
        const { name, from, to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = addExprNames(super.names, this.from);
        return addExprNames(names, this.to);
    }
}
class ForIter extends For {
    constructor(loop, varKind, name, iterable) {
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants))
            return;
        this.iterable = optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return addNames(super.names, this.iterable.names);
    }
}
class Func extends BlockNode {
    constructor(name, args, async) {
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
Func.kind = "func";
class Return extends ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
Return.kind = "return";
class Try extends BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch)
            code += this.catch.render(opts);
        if (this.finally)
            code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 ? void 0 : _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 ? void 0 : _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 ? void 0 : _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch)
            addNames(names, this.catch.names);
        if (this.finally)
            addNames(names, this.finally.names);
        return names;
    }
}
class Catch extends BlockNode {
    constructor(error) {
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
Catch.kind = "catch";
class Finally extends BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
Finally.kind = "finally";
class CodeGen {
    constructor(extScope, opts = {}) {
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = { ...opts, _n: opts.lines ? "\n" : "" };
        this._extScope = extScope;
        this._scope = new scope_1.Scope({ parent: extScope });
        this._nodes = [new Root()];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant)
            this._constants[name.str] = rhs;
        this._leafNode(new Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new AssignOp(lhs, exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function")
            c();
        else if (c !== code_1.nil)
            this._leafNode(new AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = ["{"];
        for (const [key, value] of keyValues) {
            if (code.length > 1)
                code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, code_1.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new code_1._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new If(condition));
        if (thenBody && elseBody) {
            this.code(thenBody).else().code(elseBody).endIf();
        }
        else if (thenBody) {
            this.code(thenBody).endIf();
        }
        else if (elseBody) {
            throw new Error('CodeGen: "else" body without "then" body');
        }
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode(If, Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody)
            this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new ForRange(varKind, name, from, to), () => forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = scope_1.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof code_1.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, code_1._) `${arr}.length`, (i) => {
                this.var(name, (0, code_1._) `${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new ForIter("of", varKind, name, iterable), () => forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.const) {
        if (this.opts.ownProperties) {
            return this.forOf(nameOrPrefix, (0, code_1._) `Object.keys(${obj})`, forBody);
        }
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new ForIter("in", varKind, name, obj), () => forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode(For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new Break(label));
    }
    // `return` statement
    return(value) {
        const node = new Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1)
            throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode(Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode)
            throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode(Catch, Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body)
            this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined)
            throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || (nodeCount !== undefined && toClose !== nodeCount)) {
            throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        }
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = code_1.nil, async, funcBody) {
        this._blockNode(new Func(name, args, async));
        if (funcBody)
            this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode(Func);
    }
    optimize(n = 1) {
        while (n-- > 0) {
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || (N2 && n instanceof N2)) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof If)) {
            throw new Error('CodeGen: "else" without "if"');
        }
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
exports.CodeGen = CodeGen;
function addNames(names, from) {
    for (const n in from)
        names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function addExprNames(names, from) {
    return from instanceof code_1._CodeOrName ? addNames(names, from.names) : names;
}
function optimizeExpr(expr, names, constants) {
    if (expr instanceof code_1.Name)
        return replaceName(expr);
    if (!canOptimize(expr))
        return expr;
    return new code_1._Code(expr._items.reduce((items, c) => {
        if (c instanceof code_1.Name)
            c = replaceName(c);
        if (c instanceof code_1._Code)
            items.push(...c._items);
        else
            items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1)
            return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return (e instanceof code_1._Code &&
            e._items.some((c) => c instanceof code_1.Name && names[c.str] === 1 && constants[c.str] !== undefined));
    }
}
function subtractNames(names, from) {
    for (const n in from)
        names[n] = (names[n] || 0) - (from[n] || 0);
}
function not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, code_1._) `!${par(x)}`;
}
exports.not = not;
const andCode = mappend(exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function and(...args) {
    return args.reduce(andCode);
}
exports.and = and;
const orCode = mappend(exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function or(...args) {
    return args.reduce(orCode);
}
exports.or = or;
function mappend(op) {
    return (x, y) => (x === code_1.nil ? y : y === code_1.nil ? x : (0, code_1._) `${par(x)} ${op} ${par(y)}`);
}
function par(x) {
    return x instanceof code_1.Name ? x : (0, code_1._) `(${x})`;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/scope.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ValueScope = exports.ValueScopeName = exports.Scope = exports.varKinds = exports.UsedValueState = void 0;
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/code.js");
class ValueError extends Error {
    constructor(name) {
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var UsedValueState;
(function (UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})(UsedValueState = exports.UsedValueState || (exports.UsedValueState = {}));
exports.varKinds = {
    const: new code_1.Name("const"),
    let: new code_1.Name("let"),
    var: new code_1.Name("var"),
};
class Scope {
    constructor({ prefixes, parent } = {}) {
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof code_1.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new code_1.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || (this._prefixes && !this._prefixes.has(prefix))) {
            throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        }
        return (this._names[prefix] = { prefix, index: 0 });
    }
}
exports.Scope = Scope;
class ValueScopeName extends code_1.Name {
    constructor(prefix, nameStr) {
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property, itemIndex }) {
        this.value = value;
        this.scopePath = (0, code_1._) `.${new code_1.Name(property)}[${itemIndex}]`;
    }
}
exports.ValueScopeName = ValueScopeName;
const line = (0, code_1._) `\n`;
class ValueScope extends Scope {
    constructor(opts) {
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = { ...opts, _n: opts.lines ? line : code_1.nil };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined)
            throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name)
                return _name;
        }
        else {
            vs = this._values[prefix] = new Map();
        }
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, { property: prefix, itemIndex });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs)
            return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name) => {
            if (name.scopePath === undefined)
                throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, code_1._) `${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name) => {
            if (name.value === undefined)
                throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = code_1.nil;
        for (const prefix in values) {
            const vs = values[prefix];
            if (!vs)
                continue;
            const nameSet = (usedValues[prefix] = usedValues[prefix] || new Map());
            vs.forEach((name) => {
                if (nameSet.has(name))
                    return;
                nameSet.set(name, UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? exports.varKinds.var : exports.varKinds.const;
                    code = (0, code_1._) `${code}${def} ${name} = ${c};${this.opts._n}`;
                }
                else if ((c = getCode === null || getCode === void 0 ? void 0 : getCode(name))) {
                    code = (0, code_1._) `${code}${c}${this.opts._n}`;
                }
                else {
                    throw new ValueError(name);
                }
                nameSet.set(name, UsedValueState.Completed);
            });
        }
        return code;
    }
}
exports.ValueScope = ValueScope;
//# sourceMappingURL=scope.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/errors.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.extendErrors = exports.resetErrorsCount = exports.reportExtraError = exports.reportError = exports.keyword$DataError = exports.keywordError = void 0;
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const names_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/names.js");
exports.keywordError = {
    message: ({ keyword }) => (0, codegen_1.str) `must pass "${keyword}" keyword validation`,
};
exports.keyword$DataError = {
    message: ({ keyword, schemaType }) => schemaType
        ? (0, codegen_1.str) `"${keyword}" keyword must be ${schemaType} ($data)`
        : (0, codegen_1.str) `"${keyword}" keyword is invalid ($data)`,
};
function reportError(cxt, error = exports.keywordError, errorPaths, overrideAllErrors) {
    const { it } = cxt;
    const { gen, compositeRule, allErrors } = it;
    const errObj = errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : (compositeRule || allErrors)) {
        addError(gen, errObj);
    }
    else {
        returnErrors(it, (0, codegen_1._) `[${errObj}]`);
    }
}
exports.reportError = reportError;
function reportExtraError(cxt, error = exports.keywordError, errorPaths) {
    const { it } = cxt;
    const { gen, compositeRule, allErrors } = it;
    const errObj = errorObjectCode(cxt, error, errorPaths);
    addError(gen, errObj);
    if (!(compositeRule || allErrors)) {
        returnErrors(it, names_1.default.vErrors);
    }
}
exports.reportExtraError = reportExtraError;
function resetErrorsCount(gen, errsCount) {
    gen.assign(names_1.default.errors, errsCount);
    gen.if((0, codegen_1._) `${names_1.default.vErrors} !== null`, () => gen.if(errsCount, () => gen.assign((0, codegen_1._) `${names_1.default.vErrors}.length`, errsCount), () => gen.assign(names_1.default.vErrors, null)));
}
exports.resetErrorsCount = resetErrorsCount;
function extendErrors({ gen, keyword, schemaValue, data, errsCount, it, }) {
    /* istanbul ignore if */
    if (errsCount === undefined)
        throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, names_1.default.errors, (i) => {
        gen.const(err, (0, codegen_1._) `${names_1.default.vErrors}[${i}]`);
        gen.if((0, codegen_1._) `${err}.instancePath === undefined`, () => gen.assign((0, codegen_1._) `${err}.instancePath`, (0, codegen_1.strConcat)(names_1.default.instancePath, it.errorPath)));
        gen.assign((0, codegen_1._) `${err}.schemaPath`, (0, codegen_1.str) `${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, codegen_1._) `${err}.schema`, schemaValue);
            gen.assign((0, codegen_1._) `${err}.data`, data);
        }
    });
}
exports.extendErrors = extendErrors;
function addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, codegen_1._) `${names_1.default.vErrors} === null`, () => gen.assign(names_1.default.vErrors, (0, codegen_1._) `[${err}]`), (0, codegen_1._) `${names_1.default.vErrors}.push(${err})`);
    gen.code((0, codegen_1._) `${names_1.default.errors}++`);
}
function returnErrors(it, errs) {
    const { gen, validateName, schemaEnv } = it;
    if (schemaEnv.$async) {
        gen.throw((0, codegen_1._) `new ${it.ValidationError}(${errs})`);
    }
    else {
        gen.assign((0, codegen_1._) `${validateName}.errors`, errs);
        gen.return(false);
    }
}
const E = {
    keyword: new codegen_1.Name("keyword"),
    schemaPath: new codegen_1.Name("schemaPath"),
    params: new codegen_1.Name("params"),
    propertyName: new codegen_1.Name("propertyName"),
    message: new codegen_1.Name("message"),
    schema: new codegen_1.Name("schema"),
    parentSchema: new codegen_1.Name("parentSchema"),
};
function errorObjectCode(cxt, error, errorPaths) {
    const { createErrors } = cxt.it;
    if (createErrors === false)
        return (0, codegen_1._) `{}`;
    return errorObject(cxt, error, errorPaths);
}
function errorObject(cxt, error, errorPaths = {}) {
    const { gen, it } = cxt;
    const keyValues = [
        errorInstancePath(it, errorPaths),
        errorSchemaPath(cxt, errorPaths),
    ];
    extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function errorInstancePath({ errorPath }, { instancePath }) {
    const instPath = instancePath
        ? (0, codegen_1.str) `${errorPath}${(0, util_1.getErrorPath)(instancePath, util_1.Type.Str)}`
        : errorPath;
    return [names_1.default.instancePath, (0, codegen_1.strConcat)(names_1.default.instancePath, instPath)];
}
function errorSchemaPath({ keyword, it: { errSchemaPath } }, { schemaPath, parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, codegen_1.str) `${errSchemaPath}/${keyword}`;
    if (schemaPath) {
        schPath = (0, codegen_1.str) `${schPath}${(0, util_1.getErrorPath)(schemaPath, util_1.Type.Str)}`;
    }
    return [E.schemaPath, schPath];
}
function extraErrorProps(cxt, { params, message }, keyValues) {
    const { keyword, data, schemaValue, it } = cxt;
    const { opts, propertyName, topSchemaRef, schemaPath } = it;
    keyValues.push([E.keyword, keyword], [E.params, typeof params == "function" ? params(cxt) : params || (0, codegen_1._) `{}`]);
    if (opts.messages) {
        keyValues.push([E.message, typeof message == "function" ? message(cxt) : message]);
    }
    if (opts.verbose) {
        keyValues.push([E.schema, schemaValue], [E.parentSchema, (0, codegen_1._) `${topSchemaRef}${schemaPath}`], [names_1.default.data, data]);
    }
    if (propertyName)
        keyValues.push([E.propertyName, propertyName]);
}
//# sourceMappingURL=errors.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.resolveSchema = exports.getCompilingSchema = exports.resolveRef = exports.compileSchema = exports.SchemaEnv = void 0;
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const validation_error_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/validation_error.js");
const names_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/names.js");
const resolve_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/resolve.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const validate_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/index.js");
class SchemaEnv {
    constructor(env) {
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object")
            schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, resolve_1.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
exports.SchemaEnv = SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = getCompilingSchema.call(this, sch);
    if (_sch)
        return _sch;
    const rootId = (0, resolve_1.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5, lines } = this.opts.code;
    const { ownProperties } = this.opts;
    const gen = new codegen_1.CodeGen(this.scope, { es5, lines, ownProperties });
    let _ValidationError;
    if (sch.$async) {
        _ValidationError = gen.scopeValue("Error", {
            ref: validation_error_1.default,
            code: (0, codegen_1._) `require("ajv/dist/runtime/validation_error").default`,
        });
    }
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen,
        allErrors: this.opts.allErrors,
        data: names_1.default.data,
        parentData: names_1.default.parentData,
        parentDataProperty: names_1.default.parentDataProperty,
        dataNames: [names_1.default.data],
        dataPathArr: [codegen_1.nil],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true
            ? { ref: sch.schema, code: (0, codegen_1.stringify)(sch.schema) }
            : { ref: sch.schema }),
        validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId,
        baseId: sch.baseId || rootId,
        schemaPath: codegen_1.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, codegen_1._) `""`,
        opts: this.opts,
        self: this,
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, validate_1.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs(names_1.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process)
            sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${names_1.default.self}`, `${names_1.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, { ref: validate });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async)
            validate.$async = true;
        if (this.opts.code.source === true) {
            validate.source = { validateName, validateCode, scopeValues: gen._values };
        }
        if (this.opts.unevaluated) {
            const { props, items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof codegen_1.Name ? undefined : props,
                items: items instanceof codegen_1.Name ? undefined : items,
                dynamicProps: props instanceof codegen_1.Name,
                dynamicItems: items instanceof codegen_1.Name,
            };
            if (validate.source)
                validate.source.evaluated = (0, codegen_1.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    }
    catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode)
            this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    }
    finally {
        this._compilations.delete(sch);
    }
}
exports.compileSchema = compileSchema;
function resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc)
        return schOrFunc;
    let _sch = resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId } = this.opts;
        if (schema)
            _sch = new SchemaEnv({ schema, schemaId, root, baseId });
    }
    if (_sch === undefined)
        return;
    return (root.refs[ref] = inlineOrCompile.call(this, _sch));
}
exports.resolveRef = resolveRef;
function inlineOrCompile(sch) {
    if ((0, resolve_1.inlineRef)(sch.schema, this.opts.inlineRefs))
        return sch.schema;
    return sch.validate ? sch : compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function getCompilingSchema(schEnv) {
    for (const sch of this._compilations) {
        if (sameSchemaEnv(sch, schEnv))
            return sch;
    }
}
exports.getCompilingSchema = getCompilingSchema;
function sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function resolve(root, // information about the root schema for the current schema
ref // reference to resolve
) {
    let sch;
    while (typeof (sch = this.refs[ref]) == "string")
        ref = sch;
    return sch || this.schemas[ref] || resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function resolveSchema(root, // root object with properties schema, refs TODO below SchemaEnv is assigned to it
ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, resolve_1._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, resolve_1.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) {
        return getJsonPointer.call(this, p, root);
    }
    const id = (0, resolve_1.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object")
            return;
        return getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object")
        return;
    if (!schOrRef.validate)
        compileSchema.call(this, schOrRef);
    if (id === (0, resolve_1.normalizeId)(ref)) {
        const { schema } = schOrRef;
        const { schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId)
            baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new SchemaEnv({ schema, schemaId, root, baseId });
    }
    return getJsonPointer.call(this, p, schOrRef);
}
exports.resolveSchema = resolveSchema;
const PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions",
]);
function getJsonPointer(parsedRef, { baseId, schema, root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/")
        return;
    for (const part of parsedRef.fragment.slice(1).split("/")) {
        if (typeof schema === "boolean")
            return;
        const partSchema = schema[(0, util_1.unescapeFragment)(part)];
        if (partSchema === undefined)
            return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!PREVENT_SCOPE_CHANGE.has(part) && schId) {
            baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
        }
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, util_1.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId } = this.opts;
    env = env || new SchemaEnv({ schema, schemaId, root, baseId });
    if (env.schema !== env.root.schema)
        return env;
    return undefined;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/names.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const names = {
    // validation function arguments
    data: new codegen_1.Name("data"),
    // args passed from referencing schema
    valCxt: new codegen_1.Name("valCxt"),
    instancePath: new codegen_1.Name("instancePath"),
    parentData: new codegen_1.Name("parentData"),
    parentDataProperty: new codegen_1.Name("parentDataProperty"),
    rootData: new codegen_1.Name("rootData"),
    dynamicAnchors: new codegen_1.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new codegen_1.Name("vErrors"),
    errors: new codegen_1.Name("errors"),
    this: new codegen_1.Name("this"),
    // "globals"
    self: new codegen_1.Name("self"),
    scope: new codegen_1.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new codegen_1.Name("json"),
    jsonPos: new codegen_1.Name("jsonPos"),
    jsonLen: new codegen_1.Name("jsonLen"),
    jsonPart: new codegen_1.Name("jsonPart"),
};
exports["default"] = names;
//# sourceMappingURL=names.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/ref_error.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const resolve_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/resolve.js");
class MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg) {
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, resolve_1.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, resolve_1.normalizeId)((0, resolve_1.getFullPath)(resolver, this.missingRef));
    }
}
exports["default"] = MissingRefError;
//# sourceMappingURL=ref_error.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/resolve.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSchemaRefs = exports.resolveUrl = exports.normalizeId = exports._getFullPath = exports.getFullPath = exports.inlineRef = void 0;
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const equal = __webpack_require__("../../node_modules/fast-deep-equal/index.js");
const traverse = __webpack_require__("../../node_modules/ajv-formats/node_modules/json-schema-traverse/index.js");
// TODO refactor to use keyword definitions
const SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const",
]);
function inlineRef(schema, limit = true) {
    if (typeof schema == "boolean")
        return true;
    if (limit === true)
        return !hasRef(schema);
    if (!limit)
        return false;
    return countKeys(schema) <= limit;
}
exports.inlineRef = inlineRef;
const REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor",
]);
function hasRef(schema) {
    for (const key in schema) {
        if (REF_KEYWORDS.has(key))
            return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some(hasRef))
            return true;
        if (typeof sch == "object" && hasRef(sch))
            return true;
    }
    return false;
}
function countKeys(schema) {
    let count = 0;
    for (const key in schema) {
        if (key === "$ref")
            return Infinity;
        count++;
        if (SIMPLE_INLINED.has(key))
            continue;
        if (typeof schema[key] == "object") {
            (0, util_1.eachItem)(schema[key], (sch) => (count += countKeys(sch)));
        }
        if (count === Infinity)
            return Infinity;
    }
    return count;
}
function getFullPath(resolver, id = "", normalize) {
    if (normalize !== false)
        id = normalizeId(id);
    const p = resolver.parse(id);
    return _getFullPath(resolver, p);
}
exports.getFullPath = getFullPath;
function _getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
exports._getFullPath = _getFullPath;
const TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id) {
    return id ? id.replace(TRAILING_SLASH_HASH, "") : "";
}
exports.normalizeId = normalizeId;
function resolveUrl(resolver, baseId, id) {
    id = normalizeId(id);
    return resolver.resolve(baseId, id);
}
exports.resolveUrl = resolveUrl;
const ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean")
        return {};
    const { schemaId, uriResolver } = this.opts;
    const schId = normalizeId(schema[schemaId] || baseId);
    const baseIds = { "": schId };
    const pathPrefix = getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    traverse(schema, { allKeys: true }, (sch, jsonPtr, _, parentJsonPtr) => {
        if (parentJsonPtr === undefined)
            return;
        const fullPath = pathPrefix + jsonPtr;
        let baseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string")
            baseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = baseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = normalizeId(baseId ? _resolve(baseId, ref) : ref);
            if (schemaRefs.has(ref))
                throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string")
                schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") {
                checkAmbiguosRef(sch, schOrRef.schema, ref);
            }
            else if (ref !== normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                }
                else {
                    this.refs[ref] = fullPath;
                }
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!ANCHOR.test(anchor))
                    throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !equal(sch1, sch2))
            throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
exports.getSchemaRefs = getSchemaRefs;
//# sourceMappingURL=resolve.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/rules.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRules = exports.isJSONType = void 0;
const _jsonTypes = ["string", "number", "integer", "boolean", "null", "object", "array"];
const jsonTypes = new Set(_jsonTypes);
function isJSONType(x) {
    return typeof x == "string" && jsonTypes.has(x);
}
exports.isJSONType = isJSONType;
function getRules() {
    const groups = {
        number: { type: "number", rules: [] },
        string: { type: "string", rules: [] },
        array: { type: "array", rules: [] },
        object: { type: "object", rules: [] },
    };
    return {
        types: { ...groups, integer: true, boolean: true, null: true },
        rules: [{ rules: [] }, groups.number, groups.string, groups.array, groups.object],
        post: { rules: [] },
        all: {},
        keywords: {},
    };
}
exports.getRules = getRules;
//# sourceMappingURL=rules.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.checkStrictMode = exports.getErrorPath = exports.Type = exports.useFunc = exports.setEvaluated = exports.evaluatedPropsToName = exports.mergeEvaluated = exports.eachItem = exports.unescapeJsonPointer = exports.escapeJsonPointer = exports.escapeFragment = exports.unescapeFragment = exports.schemaRefOrVal = exports.schemaHasRulesButRef = exports.schemaHasRules = exports.checkUnknownRules = exports.alwaysValidSchema = exports.toHash = void 0;
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/code.js");
// TODO refactor to use Set
function toHash(arr) {
    const hash = {};
    for (const item of arr)
        hash[item] = true;
    return hash;
}
exports.toHash = toHash;
function alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean")
        return schema;
    if (Object.keys(schema).length === 0)
        return true;
    checkUnknownRules(it, schema);
    return !schemaHasRules(schema, it.self.RULES.all);
}
exports.alwaysValidSchema = alwaysValidSchema;
function checkUnknownRules(it, schema = it.schema) {
    const { opts, self } = it;
    if (!opts.strictSchema)
        return;
    if (typeof schema === "boolean")
        return;
    const rules = self.RULES.keywords;
    for (const key in schema) {
        if (!rules[key])
            checkStrictMode(it, `unknown keyword: "${key}"`);
    }
}
exports.checkUnknownRules = checkUnknownRules;
function schemaHasRules(schema, rules) {
    if (typeof schema == "boolean")
        return !schema;
    for (const key in schema)
        if (rules[key])
            return true;
    return false;
}
exports.schemaHasRules = schemaHasRules;
function schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean")
        return !schema;
    for (const key in schema)
        if (key !== "$ref" && RULES.all[key])
            return true;
    return false;
}
exports.schemaHasRulesButRef = schemaHasRulesButRef;
function schemaRefOrVal({ topSchemaRef, schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean")
            return schema;
        if (typeof schema == "string")
            return (0, codegen_1._) `${schema}`;
    }
    return (0, codegen_1._) `${topSchemaRef}${schemaPath}${(0, codegen_1.getProperty)(keyword)}`;
}
exports.schemaRefOrVal = schemaRefOrVal;
function unescapeFragment(str) {
    return unescapeJsonPointer(decodeURIComponent(str));
}
exports.unescapeFragment = unescapeFragment;
function escapeFragment(str) {
    return encodeURIComponent(escapeJsonPointer(str));
}
exports.escapeFragment = escapeFragment;
function escapeJsonPointer(str) {
    if (typeof str == "number")
        return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
exports.escapeJsonPointer = escapeJsonPointer;
function unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
exports.unescapeJsonPointer = unescapeJsonPointer;
function eachItem(xs, f) {
    if (Array.isArray(xs)) {
        for (const x of xs)
            f(x);
    }
    else {
        f(xs);
    }
}
exports.eachItem = eachItem;
function makeMergeEvaluated({ mergeNames, mergeToName, mergeValues, resultToName, }) {
    return (gen, from, to, toName) => {
        const res = to === undefined
            ? from
            : to instanceof codegen_1.Name
                ? (from instanceof codegen_1.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to)
                : from instanceof codegen_1.Name
                    ? (mergeToName(gen, to, from), from)
                    : mergeValues(from, to);
        return toName === codegen_1.Name && !(res instanceof codegen_1.Name) ? resultToName(gen, res) : res;
    };
}
exports.mergeEvaluated = {
    props: makeMergeEvaluated({
        mergeNames: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true && ${from} !== undefined`, () => {
            gen.if((0, codegen_1._) `${from} === true`, () => gen.assign(to, true), () => gen.assign(to, (0, codegen_1._) `${to} || {}`).code((0, codegen_1._) `Object.assign(${to}, ${from})`));
        }),
        mergeToName: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true`, () => {
            if (from === true) {
                gen.assign(to, true);
            }
            else {
                gen.assign(to, (0, codegen_1._) `${to} || {}`);
                setEvaluated(gen, to, from);
            }
        }),
        mergeValues: (from, to) => (from === true ? true : { ...from, ...to }),
        resultToName: evaluatedPropsToName,
    }),
    items: makeMergeEvaluated({
        mergeNames: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true && ${from} !== undefined`, () => gen.assign(to, (0, codegen_1._) `${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true`, () => gen.assign(to, from === true ? true : (0, codegen_1._) `${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to) => (from === true ? true : Math.max(from, to)),
        resultToName: (gen, items) => gen.var("items", items),
    }),
};
function evaluatedPropsToName(gen, ps) {
    if (ps === true)
        return gen.var("props", true);
    const props = gen.var("props", (0, codegen_1._) `{}`);
    if (ps !== undefined)
        setEvaluated(gen, props, ps);
    return props;
}
exports.evaluatedPropsToName = evaluatedPropsToName;
function setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p) => gen.assign((0, codegen_1._) `${props}${(0, codegen_1.getProperty)(p)}`, true));
}
exports.setEvaluated = setEvaluated;
const snippets = {};
function useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: snippets[f.code] || (snippets[f.code] = new code_1._Code(f.code)),
    });
}
exports.useFunc = useFunc;
var Type;
(function (Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})(Type = exports.Type || (exports.Type = {}));
function getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof codegen_1.Name) {
        const isNumber = dataPropType === Type.Num;
        return jsPropertySyntax
            ? isNumber
                ? (0, codegen_1._) `"[" + ${dataProp} + "]"`
                : (0, codegen_1._) `"['" + ${dataProp} + "']"`
            : isNumber
                ? (0, codegen_1._) `"/" + ${dataProp}`
                : (0, codegen_1._) `"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, codegen_1.getProperty)(dataProp).toString() : "/" + escapeJsonPointer(dataProp);
}
exports.getErrorPath = getErrorPath;
function checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode)
        return;
    msg = `strict mode: ${msg}`;
    if (mode === true)
        throw new Error(msg);
    it.self.logger.warn(msg);
}
exports.checkStrictMode = checkStrictMode;
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/applicability.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shouldUseRule = exports.shouldUseGroup = exports.schemaHasRulesForType = void 0;
function schemaHasRulesForType({ schema, self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && shouldUseGroup(schema, group);
}
exports.schemaHasRulesForType = schemaHasRulesForType;
function shouldUseGroup(schema, group) {
    return group.rules.some((rule) => shouldUseRule(schema, rule));
}
exports.shouldUseGroup = shouldUseGroup;
function shouldUseRule(schema, rule) {
    var _a;
    return (schema[rule.keyword] !== undefined ||
        ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd) => schema[kwd] !== undefined)));
}
exports.shouldUseRule = shouldUseRule;
//# sourceMappingURL=applicability.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/boolSchema.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.boolOrEmptySchema = exports.topBoolOrEmptySchema = void 0;
const errors_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/errors.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const names_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/names.js");
const boolError = {
    message: "boolean schema is false",
};
function topBoolOrEmptySchema(it) {
    const { gen, schema, validateName } = it;
    if (schema === false) {
        falseSchemaError(it, false);
    }
    else if (typeof schema == "object" && schema.$async === true) {
        gen.return(names_1.default.data);
    }
    else {
        gen.assign((0, codegen_1._) `${validateName}.errors`, null);
        gen.return(true);
    }
}
exports.topBoolOrEmptySchema = topBoolOrEmptySchema;
function boolOrEmptySchema(it, valid) {
    const { gen, schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        falseSchemaError(it);
    }
    else {
        gen.var(valid, true); // TODO var
    }
}
exports.boolOrEmptySchema = boolOrEmptySchema;
function falseSchemaError(it, overrideAllErrors) {
    const { gen, data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen,
        keyword: "false schema",
        data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it,
    };
    (0, errors_1.reportError)(cxt, boolError, undefined, overrideAllErrors);
}
//# sourceMappingURL=boolSchema.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/dataType.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reportTypeError = exports.checkDataTypes = exports.checkDataType = exports.coerceAndCheckDataType = exports.getJSONTypes = exports.getSchemaTypes = exports.DataType = void 0;
const rules_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/rules.js");
const applicability_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/applicability.js");
const errors_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/errors.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
var DataType;
(function (DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})(DataType = exports.DataType || (exports.DataType = {}));
function getSchemaTypes(schema) {
    const types = getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false)
            throw new Error("type: null contradicts nullable: false");
    }
    else {
        if (!types.length && schema.nullable !== undefined) {
            throw new Error('"nullable" cannot be used without "type"');
        }
        if (schema.nullable === true)
            types.push("null");
    }
    return types;
}
exports.getSchemaTypes = getSchemaTypes;
function getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [ts] : [];
    if (types.every(rules_1.isJSONType))
        return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
exports.getJSONTypes = getJSONTypes;
function coerceAndCheckDataType(it, types) {
    const { gen, data, opts } = it;
    const coerceTo = coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 &&
        !(coerceTo.length === 0 && types.length === 1 && (0, applicability_1.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = checkDataTypes(types, data, opts.strictNumbers, DataType.Wrong);
        gen.if(wrongType, () => {
            if (coerceTo.length)
                coerceData(it, types, coerceTo);
            else
                reportTypeError(it);
        });
    }
    return checkTypes;
}
exports.coerceAndCheckDataType = coerceAndCheckDataType;
const COERCIBLE = new Set(["string", "number", "integer", "boolean", "null"]);
function coerceToTypes(types, coerceTypes) {
    return coerceTypes
        ? types.filter((t) => COERCIBLE.has(t) || (coerceTypes === "array" && t === "array"))
        : [];
}
function coerceData(it, types, coerceTo) {
    const { gen, data, opts } = it;
    const dataType = gen.let("dataType", (0, codegen_1._) `typeof ${data}`);
    const coerced = gen.let("coerced", (0, codegen_1._) `undefined`);
    if (opts.coerceTypes === "array") {
        gen.if((0, codegen_1._) `${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, () => gen
            .assign(data, (0, codegen_1._) `${data}[0]`)
            .assign(dataType, (0, codegen_1._) `typeof ${data}`)
            .if(checkDataTypes(types, data, opts.strictNumbers), () => gen.assign(coerced, data)));
    }
    gen.if((0, codegen_1._) `${coerced} !== undefined`);
    for (const t of coerceTo) {
        if (COERCIBLE.has(t) || (t === "array" && opts.coerceTypes === "array")) {
            coerceSpecificType(t);
        }
    }
    gen.else();
    reportTypeError(it);
    gen.endIf();
    gen.if((0, codegen_1._) `${coerced} !== undefined`, () => {
        gen.assign(data, coerced);
        assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch (t) {
            case "string":
                gen
                    .elseIf((0, codegen_1._) `${dataType} == "number" || ${dataType} == "boolean"`)
                    .assign(coerced, (0, codegen_1._) `"" + ${data}`)
                    .elseIf((0, codegen_1._) `${data} === null`)
                    .assign(coerced, (0, codegen_1._) `""`);
                return;
            case "number":
                gen
                    .elseIf((0, codegen_1._) `${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`)
                    .assign(coerced, (0, codegen_1._) `+${data}`);
                return;
            case "integer":
                gen
                    .elseIf((0, codegen_1._) `${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`)
                    .assign(coerced, (0, codegen_1._) `+${data}`);
                return;
            case "boolean":
                gen
                    .elseIf((0, codegen_1._) `${data} === "false" || ${data} === 0 || ${data} === null`)
                    .assign(coerced, false)
                    .elseIf((0, codegen_1._) `${data} === "true" || ${data} === 1`)
                    .assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, codegen_1._) `${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen
                    .elseIf((0, codegen_1._) `${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`)
                    .assign(coerced, (0, codegen_1._) `[${data}]`);
        }
    }
}
function assignParentData({ gen, parentData, parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, codegen_1._) `${parentData} !== undefined`, () => gen.assign((0, codegen_1._) `${parentData}[${parentDataProperty}]`, expr));
}
function checkDataType(dataType, data, strictNums, correct = DataType.Correct) {
    const EQ = correct === DataType.Correct ? codegen_1.operators.EQ : codegen_1.operators.NEQ;
    let cond;
    switch (dataType) {
        case "null":
            return (0, codegen_1._) `${data} ${EQ} null`;
        case "array":
            cond = (0, codegen_1._) `Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, codegen_1._) `${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, codegen_1._) `!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, codegen_1._) `typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === DataType.Correct ? cond : (0, codegen_1.not)(cond);
    function numCond(_cond = codegen_1.nil) {
        return (0, codegen_1.and)((0, codegen_1._) `typeof ${data} == "number"`, _cond, strictNums ? (0, codegen_1._) `isFinite(${data})` : codegen_1.nil);
    }
}
exports.checkDataType = checkDataType;
function checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) {
        return checkDataType(dataTypes[0], data, strictNums, correct);
    }
    let cond;
    const types = (0, util_1.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, codegen_1._) `typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, codegen_1._) `!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    }
    else {
        cond = codegen_1.nil;
    }
    if (types.number)
        delete types.integer;
    for (const t in types)
        cond = (0, codegen_1.and)(cond, checkDataType(t, data, strictNums, correct));
    return cond;
}
exports.checkDataTypes = checkDataTypes;
const typeError = {
    message: ({ schema }) => `must be ${schema}`,
    params: ({ schema, schemaValue }) => typeof schema == "string" ? (0, codegen_1._) `{type: ${schema}}` : (0, codegen_1._) `{type: ${schemaValue}}`,
};
function reportTypeError(it) {
    const cxt = getTypeErrorContext(it);
    (0, errors_1.reportError)(cxt, typeError);
}
exports.reportTypeError = reportTypeError;
function getTypeErrorContext(it) {
    const { gen, data, schema } = it;
    const schemaCode = (0, util_1.schemaRefOrVal)(it, schema, "type");
    return {
        gen,
        keyword: "type",
        data,
        schema: schema.type,
        schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it,
    };
}
//# sourceMappingURL=dataType.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/defaults.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assignDefaults = void 0;
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
function assignDefaults(it, ty) {
    const { properties, items } = it.schema;
    if (ty === "object" && properties) {
        for (const key in properties) {
            assignDefault(it, key, properties[key].default);
        }
    }
    else if (ty === "array" && Array.isArray(items)) {
        items.forEach((sch, i) => assignDefault(it, i, sch.default));
    }
}
exports.assignDefaults = assignDefaults;
function assignDefault(it, prop, defaultValue) {
    const { gen, compositeRule, data, opts } = it;
    if (defaultValue === undefined)
        return;
    const childData = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(prop)}`;
    if (compositeRule) {
        (0, util_1.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, codegen_1._) `${childData} === undefined`;
    if (opts.useDefaults === "empty") {
        condition = (0, codegen_1._) `${condition} || ${childData} === null || ${childData} === ""`;
    }
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, codegen_1._) `${childData} = ${(0, codegen_1.stringify)(defaultValue)}`);
}
//# sourceMappingURL=defaults.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getData = exports.KeywordCxt = exports.validateFunctionCode = void 0;
const boolSchema_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/boolSchema.js");
const dataType_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/dataType.js");
const applicability_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/applicability.js");
const dataType_2 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/dataType.js");
const defaults_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/defaults.js");
const keyword_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/keyword.js");
const subschema_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/subschema.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const names_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/names.js");
const resolve_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/resolve.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const errors_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/errors.js");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function validateFunctionCode(it) {
    if (isSchemaObj(it)) {
        checkKeywords(it);
        if (schemaCxtHasRules(it)) {
            topSchemaObjCode(it);
            return;
        }
    }
    validateFunction(it, () => (0, boolSchema_1.topBoolOrEmptySchema)(it));
}
exports.validateFunctionCode = validateFunctionCode;
function validateFunction({ gen, validateName, schema, schemaEnv, opts }, body) {
    if (opts.code.es5) {
        gen.func(validateName, (0, codegen_1._) `${names_1.default.data}, ${names_1.default.valCxt}`, schemaEnv.$async, () => {
            gen.code((0, codegen_1._) `"use strict"; ${funcSourceUrl(schema, opts)}`);
            destructureValCxtES5(gen, opts);
            gen.code(body);
        });
    }
    else {
        gen.func(validateName, (0, codegen_1._) `${names_1.default.data}, ${destructureValCxt(opts)}`, schemaEnv.$async, () => gen.code(funcSourceUrl(schema, opts)).code(body));
    }
}
function destructureValCxt(opts) {
    return (0, codegen_1._) `{${names_1.default.instancePath}="", ${names_1.default.parentData}, ${names_1.default.parentDataProperty}, ${names_1.default.rootData}=${names_1.default.data}${opts.dynamicRef ? (0, codegen_1._) `, ${names_1.default.dynamicAnchors}={}` : codegen_1.nil}}={}`;
}
function destructureValCxtES5(gen, opts) {
    gen.if(names_1.default.valCxt, () => {
        gen.var(names_1.default.instancePath, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.instancePath}`);
        gen.var(names_1.default.parentData, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.parentData}`);
        gen.var(names_1.default.parentDataProperty, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.parentDataProperty}`);
        gen.var(names_1.default.rootData, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.rootData}`);
        if (opts.dynamicRef)
            gen.var(names_1.default.dynamicAnchors, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.dynamicAnchors}`);
    }, () => {
        gen.var(names_1.default.instancePath, (0, codegen_1._) `""`);
        gen.var(names_1.default.parentData, (0, codegen_1._) `undefined`);
        gen.var(names_1.default.parentDataProperty, (0, codegen_1._) `undefined`);
        gen.var(names_1.default.rootData, names_1.default.data);
        if (opts.dynamicRef)
            gen.var(names_1.default.dynamicAnchors, (0, codegen_1._) `{}`);
    });
}
function topSchemaObjCode(it) {
    const { schema, opts, gen } = it;
    validateFunction(it, () => {
        if (opts.$comment && schema.$comment)
            commentKeyword(it);
        checkNoDefault(it);
        gen.let(names_1.default.vErrors, null);
        gen.let(names_1.default.errors, 0);
        if (opts.unevaluated)
            resetEvaluated(it);
        typeAndKeywords(it);
        returnResults(it);
    });
    return;
}
function resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen, validateName } = it;
    it.evaluated = gen.const("evaluated", (0, codegen_1._) `${validateName}.evaluated`);
    gen.if((0, codegen_1._) `${it.evaluated}.dynamicProps`, () => gen.assign((0, codegen_1._) `${it.evaluated}.props`, (0, codegen_1._) `undefined`));
    gen.if((0, codegen_1._) `${it.evaluated}.dynamicItems`, () => gen.assign((0, codegen_1._) `${it.evaluated}.items`, (0, codegen_1._) `undefined`));
}
function funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, codegen_1._) `/*# sourceURL=${schId} */` : codegen_1.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function subschemaCode(it, valid) {
    if (isSchemaObj(it)) {
        checkKeywords(it);
        if (schemaCxtHasRules(it)) {
            subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, boolSchema_1.boolOrEmptySchema)(it, valid);
}
function schemaCxtHasRules({ schema, self }) {
    if (typeof schema == "boolean")
        return !schema;
    for (const key in schema)
        if (self.RULES.all[key])
            return true;
    return false;
}
function isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function subSchemaObjCode(it, valid) {
    const { schema, gen, opts } = it;
    if (opts.$comment && schema.$comment)
        commentKeyword(it);
    updateContext(it);
    checkAsyncSchema(it);
    const errsCount = gen.const("_errs", names_1.default.errors);
    typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, codegen_1._) `${errsCount} === ${names_1.default.errors}`);
}
function checkKeywords(it) {
    (0, util_1.checkUnknownRules)(it);
    checkRefsAndKeywords(it);
}
function typeAndKeywords(it, errsCount) {
    if (it.opts.jtd)
        return schemaKeywords(it, [], false, errsCount);
    const types = (0, dataType_1.getSchemaTypes)(it.schema);
    const checkedTypes = (0, dataType_1.coerceAndCheckDataType)(it, types);
    schemaKeywords(it, types, !checkedTypes, errsCount);
}
function checkRefsAndKeywords(it) {
    const { schema, errSchemaPath, opts, self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, util_1.schemaHasRulesButRef)(schema, self.RULES)) {
        self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
    }
}
function checkNoDefault(it) {
    const { schema, opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) {
        (0, util_1.checkStrictMode)(it, "default is ignored in the schema root");
    }
}
function updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId)
        it.baseId = (0, resolve_1.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async)
        throw new Error("async schema in sync schema");
}
function commentKeyword({ gen, schemaEnv, schema, errSchemaPath, opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) {
        gen.code((0, codegen_1._) `${names_1.default.self}.logger.log(${msg})`);
    }
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, codegen_1.str) `${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", { ref: schemaEnv.root });
        gen.code((0, codegen_1._) `${names_1.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function returnResults(it) {
    const { gen, schemaEnv, validateName, ValidationError, opts } = it;
    if (schemaEnv.$async) {
        // TODO assign unevaluated
        gen.if((0, codegen_1._) `${names_1.default.errors} === 0`, () => gen.return(names_1.default.data), () => gen.throw((0, codegen_1._) `new ${ValidationError}(${names_1.default.vErrors})`));
    }
    else {
        gen.assign((0, codegen_1._) `${validateName}.errors`, names_1.default.vErrors);
        if (opts.unevaluated)
            assignEvaluated(it);
        gen.return((0, codegen_1._) `${names_1.default.errors} === 0`);
    }
}
function assignEvaluated({ gen, evaluated, props, items }) {
    if (props instanceof codegen_1.Name)
        gen.assign((0, codegen_1._) `${evaluated}.props`, props);
    if (items instanceof codegen_1.Name)
        gen.assign((0, codegen_1._) `${evaluated}.items`, items);
}
function schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen, schema, data, allErrors, opts, self } = it;
    const { RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, util_1.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(() => keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd)
        checkStrictTypes(it, types);
    gen.block(() => {
        for (const group of RULES.rules)
            groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, applicability_1.shouldUseGroup)(schema, group))
            return;
        if (group.type) {
            gen.if((0, dataType_2.checkDataType)(group.type, data, opts.strictNumbers));
            iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, dataType_2.reportTypeError)(it);
            }
            gen.endIf();
        }
        else {
            iterateKeywords(it, group);
        }
        // TODO make it "ok" call?
        if (!allErrors)
            gen.if((0, codegen_1._) `${names_1.default.errors} === ${errsCount || 0}`);
    }
}
function iterateKeywords(it, group) {
    const { gen, schema, opts: { useDefaults }, } = it;
    if (useDefaults)
        (0, defaults_1.assignDefaults)(it, group.type);
    gen.block(() => {
        for (const rule of group.rules) {
            if ((0, applicability_1.shouldUseRule)(schema, rule)) {
                keywordCode(it, rule.keyword, rule.definition, group.type);
            }
        }
    });
}
function checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes)
        return;
    checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes)
        checkMultipleTypes(it, types);
    checkKeywordTypes(it, it.dataTypes);
}
function checkContextTypes(it, types) {
    if (!types.length)
        return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t) => {
        if (!includesType(it.dataTypes, t)) {
            strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
        }
    });
    narrowSchemaTypes(it, types);
}
function checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) {
        strictTypesError(it, "use allowUnionTypes to allow union type keyword");
    }
}
function checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for (const keyword in rules) {
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, applicability_1.shouldUseRule)(it.schema, rule)) {
            const { type } = rule.definition;
            if (type.length && !type.some((t) => hasApplicableType(ts, t))) {
                strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
            }
        }
    }
}
function hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || (kwdT === "number" && schTs.includes("integer"));
}
function includesType(ts, t) {
    return ts.includes(t) || (t === "integer" && ts.includes("number"));
}
function narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes) {
        if (includesType(withTypes, t))
            ts.push(t);
        else if (withTypes.includes("integer") && t === "number")
            ts.push("integer");
    }
    it.dataTypes = ts;
}
function strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, util_1.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class KeywordCxt {
    constructor(it, def, keyword) {
        (0, keyword_1.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, util_1.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) {
            this.schemaCode = it.gen.const("vSchema", getData(this.$data, it));
        }
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, keyword_1.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) {
                throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
            }
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) {
            this.errsCount = it.gen.const("_errs", names_1.default.errors);
        }
    }
    result(condition, successAction, failAction) {
        this.failResult((0, codegen_1.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction)
            failAction();
        else
            this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors)
                this.gen.endIf();
        }
        else {
            if (this.allErrors)
                this.gen.endIf();
            else
                this.gen.else();
        }
    }
    pass(condition, failAction) {
        this.failResult((0, codegen_1.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors)
                this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors)
            this.gen.endIf();
        else
            this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data)
            return this.fail(condition);
        const { schemaCode } = this;
        this.fail((0, codegen_1._) `${schemaCode} !== undefined && (${(0, codegen_1.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        ;
        (append ? errors_1.reportExtraError : errors_1.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, errors_1.reportError)(this, this.def.$dataError || errors_1.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined)
            throw new Error('add "trackErrors" to keyword definition');
        (0, errors_1.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors)
            this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign)
            Object.assign(this.params, obj);
        else
            this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = codegen_1.nil) {
        this.gen.block(() => {
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = codegen_1.nil, $dataValid = codegen_1.nil) {
        if (!this.$data)
            return;
        const { gen, schemaCode, schemaType, def } = this;
        gen.if((0, codegen_1.or)((0, codegen_1._) `${schemaCode} === undefined`, $dataValid));
        if (valid !== codegen_1.nil)
            gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== codegen_1.nil)
                gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen, schemaCode, schemaType, def, it } = this;
        return (0, codegen_1.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */
                if (!(schemaCode instanceof codegen_1.Name))
                    throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [schemaType];
                return (0, codegen_1._) `${(0, dataType_2.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, dataType_2.DataType.Wrong)}`;
            }
            return codegen_1.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", { ref: def.validateSchema }); // TODO value.code for standalone
                return (0, codegen_1._) `!${validateSchemaRef}(${schemaCode})`;
            }
            return codegen_1.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, subschema_1.getSubschema)(this.it, appl);
        (0, subschema_1.extendSubschemaData)(subschema, this.it, appl);
        (0, subschema_1.extendSubschemaMode)(subschema, appl);
        const nextContext = { ...this.it, ...subschema, items: undefined, props: undefined };
        subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it, gen } = this;
        if (!it.opts.unevaluated)
            return;
        if (it.props !== true && schemaCxt.props !== undefined) {
            it.props = util_1.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        }
        if (it.items !== true && schemaCxt.items !== undefined) {
            it.items = util_1.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
        }
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it, gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, () => this.mergeEvaluated(schemaCxt, codegen_1.Name));
            return true;
        }
    }
}
exports.KeywordCxt = KeywordCxt;
function keywordCode(it, keyword, def, ruleType) {
    const cxt = new KeywordCxt(it, def, keyword);
    if ("code" in def) {
        def.code(cxt, ruleType);
    }
    else if (cxt.$data && def.validate) {
        (0, keyword_1.funcKeywordCode)(cxt, def);
    }
    else if ("macro" in def) {
        (0, keyword_1.macroKeywordCode)(cxt, def);
    }
    else if (def.compile || def.validate) {
        (0, keyword_1.funcKeywordCode)(cxt, def);
    }
}
const JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData($data, { dataLevel, dataNames, dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "")
        return names_1.default.rootData;
    if ($data[0] === "/") {
        if (!JSON_POINTER.test($data))
            throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = names_1.default.rootData;
    }
    else {
        const matches = RELATIVE_JSON_POINTER.exec($data);
        if (!matches)
            throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel)
                throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel)
            throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer)
            return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments) {
        if (segment) {
            data = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)((0, util_1.unescapeJsonPointer)(segment))}`;
            expr = (0, codegen_1._) `${expr} && ${data}`;
        }
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
exports.getData = getData;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/keyword.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateKeywordUsage = exports.validSchemaType = exports.funcKeywordCode = exports.macroKeywordCode = void 0;
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const names_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/names.js");
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
const errors_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/errors.js");
function macroKeywordCode(cxt, def) {
    const { gen, keyword, schema, parentSchema, it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false)
        it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: codegen_1.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true,
    }, valid);
    cxt.pass(valid, () => cxt.error(true));
}
exports.macroKeywordCode = macroKeywordCode;
function funcKeywordCode(cxt, def) {
    var _a;
    const { gen, keyword, schema, parentSchema, $data, it } = cxt;
    checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying)
                modifyData(cxt);
            reportErrs(() => cxt.error());
        }
        else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying)
                modifyData(cxt);
            reportErrs(() => addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(() => assignValid((0, codegen_1._) `await `), (e) => gen.assign(valid, false).if((0, codegen_1._) `${e} instanceof ${it.ValidationError}`, () => gen.assign(ruleErrs, (0, codegen_1._) `${e}.errors`), () => gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, codegen_1._) `${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid(codegen_1.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, codegen_1._) `await ` : codegen_1.nil) {
        const passCxt = it.opts.passContext ? names_1.default.this : names_1.default.self;
        const passSchema = !(("compile" in def && !$data) || def.schema === false);
        gen.assign(valid, (0, codegen_1._) `${_await}${(0, code_1.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, codegen_1.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
exports.funcKeywordCode = funcKeywordCode;
function modifyData(cxt) {
    const { gen, data, it } = cxt;
    gen.if(it.parentData, () => gen.assign(data, (0, codegen_1._) `${it.parentData}[${it.parentDataProperty}]`));
}
function addErrs(cxt, errs) {
    const { gen } = cxt;
    gen.if((0, codegen_1._) `Array.isArray(${errs})`, () => {
        gen
            .assign(names_1.default.vErrors, (0, codegen_1._) `${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`)
            .assign(names_1.default.errors, (0, codegen_1._) `${names_1.default.vErrors}.length`);
        (0, errors_1.extendErrors)(cxt);
    }, () => cxt.error());
}
function checkAsyncKeyword({ schemaEnv }, def) {
    if (def.async && !schemaEnv.$async)
        throw new Error("async keyword in sync schema");
}
function useKeyword(gen, keyword, result) {
    if (result === undefined)
        throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? { ref: result } : { ref: result, code: (0, codegen_1.stringify)(result) });
}
function validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return (!schemaType.length ||
        schemaType.some((st) => st === "array"
            ? Array.isArray(schema)
            : st === "object"
                ? schema && typeof schema == "object" && !Array.isArray(schema)
                : typeof schema == st || (allowUndefined && typeof schema == "undefined")));
}
exports.validSchemaType = validSchemaType;
function validateKeywordUsage({ schema, opts, self, errSchemaPath }, def, keyword) {
    /* istanbul ignore if */
    if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) {
        throw new Error("ajv implementation error");
    }
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd) => !Object.prototype.hasOwnProperty.call(schema, kwd))) {
        throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    }
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` +
                self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log")
                self.logger.error(msg);
            else
                throw new Error(msg);
        }
    }
}
exports.validateKeywordUsage = validateKeywordUsage;
//# sourceMappingURL=keyword.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/subschema.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.extendSubschemaMode = exports.extendSubschemaData = exports.getSubschema = void 0;
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
function getSubschema(it, { keyword, schemaProp, schema, schemaPath, errSchemaPath, topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) {
        throw new Error('both "keyword" and "schema" passed, only one allowed');
    }
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined
            ? {
                schema: sch,
                schemaPath: (0, codegen_1._) `${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}`,
                errSchemaPath: `${it.errSchemaPath}/${keyword}`,
            }
            : {
                schema: sch[schemaProp],
                schemaPath: (0, codegen_1._) `${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}${(0, codegen_1.getProperty)(schemaProp)}`,
                errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, util_1.escapeFragment)(schemaProp)}`,
            };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) {
            throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        }
        return {
            schema,
            schemaPath,
            topSchemaRef,
            errSchemaPath,
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
exports.getSubschema = getSubschema;
function extendSubschemaData(subschema, it, { dataProp, dataPropType: dpType, data, dataTypes, propertyName }) {
    if (data !== undefined && dataProp !== undefined) {
        throw new Error('both "data" and "dataProp" passed, only one allowed');
    }
    const { gen } = it;
    if (dataProp !== undefined) {
        const { errorPath, dataPathArr, opts } = it;
        const nextData = gen.let("data", (0, codegen_1._) `${it.data}${(0, codegen_1.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, codegen_1.str) `${errorPath}${(0, util_1.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, codegen_1._) `${dataProp}`;
        subschema.dataPathArr = [...dataPathArr, subschema.parentDataProperty];
    }
    if (data !== undefined) {
        const nextData = data instanceof codegen_1.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined)
            subschema.propertyName = propertyName;
        // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes)
        subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [...it.dataNames, _nextData];
    }
}
exports.extendSubschemaData = extendSubschemaData;
function extendSubschemaMode(subschema, { jtdDiscriminator, jtdMetadata, compositeRule, createErrors, allErrors }) {
    if (compositeRule !== undefined)
        subschema.compositeRule = compositeRule;
    if (createErrors !== undefined)
        subschema.createErrors = createErrors;
    if (allErrors !== undefined)
        subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
exports.extendSubschemaMode = extendSubschemaMode;
//# sourceMappingURL=subschema.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/core.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;
var validate_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/index.js");
Object.defineProperty(exports, "KeywordCxt", ({ enumerable: true, get: function () { return validate_1.KeywordCxt; } }));
var codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
Object.defineProperty(exports, "_", ({ enumerable: true, get: function () { return codegen_1._; } }));
Object.defineProperty(exports, "str", ({ enumerable: true, get: function () { return codegen_1.str; } }));
Object.defineProperty(exports, "stringify", ({ enumerable: true, get: function () { return codegen_1.stringify; } }));
Object.defineProperty(exports, "nil", ({ enumerable: true, get: function () { return codegen_1.nil; } }));
Object.defineProperty(exports, "Name", ({ enumerable: true, get: function () { return codegen_1.Name; } }));
Object.defineProperty(exports, "CodeGen", ({ enumerable: true, get: function () { return codegen_1.CodeGen; } }));
const validation_error_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/validation_error.js");
const ref_error_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/ref_error.js");
const rules_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/rules.js");
const compile_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/index.js");
const codegen_2 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const resolve_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/resolve.js");
const dataType_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/dataType.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const $dataRefSchema = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/refs/data.json");
const uri_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/uri.js");
const defaultRegExp = (str, flags) => new RegExp(str, flags);
defaultRegExp.code = "new RegExp";
const META_IGNORE_OPTIONS = ["removeAdditional", "useDefaults", "coerceTypes"];
const EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error",
]);
const removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now.",
};
const deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.',
};
const MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : uri_1.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? { ...o.code, optimize, regExp } : { optimize, regExp },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver,
    };
}
class Ajv {
    constructor(opts = {}) {
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = { ...opts, ...requiredOptions(opts) };
        const { es5, lines } = this.opts.code;
        this.scope = new codegen_2.ValueScope({ scope: {}, prefixes: EXT_SCOPE_NAMES, es5, lines });
        this.logger = getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, rules_1.getRules)();
        checkOptions.call(this, removedOptions, opts, "NOT SUPPORTED");
        checkOptions.call(this, deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = getMetaSchemaOptions.call(this);
        if (opts.formats)
            addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords)
            addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object")
            this.addMetaSchema(opts.meta);
        addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data, meta, schemaId } = this.opts;
        let _dataRefSchema = $dataRefSchema;
        if (schemaId === "id") {
            _dataRefSchema = { ...$dataRefSchema };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data)
            this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta, schemaId } = this.opts;
        return (this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined);
    }
    validate(schemaKeyRef, // key, ref or schema object
    data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v)
                throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        }
        else {
            v = this.compile(schemaKeyRef);
        }
        const valid = v(data);
        if (!("$async" in v))
            this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return (sch.validate || this._compileSchemaEnv(sch));
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") {
            throw new Error("options.loadSchema should be a function");
        }
        const { loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) {
                await runCompileAsync.call(this, { $ref }, true);
            }
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            }
            catch (e) {
                if (!(e instanceof ref_error_1.default))
                    throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef }) {
            if (this.refs[ref]) {
                throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
            }
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref])
                await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref])
                this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p)
                return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            }
            finally {
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, // If array is passed, `key` will be ignored
    key, // Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
    _meta, // true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
    _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)
                this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") {
                throw new Error(`schema ${schemaId} must be string`);
            }
        }
        key = (0, resolve_1.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, // schema key
    _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean")
            return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") {
            throw new Error("$schema must be a string");
        }
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log")
                this.logger.error(message);
            else
                throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while (typeof (sch = getSchEnv.call(this, keyRef)) == "string")
            keyRef = sch;
        if (sch === undefined) {
            const { schemaId } = this.opts;
            const root = new compile_1.SchemaEnv({ schema: {}, schemaId });
            sch = compile_1.resolveSchema.call(this, root, keyRef);
            if (!sch)
                return;
            this.refs[keyRef] = sch;
        }
        return (sch.validate || this._compileSchemaEnv(sch));
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch (typeof schemaKeyRef) {
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string": {
                const sch = getSchEnv.call(this, schemaKeyRef);
                if (typeof sch == "object")
                    this._cache.delete(sch.schema);
                delete this.schemas[schemaKeyRef];
                delete this.refs[schemaKeyRef];
                return this;
            }
            case "object": {
                const cacheKey = schemaKeyRef;
                this._cache.delete(cacheKey);
                let id = schemaKeyRef[this.opts.schemaId];
                if (id) {
                    id = (0, resolve_1.normalizeId)(id);
                    delete this.schemas[id];
                    delete this.refs[id];
                }
                return this;
            }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)
            this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        }
        else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) {
                throw new Error("addKeywords: keyword must be string or non-empty array");
            }
        }
        else {
            throw new Error("invalid addKeywords parameters");
        }
        checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, util_1.eachItem)(keyword, (kwd) => addRule.call(this, kwd));
            return this;
        }
        keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, dataType_1.getJSONTypes)(def.type),
            schemaType: (0, dataType_1.getJSONTypes)(def.schemaType),
        };
        (0, util_1.eachItem)(keyword, definition.type.length === 0
            ? (k) => addRule.call(this, k, definition)
            : (k) => definition.type.forEach((t) => addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules) {
            const i = group.rules.findIndex((rule) => rule.keyword === keyword);
            if (i >= 0)
                group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string")
            format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, // optional array of validation errors
    { separator = ", ", dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0)
            return "No errors";
        return errors
            .map((e) => `${dataVar}${e.instancePath} ${e.message}`)
            .reduce((text, msg) => text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers) {
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)
                keywords = keywords[seg];
            for (const key in rules) {
                const rule = rules[key];
                if (typeof rule != "object")
                    continue;
                const { $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema)
                    keywords[key] = schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for (const keyRef in schemas) {
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") {
                    delete schemas[keyRef];
                }
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId } = this.opts;
        if (typeof schema == "object") {
            id = schema[schemaId];
        }
        else {
            if (this.opts.jtd)
                throw new Error("schema must be object");
            else if (typeof schema != "boolean")
                throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined)
            return sch;
        baseId = (0, resolve_1.normalizeId)(id || baseId);
        const localRefs = resolve_1.getSchemaRefs.call(this, schema, baseId);
        sch = new compile_1.SchemaEnv({ schema, schemaId, meta, baseId, localRefs });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId)
                this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema)
            this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) {
            throw new Error(`schema with key or id "${id}" already exists`);
        }
    }
    _compileSchemaEnv(sch) {
        if (sch.meta)
            this._compileMetaSchema(sch);
        else
            compile_1.compileSchema.call(this, sch);
        /* istanbul ignore if */
        if (!sch.validate)
            throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            compile_1.compileSchema.call(this, sch);
        }
        finally {
            this.opts = currentOpts;
        }
    }
}
exports["default"] = Ajv;
Ajv.ValidationError = validation_error_1.default;
Ajv.MissingRefError = ref_error_1.default;
function checkOptions(checkOpts, options, msg, log = "error") {
    for (const key in checkOpts) {
        const opt = key;
        if (opt in options)
            this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function getSchEnv(keyRef) {
    keyRef = (0, resolve_1.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas)
        return;
    if (Array.isArray(optsSchemas))
        this.addSchema(optsSchemas);
    else
        for (const key in optsSchemas)
            this.addSchema(optsSchemas[key], key);
}
function addInitialFormats() {
    for (const name in this.opts.formats) {
        const format = this.opts.formats[name];
        if (format)
            this.addFormat(name, format);
    }
}
function addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for (const keyword in defs) {
        const def = defs[keyword];
        if (!def.keyword)
            def.keyword = keyword;
        this.addKeyword(def);
    }
}
function getMetaSchemaOptions() {
    const metaOpts = { ...this.opts };
    for (const opt of META_IGNORE_OPTIONS)
        delete metaOpts[opt];
    return metaOpts;
}
const noLogs = { log() { }, warn() { }, error() { } };
function getLogger(logger) {
    if (logger === false)
        return noLogs;
    if (logger === undefined)
        return console;
    if (logger.log && logger.warn && logger.error)
        return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function checkKeyword(keyword, def) {
    const { RULES } = this;
    (0, util_1.eachItem)(keyword, (kwd) => {
        if (RULES.keywords[kwd])
            throw new Error(`Keyword ${kwd} is already defined`);
        if (!KEYWORD_NAME.test(kwd))
            throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def)
        return;
    if (def.$data && !("code" in def || "validate" in def)) {
        throw new Error('$data keyword must have "code" or "validate" function');
    }
}
function addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post)
        throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t }) => t === dataType);
    if (!ruleGroup) {
        ruleGroup = { type: dataType, rules: [] };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition)
        return;
    const rule = {
        keyword,
        definition: {
            ...definition,
            type: (0, dataType_1.getJSONTypes)(definition.type),
            schemaType: (0, dataType_1.getJSONTypes)(definition.schemaType),
        },
    };
    if (definition.before)
        addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else
        ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 ? void 0 : _a.forEach((kwd) => this.addKeyword(kwd));
}
function addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule) => _rule.keyword === before);
    if (i >= 0) {
        ruleGroup.rules.splice(i, 0, rule);
    }
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function keywordMetaschema(def) {
    let { metaSchema } = def;
    if (metaSchema === undefined)
        return;
    if (def.$data && this.opts.$data)
        metaSchema = schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#",
};
function schemaOrData(schema) {
    return { anyOf: [schema, $dataRef] };
}
//# sourceMappingURL=core.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/equal.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// https://github.com/ajv-validator/ajv/issues/889
const equal = __webpack_require__("../../node_modules/fast-deep-equal/index.js");
equal.code = 'require("ajv/dist/runtime/equal").default';
exports["default"] = equal;
//# sourceMappingURL=equal.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/ucs2length.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++; // low surrogate
        }
    }
    return length;
}
exports["default"] = ucs2length;
ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
//# sourceMappingURL=ucs2length.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/uri.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const uri = __webpack_require__("../../node_modules/uri-js/dist/es5/uri.all.js");
uri.code = 'require("ajv/dist/runtime/uri").default';
exports["default"] = uri;
//# sourceMappingURL=uri.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/validation_error.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
class ValidationError extends Error {
    constructor(errors) {
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
exports["default"] = ValidationError;
//# sourceMappingURL=validation_error.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/additionalItems.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateAdditionalItems = void 0;
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const error = {
    message: ({ params: { len } }) => (0, codegen_1.str) `must NOT have more than ${len} items`,
    params: ({ params: { len } }) => (0, codegen_1._) `{limit: ${len}}`,
};
const def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: ["boolean", "object"],
    before: "uniqueItems",
    error,
    code(cxt) {
        const { parentSchema, it } = cxt;
        const { items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, util_1.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        validateAdditionalItems(cxt, items);
    },
};
function validateAdditionalItems(cxt, items) {
    const { gen, schema, data, keyword, it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, codegen_1._) `${data}.length`);
    if (schema === false) {
        cxt.setParams({ len: items.length });
        cxt.pass((0, codegen_1._) `${len} <= ${items.length}`);
    }
    else if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, codegen_1._) `${len} <= ${items.length}`); // TODO var
        gen.if((0, codegen_1.not)(valid), () => validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i) => {
            cxt.subschema({ keyword, dataProp: i, dataPropType: util_1.Type.Num }, valid);
            if (!it.allErrors)
                gen.if((0, codegen_1.not)(valid), () => gen.break());
        });
    }
}
exports.validateAdditionalItems = validateAdditionalItems;
exports["default"] = def;
//# sourceMappingURL=additionalItems.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/additionalProperties.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const names_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/names.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const error = {
    message: "must NOT have additional properties",
    params: ({ params }) => (0, codegen_1._) `{additionalProperty: ${params.additionalProperty}}`,
};
const def = {
    keyword: "additionalProperties",
    type: ["object"],
    schemaType: ["boolean", "object"],
    allowUndefined: true,
    trackErrors: true,
    error,
    code(cxt) {
        const { gen, schema, parentSchema, data, errsCount, it } = cxt;
        /* istanbul ignore if */
        if (!errsCount)
            throw new Error("ajv implementation error");
        const { allErrors, opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, util_1.alwaysValidSchema)(it, schema))
            return;
        const props = (0, code_1.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, code_1.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, codegen_1._) `${errsCount} === ${names_1.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key) => {
                if (!props.length && !patProps.length)
                    additionalPropertyCode(key);
                else
                    gen.if(isAdditional(key), () => additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, util_1.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, code_1.isOwnProperty)(gen, propsSchema, key);
            }
            else if (props.length) {
                definedProp = (0, codegen_1.or)(...props.map((p) => (0, codegen_1._) `${key} === ${p}`));
            }
            else {
                definedProp = codegen_1.nil;
            }
            if (patProps.length) {
                definedProp = (0, codegen_1.or)(definedProp, ...patProps.map((p) => (0, codegen_1._) `${(0, code_1.usePattern)(cxt, p)}.test(${key})`));
            }
            return (0, codegen_1.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, codegen_1._) `delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || (opts.removeAdditional && schema === false)) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({ additionalProperty: key });
                cxt.error();
                if (!allErrors)
                    gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, codegen_1.not)(valid), () => {
                        cxt.reset();
                        deleteAdditional(key);
                    });
                }
                else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors)
                        gen.if((0, codegen_1.not)(valid), () => gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: util_1.Type.Str,
            };
            if (errors === false) {
                Object.assign(subschema, {
                    compositeRule: true,
                    createErrors: false,
                    allErrors: false,
                });
            }
            cxt.subschema(subschema, valid);
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=additionalProperties.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/allOf.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const def = {
    keyword: "allOf",
    schemaType: "array",
    code(cxt) {
        const { gen, schema, it } = cxt;
        /* istanbul ignore if */
        if (!Array.isArray(schema))
            throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i) => {
            if ((0, util_1.alwaysValidSchema)(it, sch))
                return;
            const schCxt = cxt.subschema({ keyword: "allOf", schemaProp: i }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    },
};
exports["default"] = def;
//# sourceMappingURL=allOf.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/anyOf.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
const def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: code_1.validateUnion,
    error: { message: "must match a schema in anyOf" },
};
exports["default"] = def;
//# sourceMappingURL=anyOf.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/contains.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const error = {
    message: ({ params: { min, max } }) => max === undefined
        ? (0, codegen_1.str) `must contain at least ${min} valid item(s)`
        : (0, codegen_1.str) `must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min, max } }) => max === undefined ? (0, codegen_1._) `{minContains: ${min}}` : (0, codegen_1._) `{minContains: ${min}, maxContains: ${max}}`,
};
const def = {
    keyword: "contains",
    type: "array",
    schemaType: ["object", "boolean"],
    before: "uniqueItems",
    trackErrors: true,
    error,
    code(cxt) {
        const { gen, schema, parentSchema, data, it } = cxt;
        let min;
        let max;
        const { minContains, maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        }
        else {
            min = 1;
        }
        const len = gen.const("len", (0, codegen_1._) `${data}.length`);
        cxt.setParams({ min, max });
        if (max === undefined && min === 0) {
            (0, util_1.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, util_1.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, util_1.alwaysValidSchema)(it, schema)) {
            let cond = (0, codegen_1._) `${len} >= ${min}`;
            if (max !== undefined)
                cond = (0, codegen_1._) `${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) {
            validateItems(valid, () => gen.if(valid, () => gen.break()));
        }
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined)
                gen.if((0, codegen_1._) `${data}.length > 0`, validateItemsWithCount);
        }
        else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, () => cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, () => gen.if(schValid, () => checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i) => {
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: util_1.Type.Num,
                    compositeRule: true,
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, codegen_1._) `${count}++`);
            if (max === undefined) {
                gen.if((0, codegen_1._) `${count} >= ${min}`, () => gen.assign(valid, true).break());
            }
            else {
                gen.if((0, codegen_1._) `${count} > ${max}`, () => gen.assign(valid, false).break());
                if (min === 1)
                    gen.assign(valid, true);
                else
                    gen.if((0, codegen_1._) `${count} >= ${min}`, () => gen.assign(valid, true));
            }
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=contains.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/dependencies.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateSchemaDeps = exports.validatePropertyDeps = exports.error = void 0;
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
exports.error = {
    message: ({ params: { property, depsCount, deps } }) => {
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, codegen_1.str) `must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property, depsCount, deps, missingProperty } }) => (0, codegen_1._) `{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`, // TODO change to reference
};
const def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: exports.error,
    code(cxt) {
        const [propDeps, schDeps] = splitDependencies(cxt);
        validatePropertyDeps(cxt, propDeps);
        validateSchemaDeps(cxt, schDeps);
    },
};
function splitDependencies({ schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for (const key in schema) {
        if (key === "__proto__")
            continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [propertyDeps, schemaDeps];
}
function validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen, data, it } = cxt;
    if (Object.keys(propertyDeps).length === 0)
        return;
    const missing = gen.let("missing");
    for (const prop in propertyDeps) {
        const deps = propertyDeps[prop];
        if (deps.length === 0)
            continue;
        const hasProperty = (0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", "),
        });
        if (it.allErrors) {
            gen.if(hasProperty, () => {
                for (const depProp of deps) {
                    (0, code_1.checkReportMissingProp)(cxt, depProp);
                }
            });
        }
        else {
            gen.if((0, codegen_1._) `${hasProperty} && (${(0, code_1.checkMissingProp)(cxt, deps, missing)})`);
            (0, code_1.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
exports.validatePropertyDeps = validatePropertyDeps;
function validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen, data, keyword, it } = cxt;
    const valid = gen.name("valid");
    for (const prop in schemaDeps) {
        if ((0, util_1.alwaysValidSchema)(it, schemaDeps[prop]))
            continue;
        gen.if((0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties), () => {
            const schCxt = cxt.subschema({ keyword, schemaProp: prop }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, () => gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
exports.validateSchemaDeps = validateSchemaDeps;
exports["default"] = def;
//# sourceMappingURL=dependencies.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/if.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const error = {
    message: ({ params }) => (0, codegen_1.str) `must match "${params.ifClause}" schema`,
    params: ({ params }) => (0, codegen_1._) `{failingKeyword: ${params.ifClause}}`,
};
const def = {
    keyword: "if",
    schemaType: ["object", "boolean"],
    trackErrors: true,
    error,
    code(cxt) {
        const { gen, parentSchema, it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) {
            (0, util_1.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        }
        const hasThen = hasSchema(it, "then");
        const hasElse = hasSchema(it, "else");
        if (!hasThen && !hasElse)
            return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({ ifClause });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        }
        else if (hasThen) {
            gen.if(schValid, validateClause("then"));
        }
        else {
            gen.if((0, codegen_1.not)(schValid), validateClause("else"));
        }
        cxt.pass(valid, () => cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false,
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return () => {
                const schCxt = cxt.subschema({ keyword }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause)
                    gen.assign(ifClause, (0, codegen_1._) `${keyword}`);
                else
                    cxt.setParams({ ifClause: keyword });
            };
        }
    },
};
function hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, util_1.alwaysValidSchema)(it, schema);
}
exports["default"] = def;
//# sourceMappingURL=if.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const additionalItems_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/additionalItems.js");
const prefixItems_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/prefixItems.js");
const items_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/items.js");
const items2020_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/items2020.js");
const contains_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/contains.js");
const dependencies_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/dependencies.js");
const propertyNames_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/propertyNames.js");
const additionalProperties_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/additionalProperties.js");
const properties_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/properties.js");
const patternProperties_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/patternProperties.js");
const not_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/not.js");
const anyOf_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/anyOf.js");
const oneOf_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/oneOf.js");
const allOf_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/allOf.js");
const if_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/if.js");
const thenElse_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/thenElse.js");
function getApplicator(draft2020 = false) {
    const applicator = [
        // any
        not_1.default,
        anyOf_1.default,
        oneOf_1.default,
        allOf_1.default,
        if_1.default,
        thenElse_1.default,
        // object
        propertyNames_1.default,
        additionalProperties_1.default,
        dependencies_1.default,
        properties_1.default,
        patternProperties_1.default,
    ];
    // array
    if (draft2020)
        applicator.push(prefixItems_1.default, items2020_1.default);
    else
        applicator.push(additionalItems_1.default, items_1.default);
    applicator.push(contains_1.default);
    return applicator;
}
exports["default"] = getApplicator;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/items.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateTuple = void 0;
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
const def = {
    keyword: "items",
    type: "array",
    schemaType: ["object", "array", "boolean"],
    before: "uniqueItems",
    code(cxt) {
        const { schema, it } = cxt;
        if (Array.isArray(schema))
            return validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, util_1.alwaysValidSchema)(it, schema))
            return;
        cxt.ok((0, code_1.validateArray)(cxt));
    },
};
function validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen, parentSchema, data, keyword, it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) {
        it.items = util_1.mergeEvaluated.items(gen, schArr.length, it.items);
    }
    const valid = gen.name("valid");
    const len = gen.const("len", (0, codegen_1._) `${data}.length`);
    schArr.forEach((sch, i) => {
        if ((0, util_1.alwaysValidSchema)(it, sch))
            return;
        gen.if((0, codegen_1._) `${len} > ${i}`, () => cxt.subschema({
            keyword,
            schemaProp: i,
            dataProp: i,
        }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts, errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, util_1.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
exports.validateTuple = validateTuple;
exports["default"] = def;
//# sourceMappingURL=items.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/items2020.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
const additionalItems_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/additionalItems.js");
const error = {
    message: ({ params: { len } }) => (0, codegen_1.str) `must NOT have more than ${len} items`,
    params: ({ params: { len } }) => (0, codegen_1._) `{limit: ${len}}`,
};
const def = {
    keyword: "items",
    type: "array",
    schemaType: ["object", "boolean"],
    before: "uniqueItems",
    error,
    code(cxt) {
        const { schema, parentSchema, it } = cxt;
        const { prefixItems } = parentSchema;
        it.items = true;
        if ((0, util_1.alwaysValidSchema)(it, schema))
            return;
        if (prefixItems)
            (0, additionalItems_1.validateAdditionalItems)(cxt, prefixItems);
        else
            cxt.ok((0, code_1.validateArray)(cxt));
    },
};
exports["default"] = def;
//# sourceMappingURL=items2020.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/not.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const def = {
    keyword: "not",
    schemaType: ["object", "boolean"],
    trackErrors: true,
    code(cxt) {
        const { gen, schema, it } = cxt;
        if ((0, util_1.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false,
        }, valid);
        cxt.failResult(valid, () => cxt.reset(), () => cxt.error());
    },
    error: { message: "must NOT be valid" },
};
exports["default"] = def;
//# sourceMappingURL=not.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/oneOf.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params }) => (0, codegen_1._) `{passingSchemas: ${params.passing}}`,
};
const def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error,
    code(cxt) {
        const { gen, schema, parentSchema, it } = cxt;
        /* istanbul ignore if */
        if (!Array.isArray(schema))
            throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator)
            return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({ passing });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, () => cxt.reset(), () => cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i) => {
                let schCxt;
                if ((0, util_1.alwaysValidSchema)(it, sch)) {
                    gen.var(schValid, true);
                }
                else {
                    schCxt = cxt.subschema({
                        keyword: "oneOf",
                        schemaProp: i,
                        compositeRule: true,
                    }, schValid);
                }
                if (i > 0) {
                    gen
                        .if((0, codegen_1._) `${schValid} && ${valid}`)
                        .assign(valid, false)
                        .assign(passing, (0, codegen_1._) `[${passing}, ${i}]`)
                        .else();
                }
                gen.if(schValid, () => {
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt)
                        cxt.mergeEvaluated(schCxt, codegen_1.Name);
                });
            });
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=oneOf.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/patternProperties.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const util_2 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code(cxt) {
        const { gen, schema, data, parentSchema, it } = cxt;
        const { opts } = it;
        const patterns = (0, code_1.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p) => (0, util_1.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 ||
            (alwaysValidPatterns.length === patterns.length &&
                (!it.opts.unevaluated || it.props === true))) {
            return;
        }
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof codegen_1.Name)) {
            it.props = (0, util_2.evaluatedPropsToName)(gen, it.props);
        }
        const { props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns) {
                if (checkProperties)
                    checkMatchingProperties(pat);
                if (it.allErrors) {
                    validateProperties(pat);
                }
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for (const prop in checkProperties) {
                if (new RegExp(pat).test(prop)) {
                    (0, util_1.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
                }
            }
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key) => {
                gen.if((0, codegen_1._) `${(0, code_1.usePattern)(cxt, pat)}.test(${key})`, () => {
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) {
                        cxt.subschema({
                            keyword: "patternProperties",
                            schemaProp: pat,
                            dataProp: key,
                            dataPropType: util_2.Type.Str,
                        }, valid);
                    }
                    if (it.opts.unevaluated && props !== true) {
                        gen.assign((0, codegen_1._) `${props}[${key}]`, true);
                    }
                    else if (!alwaysValid && !it.allErrors) {
                        // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                        // or if all properties were evaluated (props === true)
                        gen.if((0, codegen_1.not)(valid), () => gen.break());
                    }
                });
            });
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=patternProperties.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/prefixItems.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const items_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/items.js");
const def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: ["array"],
    before: "uniqueItems",
    code: (cxt) => (0, items_1.validateTuple)(cxt, "items"),
};
exports["default"] = def;
//# sourceMappingURL=prefixItems.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/properties.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const validate_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/index.js");
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const additionalProperties_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/additionalProperties.js");
const def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code(cxt) {
        const { gen, schema, parentSchema, data, it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) {
            additionalProperties_1.default.code(new validate_1.KeywordCxt(it, additionalProperties_1.default, "additionalProperties"));
        }
        const allProps = (0, code_1.allSchemaProperties)(schema);
        for (const prop of allProps) {
            it.definedProperties.add(prop);
        }
        if (it.opts.unevaluated && allProps.length && it.props !== true) {
            it.props = util_1.mergeEvaluated.props(gen, (0, util_1.toHash)(allProps), it.props);
        }
        const properties = allProps.filter((p) => !(0, util_1.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0)
            return;
        const valid = gen.name("valid");
        for (const prop of properties) {
            if (hasDefault(prop)) {
                applyPropertySchema(prop);
            }
            else {
                gen.if((0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors)
                    gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop,
            }, valid);
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=properties.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/propertyNames.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const error = {
    message: "property name must be valid",
    params: ({ params }) => (0, codegen_1._) `{propertyName: ${params.propertyName}}`,
};
const def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: ["object", "boolean"],
    error,
    code(cxt) {
        const { gen, schema, data, it } = cxt;
        if ((0, util_1.alwaysValidSchema)(it, schema))
            return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key) => {
            cxt.setParams({ propertyName: key });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: ["string"],
                propertyName: key,
                compositeRule: true,
            }, valid);
            gen.if((0, codegen_1.not)(valid), () => {
                cxt.error(true);
                if (!it.allErrors)
                    gen.break();
            });
        });
        cxt.ok(valid);
    },
};
exports["default"] = def;
//# sourceMappingURL=propertyNames.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/thenElse.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const def = {
    keyword: ["then", "else"],
    schemaType: ["object", "boolean"],
    code({ keyword, parentSchema, it }) {
        if (parentSchema.if === undefined)
            (0, util_1.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    },
};
exports["default"] = def;
//# sourceMappingURL=thenElse.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateUnion = exports.validateArray = exports.usePattern = exports.callValidateCode = exports.schemaProperties = exports.allSchemaProperties = exports.noPropertyInData = exports.propertyInData = exports.isOwnProperty = exports.hasPropFunc = exports.reportMissingProp = exports.checkMissingProp = exports.checkReportMissingProp = void 0;
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const names_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/names.js");
const util_2 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
function checkReportMissingProp(cxt, prop) {
    const { gen, data, it } = cxt;
    gen.if(noPropertyInData(gen, data, prop, it.opts.ownProperties), () => {
        cxt.setParams({ missingProperty: (0, codegen_1._) `${prop}` }, true);
        cxt.error();
    });
}
exports.checkReportMissingProp = checkReportMissingProp;
function checkMissingProp({ gen, data, it: { opts } }, properties, missing) {
    return (0, codegen_1.or)(...properties.map((prop) => (0, codegen_1.and)(noPropertyInData(gen, data, prop, opts.ownProperties), (0, codegen_1._) `${missing} = ${prop}`)));
}
exports.checkMissingProp = checkMissingProp;
function reportMissingProp(cxt, missing) {
    cxt.setParams({ missingProperty: missing }, true);
    cxt.error();
}
exports.reportMissingProp = reportMissingProp;
function hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, codegen_1._) `Object.prototype.hasOwnProperty`,
    });
}
exports.hasPropFunc = hasPropFunc;
function isOwnProperty(gen, data, property) {
    return (0, codegen_1._) `${hasPropFunc(gen)}.call(${data}, ${property})`;
}
exports.isOwnProperty = isOwnProperty;
function propertyInData(gen, data, property, ownProperties) {
    const cond = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, codegen_1._) `${cond} && ${isOwnProperty(gen, data, property)}` : cond;
}
exports.propertyInData = propertyInData;
function noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(property)} === undefined`;
    return ownProperties ? (0, codegen_1.or)(cond, (0, codegen_1.not)(isOwnProperty(gen, data, property))) : cond;
}
exports.noPropertyInData = noPropertyInData;
function allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p) => p !== "__proto__") : [];
}
exports.allSchemaProperties = allSchemaProperties;
function schemaProperties(it, schemaMap) {
    return allSchemaProperties(schemaMap).filter((p) => !(0, util_1.alwaysValidSchema)(it, schemaMap[p]));
}
exports.schemaProperties = schemaProperties;
function callValidateCode({ schemaCode, data, it: { gen, topSchemaRef, schemaPath, errorPath }, it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, codegen_1._) `${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [names_1.default.instancePath, (0, codegen_1.strConcat)(names_1.default.instancePath, errorPath)],
        [names_1.default.parentData, it.parentData],
        [names_1.default.parentDataProperty, it.parentDataProperty],
        [names_1.default.rootData, names_1.default.rootData],
    ];
    if (it.opts.dynamicRef)
        valCxt.push([names_1.default.dynamicAnchors, names_1.default.dynamicAnchors]);
    const args = (0, codegen_1._) `${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== codegen_1.nil ? (0, codegen_1._) `${func}.call(${context}, ${args})` : (0, codegen_1._) `${func}(${args})`;
}
exports.callValidateCode = callValidateCode;
const newRegExp = (0, codegen_1._) `new RegExp`;
function usePattern({ gen, it: { opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, codegen_1._) `${regExp.code === "new RegExp" ? newRegExp : (0, util_2.useFunc)(gen, regExp)}(${pattern}, ${u})`,
    });
}
exports.usePattern = usePattern;
function validateArray(cxt) {
    const { gen, data, keyword, it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(() => gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(() => gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, codegen_1._) `${data}.length`);
        gen.forRange("i", 0, len, (i) => {
            cxt.subschema({
                keyword,
                dataProp: i,
                dataPropType: util_1.Type.Num,
            }, valid);
            gen.if((0, codegen_1.not)(valid), notValid);
        });
    }
}
exports.validateArray = validateArray;
function validateUnion(cxt) {
    const { gen, schema, keyword, it } = cxt;
    /* istanbul ignore if */
    if (!Array.isArray(schema))
        throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch) => (0, util_1.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated)
        return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(() => schema.forEach((_sch, i) => {
        const schCxt = cxt.subschema({
            keyword,
            schemaProp: i,
            compositeRule: true,
        }, schValid);
        gen.assign(valid, (0, codegen_1._) `${valid} || ${schValid}`);
        const merged = cxt.mergeValidEvaluated(schCxt, schValid);
        // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
        // or if all properties and items were evaluated (it.props === true && it.items === true)
        if (!merged)
            gen.if((0, codegen_1.not)(valid));
    }));
    cxt.result(valid, () => cxt.reset(), () => cxt.error(true));
}
exports.validateUnion = validateUnion;
//# sourceMappingURL=code.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/core/id.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const def = {
    keyword: "id",
    code() {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    },
};
exports["default"] = def;
//# sourceMappingURL=id.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/core/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const id_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/core/id.js");
const ref_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/core/ref.js");
const core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    { keyword: "$comment" },
    "definitions",
    id_1.default,
    ref_1.default,
];
exports["default"] = core;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/core/ref.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.callRef = exports.getValidate = void 0;
const ref_error_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/ref_error.js");
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const names_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/names.js");
const compile_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const def = {
    keyword: "$ref",
    schemaType: "string",
    code(cxt) {
        const { gen, schema: $ref, it } = cxt;
        const { baseId, schemaEnv: env, validateName, opts, self } = it;
        const { root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId)
            return callRootRef();
        const schOrEnv = compile_1.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined)
            throw new ref_error_1.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof compile_1.SchemaEnv)
            return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root)
                return callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", { ref: root });
            return callRef(cxt, (0, codegen_1._) `${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = getValidate(cxt, sch);
            callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? { ref: sch, code: (0, codegen_1.stringify)(sch) } : { ref: sch });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: codegen_1.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref,
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    },
};
function getValidate(cxt, sch) {
    const { gen } = cxt;
    return sch.validate
        ? gen.scopeValue("validate", { ref: sch.validate })
        : (0, codegen_1._) `${gen.scopeValue("wrapper", { ref: sch })}.validate`;
}
exports.getValidate = getValidate;
function callRef(cxt, v, sch, $async) {
    const { gen, it } = cxt;
    const { allErrors, schemaEnv: env, opts } = it;
    const passCxt = opts.passContext ? names_1.default.this : codegen_1.nil;
    if ($async)
        callAsyncRef();
    else
        callSyncRef();
    function callAsyncRef() {
        if (!env.$async)
            throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(() => {
            gen.code((0, codegen_1._) `await ${(0, code_1.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors)
                gen.assign(valid, true);
        }, (e) => {
            gen.if((0, codegen_1._) `!(${e} instanceof ${it.ValidationError})`, () => gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors)
                gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, code_1.callValidateCode)(cxt, v, passCxt), () => addEvaluatedFrom(v), () => addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, codegen_1._) `${source}.errors`;
        gen.assign(names_1.default.vErrors, (0, codegen_1._) `${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign(names_1.default.errors, (0, codegen_1._) `${names_1.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated)
            return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) {
                    it.props = util_1.mergeEvaluated.props(gen, schEvaluated.props, it.props);
                }
            }
            else {
                const props = gen.var("props", (0, codegen_1._) `${source}.evaluated.props`);
                it.props = util_1.mergeEvaluated.props(gen, props, it.props, codegen_1.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) {
                    it.items = util_1.mergeEvaluated.items(gen, schEvaluated.items, it.items);
                }
            }
            else {
                const items = gen.var("items", (0, codegen_1._) `${source}.evaluated.items`);
                it.items = util_1.mergeEvaluated.items(gen, items, it.items, codegen_1.Name);
            }
        }
    }
}
exports.callRef = callRef;
exports["default"] = def;
//# sourceMappingURL=ref.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/discriminator/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const types_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/discriminator/types.js");
const compile_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const error = {
    message: ({ params: { discrError, tagName } }) => discrError === types_1.DiscrError.Tag
        ? `tag "${tagName}" must be string`
        : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError, tag, tagName } }) => (0, codegen_1._) `{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`,
};
const def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error,
    code(cxt) {
        const { gen, data, schema, parentSchema, it } = cxt;
        const { oneOf } = parentSchema;
        if (!it.opts.discriminator) {
            throw new Error("discriminator: requires discriminator option");
        }
        const tagName = schema.propertyName;
        if (typeof tagName != "string")
            throw new Error("discriminator: requires propertyName");
        if (schema.mapping)
            throw new Error("discriminator: mapping is not supported");
        if (!oneOf)
            throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(tagName)}`);
        gen.if((0, codegen_1._) `typeof ${tag} == "string"`, () => validateMapping(), () => cxt.error(false, { discrError: types_1.DiscrError.Tag, tag, tagName }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for (const tagValue in mapping) {
                gen.elseIf((0, codegen_1._) `${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, { discrError: types_1.DiscrError.Mapping, tag, tagName });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({ keyword: "oneOf", schemaProp }, _valid);
            cxt.mergeEvaluated(schCxt, codegen_1.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for (let i = 0; i < oneOf.length; i++) {
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, util_1.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    sch = compile_1.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, sch === null || sch === void 0 ? void 0 : sch.$ref);
                    if (sch instanceof compile_1.SchemaEnv)
                        sch = sch.schema;
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") {
                    throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                }
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired)
                throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) {
                    addMapping(sch.const, i);
                }
                else if (sch.enum) {
                    for (const tagValue of sch.enum) {
                        addMapping(tagValue, i);
                    }
                }
                else {
                    throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
                }
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) {
                    throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                }
                oneOfMapping[tagValue] = i;
            }
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/discriminator/types.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DiscrError = void 0;
var DiscrError;
(function (DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})(DiscrError = exports.DiscrError || (exports.DiscrError = {}));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/draft7.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const core_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/core/index.js");
const validation_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/index.js");
const applicator_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/applicator/index.js");
const format_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/format/index.js");
const metadata_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/metadata.js");
const draft7Vocabularies = [
    core_1.default,
    validation_1.default,
    (0, applicator_1.default)(),
    format_1.default,
    metadata_1.metadataVocabulary,
    metadata_1.contentVocabulary,
];
exports["default"] = draft7Vocabularies;
//# sourceMappingURL=draft7.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/format/format.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const error = {
    message: ({ schemaCode }) => (0, codegen_1.str) `must match format "${schemaCode}"`,
    params: ({ schemaCode }) => (0, codegen_1._) `{format: ${schemaCode}}`,
};
const def = {
    keyword: "format",
    type: ["number", "string"],
    schemaType: "string",
    $data: true,
    error,
    code(cxt, ruleType) {
        const { gen, data, $data, schema, schemaCode, it } = cxt;
        const { opts, errSchemaPath, schemaEnv, self } = it;
        if (!opts.validateFormats)
            return;
        if ($data)
            validate$DataFormat();
        else
            validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats,
            });
            const fDef = gen.const("fDef", (0, codegen_1._) `${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, codegen_1._) `typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, () => gen.assign(fType, (0, codegen_1._) `${fDef}.type || "string"`).assign(format, (0, codegen_1._) `${fDef}.validate`), () => gen.assign(fType, (0, codegen_1._) `"string"`).assign(format, fDef));
            cxt.fail$data((0, codegen_1.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false)
                    return codegen_1.nil;
                return (0, codegen_1._) `${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async
                    ? (0, codegen_1._) `(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))`
                    : (0, codegen_1._) `${format}(${data})`;
                const validData = (0, codegen_1._) `(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, codegen_1._) `${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true)
                return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType)
                cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp
                    ? (0, codegen_1.regexpCode)(fmtDef)
                    : opts.code.formats
                        ? (0, codegen_1._) `${opts.code.formats}${(0, codegen_1.getProperty)(schema)}`
                        : undefined;
                const fmt = gen.scopeValue("formats", { key: schema, ref: fmtDef, code });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) {
                    return [fmtDef.type || "string", fmtDef.validate, (0, codegen_1._) `${fmt}.validate`];
                }
                return ["string", fmtDef, fmt];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async)
                        throw new Error("async format in sync schema");
                    return (0, codegen_1._) `await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, codegen_1._) `${fmtRef}(${data})` : (0, codegen_1._) `${fmtRef}.test(${data})`;
            }
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=format.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/format/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const format_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/format/format.js");
const format = [format_1.default];
exports["default"] = format;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/metadata.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.contentVocabulary = exports.metadataVocabulary = void 0;
exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples",
];
exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema",
];
//# sourceMappingURL=metadata.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/const.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const equal_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/equal.js");
const error = {
    message: "must be equal to constant",
    params: ({ schemaCode }) => (0, codegen_1._) `{allowedValue: ${schemaCode}}`,
};
const def = {
    keyword: "const",
    $data: true,
    error,
    code(cxt) {
        const { gen, data, $data, schemaCode, schema } = cxt;
        if ($data || (schema && typeof schema == "object")) {
            cxt.fail$data((0, codegen_1._) `!${(0, util_1.useFunc)(gen, equal_1.default)}(${data}, ${schemaCode})`);
        }
        else {
            cxt.fail((0, codegen_1._) `${schema} !== ${data}`);
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=const.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/enum.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const equal_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/equal.js");
const error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode }) => (0, codegen_1._) `{allowedValues: ${schemaCode}}`,
};
const def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error,
    code(cxt) {
        const { gen, data, $data, schema, schemaCode, it } = cxt;
        if (!$data && schema.length === 0)
            throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = () => (eql !== null && eql !== void 0 ? eql : (eql = (0, util_1.useFunc)(gen, equal_1.default)));
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        }
        else {
            /* istanbul ignore if */
            if (!Array.isArray(schema))
                throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, codegen_1.or)(...schema.map((_x, i) => equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v) => gen.if((0, codegen_1._) `${getEql()}(${data}, ${v})`, () => gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null
                ? (0, codegen_1._) `${getEql()}(${data}, ${vSchema}[${i}])`
                : (0, codegen_1._) `${data} === ${sch}`;
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=enum.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const limitNumber_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/limitNumber.js");
const multipleOf_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/multipleOf.js");
const limitLength_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/limitLength.js");
const pattern_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/pattern.js");
const limitProperties_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/limitProperties.js");
const required_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/required.js");
const limitItems_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/limitItems.js");
const uniqueItems_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/uniqueItems.js");
const const_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/const.js");
const enum_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/enum.js");
const validation = [
    // number
    limitNumber_1.default,
    multipleOf_1.default,
    // string
    limitLength_1.default,
    pattern_1.default,
    // object
    limitProperties_1.default,
    required_1.default,
    // array
    limitItems_1.default,
    uniqueItems_1.default,
    // any
    { keyword: "type", schemaType: ["string", "array"] },
    { keyword: "nullable", schemaType: "boolean" },
    const_1.default,
    enum_1.default,
];
exports["default"] = validation;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/limitItems.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const error = {
    message({ keyword, schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, codegen_1.str) `must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode }) => (0, codegen_1._) `{limit: ${schemaCode}}`,
};
const def = {
    keyword: ["maxItems", "minItems"],
    type: "array",
    schemaType: "number",
    $data: true,
    error,
    code(cxt) {
        const { keyword, data, schemaCode } = cxt;
        const op = keyword === "maxItems" ? codegen_1.operators.GT : codegen_1.operators.LT;
        cxt.fail$data((0, codegen_1._) `${data}.length ${op} ${schemaCode}`);
    },
};
exports["default"] = def;
//# sourceMappingURL=limitItems.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/limitLength.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const ucs2length_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/ucs2length.js");
const error = {
    message({ keyword, schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, codegen_1.str) `must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode }) => (0, codegen_1._) `{limit: ${schemaCode}}`,
};
const def = {
    keyword: ["maxLength", "minLength"],
    type: "string",
    schemaType: "number",
    $data: true,
    error,
    code(cxt) {
        const { keyword, data, schemaCode, it } = cxt;
        const op = keyword === "maxLength" ? codegen_1.operators.GT : codegen_1.operators.LT;
        const len = it.opts.unicode === false ? (0, codegen_1._) `${data}.length` : (0, codegen_1._) `${(0, util_1.useFunc)(cxt.gen, ucs2length_1.default)}(${data})`;
        cxt.fail$data((0, codegen_1._) `${len} ${op} ${schemaCode}`);
    },
};
exports["default"] = def;
//# sourceMappingURL=limitLength.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/limitNumber.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const ops = codegen_1.operators;
const KWDs = {
    maximum: { okStr: "<=", ok: ops.LTE, fail: ops.GT },
    minimum: { okStr: ">=", ok: ops.GTE, fail: ops.LT },
    exclusiveMaximum: { okStr: "<", ok: ops.LT, fail: ops.GTE },
    exclusiveMinimum: { okStr: ">", ok: ops.GT, fail: ops.LTE },
};
const error = {
    message: ({ keyword, schemaCode }) => (0, codegen_1.str) `must be ${KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword, schemaCode }) => (0, codegen_1._) `{comparison: ${KWDs[keyword].okStr}, limit: ${schemaCode}}`,
};
const def = {
    keyword: Object.keys(KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error,
    code(cxt) {
        const { keyword, data, schemaCode } = cxt;
        cxt.fail$data((0, codegen_1._) `${data} ${KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    },
};
exports["default"] = def;
//# sourceMappingURL=limitNumber.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/limitProperties.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const error = {
    message({ keyword, schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, codegen_1.str) `must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode }) => (0, codegen_1._) `{limit: ${schemaCode}}`,
};
const def = {
    keyword: ["maxProperties", "minProperties"],
    type: "object",
    schemaType: "number",
    $data: true,
    error,
    code(cxt) {
        const { keyword, data, schemaCode } = cxt;
        const op = keyword === "maxProperties" ? codegen_1.operators.GT : codegen_1.operators.LT;
        cxt.fail$data((0, codegen_1._) `Object.keys(${data}).length ${op} ${schemaCode}`);
    },
};
exports["default"] = def;
//# sourceMappingURL=limitProperties.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/multipleOf.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const error = {
    message: ({ schemaCode }) => (0, codegen_1.str) `must be multiple of ${schemaCode}`,
    params: ({ schemaCode }) => (0, codegen_1._) `{multipleOf: ${schemaCode}}`,
};
const def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error,
    code(cxt) {
        const { gen, data, schemaCode, it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec
            ? (0, codegen_1._) `Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}`
            : (0, codegen_1._) `${res} !== parseInt(${res})`;
        cxt.fail$data((0, codegen_1._) `(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    },
};
exports["default"] = def;
//# sourceMappingURL=multipleOf.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/pattern.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const error = {
    message: ({ schemaCode }) => (0, codegen_1.str) `must match pattern "${schemaCode}"`,
    params: ({ schemaCode }) => (0, codegen_1._) `{pattern: ${schemaCode}}`,
};
const def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error,
    code(cxt) {
        const { data, $data, schema, schemaCode, it } = cxt;
        // TODO regexp should be wrapped in try/catchs
        const u = it.opts.unicodeRegExp ? "u" : "";
        const regExp = $data ? (0, codegen_1._) `(new RegExp(${schemaCode}, ${u}))` : (0, code_1.usePattern)(cxt, schema);
        cxt.fail$data((0, codegen_1._) `!${regExp}.test(${data})`);
    },
};
exports["default"] = def;
//# sourceMappingURL=pattern.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/required.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const code_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/code.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const error = {
    message: ({ params: { missingProperty } }) => (0, codegen_1.str) `must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty } }) => (0, codegen_1._) `{missingProperty: ${missingProperty}}`,
};
const def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error,
    code(cxt) {
        const { gen, schema, schemaCode, data, $data, it } = cxt;
        const { opts } = it;
        if (!$data && schema.length === 0)
            return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors)
            allErrorsMode();
        else
            exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties } = cxt.it;
            for (const requiredKey of schema) {
                if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                    const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                    (0, util_1.checkStrictMode)(it, msg, it.opts.strictRequired);
                }
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) {
                cxt.block$data(codegen_1.nil, loopAllRequired);
            }
            else {
                for (const prop of schema) {
                    (0, code_1.checkReportMissingProp)(cxt, prop);
                }
            }
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, () => loopUntilMissing(missing, valid));
                cxt.ok(valid);
            }
            else {
                gen.if((0, code_1.checkMissingProp)(cxt, schema, missing));
                (0, code_1.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop) => {
                cxt.setParams({ missingProperty: prop });
                gen.if((0, code_1.noPropertyInData)(gen, data, prop, opts.ownProperties), () => cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({ missingProperty: missing });
            gen.forOf(missing, schemaCode, () => {
                gen.assign(valid, (0, code_1.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, codegen_1.not)(valid), () => {
                    cxt.error();
                    gen.break();
                });
            }, codegen_1.nil);
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=required.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/vocabularies/validation/uniqueItems.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const dataType_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/validate/dataType.js");
const codegen_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/compile/util.js");
const equal_1 = __webpack_require__("../../node_modules/ajv-formats/node_modules/ajv/dist/runtime/equal.js");
const error = {
    message: ({ params: { i, j } }) => (0, codegen_1.str) `must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i, j } }) => (0, codegen_1._) `{i: ${i}, j: ${j}}`,
};
const def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error,
    code(cxt) {
        const { gen, data, $data, schema, parentSchema, schemaCode, it } = cxt;
        if (!$data && !schema)
            return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, dataType_1.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, codegen_1._) `${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, codegen_1._) `${data}.length`);
            const j = gen.let("j");
            cxt.setParams({ i, j });
            gen.assign(valid, true);
            gen.if((0, codegen_1._) `${i} > 1`, () => (canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t) => t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, dataType_1.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, dataType_1.DataType.Wrong);
            const indices = gen.const("indices", (0, codegen_1._) `{}`);
            gen.for((0, codegen_1._) `;${i}--;`, () => {
                gen.let(item, (0, codegen_1._) `${data}[${i}]`);
                gen.if(wrongType, (0, codegen_1._) `continue`);
                if (itemTypes.length > 1)
                    gen.if((0, codegen_1._) `typeof ${item} == "string"`, (0, codegen_1._) `${item} += "_"`);
                gen
                    .if((0, codegen_1._) `typeof ${indices}[${item}] == "number"`, () => {
                    gen.assign(j, (0, codegen_1._) `${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                })
                    .code((0, codegen_1._) `${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, util_1.useFunc)(gen, equal_1.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, codegen_1._) `;${i}--;`, () => gen.for((0, codegen_1._) `${j} = ${i}; ${j}--;`, () => gen.if((0, codegen_1._) `${eql}(${data}[${i}], ${data}[${j}])`, () => {
                cxt.error();
                gen.assign(valid, false).break(outer);
            })));
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=uniqueItems.js.map

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/json-schema-traverse/index.js":
/***/ ((module) => {

"use strict";


var traverse = module.exports = function (schema, opts, cb) {
  // Legacy support for v0.3.1 and earlier.
  if (typeof opts == 'function') {
    cb = opts;
    opts = {};
  }

  cb = opts.cb || cb;
  var pre = (typeof cb == 'function') ? cb : cb.pre || function() {};
  var post = cb.post || function() {};

  _traverse(opts, pre, post, schema, '', schema);
};


traverse.keywords = {
  additionalItems: true,
  items: true,
  contains: true,
  additionalProperties: true,
  propertyNames: true,
  not: true,
  if: true,
  then: true,
  else: true
};

traverse.arrayKeywords = {
  items: true,
  allOf: true,
  anyOf: true,
  oneOf: true
};

traverse.propsKeywords = {
  $defs: true,
  definitions: true,
  properties: true,
  patternProperties: true,
  dependencies: true
};

traverse.skipKeywords = {
  default: true,
  enum: true,
  const: true,
  required: true,
  maximum: true,
  minimum: true,
  exclusiveMaximum: true,
  exclusiveMinimum: true,
  multipleOf: true,
  maxLength: true,
  minLength: true,
  pattern: true,
  format: true,
  maxItems: true,
  minItems: true,
  uniqueItems: true,
  maxProperties: true,
  minProperties: true
};


function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
  if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
    pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    for (var key in schema) {
      var sch = schema[key];
      if (Array.isArray(sch)) {
        if (key in traverse.arrayKeywords) {
          for (var i=0; i<sch.length; i++)
            _traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
        }
      } else if (key in traverse.propsKeywords) {
        if (sch && typeof sch == 'object') {
          for (var prop in sch)
            _traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
        }
      } else if (key in traverse.keywords || (opts.allKeys && !(key in traverse.skipKeywords))) {
        _traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
      }
    }
    post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
  }
}


function escapeJsonPtr(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/api.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module is Application Programming Interface (API) for **APG** - the ABNF Parser Generator.
//
// *Note on teminology.*
// APG is a parser generator.
// However, it really only generates a "grammar object" (see below) from the defining SABNF grammar.
// The generated parser is incomplete at this stage.
// Remaining, it is the job of the user to develop the generated parser from the grammar object and the **APG** Library (**apg-lib**).
//
// The following terminology my help clear up any confusion between the idea of a "generated parser" versus a "generated grammar object".

// - The generating parser: **APG** is an **APG** parser (yes, there is a circular dependence between **apg-api** and **apg-lib**). We'll call it the generating parser.
// - The target parser: **APG**'s goal is to generate a parser. We'll call it the target parser.
// - The target grammar: this is the (ASCII) SABNF grammar defining the target parser.
// - The target grammar object: **APG** parses the SABNF grammar and generates the JavaScript source for a target grammar object constructor function
// and/or an actual grammar object.
// - The final target parser: The user then develops the final target parser using the generated target grammar
// object and the **APG** parsing library, **apg-lib**.
// Throws execeptions on fatal errors.
//
// src: the input SABNF grammar<br>
// may be one of:
// - Buffer of bytes
// - JavaScript string
// - Array of integer character codes
module.exports = function api(src) {
  const thisFileName = 'api.js: ';
  const thisObject = this;

  /* PRIVATE PROPERTIES */
  const apglib = __webpack_require__("../../node_modules/apg-js/src/apg-lib/node-exports.js");
  const converter = __webpack_require__("../../node_modules/apg-js/src/apg-conv-api/converter.js");
  const scanner = __webpack_require__("../../node_modules/apg-js/src/apg-api/scanner.js");
  const parser = new (__webpack_require__("../../node_modules/apg-js/src/apg-api/parser.js"))();
  const { attributes, showAttributes, showAttributeErrors, showRuleDependencies } = __webpack_require__("../../node_modules/apg-js/src/apg-api/attributes.js");
  const showRules = __webpack_require__("../../node_modules/apg-js/src/apg-api/show-rules.js");

  /* PRIVATE MEMBERS (FUNCTIONS) */
  /* Convert a phrase (array of character codes) to HTML. */
  const abnfToHtml = function abnfToHtml(chars, beg, len) {
    const NORMAL = 0;
    const CONTROL = 1;
    const INVALID = 2;
    const CONTROL_BEG = `<span class="${apglib.style.CLASS_CTRLCHAR}">`;
    const CONTROL_END = '</span>';
    const INVALID_BEG = `<span class="${apglib.style.CLASS_NOMATCH}">`;
    const INVALID_END = '</span>';
    let end;
    let html = '';
    const TRUE = true;
    while (TRUE) {
      if (!Array.isArray(chars) || chars.length === 0) {
        break;
      }
      if (typeof beg !== 'number') {
        throw new Error('abnfToHtml: beg must be type number');
      }
      if (beg >= chars.length) {
        break;
      }
      if (typeof len !== 'number' || beg + len >= chars.length) {
        end = chars.length;
      } else {
        end = beg + len;
      }
      let state = NORMAL;
      for (let i = beg; i < end; i += 1) {
        const ch = chars[i];
        if (ch >= 32 && ch <= 126) {
          /* normal - printable ASCII characters */
          if (state === CONTROL) {
            html += CONTROL_END;
            state = NORMAL;
          } else if (state === INVALID) {
            html += INVALID_END;
            state = NORMAL;
          }
          /* handle reserved HTML entity characters */
          switch (ch) {
            case 32:
              html += '&nbsp;';
              break;
            case 60:
              html += '&lt;';
              break;
            case 62:
              html += '&gt;';
              break;
            case 38:
              html += '&amp;';
              break;
            case 34:
              html += '&quot;';
              break;
            case 39:
              html += '&#039;';
              break;
            case 92:
              html += '&#092;';
              break;
            default:
              html += String.fromCharCode(ch);
              break;
          }
        } else if (ch === 9 || ch === 10 || ch === 13) {
          /* control characters */
          if (state === NORMAL) {
            html += CONTROL_BEG;
            state = CONTROL;
          } else if (state === INVALID) {
            html += INVALID_END + CONTROL_BEG;
            state = CONTROL;
          }
          if (ch === 9) {
            html += 'TAB';
          }
          if (ch === 10) {
            html += 'LF';
          }
          if (ch === 13) {
            html += 'CR';
          }
        } else {
          /* invalid characters */
          if (state === NORMAL) {
            html += INVALID_BEG;
            state = INVALID;
          } else if (state === CONTROL) {
            html += CONTROL_END + INVALID_BEG;
            state = INVALID;
          }
          /* display character as hexadecimal value */
          html += `\\x${apglib.utils.charToHex(ch)}`;
        }
      }
      if (state === INVALID) {
        html += INVALID_END;
      }
      if (state === CONTROL) {
        html += CONTROL_END;
      }
      break;
    }
    return html;
  };
  /* Convert a phrase (array of character codes) to ASCII text. */
  const abnfToAscii = function abnfToAscii(chars, beg, len) {
    let str = '';
    for (let i = beg; i < beg + len; i += 1) {
      const ch = chars[i];
      if (ch >= 32 && ch <= 126) {
        str += String.fromCharCode(ch);
      } else {
        switch (ch) {
          case 9:
            str += '\\t';
            break;
          case 10:
            str += '\\n';
            break;
          case 13:
            str += '\\r';
            break;
          default:
            str += '\\unknown';
            break;
        }
      }
    }
    return str;
  };
  /* translate lines (SABNF grammar) to ASCII text */
  const linesToAscii = function linesToAscii(lines) {
    let str = 'Annotated Input Grammar';
    lines.forEach((val) => {
      str += '\n';
      str += `line no: ${val.lineNo}`;
      str += ` : char index: ${val.beginChar}`;
      str += ` : length: ${val.length}`;
      str += ` : abnf: ${abnfToAscii(thisObject.chars, val.beginChar, val.length)}`;
    });
    str += '\n';
    return str;
  };
  /* translate lines (SABNF grammar) to HTML */
  const linesToHtml = function linesToHtml(lines) {
    let html = '';
    html += `<table class="${apglib.style.CLASS_GRAMMAR}">\n`;
    const title = 'Annotated Input Grammar';
    html += `<caption>${title}</caption>\n`;
    html += '<tr>';
    html += '<th>line<br>no.</th><th>first<br>char</th><th><br>length</th><th><br>text</th>';
    html += '</tr>\n';
    lines.forEach((val) => {
      html += '<tr>';
      html += `<td>${val.lineNo}`;
      html += `</td><td>${val.beginChar}`;
      html += `</td><td>${val.length}`;
      html += `</td><td>${abnfToHtml(thisObject.chars, val.beginChar, val.length)}`;
      html += '</td>';
      html += '</tr>\n';
    });

    html += '</table>\n';
    return html;
  };
  /* Format the error messages to HTML, for page display. */
  const errorsToHtml = function errorsToHtml(errors, lines, chars, title) {
    const [style] = apglib;
    let html = '';
    const errorArrow = `<span class="${style.CLASS_NOMATCH}">&raquo;</span>`;
    html += `<p><table class="${style.CLASS_GRAMMAR}">\n`;
    if (title && typeof title === 'string') {
      html += `<caption>${title}</caption>\n`;
    }
    html += '<tr><th>line<br>no.</th><th>line<br>offset</th><th>error<br>offset</th><th><br>text</th></tr>\n';
    errors.forEach((val) => {
      let line;
      let relchar;
      let beg;
      let end;
      let text;
      let prefix = '';
      let suffix = '';
      if (lines.length === 0) {
        text = errorArrow;
        relchar = 0;
      } else {
        line = lines[val.line];
        beg = line.beginChar;
        if (val.char > beg) {
          prefix = abnfToHtml(chars, beg, val.char - beg);
        }
        beg = val.char;
        end = line.beginChar + line.length;
        if (beg < end) {
          suffix = abnfToHtml(chars, beg, end - beg);
        }
        text = prefix + errorArrow + suffix;
        relchar = val.char - line.beginChar;
        html += '<tr>';
        html += `<td>${val.line}</td><td>${line.beginChar}</td><td>${relchar}</td><td>${text}</td>`;
        html += '</tr>\n';
        html += '<tr>';
        html += `<td colspan="3"></td><td>&uarr;:&nbsp;${apglib.utils.stringToAsciiHtml(val.msg)}</td>`;
        html += '</tr>\n';
      }
    });
    html += '</table></p>\n';
    return html;
  };
  /* Display an array of errors in ASCII text */
  const errorsToAscii = function errorsToAscii(errors, lines, chars) {
    let str;
    let line;
    let beg;
    let len;
    str = '';
    errors.forEach((error) => {
      line = lines[error.line];
      str += `${line.lineNo}: `;
      str += `${line.beginChar}: `;
      str += `${error.char - line.beginChar}: `;
      beg = line.beginChar;
      len = error.char - line.beginChar;
      str += abnfToAscii(chars, beg, len);
      str += ' >> ';
      beg = error.char;
      len = line.beginChar + line.length - error.char;
      str += abnfToAscii(chars, beg, len);
      str += '\n';
      str += `${line.lineNo}: `;
      str += `${line.beginChar}: `;
      str += `${error.char - line.beginChar}: `;
      str += 'error: ';
      str += error.msg;
      str += '\n';
    });
    return str;
  };
  let isScanned = false;
  let isParsed = false;
  let isTranslated = false;
  let haveAttributes = false;
  let attributeErrors = 0;
  let lineMap;

  /* PUBLIC PROPERTIES */
  // The input SABNF grammar as a JavaScript string.
  // this.sabnf;
  // The input SABNF grammar as an array of character codes.
  // this.chars;
  // An array of line objects, defining each line of the input SABNF grammar
  // - lineNo : the zero-based line number
  // - beginChar : offset (into `this.chars`) of the first character in the line
  // - length : the number of characters in the line
  // - textLength : the number of characters of text in the line, excluding the line ending characters
  // - endType : "CRLF", "LF", "CR" or "none" if the last line has no line ending characters
  // - invalidChars : `true` if the line contains invalid characters, `false` otherwise
  // this.lines;
  // An array of rule names and data.
  // - name : the rule name
  // - lower : the rule name in lower case
  // - index : the index of the rule (ordered by appearance in SABNF grammar)
  // - isBkr : `true` if this rule has been back referenced, `false` otherwise
  // - opcodes : array of opcodes for this rule
  // - attrs : the rule attributes
  // - ctrl : system data
  // this.rules;
  // An array of UDT names and data.
  // this.udts;
  // An array of errors, if any.
  // - line : the line number containing the error
  // - char : the character offset of the error
  // - msg : the error message
  this.errors = [];

  /* CONSTRUCTOR */
  if (Buffer.isBuffer(src)) {
    this.chars = converter.decode('BINARY', src);
  } else if (Array.isArray(src)) {
    this.chars = src.slice();
  } else if (typeof src === 'string') {
    this.chars = converter.decode('STRING', src);
  } else {
    throw new Error(`${thisFileName}input source is not a string, byte Buffer or character array`);
  }
  this.sabnf = converter.encode('STRING', this.chars);

  /* PUBLIC MEMBERS (FUNCTIONS) */
  // Scan the input SABNF grammar for invalid characters and catalog the lines via `this.lines`.
  // - strict : (optional) if `true`, all lines, including the last must end with CRLF (\r\n),
  // if `false` (in any JavaScript sense) then line endings may be any mix of CRLF, LF, CR, or end-of-file.
  // - trace (*) : (optional) a parser trace object, which will trace the parser that does the scan
  this.scan = function scan(strict, trace) {
    this.lines = scanner(this.chars, this.errors, strict, trace);
    isScanned = true;
  };
  // Parse the input SABNF grammar for correct syntax.
  // - strict : (optional) if `true`, the input grammar must be strict ABNF, conforming to [RFC 5234](https://tools.ietf.org/html/rfc5234)
  // and [RFC 7405](https://tools.ietf.org/html/rfc7405). No superset features allowed.
  // - trace (\*) : (optional) a parser trace object, which will trace the syntax parser
  //
  // <i>(*)NOTE: the trace option was used primarily during development.
  // Error detection and reporting is now fairly robust and tracing should be unnecessary. Use at your own peril.</i>
  this.parse = function parse(strict, trace) {
    if (!isScanned) {
      throw new Error(`${thisFileName}grammar not scanned`);
    }
    parser.syntax(this.chars, this.lines, this.errors, strict, trace);
    isParsed = true;
  };
  // Translate the SABNF grammar syntax into the opcodes that will guide the parser for this grammar.
  this.translate = function translate() {
    if (!isParsed) {
      throw new Error(`${thisFileName}grammar not scanned and parsed`);
    }
    const ret = parser.semantic(this.chars, this.lines, this.errors);
    if (this.errors.length === 0) {
      this.rules = ret.rules;
      this.udts = ret.udts;
      lineMap = ret.lineMap;
      isTranslated = true;
    }
  };
  // Compute the attributes of each rule.
  this.attributes = function attrs() {
    if (!isTranslated) {
      throw new Error(`${thisFileName}grammar not scanned, parsed and translated`);
    }
    attributeErrors = attributes(this.rules, this.udts, lineMap, this.errors);
    haveAttributes = true;
    return attributeErrors;
  };
  // This function will perform the full suite of steps required to generate a parser grammar object
  // from the input SABNF grammar.
  this.generate = function generate(strict) {
    this.lines = scanner(this.chars, this.errors, strict);
    if (this.errors.length) {
      return;
    }
    parser.syntax(this.chars, this.lines, this.errors, strict);
    if (this.errors.length) {
      return;
    }
    const ret = parser.semantic(this.chars, this.lines, this.errors);
    if (this.errors.length) {
      return;
    }
    this.rules = ret.rules;
    this.udts = ret.udts;
    lineMap = ret.lineMap;

    attributeErrors = attributes(this.rules, this.udts, lineMap, this.errors);
    haveAttributes = true;
  };
  // Display the rules.
  // Must scan, parse and translate before calling this function, otherwise there are no rules to display.
  // - order
  //      - "index" or "i", index order (default)
  //      - "alpha" or "a", alphabetical order
  //      - none of above, index order (default)
  this.displayRules = function displayRules(order = 'index') {
    if (!isTranslated) {
      throw new Error(`${thisFileName}grammar not scanned, parsed and translated`);
    }
    return showRules(this.rules, this.udts, order);
  };
  // Display the rule dependencies.
  // Must scan, parse, translate and compute attributes before calling this function.
  // Otherwise the rule dependencies are not known.
  // - order
  //      - "index" or "i", index order (default)
  //      - "alpha" or "a", alphabetical order
  //      - "type" or "t", ordered by type (alphabetical within each type/group)
  //      - none of above, index order (default)
  this.displayRuleDependencies = function displayRuleDependencies(order = 'index') {
    if (!haveAttributes) {
      throw new Error(`${thisFileName}no attributes - must be preceeded by call to attributes()`);
    }
    return showRuleDependencies(order);
  };
  // Display the attributes.
  // Must scan, parse, translate and compute attributes before calling this function.
  // - order
  //      - "index" or "i", index order (default)
  //      - "alpha" or "a", alphabetical order
  //      - "type" or "t", ordered by type (alphabetical within each type/group)
  //      - none of above, type order (default)
  this.displayAttributes = function displayAttributes(order = 'index') {
    if (!haveAttributes) {
      throw new Error(`${thisFileName}no attributes - must be preceeded by call to attributes()`);
    }
    if (attributeErrors) {
      showAttributeErrors(order);
    }
    return showAttributes(order);
  };
  this.displayAttributeErrors = function displayAttributeErrors() {
    if (!haveAttributes) {
      throw new Error(`${thisFileName}no attributes - must be preceeded by call to attributes()`);
    }
    return showAttributeErrors();
  };
  // Returns a parser grammar object constructor function as a JavaScript string.
  // This object can then be used to construct a parser.
  this.toSource = function toSource(name) {
    if (!haveAttributes) {
      throw new Error(`${thisFileName}can't generate parser source - must be preceeded by call to attributes()`);
    }
    if (attributeErrors) {
      throw new Error(`${thisFileName}can't generate parser source - attributes have ${attributeErrors} errors`);
    }
    return parser.generateSource(this.chars, this.lines, this.rules, this.udts, name);
  };
  // Returns a parser grammar object.
  // This grammar object may be used by the application to construct a parser.
  this.toObject = function toObject() {
    if (!haveAttributes) {
      throw new Error(`${thisFileName}can't generate parser source - must be preceeded by call to attributes()`);
    }
    if (attributeErrors) {
      throw new Error(`${thisFileName}can't generate parser source - attributes have ${attributeErrors} errors`);
    }
    return parser.generateObject(this.sabnf, this.rules, this.udts);
  };
  // Display errors in text format, suitable for `console.log()`.
  this.errorsToAscii = function errorsToAsciiFunc() {
    return errorsToAscii(this.errors, this.lines, this.chars);
  };
  // Display errors in HTML format, suitable for web page display.
  // (`apg-lib.css` required for proper styling)
  this.errorsToHtml = function errorsToHtmlFunc(title) {
    return errorsToHtml(this.errors, this.lines, this.chars, title);
  };
  // Generate an annotated the SABNF grammar display in text format.
  this.linesToAscii = function linesToAsciiFunc() {
    return linesToAscii(this.lines);
  };
  // Generate an annotated the SABNF grammar display in HTML format.
  // (`apg-lib.css` required for proper styling)
  this.linesToHtml = function linesToHtmlFunc() {
    return linesToHtml(this.lines);
  };
  // This function was only used by apg.html which has been abandoned.
  /*
    this.getAttributesObject = function () {
        return null;
    };
    */
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/attributes.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable class-methods-use-this */
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// Attributes Validation
//
// It is well known that recursive-descent parsers will fail if a rule is left recursive.
// Besides left recursion, there are a couple of other fatal attributes that need to be disclosed as well.
// There are several non-fatal attributes that are of interest also.
// This module will determine six different attributes listed here with simple examples.
//
// **fatal attributes**<br>
// left recursion<br>
// S = S "x" / "y"
//
// cyclic<br>
// S = S
//
// infinite<br>
// S = "y" S
//
// **non-fatal attributes** (but nice to know)<br>
// nested recursion<br>
// S = "a" S "b" / "y"
//
// right recursion<br>
// S = "x" S / "y"
//
// empty string<br>
// S = "x" S / ""
//
// Note that these are “aggregate” attributes, in that if the attribute is true it only means that it can be true,
// not that it will always be true for every input string.
// In the simple examples above the attributes may be obvious and definite – always true or false.
// However, for a large grammar with possibly hundreds of rules and parse tree branches,
// it can be obscure which branches lead to which attributes.
// Furthermore, different input strings will lead the parser down different branches.
// One input string may parse perfectly while another will hit a left-recursive branch and bottom out the call stack.
//
// It is for this reason that the APG parser generator computes these attributes.
// When using the API the attributes call is optional but generating a parser without checking the attributes - proceed at your own peril.
//
// Additionally, the attribute phase will identify rule dependencies and mutually-recursive groups. For example,
//
// S = "a" A "b" / "y"<br>
// A = "x"
//
// S is dependent on A but A is not dependent on S.
//
// S = "a" A "b" / "c"<br>
// A = "x" S "y" / "z"
//
// S and A are dependent on one another and are mutually recursive.
module.exports = (function exportAttributes() {
  const id = __webpack_require__("../../node_modules/apg-js/src/apg-lib/identifiers.js");
  const { ruleAttributes, showAttributes, showAttributeErrors } = __webpack_require__("../../node_modules/apg-js/src/apg-api/rule-attributes.js");
  const { ruleDependencies, showRuleDependencies } = __webpack_require__("../../node_modules/apg-js/src/apg-api/rule-dependencies.js");
  class State {
    constructor(rules, udts) {
      this.rules = rules;
      this.udts = udts;
      this.ruleCount = rules.length;
      this.udtCount = udts.length;
      this.startRule = 0;
      this.dependenciesComplete = false;
      this.attributesComplete = false;
      this.isMutuallyRecursive = false;
      this.ruleIndexes = this.indexArray(this.ruleCount);
      this.ruleAlphaIndexes = this.indexArray(this.ruleCount);
      this.ruleTypeIndexes = this.indexArray(this.ruleCount);
      this.udtIndexes = this.indexArray(this.udtCount);
      this.udtAlphaIndexes = this.indexArray(this.udtCount);
      this.attrsErrorCount = 0;
      this.attrs = [];
      this.attrsErrors = [];
      this.attrsWorking = [];
      this.ruleDeps = [];
      for (let i = 0; i < this.ruleCount; i += 1) {
        this.attrs.push(this.attrGen(this.rules[i]));
        this.attrsWorking.push(this.attrGen(this.rules[i]));
        this.ruleDeps.push(this.rdGen(rules[i], this.ruleCount, this.udtCount));
      }
      this.compRulesAlpha = this.compRulesAlpha.bind(this);
      this.compUdtsAlpha = this.compUdtsAlpha.bind(this);
      this.compRulesType = this.compRulesType.bind(this);
      this.compRulesGroup = this.compRulesGroup.bind(this);
    }

    // eslint-disable-next-line class-methods-use-this
    attrGen(rule) {
      return {
        left: false,
        nested: false,
        right: false,
        empty: false,
        finite: false,
        cyclic: false,
        leaf: false,
        isOpen: false,
        isComplete: false,
        rule,
      };
    }

    // eslint-disable-next-line class-methods-use-this
    attrInit(attr) {
      attr.left = false;
      attr.nested = false;
      attr.right = false;
      attr.empty = false;
      attr.finite = false;
      attr.cyclic = false;
      attr.leaf = false;
      attr.isOpen = false;
      attr.isComplete = false;
    }

    attrCopy(dst, src) {
      dst.left = src.left;
      dst.nested = src.nested;
      dst.right = src.right;
      dst.empty = src.empty;
      dst.finite = src.finite;
      dst.cyclic = src.cyclic;
      dst.leaf = src.leaf;
      dst.isOpen = src.isOpen;
      dst.isComplete = src.isComplete;
      dst.rule = src.rule;
    }

    rdGen(rule, ruleCount, udtCount) {
      const ret = {
        rule,
        recursiveType: id.ATTR_N,
        groupNumber: -1,
        refersTo: this.falseArray(ruleCount),
        refersToUdt: this.falseArray(udtCount),
        referencedBy: this.falseArray(ruleCount),
      };
      return ret;
    }

    typeToString(recursiveType) {
      switch (recursiveType) {
        case id.ATTR_N:
          return ' N';
        case id.ATTR_R:
          return ' R';
        case id.ATTR_MR:
          return 'MR';
        default:
          return 'UNKNOWN';
      }
    }

    falseArray(length) {
      const ret = [];
      if (length > 0) {
        for (let i = 0; i < length; i += 1) {
          ret.push(false);
        }
      }
      return ret;
    }

    falsifyArray(a) {
      for (let i = 0; i < a.length; i += 1) {
        a[i] = false;
      }
    }

    indexArray(length) {
      const ret = [];
      if (length > 0) {
        for (let i = 0; i < length; i += 1) {
          ret.push(i);
        }
      }
      return ret;
    }

    compRulesAlpha(left, right) {
      if (this.rules[left].lower < this.rules[right].lower) {
        return -1;
      }
      if (this.rules[left].lower > this.rules[right].lower) {
        return 1;
      }
      return 0;
    }

    compUdtsAlpha(left, right) {
      if (this.udts[left].lower < this.udts[right].lower) {
        return -1;
      }
      if (this.udts[left].lower > this.udts[right].lower) {
        return 1;
      }
      return 0;
    }

    compRulesType(left, right) {
      if (this.ruleDeps[left].recursiveType < this.ruleDeps[right].recursiveType) {
        return -1;
      }
      if (this.ruleDeps[left].recursiveType > this.ruleDeps[right].recursiveType) {
        return 1;
      }
      return 0;
    }

    compRulesGroup(left, right) {
      if (this.ruleDeps[left].recursiveType === id.ATTR_MR && this.ruleDeps[right].recursiveType === id.ATTR_MR) {
        if (this.ruleDeps[left].groupNumber < this.ruleDeps[right].groupNumber) {
          return -1;
        }
        if (this.ruleDeps[left].groupNumber > this.ruleDeps[right].groupNumber) {
          return 1;
        }
      }
      return 0;
    }
  }
  // eslint-disable-next-line no-unused-vars
  const attributes = function attributes(rules = [], udts = [], lineMap = [], errors = []) {
    // let i = 0;
    // Initialize the state. The state of the computation get passed around to multiple functions in multiple files.
    const state = new State(rules, udts);

    // Determine all rule dependencies
    //  - which rules each rule refers to
    //  - which rules reference each rule
    ruleDependencies(state);

    // Determine the attributes for each rule.
    ruleAttributes(state);
    if (state.attrsErrorCount) {
      errors.push({ line: 0, char: 0, msg: `${state.attrsErrorCount} attribute errors` });
    }

    // Return the number of attribute errors to the caller.
    return state.attrsErrorCount;
  };

  /* Destructuring assignment - see MDN Web Docs */
  return { attributes, showAttributes, showAttributeErrors, showRuleDependencies };
})();


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/parser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module converts an input SABNF grammar text file into a
// grammar object that can be used with `apg-lib` in an application parser.
// **apg** is, in fact itself, an ABNF parser that generates an SABNF parser.
// It is based on the grammar<br>
// `./dist/abnf-for-sabnf-grammar.bnf`.<br>
// In its syntax phase, **apg** analyzes the user's input SABNF grammar for correct syntax, generating an AST as it goes.
// In its semantic phase, **apg** translates the AST to generate the parser for the input grammar.
module.exports = function exportParser() {
  const thisFileName = 'parser: ';
  const ApgLib = __webpack_require__("../../node_modules/apg-js/src/apg-lib/node-exports.js");
  const id = ApgLib.ids;
  const syn = new (__webpack_require__("../../node_modules/apg-js/src/apg-api/syntax-callbacks.js"))();
  const sem = new (__webpack_require__("../../node_modules/apg-js/src/apg-api/semantic-callbacks.js"))();
  const sabnfGrammar = new (__webpack_require__("../../node_modules/apg-js/src/apg-api/sabnf-grammar.js"))();
  // eslint-disable-next-line new-cap
  const parser = new ApgLib.parser();
  // eslint-disable-next-line new-cap
  parser.ast = new ApgLib.ast();
  parser.callbacks = syn.callbacks;
  parser.ast.callbacks = sem.callbacks;

  /* find the line containing the given character index */
  const findLine = function findLine(lines, charIndex, charLength) {
    if (charIndex < 0 || charIndex >= charLength) {
      /* return error if out of range */
      return -1;
    }
    for (let i = 0; i < lines.length; i += 1) {
      if (charIndex >= lines[i].beginChar && charIndex < lines[i].beginChar + lines[i].length) {
        return i;
      }
    }
    /* should never reach here */
    return -1;
  };
  const translateIndex = function translateIndex(map, index) {
    let ret = -1;
    if (index < map.length) {
      for (let i = index; i < map.length; i += 1) {
        if (map[i] !== null) {
          ret = map[i];
          break;
        }
      }
    }
    return ret;
  };
  /* helper function when removing redundant opcodes */
  const reduceOpcodes = function reduceOpcodes(rules) {
    rules.forEach((rule) => {
      const opcodes = [];
      const map = [];
      let reducedIndex = 0;
      rule.opcodes.forEach((op) => {
        if (op.type === id.ALT && op.children.length === 1) {
          map.push(null);
        } else if (op.type === id.CAT && op.children.length === 1) {
          map.push(null);
        } else if (op.type === id.REP && op.min === 1 && op.max === 1) {
          map.push(null);
        } else {
          map.push(reducedIndex);
          opcodes.push(op);
          reducedIndex += 1;
        }
      });
      map.push(reducedIndex);
      /* translate original opcode indexes to the reduced set. */
      opcodes.forEach((op) => {
        if (op.type === id.ALT || op.type === id.CAT) {
          for (let i = 0; i < op.children.length; i += 1) {
            op.children[i] = translateIndex(map, op.children[i]);
          }
        }
      });
      rule.opcodes = opcodes;
    });
  };
  /* Parse the grammar - the syntax phase. */
  /* SABNF grammar syntax errors are caught and reported here. */
  this.syntax = function syntax(chars, lines, errors, strict, trace) {
    if (trace) {
      if (trace.traceObject !== 'traceObject') {
        throw new TypeError(`${thisFileName}trace argument is not a trace object`);
      }
      parser.trace = trace;
    }
    const data = {};
    data.errors = errors;
    data.strict = !!strict;
    data.lines = lines;
    data.findLine = findLine;
    data.charsLength = chars.length;
    data.ruleCount = 0;
    const result = parser.parse(sabnfGrammar, 'file', chars, data);
    if (!result.success) {
      errors.push({
        line: 0,
        char: 0,
        msg: 'syntax analysis of input grammar failed',
      });
    }
  };
  /* Parse the grammar - the semantic phase, translates the AST. */
  /* SABNF grammar syntax errors are caught and reported here. */
  this.semantic = function semantic(chars, lines, errors) {
    const data = {};
    data.errors = errors;
    data.lines = lines;
    data.findLine = findLine;
    data.charsLength = chars.length;
    parser.ast.translate(data);
    if (errors.length) {
      return null;
    }
    /* Remove unneeded operators. */
    /* ALT operators with a single alternate */
    /* CAT operators with a single phrase to concatenate */
    /* REP(1,1) operators (`1*1RuleName` or `1RuleName` is the same as just `RuleName`.) */
    reduceOpcodes(data.rules);
    return {
      rules: data.rules,
      udts: data.udts,
      lineMap: data.rulesLineMap,
    };
  };
  // Generate a grammar constructor function.
  // An object instantiated from this constructor is used with the `apg-lib` `parser()` function.
  this.generateSource = function generateSource(chars, lines, rules, udts, name) {
    let source = '';
    let i;
    let bkrname;
    let bkrlower;
    let opcodeCount = 0;
    let charCodeMin = Infinity;
    let charCodeMax = 0;
    const ruleNames = [];
    const udtNames = [];
    let alt = 0;
    let cat = 0;
    let rnm = 0;
    let udt = 0;
    let rep = 0;
    let and = 0;
    let not = 0;
    let tls = 0;
    let tbs = 0;
    let trg = 0;
    let bkr = 0;
    let bka = 0;
    let bkn = 0;
    let abg = 0;
    let aen = 0;
    rules.forEach((rule) => {
      ruleNames.push(rule.lower);
      opcodeCount += rule.opcodes.length;
      rule.opcodes.forEach((op) => {
        switch (op.type) {
          case id.ALT:
            alt += 1;
            break;
          case id.CAT:
            cat += 1;
            break;
          case id.RNM:
            rnm += 1;
            break;
          case id.UDT:
            udt += 1;
            break;
          case id.REP:
            rep += 1;
            break;
          case id.AND:
            and += 1;
            break;
          case id.NOT:
            not += 1;
            break;
          case id.BKA:
            bka += 1;
            break;
          case id.BKN:
            bkn += 1;
            break;
          case id.BKR:
            bkr += 1;
            break;
          case id.ABG:
            abg += 1;
            break;
          case id.AEN:
            aen += 1;
            break;
          case id.TLS:
            tls += 1;
            for (i = 0; i < op.string.length; i += 1) {
              if (op.string[i] < charCodeMin) {
                charCodeMin = op.string[i];
              }
              if (op.string[i] > charCodeMax) {
                charCodeMax = op.string[i];
              }
            }
            break;
          case id.TBS:
            tbs += 1;
            for (i = 0; i < op.string.length; i += 1) {
              if (op.string[i] < charCodeMin) {
                charCodeMin = op.string[i];
              }
              if (op.string[i] > charCodeMax) {
                charCodeMax = op.string[i];
              }
            }
            break;
          case id.TRG:
            trg += 1;
            if (op.min < charCodeMin) {
              charCodeMin = op.min;
            }
            if (op.max > charCodeMax) {
              charCodeMax = op.max;
            }
            break;
          default:
            throw new Error('generateSource: unrecognized opcode');
        }
      });
    });
    ruleNames.sort();
    if (udts.length > 0) {
      udts.forEach((udtFunc) => {
        udtNames.push(udtFunc.lower);
      });
      udtNames.sort();
    }
    let funcname = 'module.exports';
    if (name && typeof name === 'string') {
      funcname = `let ${name}`;
    }
    source += '// copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved<br>\n';
    source += '//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>\n';
    source += '//\n';
    source += '// Generated by apg-js, Version 4.0.0 [apg-js](https://github.com/ldthomas/apg-js)\n';
    source += `${funcname} = function grammar(){\n`;
    source += '  // ```\n';
    source += '  // SUMMARY\n';
    source += `  //      rules = ${rules.length}\n`;
    source += `  //       udts = ${udts.length}\n`;
    source += `  //    opcodes = ${opcodeCount}\n`;
    source += '  //        ---   ABNF original opcodes\n';
    source += `  //        ALT = ${alt}\n`;
    source += `  //        CAT = ${cat}\n`;
    source += `  //        REP = ${rep}\n`;
    source += `  //        RNM = ${rnm}\n`;
    source += `  //        TLS = ${tls}\n`;
    source += `  //        TBS = ${tbs}\n`;
    source += `  //        TRG = ${trg}\n`;
    source += '  //        ---   SABNF superset opcodes\n';
    source += `  //        UDT = ${udt}\n`;
    source += `  //        AND = ${and}\n`;
    source += `  //        NOT = ${not}\n`;
    source += `  //        BKA = ${bka}\n`;
    source += `  //        BKN = ${bkn}\n`;
    source += `  //        BKR = ${bkr}\n`;
    source += `  //        ABG = ${abg}\n`;
    source += `  //        AEN = ${aen}\n`;
    source += '  // characters = [';
    if (tls + tbs + trg === 0) {
      source += ' none defined ]';
    } else {
      source += `${charCodeMin} - ${charCodeMax}]`;
    }
    if (udt > 0) {
      source += ' + user defined';
    }
    source += '\n';
    source += '  // ```\n';
    source += '  /* OBJECT IDENTIFIER (for internal parser use) */\n';
    source += "  this.grammarObject = 'grammarObject';\n";
    source += '\n';
    source += '  /* RULES */\n';
    source += '  this.rules = [];\n';
    rules.forEach((rule, ii) => {
      let thisRule = '  this.rules[';
      thisRule += ii;
      thisRule += "] = {name: '";
      thisRule += rule.name;
      thisRule += "', lower: '";
      thisRule += rule.lower;
      thisRule += "', index: ";
      thisRule += rule.index;
      thisRule += ', isBkr: ';
      thisRule += rule.isBkr;
      thisRule += '};\n';
      source += thisRule;
    });
    source += '\n';
    source += '  /* UDTS */\n';
    source += '  this.udts = [];\n';
    if (udts.length > 0) {
      udts.forEach((udtFunc, ii) => {
        let thisUdt = '  this.udts[';
        thisUdt += ii;
        thisUdt += "] = {name: '";
        thisUdt += udtFunc.name;
        thisUdt += "', lower: '";
        thisUdt += udtFunc.lower;
        thisUdt += "', index: ";
        thisUdt += udtFunc.index;
        thisUdt += ', empty: ';
        thisUdt += udtFunc.empty;
        thisUdt += ', isBkr: ';
        thisUdt += udtFunc.isBkr;
        thisUdt += '};\n';
        source += thisUdt;
      });
    }
    source += '\n';
    source += '  /* OPCODES */\n';
    rules.forEach((rule, ruleIndex) => {
      if (ruleIndex > 0) {
        source += '\n';
      }
      source += `  /* ${rule.name} */\n`;
      source += `  this.rules[${ruleIndex}].opcodes = [];\n`;
      rule.opcodes.forEach((op, opIndex) => {
        let prefix;
        switch (op.type) {
          case id.ALT:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${
              op.type
            }, children: [${op.children.toString()}]};// ALT\n`;
            break;
          case id.CAT:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${
              op.type
            }, children: [${op.children.toString()}]};// CAT\n`;
            break;
          case id.RNM:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}, index: ${op.index}};// RNM(${
              rules[op.index].name
            })\n`;
            break;
          case id.BKR:
            if (op.index >= rules.length) {
              bkrname = udts[op.index - rules.length].name;
              bkrlower = udts[op.index - rules.length].lower;
            } else {
              bkrname = rules[op.index].name;
              bkrlower = rules[op.index].lower;
            }
            prefix = '%i';
            if (op.bkrCase === id.BKR_MODE_CS) {
              prefix = '%s';
            }
            if (op.bkrMode === id.BKR_MODE_UM) {
              prefix += '%u';
            } else {
              prefix += '%p';
            }
            bkrname = prefix + bkrname;
            source +=
              `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}, index: ${op.index}, lower: '${bkrlower}'` +
              `, bkrCase: ${op.bkrCase}, bkrMode: ${op.bkrMode}};// BKR(\\${bkrname})\n`;
            break;
          case id.UDT:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}, empty: ${op.empty}, index: ${
              op.index
            }};// UDT(${udts[op.index].name})\n`;
            break;
          case id.REP:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}, min: ${op.min}, max: ${op.max}};// REP\n`;
            break;
          case id.AND:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}};// AND\n`;
            break;
          case id.NOT:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}};// NOT\n`;
            break;
          case id.ABG:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}};// ABG(%^)\n`;
            break;
          case id.AEN:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}};// AEN(%$)\n`;
            break;
          case id.BKA:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}};// BKA\n`;
            break;
          case id.BKN:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}};// BKN\n`;
            break;
          case id.TLS:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${
              op.type
            }, string: [${op.string.toString()}]};// TLS\n`;
            break;
          case id.TBS:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${
              op.type
            }, string: [${op.string.toString()}]};// TBS\n`;
            break;
          case id.TRG:
            source += `  this.rules[${ruleIndex}].opcodes[${opIndex}] = {type: ${op.type}, min: ${op.min}, max: ${op.max}};// TRG\n`;
            break;
          default:
            throw new Error('parser.js: ~143: unrecognized opcode');
        }
      });
    });
    source += '\n';
    source += '  // The `toString()` function will display the original grammar file(s) that produced these opcodes.\n';
    source += '  this.toString = function toString(){\n';
    source += '    let str = "";\n';
    let str;
    lines.forEach((line) => {
      const end = line.beginChar + line.length;
      str = '';
      source += '    str += "';
      for (let ii = line.beginChar; ii < end; ii += 1) {
        switch (chars[ii]) {
          case 9:
            str = ' ';
            break;
          case 10:
            str = '\\n';
            break;
          case 13:
            str = '\\r';
            break;
          case 34:
            str = '\\"';
            break;
          case 92:
            str = '\\\\';
            break;
          default:
            str = String.fromCharCode(chars[ii]);
            break;
        }
        source += str;
      }
      source += '";\n';
    });
    source += '    return str;\n';
    source += '  }\n';
    source += '}\n';
    return source;
  };
  // Generate a grammar file object.
  // Returns the same object as instantiating the constructor function returned by<br>
  // `this.generateSource()`.<br>
  this.generateObject = function generateObject(stringArg, rules, udts) {
    const obj = {};
    const ruleNames = [];
    const udtNames = [];
    const string = stringArg.slice(0);
    obj.grammarObject = 'grammarObject';
    rules.forEach((rule) => {
      ruleNames.push(rule.lower);
    });
    ruleNames.sort();
    if (udts.length > 0) {
      udts.forEach((udtFunc) => {
        udtNames.push(udtFunc.lower);
      });
      udtNames.sort();
    }
    obj.callbacks = [];
    ruleNames.forEach((name) => {
      obj.callbacks[name] = false;
    });
    if (udts.length > 0) {
      udtNames.forEach((name) => {
        obj.callbacks[name] = false;
      });
    }
    obj.rules = rules;
    obj.udts = udts;
    obj.toString = function toStringFunc() {
      return string;
    };
    return obj;
  };
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/rule-attributes.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module does the heavy lifting for attribute generation.
module.exports = (function exportRuleAttributes() {
  const id = __webpack_require__("../../node_modules/apg-js/src/apg-lib/identifiers.js");
  const thisFile = 'rule-attributes.js';
  let state = null;
  function isEmptyOnly(attr) {
    if (attr.left || attr.nested || attr.right || attr.cyclic) {
      return false;
    }
    return attr.empty;
  }
  function isRecursive(attr) {
    if (attr.left || attr.nested || attr.right || attr.cyclic) {
      return true;
    }
    return false;
  }
  function isCatNested(attrs, count) {
    let i = 0;
    let j = 0;
    let k = 0;
    /* 1. if any child is nested, CAT is nested */
    for (i = 0; i < count; i += 1) {
      if (attrs[i].nested) {
        return true;
      }
    }
    /* 2.) the left-most right recursive child
               is followed by at least one non-empty child */
    for (i = 0; i < count; i += 1) {
      if (attrs[i].right && !attrs[i].leaf) {
        for (j = i + 1; j < count; j += 1) {
          if (!isEmptyOnly(attrs[j])) {
            return true;
          }
        }
      }
    }
    /* 3.) the right-most left recursive child
               is preceded by at least one non-empty child */
    for (i = count - 1; i >= 0; i -= 1) {
      if (attrs[i].left && !attrs[i].leaf) {
        for (j = i - 1; j >= 0; j -= 1) {
          if (!isEmptyOnly(attrs[j])) {
            return true;
          }
        }
      }
    }
    /* 4. there is at lease one recursive child between
              the left-most and right-most non-recursive, non-empty children */
    for (i = 0; i < count; i += 1) {
      if (!attrs[i].empty && !isRecursive(attrs[i])) {
        for (j = i + 1; j < count; j += 1) {
          if (isRecursive(attrs[j])) {
            for (k = j + 1; k < count; k += 1) {
              if (!attrs[k].empty && !isRecursive(attrs[k])) {
                return true;
              }
            }
          }
        }
      }
    }

    /* none of the above */
    return false;
  }
  function isCatCyclic(attrs, count) {
    /* if all children are cyclic, CAT is cyclic */
    for (let i = 0; i < count; i += 1) {
      if (!attrs[i].cyclic) {
        return false;
      }
    }
    return true;
  }
  function isCatLeft(attrs, count) {
    /* if the left-most non-empty is left, CAT is left */
    for (let i = 0; i < count; i += 1) {
      if (attrs[i].left) {
        return true;
      }
      if (!attrs[i].empty) {
        return false;
      }
      /* keep looking */
    }
    return false; /* all left-most are empty */
  }
  function isCatRight(attrs, count) {
    /* if the right-most non-empty is right, CAT is right */
    for (let i = count - 1; i >= 0; i -= 1) {
      if (attrs[i].right) {
        return true;
      }
      if (!attrs[i].empty) {
        return false;
      }
      /* keep looking */
    }
    return false;
  }
  function isCatEmpty(attrs, count) {
    /* if all children are empty, CAT is empty */
    for (let i = 0; i < count; i += 1) {
      if (!attrs[i].empty) {
        return false;
      }
    }
    return true;
  }
  function isCatFinite(attrs, count) {
    /* if all children are finite, CAT is finite */
    for (let i = 0; i < count; i += 1) {
      if (!attrs[i].finite) {
        return false;
      }
    }
    return true;
  }
  function cat(stateArg, opcodes, opIndex, iAttr) {
    let i = 0;
    const opCat = opcodes[opIndex];
    const count = opCat.children.length;

    /* generate an empty array of child attributes */
    const childAttrs = [];
    for (i = 0; i < count; i += 1) {
      childAttrs.push(stateArg.attrGen());
    }
    for (i = 0; i < count; i += 1) {
      // eslint-disable-next-line no-use-before-define
      opEval(stateArg, opcodes, opCat.children[i], childAttrs[i]);
    }
    iAttr.left = isCatLeft(childAttrs, count);
    iAttr.right = isCatRight(childAttrs, count);
    iAttr.nested = isCatNested(childAttrs, count);
    iAttr.empty = isCatEmpty(childAttrs, count);
    iAttr.finite = isCatFinite(childAttrs, count);
    iAttr.cyclic = isCatCyclic(childAttrs, count);
  }
  function alt(stateArg, opcodes, opIndex, iAttr) {
    let i = 0;
    const opAlt = opcodes[opIndex];
    const count = opAlt.children.length;

    /* generate an empty array of child attributes */
    const childAttrs = [];
    for (i = 0; i < count; i += 1) {
      childAttrs.push(stateArg.attrGen());
    }
    for (i = 0; i < count; i += 1) {
      // eslint-disable-next-line no-use-before-define
      opEval(stateArg, opcodes, opAlt.children[i], childAttrs[i]);
    }

    /* if any child attribute is true, ALT is true */
    iAttr.left = false;
    iAttr.right = false;
    iAttr.nested = false;
    iAttr.empty = false;
    iAttr.finite = false;
    iAttr.cyclic = false;
    for (i = 0; i < count; i += 1) {
      if (childAttrs[i].left) {
        iAttr.left = true;
      }
      if (childAttrs[i].nested) {
        iAttr.nested = true;
      }
      if (childAttrs[i].right) {
        iAttr.right = true;
      }
      if (childAttrs[i].empty) {
        iAttr.empty = true;
      }
      if (childAttrs[i].finite) {
        iAttr.finite = true;
      }
      if (childAttrs[i].cyclic) {
        iAttr.cyclic = true;
      }
    }
  }
  function bkr(stateArg, opcodes, opIndex, iAttr) {
    const opBkr = opcodes[opIndex];
    if (opBkr.index >= stateArg.ruleCount) {
      /* use UDT values */
      iAttr.empty = stateArg.udts[opBkr.index - stateArg.ruleCount].empty;
      iAttr.finite = true;
    } else {
      /* use the empty and finite values from the back referenced rule */
      // eslint-disable-next-line no-use-before-define
      ruleAttrsEval(stateArg, opBkr.index, iAttr);

      /* however, this is a terminal node like TLS */
      iAttr.left = false;
      iAttr.nested = false;
      iAttr.right = false;
      iAttr.cyclic = false;
    }
  }

  function opEval(stateArg, opcodes, opIndex, iAttr) {
    stateArg.attrInit(iAttr);
    const opi = opcodes[opIndex];
    switch (opi.type) {
      case id.ALT:
        alt(stateArg, opcodes, opIndex, iAttr);
        break;
      case id.CAT:
        cat(stateArg, opcodes, opIndex, iAttr);
        break;
      case id.REP:
        opEval(stateArg, opcodes, opIndex + 1, iAttr);
        if (opi.min === 0) {
          iAttr.empty = true;
          iAttr.finite = true;
        }
        break;
      case id.RNM:
        // eslint-disable-next-line no-use-before-define
        ruleAttrsEval(stateArg, opcodes[opIndex].index, iAttr);
        break;
      case id.BKR:
        bkr(stateArg, opcodes, opIndex, iAttr);
        break;
      case id.AND:
      case id.NOT:
      case id.BKA:
      case id.BKN:
        opEval(stateArg, opcodes, opIndex + 1, iAttr);
        iAttr.empty = true;
        break;
      case id.TLS:
        iAttr.empty = !opcodes[opIndex].string.length;
        iAttr.finite = true;
        iAttr.cyclic = false;
        break;
      case id.TBS:
      case id.TRG:
        iAttr.empty = false;
        iAttr.finite = true;
        iAttr.cyclic = false;
        break;
      case id.UDT:
        iAttr.empty = opi.empty;
        iAttr.finite = true;
        iAttr.cyclic = false;
        break;
      case id.ABG:
      case id.AEN:
        iAttr.empty = true;
        iAttr.finite = true;
        iAttr.cyclic = false;
        break;
      default:
        throw new Error(`unknown opcode type: ${opi}`);
    }
  }
  // The main logic for handling rules that:
  //  - have already be evaluated
  //  - have not been evaluated and is the first occurrence on this branch
  //  - second occurrence on this branch for the start rule
  //  - second occurrence on this branch for non-start rules
  function ruleAttrsEval(stateArg, ruleIndex, iAttr) {
    const attri = stateArg.attrsWorking[ruleIndex];
    if (attri.isComplete) {
      /* just use the completed values */
      stateArg.attrCopy(iAttr, attri);
    } else if (!attri.isOpen) {
      /* open the rule and traverse it */
      attri.isOpen = true;
      opEval(stateArg, attri.rule.opcodes, 0, iAttr);
      /* complete this rule's attributes */
      attri.left = iAttr.left;
      attri.right = iAttr.right;
      attri.nested = iAttr.nested;
      attri.empty = iAttr.empty;
      attri.finite = iAttr.finite;
      attri.cyclic = iAttr.cyclic;
      attri.leaf = false;
      attri.isOpen = false;
      attri.isComplete = true;
    } else if (ruleIndex === stateArg.startRule) {
      /* use recursive leaf values */
      if (ruleIndex === stateArg.startRule) {
        iAttr.left = true;
        iAttr.right = true;
        iAttr.cyclic = true;
        iAttr.leaf = true;
      }
    } else {
      /* non-start rule terminal leaf */
      iAttr.finite = true;
    }
  }
  // The main driver for the attribute generation.
  const ruleAttributes = (stateArg) => {
    state = stateArg;
    let i = 0;
    let j = 0;
    const iAttr = state.attrGen();
    for (i = 0; i < state.ruleCount; i += 1) {
      /* initialize working attributes */
      for (j = 0; j < state.ruleCount; j += 1) {
        state.attrInit(state.attrsWorking[j]);
      }
      state.startRule = i;
      ruleAttrsEval(state, i, iAttr);

      /* save off the working attributes for this rule */
      state.attrCopy(state.attrs[i], state.attrsWorking[i]);
    }
    state.attributesComplete = true;
    let attri = null;
    for (i = 0; i < state.ruleCount; i += 1) {
      attri = state.attrs[i];
      if (attri.left || !attri.finite || attri.cyclic) {
        const temp = state.attrGen(attri.rule);
        state.attrCopy(temp, attri);
        state.attrsErrors.push(temp);
        state.attrsErrorCount += 1;
      }
    }
  };
  const truth = (val) => (val ? 't' : 'f');
  const tError = (val) => (val ? 'e' : 'f');
  const fError = (val) => (val ? 't' : 'e');
  const showAttr = (seq, index, attr, dep) => {
    let str = `${seq}:${index}:`;
    str += `${tError(attr.left)} `;
    str += `${truth(attr.nested)} `;
    str += `${truth(attr.right)} `;
    str += `${tError(attr.cyclic)} `;
    str += `${fError(attr.finite)} `;
    str += `${truth(attr.empty)}:`;
    str += `${state.typeToString(dep.recursiveType)}:`;
    str += dep.recursiveType === id.ATTR_MR ? dep.groupNumber : '-';
    str += `:${attr.rule.name}\n`;
    return str;
  };

  const showLegend = () => {
    let str = 'LEGEND - t=true, f=false, e=error\n';
    str += 'sequence:rule index:left nested right cyclic finite empty:type:group number:rule name\n';
    return str;
  };
  const showAttributeErrors = () => {
    let attri = null;
    let depi = null;
    let str = '';
    str += 'RULE ATTRIBUTES WITH ERRORS\n';
    str += showLegend();
    if (state.attrsErrorCount) {
      for (let i = 0; i < state.attrsErrorCount; i += 1) {
        attri = state.attrsErrors[i];
        depi = state.ruleDeps[attri.rule.index];
        str += showAttr(i, attri.rule.index, attri, depi);
      }
    } else {
      str += '<none>\n';
    }
    return str;
  };

  const show = (type) => {
    let i = 0;
    let ii = 0;
    let attri = null;
    let depi = null;
    let str = '';
    let { ruleIndexes } = state;
    // let udtIndexes = state.udtIndexes;
    if (type === 97) {
      ruleIndexes = state.ruleAlphaIndexes;
      // udtIndexes = state.udtAlphaIndexes;
    } else if (type === 116) {
      ruleIndexes = state.ruleTypeIndexes;
      // udtIndexes = state.udtAlphaIndexes;
    }
    /* show all attributes */
    for (i = 0; i < state.ruleCount; i += 1) {
      ii = ruleIndexes[i];
      attri = state.attrs[ii];
      depi = state.ruleDeps[ii];
      str += showAttr(i, ii, attri, depi);
    }
    return str;
  };

  // Display the rule attributes.
  // - order
  //      - "index" or "i", index order (default)
  //      - "alpha" or "a", alphabetical order
  //      - "type" or "t", ordered by type (alphabetical within each type/group)
  //      - none of above, index order (default)
  const showAttributes = (order = 'index') => {
    if (!state.attributesComplete) {
      throw new Error(`${thisFile}:showAttributes: attributes not available`);
    }
    let str = '';
    const leader = 'RULE ATTRIBUTES\n';
    if (order.charCodeAt(0) === 97) {
      str += 'alphabetical by rule name\n';
      str += leader;
      str += showLegend();
      str += show(97);
    } else if (order.charCodeAt(0) === 116) {
      str += 'ordered by rule type\n';
      str += leader;
      str += showLegend();
      str += show(116);
    } else {
      str += 'ordered by rule index\n';
      str += leader;
      str += showLegend();
      str += show();
    }
    return str;
  };

  /* Destructuring assignment - see MDN Web Docs */
  return { ruleAttributes, showAttributes, showAttributeErrors };
})();


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/rule-dependencies.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// Determine rule dependencies and types.
// For each rule, determine which other rules it refers to
// and which of the other rules refer back to it.
//
// Rule types are:
//  - non-recursive - the rule never refers to itself, even indirectly
//  - recursive - the rule refers to itself, possibly indirectly
//  - mutually-recursive - belongs to a group of two or more rules, each of which refers to every other rule in the group, including itself.
module.exports = (() => {
  const id = __webpack_require__("../../node_modules/apg-js/src/apg-lib/identifiers.js");
  let state = null; /* keep a global reference to the state for the show functions */

  /* scan the opcodes of the indexed rule and discover which rules it references and which rule refer back to it */
  const scan = (ruleCount, ruleDeps, index, isScanned) => {
    let i = 0;
    let j = 0;
    const rdi = ruleDeps[index];
    isScanned[index] = true;
    const op = rdi.rule.opcodes;
    for (i = 0; i < op.length; i += 1) {
      const opi = op[i];
      if (opi.type === id.RNM) {
        rdi.refersTo[opi.index] = true;
        if (!isScanned[opi.index]) {
          scan(ruleCount, ruleDeps, opi.index, isScanned);
        }
        for (j = 0; j < ruleCount; j += 1) {
          if (ruleDeps[opi.index].refersTo[j]) {
            rdi.refersTo[j] = true;
          }
        }
      } else if (opi.type === id.UDT) {
        rdi.refersToUdt[opi.index] = true;
      } else if (opi.type === id.BKR) {
        if (opi.index < ruleCount) {
          rdi.refersTo[opi.index] = true;
          if (!isScanned[opi.index]) {
            scan(ruleCount, ruleDeps, opi.index, isScanned);
          }
        } else {
          rdi.refersToUdt[ruleCount - opi.index] = true;
        }
      }
    }
  };
  // Determine the rule dependencies, types and mutually recursive groups.
  const ruleDependencies = (stateArg) => {
    state = stateArg; /* make it global */
    let i = 0;
    let j = 0;
    let groupCount = 0;
    let rdi = null;
    let rdj = null;
    let newGroup = false;
    state.dependenciesComplete = false;

    /* make a working array of rule scanned markers */
    const isScanned = state.falseArray(state.ruleCount);

    /* discover the rule dependencies */
    for (i = 0; i < state.ruleCount; i += 1) {
      state.falsifyArray(isScanned);
      scan(state.ruleCount, state.ruleDeps, i, isScanned);
    }
    /* discover all rules referencing each rule */
    for (i = 0; i < state.ruleCount; i += 1) {
      for (j = 0; j < state.ruleCount; j += 1) {
        if (i !== j) {
          if (state.ruleDeps[j].refersTo[i]) {
            state.ruleDeps[i].referencedBy[j] = true;
          }
        }
      }
    }
    /* find the non-recursive and recursive types */
    for (i = 0; i < state.ruleCount; i += 1) {
      state.ruleDeps[i].recursiveType = id.ATTR_N;
      if (state.ruleDeps[i].refersTo[i]) {
        state.ruleDeps[i].recursiveType = id.ATTR_R;
      }
    }

    /* find the mutually-recursive groups, if any */
    groupCount = -1;
    for (i = 0; i < state.ruleCount; i += 1) {
      rdi = state.ruleDeps[i];
      if (rdi.recursiveType === id.ATTR_R) {
        newGroup = true;
        for (j = 0; j < state.ruleCount; j += 1) {
          if (i !== j) {
            rdj = state.ruleDeps[j];
            if (rdj.recursiveType === id.ATTR_R) {
              if (rdi.refersTo[j] && rdj.refersTo[i]) {
                if (newGroup) {
                  groupCount += 1;
                  rdi.recursiveType = id.ATTR_MR;
                  rdi.groupNumber = groupCount;
                  newGroup = false;
                }
                rdj.recursiveType = id.ATTR_MR;
                rdj.groupNumber = groupCount;
              }
            }
          }
        }
      }
    }
    state.isMutuallyRecursive = groupCount > -1;

    /* sort the rules/UDTS */
    state.ruleAlphaIndexes.sort(state.compRulesAlpha);
    state.ruleTypeIndexes.sort(state.compRulesAlpha);
    state.ruleTypeIndexes.sort(state.compRulesType);
    if (state.isMutuallyRecursive) {
      state.ruleTypeIndexes.sort(state.compRulesGroup);
    }
    if (state.udtCount) {
      state.udtAlphaIndexes.sort(state.compUdtsAlpha);
    }

    state.dependenciesComplete = true;
  };
  const show = (type = null) => {
    let i = 0;
    let j = 0;
    let count = 0;
    let startSeg = 0;
    const maxRule = state.ruleCount - 1;
    const maxUdt = state.udtCount - 1;
    const lineLength = 100;
    let str = '';
    let pre = '';
    const toArrow = '=> ';
    const byArrow = '<= ';
    let first = false;
    let rdi = null;
    let { ruleIndexes } = state;
    let { udtIndexes } = state;
    if (type === 97) {
      ruleIndexes = state.ruleAlphaIndexes;
      udtIndexes = state.udtAlphaIndexes;
    } else if (type === 116) {
      ruleIndexes = state.ruleTypeIndexes;
      udtIndexes = state.udtAlphaIndexes;
    }
    for (i = 0; i < state.ruleCount; i += 1) {
      rdi = state.ruleDeps[ruleIndexes[i]];
      pre = `${ruleIndexes[i]}:${state.typeToString(rdi.recursiveType)}:`;
      if (state.isMutuallyRecursive) {
        pre += rdi.groupNumber > -1 ? rdi.groupNumber : '-';
        pre += ':';
      }
      pre += ' ';
      str += `${pre + state.rules[ruleIndexes[i]].name}\n`;
      first = true;
      count = 0;
      startSeg = str.length;
      str += pre;
      for (j = 0; j < state.ruleCount; j += 1) {
        if (rdi.refersTo[ruleIndexes[j]]) {
          if (first) {
            str += toArrow;
            first = false;
            str += state.ruleDeps[ruleIndexes[j]].rule.name;
          } else {
            str += `, ${state.ruleDeps[ruleIndexes[j]].rule.name}`;
          }
          count += 1;
        }
        if (str.length - startSeg > lineLength && j !== maxRule) {
          str += `\n${pre}${toArrow}`;
          startSeg = str.length;
        }
      }
      if (state.udtCount) {
        for (j = 0; j < state.udtCount; j += 1) {
          if (rdi.refersToUdt[udtIndexes[j]]) {
            if (first) {
              str += toArrow;
              first = false;
              str += state.udts[udtIndexes[j]].name;
            } else {
              str += `, ${state.udts[udtIndexes[j]].name}`;
            }
            count += 1;
          }
          if (str.length - startSeg > lineLength && j !== maxUdt) {
            str += `\n${pre}${toArrow}`;
            startSeg = str.length;
          }
        }
      }
      if (count === 0) {
        str += '=> <none>\n';
      }
      if (first === false) {
        str += '\n';
      }
      first = true;
      count = 0;
      startSeg = str.length;
      str += pre;
      for (j = 0; j < state.ruleCount; j += 1) {
        if (rdi.referencedBy[ruleIndexes[j]]) {
          if (first) {
            str += byArrow;
            first = false;
            str += state.ruleDeps[ruleIndexes[j]].rule.name;
          } else {
            str += `, ${state.ruleDeps[ruleIndexes[j]].rule.name}`;
          }
          count += 1;
        }
        if (str.length - startSeg > lineLength && j !== maxRule) {
          str += `\n${pre}${toArrow}`;
          startSeg = str.length;
        }
      }
      if (count === 0) {
        str += '<= <none>\n';
      }
      if (first === false) {
        str += '\n';
      }
      str += '\n';
    }
    return str;
  };
  // Display the rule dependencies.
  // - order
  //      - "index" or "i", index order (default)
  //      - "alpha" or "a", alphabetical order
  //      - "type" or "t", ordered by type (alphabetical within each type/group)
  //      - none of above, index order (default)
  const showRuleDependencies = (order = 'index') => {
    let str = 'RULE DEPENDENCIES(index:type:[group number:])\n';
    str += '=> refers to rule names\n';
    str += '<= referenced by rule names\n';
    if (!state.dependenciesComplete) {
      return str;
    }

    if (order.charCodeAt(0) === 97) {
      str += 'alphabetical by rule name\n';
      str += show(97);
    } else if (order.charCodeAt(0) === 116) {
      str += 'ordered by rule type\n';
      str += show(116);
    } else {
      str += 'ordered by rule index\n';
      str += show(null);
    }
    return str;
  };

  /* Destructuring assignment - see MDN Web Docs */
  return { ruleDependencies, showRuleDependencies };
})();


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/sabnf-grammar.js":
/***/ ((module) => {

// copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved<br>
//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>
//
// Generated by apg-js, Version 4.0.0 [apg-js](https://github.com/ldthomas/apg-js)
module.exports = function grammar(){
  // ```
  // SUMMARY
  //      rules = 95
  //       udts = 0
  //    opcodes = 372
  //        ---   ABNF original opcodes
  //        ALT = 43
  //        CAT = 48
  //        REP = 34
  //        RNM = 149
  //        TLS = 2
  //        TBS = 61
  //        TRG = 35
  //        ---   SABNF superset opcodes
  //        UDT = 0
  //        AND = 0
  //        NOT = 0
  //        BKA = 0
  //        BKN = 0
  //        BKR = 0
  //        ABG = 0
  //        AEN = 0
  // characters = [9 - 126]
  // ```
  /* OBJECT IDENTIFIER (for internal parser use) */
  this.grammarObject = 'grammarObject';

  /* RULES */
  this.rules = [];
  this.rules[0] = {name: 'File', lower: 'file', index: 0, isBkr: false};
  this.rules[1] = {name: 'BlankLine', lower: 'blankline', index: 1, isBkr: false};
  this.rules[2] = {name: 'Rule', lower: 'rule', index: 2, isBkr: false};
  this.rules[3] = {name: 'RuleLookup', lower: 'rulelookup', index: 3, isBkr: false};
  this.rules[4] = {name: 'RuleNameTest', lower: 'rulenametest', index: 4, isBkr: false};
  this.rules[5] = {name: 'RuleName', lower: 'rulename', index: 5, isBkr: false};
  this.rules[6] = {name: 'RuleNameError', lower: 'rulenameerror', index: 6, isBkr: false};
  this.rules[7] = {name: 'DefinedAsTest', lower: 'definedastest', index: 7, isBkr: false};
  this.rules[8] = {name: 'DefinedAsError', lower: 'definedaserror', index: 8, isBkr: false};
  this.rules[9] = {name: 'DefinedAs', lower: 'definedas', index: 9, isBkr: false};
  this.rules[10] = {name: 'Defined', lower: 'defined', index: 10, isBkr: false};
  this.rules[11] = {name: 'IncAlt', lower: 'incalt', index: 11, isBkr: false};
  this.rules[12] = {name: 'RuleError', lower: 'ruleerror', index: 12, isBkr: false};
  this.rules[13] = {name: 'LineEndError', lower: 'lineenderror', index: 13, isBkr: false};
  this.rules[14] = {name: 'Alternation', lower: 'alternation', index: 14, isBkr: false};
  this.rules[15] = {name: 'Concatenation', lower: 'concatenation', index: 15, isBkr: false};
  this.rules[16] = {name: 'Repetition', lower: 'repetition', index: 16, isBkr: false};
  this.rules[17] = {name: 'Modifier', lower: 'modifier', index: 17, isBkr: false};
  this.rules[18] = {name: 'Predicate', lower: 'predicate', index: 18, isBkr: false};
  this.rules[19] = {name: 'BasicElement', lower: 'basicelement', index: 19, isBkr: false};
  this.rules[20] = {name: 'BasicElementErr', lower: 'basicelementerr', index: 20, isBkr: false};
  this.rules[21] = {name: 'Group', lower: 'group', index: 21, isBkr: false};
  this.rules[22] = {name: 'GroupError', lower: 'grouperror', index: 22, isBkr: false};
  this.rules[23] = {name: 'GroupOpen', lower: 'groupopen', index: 23, isBkr: false};
  this.rules[24] = {name: 'GroupClose', lower: 'groupclose', index: 24, isBkr: false};
  this.rules[25] = {name: 'Option', lower: 'option', index: 25, isBkr: false};
  this.rules[26] = {name: 'OptionError', lower: 'optionerror', index: 26, isBkr: false};
  this.rules[27] = {name: 'OptionOpen', lower: 'optionopen', index: 27, isBkr: false};
  this.rules[28] = {name: 'OptionClose', lower: 'optionclose', index: 28, isBkr: false};
  this.rules[29] = {name: 'RnmOp', lower: 'rnmop', index: 29, isBkr: false};
  this.rules[30] = {name: 'BkrOp', lower: 'bkrop', index: 30, isBkr: false};
  this.rules[31] = {name: 'bkrModifier', lower: 'bkrmodifier', index: 31, isBkr: false};
  this.rules[32] = {name: 'cs', lower: 'cs', index: 32, isBkr: false};
  this.rules[33] = {name: 'ci', lower: 'ci', index: 33, isBkr: false};
  this.rules[34] = {name: 'um', lower: 'um', index: 34, isBkr: false};
  this.rules[35] = {name: 'pm', lower: 'pm', index: 35, isBkr: false};
  this.rules[36] = {name: 'bkr-name', lower: 'bkr-name', index: 36, isBkr: false};
  this.rules[37] = {name: 'rname', lower: 'rname', index: 37, isBkr: false};
  this.rules[38] = {name: 'uname', lower: 'uname', index: 38, isBkr: false};
  this.rules[39] = {name: 'ename', lower: 'ename', index: 39, isBkr: false};
  this.rules[40] = {name: 'UdtOp', lower: 'udtop', index: 40, isBkr: false};
  this.rules[41] = {name: 'udt-non-empty', lower: 'udt-non-empty', index: 41, isBkr: false};
  this.rules[42] = {name: 'udt-empty', lower: 'udt-empty', index: 42, isBkr: false};
  this.rules[43] = {name: 'RepOp', lower: 'repop', index: 43, isBkr: false};
  this.rules[44] = {name: 'AltOp', lower: 'altop', index: 44, isBkr: false};
  this.rules[45] = {name: 'CatOp', lower: 'catop', index: 45, isBkr: false};
  this.rules[46] = {name: 'StarOp', lower: 'starop', index: 46, isBkr: false};
  this.rules[47] = {name: 'AndOp', lower: 'andop', index: 47, isBkr: false};
  this.rules[48] = {name: 'NotOp', lower: 'notop', index: 48, isBkr: false};
  this.rules[49] = {name: 'BkaOp', lower: 'bkaop', index: 49, isBkr: false};
  this.rules[50] = {name: 'BknOp', lower: 'bknop', index: 50, isBkr: false};
  this.rules[51] = {name: 'AbgOp', lower: 'abgop', index: 51, isBkr: false};
  this.rules[52] = {name: 'AenOp', lower: 'aenop', index: 52, isBkr: false};
  this.rules[53] = {name: 'TrgOp', lower: 'trgop', index: 53, isBkr: false};
  this.rules[54] = {name: 'TbsOp', lower: 'tbsop', index: 54, isBkr: false};
  this.rules[55] = {name: 'TlsOp', lower: 'tlsop', index: 55, isBkr: false};
  this.rules[56] = {name: 'TlsCase', lower: 'tlscase', index: 56, isBkr: false};
  this.rules[57] = {name: 'TlsOpen', lower: 'tlsopen', index: 57, isBkr: false};
  this.rules[58] = {name: 'TlsClose', lower: 'tlsclose', index: 58, isBkr: false};
  this.rules[59] = {name: 'TlsString', lower: 'tlsstring', index: 59, isBkr: false};
  this.rules[60] = {name: 'StringTab', lower: 'stringtab', index: 60, isBkr: false};
  this.rules[61] = {name: 'ClsOp', lower: 'clsop', index: 61, isBkr: false};
  this.rules[62] = {name: 'ClsOpen', lower: 'clsopen', index: 62, isBkr: false};
  this.rules[63] = {name: 'ClsClose', lower: 'clsclose', index: 63, isBkr: false};
  this.rules[64] = {name: 'ClsString', lower: 'clsstring', index: 64, isBkr: false};
  this.rules[65] = {name: 'ProsVal', lower: 'prosval', index: 65, isBkr: false};
  this.rules[66] = {name: 'ProsValOpen', lower: 'prosvalopen', index: 66, isBkr: false};
  this.rules[67] = {name: 'ProsValString', lower: 'prosvalstring', index: 67, isBkr: false};
  this.rules[68] = {name: 'ProsValClose', lower: 'prosvalclose', index: 68, isBkr: false};
  this.rules[69] = {name: 'rep-min', lower: 'rep-min', index: 69, isBkr: false};
  this.rules[70] = {name: 'rep-min-max', lower: 'rep-min-max', index: 70, isBkr: false};
  this.rules[71] = {name: 'rep-max', lower: 'rep-max', index: 71, isBkr: false};
  this.rules[72] = {name: 'rep-num', lower: 'rep-num', index: 72, isBkr: false};
  this.rules[73] = {name: 'dString', lower: 'dstring', index: 73, isBkr: false};
  this.rules[74] = {name: 'xString', lower: 'xstring', index: 74, isBkr: false};
  this.rules[75] = {name: 'bString', lower: 'bstring', index: 75, isBkr: false};
  this.rules[76] = {name: 'Dec', lower: 'dec', index: 76, isBkr: false};
  this.rules[77] = {name: 'Hex', lower: 'hex', index: 77, isBkr: false};
  this.rules[78] = {name: 'Bin', lower: 'bin', index: 78, isBkr: false};
  this.rules[79] = {name: 'dmin', lower: 'dmin', index: 79, isBkr: false};
  this.rules[80] = {name: 'dmax', lower: 'dmax', index: 80, isBkr: false};
  this.rules[81] = {name: 'bmin', lower: 'bmin', index: 81, isBkr: false};
  this.rules[82] = {name: 'bmax', lower: 'bmax', index: 82, isBkr: false};
  this.rules[83] = {name: 'xmin', lower: 'xmin', index: 83, isBkr: false};
  this.rules[84] = {name: 'xmax', lower: 'xmax', index: 84, isBkr: false};
  this.rules[85] = {name: 'dnum', lower: 'dnum', index: 85, isBkr: false};
  this.rules[86] = {name: 'bnum', lower: 'bnum', index: 86, isBkr: false};
  this.rules[87] = {name: 'xnum', lower: 'xnum', index: 87, isBkr: false};
  this.rules[88] = {name: 'alphanum', lower: 'alphanum', index: 88, isBkr: false};
  this.rules[89] = {name: 'owsp', lower: 'owsp', index: 89, isBkr: false};
  this.rules[90] = {name: 'wsp', lower: 'wsp', index: 90, isBkr: false};
  this.rules[91] = {name: 'space', lower: 'space', index: 91, isBkr: false};
  this.rules[92] = {name: 'comment', lower: 'comment', index: 92, isBkr: false};
  this.rules[93] = {name: 'LineEnd', lower: 'lineend', index: 93, isBkr: false};
  this.rules[94] = {name: 'LineContinue', lower: 'linecontinue', index: 94, isBkr: false};

  /* UDTS */
  this.udts = [];

  /* OPCODES */
  /* File */
  this.rules[0].opcodes = [];
  this.rules[0].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[0].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
  this.rules[0].opcodes[2] = {type: 4, index: 1};// RNM(BlankLine)
  this.rules[0].opcodes[3] = {type: 4, index: 2};// RNM(Rule)
  this.rules[0].opcodes[4] = {type: 4, index: 12};// RNM(RuleError)

  /* BlankLine */
  this.rules[1].opcodes = [];
  this.rules[1].opcodes[0] = {type: 2, children: [1,5,7]};// CAT
  this.rules[1].opcodes[1] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[1].opcodes[2] = {type: 1, children: [3,4]};// ALT
  this.rules[1].opcodes[3] = {type: 6, string: [32]};// TBS
  this.rules[1].opcodes[4] = {type: 6, string: [9]};// TBS
  this.rules[1].opcodes[5] = {type: 3, min: 0, max: 1};// REP
  this.rules[1].opcodes[6] = {type: 4, index: 92};// RNM(comment)
  this.rules[1].opcodes[7] = {type: 4, index: 93};// RNM(LineEnd)

  /* Rule */
  this.rules[2].opcodes = [];
  this.rules[2].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
  this.rules[2].opcodes[1] = {type: 4, index: 3};// RNM(RuleLookup)
  this.rules[2].opcodes[2] = {type: 4, index: 89};// RNM(owsp)
  this.rules[2].opcodes[3] = {type: 4, index: 14};// RNM(Alternation)
  this.rules[2].opcodes[4] = {type: 1, children: [5,8]};// ALT
  this.rules[2].opcodes[5] = {type: 2, children: [6,7]};// CAT
  this.rules[2].opcodes[6] = {type: 4, index: 89};// RNM(owsp)
  this.rules[2].opcodes[7] = {type: 4, index: 93};// RNM(LineEnd)
  this.rules[2].opcodes[8] = {type: 2, children: [9,10]};// CAT
  this.rules[2].opcodes[9] = {type: 4, index: 13};// RNM(LineEndError)
  this.rules[2].opcodes[10] = {type: 4, index: 93};// RNM(LineEnd)

  /* RuleLookup */
  this.rules[3].opcodes = [];
  this.rules[3].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
  this.rules[3].opcodes[1] = {type: 4, index: 4};// RNM(RuleNameTest)
  this.rules[3].opcodes[2] = {type: 4, index: 89};// RNM(owsp)
  this.rules[3].opcodes[3] = {type: 4, index: 7};// RNM(DefinedAsTest)

  /* RuleNameTest */
  this.rules[4].opcodes = [];
  this.rules[4].opcodes[0] = {type: 1, children: [1,2]};// ALT
  this.rules[4].opcodes[1] = {type: 4, index: 5};// RNM(RuleName)
  this.rules[4].opcodes[2] = {type: 4, index: 6};// RNM(RuleNameError)

  /* RuleName */
  this.rules[5].opcodes = [];
  this.rules[5].opcodes[0] = {type: 4, index: 88};// RNM(alphanum)

  /* RuleNameError */
  this.rules[6].opcodes = [];
  this.rules[6].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[6].opcodes[1] = {type: 1, children: [2,3]};// ALT
  this.rules[6].opcodes[2] = {type: 5, min: 33, max: 60};// TRG
  this.rules[6].opcodes[3] = {type: 5, min: 62, max: 126};// TRG

  /* DefinedAsTest */
  this.rules[7].opcodes = [];
  this.rules[7].opcodes[0] = {type: 1, children: [1,2]};// ALT
  this.rules[7].opcodes[1] = {type: 4, index: 9};// RNM(DefinedAs)
  this.rules[7].opcodes[2] = {type: 4, index: 8};// RNM(DefinedAsError)

  /* DefinedAsError */
  this.rules[8].opcodes = [];
  this.rules[8].opcodes[0] = {type: 3, min: 1, max: 2};// REP
  this.rules[8].opcodes[1] = {type: 5, min: 33, max: 126};// TRG

  /* DefinedAs */
  this.rules[9].opcodes = [];
  this.rules[9].opcodes[0] = {type: 1, children: [1,2]};// ALT
  this.rules[9].opcodes[1] = {type: 4, index: 11};// RNM(IncAlt)
  this.rules[9].opcodes[2] = {type: 4, index: 10};// RNM(Defined)

  /* Defined */
  this.rules[10].opcodes = [];
  this.rules[10].opcodes[0] = {type: 6, string: [61]};// TBS

  /* IncAlt */
  this.rules[11].opcodes = [];
  this.rules[11].opcodes[0] = {type: 6, string: [61,47]};// TBS

  /* RuleError */
  this.rules[12].opcodes = [];
  this.rules[12].opcodes[0] = {type: 2, children: [1,6]};// CAT
  this.rules[12].opcodes[1] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[12].opcodes[2] = {type: 1, children: [3,4,5]};// ALT
  this.rules[12].opcodes[3] = {type: 5, min: 32, max: 126};// TRG
  this.rules[12].opcodes[4] = {type: 6, string: [9]};// TBS
  this.rules[12].opcodes[5] = {type: 4, index: 94};// RNM(LineContinue)
  this.rules[12].opcodes[6] = {type: 4, index: 93};// RNM(LineEnd)

  /* LineEndError */
  this.rules[13].opcodes = [];
  this.rules[13].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[13].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
  this.rules[13].opcodes[2] = {type: 5, min: 32, max: 126};// TRG
  this.rules[13].opcodes[3] = {type: 6, string: [9]};// TBS
  this.rules[13].opcodes[4] = {type: 4, index: 94};// RNM(LineContinue)

  /* Alternation */
  this.rules[14].opcodes = [];
  this.rules[14].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[14].opcodes[1] = {type: 4, index: 15};// RNM(Concatenation)
  this.rules[14].opcodes[2] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[14].opcodes[3] = {type: 2, children: [4,5,6]};// CAT
  this.rules[14].opcodes[4] = {type: 4, index: 89};// RNM(owsp)
  this.rules[14].opcodes[5] = {type: 4, index: 44};// RNM(AltOp)
  this.rules[14].opcodes[6] = {type: 4, index: 15};// RNM(Concatenation)

  /* Concatenation */
  this.rules[15].opcodes = [];
  this.rules[15].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[15].opcodes[1] = {type: 4, index: 16};// RNM(Repetition)
  this.rules[15].opcodes[2] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[15].opcodes[3] = {type: 2, children: [4,5]};// CAT
  this.rules[15].opcodes[4] = {type: 4, index: 45};// RNM(CatOp)
  this.rules[15].opcodes[5] = {type: 4, index: 16};// RNM(Repetition)

  /* Repetition */
  this.rules[16].opcodes = [];
  this.rules[16].opcodes[0] = {type: 2, children: [1,3]};// CAT
  this.rules[16].opcodes[1] = {type: 3, min: 0, max: 1};// REP
  this.rules[16].opcodes[2] = {type: 4, index: 17};// RNM(Modifier)
  this.rules[16].opcodes[3] = {type: 1, children: [4,5,6,7]};// ALT
  this.rules[16].opcodes[4] = {type: 4, index: 21};// RNM(Group)
  this.rules[16].opcodes[5] = {type: 4, index: 25};// RNM(Option)
  this.rules[16].opcodes[6] = {type: 4, index: 19};// RNM(BasicElement)
  this.rules[16].opcodes[7] = {type: 4, index: 20};// RNM(BasicElementErr)

  /* Modifier */
  this.rules[17].opcodes = [];
  this.rules[17].opcodes[0] = {type: 1, children: [1,5]};// ALT
  this.rules[17].opcodes[1] = {type: 2, children: [2,3]};// CAT
  this.rules[17].opcodes[2] = {type: 4, index: 18};// RNM(Predicate)
  this.rules[17].opcodes[3] = {type: 3, min: 0, max: 1};// REP
  this.rules[17].opcodes[4] = {type: 4, index: 43};// RNM(RepOp)
  this.rules[17].opcodes[5] = {type: 4, index: 43};// RNM(RepOp)

  /* Predicate */
  this.rules[18].opcodes = [];
  this.rules[18].opcodes[0] = {type: 1, children: [1,2,3,4]};// ALT
  this.rules[18].opcodes[1] = {type: 4, index: 49};// RNM(BkaOp)
  this.rules[18].opcodes[2] = {type: 4, index: 50};// RNM(BknOp)
  this.rules[18].opcodes[3] = {type: 4, index: 47};// RNM(AndOp)
  this.rules[18].opcodes[4] = {type: 4, index: 48};// RNM(NotOp)

  /* BasicElement */
  this.rules[19].opcodes = [];
  this.rules[19].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10]};// ALT
  this.rules[19].opcodes[1] = {type: 4, index: 40};// RNM(UdtOp)
  this.rules[19].opcodes[2] = {type: 4, index: 29};// RNM(RnmOp)
  this.rules[19].opcodes[3] = {type: 4, index: 53};// RNM(TrgOp)
  this.rules[19].opcodes[4] = {type: 4, index: 54};// RNM(TbsOp)
  this.rules[19].opcodes[5] = {type: 4, index: 55};// RNM(TlsOp)
  this.rules[19].opcodes[6] = {type: 4, index: 61};// RNM(ClsOp)
  this.rules[19].opcodes[7] = {type: 4, index: 30};// RNM(BkrOp)
  this.rules[19].opcodes[8] = {type: 4, index: 51};// RNM(AbgOp)
  this.rules[19].opcodes[9] = {type: 4, index: 52};// RNM(AenOp)
  this.rules[19].opcodes[10] = {type: 4, index: 65};// RNM(ProsVal)

  /* BasicElementErr */
  this.rules[20].opcodes = [];
  this.rules[20].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[20].opcodes[1] = {type: 1, children: [2,3,4,5]};// ALT
  this.rules[20].opcodes[2] = {type: 5, min: 33, max: 40};// TRG
  this.rules[20].opcodes[3] = {type: 5, min: 42, max: 46};// TRG
  this.rules[20].opcodes[4] = {type: 5, min: 48, max: 92};// TRG
  this.rules[20].opcodes[5] = {type: 5, min: 94, max: 126};// TRG

  /* Group */
  this.rules[21].opcodes = [];
  this.rules[21].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
  this.rules[21].opcodes[1] = {type: 4, index: 23};// RNM(GroupOpen)
  this.rules[21].opcodes[2] = {type: 4, index: 14};// RNM(Alternation)
  this.rules[21].opcodes[3] = {type: 1, children: [4,5]};// ALT
  this.rules[21].opcodes[4] = {type: 4, index: 24};// RNM(GroupClose)
  this.rules[21].opcodes[5] = {type: 4, index: 22};// RNM(GroupError)

  /* GroupError */
  this.rules[22].opcodes = [];
  this.rules[22].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[22].opcodes[1] = {type: 1, children: [2,3,4,5]};// ALT
  this.rules[22].opcodes[2] = {type: 5, min: 33, max: 40};// TRG
  this.rules[22].opcodes[3] = {type: 5, min: 42, max: 46};// TRG
  this.rules[22].opcodes[4] = {type: 5, min: 48, max: 92};// TRG
  this.rules[22].opcodes[5] = {type: 5, min: 94, max: 126};// TRG

  /* GroupOpen */
  this.rules[23].opcodes = [];
  this.rules[23].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[23].opcodes[1] = {type: 6, string: [40]};// TBS
  this.rules[23].opcodes[2] = {type: 4, index: 89};// RNM(owsp)

  /* GroupClose */
  this.rules[24].opcodes = [];
  this.rules[24].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[24].opcodes[1] = {type: 4, index: 89};// RNM(owsp)
  this.rules[24].opcodes[2] = {type: 6, string: [41]};// TBS

  /* Option */
  this.rules[25].opcodes = [];
  this.rules[25].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
  this.rules[25].opcodes[1] = {type: 4, index: 27};// RNM(OptionOpen)
  this.rules[25].opcodes[2] = {type: 4, index: 14};// RNM(Alternation)
  this.rules[25].opcodes[3] = {type: 1, children: [4,5]};// ALT
  this.rules[25].opcodes[4] = {type: 4, index: 28};// RNM(OptionClose)
  this.rules[25].opcodes[5] = {type: 4, index: 26};// RNM(OptionError)

  /* OptionError */
  this.rules[26].opcodes = [];
  this.rules[26].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[26].opcodes[1] = {type: 1, children: [2,3,4,5]};// ALT
  this.rules[26].opcodes[2] = {type: 5, min: 33, max: 40};// TRG
  this.rules[26].opcodes[3] = {type: 5, min: 42, max: 46};// TRG
  this.rules[26].opcodes[4] = {type: 5, min: 48, max: 92};// TRG
  this.rules[26].opcodes[5] = {type: 5, min: 94, max: 126};// TRG

  /* OptionOpen */
  this.rules[27].opcodes = [];
  this.rules[27].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[27].opcodes[1] = {type: 6, string: [91]};// TBS
  this.rules[27].opcodes[2] = {type: 4, index: 89};// RNM(owsp)

  /* OptionClose */
  this.rules[28].opcodes = [];
  this.rules[28].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[28].opcodes[1] = {type: 4, index: 89};// RNM(owsp)
  this.rules[28].opcodes[2] = {type: 6, string: [93]};// TBS

  /* RnmOp */
  this.rules[29].opcodes = [];
  this.rules[29].opcodes[0] = {type: 4, index: 88};// RNM(alphanum)

  /* BkrOp */
  this.rules[30].opcodes = [];
  this.rules[30].opcodes[0] = {type: 2, children: [1,2,4]};// CAT
  this.rules[30].opcodes[1] = {type: 6, string: [92]};// TBS
  this.rules[30].opcodes[2] = {type: 3, min: 0, max: 1};// REP
  this.rules[30].opcodes[3] = {type: 4, index: 31};// RNM(bkrModifier)
  this.rules[30].opcodes[4] = {type: 4, index: 36};// RNM(bkr-name)

  /* bkrModifier */
  this.rules[31].opcodes = [];
  this.rules[31].opcodes[0] = {type: 1, children: [1,7,13,19]};// ALT
  this.rules[31].opcodes[1] = {type: 2, children: [2,3]};// CAT
  this.rules[31].opcodes[2] = {type: 4, index: 32};// RNM(cs)
  this.rules[31].opcodes[3] = {type: 3, min: 0, max: 1};// REP
  this.rules[31].opcodes[4] = {type: 1, children: [5,6]};// ALT
  this.rules[31].opcodes[5] = {type: 4, index: 34};// RNM(um)
  this.rules[31].opcodes[6] = {type: 4, index: 35};// RNM(pm)
  this.rules[31].opcodes[7] = {type: 2, children: [8,9]};// CAT
  this.rules[31].opcodes[8] = {type: 4, index: 33};// RNM(ci)
  this.rules[31].opcodes[9] = {type: 3, min: 0, max: 1};// REP
  this.rules[31].opcodes[10] = {type: 1, children: [11,12]};// ALT
  this.rules[31].opcodes[11] = {type: 4, index: 34};// RNM(um)
  this.rules[31].opcodes[12] = {type: 4, index: 35};// RNM(pm)
  this.rules[31].opcodes[13] = {type: 2, children: [14,15]};// CAT
  this.rules[31].opcodes[14] = {type: 4, index: 34};// RNM(um)
  this.rules[31].opcodes[15] = {type: 3, min: 0, max: 1};// REP
  this.rules[31].opcodes[16] = {type: 1, children: [17,18]};// ALT
  this.rules[31].opcodes[17] = {type: 4, index: 32};// RNM(cs)
  this.rules[31].opcodes[18] = {type: 4, index: 33};// RNM(ci)
  this.rules[31].opcodes[19] = {type: 2, children: [20,21]};// CAT
  this.rules[31].opcodes[20] = {type: 4, index: 35};// RNM(pm)
  this.rules[31].opcodes[21] = {type: 3, min: 0, max: 1};// REP
  this.rules[31].opcodes[22] = {type: 1, children: [23,24]};// ALT
  this.rules[31].opcodes[23] = {type: 4, index: 32};// RNM(cs)
  this.rules[31].opcodes[24] = {type: 4, index: 33};// RNM(ci)

  /* cs */
  this.rules[32].opcodes = [];
  this.rules[32].opcodes[0] = {type: 6, string: [37,115]};// TBS

  /* ci */
  this.rules[33].opcodes = [];
  this.rules[33].opcodes[0] = {type: 6, string: [37,105]};// TBS

  /* um */
  this.rules[34].opcodes = [];
  this.rules[34].opcodes[0] = {type: 6, string: [37,117]};// TBS

  /* pm */
  this.rules[35].opcodes = [];
  this.rules[35].opcodes[0] = {type: 6, string: [37,112]};// TBS

  /* bkr-name */
  this.rules[36].opcodes = [];
  this.rules[36].opcodes[0] = {type: 1, children: [1,2,3]};// ALT
  this.rules[36].opcodes[1] = {type: 4, index: 38};// RNM(uname)
  this.rules[36].opcodes[2] = {type: 4, index: 39};// RNM(ename)
  this.rules[36].opcodes[3] = {type: 4, index: 37};// RNM(rname)

  /* rname */
  this.rules[37].opcodes = [];
  this.rules[37].opcodes[0] = {type: 4, index: 88};// RNM(alphanum)

  /* uname */
  this.rules[38].opcodes = [];
  this.rules[38].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[38].opcodes[1] = {type: 6, string: [117,95]};// TBS
  this.rules[38].opcodes[2] = {type: 4, index: 88};// RNM(alphanum)

  /* ename */
  this.rules[39].opcodes = [];
  this.rules[39].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[39].opcodes[1] = {type: 6, string: [101,95]};// TBS
  this.rules[39].opcodes[2] = {type: 4, index: 88};// RNM(alphanum)

  /* UdtOp */
  this.rules[40].opcodes = [];
  this.rules[40].opcodes[0] = {type: 1, children: [1,2]};// ALT
  this.rules[40].opcodes[1] = {type: 4, index: 42};// RNM(udt-empty)
  this.rules[40].opcodes[2] = {type: 4, index: 41};// RNM(udt-non-empty)

  /* udt-non-empty */
  this.rules[41].opcodes = [];
  this.rules[41].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[41].opcodes[1] = {type: 6, string: [117,95]};// TBS
  this.rules[41].opcodes[2] = {type: 4, index: 88};// RNM(alphanum)

  /* udt-empty */
  this.rules[42].opcodes = [];
  this.rules[42].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[42].opcodes[1] = {type: 6, string: [101,95]};// TBS
  this.rules[42].opcodes[2] = {type: 4, index: 88};// RNM(alphanum)

  /* RepOp */
  this.rules[43].opcodes = [];
  this.rules[43].opcodes[0] = {type: 1, children: [1,5,8,11,12]};// ALT
  this.rules[43].opcodes[1] = {type: 2, children: [2,3,4]};// CAT
  this.rules[43].opcodes[2] = {type: 4, index: 69};// RNM(rep-min)
  this.rules[43].opcodes[3] = {type: 4, index: 46};// RNM(StarOp)
  this.rules[43].opcodes[4] = {type: 4, index: 71};// RNM(rep-max)
  this.rules[43].opcodes[5] = {type: 2, children: [6,7]};// CAT
  this.rules[43].opcodes[6] = {type: 4, index: 69};// RNM(rep-min)
  this.rules[43].opcodes[7] = {type: 4, index: 46};// RNM(StarOp)
  this.rules[43].opcodes[8] = {type: 2, children: [9,10]};// CAT
  this.rules[43].opcodes[9] = {type: 4, index: 46};// RNM(StarOp)
  this.rules[43].opcodes[10] = {type: 4, index: 71};// RNM(rep-max)
  this.rules[43].opcodes[11] = {type: 4, index: 46};// RNM(StarOp)
  this.rules[43].opcodes[12] = {type: 4, index: 70};// RNM(rep-min-max)

  /* AltOp */
  this.rules[44].opcodes = [];
  this.rules[44].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[44].opcodes[1] = {type: 6, string: [47]};// TBS
  this.rules[44].opcodes[2] = {type: 4, index: 89};// RNM(owsp)

  /* CatOp */
  this.rules[45].opcodes = [];
  this.rules[45].opcodes[0] = {type: 4, index: 90};// RNM(wsp)

  /* StarOp */
  this.rules[46].opcodes = [];
  this.rules[46].opcodes[0] = {type: 6, string: [42]};// TBS

  /* AndOp */
  this.rules[47].opcodes = [];
  this.rules[47].opcodes[0] = {type: 6, string: [38]};// TBS

  /* NotOp */
  this.rules[48].opcodes = [];
  this.rules[48].opcodes[0] = {type: 6, string: [33]};// TBS

  /* BkaOp */
  this.rules[49].opcodes = [];
  this.rules[49].opcodes[0] = {type: 6, string: [38,38]};// TBS

  /* BknOp */
  this.rules[50].opcodes = [];
  this.rules[50].opcodes[0] = {type: 6, string: [33,33]};// TBS

  /* AbgOp */
  this.rules[51].opcodes = [];
  this.rules[51].opcodes[0] = {type: 6, string: [37,94]};// TBS

  /* AenOp */
  this.rules[52].opcodes = [];
  this.rules[52].opcodes[0] = {type: 6, string: [37,36]};// TBS

  /* TrgOp */
  this.rules[53].opcodes = [];
  this.rules[53].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[53].opcodes[1] = {type: 6, string: [37]};// TBS
  this.rules[53].opcodes[2] = {type: 1, children: [3,8,13]};// ALT
  this.rules[53].opcodes[3] = {type: 2, children: [4,5,6,7]};// CAT
  this.rules[53].opcodes[4] = {type: 4, index: 76};// RNM(Dec)
  this.rules[53].opcodes[5] = {type: 4, index: 79};// RNM(dmin)
  this.rules[53].opcodes[6] = {type: 6, string: [45]};// TBS
  this.rules[53].opcodes[7] = {type: 4, index: 80};// RNM(dmax)
  this.rules[53].opcodes[8] = {type: 2, children: [9,10,11,12]};// CAT
  this.rules[53].opcodes[9] = {type: 4, index: 77};// RNM(Hex)
  this.rules[53].opcodes[10] = {type: 4, index: 83};// RNM(xmin)
  this.rules[53].opcodes[11] = {type: 6, string: [45]};// TBS
  this.rules[53].opcodes[12] = {type: 4, index: 84};// RNM(xmax)
  this.rules[53].opcodes[13] = {type: 2, children: [14,15,16,17]};// CAT
  this.rules[53].opcodes[14] = {type: 4, index: 78};// RNM(Bin)
  this.rules[53].opcodes[15] = {type: 4, index: 81};// RNM(bmin)
  this.rules[53].opcodes[16] = {type: 6, string: [45]};// TBS
  this.rules[53].opcodes[17] = {type: 4, index: 82};// RNM(bmax)

  /* TbsOp */
  this.rules[54].opcodes = [];
  this.rules[54].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[54].opcodes[1] = {type: 6, string: [37]};// TBS
  this.rules[54].opcodes[2] = {type: 1, children: [3,10,17]};// ALT
  this.rules[54].opcodes[3] = {type: 2, children: [4,5,6]};// CAT
  this.rules[54].opcodes[4] = {type: 4, index: 76};// RNM(Dec)
  this.rules[54].opcodes[5] = {type: 4, index: 73};// RNM(dString)
  this.rules[54].opcodes[6] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[54].opcodes[7] = {type: 2, children: [8,9]};// CAT
  this.rules[54].opcodes[8] = {type: 6, string: [46]};// TBS
  this.rules[54].opcodes[9] = {type: 4, index: 73};// RNM(dString)
  this.rules[54].opcodes[10] = {type: 2, children: [11,12,13]};// CAT
  this.rules[54].opcodes[11] = {type: 4, index: 77};// RNM(Hex)
  this.rules[54].opcodes[12] = {type: 4, index: 74};// RNM(xString)
  this.rules[54].opcodes[13] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[54].opcodes[14] = {type: 2, children: [15,16]};// CAT
  this.rules[54].opcodes[15] = {type: 6, string: [46]};// TBS
  this.rules[54].opcodes[16] = {type: 4, index: 74};// RNM(xString)
  this.rules[54].opcodes[17] = {type: 2, children: [18,19,20]};// CAT
  this.rules[54].opcodes[18] = {type: 4, index: 78};// RNM(Bin)
  this.rules[54].opcodes[19] = {type: 4, index: 75};// RNM(bString)
  this.rules[54].opcodes[20] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[54].opcodes[21] = {type: 2, children: [22,23]};// CAT
  this.rules[54].opcodes[22] = {type: 6, string: [46]};// TBS
  this.rules[54].opcodes[23] = {type: 4, index: 75};// RNM(bString)

  /* TlsOp */
  this.rules[55].opcodes = [];
  this.rules[55].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
  this.rules[55].opcodes[1] = {type: 4, index: 56};// RNM(TlsCase)
  this.rules[55].opcodes[2] = {type: 4, index: 57};// RNM(TlsOpen)
  this.rules[55].opcodes[3] = {type: 4, index: 59};// RNM(TlsString)
  this.rules[55].opcodes[4] = {type: 4, index: 58};// RNM(TlsClose)

  /* TlsCase */
  this.rules[56].opcodes = [];
  this.rules[56].opcodes[0] = {type: 3, min: 0, max: 1};// REP
  this.rules[56].opcodes[1] = {type: 1, children: [2,3]};// ALT
  this.rules[56].opcodes[2] = {type: 7, string: [37,105]};// TLS
  this.rules[56].opcodes[3] = {type: 7, string: [37,115]};// TLS

  /* TlsOpen */
  this.rules[57].opcodes = [];
  this.rules[57].opcodes[0] = {type: 6, string: [34]};// TBS

  /* TlsClose */
  this.rules[58].opcodes = [];
  this.rules[58].opcodes[0] = {type: 6, string: [34]};// TBS

  /* TlsString */
  this.rules[59].opcodes = [];
  this.rules[59].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[59].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
  this.rules[59].opcodes[2] = {type: 5, min: 32, max: 33};// TRG
  this.rules[59].opcodes[3] = {type: 5, min: 35, max: 126};// TRG
  this.rules[59].opcodes[4] = {type: 4, index: 60};// RNM(StringTab)

  /* StringTab */
  this.rules[60].opcodes = [];
  this.rules[60].opcodes[0] = {type: 6, string: [9]};// TBS

  /* ClsOp */
  this.rules[61].opcodes = [];
  this.rules[61].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
  this.rules[61].opcodes[1] = {type: 4, index: 62};// RNM(ClsOpen)
  this.rules[61].opcodes[2] = {type: 4, index: 64};// RNM(ClsString)
  this.rules[61].opcodes[3] = {type: 4, index: 63};// RNM(ClsClose)

  /* ClsOpen */
  this.rules[62].opcodes = [];
  this.rules[62].opcodes[0] = {type: 6, string: [39]};// TBS

  /* ClsClose */
  this.rules[63].opcodes = [];
  this.rules[63].opcodes[0] = {type: 6, string: [39]};// TBS

  /* ClsString */
  this.rules[64].opcodes = [];
  this.rules[64].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[64].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
  this.rules[64].opcodes[2] = {type: 5, min: 32, max: 38};// TRG
  this.rules[64].opcodes[3] = {type: 5, min: 40, max: 126};// TRG
  this.rules[64].opcodes[4] = {type: 4, index: 60};// RNM(StringTab)

  /* ProsVal */
  this.rules[65].opcodes = [];
  this.rules[65].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
  this.rules[65].opcodes[1] = {type: 4, index: 66};// RNM(ProsValOpen)
  this.rules[65].opcodes[2] = {type: 4, index: 67};// RNM(ProsValString)
  this.rules[65].opcodes[3] = {type: 4, index: 68};// RNM(ProsValClose)

  /* ProsValOpen */
  this.rules[66].opcodes = [];
  this.rules[66].opcodes[0] = {type: 6, string: [60]};// TBS

  /* ProsValString */
  this.rules[67].opcodes = [];
  this.rules[67].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[67].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
  this.rules[67].opcodes[2] = {type: 5, min: 32, max: 61};// TRG
  this.rules[67].opcodes[3] = {type: 5, min: 63, max: 126};// TRG
  this.rules[67].opcodes[4] = {type: 4, index: 60};// RNM(StringTab)

  /* ProsValClose */
  this.rules[68].opcodes = [];
  this.rules[68].opcodes[0] = {type: 6, string: [62]};// TBS

  /* rep-min */
  this.rules[69].opcodes = [];
  this.rules[69].opcodes[0] = {type: 4, index: 72};// RNM(rep-num)

  /* rep-min-max */
  this.rules[70].opcodes = [];
  this.rules[70].opcodes[0] = {type: 4, index: 72};// RNM(rep-num)

  /* rep-max */
  this.rules[71].opcodes = [];
  this.rules[71].opcodes[0] = {type: 4, index: 72};// RNM(rep-num)

  /* rep-num */
  this.rules[72].opcodes = [];
  this.rules[72].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[72].opcodes[1] = {type: 5, min: 48, max: 57};// TRG

  /* dString */
  this.rules[73].opcodes = [];
  this.rules[73].opcodes[0] = {type: 4, index: 85};// RNM(dnum)

  /* xString */
  this.rules[74].opcodes = [];
  this.rules[74].opcodes[0] = {type: 4, index: 87};// RNM(xnum)

  /* bString */
  this.rules[75].opcodes = [];
  this.rules[75].opcodes[0] = {type: 4, index: 86};// RNM(bnum)

  /* Dec */
  this.rules[76].opcodes = [];
  this.rules[76].opcodes[0] = {type: 1, children: [1,2]};// ALT
  this.rules[76].opcodes[1] = {type: 6, string: [68]};// TBS
  this.rules[76].opcodes[2] = {type: 6, string: [100]};// TBS

  /* Hex */
  this.rules[77].opcodes = [];
  this.rules[77].opcodes[0] = {type: 1, children: [1,2]};// ALT
  this.rules[77].opcodes[1] = {type: 6, string: [88]};// TBS
  this.rules[77].opcodes[2] = {type: 6, string: [120]};// TBS

  /* Bin */
  this.rules[78].opcodes = [];
  this.rules[78].opcodes[0] = {type: 1, children: [1,2]};// ALT
  this.rules[78].opcodes[1] = {type: 6, string: [66]};// TBS
  this.rules[78].opcodes[2] = {type: 6, string: [98]};// TBS

  /* dmin */
  this.rules[79].opcodes = [];
  this.rules[79].opcodes[0] = {type: 4, index: 85};// RNM(dnum)

  /* dmax */
  this.rules[80].opcodes = [];
  this.rules[80].opcodes[0] = {type: 4, index: 85};// RNM(dnum)

  /* bmin */
  this.rules[81].opcodes = [];
  this.rules[81].opcodes[0] = {type: 4, index: 86};// RNM(bnum)

  /* bmax */
  this.rules[82].opcodes = [];
  this.rules[82].opcodes[0] = {type: 4, index: 86};// RNM(bnum)

  /* xmin */
  this.rules[83].opcodes = [];
  this.rules[83].opcodes[0] = {type: 4, index: 87};// RNM(xnum)

  /* xmax */
  this.rules[84].opcodes = [];
  this.rules[84].opcodes[0] = {type: 4, index: 87};// RNM(xnum)

  /* dnum */
  this.rules[85].opcodes = [];
  this.rules[85].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[85].opcodes[1] = {type: 5, min: 48, max: 57};// TRG

  /* bnum */
  this.rules[86].opcodes = [];
  this.rules[86].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[86].opcodes[1] = {type: 5, min: 48, max: 49};// TRG

  /* xnum */
  this.rules[87].opcodes = [];
  this.rules[87].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[87].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
  this.rules[87].opcodes[2] = {type: 5, min: 48, max: 57};// TRG
  this.rules[87].opcodes[3] = {type: 5, min: 65, max: 70};// TRG
  this.rules[87].opcodes[4] = {type: 5, min: 97, max: 102};// TRG

  /* alphanum */
  this.rules[88].opcodes = [];
  this.rules[88].opcodes[0] = {type: 2, children: [1,4]};// CAT
  this.rules[88].opcodes[1] = {type: 1, children: [2,3]};// ALT
  this.rules[88].opcodes[2] = {type: 5, min: 97, max: 122};// TRG
  this.rules[88].opcodes[3] = {type: 5, min: 65, max: 90};// TRG
  this.rules[88].opcodes[4] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[88].opcodes[5] = {type: 1, children: [6,7,8,9]};// ALT
  this.rules[88].opcodes[6] = {type: 5, min: 97, max: 122};// TRG
  this.rules[88].opcodes[7] = {type: 5, min: 65, max: 90};// TRG
  this.rules[88].opcodes[8] = {type: 5, min: 48, max: 57};// TRG
  this.rules[88].opcodes[9] = {type: 6, string: [45]};// TBS

  /* owsp */
  this.rules[89].opcodes = [];
  this.rules[89].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[89].opcodes[1] = {type: 4, index: 91};// RNM(space)

  /* wsp */
  this.rules[90].opcodes = [];
  this.rules[90].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[90].opcodes[1] = {type: 4, index: 91};// RNM(space)

  /* space */
  this.rules[91].opcodes = [];
  this.rules[91].opcodes[0] = {type: 1, children: [1,2,3,4]};// ALT
  this.rules[91].opcodes[1] = {type: 6, string: [32]};// TBS
  this.rules[91].opcodes[2] = {type: 6, string: [9]};// TBS
  this.rules[91].opcodes[3] = {type: 4, index: 92};// RNM(comment)
  this.rules[91].opcodes[4] = {type: 4, index: 94};// RNM(LineContinue)

  /* comment */
  this.rules[92].opcodes = [];
  this.rules[92].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[92].opcodes[1] = {type: 6, string: [59]};// TBS
  this.rules[92].opcodes[2] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[92].opcodes[3] = {type: 1, children: [4,5]};// ALT
  this.rules[92].opcodes[4] = {type: 5, min: 32, max: 126};// TRG
  this.rules[92].opcodes[5] = {type: 6, string: [9]};// TBS

  /* LineEnd */
  this.rules[93].opcodes = [];
  this.rules[93].opcodes[0] = {type: 1, children: [1,2,3]};// ALT
  this.rules[93].opcodes[1] = {type: 6, string: [13,10]};// TBS
  this.rules[93].opcodes[2] = {type: 6, string: [10]};// TBS
  this.rules[93].opcodes[3] = {type: 6, string: [13]};// TBS

  /* LineContinue */
  this.rules[94].opcodes = [];
  this.rules[94].opcodes[0] = {type: 2, children: [1,5]};// CAT
  this.rules[94].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
  this.rules[94].opcodes[2] = {type: 6, string: [13,10]};// TBS
  this.rules[94].opcodes[3] = {type: 6, string: [10]};// TBS
  this.rules[94].opcodes[4] = {type: 6, string: [13]};// TBS
  this.rules[94].opcodes[5] = {type: 1, children: [6,7]};// ALT
  this.rules[94].opcodes[6] = {type: 6, string: [32]};// TBS
  this.rules[94].opcodes[7] = {type: 6, string: [9]};// TBS

  // The `toString()` function will display the original grammar file(s) that produced these opcodes.
  this.toString = function toString(){
    let str = "";
    str += ";\n";
    str += "; ABNF for JavaScript APG 2.0 SABNF\n";
    str += "; RFC 5234 with some restrictions and additions.\n";
    str += "; Updated 11/24/2015 for RFC 7405 case-sensitive literal string notation\n";
    str += ";  - accepts %s\"string\" as a case-sensitive string\n";
    str += ";  - accepts %i\"string\" as a case-insensitive string\n";
    str += ";  - accepts \"string\" as a case-insensitive string\n";
    str += ";\n";
    str += "; Some restrictions:\n";
    str += ";   1. Rules must begin at first character of each line.\n";
    str += ";      Indentations on first rule and rules thereafter are not allowed.\n";
    str += ";   2. Relaxed line endings. CRLF, LF or CR are accepted as valid line ending.\n";
    str += ";   3. Prose values, i.e. <prose value>, are accepted as valid grammar syntax.\n";
    str += ";      However, a working parser cannot be generated from them.\n";
    str += ";\n";
    str += "; Super set (SABNF) additions:\n";
    str += ";   1. Look-ahead (syntactic predicate) operators are accepted as element prefixes.\n";
    str += ";      & is the positive look-ahead operator, succeeds and backtracks if the look-ahead phrase is found\n";
    str += ";      ! is the negative look-ahead operator, succeeds and backtracks if the look-ahead phrase is NOT found\n";
    str += ";      e.g. &%d13 or &rule or !(A / B)\n";
    str += ";   2. User-Defined Terminals (UDT) of the form, u_name and e_name are accepted.\n";
    str += ";      'name' is alpha followed by alpha/num/hyphen just like a rule name.\n";
    str += ";      u_name may be used as an element but no rule definition is given.\n";
    str += ";      e.g. rule = A / u_myUdt\n";
    str += ";           A = \"a\"\n";
    str += ";      would be a valid grammar.\n";
    str += ";   3. Case-sensitive, single-quoted strings are accepted.\n";
    str += ";      e.g. 'abc' would be equivalent to %d97.98.99\n";
    str += ";      (kept for backward compatibility, but superseded by %s\"abc\")  \n";
    str += "; New 12/26/2015\n";
    str += ";   4. Look-behind operators are accepted as element prefixes.\n";
    str += ";      && is the positive look-behind operator, succeeds and backtracks if the look-behind phrase is found\n";
    str += ";      !! is the negative look-behind operator, succeeds and backtracks if the look-behind phrase is NOT found\n";
    str += ";      e.g. &&%d13 or &&rule or !!(A / B)\n";
    str += ";   5. Back reference operators, i.e. \\rulename, are accepted.\n";
    str += ";      A back reference operator acts like a TLS or TBS terminal except that the phrase it attempts\n";
    str += ";      to match is a phrase previously matched by the rule 'rulename'.\n";
    str += ";      There are two modes of previous phrase matching - the parent-frame mode and the universal mode.\n";
    str += ";      In universal mode, \\rulename matches the last match to 'rulename' regardless of where it was found.\n";
    str += ";      In parent-frame mode, \\rulename matches only the last match found on the parent's frame or parse tree level.\n";
    str += ";      Back reference modifiers can be used to specify case and mode.\n";
    str += ";      \\A defaults to case-insensitive and universal mode, e.g. \\A === \\%i%uA\n";
    str += ";      Modifiers %i and %s determine case-insensitive and case-sensitive mode, respectively.\n";
    str += ";      Modifiers %u and %p determine universal mode and parent frame mode, respectively.\n";
    str += ";      Case and mode modifiers can appear in any order, e.g. \\%s%pA === \\%p%sA. \n";
    str += ";   7. String begin anchor, ABG(%^) matches the beginning of the input string location.\n";
    str += ";      Returns EMPTY or NOMATCH. Never consumes any characters.\n";
    str += ";   8. String end anchor, AEN(%$) matches the end of the input string location.\n";
    str += ";      Returns EMPTY or NOMATCH. Never consumes any characters.\n";
    str += ";\n";
    str += "File            = *(BlankLine / Rule / RuleError)\n";
    str += "BlankLine       = *(%d32/%d9) [comment] LineEnd\n";
    str += "Rule            = RuleLookup owsp Alternation ((owsp LineEnd)\n";
    str += "                / (LineEndError LineEnd))\n";
    str += "RuleLookup      = RuleNameTest owsp DefinedAsTest\n";
    str += "RuleNameTest    = RuleName/RuleNameError\n";
    str += "RuleName        = alphanum\n";
    str += "RuleNameError   = 1*(%d33-60/%d62-126)\n";
    str += "DefinedAsTest   = DefinedAs / DefinedAsError\n";
    str += "DefinedAsError  = 1*2%d33-126\n";
    str += "DefinedAs       = IncAlt / Defined\n";
    str += "Defined         = %d61\n";
    str += "IncAlt          = %d61.47\n";
    str += "RuleError       = 1*(%d32-126 / %d9  / LineContinue) LineEnd\n";
    str += "LineEndError    = 1*(%d32-126 / %d9  / LineContinue)\n";
    str += "Alternation     = Concatenation *(owsp AltOp Concatenation)\n";
    str += "Concatenation   = Repetition *(CatOp Repetition)\n";
    str += "Repetition      = [Modifier] (Group / Option / BasicElement / BasicElementErr)\n";
    str += "Modifier        = (Predicate [RepOp])\n";
    str += "                / RepOp\n";
    str += "Predicate       = BkaOp\n";
    str += "                / BknOp\n";
    str += "                / AndOp\n";
    str += "                / NotOp\n";
    str += "BasicElement    = UdtOp\n";
    str += "                / RnmOp\n";
    str += "                / TrgOp\n";
    str += "                / TbsOp\n";
    str += "                / TlsOp\n";
    str += "                / ClsOp\n";
    str += "                / BkrOp\n";
    str += "                / AbgOp\n";
    str += "                / AenOp\n";
    str += "                / ProsVal\n";
    str += "BasicElementErr = 1*(%d33-40/%d42-46/%d48-92/%d94-126)\n";
    str += "Group           = GroupOpen  Alternation (GroupClose / GroupError)\n";
    str += "GroupError      = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\n";
    str += "GroupOpen       = %d40 owsp\n";
    str += "GroupClose      = owsp %d41\n";
    str += "Option          = OptionOpen Alternation (OptionClose / OptionError)\n";
    str += "OptionError     = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\n";
    str += "OptionOpen      = %d91 owsp\n";
    str += "OptionClose     = owsp %d93\n";
    str += "RnmOp           = alphanum\n";
    str += "BkrOp           = %d92 [bkrModifier] bkr-name\n";
    str += "bkrModifier     = (cs [um / pm]) / (ci [um / pm]) / (um [cs /ci]) / (pm [cs / ci])\n";
    str += "cs              = '%s'\n";
    str += "ci              = '%i'\n";
    str += "um              = '%u'\n";
    str += "pm              = '%p'\n";
    str += "bkr-name        = uname / ename / rname\n";
    str += "rname           = alphanum\n";
    str += "uname           = %d117.95 alphanum\n";
    str += "ename           = %d101.95 alphanum\n";
    str += "UdtOp           = udt-empty\n";
    str += "                / udt-non-empty\n";
    str += "udt-non-empty   = %d117.95 alphanum\n";
    str += "udt-empty       = %d101.95 alphanum\n";
    str += "RepOp           = (rep-min StarOp rep-max)\n";
    str += "                / (rep-min StarOp)\n";
    str += "                / (StarOp rep-max)\n";
    str += "                / StarOp\n";
    str += "                / rep-min-max\n";
    str += "AltOp           = %d47 owsp\n";
    str += "CatOp           = wsp\n";
    str += "StarOp          = %d42\n";
    str += "AndOp           = %d38\n";
    str += "NotOp           = %d33\n";
    str += "BkaOp           = %d38.38\n";
    str += "BknOp           = %d33.33\n";
    str += "AbgOp           = %d37.94\n";
    str += "AenOp           = %d37.36\n";
    str += "TrgOp           = %d37 ((Dec dmin %d45 dmax) / (Hex xmin %d45 xmax) / (Bin bmin %d45 bmax))\n";
    str += "TbsOp           = %d37 ((Dec dString *(%d46 dString)) / (Hex xString *(%d46 xString)) / (Bin bString *(%d46 bString)))\n";
    str += "TlsOp           = TlsCase TlsOpen TlsString TlsClose\n";
    str += "TlsCase         = [\"%i\" / \"%s\"]\n";
    str += "TlsOpen         = %d34\n";
    str += "TlsClose        = %d34\n";
    str += "TlsString       = *(%d32-33/%d35-126/StringTab)\n";
    str += "StringTab       = %d9\n";
    str += "ClsOp           = ClsOpen ClsString ClsClose\n";
    str += "ClsOpen         = %d39\n";
    str += "ClsClose        = %d39\n";
    str += "ClsString       = *(%d32-38/%d40-126/StringTab)\n";
    str += "ProsVal         = ProsValOpen ProsValString ProsValClose\n";
    str += "ProsValOpen     = %d60\n";
    str += "ProsValString   = *(%d32-61/%d63-126/StringTab)\n";
    str += "ProsValClose    = %d62\n";
    str += "rep-min         = rep-num\n";
    str += "rep-min-max     = rep-num\n";
    str += "rep-max         = rep-num\n";
    str += "rep-num         = 1*(%d48-57)\n";
    str += "dString         = dnum\n";
    str += "xString         = xnum\n";
    str += "bString         = bnum\n";
    str += "Dec             = (%d68/%d100)\n";
    str += "Hex             = (%d88/%d120)\n";
    str += "Bin             = (%d66/%d98)\n";
    str += "dmin            = dnum\n";
    str += "dmax            = dnum\n";
    str += "bmin            = bnum\n";
    str += "bmax            = bnum\n";
    str += "xmin            = xnum\n";
    str += "xmax            = xnum\n";
    str += "dnum            = 1*(%d48-57)\n";
    str += "bnum            = 1*%d48-49\n";
    str += "xnum            = 1*(%d48-57 / %d65-70 / %d97-102)\n";
    str += ";\n";
    str += "; Basics\n";
    str += "alphanum        = (%d97-122/%d65-90) *(%d97-122/%d65-90/%d48-57/%d45)\n";
    str += "owsp            = *space\n";
    str += "wsp             = 1*space\n";
    str += "space           = %d32\n";
    str += "                / %d9\n";
    str += "                / comment\n";
    str += "                / LineContinue\n";
    str += "comment         = %d59 *(%d32-126 / %d9)\n";
    str += "LineEnd         = %d13.10\n";
    str += "                / %d10\n";
    str += "                / %d13\n";
    str += "LineContinue    = (%d13.10 / %d10 / %d13) (%d32 / %d9)\n";
    return str;
  }
}


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/scanner-callbacks.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// These are the AST translation callback functions used by the scanner
// to analyze the characters and lines.
const ids = __webpack_require__("../../node_modules/apg-js/src/apg-lib/identifiers.js");
const utils = __webpack_require__("../../node_modules/apg-js/src/apg-lib/utilities.js");

function semLine(state, chars, phraseIndex, phraseCount, data) {
  if (state === ids.SEM_PRE) {
    data.endLength = 0;
    data.textLength = 0;
    data.invalidCount = 0;
  } else {
    data.lines.push({
      lineNo: data.lines.length,
      beginChar: phraseIndex,
      length: phraseCount,
      textLength: data.textLength,
      endType: data.endType,
      invalidChars: data.invalidCount,
    });
  }
  return ids.SEM_OK;
}
function semLineText(state, chars, phraseIndex, phraseCount, data) {
  if (state === ids.SEM_PRE) {
    data.textLength = phraseCount;
  }
  return ids.SEM_OK;
}
function semLastLine(state, chars, phraseIndex, phraseCount, data) {
  if (state === ids.SEM_PRE) {
    data.endLength = 0;
    data.textLength = 0;
    data.invalidCount = 0;
  } else if (data.strict) {
    data.lines.push({
      lineNo: data.lines.length,
      beginChar: phraseIndex,
      length: phraseCount,
      textLength: phraseCount,
      endType: 'none',
      invalidChars: data.invalidCount,
    });
    data.errors.push({
      line: data.lineNo,
      char: phraseIndex + phraseCount,
      msg: 'no line end on last line - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)',
    });
  } else {
    /* add a line ender */
    chars.push(10);
    data.lines.push({
      lineNo: data.lines.length,
      beginChar: phraseIndex,
      length: phraseCount + 1,
      textLength: phraseCount,
      endType: 'LF',
      invalidChars: data.invalidCount,
    });
  }
  return ids.SEM_OK;
}
function semInvalid(state, chars, phraseIndex, phraseCount, data) {
  if (state === ids.SEM_PRE) {
    data.errors.push({
      line: data.lineNo,
      char: phraseIndex,
      msg: `invalid character found '\\x${utils.charToHex(chars[phraseIndex])}'`,
    });
  }
  return ids.SEM_OK;
}
function semEnd(state, chars, phraseIndex, phraseCount, data) {
  if (state === ids.SEM_POST) {
    data.lineNo += 1;
  }
  return ids.SEM_OK;
}
function semLF(state, chars, phraseIndex, phraseCount, data) {
  if (state === ids.SEM_PRE) {
    data.endType = 'LF';
    if (data.strict) {
      data.errors.push({
        line: data.lineNo,
        char: phraseIndex,
        msg: 'line end character LF(\\n, \\x0A) - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)',
      });
    }
  }
  return ids.SEM_OK;
}
function semCR(state, chars, phraseIndex, phraseCount, data) {
  if (state === ids.SEM_PRE) {
    data.endType = 'CR';
    if (data.strict) {
      data.errors.push({
        line: data.lineNo,
        char: phraseIndex,
        msg: 'line end character CR(\\r, \\x0D) - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)',
      });
    }
  }
  return ids.SEM_OK;
}
function semCRLF(state, chars, phraseIndex, phraseCount, data) {
  if (state === ids.SEM_PRE) {
    data.endType = 'CRLF';
  }
  return ids.SEM_OK;
}
const callbacks = [];
callbacks.line = semLine;
callbacks['line-text'] = semLineText;
callbacks['last-line'] = semLastLine;
callbacks.invalid = semInvalid;
callbacks.end = semEnd;
callbacks.lf = semLF;
callbacks.cr = semCR;
callbacks.crlf = semCRLF;
exports.callbacks = callbacks;


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/scanner-grammar.js":
/***/ ((module) => {

// copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved<br>
//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>
//
// Generated by apg-js, Version 4.0.0 [apg-js](https://github.com/ldthomas/apg-js)
module.exports = function grammar(){
  // ```
  // SUMMARY
  //      rules = 10
  //       udts = 0
  //    opcodes = 31
  //        ---   ABNF original opcodes
  //        ALT = 5
  //        CAT = 2
  //        REP = 4
  //        RNM = 11
  //        TLS = 0
  //        TBS = 4
  //        TRG = 5
  //        ---   SABNF superset opcodes
  //        UDT = 0
  //        AND = 0
  //        NOT = 0
  //        BKA = 0
  //        BKN = 0
  //        BKR = 0
  //        ABG = 0
  //        AEN = 0
  // characters = [0 - 4294967295]
  // ```
  /* OBJECT IDENTIFIER (for internal parser use) */
  this.grammarObject = 'grammarObject';

  /* RULES */
  this.rules = [];
  this.rules[0] = {name: 'file', lower: 'file', index: 0, isBkr: false};
  this.rules[1] = {name: 'line', lower: 'line', index: 1, isBkr: false};
  this.rules[2] = {name: 'line-text', lower: 'line-text', index: 2, isBkr: false};
  this.rules[3] = {name: 'last-line', lower: 'last-line', index: 3, isBkr: false};
  this.rules[4] = {name: 'valid', lower: 'valid', index: 4, isBkr: false};
  this.rules[5] = {name: 'invalid', lower: 'invalid', index: 5, isBkr: false};
  this.rules[6] = {name: 'end', lower: 'end', index: 6, isBkr: false};
  this.rules[7] = {name: 'CRLF', lower: 'crlf', index: 7, isBkr: false};
  this.rules[8] = {name: 'LF', lower: 'lf', index: 8, isBkr: false};
  this.rules[9] = {name: 'CR', lower: 'cr', index: 9, isBkr: false};

  /* UDTS */
  this.udts = [];

  /* OPCODES */
  /* file */
  this.rules[0].opcodes = [];
  this.rules[0].opcodes[0] = {type: 2, children: [1,3]};// CAT
  this.rules[0].opcodes[1] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[0].opcodes[2] = {type: 4, index: 1};// RNM(line)
  this.rules[0].opcodes[3] = {type: 3, min: 0, max: 1};// REP
  this.rules[0].opcodes[4] = {type: 4, index: 3};// RNM(last-line)

  /* line */
  this.rules[1].opcodes = [];
  this.rules[1].opcodes[0] = {type: 2, children: [1,2]};// CAT
  this.rules[1].opcodes[1] = {type: 4, index: 2};// RNM(line-text)
  this.rules[1].opcodes[2] = {type: 4, index: 6};// RNM(end)

  /* line-text */
  this.rules[2].opcodes = [];
  this.rules[2].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
  this.rules[2].opcodes[1] = {type: 1, children: [2,3]};// ALT
  this.rules[2].opcodes[2] = {type: 4, index: 4};// RNM(valid)
  this.rules[2].opcodes[3] = {type: 4, index: 5};// RNM(invalid)

  /* last-line */
  this.rules[3].opcodes = [];
  this.rules[3].opcodes[0] = {type: 3, min: 1, max: Infinity};// REP
  this.rules[3].opcodes[1] = {type: 1, children: [2,3]};// ALT
  this.rules[3].opcodes[2] = {type: 4, index: 4};// RNM(valid)
  this.rules[3].opcodes[3] = {type: 4, index: 5};// RNM(invalid)

  /* valid */
  this.rules[4].opcodes = [];
  this.rules[4].opcodes[0] = {type: 1, children: [1,2]};// ALT
  this.rules[4].opcodes[1] = {type: 5, min: 32, max: 126};// TRG
  this.rules[4].opcodes[2] = {type: 6, string: [9]};// TBS

  /* invalid */
  this.rules[5].opcodes = [];
  this.rules[5].opcodes[0] = {type: 1, children: [1,2,3,4]};// ALT
  this.rules[5].opcodes[1] = {type: 5, min: 0, max: 8};// TRG
  this.rules[5].opcodes[2] = {type: 5, min: 11, max: 12};// TRG
  this.rules[5].opcodes[3] = {type: 5, min: 14, max: 31};// TRG
  this.rules[5].opcodes[4] = {type: 5, min: 127, max: 4294967295};// TRG

  /* end */
  this.rules[6].opcodes = [];
  this.rules[6].opcodes[0] = {type: 1, children: [1,2,3]};// ALT
  this.rules[6].opcodes[1] = {type: 4, index: 7};// RNM(CRLF)
  this.rules[6].opcodes[2] = {type: 4, index: 8};// RNM(LF)
  this.rules[6].opcodes[3] = {type: 4, index: 9};// RNM(CR)

  /* CRLF */
  this.rules[7].opcodes = [];
  this.rules[7].opcodes[0] = {type: 6, string: [13,10]};// TBS

  /* LF */
  this.rules[8].opcodes = [];
  this.rules[8].opcodes[0] = {type: 6, string: [10]};// TBS

  /* CR */
  this.rules[9].opcodes = [];
  this.rules[9].opcodes[0] = {type: 6, string: [13]};// TBS

  // The `toString()` function will display the original grammar file(s) that produced these opcodes.
  this.toString = function toString(){
    let str = "";
    str += "file = *line [last-line]\n";
    str += "line = line-text end\n";
    str += "line-text = *(valid/invalid)\n";
    str += "last-line = 1*(valid/invalid)\n";
    str += "valid = %d32-126 / %d9\n";
    str += "invalid = %d0-8 / %d11-12 /%d14-31 / %x7f-ffffffff\n";
    str += "end = CRLF / LF / CR\n";
    str += "CRLF = %d13.10\n";
    str += "LF = %d10\n";
    str += "CR = %d13\n";
    return str;
  }
}


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/scanner.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module reads the input grammar file and does a preliminary analysis
// before attempting to parse it into a grammar object.
// See:<br>
// `./dist/scanner-grammar.bnf`<br>
// for the grammar file this parser is based on.
//
// It has two primary functions.
// - verify the character codes - no non-printing ASCII characters
// - catalog the lines - create an array with a line object for each line.
// The object carries information about the line number and character length which is used
// by the parser generator primarily for error reporting.
module.exports = function exfn(chars, errors, strict, trace) {
  const thisFileName = 'scanner.js: ';
  const apglib = __webpack_require__("../../node_modules/apg-js/src/apg-lib/node-exports.js");
  const grammar = new (__webpack_require__("../../node_modules/apg-js/src/apg-api/scanner-grammar.js"))();
  const { callbacks } = __webpack_require__("../../node_modules/apg-js/src/apg-api/scanner-callbacks.js");

  /* Scan the grammar for character code errors and catalog the lines. */
  const lines = [];
  // eslint-disable-next-line new-cap
  const parser = new apglib.parser();
  // eslint-disable-next-line new-cap
  parser.ast = new apglib.ast();
  parser.ast.callbacks = callbacks;
  if (trace) {
    if (trace.traceObject !== 'traceObject') {
      throw new TypeError(`${thisFileName}trace argument is not a trace object`);
    }
    parser.trace = trace;
  }

  /* parse the input SABNF grammar */
  const test = parser.parse(grammar, 'file', chars);
  if (test.success !== true) {
    errors.push({
      line: 0,
      char: 0,
      msg: 'syntax analysis error analyzing input SABNF grammar',
    });
    return;
  }
  const data = {
    lines,
    lineNo: 0,
    errors,
    strict: !!strict,
  };

  /* translate (analyze) the input SABNF grammar */
  parser.ast.translate(data);
  // eslint-disable-next-line consistent-return
  return lines;
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/semantic-callbacks.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module has all of the AST translation callback functions for the semantic analysis
// phase of the generator.
// See:<br>
// `./dist/abnf-for-sabnf-grammar.bnf`<br>
// for the grammar file these callback functions are based on.
module.exports = function exfn() {
  const apglib = __webpack_require__("../../node_modules/apg-js/src/apg-lib/node-exports.js");
  const id = apglib.ids;

  /* Some helper functions. */
  const NameList = function NameList() {
    this.names = [];
    /* Adds a new rule name object to the list. Returns -1 if the name already exists. */
    /* Returns the added name object if the name does not already exist. */
    this.add = function add(name) {
      let ret = -1;
      const find = this.get(name);
      if (find === -1) {
        ret = {
          name,
          lower: name.toLowerCase(),
          index: this.names.length,
        };
        this.names.push(ret);
      }
      return ret;
    };
    /* Brute-force look up. */
    this.get = function get(name) {
      let ret = -1;
      const lower = name.toLowerCase();
      for (let i = 0; i < this.names.length; i += 1) {
        if (this.names[i].lower === lower) {
          ret = this.names[i];
          break;
        }
      }
      return ret;
    };
  };
  /* converts text decimal numbers from, e.g. %d99, to an integer */
  const decnum = function decnum(chars, beg, len) {
    let num = 0;
    for (let i = beg; i < beg + len; i += 1) {
      num = 10 * num + chars[i] - 48;
    }
    return num;
  };
  /* converts text binary numbers from, e.g. %b10, to an integer */
  const binnum = function binnum(chars, beg, len) {
    let num = 0;
    for (let i = beg; i < beg + len; i += 1) {
      num = 2 * num + chars[i] - 48;
    }
    return num;
  };
  /* converts text hexadecimal numbers from, e.g. %xff, to an integer */
  const hexnum = function hexnum(chars, beg, len) {
    let num = 0;
    for (let i = beg; i < beg + len; i += 1) {
      let digit = chars[i];
      if (digit >= 48 && digit <= 57) {
        digit -= 48;
      } else if (digit >= 65 && digit <= 70) {
        digit -= 55;
      } else if (digit >= 97 && digit <= 102) {
        digit -= 87;
      } else {
        throw new Error('hexnum out of range');
      }
      num = 16 * num + digit;
    }
    return num;
  };

  // This is the prototype for all semantic analysis callback functions.
  // ````
  // state - the translator state
  //   id.SEM_PRE for downward (pre-branch) traversal of the AST
  //   id.SEM_POST for upward (post branch) traversal of the AST
  // chars - the array of character codes for the input string
  // phraseIndex - index into the chars array to the first
  //               character of the phrase
  // phraseCount - the number of characters in the phrase
  // data - user-defined data passed to the translator
  //        for use by the callback functions.
  // @return id.SEM_OK, normal return.
  //         id.SEM_SKIP in state id.SEM_PRE will
  //         skip the branch below.
  //         Any thing else is an error which will
  //         stop the translation.
  // ````
  /*
  function semCallbackPrototype(state, chars, phraseIndex, phraseCount, data) {
    let ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
    } else if (state === id.SEM_POST) {
    }
    return ret;
  }
  */
  // The AST callback functions.
  function semFile(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.ruleNames = new NameList();
      data.udtNames = new NameList();
      data.rules = [];
      data.udts = [];
      data.rulesLineMap = [];
      data.opcodes = [];
      data.altStack = [];
      data.topStack = null;
      data.topRule = null;
    } else if (state === id.SEM_POST) {
      /* validate RNM rule names and set opcode rule index */
      let nameObj;
      data.rules.forEach((rule) => {
        rule.isBkr = false;
        rule.opcodes.forEach((op) => {
          if (op.type === id.RNM) {
            nameObj = data.ruleNames.get(op.index.name);
            if (nameObj === -1) {
              data.errors.push({
                line: data.findLine(data.lines, op.index.phraseIndex, data.charsLength),
                char: op.index.phraseIndex,
                msg: `Rule name '${op.index.name}' used but not defined.`,
              });
              op.index = -1;
            } else {
              op.index = nameObj.index;
            }
          }
        });
      });
      /* validate BKR rule names and set opcode rule index */
      data.udts.forEach((udt) => {
        udt.isBkr = false;
      });
      data.rules.forEach((rule) => {
        rule.opcodes.forEach((op) => {
          if (op.type === id.BKR) {
            rule.hasBkr = true;
            nameObj = data.ruleNames.get(op.index.name);
            if (nameObj !== -1) {
              data.rules[nameObj.index].isBkr = true;
              op.index = nameObj.index;
            } else {
              nameObj = data.udtNames.get(op.index.name);
              if (nameObj !== -1) {
                data.udts[nameObj.index].isBkr = true;
                op.index = data.rules.length + nameObj.index;
              } else {
                data.errors.push({
                  line: data.findLine(data.lines, op.index.phraseIndex, data.charsLength),
                  char: op.index.phraseIndex,
                  msg: `Back reference name '${op.index.name}' refers to undefined rule or unamed UDT.`,
                });
                op.index = -1;
              }
            }
          }
        });
      });
    }
    return ret;
  }
  function semRule(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.altStack.length = 0;
      data.topStack = null;
      data.rulesLineMap.push({
        line: data.findLine(data.lines, phraseIndex, data.charsLength),
        char: phraseIndex,
      });
    }
    return ret;
  }
  function semRuleLookup(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.ruleName = '';
      data.definedas = '';
    } else if (state === id.SEM_POST) {
      let ruleName;
      if (data.definedas === '=') {
        ruleName = data.ruleNames.add(data.ruleName);
        if (ruleName === -1) {
          data.definedas = null;
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: `Rule name '${data.ruleName}' previously defined.`,
          });
        } else {
          /* start a new rule */
          data.topRule = {
            name: ruleName.name,
            lower: ruleName.lower,
            opcodes: [],
            index: ruleName.index,
          };
          data.rules.push(data.topRule);
          data.opcodes = data.topRule.opcodes;
        }
      } else {
        ruleName = data.ruleNames.get(data.ruleName);
        if (ruleName === -1) {
          data.definedas = null;
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: `Rule name '${data.ruleName}' for incremental alternate not previously defined.`,
          });
        } else {
          data.topRule = data.rules[ruleName.index];
          data.opcodes = data.topRule.opcodes;
        }
      }
    }
    return ret;
  }
  function semAlternation(state, chars, phraseIndex, phraseCount, data) {
    let ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      const TRUE = true;
      while (TRUE) {
        if (data.definedas === null) {
          /* rule error - skip opcode generation */
          ret = id.SEM_SKIP;
          break;
        }
        if (data.topStack === null) {
          /* top-level ALT */
          if (data.definedas === '=') {
            /* "=" new rule */
            data.topStack = {
              alt: {
                type: id.ALT,
                children: [],
              },
              cat: null,
            };
            data.altStack.push(data.topStack);
            data.opcodes.push(data.topStack.alt);
            break;
          }
          /* "=/" incremental alternate */
          data.topStack = {
            alt: data.opcodes[0],
            cat: null,
          };
          data.altStack.push(data.topStack);
          break;
        }
        /* lower-level ALT */
        data.topStack = {
          alt: {
            type: id.ALT,
            children: [],
          },
          cat: null,
        };
        data.altStack.push(data.topStack);
        data.opcodes.push(data.topStack.alt);
        break;
      }
    } else if (state === id.SEM_POST) {
      data.altStack.pop();
      if (data.altStack.length > 0) {
        data.topStack = data.altStack[data.altStack.length - 1];
      } else {
        data.topStack = null;
      }
    }
    return ret;
  }
  function semConcatenation(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.topStack.alt.children.push(data.opcodes.length);
      data.topStack.cat = {
        type: id.CAT,
        children: [],
      };
      data.opcodes.push(data.topStack.cat);
    } else if (state === id.SEM_POST) {
      data.topStack.cat = null;
    }
    return ret;
  }
  function semRepetition(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.topStack.cat.children.push(data.opcodes.length);
    }
    return ret;
  }
  function semOptionOpen(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.opcodes.push({
        type: id.REP,
        min: 0,
        max: 1,
        char: phraseIndex,
      });
    }
    return ret;
  }
  function semRuleName(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.ruleName = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
    }
    return ret;
  }
  function semDefined(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.definedas = '=';
    }
    return ret;
  }
  function semIncAlt(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.definedas = '=/';
    }
    return ret;
  }
  function semRepOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.min = 0;
      data.max = Infinity;
      data.topRep = {
        type: id.REP,
        min: 0,
        max: Infinity,
      };
      data.opcodes.push(data.topRep);
    } else if (state === id.SEM_POST) {
      if (data.min > data.max) {
        data.errors.push({
          line: data.findLine(data.lines, phraseIndex, data.charsLength),
          char: phraseIndex,
          msg: `repetition min cannot be greater than max: min: ${data.min}: max: ${data.max}`,
        });
      }
      data.topRep.min = data.min;
      data.topRep.max = data.max;
    }
    return ret;
  }
  function semRepMin(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.min = decnum(chars, phraseIndex, phraseCount);
    }
    return ret;
  }
  function semRepMax(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.max = decnum(chars, phraseIndex, phraseCount);
    }
    return ret;
  }
  function semRepMinMax(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.max = decnum(chars, phraseIndex, phraseCount);
      data.min = data.max;
    }
    return ret;
  }
  function semAndOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.opcodes.push({
        type: id.AND,
      });
    }
    return ret;
  }
  function semNotOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.opcodes.push({
        type: id.NOT,
      });
    }
    return ret;
  }
  function semRnmOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.opcodes.push({
        type: id.RNM,
        /* NOTE: this is temporary info, index will be replaced with integer later. */
        /* Probably not the best coding practice but here you go. */
        index: {
          phraseIndex,
          name: apglib.utils.charsToString(chars, phraseIndex, phraseCount),
        },
      });
    }
    return ret;
  }
  function semAbgOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.opcodes.push({
        type: id.ABG,
      });
    }
    return ret;
  }
  function semAenOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.opcodes.push({
        type: id.AEN,
      });
    }
    return ret;
  }
  function semBkaOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.opcodes.push({
        type: id.BKA,
      });
    }
    return ret;
  }
  function semBknOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.opcodes.push({
        type: id.BKN,
      });
    }
    return ret;
  }
  function semBkrOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.ci = true; /* default to case insensitive */
      data.cs = false;
      data.um = true;
      data.pm = false;
    } else if (state === id.SEM_POST) {
      data.opcodes.push({
        type: id.BKR,
        bkrCase: data.cs === true ? id.BKR_MODE_CS : id.BKR_MODE_CI,
        bkrMode: data.pm === true ? id.BKR_MODE_PM : id.BKR_MODE_UM,
        /* NOTE: this is temporary info, index will be replaced with integer later. */
        /* Probably not the best coding practice but here you go. */
        index: {
          phraseIndex: data.bkrname.phraseIndex,
          name: apglib.utils.charsToString(chars, data.bkrname.phraseIndex, data.bkrname.phraseLength),
        },
      });
    }
    return ret;
  }
  function semBkrCi(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.ci = true;
    }
    return ret;
  }
  function semBkrCs(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.cs = true;
    }
    return ret;
  }
  function semBkrUm(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.um = true;
    }
    return ret;
  }
  function semBkrPm(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.pm = true;
    }
    return ret;
  }
  function semBkrName(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.bkrname = {
        phraseIndex,
        phraseLength: phraseCount,
      };
    }
    return ret;
  }
  function semUdtEmpty(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      const name = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
      let udtName = data.udtNames.add(name);
      if (udtName === -1) {
        udtName = data.udtNames.get(name);
        if (udtName === -1) {
          throw new Error('semUdtEmpty: name look up error');
        }
      } else {
        data.udts.push({
          name: udtName.name,
          lower: udtName.lower,
          index: udtName.index,
          empty: true,
        });
      }
      data.opcodes.push({
        type: id.UDT,
        empty: true,
        index: udtName.index,
      });
    }
    return ret;
  }
  function semUdtNonEmpty(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      const name = apglib.utils.charsToString(chars, phraseIndex, phraseCount);
      let udtName = data.udtNames.add(name);
      if (udtName === -1) {
        udtName = data.udtNames.get(name);
        if (udtName === -1) {
          throw new Error('semUdtNonEmpty: name look up error');
        }
      } else {
        data.udts.push({
          name: udtName.name,
          lower: udtName.lower,
          index: udtName.index,
          empty: false,
        });
      }
      data.opcodes.push({
        type: id.UDT,
        empty: false,
        index: udtName.index,
        syntax: null,
        semantic: null,
      });
    }
    return ret;
  }
  function semTlsOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.tlscase = true; /* default to case insensitive */
    }
    return ret;
  }
  function semTlsCase(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      if (phraseCount > 0 && (chars[phraseIndex + 1] === 83 || chars[phraseIndex + 1] === 115)) {
        data.tlscase = false; /* set to case sensitive */
      }
    }
    return ret;
  }
  function semTlsString(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      if (data.tlscase) {
        const str = chars.slice(phraseIndex, phraseIndex + phraseCount);
        for (let i = 0; i < str.length; i += 1) {
          if (str[i] >= 65 && str[i] <= 90) {
            str[i] += 32;
          }
        }
        data.opcodes.push({
          type: id.TLS,
          string: str,
        });
      } else {
        data.opcodes.push({
          type: id.TBS,
          string: chars.slice(phraseIndex, phraseIndex + phraseCount),
        });
      }
    }
    return ret;
  }
  function semClsOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      if (phraseCount <= 2) {
        /* only TLS is allowed to be empty */
        data.opcodes.push({
          type: id.TLS,
          string: [],
        });
      } else {
        data.opcodes.push({
          type: id.TBS,
          string: chars.slice(phraseIndex + 1, phraseIndex + phraseCount - 1),
        });
      }
    }
    return ret;
  }
  function semTbsOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.tbsstr = [];
    } else if (state === id.SEM_POST) {
      data.opcodes.push({
        type: id.TBS,
        string: data.tbsstr,
      });
    }
    return ret;
  }
  function semTrgOp(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_PRE) {
      data.min = 0;
      data.max = 0;
    } else if (state === id.SEM_POST) {
      if (data.min > data.max) {
        data.errors.push({
          line: data.findLine(data.lines, phraseIndex, data.charsLength),
          char: phraseIndex,
          msg: `TRG, (%dmin-max), min cannot be greater than max: min: ${data.min}: max: ${data.max}`,
        });
      }
      data.opcodes.push({
        type: id.TRG,
        min: data.min,
        max: data.max,
      });
    }
    return ret;
  }
  function semDmin(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.min = decnum(chars, phraseIndex, phraseCount);
    }
    return ret;
  }
  function semDmax(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.max = decnum(chars, phraseIndex, phraseCount);
    }
    return ret;
  }
  function semBmin(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.min = binnum(chars, phraseIndex, phraseCount);
    }
    return ret;
  }
  function semBmax(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.max = binnum(chars, phraseIndex, phraseCount);
    }
    return ret;
  }
  function semXmin(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.min = hexnum(chars, phraseIndex, phraseCount);
    }
    return ret;
  }
  function semXmax(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.max = hexnum(chars, phraseIndex, phraseCount);
    }
    return ret;
  }
  function semDstring(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.tbsstr.push(decnum(chars, phraseIndex, phraseCount));
    }
    return ret;
  }
  function semBstring(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.tbsstr.push(binnum(chars, phraseIndex, phraseCount));
    }
    return ret;
  }
  function semXstring(state, chars, phraseIndex, phraseCount, data) {
    const ret = id.SEM_OK;
    if (state === id.SEM_POST) {
      data.tbsstr.push(hexnum(chars, phraseIndex, phraseCount));
    }
    return ret;
  }
  // Define the callback functions to the AST object.
  this.callbacks = [];
  this.callbacks.abgop = semAbgOp;
  this.callbacks.aenop = semAenOp;
  this.callbacks.alternation = semAlternation;
  this.callbacks.andop = semAndOp;
  this.callbacks.bmax = semBmax;
  this.callbacks.bmin = semBmin;
  this.callbacks.bkaop = semBkaOp;
  this.callbacks.bknop = semBknOp;
  this.callbacks.bkrop = semBkrOp;
  this.callbacks['bkr-name'] = semBkrName;
  this.callbacks.bstring = semBstring;
  this.callbacks.clsop = semClsOp;
  this.callbacks.ci = semBkrCi;
  this.callbacks.cs = semBkrCs;
  this.callbacks.um = semBkrUm;
  this.callbacks.pm = semBkrPm;
  this.callbacks.concatenation = semConcatenation;
  this.callbacks.defined = semDefined;
  this.callbacks.dmax = semDmax;
  this.callbacks.dmin = semDmin;
  this.callbacks.dstring = semDstring;
  this.callbacks.file = semFile;
  this.callbacks.incalt = semIncAlt;
  this.callbacks.notop = semNotOp;
  this.callbacks.optionopen = semOptionOpen;
  this.callbacks['rep-max'] = semRepMax;
  this.callbacks['rep-min'] = semRepMin;
  this.callbacks['rep-min-max'] = semRepMinMax;
  this.callbacks.repetition = semRepetition;
  this.callbacks.repop = semRepOp;
  this.callbacks.rnmop = semRnmOp;
  this.callbacks.rule = semRule;
  this.callbacks.rulelookup = semRuleLookup;
  this.callbacks.rulename = semRuleName;
  this.callbacks.tbsop = semTbsOp;
  this.callbacks.tlscase = semTlsCase;
  this.callbacks.tlsstring = semTlsString;
  this.callbacks.tlsop = semTlsOp;
  this.callbacks.trgop = semTrgOp;
  this.callbacks['udt-empty'] = semUdtEmpty;
  this.callbacks['udt-non-empty'] = semUdtNonEmpty;
  this.callbacks.xmax = semXmax;
  this.callbacks.xmin = semXmin;
  this.callbacks.xstring = semXstring;
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/show-rules.js":
/***/ ((module) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
module.exports = (function exfn() {
  const thisFileName = 'show-rules.js';
  // Display the rules.
  // This function may be called before the attributes calculation.
  // Sorting is done independently from the attributes.
  // - order
  //      - "index" or "i", index order (default)
  //      - "alpha" or "a", alphabetical order
  //      - none of above, index order (default)
  const showRules = function showRules(rulesIn = [], udtsIn = [], order = 'index') {
    const thisFuncName = 'showRules';
    let alphaArray = [];
    let udtAlphaArray = [];
    const indexArray = [];
    const udtIndexArray = [];
    const rules = rulesIn;
    const udts = udtsIn;
    const ruleCount = rulesIn.length;
    const udtCount = udtsIn.length;
    let str = 'RULE/UDT NAMES';
    let i;
    function compRulesAlpha(left, right) {
      if (rules[left].lower < rules[right].lower) {
        return -1;
      }
      if (rules[left].lower > rules[right].lower) {
        return 1;
      }
      return 0;
    }
    function compUdtsAlpha(left, right) {
      if (udts[left].lower < udts[right].lower) {
        return -1;
      }
      if (udts[left].lower > udts[right].lower) {
        return 1;
      }
      return 0;
    }
    if (!(Array.isArray(rulesIn) && rulesIn.length)) {
      throw new Error(`${thisFileName}:${thisFuncName}: rules arg must be array with length > 0`);
    }
    if (!Array.isArray(udtsIn)) {
      throw new Error(`${thisFileName}:${thisFuncName}: udts arg must be array`);
    }

    for (i = 0; i < ruleCount; i += 1) {
      indexArray.push(i);
    }
    alphaArray = indexArray.slice(0);
    alphaArray.sort(compRulesAlpha);
    if (udtCount) {
      for (i = 0; i < udtCount; i += 1) {
        udtIndexArray.push(i);
      }
      udtAlphaArray = udtIndexArray.slice(0);
      udtAlphaArray.sort(compUdtsAlpha);
    }
    if (order.charCodeAt(0) === 97) {
      str += ' - alphabetical by rule/UDT name\n';
      for (i = 0; i < ruleCount; i += 1) {
        str += `${i}: ${alphaArray[i]}: ${rules[alphaArray[i]].name}\n`;
      }
      if (udtCount) {
        for (i = 0; i < udtCount; i += 1) {
          str += `${i}: ${udtAlphaArray[i]}: ${udts[udtAlphaArray[i]].name}\n`;
        }
      }
    } else {
      str += ' - ordered by rule/UDT index\n';
      for (i = 0; i < ruleCount; i += 1) {
        str += `${i}: ${rules[i].name}\n`;
      }
      if (udtCount) {
        for (i = 0; i < udtCount; i += 1) {
          str += `${i}: ${udts[i].name}\n`;
        }
      }
    }
    return str;
  };
  return showRules;
})();


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-api/syntax-callbacks.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable func-names */
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module has all of the callback functions for the syntax phase of the generation.
// See:<br>
// `./dist/abnf-for-sabnf-grammar.bnf`<br>
// for the grammar file these callback functions are based on.
module.exports = function exfn() {
  const thisFileName = 'syntax-callbacks.js: ';
  const apglib = __webpack_require__("../../node_modules/apg-js/src/apg-lib/node-exports.js");
  const id = apglib.ids;
  let topAlt;
  /* syntax, RNM, callback functions */
  const synFile = function synFile(result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        data.altStack = [];
        data.repCount = 0;
        break;
      case id.EMPTY:
        data.errors.push({
          line: 0,
          char: 0,
          msg: 'grammar file is empty',
        });
        break;
      case id.MATCH:
        if (data.ruleCount === 0) {
          data.errors.push({
            line: 0,
            char: 0,
            msg: 'no rules defined',
          });
        }
        break;
      case id.NOMATCH:
        throw new Error(`${thisFileName}synFile: grammar file NOMATCH: design error: should never happen.`);
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  // eslint-disable-next-line func-names
  const synRule = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        data.altStack.length = 0;
        topAlt = {
          groupOpen: null,
          groupError: false,
          optionOpen: null,
          optionError: false,
          tlsOpen: null,
          clsOpen: null,
          prosValOpen: null,
          basicError: false,
        };
        data.altStack.push(topAlt);
        break;
      case id.EMPTY:
        throw new Error(`${thisFileName}synRule: EMPTY: rule cannot be empty`);
      case id.NOMATCH:
        break;
      case id.MATCH:
        data.ruleCount += 1;
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synRuleError = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        data.errors.push({
          line: data.findLine(data.lines, phraseIndex, data.charsLength),
          char: phraseIndex,
          msg: 'Unrecognized SABNF line. Invalid rule, comment or blank line.',
        });
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synRuleNameError = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        data.errors.push({
          line: data.findLine(data.lines, phraseIndex, data.charsLength),
          char: phraseIndex,
          msg: 'Rule names must be alphanum and begin with alphabetic character.',
        });
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synDefinedAsError = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        data.errors.push({
          line: data.findLine(data.lines, phraseIndex, data.charsLength),
          char: phraseIndex,
          msg: "Expected '=' or '=/'. Not found.",
        });
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synAndOp = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.strict) {
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: 'AND operator(&) found - strict ABNF specified.',
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synNotOp = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.strict) {
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: 'NOT operator(!) found - strict ABNF specified.',
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synBkaOp = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.strict) {
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: 'Positive look-behind operator(&&) found - strict ABNF specified.',
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synBknOp = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.strict) {
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: 'Negative look-behind operator(!!) found - strict ABNF specified.',
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synAbgOp = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.strict) {
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: 'Beginning of string anchor(%^) found - strict ABNF specified.',
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synAenOp = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.strict) {
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: 'End of string anchor(%$) found - strict ABNF specified.',
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synBkrOp = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.strict) {
          const name = apglib.utils.charsToString(chars, phraseIndex, result.phraseLength);
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: `Back reference operator(${name}) found - strict ABNF specified.`,
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synUdtOp = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.strict) {
          const name = apglib.utils.charsToString(chars, phraseIndex, result.phraseLength);
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: `UDT operator found(${name}) - strict ABNF specified.`,
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synTlsOpen = function (result, chars, phraseIndex) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        topAlt.tlsOpen = phraseIndex;
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synTlsString = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        data.stringTabChar = false;
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.stringTabChar !== false) {
          data.errors.push({
            line: data.findLine(data.lines, data.stringTabChar),
            char: data.stringTabChar,
            msg: "Tab character (\\t, x09) not allowed in literal string (see 'quoted-string' definition, RFC 7405.)",
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synStringTab = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        data.stringTabChar = phraseIndex;
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synTlsClose = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        data.errors.push({
          line: data.findLine(data.lines, topAlt.tlsOpen),
          char: topAlt.tlsOpen,
          msg: 'Case-insensitive literal string("...") opened but not closed.',
        });
        topAlt.basicError = true;
        topAlt.tlsOpen = null;
        break;
      case id.MATCH:
        topAlt.tlsOpen = null;
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synClsOpen = function (result, chars, phraseIndex) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        topAlt.clsOpen = phraseIndex;
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synClsString = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        data.stringTabChar = false;
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.stringTabChar !== false) {
          data.errors.push({
            line: data.findLine(data.lines, data.stringTabChar),
            char: data.stringTabChar,
            msg: 'Tab character (\\t, x09) not allowed in literal string.',
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synClsClose = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        data.errors.push({
          line: data.findLine(data.lines, topAlt.clsOpen),
          char: topAlt.clsOpen,
          msg: "Case-sensitive literal string('...') opened but not closed.",
        });
        topAlt.clsOpen = null;
        topAlt.basicError = true;
        break;
      case id.MATCH:
        if (data.strict) {
          data.errors.push({
            line: data.findLine(data.lines, topAlt.clsOpen),
            char: topAlt.clsOpen,
            msg: "Case-sensitive string operator('...') found - strict ABNF specified.",
          });
        }
        topAlt.clsOpen = null;
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synProsValOpen = function (result, chars, phraseIndex) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        topAlt.prosValOpen = phraseIndex;
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synProsValString = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        data.stringTabChar = false;
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (data.stringTabChar !== false) {
          data.errors.push({
            line: data.findLine(data.lines, data.stringTabChar),
            char: data.stringTabChar,
            msg: 'Tab character (\\t, x09) not allowed in prose value string.',
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synProsValClose = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        data.errors.push({
          line: data.findLine(data.lines, topAlt.prosValOpen),
          char: topAlt.prosValOpen,
          msg: 'Prose value operator(<...>) opened but not closed.',
        });
        topAlt.basicError = true;
        topAlt.prosValOpen = null;
        break;
      case id.MATCH:
        data.errors.push({
          line: data.findLine(data.lines, topAlt.prosValOpen),
          char: topAlt.prosValOpen,
          msg: 'Prose value operator(<...>) found. The ABNF syntax is valid, but a parser cannot be generated from this grammar.',
        });
        topAlt.prosValOpen = null;
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synGroupOpen = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        topAlt = {
          groupOpen: phraseIndex,
          groupError: false,
          optionOpen: null,
          optionError: false,
          tlsOpen: null,
          clsOpen: null,
          prosValOpen: null,
          basicError: false,
        };
        data.altStack.push(topAlt);
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synGroupClose = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        data.errors.push({
          line: data.findLine(data.lines, topAlt.groupOpen),
          char: topAlt.groupOpen,
          msg: 'Group "(...)" opened but not closed.',
        });
        topAlt = data.altStack.pop();
        topAlt.groupError = true;
        break;
      case id.MATCH:
        topAlt = data.altStack.pop();
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synOptionOpen = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        topAlt = {
          groupOpen: null,
          groupError: false,
          optionOpen: phraseIndex,
          optionError: false,
          tlsOpen: null,
          clsOpen: null,
          prosValOpen: null,
          basicError: false,
        };
        data.altStack.push(topAlt);
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synOptionClose = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        data.errors.push({
          line: data.findLine(data.lines, topAlt.optionOpen),
          char: topAlt.optionOpen,
          msg: 'Option "[...]" opened but not closed.',
        });
        topAlt = data.altStack.pop();
        topAlt.optionError = true;
        break;
      case id.MATCH:
        topAlt = data.altStack.pop();
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synBasicElementError = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (topAlt.basicError === false) {
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: 'Unrecognized SABNF element.',
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synLineEnd = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        if (result.phraseLength === 1 && data.strict) {
          const end = chars[phraseIndex] === 13 ? 'CR' : 'LF';
          data.errors.push({
            line: data.findLine(data.lines, phraseIndex, data.charsLength),
            char: phraseIndex,
            msg: `Line end '${end}' found - strict ABNF specified, only CRLF allowed.`,
          });
        }
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synLineEndError = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        break;
      case id.MATCH:
        data.errors.push({
          line: data.findLine(data.lines, phraseIndex, data.charsLength),
          char: phraseIndex,
          msg: 'Unrecognized grammar element or characters.',
        });
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  const synRepetition = function (result, chars, phraseIndex, data) {
    switch (result.state) {
      case id.ACTIVE:
        break;
      case id.EMPTY:
        break;
      case id.NOMATCH:
        data.repCount += 1;
        break;
      case id.MATCH:
        data.repCount += 1;
        break;
      default:
        throw new Error(`${thisFileName}synFile: unrecognized case.`);
    }
  };
  // Define the list of callback functions.
  this.callbacks = [];
  this.callbacks.andop = synAndOp;
  this.callbacks.basicelementerr = synBasicElementError;
  this.callbacks.clsclose = synClsClose;
  this.callbacks.clsopen = synClsOpen;
  this.callbacks.clsstring = synClsString;
  this.callbacks.definedaserror = synDefinedAsError;
  this.callbacks.file = synFile;
  this.callbacks.groupclose = synGroupClose;
  this.callbacks.groupopen = synGroupOpen;
  this.callbacks.lineenderror = synLineEndError;
  this.callbacks.lineend = synLineEnd;
  this.callbacks.notop = synNotOp;
  this.callbacks.optionclose = synOptionClose;
  this.callbacks.optionopen = synOptionOpen;
  this.callbacks.prosvalclose = synProsValClose;
  this.callbacks.prosvalopen = synProsValOpen;
  this.callbacks.prosvalstring = synProsValString;
  this.callbacks.repetition = synRepetition;
  this.callbacks.rule = synRule;
  this.callbacks.ruleerror = synRuleError;
  this.callbacks.rulenameerror = synRuleNameError;
  this.callbacks.stringtab = synStringTab;
  this.callbacks.tlsclose = synTlsClose;
  this.callbacks.tlsopen = synTlsOpen;
  this.callbacks.tlsstring = synTlsString;
  this.callbacks.udtop = synUdtOp;
  this.callbacks.bkaop = synBkaOp;
  this.callbacks.bknop = synBknOp;
  this.callbacks.bkrop = synBkrOp;
  this.callbacks.abgop = synAbgOp;
  this.callbacks.aenop = synAenOp;
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-conv-api/converter.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module exposes the public encoding, decoding and conversion functions.
// Its private functions provide the disassembling and interpetation of the source and destination encoding types.
// In the case of Unicode encodings, private functions determine the presence of Byte Order Marks (BOMs), if any.
//
// Throws "TypeError" exceptions on input errors.
//

'use strict;';

const thisThis = this;
const trans = __webpack_require__("../../node_modules/apg-js/src/apg-conv-api/transformers.js");

/* types */
const UTF8 = 'UTF8';
const UTF16 = 'UTF16';
const UTF16BE = 'UTF16BE';
const UTF16LE = 'UTF16LE';
const UTF32 = 'UTF32';
const UTF32BE = 'UTF32BE';
const UTF32LE = 'UTF32LE';
const UINT7 = 'UINT7';
const ASCII = 'ASCII';
const BINARY = 'BINARY';
const UINT8 = 'UINT8';
const UINT16 = 'UINT16';
const UINT16LE = 'UINT16LE';
const UINT16BE = 'UINT16BE';
const UINT32 = 'UINT32';
const UINT32LE = 'UINT32LE';
const UINT32BE = 'UINT32BE';
const ESCAPED = 'ESCAPED';
const STRING = 'STRING';

/* private functions */
// Find the UTF8 BOM, if any.
const bom8 = function bom8(src) {
  src.type = UTF8;
  const buf = src.data;
  src.bom = 0;
  if (buf.length >= 3) {
    if (buf[0] === 0xef && buf[1] === 0xbb && buf[2] === 0xbf) {
      src.bom = 3;
    }
  }
};
// Find the UTF16 BOM, if any, and determine the UTF16 type.
// Defaults to UTF16BE.
// Throws TypeError exception if BOM does not match the specified type.
const bom16 = function bom16(src) {
  const buf = src.data;
  src.bom = 0;
  switch (src.type) {
    case UTF16:
      src.type = UTF16BE;
      if (buf.length >= 2) {
        if (buf[0] === 0xfe && buf[1] === 0xff) {
          src.bom = 2;
        } else if (buf[0] === 0xff && buf[1] === 0xfe) {
          src.type = UTF16LE;
          src.bom = 2;
        }
      }
      break;
    case UTF16BE:
      src.type = UTF16BE;
      if (buf.length >= 2) {
        if (buf[0] === 0xfe && buf[1] === 0xff) {
          src.bom = 2;
        } else if (buf[0] === 0xff && buf[1] === 0xfe) {
          throw new TypeError(`src type: "${UTF16BE}" specified but BOM is for "${UTF16LE}"`);
        }
      }
      break;
    case UTF16LE:
      src.type = UTF16LE;
      if (buf.length >= 0) {
        if (buf[0] === 0xfe && buf[1] === 0xff) {
          throw new TypeError(`src type: "${UTF16LE}" specified but BOM is for "${UTF16BE}"`);
        } else if (buf[0] === 0xff && buf[1] === 0xfe) {
          src.bom = 2;
        }
      }
      break;
    default:
      throw new TypeError(`UTF16 BOM: src type "${src.type}" unrecognized`);
  }
};
// Find the UTF32 BOM, if any, and determine the UTF32 type.
// Defaults to UTF32BE.
// Throws exception if BOM does not match the specified type.
const bom32 = function bom32(src) {
  const buf = src.data;
  src.bom = 0;
  switch (src.type) {
    case UTF32:
      src.type = UTF32BE;
      if (buf.length >= 4) {
        if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) {
          src.bom = 4;
        }
        if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) {
          src.type = UTF32LE;
          src.bom = 4;
        }
      }
      break;
    case UTF32BE:
      src.type = UTF32BE;
      if (buf.length >= 4) {
        if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) {
          src.bom = 4;
        }
        if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) {
          throw new TypeError(`src type: ${UTF32BE} specified but BOM is for ${UTF32LE}"`);
        }
      }
      break;
    case UTF32LE:
      src.type = UTF32LE;
      if (buf.length >= 4) {
        if (buf[0] === 0 && buf[1] === 0 && buf[2] === 0xfe && buf[3] === 0xff) {
          throw new TypeError(`src type: "${UTF32LE}" specified but BOM is for "${UTF32BE}"`);
        }
        if (buf[0] === 0xff && buf[1] === 0xfe && buf[2] === 0 && buf[3] === 0) {
          src.bom = 4;
        }
      }
      break;
    default:
      throw new TypeError(`UTF32 BOM: src type "${src.type}" unrecognized`);
  }
};
// Validates the source encoding type and matching data.
// If the BASE64: prefix is present, the base 64 decoding is done here as the initial step.
// - For type STRING, data must be a JavaScript string.
// - For type BASE64:*, data may be a string or Buffer.
// - For all other types, data must be a Buffer.
// - The BASE64: prefix is not allowed for type STRING.
const validateSrc = function validateSrc(type, data) {
  function getType(typeArg) {
    const ret = {
      type: '',
      base64: false,
    };
    const rx = /^(base64:)?([a-zA-Z0-9]+)$/i;
    const result = rx.exec(typeArg);
    if (result) {
      if (result[2]) {
        ret.type = result[2].toUpperCase();
      }
      if (result[1]) {
        ret.base64 = true;
      }
    }
    return ret;
  }
  if (typeof type !== 'string' || type === '') {
    throw new TypeError(`type: "${type}" not recognized`);
  }
  const ret = getType(type.toUpperCase());
  if (ret.base64) {
    /* handle base 64 */
    if (ret.type === STRING) {
      throw new TypeError(`type: "${type} "BASE64:" prefix not allowed with type ${STRING}`);
    }
    if (Buffer.isBuffer(data)) {
      ret.data = trans.base64.decode(data);
    } else if (typeof data === 'string') {
      const buf = Buffer.from(data, 'ascii');
      ret.data = trans.base64.decode(buf);
    } else {
      throw new TypeError(`type: "${type} unrecognized data type: typeof(data): ${typeof data}`);
    }
  } else {
    ret.data = data;
  }
  switch (ret.type) {
    case UTF8:
      bom8(ret);
      break;
    case UTF16:
    case UTF16BE:
    case UTF16LE:
      bom16(ret);
      break;
    case UTF32:
    case UTF32BE:
    case UTF32LE:
      bom32(ret);
      break;
    case UINT16:
      ret.type = UINT16BE;
      break;
    case UINT32:
      ret.type = UINT32BE;
      break;
    case ASCII:
      ret.type = UINT7;
      break;
    case BINARY:
      ret.type = UINT8;
      break;
    case UINT7:
    case UINT8:
    case UINT16LE:
    case UINT16BE:
    case UINT32LE:
    case UINT32BE:
    case STRING:
    case ESCAPED:
      break;
    default:
      throw new TypeError(`type: "${type}" not recognized`);
  }
  if (ret.type === STRING) {
    if (typeof ret.data !== 'string') {
      throw new TypeError(`type: "${type}" but data is not a string`);
    }
  } else if (!Buffer.isBuffer(ret.data)) {
    throw new TypeError(`type: "${type}" but data is not a Buffer`);
  }
  return ret;
};
// Disassembles and validates the destination type.
// `chars` must be an Array of integers.
// The :BASE64 suffix is not allowed for type STRING.
const validateDst = function validateDst(type, chars) {
  function getType(typeArg) {
    let fix;
    let rem;
    const ret = {
      crlf: false,
      lf: false,
      base64: false,
      type: '',
    };
    /* prefix, if any */
    const TRUE = true;
    while (TRUE) {
      rem = typeArg;
      fix = typeArg.slice(0, 5);
      if (fix === 'CRLF:') {
        ret.crlf = true;
        rem = typeArg.slice(5);
        break;
      }
      fix = typeArg.slice(0, 3);
      if (fix === 'LF:') {
        ret.lf = true;
        rem = typeArg.slice(3);
        break;
      }
      break;
    }
    /* suffix, if any */
    fix = rem.split(':');
    if (fix.length === 1) {
      // eslint-disable-next-line prefer-destructuring
      ret.type = fix[0];
    } else if (fix.length === 2 && fix[1] === 'BASE64') {
      ret.base64 = true;
      // eslint-disable-next-line prefer-destructuring
      ret.type = fix[0];
    }
    return ret;
  }
  if (!Array.isArray(chars)) {
    throw new TypeError(`dst chars: not array: "${typeof chars}`);
  }
  if (typeof type !== 'string') {
    throw new TypeError(`dst type: not string: "${typeof type}`);
  }
  const ret = getType(type.toUpperCase());
  switch (ret.type) {
    case UTF8:
    case UTF16BE:
    case UTF16LE:
    case UTF32BE:
    case UTF32LE:
    case UINT7:
    case UINT8:
    case UINT16LE:
    case UINT16BE:
    case UINT32LE:
    case UINT32BE:
    case ESCAPED:
      break;
    case STRING:
      if (ret.base64) {
        throw new TypeError(`":BASE64" suffix not allowed with type ${STRING}`);
      }
      break;
    case ASCII:
      ret.type = UINT7;
      break;
    case BINARY:
      ret.type = UINT8;
      break;
    case UTF16:
      ret.type = UTF16BE;
      break;
    case UTF32:
      ret.type = UTF32BE;
      break;
    case UINT16:
      ret.type = UINT16BE;
      break;
    case UINT32:
      ret.type = UINT32BE;
      break;
    default:
      throw new TypeError(`dst type unrecognized: "${type}" : must have form [crlf:|lf:]type[:base64]`);
  }
  return ret;
};
// Select and call the requested encoding function.
const encode = function encode(type, chars) {
  switch (type) {
    case UTF8:
      return trans.utf8.encode(chars);
    case UTF16BE:
      return trans.utf16be.encode(chars);
    case UTF16LE:
      return trans.utf16le.encode(chars);
    case UTF32BE:
      return trans.utf32be.encode(chars);
    case UTF32LE:
      return trans.utf32le.encode(chars);
    case UINT7:
      return trans.uint7.encode(chars);
    case UINT8:
      return trans.uint8.encode(chars);
    case UINT16BE:
      return trans.uint16be.encode(chars);
    case UINT16LE:
      return trans.uint16le.encode(chars);
    case UINT32BE:
      return trans.uint32be.encode(chars);
    case UINT32LE:
      return trans.uint32le.encode(chars);
    case STRING:
      return trans.string.encode(chars);
    case ESCAPED:
      return trans.escaped.encode(chars);
    default:
      throw new TypeError(`encode type "${type}" not recognized`);
  }
};
// Select and call the requested decoding function.
// `src` contains BOM information as well as the source type and data.
const decode = function decode(src) {
  switch (src.type) {
    case UTF8:
      return trans.utf8.decode(src.data, src.bom);
    case UTF16LE:
      return trans.utf16le.decode(src.data, src.bom);
    case UTF16BE:
      return trans.utf16be.decode(src.data, src.bom);
    case UTF32BE:
      return trans.utf32be.decode(src.data, src.bom);
    case UTF32LE:
      return trans.utf32le.decode(src.data, src.bom);
    case UINT7:
      return trans.uint7.decode(src.data);
    case UINT8:
      return trans.uint8.decode(src.data);
    case UINT16BE:
      return trans.uint16be.decode(src.data);
    case UINT16LE:
      return trans.uint16le.decode(src.data);
    case UINT32BE:
      return trans.uint32be.decode(src.data);
    case UINT32LE:
      return trans.uint32le.decode(src.data);
    case STRING:
      return trans.string.decode(src.data);
    case ESCAPED:
      return trans.escaped.decode(src.data);
    default:
      throw new TypeError(`decode type "${src.type}" not recognized`);
  }
};

// The public decoding function. Returns an array of integers.
exports.decode = function exportsDecode(type, data) {
  const src = validateSrc(type, data);
  return decode(src);
};
// The public encoding function. Returns a Buffer-typed byte array.
exports.encode = function exportsEncode(type, chars) {
  let c;
  let buf;
  const dst = validateDst(type, chars);
  if (dst.crlf) {
    /* prefix with CRLF line end conversion, don't contaminate caller's chars array */
    c = trans.lineEnds.crlf(chars);
    buf = encode(dst.type, c);
  } else if (dst.lf) {
    /* prefix with LF line end conversion, don't contaminate caller's chars array */
    c = trans.lineEnds.lf(chars);
    buf = encode(dst.type, c);
  } else {
    buf = encode(dst.type, chars);
  }
  if (dst.base64) {
    /* post base 64 encoding */
    buf = trans.base64.encode(buf);
  }
  return buf;
};
// Converts data of type `srcType` to data of type `dstType`.
// `srcData` may be a JavaScript String, or node.js Buffer, depending on the corresponding type.
exports.convert = function convert(srcType, srcData, dstType) {
  return thisThis.encode(dstType, thisThis.decode(srcType, srcData));
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-conv-api/transformers.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];
/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
/* eslint-disable no-bitwise */
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module contains the actual encoding and decoding algorithms.
// Throws "RangeError" exceptions on characters or bytes out of range for the given encoding.

'use strict;';

const thisThis = this;

/* decoding error codes */
const NON_SHORTEST = 0xfffffffc;
const TRAILING = 0xfffffffd;
const RANGE = 0xfffffffe;
const ILL_FORMED = 0xffffffff;

/* mask[n] = 2**n - 1, ie. mask[n] = n bits on. e.g. mask[6] = %b111111 */
const mask = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023];

/* ascii[n] = 'HH', where 0xHH = n, eg. ascii[254] = 'FE' */
const ascii = [
  '00',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '0A',
  '0B',
  '0C',
  '0D',
  '0E',
  '0F',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '1A',
  '1B',
  '1C',
  '1D',
  '1E',
  '1F',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '2A',
  '2B',
  '2C',
  '2D',
  '2E',
  '2F',
  '30',
  '31',
  '32',
  '33',
  '34',
  '35',
  '36',
  '37',
  '38',
  '39',
  '3A',
  '3B',
  '3C',
  '3D',
  '3E',
  '3F',
  '40',
  '41',
  '42',
  '43',
  '44',
  '45',
  '46',
  '47',
  '48',
  '49',
  '4A',
  '4B',
  '4C',
  '4D',
  '4E',
  '4F',
  '50',
  '51',
  '52',
  '53',
  '54',
  '55',
  '56',
  '57',
  '58',
  '59',
  '5A',
  '5B',
  '5C',
  '5D',
  '5E',
  '5F',
  '60',
  '61',
  '62',
  '63',
  '64',
  '65',
  '66',
  '67',
  '68',
  '69',
  '6A',
  '6B',
  '6C',
  '6D',
  '6E',
  '6F',
  '70',
  '71',
  '72',
  '73',
  '74',
  '75',
  '76',
  '77',
  '78',
  '79',
  '7A',
  '7B',
  '7C',
  '7D',
  '7E',
  '7F',
  '80',
  '81',
  '82',
  '83',
  '84',
  '85',
  '86',
  '87',
  '88',
  '89',
  '8A',
  '8B',
  '8C',
  '8D',
  '8E',
  '8F',
  '90',
  '91',
  '92',
  '93',
  '94',
  '95',
  '96',
  '97',
  '98',
  '99',
  '9A',
  '9B',
  '9C',
  '9D',
  '9E',
  '9F',
  'A0',
  'A1',
  'A2',
  'A3',
  'A4',
  'A5',
  'A6',
  'A7',
  'A8',
  'A9',
  'AA',
  'AB',
  'AC',
  'AD',
  'AE',
  'AF',
  'B0',
  'B1',
  'B2',
  'B3',
  'B4',
  'B5',
  'B6',
  'B7',
  'B8',
  'B9',
  'BA',
  'BB',
  'BC',
  'BD',
  'BE',
  'BF',
  'C0',
  'C1',
  'C2',
  'C3',
  'C4',
  'C5',
  'C6',
  'C7',
  'C8',
  'C9',
  'CA',
  'CB',
  'CC',
  'CD',
  'CE',
  'CF',
  'D0',
  'D1',
  'D2',
  'D3',
  'D4',
  'D5',
  'D6',
  'D7',
  'D8',
  'D9',
  'DA',
  'DB',
  'DC',
  'DD',
  'DE',
  'DF',
  'E0',
  'E1',
  'E2',
  'E3',
  'E4',
  'E5',
  'E6',
  'E7',
  'E8',
  'E9',
  'EA',
  'EB',
  'EC',
  'ED',
  'EE',
  'EF',
  'F0',
  'F1',
  'F2',
  'F3',
  'F4',
  'F5',
  'F6',
  'F7',
  'F8',
  'F9',
  'FA',
  'FB',
  'FC',
  'FD',
  'FE',
  'FF',
];

/* vector of base 64 characters */
const base64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='.split('');

/* vector of base 64 character codes */
const base64codes = [];
base64chars.forEach((char) => {
  base64codes.push(char.charCodeAt(0));
});

// The UTF8 algorithms.
exports.utf8 = {
  encode(chars) {
    const bytes = [];
    chars.forEach((char) => {
      if (char >= 0 && char <= 0x7f) {
        bytes.push(char);
      } else if (char <= 0x7ff) {
        bytes.push(0xc0 + ((char >> 6) & mask[5]));
        bytes.push(0x80 + (char & mask[6]));
      } else if (char < 0xd800 || (char > 0xdfff && char <= 0xffff)) {
        bytes.push(0xe0 + ((char >> 12) & mask[4]));
        bytes.push(0x80 + ((char >> 6) & mask[6]));
        bytes.push(0x80 + (char & mask[6]));
      } else if (char >= 0x10000 && char <= 0x10ffff) {
        const u = (char >> 16) & mask[5];
        bytes.push(0xf0 + (u >> 2));
        bytes.push(0x80 + ((u & mask[2]) << 4) + ((char >> 12) & mask[4]));
        bytes.push(0x80 + ((char >> 6) & mask[6]));
        bytes.push(0x80 + (char & mask[6]));
      } else {
        throw new RangeError(`utf8.encode: character out of range: char: ${char}`);
      }
    });
    return Buffer.from(bytes);
  },
  decode(buf, bom) {
    /* bytes functions return error for non-shortest forms & values out of range */
    function bytes2(b1, b2) {
      /* U+0080..U+07FF */
      /* 00000000 00000yyy yyxxxxxx | 110yyyyy 10xxxxxx */
      if ((b2 & 0xc0) !== 0x80) {
        return TRAILING;
      }
      const x = ((b1 & mask[5]) << 6) + (b2 & mask[6]);
      if (x < 0x80) {
        return NON_SHORTEST;
      }
      return x;
    }
    function bytes3(b1, b2, b3) {
      /* U+0800..U+FFFF */
      /* 00000000 zzzzyyyy yyxxxxxx | 1110zzzz 10yyyyyy 10xxxxxx */
      if ((b3 & 0xc0) !== 0x80 || (b2 & 0xc0) !== 0x80) {
        return TRAILING;
      }
      const x = ((b1 & mask[4]) << 12) + ((b2 & mask[6]) << 6) + (b3 & mask[6]);
      if (x < 0x800) {
        return NON_SHORTEST;
      }
      if (x >= 0xd800 && x <= 0xdfff) {
        return RANGE;
      }
      return x;
    }
    function bytes4(b1, b2, b3, b4) {
      /* U+10000..U+10FFFF */
      /* 000uuuuu zzzzyyyy yyxxxxxx | 11110uuu 10uuzzzz 10yyyyyy 10xxxxxx */
      if ((b4 & 0xc0) !== 0x80 || (b3 & 0xc0) !== 0x80 || (b2 & 0xc0) !== 0x80) {
        return TRAILING;
      }
      const x =
        ((((b1 & mask[3]) << 2) + ((b2 >> 4) & mask[2])) << 16) +
        ((b2 & mask[4]) << 12) +
        ((b3 & mask[6]) << 6) +
        (b4 & mask[6]);
      if (x < 0x10000) {
        return NON_SHORTEST;
      }
      if (x > 0x10ffff) {
        return RANGE;
      }
      return x;
    }
    let c;
    let b1;
    let i1;
    let i2;
    let i3;
    let inc;
    const len = buf.length;
    let i = bom ? 3 : 0;
    const chars = [];
    while (i < len) {
      b1 = buf[i];
      c = ILL_FORMED;
      const TRUE = true;
      while (TRUE) {
        if (b1 >= 0 && b1 <= 0x7f) {
          /* U+0000..U+007F 00..7F */
          c = b1;
          inc = 1;
          break;
        }
        i1 = i + 1;
        if (i1 < len && b1 >= 0xc2 && b1 <= 0xdf) {
          /* U+0080..U+07FF C2..DF 80..BF */
          c = bytes2(b1, buf[i1]);
          inc = 2;
          break;
        }
        i2 = i + 2;
        if (i2 < len && b1 >= 0xe0 && b1 <= 0xef) {
          /* U+0800..U+FFFF */
          c = bytes3(b1, buf[i1], buf[i2]);
          inc = 3;
          break;
        }
        i3 = i + 3;
        if (i3 < len && b1 >= 0xf0 && b1 <= 0xf4) {
          /* U+10000..U+10FFFF */
          c = bytes4(b1, buf[i1], buf[i2], buf[i3]);
          inc = 4;
          break;
        }
        /* if we fall through to here, it is an ill-formed sequence */
        break;
      }
      if (c > 0x10ffff) {
        const at = `byte[${i}]`;
        if (c === ILL_FORMED) {
          throw new RangeError(`utf8.decode: ill-formed UTF8 byte sequence found at: ${at}`);
        }
        if (c === TRAILING) {
          throw new RangeError(`utf8.decode: illegal trailing byte found at: ${at}`);
        }
        if (c === RANGE) {
          throw new RangeError(`utf8.decode: code point out of range found at: ${at}`);
        }
        if (c === NON_SHORTEST) {
          throw new RangeError(`utf8.decode: non-shortest form found at: ${at}`);
        }
        throw new RangeError(`utf8.decode: unrecognized error found at: ${at}`);
      }
      chars.push(c);
      i += inc;
    }
    return chars;
  },
};

// The UTF16BE algorithms.
exports.utf16be = {
  encode(chars) {
    const bytes = [];
    let char;
    let h;
    let l;
    for (let i = 0; i < chars.length; i += 1) {
      char = chars[i];
      if ((char >= 0 && char <= 0xd7ff) || (char >= 0xe000 && char <= 0xffff)) {
        bytes.push((char >> 8) & mask[8]);
        bytes.push(char & mask[8]);
      } else if (char >= 0x10000 && char <= 0x10ffff) {
        l = char - 0x10000;
        h = 0xd800 + (l >> 10);
        l = 0xdc00 + (l & mask[10]);
        bytes.push((h >> 8) & mask[8]);
        bytes.push(h & mask[8]);
        bytes.push((l >> 8) & mask[8]);
        bytes.push(l & mask[8]);
      } else {
        throw new RangeError(`utf16be.encode: UTF16BE value out of range: char[${i}]: ${char}`);
      }
    }
    return Buffer.from(bytes);
  },
  decode(buf, bom) {
    /* assumes caller has insured that buf is a Buffer of bytes */
    if (buf.length % 2 > 0) {
      throw new RangeError(`utf16be.decode: data length must be even multiple of 2: length: ${buf.length}`);
    }
    const chars = [];
    const len = buf.length;
    let i = bom ? 2 : 0;
    let j = 0;
    let c;
    let inc;
    let i1;
    let i3;
    let high;
    let low;
    while (i < len) {
      const TRUE = true;
      while (TRUE) {
        i1 = i + 1;
        if (i1 < len) {
          high = (buf[i] << 8) + buf[i1];
          if (high < 0xd800 || high > 0xdfff) {
            c = high;
            inc = 2;
            break;
          }
          i3 = i + 3;
          if (i3 < len) {
            low = (buf[i + 2] << 8) + buf[i3];
            if (high <= 0xdbff && low >= 0xdc00 && low <= 0xdfff) {
              c = 0x10000 + ((high - 0xd800) << 10) + (low - 0xdc00);
              inc = 4;
              break;
            }
          }
        }
        /* if we fall through to here, it is an ill-formed sequence */
        throw new RangeError(`utf16be.decode: ill-formed UTF16BE byte sequence found: byte[${i}]`);
      }
      chars[j++] = c;
      i += inc;
    }
    return chars;
  },
};

// The UTF16LE algorithms.
exports.utf16le = {
  encode(chars) {
    const bytes = [];
    let char;
    let h;
    let l;
    for (let i = 0; i < chars.length; i += 1) {
      char = chars[i];
      if ((char >= 0 && char <= 0xd7ff) || (char >= 0xe000 && char <= 0xffff)) {
        bytes.push(char & mask[8]);
        bytes.push((char >> 8) & mask[8]);
      } else if (char >= 0x10000 && char <= 0x10ffff) {
        l = char - 0x10000;
        h = 0xd800 + (l >> 10);
        l = 0xdc00 + (l & mask[10]);
        bytes.push(h & mask[8]);
        bytes.push((h >> 8) & mask[8]);
        bytes.push(l & mask[8]);
        bytes.push((l >> 8) & mask[8]);
      } else {
        throw new RangeError(`utf16le.encode: UTF16LE value out of range: char[${i}]: ${char}`);
      }
    }
    return Buffer.from(bytes);
  },
  decode(buf, bom) {
    /* assumes caller has insured that buf is a Buffer of bytes */
    if (buf.length % 2 > 0) {
      throw new RangeError(`utf16le.decode: data length must be even multiple of 2: length: ${buf.length}`);
    }
    const chars = [];
    const len = buf.length;
    let i = bom ? 2 : 0;
    let j = 0;
    let c;
    let inc;
    let i1;
    let i3;
    let high;
    let low;
    while (i < len) {
      const TRUE = true;
      while (TRUE) {
        i1 = i + 1;
        if (i1 < len) {
          high = (buf[i1] << 8) + buf[i];
          if (high < 0xd800 || high > 0xdfff) {
            c = high;
            inc = 2;
            break;
          }
          i3 = i + 3;
          if (i3 < len) {
            low = (buf[i3] << 8) + buf[i + 2];
            if (high <= 0xdbff && low >= 0xdc00 && low <= 0xdfff) {
              c = 0x10000 + ((high - 0xd800) << 10) + (low - 0xdc00);
              inc = 4;
              break;
            }
          }
        }
        /* if we fall through to here, it is an ill-formed sequence */
        throw new RangeError(`utf16le.decode: ill-formed UTF16LE byte sequence found: byte[${i}]`);
      }
      chars[j++] = c;
      i += inc;
    }
    return chars;
  },
};

// The UTF32BE algorithms.
exports.utf32be = {
  encode(chars) {
    const buf = Buffer.alloc(chars.length * 4);
    let i = 0;
    chars.forEach((char) => {
      if ((char >= 0xd800 && char <= 0xdfff) || char > 0x10ffff) {
        throw new RangeError(`utf32be.encode: UTF32BE character code out of range: char[${i / 4}]: ${char}`);
      }
      buf[i++] = (char >> 24) & mask[8];
      buf[i++] = (char >> 16) & mask[8];
      buf[i++] = (char >> 8) & mask[8];
      buf[i++] = char & mask[8];
    });
    return buf;
  },
  decode(buf, bom) {
    /* caller to insure buf is a Buffer of bytes */
    if (buf.length % 4 > 0) {
      throw new RangeError(`utf32be.decode: UTF32BE byte length must be even multiple of 4: length: ${buf.length}`);
    }
    const chars = [];
    let i = bom ? 4 : 0;
    for (; i < buf.length; i += 4) {
      const char = (buf[i] << 24) + (buf[i + 1] << 16) + (buf[i + 2] << 8) + buf[i + 3];
      if ((char >= 0xd800 && char <= 0xdfff) || char > 0x10ffff) {
        throw new RangeError(`utf32be.decode: UTF32BE character code out of range: char[${i / 4}]: ${char}`);
      }
      chars.push(char);
    }
    return chars;
  },
};

// The UTF32LE algorithms.
exports.utf32le = {
  encode(chars) {
    const buf = Buffer.alloc(chars.length * 4);
    let i = 0;
    chars.forEach((char) => {
      if ((char >= 0xd800 && char <= 0xdfff) || char > 0x10ffff) {
        throw new RangeError(`utf32le.encode: UTF32LE character code out of range: char[${i / 4}]: ${char}`);
      }
      buf[i++] = char & mask[8];
      buf[i++] = (char >> 8) & mask[8];
      buf[i++] = (char >> 16) & mask[8];
      buf[i++] = (char >> 24) & mask[8];
    });
    return buf;
  },
  decode(buf, bom) {
    /* caller to insure buf is a Buffer of bytes */
    if (buf.length % 4 > 0) {
      throw new RangeError(`utf32be.decode: UTF32LE byte length must be even multiple of 4: length: ${buf.length}`);
    }
    const chars = [];
    let i = bom ? 4 : 0;
    for (; i < buf.length; i += 4) {
      const char = (buf[i + 3] << 24) + (buf[i + 2] << 16) + (buf[i + 1] << 8) + buf[i];
      if ((char >= 0xd800 && char <= 0xdfff) || char > 0x10ffff) {
        throw new RangeError(`utf32le.encode: UTF32LE character code out of range: char[${i / 4}]: ${char}`);
      }
      chars.push(char);
    }
    return chars;
  },
};

// The UINT7 algorithms. ASCII or 7-bit unsigned integers.
exports.uint7 = {
  encode(chars) {
    const buf = Buffer.alloc(chars.length);
    for (let i = 0; i < chars.length; i += 1) {
      if (chars[i] > 0x7f) {
        throw new RangeError(`uint7.encode: UINT7 character code out of range: char[${i}]: ${chars[i]}`);
      }
      buf[i] = chars[i];
    }
    return buf;
  },
  decode(buf) {
    const chars = [];
    for (let i = 0; i < buf.length; i += 1) {
      if (buf[i] > 0x7f) {
        throw new RangeError(`uint7.decode: UINT7 character code out of range: byte[${i}]: ${buf[i]}`);
      }
      chars[i] = buf[i];
    }
    return chars;
  },
};

// The UINT8 algorithms. BINARY, Latin 1 or 8-bit unsigned integers.
exports.uint8 = {
  encode(chars) {
    const buf = Buffer.alloc(chars.length);
    for (let i = 0; i < chars.length; i += 1) {
      if (chars[i] > 0xff) {
        throw new RangeError(`uint8.encode: UINT8 character code out of range: char[${i}]: ${chars[i]}`);
      }
      buf[i] = chars[i];
    }
    return buf;
  },
  decode(buf) {
    const chars = [];
    for (let i = 0; i < buf.length; i += 1) {
      chars[i] = buf[i];
    }
    return chars;
  },
};

// The UINT16BE algorithms. Big-endian 16-bit unsigned integers.
exports.uint16be = {
  encode(chars) {
    const buf = Buffer.alloc(chars.length * 2);
    let i = 0;
    chars.forEach((char) => {
      if (char > 0xffff) {
        throw new RangeError(`uint16be.encode: UINT16BE character code out of range: char[${i / 2}]: ${char}`);
      }
      buf[i++] = (char >> 8) & mask[8];
      buf[i++] = char & mask[8];
    });
    return buf;
  },
  decode(buf) {
    if (buf.length % 2 > 0) {
      throw new RangeError(`uint16be.decode: UINT16BE byte length must be even multiple of 2: length: ${buf.length}`);
    }
    const chars = [];
    for (let i = 0; i < buf.length; i += 2) {
      chars.push((buf[i] << 8) + buf[i + 1]);
    }
    return chars;
  },
};

// The UINT16LE algorithms. Little-endian 16-bit unsigned integers.
exports.uint16le = {
  encode(chars) {
    const buf = Buffer.alloc(chars.length * 2);
    let i = 0;
    chars.forEach((char) => {
      if (char > 0xffff) {
        throw new RangeError(`uint16le.encode: UINT16LE character code out of range: char[${i / 2}]: ${char}`);
      }
      buf[i++] = char & mask[8];
      buf[i++] = (char >> 8) & mask[8];
    });
    return buf;
  },
  decode(buf) {
    if (buf.length % 2 > 0) {
      throw new RangeError(`uint16le.decode: UINT16LE byte length must be even multiple of 2: length: ${buf.length}`);
    }
    const chars = [];
    for (let i = 0; i < buf.length; i += 2) {
      chars.push((buf[i + 1] << 8) + buf[i]);
    }
    return chars;
  },
};

// The UINT32BE algorithms. Big-endian 32-bit unsigned integers.
exports.uint32be = {
  encode(chars) {
    const buf = Buffer.alloc(chars.length * 4);
    let i = 0;
    chars.forEach((char) => {
      buf[i++] = (char >> 24) & mask[8];
      buf[i++] = (char >> 16) & mask[8];
      buf[i++] = (char >> 8) & mask[8];
      buf[i++] = char & mask[8];
    });
    return buf;
  },
  decode(buf) {
    if (buf.length % 4 > 0) {
      throw new RangeError(`uint32be.decode: UINT32BE byte length must be even multiple of 4: length: ${buf.length}`);
    }
    const chars = [];
    for (let i = 0; i < buf.length; i += 4) {
      chars.push((buf[i] << 24) + (buf[i + 1] << 16) + (buf[i + 2] << 8) + buf[i + 3]);
    }
    return chars;
  },
};

// The UINT32LE algorithms. Little-endian 32-bit unsigned integers.
exports.uint32le = {
  encode(chars) {
    const buf = Buffer.alloc(chars.length * 4);
    let i = 0;
    chars.forEach((char) => {
      buf[i++] = char & mask[8];
      buf[i++] = (char >> 8) & mask[8];
      buf[i++] = (char >> 16) & mask[8];
      buf[i++] = (char >> 24) & mask[8];
    });
    return buf;
  },
  decode(buf) {
    /* caller to insure buf is a Buffer of bytes */
    if (buf.length % 4 > 0) {
      throw new RangeError(`uint32le.decode: UINT32LE byte length must be even multiple of 4: length: ${buf.length}`);
    }
    const chars = [];
    for (let i = 0; i < buf.length; i += 4) {
      chars.push((buf[i + 3] << 24) + (buf[i + 2] << 16) + (buf[i + 1] << 8) + buf[i]);
    }
    return chars;
  },
};

// The STRING algorithms. Converts JavaScript strings to Array of 32-bit integers and vice versa.
// Uses the node.js Buffer's native "utf16le" capabilites.
exports.string = {
  encode(chars) {
    return thisThis.utf16le.encode(chars).toString('utf16le');
  },
  decode(str) {
    return thisThis.utf16le.decode(Buffer.from(str, 'utf16le'), 0);
  },
};

// The ESCAPED algorithms.
// Note that ESCAPED format contains only ASCII characters.
// The characters are always in the form of a Buffer of bytes.
exports.escaped = {
  // Encodes an Array of 32-bit integers into ESCAPED format.
  encode(chars) {
    const bytes = [];
    for (let i = 0; i < chars.length; i += 1) {
      const char = chars[i];
      if (char === 96) {
        bytes.push(char);
        bytes.push(char);
      } else if (char === 10) {
        bytes.push(char);
      } else if (char >= 32 && char <= 126) {
        bytes.push(char);
      } else {
        let str = '';
        if (char >= 0 && char <= 31) {
          str += `\`x${ascii[char]}`;
        } else if (char >= 127 && char <= 255) {
          str += `\`x${ascii[char]}`;
        } else if (char >= 0x100 && char <= 0xffff) {
          str += `\`u${ascii[(char >> 8) & mask[8]]}${ascii[char & mask[8]]}`;
        } else if (char >= 0x10000 && char <= 0xffffffff) {
          str += '`u{';
          const digit = (char >> 24) & mask[8];
          if (digit > 0) {
            str += ascii[digit];
          }
          str += `${ascii[(char >> 16) & mask[8]] + ascii[(char >> 8) & mask[8]] + ascii[char & mask[8]]}}`;
        } else {
          throw new Error('escape.encode(char): char > 0xffffffff not allowed');
        }
        const buf = Buffer.from(str);
        buf.forEach((b) => {
          bytes.push(b);
        });
      }
    }
    return Buffer.from(bytes);
  },
  // Decodes ESCAPED format from a Buffer of bytes to an Array of 32-bit integers.
  decode(buf) {
    function isHex(hex) {
      if ((hex >= 48 && hex <= 57) || (hex >= 65 && hex <= 70) || (hex >= 97 && hex <= 102)) {
        return true;
      }
      return false;
    }
    function getx(i, len, bufArg) {
      const ret = { char: null, nexti: i + 2, error: true };
      if (i + 1 < len) {
        if (isHex(bufArg[i]) && isHex(bufArg[i + 1])) {
          const str = String.fromCodePoint(bufArg[i], bufArg[i + 1]);
          ret.char = parseInt(str, 16);
          if (!Number.isNaN(ret.char)) {
            ret.error = false;
          }
        }
      }
      return ret;
    }
    function getu(i, len, bufArg) {
      const ret = { char: null, nexti: i + 4, error: true };
      if (i + 3 < len) {
        if (isHex(bufArg[i]) && isHex(bufArg[i + 1]) && isHex(bufArg[i + 2]) && isHex(bufArg[i + 3])) {
          const str = String.fromCodePoint(bufArg[i], bufArg[i + 1], bufArg[i + 2], bufArg[i + 3]);
          ret.char = parseInt(str, 16);
          if (!Number.isNaN(ret.char)) {
            ret.error = false;
          }
        }
      }
      return ret;
    }
    function getU(i, len, bufArg) {
      const ret = { char: null, nexti: i + 4, error: true };
      let str = '';
      while (i < len && isHex(bufArg[i])) {
        str += String.fromCodePoint(bufArg[i]);
        // eslint-disable-next-line no-param-reassign
        i += 1;
      }
      ret.char = parseInt(str, 16);
      if (bufArg[i] === 125 && !Number.isNaN(ret.char)) {
        ret.error = false;
      }
      ret.nexti = i + 1;
      return ret;
    }
    const chars = [];
    const len = buf.length;
    let i1;
    let ret;
    let error;
    let i = 0;
    while (i < len) {
      const TRUE = true;
      while (TRUE) {
        error = true;
        if (buf[i] !== 96) {
          /* unescaped character */
          chars.push(buf[i]);
          i += 1;
          error = false;
          break;
        }
        i1 = i + 1;
        if (i1 >= len) {
          break;
        }
        if (buf[i1] === 96) {
          /* escaped grave accent */
          chars.push(96);
          i += 2;
          error = false;
          break;
        }
        if (buf[i1] === 120) {
          ret = getx(i1 + 1, len, buf);
          if (ret.error) {
            break;
          }
          /* escaped hex */
          chars.push(ret.char);
          i = ret.nexti;
          error = false;
          break;
        }
        if (buf[i1] === 117) {
          if (buf[i1 + 1] === 123) {
            ret = getU(i1 + 2, len, buf);
            if (ret.error) {
              break;
            }
            /* escaped utf-32 */
            chars.push(ret.char);
            i = ret.nexti;
            error = false;
            break;
          }
          ret = getu(i1 + 1, len, buf);
          if (ret.error) {
            break;
          }
          /* escaped utf-16 */
          chars.push(ret.char);
          i = ret.nexti;
          error = false;
          break;
        }
        break;
      }
      if (error) {
        throw new Error(`escaped.decode: ill-formed escape sequence at buf[${i}]`);
      }
    }
    return chars;
  },
};

// The line end conversion algorigthms.
const CR = 13;
const LF = 10;
exports.lineEnds = {
  crlf(chars) {
    const lfchars = [];
    let i = 0;
    while (i < chars.length) {
      switch (chars[i]) {
        case CR:
          if (i + 1 < chars.length && chars[i + 1] === LF) {
            i += 2;
          } else {
            i += 1;
          }
          lfchars.push(CR);
          lfchars.push(LF);
          break;
        case LF:
          lfchars.push(CR);
          lfchars.push(LF);
          i += 1;
          break;
        default:
          lfchars.push(chars[i]);
          i += 1;
          break;
      }
    }
    if (lfchars.length > 0 && lfchars[lfchars.length - 1] !== LF) {
      lfchars.push(CR);
      lfchars.push(LF);
    }
    return lfchars;
  },
  lf(chars) {
    const lfchars = [];
    let i = 0;
    while (i < chars.length) {
      switch (chars[i]) {
        case CR:
          if (i + 1 < chars.length && chars[i + 1] === LF) {
            i += 2;
          } else {
            i += 1;
          }
          lfchars.push(LF);
          break;
        case LF:
          lfchars.push(LF);
          i += 1;
          break;
        default:
          lfchars.push(chars[i]);
          i += 1;
          break;
      }
    }
    if (lfchars.length > 0 && lfchars[lfchars.length - 1] !== LF) {
      lfchars.push(LF);
    }
    return lfchars;
  },
};

// The base 64 algorithms.
exports.base64 = {
  encode(buf) {
    if (buf.length === 0) {
      return Buffer.alloc(0);
    }
    let i;
    let j;
    let n;
    let tail = buf.length % 3;
    tail = tail > 0 ? 3 - tail : 0;
    let units = (buf.length + tail) / 3;
    const base64 = Buffer.alloc(units * 4);
    if (tail > 0) {
      units -= 1;
    }
    i = 0;
    j = 0;
    for (let u = 0; u < units; u += 1) {
      n = buf[i++] << 16;
      n += buf[i++] << 8;
      n += buf[i++];
      base64[j++] = base64codes[(n >> 18) & mask[6]];
      base64[j++] = base64codes[(n >> 12) & mask[6]];
      base64[j++] = base64codes[(n >> 6) & mask[6]];
      base64[j++] = base64codes[n & mask[6]];
    }
    if (tail === 0) {
      return base64;
    }
    if (tail === 1) {
      n = buf[i++] << 16;
      n += buf[i] << 8;
      base64[j++] = base64codes[(n >> 18) & mask[6]];
      base64[j++] = base64codes[(n >> 12) & mask[6]];
      base64[j++] = base64codes[(n >> 6) & mask[6]];
      base64[j] = base64codes[64];
      return base64;
    }
    if (tail === 2) {
      n = buf[i] << 16;
      base64[j++] = base64codes[(n >> 18) & mask[6]];
      base64[j++] = base64codes[(n >> 12) & mask[6]];
      base64[j++] = base64codes[64];
      base64[j] = base64codes[64];
      return base64;
    }
    return undefined;
  },
  decode(codes) {
    /* remove white space and ctrl characters, validate & translate characters */
    function validate(buf) {
      const chars = [];
      let tail = 0;
      for (let i = 0; i < buf.length; i += 1) {
        const char = buf[i];
        const TRUE = true;
        while (TRUE) {
          if (char === 32 || char === 9 || char === 10 || char === 13) {
            break;
          }
          if (char >= 65 && char <= 90) {
            chars.push(char - 65);
            break;
          }
          if (char >= 97 && char <= 122) {
            chars.push(char - 71);
            break;
          }
          if (char >= 48 && char <= 57) {
            chars.push(char + 4);
            break;
          }
          if (char === 43) {
            chars.push(62);
            break;
          }
          if (char === 47) {
            chars.push(63);
            break;
          }
          if (char === 61) {
            chars.push(64);
            tail += 1;
            break;
          }
          /* invalid character */
          throw new RangeError(`base64.decode: invalid character buf[${i}]: ${char}`);
        }
      }
      /* validate length */
      if (chars.length % 4 > 0) {
        throw new RangeError(`base64.decode: string length not integral multiple of 4: ${chars.length}`);
      }
      /* validate tail */
      switch (tail) {
        case 0:
          break;
        case 1:
          if (chars[chars.length - 1] !== 64) {
            throw new RangeError('base64.decode: one tail character found: not last character');
          }
          break;
        case 2:
          if (chars[chars.length - 1] !== 64 || chars[chars.length - 2] !== 64) {
            throw new RangeError('base64.decode: two tail characters found: not last characters');
          }
          break;
        default:
          throw new RangeError(`base64.decode: more than two tail characters found: ${tail}`);
      }
      return { tail, buf: Buffer.from(chars) };
    }

    if (codes.length === 0) {
      return Buffer.alloc(0);
    }
    const val = validate(codes);
    const { tail } = val;
    const base64 = val.buf;
    let i;
    let j;
    let n;
    let units = base64.length / 4;
    const buf = Buffer.alloc(units * 3 - tail);
    if (tail > 0) {
      units -= 1;
    }
    j = 0;
    i = 0;
    for (let u = 0; u < units; u += 1) {
      n = base64[i++] << 18;
      n += base64[i++] << 12;
      n += base64[i++] << 6;
      n += base64[i++];
      buf[j++] = (n >> 16) & mask[8];
      buf[j++] = (n >> 8) & mask[8];
      buf[j++] = n & mask[8];
    }
    if (tail === 1) {
      n = base64[i++] << 18;
      n += base64[i++] << 12;
      n += base64[i] << 6;
      buf[j++] = (n >> 16) & mask[8];
      buf[j] = (n >> 8) & mask[8];
    }
    if (tail === 2) {
      n = base64[i++] << 18;
      n += base64[i++] << 12;
      buf[j] = (n >> 16) & mask[8];
    }
    return buf;
  },
  // Converts a base 64 Buffer of bytes to a JavaScript string with line breaks.
  toString(buf) {
    if (buf.length % 4 > 0) {
      throw new RangeError(`base64.toString: input buffer length not multiple of 4: ${buf.length}`);
    }
    let str = '';
    let lineLen = 0;
    function buildLine(c1, c2, c3, c4) {
      switch (lineLen) {
        case 76:
          str += `\r\n${c1}${c2}${c3}${c4}`;
          lineLen = 4;
          break;
        case 75:
          str += `${c1}\r\n${c2}${c3}${c4}`;
          lineLen = 3;
          break;
        case 74:
          str += `${c1 + c2}\r\n${c3}${c4}`;
          lineLen = 2;
          break;
        case 73:
          str += `${c1 + c2 + c3}\r\n${c4}`;
          lineLen = 1;
          break;
        default:
          str += c1 + c2 + c3 + c4;
          lineLen += 4;
          break;
      }
    }
    function validate(c) {
      if (c >= 65 && c <= 90) {
        return true;
      }
      if (c >= 97 && c <= 122) {
        return true;
      }
      if (c >= 48 && c <= 57) {
        return true;
      }
      if (c === 43) {
        return true;
      }
      if (c === 47) {
        return true;
      }
      if (c === 61) {
        return true;
      }
      return false;
    }
    for (let i = 0; i < buf.length; i += 4) {
      for (let j = i; j < i + 4; j += 1) {
        if (!validate(buf[j])) {
          throw new RangeError(`base64.toString: buf[${j}]: ${buf[j]} : not valid base64 character code`);
        }
      }
      buildLine(
        String.fromCharCode(buf[i]),
        String.fromCharCode(buf[i + 1]),
        String.fromCharCode(buf[i + 2]),
        String.fromCharCode(buf[i + 3])
      );
    }
    return str;
  },
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-lib/ast.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module is used by the parser to build an [Abstract Syntax Tree](https://en.wikipedia.org/wiki/Abstract_syntax_tree) (AST).
// The AST can be thought of as a subset of the full parse tree.
// Each node of the AST holds the phrase that was matched at the corresponding, named parse tree node.
// It is built as the parser successfully matches phrases to the rule names
// (`RNM` operators) and `UDT`s as it parses an input string.
// The user controls which `RNM` or `UDT` names to keep on the AST.
// The user can also associate callback functions with some or all of the retained
// AST nodes to be used to translate the node phrases. That is, associate semantic
// actions to the matched phrases.
// Translating the AST rather that attempting to apply semantic actions during
// the parsing process, has the advantage that there is no backtracking and that the phrases
// are known while traversing down tree as will as up.
//
// Let `ast` be an `ast.js` object. To identify a node to be kept on the AST:
// ```
// ast.callbacks["rulename"] = true; (all nodes default to false)
// ```
// To associate a callback function with a node:
// ```
// ast.callbacks["rulename"] = fn
// ```
// `rulename` is any `RNM` or `UDT` name defined by the associated grammar
// and `fn` is a user-written callback function.
// (See [`apg-examples`](https://github.com/ldthomas/apg-js2-examples/tree/master/ast) for examples of how to create an AST,
// define the nodes and callback functions and attach it to a parser.)
module.exports = function exportsAst() {
  const id = __webpack_require__("../../node_modules/apg-js/src/apg-lib/identifiers.js");
  const utils = __webpack_require__("../../node_modules/apg-js/src/apg-lib/utilities.js");

  const thisFileName = 'ast.js: ';
  const that = this;
  let rules = null;
  let udts = null;
  let chars = null;
  let nodeCount = 0;
  const nodesDefined = [];
  const nodeCallbacks = [];
  const stack = [];
  const records = [];
  this.callbacks = [];
  this.astObject = 'astObject';
  /* called by the parser to initialize the AST with the rules, UDTs and the input characters */
  this.init = function init(rulesIn, udtsIn, charsIn) {
    stack.length = 0;
    records.length = 0;
    nodesDefined.length = 0;
    nodeCount = 0;
    rules = rulesIn;
    udts = udtsIn;
    chars = charsIn;
    let i;
    const list = [];
    for (i = 0; i < rules.length; i += 1) {
      list.push(rules[i].lower);
    }
    for (i = 0; i < udts.length; i += 1) {
      list.push(udts[i].lower);
    }
    nodeCount = rules.length + udts.length;
    for (i = 0; i < nodeCount; i += 1) {
      nodesDefined[i] = false;
      nodeCallbacks[i] = null;
    }
    for (const index in that.callbacks) {
      const lower = index.toLowerCase();
      i = list.indexOf(lower);
      if (i < 0) {
        throw new Error(`${thisFileName}init: node '${index}' not a rule or udt name`);
      }
      if (typeof that.callbacks[index] === 'function') {
        nodesDefined[i] = true;
        nodeCallbacks[i] = that.callbacks[index];
      }
      if (that.callbacks[index] === true) {
        nodesDefined[i] = true;
      }
    }
  };
  /* AST node definitions - called by the parser's `RNM` operator */
  this.ruleDefined = function ruleDefined(index) {
    return nodesDefined[index] !== false;
  };
  /* AST node definitions - called by the parser's `UDT` operator */
  this.udtDefined = function udtDefined(index) {
    return nodesDefined[rules.length + index] !== false;
  };
  /* called by the parser's `RNM` & `UDT` operators */
  /* builds a record for the downward traversal of the node */
  this.down = function down(callbackIndex, name) {
    const thisIndex = records.length;
    stack.push(thisIndex);
    records.push({
      name,
      thisIndex,
      thatIndex: null,
      state: id.SEM_PRE,
      callbackIndex,
      phraseIndex: null,
      phraseLength: null,
      stack: stack.length,
    });
    return thisIndex;
  };
  /* called by the parser's `RNM` & `UDT` operators */
  /* builds a record for the upward traversal of the node */
  this.up = function up(callbackIndex, name, phraseIndex, phraseLength) {
    const thisIndex = records.length;
    const thatIndex = stack.pop();
    records.push({
      name,
      thisIndex,
      thatIndex,
      state: id.SEM_POST,
      callbackIndex,
      phraseIndex,
      phraseLength,
      stack: stack.length,
    });
    records[thatIndex].thatIndex = thisIndex;
    records[thatIndex].phraseIndex = phraseIndex;
    records[thatIndex].phraseLength = phraseLength;
    return thisIndex;
  };
  // Called by the user to translate the AST.
  // Translate means to associate or apply some semantic action to the
  // phrases that were syntactically matched to the AST nodes according
  // to the defining grammar.
  // ```
  // data - optional user-defined data
  //        passed to the callback functions by the translator
  // ```
  this.translate = function translate(data) {
    let ret;
    let callback;
    let record;
    for (let i = 0; i < records.length; i += 1) {
      record = records[i];
      callback = nodeCallbacks[record.callbackIndex];
      if (record.state === id.SEM_PRE) {
        if (callback !== null) {
          ret = callback(id.SEM_PRE, chars, record.phraseIndex, record.phraseLength, data);
          if (ret === id.SEM_SKIP) {
            i = record.thatIndex;
          }
        }
      } else if (callback !== null) {
        callback(id.SEM_POST, chars, record.phraseIndex, record.phraseLength, data);
      }
    }
  };
  /* called by the parser to reset the length of the records array */
  /* necessary on backtracking */
  this.setLength = function setLength(length) {
    records.length = length;
    if (length > 0) {
      stack.length = records[length - 1].stack;
    } else {
      stack.length = 0;
    }
  };
  /* called by the parser to get the length of the records array */
  this.getLength = function getLength() {
    return records.length;
  };
  /* helper for XML display */
  function indent(n) {
    let ret = '';
    for (let i = 0; i < n; i += 1) {
      ret += ' ';
    }
    return ret;
  }
  // Generate an `XML` version of the AST.
  // Useful if you want to use a special or favorite XML parser to translate the
  // AST.
  // ```
  // mode - the display mode of the captured phrases
  //      - default mode is "ascii"
  //      - can be: "ascii"
  //                "decimal"
  //                "hexadecimal"
  //                "unicode"
  // ```
  this.toXml = function toSml(modeArg) {
    let display = utils.charsToDec;
    let caption = 'decimal integer character codes';
    if (typeof modeArg === 'string' && modeArg.length >= 3) {
      const mode = modeArg.slice(0, 3).toLowerCase();
      if (mode === 'asc') {
        display = utils.charsToAscii;
        caption = 'ASCII for printing characters, hex for non-printing';
      } else if (mode === 'hex') {
        display = utils.charsToHex;
        caption = 'hexadecimal integer character codes';
      } else if (mode === 'uni') {
        display = utils.charsToUnicode;
        caption = 'Unicode UTF-32 integer character codes';
      }
    }
    let xml = '';
    let depth = 0;
    xml += '<?xml version="1.0" encoding="utf-8"?>\n';
    xml += `<root nodes="${records.length / 2}" characters="${chars.length}">\n`;
    xml += `<!-- input string, ${caption} -->\n`;
    xml += indent(depth + 2);
    xml += display(chars);
    xml += '\n';
    records.forEach((rec) => {
      if (rec.state === id.SEM_PRE) {
        depth += 1;
        xml += indent(depth);
        xml += `<node name="${rec.name}" index="${rec.phraseIndex}" length="${rec.phraseLength}">\n`;
        xml += indent(depth + 2);
        xml += display(chars, rec.phraseIndex, rec.phraseLength);
        xml += '\n';
      } else {
        xml += indent(depth);
        xml += `</node><!-- name="${rec.name}" -->\n`;
        depth -= 1;
      }
    });

    xml += '</root>\n';
    return xml;
  };
  /* generate a JavaScript object version of the AST */
  /* for the phrase-matching engine apg-exp */
  this.phrases = function phrases() {
    const obj = {};
    let i;
    let record;
    for (i = 0; i < records.length; i += 1) {
      record = records[i];
      if (record.state === id.SEM_PRE) {
        if (!Array.isArray(obj[record.name])) {
          obj[record.name] = [];
        }
        obj[record.name].push({
          index: record.phraseIndex,
          length: record.phraseLength,
        });
      }
    }
    return obj;
  };
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-lib/circular-buffer.js":
/***/ ((module) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module acts as a "circular buffer". It is used to keep track
// only the last N records in an array of records. If more than N records
// are saved, each additional record overwrites the previously oldest record.
// This module deals only with the record indexes and does not save
// any actual records. It is used by [`trace.js`](./trace.html) for limiting the number of
// trace records saved.
module.exports = function exportsCircularBuffer() {
  'use strict;';

  const thisFileName = 'circular-buffer.js: ';
  let itemIndex = -1;
  let maxListSize = 0;
  // Initialize buffer.<br>
  // *size* is `maxListSize`, the maximum number of records saved before overwriting begins.
  this.init = function init(size) {
    if (typeof size !== 'number' || size <= 0) {
      throw new Error(`${thisFileName}init: circular buffer size must an integer > 0`);
    }
    maxListSize = Math.ceil(size);
    itemIndex = -1;
  };
  // Call this to increment the number of records collected.<br>
  // Returns the array index number to store the next record in.
  this.increment = function increment() {
    itemIndex += 1;
    return (itemIndex + maxListSize) % maxListSize;
  };
  // Returns `maxListSize` - the maximum number of records to keep in the buffer.
  this.maxSize = function maxSize() {
    return maxListSize;
  };
  // Returns the highest number of items saved.<br>
  // (The number of items is the actual number of records processed
  // even though only `maxListSize` records are actually retained.)
  this.items = function items() {
    return itemIndex + 1;
  };
  // Returns the record number associated with this item index.
  this.getListIndex = function getListIndex(item) {
    if (itemIndex === -1) {
      return -1;
    }
    if (item < 0 || item > itemIndex) {
      return -1;
    }
    if (itemIndex - item >= maxListSize) {
      return -1;
    }
    return (item + maxListSize) % maxListSize;
  };
  // The iterator over the circular buffer.
  // The user's function, `fn`, will be called with arguments `fn(listIndex, itemIndex)`
  // where `listIndex` is the saved record index and `itemIndex` is the actual item index.
  this.forEach = function forEach(fn) {
    if (itemIndex === -1) {
      /* no records have been collected */
      return;
    }
    if (itemIndex < maxListSize) {
      /* fewer than maxListSize records have been collected - number of items = number of records */
      for (let i = 0; i <= itemIndex; i += 1) {
        fn(i, i);
      }
      return;
    }
    /* start with the oldest record saved and finish with the most recent record saved */
    for (let i = itemIndex - maxListSize + 1; i <= itemIndex; i += 1) {
      const listIndex = (i + maxListSize) % maxListSize;
      fn(listIndex, i);
    }
  };
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-lib/emitcss.js":
/***/ ((module) => {

// This module has been developed programmatically in the `apg-lib` build process.
// It is used to build web pages programatically on the fly without the need for <script> or <style> tags.

module.exports = function emittcss(){
return '/* This file automatically generated by jsonToless() and LESS. */\n.apg-mono {\n  font-family: monospace;\n}\n.apg-active {\n  font-weight: bold;\n  color: #000000;\n}\n.apg-match {\n  font-weight: bold;\n  color: #264BFF;\n}\n.apg-empty {\n  font-weight: bold;\n  color: #0fbd0f;\n}\n.apg-nomatch {\n  font-weight: bold;\n  color: #FF4000;\n}\n.apg-lh-match {\n  font-weight: bold;\n  color: #1A97BA;\n}\n.apg-lb-match {\n  font-weight: bold;\n  color: #5F1687;\n}\n.apg-remainder {\n  font-weight: bold;\n  color: #999999;\n}\n.apg-ctrl-char {\n  font-weight: bolder;\n  font-style: italic;\n  font-size: 0.6em;\n}\n.apg-line-end {\n  font-weight: bold;\n  color: #000000;\n}\n.apg-error {\n  font-weight: bold;\n  color: #FF4000;\n}\n.apg-phrase {\n  color: #000000;\n  background-color: #8caae6;\n}\n.apg-empty-phrase {\n  color: #0fbd0f;\n}\ntable.apg-state {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: left;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-state th,\ntable.apg-state td {\n  text-align: left;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-state th:nth-last-child(2),\ntable.apg-state td:nth-last-child(2) {\n  text-align: right;\n}\ntable.apg-state caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-stats {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-stats th,\ntable.apg-stats td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-stats caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-trace {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-trace caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-trace th,\ntable.apg-trace td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-trace th:last-child,\ntable.apg-trace th:nth-last-child(2),\ntable.apg-trace td:last-child,\ntable.apg-trace td:nth-last-child(2) {\n  text-align: left;\n}\ntable.apg-grammar {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-grammar caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-grammar th,\ntable.apg-grammar td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-grammar th:last-child,\ntable.apg-grammar td:last-child {\n  text-align: left;\n}\ntable.apg-rules {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-rules caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-rules th,\ntable.apg-rules td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-rules a {\n  color: #003399 !important;\n}\ntable.apg-rules a:hover {\n  color: #8caae6 !important;\n}\ntable.apg-attrs {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: center;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-attrs caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-attrs th,\ntable.apg-attrs td {\n  text-align: center;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-attrs th:nth-child(1),\ntable.apg-attrs th:nth-child(2),\ntable.apg-attrs th:nth-child(3) {\n  text-align: right;\n}\ntable.apg-attrs td:nth-child(1),\ntable.apg-attrs td:nth-child(2),\ntable.apg-attrs td:nth-child(3) {\n  text-align: right;\n}\ntable.apg-attrs a {\n  color: #003399 !important;\n}\ntable.apg-attrs a:hover {\n  color: #8caae6 !important;\n}\n';
}


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-lib/identifiers.js":
/***/ ((module) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module exposes a list of named identifiers, shared across the parser generator
// and the parsers that are generated.

module.exports = {
  // Identifies the operator type. Used by the generator
  // to indicate operator types in the grammar object.
  // Used by the [parser](./parser.html) when interpreting the grammar object.
  /* the original ABNF operators */
  ALT: 1 /* alternation */,
  CAT: 2 /* concatenation */,
  REP: 3 /* repetition */,
  RNM: 4 /* rule name */,
  TRG: 5 /* terminal range */,
  TBS: 6 /* terminal binary string, case sensitive */,
  TLS: 7 /* terminal literal string, case insensitive */,
  /* the super set, SABNF operators */
  UDT: 11 /* user-defined terminal */,
  AND: 12 /* positive look ahead */,
  NOT: 13 /* negative look ahead */,
  BKR: 14 /* back reference to a previously matched rule name */,
  BKA: 15 /* positive look behind */,
  BKN: 16 /* negative look behind */,
  ABG: 17 /* anchor - begin of string */,
  AEN: 18 /* anchor - end of string */,
  // Used by the parser and the user's `RNM` and `UDT` callback functions.
  // Identifies the parser state as it traverses the parse tree nodes.
  // - *ACTIVE* - indicates the downward direction through the parse tree node.
  // - *MATCH* - indicates the upward direction and a phrase, of length \> 0, has been successfully matched
  // - *EMPTY* - indicates the upward direction and a phrase, of length = 0, has been successfully matched
  // - *NOMATCH* - indicates the upward direction and the parser failed to match any phrase at all
  ACTIVE: 100,
  MATCH: 101,
  EMPTY: 102,
  NOMATCH: 103,
  // Used by [`AST` translator](./ast.html) (semantic analysis) and the user's callback functions
  // to indicate the direction of flow through the `AST` nodes.
  // - *SEM_PRE* - indicates the downward (pre-branch) direction through the `AST` node.
  // - *SEM_POST* - indicates the upward (post-branch) direction through the `AST` node.
  SEM_PRE: 200,
  SEM_POST: 201,
  // Used by the user's callback functions to indicate to the `AST` translator (semantic analysis) how to proceed.
  // - *SEM_OK* - normal return value
  // - *SEM_SKIP* - if a callback function returns this value from the SEM_PRE state,
  // the translator will skip processing all `AST` nodes in the branch below the current node.
  // Ignored if returned from the SEM_POST state.
  SEM_OK: 300,
  SEM_SKIP: 301,
  // Used in attribute generation to distinguish the necessary attribute categories.
  // - *ATTR_N* - non-recursive
  // - *ATTR_R* - recursive
  // - *ATTR_MR* - belongs to a mutually-recursive set
  ATTR_N: 400,
  ATTR_R: 401,
  ATTR_MR: 402,
  // Look around values indicate whether the parser is in look ahead or look behind mode.
  // Used by the tracing facility to indicate the look around mode in the trace records display.
  // - *LOOKAROUND_NONE* - the parser is in normal parsing mode
  // - *LOOKAROUND_AHEAD* - the parse is in look-ahead mode, phrase matching for operator `AND(&)` or `NOT(!)`
  // - *LOOKAROUND_BEHIND* - the parse is in look-behind mode, phrase matching for operator `BKA(&&)` or `BKN(!!)`
  LOOKAROUND_NONE: 500,
  LOOKAROUND_AHEAD: 501,
  LOOKAROUND_BEHIND: 502,
  // Back reference rule mode indicators
  // - *BKR_MODE_UM* - the back reference is using universal mode
  // - *BKR_MODE_PM* - the back reference is using parent frame mode
  // - *BKR_MODE_CS* - the back reference is using case-sensitive phrase matching
  // - *BKR_MODE_CI* - the back reference is using case-insensitive phrase matching
  BKR_MODE_UM: 601,
  BKR_MODE_PM: 602,
  BKR_MODE_CS: 603,
  BKR_MODE_CI: 604,
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-lib/node-exports.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module serves to export all library objects and object constructors with the `require("apg-lib")` statement.
// For example, to create a new parser in your program,
// ````
// let apglib = require("../apg-lib/node-exports");
// let my-parser = new apglib.parser();
// ````
module.exports = {
  ast: __webpack_require__("../../node_modules/apg-js/src/apg-lib/ast.js"),
  circular: __webpack_require__("../../node_modules/apg-js/src/apg-lib/circular-buffer.js"),
  ids: __webpack_require__("../../node_modules/apg-js/src/apg-lib/identifiers.js"),
  parser: __webpack_require__("../../node_modules/apg-js/src/apg-lib/parser.js"),
  stats: __webpack_require__("../../node_modules/apg-js/src/apg-lib/stats.js"),
  trace: __webpack_require__("../../node_modules/apg-js/src/apg-lib/trace.js"),
  utils: __webpack_require__("../../node_modules/apg-js/src/apg-lib/utilities.js"),
  emitcss: __webpack_require__("../../node_modules/apg-js/src/apg-lib/emitcss.js"),
  style: __webpack_require__("../../node_modules/apg-js/src/apg-lib/style.js"),
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-lib/parser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable func-names */
/* eslint-disable no-restricted-syntax */
/* eslint-disable new-cap */
/* eslint-disable guard-for-in */
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This is the primary object of `apg-lib`. Calling its `parse()` member function
// walks the parse tree of opcodes, matching phrases from the input string as it goes.
// The working code for all of the operators, `ALT`, `CAT`, etc. is in this module.
module.exports = function parser() {
  const id = __webpack_require__("../../node_modules/apg-js/src/apg-lib/identifiers.js");
  const utils = __webpack_require__("../../node_modules/apg-js/src/apg-lib/utilities.js");

  const thisFileName = 'parser.js: ';
  const thisThis = this;
  let opExecute;
  this.ast = null;
  this.stats = null;
  this.trace = null;
  this.callbacks = [];
  let opcodes = null;
  let chars = null;
  let charsBegin;
  let charsLength;
  let charsEnd;
  let lookAround;
  let treeDepth = 0;
  let maxTreeDepth = 0;
  let nodeHits = 0;
  let ruleCallbacks = null;
  let udtCallbacks = null;
  let rules = null;
  let udts = null;
  let syntaxData = null;
  let maxMatched = 0;
  let limitTreeDepth = Infinity;
  let limitNodeHits = Infinity;
  // Evaluates any given rule. This can be called from the syntax callback
  // functions to evaluate any rule in the grammar's rule list. Great caution
  // should be used. Use of this function will alter the language that the
  // parser accepts.
  const evaluateRule = function evaluateRule(ruleIndex, phraseIndex, sysData) {
    const functionName = `${thisFileName}evaluateRule(): `;
    if (ruleIndex >= rules.length) {
      throw new Error(`${functionName}rule index: ${ruleIndex} out of range`);
    }
    if (phraseIndex >= charsEnd) {
      throw new Error(`${functionName}phrase index: ${phraseIndex} out of range`);
    }
    const { length } = opcodes;
    opcodes.push({
      type: id.RNM,
      index: ruleIndex,
    });
    opExecute(length, phraseIndex, sysData);
    opcodes.pop();
  };
  // Evaluates any given UDT. This can be called from the syntax callback
  // functions to evaluate any UDT in the grammar's UDT list. Great caution
  // should be used. Use of this function will alter the language that the
  // parser accepts.
  const evaluateUdt = function (udtIndex, phraseIndex, sysData) {
    const functionName = `${thisFileName}evaluateUdt(): `;
    if (udtIndex >= udts.length) {
      throw new Error(`${functionName}udt index: ${udtIndex} out of range`);
    }
    if (phraseIndex >= charsEnd) {
      throw new Error(`${functionName}phrase index: ${phraseIndex} out of range`);
    }
    const { length } = opcodes;
    opcodes.push({
      type: id.UDT,
      empty: udts[udtIndex].empty,
      index: udtIndex,
    });
    opExecute(length, phraseIndex, sysData);
    opcodes.pop();
  };
  /* Clears this object of any/all data that has been initialized or added to it. */
  /* Called by parse() on initialization, allowing this object to be re-used for multiple parsing calls. */
  const clear = function () {
    treeDepth = 0;
    maxTreeDepth = 0;
    nodeHits = 0;
    maxMatched = 0;
    lookAround = [
      {
        lookAround: id.LOOKAROUND_NONE,
        anchor: 0,
        charsEnd: 0,
        charsLength: 0,
      },
    ];
    rules = null;
    udts = null;
    chars = null;
    charsBegin = 0;
    charsLength = 0;
    charsEnd = 0;
    ruleCallbacks = null;
    udtCallbacks = null;
    syntaxData = null;
    opcodes = null;
  };
  /* object for maintaining a stack of back reference frames */
  const backRef = function () {
    const stack = [];
    const init = function () {
      const obj = {};
      rules.forEach((rule) => {
        if (rule.isBkr) {
          obj[rule.lower] = null;
        }
      });
      if (udts.length > 0) {
        udts.forEach((udt) => {
          if (udt.isBkr) {
            obj[udt.lower] = null;
          }
        });
      }
      stack.push(obj);
    };
    const copy = function () {
      const top = stack[stack.length - 1];
      const obj = {};
      /* // eslint-disable-next-line no-restricted-syntax */
      for (const name in top) {
        obj[name] = top[name];
      }
      return obj;
    };
    this.push = function push() {
      stack.push(copy());
    };
    this.pop = function pop(lengthArg) {
      let length = lengthArg;
      if (!length) {
        length = stack.length - 1;
      }
      if (length < 1 || length > stack.length) {
        throw new Error(`${thisFileName}backRef.pop(): bad length: ${length}`);
      }
      stack.length = length;
      return stack[stack.length - 1];
    };
    this.length = function length() {
      return stack.length;
    };
    this.savePhrase = function savePhrase(name, index, length) {
      stack[stack.length - 1][name] = {
        phraseIndex: index,
        phraseLength: length,
      };
    };
    this.getPhrase = function (name) {
      return stack[stack.length - 1][name];
    };
    /* constructor */
    init();
  };
  // The system data structure that relays system information to and from the rule and UDT callback functions.
  // - *state* - the state of the parser, ACTIVE, MATCH, EMPTY or NOMATCH (see the `identifiers` object in
  // [`apg-lib`](https://github.com/ldthomas/apg-js2-lib))
  // - *phraseLength* - the number of characters matched if the state is MATCHED or EMPTY
  // - *lookaround* - the top of the stack holds the current look around state,
  // LOOKAROUND_NONE, LOOKAROUND_AHEAD or LOOKAROUND_BEHIND,
  // - *uFrame* - the "universal" back reference frame.
  // Holds the last matched phrase for each of the back referenced rules and UDTs.
  // - *pFrame* - the stack of "parent" back reference frames.
  // Holds the matched phrase from the parent frame of each back referenced rules and UDTs.
  // - *evaluateRule* - a reference to this object's `evaluateRule()` function.
  // Can be called from a callback function (use with extreme caution!)
  // - *evaluateUdt* - a reference to this object's `evaluateUdt()` function.
  // Can be called from a callback function (use with extreme caution!)
  const systemData = function systemData() {
    const thisData = this;
    this.state = id.ACTIVE;
    this.phraseLength = 0;
    this.ruleIndex = 0;
    this.udtIndex = 0;
    this.lookAround = lookAround[lookAround.length - 1];
    this.uFrame = new backRef();
    this.pFrame = new backRef();
    this.evaluateRule = evaluateRule;
    this.evaluateUdt = evaluateUdt;
    /* refresh the parser state for the next operation */
    this.refresh = function refresh() {
      thisData.state = id.ACTIVE;
      thisData.phraseLength = 0;
      thisData.lookAround = lookAround[lookAround.length - 1];
    };
  };
  /* some look around helper functions */
  const lookAroundValue = function lookAroundValue() {
    return lookAround[lookAround.length - 1];
  };
  /* return true if parser is in look around (ahead or behind) state */
  const inLookAround = function inLookAround() {
    return lookAround.length > 1;
  };
  /* return true if parser is in look behind state */
  const inLookBehind = function () {
    return lookAround[lookAround.length - 1].lookAround === id.LOOKAROUND_BEHIND;
  };
  /* called by parse() to initialize the AST object, if one has been defined */
  const initializeAst = function () {
    const functionName = `${thisFileName}initializeAst(): `;
    const TRUE = true;
    while (TRUE) {
      if (thisThis.ast === undefined) {
        thisThis.ast = null;
        break;
      }
      if (thisThis.ast === null) {
        break;
      }
      if (thisThis.ast.astObject !== 'astObject') {
        throw new Error(`${functionName}ast object not recognized`);
      }
      break;
    }
    if (thisThis.ast !== null) {
      thisThis.ast.init(rules, udts, chars);
    }
  };
  /* called by parse() to initialize the trace object, if one has been defined */
  const initializeTrace = function () {
    const functionName = `${thisFileName}initializeTrace(): `;
    const TRUE = true;
    while (TRUE) {
      if (thisThis.trace === undefined) {
        thisThis.trace = null;
        break;
      }
      if (thisThis.trace === null) {
        break;
      }
      if (thisThis.trace.traceObject !== 'traceObject') {
        throw new Error(`${functionName}trace object not recognized`);
      }
      break;
    }
    if (thisThis.trace !== null) {
      thisThis.trace.init(rules, udts, chars);
    }
  };
  /* called by parse() to initialize the statistics object, if one has been defined */
  const initializeStats = function () {
    const functionName = `${thisFileName}initializeStats(): `;
    const TRUE = true;
    while (TRUE) {
      if (thisThis.stats === undefined) {
        thisThis.stats = null;
        break;
      }
      if (thisThis.stats === null) {
        break;
      }
      if (thisThis.stats.statsObject !== 'statsObject') {
        throw new Error(`${functionName}stats object not recognized`);
      }
      break;
    }
    if (thisThis.stats !== null) {
      thisThis.stats.init(rules, udts);
    }
  };
  /* called by parse() to initialize the rules & udts from the grammar object */
  /* (the grammar object generated previously by apg) */
  const initializeGrammar = function (grammar) {
    const functionName = `${thisFileName}initializeGrammar(): `;
    if (!grammar) {
      throw new Error(`${functionName}grammar object undefined`);
    }
    if (grammar.grammarObject !== 'grammarObject') {
      throw new Error(`${functionName}bad grammar object`);
    }
    rules = grammar.rules;
    udts = grammar.udts;
  };
  /* called by parse() to initialize the start rule */
  const initializeStartRule = function (startRule) {
    const functionName = `${thisFileName}initializeStartRule(): `;
    let start = null;
    if (typeof startRule === 'number') {
      if (startRule >= rules.length) {
        throw new Error(`${functionName}start rule index too large: max: ${rules.length}: index: ${startRule}`);
      }
      start = startRule;
    } else if (typeof startRule === 'string') {
      const lower = startRule.toLowerCase();
      for (let i = 0; i < rules.length; i += 1) {
        if (lower === rules[i].lower) {
          start = rules[i].index;
          break;
        }
      }
      if (start === null) {
        throw new Error(`${functionName}start rule name '${startRule}' not recognized`);
      }
    } else {
      throw new Error(`${functionName}type of start rule '${typeof startRule}' not recognized`);
    }
    return start;
  };
  /* called by parse() to initialize the array of characters codes representing the input string */
  const initializeInputChars = function initializeInputChars(inputArg, begArg, lenArg) {
    const functionName = `${thisFileName}initializeInputChars(): `;
    /* varify and normalize input */
    let input = inputArg;
    let beg = begArg;
    let len = lenArg;
    if (input === undefined) {
      throw new Error(`${functionName}input string is undefined`);
    }
    if (input === null) {
      throw new Error(`${functionName}input string is null`);
    }
    if (typeof input === 'string') {
      input = utils.stringToChars(input);
    } else if (!Array.isArray(input)) {
      throw new Error(`${functionName}input string is not a string or array`);
    }
    if (input.length > 0) {
      if (typeof input[0] !== 'number') {
        throw new Error(`${functionName}input string not an array of integers`);
      }
    }
    /* verify and normalize beginning index */
    if (typeof beg !== 'number') {
      beg = 0;
    } else {
      beg = Math.floor(beg);
      if (beg < 0 || beg > input.length) {
        throw new Error(`${functionName}input beginning index out of range: ${beg}`);
      }
    }
    /* verify and normalize input length */
    if (typeof len !== 'number') {
      len = input.length - beg;
    } else {
      len = Math.floor(len);
      if (len < 0 || len > input.length - beg) {
        throw new Error(`${functionName}input length out of range: ${len}`);
      }
    }
    chars = input;
    charsBegin = beg;
    charsLength = len;
    charsEnd = charsBegin + charsLength;
  };
  /* called by parse() to initialize the user-written, syntax callback functions, if any */
  const initializeCallbacks = function () {
    const functionName = `${thisFileName}initializeCallbacks(): `;
    let i;
    ruleCallbacks = [];
    udtCallbacks = [];
    for (i = 0; i < rules.length; i += 1) {
      ruleCallbacks[i] = null;
    }
    for (i = 0; i < udts.length; i += 1) {
      udtCallbacks[i] = null;
    }
    let func;
    const list = [];
    for (i = 0; i < rules.length; i += 1) {
      list.push(rules[i].lower);
    }
    for (i = 0; i < udts.length; i += 1) {
      list.push(udts[i].lower);
    }
    for (const index in thisThis.callbacks) {
      i = list.indexOf(index.toLowerCase());
      if (i < 0) {
        throw new Error(`${functionName}syntax callback '${index}' not a rule or udt name`);
      }
      func = thisThis.callbacks[index];
      if (!func) {
        func = null;
      }
      if (typeof func === 'function' || func === null) {
        if (i < rules.length) {
          ruleCallbacks[i] = func;
        } else {
          udtCallbacks[i - rules.length] = func;
        }
      } else {
        throw new Error(
          `${functionName}syntax callback[${index}] must be function reference or 'false' (false/null/undefined/etc.)`
        );
      }
    }
    /* make sure all udts have been defined - the parser can't work without them */
    for (i = 0; i < udts.length; i += 1) {
      if (udtCallbacks[i] === null) {
        throw new Error(
          `${functionName}all UDT callbacks must be defined. UDT callback[${udts[i].lower}] not a function reference`
        );
      }
    }
  };
  // Set the maximum parse tree depth allowed. The default is `Infinity`.
  // A limit is not normally needed, but can be used to protect against an
  // exponentual or "catastrophically backtracking" grammar.
  // <ul>
  // <li>
  // depth - max allowed parse tree depth. An exception is thrown if exceeded.
  // </li>
  // </ul>
  this.setMaxTreeDepth = function (depth) {
    if (typeof depth !== 'number') {
      throw new Error(`parser: max tree depth must be integer > 0: ${depth}`);
    }
    limitTreeDepth = Math.floor(depth);
    if (limitTreeDepth <= 0) {
      throw new Error(`parser: max tree depth must be integer > 0: ${depth}`);
    }
  };
  // Set the maximum number of node hits (parser unit steps or opcode function calls) allowed.
  // The default is `Infinity`.
  // A limit is not normally needed, but can be used to protect against an
  // exponentual or "catastrophically backtracking" grammar.
  // <ul>
  // <li>
  // hits - maximum number of node hits or parser unit steps allowed.
  // An exception thrown if exceeded.
  // </li>
  // </ul>
  this.setMaxNodeHits = function (hits) {
    if (typeof hits !== 'number') {
      throw new Error(`parser: max node hits must be integer > 0: ${hits}`);
    }
    limitNodeHits = Math.floor(hits);
    if (limitNodeHits <= 0) {
      throw new Error(`parser: max node hits must be integer > 0: ${hits}`);
    }
  };
  /* the main parser function */
  const privateParse = function (grammar, startRuleArg, callbackData) {
    let success;
    const functionName = `${thisFileName}parse(): `;
    initializeGrammar(grammar);
    const startRule = initializeStartRule(startRuleArg);
    initializeCallbacks();
    initializeTrace();
    initializeStats();
    initializeAst();
    const sysData = new systemData();
    if (!(callbackData === undefined || callbackData === null)) {
      syntaxData = callbackData;
    }
    /* create a dummy opcode for the start rule */
    opcodes = [
      {
        type: id.RNM,
        index: startRule,
      },
    ];
    /* execute the start rule */
    opExecute(0, charsBegin, sysData);
    opcodes = null;
    /* test and return the sysData */
    switch (sysData.state) {
      case id.ACTIVE:
        throw new Error(`${functionName}final state should never be 'ACTIVE'`);
      case id.NOMATCH:
        success = false;
        break;
      case id.EMPTY:
      case id.MATCH:
        if (sysData.phraseLength === charsLength) {
          success = true;
        } else {
          success = false;
        }
        break;
      default:
        throw new Error('unrecognized state');
    }
    return {
      success,
      state: sysData.state,
      length: charsLength,
      matched: sysData.phraseLength,
      maxMatched,
      maxTreeDepth,
      nodeHits,
      inputLength: chars.length,
      subBegin: charsBegin,
      subEnd: charsEnd,
      subLength: charsLength,
    };
  };

  // This form allows parsing of a sub-string of the full input string.
  // <ul>
  // <li>*inputIndex* - index of the first character in the sub-string</li>
  // <li>*inputLength* - length of the sub-string</li>
  // </ul>
  // All other parameters as for the above function `parse()`.
  this.parseSubstring = function parseSubstring(grammar, startRule, inputChars, inputIndex, inputLength, callbackData) {
    clear();
    initializeInputChars(inputChars, inputIndex, inputLength);
    return privateParse(grammar, startRule, callbackData);
  };
  // This is the main function, called to parse an input string.
  // <ul>
  // <li>*grammar* - an instantiated grammar object - the output of `apg` for a
  // specific SABNF grammar</li>
  // <li>*startRule* - the rule name or rule index to be used as the root of the
  // parse tree. This is usually the first rule, index = 0, of the grammar
  // but can be any rule defined in the above grammar object.</li>
  // <li>*inputChars* - the input string. Can be a string or an array of integer character codes representing the
  // string.</li>
  // <li>*callbackData* - user-defined data object to be passed to the user's
  // callback functions.
  // This is not used by the parser in any way, merely passed on to the user.
  // May be `null` or omitted.</li>
  // </ul>
  this.parse = function parse(grammar, startRule, inputChars, callbackData) {
    clear();
    initializeInputChars(inputChars, 0, inputChars.length);
    return privateParse(grammar, startRule, callbackData);
  };
  // The `ALT` operator.<br>
  // Executes its child nodes, from left to right, until it finds a match.
  // Fails if *all* of its child nodes fail.
  const opALT = function (opIndex, phraseIndex, sysData) {
    const op = opcodes[opIndex];
    for (let i = 0; i < op.children.length; i += 1) {
      opExecute(op.children[i], phraseIndex, sysData);
      if (sysData.state !== id.NOMATCH) {
        break;
      }
    }
  };
  // The `CAT` operator.<br>
  // Executes all of its child nodes, from left to right,
  // concatenating the matched phrases.
  // Fails if *any* child nodes fail.
  const opCAT = function (opIndex, phraseIndex, sysData) {
    let success;
    let astLength;
    let catCharIndex;
    let catPhrase;
    const op = opcodes[opIndex];
    const ulen = sysData.uFrame.length();
    const plen = sysData.pFrame.length();
    if (thisThis.ast) {
      astLength = thisThis.ast.getLength();
    }
    success = true;
    catCharIndex = phraseIndex;
    catPhrase = 0;
    for (let i = 0; i < op.children.length; i += 1) {
      opExecute(op.children[i], catCharIndex, sysData);
      if (sysData.state === id.NOMATCH) {
        success = false;
        break;
      } else {
        catCharIndex += sysData.phraseLength;
        catPhrase += sysData.phraseLength;
      }
    }
    if (success) {
      sysData.state = catPhrase === 0 ? id.EMPTY : id.MATCH;
      sysData.phraseLength = catPhrase;
    } else {
      sysData.state = id.NOMATCH;
      sysData.phraseLength = 0;
      /* reset the back referencing frames on failure */
      sysData.uFrame.pop(ulen);
      sysData.pFrame.pop(plen);
      if (thisThis.ast) {
        thisThis.ast.setLength(astLength);
      }
    }
  };
  // The `REP` operator.<br>
  // Repeatedly executes its single child node,
  // concatenating each of the matched phrases found.
  // The number of repetitions executed and its final sysData depends
  // on its `min` & `max` repetition values.
  const opREP = function (opIndex, phraseIndex, sysData) {
    let astLength;
    let repCharIndex;
    let repPhrase;
    let repCount;
    const op = opcodes[opIndex];
    repCharIndex = phraseIndex;
    repPhrase = 0;
    repCount = 0;
    const ulen = sysData.uFrame.length();
    const plen = sysData.pFrame.length();
    if (thisThis.ast) {
      astLength = thisThis.ast.getLength();
    }
    const TRUE = true;
    while (TRUE) {
      if (repCharIndex >= charsEnd) {
        /* exit on end of input string */
        break;
      }
      opExecute(opIndex + 1, repCharIndex, sysData);
      if (sysData.state === id.NOMATCH) {
        /* always end if the child node fails */
        break;
      }
      if (sysData.state === id.EMPTY) {
        /* REP always succeeds when the child node returns an empty phrase */
        /* this may not seem obvious, but that's the way it works out */
        break;
      }
      repCount += 1;
      repPhrase += sysData.phraseLength;
      repCharIndex += sysData.phraseLength;
      if (repCount === op.max) {
        /* end on maxed out reps */
        break;
      }
    }
    /* evaluate the match count according to the min, max values */
    if (sysData.state === id.EMPTY) {
      sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
      sysData.phraseLength = repPhrase;
    } else if (repCount >= op.min) {
      sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
      sysData.phraseLength = repPhrase;
    } else {
      sysData.state = id.NOMATCH;
      sysData.phraseLength = 0;
      /* reset the back referencing frames on failure */
      sysData.uFrame.pop(ulen);
      sysData.pFrame.pop(plen);
      if (thisThis.ast) {
        thisThis.ast.setLength(astLength);
      }
    }
  };
  // Validate the callback function's returned sysData values.
  // It's the user's responsibility to get them right
  // but `RNM` fails if not.
  const validateRnmCallbackResult = function (rule, sysData, charsLeft, down) {
    if (sysData.phraseLength > charsLeft) {
      let str = `${thisFileName}opRNM(${rule.name}): callback function error: `;
      str += `sysData.phraseLength: ${sysData.phraseLength}`;
      str += ` must be <= remaining chars: ${charsLeft}`;
      throw new Error(str);
    }
    switch (sysData.state) {
      case id.ACTIVE:
        if (down !== true) {
          throw new Error(
            `${thisFileName}opRNM(${rule.name}): callback function return error. ACTIVE state not allowed.`
          );
        }
        break;
      case id.EMPTY:
        sysData.phraseLength = 0;
        break;
      case id.MATCH:
        if (sysData.phraseLength === 0) {
          sysData.state = id.EMPTY;
        }
        break;
      case id.NOMATCH:
        sysData.phraseLength = 0;
        break;
      default:
        throw new Error(
          `${thisFileName}opRNM(${rule.name}): callback function return error. Unrecognized return state: ${sysData.state}`
        );
    }
  };
  // The `RNM` operator.<br>
  // This operator will acts as a root node for a parse tree branch below and
  // returns the matched phrase to its parent.
  // However, its larger responsibility is handling user-defined callback functions, back references and `AST` nodes.
  // Note that the `AST` is a separate object, but `RNM` calls its functions to create its nodes.
  // See [`ast.js`](./ast.html) for usage.
  const opRNM = function (opIndex, phraseIndex, sysData) {
    let astLength;
    let astDefined;
    let savedOpcodes;
    let ulen;
    let plen;
    let saveFrame;
    const op = opcodes[opIndex];
    const rule = rules[op.index];
    const callback = ruleCallbacks[rule.index];
    const notLookAround = !inLookAround();
    /* ignore AST and back references in lookaround */
    if (notLookAround) {
      /* begin AST and back references */
      astDefined = thisThis.ast && thisThis.ast.ruleDefined(op.index);
      if (astDefined) {
        astLength = thisThis.ast.getLength();
        thisThis.ast.down(op.index, rules[op.index].name);
      }
      ulen = sysData.uFrame.length();
      plen = sysData.pFrame.length();
      sysData.uFrame.push();
      sysData.pFrame.push();
      saveFrame = sysData.pFrame;
      sysData.pFrame = new backRef();
    }
    if (callback === null) {
      /* no callback - just execute the rule */
      savedOpcodes = opcodes;
      opcodes = rule.opcodes;
      opExecute(0, phraseIndex, sysData);
      opcodes = savedOpcodes;
    } else {
      /* call user's callback */
      const charsLeft = charsEnd - phraseIndex;
      sysData.ruleIndex = rule.index;
      callback(sysData, chars, phraseIndex, syntaxData);
      validateRnmCallbackResult(rule, sysData, charsLeft, true);
      if (sysData.state === id.ACTIVE) {
        savedOpcodes = opcodes;
        opcodes = rule.opcodes;
        opExecute(0, phraseIndex, sysData);
        opcodes = savedOpcodes;
        sysData.ruleIndex = rule.index;
        callback(sysData, chars, phraseIndex, syntaxData);
        validateRnmCallbackResult(rule, sysData, charsLeft, false);
      } /* implied else clause: just accept the callback sysData - RNM acting as UDT */
    }
    if (notLookAround) {
      /* end AST */
      if (astDefined) {
        if (sysData.state === id.NOMATCH) {
          thisThis.ast.setLength(astLength);
        } else {
          thisThis.ast.up(op.index, rule.name, phraseIndex, sysData.phraseLength);
        }
      }
      /* end back reference */
      sysData.pFrame = saveFrame;
      if (sysData.state === id.NOMATCH) {
        sysData.uFrame.pop(ulen);
        sysData.pFrame.pop(plen);
      } else if (rule.isBkr) {
        /* save phrase on both the parent and universal frames */
        /* BKR operator will decide which to use later */
        sysData.pFrame.savePhrase(rule.lower, phraseIndex, sysData.phraseLength);
        sysData.uFrame.savePhrase(rule.lower, phraseIndex, sysData.phraseLength);
      }
    }
  };
  // Validate the callback function's returned sysData values.
  // It's the user's responsibility to get it right but `UDT` fails if not.
  const validateUdtCallbackResult = function (udt, sysData, charsLeft) {
    if (sysData.phraseLength > charsLeft) {
      let str = `${thisFileName}opUDT(${udt.name}): callback function error: `;
      str += `sysData.phraseLength: ${sysData.phraseLength}`;
      str += ` must be <= remaining chars: ${charsLeft}`;
      throw new Error(str);
    }
    switch (sysData.state) {
      case id.ACTIVE:
        throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. ACTIVE state not allowed.`);
      case id.EMPTY:
        if (udt.empty === false) {
          throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. May not return EMPTY.`);
        } else {
          sysData.phraseLength = 0;
        }
        break;
      case id.MATCH:
        if (sysData.phraseLength === 0) {
          if (udt.empty === false) {
            throw new Error(`${thisFileName}opUDT(${udt.name}): callback function return error. May not return EMPTY.`);
          } else {
            sysData.state = id.EMPTY;
          }
        }
        break;
      case id.NOMATCH:
        sysData.phraseLength = 0;
        break;
      default:
        throw new Error(
          `${thisFileName}opUDT(${udt.name}): callback function return error. Unrecognized return state: ${sysData.state}`
        );
    }
  };
  // The `UDT` operator.<br>
  // Simply calls the user's callback function, but operates like `RNM` with regard to the `AST`
  // and back referencing.
  // There is some ambiguity here. `UDT`s act as terminals for phrase recognition but as named rules
  // for `AST` nodes and back referencing.
  // See [`ast.js`](./ast.html) for usage.
  const opUDT = function (opIndex, phraseIndex, sysData) {
    let astLength;
    let astIndex;
    let astDefined;
    let ulen;
    let plen;
    let saveFrame;
    const op = opcodes[opIndex];
    const udt = udts[op.index];
    sysData.UdtIndex = udt.index;

    const notLookAround = !inLookAround();
    /* ignore AST and back references in lookaround */
    if (notLookAround) {
      /* begin AST and back reference */
      astDefined = thisThis.ast && thisThis.ast.udtDefined(op.index);
      if (astDefined) {
        astIndex = rules.length + op.index;
        astLength = thisThis.ast.getLength();
        thisThis.ast.down(astIndex, udt.name);
      }
      /* NOTE: push and pop of the back reference frame is normally not necessary */
      /* only in the case that the UDT calls evaluateRule() or evaluateUdt() */
      ulen = sysData.uFrame.length();
      plen = sysData.pFrame.length();
      sysData.uFrame.push();
      sysData.pFrame.push();
      saveFrame = sysData.pFrame;
      sysData.pFrame = new backRef();
    }
    /* call the UDT */
    const charsLeft = charsEnd - phraseIndex;
    udtCallbacks[op.index](sysData, chars, phraseIndex, syntaxData);
    validateUdtCallbackResult(udt, sysData, charsLeft);
    if (notLookAround) {
      /* end AST */
      if (astDefined) {
        if (sysData.state === id.NOMATCH) {
          thisThis.ast.setLength(astLength);
        } else {
          thisThis.ast.up(astIndex, udt.name, phraseIndex, sysData.phraseLength);
        }
      }
      /* end back reference */
      sysData.pFrame = saveFrame;
      if (sysData.state === id.NOMATCH) {
        sysData.uFrame.pop(ulen);
        sysData.pFrame.pop(plen);
      } else if (udt.isBkr) {
        /* save phrase on both the parent and universal frames */
        /* BKR operator will decide which to use later */
        sysData.pFrame.savePhrase(udt.lower, phraseIndex, sysData.phraseLength);
        sysData.uFrame.savePhrase(udt.lower, phraseIndex, sysData.phraseLength);
      }
    }
  };
  // The `AND` operator.<br>
  // This is the positive `look ahead` operator.
  // Executes its single child node, returning the EMPTY state
  // if it succeedsand NOMATCH if it fails.
  // *Always* backtracks on any matched phrase and returns EMPTY on success.
  const opAND = function (opIndex, phraseIndex, sysData) {
    lookAround.push({
      lookAround: id.LOOKAROUND_AHEAD,
      anchor: phraseIndex,
      charsEnd,
      charsLength,
    });
    charsEnd = chars.length;
    charsLength = chars.length - charsBegin;
    opExecute(opIndex + 1, phraseIndex, sysData);
    const pop = lookAround.pop();
    charsEnd = pop.charsEnd;
    charsLength = pop.charsLength;
    sysData.phraseLength = 0;
    switch (sysData.state) {
      case id.EMPTY:
        sysData.state = id.EMPTY;
        break;
      case id.MATCH:
        sysData.state = id.EMPTY;
        break;
      case id.NOMATCH:
        sysData.state = id.NOMATCH;
        break;
      default:
        throw new Error(`opAND: invalid state ${sysData.state}`);
    }
  };
  // The `NOT` operator.<br>
  // This is the negative `look ahead` operator.
  // Executes its single child node, returning the EMPTY state
  // if it *fails* and NOMATCH if it succeeds.
  // *Always* backtracks on any matched phrase and returns EMPTY
  // on success (failure of its child node).
  const opNOT = function (opIndex, phraseIndex, sysData) {
    lookAround.push({
      lookAround: id.LOOKAROUND_AHEAD,
      anchor: phraseIndex,
      charsEnd,
      charsLength,
    });
    charsEnd = chars.length;
    charsLength = chars.length - charsBegin;
    opExecute(opIndex + 1, phraseIndex, sysData);
    const pop = lookAround.pop();
    charsEnd = pop.charsEnd;
    charsLength = pop.charsLength;
    sysData.phraseLength = 0;
    switch (sysData.state) {
      case id.EMPTY:
      case id.MATCH:
        sysData.state = id.NOMATCH;
        break;
      case id.NOMATCH:
        sysData.state = id.EMPTY;
        break;
      default:
        throw new Error(`opNOT: invalid state ${sysData.state}`);
    }
  };
  // The `TRG` operator.<br>
  // Succeeds if the single first character of the phrase is
  // within the `min - max` range.
  const opTRG = function (opIndex, phraseIndex, sysData) {
    const op = opcodes[opIndex];
    sysData.state = id.NOMATCH;
    if (phraseIndex < charsEnd) {
      if (op.min <= chars[phraseIndex] && chars[phraseIndex] <= op.max) {
        sysData.state = id.MATCH;
        sysData.phraseLength = 1;
      }
    }
  };
  // The `TBS` operator.<br>
  // Matches its pre-defined phrase against the input string.
  // All characters must match exactly.
  // Case-sensitive literal strings (`'string'` & `%s"string"`) are translated to `TBS`
  // operators by `apg`.
  // Phrase length of zero is not allowed.
  // Empty phrases can only be defined with `TLS` operators.
  const opTBS = function (opIndex, phraseIndex, sysData) {
    let i;
    const op = opcodes[opIndex];
    const len = op.string.length;
    sysData.state = id.NOMATCH;
    if (phraseIndex + len <= charsEnd) {
      for (i = 0; i < len; i += 1) {
        if (chars[phraseIndex + i] !== op.string[i]) {
          return;
        }
      }
      sysData.state = id.MATCH;
      sysData.phraseLength = len;
    } /* implied else NOMATCH */
  };
  // The `TLS` operator.<br>
  // Matches its pre-defined phrase against the input string.
  // A case-insensitive match is attempted for ASCII alphbetical characters.
  // `TLS` is the only operator that explicitly allows empty phrases.
  // `apg` will fail for empty `TBS`, case-sensitive strings (`''`) or
  // zero repetitions (`0*0RuleName` or `0RuleName`).
  const opTLS = function (opIndex, phraseIndex, sysData) {
    let i;
    let code;
    const op = opcodes[opIndex];
    sysData.state = id.NOMATCH;
    const len = op.string.length;
    if (len === 0) {
      /* EMPTY match allowed for TLS */
      sysData.state = id.EMPTY;
      return;
    }
    if (phraseIndex + len <= charsEnd) {
      for (i = 0; i < len; i += 1) {
        code = chars[phraseIndex + i];
        if (code >= 65 && code <= 90) {
          code += 32;
        }
        if (code !== op.string[i]) {
          return;
        }
      }
      sysData.state = id.MATCH;
      sysData.phraseLength = len;
    } /* implied else NOMATCH */
  };
  // The `ABG` operator.<br>
  // This is an "anchor" for the beginning of the string, similar to the familiar regex `^` anchor.
  // An anchor matches a position rather than a phrase.
  // Returns EMPTY if `phraseIndex` is 0, NOMATCH otherwise.
  const opABG = function (opIndex, phraseIndex, sysData) {
    sysData.state = id.NOMATCH;
    sysData.phraseLength = 0;
    sysData.state = phraseIndex === 0 ? id.EMPTY : id.NOMATCH;
  };
  // The `AEN` operator.<br>
  // This is an "anchor" for the end of the string, similar to the familiar regex `$` anchor.
  // An anchor matches a position rather than a phrase.
  // Returns EMPTY if `phraseIndex` equals the input string length, NOMATCH otherwise.
  const opAEN = function (opIndex, phraseIndex, sysData) {
    sysData.state = id.NOMATCH;
    sysData.phraseLength = 0;
    sysData.state = phraseIndex === chars.length ? id.EMPTY : id.NOMATCH;
  };
  // The `BKR` operator.<br>
  // The back reference operator.
  // Matches the last matched phrase of the named rule or UDT against the input string.
  // For ASCII alphbetical characters the match may be case sensitive (`%s`) or insensitive (`%i`),
  // depending on the back reference definition.
  // For `universal` mode (`%u`) matches the last phrase found anywhere in the grammar.
  // For `parent frame` mode (`%p`) matches the last phrase found in the parent rule only.
  const opBKR = function (opIndex, phraseIndex, sysData) {
    let i;
    let code;
    let lmcode;
    let lower;
    const op = opcodes[opIndex];
    sysData.state = id.NOMATCH;
    if (op.index < rules.length) {
      lower = rules[op.index].lower;
    } else {
      lower = udts[op.index - rules.length].lower;
    }
    const frame = op.bkrMode === id.BKR_MODE_PM ? sysData.pFrame.getPhrase(lower) : sysData.uFrame.getPhrase(lower);
    const insensitive = op.bkrCase === id.BKR_MODE_CI;
    if (frame === null) {
      return;
    }
    const lmIndex = frame.phraseIndex;
    const len = frame.phraseLength;
    if (len === 0) {
      sysData.state = id.EMPTY;
      return;
    }
    if (phraseIndex + len <= charsEnd) {
      if (insensitive) {
        /* case-insensitive match */
        for (i = 0; i < len; i += 1) {
          code = chars[phraseIndex + i];
          lmcode = chars[lmIndex + i];
          if (code >= 65 && code <= 90) {
            code += 32;
          }
          if (lmcode >= 65 && lmcode <= 90) {
            lmcode += 32;
          }
          if (code !== lmcode) {
            return;
          }
        }
        sysData.state = id.MATCH;
        sysData.phraseLength = len;
      } else {
        /* case-sensitive match */
        for (i = 0; i < len; i += 1) {
          code = chars[phraseIndex + i];
          lmcode = chars[lmIndex + i];
          if (code !== lmcode) {
            return;
          }
        }
      }
      sysData.state = id.MATCH;
      sysData.phraseLength = len;
    }
  };
  // The `BKA` operator.<br>
  // This is the positive `look behind` operator.
  // It's child node is parsed right-to-left.
  // Returns the EMPTY state if a match is found, NOMATCH otherwise.
  // Like the look ahead operators, it always backtracks to `phraseIndex`.
  const opBKA = function (opIndex, phraseIndex, sysData) {
    lookAround.push({
      lookAround: id.LOOKAROUND_BEHIND,
      anchor: phraseIndex,
    });
    opExecute(opIndex + 1, phraseIndex, sysData);
    lookAround.pop();
    sysData.phraseLength = 0;
    switch (sysData.state) {
      case id.EMPTY:
        sysData.state = id.EMPTY;
        break;
      case id.MATCH:
        sysData.state = id.EMPTY;
        break;
      case id.NOMATCH:
        sysData.state = id.NOMATCH;
        break;
      default:
        throw new Error(`opBKA: invalid state ${sysData.state}`);
    }
  };
  // The `BKN` operator.<br>
  // This is the negative `look behind` operator.
  // It's child node is parsed right-to-left.
  // Returns the EMPTY state if a match is *not* found, NOMATCH otherwise.
  // Like the look ahead operators, it always backtracks to `phraseIndex`.
  const opBKN = function (opIndex, phraseIndex, sysData) {
    // let op;
    // op = opcodes[opIndex];
    lookAround.push({
      lookAround: id.LOOKAROUND_BEHIND,
      anchor: phraseIndex,
    });
    opExecute(opIndex + 1, phraseIndex, sysData);
    lookAround.pop();
    sysData.phraseLength = 0;
    switch (sysData.state) {
      case id.EMPTY:
      case id.MATCH:
        sysData.state = id.NOMATCH;
        break;
      case id.NOMATCH:
        sysData.state = id.EMPTY;
        break;
      default:
        throw new Error(`opBKN: invalid state ${sysData.state}`);
    }
  };
  // The right-to-left `CAT` operator.<br>
  // Called for `CAT` operators when in look behind mode.
  // Calls its child nodes from right to left concatenating matched phrases right to left.
  const opCATBehind = function (opIndex, phraseIndex, sysData) {
    let success;
    let astLength;
    let catCharIndex;
    let catMatched;
    const op = opcodes[opIndex];
    const ulen = sysData.uFrame.length();
    const plen = sysData.pFrame.length();
    if (thisThis.ast) {
      astLength = thisThis.ast.getLength();
    }
    success = true;
    catCharIndex = phraseIndex;
    catMatched = 0;
    // catPhrase = 0;
    for (let i = op.children.length - 1; i >= 0; i -= 1) {
      opExecute(op.children[i], catCharIndex, sysData);
      catCharIndex -= sysData.phraseLength;
      catMatched += sysData.phraseLength;
      // catPhrase += sysData.phraseLength;
      if (sysData.state === id.NOMATCH) {
        success = false;
        break;
      }
    }
    if (success) {
      sysData.state = catMatched === 0 ? id.EMPTY : id.MATCH;
      sysData.phraseLength = catMatched;
    } else {
      sysData.state = id.NOMATCH;
      sysData.phraseLength = 0;
      sysData.uFrame.pop(ulen);
      sysData.pFrame.pop(plen);
      if (thisThis.ast) {
        thisThis.ast.setLength(astLength);
      }
    }
  };
  // The right-to-left `REP` operator.<br>
  // Called for `REP` operators in look behind mode.
  // Makes repeated calls to its child node, concatenating matched phrases right to left.
  const opREPBehind = function (opIndex, phraseIndex, sysData) {
    let astLength;
    let repCharIndex;
    let repPhrase;
    let repCount;
    const op = opcodes[opIndex];
    repCharIndex = phraseIndex;
    repPhrase = 0;
    repCount = 0;
    const ulen = sysData.uFrame.length();
    const plen = sysData.pFrame.length();
    if (thisThis.ast) {
      astLength = thisThis.ast.getLength();
    }
    const TRUE = true;
    while (TRUE) {
      if (repCharIndex <= 0) {
        /* exit on end of input string */
        break;
      }
      opExecute(opIndex + 1, repCharIndex, sysData);
      if (sysData.state === id.NOMATCH) {
        /* always end if the child node fails */
        break;
      }
      if (sysData.state === id.EMPTY) {
        /* REP always succeeds when the child node returns an empty phrase */
        /* this may not seem obvious, but that's the way it works out */
        break;
      }
      repCount += 1;
      repPhrase += sysData.phraseLength;
      repCharIndex -= sysData.phraseLength;
      if (repCount === op.max) {
        /* end on maxed out reps */
        break;
      }
    }
    /* evaluate the match count according to the min, max values */
    if (sysData.state === id.EMPTY) {
      sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
      sysData.phraseLength = repPhrase;
    } else if (repCount >= op.min) {
      sysData.state = repPhrase === 0 ? id.EMPTY : id.MATCH;
      sysData.phraseLength = repPhrase;
    } else {
      sysData.state = id.NOMATCH;
      sysData.phraseLength = 0;
      sysData.uFrame.pop(ulen);
      sysData.pFrame.pop(plen);
      if (thisThis.ast) {
        thisThis.ast.setLength(astLength);
      }
    }
  };
  // The right-to-left `TRG` operator.<br>
  // Called for `TRG` operators in look behind mode.
  // Matches a single character at `phraseIndex - 1` to the `min` - `max` range.
  const opTRGBehind = function (opIndex, phraseIndex, sysData) {
    const op = opcodes[opIndex];
    sysData.state = id.NOMATCH;
    sysData.phraseLength = 0;
    if (phraseIndex > 0) {
      const char = chars[phraseIndex - 1];
      if (op.min <= char && char <= op.max) {
        sysData.state = id.MATCH;
        sysData.phraseLength = 1;
      }
    }
  };
  // The right-to-left `TBS` operator.<br>
  // Called for `TBS` operators in look behind mode.
  // Matches the `TBS` phrase to the left of `phraseIndex`.
  const opTBSBehind = function (opIndex, phraseIndex, sysData) {
    let i;
    const op = opcodes[opIndex];
    sysData.state = id.NOMATCH;
    const len = op.string.length;
    const beg = phraseIndex - len;
    if (beg >= 0) {
      for (i = 0; i < len; i += 1) {
        if (chars[beg + i] !== op.string[i]) {
          return;
        }
      }
      sysData.state = id.MATCH;
      sysData.phraseLength = len;
    }
  };
  // The right-to-left `TLS` operator.<br>
  // Called for `TLS` operators in look behind mode.
  // Matches the `TLS` phrase to the left of `phraseIndex`.
  const opTLSBehind = function (opIndex, phraseIndex, sysData) {
    let char;
    const op = opcodes[opIndex];
    sysData.state = id.NOMATCH;
    const len = op.string.length;
    if (len === 0) {
      /* EMPTY match allowed for TLS */
      sysData.state = id.EMPTY;
      return;
    }
    const beg = phraseIndex - len;
    if (beg >= 0) {
      for (let i = 0; i < len; i += 1) {
        char = chars[beg + i];
        if (char >= 65 && char <= 90) {
          char += 32;
        }
        if (char !== op.string[i]) {
          return;
        }
      }
      sysData.state = id.MATCH;
      sysData.phraseLength = len;
    }
  };
  // The right-to-left back reference operator.<br>
  // Matches the back referenced phrase to the left of `phraseIndex`.
  const opBKRBehind = function (opIndex, phraseIndex, sysData) {
    let i;
    let code;
    let lmcode;
    let lower;
    const op = opcodes[opIndex];
    /* NOMATCH default */
    sysData.state = id.NOMATCH;
    sysData.phraseLength = 0;
    if (op.index < rules.length) {
      lower = rules[op.index].lower;
    } else {
      lower = udts[op.index - rules.length].lower;
    }
    const frame = op.bkrMode === id.BKR_MODE_PM ? sysData.pFrame.getPhrase(lower) : sysData.uFrame.getPhrase(lower);
    const insensitive = op.bkrCase === id.BKR_MODE_CI;
    if (frame === null) {
      return;
    }
    const lmIndex = frame.phraseIndex;
    const len = frame.phraseLength;
    if (len === 0) {
      sysData.state = id.EMPTY;
      sysData.phraseLength = 0;
      return;
    }
    const beg = phraseIndex - len;
    if (beg >= 0) {
      if (insensitive) {
        /* case-insensitive match */
        for (i = 0; i < len; i += 1) {
          code = chars[beg + i];
          lmcode = chars[lmIndex + i];
          if (code >= 65 && code <= 90) {
            code += 32;
          }
          if (lmcode >= 65 && lmcode <= 90) {
            lmcode += 32;
          }
          if (code !== lmcode) {
            return;
          }
        }
        sysData.state = id.MATCH;
        sysData.phraseLength = len;
      } else {
        /* case-sensitive match */
        for (i = 0; i < len; i += 1) {
          code = chars[beg + i];
          lmcode = chars[lmIndex + i];
          if (code !== lmcode) {
            return;
          }
        }
      }
      sysData.state = id.MATCH;
      sysData.phraseLength = len;
    }
  };
  // Generalized execution function.<br>
  // Having a single, generalized function, allows a single location
  // for tracing and statistics gathering functions to be called.
  // Tracing and statistics are handled in separate objects.
  // However, the parser calls their API to build the object data records.
  // See [`trace.js`](./trace.html) and [`stats.js`](./stats.html) for their
  // usage.
  opExecute = function opExecuteFunc(opIndex, phraseIndex, sysData) {
    let ret = true;
    const op = opcodes[opIndex];
    nodeHits += 1;
    if (nodeHits > limitNodeHits) {
      throw new Error(`parser: maximum number of node hits exceeded: ${limitNodeHits}`);
    }
    treeDepth += 1;
    if (treeDepth > maxTreeDepth) {
      maxTreeDepth = treeDepth;
      if (maxTreeDepth > limitTreeDepth) {
        throw new Error(`parser: maximum parse tree depth exceeded: ${limitTreeDepth}`);
      }
    }
    sysData.refresh();
    if (thisThis.trace !== null) {
      /* collect the trace record for down the parse tree */
      const lk = lookAroundValue();
      thisThis.trace.down(op, sysData.state, phraseIndex, sysData.phraseLength, lk.anchor, lk.lookAround);
    }
    if (inLookBehind()) {
      switch (op.type) {
        case id.ALT:
          opALT(opIndex, phraseIndex, sysData);
          break;
        case id.CAT:
          opCATBehind(opIndex, phraseIndex, sysData);
          break;
        case id.REP:
          opREPBehind(opIndex, phraseIndex, sysData);
          break;
        case id.RNM:
          opRNM(opIndex, phraseIndex, sysData);
          break;
        case id.UDT:
          opUDT(opIndex, phraseIndex, sysData);
          break;
        case id.AND:
          opAND(opIndex, phraseIndex, sysData);
          break;
        case id.NOT:
          opNOT(opIndex, phraseIndex, sysData);
          break;
        case id.TRG:
          opTRGBehind(opIndex, phraseIndex, sysData);
          break;
        case id.TBS:
          opTBSBehind(opIndex, phraseIndex, sysData);
          break;
        case id.TLS:
          opTLSBehind(opIndex, phraseIndex, sysData);
          break;
        case id.BKR:
          opBKRBehind(opIndex, phraseIndex, sysData);
          break;
        case id.BKA:
          opBKA(opIndex, phraseIndex, sysData);
          break;
        case id.BKN:
          opBKN(opIndex, phraseIndex, sysData);
          break;
        case id.ABG:
          opABG(opIndex, phraseIndex, sysData);
          break;
        case id.AEN:
          opAEN(opIndex, phraseIndex, sysData);
          break;
        default:
          ret = false;
          break;
      }
    } else {
      switch (op.type) {
        case id.ALT:
          opALT(opIndex, phraseIndex, sysData);
          break;
        case id.CAT:
          opCAT(opIndex, phraseIndex, sysData);
          break;
        case id.REP:
          opREP(opIndex, phraseIndex, sysData);
          break;
        case id.RNM:
          opRNM(opIndex, phraseIndex, sysData);
          break;
        case id.UDT:
          opUDT(opIndex, phraseIndex, sysData);
          break;
        case id.AND:
          opAND(opIndex, phraseIndex, sysData);
          break;
        case id.NOT:
          opNOT(opIndex, phraseIndex, sysData);
          break;
        case id.TRG:
          opTRG(opIndex, phraseIndex, sysData);
          break;
        case id.TBS:
          opTBS(opIndex, phraseIndex, sysData);
          break;
        case id.TLS:
          opTLS(opIndex, phraseIndex, sysData);
          break;
        case id.BKR:
          opBKR(opIndex, phraseIndex, sysData);
          break;
        case id.BKA:
          opBKA(opIndex, phraseIndex, sysData);
          break;
        case id.BKN:
          opBKN(opIndex, phraseIndex, sysData);
          break;
        case id.ABG:
          opABG(opIndex, phraseIndex, sysData);
          break;
        case id.AEN:
          opAEN(opIndex, phraseIndex, sysData);
          break;
        default:
          ret = false;
          break;
      }
    }
    if (!inLookAround() && phraseIndex + sysData.phraseLength > maxMatched) {
      maxMatched = phraseIndex + sysData.phraseLength;
    }
    if (thisThis.stats !== null) {
      /* collect the statistics */
      thisThis.stats.collect(op, sysData);
    }
    if (thisThis.trace !== null) {
      /* collect the trace record for up the parse tree */
      const lk = lookAroundValue();
      thisThis.trace.up(op, sysData.state, phraseIndex, sysData.phraseLength, lk.anchor, lk.lookAround);
    }
    treeDepth -= 1;
    return ret;
  };
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-lib/stats.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module is the constructor for the statistics gathering object.
// The statistics are nothing more than keeping a count of the
// number of times each node in the parse tree is traversed.
//
// Counts are collected for each of the individual types of operators.
// Additionally, counts are collected for each of the individually named
// `RNM` and `UDT` operators.
module.exports = function statsFunc() {
  const id = __webpack_require__("../../node_modules/apg-js/src/apg-lib/identifiers.js");
  const utils = __webpack_require__("../../node_modules/apg-js/src/apg-lib/utilities.js");
  const style = __webpack_require__("../../node_modules/apg-js/src/apg-lib/style.js");

  const thisFileName = 'stats.js: ';
  let rules = [];
  let udts = [];
  const stats = [];
  let totals;
  const ruleStats = [];
  const udtStats = [];
  this.statsObject = 'statsObject';
  const nameId = 'stats';
  /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators alphabetically by name. */
  const sortAlpha = function sortAlpha(lhs, rhs) {
    if (lhs.lower < rhs.lower) {
      return -1;
    }
    if (lhs.lower > rhs.lower) {
      return 1;
    }
    return 0;
  };
  /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators by hit count. */
  const sortHits = function sortHits(lhs, rhs) {
    if (lhs.total < rhs.total) {
      return 1;
    }
    if (lhs.total > rhs.total) {
      return -1;
    }
    return sortAlpha(lhs, rhs);
  };
  /* `Array.sort()` callback function for sorting `RNM` and `UDT` operators by index */
  /* (in the order in which they appear in the SABNF grammar). */
  const sortIndex = function sortIndex(lhs, rhs) {
    if (lhs.index < rhs.index) {
      return -1;
    }
    if (lhs.index > rhs.index) {
      return 1;
    }
    return 0;
  };
  const EmptyStat = function EmptyStat() {
    this.empty = 0;
    this.match = 0;
    this.nomatch = 0;
    this.total = 0;
  };
  /* Zero out all stats */
  const clear = function clear() {
    stats.length = 0;
    totals = new EmptyStat();
    stats[id.ALT] = new EmptyStat();
    stats[id.CAT] = new EmptyStat();
    stats[id.REP] = new EmptyStat();
    stats[id.RNM] = new EmptyStat();
    stats[id.TRG] = new EmptyStat();
    stats[id.TBS] = new EmptyStat();
    stats[id.TLS] = new EmptyStat();
    stats[id.UDT] = new EmptyStat();
    stats[id.AND] = new EmptyStat();
    stats[id.NOT] = new EmptyStat();
    stats[id.BKR] = new EmptyStat();
    stats[id.BKA] = new EmptyStat();
    stats[id.BKN] = new EmptyStat();
    stats[id.ABG] = new EmptyStat();
    stats[id.AEN] = new EmptyStat();
    ruleStats.length = 0;
    for (let i = 0; i < rules.length; i += 1) {
      ruleStats.push({
        empty: 0,
        match: 0,
        nomatch: 0,
        total: 0,
        name: rules[i].name,
        lower: rules[i].lower,
        index: rules[i].index,
      });
    }
    if (udts.length > 0) {
      udtStats.length = 0;
      for (let i = 0; i < udts.length; i += 1) {
        udtStats.push({
          empty: 0,
          match: 0,
          nomatch: 0,
          total: 0,
          name: udts[i].name,
          lower: udts[i].lower,
          index: udts[i].index,
        });
      }
    }
  };
  /* increment the designated operator hit count by one */
  const incStat = function incStat(stat, state) {
    stat.total += 1;
    switch (state) {
      case id.EMPTY:
        stat.empty += 1;
        break;
      case id.MATCH:
        stat.match += 1;
        break;
      case id.NOMATCH:
        stat.nomatch += 1;
        break;
      default:
        throw new Error(`${thisFileName}collect(): incStat(): unrecognized state: ${state}`);
    }
  };
  /* helper for toHtml() */
  const displayRow = function displayRow(name, stat) {
    let html = '';
    html += '<tr>';
    html += `<td class="${style.CLASS_ACTIVE}">${name}</td>`;
    html += `<td class="${style.CLASS_EMPTY}">${stat.empty}</td>`;
    html += `<td class="${style.CLASS_MATCH}">${stat.match}</td>`;
    html += `<td class="${style.CLASS_NOMATCH}">${stat.nomatch}</td>`;
    html += `<td class="${style.CLASS_ACTIVE}">${stat.total}</td>`;
    html += '</tr>\n';
    return html;
  };
  const displayOpsOnly = function displayOpsOnly() {
    let html = '';
    html += displayRow('ALT', stats[id.ALT]);
    html += displayRow('CAT', stats[id.CAT]);
    html += displayRow('REP', stats[id.REP]);
    html += displayRow('RNM', stats[id.RNM]);
    html += displayRow('TRG', stats[id.TRG]);
    html += displayRow('TBS', stats[id.TBS]);
    html += displayRow('TLS', stats[id.TLS]);
    html += displayRow('UDT', stats[id.UDT]);
    html += displayRow('AND', stats[id.AND]);
    html += displayRow('NOT', stats[id.NOT]);
    html += displayRow('BKR', stats[id.BKR]);
    html += displayRow('BKA', stats[id.BKA]);
    html += displayRow('BKN', stats[id.BKN]);
    html += displayRow('ABG', stats[id.ABG]);
    html += displayRow('AEN', stats[id.AEN]);
    html += displayRow('totals', totals);
    return html;
  };
  /* helper for toHtml() */
  const displayRules = function displayRules() {
    let html = '';
    html += '<tr><th></th><th></th><th></th><th></th><th></th></tr>\n';
    html += '<tr><th>rules</th><th></th><th></th><th></th><th></th></tr>\n';
    for (let i = 0; i < rules.length; i += 1) {
      if (ruleStats[i].total > 0) {
        html += '<tr>';
        html += `<td class="${style.CLASS_ACTIVE}">${ruleStats[i].name}</td>`;
        html += `<td class="${style.CLASS_EMPTY}">${ruleStats[i].empty}</td>`;
        html += `<td class="${style.CLASS_MATCH}">${ruleStats[i].match}</td>`;
        html += `<td class="${style.CLASS_NOMATCH}">${ruleStats[i].nomatch}</td>`;
        html += `<td class="${style.CLASS_ACTIVE}">${ruleStats[i].total}</td>`;
        html += '</tr>\n';
      }
    }
    if (udts.length > 0) {
      html += '<tr><th></th><th></th><th></th><th></th><th></th></tr>\n';
      html += '<tr><th>udts</th><th></th><th></th><th></th><th></th></tr>\n';
      for (let i = 0; i < udts.length; i += 1) {
        if (udtStats[i].total > 0) {
          html += '<tr>';
          html += `<td class="${style.CLASS_ACTIVE}">${udtStats[i].name}</td>`;
          html += `<td class="${style.CLASS_EMPTY}">${udtStats[i].empty}</td>`;
          html += `<td class="${style.CLASS_MATCH}">${udtStats[i].match}</td>`;
          html += `<td class="${style.CLASS_NOMATCH}">${udtStats[i].nomatch}</td>`;
          html += `<td class="${style.CLASS_ACTIVE}">${udtStats[i].total}</td>`;
          html += '</tr>\n';
        }
      }
    }
    return html;
  };
  /* called only by the parser to validate a stats object */
  this.validate = function validate(name) {
    let ret = false;
    if (typeof name === 'string' && nameId === name) {
      ret = true;
    }
    return ret;
  };
  /* no verification of input - only called by parser() */
  this.init = function init(inputRules, inputUdts) {
    rules = inputRules;
    udts = inputUdts;
    clear();
  };
  /* This function is the main interaction with the parser. */
  /* The parser calls it after each node has been traversed. */
  this.collect = function collect(op, result) {
    incStat(totals, result.state, result.phraseLength);
    incStat(stats[op.type], result.state, result.phraseLength);
    if (op.type === id.RNM) {
      incStat(ruleStats[op.index], result.state, result.phraseLength);
    }
    if (op.type === id.UDT) {
      incStat(udtStats[op.index], result.state, result.phraseLength);
    }
  };
  // Display the statistics as an HTML table.
  // - *type*
  //   - "ops" - (default) display only the total hit counts for all operator types.
  //   - "index" - additionally, display the hit counts for the individual `RNM` and `UDT` operators ordered by index.
  //   - "hits" - additionally, display the hit counts for the individual `RNM` and `UDT` operators by hit count.
  //   - "alpha" - additionally, display the hit counts for the individual `RNM` and `UDT` operators by name alphabetically.
  // - *caption* - optional caption for the table
  this.toHtml = function toHtml(type, caption) {
    let html = '';
    html += `<table class="${style.CLASS_STATS}">\n`;
    if (typeof caption === 'string') {
      html += `<caption>${caption}</caption>\n`;
    }
    html += `<tr><th class="${style.CLASS_ACTIVE}">ops</th>\n`;
    html += `<th class="${style.CLASS_EMPTY}">EMPTY</th>\n`;
    html += `<th class="${style.CLASS_MATCH}">MATCH</th>\n`;
    html += `<th class="${style.CLASS_NOMATCH}">NOMATCH</th>\n`;
    html += `<th class="${style.CLASS_ACTIVE}">totals</th></tr>\n`;
    const test = true;
    while (test) {
      if (type === undefined) {
        html += displayOpsOnly();
        break;
      }
      if (type === null) {
        html += displayOpsOnly();
        break;
      }
      if (type === 'ops') {
        html += displayOpsOnly();
        break;
      }
      if (type === 'index') {
        ruleStats.sort(sortIndex);
        if (udtStats.length > 0) {
          udtStats.sort(sortIndex);
        }
        html += displayOpsOnly();
        html += displayRules();
        break;
      }
      if (type === 'hits') {
        ruleStats.sort(sortHits);
        if (udtStats.length > 0) {
          udtStats.sort(sortIndex);
        }
        html += displayOpsOnly();
        html += displayRules();
        break;
      }
      if (type === 'alpha') {
        ruleStats.sort(sortAlpha);
        if (udtStats.length > 0) {
          udtStats.sort(sortAlpha);
        }
        html += displayOpsOnly();
        html += displayRules();
        break;
      }
      break;
    }
    html += '</table>\n';
    return html;
  };
  // Display the stats table in a complete HTML5 page.
  this.toHtmlPage = function toHtmlPage(type, caption, title) {
    return utils.htmlToPage(this.toHtml(type, caption), title);
  };
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-lib/style.js":
/***/ ((module) => {

module.exports = {

  // Generated by apglib/style.js 
  CLASS_MONOSPACE: 'apg-mono',
  CLASS_ACTIVE: 'apg-active',
  CLASS_EMPTY: 'apg-empty',
  CLASS_MATCH: 'apg-match',
  CLASS_NOMATCH: 'apg-nomatch',
  CLASS_LOOKAHEAD: 'apg-lh-match',
  CLASS_LOOKBEHIND: 'apg-lb-match',
  CLASS_REMAINDER: 'apg-remainder',
  CLASS_CTRLCHAR: 'apg-ctrl-char',
  CLASS_LINEEND: 'apg-line-end',
  CLASS_ERROR: 'apg-error',
  CLASS_PHRASE: 'apg-phrase',
  CLASS_EMPTYPHRASE: 'apg-empty-phrase',
  CLASS_STATE: 'apg-state',
  CLASS_STATS: 'apg-stats',
  CLASS_TRACE: 'apg-trace',
  CLASS_GRAMMAR: 'apg-grammar',
  CLASS_RULES: 'apg-rules',
  CLASS_RULESLINK: 'apg-rules-link',
  CLASS_ATTRIBUTES: 'apg-attrs',
}


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-lib/trace.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable func-names */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module provides a means of tracing the parser through the parse tree as it goes.
// It is the primary debugging facility for debugging both the SABNF grammar syntax
// and the input strings that are supposed to be valid grammar sentences.
// It is also a very informative and educational tool for understanding
// how a parser actually operates for a given language.
//
// Tracing is the process of generating and saving a record of information for each passage
// of the parser through a parse tree node. And since it traverses each node twice, once down the tree
// and once coming back up, there are two records for each node.
// This, obviously, has the potential of generating lots of records.
// And since these records are normally displayed on a web page
// it is important to have a means to limit the actual number of records generated to
// probably no more that a few thousand. This is almost always enough to find any errors.
// The problem is to get the *right* few thousand records.
// Therefore, this module has a number of ways of limiting and/or filtering, the number and type of records.
// Considerable effort has been made to make this filtering of the trace output as simple
// and intuitive as possible.
//
// However, the ability to filter the trace records, or for that matter even understand what they are
// and the information they contain, does require a minimum amount of understanding of the APG parsing
// method. The parse tree nodes are all represented by APG operators. They break down into two natural groups.
// - The `RNM` operators and `UDT` operators are named phrases.
// These are names chosen by the writer of the SABNF grammar to represent special phrases of interest.
// - All others collect, concatenate and otherwise manipulate various intermediate phrases along the way.
//
// There are separate means of filtering which of these operators in each of these two groups get traced.
// Let `trace` be an instantiated `trace.js` object.
// Prior to parsing the string, filtering the rules and UDTs can be defined as follows:
// ```
// trace.filter.rules["rulename"] = true;
//     /* trace rule name "rulename" */
// trace.filter.rules["udtname"]  = true;
//     /* trace UDT name "udtname" */
// trace.filter.rules["<ALL>"]    = true;
//     /* trace all rules and UDTs (the default) */
// trace.filter.rules["<NONE>"]   = true;
//     /* trace no rules or UDTS */
// ```
// If any rule or UDT name other than "&lt;ALL>" or "&lt;NONE>" is specified, all other names are turned off.
// Therefore, to be selective of rule names, a filter statement is required for each rule/UDT name desired.
//
// Filtering of the other operators follows a similar procedure.
// ```
// trace.filter.operators["TRG"] = true;
//     /* trace the terminal range, TRG, operators */
// trace.filter.operators["CAT"]  = true;
//     /* trace the concatenations, CAT, operators */
// trace.filter.operators["<ALL>"]    = true;
//     /* trace all operators */
// trace.filter.operators["<NONE>"]   = true;
//     /* trace no operators (the default) */
// ```
// If any operator name other than "&lt;ALL>" or "&lt;NONE>" is specified, all other names are turned off.
// Therefore, to be selective of operator names, a filter statement is required for each name desired.
//
// There is, additionally, a means for limiting the total number of filtered or saved trace records.
// See the function, `setMaxRecords(max)` below. This will result in only the last `max` records being saved.
//
// (See [`apg-examples`](https://github.com/ldthomas/apg-js-examples) for examples of using `trace.js`.)
module.exports = function exportTrace() {
  const utils = __webpack_require__("../../node_modules/apg-js/src/apg-lib/utilities.js");
  const style = __webpack_require__("../../node_modules/apg-js/src/apg-lib/style.js");
  const circular = new (__webpack_require__("../../node_modules/apg-js/src/apg-lib/circular-buffer.js"))();
  const id = __webpack_require__("../../node_modules/apg-js/src/apg-lib/identifiers.js");

  const thisFileName = 'trace.js: ';
  const that = this;
  const MODE_HEX = 16;
  const MODE_DEC = 10;
  const MODE_ASCII = 8;
  const MODE_UNICODE = 32;
  const MAX_PHRASE = 80;
  const MAX_TLS = 5;
  const records = [];
  let maxRecords = 5000;
  let lastRecord = -1;
  let filteredRecords = 0;
  let treeDepth = 0;
  const recordStack = [];
  let chars = null;
  let rules = null;
  let udts = null;
  const operatorFilter = [];
  const ruleFilter = [];
  /* special trace table phrases */
  const PHRASE_END = `<span class="${style.CLASS_LINEEND}">&bull;</span>`;
  const PHRASE_CONTINUE = `<span class="${style.CLASS_LINEEND}">&hellip;</span>`;
  const PHRASE_EMPTY = `<span class="${style.CLASS_EMPTY}">&#120634;</span>`;
  /* filter the non-RNM & non-UDT operators */
  const initOperatorFilter = function () {
    const setOperators = function (set) {
      operatorFilter[id.ALT] = set;
      operatorFilter[id.CAT] = set;
      operatorFilter[id.REP] = set;
      operatorFilter[id.TLS] = set;
      operatorFilter[id.TBS] = set;
      operatorFilter[id.TRG] = set;
      operatorFilter[id.AND] = set;
      operatorFilter[id.NOT] = set;
      operatorFilter[id.BKR] = set;
      operatorFilter[id.BKA] = set;
      operatorFilter[id.BKN] = set;
      operatorFilter[id.ABG] = set;
      operatorFilter[id.AEN] = set;
    };
    let items = 0;
    // eslint-disable-next-line no-unused-vars
    for (const name in that.filter.operators) {
      items += 1;
    }
    if (items === 0) {
      /* case 1: no operators specified: default: do not trace any operators */
      setOperators(false);
      return;
    }
    for (const name in that.filter.operators) {
      const upper = name.toUpperCase();
      if (upper === '<ALL>') {
        /* case 2: <all> operators specified: trace all operators ignore all other operator commands */
        setOperators(true);
        return;
      }
      if (upper === '<NONE>') {
        /* case 3: <none> operators specified: trace NO operators ignore all other operator commands */
        setOperators(false);
        return;
      }
    }
    setOperators(false);
    for (const name in that.filter.operators) {
      const upper = name.toUpperCase();
      /* case 4: one or more individual operators specified: trace 'true' operators only */
      if (upper === 'ALT') {
        operatorFilter[id.ALT] = that.filter.operators[name] === true;
      } else if (upper === 'CAT') {
        operatorFilter[id.CAT] = that.filter.operators[name] === true;
      } else if (upper === 'REP') {
        operatorFilter[id.REP] = that.filter.operators[name] === true;
      } else if (upper === 'AND') {
        operatorFilter[id.AND] = that.filter.operators[name] === true;
      } else if (upper === 'NOT') {
        operatorFilter[id.NOT] = that.filter.operators[name] === true;
      } else if (upper === 'TLS') {
        operatorFilter[id.TLS] = that.filter.operators[name] === true;
      } else if (upper === 'TBS') {
        operatorFilter[id.TBS] = that.filter.operators[name] === true;
      } else if (upper === 'TRG') {
        operatorFilter[id.TRG] = that.filter.operators[name] === true;
      } else if (upper === 'BKR') {
        operatorFilter[id.BKR] = that.filter.operators[name] === true;
      } else if (upper === 'BKA') {
        operatorFilter[id.BKA] = that.filter.operators[name] === true;
      } else if (upper === 'BKN') {
        operatorFilter[id.BKN] = that.filter.operators[name] === true;
      } else if (upper === 'ABG') {
        operatorFilter[id.ABG] = that.filter.operators[name] === true;
      } else if (upper === 'AEN') {
        operatorFilter[id.AEN] = that.filter.operators[name] === true;
      } else {
        throw new Error(
          `${thisFileName}initOpratorFilter: '${name}' not a valid operator name.` +
            ` Must be <all>, <none>, alt, cat, rep, tls, tbs, trg, and, not, bkr, bka or bkn`
        );
      }
    }
  };
  /* filter the rule and `UDT` named operators */
  const initRuleFilter = function () {
    const setRules = function (set) {
      operatorFilter[id.RNM] = set;
      operatorFilter[id.UDT] = set;
      const count = rules.length + udts.length;
      ruleFilter.length = 0;
      for (let i = 0; i < count; i += 1) {
        ruleFilter.push(set);
      }
    };
    let items;
    let i;
    const list = [];
    for (i = 0; i < rules.length; i += 1) {
      list.push(rules[i].lower);
    }
    for (i = 0; i < udts.length; i += 1) {
      list.push(udts[i].lower);
    }
    ruleFilter.length = 0;
    items = 0;
    // eslint-disable-next-line no-unused-vars
    for (const name in that.filter.rules) {
      items += 1;
    }
    if (items === 0) {
      /* case 1: default to all rules & udts */
      setRules(true);
      return;
    }
    for (const name in that.filter.rules) {
      const lower = name.toLowerCase();
      if (lower === '<all>') {
        /* case 2: trace all rules ignore all other rule commands */
        setRules(true);
        return;
      }
      if (lower === '<none>') {
        /* case 3: trace no rules */
        setRules(false);
        return;
      }
    }
    /* case 4: trace only individually specified rules */
    setRules(false);
    operatorFilter[id.RNM] = true;
    operatorFilter[id.UDT] = true;
    for (const name in that.filter.rules) {
      const lower = name.toLowerCase();
      i = list.indexOf(lower);
      if (i < 0) {
        throw new Error(`${thisFileName}initRuleFilter: '${name}' not a valid rule or udt name`);
      }
      ruleFilter[i] = that.filter.rules[name] === true;
    }
  };
  /* used by other APG components to verify that they have a valid trace object */
  this.traceObject = 'traceObject';
  this.filter = {
    operators: [],
    rules: [],
  };
  // Set the maximum number of records to keep (default = 5000).
  // Each record number larger than `maxRecords`
  // will result in deleting the previously oldest record.
  // - `max`: maximum number of records to retain (default = 5000)
  // - `last`: last record number to retain, (default = -1 for (unknown) actual last record)
  this.setMaxRecords = function (max, last) {
    lastRecord = -1;
    if (typeof max === 'number' && max > 0) {
      maxRecords = Math.ceil(max);
    } else {
      maxRecords = 0;
      return;
    }
    if (typeof last === 'number') {
      lastRecord = Math.floor(last);
      if (lastRecord < 0) {
        lastRecord = -1;
      }
    }
  };
  // Returns `maxRecords` to the caller.
  this.getMaxRecords = function () {
    return maxRecords;
  };
  // Returns `lastRecord` to the caller.
  this.getLastRecord = function () {
    return lastRecord;
  };
  /* Called only by the `parser.js` object. No verification of input. */
  this.init = function (rulesIn, udtsIn, charsIn) {
    records.length = 0;
    recordStack.length = 0;
    filteredRecords = 0;
    treeDepth = 0;
    chars = charsIn;
    rules = rulesIn;
    udts = udtsIn;
    initOperatorFilter();
    initRuleFilter();
    circular.init(maxRecords);
  };
  /* returns true if this records passes through the designated filter, false if the record is to be skipped */
  const filterOps = function (op) {
    let ret = false;
    if (op.type === id.RNM) {
      if (operatorFilter[op.type] && ruleFilter[op.index]) {
        ret = true;
      } else {
        ret = false;
      }
    } else if (op.type === id.UDT) {
      if (operatorFilter[op.type] && ruleFilter[rules.length + op.index]) {
        ret = true;
      } else {
        ret = false;
      }
    } else {
      ret = operatorFilter[op.type];
    }
    return ret;
  };
  const filterRecords = function (record) {
    if (lastRecord === -1) {
      return true;
    }
    if (record <= lastRecord) {
      return true;
    }
    return false;
  };
  /* Collect the "down" record. */
  this.down = function (op, state, offset, length, anchor, lookAround) {
    if (filterRecords(filteredRecords) && filterOps(op)) {
      recordStack.push(filteredRecords);
      records[circular.increment()] = {
        dirUp: false,
        depth: treeDepth,
        thisLine: filteredRecords,
        thatLine: undefined,
        opcode: op,
        state,
        phraseIndex: offset,
        phraseLength: length,
        lookAnchor: anchor,
        lookAround,
      };
      filteredRecords += 1;
      treeDepth += 1;
    }
  };
  /* Collect the "up" record. */
  this.up = function (op, state, offset, length, anchor, lookAround) {
    if (filterRecords(filteredRecords) && filterOps(op)) {
      const thisLine = filteredRecords;
      const thatLine = recordStack.pop();
      const thatRecord = circular.getListIndex(thatLine);
      if (thatRecord !== -1) {
        records[thatRecord].thatLine = thisLine;
      }
      treeDepth -= 1;
      records[circular.increment()] = {
        dirUp: true,
        depth: treeDepth,
        thisLine,
        thatLine,
        opcode: op,
        state,
        phraseIndex: offset,
        phraseLength: length,
        lookAnchor: anchor,
        lookAround,
      };
      filteredRecords += 1;
    }
  };
  /* convert the trace records to a tree of nodes */
  const toTreeObj = function () {
    /* private helper functions */
    function nodeOpcode(node, opcode) {
      let name;
      let casetype;
      let modetype;
      if (opcode) {
        node.op = { id: opcode.type, name: utils.opcodeToString(opcode.type) };
        node.opData = undefined;
        switch (opcode.type) {
          case id.RNM:
            node.opData = rules[opcode.index].name;
            break;
          case id.UDT:
            node.opData = udts[opcode.index].name;
            break;
          case id.BKR:
            if (opcode.index < rules.length) {
              name = rules[opcode.index].name;
            } else {
              name = udts[opcode.index - rules.length].name;
            }
            casetype = opcode.bkrCase === id.BKR_MODE_CI ? '%i' : '%s';
            modetype = opcode.bkrMode === id.BKR_MODE_UM ? '%u' : '%p';
            node.opData = `\\\\${casetype}${modetype}${name}`;
            break;
          case id.TLS:
            node.opData = [];
            for (let i = 0; i < opcode.string.length; i += 1) {
              node.opData.push(opcode.string[i]);
            }
            break;
          case id.TBS:
            node.opData = [];
            for (let i = 0; i < opcode.string.length; i += 1) {
              node.opData.push(opcode.string[i]);
            }
            break;
          case id.TRG:
            node.opData = [opcode.min, opcode.max];
            break;
          case id.REP:
            node.opData = [opcode.min, opcode.max];
            break;
          default:
            throw new Error('unrecognized opcode');
        }
      } else {
        node.op = { id: undefined, name: undefined };
        node.opData = undefined;
      }
    }
    function nodePhrase(state, index, length) {
      if (state === id.MATCH) {
        return {
          index,
          length,
        };
      }
      if (state === id.NOMATCH) {
        return {
          index,
          length: 0,
        };
      }
      if (state === id.EMPTY) {
        return {
          index,
          length: 0,
        };
      }
      return null;
    }
    let nodeId = -1;
    function nodeDown(parent, record, depth) {
      const node = {
        // eslint-disable-next-line no-plusplus
        id: nodeId++,
        branch: -1,
        parent,
        up: false,
        down: false,
        depth,
        children: [],
      };
      if (record) {
        node.down = true;
        node.state = { id: record.state, name: utils.stateToString(record.state) };
        node.phrase = null;
        nodeOpcode(node, record.opcode);
      } else {
        node.state = { id: undefined, name: undefined };
        node.phrase = nodePhrase();
        nodeOpcode(node, undefined);
      }
      return node;
    }
    function nodeUp(node, record) {
      if (record) {
        node.up = true;
        node.state = { id: record.state, name: utils.stateToString(record.state) };
        node.phrase = nodePhrase(record.state, record.phraseIndex, record.phraseLength);
        if (!node.down) {
          nodeOpcode(node, record.opcode);
        }
      }
    }
    /* walk the final tree: label branches and count leaf nodes */
    let leafNodes = 0;
    let depth = -1;
    let branchCount = 1;
    function walk(node) {
      depth += 1;
      node.branch = branchCount;
      if (depth > treeDepth) {
        treeDepth = depth;
      }
      if (node.children.length === 0) {
        leafNodes += 1;
      } else {
        for (let i = 0; i < node.children.length; i += 1) {
          if (i > 0) {
            branchCount += 1;
          }
          node.children[i].leftMost = false;
          node.children[i].rightMost = false;
          if (node.leftMost) {
            node.children[i].leftMost = i === 0;
          }
          if (node.rightMost) {
            node.children[i].rightMost = i === node.children.length - 1;
          }
          walk(node.children[i]);
        }
      }
      depth -= 1;
    }
    function display(node, offset) {
      let name;
      const obj = {};
      obj.id = node.id;
      obj.branch = node.branch;
      obj.leftMost = node.leftMost;
      obj.rightMost = node.rightMost;
      name = node.state.name ? node.state.name : 'ACTIVE';
      obj.state = { id: node.state.id, name };
      name = node.op.name ? node.op.name : '?';
      obj.op = { id: node.op.id, name };
      if (typeof node.opData === 'string') {
        obj.opData = node.opData;
      } else if (Array.isArray(node.opData)) {
        obj.opData = [];
        for (let i = 0; i < node.opData.length; i += 1) {
          obj.opData[i] = node.opData[i];
        }
      } else {
        obj.opData = undefined;
      }
      if (node.phrase) {
        obj.phrase = { index: node.phrase.index, length: node.phrase.length };
      } else {
        obj.phrase = null;
      }
      obj.depth = node.depth;
      obj.children = [];
      for (let i = 0; i < node.children.length; i += 1) {
        const c = i !== node.children.length - 1;
        obj.children[i] = display(node.children[i], offset, c);
      }
      return obj;
    }

    /* construct the tree beginning here */
    const branch = [];
    let root;
    let node;
    let parent;
    let record;
    let firstRecord = true;
    /* push a dummy node so the root node will have a non-null parent */
    const dummy = nodeDown(null, null, -1);
    branch.push(dummy);
    node = dummy;
    circular.forEach((lineIndex) => {
      record = records[lineIndex];
      if (firstRecord) {
        firstRecord = false;
        if (record.depth > 0) {
          /* push some dummy nodes to fill in for missing records */
          const num = record.dirUp ? record.depth + 1 : record.depth;
          for (let i = 0; i < num; i += 1) {
            parent = node;
            node = nodeDown(node, null, i);
            branch.push(node);
            parent.children.push(node);
          }
        }
      }
      if (record.dirUp) {
        /* handle the next record up */
        node = branch.pop();
        nodeUp(node, record);
        node = branch[branch.length - 1];
      } else {
        /* handle the next record down */
        parent = node;
        node = nodeDown(node, record, record.depth);
        branch.push(node);
        parent.children.push(node);
      }
    });

    /* if not at root, walk it up to root */
    while (branch.length > 1) {
      node = branch.pop();
      nodeUp(node, null);
    }
    /* maybe redundant or paranoid tests: these should never happen */
    if (dummy.children.length === 0) {
      throw new Error('trace.toTree(): parse tree has no nodes');
    }
    if (branch.length === 0) {
      throw new Error('trace.toTree(): integrity check: dummy root node disappeared?');
    }

    /* if no record for start rule: find the pseudo root node (first dummy node above a real node) */
    root = dummy.children[0];
    let prev = root;
    while (root && !root.down && !root.up) {
      prev = root;
      root = root.children[0];
    }
    root = prev;

    /* walk the tree of nodes: label brances and count leaves */
    root.leftMost = true;
    root.rightMost = true;
    walk(root);
    root.branch = 0;

    /* generate the exported object */
    const obj = {};
    obj.string = [];
    for (let i = 0; i < chars.length; i += 1) {
      obj.string[i] = chars[i];
    }
    /* generate the exported rule names */
    obj.rules = [];
    for (let i = 0; i < rules.length; i += 1) {
      obj.rules[i] = rules[i].name;
    }
    /* generate the exported UDT names */
    obj.udts = [];
    for (let i = 0; i < udts.length; i += 1) {
      obj.udts[i] = udts[i].name;
    }
    /* generate the ids */
    obj.id = {};
    obj.id.ALT = { id: id.ALT, name: 'ALT' };
    obj.id.CAT = { id: id.CAT, name: 'CAT' };
    obj.id.REP = { id: id.REP, name: 'REP' };
    obj.id.RNM = { id: id.RNM, name: 'RNM' };
    obj.id.TLS = { id: id.TLS, name: 'TLS' };
    obj.id.TBS = { id: id.TBS, name: 'TBS' };
    obj.id.TRG = { id: id.TRG, name: 'TRG' };
    obj.id.UDT = { id: id.UDT, name: 'UDT' };
    obj.id.AND = { id: id.AND, name: 'AND' };
    obj.id.NOT = { id: id.NOT, name: 'NOT' };
    obj.id.BKR = { id: id.BKR, name: 'BKR' };
    obj.id.BKA = { id: id.BKA, name: 'BKA' };
    obj.id.BKN = { id: id.BKN, name: 'BKN' };
    obj.id.ABG = { id: id.ABG, name: 'ABG' };
    obj.id.AEN = { id: id.AEN, name: 'AEN' };
    obj.id.ACTIVE = { id: id.ACTIVE, name: 'ACTIVE' };
    obj.id.MATCH = { id: id.MATCH, name: 'MATCH' };
    obj.id.EMPTY = { id: id.EMPTY, name: 'EMPTY' };
    obj.id.NOMATCH = { id: id.NOMATCH, name: 'NOMATCH' };
    /* generate the max tree depth */
    obj.treeDepth = treeDepth;
    /* generate the number of leaf nodes (branches) */
    obj.leafNodes = leafNodes;
    /* generate the types of the left- and right-most branches */
    let branchesIncomplete;
    if (root.down) {
      if (root.up) {
        branchesIncomplete = 'none';
      } else {
        branchesIncomplete = 'right';
      }
    } else if (root.up) {
      branchesIncomplete = 'left';
    } else {
      branchesIncomplete = 'both';
    }
    obj.branchesIncomplete = branchesIncomplete;
    obj.tree = display(root, root.depth, false);
    return obj;
  };
  // Returns the trace records as JSON parse tree object.
  // - stringify: if `true`, the object is 'stringified' before returning, otherwise, the object itself is returned.
  this.toTree = function (stringify) {
    const obj = toTreeObj();
    if (stringify) {
      return JSON.stringify(obj);
    }
    return obj;
  };
  // Translate the trace records to HTML format and create a complete HTML page for browser display.
  this.toHtmlPage = function (mode, caption, title) {
    return utils.htmlToPage(this.toHtml(mode, caption), title);
  };

  /* From here on down, these are just helper functions for `toHtml()`. */
  const htmlHeader = function (mode, caption) {
    /* open the page */
    /* write the HTML5 header with table style */
    /* open the <table> tag */
    let modeName;
    switch (mode) {
      case MODE_HEX:
        modeName = 'hexadecimal';
        break;
      case MODE_DEC:
        modeName = 'decimal';
        break;
      case MODE_ASCII:
        modeName = 'ASCII';
        break;
      case MODE_UNICODE:
        modeName = 'UNICODE';
        break;
      default:
        throw new Error(`${thisFileName}htmlHeader: unrecognized mode: ${mode}`);
    }
    let header = '';
    header += `<p>display mode: ${modeName}</p>\n`;
    header += `<table class="${style.CLASS_TRACE}">\n`;
    if (typeof caption === 'string') {
      header += `<caption>${caption}</caption>`;
    }
    return header;
  };
  const htmlFooter = function () {
    let footer = '';
    /* close the </table> tag */
    footer += '</table>\n';
    /* display a table legend */
    footer += `<p class="${style.CLASS_MONOSPACE}">legend:<br>\n`;
    footer += '(a)&nbsp;-&nbsp;line number<br>\n';
    footer += '(b)&nbsp;-&nbsp;matching line number<br>\n';
    footer += '(c)&nbsp;-&nbsp;phrase offset<br>\n';
    footer += '(d)&nbsp;-&nbsp;phrase length<br>\n';
    footer += '(e)&nbsp;-&nbsp;tree depth<br>\n';
    footer += '(f)&nbsp;-&nbsp;operator state<br>\n';
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_ACTIVE}">&darr;</span>&nbsp;&nbsp;phrase opened<br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_MATCH}">&uarr;M</span> phrase matched<br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_EMPTY}">&uarr;E</span> empty phrase matched<br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_NOMATCH}">&uarr;N</span> phrase not matched<br>\n`;
    footer +=
      'operator&nbsp;-&nbsp;ALT, CAT, REP, RNM, TRG, TLS, TBS<sup>&dagger;</sup>, UDT, AND, NOT, BKA, BKN, BKR, ABG, AEN<sup>&Dagger;</sup><br>\n';
    footer += `phrase&nbsp;&nbsp;&nbsp;-&nbsp;up to ${MAX_PHRASE} characters of the phrase being matched<br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_MATCH}">matched characters</span><br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_LOOKAHEAD}">matched characters in look ahead mode</span><br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_LOOKBEHIND}">matched characters in look behind mode</span><br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_REMAINDER}">remainder characters(not yet examined by parser)</span><br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${style.CLASS_CTRLCHAR}">control characters, TAB, LF, CR, etc. (ASCII mode only)</span><br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${PHRASE_EMPTY} empty string<br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${PHRASE_END} end of input string<br>\n`;
    footer += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${PHRASE_CONTINUE} input string display truncated<br>\n`;
    footer += '</p>\n';
    footer += `<p class="${style.CLASS_MONOSPACE}">\n`;
    footer += '<sup>&dagger;</sup>original ABNF operators:<br>\n';
    footer += 'ALT - alternation<br>\n';
    footer += 'CAT - concatenation<br>\n';
    footer += 'REP - repetition<br>\n';
    footer += 'RNM - rule name<br>\n';
    footer += 'TRG - terminal range<br>\n';
    footer += 'TLS - terminal literal string (case insensitive)<br>\n';
    footer += 'TBS - terminal binary string (case sensitive)<br>\n';
    footer += '<br>\n';
    footer += '<sup>&Dagger;</sup>super set SABNF operators:<br>\n';
    footer += 'UDT - user-defined terminal<br>\n';
    footer += 'AND - positive look ahead<br>\n';
    footer += 'NOT - negative look ahead<br>\n';
    footer += 'BKA - positive look behind<br>\n';
    footer += 'BKN - negative look behind<br>\n';
    footer += 'BKR - back reference<br>\n';
    footer += 'ABG - anchor - begin of input string<br>\n';
    footer += 'AEN - anchor - end of input string<br>\n';
    footer += '</p>\n';
    return footer;
  };
  this.indent = function (depth) {
    let html = '';
    for (let i = 0; i < depth; i += 1) {
      html += '.';
    }
    return html;
  };
  /* format the TRG operator */
  const displayTrg = function (mode, op) {
    let html = '';
    if (op.type === id.TRG) {
      if (mode === MODE_HEX || mode === MODE_UNICODE) {
        let hex = op.min.toString(16).toUpperCase();
        if (hex.length % 2 !== 0) {
          hex = `0${hex}`;
        }
        html += mode === MODE_HEX ? '%x' : 'U+';
        html += hex;
        hex = op.max.toString(16).toUpperCase();
        if (hex.length % 2 !== 0) {
          hex = `0${hex}`;
        }
        html += `&ndash;${hex}`;
      } else {
        html = `%d${op.min.toString(10)}&ndash;${op.max.toString(10)}`;
      }
    }
    return html;
  };
  /* format the REP operator */
  const displayRep = function (mode, op) {
    let html = '';
    if (op.type === id.REP) {
      if (mode === MODE_HEX) {
        let hex = op.min.toString(16).toUpperCase();
        if (hex.length % 2 !== 0) {
          hex = `0${hex}`;
        }
        html = `x${hex}`;
        if (op.max < Infinity) {
          hex = op.max.toString(16).toUpperCase();
          if (hex.length % 2 !== 0) {
            hex = `0${hex}`;
          }
        } else {
          hex = 'inf';
        }
        html += `&ndash;${hex}`;
      } else if (op.max < Infinity) {
        html = `${op.min.toString(10)}&ndash;${op.max.toString(10)}`;
      } else {
        html = `${op.min.toString(10)}&ndash;inf`;
      }
    }
    return html;
  };
  /* format the TBS operator */
  const displayTbs = function (mode, op) {
    let html = '';
    if (op.type === id.TBS) {
      const len = Math.min(op.string.length, MAX_TLS * 2);
      if (mode === MODE_HEX || mode === MODE_UNICODE) {
        html += mode === MODE_HEX ? '%x' : 'U+';
        for (let i = 0; i < len; i += 1) {
          let hex;
          if (i > 0) {
            html += '.';
          }
          hex = op.string[i].toString(16).toUpperCase();
          if (hex.length % 2 !== 0) {
            hex = `0${hex}`;
          }
          html += hex;
        }
      } else {
        html = '%d';
        for (let i = 0; i < len; i += 1) {
          if (i > 0) {
            html += '.';
          }
          html += op.string[i].toString(10);
        }
      }
      if (len < op.string.length) {
        html += PHRASE_CONTINUE;
      }
    }
    return html;
  };
  /* format the TLS operator */
  const displayTls = function (mode, op) {
    let html = '';
    if (op.type === id.TLS) {
      const len = Math.min(op.string.length, MAX_TLS);
      if (mode === MODE_HEX || mode === MODE_DEC) {
        let charu;
        let charl;
        let base;
        if (mode === MODE_HEX) {
          html = '%x';
          base = 16;
        } else {
          html = '%d';
          base = 10;
        }
        for (let i = 0; i < len; i += 1) {
          if (i > 0) {
            html += '.';
          }
          charl = op.string[i];
          if (charl >= 97 && charl <= 122) {
            charu = charl - 32;
            html += `${charu.toString(base)}/${charl.toString(base)}`.toUpperCase();
          } else if (charl >= 65 && charl <= 90) {
            charu = charl;
            charl += 32;
            html += `${charu.toString(base)}/${charl.toString(base)}`.toUpperCase();
          } else {
            html += charl.toString(base).toUpperCase();
          }
        }
        if (len < op.string.length) {
          html += PHRASE_CONTINUE;
        }
      } else {
        html = '"';
        for (let i = 0; i < len; i += 1) {
          html += utils.asciiChars[op.string[i]];
        }
        if (len < op.string.length) {
          html += PHRASE_CONTINUE;
        }
        html += '"';
      }
    }
    return html;
  };
  const subPhrase = function (mode, charsArg, index, length, prev) {
    if (length === 0) {
      return '';
    }
    let phrase = '';
    const comma = prev ? ',' : '';
    switch (mode) {
      case MODE_HEX:
        phrase = comma + utils.charsToHex(charsArg, index, length);
        break;
      case MODE_DEC:
        if (prev) {
          return `,${utils.charsToDec(charsArg, index, length)}`;
        }
        phrase = comma + utils.charsToDec(charsArg, index, length);
        break;
      case MODE_UNICODE:
        phrase = utils.charsToUnicode(charsArg, index, length);
        break;
      case MODE_ASCII:
      default:
        phrase = utils.charsToAsciiHtml(charsArg, index, length);
        break;
    }
    return phrase;
  };
  /* display phrases matched in look-behind mode */
  const displayBehind = function (mode, charsArg, state, index, length, anchor) {
    let html = '';
    let beg1;
    let len1;
    let beg2;
    let len2;
    let lastchar = PHRASE_END;
    const spanBehind = `<span class="${style.CLASS_LOOKBEHIND}">`;
    const spanRemainder = `<span class="${style.CLASS_REMAINDER}">`;
    const spanend = '</span>';
    let prev = false;
    switch (state) {
      case id.EMPTY:
        html += PHRASE_EMPTY;
      /* // eslint-disable-next-line no-fallthrough */
      case id.NOMATCH:
      case id.MATCH:
      case id.ACTIVE:
        beg1 = index - length;
        len1 = anchor - beg1;
        beg2 = anchor;
        len2 = charsArg.length - beg2;
        break;
      default:
        throw new Error('unrecognized state');
    }
    lastchar = PHRASE_END;
    if (len1 > MAX_PHRASE) {
      len1 = MAX_PHRASE;
      lastchar = PHRASE_CONTINUE;
      len2 = 0;
    } else if (len1 + len2 > MAX_PHRASE) {
      lastchar = PHRASE_CONTINUE;
      len2 = MAX_PHRASE - len1;
    }
    if (len1 > 0) {
      html += spanBehind;
      html += subPhrase(mode, charsArg, beg1, len1, prev);
      html += spanend;
      prev = true;
    }
    if (len2 > 0) {
      html += spanRemainder;
      html += subPhrase(mode, charsArg, beg2, len2, prev);
      html += spanend;
    }
    return html + lastchar;
  };
  const displayForward = function (mode, charsArg, state, index, length, spanAhead) {
    let html = '';
    let beg1;
    let len1;
    let beg2;
    let len2;
    let lastchar = PHRASE_END;
    const spanRemainder = `<span class="${style.CLASS_REMAINDER}">`;
    const spanend = '</span>';
    let prev = false;
    switch (state) {
      case id.EMPTY:
        html += PHRASE_EMPTY;
      /* // eslint-disable-next-line no-fallthrough */
      case id.NOMATCH:
      case id.ACTIVE:
        beg1 = index;
        len1 = 0;
        beg2 = index;
        len2 = charsArg.length - beg2;
        break;
      case id.MATCH:
        beg1 = index;
        len1 = length;
        beg2 = index + len1;
        len2 = charsArg.length - beg2;
        break;
      default:
        throw new Error('unrecognized state');
    }
    lastchar = PHRASE_END;
    if (len1 > MAX_PHRASE) {
      len1 = MAX_PHRASE;
      lastchar = PHRASE_CONTINUE;
      len2 = 0;
    } else if (len1 + len2 > MAX_PHRASE) {
      lastchar = PHRASE_CONTINUE;
      len2 = MAX_PHRASE - len1;
    }
    if (len1 > 0) {
      html += spanAhead;
      html += subPhrase(mode, charsArg, beg1, len1, prev);
      html += spanend;
      prev = true;
    }
    if (len2 > 0) {
      html += spanRemainder;
      html += subPhrase(mode, charsArg, beg2, len2, prev);
      html += spanend;
    }
    return html + lastchar;
  };
  /* display phrases matched in look-ahead mode */
  const displayAhead = function (mode, charsArg, state, index, length) {
    const spanAhead = `<span class="${style.CLASS_LOOKAHEAD}">`;
    return displayForward(mode, charsArg, state, index, length, spanAhead);
  };
  /* display phrases matched in normal parsing mode */
  const displayNone = function (mode, charsArg, state, index, length) {
    const spanAhead = `<span class="${style.CLASS_MATCH}">`;
    return displayForward(mode, charsArg, state, index, length, spanAhead);
  };
  /* Returns the filtered records, formatted as an HTML table. */
  const htmlTable = function (mode) {
    if (rules === null) {
      return '';
    }
    let html = '';
    let thisLine;
    let thatLine;
    let lookAhead;
    let lookBehind;
    let lookAround;
    let anchor;
    html += '<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>';
    html += '<th>operator</th><th>phrase</th></tr>\n';
    circular.forEach((lineIndex) => {
      const line = records[lineIndex];
      thisLine = line.thisLine;
      thatLine = line.thatLine !== undefined ? line.thatLine : '--';
      lookAhead = false;
      lookBehind = false;
      lookAround = false;
      if (line.lookAround === id.LOOKAROUND_AHEAD) {
        lookAhead = true;
        lookAround = true;
        anchor = line.lookAnchor;
      }
      if (line.opcode.type === id.AND || line.opcode.type === id.NOT) {
        lookAhead = true;
        lookAround = true;
        anchor = line.phraseIndex;
      }
      if (line.lookAround === id.LOOKAROUND_BEHIND) {
        lookBehind = true;
        lookAround = true;
        anchor = line.lookAnchor;
      }
      if (line.opcode.type === id.BKA || line.opcode.type === id.BKN) {
        lookBehind = true;
        lookAround = true;
        anchor = line.phraseIndex;
      }
      html += '<tr>';
      html += `<td>${thisLine}</td><td>${thatLine}</td>`;
      html += `<td>${line.phraseIndex}</td>`;
      html += `<td>${line.phraseLength}</td>`;
      html += `<td>${line.depth}</td>`;
      html += '<td>';
      switch (line.state) {
        case id.ACTIVE:
          html += `<span class="${style.CLASS_ACTIVE}">&darr;&nbsp;</span>`;
          break;
        case id.MATCH:
          html += `<span class="${style.CLASS_MATCH}">&uarr;M</span>`;
          break;
        case id.NOMATCH:
          html += `<span class="${style.CLASS_NOMATCH}">&uarr;N</span>`;
          break;
        case id.EMPTY:
          html += `<span class="${style.CLASS_EMPTY}">&uarr;E</span>`;
          break;
        default:
          html += `<span class="${style.CLASS_ACTIVE}">--</span>`;
          break;
      }
      html += '</td>';
      html += '<td>';
      html += that.indent(line.depth);
      if (lookAhead) {
        html += `<span class="${style.CLASS_LOOKAHEAD}">`;
      } else if (lookBehind) {
        html += `<span class="${style.CLASS_LOOKBEHIND}">`;
      }
      html += utils.opcodeToString(line.opcode.type);
      if (line.opcode.type === id.RNM) {
        html += `(${rules[line.opcode.index].name}) `;
      }
      if (line.opcode.type === id.BKR) {
        const casetype = line.opcode.bkrCase === id.BKR_MODE_CI ? '%i' : '%s';
        const modetype = line.opcode.bkrMode === id.BKR_MODE_UM ? '%u' : '%p';
        html += `(\\${casetype}${modetype}${rules[line.opcode.index].name}) `;
      }
      if (line.opcode.type === id.UDT) {
        html += `(${udts[line.opcode.index].name}) `;
      }
      if (line.opcode.type === id.TRG) {
        html += `(${displayTrg(mode, line.opcode)}) `;
      }
      if (line.opcode.type === id.TBS) {
        html += `(${displayTbs(mode, line.opcode)}) `;
      }
      if (line.opcode.type === id.TLS) {
        html += `(${displayTls(mode, line.opcode)}) `;
      }
      if (line.opcode.type === id.REP) {
        html += `(${displayRep(mode, line.opcode)}) `;
      }
      if (lookAround) {
        html += '</span>';
      }
      html += '</td>';
      html += '<td>';
      if (lookBehind) {
        html += displayBehind(mode, chars, line.state, line.phraseIndex, line.phraseLength, anchor);
      } else if (lookAhead) {
        html += displayAhead(mode, chars, line.state, line.phraseIndex, line.phraseLength);
      } else {
        html += displayNone(mode, chars, line.state, line.phraseIndex, line.phraseLength);
      }
      html += '</td></tr>\n';
    });
    html += '<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>';
    html += '<th>operator</th><th>phrase</th></tr>\n';
    html += '</table>\n';
    return html;
  };
  // Translate the trace records to HTML format.
  // - *modearg* - can be `"ascii"`, `"decimal"`, `"hexadecimal"` or `"unicode"`.
  // Determines the format of the string character code display.
  // - *caption* - optional caption for the HTML table.
  this.toHtml = function (modearg, caption) {
    /* writes the trace records as a table in a complete html page */
    let mode = MODE_ASCII;
    if (typeof modearg === 'string' && modearg.length >= 3) {
      const modein = modearg.toLowerCase().slice(0, 3);
      if (modein === 'hex') {
        mode = MODE_HEX;
      } else if (modein === 'dec') {
        mode = MODE_DEC;
      } else if (modein === 'uni') {
        mode = MODE_UNICODE;
      }
    }
    let html = '';
    html += htmlHeader(mode, caption);
    html += htmlTable(mode);
    html += htmlFooter();
    return html;
  };
};


/***/ }),

/***/ "../../node_modules/apg-js/src/apg-lib/utilities.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/* eslint-disable func-names */
/*  *************************************************************************************
 *   copyright: Copyright (c) 2021 Lowell D. Thomas, all rights reserved
 *     license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)
 *   ********************************************************************************* */
// This module exports a variety of utility functions that support
// [`apg`](https://github.com/ldthomas/apg-js2), [`apg-lib`](https://github.com/ldthomas/apg-js2-lib)
// and the generated parser applications.

const style = __webpack_require__("../../node_modules/apg-js/src/apg-lib/style.js");
const converter = __webpack_require__("../../node_modules/apg-js/src/apg-conv-api/converter.js");
const emitCss = __webpack_require__("../../node_modules/apg-js/src/apg-lib/emitcss.js");
const id = __webpack_require__("../../node_modules/apg-js/src/apg-lib/identifiers.js");

const thisFileName = 'utilities.js: ';
const thisThis = this;

/* translate (implied) phrase beginning character and length to actual first and last character indexes */
/* used by multiple phrase handling functions */
const getBounds = function (length, begArg, len) {
  let end;
  let beg = begArg;
  const TRUE = true;
  while (TRUE) {
    if (length <= 0) {
      beg = 0;
      end = 0;
      break;
    }
    if (typeof beg !== 'number') {
      beg = 0;
      end = length;
      break;
    }
    if (beg >= length) {
      beg = length;
      end = length;
      break;
    }
    if (typeof len !== 'number') {
      end = length;
      break;
    }
    end = beg + len;
    if (end > length) {
      end = length;
      break;
    }
    break;
  }
  return {
    beg,
    end,
  };
};
// Generates a complete, minimal HTML5 page, inserting the user's HTML text on the page.
// - *html* - the page text in HTML format
// - *title* - the HTML page `<title>` - defaults to `htmlToPage`.
exports.htmlToPage = function (html, titleArg) {
  let title;
  if (typeof html !== 'string') {
    throw new Error(`${thisFileName}htmlToPage: input HTML is not a string`);
  }
  if (typeof titleArg !== 'string') {
    title = 'htmlToPage';
  } else {
    title = titleArg;
  }
  let page = '';
  page += '<!DOCTYPE html>\n';
  page += '<html lang="en">\n';
  page += '<head>\n';
  page += '<meta charset="utf-8">\n';
  page += `<title>${title}</title>\n`;
  page += '<style>\n';
  page += emitCss();
  page += '</style>\n';
  page += '</head>\n<body>\n';
  page += `<p>${new Date()}</p>\n`;
  page += html;
  page += '</body>\n</html>\n';
  return page;
};
// Formats the returned object from `parser.parse()`
// into an HTML table.
// ```
// return {
//   success : sysData.success,
//   state : sysData.state,
//   length : charsLength,
//   matched : sysData.phraseLength,
//   maxMatched : maxMatched,
//   maxTreeDepth : maxTreeDepth,
//   nodeHits : nodeHits,
//   inputLength : chars.length,
//   subBegin : charsBegin,
//   subEnd : charsEnd,
//   subLength : charsLength
// };
// ```
exports.parserResultToHtml = function (result, caption) {
  let cap = null;
  if (typeof caption === 'string' && caption !== '') {
    cap = caption;
  }
  let success;
  let state;
  if (result.success === true) {
    success = `<span class="${style.CLASS_MATCH}">true</span>`;
  } else {
    success = `<span class="${style.CLASS_NOMATCH}">false</span>`;
  }
  if (result.state === id.EMPTY) {
    state = `<span class="${style.CLASS_EMPTY}">EMPTY</span>`;
  } else if (result.state === id.MATCH) {
    state = `<span class="${style.CLASS_MATCH}">MATCH</span>`;
  } else if (result.state === id.NOMATCH) {
    state = `<span class="${style.CLASS_NOMATCH}">NOMATCH</span>`;
  } else {
    state = `<span class="${style.CLASS_NOMATCH}">unrecognized</span>`;
  }
  let html = '';
  html += `<table class="${style.CLASS_STATE}">\n`;
  if (cap) {
    html += `<caption>${cap}</caption>\n`;
  }
  html += '<tr><th>state item</th><th>value</th><th>description</th></tr>\n';
  html += `<tr><td>parser success</td><td>${success}</td>\n`;
  html += `<td><span class="${style.CLASS_MATCH}">true</span> if the parse succeeded,\n`;
  html += ` <span class="${style.CLASS_NOMATCH}">false</span> otherwise`;
  html += '<br><i>NOTE: for success, entire string must be matched</i></td></tr>\n';
  html += `<tr><td>parser state</td><td>${state}</td>\n`;
  html += `<td><span class="${style.CLASS_EMPTY}">EMPTY</span>, `;
  html += `<span class="${style.CLASS_MATCH}">MATCH</span> or \n`;
  html += `<span class="${style.CLASS_NOMATCH}">NOMATCH</span></td></tr>\n`;
  html += `<tr><td>string length</td><td>${result.length}</td><td>length of the input (sub)string</td></tr>\n`;
  html += `<tr><td>matched length</td><td>${result.matched}</td><td>number of input string characters matched</td></tr>\n`;
  html += `<tr><td>max matched</td><td>${result.maxMatched}</td><td>maximum number of input string characters matched</td></tr>\n`;
  html += `<tr><td>max tree depth</td><td>${result.maxTreeDepth}</td><td>maximum depth of the parse tree reached</td></tr>\n`;
  html += `<tr><td>node hits</td><td>${result.nodeHits}</td><td>number of parse tree node hits (opcode function calls)</td></tr>\n`;
  html += `<tr><td>input length</td><td>${result.inputLength}</td><td>length of full input string</td></tr>\n`;
  html += `<tr><td>sub-string begin</td><td>${result.subBegin}</td><td>sub-string first character index</td></tr>\n`;
  html += `<tr><td>sub-string end</td><td>${result.subEnd}</td><td>sub-string end-of-string index</td></tr>\n`;
  html += `<tr><td>sub-string length</td><td>${result.subLength}</td><td>sub-string length</td></tr>\n`;
  html += '</table>\n';
  return html;
};
// Translates a sub-array of integer character codes into a string.
// Very useful in callback functions to translate the matched phrases into strings.
exports.charsToString = function (chars, phraseIndex, phraseLength) {
  let beg;
  let end;
  if (typeof phraseIndex === 'number') {
    if (phraseIndex >= chars.length) {
      return '';
    }
    beg = phraseIndex < 0 ? 0 : phraseIndex;
  } else {
    beg = 0;
  }
  if (typeof phraseLength === 'number') {
    if (phraseLength <= 0) {
      return '';
    }
    end = phraseLength > chars.length - beg ? chars.length : beg + phraseLength;
  } else {
    end = chars.length;
  }
  if (beg < end) {
    return converter.encode('UTF16LE', chars.slice(beg, end)).toString('utf16le');
  }
  return '';
};
// Translates a string into an array of integer character codes.
exports.stringToChars = function (string) {
  return converter.decode('STRING', string);
};
// Translates an opcode identifier into a human-readable string.
exports.opcodeToString = function (type) {
  let ret = 'unknown';
  switch (type) {
    case id.ALT:
      ret = 'ALT';
      break;
    case id.CAT:
      ret = 'CAT';
      break;
    case id.RNM:
      ret = 'RNM';
      break;
    case id.UDT:
      ret = 'UDT';
      break;
    case id.AND:
      ret = 'AND';
      break;
    case id.NOT:
      ret = 'NOT';
      break;
    case id.REP:
      ret = 'REP';
      break;
    case id.TRG:
      ret = 'TRG';
      break;
    case id.TBS:
      ret = 'TBS';
      break;
    case id.TLS:
      ret = 'TLS';
      break;
    case id.BKR:
      ret = 'BKR';
      break;
    case id.BKA:
      ret = 'BKA';
      break;
    case id.BKN:
      ret = 'BKN';
      break;
    case id.ABG:
      ret = 'ABG';
      break;
    case id.AEN:
      ret = 'AEN';
      break;
    default:
      throw new Error('unrecognized opcode');
  }
  return ret;
};
// Translates an state identifier into a human-readable string.
exports.stateToString = function (state) {
  let ret = 'unknown';
  switch (state) {
    case id.ACTIVE:
      ret = 'ACTIVE';
      break;
    case id.MATCH:
      ret = 'MATCH';
      break;
    case id.EMPTY:
      ret = 'EMPTY';
      break;
    case id.NOMATCH:
      ret = 'NOMATCH';
      break;
    default:
      throw new Error('unrecognized state');
  }
  return ret;
};
// Array which translates all 128, 7-bit ASCII character codes to their respective HTML format.
exports.asciiChars = [
  'NUL',
  'SOH',
  'STX',
  'ETX',
  'EOT',
  'ENQ',
  'ACK',
  'BEL',
  'BS',
  'TAB',
  'LF',
  'VT',
  'FF',
  'CR',
  'SO',
  'SI',
  'DLE',
  'DC1',
  'DC2',
  'DC3',
  'DC4',
  'NAK',
  'SYN',
  'ETB',
  'CAN',
  'EM',
  'SUB',
  'ESC',
  'FS',
  'GS',
  'RS',
  'US',
  '&nbsp;',
  '!',
  '&#34;',
  '#',
  '$',
  '%',
  '&#38;',
  '&#39;',
  '(',
  ')',
  '*',
  '+',
  ',',
  '-',
  '.',
  '/',
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  ':',
  ';',
  '&#60;',
  '=',
  '&#62;',
  '?',
  '@',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
  '[',
  '&#92;',
  ']',
  '^',
  '_',
  '`',
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
  '{',
  '|',
  '}',
  '~',
  'DEL',
];
// Translates a single character to hexadecimal with leading zeros for 2, 4, or 8 digit display.
exports.charToHex = function (char) {
  let ch = char.toString(16).toUpperCase();
  switch (ch.length) {
    case 1:
    case 3:
    case 7:
      ch = `0${ch}`;
      break;
    case 2:
    case 6:
      ch = `00${ch}`;
      break;
    case 4:
      break;
    case 5:
      ch = `000${ch}`;
      break;
    default:
      throw new Error('unrecognized option');
  }
  return ch;
};
// Translates a sub-array of character codes to decimal display format.
exports.charsToDec = function (chars, beg, len) {
  let ret = '';
  if (!Array.isArray(chars)) {
    throw new Error(`${thisFileName}charsToDec: input must be an array of integers`);
  }
  const bounds = getBounds(chars.length, beg, len);
  if (bounds.end > bounds.beg) {
    ret += chars[bounds.beg];
    for (let i = bounds.beg + 1; i < bounds.end; i += 1) {
      ret += `,${chars[i]}`;
    }
  }
  return ret;
};
// Translates a sub-array of character codes to hexadecimal display format.
exports.charsToHex = function (chars, beg, len) {
  let ret = '';
  if (!Array.isArray(chars)) {
    throw new Error(`${thisFileName}charsToHex: input must be an array of integers`);
  }
  const bounds = getBounds(chars.length, beg, len);
  if (bounds.end > bounds.beg) {
    ret += `\\x${thisThis.charToHex(chars[bounds.beg])}`;
    for (let i = bounds.beg + 1; i < bounds.end; i += 1) {
      ret += `,\\x${thisThis.charToHex(chars[i])}`;
    }
  }
  return ret;
};
exports.charsToHtmlEntities = function (chars, beg, len) {
  let ret = '';
  if (!Array.isArray(chars)) {
    throw new Error(`${thisFileName}charsToHex: input must be an array of integers`);
  }
  const bounds = getBounds(chars.length, beg, len);
  if (bounds.end > bounds.beg) {
    for (let i = bounds.beg; i < bounds.end; i += 1) {
      ret += `&#x${chars[i].toString(16)};`;
    }
  }
  return ret;
};
// Translates a sub-array of character codes to Unicode display format.
function isUnicode(char) {
  if (char >= 0xd800 && char <= 0xdfff) {
    return false;
  }
  if (char > 0x10ffff) {
    return false;
  }
  return true;
}
exports.charsToUnicode = function (chars, beg, len) {
  let ret = '';
  if (!Array.isArray(chars)) {
    throw new Error(`${thisFileName}charsToUnicode: input must be an array of integers`);
  }
  const bounds = getBounds(chars.length, beg, len);
  if (bounds.end > bounds.beg) {
    for (let i = bounds.beg; i < bounds.end; i += 1) {
      if (isUnicode(chars[i])) {
        ret += `&#${chars[i]};`;
      } else {
        ret += ` U+${thisThis.charToHex(chars[i])}`;
      }
    }
  }
  return ret;
};
// Translates a sub-array of character codes to JavaScript Unicode display format (`\uXXXX`).
exports.charsToJsUnicode = function (chars, beg, len) {
  let ret = '';
  if (!Array.isArray(chars)) {
    throw new Error(`${thisFileName}charsToJsUnicode: input must be an array of integers`);
  }
  const bounds = getBounds(chars.length, beg, len);
  if (bounds.end > bounds.beg) {
    ret += `\\u${thisThis.charToHex(chars[bounds.beg])}`;
    for (let i = bounds.beg + 1; i < bounds.end; i += 1) {
      ret += `,\\u${thisThis.charToHex(chars[i])}`;
    }
  }
  return ret;
};
// Translates a sub-array of character codes to printing ASCII character display format.
exports.charsToAscii = function (chars, beg, len) {
  let ret = '';
  if (!Array.isArray(chars)) {
    throw new Error(`${thisFileName}charsToAscii: input must be an array of integers`);
  }
  const bounds = getBounds(chars.length, beg, len);
  for (let i = bounds.beg; i < bounds.end; i += 1) {
    const char = chars[i];
    if (char >= 32 && char <= 126) {
      ret += String.fromCharCode(char);
    } else {
      ret += `\\x${thisThis.charToHex(char)}`;
    }
  }
  return ret;
};
// Translates a sub-array of character codes to HTML display format.
exports.charsToAsciiHtml = function (chars, beg, len) {
  if (!Array.isArray(chars)) {
    throw new Error(`${thisFileName}charsToAsciiHtml: input must be an array of integers`);
  }
  let html = '';
  let char;
  const bounds = getBounds(chars.length, beg, len);
  for (let i = bounds.beg; i < bounds.end; i += 1) {
    char = chars[i];
    if (char < 32 || char === 127) {
      /* control characters */
      html += `<span class="${style.CLASS_CTRLCHAR}">${thisThis.asciiChars[char]}</span>`;
    } else if (char > 127) {
      /* non-ASCII */
      html += `<span class="${style.CLASS_CTRLCHAR}">U+${thisThis.charToHex(char)}</span>`;
    } else {
      /* printing ASCII, 32 <= char <= 126 */
      html += thisThis.asciiChars[char];
    }
  }
  return html;
};
// Translates a JavaScript string to HTML display format.
exports.stringToAsciiHtml = function (str) {
  const chars = converter.decode('STRING', str);
  return this.charsToAsciiHtml(chars);
};


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


const asn1 = exports;

asn1.bignum = __webpack_require__("../../node_modules/asn1.js/node_modules/bn.js/lib/bn.js");

asn1.define = (__webpack_require__("../../node_modules/asn1.js/lib/asn1/api.js").define);
asn1.base = __webpack_require__("../../node_modules/asn1.js/lib/asn1/base/index.js");
asn1.constants = __webpack_require__("../../node_modules/asn1.js/lib/asn1/constants/index.js");
asn1.decoders = __webpack_require__("../../node_modules/asn1.js/lib/asn1/decoders/index.js");
asn1.encoders = __webpack_require__("../../node_modules/asn1.js/lib/asn1/encoders/index.js");


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/api.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


const encoders = __webpack_require__("../../node_modules/asn1.js/lib/asn1/encoders/index.js");
const decoders = __webpack_require__("../../node_modules/asn1.js/lib/asn1/decoders/index.js");
const inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");

const api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
}

Entity.prototype._createNamed = function createNamed(Base) {
  const name = this.name;

  function Generated(entity) {
    this._initNamed(entity, name);
  }
  inherits(Generated, Base);
  Generated.prototype._initNamed = function _initNamed(entity, name) {
    Base.call(this, entity, name);
  };

  return new Generated(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/base/buffer.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


const inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");
const Reporter = (__webpack_require__("../../node_modules/asn1.js/lib/asn1/base/reporter.js")/* .Reporter */ .b);
const Buffer = (__webpack_require__("../../node_modules/safer-buffer/safer.js").Buffer);

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.C = DecoderBuffer;

DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
  if (data instanceof DecoderBuffer) {
    return true;
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    Buffer.isBuffer(data.base) &&
    data.constructor.name === 'DecoderBuffer' &&
    typeof data.offset === 'number' &&
    typeof data.length === 'number' &&
    typeof data.save === 'function' &&
    typeof data.restore === 'function' &&
    typeof data.isEmpty === 'function' &&
    typeof data.readUInt8 === 'function' &&
    typeof data.skip === 'function' &&
    typeof data.raw === 'function';

  return isCompatible;
};

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  const res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
};

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  const res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
};

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
};

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!EncoderBuffer.isEncoderBuffer(item))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.R = EncoderBuffer;

EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
  if (data instanceof EncoderBuffer) {
    return true;
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    data.constructor.name === 'EncoderBuffer' &&
    typeof data.length === 'number' &&
    typeof data.join === 'function';

  return isCompatible;
};

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = Buffer.alloc(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/base/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


const base = exports;

base.Reporter = (__webpack_require__("../../node_modules/asn1.js/lib/asn1/base/reporter.js")/* .Reporter */ .b);
base.DecoderBuffer = (__webpack_require__("../../node_modules/asn1.js/lib/asn1/base/buffer.js")/* .DecoderBuffer */ .C);
base.EncoderBuffer = (__webpack_require__("../../node_modules/asn1.js/lib/asn1/base/buffer.js")/* .EncoderBuffer */ .R);
base.Node = __webpack_require__("../../node_modules/asn1.js/lib/asn1/base/node.js");


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/base/node.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const Reporter = (__webpack_require__("../../node_modules/asn1.js/lib/asn1/base/reporter.js")/* .Reporter */ .b);
const EncoderBuffer = (__webpack_require__("../../node_modules/asn1.js/lib/asn1/base/buffer.js")/* .EncoderBuffer */ .R);
const DecoderBuffer = (__webpack_require__("../../node_modules/asn1.js/lib/asn1/base/buffer.js")/* .DecoderBuffer */ .C);
const assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");

// Supported tags
const tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
const methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
const overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent, name) {
  const state = {};
  this._baseState = state;

  state.name = name;
  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

const stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  const state = this._baseState;
  const cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  const res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  const state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      const clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  const state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  const state = this._baseState;

  // Filter children and args
  const children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      const res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        const value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    const state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  const state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  const state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  const state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  const state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  const state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  const state = this._baseState;
  const args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  const state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  const state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  const state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  const state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  const state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  let result = state['default'];
  let present = true;

  let prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    let tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      const save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  let prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      const explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    const start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      let save;
      if (state.any)
        save = input.save();
      const body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any) {
      // no-op
    } else if (state.choice === null) {
      result = this._decodeGeneric(state.tag, input, options);
    } else {
      result = this._decodeChoice(input, options);
    }

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      const data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
        ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  const state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
      ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  const state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  const state = this._baseState;
  let result = null;
  let match = false;

  Object.keys(state.choice).some(function(key) {
    const save = input.save();
    const node = state.choice[key];
    try {
      const value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  const state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  const result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  const state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  let result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default'];
    else
      return;
  }

  // Encode children first
  let content = null;
  let primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      const prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      const res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      const child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        const state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  if (!state.any && state.choice === null) {
    const tag = state.implicit !== null ? state.implicit : state.tag;
    const cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  const state = this._baseState;

  const node = state.choice[data.type];
  if (!node) {
    assert(
      false,
      data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  const state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/base/reporter.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


const inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.b = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  const state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  const state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  const state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  const state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  const state = this._reporterState;

  const prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  const state = this._reporterState;

  const now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  let err;
  const state = this._reporterState;

  const inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  const state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
}
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/constants/der.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


// Helper
function reverse(map) {
  const res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    const value = map[key];
    res[value] = key;
  });

  return res;
}

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = reverse(exports.tag);


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/constants/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


const constants = exports;

// Helper
constants._reverse = function reverse(map) {
  const res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    const value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__("../../node_modules/asn1.js/lib/asn1/constants/der.js");


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/decoders/der.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");

const bignum = __webpack_require__("../../node_modules/asn1.js/node_modules/bn.js/lib/bn.js");
const DecoderBuffer = (__webpack_require__("../../node_modules/asn1.js/lib/asn1/base/buffer.js")/* .DecoderBuffer */ .C);
const Node = __webpack_require__("../../node_modules/asn1.js/lib/asn1/base/node.js");

// Import DER constants
const der = __webpack_require__("../../node_modules/asn1.js/lib/asn1/constants/der.js");

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!DecoderBuffer.isDecoderBuffer(data)) {
    data = new DecoderBuffer(data, options);
  }

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  const state = buffer.save();
  const decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  const decodedTag = derDecodeTag(buffer,
    'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  let len = derDecodeLen(buffer,
    decodedTag.primitive,
    'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  const state = buffer.save();
  const res = this._skipUntilEnd(
    buffer,
    'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  for (;;) {
    const tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    const len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    let res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len);
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
  options) {
  const result = [];
  while (!buffer.isEmpty()) {
    const possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    const res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    const unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    const raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    let str = '';
    for (let i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    const numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    const printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  let result;
  const identifiers = [];
  let ident = 0;
  let subident = 0;
  while (!buffer.isEmpty()) {
    subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  const first = (identifiers[0] / 40) | 0;
  const second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    let tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  const str = buffer.raw().toString();

  let year;
  let mon;
  let day;
  let hour;
  let min;
  let sec;
  if (tag === 'gentime') {
    year = str.slice(0, 4) | 0;
    mon = str.slice(4, 6) | 0;
    day = str.slice(6, 8) | 0;
    hour = str.slice(8, 10) | 0;
    min = str.slice(10, 12) | 0;
    sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    year = str.slice(0, 2) | 0;
    mon = str.slice(2, 4) | 0;
    day = str.slice(4, 6) | 0;
    hour = str.slice(6, 8) | 0;
    min = str.slice(8, 10) | 0;
    sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull() {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  const res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  const raw = buffer.raw();
  let res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  let tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  const cls = der.tagClass[tag >> 6];
  const primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    let oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  const tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  let len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  const num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (let i = 0; i < num; i++) {
    len <<= 8;
    const j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/decoders/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


const decoders = exports;

decoders.der = __webpack_require__("../../node_modules/asn1.js/lib/asn1/decoders/der.js");
decoders.pem = __webpack_require__("../../node_modules/asn1.js/lib/asn1/decoders/pem.js");


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/decoders/pem.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");
const Buffer = (__webpack_require__("../../node_modules/safer-buffer/safer.js").Buffer);

const DERDecoder = __webpack_require__("../../node_modules/asn1.js/lib/asn1/decoders/der.js");

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  const lines = data.toString().split(/[\r\n]+/g);

  const label = options.label.toUpperCase();

  const re = /^-----(BEGIN|END) ([^-]+)-----$/;
  let start = -1;
  let end = -1;
  for (let i = 0; i < lines.length; i++) {
    const match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  const base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9+/=]+/gi, '');

  const input = Buffer.from(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/encoders/der.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");
const Buffer = (__webpack_require__("../../node_modules/safer-buffer/safer.js").Buffer);
const Node = __webpack_require__("../../node_modules/asn1.js/lib/asn1/base/node.js");

// Import DER constants
const der = __webpack_require__("../../node_modules/asn1.js/lib/asn1/constants/der.js");

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
  primitive,
  cls,
  content) {
  const encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    const header = Buffer.alloc(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  let lenOctets = 1;
  for (let i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  const header = Buffer.alloc(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    const buf = Buffer.alloc(str.length * 2);
    for (let i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s.]+/g);
    for (let i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (let i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  let size = 0;
  for (let i = 0; i < id.length; i++) {
    let ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  const objid = Buffer.alloc(size);
  let offset = objid.length - 1;
  for (let i = id.length - 1; i >= 0; i--) {
    let ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  let str;
  const date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getUTCFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getUTCFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    const numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = Buffer.from(numArray);
  }

  if (Buffer.isBuffer(num)) {
    let size = num.length;
    if (num.length === 0)
      size++;

    const out = Buffer.alloc(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0;
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  let size = 1;
  for (let i = num; i >= 0x100; i >>= 8)
    size++;

  const out = new Array(size);
  for (let i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(Buffer.from(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  const state = this._baseState;
  let i;
  if (state['default'] === null)
    return false;

  const data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  let res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/encoders/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


const encoders = exports;

encoders.der = __webpack_require__("../../node_modules/asn1.js/lib/asn1/encoders/der.js");
encoders.pem = __webpack_require__("../../node_modules/asn1.js/lib/asn1/encoders/pem.js");


/***/ }),

/***/ "../../node_modules/asn1.js/lib/asn1/encoders/pem.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");

const DEREncoder = __webpack_require__("../../node_modules/asn1.js/lib/asn1/encoders/der.js");

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  const buf = DEREncoder.prototype.encode.call(this, data);

  const p = buf.toString('base64');
  const out = [ '-----BEGIN ' + options.label + '-----' ];
  for (let i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),

/***/ "../../node_modules/asn1.js/node_modules/bn.js/lib/bn.js":
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ "./src/Authentication.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createPrivateKeyAuthentication = exports.createAuthentication = exports.AuthenticationInjectionToken = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.starts-with.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var _wallet = __webpack_require__("../../node_modules/@ethersproject/wallet/lib.esm/index.js");
var _providers = __webpack_require__("../../node_modules/@ethersproject/providers/lib.esm/index.js");
var _transactions = __webpack_require__("../../node_modules/@ethersproject/transactions/lib.esm/index.js");
var _Ethereum = __webpack_require__("./src/Ethereum.ts");
var _promises = __webpack_require__("./src/utils/promises.ts");
var _pMemoize = _interopRequireDefault(__webpack_require__("../../node_modules/p-memoize/index.js"));
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _signingUtils = __webpack_require__("./src/utils/signingUtils.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var AuthenticationInjectionToken = Symbol('Authentication');
exports.AuthenticationInjectionToken = AuthenticationInjectionToken;
var createPrivateKeyAuthentication = function createPrivateKeyAuthentication(key, config) {
  var address = (0, _utils.toEthereumAddress)((0, _transactions.computeAddress)(key));
  return {
    getAddress: function () {
      var _getAddress = _asyncToGenerator(function* () {
        return address;
      });
      function getAddress() {
        return _getAddress.apply(this, arguments);
      }
      return getAddress;
    }(),
    createMessageSignature: function () {
      var _createMessageSignature = _asyncToGenerator(function* (payload) {
        return (0, _signingUtils.sign)(payload, key);
      });
      function createMessageSignature(_x) {
        return _createMessageSignature.apply(this, arguments);
      }
      return createMessageSignature;
    }(),
    getStreamRegistryChainSigner: function () {
      var _getStreamRegistryChainSigner = _asyncToGenerator(function* () {
        var primaryProvider = (0, _Ethereum.getStreamRegistryChainProviders)(config)[0];
        return new _wallet.Wallet(key, primaryProvider);
      });
      function getStreamRegistryChainSigner() {
        return _getStreamRegistryChainSigner.apply(this, arguments);
      }
      return getStreamRegistryChainSigner;
    }()
  };
};
exports.createPrivateKeyAuthentication = createPrivateKeyAuthentication;
var createAuthentication = function createAuthentication(config) {
  var _config$auth, _config$auth2;
  if (((_config$auth = config.auth) === null || _config$auth === void 0 ? void 0 : _config$auth.privateKey) !== undefined) {
    var privateKey = config.auth.privateKey;
    var normalizedPrivateKey = !privateKey.startsWith('0x') ? "0x".concat(privateKey) : privateKey;
    return createPrivateKeyAuthentication(normalizedPrivateKey, config);
  } else if (((_config$auth2 = config.auth) === null || _config$auth2 === void 0 ? void 0 : _config$auth2.ethereum) !== undefined) {
    var _config$auth3;
    var ethereum = (_config$auth3 = config.auth) === null || _config$auth3 === void 0 ? void 0 : _config$auth3.ethereum;
    var provider = new _providers.Web3Provider(ethereum);
    var signer = provider.getSigner();
    return {
      getAddress: (0, _pMemoize.default)( /*#__PURE__*/_asyncToGenerator(function* () {
        try {
          if (!('request' in ethereum && typeof ethereum.request === 'function')) {
            throw new Error("invalid ethereum provider ".concat(ethereum));
          }
          var accounts = yield ethereum.request({
            method: 'eth_requestAccounts'
          });
          return (0, _utils.toEthereumAddress)(accounts[0]);
        } catch (_unused) {
          throw new Error('no addresses connected and selected in the custom authentication provider');
        }
      })),
      createMessageSignature: (0, _promises.pLimitFn)( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(function* (payload) {
          // sign one at a time & wait a moment before asking for next signature
          // otherwise MetaMask extension may not show the prompt window
          var sig = yield signer.signMessage(payload);
          yield (0, _utils.wait)(50);
          return sig;
        });
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }(), 1),
      getStreamRegistryChainSigner: function () {
        var _getStreamRegistryChainSigner2 = _asyncToGenerator(function* () {
          if (config.contracts.streamRegistryChainRPCs.chainId === undefined) {
            throw new Error('Streamr streamRegistryChainRPC not configured (with chainId) in the StreamrClient options!');
          }
          var _yield$provider$getNe = yield provider.getNetwork(),
            chainId = _yield$provider$getNe.chainId;
          if (chainId !== config.contracts.streamRegistryChainRPCs.chainId) {
            var sideChainId = config.contracts.streamRegistryChainRPCs.chainId;
            throw new Error( // eslint-disable-next-line max-len
            "Please connect the custom authentication provider to Ethereum blockchain with chainId ".concat(sideChainId, ": current chainId is ").concat(chainId));
          }
          return signer;
          // TODO: handle events
          // ethereum.on('accountsChanged', (accounts) => { })
          // https://docs.metamask.io/guide/ethereum-provider.html#events says:
          //   "We recommend reloading the page unless you have a very good reason not to"
          //   Of course we can't and won't do that, but if we need something chain-dependent...
          // ethereum.on('chainChanged', (chainId) => { window.location.reload() });
        });
        function getStreamRegistryChainSigner() {
          return _getStreamRegistryChainSigner2.apply(this, arguments);
        }
        return getStreamRegistryChainSigner;
      }()
    };
  } else {
    return createPrivateKeyAuthentication(_wallet.Wallet.createRandom().privateKey, config);
  }
};
exports.createAuthentication = createAuthentication;

/***/ }),

/***/ "./src/Config.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.validateConfig = exports.redactConfig = exports.createStrictConfig = exports.STREAMR_STORAGE_NODE_GERMANY = exports.ConfigInjectionToken = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.trim.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/reflect-metadata/Reflect.js");
var _cloneDeep = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/cloneDeep.js"));
var _ajv = _interopRequireDefault(__webpack_require__("./node_modules/ajv/dist/ajv.js"));
var _ajvFormats = _interopRequireDefault(__webpack_require__("../../node_modules/ajv-formats/dist/index.js"));
var _configSchema = _interopRequireDefault(__webpack_require__("./src/config.schema.json"));
var _utils = __webpack_require__("./src/utils/utils.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// these should come from ETH-184 config package when it's ready

/**
 * @category Important
 */

var STREAMR_STORAGE_NODE_GERMANY = '0x31546eEA76F2B2b3C5cC06B1c93601dc35c9D916';
exports.STREAMR_STORAGE_NODE_GERMANY = STREAMR_STORAGE_NODE_GERMANY;
var createStrictConfig = function createStrictConfig() {
  var _config$id;
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // TODO is it good to cloneDeep the input object as it may have object references (e.g. auth.ethereum)?
  var config = validateConfig((0, _cloneDeep.default)(input));
  (_config$id = config.id) !== null && _config$id !== void 0 ? _config$id : config.id = (0, _utils.generateClientId)();
  return config;
};
exports.createStrictConfig = createStrictConfig;
var validateConfig = function validateConfig(data) {
  var ajv = new _ajv.default({
    useDefaults: true
  });
  (0, _ajvFormats.default)(ajv);
  ajv.addFormat('ethereum-address', /^0x[a-zA-Z0-9]{40}$/);
  ajv.addFormat('ethereum-private-key', /^(0x)?[a-zA-Z0-9]{64}$/);
  var validate = ajv.compile(_configSchema.default);
  if (!validate(data)) {
    throw new Error(validate.errors.map(function (e) {
      var text = ajv.errorsText([e], {
        dataVar: ''
      }).trim();
      if (e.params.additionalProperty) {
        text += ": ".concat(e.params.additionalProperty);
      }
      return text;
    }).join('\n'));
  }
  return data;
};
exports.validateConfig = validateConfig;
var redactConfig = function redactConfig(config) {
  var _config$auth;
  if (((_config$auth = config.auth) === null || _config$auth === void 0 ? void 0 : _config$auth.privateKey) !== undefined) {
    config.auth.privateKey = '(redacted)';
  }
};
exports.redactConfig = redactConfig;
var ConfigInjectionToken = Symbol('Config');
exports.ConfigInjectionToken = ConfigInjectionToken;

/***/ }),

/***/ "./src/ConfigTest.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DOCKER_DEV_STORAGE_NODE = exports.CONFIG_TEST = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _toNumber, _toNumber2;
function toNumber(value) {
  return value !== undefined ? Number(value) : undefined;
}
var sideChainConfig = {
  name: 'streamr',
  chainId: 8997,
  rpcs: [{
    url: process.env.SIDECHAIN_URL || "http://".concat(process.env.STREAMR_DOCKER_DEV_HOST || '127.0.0.1', ":8546"),
    timeout: (_toNumber = toNumber(process.env.TEST_TIMEOUT)) !== null && _toNumber !== void 0 ? _toNumber : 30 * 1000
  }]
};

/**
 * Streamr client constructor options that work in the test environment
 */
var CONFIG_TEST = {
  network: {
    trackers: [{
      id: '0xb9e7cEBF7b03AE26458E32a059488386b05798e8',
      ws: "ws://".concat(process.env.STREAMR_DOCKER_DEV_HOST || '127.0.0.1', ":30301"),
      http: "http://".concat(process.env.STREAMR_DOCKER_DEV_HOST || '127.0.0.1', ":30301")
    }, {
      id: '0x0540A3e144cdD81F402e7772C76a5808B71d2d30',
      ws: "ws://".concat(process.env.STREAMR_DOCKER_DEV_HOST || '127.0.0.1', ":30302"),
      http: "http://".concat(process.env.STREAMR_DOCKER_DEV_HOST || '127.0.0.1', ":30302")
    }, {
      id: '0xf2C195bE194a2C91e93Eacb1d6d55a00552a85E2',
      ws: "ws://".concat(process.env.STREAMR_DOCKER_DEV_HOST || '127.0.0.1', ":30303"),
      http: "http://".concat(process.env.STREAMR_DOCKER_DEV_HOST || '127.0.0.1', ":30303")
    }],
    webrtcDisallowPrivateAddresses: false,
    iceServers: []
  },
  contracts: {
    streamRegistryChainAddress: '0x6cCdd5d866ea766f6DF5965aA98DeCCD629ff222',
    streamStorageRegistryChainAddress: '0xd04af489677001444280366Dd0885B03dAaDe71D',
    storageNodeRegistryChainAddress: '0x231b810D98702782963472e1D60a25496999E75D',
    mainChainRPCs: {
      name: 'dev_ethereum',
      chainId: 8995,
      rpcs: [{
        url: process.env.ETHEREUM_SERVER_URL || "http://".concat(process.env.STREAMR_DOCKER_DEV_HOST || '127.0.0.1', ":8545"),
        timeout: (_toNumber2 = toNumber(process.env.TEST_TIMEOUT)) !== null && _toNumber2 !== void 0 ? _toNumber2 : 30 * 1000
      }]
    },
    streamRegistryChainRPCs: sideChainConfig,
    theGraphUrl: "http://".concat(process.env.STREAMR_DOCKER_DEV_HOST || '127.0.0.1', ":8000/subgraphs/name/streamr-dev/network-contracts")
  },
  _timeouts: {
    theGraph: {
      timeout: 10 * 1000,
      retryInterval: 500
    },
    storageNode: {
      timeout: 30 * 1000,
      retryInterval: 500
    },
    ensStreamCreation: {
      timeout: 20 * 1000,
      retryInterval: 500
    },
    httpFetchTimeout: 30 * 1000
  },
  metrics: false
};
exports.CONFIG_TEST = CONFIG_TEST;
var DOCKER_DEV_STORAGE_NODE = (0, _utils.toEthereumAddress)('0xde1112f631486CfC759A50196853011528bC5FA0');
exports.DOCKER_DEV_STORAGE_NODE = DOCKER_DEV_STORAGE_NODE;

/***/ }),

/***/ "./src/ContractFactory.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ContractFactory = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
var _contracts = __webpack_require__("../../node_modules/@ethersproject/contracts/lib.esm/index.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Config = __webpack_require__("./src/Config.ts");
var _events = __webpack_require__("./src/events.ts");
var _contract = __webpack_require__("./src/utils/contract.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _class;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ContractFactory = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_LoggerFactory.LoggerFactory)(target, undefined, 1);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 2);
}, _dec4 = Reflect.metadata("design:type", Function), _dec5 = Reflect.metadata("design:paramtypes", [typeof _events.StreamrClientEventEmitter === "undefined" ? Object : _events.StreamrClientEventEmitter, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = /*#__PURE__*/function () {
  function ContractFactory(eventEmitter, loggerFactory, config) {
    _classCallCheck(this, ContractFactory);
    this.eventEmitter = eventEmitter;
    this.loggerFactory = loggerFactory;
    this.config = config;
  }
  _createClass(ContractFactory, [{
    key: "createReadContract",
    value: function createReadContract(address, contractInterface, provider, name) {
      return (0, _contract.createDecoratedContract)(new _contracts.Contract(address, contractInterface, provider), name, this.loggerFactory, this.config.contracts.maxConcurrentCalls);
    }
  }, {
    key: "createWriteContract",
    value: function createWriteContract(address, contractInterface, signer, name) {
      var _this = this;
      var contract = (0, _contract.createDecoratedContract)(new _contracts.Contract(address, contractInterface, signer), name, this.loggerFactory,
      // The current maxConcurrentCalls value is just a placeholder as we don't support concurrent writes (as we don't use nonces).
      // When we add the support, we should use the maxConcurrentCalls option from client config here.
      // Also note that if we'd use a limit of 1, it wouldn't make the concurrent transactions to a sequence of transactions,
      // because the concurrency limit covers only submits, not tx.wait() calls.
      999999);
      contract.eventEmitter.on('onTransactionConfirm', function (methodName, transaction, receipt) {
        _this.eventEmitter.emit('confirmContractTransaction', {
          methodName: methodName,
          transaction: transaction,
          receipt: receipt
        });
      });
      return contract;
    }
  }]);
  return ContractFactory;
}()) || _class) || _class) || _class) || _class) || _class);
exports.ContractFactory = ContractFactory;

/***/ }),

/***/ "./src/DestroySignal.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DestroySignal = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Signal = __webpack_require__("./src/utils/Signal.ts");
var _StreamrClientError = __webpack_require__("./src/StreamrClientError.ts");
var _dec, _dec2, _dec3, _class;
/**
 * Client-wide destroy signal.
 */
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Listen to onDestroy to fire cleanup code on destroy.
 * Careful not to introduce memleaks.
 * Trigger this to destroy the client.
 */
var DestroySignal = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = Reflect.metadata("design:type", Function), _dec3 = Reflect.metadata("design:paramtypes", []), _dec(_class = _dec2(_class = _dec3(_class = /*#__PURE__*/function () {
  function DestroySignal() {
    _classCallCheck(this, DestroySignal);
    _defineProperty(this, "onDestroy", _Signal.Signal.once());
    _defineProperty(this, "trigger", this.destroy);
    var controller = new AbortController();
    this.abortSignal = controller.signal;
    this.onDestroy.listen(function () {
      controller.abort();
    });
  }
  _createClass(DestroySignal, [{
    key: "destroy",
    value: function destroy() {
      return this.onDestroy.trigger();
    }
  }, {
    key: "assertNotDestroyed",
    value: function assertNotDestroyed() {
      if (this.isDestroyed()) {
        throw new _StreamrClientError.StreamrClientError('Client is destroyed. Create a new instance', 'CLIENT_DESTROYED');
      }
    }
  }, {
    key: "isDestroyed",
    value: function isDestroyed() {
      return this.onDestroy.triggerCount() > 0;
    }
  }]);
  return DestroySignal;
}()) || _class) || _class) || _class);
exports.DestroySignal = DestroySignal;

/***/ }),

/***/ "./src/Ethereum.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getStreamRegistryOverrides = exports.getStreamRegistryChainProviders = exports.getMainnetProviders = exports.generateEthereumAccount = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
var _wallet = __webpack_require__("../../node_modules/@ethersproject/wallet/lib.esm/index.js");
var _providers = __webpack_require__("../../node_modules/@ethersproject/providers/lib.esm/index.js");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * Config and utilities for interating with identity & Ethereum chain.
                                                                                                                                                                                                                                                                                                                                                                                               */
var generateEthereumAccount = function generateEthereumAccount() {
  var wallet = _wallet.Wallet.createRandom();
  return {
    address: wallet.address,
    privateKey: wallet.privateKey
  };
};
exports.generateEthereumAccount = generateEthereumAccount;
var getMainnetProviders = function getMainnetProviders(config) {
  return getRpcProviders(config.contracts.mainChainRPCs, config.contracts.pollInterval);
};
exports.getMainnetProviders = getMainnetProviders;
var getStreamRegistryChainProviders = function getStreamRegistryChainProviders(config) {
  return getRpcProviders(config.contracts.streamRegistryChainRPCs, config.contracts.pollInterval);
};
exports.getStreamRegistryChainProviders = getStreamRegistryChainProviders;
var getRpcProviders = function getRpcProviders(connectionInfo, pollInterval) {
  return connectionInfo.rpcs.map(function (c) {
    var provider = new _providers.JsonRpcProvider(c);
    if (pollInterval !== undefined) {
      provider.pollingInterval = pollInterval;
    }
    return provider;
  });
};
var getStreamRegistryOverrides = function getStreamRegistryOverrides(config) {
  var _config$contracts$str;
  var primaryProvider = getStreamRegistryChainProviders(config)[0];
  return getOverrides((_config$contracts$str = config.contracts.streamRegistryChainRPCs.name) !== null && _config$contracts$str !== void 0 ? _config$contracts$str : 'polygon', primaryProvider, config);
};

/**
 * Apply the gasPriceStrategy to the estimated gas price, if given
 * Ethers.js will resolve the gas price promise before sending the tx
 */
exports.getStreamRegistryOverrides = getStreamRegistryOverrides;
var getOverrides = function getOverrides(chainName, provider, config) {
  var _chainConfig$override;
  var chainConfig = config.contracts.ethereumNetworks[chainName];
  if (chainConfig === undefined) {
    return {};
  }
  var overrides = (_chainConfig$override = chainConfig.overrides) !== null && _chainConfig$override !== void 0 ? _chainConfig$override : {};
  if (chainConfig.highGasPriceStrategy) {
    var gasPriceStrategy = function gasPriceStrategy(estimatedGasPrice) {
      return estimatedGasPrice.add('10000000000');
    };
    return _objectSpread(_objectSpread({}, overrides), {}, {
      gasPrice: provider.getGasPrice().then(gasPriceStrategy)
    });
  }
  return overrides;
};

/***/ }),

/***/ "./src/HttpUtil.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ValidationError = exports.NotFoundError = exports.HttpUtil = exports.HttpError = exports.ErrorCode = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.from-entries.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.entries.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/web.url-search-params.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var _nodeFetch = _interopRequireDefault(__webpack_require__("./src/shim/node-fetch.ts"));
var _WebStreamToNodeStream = __webpack_require__("./src/utils/WebStreamToNodeStream.ts");
var _split = _interopRequireDefault(__webpack_require__("./node_modules/split2/index.js"));
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _dec, _dec2, _dec3, _dec4, _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _asyncGeneratorDelegate(inner) { var iter = {}, waiting = !1; function pump(key, value) { return waiting = !0, value = new Promise(function (resolve) { resolve(inner[key](value)); }), { done: !1, value: new _OverloadYield(value, 1) }; } return iter["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () { return this; }, iter.next = function (value) { return waiting ? (waiting = !1, value) : pump("next", value); }, "function" == typeof inner.throw && (iter.throw = function (value) { if (waiting) throw waiting = !1, value; return pump("throw", value); }), "function" == typeof inner.return && (iter.return = function (value) { return waiting ? (waiting = !1, value) : pump("return", value); }), iter; }
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
var ErrorCode = /*#__PURE__*/function (ErrorCode) {
  ErrorCode["NOT_FOUND"] = "NOT_FOUND";
  ErrorCode["VALIDATION_ERROR"] = "VALIDATION_ERROR";
  ErrorCode["UNKNOWN"] = "UNKNOWN";
  return ErrorCode;
}({});
exports.ErrorCode = ErrorCode;
var HttpError = /*#__PURE__*/function (_Error) {
  _inherits(HttpError, _Error);
  var _super = _createSuper(HttpError);
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  function HttpError(message, response, body, errorCode) {
    var _this2;
    _classCallCheck(this, HttpError);
    var typePrefix = errorCode ? errorCode + ': ' : '';
    // add leading space if there is a body set
    _this2 = _super.call(this, typePrefix + message);
    _this2.response = response;
    _this2.body = body;
    _this2.code = errorCode || ErrorCode.UNKNOWN;
    _this2.errorCode = _this2.code;
    return _this2;
  }
  return _createClass(HttpError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.HttpError = HttpError;
var ValidationError = /*#__PURE__*/function (_HttpError) {
  _inherits(ValidationError, _HttpError);
  var _super2 = _createSuper(ValidationError);
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  function ValidationError(message, response, body) {
    _classCallCheck(this, ValidationError);
    return _super2.call(this, message, response, body, ErrorCode.VALIDATION_ERROR);
  }
  return _createClass(ValidationError);
}(HttpError);
exports.ValidationError = ValidationError;
var NotFoundError = /*#__PURE__*/function (_HttpError2) {
  _inherits(NotFoundError, _HttpError2);
  var _super3 = _createSuper(NotFoundError);
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  function NotFoundError(message, response, body) {
    _classCallCheck(this, NotFoundError);
    return _super3.call(this, message, response, body, ErrorCode.NOT_FOUND);
  }
  return _createClass(NotFoundError);
}(HttpError);
exports.NotFoundError = NotFoundError;
var ERROR_TYPES = new Map();
ERROR_TYPES.set(ErrorCode.VALIDATION_ERROR, ValidationError);
ERROR_TYPES.set(ErrorCode.NOT_FOUND, NotFoundError);
ERROR_TYPES.set(ErrorCode.UNKNOWN, HttpError);
var parseErrorCode = function parseErrorCode(body) {
  var json;
  try {
    json = JSON.parse(body);
  } catch (err) {
    return ErrorCode.UNKNOWN;
  }
  var _json = json,
    code = _json.code;
  return code in ErrorCode ? code : ErrorCode.UNKNOWN;
};
var HttpUtil = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_LoggerFactory.LoggerFactory)(target, undefined, 0);
}, _dec3 = Reflect.metadata("design:type", Function), _dec4 = Reflect.metadata("design:paramtypes", [typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = /*#__PURE__*/function () {
  function HttpUtil(loggerFactory) {
    _classCallCheck(this, HttpUtil);
    this.logger = loggerFactory.createLogger(module);
  }
  _createClass(HttpUtil, [{
    key: "fetchHttpStream",
    value: function fetchHttpStream(url) {
      var _this = this;
      var abortController = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new AbortController();
      return _wrapAsyncGenerator(function* () {
        // cast is needed until this is fixed: https://github.com/node-fetch/node-fetch/issues/1652
        var response = yield _awaitAsyncGenerator(fetchResponse(url, _this.logger, abortController.signal));
        if (!response.body) {
          throw new Error('No Response Body');
        }
        var stream;
        try {
          // in the browser, response.body will be a web stream. Convert this into a node stream.
          var source = (0, _WebStreamToNodeStream.WebStreamToNodeStream)(response.body);
          stream = source.pipe((0, _split.default)(function (message) {
            return _protocol.StreamMessage.deserialize(message);
          }));
          stream.once('close', function () {
            abortController.abort();
          });
          yield* _asyncGeneratorDelegate(_asyncIterator(stream), _awaitAsyncGenerator);
        } catch (err) {
          abortController.abort();
          throw err;
        } finally {
          var _stream;
          (_stream = stream) === null || _stream === void 0 ? void 0 : _stream.destroy();
        }
      })();
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "createQueryString",
    value: function createQueryString(query) {
      var withoutEmpty = Object.fromEntries(Object.entries(query).filter(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          _k = _ref2[0],
          v = _ref2[1];
        return v != null;
      }));
      return new URLSearchParams(withoutEmpty).toString();
    }
  }]);
  return HttpUtil;
}()) || _class) || _class) || _class) || _class);
exports.HttpUtil = HttpUtil;
function fetchResponse(_x2, _x3, _x4) {
  return _fetchResponse.apply(this, arguments);
}
function _fetchResponse() {
  _fetchResponse = _asyncToGenerator(function* (url, logger, abortSignal) {
    var timeStart = Date.now();
    logger.debug('Send HTTP request', {
      url: url
    });
    var response = yield (0, _nodeFetch.default)(url, {
      signal: abortSignal
    });
    var timeEnd = Date.now();
    logger.debug('Received HTTP response', {
      url: url,
      status: response.status,
      statusText: response.statusText,
      timeTakenInMs: timeEnd - timeStart
    });
    if (response.ok) {
      return response;
    }
    var body = yield response.text();
    var errorCode = parseErrorCode(body);
    var ErrorClass = ERROR_TYPES.get(errorCode);
    throw new ErrorClass("Request to ".concat(url, " returned with error code ").concat(response.status, "."), response, body, errorCode);
  });
  return _fetchResponse.apply(this, arguments);
}

/***/ }),

/***/ "./src/Message.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.convertStreamMessageToMessage = void 0;
/**
 * Represents a message in the Streamr Network.
 *
 * @category Important
 */

var convertStreamMessageToMessage = function convertStreamMessageToMessage(msg) {
  return {
    content: msg.getParsedContent(),
    streamId: msg.getStreamId(),
    streamPartition: msg.getStreamPartition(),
    timestamp: msg.getTimestamp(),
    sequenceNumber: msg.getSequenceNumber(),
    signature: msg.signature,
    publisherId: msg.getPublisherId(),
    msgChainId: msg.getMsgChainId(),
    streamMessage: msg
    // TODO add other relevant fields (could update some test assertions to
    // use those keys instead of getting the fields via from streamMessage property)
  };
};
exports.convertStreamMessageToMessage = convertStreamMessageToMessage;

/***/ }),

/***/ "./src/MetricsPublisher.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MetricsPublisher = exports.DEFAULTS = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _events = __webpack_require__("./src/events.ts");
var _DestroySignal = __webpack_require__("./src/DestroySignal.ts");
var _NetworkNodeFacade = __webpack_require__("./src/NetworkNodeFacade.ts");
var _Publisher = __webpack_require__("./src/publish/Publisher.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _promises = __webpack_require__("./src/utils/promises.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DEFAULTS = {
  periods: [{
    duration: 60000,
    streamId: 'streamr.eth/metrics/nodes/firehose/min'
  }, {
    duration: 3600000,
    streamId: 'streamr.eth/metrics/nodes/firehose/hour'
  }, {
    duration: 86400000,
    streamId: 'streamr.eth/metrics/nodes/firehose/day'
  }],
  maxPublishDelay: 30000
};
exports.DEFAULTS = DEFAULTS;
var getNormalizedConfig = function getNormalizedConfig(config) {
  if (config.metrics === true) {
    return DEFAULTS;
  } else if (config.metrics === false) {
    return _objectSpread(_objectSpread({}, DEFAULTS), {}, {
      periods: []
    });
  } else if (config.metrics !== undefined) {
    return (0, _utils.merge)(DEFAULTS, config.metrics);
  } else {
    var _config$auth;
    var isEthereumAuth = ((_config$auth = config.auth) === null || _config$auth === void 0 ? void 0 : _config$auth.ethereum) !== undefined;
    return _objectSpread(_objectSpread({}, DEFAULTS), {}, {
      periods: isEthereumAuth ? [] : DEFAULTS.periods
    });
  }
};
var MetricsPublisher = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_Publisher.Publisher)(target, undefined, 0);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_NetworkNodeFacade.NetworkNodeFacade)(target, undefined, 1);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)(_events.StreamrClientEventEmitter)(target, undefined, 2);
}, _dec5 = function _dec5(target, key) {
  return (0, _tsyringe.inject)(_DestroySignal.DestroySignal)(target, undefined, 3);
}, _dec6 = function _dec6(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 4);
}, _dec7 = Reflect.metadata("design:type", Function), _dec8 = Reflect.metadata("design:paramtypes", [typeof _Publisher.Publisher === "undefined" ? Object : _Publisher.Publisher, typeof _NetworkNodeFacade.NetworkNodeFacade === "undefined" ? Object : _NetworkNodeFacade.NetworkNodeFacade, typeof _events.StreamrClientEventEmitter === "undefined" ? Object : _events.StreamrClientEventEmitter, typeof _DestroySignal.DestroySignal === "undefined" ? Object : _DestroySignal.DestroySignal, typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = _dec8(_class = /*#__PURE__*/function () {
  function MetricsPublisher(publisher, node, eventEmitter, destroySignal, config) {
    var _this = this;
    _classCallCheck(this, MetricsPublisher);
    this.publisher = publisher;
    this.node = node;
    this.eventEmitter = eventEmitter;
    this.destroySignal = destroySignal;
    this.config = getNormalizedConfig(config);
    var ensureStarted = (0, _promises.pOnce)( /*#__PURE__*/_asyncToGenerator(function* () {
      var node = yield _this.node.getNode();
      var metricsContext = node.getMetricsContext();
      var partitionKey = (0, _NetworkNodeFacade.getEthereumAddressFromNodeId)(node.getNodeId()).toLowerCase();
      _this.config.periods.map(function (config) {
        return metricsContext.createReportProducer( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(function* (report) {
            yield _this.publish(report, config.streamId, partitionKey);
          });
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(), config.duration, _this.destroySignal.abortSignal);
      });
    }));
    if (this.config.periods.length > 0) {
      this.eventEmitter.on('publish', function () {
        return ensureStarted();
      });
      this.eventEmitter.on('subscribe', function () {
        return ensureStarted();
      });
    }
  }
  _createClass(MetricsPublisher, [{
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator(function* (report, streamId, partitionKey) {
        yield (0, _utils.wait)(Math.random() * this.config.maxPublishDelay);
        try {
          yield this.publisher.publish(streamId, report, {
            timestamp: report.period.end,
            partitionKey: partitionKey
          });
        } catch (e) {
          console.warn("Unable to publish metrics: ".concat(e.message));
        }
      });
      function publish(_x2, _x3, _x4) {
        return _publish.apply(this, arguments);
      }
      return publish;
    }()
  }]);
  return MetricsPublisher;
}()) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
exports.MetricsPublisher = MetricsPublisher;

/***/ }),

/***/ "./src/NetworkNodeFacade.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getEthereumAddressFromNodeId = exports.NetworkNodeFactory = exports.NetworkNodeFacade = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.starts-with.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _eventemitter = _interopRequireDefault(__webpack_require__("../../node_modules/eventemitter3/index.js"));
var _networkNode = __webpack_require__("../network/src/exports-browser.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _uuid = __webpack_require__("./src/utils/uuid.ts");
var _promises = __webpack_require__("./src/utils/promises.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _DestroySignal = __webpack_require__("./src/DestroySignal.ts");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _trackerRegistry = __webpack_require__("./src/registry/trackerRegistry.ts");
var _dec, _class, _dec2, _dec3, _dec4, _dec5, _dec6, _class2;
/**
 * Wrap a network node.
 */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// TODO should we make getNode() an internal method, and provide these all these services as client methods?
/** @deprecated This in an internal interface */

var getEthereumAddressFromNodeId = function getEthereumAddressFromNodeId(nodeId) {
  var ETHERUM_ADDRESS_LENGTH = 42;
  return nodeId.substring(0, ETHERUM_ADDRESS_LENGTH);
};
exports.getEthereumAddressFromNodeId = getEthereumAddressFromNodeId;
/**
 * The factory is used so that integration tests can replace the real network node with a fake instance
 */
/* eslint-disable class-methods-use-this */
var NetworkNodeFactory = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec(_class = /*#__PURE__*/function () {
  function NetworkNodeFactory() {
    _classCallCheck(this, NetworkNodeFactory);
  }
  _createClass(NetworkNodeFactory, [{
    key: "createNetworkNode",
    value: function createNetworkNode(opts) {
      return (0, _networkNode.createNetworkNode)(opts);
    }
  }]);
  return NetworkNodeFactory;
}()) || _class);
/**
 * Wrap a network node.
 * Lazily creates & starts node on first call to getNode().
 */
exports.NetworkNodeFactory = NetworkNodeFactory;
var NetworkNodeFacade = (_dec2 = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 2);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 3);
}, _dec5 = Reflect.metadata("design:type", Function), _dec6 = Reflect.metadata("design:paramtypes", [typeof _DestroySignal.DestroySignal === "undefined" ? Object : _DestroySignal.DestroySignal, typeof NetworkNodeFactory === "undefined" ? Object : NetworkNodeFactory, typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication, typeof Pick === "undefined" ? Object : Pick]), _dec2(_class2 = _dec3(_class2 = _dec4(_class2 = _dec5(_class2 = _dec6(_class2 = /*#__PURE__*/function () {
  function NetworkNodeFacade(destroySignal, networkNodeFactory, authentication, config) {
    var _this = this;
    _classCallCheck(this, NetworkNodeFacade);
    _defineProperty(this, "startNodeCalled", false);
    _defineProperty(this, "startNodeComplete", false);
    /**
     * Stop network node, or wait for it to stop if already stopping.
     * Subsequent calls to getNode/start will fail.
     */
    _defineProperty(this, "destroy", (0, _promises.pOnce)( /*#__PURE__*/_asyncToGenerator(function* () {
      var node = _this.cachedNode;
      _this.cachedNode = undefined;
      // stop node only if started or in progress
      if (node && _this.startNodeCalled) {
        if (!_this.startNodeComplete) {
          // wait for start to finish before stopping node
          var startNodeTask = _this.startNodeTask();
          _this.startNodeTask.reset(); // allow subsequent calls to fail
          yield startNodeTask;
        }
        yield node.stop();
      }
      _this.startNodeTask.reset(); // allow subsequent calls to fail
    })));
    /**
     * Start network node, or wait for it to start if already started.
     */
    _defineProperty(this, "startNodeTask", (0, _promises.pOnce)( /*#__PURE__*/_asyncToGenerator(function* () {
      _this.startNodeCalled = true;
      try {
        var node = yield _this.initNode();
        if (!_this.destroySignal.isDestroyed()) {
          node.start();
        }
        if (_this.destroySignal.isDestroyed()) {
          yield node.stop();
        } else {
          _this.eventEmitter.emit('start');
        }
        _this.assertNotDestroyed();
        return node;
      } finally {
        _this.startNodeComplete = true;
      }
    })));
    _defineProperty(this, "startNode", this.startNodeTask);
    _defineProperty(this, "getNode", this.startNodeTask);
    this.destroySignal = destroySignal;
    this.networkNodeFactory = networkNodeFactory;
    this.authentication = authentication;
    this.config = config;
    this.eventEmitter = new _eventemitter.default();
    destroySignal.onDestroy.listen(this.destroy);
  }
  _createClass(NetworkNodeFacade, [{
    key: "assertNotDestroyed",
    value: function assertNotDestroyed() {
      this.destroySignal.assertNotDestroyed();
    }
  }, {
    key: "getNetworkOptions",
    value: function () {
      var _getNetworkOptions = _asyncToGenerator(function* () {
        var id = this.config.network.id;
        if (id == null || id === '') {
          id = yield this.generateId();
        } else {
          var ethereumAddress = yield this.authentication.getAddress();
          if (!id.toLowerCase().startsWith(ethereumAddress)) {
            throw new Error("given node id ".concat(id, " not compatible with authenticated wallet ").concat(ethereumAddress));
          }
        }
        return _objectSpread(_objectSpread({}, this.config.network), {}, {
          id: id,
          trackers: yield (0, _trackerRegistry.getTrackers)(this.config),
          metricsContext: new _utils.MetricsContext()
        });
      });
      function getNetworkOptions() {
        return _getNetworkOptions.apply(this, arguments);
      }
      return getNetworkOptions;
    }()
  }, {
    key: "initNode",
    value: function () {
      var _initNode = _asyncToGenerator(function* () {
        this.assertNotDestroyed();
        if (this.cachedNode) {
          return this.cachedNode;
        }
        var node = this.networkNodeFactory.createNetworkNode(yield this.getNetworkOptions());
        if (!this.destroySignal.isDestroyed()) {
          this.cachedNode = node;
        }
        return node;
      });
      function initNode() {
        return _initNode.apply(this, arguments);
      }
      return initNode;
    }()
  }, {
    key: "generateId",
    value: function () {
      var _generateId = _asyncToGenerator(function* () {
        var address = yield this.authentication.getAddress();
        return "".concat(address, "#").concat((0, _uuid.uuid)());
      });
      function generateId() {
        return _generateId.apply(this, arguments);
      }
      return generateId;
    }()
  }, {
    key: "getNodeId",
    value: function () {
      var _getNodeId = _asyncToGenerator(function* () {
        var node = yield this.getNode();
        return node.getNodeId();
      });
      function getNodeId() {
        return _getNodeId.apply(this, arguments);
      }
      return getNodeId;
    }()
    /**
     * Calls publish on node after starting it.
     * Basically a wrapper around: (await getNode()).publish(…)
     * but will be sync in case that node is already started.
     * Zalgo intentional. See below.
     */
  }, {
    key: "publishToNode",
    value: function publishToNode(streamMessage) {
      // NOTE: function is intentionally not async for performance reasons.
      // Will call cachedNode.publish immediately if cachedNode is set.
      // Otherwise will wait for node to start.
      this.destroySignal.assertNotDestroyed();
      if (this.isStarting()) {
        // use .then instead of async/await so
        // this.cachedNode.publish call can be sync
        return this.startNodeTask().then(function (node) {
          return node.publish(streamMessage);
        });
      }
      return this.cachedNode.publish(streamMessage);
    }
  }, {
    key: "setProxies",
    value: function () {
      var _setProxies = _asyncToGenerator(function* (streamPartId, nodeIds, direction, connectionCount) {
        var _this2 = this;
        if (this.isStarting()) {
          yield this.startNodeTask();
        }
        yield this.cachedNode.setProxies(streamPartId, nodeIds, direction, function () {
          return _this2.authentication.getAddress();
        }, connectionCount);
      });
      function setProxies(_x, _x2, _x3, _x4) {
        return _setProxies.apply(this, arguments);
      }
      return setProxies;
    }()
  }, {
    key: "isStarting",
    value: function isStarting() {
      return !this.cachedNode || !this.startNodeComplete;
    }
  }, {
    key: "once",
    value: function once(eventName, listener) {
      this.eventEmitter.once(eventName, listener);
    }
  }]);
  return NetworkNodeFacade;
}()) || _class2) || _class2) || _class2) || _class2) || _class2);
exports.NetworkNodeFacade = NetworkNodeFacade;

/***/ }),

/***/ "./src/PersistenceManager.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __dirname = "/";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PersistenceManager = exports.NAMESPACES = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
__webpack_require__("../../node_modules/reflect-metadata/Reflect.js");
var _path = __webpack_require__("../../node_modules/path-browserify/index.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _DestroySignal = __webpack_require__("./src/DestroySignal.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _ServerPersistence = _interopRequireDefault(__webpack_require__("./src/utils/persistence/BrowserPersistence.ts"));
var _dec, _dec2, _dec3, _dec4, _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var NAMESPACES = {
  ENCRYPTION_KEYS: 'EncryptionKeys',
  LATEST_ENCRYPTION_KEY_IDS: 'LatestEncryptionKeyIds'
};
exports.NAMESPACES = NAMESPACES;
var PersistenceManager = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 0);
}, _dec3 = Reflect.metadata("design:type", Function), _dec4 = Reflect.metadata("design:paramtypes", [typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication, typeof _DestroySignal.DestroySignal === "undefined" ? Object : _DestroySignal.DestroySignal, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = /*#__PURE__*/function () {
  /* eslint-disable indent */
  function PersistenceManager(authentication, destroySignal, loggerFactory) {
    var _this = this;
    _classCallCheck(this, PersistenceManager);
    this.authentication = authentication;
    this.loggerFactory = loggerFactory;
    destroySignal.onDestroy.listen(function () {
      if (_this.persistence !== undefined) {
        return _this.persistence.close();
      }
    });
  }
  _createClass(PersistenceManager, [{
    key: "ensureInitialized",
    value: function () {
      var _ensureInitialized = _asyncToGenerator(function* () {
        if (this.persistence === undefined) {
          this.persistence = yield _ServerPersistence.default.createInstance({
            loggerFactory: this.loggerFactory,
            clientId: yield this.authentication.getAddress(),
            namespaces: Object.values(NAMESPACES),
            migrationsPath: (0, _path.join)(__dirname, 'encryption/migrations') // TODO move migrations to some generic place?
          });
        }
      });
      function ensureInitialized() {
        return _ensureInitialized.apply(this, arguments);
      }
      return ensureInitialized;
    }()
  }, {
    key: "getPersistence",
    value: function () {
      var _getPersistence = _asyncToGenerator(function* (namespace) {
        var _this2 = this;
        yield this.ensureInitialized();
        return {
          get: function get(key) {
            return _this2.persistence.get(key, namespace);
          },
          set: function set(key, value) {
            return _this2.persistence.set(key, value, namespace);
          }
        };
      });
      function getPersistence(_x) {
        return _getPersistence.apply(this, arguments);
      }
      return getPersistence;
    }()
  }]);
  return PersistenceManager;
}()) || _class) || _class) || _class) || _class);
exports.PersistenceManager = PersistenceManager;

/***/ }),

/***/ "./src/Stream.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.VALID_FIELD_TYPES = exports.Stream = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.entries.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _range = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/range.js"));
var _Message = __webpack_require__("./src/Message.ts");
var _StreamIDBuilder = __webpack_require__("./src/StreamIDBuilder.ts");
var _StreamrClientError = __webpack_require__("./src/StreamrClientError.ts");
var _Subscription = __webpack_require__("./src/subscribe/Subscription.ts");
var _utils2 = __webpack_require__("./src/utils/utils.ts");
var _waitForAssignmentsToPropagate = __webpack_require__("./src/utils/waitForAssignmentsToPropagate.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var VALID_FIELD_TYPES = ['number', 'string', 'boolean', 'list', 'map'];
exports.VALID_FIELD_TYPES = VALID_FIELD_TYPES;
function getFieldType(value) {
  var type = _typeof(value);
  switch (true) {
    case Array.isArray(value):
      {
        return 'list';
      }
    case type === 'object':
      {
        return 'map';
      }
    case VALID_FIELD_TYPES.includes(type):
      {
        // see https://github.com/microsoft/TypeScript/issues/36275
        return type;
      }
    default:
      {
        return undefined;
      }
  }
}

/**
 * A convenience API for managing and accessing an individual stream.
 *
 * @category Important
 */
/* eslint-disable no-underscore-dangle */
var Stream = /*#__PURE__*/function () {
  /** @internal */
  function Stream(id, metadata, resends, publisher, subscriber, streamRegistryCached, streamRegistry, streamStorageRegistry, loggerFactory, eventEmitter, config) {
    _classCallCheck(this, Stream);
    this.id = id;
    this.metadata = (0, _utils.merge)({
      partitions: 1,
      // TODO should we remove this default or make config as a required StreamMetadata field?
      config: {
        fields: []
      }
    }, metadata);
    this._resends = resends;
    this._publisher = publisher;
    this._subscriber = subscriber;
    this._streamRegistryCached = streamRegistryCached;
    this._streamRegistry = streamRegistry;
    this._streamStorageRegistry = streamStorageRegistry;
    this._loggerFactory = loggerFactory;
    this._eventEmitter = eventEmitter;
    this._config = config;
  }

  /**
   * Updates the metadata of the stream by merging with the existing metadata.
   */
  _createClass(Stream, [{
    key: "update",
    value: function () {
      var _update = _asyncToGenerator(function* (metadata) {
        var merged = (0, _utils.merge)(this.getMetadata(), metadata);
        try {
          yield this._streamRegistry.updateStream(this.id, merged);
        } finally {
          this._streamRegistryCached.clearStream(this.id);
        }
        this.metadata = merged;
      });
      function update(_x) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
    /**
     * Returns the partitions of the stream.
     */
  }, {
    key: "getStreamParts",
    value: function getStreamParts() {
      var _this = this;
      return (0, _range.default)(0, this.getMetadata().partitions).map(function (p) {
        return (0, _protocol.toStreamPartID)(_this.id, p);
      });
    }

    /**
     * Returns the metadata of the stream.
     */
  }, {
    key: "getMetadata",
    value: function getMetadata() {
      return this.metadata;
    }

    /**
     * Deletes the stream.
     *
     * @remarks Stream instance should not be used afterwards.
     */
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator(function* () {
        try {
          yield this._streamRegistry.deleteStream(this.id);
        } finally {
          this._streamRegistryCached.clearStream(this.id);
        }
      });
      function _delete() {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
    /**
     * Attempts to detect and update the {@link StreamMetadata.config} metadata of the stream by performing a resend.
     *
     * @remarks Only works on stored streams.
     *
     * @returns be mindful that in the case of there being zero messages stored, the returned promise will resolve even
     * though fields were not updated
     */
  }, {
    key: "detectFields",
    value: function () {
      var _detectFields = _asyncToGenerator(function* () {
        // Get last message of the stream to be used for field detecting
        var sub = yield this._resends.last((0, _protocol.toStreamPartID)(this.id, _StreamIDBuilder.DEFAULT_PARTITION), {
          count: 1
        }, false);
        var receivedMsgs = yield (0, _utils.collect)(sub);
        if (!receivedMsgs.length) {
          return;
        }
        var lastMessage = receivedMsgs[0].content;
        var fields = Object.entries(lastMessage).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            name = _ref2[0],
            value = _ref2[1];
          var type = getFieldType(value);
          return !!type && {
            name: name,
            type: type
          };
        }).filter(Boolean); // see https://github.com/microsoft/TypeScript/issues/30621

        // Save field config back to the stream
        yield this.update({
          config: {
            fields: fields
          }
        });
      });
      function detectFields() {
        return _detectFields.apply(this, arguments);
      }
      return detectFields;
    }()
    /**
     * Assigns the stream to a storage node.
     *
     * @category Important
     *
     * @param waitOptions - control how long to wait for storage node to pick up on assignment
     * @returns a resolved promise if (1) stream was assigned to storage node and (2) the storage node acknowledged the
     * assignment within `timeout`, otherwise rejects. Notice that is possible for this promise to reject but for the
     * storage node assignment to go through eventually.
     */
  }, {
    key: "addToStorageNode",
    value: function () {
      var _addToStorageNode = _asyncToGenerator(function* (storageNodeAddress) {
        var waitOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var normalizedNodeAddress = (0, _utils.toEthereumAddress)(storageNodeAddress);
        // check whether the stream is already stored: the assignment event listener logic requires that
        // there must not be an existing assignment (it timeouts if there is an existing assignment as the
        // storage node doesn't send an assignment event in that case)
        var isAlreadyStored = yield this._streamStorageRegistry.isStoredStream(this.id, normalizedNodeAddress);
        if (isAlreadyStored) {
          return;
        }
        var assignmentSubscription;
        try {
          var _waitOptions$timeout;
          var streamPartId = (0, _protocol.toStreamPartID)((0, _utils2.formStorageNodeAssignmentStreamId)(normalizedNodeAddress), _StreamIDBuilder.DEFAULT_PARTITION);
          assignmentSubscription = new _Subscription.Subscription(streamPartId, false, this._loggerFactory);
          yield this._subscriber.add(assignmentSubscription);
          var propagationPromise = (0, _waitForAssignmentsToPropagate.waitForAssignmentsToPropagate)(assignmentSubscription.getStreamMessages(), {
            id: this.id,
            partitions: this.getMetadata().partitions
          }, this._loggerFactory);
          yield this._streamStorageRegistry.addStreamToStorageNode(this.id, normalizedNodeAddress);
          yield (0, _utils.withTimeout)(propagationPromise, // eslint-disable-next-line no-underscore-dangle
          (_waitOptions$timeout = waitOptions.timeout) !== null && _waitOptions$timeout !== void 0 ? _waitOptions$timeout : this._config._timeouts.storageNode.timeout, 'storage node did not respond');
        } finally {
          var _assignmentSubscripti;
          this._streamRegistryCached.clearStream(this.id);
          yield (_assignmentSubscripti = assignmentSubscription) === null || _assignmentSubscripti === void 0 ? void 0 : _assignmentSubscripti.unsubscribe(); // should never reject...
        }
      });
      function addToStorageNode(_x2) {
        return _addToStorageNode.apply(this, arguments);
      }
      return addToStorageNode;
    }()
    /**
     * See {@link StreamrClient.removeStreamFromStorageNode | StreamrClient.removeStreamFromStorageNode}.
     */
  }, {
    key: "removeFromStorageNode",
    value: function () {
      var _removeFromStorageNode = _asyncToGenerator(function* (nodeAddress) {
        try {
          return this._streamStorageRegistry.removeStreamFromStorageNode(this.id, (0, _utils.toEthereumAddress)(nodeAddress));
        } finally {
          this._streamRegistryCached.clearStream(this.id);
        }
      });
      function removeFromStorageNode(_x3) {
        return _removeFromStorageNode.apply(this, arguments);
      }
      return removeFromStorageNode;
    }()
    /**
     * See {@link StreamrClient.getStorageNodes | StreamrClient.getStorageNodes}.
     */
  }, {
    key: "getStorageNodes",
    value: function () {
      var _getStorageNodes = _asyncToGenerator(function* () {
        return this._streamStorageRegistry.getStorageNodes(this.id);
      });
      function getStorageNodes() {
        return _getStorageNodes.apply(this, arguments);
      }
      return getStorageNodes;
    }()
    /**
     * See {@link StreamrClient.publish | StreamrClient.publish}.
     *
     * @category Important
     */
  }, {
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator(function* (content, metadata) {
        var result = yield this._publisher.publish(this.id, content, metadata);
        this._eventEmitter.emit('publish', undefined);
        return (0, _Message.convertStreamMessageToMessage)(result);
      });
      function publish(_x4, _x5) {
        return _publish.apply(this, arguments);
      }
      return publish;
    }() /** @internal */
  }, {
    key: "hasPermission",
    value:
    /**
     * See {@link StreamrClient.hasPermission | StreamrClient.hasPermission}.
     *
     * @category Important
     */
    function () {
      var _hasPermission = _asyncToGenerator(function* (query) {
        return this._streamRegistry.hasPermission(_objectSpread({
          streamId: this.id
        }, query));
      });
      function hasPermission(_x6) {
        return _hasPermission.apply(this, arguments);
      }
      return hasPermission;
    }()
    /**
     * See {@link StreamrClient.getPermissions | StreamrClient.getPermissions}.
     *
     * @category Important
     */
  }, {
    key: "getPermissions",
    value: function () {
      var _getPermissions = _asyncToGenerator(function* () {
        return this._streamRegistry.getPermissions(this.id);
      });
      function getPermissions() {
        return _getPermissions.apply(this, arguments);
      }
      return getPermissions;
    }()
    /**
     * See {@link StreamrClient.grantPermissions | StreamrClient.grantPermissions}.
     *
     * @category Important
     */
  }, {
    key: "grantPermissions",
    value: function () {
      var _grantPermissions = _asyncToGenerator(function* () {
        var _this$_streamRegistry;
        for (var _len = arguments.length, assignments = new Array(_len), _key = 0; _key < _len; _key++) {
          assignments[_key] = arguments[_key];
        }
        return (_this$_streamRegistry = this._streamRegistry).grantPermissions.apply(_this$_streamRegistry, [this.id].concat(assignments));
      });
      function grantPermissions() {
        return _grantPermissions.apply(this, arguments);
      }
      return grantPermissions;
    }()
    /**
     * See {@link StreamrClient.revokePermissions | StreamrClient.revokePermissions}.
     *
     * @category Important
     */
  }, {
    key: "revokePermissions",
    value: function () {
      var _revokePermissions = _asyncToGenerator(function* () {
        var _this$_streamRegistry2;
        for (var _len2 = arguments.length, assignments = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          assignments[_key2] = arguments[_key2];
        }
        return (_this$_streamRegistry2 = this._streamRegistry).revokePermissions.apply(_this$_streamRegistry2, [this.id].concat(assignments));
      });
      function revokePermissions() {
        return _revokePermissions.apply(this, arguments);
      }
      return revokePermissions;
    }()
  }], [{
    key: "parseMetadata",
    value: function parseMetadata(metadata) {
      // TODO we could pick the fields of StreamMetadata explicitly, so that this
      // object can't contain extra fields
      if (metadata === '') {
        return {
          partitions: 1
        };
      }
      var err = new _StreamrClientError.StreamrClientError("Invalid stream metadata: ".concat(metadata), 'INVALID_STREAM_METADATA');
      var json;
      try {
        json = JSON.parse(metadata);
      } catch (_ignored) {
        throw err;
      }
      if (json.partitions !== undefined) {
        try {
          (0, _protocol.ensureValidStreamPartitionCount)(json.partitions);
          return json;
        } catch (_ignored) {
          throw err;
        }
      } else {
        return _objectSpread(_objectSpread({}, json), {}, {
          partitions: 1
        });
      }
    }
  }]);
  return Stream;
}();
exports.Stream = Stream;

/***/ }),

/***/ "./src/StreamFactory.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamFactory = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Config = __webpack_require__("./src/Config.ts");
var _events = __webpack_require__("./src/events.ts");
var _Publisher = __webpack_require__("./src/publish/Publisher.ts");
var _StreamRegistry = __webpack_require__("./src/registry/StreamRegistry.ts");
var _StreamRegistryCached = __webpack_require__("./src/registry/StreamRegistryCached.ts");
var _StreamStorageRegistry = __webpack_require__("./src/registry/StreamStorageRegistry.ts");
var _Stream = __webpack_require__("./src/Stream.ts");
var _Resends = __webpack_require__("./src/subscribe/Resends.ts");
var _Subscriber = __webpack_require__("./src/subscribe/Subscriber.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var StreamFactory = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _Publisher.Publisher;
  }))(target, undefined, 1);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _StreamRegistryCached.StreamRegistryCached;
  }))(target, undefined, 3);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _StreamRegistry.StreamRegistry;
  }))(target, undefined, 4);
}, _dec5 = function _dec5(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 8);
}, _dec6 = Reflect.metadata("design:type", Function), _dec7 = Reflect.metadata("design:paramtypes", [typeof _Resends.Resends === "undefined" ? Object : _Resends.Resends, typeof _Publisher.Publisher === "undefined" ? Object : _Publisher.Publisher, typeof _Subscriber.Subscriber === "undefined" ? Object : _Subscriber.Subscriber, typeof _StreamRegistryCached.StreamRegistryCached === "undefined" ? Object : _StreamRegistryCached.StreamRegistryCached, typeof _StreamRegistry.StreamRegistry === "undefined" ? Object : _StreamRegistry.StreamRegistry, typeof _StreamStorageRegistry.StreamStorageRegistry === "undefined" ? Object : _StreamStorageRegistry.StreamStorageRegistry, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof _events.StreamrClientEventEmitter === "undefined" ? Object : _events.StreamrClientEventEmitter, typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = /*#__PURE__*/function () {
  /** @internal */

  /** @internal */
  function StreamFactory(resends, publisher, subscriber, streamRegistryCached, streamRegistry, streamStorageRegistry, loggerFactory, eventEmitter, config) {
    _classCallCheck(this, StreamFactory);
    this.resends = resends;
    this.publisher = publisher;
    this.subscriber = subscriber;
    this.streamRegistryCached = streamRegistryCached;
    this.streamRegistry = streamRegistry;
    this.streamStorageRegistry = streamStorageRegistry;
    this.loggerFactory = loggerFactory;
    this.eventEmitter = eventEmitter;
    this.config = config;
  }
  _createClass(StreamFactory, [{
    key: "createStream",
    value: function createStream(id, metadata) {
      return new _Stream.Stream(id, metadata, this.resends, this.publisher, this.subscriber, this.streamRegistryCached, this.streamRegistry, this.streamStorageRegistry, this.loggerFactory, this.eventEmitter, this.config);
    }
  }]);
  return StreamFactory;
}()) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
exports.StreamFactory = StreamFactory;

/***/ }),

/***/ "./src/StreamIDBuilder.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamIDBuilder = exports.DEFAULT_PARTITION = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _dec, _dec2, _dec3, _dec4, _class;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var DEFAULT_PARTITION = 0;
exports.DEFAULT_PARTITION = DEFAULT_PARTITION;
function pickStreamId(definition) {
  var obj = definition;
  if (obj.id !== undefined) {
    return obj.id;
  } else if (obj.stream !== undefined) {
    return obj.stream;
  } else if (obj.streamId !== undefined) {
    return obj.streamId;
  } else {
    throw new Error('streamDefinition: object must have property: "id", "stream", or "streamId"');
  }
}
function parseRawDefinition(definition) {
  if (typeof definition === 'string') {
    return _protocol.StreamPartIDUtils.parseRawElements(definition);
  } else if (_typeof(definition) === 'object') {
    return [pickStreamId(definition), definition.partition];
  } else {
    throw new Error('streamDefinition: must be of type string or object');
  }
}
var StreamIDBuilder = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 0);
}, _dec3 = Reflect.metadata("design:type", Function), _dec4 = Reflect.metadata("design:paramtypes", [typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = /*#__PURE__*/function () {
  function StreamIDBuilder(authentication) {
    _classCallCheck(this, StreamIDBuilder);
    this.authentication = authentication;
  }
  _createClass(StreamIDBuilder, [{
    key: "toStreamID",
    value: function () {
      var _toStreamID2 = _asyncToGenerator(function* (streamIdOrPath) {
        var address;
        if (_protocol.StreamIDUtils.isPathOnlyFormat(streamIdOrPath)) {
          address = yield this.authentication.getAddress();
        }
        return (0, _protocol.toStreamID)(streamIdOrPath, address);
      });
      function toStreamID(_x) {
        return _toStreamID2.apply(this, arguments);
      }
      return toStreamID;
    }()
  }, {
    key: "toStreamPartID",
    value: function () {
      var _toStreamPartID2 = _asyncToGenerator(function* (definition) {
        var _yield$this$toStreamP = yield this.toStreamPartElements(definition),
          _yield$this$toStreamP2 = _slicedToArray(_yield$this$toStreamP, 2),
          streamId = _yield$this$toStreamP2[0],
          streamPartition = _yield$this$toStreamP2[1];
        return (0, _protocol.toStreamPartID)(streamId, streamPartition !== null && streamPartition !== void 0 ? streamPartition : DEFAULT_PARTITION);
      });
      function toStreamPartID(_x2) {
        return _toStreamPartID2.apply(this, arguments);
      }
      return toStreamPartID;
    }()
  }, {
    key: "toStreamPartElements",
    value: function () {
      var _toStreamPartElements = _asyncToGenerator(function* (definition) {
        var _parseRawDefinition = parseRawDefinition(definition),
          _parseRawDefinition2 = _slicedToArray(_parseRawDefinition, 2),
          streamId = _parseRawDefinition2[0],
          streamPartition = _parseRawDefinition2[1];
        return [yield this.toStreamID(streamId), streamPartition];
      });
      function toStreamPartElements(_x3) {
        return _toStreamPartElements.apply(this, arguments);
      }
      return toStreamPartElements;
    }()
  }, {
    key: "match",
    value: function () {
      var _match = _asyncToGenerator(function* (definition, streamPartId) {
        var _yield$this$toStreamP3 = yield this.toStreamPartElements(definition),
          _yield$this$toStreamP4 = _slicedToArray(_yield$this$toStreamP3, 2),
          targetStreamId = _yield$this$toStreamP4[0],
          targetPartition = _yield$this$toStreamP4[1];
        return targetStreamId === _protocol.StreamPartIDUtils.getStreamID(streamPartId) && (targetPartition === undefined || targetPartition === _protocol.StreamPartIDUtils.getStreamPartition(streamPartId));
      });
      function match(_x4, _x5) {
        return _match.apply(this, arguments);
      }
      return match;
    }()
  }]);
  return StreamIDBuilder;
}()) || _class) || _class) || _class) || _class);
exports.StreamIDBuilder = StreamIDBuilder;

/***/ }),

/***/ "./src/StreamrClient.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamrClient = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/esnext.promise.all-settled.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/reflect-metadata/Reflect.js");
__webpack_require__("./src/utils/PatchTsyringe.ts");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Ethereum = __webpack_require__("./src/Ethereum.ts");
var _promises = __webpack_require__("./src/utils/promises.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _Publisher = __webpack_require__("./src/publish/Publisher.ts");
var _Subscriber = __webpack_require__("./src/subscribe/Subscriber.ts");
var _Resends = __webpack_require__("./src/subscribe/Resends.ts");
var _ResendSubscription = __webpack_require__("./src/subscribe/ResendSubscription.ts");
var _NetworkNodeFacade = __webpack_require__("./src/NetworkNodeFacade.ts");
var _DestroySignal = __webpack_require__("./src/DestroySignal.ts");
var _LocalGroupKeyStore = __webpack_require__("./src/encryption/LocalGroupKeyStore.ts");
var _StorageNodeRegistry = __webpack_require__("./src/registry/StorageNodeRegistry.ts");
var _StreamRegistry = __webpack_require__("./src/registry/StreamRegistry.ts");
var _Subscription = __webpack_require__("./src/subscribe/Subscription.ts");
var _StreamIDBuilder = __webpack_require__("./src/StreamIDBuilder.ts");
var _events = __webpack_require__("./src/events.ts");
var _MetricsPublisher = __webpack_require__("./src/MetricsPublisher.ts");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _StreamStorageRegistry = __webpack_require__("./src/registry/StreamStorageRegistry.ts");
var _PublisherKeyExchange = __webpack_require__("./src/encryption/PublisherKeyExchange.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _Message = __webpack_require__("./src/Message.ts");
var _HttpUtil = __webpack_require__("./src/HttpUtil.ts");
var _omit = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/omit.js"));
var _merge = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/merge.js"));
var _StreamrClientError = __webpack_require__("./src/StreamrClientError.ts");
var _utils2 = __webpack_require__("./src/utils/utils.ts");
var _HttpFetcher = __webpack_require__("./src/utils/HttpFetcher.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// TODO: this type only exists to enable tsdoc to generate proper documentation
// TODO: this type only exists to enable tsdoc to generate proper documentation
/**
 * The main API used to interact with Streamr.
 *
 * @category Important
 */
var StreamrClient = /*#__PURE__*/function () {
  function StreamrClient() {
    var _this = this;
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var parentContainer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _tsyringe.container;
    _classCallCheck(this, StreamrClient);
    _defineProperty(this, "_connect", (0, _promises.pOnce)( /*#__PURE__*/_asyncToGenerator(function* () {
      yield _this.node.startNode();
    })));
    _defineProperty(this, "_destroy", (0, _promises.pOnce)( /*#__PURE__*/_asyncToGenerator(function* () {
      _this.eventEmitter.removeAllListeners();
      // eslint-disable-next-line no-underscore-dangle
      _this._connect.reset(); // reset connect (will error on next call)
      var tasks = [_this.destroySignal.destroy().then(function () {
        return undefined;
      }), _this.subscriber.unsubscribe()];
      yield Promise.allSettled(tasks);
      yield Promise.all(tasks);
    })));
    var strictConfig = (0, _Config.createStrictConfig)(config);
    var authentication = (0, _Authentication.createAuthentication)(strictConfig);
    (0, _Config.redactConfig)(strictConfig);
    var container = parentContainer.createChildContainer();
    container.register(_Authentication.AuthenticationInjectionToken, {
      useValue: authentication
    });
    container.register(_Config.ConfigInjectionToken, {
      useValue: strictConfig
    });
    // eslint-disable-next-line max-len
    container.register(_utils.TheGraphClient, {
      useValue: (0, _utils2.createTheGraphClient)(container.resolve(_HttpFetcher.HttpFetcher), container.resolve(_events.StreamrClientEventEmitter), strictConfig)
    });
    this.id = strictConfig.id;
    this.config = strictConfig;
    this.node = container.resolve(_NetworkNodeFacade.NetworkNodeFacade);
    this.authentication = container.resolve(_Authentication.AuthenticationInjectionToken);
    this.resends = container.resolve(_Resends.Resends);
    this.publisher = container.resolve(_Publisher.Publisher);
    this.subscriber = container.resolve(_Subscriber.Subscriber);
    this.localGroupKeyStore = container.resolve(_LocalGroupKeyStore.LocalGroupKeyStore);
    this.destroySignal = container.resolve(_DestroySignal.DestroySignal);
    this.streamRegistry = container.resolve(_StreamRegistry.StreamRegistry);
    this.streamStorageRegistry = container.resolve(_StreamStorageRegistry.StreamStorageRegistry);
    this.storageNodeRegistry = container.resolve(_StorageNodeRegistry.StorageNodeRegistry);
    this.loggerFactory = container.resolve(_LoggerFactory.LoggerFactory);
    this.streamIdBuilder = container.resolve(_StreamIDBuilder.StreamIDBuilder);
    this.eventEmitter = container.resolve(_events.StreamrClientEventEmitter);
    container.resolve(_PublisherKeyExchange.PublisherKeyExchange); // side effect: activates publisher key exchange
    container.resolve(_MetricsPublisher.MetricsPublisher); // side effect: activates metrics publisher
  }

  // --------------------------------------------------------------------------------------------
  // Publish
  // --------------------------------------------------------------------------------------------

  /**
   * Publishes a message to a stream partition in the network.
   *
   * @category Important
   *
   * @param streamDefinition - the stream or stream partition to publish the message to
   * @param content - the content (the payload) of the message (must be JSON serializable)
   * @param metadata - provide additional metadata to be included in the message or to control the publishing process
   * @returns the published message (note: the field {@link Message.content} is encrypted if the stream is private)
   */
  _createClass(StreamrClient, [{
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator(function* (streamDefinition, content, metadata) {
        var result = yield this.publisher.publish(streamDefinition, content, metadata);
        this.eventEmitter.emit('publish', undefined);
        return (0, _Message.convertStreamMessageToMessage)(result);
      });
      function publish(_x, _x2, _x3) {
        return _publish.apply(this, arguments);
      }
      return publish;
    }()
    /**
     * Manually updates the encryption key used when publishing messages to a given stream.
     */
  }, {
    key: "updateEncryptionKey",
    value: function () {
      var _updateEncryptionKey = _asyncToGenerator(function* (opts) {
        if (opts.streamId === undefined) {
          throw new Error('streamId required');
        }
        if (opts.key !== undefined && this.config.encryption.litProtocolEnabled) {
          throw new _StreamrClientError.StreamrClientError('cannot pass "key" when Lit Protocol is enabled', 'UNSUPPORTED_OPERATION');
        }
        var streamId = yield this.streamIdBuilder.toStreamID(opts.streamId);
        var queue = yield this.publisher.getGroupKeyQueue(streamId);
        if (opts.distributionMethod === 'rotate') {
          yield queue.rotate(opts.key);
        } else if (opts.distributionMethod === 'rekey') {
          yield queue.rekey(opts.key);
        } else {
          throw new Error("assertion failed: distribution method ".concat(opts.distributionMethod));
        }
      });
      function updateEncryptionKey(_x4) {
        return _updateEncryptionKey.apply(this, arguments);
      }
      return updateEncryptionKey;
    }()
    /**
     * Adds an encryption key for a given publisher to the key store.
     *
     * @remarks Keys will be added to the store automatically by the client as encountered. This method can be used to
     * manually add some known keys into the store.
     */
  }, {
    key: "addEncryptionKey",
    value: function () {
      var _addEncryptionKey = _asyncToGenerator(function* (key, publisherId) {
        yield this.localGroupKeyStore.set(key.id, publisherId, key.data);
      });
      function addEncryptionKey(_x5, _x6) {
        return _addEncryptionKey.apply(this, arguments);
      }
      return addEncryptionKey;
    }() // --------------------------------------------------------------------------------------------
    // Subscribe
    // --------------------------------------------------------------------------------------------
    /**
     * Subscribes to a stream partition in the network.
     *
     * @category Important
     *
     * @param options - the stream or stream partition to subscribe to,
     * additionally a resend can be performed by providing resend options
     * @param onMessage - callback will be invoked for each message received in subscription
     * @returns a {@link Subscription} that can be used to manage the subscription etc.
     */
  }, {
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator(function* (options, onMessage) {
        var _options$raw;
        if (options.raw === true && options.resend !== undefined) {
          throw new Error('Raw subscriptions are not supported for resend');
        }
        var streamPartId = yield this.streamIdBuilder.toStreamPartID(options);
        var sub = options.resend !== undefined ? new _ResendSubscription.ResendSubscription(streamPartId, options.resend, this.resends, this.loggerFactory, this.config) : new _Subscription.Subscription(streamPartId, (_options$raw = options.raw) !== null && _options$raw !== void 0 ? _options$raw : false, this.loggerFactory);
        yield this.subscriber.add(sub);
        if (onMessage !== undefined) {
          sub.useLegacyOnMessageHandler(onMessage);
        }
        this.eventEmitter.emit('subscribe', undefined);
        return sub;
      });
      function subscribe(_x7, _x8) {
        return _subscribe.apply(this, arguments);
      }
      return subscribe;
    }()
    /**
     * Unsubscribes from streams or stream partitions in the network.
     *
     * @remarks no-op if subscription does not exist
     *
     * @category Important
     *
     * @param streamDefinitionOrSubscription - leave as `undefined` to unsubscribe from all existing subscriptions.
     */
  }, {
    key: "unsubscribe",
    value: function unsubscribe(streamDefinitionOrSubscription) {
      return this.subscriber.unsubscribe(streamDefinitionOrSubscription);
    }

    /**
     * Returns a list of subscriptions matching the given criteria.
     *
     * @category Important
     *
     * @param streamDefinition - leave as `undefined` to get all subscriptions
     */
  }, {
    key: "getSubscriptions",
    value: function getSubscriptions(streamDefinition) {
      return this.subscriber.getSubscriptions(streamDefinition);
    }

    // --------------------------------------------------------------------------------------------
    // Resend
    // --------------------------------------------------------------------------------------------

    /**
     * Performs a resend of stored historical data.
     *
     * @category Important
     *
     * @param streamDefinition - the stream partition for which data should be resent
     * @param options - defines the kind of resend that should be performed
     * @param onMessage - callback will be invoked for each message retrieved
     * @returns a {@link MessageStream} that provides an alternative way of iterating messages. Rejects if the stream is
     * not stored (i.e. is not assigned to a storage node).
     */
  }, {
    key: "resend",
    value: function () {
      var _resend = _asyncToGenerator(function* (streamDefinition, options, onMessage) {
        var streamPartId = yield this.streamIdBuilder.toStreamPartID(streamDefinition);
        var messageStream = yield this.resends.resend(streamPartId, options);
        if (onMessage !== undefined) {
          messageStream.useLegacyOnMessageHandler(onMessage);
        }
        return messageStream;
      });
      function resend(_x9, _x10, _x11) {
        return _resend.apply(this, arguments);
      }
      return resend;
    }()
    /**
     * Waits for a message to be stored by a storage node.
     *
     * @param message - the message to be awaited for
     * @param options - additional options for controlling waiting and message matching
     * @returns rejects if message was found in storage before timeout
     */
  }, {
    key: "waitForStorage",
    value: function waitForStorage(message, options) {
      return this.resends.waitForStorage(message, options);
    }

    // --------------------------------------------------------------------------------------------
    // Stream management
    // --------------------------------------------------------------------------------------------

    /**
     * Gets a stream.
     *
     * @category Important
     *
     * @returns rejects if the stream is not found
     */
  }, {
    key: "getStream",
    value: function getStream(streamIdOrPath) {
      return this.streamRegistry.getStream(streamIdOrPath);
    }

    /**
     * Creates a new stream.
     *
     * @category Important
     *
     * @param propsOrStreamIdOrPath - the stream id to be used for the new stream, and optionally, any
     * associated metadata
     *
     * @remarks when creating a stream with an ENS domain, the returned promise can take several minutes to settle
     */
  }, {
    key: "createStream",
    value: function () {
      var _createStream = _asyncToGenerator(function* (propsOrStreamIdOrPath) {
        var props = _typeof(propsOrStreamIdOrPath) === 'object' ? propsOrStreamIdOrPath : {
          id: propsOrStreamIdOrPath
        };
        var streamId = yield this.streamIdBuilder.toStreamID(props.id);
        return this.streamRegistry.createStream(streamId, (0, _merge.default)({
          partitions: 1
        }, (0, _omit.default)(props, 'id')));
      });
      function createStream(_x12) {
        return _createStream.apply(this, arguments);
      }
      return createStream;
    }()
    /**
     * Gets a stream, creating one if it does not exist.
     *
     * @category Important
     *
     * @param props - the stream id to get or create. Field `partitions` is only used if creating the stream.
     *
     * @remarks when creating a stream with an ENS domain, the returned promise can take several minutes to settle
     */
  }, {
    key: "getOrCreateStream",
    value: function () {
      var _getOrCreateStream = _asyncToGenerator(function* (props) {
        try {
          return yield this.getStream(props.id);
        } catch (err) {
          if (err.errorCode === _HttpUtil.ErrorCode.NOT_FOUND) {
            return this.createStream(props);
          }
          throw err;
        }
      });
      function getOrCreateStream(_x13) {
        return _getOrCreateStream.apply(this, arguments);
      }
      return getOrCreateStream;
    }()
    /**
     * Updates the metadata of a stream.
     *
     * @param props - the stream id and the metadata fields to be updated
     */
  }, {
    key: "updateStream",
    value: function () {
      var _updateStream = _asyncToGenerator(function* (props) {
        var streamId = yield this.streamIdBuilder.toStreamID(props.id);
        return this.streamRegistry.updateStream(streamId, (0, _omit.default)(props, 'id'));
      });
      function updateStream(_x14) {
        return _updateStream.apply(this, arguments);
      }
      return updateStream;
    }()
    /**
     * Deletes a stream.
     */
  }, {
    key: "deleteStream",
    value: function deleteStream(streamIdOrPath) {
      return this.streamRegistry.deleteStream(streamIdOrPath);
    }

    /**
     * Searches for streams based on given criteria.
     *
     * @param term - a search term that should be part of the stream id of a result
     * @param permissionFilter - permissions that should be in effect for a result
     * @param orderBy - the default is ascending order by stream id field
     */
  }, {
    key: "searchStreams",
    value: function searchStreams(term, permissionFilter) {
      var orderBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        field: 'id',
        direction: 'asc'
      };
      return this.streamRegistry.searchStreams(term, permissionFilter, orderBy);
    }

    // --------------------------------------------------------------------------------------------
    // Permissions
    // --------------------------------------------------------------------------------------------

    /**
     * Gets all ethereum addresses that have {@link StreamPermission.PUBLISH} permission to the stream.
     */
  }, {
    key: "getStreamPublishers",
    value: function getStreamPublishers(streamIdOrPath) {
      return this.streamRegistry.getStreamPublishers(streamIdOrPath);
    }

    /**
     * Gets all ethereum addresses that have {@link StreamPermission.SUBSCRIBE} permission to the stream.
     */
  }, {
    key: "getStreamSubscribers",
    value: function getStreamSubscribers(streamIdOrPath) {
      return this.streamRegistry.getStreamSubscribers(streamIdOrPath);
    }

    /**
     * Checks whether the given permission is in effect.
     */
  }, {
    key: "hasPermission",
    value: function hasPermission(query) {
      return this.streamRegistry.hasPermission(query);
    }

    /**
     * Returns the list of all permissions in effect for a given stream.
     */
  }, {
    key: "getPermissions",
    value: function getPermissions(streamIdOrPath) {
      return this.streamRegistry.getPermissions(streamIdOrPath);
    }

    /**
     * Grants permissions on a given stream.
     */
  }, {
    key: "grantPermissions",
    value: function grantPermissions(streamIdOrPath) {
      var _this$streamRegistry;
      for (var _len = arguments.length, assignments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        assignments[_key - 1] = arguments[_key];
      }
      return (_this$streamRegistry = this.streamRegistry).grantPermissions.apply(_this$streamRegistry, [streamIdOrPath].concat(assignments));
    }

    /**
     * Revokes permissions on a given stream.
     */
  }, {
    key: "revokePermissions",
    value: function revokePermissions(streamIdOrPath) {
      var _this$streamRegistry2;
      for (var _len2 = arguments.length, assignments = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        assignments[_key2 - 1] = arguments[_key2];
      }
      return (_this$streamRegistry2 = this.streamRegistry).revokePermissions.apply(_this$streamRegistry2, [streamIdOrPath].concat(assignments));
    }

    /**
     * Sets a list of permissions to be in effect.
     *
     * @remarks Can be used to set the permissions of multiple streams in one transaction. Great for doing bulk
     * operations and saving gas costs. Notice that the behaviour is overwriting, therefore any existing permissions not
     * defined will be removed (per stream).
     */
  }, {
    key: "setPermissions",
    value: function setPermissions() {
      var _this$streamRegistry3;
      return (_this$streamRegistry3 = this.streamRegistry).setPermissions.apply(_this$streamRegistry3, arguments);
    }

    /**
     * Checks whether a given ethereum address has {@link StreamPermission.PUBLISH} permission to a stream.
     */
  }, {
    key: "isStreamPublisher",
    value: function () {
      var _isStreamPublisher = _asyncToGenerator(function* (streamIdOrPath, userAddress) {
        return this.streamRegistry.isStreamPublisher(streamIdOrPath, (0, _utils.toEthereumAddress)(userAddress));
      });
      function isStreamPublisher(_x15, _x16) {
        return _isStreamPublisher.apply(this, arguments);
      }
      return isStreamPublisher;
    }()
    /**
     * Checks whether a given ethereum address has {@link StreamPermission.SUBSCRIBE} permission to a stream.
     */
  }, {
    key: "isStreamSubscriber",
    value: function () {
      var _isStreamSubscriber = _asyncToGenerator(function* (streamIdOrPath, userAddress) {
        return this.streamRegistry.isStreamSubscriber(streamIdOrPath, (0, _utils.toEthereumAddress)(userAddress));
      });
      function isStreamSubscriber(_x17, _x18) {
        return _isStreamSubscriber.apply(this, arguments);
      }
      return isStreamSubscriber;
    }() // --------------------------------------------------------------------------------------------
    // Storage
    // --------------------------------------------------------------------------------------------
    /**
     * Assigns a stream to a storage node.
     */
  }, {
    key: "addStreamToStorageNode",
    value: function () {
      var _addStreamToStorageNode = _asyncToGenerator(function* (streamIdOrPath, storageNodeAddress) {
        return this.streamStorageRegistry.addStreamToStorageNode(streamIdOrPath, (0, _utils.toEthereumAddress)(storageNodeAddress));
      });
      function addStreamToStorageNode(_x19, _x20) {
        return _addStreamToStorageNode.apply(this, arguments);
      }
      return addStreamToStorageNode;
    }()
    /**
     * Unassigns a stream from a storage node.
     */
  }, {
    key: "removeStreamFromStorageNode",
    value: function () {
      var _removeStreamFromStorageNode = _asyncToGenerator(function* (streamIdOrPath, storageNodeAddress) {
        return this.streamStorageRegistry.removeStreamFromStorageNode(streamIdOrPath, (0, _utils.toEthereumAddress)(storageNodeAddress));
      });
      function removeStreamFromStorageNode(_x21, _x22) {
        return _removeStreamFromStorageNode.apply(this, arguments);
      }
      return removeStreamFromStorageNode;
    }()
    /**
     * Checks whether a stream is assigned to a storage node.
     */
  }, {
    key: "isStoredStream",
    value: function () {
      var _isStoredStream = _asyncToGenerator(function* (streamIdOrPath, storageNodeAddress) {
        return this.streamStorageRegistry.isStoredStream(streamIdOrPath, (0, _utils.toEthereumAddress)(storageNodeAddress));
      });
      function isStoredStream(_x23, _x24) {
        return _isStoredStream.apply(this, arguments);
      }
      return isStoredStream;
    }()
    /**
     * Gets all streams assigned to a storage node.
     *
     * @returns a list of {@link Stream} as well as `blockNumber` of result (i.e. blockchain state)
     */
  }, {
    key: "getStoredStreams",
    value: function () {
      var _getStoredStreams = _asyncToGenerator(function* (storageNodeAddress) {
        return this.streamStorageRegistry.getStoredStreams((0, _utils.toEthereumAddress)(storageNodeAddress));
      });
      function getStoredStreams(_x25) {
        return _getStoredStreams.apply(this, arguments);
      }
      return getStoredStreams;
    }()
    /**
     * Gets a list of storage nodes.
     *
     * @param streamIdOrPath - if a stream is given, returns the list of storage nodes the stream has been assigned to;
     * leave as `undefined` to return all storage nodes
     */
  }, {
    key: "getStorageNodes",
    value: function () {
      var _getStorageNodes = _asyncToGenerator(function* (streamIdOrPath) {
        return this.streamStorageRegistry.getStorageNodes(streamIdOrPath);
      });
      function getStorageNodes(_x26) {
        return _getStorageNodes.apply(this, arguments);
      }
      return getStorageNodes;
    }()
    /**
     * Sets the metadata of a storage node in the storage node registry.
     *
     * @remarks Acts on behalf of the wallet associated with the current {@link StreamrClient} instance.
     *
     * @param metadata - if `undefined`, removes the storage node from the registry
     */
  }, {
    key: "setStorageNodeMetadata",
    value: function setStorageNodeMetadata(metadata) {
      return this.storageNodeRegistry.setStorageNodeMetadata(metadata);
    }

    /**
     * Gets the metadata of a storage node from the storage node registry.
     *
     * @returns rejects if the storage node is not found
     */
  }, {
    key: "getStorageNodeMetadata",
    value: function () {
      var _getStorageNodeMetadata = _asyncToGenerator(function* (nodeAddress) {
        return this.storageNodeRegistry.getStorageNodeMetadata((0, _utils.toEthereumAddress)(nodeAddress));
      });
      function getStorageNodeMetadata(_x27) {
        return _getStorageNodeMetadata.apply(this, arguments);
      }
      return getStorageNodeMetadata;
    }() // --------------------------------------------------------------------------------------------
    // Authentication
    // --------------------------------------------------------------------------------------------
    /**
     * Gets the Ethereum address of the wallet associated with the current {@link StreamrClient} instance.
     */
  }, {
    key: "getAddress",
    value: function getAddress() {
      return this.authentication.getAddress();
    }

    // --------------------------------------------------------------------------------------------
    // Network node
    // --------------------------------------------------------------------------------------------

    /**
     * @deprecated This in an internal method
     */
  }, {
    key: "getNode",
    value: function getNode() {
      return this.node.getNode();
    }
  }, {
    key: "setProxies",
    value: function () {
      var _setProxies = _asyncToGenerator(function* (streamDefinition, nodeIds, direction, connectionCount) {
        var streamPartId = yield this.streamIdBuilder.toStreamPartID(streamDefinition);
        yield this.node.setProxies(streamPartId, nodeIds, direction, connectionCount);
      });
      function setProxies(_x28, _x29, _x30, _x31) {
        return _setProxies.apply(this, arguments);
      }
      return setProxies;
    }() // --------------------------------------------------------------------------------------------
    // Lifecycle
    // --------------------------------------------------------------------------------------------
    /**
     * Used to manually initialize the network stack and connect to the network.
     *
     * @remarks Connecting is handled automatically by the client. Generally this method need not be called by the user.
     */
  }, {
    key: "connect",
    value: function connect() {
      // eslint-disable-next-line no-underscore-dangle
      return this._connect();
    }
  }, {
    key: "destroy",
    value:
    /**
     * Destroys an instance of a {@link StreamrClient} by disconnecting from peers, clearing any pending tasks, and
     * freeing up resources. This should be called once a user is done with the instance.
     *
     * @remarks As the name implies, the client instance (or any streams or subscriptions returned by it) should _not_
     * be used after calling this method.
     */
    function destroy() {
      // eslint-disable-next-line no-underscore-dangle
      return this._destroy();
    }
  }, {
    key: "getDiagnosticInfo",
    value:
    /**
     * Get diagnostic info about the underlying network. Useful for debugging issues.
     *
     * @remark returned object's structure can change without semver considerations
     */
    function () {
      var _getDiagnosticInfo = _asyncToGenerator(function* () {
        return (yield this.node.getNode()).getDiagnosticInfo();
      });
      function getDiagnosticInfo() {
        return _getDiagnosticInfo.apply(this, arguments);
      }
      return getDiagnosticInfo;
    }() // --------------------------------------------------------------------------------------------
    // Events
    // --------------------------------------------------------------------------------------------
    /**
     * Adds an event listener to the client.
     * @param eventName - event name, see {@link StreamrClientEvents} for options
     * @param listener - the callback function
     */
  }, {
    key: "on",
    value: function on(eventName, listener) {
      this.eventEmitter.on(eventName, listener);
    }

    /**
     * Adds an event listener to the client that is invoked only once.
     * @param eventName - event name, see {@link StreamrClientEvents} for options
     * @param listener - the callback function
     */
  }, {
    key: "once",
    value: function once(eventName, listener) {
      this.eventEmitter.once(eventName, listener);
    }

    /**
     * Removes an event listener from the client.
     * @param eventName - event name, see {@link StreamrClientEvents} for options
     * @param listener - the callback function to remove
     */
  }, {
    key: "off",
    value: function off(eventName, listener) {
      this.eventEmitter.off(eventName, listener);
    }
  }]);
  return StreamrClient;
}();
exports.StreamrClient = StreamrClient;
_defineProperty(StreamrClient, "generateEthereumAccount", _Ethereum.generateEthereumAccount);

/***/ }),

/***/ "./src/StreamrClientError.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamrClientError = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var StreamrClientError = /*#__PURE__*/function (_Error) {
  _inherits(StreamrClientError, _Error);
  var _super = _createSuper(StreamrClientError);
  function StreamrClientError(message, code) {
    var _this;
    _classCallCheck(this, StreamrClientError);
    _this = _super.call(this, message);
    _this.code = code;
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass(StreamrClientError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.StreamrClientError = StreamrClientError;

/***/ }),

/***/ "./src/encryption/EncryptionUtil.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.EncryptionUtil = exports.DecryptError = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.starts-with.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.ends-with.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _crypto = _interopRequireDefault(__webpack_require__("../../node_modules/crypto-browserify/index.js"));
var _bytes = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var DecryptError = /*#__PURE__*/function (_StreamMessageError) {
  _inherits(DecryptError, _StreamMessageError);
  var _super = _createSuper(DecryptError);
  function DecryptError(streamMessage) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    _classCallCheck(this, DecryptError);
    return _super.call(this, "Decrypt error: ".concat(message), streamMessage);
  }
  return _createClass(DecryptError);
}(_protocol.StreamMessageError); // eslint-disable-next-line @typescript-eslint/no-extraneous-class
exports.DecryptError = DecryptError;
var EncryptionUtil = /*#__PURE__*/function () {
  function EncryptionUtil() {
    _classCallCheck(this, EncryptionUtil);
  }
  _createClass(EncryptionUtil, null, [{
    key: "validateRSAPublicKey",
    value: function validateRSAPublicKey(publicKey) {
      var keyString = typeof publicKey === 'string' ? publicKey : publicKey.toString('utf8');
      if (typeof keyString !== 'string' || !keyString.startsWith('-----BEGIN PUBLIC KEY-----') || !keyString.endsWith('-----END PUBLIC KEY-----\n')) {
        throw new Error('"publicKey" must be a PKCS#8 RSA public key in the PEM format');
      }
    }

    /**
     * Returns a Buffer or a hex String
     */
  }, {
    key: "encryptWithRSAPublicKey",
    value: function encryptWithRSAPublicKey(plaintextBuffer, publicKey) {
      var outputInHex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.validateRSAPublicKey(publicKey);
      var ciphertextBuffer = _crypto.default.publicEncrypt(publicKey, plaintextBuffer);
      if (outputInHex) {
        return (0, _bytes.hexlify)(ciphertextBuffer).slice(2);
      }
      return ciphertextBuffer;
    }

    // Returns a Buffer
  }, {
    key: "decryptWithRSAPrivateKey",
    value: function decryptWithRSAPrivateKey(ciphertext, privateKey) {
      var isHexString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var ciphertextBuffer = isHexString ? (0, _bytes.arrayify)("0x".concat(ciphertext)) : ciphertext;
      return _crypto.default.privateDecrypt(privateKey, ciphertextBuffer);
    }

    /*
     * Returns a hex string without the '0x' prefix.
     */
  }, {
    key: "encryptWithAES",
    value: function encryptWithAES(data, cipherKey) {
      var iv = _crypto.default.randomBytes(16); // always need a fresh IV when using CTR mode
      var cipher = _crypto.default.createCipheriv('aes-256-ctr', cipherKey, iv);
      return (0, _bytes.hexlify)(iv).slice(2) + cipher.update(data, undefined, 'hex') + cipher.final('hex');
    }

    /*
     * 'ciphertext' must be a hex string (without '0x' prefix), 'groupKey' must be a GroupKey. Returns a Buffer.
     */
  }, {
    key: "decryptWithAES",
    value: function decryptWithAES(ciphertext, cipherKey) {
      var iv = (0, _bytes.arrayify)("0x".concat(ciphertext.slice(0, 32)));
      var decipher = _crypto.default.createDecipheriv('aes-256-ctr', cipherKey, iv);
      return Buffer.concat([decipher.update(ciphertext.slice(32), 'hex'), decipher.final()]);
    }
  }, {
    key: "decryptStreamMessage",
    value: function decryptStreamMessage(streamMessage, groupKey) {
      if (streamMessage.encryptionType !== _protocol.EncryptionType.AES) {
        return;
      }
      try {
        streamMessage.encryptionType = _protocol.EncryptionType.NONE;
        var serializedContent = this.decryptWithAES(streamMessage.getSerializedContent(), groupKey.data).toString();
        streamMessage.parsedContent = JSON.parse(serializedContent);
        streamMessage.serializedContent = serializedContent;
      } catch (err) {
        streamMessage.encryptionType = _protocol.EncryptionType.AES;
        throw new DecryptError(streamMessage, err.stack);
      }
      try {
        var newGroupKey = streamMessage.newGroupKey;
        if (newGroupKey) {
          // newGroupKey should be EncryptedGroupKey | GroupKey, but GroupKey is not defined in protocol
          // @ts-expect-error expecting EncryptedGroupKey
          streamMessage.newGroupKey = groupKey.decryptNextGroupKey(newGroupKey);
        }
      } catch (err) {
        streamMessage.encryptionType = _protocol.EncryptionType.AES;
        throw new DecryptError(streamMessage, "Could not decrypt new group key: ".concat(err.stack));
      }
      /* eslint-enable no-param-reassign */
    }
  }]);
  return EncryptionUtil;
}();
exports.EncryptionUtil = EncryptionUtil;

/***/ }),

/***/ "./src/encryption/GroupKey.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.GroupKeyError = exports.GroupKey = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _crypto = _interopRequireDefault(__webpack_require__("../../node_modules/crypto-browserify/index.js"));
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _uuid = __webpack_require__("./src/utils/uuid.ts");
var _EncryptionUtil = __webpack_require__("./src/encryption/EncryptionUtil.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var GroupKeyError = /*#__PURE__*/function (_Error) {
  _inherits(GroupKeyError, _Error);
  var _super = _createSuper(GroupKeyError);
  function GroupKeyError(message, groupKey) {
    var _this;
    _classCallCheck(this, GroupKeyError);
    _this = _super.call(this, message);
    _this.groupKey = groupKey;
    return _this;
  }
  return _createClass(GroupKeyError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * GroupKeys are AES cipher keys, which are used to encrypt/decrypt StreamMessages (when encryptionType is AES).
 * Each group key contains 256 random bits of key data and an UUID.
 */
exports.GroupKeyError = GroupKeyError;
var GroupKey = /*#__PURE__*/function () {
  /** @internal */

  /** @internal */

  function GroupKey(groupKeyId, data) {
    _classCallCheck(this, GroupKey);
    this.id = groupKeyId;
    if (!groupKeyId) {
      throw new GroupKeyError("groupKeyId must not be falsey ".concat(groupKeyId));
    }
    if (!data) {
      throw new GroupKeyError("groupKeyBufferOrHexString must not be falsey ".concat(data));
    }
    this.data = data;
    GroupKey.validate(this);
  }
  _createClass(GroupKey, [{
    key: "encryptNextGroupKey",
    value: /** @internal */
    function encryptNextGroupKey(nextGroupKey) {
      return new _protocol.EncryptedGroupKey(nextGroupKey.id, _EncryptionUtil.EncryptionUtil.encryptWithAES(nextGroupKey.data, this.data));
    }

    /** @internal */
  }, {
    key: "decryptNextGroupKey",
    value: function decryptNextGroupKey(nextGroupKey) {
      return new GroupKey(nextGroupKey.groupKeyId, _EncryptionUtil.EncryptionUtil.decryptWithAES(nextGroupKey.encryptedGroupKeyHex, this.data));
    }

    /** @internal */
  }], [{
    key: "validate",
    value: function validate(maybeGroupKey) {
      if (!maybeGroupKey) {
        throw new GroupKeyError("value must be a ".concat(this.name, ": ").concat(maybeGroupKey), maybeGroupKey);
      }
      if (!(maybeGroupKey instanceof this)) {
        throw new GroupKeyError("value must be a ".concat(this.name, ": ").concat(maybeGroupKey), maybeGroupKey);
      }
      if (!maybeGroupKey.id || typeof maybeGroupKey.id !== 'string') {
        throw new GroupKeyError("".concat(this.name, " id must be a string: ").concat(maybeGroupKey), maybeGroupKey);
      }
      if (maybeGroupKey.id.includes('---BEGIN')) {
        throw new GroupKeyError("".concat(this.name, " public/private key is not a valid group key id: ").concat(maybeGroupKey), maybeGroupKey);
      }
      if (!maybeGroupKey.data || !Buffer.isBuffer(maybeGroupKey.data)) {
        throw new GroupKeyError("".concat(this.name, " data must be a Buffer: ").concat(maybeGroupKey), maybeGroupKey);
      }
      if (maybeGroupKey.data.length !== 32) {
        throw new GroupKeyError("Group key must have a size of 256 bits, not ".concat(maybeGroupKey.data.length * 8), maybeGroupKey);
      }
    }
  }, {
    key: "generate",
    value: function generate() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _uuid.uuid)('GroupKey');
      var keyBytes = _crypto.default.randomBytes(32);
      return new GroupKey(id, keyBytes);
    }
  }, {
    key: "decryptRSAEncrypted",
    value: function decryptRSAEncrypted(encryptedKey, rsaPrivateKey) {
      return new GroupKey(encryptedKey.groupKeyId, _EncryptionUtil.EncryptionUtil.decryptWithRSAPrivateKey(encryptedKey.encryptedGroupKeyHex, rsaPrivateKey, true));
    }
  }]);
  return GroupKey;
}();
exports.GroupKey = GroupKey;

/***/ }),

/***/ "./src/encryption/GroupKeyManager.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.GroupKeyManager = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
var _LitProtocolFacade = __webpack_require__("./src/encryption/LitProtocolFacade.ts");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _LocalGroupKeyStore = __webpack_require__("./src/encryption/LocalGroupKeyStore.ts");
var _GroupKey = __webpack_require__("./src/encryption/GroupKey.ts");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _SubscriberKeyExchange = __webpack_require__("./src/encryption/SubscriberKeyExchange.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _events = __webpack_require__("./src/events.ts");
var _DestroySignal = __webpack_require__("./src/DestroySignal.ts");
var _crypto = _interopRequireDefault(__webpack_require__("../../node_modules/crypto-browserify/index.js"));
var _uuid = __webpack_require__("./src/utils/uuid.ts");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var GroupKeyManager = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 5);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 6);
}, _dec4 = Reflect.metadata("design:type", Function), _dec5 = Reflect.metadata("design:paramtypes", [typeof _LocalGroupKeyStore.LocalGroupKeyStore === "undefined" ? Object : _LocalGroupKeyStore.LocalGroupKeyStore, typeof _LitProtocolFacade.LitProtocolFacade === "undefined" ? Object : _LitProtocolFacade.LitProtocolFacade, typeof _SubscriberKeyExchange.SubscriberKeyExchange === "undefined" ? Object : _SubscriberKeyExchange.SubscriberKeyExchange, typeof _events.StreamrClientEventEmitter === "undefined" ? Object : _events.StreamrClientEventEmitter, typeof _DestroySignal.DestroySignal === "undefined" ? Object : _DestroySignal.DestroySignal, typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication, typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = /*#__PURE__*/function () {
  function GroupKeyManager(localGroupKeyStore, litProtocolFacade, subscriberKeyExchange, eventEmitter, destroySignal, authentication, config) {
    _classCallCheck(this, GroupKeyManager);
    this.localGroupKeyStore = localGroupKeyStore;
    this.litProtocolFacade = litProtocolFacade;
    this.subscriberKeyExchange = subscriberKeyExchange;
    this.eventEmitter = eventEmitter;
    this.destroySignal = destroySignal;
    this.authentication = authentication;
    this.config = config;
  }
  _createClass(GroupKeyManager, [{
    key: "fetchKey",
    value: function () {
      var _fetchKey = _asyncToGenerator(function* (streamPartId, groupKeyId, publisherId) {
        var streamId = _protocol.StreamPartIDUtils.getStreamID(streamPartId);

        // 1st try: local storage
        var groupKey = yield this.localGroupKeyStore.get(groupKeyId, publisherId);
        if (groupKey !== undefined) {
          return groupKey;
        }

        // 2nd try: lit-protocol
        if (this.config.encryption.litProtocolEnabled) {
          groupKey = yield this.litProtocolFacade.get(streamId, groupKeyId);
          if (groupKey !== undefined) {
            yield this.localGroupKeyStore.set(groupKey.id, publisherId, groupKey.data);
            return groupKey;
          }
        }

        // 3rd try: Streamr key-exchange
        yield this.subscriberKeyExchange.requestGroupKey(groupKeyId, publisherId, streamPartId);
        var groupKeyIds = yield (0, _utils.waitForEvent)(
        // TODO remove "as any" type casing in NET-889
        this.eventEmitter, 'storeEncryptionKeyToLocalStore', this.config.encryption.keyRequestTimeout, function (storedGroupKeyId) {
          return storedGroupKeyId === groupKeyId;
        }, this.destroySignal.abortSignal);
        groupKey = yield this.localGroupKeyStore.get(groupKeyIds[0], publisherId);
        return groupKey;
      });
      function fetchKey(_x, _x2, _x3) {
        return _fetchKey.apply(this, arguments);
      }
      return fetchKey;
    }()
  }, {
    key: "fetchLatestEncryptionKey",
    value: function () {
      var _fetchLatestEncryptionKey = _asyncToGenerator(function* (publisherId, streamId) {
        if (publisherId !== (yield this.authentication.getAddress())) {
          throw new Error('storeKey: fetching latest encryption keys for other publishers not supported.');
        }
        var keyId = yield this.localGroupKeyStore.getLatestEncryptionKeyId(publisherId, streamId);
        return keyId !== undefined ? this.localGroupKeyStore.get(keyId, publisherId) : undefined;
      });
      function fetchLatestEncryptionKey(_x4, _x5) {
        return _fetchLatestEncryptionKey.apply(this, arguments);
      }
      return fetchLatestEncryptionKey;
    }()
  }, {
    key: "storeKey",
    value: function () {
      var _storeKey = _asyncToGenerator(function* (groupKey, publisherId, streamId) {
        if (publisherId !== (yield this.authentication.getAddress())) {
          // TODO: unit test?
          throw new Error('storeKey: storing latest encryption keys for other publishers not supported.');
        }
        if (groupKey === undefined) {
          var keyData = _crypto.default.randomBytes(32);
          // 1st try lit-protocol, if a key cannot be generated and stored, then generate group key locally
          if (this.config.encryption.litProtocolEnabled) {
            groupKey = yield this.litProtocolFacade.store(streamId, keyData);
          }
          if (groupKey === undefined) {
            groupKey = new _GroupKey.GroupKey((0, _uuid.uuid)('GroupKey'), keyData);
          }
        }
        yield this.localGroupKeyStore.set(groupKey.id, publisherId, groupKey.data);
        yield this.localGroupKeyStore.setLatestEncryptionKeyId(groupKey.id, publisherId, streamId);
        return groupKey;
      });
      function storeKey(_x6, _x7, _x8) {
        return _storeKey.apply(this, arguments);
      }
      return storeKey;
    }()
  }, {
    key: "addKeyToLocalStore",
    value: function addKeyToLocalStore(groupKey, publisherId) {
      return this.localGroupKeyStore.set(groupKey.id, publisherId, groupKey.data);
    }
  }]);
  return GroupKeyManager;
}()) || _class) || _class) || _class) || _class) || _class);
exports.GroupKeyManager = GroupKeyManager;

/***/ }),

/***/ "./src/encryption/LitProtocolFacade.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);
/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-map.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LitProtocolFacade = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
var LitJsSdk = _interopRequireWildcard(__webpack_require__("../../node_modules/@lit-protocol/lit-node-client/src/index.js"));
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var siwe = _interopRequireWildcard(__webpack_require__("../../node_modules/lit-siwe/dist/siwe.js"));
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _ethers = __webpack_require__("../../node_modules/ethers/lib.esm/index.js");
var _permission = __webpack_require__("./src/permission.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _GroupKey = __webpack_require__("./src/encryption/GroupKey.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _class;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var logger = new _utils.Logger(module);
var chain = 'polygon';
var LIT_PROTOCOL_CONNECT_INTERVAL = 60 * 60 * 1000; // 1h

var formEvmContractConditions = function formEvmContractConditions(streamRegistryChainAddress, streamId) {
  return [{
    contractAddress: streamRegistryChainAddress,
    chain: chain,
    functionName: 'hasPermission',
    functionParams: [streamId, ':userAddress', "".concat((0, _permission.streamPermissionToSolidityType)(_permission.StreamPermission.SUBSCRIBE))],
    functionAbi: {
      inputs: [{
        name: "streamId",
        type: "string"
      }, {
        name: "user",
        type: "address"
      }, {
        name: "permissionType",
        type: "uint8"
      }],
      name: "hasPermission",
      outputs: [{
        name: "userHasPermission",
        type: "bool"
      }],
      stateMutability: "view",
      type: "function"
    },
    returnValueTest: {
      key: "userHasPermission",
      comparator: '=',
      value: "true"
    }
  }];
};
var signAuthMessage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (authentication) {
    var domain = "dummy.com";
    var uri = "https://dummy.com";
    var statement = "dummy";
    var addressInChecksumCase = _ethers.ethers.utils.getAddress(yield authentication.getAddress());
    var siweMessage = new siwe.SiweMessage({
      domain: domain,
      uri: uri,
      statement: statement,
      address: addressInChecksumCase,
      version: "1",
      chainId: 1
    });
    var messageToSign = siweMessage.prepareMessage();
    var signature = yield authentication.createMessageSignature(messageToSign);
    return {
      sig: signature,
      derivedVia: "web3.eth.personal.sign",
      signedMessage: messageToSign,
      address: addressInChecksumCase
    };
  });
  return function signAuthMessage(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * This class only operates with Polygon production network and therefore ignores contracts config.
 */
var LitProtocolFacade = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 1);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 2);
}, _dec4 = Reflect.metadata("design:type", Function), _dec5 = Reflect.metadata("design:paramtypes", [typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof Pick === "undefined" ? Object : Pick, typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = /*#__PURE__*/function () {
  function LitProtocolFacade(loggerFactory, config, authentication) {
    _classCallCheck(this, LitProtocolFacade);
    this.authentication = authentication;
    this.config = config;
    this.logger = loggerFactory.createLogger(module);
  }
  _createClass(LitProtocolFacade, [{
    key: "getLitNodeClient",
    value: function () {
      var _getLitNodeClient = _asyncToGenerator(function* () {
        var _this = this;
        if (this.litNodeClient === undefined) {
          this.litNodeClient = new LitJsSdk.LitNodeClient({
            alertWhenUnauthorized: false,
            debug: this.config.encryption.litProtocolLogging
          });
          // Add a rate limiter to avoid calling `connect` each time we want to use lit protocol as this would cause an unnecessary handshake.
          this.connectLitNodeClient = (0, _utils.withRateLimit)(function () {
            return _this.litNodeClient.connect();
          }, LIT_PROTOCOL_CONNECT_INTERVAL);
        }
        yield this.connectLitNodeClient();
        return this.litNodeClient;
      });
      function getLitNodeClient() {
        return _getLitNodeClient.apply(this, arguments);
      }
      return getLitNodeClient;
    }()
  }, {
    key: "store",
    value: function () {
      var _store = _asyncToGenerator(function* (streamId, symmetricKey) {
        var traceId = (0, _utils.randomString)(5);
        this.logger.debug('Storing key', {
          streamId: streamId,
          traceId: traceId
        });
        try {
          var authSig = yield signAuthMessage(this.authentication);
          var client = yield this.getLitNodeClient();
          var encryptedSymmetricKey = yield client.saveEncryptionKey({
            evmContractConditions: formEvmContractConditions(this.config.contracts.streamRegistryChainAddress, streamId),
            symmetricKey: symmetricKey,
            authSig: authSig,
            chain: chain
          });
          if (encryptedSymmetricKey === undefined) {
            return undefined;
          }
          var groupKeyId = LitJsSdk.uint8arrayToString(encryptedSymmetricKey, 'base16');
          this.logger.debug('Stored key', {
            traceId: traceId,
            streamId: streamId,
            groupKeyId: groupKeyId
          });
          return new _GroupKey.GroupKey(groupKeyId, Buffer.from(symmetricKey));
        } catch (err) {
          logger.warn('Failed to store key', {
            traceId: traceId,
            err: err,
            streamId: streamId
          });
          return undefined;
        }
      });
      function store(_x2, _x3) {
        return _store.apply(this, arguments);
      }
      return store;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(function* (streamId, groupKeyId) {
        this.logger.debug('Getting key', {
          groupKeyId: groupKeyId,
          streamId: streamId
        });
        try {
          var authSig = yield signAuthMessage(this.authentication);
          var client = yield this.getLitNodeClient();
          var symmetricKey = yield client.getEncryptionKey({
            evmContractConditions: formEvmContractConditions(this.config.contracts.streamRegistryChainAddress, streamId),
            toDecrypt: groupKeyId,
            chain: chain,
            authSig: authSig
          });
          if (symmetricKey === undefined) {
            return undefined;
          }
          this.logger.debug('Got key', {
            groupKeyId: groupKeyId,
            streamId: streamId
          });
          return new _GroupKey.GroupKey(groupKeyId, Buffer.from(symmetricKey));
        } catch (err) {
          logger.warn('Failed to get key', {
            err: err,
            streamId: streamId,
            groupKeyId: groupKeyId
          });
          return undefined;
        }
      });
      function get(_x4, _x5) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }]);
  return LitProtocolFacade;
}()) || _class) || _class) || _class) || _class) || _class);
exports.LitProtocolFacade = LitProtocolFacade;

/***/ }),

/***/ "./src/encryption/LocalGroupKeyStore.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);
/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LocalGroupKeyStore = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _events = __webpack_require__("./src/events.ts");
var _PersistenceManager = __webpack_require__("./src/PersistenceManager.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _GroupKey = __webpack_require__("./src/encryption/GroupKey.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @privateRemarks
 *
 * In the client API we use the term EncryptionKey instead of GroupKey.
 * The GroupKey name comes from the protocol. TODO: we could rename all classes
 * and methods to use the term EncryptionKey (except protocol-classes, which
 * should use the protocol level term GroupKey)
 */

function formLookupKey1(keyId, publisherId) {
  return "".concat(publisherId, "::").concat(keyId);
}
function formLookupKey2(publisherId, streamId) {
  return "".concat(publisherId, "::").concat(streamId);
}
var LocalGroupKeyStore = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_PersistenceManager.PersistenceManager)(target, undefined, 0);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_LoggerFactory.LoggerFactory)(target, undefined, 1);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)(_events.StreamrClientEventEmitter)(target, undefined, 2);
}, _dec5 = Reflect.metadata("design:type", Function), _dec6 = Reflect.metadata("design:paramtypes", [typeof _PersistenceManager.PersistenceManager === "undefined" ? Object : _PersistenceManager.PersistenceManager, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof _events.StreamrClientEventEmitter === "undefined" ? Object : _events.StreamrClientEventEmitter]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = /*#__PURE__*/function () {
  function LocalGroupKeyStore(persistenceManager, loggerFactory, eventEmitter) {
    _classCallCheck(this, LocalGroupKeyStore);
    this.persistenceManager = persistenceManager;
    this.eventEmitter = eventEmitter;
    this.logger = loggerFactory.createLogger(module);
  }
  _createClass(LocalGroupKeyStore, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(function* (keyId, publisherId) {
        var persistence = yield this.persistenceManager.getPersistence(_PersistenceManager.NAMESPACES.ENCRYPTION_KEYS);
        var value = yield persistence.get(formLookupKey1(keyId, publisherId));
        if (value !== undefined) {
          return new _GroupKey.GroupKey(keyId, Buffer.from(value, 'hex'));
        } else {
          return this.getLegacyKey(keyId);
        }
      });
      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
    /**
     * Legacy keys refer to group keys migrated from a previous version of the client where group keys were not tied
     * to a specific publisherId, therefore any publisherId for a given legacy key id is considered a match.
     *
     * TODO: remove this functionality in the future
     */
  }, {
    key: "getLegacyKey",
    value: function () {
      var _getLegacyKey = _asyncToGenerator(function* (keyId) {
        var persistence = yield this.persistenceManager.getPersistence(_PersistenceManager.NAMESPACES.ENCRYPTION_KEYS);
        var value = yield persistence.get(formLookupKey1(keyId, 'LEGACY'));
        return value !== undefined ? new _GroupKey.GroupKey(keyId, Buffer.from(value, 'hex')) : undefined;
      });
      function getLegacyKey(_x3) {
        return _getLegacyKey.apply(this, arguments);
      }
      return getLegacyKey;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator(function* (keyId, publisherId, data) {
        var persistence = yield this.persistenceManager.getPersistence(_PersistenceManager.NAMESPACES.ENCRYPTION_KEYS);
        yield persistence.set(formLookupKey1(keyId, publisherId), Buffer.from(data).toString('hex'));
        this.logger.debug('Set key', {
          keyId: keyId,
          publisherId: publisherId
        });
        this.eventEmitter.emit('storeEncryptionKeyToLocalStore', keyId);
      });
      function set(_x4, _x5, _x6) {
        return _set.apply(this, arguments);
      }
      return set;
    }()
  }, {
    key: "setLatestEncryptionKeyId",
    value: function () {
      var _setLatestEncryptionKeyId = _asyncToGenerator(function* (keyId, publisherId, streamId) {
        var persistence = yield this.persistenceManager.getPersistence(_PersistenceManager.NAMESPACES.LATEST_ENCRYPTION_KEY_IDS);
        this.logger.debug('Set latest encryptionKeyId', {
          keyId: keyId,
          publisherId: publisherId,
          streamId: streamId
        });
        yield persistence.set(formLookupKey2(publisherId, streamId), keyId);
      });
      function setLatestEncryptionKeyId(_x7, _x8, _x9) {
        return _setLatestEncryptionKeyId.apply(this, arguments);
      }
      return setLatestEncryptionKeyId;
    }()
  }, {
    key: "getLatestEncryptionKeyId",
    value: function () {
      var _getLatestEncryptionKeyId = _asyncToGenerator(function* (publisherId, streamId) {
        var persistence = yield this.persistenceManager.getPersistence(_PersistenceManager.NAMESPACES.LATEST_ENCRYPTION_KEY_IDS);
        var value = yield persistence.get(formLookupKey2(publisherId, streamId));
        return value;
      });
      function getLatestEncryptionKeyId(_x10, _x11) {
        return _getLatestEncryptionKeyId.apply(this, arguments);
      }
      return getLatestEncryptionKeyId;
    }()
  }]);
  return LocalGroupKeyStore;
}()) || _class) || _class) || _class) || _class) || _class) || _class);
exports.LocalGroupKeyStore = LocalGroupKeyStore;

/***/ }),

/***/ "./src/encryption/PublisherKeyExchange.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PublisherKeyExchange = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _without = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/without.js"));
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _NetworkNodeFacade = __webpack_require__("./src/NetworkNodeFacade.ts");
var _validateStreamMessage = __webpack_require__("./src/utils/validateStreamMessage.ts");
var _MessageFactory = __webpack_require__("./src/publish/MessageFactory.ts");
var _messageChain = __webpack_require__("./src/publish/messageChain.ts");
var _StreamRegistryCached = __webpack_require__("./src/registry/StreamRegistryCached.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _EncryptionUtil = __webpack_require__("./src/encryption/EncryptionUtil.ts");
var _LocalGroupKeyStore = __webpack_require__("./src/encryption/LocalGroupKeyStore.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 * Sends group key responses
 */
var PublisherKeyExchange = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_LoggerFactory.LoggerFactory)(target, undefined, 2);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 3);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _StreamRegistryCached.StreamRegistryCached;
  }))(target, undefined, 4);
}, _dec5 = Reflect.metadata("design:type", Function), _dec6 = Reflect.metadata("design:paramtypes", [typeof _LocalGroupKeyStore.LocalGroupKeyStore === "undefined" ? Object : _LocalGroupKeyStore.LocalGroupKeyStore, typeof _NetworkNodeFacade.NetworkNodeFacade === "undefined" ? Object : _NetworkNodeFacade.NetworkNodeFacade, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication, typeof _StreamRegistryCached.StreamRegistryCached === "undefined" ? Object : _StreamRegistryCached.StreamRegistryCached]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = /*#__PURE__*/function () {
  function PublisherKeyExchange(store, networkNodeFacade, loggerFactory, authentication, streamRegistryCached) {
    var _this = this;
    _classCallCheck(this, PublisherKeyExchange);
    this.logger = loggerFactory.createLogger(module);
    this.store = store;
    this.networkNodeFacade = networkNodeFacade;
    this.authentication = authentication;
    this.streamRegistryCached = streamRegistryCached;
    networkNodeFacade.once('start', /*#__PURE__*/_asyncToGenerator(function* () {
      var node = yield networkNodeFacade.getNode();
      node.addMessageListener(function (msg) {
        return _this.onMessage(msg);
      });
      _this.logger.debug('Started');
    }));
  }
  _createClass(PublisherKeyExchange, [{
    key: "onMessage",
    value: function () {
      var _onMessage = _asyncToGenerator(function* (request) {
        var _this2 = this;
        if (_protocol.GroupKeyRequest.is(request)) {
          try {
            var authenticatedUser = yield this.authentication.getAddress();
            var _ref2 = _protocol.GroupKeyRequest.fromStreamMessage(request),
              recipient = _ref2.recipient,
              requestId = _ref2.requestId,
              rsaPublicKey = _ref2.rsaPublicKey,
              groupKeyIds = _ref2.groupKeyIds;
            if (recipient === authenticatedUser) {
              this.logger.debug('Handling group key request', {
                requestId: requestId
              });
              yield (0, _validateStreamMessage.validateStreamMessage)(request, this.streamRegistryCached);
              var keys = (0, _without.default)(yield Promise.all(groupKeyIds.map(function (id) {
                return _this2.store.get(id, authenticatedUser);
              })), undefined);
              if (keys.length > 0) {
                var response = yield this.createResponse(keys, request.getStreamPartID(), rsaPublicKey, request.getPublisherId(), requestId);
                var node = yield this.networkNodeFacade.getNode();
                node.publish(response);
                this.logger.debug('Handled group key request (found keys)', {
                  groupKeyIds: keys.map(function (k) {
                    return k.id;
                  }).join(),
                  recipient: request.getPublisherId()
                });
              } else {
                this.logger.debug('Handled group key request (no keys found)', {
                  requestId: requestId,
                  recipient: request.getPublisherId()
                });
              }
            }
          } catch (err) {
            this.logger.debug('Failed to handle group key request', err);
          }
        }
      });
      function onMessage(_x) {
        return _onMessage.apply(this, arguments);
      }
      return onMessage;
    }()
  }, {
    key: "createResponse",
    value: function () {
      var _createResponse = _asyncToGenerator(function* (keys, streamPartId, rsaPublicKey, recipient, requestId) {
        var encryptedGroupKeys = yield Promise.all(keys.map(function (key) {
          var encryptedGroupKeyHex = _EncryptionUtil.EncryptionUtil.encryptWithRSAPublicKey(key.data, rsaPublicKey, true);
          return new _protocol.EncryptedGroupKey(key.id, encryptedGroupKeyHex);
        }));
        var responseContent = new _protocol.GroupKeyResponse({
          recipient: recipient,
          requestId: requestId,
          encryptedGroupKeys: encryptedGroupKeys
        });
        var response = (0, _MessageFactory.createSignedMessage)({
          messageId: new _protocol.MessageID(_protocol.StreamPartIDUtils.getStreamID(streamPartId), _protocol.StreamPartIDUtils.getStreamPartition(streamPartId), Date.now(), 0, yield this.authentication.getAddress(), (0, _messageChain.createRandomMsgChainId)()),
          serializedContent: JSON.stringify(responseContent.toArray()),
          messageType: _protocol.StreamMessageType.GROUP_KEY_RESPONSE,
          encryptionType: _protocol.EncryptionType.RSA,
          authentication: this.authentication
        });
        return response;
      });
      function createResponse(_x2, _x3, _x4, _x5, _x6) {
        return _createResponse.apply(this, arguments);
      }
      return createResponse;
    }()
  }]);
  return PublisherKeyExchange;
}()) || _class) || _class) || _class) || _class) || _class) || _class);
exports.PublisherKeyExchange = PublisherKeyExchange;

/***/ }),

/***/ "./src/encryption/RSAKeyPair.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.RSAKeyPair = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array-buffer.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.uint8-array.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.copy-within.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.every.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.fill.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.find.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.find-index.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.join.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.last-index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.reduce.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.reduce-right.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.reverse.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.some.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.sort.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.subarray.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.to-locale-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.typed-array.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var _crypto = _interopRequireDefault(__webpack_require__("../../node_modules/crypto-browserify/index.js"));
var _util = __webpack_require__("../../node_modules/util/util.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var webcrypto = _crypto.default.webcrypto;
function getSubtle() {
  var _window, _window$crypto;
  var subtle = typeof window !== 'undefined' ? (_window = window) === null || _window === void 0 ? void 0 : (_window$crypto = _window.crypto) === null || _window$crypto === void 0 ? void 0 : _window$crypto.subtle : webcrypto.subtle;
  if (!subtle) {
    var url = 'https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto';
    throw new Error("SubtleCrypto not supported. This feature is available only in secure contexts (HTTPS) & Node 16+. ".concat(url));
  }
  return subtle;
}
function ab2str() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  // @ts-expect-error Uint8Array parameters
  return String.fromCharCode.apply(null, _construct(Uint8Array, args));
}

// shim browser btoa for node
function btoa(str) {
  if (__webpack_require__.g.btoa) {
    return __webpack_require__.g.btoa(str);
  }
  var buffer;
  if (Buffer.isBuffer(str)) {
    buffer = str;
  } else {
    buffer = Buffer.from(str.toString(), 'binary');
  }
  return buffer.toString('base64');
}
function exportCryptoKey(_x) {
  return _exportCryptoKey.apply(this, arguments);
}
function _exportCryptoKey() {
  _exportCryptoKey = _asyncToGenerator(function* (key) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$isPrivate = _ref.isPrivate,
      isPrivate = _ref$isPrivate === void 0 ? false : _ref$isPrivate;
    var keyType = isPrivate ? 'pkcs8' : 'spki';
    var exported = yield getSubtle().exportKey(keyType, key);
    var exportedAsString = ab2str(exported);
    var exportedAsBase64 = btoa(exportedAsString);
    var TYPE = isPrivate ? 'PRIVATE' : 'PUBLIC';
    return "-----BEGIN ".concat(TYPE, " KEY-----\n").concat(exportedAsBase64, "\n-----END ").concat(TYPE, " KEY-----\n");
  });
  return _exportCryptoKey.apply(this, arguments);
}
var RSAKeyPair = /*#__PURE__*/function () {
  // the keys are in PEM format

  function RSAKeyPair(privateKey, publicKey) {
    _classCallCheck(this, RSAKeyPair);
    this.privateKey = privateKey;
    this.publicKey = publicKey;
  }
  _createClass(RSAKeyPair, [{
    key: "getPublicKey",
    value: function getPublicKey() {
      return this.publicKey;
    }
  }, {
    key: "getPrivateKey",
    value: function getPrivateKey() {
      return this.privateKey;
    }
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator(function* () {
        return typeof window !== 'undefined' ? RSAKeyPair.create_browserEnvironment() : RSAKeyPair.create_serverEnvironment();
      });
      function create() {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "create_serverEnvironment",
    value: function () {
      var _create_serverEnvironment = _asyncToGenerator(function* () {
        // promisify here to work around browser/server packaging
        var generateKeyPair = (0, _util.promisify)(_crypto.default.generateKeyPair);
        var _yield$generateKeyPai = yield generateKeyPair('rsa', {
            modulusLength: 4096,
            publicKeyEncoding: {
              type: 'spki',
              format: 'pem'
            },
            privateKeyEncoding: {
              type: 'pkcs8',
              format: 'pem'
            }
          }),
          publicKey = _yield$generateKeyPai.publicKey,
          privateKey = _yield$generateKeyPai.privateKey;
        return new RSAKeyPair(privateKey, publicKey);
      });
      function create_serverEnvironment() {
        return _create_serverEnvironment.apply(this, arguments);
      }
      return create_serverEnvironment;
    }()
  }, {
    key: "create_browserEnvironment",
    value: function () {
      var _create_browserEnvironment = _asyncToGenerator(function* () {
        var _yield$getSubtle$gene = yield getSubtle().generateKey({
            name: 'RSA-OAEP',
            modulusLength: 4096,
            publicExponent: new Uint8Array([1, 0, 1]),
            // 65537
            hash: 'SHA-256'
          }, true, ['encrypt', 'decrypt']),
          publicKey = _yield$getSubtle$gene.publicKey,
          privateKey = _yield$getSubtle$gene.privateKey;
        var _yield$Promise$all = yield Promise.all([exportCryptoKey(privateKey, {
            isPrivate: true
          }), exportCryptoKey(publicKey, {
            isPrivate: false
          })]),
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2),
          exportedPrivate = _yield$Promise$all2[0],
          exportedPublic = _yield$Promise$all2[1];
        return new RSAKeyPair(exportedPrivate, exportedPublic);
      });
      function create_browserEnvironment() {
        return _create_browserEnvironment.apply(this, arguments);
      }
      return create_browserEnvironment;
    }()
  }]);
  return RSAKeyPair;
}();
exports.RSAKeyPair = RSAKeyPair;

/***/ }),

/***/ "./src/encryption/SubscriberKeyExchange.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SubscriberKeyExchange = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _uuid = __webpack_require__("./node_modules/uuid/dist/commonjs-browser/index.js");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _NetworkNodeFacade = __webpack_require__("./src/NetworkNodeFacade.ts");
var _validateStreamMessage = __webpack_require__("./src/utils/validateStreamMessage.ts");
var _MessageFactory = __webpack_require__("./src/publish/MessageFactory.ts");
var _messageChain = __webpack_require__("./src/publish/messageChain.ts");
var _StreamRegistryCached = __webpack_require__("./src/registry/StreamRegistryCached.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _promises = __webpack_require__("./src/utils/promises.ts");
var _utils = __webpack_require__("./src/utils/utils.ts");
var _GroupKey = __webpack_require__("./src/encryption/GroupKey.ts");
var _LocalGroupKeyStore = __webpack_require__("./src/encryption/LocalGroupKeyStore.ts");
var _RSAKeyPair = __webpack_require__("./src/encryption/RSAKeyPair.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MAX_PENDING_REQUEST_COUNT = 50000; // just some limit, we can tweak the number if needed

/*
 * Sends group key requests and receives group key responses
 */
var SubscriberKeyExchange = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 2);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _StreamRegistryCached.StreamRegistryCached;
  }))(target, undefined, 3);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)(_LoggerFactory.LoggerFactory)(target, undefined, 4);
}, _dec5 = function _dec5(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 5);
}, _dec6 = Reflect.metadata("design:type", Function), _dec7 = Reflect.metadata("design:paramtypes", [typeof _NetworkNodeFacade.NetworkNodeFacade === "undefined" ? Object : _NetworkNodeFacade.NetworkNodeFacade, typeof _LocalGroupKeyStore.LocalGroupKeyStore === "undefined" ? Object : _LocalGroupKeyStore.LocalGroupKeyStore, typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication, typeof _StreamRegistryCached.StreamRegistryCached === "undefined" ? Object : _StreamRegistryCached.StreamRegistryCached, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = /*#__PURE__*/function () {
  function SubscriberKeyExchange(networkNodeFacade, store, authentication, streamRegistryCached, loggerFactory, config) {
    var _this = this;
    _classCallCheck(this, SubscriberKeyExchange);
    _defineProperty(this, "pendingRequests", new _utils.MaxSizedSet(MAX_PENDING_REQUEST_COUNT));
    this.logger = loggerFactory.createLogger(module);
    this.networkNodeFacade = networkNodeFacade;
    this.store = store;
    this.authentication = authentication;
    this.streamRegistryCached = streamRegistryCached;
    this.ensureStarted = (0, _promises.pOnce)( /*#__PURE__*/_asyncToGenerator(function* () {
      _this.rsaKeyPair = yield _RSAKeyPair.RSAKeyPair.create();
      var node = yield networkNodeFacade.getNode();
      node.addMessageListener(function (msg) {
        return _this.onMessage(msg);
      });
      _this.logger.debug('Started');
    }));
    this.requestGroupKey = (0, _promises.withThrottling)(function (groupKeyId, publisherId, streamPartId) {
      return _this.doRequestGroupKey(groupKeyId, publisherId, streamPartId);
    }, config.encryption.maxKeyRequestsPerSecond);
  }
  _createClass(SubscriberKeyExchange, [{
    key: "doRequestGroupKey",
    value: function () {
      var _doRequestGroupKey = _asyncToGenerator(function* (groupKeyId, publisherId, streamPartId) {
        yield this.ensureStarted();
        var requestId = (0, _uuid.v4)();
        var request = yield this.createRequest(groupKeyId, streamPartId, publisherId, this.rsaKeyPair.getPublicKey(), requestId);
        var node = yield this.networkNodeFacade.getNode();
        node.publish(request);
        this.pendingRequests.add(requestId);
        this.logger.debug('Sent group key request (waiting for response)', {
          groupKeyId: groupKeyId,
          requestId: requestId,
          publisherId: publisherId
        });
      });
      function doRequestGroupKey(_x, _x2, _x3) {
        return _doRequestGroupKey.apply(this, arguments);
      }
      return doRequestGroupKey;
    }()
  }, {
    key: "createRequest",
    value: function () {
      var _createRequest = _asyncToGenerator(function* (groupKeyId, streamPartId, publisherId, rsaPublicKey, requestId) {
        var requestContent = new _protocol.GroupKeyRequest({
          recipient: publisherId,
          requestId: requestId,
          rsaPublicKey: rsaPublicKey,
          groupKeyIds: [groupKeyId]
        }).toArray();
        return (0, _MessageFactory.createSignedMessage)({
          messageId: new _protocol.MessageID(_protocol.StreamPartIDUtils.getStreamID(streamPartId), _protocol.StreamPartIDUtils.getStreamPartition(streamPartId), Date.now(), 0, yield this.authentication.getAddress(), (0, _messageChain.createRandomMsgChainId)()),
          serializedContent: JSON.stringify(requestContent),
          messageType: _protocol.StreamMessageType.GROUP_KEY_REQUEST,
          encryptionType: _protocol.EncryptionType.NONE,
          authentication: this.authentication
        });
      });
      function createRequest(_x4, _x5, _x6, _x7, _x8) {
        return _createRequest.apply(this, arguments);
      }
      return createRequest;
    }()
  }, {
    key: "onMessage",
    value: function () {
      var _onMessage = _asyncToGenerator(function* (msg) {
        var _this2 = this;
        if (_protocol.GroupKeyResponse.is(msg)) {
          try {
            var authenticatedUser = yield this.authentication.getAddress();
            var _ref2 = _protocol.GroupKeyResponse.fromStreamMessage(msg),
              requestId = _ref2.requestId,
              recipient = _ref2.recipient,
              encryptedGroupKeys = _ref2.encryptedGroupKeys;
            if (recipient === authenticatedUser && this.pendingRequests.has(requestId)) {
              this.logger.debug('Handle group key response', {
                requestId: requestId
              });
              this.pendingRequests.delete(requestId);
              yield (0, _validateStreamMessage.validateStreamMessage)(msg, this.streamRegistryCached);
              yield Promise.all(encryptedGroupKeys.map( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(function* (encryptedKey) {
                  var key = _GroupKey.GroupKey.decryptRSAEncrypted(encryptedKey, _this2.rsaKeyPair.getPrivateKey());
                  yield _this2.store.set(key.id, msg.getPublisherId(), key.data);
                });
                return function (_x10) {
                  return _ref3.apply(this, arguments);
                };
              }()));
            }
          } catch (err) {
            this.logger.debug('Failed to handle group key response', {
              err: err
            });
          }
        }
      });
      function onMessage(_x9) {
        return _onMessage.apply(this, arguments);
      }
      return onMessage;
    }()
  }]);
  return SubscriberKeyExchange;
}()) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
exports.SubscriberKeyExchange = SubscriberKeyExchange;

/***/ }),

/***/ "./src/encryption/decrypt.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.decrypt = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
var _EncryptionUtil = __webpack_require__("./src/encryption/EncryptionUtil.ts");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
// TODO if this.destroySignal.isDestroyed() is true, would it make sense to reject the promise
// and not to return the original encrypted message?
// - e.g. StoppedError, which is not visible to end-user
var decrypt = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (streamMessage, groupKeyManager, destroySignal) {
    if (destroySignal.isDestroyed()) {
      return streamMessage;
    }
    var groupKey;
    try {
      groupKey = yield groupKeyManager.fetchKey(streamMessage.getStreamPartID(), streamMessage.groupKeyId, streamMessage.getPublisherId());
    } catch (e) {
      if (destroySignal.isDestroyed()) {
        return streamMessage;
      }
      throw new _EncryptionUtil.DecryptError(streamMessage, "Could not get GroupKey ".concat(streamMessage.groupKeyId, ": ").concat(e.message));
    }
    if (destroySignal.isDestroyed()) {
      return streamMessage;
    }
    var clone = streamMessage.clone();
    _EncryptionUtil.EncryptionUtil.decryptStreamMessage(clone, groupKey);
    if (streamMessage.newGroupKey) {
      // newGroupKey has been converted into GroupKey
      yield groupKeyManager.addKeyToLocalStore(clone.newGroupKey, streamMessage.getPublisherId());
    }
    return clone;
  });
  return function decrypt(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
exports.decrypt = decrypt;

/***/ }),

/***/ "./src/events.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamrClientEventEmitter = void 0;
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _dec, _class;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// events for internal communication between StreamrClient components
var StreamrClientEventEmitter = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec(_class = /*#__PURE__*/function (_ObservableEventEmitt) {
  _inherits(StreamrClientEventEmitter, _ObservableEventEmitt);
  var _super = _createSuper(StreamrClientEventEmitter);
  function StreamrClientEventEmitter() {
    _classCallCheck(this, StreamrClientEventEmitter);
    return _super.apply(this, arguments);
  }
  return _createClass(StreamrClientEventEmitter);
}(_utils.ObservableEventEmitter)) || _class);
exports.StreamrClientEventEmitter = StreamrClientEventEmitter;

/***/ }),

/***/ "./src/exports-browser.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-map.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.assign.js");
var StreamrClientExports = _interopRequireWildcard(__webpack_require__("./src/exports.ts"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
Object.assign(StreamrClientExports.StreamrClient, StreamrClientExports);
var _default = StreamrClientExports.StreamrClient;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/exports.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "CONFIG_TEST", ({
  enumerable: true,
  get: function get() {
    return _ConfigTest.CONFIG_TEST;
  }
}));
Object.defineProperty(exports, "ChainConnectionInfo", ({
  enumerable: true,
  get: function get() {
    return _Config.ChainConnectionInfo;
  }
}));
Object.defineProperty(exports, "ContentType", ({
  enumerable: true,
  get: function get() {
    return _protocol.ContentType;
  }
}));
Object.defineProperty(exports, "EncryptionKey", ({
  enumerable: true,
  get: function get() {
    return _GroupKey.GroupKey;
  }
}));
Object.defineProperty(exports, "EncryptionType", ({
  enumerable: true,
  get: function get() {
    return _protocol.EncryptionType;
  }
}));
Object.defineProperty(exports, "EthereumNetworkConfig", ({
  enumerable: true,
  get: function get() {
    return _Config.EthereumNetworkConfig;
  }
}));
Object.defineProperty(exports, "ExtraSubscribeOptions", ({
  enumerable: true,
  get: function get() {
    return _StreamrClient.ExtraSubscribeOptions;
  }
}));
Object.defineProperty(exports, "Field", ({
  enumerable: true,
  get: function get() {
    return _Stream.Field;
  }
}));
Object.defineProperty(exports, "Message", ({
  enumerable: true,
  get: function get() {
    return _Message.Message;
  }
}));
Object.defineProperty(exports, "MessageMetadata", ({
  enumerable: true,
  get: function get() {
    return _Message.MessageMetadata;
  }
}));
Object.defineProperty(exports, "NetworkNodeStub", ({
  enumerable: true,
  get: function get() {
    return _NetworkNodeFacade.NetworkNodeStub;
  }
}));
Object.defineProperty(exports, "PermissionAssignment", ({
  enumerable: true,
  get: function get() {
    return _permission.PermissionAssignment;
  }
}));
Object.defineProperty(exports, "PermissionQuery", ({
  enumerable: true,
  get: function get() {
    return _permission.PermissionQuery;
  }
}));
Object.defineProperty(exports, "PrivateKeyAuthConfig", ({
  enumerable: true,
  get: function get() {
    return _Config.PrivateKeyAuthConfig;
  }
}));
Object.defineProperty(exports, "ProviderAuthConfig", ({
  enumerable: true,
  get: function get() {
    return _Config.ProviderAuthConfig;
  }
}));
Object.defineProperty(exports, "ProxyDirection", ({
  enumerable: true,
  get: function get() {
    return _protocol.ProxyDirection;
  }
}));
Object.defineProperty(exports, "PublicPermissionAssignment", ({
  enumerable: true,
  get: function get() {
    return _permission.PublicPermissionAssignment;
  }
}));
Object.defineProperty(exports, "PublicPermissionQuery", ({
  enumerable: true,
  get: function get() {
    return _permission.PublicPermissionQuery;
  }
}));
Object.defineProperty(exports, "PublishMetadata", ({
  enumerable: true,
  get: function get() {
    return _Publisher.PublishMetadata;
  }
}));
Object.defineProperty(exports, "ResendFromOptions", ({
  enumerable: true,
  get: function get() {
    return _Resends.ResendFromOptions;
  }
}));
Object.defineProperty(exports, "ResendLastOptions", ({
  enumerable: true,
  get: function get() {
    return _Resends.ResendLastOptions;
  }
}));
Object.defineProperty(exports, "ResendOptions", ({
  enumerable: true,
  get: function get() {
    return _Resends.ResendOptions;
  }
}));
Object.defineProperty(exports, "ResendRangeOptions", ({
  enumerable: true,
  get: function get() {
    return _Resends.ResendRangeOptions;
  }
}));
Object.defineProperty(exports, "ResendRef", ({
  enumerable: true,
  get: function get() {
    return _Resends.ResendRef;
  }
}));
Object.defineProperty(exports, "STREAMR_STORAGE_NODE_GERMANY", ({
  enumerable: true,
  get: function get() {
    return _Config.STREAMR_STORAGE_NODE_GERMANY;
  }
}));
Object.defineProperty(exports, "SearchStreamsOrderBy", ({
  enumerable: true,
  get: function get() {
    return _searchStreams.SearchStreamsOrderBy;
  }
}));
Object.defineProperty(exports, "SearchStreamsPermissionFilter", ({
  enumerable: true,
  get: function get() {
    return _searchStreams.SearchStreamsPermissionFilter;
  }
}));
Object.defineProperty(exports, "StorageNodeAssignmentEvent", ({
  enumerable: true,
  get: function get() {
    return _StreamStorageRegistry.StorageNodeAssignmentEvent;
  }
}));
Object.defineProperty(exports, "StorageNodeMetadata", ({
  enumerable: true,
  get: function get() {
    return _StorageNodeRegistry.StorageNodeMetadata;
  }
}));
Object.defineProperty(exports, "Stream", ({
  enumerable: true,
  get: function get() {
    return _Stream.Stream;
  }
}));
Object.defineProperty(exports, "StreamCreationEvent", ({
  enumerable: true,
  get: function get() {
    return _StreamRegistry.StreamCreationEvent;
  }
}));
Object.defineProperty(exports, "StreamDefinition", ({
  enumerable: true,
  get: function get() {
    return _types.StreamDefinition;
  }
}));
Object.defineProperty(exports, "StreamMessageType", ({
  enumerable: true,
  get: function get() {
    return _protocol.StreamMessageType;
  }
}));
Object.defineProperty(exports, "StreamMetadata", ({
  enumerable: true,
  get: function get() {
    return _Stream.StreamMetadata;
  }
}));
Object.defineProperty(exports, "StreamPermission", ({
  enumerable: true,
  get: function get() {
    return _permission.StreamPermission;
  }
}));
Object.defineProperty(exports, "StreamrClient", ({
  enumerable: true,
  get: function get() {
    return _StreamrClient.StreamrClient;
  }
}));
Object.defineProperty(exports, "StreamrClientConfig", ({
  enumerable: true,
  get: function get() {
    return _Config.StreamrClientConfig;
  }
}));
Object.defineProperty(exports, "StreamrClientEvents", ({
  enumerable: true,
  get: function get() {
    return _events.StreamrClientEvents;
  }
}));
Object.defineProperty(exports, "SubscribeOptions", ({
  enumerable: true,
  get: function get() {
    return _StreamrClient.SubscribeOptions;
  }
}));
Object.defineProperty(exports, "Subscription", ({
  enumerable: true,
  get: function get() {
    return _Subscription.Subscription;
  }
}));
Object.defineProperty(exports, "SubscriptionEvents", ({
  enumerable: true,
  get: function get() {
    return _Subscription.SubscriptionEvents;
  }
}));
Object.defineProperty(exports, "TrackerRegistryContract", ({
  enumerable: true,
  get: function get() {
    return _Config.TrackerRegistryContract;
  }
}));
Object.defineProperty(exports, "UpdateEncryptionKeyOptions", ({
  enumerable: true,
  get: function get() {
    return _LocalGroupKeyStore.UpdateEncryptionKeyOptions;
  }
}));
Object.defineProperty(exports, "UserPermissionAssignment", ({
  enumerable: true,
  get: function get() {
    return _permission.UserPermissionAssignment;
  }
}));
Object.defineProperty(exports, "UserPermissionQuery", ({
  enumerable: true,
  get: function get() {
    return _permission.UserPermissionQuery;
  }
}));
Object.defineProperty(exports, "VALID_FIELD_TYPES", ({
  enumerable: true,
  get: function get() {
    return _Stream.VALID_FIELD_TYPES;
  }
}));
Object.defineProperty(exports, "formStorageNodeAssignmentStreamId", ({
  enumerable: true,
  get: function get() {
    return _utils.formStorageNodeAssignmentStreamId;
  }
}));
var _StreamrClient = __webpack_require__("./src/StreamrClient.ts");
var _Stream = __webpack_require__("./src/Stream.ts");
var _Message = __webpack_require__("./src/Message.ts");
var _events = __webpack_require__("./src/events.ts");
var _Publisher = __webpack_require__("./src/publish/Publisher.ts");
var _Subscription = __webpack_require__("./src/subscribe/Subscription.ts");
var _Resends = __webpack_require__("./src/subscribe/Resends.ts");
var _permission = __webpack_require__("./src/permission.ts");
var _StreamRegistry = __webpack_require__("./src/registry/StreamRegistry.ts");
var _StreamStorageRegistry = __webpack_require__("./src/registry/StreamStorageRegistry.ts");
var _StorageNodeRegistry = __webpack_require__("./src/registry/StorageNodeRegistry.ts");
var _searchStreams = __webpack_require__("./src/registry/searchStreams.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _GroupKey = __webpack_require__("./src/encryption/GroupKey.ts");
var _LocalGroupKeyStore = __webpack_require__("./src/encryption/LocalGroupKeyStore.ts");
var _ConfigTest = __webpack_require__("./src/ConfigTest.ts");
var _NetworkNodeFacade = __webpack_require__("./src/NetworkNodeFacade.ts");
var _types = __webpack_require__("./src/types.ts");
var _utils = __webpack_require__("./src/utils/utils.ts");
var _protocol = __webpack_require__("../protocol/src/exports.ts");

/***/ }),

/***/ "./src/permission.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.streamPermissionToSolidityType = exports.isPublicPermissionQuery = exports.isPublicPermissionAssignment = exports.convertStreamPermissionsToChainPermission = exports.convertChainPermissionsToStreamPermissions = exports.StreamPermission = exports.PUBLIC_PERMISSION_ADDRESS = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.includes.js");
var _constants = __webpack_require__("../../node_modules/@ethersproject/constants/lib.esm/index.js");
var _bignumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/index.js");
var StreamPermission = /*#__PURE__*/function (StreamPermission) {
  StreamPermission["EDIT"] = "edit";
  StreamPermission["DELETE"] = "delete";
  StreamPermission["PUBLISH"] = "publish";
  StreamPermission["SUBSCRIBE"] = "subscribe";
  StreamPermission["GRANT"] = "grant";
  return StreamPermission;
}({});
exports.StreamPermission = StreamPermission;
var PUBLIC_PERMISSION_ADDRESS = '0x0000000000000000000000000000000000000000';
exports.PUBLIC_PERMISSION_ADDRESS = PUBLIC_PERMISSION_ADDRESS;
var isPublicPermissionQuery = function isPublicPermissionQuery(query) {
  return query.public === true;
};
exports.isPublicPermissionQuery = isPublicPermissionQuery;
var isPublicPermissionAssignment = function isPublicPermissionAssignment(query) {
  return query.public === true;
};
exports.isPublicPermissionAssignment = isPublicPermissionAssignment;
var streamPermissionToSolidityType = function streamPermissionToSolidityType(permission) {
  switch (permission) {
    case StreamPermission.EDIT:
      return _bignumber.BigNumber.from(0);
    case StreamPermission.DELETE:
      return _bignumber.BigNumber.from(1);
    case StreamPermission.PUBLISH:
      return _bignumber.BigNumber.from(2);
    case StreamPermission.SUBSCRIBE:
      return _bignumber.BigNumber.from(3);
    case StreamPermission.GRANT:
      return _bignumber.BigNumber.from(4);
    default:
      break;
  }
  return _bignumber.BigNumber.from(0);
};
exports.streamPermissionToSolidityType = streamPermissionToSolidityType;
var convertChainPermissionsToStreamPermissions = function convertChainPermissionsToStreamPermissions(chainPermissions) {
  var now = Math.round(Date.now() / 1000);
  var permissions = [];
  if (chainPermissions.canEdit) {
    permissions.push(StreamPermission.EDIT);
  }
  if (chainPermissions.canDelete) {
    permissions.push(StreamPermission.DELETE);
  }
  if (_bignumber.BigNumber.from(chainPermissions.publishExpiration).gt(now)) {
    permissions.push(StreamPermission.PUBLISH);
  }
  if (_bignumber.BigNumber.from(chainPermissions.subscribeExpiration).gt(now)) {
    permissions.push(StreamPermission.SUBSCRIBE);
  }
  if (chainPermissions.canGrant) {
    permissions.push(StreamPermission.GRANT);
  }
  return permissions;
};
exports.convertChainPermissionsToStreamPermissions = convertChainPermissionsToStreamPermissions;
var convertStreamPermissionsToChainPermission = function convertStreamPermissionsToChainPermission(permissions) {
  return {
    canEdit: permissions.includes(StreamPermission.EDIT),
    canDelete: permissions.includes(StreamPermission.DELETE),
    publishExpiration: permissions.includes(StreamPermission.PUBLISH) ? _constants.MaxInt256 : _bignumber.BigNumber.from(0),
    subscribeExpiration: permissions.includes(StreamPermission.SUBSCRIBE) ? _constants.MaxInt256 : _bignumber.BigNumber.from(0),
    canGrant: permissions.includes(StreamPermission.GRANT)
  };
};
exports.convertStreamPermissionsToChainPermission = convertStreamPermissionsToChainPermission;

/***/ }),

/***/ "./src/publish/GroupKeyQueue.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.GroupKeyQueue = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var GroupKeyQueue = /*#__PURE__*/function () {
  function GroupKeyQueue(streamId, authentication, groupKeyManager) {
    _classCallCheck(this, GroupKeyQueue);
    this.streamId = streamId;
    this.authentication = authentication;
    this.groupKeyManager = groupKeyManager;
  }
  _createClass(GroupKeyQueue, [{
    key: "useGroupKey",
    value: function () {
      var _useGroupKey = _asyncToGenerator(function* () {
        // Ensure we have a current key by picking a queued key or generating a new one
        if (!this.currentGroupKey) {
          this.currentGroupKey = this.queuedGroupKey || (yield this.rekey());
          this.queuedGroupKey = undefined;
        }
        // Always return an array consisting of currentGroupKey and queuedGroupKey (latter may be undefined)
        var result = {
          current: this.currentGroupKey,
          next: this.queuedGroupKey
        };
        // Perform the rotate if there's a next key queued
        if (this.queuedGroupKey) {
          this.currentGroupKey = this.queuedGroupKey;
          this.queuedGroupKey = undefined;
        }
        return result;
      });
      function useGroupKey() {
        return _useGroupKey.apply(this, arguments);
      }
      return useGroupKey;
    }()
  }, {
    key: "rotate",
    value: function () {
      var _rotate = _asyncToGenerator(function* (newKey) {
        var publisherId = yield this.authentication.getAddress();
        newKey = yield this.groupKeyManager.storeKey(newKey, publisherId, this.streamId);
        this.queuedGroupKey = newKey;
        return newKey;
      });
      function rotate(_x) {
        return _rotate.apply(this, arguments);
      }
      return rotate;
    }()
  }, {
    key: "rekey",
    value: function () {
      var _rekey = _asyncToGenerator(function* (newKey) {
        var publisherId = yield this.authentication.getAddress();
        newKey = yield this.groupKeyManager.storeKey(newKey, publisherId, this.streamId);
        this.currentGroupKey = newKey;
        this.queuedGroupKey = undefined;
        return newKey;
      });
      function rekey(_x2) {
        return _rekey.apply(this, arguments);
      }
      return rekey;
    }()
  }], [{
    key: "createInstance",
    value: // a group key queued to be rotated into use after the call to useGroupKey
    function () {
      var _createInstance = _asyncToGenerator(function* (streamId, authentication, groupKeyManager) {
        var instance = new GroupKeyQueue(streamId, authentication, groupKeyManager);
        instance.currentGroupKey = yield instance.groupKeyManager.fetchLatestEncryptionKey(yield authentication.getAddress(), streamId);
        return instance;
      });
      function createInstance(_x3, _x4, _x5) {
        return _createInstance.apply(this, arguments);
      }
      return createInstance;
    }()
  }]);
  return GroupKeyQueue;
}();
exports.GroupKeyQueue = GroupKeyQueue;

/***/ }),

/***/ "./src/publish/MessageFactory.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createSignedMessage = exports.MessageFactory = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
var _random = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/random.js"));
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _EncryptionUtil = __webpack_require__("./src/encryption/EncryptionUtil.ts");
var _messageChain = __webpack_require__("./src/publish/messageChain.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _Mapping = __webpack_require__("./src/utils/Mapping.ts");
var _utils2 = __webpack_require__("./src/utils/utils.ts");
var _StreamrClientError = __webpack_require__("./src/StreamrClientError.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var createSignedMessage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (opts) {
    var _opts$prevMsgRef, _opts$newGroupKey;
    var signature = yield opts.authentication.createMessageSignature((0, _protocol.createSignaturePayload)({
      messageId: opts.messageId,
      serializedContent: opts.serializedContent,
      prevMsgRef: (_opts$prevMsgRef = opts.prevMsgRef) !== null && _opts$prevMsgRef !== void 0 ? _opts$prevMsgRef : undefined,
      newGroupKey: (_opts$newGroupKey = opts.newGroupKey) !== null && _opts$newGroupKey !== void 0 ? _opts$newGroupKey : undefined
    }));
    return new _protocol.StreamMessage(_objectSpread(_objectSpread({}, opts), {}, {
      signature: signature,
      content: opts.serializedContent
    }));
  });
  return function createSignedMessage(_x) {
    return _ref.apply(this, arguments);
  };
}();
exports.createSignedMessage = createSignedMessage;
var MessageFactory = /*#__PURE__*/function () {
  function MessageFactory(opts) {
    _classCallCheck(this, MessageFactory);
    _defineProperty(this, "prevMsgRefs", new Map());
    this.streamId = opts.streamId;
    this.authentication = opts.authentication;
    this.streamRegistry = opts.streamRegistry;
    this.groupKeyQueue = opts.groupKeyQueue;
    this.defaultMessageChainIds = new _Mapping.Mapping( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (_partition) {
        return (0, _messageChain.createRandomMsgChainId)();
      });
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  }

  /* eslint-disable padding-line-between-statements */
  _createClass(MessageFactory, [{
    key: "createMessage",
    value: function () {
      var _createMessage = _asyncToGenerator(function* (content, metadata, explicitPartition) {
        var _metadata$msgChainId;
        var publisherId = yield this.authentication.getAddress();
        var isPublisher = yield this.streamRegistry.isStreamPublisher(this.streamId, publisherId);
        if (!isPublisher) {
          throw new _StreamrClientError.StreamrClientError("You don't have permission to publish to this stream. Using address: ".concat(publisherId), 'MISSING_PERMISSION');
        }
        var partitionCount = (yield this.streamRegistry.getStream(this.streamId)).getMetadata().partitions;
        var partition;
        if (explicitPartition !== undefined) {
          if (explicitPartition < 0 || explicitPartition >= partitionCount) {
            throw new Error("Partition ".concat(explicitPartition, " is out of range (0..").concat(partitionCount - 1, ")"));
          }
          if (metadata.partitionKey !== undefined) {
            throw new Error('Invalid combination of "partition" and "partitionKey"');
          }
          partition = explicitPartition;
        } else {
          partition = metadata.partitionKey !== undefined ? (0, _utils.keyToArrayIndex)(partitionCount, metadata.partitionKey) : this.getDefaultPartition(partitionCount);
        }
        var msgChainId = (_metadata$msgChainId = metadata.msgChainId) !== null && _metadata$msgChainId !== void 0 ? _metadata$msgChainId : yield this.defaultMessageChainIds.get(partition);
        var msgChainKey = (0, _utils2.formLookupKey)(partition, msgChainId);
        var prevMsgRef = this.prevMsgRefs.get(msgChainKey);
        var msgRef = (0, _messageChain.createMessageRef)(metadata.timestamp, prevMsgRef);
        this.prevMsgRefs.set(msgChainKey, msgRef);
        var messageId = new _protocol.MessageID(this.streamId, partition, msgRef.timestamp, msgRef.sequenceNumber, publisherId, msgChainId);
        var encryptionType = (yield this.streamRegistry.isPublic(this.streamId)) ? _protocol.EncryptionType.NONE : _protocol.EncryptionType.AES;
        var groupKeyId;
        var newGroupKey;
        var serializedContent = JSON.stringify(content);
        if (encryptionType === _protocol.EncryptionType.AES) {
          var keySequence = yield this.groupKeyQueue.useGroupKey();
          serializedContent = _EncryptionUtil.EncryptionUtil.encryptWithAES(Buffer.from(serializedContent, 'utf8'), keySequence.current.data);
          groupKeyId = keySequence.current.id;
          if (keySequence.next !== undefined) {
            newGroupKey = keySequence.current.encryptNextGroupKey(keySequence.next);
          }
        }
        return createSignedMessage({
          messageId: messageId,
          serializedContent: serializedContent,
          prevMsgRef: prevMsgRef,
          encryptionType: encryptionType,
          groupKeyId: groupKeyId,
          newGroupKey: newGroupKey,
          authentication: this.authentication
        });
      });
      function createMessage(_x3, _x4, _x5) {
        return _createMessage.apply(this, arguments);
      }
      return createMessage;
    }()
  }, {
    key: "getDefaultPartition",
    value: function getDefaultPartition(partitionCount) {
      // we want to (re-)select a random partition in these two situations
      // 1) this is the first publish, and we have not yet selected any partition (the most typical case)
      // 2) the partition count may have decreased since we initially selected a random partitions, and it
      //    is now out-of-range (very rare case)
      if (this.defaultPartition === undefined || this.defaultPartition >= partitionCount) {
        this.defaultPartition = (0, _random.default)(partitionCount - 1);
      }
      return this.defaultPartition;
    }
  }]);
  return MessageFactory;
}();
exports.MessageFactory = MessageFactory;

/***/ }),

/***/ "./src/publish/Publisher.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Publisher = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _pLimit = _interopRequireDefault(__webpack_require__("./node_modules/p-limit/index.js"));
var _StreamIDBuilder = __webpack_require__("./src/StreamIDBuilder.ts");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _NetworkNodeFacade = __webpack_require__("./src/NetworkNodeFacade.ts");
var _MessageFactory = __webpack_require__("./src/publish/MessageFactory.ts");
var _isString = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/isString.js"));
var _StreamRegistryCached = __webpack_require__("./src/registry/StreamRegistryCached.ts");
var _GroupKeyQueue = __webpack_require__("./src/publish/GroupKeyQueue.ts");
var _Mapping = __webpack_require__("./src/utils/Mapping.ts");
var _StreamrClientError = __webpack_require__("./src/StreamrClientError.ts");
var _GroupKeyManager = __webpack_require__("./src/encryption/GroupKeyManager.ts");
var _dec, _dec2, _dec3, _dec4, _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var parseTimestamp = function parseTimestamp(metadata) {
  if ((metadata === null || metadata === void 0 ? void 0 : metadata.timestamp) === undefined) {
    return Date.now();
  } else {
    return metadata.timestamp instanceof Date ? metadata.timestamp.getTime() : (0, _isString.default)(metadata.timestamp) ? new Date(metadata.timestamp).getTime() : metadata.timestamp;
  }
};
var Publisher = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 1);
}, _dec3 = Reflect.metadata("design:type", Function), _dec4 = Reflect.metadata("design:paramtypes", [typeof _StreamIDBuilder.StreamIDBuilder === "undefined" ? Object : _StreamIDBuilder.StreamIDBuilder, typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication, typeof _StreamRegistryCached.StreamRegistryCached === "undefined" ? Object : _StreamRegistryCached.StreamRegistryCached, typeof _GroupKeyManager.GroupKeyManager === "undefined" ? Object : _GroupKeyManager.GroupKeyManager, typeof _NetworkNodeFacade.NetworkNodeFacade === "undefined" ? Object : _NetworkNodeFacade.NetworkNodeFacade]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = /*#__PURE__*/function () {
  function Publisher(streamIdBuilder, authentication, streamRegistryCached, groupKeyManager, node) {
    var _this = this;
    _classCallCheck(this, Publisher);
    _defineProperty(this, "concurrencyLimit", (0, _pLimit.default)(1));
    this.streamIdBuilder = streamIdBuilder;
    this.authentication = authentication;
    this.streamRegistryCached = streamRegistryCached;
    this.node = node;
    this.messageFactories = new _Mapping.Mapping( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (streamId) {
        return _this.createMessageFactory(streamId);
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    this.groupKeyQueues = new _Mapping.Mapping( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (streamId) {
        return _GroupKeyQueue.GroupKeyQueue.createInstance(streamId, _this.authentication, groupKeyManager);
      });
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  }
  _createClass(Publisher, [{
    key: "publish",
    value: function () {
      var _publish = _asyncToGenerator(function* (streamDefinition, content, metadata) {
        var _this2 = this;
        var timestamp = parseTimestamp(metadata);
        /*
         * There are some steps in the publish process which need to be done sequentially:
         * - message chaining
         * - consuming a group key from a queue
         *
         * It is also good if messages are published to node in the same sequence (within
         * a message chain), as that can avoid unnecessary gap fills: if a subscriber would
         * receive messages m1, m2, m3 in order m1, m3, m2 it would try to get m2 via
         * a gap fill resend before it receives it normally).
         *
         * Currently we limit that there can be only one publish task at any given time.
         * That way message chaining and group keys consuming is done properly. If we want
         * to improve concurrency, we could maybe offload message encryptions to a separate
         * tasks which we'd execute in parallel.
         */
        return this.concurrencyLimit( /*#__PURE__*/_asyncToGenerator(function* () {
          var _yield$_this2$streamI = yield _this2.streamIdBuilder.toStreamPartElements(streamDefinition),
            _yield$_this2$streamI2 = _slicedToArray(_yield$_this2$streamI, 2),
            streamId = _yield$_this2$streamI2[0],
            partition = _yield$_this2$streamI2[1];
          try {
            var messageFactory = yield _this2.messageFactories.get(streamId);
            var message = yield messageFactory.createMessage(content, _objectSpread(_objectSpread({}, metadata), {}, {
              timestamp: timestamp
            }), partition);
            yield _this2.node.publishToNode(message);
            return message;
          } catch (e) {
            var errorCode = e instanceof _StreamrClientError.StreamrClientError ? e.code : 'UNKNOWN_ERROR';
            throw new _StreamrClientError.StreamrClientError("Failed to publish to stream ".concat(streamId, ". Cause: ").concat(e.message), errorCode);
          }
        }));
      });
      function publish(_x3, _x4, _x5) {
        return _publish.apply(this, arguments);
      }
      return publish;
    }()
  }, {
    key: "getGroupKeyQueue",
    value: function getGroupKeyQueue(streamId) {
      return this.groupKeyQueues.get(streamId);
    }

    /* eslint-disable @typescript-eslint/no-shadow */
  }, {
    key: "createMessageFactory",
    value: function () {
      var _createMessageFactory = _asyncToGenerator(function* (streamId) {
        return new _MessageFactory.MessageFactory({
          streamId: streamId,
          authentication: this.authentication,
          streamRegistry: this.streamRegistryCached,
          groupKeyQueue: yield this.groupKeyQueues.get(streamId)
        });
      });
      function createMessageFactory(_x6) {
        return _createMessageFactory.apply(this, arguments);
      }
      return createMessageFactory;
    }()
  }]);
  return Publisher;
}()) || _class) || _class) || _class) || _class);
exports.Publisher = Publisher;

/***/ }),

/***/ "./src/publish/messageChain.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createRandomMsgChainId = exports.createMessageRef = void 0;
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var createRandomMsgChainId = function createRandomMsgChainId() {
  return (0, _utils.randomString)(20);
};

/**
 * Generate the next message MessageID for a message chain.
 * Messages with same timestamp get incremented sequence numbers.
 */
exports.createRandomMsgChainId = createRandomMsgChainId;
var createMessageRef = function createMessageRef(timestamp, prevMsgRef) {
  // NOTE: publishing back-dated (i.e. non-sequentially timestamped) messages will 'break' sequencing.
  // i.e. we lose track of biggest sequence number whenever timestamp changes for stream id+partition combo
  // so backdated messages will start at sequence 0 again, regardless of the sequencing of existing messages.
  // storage considers timestamp+sequence number unique, so the newer messages will clobber the older messages
  // Not feasible to keep greatest sequence number for every millisecond timestamp so not sure a good way around this.
  // Possible we should keep a global sequence number
  // The sequence breaking issue above can be "fixed" if we throw an exception for backdated timestamp.
  // In that case we don't publish the message and the backdated timestamp won't be useds as prevMsgRef
  // for a possible subsequent publish request.
  var isBackdated = prevMsgRef !== undefined && timestamp < prevMsgRef.timestamp;
  if (isBackdated) {
    throw new Error('prevMessageRef must come before current');
  }
  var isSameTimestamp = prevMsgRef !== undefined && prevMsgRef.timestamp === timestamp;
  var nextSequenceNumber = isSameTimestamp ? prevMsgRef.sequenceNumber + 1 : 0;
  var createdMessageRef = new _protocol.MessageRef(timestamp, nextSequenceNumber);
  return createdMessageRef;
};
exports.createMessageRef = createMessageRef;

/***/ }),

/***/ "./src/registry/StorageNodeRegistry.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StorageNodeRegistry = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
var _NodeRegistryAbi = _interopRequireDefault(__webpack_require__("./src/ethereumArtifacts/NodeRegistryAbi.json"));
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Config = __webpack_require__("./src/Config.ts");
var _Ethereum = __webpack_require__("./src/Ethereum.ts");
var _HttpUtil = __webpack_require__("./src/HttpUtil.ts");
var _contract = __webpack_require__("./src/utils/contract.ts");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _ContractFactory = __webpack_require__("./src/ContractFactory.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _dec, _dec2, _dec3, _dec4, _dec5, _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Store a mapping of storage node addresses <-> storage node URLs
 */
var StorageNodeRegistry = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 1);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 2);
}, _dec4 = Reflect.metadata("design:type", Function), _dec5 = Reflect.metadata("design:paramtypes", [typeof _ContractFactory.ContractFactory === "undefined" ? Object : _ContractFactory.ContractFactory, typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication, typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = /*#__PURE__*/function () {
  function StorageNodeRegistry(contractFactory, authentication, config) {
    var _this = this;
    _classCallCheck(this, StorageNodeRegistry);
    this.contractFactory = contractFactory;
    this.authentication = authentication;
    this.config = config;
    this.nodeRegistryContractsReadonly = (0, _Ethereum.getStreamRegistryChainProviders)(config).map(function (provider) {
      return _this.contractFactory.createReadContract((0, _utils.toEthereumAddress)(_this.config.contracts.storageNodeRegistryChainAddress), _NodeRegistryAbi.default, provider, 'storageNodeRegistry');
    });
  }
  _createClass(StorageNodeRegistry, [{
    key: "connectToContract",
    value: function () {
      var _connectToContract = _asyncToGenerator(function* () {
        if (!this.nodeRegistryContract) {
          var chainSigner = yield this.authentication.getStreamRegistryChainSigner();
          this.nodeRegistryContract = this.contractFactory.createWriteContract((0, _utils.toEthereumAddress)(this.config.contracts.storageNodeRegistryChainAddress), _NodeRegistryAbi.default, chainSigner, 'storageNodeRegistry');
        }
      });
      function connectToContract() {
        return _connectToContract.apply(this, arguments);
      }
      return connectToContract;
    }()
  }, {
    key: "setStorageNodeMetadata",
    value: function () {
      var _setStorageNodeMetadata = _asyncToGenerator(function* (metadata) {
        yield this.connectToContract();
        var ethersOverrides = (0, _Ethereum.getStreamRegistryOverrides)(this.config);
        if (metadata !== undefined) {
          yield (0, _contract.waitForTx)(this.nodeRegistryContract.createOrUpdateNodeSelf(JSON.stringify(metadata), ethersOverrides));
        } else {
          yield (0, _contract.waitForTx)(this.nodeRegistryContract.removeNodeSelf(ethersOverrides));
        }
      });
      function setStorageNodeMetadata(_x) {
        return _setStorageNodeMetadata.apply(this, arguments);
      }
      return setStorageNodeMetadata;
    }()
  }, {
    key: "getStorageNodeMetadata",
    value: function () {
      var _getStorageNodeMetadata = _asyncToGenerator(function* (nodeAddress) {
        var _yield$queryAllReadon = yield (0, _contract.queryAllReadonlyContracts)(function (contract) {
            return contract.getNode(nodeAddress);
          }, this.nodeRegistryContractsReadonly),
          _yield$queryAllReadon2 = _slicedToArray(_yield$queryAllReadon, 2),
          resultNodeAddress = _yield$queryAllReadon2[0],
          metadata = _yield$queryAllReadon2[1];
        var NODE_NOT_FOUND = '0x0000000000000000000000000000000000000000';
        if (resultNodeAddress !== NODE_NOT_FOUND) {
          return JSON.parse(metadata);
        } else {
          throw new _HttpUtil.NotFoundError('Node not found, id: ' + nodeAddress);
        }
      });
      function getStorageNodeMetadata(_x2) {
        return _getStorageNodeMetadata.apply(this, arguments);
      }
      return getStorageNodeMetadata;
    }()
  }]);
  return StorageNodeRegistry;
}()) || _class) || _class) || _class) || _class) || _class);
exports.StorageNodeRegistry = StorageNodeRegistry;

/***/ }),

/***/ "./src/registry/StreamRegistry.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamRegistry = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _ContractFactory = __webpack_require__("./src/ContractFactory.ts");
var _Ethereum = __webpack_require__("./src/Ethereum.ts");
var _HttpUtil = __webpack_require__("./src/HttpUtil.ts");
var _Stream = __webpack_require__("./src/Stream.ts");
var _StreamIDBuilder = __webpack_require__("./src/StreamIDBuilder.ts");
var _StreamRegistryV4Abi = _interopRequireDefault(__webpack_require__("./src/ethereumArtifacts/StreamRegistryV4Abi.json"));
var _events = __webpack_require__("./src/events.ts");
var _permission = __webpack_require__("./src/permission.ts");
var _GeneratorUtils = __webpack_require__("./src/utils/GeneratorUtils.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _contract = __webpack_require__("./src/utils/contract.ts");
var _promises = __webpack_require__("./src/utils/promises.ts");
var _StreamFactory = __webpack_require__("./src/StreamFactory.ts");
var _StreamRegistryCached = __webpack_require__("./src/registry/StreamRegistryCached.ts");
var _searchStreams2 = __webpack_require__("./src/registry/searchStreams.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _asyncGeneratorDelegate(inner) { var iter = {}, waiting = !1; function pump(key, value) { return waiting = !0, value = new Promise(function (resolve) { resolve(inner[key](value)); }), { done: !1, value: new _OverloadYield(value, 1) }; } return iter["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () { return this; }, iter.next = function (value) { return waiting ? (waiting = !1, value) : pump("next", value); }, "function" == typeof inner.throw && (iter.throw = function (value) { if (waiting) throw waiting = !1, value; return pump("throw", value); }), "function" == typeof inner.return && (iter.return = function (value) { return waiting ? (waiting = !1, value) : pump("return", value); }), iter; }
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
/*
 * On-chain registry of stream metadata and permissions.
 *
 * Does not support system streams (the key exchange stream)
 */

var streamContractErrorProcessor = function streamContractErrorProcessor(err, streamId, registry) {
  var _err$reason;
  if (((_err$reason = err.reason) === null || _err$reason === void 0 ? void 0 : _err$reason.code) === 'CALL_EXCEPTION') {
    throw new _HttpUtil.NotFoundError('Stream not found: id=' + streamId);
  } else {
    throw new Error("Could not reach the ".concat(registry, " Smart Contract: ").concat(err.message));
  }
};
var StreamRegistry = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_LoggerFactory.LoggerFactory)(target, undefined, 1);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_StreamIDBuilder.StreamIDBuilder)(target, undefined, 2);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _StreamRegistryCached.StreamRegistryCached;
  }))(target, undefined, 5);
}, _dec5 = function _dec5(target, key) {
  return (0, _tsyringe.inject)(_events.StreamrClientEventEmitter)(target, undefined, 6);
}, _dec6 = function _dec6(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 7);
}, _dec7 = function _dec7(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 8);
}, _dec8 = Reflect.metadata("design:type", Function), _dec9 = Reflect.metadata("design:paramtypes", [typeof _ContractFactory.ContractFactory === "undefined" ? Object : _ContractFactory.ContractFactory, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof _StreamIDBuilder.StreamIDBuilder === "undefined" ? Object : _StreamIDBuilder.StreamIDBuilder, typeof _StreamFactory.StreamFactory === "undefined" ? Object : _StreamFactory.StreamFactory, typeof _utils.TheGraphClient === "undefined" ? Object : _utils.TheGraphClient, typeof _StreamRegistryCached.StreamRegistryCached === "undefined" ? Object : _StreamRegistryCached.StreamRegistryCached, typeof _events.StreamrClientEventEmitter === "undefined" ? Object : _events.StreamrClientEventEmitter, typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication, typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = _dec8(_class = _dec9(_class = /*#__PURE__*/function () {
  /** @internal */

  /** @internal */
  function StreamRegistry(contractFactory, loggerFactory, streamIdBuilder, streamFactory, theGraphClient, streamRegistryCached, eventEmitter, authentication, config) {
    var _this2 = this;
    _classCallCheck(this, StreamRegistry);
    this.contractFactory = contractFactory;
    this.streamIdBuilder = streamIdBuilder;
    this.streamFactory = streamFactory;
    this.theGraphClient = theGraphClient;
    this.streamRegistryCached = streamRegistryCached;
    this.authentication = authentication;
    this.config = config;
    this.logger = loggerFactory.createLogger(module);
    var chainProviders = (0, _Ethereum.getStreamRegistryChainProviders)(config);
    this.streamRegistryContractsReadonly = chainProviders.map(function (provider) {
      return _this2.contractFactory.createReadContract((0, _utils.toEthereumAddress)(_this2.config.contracts.streamRegistryChainAddress), _StreamRegistryV4Abi.default, provider, 'streamRegistry');
    });
    (0, _contract.initContractEventGateway)({
      sourceName: 'StreamCreated',
      sourceEmitter: this.streamRegistryContractsReadonly[0],
      targetName: 'createStream',
      targetEmitter: eventEmitter,
      transformation: function transformation(streamId, metadata, extra) {
        return {
          streamId: (0, _protocol.toStreamID)(streamId),
          metadata: _Stream.Stream.parseMetadata(metadata),
          blockNumber: extra.blockNumber
        };
      },
      loggerFactory: loggerFactory
    });
  }
  _createClass(StreamRegistry, [{
    key: "parseStream",
    value: function parseStream(id, metadata) {
      var props = _Stream.Stream.parseMetadata(metadata);
      return this.streamFactory.createStream(id, props);
    }
  }, {
    key: "connectToContract",
    value: function () {
      var _connectToContract = _asyncToGenerator(function* () {
        if (!this.streamRegistryContract) {
          var chainSigner = yield this.authentication.getStreamRegistryChainSigner();
          this.streamRegistryContract = this.contractFactory.createWriteContract((0, _utils.toEthereumAddress)(this.config.contracts.streamRegistryChainAddress), _StreamRegistryV4Abi.default, chainSigner, 'streamRegistry');
        }
      });
      function connectToContract() {
        return _connectToContract.apply(this, arguments);
      }
      return connectToContract;
    }()
  }, {
    key: "createStream",
    value: function () {
      var _createStream = _asyncToGenerator(function* (streamId, metadata) {
        var _this3 = this;
        var ethersOverrides = (0, _Ethereum.getStreamRegistryOverrides)(this.config);
        var domainAndPath = _protocol.StreamIDUtils.getDomainAndPath(streamId);
        if (domainAndPath === undefined) {
          throw new Error("stream id \"".concat(streamId, "\" not valid"));
        }
        var _domainAndPath = _slicedToArray(domainAndPath, 2),
          domain = _domainAndPath[0],
          path = _domainAndPath[1];
        yield this.connectToContract();
        if ((0, _utils.isENSName)(domain)) {
          /*
              The call to createStreamWithENS delegates the ENS ownership check, and therefore the
              call doesn't fail e.g. if the user doesn't own the ENS name. To see whether the stream
              creation succeeeds, we need to poll the chain for stream existence. If the polling timeouts, we don't
              know what the actual error was. (Most likely it has nothing to do with timeout
              -> we don't use the error from until(), but throw an explicit error instead.)
          */
          yield (0, _contract.waitForTx)(this.streamRegistryContract.createStreamWithENS(domain, path, JSON.stringify(metadata), ethersOverrides));
          try {
            yield (0, _promises.until)( /*#__PURE__*/_asyncToGenerator(function* () {
              return _this3.streamExistsOnChain(streamId);
            }),
            // eslint-disable-next-line no-underscore-dangle
            this.config._timeouts.ensStreamCreation.timeout,
            // eslint-disable-next-line no-underscore-dangle
            this.config._timeouts.ensStreamCreation.retryInterval);
          } catch (e) {
            throw new Error("unable to create stream \"".concat(streamId, "\""));
          }
        } else {
          yield this.ensureStreamIdInNamespaceOfAuthenticatedUser(domain, streamId);
          yield (0, _contract.waitForTx)(this.streamRegistryContract.createStream(path, JSON.stringify(metadata), ethersOverrides));
        }
        return this.streamFactory.createStream(streamId, metadata);
      });
      function createStream(_x, _x2) {
        return _createStream.apply(this, arguments);
      }
      return createStream;
    }()
  }, {
    key: "ensureStreamIdInNamespaceOfAuthenticatedUser",
    value: function () {
      var _ensureStreamIdInNamespaceOfAuthenticatedUser = _asyncToGenerator(function* (address, streamId) {
        var userAddress = yield this.authentication.getAddress();
        if (address !== userAddress) {
          throw new Error("stream id \"".concat(streamId, "\" not in namespace of authenticated user \"").concat(userAddress, "\""));
        }
      });
      function ensureStreamIdInNamespaceOfAuthenticatedUser(_x3, _x4) {
        return _ensureStreamIdInNamespaceOfAuthenticatedUser.apply(this, arguments);
      }
      return ensureStreamIdInNamespaceOfAuthenticatedUser;
    }() // TODO maybe we should require metadata to be StreamMetadata instead of Partial<StreamMetadata>
    // Most likely the contract doesn't make any merging (like we do in Stream#update)?
  }, {
    key: "updateStream",
    value: function () {
      var _updateStream = _asyncToGenerator(function* (streamId, metadata) {
        yield this.connectToContract();
        var ethersOverrides = (0, _Ethereum.getStreamRegistryOverrides)(this.config);
        yield (0, _contract.waitForTx)(this.streamRegistryContract.updateStreamMetadata(streamId, JSON.stringify(metadata), ethersOverrides));
        return this.streamFactory.createStream(streamId, metadata);
      });
      function updateStream(_x5, _x6) {
        return _updateStream.apply(this, arguments);
      }
      return updateStream;
    }()
  }, {
    key: "deleteStream",
    value: function () {
      var _deleteStream = _asyncToGenerator(function* (streamIdOrPath) {
        var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
        yield this.connectToContract();
        var ethersOverrides = (0, _Ethereum.getStreamRegistryOverrides)(this.config);
        yield (0, _contract.waitForTx)(this.streamRegistryContract.deleteStream(streamId, ethersOverrides));
      });
      function deleteStream(_x7) {
        return _deleteStream.apply(this, arguments);
      }
      return deleteStream;
    }()
  }, {
    key: "streamExistsOnChain",
    value: function () {
      var _streamExistsOnChain = _asyncToGenerator(function* (streamIdOrPath) {
        var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
        this.logger.debug('Check if stream exists on chain', {
          streamId: streamId
        });
        return (0, _contract.queryAllReadonlyContracts)(function (contract) {
          return contract.exists(streamId);
        }, this.streamRegistryContractsReadonly);
      });
      function streamExistsOnChain(_x8) {
        return _streamExistsOnChain.apply(this, arguments);
      }
      return streamExistsOnChain;
    }()
  }, {
    key: "getStream",
    value: function () {
      var _getStream = _asyncToGenerator(function* (streamIdOrPath) {
        var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
        var metadata;
        try {
          metadata = yield (0, _contract.queryAllReadonlyContracts)(function (contract) {
            return contract.getStreamMetadata(streamId);
          }, this.streamRegistryContractsReadonly);
        } catch (err) {
          return streamContractErrorProcessor(err, streamId, 'StreamRegistry');
        }
        return this.parseStream(streamId, metadata);
      });
      function getStream(_x9) {
        return _getStream.apply(this, arguments);
      }
      return getStream;
    }()
  }, {
    key: "searchStreams",
    value: function searchStreams(term, permissionFilter, orderBy) {
      var _this4 = this;
      return (0, _searchStreams2.searchStreams)(term, permissionFilter, orderBy, this.theGraphClient, function (id, metadata) {
        return _this4.parseStream(id, metadata);
      }, this.logger);
    }
  }, {
    key: "getStreamPublishers",
    value: function getStreamPublishers(streamIdOrPath) {
      return this.getStreamPublishersOrSubscribersList(streamIdOrPath, 'publishExpiration');
    }
  }, {
    key: "getStreamSubscribers",
    value: function getStreamSubscribers(streamIdOrPath) {
      return this.getStreamPublishersOrSubscribersList(streamIdOrPath, 'subscribeExpiration');
    }
  }, {
    key: "getStreamPublishersOrSubscribersList",
    value: function getStreamPublishersOrSubscribersList(streamIdOrPath, fieldName) {
      var _this = this;
      return _wrapAsyncGenerator(function* () {
        var streamId = yield _awaitAsyncGenerator(_this.streamIdBuilder.toStreamID(streamIdOrPath));
        var backendResults = _this.theGraphClient.queryEntities(function (lastId, pageSize) {
          return StreamRegistry.buildStreamPublishersOrSubscribersQuery(streamId, fieldName, lastId, pageSize);
        });
        /*
         * There can be orphaned permission entities if a stream is deleted (currently
         * we don't remove the assigned permissions, see ETH-222)
         * TODO remove the filtering when ETH-222 has been implemented, and remove also
         * stream result field in buildStreamPublishersOrSubscribersQuery as it is
         * no longer needed
         */
        var validItems = (0, _GeneratorUtils.filter)(backendResults, function (p) {
          return p.stream !== null;
        });
        yield* _asyncGeneratorDelegate(_asyncIterator((0, _GeneratorUtils.map)(validItems, function (item) {
          return item.userAddress;
        })), _awaitAsyncGenerator);
      })();
    }
  }, {
    key: "hasPermission",
    value: // --------------------------------------------------------------------------------------------
    // Permissions
    // --------------------------------------------------------------------------------------------
    /* eslint-disable no-else-return */
    function () {
      var _hasPermission = _asyncToGenerator(function* (query) {
        var streamId = yield this.streamIdBuilder.toStreamID(query.streamId);
        return (0, _contract.queryAllReadonlyContracts)(function (contract) {
          var permissionType = (0, _permission.streamPermissionToSolidityType)(query.permission);
          if ((0, _permission.isPublicPermissionQuery)(query)) {
            return contract.hasPublicPermission(streamId, permissionType);
          } else if (query.allowPublic) {
            return contract.hasPermission(streamId, (0, _utils.toEthereumAddress)(query.user), permissionType);
          } else {
            return contract.hasDirectPermission(streamId, (0, _utils.toEthereumAddress)(query.user), permissionType);
          }
        }, this.streamRegistryContractsReadonly);
      });
      function hasPermission(_x10) {
        return _hasPermission.apply(this, arguments);
      }
      return hasPermission;
    }()
  }, {
    key: "getPermissions",
    value: function () {
      var _getPermissions = _asyncToGenerator(function* (streamIdOrPath) {
        var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
        var queryResults = yield (0, _utils.collect)(this.theGraphClient.queryEntities(function (lastId, pageSize) {
          var query = "{\n                    stream (id: \"".concat(streamId, "\") {\n                        id\n                        metadata\n                        permissions(first: ").concat(pageSize, " orderBy: \"id\" where: { id_gt: \"").concat(lastId, "\"}) {\n                            id\n                            userAddress\n                            canEdit\n                            canDelete\n                            publishExpiration\n                            subscribeExpiration\n                            canGrant\n                        }\n                    }\n                }");
          return {
            query: query
          };
        }, function (response) {
          if (response.stream !== null) {
            return response.stream.permissions;
          } else {
            throw new _HttpUtil.NotFoundError('stream not found: id: ' + streamId);
          }
        }));
        var assignments = [];
        queryResults.forEach(function (permissionResult) {
          var permissions = (0, _permission.convertChainPermissionsToStreamPermissions)(permissionResult);
          /*
          * There can be query results, which don't contain any permissions. That happens if a
          * user revokes all permissions from a stream. Currently we don't remove these empty assignments
          * from The Graph index. TODO remove the "permission.length > 0" if/when we implement the
          * empty assignments cleanup in The Graph.
          */
          if (permissions.length > 0) {
            if (permissionResult.userAddress === _permission.PUBLIC_PERMISSION_ADDRESS) {
              assignments.push({
                public: true,
                permissions: permissions
              });
            } else {
              assignments.push({
                user: permissionResult.userAddress,
                permissions: permissions
              });
            }
          }
        });
        return assignments;
      });
      function getPermissions(_x11) {
        return _getPermissions.apply(this, arguments);
      }
      return getPermissions;
    }()
  }, {
    key: "grantPermissions",
    value: function () {
      var _grantPermissions = _asyncToGenerator(function* (streamIdOrPath) {
        var _this5 = this;
        for (var _len = arguments.length, assignments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          assignments[_key - 1] = arguments[_key];
        }
        return this.updatePermissions.apply(this, [streamIdOrPath, function (streamId, user, solidityType) {
          return user === undefined ? _this5.streamRegistryContract.grantPublicPermission(streamId, solidityType, (0, _Ethereum.getStreamRegistryOverrides)(_this5.config)) : _this5.streamRegistryContract.grantPermission(streamId, user, solidityType, (0, _Ethereum.getStreamRegistryOverrides)(_this5.config));
        }].concat(assignments));
      });
      function grantPermissions(_x12) {
        return _grantPermissions.apply(this, arguments);
      }
      return grantPermissions;
    }()
  }, {
    key: "revokePermissions",
    value: function () {
      var _revokePermissions = _asyncToGenerator(function* (streamIdOrPath) {
        var _this6 = this;
        for (var _len2 = arguments.length, assignments = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          assignments[_key2 - 1] = arguments[_key2];
        }
        return this.updatePermissions.apply(this, [streamIdOrPath, function (streamId, user, solidityType) {
          return user === undefined ? _this6.streamRegistryContract.revokePublicPermission(streamId, solidityType, (0, _Ethereum.getStreamRegistryOverrides)(_this6.config)) : _this6.streamRegistryContract.revokePermission(streamId, user, solidityType, (0, _Ethereum.getStreamRegistryOverrides)(_this6.config));
        }].concat(assignments));
      });
      function revokePermissions(_x13) {
        return _revokePermissions.apply(this, arguments);
      }
      return revokePermissions;
    }()
  }, {
    key: "updatePermissions",
    value: function () {
      var _updatePermissions = _asyncToGenerator(function* (streamIdOrPath, createTransaction) {
        var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
        this.streamRegistryCached.clearStream(streamId);
        yield this.connectToContract();
        for (var _len3 = arguments.length, assignments = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          assignments[_key3 - 2] = arguments[_key3];
        }
        for (var _i2 = 0, _assignments = assignments; _i2 < _assignments.length; _i2++) {
          var assignment = _assignments[_i2];
          var _iterator = _createForOfIteratorHelper(assignment.permissions),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var permission = _step.value;
              var _solidityType = (0, _permission.streamPermissionToSolidityType)(permission);
              var _user = (0, _permission.isPublicPermissionAssignment)(assignment) ? undefined : (0, _utils.toEthereumAddress)(assignment.user);
              var txToSubmit = createTransaction(streamId, _user, _solidityType);
              // eslint-disable-next-line no-await-in-loop
              yield (0, _contract.waitForTx)(txToSubmit);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      });
      function updatePermissions(_x14, _x15) {
        return _updatePermissions.apply(this, arguments);
      }
      return updatePermissions;
    }()
  }, {
    key: "setPermissions",
    value: function () {
      var _setPermissions = _asyncToGenerator(function* () {
        var streamIds = [];
        var targets = [];
        var chainPermissions = [];
        for (var _len4 = arguments.length, items = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          items[_key4] = arguments[_key4];
        }
        for (var _i3 = 0, _items = items; _i3 < _items.length; _i3++) {
          var item = _items[_i3];
          // eslint-disable-next-line no-await-in-loop
          var streamId = yield this.streamIdBuilder.toStreamID(item.streamId);
          this.streamRegistryCached.clearStream(streamId);
          streamIds.push(streamId);
          targets.push(item.assignments.map(function (assignment) {
            return (0, _permission.isPublicPermissionAssignment)(assignment) ? _permission.PUBLIC_PERMISSION_ADDRESS : assignment.user;
          }));
          chainPermissions.push(item.assignments.map(function (assignment) {
            return (0, _permission.convertStreamPermissionsToChainPermission)(assignment.permissions);
          }));
        }
        yield this.connectToContract();
        var ethersOverrides = (0, _Ethereum.getStreamRegistryOverrides)(this.config);
        var txToSubmit = this.streamRegistryContract.setPermissionsMultipleStreams(streamIds, targets, chainPermissions, ethersOverrides);
        yield (0, _contract.waitForTx)(txToSubmit);
      });
      function setPermissions() {
        return _setPermissions.apply(this, arguments);
      }
      return setPermissions;
    }()
  }, {
    key: "isStreamPublisher",
    value: function () {
      var _isStreamPublisher = _asyncToGenerator(function* (streamIdOrPath, userAddress) {
        var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
        try {
          return yield (0, _contract.queryAllReadonlyContracts)(function (contract) {
            return contract.hasPermission(streamId, userAddress, (0, _permission.streamPermissionToSolidityType)(_permission.StreamPermission.PUBLISH));
          }, this.streamRegistryContractsReadonly);
        } catch (err) {
          return streamContractErrorProcessor(err, streamId, 'StreamPermission');
        }
      });
      function isStreamPublisher(_x16, _x17) {
        return _isStreamPublisher.apply(this, arguments);
      }
      return isStreamPublisher;
    }()
  }, {
    key: "isStreamSubscriber",
    value: function () {
      var _isStreamSubscriber = _asyncToGenerator(function* (streamIdOrPath, userAddress) {
        var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
        try {
          return yield (0, _contract.queryAllReadonlyContracts)(function (contract) {
            return contract.hasPermission(streamId, userAddress, (0, _permission.streamPermissionToSolidityType)(_permission.StreamPermission.SUBSCRIBE));
          }, this.streamRegistryContractsReadonly);
        } catch (err) {
          return streamContractErrorProcessor(err, streamId, 'StreamPermission');
        }
      });
      function isStreamSubscriber(_x18, _x19) {
        return _isStreamSubscriber.apply(this, arguments);
      }
      return isStreamSubscriber;
    }()
  }], [{
    key: "buildStreamPublishersOrSubscribersQuery",
    value: function buildStreamPublishersOrSubscribersQuery(streamId, fieldName, lastId, pageSize) {
      var query = "\n        {\n            permissions (\n                first: ".concat(pageSize, "\n                orderBy: \"id\"\n                where: {\n                    id_gt: \"").concat(lastId, "\"\n                    stream: \"").concat(streamId, "\"\n                    ").concat(fieldName, "_gt: \"").concat(Math.round(Date.now() / 1000), "\"\n                }\n            ) {\n                id\n                userAddress\n                stream {\n                    id\n                }\n            }\n        }");
      return {
        query: query
      };
    }
  }]);
  return StreamRegistry;
}()) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
exports.StreamRegistry = StreamRegistry;

/***/ }),

/***/ "./src/registry/StreamRegistryCached.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamRegistryCached = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.starts-with.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _caches = __webpack_require__("./src/utils/caches.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _StreamRegistry = __webpack_require__("./src/registry/StreamRegistry.ts");
var _permission = __webpack_require__("./src/permission.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SEPARATOR = '|'; // always use SEPARATOR for cache key

/* eslint-disable no-underscore-dangle */
var StreamRegistryCached = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_LoggerFactory.LoggerFactory)(target, undefined, 0);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _StreamRegistry.StreamRegistry;
  }))(target, undefined, 1);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 2);
}, _dec5 = Reflect.metadata("design:type", Function), _dec6 = Reflect.metadata("design:paramtypes", [typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof _StreamRegistry.StreamRegistry === "undefined" ? Object : _StreamRegistry.StreamRegistry, typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = /*#__PURE__*/function () {
  function StreamRegistryCached(loggerFactory, streamRegistry, config) {
    var _this = this;
    _classCallCheck(this, StreamRegistryCached);
    this.streamRegistry = streamRegistry;
    this.logger = loggerFactory.createLogger(module);
    this._getStream = (0, _caches.CacheAsyncFn)(function (streamId) {
      return _this.streamRegistry.getStream(streamId);
    }, _objectSpread(_objectSpread({}, config.cache), {}, {
      cacheKey: function cacheKey(_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          streamId = _ref2[0];
        // see clearStream
        return "".concat(streamId).concat(SEPARATOR);
      }
    }));
    this._isStreamPublisher = (0, _caches.CacheAsyncFn)(function (streamId, ethAddress) {
      return _this.streamRegistry.isStreamPublisher(streamId, ethAddress);
    }, _objectSpread(_objectSpread({}, config.cache), {}, {
      cacheKey: function cacheKey(_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          streamId = _ref4[0],
          ethAddress = _ref4[1];
        return [streamId, ethAddress].join(SEPARATOR);
      }
    }));
    this._isStreamSubscriber = (0, _caches.CacheAsyncFn)(function (streamId, ethAddress) {
      return _this.streamRegistry.isStreamSubscriber(streamId, ethAddress);
    }, _objectSpread(_objectSpread({}, config.cache), {}, {
      cacheKey: function cacheKey(_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          streamId = _ref6[0],
          ethAddress = _ref6[1];
        return [streamId, ethAddress].join(SEPARATOR);
      }
    }));
    this._isPublic = (0, _caches.CacheAsyncFn)(function (streamId) {
      return _this.streamRegistry.hasPermission({
        streamId: streamId,
        public: true,
        permission: _permission.StreamPermission.SUBSCRIBE
      });
    }, _objectSpread(_objectSpread({}, config.cache), {}, {
      cacheKey: function cacheKey(_ref7) {
        var _ref8 = _slicedToArray(_ref7, 1),
          streamId = _ref8[0];
        return ['PublicSubscribe', streamId].join(SEPARATOR);
      }
    }));
  }
  _createClass(StreamRegistryCached, [{
    key: "getStream",
    value: function getStream(streamId) {
      return this._getStream(streamId);
    }
  }, {
    key: "isStreamPublisher",
    value: function isStreamPublisher(streamId, ethAddress) {
      return this._isStreamPublisher(streamId, ethAddress);
    }
  }, {
    key: "isStreamSubscriber",
    value: function isStreamSubscriber(streamId, ethAddress) {
      return this._isStreamSubscriber(streamId, ethAddress);
    }
  }, {
    key: "isPublic",
    value: function isPublic(streamId) {
      return this._isPublic(streamId);
    }

    /**
     * Clear cache for streamId
     */
  }, {
    key: "clearStream",
    value: function clearStream(streamId) {
      this.logger.debug('Clear caches matching stream', {
        streamId: streamId
      });
      // include separator so startsWith(streamid) doesn't match streamid-something
      var target = "".concat(streamId).concat(SEPARATOR);
      var matchTarget = function matchTarget(s) {
        return s.startsWith(target);
      };
      this._getStream.clearMatching(matchTarget);
      this._isStreamPublisher.clearMatching(matchTarget);
      this._isStreamSubscriber.clearMatching(matchTarget);
    }
  }]);
  return StreamRegistryCached;
}()) || _class) || _class) || _class) || _class) || _class) || _class);
exports.StreamRegistryCached = StreamRegistryCached;

/***/ }),

/***/ "./src/registry/StreamStorageRegistry.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamStorageRegistry = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _min = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/min.js"));
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Authentication = __webpack_require__("./src/Authentication.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _ContractFactory = __webpack_require__("./src/ContractFactory.ts");
var _Ethereum = __webpack_require__("./src/Ethereum.ts");
var _Stream = __webpack_require__("./src/Stream.ts");
var _StreamFactory = __webpack_require__("./src/StreamFactory.ts");
var _StreamIDBuilder = __webpack_require__("./src/StreamIDBuilder.ts");
var _StreamStorageRegistryV2Abi = _interopRequireDefault(__webpack_require__("./src/ethereumArtifacts/StreamStorageRegistryV2Abi.json"));
var _events = __webpack_require__("./src/events.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _contract = __webpack_require__("./src/utils/contract.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Stores storage node assignments (mapping of streamIds <-> storage nodes addresses)
 */
var StreamStorageRegistry = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _StreamFactory.StreamFactory;
  }))(target, undefined, 1);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_StreamIDBuilder.StreamIDBuilder)(target, undefined, 2);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)(_events.StreamrClientEventEmitter)(target, undefined, 4);
}, _dec5 = function _dec5(target, key) {
  return (0, _tsyringe.inject)(_Authentication.AuthenticationInjectionToken)(target, undefined, 5);
}, _dec6 = function _dec6(target, key) {
  return (0, _tsyringe.inject)(_LoggerFactory.LoggerFactory)(target, undefined, 6);
}, _dec7 = function _dec7(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 7);
}, _dec8 = Reflect.metadata("design:type", Function), _dec9 = Reflect.metadata("design:paramtypes", [typeof _ContractFactory.ContractFactory === "undefined" ? Object : _ContractFactory.ContractFactory, typeof _StreamFactory.StreamFactory === "undefined" ? Object : _StreamFactory.StreamFactory, typeof _StreamIDBuilder.StreamIDBuilder === "undefined" ? Object : _StreamIDBuilder.StreamIDBuilder, typeof _utils.TheGraphClient === "undefined" ? Object : _utils.TheGraphClient, typeof _events.StreamrClientEventEmitter === "undefined" ? Object : _events.StreamrClientEventEmitter, typeof _Authentication.Authentication === "undefined" ? Object : _Authentication.Authentication, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = _dec7(_class = _dec8(_class = _dec9(_class = /*#__PURE__*/function () {
  function StreamStorageRegistry(contractFactory, streamFactory, streamIdBuilder, theGraphClient, eventEmitter, authentication, loggerFactory, config) {
    var _this = this;
    _classCallCheck(this, StreamStorageRegistry);
    this.contractFactory = contractFactory;
    this.streamFactory = streamFactory;
    this.streamIdBuilder = streamIdBuilder;
    this.theGraphClient = theGraphClient;
    this.authentication = authentication;
    this.config = config;
    this.logger = loggerFactory.createLogger(module);
    this.streamStorageRegistryContractsReadonly = (0, _Ethereum.getStreamRegistryChainProviders)(config).map(function (provider) {
      return _this.contractFactory.createReadContract((0, _utils.toEthereumAddress)(_this.config.contracts.streamStorageRegistryChainAddress), _StreamStorageRegistryV2Abi.default, provider, 'streamStorageRegistry');
    });
    this.initStreamAssignmentEventListeners(eventEmitter, loggerFactory);
  }
  _createClass(StreamStorageRegistry, [{
    key: "initStreamAssignmentEventListeners",
    value: function initStreamAssignmentEventListeners(eventEmitter, loggerFactory) {
      var primaryReadonlyContract = this.streamStorageRegistryContractsReadonly[0];
      var transformation = function transformation(streamId, nodeAddress, extra) {
        return {
          streamId: (0, _protocol.toStreamID)(streamId),
          nodeAddress: (0, _utils.toEthereumAddress)(nodeAddress),
          blockNumber: extra.blockNumber
        };
      };
      (0, _contract.initContractEventGateway)({
        sourceName: 'Added',
        sourceEmitter: primaryReadonlyContract,
        targetName: 'addToStorageNode',
        targetEmitter: eventEmitter,
        transformation: transformation,
        loggerFactory: loggerFactory
      });
      (0, _contract.initContractEventGateway)({
        sourceName: 'Removed',
        sourceEmitter: primaryReadonlyContract,
        targetName: 'removeFromStorageNode',
        targetEmitter: eventEmitter,
        transformation: transformation,
        loggerFactory: loggerFactory
      });
    }
  }, {
    key: "connectToContract",
    value: function () {
      var _connectToContract = _asyncToGenerator(function* () {
        if (!this.streamStorageRegistryContract) {
          var chainSigner = yield this.authentication.getStreamRegistryChainSigner();
          this.streamStorageRegistryContract = this.contractFactory.createWriteContract((0, _utils.toEthereumAddress)(this.config.contracts.streamStorageRegistryChainAddress), _StreamStorageRegistryV2Abi.default, chainSigner, 'streamStorageRegistry');
        }
      });
      function connectToContract() {
        return _connectToContract.apply(this, arguments);
      }
      return connectToContract;
    }()
  }, {
    key: "addStreamToStorageNode",
    value: function () {
      var _addStreamToStorageNode = _asyncToGenerator(function* (streamIdOrPath, nodeAddress) {
        var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
        this.logger.debug('Add stream to storage node', {
          streamId: streamId,
          nodeAddress: nodeAddress
        });
        yield this.connectToContract();
        var ethersOverrides = (0, _Ethereum.getStreamRegistryOverrides)(this.config);
        yield (0, _contract.waitForTx)(this.streamStorageRegistryContract.addStorageNode(streamId, nodeAddress, ethersOverrides));
      });
      function addStreamToStorageNode(_x, _x2) {
        return _addStreamToStorageNode.apply(this, arguments);
      }
      return addStreamToStorageNode;
    }()
  }, {
    key: "removeStreamFromStorageNode",
    value: function () {
      var _removeStreamFromStorageNode = _asyncToGenerator(function* (streamIdOrPath, nodeAddress) {
        var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
        this.logger.debug('Remove stream from storage node', {
          streamId: streamId,
          nodeAddress: nodeAddress
        });
        yield this.connectToContract();
        var ethersOverrides = (0, _Ethereum.getStreamRegistryOverrides)(this.config);
        yield (0, _contract.waitForTx)(this.streamStorageRegistryContract.removeStorageNode(streamId, nodeAddress, ethersOverrides));
      });
      function removeStreamFromStorageNode(_x3, _x4) {
        return _removeStreamFromStorageNode.apply(this, arguments);
      }
      return removeStreamFromStorageNode;
    }()
  }, {
    key: "isStoredStream",
    value: function () {
      var _isStoredStream = _asyncToGenerator(function* (streamIdOrPath, nodeAddress) {
        var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
        this.logger.debug('Check if stream is stored in storage node', {
          streamId: streamId,
          nodeAddress: nodeAddress
        });
        return (0, _contract.queryAllReadonlyContracts)(function (contract) {
          return contract.isStorageNodeOf(streamId, nodeAddress);
        }, this.streamStorageRegistryContractsReadonly);
      });
      function isStoredStream(_x5, _x6) {
        return _isStoredStream.apply(this, arguments);
      }
      return isStoredStream;
    }()
  }, {
    key: "getStoredStreams",
    value: function () {
      var _getStoredStreams = _asyncToGenerator(function* (nodeAddress) {
        var _this2 = this;
        this.logger.debug('Get stored streams of storage node', {
          nodeAddress: nodeAddress
        });
        var blockNumbers = [];
        var res = yield (0, _utils.collect)(this.theGraphClient.queryEntities(function (lastId, pageSize) {
          var query = "{\n                    node (id: \"".concat(nodeAddress, "\") {\n                        id\n                        metadata\n                        lastSeen\n                        storedStreams (first: ").concat(pageSize, " orderBy: \"id\" where: { id_gt: \"").concat(lastId, "\"}) {\n                            id,\n                            metadata\n                        }\n                    }\n                    _meta {\n                        block {\n                            number\n                        }\n                    }\n                }");
          return {
            query: query
          };
        }, function (response) {
          // eslint-disable-next-line no-underscore-dangle
          blockNumbers.push(response._meta.block.number);
          return response.node !== null ? response.node.storedStreams : [];
        }));
        var streams = res.map(function (stream) {
          var props = _Stream.Stream.parseMetadata(stream.metadata);
          return _this2.streamFactory.createStream((0, _protocol.toStreamID)(stream.id), props); // toStreamID() not strictly necessary
        });

        return {
          streams: streams,
          blockNumber: (0, _min.default)(blockNumbers)
        };
      });
      function getStoredStreams(_x7) {
        return _getStoredStreams.apply(this, arguments);
      }
      return getStoredStreams;
    }()
  }, {
    key: "getStorageNodes",
    value: function () {
      var _getStorageNodes = _asyncToGenerator(function* (streamIdOrPath) {
        var queryResults;
        if (streamIdOrPath !== undefined) {
          var streamId = yield this.streamIdBuilder.toStreamID(streamIdOrPath);
          this.logger.debug('Get storage nodes of stream', {
            streamId: streamId
          });
          queryResults = yield (0, _utils.collect)(this.theGraphClient.queryEntities(function (lastId, pageSize) {
            var query = "{\n                        stream (id: \"".concat(streamId, "\") {\n                            id\n                            metadata\n                            storageNodes (first: ").concat(pageSize, " orderBy: \"id\" where: { id_gt: \"").concat(lastId, "\"}) {\n                                id\n                                metadata\n                                lastSeen\n                            }\n                        }\n                    }");
            return {
              query: query
            };
          }, function (response) {
            return response.stream !== null ? response.stream.storageNodes : [];
          }));
        } else {
          this.logger.debug('Get all storage nodes');
          queryResults = yield (0, _utils.collect)(this.theGraphClient.queryEntities(function (lastId, pageSize) {
            var query = "{\n                        nodes (first: ".concat(pageSize, " orderBy: \"id\" where: { id_gt: \"").concat(lastId, "\"}) {\n                            id\n                            metadata\n                            lastSeen\n                        }\n                    }");
            return {
              query: query
            };
          }));
        }
        return queryResults.map(function (node) {
          return (0, _utils.toEthereumAddress)(node.id);
        });
      });
      function getStorageNodes(_x8) {
        return _getStorageNodes.apply(this, arguments);
      }
      return getStorageNodes;
    }()
  }]);
  return StreamStorageRegistry;
}()) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class) || _class);
exports.StreamStorageRegistry = StreamStorageRegistry;

/***/ }),

/***/ "./src/registry/searchStreams.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.searchStreams = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.some.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _permission = __webpack_require__("./src/permission.ts");
var _GeneratorUtils = __webpack_require__("./src/utils/GeneratorUtils.ts");
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _asyncGeneratorDelegate(inner) { var iter = {}, waiting = !1; function pump(key, value) { return waiting = !0, value = new Promise(function (resolve) { resolve(inner[key](value)); }), { done: !1, value: new _OverloadYield(value, 1) }; } return iter["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () { return this; }, iter.next = function (value) { return waiting ? (waiting = !1, value) : pump("next", value); }, "function" == typeof inner.throw && (iter.throw = function (value) { if (waiting) throw waiting = !1, value; return pump("throw", value); }), "function" == typeof inner.return && (iter.return = function (value) { return waiting ? (waiting = !1, value) : pump("return", value); }), iter; }
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); } /* eslint-disable padding-line-between-statements */
var searchStreams = function searchStreams(term, permissionFilter, orderBy, theGraphClient, parseStream, logger) {
  if (term === undefined && permissionFilter === undefined) {
    throw new Error('Requires a search term or a permission filter');
  }
  logger.debug('Search for streams', {
    term: term,
    permissionFilter: permissionFilter
  });
  return (0, _GeneratorUtils.map)(fetchSearchStreamsResultFromTheGraph(term, permissionFilter, orderBy, theGraphClient), function (item) {
    return parseStream((0, _protocol.toStreamID)(item.stream.id), item.stream.metadata);
  }, function (err, item) {
    logger.debug('Omit stream from search result (invalid data)', {
      streamId: item.stream.id,
      reason: err === null || err === void 0 ? void 0 : err.message
    });
  });
};
exports.searchStreams = searchStreams;
function fetchSearchStreamsResultFromTheGraph(_x, _x2, _x3, _x4) {
  return _fetchSearchStreamsResultFromTheGraph.apply(this, arguments);
}
/*
 * Note that we query the results via permissions entity even if there is no permission filter
 * defined. It is maybe possible to optimize the non-permission related queries by searching over
 * the Stream entity. To support that we'd need to add a new field to The Graph (e.g. "idAsString"),
 * as we can't do substring filtering by Stream id field (there is no "id_contains" because
 * ID type is not a string)
 */
function _fetchSearchStreamsResultFromTheGraph() {
  _fetchSearchStreamsResultFromTheGraph = _wrapAsyncGenerator(function* (term, permissionFilter, orderBy, theGraphClient) {
    var backendResults = theGraphClient.queryEntities(function (lastId, pageSize) {
      return buildQuery(term, permissionFilter, orderBy, lastId, pageSize);
    });
    /*
     * There can be orphaned permission entities if a stream is deleted (currently
     * we don't remove the assigned permissions, see ETH-222)
     * TODO remove the filtering when ETH-222 has been implemented
     */
    var withoutOrphaned = (0, _GeneratorUtils.filter)(backendResults, function (p) {
      return p.stream !== null;
    });
    /*
     * As we query via permissions entity, any stream can appear multiple times (once per
     * permission user) if we don't do have exactly one userAddress in the GraphQL query.
     * That is the case if no permission filter is defined at all, or if permission.allowPublic
     * is true (then it appears twice: once for the user, and once for the public address).
     */
    var withoutDuplicates = (0, _GeneratorUtils.unique)(withoutOrphaned, function (p) {
      return p.stream.id;
    });
    if (permissionFilter !== undefined) {
      var _permissionFilter$any;
      /*
       * There are situations where the The Graph may contain empty assignments (all boolean flags false,
       * and all expirations in the past). E.g.:
       * - if we granted some permissions to a user, but then removed all those permissions
       * - if we granted an expirable permission (subscribe or publish), and it has now expired
       * We don't want to return empty assignments to the user, because from user's perspective those are
       * non-existing assignments.
       * -> Here we filter out the empty assignments by defining a fallback value for anyOf filter
       */
      var anyOf = (_permissionFilter$any = permissionFilter.anyOf) !== null && _permissionFilter$any !== void 0 ? _permissionFilter$any : Object.values(_permission.StreamPermission);
      yield* _asyncGeneratorDelegate(_asyncIterator((0, _GeneratorUtils.filter)(withoutDuplicates, function (item) {
        var actual = (0, _permission.convertChainPermissionsToStreamPermissions)(item);
        return anyOf.some(function (p) {
          return actual.includes(p);
        });
      })), _awaitAsyncGenerator);
    } else {
      yield* _asyncGeneratorDelegate(_asyncIterator(withoutDuplicates), _awaitAsyncGenerator);
    }
  });
  return _fetchSearchStreamsResultFromTheGraph.apply(this, arguments);
}
var buildQuery = function buildQuery(term, permissionFilter, orderBy, lastId, pageSize) {
  var variables = {
    stream_contains: term,
    id_gt: lastId
  };
  if (permissionFilter !== undefined) {
    variables.userAddress_in = [(0, _utils.toEthereumAddress)(permissionFilter.user)];
    if (permissionFilter.allowPublic) {
      variables.userAddress_in.push(_permission.PUBLIC_PERMISSION_ADDRESS);
    }
    if (permissionFilter.allOf !== undefined) {
      var now = String(Math.round(Date.now() / 1000));
      variables.canEdit = permissionFilter.allOf.includes(_permission.StreamPermission.EDIT) ? true : undefined;
      variables.canDelete = permissionFilter.allOf.includes(_permission.StreamPermission.DELETE) ? true : undefined;
      variables.publishExpiration_gt = permissionFilter.allOf.includes(_permission.StreamPermission.PUBLISH) ? now : undefined;
      variables.subscribeExpiration_gt = permissionFilter.allOf.includes(_permission.StreamPermission.SUBSCRIBE) ? now : undefined;
      variables.canGrant = permissionFilter.allOf.includes(_permission.StreamPermission.GRANT) ? true : undefined;
    }
  }
  var query = "\n        query (\n            $stream_contains: String,\n            $userAddress_in: [Bytes!]\n            $canEdit: Boolean\n            $canDelete: Boolean\n            $publishExpiration_gt: BigInt\n            $subscribeExpiration_gt: BigInt\n            $canGrant: Boolean\n            $id_gt: String\n        ) {\n            permissions (\n                first: ".concat(pageSize, ",\n                orderBy: \"stream__").concat(orderBy.field, "\",\n                orderDirection: \"").concat(orderBy.direction, "\", \n                ").concat(_utils.TheGraphClient.createWhereClause(variables), "\n            ) {\n                id\n                stream {\n                    id\n                    metadata\n                }\n                userAddress\n                canEdit\n                canDelete\n                publishExpiration\n                subscribeExpiration\n                canGrant\n            }\n        }");
  return {
    query: query,
    variables: variables
  };
};

/***/ }),

/***/ "./src/registry/trackerRegistry.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-map.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getTrackers = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var _contracts = __webpack_require__("../../node_modules/@ethersproject/contracts/lib.esm/index.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _Ethereum = __webpack_require__("./src/Ethereum.ts");
var trackerRegistryConfig = _interopRequireWildcard(__webpack_require__("./src/ethereumArtifacts/TrackerRegistry.json"));
var _promises = __webpack_require__("./src/utils/promises.ts");
var _shuffle = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/shuffle.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function fetchTrackers(_x, _x2) {
  return _fetchTrackers.apply(this, arguments);
}
function _fetchTrackers() {
  _fetchTrackers = _asyncToGenerator(function* (contractAddress, jsonRpcProvider) {
    // check that provider is connected and has some valid blockNumber
    yield jsonRpcProvider.getBlockNumber();
    var contract = new _contracts.Contract(contractAddress, trackerRegistryConfig.abi, jsonRpcProvider);
    // check that contract is connected
    yield contract.addressPromise;
    if (typeof contract.getNodes !== 'function') {
      throw Error("getNodes function is not defined in smart contract (".concat(contractAddress, ")"));
    }
    return contract.getNodes();
  });
  return _fetchTrackers.apply(this, arguments);
}
function getTrackerRegistryFromContract(_x3, _x4) {
  return _getTrackerRegistryFromContract.apply(this, arguments);
}
function _getTrackerRegistryFromContract() {
  _getTrackerRegistryFromContract = _asyncToGenerator(function* (contractAddress, rpcProvider) {
    var trackers = yield fetchTrackers(contractAddress, rpcProvider);
    var records = [];
    for (var i = 0; i < trackers.length; ++i) {
      var _trackers$i = trackers[i],
        metadata = _trackers$i.metadata,
        url = _trackers$i.url,
        nodeAddress = _trackers$i.nodeAddress;
      try {
        // The field is tracker.metadata in newer contracts and tracker.url in old contracts.
        // It's safe to clean up tracker.url when no such contract is used anymore.
        var urls = JSON.parse(metadata || url);
        records.push(_objectSpread({
          id: nodeAddress
        }, urls));
      } catch (e) {
        throw new Error("Element trackers[".concat(i, "] not parsable as object: ").concat(trackers[i]));
      }
    }
    return (0, _protocol.createTrackerRegistry)(records);
  });
  return _getTrackerRegistryFromContract.apply(this, arguments);
}
var getTrackers = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (config) {
    return 'contractAddress' in config.network.trackers ? (0, _promises.tryInSequence)((0, _shuffle.default)((0, _Ethereum.getMainnetProviders)(config)).map(function (provider) {
      return /*#__PURE__*/_asyncToGenerator(function* () {
        var address = (0, _utils.toEthereumAddress)(config.network.trackers.contractAddress);
        var registry = yield getTrackerRegistryFromContract(address, provider);
        return registry.getAllTrackers();
      });
    })) : config.network.trackers;
  });
  return function getTrackers(_x5) {
    return _ref.apply(this, arguments);
  };
}();
exports.getTrackers = getTrackers;

/***/ }),

/***/ "./src/shim/node-fetch.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
// In browsers, the node-fetch package is replaced with this to use native fetch
var _default = typeof window !== 'undefined' && typeof window.fetch !== 'undefined' && window.fetch.bind(window) || typeof fetch !== 'undefined' && fetch || undefined;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ "./src/subscribe/MessageStream.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MessageStream = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
var _PushPipeline = __webpack_require__("./src/utils/PushPipeline.ts");
var _Message = __webpack_require__("./src/Message.ts");
var _omit = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/omit.js"));
var _Symbol$asyncIterator;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Wrapper around PushPipeline specific to StreamMessages.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Subscriptions are MessageStreams.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Not all MessageStreams are Subscriptions.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */
_Symbol$asyncIterator = Symbol.asyncIterator;
/**
 * Provides asynchronous iteration with
 * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for-await...of | for await .. of}.
 */
var MessageStream = /*#__PURE__*/function () {
  /** @internal */
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  function MessageStream() {
    _classCallCheck(this, MessageStream);
    _defineProperty(this, "pipeline", new _PushPipeline.PushPipeline());
    /*
     * The methods below are used to control or observe the pipeline.
     * TODO We should refactor the pipeline handling so that a MessageStream producer
     * (e.g. SubscriptionSession or Resends) creates a PushPipeline (or similar) data structure,
     * and calls these methods for that pipeline. Here in MessageStream we'd see the object
     * as Pipeline interface. Ideally here in MessageStream we'd use the pipeline only to get
     * an async iterator when [Symbol.asyncIterator]() is called for this MessageStream.
     * When the we have done the refactoring, all/most other methods below could be removed.
     */
    /** @internal */
    _defineProperty(this, "onFinally", this.pipeline.onFinally);
    /** @internal */
    _defineProperty(this, "onBeforeFinally", this.pipeline.onBeforeFinally);
    /** @internal */
    _defineProperty(this, "onError", this.pipeline.onError);
    /** @internal */
    _defineProperty(this, "onMessage", this.pipeline.onMessage);
  }

  /**
   * Attach a legacy onMessage handler and consume if necessary.
   * onMessage is passed parsed content as first arument, and streamMessage as second argument.
   * @internal
   */
  _createClass(MessageStream, [{
    key: "useLegacyOnMessageHandler",
    value: function useLegacyOnMessageHandler(onMessage) {
      this.pipeline.onMessage.listen( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (streamMessage) {
          var msg = (0, _Message.convertStreamMessageToMessage)(streamMessage);
          yield onMessage(msg.content, (0, _omit.default)(msg, 'content'));
        });
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      this.pipeline.flow();
      return this;
    }

    /** @internal */
  }, {
    key: "getStreamMessages",
    value: function getStreamMessages() {
      return this.pipeline;
    }
  }, {
    key: _Symbol$asyncIterator,
    value: function value() {
      var _this = this;
      return _wrapAsyncGenerator(function* () {
        var _iteratorAbruptCompletion = false;
        var _didIteratorError = false;
        var _iteratorError;
        try {
          for (var _iterator = _asyncIterator(_this.pipeline), _step; _iteratorAbruptCompletion = !(_step = yield _awaitAsyncGenerator(_iterator.next())).done; _iteratorAbruptCompletion = false) {
            var msg = _step.value;
            {
              yield (0, _Message.convertStreamMessageToMessage)(msg);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (_iteratorAbruptCompletion && _iterator.return != null) {
              yield _awaitAsyncGenerator(_iterator.return());
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      })();
    }
  }, {
    key: "flow",
    value: /** @internal */
    function flow() {
      this.pipeline.flow();
    }

    /** @internal */
  }, {
    key: "push",
    value: function () {
      var _push = _asyncToGenerator(function* (item) {
        yield this.pipeline.push(item);
      });
      function push(_x2) {
        return _push.apply(this, arguments);
      }
      return push;
    }() /** @internal */
  }, {
    key: "pipe",
    value: function pipe(fn) {
      return this.pipeline.pipe(fn);
    }

    /** @internal */
  }, {
    key: "forEach",
    value: function forEach(fn) {
      return this.pipeline.forEach(fn);
    }

    /** @internal */
  }, {
    key: "pull",
    value: function () {
      var _pull = _asyncToGenerator(function* (source) {
        return this.pipeline.pull(source);
      });
      function pull(_x3) {
        return _pull.apply(this, arguments);
      }
      return pull;
    }() /** @internal */
  }, {
    key: "handleError",
    value: function () {
      var _handleError = _asyncToGenerator(function* (err) {
        yield this.pipeline.handleError(err);
      });
      function handleError(_x4) {
        return _handleError.apply(this, arguments);
      }
      return handleError;
    }() /** @internal */
  }, {
    key: "end",
    value: function end(err) {
      this.pipeline.end(err);
    }

    /** @internal */
  }, {
    key: "endWrite",
    value: function endWrite(err) {
      this.pipeline.endWrite(err);
    }

    /** @internal */
  }, {
    key: "isDone",
    value: function isDone() {
      return this.pipeline.isDone();
    }

    /** @internal */
  }, {
    key: "return",
    value: function _return() {
      return this.pipeline.return();
    }

    // used only in tests
    /** @internal */
  }, {
    key: "throw",
    value: function _throw(err) {
      return this.pipeline.throw(err);
    }
  }]);
  return MessageStream;
}();
exports.MessageStream = MessageStream;

/***/ }),

/***/ "./src/subscribe/MsgChainUtil.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MsgChainUtil = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _PushBuffer = __webpack_require__("./src/utils/PushBuffer.ts");
var _Symbol$asyncIterator;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MsgChainProcessor = /*#__PURE__*/function () {
  function MsgChainProcessor(outputBuffer, processMessageFn, onError) {
    _classCallCheck(this, MsgChainProcessor);
    _defineProperty(this, "busy", new _utils.Gate(true));
    _defineProperty(this, "inputBuffer", []);
    this.outputBuffer = outputBuffer;
    this.processMessageFn = processMessageFn;
    this.onError = onError;
  }
  _createClass(MsgChainProcessor, [{
    key: "addMessage",
    value: function () {
      var _addMessage = _asyncToGenerator(function* (message) {
        this.inputBuffer.push(message);
        if (this.busy.isOpen()) {
          this.busy.close();
          while (this.inputBuffer.length > 0) {
            var nextMessage = this.inputBuffer.shift();
            try {
              var processedMessage = yield this.processMessageFn(nextMessage);
              this.outputBuffer.push(processedMessage);
            } catch (e) {
              this.onError.trigger(e);
            }
          }
          this.busy.open();
        }
      });
      function addMessage(_x) {
        return _addMessage.apply(this, arguments);
      }
      return addMessage;
    }()
  }]);
  return MsgChainProcessor;
}();
_Symbol$asyncIterator = Symbol.asyncIterator;
var MsgChainUtil = /*#__PURE__*/function () {
  function MsgChainUtil(processMessageFn, onError) {
    _classCallCheck(this, MsgChainUtil);
    _defineProperty(this, "outputBuffer", new _PushBuffer.PushBuffer());
    _defineProperty(this, "processors", new Map());
    this.processMessageFn = processMessageFn;
    this.onError = onError;
  }
  _createClass(MsgChainUtil, [{
    key: "addMessage",
    value: function addMessage(message) {
      var id = "".concat(message.getPublisherId(), "-").concat(message.getMsgChainId());
      var processor = this.processors.get(id);
      if (processor === undefined) {
        processor = new MsgChainProcessor(this.outputBuffer, this.processMessageFn, this.onError);
        this.processors.set(id, processor);
      }
      processor.addMessage(message); // add a task, but don't wait for it to complete
    }
  }, {
    key: "flush",
    value: function () {
      var _flush = _asyncToGenerator(function* () {
        yield Promise.all(Array.from(this.processors.values()).map(function (p) {
          return p.busy.waitUntilOpen();
        }));
      });
      function flush() {
        return _flush.apply(this, arguments);
      }
      return flush;
    }()
  }, {
    key: "stop",
    value: function stop() {
      this.outputBuffer.endWrite();
    }
  }, {
    key: _Symbol$asyncIterator,
    value: function value() {
      return this.outputBuffer;
    }
  }]);
  return MsgChainUtil;
}();
exports.MsgChainUtil = MsgChainUtil;

/***/ }),

/***/ "./src/subscribe/OrderMessages.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.OrderMessages = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
var _PushBuffer = __webpack_require__("./src/utils/PushBuffer.ts");
var _OrderingUtil = _interopRequireDefault(__webpack_require__("./src/subscribe/ordering/OrderingUtil.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _asyncGeneratorDelegate(inner) { var iter = {}, waiting = !1; function pump(key, value) { return waiting = !0, value = new Promise(function (resolve) { resolve(inner[key](value)); }), { done: !1, value: new _OverloadYield(value, 1) }; } return iter["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () { return this; }, iter.next = function (value) { return waiting ? (waiting = !1, value) : pump("next", value); }, "function" == typeof inner.throw && (iter.throw = function (value) { if (waiting) throw waiting = !1, value; return pump("throw", value); }), "function" == typeof inner.return && (iter.return = function (value) { return waiting ? (waiting = !1, value) : pump("return", value); }), iter; }
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Makes OrderingUtil more compatible with use in pipeline.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */
/**
 * Wraps OrderingUtil into a PushBuffer.
 * Implements gap filling
 */
var OrderMessages = /*#__PURE__*/function () {
  function OrderMessages(config, resends, streamPartId, loggerFactory) {
    var _this = this;
    _classCallCheck(this, OrderMessages);
    _defineProperty(this, "done", false);
    _defineProperty(this, "inputClosed", false);
    _defineProperty(this, "enabled", true);
    _defineProperty(this, "resendStreams", new Set());
    // holds outstanding resends for cleanup
    _defineProperty(this, "outBuffer", new _PushBuffer.PushBuffer());
    this.config = config;
    this.resends = resends;
    this.streamPartId = streamPartId;
    this.logger = loggerFactory.createLogger(module);
    this.onOrdered = this.onOrdered.bind(this);
    this.onGap = this.onGap.bind(this);
    this.maybeClose = this.maybeClose.bind(this);
    var _this$config = this.config,
      gapFillTimeout = _this$config.gapFillTimeout,
      retryResendAfter = _this$config.retryResendAfter,
      maxGapRequests = _this$config.maxGapRequests,
      gapFill = _this$config.gapFill;
    this.enabled = gapFill && maxGapRequests > 0;
    this.orderingUtil = new _OrderingUtil.default(this.streamPartId, this.onOrdered, this.onGap, function () {
      return _this.maybeClose();
    }, function () {
      return _this.maybeClose();
    },
    // probably noop, TODO: handle gapfill errors without closing stream or logging
    gapFillTimeout, retryResendAfter, this.enabled ? maxGapRequests : 0);
  }
  _createClass(OrderMessages, [{
    key: "onGap",
    value: function () {
      var _onGap = _asyncToGenerator(function* (from, to, context) {
        var _this2 = this;
        if (this.done || !this.enabled) {
          return;
        }
        this.logger.debug('Encountered gap', {
          streamPartId: this.streamPartId,
          context: context,
          from: from,
          to: to
        });
        var resendMessageStream;
        try {
          resendMessageStream = yield this.resends.range(this.streamPartId, {
            fromTimestamp: from.timestamp,
            toTimestamp: to.timestamp,
            fromSequenceNumber: from.sequenceNumber,
            toSequenceNumber: to.sequenceNumber,
            publisherId: context.publisherId,
            msgChainId: context.msgChainId
          }, true);
          resendMessageStream.onFinally.listen(function () {
            _this2.resendStreams.delete(resendMessageStream);
          });
          this.resendStreams.add(resendMessageStream);
          if (this.done) {
            return;
          }
          var _iteratorAbruptCompletion = false;
          var _didIteratorError = false;
          var _iteratorError;
          try {
            for (var _iterator = _asyncIterator(resendMessageStream.getStreamMessages()), _step; _iteratorAbruptCompletion = !(_step = yield _iterator.next()).done; _iteratorAbruptCompletion = false) {
              var streamMessage = _step.value;
              {
                if (this.done) {
                  return;
                }
                this.orderingUtil.add(streamMessage);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (_iteratorAbruptCompletion && _iterator.return != null) {
                yield _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } catch (err) {
          if (this.done) {
            return;
          }
          if (err.code === 'NO_STORAGE_NODES') {
            // ignore NO_STORAGE_NODES errors
            // if stream has no storage we can't do resends
            this.enabled = false;
            this.orderingUtil.disable();
          } else {
            this.outBuffer.endWrite(err);
          }
        } finally {
          if (resendMessageStream != null) {
            this.resendStreams.delete(resendMessageStream);
          }
        }
      });
      function onGap(_x3, _x4, _x5) {
        return _onGap.apply(this, arguments);
      }
      return onGap;
    }()
  }, {
    key: "onOrdered",
    value: function onOrdered(orderedMessage) {
      if (this.outBuffer.isDone() || this.done) {
        return;
      }
      this.outBuffer.push(orderedMessage);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.done = true;
    }
  }, {
    key: "maybeClose",
    value: function maybeClose() {
      // we can close when:
      // input has closed (i.e. all messages sent)
      // AND
      // no gaps are pending
      // AND
      // gaps have been filled or failed
      // NOTE ordering util cannot have gaps if queue is empty
      if (this.inputClosed && this.orderingUtil.isEmpty()) {
        this.outBuffer.endWrite();
      }
    }
  }, {
    key: "addToOrderingUtil",
    value: function () {
      var _addToOrderingUtil = _asyncToGenerator(function* (src) {
        try {
          var _iteratorAbruptCompletion2 = false;
          var _didIteratorError2 = false;
          var _iteratorError2;
          try {
            for (var _iterator2 = _asyncIterator(src), _step2; _iteratorAbruptCompletion2 = !(_step2 = yield _iterator2.next()).done; _iteratorAbruptCompletion2 = false) {
              var msg = _step2.value;
              {
                this.orderingUtil.add(msg);
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (_iteratorAbruptCompletion2 && _iterator2.return != null) {
                yield _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
          this.inputClosed = true;
          this.maybeClose();
        } catch (err) {
          this.outBuffer.endWrite(err);
        }
      });
      function addToOrderingUtil(_x6) {
        return _addToOrderingUtil.apply(this, arguments);
      }
      return addToOrderingUtil;
    }()
  }, {
    key: "transform",
    value: function transform() {
      return /*#__PURE__*/function () {
        var _Transform = _wrapAsyncGenerator(function* (src) {
          try {
            this.addToOrderingUtil(src);
            yield* _asyncGeneratorDelegate(_asyncIterator(this.outBuffer), _awaitAsyncGenerator);
          } finally {
            this.done = true;
            this.orderingUtil.clearGaps();
            this.resendStreams.forEach(function (s) {
              return s.end();
            });
            this.resendStreams.clear();
            this.orderingUtil.clearGaps();
          }
        });
        function Transform(_x, _x2) {
          return _Transform.apply(this, arguments);
        }
        return Transform;
      }().bind(this);
    }
  }]);
  return OrderMessages;
}();
exports.OrderMessages = OrderMessages;

/***/ }),

/***/ "./src/subscribe/ResendSubscription.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ResendSubscription = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Subscription2 = __webpack_require__("./src/subscribe/Subscription.ts");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _OrderMessages = __webpack_require__("./src/subscribe/OrderMessages.ts");
var _Resends = __webpack_require__("./src/subscribe/Resends.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _Config2 = __webpack_require__("./src/Config.ts");
var _dec, _dec2, _dec3, _class;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _asyncGeneratorDelegate(inner) { var iter = {}, waiting = !1; function pump(key, value) { return waiting = !0, value = new Promise(function (resolve) { resolve(inner[key](value)); }), { done: !1, value: new _OverloadYield(value, 1) }; } return iter["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () { return this; }, iter.next = function (value) { return waiting ? (waiting = !1, value) : pump("next", value); }, "function" == typeof inner.throw && (iter.throw = function (value) { if (waiting) throw waiting = !1, value; return pump("throw", value); }), "function" == typeof inner.return && (iter.return = function (value) { return waiting ? (waiting = !1, value) : pump("return", value); }), iter; }
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
var ResendSubscription = (_dec = function _dec(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 4);
}, _dec2 = Reflect.metadata("design:type", Function), _dec3 = Reflect.metadata("design:paramtypes", [typeof _protocol.StreamPartID === "undefined" ? Object : _protocol.StreamPartID, typeof _Resends.ResendOptions === "undefined" ? Object : _Resends.ResendOptions, typeof _Resends.Resends === "undefined" ? Object : _Resends.Resends, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof _Config2.StrictStreamrClientConfig === "undefined" ? Object : _Config2.StrictStreamrClientConfig]), _dec(_class = _dec2(_class = _dec3(_class = /*#__PURE__*/function (_Subscription) {
  _inherits(ResendSubscription, _Subscription);
  var _super = _createSuper(ResendSubscription);
  /** @internal */
  function ResendSubscription(streamPartId, resendOptions, resends, loggerFactory, config) {
    var _this2;
    _classCallCheck(this, ResendSubscription);
    _this2 = _super.call(this, streamPartId, false, loggerFactory);
    _this2.resendOptions = resendOptions;
    _this2.resends = resends;
    _this2.pipe(_this2.resendThenRealtime.bind(_assertThisInitialized(_this2)));
    if (config.orderMessages) {
      var orderMessages = new _OrderMessages.OrderMessages(config, resends, streamPartId, loggerFactory);
      _this2.pipe(orderMessages.transform());
      _this2.onBeforeFinally.listen(function () {
        return orderMessages.stop();
      });
    }
    return _this2;
  }
  _createClass(ResendSubscription, [{
    key: "getResent",
    value: function () {
      var _getResent = _asyncToGenerator(function* () {
        var resentMsgs = yield this.resends.resend(this.streamPartId, this.resendOptions);
        this.onBeforeFinally.listen( /*#__PURE__*/_asyncToGenerator(function* () {
          resentMsgs.end();
          yield resentMsgs.return();
        }));
        return resentMsgs;
      });
      function getResent() {
        return _getResent.apply(this, arguments);
      }
      return getResent;
    }()
  }, {
    key: "resendThenRealtime",
    value: function resendThenRealtime(src) {
      var _this = this;
      return _wrapAsyncGenerator(function* () {
        try {
          yield* _asyncGeneratorDelegate(_asyncIterator((yield _awaitAsyncGenerator(_this.getResent())).getStreamMessages()), _awaitAsyncGenerator);
        } catch (err) {
          if (err.code === 'NO_STORAGE_NODES') {
            _this.logger.warn('Skip resend (no storage assigned to stream)', {
              streamPartId: _this.streamPartId,
              resendOptions: _this.resendOptions
            });
          } else {
            yield _awaitAsyncGenerator(_this.handleError(err));
          }
        }
        _this.eventEmitter.emit('resendComplete');
        yield* _asyncGeneratorDelegate(_asyncIterator(src), _awaitAsyncGenerator);
      })();
    }
  }]);
  return ResendSubscription;
}(_Subscription2.Subscription)) || _class) || _class) || _class);
exports.ResendSubscription = ResendSubscription;

/***/ }),

/***/ "./src/subscribe/Resends.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Resends = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _MessageStream = __webpack_require__("./src/subscribe/MessageStream.ts");
var _subscribePipeline = __webpack_require__("./src/subscribe/subscribePipeline.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _random = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/random.js"));
var _Config = __webpack_require__("./src/Config.ts");
var _DestroySignal = __webpack_require__("./src/DestroySignal.ts");
var _HttpUtil = __webpack_require__("./src/HttpUtil.ts");
var _StreamrClientError = __webpack_require__("./src/StreamrClientError.ts");
var _GroupKeyManager = __webpack_require__("./src/encryption/GroupKeyManager.ts");
var _StorageNodeRegistry = __webpack_require__("./src/registry/StorageNodeRegistry.ts");
var _StreamRegistryCached = __webpack_require__("./src/registry/StreamRegistryCached.ts");
var _StreamStorageRegistry = __webpack_require__("./src/registry/StreamStorageRegistry.ts");
var _GeneratorUtils = __webpack_require__("./src/utils/GeneratorUtils.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var MIN_SEQUENCE_NUMBER_VALUE = 0;

/**
 * Resend the latest "n" messages.
 */

/**
 * Resend messages starting from a given point in time.
 */

/**
 * Resend messages between two points in time.
 */

/**
 * The supported resend types.
 */

function isResendLast(options) {
  return options && _typeof(options) === 'object' && 'last' in options && options.last != null;
}
function isResendFrom(options) {
  return options && _typeof(options) === 'object' && 'from' in options && !('to' in options) && options.from != null;
}
function isResendRange(options) {
  return options && _typeof(options) === 'object' && 'from' in options && 'to' in options && options.to && options.from != null;
}
var Resends = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _StorageNodeRegistry.StorageNodeRegistry;
  }))(target, undefined, 1);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _StreamRegistryCached.StreamRegistryCached;
  }))(target, undefined, 2);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 6);
}, _dec5 = Reflect.metadata("design:type", Function), _dec6 = Reflect.metadata("design:paramtypes", [typeof _StreamStorageRegistry.StreamStorageRegistry === "undefined" ? Object : _StreamStorageRegistry.StreamStorageRegistry, typeof _StorageNodeRegistry.StorageNodeRegistry === "undefined" ? Object : _StorageNodeRegistry.StorageNodeRegistry, typeof _StreamRegistryCached.StreamRegistryCached === "undefined" ? Object : _StreamRegistryCached.StreamRegistryCached, typeof _HttpUtil.HttpUtil === "undefined" ? Object : _HttpUtil.HttpUtil, typeof _GroupKeyManager.GroupKeyManager === "undefined" ? Object : _GroupKeyManager.GroupKeyManager, typeof _DestroySignal.DestroySignal === "undefined" ? Object : _DestroySignal.DestroySignal, typeof _Config.StrictStreamrClientConfig === "undefined" ? Object : _Config.StrictStreamrClientConfig, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = /*#__PURE__*/function () {
  function Resends(streamStorageRegistry, storageNodeRegistry, streamRegistryCached, httpUtil, groupKeyManager, destroySignal, config, loggerFactory) {
    _classCallCheck(this, Resends);
    this.streamStorageRegistry = streamStorageRegistry;
    this.storageNodeRegistry = storageNodeRegistry;
    this.streamRegistryCached = streamRegistryCached;
    this.httpUtil = httpUtil;
    this.groupKeyManager = groupKeyManager;
    this.destroySignal = destroySignal;
    this.config = config;
    this.loggerFactory = loggerFactory;
    this.logger = loggerFactory.createLogger(module);
  }
  _createClass(Resends, [{
    key: "resend",
    value: function resend(streamPartId, options) {
      if (isResendLast(options)) {
        return this.last(streamPartId, {
          count: options.last
        }, false);
      }
      if (isResendRange(options)) {
        return this.range(streamPartId, {
          fromTimestamp: new Date(options.from.timestamp).getTime(),
          fromSequenceNumber: options.from.sequenceNumber,
          toTimestamp: new Date(options.to.timestamp).getTime(),
          toSequenceNumber: options.to.sequenceNumber,
          publisherId: options.publisherId !== undefined ? (0, _utils.toEthereumAddress)(options.publisherId) : undefined,
          msgChainId: options.msgChainId
        }, false);
      }
      if (isResendFrom(options)) {
        return this.from(streamPartId, {
          fromTimestamp: new Date(options.from.timestamp).getTime(),
          fromSequenceNumber: options.from.sequenceNumber,
          publisherId: options.publisherId !== undefined ? (0, _utils.toEthereumAddress)(options.publisherId) : undefined
        }, false);
      }
      throw new _StreamrClientError.StreamrClientError("can not resend without valid resend options: ".concat(JSON.stringify({
        streamPartId: streamPartId,
        options: options
      })), 'INVALID_ARGUMENT');
    }
  }, {
    key: "fetchStream",
    value: function () {
      var _fetchStream = _asyncToGenerator(function* (endpointSuffix, streamPartId, query, raw) {
        var _this = this;
        var traceId = (0, _utils.randomString)(5);
        this.logger.debug('Fetch resend data', {
          loggerIdx: traceId,
          resendType: endpointSuffix,
          streamPartId: streamPartId,
          query: query
        });
        var streamId = _protocol.StreamPartIDUtils.getStreamID(streamPartId);
        var nodeAddresses = yield this.streamStorageRegistry.getStorageNodes(streamId);
        if (!nodeAddresses.length) {
          throw new _StreamrClientError.StreamrClientError("no storage assigned: ".concat(streamId), 'NO_STORAGE_NODES');
        }
        var nodeAddress = nodeAddresses[(0, _random.default)(0, nodeAddresses.length - 1)];
        var nodeUrl = (yield this.storageNodeRegistry.getStorageNodeMetadata(nodeAddress)).http;
        var url = this.createUrl(nodeUrl, endpointSuffix, streamPartId, query);
        var messageStream = raw === false ? (0, _subscribePipeline.createSubscribePipeline)({
          streamPartId: streamPartId,
          resends: this,
          groupKeyManager: this.groupKeyManager,
          streamRegistryCached: this.streamRegistryCached,
          destroySignal: this.destroySignal,
          config: this.config,
          loggerFactory: this.loggerFactory
        }) : new _MessageStream.MessageStream();
        var dataStream = this.httpUtil.fetchHttpStream(url);
        messageStream.pull((0, _GeneratorUtils.counting)(dataStream, function (count) {
          _this.logger.debug('Finished resend', {
            loggerIdx: traceId,
            messageCount: count
          });
        }));
        return messageStream;
      });
      function fetchStream(_x, _x2, _x3, _x4) {
        return _fetchStream.apply(this, arguments);
      }
      return fetchStream;
    }()
  }, {
    key: "last",
    value: function () {
      var _last = _asyncToGenerator(function* (streamPartId, _ref, raw) {
        var count = _ref.count;
        if (count <= 0) {
          var emptyStream = new _MessageStream.MessageStream();
          emptyStream.endWrite();
          return emptyStream;
        }
        return this.fetchStream('last', streamPartId, {
          count: count
        }, raw);
      });
      function last(_x5, _x6, _x7) {
        return _last.apply(this, arguments);
      }
      return last;
    }()
  }, {
    key: "from",
    value: function () {
      var _from = _asyncToGenerator(function* (streamPartId, _ref2, raw) {
        var fromTimestamp = _ref2.fromTimestamp,
          _ref2$fromSequenceNum = _ref2.fromSequenceNumber,
          fromSequenceNumber = _ref2$fromSequenceNum === void 0 ? MIN_SEQUENCE_NUMBER_VALUE : _ref2$fromSequenceNum,
          publisherId = _ref2.publisherId;
        return this.fetchStream('from', streamPartId, {
          fromTimestamp: fromTimestamp,
          fromSequenceNumber: fromSequenceNumber,
          publisherId: publisherId
        }, raw);
      });
      function from(_x8, _x9, _x10) {
        return _from.apply(this, arguments);
      }
      return from;
    }()
  }, {
    key: "range",
    value: function () {
      var _range = _asyncToGenerator(function* (streamPartId, _ref3, raw) {
        var fromTimestamp = _ref3.fromTimestamp,
          _ref3$fromSequenceNum = _ref3.fromSequenceNumber,
          fromSequenceNumber = _ref3$fromSequenceNum === void 0 ? MIN_SEQUENCE_NUMBER_VALUE : _ref3$fromSequenceNum,
          toTimestamp = _ref3.toTimestamp,
          _ref3$toSequenceNumbe = _ref3.toSequenceNumber,
          toSequenceNumber = _ref3$toSequenceNumbe === void 0 ? MIN_SEQUENCE_NUMBER_VALUE : _ref3$toSequenceNumbe,
          publisherId = _ref3.publisherId,
          msgChainId = _ref3.msgChainId;
        return this.fetchStream('range', streamPartId, {
          fromTimestamp: fromTimestamp,
          fromSequenceNumber: fromSequenceNumber,
          toTimestamp: toTimestamp,
          toSequenceNumber: toSequenceNumber,
          publisherId: publisherId,
          msgChainId: msgChainId
        }, raw);
      });
      function range(_x11, _x12, _x13) {
        return _range.apply(this, arguments);
      }
      return range;
    }()
  }, {
    key: "waitForStorage",
    value: function () {
      var _waitForStorage = _asyncToGenerator(function* (message) {
        var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$interval = _ref4.interval,
          interval = _ref4$interval === void 0 ? this.config._timeouts.storageNode.retryInterval : _ref4$interval,
          _ref4$timeout = _ref4.timeout,
          timeout = _ref4$timeout === void 0 ? this.config._timeouts.storageNode.timeout : _ref4$timeout,
          _ref4$count = _ref4.count,
          count = _ref4$count === void 0 ? 100 : _ref4$count,
          _ref4$messageMatchFn = _ref4.messageMatchFn,
          messageMatchFn = _ref4$messageMatchFn === void 0 ? function (msgTarget, msgGot) {
            return msgTarget.signature === msgGot.signature;
          } : _ref4$messageMatchFn;
        if (!message) {
          throw new _StreamrClientError.StreamrClientError('waitForStorage requires a Message', 'INVALID_ARGUMENT');
        }
        var start = Date.now();
        var last;
        var found = false;
        while (!found) {
          var duration = Date.now() - start;
          if (duration > timeout) {
            var _last2;
            this.logger.debug('Timed out waiting for storage to contain message', {
              expected: message.streamMessage.getMessageID(),
              lastReceived: (_last2 = last) === null || _last2 === void 0 ? void 0 : _last2.map(function (l) {
                return l.streamMessage.getMessageID();
              })
            });
            throw new Error("timed out after ".concat(duration, "ms waiting for message"));
          }
          var resendStream = yield this.resend((0, _protocol.toStreamPartID)(message.streamId, message.streamPartition), {
            last: count
          });
          last = yield (0, _utils.collect)(resendStream);
          var _iterator = _createForOfIteratorHelper(last),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var lastMsg = _step.value;
              if (messageMatchFn(message, lastMsg)) {
                found = true;
                this.logger.debug('Found matching message');
                return;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          this.logger.debug('Retry after delay (matching message not found)', {
            expected: message.streamMessage.getMessageID(),
            'last-3': last.slice(-3).map(function (l) {
              return l.streamMessage.getMessageID();
            }),
            delayInMs: interval
          });
          yield (0, _utils.wait)(interval);
        }
        /* eslint-enable no-await-in-loop */
      });
      function waitForStorage(_x14) {
        return _waitForStorage.apply(this, arguments);
      }
      return waitForStorage;
    }()
  }, {
    key: "createUrl",
    value: function createUrl(baseUrl, endpointSuffix, streamPartId) {
      var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var queryMap = _objectSpread(_objectSpread({}, query), {}, {
        format: 'raw'
      });
      var _StreamPartIDUtils$ge = _protocol.StreamPartIDUtils.getStreamIDAndPartition(streamPartId),
        _StreamPartIDUtils$ge2 = _slicedToArray(_StreamPartIDUtils$ge, 2),
        streamId = _StreamPartIDUtils$ge2[0],
        streamPartition = _StreamPartIDUtils$ge2[1];
      var queryString = this.httpUtil.createQueryString(queryMap);
      return "".concat(baseUrl, "/streams/").concat(encodeURIComponent(streamId), "/data/partitions/").concat(streamPartition, "/").concat(endpointSuffix, "?").concat(queryString);
    }
  }]);
  return Resends;
}()) || _class) || _class) || _class) || _class) || _class) || _class);
exports.Resends = Resends;

/***/ }),

/***/ "./src/subscribe/Subscriber.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Subscriber = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.reduce.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.match.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.flat-map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.unscopables.flat-map.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _promises = __webpack_require__("./src/utils/promises.ts");
var _SubscriptionSession = __webpack_require__("./src/subscribe/SubscriptionSession.ts");
var _Subscription = __webpack_require__("./src/subscribe/Subscription.ts");
var _StreamIDBuilder = __webpack_require__("./src/StreamIDBuilder.ts");
var _Resends = __webpack_require__("./src/subscribe/Resends.ts");
var _NetworkNodeFacade = __webpack_require__("./src/NetworkNodeFacade.ts");
var _DestroySignal = __webpack_require__("./src/DestroySignal.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _StreamRegistryCached = __webpack_require__("./src/registry/StreamRegistryCached.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _GroupKeyManager = __webpack_require__("./src/encryption/GroupKeyManager.ts");
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Subscriber = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)((0, _tsyringe.delay)(function () {
    return _StreamRegistryCached.StreamRegistryCached;
  }))(target, undefined, 3);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 6);
}, _dec4 = function _dec4(target, key) {
  return (0, _tsyringe.inject)(_LoggerFactory.LoggerFactory)(target, undefined, 7);
}, _dec5 = Reflect.metadata("design:type", Function), _dec6 = Reflect.metadata("design:paramtypes", [typeof _StreamIDBuilder.StreamIDBuilder === "undefined" ? Object : _StreamIDBuilder.StreamIDBuilder, typeof _Resends.Resends === "undefined" ? Object : _Resends.Resends, typeof _GroupKeyManager.GroupKeyManager === "undefined" ? Object : _GroupKeyManager.GroupKeyManager, typeof _StreamRegistryCached.StreamRegistryCached === "undefined" ? Object : _StreamRegistryCached.StreamRegistryCached, typeof _NetworkNodeFacade.NetworkNodeFacade === "undefined" ? Object : _NetworkNodeFacade.NetworkNodeFacade, typeof _DestroySignal.DestroySignal === "undefined" ? Object : _DestroySignal.DestroySignal, typeof _Config.StrictStreamrClientConfig === "undefined" ? Object : _Config.StrictStreamrClientConfig, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = _dec6(_class = /*#__PURE__*/function () {
  function Subscriber(streamIdBuilder, resends, groupKeyManager, streamRegistryCached, node, destroySignal, config, loggerFactory) {
    _classCallCheck(this, Subscriber);
    _defineProperty(this, "subSessions", new Map());
    this.streamIdBuilder = streamIdBuilder;
    this.resends = resends;
    this.groupKeyManager = groupKeyManager;
    this.streamRegistryCached = streamRegistryCached;
    this.node = node;
    this.destroySignal = destroySignal;
    this.config = config;
    this.loggerFactory = loggerFactory;
    this.logger = loggerFactory.createLogger(module);
  }
  _createClass(Subscriber, [{
    key: "getOrCreateSubscriptionSession",
    value: function getOrCreateSubscriptionSession(streamPartId) {
      var _this = this;
      if (this.subSessions.has(streamPartId)) {
        return this.getSubscriptionSession(streamPartId);
      }
      var subSession = new _SubscriptionSession.SubscriptionSession(streamPartId, this.resends, this.groupKeyManager, this.streamRegistryCached, this.node, this.destroySignal, this.loggerFactory, this.config);
      this.subSessions.set(streamPartId, subSession);
      subSession.onRetired.listen(function () {
        _this.subSessions.delete(streamPartId);
      });
      this.logger.debug('Created new SubscriptionSession', {
        streamPartId: streamPartId
      });
      return subSession;
    }
  }, {
    key: "add",
    value: function () {
      var _add = _asyncToGenerator(function* (sub) {
        var subSession = this.getOrCreateSubscriptionSession(sub.streamPartId);

        // add subscription to subSession
        try {
          yield subSession.add(sub);
        } catch (err) {
          this.logger.debug('Failed to add Subscription to SubscriptionSession', err);
          // clean up if fail
          yield this.remove(sub);
          throw err;
        }
      });
      function add(_x) {
        return _add.apply(this, arguments);
      }
      return add;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator(function* (sub) {
        if (!sub) {
          return;
        }
        var subSession = this.subSessions.get(sub.streamPartId);
        if (!subSession) {
          return;
        }
        yield subSession.remove(sub);
      });
      function remove(_x2) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe = _asyncToGenerator(function* (streamDefinitionOrSubscription) {
        if (streamDefinitionOrSubscription instanceof _Subscription.Subscription) {
          return this.remove(streamDefinitionOrSubscription);
        }
        return this.removeAll(streamDefinitionOrSubscription);
      });
      function unsubscribe(_x3) {
        return _unsubscribe.apply(this, arguments);
      }
      return unsubscribe;
    }()
    /**
     * Remove all subscriptions, optionally only those matching options.
     */
  }, {
    key: "removeAll",
    value: function () {
      var _removeAll = _asyncToGenerator(function* (streamDefinition) {
        var _this2 = this;
        var subs = !streamDefinition ? this.getAllSubscriptions() : yield this.getSubscriptions(streamDefinition);
        return (0, _promises.allSettledValues)(subs.map(function (sub) {
          return _this2.remove(sub);
        }));
      });
      function removeAll(_x4) {
        return _removeAll.apply(this, arguments);
      }
      return removeAll;
    }()
    /**
     * Count all subscriptions.
     */
  }, {
    key: "countAll",
    value: function countAll() {
      var count = 0;
      this.subSessions.forEach(function (s) {
        count += s.count();
      });
      return count;
    }

    /**
     * Count all matching subscriptions.
     */
    // TODO rename this to something more specific?
  }, {
    key: "count",
    value: function () {
      var _count = _asyncToGenerator(function* (streamDefinition) {
        if (streamDefinition === undefined) {
          return this.countAll();
        }
        return (yield this.getSubscriptions(streamDefinition)).length;
      });
      function count(_x5) {
        return _count.apply(this, arguments);
      }
      return count;
    }()
    /**
     * Get all subscriptions.
     */
  }, {
    key: "getAllSubscriptions",
    value: function getAllSubscriptions() {
      return _toConsumableArray(this.subSessions.values()).reduce(function (o, s) {
        // @ts-expect-error private
        o.push.apply(o, _toConsumableArray(s.subscriptions));
        return o;
      }, []);
    }

    /**
     * Get subscription session for matching sub options.
     */
  }, {
    key: "getSubscriptionSession",
    value: function getSubscriptionSession(streamPartId) {
      return this.subSessions.get(streamPartId);
    }
  }, {
    key: "countSubscriptionSessions",
    value: function countSubscriptionSessions() {
      return this.subSessions.size;
    }
  }, {
    key: "getSubscriptions",
    value: function () {
      var _getSubscriptions = _asyncToGenerator(function* (streamDefinition) {
        var _this3 = this;
        if (!streamDefinition) {
          return this.getAllSubscriptions();
        }
        var results = [];
        yield Promise.all(_toConsumableArray(this.subSessions.values()).map( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(function* (subSession) {
            var isMatch = yield _this3.streamIdBuilder.match(streamDefinition, subSession.streamPartId);
            if (isMatch) {
              results.push(subSession);
            }
          });
          return function (_x7) {
            return _ref.apply(this, arguments);
          };
        }()));
        return results.flatMap(function (subSession) {
          return _toConsumableArray(subSession.subscriptions);
        });
      });
      function getSubscriptions(_x6) {
        return _getSubscriptions.apply(this, arguments);
      }
      return getSubscriptions;
    }()
  }]);
  return Subscriber;
}()) || _class) || _class) || _class) || _class) || _class) || _class);
exports.Subscriber = Subscriber;

/***/ }),

/***/ "./src/subscribe/Subscription.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Subscription = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _MessageStream2 = __webpack_require__("./src/subscribe/MessageStream.ts");
var _eventemitter = _interopRequireDefault(__webpack_require__("../../node_modules/eventemitter3/index.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * Events emitted by {@link Subscription}.
 */
/**
 * A convenience API for managing an individual subscription.
 *
 * @category Important
 */
var Subscription = /*#__PURE__*/function (_MessageStream) {
  _inherits(Subscription, _MessageStream);
  var _super = _createSuper(Subscription);
  /** @internal */

  /** @internal */
  function Subscription(streamPartId, isRaw, loggerFactory) {
    var _this;
    _classCallCheck(this, Subscription);
    _this = _super.call(this);
    _this.streamPartId = streamPartId;
    _this.isRaw = isRaw;
    _this.eventEmitter = new _eventemitter.default();
    _this.logger = loggerFactory.createLogger(module);
    _this.onError.listen(function (err) {
      _this.eventEmitter.emit('error', err);
      _this.logger.debug('Encountered error', {
        err: err
      });
    });
    return _this;
  }

  /**
   * Unsubscribes this subscription.
   *
   * @remarks The instance should not be used after calling this.
   */
  _createClass(Subscription, [{
    key: "unsubscribe",
    value: function () {
      var _unsubscribe = _asyncToGenerator(function* () {
        this.end();
        yield this.return();
        this.eventEmitter.removeAllListeners();
      });
      function unsubscribe() {
        return _unsubscribe.apply(this, arguments);
      }
      return unsubscribe;
    }()
    /**
     * Adds an event listener to the subscription.
     * @param eventName - event name, see {@link SubscriptionEvents} for options
     * @param listener - the callback function
     */
  }, {
    key: "on",
    value: function on(eventName, listener) {
      this.eventEmitter.on(eventName, listener);
    }

    /**
     * Adds an event listener to the subscription that is invoked only once.
     * @param eventName - event name, see {@link SubscriptionEvents} for options
     * @param listener - the callback function
     */
  }, {
    key: "once",
    value: function once(eventName, listener) {
      this.eventEmitter.once(eventName, listener);
    }

    /**
     * Removes an event listener from the subscription.
     * @param eventName - event name, see {@link SubscriptionEvents} for options
     * @param listener - the callback function to remove
     */
  }, {
    key: "off",
    value: function off(eventName, listener) {
      this.eventEmitter.off(eventName, listener);
    }
  }]);
  return Subscription;
}(_MessageStream2.MessageStream);
exports.Subscription = Subscription;

/***/ }),

/***/ "./src/subscribe/SubscriptionSession.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SubscriptionSession = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-set.js");
__webpack_require__("../../node_modules/core-js/modules/esnext.promise.all-settled.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _Scaffold = __webpack_require__("./src/utils/Scaffold.ts");
var _Signal = __webpack_require__("./src/utils/Signal.ts");
var _subscribePipeline = __webpack_require__("./src/subscribe/subscribePipeline.ts");
var _NetworkNodeFacade = __webpack_require__("./src/NetworkNodeFacade.ts");
var _Resends = __webpack_require__("./src/subscribe/Resends.ts");
var _StreamRegistryCached = __webpack_require__("./src/registry/StreamRegistryCached.ts");
var _DestroySignal = __webpack_require__("./src/DestroySignal.ts");
var _Config = __webpack_require__("./src/Config.ts");
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _GroupKeyManager = __webpack_require__("./src/encryption/GroupKeyManager.ts");
var _dec, _dec2, _dec3, _class;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
/**
 * Manages adding & removing subscriptions to node as needed.
 * A session contains one or more subscriptions to a single streamId + streamPartition pair.
 */
var SubscriptionSession = (_dec = function _dec(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 7);
}, _dec2 = Reflect.metadata("design:type", Function), _dec3 = Reflect.metadata("design:paramtypes", [typeof _protocol.StreamPartID === "undefined" ? Object : _protocol.StreamPartID, typeof _Resends.Resends === "undefined" ? Object : _Resends.Resends, typeof _GroupKeyManager.GroupKeyManager === "undefined" ? Object : _GroupKeyManager.GroupKeyManager, typeof _StreamRegistryCached.StreamRegistryCached === "undefined" ? Object : _StreamRegistryCached.StreamRegistryCached, typeof _NetworkNodeFacade.NetworkNodeFacade === "undefined" ? Object : _NetworkNodeFacade.NetworkNodeFacade, typeof _DestroySignal.DestroySignal === "undefined" ? Object : _DestroySignal.DestroySignal, typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof _Config.StrictStreamrClientConfig === "undefined" ? Object : _Config.StrictStreamrClientConfig]), _dec(_class = _dec2(_class = _dec3(_class = /*#__PURE__*/function () {
  function SubscriptionSession(streamPartId, resends, groupKeyManager, streamRegistryCached, _node, destroySignal, loggerFactory, config) {
    var _this2 = this;
    _classCallCheck(this, SubscriptionSession);
    _defineProperty(this, "onRetired", _Signal.Signal.once());
    _defineProperty(this, "isRetired", false);
    _defineProperty(this, "isStopped", false);
    _defineProperty(this, "subscriptions", new Set());
    _defineProperty(this, "pendingRemoval", new WeakSet());
    _defineProperty(this, "onMessageInput", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (msg) {
        if (!msg || _this2.isStopped || _this2.isRetired) {
          return;
        }
        if (msg.getStreamPartID() !== _this2.streamPartId) {
          return;
        }
        if (msg.messageType !== _protocol.StreamMessageType.MESSAGE) {
          return;
        }
        var tasks = [];
        var hasNormalSubscriptions = false;
        var _iterator2 = _createForOfIteratorHelper(_this2.subscriptions.values()),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var sub = _step2.value;
            if (sub.isRaw) {
              tasks.push(sub.push(msg));
            } else {
              hasNormalSubscriptions = true;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        if (hasNormalSubscriptions) {
          tasks.push(_this2.pipeline.push(msg));
        }
        yield Promise.all(tasks);
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(this, "updateNodeSubscriptions", function () {
      var node;
      return (0, _Scaffold.Scaffold)([/*#__PURE__*/_asyncToGenerator(function* () {
        node = yield _this2.subscribe();
        return /*#__PURE__*/_asyncToGenerator(function* () {
          var prevNode = node;
          node = undefined;
          yield _this2.unsubscribe(prevNode);
          yield _this2.stop();
        });
      })], function () {
        return _this2.shouldBeSubscribed();
      });
    }());
    this.streamPartId = streamPartId;
    this.distributeMessage = this.distributeMessage.bind(this);
    this.node = _node;
    this.onError = this.onError.bind(this);
    this.pipeline = (0, _subscribePipeline.createSubscribePipeline)({
      streamPartId: streamPartId,
      resends: resends,
      groupKeyManager: groupKeyManager,
      streamRegistryCached: streamRegistryCached,
      loggerFactory: loggerFactory,
      destroySignal: destroySignal,
      config: config
    });
    this.pipeline.onError.listen(this.onError);
    this.pipeline.pipe(this.distributeMessage).onBeforeFinally.listen( /*#__PURE__*/_asyncToGenerator(function* () {
      if (!_this2.isStopped) {
        yield _this2.stop();
      }
    }));
    this.pipeline.flow();
  }
  _createClass(SubscriptionSession, [{
    key: "retire",
    value: function () {
      var _retire = _asyncToGenerator(function* () {
        if (this.isRetired) {
          return;
        }
        this.isRetired = true;
        yield this.onRetired.trigger();
      });
      function retire() {
        return _retire.apply(this, arguments);
      }
      return retire;
    }()
  }, {
    key: "onError",
    value: function () {
      var _onError = _asyncToGenerator(function* (error) {
        // eslint-disable-next-line promise/no-promise-in-callback
        yield Promise.allSettled(_toConsumableArray(this.subscriptions).map( /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(function* (sub) {
            yield sub.handleError(error);
          });
          return function (_x3) {
            return _ref5.apply(this, arguments);
          };
        }()));
      });
      function onError(_x2) {
        return _onError.apply(this, arguments);
      }
      return onError;
    }()
  }, {
    key: "distributeMessage",
    value: function distributeMessage(src) {
      var _this = this;
      return _wrapAsyncGenerator(function* () {
        var _iteratorAbruptCompletion = false;
        var _didIteratorError = false;
        var _iteratorError;
        try {
          var _loop = function* _loop() {
            var msg = _step.value;
            {
              yield _awaitAsyncGenerator(Promise.all(_toConsumableArray(_this.subscriptions).map( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(function* (sub) {
                  yield sub.push(msg);
                });
                return function (_x4) {
                  return _ref6.apply(this, arguments);
                };
              }())));
              yield msg;
            }
          };
          for (var _iterator = _asyncIterator(src), _step; _iteratorAbruptCompletion = !(_step = yield _awaitAsyncGenerator(_iterator.next())).done; _iteratorAbruptCompletion = false) {
            yield* _loop();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (_iteratorAbruptCompletion && _iterator.return != null) {
              yield _awaitAsyncGenerator(_iterator.return());
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      })();
    }
  }, {
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator(function* () {
        var node = yield this.node.getNode();
        node.addMessageListener(this.onMessageInput);
        node.subscribe(this.streamPartId);
        return node;
      });
      function subscribe() {
        return _subscribe.apply(this, arguments);
      }
      return subscribe;
    }()
  }, {
    key: "unsubscribe",
    value: function () {
      var _unsubscribe = _asyncToGenerator(function* (node) {
        this.pipeline.end();
        this.pipeline.return();
        this.pipeline.onError.end(new Error('done'));
        node.removeMessageListener(this.onMessageInput);
        node.unsubscribe(this.streamPartId);
      });
      function unsubscribe(_x5) {
        return _unsubscribe.apply(this, arguments);
      }
      return unsubscribe;
    }()
  }, {
    key: "updateSubscriptions",
    value: function () {
      var _updateSubscriptions = _asyncToGenerator(function* () {
        yield this.updateNodeSubscriptions();
        if (!this.shouldBeSubscribed() && !this.isStopped) {
          yield this.stop();
        }
      });
      function updateSubscriptions() {
        return _updateSubscriptions.apply(this, arguments);
      }
      return updateSubscriptions;
    }()
  }, {
    key: "shouldBeSubscribed",
    value: function shouldBeSubscribed() {
      return !this.isRetired && !this.isStopped && !!this.count();
    }
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(function* () {
        this.isStopped = true;
        this.pipeline.end();
        yield this.retire();
        yield this.pipeline.return();
      });
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }, {
    key: "has",
    value: function has(sub) {
      return this.subscriptions.has(sub);
    }

    /**
     * Add subscription & appropriate connection handle.
     */
  }, {
    key: "add",
    value: function () {
      var _add = _asyncToGenerator(function* (sub) {
        var _this3 = this;
        if (!sub || this.subscriptions.has(sub) || this.pendingRemoval.has(sub)) {
          return;
        } // already has
        this.subscriptions.add(sub);
        sub.onBeforeFinally.listen(function () {
          return _this3.remove(sub);
        });
        yield this.updateSubscriptions();
      });
      function add(_x6) {
        return _add.apply(this, arguments);
      }
      return add;
    }()
    /**
     * Remove subscription & appropriate connection handle.
     */
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator(function* (sub) {
        if (!sub || this.pendingRemoval.has(sub) || !this.subscriptions.has(sub)) {
          return;
        }
        this.pendingRemoval.add(sub);
        this.subscriptions.delete(sub);
        try {
          if (!sub.isDone()) {
            yield sub.unsubscribe();
          }
        } finally {
          yield this.updateSubscriptions();
        }
      });
      function remove(_x7) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
    /**
     * How many subscriptions
     */
  }, {
    key: "count",
    value: function count() {
      return this.subscriptions.size;
    }
  }]);
  return SubscriptionSession;
}()) || _class) || _class) || _class);
exports.SubscriptionSession = SubscriptionSession;

/***/ }),

/***/ "./src/subscribe/ordering/GapFillFailedError.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var GapFillFailedError = /*#__PURE__*/function (_Error) {
  _inherits(GapFillFailedError, _Error);
  var _super = _createSuper(GapFillFailedError);
  function GapFillFailedError(from, to, context, nbTrials) {
    var _this;
    _classCallCheck(this, GapFillFailedError);
    // eslint-disable-next-line max-len
    _this = _super.call(this, "Failed to fill gap between ".concat(from.serialize(), " and ").concat(to.serialize(), " for ").concat(context.streamPartId, " ").concat(context.publisherId, "-").concat(context.msgChainId, " after ").concat(nbTrials, " trials"));
    _this.from = from;
    _this.to = to;
    _this.context = context;
    return _this;
  }
  return _createClass(GapFillFailedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports["default"] = GapFillFailedError;
module.exports = exports.default;

/***/ }),

/***/ "./src/subscribe/ordering/OrderedMsgChain.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.OrderedMsgChain = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _heap = _interopRequireDefault(__webpack_require__("../../node_modules/heap/index.js"));
var _GapFillFailedError = _interopRequireDefault(__webpack_require__("./src/subscribe/ordering/GapFillFailedError.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function toMsgRefId(streamMessage) {
  return streamMessage.getMessageRef().serialize();
}
/**
 * Set of StreamMessages, unique by serialized msgRef i.e. timestamp + sequence number.
 */
var StreamMessageSet = /*#__PURE__*/function () {
  function StreamMessageSet() {
    _classCallCheck(this, StreamMessageSet);
    _defineProperty(this, "msgMap", new Map());
  }
  _createClass(StreamMessageSet, [{
    key: "has",
    value: function has(streamMessage) {
      return this.msgMap.has(toMsgRefId(streamMessage));
    }

    /**
     * Get StreamMessage associated with this msgRef
     */
  }, {
    key: "get",
    value: function get(msgRef) {
      return this.msgMap.get(msgRef.serialize());
    }
  }, {
    key: "delete",
    value: function _delete(streamMessage) {
      return this.msgMap.delete(toMsgRefId(streamMessage));
    }
  }, {
    key: "add",
    value: function add(streamMessage) {
      if (!this.has(streamMessage)) {
        return this.msgMap.set(toMsgRefId(streamMessage), streamMessage);
      }
      return this;
    }
  }, {
    key: "size",
    value: function size() {
      return this.msgMap.size;
    }
  }]);
  return StreamMessageSet;
}();
/**
 * Ordered queue of StreamMessages.
 * Deduplicated by serialized msgRef.
 */
var MsgChainQueue = /*#__PURE__*/function () {
  function MsgChainQueue() {
    _classCallCheck(this, MsgChainQueue);
    /**
     * Ordered message refs
     */
    _defineProperty(this, "queue", new _heap.default(function (msg1, msg2) {
      return msg1.compareTo(msg2);
    }));
    /**
     * Mapping from msgRef to message.
     */
    _defineProperty(this, "pendingMsgs", new StreamMessageSet());
  }
  _createClass(MsgChainQueue, [{
    key: "peek",
    value:
    /**
     * Peek at next message in-order.
     */
    function peek() {
      if (this.isEmpty()) {
        return;
      }
      var ref = this.queue.peek();
      return this.pendingMsgs.get(ref);
    }

    /**
     * True if queue already has a message with this message ref.
     */
  }, {
    key: "has",
    value: function has(streamMessage) {
      // prevent duplicates
      return this.pendingMsgs.has(streamMessage);
    }

    /**
     * Push new item into the queue.
     * Ignores duplicates.
     */
  }, {
    key: "push",
    value: function push(streamMessage) {
      // prevent duplicates
      if (this.has(streamMessage)) {
        return;
      }
      this.pendingMsgs.add(streamMessage);
      var msgRef = streamMessage.getMessageRef();
      this.queue.push(msgRef);
    }

    /**
     * Remove next item from queue and return it.
     */
  }, {
    key: "pop",
    value: function pop() {
      if (this.isEmpty()) {
        return;
      }
      var streamMessage = this.peek();
      if (!streamMessage) {
        return;
      }
      this.queue.pop();
      this.pendingMsgs.delete(streamMessage);
      return streamMessage;
    }

    /**
     * True if there are no items in the queue.
     */
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.queue.empty();
    }

    /**
     * Number of items in queue.
     */
  }, {
    key: "size",
    value: function size() {
      return this.queue.size();
    }
  }]);
  return MsgChainQueue;
}();
var logger = new _utils.Logger(module);
var OrderedMsgChain = /*#__PURE__*/function () {
  function OrderedMsgChain(context, inOrderHandler, gapHandler, onDrain, onError, gapFillTimeout, retryResendAfter, maxGapRequests) {
    _classCallCheck(this, OrderedMsgChain);
    _defineProperty(this, "lastOrderedMsgRef", null);
    _defineProperty(this, "hasPendingGap", false);
    _defineProperty(this, "gapRequestCount", 0);
    _defineProperty(this, "nextGaps", null);
    _defineProperty(this, "queue", new MsgChainQueue());
    _defineProperty(this, "markedExplicitly", new StreamMessageSet());
    this.context = context;
    this.inOrderHandler = inOrderHandler;
    this.gapHandler = gapHandler;
    this.onDrain = onDrain;
    this.onError = onError;
    this.lastOrderedMsgRef = null;
    this.gapFillTimeout = gapFillTimeout;
    this.retryResendAfter = retryResendAfter;
    this.maxGapRequests = maxGapRequests;
  }

  /**
   * Messages are stale if they are already enqueued or last ordered message is newer.
   */
  _createClass(OrderedMsgChain, [{
    key: "isStaleMessage",
    value: function isStaleMessage(streamMessage) {
      var msgRef = streamMessage.getMessageRef();
      return !!(
      // already enqueued
      this.queue.has(streamMessage) || this.lastOrderedMsgRef
      // or older/equal to last ordered msgRef
      && msgRef.compareTo(this.lastOrderedMsgRef) <= 0);
    }

    /**
     * Add message to queue.
     */
  }, {
    key: "add",
    value: function add(unorderedStreamMessage) {
      if (this.isStaleMessage(unorderedStreamMessage)) {
        var msgRef = unorderedStreamMessage.getMessageRef();
        // Prevent double-processing of messages for any reason
        logger.trace('Ignore message (already enqueued or processed a newer message)', {
          ignoredMsgRef: msgRef,
          lastMsgRef: this.lastOrderedMsgRef
        });
        return;
      }

      // gap handling disabled
      if (!this.isGapHandlingEnabled()) {
        this.markMessage(unorderedStreamMessage);
      }
      this.queue.push(unorderedStreamMessage);
      this.checkQueue();
    }

    /**
     * Adds message to set of marked messages.
     * Does nothing and returns false if message is stale.
     */
  }, {
    key: "markMessage",
    value: function markMessage(streamMessage) {
      if (!streamMessage || this.isStaleMessage(streamMessage)) {
        // do nothing if already past/handled this message
        return false;
      }
      if (this.isGapHandlingEnabled()) {
        logger.trace('markMessage', {
          msgRef: streamMessage.getMessageRef()
        });
      }
      this.markedExplicitly.add(streamMessage);
      return true;
    }

    /**
     * Cancel any outstanding gap fill request.
     */
  }, {
    key: "clearGap",
    value: function clearGap() {
      if (this.hasPendingGap) {
        logger.trace('clearGap');
      }
      this.hasPendingGap = false;
      clearTimeout(this.nextGaps);
      this.nextGaps = null;
    }
  }, {
    key: "disable",
    value: function disable() {
      this.maxGapRequests = 0;
      this.clearGap();
      this.checkQueue();
    }
  }, {
    key: "isGapHandlingEnabled",
    value: function isGapHandlingEnabled() {
      return this.maxGapRequests > 0;
    }

    /**
     * True if queue is empty.
     */
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.queue.isEmpty();
    }

    /**
     * True if the next queued message is the next message in the chain.
     * Always true for first message and unchained messages i.e. messages without a prevMsgRef.
     */
  }, {
    key: "hasNextMessageInChain",
    value: function hasNextMessageInChain() {
      var streamMessage = this.queue.peek();
      if (!streamMessage) {
        return false;
      }
      var prevMsgRef = streamMessage.prevMsgRef;
      // is first message
      if (this.lastOrderedMsgRef === null) {
        return true;
      }
      if (prevMsgRef !== null) {
        // if has prev, message is chained: ensure prev points at last ordered message
        return prevMsgRef.compareTo(this.lastOrderedMsgRef) === 0;
      } else {
        // without prev, message is unchained.
        // only first message in chain should have no prev
        // This assumes it's the next message if it's newer
        // and relies on queue pre-sorting messages
        return streamMessage.getMessageRef().compareTo(this.lastOrderedMsgRef) > 0;
      }
    }

    /**
     * Keep popping messages until we hit a gap or run out of messages.
     */
  }, {
    key: "checkQueue",
    value: function checkQueue() {
      var processedMessages = 0;
      while (this.hasNextMessageInChain()) {
        processedMessages += 1;
        this.pop();
      }

      // if queue not empty then we have a gap
      if (!this.queue.isEmpty()) {
        this.scheduleGap();
        return;
      }

      // emit drain after clearing a block. If only a single item was in the
      // queue, the queue was never blocked, so it doesn't need to 'drain'.
      if (processedMessages > 1) {
        logger.trace('Drained queue', {
          processedMessages: processedMessages,
          lastMsgRef: this.lastOrderedMsgRef
        });
        this.clearGap();
        this.onDrain(processedMessages);
      }
    }

    /**
     * Remove next message from queue and run it through inOrderHandler if valid.
     */
  }, {
    key: "pop",
    value: function pop() {
      var msg = this.queue.pop();
      if (!msg) {
        return;
      }
      this.lastOrderedMsgRef = msg.getMessageRef();
      try {
        if (this.markedExplicitly.has(msg)) {
          this.markedExplicitly.delete(msg);
          if (this.isGapHandlingEnabled()) {
            logger.trace('Skipped message', {
              msgRef: msg.getMessageRef()
            });
            return msg;
          }
        }
        this.inOrderHandler(msg);
      } catch (err) {
        this.onError(err);
      }
      return msg;
    }

    /**
     * Schedule a requestGapFill call.
     */
  }, {
    key: "scheduleGap",
    value: function scheduleGap() {
      var _this = this;
      if (this.hasPendingGap) {
        return;
      }
      this.gapRequestCount = 0;
      this.hasPendingGap = true;
      if (!this.isGapHandlingEnabled()) {
        this.onGapFillsExhausted();
        return;
      }
      logger.trace('scheduleGap', {
        timeoutMs: this.gapFillTimeout
      });
      var nextGap = function nextGap(timeout) {
        clearTimeout(_this.nextGaps);
        _this.nextGaps = setTimeout( /*#__PURE__*/_asyncToGenerator(function* () {
          if (!_this.hasPendingGap) {
            return;
          }
          yield _this.requestGapFill();
          if (!_this.hasPendingGap) {
            return;
          }
          nextGap(_this.retryResendAfter);
        }), timeout);
      };
      nextGap(this.gapFillTimeout);
    }

    /**
     * Call gapHandler until run out of gapRequests.
     * Failure emits an error and sets up to continue processing enqueued messages after the gap.
     */
  }, {
    key: "requestGapFill",
    value: function () {
      var _requestGapFill = _asyncToGenerator(function* () {
        if (!this.hasPendingGap || this.isEmpty()) {
          return;
        }
        var msg = this.queue.peek();
        var lastOrderedMsgRef = this.lastOrderedMsgRef;
        if (!msg || !lastOrderedMsgRef) {
          return;
        }
        // Note: msg will always have a prevMsgRef at this point. First message
        // & unchained messages won't trigger gapfill i.e. Only chained
        // messages (messages with a prevMsgRef) can block queue processing.
        // Unchained messages arriving after queue is blocked will get
        // processed immediately if they sort earlier than the blocking message
        // or they will get queued behind the chained message and will be
        // processed unconditionally as soon as the queue is unblocked.
        var to = msg.prevMsgRef;
        var from = new _protocol.MessageRef(lastOrderedMsgRef.timestamp, lastOrderedMsgRef.sequenceNumber + 1);
        var gapRequestCount = this.gapRequestCount,
          maxGapRequests = this.maxGapRequests;
        if (gapRequestCount < maxGapRequests) {
          logger.trace('requestGapFill', {
            attemptNo: gapRequestCount + 1,
            maxAttempts: maxGapRequests,
            from: from,
            to: to
          });
          this.gapRequestCount += 1;
          try {
            yield this.gapHandler(from, to, this.context);
          } catch (err) {
            this.onError(err);
          }
        } else {
          this.onGapFillsExhausted();
        }
      });
      function requestGapFill() {
        return _requestGapFill.apply(this, arguments);
      }
      return requestGapFill;
    }()
  }, {
    key: "onGapFillsExhausted",
    value: function onGapFillsExhausted() {
      if (!this.hasPendingGap || this.isEmpty()) {
        return;
      }
      var maxGapRequests = this.maxGapRequests;
      var msg = this.queue.peek();
      var lastOrderedMsgRef = this.lastOrderedMsgRef;
      if (!msg || !lastOrderedMsgRef) {
        return;
      }
      var to = msg.prevMsgRef;
      var from = new _protocol.MessageRef(lastOrderedMsgRef.timestamp, lastOrderedMsgRef.sequenceNumber + 1);
      if (this.isGapHandlingEnabled()) {
        logger.trace('requestGapFill failed after reaching max attempts', {
          maxGapRequests: maxGapRequests,
          from: from,
          to: to
        });
      }

      // skip gap, allow queue processing to continue
      this.lastOrderedMsgRef = msg.getPreviousMessageRef();
      if (this.isGapHandlingEnabled()) {
        this.onError(new _GapFillFailedError.default(from, to, this.context, maxGapRequests));
      }
      this.clearGap();
      // keep processing
      this.checkQueue();
    }
  }]);
  return OrderedMsgChain;
}();
exports.OrderedMsgChain = OrderedMsgChain;

/***/ }),

/***/ "./src/subscribe/ordering/OrderingUtil.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.every.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _OrderedMsgChain = __webpack_require__("./src/subscribe/ordering/OrderedMsgChain.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var OrderingUtil = /*#__PURE__*/function () {
  function OrderingUtil(streamPartId, inOrderHandler, gapHandler, onDrain, onError, gapFillTimeout, retryResendAfter, maxGapRequests) {
    _classCallCheck(this, OrderingUtil);
    this.streamPartId = streamPartId;
    this.inOrderHandler = inOrderHandler;
    this.gapHandler = gapHandler;
    this.onDrain = onDrain;
    this.onError = onError;
    this.gapFillTimeout = gapFillTimeout;
    this.retryResendAfter = retryResendAfter;
    this.maxGapRequests = maxGapRequests;
    this.orderedChains = {};
  }
  _createClass(OrderingUtil, [{
    key: "add",
    value: function add(unorderedStreamMessage) {
      var chain = this.getChain(unorderedStreamMessage.getPublisherId(), unorderedStreamMessage.getMsgChainId());
      chain.add(unorderedStreamMessage);
    }
  }, {
    key: "getChain",
    value: function getChain(publisherId, msgChainId) {
      var key = publisherId + msgChainId;
      if (!this.orderedChains[key]) {
        var chain = new _OrderedMsgChain.OrderedMsgChain({
          streamPartId: this.streamPartId,
          publisherId: publisherId,
          msgChainId: msgChainId
        }, this.inOrderHandler, this.gapHandler, this.onDrain, this.onError, this.gapFillTimeout, this.retryResendAfter, this.maxGapRequests);
        this.orderedChains[key] = chain;
      }
      return this.orderedChains[key];
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return Object.values(this.orderedChains).every(function (chain) {
        return chain.isEmpty();
      });
    }
  }, {
    key: "clearGaps",
    value: function clearGaps() {
      Object.values(this.orderedChains).forEach(function (chain) {
        chain.clearGap();
      });
    }
  }, {
    key: "disable",
    value: function disable() {
      this.maxGapRequests = 0;
      Object.values(this.orderedChains).forEach(function (chain) {
        chain.disable();
      });
    }
  }]);
  return OrderingUtil;
}();
exports["default"] = OrderingUtil;
module.exports = exports.default;

/***/ }),

/***/ "./src/subscribe/subscribePipeline.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createSubscribePipeline = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-set.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.immediate.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _OrderMessages = __webpack_require__("./src/subscribe/OrderMessages.ts");
var _MessageStream = __webpack_require__("./src/subscribe/MessageStream.ts");
var _validateStreamMessage = __webpack_require__("./src/utils/validateStreamMessage.ts");
var _decrypt = __webpack_require__("./src/encryption/decrypt.ts");
var _MsgChainUtil = __webpack_require__("./src/subscribe/MsgChainUtil.ts");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _asyncGeneratorDelegate(inner) { var iter = {}, waiting = !1; function pump(key, value) { return waiting = !0, value = new Promise(function (resolve) { resolve(inner[key](value)); }), { done: !1, value: new _OverloadYield(value, 1) }; } return iter["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () { return this; }, iter.next = function (value) { return waiting ? (waiting = !1, value) : pump("next", value); }, "function" == typeof inner.throw && (iter.throw = function (value) { if (waiting) throw waiting = !1, value; return pump("throw", value); }), "function" == typeof inner.return && (iter.return = function (value) { return waiting ? (waiting = !1, value) : pump("return", value); }), iter; }
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Subscription message processing pipeline
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */
var createSubscribePipeline = function createSubscribePipeline(opts) {
  var logger = opts.loggerFactory.createLogger(module);

  /* eslint-enable object-curly-newline */

  var onError = function onError(error, streamMessage) {
    if (streamMessage) {
      ignoreMessages.add(streamMessage);
    }
    if (error && 'streamMessage' in error && error.streamMessage) {
      ignoreMessages.add(error.streamMessage);
    }
    throw error;
  };
  var messageStream = new _MessageStream.MessageStream();
  var msgChainUtil = new _MsgChainUtil.MsgChainUtil( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (msg) {
      yield (0, _validateStreamMessage.validateStreamMessage)(msg, opts.streamRegistryCached);
      if (_protocol.StreamMessage.isAESEncrypted(msg)) {
        try {
          return (0, _decrypt.decrypt)(msg, opts.groupKeyManager, opts.destroySignal);
        } catch (err) {
          // TODO log this in onError? if we want to log all errors?
          logger.debug('Failed to decrypt', {
            messageId: msg.getMessageID(),
            err: err
          });
          // clear cached permissions if cannot decrypt, likely permissions need updating
          opts.streamRegistryCached.clearStream(msg.getStreamId());
          throw err;
        }
      } else {
        return msg;
      }
    });
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }(), messageStream.onError);

  // collect messages that fail validation/parsixng, do not push out of pipeline
  // NOTE: we let failed messages be processed and only removed at end so they don't
  // end up acting as gaps that we repeatedly try to fill.
  var ignoreMessages = new WeakSet();
  messageStream.onError.listen(onError);
  if (opts.config.orderMessages) {
    // order messages (fill gaps)
    var orderMessages = new _OrderMessages.OrderMessages(opts.config, opts.resends, opts.streamPartId, opts.loggerFactory);
    messageStream.pipe(orderMessages.transform());
    messageStream.onBeforeFinally.listen(function () {
      orderMessages.stop();
    });
  }
  messageStream
  // validate & decrypt
  .pipe( /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator(function* (src) {
      setImmediate( /*#__PURE__*/_asyncToGenerator(function* () {
        var _iteratorAbruptCompletion = false;
        var _didIteratorError = false;
        var _iteratorError;
        try {
          for (var _iterator = _asyncIterator(src), _step; _iteratorAbruptCompletion = !(_step = yield _iterator.next()).done; _iteratorAbruptCompletion = false) {
            var msg = _step.value;
            {
              msgChainUtil.addMessage(msg);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (_iteratorAbruptCompletion && _iterator.return != null) {
              yield _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
        yield msgChainUtil.flush();
        msgChainUtil.stop();
      }));
      yield* _asyncGeneratorDelegate(_asyncIterator(msgChainUtil), _awaitAsyncGenerator);
    });
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }())
  // parse content
  .forEach(function (streamMessage) {
    streamMessage.getParsedContent();
  })
  // ignore any failed messages
  .filter(function (streamMessage) {
    return !ignoreMessages.has(streamMessage);
  });
  return messageStream;
};
exports.createSubscribePipeline = createSubscribePipeline;

/***/ }),

/***/ "./src/types.ts":
/***/ (() => {

"use strict";


/***/ }),

/***/ "./src/utils/AggregatedError.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AggregatedError = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.flat-map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.unscopables.flat-map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.assign.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * An Error of Errors
 * Pass an array of errors + message to create
 * Single error without throwing away other errors
 * Specifically not using AggregateError name as this has slightly different API
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
 */

function joinMessages(msgs) {
  return msgs.filter(Boolean).join('\n');
}
function getStacks(err) {
  if (err instanceof AggregatedError) {
    return [err.ownStack].concat(_toConsumableArray(_toConsumableArray(err.errors).map(function (_ref) {
      var stack = _ref.stack;
      return stack;
    })));
  }
  return [err.stack];
}
function joinStackTraces(errs) {
  return errs.flatMap(function (err) {
    return getStacks(err);
  }).filter(Boolean).join('\n');
}
var AggregatedError = /*#__PURE__*/function (_Error) {
  _inherits(AggregatedError, _Error);
  var _super = _createSuper(AggregatedError);
  function AggregatedError() {
    var _this;
    var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    _classCallCheck(this, AggregatedError);
    var message = joinMessages([errorMessage].concat(_toConsumableArray(errors.map(function (err) {
      return err.message;
    }))));
    _this = _super.call(this, message);
    errors.forEach(function (err) {
      Object.assign(_assertThisInitialized(_this), err);
    });
    _this.message = message;
    _this.ownMessage = errorMessage;
    _this.errors = new Set(errors);
    _this.ownStack = _this.stack;
    _this.stack = joinStackTraces([_assertThisInitialized(_this)].concat(_toConsumableArray(errors)));
    return _this;
  }

  /**
   * Combine any errors from Promise.allSettled into AggregatedError.
   */
  _createClass(AggregatedError, [{
    key: "extend",
    value:
    /**
     * Create a new error that adds err to list of errors
     */

    function extend(err) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var baseClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.constructor;
      if (err === this || this.errors.has(err)) {
        return this;
      }
      var errors = [err].concat(_toConsumableArray(this.errors));
      return new baseClass(errors, joinMessages([message, this.ownMessage]));
    }
  }], [{
    key: "fromAllSettled",
    value: function fromAllSettled() {
      var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var errs = results.map(function (_ref2) {
        var reason = _ref2.reason;
        return reason;
      }).filter(Boolean);
      if (!errs.length) {
        return undefined;
      }
      return new this(errs, errorMessage);
    }

    /**
     * Combine any errors from Promise.allSettled into AggregatedError and throw it.
     */
  }, {
    key: "throwAllSettled",
    value: function throwAllSettled() {
      var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var err = this.fromAllSettled(results, errorMessage);
      if (err) {
        throw err;
      }
    }

    /**
     * Handles 'upgrading' an existing error to an AggregatedError when necesary.
     */
  }, {
    key: "from",
    value: function from(oldErr, newErr, msg) {
      if (!newErr) {
        if (oldErr && msg) {
          // copy message
          oldErr.message = joinMessages([oldErr.message, msg]);
        }
        return oldErr;
      }

      // When no oldErr, just return newErr
      if (!oldErr) {
        if (newErr && msg) {
          // copy message
          newErr.message = joinMessages([newErr.message, msg]);
        }
        return newErr;
      }

      // When oldErr is an AggregatedError, extend it
      if (oldErr instanceof AggregatedError) {
        return oldErr.extend(newErr, msg, this);
      }

      // Otherwise create new AggregatedError from oldErr and newErr
      return new this([oldErr]).extend(newErr, msg);
    }
  }]);
  return AggregatedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.AggregatedError = AggregatedError;

/***/ }),

/***/ "./src/utils/Gate.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Gate = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /**
                                                                                                                                                                                                                                                                                                                                                                                               * Async Gate
                                                                                                                                                                                                                                                                                                                                                                                               * Useful for blocking actions until some condition is met.
                                                                                                                                                                                                                                                                                                                                                                                               * Starts open.
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * gate.open() Opens gate
                                                                                                                                                                                                                                                                                                                                                                                               * gate.close() Closes gate
                                                                                                                                                                                                                                                                                                                                                                                               * gate.lock() Permanently lock gate. Pending & future check calls resolve false.
                                                                                                                                                                                                                                                                                                                                                                                               * gate.check() Will async block if gate closed.
                                                                                                                                                                                                                                                                                                                                                                                               * gate.check() Calls resolve true when gate opened.
                                                                                                                                                                                                                                                                                                                                                                                               * gate.check() Calls resolve false when gate locked.
                                                                                                                                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                                                                                                                                               * ```ts
                                                                                                                                                                                                                                                                                                                                                                                               * const gate = new Gate()
                                                                                                                                                                                                                                                                                                                                                                                               * gate.close() // prevent gate.check() from resolving
                                                                                                                                                                                                                                                                                                                                                                                               * const onOpen = gate.check().then(() => console.log('opened'))
                                                                                                                                                                                                                                                                                                                                                                                               * await wait(100)
                                                                                                                                                                                                                                                                                                                                                                                               * gate.open() // onOpen will now resolve
                                                                                                                                                                                                                                                                                                                                                                                               * await gate.check() // gate is open so this will resolve immediately
                                                                                                                                                                                                                                                                                                                                                                                               * gate.close()
                                                                                                                                                                                                                                                                                                                                                                                               * // will block until open/lock is called
                                                                                                                                                                                                                                                                                                                                                                                               * const onOpenAgain = gate.check().then((isOk) => console.log('is locked?', !isOk))
                                                                                                                                                                                                                                                                                                                                                                                               * gate.lock() // prevent open/close.
                                                                                                                                                                                                                                                                                                                                                                                               * // with lock() outstanding check() calls will resolve, but with false value
                                                                                                                                                                                                                                                                                                                                                                                               * console.log(await gate.check()) // false
                                                                                                                                                                                                                                                                                                                                                                                               * console.log(await gate.check()) // false
                                                                                                                                                                                                                                                                                                                                                                                               * gate.open() // noop
                                                                                                                                                                                                                                                                                                                                                                                               * console.log(await gate.check()) // false
                                                                                                                                                                                                                                                                                                                                                                                               * gate.close() // noop
                                                                                                                                                                                                                                                                                                                                                                                               * ```
                                                                                                                                                                                                                                                                                                                                                                                               */
// This is similar to the Gate class of @streamr/utils, but implements also locking featute
// TODO remove this class if the lock() feature is no longer needed and use the class 
// from @streamr/utils instead
var Gate = /*#__PURE__*/function () {
  function Gate() {
    _classCallCheck(this, Gate);
    _defineProperty(this, "isLocked", false);
  }
  _createClass(Gate, [{
    key: "open",
    value:
    /**
     * Opens gate.
     * Pending check calls will resolve true.
     * Future check calls will resolve true, until close or lock called.
     */
    function open() {
      if (this.isLocked) {
        // do nothing
        return;
      }
      this.clearPending();
    }

    /**
     * Stops gate opening or closing. Pending and future calls will resolve false.
     */
  }, {
    key: "lock",
    value: function lock() {
      if (this.isLocked) {
        // do nothing
        return;
      }
      this.isLocked = true;
      this.clearPending();
    }

    /**
     * Opens gate but resolves pending with an error.
     * TODO: remove? might not be needed.
     */
  }, {
    key: "error",
    value: function error(err) {
      if (this.isLocked) {
        // do nothing
        return;
      }

      // this.debug('error', err)
      this.clearPending(err);
    }

    /**
     * Closes gate.
     * Noop if already closed.
     * Future check calls will block, until open or lock called.
     */
  }, {
    key: "close",
    value: function close() {
      if (this.isLocked) {
        // do nothing
        return;
      }
      if (!this.pending) {
        // this.debug('close')
        this.pending = new _utils.Defer();
      }
    }

    /**
     * Calls open/close based on shouldBeOpen parameter.
     * Convenience.
     */
  }, {
    key: "setOpenState",
    value: function setOpenState(shouldBeOpen) {
      if (shouldBeOpen) {
        this.open();
      } else {
        this.close();
      }
    }

    /**
     * @returns True iff gate is open. False if locked or closed.
     */
  }, {
    key: "isOpen",
    value: function isOpen() {
      return !this.isLocked && !this.pending;
    }
  }, {
    key: "clearPending",
    value: function clearPending(err) {
      var pending = this.pending;
      if (!pending) {
        return;
      }
      this.pending = undefined;
      if (err) {
        pending.reject(err);
      } else {
        pending.resolve(undefined);
      }
    }

    /**
     * @returns Promise<true> iff opened successfully
     */
  }, {
    key: "check",
    value: function () {
      var _check = _asyncToGenerator(function* () {
        if (this.pending) {
          yield this.pending;
        }
        return !this.isLocked;
      });
      function check() {
        return _check.apply(this, arguments);
      }
      return check;
    }()
  }]);
  return Gate;
}();
exports.Gate = Gate;

/***/ }),

/***/ "./src/utils/GeneratorUtils.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.consume = consume;
exports.counting = void 0;
exports.filter = filter;
exports.forEach = forEach;
exports.fromArray = void 0;
exports.map = map;
exports.unique = unique;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
var noopConsume = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (src) {
    // eslint-disable-next-line no-underscore-dangle
    var _iteratorAbruptCompletion = false;
    var _didIteratorError = false;
    var _iteratorError;
    try {
      for (var _iterator = _asyncIterator(src), _step; _iteratorAbruptCompletion = !(_step = yield _iterator.next()).done; _iteratorAbruptCompletion = false) {
        var _msg = _step.value;
      } // noop, just consume
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (_iteratorAbruptCompletion && _iterator.return != null) {
          yield _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  });
  return function noopConsume(_x15) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Similar to Array#forEach or Stream.PassThrough.
 * Allows inspection of a pipeline without mutating it.
 * Note: Pipeline will block until forEach call resolves.
 */
function forEach(_x, _x2, _x3) {
  return _forEach.apply(this, arguments);
}
/**
 * Similar to Array#map or Stream.Transform.
 */
function _forEach() {
  _forEach = _wrapAsyncGenerator(function* (src, fn, onError) {
    var index = 0;
    var _iteratorAbruptCompletion2 = false;
    var _didIteratorError2 = false;
    var _iteratorError2;
    try {
      for (var _iterator2 = _asyncIterator(src), _step2; _iteratorAbruptCompletion2 = !(_step2 = yield _awaitAsyncGenerator(_iterator2.next())).done; _iteratorAbruptCompletion2 = false) {
        var v = _step2.value;
        {
          try {
            yield _awaitAsyncGenerator(fn(v, index, src));
          } catch (err) {
            if (onError) {
              yield _awaitAsyncGenerator(onError(err, v, index));
              continue;
            } else {
              throw err;
            }
          } finally {
            index += 1;
          }
          yield v;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (_iteratorAbruptCompletion2 && _iterator2.return != null) {
          yield _awaitAsyncGenerator(_iterator2.return());
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  });
  return _forEach.apply(this, arguments);
}
function map(_x4, _x5, _x6) {
  return _map.apply(this, arguments);
}
/**
 * Similar to Array#filter
 */
function _map() {
  _map = _wrapAsyncGenerator(function* (src, fn, onError) {
    var index = 0;
    var _iteratorAbruptCompletion3 = false;
    var _didIteratorError3 = false;
    var _iteratorError3;
    try {
      for (var _iterator3 = _asyncIterator(src), _step3; _iteratorAbruptCompletion3 = !(_step3 = yield _awaitAsyncGenerator(_iterator3.next())).done; _iteratorAbruptCompletion3 = false) {
        var v = _step3.value;
        {
          try {
            yield yield _awaitAsyncGenerator(fn(v, index, src));
          } catch (err) {
            if (onError) {
              yield _awaitAsyncGenerator(onError(err, v, index));
              continue;
            } else {
              throw err;
            }
          } finally {
            index += 1;
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (_iteratorAbruptCompletion3 && _iterator3.return != null) {
          yield _awaitAsyncGenerator(_iterator3.return());
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  });
  return _map.apply(this, arguments);
}
function filter(_x7, _x8, _x9) {
  return _filter.apply(this, arguments);
}
/**
 * Start consuming generator.
 * Takes optional forEach function.
 */
function _filter() {
  _filter = _wrapAsyncGenerator(function* (src, fn, onError) {
    var index = 0;
    var _iteratorAbruptCompletion4 = false;
    var _didIteratorError4 = false;
    var _iteratorError4;
    try {
      for (var _iterator4 = _asyncIterator(src), _step4; _iteratorAbruptCompletion4 = !(_step4 = yield _awaitAsyncGenerator(_iterator4.next())).done; _iteratorAbruptCompletion4 = false) {
        var v = _step4.value;
        {
          var ok = void 0;
          try {
            ok = yield _awaitAsyncGenerator(fn(v, index, src));
          } catch (err) {
            if (onError) {
              yield _awaitAsyncGenerator(onError(err, v, index));
              continue;
            } else {
              throw err;
            }
          } finally {
            index += 1;
          }
          if (ok) {
            yield v;
          }
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (_iteratorAbruptCompletion4 && _iterator4.return != null) {
          yield _awaitAsyncGenerator(_iterator4.return());
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  });
  return _filter.apply(this, arguments);
}
function consume(_x16) {
  return _consume.apply(this, arguments);
}
function _consume() {
  _consume = _asyncToGenerator(function* (src) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (v) {
      return v;
    };
    var onError = arguments.length > 2 ? arguments[2] : undefined;
    return noopConsume(forEach(src, fn, onError));
  });
  return _consume.apply(this, arguments);
}
function unique(_x10, _x11) {
  return _unique.apply(this, arguments);
}
function _unique() {
  _unique = _wrapAsyncGenerator(function* (source, getIdentity) {
    var seenIdentities = new Set();
    var _iteratorAbruptCompletion5 = false;
    var _didIteratorError5 = false;
    var _iteratorError5;
    try {
      for (var _iterator5 = _asyncIterator(source), _step5; _iteratorAbruptCompletion5 = !(_step5 = yield _awaitAsyncGenerator(_iterator5.next())).done; _iteratorAbruptCompletion5 = false) {
        var _item = _step5.value;
        {
          var identity = getIdentity(_item);
          if (!seenIdentities.has(identity)) {
            seenIdentities.add(identity);
            yield _item;
          }
        }
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (_iteratorAbruptCompletion5 && _iterator5.return != null) {
          yield _awaitAsyncGenerator(_iterator5.return());
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
  });
  return _unique.apply(this, arguments);
}
var fromArray = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator(function* (items) {
    var _iterator7 = _createForOfIteratorHelper(items),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var _item2 = _step7.value;
        yield _item2;
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
  });
  return function fromArray(_x12) {
    return _ref.apply(this, arguments);
  };
}();
exports.fromArray = fromArray;
var counting = /*#__PURE__*/function () {
  var _ref2 = _wrapAsyncGenerator(function* (items, onFinally) {
    var count = 0;
    try {
      var _iteratorAbruptCompletion6 = false;
      var _didIteratorError6 = false;
      var _iteratorError6;
      try {
        for (var _iterator6 = _asyncIterator(items), _step6; _iteratorAbruptCompletion6 = !(_step6 = yield _awaitAsyncGenerator(_iterator6.next())).done; _iteratorAbruptCompletion6 = false) {
          var _item3 = _step6.value;
          {
            yield _item3;
            count++;
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (_iteratorAbruptCompletion6 && _iterator6.return != null) {
            yield _awaitAsyncGenerator(_iterator6.return());
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    } finally {
      onFinally(count);
    }
  });
  return function counting(_x13, _x14) {
    return _ref2.apply(this, arguments);
  };
}();
exports.counting = counting;

/***/ }),

/***/ "./src/utils/HttpFetcher.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.HttpFetcher = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _Config = __webpack_require__("./src/Config.ts");
var _nodeFetch = _interopRequireDefault(__webpack_require__("./src/shim/node-fetch.ts"));
var _LoggerFactory = __webpack_require__("./src/utils/LoggerFactory.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _dec, _dec2, _dec3, _dec4, _dec5, _class;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var HttpFetcher = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_LoggerFactory.LoggerFactory)(target, undefined, 0);
}, _dec3 = function _dec3(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 1);
}, _dec4 = Reflect.metadata("design:type", Function), _dec5 = Reflect.metadata("design:paramtypes", [typeof _LoggerFactory.LoggerFactory === "undefined" ? Object : _LoggerFactory.LoggerFactory, typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = /*#__PURE__*/function () {
  /** @internal */
  function HttpFetcher(loggerFactory, config) {
    _classCallCheck(this, HttpFetcher);
    this.config = config;
    this.logger = loggerFactory.createLogger(module);
  }
  _createClass(HttpFetcher, [{
    key: "fetch",
    value: function fetch(url, init) {
      // eslint-disable-next-line no-underscore-dangle
      var timeout = this.config._timeouts.httpFetchTimeout;
      this.logger.debug('Fetch', {
        url: url,
        timeout: timeout
      });
      return (0, _nodeFetch.default)(url, (0, _utils.merge)({
        timeout: timeout
      }, init));
    }
  }]);
  return HttpFetcher;
}()) || _class) || _class) || _class) || _class) || _class);
exports.HttpFetcher = HttpFetcher;

/***/ }),

/***/ "./src/utils/LoggerFactory.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoggerFactory = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _Config = __webpack_require__("./src/Config.ts");
var _dec, _dec2, _dec3, _dec4, _class;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var LoggerFactory = (_dec = (0, _tsyringe.scoped)(_tsyringe.Lifecycle.ContainerScoped), _dec2 = function _dec2(target, key) {
  return (0, _tsyringe.inject)(_Config.ConfigInjectionToken)(target, undefined, 0);
}, _dec3 = Reflect.metadata("design:type", Function), _dec4 = Reflect.metadata("design:paramtypes", [typeof Pick === "undefined" ? Object : Pick]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = /*#__PURE__*/function () {
  function LoggerFactory(config) {
    _classCallCheck(this, LoggerFactory);
    this.config = config;
  }
  _createClass(LoggerFactory, [{
    key: "createLogger",
    value: function createLogger(module) {
      return new _utils.Logger(module, {
        id: this.config.id
      }, this.config.logLevel);
    }
  }]);
  return LoggerFactory;
}()) || _class) || _class) || _class) || _class);
exports.LoggerFactory = LoggerFactory;

/***/ }),

/***/ "./src/utils/Mapping.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Mapping = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _utils = __webpack_require__("./src/utils/utils.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// an wrapper object is used so that we can store undefined values
/*
 * A map data structure which lazily evaluates values. A factory function
 * is called to create a value when when an item is queried for the first time.
 * The map stores the value and any subsequent call to get() returns
 * the same value.
 */
var Mapping = /*#__PURE__*/function () {
  function Mapping(valueFactory) {
    _classCallCheck(this, Mapping);
    _defineProperty(this, "delegate", new Map());
    this.valueFactory = valueFactory;
  }
  _createClass(Mapping, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(function* () {
        var key = _utils.formLookupKey.apply(void 0, arguments);
        var valueWrapper = this.delegate.get(key);
        if (valueWrapper === undefined) {
          var value = yield this.valueFactory.apply(this, arguments);
          valueWrapper = {
            value: value
          };
          this.delegate.set(key, valueWrapper);
        }
        return valueWrapper.value;
      });
      function get() {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }]);
  return Mapping;
}();
exports.Mapping = Mapping;

/***/ }),

/***/ "./src/utils/PatchTsyringe.ts":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var _tsyringe = __webpack_require__("../../node_modules/tsyringe/dist/esm5/index.js");
var _injectionToken = __webpack_require__("../../node_modules/tsyringe/dist/cjs/providers/injection-token.js");
var _errorHelpers = __webpack_require__("../../node_modules/tsyringe/dist/cjs/error-helpers.js");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /* eslint-disable @typescript-eslint/ban-ts-comment */ // horrible, hacky workaround to prevent tsyringe from replacing useful,
// specific errors produced by constructors with tsyringe-specific errors that
// look like "Cannot inject the dependency".  These errors lose the original
// error's stack, constructor and any additional context that was attached for
// control flow or debugging purposes e.g. err.code or err.syscall.
//
// See: https://github.com/microsoft/tsyringe/issues/177
// @ts-nocheck
// `dist` import below are intentional. Will not work properly if imported directly.
// eslint-disable-next-line no-restricted-imports
// eslint-disable-next-line no-restricted-imports
// Should be identical to original resolveParams, but replaces new Error with err.message = formatErrorCtor
// See: https://github.com/microsoft/tsyringe/blob/0cb911b799ccd0b3079629865f1a8fb04cc49658/src/dependency-container.ts#L495-L525
_tsyringe.container.constructor.prototype.resolveParams = function resolveParams(context, ctor) {
  var _this = this;
  return function (param, idx) {
    try {
      if ((0, _injectionToken.isTokenDescriptor)(param)) {
        if ((0, _injectionToken.isTransformDescriptor)(param)) {
          var _this$resolve, _this$resolve2;
          return param.multiple ? (_this$resolve = _this.resolve(param.transform)).transform.apply(_this$resolve, [_this.resolveAll(param.token)].concat(_toConsumableArray(param.transformArgs))) : (_this$resolve2 = _this.resolve(param.transform)).transform.apply(_this$resolve2, [_this.resolve(param.token, context)].concat(_toConsumableArray(param.transformArgs)));
        } else {
          return param.multiple ? _this.resolveAll(param.token) : _this.resolve(param.token, context);
        }
      } else if ((0, _injectionToken.isTransformDescriptor)(param)) {
        var _this$resolve3;
        return (_this$resolve3 = _this.resolve(param.transform, context)).transform.apply(_this$resolve3, [_this.resolve(param.token, context)].concat(_toConsumableArray(param.transformArgs)));
      }
      return _this.resolve(param, context);
    } catch (e) {
      e.message = (0, _errorHelpers.formatErrorCtor)(ctor, idx, e);
      throw e;
    }
  };
};

/***/ }),

/***/ "./src/utils/Pipeline.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Pipeline = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.assign.js");
__webpack_require__("../../node_modules/core-js/modules/web.immediate.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.reduce.js");
var _utils = __webpack_require__("./src/utils/utils.ts");
var _promises = __webpack_require__("./src/utils/promises.ts");
var _iterators = __webpack_require__("./src/utils/iterators.ts");
var G = _interopRequireWildcard(__webpack_require__("./src/utils/GeneratorUtils.ts"));
var _Signal = __webpack_require__("./src/utils/Signal.ts");
var _StreamrClientError = __webpack_require__("./src/StreamrClientError.ts");
var _Symbol$asyncIterator;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
/**
 * Pipeline public interface
 */
var PipelineDefinition = /*#__PURE__*/function () {
  function PipelineDefinition(source) {
    var transforms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    _classCallCheck(this, PipelineDefinition);
    this.source = this.setSource(source);
    this.transforms = transforms;
  }

  /**
   * Append a transformation step to this pipeline.
   * Changes the pipeline's output type to output type of this generator.
   */
  _createClass(PipelineDefinition, [{
    key: "pipe",
    value: function pipe(fn) {
      this.transforms.push(fn);
      return this;
    }
  }, {
    key: "clearTransforms",
    value: function clearTransforms() {
      this.transforms = [];
    }
  }, {
    key: "setSource",
    value: function setSource(source) {
      var id = 'id' in source ? source.id : (0, _utils.instanceId)(source, 'Source');
      this.source = Object.assign(source, {
        id: id
      });
      return this.source;
    }
  }, {
    key: "getTransforms",
    value: function getTransforms() {
      return this.transforms;
    }
  }]);
  return PipelineDefinition;
}();
_Symbol$asyncIterator = Symbol.asyncIterator;
var Pipeline = /*#__PURE__*/function () {
  function Pipeline(source, definition) {
    _classCallCheck(this, Pipeline);
    _defineProperty(this, "isIterating", false);
    _defineProperty(this, "isCleaningUp", false);
    /**
     * Triggers once when pipeline ends.
     * Usage: `pipeline.onFinally(callback)`
     */
    _defineProperty(this, "onFinally", _Signal.Signal.once());
    /**
     * Triggers once when pipeline is about to end.
     */
    _defineProperty(this, "onBeforeFinally", _Signal.Signal.once());
    _defineProperty(this, "onMessage", _Signal.Signal.create());
    _defineProperty(this, "onError", _Signal.ErrorSignal.create());
    this.source = source;
    this.definition = definition || new PipelineDefinition(source);
    this.cleanup = (0, _promises.pOnce)(this.cleanup.bind(this));
    this.iterator = (0, _iterators.iteratorFinally)(this.iterate(), this.cleanup);
    this.handleError = this.handleError.bind(this);
  }

  /**
   * Append a transformation step to this pipeline.
   * Changes the pipeline's output type to output type of this generator.
   */
  _createClass(Pipeline, [{
    key: "pipe",
    value: function pipe(fn) {
      if (this.isIterating) {
        throw new _StreamrClientError.StreamrClientError("cannot pipe after already iterating: ".concat(this.isIterating), 'PIPELINE_ERROR');
      }
      this.definition.pipe(fn);
      // this allows .pipe chaining to be type aware
      // i.e. new Pipeline(Type1).pipe(Type1 => Type2).pipe(Type2 => Type3)
      return this;
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var _this2 = this;
      return this.pipe(function (src) {
        return G.forEach(src, fn, _this2.onError.trigger);
      });
    }
  }, {
    key: "filter",
    value: function filter(fn) {
      var _this3 = this;
      return this.pipe(function (src) {
        return G.filter(src, fn, _this3.onError.trigger);
      });
    }
  }, {
    key: "flow",
    value: function flow() {
      var _this4 = this;
      setImmediate(function () {
        // consume if not already doing so
        if (!_this4.isIterating) {
          G.consume(_this4);
        }
      });
      return this;
    }
  }, {
    key: "cleanup",
    value: function () {
      var _cleanup = _asyncToGenerator(function* (error) {
        this.isCleaningUp = true;
        try {
          try {
            if (error) {
              yield this.onError.trigger(error);
            }
          } finally {
            yield this.definition.source.return(undefined);
          }
        } finally {
          yield this.onBeforeFinally.trigger();
          yield this.onFinally.trigger(error);
          this.definition.clearTransforms();
        }
      });
      function cleanup(_x) {
        return _cleanup.apply(this, arguments);
      }
      return cleanup;
    }()
  }, {
    key: "handleError",
    value: function () {
      var _handleError = _asyncToGenerator(function* (err) {
        yield this.onError.trigger(err);
      });
      function handleError(_x2) {
        return _handleError.apply(this, arguments);
      }
      return handleError;
    }()
  }, {
    key: "iterate",
    value: function iterate() {
      var _this = this;
      return _wrapAsyncGenerator(function* () {
        _this.isIterating = true;

        // this.debug('iterate', this.definition.source)
        if (!_this.definition.source) {
          throw new _StreamrClientError.StreamrClientError('no source', 'PIPELINE_ERROR');
        }
        var transforms = _this.definition.getTransforms();
        // this.debug('transforms', transforms)

        // each pipeline step creates a generator
        // which is then passed into the next transform
        // end result is output of last transform's generator
        var pipeline = transforms.reduce(function (prev, transform) {
          return transform(prev);
        }, _this.definition.source);
        try {
          var _iteratorAbruptCompletion = false;
          var _didIteratorError = false;
          var _iteratorError;
          try {
            for (var _iterator = _asyncIterator(pipeline), _step; _iteratorAbruptCompletion = !(_step = yield _awaitAsyncGenerator(_iterator.next())).done; _iteratorAbruptCompletion = false) {
              var msg = _step.value;
              {
                yield _awaitAsyncGenerator(_this.onMessage.trigger(msg));
                yield msg;
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (_iteratorAbruptCompletion && _iterator.return != null) {
                yield _awaitAsyncGenerator(_iterator.return());
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
          _this.isCleaningUp = true;
        } catch (err) {
          _this.isCleaningUp = true;
          yield _awaitAsyncGenerator(_this.handleError(err));
        } finally {
          _this.isCleaningUp = true;
          if (!_this.onBeforeFinally.triggerCount) {
            yield _awaitAsyncGenerator(_this.onBeforeFinally.trigger());
          }
        }
      })();
    }

    // AsyncGenerator implementation
  }, {
    key: "throw",
    value: function () {
      var _throw2 = _asyncToGenerator(function* (err) {
        if (this.isCleaningUp) {
          throw err;
        }
        if (!this.onBeforeFinally.triggerCount) {
          yield this.onBeforeFinally.trigger();
        }

        // eslint-disable-next-line promise/no-promise-in-callback
        yield this.definition.source.throw(err).catch(function () {});
        return this.iterator.throw(err);
      });
      function _throw(_x3) {
        return _throw2.apply(this, arguments);
      }
      return _throw;
    }()
  }, {
    key: "return",
    value: function () {
      var _return2 = _asyncToGenerator(function* (v) {
        if (this.isCleaningUp) {
          return Promise.resolve({
            done: true,
            value: v
          });
        }
        if (!this.onBeforeFinally.triggerCount) {
          yield this.onBeforeFinally.trigger();
        }
        yield this.definition.source.return(undefined);
        return this.iterator.return(v);
      });
      function _return(_x4) {
        return _return2.apply(this, arguments);
      }
      return _return;
    }()
  }, {
    key: "next",
    value: function () {
      var _next2 = _asyncToGenerator(function* () {
        return this.iterator.next();
      });
      function next() {
        return _next2.apply(this, arguments);
      }
      return next;
    }()
    /**
     * Create a new Pipeline forked from this pipeline.
     * Pushes results into fork.
     * Note: Does not start consuming this pipeline.
     */
  }, {
    key: _Symbol$asyncIterator,
    value: function value() {
      if (this.isIterating) {
        throw new _StreamrClientError.StreamrClientError('already iterating', 'PIPELINE_ERROR');
      }
      return this;
    }
  }]);
  return Pipeline;
}();
exports.Pipeline = Pipeline;

/***/ }),

/***/ "./src/utils/PushBuffer.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PushBuffer = exports.DEFAULT_BUFFER_SIZE = void 0;
exports.pull = pull;
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.is-safe-integer.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _Gate = __webpack_require__("./src/utils/Gate.ts");
var G = _interopRequireWildcard(__webpack_require__("./src/utils/GeneratorUtils.ts"));
var _StreamrClientError = __webpack_require__("./src/StreamrClientError.ts");
var _Symbol$asyncIterator;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
var DEFAULT_BUFFER_SIZE = 256;
exports.DEFAULT_BUFFER_SIZE = DEFAULT_BUFFER_SIZE;
function isError(err) {
  if (!err) {
    return false;
  }
  if (err instanceof Error) {
    return true;
  }
  return !!(err && err.stack && err.message && typeof err.stack === 'string' && typeof err.message === 'string');
}
_Symbol$asyncIterator = Symbol.asyncIterator;
/**
 * Implements an async buffer.
 * Push items into buffer, push will async block once buffer is full.
 * and will unblock once buffer has been consumed.
 */
var PushBuffer = /*#__PURE__*/function () {
  function PushBuffer() {
    var bufferSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_BUFFER_SIZE;
    _classCallCheck(this, PushBuffer);
    _defineProperty(this, "buffer", []);
    _defineProperty(this, "isIterating", false);
    if (!(bufferSize > 0 && Number.isSafeInteger(bufferSize))) {
      throw new _StreamrClientError.StreamrClientError("bufferSize must be a safe positive integer, got: ".concat(bufferSize), 'INVALID_ARGUMENT');
    }
    this.bufferSize = bufferSize;
    // start both closed
    this.writeGate = new _Gate.Gate();
    this.readGate = new _Gate.Gate();
    this.writeGate.close();
    this.readGate.close();
    this.iterator = this.iterate();
    // this.debug('create', this.bufferSize)
  }

  /**
   * Puts item in buffer and opens readGate.
   * Blocks until writeGate is open again (or locked)
   * @returns Promise<true> if item was pushed, Promise<false> if done or became done before writeGate opened.
   */
  _createClass(PushBuffer, [{
    key: "push",
    value: function () {
      var _push = _asyncToGenerator(function* (item) {
        if (!this.isWritable()) {
          return false;
        }
        this.buffer.push(item);
        this.updateWriteGate();
        this.readGate.open();
        return this.writeGate.check();
      });
      function push(_x) {
        return _push.apply(this, arguments);
      }
      return push;
    }()
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var p = new PushBuffer(this.bufferSize);
      pull(G.forEach(this, fn), p);
      return p;
    }
  }, {
    key: "filter",
    value: function filter(fn) {
      var p = new PushBuffer(this.bufferSize);
      pull(G.filter(this, fn), p);
      return p;
    }
  }, {
    key: "updateWriteGate",
    value: function updateWriteGate() {
      this.writeGate.setOpenState(!this.isFull());
    }

    /**
     * Immediate end of reading and writing
     * Buffer will not flush.
     */
  }, {
    key: "end",
    value: function end(err) {
      if (err) {
        this.error = err;
      }
      this.lock();
    }

    /**
     * Prevent further reads or writes.
     */
  }, {
    key: "lock",
    value: function lock() {
      this.writeGate.lock();
      this.readGate.lock();
    }

    /**
     * Prevent further writes.
     * Allows buffer to flush before ending.
     */
  }, {
    key: "endWrite",
    value: function endWrite(err) {
      if (err && !this.error) {
        this.error = err;
      }
      this.readGate.open();
      this.writeGate.lock();
    }

    /**
     * True if buffered at least bufferSize items.
     * After this point, push will block until buffer is emptied again.
     */
  }, {
    key: "isFull",
    value: function isFull() {
      return this.buffer.length >= this.bufferSize;
    }

    /**
     * True if buffer has closed reads and writes.
     */
  }, {
    key: "isDone",
    value: function isDone() {
      return this.writeGate.isLocked && this.readGate.isLocked;
    }

    /**
     * Can't write if write gate locked.
     * No point writing if read gate is locked.
     */
  }, {
    key: "isWritable",
    value: function isWritable() {
      return !this.writeGate.isLocked && !this.readGate.isLocked;
    }
  }, {
    key: "iterate",
    value: function iterate() {
      var _this = this;
      return _wrapAsyncGenerator(function* () {
        _this.isIterating = true;
        try {
          // if there's something buffered, we want to flush it
          while (!_this.readGate.isLocked) {
            // keep reading off front of buffer until buffer empty
            while (_this.buffer.length && !_this.readGate.isLocked) {
              var v = _this.buffer.shift();
              // maybe open write gate
              _this.updateWriteGate();
              if (isError(v)) {
                throw v;
              }
              yield v;
            }
            if (_this.buffer.length === 0 && _this.writeGate.isLocked) {
              break;
            }
            if (_this.isDone()) {
              // buffer is empty and we're done
              break;
            }

            // buffer must be empty, close readGate until more writes.
            _this.readGate.close();
            // wait for something to be written
            var ok = yield _awaitAsyncGenerator(_this.readGate.check());
            if (!ok) {
              // no more reading
              break;
            }
          }
          var _error = _this.error;
          if (_error) {
            _this.error = undefined;
            throw _error;
          }
        } finally {
          _this.buffer = [];
          _this.lock();
        }
      })();
    }
  }, {
    key: "length",
    get: function get() {
      return this.buffer.length;
    }

    // clears any pending items in buffer
  }, {
    key: "clear",
    value: function clear() {
      this.buffer = [];
    }

    // AsyncGenerator implementation
  }, {
    key: "throw",
    value: function () {
      var _throw2 = _asyncToGenerator(function* (err) {
        this.endWrite(err);
        return this.iterator.throw(err);
      });
      function _throw(_x2) {
        return _throw2.apply(this, arguments);
      }
      return _throw;
    }()
  }, {
    key: "return",
    value: function () {
      var _return2 = _asyncToGenerator(function* (v) {
        this.end();
        return this.iterator.return(v);
      });
      function _return(_x3) {
        return _return2.apply(this, arguments);
      }
      return _return;
    }()
  }, {
    key: "next",
    value: function next() {
      return this.iterator.next();
    }
  }, {
    key: "pull",
    value: function () {
      var _pull = _asyncToGenerator(function* (src) {
        try {
          var _iteratorAbruptCompletion = false;
          var _didIteratorError = false;
          var _iteratorError;
          try {
            for (var _iterator = _asyncIterator(src), _step; _iteratorAbruptCompletion = !(_step = yield _iterator.next()).done; _iteratorAbruptCompletion = false) {
              var v = _step.value;
              {
                var ok = yield this.push(v);
                if (!ok || !this.isWritable()) {
                  break;
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (_iteratorAbruptCompletion && _iterator.return != null) {
                yield _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        } catch (err) {
          // this.endWrite(err)
        }
        this.endWrite();
      });
      function pull(_x4) {
        return _pull.apply(this, arguments);
      }
      return pull;
    }()
  }, {
    key: _Symbol$asyncIterator,
    value: function value() {
      if (this.isIterating) {
        // @ts-expect-error ts can't do this.constructor properly
        throw new this.constructor.Error(this, 'already iterating');
      }
      return this;
    }
  }]);
  return PushBuffer;
}();
/**
 * Pull from a source into some PushBuffer
 */
exports.PushBuffer = PushBuffer;
function pull(_x5, _x6) {
  return _pull2.apply(this, arguments);
}
function _pull2() {
  _pull2 = _asyncToGenerator(function* (src, dest) {
    if (!src) {
      throw new Error('no source');
    }
    try {
      var _iteratorAbruptCompletion2 = false;
      var _didIteratorError2 = false;
      var _iteratorError2;
      try {
        for (var _iterator2 = _asyncIterator(src), _step2; _iteratorAbruptCompletion2 = !(_step2 = yield _iterator2.next()).done; _iteratorAbruptCompletion2 = false) {
          var v = _step2.value;
          {
            var ok = yield dest.push(v);
            if (!ok) {
              break;
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (_iteratorAbruptCompletion2 && _iterator2.return != null) {
            yield _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    } catch (err) {
      dest.endWrite(err);
    } finally {
      dest.endWrite();
    }
  });
  return _pull2.apply(this, arguments);
}

/***/ }),

/***/ "./src/utils/PushPipeline.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.get.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PushPipeline = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _PushBuffer = __webpack_require__("./src/utils/PushBuffer.ts");
var _Pipeline2 = __webpack_require__("./src/utils/Pipeline.ts");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * Pipeline that is also a PushBuffer.
 * i.e. can call .push to push data into pipeline and .pipe to transform it.
 */
var PushPipeline = /*#__PURE__*/function (_Pipeline) {
  _inherits(PushPipeline, _Pipeline);
  var _super = _createSuper(PushPipeline);
  function PushPipeline() {
    var _this;
    var bufferSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _PushBuffer.DEFAULT_BUFFER_SIZE;
    _classCallCheck(this, PushPipeline);
    var inputBuffer = new _PushBuffer.PushBuffer(bufferSize);
    _this = _super.call(this, inputBuffer);
    _this.source = inputBuffer;
    return _this;
  }
  _createClass(PushPipeline, [{
    key: "pipe",
    value: function pipe(fn) {
      // this method override just fixes the output type to be PushPipeline rather than Pipeline
      _get(_getPrototypeOf(PushPipeline.prototype), "pipe", this).call(this, fn);
      return this;
    }
  }, {
    key: "filter",
    value: function filter(fn) {
      // this method override just fixes the output type to be PushPipeline rather than Pipeline
      return _get(_getPrototypeOf(PushPipeline.prototype), "filter", this).call(this, fn);
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      // this method override just fixes the output type to be PushPipeline rather than Pipeline
      return _get(_getPrototypeOf(PushPipeline.prototype), "forEach", this).call(this, fn);
    }
  }, {
    key: "pull",
    value: function pull(source) {
      return (0, _PushBuffer.pull)(source, this);
    }

    // wrapped PushBuffer methods below here
  }, {
    key: "push",
    value: function () {
      var _push = _asyncToGenerator(function* (item) {
        return this.source.push(item);
      });
      function push(_x) {
        return _push.apply(this, arguments);
      }
      return push;
    }()
  }, {
    key: "handleError",
    value: function () {
      var _handleError = _asyncToGenerator(function* (err) {
        try {
          yield this.onError.trigger(err);
        } catch (error) {
          if (this.isCleaningUp) {
            throw error;
          }
          yield this.push(error);
        }
      });
      function handleError(_x2) {
        return _handleError.apply(this, arguments);
      }
      return handleError;
    }()
  }, {
    key: "end",
    value: function end(err) {
      return this.source.end(err);
    }
  }, {
    key: "endWrite",
    value: function endWrite(err) {
      return this.source.endWrite(err);
    }
  }, {
    key: "isDone",
    value: function isDone() {
      return this.source.isDone();
    }
  }, {
    key: "length",
    get: function get() {
      return this.source.length || 0;
    }
  }, {
    key: "clear",
    value: function clear() {
      return this.source.clear();
    }
  }]);
  return PushPipeline;
}(_Pipeline2.Pipeline);
exports.PushPipeline = PushPipeline;

/***/ }),

/***/ "./src/utils/Scaffold.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Scaffold = Scaffold;
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.reverse.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.assign.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
var _pLimit = _interopRequireDefault(__webpack_require__("./node_modules/p-limit/index.js"));
var _AggregatedError = __webpack_require__("./src/utils/AggregatedError.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/**
 * Takes a sequence of async steps & a check function.
 * While check function is true, will execute steps in order until all done.
 * Each step optionally returns a cleanup function.
 * If/when check fails (or there's an error) cleanup functions will be executed in order.
 * onChange fires when up/down direction changes.
 * onDone fires when no more up/down steps to execute.
 * onError fires when something errors. Rethrow in onError to keep error, don't rethrow to suppress.
 * returns a function which should be called whenever something changes that could affect the check.
 */
// possibly no StepDown

var noop = function noop() {};
function Scaffold() {
  var sequence = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _checkFn = arguments.length > 1 ? arguments[1] : undefined;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id,
    onError = _ref.onError,
    onDone = _ref.onDone,
    onChange = _ref.onChange;
  var error;
  // ignore error if check fails

  var nextSteps = sequence.slice().reverse().map(function (fn) {
    return /*#__PURE__*/_asyncToGenerator(function* () {
      var downFn = yield fn();
      return typeof downFn === 'function' ? downFn : noop;
    });
  });
  var prevSteps = [];
  var onDownSteps = [];
  var queue = (0, _pLimit.default)(1);
  var isDone = false;
  var didStart = false;
  function collectErrors(err) {
    try {
      if (typeof onError === 'function') {
        onError(err); // give option to suppress error
      } else {
        throw err; // rethrow
      }
    } catch (newErr) {
      error = _AggregatedError.AggregatedError.from(error, newErr, "ScaffoldError:".concat(id));
    }
  }
  var checkShouldUp = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(function* () {
      if (error) {
        return false;
      }
      try {
        return yield _checkFn();
      } catch (err) {
        collectErrors(err);
      }
      return false;
    });
    return function checkShouldUp() {
      return _ref3.apply(this, arguments);
    };
  }();
  var shouldUp = false;
  var prevShouldUp = false;
  var innerQueue = (0, _pLimit.default)(1);
  function nextScaffoldStep() {
    return _nextScaffoldStep.apply(this, arguments);
  }
  function _nextScaffoldStep() {
    _nextScaffoldStep = _asyncToGenerator(function* () {
      shouldUp = yield checkShouldUp();
      var didChange = prevShouldUp !== shouldUp;
      prevShouldUp = shouldUp;
      if (didChange && typeof onChange === 'function') {
        try {
          yield onChange(shouldUp);
        } catch (err) {
          collectErrors(err);
        }
        return nextScaffoldStep();
      }
      if (shouldUp) {
        if (nextSteps.length) {
          isDone = false;
          didStart = true;
          var onDownStep;
          var stepFn = nextSteps.pop();
          prevSteps.push(stepFn);
          try {
            onDownStep = yield stepFn();
          } catch (err) {
            collectErrors(err);
          }
          onDownSteps.push(onDownStep || function () {});
          return yield nextScaffoldStep(); // return await gives us a better stack trace
        }
      } else if (onDownSteps.length) {
        isDone = false;
        didStart = true;
        var _stepFn = onDownSteps.pop(); // exists because checked onDownSteps.length
        try {
          yield _stepFn();
        } catch (err) {
          collectErrors(err);
        }
        nextSteps.push(prevSteps.pop());
        return yield nextScaffoldStep(); // return await gives us a better stack trace
      } else if (error) {
        var _err2 = error;
        error = undefined;
        isDone = true;
        throw _err2;
      }
      isDone = true;
      return Promise.resolve();
    });
    return _nextScaffoldStep.apply(this, arguments);
  }
  function isActive() {
    return !(didStart && isDone && !queue.activeCount && !queue.pendingCount);
  }
  var nextDone = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(function* () {
      yield innerQueue(function () {
        return nextScaffoldStep();
      });
    });
    return function nextDone() {
      return _ref4.apply(this, arguments);
    };
  }();
  var currentStep;
  var queuedNext = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function* () {
      var stepErr;
      try {
        currentStep = queue(function () {
          return nextDone();
        });
        yield currentStep;
      } catch (err) {
        stepErr = err;
        throw err;
      } finally {
        if (!isActive()) {
          didStart = false;
          if (typeof onDone === 'function') {
            var _err = stepErr;
            stepErr = undefined;
            yield onDone(shouldUp, _err);
          }
        }
      }
    });
    return function queuedNext() {
      return _ref5.apply(this, arguments);
    };
  }();
  return Object.assign(queuedNext, {
    next: nextDone,
    isActive: isActive,
    getCurrentStep: function getCurrentStep() {
      return currentStep;
    },
    get activeCount() {
      return queue.activeCount;
    },
    get pendingCount() {
      return queue.pendingCount;
    },
    setError: function setError(err) {
      error = _AggregatedError.AggregatedError.from(error, err);
    },
    getError: function getError() {
      return error;
    },
    clearError: function clearError() {
      var err = error;
      error = undefined;
      return err;
    }
  });
}

/***/ }),

/***/ "./src/utils/Signal.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.get.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TRIGGER_TYPE = exports.Signal = exports.ErrorSignal = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.assign.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.find-index.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.splice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.reduce.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-set.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
var _promises = __webpack_require__("./src/utils/promises.ts");
var _Symbol$asyncIterator;
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
var TRIGGER_TYPE = /*#__PURE__*/function (TRIGGER_TYPE) {
  TRIGGER_TYPE["ONCE"] = "ONCE";
  TRIGGER_TYPE["ONE"] = "ONE";
  TRIGGER_TYPE["QUEUE"] = "QUEUE";
  TRIGGER_TYPE["PARALLEL"] = "PARALLEL";
  return TRIGGER_TYPE;
}({});
/**
 * Like an event emitter, but for a single event.  Listeners are executed
 * in-order, in an async sequence.  Any errors in listerns errors will be
 * thrown by trigger() as an AggregateError at end.
 *
 * Allows attaching onEvent properties to classes e.g.
 * ```ts
 * class Messages {
 *     onMessage = Signal.create<Message>(this)
 *     async push(msg: Message) {
 *         await this.onMessage.trigger(msg)
 *     }
 * }
 *
 * const msgs = new Messages()
 * msgs.onMessage((msg) => console.log(msg))
 * await msgs.push(new Message())
 * ```
 */
exports.TRIGGER_TYPE = TRIGGER_TYPE;
_Symbol$asyncIterator = Symbol.asyncIterator;
var Signal = /*#__PURE__*/function () {
  function Signal() {
    var _this2 = this;
    var triggerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TRIGGER_TYPE.PARALLEL;
    _classCallCheck(this, Signal);
    _defineProperty(this, "listeners", []);
    _defineProperty(this, "isEnded", false);
    _defineProperty(this, "triggerCountValue", 0);
    /**
     * No more events.
     */
    _defineProperty(this, "end", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this2.lastValue = args;
      _this2.isEnded = true;
    });
    this.triggerType = triggerType;
    this.trigger = Function.prototype.bind.call(this.trigger, this);
    switch (triggerType) {
      case TRIGGER_TYPE.ONCE:
        {
          this.trigger = (0, _promises.pOnce)(this.trigger);
          break;
        }
      case TRIGGER_TYPE.QUEUE:
        {
          this.trigger = (0, _promises.pLimitFn)(this.trigger);
          break;
        }
      case TRIGGER_TYPE.ONE:
        {
          this.trigger = (0, _promises.pOne)(this.trigger);
          break;
        }
      case TRIGGER_TYPE.PARALLEL:
        {
          // no special handling
          break;
        }
      default:
        {
          throw new Error("unknown trigger type: ".concat(triggerType));
        }
    }
  }
  _createClass(Signal, [{
    key: "triggerCount",
    value: function triggerCount() {
      return this.triggerCountValue;
    }
  }, {
    key: "wait",
    value:
    /**
     * Promise that resolves on next trigger.
     */
    function wait() {
      var _this3 = this;
      return new Promise(function (resolve) {
        _this3.once(function () {
          return resolve(arguments.length <= 0 ? undefined : arguments[0]);
        });
      });
    }
  }, {
    key: "getLastValue",
    value: function () {
      var _getLastValue = _asyncToGenerator(function* () {
        if (this.currentTask) {
          yield this.currentTask;
        }
        if (!this.lastValue) {
          throw new Error('Signal ended with no value');
        }
        return this.lastValue;
      });
      function getLastValue() {
        return _getLastValue.apply(this, arguments);
      }
      return getLastValue;
    }()
    /**
     * Attach a callback listener to this Signal.
     */
  }, {
    key: "listen",
    value: function listen(cb) {
      var _this4 = this;
      if (!cb) {
        return new Promise(function (resolve) {
          _this4.once(function () {
            resolve(arguments.length <= 0 ? undefined : arguments[0]);
          });
        });
      }
      if (this.isEnded) {
        // wait for any outstanding, ended so can't re-trigger
        this.getLastValue().then(function (args) {
          return cb.apply(void 0, _toConsumableArray(args));
        }).catch(function () {});
        return this;
      }
      this.listeners.push(cb);
      return this;
    }
  }, {
    key: "once",
    value: function once(cb) {
      var _this5 = this;
      if (!cb) {
        return this.listen();
      }
      var wrappedListener = Object.assign(function () {
        _this5.unlisten(cb);
        return cb.apply(void 0, arguments);
      }, {
        listener: cb
      });
      return this.listen(wrappedListener);
    }
  }, {
    key: "countListeners",
    value: function countListeners() {
      return this.listeners.length;
    }

    /**
     * Remove a callback listener from this Signal.
     */
  }, {
    key: "unlisten",
    value: function unlisten(cb) {
      var index = this.listeners.findIndex(function (listener) {
        return listener === cb || 'listener' in listener && listener.listener === cb;
      });
      this.listeners.splice(index, 1);
      return this;
    }
  }, {
    key: "execTrigger",
    value: function () {
      var _execTrigger = _asyncToGenerator(function* () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        if (this.isEnded) {
          return;
        }
        this.triggerCountValue += 1;

        // capture listeners
        var tasks = this.listeners.slice();
        if (this.triggerType === TRIGGER_TYPE.ONCE) {
          // remove all listeners
          this.listeners = [];
          this.end.apply(this, args);
        }
        if (!tasks.length) {
          return;
        }

        // execute tasks in sequence
        yield tasks.reduce( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(function* (prev, task) {
            yield prev;
            yield task.apply(void 0, args);
          });
          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }(), Promise.resolve());
      });
      function execTrigger() {
        return _execTrigger.apply(this, arguments);
      }
      return execTrigger;
    }()
  }, {
    key: "trigger",
    value:
    /**
     * Trigger the signal with optional value, like emitter.emit.
     */
    function () {
      var _trigger = _asyncToGenerator(function* () {
        var task = this.execTrigger.apply(this, arguments);
        this.currentTask = task;
        try {
          return yield this.currentTask;
        } finally {
          if (this.currentTask === task) {
            this.currentTask = undefined;
          }
        }
      });
      function trigger() {
        return _trigger.apply(this, arguments);
      }
      return trigger;
    }()
  }, {
    key: _Symbol$asyncIterator,
    value: function value() {
      var _this = this;
      return _wrapAsyncGenerator(function* () {
        while (!_this.isEnded) {
          yield yield _awaitAsyncGenerator(_this.listen());
        }
      })();
    }
  }], [{
    key: "create",
    value:
    /**
     *  Create a Signal's listen function with signal utility methods attached.
     *  See example above.
     */
    function create() {
      var triggerType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TRIGGER_TYPE.PARALLEL;
      return new this(triggerType);
    }

    /**
     * Will only trigger once.  Adding listeners after already fired will fire
     * listener immediately.  Calling trigger after already triggered is a
     * noop.
     */
  }, {
    key: "once",
    value: function once() {
      return this.create(TRIGGER_TYPE.ONCE);
    }

    /**
     * Only one pending trigger call at a time.  Calling trigger again while
     * listeners are pending will not trigger listeners again, and will resolve
     * when listeners are resolved.
     */
  }, {
    key: "one",
    value: function one() {
      return this.create(TRIGGER_TYPE.ONE);
    }

    /**
     * Only one pending trigger call at a time, but calling trigger again while
     * listeners are pending will enqueue the trigger until after listeners are
     * resolved.
     */
  }, {
    key: "queue",
    value: function queue() {
      return this.create(TRIGGER_TYPE.QUEUE);
    }

    /**
     * Trigger does not wait for pending trigger calls at all.
     * Listener functions are still executed in async series,
     * but multiple triggers can be active in parallel.
     */
  }, {
    key: "parallel",
    value: function parallel() {
      return this.create(TRIGGER_TYPE.PARALLEL);
    }
  }]);
  return Signal;
}();
/**
 * Special Signal for Errors.
 * Trigger this Signal to decide whether to suppress or throw err.
 * Suppress error if listeners don't rethrow
 * Throws on trigger if no listeners.
 * Won't trigger listeners for same Error instance more than once.
 */
exports.Signal = Signal;
_defineProperty(Signal, "TRIGGER_TYPE", TRIGGER_TYPE);
var ErrorSignal = /*#__PURE__*/function (_Signal) {
  _inherits(ErrorSignal, _Signal);
  var _super = _createSuper(ErrorSignal);
  function ErrorSignal() {
    var _this6;
    _classCallCheck(this, ErrorSignal);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this6 = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this6), "seenErrors", new WeakSet());
    _defineProperty(_assertThisInitialized(_this6), "ignoredErrors", new WeakSet());
    _defineProperty(_assertThisInitialized(_this6), "minListeners", 1);
    return _this6;
  }
  _createClass(ErrorSignal, [{
    key: "execTrigger",
    value: function () {
      var _execTrigger2 = _asyncToGenerator(function* () {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }
        if (this.isEnded) {
          return;
        }
        this.triggerCountValue += 1;

        // capture listeners
        var tasks = this.listeners.slice();
        if (this.triggerType === TRIGGER_TYPE.ONCE) {
          // remove all listeners
          this.listeners = [];
          this.end.apply(this, args);
        }
        if (!tasks.length) {
          return;
        }

        // execute tasks in sequence
        yield tasks.reduce( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(function* (prev, task) {
            // pass previous error to next
            try {
              yield prev;
            } catch (err) {
              // @ts-expect-error type mismatch in err parameter
              yield task(err);
              return;
            }
            yield task.apply(void 0, args);
          });
          return function (_x3, _x4) {
            return _ref2.apply(this, arguments);
          };
        }(), Promise.resolve());
      });
      function execTrigger() {
        return _execTrigger2.apply(this, arguments);
      }
      return execTrigger;
    }()
  }, {
    key: "trigger",
    value: function () {
      var _trigger2 = _asyncToGenerator(function* () {
        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }
        var err = args[0];
        // don't double-handle errors
        if (this.ignoredErrors.has(err)) {
          return;
        }
        if (this.seenErrors.has(err)) {
          // if we've seen this error, just throw
          throw err;
        }
        this.seenErrors.add(err);
        var hadMinListeners = !!(this.countListeners() >= this.minListeners);
        try {
          var _get2;
          yield (_get2 = _get(_getPrototypeOf(ErrorSignal.prototype), "trigger", this)).call.apply(_get2, [this].concat(args));
          // rethrow if no listeners
          if (!hadMinListeners) {
            throw err;
          }

          // suppress error
          this.ignoredErrors.add(err);
        } catch (nextErr) {
          // don't double handle if different error thrown
          // by onError trigger
          this.seenErrors.add(nextErr);
          throw nextErr;
        }
      });
      function trigger() {
        return _trigger2.apply(this, arguments);
      }
      return trigger;
    }()
  }]);
  return ErrorSignal;
}(Signal);
exports.ErrorSignal = ErrorSignal;

/***/ }),

/***/ "./src/utils/WebStreamToNodeStream.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.WebStreamToNodeStream = WebStreamToNodeStream;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.finally.js");
var _stream = __webpack_require__("../../node_modules/readable-stream/lib/ours/browser.js");
var _events = __webpack_require__("../../node_modules/events/events.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var ignoreAbort = function ignoreAbort(err) {
  if (err.name === 'AbortError') {
    // ignore AbortError
    return;
  }
  throw err;
};

/**
 * Write to stream.
 * Block until drained or aborted
 */
function write(_x, _x2, _x3) {
  return _write.apply(this, arguments);
}
/**
 * Background async task to pull data from the browser stream and push it into the node stream.
 */
function _write() {
  _write = _asyncToGenerator(function* (stream, data, ac) {
    if (stream.write(data)) {
      return;
    }
    yield (0, _events.once)(stream, 'drain', ac);
  });
  return _write.apply(this, arguments);
}
function pull(_x4, _x5) {
  return _pull.apply(this, arguments);
}
/**
 * Convert browser ReadableStream to Node stream.Readable.
 */
function _pull() {
  _pull = _asyncToGenerator(function* (fromBrowserStream, toNodeStream) {
    var reader = fromBrowserStream.getReader();
    /* eslint-disable no-constant-condition */
    var ac = new AbortController();
    var cleanup = function cleanup() {
      ac.abort();
    };
    reader.closed.finally(function () {
      // eslint-disable-line promise/catch-or-return
      toNodeStream.off('close', cleanup);
    });
    // toNodeStream.once('error', cleanup)

    try {
      while (true) {
        var _yield$reader$read = yield reader.read(),
          done = _yield$reader$read.done,
          value = _yield$reader$read.value;
        if (done) {
          return;
        }
        if (!toNodeStream.writable) {
          return;
        }
        yield write(toNodeStream, value, ac);
      }
    } catch (err) {
      toNodeStream.destroy(err);
      reader.cancel();
      ac.abort();
    } finally {
      reader.cancel();
      toNodeStream.end();
    }
    /* eslint-enable no-constant-condition, no-await-in-loop */
  });
  return _pull.apply(this, arguments);
}
function WebStreamToNodeStream(webStream, nodeStreamOptions) {
  if ('pipe' in webStream) {
    return webStream;
  }

  // use PassThrough so we can write to it
  var nodeStream = new _stream.PassThrough(nodeStreamOptions);
  pull(webStream, nodeStream).catch(ignoreAbort);
  return nodeStream;
}

/***/ }),

/***/ "./src/utils/caches.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CacheAsyncFn = CacheAsyncFn;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.assign.js");
var _pMemoize = _interopRequireDefault(__webpack_require__("../../node_modules/p-memoize/index.js"));
var _quickLru = _interopRequireDefault(__webpack_require__("./vendor/quick-lru/index.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _clearMatching(cache, matchFn) {
  var _iterator = _createForOfIteratorHelper(cache.keys()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _key = _step.value;
      if (matchFn(_key)) {
        cache.delete(_key);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
/**
 * Returns a cached async fn, cached keyed on first argument passed. See documentation for mem/p-memoize.
 * Caches into a LRU cache capped at options.maxSize
 * Won't call asyncFn again until options.maxAge or options.maxSize exceeded, or cachedAsyncFn.clear() is called.
 * Won't cache rejections by default. Override with options.cachePromiseRejection = true.
 *
 * ```js
 * const cachedAsyncFn = CacheAsyncFn(asyncFn, options)
 * await cachedAsyncFn(key)
 * await cachedAsyncFn(key)
 * cachedAsyncFn.clear()
 * ```
 */
function CacheAsyncFn(asyncFn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$maxSize = _ref.maxSize,
    maxSize = _ref$maxSize === void 0 ? 10000 : _ref$maxSize,
    _ref$maxAge = _ref.maxAge,
    maxAge = _ref$maxAge === void 0 ? 30 * 60 * 1000 : _ref$maxAge,
    _ref$cachePromiseReje = _ref.cachePromiseRejection,
    cachePromiseRejection = _ref$cachePromiseReje === void 0 ? false : _ref$cachePromiseReje,
    _ref$onEviction = _ref.onEviction,
    onEviction = _ref$onEviction === void 0 ? function () {} : _ref$onEviction,
    _ref$cacheKey = _ref.cacheKey,
    cacheKey = _ref$cacheKey === void 0 ? function (args) {
      return args[0];
    } : _ref$cacheKey;
  var cache = new _quickLru.default({
    maxSize: maxSize,
    maxAge: maxAge,
    onEviction: onEviction
  });
  var cachedFn = Object.assign((0, _pMemoize.default)(asyncFn, {
    cachePromiseRejection: cachePromiseRejection,
    cache: cache,
    cacheKey: cacheKey
  }), {
    clearMatching: function clearMatching(matchFn) {
      return _clearMatching(cache, matchFn);
    }
  });
  return cachedFn;
}

/***/ }),

/***/ "./src/utils/contract.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.queryAllReadonlyContracts = exports.initContractEventGateway = exports.createDecoratedContract = void 0;
exports.waitForTx = waitForTx;
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _eventemitter = _interopRequireDefault(__webpack_require__("../../node_modules/eventemitter3/index.js"));
var _networkNode = __webpack_require__("../network/src/exports-browser.ts");
var _pLimit = _interopRequireDefault(__webpack_require__("./node_modules/p-limit/index.js"));
var _promises = __webpack_require__("./src/utils/promises.ts");
var _shuffle = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/shuffle.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function waitForTx(_x) {
  return _waitForTx.apply(this, arguments);
}
function _waitForTx() {
  _waitForTx = _asyncToGenerator(function* (txToSubmit) {
    var tx = yield txToSubmit;
    return tx.wait();
  });
  return _waitForTx.apply(this, arguments);
}
var isTransaction = function isTransaction(returnValue) {
  return returnValue.wait !== undefined && typeof returnValue.wait === 'function';
};
var createLogger = function createLogger(eventEmitter, loggerFactory) {
  var logger = loggerFactory.createLogger(module);
  eventEmitter.on('onMethodExecute', function (methodName) {
    logger.debug('Execute method', {
      methodName: methodName
    });
  });
  eventEmitter.on('onTransactionSubmit', function (methodName, tx) {
    var _tx$gasPrice;
    logger.debug('Submit transaction', {
      method: methodName,
      tx: tx.hash,
      to: _networkNode.NameDirectory.getName(tx.to),
      nonce: tx.nonce,
      gasLimit: tx.gasLimit.toNumber(),
      gasPrice: (_tx$gasPrice = tx.gasPrice) === null || _tx$gasPrice === void 0 ? void 0 : _tx$gasPrice.toNumber()
    });
  });
  eventEmitter.on('onTransactionConfirm', function (methodName, tx, receipt) {
    logger.debug('Received transaction confirmation', {
      method: methodName,
      tx: tx.hash,
      block: receipt.blockNumber,
      confirmations: receipt.confirmations,
      gasUsed: receipt.gasUsed.toNumber(),
      events: (receipt.events || []).map(function (e) {
        return e.event;
      })
    });
  });
};
var withErrorHandling = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (execute, methodName) {
    try {
      return yield execute();
    } catch (e) {
      var wrappedError = new Error("Error in contract call \"".concat(methodName, "\""));
      // @ts-expect-error unknown property
      wrappedError.reason = e;
      throw wrappedError;
    }
  });
  return function withErrorHandling(_x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var createWrappedContractMethod = function createWrappedContractMethod(originalMethod, methodName, eventEmitter, concurrencyLimit) {
  return /*#__PURE__*/_asyncToGenerator(function* () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var returnValue = yield withErrorHandling(function () {
      return concurrencyLimit(function () {
        eventEmitter.emit('onMethodExecute', methodName);
        return originalMethod.apply(void 0, args);
      });
    }, methodName);
    if (isTransaction(returnValue)) {
      var _tx = returnValue;
      var originalWaitMethod = _tx.wait;
      _tx.wait = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(function* (confirmations) {
          var receipt = yield withErrorHandling(function () {
            return originalWaitMethod(confirmations);
          }, "".concat(methodName, ".wait"));
          eventEmitter.emit('onTransactionConfirm', methodName, _tx, receipt);
          return receipt;
        });
        return function (_x4) {
          return _ref3.apply(this, arguments);
        };
      }();
      eventEmitter.emit('onTransactionSubmit', methodName, _tx);
    }
    return returnValue;
  });
};

/**
 * Adds error handling, logging and limits concurrency.
 * 
 * You can use the decorated contract normally, e.g.:
 *     const tx = await contract.createFoobar(123)
 *     return await tx.wait()
 * or
 *     await contract.getFoobar(456)
 */
var createDecoratedContract = function createDecoratedContract(contract, contractName, loggerFactory, maxConcurrentCalls) {
  var eventEmitter = new _eventemitter.default();
  var methods = {};
  var concurrencyLimit = (0, _pLimit.default)(maxConcurrentCalls);
  /*
   * Wrap each contract function. We read the list of functions from contract.functions, but
   * actually delegate each method to contract[methodName]. Those methods are almost identical
   * to contract.functions[methodName] methods. The major difference is the way of handling
   * single-value results: the return type of contract.functions[methodName] is always
   * Promise<Result> (see https://docs.ethers.io/v5/api/contract/contract/#Contract--readonly)
   */
  Object.keys(contract.functions).forEach(function (methodName) {
    methods[methodName] = createWrappedContractMethod(contract[methodName], "".concat(contractName, ".").concat(methodName), eventEmitter, concurrencyLimit);
  });
  createLogger(eventEmitter, loggerFactory);
  var result = {
    eventEmitter: eventEmitter
  };
  // copy own properties and inherited properties (e.g. contract.removeAllListeners)
  for (var key in contract) {
    result[key] = methods[key] !== undefined ? methods[key] : contract[key];
  }
  return result;
};
exports.createDecoratedContract = createDecoratedContract;
var queryAllReadonlyContracts = function queryAllReadonlyContracts(call, contracts) {
  return (0, _promises.tryInSequence)((0, _shuffle.default)(contracts).map(function (contract) {
    return function () {
      return call(contract);
    };
  }));
};
exports.queryAllReadonlyContracts = queryAllReadonlyContracts;
var initContractEventGateway = function initContractEventGateway(opts) {
  var logger = opts.loggerFactory.createLogger(module);
  (0, _utils.initEventGateway)(opts.targetName, function (emit) {
    var listener = function listener() {
      var targetEvent;
      try {
        targetEvent = opts.transformation.apply(opts, arguments);
      } catch (err) {
        logger.debug('Skip emit event', {
          eventName: opts.targetName,
          reason: err === null || err === void 0 ? void 0 : err.message
        });
        return;
      }
      emit(targetEvent);
    };
    opts.sourceEmitter.on(opts.sourceName, listener);
    return listener;
  }, function (listener) {
    opts.sourceEmitter.off(opts.sourceName, listener);
  }, opts.targetEmitter);
};
exports.initContractEventGateway = initContractEventGateway;

/***/ }),

/***/ "./src/utils/iterators.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CancelableGenerator = CancelableGenerator;
exports.iteratorFinally = iteratorFinally;
exports.nextValue = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.finally.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.assign.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-map.js");
var _events = _interopRequireDefault(__webpack_require__("../../node_modules/events/events.js"));
var _pMemoize = _interopRequireDefault(__webpack_require__("../../node_modules/p-memoize/index.js"));
var _AggregatedError = __webpack_require__("./src/utils/AggregatedError.ts");
var _promises = __webpack_require__("./src/utils/promises.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _asyncGeneratorDelegate(inner) { var iter = {}, waiting = !1; function pump(key, value) { return waiting = !0, value = new Promise(function (resolve) { resolve(inner[key](value)); }), { done: !1, value: new _OverloadYield(value, 1) }; } return iter["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () { return this; }, iter.next = function (value) { return waiting ? (waiting = !1, value) : pump("next", value); }, "function" == typeof inner.throw && (iter.throw = function (value) { if (waiting) throw waiting = !1, value; return pump("throw", value); }), "function" == typeof inner.return && (iter.return = function (value) { return waiting ? (waiting = !1, value) : pump("return", value); }), iter; }
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
/**
 * Allows injecting a function to execute after an iterator finishes.
 * Executes finally function even if generator not started.
 * Returns new generator.
 */

function iteratorFinally(
// eslint-disable-line no-redeclare
iterable, onFinally) {
  if (!onFinally) {
    // noop if no onFinally
    return function () {
      var _Noop = _wrapAsyncGenerator(function* () {
        yield* _asyncGeneratorDelegate(_asyncIterator(iterable), _awaitAsyncGenerator);
      });
      function Noop() {
        return _Noop.apply(this, arguments);
      }
      return Noop;
    }()();
  }
  var started = false;
  var ended = false;
  var error;
  var onFinallyTask;
  // ensure finally only runs once
  var _onFinallyOnce = function onFinallyOnce(err) {
    if (!onFinallyTask) {
      // eslint-disable-next-line promise/no-promise-in-callback
      onFinallyTask = Promise.resolve(onFinally(err)).finally(function () {
        _onFinallyOnce = function onFinallyOnce() {};
      });
    }
    return onFinallyTask;
  };

  // wraps return/throw to call onFinally even if generator was never started
  function handleFinally(originalFn) {
    return /*#__PURE__*/_asyncToGenerator(function* () {
      // * only await onFinally if not started
      // * call original return/throw *immediately* in either case
      // Otherwise:
      // * if started, iterator won't stop until onFinally finishes
      // * if not started, iterator can still be started before onFinally finishes
      // This function handles both cases, but note here as a reminder.
      ended = true;
      if (started) {
        return originalFn.apply(void 0, arguments);
      }

      // otherwise iteration can still start if finally function still pending
      try {
        return yield originalFn.apply(void 0, arguments);
      } catch (err) {
        if (!error) {
          error = err;
        }
        throw err;
      } finally {
        yield _onFinallyOnce(error);
      }
    });
  }

  // wrap in generator to track if generator was started
  var gen = function () {
    var _TrackStarted = _wrapAsyncGenerator(function* () {
      started = true;
      try {
        yield* _asyncGeneratorDelegate(_asyncIterator(iterable), _awaitAsyncGenerator);
      } catch (err) {
        if (!error) {
          error = err;
        }
        throw err;
      } finally {
        yield _awaitAsyncGenerator(_onFinallyOnce(error));
      }
    });
    function TrackStarted() {
      return _TrackStarted.apply(this, arguments);
    }
    return TrackStarted;
  }()();
  var it = gen[Symbol.asyncIterator].bind(gen);
  var g;
  // copy cancel api across if exists
  if ('cancel' in iterable) {
    g = Object.assign(gen, {
      cancel: function cancel(err) {
        return iterable.cancel(err);
      },
      isCancelled: function isCancelled() {
        return iterable.isCancelled();
      }
    });
  } else {
    g = gen;
  }

  // replace generator methods
  return Object.assign(g, _defineProperty({
    return: handleFinally(g.return.bind(g)),
    throw: handleFinally(g.throw.bind(g))
  }, Symbol.asyncIterator, function () {
    // if ended before started
    if (ended && !started) {
      // return a generator that simply runs finally script (once)
      return function () {
        var _generatorRunFinally = _wrapAsyncGenerator(function* () {
          // eslint-disable-line require-yield
          try {
            // NOTE: native generators do not throw if gen.throw(err) called before started
            // so we should do the same here
            if ('return' in iterable) {
              yield _awaitAsyncGenerator(iterable.return(undefined)); // runs onFinally for nested iterable
            }
          } finally {
            yield _awaitAsyncGenerator(_onFinallyOnce());
          }
        });
        function generatorRunFinally() {
          return _generatorRunFinally.apply(this, arguments);
        }
        return generatorRunFinally;
      }()();
    }
    return it();
  }));
}
function endGenerator(_x, _x2) {
  return _endGenerator.apply(this, arguments);
}
function _endGenerator() {
  _endGenerator = _asyncToGenerator(function* (gtr, error) {
    return error ? gtr.throw(error).catch(function () {}) // ignore err
    : gtr.return(undefined);
  });
  return _endGenerator.apply(this, arguments);
}
function canCancel(gtr) {
  return gtr && 'cancel' in gtr && typeof gtr.cancel === 'function' && typeof gtr.isCancelled === 'function' && !gtr.isCancelled();
}
function cancelGenerator(_x3, _x4) {
  return _cancelGenerator.apply(this, arguments);
}
function _cancelGenerator() {
  _cancelGenerator = _asyncToGenerator(function* (gtr, error) {
    if (!canCancel(gtr)) {
      return;
    }
    yield gtr.cancel(error);
  });
  return _cancelGenerator.apply(this, arguments);
}
var endGeneratorTimeout = (0, _pMemoize.default)( /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (gtr, error) {
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 250;
    yield (0, _promises.pTimeout)(endGenerator(gtr, error), {
      timeout: timeout,
      rejectOnTimeout: false
    });
    if (canCancel(gtr)) {
      yield cancelGenerator(gtr, error);
    }
  });
  return function (_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}(), {
  cache: new WeakMap(),
  cachePromiseRejection: true
});

/**
 * Creates a generator that can be cancelled and perform optional final cleanup.
 * const [cancal, generator] = CancelableGenerator(iterable, onFinally)
 */
function CancelableGenerator(iterable) {
  var onFinally = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref3$timeout = _ref3.timeout,
    timeout = _ref3$timeout === void 0 ? 250 : _ref3$timeout;
  var cancelled = false;
  var finalCalled = false;
  var error;
  var cancelSignal = new _events.default();
  var onDone = new _utils.Defer();
  var iterator;
  function cancelIterable(_x7) {
    return _cancelIterable.apply(this, arguments);
  }
  function _cancelIterable() {
    _cancelIterable = _asyncToGenerator(function* (err) {
      // cancel inner if has cancel
      yield cancelGenerator(iterable, err);
      yield cancelGenerator(iterator, err);
    });
    return _cancelIterable.apply(this, arguments);
  }
  function collectErrors(value) {
    if (!value || value === error) {
      return;
    }
    if (!error) {
      error = value;
      return;
    }
    error = 'extend' in error ? error.extend(value, value.message) : new _AggregatedError.AggregatedError([value, error], value.message);
  }
  function resolveCancel(value) {
    if (value instanceof Error) {
      collectErrors(value);
    }
    if (error) {
      cancelSignal.emit('cancel', error);
    } else {
      cancelSignal.emit('cancel', value);
    }
  }
  var cancel = function cancel(gtr) {
    return /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(function* (value) {
        if (cancelled || finalCalled) {
          // prevent recursion
          return onDone;
        }
        cancelled = true;
        resolveCancel(value);

        // need to make sure we don't try return inside final otherwise we end up deadlocked
        yield endGeneratorTimeout(gtr, error, timeout);
        return onDone;
      });
      return function (_x8) {
        return _ref4.apply(this, arguments);
      };
    }();
  };
  var pendingNext = 0;
  function CancelableGeneratorFn() {
    return _CancelableGeneratorFn.apply(this, arguments);
  }
  function _CancelableGeneratorFn() {
    _CancelableGeneratorFn = _wrapAsyncGenerator(function* () {
      // manually iterate
      iterator = iterable[Symbol.asyncIterator]();
      try {
        yield* _asyncGeneratorDelegate(_asyncIterator(_defineProperty({
          // each next() races against cancel signal
          next: function () {
            var _next2 = _asyncToGenerator(function* () {
              pendingNext += 1;
              cancelSignal.setMaxListeners(pendingNext);
              // NOTE:
              // Very easy to create a memleak here.
              // Using a shared promise with Promise.race
              // between loop iterations prevents data from being GC'ed.
              // Create new per-loop promise and resolve using an event emitter.
              var cancelPromise = new _utils.Defer();
              var onCancel = function onCancel(v) {
                if (v instanceof Error) {
                  cancelPromise.reject(v);
                } else {
                  cancelPromise.resolve({
                    value: undefined,
                    done: true
                  });
                }
              };
              cancelSignal.once('cancel', onCancel);
              return Promise.race([iterator.next(), cancelPromise]).finally(function () {
                pendingNext -= 1;
                cancelSignal.setMaxListeners(pendingNext);
                cancelSignal.off('cancel', onCancel);
              });
            });
            function next() {
              return _next2.apply(this, arguments);
            }
            return next;
          }(),
          throw: function _throw(err) {
            return _asyncToGenerator(function* () {
              cancelSignal.removeAllListeners();
              yield endGeneratorTimeout(iterator, err, timeout);
              throw err;
            })();
          },
          return: function _return(v) {
            return _asyncToGenerator(function* () {
              cancelSignal.removeAllListeners();
              yield endGeneratorTimeout(iterator, error, timeout);
              return {
                value: v,
                done: true
              };
            })();
          }
        }, Symbol.asyncIterator, function () {
          return this;
        })), _awaitAsyncGenerator);
      } finally {
        cancelSignal.removeAllListeners();
        // try end iterator
        if (iterator) {
          yield _awaitAsyncGenerator(endGeneratorTimeout(iterator, error, timeout));
        }
      }
    });
    return _CancelableGeneratorFn.apply(this, arguments);
  }
  var c = CancelableGeneratorFn();
  var cancelableGenerator = iteratorFinally(c, /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(function* (err) {
      finalCalled = true;
      try {
        // cancel inner if has cancel
        yield cancelIterable(err || error);
        yield onFinally(err || error);
      } finally {
        onDone.resolve(undefined);
      }

      // error whole generator, for await of will reject.
      if (error) {
        throw error;
      }
      return onDone;
    });
    return function (_x9) {
      return _ref5.apply(this, arguments);
    };
  }());
  var cancelFn = cancel(cancelableGenerator);
  Object.assign(cancelableGenerator, {
    cancel: cancelFn,
    timeout: timeout,
    isCancelled: function isCancelled() {
      return cancelled;
    },
    isDone: function isDone() {
      return finalCalled;
    }
  });
  return cancelableGenerator;
}
var nextValue = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(function* (source) {
    var item = source.next();
    return (yield item).value;
  });
  return function nextValue(_x10) {
    return _ref6.apply(this, arguments);
  };
}();
exports.nextValue = nextValue;

/***/ }),

/***/ "./src/utils/persistence/BrowserPersistence.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _idb = __webpack_require__("../../node_modules/idb/build/index.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BrowserPersistence = /*#__PURE__*/function () {
  function BrowserPersistence(db) {
    _classCallCheck(this, BrowserPersistence);
    this.db = db;
  }
  _createClass(BrowserPersistence, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(function* (key, namespace) {
        return this.db.get(namespace, key);
      });
      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = _asyncToGenerator(function* (key, value, namespace) {
        yield this.db.put(namespace, value, key);
      });
      function set(_x3, _x4, _x5) {
        return _set.apply(this, arguments);
      }
      return set;
    }() // eslint-disable-next-line class-methods-use-this
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator(function* () {
        // noop
      });
      function close() {
        return _close.apply(this, arguments);
      }
      return close;
    }()
  }], [{
    key: "createInstance",
    value: function () {
      var _createInstance = _asyncToGenerator(function* (opts) {
        var db = yield (0, _idb.openDB)("streamr-client::".concat(opts.clientId), 1, {
          upgrade: function upgrade(db) {
            opts.namespaces.forEach(function (namespace) {
              return db.createObjectStore(namespace);
            });
          }
        });
        return new BrowserPersistence(db);
      });
      function createInstance(_x6) {
        return _createInstance.apply(this, arguments);
      }
      return createInstance;
    }()
  }]);
  return BrowserPersistence;
}();
exports["default"] = BrowserPersistence;
module.exports = exports.default;

/***/ }),

/***/ "./src/utils/promises.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TimeoutError = void 0;
exports.allSettledValues = allSettledValues;
exports.pLimitFn = pLimitFn;
exports.pOnce = pOnce;
exports.pOne = pOne;
exports.pTimeout = pTimeout;
exports.tryInSequence = void 0;
exports.until = until;
exports.withThrottling = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.assign.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.finally.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/esnext.promise.all-settled.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
var _pLimit = _interopRequireDefault(__webpack_require__("./node_modules/p-limit/index.js"));
var _pThrottle = _interopRequireDefault(__webpack_require__("../../node_modules/p-throttle/index.js"));
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _AggregatedError = __webpack_require__("./src/utils/AggregatedError.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/**
 * Returns a function that executes with limited concurrency.
 */
function pLimitFn(fn) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var queue = (0, _pLimit.default)(limit);
  return Object.assign(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return queue(function () {
      return fn.apply(void 0, args);
    });
  }, {
    clear: function clear() {
      queue.clearQueue();
    }
  });
}

/**
 * Only allows one outstanding call.
 * Returns same promise while task is executing.
 */

function pOne(fn) {
  var once = pOnce(fn);
  return /*#__PURE__*/_asyncToGenerator(function* () {
    try {
      return yield once.apply(void 0, arguments);
    } finally {
      once.reset();
    }
  });
}

/**
 * Only allows calling `fn` once.
 * Returns same promise while task is executing.
 */

function pOnce(fn) {
  var currentCall = {
    status: 'init'
  };
  return Object.assign( /*#__PURE__*/function () {
    var _pOnceWrap = _asyncToGenerator(function* () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      // eslint-disable-line prefer-arrow-callback
      // capture currentCall so can assign to it, even after reset
      var thisCall = currentCall;
      if (thisCall.status === 'pending') {
        return thisCall.promise;
      }
      if (thisCall.status === 'fulfilled') {
        return thisCall.value;
      }
      if (thisCall.status === 'rejected') {
        throw thisCall.reason;
      }

      // status === 'init'

      currentCall = thisCall;
      var promise = _asyncToGenerator(function* () {
        // capture value/error
        try {
          var value = yield fn.apply(void 0, args);
          Object.assign(thisCall, {
            promise: undefined,
            // release promise
            status: 'fulfilled',
            value: value
          });
          return value;
        } catch (reason) {
          Object.assign(thisCall, {
            promise: undefined,
            // release promise
            status: 'rejected',
            reason: reason
          });
          throw reason;
        }
      })();
      promise.catch(function () {}); // prevent unhandled
      Object.assign(thisCall, {
        status: 'pending',
        promise: promise
      });
      return promise;
    });
    function pOnceWrap() {
      return _pOnceWrap.apply(this, arguments);
    }
    return pOnceWrap;
  }(), {
    isStarted: function isStarted() {
      return currentCall.status !== 'init';
    },
    reset: function reset() {
      currentCall = {
        status: 'init'
      };
    }
  });
}
var TimeoutError = /*#__PURE__*/function (_Error) {
  _inherits(TimeoutError, _Error);
  var _super = _createSuper(TimeoutError);
  function TimeoutError() {
    var _this;
    var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    _classCallCheck(this, TimeoutError);
    _this = _super.call(this, "The operation timed out. ".concat(timeout, "ms. ").concat(msg));
    _this.timeout = timeout;
    return _this;
  }
  return _createClass(TimeoutError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Takes a promise and a timeout and an optional message for timeout errors.
 * Returns a promise that rejects when timeout expires, or when promise settles, whichever comes first.
 *
 * Invoke with positional arguments for timeout & message:
 * await pTimeout(promise, timeout, message)
 *
 * or using an options object for timeout, message & rejectOnTimeout:
 *
 * await pTimeout(promise, { timeout, message, rejectOnTimeout })
 *
 * message and rejectOnTimeout are optional.
 */
exports.TimeoutError = TimeoutError;
function pTimeout(_x) {
  return _pTimeout.apply(this, arguments);
}
/**
 * Convert allSettled results into a thrown Aggregate error if necessary.
 */
function _pTimeout() {
  _pTimeout = _asyncToGenerator(function* (promise) {
    var opts = {};
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    if (args[0] && _typeof(args[0]) === 'object') {
      opts = args[0];
    } else {
      opts.timeout = args[0];
      opts.message = args[1];
    }
    var _opts = opts,
      _opts$timeout = _opts.timeout,
      timeout = _opts$timeout === void 0 ? 0 : _opts$timeout,
      _opts$message = _opts.message,
      message = _opts$message === void 0 ? '' : _opts$message,
      _opts$rejectOnTimeout = _opts.rejectOnTimeout,
      rejectOnTimeout = _opts$rejectOnTimeout === void 0 ? true : _opts$rejectOnTimeout;
    if (typeof timeout !== 'number') {
      throw new Error("timeout must be a number, got ".concat(timeout));
    }
    var timedOut = false;
    var p = new _utils.Defer();
    var t = setTimeout(function () {
      timedOut = true;
      if (rejectOnTimeout) {
        p.reject(new TimeoutError(message, timeout));
      } else {
        p.resolve(undefined);
      }
    }, timeout);
    p.catch(function () {});
    return Promise.race([Promise.resolve(promise).catch(function (err) {
      clearTimeout(t);
      if (timedOut) {
        // ignore errors after timeout
        return undefined;
      }
      throw err;
    }), p]).finally(function () {
      clearTimeout(t);
      p.resolve(undefined);
    });
  });
  return _pTimeout.apply(this, arguments);
}
function allSettledValues(_x2) {
  return _allSettledValues.apply(this, arguments);
} // TODO use streamr-test-utils#waitForCondition instead (when streamr-test-utils is no longer a test-only dependency)
/**
 * Wait until a condition is true
 * @param condition - wait until this callback function returns true
 * @param timeOutMs - stop waiting after that many milliseconds, -1 for disable
 * @param pollingIntervalMs - check condition between so many milliseconds
 * @param failedMsgFn - append the string return value of this getter function to the error message, if given
 * @return the (last) truthy value returned by the condition function
 */
function _allSettledValues() {
  _allSettledValues = _asyncToGenerator(function* (items) {
    var errorMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var result = yield Promise.allSettled(items);
    var errs = result.filter(function (_ref4) {
      var status = _ref4.status;
      return status === 'rejected';
    }).map(function (v) {
      return v.reason;
    });
    if (errs.length) {
      throw new _AggregatedError.AggregatedError(errs, errorMessage);
    }
    return result.map(function (v) {
      return v.value;
    });
  });
  return _allSettledValues.apply(this, arguments);
}
function until(_x3) {
  return _until.apply(this, arguments);
} // TODO better type annotations
function _until() {
  _until = _asyncToGenerator(function* (condition) {
    var timeOutMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;
    var pollingIntervalMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var failedMsgFn = arguments.length > 3 ? arguments[3] : undefined;
    // condition could as well return any instead of boolean, could be convenient
    // sometimes if waiting until a value is returned. Maybe change if such use
    // case emerges.
    var err = new Error("Timeout after ".concat(timeOutMs, " milliseconds"));
    var isTimedOut = false;
    var t;
    if (timeOutMs > 0) {
      t = setTimeout(function () {
        isTimedOut = true;
      }, timeOutMs);
    }
    try {
      // Promise wrapped condition function works for normal functions just the same as Promises
      var wasDone = false;
      while (!wasDone && !isTimedOut) {
        // eslint-disable-line no-await-in-loop
        wasDone = yield Promise.resolve().then(condition); // eslint-disable-line no-await-in-loop
        if (!wasDone && !isTimedOut) {
          yield (0, _utils.wait)(pollingIntervalMs); // eslint-disable-line no-await-in-loop
        }
      }

      if (isTimedOut) {
        if (failedMsgFn) {
          err.message += " ".concat(failedMsgFn());
        }
        throw err;
      }
      return wasDone;
    } finally {
      clearTimeout(t);
    }
  });
  return _until.apply(this, arguments);
}
var withThrottling = function withThrottling(fn, maxInvocationsPerSecond) {
  var throttler = (0, _pThrottle.default)({
    limit: maxInvocationsPerSecond,
    interval: 1000
  });
  return throttler(fn);
};
exports.withThrottling = withThrottling;
var tryInSequence = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (fns) {
    if (fns.length === 0) {
      throw new Error('no tasks');
    }
    var firstError;
    var _iterator = _createForOfIteratorHelper(fns),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var fn = _step.value;
        try {
          var promise = fn();
          return yield promise;
        } catch (e) {
          if (firstError === undefined) {
            firstError = e;
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    throw firstError;
  });
  return function tryInSequence(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
exports.tryInSequence = tryInSequence;

/***/ }),

/***/ "./src/utils/signingUtils.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.recover = recover;
exports.sign = sign;
exports.verify = verify;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.starts-with.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
var _secp256k = _interopRequireDefault(__webpack_require__("../../node_modules/secp256k1/elliptic.js"));
var _sha = __webpack_require__("../../node_modules/sha3/index.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SIGN_MAGIC = "\x19Ethereum Signed Message:\n";
var keccak = new _sha.Keccak(256);

/**
 * Contains functions to creates and verifies standard Ethereum signatures.
 * These are a faster implementation than found in ether.js library. They are
 * compatible with e.g. ether.js's verifyMessage and signMessage functions.
 *
 * In Node environment the performance is significantly better compared
 * to ether.js v5.5.0.
 *
 * See test/benchmark/SigningUtils.ts and the original PR:
 * https://github.com/streamr-dev/streamr-client-protocol-js/pull/35
 */

function hash(messageBuffer) {
  var prefixString = SIGN_MAGIC + messageBuffer.length;
  var merged = Buffer.concat([Buffer.from(prefixString, 'utf-8'), messageBuffer]);
  keccak.reset();
  keccak.update(merged);
  return keccak.digest('binary');
}
function recoverPublicKey(signatureBuffer, payloadBuffer) {
  var recoveryId = signatureBuffer.readUInt8(signatureBuffer.length - 1) - 27;
  return _secp256k.default.ecdsaRecover(signatureBuffer.subarray(0, signatureBuffer.length - 1), recoveryId, hash(payloadBuffer), false, Buffer.alloc);
}
function normalize(privateKeyOrAddress) {
  return privateKeyOrAddress.startsWith('0x') ? privateKeyOrAddress.substring(2) : privateKeyOrAddress;
}
function sign(payload, privateKey) {
  var payloadBuffer = Buffer.from(payload, 'utf-8');
  var privateKeyBuffer = Buffer.from(normalize(privateKey), 'hex');
  var msgHash = hash(payloadBuffer);
  var sigObj = _secp256k.default.ecdsaSign(msgHash, privateKeyBuffer);
  var result = Buffer.alloc(sigObj.signature.length + 1, Buffer.from(sigObj.signature));
  result.writeInt8(27 + sigObj.recid, result.length - 1);
  return '0x' + result.toString('hex');
}
function recover(signature, payload) {
  var publicKeyBuffer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  var signatureBuffer = Buffer.from(normalize(signature), 'hex'); // remove '0x' prefix
  var payloadBuffer = Buffer.from(payload, 'utf-8');
  if (!publicKeyBuffer) {
    publicKeyBuffer = recoverPublicKey(signatureBuffer, payloadBuffer);
  }
  var pubKeyWithoutFirstByte = publicKeyBuffer.subarray(1, publicKeyBuffer.length);
  keccak.reset();
  keccak.update(Buffer.from(pubKeyWithoutFirstByte));
  var hashOfPubKey = keccak.digest('binary');
  return '0x' + hashOfPubKey.subarray(12, hashOfPubKey.length).toString('hex');
}
function verify(address, payload, signature) {
  try {
    var recoveredAddress = (0, _utils.toEthereumAddress)(recover(signature, payload));
    return recoveredAddress === address;
  } catch (err) {
    return false;
  }
}

/***/ }),

/***/ "./src/utils/utils.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.formLookupKey = exports.createTheGraphClient = exports.counterId = exports.MaxSizedSet = exports.CounterId = void 0;
exports.formStorageNodeAssignmentStreamId = formStorageNodeAssignmentStreamId;
exports.generateClientId = generateClientId;
exports.getEndpointUrl = void 0;
exports.instanceId = instanceId;
__webpack_require__("../../node_modules/core-js/modules/es.number.max-safe-integer.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _quickLru = _interopRequireDefault(__webpack_require__("./vendor/quick-lru/index.js"));
var _uuid = __webpack_require__("./src/utils/uuid.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Generates counter-based ids.
 * Basically lodash.uniqueid but per-prefix.
 * Not universally unique.
 * Generally useful for tracking instances.
 *
 * Careful not to use too many prefixes since it needs to hold all prefixes in memory
 * e.g. don't pass new uuid as a prefix
 *
 * counterId('test') => test.0
 * counterId('test') => test.1
 */

// TODO convert to a class?

var CounterId = function CounterId(rootPrefix) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$maxPrefixes = _ref.maxPrefixes,
    maxPrefixes = _ref$maxPrefixes === void 0 ? 256 : _ref$maxPrefixes;
  var counts = {}; // possible we could switch this to WeakMap and pass functions or classes.
  var didWarn = false;
  var counterIdFn = function counterIdFn() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'ID';
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _uuid.SEPARATOR;
    // pedantic: wrap around if count grows too large
    counts[prefix] = (counts[prefix] + 1 || 0) % Number.MAX_SAFE_INTEGER;

    // warn once if too many prefixes
    if (!didWarn) {
      var numTracked = Object.keys(counts).length;
      if (numTracked > maxPrefixes) {
        didWarn = true;
        console.warn("counterId should not be used for a large number of unique prefixes: ".concat(numTracked, " > ").concat(maxPrefixes));
      }
    }

    // connect prefix with separator
    return [rootPrefix, prefix, counts[prefix]].filter(function (v) {
      return v != null;
    }) // remove {root}Prefix if not set
    .join(separator);
  };

  /**
   * Clears counts for prefix or all if no prefix supplied.
   *
   * @param {string?} prefix
   */
  counterIdFn.clear = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    // check length to differentiate between clear(undefined) & clear()
    if (args.length) {
      var _prefix = args[0];
      delete counts[_prefix];
    } else {
      // clear all
      counts = {};
    }
  };
  return counterIdFn;
};
exports.CounterId = CounterId;
var counterId = CounterId();
exports.counterId = counterId;
function instanceId(instance) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return counterId(instance.constructor.name) + suffix;
}
var getEndpointUrl = function getEndpointUrl(baseUrl) {
  for (var _len2 = arguments.length, pathParts = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    pathParts[_key2 - 1] = arguments[_key2];
  }
  return baseUrl + '/' + pathParts.map(function (part) {
    return encodeURIComponent(part);
  }).join('/');
};
exports.getEndpointUrl = getEndpointUrl;
function formStorageNodeAssignmentStreamId(clusterAddress) {
  return (0, _protocol.toStreamID)('/assignments', (0, _utils.toEthereumAddress)(clusterAddress));
}
var MaxSizedSet = /*#__PURE__*/function () {
  function MaxSizedSet(maxSize) {
    _classCallCheck(this, MaxSizedSet);
    this.delegate = new _quickLru.default({
      maxSize: maxSize
    });
  }
  _createClass(MaxSizedSet, [{
    key: "add",
    value: function add(value) {
      this.delegate.set(value, true);
    }
  }, {
    key: "has",
    value: function has(value) {
      return this.delegate.has(value);
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      this.delegate.delete(value);
    }
  }]);
  return MaxSizedSet;
}();
exports.MaxSizedSet = MaxSizedSet;
function generateClientId() {
  return counterId(process.pid ? "".concat(process.pid) : (0, _utils.randomString)(4), '/');
}

// A unique internal identifier to some list of primitive values. Useful
// e.g. as a map key or a cache key.
var formLookupKey = function formLookupKey() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }
  return args.join('|');
};

/** @internal */
exports.formLookupKey = formLookupKey;
var createTheGraphClient = function createTheGraphClient(httpFetcher, eventEmitter, config) {
  var instance = new _utils.TheGraphClient({
    serverUrl: config.contracts.theGraphUrl,
    fetch: function fetch(url, init) {
      return httpFetcher.fetch(url, init);
    },
    // eslint-disable-next-line no-underscore-dangle
    indexTimeout: config._timeouts.theGraph.timeout,
    // eslint-disable-next-line no-underscore-dangle
    indexPollInterval: config._timeouts.theGraph.retryInterval
  });
  eventEmitter.on('confirmContractTransaction', function (payload) {
    instance.updateRequiredBlockNumber(payload.receipt.blockNumber);
  });
  return instance;
};
exports.createTheGraphClient = createTheGraphClient;

/***/ }),

/***/ "./src/utils/uuid.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SEPARATOR = void 0;
exports.uuid = uuid;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var _uuid = __webpack_require__("./node_modules/uuid/dist/commonjs-browser/index.js");
var _uniqueId = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/uniqueId.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SEPARATOR = '-';
exports.SEPARATOR = SEPARATOR;
var UUID;
function uuid() {
  var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (typeof UUID === 'undefined') {
    // Create UUID on the first use of the function in order to avoid premature `uuidv4` calls.
    // Doing it outside will break browser projects that utilize server-side rendering (no
    // `window` while build's target is `web`).
    UUID = (0, _uuid.v4)();
  }

  // Incrementing + human readable uuid
  return (0, _uniqueId.default)("".concat(UUID).concat(label ? "".concat(SEPARATOR).concat(label) : ''));
}

/***/ }),

/***/ "./src/utils/validateStreamMessage.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.validateStreamMessage = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _signingUtils = __webpack_require__("./src/utils/signingUtils.ts");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var validateStreamMessage = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (msg, streamRegistry) {
    yield doValidate(msg, streamRegistry).catch(function (err) {
      // all StreamMessageError already have this streamMessage, maybe this is 
      // here if e.g. contract call fails? TODO is this really needed as
      // the onError callback in subscribePipeline knows which message
      // it is handling?
      if (!err.streamMessage) {
        err.streamMessage = msg;
      }
      throw err;
    });
  });
  return function validateStreamMessage(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Checks that the given StreamMessage satisfies the requirements of the protocol.
 * This includes checking permissions as well as signature. The method supports all
 * message types defined by the protocol.
 *
 * Resolves the promise if the message is valid, rejects otherwise.
 *
 * @param streamMessage the StreamMessage to validate.
 */
exports.validateStreamMessage = validateStreamMessage;
var doValidate = function doValidate(streamMessage, streamRegistry) {
  assertSignatureIsValid(streamMessage);
  switch (streamMessage.messageType) {
    case _protocol.StreamMessageType.MESSAGE:
      return validateMessage(streamMessage, streamRegistry);
    case _protocol.StreamMessageType.GROUP_KEY_REQUEST:
      return validateGroupKeyMessage(streamMessage, _protocol.GroupKeyMessage.fromStreamMessage(streamMessage).recipient, streamMessage.getPublisherId(), streamRegistry);
    case _protocol.StreamMessageType.GROUP_KEY_RESPONSE:
      return validateGroupKeyMessage(streamMessage, streamMessage.getPublisherId(), _protocol.GroupKeyMessage.fromStreamMessage(streamMessage).recipient, streamRegistry);
    default:
      throw new _protocol.StreamMessageError("Unknown message type: ".concat(streamMessage.messageType, "!"), streamMessage);
  }
};

/**
 * Checks that the signature in the given StreamMessage is cryptographically valid.
 * Resolves if valid, rejects otherwise.
 *
 * @param streamMessage the StreamMessage to validate.
 */
var assertSignatureIsValid = function assertSignatureIsValid(streamMessage) {
  var _streamMessage$prevMs, _streamMessage$newGro;
  var payload = (0, _protocol.createSignaturePayload)({
    messageId: streamMessage.getMessageID(),
    serializedContent: streamMessage.getSerializedContent(),
    prevMsgRef: (_streamMessage$prevMs = streamMessage.prevMsgRef) !== null && _streamMessage$prevMs !== void 0 ? _streamMessage$prevMs : undefined,
    newGroupKey: (_streamMessage$newGro = streamMessage.newGroupKey) !== null && _streamMessage$newGro !== void 0 ? _streamMessage$newGro : undefined
  });
  var success;
  try {
    success = (0, _signingUtils.verify)(streamMessage.getPublisherId(), payload, streamMessage.signature);
  } catch (err) {
    throw new _protocol.StreamMessageError("An error occurred during address recovery from signature: ".concat(err), streamMessage);
  }
  if (!success) {
    throw new _protocol.StreamMessageError('Signature validation failed', streamMessage);
  }
};
var validateMessage = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (streamMessage, streamRegistry) {
    var streamId = streamMessage.getStreamId();
    var stream = yield streamRegistry.getStream(streamId);
    var partitionCount = stream.getMetadata().partitions;
    if (streamMessage.getStreamPartition() < 0 || streamMessage.getStreamPartition() >= partitionCount) {
      throw new _protocol.StreamMessageError("Partition ".concat(streamMessage.getStreamPartition(), " is out of range (0..").concat(partitionCount - 1, ")"), streamMessage);
    }
    var sender = streamMessage.getPublisherId();
    var isPublisher = yield streamRegistry.isStreamPublisher(streamId, sender);
    if (!isPublisher) {
      throw new _protocol.StreamMessageError("".concat(sender, " is not a publisher on stream ").concat(streamId), streamMessage);
    }
  });
  return function validateMessage(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var validateGroupKeyMessage = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(function* (streamMessage, expectedPublisher, expectedSubscriber, streamRegistry) {
    var streamId = streamMessage.getStreamId();
    var isPublisher = yield streamRegistry.isStreamPublisher(streamId, expectedPublisher);
    if (!isPublisher) {
      throw new _protocol.StreamMessageError("".concat(expectedPublisher, " is not a publisher on stream ").concat(streamId), streamMessage);
    }
    var isSubscriber = yield streamRegistry.isStreamSubscriber(streamId, expectedSubscriber);
    if (!isSubscriber) {
      throw new _protocol.StreamMessageError("".concat(expectedSubscriber, " is not a subscriber on stream ").concat(streamId), streamMessage);
    }
  });
  return function validateGroupKeyMessage(_x5, _x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./src/utils/waitForAssignmentsToPropagate.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.waitForAssignmentsToPropagate = waitForAssignmentsToPropagate;
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
function waitForAssignmentsToPropagate(_x, _x2, _x3) {
  return _waitForAssignmentsToPropagate.apply(this, arguments);
}
function _waitForAssignmentsToPropagate() {
  _waitForAssignmentsToPropagate = _asyncToGenerator(function* (messages, targetStream, loggerFactory) {
    var foundPartitions = new Set();
    var _iteratorAbruptCompletion = false;
    var _didIteratorError = false;
    var _iteratorError;
    try {
      for (var _iterator = _asyncIterator(messages), _step; _iteratorAbruptCompletion = !(_step = yield _iterator.next()).done; _iteratorAbruptCompletion = false) {
        var msg = _step.value;
        {
          var streamPart = msg.getParsedContent().streamPart;
          try {
            var streamPartId = _protocol.StreamPartIDUtils.parse(streamPart);
            var _StreamPartIDUtils$ge = _protocol.StreamPartIDUtils.getStreamIDAndPartition(streamPartId),
              _StreamPartIDUtils$ge2 = _slicedToArray(_StreamPartIDUtils$ge, 2),
              streamId = _StreamPartIDUtils$ge2[0],
              partition = _StreamPartIDUtils$ge2[1];
            if (streamId === targetStream.id && partition < targetStream.partitions) {
              foundPartitions.add(partition);
              if (foundPartitions.size === targetStream.partitions) {
                return;
              }
            }
          } catch (_unused) {
            loggerFactory.createLogger(module).debug('Ignore malformed content');
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (_iteratorAbruptCompletion && _iterator.return != null) {
          yield _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  });
  return _waitForAssignmentsToPropagate.apply(this, arguments);
}

/***/ }),

/***/ "./vendor/quick-lru/index.js":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-string-tag.js");
__webpack_require__("../../node_modules/core-js/modules/es.json.to-string-tag.js");
__webpack_require__("../../node_modules/core-js/modules/es.math.to-string-tag.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var QuickLRU = /*#__PURE__*/function (_Map, _Symbol$iterator, _Symbol$toStringTag) {
  _inherits(QuickLRU, _Map);
  var _super = _createSuper(QuickLRU);
  function QuickLRU() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, QuickLRU);
    _this = _super.call(this);
    if (!(options.maxSize && options.maxSize > 0)) {
      throw new TypeError('`maxSize` must be a number greater than 0');
    }
    if (typeof options.maxAge === 'number' && options.maxAge === 0) {
      throw new TypeError('`maxAge` must be a number greater than 0');
    }

    // TODO: Use private class fields when ESLint supports them.
    _this.maxSize = options.maxSize;
    _this.maxAge = options.maxAge || Number.POSITIVE_INFINITY;
    _this.onEviction = options.onEviction;
    _this.cache = new Map();
    _this.oldCache = new Map();
    _this._size = 0;
    return _this;
  }

  // TODO: Use private class methods when targeting Node.js 16.
  _createClass(QuickLRU, [{
    key: "_emitEvictions",
    value: function _emitEvictions(cache) {
      if (typeof this.onEviction !== 'function') {
        return;
      }
      var _iterator = _createForOfIteratorHelper(cache),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            item = _step$value[1];
          this.onEviction(key, item.value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_deleteIfExpired",
    value: function _deleteIfExpired(key, item) {
      if (typeof item.expiry === 'number' && item.expiry <= Date.now()) {
        if (typeof this.onEviction === 'function') {
          this.onEviction(key, item.value);
        }
        return this.delete(key);
      }
      return false;
    }
  }, {
    key: "_getOrDeleteIfExpired",
    value: function _getOrDeleteIfExpired(key, item) {
      var deleted = this._deleteIfExpired(key, item);
      if (deleted === false) {
        return item.value;
      }
    }
  }, {
    key: "_getItemValue",
    value: function _getItemValue(key, item) {
      return item.expiry ? this._getOrDeleteIfExpired(key, item) : item.value;
    }
  }, {
    key: "_peek",
    value: function _peek(key, cache) {
      var item = cache.get(key);
      return this._getItemValue(key, item);
    }
  }, {
    key: "_set",
    value: function _set(key, value) {
      this.cache.set(key, value);
      this._size++;
      if (this._size >= this.maxSize) {
        this._size = 0;
        this._emitEvictions(this.oldCache);
        this.oldCache = this.cache;
        this.cache = new Map();
      }
    }
  }, {
    key: "_moveToRecent",
    value: function _moveToRecent(key, item) {
      this.oldCache.delete(key);
      this._set(key, item);
    }
  }, {
    key: "_entriesAscending",
    value: function* _entriesAscending() {
      var _iterator2 = _createForOfIteratorHelper(this.oldCache),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          var _item = _slicedToArray(item, 2),
            key = _item[0],
            value = _item[1];
          if (!this.cache.has(key)) {
            var deleted = this._deleteIfExpired(key, value);
            if (deleted === false) {
              yield item;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(this.cache),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _item2 = _step3.value;
          var _item3 = _slicedToArray(_item2, 2),
            _key = _item3[0],
            _value = _item3[1];
          var _deleted = this._deleteIfExpired(_key, _value);
          if (_deleted === false) {
            yield _item2;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      if (this.cache.has(key)) {
        var item = this.cache.get(key);
        return this._getItemValue(key, item);
      }
      if (this.oldCache.has(key)) {
        var _item4 = this.oldCache.get(key);
        if (this._deleteIfExpired(key, _item4) === false) {
          this._moveToRecent(key, _item4);
          return _item4.value;
        }
      }
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$maxAge = _ref.maxAge,
        maxAge = _ref$maxAge === void 0 ? this.maxAge : _ref$maxAge;
      var expiry = typeof maxAge === 'number' && maxAge !== Number.POSITIVE_INFINITY ? Date.now() + maxAge : undefined;
      if (this.cache.has(key)) {
        this.cache.set(key, {
          value: value,
          expiry: expiry
        });
      } else {
        this._set(key, {
          value: value,
          expiry: expiry
        });
      }
    }
  }, {
    key: "has",
    value: function has(key) {
      if (this.cache.has(key)) {
        return !this._deleteIfExpired(key, this.cache.get(key));
      }
      if (this.oldCache.has(key)) {
        return !this._deleteIfExpired(key, this.oldCache.get(key));
      }
      return false;
    }
  }, {
    key: "peek",
    value: function peek(key) {
      if (this.cache.has(key)) {
        return this._peek(key, this.cache);
      }
      if (this.oldCache.has(key)) {
        return this._peek(key, this.oldCache);
      }
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var deleted = this.cache.delete(key);
      if (deleted) {
        this._size--;
      }
      return this.oldCache.delete(key) || deleted;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cache.clear();
      this.oldCache.clear();
      this._size = 0;
    }
  }, {
    key: "resize",
    value: function resize(newSize) {
      if (!(newSize && newSize > 0)) {
        throw new TypeError('`maxSize` must be a number greater than 0');
      }
      var items = _toConsumableArray(this._entriesAscending());
      var removeCount = items.length - newSize;
      if (removeCount < 0) {
        this.cache = new Map(items);
        this.oldCache = new Map();
        this._size = items.length;
      } else {
        if (removeCount > 0) {
          this._emitEvictions(items.slice(0, removeCount));
        }
        this.oldCache = new Map(items.slice(removeCount));
        this.cache = new Map();
        this._size = 0;
      }
      this.maxSize = newSize;
    }
  }, {
    key: "keys",
    value: function* keys() {
      var _iterator4 = _createForOfIteratorHelper(this),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 1),
            key = _step4$value[0];
          yield key;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "values",
    value: function* values() {
      var _iterator5 = _createForOfIteratorHelper(this),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
            value = _step5$value[1];
          yield value;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: _Symbol$iterator,
    value: function* value() {
      var _iterator6 = _createForOfIteratorHelper(this.cache),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var item = _step6.value;
          var _item5 = _slicedToArray(item, 2),
            key = _item5[0],
            value = _item5[1];
          var deleted = this._deleteIfExpired(key, value);
          if (deleted === false) {
            yield [key, value.value];
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      var _iterator7 = _createForOfIteratorHelper(this.oldCache),
        _step7;
      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _item6 = _step7.value;
          var _item7 = _slicedToArray(_item6, 2),
            _key2 = _item7[0],
            _value2 = _item7[1];
          if (!this.cache.has(_key2)) {
            var _deleted2 = this._deleteIfExpired(_key2, _value2);
            if (_deleted2 === false) {
              yield [_key2, _value2.value];
            }
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  }, {
    key: "entriesDescending",
    value: function* entriesDescending() {
      var items = _toConsumableArray(this.cache);
      for (var i = items.length - 1; i >= 0; --i) {
        var item = items[i];
        var _item8 = _slicedToArray(item, 2),
          key = _item8[0],
          value = _item8[1];
        var deleted = this._deleteIfExpired(key, value);
        if (deleted === false) {
          yield [key, value.value];
        }
      }
      items = _toConsumableArray(this.oldCache);
      for (var _i2 = items.length - 1; _i2 >= 0; --_i2) {
        var _item9 = items[_i2];
        var _item10 = _slicedToArray(_item9, 2),
          _key3 = _item10[0],
          _value3 = _item10[1];
        if (!this.cache.has(_key3)) {
          var _deleted3 = this._deleteIfExpired(_key3, _value3);
          if (_deleted3 === false) {
            yield [_key3, _value3.value];
          }
        }
      }
    }
  }, {
    key: "entriesAscending",
    value: function* entriesAscending() {
      var _iterator8 = _createForOfIteratorHelper(this._entriesAscending()),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _step8$value = _slicedToArray(_step8.value, 2),
            key = _step8$value[0],
            value = _step8$value[1];
          yield [key, value.value];
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "size",
    get: function get() {
      if (!this._size) {
        return this.oldCache.size;
      }
      var oldCacheSize = 0;
      var _iterator9 = _createForOfIteratorHelper(this.oldCache.keys()),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var key = _step9.value;
          if (!this.cache.has(key)) {
            oldCacheSize++;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return Math.min(this._size + oldCacheSize, this.maxSize);
    }
  }, {
    key: "entries",
    value: function entries() {
      return this.entriesAscending();
    }
  }, {
    key: "forEach",
    value: function forEach(callbackFunction) {
      var thisArgument = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      var _iterator10 = _createForOfIteratorHelper(this.entriesAscending()),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _step10$value = _slicedToArray(_step10.value, 2),
            key = _step10$value[0],
            value = _step10$value[1];
          callbackFunction.call(thisArgument, value, key, this);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }, {
    key: _Symbol$toStringTag,
    get: function get() {
      return JSON.stringify(_toConsumableArray(this.entriesAscending()));
    }
  }]);
  return QuickLRU;
}( /*#__PURE__*/_wrapNativeSuper(Map), Symbol.iterator, Symbol.toStringTag);
exports["default"] = QuickLRU;
module.exports = exports.default;

/***/ }),

/***/ "../network/src/NameDirectory.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.NameDirectory = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 * Get human-readable names for some Ethereum addresses in Streamr test environment
 * The list doesn't contain all known contract addresses or nodes, but we can add more
 * addresses if needed.
 * 
 * Currently contains hardcoded names for all streamr-docker-dev Broker/Tracker entities
 * -> in the future each node receives the peer names from Tracker
 *    and we can remove the hardcoded values
 */

var NAMES = {
  '0xb9e7cebf7b03ae26458e32a059488386b05798e8': 'T1',
  '0x0540a3e144cdd81f402e7772c76a5808b71d2d30': 'T2',
  '0xf2c195be194a2c91e93eacb1d6d55a00552a85e2': 'T3',
  '0xde1112f631486cfc759a50196853011528bc5fa0': 'S1',
  '0xde222e8603fcf641f928e5f66a0cbf4de70d5352': 'B1',
  '0xde3331ca6b8b636e0b82bf08e941f727b8927442': 'B2',
  '0x6ccdd5d866ea766f6df5965aa98deccd629ff222': 'DOCKER_DEV_STREAM_REGISTRY',
  '0xd04af489677001444280366dd0885b03daade71d': 'DOCKER_DEV_STREAM_STORAGE_REGISTRY',
  '0x231b810d98702782963472e1d60a25496999e75d': 'DOCKER_DEV_STORAGE_NODE_REGISTRY'
};

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var NameDirectory = /*#__PURE__*/function () {
  function NameDirectory() {
    _classCallCheck(this, NameDirectory);
  }
  _createClass(NameDirectory, null, [{
    key: "getName",
    value:
    // if name is not known, creates a short name from the address
    function getName(address) {
      if (address === undefined) {
        return undefined;
      }
      var name = NAMES[address.toLowerCase()];
      if (name !== undefined) {
        return name;
      } else {
        return address.length > NameDirectory.MAX_FALLBACK_NAME_LENGTH ? address.substring(0, this.MAX_FALLBACK_NAME_LENGTH) : address;
      }
    }
  }]);
  return NameDirectory;
}();
exports.NameDirectory = NameDirectory;
_defineProperty(NameDirectory, "MAX_FALLBACK_NAME_LENGTH", 8);

/***/ }),

/***/ "../network/src/connection/MessageQueue.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.QueueItem = exports.MessageQueue = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _heap = _interopRequireDefault(__webpack_require__("../../node_modules/heap/index.js"));
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var QueueItem = /*#__PURE__*/function () {
  function QueueItem(message, onSuccess, onError) {
    _classCallCheck(this, QueueItem);
    this.message = message;
    this.onSuccess = onSuccess;
    this.onError = onError;
    this.errorInfos = [];
    this.no = QueueItem.nextNumber++;
    this.tries = 0;
    this.failed = false;
  }
  _createClass(QueueItem, [{
    key: "getMessage",
    value: function getMessage() {
      return this.message;
    }
  }, {
    key: "getErrorInfos",
    value: function getErrorInfos() {
      return this.errorInfos;
    }
  }, {
    key: "isFailed",
    value: function isFailed() {
      return this.failed;
    }
  }, {
    key: "delivered",
    value: function delivered() {
      this.onSuccess();
    }
  }, {
    key: "incrementTries",
    value: function incrementTries(info) {
      this.tries += 1;
      this.errorInfos.push(info);
      if (this.tries >= MessageQueue.MAX_TRIES) {
        this.failed = true;
      }
      if (this.isFailed()) {
        this.onError(new Error('Failed to deliver message.'));
      }
    }
  }, {
    key: "immediateFail",
    value: function immediateFail(errMsg) {
      this.failed = true;
      this.onError(new Error(errMsg));
    }
  }]);
  return QueueItem;
}();
exports.QueueItem = QueueItem;
_defineProperty(QueueItem, "nextNumber", 0);
var MessageQueue = /*#__PURE__*/function () {
  function MessageQueue(maxSize) {
    _classCallCheck(this, MessageQueue);
    this.heap = new _heap.default(function (a, b) {
      return a.no - b.no;
    });
    this.logger = new _utils.Logger(module);
    this.maxSize = maxSize;
  }
  _createClass(MessageQueue, [{
    key: "add",
    value: function add(message) {
      var _this = this;
      if (this.size() === this.maxSize) {
        this.logger.warn('Discard oldest message (queue is full)', {
          maxSize: this.maxSize
        });
        this.pop().immediateFail('Message queue full, dropping message.');
      }
      return new Promise(function (resolve, reject) {
        _this.heap.push(new QueueItem(message, resolve, reject));
      });
    }
  }, {
    key: "peek",
    value: function peek() {
      return this.heap.peek();
    }
  }, {
    key: "pop",
    value: function pop() {
      return this.heap.pop();
    }
  }, {
    key: "size",
    value: function size() {
      return this.heap.size();
    }
  }, {
    key: "empty",
    value: function empty() {
      return this.heap.empty();
    }
  }, {
    key: "clear",
    value: function clear() {
      // @ts-expect-error clear exists but isn't in typedef
      return this.heap.clear();
    }
  }]);
  return MessageQueue;
}();
exports.MessageQueue = MessageQueue;
_defineProperty(MessageQueue, "MAX_TRIES", 10);

/***/ }),

/***/ "../network/src/connection/NegotiatedProtocolVersions.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.NegotiatedProtocolVersions = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultControlLayerVersions = _protocol.ControlMessage.getSupportedVersions();
var defaultMessageLayerVersions = _protocol.StreamMessage.getSupportedVersions();
var NegotiatedProtocolVersions = /*#__PURE__*/function () {
  function NegotiatedProtocolVersions(peerInfo) {
    _classCallCheck(this, NegotiatedProtocolVersions);
    this.negotiatedProtocolVersions = Object.create(null);
    this.peerInfo = peerInfo;
    this.defaultProtocolVersions = {
      controlLayerVersion: Math.max.apply(Math, [0].concat(_toConsumableArray(defaultControlLayerVersions))),
      messageLayerVersion: Math.max.apply(Math, [0].concat(_toConsumableArray(defaultMessageLayerVersions)))
    };
  }
  _createClass(NegotiatedProtocolVersions, [{
    key: "negotiateProtocolVersion",
    value: function negotiateProtocolVersion(peerId, controlLayerVersions, messageLayerVersions) {
      var _this$validateProtoco = this.validateProtocolVersions(controlLayerVersions, messageLayerVersions),
        _this$validateProtoco2 = _slicedToArray(_this$validateProtoco, 2),
        controlLayerVersion = _this$validateProtoco2[0],
        messageLayerVersion = _this$validateProtoco2[1];
      this.negotiatedProtocolVersions[peerId] = {
        controlLayerVersion: controlLayerVersion,
        messageLayerVersion: messageLayerVersion
      };
    }
  }, {
    key: "removeNegotiatedProtocolVersion",
    value: function removeNegotiatedProtocolVersion(peerId) {
      delete this.negotiatedProtocolVersions[peerId];
    }
  }, {
    key: "getNegotiatedProtocolVersions",
    value: function getNegotiatedProtocolVersions(peerId) {
      return this.negotiatedProtocolVersions[peerId];
    }
  }, {
    key: "getDefaultProtocolVersions",
    value: function getDefaultProtocolVersions() {
      return this.defaultProtocolVersions;
    }
  }, {
    key: "validateProtocolVersions",
    value: function validateProtocolVersions(controlLayerVersions, messageLayerVersions) {
      if (!controlLayerVersions || !messageLayerVersions || controlLayerVersions.length === 0 || messageLayerVersions.length === 0) {
        throw new Error('Missing version negotiation! Must give controlLayerVersions and messageLayerVersions as query parameters!');
      }
      var controlLayerVersion = Math.max.apply(Math, _toConsumableArray(this.peerInfo.controlLayerVersions.filter(function (version) {
        return controlLayerVersions.includes(version);
      })));
      var messageLayerVersion = Math.max.apply(Math, _toConsumableArray(this.peerInfo.messageLayerVersions.filter(function (version) {
        return messageLayerVersions.includes(version);
      })));

      // Validate that the requested versions are supported
      if (controlLayerVersion < 0) {
        throw new Error("Supported ControlLayer versions: ".concat(JSON.stringify(defaultControlLayerVersions), ". Are you using an outdated library?"));
      }
      if (messageLayerVersion < 0) {
        throw new Error("Supported MessageLayer versions: ".concat(JSON.stringify(defaultMessageLayerVersions), ". Are you using an outdated library?"));
      }
      return [controlLayerVersion, messageLayerVersion];
    }
  }]);
  return NegotiatedProtocolVersions;
}();
exports.NegotiatedProtocolVersions = NegotiatedProtocolVersions;

/***/ }),

/***/ "../network/src/connection/PeerInfo.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PeerType = exports.PeerInfo = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PeerType = /*#__PURE__*/function (PeerType) {
  PeerType["Tracker"] = "tracker";
  PeerType["Node"] = "node";
  PeerType["Unknown"] = "unknown";
  return PeerType;
}({});
exports.PeerType = PeerType;
var defaultControlLayerVersions = _protocol.ControlMessage.getSupportedVersions();
var defaultMessageLayerVersions = _protocol.StreamMessage.getSupportedVersions();
var PeerInfo = /*#__PURE__*/function () {
  function PeerInfo(peerId, peerType, controlLayerVersions, messageLayerVersions, location) {
    _classCallCheck(this, PeerInfo);
    if (!peerId) {
      throw new Error('peerId not given');
    }
    if (!peerType) {
      throw new Error('peerType not given');
    }
    if (!Object.values(PeerType).includes(peerType)) {
      throw new Error("peerType ".concat(peerType, " not in peerTypes list"));
    }
    if (!controlLayerVersions || controlLayerVersions.length === 0) {
      throw new Error('controlLayerVersions not given');
    }
    if (!messageLayerVersions || messageLayerVersions.length === 0) {
      throw new Error('messageLayerVersions not given');
    }
    this.peerId = peerId;
    this.peerType = peerType;
    this.controlLayerVersions = controlLayerVersions;
    this.messageLayerVersions = messageLayerVersions;
    this.location = location;
  }
  _createClass(PeerInfo, [{
    key: "isTracker",
    value: function isTracker() {
      return this.peerType === PeerType.Tracker;
    }
  }, {
    key: "isNode",
    value: function isNode() {
      return this.peerType === PeerType.Node;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "<".concat(this.peerId.slice(0, 8), ">");
    }
  }], [{
    key: "newTracker",
    value: function newTracker(peerId, controlLayerVersions, messageLayerVersions, location) {
      return new PeerInfo(peerId, PeerType.Tracker, controlLayerVersions || defaultControlLayerVersions, messageLayerVersions || defaultMessageLayerVersions, location);
    }
  }, {
    key: "newNode",
    value: function newNode(peerId, controlLayerVersions, messageLayerVersions, location) {
      return new PeerInfo(peerId, PeerType.Node, controlLayerVersions || defaultControlLayerVersions, messageLayerVersions || defaultMessageLayerVersions, location);
    }
  }, {
    key: "newUnknown",
    value: function newUnknown(peerId) {
      return new PeerInfo(peerId, PeerType.Unknown, defaultControlLayerVersions, defaultMessageLayerVersions);
    }
  }, {
    key: "fromObject",
    value: function fromObject(_ref) {
      var peerId = _ref.peerId,
        peerType = _ref.peerType,
        location = _ref.location,
        controlLayerVersions = _ref.controlLayerVersions,
        messageLayerVersions = _ref.messageLayerVersions;
      return new PeerInfo(peerId, peerType, controlLayerVersions || defaultControlLayerVersions, messageLayerVersions || defaultMessageLayerVersions, location !== null && location !== void 0 ? location : undefined);
    }
  }]);
  return PeerInfo;
}();
exports.PeerInfo = PeerInfo;

/***/ }),

/***/ "../network/src/connection/webrtc/BrowserWebRtcConnection.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.get.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.webRtcConnectionFactory = exports.BrowserWebRtcConnection = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _WebRtcConnection2 = __webpack_require__("../network/src/connection/webrtc/WebRtcConnection.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _NameDirectory = __webpack_require__("../network/src/NameDirectory.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable class-methods-use-this */
var webRtcConnectionFactory = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }
  _createClass(_class, [{
    key: "createConnection",
    value: function createConnection(opts) {
      return new BrowserWebRtcConnection(opts);
    }
  }, {
    key: "registerWebRtcEndpoint",
    value: function registerWebRtcEndpoint() {}
  }, {
    key: "unregisterWebRtcEndpoint",
    value: function unregisterWebRtcEndpoint() {}
  }]);
  return _class;
}())();

/** eslint-disable class-methods-use-this */
exports.webRtcConnectionFactory = webRtcConnectionFactory;
var BrowserWebRtcConnection = /*#__PURE__*/function (_WebRtcConnection) {
  _inherits(BrowserWebRtcConnection, _WebRtcConnection);
  var _super = _createSuper(BrowserWebRtcConnection);
  function BrowserWebRtcConnection(opts) {
    var _this;
    _classCallCheck(this, BrowserWebRtcConnection);
    _this = _super.call(this, opts);
    _defineProperty(_assertThisInitialized(_this), "peerConnection", null);
    _defineProperty(_assertThisInitialized(_this), "dataChannel", null);
    _defineProperty(_assertThisInitialized(_this), "lastState", undefined);
    _defineProperty(_assertThisInitialized(_this), "lastGatheringState", undefined);
    _defineProperty(_assertThisInitialized(_this), "makingOffer", false);
    _this.logger = new _utils.Logger(module, {
      connection: "".concat(_NameDirectory.NameDirectory.getName(_this.getPeerId()), "/").concat(_this.id)
    });
    return _this;
  }
  _createClass(BrowserWebRtcConnection, [{
    key: "doConnect",
    value: function doConnect() {
      var _this2 = this;
      var urls = this.iceServers.map(function (_ref) {
        var url = _ref.url,
          port = _ref.port,
          username = _ref.username,
          password = _ref.password;
        return {
          urls: "".concat(url, ":").concat(port),
          username: username,
          credential: password
        };
      });
      this.peerConnection = new RTCPeerConnection({
        iceServers: urls
      });
      this.peerConnection.onicecandidate = function (event) {
        if (event.candidate && event.candidate.sdpMid) {
          _this2.emitLocalCandidate(event.candidate.candidate, event.candidate.sdpMid);
        }
      };
      this.peerConnection.onicegatheringstatechange = function () {
        var _this2$peerConnection, _this2$peerConnection2;
        _this2.logger.trace('conn.onGatheringStateChange', {
          oldState: _this2.lastGatheringState,
          newState: (_this2$peerConnection = _this2.peerConnection) === null || _this2$peerConnection === void 0 ? void 0 : _this2$peerConnection.iceGatheringState
        });
        _this2.lastGatheringState = (_this2$peerConnection2 = _this2.peerConnection) === null || _this2$peerConnection2 === void 0 ? void 0 : _this2$peerConnection2.iceGatheringState;
      };
      if (this.isOffering()) {
        this.peerConnection.onnegotiationneeded = /*#__PURE__*/_asyncToGenerator(function* () {
          try {
            if (_this2.peerConnection) {
              _this2.makingOffer = true;
              try {
                yield _this2.peerConnection.setLocalDescription();
              } catch (err) {
                _this2.logger.warn('Failed to set local description', err);
              }
              if (_this2.peerConnection.localDescription) {
                var _this2$peerConnection3, _this2$peerConnection4;
                _this2.emitLocalDescription((_this2$peerConnection3 = _this2.peerConnection.localDescription) === null || _this2$peerConnection3 === void 0 ? void 0 : _this2$peerConnection3.sdp, (_this2$peerConnection4 = _this2.peerConnection.localDescription) === null || _this2$peerConnection4 === void 0 ? void 0 : _this2$peerConnection4.type);
              }
            }
          } catch (err) {
            console.error(err);
          } finally {
            _this2.makingOffer = false;
          }
        });
        var dataChannel = this.peerConnection.createDataChannel('streamrDataChannel');
        this.setupDataChannel(dataChannel);
      } else {
        this.peerConnection.ondatachannel = function (event) {
          _this2.setupDataChannel(event.channel);
          _this2.logger.trace('connection.onDataChannel');
          _this2.openDataChannel(event.channel);
        };
      }
    }
  }, {
    key: "doClose",
    value: function doClose(err) {
      if (err !== undefined) {
        this.logger.warn('Close BrowserWebRTCConnection', {
          err: err
        });
      }
      if (this.dataChannel) {
        try {
          this.dataChannel.close();
        } catch (err) {
          this.logger.warn('Encountered error while closing dataChannel', {
            err: err
          });
        }
      }
      this.dataChannel = null;
      if (this.peerConnection) {
        try {
          this.peerConnection.close();
        } catch (err) {
          this.logger.warn('Encountered error while closing peerConnection', {
            err: err
          });
        }
      }
      this.peerConnection = null;
    }
  }, {
    key: "doSetRemoteDescription",
    value: function () {
      var _doSetRemoteDescription = _asyncToGenerator(function* (description, type) {
        var offerCollision = type == "offer" && (this.makingOffer || !this.peerConnection || this.peerConnection.signalingState != "stable");
        var ignoreOffer = this.isOffering() && offerCollision;
        if (ignoreOffer) {
          return;
        }
        try {
          var _this$peerConnection;
          yield (_this$peerConnection = this.peerConnection) === null || _this$peerConnection === void 0 ? void 0 : _this$peerConnection.setRemoteDescription({
            sdp: description,
            type: type
          });
        } catch (err) {
          this.logger.warn('Failed to set remote description', err);
        }
        if (type == "offer" && this.peerConnection) {
          try {
            yield this.peerConnection.setLocalDescription();
          } catch (err) {
            this.logger.warn('Failed to set local description', err);
          }
          if (this.peerConnection.localDescription) {
            this.emitLocalDescription(this.peerConnection.localDescription.sdp, this.peerConnection.localDescription.type);
          }
        }
      });
      function doSetRemoteDescription(_x, _x2) {
        return _doSetRemoteDescription.apply(this, arguments);
      }
      return doSetRemoteDescription;
    }()
  }, {
    key: "setRemoteDescription",
    value: function setRemoteDescription(description, type) {
      this.doSetRemoteDescription(description, type);
    }
  }, {
    key: "addRemoteCandidate",
    value: function addRemoteCandidate(candidate, mid) {
      var _this3 = this;
      try {
        var _this$peerConnection2;
        (_this$peerConnection2 = this.peerConnection) === null || _this$peerConnection2 === void 0 ? void 0 : _this$peerConnection2.addIceCandidate({
          candidate: candidate,
          sdpMid: mid
        }).then(function () {
          return;
        }).catch(function (err) {
          _this3.logger.warn('Failed to add ice candidate (#1)', {
            err: err
          });
        });
      } catch (err) {
        this.logger.warn('Failed to add ice candidate (#2)', {
          err: err
        });
      }
    }
  }, {
    key: "getBufferedAmount",
    value: function getBufferedAmount() {
      if (this.dataChannel) {
        var _this$dataChannel;
        return (_this$dataChannel = this.dataChannel) === null || _this$dataChannel === void 0 ? void 0 : _this$dataChannel.bufferedAmount;
      }
      return 0;
    }
  }, {
    key: "getMaxMessageSize",
    value: function getMaxMessageSize() {
      return 1024 * 1024;
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      if (!this.peerConnection || !this.dataChannel || this.dataChannel.readyState != "open") {
        return false;
      }
      return true;
    }
  }, {
    key: "getLastState",
    value: function getLastState() {
      return this.lastState;
    }
  }, {
    key: "getLastGatheringState",
    value: function getLastGatheringState() {
      return this.lastGatheringState;
    }
  }, {
    key: "doSendMessage",
    value: function doSendMessage(message) {
      var _this$dataChannel2;
      (_this$dataChannel2 = this.dataChannel) === null || _this$dataChannel2 === void 0 ? void 0 : _this$dataChannel2.send(message);
    }
  }, {
    key: "setupDataChannel",
    value: function setupDataChannel(dataChannel) {
      var _this4 = this;
      dataChannel.onopen = function () {
        _this4.logger.trace('dc.onOpen');
        _this4.openDataChannel(dataChannel);
      };
      dataChannel.onclose = function () {
        _this4.logger.trace('dc.onClosed');
        _this4.close();
      };
      dataChannel.onerror = function (err) {
        _this4.logger.warn('Encountered error (emitted by dataChannel.onerror)', {
          err: err
        });
      };
      dataChannel.onbufferedamountlow = function () {
        _this4.emitLowBackpressure();
      };
      dataChannel.onmessage = function (msg) {
        _this4.logger.trace('dc.onmessage');
        _this4.emitMessage(msg.data.toString());
      };
    }
  }, {
    key: "openDataChannel",
    value: function openDataChannel(dataChannel) {
      this.lastState = 'connected';
      this.dataChannel = dataChannel;
      this.emitOpen();
    }
  }, {
    key: "close",
    value: function close(err) {
      this.lastState = 'close';
      _get(_getPrototypeOf(BrowserWebRtcConnection.prototype), "close", this).call(this, err);
    }
  }]);
  return BrowserWebRtcConnection;
}(_WebRtcConnection2.WebRtcConnection);
exports.BrowserWebRtcConnection = BrowserWebRtcConnection;

/***/ }),

/***/ "../network/src/connection/webrtc/DeferredConnectionAttempt.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DeferredConnectionAttempt = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _events = _interopRequireDefault(__webpack_require__("../../node_modules/events/events.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DeferredConnectionAttempt = /*#__PURE__*/function () {
  function DeferredConnectionAttempt() {
    var _this = this;
    _classCallCheck(this, DeferredConnectionAttempt);
    this.eventEmitter = new _events.default();
    this.connectionAttemptPromise = new Promise(function (resolve, reject) {
      _this.eventEmitter.once('resolve', function (targetPeerId) {
        resolve(targetPeerId);
      });
      _this.eventEmitter.once('reject', function (reason) {
        reject(reason);
      });
    });

    // allow promise to reject without outside catch
    this.connectionAttemptPromise.catch(function () {});
  }
  _createClass(DeferredConnectionAttempt, [{
    key: "getPromise",
    value: function getPromise() {
      return this.connectionAttemptPromise;
    }
  }, {
    key: "resolve",
    value: function resolve(targetPeerId) {
      this.eventEmitter.emit('resolve', targetPeerId);
    }
  }, {
    key: "reject",
    value: function reject(reason) {
      this.eventEmitter.emit('reject', reason);
    }
  }]);
  return DeferredConnectionAttempt;
}();
exports.DeferredConnectionAttempt = DeferredConnectionAttempt;

/***/ }),

/***/ "../network/src/connection/webrtc/IWebRtcEndpoint.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Event = void 0;
var Event = /*#__PURE__*/function (Event) {
  Event["PEER_CONNECTED"] = "streamr:peer:connect";
  Event["PEER_DISCONNECTED"] = "streamr:peer:disconnect";
  Event["MESSAGE_RECEIVED"] = "streamr:message-received";
  Event["HIGH_BACK_PRESSURE"] = "streamr:high-back-pressure";
  Event["LOW_BACK_PRESSURE"] = "streamr:low-back-pressure";
  return Event;
}({});
exports.Event = Event;

/***/ }),

/***/ "../network/src/connection/webrtc/WebRtcConnection.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.WebRtcConnection = exports.ConnectionEmitter = void 0;
exports.isOffering = _isOffering;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/web.immediate.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _events = __webpack_require__("../../node_modules/events/events.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _PeerInfo = __webpack_require__("../network/src/connection/PeerInfo.ts");
var _MessageQueue = __webpack_require__("../network/src/connection/MessageQueue.ts");
var _NameDirectory = __webpack_require__("../network/src/NameDirectory.ts");
var _crypto = _interopRequireDefault(__webpack_require__("../../node_modules/crypto-browserify/index.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ID = 0;

/**
 * Strict types for EventEmitter interface.
 */

// reminder: only use Connection emitter for external handlers
// to make it safe for consumers to call removeAllListeners
// i.e. no this.on('event')
// eslint-disable-next-line @typescript-eslint/prefer-function-type
var ConnectionEmitter = _events.EventEmitter;
exports.ConnectionEmitter = ConnectionEmitter;
function _isOffering(myId, theirId) {
  return offeringHash(myId + theirId) < offeringHash(theirId + myId);
}
function offeringHash(idPair) {
  var buffer = _crypto.default.createHash('md5').update(idPair).digest();
  return buffer.readInt32LE(0);
}

/**
 * Shared base class for WebRTC connections implemented in different libraries.
 * Encapsulates the common needs of such connections such as:
 *
 *  - Determining offerer / answerer roles upon connecting
 *  - Connection timeout
 *  - Message queueing and retries on message delivery failures
 *  - Backpressure handling
 *  - Ping/Pong mechanism for RTT calculation and dead connection detection
 *  - Deferred promise handling in case of connection re-attempts
 *  - Closing of connection and associated clean up
 *  - Ensuring event loop isn't greedily reserved for long periods of time
 *
 *  Implementers of this base class should make sure to implement the
 *  abstract methods. Implementers should also make sure their base classes
 *  invoke all "emit"-prefixed protected methods:
 *  - emitOpen
 *  - emitLocalDescription
 *  - emitLocalCandidate
 *  - emitMessage
 *  - emitLowBackpressure
 *
 *  See the respective JSDocs for more information.
 *
 */
var WebRtcConnection = /*#__PURE__*/function (_ConnectionEmitter) {
  _inherits(WebRtcConnection, _ConnectionEmitter);
  var _super = _createSuper(WebRtcConnection);
  function WebRtcConnection(_ref) {
    var _this;
    var selfId = _ref.selfId,
      targetPeerId = _ref.targetPeerId,
      iceServers = _ref.iceServers,
      messageQueue = _ref.messageQueue,
      deferredConnectionAttempt = _ref.deferredConnectionAttempt,
      pingInterval = _ref.pingInterval,
      portRange = _ref.portRange,
      maxMessageSize = _ref.maxMessageSize,
      externalIp = _ref.externalIp,
      _ref$bufferThresholdH = _ref.bufferThresholdHigh,
      bufferThresholdHigh = _ref$bufferThresholdH === void 0 ? Math.pow(2, 17) : _ref$bufferThresholdH,
      _ref$bufferThresholdL = _ref.bufferThresholdLow,
      bufferThresholdLow = _ref$bufferThresholdL === void 0 ? Math.pow(2, 15) : _ref$bufferThresholdL,
      _ref$newConnectionTim = _ref.newConnectionTimeout,
      newConnectionTimeout = _ref$newConnectionTim === void 0 ? 15000 : _ref$newConnectionTim,
      _ref$maxPingPongAttem = _ref.maxPingPongAttempts,
      maxPingPongAttempts = _ref$maxPingPongAttem === void 0 ? 5 : _ref$maxPingPongAttem,
      _ref$flushRetryTimeou = _ref.flushRetryTimeout,
      flushRetryTimeout = _ref$flushRetryTimeou === void 0 ? 500 : _ref$flushRetryTimeou;
    _classCallCheck(this, WebRtcConnection);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "connectionId", 'none');
    _defineProperty(_assertThisInitialized(_this), "pingAttempts", 0);
    _defineProperty(_assertThisInitialized(_this), "hasOpened", false);
    // diagnostic info
    _defineProperty(_assertThisInitialized(_this), "messagesSent", 0);
    _defineProperty(_assertThisInitialized(_this), "messagesRecv", 0);
    _defineProperty(_assertThisInitialized(_this), "bytesSent", 0);
    _defineProperty(_assertThisInitialized(_this), "bytesRecv", 0);
    _defineProperty(_assertThisInitialized(_this), "sendFailures", 0);
    _defineProperty(_assertThisInitialized(_this), "openSince", null);
    ID += 1;
    _this.id = "Connection".concat(ID);
    _this.selfId = selfId;
    _this.peerInfo = _PeerInfo.PeerInfo.newUnknown(targetPeerId);
    _this.iceServers = iceServers;
    _this.bufferThresholdHigh = bufferThresholdHigh;
    _this.bufferThresholdLow = bufferThresholdLow;
    _this.maxMessageSize = maxMessageSize;
    _this.newConnectionTimeout = newConnectionTimeout;
    _this.maxPingPongAttempts = maxPingPongAttempts;
    _this.pingInterval = pingInterval;
    _this.flushRetryTimeout = flushRetryTimeout;
    _this.messageQueue = messageQueue;
    _this.deferredConnectionAttempt = deferredConnectionAttempt;
    _this.externalIp = externalIp;
    _this.portRange = portRange;
    _this.baseLogger = new _utils.Logger(module, {
      id: "".concat(_NameDirectory.NameDirectory.getName(_this.getPeerId()), "/").concat(ID)
    });
    _this.isFinished = false;
    _this.paused = false;
    _this.flushTimeoutRef = null;
    _this.connectionTimeoutRef = null;
    _this.pingTimeoutRef = setTimeout(function () {
      return _this.ping();
    }, _this.pingInterval);
    _this.flushRef = null;
    _this.rtt = null;
    _this.rttStart = null;
    _this.baseLogger.trace('Create', {
      selfId: _this.selfId,
      messageQueue: _this.messageQueue.size(),
      peerInfo: _this.peerInfo
    });
    return _this;
  }
  _createClass(WebRtcConnection, [{
    key: "connect",
    value: function connect() {
      var _this2 = this;
      if (this.isFinished) {
        throw new Error('Connection already closed.');
      }
      this.connectionTimeoutRef = setTimeout(function () {
        if (_this2.isFinished) {
          return;
        }
        _this2.close(new Error("timed out after ".concat(_this2.newConnectionTimeout, "ms")));
      }, this.newConnectionTimeout);
      this.doConnect();
    }
  }, {
    key: "getDeferredConnectionAttempt",
    value: function getDeferredConnectionAttempt() {
      return this.deferredConnectionAttempt;
    }
  }, {
    key: "stealDeferredConnectionAttempt",
    value: function stealDeferredConnectionAttempt() {
      var att = this.deferredConnectionAttempt;
      this.deferredConnectionAttempt = null;
      return att;
    }
  }, {
    key: "close",
    value: function close(err) {
      if (this.isFinished) {
        // already closed, noop
        return;
      }
      this.isFinished = true;
      if (err) {
        this.baseLogger.debug('Close connection', {
          err: err
        });
      } else {
        this.baseLogger.trace('close()');
      }
      if (this.flushRef) {
        clearImmediate(this.flushRef);
      }
      if (this.flushTimeoutRef) {
        clearTimeout(this.flushTimeoutRef);
      }
      if (this.connectionTimeoutRef) {
        clearTimeout(this.connectionTimeoutRef);
      }
      if (this.pingTimeoutRef) {
        clearTimeout(this.pingTimeoutRef);
      }
      this.flushTimeoutRef = null;
      this.connectionTimeoutRef = null;
      this.pingTimeoutRef = null;
      this.flushRef = null;
      try {
        this.doClose(err);
      } catch (e) {
        this.baseLogger.warn('Encountered error in doClose', e);
      }
      if (!this.hasOpened) {
        this.emit('failed');
      }
      if (err) {
        this.emitClose(err);
        return;
      }
      this.emitClose('closed');
    }
  }, {
    key: "emitClose",
    value: function emitClose(reason) {
      if (this.deferredConnectionAttempt) {
        var def = this.deferredConnectionAttempt;
        this.deferredConnectionAttempt = null;
        def.reject(reason);
      }
      this.openSince = null;
      this.emit('close');
    }
  }, {
    key: "getConnectionId",
    value: function getConnectionId() {
      return this.connectionId;
    }
  }, {
    key: "setConnectionId",
    value: function setConnectionId(id) {
      this.connectionId = id;
    }
  }, {
    key: "send",
    value: function send(message) {
      this.setFlushRef();
      return this.messageQueue.add(message);
    }
  }, {
    key: "setPeerInfo",
    value: function setPeerInfo(peerInfo) {
      this.peerInfo = peerInfo;
    }
  }, {
    key: "getPeerInfo",
    value: function getPeerInfo() {
      return this.peerInfo;
    }
  }, {
    key: "getPeerId",
    value: function getPeerId() {
      return this.peerInfo.peerId;
    }
  }, {
    key: "getRtt",
    value: function getRtt() {
      return this.rtt;
    }
  }, {
    key: "ping",
    value: function ping() {
      var _this3 = this;
      if (this.isFinished) {
        return;
      }
      if (this.isOpen()) {
        if (this.pingAttempts >= this.maxPingPongAttempts) {
          if (this.pingTimeoutRef) {
            clearTimeout(this.pingTimeoutRef);
            this.pingTimeoutRef = null;
          }
          this.baseLogger.debug('Close connection (failed to receive pong after ping attempts)', {
            maxAttempts: this.maxPingPongAttempts
          });
          this.close(new Error('pong not received'));
          return;
        } else {
          this.rttStart = Date.now();
          try {
            if (this.isOpen()) {
              this.doSendMessage('ping');
            }
          } catch (err) {
            this.baseLogger.debug('Failed to send ping', {
              peerId: this.peerInfo.peerId,
              err: err
            });
          }
          this.pingAttempts += 1;
        }
      }
      if (this.pingTimeoutRef) {
        clearTimeout(this.pingTimeoutRef);
        this.pingTimeoutRef = null;
      }
      this.pingTimeoutRef = setTimeout(function () {
        return _this3.ping();
      }, this.pingInterval);
    }
  }, {
    key: "pong",
    value: function pong() {
      if (this.isFinished) {
        return;
      }
      try {
        if (this.isOpen()) {
          this.doSendMessage('pong');
        }
      } catch (err) {
        this.baseLogger.warn('Failed to send pong', {
          peerId: this.peerInfo.peerId,
          err: err
        });
      }
    }
  }, {
    key: "isOffering",
    value: function isOffering() {
      return _isOffering(this.selfId, this.peerInfo.peerId);
    }
  }, {
    key: "getDiagnosticInfo",
    value: function getDiagnosticInfo() {
      return {
        connectionId: this.getConnectionId(),
        peerId: this.getPeerId(),
        rtt: this.getRtt(),
        ageInSec: this.openSince !== null ? Math.round((Date.now() - this.openSince) / 1000) : null,
        messageQueueLength: this.messageQueue.size(),
        bufferedAmount: this.getBufferedAmount(),
        messagesSent: this.messagesSent,
        messagesRecv: this.messagesRecv,
        bytesSend: this.bytesSent,
        bytesRecv: this.bytesRecv,
        sendFailures: this.sendFailures,
        open: this.isOpen(),
        paused: this.paused,
        finished: this.isFinished,
        pingAttempts: this.pingAttempts,
        isOffering: this.isOffering(),
        lastState: this.getLastState(),
        lastGatheringState: this.getLastGatheringState()
      };
    }
  }, {
    key: "setFlushRef",
    value: function setFlushRef() {
      var _this4 = this;
      if (this.flushRef === null) {
        this.flushRef = setImmediate(function () {
          _this4.flushRef = null;
          _this4.attemptToFlushMessages();
        });
      }
    }
  }, {
    key: "attemptToFlushMessages",
    value: function attemptToFlushMessages() {
      var numOfSuccessSends = 0;
      while (!this.isFinished && !this.messageQueue.empty() && this.isOpen()) {
        // Max 10 messages sent in busy-loop, then relinquish control for a moment, in case `dc.send` is blocking
        // (is it?)
        if (numOfSuccessSends >= 10) {
          this.setFlushRef();
          return;
        }
        var queueItem = this.messageQueue.peek();
        if (queueItem.isFailed()) {
          this.baseLogger.debug('Encountered failed queue item', {
            queueItem: queueItem,
            numOfSuccessSends: numOfSuccessSends
          });
          this.messageQueue.pop();
        } else if (queueItem.getMessage().length > this.getMaxMessageSize()) {
          var errorMessage = 'Dropping message due to size ' + queueItem.getMessage().length + ' exceeding the limit of ' + this.getMaxMessageSize();
          queueItem.immediateFail(errorMessage);
          this.baseLogger.warn('Dropping message due to size', {
            size: queueItem.getMessage().length,
            limit: this.getMaxMessageSize()
          });
          this.messageQueue.pop();
        } else if (this.paused || this.getBufferedAmount() >= this.bufferThresholdHigh) {
          if (!this.paused) {
            this.paused = true;
            this.emit('bufferHigh');
          }
          return; // method eventually re-scheduled by `onBufferedAmountLow`
        } else {
          var sent = void 0;
          var caughtError = undefined;
          if (this.isOpen()) {
            try {
              this.doSendMessage(queueItem.getMessage());
              // this.isOpen() is checked immediately after the call to node-datachannel.sendMessage() as if
              // this.isOpen() returns false after a "successful" send, the message is lost with a near 100% chance.
              // This does not work as expected if this.isOpen() is checked before sending a message
              sent = this.isOpen();
            } catch (e) {
              caughtError = e;
              sent = false;
            }
          } else {
            sent = false;
          }
          if (sent) {
            this.messageQueue.pop();
            queueItem.delivered();
            numOfSuccessSends += 1;
            this.messagesSent += 1;
            this.bytesSent += queueItem.getMessage().length;
          } else {
            var _caughtError;
            this.baseLogger.debug('Failed to send queue item', {
              numOfSuccessSends: numOfSuccessSends,
              queueItem: queueItem,
              messageQueueSize: this.messageQueue.size()
            });
            this.sendFailures += 1;
            this.processFailedMessage(queueItem, (_caughtError = caughtError) !== null && _caughtError !== void 0 ? _caughtError : new Error('failed to send message'));
            return; // method rescheduled by `this.flushTimeoutRef`
          }
        }
      }
    }
  }, {
    key: "processFailedMessage",
    value: function processFailedMessage(queueItem, e) {
      var _this5 = this;
      queueItem.incrementTries({
        error: e.toString(),
        'connection.iceConnectionState': this.getLastGatheringState(),
        'connection.connectionState': this.getLastState()
      });
      if (queueItem.isFailed()) {
        var infoText = queueItem.getErrorInfos().map(function (i) {
          return JSON.stringify(i);
        }).join('\n\t');
        this.baseLogger.warn('Discard message (all previous send attempts failed)', {
          maxTries: _MessageQueue.MessageQueue.MAX_TRIES,
          infoText: infoText
        });
        this.messageQueue.pop();
      }
      if (this.flushTimeoutRef === null) {
        this.flushTimeoutRef = setTimeout(function () {
          _this5.flushTimeoutRef = null;
          _this5.attemptToFlushMessages();
        }, this.flushRetryTimeout);
      }
    }
  }, {
    key: "emitOpen",
    value:
    /**
     * Subclass should call this method when the connection has opened.
     */
    function emitOpen() {
      if (this.connectionTimeoutRef !== null) {
        clearTimeout(this.connectionTimeoutRef);
      }
      if (this.deferredConnectionAttempt) {
        var def = this.deferredConnectionAttempt;
        this.deferredConnectionAttempt = null;
        def.resolve(this.peerInfo.peerId);
      }
      this.openSince = Date.now();
      this.hasOpened = true;
      this.setFlushRef();
      this.emit('open');
    }

    /**
     * Subclass should call this method when a new local description is available.
     */
  }, {
    key: "emitLocalDescription",
    value: function emitLocalDescription(description, type) {
      this.emit('localDescription', type, description);
    }

    /**
     * Subclass should call this method when a new local candidate is available.
     */
  }, {
    key: "emitLocalCandidate",
    value: function emitLocalCandidate(candidate, mid) {
      this.emit('localCandidate', candidate, mid);
    }

    /**
     * Subclass should call this method when it has received a message.
     */
  }, {
    key: "emitMessage",
    value: function emitMessage(msg) {
      if (msg === 'ping') {
        this.pong();
      } else if (msg === 'pong') {
        this.pingAttempts = 0;
        this.rtt = Date.now() - this.rttStart;
      } else {
        this.messagesRecv += 1;
        this.bytesRecv += msg.length;
        this.emit('message', msg);
      }
    }

    /**
     * Subclass should call this method when backpressure has reached low watermark.
     */
  }, {
    key: "emitLowBackpressure",
    value: function emitLowBackpressure() {
      if (!this.paused) {
        return;
      }
      this.paused = false;
      this.setFlushRef();
      this.emit('bufferLow');
    }

    /**
     * Forcefully restart the connection timeout (e.g. on state change) from subclass.
     */
  }, {
    key: "restartConnectionTimeout",
    value: function restartConnectionTimeout() {
      var _this6 = this;
      clearTimeout(this.connectionTimeoutRef);
      this.connectionTimeoutRef = setTimeout(function () {
        if (_this6.isFinished) {
          return;
        }
        _this6.close(new Error("timed out after ".concat(_this6.newConnectionTimeout, "ms")));
      }, this.newConnectionTimeout);
    }
  }]);
  return WebRtcConnection;
}(ConnectionEmitter);
exports.WebRtcConnection = WebRtcConnection;

/***/ }),

/***/ "../network/src/connection/webrtc/WebRtcEndpoint.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.WebRtcEndpoint = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.entries.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
var _events = __webpack_require__("../../node_modules/events/events.js");
var _IWebRtcEndpoint = __webpack_require__("../network/src/connection/webrtc/IWebRtcEndpoint.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _PeerInfo = __webpack_require__("../network/src/connection/PeerInfo.ts");
var _DeferredConnectionAttempt = __webpack_require__("../network/src/connection/webrtc/DeferredConnectionAttempt.ts");
var _WebRtcConnection = __webpack_require__("../network/src/connection/webrtc/WebRtcConnection.ts");
var _MessageQueue = __webpack_require__("../network/src/connection/MessageQueue.ts");
var _NameDirectory = __webpack_require__("../network/src/NameDirectory.ts");
var _uuid = __webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/index.js");
var _AddressTools = __webpack_require__("../network/src/helpers/AddressTools.ts");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var WebRtcError = /*#__PURE__*/function (_Error) {
  _inherits(WebRtcError, _Error);
  var _super = _createSuper(WebRtcError);
  function WebRtcError() {
    _classCallCheck(this, WebRtcError);
    return _super.apply(this, arguments);
  }
  return _createClass(WebRtcError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var logger = new _utils.Logger(module);
var WebRtcEndpoint = /*#__PURE__*/function (_EventEmitter) {
  _inherits(WebRtcEndpoint, _EventEmitter);
  var _super2 = _createSuper(WebRtcEndpoint);
  function WebRtcEndpoint(peerInfo, iceServers, rtcSignaller, metricsContext, negotiatedProtocolVersions, connectionFactory, newConnectionTimeout, pingInterval, webrtcDatachannelBufferThresholdLow, webrtcDatachannelBufferThresholdHigh, webrtcSendBufferMaxMessageCount, webrtcDisallowPrivateAddresses, portRange, maxMessageSize, externalIp) {
    var _this;
    _classCallCheck(this, WebRtcEndpoint);
    _this = _super2.call(this);
    _defineProperty(_assertThisInitialized(_this), "stopped", false);
    _this.peerInfo = peerInfo;
    _this.iceServers = iceServers;
    _this.rtcSignaller = rtcSignaller;
    _this.negotiatedProtocolVersions = negotiatedProtocolVersions;
    _this.connectionFactory = connectionFactory;
    _this.connections = {};
    _this.messageQueues = {};
    _this.newConnectionTimeout = newConnectionTimeout;
    _this.pingInterval = pingInterval;
    _this.bufferThresholdLow = webrtcDatachannelBufferThresholdLow;
    _this.bufferThresholdHigh = webrtcDatachannelBufferThresholdHigh;
    _this.sendBufferMaxMessageCount = webrtcSendBufferMaxMessageCount;
    _this.disallowPrivateAddresses = webrtcDisallowPrivateAddresses;
    _this.maxMessageSize = maxMessageSize;
    _this.portRange = portRange;
    _this.externalIp = externalIp;
    _this.connectionFactory.registerWebRtcEndpoint();
    rtcSignaller.setOfferListener( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (options) {
        _this.onRtcOfferFromSignaller(options);
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    rtcSignaller.setAnswerListener(function (options) {
      _this.onRtcAnswerFromSignaller(options);
    });
    rtcSignaller.setIceCandidateListener(function (options) {
      _this.onIceCandidateFromSignaller(options);
    });
    rtcSignaller.setConnectListener( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* (options) {
        _this.onConnectFromSignaller(options);
      });
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    rtcSignaller.setErrorListener(function (options) {
      _this.onErrorFromSignaller(options);
    });
    _this.metrics = {
      sendMessagesPerSecond: new _utils.RateMetric(),
      sendBytesPerSecond: new _utils.RateMetric(),
      receiveMessagesPerSecond: new _utils.RateMetric(),
      receiveBytesPerSecond: new _utils.RateMetric(),
      connectionAverageCount: new _utils.LevelMetric(0),
      connectionTotalFailureCount: new _utils.CountMetric()
    };
    metricsContext.addMetrics('node', _this.metrics);
    _this.startConnectionStatusReport();
    return _this;
  }
  _createClass(WebRtcEndpoint, [{
    key: "startConnectionStatusReport",
    value: function startConnectionStatusReport() {
      var _this2 = this;
      var getPeerNameList = function getPeerNameList(peerIds) {
        return peerIds.map(function (peerId) {
          return _NameDirectory.NameDirectory.getName(peerId);
        }).join(',');
      };
      var STATUS_REPORT_INTERVAL_MS = 5 * 60 * 1000;
      this.statusReportTimer = setInterval(function () {
        var connectedPeerIds = [];
        var pendingPeerIds = [];
        var undefinedStates = [];
        var connections = Object.keys(_this2.connections);
        for (var _i = 0, _connections = connections; _i < _connections.length; _i++) {
          var peerId = _connections[_i];
          var lastState = _this2.connections[peerId].getLastState();
          if (lastState === 'connected') {
            connectedPeerIds.push(peerId);
          } else if (lastState === 'connecting') {
            pendingPeerIds.push(peerId);
          } else if (lastState === undefined) {
            undefinedStates.push(peerId);
          }
        }
        if (connections.length > 0 && connections.length === undefinedStates.length) {
          logger.warn('Failed to determine WebRTC datachannel connection states');
        } else {
          var suffix = pendingPeerIds.length > 0 ? " (trying to connect to ".concat(pendingPeerIds.length, " peers)") : '';
          logger.info("Connected to ".concat(connectedPeerIds.length, " peers").concat(suffix));
          logger.debug("Connected to peers: ".concat(getPeerNameList(connectedPeerIds) || '[]'));
          logger.debug("Connect to peers (pending): ".concat(getPeerNameList(pendingPeerIds) || '[]'));
        }
      }, STATUS_REPORT_INTERVAL_MS);
    }
  }, {
    key: "createConnection",
    value: function createConnection(targetPeerId, routerId, deferredConnectionAttempt) {
      var _this3 = this;
      var messageQueue = this.messageQueues[targetPeerId] = this.messageQueues[targetPeerId] || new _MessageQueue.MessageQueue(this.sendBufferMaxMessageCount);
      var connectionOptions = {
        selfId: this.peerInfo.peerId,
        targetPeerId: targetPeerId,
        routerId: routerId,
        iceServers: this.iceServers,
        bufferThresholdHigh: this.bufferThresholdHigh,
        bufferThresholdLow: this.bufferThresholdLow,
        messageQueue: messageQueue,
        deferredConnectionAttempt: deferredConnectionAttempt || new _DeferredConnectionAttempt.DeferredConnectionAttempt(),
        newConnectionTimeout: this.newConnectionTimeout,
        pingInterval: this.pingInterval,
        portRange: this.portRange,
        maxMessageSize: this.maxMessageSize,
        externalIp: this.externalIp
      };
      var connection = this.connectionFactory.createConnection(connectionOptions);
      if (connection.isOffering()) {
        connection.once('localDescription', function (_type, description) {
          _this3.rtcSignaller.sendRtcOffer(routerId, connection.getPeerId(), connection.getConnectionId(), description);
          _this3.attemptProtocolVersionValidation(connection);
        });
      } else {
        connection.once('localDescription', function (_type, description) {
          _this3.rtcSignaller.sendRtcAnswer(routerId, connection.getPeerId(), connection.getConnectionId(), description);
          _this3.attemptProtocolVersionValidation(connection);
        });
      }
      connection.on('localCandidate', function (candidate, mid) {
        _this3.rtcSignaller.sendRtcIceCandidate(routerId, connection.getPeerId(), connection.getConnectionId(), candidate, mid);
      });
      connection.once('open', function () {
        _this3.emit(_IWebRtcEndpoint.Event.PEER_CONNECTED, connection.getPeerInfo());
      });
      connection.on('message', function (message) {
        _this3.emit(_IWebRtcEndpoint.Event.MESSAGE_RECEIVED, connection.getPeerInfo(), message);
        _this3.metrics.receiveMessagesPerSecond.record(1);
        _this3.metrics.receiveBytesPerSecond.record(message.length);
      });
      connection.once('close', function () {
        if (_this3.connections[targetPeerId] === connection) {
          // if endpoint.close() was called, connection has already been
          // removed and possibly replaced. This check avoids deleting new
          // connection.
          delete _this3.connections[targetPeerId];
          _this3.onConnectionCountChange();
        }
        _this3.negotiatedProtocolVersions.removeNegotiatedProtocolVersion(targetPeerId);
        _this3.emit(_IWebRtcEndpoint.Event.PEER_DISCONNECTED, connection.getPeerInfo());
        connection.removeAllListeners();
      });
      connection.on('bufferLow', function () {
        _this3.emit(_IWebRtcEndpoint.Event.LOW_BACK_PRESSURE, connection.getPeerInfo());
      });
      connection.on('bufferHigh', function () {
        _this3.emit(_IWebRtcEndpoint.Event.HIGH_BACK_PRESSURE, connection.getPeerInfo());
      });
      connection.on('failed', function () {
        _this3.metrics.connectionTotalFailureCount.record(1);
      });
      return connection;
    }
  }, {
    key: "onRtcOfferFromSignaller",
    value: function onRtcOfferFromSignaller(_ref3) {
      var routerId = _ref3.routerId,
        originatorInfo = _ref3.originatorInfo,
        description = _ref3.description,
        connectionId = _ref3.connectionId;
      var peerId = originatorInfo.peerId;
      var connection;
      if (!this.connections[peerId]) {
        connection = this.createConnection(peerId, routerId, null);
        try {
          connection.connect();
        } catch (e) {
          logger.warn('Failed to connect (onRtcOfferFromSignaller)', e);
        }
        this.connections[peerId] = connection;
        this.onConnectionCountChange();
      } else if (this.connections[peerId].getConnectionId() !== 'none') {
        connection = this.replaceConnection(peerId, routerId);
      } else {
        connection = this.connections[peerId];
      }
      connection.setPeerInfo(_PeerInfo.PeerInfo.fromObject(originatorInfo));
      connection.setConnectionId(connectionId);
      connection.setRemoteDescription(description, 'offer');
    }
  }, {
    key: "onRtcAnswerFromSignaller",
    value: function onRtcAnswerFromSignaller(_ref4) {
      var originatorInfo = _ref4.originatorInfo,
        description = _ref4.description,
        connectionId = _ref4.connectionId;
      var peerId = originatorInfo.peerId;
      var connection = this.connections[peerId];
      if (!connection) {
        logger.debug('Received unexpected rtcAnswer', {
          peerId: peerId,
          description: description
        });
      } else if (connection.getConnectionId() !== connectionId) {
        logger.debug('Received unexpected rtcAnswer (connectionId mismatch)', {
          peerId: peerId,
          currentConnectionId: connection.getConnectionId(),
          sentConnectionId: connectionId
        });
      } else {
        connection.setPeerInfo(_PeerInfo.PeerInfo.fromObject(originatorInfo));
        connection.setRemoteDescription(description, 'answer');
        this.attemptProtocolVersionValidation(connection);
      }
    }
  }, {
    key: "isIceCandidateAllowed",
    value: function isIceCandidateAllowed(candidate) {
      if (this.disallowPrivateAddresses) {
        var address = (0, _AddressTools.getAddressFromIceCandidate)(candidate);
        if (address && (0, _AddressTools.isPrivateIPv4)(address)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "onIceCandidateFromSignaller",
    value: function onIceCandidateFromSignaller(_ref5) {
      var originatorInfo = _ref5.originatorInfo,
        candidate = _ref5.candidate,
        mid = _ref5.mid,
        connectionId = _ref5.connectionId;
      var peerId = originatorInfo.peerId;
      var connection = this.connections[peerId];
      if (!connection) {
        logger.debug('Received unexpected iceCandidate (no connection)', {
          peerId: peerId,
          candidate: candidate
        });
      } else if (connection.getConnectionId() !== connectionId) {
        logger.debug('Received unexpected iceCandidate (connectionId mismatch)', {
          peerId: peerId,
          currentConnectionId: connection.getConnectionId(),
          sentConnectionId: connectionId
        });
      } else {
        if (this.isIceCandidateAllowed(candidate)) {
          connection.addRemoteCandidate(candidate, mid);
        }
      }
    }
  }, {
    key: "onErrorFromSignaller",
    value: function onErrorFromSignaller(_ref6) {
      var targetNode = _ref6.targetNode,
        errorCode = _ref6.errorCode;
      var error = new WebRtcError("RTC error ".concat(errorCode, " while attempting to signal with node ").concat(targetNode));
      var connection = this.connections[targetNode];
      // treat rtcSignaller errors as connection errors.
      if (connection) {
        connection.close(error);
      }
    }
  }, {
    key: "onConnectFromSignaller",
    value: function onConnectFromSignaller(_ref7) {
      var originatorInfo = _ref7.originatorInfo,
        routerId = _ref7.routerId;
      var peerId = originatorInfo.peerId;
      if (this.connections[peerId]) {
        this.replaceConnection(peerId, routerId, (0, _uuid.v4)());
      } else {
        this.connect(peerId, routerId, true).then(function () {
          logger.trace('Failed to connect (unattended connectListener induced connection)', {
            peerId: peerId
          });
          return peerId;
        }).catch(function (err) {
          logger.trace('Failed to connect (connectListener induced connection)', {
            peerId: peerId,
            err: err
          });
        });
      }
    }
  }, {
    key: "replaceConnection",
    value: function replaceConnection(peerId, routerId, newConnectionId) {
      // Close old connection
      var conn = this.connections[peerId];
      var deferredConnectionAttempt = null;
      if (conn.getDeferredConnectionAttempt()) {
        deferredConnectionAttempt = conn.stealDeferredConnectionAttempt();
      }
      delete this.connections[peerId];
      this.onConnectionCountChange();
      conn.close();

      // Set up new connection
      var connection = this.createConnection(peerId, routerId, deferredConnectionAttempt);
      if (newConnectionId) {
        connection.setConnectionId(newConnectionId);
      }
      try {
        connection.connect();
      } catch (e) {
        logger.warn('Failed to connect (replaceConnection)', e);
      }
      this.connections[peerId] = connection;
      this.onConnectionCountChange();
      return connection;
    }
  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator(function* (targetPeerId, routerId) {
        var trackerInstructed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        // Prevent new connections from being opened when WebRtcEndpoint has been closed
        if (this.stopped) {
          return Promise.reject(new WebRtcError('WebRtcEndpoint has been stopped'));
        }
        if (this.connections[targetPeerId]) {
          var _connection = this.connections[targetPeerId];
          var lastState = _connection.getLastState();
          var deferredConnectionAttempt = _connection.getDeferredConnectionAttempt();
          logger.trace('Found pre-existing connection for peer', {
            role: (0, _WebRtcConnection.isOffering)(this.peerInfo.peerId, targetPeerId) ? 'offerer' : 'answerer',
            targetPeerId: _NameDirectory.NameDirectory.getName(targetPeerId),
            state: lastState
          });
          if (lastState === 'connected') {
            return Promise.resolve(targetPeerId);
          } else if (deferredConnectionAttempt) {
            return deferredConnectionAttempt.getPromise();
          } else {
            throw new Error("unexpected deferedConnectionAttempt == null ".concat(_connection.getPeerId()));
          }
        }
        var connection = this.createConnection(targetPeerId, routerId, null);
        if (connection.isOffering()) {
          connection.setConnectionId((0, _uuid.v4)());
        }
        this.connections[targetPeerId] = connection;
        this.onConnectionCountChange();
        connection.connect();
        if (!trackerInstructed && !connection.isOffering()) {
          // If we are non-offerer and this connection was not instructed by the tracker, we need
          // to let the offering side know about it so it can send us the initial offer message.

          this.rtcSignaller.sendRtcConnect(routerId, connection.getPeerId());
        }
        var deferredAttempt = connection.getDeferredConnectionAttempt();
        if (connection.getLastState() == 'connected') {
          return targetPeerId;
        }
        if (deferredAttempt) {
          return deferredAttempt.getPromise();
        } else {
          throw new WebRtcError("disconnected ".concat(connection.getPeerId()));
        }
      });
      function connect(_x3, _x4) {
        return _connect.apply(this, arguments);
      }
      return connect;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(function* (targetPeerId, message) {
        if (!this.connections[targetPeerId]) {
          throw new WebRtcError("Not connected to ".concat(targetPeerId, "."));
        }
        yield this.connections[targetPeerId].send(message);
        this.metrics.sendMessagesPerSecond.record(1);
        this.metrics.sendBytesPerSecond.record(message.length);
      });
      function send(_x5, _x6) {
        return _send.apply(this, arguments);
      }
      return send;
    }()
  }, {
    key: "attemptProtocolVersionValidation",
    value: function attemptProtocolVersionValidation(connection) {
      try {
        this.negotiatedProtocolVersions.negotiateProtocolVersion(connection.getPeerId(), connection.getPeerInfo().controlLayerVersions, connection.getPeerInfo().messageLayerVersions);
      } catch (err) {
        logger.debug('Encountered error while negotiating protocol versions', err);
        this.close(connection.getPeerId(), "No shared protocol versions with node: ".concat(connection.getPeerId()));
      }
    }
  }, {
    key: "close",
    value: function close(receiverPeerId, reason) {
      var connection = this.connections[receiverPeerId];
      if (connection) {
        logger.debug('Close connection', {
          peerId: _NameDirectory.NameDirectory.getName(receiverPeerId),
          reason: reason
        });
        delete this.connections[receiverPeerId];
        this.onConnectionCountChange();
        connection.close();
      }
    }
  }, {
    key: "getRtts",
    value: function getRtts() {
      var rtts = {};
      Object.entries(this.connections).forEach(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 2),
          targetPeerId = _ref9[0],
          connection = _ref9[1];
        var rtt = connection.getRtt();
        if (rtt !== undefined && rtt !== null) {
          rtts[targetPeerId] = rtt;
        }
      });
      return rtts;
    }
  }, {
    key: "getPeerInfo",
    value: function getPeerInfo() {
      return this.peerInfo;
    }
  }, {
    key: "getNegotiatedMessageLayerProtocolVersionOnNode",
    value: function getNegotiatedMessageLayerProtocolVersionOnNode(peerId) {
      var _this$negotiatedProto;
      return (_this$negotiatedProto = this.negotiatedProtocolVersions.getNegotiatedProtocolVersions(peerId)) === null || _this$negotiatedProto === void 0 ? void 0 : _this$negotiatedProto.messageLayerVersion;
    }
  }, {
    key: "getNegotiatedControlLayerProtocolVersionOnNode",
    value: function getNegotiatedControlLayerProtocolVersionOnNode(peerId) {
      var _this$negotiatedProto2;
      return (_this$negotiatedProto2 = this.negotiatedProtocolVersions.getNegotiatedProtocolVersions(peerId)) === null || _this$negotiatedProto2 === void 0 ? void 0 : _this$negotiatedProto2.controlLayerVersion;
    }
  }, {
    key: "getDefaultMessageLayerProtocolVersion",
    value: function getDefaultMessageLayerProtocolVersion() {
      return this.negotiatedProtocolVersions.getDefaultProtocolVersions().messageLayerVersion;
    }
  }, {
    key: "getDefaultControlLayerProtocolVersion",
    value: function getDefaultControlLayerProtocolVersion() {
      return this.negotiatedProtocolVersions.getDefaultProtocolVersions().controlLayerVersion;
    }

    /**
     * @deprecated
     */
  }, {
    key: "getAddress",
    value: function getAddress() {
      return this.peerInfo.peerId;
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.stopped === true) {
        throw new Error('already stopped');
      }
      this.stopped = true;
      var connections = this.connections,
        messageQueues = this.messageQueues;
      this.connections = {};
      this.onConnectionCountChange();
      this.messageQueues = {};
      this.rtcSignaller.setOfferListener(function () {});
      this.rtcSignaller.setAnswerListener(function () {});
      this.rtcSignaller.setIceCandidateListener(function () {});
      this.rtcSignaller.setErrorListener(function () {});
      this.rtcSignaller.setConnectListener(function () {});
      clearInterval(this.statusReportTimer);
      this.removeAllListeners();
      Object.values(connections).forEach(function (connection) {
        return connection.close();
      });
      Object.values(messageQueues).forEach(function (queue) {
        return queue.clear();
      });
      this.connectionFactory.unregisterWebRtcEndpoint();
    }
  }, {
    key: "getAllConnectionNodeIds",
    value: function getAllConnectionNodeIds() {
      return Object.keys(this.connections);
    }
  }, {
    key: "getDiagnosticInfo",
    value: function getDiagnosticInfo() {
      return {
        connections: Object.values(this.connections).map(function (c) {
          return c.getDiagnosticInfo();
        })
      };
    }
  }, {
    key: "onConnectionCountChange",
    value: function onConnectionCountChange() {
      this.metrics.connectionAverageCount.record(Object.keys(this.connections).length);
    }
  }]);
  return WebRtcEndpoint;
}(_events.EventEmitter);
exports.WebRtcEndpoint = WebRtcEndpoint;

/***/ }),

/***/ "../network/src/connection/ws/AbstractClientWsEndpoint.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AbstractClientWsEndpoint = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.finally.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.from-entries.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _AbstractWsEndpoint2 = __webpack_require__("../network/src/connection/ws/AbstractWsEndpoint.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var logger = new _utils.Logger(module);
var AbstractClientWsEndpoint = /*#__PURE__*/function (_AbstractWsEndpoint) {
  _inherits(AbstractClientWsEndpoint, _AbstractWsEndpoint);
  var _super = _createSuper(AbstractClientWsEndpoint);
  function AbstractClientWsEndpoint(peerInfo, pingInterval) {
    var _this;
    _classCallCheck(this, AbstractClientWsEndpoint);
    _this = _super.call(this, peerInfo, pingInterval);
    _this.connectionsByServerUrl = new Map();
    _this.serverUrlByPeerId = new Map();
    _this.pendingConnections = new Map();
    return _this;
  }
  _createClass(AbstractClientWsEndpoint, [{
    key: "getServerUrlByPeerId",
    value: function getServerUrlByPeerId(peerId) {
      return this.serverUrlByPeerId.get(peerId);
    }
  }, {
    key: "doClose",
    value: function doClose(connection, _code, _reason) {
      var serverUrl = this.serverUrlByPeerId.get(connection.getPeerId());
      this.connectionsByServerUrl.delete(serverUrl);
      this.serverUrlByPeerId.delete(connection.getPeerId());
    }
  }, {
    key: "doStop",
    value: function () {
      var _doStop = _asyncToGenerator(function* () {
        this.getConnections().forEach(function (connection) {
          connection.close(_AbstractWsEndpoint2.DisconnectionCode.GRACEFUL_SHUTDOWN, _AbstractWsEndpoint2.DisconnectionReason.GRACEFUL_SHUTDOWN);
        });
      });
      function doStop() {
        return _doStop.apply(this, arguments);
      }
      return doStop;
    }()
  }, {
    key: "connect",
    value: function connect(serverUrl, serverPeerInfo) {
      var _this2 = this;
      // Check for existing connection and its state
      var existingConnection = this.connectionsByServerUrl.get(serverUrl);
      if (existingConnection !== undefined) {
        if (existingConnection.getReadyState() === 1) {
          return Promise.resolve(existingConnection.getPeerId());
        }
        logger.trace('Close connection (readyState not connected)', {
          serverUrl: serverUrl,
          readyState: existingConnection.getReadyState()
        });
        this.close(existingConnection.getPeerId(), _AbstractWsEndpoint2.DisconnectionCode.DEAD_CONNECTION, _AbstractWsEndpoint2.DisconnectionReason.DEAD_CONNECTION);
      }

      // Check for pending connection
      var pendingConnection = this.pendingConnections.get(serverUrl);
      if (pendingConnection !== undefined) {
        return pendingConnection;
      }

      // Perform connection
      logger.trace('Connect to server', {
        serverUrl: serverUrl
      });
      var p = this.doConnect(serverUrl, serverPeerInfo).finally(function () {
        _this2.pendingConnections.delete(serverUrl);
      });
      this.pendingConnections.set(serverUrl, p);
      return p;
    }

    /**
     * Custom connect logic of subclass
     */
  }, {
    key: "handshakeInit",
    value:
    /**
     * Init client-side handshake timeout
     */
    function handshakeInit(ws, serverPeerInfo, reject) {
      var _this3 = this;
      var peerId = serverPeerInfo.peerId;
      this.handshakeTimeoutRefs[peerId] = setTimeout(function () {
        ws.close(_AbstractWsEndpoint2.DisconnectionCode.FAILED_HANDSHAKE, "Handshake not received from ".concat(peerId));
        logger.warn('Timed out waiting for handshake from peer', {
          peerId: peerId
        });
        delete _this3.handshakeTimeoutRefs[peerId];
        reject("Handshake not received from ".concat(peerId));
      }, this.handshakeTimer);
    }

    /**
     * Initial handshake message listener
     */
  }, {
    key: "handshakeListener",
    value: function handshakeListener(ws, serverPeerInfo, serverUrl, message, resolve) {
      try {
        var _this$doHandshakePars = this.doHandshakeParse(message),
          _uuid = _this$doHandshakePars.uuid,
          _peerId = _this$doHandshakePars.peerId;
        if (_uuid && _peerId === serverPeerInfo.peerId) {
          this.clearHandshake(_peerId);
          this.doHandshakeResponse(_uuid, _peerId, ws);
          resolve(this.setUpConnection(ws, serverPeerInfo, serverUrl));
        } else {
          logger.trace('Received unexpected message (expected a handshake message)', {
            gotInstead: message === null || message === void 0 ? void 0 : message.toString()
          });
        }
      } catch (err) {
        logger.trace('handshakeListener', err);
      }
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "onHandshakeError",
    value: function onHandshakeError(serverUrl, error, reject) {
      logger.trace('onHandshakeError', {
        serverUrl: serverUrl,
        error: error
      });
      reject(error);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "onHandshakeClosed",
    value: function onHandshakeClosed(serverUrl, code, reason, reject) {
      logger.trace('onHandshakeClosed', {
        serverUrl: serverUrl,
        code: code,
        reason: reason
      });
      reject(reason);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "ongoingConnectionError",
    value: function ongoingConnectionError(serverPeerId, error, connection) {
      logger.trace('ongoingConnectionError', {
        serverPeerId: serverPeerId,
        error: error
      });
      connection.terminate();
    }

    /**
     * Send a handshake response back to the server
     */
  }, {
    key: "setUpConnection",
    value: function setUpConnection(ws, serverPeerInfo, serverUrl) {
      var connection = this.doSetUpConnection(ws, serverPeerInfo);
      this.connectionsByServerUrl.set(serverUrl, connection);
      this.serverUrlByPeerId.set(connection.getPeerId(), serverUrl);
      this.onNewConnection(connection);
      return connection.getPeerId();
    }
  }, {
    key: "getDiagnosticInfo",
    value: function getDiagnosticInfo() {
      return {
        connections: this.getConnections().map(function (c) {
          return c.getDiagnosticInfo();
        }),
        serverUrls: Object.fromEntries(this.serverUrlByPeerId),
        pendingConnections: Object.keys(this.pendingConnections)
      };
    }
  }]);
  return AbstractClientWsEndpoint;
}(_AbstractWsEndpoint2.AbstractWsEndpoint);
exports.AbstractClientWsEndpoint = AbstractClientWsEndpoint;

/***/ }),

/***/ "../network/src/connection/ws/AbstractWsConnection.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LOW_BACK_PRESSURE = exports.HIGH_BACK_PRESSURE = exports.AbstractWsConnection = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var HIGH_BACK_PRESSURE = 1024 * 1024 * 2;
exports.HIGH_BACK_PRESSURE = HIGH_BACK_PRESSURE;
var LOW_BACK_PRESSURE = 1024 * 1024;
exports.LOW_BACK_PRESSURE = LOW_BACK_PRESSURE;
var AbstractWsConnection = /*#__PURE__*/function () {
  function AbstractWsConnection(peerInfo) {
    _classCallCheck(this, AbstractWsConnection);
    _defineProperty(this, "respondedPong", true);
    _defineProperty(this, "highBackPressure", false);
    this.peerInfo = peerInfo;
    this.logger = new _utils.Logger(module, {
      peerId: peerInfo.peerId
    });
  }
  _createClass(AbstractWsConnection, [{
    key: "setBackPressureHandlers",
    value: function setBackPressureHandlers(onLowBackPressure, onHighBackPressure) {
      if (this.onLowBackPressure === undefined && this.onHighBackPressure === undefined) {
        this.onLowBackPressure = onLowBackPressure;
        this.onHighBackPressure = onHighBackPressure;
      } else {
        throw new Error('invariant: cannot re-set backpressure handlers');
      }
    }
  }, {
    key: "ping",
    value: function ping() {
      this.respondedPong = false;
      this.rttStart = Date.now();
      this.sendPing();
    }
  }, {
    key: "onPong",
    value: function onPong() {
      this.respondedPong = true;
      this.rtt = Date.now() - this.rttStart;
    }
  }, {
    key: "evaluateBackPressure",
    value: function evaluateBackPressure() {
      var bufferedAmount = this.getBufferedAmount();
      if (!this.highBackPressure && bufferedAmount > HIGH_BACK_PRESSURE) {
        this.logger.debug('Encountered high back pressure', {
          peerId: this.getPeerInfo().peerId,
          bufferedAmount: bufferedAmount
        });
        this.highBackPressure = true;
        if (this.onHighBackPressure === undefined) {
          throw new Error('onHighBackPressure listener not set');
        }
        this.onHighBackPressure();
      } else if (this.highBackPressure && bufferedAmount < LOW_BACK_PRESSURE) {
        this.logger.debug('Encountered low back pressure', {
          peerId: this.getPeerInfo().peerId,
          bufferedAmount: bufferedAmount
        });
        this.highBackPressure = false;
        if (this.onLowBackPressure === undefined) {
          throw new Error('onLowBackPressure listener not set');
        }
        this.onLowBackPressure();
      }
    }
  }, {
    key: "getPeerInfo",
    value: function getPeerInfo() {
      return this.peerInfo;
    }
  }, {
    key: "getRespondedPong",
    value: function getRespondedPong() {
      return this.respondedPong;
    }
  }, {
    key: "getRtt",
    value: function getRtt() {
      return this.rtt;
    }
  }, {
    key: "getPeerId",
    value: function getPeerId() {
      return this.getPeerInfo().peerId;
    }
  }, {
    key: "getDiagnosticInfo",
    value: function getDiagnosticInfo() {
      var getHumanReadableReadyState = function getHumanReadableReadyState(n) {
        switch (n) {
          case 0:
            return 'connecting';
          case 1:
            return 'open';
          case 2:
            return 'closing';
          case 3:
            return 'closed';
          default:
            return "unknown (".concat(n, ")");
        }
      };
      return {
        peerId: this.getPeerId(),
        rtt: this.getRtt(),
        respondedPong: this.getRespondedPong(),
        readyState: getHumanReadableReadyState(this.getReadyState()),
        bufferedAmount: this.getBufferedAmount(),
        highBackPressure: this.highBackPressure
      };
    }
  }]);
  return AbstractWsConnection;
}();
exports.AbstractWsConnection = AbstractWsConnection;

/***/ }),

/***/ "../network/src/connection/ws/AbstractWsEndpoint.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.UnknownPeerError = exports.Event = exports.DisconnectionReason = exports.DisconnectionCode = exports.AbstractWsEndpoint = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _events = __webpack_require__("../../node_modules/events/events.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _PingPongWs = __webpack_require__("../network/src/connection/ws/PingPongWs.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Event = /*#__PURE__*/function (Event) {
  Event["PEER_CONNECTED"] = "streamr:peer:connect";
  Event["PEER_DISCONNECTED"] = "streamr:peer:disconnect";
  Event["MESSAGE_RECEIVED"] = "streamr:message-received";
  Event["HIGH_BACK_PRESSURE"] = "streamr:high-back-pressure";
  Event["LOW_BACK_PRESSURE"] = "streamr:low-back-pressure";
  return Event;
}({});
exports.Event = Event;
var DisconnectionCode = /*#__PURE__*/function (DisconnectionCode) {
  DisconnectionCode[DisconnectionCode["GRACEFUL_SHUTDOWN"] = 1000] = "GRACEFUL_SHUTDOWN";
  DisconnectionCode[DisconnectionCode["FAILED_HANDSHAKE"] = 4000] = "FAILED_HANDSHAKE";
  DisconnectionCode[DisconnectionCode["DEAD_CONNECTION"] = 4001] = "DEAD_CONNECTION";
  DisconnectionCode[DisconnectionCode["DUPLICATE_SOCKET"] = 4002] = "DUPLICATE_SOCKET";
  DisconnectionCode[DisconnectionCode["INVALID_PROTOCOL_MESSAGE"] = 4003] = "INVALID_PROTOCOL_MESSAGE";
  return DisconnectionCode;
}({});
exports.DisconnectionCode = DisconnectionCode;
var DisconnectionReason = /*#__PURE__*/function (DisconnectionReason) {
  DisconnectionReason["GRACEFUL_SHUTDOWN"] = "streamr:node:graceful-shutdown";
  DisconnectionReason["DUPLICATE_SOCKET"] = "streamr:endpoint:duplicate-connection";
  DisconnectionReason["NO_SHARED_STREAM_PARTS"] = "streamr:node:no-shared-stream-parts";
  DisconnectionReason["DEAD_CONNECTION"] = "dead connection";
  DisconnectionReason["INVALID_PROTOCOL_MESSAGE"] = "streamr:protocol:invalid-protocol-message";
  return DisconnectionReason;
}({});
exports.DisconnectionReason = DisconnectionReason;
var UnknownPeerError = /*#__PURE__*/function (_Error) {
  _inherits(UnknownPeerError, _Error);
  var _super = _createSuper(UnknownPeerError);
  function UnknownPeerError() {
    var _this;
    _classCallCheck(this, UnknownPeerError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "code", UnknownPeerError.CODE);
    return _this;
  }
  return _createClass(UnknownPeerError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.UnknownPeerError = UnknownPeerError;
_defineProperty(UnknownPeerError, "CODE", 'UnknownPeerError');
var logger = new _utils.Logger(module);
var AbstractWsEndpoint = /*#__PURE__*/function (_EventEmitter) {
  _inherits(AbstractWsEndpoint, _EventEmitter);
  var _super2 = _createSuper(AbstractWsEndpoint);
  function AbstractWsEndpoint(peerInfo, pingInterval) {
    var _this2;
    _classCallCheck(this, AbstractWsEndpoint);
    _this2 = _super2.call(this);
    _defineProperty(_assertThisInitialized(_this2), "connectionById", new Map());
    _defineProperty(_assertThisInitialized(_this2), "stopped", false);
    _this2.peerInfo = peerInfo;
    _this2.pingPongWs = new _PingPongWs.PingPongWs(function () {
      return _this2.getConnections();
    }, pingInterval);
    _this2.handshakeTimeoutRefs = {};
    _this2.handshakeTimer = 15 * 1000;
    return _this2;
  }
  _createClass(AbstractWsEndpoint, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(function* (recipientId, message) {
        if (this.stopped) {
          return;
        }
        var connection = this.getConnectionByPeerId(recipientId);
        if (connection !== undefined) {
          try {
            connection.evaluateBackPressure();
            yield connection.send(message);
          } catch (err) {
            logger.debug('Failed to send message', {
              recipientId: recipientId,
              err: err
            });
            connection.terminate();
            throw err;
          }
          logger.trace('Sent message', {
            recipientId: recipientId,
            size: message.length
          });
        } else {
          throw new UnknownPeerError("cannot send to ".concat(recipientId, " because not connected"));
        }
      });
      function send(_x, _x2) {
        return _send.apply(this, arguments);
      }
      return send;
    }()
  }, {
    key: "close",
    value: function close(recipientId, code, reason) {
      var connection = this.getConnectionByPeerId(recipientId);
      if (connection !== undefined) {
        try {
          logger.trace('Close connection', {
            recipientId: recipientId,
            reason: reason
          });
          connection.close(code, reason);
        } catch (err) {
          logger.warn('Failed to close connection', {
            recipientId: recipientId,
            err: err
          });
        }
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this3 = this;
      this.stopped = true;
      this.pingPongWs.stop();
      Object.keys(this.handshakeTimeoutRefs).map(function (id) {
        _this3.clearHandshake(id);
      });
      this.handshakeTimeoutRefs = {};
      return this.doStop();
    }
  }, {
    key: "getRtts",
    value: function getRtts() {
      return this.pingPongWs.getRtts();
    }
  }, {
    key: "getPeers",
    value: function getPeers() {
      return this.connectionById;
    }
  }, {
    key: "getPeerInfos",
    value: function getPeerInfos() {
      return this.getConnections().map(function (connection) {
        return connection.getPeerInfo();
      });
    }
  }, {
    key: "clearHandshake",
    value: function clearHandshake(id) {
      if (this.handshakeTimeoutRefs[id]) {
        clearTimeout(this.handshakeTimeoutRefs[id]);
        delete this.handshakeTimeoutRefs[id];
      }
    }

    /**
     * Custom close logic of subclass
     */
  }, {
    key: "onNewConnection",
    value:
    /**
     * Implementer should invoke this whenever a new connection is formed
     */
    function onNewConnection(connection) {
      var _this4 = this;
      if (this.stopped) {
        connection.close(DisconnectionCode.GRACEFUL_SHUTDOWN, DisconnectionReason.GRACEFUL_SHUTDOWN);
        return;
      }
      var peerInfo = connection.getPeerInfo();
      connection.setBackPressureHandlers(function () {
        _this4.emitLowBackPressure(peerInfo);
      }, function () {
        _this4.emitHighBackPressure(peerInfo);
      });
      this.connectionById.set(connection.getPeerId(), connection);
      logger.trace('Added peer to connection list', {
        peerId: connection.getPeerId()
      });
      this.emit(Event.PEER_CONNECTED, peerInfo);
    }

    /**
     * Implementer should invoke this whenever a message is received.
     */
  }, {
    key: "onReceive",
    value: function onReceive(connection, message) {
      if (this.stopped) {
        return;
      }
      logger.trace('Received message', {
        size: message.length,
        sender: connection.getPeerInfo()
      });
      this.emit(Event.MESSAGE_RECEIVED, connection.getPeerInfo(), message);
    }

    /**
     * Implementer should invoke this whenever a connection is closed.
     */
  }, {
    key: "onClose",
    value: function onClose(connection, code, reason) {
      logger.trace('onClose', {
        peerId: connection.getPeerId(),
        code: code,
        reason: reason
      });
      this.connectionById.delete(connection.getPeerId());
      try {
        this.doClose(connection, code, reason);
      } finally {
        this.emit(Event.PEER_DISCONNECTED, connection.getPeerInfo(), reason);
      }
    }
  }, {
    key: "getConnections",
    value: function getConnections() {
      return _toConsumableArray(this.connectionById.values());
    }
  }, {
    key: "getConnectionByPeerId",
    value: function getConnectionByPeerId(peerId) {
      return this.connectionById.get(peerId);
    }
  }, {
    key: "emitLowBackPressure",
    value: function emitLowBackPressure(peerInfo) {
      this.emit(Event.LOW_BACK_PRESSURE, peerInfo);
    }
  }, {
    key: "emitHighBackPressure",
    value: function emitHighBackPressure(peerInfo) {
      this.emit(Event.HIGH_BACK_PRESSURE, peerInfo);
    }
  }]);
  return AbstractWsEndpoint;
}(_events.EventEmitter);
exports.AbstractWsEndpoint = AbstractWsEndpoint;

/***/ }),

/***/ "../network/src/connection/ws/BrowserClientWsConnection.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.BrowserWebSocketConnectionFactory = exports.BrowserClientWsConnection = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.freeze.js");
var _AbstractWsConnection2 = __webpack_require__("../network/src/connection/ws/AbstractWsConnection.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var logger = new _utils.Logger(module);
var BrowserWebSocketConnectionFactory = Object.freeze({
  createConnection: function createConnection(socket, peerInfo) {
    return new BrowserClientWsConnection(socket, peerInfo);
  }
});
exports.BrowserWebSocketConnectionFactory = BrowserWebSocketConnectionFactory;
var BrowserClientWsConnection = /*#__PURE__*/function (_AbstractWsConnection) {
  _inherits(BrowserClientWsConnection, _AbstractWsConnection);
  var _super = _createSuper(BrowserClientWsConnection);
  function BrowserClientWsConnection(socket, peerInfo) {
    var _this;
    _classCallCheck(this, BrowserClientWsConnection);
    _this = _super.call(this, peerInfo);
    _this.socket = socket;
    return _this;
  }
  _createClass(BrowserClientWsConnection, [{
    key: "close",
    value: function close(code, reason) {
      try {
        this.socket.close(code, reason);
      } catch (err) {
        logger.error('Failed to close connection', err);
      }
    }
  }, {
    key: "terminate",
    value: function terminate() {
      try {
        this.socket.close();
      } catch (err) {
        logger.error('Failed to terminate connection', err);
      }
    }
  }, {
    key: "getBufferedAmount",
    value: function getBufferedAmount() {
      return this.socket.bufferedAmount;
    }
  }, {
    key: "getReadyState",
    value: function getReadyState() {
      return this.socket.readyState;
    }

    // TODO: toString() representation for logging
  }, {
    key: "sendPing",
    value: function sendPing() {
      this.socket.send('ping');
    }
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(function* (message) {
        this.socket.send(message);
      });
      function send(_x) {
        return _send.apply(this, arguments);
      }
      return send;
    }()
  }]);
  return BrowserClientWsConnection;
}(_AbstractWsConnection2.AbstractWsConnection);
exports.BrowserClientWsConnection = BrowserClientWsConnection;

/***/ }),

/***/ "../network/src/connection/ws/BrowserClientWsEndpoint.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _websocket = __webpack_require__("../../node_modules/websocket/lib/browser.js");
var _AbstractWsEndpoint = __webpack_require__("../network/src/connection/ws/AbstractWsEndpoint.ts");
var _BrowserClientWsConnection = __webpack_require__("../network/src/connection/ws/BrowserClientWsConnection.ts");
var _AbstractClientWsEndpoint = __webpack_require__("../network/src/connection/ws/AbstractClientWsEndpoint.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var logger = new _utils.Logger(module);
var BrowserClientWsEndpoint = /*#__PURE__*/function (_AbstractClientWsEndp) {
  _inherits(BrowserClientWsEndpoint, _AbstractClientWsEndp);
  var _super = _createSuper(BrowserClientWsEndpoint);
  function BrowserClientWsEndpoint() {
    _classCallCheck(this, BrowserClientWsEndpoint);
    return _super.apply(this, arguments);
  }
  _createClass(BrowserClientWsEndpoint, [{
    key: "doConnect",
    value: function doConnect(serverUrl, serverPeerInfo) {
      var _this = this;
      return new Promise(function (resolve, reject) {
        try {
          var ws = new _websocket.w3cwebsocket(serverUrl);
          ws.onopen = function () {
            _this.handshakeInit(ws, serverPeerInfo, reject);
          };
          ws.onmessage = function (message) {
            _this.handshakeListener(ws, serverPeerInfo, serverUrl, message, resolve);
          };
          ws.onerror = function (error) {
            _this.onHandshakeError(serverUrl, error, reject);
          };
          ws.onclose = function (event) {
            _this.onHandshakeClosed(serverUrl, event.code, event.reason, reject);
          };
        } catch (err) {
          logger.trace('Failed to connect to server', {
            serverUrl: serverUrl,
            err: err
          });
          reject(err);
        }
      });
    }
  }, {
    key: "doSetUpConnection",
    value: function doSetUpConnection(ws, serverPeerInfo) {
      var _this2 = this;
      var connection = _BrowserClientWsConnection.BrowserWebSocketConnectionFactory.createConnection(ws, serverPeerInfo);
      ws.onmessage = function (message) {
        var parsedMsg = message.data.toString();
        if (parsedMsg === 'pong') {
          connection.onPong();
        } else {
          _this2.onReceive(connection, parsedMsg);
        }
      };
      ws.onclose = function (event) {
        _this2.onClose(connection, event.code, event.reason);
        if (event.code === _AbstractWsEndpoint.DisconnectionCode.DUPLICATE_SOCKET) {
          logger.warn('Refused connection (Duplicate nodeId detected, are you running multiple nodes with the same private key?)');
        } else if (event.code === _AbstractWsEndpoint.DisconnectionCode.INVALID_PROTOCOL_MESSAGE) {
          logger.warn('Refused connection (Invalid protocol message format detected, are you running an outdated version?)');
        }
      };
      ws.onerror = function (error) {
        _this2.ongoingConnectionError(serverPeerInfo.peerId, error, connection);
      };
      return connection;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "doHandshakeResponse",
    value: function doHandshakeResponse(uuid, _peerId, ws) {
      ws.send(JSON.stringify({
        uuid: uuid,
        peerId: this.peerInfo.peerId
      }));
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "doHandshakeParse",
    value: function doHandshakeParse(message) {
      var _JSON$parse = JSON.parse(message.data.toString()),
        uuid = _JSON$parse.uuid,
        peerId = _JSON$parse.peerId;
      return {
        uuid: uuid,
        peerId: peerId
      };
    }
  }]);
  return BrowserClientWsEndpoint;
}(_AbstractClientWsEndpoint.AbstractClientWsEndpoint);
exports["default"] = BrowserClientWsEndpoint;
module.exports = exports.default;

/***/ }),

/***/ "../network/src/connection/ws/PingPongWs.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PingPongWs = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _utils.Logger(module);
var PingPongWs = /*#__PURE__*/function () {
  function PingPongWs(getConnections, pingIntervalInMs) {
    var _this = this;
    _classCallCheck(this, PingPongWs);
    this.getConnections = getConnections;
    this.pingIntervalInMs = pingIntervalInMs;
    this.pingInterval = setInterval(function () {
      return _this.pingConnections();
    }, pingIntervalInMs);
  }
  _createClass(PingPongWs, [{
    key: "getRtts",
    value: function getRtts() {
      var rtts = {};
      this.getConnections().forEach(function (connection) {
        var rtt = connection.getRtt();
        if (rtt !== undefined) {
          rtts[connection.getPeerId()] = rtt;
        }
      });
      return rtts;
    }
  }, {
    key: "stop",
    value: function stop() {
      clearInterval(this.pingInterval);
    }
  }, {
    key: "pingConnections",
    value: function pingConnections() {
      var _this2 = this;
      this.getConnections().forEach(function (connection) {
        if (!connection.getRespondedPong()) {
          logger.warn('Terminate connection (did not receive pong response in time)', {
            peerId: connection.getPeerId(),
            pingIntervalInMs: _this2.pingIntervalInMs
          });
          connection.terminate();
        } else {
          try {
            connection.ping();
            logger.trace('Sent ping', {
              peerId: connection.getPeerId(),
              rtt: connection.getRtt()
            });
          } catch (err) {
            logger.warn('Terminate connection (error thrown when attempting to ping)', {
              peerId: connection.getPeerId(),
              err: err
            });
            connection.terminate();
          }
        }
      });
    }
  }]);
  return PingPongWs;
}();
exports.PingPongWs = PingPongWs;

/***/ }),

/***/ "../network/src/constants.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.GOOGLE_STUN_SERVER = exports.DEFAULT_MAX_NEIGHBOR_COUNT = exports.COUNTER_UNSUBSCRIBE = void 0;
var COUNTER_UNSUBSCRIBE = -1;
exports.COUNTER_UNSUBSCRIBE = COUNTER_UNSUBSCRIBE;
var DEFAULT_MAX_NEIGHBOR_COUNT = 4;
exports.DEFAULT_MAX_NEIGHBOR_COUNT = DEFAULT_MAX_NEIGHBOR_COUNT;
var GOOGLE_STUN_SERVER = {
  url: 'stun:stun.l.google.com',
  port: 19302
};
exports.GOOGLE_STUN_SERVER = GOOGLE_STUN_SERVER;

/***/ }),

/***/ "../network/src/createNetworkNode.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createNetworkNode = exports.TEST_CONFIG = void 0;
var _NodeToTracker = __webpack_require__("../network/src/protocol/NodeToTracker.ts");
var _NodeToNode = __webpack_require__("../network/src/protocol/NodeToNode.ts");
var _RtcSignaller = __webpack_require__("../network/src/logic/RtcSignaller.ts");
var _NetworkNode = __webpack_require__("../network/src/logic/NetworkNode.ts");
var _NegotiatedProtocolVersions = __webpack_require__("../network/src/connection/NegotiatedProtocolVersions.ts");
var _PeerInfo = __webpack_require__("../network/src/connection/PeerInfo.ts");
var _NodeClientWsEndpoint = _interopRequireDefault(__webpack_require__("../network/src/connection/ws/BrowserClientWsEndpoint.ts"));
var _WebRtcEndpoint = __webpack_require__("../network/src/connection/webrtc/WebRtcEndpoint.ts");
var _NodeWebRtcConnection = __webpack_require__("../network/src/connection/webrtc/BrowserWebRtcConnection.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TEST_CONFIG = {
  disconnectionWaitTime: 30 * 1000,
  peerPingInterval: 30 * 1000,
  newWebrtcConnectionTimeout: 15 * 1000,
  webrtcDatachannelBufferThresholdLow: Math.pow(2, 15),
  webrtcDatachannelBufferThresholdHigh: Math.pow(2, 17),
  webrtcSendBufferMaxMessageCount: 500,
  iceServers: [],
  rttUpdateTimeout: 15 * 1000,
  trackerConnectionMaintenanceInterval: 5 * 1000,
  webrtcDisallowPrivateAddresses: false,
  acceptProxyConnections: false,
  trackerPingInterval: 60 * 1000,
  webrtcPortRange: {
    min: 6000,
    max: 65535
  },
  webrtcMaxMessageSize: 1048576
};
exports.TEST_CONFIG = TEST_CONFIG;
var createNetworkNode = function createNetworkNode(_ref) {
  var id = _ref.id,
    location = _ref.location,
    trackers = _ref.trackers,
    metricsContext = _ref.metricsContext,
    peerPingInterval = _ref.peerPingInterval,
    trackerPingInterval = _ref.trackerPingInterval,
    disconnectionWaitTime = _ref.disconnectionWaitTime,
    newWebrtcConnectionTimeout = _ref.newWebrtcConnectionTimeout,
    rttUpdateTimeout = _ref.rttUpdateTimeout,
    webrtcDatachannelBufferThresholdLow = _ref.webrtcDatachannelBufferThresholdLow,
    webrtcDatachannelBufferThresholdHigh = _ref.webrtcDatachannelBufferThresholdHigh,
    webrtcSendBufferMaxMessageCount = _ref.webrtcSendBufferMaxMessageCount,
    iceServers = _ref.iceServers,
    trackerConnectionMaintenanceInterval = _ref.trackerConnectionMaintenanceInterval,
    webrtcDisallowPrivateAddresses = _ref.webrtcDisallowPrivateAddresses,
    acceptProxyConnections = _ref.acceptProxyConnections,
    webrtcPortRange = _ref.webrtcPortRange,
    webrtcMaxMessageSize = _ref.webrtcMaxMessageSize,
    externalIp = _ref.externalIp;
  var peerInfo = _PeerInfo.PeerInfo.newNode(id, undefined, undefined, location);
  var endpoint = new _NodeClientWsEndpoint.default(peerInfo, trackerPingInterval);
  var nodeToTracker = new _NodeToTracker.NodeToTracker(endpoint);
  var webRtcSignaller = new _RtcSignaller.RtcSignaller(peerInfo, nodeToTracker);
  var negotiatedProtocolVersions = new _NegotiatedProtocolVersions.NegotiatedProtocolVersions(peerInfo);
  var nodeToNode = new _NodeToNode.NodeToNode(new _WebRtcEndpoint.WebRtcEndpoint(peerInfo, iceServers, webRtcSignaller, metricsContext, negotiatedProtocolVersions, _NodeWebRtcConnection.webRtcConnectionFactory, newWebrtcConnectionTimeout, peerPingInterval, webrtcDatachannelBufferThresholdLow, webrtcDatachannelBufferThresholdHigh, webrtcSendBufferMaxMessageCount, webrtcDisallowPrivateAddresses, webrtcPortRange, webrtcMaxMessageSize, externalIp));
  return new _NetworkNode.NetworkNode({
    peerInfo: peerInfo,
    trackers: trackers,
    protocols: {
      nodeToTracker: nodeToTracker,
      nodeToNode: nodeToNode
    },
    metricsContext: metricsContext,
    disconnectionWaitTime: disconnectionWaitTime,
    rttUpdateTimeout: rttUpdateTimeout,
    trackerConnectionMaintenanceInterval: trackerConnectionMaintenanceInterval,
    acceptProxyConnections: acceptProxyConnections
  });
};
exports.createNetworkNode = createNetworkNode;

/***/ }),

/***/ "../network/src/exports-browser.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "AbstractNodeOptions", ({
  enumerable: true,
  get: function get() {
    return _identifiers.AbstractNodeOptions;
  }
}));
Object.defineProperty(exports, "IceServer", ({
  enumerable: true,
  get: function get() {
    return _WebRtcConnection.IceServer;
  }
}));
Object.defineProperty(exports, "Location", ({
  enumerable: true,
  get: function get() {
    return _identifiers.Location;
  }
}));
Object.defineProperty(exports, "Logger", ({
  enumerable: true,
  get: function get() {
    return _utils.Logger;
  }
}));
Object.defineProperty(exports, "MetricsContext", ({
  enumerable: true,
  get: function get() {
    return _utils.MetricsContext;
  }
}));
Object.defineProperty(exports, "NameDirectory", ({
  enumerable: true,
  get: function get() {
    return _NameDirectory.NameDirectory;
  }
}));
Object.defineProperty(exports, "NetworkNode", ({
  enumerable: true,
  get: function get() {
    return _NetworkNode.NetworkNode;
  }
}));
Object.defineProperty(exports, "NetworkNodeOptions", ({
  enumerable: true,
  get: function get() {
    return _createNetworkNode.NetworkNodeOptions;
  }
}));
Object.defineProperty(exports, "createNetworkNode", ({
  enumerable: true,
  get: function get() {
    return _createNetworkNode.createNetworkNode;
  }
}));
__webpack_require__("../../node_modules/setimmediate/setImmediate.js");
var _WebRtcConnection = __webpack_require__("../network/src/connection/webrtc/WebRtcConnection.ts");
var _NameDirectory = __webpack_require__("../network/src/NameDirectory.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _identifiers = __webpack_require__("../network/src/identifiers.ts");
var _createNetworkNode = __webpack_require__("../network/src/createNetworkNode.ts");
var _NetworkNode = __webpack_require__("../network/src/logic/NetworkNode.ts");

/***/ }),

/***/ "../network/src/helpers/AddressTools.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getAddressFromIceCandidate = getAddressFromIceCandidate;
exports.isPrivateIPv4 = isPrivateIPv4;
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.match.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
var _ipaddr = _interopRequireDefault(__webpack_require__("../../node_modules/ipaddr.js/lib/ipaddr.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
// IPv4 private address ranges as specified by RFC 1918
var IPv4PrivateRanges = ['10.0.0.0/8', '172.16.0.0/12', '192.168.0.0/16'].map(function (a) {
  return _ipaddr.default.parseCIDR(a);
});
function isPrivateIPv4(address) {
  if (_ipaddr.default.IPv4.isValid(address)) {
    var ip = _ipaddr.default.IPv4.parse(address);
    var _iterator = _createForOfIteratorHelper(IPv4PrivateRanges),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var range = _step.value;
        if (ip.match(range)) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return false;
}
function getAddressFromIceCandidate(candidate) {
  var fields = candidate.split(' ').filter(function (field) {
    return field.length > 0;
  });
  return fields.length >= 5 && _ipaddr.default.isValid(fields[4]) ? fields[4] : undefined;
}

/***/ }),

/***/ "../network/src/identifiers.ts":
/***/ (() => {

"use strict";


/***/ }),

/***/ "../network/src/logic/DisconnectionManager.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DisconnectionManager = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _NameDirectory = __webpack_require__("../network/src/NameDirectory.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _utils.Logger(module);
/**
 * DisconnectionManager assists a network node in disconnecting from other nodes when streams are
 * no longer shared between them.
 *
 * There are two ways this is achieved:
 *  1. Manual: a node can schedule (and cancel) disconnections that get executed after `disconnectionDelayInMs` if
 *      they still don't share streams.
 *  2. Automatic: a clean up interval is ran periodically in which any node without shared streams gets disconnected
 *      from.
 */
var DisconnectionManager = /*#__PURE__*/function () {
  function DisconnectionManager(_ref) {
    var getAllNodes = _ref.getAllNodes,
      hasSharedStreams = _ref.hasSharedStreamParts,
      disconnect = _ref.disconnect,
      disconnectionDelayInMs = _ref.disconnectionDelayInMs,
      cleanUpIntervalInMs = _ref.cleanUpIntervalInMs;
    _classCallCheck(this, DisconnectionManager);
    _defineProperty(this, "disconnectionTimers", new Map());
    _defineProperty(this, "connectionCleanUpInterval", null);
    this.getAllNodes = getAllNodes;
    this.hasSharedStreams = hasSharedStreams;
    this.disconnect = disconnect;
    this.disconnectionDelayInMs = disconnectionDelayInMs;
    this.cleanUpIntervalInMs = cleanUpIntervalInMs;
  }
  _createClass(DisconnectionManager, [{
    key: "start",
    value: function start() {
      var _this = this;
      this.connectionCleanUpInterval = setInterval(function () {
        var nodeIds = _this.getAllNodes();
        var nonNeighborNodeIds = nodeIds.filter(function (nodeId) {
          return !_this.hasSharedStreams(nodeId);
        });
        if (nonNeighborNodeIds.length > 0) {
          logger.debug('Disconnect from nodes', {
            nodeCount: nonNeighborNodeIds.length
          });
          nonNeighborNodeIds.forEach(function (nodeId) {
            _this.loggedDisconnect(nodeId);
          });
        }
      }, this.cleanUpIntervalInMs);
    }
  }, {
    key: "stop",
    value: function stop() {
      clearInterval(this.connectionCleanUpInterval);
      this.disconnectionTimers.forEach(function (timeout) {
        clearTimeout(timeout);
      });
    }
  }, {
    key: "scheduleDisconnectionIfNoSharedStreamParts",
    value: function scheduleDisconnectionIfNoSharedStreamParts(nodeId) {
      var _this2 = this;
      if (!this.hasSharedStreams(nodeId)) {
        this.cancelScheduledDisconnection(nodeId);
        this.disconnectionTimers.set(nodeId, setTimeout(function () {
          _this2.disconnectionTimers.delete(nodeId);
          if (!_this2.hasSharedStreams(nodeId)) {
            _this2.loggedDisconnect(nodeId);
          }
        }, this.disconnectionDelayInMs));
        logger.trace('Schedule disconnection from node', {
          nodeId: nodeId,
          delayInMs: this.disconnectionDelayInMs
        });
      }
    }
  }, {
    key: "cancelScheduledDisconnection",
    value: function cancelScheduledDisconnection(nodeId) {
      var timeout = this.disconnectionTimers.get(nodeId);
      if (timeout !== undefined) {
        clearTimeout(timeout);
        this.disconnectionTimers.delete(nodeId);
        logger.trace('Cancel scheduled disconnection from node', {
          nodeId: nodeId
        });
      }
    }
  }, {
    key: "loggedDisconnect",
    value: function loggedDisconnect(nodeId) {
      logger.trace('loggedDisconnect', {
        nodeId: _NameDirectory.NameDirectory.getName(nodeId)
      });
      this.disconnect(nodeId, DisconnectionManager.DISCONNECTION_REASON);
    }
  }]);
  return DisconnectionManager;
}();
exports.DisconnectionManager = DisconnectionManager;
_defineProperty(DisconnectionManager, "DISCONNECTION_REASON", 'no shared streams');

/***/ }),

/***/ "../network/src/logic/DuplicateMessageDetector.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.NumberPair = exports.InvalidNumberingError = exports.GapMisMatchError = exports.DuplicateMessageDetector = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.splice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Represent a pair of numbers (a,b). Ordering between two pairs is defined as
 * follows. First compare first numbers. Compare second numbers if first are
 * equal.
 */
var NumberPair = /*#__PURE__*/function () {
  function NumberPair(a, b) {
    _classCallCheck(this, NumberPair);
    this.a = a;
    this.b = b;
  }
  _createClass(NumberPair, [{
    key: "greaterThanOrEqual",
    value: function greaterThanOrEqual(otherPair) {
      return this.greaterThan(otherPair) || this.equalTo(otherPair);
    }
  }, {
    key: "greaterThan",
    value: function greaterThan(otherPair) {
      return this.compareTo(otherPair) === 1;
    }
  }, {
    key: "equalTo",
    value: function equalTo(otherPair) {
      return this.compareTo(otherPair) === 0;
    }
  }, {
    key: "compareTo",
    value: function compareTo(otherPair) {
      if (this.a > otherPair.a) {
        return 1;
      }
      if (this.a < otherPair.a) {
        return -1;
      }
      if (this.b > otherPair.b) {
        return 1;
      }
      if (this.b < otherPair.b) {
        return -1;
      }
      return 0;
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this.a, "|").concat(this.b);
    }
  }]);
  return NumberPair;
}();
exports.NumberPair = NumberPair;
var InvalidNumberingError = /*#__PURE__*/function (_Error) {
  _inherits(InvalidNumberingError, _Error);
  var _super = _createSuper(InvalidNumberingError);
  function InvalidNumberingError() {
    _classCallCheck(this, InvalidNumberingError);
    return _super.call(this, 'pre-condition: previousNumber < number');
  }
  return _createClass(InvalidNumberingError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.InvalidNumberingError = InvalidNumberingError;
var GapMisMatchError = /*#__PURE__*/function (_Error2) {
  _inherits(GapMisMatchError, _Error2);
  var _super2 = _createSuper(GapMisMatchError);
  function GapMisMatchError(state, previousNumber, number) {
    _classCallCheck(this, GapMisMatchError);
    return _super2.call(this, 'pre-condition: gap overlap in given numbers:' + " previousNumber=".concat(previousNumber, ", number=").concat(number, ", state=").concat(state));
  }
  return _createClass(GapMisMatchError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 *
 * Keeps track of a stream's message numbers and reports already seen numbers
 * as duplicates.
 *
 * Leverages the fact that message are assigned numbers from a strictly
 * increasing integer sequence for lowered space complexity. For example,
 * if we know that all messages up to number N have been seen, we can only
 * store the number N to provide message identity check. This is because
 * anything less than N can be deemed a duplicate.
 *
 * Messages arriving out-of-order makes this a bit harder since gaps form.
 * Most of the code in this class is built to deal with this complexity.
 * Basically, we need to keep track of which intervals [N,M] could still
 * contain unseen messages. We should also remove intervals after we are sure
 * that they contain no unseen messages.
 *
 * In addition to the above, there needs to be a limit to the number of
 * intervals we store, as it could well be that some messages never
 * arrive. The strategy is to start removing the lowest numbered
 * intervals when storage limits are hit.
 *
 */
exports.GapMisMatchError = GapMisMatchError;
var DuplicateMessageDetector = /*#__PURE__*/function () {
  function DuplicateMessageDetector() {
    var maxNumberOfGaps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
    _classCallCheck(this, DuplicateMessageDetector);
    this.maxNumberOfGaps = maxNumberOfGaps;
    this.gaps = []; // ascending order of half-closed intervals (x,y] representing gaps that contain unseen message(s)
  }

  /**
   * returns true if number has not yet been seen (i.e. is not a duplicate)
   */
  _createClass(DuplicateMessageDetector, [{
    key: "markAndCheck",
    value: function markAndCheck(previousNumber, number) {
      if (previousNumber && previousNumber.greaterThanOrEqual(number)) {
        throw new InvalidNumberingError();
      }
      if (this.gaps.length === 0) {
        this.gaps.push([number, new NumberPair(Infinity, Infinity)]);
        return true;
      }

      // Handle special case where previousNumber is not provided. Only
      // minimal duplicate detection is provided (comparing against latest
      // known message number).
      if (previousNumber === null) {
        if (number.greaterThan(this.gaps[this.gaps.length - 1][0])) {
          this.gaps[this.gaps.length - 1][0] = number;
          return true;
        }
        return false;
      }
      for (var i = this.gaps.length - 1; i >= 0; --i) {
        var _this$gaps$i = _slicedToArray(this.gaps[i], 2),
          lowerBound = _this$gaps$i[0],
          upperBound = _this$gaps$i[1]; // invariant: upperBound > lowerBound

        // implies number > upperBound (would've been handled in previous iteration if gap exists)
        if (previousNumber.greaterThanOrEqual(upperBound)) {
          return false;
        }
        if (previousNumber.greaterThanOrEqual(lowerBound)) {
          if (number.greaterThan(upperBound)) {
            throw new GapMisMatchError(this.toString(), previousNumber, number);
          }
          if (previousNumber.equalTo(lowerBound)) {
            if (number.equalTo(upperBound)) {
              this.gaps.splice(i, 1);
            } else {
              this.gaps[i] = [number, upperBound];
            }
          } else if (number.equalTo(upperBound)) {
            this.gaps[i] = [lowerBound, previousNumber];
          } else {
            this.gaps.splice(i, 1, [lowerBound, previousNumber], [number, upperBound]);
          }

          // invariants after:
          //   - gaps are in ascending order
          //   - the intersection between any two gaps is empty
          //   - there are no gaps that define the empty set
          //   - last gap is [n, Infinity]
          //   - anything not covered by a gap is considered seen

          this.dropLowestGapIfOverMaxNumberOfGaps();
          return true;
        }
        if (number.greaterThan(lowerBound)) {
          throw new GapMisMatchError(this.toString(), previousNumber, number);
        }
      }
      return false;
    }
  }, {
    key: "dropLowestGapIfOverMaxNumberOfGaps",
    value: function dropLowestGapIfOverMaxNumberOfGaps() {
      // invariant: this.gaps.length <= this.maxNumberOfGaps + 1
      if (this.gaps.length > this.maxNumberOfGaps) {
        this.gaps.shift();
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.gaps.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          lower = _ref2[0],
          upper = _ref2[1];
        return "(".concat(lower, ", ").concat(upper, "]");
      }).join(', ');
    }
  }]);
  return DuplicateMessageDetector;
}();
exports.DuplicateMessageDetector = DuplicateMessageDetector;

/***/ }),

/***/ "../network/src/logic/InstructionRetryManager.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.InstructionRetryManager = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _utils.Logger(module);
var InstructionRetryManager = /*#__PURE__*/function () {
  function InstructionRetryManager(handleFn, intervalInMs) {
    _classCallCheck(this, InstructionRetryManager);
    this.handleFn = handleFn;
    this.intervalInMs = intervalInMs;
    this.instructionRetryIntervals = {};
    this.statusSendCounterLimit = 9;
    this.stopped = false;
  }
  _createClass(InstructionRetryManager, [{
    key: "add",
    value: function add(instructionMessage, trackerId) {
      var _this = this;
      if (this.stopped) {
        return;
      }
      var streamPartId = instructionMessage.getStreamPartID();
      if (this.instructionRetryIntervals[streamPartId]) {
        clearTimeout(this.instructionRetryIntervals[streamPartId].interval);
      }
      this.instructionRetryIntervals[streamPartId] = {
        interval: setTimeout(function () {
          return _this.retryFunction(instructionMessage, trackerId);
        }, this.intervalInMs),
        counter: 0
      };
    }
  }, {
    key: "retryFunction",
    value: function () {
      var _retryFunction = _asyncToGenerator(function* (instructionMessage, trackerId) {
        var _this2 = this;
        if (this.stopped) {
          return;
        }
        var streamPartId = instructionMessage.getStreamPartID();
        try {
          // First and every nth instruction retries will always send status messages to tracker
          yield this.handleFn(instructionMessage, trackerId, this.instructionRetryIntervals[streamPartId].counter !== 0);
        } catch (err) {
          logger.warn('Encountered error handling instruction', err);
        }
        // Check that stream has not been removed
        if (this.instructionRetryIntervals[streamPartId]) {
          if (this.instructionRetryIntervals[streamPartId].counter >= this.statusSendCounterLimit) {
            this.instructionRetryIntervals[streamPartId].counter = 0;
          } else {
            this.instructionRetryIntervals[streamPartId].counter += 1;
          }
          clearTimeout(this.instructionRetryIntervals[streamPartId].interval);
          this.instructionRetryIntervals[streamPartId].interval = setTimeout(function () {
            return _this2.retryFunction(instructionMessage, trackerId);
          }, this.intervalInMs);
        }
      });
      function retryFunction(_x, _x2) {
        return _retryFunction.apply(this, arguments);
      }
      return retryFunction;
    }()
  }, {
    key: "removeStreamPart",
    value: function removeStreamPart(streamPartId) {
      if (this.stopped) {
        return;
      }
      if (streamPartId in this.instructionRetryIntervals) {
        clearTimeout(this.instructionRetryIntervals[streamPartId].interval);
        delete this.instructionRetryIntervals[streamPartId];
        logger.debug('Removed', {
          streamPartId: streamPartId
        });
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      Object.values(this.instructionRetryIntervals).forEach(function (obj) {
        clearTimeout(obj.interval);
        obj.counter = 0;
      });
      this.instructionRetryIntervals = {};
      this.stopped = true;
    }
  }]);
  return InstructionRetryManager;
}();
exports.InstructionRetryManager = InstructionRetryManager;

/***/ }),

/***/ "../network/src/logic/InstructionThrottler.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.InstructionThrottler = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.some.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _cancelablePromise = __webpack_require__("../../node_modules/cancelable-promise/umd/CancelablePromise.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _utils.Logger(module);

/**
 * InstructionThrottler makes sure that
 *  1. no more than one instruction is handled at a time
 *  2. any new instructions arriving while an instruction is being handled are queued in a
 *     way where only the most latest instruction per stream part is kept in queue.
 */
var InstructionThrottler = /*#__PURE__*/function () {
  function InstructionThrottler(handleFn) {
    _classCallCheck(this, InstructionThrottler);
    _defineProperty(this, "queue", {});
    _defineProperty(this, "instructionCounter", {});
    this.handleFn = handleFn;
    this.ongoingPromises = {};
    this.stopped = false;
  }
  _createClass(InstructionThrottler, [{
    key: "add",
    value: function add(instructionMessage, trackerId) {
      if (this.stopped) {
        return;
      }
      var streamPartId = instructionMessage.getStreamPartID();
      if (!this.instructionCounter[streamPartId] || this.instructionCounter[streamPartId] <= instructionMessage.counter) {
        this.instructionCounter[streamPartId] = instructionMessage.counter;
        this.queue[streamPartId] = {
          instructionMessage: instructionMessage,
          trackerId: trackerId
        };
        if (!this.ongoingPromises[streamPartId]) {
          this.ongoingPromises[streamPartId] = {
            promise: null,
            handling: false
          };
        }
        if (!this.ongoingPromises[streamPartId].handling) {
          this.invokeHandleFnWithLock(streamPartId).catch(function (err) {
            logger.warn('Failed to handle instruction', err);
          });
        }
      }
    }
  }, {
    key: "removeStreamPart",
    value: function removeStreamPart(streamPartId) {
      if (this.stopped) {
        return;
      }
      delete this.queue[streamPartId];
      delete this.instructionCounter[streamPartId];
      if (this.ongoingPromises[streamPartId]) {
        this.ongoingPromises[streamPartId].promise.cancel();
      }
      delete this.ongoingPromises[streamPartId];
    }
  }, {
    key: "isIdle",
    value: function isIdle() {
      return !Object.values(this.ongoingPromises).some(function (p) {
        return p.handling;
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this = this;
      this.queue = {};
      this.instructionCounter = {};
      Object.keys(this.ongoingPromises).forEach(function (streamPartId) {
        if (_this.ongoingPromises[streamPartId]) {
          _this.ongoingPromises[streamPartId].promise.cancel();
        }
        delete _this.ongoingPromises[streamPartId];
      });
      this.ongoingPromises = {};
      this.stopped = true;
    }
  }, {
    key: "invokeHandleFnWithLock",
    value: function () {
      var _invokeHandleFnWithLock = _asyncToGenerator(function* (streamPartId) {
        if (this.stopped) {
          return;
        }
        if (!this.queue[streamPartId]) {
          if (this.ongoingPromises[streamPartId]) {
            this.ongoingPromises[streamPartId].handling = false;
          }
          return;
        }
        this.ongoingPromises[streamPartId].handling = true;
        var _this$queue$streamPar = this.queue[streamPartId],
          instructionMessage = _this$queue$streamPar.instructionMessage,
          trackerId = _this$queue$streamPar.trackerId;
        delete this.queue[streamPartId];
        try {
          this.ongoingPromises[streamPartId].promise = (0, _cancelablePromise.cancelable)(this.handleFn(instructionMessage, trackerId));
          yield this.ongoingPromises[streamPartId].promise;
        } catch (err) {
          logger.warn('Encountered error handling instruction', err);
        } finally {
          this.invokeHandleFnWithLock(streamPartId);
        }
      });
      function invokeHandleFnWithLock(_x) {
        return _invokeHandleFnWithLock.apply(this, arguments);
      }
      return invokeHandleFnWithLock;
    }()
  }]);
  return InstructionThrottler;
}();
exports.InstructionThrottler = InstructionThrottler;

/***/ }),

/***/ "../network/src/logic/NetworkNode.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.NetworkNode = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _Node2 = __webpack_require__("../network/src/logic/Node.ts");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
Convenience wrapper for building client-facing functionality. Used by client.
 */
var NetworkNode = /*#__PURE__*/function (_Node) {
  _inherits(NetworkNode, _Node);
  var _super = _createSuper(NetworkNode);
  function NetworkNode(opts) {
    _classCallCheck(this, NetworkNode);
    var networkOpts = _objectSpread({}, opts);
    return _super.call(this, networkOpts);
  }
  _createClass(NetworkNode, [{
    key: "setExtraMetadata",
    value: function setExtraMetadata(metadata) {
      this.extraMetadata = metadata;
    }
  }, {
    key: "publish",
    value: function publish(streamMessage) {
      var streamPartId = streamMessage.getStreamPartID();
      if (this.isProxiedStreamPart(streamPartId, _protocol.ProxyDirection.SUBSCRIBE) && streamMessage.messageType === _protocol.StreamMessageType.MESSAGE) {
        throw new Error("Cannot publish content data to ".concat(streamPartId, " as proxy subscribe connections have been set"));
      }
      this.subscribeToStreamIfHaveNotYet(streamPartId);
      this.onDataReceived(streamMessage);
    }
  }, {
    key: "setProxies",
    value: function () {
      var _setProxies = _asyncToGenerator(function* (streamPartId, contactNodeIds, direction, getUserId, connectionCount) {
        if (this.acceptProxyConnections) {
          throw new Error('cannot set proxies when acceptProxyConnections=true');
        }
        yield this.doSetProxies(streamPartId, contactNodeIds, direction, getUserId, connectionCount);
      });
      function setProxies(_x, _x2, _x3, _x4, _x5) {
        return _setProxies.apply(this, arguments);
      }
      return setProxies;
    }()
  }, {
    key: "addMessageListener",
    value: function addMessageListener(cb) {
      this.on(_Node2.Event.UNSEEN_MESSAGE_RECEIVED, cb);
    }
  }, {
    key: "removeMessageListener",
    value: function removeMessageListener(cb) {
      this.off(_Node2.Event.UNSEEN_MESSAGE_RECEIVED, cb);
    }
  }, {
    key: "subscribe",
    value: function subscribe(streamPartId) {
      if (this.isProxiedStreamPart(streamPartId, _protocol.ProxyDirection.PUBLISH)) {
        throw new Error("Cannot subscribe to ".concat(streamPartId, " as proxy publish connections have been set"));
      }
      this.subscribeToStreamIfHaveNotYet(streamPartId);
    }
  }, {
    key: "subscribeAndWaitForJoin",
    value: function () {
      var _subscribeAndWaitForJoin = _asyncToGenerator(function* (streamPartId, timeout) {
        if (this.isProxiedStreamPart(streamPartId, _protocol.ProxyDirection.PUBLISH)) {
          throw new Error("Cannot subscribe to ".concat(streamPartId, " as proxy publish connections have been set"));
        }
        return this.subscribeAndWaitForJoinOperation(streamPartId, timeout);
      });
      function subscribeAndWaitForJoin(_x6, _x7) {
        return _subscribeAndWaitForJoin.apply(this, arguments);
      }
      return subscribeAndWaitForJoin;
    }()
  }, {
    key: "waitForJoinAndPublish",
    value: function () {
      var _waitForJoinAndPublish = _asyncToGenerator(function* (streamMessage, timeout) {
        var streamPartId = streamMessage.getStreamPartID();
        if (this.isProxiedStreamPart(streamPartId, _protocol.ProxyDirection.SUBSCRIBE)) {
          throw new Error("Cannot publish to ".concat(streamPartId, " as proxy subscribe connections have been set"));
        }
        var numOfNeighbors = yield this.subscribeAndWaitForJoin(streamPartId, timeout);
        this.onDataReceived(streamMessage);
        return numOfNeighbors;
      });
      function waitForJoinAndPublish(_x8, _x9) {
        return _waitForJoinAndPublish.apply(this, arguments);
      }
      return waitForJoinAndPublish;
    }()
  }, {
    key: "unsubscribe",
    value: function unsubscribe(streamPartId) {
      this.unsubscribeFromStream(streamPartId);
    }
  }, {
    key: "getNeighborsForStreamPart",
    value: function getNeighborsForStreamPart(streamPartId) {
      return this.streamPartManager.isSetUp(streamPartId) ? this.streamPartManager.getNeighborsForStreamPart(streamPartId) : [];
    }
  }, {
    key: "hasStreamPart",
    value: function hasStreamPart(streamPartId) {
      return this.streamPartManager.isSetUp(streamPartId);
    }
  }, {
    key: "hasProxyConnection",
    value: function hasProxyConnection(streamPartId, contactNodeId, direction) {
      if (direction === _protocol.ProxyDirection.PUBLISH) {
        return this.streamPartManager.hasOutOnlyConnection(streamPartId, contactNodeId);
      } else if (direction === _protocol.ProxyDirection.SUBSCRIBE) {
        return this.streamPartManager.hasInOnlyConnection(streamPartId, contactNodeId);
      } else {
        throw new Error("Assertion failed expected ProxyDirection but received ".concat(direction));
      }
    }
  }, {
    key: "getRtt",
    value: function getRtt(nodeId) {
      return this.nodeToNode.getRtts()[nodeId];
    }
  }]);
  return NetworkNode;
}(_Node2.Node);
exports.NetworkNode = NetworkNode;

/***/ }),

/***/ "../network/src/logic/Node.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Node = exports.Event = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.date.to-iso-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/esnext.promise.all-settled.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.immediate.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.finally.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _events = __webpack_require__("../../node_modules/events/events.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _NodeToNode = __webpack_require__("../network/src/protocol/NodeToNode.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _StreamPartManager = __webpack_require__("../network/src/logic/StreamPartManager.ts");
var _DuplicateMessageDetector = __webpack_require__("../network/src/logic/DuplicateMessageDetector.ts");
var _constants = __webpack_require__("../network/src/constants.ts");
var _TrackerManager = __webpack_require__("../network/src/logic/TrackerManager.ts");
var _Propagation = __webpack_require__("../network/src/logic/propagation/Propagation.ts");
var _DisconnectionManager = __webpack_require__("../network/src/logic/DisconnectionManager.ts");
var _ProxyStreamConnectionClient = __webpack_require__("../network/src/logic/proxy/ProxyStreamConnectionClient.ts");
var _ProxyStreamConnectionServer = __webpack_require__("../network/src/logic/proxy/ProxyStreamConnectionServer.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _utils.Logger(module);
var Event = /*#__PURE__*/function (Event) {
  Event["NODE_CONNECTED"] = "streamr:node:node-connected";
  Event["NODE_DISCONNECTED"] = "streamr:node:node-disconnected";
  Event["MESSAGE_RECEIVED"] = "streamr:node:message-received";
  Event["UNSEEN_MESSAGE_RECEIVED"] = "streamr:node:unseen-message-received";
  Event["DUPLICATE_MESSAGE_RECEIVED"] = "streamr:node:duplicate-message-received";
  Event["NODE_SUBSCRIBED"] = "streamr:node:subscribed-successfully";
  Event["NODE_UNSUBSCRIBED"] = "streamr:node:node-unsubscribed";
  Event["ONE_WAY_CONNECTION_CLOSED"] = "stream:node-one-way-connection-closed";
  Event["JOIN_COMPLETED"] = "stream:node-stream-join-operation-completed";
  Event["JOIN_FAILED"] = "stream:node-stream-join-operation-failed";
  return Event;
}({});
exports.Event = Event;
var Node = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Node, _EventEmitter);
  var _super = _createSuper(Node);
  function Node(opts) {
    var _this;
    _classCallCheck(this, Node);
    _this = _super.call(this);
    // id => counter
    _defineProperty(_assertThisInitialized(_this), "extraMetadata", {});
    _this.nodeToNode = opts.protocols.nodeToNode;
    _this.peerInfo = opts.peerInfo;
    _this.nodeConnectTimeout = opts.nodeConnectTimeout || 15000;
    _this.consecutiveDeliveryFailures = {};
    _this.started = new Date().toISOString();
    _this.acceptProxyConnections = opts.acceptProxyConnections;
    _this.metricsContext = opts.metricsContext || new _utils.MetricsContext();
    _this.metrics = {
      publishMessagesPerSecond: new _utils.RateMetric(),
      publishBytesPerSecond: new _utils.RateMetric()
    };
    _this.metricsContext.addMetrics('node', _this.metrics);
    _this.streamPartManager = new _StreamPartManager.StreamPartManager();
    _this.disconnectionManager = new _DisconnectionManager.DisconnectionManager({
      getAllNodes: _this.nodeToNode.getAllConnectionNodeIds,
      hasSharedStreamParts: _this.streamPartManager.isNodePresent.bind(_this.streamPartManager),
      disconnect: _this.nodeToNode.disconnectFromNode.bind(_this.nodeToNode),
      disconnectionDelayInMs: opts.disconnectionWaitTime,
      cleanUpIntervalInMs: 2 * 60 * 1000
    });
    _this.propagation = new _Propagation.Propagation({
      sendToNeighbor: function () {
        var _sendToNeighbor = _asyncToGenerator(function* (neighborId, streamMessage) {
          try {
            yield _this.nodeToNode.sendData(neighborId, streamMessage);
            _this.consecutiveDeliveryFailures[neighborId] = 0;
          } catch (err) {
            var serializedMsgId = streamMessage.getMessageID().serialize();
            logger.warn('Failed to propagate message to neighbor', {
              messageId: serializedMsgId,
              consecutiveFails: _this.consecutiveDeliveryFailures[neighborId] || 0,
              neighbor: neighborId,
              reason: err
            });

            // TODO: this is hack to get around the issue where `StreamStateManager` believes that we are
            //  connected to a neighbor whilst `WebRtcEndpoint` knows that we are not. In this situation, the
            //  Node will continuously attempt to propagate messages to the neighbor but will not actually ever
            //  (re-)attempt a connection unless as a side-effect of something else (e.g. subscribing to another
            //  stream, and the neighbor in question happens to get assigned to us via the other stream.)
            //
            // This hack basically counts consecutive delivery failures, and upon hitting 100 such failures,
            // decides to forcefully disconnect the neighbor.
            //
            // Ideally this hack would not be needed, but alas, it seems like with the current event-system,
            // we don't end up with an up-to-date state in the logic layer. I believe something like the
            // ConnectionManager-model could help us solve the issue for good.
            if (_this.consecutiveDeliveryFailures[neighborId] === undefined) {
              _this.consecutiveDeliveryFailures[neighborId] = 0;
            }
            _this.consecutiveDeliveryFailures[neighborId] += 1;
            if (_this.consecutiveDeliveryFailures[neighborId] >= 100) {
              logger.warn('Disconnect from neighbor (encountered 100 consecutive delivery failures)', {
                neighbor: neighborId
              });
              _this.onNodeDisconnected(neighborId); // force disconnect
              _this.consecutiveDeliveryFailures[neighborId] = 0;
            }
            throw err;
          }
        });
        function sendToNeighbor(_x, _x2) {
          return _sendToNeighbor.apply(this, arguments);
        }
        return sendToNeighbor;
      }(),
      minPropagationTargets: Math.floor(_constants.DEFAULT_MAX_NEIGHBOR_COUNT / 2)
    });
    _this.trackerManager = new _TrackerManager.TrackerManager(opts.protocols.nodeToTracker, opts, _this.streamPartManager, function (includeRtt) {
      return {
        started: _this.started,
        location: _this.peerInfo.location,
        extra: _this.extraMetadata,
        rtts: includeRtt ? _this.nodeToNode.getRtts() : null,
        version: "brubeck-1.0"
      };
    }, {
      subscribeToStreamPartOnNodes: _this.subscribeToStreamPartOnNodes.bind(_assertThisInitialized(_this)),
      unsubscribeFromStreamPartOnNode: _this.unsubscribeFromStreamPartOnNode.bind(_assertThisInitialized(_this)),
      emitJoinCompleted: _this.emitJoinCompleted.bind(_assertThisInitialized(_this)),
      emitJoinFailed: _this.emitJoinFailed.bind(_assertThisInitialized(_this))
    });
    _this.proxyStreamConnectionClient = new _ProxyStreamConnectionClient.ProxyStreamConnectionClient({
      trackerManager: _this.trackerManager,
      streamPartManager: _this.streamPartManager,
      propagation: _this.propagation,
      node: _assertThisInitialized(_this),
      nodeToNode: _this.nodeToNode,
      nodeConnectTimeout: _this.nodeConnectTimeout
    });
    _this.proxyStreamConnectionServer = new _ProxyStreamConnectionServer.ProxyStreamConnectionServer({
      streamPartManager: _this.streamPartManager,
      propagation: _this.propagation,
      node: _assertThisInitialized(_this),
      nodeToNode: _this.nodeToNode,
      acceptProxyConnections: _this.acceptProxyConnections
    });
    _this.nodeToNode.on(_NodeToNode.Event.NODE_CONNECTED, function (nodeId) {
      return _this.emit(Event.NODE_CONNECTED, nodeId);
    });
    _this.nodeToNode.on(_NodeToNode.Event.DATA_RECEIVED, function (broadcastMessage, nodeId) {
      return _this.onDataReceived(broadcastMessage.streamMessage, nodeId);
    });
    _this.nodeToNode.on(_NodeToNode.Event.NODE_DISCONNECTED, function (nodeId) {
      return _this.onNodeDisconnected(nodeId);
    });
    return _this;
  }
  _createClass(Node, [{
    key: "start",
    value: function start() {
      this.trackerManager.start();
    }
  }, {
    key: "subscribeToStreamIfHaveNotYet",
    value: function subscribeToStreamIfHaveNotYet(streamPartId) {
      var sendStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (!this.streamPartManager.isSetUp(streamPartId)) {
        logger.trace('subscribeToStreamIfHaveNotYet', {
          streamPartId: streamPartId
        });
        this.streamPartManager.setUpStreamPart(streamPartId);
        this.trackerManager.onNewStreamPart(streamPartId); // TODO: perhaps we should react based on event from StreamManager?
        if (sendStatus) {
          this.trackerManager.sendStreamPartStatus(streamPartId);
        }
      } else if (this.streamPartManager.isSetUp(streamPartId) && this.streamPartManager.isBehindProxy(streamPartId)) {
        logger.trace('Failed to join stream as stream is set to be behind proxy', {
          streamPartId: streamPartId
        });
      }
    }
  }, {
    key: "unsubscribeFromStream",
    value: function unsubscribeFromStream(streamPartId) {
      var sendStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      logger.trace('unsubscribeFromStream', {
        streamPartId: streamPartId
      });
      this.streamPartManager.removeStreamPart(streamPartId);
      this.trackerManager.onUnsubscribeFromStreamPart(streamPartId);
      if (sendStatus) {
        this.trackerManager.sendStreamPartStatus(streamPartId);
      }
    }
  }, {
    key: "subscribeToStreamPartOnNodes",
    value: function subscribeToStreamPartOnNodes(nodeIds, streamPartId, trackerId, reattempt) {
      var _this2 = this;
      var subscribePromises = nodeIds.map( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (nodeId) {
          yield (0, _utils.withTimeout)(_this2.nodeToNode.connectToNode(nodeId, trackerId, !reattempt), _this2.nodeConnectTimeout);
          _this2.disconnectionManager.cancelScheduledDisconnection(nodeId);
          _this2.subscribeToStreamPartOnNode(nodeId, streamPartId, false);
          return nodeId;
        });
        return function (_x3) {
          return _ref.apply(this, arguments);
        };
      }());
      return Promise.allSettled(subscribePromises);
    }
  }, {
    key: "doSetProxies",
    value: function () {
      var _doSetProxies = _asyncToGenerator(function* (streamPartId, contactNodeIds, direction, getUserId, connectionCount) {
        yield this.proxyStreamConnectionClient.setProxies(streamPartId, contactNodeIds, direction, getUserId, connectionCount);
      });
      function doSetProxies(_x4, _x5, _x6, _x7, _x8) {
        return _doSetProxies.apply(this, arguments);
      }
      return doSetProxies;
    }() // Null source is used when a message is published by the node itself
  }, {
    key: "onDataReceived",
    value: function onDataReceived(streamMessage) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var streamPartId = streamMessage.getStreamPartID();
      if (!this.streamPartManager.isSetUp(streamPartId)) {
        return;
        // Check if the stream is set as one-directional and has inbound connection if message is content typed
      } else if (source && this.streamPartManager.isSetUp(streamPartId) && this.streamPartManager.isBehindProxy(streamPartId) && streamMessage.messageType === _protocol.StreamMessageType.MESSAGE && !this.streamPartManager.hasInboundConnection(streamPartId, source)) {
        logger.warn('Received unexpected message on outbound proxy stream', {
          source: source,
          streamPartId: streamPartId
        });
        return;
      }
      this.emit(Event.MESSAGE_RECEIVED, streamMessage, source);

      // Check duplicate
      var isUnseen;
      try {
        isUnseen = this.streamPartManager.markNumbersAndCheckThatIsNotDuplicate(streamMessage.messageId, streamMessage.prevMsgRef);
      } catch (err) {
        if (err instanceof _DuplicateMessageDetector.InvalidNumberingError) {
          logger.trace('Received message with invalid numbering', {
            source: source,
            messageId: streamMessage.messageId
          });
          return;
        }
        if (err instanceof _DuplicateMessageDetector.GapMisMatchError) {
          logger.warn('Received data with gap mismatch', {
            source: source,
            messageId: streamMessage.messageId,
            err: err
          });
          return;
        }
        throw err;
      }
      if (isUnseen) {
        logger.trace('Received message', {
          source: source,
          messageId: streamMessage.messageId
        });
        var propagationTargets = this.getPropagationTargets(streamMessage);
        this.emit(Event.UNSEEN_MESSAGE_RECEIVED, streamMessage, source);
        this.propagation.feedUnseenMessage(streamMessage, propagationTargets, source);
        if (source === null) {
          this.metrics.publishMessagesPerSecond.record(1);
          this.metrics.publishBytesPerSecond.record(streamMessage.getSerializedContent().length);
        }
      } else {
        logger.trace('Ignored duplicate message', {
          source: source,
          messageId: streamMessage.messageId
        });
        this.emit(Event.DUPLICATE_MESSAGE_RECEIVED, streamMessage, source);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.proxyStreamConnectionClient.stop();
      this.proxyStreamConnectionServer.stop();
      this.disconnectionManager.stop();
      this.nodeToNode.stop();
      return this.trackerManager.stop();
    }
  }, {
    key: "getPropagationTargets",
    value: function getPropagationTargets(streamMessage) {
      var streamPartId = streamMessage.getStreamPartID();
      var propagationTargets = [];
      propagationTargets = propagationTargets.concat(_toConsumableArray(this.streamPartManager.getOutboundNodesForStreamPart(streamPartId)));
      if (this.acceptProxyConnections) {
        if (_protocol.GroupKeyRequest.is(streamMessage) || _protocol.GroupKeyResponse.is(streamMessage)) {
          var _ref2 = _protocol.GroupKeyRequest.fromStreamMessage(streamMessage),
            recipient = _ref2.recipient;
          propagationTargets = propagationTargets.concat(this.proxyStreamConnectionServer.getNodeIdsForUserId(streamPartId, recipient));
        }
      } else if (this.streamPartManager.isBehindProxy(streamMessage.getStreamPartID()) && this.proxyStreamConnectionClient.isProxiedStreamPart(streamMessage.getStreamPartID(), _protocol.ProxyDirection.SUBSCRIBE)) {
        propagationTargets = propagationTargets.concat(_toConsumableArray(this.streamPartManager.getInboundNodesForStreamPart(streamPartId)));
      }
      return propagationTargets;
    }
  }, {
    key: "subscribeToStreamPartOnNode",
    value: function subscribeToStreamPartOnNode(node, streamPartId) {
      var sendStatus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.streamPartManager.addNeighbor(streamPartId, node);
      this.propagation.onNeighborJoined(node, streamPartId);
      if (sendStatus) {
        this.trackerManager.sendStreamPartStatus(streamPartId);
      }
      this.emit(Event.NODE_SUBSCRIBED, node, streamPartId);
      return node;
    }
  }, {
    key: "unsubscribeFromStreamPartOnNode",
    value: function unsubscribeFromStreamPartOnNode(node, streamPartId) {
      var sendStatus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.streamPartManager.removeNodeFromStreamPart(streamPartId, node);
      logger.trace('unsubscribeFromStreamPartOnNode', {
        node: node,
        streamPartId: streamPartId
      });
      this.emit(Event.NODE_UNSUBSCRIBED, node, streamPartId);
      this.disconnectionManager.scheduleDisconnectionIfNoSharedStreamParts(node);
      if (sendStatus) {
        this.trackerManager.sendStreamPartStatus(streamPartId);
      }
    }
  }, {
    key: "onNodeDisconnected",
    value: function onNodeDisconnected(node) {
      var _this3 = this;
      var _this$streamPartManag = this.streamPartManager.removeNodeFromAllStreamParts(node),
        _this$streamPartManag2 = _slicedToArray(_this$streamPartManag, 2),
        streams = _this$streamPartManag2[0],
        proxiedStreams = _this$streamPartManag2[1];
      logger.trace('Remove all subscriptions of node', {
        node: node
      });
      streams.forEach(function (s) {
        _this3.trackerManager.sendStreamPartStatus(s);
      });
      proxiedStreams.forEach(function (s) {
        setImmediate( /*#__PURE__*/_asyncToGenerator(function* () {
          return _this3.proxyStreamConnectionClient.onNodeDisconnected(s, node);
        }));
      });
      this.emit(Event.NODE_DISCONNECTED, node);
    }
  }, {
    key: "getStreamParts",
    value: function getStreamParts() {
      return this.streamPartManager.getStreamParts();
    }
  }, {
    key: "getNeighbors",
    value: function getNeighbors() {
      return this.streamPartManager.getAllNodes();
    }
  }, {
    key: "getNodeId",
    value: function getNodeId() {
      return this.peerInfo.peerId;
    }
  }, {
    key: "getMetricsContext",
    value: function getMetricsContext() {
      return this.metricsContext;
    }
  }, {
    key: "getDiagnosticInfo",
    value: function getDiagnosticInfo() {
      return {
        nodeId: this.getNodeId(),
        started: this.started,
        nodeToNode: this.nodeToNode.getDiagnosticInfo(),
        trackers: this.trackerManager.getDiagnosticInfo(),
        node: {
          streamParts: _toConsumableArray(this.getStreamParts()),
          neighbors: this.getNeighbors(),
          assignments: this.streamPartManager.getDiagnosticInfo(),
          activePropagationTasks: this.propagation.numOfActivePropagationTasks()
        }
      };
    }
  }, {
    key: "subscribeAndWaitForJoinOperation",
    value: function () {
      var _subscribeAndWaitForJoinOperation = _asyncToGenerator(function* (streamPartId) {
        var _this4 = this;
        var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.nodeConnectTimeout;
        if (this.streamPartManager.isSetUp(streamPartId)) {
          return this.streamPartManager.getAllNodesForStreamPart(streamPartId).length;
        }
        var resolveHandler;
        var rejectHandler;
        var res = yield Promise.all([(0, _utils.withTimeout)(new Promise(function (resolve, reject) {
          resolveHandler = function resolveHandler(stream, numOfNeighbors) {
            if (stream === streamPartId) {
              resolve(numOfNeighbors);
            }
          };
          rejectHandler = function rejectHandler(stream, error) {
            if (stream === streamPartId) {
              reject(new Error(error));
            }
          };
          _this4.on(Event.JOIN_COMPLETED, resolveHandler);
          _this4.on(Event.JOIN_FAILED, rejectHandler);
        }), timeout), this.subscribeToStreamIfHaveNotYet(streamPartId)]).finally(function () {
          _this4.off(Event.JOIN_COMPLETED, resolveHandler);
          _this4.off(Event.JOIN_FAILED, rejectHandler);
        });
        return res[0];
      });
      function subscribeAndWaitForJoinOperation(_x9) {
        return _subscribeAndWaitForJoinOperation.apply(this, arguments);
      }
      return subscribeAndWaitForJoinOperation;
    }()
  }, {
    key: "emitJoinCompleted",
    value: function emitJoinCompleted(streamPartId, numOfNeighbors) {
      this.emit(Event.JOIN_COMPLETED, streamPartId, numOfNeighbors);
    }
  }, {
    key: "emitJoinFailed",
    value: function emitJoinFailed(streamPartId, error) {
      this.emit(Event.JOIN_FAILED, streamPartId, error);
    }
  }, {
    key: "isProxiedStreamPart",
    value: function isProxiedStreamPart(streamPartId, direction) {
      return this.streamPartManager.isBehindProxy(streamPartId) && this.proxyStreamConnectionClient.isProxiedStreamPart(streamPartId, direction);
    }
  }]);
  return Node;
}(_events.EventEmitter);
exports.Node = Node;

/***/ }),

/***/ "../network/src/logic/RtcSignaller.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.RtcSignaller = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _NodeToTracker = __webpack_require__("../network/src/protocol/NodeToTracker.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _utils.Logger(module);
var RtcSignaller = /*#__PURE__*/function () {
  function RtcSignaller(peerInfo, nodeToTracker) {
    var _this = this;
    _classCallCheck(this, RtcSignaller);
    this.peerInfo = peerInfo;
    this.nodeToTracker = nodeToTracker;
    this.offerListener = null;
    this.answerListener = null;
    this.iceCandidateListener = null;
    this.connectListener = null;
    this.errorListener = null;
    nodeToTracker.on(_NodeToTracker.Event.RELAY_MESSAGE_RECEIVED, function (relayMessage, source) {
      var originator = relayMessage.originator,
        targetNode = relayMessage.targetNode,
        subType = relayMessage.subType;
      if (relayMessage.isRtcOfferMessage()) {
        _this.offerListener({
          routerId: source,
          originatorInfo: originator,
          connectionId: relayMessage.data.connectionId,
          description: relayMessage.data.description
        });
      } else if (relayMessage.isRtcAnswerMessage()) {
        _this.answerListener({
          routerId: source,
          originatorInfo: originator,
          connectionId: relayMessage.data.connectionId,
          description: relayMessage.data.description
        });
      } else if (relayMessage.isIceCandidateMessage()) {
        _this.iceCandidateListener({
          routerId: source,
          originatorInfo: originator,
          connectionId: relayMessage.data.connectionId,
          candidate: relayMessage.data.candidate,
          mid: relayMessage.data.mid
        });
      } else if (relayMessage.isRtcConnectMessage()) {
        _this.connectListener({
          routerId: source,
          targetNode: targetNode,
          originatorInfo: originator
        });
      } else {
        logger.warn('Encountered unrecognized subtype', {
          subType: subType,
          content: relayMessage
        });
      }
    });
    nodeToTracker.on(_NodeToTracker.Event.RTC_ERROR_RECEIVED, function (message, source) {
      _this.errorListener({
        routerId: source,
        targetNode: message.targetNode,
        errorCode: message.errorCode
      });
    });
  }
  _createClass(RtcSignaller, [{
    key: "sendRtcOffer",
    value: function sendRtcOffer(routerId, targetPeerId, connectionId, description) {
      this.nodeToTracker.sendRtcOffer(routerId, targetPeerId, connectionId, this.peerInfo, description).catch(function (err) {
        logger.debug('Failed to sendRtcOffer', {
          routerId: routerId,
          err: err
        }); // TODO: better?
      });
    }
  }, {
    key: "sendRtcAnswer",
    value: function sendRtcAnswer(routerId, targetPeerId, connectionId, description) {
      this.nodeToTracker.sendRtcAnswer(routerId, targetPeerId, connectionId, this.peerInfo, description).catch(function (err) {
        logger.debug('Failed to sendRtcAnswer', {
          routerId: routerId,
          err: err
        }); // TODO: better?
      });
    }
  }, {
    key: "sendRtcIceCandidate",
    value: function sendRtcIceCandidate(routerId, targetPeerId, connectionId, candidate, mid) {
      this.nodeToTracker.sendRtcIceCandidate(routerId, targetPeerId, connectionId, this.peerInfo, candidate, mid).catch(function (err) {
        logger.debug('Failed to sendRtcIceCandidate', {
          routerId: routerId,
          err: err
        }); // TODO: better?
      });
    }
  }, {
    key: "sendRtcConnect",
    value: function sendRtcConnect(routerId, targetPeerId) {
      this.nodeToTracker.sendRtcConnect(routerId, targetPeerId, this.peerInfo).catch(function (err) {
        logger.debug('Failed to sendRtcConnect', {
          routerId: routerId,
          err: err
        }); // TODO: better?
      });
    }
  }, {
    key: "setOfferListener",
    value: function setOfferListener(fn) {
      this.offerListener = fn;
    }
  }, {
    key: "setAnswerListener",
    value: function setAnswerListener(fn) {
      this.answerListener = fn;
    }
  }, {
    key: "setIceCandidateListener",
    value: function setIceCandidateListener(fn) {
      this.iceCandidateListener = fn;
    }
  }, {
    key: "setErrorListener",
    value: function setErrorListener(fn) {
      this.errorListener = fn;
    }
  }, {
    key: "setConnectListener",
    value: function setConnectListener(fn) {
      this.connectListener = fn;
    }
  }]);
  return RtcSignaller;
}();
exports.RtcSignaller = RtcSignaller;

/***/ }),

/***/ "../network/src/logic/StreamPartManager.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamPartManager = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.some.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _DuplicateMessageDetector = __webpack_require__("../network/src/logic/DuplicateMessageDetector.ts");
var _constants = __webpack_require__("../network/src/constants.ts");
var _uniq = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/uniq.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function keyForDetector(_ref) {
  var publisherId = _ref.publisherId,
    msgChainId = _ref.msgChainId;
  return "".concat(publisherId, "-").concat(msgChainId);
}
var StreamPartManager = /*#__PURE__*/function () {
  function StreamPartManager() {
    _classCallCheck(this, StreamPartManager);
    _defineProperty(this, "streamParts", new Map());
  }
  _createClass(StreamPartManager, [{
    key: "setUpStreamPart",
    value: function setUpStreamPart(streamPartId) {
      var isBehindProxy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.isSetUp(streamPartId)) {
        throw new Error("Stream part ".concat(streamPartId, " already set up"));
      }
      this.streamParts.set(streamPartId, {
        detectors: new Map(),
        neighbors: new Set(),
        counter: 0,
        inOnly: new Set(),
        outOnly: new Set(),
        isBehindProxy: isBehindProxy
      });
    }
  }, {
    key: "markNumbersAndCheckThatIsNotDuplicate",
    value: function markNumbersAndCheckThatIsNotDuplicate(messageId, previousMessageReference) {
      var streamPartId = messageId.getStreamPartID();
      this.ensureThatIsSetUp(streamPartId);
      var detectorKey = keyForDetector(messageId);
      var _ref2 = this.streamParts.get(streamPartId),
        detectors = _ref2.detectors;
      if (!detectors.has(detectorKey)) {
        detectors.set(detectorKey, new _DuplicateMessageDetector.DuplicateMessageDetector());
      }
      return detectors.get(detectorKey).markAndCheck(previousMessageReference === null ? null : new _DuplicateMessageDetector.NumberPair(previousMessageReference.timestamp, previousMessageReference.sequenceNumber), new _DuplicateMessageDetector.NumberPair(messageId.timestamp, messageId.sequenceNumber));
    }
  }, {
    key: "updateCounter",
    value: function updateCounter(streamPartId, counter) {
      this.streamParts.get(streamPartId).counter = counter;
    }
  }, {
    key: "isNewStream",
    value: function isNewStream(streamPartId) {
      this.ensureThatIsSetUp(streamPartId);
      return this.streamParts.get(streamPartId).counter === 0;
    }
  }, {
    key: "addNeighbor",
    value: function addNeighbor(streamPartId, node) {
      this.ensureThatIsSetUp(streamPartId);
      var _ref3 = this.streamParts.get(streamPartId),
        neighbors = _ref3.neighbors;
      neighbors.add(node);
    }
  }, {
    key: "addInOnlyNeighbor",
    value: function addInOnlyNeighbor(streamPartId, node) {
      this.ensureThatIsSetUp(streamPartId);
      var _ref4 = this.streamParts.get(streamPartId),
        inOnly = _ref4.inOnly;
      inOnly.add(node);
    }
  }, {
    key: "addOutOnlyNeighbor",
    value: function addOutOnlyNeighbor(streamPartId, node) {
      this.ensureThatIsSetUp(streamPartId);
      var _ref5 = this.streamParts.get(streamPartId),
        outOnly = _ref5.outOnly;
      outOnly.add(node);
    }
  }, {
    key: "removeNodeFromStreamPart",
    value: function removeNodeFromStreamPart(streamPartId, node) {
      this.ensureThatIsSetUp(streamPartId);
      var _ref6 = this.streamParts.get(streamPartId),
        neighbors = _ref6.neighbors,
        inOnly = _ref6.inOnly,
        outOnly = _ref6.outOnly;
      neighbors.delete(node);
      inOnly.delete(node);
      outOnly.delete(node);
    }
  }, {
    key: "getStreamPartStatus",
    value: function getStreamPartStatus(streamPartId) {
      var state = this.streamParts.get(streamPartId);
      var _StreamPartIDUtils$ge = _protocol.StreamPartIDUtils.getStreamIDAndPartition(streamPartId),
        _StreamPartIDUtils$ge2 = _slicedToArray(_StreamPartIDUtils$ge, 2),
        id = _StreamPartIDUtils$ge2[0],
        partition = _StreamPartIDUtils$ge2[1];
      if (state !== undefined) {
        return {
          id: id,
          partition: partition,
          neighbors: _toConsumableArray(state.neighbors),
          counter: state.counter
        };
      } else {
        return {
          id: id,
          partition: partition,
          neighbors: [],
          counter: _constants.COUNTER_UNSUBSCRIBE
        };
      }
    }
  }, {
    key: "removeNodeFromAllStreamParts",
    value: function removeNodeFromAllStreamParts(node) {
      var _this = this;
      var streamParts = [];
      var notRemovedProxies = [];
      this.streamParts.forEach(function (_ref7, streamPartId) {
        var neighbors = _ref7.neighbors,
          inOnly = _ref7.inOnly,
          outOnly = _ref7.outOnly;
        var isRemoved = neighbors.delete(node);
        if (isRemoved) {
          streamParts.push(streamPartId);
        }
        if (_this.isBehindProxy(streamPartId)) {
          notRemovedProxies.push(streamPartId);
        } else {
          inOnly.delete(node);
          outOnly.delete(node);
        }
      });
      return [streamParts, notRemovedProxies];
    }
  }, {
    key: "removeStreamPart",
    value: function removeStreamPart(streamPartId) {
      this.ensureThatIsSetUp(streamPartId);
      this.streamParts.delete(streamPartId);
    }
  }, {
    key: "isSetUp",
    value: function isSetUp(streamPartId) {
      return this.streamParts.has(streamPartId);
    }
  }, {
    key: "isNodePresent",
    value: function isNodePresent(node) {
      return _toConsumableArray(this.streamParts.values()).some(function (_ref8) {
        var neighbors = _ref8.neighbors,
          inOnly = _ref8.inOnly,
          outOnly = _ref8.outOnly;
        return neighbors.has(node) || inOnly.has(node) || outOnly.has(node);
      });
    }
  }, {
    key: "getStreamParts",
    value: function getStreamParts() {
      return this.streamParts.keys();
    }
  }, {
    key: "getNeighborsForStreamPart",
    value: function getNeighborsForStreamPart(streamPartId) {
      this.ensureThatIsSetUp(streamPartId);
      return _toConsumableArray(this.streamParts.get(streamPartId).neighbors);
    }
  }, {
    key: "getOutboundNodesForStreamPart",
    value: function getOutboundNodesForStreamPart(streamPartId) {
      this.ensureThatIsSetUp(streamPartId);
      var _ref9 = this.streamParts.get(streamPartId),
        neighbors = _ref9.neighbors,
        outOnly = _ref9.outOnly;
      return [].concat(_toConsumableArray(neighbors), _toConsumableArray(outOnly));
    }
  }, {
    key: "getInboundNodesForStreamPart",
    value: function getInboundNodesForStreamPart(streamPartId) {
      this.ensureThatIsSetUp(streamPartId);
      var _ref10 = this.streamParts.get(streamPartId),
        neighbors = _ref10.neighbors,
        inOnly = _ref10.inOnly;
      return [].concat(_toConsumableArray(neighbors), _toConsumableArray(inOnly));
    }
  }, {
    key: "getAllNodesForStreamPart",
    value: function getAllNodesForStreamPart(streamPartId) {
      this.ensureThatIsSetUp(streamPartId);
      var _ref11 = this.streamParts.get(streamPartId),
        neighbors = _ref11.neighbors,
        inOnly = _ref11.inOnly,
        outOnly = _ref11.outOnly;
      return [].concat(_toConsumableArray(neighbors), _toConsumableArray(inOnly), _toConsumableArray(outOnly));
    }
  }, {
    key: "getAllNodes",
    value: function getAllNodes() {
      var nodes = [];
      this.streamParts.forEach(function (_ref12) {
        var neighbors = _ref12.neighbors;
        nodes.push.apply(nodes, _toConsumableArray(neighbors));
      });
      return (0, _uniq.default)(nodes);
    }
  }, {
    key: "hasNeighbor",
    value: function hasNeighbor(streamPartId, node) {
      this.ensureThatIsSetUp(streamPartId);
      return this.streamParts.get(streamPartId).neighbors.has(node);
    }
  }, {
    key: "hasOutOnlyConnection",
    value: function hasOutOnlyConnection(streamPartId, node) {
      this.ensureThatIsSetUp(streamPartId);
      return this.streamParts.get(streamPartId).outOnly.has(node);
    }
  }, {
    key: "hasInOnlyConnection",
    value: function hasInOnlyConnection(streamPartId, node) {
      this.ensureThatIsSetUp(streamPartId);
      return this.streamParts.get(streamPartId).inOnly.has(node);
    }
  }, {
    key: "hasOnewayConnection",
    value: function hasOnewayConnection(streamPartId, node) {
      this.ensureThatIsSetUp(streamPartId);
      return this.streamParts.get(streamPartId).outOnly.has(node) || this.streamParts.get(streamPartId).inOnly.has(node);
    }
  }, {
    key: "hasInboundConnection",
    value: function hasInboundConnection(streamPartId, node) {
      return this.hasInOnlyConnection(streamPartId, node) || this.hasNeighbor(streamPartId, node);
    }
  }, {
    key: "isBehindProxy",
    value: function isBehindProxy(streamPartId) {
      return this.isSetUp(streamPartId) && this.streamParts.get(streamPartId).isBehindProxy;
    }
  }, {
    key: "getDiagnosticInfo",
    value: function getDiagnosticInfo() {
      var state = {};
      var _iterator = _createForOfIteratorHelper(this.getStreamParts()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var streamPartId = _step.value;
          state[streamPartId] = this.getNeighborsForStreamPart(streamPartId);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return state;
    }
  }, {
    key: "ensureThatIsSetUp",
    value: function ensureThatIsSetUp(streamPartId) {
      if (!this.isSetUp(streamPartId)) {
        throw new Error("Stream part ".concat(streamPartId, " is not set up"));
      }
    }
  }]);
  return StreamPartManager;
}();
exports.StreamPartManager = StreamPartManager;

/***/ }),

/***/ "../network/src/logic/TrackerConnector.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TrackerConnector = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _PeerInfo = __webpack_require__("../network/src/connection/PeerInfo.ts");
var _NameDirectory = __webpack_require__("../network/src/NameDirectory.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _utils.Logger(module);
var ConnectionState = /*#__PURE__*/function (ConnectionState) {
  ConnectionState[ConnectionState["SUCCESS"] = 0] = "SUCCESS";
  ConnectionState[ConnectionState["ERROR"] = 1] = "ERROR";
  return ConnectionState;
}(ConnectionState || {});
var TrackerConnector = /*#__PURE__*/function () {
  function TrackerConnector(getStreamParts, connectToTracker, disconnectFromTracker, trackerRegistry, maintenanceInterval) {
    _classCallCheck(this, TrackerConnector);
    this.getStreamParts = getStreamParts;
    this.connectToTracker = connectToTracker;
    this.disconnectFromTracker = disconnectFromTracker;
    this.trackerRegistry = trackerRegistry;
    this.maintenanceInterval = maintenanceInterval;
    this.connectionStates = new Map();
    this.signallingOnlySessions = new Map();
  }
  _createClass(TrackerConnector, [{
    key: "onNewStreamPart",
    value: function onNewStreamPart(streamPartId) {
      var trackerInfo = this.trackerRegistry.getTracker(streamPartId);
      this.connectTo(trackerInfo);
    }
  }, {
    key: "addSignallingOnlySession",
    value: function () {
      var _addSignallingOnlySession = _asyncToGenerator(function* (streamPartId, nodeToSignal) {
        var tracker = this.trackerRegistry.getTracker(streamPartId);
        if (!this.signallingOnlySessions.has(streamPartId)) {
          this.signallingOnlySessions.set(streamPartId, new Set());
        }
        this.signallingOnlySessions.get(streamPartId).add(nodeToSignal);
        yield this.connectToTracker(tracker.ws, _PeerInfo.PeerInfo.newTracker(tracker.id));
        logger.info('Connected to tracker for signalling only', {
          trackerId: _NameDirectory.NameDirectory.getName(tracker.id)
        });
      });
      function addSignallingOnlySession(_x, _x2) {
        return _addSignallingOnlySession.apply(this, arguments);
      }
      return addSignallingOnlySession;
    }()
  }, {
    key: "removeSignallingOnlySession",
    value: function removeSignallingOnlySession(streamPartId, nodeToSignal) {
      if (this.signallingOnlySessions.has(streamPartId)) {
        var session = this.signallingOnlySessions.get(streamPartId);
        session.delete(nodeToSignal);
        if (session.size === 0) {
          this.signallingOnlySessions.delete(streamPartId);
        }
      }
    }
  }, {
    key: "start",
    value: function start() {
      this.maintainConnections();
      this.maintenanceTimer = setInterval(this.maintainConnections.bind(this), this.maintenanceInterval);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.maintenanceTimer) {
        clearInterval(this.maintenanceTimer);
        this.maintenanceTimer = null;
      }
    }
  }, {
    key: "maintainConnections",
    value: function maintainConnections() {
      var _this = this;
      this.trackerRegistry.getAllTrackers().forEach(function (trackerInfo) {
        if (_this.isActiveTracker(trackerInfo.id)) {
          _this.connectTo(trackerInfo);
        } else {
          _this.disconnectFromTracker(trackerInfo.id);
        }
      });
    }
  }, {
    key: "connectTo",
    value: function connectTo(_ref) {
      var _this2 = this;
      var id = _ref.id,
        ws = _ref.ws;
      this.connectToTracker(ws, _PeerInfo.PeerInfo.newTracker(id)).then(function () {
        if (_this2.connectionStates.get(id) !== ConnectionState.SUCCESS) {
          logger.info('Connected to tracker', {
            trackerId: _NameDirectory.NameDirectory.getName(id)
          });
          _this2.connectionStates.set(id, ConnectionState.SUCCESS);
        }
        return;
      }).catch(function (err) {
        if (_this2.connectionStates.get(id) !== ConnectionState.ERROR) {
          // TODO we could also store the previous error and check that the current error is the same?
          // -> now it doesn't log anything if the connection error reason changes
          _this2.connectionStates.set(id, ConnectionState.ERROR);
          logger.warn('Could not connect to tracker', {
            trackerId: _NameDirectory.NameDirectory.getName(id),
            reason: err.message
          });
        }
      });
    }
  }, {
    key: "isActiveTracker",
    value: function isActiveTracker(trackerId) {
      var streamPartIds = [].concat(_toConsumableArray(this.getStreamParts()), _toConsumableArray(this.signallingOnlySessions.keys()));
      var _iterator = _createForOfIteratorHelper(streamPartIds),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var streamPartId = _step.value;
          if (this.trackerRegistry.getTracker(streamPartId).id === trackerId) {
            return true;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return false;
    }
  }]);
  return TrackerConnector;
}();
exports.TrackerConnector = TrackerConnector;

/***/ }),

/***/ "../network/src/logic/TrackerManager.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TrackerManager = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _TrackerConnector = __webpack_require__("../network/src/logic/TrackerConnector.ts");
var _NodeToTracker = __webpack_require__("../network/src/protocol/NodeToTracker.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _InstructionThrottler = __webpack_require__("../network/src/logic/InstructionThrottler.ts");
var _InstructionRetryManager = __webpack_require__("../network/src/logic/InstructionRetryManager.ts");
var _NameDirectory = __webpack_require__("../network/src/NameDirectory.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _utils.Logger(module);
var TrackerManager = /*#__PURE__*/function () {
  function TrackerManager(nodeToTracker, opts, streamPartManager, getNodeDescriptor, subscriber) {
    var _this = this;
    _classCallCheck(this, TrackerManager);
    _defineProperty(this, "rttUpdateTimeoutsOnTrackers", {});
    this.nodeToTracker = nodeToTracker;
    this.streamPartManager = streamPartManager;
    this.trackerRegistry = (0, _protocol.createTrackerRegistry)(opts.trackers);
    this.getNodeDescriptor = getNodeDescriptor;
    this.subscriber = subscriber;
    this.rttUpdateInterval = opts.rttUpdateTimeout;
    this.trackerConnector = new _TrackerConnector.TrackerConnector(streamPartManager.getStreamParts.bind(streamPartManager), this.nodeToTracker.connectToTracker.bind(this.nodeToTracker), this.nodeToTracker.disconnectFromTracker.bind(this.nodeToTracker), this.trackerRegistry, opts.trackerConnectionMaintenanceInterval);
    this.instructionThrottler = new _InstructionThrottler.InstructionThrottler(this.handleTrackerInstruction.bind(this));
    this.instructionRetryManager = new _InstructionRetryManager.InstructionRetryManager(this.handleTrackerInstruction.bind(this), opts.instructionRetryInterval || 3 * 60 * 1000);
    this.nodeToTracker.on(_NodeToTracker.Event.CONNECTED_TO_TRACKER, function (trackerId) {
      logger.trace('Connected to tracker', {
        trackerId: trackerId
      });
      _this.getStreamPartsForTracker(trackerId).forEach(function (streamPart) {
        _this.sendStatus(streamPart, trackerId);
      });
    });
    this.nodeToTracker.on(_NodeToTracker.Event.STATUS_ACK_RECEIVED, function (statusAckMessage) {
      var streamPartId = statusAckMessage.getStreamPartID();
      if (_this.streamPartManager.isSetUp(streamPartId) && _this.streamPartManager.isNewStream(streamPartId)) {
        _this.subscriber.emitJoinCompleted(streamPartId, 0);
      }
    });
    this.nodeToTracker.on(_NodeToTracker.Event.TRACKER_INSTRUCTION_RECEIVED, function (instructionMessage, trackerId) {
      _this.instructionThrottler.add(instructionMessage, trackerId);
    });
    this.nodeToTracker.on(_NodeToTracker.Event.TRACKER_DISCONNECTED, function (trackerId) {
      logger.trace('Disconnected from tracker', {
        trackerId: trackerId
      });
    });
  }
  _createClass(TrackerManager, [{
    key: "sendStreamPartStatus",
    value: function sendStreamPartStatus(streamPartId) {
      var trackerId = this.getTrackerId(streamPartId);
      this.sendStatus(streamPartId, trackerId);
    }
  }, {
    key: "onNewStreamPart",
    value: function onNewStreamPart(streamPartId) {
      this.trackerConnector.onNewStreamPart(streamPartId);
    }
  }, {
    key: "addSignallingOnlySession",
    value: function () {
      var _addSignallingOnlySession = _asyncToGenerator(function* (streamPartId, nodeToSignal) {
        yield this.trackerConnector.addSignallingOnlySession(streamPartId, nodeToSignal);
      });
      function addSignallingOnlySession(_x, _x2) {
        return _addSignallingOnlySession.apply(this, arguments);
      }
      return addSignallingOnlySession;
    }()
  }, {
    key: "removeSignallingOnlySession",
    value: function removeSignallingOnlySession(streamPartId, nodeToSignal) {
      this.trackerConnector.removeSignallingOnlySession(streamPartId, nodeToSignal);
    }
  }, {
    key: "onUnsubscribeFromStreamPart",
    value: function onUnsubscribeFromStreamPart(streamPartId) {
      this.instructionThrottler.removeStreamPart(streamPartId);
      this.instructionRetryManager.removeStreamPart(streamPartId);
    }
  }, {
    key: "start",
    value: function start() {
      this.trackerConnector.start();
    }
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(function* () {
        this.instructionThrottler.stop();
        this.instructionRetryManager.stop();
        this.trackerConnector.stop();
        Object.values(this.rttUpdateTimeoutsOnTrackers).forEach(function (timeout) {
          return clearTimeout(timeout);
        });
        yield this.nodeToTracker.stop();
      });
      function stop() {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }, {
    key: "getStreamPartsForTracker",
    value: function getStreamPartsForTracker(trackerId) {
      var _this2 = this;
      return _toConsumableArray(this.streamPartManager.getStreamParts()).filter(function (streamPartId) {
        return _this2.getTrackerId(streamPartId) === trackerId;
      });
    }
  }, {
    key: "shouldIncludeRttInfo",
    value: function shouldIncludeRttInfo(trackerId) {
      var _this3 = this;
      if (!(trackerId in this.rttUpdateTimeoutsOnTrackers)) {
        this.rttUpdateTimeoutsOnTrackers[trackerId] = setTimeout(function () {
          logger.trace('Triggered RTT update timeout to tracker', {
            trackerId: trackerId
          });
          delete _this3.rttUpdateTimeoutsOnTrackers[trackerId];
        }, this.rttUpdateInterval);
        return true;
      }
      return false;
    }
  }, {
    key: "sendStatus",
    value: function () {
      var _sendStatus = _asyncToGenerator(function* (streamPartId, trackerId) {
        if (!this.streamPartManager.isBehindProxy(streamPartId)) {
          var nodeDescriptor = this.getNodeDescriptor(this.shouldIncludeRttInfo(trackerId));
          var status = _objectSpread({
            streamPart: this.streamPartManager.getStreamPartStatus(streamPartId)
          }, nodeDescriptor);
          try {
            yield this.nodeToTracker.sendStatus(trackerId, status);
            logger.trace('Sent status to tracker', {
              streamPartId: status.streamPart,
              trackerId: trackerId
            });
          } catch (err) {
            logger.trace('Failed to send status to tracker', {
              err: err,
              trackerId: trackerId
            });
          }
        }
      });
      function sendStatus(_x3, _x4) {
        return _sendStatus.apply(this, arguments);
      }
      return sendStatus;
    }()
  }, {
    key: "handleTrackerInstruction",
    value: function () {
      var _handleTrackerInstruction = _asyncToGenerator(function* (instructionMessage, trackerId) {
        var _this4 = this;
        var reattempt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var streamPartId = instructionMessage.getStreamPartID();
        if (!this.streamPartManager.isSetUp(streamPartId)) {
          return;
        }
        var nodeIds = instructionMessage.nodeIds,
          counter = instructionMessage.counter;
        this.instructionRetryManager.add(instructionMessage, trackerId);

        // Check that tracker matches expected tracker
        var expectedTrackerId = this.getTrackerId(streamPartId);
        if (trackerId !== expectedTrackerId) {
          logger.warn('Received instructions from unexpected tracker', {
            expectedTrackerId: expectedTrackerId,
            trackerId: trackerId
          });
          return;
        }
        logger.trace('Receive instructions', {
          streamPartId: streamPartId,
          nodeIds: nodeIds
        });
        var currentNodes = this.streamPartManager.getNeighborsForStreamPart(streamPartId);
        var nodesToUnsubscribeFrom = currentNodes.filter(function (nodeId) {
          return !nodeIds.includes(nodeId);
        });
        nodesToUnsubscribeFrom.forEach(function (nodeId) {
          _this4.subscriber.unsubscribeFromStreamPartOnNode(nodeId, streamPartId, false);
        });
        var results = yield this.subscriber.subscribeToStreamPartOnNodes(nodeIds, streamPartId, trackerId, reattempt);
        var newStream = false;
        if (this.streamPartManager.isSetUp(streamPartId)) {
          newStream = this.streamPartManager.isNewStream(streamPartId);
          this.streamPartManager.updateCounter(streamPartId, counter);
        }

        // Log success / failures
        var subscribedNodeIds = [];
        var unsubscribedNodeIds = [];
        var failedInstructions = false;
        results.forEach(function (res, i) {
          if (res.status === 'fulfilled') {
            subscribedNodeIds.push(res.value);
          } else {
            failedInstructions = true;
            logger.debug('Failed to subscribe to node', {
              nodeId: _NameDirectory.NameDirectory.getName(nodeIds[i]),
              reason: res.reason
            });
          }
        });
        if (!reattempt || failedInstructions) {
          this.sendStreamPartStatus(streamPartId);
        }
        if (newStream) {
          if (subscribedNodeIds.length === 0) {
            this.subscriber.emitJoinFailed(streamPartId, "Failed initial join operation to stream partition ".concat(streamPartId, ", failed to form connections to all target neighbors"));
          } else {
            this.subscriber.emitJoinCompleted(streamPartId, subscribedNodeIds.length);
          }
        }
        logger.trace('Fulfilled tracker instructions', {
          subscribedNodeIds: subscribedNodeIds,
          unsubscribedNodeIds: unsubscribedNodeIds,
          streamPartId: streamPartId,
          counter: counter,
          fullFilledAll: subscribedNodeIds.length === nodeIds.length
        });
      });
      function handleTrackerInstruction(_x5, _x6) {
        return _handleTrackerInstruction.apply(this, arguments);
      }
      return handleTrackerInstruction;
    }()
  }, {
    key: "getTrackerId",
    value: function getTrackerId(streamPartId) {
      return this.trackerRegistry.getTracker(streamPartId).id;
    }
  }, {
    key: "getTrackerAddress",
    value: function getTrackerAddress(streamPartId) {
      return this.trackerRegistry.getTracker(streamPartId).ws;
    }
  }, {
    key: "getDiagnosticInfo",
    value: function getDiagnosticInfo() {
      return this.nodeToTracker.getDiagnosticInfo();
    }
  }]);
  return TrackerManager;
}();
exports.TrackerManager = TrackerManager;

/***/ }),

/***/ "../network/src/logic/propagation/FifoMapWithTtl.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.FifoMapWithTtl = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _yallist = _interopRequireDefault(__webpack_require__("../network/node_modules/yallist/yallist.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * A "Map" implementation with a maximum size and TTL expiration on entries.
 *
 * When full, room is made for new entries by dropping existing by FIFO method.
 *
 * Entries have a TTL after which they are considered stale. Stale items are
 * not returned when querying.
 *
 */
var FifoMapWithTtl = /*#__PURE__*/function () {
  // queue is used to determine deletion order when full

  function FifoMapWithTtl(_ref) {
    var ttlInMs = _ref.ttlInMs,
      maxSize = _ref.maxSize,
      _ref$onItemDropped = _ref.onItemDropped,
      onItemDropped = _ref$onItemDropped === void 0 ? function () {} : _ref$onItemDropped,
      _ref$timeProvider = _ref.timeProvider,
      timeProvider = _ref$timeProvider === void 0 ? Date.now : _ref$timeProvider;
    _classCallCheck(this, FifoMapWithTtl);
    // class invariant: the keys present in `items` and `dropQueue` are the same set.
    _defineProperty(this, "items", new Map());
    _defineProperty(this, "dropQueue", _yallist.default.create());
    if (ttlInMs < 0) {
      throw new Error("ttlInMs (".concat(ttlInMs, ") cannot be < 0"));
    }
    if (maxSize < 0) {
      throw new Error("maxSize (".concat(maxSize, ") cannot be < 0"));
    }
    this.ttlInMs = ttlInMs;
    this.maxSize = maxSize;
    this.onItemDropped = onItemDropped;
    this.timeProvider = timeProvider;
  }
  _createClass(FifoMapWithTtl, [{
    key: "set",
    value: function set(key, value) {
      if (this.maxSize === 0) {
        return;
      }
      if (this.items.size > this.maxSize) {
        throw new Error('assertion error: maximum size exceeded');
      }

      // delete an existing entry if exists
      this.delete(key);

      // make room for new entry
      if (this.items.size === this.maxSize) {
        var keyToDel = this.dropQueue.shift();
        if (keyToDel === undefined) {
          throw new Error('assertion error: queue empty but still have items');
        }
        this.items.delete(keyToDel);
        this.onItemDropped(keyToDel);
      }

      // add entry
      var dropQueueNode = new _yallist.default.Node(key);
      this.dropQueue.pushNode(dropQueueNode);
      this.items.set(key, {
        value: value,
        dropQueueNode: dropQueueNode,
        expiresAt: this.timeProvider() + this.ttlInMs
      });
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var item = this.items.get(key);
      if (item !== undefined) {
        this.items.delete(key);
        this.dropQueue.removeNode(item.dropQueueNode);
        this.onItemDropped(key);
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var item = this.items.get(key);
      if (item === undefined) {
        return undefined;
      }
      if (item.expiresAt <= this.timeProvider()) {
        this.delete(key);
        return undefined;
      }
      return item.value;
    }
  }, {
    key: "size",
    value: function size() {
      return this.items.size;
    }
  }]);
  return FifoMapWithTtl;
}();
exports.FifoMapWithTtl = FifoMapWithTtl;

/***/ }),

/***/ "../network/src/logic/propagation/Propagation.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Propagation = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _PropagationTaskStore = __webpack_require__("../network/src/logic/propagation/PropagationTaskStore.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DEFAULT_MAX_MESSAGES = 30;
var DEFAULT_TTL = 30 * 1000;

/**
 * Message propagation logic of a node. Given a message, this class will actively attempt to propagate it to
 * `minPropagationTargets` neighbors until success or TTL expiration.
 *
 * Setting `minPropagationTargets = 0` effectively disables any propagation reattempts. A message will then
 * only be propagated exactly once, to neighbors that are present at that moment, in a fire-and-forget manner.
 */
var Propagation = /*#__PURE__*/function () {
  function Propagation(_ref) {
    var sendToNeighbor = _ref.sendToNeighbor,
      minPropagationTargets = _ref.minPropagationTargets,
      _ref$ttl = _ref.ttl,
      ttl = _ref$ttl === void 0 ? DEFAULT_TTL : _ref$ttl,
      _ref$maxMessages = _ref.maxMessages,
      maxMessages = _ref$maxMessages === void 0 ? DEFAULT_MAX_MESSAGES : _ref$maxMessages;
    _classCallCheck(this, Propagation);
    this.sendToNeighbor = sendToNeighbor;
    this.minPropagationTargets = minPropagationTargets;
    this.activeTaskStore = new _PropagationTaskStore.PropagationTaskStore(ttl, maxMessages);
  }

  /**
   * Node should invoke this when it learns about a new message
   */
  _createClass(Propagation, [{
    key: "feedUnseenMessage",
    value: function feedUnseenMessage(message, targets, source) {
      var task = {
        message: message,
        source: source,
        handledNeighbors: new Set()
      };
      this.activeTaskStore.add(task);
      var _iterator = _createForOfIteratorHelper(targets),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var target = _step.value;
          this.sendAndAwaitThenMark(task, target);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    /**
     * Node should invoke this when it learns about a new node stream assignment
     */
  }, {
    key: "onNeighborJoined",
    value: function onNeighborJoined(neighborId, streamPartId) {
      var tasksOfStream = this.activeTaskStore.get(streamPartId);
      var _iterator2 = _createForOfIteratorHelper(tasksOfStream),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var task = _step2.value;
          this.sendAndAwaitThenMark(task, neighborId);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "numOfActivePropagationTasks",
    value: function numOfActivePropagationTasks() {
      return this.activeTaskStore.size();
    }
  }, {
    key: "sendAndAwaitThenMark",
    value: function sendAndAwaitThenMark(_ref2, neighborId) {
      var _this = this;
      var message = _ref2.message,
        source = _ref2.source,
        handledNeighbors = _ref2.handledNeighbors;
      if (!handledNeighbors.has(neighborId) && neighborId !== source) {
        _asyncToGenerator(function* () {
          try {
            yield _this.sendToNeighbor(neighborId, message);
          } catch (_unused) {
            return;
          }
          // Side-note: due to asynchronicity, the task being modified at this point could already be stale and
          // deleted from `activeTaskStore`. However, as modifying it or re-deleting it is pretty much
          // inconsequential at this point, leaving the logic as is.
          handledNeighbors.add(neighborId);
          if (handledNeighbors.size >= _this.minPropagationTargets) {
            _this.activeTaskStore.delete(message.messageId);
          }
        })();
      }
    }
  }]);
  return Propagation;
}();
exports.Propagation = Propagation;

/***/ }),

/***/ "../network/src/logic/propagation/PropagationTaskStore.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PropagationTaskStore = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _FifoMapWithTtl = __webpack_require__("../network/src/logic/propagation/FifoMapWithTtl.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Keeps track of propagation tasks for the needs of message propagation logic.
 *
 * Properties:
 * - Allows fetching propagation tasks by StreamPartID
 * - Upper bound on number of tasks stored, replacement policy if FIFO
 * - Items have a TTL, after which they are considered stale and not returned when querying
**/
var PropagationTaskStore = /*#__PURE__*/function () {
  function PropagationTaskStore(ttlInMs, maxTasks) {
    var _this = this;
    _classCallCheck(this, PropagationTaskStore);
    _defineProperty(this, "streamPartLookup", new Map());
    this.tasks = new _FifoMapWithTtl.FifoMapWithTtl({
      ttlInMs: ttlInMs,
      maxSize: maxTasks,
      onItemDropped: function onItemDropped(messageId) {
        var streamPartId = messageId.getStreamPartID();
        var messageIdsForStream = _this.streamPartLookup.get(streamPartId);
        if (messageIdsForStream !== undefined) {
          messageIdsForStream.delete(messageId);
          if (messageIdsForStream.size === 0) {
            _this.streamPartLookup.delete(streamPartId);
          }
        }
      }
    });
  }
  _createClass(PropagationTaskStore, [{
    key: "add",
    value: function add(task) {
      var messageId = task.message.messageId;
      var streamPartId = messageId.getStreamPartID();
      if (!this.streamPartLookup.has(streamPartId)) {
        this.streamPartLookup.set(streamPartId, new Set());
      }
      this.streamPartLookup.get(streamPartId).add(messageId);
      this.tasks.set(messageId, task);
    }
  }, {
    key: "delete",
    value: function _delete(messageId) {
      this.tasks.delete(messageId); // causes `onKeyDropped` to be invoked
    }
  }, {
    key: "get",
    value: function get(streamPartId) {
      var _this2 = this;
      var messageIds = this.streamPartLookup.get(streamPartId);
      var tasks = [];
      if (messageIds !== undefined) {
        messageIds.forEach(function (messageId) {
          var task = _this2.tasks.get(messageId);
          if (task !== undefined) {
            // should never be undefined if we don't have bugs
            tasks.push(task);
          }
        });
      }
      return tasks;
    }
  }, {
    key: "size",
    value: function size() {
      return this.tasks.size();
    }
  }]);
  return PropagationTaskStore;
}();
exports.PropagationTaskStore = PropagationTaskStore;

/***/ }),

/***/ "../network/src/logic/proxy/ProxyStreamConnectionClient.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.retry = exports.ProxyStreamConnectionClient = exports.Event = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/esnext.promise.all-settled.js");
var _NodeToNode = __webpack_require__("../network/src/protocol/NodeToNode.ts");
var _Node = __webpack_require__("../network/src/logic/Node.ts");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _sampleSize = _interopRequireDefault(__webpack_require__("../../node_modules/lodash/sampleSize.js"));
var _events = __webpack_require__("../../node_modules/events/events.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var logger = new _utils.Logger(module);
var Event = /*#__PURE__*/function (Event) {
  Event["CONNECTION_ACCEPTED"] = "proxy-connection-accepted";
  Event["CONNECTION_REJECTED"] = "proxy-connection-rejected";
  return Event;
}({});
exports.Event = Event;
var retry = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (task, description, abortSignal) {
    var delay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 15000;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      try {
        var result = yield task();
        return result;
      } catch (e) {
        logger.warn("Failed ".concat(description, " (retrying after delay)"), {
          delayInMs: delay
        });
      }
      yield (0, _utils.wait)(delay, abortSignal);
    }
  });
  return function retry(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
exports.retry = retry;
var ProxyStreamConnectionClient = /*#__PURE__*/function (_EventEmitter) {
  _inherits(ProxyStreamConnectionClient, _EventEmitter);
  var _super = _createSuper(ProxyStreamConnectionClient);
  function ProxyStreamConnectionClient(opts) {
    var _this;
    _classCallCheck(this, ProxyStreamConnectionClient);
    _this = _super.call(this);
    _this.trackerManager = opts.trackerManager;
    _this.streamPartManager = opts.streamPartManager;
    _this.nodeToNode = opts.nodeToNode;
    _this.node = opts.node;
    _this.nodeConnectTimeout = opts.nodeConnectTimeout;
    _this.propagation = opts.propagation;
    _this.definitions = new Map();
    _this.connections = new Map();
    _this.abortController = new AbortController();
    _this.nodeToNode.on(_NodeToNode.Event.PROXY_CONNECTION_RESPONSE_RECEIVED, function (message, nodeId) {
      _this.processHandshakeResponse(message, nodeId);
    });
    return _this;
  }
  _createClass(ProxyStreamConnectionClient, [{
    key: "setProxies",
    value: function () {
      var _setProxies = _asyncToGenerator(function* (streamPartId, nodeIds, direction, getUserId, connectionCount) {
        logger.trace('setProxies', {
          streamPartId: streamPartId
        });
        if (connectionCount !== undefined && connectionCount > nodeIds.length) {
          throw Error('Cannot set connectionCount above the size of the configured array of nodes');
        }
        if (this.streamPartManager.isSetUp(streamPartId) && !this.streamPartManager.isBehindProxy(streamPartId)) {
          throw Error("Could not set ".concat(direction, " proxies for stream ").concat(streamPartId, ", non-proxy stream already exists"));
        }
        if (nodeIds.length > 0 && !this.streamPartManager.isSetUp(streamPartId)) {
          this.streamPartManager.setUpStreamPart(streamPartId, true);
        }
        this.definitions.set(streamPartId, {
          nodeIds: new Set(nodeIds),
          userId: yield getUserId(),
          direction: direction,
          connectionCount: connectionCount !== null && connectionCount !== void 0 ? connectionCount : nodeIds.length
        });
        yield this.updateConnections(streamPartId);
      });
      function setProxies(_x4, _x5, _x6, _x7, _x8) {
        return _setProxies.apply(this, arguments);
      }
      return setProxies;
    }()
  }, {
    key: "updateConnections",
    value: function () {
      var _updateConnections = _asyncToGenerator(function* (streamPartId) {
        var _this2 = this;
        yield Promise.all(this.getInvalidConnections(streamPartId).map( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(function* (id) {
            yield _this2.closeConnection(streamPartId, id);
          });
          return function (_x10) {
            return _ref2.apply(this, arguments);
          };
        }()));
        var connectionCountDiff = this.definitions.get(streamPartId).connectionCount - this.getConnections(streamPartId).size;
        if (connectionCountDiff > 0) {
          yield this.openRandomConnections(streamPartId, connectionCountDiff);
        } else if (connectionCountDiff < 0) {
          yield this.closeRandomConnections(streamPartId, -connectionCountDiff);
        }
      });
      function updateConnections(_x9) {
        return _updateConnections.apply(this, arguments);
      }
      return updateConnections;
    }()
  }, {
    key: "getInvalidConnections",
    value: function getInvalidConnections(streamPartId) {
      var _this3 = this;
      return Array.from(this.getConnections(streamPartId).keys()).filter(function (id) {
        var definition = _this3.definitions.get(streamPartId);
        return !definition.nodeIds.has(id) || definition.direction !== _this3.getConnections(streamPartId).get(id);
      });
    }
  }, {
    key: "openRandomConnections",
    value: function () {
      var _openRandomConnections = _asyncToGenerator(function* (streamPartId, connectionCount) {
        var _this4 = this;
        var definition = this.definitions.get(streamPartId);
        var proxiesToAttempt = (0, _sampleSize.default)(Array.from(definition.nodeIds.keys()).filter(function (id) {
          return !_this4.getConnections(streamPartId).has(id);
        }), connectionCount);
        yield Promise.all(proxiesToAttempt.map(function (id) {
          return _this4.attemptConnection(streamPartId, id, definition.direction, definition.userId);
        }));
      });
      function openRandomConnections(_x11, _x12) {
        return _openRandomConnections.apply(this, arguments);
      }
      return openRandomConnections;
    }()
  }, {
    key: "attemptConnection",
    value: function () {
      var _attemptConnection = _asyncToGenerator(function* (streamPartId, nodeId, direction, userId) {
        yield Promise.all([this.waitForHandshake(streamPartId, nodeId, direction), this.initiateConnection(streamPartId, nodeId, direction, userId)]);
      });
      function attemptConnection(_x13, _x14, _x15, _x16) {
        return _attemptConnection.apply(this, arguments);
      }
      return attemptConnection;
    }()
  }, {
    key: "waitForHandshake",
    value: function () {
      var _waitForHandshake = _asyncToGenerator(function* (streamPartId, contactNodeId, direction) {
        var _this5 = this;
        var predicate = function predicate(node, stream, eventDirection) {
          return node === contactNodeId && stream === streamPartId && direction === eventDirection;
        };
        yield Promise.race([(0, _utils.waitForEvent)(this, Event.CONNECTION_ACCEPTED, this.nodeConnectTimeout, predicate), _asyncToGenerator(function* () {
          var result = yield (0, _utils.waitForEvent)(_this5, Event.CONNECTION_REJECTED, _this5.nodeConnectTimeout, predicate);
          throw new Error("Joining stream as proxy ".concat(direction, " failed on contact-node ").concat(contactNodeId, " for stream ").concat(streamPartId) + " reason: ".concat(result[3]));
        })()]);
      });
      function waitForHandshake(_x17, _x18, _x19) {
        return _waitForHandshake.apply(this, arguments);
      }
      return waitForHandshake;
    }()
  }, {
    key: "initiateConnection",
    value: function () {
      var _initiateConnection = _asyncToGenerator(function* (streamPartId, targetNodeId, direction, userId) {
        logger.info('Open proxy connection', {
          targetNodeId: targetNodeId,
          streamPartId: streamPartId
        });
        try {
          yield this.connectAndHandshake(streamPartId, targetNodeId, direction, userId);
        } catch (err) {
          logger.warn('Failed to create a proxy stream connection', {
            streamPartId: streamPartId,
            targetNodeId: targetNodeId,
            direction: direction,
            userId: userId,
            err: err
          });
          this.emit(Event.CONNECTION_REJECTED, targetNodeId, streamPartId, direction, err);
        } finally {
          this.trackerManager.removeSignallingOnlySession(streamPartId, targetNodeId);
        }
      });
      function initiateConnection(_x20, _x21, _x22, _x23) {
        return _initiateConnection.apply(this, arguments);
      }
      return initiateConnection;
    }()
  }, {
    key: "connectAndHandshake",
    value: function () {
      var _connectAndHandshake = _asyncToGenerator(function* (streamPartId, targetNodeId, direction, userId) {
        yield this.trackerManager.addSignallingOnlySession(streamPartId, targetNodeId);
        var trackerId = this.trackerManager.getTrackerId(streamPartId);
        yield (0, _utils.withTimeout)(this.nodeToNode.connectToNode(targetNodeId, trackerId, false), this.nodeConnectTimeout);
        yield this.nodeToNode.requestProxyConnection(targetNodeId, streamPartId, direction, userId);
      });
      function connectAndHandshake(_x24, _x25, _x26, _x27) {
        return _connectAndHandshake.apply(this, arguments);
      }
      return connectAndHandshake;
    }()
  }, {
    key: "closeRandomConnections",
    value: function () {
      var _closeRandomConnections = _asyncToGenerator(function* (streamPartId, connectionCount) {
        var _this6 = this;
        var proxiesToDisconnect = (0, _sampleSize.default)(Array.from(this.getConnections(streamPartId).keys()), connectionCount);
        yield Promise.allSettled(proxiesToDisconnect.map(function (node) {
          return _this6.closeConnection(streamPartId, node);
        }));
      });
      function closeRandomConnections(_x28, _x29) {
        return _closeRandomConnections.apply(this, arguments);
      }
      return closeRandomConnections;
    }()
  }, {
    key: "closeConnection",
    value: function () {
      var _closeConnection = _asyncToGenerator(function* (streamPartId, targetNodeId) {
        if (this.getConnections(streamPartId).has(targetNodeId) && this.streamPartManager.hasOnewayConnection(streamPartId, targetNodeId)) {
          logger.info('Close proxy connection', {
            targetNodeId: targetNodeId,
            streamPartId: streamPartId
          });
          yield this.nodeToNode.leaveStreamOnNode(targetNodeId, streamPartId);
          this.node.emit(_Node.Event.ONE_WAY_CONNECTION_CLOSED, targetNodeId, streamPartId);
          this.removeConnection(streamPartId, targetNodeId);
        }
      });
      function closeConnection(_x30, _x31) {
        return _closeConnection.apply(this, arguments);
      }
      return closeConnection;
    }()
  }, {
    key: "getConnections",
    value: function getConnections(streamPartId) {
      var _this$connections$get;
      return (_this$connections$get = this.connections.get(streamPartId)) !== null && _this$connections$get !== void 0 ? _this$connections$get : new Map();
    }
  }, {
    key: "hasConnection",
    value: function hasConnection(nodeId, streamPartId) {
      return this.getConnections(streamPartId).has(nodeId);
    }
  }, {
    key: "removeConnection",
    value: function removeConnection(streamPartId, nodeId) {
      if (this.hasConnection(nodeId, streamPartId)) {
        this.connections.get(streamPartId).delete(nodeId);
      }
      this.streamPartManager.removeNodeFromStreamPart(streamPartId, nodeId);
      if (this.definitions.get(streamPartId).nodeIds.size === 0 && this.getConnections(streamPartId).size === 0) {
        this.streamPartManager.removeStreamPart(streamPartId);
      }
    }
  }, {
    key: "processHandshakeResponse",
    value: function processHandshakeResponse(message, nodeId) {
      var streamPartId = message.getStreamPartID();
      if (message.accepted) {
        if (!this.connections.has(streamPartId)) {
          this.connections.set(streamPartId, new Map());
        }
        this.connections.get(streamPartId).set(nodeId, message.direction);
        if (message.direction === _protocol.ProxyDirection.PUBLISH) {
          this.streamPartManager.addOutOnlyNeighbor(streamPartId, nodeId);
          this.propagation.onNeighborJoined(nodeId, streamPartId);
        } else {
          this.streamPartManager.addInOnlyNeighbor(streamPartId, nodeId);
        }
        this.emit(Event.CONNECTION_ACCEPTED, nodeId, streamPartId, message.direction);
      } else {
        this.emit(Event.CONNECTION_REJECTED, nodeId, streamPartId, message.direction, "Target node ".concat(nodeId, " rejected proxy ").concat(message.direction, " stream connection ").concat(streamPartId));
      }
    }
  }, {
    key: "onNodeDisconnected",
    value: function () {
      var _onNodeDisconnected = _asyncToGenerator(function* (streamPartId, nodeId) {
        var _this7 = this;
        this.removeConnection(streamPartId, nodeId);
        yield retry(function () {
          return _this7.updateConnections(streamPartId);
        }, 'updating proxy connections', this.abortController.signal);
      });
      function onNodeDisconnected(_x32, _x33) {
        return _onNodeDisconnected.apply(this, arguments);
      }
      return onNodeDisconnected;
    }()
  }, {
    key: "isProxiedStreamPart",
    value: function isProxiedStreamPart(streamPartId, direction) {
      if (this.definitions.has(streamPartId)) {
        return this.definitions.get(streamPartId).direction === direction;
      }
      return false;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.definitions.clear();
      this.abortController.abort();
    }
  }]);
  return ProxyStreamConnectionClient;
}(_events.EventEmitter);
exports.ProxyStreamConnectionClient = ProxyStreamConnectionClient;

/***/ }),

/***/ "../network/src/logic/proxy/ProxyStreamConnectionServer.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ProxyStreamConnectionServer = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _NodeToNode = __webpack_require__("../network/src/protocol/NodeToNode.ts");
var _Node = __webpack_require__("../network/src/logic/Node.ts");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _utils.Logger(module);
var ProxyStreamConnectionServer = /*#__PURE__*/function () {
  function ProxyStreamConnectionServer(opts) {
    var _this = this;
    _classCallCheck(this, ProxyStreamConnectionServer);
    this.streamPartManager = opts.streamPartManager;
    this.nodeToNode = opts.nodeToNode;
    this.node = opts.node;
    this.acceptProxyConnections = opts.acceptProxyConnections;
    this.propagation = opts.propagation;
    this.connections = new Map();
    this.nodeToNode.on(_NodeToNode.Event.PROXY_CONNECTION_REQUEST_RECEIVED, function (message, nodeId) {
      _this.processHandshakeRequest(message, nodeId);
    });
    this.nodeToNode.on(_NodeToNode.Event.LEAVE_REQUEST_RECEIVED, function (message, nodeId) {
      _this.processLeaveRequest(message, nodeId);
    });
  }
  _createClass(ProxyStreamConnectionServer, [{
    key: "processHandshakeRequest",
    value: function () {
      var _processHandshakeRequest = _asyncToGenerator(function* (message, nodeId) {
        var streamPartId = message.getStreamPartID();
        var isAccepted = this.acceptProxyConnections && this.streamPartManager.isSetUp(streamPartId);
        yield this.nodeToNode.respondToProxyConnectionRequest(nodeId, streamPartId, message.direction, isAccepted);
        if (isAccepted) {
          this.addConnection(streamPartId, nodeId, message.direction, message.userId);
          if (message.direction === _protocol.ProxyDirection.PUBLISH) {
            this.streamPartManager.addInOnlyNeighbor(streamPartId, nodeId);
          } else {
            this.streamPartManager.addOutOnlyNeighbor(streamPartId, nodeId);
            this.propagation.onNeighborJoined(nodeId, streamPartId);
          }
        }
      });
      function processHandshakeRequest(_x, _x2) {
        return _processHandshakeRequest.apply(this, arguments);
      }
      return processHandshakeRequest;
    }()
  }, {
    key: "addConnection",
    value: function addConnection(streamPartId, nodeId, direction, userId) {
      if (!this.connections.has(streamPartId)) {
        this.connections.set(streamPartId, new Map());
      }
      this.connections.get(streamPartId).set(nodeId, {
        direction: direction,
        userId: userId
      });
    }
  }, {
    key: "processLeaveRequest",
    value: function processLeaveRequest(message, nodeId) {
      var streamPartId = message.getStreamPartID();
      this.removeConnection(streamPartId, nodeId);
      this.node.emit(_Node.Event.ONE_WAY_CONNECTION_CLOSED, nodeId, streamPartId);
      logger.info('Processed leave request by proxy node', {
        nodeId: nodeId,
        streamPartId: streamPartId
      });
    }
  }, {
    key: "removeConnection",
    value: function removeConnection(streamPartId, nodeId) {
      if (this.hasConnection(streamPartId, nodeId)) {
        this.connections.get(streamPartId).delete(nodeId);
        if (this.connections.get(streamPartId).size === 0) {
          this.connections.delete(streamPartId);
        }
        this.streamPartManager.removeNodeFromStreamPart(streamPartId, nodeId);
      }
    }
  }, {
    key: "hasConnection",
    value: function hasConnection(streamPartId, nodeId) {
      return this.connections.has(streamPartId) && this.connections.get(streamPartId).has(nodeId);
    }
  }, {
    key: "getNodeIdsForUserId",
    value: function getNodeIdsForUserId(streamPartId, userId) {
      var connections = this.connections.get(streamPartId);
      return connections ? Array.from(connections.keys()).filter(function (nodeId) {
        return connections.get(nodeId).userId === userId;
      }) : [];
    }
  }, {
    key: "stop",
    value: function stop() {
      this.connections.clear();
    }
  }]);
  return ProxyStreamConnectionServer;
}();
exports.ProxyStreamConnectionServer = ProxyStreamConnectionServer;

/***/ }),

/***/ "../network/src/protocol/NodeToNode.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.NodeToNode = exports.Event = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _events = __webpack_require__("../../node_modules/events/events.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _utils2 = __webpack_require__("../network/src/protocol/utils.ts");
var _IWebRtcEndpoint = __webpack_require__("../network/src/connection/webrtc/IWebRtcEndpoint.ts");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Event = /*#__PURE__*/function (Event) {
  Event["NODE_CONNECTED"] = "streamr:node-node:node-connected";
  Event["NODE_DISCONNECTED"] = "streamr:node-node:node-disconnected";
  Event["DATA_RECEIVED"] = "streamr:node-node:stream-data";
  Event["LOW_BACK_PRESSURE"] = "streamr:node-node:low-back-pressure";
  Event["HIGH_BACK_PRESSURE"] = "streamr:node-node:high-back-pressure";
  Event["PROXY_CONNECTION_REQUEST_RECEIVED"] = "node-node:publish-only-stream-request-received";
  Event["PROXY_CONNECTION_RESPONSE_RECEIVED"] = "node-node:publish-only-stream-response-received";
  Event["LEAVE_REQUEST_RECEIVED"] = "node-node:leave-request-received";
  return Event;
}({});
exports.Event = Event;
var eventPerType = {};
eventPerType[_protocol.ControlMessage.TYPES.BroadcastMessage] = Event.DATA_RECEIVED;
eventPerType[_protocol.ControlMessage.TYPES.ProxyConnectionRequest] = Event.PROXY_CONNECTION_REQUEST_RECEIVED;
eventPerType[_protocol.ControlMessage.TYPES.ProxyConnectionResponse] = Event.PROXY_CONNECTION_RESPONSE_RECEIVED;
eventPerType[_protocol.ControlMessage.TYPES.UnsubscribeRequest] = Event.LEAVE_REQUEST_RECEIVED;
var logger = new _utils.Logger(module);
var NodeToNode = /*#__PURE__*/function (_EventEmitter) {
  _inherits(NodeToNode, _EventEmitter);
  var _super = _createSuper(NodeToNode);
  function NodeToNode(endpoint) {
    var _this;
    _classCallCheck(this, NodeToNode);
    _this = _super.call(this);
    _this.endpoint = endpoint;
    endpoint.on(_IWebRtcEndpoint.Event.PEER_CONNECTED, function (peerInfo) {
      return _this.onPeerConnected(peerInfo);
    });
    endpoint.on(_IWebRtcEndpoint.Event.PEER_DISCONNECTED, function (peerInfo) {
      return _this.onPeerDisconnected(peerInfo);
    });
    endpoint.on(_IWebRtcEndpoint.Event.MESSAGE_RECEIVED, function (peerInfo, message) {
      return _this.onMessageReceived(peerInfo, message);
    });
    endpoint.on(_IWebRtcEndpoint.Event.LOW_BACK_PRESSURE, function (peerInfo) {
      return _this.onLowBackPressure(peerInfo);
    });
    endpoint.on(_IWebRtcEndpoint.Event.HIGH_BACK_PRESSURE, function (peerInfo) {
      return _this.onHighBackPressure(peerInfo);
    });
    return _this;
  }
  _createClass(NodeToNode, [{
    key: "connectToNode",
    value: function connectToNode(receiverNodeId, trackerId) {
      var trackerInstructed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return this.endpoint.connect(receiverNodeId, trackerId, trackerInstructed);
    }
  }, {
    key: "sendData",
    value: function sendData(receiverNodeId, streamMessage) {
      return this.send(receiverNodeId, new _protocol.BroadcastMessage({
        requestId: '',
        // TODO: how to echo here the requestId of the original SubscribeRequest?
        streamMessage: streamMessage
      }));
    }
  }, {
    key: "send",
    value: function send(receiverNodeId, message) {
      var _this$getNegotiatedPr = this.getNegotiatedProtocolVersionsOnNode(receiverNodeId),
        _this$getNegotiatedPr2 = _slicedToArray(_this$getNegotiatedPr, 2),
        controlLayerVersion = _this$getNegotiatedPr2[0],
        messageLayerVersion = _this$getNegotiatedPr2[1];
      return this.endpoint.send(receiverNodeId, message.serialize(controlLayerVersion, messageLayerVersion)).then(function () {
        return message;
      });
    }
  }, {
    key: "disconnectFromNode",
    value: function disconnectFromNode(receiverNodeId, reason) {
      this.endpoint.close(receiverNodeId, reason);
    }

    /**
     * @deprecated
     */
  }, {
    key: "getAddress",
    value: function getAddress() {
      return this.endpoint.getAddress();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.endpoint.stop();
    }
  }, {
    key: "onPeerConnected",
    value: function onPeerConnected(peerInfo) {
      if (peerInfo.isNode()) {
        this.emit(Event.NODE_CONNECTED, peerInfo.peerId);
      }
    }
  }, {
    key: "onPeerDisconnected",
    value: function onPeerDisconnected(peerInfo) {
      if (peerInfo.isNode()) {
        this.emit(Event.NODE_DISCONNECTED, peerInfo.peerId);
      }
    }
  }, {
    key: "onMessageReceived",
    value: function onMessageReceived(peerInfo, rawMessage) {
      if (peerInfo.isNode()) {
        var _message = (0, _utils2.decode)(rawMessage, _protocol.ControlMessage.deserialize);
        if (_message != null) {
          this.emit(eventPerType[_message.type], _message, peerInfo.peerId);
        } else {
          logger.warn('Drop invalid message', {
            sender: peerInfo.peerId,
            rawMessage: rawMessage
          });
        }
      }
    }
  }, {
    key: "onLowBackPressure",
    value: function onLowBackPressure(peerInfo) {
      if (peerInfo.isNode()) {
        this.emit(Event.LOW_BACK_PRESSURE, peerInfo.peerId);
      }
    }
  }, {
    key: "onHighBackPressure",
    value: function onHighBackPressure(peerInfo) {
      if (peerInfo.isNode()) {
        this.emit(Event.HIGH_BACK_PRESSURE, peerInfo.peerId);
      }
    }
  }, {
    key: "getRtts",
    value: function getRtts() {
      return this.endpoint.getRtts();
    }
  }, {
    key: "getNegotiatedProtocolVersionsOnNode",
    value: function getNegotiatedProtocolVersionsOnNode(nodeId) {
      var messageLayerVersion = this.endpoint.getNegotiatedMessageLayerProtocolVersionOnNode(nodeId) || this.endpoint.getDefaultMessageLayerProtocolVersion();
      var controlLayerVersion = this.endpoint.getNegotiatedControlLayerProtocolVersionOnNode(nodeId) || this.endpoint.getDefaultControlLayerProtocolVersion();
      return [controlLayerVersion, messageLayerVersion];
    }
  }, {
    key: "requestProxyConnection",
    value: function () {
      var _requestProxyConnection = _asyncToGenerator(function* (nodeId, streamPartId, direction, userId) {
        var _StreamPartIDUtils$ge = _protocol.StreamPartIDUtils.getStreamIDAndPartition(streamPartId),
          _StreamPartIDUtils$ge2 = _slicedToArray(_StreamPartIDUtils$ge, 2),
          streamId = _StreamPartIDUtils$ge2[0],
          streamPartition = _StreamPartIDUtils$ge2[1];
        yield this.send(nodeId, new _protocol.ProxyConnectionRequest({
          requestId: '',
          senderId: nodeId,
          streamId: streamId,
          streamPartition: streamPartition,
          userId: userId,
          direction: direction
        }));
      });
      function requestProxyConnection(_x2, _x3, _x4, _x5) {
        return _requestProxyConnection.apply(this, arguments);
      }
      return requestProxyConnection;
    }()
  }, {
    key: "leaveStreamOnNode",
    value: function () {
      var _leaveStreamOnNode = _asyncToGenerator(function* (nodeId, streamPartId) {
        var _StreamPartIDUtils$ge3 = _protocol.StreamPartIDUtils.getStreamIDAndPartition(streamPartId),
          _StreamPartIDUtils$ge4 = _slicedToArray(_StreamPartIDUtils$ge3, 2),
          streamId = _StreamPartIDUtils$ge4[0],
          streamPartition = _StreamPartIDUtils$ge4[1];
        yield this.send(nodeId, new _protocol.UnsubscribeRequest({
          requestId: '',
          streamId: streamId,
          streamPartition: streamPartition
        }));
      });
      function leaveStreamOnNode(_x6, _x7) {
        return _leaveStreamOnNode.apply(this, arguments);
      }
      return leaveStreamOnNode;
    }()
  }, {
    key: "respondToProxyConnectionRequest",
    value: function () {
      var _respondToProxyConnectionRequest = _asyncToGenerator(function* (nodeId, streamPartId, direction, accepted) {
        var _StreamPartIDUtils$ge5 = _protocol.StreamPartIDUtils.getStreamIDAndPartition(streamPartId),
          _StreamPartIDUtils$ge6 = _slicedToArray(_StreamPartIDUtils$ge5, 2),
          streamId = _StreamPartIDUtils$ge6[0],
          streamPartition = _StreamPartIDUtils$ge6[1];
        yield this.send(nodeId, new _protocol.ProxyConnectionResponse({
          requestId: '',
          senderId: nodeId,
          streamId: streamId,
          streamPartition: streamPartition,
          direction: direction,
          accepted: accepted
        }));
      });
      function respondToProxyConnectionRequest(_x8, _x9, _x10, _x11) {
        return _respondToProxyConnectionRequest.apply(this, arguments);
      }
      return respondToProxyConnectionRequest;
    }()
  }, {
    key: "getAllConnectionNodeIds",
    value: function getAllConnectionNodeIds() {
      return this.endpoint.getAllConnectionNodeIds();
    }
  }, {
    key: "getDiagnosticInfo",
    value: function getDiagnosticInfo() {
      return this.endpoint.getDiagnosticInfo();
    }
  }]);
  return NodeToNode;
}(_events.EventEmitter);
exports.NodeToNode = NodeToNode;

/***/ }),

/***/ "../network/src/protocol/NodeToTracker.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.NodeToTracker = exports.Event = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _events = __webpack_require__("../../node_modules/events/events.js");
var _uuid = __webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/index.js");
var _protocol = __webpack_require__("../protocol/src/exports.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
var _utils2 = __webpack_require__("../network/src/protocol/utils.ts");
var _NameDirectory = __webpack_require__("../network/src/NameDirectory.ts");
var _AbstractWsEndpoint = __webpack_require__("../network/src/connection/ws/AbstractWsEndpoint.ts");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Event = /*#__PURE__*/function (Event) {
  Event["CONNECTED_TO_TRACKER"] = "streamr:tracker-node:send-status";
  Event["TRACKER_DISCONNECTED"] = "streamr:tracker-node:tracker-disconnected";
  Event["TRACKER_INSTRUCTION_RECEIVED"] = "streamr:tracker-node:tracker-instruction-received";
  Event["STATUS_ACK_RECEIVED"] = "streamr:tracker-node:status-ack-received";
  Event["RELAY_MESSAGE_RECEIVED"] = "streamr:tracker-node:relay-message-received";
  Event["RTC_ERROR_RECEIVED"] = "streamr:tracker-node:rtc-error-received";
  return Event;
}({});
exports.Event = Event;
var eventPerType = {};
eventPerType[_protocol.TrackerMessage.TYPES.InstructionMessage] = Event.TRACKER_INSTRUCTION_RECEIVED;
eventPerType[_protocol.TrackerMessage.TYPES.StatusAckMessage] = Event.STATUS_ACK_RECEIVED;
eventPerType[_protocol.TrackerMessage.TYPES.RelayMessage] = Event.RELAY_MESSAGE_RECEIVED;
eventPerType[_protocol.TrackerMessage.TYPES.ErrorMessage] = Event.RTC_ERROR_RECEIVED;
var logger = new _utils.Logger(module);
var NodeToTracker = /*#__PURE__*/function (_EventEmitter) {
  _inherits(NodeToTracker, _EventEmitter);
  var _super = _createSuper(NodeToTracker);
  function NodeToTracker(endpoint) {
    var _this;
    _classCallCheck(this, NodeToTracker);
    _this = _super.call(this);
    _this.endpoint = endpoint;
    _this.endpoint.on(_AbstractWsEndpoint.Event.PEER_CONNECTED, function (peerInfo) {
      return _this.onPeerConnected(peerInfo);
    });
    _this.endpoint.on(_AbstractWsEndpoint.Event.PEER_DISCONNECTED, function (peerInfo) {
      return _this.onPeerDisconnected(peerInfo);
    });
    _this.endpoint.on(_AbstractWsEndpoint.Event.MESSAGE_RECEIVED, function (peerInfo, message) {
      return _this.onMessageReceived(peerInfo, message);
    });
    return _this;
  }
  _createClass(NodeToTracker, [{
    key: "sendStatus",
    value: function () {
      var _sendStatus = _asyncToGenerator(function* (trackerId, status) {
        var requestId = (0, _uuid.v4)();
        yield this.send(trackerId, new _protocol.StatusMessage({
          requestId: requestId,
          status: status
        }));
        return requestId;
      });
      function sendStatus(_x, _x2) {
        return _sendStatus.apply(this, arguments);
      }
      return sendStatus;
    }()
  }, {
    key: "sendRtcOffer",
    value: function () {
      var _sendRtcOffer = _asyncToGenerator(function* (trackerId, targetNode, connectionId, originatorInfo, description) {
        var requestId = (0, _uuid.v4)();
        yield this.send(trackerId, new _protocol.RelayMessage({
          requestId: requestId,
          originator: originatorInfo,
          targetNode: targetNode,
          subType: _protocol.RelayMessageSubType.RTC_OFFER,
          data: {
            connectionId: connectionId,
            description: description
          }
        }));
        return requestId;
      });
      function sendRtcOffer(_x3, _x4, _x5, _x6, _x7) {
        return _sendRtcOffer.apply(this, arguments);
      }
      return sendRtcOffer;
    }()
  }, {
    key: "sendRtcAnswer",
    value: function () {
      var _sendRtcAnswer = _asyncToGenerator(function* (trackerId, targetNode, connectionId, originatorInfo, description) {
        var requestId = (0, _uuid.v4)();
        yield this.send(trackerId, new _protocol.RelayMessage({
          requestId: requestId,
          originator: originatorInfo,
          targetNode: targetNode,
          subType: _protocol.RelayMessageSubType.RTC_ANSWER,
          data: {
            connectionId: connectionId,
            description: description
          }
        }));
        return requestId;
      });
      function sendRtcAnswer(_x8, _x9, _x10, _x11, _x12) {
        return _sendRtcAnswer.apply(this, arguments);
      }
      return sendRtcAnswer;
    }()
  }, {
    key: "sendRtcIceCandidate",
    value: function () {
      var _sendRtcIceCandidate = _asyncToGenerator(function* (trackerId, targetNode, connectionId, originatorInfo, candidate, mid) {
        var requestId = (0, _uuid.v4)();
        yield this.send(trackerId, new _protocol.RelayMessage({
          requestId: requestId,
          originator: originatorInfo,
          targetNode: targetNode,
          subType: _protocol.RelayMessageSubType.ICE_CANDIDATE,
          data: {
            connectionId: connectionId,
            candidate: candidate,
            mid: mid
          }
        }));
        return requestId;
      });
      function sendRtcIceCandidate(_x13, _x14, _x15, _x16, _x17, _x18) {
        return _sendRtcIceCandidate.apply(this, arguments);
      }
      return sendRtcIceCandidate;
    }()
  }, {
    key: "sendRtcConnect",
    value: function () {
      var _sendRtcConnect = _asyncToGenerator(function* (trackerId, targetNode, originatorInfo) {
        var requestId = (0, _uuid.v4)();
        yield this.send(trackerId, new _protocol.RelayMessage({
          requestId: requestId,
          originator: originatorInfo,
          targetNode: targetNode,
          subType: _protocol.RelayMessageSubType.RTC_CONNECT,
          data: {}
        }));
        return requestId;
      });
      function sendRtcConnect(_x19, _x20, _x21) {
        return _sendRtcConnect.apply(this, arguments);
      }
      return sendRtcConnect;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(function* (receiverTrackerId, message) {
        yield this.endpoint.send(receiverTrackerId, message.serialize());
      });
      function send(_x22, _x23) {
        return _send.apply(this, arguments);
      }
      return send;
    }()
  }, {
    key: "getServerUrlByTrackerId",
    value: function getServerUrlByTrackerId(trackerId) {
      return this.endpoint.getServerUrlByPeerId(trackerId);
    }
  }, {
    key: "getDiagnosticInfo",
    value: function getDiagnosticInfo() {
      return this.endpoint.getDiagnosticInfo();
    }
  }, {
    key: "stop",
    value: function stop() {
      return this.endpoint.stop();
    }
  }, {
    key: "onMessageReceived",
    value: function onMessageReceived(peerInfo, rawMessage) {
      if (peerInfo.isTracker()) {
        var message = (0, _utils2.decode)(rawMessage, _protocol.TrackerMessage.deserialize);
        if (message != null) {
          this.emit(eventPerType[message.type], message, peerInfo.peerId);
        } else {
          logger.warn('Drop invalid message', {
            sender: peerInfo.peerId,
            rawMessage: rawMessage
          });
        }
      }
    }
  }, {
    key: "connectToTracker",
    value: function connectToTracker(trackerAddress, trackerPeerInfo) {
      return this.endpoint.connect(trackerAddress, trackerPeerInfo);
    }
  }, {
    key: "disconnectFromTracker",
    value: function disconnectFromTracker(trackerId) {
      this.endpoint.close(trackerId, 1000, _AbstractWsEndpoint.DisconnectionReason.NO_SHARED_STREAM_PARTS);
    }
  }, {
    key: "onPeerConnected",
    value: function onPeerConnected(peerInfo) {
      if (peerInfo.isTracker()) {
        logger.debug('Connected to tracker', {
          trackerId: _NameDirectory.NameDirectory.getName(peerInfo.peerId)
        });
        this.emit(Event.CONNECTED_TO_TRACKER, peerInfo.peerId);
      }
    }
  }, {
    key: "onPeerDisconnected",
    value: function onPeerDisconnected(peerInfo) {
      if (peerInfo.isTracker()) {
        this.emit(Event.TRACKER_DISCONNECTED, peerInfo.peerId);
      }
    }
  }]);
  return NodeToTracker;
}(_events.EventEmitter);
exports.NodeToTracker = NodeToTracker;

/***/ }),

/***/ "../network/src/protocol/utils.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.decode = decode;
function decode(serializedMessage, deserializeFn) {
  try {
    return deserializeFn(serializedMessage);
  } catch (_unused) {
    return null;
  }
}

/***/ }),

/***/ "../protocol/src/Serializer.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Serializer = void 0;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var Serializer = /*#__PURE__*/_createClass(function Serializer() {
  _classCallCheck(this, Serializer);
});
exports.Serializer = Serializer;

/***/ }),

/***/ "../protocol/src/errors/InvalidJsonError.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _StreamMessageError2 = _interopRequireDefault(__webpack_require__("../protocol/src/errors/StreamMessageError.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var InvalidJsonError = /*#__PURE__*/function (_StreamMessageError) {
  _inherits(InvalidJsonError, _StreamMessageError);
  var _super = _createSuper(InvalidJsonError);
  function InvalidJsonError(streamId, parseError, streamMessage) {
    var _this;
    _classCallCheck(this, InvalidJsonError);
    _this = _super.call(this, "Invalid JSON in stream ".concat(streamId, ": ").concat(parseError), streamMessage);
    _this.parseError = parseError;
    return _this;
  }
  return _createClass(InvalidJsonError);
}(_StreamMessageError2.default);
exports["default"] = InvalidJsonError;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/errors/StreamMessageError.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _ValidationError2 = _interopRequireDefault(__webpack_require__("../protocol/src/errors/ValidationError.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var StreamMessageError = /*#__PURE__*/function (_ValidationError) {
  _inherits(StreamMessageError, _ValidationError);
  var _super = _createSuper(StreamMessageError);
  function StreamMessageError(msg, streamMessage, code) {
    var _this;
    _classCallCheck(this, StreamMessageError);
    _this = _super.call(this, msg, code);
    _this.streamMessage = streamMessage;
    return _this;
  }
  return _createClass(StreamMessageError);
}(_ValidationError2.default);
exports["default"] = StreamMessageError;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/errors/UnsupportedTypeError.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var UnsupportedTypeError = /*#__PURE__*/function (_Error) {
  _inherits(UnsupportedTypeError, _Error);
  var _super = _createSuper(UnsupportedTypeError);
  function UnsupportedTypeError(type, message) {
    var _this;
    _classCallCheck(this, UnsupportedTypeError);
    _this = _super.call(this, "Unsupported type: ".concat(type, ", message: ").concat(message));
    _this.type = type;
    return _this;
  }
  return _createClass(UnsupportedTypeError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports["default"] = UnsupportedTypeError;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/errors/UnsupportedVersionError.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var UnsupportedVersionError = /*#__PURE__*/function (_Error) {
  _inherits(UnsupportedVersionError, _Error);
  var _super = _createSuper(UnsupportedVersionError);
  function UnsupportedVersionError(version, message) {
    var _this;
    _classCallCheck(this, UnsupportedVersionError);
    _this = _super.call(this, "Unsupported version: ".concat(version, ", message: ").concat(message));
    _this.version = version;
    return _this;
  }
  return _createClass(UnsupportedVersionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports["default"] = UnsupportedVersionError;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/errors/ValidationError.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ValidationError = /*#__PURE__*/function (_Error) {
  _inherits(ValidationError, _Error);
  var _super = _createSuper(ValidationError);
  function ValidationError(msg, code) {
    var _this;
    _classCallCheck(this, ValidationError);
    _this = _super.call(this, msg);
    _this.code = code;
    return _this;
  }
  return _createClass(ValidationError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports["default"] = ValidationError;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/errors/exports.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "InvalidJsonError", ({
  enumerable: true,
  get: function get() {
    return _InvalidJsonError.default;
  }
}));
Object.defineProperty(exports, "StreamMessageError", ({
  enumerable: true,
  get: function get() {
    return _StreamMessageError.default;
  }
}));
Object.defineProperty(exports, "UnsupportedVersionError", ({
  enumerable: true,
  get: function get() {
    return _UnsupportedVersionError.default;
  }
}));
Object.defineProperty(exports, "ValidationError", ({
  enumerable: true,
  get: function get() {
    return _ValidationError.default;
  }
}));
var _InvalidJsonError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/InvalidJsonError.ts"));
var _UnsupportedVersionError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/UnsupportedVersionError.ts"));
var _ValidationError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/ValidationError.ts"));
var _StreamMessageError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/StreamMessageError.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "../protocol/src/exports.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _exports = __webpack_require__("../protocol/src/protocol/control_layer/exports.ts");
Object.keys(_exports).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _exports[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _exports[key];
    }
  });
});
var _exports2 = __webpack_require__("../protocol/src/protocol/message_layer/exports.ts");
Object.keys(_exports2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _exports2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _exports2[key];
    }
  });
});
var _exports3 = __webpack_require__("../protocol/src/protocol/tracker_layer/exports.ts");
Object.keys(_exports3).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _exports3[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _exports3[key];
    }
  });
});
var _exports4 = __webpack_require__("../protocol/src/errors/exports.ts");
Object.keys(_exports4).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _exports4[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _exports4[key];
    }
  });
});
var _exports5 = __webpack_require__("../protocol/src/utils/exports.ts");
Object.keys(_exports5).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _exports5[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _exports5[key];
    }
  });
});

/***/ }),

/***/ "../protocol/src/protocol/control_layer/ControlMessage.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.ControlMessageType = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.parse-int.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _UnsupportedVersionError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/UnsupportedVersionError.ts"));
var _UnsupportedTypeError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/UnsupportedTypeError.ts"));
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// TODO use ControlMessageType instead of number when we have real enums
var serializerByVersionAndType = {};
var LATEST_VERSION = 2;
var ControlMessageType = /*#__PURE__*/function (ControlMessageType) {
  ControlMessageType[ControlMessageType["BroadcastMessage"] = 0] = "BroadcastMessage";
  ControlMessageType[ControlMessageType["ErrorResponse"] = 7] = "ErrorResponse";
  ControlMessageType[ControlMessageType["UnsubscribeRequest"] = 10] = "UnsubscribeRequest";
  ControlMessageType[ControlMessageType["ProxyConnectionRequest"] = 14] = "ProxyConnectionRequest";
  ControlMessageType[ControlMessageType["ProxyConnectionResponse"] = 15] = "ProxyConnectionResponse";
  return ControlMessageType;
}({});
exports.ControlMessageType = ControlMessageType;
var ControlMessage = /*#__PURE__*/function () {
  // TODO can we remove this and use the enum object directly?

  // eslint-disable-next-line @typescript-eslint/default-param-last
  function ControlMessage() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LATEST_VERSION;
    var type = arguments.length > 1 ? arguments[1] : undefined;
    var requestId = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, ControlMessage);
    if ((this instanceof ControlMessage ? this.constructor : void 0) === ControlMessage) {
      throw new TypeError('ControlMessage is abstract.');
    }
    (0, _validations.validateIsInteger)('version', version);
    this.version = version;
    (0, _validations.validateIsInteger)('type', type);
    this.type = type;

    // Since V2 - allow null in older versions
    (0, _validations.validateIsString)('requestId', requestId, version < 2);
    this.requestId = requestId;
  }
  _createClass(ControlMessage, [{
    key: "serialize",
    value: function serialize() {
      var _ControlMessage$getSe;
      var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.version;
      for (var _len = arguments.length, typeSpecificSerializeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        typeSpecificSerializeArgs[_key - 1] = arguments[_key];
      }
      return JSON.stringify((_ControlMessage$getSe = ControlMessage.getSerializer(version, this.type)).toArray.apply(_ControlMessage$getSe, [this].concat(typeSpecificSerializeArgs)));
    }

    /**
     * Takes a serialized representation (array or string) of a message, and returns a ControlMessage instance.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  }], [{
    key: "registerSerializer",
    value: function registerSerializer(version, type, serializer) {
      // Check the serializer interface
      if (!serializer.fromArray) {
        throw new Error("Serializer ".concat(JSON.stringify(serializer), " doesn't implement a method fromArray!"));
      }
      if (!serializer.toArray) {
        throw new Error("Serializer ".concat(JSON.stringify(serializer), " doesn't implement a method toArray!"));
      }
      if (serializerByVersionAndType[version] === undefined) {
        serializerByVersionAndType[version] = {};
      }
      if (serializerByVersionAndType[version][type] !== undefined) {
        throw new Error("Serializer for version ".concat(version, " and type ").concat(type, " is already registered: ").concat(JSON.stringify(serializerByVersionAndType[version][type])));
      }
      serializerByVersionAndType[version][type] = serializer;
    }
  }, {
    key: "unregisterSerializer",
    value: function unregisterSerializer(version, type) {
      delete serializerByVersionAndType[version][type];
    }
  }, {
    key: "getSerializer",
    value: function getSerializer(version, type) {
      var serializersByType = serializerByVersionAndType[version];
      if (!serializersByType) {
        throw new _UnsupportedVersionError.default(version, "Supported versions: [".concat(ControlMessage.getSupportedVersions(), "]"));
      }
      var clazz = serializersByType[type];
      if (!clazz) {
        throw new _UnsupportedTypeError.default(type, "Supported types: [".concat(Object.keys(serializersByType), "]"));
      }
      return clazz;
    }
  }, {
    key: "getSupportedVersions",
    value: function getSupportedVersions() {
      return Object.keys(serializerByVersionAndType).map(function (key) {
        return parseInt(key, 10);
      });
    }
  }, {
    key: "deserialize",
    value: function deserialize(msg) {
      var messageArray = typeof msg === 'string' ? JSON.parse(msg) : msg;
      var messageVersion = messageArray[0];
      var messageType = messageArray[1];
      var C = ControlMessage.getSerializer(messageVersion, messageType);
      for (var _len2 = arguments.length, typeSpecificDeserializeArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        typeSpecificDeserializeArgs[_key2 - 1] = arguments[_key2];
      }
      return C.fromArray.apply(C, [messageArray].concat(typeSpecificDeserializeArgs));
    }
  }]);
  return ControlMessage;
}();
exports["default"] = ControlMessage;
_defineProperty(ControlMessage, "LATEST_VERSION", LATEST_VERSION);
_defineProperty(ControlMessage, "TYPES", ControlMessageType);

/***/ }),

/***/ "../protocol/src/protocol/control_layer/broadcast_message/BroadcastMessage.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _ControlMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _StreamMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/StreamMessage.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var BroadcastMessage = /*#__PURE__*/function (_ControlMessage) {
  _inherits(BroadcastMessage, _ControlMessage);
  var _super = _createSuper(BroadcastMessage);
  function BroadcastMessage(_ref) {
    var _this;
    var _ref$version = _ref.version,
      version = _ref$version === void 0 ? _ControlMessage2.default.LATEST_VERSION : _ref$version,
      requestId = _ref.requestId,
      streamMessage = _ref.streamMessage;
    _classCallCheck(this, BroadcastMessage);
    _this = _super.call(this, version, _ControlMessage2.default.TYPES.BroadcastMessage, requestId);
    (0, _validations.validateIsType)('streamMessage', streamMessage, 'StreamMessage', _StreamMessage.default);
    _this.streamMessage = streamMessage;
    return _this;
  }
  return _createClass(BroadcastMessage);
}(_ControlMessage2.default);
exports["default"] = BroadcastMessage;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/control_layer/broadcast_message/BroadcastMessageSerializerV2.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _ControlMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
var _StreamMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/StreamMessage.ts"));
var _BroadcastMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/broadcast_message/BroadcastMessage.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 2;

/* eslint-disable class-methods-use-this */
var BroadcastMessageSerializerV2 = /*#__PURE__*/function (_Serializer) {
  _inherits(BroadcastMessageSerializerV2, _Serializer);
  var _super = _createSuper(BroadcastMessageSerializerV2);
  function BroadcastMessageSerializerV2() {
    _classCallCheck(this, BroadcastMessageSerializerV2);
    return _super.apply(this, arguments);
  }
  _createClass(BroadcastMessageSerializerV2, [{
    key: "toArray",
    value: function toArray(broadcastMessage) {
      var streamMessageVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _StreamMessage.default.LATEST_VERSION;
      return [VERSION, _ControlMessage.default.TYPES.BroadcastMessage, broadcastMessage.requestId, _StreamMessage.default.getSerializer(streamMessageVersion).toArray(broadcastMessage.streamMessage)];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 4),
        version = _arr2[0],
        _type = _arr2[1],
        requestId = _arr2[2],
        serializedStreamMsg = _arr2[3];
      return new _BroadcastMessage.default({
        version: version,
        requestId: requestId,
        streamMessage: _StreamMessage.default.deserialize(serializedStreamMsg)
      });
    }
  }]);
  return BroadcastMessageSerializerV2;
}(_Serializer2.Serializer);
exports["default"] = BroadcastMessageSerializerV2;
_ControlMessage.default.registerSerializer(VERSION, _ControlMessage.default.TYPES.BroadcastMessage, new BroadcastMessageSerializerV2());
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/control_layer/error_response/ErrorResponse.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.ErrorCode = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _ControlMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ErrorCode = /*#__PURE__*/function (ErrorCode) {
  ErrorCode["AUTHENTICATION_FAILED"] = "AUTHENTICATION_FAILED";
  ErrorCode["NOT_FOUND"] = "NOT_FOUND";
  return ErrorCode;
}({});
exports.ErrorCode = ErrorCode;
var ErrorResponse = /*#__PURE__*/function (_ControlMessage) {
  _inherits(ErrorResponse, _ControlMessage);
  var _super = _createSuper(ErrorResponse);
  function ErrorResponse(_ref) {
    var _this;
    var _ref$version = _ref.version,
      version = _ref$version === void 0 ? _ControlMessage2.default.LATEST_VERSION : _ref$version,
      requestId = _ref.requestId,
      errorMessage = _ref.errorMessage,
      errorCode = _ref.errorCode;
    _classCallCheck(this, ErrorResponse);
    _this = _super.call(this, version, _ControlMessage2.default.TYPES.ErrorResponse, requestId);
    (0, _validations.validateIsString)('errorMessage', errorMessage);
    _this.errorMessage = errorMessage;

    // Since V2
    if (version >= 2) {
      (0, _validations.validateIsString)('errorCode', errorCode);
    }
    _this.errorCode = errorCode;
    return _this;
  }
  return _createClass(ErrorResponse);
}(_ControlMessage2.default);
exports["default"] = ErrorResponse;

/***/ }),

/***/ "../protocol/src/protocol/control_layer/error_response/ErrorResponseSerializerV2.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _ControlMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
var _ErrorResponse = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/error_response/ErrorResponse.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 2;

/* eslint-disable class-methods-use-this */
var ErrorResponseSerializerV2 = /*#__PURE__*/function (_Serializer) {
  _inherits(ErrorResponseSerializerV2, _Serializer);
  var _super = _createSuper(ErrorResponseSerializerV2);
  function ErrorResponseSerializerV2() {
    _classCallCheck(this, ErrorResponseSerializerV2);
    return _super.apply(this, arguments);
  }
  _createClass(ErrorResponseSerializerV2, [{
    key: "toArray",
    value: function toArray(errorResponse) {
      return [VERSION, _ControlMessage.default.TYPES.ErrorResponse, errorResponse.requestId, errorResponse.errorMessage, errorResponse.errorCode];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 5),
        version = _arr2[0],
        _type = _arr2[1],
        requestId = _arr2[2],
        errorMessage = _arr2[3],
        errorCode = _arr2[4];
      return new _ErrorResponse.default({
        version: version,
        requestId: requestId,
        errorMessage: errorMessage,
        errorCode: errorCode
      });
    }
  }]);
  return ErrorResponseSerializerV2;
}(_Serializer2.Serializer);
exports["default"] = ErrorResponseSerializerV2;
_ControlMessage.default.registerSerializer(VERSION, _ControlMessage.default.TYPES.ErrorResponse, new ErrorResponseSerializerV2());
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/control_layer/exports.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-map.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "BroadcastMessage", ({
  enumerable: true,
  get: function get() {
    return _BroadcastMessage.default;
  }
}));
Object.defineProperty(exports, "ControlMessage", ({
  enumerable: true,
  get: function get() {
    return _ControlMessage.default;
  }
}));
Object.defineProperty(exports, "ControlMessageType", ({
  enumerable: true,
  get: function get() {
    return _ControlMessage.ControlMessageType;
  }
}));
Object.defineProperty(exports, "ErrorCode", ({
  enumerable: true,
  get: function get() {
    return _ErrorResponse.ErrorCode;
  }
}));
Object.defineProperty(exports, "ErrorResponse", ({
  enumerable: true,
  get: function get() {
    return _ErrorResponse.default;
  }
}));
Object.defineProperty(exports, "ProxyConnectionRequest", ({
  enumerable: true,
  get: function get() {
    return _ProxyConnectionRequest.default;
  }
}));
Object.defineProperty(exports, "ProxyConnectionResponse", ({
  enumerable: true,
  get: function get() {
    return _ProxyConnectionResponse.default;
  }
}));
Object.defineProperty(exports, "UnsubscribeRequest", ({
  enumerable: true,
  get: function get() {
    return _UnsubscribeRequest.default;
  }
}));
var _BroadcastMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/broadcast_message/BroadcastMessage.ts"));
var _ErrorResponse = _interopRequireWildcard(__webpack_require__("../protocol/src/protocol/control_layer/error_response/ErrorResponse.ts"));
var _ProxyConnectionRequest = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/proxy_connection_request/ProxyConnectionRequest.ts"));
var _ProxyConnectionResponse = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/proxy_connection_response/ProxyConnectionResponse.ts"));
var _UnsubscribeRequest = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/unsubscribe_request/UnsubscribeRequest.ts"));
var _ControlMessage = _interopRequireWildcard(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
__webpack_require__("../protocol/src/protocol/control_layer/broadcast_message/BroadcastMessageSerializerV2.ts");
__webpack_require__("../protocol/src/protocol/control_layer/error_response/ErrorResponseSerializerV2.ts");
__webpack_require__("../protocol/src/protocol/control_layer/unsubscribe_request/UnsubscribeRequestSerializerV2.ts");
__webpack_require__("../protocol/src/protocol/control_layer/proxy_connection_request/ProxyConnectionRequestSerializerV2.ts");
__webpack_require__("../protocol/src/protocol/control_layer/proxy_connection_response/ProxyConnectionResponseSerializerV2.ts");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "../protocol/src/protocol/control_layer/proxy_connection_request/ProxyConnectionRequest.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _ControlMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _StreamPartID = __webpack_require__("../protocol/src/utils/StreamPartID.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ProxyConnectionRequest = /*#__PURE__*/function (_ControlMessage) {
  _inherits(ProxyConnectionRequest, _ControlMessage);
  var _super = _createSuper(ProxyConnectionRequest);
  function ProxyConnectionRequest(_ref) {
    var _this;
    var _ref$version = _ref.version,
      version = _ref$version === void 0 ? _ControlMessage2.default.LATEST_VERSION : _ref$version,
      requestId = _ref.requestId,
      senderId = _ref.senderId,
      streamId = _ref.streamId,
      streamPartition = _ref.streamPartition,
      direction = _ref.direction,
      userId = _ref.userId;
    _classCallCheck(this, ProxyConnectionRequest);
    _this = _super.call(this, version, _ControlMessage2.default.TYPES.ProxyConnectionRequest, requestId);
    (0, _validations.validateIsNotNullOrUndefined)('senderId', senderId);
    _this.senderId = senderId;
    (0, _validations.validateIsString)('streamId', streamId);
    _this.streamId = streamId;
    (0, _validations.validateIsInteger)('streamPartition', streamPartition);
    _this.streamPartition = streamPartition;
    (0, _validations.validateIsDirection)('direction', direction);
    _this.direction = direction;
    (0, _validations.validateIsString)('userId', userId);
    _this.userId = userId;
    return _this;
  }
  _createClass(ProxyConnectionRequest, [{
    key: "getStreamPartID",
    value: function getStreamPartID() {
      return (0, _StreamPartID.toStreamPartID)(this.streamId, this.streamPartition);
    }
  }]);
  return ProxyConnectionRequest;
}(_ControlMessage2.default);
exports["default"] = ProxyConnectionRequest;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/control_layer/proxy_connection_request/ProxyConnectionRequestSerializerV2.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _ControlMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
var _ProxyConnectionRequest = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/proxy_connection_request/ProxyConnectionRequest.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
var _StreamID = __webpack_require__("../protocol/src/utils/StreamID.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 2;

/* eslint-disable class-methods-use-this */
var ProxyConnectionRequestSerializerV2 = /*#__PURE__*/function (_Serializer) {
  _inherits(ProxyConnectionRequestSerializerV2, _Serializer);
  var _super = _createSuper(ProxyConnectionRequestSerializerV2);
  function ProxyConnectionRequestSerializerV2() {
    _classCallCheck(this, ProxyConnectionRequestSerializerV2);
    return _super.apply(this, arguments);
  }
  _createClass(ProxyConnectionRequestSerializerV2, [{
    key: "toArray",
    value: function toArray(proxyConnectionRequest) {
      return [VERSION, _ControlMessage.default.TYPES.ProxyConnectionRequest, proxyConnectionRequest.requestId, proxyConnectionRequest.streamId, proxyConnectionRequest.streamPartition, proxyConnectionRequest.senderId, proxyConnectionRequest.direction, proxyConnectionRequest.userId];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 8),
        version = _arr2[0],
        __type = _arr2[1],
        requestId = _arr2[2],
        streamId = _arr2[3],
        streamPartition = _arr2[4],
        senderId = _arr2[5],
        direction = _arr2[6],
        userId = _arr2[7];
      return new _ProxyConnectionRequest.default({
        version: version,
        requestId: requestId,
        streamId: (0, _StreamID.toStreamID)(streamId),
        streamPartition: streamPartition,
        senderId: senderId,
        direction: direction,
        userId: userId
      });
    }
  }]);
  return ProxyConnectionRequestSerializerV2;
}(_Serializer2.Serializer);
exports["default"] = ProxyConnectionRequestSerializerV2;
_ControlMessage.default.registerSerializer(VERSION, _ControlMessage.default.TYPES.ProxyConnectionRequest, new ProxyConnectionRequestSerializerV2());
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/control_layer/proxy_connection_response/ProxyConnectionResponse.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _ControlMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _StreamPartID = __webpack_require__("../protocol/src/utils/StreamPartID.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ProxyConnectionResponse = /*#__PURE__*/function (_ControlMessage) {
  _inherits(ProxyConnectionResponse, _ControlMessage);
  var _super = _createSuper(ProxyConnectionResponse);
  function ProxyConnectionResponse(_ref) {
    var _this;
    var _ref$version = _ref.version,
      version = _ref$version === void 0 ? _ControlMessage2.default.LATEST_VERSION : _ref$version,
      requestId = _ref.requestId,
      senderId = _ref.senderId,
      streamId = _ref.streamId,
      streamPartition = _ref.streamPartition,
      direction = _ref.direction,
      accepted = _ref.accepted;
    _classCallCheck(this, ProxyConnectionResponse);
    _this = _super.call(this, version, _ControlMessage2.default.TYPES.ProxyConnectionResponse, requestId);
    (0, _validations.validateIsNotNullOrUndefined)('senderId', senderId);
    _this.senderId = senderId;
    (0, _validations.validateIsString)('streamId', streamId);
    _this.streamId = streamId;
    (0, _validations.validateIsInteger)('streamPartition', streamPartition);
    _this.streamPartition = streamPartition;
    (0, _validations.validateIsNotNullOrUndefined)('accepted', accepted);
    _this.accepted = accepted;
    (0, _validations.validateIsDirection)('direction', direction);
    _this.direction = direction;
    return _this;
  }
  _createClass(ProxyConnectionResponse, [{
    key: "getStreamPartID",
    value: function getStreamPartID() {
      return (0, _StreamPartID.toStreamPartID)(this.streamId, this.streamPartition);
    }
  }]);
  return ProxyConnectionResponse;
}(_ControlMessage2.default);
exports["default"] = ProxyConnectionResponse;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/control_layer/proxy_connection_response/ProxyConnectionResponseSerializerV2.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _ControlMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
var _ProxyConnectionResponse = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/proxy_connection_response/ProxyConnectionResponse.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
var _StreamID = __webpack_require__("../protocol/src/utils/StreamID.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 2;

/* eslint-disable class-methods-use-this */
var ProxyConnectionResponseSerializerV2 = /*#__PURE__*/function (_Serializer) {
  _inherits(ProxyConnectionResponseSerializerV2, _Serializer);
  var _super = _createSuper(ProxyConnectionResponseSerializerV2);
  function ProxyConnectionResponseSerializerV2() {
    _classCallCheck(this, ProxyConnectionResponseSerializerV2);
    return _super.apply(this, arguments);
  }
  _createClass(ProxyConnectionResponseSerializerV2, [{
    key: "toArray",
    value: function toArray(proxyConnectionResponse) {
      return [VERSION, _ControlMessage.default.TYPES.ProxyConnectionResponse, proxyConnectionResponse.requestId, proxyConnectionResponse.streamId, proxyConnectionResponse.streamPartition, proxyConnectionResponse.senderId, proxyConnectionResponse.direction, proxyConnectionResponse.accepted];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 8),
        version = _arr2[0],
        _type = _arr2[1],
        requestId = _arr2[2],
        streamId = _arr2[3],
        streamPartition = _arr2[4],
        senderId = _arr2[5],
        direction = _arr2[6],
        accepted = _arr2[7];
      return new _ProxyConnectionResponse.default({
        version: version,
        requestId: requestId,
        streamId: (0, _StreamID.toStreamID)(streamId),
        streamPartition: streamPartition,
        senderId: senderId,
        direction: direction,
        accepted: accepted
      });
    }
  }]);
  return ProxyConnectionResponseSerializerV2;
}(_Serializer2.Serializer);
exports["default"] = ProxyConnectionResponseSerializerV2;
_ControlMessage.default.registerSerializer(VERSION, _ControlMessage.default.TYPES.ProxyConnectionResponse, new ProxyConnectionResponseSerializerV2());
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/control_layer/unsubscribe_request/UnsubscribeRequest.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _ControlMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
var _StreamPartID = __webpack_require__("../protocol/src/utils/StreamPartID.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var UnsubscribeRequest = /*#__PURE__*/function (_ControlMessage) {
  _inherits(UnsubscribeRequest, _ControlMessage);
  var _super = _createSuper(UnsubscribeRequest);
  function UnsubscribeRequest(_ref) {
    var _this;
    var _ref$version = _ref.version,
      version = _ref$version === void 0 ? _ControlMessage2.default.LATEST_VERSION : _ref$version,
      requestId = _ref.requestId,
      streamId = _ref.streamId,
      streamPartition = _ref.streamPartition;
    _classCallCheck(this, UnsubscribeRequest);
    _this = _super.call(this, version, _ControlMessage2.default.TYPES.UnsubscribeRequest, requestId);
    (0, _validations.validateIsNotEmptyString)('streamId', streamId);
    (0, _validations.validateIsNotNegativeInteger)('streamPartition', streamPartition);
    _this.streamId = streamId;
    _this.streamPartition = streamPartition;
    return _this;
  }
  _createClass(UnsubscribeRequest, [{
    key: "getStreamPartID",
    value: function getStreamPartID() {
      return (0, _StreamPartID.toStreamPartID)(this.streamId, this.streamPartition);
    }
  }]);
  return UnsubscribeRequest;
}(_ControlMessage2.default);
exports["default"] = UnsubscribeRequest;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/control_layer/unsubscribe_request/UnsubscribeRequestSerializerV2.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _ControlMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/ControlMessage.ts"));
var _UnsubscribeRequest = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/control_layer/unsubscribe_request/UnsubscribeRequest.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
var _StreamID = __webpack_require__("../protocol/src/utils/StreamID.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 2;

/* eslint-disable class-methods-use-this */
var UnsubscribeRequestSerializerV2 = /*#__PURE__*/function (_Serializer) {
  _inherits(UnsubscribeRequestSerializerV2, _Serializer);
  var _super = _createSuper(UnsubscribeRequestSerializerV2);
  function UnsubscribeRequestSerializerV2() {
    _classCallCheck(this, UnsubscribeRequestSerializerV2);
    return _super.apply(this, arguments);
  }
  _createClass(UnsubscribeRequestSerializerV2, [{
    key: "toArray",
    value: function toArray(unsubscribeRequest) {
      return [VERSION, _ControlMessage.default.TYPES.UnsubscribeRequest, unsubscribeRequest.requestId, unsubscribeRequest.streamId, unsubscribeRequest.streamPartition];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 5),
        version = _arr2[0],
        _type = _arr2[1],
        requestId = _arr2[2],
        streamId = _arr2[3],
        streamPartition = _arr2[4];
      return new _UnsubscribeRequest.default({
        version: version,
        requestId: requestId,
        streamId: (0, _StreamID.toStreamID)(streamId),
        streamPartition: streamPartition
      });
    }
  }]);
  return UnsubscribeRequestSerializerV2;
}(_Serializer2.Serializer);
exports["default"] = UnsubscribeRequestSerializerV2;
_ControlMessage.default.registerSerializer(VERSION, _ControlMessage.default.TYPES.UnsubscribeRequest, new UnsubscribeRequestSerializerV2());
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/message_layer/EncryptedGroupKey.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/** @internal */
var EncryptedGroupKey = /*#__PURE__*/function () {
  /**
   * A pair (groupKeyId, encryptedGroupKey) where the encryptedGroupKey is an encrypted, hex-encoded version of the group key.
   * @param groupKeyId
   * @param encryptedGroupKeyHex
   * @param serialized Optional. If given, this exact string is returned from serialize().
   */
  function EncryptedGroupKey(groupKeyId, encryptedGroupKeyHex) {
    var serialized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    _classCallCheck(this, EncryptedGroupKey);
    (0, _validations.validateIsString)('groupKeyId', groupKeyId);
    this.groupKeyId = groupKeyId;
    (0, _validations.validateIsString)('encryptedGroupKeyHex', encryptedGroupKeyHex);
    this.encryptedGroupKeyHex = encryptedGroupKeyHex;
    (0, _validations.validateIsString)('serialized', serialized, true);
    this.serialized = serialized;
  }

  /** @internal */
  _createClass(EncryptedGroupKey, [{
    key: "toArray",
    value: function toArray() {
      return [this.groupKeyId, this.encryptedGroupKeyHex];
    }
  }, {
    key: "serialize",
    value: function serialize() {
      // Return the cached serialized form to ensure that it stays unchanged (important for validation)
      if (this.serialized) {
        return this.serialized;
      }
      return JSON.stringify(this.toArray());
    }
  }], [{
    key: "deserialize",
    value: function deserialize(json) {
      var _JSON$parse = JSON.parse(json),
        _JSON$parse2 = _slicedToArray(_JSON$parse, 2),
        groupKeyId = _JSON$parse2[0],
        encryptedGroupKeyHex = _JSON$parse2[1];
      return new EncryptedGroupKey(groupKeyId, encryptedGroupKeyHex, json);
    }

    /** @internal */
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 2),
        groupKeyId = _arr2[0],
        encryptedGroupKeyHex = _arr2[1];
      return new EncryptedGroupKey(groupKeyId, encryptedGroupKeyHex);
    }
  }]);
  return EncryptedGroupKey;
}();
exports["default"] = EncryptedGroupKey;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/message_layer/GroupKeyMessage.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _ValidationError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/ValidationError.ts"));
var _StreamMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/StreamMessage.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// TODO refactor deserialization to separate class (Serializer<GroupKeyMessage>)
//
// remove new, don't care about how to construct since we have from/to methods
var GroupKeyMessage = /*#__PURE__*/function () {
  function GroupKeyMessage(recipient, messageType) {
    _classCallCheck(this, GroupKeyMessage);
    (0, _validations.validateIsString)('recipient', recipient);
    this.recipient = recipient;
    _StreamMessage.default.validateMessageType(messageType);
    this.messageType = messageType;
  }
  _createClass(GroupKeyMessage, [{
    key: "serialize",
    value: function serialize() {
      return JSON.stringify(this.toArray());
    }
  }], [{
    key: "deserialize",
    value: function deserialize(serialized, messageType) {
      if (!GroupKeyMessage.classByMessageType[messageType]) {
        throw new _ValidationError.default("Unknown MessageType: ".concat(messageType));
      }
      return GroupKeyMessage.classByMessageType[messageType].fromArray(JSON.parse(serialized));
    }
  }, {
    key: "fromStreamMessage",
    value: function fromStreamMessage(streamMessage) {
      return GroupKeyMessage.deserialize(streamMessage.getSerializedContent(), streamMessage.messageType);
    }
  }, {
    key: "fromArray",
    value: function fromArray(_arr) {
      // typescript doesn't support abstract static so have to do this
      throw new Error('must be overridden');
    }
  }]);
  return GroupKeyMessage;
}();
exports["default"] = GroupKeyMessage;
// messageType -> class mapping
_defineProperty(GroupKeyMessage, "classByMessageType", {});
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/message_layer/GroupKeyRequest.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _GroupKeyMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/GroupKeyMessage.ts"));
var _StreamMessage = __webpack_require__("../protocol/src/protocol/message_layer/StreamMessage.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var GroupKeyRequest = /*#__PURE__*/function (_GroupKeyMessage) {
  _inherits(GroupKeyRequest, _GroupKeyMessage);
  var _super = _createSuper(GroupKeyRequest);
  function GroupKeyRequest(_ref) {
    var _this;
    var requestId = _ref.requestId,
      recipient = _ref.recipient,
      rsaPublicKey = _ref.rsaPublicKey,
      groupKeyIds = _ref.groupKeyIds;
    _classCallCheck(this, GroupKeyRequest);
    _this = _super.call(this, recipient, _StreamMessage.StreamMessageType.GROUP_KEY_REQUEST);
    (0, _validations.validateIsString)('requestId', requestId);
    _this.requestId = requestId;
    (0, _validations.validateIsString)('rsaPublicKey', rsaPublicKey);
    _this.rsaPublicKey = rsaPublicKey;
    (0, _validations.validateIsArray)('groupKeyIds', groupKeyIds);
    _this.groupKeyIds = groupKeyIds;
    return _this;
  }
  _createClass(GroupKeyRequest, [{
    key: "toArray",
    value: function toArray() {
      return [this.requestId, this.recipient, this.rsaPublicKey, this.groupKeyIds];
    }
  }], [{
    key: "fromArray",
    value: function fromArray(args) {
      var _args = _slicedToArray(args, 4),
        requestId = _args[0],
        recipient = _args[1],
        rsaPublicKey = _args[2],
        groupKeyIds = _args[3];
      return new GroupKeyRequest({
        requestId: requestId,
        recipient: (0, _utils.toEthereumAddress)(recipient),
        rsaPublicKey: rsaPublicKey,
        groupKeyIds: groupKeyIds
      });
    }
  }, {
    key: "is",
    value: function is(streamMessage) {
      return streamMessage.messageType === _StreamMessage.StreamMessageType.GROUP_KEY_REQUEST;
    }
  }]);
  return GroupKeyRequest;
}(_GroupKeyMessage2.default);
exports["default"] = GroupKeyRequest;
_GroupKeyMessage2.default.classByMessageType[_StreamMessage.StreamMessageType.GROUP_KEY_REQUEST] = GroupKeyRequest;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/message_layer/GroupKeyResponse.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _ValidationError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/ValidationError.ts"));
var _StreamMessage = __webpack_require__("../protocol/src/protocol/message_layer/StreamMessage.ts");
var _GroupKeyMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/GroupKeyMessage.ts"));
var _EncryptedGroupKey = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/EncryptedGroupKey.ts"));
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } /** @internal */
var GroupKeyResponse = /*#__PURE__*/function (_GroupKeyMessage) {
  _inherits(GroupKeyResponse, _GroupKeyMessage);
  var _super = _createSuper(GroupKeyResponse);
  function GroupKeyResponse(_ref) {
    var _this;
    var requestId = _ref.requestId,
      recipient = _ref.recipient,
      encryptedGroupKeys = _ref.encryptedGroupKeys;
    _classCallCheck(this, GroupKeyResponse);
    _this = _super.call(this, recipient, _StreamMessage.StreamMessageType.GROUP_KEY_RESPONSE);
    (0, _validations.validateIsString)('requestId', requestId);
    _this.requestId = requestId;
    (0, _validations.validateIsArray)('encryptedGroupKeys', encryptedGroupKeys);
    _this.encryptedGroupKeys = encryptedGroupKeys;

    // Validate content of encryptedGroupKeys
    _this.encryptedGroupKeys.forEach(function (it) {
      if (!(it instanceof _EncryptedGroupKey.default)) {
        throw new _ValidationError.default("Expected 'encryptedGroupKeys' to be a list of EncryptedGroupKey instances! Was: ".concat(_this.encryptedGroupKeys));
      }
    });
    return _this;
  }
  _createClass(GroupKeyResponse, [{
    key: "toArray",
    value: function toArray() {
      return [this.requestId, this.recipient, this.encryptedGroupKeys.map(function (it) {
        return it.toArray();
      })];
    }
  }], [{
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 3),
        requestId = _arr2[0],
        recipient = _arr2[1],
        encryptedGroupKeys = _arr2[2];
      return new GroupKeyResponse({
        requestId: requestId,
        recipient: (0, _utils.toEthereumAddress)(recipient),
        encryptedGroupKeys: encryptedGroupKeys.map(function (it) {
          return _EncryptedGroupKey.default.fromArray(it);
        })
      });
    }
  }, {
    key: "is",
    value: function is(streamMessage) {
      return streamMessage.messageType === _StreamMessage.StreamMessageType.GROUP_KEY_RESPONSE;
    }
  }]);
  return GroupKeyResponse;
}(_GroupKeyMessage2.default);
exports["default"] = GroupKeyResponse;
_GroupKeyMessage2.default.classByMessageType[_StreamMessage.StreamMessageType.GROUP_KEY_RESPONSE] = GroupKeyResponse;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/message_layer/MessageID.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _MessageRef = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/MessageRef.ts"));
var _StreamID = __webpack_require__("../protocol/src/utils/StreamID.ts");
var _StreamPartID = __webpack_require__("../protocol/src/utils/StreamPartID.ts");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/** @internal */
var MessageID = /*#__PURE__*/function () {
  function MessageID(streamId, streamPartition, timestamp, sequenceNumber, publisherId, msgChainId) {
    _classCallCheck(this, MessageID);
    (0, _validations.validateIsNotEmptyString)('streamId', streamId);
    (0, _validations.validateIsNotNegativeInteger)('streamPartition', streamPartition);
    (0, _validations.validateIsNotNegativeInteger)('timestamp', timestamp);
    (0, _validations.validateIsNotNegativeInteger)('sequenceNumber', sequenceNumber);
    (0, _validations.validateIsString)('publisherId', publisherId);
    (0, _validations.validateIsString)('msgChainId', msgChainId);
    this.streamId = streamId;
    this.streamPartition = streamPartition;
    this.timestamp = timestamp;
    this.sequenceNumber = sequenceNumber;
    this.publisherId = publisherId;
    this.msgChainId = msgChainId;
  }

  /** @internal */
  _createClass(MessageID, [{
    key: "toArray",
    value: function toArray() {
      return [this.streamId, this.streamPartition, this.timestamp, this.sequenceNumber, this.publisherId, this.msgChainId];
    }

    /** @internal */
  }, {
    key: "getStreamPartID",
    value: function getStreamPartID() {
      return (0, _StreamPartID.toStreamPartID)(this.streamId, this.streamPartition);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return JSON.stringify(this.toArray());
    }
  }, {
    key: "toMessageRef",
    value: function toMessageRef() {
      return new _MessageRef.default(this.timestamp, this.sequenceNumber);
    }
  }, {
    key: "clone",
    value: function clone() {
      return _construct(MessageID, _toConsumableArray(this.toArray()));
    }
  }], [{
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 6),
        streamId = _arr2[0],
        streamPartition = _arr2[1],
        timestamp = _arr2[2],
        sequenceNumber = _arr2[3],
        publisherId = _arr2[4],
        msgChainId = _arr2[5];
      return new MessageID((0, _StreamID.toStreamID)(streamId), streamPartition, timestamp, sequenceNumber, (0, _utils.toEthereumAddress)(publisherId), msgChainId);
    }
  }]);
  return MessageID;
}();
exports["default"] = MessageID;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/message_layer/MessageRef.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var MessageRef = /*#__PURE__*/function () {
  function MessageRef(timestamp, sequenceNumber) {
    _classCallCheck(this, MessageRef);
    (0, _validations.validateIsNotNegativeInteger)('timestamp', timestamp);
    (0, _validations.validateIsNotNegativeInteger)('sequenceNumber', sequenceNumber, true);
    this.timestamp = timestamp;
    this.sequenceNumber = sequenceNumber;
  }
  _createClass(MessageRef, [{
    key: "compareTo",
    value: function compareTo(other) {
      if (this.timestamp < other.timestamp) {
        return -1;
      }
      if (this.timestamp > other.timestamp) {
        return 1;
      }
      if (this.sequenceNumber < other.sequenceNumber) {
        return -1;
      }
      if (this.sequenceNumber > other.sequenceNumber) {
        return 1;
      }
      return 0;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return [this.timestamp, this.sequenceNumber];
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return JSON.stringify(this.toArray());
    }
  }, {
    key: "clone",
    value: function clone() {
      return new MessageRef(this.timestamp, this.sequenceNumber);
    }
  }], [{
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 2),
        timestamp = _arr2[0],
        sequenceNumber = _arr2[1];
      return new MessageRef(timestamp, sequenceNumber);
    }
  }]);
  return MessageRef;
}();
exports["default"] = MessageRef;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/message_layer/StreamMessage.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.StreamMessageType = exports.EncryptionType = exports.ContentType = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.parse-int.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
var _InvalidJsonError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/InvalidJsonError.ts"));
var _StreamMessageError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/StreamMessageError.ts"));
var _ValidationError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/ValidationError.ts"));
var _UnsupportedVersionError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/UnsupportedVersionError.ts"));
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _MessageRef = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/MessageRef.ts"));
var _MessageID = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/MessageID.ts"));
var _EncryptedGroupKey = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/EncryptedGroupKey.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var serializerByVersion = {};
var LATEST_VERSION = 32;
var StreamMessageType = /*#__PURE__*/function (StreamMessageType) {
  StreamMessageType[StreamMessageType["MESSAGE"] = 27] = "MESSAGE";
  StreamMessageType[StreamMessageType["GROUP_KEY_REQUEST"] = 28] = "GROUP_KEY_REQUEST";
  StreamMessageType[StreamMessageType["GROUP_KEY_RESPONSE"] = 29] = "GROUP_KEY_RESPONSE";
  return StreamMessageType;
}({});
exports.StreamMessageType = StreamMessageType;
var ContentType = /*#__PURE__*/function (ContentType) {
  ContentType[ContentType["JSON"] = 0] = "JSON";
  return ContentType;
}({});
exports.ContentType = ContentType;
var EncryptionType = /*#__PURE__*/function (EncryptionType) {
  EncryptionType[EncryptionType["NONE"] = 0] = "NONE";
  EncryptionType[EncryptionType["RSA"] = 1] = "RSA";
  EncryptionType[EncryptionType["AES"] = 2] = "AES";
  return EncryptionType;
}({});
/**
 * Encrypted StreamMessage.
 */
exports.EncryptionType = EncryptionType;
var StreamMessage = /*#__PURE__*/function () {
  function StreamMessage(_ref) {
    var messageId = _ref.messageId,
      _ref$prevMsgRef = _ref.prevMsgRef,
      prevMsgRef = _ref$prevMsgRef === void 0 ? null : _ref$prevMsgRef,
      content = _ref.content,
      _ref$messageType = _ref.messageType,
      messageType = _ref$messageType === void 0 ? StreamMessageType.MESSAGE : _ref$messageType,
      _ref$contentType = _ref.contentType,
      contentType = _ref$contentType === void 0 ? ContentType.JSON : _ref$contentType,
      _ref$encryptionType = _ref.encryptionType,
      encryptionType = _ref$encryptionType === void 0 ? EncryptionType.NONE : _ref$encryptionType,
      _ref$groupKeyId = _ref.groupKeyId,
      groupKeyId = _ref$groupKeyId === void 0 ? null : _ref$groupKeyId,
      _ref$newGroupKey = _ref.newGroupKey,
      newGroupKey = _ref$newGroupKey === void 0 ? null : _ref$newGroupKey,
      signature = _ref.signature;
    _classCallCheck(this, StreamMessage);
    (0, _validations.validateIsType)('messageId', messageId, 'MessageID', _MessageID.default);
    this.messageId = messageId;
    (0, _validations.validateIsType)('prevMsgRef', prevMsgRef, 'MessageRef', _MessageRef.default, true);
    this.prevMsgRef = prevMsgRef;
    StreamMessage.validateMessageType(messageType);
    this.messageType = messageType;
    StreamMessage.validateContentType(contentType);
    this.contentType = contentType;
    StreamMessage.validateEncryptionType(encryptionType);
    this.encryptionType = encryptionType;
    (0, _validations.validateIsString)('groupKeyId', groupKeyId, this.encryptionType !== EncryptionType.AES);
    this.groupKeyId = groupKeyId;
    (0, _validations.validateIsType)('newGroupKey', newGroupKey, 'EncryptedGroupKey', _EncryptedGroupKey.default, true);
    this.newGroupKey = newGroupKey;
    (0, _validations.validateIsString)('signature', signature, false);
    this.signature = signature;
    if (typeof content === 'string') {
      // this.parsedContent gets written lazily
      this.serializedContent = content;
    } else {
      this.parsedContent = content;
      this.serializedContent = JSON.stringify(content);
    }
    (0, _validations.validateIsNotEmptyString)('content', this.serializedContent);
    StreamMessage.validateSequence(this);
  }
  _createClass(StreamMessage, [{
    key: "clone",
    value:
    /**
     * Create a new StreamMessage identical to the passed-in streamMessage.
     */
    function clone() {
      var content = this.encryptionType === EncryptionType.NONE ? this.getParsedContent() : this.getSerializedContent();
      return new StreamMessage({
        messageId: this.messageId.clone(),
        prevMsgRef: this.prevMsgRef ? this.prevMsgRef.clone() : null,
        content: content,
        messageType: this.messageType,
        contentType: this.contentType,
        encryptionType: this.encryptionType,
        groupKeyId: this.groupKeyId,
        newGroupKey: this.newGroupKey,
        signature: this.signature
      });
    }
  }, {
    key: "getStreamId",
    value: function getStreamId() {
      return this.messageId.streamId;
    }
  }, {
    key: "getStreamPartition",
    value: function getStreamPartition() {
      return this.messageId.streamPartition;
    }
  }, {
    key: "getStreamPartID",
    value: function getStreamPartID() {
      return this.messageId.getStreamPartID();
    }
  }, {
    key: "getTimestamp",
    value: function getTimestamp() {
      return this.messageId.timestamp;
    }
  }, {
    key: "getSequenceNumber",
    value: function getSequenceNumber() {
      return this.messageId.sequenceNumber;
    }
  }, {
    key: "getPublisherId",
    value: function getPublisherId() {
      return this.messageId.publisherId;
    }
  }, {
    key: "getMsgChainId",
    value: function getMsgChainId() {
      return this.messageId.msgChainId;
    }
  }, {
    key: "getMessageRef",
    value: function getMessageRef() {
      return new _MessageRef.default(this.getTimestamp(), this.getSequenceNumber());
    }
  }, {
    key: "getPreviousMessageRef",
    value: function getPreviousMessageRef() {
      return this.prevMsgRef;
    }
  }, {
    key: "getMessageID",
    value: function getMessageID() {
      return this.messageId;
    }
  }, {
    key: "getSerializedContent",
    value: function getSerializedContent() {
      return this.serializedContent;
    }

    /**
     * Lazily parses the content to JSON
     */
  }, {
    key: "getParsedContent",
    value: function getParsedContent() {
      if (this.parsedContent == null) {
        // Don't try to parse encrypted messages
        if (this.messageType === StreamMessageType.MESSAGE && this.encryptionType !== EncryptionType.NONE) {
          // @ts-expect-error need type narrowing for encrypted vs unencrypted
          return this.serializedContent;
        }
        if (this.contentType === ContentType.JSON) {
          try {
            this.parsedContent = JSON.parse(this.serializedContent);
          } catch (err) {
            throw new _InvalidJsonError.default(this.getStreamId(), err, this);
          }
        } else {
          throw new _StreamMessageError.default("Unsupported contentType for getParsedContent: ".concat(this.contentType), this);
        }
      }

      // should be expected type by here
      return this.parsedContent;
    }
  }, {
    key: "getContent",
    value: function getContent() {
      var parsedContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (parsedContent) {
        return this.getParsedContent();
      }
      return this.getSerializedContent();
    }
  }, {
    key: "getNewGroupKey",
    value: function getNewGroupKey() {
      return this.newGroupKey;
    }

    /** @internal */
  }, {
    key: "serialize",
    value: function serialize() {
      var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LATEST_VERSION;
      var serializer = StreamMessage.getSerializer(version);
      return JSON.stringify(serializer.toArray(this));
    }

    /**
     * Takes a serialized representation (array or string) of a message, and returns a StreamMessage instance.
     */
  }], [{
    key: "registerSerializer",
    value: function registerSerializer(version, serializer) {
      // Check the serializer interface
      if (!serializer.fromArray) {
        throw new Error("Serializer ".concat(JSON.stringify(serializer), " doesn't implement a method fromArray!"));
      }
      if (!serializer.toArray) {
        throw new Error("Serializer ".concat(JSON.stringify(serializer), " doesn't implement a method toArray!"));
      }
      if (serializerByVersion[version] !== undefined) {
        throw new Error("Serializer for version ".concat(version, " is already registered: ").concat(JSON.stringify(serializerByVersion[version])));
      }
      serializerByVersion[version] = serializer;
    }

    /** @internal */
  }, {
    key: "unregisterSerializer",
    value: function unregisterSerializer(version) {
      delete serializerByVersion[version];
    }

    /** @internal */
  }, {
    key: "getSerializer",
    value: function getSerializer(version) {
      var clazz = serializerByVersion[version];
      if (!clazz) {
        throw new _UnsupportedVersionError.default(version, "Supported versions: [".concat(StreamMessage.getSupportedVersions(), "]"));
      }
      return clazz;
    }
  }, {
    key: "getSupportedVersions",
    value: function getSupportedVersions() {
      return Object.keys(serializerByVersion).map(function (key) {
        return parseInt(key, 10);
      });
    }
  }, {
    key: "deserialize",
    value: function deserialize(msg) {
      var messageArray = typeof msg === 'string' ? JSON.parse(msg) : msg;
      var messageVersion = messageArray[0];
      var C = StreamMessage.getSerializer(messageVersion);
      return C.fromArray(messageArray);
    }
  }, {
    key: "validateMessageType",
    value: function validateMessageType(messageType) {
      if (!StreamMessage.VALID_MESSAGE_TYPES.has(messageType)) {
        throw new _ValidationError.default("Unsupported message type: ".concat(messageType));
      }
    }
  }, {
    key: "validateContentType",
    value: function validateContentType(contentType) {
      if (!StreamMessage.VALID_CONTENT_TYPES.has(contentType)) {
        throw new _ValidationError.default("Unsupported content type: ".concat(contentType));
      }
    }
  }, {
    key: "validateEncryptionType",
    value: function validateEncryptionType(encryptionType) {
      if (!StreamMessage.VALID_ENCRYPTIONS.has(encryptionType)) {
        throw new _ValidationError.default("Unsupported encryption type: ".concat(encryptionType));
      }
    }
  }, {
    key: "versionSupportsEncryption",
    value: function versionSupportsEncryption(streamMessageVersion) {
      return streamMessageVersion >= 31;
    }
  }, {
    key: "validateSequence",
    value: function validateSequence(_ref2) {
      var messageId = _ref2.messageId,
        prevMsgRef = _ref2.prevMsgRef;
      if (!prevMsgRef) {
        return;
      }
      var comparison = messageId.toMessageRef().compareTo(prevMsgRef);

      // cannot have same timestamp + sequence
      if (comparison === 0) {
        throw new _ValidationError.default("prevMessageRef cannot be identical to current. Current: ".concat(messageId.toMessageRef().toArray(), " Previous: ").concat(prevMsgRef.toArray()));
      }

      // previous cannot be newer
      if (comparison < 0) {
        throw new _ValidationError.default("prevMessageRef must come before current. Current: ".concat(messageId.toMessageRef().toArray(), " Previous: ").concat(prevMsgRef.toArray()));
      }
    }
  }, {
    key: "isAESEncrypted",
    value: function isAESEncrypted(msg) {
      return msg.encryptionType === EncryptionType.AES;
    }
  }]);
  return StreamMessage;
}();
exports["default"] = StreamMessage;
_defineProperty(StreamMessage, "LATEST_VERSION", LATEST_VERSION);
_defineProperty(StreamMessage, "VALID_MESSAGE_TYPES", new Set(Object.values(StreamMessageType)));
_defineProperty(StreamMessage, "VALID_CONTENT_TYPES", new Set(Object.values(ContentType)));
_defineProperty(StreamMessage, "VALID_ENCRYPTIONS", new Set(Object.values(EncryptionType)));

/***/ }),

/***/ "../protocol/src/protocol/message_layer/StreamMessageSerializerV32.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.SIGNATURE_TYPE_ETH = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _StreamMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/StreamMessage.ts"));
var _MessageRef = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/MessageRef.ts"));
var _MessageID = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/MessageID.ts"));
var _EncryptedGroupKey = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/EncryptedGroupKey.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
var _ValidationError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/ValidationError.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 32;
var SIGNATURE_TYPE_ETH = 2;

/* eslint-disable class-methods-use-this */
exports.SIGNATURE_TYPE_ETH = SIGNATURE_TYPE_ETH;
var StreamMessageSerializerV32 = /*#__PURE__*/function (_Serializer) {
  _inherits(StreamMessageSerializerV32, _Serializer);
  var _super = _createSuper(StreamMessageSerializerV32);
  function StreamMessageSerializerV32() {
    _classCallCheck(this, StreamMessageSerializerV32);
    return _super.apply(this, arguments);
  }
  _createClass(StreamMessageSerializerV32, [{
    key: "toArray",
    value: function toArray(streamMessage) {
      return [VERSION, streamMessage.messageId.toArray(), streamMessage.prevMsgRef ? streamMessage.prevMsgRef.toArray() : null, streamMessage.messageType, streamMessage.contentType, streamMessage.encryptionType, streamMessage.groupKeyId, streamMessage.serializedContent, streamMessage.newGroupKey ? streamMessage.newGroupKey.serialize() : null, SIGNATURE_TYPE_ETH, streamMessage.signature];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 11),
        _version = _arr2[0],
        messageIdArr = _arr2[1],
        prevMsgRefArr = _arr2[2],
        messageType = _arr2[3],
        contentType = _arr2[4],
        encryptionType = _arr2[5],
        groupKeyId = _arr2[6],
        serializedContent = _arr2[7],
        serializedNewGroupKey = _arr2[8],
        signatureType = _arr2[9],
        signature = _arr2[10];
      if (signatureType !== SIGNATURE_TYPE_ETH) {
        throw new _ValidationError.default("Unsupported signature type: ".concat(signatureType));
      }
      return new _StreamMessage.default({
        messageId: _MessageID.default.fromArray(messageIdArr),
        prevMsgRef: prevMsgRefArr ? _MessageRef.default.fromArray(prevMsgRefArr) : null,
        content: serializedContent,
        messageType: messageType,
        contentType: contentType,
        encryptionType: encryptionType,
        groupKeyId: groupKeyId,
        newGroupKey: serializedNewGroupKey ? _EncryptedGroupKey.default.deserialize(serializedNewGroupKey) : null,
        signature: signature
      });
    }
  }]);
  return StreamMessageSerializerV32;
}(_Serializer2.Serializer);
exports["default"] = StreamMessageSerializerV32;
_StreamMessage.default.registerSerializer(VERSION, new StreamMessageSerializerV32());

/***/ }),

/***/ "../protocol/src/protocol/message_layer/exports.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-map.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _exportNames = {
  MessageID: true,
  MessageRef: true,
  StreamMessage: true,
  StreamMessageAESEncrypted: true,
  StreamMessageType: true,
  GroupKeyRequest: true,
  GroupKeyRequestSerialized: true,
  GroupKeyResponse: true,
  GroupKeyResponseSerialized: true,
  EncryptedGroupKey: true,
  createSignaturePayload: true,
  GroupKeyMessage: true
};
Object.defineProperty(exports, "EncryptedGroupKey", ({
  enumerable: true,
  get: function get() {
    return _EncryptedGroupKey.default;
  }
}));
Object.defineProperty(exports, "GroupKeyMessage", ({
  enumerable: true,
  get: function get() {
    return _GroupKeyMessage.default;
  }
}));
Object.defineProperty(exports, "GroupKeyRequest", ({
  enumerable: true,
  get: function get() {
    return _GroupKeyRequest.default;
  }
}));
Object.defineProperty(exports, "GroupKeyRequestSerialized", ({
  enumerable: true,
  get: function get() {
    return _GroupKeyRequest.GroupKeyRequestSerialized;
  }
}));
Object.defineProperty(exports, "GroupKeyResponse", ({
  enumerable: true,
  get: function get() {
    return _GroupKeyResponse.default;
  }
}));
Object.defineProperty(exports, "GroupKeyResponseSerialized", ({
  enumerable: true,
  get: function get() {
    return _GroupKeyResponse.GroupKeyResponseSerialized;
  }
}));
Object.defineProperty(exports, "MessageID", ({
  enumerable: true,
  get: function get() {
    return _MessageID.default;
  }
}));
Object.defineProperty(exports, "MessageRef", ({
  enumerable: true,
  get: function get() {
    return _MessageRef.default;
  }
}));
Object.defineProperty(exports, "StreamMessage", ({
  enumerable: true,
  get: function get() {
    return _StreamMessage.default;
  }
}));
Object.defineProperty(exports, "StreamMessageAESEncrypted", ({
  enumerable: true,
  get: function get() {
    return _StreamMessage.StreamMessageAESEncrypted;
  }
}));
Object.defineProperty(exports, "StreamMessageType", ({
  enumerable: true,
  get: function get() {
    return _StreamMessage.StreamMessageType;
  }
}));
Object.defineProperty(exports, "createSignaturePayload", ({
  enumerable: true,
  get: function get() {
    return _signature.createSignaturePayload;
  }
}));
var _MessageID = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/MessageID.ts"));
var _MessageRef = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/MessageRef.ts"));
var _StreamMessage = _interopRequireWildcard(__webpack_require__("../protocol/src/protocol/message_layer/StreamMessage.ts"));
Object.keys(_StreamMessage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StreamMessage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StreamMessage[key];
    }
  });
});
var _GroupKeyRequest = _interopRequireWildcard(__webpack_require__("../protocol/src/protocol/message_layer/GroupKeyRequest.ts"));
var _GroupKeyResponse = _interopRequireWildcard(__webpack_require__("../protocol/src/protocol/message_layer/GroupKeyResponse.ts"));
var _EncryptedGroupKey = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/EncryptedGroupKey.ts"));
var _signature = __webpack_require__("../protocol/src/protocol/message_layer/signature.ts");
__webpack_require__("../protocol/src/protocol/message_layer/StreamMessageSerializerV32.ts");
var _GroupKeyMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/message_layer/GroupKeyMessage.ts"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "../protocol/src/protocol/message_layer/signature.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createSignaturePayload = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
var createSignaturePayload = function createSignaturePayload(opts) {
  var prev = opts.prevMsgRef !== undefined ? "".concat(opts.prevMsgRef.timestamp).concat(opts.prevMsgRef.sequenceNumber) : '';
  var newGroupKey = opts.newGroupKey !== undefined ? opts.newGroupKey.serialize() : '';
  return "".concat(opts.messageId.streamId).concat(opts.messageId.streamPartition).concat(opts.messageId.timestamp).concat(opts.messageId.sequenceNumber) + "".concat(opts.messageId.publisherId).concat(opts.messageId.msgChainId).concat(prev).concat(opts.serializedContent).concat(newGroupKey);
};
exports.createSignaturePayload = createSignaturePayload;

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/Originator.ts":
/***/ (() => {

"use strict";


/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/TrackerMessage.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.TrackerMessageType = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.parse-int.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _UnsupportedVersionError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/UnsupportedVersionError.ts"));
var _UnsupportedTypeError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/UnsupportedTypeError.ts"));
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// TODO use ControlMessageType instead of number when we have real enums
var serializerByVersionAndType = {};
var LATEST_VERSION = 2;
var TrackerMessageType = /*#__PURE__*/function (TrackerMessageType) {
  TrackerMessageType[TrackerMessageType["StatusMessage"] = 1] = "StatusMessage";
  TrackerMessageType[TrackerMessageType["InstructionMessage"] = 2] = "InstructionMessage";
  TrackerMessageType[TrackerMessageType["RelayMessage"] = 5] = "RelayMessage";
  TrackerMessageType[TrackerMessageType["ErrorMessage"] = 6] = "ErrorMessage";
  TrackerMessageType[TrackerMessageType["StatusAckMessage"] = 7] = "StatusAckMessage";
  return TrackerMessageType;
}({});
exports.TrackerMessageType = TrackerMessageType;
var TrackerMessage = /*#__PURE__*/function () {
  // TODO can we remove this and use the enum object directly?

  // eslint-disable-next-line @typescript-eslint/default-param-last
  function TrackerMessage() {
    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LATEST_VERSION;
    var type = arguments.length > 1 ? arguments[1] : undefined;
    var requestId = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, TrackerMessage);
    if ((this instanceof TrackerMessage ? this.constructor : void 0) === TrackerMessage) {
      throw new TypeError('TrackerMessage is abstract.');
    }
    (0, _validations.validateIsInteger)('version', version);
    (0, _validations.validateIsInteger)('type', type);
    (0, _validations.validateIsString)('requestId', requestId);
    this.version = version;
    this.type = type;
    this.requestId = requestId;
  }
  _createClass(TrackerMessage, [{
    key: "serialize",
    value: function serialize() {
      var _TrackerMessage$getSe;
      var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.version;
      for (var _len = arguments.length, typeSpecificSerializeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        typeSpecificSerializeArgs[_key - 1] = arguments[_key];
      }
      return JSON.stringify((_TrackerMessage$getSe = TrackerMessage.getSerializer(version, this.type)).toArray.apply(_TrackerMessage$getSe, [this].concat(typeSpecificSerializeArgs)));
    }

    /**
     * Takes a serialized representation (array or string) of a message, and returns a ControlMessage instance.
     */
  }], [{
    key: "registerSerializer",
    value: function registerSerializer(version, type, serializer) {
      // Check the serializer interface
      if (!serializer.fromArray) {
        throw new Error("Serializer ".concat(JSON.stringify(serializer), " doesn't implement a method fromArray!"));
      }
      if (!serializer.toArray) {
        throw new Error("Serializer ".concat(JSON.stringify(serializer), " doesn't implement a method toArray!"));
      }
      if (serializerByVersionAndType[version] === undefined) {
        serializerByVersionAndType[version] = {};
      }
      if (serializerByVersionAndType[version][type] !== undefined) {
        throw new Error("Serializer for version ".concat(version, " and type ").concat(type, " is already registered: ").concat(JSON.stringify(serializerByVersionAndType[version][type])));
      }
      serializerByVersionAndType[version][type] = serializer;
    }
  }, {
    key: "unregisterSerializer",
    value: function unregisterSerializer(version, type) {
      delete serializerByVersionAndType[version][type];
    }
  }, {
    key: "getSerializer",
    value: function getSerializer(version, type) {
      var serializersByType = serializerByVersionAndType[version];
      if (!serializersByType) {
        throw new _UnsupportedVersionError.default(version, "Supported versions: [".concat(TrackerMessage.getSupportedVersions(), "]"));
      }
      var clazz = serializersByType[type];
      if (!clazz) {
        throw new _UnsupportedTypeError.default(type, "Supported types: [".concat(Object.keys(serializersByType), "]"));
      }
      return clazz;
    }
  }, {
    key: "getSupportedVersions",
    value: function getSupportedVersions() {
      return Object.keys(serializerByVersionAndType).map(function (key) {
        return parseInt(key, 10);
      });
    }
  }, {
    key: "deserialize",
    value: function deserialize(msg) {
      var messageArray = typeof msg === 'string' ? JSON.parse(msg) : msg;
      var messageVersion = messageArray[0];
      var messageType = messageArray[1];
      var C = TrackerMessage.getSerializer(messageVersion, messageType);
      for (var _len2 = arguments.length, typeSpecificDeserializeArgs = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        typeSpecificDeserializeArgs[_key2 - 1] = arguments[_key2];
      }
      return C.fromArray.apply(C, [messageArray].concat(typeSpecificDeserializeArgs));
    }
  }]);
  return TrackerMessage;
}();
exports["default"] = TrackerMessage;
_defineProperty(TrackerMessage, "LATEST_VERSION", LATEST_VERSION);
_defineProperty(TrackerMessage, "TYPES", TrackerMessageType);

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/error_message/ErrorMessage.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.ErrorCode = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _TrackerMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var ErrorCode = /*#__PURE__*/function (ErrorCode) {
  ErrorCode["UNKNOWN_PEER"] = "RTC_UNKNOWN_PEER";
  return ErrorCode;
}({});
exports.ErrorCode = ErrorCode;
var ErrorMessage = /*#__PURE__*/function (_TrackerMessage) {
  _inherits(ErrorMessage, _TrackerMessage);
  var _super = _createSuper(ErrorMessage);
  // TODO can we remove this and use the enum object directly?

  function ErrorMessage(_ref) {
    var _this;
    var _ref$version = _ref.version,
      version = _ref$version === void 0 ? _TrackerMessage2.default.LATEST_VERSION : _ref$version,
      requestId = _ref.requestId,
      errorCode = _ref.errorCode,
      targetNode = _ref.targetNode;
    _classCallCheck(this, ErrorMessage);
    _this = _super.call(this, version, _TrackerMessage2.default.TYPES.ErrorMessage, requestId);
    (0, _validations.validateIsOneOf)('errorCode', errorCode, Object.values(ErrorMessage.ERROR_CODES));
    (0, _validations.validateIsNotEmptyString)('targetNode', targetNode);
    _this.errorCode = errorCode;
    _this.targetNode = targetNode;
    return _this;
  }
  return _createClass(ErrorMessage);
}(_TrackerMessage2.default);
exports["default"] = ErrorMessage;
_defineProperty(ErrorMessage, "ERROR_CODES", ErrorCode);

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/error_message/ErrorMessageSerializerV2.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _TrackerMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
var _ErrorMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/error_message/ErrorMessage.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 2;

/* eslint-disable class-methods-use-this */
var ErrorMessageSerializerV2 = /*#__PURE__*/function (_Serializer) {
  _inherits(ErrorMessageSerializerV2, _Serializer);
  var _super = _createSuper(ErrorMessageSerializerV2);
  function ErrorMessageSerializerV2() {
    _classCallCheck(this, ErrorMessageSerializerV2);
    return _super.apply(this, arguments);
  }
  _createClass(ErrorMessageSerializerV2, [{
    key: "toArray",
    value: function toArray(errorMessage) {
      return [VERSION, _TrackerMessage.default.TYPES.ErrorMessage, errorMessage.requestId, errorMessage.errorCode, errorMessage.targetNode];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 5),
        version = _arr2[0],
        _type = _arr2[1],
        requestId = _arr2[2],
        errorCode = _arr2[3],
        targetNode = _arr2[4];
      return new _ErrorMessage.default({
        version: version,
        requestId: requestId,
        errorCode: errorCode,
        targetNode: targetNode
      });
    }
  }]);
  return ErrorMessageSerializerV2;
}(_Serializer2.Serializer);
exports["default"] = ErrorMessageSerializerV2;
_TrackerMessage.default.registerSerializer(VERSION, _TrackerMessage.default.TYPES.ErrorMessage, new ErrorMessageSerializerV2());
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/exports.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.weak-map.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "ErrorMessage", ({
  enumerable: true,
  get: function get() {
    return _ErrorMessage.default;
  }
}));
Object.defineProperty(exports, "InstructionMessage", ({
  enumerable: true,
  get: function get() {
    return _InstructionMessage.default;
  }
}));
Object.defineProperty(exports, "Originator", ({
  enumerable: true,
  get: function get() {
    return _Originator.Originator;
  }
}));
Object.defineProperty(exports, "RelayMessage", ({
  enumerable: true,
  get: function get() {
    return _RelayMessage.default;
  }
}));
Object.defineProperty(exports, "RelayMessageSubType", ({
  enumerable: true,
  get: function get() {
    return _RelayMessage.RelayMessageSubType;
  }
}));
Object.defineProperty(exports, "RtcAnswerMessage", ({
  enumerable: true,
  get: function get() {
    return _RelayMessage.RtcAnswerMessage;
  }
}));
Object.defineProperty(exports, "RtcConnectMessage", ({
  enumerable: true,
  get: function get() {
    return _RelayMessage.RtcConnectMessage;
  }
}));
Object.defineProperty(exports, "RtcIceCandidateMessage", ({
  enumerable: true,
  get: function get() {
    return _RelayMessage.RtcIceCandidateMessage;
  }
}));
Object.defineProperty(exports, "RtcOfferMessage", ({
  enumerable: true,
  get: function get() {
    return _RelayMessage.RtcOfferMessage;
  }
}));
Object.defineProperty(exports, "StatusAckMessage", ({
  enumerable: true,
  get: function get() {
    return _StatusAckMessage.default;
  }
}));
Object.defineProperty(exports, "StatusMessage", ({
  enumerable: true,
  get: function get() {
    return _StatusMessage.default;
  }
}));
Object.defineProperty(exports, "TrackerMessage", ({
  enumerable: true,
  get: function get() {
    return _TrackerMessage.default;
  }
}));
Object.defineProperty(exports, "TrackerMessageType", ({
  enumerable: true,
  get: function get() {
    return _TrackerMessage.TrackerMessageType;
  }
}));
var _InstructionMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/instruction_message/InstructionMessage.ts"));
var _ErrorMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/error_message/ErrorMessage.ts"));
var _RelayMessage = _interopRequireWildcard(__webpack_require__("../protocol/src/protocol/tracker_layer/relay_message/RelayMessage.ts"));
var _StatusMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/status_message/StatusMessage.ts"));
var _StatusAckMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/status_ack_message/StatusAckMessage.ts"));
var _TrackerMessage = _interopRequireWildcard(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
var _Originator = __webpack_require__("../protocol/src/protocol/tracker_layer/Originator.ts");
__webpack_require__("../protocol/src/protocol/tracker_layer/error_message/ErrorMessageSerializerV2.ts");
__webpack_require__("../protocol/src/protocol/tracker_layer/instruction_message/InstructionMessageSerializerV2.ts");
__webpack_require__("../protocol/src/protocol/tracker_layer/relay_message/RelayMessageSerializerV2.ts");
__webpack_require__("../protocol/src/protocol/tracker_layer/status_message/StatusMessageSerializerV2.ts");
__webpack_require__("../protocol/src/protocol/tracker_layer/status_ack_message/StatusAckMessageSerializerV2.ts");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/instruction_message/InstructionMessage.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _TrackerMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
var _StreamPartID = __webpack_require__("../protocol/src/utils/StreamPartID.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var InstructionMessage = /*#__PURE__*/function (_TrackerMessage) {
  _inherits(InstructionMessage, _TrackerMessage);
  var _super = _createSuper(InstructionMessage);
  function InstructionMessage(_ref) {
    var _this;
    var _ref$version = _ref.version,
      version = _ref$version === void 0 ? _TrackerMessage2.default.LATEST_VERSION : _ref$version,
      requestId = _ref.requestId,
      streamId = _ref.streamId,
      streamPartition = _ref.streamPartition,
      nodeIds = _ref.nodeIds,
      counter = _ref.counter;
    _classCallCheck(this, InstructionMessage);
    _this = _super.call(this, version, _TrackerMessage2.default.TYPES.InstructionMessage, requestId);
    (0, _validations.validateIsNotEmptyString)('streamId', streamId);
    (0, _validations.validateIsNotNegativeInteger)('streamPartition', streamPartition);
    (0, _validations.validateIsArray)('nodeIds', nodeIds);
    (0, _validations.validateIsNotNegativeInteger)('counter', counter);
    _this.streamId = streamId;
    _this.streamPartition = streamPartition;
    _this.nodeIds = nodeIds;
    _this.counter = counter;
    return _this;
  }
  _createClass(InstructionMessage, [{
    key: "getStreamPartID",
    value: function getStreamPartID() {
      return (0, _StreamPartID.toStreamPartID)(this.streamId, this.streamPartition);
    }
  }]);
  return InstructionMessage;
}(_TrackerMessage2.default);
exports["default"] = InstructionMessage;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/instruction_message/InstructionMessageSerializerV2.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _TrackerMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
var _InstructionMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/instruction_message/InstructionMessage.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
var _StreamID = __webpack_require__("../protocol/src/utils/StreamID.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 2;

/* eslint-disable class-methods-use-this */
var InstructionMessageSerializerV2 = /*#__PURE__*/function (_Serializer) {
  _inherits(InstructionMessageSerializerV2, _Serializer);
  var _super = _createSuper(InstructionMessageSerializerV2);
  function InstructionMessageSerializerV2() {
    _classCallCheck(this, InstructionMessageSerializerV2);
    return _super.apply(this, arguments);
  }
  _createClass(InstructionMessageSerializerV2, [{
    key: "toArray",
    value: function toArray(instructionMessage) {
      return [VERSION, _TrackerMessage.default.TYPES.InstructionMessage, instructionMessage.requestId, instructionMessage.streamId, instructionMessage.streamPartition, instructionMessage.nodeIds, instructionMessage.counter];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 7),
        version = _arr2[0],
        _type = _arr2[1],
        requestId = _arr2[2],
        streamId = _arr2[3],
        streamPartition = _arr2[4],
        nodeIds = _arr2[5],
        counter = _arr2[6];
      return new _InstructionMessage.default({
        version: version,
        requestId: requestId,
        streamId: (0, _StreamID.toStreamID)(streamId),
        streamPartition: streamPartition,
        nodeIds: nodeIds,
        counter: counter
      });
    }
  }]);
  return InstructionMessageSerializerV2;
}(_Serializer2.Serializer);
exports["default"] = InstructionMessageSerializerV2;
_TrackerMessage.default.registerSerializer(VERSION, _TrackerMessage.default.TYPES.InstructionMessage, new InstructionMessageSerializerV2());
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/relay_message/RelayMessage.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.RelayMessageSubType = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.values.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _TrackerMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var RelayMessageSubType = /*#__PURE__*/function (RelayMessageSubType) {
  RelayMessageSubType["RTC_OFFER"] = "rtcOffer";
  RelayMessageSubType["RTC_ANSWER"] = "rtcAnswer";
  RelayMessageSubType["RTC_CONNECT"] = "rtcConnect";
  RelayMessageSubType["ICE_CANDIDATE"] = "iceCandidate";
  return RelayMessageSubType;
}({});
exports.RelayMessageSubType = RelayMessageSubType;
var RelayMessage = /*#__PURE__*/function (_TrackerMessage) {
  _inherits(RelayMessage, _TrackerMessage);
  var _super = _createSuper(RelayMessage);
  function RelayMessage(_ref) {
    var _this;
    var _ref$version = _ref.version,
      version = _ref$version === void 0 ? _TrackerMessage2.default.LATEST_VERSION : _ref$version,
      requestId = _ref.requestId,
      originator = _ref.originator,
      targetNode = _ref.targetNode,
      subType = _ref.subType,
      data = _ref.data;
    _classCallCheck(this, RelayMessage);
    _this = _super.call(this, version, _TrackerMessage2.default.TYPES.RelayMessage, requestId);
    (0, _validations.validateIsNotNullOrUndefined)('originator', originator);
    (0, _validations.validateIsNotEmptyString)('targetNode', targetNode);
    (0, _validations.validateIsOneOf)('subType', subType, Object.values(RelayMessageSubType));
    (0, _validations.validateIsNotNullOrUndefined)('data', data);
    _this.originator = originator;
    _this.targetNode = targetNode;
    _this.subType = subType;
    _this.data = data;
    return _this;
  }
  _createClass(RelayMessage, [{
    key: "isRtcOfferMessage",
    value: function isRtcOfferMessage() {
      return this.subType === RelayMessageSubType.RTC_OFFER;
    }
  }, {
    key: "isRtcAnswerMessage",
    value: function isRtcAnswerMessage() {
      return this.subType === RelayMessageSubType.RTC_ANSWER;
    }
  }, {
    key: "isRtcConnectMessage",
    value: function isRtcConnectMessage() {
      return this.subType === RelayMessageSubType.RTC_CONNECT;
    }
  }, {
    key: "isIceCandidateMessage",
    value: function isIceCandidateMessage() {
      return this.subType === RelayMessageSubType.ICE_CANDIDATE;
    }
  }]);
  return RelayMessage;
}(_TrackerMessage2.default);
exports["default"] = RelayMessage;

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/relay_message/RelayMessageSerializerV2.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _TrackerMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
var _RelayMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/relay_message/RelayMessage.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 2;

/* eslint-disable class-methods-use-this */
var RelayMessageSerializerV2 = /*#__PURE__*/function (_Serializer) {
  _inherits(RelayMessageSerializerV2, _Serializer);
  var _super = _createSuper(RelayMessageSerializerV2);
  function RelayMessageSerializerV2() {
    _classCallCheck(this, RelayMessageSerializerV2);
    return _super.apply(this, arguments);
  }
  _createClass(RelayMessageSerializerV2, [{
    key: "toArray",
    value: function toArray(relayMessage) {
      return [VERSION, _TrackerMessage.default.TYPES.RelayMessage, relayMessage.requestId, relayMessage.originator, relayMessage.targetNode, relayMessage.subType, relayMessage.data];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 7),
        version = _arr2[0],
        _type = _arr2[1],
        requestId = _arr2[2],
        originator = _arr2[3],
        targetNode = _arr2[4],
        subType = _arr2[5],
        data = _arr2[6];
      return new _RelayMessage.default({
        version: version,
        requestId: requestId,
        originator: originator,
        targetNode: targetNode,
        subType: subType,
        data: data
      });
    }
  }]);
  return RelayMessageSerializerV2;
}(_Serializer2.Serializer);
exports["default"] = RelayMessageSerializerV2;
_TrackerMessage.default.registerSerializer(VERSION, _TrackerMessage.default.TYPES.RelayMessage, new RelayMessageSerializerV2());
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/status_ack_message/StatusAckMessage.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _TrackerMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
var _StreamPartID = __webpack_require__("../protocol/src/utils/StreamPartID.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var StatusAckMessage = /*#__PURE__*/function (_TrackerMessage) {
  _inherits(StatusAckMessage, _TrackerMessage);
  var _super = _createSuper(StatusAckMessage);
  function StatusAckMessage(_ref) {
    var _this;
    var _ref$version = _ref.version,
      version = _ref$version === void 0 ? _TrackerMessage2.default.LATEST_VERSION : _ref$version,
      requestId = _ref.requestId,
      streamId = _ref.streamId,
      streamPartition = _ref.streamPartition;
    _classCallCheck(this, StatusAckMessage);
    _this = _super.call(this, version, _TrackerMessage2.default.TYPES.StatusAckMessage, requestId);
    (0, _validations.validateIsNotEmptyString)('streamId', streamId);
    (0, _validations.validateIsNotNegativeInteger)('streamPartition', streamPartition);
    _this.streamId = streamId;
    _this.streamPartition = streamPartition;
    return _this;
  }
  _createClass(StatusAckMessage, [{
    key: "getStreamPartID",
    value: function getStreamPartID() {
      return (0, _StreamPartID.toStreamPartID)(this.streamId, this.streamPartition);
    }
  }]);
  return StatusAckMessage;
}(_TrackerMessage2.default);
exports["default"] = StatusAckMessage;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/status_ack_message/StatusAckMessageSerializerV2.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _TrackerMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
var _StatusAckMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/status_ack_message/StatusAckMessage.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
var _StreamID = __webpack_require__("../protocol/src/utils/StreamID.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 2;

/* eslint-disable class-methods-use-this */
var StatusAckMessageSerializerV2 = /*#__PURE__*/function (_Serializer) {
  _inherits(StatusAckMessageSerializerV2, _Serializer);
  var _super = _createSuper(StatusAckMessageSerializerV2);
  function StatusAckMessageSerializerV2() {
    _classCallCheck(this, StatusAckMessageSerializerV2);
    return _super.apply(this, arguments);
  }
  _createClass(StatusAckMessageSerializerV2, [{
    key: "toArray",
    value: function toArray(statusAckMessage) {
      return [VERSION, _TrackerMessage.default.TYPES.StatusAckMessage, statusAckMessage.requestId, statusAckMessage.streamId, statusAckMessage.streamPartition];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 5),
        version = _arr2[0],
        _type = _arr2[1],
        requestId = _arr2[2],
        streamId = _arr2[3],
        streamPartition = _arr2[4];
      return new _StatusAckMessage.default({
        version: version,
        requestId: requestId,
        streamId: (0, _StreamID.toStreamID)(streamId),
        streamPartition: streamPartition
      });
    }
  }]);
  return StatusAckMessageSerializerV2;
}(_Serializer2.Serializer);
exports["default"] = StatusAckMessageSerializerV2;
_TrackerMessage.default.registerSerializer(VERSION, _TrackerMessage.default.TYPES.StatusAckMessage, new StatusAckMessageSerializerV2());
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/status_message/StatusMessage.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _validations = __webpack_require__("../protocol/src/utils/validations.ts");
var _TrackerMessage2 = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var StatusMessage = /*#__PURE__*/function (_TrackerMessage) {
  _inherits(StatusMessage, _TrackerMessage);
  var _super = _createSuper(StatusMessage);
  function StatusMessage(_ref) {
    var _this;
    var _ref$version = _ref.version,
      version = _ref$version === void 0 ? _TrackerMessage2.default.LATEST_VERSION : _ref$version,
      requestId = _ref.requestId,
      status = _ref.status;
    _classCallCheck(this, StatusMessage);
    _this = _super.call(this, version, _TrackerMessage2.default.TYPES.StatusMessage, requestId);
    (0, _validations.validateIsNotNullOrUndefined)('status', status);
    _this.status = status;
    return _this;
  }
  return _createClass(StatusMessage);
}(_TrackerMessage2.default);
exports["default"] = StatusMessage;
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/protocol/tracker_layer/status_message/StatusMessageSerializerV2.ts":
/***/ ((module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
var _TrackerMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/TrackerMessage.ts"));
var _StatusMessage = _interopRequireDefault(__webpack_require__("../protocol/src/protocol/tracker_layer/status_message/StatusMessage.ts"));
var _Serializer2 = __webpack_require__("../protocol/src/Serializer.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VERSION = 2;

/* eslint-disable class-methods-use-this */
var StatusMessageSerializerV2 = /*#__PURE__*/function (_Serializer) {
  _inherits(StatusMessageSerializerV2, _Serializer);
  var _super = _createSuper(StatusMessageSerializerV2);
  function StatusMessageSerializerV2() {
    _classCallCheck(this, StatusMessageSerializerV2);
    return _super.apply(this, arguments);
  }
  _createClass(StatusMessageSerializerV2, [{
    key: "toArray",
    value: function toArray(statusMessage) {
      return [VERSION, _TrackerMessage.default.TYPES.StatusMessage, statusMessage.requestId, statusMessage.status];
    }
  }, {
    key: "fromArray",
    value: function fromArray(arr) {
      var _arr2 = _slicedToArray(arr, 4),
        version = _arr2[0],
        _type = _arr2[1],
        requestId = _arr2[2],
        status = _arr2[3];
      return new _StatusMessage.default({
        version: version,
        requestId: requestId,
        status: status
      });
    }
  }]);
  return StatusMessageSerializerV2;
}(_Serializer2.Serializer);
exports["default"] = StatusMessageSerializerV2;
_TrackerMessage.default.registerSerializer(VERSION, _TrackerMessage.default.TYPES.StatusMessage, new StatusMessageSerializerV2());
module.exports = exports.default;

/***/ }),

/***/ "../protocol/src/utils/StreamID.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamIDUtils = void 0;
exports.toStreamID = toStreamID;
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.starts-with.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Create an instance of `StreamID` from a given string stream id or path.
 *
 * Supported formats:
 *  - full stream id format, e.g., '0x0000000000000000000000000000000000000000/foo/bar' or 'name.eth/foo/bar'
 *  - path-only format, e.g. , '/foo/bar'
 *  - legacy format, e.g., '7wa7APtlTq6EC5iTCBy6dw'
 *
 *  If `streamIdOrPath` is not in path-only format, `domain` can be left undefined.
 */
function toStreamID(streamIdOrPath, domain) {
  if (streamIdOrPath.length === 0) {
    throw new Error('stream id may not be empty');
  }
  var firstSlashIdx = streamIdOrPath.indexOf('/');
  if (firstSlashIdx === -1) {
    // legacy format
    return streamIdOrPath;
  } else if (firstSlashIdx === 0) {
    // path-only format
    if (domain === undefined) {
      throw new Error("path-only format \"".concat(streamIdOrPath, "\" provided without domain"));
    }
    return domain + streamIdOrPath;
  } else {
    var _domain = (0, _utils.toEthereumAddressOrENSName)(streamIdOrPath.substring(0, firstSlashIdx));
    var path = streamIdOrPath.substring(firstSlashIdx);
    return _domain + path;
  }
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var StreamIDUtils = /*#__PURE__*/function () {
  function StreamIDUtils() {
    _classCallCheck(this, StreamIDUtils);
  }
  _createClass(StreamIDUtils, null, [{
    key: "isPathOnlyFormat",
    value: function isPathOnlyFormat(streamIdOrPath) {
      return streamIdOrPath.startsWith('/');
    }
  }, {
    key: "getDomain",
    value: function getDomain(streamId) {
      var domainAndPath = StreamIDUtils.getDomainAndPath(streamId);
      return domainAndPath === null || domainAndPath === void 0 ? void 0 : domainAndPath[0];
    }
  }, {
    key: "getPath",
    value: function getPath(streamId) {
      var domainAndPath = StreamIDUtils.getDomainAndPath(streamId);
      return domainAndPath === null || domainAndPath === void 0 ? void 0 : domainAndPath[1];
    }
  }, {
    key: "getDomainAndPath",
    value: function getDomainAndPath(streamId) {
      var firstSlashIdx = streamId.indexOf('/');
      if (firstSlashIdx !== -1) {
        var domain = streamId.substring(0, firstSlashIdx);
        return [domain, streamId.substring(firstSlashIdx)];
      } else {
        return undefined;
      }
    }
  }]);
  return StreamIDUtils;
}();
exports.StreamIDUtils = StreamIDUtils;

/***/ }),

/***/ "../protocol/src/utils/StreamPartID.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StreamPartIDUtils = void 0;
exports.toStreamPartID = toStreamPartID;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.last-index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _StreamID = __webpack_require__("../protocol/src/utils/StreamID.ts");
var _partition = __webpack_require__("../protocol/src/utils/partition.ts");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DELIMITER = '#';
function toStreamPartID(streamId, streamPartition) {
  (0, _partition.ensureValidStreamPartitionIndex)(streamPartition);
  return "".concat(streamId).concat(DELIMITER).concat(streamPartition);
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
var StreamPartIDUtils = /*#__PURE__*/function () {
  function StreamPartIDUtils() {
    _classCallCheck(this, StreamPartIDUtils);
  }
  _createClass(StreamPartIDUtils, null, [{
    key: "parse",
    value: function parse(streamPartIdAsStr) {
      var _StreamPartIDUtils$pa = StreamPartIDUtils.parseRawElements(streamPartIdAsStr),
        _StreamPartIDUtils$pa2 = _slicedToArray(_StreamPartIDUtils$pa, 2),
        streamId = _StreamPartIDUtils$pa2[0],
        streamPartition = _StreamPartIDUtils$pa2[1];
      if (streamPartition === undefined) {
        throw new Error("invalid streamPartID string: ".concat(streamPartIdAsStr));
      }
      (0, _StreamID.toStreamID)(streamId); // throws if not valid
      (0, _partition.ensureValidStreamPartitionIndex)(streamPartition);
      return streamPartIdAsStr;
    }
  }, {
    key: "getStreamID",
    value: function getStreamID(streamPartId) {
      return this.getStreamIDAndPartition(streamPartId)[0];
    }
  }, {
    key: "getStreamPartition",
    value: function getStreamPartition(streamPartId) {
      return this.getStreamIDAndPartition(streamPartId)[1];
    }
  }, {
    key: "getStreamIDAndPartition",
    value: function getStreamIDAndPartition(streamPartId) {
      return StreamPartIDUtils.parseRawElements(streamPartId);
    }
  }, {
    key: "parseRawElements",
    value: function parseRawElements(str) {
      var lastIdx = str.lastIndexOf(DELIMITER);
      if (lastIdx === -1 || lastIdx === str.length - 1) {
        return [str, undefined];
      }
      return [str.substring(0, lastIdx), Number(str.substring(lastIdx + 1))];
    }
  }]);
  return StreamPartIDUtils;
}();
exports.StreamPartIDUtils = StreamPartIDUtils;

/***/ }),

/***/ "../protocol/src/utils/TrackerRegistry.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TrackerRegistry = void 0;
exports.createTrackerRegistry = createTrackerRegistry;
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var _utils = __webpack_require__("../utils/dist/src/exports.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var TrackerRegistry = /*#__PURE__*/function () {
  function TrackerRegistry(records) {
    _classCallCheck(this, TrackerRegistry);
    this.records = records.slice(); // copy before mutating
  }
  _createClass(TrackerRegistry, [{
    key: "getTracker",
    value: function getTracker(streamPartId) {
      var index = (0, _utils.keyToArrayIndex)(this.records.length, streamPartId);
      return this.records[index];
    }
  }, {
    key: "getAllTrackers",
    value: function getAllTrackers() {
      return this.records;
    }
  }]);
  return TrackerRegistry;
}();
exports.TrackerRegistry = TrackerRegistry;
function createTrackerRegistry(servers) {
  return new TrackerRegistry(servers);
}

/***/ }),

/***/ "../protocol/src/utils/exports.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "MAX_PARTITION_COUNT", ({
  enumerable: true,
  get: function get() {
    return _partition.MAX_PARTITION_COUNT;
  }
}));
Object.defineProperty(exports, "ProxyDirection", ({
  enumerable: true,
  get: function get() {
    return _types.ProxyDirection;
  }
}));
Object.defineProperty(exports, "StreamID", ({
  enumerable: true,
  get: function get() {
    return _StreamID.StreamID;
  }
}));
Object.defineProperty(exports, "StreamIDUtils", ({
  enumerable: true,
  get: function get() {
    return _StreamID.StreamIDUtils;
  }
}));
Object.defineProperty(exports, "StreamPartID", ({
  enumerable: true,
  get: function get() {
    return _StreamPartID.StreamPartID;
  }
}));
Object.defineProperty(exports, "StreamPartIDUtils", ({
  enumerable: true,
  get: function get() {
    return _StreamPartID.StreamPartIDUtils;
  }
}));
Object.defineProperty(exports, "TrackerRegistry", ({
  enumerable: true,
  get: function get() {
    return _TrackerRegistry.TrackerRegistry;
  }
}));
Object.defineProperty(exports, "TrackerRegistryRecord", ({
  enumerable: true,
  get: function get() {
    return _TrackerRegistry.TrackerRegistryRecord;
  }
}));
Object.defineProperty(exports, "createTrackerRegistry", ({
  enumerable: true,
  get: function get() {
    return _TrackerRegistry.createTrackerRegistry;
  }
}));
Object.defineProperty(exports, "ensureValidStreamPartitionCount", ({
  enumerable: true,
  get: function get() {
    return _partition.ensureValidStreamPartitionCount;
  }
}));
Object.defineProperty(exports, "toStreamID", ({
  enumerable: true,
  get: function get() {
    return _StreamID.toStreamID;
  }
}));
Object.defineProperty(exports, "toStreamPartID", ({
  enumerable: true,
  get: function get() {
    return _StreamPartID.toStreamPartID;
  }
}));
var _TrackerRegistry = __webpack_require__("../protocol/src/utils/TrackerRegistry.ts");
var _StreamID = __webpack_require__("../protocol/src/utils/StreamID.ts");
var _partition = __webpack_require__("../protocol/src/utils/partition.ts");
var _StreamPartID = __webpack_require__("../protocol/src/utils/StreamPartID.ts");
var _types = __webpack_require__("../protocol/src/utils/types.ts");

/***/ }),

/***/ "../protocol/src/utils/partition.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MAX_PARTITION_COUNT = void 0;
exports.ensureValidStreamPartitionCount = ensureValidStreamPartitionCount;
exports.ensureValidStreamPartitionIndex = ensureValidStreamPartitionIndex;
__webpack_require__("../../node_modules/core-js/modules/es.number.is-safe-integer.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var MAX_PARTITION_COUNT = 100;
exports.MAX_PARTITION_COUNT = MAX_PARTITION_COUNT;
function ensureValidStreamPartitionIndex(streamPartition) {
  if (!Number.isSafeInteger(streamPartition) || streamPartition < 0 || streamPartition >= MAX_PARTITION_COUNT) {
    throw new Error("invalid streamPartition value: ".concat(streamPartition));
  }
}
function ensureValidStreamPartitionCount(streamPartition) {
  if (!Number.isSafeInteger(streamPartition) || streamPartition < 0 || streamPartition > MAX_PARTITION_COUNT) {
    throw new Error("invalid streamPartition value: ".concat(streamPartition));
  }
}

/***/ }),

/***/ "../protocol/src/utils/types.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ProxyDirection = void 0;
var ProxyDirection = /*#__PURE__*/function (ProxyDirection) {
  ProxyDirection["PUBLISH"] = "publish";
  ProxyDirection["SUBSCRIBE"] = "subscribe";
  return ProxyDirection;
}({});
exports.ProxyDirection = ProxyDirection;

/***/ }),

/***/ "../protocol/src/utils/validations.ts":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.validateIsArray = validateIsArray;
exports.validateIsDirection = validateIsDirection;
exports.validateIsInteger = validateIsInteger;
exports.validateIsNotEmptyString = validateIsNotEmptyString;
exports.validateIsNotNegativeInteger = validateIsNotNegativeInteger;
exports.validateIsNotNullOrUndefined = validateIsNotNullOrUndefined;
exports.validateIsOneOf = validateIsOneOf;
exports.validateIsString = validateIsString;
exports.validateIsType = validateIsType;
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.is-integer.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.includes.js");
var _ValidationError = _interopRequireDefault(__webpack_require__("../protocol/src/errors/ValidationError.ts"));
var _types = __webpack_require__("../protocol/src/utils/types.ts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function validateIsNotNullOrUndefined(varName, varValue) {
  if (varValue === undefined) {
    throw new _ValidationError.default("Expected ".concat(varName, " to not be undefined."));
  }
  if (varValue == null) {
    throw new _ValidationError.default("Expected ".concat(varName, " to not be null."));
  }
}
function validateIsString(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (allowNull && varValue == null) {
    return;
  }
  validateIsNotNullOrUndefined(varName, varValue);
  if (typeof varValue !== 'string' && !(varValue instanceof String)) {
    throw new _ValidationError.default("Expected ".concat(varName, " to be a string but was a ").concat(_typeof(varValue), " (").concat(varValue, ")."));
  }
}
function validateIsNotEmptyString(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (allowNull && varValue == null) {
    return;
  }
  validateIsString(varName, varValue);
  if (varValue.length === 0) {
    throw new _ValidationError.default("Expected ".concat(varName, " to not be an empty string."));
  }
}
function validateIsInteger(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (allowNull && varValue == null) {
    return;
  }
  validateIsNotNullOrUndefined(varName, varValue);
  if (!Number.isInteger(varValue)) {
    throw new _ValidationError.default("Expected ".concat(varName, " to be an integer but was a ").concat(_typeof(varValue), " (").concat(varValue, ")."));
  }
}
function validateIsNotNegativeInteger(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (allowNull && varValue == null) {
    return;
  }
  validateIsInteger(varName, varValue);
  if (varValue < 0) {
    throw new _ValidationError.default("Expected ".concat(varName, " to not be negative (").concat(varValue, ")."));
  }
}
function validateIsArray(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (allowNull && varValue == null) {
    return;
  }
  validateIsNotNullOrUndefined(varName, varValue);
  if (!Array.isArray(varValue)) {
    throw new _ValidationError.default("Expected ".concat(varName, " to be an array but was a ").concat(_typeof(varValue), " (").concat(varValue, ")."));
  }
}
function validateIsDirection(varName, varValue) {
  var allowNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (allowNull && varValue == null) {
    return;
  }
  validateIsNotNullOrUndefined(varName, varValue);
  if (varValue in _types.ProxyDirection) {
    throw new _ValidationError.default("Expected ".concat(varName, " to be a ProxyDirection but was a ").concat(_typeof(varValue), " (").concat(varValue, ")."));
  }
}
function validateIsType(varName, varValue, typeName, typeClass) {
  var allowNull = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (allowNull && varValue == null) {
    return;
  }
  if (!(varValue instanceof typeClass)) {
    var msg = "Expected ".concat(varName, " to be an instance of (").concat(typeName, "), but it was: ").concat(JSON.stringify(varValue));
    throw new _ValidationError.default(msg);
  }
}
function validateIsOneOf(varName, varValue, validValues) {
  var allowNull = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  if (allowNull && varValue == null) {
    return;
  }
  validateIsNotNullOrUndefined(varName, varValue);
  if (!validValues.includes(varValue)) {
    var msg = "Expected ".concat(varName, " to be one of ").concat(JSON.stringify(validValues), " but was (").concat(varValue, ").");
    throw new _ValidationError.default(msg);
  }
}

/***/ }),

/***/ "../utils/dist/src/Defer.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.get.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Defer = void 0;
var once_1 = __importDefault(__webpack_require__("../../node_modules/lodash/once.js"));
var noopExecutor = function noopExecutor() {};
/**
 * Deferred promise allowing external control of resolve / reject.
 */
var Defer = /*#__PURE__*/function (_Promise) {
  _inherits(Defer, _Promise);
  var _super = _createSuper(Defer);
  function Defer() {
    var _thisSuper, _this;
    var executor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noopExecutor;
    _classCallCheck(this, Defer);
    var localResolve;
    var localReject;
    _this = _super.call(this, function (resolve, reject) {
      localResolve = resolve;
      localReject = reject;
      executor(resolve, reject);
    });
    _this.settled = false;
    if (localResolve === undefined) {
      throw new Error('invariant violation: resolveFn was undefined');
    }
    if (localReject === undefined) {
      throw new Error('invariant violation: rejectFn was undefined');
    }
    _this.resolveFn = localResolve;
    _this.rejectFn = localReject;
    _this.ensureNoopCatchAttached = (0, once_1.default)(function () {
      _get((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(Defer.prototype)), "catch", _thisSuper).call(_thisSuper, function () {});
    });
    return _this;
  }
  _createClass(Defer, [{
    key: "resolve",
    value: function resolve(value) {
      this.ensureNoopCatchAttached();
      if (!this.settled) {
        this.settled = true;
        this.resolveFn(value);
      }
    }
  }, {
    key: "reject",
    value: function reject(error) {
      this.ensureNoopCatchAttached();
      if (!this.settled) {
        this.settled = true;
        this.rejectFn(error);
      }
    }
  }, {
    key: "wrap",
    value: function wrap(fn) {
      var _this2 = this;
      this.ensureNoopCatchAttached();
      return /*#__PURE__*/_asyncToGenerator(function* () {
        try {
          var value = yield fn.apply(void 0, arguments);
          _this2.resolve(value);
          return value;
        } catch (err) {
          _this2.reject(err);
          throw err;
        }
      });
    }
  }]);
  return Defer;
}( /*#__PURE__*/_wrapNativeSuper(Promise));
exports.Defer = Defer;

/***/ }),

/***/ "../utils/dist/src/ENSName.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.toENSName = exports.isENSNameFormatIgnoreCase = void 0;
function isENSNameFormatIgnoreCase(str) {
  return str.indexOf('.') > 0;
}
exports.isENSNameFormatIgnoreCase = isENSNameFormatIgnoreCase;
function toENSName(str) {
  if (isENSNameFormatIgnoreCase(str)) {
    return str.toLowerCase();
  }
  throw new Error("not a valid ENS name: \"".concat(str, "\""));
}
exports.toENSName = toENSName;

/***/ }),

/***/ "../utils/dist/src/EthereumAddress.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.match.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.toEthereumAddress = void 0;
var REGEX = /^0x[a-fA-F0-9]{40}$/;
function toEthereumAddress(str) {
  if (str.match(REGEX)) {
    return str.toLowerCase();
  }
  throw new Error("not a valid Ethereum address: \"".concat(str, "\""));
}
exports.toEthereumAddress = toEthereumAddress;

/***/ }),

/***/ "../utils/dist/src/Gate.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Gate = void 0;
var Defer_1 = __webpack_require__("../utils/dist/src/Defer.js");
/*
 * Gate to lock access to some resource.
 */
var Gate = /*#__PURE__*/function () {
  function Gate(isOpen) {
    _classCallCheck(this, Gate);
    if (!isOpen) {
      this.close();
    }
  }
  _createClass(Gate, [{
    key: "open",
    value: function open() {
      this.clearPending();
    }
  }, {
    key: "close",
    value: function close() {
      if (this.pending === undefined) {
        this.pending = new Defer_1.Defer();
      }
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return !this.pending;
    }
  }, {
    key: "clearPending",
    value: function clearPending() {
      var pending = this.pending;
      if (pending === undefined) {
        return;
      }
      this.pending = undefined;
      pending.resolve(undefined);
    }
  }, {
    key: "waitUntilOpen",
    value: function () {
      var _waitUntilOpen = _asyncToGenerator(function* () {
        if (this.pending) {
          yield this.pending;
        }
      });
      function waitUntilOpen() {
        return _waitUntilOpen.apply(this, arguments);
      }
      return waitUntilOpen;
    }()
  }]);
  return Gate;
}();
exports.Gate = Gate;

/***/ }),

/***/ "../utils/dist/src/Logger.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");


__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-properties.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.split.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
var _process$env$LOG_LEVE, _parseBoolean2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Logger = void 0;
var pino_1 = __importDefault(__webpack_require__("../../node_modules/pino/browser.js"));
var path_1 = __importDefault(__webpack_require__("../../node_modules/path-browserify/index.js"));
var without_1 = __importDefault(__webpack_require__("../../node_modules/lodash/without.js"));
var padEnd_1 = __importDefault(__webpack_require__("../../node_modules/lodash/padEnd.js"));
var parseBoolean = function parseBoolean(value) {
  switch (value) {
    case 'true':
      return true;
    case 'false':
      return false;
    case undefined:
      return undefined;
    default:
      throw new Error('Invalid boolean value: ${value}');
  }
};
/**
 * Disabled when in browser or when environment variable DISABLE_PRETTY_LOG is set to true.
 */
function isPrettyPrintDisabled() {
  var _parseBoolean;
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' || ((_parseBoolean = parseBoolean(process.env.DISABLE_PRETTY_LOG)) !== null && _parseBoolean !== void 0 ? _parseBoolean : false);
}
var rootLogger = (0, pino_1.default)({
  name: 'rootLogger',
  enabled: !process.env.NOLOG,
  level: (_process$env$LOG_LEVE = process.env.LOG_LEVEL) !== null && _process$env$LOG_LEVE !== void 0 ? _process$env$LOG_LEVE : 'info',
  formatters: {
    level: function level(label) {
      return {
        level: label
      }; // log level as string instead of number
    }
  },

  transport: isPrettyPrintDisabled() ? undefined : {
    target: 'pino-pretty',
    options: {
      colorize: (_parseBoolean2 = parseBoolean(process.env.LOG_COLORS)) !== null && _parseBoolean2 !== void 0 ? _parseBoolean2 : true,
      singleLine: true,
      translateTime: 'yyyy-mm-dd"T"HH:MM:ss.l',
      ignore: 'pid,hostname',
      levelFirst: true
    }
  },
  browser: {
    asObject: true
  }
});
/**
 * This whole monstrosity exists only because pino in browser environment will not print a log message
 * when invoking `logger.info(undefined, 'msg') instead you need to call `logger.info(msg)`.
 */
function wrappedMethodCall(wrappedPinoMethod) {
  return function (msg, metadata) {
    if (metadata !== undefined) {
      wrappedPinoMethod(metadata, msg);
    } else {
      wrappedPinoMethod(msg);
    }
  };
}
var Logger = /*#__PURE__*/function () {
  function Logger(module, contextBindings) {
    var _process$env$LOG_LEVE2;
    var defaultLogLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'info';
    var parentLogger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : rootLogger;
    _classCallCheck(this, Logger);
    this.logger = parentLogger.child(_objectSpread({
      name: Logger.createName(module)
    }, contextBindings), {
      level: (_process$env$LOG_LEVE2 = process.env.LOG_LEVEL) !== null && _process$env$LOG_LEVE2 !== void 0 ? _process$env$LOG_LEVE2 : defaultLogLevel
    });
    this.fatal = wrappedMethodCall(this.logger.fatal.bind(this.logger));
    this.error = wrappedMethodCall(this.logger.error.bind(this.logger));
    this.warn = wrappedMethodCall(this.logger.warn.bind(this.logger));
    this.info = wrappedMethodCall(this.logger.info.bind(this.logger));
    this.debug = wrappedMethodCall(this.logger.debug.bind(this.logger));
    this.trace = wrappedMethodCall(this.logger.trace.bind(this.logger));
  }
  _createClass(Logger, null, [{
    key: "createName",
    value: function createName(module) {
      var parsedPath = path_1.default.parse(String(module.id));
      var fileId = parsedPath.name;
      if (fileId === 'index') {
        // file with name "foobar/index.ts" -> "foobar"
        var parts = parsedPath.dir.split(path_1.default.sep);
        fileId = parts[parts.length - 1];
      }
      var longName = (0, without_1.default)([process.env.STREAMR_APPLICATION_ID, fileId], undefined).join(':');
      return isPrettyPrintDisabled() ? longName : (0, padEnd_1.default)(longName.substring(0, this.NAME_LENGTH), this.NAME_LENGTH, ' ');
    }
  }]);
  return Logger;
}();
exports.Logger = Logger;
Logger.NAME_LENGTH = 20;

/***/ }),

/***/ "../utils/dist/src/Metric.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.get.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MetricsContext = exports.RateMetric = exports.LevelMetric = exports.AverageMetric = exports.CountMetric = exports.Metric = void 0;
var eventemitter3_1 = __importDefault(__webpack_require__("../../node_modules/eventemitter3/index.js"));
var set_1 = __importDefault(__webpack_require__("../../node_modules/lodash/set.js"));
var scheduleAtFixedRate_1 = __webpack_require__("../utils/dist/src/scheduleAtFixedRate.js");
var Sampler = /*#__PURE__*/function () {
  function Sampler(metric) {
    var _this = this;
    _classCallCheck(this, Sampler);
    this.metric = metric;
    this.listener = function (value) {
      return _this.onRecord(value);
    };
  }
  _createClass(Sampler, [{
    key: "start",
    value: function start(_now) {
      this.metric.on('record', this.listener);
    }
  }, {
    key: "stop",
    value: function stop(_now) {
      this.metric.off('record', this.listener);
    }
  }]);
  return Sampler;
}();
var Metric = /*#__PURE__*/function () {
  /** @internal */
  function Metric(samplerFactory, initialValue) {
    _classCallCheck(this, Metric);
    this.eventEmitter = new eventemitter3_1.default();
    this.samplerFactory = samplerFactory;
    this.latestValue = initialValue;
  }
  _createClass(Metric, [{
    key: "record",
    value: function record(value) {
      this.latestValue = value;
      this.eventEmitter.emit('record', value);
    }
  }, {
    key: "getLatestValue",
    value: function getLatestValue() {
      return this.latestValue;
    }
    /** @internal */
  }, {
    key: "on",
    value: function on(eventName, listener) {
      this.eventEmitter.on(eventName, listener);
    }
    /** @internal */
  }, {
    key: "off",
    value: function off(eventName, listener) {
      this.eventEmitter.off(eventName, listener);
    }
    /** @internal */
  }, {
    key: "createSampler",
    value: function createSampler() {
      return this.samplerFactory(this);
    }
  }]);
  return Metric;
}();
exports.Metric = Metric;
/*
 * Sum of all records within a sampling period.
 *
 * E.g. count of failed connections
 */
var CountSampler = /*#__PURE__*/function (_Sampler) {
  _inherits(CountSampler, _Sampler);
  var _super = _createSuper(CountSampler);
  function CountSampler() {
    var _this2;
    _classCallCheck(this, CountSampler);
    _this2 = _super.apply(this, arguments);
    _this2.sum = 0;
    return _this2;
  }
  _createClass(CountSampler, [{
    key: "onRecord",
    value: function onRecord(value) {
      this.sum += value;
    }
  }, {
    key: "getAggregatedValue",
    value: function getAggregatedValue() {
      return this.sum;
    }
  }]);
  return CountSampler;
}(Sampler);
var CountMetric = /*#__PURE__*/function (_Metric) {
  _inherits(CountMetric, _Metric);
  var _super2 = _createSuper(CountMetric);
  function CountMetric() {
    _classCallCheck(this, CountMetric);
    return _super2.call(this, function (m) {
      return new CountSampler(m);
    });
  }
  return _createClass(CountMetric);
}(Metric);
exports.CountMetric = CountMetric;
/*
 * Average of all records within a sampling period. If the sampling data is
 * continuous, you may want to use LevelSampler instead.
 *
 * E.g. average latency
 */
var AverageSampler = /*#__PURE__*/function (_Sampler2) {
  _inherits(AverageSampler, _Sampler2);
  var _super3 = _createSuper(AverageSampler);
  function AverageSampler() {
    var _this3;
    _classCallCheck(this, AverageSampler);
    _this3 = _super3.apply(this, arguments);
    _this3.sum = 0;
    _this3.count = 0;
    return _this3;
  }
  _createClass(AverageSampler, [{
    key: "onRecord",
    value: function onRecord(value) {
      this.sum += value;
      this.count++;
    }
  }, {
    key: "getAggregatedValue",
    value: function getAggregatedValue() {
      if (this.count > 0) {
        return this.sum / this.count;
      } else {
        return undefined;
      }
    }
  }]);
  return AverageSampler;
}(Sampler);
var AverageMetric = /*#__PURE__*/function (_Metric2) {
  _inherits(AverageMetric, _Metric2);
  var _super4 = _createSuper(AverageMetric);
  function AverageMetric() {
    _classCallCheck(this, AverageMetric);
    return _super4.call(this, function (m) {
      return new AverageSampler(m);
    });
  }
  return _createClass(AverageMetric);
}(Metric);
exports.AverageMetric = AverageMetric;
/*
 * Average level of the records during a sampling period. Takes the average of the
 * recorded values, but also includes the current level as a first sample when
 * the sampling starts.
 *
 * E.g. average count of currently active connections
 */
var LevelSampler = /*#__PURE__*/function (_AverageSampler) {
  _inherits(LevelSampler, _AverageSampler);
  var _super5 = _createSuper(LevelSampler);
  function LevelSampler() {
    _classCallCheck(this, LevelSampler);
    return _super5.apply(this, arguments);
  }
  _createClass(LevelSampler, [{
    key: "start",
    value: function start(now) {
      _get(_getPrototypeOf(LevelSampler.prototype), "start", this).call(this, now);
      var latest = this.metric.getLatestValue();
      if (latest !== undefined) {
        this.onRecord(latest);
      }
    }
  }]);
  return LevelSampler;
}(AverageSampler);
var LevelMetric = /*#__PURE__*/function (_Metric3) {
  _inherits(LevelMetric, _Metric3);
  var _super6 = _createSuper(LevelMetric);
  function LevelMetric(initialValue) {
    _classCallCheck(this, LevelMetric);
    return _super6.call(this, function (m) {
      return new LevelSampler(m);
    }, initialValue);
  }
  return _createClass(LevelMetric);
}(Metric);
exports.LevelMetric = LevelMetric;
/*
 * Sum of records divided by seconds.
 *
 * E.g. download speed (bytes per second)
 */
var RateSampler = /*#__PURE__*/function (_Sampler3) {
  _inherits(RateSampler, _Sampler3);
  var _super7 = _createSuper(RateSampler);
  function RateSampler() {
    var _this4;
    _classCallCheck(this, RateSampler);
    _this4 = _super7.apply(this, arguments);
    _this4.sum = 0;
    _this4.startTimestamp = undefined;
    _this4.stopTimestamp = undefined;
    return _this4;
  }
  _createClass(RateSampler, [{
    key: "start",
    value: function start(now) {
      _get(_getPrototypeOf(RateSampler.prototype), "start", this).call(this, now);
      this.startTimestamp = now;
    }
  }, {
    key: "stop",
    value: function stop(now) {
      _get(_getPrototypeOf(RateSampler.prototype), "stop", this).call(this, now);
      this.stopTimestamp = now;
    }
  }, {
    key: "onRecord",
    value: function onRecord(value) {
      this.sum += value;
    }
  }, {
    key: "getAggregatedValue",
    value: function getAggregatedValue() {
      if (this.startTimestamp !== undefined && this.stopTimestamp !== undefined && this.startTimestamp !== this.stopTimestamp) {
        var elapsedSeconds = (this.stopTimestamp - this.startTimestamp) / 1000;
        return this.sum / elapsedSeconds;
      } else {
        return undefined;
      }
    }
  }]);
  return RateSampler;
}(Sampler);
var RateMetric = /*#__PURE__*/function (_Metric4) {
  _inherits(RateMetric, _Metric4);
  var _super8 = _createSuper(RateMetric);
  function RateMetric() {
    _classCallCheck(this, RateMetric);
    return _super8.call(this, function (m) {
      return new RateSampler(m);
    });
  }
  return _createClass(RateMetric);
}(Metric);
exports.RateMetric = RateMetric;
var MetricsContext = /*#__PURE__*/function () {
  function MetricsContext() {
    _classCallCheck(this, MetricsContext);
    this.metrics = new Map();
  }
  _createClass(MetricsContext, [{
    key: "addMetrics",
    value: function addMetrics(namespace, definitions) {
      var _this5 = this;
      Object.keys(definitions).forEach(function (key) {
        var id = "".concat(namespace, ".").concat(key);
        if (_this5.metrics.has(id)) {
          throw new Error("Metrics \"".concat(id, "\" already created"));
        }
        _this5.metrics.set(id, definitions[key]);
      });
    }
  }, {
    key: "createReportProducer",
    value: function createReportProducer(onReport, interval, abortSignal, formatNumber) {
      var _this6 = this;
      var ongoingSamples = new Map();
      return (0, scheduleAtFixedRate_1.scheduleAtFixedRate)( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(function* (now) {
          if (ongoingSamples.size > 0) {
            var report = {
              period: {
                start: now - interval,
                end: now
              }
            };
            ongoingSamples.forEach(function (sample, metricId) {
              sample.stop(now);
              var value = sample.getAggregatedValue();
              if (value !== undefined) {
                (0, set_1.default)(report, metricId, formatNumber !== undefined ? formatNumber(value) : value);
              }
            });
            onReport(report);
            ongoingSamples.clear();
          }
          _this6.metrics.forEach(function (metric, id) {
            var sample = metric.createSampler();
            sample.start(now);
            ongoingSamples.set(id, sample);
          });
        });
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }(), interval, abortSignal);
    }
  }, {
    key: "getMetric",
    value: function getMetric(id) {
      return this.metrics.get(id);
    }
  }]);
  return MetricsContext;
}();
exports.MetricsContext = MetricsContext;

/***/ }),

/***/ "../utils/dist/src/Multimap.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.includes.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Multimap = void 0;
/**
 * Generic multimap: a key which maps to multiple valuess.
 * The values is an array
 * -> when we query the data, we get it back in the same order
 * -> an array may contain duplicates, if same value is added multiple times
 *    (we could implement a Multiset class if we need a different kind of duplication handling)
 *
 * TODO: implement some unit tests if this is not just a test helper class.
 **/
var Multimap = /*#__PURE__*/function () {
  function Multimap() {
    _classCallCheck(this, Multimap);
    this.values = new Map();
  }
  _createClass(Multimap, [{
    key: "get",
    value: function get(key) {
      var _this$values$get;
      return (_this$values$get = this.values.get(key)) !== null && _this$values$get !== void 0 ? _this$values$get : [];
    }
  }, {
    key: "has",
    value: function has(key, value) {
      var items = this.values.get(key);
      if (items !== undefined) {
        return items.includes(value);
        // eslint-disable-next-line no-else-return
      } else {
        return false;
      }
    }
  }, {
    key: "add",
    value: function add(key, value) {
      this.values.set(key, this.get(key).concat(value));
    }
  }, {
    key: "addAll",
    value: function addAll(key, values) {
      this.values.set(key, this.get(key).concat(values));
    }
  }, {
    key: "remove",
    value: function remove(key, value) {
      var items = this.values.get(key);
      if (items !== undefined) {
        var newItems = items.filter(function (i) {
          return i !== value;
        });
        if (newItems.length > 0) {
          this.values.set(key, newItems);
        } else {
          this.values.delete(key);
        }
      }
    }
  }, {
    key: "removeAll",
    value: function removeAll(key, values) {
      var _this = this;
      values.forEach(function (value) {
        return _this.remove(key, value);
      });
    }
  }, {
    key: "keys",
    value: function keys() {
      return Array.from(this.values.keys());
    }
  }]);
  return Multimap;
}();
exports.Multimap = Multimap;

/***/ }),

/***/ "../utils/dist/src/ObservableEventEmitter.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ObservableEventEmitter = void 0;
var eventemitter3_1 = __importDefault(__webpack_require__("../../node_modules/eventemitter3/index.js"));
/*
 * Emits an addEventListener/removeEventListener event to a separate EventEmitter
 * whenever a listener is added or removed
 */
var ObservableEventEmitter = /*#__PURE__*/function () {
  function ObservableEventEmitter() {
    _classCallCheck(this, ObservableEventEmitter);
    this.delegate = new eventemitter3_1.default();
    this.observer = new eventemitter3_1.default();
  }
  _createClass(ObservableEventEmitter, [{
    key: "on",
    value: function on(eventName, listener) {
      this.delegate.on(eventName, listener);
      this.observer.emit('addEventListener', eventName);
    }
  }, {
    key: "once",
    value: function once(eventName, listener) {
      var _this = this;
      var wrappedFn = function wrappedFn(payload) {
        listener(payload);
        _this.observer.emit('removeEventListener', eventName);
      };
      this.delegate.once(eventName, wrappedFn);
      this.observer.emit('addEventListener', eventName);
    }
  }, {
    key: "off",
    value: function off(eventName, listener) {
      this.delegate.off(eventName, listener);
      this.observer.emit('removeEventListener', eventName);
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners() {
      var eventNames = this.delegate.eventNames();
      this.delegate.removeAllListeners();
      var _iterator = _createForOfIteratorHelper(eventNames),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var eventName = _step.value;
          this.observer.emit('removeEventListener', eventName);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "emit",
    value: function emit(eventName, payload) {
      this.delegate.emit(eventName, payload);
    }
  }, {
    key: "getListenerCount",
    value: function getListenerCount(eventName) {
      return this.delegate.listenerCount(eventName);
    }
  }, {
    key: "getObserver",
    value: function getObserver() {
      return this.observer;
    }
  }]);
  return ObservableEventEmitter;
}();
exports.ObservableEventEmitter = ObservableEventEmitter;

/***/ }),

/***/ "../utils/dist/src/TheGraphClient.js":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
/* module decorator */ module = __webpack_require__.nmd(module);


__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.keys.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.join.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.filter.js");
__webpack_require__("../../node_modules/core-js/modules/es.set.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.for-each.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.for-each.js");
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }
function _AsyncGenerator(gen) { var front, back; function resume(key, arg) { try { var result = gen[key](arg), value = result.value, overloaded = value instanceof _OverloadYield; Promise.resolve(overloaded ? value.v : value).then(function (arg) { if (overloaded) { var nextKey = "return" === key ? "return" : "next"; if (!value.k || arg.done) return resume(nextKey, arg); arg = gen[nextKey](arg).value; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: !0 }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: !1 }); } (front = front.next) ? resume(front.key, front.arg) : back = null; } this._invoke = function (key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; back ? back = back.next = request : (front = back = request, resume(key, arg)); }); }, "function" != typeof gen.return && (this.return = void 0); }
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; }, _AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); }, _AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); }, _AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };
function _awaitAsyncGenerator(value) { return new _OverloadYield(value, 0); }
function _asyncGeneratorDelegate(inner) { var iter = {}, waiting = !1; function pump(key, value) { return waiting = !0, value = new Promise(function (resolve) { resolve(inner[key](value)); }), { done: !1, value: new _OverloadYield(value, 1) }; } return iter["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function () { return this; }, iter.next = function (value) { return waiting ? (waiting = !1, value) : pump("next", value); }, "function" == typeof inner.throw && (iter.throw = function (value) { if (waiting) throw waiting = !1, value; return pump("throw", value); }), "function" == typeof inner.return && (iter.return = function (value) { return waiting ? (waiting = !1, value) : pump("return", value); }), iter; }
function _OverloadYield(value, kind) { this.v = value, this.k = kind; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TheGraphClient = void 0;
var Gate_1 = __webpack_require__("../utils/dist/src/Gate.js");
var Logger_1 = __webpack_require__("../utils/dist/src/Logger.js");
var wait_1 = __webpack_require__("../utils/dist/src/wait.js");
var withTimeout_1 = __webpack_require__("../utils/dist/src/withTimeout.js");
/**
 * Query one entity with queryEntity method, and a list of entitities with queryEntities method.
 * The queryEntities method does pagination automatically.
 *
 * If we want to ensure that The Graph index is up-to-date, we can call the updateRequiredBlockNumber()
 * method. In that case a queryEntity()/queryEntities() waits until The Graph has been indexed at least
 * to that block number. If the indexing takes longer than opts.indexTimeout, the query call rejects
 * with a TimeoutError.
 */
var TheGraphClient = /*#__PURE__*/function () {
  function TheGraphClient(opts) {
    var _opts$logger,
      _this2 = this,
      _opts$indexTimeout,
      _opts$indexPollInterv;
    _classCallCheck(this, TheGraphClient);
    this.requiredBlockNumber = 0;
    this.serverUrl = opts.serverUrl;
    this.fetch = opts.fetch;
    this.logger = (_opts$logger = opts.logger) !== null && _opts$logger !== void 0 ? _opts$logger : new Logger_1.Logger(module);
    this.indexingState = new IndexingState(function () {
      return _this2.getIndexBlockNumber();
    }, (_opts$indexTimeout = opts.indexTimeout) !== null && _opts$indexTimeout !== void 0 ? _opts$indexTimeout : 60000, (_opts$indexPollInterv = opts.indexPollInterval) !== null && _opts$indexPollInterv !== void 0 ? _opts$indexPollInterv : 1000, this.logger);
  }
  _createClass(TheGraphClient, [{
    key: "queryEntity",
    value: function () {
      var _queryEntity = _asyncToGenerator(function* (query) {
        yield this.indexingState.waitUntilIndexed(this.requiredBlockNumber);
        return this.sendQuery(query);
      });
      function queryEntity(_x) {
        return _queryEntity.apply(this, arguments);
      }
      return queryEntity;
    }()
  }, {
    key: "queryEntities",
    value: function queryEntities(createQuery) {
      var _this = this;
      var parseItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (response) {
        var rootKey = Object.keys(response)[0];
        return response[rootKey];
      };
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
      return _wrapAsyncGenerator(function* () {
        yield _awaitAsyncGenerator(_this.indexingState.waitUntilIndexed(_this.requiredBlockNumber));
        var lastResultSet;
        do {
          var lastId = lastResultSet !== undefined ? lastResultSet[lastResultSet.length - 1].id : '';
          var query = createQuery(lastId, pageSize);
          var response = yield _awaitAsyncGenerator(_this.sendQuery(query));
          var items = parseItems(response);
          yield* _asyncGeneratorDelegate(_asyncIterator(items), _awaitAsyncGenerator);
          lastResultSet = items;
        } while (lastResultSet.length === pageSize);
      })();
    }
  }, {
    key: "updateRequiredBlockNumber",
    value: function updateRequiredBlockNumber(blockNumber) {
      this.requiredBlockNumber = Math.max(blockNumber, this.requiredBlockNumber);
    }
  }, {
    key: "sendQuery",
    value: function () {
      var _sendQuery = _asyncToGenerator(function* (query) {
        this.logger.trace('Send GraphQL query', {
          query: query
        });
        var res = yield this.fetch(this.serverUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            accept: '*/*'
          },
          body: JSON.stringify(query)
        });
        var resText = yield res.text();
        var resJson;
        try {
          resJson = JSON.parse(resText);
        } catch (_unused) {
          throw new Error("GraphQL query failed with \"".concat(resText, "\""));
        }
        this.logger.trace('Received GraphQL response', {
          resJson: resJson
        });
        if (!resJson.data) {
          if (resJson.errors && resJson.errors.length > 0) {
            throw new Error('GraphQL query failed: ' + JSON.stringify(resJson.errors.map(function (e) {
              return e.message;
            })));
          } else {
            throw new Error('GraphQL query failed');
          }
        }
        return resJson.data;
      });
      function sendQuery(_x2) {
        return _sendQuery.apply(this, arguments);
      }
      return sendQuery;
    }()
  }, {
    key: "getIndexBlockNumber",
    value: function () {
      var _getIndexBlockNumber = _asyncToGenerator(function* () {
        var response = yield this.sendQuery({
          query: '{ _meta { block { number } } }'
        });
        // eslint-disable-next-line no-underscore-dangle
        return response._meta.block.number;
      });
      function getIndexBlockNumber() {
        return _getIndexBlockNumber.apply(this, arguments);
      }
      return getIndexBlockNumber;
    }()
  }], [{
    key: "createWhereClause",
    value: function createWhereClause(variables) {
      var parameterList = Object.keys(variables).filter(function (k) {
        return variables[k] !== undefined;
      }).map(function (k) {
        return k + ': $' + k;
      }).join(' ');
      return "where: { ".concat(parameterList, " }");
    }
  }]);
  return TheGraphClient;
}();
exports.TheGraphClient = TheGraphClient;
var BlockNumberGate = /*#__PURE__*/function (_Gate_1$Gate) {
  _inherits(BlockNumberGate, _Gate_1$Gate);
  var _super = _createSuper(BlockNumberGate);
  function BlockNumberGate(blockNumber) {
    var _this3;
    _classCallCheck(this, BlockNumberGate);
    _this3 = _super.call(this, true);
    _this3.blockNumber = blockNumber;
    return _this3;
  }
  return _createClass(BlockNumberGate);
}(Gate_1.Gate);
var IndexingState = /*#__PURE__*/function () {
  function IndexingState(getCurrentBlockNumber, timeout, pollInterval, logger) {
    _classCallCheck(this, IndexingState);
    this.blockNumber = 0;
    this.gates = new Set();
    this.getCurrentBlockNumber = getCurrentBlockNumber;
    this.timeout = timeout;
    this.pollInterval = pollInterval;
    this.logger = logger;
  }
  _createClass(IndexingState, [{
    key: "waitUntilIndexed",
    value: function () {
      var _waitUntilIndexed = _asyncToGenerator(function* (blockNumber) {
        this.logger.debug('Wait until The Graph is synchronized', {
          blockTarget: blockNumber
        });
        var gate = this.getOrCreateGate(blockNumber);
        try {
          yield (0, withTimeout_1.withTimeout)(gate.waitUntilOpen(), this.timeout, "The Graph did not synchronize to block ".concat(blockNumber));
        } catch (e) {
          if (e instanceof withTimeout_1.TimeoutError) {
            this.gates.delete(gate);
          }
          throw e;
        }
      });
      function waitUntilIndexed(_x3) {
        return _waitUntilIndexed.apply(this, arguments);
      }
      return waitUntilIndexed;
    }()
  }, {
    key: "getOrCreateGate",
    value: function getOrCreateGate(blockNumber) {
      var gate = new BlockNumberGate(blockNumber);
      if (blockNumber > this.blockNumber) {
        var isPolling = this.gates.size > 0;
        gate.close();
        this.gates.add(gate);
        if (!isPolling) {
          this.startPolling();
        }
      }
      return gate;
    }
  }, {
    key: "startPolling",
    value: function () {
      var _startPolling = _asyncToGenerator(function* () {
        var _this4 = this;
        this.logger.trace('Start polling');
        while (this.gates.size > 0) {
          var newBlockNumber = yield this.getCurrentBlockNumber();
          if (newBlockNumber !== this.blockNumber) {
            this.blockNumber = newBlockNumber;
            this.logger.trace('Polled', {
              blockNumber: this.blockNumber
            });
            this.gates.forEach(function (gate) {
              if (gate.blockNumber <= _this4.blockNumber) {
                gate.open();
                _this4.gates.delete(gate);
              }
            });
          }
          if (this.gates.size > 0) {
            yield (0, wait_1.wait)(this.pollInterval);
          }
        }
        this.logger.trace('Stop polling');
      });
      function startPolling() {
        return _startPolling.apply(this, arguments);
      }
      return startPolling;
    }()
  }]);
  return IndexingState;
}();

/***/ }),

/***/ "../utils/dist/src/abortableTimers.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.setAbortableInterval = exports.setAbortableTimeout = void 0;
/**
 * setTimeout with AbortSignal support. Aborting will simply clear
 * the timeout silently.
 */
exports.setAbortableTimeout = createAbortableTimerFn(setTimeout, clearTimeout, true);
/**
 * setInterval with AbortSignal support. Aborting will simply clear
 * the interval silently.
 */
exports.setAbortableInterval = createAbortableTimerFn(setInterval, clearInterval, false);
function createAbortableTimerFn(setupTimerFn, clearFn, removeListenerOnCb) {
  return function (callback, ms, abortSignal) {
    if (abortSignal.aborted) {
      return;
    }
    var abortListener = function abortListener() {
      clearFn(timeoutRef);
    };
    abortSignal.addEventListener('abort', abortListener, {
      once: true
    });
    var timeoutRef = setupTimerFn(function () {
      if (removeListenerOnCb) {
        abortSignal.removeEventListener('abort', abortListener);
      }
      callback();
    }, ms);
  };
}

/***/ }),

/***/ "../utils/dist/src/asAbortable.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.finally.js");
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.asAbortable = exports.AbortError = void 0;
var AbortError = /*#__PURE__*/function (_Error) {
  _inherits(AbortError, _Error);
  var _super = _createSuper(AbortError);
  function AbortError(customErrorContext) {
    var _this;
    _classCallCheck(this, AbortError);
    _this = _super.call(this, customErrorContext === undefined ? "aborted" : "".concat(customErrorContext, " aborted"));
    _this.code = 'AbortError';
    return _this;
  }
  return _createClass(AbortError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.AbortError = AbortError;
/**
 * Wraps a Promise into one that can be aborted with `AbortSignal`.
 * Aborting causes the returned Promise to reject with `AbortError` unless
 * the underlying promise itself has already resolved or rejected.
 *
 * Notice that it is the user's responsibility to implement any custom cleanup
 * logic in a `finally` or `catch` block in case of resources that need to be
 * freed up.
 */
function asAbortable(promise, abortSignal, customErrorContext) {
  if (abortSignal === undefined) {
    return promise;
  }
  if (abortSignal.aborted) {
    return Promise.reject(new AbortError(customErrorContext));
  }
  var abortListener;
  return new Promise(function (resolve, reject) {
    abortListener = function abortListener() {
      reject(new AbortError(customErrorContext));
    };
    abortSignal.addEventListener('abort', abortListener);
    promise.then(resolve, reject);
  }).finally(function () {
    abortSignal.removeEventListener('abort', abortListener);
  });
}
exports.asAbortable = asAbortable;

/***/ }),

/***/ "../utils/dist/src/collect.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.async-iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }
function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.collect = void 0;
var collect = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (source, maxCount) {
    if (maxCount !== undefined && maxCount <= 0) {
      return [];
    }
    var items = [];
    var _iteratorAbruptCompletion = false;
    var _didIteratorError = false;
    var _iteratorError;
    try {
      for (var _iterator = _asyncIterator(source), _step; _iteratorAbruptCompletion = !(_step = yield _iterator.next()).done; _iteratorAbruptCompletion = false) {
        var item = _step.value;
        {
          items.push(item);
          if (maxCount !== undefined && items.length >= maxCount) {
            break;
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (_iteratorAbruptCompletion && _iterator.return != null) {
          yield _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    return items;
  });
  return function collect(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
exports.collect = collect;

/***/ }),

/***/ "../utils/dist/src/composeAbortSignals.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.find.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.composeAbortSignals = void 0;
/**
 * Compose a single AbortSignal from multiple AbortSignals with "OR" logic.
 */
function composeAbortSignals() {
  for (var _len = arguments.length, signals = new Array(_len), _key = 0; _key < _len; _key++) {
    signals[_key] = arguments[_key];
  }
  if (signals.length === 0) {
    throw new Error('must provide at least one AbortSignal');
  }
  var preAbortedSignal = signals.find(function (s) {
    return s.aborted;
  });
  if (preAbortedSignal !== undefined) {
    return preAbortedSignal;
  }
  var abortController = new AbortController();
  var abort = function abort() {
    for (var _i = 0, _signals = signals; _i < _signals.length; _i++) {
      var signal = _signals[_i];
      signal.removeEventListener('abort', abort);
    }
    signals = []; // allow gc
    abortController.abort();
  };
  for (var _i2 = 0, _signals2 = signals; _i2 < _signals2.length; _i2++) {
    var signal = _signals2[_i2];
    signal.addEventListener('abort', abort);
  }
  return abortController.signal;
}
exports.composeAbortSignals = composeAbortSignals;

/***/ }),

/***/ "../utils/dist/src/exports.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.RateMetric = exports.MetricsContext = exports.Metric = exports.LevelMetric = exports.CountMetric = exports.TheGraphClient = exports.Gate = exports.collect = exports.merge = exports.initEventGateway = exports.ObservableEventEmitter = exports.withTimeout = exports.withRateLimit = exports.waitForEvent = exports.waitForCondition = exports.wait = exports.toEthereumAddressOrENSName = exports.toEthereumAddress = exports.toENSName = exports.setAbortableTimeout = exports.setAbortableInterval = exports.scheduleAtInterval = exports.scheduleAtFixedRate = exports.randomString = exports.keyToArrayIndex = exports.isENSName = exports.composeAbortSignals = exports.asAbortable = exports.pTransaction = exports.TimeoutError = exports.AbortError = exports.Multimap = exports.Logger = exports.Defer = void 0;
var pTransaction_1 = __webpack_require__("../utils/dist/src/pTransaction.js");
Object.defineProperty(exports, "pTransaction", ({
  enumerable: true,
  get: function get() {
    return pTransaction_1.pTransaction;
  }
}));
var asAbortable_1 = __webpack_require__("../utils/dist/src/asAbortable.js");
Object.defineProperty(exports, "AbortError", ({
  enumerable: true,
  get: function get() {
    return asAbortable_1.AbortError;
  }
}));
Object.defineProperty(exports, "asAbortable", ({
  enumerable: true,
  get: function get() {
    return asAbortable_1.asAbortable;
  }
}));
var abortableTimers_1 = __webpack_require__("../utils/dist/src/abortableTimers.js");
Object.defineProperty(exports, "setAbortableInterval", ({
  enumerable: true,
  get: function get() {
    return abortableTimers_1.setAbortableInterval;
  }
}));
Object.defineProperty(exports, "setAbortableTimeout", ({
  enumerable: true,
  get: function get() {
    return abortableTimers_1.setAbortableTimeout;
  }
}));
var Defer_1 = __webpack_require__("../utils/dist/src/Defer.js");
Object.defineProperty(exports, "Defer", ({
  enumerable: true,
  get: function get() {
    return Defer_1.Defer;
  }
}));
var ENSName_1 = __webpack_require__("../utils/dist/src/ENSName.js");
Object.defineProperty(exports, "toENSName", ({
  enumerable: true,
  get: function get() {
    return ENSName_1.toENSName;
  }
}));
var EthereumAddress_1 = __webpack_require__("../utils/dist/src/EthereumAddress.js");
Object.defineProperty(exports, "toEthereumAddress", ({
  enumerable: true,
  get: function get() {
    return EthereumAddress_1.toEthereumAddress;
  }
}));
var isENSName_1 = __webpack_require__("../utils/dist/src/isENSName.js");
Object.defineProperty(exports, "isENSName", ({
  enumerable: true,
  get: function get() {
    return isENSName_1.isENSName;
  }
}));
var keyToArrayIndex_1 = __webpack_require__("../utils/dist/src/keyToArrayIndex.js");
Object.defineProperty(exports, "keyToArrayIndex", ({
  enumerable: true,
  get: function get() {
    return keyToArrayIndex_1.keyToArrayIndex;
  }
}));
var Logger_1 = __webpack_require__("../utils/dist/src/Logger.js");
Object.defineProperty(exports, "Logger", ({
  enumerable: true,
  get: function get() {
    return Logger_1.Logger;
  }
}));
var Metric_1 = __webpack_require__("../utils/dist/src/Metric.js");
Object.defineProperty(exports, "CountMetric", ({
  enumerable: true,
  get: function get() {
    return Metric_1.CountMetric;
  }
}));
Object.defineProperty(exports, "Metric", ({
  enumerable: true,
  get: function get() {
    return Metric_1.Metric;
  }
}));
Object.defineProperty(exports, "LevelMetric", ({
  enumerable: true,
  get: function get() {
    return Metric_1.LevelMetric;
  }
}));
Object.defineProperty(exports, "MetricsContext", ({
  enumerable: true,
  get: function get() {
    return Metric_1.MetricsContext;
  }
}));
Object.defineProperty(exports, "RateMetric", ({
  enumerable: true,
  get: function get() {
    return Metric_1.RateMetric;
  }
}));
var Multimap_1 = __webpack_require__("../utils/dist/src/Multimap.js");
Object.defineProperty(exports, "Multimap", ({
  enumerable: true,
  get: function get() {
    return Multimap_1.Multimap;
  }
}));
var randomString_1 = __webpack_require__("../utils/dist/src/randomString.js");
Object.defineProperty(exports, "randomString", ({
  enumerable: true,
  get: function get() {
    return randomString_1.randomString;
  }
}));
var scheduleAtFixedRate_1 = __webpack_require__("../utils/dist/src/scheduleAtFixedRate.js");
Object.defineProperty(exports, "scheduleAtFixedRate", ({
  enumerable: true,
  get: function get() {
    return scheduleAtFixedRate_1.scheduleAtFixedRate;
  }
}));
var scheduleAtInterval_1 = __webpack_require__("../utils/dist/src/scheduleAtInterval.js");
Object.defineProperty(exports, "scheduleAtInterval", ({
  enumerable: true,
  get: function get() {
    return scheduleAtInterval_1.scheduleAtInterval;
  }
}));
var toEthereumAddressOrENSName_1 = __webpack_require__("../utils/dist/src/toEthereumAddressOrENSName.js");
Object.defineProperty(exports, "toEthereumAddressOrENSName", ({
  enumerable: true,
  get: function get() {
    return toEthereumAddressOrENSName_1.toEthereumAddressOrENSName;
  }
}));
var wait_1 = __webpack_require__("../utils/dist/src/wait.js");
Object.defineProperty(exports, "wait", ({
  enumerable: true,
  get: function get() {
    return wait_1.wait;
  }
}));
var waitForEvent_1 = __webpack_require__("../utils/dist/src/waitForEvent.js");
Object.defineProperty(exports, "waitForEvent", ({
  enumerable: true,
  get: function get() {
    return waitForEvent_1.waitForEvent;
  }
}));
var withTimeout_1 = __webpack_require__("../utils/dist/src/withTimeout.js");
Object.defineProperty(exports, "TimeoutError", ({
  enumerable: true,
  get: function get() {
    return withTimeout_1.TimeoutError;
  }
}));
Object.defineProperty(exports, "withTimeout", ({
  enumerable: true,
  get: function get() {
    return withTimeout_1.withTimeout;
  }
}));
var composeAbortSignals_1 = __webpack_require__("../utils/dist/src/composeAbortSignals.js");
Object.defineProperty(exports, "composeAbortSignals", ({
  enumerable: true,
  get: function get() {
    return composeAbortSignals_1.composeAbortSignals;
  }
}));
var waitForCondition_1 = __webpack_require__("../utils/dist/src/waitForCondition.js");
Object.defineProperty(exports, "waitForCondition", ({
  enumerable: true,
  get: function get() {
    return waitForCondition_1.waitForCondition;
  }
}));
var withRateLimit_1 = __webpack_require__("../utils/dist/src/withRateLimit.js");
Object.defineProperty(exports, "withRateLimit", ({
  enumerable: true,
  get: function get() {
    return withRateLimit_1.withRateLimit;
  }
}));
var ObservableEventEmitter_1 = __webpack_require__("../utils/dist/src/ObservableEventEmitter.js");
Object.defineProperty(exports, "ObservableEventEmitter", ({
  enumerable: true,
  get: function get() {
    return ObservableEventEmitter_1.ObservableEventEmitter;
  }
}));
var initEventGateway_1 = __webpack_require__("../utils/dist/src/initEventGateway.js");
Object.defineProperty(exports, "initEventGateway", ({
  enumerable: true,
  get: function get() {
    return initEventGateway_1.initEventGateway;
  }
}));
var merge_1 = __webpack_require__("../utils/dist/src/merge.js");
Object.defineProperty(exports, "merge", ({
  enumerable: true,
  get: function get() {
    return merge_1.merge;
  }
}));
var collect_1 = __webpack_require__("../utils/dist/src/collect.js");
Object.defineProperty(exports, "collect", ({
  enumerable: true,
  get: function get() {
    return collect_1.collect;
  }
}));
var Gate_1 = __webpack_require__("../utils/dist/src/Gate.js");
Object.defineProperty(exports, "Gate", ({
  enumerable: true,
  get: function get() {
    return Gate_1.Gate;
  }
}));
var TheGraphClient_1 = __webpack_require__("../utils/dist/src/TheGraphClient.js");
Object.defineProperty(exports, "TheGraphClient", ({
  enumerable: true,
  get: function get() {
    return TheGraphClient_1.TheGraphClient;
  }
}));

/***/ }),

/***/ "../utils/dist/src/initEventGateway.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.initEventGateway = void 0;
/*
 * Initializes a gateway which can produce events to the given emitter. The gateway is running
 * when there are any listeners for the given eventName: the start() callback is called
 * when a first event listener for the event name is added, and the stop() callback is called
 * when the last event listener is removed.
 */
var initEventGateway = function initEventGateway(eventName, start, stop, emitter) {
  var observer = emitter.getObserver();
  var emit = function emit(payload) {
    return emitter.emit(eventName, payload);
  };
  var producer;
  observer.on('addEventListener', function (sourceEvent) {
    if (sourceEvent === eventName && producer === undefined) {
      producer = start(emit);
    }
  });
  observer.on('removeEventListener', function (sourceEvent) {
    if (sourceEvent === eventName && producer !== undefined && emitter.getListenerCount(eventName) === 0) {
      stop(producer);
      producer = undefined;
    }
  });
  if (emitter.getListenerCount(eventName) > 0) {
    producer = start(emit);
  }
};
exports.initEventGateway = initEventGateway;

/***/ }),

/***/ "../utils/dist/src/isENSName.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isENSName = void 0;
var ENSName_1 = __webpack_require__("../utils/dist/src/ENSName.js");
function isENSName(domain) {
  return (0, ENSName_1.isENSNameFormatIgnoreCase)(domain);
}
exports.isENSName = isENSName;

/***/ }),

/***/ "../utils/dist/src/keyToArrayIndex.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.is-safe-integer.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.keyToArrayIndex = void 0;
var crypto_1 = __importDefault(__webpack_require__("../../node_modules/crypto-browserify/index.js"));
/**
 * Computes a deterministic index for a given string or number key.
 * Used for deterministically selecting an entry from an ordered list
 * for various load balancing and partitioning purposes.
 *
 * @param lengthOfArray Number of items to select from
 * @param key Input string or number
 * @returns Array index between [0..lengthOfArray-1]
 */
function keyToArrayIndex(lengthOfArray, key) {
  if (!(Number.isSafeInteger(lengthOfArray) && lengthOfArray > 0)) {
    throw new Error("lengthOfArray is not a safe positive integer! ".concat(lengthOfArray));
  }
  if (lengthOfArray === 1) {
    // Fast common case
    return 0;
  }
  // Number key handling
  if (typeof key === 'number') {
    return Math.abs(key) % lengthOfArray;
  }
  // String key handling
  var buffer = crypto_1.default.createHash('md5').update(key).digest();
  var intHash = buffer.readInt32LE(0);
  return Math.abs(intHash) % lengthOfArray;
}
exports.keyToArrayIndex = keyToArrayIndex;

/***/ }),

/***/ "../utils/dist/src/merge.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.entries.js");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.merge = void 0;
var merge = function merge() {
  var result = {};
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
    var source = _sources[_i];
    if (source !== undefined) {
      for (var _i2 = 0, _Object$entries = Object.entries(source); _i2 < _Object$entries.length; _i2++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (value !== undefined) {
          result[key] = value;
        }
      }
    }
  }
  return result;
};
exports.merge = merge;

/***/ }),

/***/ "../utils/dist/src/pTransaction.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/esnext.promise.all-settled.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.map.js");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.pTransaction = void 0;
/**
 * Given an iterable of promises, settles them one at a time.
 * If all of them resolve, returns the list of values.
 * If one of them rejects, provides a callback for reverting the
 * preceding (already resolved) values.
 */
function pTransaction(_x, _x2) {
  return _pTransaction.apply(this, arguments);
}
function _pTransaction() {
  _pTransaction = _asyncToGenerator(function* (promises, rollback) {
    var results = [];
    var _iterator = _createForOfIteratorHelper(promises),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var promise = _step.value;
        try {
          results.push(yield promise);
        } catch (err) {
          yield Promise.allSettled(results.map(function (r) {
            return rollback(r);
          }));
          throw err;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return results;
  });
  return _pTransaction.apply(this, arguments);
}
exports.pTransaction = pTransaction;

/***/ }),

/***/ "../utils/dist/src/randomString.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.randomString = exports.DEFAULT_CHARSET = void 0;
exports.DEFAULT_CHARSET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
// From: https://stackoverflow.com/questions/10726909/random-alpha-numeric-string-in-javascript
function randomString(length) {
  var charset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : exports.DEFAULT_CHARSET;
  var result = '';
  for (var i = 0; i < length; ++i) {
    result += charset[Math.floor(Math.random() * charset.length)];
  }
  return result;
}
exports.randomString = randomString;

/***/ }),

/***/ "../utils/dist/src/scheduleAtFixedRate.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.repeatScheduleTask = exports.scheduleAtFixedRate = void 0;
var abortableTimers_1 = __webpack_require__("../utils/dist/src/abortableTimers.js");
/*
 * @param {number} interval - execute task when UTC timestamp is divisible by the given interval
 *                            e.g. scheduleAtFixedRate(() => {},  24 * 60 * 60 * 1000) triggers the
 *                            task once a day at 00:00 UTC
 *                            (but no tasks will be executed concurrently: if a previous task is
 *                            still ongoing when the next task should, the new task is silently skipped)
 */
var scheduleAtFixedRate = function scheduleAtFixedRate(task, interval, abortSignal) {
  var initTime = Date.now();
  var invocationTime = initTime - initTime % interval;
  (0, exports.repeatScheduleTask)(function (doneCb) {
    var now = Date.now();
    invocationTime += interval;
    if (now < invocationTime) {
      (0, abortableTimers_1.setAbortableTimeout)( /*#__PURE__*/_asyncToGenerator(function* () {
        yield task(invocationTime);
        doneCb();
      }), invocationTime - now, abortSignal);
    } else {
      doneCb();
    }
  }, abortSignal);
};
exports.scheduleAtFixedRate = scheduleAtFixedRate;
/** @internal */
var repeatScheduleTask = function repeatScheduleTask(scheduleNextTask, abortSignal) {
  var scheduleNext = function scheduleNext() {
    if (!(abortSignal !== null && abortSignal !== void 0 && abortSignal.aborted)) {
      scheduleNextTask(scheduleNext);
    }
  };
  scheduleNext();
};
exports.repeatScheduleTask = repeatScheduleTask;

/***/ }),

/***/ "../utils/dist/src/scheduleAtInterval.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.scheduleAtInterval = void 0;
/*
 * @param {number} interval - number of milliseconds to wait after a task is completed
 */
var scheduleAtFixedRate_1 = __webpack_require__("../utils/dist/src/scheduleAtFixedRate.js");
var abortableTimers_1 = __webpack_require__("../utils/dist/src/abortableTimers.js");
var scheduleAtInterval = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (task, interval, executeAtStart, abortSignal) {
    if (abortSignal !== null && abortSignal !== void 0 && abortSignal.aborted) {
      return;
    }
    if (executeAtStart) {
      yield task();
    }
    (0, scheduleAtFixedRate_1.repeatScheduleTask)(function (doneCb) {
      (0, abortableTimers_1.setAbortableTimeout)( /*#__PURE__*/_asyncToGenerator(function* () {
        yield task();
        doneCb();
      }), interval, abortSignal);
    }, abortSignal);
  });
  return function scheduleAtInterval(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
exports.scheduleAtInterval = scheduleAtInterval;

/***/ }),

/***/ "../utils/dist/src/toEthereumAddressOrENSName.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.toEthereumAddressOrENSName = void 0;
var EthereumAddress_1 = __webpack_require__("../utils/dist/src/EthereumAddress.js");
var ENSName_1 = __webpack_require__("../utils/dist/src/ENSName.js");
function toEthereumAddressOrENSName(str) {
  return (0, ENSName_1.isENSNameFormatIgnoreCase)(str) ? (0, ENSName_1.toENSName)(str) : (0, EthereumAddress_1.toEthereumAddress)(str);
}
exports.toEthereumAddressOrENSName = toEthereumAddressOrENSName;

/***/ }),

/***/ "../utils/dist/src/wait.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.finally.js");
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.wait = void 0;
var asAbortable_1 = __webpack_require__("../utils/dist/src/asAbortable.js");
/**
 * Wait for a specific time
 * @param ms time to wait for in milliseconds
 * @param abortSignal to control abortion of any wait
 * @returns {Promise<void>} resolves when time has passed
 */
function wait(ms, abortSignal) {
  var timeoutRef;
  return (0, asAbortable_1.asAbortable)(new Promise(function (resolve) {
    timeoutRef = setTimeout(resolve, ms);
  }), abortSignal).finally(function () {
    clearTimeout(timeoutRef);
  });
}
exports.wait = wait;

/***/ }),

/***/ "../utils/dist/src/waitForCondition.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.from.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.slice.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.waitForCondition = void 0;
var asAbortable_1 = __webpack_require__("../utils/dist/src/asAbortable.js");
var wait_1 = __webpack_require__("../utils/dist/src/wait.js");
var compact_1 = __importDefault(__webpack_require__("../../node_modules/lodash/compact.js"));
var composeAbortSignals_1 = __webpack_require__("../utils/dist/src/composeAbortSignals.js");
function throwError(userAborted, conditionFn, onTimeoutContext) {
  var action = userAborted ? 'aborted' : 'timed out';
  var msg = "waitForCondition: ".concat(action, " before \"").concat(conditionFn.toString(), "\" became true");
  if (onTimeoutContext) {
    msg += "\n".concat(onTimeoutContext());
  }
  throw new Error(msg);
}
/**
 * Wait for a condition to become true by re-evaluating `conditionFn` every `retryInterval` milliseconds.
 *
 * @param conditionFn condition to be evaluated; should return boolean or Promise<boolean> and have
 * no side effects.
 * @param timeout amount of time in milliseconds to wait for
 * @param retryInterval how often, in milliseconds, to re-evaluate condition
 * @param abortSignal pass an abort signal to cancel prematurely
 * @param onTimeoutContext evaluated only on timeout. Used to associate human-friendly textual context to error.
 * @returns {Promise<void>} resolves immediately if
 * conditionFn evaluates to true on a retry attempt within timeout. If timeout
 * is reached with conditionFn never evaluating to true, rejects.
 */
var waitForCondition = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (conditionFn) {
    var _abortSignal$aborted;
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
    var retryInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var abortSignal = arguments.length > 3 ? arguments[3] : undefined;
    var onTimeoutContext = arguments.length > 4 ? arguments[4] : undefined;
    var userAborted = (_abortSignal$aborted = abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) !== null && _abortSignal$aborted !== void 0 ? _abortSignal$aborted : false;
    if (userAborted) {
      throwError(userAborted, conditionFn, onTimeoutContext);
    }
    abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.addEventListener('abort', function () {
      userAborted = true;
    }, {
      once: true
    });
    var timeoutAbortSignal = AbortSignal.timeout(timeout); // TODO: remove `as any` cast when @types/node has support...
    var composedSignal = (0, composeAbortSignals_1.composeAbortSignals).apply(void 0, _toConsumableArray((0, compact_1.default)([timeoutAbortSignal, abortSignal])));
    try {
      // eslint-disable-next-line no-constant-condition
      while (true) {
        var result = yield (0, asAbortable_1.asAbortable)(Promise.resolve(conditionFn()), composedSignal);
        if (result) {
          return;
        }
        yield (0, wait_1.wait)(retryInterval, composedSignal);
      }
    } catch (e) {
      if (e.code === 'AbortError') {
        throwError(userAborted, conditionFn, onTimeoutContext);
      }
      throw e;
    }
  });
  return function waitForCondition(_x) {
    return _ref.apply(this, arguments);
  };
}();
exports.waitForCondition = waitForCondition;

/***/ }),

/***/ "../utils/dist/src/waitForEvent.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.finally.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.waitForEvent = void 0;
var withTimeout_1 = __webpack_require__("../utils/dist/src/withTimeout.js");
/**
 * Wait for an event to be emitted on emitter within timeout.
 *
 * @param emitter emitter of event
 * @param eventName event to wait for
 * @param timeout amount of time in milliseconds to wait for
 * @param predicate function that gets passed the event arguments, should return true if event accepted
 * @param abortSignal
 * @returns {Promise<unknown[]>} resolves with event arguments if event occurred within timeout else rejects
 */
function waitForEvent(_x, _x2) {
  return _waitForEvent.apply(this, arguments);
}
function _waitForEvent() {
  _waitForEvent = _asyncToGenerator(function* (emitter, eventName) {
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
    var predicate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
      return true;
    };
    var abortSignal = arguments.length > 4 ? arguments[4] : undefined;
    var listener;
    // eslint-disable-next-line no-async-promise-executor
    var task = new Promise(function (resolve) {
      listener = function listener() {
        for (var _len = arguments.length, eventArgs = new Array(_len), _key = 0; _key < _len; _key++) {
          eventArgs[_key] = arguments[_key];
        }
        if (predicate.apply(void 0, eventArgs)) {
          resolve(eventArgs);
        }
      };
      emitter.on(eventName, listener);
    });
    return (0, withTimeout_1.withTimeout)(task, timeout, 'waitForEvent', abortSignal).finally(function () {
      emitter.off(eventName, listener);
    });
  });
  return _waitForEvent.apply(this, arguments);
}
exports.waitForEvent = waitForEvent;

/***/ }),

/***/ "../utils/dist/src/withRateLimit.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.withRateLimit = void 0;
/**
 * Wraps a rate limiter around a function that ensures the function is invoked max once per `intervalInMs`.
 */
function withRateLimit(fn, intervalInMs) {
  var lastInvocationTimestamp = 0;
  return /*#__PURE__*/_asyncToGenerator(function* () {
    var now = Date.now();
    if (now - lastInvocationTimestamp >= intervalInMs) {
      lastInvocationTimestamp = now;
      yield fn();
    }
  });
}
exports.withRateLimit = withRateLimit;

/***/ }),

/***/ "../utils/dist/src/withTimeout.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
__webpack_require__("../../node_modules/core-js/modules/es.object.set-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-prototype-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.index-of.js");
__webpack_require__("../../node_modules/core-js/modules/es.regexp.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.reflect.construct.js");
__webpack_require__("../../node_modules/core-js/modules/es.map.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.date.to-primitive.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.description.js");
__webpack_require__("../../node_modules/core-js/modules/es.number.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.define-property.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.concat.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.to-string.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.finally.js");
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/es.string.iterator.js");
__webpack_require__("../../node_modules/core-js/modules/web.dom-collections.iterator.js");
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.withTimeout = exports.TimeoutError = void 0;
var asAbortable_1 = __webpack_require__("../utils/dist/src/asAbortable.js");
var TimeoutError = /*#__PURE__*/function (_Error) {
  _inherits(TimeoutError, _Error);
  var _super = _createSuper(TimeoutError);
  function TimeoutError(timeoutInMs, customErrorContext) {
    var _this;
    _classCallCheck(this, TimeoutError);
    _this = _super.call(this, customErrorContext === undefined ? "timed out after ".concat(timeoutInMs, " ms") : "".concat(customErrorContext, " (timed out after ").concat(timeoutInMs, " ms)"));
    _this.code = 'TimeoutError';
    return _this;
  }
  return _createClass(TimeoutError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
exports.TimeoutError = TimeoutError;
var withTimeout = function withTimeout(task, timeoutInMs, customErrorContext, abortSignal) {
  var timeoutRef;
  return (0, asAbortable_1.asAbortable)(Promise.race([task, new Promise(function (_resolve, reject) {
    timeoutRef = setTimeout(function () {
      reject(new TimeoutError(timeoutInMs, customErrorContext));
    }, timeoutInMs);
  })]), abortSignal, customErrorContext).finally(function () {
    clearTimeout(timeoutRef);
  });
};
exports.withTimeout = withTimeout;

/***/ }),

/***/ "../../node_modules/base64-js/index.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "../../node_modules/bech32/index.js":
/***/ ((module) => {

"use strict";

var ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l'

// pre-compute lookup table
var ALPHABET_MAP = {}
for (var z = 0; z < ALPHABET.length; z++) {
  var x = ALPHABET.charAt(z)

  if (ALPHABET_MAP[x] !== undefined) throw new TypeError(x + ' is ambiguous')
  ALPHABET_MAP[x] = z
}

function polymodStep (pre) {
  var b = pre >> 25
  return ((pre & 0x1FFFFFF) << 5) ^
    (-((b >> 0) & 1) & 0x3b6a57b2) ^
    (-((b >> 1) & 1) & 0x26508e6d) ^
    (-((b >> 2) & 1) & 0x1ea119fa) ^
    (-((b >> 3) & 1) & 0x3d4233dd) ^
    (-((b >> 4) & 1) & 0x2a1462b3)
}

function prefixChk (prefix) {
  var chk = 1
  for (var i = 0; i < prefix.length; ++i) {
    var c = prefix.charCodeAt(i)
    if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')'

    chk = polymodStep(chk) ^ (c >> 5)
  }
  chk = polymodStep(chk)

  for (i = 0; i < prefix.length; ++i) {
    var v = prefix.charCodeAt(i)
    chk = polymodStep(chk) ^ (v & 0x1f)
  }
  return chk
}

function encode (prefix, words, LIMIT) {
  LIMIT = LIMIT || 90
  if ((prefix.length + 7 + words.length) > LIMIT) throw new TypeError('Exceeds length limit')

  prefix = prefix.toLowerCase()

  // determine chk mod
  var chk = prefixChk(prefix)
  if (typeof chk === 'string') throw new Error(chk)

  var result = prefix + '1'
  for (var i = 0; i < words.length; ++i) {
    var x = words[i]
    if ((x >> 5) !== 0) throw new Error('Non 5-bit word')

    chk = polymodStep(chk) ^ x
    result += ALPHABET.charAt(x)
  }

  for (i = 0; i < 6; ++i) {
    chk = polymodStep(chk)
  }
  chk ^= 1

  for (i = 0; i < 6; ++i) {
    var v = (chk >> ((5 - i) * 5)) & 0x1f
    result += ALPHABET.charAt(v)
  }

  return result
}

function __decode (str, LIMIT) {
  LIMIT = LIMIT || 90
  if (str.length < 8) return str + ' too short'
  if (str.length > LIMIT) return 'Exceeds length limit'

  // don't allow mixed case
  var lowered = str.toLowerCase()
  var uppered = str.toUpperCase()
  if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str
  str = lowered

  var split = str.lastIndexOf('1')
  if (split === -1) return 'No separator character for ' + str
  if (split === 0) return 'Missing prefix for ' + str

  var prefix = str.slice(0, split)
  var wordChars = str.slice(split + 1)
  if (wordChars.length < 6) return 'Data too short'

  var chk = prefixChk(prefix)
  if (typeof chk === 'string') return chk

  var words = []
  for (var i = 0; i < wordChars.length; ++i) {
    var c = wordChars.charAt(i)
    var v = ALPHABET_MAP[c]
    if (v === undefined) return 'Unknown character ' + c
    chk = polymodStep(chk) ^ v

    // not in the checksum?
    if (i + 6 >= wordChars.length) continue
    words.push(v)
  }

  if (chk !== 1) return 'Invalid checksum for ' + str
  return { prefix: prefix, words: words }
}

function decodeUnsafe () {
  var res = __decode.apply(null, arguments)
  if (typeof res === 'object') return res
}

function decode (str) {
  var res = __decode.apply(null, arguments)
  if (typeof res === 'object') return res

  throw new Error(res)
}

function convert (data, inBits, outBits, pad) {
  var value = 0
  var bits = 0
  var maxV = (1 << outBits) - 1

  var result = []
  for (var i = 0; i < data.length; ++i) {
    value = (value << inBits) | data[i]
    bits += inBits

    while (bits >= outBits) {
      bits -= outBits
      result.push((value >> bits) & maxV)
    }
  }

  if (pad) {
    if (bits > 0) {
      result.push((value << (outBits - bits)) & maxV)
    }
  } else {
    if (bits >= inBits) return 'Excess padding'
    if ((value << (outBits - bits)) & maxV) return 'Non-zero padding'
  }

  return result
}

function toWordsUnsafe (bytes) {
  var res = convert(bytes, 8, 5, true)
  if (Array.isArray(res)) return res
}

function toWords (bytes) {
  var res = convert(bytes, 8, 5, true)
  if (Array.isArray(res)) return res

  throw new Error(res)
}

function fromWordsUnsafe (words) {
  var res = convert(words, 5, 8, false)
  if (Array.isArray(res)) return res
}

function fromWords (words) {
  var res = convert(words, 5, 8, false)
  if (Array.isArray(res)) return res

  throw new Error(res)
}

module.exports = {
  decodeUnsafe: decodeUnsafe,
  decode: decode,
  encode: encode,
  toWordsUnsafe: toWordsUnsafe,
  toWords: toWords,
  fromWordsUnsafe: fromWordsUnsafe,
  fromWords: fromWords
}


/***/ }),

/***/ "../../node_modules/bn.js/lib/bn.js":
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // '0' - '9'
    if (c >= 48 && c <= 57) {
      return c - 48;
    // 'A' - 'F'
    } else if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    } else {
      assert(false, 'Invalid character in ' + string);
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this._strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ "../../node_modules/brorand/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__("../../node_modules/crypto-browserify/index.js");
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),

/***/ "../../node_modules/browserify-aes/aes.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),

/***/ "../../node_modules/browserify-aes/authCipher.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aes = __webpack_require__("../../node_modules/browserify-aes/aes.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var Transform = __webpack_require__("../../node_modules/cipher-base/index.js")
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var GHASH = __webpack_require__("../../node_modules/browserify-aes/ghash.js")
var xor = __webpack_require__("../../node_modules/buffer-xor/index.js")
var incr32 = __webpack_require__("../../node_modules/browserify-aes/incr32.js")

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),

/***/ "../../node_modules/browserify-aes/browser.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var ciphers = __webpack_require__("../../node_modules/browserify-aes/encrypter.js")
var deciphers = __webpack_require__("../../node_modules/browserify-aes/decrypter.js")
var modes = __webpack_require__("../../node_modules/browserify-aes/modes/list.json")

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ "../../node_modules/browserify-aes/decrypter.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var AuthCipher = __webpack_require__("../../node_modules/browserify-aes/authCipher.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var MODES = __webpack_require__("../../node_modules/browserify-aes/modes/index.js")
var StreamCipher = __webpack_require__("../../node_modules/browserify-aes/streamCipher.js")
var Transform = __webpack_require__("../../node_modules/cipher-base/index.js")
var aes = __webpack_require__("../../node_modules/browserify-aes/aes.js")
var ebtk = __webpack_require__("../../node_modules/evp_bytestokey/index.js")
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),

/***/ "../../node_modules/browserify-aes/encrypter.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var MODES = __webpack_require__("../../node_modules/browserify-aes/modes/index.js")
var AuthCipher = __webpack_require__("../../node_modules/browserify-aes/authCipher.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var StreamCipher = __webpack_require__("../../node_modules/browserify-aes/streamCipher.js")
var Transform = __webpack_require__("../../node_modules/cipher-base/index.js")
var aes = __webpack_require__("../../node_modules/browserify-aes/aes.js")
var ebtk = __webpack_require__("../../node_modules/evp_bytestokey/index.js")
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),

/***/ "../../node_modules/browserify-aes/ghash.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),

/***/ "../../node_modules/browserify-aes/incr32.js":
/***/ ((module) => {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),

/***/ "../../node_modules/browserify-aes/modes/cbc.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var xor = __webpack_require__("../../node_modules/buffer-xor/index.js")

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),

/***/ "../../node_modules/browserify-aes/modes/cfb.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var xor = __webpack_require__("../../node_modules/buffer-xor/index.js")

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),

/***/ "../../node_modules/browserify-aes/modes/cfb1.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ "../../node_modules/browserify-aes/modes/cfb8.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ "../../node_modules/browserify-aes/modes/ctr.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var xor = __webpack_require__("../../node_modules/buffer-xor/index.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var incr32 = __webpack_require__("../../node_modules/browserify-aes/incr32.js")

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),

/***/ "../../node_modules/browserify-aes/modes/ecb.js":
/***/ ((__unused_webpack_module, exports) => {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),

/***/ "../../node_modules/browserify-aes/modes/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var modeModules = {
  ECB: __webpack_require__("../../node_modules/browserify-aes/modes/ecb.js"),
  CBC: __webpack_require__("../../node_modules/browserify-aes/modes/cbc.js"),
  CFB: __webpack_require__("../../node_modules/browserify-aes/modes/cfb.js"),
  CFB8: __webpack_require__("../../node_modules/browserify-aes/modes/cfb8.js"),
  CFB1: __webpack_require__("../../node_modules/browserify-aes/modes/cfb1.js"),
  OFB: __webpack_require__("../../node_modules/browserify-aes/modes/ofb.js"),
  CTR: __webpack_require__("../../node_modules/browserify-aes/modes/ctr.js"),
  GCM: __webpack_require__("../../node_modules/browserify-aes/modes/ctr.js")
}

var modes = __webpack_require__("../../node_modules/browserify-aes/modes/list.json")

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),

/***/ "../../node_modules/browserify-aes/modes/ofb.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];
var xor = __webpack_require__("../../node_modules/buffer-xor/index.js")

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),

/***/ "../../node_modules/browserify-aes/streamCipher.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aes = __webpack_require__("../../node_modules/browserify-aes/aes.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var Transform = __webpack_require__("../../node_modules/cipher-base/index.js")
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),

/***/ "../../node_modules/browserify-cipher/browser.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DES = __webpack_require__("../../node_modules/browserify-des/index.js")
var aes = __webpack_require__("../../node_modules/browserify-aes/browser.js")
var aesModes = __webpack_require__("../../node_modules/browserify-aes/modes/index.js")
var desModes = __webpack_require__("../../node_modules/browserify-des/modes.js")
var ebtk = __webpack_require__("../../node_modules/evp_bytestokey/index.js")

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ "../../node_modules/browserify-des/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var CipherBase = __webpack_require__("../../node_modules/cipher-base/index.js")
var des = __webpack_require__("../../node_modules/des.js/lib/des.js")
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),

/***/ "../../node_modules/browserify-des/modes.js":
/***/ ((__unused_webpack_module, exports) => {

exports["des-ecb"] = {
  key: 8,
  iv: 0
}
exports["des-cbc"] = exports.des = {
  key: 8,
  iv: 8
}
exports["des-ede3-cbc"] = exports.des3 = {
  key: 24,
  iv: 8
}
exports["des-ede3"] = {
  key: 24,
  iv: 0
}
exports["des-ede-cbc"] = {
  key: 16,
  iv: 8
}
exports["des-ede"] = {
  key: 16,
  iv: 0
}


/***/ }),

/***/ "../../node_modules/browserify-rsa/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];
var BN = __webpack_require__("../../node_modules/bn.js/lib/bn.js")
var randomBytes = __webpack_require__("../../node_modules/randombytes/browser.js")

function blind (priv) {
  var r = getr(priv)
  var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed()
  return { blinder: blinder, unblinder: r.invm(priv.modulus) }
}

function getr (priv) {
  var len = priv.modulus.byteLength()
  var r
  do {
    r = new BN(randomBytes(len))
  } while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))
  return r
}

function crt (msg, priv) {
  var blinds = blind(priv)
  var len = priv.modulus.byteLength()
  var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus)
  var c1 = blinded.toRed(BN.mont(priv.prime1))
  var c2 = blinded.toRed(BN.mont(priv.prime2))
  var qinv = priv.coefficient
  var p = priv.prime1
  var q = priv.prime2
  var m1 = c1.redPow(priv.exponent1).fromRed()
  var m2 = c2.redPow(priv.exponent2).fromRed()
  var h = m1.isub(m2).imul(qinv).umod(p).imul(q)
  return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len)
}
crt.getr = getr

module.exports = crt


/***/ }),

/***/ "../../node_modules/browserify-sign/algos.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__("../../node_modules/browserify-sign/browser/algorithms.json")


/***/ }),

/***/ "../../node_modules/browserify-sign/browser/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__("../../node_modules/browserify-sign/node_modules/safe-buffer/index.js").Buffer)
var createHash = __webpack_require__("../../node_modules/create-hash/browser.js")
var stream = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/readable-browser.js")
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var sign = __webpack_require__("../../node_modules/browserify-sign/browser/sign.js")
var verify = __webpack_require__("../../node_modules/browserify-sign/browser/verify.js")

var algorithms = __webpack_require__("../../node_modules/browserify-sign/browser/algorithms.json")
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = Buffer.from(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}


/***/ }),

/***/ "../../node_modules/browserify-sign/browser/sign.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = (__webpack_require__("../../node_modules/browserify-sign/node_modules/safe-buffer/index.js").Buffer)
var createHmac = __webpack_require__("../../node_modules/create-hmac/browser.js")
var crt = __webpack_require__("../../node_modules/browserify-rsa/index.js")
var EC = (__webpack_require__("../../node_modules/elliptic/lib/elliptic.js").ec)
var BN = __webpack_require__("../../node_modules/bn.js/lib/bn.js")
var parseKeys = __webpack_require__("../../node_modules/parse-asn1/index.js")
var curves = __webpack_require__("../../node_modules/browserify-sign/browser/curves.json")

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [0, 1]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return Buffer.from(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [0].concat(r)
  if (s[0] & 0x80) s = [0].concat(s)

  var total = r.length + s.length + 4
  var res = [0x30, total, 0x02, r.length]
  res = res.concat(r, [0x02, s.length], s)
  return Buffer.from(res)
}

function getKey (x, q, hash, algo) {
  x = Buffer.from(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - x.length)
    x = Buffer.concat([zeros, x])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = Buffer.alloc(hlen)
  v.fill(1)
  var k = Buffer.alloc(hlen)
  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = Buffer.from(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - out.length)
    out = Buffer.concat([zeros, out])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = Buffer.alloc(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([t, kv.v])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey


/***/ }),

/***/ "../../node_modules/browserify-sign/browser/verify.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = (__webpack_require__("../../node_modules/browserify-sign/node_modules/safe-buffer/index.js").Buffer)
var BN = __webpack_require__("../../node_modules/bn.js/lib/bn.js")
var EC = (__webpack_require__("../../node_modules/elliptic/lib/elliptic.js").ec)
var parseKeys = __webpack_require__("../../node_modules/parse-asn1/index.js")
var curves = __webpack_require__("../../node_modules/browserify-sign/browser/curves.json")

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [1]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = Buffer.from(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = Buffer.from(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify


/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js":
/***/ ((module) => {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.q = codes;


/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_readable.js");
var Writable = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_writable.js");
__webpack_require__("../../node_modules/inherits/inherits_browser.js")(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_passthrough.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_transform.js");
__webpack_require__("../../node_modules/inherits/inherits_browser.js")(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_readable.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = (__webpack_require__("../../node_modules/events/events.js").EventEmitter);
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

var Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__("?ec48");
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/buffer_list.js");
var destroyImpl = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/destroy.js");
var _require = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/state.js"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js")/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__("../../node_modules/inherits/inherits_browser.js")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = (__webpack_require__("../../node_modules/string_decoder/lib/string_decoder.js").StringDecoder);
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = (__webpack_require__("../../node_modules/string_decoder/lib/string_decoder.js").StringDecoder);
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/async_iterator.js");
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/from-browser.js");
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_transform.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = (__webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js")/* .codes */ .q),
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");
__webpack_require__("../../node_modules/inherits/inherits_browser.js")(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_writable.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("../../node_modules/util-deprecate/browser.js")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

var Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/destroy.js");
var _require = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/state.js"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js")/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__("../../node_modules/inherits/inherits_browser.js")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/async_iterator.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");


var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/buffer_list.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__("../../node_modules/buffer/index.js"),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__("?ff61"),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/destroy.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");


// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/end-of-stream.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = (__webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js")/* .codes.ERR_STREAM_PREMATURE_CLOSE */ .q.ERR_STREAM_PREMATURE_CLOSE);
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/from-browser.js":
/***/ ((module) => {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/pipeline.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = (__webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js")/* .codes */ .q),
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/state.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var ERR_INVALID_OPT_VALUE = (__webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/errors-browser.js")/* .codes.ERR_INVALID_OPT_VALUE */ .q.ERR_INVALID_OPT_VALUE);
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/stream-browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__("../../node_modules/events/events.js").EventEmitter;


/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/readable-stream/readable-browser.js":
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_readable.js");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_writable.js");
exports.Duplex = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_duplex.js");
exports.Transform = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_transform.js");
exports.PassThrough = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/_stream_passthrough.js");
exports.finished = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");
exports.pipeline = __webpack_require__("../../node_modules/browserify-sign/node_modules/readable-stream/lib/internal/streams/pipeline.js");


/***/ }),

/***/ "../../node_modules/browserify-sign/node_modules/safe-buffer/index.js":
/***/ ((module, exports, __webpack_require__) => {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("../../node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "../../node_modules/buffer-xor/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];
module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}


/***/ }),

/***/ "../../node_modules/buffer/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



const base64 = __webpack_require__("../../node_modules/base64-js/index.js")
const ieee754 = __webpack_require__("../../node_modules/ieee754/index.js")
const customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

const K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    const arr = new Uint8Array(1)
    const proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  const buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  const valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  const b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  const length = byteLength(string, encoding) | 0
  let buf = createBuffer(length)

  const actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  const length = array.length < 0 ? 0 : checked(array.length) | 0
  const buf = createBuffer(length)
  for (let i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    const copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  let buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    const len = checked(obj.length) | 0
    const buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  let x = a.length
  let y = b.length

  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  let i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  const buffer = Buffer.allocUnsafe(length)
  let pos = 0
  for (i = 0; i < list.length; ++i) {
    let buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)
        buf.copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  const len = string.length
  const mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  let loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  const i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  const len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (let i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  const len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (let i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  const len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (let i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  const length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  let str = ''
  const max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  let x = thisEnd - thisStart
  let y = end - start
  const len = Math.min(x, y)

  const thisCopy = this.slice(thisStart, thisEnd)
  const targetCopy = target.slice(start, end)

  for (let i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  let indexSize = 1
  let arrLength = arr.length
  let valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  let i
  if (dir) {
    let foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      let found = true
      for (let j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  const remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  const strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  let i
  for (i = 0; i < length; ++i) {
    const parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  const remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  let loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  const res = []

  let i = start
  while (i < end) {
    const firstByte = buf[i]
    let codePoint = null
    let bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      let secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  const len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  let res = ''
  let i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  let ret = ''
  end = Math.min(buf.length, end)

  for (let i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  const len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  let out = ''
  for (let i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  const bytes = buf.slice(start, end)
  let res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (let i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  const len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  const newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  let val = this[offset + --byteLength]
  let mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const lo = first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24

  const hi = this[++offset] +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    last * 2 ** 24

  return BigInt(lo) + (BigInt(hi) << BigInt(32))
})

Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const hi = first * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  const lo = this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last

  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
})

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let val = this[offset]
  let mul = 1
  let i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  let i = byteLength
  let mul = 1
  let val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  const val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = this[offset + 4] +
    this[offset + 5] * 2 ** 8 +
    this[offset + 6] * 2 ** 16 +
    (last << 24) // Overflow

  return (BigInt(val) << BigInt(32)) +
    BigInt(first +
    this[++offset] * 2 ** 8 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 24)
})

Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
  offset = offset >>> 0
  validateNumber(offset, 'offset')
  const first = this[offset]
  const last = this[offset + 7]
  if (first === undefined || last === undefined) {
    boundsError(offset, this.length - 8)
  }

  const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    this[++offset]

  return (BigInt(val) << BigInt(32)) +
    BigInt(this[++offset] * 2 ** 24 +
    this[++offset] * 2 ** 16 +
    this[++offset] * 2 ** 8 +
    last)
})

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let mul = 1
  let i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    const maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  let i = byteLength - 1
  let mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function wrtBigUInt64LE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  lo = lo >> 8
  buf[offset++] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  hi = hi >> 8
  buf[offset++] = hi
  return offset
}

function wrtBigUInt64BE (buf, value, offset, min, max) {
  checkIntBI(value, min, max, buf, offset, 7)

  let lo = Number(value & BigInt(0xffffffff))
  buf[offset + 7] = lo
  lo = lo >> 8
  buf[offset + 6] = lo
  lo = lo >> 8
  buf[offset + 5] = lo
  lo = lo >> 8
  buf[offset + 4] = lo
  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff))
  buf[offset + 3] = hi
  hi = hi >> 8
  buf[offset + 2] = hi
  hi = hi >> 8
  buf[offset + 1] = hi
  hi = hi >> 8
  buf[offset] = hi
  return offset + 8
}

Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
})

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = 0
  let mul = 1
  let sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    const limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  let i = byteLength - 1
  let mul = 1
  let sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
})

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  const len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      const code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  let i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    const bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    const len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// CUSTOM ERRORS
// =============

// Simplified versions from Node, changed for Buffer-only usage
const errors = {}
function E (sym, getMessage, Base) {
  errors[sym] = class NodeError extends Base {
    constructor () {
      super()

      Object.defineProperty(this, 'message', {
        value: getMessage.apply(this, arguments),
        writable: true,
        configurable: true
      })

      // Add the error code to the name to include it in the stack trace.
      this.name = `${this.name} [${sym}]`
      // Access the stack to generate the error message including the error code
      // from the name.
      this.stack // eslint-disable-line no-unused-expressions
      // Reset the name to the actual name.
      delete this.name
    }

    get code () {
      return sym
    }

    set code (value) {
      Object.defineProperty(this, 'code', {
        configurable: true,
        enumerable: true,
        value,
        writable: true
      })
    }

    toString () {
      return `${this.name} [${sym}]: ${this.message}`
    }
  }
}

E('ERR_BUFFER_OUT_OF_BOUNDS',
  function (name) {
    if (name) {
      return `${name} is outside of buffer bounds`
    }

    return 'Attempt to access memory outside buffer bounds'
  }, RangeError)
E('ERR_INVALID_ARG_TYPE',
  function (name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
  }, TypeError)
E('ERR_OUT_OF_RANGE',
  function (str, range, input) {
    let msg = `The value of "${str}" is out of range.`
    let received = input
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    }
    msg += ` It must be ${range}. Received ${received}`
    return msg
  }, RangeError)

function addNumericalSeparator (val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}

// CHECK FUNCTIONS
// ===============

function checkBounds (buf, offset, byteLength) {
  validateNumber(offset, 'offset')
  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
    boundsError(offset, buf.length - (byteLength + 1))
  }
}

function checkIntBI (value, min, max, buf, offset, byteLength) {
  if (value > max || value < min) {
    const n = typeof min === 'bigint' ? 'n' : ''
    let range
    if (byteLength > 3) {
      if (min === 0 || min === BigInt(0)) {
        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`
      } else {
        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
                `${(byteLength + 1) * 8 - 1}${n}`
      }
    } else {
      range = `>= ${min}${n} and <= ${max}${n}`
    }
    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
  }
  checkBounds(buf, offset, byteLength)
}

function validateNumber (value, name) {
  if (typeof value !== 'number') {
    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
}

function boundsError (value, length, type) {
  if (Math.floor(value) !== value) {
    validateNumber(value, type)
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value)
  }

  if (length < 0) {
    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
  }

  throw new errors.ERR_OUT_OF_RANGE(type || 'offset',
                                    `>= ${type ? 1 : 0} and <= ${length}`,
                                    value)
}

// HELPER FUNCTIONS
// ================

const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  let codePoint
  const length = string.length
  let leadSurrogate = null
  const bytes = []

  for (let i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  let c, hi, lo
  const byteArray = []
  for (let i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  let i
  for (i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = (function () {
  const alphabet = '0123456789abcdef'
  const table = new Array(256)
  for (let i = 0; i < 16; ++i) {
    const i16 = i * 16
    for (let j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()

// Return not function with Error if BigInt not supported
function defineBigIntMethod (fn) {
  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
}

function BufferBigIntNotDefined () {
  throw new Error('BigInt not supported')
}


/***/ }),

/***/ "../../node_modules/call-bind/callBound.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__("../../node_modules/get-intrinsic/index.js");

var callBind = __webpack_require__("../../node_modules/call-bind/index.js");

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ "../../node_modules/call-bind/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__("../../node_modules/function-bind/index.js");
var GetIntrinsic = __webpack_require__("../../node_modules/get-intrinsic/index.js");

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ "../../node_modules/cancelable-promise/umd/CancelablePromise.js":
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.CancelablePromise = void 0;
  _exports.cancelable = cancelable;
  _exports.default = void 0;
  _exports.isCancelablePromise = isCancelablePromise;

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

  function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

  function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

  function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }

  function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

  function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }

  var toStringTag = typeof Symbol !== 'undefined' ? Symbol.toStringTag : '@@toStringTag';

  var _internals = /*#__PURE__*/new WeakMap();

  var _promise = /*#__PURE__*/new WeakMap();

  var CancelablePromiseInternal = /*#__PURE__*/function () {
    function CancelablePromiseInternal(_ref) {
      var _ref$executor = _ref.executor,
          executor = _ref$executor === void 0 ? function () {} : _ref$executor,
          _ref$internals = _ref.internals,
          internals = _ref$internals === void 0 ? defaultInternals() : _ref$internals,
          _ref$promise = _ref.promise,
          promise = _ref$promise === void 0 ? new Promise(function (resolve, reject) {
        return executor(resolve, reject, function (onCancel) {
          internals.onCancelList.push(onCancel);
        });
      }) : _ref$promise;

      _classCallCheck(this, CancelablePromiseInternal);

      _classPrivateFieldInitSpec(this, _internals, {
        writable: true,
        value: void 0
      });

      _classPrivateFieldInitSpec(this, _promise, {
        writable: true,
        value: void 0
      });

      _defineProperty(this, toStringTag, 'CancelablePromise');

      this.cancel = this.cancel.bind(this);

      _classPrivateFieldSet(this, _internals, internals);

      _classPrivateFieldSet(this, _promise, promise || new Promise(function (resolve, reject) {
        return executor(resolve, reject, function (onCancel) {
          internals.onCancelList.push(onCancel);
        });
      }));
    }

    _createClass(CancelablePromiseInternal, [{
      key: "then",
      value: function then(onfulfilled, onrejected) {
        return makeCancelable(_classPrivateFieldGet(this, _promise).then(createCallback(onfulfilled, _classPrivateFieldGet(this, _internals)), createCallback(onrejected, _classPrivateFieldGet(this, _internals))), _classPrivateFieldGet(this, _internals));
      }
    }, {
      key: "catch",
      value: function _catch(onrejected) {
        return makeCancelable(_classPrivateFieldGet(this, _promise).catch(createCallback(onrejected, _classPrivateFieldGet(this, _internals))), _classPrivateFieldGet(this, _internals));
      }
    }, {
      key: "finally",
      value: function _finally(onfinally, runWhenCanceled) {
        var _this = this;

        if (runWhenCanceled) {
          _classPrivateFieldGet(this, _internals).onCancelList.push(onfinally);
        }

        return makeCancelable(_classPrivateFieldGet(this, _promise).finally(createCallback(function () {
          if (onfinally) {
            if (runWhenCanceled) {
              _classPrivateFieldGet(_this, _internals).onCancelList = _classPrivateFieldGet(_this, _internals).onCancelList.filter(function (callback) {
                return callback !== onfinally;
              });
            }

            return onfinally();
          }
        }, _classPrivateFieldGet(this, _internals))), _classPrivateFieldGet(this, _internals));
      }
    }, {
      key: "cancel",
      value: function cancel() {
        _classPrivateFieldGet(this, _internals).isCanceled = true;

        var callbacks = _classPrivateFieldGet(this, _internals).onCancelList;

        _classPrivateFieldGet(this, _internals).onCancelList = [];

        var _iterator = _createForOfIteratorHelper(callbacks),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var callback = _step.value;

            if (typeof callback === 'function') {
              try {
                callback();
              } catch (err) {
                console.error(err);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "isCanceled",
      value: function isCanceled() {
        return _classPrivateFieldGet(this, _internals).isCanceled === true;
      }
    }]);

    return CancelablePromiseInternal;
  }();

  var CancelablePromise = /*#__PURE__*/function (_CancelablePromiseInt) {
    _inherits(CancelablePromise, _CancelablePromiseInt);

    var _super = _createSuper(CancelablePromise);

    function CancelablePromise(executor) {
      _classCallCheck(this, CancelablePromise);

      return _super.call(this, {
        executor: executor
      });
    }

    return _createClass(CancelablePromise);
  }(CancelablePromiseInternal);

  _exports.CancelablePromise = CancelablePromise;

  _defineProperty(CancelablePromise, "all", function all(iterable) {
    return makeAllCancelable(iterable, Promise.all(iterable));
  });

  _defineProperty(CancelablePromise, "allSettled", function allSettled(iterable) {
    return makeAllCancelable(iterable, Promise.allSettled(iterable));
  });

  _defineProperty(CancelablePromise, "any", function any(iterable) {
    return makeAllCancelable(iterable, Promise.any(iterable));
  });

  _defineProperty(CancelablePromise, "race", function race(iterable) {
    return makeAllCancelable(iterable, Promise.race(iterable));
  });

  _defineProperty(CancelablePromise, "resolve", function resolve(value) {
    return cancelable(Promise.resolve(value));
  });

  _defineProperty(CancelablePromise, "reject", function reject(reason) {
    return cancelable(Promise.reject(reason));
  });

  _defineProperty(CancelablePromise, "isCancelable", isCancelablePromise);

  var _default = CancelablePromise;
  _exports.default = _default;

  function cancelable(promise) {
    return makeCancelable(promise, defaultInternals());
  }

  function isCancelablePromise(promise) {
    return promise instanceof CancelablePromise || promise instanceof CancelablePromiseInternal;
  }

  function createCallback(onResult, internals) {
    if (onResult) {
      return function (arg) {
        if (!internals.isCanceled) {
          var result = onResult(arg);

          if (isCancelablePromise(result)) {
            internals.onCancelList.push(result.cancel);
          }

          return result;
        }

        return arg;
      };
    }
  }

  function makeCancelable(promise, internals) {
    return new CancelablePromiseInternal({
      internals: internals,
      promise: promise
    });
  }

  function makeAllCancelable(iterable, promise) {
    var internals = defaultInternals();
    internals.onCancelList.push(function () {
      var _iterator2 = _createForOfIteratorHelper(iterable),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var resolvable = _step2.value;

          if (isCancelablePromise(resolvable)) {
            resolvable.cancel();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    });
    return new CancelablePromiseInternal({
      internals: internals,
      promise: promise
    });
  }

  function defaultInternals() {
    return {
      isCanceled: false,
      onCancelList: []
    };
  }
});
//# sourceMappingURL=CancelablePromise.js.map

/***/ }),

/***/ "../../node_modules/cipher-base/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var Transform = (__webpack_require__("../../node_modules/readable-stream/lib/ours/browser.js").Transform)
var StringDecoder = (__webpack_require__("../../node_modules/string_decoder/lib/string_decoder.js").StringDecoder)
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),

/***/ "../../node_modules/core-js/internals/a-callable.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/a-constructor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isConstructor = __webpack_require__("../../node_modules/core-js/internals/is-constructor.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/a-possible-prototype.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/add-to-unscopables.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var defineProperty = (__webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/advance-string-index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = (__webpack_require__("../../node_modules/core-js/internals/string-multibyte.js").charAt);

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/an-instance.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/an-object.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-buffer-basic-detection.js":
/***/ ((module) => {

// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ }),

/***/ "../../node_modules/core-js/internals/array-buffer-non-extensible.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ "../../node_modules/core-js/internals/array-buffer-view-core.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var NATIVE_ARRAY_BUFFER = __webpack_require__("../../node_modules/core-js/internals/array-buffer-basic-detection.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var getPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var uid = __webpack_require__("../../node_modules/core-js/internals/uid.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = getPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwn(TypedArrayConstructorsList, klass)
    || hasOwn(BigIntArrayConstructorsList, klass);
};

var aTypedArray = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError('Target is not a typed array');
};

var aTypedArrayConstructor = function (C) {
  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
  throw TypeError(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod = function (KEY, property, forced, options) {
  if (!DESCRIPTORS) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!DESCRIPTORS) return;
  if (setPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global[ARRAY];
      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

module.exports = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray,
  aTypedArrayConstructor: aTypedArrayConstructor,
  exportTypedArrayMethod: exportTypedArrayMethod,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-buffer.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var NATIVE_ARRAY_BUFFER = __webpack_require__("../../node_modules/core-js/internals/array-buffer-basic-detection.js");
var FunctionName = __webpack_require__("../../node_modules/core-js/internals/function-name.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var defineBuiltIns = __webpack_require__("../../node_modules/core-js/internals/define-built-ins.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var anInstance = __webpack_require__("../../node_modules/core-js/internals/an-instance.js");
var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");
var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");
var toIndex = __webpack_require__("../../node_modules/core-js/internals/to-index.js");
var IEEE754 = __webpack_require__("../../node_modules/core-js/internals/ieee754.js");
var getPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");
var getOwnPropertyNames = (__webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js").f);
var arrayFill = __webpack_require__("../../node_modules/core-js/internals/array-fill.js");
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice-simple.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = InternalStateModule.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = InternalStateModule.getterFor(DATA_VIEW);
var setInternalState = InternalStateModule.set;
var NativeArrayBuffer = global[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array = global.Array;
var RangeError = global.RangeError;
var fill = uncurryThis(arrayFill);
var reverse = uncurryThis([].reverse);

var packIEEE754 = IEEE754.pack;
var unpackIEEE754 = IEEE754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalDataViewState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySlice(bytes, start, start + count);
  return isLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalDataViewState(view);
  if (intIndex + count > store.byteLength) throw RangeError(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!NATIVE_ARRAY_BUFFER) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      type: ARRAY_BUFFER,
      bytes: fill(Array(byteLength), 0),
      byteLength: byteLength
    });
    if (!DESCRIPTORS) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    setInternalState(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!DESCRIPTORS) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype = $DataView[PROTOTYPE];

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter($DataView, 'buffer', getInternalDataViewState);
    addGetter($DataView, 'byteLength', getInternalDataViewState);
    addGetter($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length != 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return new NativeArrayBuffer(toIndex(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }

    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    setPrototypeOf(DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

module.exports = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-copy-within.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var toAbsoluteIndex = __webpack_require__("../../node_modules/core-js/internals/to-absolute-index.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var deletePropertyOrThrow = __webpack_require__("../../node_modules/core-js/internals/delete-property-or-throw.js");

var min = Math.min;

// `Array.prototype.copyWithin` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.copywithin
// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = lengthOfArrayLike(O);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else deletePropertyOrThrow(O, to);
    to += inc;
    from += inc;
  } return O;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-fill.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var toAbsoluteIndex = __webpack_require__("../../node_modules/core-js/internals/to-absolute-index.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-for-each.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $forEach = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").forEach);
var arrayMethodIsStrict = __webpack_require__("../../node_modules/core-js/internals/array-method-is-strict.js");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "../../node_modules/core-js/internals/array-from-constructor-and-list.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");

module.exports = function (Constructor, list) {
  var index = 0;
  var length = lengthOfArrayLike(list);
  var result = new Constructor(length);
  while (length > index) result[index] = list[index++];
  return result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-from.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var callWithSafeIterationClosing = __webpack_require__("../../node_modules/core-js/internals/call-with-safe-iteration-closing.js");
var isArrayIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/is-array-iterator-method.js");
var isConstructor = __webpack_require__("../../node_modules/core-js/internals/is-constructor.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var createProperty = __webpack_require__("../../node_modules/core-js/internals/create-property.js");
var getIterator = __webpack_require__("../../node_modules/core-js/internals/get-iterator.js");
var getIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/get-iterator-method.js");

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-includes.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var toAbsoluteIndex = __webpack_require__("../../node_modules/core-js/internals/to-absolute-index.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-iteration.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var IndexedObject = __webpack_require__("../../node_modules/core-js/internals/indexed-object.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var arraySpeciesCreate = __webpack_require__("../../node_modules/core-js/internals/array-species-create.js");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-last-index-of.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-array-prototype-lastindexof -- safe */
var apply = __webpack_require__("../../node_modules/core-js/internals/function-apply.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var arrayMethodIsStrict = __webpack_require__("../../node_modules/core-js/internals/array-method-is-strict.js");

var min = Math.min;
var $lastIndexOf = [].lastIndexOf;
var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;

// `Array.prototype.lastIndexOf` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
  // convert -0 to +0
  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
  var O = toIndexedObject(this);
  var length = lengthOfArrayLike(O);
  var index = length - 1;
  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
  if (index < 0) index = length + index;
  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
  return -1;
} : $lastIndexOf;


/***/ }),

/***/ "../../node_modules/core-js/internals/array-method-has-species-support.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__("../../node_modules/core-js/internals/engine-v8-version.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-method-is-strict.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-reduce.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var IndexedObject = __webpack_require__("../../node_modules/core-js/internals/indexed-object.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");

var $TypeError = TypeError;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aCallable(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike(O);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw $TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-set-length.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var isArray = __webpack_require__("../../node_modules/core-js/internals/is-array.js");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-slice-simple.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toAbsoluteIndex = __webpack_require__("../../node_modules/core-js/internals/to-absolute-index.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var createProperty = __webpack_require__("../../node_modules/core-js/internals/create-property.js");

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-slice.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "../../node_modules/core-js/internals/array-sort.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice-simple.js");

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),

/***/ "../../node_modules/core-js/internals/array-species-constructor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__("../../node_modules/core-js/internals/is-array.js");
var isConstructor = __webpack_require__("../../node_modules/core-js/internals/is-constructor.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/array-species-create.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arraySpeciesConstructor = __webpack_require__("../../node_modules/core-js/internals/array-species-constructor.js");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/call-with-safe-iteration-closing.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var iteratorClose = __webpack_require__("../../node_modules/core-js/internals/iterator-close.js");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/check-correctness-of-iteration.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/classof-raw.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/classof.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var TO_STRING_TAG_SUPPORT = __webpack_require__("../../node_modules/core-js/internals/to-string-tag-support.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var classofRaw = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/collection-strong.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var defineBuiltIns = __webpack_require__("../../node_modules/core-js/internals/define-built-ins.js");
var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var anInstance = __webpack_require__("../../node_modules/core-js/internals/an-instance.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var defineIterator = __webpack_require__("../../node_modules/core-js/internals/iterator-define.js");
var createIterResultObject = __webpack_require__("../../node_modules/core-js/internals/create-iter-result-object.js");
var setSpecies = __webpack_require__("../../node_modules/core-js/internals/set-species.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var fastKey = (__webpack_require__("../../node_modules/core-js/internals/internal-metadata.js").fastKey);
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind == 'keys') return createIterResultObject(entry.key, false);
      if (kind == 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/collection-weak.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var defineBuiltIns = __webpack_require__("../../node_modules/core-js/internals/define-built-ins.js");
var getWeakData = (__webpack_require__("../../node_modules/core-js/internals/internal-metadata.js").getWeakData);
var anInstance = __webpack_require__("../../node_modules/core-js/internals/an-instance.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var ArrayIterationModule = __webpack_require__("../../node_modules/core-js/internals/array-iteration.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (state) {
  return state.frozen || (state.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn(data, state.id);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/collection.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var isForced = __webpack_require__("../../node_modules/core-js/internals/is-forced.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var InternalMetadataModule = __webpack_require__("../../node_modules/core-js/internals/internal-metadata.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var anInstance = __webpack_require__("../../node_modules/core-js/internals/an-instance.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var checkCorrectnessOfIteration = __webpack_require__("../../node_modules/core-js/internals/check-correctness-of-iteration.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var inheritIfRequired = __webpack_require__("../../node_modules/core-js/internals/inherit-if-required.js");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, constructor: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/copy-constructor-properties.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var ownKeys = __webpack_require__("../../node_modules/core-js/internals/own-keys.js");
var getOwnPropertyDescriptorModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/correct-is-regexp-logic.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/correct-prototype-getter.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/create-iter-result-object.js":
/***/ ((module) => {

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ "../../node_modules/core-js/internals/create-non-enumerable-property.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/create-property-descriptor.js":
/***/ ((module) => {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "../../node_modules/core-js/internals/create-property.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toPropertyKey = __webpack_require__("../../node_modules/core-js/internals/to-property-key.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/date-to-iso-string.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var padStart = (__webpack_require__("../../node_modules/core-js/internals/string-pad.js").start);

var $RangeError = RangeError;
var $isFinite = isFinite;
var abs = Math.abs;
var DatePrototype = Date.prototype;
var nativeDateToISOString = DatePrototype.toISOString;
var thisTimeValue = uncurryThis(DatePrototype.getTime);
var getUTCDate = uncurryThis(DatePrototype.getUTCDate);
var getUTCFullYear = uncurryThis(DatePrototype.getUTCFullYear);
var getUTCHours = uncurryThis(DatePrototype.getUTCHours);
var getUTCMilliseconds = uncurryThis(DatePrototype.getUTCMilliseconds);
var getUTCMinutes = uncurryThis(DatePrototype.getUTCMinutes);
var getUTCMonth = uncurryThis(DatePrototype.getUTCMonth);
var getUTCSeconds = uncurryThis(DatePrototype.getUTCSeconds);

// `Date.prototype.toISOString` method implementation
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit fails here:
module.exports = (fails(function () {
  return nativeDateToISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  nativeDateToISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!$isFinite(thisTimeValue(this))) throw $RangeError('Invalid time value');
  var date = this;
  var year = getUTCFullYear(date);
  var milliseconds = getUTCMilliseconds(date);
  var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
  return sign + padStart(abs(year), sign ? 6 : 4, 0) +
    '-' + padStart(getUTCMonth(date) + 1, 2, 0) +
    '-' + padStart(getUTCDate(date), 2, 0) +
    'T' + padStart(getUTCHours(date), 2, 0) +
    ':' + padStart(getUTCMinutes(date), 2, 0) +
    ':' + padStart(getUTCSeconds(date), 2, 0) +
    '.' + padStart(milliseconds, 3, 0) +
    'Z';
} : nativeDateToISOString;


/***/ }),

/***/ "../../node_modules/core-js/internals/date-to-primitive.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var ordinaryToPrimitive = __webpack_require__("../../node_modules/core-js/internals/ordinary-to-primitive.js");

var $TypeError = TypeError;

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw $TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/define-built-in-accessor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var makeBuiltIn = __webpack_require__("../../node_modules/core-js/internals/make-built-in.js");
var defineProperty = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/define-built-in.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var makeBuiltIn = __webpack_require__("../../node_modules/core-js/internals/make-built-in.js");
var defineGlobalProperty = __webpack_require__("../../node_modules/core-js/internals/define-global-property.js");

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/define-built-ins.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/define-global-property.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/delete-property-or-throw.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/descriptors.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/document-all.js":
/***/ ((module) => {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ "../../node_modules/core-js/internals/document-create-element.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "../../node_modules/core-js/internals/does-not-exceed-safe-integer.js":
/***/ ((module) => {

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/dom-iterables.js":
/***/ ((module) => {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "../../node_modules/core-js/internals/dom-token-list-prototype.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("../../node_modules/core-js/internals/document-create-element.js");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-ff-version.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var IS_DENO = __webpack_require__("../../node_modules/core-js/internals/engine-is-deno.js");
var IS_NODE = __webpack_require__("../../node_modules/core-js/internals/engine-is-node.js");

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-bun.js":
/***/ ((module) => {

/* global Bun -- Deno case */
module.exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-deno.js":
/***/ ((module) => {

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-ie-or-edge.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var UA = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-ios-pebble.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-ios.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-node.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");

module.exports = typeof process != 'undefined' && classof(process) == 'process';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-is-webos-webkit.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-user-agent.js":
/***/ ((module) => {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-v8-version.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var userAgent = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "../../node_modules/core-js/internals/engine-webkit-version.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var userAgent = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ "../../node_modules/core-js/internals/enum-bug-keys.js":
/***/ ((module) => {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "../../node_modules/core-js/internals/export.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var getOwnPropertyDescriptor = (__webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js").f);
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var defineGlobalProperty = __webpack_require__("../../node_modules/core-js/internals/define-global-property.js");
var copyConstructorProperties = __webpack_require__("../../node_modules/core-js/internals/copy-constructor-properties.js");
var isForced = __webpack_require__("../../node_modules/core-js/internals/is-forced.js");

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/fails.js":
/***/ ((module) => {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("../../node_modules/core-js/modules/es.regexp.exec.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this-clause.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var regexpExec = __webpack_require__("../../node_modules/core-js/internals/regexp-exec.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/flatten-into-array.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var isArray = __webpack_require__("../../node_modules/core-js/internals/is-array.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var doesNotExceedSafeInteger = __webpack_require__("../../node_modules/core-js/internals/does-not-exceed-safe-integer.js");
var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        elementLen = lengthOfArrayLike(element);
        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

module.exports = flattenIntoArray;


/***/ }),

/***/ "../../node_modules/core-js/internals/freezing.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "../../node_modules/core-js/internals/function-apply.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_BIND = __webpack_require__("../../node_modules/core-js/internals/function-bind-native.js");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "../../node_modules/core-js/internals/function-bind-context.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this-clause.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var NATIVE_BIND = __webpack_require__("../../node_modules/core-js/internals/function-bind-native.js");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-bind-native.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "../../node_modules/core-js/internals/function-bind.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice.js");
var NATIVE_BIND = __webpack_require__("../../node_modules/core-js/internals/function-bind-native.js");

var $Function = Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
// eslint-disable-next-line es/no-function-prototype-bind -- detection
module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-call.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_BIND = __webpack_require__("../../node_modules/core-js/internals/function-bind-native.js");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-name.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-uncurry-this-accessor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-uncurry-this-clause.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classofRaw = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/function-uncurry-this.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_BIND = __webpack_require__("../../node_modules/core-js/internals/function-bind-native.js");

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "../../node_modules/core-js/internals/get-built-in.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "../../node_modules/core-js/internals/get-iterator-method.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");
var getMethod = __webpack_require__("../../node_modules/core-js/internals/get-method.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var Iterators = __webpack_require__("../../node_modules/core-js/internals/iterators.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "../../node_modules/core-js/internals/get-iterator.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");
var getIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/get-iterator-method.js");

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/get-json-replacer-function.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var isArray = __webpack_require__("../../node_modules/core-js/internals/is-array.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) == 'Number' || classof(element) == 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ "../../node_modules/core-js/internals/get-method.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/global.js":
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ "../../node_modules/core-js/internals/has-own-property.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/hidden-keys.js":
/***/ ((module) => {

module.exports = {};


/***/ }),

/***/ "../../node_modules/core-js/internals/host-report-errors.js":
/***/ ((module) => {

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/html.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "../../node_modules/core-js/internals/ie8-dom-define.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var createElement = __webpack_require__("../../node_modules/core-js/internals/document-create-element.js");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/ieee754.js":
/***/ ((module) => {

// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

module.exports = {
  pack: pack,
  unpack: unpack
};


/***/ }),

/***/ "../../node_modules/core-js/internals/indexed-object.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ "../../node_modules/core-js/internals/inherit-if-required.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/inspect-source.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var store = __webpack_require__("../../node_modules/core-js/internals/shared-store.js");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "../../node_modules/core-js/internals/internal-metadata.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var hiddenKeys = __webpack_require__("../../node_modules/core-js/internals/hidden-keys.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var defineProperty = (__webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f);
var getOwnPropertyNamesModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertyNamesExternalModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names-external.js");
var isExtensible = __webpack_require__("../../node_modules/core-js/internals/object-is-extensible.js");
var uid = __webpack_require__("../../node_modules/core-js/internals/uid.js");
var FREEZING = __webpack_require__("../../node_modules/core-js/internals/freezing.js");

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "../../node_modules/core-js/internals/internal-state.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_WEAK_MAP = __webpack_require__("../../node_modules/core-js/internals/weak-map-basic-detection.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared-store.js");
var sharedKey = __webpack_require__("../../node_modules/core-js/internals/shared-key.js");
var hiddenKeys = __webpack_require__("../../node_modules/core-js/internals/hidden-keys.js");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-array-iterator-method.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var Iterators = __webpack_require__("../../node_modules/core-js/internals/iterators.js");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-array.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-big-int-array.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");

module.exports = function (it) {
  var klass = classof(it);
  return klass == 'BigInt64Array' || klass == 'BigUint64Array';
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-callable.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var $documentAll = __webpack_require__("../../node_modules/core-js/internals/document-all.js");

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-constructor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var inspectSource = __webpack_require__("../../node_modules/core-js/internals/inspect-source.js");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "../../node_modules/core-js/internals/is-data-descriptor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");

module.exports = function (descriptor) {
  return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-forced.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "../../node_modules/core-js/internals/is-integral-number.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-null-or-undefined.js":
/***/ ((module) => {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-object.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var $documentAll = __webpack_require__("../../node_modules/core-js/internals/document-all.js");

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-pure.js":
/***/ ((module) => {

module.exports = false;


/***/ }),

/***/ "../../node_modules/core-js/internals/is-regexp.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/is-symbol.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var USE_SYMBOL_AS_UID = __webpack_require__("../../node_modules/core-js/internals/use-symbol-as-uid.js");

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterate.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");
var isArrayIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/is-array-iterator-method.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var getIterator = __webpack_require__("../../node_modules/core-js/internals/get-iterator.js");
var getIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/get-iterator-method.js");
var iteratorClose = __webpack_require__("../../node_modules/core-js/internals/iterator-close.js");

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterator-close.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var getMethod = __webpack_require__("../../node_modules/core-js/internals/get-method.js");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterator-create-constructor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var IteratorPrototype = (__webpack_require__("../../node_modules/core-js/internals/iterators-core.js").IteratorPrototype);
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var Iterators = __webpack_require__("../../node_modules/core-js/internals/iterators.js");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterator-define.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var FunctionName = __webpack_require__("../../node_modules/core-js/internals/function-name.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var createIteratorConstructor = __webpack_require__("../../node_modules/core-js/internals/iterator-create-constructor.js");
var getPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-get-prototype-of.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var Iterators = __webpack_require__("../../node_modules/core-js/internals/iterators.js");
var IteratorsCore = __webpack_require__("../../node_modules/core-js/internals/iterators-core.js");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterators-core.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var getPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-get-prototype-of.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "../../node_modules/core-js/internals/iterators.js":
/***/ ((module) => {

module.exports = {};


/***/ }),

/***/ "../../node_modules/core-js/internals/length-of-array-like.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/make-built-in.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__("../../node_modules/core-js/internals/function-name.js").CONFIGURABLE);
var inspectSource = __webpack_require__("../../node_modules/core-js/internals/inspect-source.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "../../node_modules/core-js/internals/math-trunc.js":
/***/ ((module) => {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/microtask.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var getOwnPropertyDescriptor = (__webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js").f);
var macrotask = (__webpack_require__("../../node_modules/core-js/internals/task.js").set);
var Queue = __webpack_require__("../../node_modules/core-js/internals/queue.js");
var IS_IOS = __webpack_require__("../../node_modules/core-js/internals/engine-is-ios.js");
var IS_IOS_PEBBLE = __webpack_require__("../../node_modules/core-js/internals/engine-is-ios-pebble.js");
var IS_WEBOS_WEBKIT = __webpack_require__("../../node_modules/core-js/internals/engine-is-webos-webkit.js");
var IS_NODE = __webpack_require__("../../node_modules/core-js/internals/engine-is-node.js");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),

/***/ "../../node_modules/core-js/internals/new-promise-capability.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/not-a-regexp.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isRegExp = __webpack_require__("../../node_modules/core-js/internals/is-regexp.js");

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw $TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/number-parse-int.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var trim = (__webpack_require__("../../node_modules/core-js/internals/string-trim.js").trim);
var whitespaces = __webpack_require__("../../node_modules/core-js/internals/whitespaces.js");

var $parseInt = global.parseInt;
var Symbol = global.Symbol;
var ITERATOR = Symbol && Symbol.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
module.exports = FORCED ? function parseInt(string, radix) {
  var S = trim(toString(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;


/***/ }),

/***/ "../../node_modules/core-js/internals/object-assign.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var objectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys.js");
var getOwnPropertySymbolsModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-symbols.js");
var propertyIsEnumerableModule = __webpack_require__("../../node_modules/core-js/internals/object-property-is-enumerable.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var IndexedObject = __webpack_require__("../../node_modules/core-js/internals/indexed-object.js");

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "../../node_modules/core-js/internals/object-create.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var definePropertiesModule = __webpack_require__("../../node_modules/core-js/internals/object-define-properties.js");
var enumBugKeys = __webpack_require__("../../node_modules/core-js/internals/enum-bug-keys.js");
var hiddenKeys = __webpack_require__("../../node_modules/core-js/internals/hidden-keys.js");
var html = __webpack_require__("../../node_modules/core-js/internals/html.js");
var documentCreateElement = __webpack_require__("../../node_modules/core-js/internals/document-create-element.js");
var sharedKey = __webpack_require__("../../node_modules/core-js/internals/shared-key.js");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-define-properties.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("../../node_modules/core-js/internals/v8-prototype-define-bug.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var objectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys.js");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-define-property.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var IE8_DOM_DEFINE = __webpack_require__("../../node_modules/core-js/internals/ie8-dom-define.js");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("../../node_modules/core-js/internals/v8-prototype-define-bug.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var toPropertyKey = __webpack_require__("../../node_modules/core-js/internals/to-property-key.js");

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-get-own-property-descriptor.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var propertyIsEnumerableModule = __webpack_require__("../../node_modules/core-js/internals/object-property-is-enumerable.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var toPropertyKey = __webpack_require__("../../node_modules/core-js/internals/to-property-key.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var IE8_DOM_DEFINE = __webpack_require__("../../node_modules/core-js/internals/ie8-dom-define.js");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-get-own-property-names-external.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var $getOwnPropertyNames = (__webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js").f);
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice-simple.js");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-get-own-property-names.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var internalObjectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__("../../node_modules/core-js/internals/enum-bug-keys.js");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-get-own-property-symbols.js":
/***/ ((__unused_webpack_module, exports) => {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "../../node_modules/core-js/internals/object-get-prototype-of.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var sharedKey = __webpack_require__("../../node_modules/core-js/internals/shared-key.js");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("../../node_modules/core-js/internals/correct-prototype-getter.js");

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-is-extensible.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__("../../node_modules/core-js/internals/array-buffer-non-extensible.js");

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ "../../node_modules/core-js/internals/object-is-prototype-of.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "../../node_modules/core-js/internals/object-keys-internal.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var indexOf = (__webpack_require__("../../node_modules/core-js/internals/array-includes.js").indexOf);
var hiddenKeys = __webpack_require__("../../node_modules/core-js/internals/hidden-keys.js");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-keys.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var internalObjectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys-internal.js");
var enumBugKeys = __webpack_require__("../../node_modules/core-js/internals/enum-bug-keys.js");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-property-is-enumerable.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "../../node_modules/core-js/internals/object-set-prototype-of.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this-accessor.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var aPossiblePrototype = __webpack_require__("../../node_modules/core-js/internals/a-possible-prototype.js");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "../../node_modules/core-js/internals/object-to-array.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var objectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var $propertyIsEnumerable = (__webpack_require__("../../node_modules/core-js/internals/object-property-is-enumerable.js").f);

var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "../../node_modules/core-js/internals/object-to-string.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("../../node_modules/core-js/internals/to-string-tag-support.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "../../node_modules/core-js/internals/ordinary-to-primitive.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "../../node_modules/core-js/internals/own-keys.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var getOwnPropertyNamesModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertySymbolsModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-symbols.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/path.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

module.exports = global;


/***/ }),

/***/ "../../node_modules/core-js/internals/perform.js":
/***/ ((module) => {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/promise-constructor-detection.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isForced = __webpack_require__("../../node_modules/core-js/internals/is-forced.js");
var inspectSource = __webpack_require__("../../node_modules/core-js/internals/inspect-source.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var IS_BROWSER = __webpack_require__("../../node_modules/core-js/internals/engine-is-browser.js");
var IS_DENO = __webpack_require__("../../node_modules/core-js/internals/engine-is-deno.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var V8_VERSION = __webpack_require__("../../node_modules/core-js/internals/engine-v8-version.js");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ "../../node_modules/core-js/internals/promise-native-constructor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

module.exports = global.Promise;


/***/ }),

/***/ "../../node_modules/core-js/internals/promise-resolve.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var newPromiseCapability = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/promise-statics-incorrect-iteration.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var checkCorrectnessOfIteration = __webpack_require__("../../node_modules/core-js/internals/check-correctness-of-iteration.js");
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__("../../node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ "../../node_modules/core-js/internals/queue.js":
/***/ ((module) => {

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ "../../node_modules/core-js/internals/regexp-exec-abstract.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof-raw.js");
var regexpExec = __webpack_require__("../../node_modules/core-js/internals/regexp-exec.js");

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ "../../node_modules/core-js/internals/regexp-exec.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var regexpFlags = __webpack_require__("../../node_modules/core-js/internals/regexp-flags.js");
var stickyHelpers = __webpack_require__("../../node_modules/core-js/internals/regexp-sticky-helpers.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var getInternalState = (__webpack_require__("../../node_modules/core-js/internals/internal-state.js").get);
var UNSUPPORTED_DOT_ALL = __webpack_require__("../../node_modules/core-js/internals/regexp-unsupported-dot-all.js");
var UNSUPPORTED_NCG = __webpack_require__("../../node_modules/core-js/internals/regexp-unsupported-ncg.js");

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "../../node_modules/core-js/internals/regexp-flags.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/regexp-get-flags.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var regExpFlags = __webpack_require__("../../node_modules/core-js/internals/regexp-flags.js");

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/regexp-sticky-helpers.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ "../../node_modules/core-js/internals/regexp-unsupported-dot-all.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ "../../node_modules/core-js/internals/regexp-unsupported-ncg.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ "../../node_modules/core-js/internals/require-object-coercible.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/schedulers-fix.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var apply = __webpack_require__("../../node_modules/core-js/internals/function-apply.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var ENGINE_IS_BUN = __webpack_require__("../../node_modules/core-js/internals/engine-is-bun.js");
var USER_AGENT = __webpack_require__("../../node_modules/core-js/internals/engine-user-agent.js");
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice.js");
var validateArgumentsLength = __webpack_require__("../../node_modules/core-js/internals/validate-arguments-length.js");

var Function = global.Function;
// dirty IE9- and Bun 0.3.0- checks
var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && (function () {
  var version = global.Bun.version.split('.');
  return version.length < 3 || version[0] == 0 && (version[1] < 3 || version[1] == 3 && version[2] == 0);
})();

// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
module.exports = function (scheduler, hasTimeArg) {
  var firstParamIndex = hasTimeArg ? 2 : 1;
  return WRAP ? function (handler, timeout /* , ...arguments */) {
    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
    var fn = isCallable(handler) ? handler : Function(handler);
    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
    var callback = boundArgs ? function () {
      apply(fn, this, params);
    } : fn;
    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
  } : scheduler;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/set-species.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/set-to-string-tag.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = (__webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f);
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/shared-key.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var uid = __webpack_require__("../../node_modules/core-js/internals/uid.js");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/shared-store.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var defineGlobalProperty = __webpack_require__("../../node_modules/core-js/internals/define-global-property.js");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ "../../node_modules/core-js/internals/shared.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var store = __webpack_require__("../../node_modules/core-js/internals/shared-store.js");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.30.2',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "../../node_modules/core-js/internals/species-constructor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var aConstructor = __webpack_require__("../../node_modules/core-js/internals/a-constructor.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/string-multibyte.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "../../node_modules/core-js/internals/string-pad.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// https://github.com/tc39/proposal-string-pad-start-end
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var $repeat = __webpack_require__("../../node_modules/core-js/internals/string-repeat.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");

var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var ceil = Math.ceil;

// `String.prototype.{ padStart, padEnd }` methods implementation
var createMethod = function (IS_END) {
  return function ($this, maxLength, fillString) {
    var S = toString(requireObjectCoercible($this));
    var intMaxLength = toLength(maxLength);
    var stringLength = S.length;
    var fillStr = fillString === undefined ? ' ' : toString(fillString);
    var fillLen, stringFiller;
    if (intMaxLength <= stringLength || fillStr == '') return S;
    fillLen = intMaxLength - stringLength;
    stringFiller = repeat(fillStr, ceil(fillLen / fillStr.length));
    if (stringFiller.length > fillLen) stringFiller = stringSlice(stringFiller, 0, fillLen);
    return IS_END ? S + stringFiller : stringFiller + S;
  };
};

module.exports = {
  // `String.prototype.padStart` method
  // https://tc39.es/ecma262/#sec-string.prototype.padstart
  start: createMethod(false),
  // `String.prototype.padEnd` method
  // https://tc39.es/ecma262/#sec-string.prototype.padend
  end: createMethod(true)
};


/***/ }),

/***/ "../../node_modules/core-js/internals/string-repeat.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");

var $RangeError = RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n == Infinity) throw $RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/string-trim-forced.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var PROPER_FUNCTION_NAME = (__webpack_require__("../../node_modules/core-js/internals/function-name.js").PROPER);
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var whitespaces = __webpack_require__("../../node_modules/core-js/internals/whitespaces.js");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ "../../node_modules/core-js/internals/string-trim.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var whitespaces = __webpack_require__("../../node_modules/core-js/internals/whitespaces.js");

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "../../node_modules/core-js/internals/symbol-constructor-detection.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("../../node_modules/core-js/internals/engine-v8-version.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/symbol-define-to-primitive.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/symbol-registry-detection.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ "../../node_modules/core-js/internals/task.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var apply = __webpack_require__("../../node_modules/core-js/internals/function-apply.js");
var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var html = __webpack_require__("../../node_modules/core-js/internals/html.js");
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice.js");
var createElement = __webpack_require__("../../node_modules/core-js/internals/document-create-element.js");
var validateArgumentsLength = __webpack_require__("../../node_modules/core-js/internals/validate-arguments-length.js");
var IS_IOS = __webpack_require__("../../node_modules/core-js/internals/engine-is-ios.js");
var IS_NODE = __webpack_require__("../../node_modules/core-js/internals/engine-is-node.js");

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "../../node_modules/core-js/internals/this-number-value.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ "../../node_modules/core-js/internals/to-absolute-index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-big-int.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPrimitive = __webpack_require__("../../node_modules/core-js/internals/to-primitive.js");

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
module.exports = function (argument) {
  var prim = toPrimitive(argument, 'number');
  if (typeof prim == 'number') throw $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");
var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");

var $RangeError = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw $RangeError('Wrong length or index');
  return length;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-indexed-object.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("../../node_modules/core-js/internals/indexed-object.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-integer-or-infinity.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var trunc = __webpack_require__("../../node_modules/core-js/internals/math-trunc.js");

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-length.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-object.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-offset.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPositiveInteger = __webpack_require__("../../node_modules/core-js/internals/to-positive-integer.js");

var $RangeError = RangeError;

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw $RangeError('Wrong offset');
  return offset;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-positive-integer.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");

var $RangeError = RangeError;

module.exports = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw $RangeError("The argument can't be less than 0");
  return result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-primitive.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var isSymbol = __webpack_require__("../../node_modules/core-js/internals/is-symbol.js");
var getMethod = __webpack_require__("../../node_modules/core-js/internals/get-method.js");
var ordinaryToPrimitive = __webpack_require__("../../node_modules/core-js/internals/ordinary-to-primitive.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-property-key.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toPrimitive = __webpack_require__("../../node_modules/core-js/internals/to-primitive.js");
var isSymbol = __webpack_require__("../../node_modules/core-js/internals/is-symbol.js");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "../../node_modules/core-js/internals/to-string-tag-support.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "../../node_modules/core-js/internals/to-string.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/try-to-string.js":
/***/ ((module) => {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "../../node_modules/core-js/internals/typed-array-constructor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__("../../node_modules/core-js/internals/typed-array-constructors-require-wrappers.js");
var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var ArrayBufferModule = __webpack_require__("../../node_modules/core-js/internals/array-buffer.js");
var anInstance = __webpack_require__("../../node_modules/core-js/internals/an-instance.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var isIntegralNumber = __webpack_require__("../../node_modules/core-js/internals/is-integral-number.js");
var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");
var toIndex = __webpack_require__("../../node_modules/core-js/internals/to-index.js");
var toOffset = __webpack_require__("../../node_modules/core-js/internals/to-offset.js");
var toPropertyKey = __webpack_require__("../../node_modules/core-js/internals/to-property-key.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var isSymbol = __webpack_require__("../../node_modules/core-js/internals/is-symbol.js");
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");
var getOwnPropertyNames = (__webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js").f);
var typedArrayFrom = __webpack_require__("../../node_modules/core-js/internals/typed-array-from.js");
var forEach = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").forEach);
var setSpecies = __webpack_require__("../../node_modules/core-js/internals/set-species.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var getOwnPropertyDescriptorModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");
var inheritIfRequired = __webpack_require__("../../node_modules/core-js/internals/inherit-if-required.js");

var getInternalState = InternalStateModule.get;
var setInternalState = InternalStateModule.set;
var enforceInternalState = InternalStateModule.enforce;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var round = Math.round;
var RangeError = global.RangeError;
var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = ArrayBufferModule.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = ArrayBufferViewCore.TypedArray;
var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = ArrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  aTypedArrayConstructor(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  defineBuiltInAccessor(it, key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwn(descriptor, 'value')
    && !hasOwn(descriptor, 'get')
    && !hasOwn(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (DESCRIPTORS) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
    definePropertyModule.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return call(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor != NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    $({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };


/***/ }),

/***/ "../../node_modules/core-js/internals/typed-array-constructors-require-wrappers.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable no-new -- required for testing */
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var checkCorrectnessOfIteration = __webpack_require__("../../node_modules/core-js/internals/check-correctness-of-iteration.js");
var NATIVE_ARRAY_BUFFER_VIEWS = (__webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js").NATIVE_ARRAY_BUFFER_VIEWS);

var ArrayBuffer = global.ArrayBuffer;
var Int8Array = global.Int8Array;

module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array(1);
}) || !fails(function () {
  new Int8Array(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array();
  new Int8Array(null);
  new Int8Array(1.5);
  new Int8Array(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/typed-array-from-species-and-list.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayFromConstructorAndList = __webpack_require__("../../node_modules/core-js/internals/array-from-constructor-and-list.js");
var typedArraySpeciesConstructor = __webpack_require__("../../node_modules/core-js/internals/typed-array-species-constructor.js");

module.exports = function (instance, list) {
  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/typed-array-from.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var aConstructor = __webpack_require__("../../node_modules/core-js/internals/a-constructor.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var getIterator = __webpack_require__("../../node_modules/core-js/internals/get-iterator.js");
var getIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/get-iterator-method.js");
var isArrayIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/is-array-iterator-method.js");
var isBigIntArray = __webpack_require__("../../node_modules/core-js/internals/is-big-int-array.js");
var aTypedArrayConstructor = (__webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js").aTypedArrayConstructor);
var toBigInt = __webpack_require__("../../node_modules/core-js/internals/to-big-int.js");

module.exports = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = call(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = bind(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }
  return result;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/typed-array-species-constructor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var speciesConstructor = __webpack_require__("../../node_modules/core-js/internals/species-constructor.js");

var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;

// a part of `TypedArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#typedarray-species-create
module.exports = function (originalArray) {
  return aTypedArrayConstructor(speciesConstructor(originalArray, getTypedArrayConstructor(originalArray)));
};


/***/ }),

/***/ "../../node_modules/core-js/internals/uid.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "../../node_modules/core-js/internals/url-constructor-detection.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || (!searchParams.size && (IS_PURE || !DESCRIPTORS))
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ "../../node_modules/core-js/internals/use-symbol-as-uid.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "../../node_modules/core-js/internals/v8-prototype-define-bug.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "../../node_modules/core-js/internals/validate-arguments-length.js":
/***/ ((module) => {

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ "../../node_modules/core-js/internals/weak-map-basic-detection.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ "../../node_modules/core-js/internals/well-known-symbol-define.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var path = __webpack_require__("../../node_modules/core-js/internals/path.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var wrappedWellKnownSymbolModule = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-wrapped.js");
var defineProperty = (__webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "../../node_modules/core-js/internals/well-known-symbol-wrapped.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "../../node_modules/core-js/internals/well-known-symbol.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var uid = __webpack_require__("../../node_modules/core-js/internals/uid.js");
var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");
var USE_SYMBOL_AS_UID = __webpack_require__("../../node_modules/core-js/internals/use-symbol-as-uid.js");

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "../../node_modules/core-js/internals/whitespaces.js":
/***/ ((module) => {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array-buffer.slice.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this-clause.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var ArrayBufferModule = __webpack_require__("../../node_modules/core-js/internals/array-buffer.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var toAbsoluteIndex = __webpack_require__("../../node_modules/core-js/internals/to-absolute-index.js");
var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");
var speciesConstructor = __webpack_require__("../../node_modules/core-js/internals/species-constructor.js");

var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
var DataView = ArrayBufferModule.DataView;
var DataViewPrototype = DataView.prototype;
var nativeArrayBufferSlice = uncurryThis(ArrayBuffer.prototype.slice);
var getUint8 = uncurryThis(DataViewPrototype.getUint8);
var setUint8 = uncurryThis(DataViewPrototype.setUint8);

var INCORRECT_SLICE = fails(function () {
  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
});

// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
  slice: function slice(start, end) {
    if (nativeArrayBufferSlice && end === undefined) {
      return nativeArrayBufferSlice(anObject(this), start); // FF fix
    }
    var length = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    var result = new (speciesConstructor(this, ArrayBuffer))(toLength(fin - first));
    var viewSource = new DataView(this);
    var viewTarget = new DataView(result);
    var index = 0;
    while (first < fin) {
      setUint8(viewTarget, index++, getUint8(viewSource, first++));
    } return result;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.concat.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isArray = __webpack_require__("../../node_modules/core-js/internals/is-array.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var doesNotExceedSafeInteger = __webpack_require__("../../node_modules/core-js/internals/does-not-exceed-safe-integer.js");
var createProperty = __webpack_require__("../../node_modules/core-js/internals/create-property.js");
var arraySpeciesCreate = __webpack_require__("../../node_modules/core-js/internals/array-species-create.js");
var arrayMethodHasSpeciesSupport = __webpack_require__("../../node_modules/core-js/internals/array-method-has-species-support.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var V8_VERSION = __webpack_require__("../../node_modules/core-js/internals/engine-v8-version.js");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.every.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $every = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").every);
var arrayMethodIsStrict = __webpack_require__("../../node_modules/core-js/internals/array-method-is-strict.js");

var STRICT_METHOD = arrayMethodIsStrict('every');

// `Array.prototype.every` method
// https://tc39.es/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.filter.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $filter = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").filter);
var arrayMethodHasSpeciesSupport = __webpack_require__("../../node_modules/core-js/internals/array-method-has-species-support.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.find-index.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $findIndex = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").findIndex);
var addToUnscopables = __webpack_require__("../../node_modules/core-js/internals/add-to-unscopables.js");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-findindex -- testing
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.find.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $find = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").find);
var addToUnscopables = __webpack_require__("../../node_modules/core-js/internals/add-to-unscopables.js");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.flat-map.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var flattenIntoArray = __webpack_require__("../../node_modules/core-js/internals/flatten-into-array.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var arraySpeciesCreate = __webpack_require__("../../node_modules/core-js/internals/array-species-create.js");

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.for-each.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var forEach = __webpack_require__("../../node_modules/core-js/internals/array-for-each.js");

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.from.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var from = __webpack_require__("../../node_modules/core-js/internals/array-from.js");
var checkCorrectnessOfIteration = __webpack_require__("../../node_modules/core-js/internals/check-correctness-of-iteration.js");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.includes.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $includes = (__webpack_require__("../../node_modules/core-js/internals/array-includes.js").includes);
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var addToUnscopables = __webpack_require__("../../node_modules/core-js/internals/add-to-unscopables.js");

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.index-of.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

/* eslint-disable es/no-array-prototype-indexof -- required for testing */
var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this-clause.js");
var $indexOf = (__webpack_require__("../../node_modules/core-js/internals/array-includes.js").indexOf);
var arrayMethodIsStrict = __webpack_require__("../../node_modules/core-js/internals/array-method-is-strict.js");

var nativeIndexOf = uncurryThis([].indexOf);

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
var FORCED = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: FORCED }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf(this, searchElement, fromIndex) || 0
      : $indexOf(this, searchElement, fromIndex);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.iterator.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var addToUnscopables = __webpack_require__("../../node_modules/core-js/internals/add-to-unscopables.js");
var Iterators = __webpack_require__("../../node_modules/core-js/internals/iterators.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");
var defineProperty = (__webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f);
var defineIterator = __webpack_require__("../../node_modules/core-js/internals/iterator-define.js");
var createIterResultObject = __webpack_require__("../../node_modules/core-js/internals/create-iter-result-object.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.join.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var IndexedObject = __webpack_require__("../../node_modules/core-js/internals/indexed-object.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var arrayMethodIsStrict = __webpack_require__("../../node_modules/core-js/internals/array-method-is-strict.js");

var nativeJoin = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: FORCED }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.last-index-of.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var lastIndexOf = __webpack_require__("../../node_modules/core-js/internals/array-last-index-of.js");

// `Array.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
  lastIndexOf: lastIndexOf
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.map.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $map = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").map);
var arrayMethodHasSpeciesSupport = __webpack_require__("../../node_modules/core-js/internals/array-method-has-species-support.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.reduce.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $reduce = (__webpack_require__("../../node_modules/core-js/internals/array-reduce.js").left);
var arrayMethodIsStrict = __webpack_require__("../../node_modules/core-js/internals/array-method-is-strict.js");
var CHROME_VERSION = __webpack_require__("../../node_modules/core-js/internals/engine-v8-version.js");
var IS_NODE = __webpack_require__("../../node_modules/core-js/internals/engine-is-node.js");

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.reverse.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var isArray = __webpack_require__("../../node_modules/core-js/internals/is-array.js");

var nativeReverse = uncurryThis([].reverse);
var test = [1, 2];

// `Array.prototype.reverse` method
// https://tc39.es/ecma262/#sec-array.prototype.reverse
// fix for Safari 12.0 bug
// https://bugs.webkit.org/show_bug.cgi?id=188794
$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
  reverse: function reverse() {
    // eslint-disable-next-line no-self-assign -- dirty hack
    if (isArray(this)) this.length = this.length;
    return nativeReverse(this);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.slice.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var isArray = __webpack_require__("../../node_modules/core-js/internals/is-array.js");
var isConstructor = __webpack_require__("../../node_modules/core-js/internals/is-constructor.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var toAbsoluteIndex = __webpack_require__("../../node_modules/core-js/internals/to-absolute-index.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var createProperty = __webpack_require__("../../node_modules/core-js/internals/create-property.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var arrayMethodHasSpeciesSupport = __webpack_require__("../../node_modules/core-js/internals/array-method-has-species-support.js");
var nativeSlice = __webpack_require__("../../node_modules/core-js/internals/array-slice.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.some.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $some = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").some);
var arrayMethodIsStrict = __webpack_require__("../../node_modules/core-js/internals/array-method-is-strict.js");

var STRICT_METHOD = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.splice.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var toAbsoluteIndex = __webpack_require__("../../node_modules/core-js/internals/to-absolute-index.js");
var toIntegerOrInfinity = __webpack_require__("../../node_modules/core-js/internals/to-integer-or-infinity.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var setArrayLength = __webpack_require__("../../node_modules/core-js/internals/array-set-length.js");
var doesNotExceedSafeInteger = __webpack_require__("../../node_modules/core-js/internals/does-not-exceed-safe-integer.js");
var arraySpeciesCreate = __webpack_require__("../../node_modules/core-js/internals/array-species-create.js");
var createProperty = __webpack_require__("../../node_modules/core-js/internals/create-property.js");
var deletePropertyOrThrow = __webpack_require__("../../node_modules/core-js/internals/delete-property-or-throw.js");
var arrayMethodHasSpeciesSupport = __webpack_require__("../../node_modules/core-js/internals/array-method-has-species-support.js");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    setArrayLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.array.unscopables.flat-map.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = __webpack_require__("../../node_modules/core-js/internals/add-to-unscopables.js");

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.date.to-iso-string.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var toISOString = __webpack_require__("../../node_modules/core-js/internals/date-to-iso-string.js");

// `Date.prototype.toISOString` method
// https://tc39.es/ecma262/#sec-date.prototype.toisostring
// PhantomJS / old WebKit has a broken implementations
$({ target: 'Date', proto: true, forced: Date.prototype.toISOString !== toISOString }, {
  toISOString: toISOString
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.date.to-primitive.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var dateToPrimitive = __webpack_require__("../../node_modules/core-js/internals/date-to-primitive.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
  defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.json.stringify.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var apply = __webpack_require__("../../node_modules/core-js/internals/function-apply.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isSymbol = __webpack_require__("../../node_modules/core-js/internals/is-symbol.js");
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice.js");
var getReplacerFunction = __webpack_require__("../../node_modules/core-js/internals/get-json-replacer-function.js");
var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.json.to-string-tag.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.map.constructor.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__("../../node_modules/core-js/internals/collection.js");
var collectionStrong = __webpack_require__("../../node_modules/core-js/internals/collection-strong.js");

// `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects
collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.map.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("../../node_modules/core-js/modules/es.map.constructor.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/es.math.to-string-tag.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.number.constructor.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var path = __webpack_require__("../../node_modules/core-js/internals/path.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var isForced = __webpack_require__("../../node_modules/core-js/internals/is-forced.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var inheritIfRequired = __webpack_require__("../../node_modules/core-js/internals/inherit-if-required.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var isSymbol = __webpack_require__("../../node_modules/core-js/internals/is-symbol.js");
var toPrimitive = __webpack_require__("../../node_modules/core-js/internals/to-primitive.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var getOwnPropertyNames = (__webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js").f);
var getOwnPropertyDescriptor = (__webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js").f);
var defineProperty = (__webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f);
var thisNumberValue = __webpack_require__("../../node_modules/core-js/internals/this-number-value.js");
var trim = (__webpack_require__("../../node_modules/core-js/internals/string-trim.js").trim);

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = stringSlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;

$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.number.is-integer.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var isIntegralNumber = __webpack_require__("../../node_modules/core-js/internals/is-integral-number.js");

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.number.is-safe-integer.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var isIntegralNumber = __webpack_require__("../../node_modules/core-js/internals/is-integral-number.js");

var abs = Math.abs;

// `Number.isSafeInteger` method
// https://tc39.es/ecma262/#sec-number.issafeinteger
$({ target: 'Number', stat: true }, {
  isSafeInteger: function isSafeInteger(number) {
    return isIntegralNumber(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.number.max-safe-integer.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.assign.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var assign = __webpack_require__("../../node_modules/core-js/internals/object-assign.js");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.define-properties.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var defineProperties = (__webpack_require__("../../node_modules/core-js/internals/object-define-properties.js").f);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperties !== defineProperties, sham: !DESCRIPTORS }, {
  defineProperties: defineProperties
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.define-property.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var defineProperty = (__webpack_require__("../../node_modules/core-js/internals/object-define-property.js").f);

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe
$({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty, sham: !DESCRIPTORS }, {
  defineProperty: defineProperty
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.entries.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $entries = (__webpack_require__("../../node_modules/core-js/internals/object-to-array.js").entries);

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.freeze.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var FREEZING = __webpack_require__("../../node_modules/core-js/internals/freezing.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var onFreeze = (__webpack_require__("../../node_modules/core-js/internals/internal-metadata.js").onFreeze);

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.from-entries.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var createProperty = __webpack_require__("../../node_modules/core-js/internals/create-property.js");

// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$({ target: 'Object', stat: true }, {
  fromEntries: function fromEntries(iterable) {
    var obj = {};
    iterate(iterable, function (k, v) {
      createProperty(obj, k, v);
    }, { AS_ENTRIES: true });
    return obj;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.get-own-property-descriptor.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var nativeGetOwnPropertyDescriptor = (__webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js").f);
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.get-own-property-descriptors.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var ownKeys = __webpack_require__("../../node_modules/core-js/internals/own-keys.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var getOwnPropertyDescriptorModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js");
var createProperty = __webpack_require__("../../node_modules/core-js/internals/create-property.js");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.get-own-property-symbols.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var getOwnPropertySymbolsModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-symbols.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.get-prototype-of.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var nativeGetPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-get-prototype-of.js");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("../../node_modules/core-js/internals/correct-prototype-getter.js");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.keys.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var toObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var nativeKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.set-prototype-of.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.to-string.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var TO_STRING_TAG_SUPPORT = __webpack_require__("../../node_modules/core-js/internals/to-string-tag-support.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/object-to-string.js");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.object.values.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $values = (__webpack_require__("../../node_modules/core-js/internals/object-to-array.js").values);

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.parse-int.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $parseInt = __webpack_require__("../../node_modules/core-js/internals/number-parse-int.js");

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$({ global: true, forced: parseInt != $parseInt }, {
  parseInt: $parseInt
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.all-settled.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");
var perform = __webpack_require__("../../node_modules/core-js/internals/perform.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("../../node_modules/core-js/internals/promise-statics-incorrect-iteration.js");

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.all.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");
var perform = __webpack_require__("../../node_modules/core-js/internals/perform.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("../../node_modules/core-js/internals/promise-statics-incorrect-iteration.js");

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.catch.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__("../../node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR);
var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.constructor.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var IS_NODE = __webpack_require__("../../node_modules/core-js/internals/engine-is-node.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var setPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-set-prototype-of.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var setSpecies = __webpack_require__("../../node_modules/core-js/internals/set-species.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var anInstance = __webpack_require__("../../node_modules/core-js/internals/an-instance.js");
var speciesConstructor = __webpack_require__("../../node_modules/core-js/internals/species-constructor.js");
var task = (__webpack_require__("../../node_modules/core-js/internals/task.js").set);
var microtask = __webpack_require__("../../node_modules/core-js/internals/microtask.js");
var hostReportErrors = __webpack_require__("../../node_modules/core-js/internals/host-report-errors.js");
var perform = __webpack_require__("../../node_modules/core-js/internals/perform.js");
var Queue = __webpack_require__("../../node_modules/core-js/internals/queue.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");
var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var PromiseConstructorDetection = __webpack_require__("../../node_modules/core-js/internals/promise-constructor-detection.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.finally.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var speciesConstructor = __webpack_require__("../../node_modules/core-js/internals/species-constructor.js");
var promiseResolve = __webpack_require__("../../node_modules/core-js/internals/promise-resolve.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("../../node_modules/core-js/modules/es.promise.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.all.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.catch.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.race.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.reject.js");
__webpack_require__("../../node_modules/core-js/modules/es.promise.resolve.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.race.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");
var perform = __webpack_require__("../../node_modules/core-js/internals/perform.js");
var iterate = __webpack_require__("../../node_modules/core-js/internals/iterate.js");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("../../node_modules/core-js/internals/promise-statics-incorrect-iteration.js");

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.reject.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var newPromiseCapabilityModule = __webpack_require__("../../node_modules/core-js/internals/new-promise-capability.js");
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__("../../node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR);

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.promise.resolve.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var NativePromiseConstructor = __webpack_require__("../../node_modules/core-js/internals/promise-native-constructor.js");
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__("../../node_modules/core-js/internals/promise-constructor-detection.js").CONSTRUCTOR);
var promiseResolve = __webpack_require__("../../node_modules/core-js/internals/promise-resolve.js");

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.reflect.construct.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var apply = __webpack_require__("../../node_modules/core-js/internals/function-apply.js");
var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind.js");
var aConstructor = __webpack_require__("../../node_modules/core-js/internals/a-constructor.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.reflect.get.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var isDataDescriptor = __webpack_require__("../../node_modules/core-js/internals/is-data-descriptor.js");
var getOwnPropertyDescriptorModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js");
var getPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-get-prototype-of.js");

// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
  if (descriptor) return isDataDescriptor(descriptor)
    ? descriptor.value
    : descriptor.get === undefined ? undefined : call(descriptor.get, receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.regexp.exec.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var exec = __webpack_require__("../../node_modules/core-js/internals/regexp-exec.js");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.regexp.to-string.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var PROPER_FUNCTION_NAME = (__webpack_require__("../../node_modules/core-js/internals/function-name.js").PROPER);
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var $toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var getRegExpFlags = __webpack_require__("../../node_modules/core-js/internals/regexp-get-flags.js");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.set.constructor.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__("../../node_modules/core-js/internals/collection.js");
var collectionStrong = __webpack_require__("../../node_modules/core-js/internals/collection-strong.js");

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.set.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("../../node_modules/core-js/modules/es.set.constructor.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/es.string.ends-with.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this-clause.js");
var getOwnPropertyDescriptor = (__webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js").f);
var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var notARegExp = __webpack_require__("../../node_modules/core-js/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");
var correctIsRegExpLogic = __webpack_require__("../../node_modules/core-js/internals/correct-is-regexp-logic.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");

// eslint-disable-next-line es/no-string-prototype-endswith -- safe
var nativeEndsWith = uncurryThis(''.endsWith);
var slice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return nativeEndsWith
      ? nativeEndsWith(that, search, end)
      : slice(that, end - search.length, end) === search;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.string.includes.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var notARegExp = __webpack_require__("../../node_modules/core-js/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var correctIsRegExpLogic = __webpack_require__("../../node_modules/core-js/internals/correct-is-regexp-logic.js");

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.string.iterator.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var charAt = (__webpack_require__("../../node_modules/core-js/internals/string-multibyte.js").charAt);
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");
var defineIterator = __webpack_require__("../../node_modules/core-js/internals/iterator-define.js");
var createIterResultObject = __webpack_require__("../../node_modules/core-js/internals/create-iter-result-object.js");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.string.match.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("../../node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");
var getMethod = __webpack_require__("../../node_modules/core-js/internals/get-method.js");
var advanceStringIndex = __webpack_require__("../../node_modules/core-js/internals/advance-string-index.js");
var regExpExec = __webpack_require__("../../node_modules/core-js/internals/regexp-exec-abstract.js");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.string.split.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var apply = __webpack_require__("../../node_modules/core-js/internals/function-apply.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("../../node_modules/core-js/internals/fix-regexp-well-known-symbol-logic.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var isNullOrUndefined = __webpack_require__("../../node_modules/core-js/internals/is-null-or-undefined.js");
var isRegExp = __webpack_require__("../../node_modules/core-js/internals/is-regexp.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");
var speciesConstructor = __webpack_require__("../../node_modules/core-js/internals/species-constructor.js");
var advanceStringIndex = __webpack_require__("../../node_modules/core-js/internals/advance-string-index.js");
var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var getMethod = __webpack_require__("../../node_modules/core-js/internals/get-method.js");
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice-simple.js");
var callRegExpExec = __webpack_require__("../../node_modules/core-js/internals/regexp-exec-abstract.js");
var regexpExec = __webpack_require__("../../node_modules/core-js/internals/regexp-exec.js");
var stickyHelpers = __webpack_require__("../../node_modules/core-js/internals/regexp-sticky-helpers.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.string.starts-with.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this-clause.js");
var getOwnPropertyDescriptor = (__webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js").f);
var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var notARegExp = __webpack_require__("../../node_modules/core-js/internals/not-a-regexp.js");
var requireObjectCoercible = __webpack_require__("../../node_modules/core-js/internals/require-object-coercible.js");
var correctIsRegExpLogic = __webpack_require__("../../node_modules/core-js/internals/correct-is-regexp-logic.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.string.trim.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var $trim = (__webpack_require__("../../node_modules/core-js/internals/string-trim.js").trim);
var forcedStringTrimMethod = __webpack_require__("../../node_modules/core-js/internals/string-trim-forced.js");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.async-iterator.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.constructor.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var IS_PURE = __webpack_require__("../../node_modules/core-js/internals/is-pure.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var NATIVE_SYMBOL = __webpack_require__("../../node_modules/core-js/internals/symbol-constructor-detection.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-indexed-object.js");
var toPropertyKey = __webpack_require__("../../node_modules/core-js/internals/to-property-key.js");
var $toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");
var nativeObjectCreate = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var objectKeys = __webpack_require__("../../node_modules/core-js/internals/object-keys.js");
var getOwnPropertyNamesModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names.js");
var getOwnPropertyNamesExternal = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-names-external.js");
var getOwnPropertySymbolsModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-symbols.js");
var getOwnPropertyDescriptorModule = __webpack_require__("../../node_modules/core-js/internals/object-get-own-property-descriptor.js");
var definePropertyModule = __webpack_require__("../../node_modules/core-js/internals/object-define-property.js");
var definePropertiesModule = __webpack_require__("../../node_modules/core-js/internals/object-define-properties.js");
var propertyIsEnumerableModule = __webpack_require__("../../node_modules/core-js/internals/object-property-is-enumerable.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var sharedKey = __webpack_require__("../../node_modules/core-js/internals/shared-key.js");
var hiddenKeys = __webpack_require__("../../node_modules/core-js/internals/hidden-keys.js");
var uid = __webpack_require__("../../node_modules/core-js/internals/uid.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var wrappedWellKnownSymbolModule = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-wrapped.js");
var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");
var defineSymbolToPrimitive = __webpack_require__("../../node_modules/core-js/internals/symbol-define-to-primitive.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");
var $forEach = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.description.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var isPrototypeOf = __webpack_require__("../../node_modules/core-js/internals/object-is-prototype-of.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var copyConstructorProperties = __webpack_require__("../../node_modules/core-js/internals/copy-constructor-properties.js");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.for.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("../../node_modules/core-js/internals/symbol-registry-detection.js");

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.iterator.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("../../node_modules/core-js/modules/es.symbol.constructor.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.for.js");
__webpack_require__("../../node_modules/core-js/modules/es.symbol.key-for.js");
__webpack_require__("../../node_modules/core-js/modules/es.json.stringify.js");
__webpack_require__("../../node_modules/core-js/modules/es.object.get-own-property-symbols.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.key-for.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var isSymbol = __webpack_require__("../../node_modules/core-js/internals/is-symbol.js");
var tryToString = __webpack_require__("../../node_modules/core-js/internals/try-to-string.js");
var shared = __webpack_require__("../../node_modules/core-js/internals/shared.js");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("../../node_modules/core-js/internals/symbol-registry-detection.js");

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.to-primitive.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");
var defineSymbolToPrimitive = __webpack_require__("../../node_modules/core-js/internals/symbol-define-to-primitive.js");

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();


/***/ }),

/***/ "../../node_modules/core-js/modules/es.symbol.to-string-tag.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var getBuiltIn = __webpack_require__("../../node_modules/core-js/internals/get-built-in.js");
var defineWellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol-define.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.copy-within.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $ArrayCopyWithin = __webpack_require__("../../node_modules/core-js/internals/array-copy-within.js");

var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.copyWithin` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
  return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.every.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $every = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").every);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.every` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.fill.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $fill = __webpack_require__("../../node_modules/core-js/internals/array-fill.js");
var toBigInt = __webpack_require__("../../node_modules/core-js/internals/to-big-int.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var slice = uncurryThis(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return call($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.filter.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $filter = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").filter);
var fromSpeciesAndList = __webpack_require__("../../node_modules/core-js/internals/typed-array-from-species-and-list.js");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.filter` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.find-index.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $findIndex = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").findIndex);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.find.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $find = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").find);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.find` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.for-each.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $forEach = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").forEach);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.forEach` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.includes.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $includes = (__webpack_require__("../../node_modules/core-js/internals/array-includes.js").includes);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.includes` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.index-of.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $indexOf = (__webpack_require__("../../node_modules/core-js/internals/array-includes.js").indexOf);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.iterator.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var ArrayIterators = __webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');
var Uint8Array = global.Uint8Array;
var arrayValues = uncurryThis(ArrayIterators.values);
var arrayKeys = uncurryThis(ArrayIterators.keys);
var arrayEntries = uncurryThis(ArrayIterators.entries);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;

var GENERIC = !fails(function () {
  TypedArrayPrototype[ITERATOR].call([1]);
});

var ITERATOR_IS_VALUES = !!TypedArrayPrototype
  && TypedArrayPrototype.values
  && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values
  && TypedArrayPrototype.values.name === 'values';

var typedArrayValues = function values() {
  return arrayValues(aTypedArray(this));
};

// `%TypedArray%.prototype.entries` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
exportTypedArrayMethod('entries', function entries() {
  return arrayEntries(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.keys` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
exportTypedArrayMethod('keys', function keys() {
  return arrayKeys(aTypedArray(this));
}, GENERIC);
// `%TypedArray%.prototype.values` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
// `%TypedArray%.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.join.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $join = uncurryThis([].join);

// `%TypedArray%.prototype.join` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
exportTypedArrayMethod('join', function join(separator) {
  return $join(aTypedArray(this), separator);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.last-index-of.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var apply = __webpack_require__("../../node_modules/core-js/internals/function-apply.js");
var $lastIndexOf = __webpack_require__("../../node_modules/core-js/internals/array-last-index-of.js");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.lastIndexOf` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
  var length = arguments.length;
  return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.map.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $map = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").map);
var typedArraySpeciesConstructor = __webpack_require__("../../node_modules/core-js/internals/typed-array-species-constructor.js");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.map` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
    return new (typedArraySpeciesConstructor(O))(length);
  });
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.reduce-right.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $reduceRight = (__webpack_require__("../../node_modules/core-js/internals/array-reduce.js").right);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduceRight` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.reduce.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $reduce = (__webpack_require__("../../node_modules/core-js/internals/array-reduce.js").left);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.reduce` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
  var length = arguments.length;
  return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.reverse.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var floor = Math.floor;

// `%TypedArray%.prototype.reverse` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
exportTypedArrayMethod('reverse', function reverse() {
  var that = this;
  var length = aTypedArray(that).length;
  var middle = floor(length / 2);
  var index = 0;
  var value;
  while (index < middle) {
    value = that[index];
    that[index++] = that[--length];
    that[length] = value;
  } return that;
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.set.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var lengthOfArrayLike = __webpack_require__("../../node_modules/core-js/internals/length-of-array-like.js");
var toOffset = __webpack_require__("../../node_modules/core-js/internals/to-offset.js");
var toIndexedObject = __webpack_require__("../../node_modules/core-js/internals/to-object.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");

var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  call($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
  aTypedArray(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toIndexedObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.slice.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var typedArraySpeciesConstructor = __webpack_require__("../../node_modules/core-js/internals/typed-array-species-constructor.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice.js");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

var FORCED = fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  new Int8Array(1).slice();
});

// `%TypedArray%.prototype.slice` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
exportTypedArrayMethod('slice', function slice(start, end) {
  var list = arraySlice(aTypedArray(this), start, end);
  var C = typedArraySpeciesConstructor(this);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
}, FORCED);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.some.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var $some = (__webpack_require__("../../node_modules/core-js/internals/array-iteration.js").some);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.some` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.sort.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this-clause.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var aCallable = __webpack_require__("../../node_modules/core-js/internals/a-callable.js");
var internalSort = __webpack_require__("../../node_modules/core-js/internals/array-sort.js");
var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var FF = __webpack_require__("../../node_modules/core-js/internals/engine-ff-version.js");
var IE_OR_EDGE = __webpack_require__("../../node_modules/core-js/internals/engine-is-ie-or-edge.js");
var V8 = __webpack_require__("../../node_modules/core-js/internals/engine-v8-version.js");
var WEBKIT = __webpack_require__("../../node_modules/core-js/internals/engine-webkit-version.js");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = global.Uint16Array;
var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
  nativeSort(new Uint16Array(2), null);
}) && fails(function () {
  nativeSort(new Uint16Array(2), {});
}));

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 74;
  if (FF) return FF < 67;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);

  return internalSort(aTypedArray(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.subarray.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var toLength = __webpack_require__("../../node_modules/core-js/internals/to-length.js");
var toAbsoluteIndex = __webpack_require__("../../node_modules/core-js/internals/to-absolute-index.js");
var typedArraySpeciesConstructor = __webpack_require__("../../node_modules/core-js/internals/typed-array-species-constructor.js");

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;

// `%TypedArray%.prototype.subarray` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
exportTypedArrayMethod('subarray', function subarray(begin, end) {
  var O = aTypedArray(this);
  var length = O.length;
  var beginIndex = toAbsoluteIndex(begin, length);
  var C = typedArraySpeciesConstructor(O);
  return new C(
    O.buffer,
    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
  );
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.to-locale-string.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var apply = __webpack_require__("../../node_modules/core-js/internals/function-apply.js");
var ArrayBufferViewCore = __webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js");
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var arraySlice = __webpack_require__("../../node_modules/core-js/internals/array-slice.js");

var Int8Array = global.Int8Array;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var $toLocaleString = [].toLocaleString;

// iOS Safari 6.x fails here
var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
  $toLocaleString.call(new Int8Array(1));
});

var FORCED = fails(function () {
  return [1, 2].toLocaleString() != new Int8Array([1, 2]).toLocaleString();
}) || !fails(function () {
  Int8Array.prototype.toLocaleString.call([1, 2]);
});

// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
exportTypedArrayMethod('toLocaleString', function toLocaleString() {
  return apply(
    $toLocaleString,
    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
    arraySlice(arguments)
  );
}, FORCED);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.to-string.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var exportTypedArrayMethod = (__webpack_require__("../../node_modules/core-js/internals/array-buffer-view-core.js").exportTypedArrayMethod);
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");

var Uint8Array = global.Uint8Array;
var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
var arrayToString = [].toString;
var join = uncurryThis([].join);

if (fails(function () { arrayToString.call({}); })) {
  arrayToString = function toString() {
    return join(this);
  };
}

var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString != arrayToString;

// `%TypedArray%.prototype.toString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.typed-array.uint8-array.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var createTypedArrayConstructor = __webpack_require__("../../node_modules/core-js/internals/typed-array-constructor.js");

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
createTypedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),

/***/ "../../node_modules/core-js/modules/es.weak-map.constructor.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var FREEZING = __webpack_require__("../../node_modules/core-js/internals/freezing.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var defineBuiltIns = __webpack_require__("../../node_modules/core-js/internals/define-built-ins.js");
var InternalMetadataModule = __webpack_require__("../../node_modules/core-js/internals/internal-metadata.js");
var collection = __webpack_require__("../../node_modules/core-js/internals/collection.js");
var collectionWeak = __webpack_require__("../../node_modules/core-js/internals/collection-weak.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var enforceInternalState = (__webpack_require__("../../node_modules/core-js/internals/internal-state.js").enforce);
var fails = __webpack_require__("../../node_modules/core-js/internals/fails.js");
var NATIVE_WEAK_MAP = __webpack_require__("../../node_modules/core-js/internals/weak-map-basic-detection.js");

var $Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = $Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var isFrozen = $Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var isSealed = $Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var freeze = $Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var seal = $Object.seal;

var FROZEN = {};
var SEALED = {};
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
var WeakMapPrototype = $WeakMap.prototype;
var nativeSet = uncurryThis(WeakMapPrototype.set);

// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var hasMSEdgeFreezingBug = function () {
  return FREEZING && fails(function () {
    var frozenArray = freeze([]);
    nativeSet(new $WeakMap(), frozenArray, 1);
    return !isFrozen(frozenArray);
  });
};

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP) if (IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
  var nativeHas = uncurryThis(WeakMapPrototype.has);
  var nativeGet = uncurryThis(WeakMapPrototype.get);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      } return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      } return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      } return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);
      return this;
    }
  });
// Chakra Edge frozen keys fix
} else if (hasMSEdgeFreezingBug()) {
  defineBuiltIns(WeakMapPrototype, {
    set: function set(key, value) {
      var arrayIntegrityLevel;
      if (isArray(key)) {
        if (isFrozen(key)) arrayIntegrityLevel = FROZEN;
        else if (isSealed(key)) arrayIntegrityLevel = SEALED;
      }
      nativeSet(this, key, value);
      if (arrayIntegrityLevel == FROZEN) freeze(key);
      if (arrayIntegrityLevel == SEALED) seal(key);
      return this;
    }
  });
}


/***/ }),

/***/ "../../node_modules/core-js/modules/es.weak-map.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("../../node_modules/core-js/modules/es.weak-map.constructor.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/es.weak-set.constructor.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var collection = __webpack_require__("../../node_modules/core-js/internals/collection.js");
var collectionWeak = __webpack_require__("../../node_modules/core-js/internals/collection-weak.js");

// `WeakSet` constructor
// https://tc39.es/ecma262/#sec-weakset-constructor
collection('WeakSet', function (init) {
  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionWeak);


/***/ }),

/***/ "../../node_modules/core-js/modules/es.weak-set.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("../../node_modules/core-js/modules/es.weak-set.constructor.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/esnext.promise.all-settled.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove from `core-js@4`
__webpack_require__("../../node_modules/core-js/modules/es.promise.all-settled.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/web.clear-immediate.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var clearImmediate = (__webpack_require__("../../node_modules/core-js/internals/task.js").clear);

// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$({ global: true, bind: true, enumerable: true, forced: global.clearImmediate !== clearImmediate }, {
  clearImmediate: clearImmediate
});


/***/ }),

/***/ "../../node_modules/core-js/modules/web.dom-collections.for-each.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var DOMIterables = __webpack_require__("../../node_modules/core-js/internals/dom-iterables.js");
var DOMTokenListPrototype = __webpack_require__("../../node_modules/core-js/internals/dom-token-list-prototype.js");
var forEach = __webpack_require__("../../node_modules/core-js/internals/array-for-each.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ "../../node_modules/core-js/modules/web.dom-collections.iterator.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var DOMIterables = __webpack_require__("../../node_modules/core-js/internals/dom-iterables.js");
var DOMTokenListPrototype = __webpack_require__("../../node_modules/core-js/internals/dom-token-list-prototype.js");
var ArrayIteratorMethods = __webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
var createNonEnumerableProperty = __webpack_require__("../../node_modules/core-js/internals/create-non-enumerable-property.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "../../node_modules/core-js/modules/web.immediate.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("../../node_modules/core-js/modules/web.clear-immediate.js");
__webpack_require__("../../node_modules/core-js/modules/web.set-immediate.js");


/***/ }),

/***/ "../../node_modules/core-js/modules/web.set-immediate.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var setTask = (__webpack_require__("../../node_modules/core-js/internals/task.js").set);
var schedulersFix = __webpack_require__("../../node_modules/core-js/internals/schedulers-fix.js");

// https://github.com/oven-sh/bun/issues/1633
var setImmediate = global.setImmediate ? schedulersFix(setTask, false) : setTask;

// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$({ global: true, bind: true, enumerable: true, forced: global.setImmediate !== setImmediate }, {
  setImmediate: setImmediate
});


/***/ }),

/***/ "../../node_modules/core-js/modules/web.url-search-params.constructor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__("../../node_modules/core-js/modules/es.array.iterator.js");
var $ = __webpack_require__("../../node_modules/core-js/internals/export.js");
var global = __webpack_require__("../../node_modules/core-js/internals/global.js");
var call = __webpack_require__("../../node_modules/core-js/internals/function-call.js");
var uncurryThis = __webpack_require__("../../node_modules/core-js/internals/function-uncurry-this.js");
var DESCRIPTORS = __webpack_require__("../../node_modules/core-js/internals/descriptors.js");
var USE_NATIVE_URL = __webpack_require__("../../node_modules/core-js/internals/url-constructor-detection.js");
var defineBuiltIn = __webpack_require__("../../node_modules/core-js/internals/define-built-in.js");
var defineBuiltInAccessor = __webpack_require__("../../node_modules/core-js/internals/define-built-in-accessor.js");
var defineBuiltIns = __webpack_require__("../../node_modules/core-js/internals/define-built-ins.js");
var setToStringTag = __webpack_require__("../../node_modules/core-js/internals/set-to-string-tag.js");
var createIteratorConstructor = __webpack_require__("../../node_modules/core-js/internals/iterator-create-constructor.js");
var InternalStateModule = __webpack_require__("../../node_modules/core-js/internals/internal-state.js");
var anInstance = __webpack_require__("../../node_modules/core-js/internals/an-instance.js");
var isCallable = __webpack_require__("../../node_modules/core-js/internals/is-callable.js");
var hasOwn = __webpack_require__("../../node_modules/core-js/internals/has-own-property.js");
var bind = __webpack_require__("../../node_modules/core-js/internals/function-bind-context.js");
var classof = __webpack_require__("../../node_modules/core-js/internals/classof.js");
var anObject = __webpack_require__("../../node_modules/core-js/internals/an-object.js");
var isObject = __webpack_require__("../../node_modules/core-js/internals/is-object.js");
var $toString = __webpack_require__("../../node_modules/core-js/internals/to-string.js");
var create = __webpack_require__("../../node_modules/core-js/internals/object-create.js");
var createPropertyDescriptor = __webpack_require__("../../node_modules/core-js/internals/create-property-descriptor.js");
var getIterator = __webpack_require__("../../node_modules/core-js/internals/get-iterator.js");
var getIteratorMethod = __webpack_require__("../../node_modules/core-js/internals/get-iterator-method.js");
var validateArgumentsLength = __webpack_require__("../../node_modules/core-js/internals/validate-arguments-length.js");
var wellKnownSymbol = __webpack_require__("../../node_modules/core-js/internals/well-known-symbol.js");
var arraySort = __webpack_require__("../../node_modules/core-js/internals/array-sort.js");

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw TypeError('Expected sequence with length 2');
        push(this.entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(this.entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState(this, new URLSearchParamsState(init));
  if (!DESCRIPTORS) this.length = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    if (!DESCRIPTORS) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    if (!DESCRIPTORS) this.length = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    if (!DESCRIPTORS) this.length = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ "../../node_modules/core-js/modules/web.url-search-params.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("../../node_modules/core-js/modules/web.url-search-params.constructor.js");


/***/ }),

/***/ "../../node_modules/create-ecdh/browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];
var elliptic = __webpack_require__("../../node_modules/elliptic/lib/elliptic.js")
var BN = __webpack_require__("../../node_modules/create-ecdh/node_modules/bn.js/lib/bn.js")

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}


/***/ }),

/***/ "../../node_modules/create-ecdh/node_modules/bn.js/lib/bn.js":
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ "../../node_modules/create-hash/browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var MD5 = __webpack_require__("../../node_modules/md5.js/index.js")
var RIPEMD160 = __webpack_require__("../../node_modules/ripemd160/index.js")
var sha = __webpack_require__("../../node_modules/sha.js/index.js")
var Base = __webpack_require__("../../node_modules/cipher-base/index.js")

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),

/***/ "../../node_modules/create-hash/md5.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var MD5 = __webpack_require__("../../node_modules/md5.js/index.js")

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),

/***/ "../../node_modules/create-hmac/browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var Legacy = __webpack_require__("../../node_modules/create-hmac/legacy.js")
var Base = __webpack_require__("../../node_modules/cipher-base/index.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var md5 = __webpack_require__("../../node_modules/create-hash/md5.js")
var RIPEMD160 = __webpack_require__("../../node_modules/ripemd160/index.js")

var sha = __webpack_require__("../../node_modules/sha.js/index.js")

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),

/***/ "../../node_modules/create-hmac/legacy.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var Base = __webpack_require__("../../node_modules/cipher-base/index.js")

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),

/***/ "../../node_modules/crypto-browserify/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__("../../node_modules/randombytes/browser.js")
exports.createHash = exports.Hash = __webpack_require__("../../node_modules/create-hash/browser.js")
exports.createHmac = exports.Hmac = __webpack_require__("../../node_modules/create-hmac/browser.js")

var algos = __webpack_require__("../../node_modules/browserify-sign/algos.js")
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__("../../node_modules/pbkdf2/browser.js")
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__("../../node_modules/browserify-cipher/browser.js")

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__("../../node_modules/diffie-hellman/browser.js")

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__("../../node_modules/browserify-sign/browser/index.js")

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__("../../node_modules/create-ecdh/browser.js")

var publicEncrypt = __webpack_require__("../../node_modules/public-encrypt/browser.js")

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__("../../node_modules/randomfill/browser.js")

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),

/***/ "../../node_modules/des.js/lib/des.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.utils = __webpack_require__("../../node_modules/des.js/lib/des/utils.js");
exports.Cipher = __webpack_require__("../../node_modules/des.js/lib/des/cipher.js");
exports.DES = __webpack_require__("../../node_modules/des.js/lib/des/des.js");
exports.CBC = __webpack_require__("../../node_modules/des.js/lib/des/cbc.js");
exports.EDE = __webpack_require__("../../node_modules/des.js/lib/des/ede.js");


/***/ }),

/***/ "../../node_modules/des.js/lib/des/cbc.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),

/***/ "../../node_modules/des.js/lib/des/cipher.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),

/***/ "../../node_modules/des.js/lib/des/des.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");

var utils = __webpack_require__("../../node_modules/des.js/lib/des/utils.js");
var Cipher = __webpack_require__("../../node_modules/des.js/lib/des/cipher.js");

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),

/***/ "../../node_modules/des.js/lib/des/ede.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");

var Cipher = __webpack_require__("../../node_modules/des.js/lib/des/cipher.js");
var DES = __webpack_require__("../../node_modules/des.js/lib/des/des.js");

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),

/***/ "../../node_modules/des.js/lib/des/utils.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),

/***/ "../../node_modules/diffie-hellman/browser.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];
var generatePrime = __webpack_require__("../../node_modules/diffie-hellman/lib/generatePrime.js")
var primes = __webpack_require__("../../node_modules/diffie-hellman/lib/primes.json")

var DH = __webpack_require__("../../node_modules/diffie-hellman/lib/dh.js")

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman


/***/ }),

/***/ "../../node_modules/diffie-hellman/lib/dh.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];
var BN = __webpack_require__("../../node_modules/diffie-hellman/node_modules/bn.js/lib/bn.js");
var MillerRabin = __webpack_require__("../../node_modules/miller-rabin/lib/mr.js");
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__("../../node_modules/diffie-hellman/lib/generatePrime.js");
var randomBytes = __webpack_require__("../../node_modules/randombytes/browser.js");
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}


/***/ }),

/***/ "../../node_modules/diffie-hellman/lib/generatePrime.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var randomBytes = __webpack_require__("../../node_modules/randombytes/browser.js");
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__("../../node_modules/diffie-hellman/node_modules/bn.js/lib/bn.js");
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__("../../node_modules/miller-rabin/lib/mr.js");
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),

/***/ "../../node_modules/diffie-hellman/node_modules/bn.js/lib/bn.js":
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var elliptic = exports;

elliptic.version = (__webpack_require__("../../node_modules/elliptic/package.json")/* .version */ .i8);
elliptic.utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");
elliptic.rand = __webpack_require__("../../node_modules/brorand/index.js");
elliptic.curve = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curve/index.js");
elliptic.curves = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curves.js");

// Protocols
elliptic.ec = __webpack_require__("../../node_modules/elliptic/lib/elliptic/ec/index.js");
elliptic.eddsa = __webpack_require__("../../node_modules/elliptic/lib/elliptic/eddsa/index.js");


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/curve/base.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__("../../node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/curve/edwards.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");
var BN = __webpack_require__("../../node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");
var Base = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curve/base.js");

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  var e;
  var h;
  var j;
  if (this.curve.twisted) {
    // E = a * C
    e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      h = this.z.redSqr();
      // J = F - 2 * H
      j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    e = c.redAdd(d);
    // H = (c * Z1)^2
    h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/curve/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var curve = exports;

curve.base = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curve/base.js");
curve.short = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curve/short.js");
curve.mont = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curve/mont.js");
curve.edwards = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curve/edwards.js");


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/curve/mont.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__("../../node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");
var Base = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curve/base.js");

var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/curve/short.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");
var BN = __webpack_require__("../../node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");
var Base = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curve/base.js");

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/curves.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var curves = exports;

var hash = __webpack_require__("../../node_modules/hash.js/lib/hash.js");
var curve = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curve/index.js");
var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = __webpack_require__("../../node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js");
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/ec/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__("../../node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var HmacDRBG = __webpack_require__("../../node_modules/hmac-drbg/lib/hmac-drbg.js");
var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");
var curves = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curves.js");
var rand = __webpack_require__("../../node_modules/brorand/index.js");
var assert = utils.assert;

var KeyPair = __webpack_require__("../../node_modules/elliptic/lib/elliptic/ec/key.js");
var Signature = __webpack_require__("../../node_modules/elliptic/lib/elliptic/ec/signature.js");

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(Object.prototype.hasOwnProperty.call(curves, options),
      'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  for (;;) {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/ec/key.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__("../../node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/ec/signature.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__("../../node_modules/elliptic/node_modules/bn.js/lib/bn.js");

var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/eddsa/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var hash = __webpack_require__("../../node_modules/hash.js/lib/hash.js");
var curves = __webpack_require__("../../node_modules/elliptic/lib/elliptic/curves.js");
var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__("../../node_modules/elliptic/lib/elliptic/eddsa/key.js");
var Signature = __webpack_require__("../../node_modules/elliptic/lib/elliptic/eddsa/signature.js");

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
    .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/eddsa/key.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/eddsa/signature.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var BN = __webpack_require__("../../node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var utils = __webpack_require__("../../node_modules/elliptic/lib/elliptic/utils.js");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength),
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/precomputed/secp256k1.js":
/***/ ((module) => {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
      ],
    ],
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
      ],
    ],
  },
};


/***/ }),

/***/ "../../node_modules/elliptic/lib/elliptic/utils.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var utils = exports;
var BN = __webpack_require__("../../node_modules/elliptic/node_modules/bn.js/lib/bn.js");
var minAssert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");
var minUtils = __webpack_require__("../../node_modules/minimalistic-crypto-utils/lib/utils.js");

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),

/***/ "../../node_modules/elliptic/node_modules/bn.js/lib/bn.js":
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ "../../node_modules/es5-ext/global.js":
/***/ ((module) => {

var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

module.exports = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Fallback to standard globalThis if available
	if (typeof globalThis === "object" && globalThis) return globalThis;

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of updates to Object.prototype being restricted
		// via preventExtensions, seal or freeze
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ works, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();


/***/ }),

/***/ "../../node_modules/ethers/lib.esm/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  BaseContract: () => (/* reexport */ lib_esm.BaseContract),
  BigNumber: () => (/* reexport */ bignumber/* BigNumber */.O$),
  Contract: () => (/* reexport */ lib_esm.Contract),
  ContractFactory: () => (/* reexport */ lib_esm.ContractFactory),
  FixedNumber: () => (/* reexport */ fixednumber/* FixedNumber */.xs),
  Signer: () => (/* reexport */ abstract_signer_lib_esm/* Signer */.E),
  VoidSigner: () => (/* reexport */ abstract_signer_lib_esm/* VoidSigner */.b),
  Wallet: () => (/* reexport */ wallet_lib_esm.Wallet),
  Wordlist: () => (/* reexport */ browser_wordlists.Wordlist),
  constants: () => (/* reexport */ constants_lib_esm),
  errors: () => (/* reexport */ logger_lib_esm.ErrorCode),
  ethers: () => (/* reexport */ ethers_namespaceObject),
  getDefaultProvider: () => (/* reexport */ providers_lib_esm.getDefaultProvider),
  logger: () => (/* reexport */ logger),
  providers: () => (/* reexport */ providers_lib_esm),
  utils: () => (/* reexport */ utils_namespaceObject),
  version: () => (/* reexport */ version),
  wordlists: () => (/* reexport */ browser_wordlists/* wordlists */.E)
});

// NAMESPACE OBJECT: ../../node_modules/ethers/lib.esm/utils.js
var utils_namespaceObject = {};
__webpack_require__.r(utils_namespaceObject);
__webpack_require__.d(utils_namespaceObject, {
  AbiCoder: () => (abi_coder/* AbiCoder */.R),
  ConstructorFragment: () => (fragments/* ConstructorFragment */.Xg),
  ErrorFragment: () => (fragments/* ErrorFragment */.IC),
  EventFragment: () => (fragments/* EventFragment */.QV),
  FormatTypes: () => (fragments/* FormatTypes */.pc),
  Fragment: () => (fragments/* Fragment */.HY),
  FunctionFragment: () => (fragments/* FunctionFragment */.YW),
  HDNode: () => (hdnode_lib_esm.HDNode),
  Indexed: () => (lib_esm_interface/* Indexed */.Hk),
  Interface: () => (lib_esm_interface/* Interface */.vU),
  LogDescription: () => (lib_esm_interface/* LogDescription */.CC),
  Logger: () => (logger_lib_esm.Logger),
  ParamType: () => (fragments/* ParamType */._R),
  RLP: () => (rlp_lib_esm),
  SigningKey: () => (signing_key_lib_esm.SigningKey),
  SupportedAlgorithm: () => (types/* SupportedAlgorithm */.p),
  TransactionDescription: () => (lib_esm_interface/* TransactionDescription */.vk),
  TransactionTypes: () => (transactions_lib_esm.TransactionTypes),
  UnicodeNormalizationForm: () => (utf8/* UnicodeNormalizationForm */.Uj),
  Utf8ErrorFuncs: () => (utf8/* Utf8ErrorFuncs */.te),
  Utf8ErrorReason: () => (utf8/* Utf8ErrorReason */.Uw),
  _TypedDataEncoder: () => (typed_data/* TypedDataEncoder */.E),
  _fetchData: () => (web_lib_esm._fetchData),
  _toEscapedUtf8String: () => (utf8/* _toEscapedUtf8String */.U$),
  accessListify: () => (transactions_lib_esm.accessListify),
  arrayify: () => (bytes_lib_esm.arrayify),
  base58: () => (basex_lib_esm.Base58),
  base64: () => (base64_lib_esm),
  checkProperties: () => (properties_lib_esm.checkProperties),
  checkResultErrors: () => (abstract_coder/* checkResultErrors */.BR),
  commify: () => (units_lib_esm.commify),
  computeAddress: () => (transactions_lib_esm.computeAddress),
  computeHmac: () => (sha2/* computeHmac */.Gy),
  computePublicKey: () => (signing_key_lib_esm.computePublicKey),
  concat: () => (bytes_lib_esm.concat),
  deepCopy: () => (properties_lib_esm.deepCopy),
  defaultAbiCoder: () => (abi_coder/* defaultAbiCoder */.$),
  defaultPath: () => (hdnode_lib_esm.defaultPath),
  defineReadOnly: () => (properties_lib_esm.defineReadOnly),
  dnsEncode: () => (namehash/* dnsEncode */.Kn),
  entropyToMnemonic: () => (hdnode_lib_esm.entropyToMnemonic),
  fetchJson: () => (web_lib_esm.fetchJson),
  formatBytes32String: () => (bytes32/* formatBytes32String */.s),
  formatEther: () => (units_lib_esm.formatEther),
  formatUnits: () => (units_lib_esm.formatUnits),
  getAccountPath: () => (hdnode_lib_esm.getAccountPath),
  getAddress: () => (address_lib_esm.getAddress),
  getContractAddress: () => (address_lib_esm.getContractAddress),
  getCreate2Address: () => (address_lib_esm.getCreate2Address),
  getIcapAddress: () => (address_lib_esm.getIcapAddress),
  getJsonWalletAddress: () => (inspect/* getJsonWalletAddress */.Rb),
  getStatic: () => (properties_lib_esm.getStatic),
  hashMessage: () => (message/* hashMessage */.r),
  hexConcat: () => (bytes_lib_esm.hexConcat),
  hexDataLength: () => (bytes_lib_esm.hexDataLength),
  hexDataSlice: () => (bytes_lib_esm.hexDataSlice),
  hexStripZeros: () => (bytes_lib_esm.hexStripZeros),
  hexValue: () => (bytes_lib_esm.hexValue),
  hexZeroPad: () => (bytes_lib_esm.hexZeroPad),
  hexlify: () => (bytes_lib_esm.hexlify),
  id: () => (id.id),
  isAddress: () => (address_lib_esm.isAddress),
  isBytes: () => (bytes_lib_esm.isBytes),
  isBytesLike: () => (bytes_lib_esm.isBytesLike),
  isHexString: () => (bytes_lib_esm.isHexString),
  isValidMnemonic: () => (hdnode_lib_esm.isValidMnemonic),
  isValidName: () => (namehash/* isValidName */.r1),
  joinSignature: () => (bytes_lib_esm.joinSignature),
  keccak256: () => (keccak256_lib_esm.keccak256),
  mnemonicToEntropy: () => (hdnode_lib_esm.mnemonicToEntropy),
  mnemonicToSeed: () => (hdnode_lib_esm.mnemonicToSeed),
  namehash: () => (namehash/* namehash */.VM),
  nameprep: () => (idna/* nameprep */.Ll),
  parseBytes32String: () => (bytes32/* parseBytes32String */.F),
  parseEther: () => (units_lib_esm.parseEther),
  parseTransaction: () => (transactions_lib_esm.parse),
  parseUnits: () => (units_lib_esm.parseUnits),
  poll: () => (web_lib_esm.poll),
  randomBytes: () => (random/* randomBytes */.O),
  recoverAddress: () => (transactions_lib_esm.recoverAddress),
  recoverPublicKey: () => (signing_key_lib_esm.recoverPublicKey),
  resolveProperties: () => (properties_lib_esm.resolveProperties),
  ripemd160: () => (sha2/* ripemd160 */.bP),
  serializeTransaction: () => (transactions_lib_esm.serialize),
  sha256: () => (sha2/* sha256 */.JQ),
  sha512: () => (sha2/* sha512 */.o),
  shallowCopy: () => (properties_lib_esm.shallowCopy),
  shuffled: () => (shuffle/* shuffled */.y),
  solidityKeccak256: () => (solidity_lib_esm.keccak256),
  solidityPack: () => (solidity_lib_esm.pack),
  soliditySha256: () => (solidity_lib_esm.sha256),
  splitSignature: () => (bytes_lib_esm.splitSignature),
  stripZeros: () => (bytes_lib_esm.stripZeros),
  toUtf8Bytes: () => (utf8/* toUtf8Bytes */.Y0),
  toUtf8CodePoints: () => (utf8/* toUtf8CodePoints */.XL),
  toUtf8String: () => (utf8/* toUtf8String */.ZN),
  verifyMessage: () => (wallet_lib_esm.verifyMessage),
  verifyTypedData: () => (wallet_lib_esm.verifyTypedData),
  zeroPad: () => (bytes_lib_esm.zeroPad)
});

// NAMESPACE OBJECT: ../../node_modules/ethers/lib.esm/ethers.js
var ethers_namespaceObject = {};
__webpack_require__.r(ethers_namespaceObject);
__webpack_require__.d(ethers_namespaceObject, {
  BaseContract: () => (lib_esm.BaseContract),
  BigNumber: () => (bignumber/* BigNumber */.O$),
  Contract: () => (lib_esm.Contract),
  ContractFactory: () => (lib_esm.ContractFactory),
  FixedNumber: () => (fixednumber/* FixedNumber */.xs),
  Signer: () => (abstract_signer_lib_esm/* Signer */.E),
  VoidSigner: () => (abstract_signer_lib_esm/* VoidSigner */.b),
  Wallet: () => (wallet_lib_esm.Wallet),
  Wordlist: () => (browser_wordlists.Wordlist),
  constants: () => (constants_lib_esm),
  errors: () => (logger_lib_esm.ErrorCode),
  getDefaultProvider: () => (providers_lib_esm.getDefaultProvider),
  logger: () => (logger),
  providers: () => (providers_lib_esm),
  utils: () => (utils_namespaceObject),
  version: () => (version),
  wordlists: () => (browser_wordlists/* wordlists */.E)
});

// EXTERNAL MODULE: ../../node_modules/@ethersproject/contracts/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__("../../node_modules/@ethersproject/contracts/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js
var fixednumber = __webpack_require__("../../node_modules/@ethersproject/bignumber/lib.esm/fixednumber.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abstract-signer/lib.esm/index.js + 1 modules
var abstract_signer_lib_esm = __webpack_require__("../../node_modules/@ethersproject/abstract-signer/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/wallet/lib.esm/index.js + 1 modules
var wallet_lib_esm = __webpack_require__("../../node_modules/@ethersproject/wallet/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/constants/lib.esm/index.js + 1 modules
var constants_lib_esm = __webpack_require__("../../node_modules/@ethersproject/constants/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/providers/lib.esm/index.js + 20 modules
var providers_lib_esm = __webpack_require__("../../node_modules/@ethersproject/providers/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/wordlists/lib/browser-wordlists.js
var browser_wordlists = __webpack_require__("../../node_modules/@ethersproject/wordlists/lib/browser-wordlists.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abi/lib.esm/abi-coder.js + 10 modules
var abi_coder = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/abi-coder.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abi/lib.esm/fragments.js
var fragments = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/fragments.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abi/lib.esm/coders/abstract-coder.js
var abstract_coder = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/coders/abstract-coder.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/abi/lib.esm/interface.js
var lib_esm_interface = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/interface.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/address/lib.esm/index.js + 1 modules
var address_lib_esm = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/base64/lib.esm/index.js
var base64_lib_esm = __webpack_require__("../../node_modules/@ethersproject/base64/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/basex/lib.esm/index.js
var basex_lib_esm = __webpack_require__("../../node_modules/@ethersproject/basex/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bytes/lib.esm/index.js + 1 modules
var bytes_lib_esm = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hash/lib.esm/namehash.js + 3 modules
var namehash = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/namehash.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hash/lib.esm/message.js
var message = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/message.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hash/lib.esm/id.js
var id = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/id.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hash/lib.esm/typed-data.js
var typed_data = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/typed-data.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/hdnode/lib.esm/index.js + 1 modules
var hdnode_lib_esm = __webpack_require__("../../node_modules/@ethersproject/hdnode/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/json-wallets/lib.esm/inspect.js
var inspect = __webpack_require__("../../node_modules/@ethersproject/json-wallets/lib.esm/inspect.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/keccak256/lib.esm/index.js
var keccak256_lib_esm = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/logger/lib.esm/index.js + 1 modules
var logger_lib_esm = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/sha2/lib.esm/sha2.js + 1 modules
var sha2 = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/sha2.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/solidity/lib.esm/index.js + 1 modules
var solidity_lib_esm = __webpack_require__("../../node_modules/@ethersproject/solidity/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/random/lib.esm/random.js + 1 modules
var random = __webpack_require__("../../node_modules/@ethersproject/random/lib.esm/random.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/random/lib.esm/shuffle.js
var shuffle = __webpack_require__("../../node_modules/@ethersproject/random/lib.esm/shuffle.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/properties/lib.esm/index.js + 1 modules
var properties_lib_esm = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/rlp/lib.esm/index.js + 1 modules
var rlp_lib_esm = __webpack_require__("../../node_modules/@ethersproject/rlp/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/signing-key/lib.esm/index.js + 2 modules
var signing_key_lib_esm = __webpack_require__("../../node_modules/@ethersproject/signing-key/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/strings/lib.esm/idna.js
var idna = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/idna.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/strings/lib.esm/utf8.js + 1 modules
var utf8 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/utf8.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/strings/lib.esm/bytes32.js
var bytes32 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/bytes32.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/transactions/lib.esm/index.js + 1 modules
var transactions_lib_esm = __webpack_require__("../../node_modules/@ethersproject/transactions/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var units_lib_esm = __webpack_require__("../../node_modules/@ethersproject/units/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/web/lib.esm/index.js + 2 modules
var web_lib_esm = __webpack_require__("../../node_modules/@ethersproject/web/lib.esm/index.js");
// EXTERNAL MODULE: ../../node_modules/@ethersproject/sha2/lib.esm/types.js
var types = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/types.js");
;// CONCATENATED MODULE: ../../node_modules/ethers/lib.esm/utils.js






















////////////////////////
// Enums


////////////////////////
// Exports

//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ../../node_modules/ethers/lib.esm/_version.js
const version = "ethers/5.7.2";
//# sourceMappingURL=_version.js.map
;// CONCATENATED MODULE: ../../node_modules/ethers/lib.esm/ethers.js











////////////////////////
// Compile-Time Constants
// This is generated by "npm run dist"

const logger = new logger_lib_esm.Logger(version);
////////////////////////
// Exports

//# sourceMappingURL=ethers.js.map
;// CONCATENATED MODULE: ../../node_modules/ethers/lib.esm/index.js

// To modify this file, you must update ./misc/admin/lib/cmds/update-exports.js

try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) {
        anyGlobal._ethers = ethers_namespaceObject;
    }
}
catch (error) { }


//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/ethers/lib/utils.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatBytes32String = exports.Utf8ErrorFuncs = exports.toUtf8String = exports.toUtf8CodePoints = exports.toUtf8Bytes = exports._toEscapedUtf8String = exports.nameprep = exports.hexDataSlice = exports.hexDataLength = exports.hexZeroPad = exports.hexValue = exports.hexStripZeros = exports.hexConcat = exports.isHexString = exports.hexlify = exports.base64 = exports.base58 = exports.TransactionDescription = exports.LogDescription = exports.Interface = exports.SigningKey = exports.HDNode = exports.defaultPath = exports.isBytesLike = exports.isBytes = exports.zeroPad = exports.stripZeros = exports.concat = exports.arrayify = exports.shallowCopy = exports.resolveProperties = exports.getStatic = exports.defineReadOnly = exports.deepCopy = exports.checkProperties = exports.poll = exports.fetchJson = exports._fetchData = exports.RLP = exports.Logger = exports.checkResultErrors = exports.FormatTypes = exports.ParamType = exports.FunctionFragment = exports.EventFragment = exports.ErrorFragment = exports.ConstructorFragment = exports.Fragment = exports.defaultAbiCoder = exports.AbiCoder = void 0;
exports.Indexed = exports.Utf8ErrorReason = exports.UnicodeNormalizationForm = exports.SupportedAlgorithm = exports.mnemonicToSeed = exports.isValidMnemonic = exports.entropyToMnemonic = exports.mnemonicToEntropy = exports.getAccountPath = exports.verifyTypedData = exports.verifyMessage = exports.recoverPublicKey = exports.computePublicKey = exports.recoverAddress = exports.computeAddress = exports.getJsonWalletAddress = exports.TransactionTypes = exports.serializeTransaction = exports.parseTransaction = exports.accessListify = exports.joinSignature = exports.splitSignature = exports.soliditySha256 = exports.solidityKeccak256 = exports.solidityPack = exports.shuffled = exports.randomBytes = exports.sha512 = exports.sha256 = exports.ripemd160 = exports.keccak256 = exports.computeHmac = exports.commify = exports.parseUnits = exports.formatUnits = exports.parseEther = exports.formatEther = exports.isAddress = exports.getCreate2Address = exports.getContractAddress = exports.getIcapAddress = exports.getAddress = exports._TypedDataEncoder = exports.id = exports.isValidName = exports.namehash = exports.hashMessage = exports.dnsEncode = exports.parseBytes32String = void 0;
var abi_1 = __webpack_require__("../../node_modules/@ethersproject/abi/lib.esm/index.js");
Object.defineProperty(exports, "AbiCoder", ({ enumerable: true, get: function () { return abi_1.AbiCoder; } }));
Object.defineProperty(exports, "checkResultErrors", ({ enumerable: true, get: function () { return abi_1.checkResultErrors; } }));
Object.defineProperty(exports, "ConstructorFragment", ({ enumerable: true, get: function () { return abi_1.ConstructorFragment; } }));
Object.defineProperty(exports, "defaultAbiCoder", ({ enumerable: true, get: function () { return abi_1.defaultAbiCoder; } }));
Object.defineProperty(exports, "ErrorFragment", ({ enumerable: true, get: function () { return abi_1.ErrorFragment; } }));
Object.defineProperty(exports, "EventFragment", ({ enumerable: true, get: function () { return abi_1.EventFragment; } }));
Object.defineProperty(exports, "FormatTypes", ({ enumerable: true, get: function () { return abi_1.FormatTypes; } }));
Object.defineProperty(exports, "Fragment", ({ enumerable: true, get: function () { return abi_1.Fragment; } }));
Object.defineProperty(exports, "FunctionFragment", ({ enumerable: true, get: function () { return abi_1.FunctionFragment; } }));
Object.defineProperty(exports, "Indexed", ({ enumerable: true, get: function () { return abi_1.Indexed; } }));
Object.defineProperty(exports, "Interface", ({ enumerable: true, get: function () { return abi_1.Interface; } }));
Object.defineProperty(exports, "LogDescription", ({ enumerable: true, get: function () { return abi_1.LogDescription; } }));
Object.defineProperty(exports, "ParamType", ({ enumerable: true, get: function () { return abi_1.ParamType; } }));
Object.defineProperty(exports, "TransactionDescription", ({ enumerable: true, get: function () { return abi_1.TransactionDescription; } }));
var address_1 = __webpack_require__("../../node_modules/@ethersproject/address/lib.esm/index.js");
Object.defineProperty(exports, "getAddress", ({ enumerable: true, get: function () { return address_1.getAddress; } }));
Object.defineProperty(exports, "getCreate2Address", ({ enumerable: true, get: function () { return address_1.getCreate2Address; } }));
Object.defineProperty(exports, "getContractAddress", ({ enumerable: true, get: function () { return address_1.getContractAddress; } }));
Object.defineProperty(exports, "getIcapAddress", ({ enumerable: true, get: function () { return address_1.getIcapAddress; } }));
Object.defineProperty(exports, "isAddress", ({ enumerable: true, get: function () { return address_1.isAddress; } }));
var base64 = __importStar(__webpack_require__("../../node_modules/@ethersproject/base64/lib.esm/index.js"));
exports.base64 = base64;
var basex_1 = __webpack_require__("../../node_modules/@ethersproject/basex/lib.esm/index.js");
Object.defineProperty(exports, "base58", ({ enumerable: true, get: function () { return basex_1.Base58; } }));
var bytes_1 = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
Object.defineProperty(exports, "arrayify", ({ enumerable: true, get: function () { return bytes_1.arrayify; } }));
Object.defineProperty(exports, "concat", ({ enumerable: true, get: function () { return bytes_1.concat; } }));
Object.defineProperty(exports, "hexConcat", ({ enumerable: true, get: function () { return bytes_1.hexConcat; } }));
Object.defineProperty(exports, "hexDataSlice", ({ enumerable: true, get: function () { return bytes_1.hexDataSlice; } }));
Object.defineProperty(exports, "hexDataLength", ({ enumerable: true, get: function () { return bytes_1.hexDataLength; } }));
Object.defineProperty(exports, "hexlify", ({ enumerable: true, get: function () { return bytes_1.hexlify; } }));
Object.defineProperty(exports, "hexStripZeros", ({ enumerable: true, get: function () { return bytes_1.hexStripZeros; } }));
Object.defineProperty(exports, "hexValue", ({ enumerable: true, get: function () { return bytes_1.hexValue; } }));
Object.defineProperty(exports, "hexZeroPad", ({ enumerable: true, get: function () { return bytes_1.hexZeroPad; } }));
Object.defineProperty(exports, "isBytes", ({ enumerable: true, get: function () { return bytes_1.isBytes; } }));
Object.defineProperty(exports, "isBytesLike", ({ enumerable: true, get: function () { return bytes_1.isBytesLike; } }));
Object.defineProperty(exports, "isHexString", ({ enumerable: true, get: function () { return bytes_1.isHexString; } }));
Object.defineProperty(exports, "joinSignature", ({ enumerable: true, get: function () { return bytes_1.joinSignature; } }));
Object.defineProperty(exports, "zeroPad", ({ enumerable: true, get: function () { return bytes_1.zeroPad; } }));
Object.defineProperty(exports, "splitSignature", ({ enumerable: true, get: function () { return bytes_1.splitSignature; } }));
Object.defineProperty(exports, "stripZeros", ({ enumerable: true, get: function () { return bytes_1.stripZeros; } }));
var hash_1 = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/index.js");
Object.defineProperty(exports, "_TypedDataEncoder", ({ enumerable: true, get: function () { return hash_1._TypedDataEncoder; } }));
Object.defineProperty(exports, "dnsEncode", ({ enumerable: true, get: function () { return hash_1.dnsEncode; } }));
Object.defineProperty(exports, "hashMessage", ({ enumerable: true, get: function () { return hash_1.hashMessage; } }));
Object.defineProperty(exports, "id", ({ enumerable: true, get: function () { return hash_1.id; } }));
Object.defineProperty(exports, "isValidName", ({ enumerable: true, get: function () { return hash_1.isValidName; } }));
Object.defineProperty(exports, "namehash", ({ enumerable: true, get: function () { return hash_1.namehash; } }));
var hdnode_1 = __webpack_require__("../../node_modules/@ethersproject/hdnode/lib.esm/index.js");
Object.defineProperty(exports, "defaultPath", ({ enumerable: true, get: function () { return hdnode_1.defaultPath; } }));
Object.defineProperty(exports, "entropyToMnemonic", ({ enumerable: true, get: function () { return hdnode_1.entropyToMnemonic; } }));
Object.defineProperty(exports, "getAccountPath", ({ enumerable: true, get: function () { return hdnode_1.getAccountPath; } }));
Object.defineProperty(exports, "HDNode", ({ enumerable: true, get: function () { return hdnode_1.HDNode; } }));
Object.defineProperty(exports, "isValidMnemonic", ({ enumerable: true, get: function () { return hdnode_1.isValidMnemonic; } }));
Object.defineProperty(exports, "mnemonicToEntropy", ({ enumerable: true, get: function () { return hdnode_1.mnemonicToEntropy; } }));
Object.defineProperty(exports, "mnemonicToSeed", ({ enumerable: true, get: function () { return hdnode_1.mnemonicToSeed; } }));
var json_wallets_1 = __webpack_require__("../../node_modules/@ethersproject/json-wallets/lib.esm/index.js");
Object.defineProperty(exports, "getJsonWalletAddress", ({ enumerable: true, get: function () { return json_wallets_1.getJsonWalletAddress; } }));
var keccak256_1 = __webpack_require__("../../node_modules/@ethersproject/keccak256/lib.esm/index.js");
Object.defineProperty(exports, "keccak256", ({ enumerable: true, get: function () { return keccak256_1.keccak256; } }));
var logger_1 = __webpack_require__("../../node_modules/@ethersproject/logger/lib.esm/index.js");
Object.defineProperty(exports, "Logger", ({ enumerable: true, get: function () { return logger_1.Logger; } }));
var sha2_1 = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/index.js");
Object.defineProperty(exports, "computeHmac", ({ enumerable: true, get: function () { return sha2_1.computeHmac; } }));
Object.defineProperty(exports, "ripemd160", ({ enumerable: true, get: function () { return sha2_1.ripemd160; } }));
Object.defineProperty(exports, "sha256", ({ enumerable: true, get: function () { return sha2_1.sha256; } }));
Object.defineProperty(exports, "sha512", ({ enumerable: true, get: function () { return sha2_1.sha512; } }));
var solidity_1 = __webpack_require__("../../node_modules/@ethersproject/solidity/lib.esm/index.js");
Object.defineProperty(exports, "solidityKeccak256", ({ enumerable: true, get: function () { return solidity_1.keccak256; } }));
Object.defineProperty(exports, "solidityPack", ({ enumerable: true, get: function () { return solidity_1.pack; } }));
Object.defineProperty(exports, "soliditySha256", ({ enumerable: true, get: function () { return solidity_1.sha256; } }));
var random_1 = __webpack_require__("../../node_modules/@ethersproject/random/lib.esm/index.js");
Object.defineProperty(exports, "randomBytes", ({ enumerable: true, get: function () { return random_1.randomBytes; } }));
Object.defineProperty(exports, "shuffled", ({ enumerable: true, get: function () { return random_1.shuffled; } }));
var properties_1 = __webpack_require__("../../node_modules/@ethersproject/properties/lib.esm/index.js");
Object.defineProperty(exports, "checkProperties", ({ enumerable: true, get: function () { return properties_1.checkProperties; } }));
Object.defineProperty(exports, "deepCopy", ({ enumerable: true, get: function () { return properties_1.deepCopy; } }));
Object.defineProperty(exports, "defineReadOnly", ({ enumerable: true, get: function () { return properties_1.defineReadOnly; } }));
Object.defineProperty(exports, "getStatic", ({ enumerable: true, get: function () { return properties_1.getStatic; } }));
Object.defineProperty(exports, "resolveProperties", ({ enumerable: true, get: function () { return properties_1.resolveProperties; } }));
Object.defineProperty(exports, "shallowCopy", ({ enumerable: true, get: function () { return properties_1.shallowCopy; } }));
var RLP = __importStar(__webpack_require__("../../node_modules/@ethersproject/rlp/lib.esm/index.js"));
exports.RLP = RLP;
var signing_key_1 = __webpack_require__("../../node_modules/@ethersproject/signing-key/lib.esm/index.js");
Object.defineProperty(exports, "computePublicKey", ({ enumerable: true, get: function () { return signing_key_1.computePublicKey; } }));
Object.defineProperty(exports, "recoverPublicKey", ({ enumerable: true, get: function () { return signing_key_1.recoverPublicKey; } }));
Object.defineProperty(exports, "SigningKey", ({ enumerable: true, get: function () { return signing_key_1.SigningKey; } }));
var strings_1 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/index.js");
Object.defineProperty(exports, "formatBytes32String", ({ enumerable: true, get: function () { return strings_1.formatBytes32String; } }));
Object.defineProperty(exports, "nameprep", ({ enumerable: true, get: function () { return strings_1.nameprep; } }));
Object.defineProperty(exports, "parseBytes32String", ({ enumerable: true, get: function () { return strings_1.parseBytes32String; } }));
Object.defineProperty(exports, "_toEscapedUtf8String", ({ enumerable: true, get: function () { return strings_1._toEscapedUtf8String; } }));
Object.defineProperty(exports, "toUtf8Bytes", ({ enumerable: true, get: function () { return strings_1.toUtf8Bytes; } }));
Object.defineProperty(exports, "toUtf8CodePoints", ({ enumerable: true, get: function () { return strings_1.toUtf8CodePoints; } }));
Object.defineProperty(exports, "toUtf8String", ({ enumerable: true, get: function () { return strings_1.toUtf8String; } }));
Object.defineProperty(exports, "Utf8ErrorFuncs", ({ enumerable: true, get: function () { return strings_1.Utf8ErrorFuncs; } }));
var transactions_1 = __webpack_require__("../../node_modules/@ethersproject/transactions/lib.esm/index.js");
Object.defineProperty(exports, "accessListify", ({ enumerable: true, get: function () { return transactions_1.accessListify; } }));
Object.defineProperty(exports, "computeAddress", ({ enumerable: true, get: function () { return transactions_1.computeAddress; } }));
Object.defineProperty(exports, "parseTransaction", ({ enumerable: true, get: function () { return transactions_1.parse; } }));
Object.defineProperty(exports, "recoverAddress", ({ enumerable: true, get: function () { return transactions_1.recoverAddress; } }));
Object.defineProperty(exports, "serializeTransaction", ({ enumerable: true, get: function () { return transactions_1.serialize; } }));
Object.defineProperty(exports, "TransactionTypes", ({ enumerable: true, get: function () { return transactions_1.TransactionTypes; } }));
var units_1 = __webpack_require__("../../node_modules/@ethersproject/units/lib.esm/index.js");
Object.defineProperty(exports, "commify", ({ enumerable: true, get: function () { return units_1.commify; } }));
Object.defineProperty(exports, "formatEther", ({ enumerable: true, get: function () { return units_1.formatEther; } }));
Object.defineProperty(exports, "parseEther", ({ enumerable: true, get: function () { return units_1.parseEther; } }));
Object.defineProperty(exports, "formatUnits", ({ enumerable: true, get: function () { return units_1.formatUnits; } }));
Object.defineProperty(exports, "parseUnits", ({ enumerable: true, get: function () { return units_1.parseUnits; } }));
var wallet_1 = __webpack_require__("../../node_modules/@ethersproject/wallet/lib.esm/index.js");
Object.defineProperty(exports, "verifyMessage", ({ enumerable: true, get: function () { return wallet_1.verifyMessage; } }));
Object.defineProperty(exports, "verifyTypedData", ({ enumerable: true, get: function () { return wallet_1.verifyTypedData; } }));
var web_1 = __webpack_require__("../../node_modules/@ethersproject/web/lib.esm/index.js");
Object.defineProperty(exports, "_fetchData", ({ enumerable: true, get: function () { return web_1._fetchData; } }));
Object.defineProperty(exports, "fetchJson", ({ enumerable: true, get: function () { return web_1.fetchJson; } }));
Object.defineProperty(exports, "poll", ({ enumerable: true, get: function () { return web_1.poll; } }));
////////////////////////
// Enums
var sha2_2 = __webpack_require__("../../node_modules/@ethersproject/sha2/lib.esm/index.js");
Object.defineProperty(exports, "SupportedAlgorithm", ({ enumerable: true, get: function () { return sha2_2.SupportedAlgorithm; } }));
var strings_2 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/index.js");
Object.defineProperty(exports, "UnicodeNormalizationForm", ({ enumerable: true, get: function () { return strings_2.UnicodeNormalizationForm; } }));
Object.defineProperty(exports, "Utf8ErrorReason", ({ enumerable: true, get: function () { return strings_2.Utf8ErrorReason; } }));
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "../../node_modules/eventemitter3/index.js":
/***/ ((module) => {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ "../../node_modules/events/events.js":
/***/ ((module) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ "../../node_modules/evp_bytestokey/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var MD5 = __webpack_require__("../../node_modules/md5.js/index.js")

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),

/***/ "../../node_modules/fast-deep-equal/index.js":
/***/ ((module) => {

"use strict";


// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ "../../node_modules/for-each/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var isCallable = __webpack_require__("../../node_modules/is-callable/index.js");

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;


/***/ }),

/***/ "../../node_modules/function-bind/implementation.js":
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ "../../node_modules/function-bind/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__("../../node_modules/function-bind/implementation.js");

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ "../../node_modules/get-intrinsic/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__("../../node_modules/has-symbols/index.js")();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

try {
	null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
	// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
	var errorProto = getProto(getProto(e));
	INTRINSICS['%Error.prototype%'] = errorProto;
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__("../../node_modules/function-bind/index.js");
var hasOwn = __webpack_require__("../../node_modules/has/src/index.js");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ "../../node_modules/gopd/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__("../../node_modules/get-intrinsic/index.js");

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ "../../node_modules/has-symbols/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__("../../node_modules/has-symbols/shams.js");

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ "../../node_modules/has-symbols/shams.js":
/***/ ((module) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ "../../node_modules/has-tostringtag/shams.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var hasSymbols = __webpack_require__("../../node_modules/has-symbols/shams.js");

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),

/***/ "../../node_modules/has/src/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__("../../node_modules/function-bind/index.js");

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ "../../node_modules/hash-base/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var Buffer = (__webpack_require__("../../node_modules/hash-base/node_modules/safe-buffer/index.js").Buffer)
var Transform = (__webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/readable-browser.js").Transform)
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/errors-browser.js":
/***/ ((module) => {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.q = codes;


/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_readable.js");
var Writable = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_writable.js");
__webpack_require__("../../node_modules/inherits/inherits_browser.js")(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_passthrough.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_transform.js");
__webpack_require__("../../node_modules/inherits/inherits_browser.js")(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_readable.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = (__webpack_require__("../../node_modules/events/events.js").EventEmitter);
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

var Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__("?4a48");
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/buffer_list.js");
var destroyImpl = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/destroy.js");
var _require = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/state.js"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/errors-browser.js")/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__("../../node_modules/inherits/inherits_browser.js")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = (__webpack_require__("../../node_modules/string_decoder/lib/string_decoder.js").StringDecoder);
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = (__webpack_require__("../../node_modules/string_decoder/lib/string_decoder.js").StringDecoder);
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/async_iterator.js");
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/from-browser.js");
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_transform.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = (__webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/errors-browser.js")/* .codes */ .q),
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");
__webpack_require__("../../node_modules/inherits/inherits_browser.js")(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_writable.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("../../node_modules/util-deprecate/browser.js")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/stream-browser.js");
/*</replacement>*/

var Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
var OurUint8Array = (typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/destroy.js");
var _require = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/state.js"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = (__webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/errors-browser.js")/* .codes */ .q),
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__("../../node_modules/inherits/inherits_browser.js")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/async_iterator.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");


var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/buffer_list.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__("../../node_modules/buffer/index.js"),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__("?d5c0"),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/destroy.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");


// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/end-of-stream.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = (__webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/errors-browser.js")/* .codes.ERR_STREAM_PREMATURE_CLOSE */ .q.ERR_STREAM_PREMATURE_CLOSE);
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/from-browser.js":
/***/ ((module) => {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/pipeline.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = (__webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/errors-browser.js")/* .codes */ .q),
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/state.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var ERR_INVALID_OPT_VALUE = (__webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/errors-browser.js")/* .codes.ERR_INVALID_OPT_VALUE */ .q.ERR_INVALID_OPT_VALUE);
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/stream-browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__("../../node_modules/events/events.js").EventEmitter;


/***/ }),

/***/ "../../node_modules/hash-base/node_modules/readable-stream/readable-browser.js":
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_readable.js");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_writable.js");
exports.Duplex = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_duplex.js");
exports.Transform = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_transform.js");
exports.PassThrough = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/_stream_passthrough.js");
exports.finished = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/end-of-stream.js");
exports.pipeline = __webpack_require__("../../node_modules/hash-base/node_modules/readable-stream/lib/internal/streams/pipeline.js");


/***/ }),

/***/ "../../node_modules/hash-base/node_modules/safe-buffer/index.js":
/***/ ((module, exports, __webpack_require__) => {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("../../node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var hash = exports;

hash.utils = __webpack_require__("../../node_modules/hash.js/lib/hash/utils.js");
hash.common = __webpack_require__("../../node_modules/hash.js/lib/hash/common.js");
hash.sha = __webpack_require__("../../node_modules/hash.js/lib/hash/sha.js");
hash.ripemd = __webpack_require__("../../node_modules/hash.js/lib/hash/ripemd.js");
hash.hmac = __webpack_require__("../../node_modules/hash.js/lib/hash/hmac.js");

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/common.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/hash.js/lib/hash/utils.js");
var assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/hmac.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/hash.js/lib/hash/utils.js");
var assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/ripemd.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/hash.js/lib/hash/utils.js");
var common = __webpack_require__("../../node_modules/hash.js/lib/hash/common.js");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/sha.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


exports.sha1 = __webpack_require__("../../node_modules/hash.js/lib/hash/sha/1.js");
exports.sha224 = __webpack_require__("../../node_modules/hash.js/lib/hash/sha/224.js");
exports.sha256 = __webpack_require__("../../node_modules/hash.js/lib/hash/sha/256.js");
exports.sha384 = __webpack_require__("../../node_modules/hash.js/lib/hash/sha/384.js");
exports.sha512 = __webpack_require__("../../node_modules/hash.js/lib/hash/sha/512.js");


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/sha/1.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/hash.js/lib/hash/utils.js");
var common = __webpack_require__("../../node_modules/hash.js/lib/hash/common.js");
var shaCommon = __webpack_require__("../../node_modules/hash.js/lib/hash/sha/common.js");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/sha/224.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/hash.js/lib/hash/utils.js");
var SHA256 = __webpack_require__("../../node_modules/hash.js/lib/hash/sha/256.js");

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/sha/256.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/hash.js/lib/hash/utils.js");
var common = __webpack_require__("../../node_modules/hash.js/lib/hash/common.js");
var shaCommon = __webpack_require__("../../node_modules/hash.js/lib/hash/sha/common.js");
var assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/sha/384.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/hash.js/lib/hash/utils.js");

var SHA512 = __webpack_require__("../../node_modules/hash.js/lib/hash/sha/512.js");

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/sha/512.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/hash.js/lib/hash/utils.js");
var common = __webpack_require__("../../node_modules/hash.js/lib/hash/common.js");
var assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/sha/common.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__("../../node_modules/hash.js/lib/hash/utils.js");
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),

/***/ "../../node_modules/hash.js/lib/hash/utils.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),

/***/ "../../node_modules/heap/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__("../../node_modules/heap/lib/heap.js");


/***/ }),

/***/ "../../node_modules/heap/lib/heap.js":
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Generated by CoffeeScript 1.8.0
(function() {
  var Heap, defaultCmp, floor, heapify, heappop, heappush, heappushpop, heapreplace, insort, min, nlargest, nsmallest, updateItem, _siftdown, _siftup;

  floor = Math.floor, min = Math.min;


  /*
  Default comparison function to be used
   */

  defaultCmp = function(x, y) {
    if (x < y) {
      return -1;
    }
    if (x > y) {
      return 1;
    }
    return 0;
  };


  /*
  Insert item x in list a, and keep it sorted assuming a is sorted.
  
  If x is already in a, insert it to the right of the rightmost x.
  
  Optional args lo (default 0) and hi (default a.length) bound the slice
  of a to be searched.
   */

  insort = function(a, x, lo, hi, cmp) {
    var mid;
    if (lo == null) {
      lo = 0;
    }
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (lo < 0) {
      throw new Error('lo must be non-negative');
    }
    if (hi == null) {
      hi = a.length;
    }
    while (lo < hi) {
      mid = floor((lo + hi) / 2);
      if (cmp(x, a[mid]) < 0) {
        hi = mid;
      } else {
        lo = mid + 1;
      }
    }
    return ([].splice.apply(a, [lo, lo - lo].concat(x)), x);
  };


  /*
  Push item onto heap, maintaining the heap invariant.
   */

  heappush = function(array, item, cmp) {
    if (cmp == null) {
      cmp = defaultCmp;
    }
    array.push(item);
    return _siftdown(array, 0, array.length - 1, cmp);
  };


  /*
  Pop the smallest item off the heap, maintaining the heap invariant.
   */

  heappop = function(array, cmp) {
    var lastelt, returnitem;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    lastelt = array.pop();
    if (array.length) {
      returnitem = array[0];
      array[0] = lastelt;
      _siftup(array, 0, cmp);
    } else {
      returnitem = lastelt;
    }
    return returnitem;
  };


  /*
  Pop and return the current smallest value, and add the new item.
  
  This is more efficient than heappop() followed by heappush(), and can be
  more appropriate when using a fixed size heap. Note that the value
  returned may be larger than item! That constrains reasonable use of
  this routine unless written as part of a conditional replacement:
      if item > array[0]
        item = heapreplace(array, item)
   */

  heapreplace = function(array, item, cmp) {
    var returnitem;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    returnitem = array[0];
    array[0] = item;
    _siftup(array, 0, cmp);
    return returnitem;
  };


  /*
  Fast version of a heappush followed by a heappop.
   */

  heappushpop = function(array, item, cmp) {
    var _ref;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (array.length && cmp(array[0], item) < 0) {
      _ref = [array[0], item], item = _ref[0], array[0] = _ref[1];
      _siftup(array, 0, cmp);
    }
    return item;
  };


  /*
  Transform list into a heap, in-place, in O(array.length) time.
   */

  heapify = function(array, cmp) {
    var i, _i, _j, _len, _ref, _ref1, _results, _results1;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    _ref1 = (function() {
      _results1 = [];
      for (var _j = 0, _ref = floor(array.length / 2); 0 <= _ref ? _j < _ref : _j > _ref; 0 <= _ref ? _j++ : _j--){ _results1.push(_j); }
      return _results1;
    }).apply(this).reverse();
    _results = [];
    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
      i = _ref1[_i];
      _results.push(_siftup(array, i, cmp));
    }
    return _results;
  };


  /*
  Update the position of the given item in the heap.
  This function should be called every time the item is being modified.
   */

  updateItem = function(array, item, cmp) {
    var pos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    pos = array.indexOf(item);
    if (pos === -1) {
      return;
    }
    _siftdown(array, 0, pos, cmp);
    return _siftup(array, pos, cmp);
  };


  /*
  Find the n largest elements in a dataset.
   */

  nlargest = function(array, n, cmp) {
    var elem, result, _i, _len, _ref;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    result = array.slice(0, n);
    if (!result.length) {
      return result;
    }
    heapify(result, cmp);
    _ref = array.slice(n);
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      elem = _ref[_i];
      heappushpop(result, elem, cmp);
    }
    return result.sort(cmp).reverse();
  };


  /*
  Find the n smallest elements in a dataset.
   */

  nsmallest = function(array, n, cmp) {
    var elem, i, los, result, _i, _j, _len, _ref, _ref1, _results;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    if (n * 10 <= array.length) {
      result = array.slice(0, n).sort(cmp);
      if (!result.length) {
        return result;
      }
      los = result[result.length - 1];
      _ref = array.slice(n);
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elem = _ref[_i];
        if (cmp(elem, los) < 0) {
          insort(result, elem, 0, null, cmp);
          result.pop();
          los = result[result.length - 1];
        }
      }
      return result;
    }
    heapify(array, cmp);
    _results = [];
    for (i = _j = 0, _ref1 = min(n, array.length); 0 <= _ref1 ? _j < _ref1 : _j > _ref1; i = 0 <= _ref1 ? ++_j : --_j) {
      _results.push(heappop(array, cmp));
    }
    return _results;
  };

  _siftdown = function(array, startpos, pos, cmp) {
    var newitem, parent, parentpos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    newitem = array[pos];
    while (pos > startpos) {
      parentpos = (pos - 1) >> 1;
      parent = array[parentpos];
      if (cmp(newitem, parent) < 0) {
        array[pos] = parent;
        pos = parentpos;
        continue;
      }
      break;
    }
    return array[pos] = newitem;
  };

  _siftup = function(array, pos, cmp) {
    var childpos, endpos, newitem, rightpos, startpos;
    if (cmp == null) {
      cmp = defaultCmp;
    }
    endpos = array.length;
    startpos = pos;
    newitem = array[pos];
    childpos = 2 * pos + 1;
    while (childpos < endpos) {
      rightpos = childpos + 1;
      if (rightpos < endpos && !(cmp(array[childpos], array[rightpos]) < 0)) {
        childpos = rightpos;
      }
      array[pos] = array[childpos];
      pos = childpos;
      childpos = 2 * pos + 1;
    }
    array[pos] = newitem;
    return _siftdown(array, startpos, pos, cmp);
  };

  Heap = (function() {
    Heap.push = heappush;

    Heap.pop = heappop;

    Heap.replace = heapreplace;

    Heap.pushpop = heappushpop;

    Heap.heapify = heapify;

    Heap.updateItem = updateItem;

    Heap.nlargest = nlargest;

    Heap.nsmallest = nsmallest;

    function Heap(cmp) {
      this.cmp = cmp != null ? cmp : defaultCmp;
      this.nodes = [];
    }

    Heap.prototype.push = function(x) {
      return heappush(this.nodes, x, this.cmp);
    };

    Heap.prototype.pop = function() {
      return heappop(this.nodes, this.cmp);
    };

    Heap.prototype.peek = function() {
      return this.nodes[0];
    };

    Heap.prototype.contains = function(x) {
      return this.nodes.indexOf(x) !== -1;
    };

    Heap.prototype.replace = function(x) {
      return heapreplace(this.nodes, x, this.cmp);
    };

    Heap.prototype.pushpop = function(x) {
      return heappushpop(this.nodes, x, this.cmp);
    };

    Heap.prototype.heapify = function() {
      return heapify(this.nodes, this.cmp);
    };

    Heap.prototype.updateItem = function(x) {
      return updateItem(this.nodes, x, this.cmp);
    };

    Heap.prototype.clear = function() {
      return this.nodes = [];
    };

    Heap.prototype.empty = function() {
      return this.nodes.length === 0;
    };

    Heap.prototype.size = function() {
      return this.nodes.length;
    };

    Heap.prototype.clone = function() {
      var heap;
      heap = new Heap();
      heap.nodes = this.nodes.slice(0);
      return heap;
    };

    Heap.prototype.toArray = function() {
      return this.nodes.slice(0);
    };

    Heap.prototype.insert = Heap.prototype.push;

    Heap.prototype.top = Heap.prototype.peek;

    Heap.prototype.front = Heap.prototype.peek;

    Heap.prototype.has = Heap.prototype.contains;

    Heap.prototype.copy = Heap.prototype.clone;

    return Heap;

  })();

  (function(root, factory) {
    if (true) {
      return !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {}
  })(this, function() {
    return Heap;
  });

}).call(this);


/***/ }),

/***/ "../../node_modules/hmac-drbg/lib/hmac-drbg.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var hash = __webpack_require__("../../node_modules/hash.js/lib/hash.js");
var utils = __webpack_require__("../../node_modules/minimalistic-crypto-utils/lib/utils.js");
var assert = __webpack_require__("../../node_modules/minimalistic-assert/index.js");

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),

/***/ "../../node_modules/ieee754/index.js":
/***/ ((__unused_webpack_module, exports) => {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "../../node_modules/inherits/inherits_browser.js":
/***/ ((module) => {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ "../../node_modules/ipaddr.js/lib/ipaddr.js":
/***/ (function(module) {

(function (root) {
    'use strict';
    // A list of regular expressions that match arbitrary IPv4 addresses,
    // for which a number of weird notations exist.
    // Note that an address like 0010.0xa5.1.1 is considered legal.
    const ipv4Part = '(0?\\d+|0x[a-f0-9]+)';
    const ipv4Regexes = {
        fourOctet: new RegExp(`^${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}$`, 'i'),
        threeOctet: new RegExp(`^${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}$`, 'i'),
        twoOctet: new RegExp(`^${ipv4Part}\\.${ipv4Part}$`, 'i'),
        longValue: new RegExp(`^${ipv4Part}$`, 'i')
    };

    // Regular Expression for checking Octal numbers
    const octalRegex = new RegExp(`^0[0-7]+$`, 'i');
    const hexRegex = new RegExp(`^0x[a-f0-9]+$`, 'i');

    const zoneIndex = '%[0-9a-z]{1,}';

    // IPv6-matching regular expressions.
    // For IPv6, the task is simpler: it is enough to match the colon-delimited
    // hexadecimal IPv6 and a transitional variant with dotted-decimal IPv4 at
    // the end.
    const ipv6Part = '(?:[0-9a-f]+::?)+';
    const ipv6Regexes = {
        zoneIndex: new RegExp(zoneIndex, 'i'),
        'native': new RegExp(`^(::)?(${ipv6Part})?([0-9a-f]+)?(::)?(${zoneIndex})?$`, 'i'),
        deprecatedTransitional: new RegExp(`^(?:::)(${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}(${zoneIndex})?)$`, 'i'),
        transitional: new RegExp(`^((?:${ipv6Part})|(?:::)(?:${ipv6Part})?)${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}\\.${ipv4Part}(${zoneIndex})?$`, 'i')
    };

    // Expand :: in an IPv6 address or address part consisting of `parts` groups.
    function expandIPv6 (string, parts) {
        // More than one '::' means invalid adddress
        if (string.indexOf('::') !== string.lastIndexOf('::')) {
            return null;
        }

        let colonCount = 0;
        let lastColon = -1;
        let zoneId = (string.match(ipv6Regexes.zoneIndex) || [])[0];
        let replacement, replacementCount;

        // Remove zone index and save it for later
        if (zoneId) {
            zoneId = zoneId.substring(1);
            string = string.replace(/%.+$/, '');
        }

        // How many parts do we already have?
        while ((lastColon = string.indexOf(':', lastColon + 1)) >= 0) {
            colonCount++;
        }

        // 0::0 is two parts more than ::
        if (string.substr(0, 2) === '::') {
            colonCount--;
        }

        if (string.substr(-2, 2) === '::') {
            colonCount--;
        }

        // The following loop would hang if colonCount > parts
        if (colonCount > parts) {
            return null;
        }

        // replacement = ':' + '0:' * (parts - colonCount)
        replacementCount = parts - colonCount;
        replacement = ':';
        while (replacementCount--) {
            replacement += '0:';
        }

        // Insert the missing zeroes
        string = string.replace('::', replacement);

        // Trim any garbage which may be hanging around if :: was at the edge in
        // the source strin
        if (string[0] === ':') {
            string = string.slice(1);
        }

        if (string[string.length - 1] === ':') {
            string = string.slice(0, -1);
        }

        parts = (function () {
            const ref = string.split(':');
            const results = [];

            for (let i = 0; i < ref.length; i++) {
                results.push(parseInt(ref[i], 16));
            }

            return results;
        })();

        return {
            parts: parts,
            zoneId: zoneId
        };
    }

    // A generic CIDR (Classless Inter-Domain Routing) RFC1518 range matcher.
    function matchCIDR (first, second, partSize, cidrBits) {
        if (first.length !== second.length) {
            throw new Error('ipaddr: cannot match CIDR for objects with different lengths');
        }

        let part = 0;
        let shift;

        while (cidrBits > 0) {
            shift = partSize - cidrBits;
            if (shift < 0) {
                shift = 0;
            }

            if (first[part] >> shift !== second[part] >> shift) {
                return false;
            }

            cidrBits -= partSize;
            part += 1;
        }

        return true;
    }

    function parseIntAuto (string) {
        // Hexadedimal base 16 (0x#)
        if (hexRegex.test(string)) {
            return parseInt(string, 16);
        }
        // While octal representation is discouraged by ECMAScript 3
        // and forbidden by ECMAScript 5, we silently allow it to
        // work only if the rest of the string has numbers less than 8.
        if (string[0] === '0' && !isNaN(parseInt(string[1], 10))) {
        if (octalRegex.test(string)) {
            return parseInt(string, 8);
        }
            throw new Error(`ipaddr: cannot parse ${string} as octal`);
        }
        // Always include the base 10 radix!
        return parseInt(string, 10);
    }

    function padPart (part, length) {
        while (part.length < length) {
            part = `0${part}`;
        }

        return part;
    }

    const ipaddr = {};

    // An IPv4 address (RFC791).
    ipaddr.IPv4 = (function () {
        // Constructs a new IPv4 address from an array of four octets
        // in network order (MSB first)
        // Verifies the input.
        function IPv4 (octets) {
            if (octets.length !== 4) {
                throw new Error('ipaddr: ipv4 octet count should be 4');
            }

            let i, octet;

            for (i = 0; i < octets.length; i++) {
                octet = octets[i];
                if (!((0 <= octet && octet <= 255))) {
                    throw new Error('ipaddr: ipv4 octet should fit in 8 bits');
                }
            }

            this.octets = octets;
        }

        // Special IPv4 address ranges.
        // See also https://en.wikipedia.org/wiki/Reserved_IP_addresses
        IPv4.prototype.SpecialRanges = {
            unspecified: [[new IPv4([0, 0, 0, 0]), 8]],
            broadcast: [[new IPv4([255, 255, 255, 255]), 32]],
            // RFC3171
            multicast: [[new IPv4([224, 0, 0, 0]), 4]],
            // RFC3927
            linkLocal: [[new IPv4([169, 254, 0, 0]), 16]],
            // RFC5735
            loopback: [[new IPv4([127, 0, 0, 0]), 8]],
            // RFC6598
            carrierGradeNat: [[new IPv4([100, 64, 0, 0]), 10]],
            // RFC1918
            'private': [
                [new IPv4([10, 0, 0, 0]), 8],
                [new IPv4([172, 16, 0, 0]), 12],
                [new IPv4([192, 168, 0, 0]), 16]
            ],
            // Reserved and testing-only ranges; RFCs 5735, 5737, 2544, 1700
            reserved: [
                [new IPv4([192, 0, 0, 0]), 24],
                [new IPv4([192, 0, 2, 0]), 24],
                [new IPv4([192, 88, 99, 0]), 24],
                [new IPv4([198, 51, 100, 0]), 24],
                [new IPv4([203, 0, 113, 0]), 24],
                [new IPv4([240, 0, 0, 0]), 4]
            ]
        };

        // The 'kind' method exists on both IPv4 and IPv6 classes.
        IPv4.prototype.kind = function () {
            return 'ipv4';
        };

        // Checks if this address matches other one within given CIDR range.
        IPv4.prototype.match = function (other, cidrRange) {
            let ref;
            if (cidrRange === undefined) {
                ref = other;
                other = ref[0];
                cidrRange = ref[1];
            }

            if (other.kind() !== 'ipv4') {
                throw new Error('ipaddr: cannot match ipv4 address with non-ipv4 one');
            }

            return matchCIDR(this.octets, other.octets, 8, cidrRange);
        };

        // returns a number of leading ones in IPv4 address, making sure that
        // the rest is a solid sequence of 0's (valid netmask)
        // returns either the CIDR length or null if mask is not valid
        IPv4.prototype.prefixLengthFromSubnetMask = function () {
            let cidr = 0;
            // non-zero encountered stop scanning for zeroes
            let stop = false;
            // number of zeroes in octet
            const zerotable = {
                0: 8,
                128: 7,
                192: 6,
                224: 5,
                240: 4,
                248: 3,
                252: 2,
                254: 1,
                255: 0
            };
            let i, octet, zeros;

            for (i = 3; i >= 0; i -= 1) {
                octet = this.octets[i];
                if (octet in zerotable) {
                    zeros = zerotable[octet];
                    if (stop && zeros !== 0) {
                        return null;
                    }

                    if (zeros !== 8) {
                        stop = true;
                    }

                    cidr += zeros;
                } else {
                    return null;
                }
            }

            return 32 - cidr;
        };

        // Checks if the address corresponds to one of the special ranges.
        IPv4.prototype.range = function () {
            return ipaddr.subnetMatch(this, this.SpecialRanges);
        };

        // Returns an array of byte-sized values in network order (MSB first)
        IPv4.prototype.toByteArray = function () {
            return this.octets.slice(0);
        };

        // Converts this IPv4 address to an IPv4-mapped IPv6 address.
        IPv4.prototype.toIPv4MappedAddress = function () {
            return ipaddr.IPv6.parse(`::ffff:${this.toString()}`);
        };

        // Symmetrical method strictly for aligning with the IPv6 methods.
        IPv4.prototype.toNormalizedString = function () {
            return this.toString();
        };

        // Returns the address in convenient, decimal-dotted format.
        IPv4.prototype.toString = function () {
            return this.octets.join('.');
        };

        return IPv4;
    })();

    // A utility function to return broadcast address given the IPv4 interface and prefix length in CIDR notation
    ipaddr.IPv4.broadcastAddressFromCIDR = function (string) {

        try {
            const cidr = this.parseCIDR(string);
            const ipInterfaceOctets = cidr[0].toByteArray();
            const subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            const octets = [];
            let i = 0;
            while (i < 4) {
                // Broadcast address is bitwise OR between ip interface and inverted mask
                octets.push(parseInt(ipInterfaceOctets[i], 10) | parseInt(subnetMaskOctets[i], 10) ^ 255);
                i++;
            }

            return new this(octets);
        } catch (e) {
            throw new Error('ipaddr: the address does not have IPv4 CIDR format');
        }
    };

    // Checks if a given string is formatted like IPv4 address.
    ipaddr.IPv4.isIPv4 = function (string) {
        return this.parser(string) !== null;
    };

    // Checks if a given string is a valid IPv4 address.
    ipaddr.IPv4.isValid = function (string) {
        try {
            new this(this.parser(string));
            return true;
        } catch (e) {
            return false;
        }
    };

    // Checks if a given string is a full four-part IPv4 Address.
    ipaddr.IPv4.isValidFourPartDecimal = function (string) {
        if (ipaddr.IPv4.isValid(string) && string.match(/^(0|[1-9]\d*)(\.(0|[1-9]\d*)){3}$/)) {
            return true;
        } else {
            return false;
        }
    };

    // A utility function to return network address given the IPv4 interface and prefix length in CIDR notation
    ipaddr.IPv4.networkAddressFromCIDR = function (string) {
        let cidr, i, ipInterfaceOctets, octets, subnetMaskOctets;

        try {
            cidr = this.parseCIDR(string);
            ipInterfaceOctets = cidr[0].toByteArray();
            subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            octets = [];
            i = 0;
            while (i < 4) {
                // Network address is bitwise AND between ip interface and mask
                octets.push(parseInt(ipInterfaceOctets[i], 10) & parseInt(subnetMaskOctets[i], 10));
                i++;
            }

            return new this(octets);
        } catch (e) {
            throw new Error('ipaddr: the address does not have IPv4 CIDR format');
        }
    };

    // Tries to parse and validate a string with IPv4 address.
    // Throws an error if it fails.
    ipaddr.IPv4.parse = function (string) {
        const parts = this.parser(string);

        if (parts === null) {
            throw new Error('ipaddr: string is not formatted like an IPv4 Address');
        }

        return new this(parts);
    };

    // Parses the string as an IPv4 Address with CIDR Notation.
    ipaddr.IPv4.parseCIDR = function (string) {
        let match;

        if ((match = string.match(/^(.+)\/(\d+)$/))) {
            const maskLength = parseInt(match[2]);
            if (maskLength >= 0 && maskLength <= 32) {
                const parsed = [this.parse(match[1]), maskLength];
                Object.defineProperty(parsed, 'toString', {
                    value: function () {
                        return this.join('/');
                    }
                });
                return parsed;
            }
        }

        throw new Error('ipaddr: string is not formatted like an IPv4 CIDR range');
    };

    // Classful variants (like a.b, where a is an octet, and b is a 24-bit
    // value representing last three octets; this corresponds to a class C
    // address) are omitted due to classless nature of modern Internet.
    ipaddr.IPv4.parser = function (string) {
        let match, part, value;

        // parseInt recognizes all that octal & hexadecimal weirdness for us
        if ((match = string.match(ipv4Regexes.fourOctet))) {
            return (function () {
                const ref = match.slice(1, 6);
                const results = [];

                for (let i = 0; i < ref.length; i++) {
                    part = ref[i];
                    results.push(parseIntAuto(part));
                }

                return results;
            })();
        } else if ((match = string.match(ipv4Regexes.longValue))) {
            value = parseIntAuto(match[1]);
            if (value > 0xffffffff || value < 0) {
                throw new Error('ipaddr: address outside defined range');
            }

            return ((function () {
                const results = [];
                let shift;

                for (shift = 0; shift <= 24; shift += 8) {
                    results.push((value >> shift) & 0xff);
                }

                return results;
            })()).reverse();
        } else if ((match = string.match(ipv4Regexes.twoOctet))) {
            return (function () {
                const ref = match.slice(1, 4);
                const results = [];

                value = parseIntAuto(ref[1]);
                if (value > 0xffffff || value < 0) {
                    throw new Error('ipaddr: address outside defined range');
                }

                results.push(parseIntAuto(ref[0]));
                results.push((value >> 16) & 0xff);
                results.push((value >>  8) & 0xff);
                results.push( value        & 0xff);

                return results;
            })();
        } else if ((match = string.match(ipv4Regexes.threeOctet))) {
            return (function () {
                const ref = match.slice(1, 5);
                const results = [];

                value = parseIntAuto(ref[2]);
                if (value > 0xffff || value < 0) {
                    throw new Error('ipaddr: address outside defined range');
                }

                results.push(parseIntAuto(ref[0]));
                results.push(parseIntAuto(ref[1]));
                results.push((value >> 8) & 0xff);
                results.push( value       & 0xff);

                return results;
            })();
        } else {
            return null;
        }
    };

    // A utility function to return subnet mask in IPv4 format given the prefix length
    ipaddr.IPv4.subnetMaskFromPrefixLength = function (prefix) {
        prefix = parseInt(prefix);
        if (prefix < 0 || prefix > 32) {
            throw new Error('ipaddr: invalid IPv4 prefix length');
        }

        const octets = [0, 0, 0, 0];
        let j = 0;
        const filledOctetCount = Math.floor(prefix / 8);

        while (j < filledOctetCount) {
            octets[j] = 255;
            j++;
        }

        if (filledOctetCount < 4) {
            octets[filledOctetCount] = Math.pow(2, prefix % 8) - 1 << 8 - (prefix % 8);
        }

        return new this(octets);
    };

    // An IPv6 address (RFC2460)
    ipaddr.IPv6 = (function () {
        // Constructs an IPv6 address from an array of eight 16 - bit parts
        // or sixteen 8 - bit parts in network order(MSB first).
        // Throws an error if the input is invalid.
        function IPv6 (parts, zoneId) {
            let i, part;

            if (parts.length === 16) {
                this.parts = [];
                for (i = 0; i <= 14; i += 2) {
                    this.parts.push((parts[i] << 8) | parts[i + 1]);
                }
            } else if (parts.length === 8) {
                this.parts = parts;
            } else {
                throw new Error('ipaddr: ipv6 part count should be 8 or 16');
            }

            for (i = 0; i < this.parts.length; i++) {
                part = this.parts[i];
                if (!((0 <= part && part <= 0xffff))) {
                    throw new Error('ipaddr: ipv6 part should fit in 16 bits');
                }
            }

            if (zoneId) {
                this.zoneId = zoneId;
            }
        }

        // Special IPv6 ranges
        IPv6.prototype.SpecialRanges = {
            // RFC4291, here and after
            unspecified: [new IPv6([0, 0, 0, 0, 0, 0, 0, 0]), 128],
            linkLocal: [new IPv6([0xfe80, 0, 0, 0, 0, 0, 0, 0]), 10],
            multicast: [new IPv6([0xff00, 0, 0, 0, 0, 0, 0, 0]), 8],
            loopback: [new IPv6([0, 0, 0, 0, 0, 0, 0, 1]), 128],
            uniqueLocal: [new IPv6([0xfc00, 0, 0, 0, 0, 0, 0, 0]), 7],
            ipv4Mapped: [new IPv6([0, 0, 0, 0, 0, 0xffff, 0, 0]), 96],
            // RFC6145
            rfc6145: [new IPv6([0, 0, 0, 0, 0xffff, 0, 0, 0]), 96],
            // RFC6052
            rfc6052: [new IPv6([0x64, 0xff9b, 0, 0, 0, 0, 0, 0]), 96],
            // RFC3056
            '6to4': [new IPv6([0x2002, 0, 0, 0, 0, 0, 0, 0]), 16],
            // RFC6052, RFC6146
            teredo: [new IPv6([0x2001, 0, 0, 0, 0, 0, 0, 0]), 32],
            // RFC4291
            reserved: [[new IPv6([0x2001, 0xdb8, 0, 0, 0, 0, 0, 0]), 32]]
        };

        // Checks if this address is an IPv4-mapped IPv6 address.
        IPv6.prototype.isIPv4MappedAddress = function () {
            return this.range() === 'ipv4Mapped';
        };

        // The 'kind' method exists on both IPv4 and IPv6 classes.
        IPv6.prototype.kind = function () {
            return 'ipv6';
        };

        // Checks if this address matches other one within given CIDR range.
        IPv6.prototype.match = function (other, cidrRange) {
            let ref;

            if (cidrRange === undefined) {
                ref = other;
                other = ref[0];
                cidrRange = ref[1];
            }

            if (other.kind() !== 'ipv6') {
                throw new Error('ipaddr: cannot match ipv6 address with non-ipv6 one');
            }

            return matchCIDR(this.parts, other.parts, 16, cidrRange);
        };

        // returns a number of leading ones in IPv6 address, making sure that
        // the rest is a solid sequence of 0's (valid netmask)
        // returns either the CIDR length or null if mask is not valid
        IPv6.prototype.prefixLengthFromSubnetMask = function () {
            let cidr = 0;
            // non-zero encountered stop scanning for zeroes
            let stop = false;
            // number of zeroes in octet
            const zerotable = {
                0: 16,
                32768: 15,
                49152: 14,
                57344: 13,
                61440: 12,
                63488: 11,
                64512: 10,
                65024: 9,
                65280: 8,
                65408: 7,
                65472: 6,
                65504: 5,
                65520: 4,
                65528: 3,
                65532: 2,
                65534: 1,
                65535: 0
            };
            let part, zeros;

            for (let i = 7; i >= 0; i -= 1) {
                part = this.parts[i];
                if (part in zerotable) {
                    zeros = zerotable[part];
                    if (stop && zeros !== 0) {
                        return null;
                    }

                    if (zeros !== 16) {
                        stop = true;
                    }

                    cidr += zeros;
                } else {
                    return null;
                }
            }

            return 128 - cidr;
        };


        // Checks if the address corresponds to one of the special ranges.
        IPv6.prototype.range = function () {
            return ipaddr.subnetMatch(this, this.SpecialRanges);
        };

        // Returns an array of byte-sized values in network order (MSB first)
        IPv6.prototype.toByteArray = function () {
            let part;
            const bytes = [];
            const ref = this.parts;
            for (let i = 0; i < ref.length; i++) {
                part = ref[i];
                bytes.push(part >> 8);
                bytes.push(part & 0xff);
            }

            return bytes;
        };

        // Returns the address in expanded format with all zeroes included, like
        // 2001:0db8:0008:0066:0000:0000:0000:0001
        IPv6.prototype.toFixedLengthString = function () {
            const addr = ((function () {
                const results = [];
                for (let i = 0; i < this.parts.length; i++) {
                    results.push(padPart(this.parts[i].toString(16), 4));
                }

                return results;
            }).call(this)).join(':');

            let suffix = '';

            if (this.zoneId) {
                suffix = `%${this.zoneId}`;
            }

            return addr + suffix;
        };

        // Converts this address to IPv4 address if it is an IPv4-mapped IPv6 address.
        // Throws an error otherwise.
        IPv6.prototype.toIPv4Address = function () {
            if (!this.isIPv4MappedAddress()) {
                throw new Error('ipaddr: trying to convert a generic ipv6 address to ipv4');
            }

            const ref = this.parts.slice(-2);
            const high = ref[0];
            const low = ref[1];

            return new ipaddr.IPv4([high >> 8, high & 0xff, low >> 8, low & 0xff]);
        };

        // Returns the address in expanded format with all zeroes included, like
        // 2001:db8:8:66:0:0:0:1
        //
        // Deprecated: use toFixedLengthString() instead.
        IPv6.prototype.toNormalizedString = function () {
            const addr = ((function () {
                const results = [];

                for (let i = 0; i < this.parts.length; i++) {
                    results.push(this.parts[i].toString(16));
                }

                return results;
            }).call(this)).join(':');

            let suffix = '';

            if (this.zoneId) {
                suffix = `%${this.zoneId}`;
            }

            return addr + suffix;
        };

        // Returns the address in compact, human-readable format like
        // 2001:db8:8:66::1
        // in line with RFC 5952 (see https://tools.ietf.org/html/rfc5952#section-4)
        IPv6.prototype.toRFC5952String = function () {
            const regex = /((^|:)(0(:|$)){2,})/g;
            const string = this.toNormalizedString();
            let bestMatchIndex = 0;
            let bestMatchLength = -1;
            let match;

            while ((match = regex.exec(string))) {
                if (match[0].length > bestMatchLength) {
                    bestMatchIndex = match.index;
                    bestMatchLength = match[0].length;
                }
            }

            if (bestMatchLength < 0) {
                return string;
            }

            return `${string.substring(0, bestMatchIndex)}::${string.substring(bestMatchIndex + bestMatchLength)}`;
        };

        // Returns the address in compact, human-readable format like
        // 2001:db8:8:66::1
        //
        // Deprecated: use toRFC5952String() instead.
        IPv6.prototype.toString = function () {
            // Replace the first sequence of 1 or more '0' parts with '::'
            return this.toNormalizedString().replace(/((^|:)(0(:|$))+)/, '::');
        };

        return IPv6;

    })();

    // A utility function to return broadcast address given the IPv6 interface and prefix length in CIDR notation
    ipaddr.IPv6.broadcastAddressFromCIDR = function (string) {
        try {
            const cidr = this.parseCIDR(string);
            const ipInterfaceOctets = cidr[0].toByteArray();
            const subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            const octets = [];
            let i = 0;
            while (i < 16) {
                // Broadcast address is bitwise OR between ip interface and inverted mask
                octets.push(parseInt(ipInterfaceOctets[i], 10) | parseInt(subnetMaskOctets[i], 10) ^ 255);
                i++;
            }

            return new this(octets);
        } catch (e) {
            throw new Error(`ipaddr: the address does not have IPv6 CIDR format (${e})`);
        }
    };

    // Checks if a given string is formatted like IPv6 address.
    ipaddr.IPv6.isIPv6 = function (string) {
        return this.parser(string) !== null;
    };

    // Checks to see if string is a valid IPv6 Address
    ipaddr.IPv6.isValid = function (string) {

        // Since IPv6.isValid is always called first, this shortcut
        // provides a substantial performance gain.
        if (typeof string === 'string' && string.indexOf(':') === -1) {
            return false;
        }

        try {
            const addr = this.parser(string);
            new this(addr.parts, addr.zoneId);
            return true;
        } catch (e) {
            return false;
        }
    };

    // A utility function to return network address given the IPv6 interface and prefix length in CIDR notation
    ipaddr.IPv6.networkAddressFromCIDR = function (string) {
        let cidr, i, ipInterfaceOctets, octets, subnetMaskOctets;

        try {
            cidr = this.parseCIDR(string);
            ipInterfaceOctets = cidr[0].toByteArray();
            subnetMaskOctets = this.subnetMaskFromPrefixLength(cidr[1]).toByteArray();
            octets = [];
            i = 0;
            while (i < 16) {
                // Network address is bitwise AND between ip interface and mask
                octets.push(parseInt(ipInterfaceOctets[i], 10) & parseInt(subnetMaskOctets[i], 10));
                i++;
            }

            return new this(octets);
        } catch (e) {
            throw new Error(`ipaddr: the address does not have IPv6 CIDR format (${e})`);
        }
    };

    // Tries to parse and validate a string with IPv6 address.
    // Throws an error if it fails.
    ipaddr.IPv6.parse = function (string) {
        const addr = this.parser(string);

        if (addr.parts === null) {
            throw new Error('ipaddr: string is not formatted like an IPv6 Address');
        }

        return new this(addr.parts, addr.zoneId);
    };

    ipaddr.IPv6.parseCIDR = function (string) {
        let maskLength, match, parsed;

        if ((match = string.match(/^(.+)\/(\d+)$/))) {
            maskLength = parseInt(match[2]);
            if (maskLength >= 0 && maskLength <= 128) {
                parsed = [this.parse(match[1]), maskLength];
                Object.defineProperty(parsed, 'toString', {
                    value: function () {
                        return this.join('/');
                    }
                });
                return parsed;
            }
        }

        throw new Error('ipaddr: string is not formatted like an IPv6 CIDR range');
    };

    // Parse an IPv6 address.
    ipaddr.IPv6.parser = function (string) {
        let addr, i, match, octet, octets, zoneId;

        if ((match = string.match(ipv6Regexes.deprecatedTransitional))) {
            return this.parser(`::ffff:${match[1]}`);
        }
        if (ipv6Regexes.native.test(string)) {
            return expandIPv6(string, 8);
        }
        if ((match = string.match(ipv6Regexes.transitional))) {
            zoneId = match[6] || '';
            addr = expandIPv6(match[1].slice(0, -1) + zoneId, 6);
            if (addr.parts) {
                octets = [
                    parseInt(match[2]),
                    parseInt(match[3]),
                    parseInt(match[4]),
                    parseInt(match[5])
                ];
                for (i = 0; i < octets.length; i++) {
                    octet = octets[i];
                    if (!((0 <= octet && octet <= 255))) {
                        return null;
                    }
                }

                addr.parts.push(octets[0] << 8 | octets[1]);
                addr.parts.push(octets[2] << 8 | octets[3]);
                return {
                    parts: addr.parts,
                    zoneId: addr.zoneId
                };
            }
        }

        return null;
    };

    // A utility function to return subnet mask in IPv6 format given the prefix length
    ipaddr.IPv6.subnetMaskFromPrefixLength = function (prefix) {
        prefix = parseInt(prefix);
        if (prefix < 0 || prefix > 128) {
            throw new Error('ipaddr: invalid IPv6 prefix length');
        }

        const octets = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        let j = 0;
        const filledOctetCount = Math.floor(prefix / 8);

        while (j < filledOctetCount) {
            octets[j] = 255;
            j++;
        }

        if (filledOctetCount < 16) {
            octets[filledOctetCount] = Math.pow(2, prefix % 8) - 1 << 8 - (prefix % 8);
        }

        return new this(octets);
    };

    // Try to parse an array in network order (MSB first) for IPv4 and IPv6
    ipaddr.fromByteArray = function (bytes) {
        const length = bytes.length;

        if (length === 4) {
            return new ipaddr.IPv4(bytes);
        } else if (length === 16) {
            return new ipaddr.IPv6(bytes);
        } else {
            throw new Error('ipaddr: the binary input is neither an IPv6 nor IPv4 address');
        }
    };

    // Checks if the address is valid IP address
    ipaddr.isValid = function (string) {
        return ipaddr.IPv6.isValid(string) || ipaddr.IPv4.isValid(string);
    };


    // Attempts to parse an IP Address, first through IPv6 then IPv4.
    // Throws an error if it could not be parsed.
    ipaddr.parse = function (string) {
        if (ipaddr.IPv6.isValid(string)) {
            return ipaddr.IPv6.parse(string);
        } else if (ipaddr.IPv4.isValid(string)) {
            return ipaddr.IPv4.parse(string);
        } else {
            throw new Error('ipaddr: the address has neither IPv6 nor IPv4 format');
        }
    };

    // Attempt to parse CIDR notation, first through IPv6 then IPv4.
    // Throws an error if it could not be parsed.
    ipaddr.parseCIDR = function (string) {
        try {
            return ipaddr.IPv6.parseCIDR(string);
        } catch (e) {
            try {
                return ipaddr.IPv4.parseCIDR(string);
            } catch (e2) {
                throw new Error('ipaddr: the address has neither IPv6 nor IPv4 CIDR format');
            }
        }
    };

    // Parse an address and return plain IPv4 address if it is an IPv4-mapped address
    ipaddr.process = function (string) {
        const addr = this.parse(string);

        if (addr.kind() === 'ipv6' && addr.isIPv4MappedAddress()) {
            return addr.toIPv4Address();
        } else {
            return addr;
        }
    };

    // An utility function to ease named range matching. See examples below.
    // rangeList can contain both IPv4 and IPv6 subnet entries and will not throw errors
    // on matching IPv4 addresses to IPv6 ranges or vice versa.
    ipaddr.subnetMatch = function (address, rangeList, defaultName) {
        let i, rangeName, rangeSubnets, subnet;

        if (defaultName === undefined || defaultName === null) {
            defaultName = 'unicast';
        }

        for (rangeName in rangeList) {
            if (Object.prototype.hasOwnProperty.call(rangeList, rangeName)) {
                rangeSubnets = rangeList[rangeName];
                // ECMA5 Array.isArray isn't available everywhere
                if (rangeSubnets[0] && !(rangeSubnets[0] instanceof Array)) {
                    rangeSubnets = [rangeSubnets];
                }

                for (i = 0; i < rangeSubnets.length; i++) {
                    subnet = rangeSubnets[i];
                    if (address.kind() === subnet[0].kind() && address.match.apply(address, subnet)) {
                        return rangeName;
                    }
                }
            }
        }

        return defaultName;
    };

    // Export for both the CommonJS and browser-like environment
    if ( true && module.exports) {
        module.exports = ipaddr;

    } else {
        root.ipaddr = ipaddr;
    }

}(this));


/***/ }),

/***/ "../../node_modules/is-arguments/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var hasToStringTag = __webpack_require__("../../node_modules/has-tostringtag/shams.js")();
var callBound = __webpack_require__("../../node_modules/call-bind/callBound.js");

var $toString = callBound('Object.prototype.toString');

var isStandardArguments = function isArguments(value) {
	if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
		return false;
	}
	return $toString(value) === '[object Arguments]';
};

var isLegacyArguments = function isArguments(value) {
	if (isStandardArguments(value)) {
		return true;
	}
	return value !== null &&
		typeof value === 'object' &&
		typeof value.length === 'number' &&
		value.length >= 0 &&
		$toString(value) !== '[object Array]' &&
		$toString(value.callee) === '[object Function]';
};

var supportsStandardArguments = (function () {
	return isStandardArguments(arguments);
}());

isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests

module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),

/***/ "../../node_modules/is-callable/index.js":
/***/ ((module) => {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var objectClass = '[object Object]';
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var ddaClass = '[object HTMLAllCollection]'; // IE 11
var ddaClass2 = '[object HTML document.all class]';
var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`

var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing

var isDDA = function isDocumentDotAll() { return false; };
if (typeof document === 'object') {
	// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
	var all = document.all;
	if (toStr.call(all) === toStr.call(document.all)) {
		isDDA = function isDocumentDotAll(value) {
			/* globals document: false */
			// in IE 6-8, typeof document.all is "object" and it's truthy
			if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
				try {
					var str = toStr.call(value);
					return (
						str === ddaClass
						|| str === ddaClass2
						|| str === ddaClass3 // opera 12.16
						|| str === objectClass // IE 6-8
					) && value('') == null; // eslint-disable-line eqeqeq
				} catch (e) { /**/ }
			}
			return false;
		};
	}
}

module.exports = reflectApply
	? function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value) && tryFunctionObject(value);
	}
	: function isCallable(value) {
		if (isDDA(value)) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
		return tryFunctionObject(value);
	};


/***/ }),

/***/ "../../node_modules/is-generator-function/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var toStr = Object.prototype.toString;
var fnToStr = Function.prototype.toString;
var isFnRegex = /^\s*(?:function)?\*/;
var hasToStringTag = __webpack_require__("../../node_modules/has-tostringtag/shams.js")();
var getProto = Object.getPrototypeOf;
var getGeneratorFunc = function () { // eslint-disable-line consistent-return
	if (!hasToStringTag) {
		return false;
	}
	try {
		return Function('return function*() {}')();
	} catch (e) {
	}
};
var GeneratorFunction;

module.exports = function isGeneratorFunction(fn) {
	if (typeof fn !== 'function') {
		return false;
	}
	if (isFnRegex.test(fnToStr.call(fn))) {
		return true;
	}
	if (!hasToStringTag) {
		var str = toStr.call(fn);
		return str === '[object GeneratorFunction]';
	}
	if (!getProto) {
		return false;
	}
	if (typeof GeneratorFunction === 'undefined') {
		var generatorFunc = getGeneratorFunc();
		GeneratorFunction = generatorFunc ? getProto(generatorFunc) : false;
	}
	return getProto(fn) === GeneratorFunction;
};


/***/ }),

/***/ "../../node_modules/is-typed-array/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var forEach = __webpack_require__("../../node_modules/for-each/index.js");
var availableTypedArrays = __webpack_require__("../../node_modules/available-typed-arrays/index.js");
var callBound = __webpack_require__("../../node_modules/call-bind/callBound.js");

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__("../../node_modules/has-tostringtag/shams.js")();
var gOPD = __webpack_require__("../../node_modules/gopd/index.js");

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
	for (var i = 0; i < array.length; i += 1) {
		if (array[i] === value) {
			return i;
		}
	}
	return -1;
};
var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		var arr = new g[typedArray]();
		if (Symbol.toStringTag in arr) {
			var proto = getPrototypeOf(arr);
			var descriptor = gOPD(proto, Symbol.toStringTag);
			if (!descriptor) {
				var superProto = getPrototypeOf(proto);
				descriptor = gOPD(superProto, Symbol.toStringTag);
			}
			toStrTags[typedArray] = descriptor.get;
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var anyTrue = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!anyTrue) {
			try {
				anyTrue = getter.call(value) === typedArray;
			} catch (e) { /**/ }
		}
	});
	return anyTrue;
};

module.exports = function isTypedArray(value) {
	if (!value || typeof value !== 'object') { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) {
		var tag = $slice($toString(value), 8, -1);
		return $indexOf(typedArrays, tag) > -1;
	}
	if (!gOPD) { return false; }
	return tryTypedArrays(value);
};


/***/ }),

/***/ "../../node_modules/js-sha3/src/sha3.js":
/***/ ((module, exports, __webpack_require__) => {

/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */
/*jslint bitwise: true */
(function () {
  'use strict';

  var INPUT_ERROR = 'input is invalid type';
  var FINALIZE_ERROR = 'finalize already called';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_SHA3_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = __webpack_require__.g;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && "object" === 'object' && module.exports;
  var AMD =  true && __webpack_require__.amdO;
  var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var SHAKE_PADDING = [31, 7936, 2031616, 520093696];
  var CSHAKE_PADDING = [4, 1024, 262144, 67108864];
  var KECCAK_PADDING = [1, 256, 65536, 16777216];
  var PADDING = [6, 1536, 393216, 100663296];
  var SHIFT = [0, 8, 16, 24];
  var RC = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649,
    0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0,
    2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771,
    2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648,
    2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648];
  var BITS = [224, 256, 384, 512];
  var SHAKE_BITS = [128, 256];
  var OUTPUT_TYPES = ['hex', 'buffer', 'arrayBuffer', 'array', 'digest'];
  var CSHAKE_BYTEPAD = {
    '128': 168,
    '256': 136
  };

  if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  var createOutputMethod = function (bits, padding, outputType) {
    return function (message) {
      return new Keccak(bits, padding, bits).update(message)[outputType]();
    };
  };

  var createShakeOutputMethod = function (bits, padding, outputType) {
    return function (message, outputBits) {
      return new Keccak(bits, padding, outputBits).update(message)[outputType]();
    };
  };

  var createCshakeOutputMethod = function (bits, padding, outputType) {
    return function (message, outputBits, n, s) {
      return methods['cshake' + bits].update(message, outputBits, n, s)[outputType]();
    };
  };

  var createKmacOutputMethod = function (bits, padding, outputType) {
    return function (key, message, outputBits, s) {
      return methods['kmac' + bits].update(key, message, outputBits, s)[outputType]();
    };
  };

  var createOutputMethods = function (method, createMethod, bits, padding) {
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createMethod(bits, padding, type);
    }
    return method;
  };

  var createMethod = function (bits, padding) {
    var method = createOutputMethod(bits, padding, 'hex');
    method.create = function () {
      return new Keccak(bits, padding, bits);
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    return createOutputMethods(method, createOutputMethod, bits, padding);
  };

  var createShakeMethod = function (bits, padding) {
    var method = createShakeOutputMethod(bits, padding, 'hex');
    method.create = function (outputBits) {
      return new Keccak(bits, padding, outputBits);
    };
    method.update = function (message, outputBits) {
      return method.create(outputBits).update(message);
    };
    return createOutputMethods(method, createShakeOutputMethod, bits, padding);
  };

  var createCshakeMethod = function (bits, padding) {
    var w = CSHAKE_BYTEPAD[bits];
    var method = createCshakeOutputMethod(bits, padding, 'hex');
    method.create = function (outputBits, n, s) {
      if (!n && !s) {
        return methods['shake' + bits].create(outputBits);
      } else {
        return new Keccak(bits, padding, outputBits).bytepad([n, s], w);
      }
    };
    method.update = function (message, outputBits, n, s) {
      return method.create(outputBits, n, s).update(message);
    };
    return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
  };

  var createKmacMethod = function (bits, padding) {
    var w = CSHAKE_BYTEPAD[bits];
    var method = createKmacOutputMethod(bits, padding, 'hex');
    method.create = function (key, outputBits, s) {
      return new Kmac(bits, padding, outputBits).bytepad(['KMAC', s], w).bytepad([key], w);
    };
    method.update = function (key, message, outputBits, s) {
      return method.create(key, outputBits, s).update(message);
    };
    return createOutputMethods(method, createKmacOutputMethod, bits, padding);
  };

  var algorithms = [
    { name: 'keccak', padding: KECCAK_PADDING, bits: BITS, createMethod: createMethod },
    { name: 'sha3', padding: PADDING, bits: BITS, createMethod: createMethod },
    { name: 'shake', padding: SHAKE_PADDING, bits: SHAKE_BITS, createMethod: createShakeMethod },
    { name: 'cshake', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createCshakeMethod },
    { name: 'kmac', padding: CSHAKE_PADDING, bits: SHAKE_BITS, createMethod: createKmacMethod }
  ];

  var methods = {}, methodNames = [];

  for (var i = 0; i < algorithms.length; ++i) {
    var algorithm = algorithms[i];
    var bits = algorithm.bits;
    for (var j = 0; j < bits.length; ++j) {
      var methodName = algorithm.name + '_' + bits[j];
      methodNames.push(methodName);
      methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
      if (algorithm.name !== 'sha3') {
        var newMethodName = algorithm.name + bits[j];
        methodNames.push(newMethodName);
        methods[newMethodName] = methods[methodName];
      }
    }
  }

  function Keccak(bits, padding, outputBits) {
    this.blocks = [];
    this.s = [];
    this.padding = padding;
    this.outputBits = outputBits;
    this.reset = true;
    this.finalized = false;
    this.block = 0;
    this.start = 0;
    this.blockCount = (1600 - (bits << 1)) >> 5;
    this.byteCount = this.blockCount << 2;
    this.outputBlocks = outputBits >> 5;
    this.extraBytes = (outputBits & 31) >> 3;

    for (var i = 0; i < 50; ++i) {
      this.s[i] = 0;
    }
  }

  Keccak.prototype.update = function (message) {
    if (this.finalized) {
      throw new Error(FINALIZE_ERROR);
    }
    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw new Error(INPUT_ERROR);
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw new Error(INPUT_ERROR);
          }
        }
      } else {
        throw new Error(INPUT_ERROR);
      }
      notString = true;
    }
    var blocks = this.blocks, byteCount = this.byteCount, length = message.length,
      blockCount = this.blockCount, index = 0, s = this.s, i, code;

    while (index < length) {
      if (this.reset) {
        this.reset = false;
        blocks[0] = this.block;
        for (i = 1; i < blockCount + 1; ++i) {
          blocks[i] = 0;
        }
      }
      if (notString) {
        for (i = this.start; index < length && i < byteCount; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < byteCount; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }
      this.lastByteIndex = i;
      if (i >= byteCount) {
        this.start = i - byteCount;
        this.block = blocks[blockCount];
        for (i = 0; i < blockCount; ++i) {
          s[i] ^= blocks[i];
        }
        f(s);
        this.reset = true;
      } else {
        this.start = i;
      }
    }
    return this;
  };

  Keccak.prototype.encode = function (x, right) {
    var o = x & 255, n = 1;
    var bytes = [o];
    x = x >> 8;
    o = x & 255;
    while (o > 0) {
      bytes.unshift(o);
      x = x >> 8;
      o = x & 255;
      ++n;
    }
    if (right) {
      bytes.push(n);
    } else {
      bytes.unshift(n);
    }
    this.update(bytes);
    return bytes.length;
  };

  Keccak.prototype.encodeString = function (str) {
    var notString, type = typeof str;
    if (type !== 'string') {
      if (type === 'object') {
        if (str === null) {
          throw new Error(INPUT_ERROR);
        } else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) {
          str = new Uint8Array(str);
        } else if (!Array.isArray(str)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) {
            throw new Error(INPUT_ERROR);
          }
        }
      } else {
        throw new Error(INPUT_ERROR);
      }
      notString = true;
    }
    var bytes = 0, length = str.length;
    if (notString) {
      bytes = length;
    } else {
      for (var i = 0; i < str.length; ++i) {
        var code = str.charCodeAt(i);
        if (code < 0x80) {
          bytes += 1;
        } else if (code < 0x800) {
          bytes += 2;
        } else if (code < 0xd800 || code >= 0xe000) {
          bytes += 3;
        } else {
          code = 0x10000 + (((code & 0x3ff) << 10) | (str.charCodeAt(++i) & 0x3ff));
          bytes += 4;
        }
      }
    }
    bytes += this.encode(bytes * 8);
    this.update(str);
    return bytes;
  };

  Keccak.prototype.bytepad = function (strs, w) {
    var bytes = this.encode(w);
    for (var i = 0; i < strs.length; ++i) {
      bytes += this.encodeString(strs[i]);
    }
    var paddingBytes = w - bytes % w;
    var zeros = [];
    zeros.length = paddingBytes;
    this.update(zeros);
    return this;
  };

  Keccak.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
    blocks[i >> 2] |= this.padding[i & 3];
    if (this.lastByteIndex === this.byteCount) {
      blocks[0] = blocks[blockCount];
      for (i = 1; i < blockCount + 1; ++i) {
        blocks[i] = 0;
      }
    }
    blocks[blockCount - 1] |= 0x80000000;
    for (i = 0; i < blockCount; ++i) {
      s[i] ^= blocks[i];
    }
    f(s);
  };

  Keccak.prototype.toString = Keccak.prototype.hex = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var hex = '', block;
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        block = s[i];
        hex += HEX_CHARS[(block >> 4) & 0x0F] + HEX_CHARS[block & 0x0F] +
          HEX_CHARS[(block >> 12) & 0x0F] + HEX_CHARS[(block >> 8) & 0x0F] +
          HEX_CHARS[(block >> 20) & 0x0F] + HEX_CHARS[(block >> 16) & 0x0F] +
          HEX_CHARS[(block >> 28) & 0x0F] + HEX_CHARS[(block >> 24) & 0x0F];
      }
      if (j % blockCount === 0) {
        f(s);
        i = 0;
      }
    }
    if (extraBytes) {
      block = s[i];
      hex += HEX_CHARS[(block >> 4) & 0x0F] + HEX_CHARS[block & 0x0F];
      if (extraBytes > 1) {
        hex += HEX_CHARS[(block >> 12) & 0x0F] + HEX_CHARS[(block >> 8) & 0x0F];
      }
      if (extraBytes > 2) {
        hex += HEX_CHARS[(block >> 20) & 0x0F] + HEX_CHARS[(block >> 16) & 0x0F];
      }
    }
    return hex;
  };

  Keccak.prototype.arrayBuffer = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var bytes = this.outputBits >> 3;
    var buffer;
    if (extraBytes) {
      buffer = new ArrayBuffer((outputBlocks + 1) << 2);
    } else {
      buffer = new ArrayBuffer(bytes);
    }
    var array = new Uint32Array(buffer);
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        array[j] = s[i];
      }
      if (j % blockCount === 0) {
        f(s);
      }
    }
    if (extraBytes) {
      array[i] = s[i];
      buffer = buffer.slice(0, bytes);
    }
    return buffer;
  };

  Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;

  Keccak.prototype.digest = Keccak.prototype.array = function () {
    this.finalize();

    var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks,
      extraBytes = this.extraBytes, i = 0, j = 0;
    var array = [], offset, block;
    while (j < outputBlocks) {
      for (i = 0; i < blockCount && j < outputBlocks; ++i, ++j) {
        offset = j << 2;
        block = s[i];
        array[offset] = block & 0xFF;
        array[offset + 1] = (block >> 8) & 0xFF;
        array[offset + 2] = (block >> 16) & 0xFF;
        array[offset + 3] = (block >> 24) & 0xFF;
      }
      if (j % blockCount === 0) {
        f(s);
      }
    }
    if (extraBytes) {
      offset = j << 2;
      block = s[i];
      array[offset] = block & 0xFF;
      if (extraBytes > 1) {
        array[offset + 1] = (block >> 8) & 0xFF;
      }
      if (extraBytes > 2) {
        array[offset + 2] = (block >> 16) & 0xFF;
      }
    }
    return array;
  };

  function Kmac(bits, padding, outputBits) {
    Keccak.call(this, bits, padding, outputBits);
  }

  Kmac.prototype = new Keccak();

  Kmac.prototype.finalize = function () {
    this.encode(this.outputBits, true);
    return Keccak.prototype.finalize.call(this);
  };

  var f = function (s) {
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9,
      b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17,
      b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33,
      b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for (n = 0; n < 48; n += 2) {
      c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
      c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
      c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
      c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
      c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
      c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
      c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
      c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
      c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
      c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];

      h = c8 ^ ((c2 << 1) | (c3 >>> 31));
      l = c9 ^ ((c3 << 1) | (c2 >>> 31));
      s[0] ^= h;
      s[1] ^= l;
      s[10] ^= h;
      s[11] ^= l;
      s[20] ^= h;
      s[21] ^= l;
      s[30] ^= h;
      s[31] ^= l;
      s[40] ^= h;
      s[41] ^= l;
      h = c0 ^ ((c4 << 1) | (c5 >>> 31));
      l = c1 ^ ((c5 << 1) | (c4 >>> 31));
      s[2] ^= h;
      s[3] ^= l;
      s[12] ^= h;
      s[13] ^= l;
      s[22] ^= h;
      s[23] ^= l;
      s[32] ^= h;
      s[33] ^= l;
      s[42] ^= h;
      s[43] ^= l;
      h = c2 ^ ((c6 << 1) | (c7 >>> 31));
      l = c3 ^ ((c7 << 1) | (c6 >>> 31));
      s[4] ^= h;
      s[5] ^= l;
      s[14] ^= h;
      s[15] ^= l;
      s[24] ^= h;
      s[25] ^= l;
      s[34] ^= h;
      s[35] ^= l;
      s[44] ^= h;
      s[45] ^= l;
      h = c4 ^ ((c8 << 1) | (c9 >>> 31));
      l = c5 ^ ((c9 << 1) | (c8 >>> 31));
      s[6] ^= h;
      s[7] ^= l;
      s[16] ^= h;
      s[17] ^= l;
      s[26] ^= h;
      s[27] ^= l;
      s[36] ^= h;
      s[37] ^= l;
      s[46] ^= h;
      s[47] ^= l;
      h = c6 ^ ((c0 << 1) | (c1 >>> 31));
      l = c7 ^ ((c1 << 1) | (c0 >>> 31));
      s[8] ^= h;
      s[9] ^= l;
      s[18] ^= h;
      s[19] ^= l;
      s[28] ^= h;
      s[29] ^= l;
      s[38] ^= h;
      s[39] ^= l;
      s[48] ^= h;
      s[49] ^= l;

      b0 = s[0];
      b1 = s[1];
      b32 = (s[11] << 4) | (s[10] >>> 28);
      b33 = (s[10] << 4) | (s[11] >>> 28);
      b14 = (s[20] << 3) | (s[21] >>> 29);
      b15 = (s[21] << 3) | (s[20] >>> 29);
      b46 = (s[31] << 9) | (s[30] >>> 23);
      b47 = (s[30] << 9) | (s[31] >>> 23);
      b28 = (s[40] << 18) | (s[41] >>> 14);
      b29 = (s[41] << 18) | (s[40] >>> 14);
      b20 = (s[2] << 1) | (s[3] >>> 31);
      b21 = (s[3] << 1) | (s[2] >>> 31);
      b2 = (s[13] << 12) | (s[12] >>> 20);
      b3 = (s[12] << 12) | (s[13] >>> 20);
      b34 = (s[22] << 10) | (s[23] >>> 22);
      b35 = (s[23] << 10) | (s[22] >>> 22);
      b16 = (s[33] << 13) | (s[32] >>> 19);
      b17 = (s[32] << 13) | (s[33] >>> 19);
      b48 = (s[42] << 2) | (s[43] >>> 30);
      b49 = (s[43] << 2) | (s[42] >>> 30);
      b40 = (s[5] << 30) | (s[4] >>> 2);
      b41 = (s[4] << 30) | (s[5] >>> 2);
      b22 = (s[14] << 6) | (s[15] >>> 26);
      b23 = (s[15] << 6) | (s[14] >>> 26);
      b4 = (s[25] << 11) | (s[24] >>> 21);
      b5 = (s[24] << 11) | (s[25] >>> 21);
      b36 = (s[34] << 15) | (s[35] >>> 17);
      b37 = (s[35] << 15) | (s[34] >>> 17);
      b18 = (s[45] << 29) | (s[44] >>> 3);
      b19 = (s[44] << 29) | (s[45] >>> 3);
      b10 = (s[6] << 28) | (s[7] >>> 4);
      b11 = (s[7] << 28) | (s[6] >>> 4);
      b42 = (s[17] << 23) | (s[16] >>> 9);
      b43 = (s[16] << 23) | (s[17] >>> 9);
      b24 = (s[26] << 25) | (s[27] >>> 7);
      b25 = (s[27] << 25) | (s[26] >>> 7);
      b6 = (s[36] << 21) | (s[37] >>> 11);
      b7 = (s[37] << 21) | (s[36] >>> 11);
      b38 = (s[47] << 24) | (s[46] >>> 8);
      b39 = (s[46] << 24) | (s[47] >>> 8);
      b30 = (s[8] << 27) | (s[9] >>> 5);
      b31 = (s[9] << 27) | (s[8] >>> 5);
      b12 = (s[18] << 20) | (s[19] >>> 12);
      b13 = (s[19] << 20) | (s[18] >>> 12);
      b44 = (s[29] << 7) | (s[28] >>> 25);
      b45 = (s[28] << 7) | (s[29] >>> 25);
      b26 = (s[38] << 8) | (s[39] >>> 24);
      b27 = (s[39] << 8) | (s[38] >>> 24);
      b8 = (s[48] << 14) | (s[49] >>> 18);
      b9 = (s[49] << 14) | (s[48] >>> 18);

      s[0] = b0 ^ (~b2 & b4);
      s[1] = b1 ^ (~b3 & b5);
      s[10] = b10 ^ (~b12 & b14);
      s[11] = b11 ^ (~b13 & b15);
      s[20] = b20 ^ (~b22 & b24);
      s[21] = b21 ^ (~b23 & b25);
      s[30] = b30 ^ (~b32 & b34);
      s[31] = b31 ^ (~b33 & b35);
      s[40] = b40 ^ (~b42 & b44);
      s[41] = b41 ^ (~b43 & b45);
      s[2] = b2 ^ (~b4 & b6);
      s[3] = b3 ^ (~b5 & b7);
      s[12] = b12 ^ (~b14 & b16);
      s[13] = b13 ^ (~b15 & b17);
      s[22] = b22 ^ (~b24 & b26);
      s[23] = b23 ^ (~b25 & b27);
      s[32] = b32 ^ (~b34 & b36);
      s[33] = b33 ^ (~b35 & b37);
      s[42] = b42 ^ (~b44 & b46);
      s[43] = b43 ^ (~b45 & b47);
      s[4] = b4 ^ (~b6 & b8);
      s[5] = b5 ^ (~b7 & b9);
      s[14] = b14 ^ (~b16 & b18);
      s[15] = b15 ^ (~b17 & b19);
      s[24] = b24 ^ (~b26 & b28);
      s[25] = b25 ^ (~b27 & b29);
      s[34] = b34 ^ (~b36 & b38);
      s[35] = b35 ^ (~b37 & b39);
      s[44] = b44 ^ (~b46 & b48);
      s[45] = b45 ^ (~b47 & b49);
      s[6] = b6 ^ (~b8 & b0);
      s[7] = b7 ^ (~b9 & b1);
      s[16] = b16 ^ (~b18 & b10);
      s[17] = b17 ^ (~b19 & b11);
      s[26] = b26 ^ (~b28 & b20);
      s[27] = b27 ^ (~b29 & b21);
      s[36] = b36 ^ (~b38 & b30);
      s[37] = b37 ^ (~b39 & b31);
      s[46] = b46 ^ (~b48 & b40);
      s[47] = b47 ^ (~b49 & b41);
      s[8] = b8 ^ (~b0 & b2);
      s[9] = b9 ^ (~b1 & b3);
      s[18] = b18 ^ (~b10 & b12);
      s[19] = b19 ^ (~b11 & b13);
      s[28] = b28 ^ (~b20 & b22);
      s[29] = b29 ^ (~b21 & b23);
      s[38] = b38 ^ (~b30 & b32);
      s[39] = b39 ^ (~b31 & b33);
      s[48] = b48 ^ (~b40 & b42);
      s[49] = b49 ^ (~b41 & b43);

      s[0] ^= RC[n];
      s[1] ^= RC[n + 1];
    }
  };

  if (COMMON_JS) {
    module.exports = methods;
  } else {
    for (i = 0; i < methodNames.length; ++i) {
      root[methodNames[i]] = methods[methodNames[i]];
    }
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return methods;
      }).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();


/***/ }),

/***/ "../../node_modules/lit-connect-modal/build/index.js":
/***/ ((module) => {

var u=Object.defineProperty;var R=Object.getOwnPropertyDescriptor;var U=Object.getOwnPropertyNames;var J=Object.prototype.hasOwnProperty;var Q=(n,e)=>{for(var o in e)u(n,o,{get:e[o],enumerable:!0})},X=(n,e,o,i)=>{if(e&&typeof e=="object"||typeof e=="function")for(let t of U(e))!J.call(n,t)&&t!==o&&u(n,t,{get:()=>e[t],enumerable:!(i=R(e,t))||i.enumerable});return n};var Z=n=>X(u({},"__esModule",{value:!0}),n);var ae={};Q(ae,{default:()=>h});module.exports=Z(ae);function C(n,e){for(var o=0;o<e.length;o++){var i=e[o];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(n,i.key,i)}}function f(n){return function(e){if(Array.isArray(e))return g(e)}(n)||function(e){if(typeof Symbol<"u"&&Symbol.iterator in Object(e))return Array.from(e)}(n)||function(e,o){if(!!e){if(typeof e=="string")return g(e,o);var i=Object.prototype.toString.call(e).slice(8,-1);if(i==="Object"&&e.constructor&&(i=e.constructor.name),i==="Map"||i==="Set")return Array.from(e);if(i==="Arguments"||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))return g(e,o)}}(n)||function(){throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`)}()}function g(n,e){(e==null||e>n.length)&&(e=n.length);for(var o=0,i=new Array(e);o<e;o++)i[o]=n[o];return i}var L,v,m,p,A,I=(L=["a[href]","area[href]",'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',"select:not([disabled]):not([aria-hidden])","textarea:not([disabled]):not([aria-hidden])","button:not([disabled]):not([aria-hidden])","iframe","object","embed","[contenteditable]",'[tabindex]:not([tabindex^="-"])'],v=function(){function n(t){var l=t.targetModal,a=t.triggers,r=a===void 0?[]:a,s=t.onShow,c=s===void 0?function(){}:s,d=t.onClose,j=d===void 0?function(){}:d,b=t.openTrigger,_=b===void 0?"data-micromodal-trigger":b,y=t.closeTrigger,V=y===void 0?"data-micromodal-close":y,w=t.openClass,q=w===void 0?"is-open":w,k=t.disableScroll,H=k!==void 0&&k,M=t.disableFocus,K=M!==void 0&&M,z=t.awaitCloseAnimation,N=z!==void 0&&z,E=t.awaitOpenAnimation,D=E!==void 0&&E,x=t.debugMode,$=x!==void 0&&x;(function(Y,G){if(!(Y instanceof G))throw new TypeError("Cannot call a class as a function")})(this,n),this.modal=document.getElementById(l),this.config={debugMode:$,disableScroll:H,openTrigger:_,closeTrigger:V,openClass:q,onShow:c,onClose:j,awaitCloseAnimation:N,awaitOpenAnimation:D,disableFocus:K},r.length>0&&this.registerTriggers.apply(this,f(r)),this.onClick=this.onClick.bind(this),this.onKeydown=this.onKeydown.bind(this)}var e,o,i;return e=n,(o=[{key:"registerTriggers",value:function(){for(var t=this,l=arguments.length,a=new Array(l),r=0;r<l;r++)a[r]=arguments[r];a.filter(Boolean).forEach(function(s){s.addEventListener("click",function(c){return t.showModal(c)})})}},{key:"showModal",value:function(){var t=this,l=arguments.length>0&&arguments[0]!==void 0?arguments[0]:null;if(this.activeElement=document.activeElement,this.modal.setAttribute("aria-hidden","false"),this.modal.classList.add(this.config.openClass),this.scrollBehaviour("disable"),this.addEventListeners(),this.config.awaitOpenAnimation){var a=function r(){t.modal.removeEventListener("animationend",r,!1),t.setFocusToFirstNode()};this.modal.addEventListener("animationend",a,!1)}else this.setFocusToFirstNode();this.config.onShow(this.modal,this.activeElement,l)}},{key:"closeModal",value:function(){var t=arguments.length>0&&arguments[0]!==void 0?arguments[0]:null,l=this.modal;if(this.modal.setAttribute("aria-hidden","true"),this.removeEventListeners(),this.scrollBehaviour("enable"),this.activeElement&&this.activeElement.focus&&this.activeElement.focus(),this.config.onClose(this.modal,this.activeElement,t),this.config.awaitCloseAnimation){var a=this.config.openClass;this.modal.addEventListener("animationend",function r(){l.classList.remove(a),l.removeEventListener("animationend",r,!1)},!1)}else l.classList.remove(this.config.openClass)}},{key:"closeModalById",value:function(t){this.modal=document.getElementById(t),this.modal&&this.closeModal()}},{key:"scrollBehaviour",value:function(t){if(this.config.disableScroll){var l=document.querySelector("body");switch(t){case"enable":Object.assign(l.style,{overflow:""});break;case"disable":Object.assign(l.style,{overflow:"hidden"})}}}},{key:"addEventListeners",value:function(){this.modal.addEventListener("touchstart",this.onClick),this.modal.addEventListener("click",this.onClick),document.addEventListener("keydown",this.onKeydown)}},{key:"removeEventListeners",value:function(){this.modal.removeEventListener("touchstart",this.onClick),this.modal.removeEventListener("click",this.onClick),document.removeEventListener("keydown",this.onKeydown)}},{key:"onClick",value:function(t){(t.target.hasAttribute(this.config.closeTrigger)||t.target.parentNode.hasAttribute(this.config.closeTrigger))&&(t.preventDefault(),t.stopPropagation(),this.closeModal(t))}},{key:"onKeydown",value:function(t){t.keyCode===27&&this.closeModal(t),t.keyCode===9&&this.retainFocus(t)}},{key:"getFocusableNodes",value:function(){var t=this.modal.querySelectorAll(L);return Array.apply(void 0,f(t))}},{key:"setFocusToFirstNode",value:function(){var t=this;if(!this.config.disableFocus){var l=this.getFocusableNodes();if(l.length!==0){var a=l.filter(function(r){return!r.hasAttribute(t.config.closeTrigger)});a.length>0&&a[0].focus(),a.length===0&&l[0].focus()}}}},{key:"retainFocus",value:function(t){var l=this.getFocusableNodes();if(l.length!==0)if(l=l.filter(function(r){return r.offsetParent!==null}),this.modal.contains(document.activeElement)){var a=l.indexOf(document.activeElement);t.shiftKey&&a===0&&(l[l.length-1].focus(),t.preventDefault()),!t.shiftKey&&l.length>0&&a===l.length-1&&(l[0].focus(),t.preventDefault())}else l[0].focus()}}])&&C(e.prototype,o),i&&C(e,i),n}(),m=null,p=function(n){if(!document.getElementById(n))return console.warn("MicroModal: \u2757Seems like you have missed %c'".concat(n,"'"),"background-color: #f8f9fa;color: #50596c;font-weight: bold;","ID somewhere in your code. Refer example below to resolve it."),console.warn("%cExample:","background-color: #f8f9fa;color: #50596c;font-weight: bold;",'<div class="modal" id="'.concat(n,'"></div>')),!1},A=function(n,e){if(function(i){i.length<=0&&(console.warn("MicroModal: \u2757Please specify at least one %c'micromodal-trigger'","background-color: #f8f9fa;color: #50596c;font-weight: bold;","data attribute."),console.warn("%cExample:","background-color: #f8f9fa;color: #50596c;font-weight: bold;",'<a href="#" data-micromodal-trigger="my-modal"></a>'))}(n),!e)return!0;for(var o in e)p(o);return!0},{init:function(n){var e=Object.assign({},{openTrigger:"data-micromodal-trigger"},n),o=f(document.querySelectorAll("[".concat(e.openTrigger,"]"))),i=function(a,r){var s=[];return a.forEach(function(c){var d=c.attributes[r].value;s[d]===void 0&&(s[d]=[]),s[d].push(c)}),s}(o,e.openTrigger);if(e.debugMode!==!0||A(o,i)!==!1)for(var t in i){var l=i[t];e.targetModal=t,e.triggers=f(l),m=new v(e)}},show:function(n,e){var o=e||{};o.targetModal=n,o.debugMode===!0&&p(n)===!1||(m&&m.removeEventListeners(),(m=new v(o)).showModal())},close:function(n){n?m.closeModalById(n):m.closeModal()}});typeof window<"u"&&(window.MicroModal=I);var O=I;var S=`.modal {
  font-family: -apple-system,BlinkMacSystemFont,avenir next,avenir,helvetica neue,helvetica,ubuntu,roboto,noto,segoe ui,arial,sans-serif;
}

.lcm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 12;
}

.lcm-modal-container {
  border: 1px solid rgba(129, 89, 217, 1);
  background-color: #fff;
  padding: 0 1.5rem;
  max-width: 500px;
  max-height: 100vh;
  border-radius: 0.25rem;
  overflow-y: auto;
  box-sizing: border-box;
}

.lcm-modal-content {
  margin-top: 2rem;
  margin-bottom: 2rem;
  line-height: 1.5;
  color: rgba(0,0,0,.8);
}

.lcm-wallet-container {
  display: flex;
  align-items: center;
  margin: 2rem 0.5rem;
  transition-duration: 0.2s;
  border-radius: 0.25rem;
  padding: 2rem;
  cursor: pointer;
}

.lcm-wallet-container:hover {
  background-color: #d4d4d4;
}

.lcm-wallet-logo {
  height: 2.5rem;
  width: 3.75rem;
  margin-right: 1.5rem;
}

.lcm-text-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.lcm-wallet-name {
  font-weight: bold;
  font-size: 1.2rem;
  margin: 0;
}

.lcm-wallet-synopsis {
  color: #777;
  font-size: 0.9rem;
  margin: 0;
}


@keyframes mmfadeIn {
    from { opacity: 0; }
      to { opacity: 1; }
}

@keyframes mmfadeOut {
    from { opacity: 1; }
      to { opacity: 0; }
}

@keyframes mmslideIn {
  from { transform: translateY(15%); }
    to { transform: translateY(0); }
}

@keyframes mmslideOut {
    from { transform: translateY(0); }
    to { transform: translateY(-10%); }
}

.micromodal-slide {
  display: none;
}

.micromodal-slide.is-open {
  display: block;
}

.micromodal-slide[aria-hidden="false"] .lcm-modal-overlay {
  animation: mmfadeIn .3s cubic-bezier(0.0, 0.0, 0.2, 1);
}

.micromodal-slide[aria-hidden="false"] .lcm-modal-container {
  animation: mmslideIn .3s cubic-bezier(0, 0, .2, 1);
}

.micromodal-slide[aria-hidden="true"] .lcm-modal-overlay {
  animation: mmfadeOut .3s cubic-bezier(0.0, 0.0, 0.2, 1);
}

.micromodal-slide[aria-hidden="true"] .lcm-modal-container {
  animation: mmslideOut .3s cubic-bezier(0, 0, .2, 1);
}

.micromodal-slide .lcm-modal-container,
.micromodal-slide .lcm-modal-overlay {
  will-change: transform;
}
`;var T="data:image/svg+xml;base64,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";var B="data:image/svg+xml;base64,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";var W="data:image/svg+xml;base64,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";var ne=[{htmlId:"lcm-metaMask",id:"metamask",logo:T,name:"MetaMask",provider:globalThis.ethereum,synopsis:"Connect your MetaMask Wallet",checkIfPresent:()=>typeof globalThis.ethereum<"u"},{htmlId:"lcm-coinbase",id:"coinbase",logo:B,name:"Coinbase",provider:globalThis.ethereum?.providers?.find(n=>n.isCoinbaseWallet),synopsis:"Connect your Coinbase Wallet",checkIfPresent:()=>!!globalThis.ethereum?.providers?.find(n=>n.isCoinbaseWallet)},{htmlId:"lcm-walletConnect",id:"walletconnect",logo:W,name:"Wallet Connect",provider:null,synopsis:"Scan with WalletConnect to connect"}],F=ne;var le={walletconnect:(n,e)=>{let o=n.walletconnect,i=o.options,t="https://bridge.walletconnect.org",l=!0,a="",r,s=1,c;i&&(t=i.bridge||t,l=typeof i.qrcode<"u"?i.qrcode:l,a=i.infuraId||"",r=i.rpc||void 0,s=i.chainId||1,c=i.qrcodeModalOptions||void 0);let d=o.package;return new d({bridge:t,qrcode:l,infuraId:a,rpc:r,chainId:s,qrcodeModalOptions:c})}},P=le;var h=class{constructor({providerOptions:e}){this.dialog=O,this.closeAction=void 0,this.parent=document.body,this.filteredListOfWalletsArray=[],this.providerOptions=e,this._filterListOfWallets(),this._instantiateLitConnectModal();var o=document.createElement("style");o.innerHTML=S,document.head.appendChild(o)}getWalletProvider(){let e=localStorage.getItem("lit-web3-provider");return this.dialog.show("lit-connect-modal"),new Promise((o,i)=>{if(e){let t=this.filteredListOfWalletsArray.find(l=>l.id===e);o(t.provider),this._destroy();return}this.filteredListOfWalletsArray.forEach(t=>{let l=document.getElementById(t.id);console.log("walletEntry- ",l),l.addEventListener("click",()=>{localStorage.setItem("lit-web3-provider",t.id),console.log("resolved id & provider- ",t.id,t.provider),o(t.provider),this._destroy()})}),this.closeAction.addEventListener("click",()=>{o(!1),this._destroy()})})}_filterListOfWallets(){let e=[];F.forEach(o=>{if(!!o.checkIfPresent&&o.checkIfPresent()===!0)e.push(o);else if(this.providerOptions[o.id]){let i=o;i.provider=P[o.id](this.providerOptions,o.id),e.push(i)}}),this.filteredListOfWalletsArray=e}_instantiateLitConnectModal(){let e=document.createElement("div");e.setAttribute("id","lit-connect-modal-container"),e.innerHTML=`
      <div class="modal micromodal-slide" id="lit-connect-modal" aria-hidden="true">
        <div class="lcm-modal-overlay" id="lcm-modal-overlay" tabindex="-1" data-micromodal-close>
          <div class="lcm-modal-container" role="dialog" aria-modal="true" aria-labelledby="lit-connect-modal-title">
            <main class="lcm-modal-content" id="lit-connect-modal-content">
            </main>
          </div>
        </div>
      </div>
    `,this.parent.appendChild(e),this.trueButton=document.getElementById("lcm-continue-button"),this.closeAction=document.getElementById("lcm-modal-overlay"),this._buildListOfWallets(),this.dialog.init({disableScroll:!0,disableFocus:!1,awaitOpenAnimation:!1,awaitCloseAnimation:!1,debugMode:!1}),console.log("Providers- ",globalThis.ethereum?.providers);let o=document.getElementById("lcm-metaMast")}_buildListOfWallets(){let e=document.getElementById("lit-connect-modal-content"),o="";this.filteredListOfWalletsArray.forEach(i=>{o+=`
        <div class="lcm-wallet-container" id="${i.id}">
          <img class="lcm-wallet-logo"  src=${i.logo} />
          <div class="lcm-text-column">
            <p class="lcm-wallet-name" >${i.name}</p>
            <p class="lcm-wallet-synopsis" >${i.synopsis}</p>
          </div>
        </div>
      `}),e.innerHTML=o}_destroy(){let e=document.getElementById("lit-connect-modal-container");e&&e.remove()}};
//# sourceMappingURL=index.js.map


/***/ }),

/***/ "../../node_modules/lit-siwe/dist/client.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.generateNonce = exports.checkContractWalletSignature = exports.SiweMessage = exports.SignatureType = exports.ErrorTypes = void 0;
const random_1 = __webpack_require__("../../node_modules/@stablelib/random/lib/random.js");
// TODO: Figure out how to get types from this lib:
// import { Contract, ethers, utils } from 'ethers';
const contracts_1 = __webpack_require__("../../node_modules/@ethersproject/contracts/lib.esm/index.js");
const wallet_1 = __webpack_require__("../../node_modules/@ethersproject/wallet/lib.esm/index.js");
const hash_1 = __webpack_require__("../../node_modules/@ethersproject/hash/lib.esm/index.js");
const siwe_parser_1 = __webpack_require__("../../node_modules/@spruceid/siwe-parser/dist/parsers.js");
/**
 * Possible message error types.
 */
var ErrorTypes;
(function (ErrorTypes) {
    /**Thrown when the `validate()` function can verify the message. */
    ErrorTypes["INVALID_SIGNATURE"] = "Invalid signature.";
    /**Thrown when the `expirationTime` is present and in the past. */
    ErrorTypes["EXPIRED_MESSAGE"] = "Expired message.";
    /**Thrown when some required field is missing. */
    ErrorTypes["MALFORMED_SESSION"] = "Malformed session.";
})(ErrorTypes = exports.ErrorTypes || (exports.ErrorTypes = {}));
/**@deprecated
 * Possible signature types that this library supports.
 *
 * This enum will be removed in future releases. And signature type will be
 * inferred from version.
 */
var SignatureType;
(function (SignatureType) {
    /**EIP-191 signature scheme */
    SignatureType["PERSONAL_SIGNATURE"] = "Personal signature";
})(SignatureType = exports.SignatureType || (exports.SignatureType = {}));
class SiweMessage {
    /**
     * Creates a parsed Sign-In with Ethereum Message (EIP-4361) object from a
     * string or an object. If a string is used an ABNF parser is called to
     * validate the parameter, otherwise the fields are attributed.
     * @param param {string | SiweMessage} Sign message as a string or an object.
     */
    constructor(param) {
        if (typeof param === "string") {
            const parsedMessage = new siwe_parser_1.ParsedMessage(param);
            this.domain = parsedMessage.domain;
            this.address = parsedMessage.address;
            this.statement = parsedMessage.statement;
            this.uri = parsedMessage.uri;
            this.version = parsedMessage.version;
            this.nonce = parsedMessage.nonce;
            this.issuedAt = parsedMessage.issuedAt;
            this.expirationTime = parsedMessage.expirationTime;
            this.notBefore = parsedMessage.notBefore;
            this.requestId = parsedMessage.requestId;
            this.chainId = parsedMessage.chainId;
            this.resources = parsedMessage.resources;
        }
        else {
            Object.assign(this, param);
            if (typeof this.chainId === "string") {
                this.chainId = parseInt(this.chainId);
            }
        }
    }
    /**
     * Given a sign message (EIP-4361) returns the correct matching groups.
     * @param message {string}
     * @returns {RegExpExecArray} The matching groups for the message
     */
    regexFromMessage(message) {
        const parsedMessage = new siwe_parser_1.ParsedMessageRegExp(message);
        return parsedMessage.match;
    }
    /**
     * This function can be used to retrieve an EIP-4361 formated message for
     * signature, although you can call it directly it's advised to use
     * [signMessage()] instead which will resolve to the correct method based
     * on the [type] attribute of this object, in case of other formats being
     * implemented.
     * @returns {string} EIP-4361 formated message, ready for EIP-191 signing.
     */
    toMessage() {
        const header = `${this.domain} wants you to sign in with your Ethereum account:`;
        const uriField = `URI: ${this.uri}`;
        let prefix = [header, this.address].join("\n");
        const versionField = `Version: ${this.version}`;
        if (!this.nonce) {
            this.nonce = (0, exports.generateNonce)();
        }
        const chainField = `Chain ID: ` + this.chainId || 0;
        const nonceField = `Nonce: ${this.nonce}`;
        const suffixArray = [uriField, versionField, chainField, nonceField];
        if (this.issuedAt) {
            Date.parse(this.issuedAt);
        }
        this.issuedAt = this.issuedAt ? this.issuedAt : new Date().toISOString();
        suffixArray.push(`Issued At: ${this.issuedAt}`);
        if (this.expirationTime) {
            const expiryField = `Expiration Time: ${this.expirationTime}`;
            suffixArray.push(expiryField);
        }
        if (this.notBefore) {
            suffixArray.push(`Not Before: ${this.notBefore}`);
        }
        if (this.requestId) {
            suffixArray.push(`Request ID: ${this.requestId}`);
        }
        if (this.resources) {
            suffixArray.push([`Resources:`, ...this.resources.map((x) => `- ${x}`)].join("\n"));
        }
        let suffix = suffixArray.join("\n");
        prefix = [prefix, this.statement].join("\n\n");
        if (this.statement) {
            prefix += "\n";
        }
        return [prefix, suffix].join("\n");
    }
    /** @deprecated
     * signMessage method is deprecated, use prepareMessage instead.
     *
     * This method parses all the fields in the object and creates a sign
     * message according with the type defined.
     * @returns {string} Returns a message ready to be signed according with the
     * type defined in the object.
     */
    signMessage() {
        console &&
            console.warn &&
            console.warn("signMessage method is deprecated, use prepareMessage instead.");
        return this.prepareMessage();
    }
    /**
     * This method parses all the fields in the object and creates a sign
     * message according with the type defined.
     * @returns {string} Returns a message ready to be signed according with the
     * type defined in the object.
     */
    prepareMessage() {
        let message;
        switch (this.version) {
            case "1": {
                message = this.toMessage();
                break;
            }
            default: {
                message = this.toMessage();
                break;
            }
        }
        return message;
    }
    /**
     * Validates the integrity of the fields of this objects by matching it's
     * signature.
     * @param provider A Web3 provider able to perform a contract check, this is
     * required if support for Smart Contract Wallets that implement EIP-1271 is
     * needed.
     * @returns {Promise<SiweMessage>} This object if valid.
     */
    validate(signature = this.signature, provider) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                const message = this.prepareMessage();
                try {
                    let missing = [];
                    if (!message) {
                        missing.push("`message`");
                    }
                    if (!signature) {
                        missing.push("`signature`");
                    }
                    if (!this.address) {
                        missing.push("`address`");
                    }
                    if (missing.length > 0) {
                        throw new Error(`${ErrorTypes.MALFORMED_SESSION} missing: ${missing.join(", ")}.`);
                    }
                    let addr;
                    try {
                        addr = (0, wallet_1.verifyMessage)(message, signature);
                    }
                    catch (_) {
                    }
                    finally {
                        if (addr !== this.address) {
                            try {
                                //EIP-1271
                                const isValidSignature = yield (0, exports.checkContractWalletSignature)(this, signature, provider);
                                if (!isValidSignature) {
                                    throw new Error(`${ErrorTypes.INVALID_SIGNATURE}: ${addr} !== ${this.address}`);
                                }
                            }
                            catch (e) {
                                throw e;
                            }
                        }
                    }
                    const parsedMessage = new SiweMessage(message);
                    if (parsedMessage.expirationTime) {
                        const exp = new Date(parsedMessage.expirationTime).getTime();
                        if (isNaN(exp)) {
                            throw new Error(`${ErrorTypes.MALFORMED_SESSION} invalid expiration date.`);
                        }
                        if (new Date().getTime() >= exp) {
                            throw new Error(ErrorTypes.EXPIRED_MESSAGE);
                        }
                    }
                    resolve(parsedMessage);
                }
                catch (e) {
                    reject(e);
                }
            }));
        });
    }
}
exports.SiweMessage = SiweMessage;
/**
 * This method calls the EIP-1271 method for Smart Contract wallets
 * @param message The EIP-4361 parsed message
 * @param provider Web3 provider able to perform a contract check (Web3/EthersJS).
 * @returns {Promise<boolean>} Checks for the smart contract (if it exists) if
 * the signature is valid for given address.
 */
const checkContractWalletSignature = (message, signature, provider) => __awaiter(void 0, void 0, void 0, function* () {
    if (!provider) {
        return false;
    }
    const abi = [
        "function isValidSignature(bytes32 _message, bytes _signature) public view returns (bool)",
    ];
    try {
        const walletContract = new contracts_1.Contract(message.address, abi, provider);
        const hashMessage = (0, hash_1.hashMessage)(message.signMessage());
        return yield walletContract.isValidSignature(hashMessage, signature);
    }
    catch (e) {
        throw e;
    }
});
exports.checkContractWalletSignature = checkContractWalletSignature;
/**
 * This method leverages a native CSPRNG with support for both browser and Node.js
 * environments in order generate a cryptographically secure nonce for use in the
 * SiweMessage in order to prevent replay attacks.
 *
 * 96 bits has been chosen as a number to sufficiently balance size and security considerations
 * relative to the lifespan of it's usage.
 *
 * @returns cryptographically generated random nonce with 96 bits of entropy encoded with
 * an alphanumeric character set.
 */
const generateNonce = () => {
    return (0, random_1.randomStringForEntropy)(96);
};
exports.generateNonce = generateNonce;


/***/ }),

/***/ "../../node_modules/lit-siwe/dist/siwe.js":
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__("../../node_modules/lit-siwe/dist/client.js"), exports);


/***/ }),

/***/ "../../node_modules/lodash/_SetCache.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__("../../node_modules/lodash/isArray.js");

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),

/***/ "../../node_modules/lodash/_Stack.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var listCacheClear = __webpack_require__("../../node_modules/lodash/_listCacheClear.js"),
    listCacheDelete = __webpack_require__("../../node_modules/lodash/_listCacheDelete.js"),
    listCacheGet = __webpack_require__("../../node_modules/lodash/_listCacheGet.js"),
    listCacheHas = __webpack_require__("../../node_modules/lodash/_listCacheHas.js"),
    listCacheSet = __webpack_require__("../../node_modules/lodash/_listCacheSet.js");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "../../node_modules/lodash/_Symbol.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__("../../node_modules/lodash/_root.js");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "../../node_modules/lodash/_Uint8Array.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var root = __webpack_require__("../../node_modules/lodash/_root.js");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "../../node_modules/lodash/_apply.js":
/***/ ((module) => {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "../../node_modules/lodash/_arrayEach.js":
/***/ ((module) => {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ "../../node_modules/lodash/_arrayIncludes.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIndexOf = __webpack_require__("../../node_modules/lodash/_baseIndexOf.js");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "../../node_modules/lodash/_arrayIncludesWith.js":
/***/ ((module) => {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ "../../node_modules/lodash/_arrayMap.js":
/***/ ((module) => {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ "../../node_modules/lodash/_asciiSize.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseProperty = __webpack_require__("../../node_modules/lodash/_baseProperty.js");

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),

/***/ "../../node_modules/lodash/_asciiToArray.js":
/***/ ((module) => {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ "../../node_modules/lodash/_assignMergeValue.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__("../../node_modules/lodash/_baseAssignValue.js"),
    eq = __webpack_require__("../../node_modules/lodash/eq.js");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "../../node_modules/lodash/_assignValue.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseAssignValue = __webpack_require__("../../node_modules/lodash/_baseAssignValue.js"),
    eq = __webpack_require__("../../node_modules/lodash/eq.js");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "../../node_modules/lodash/_assocIndexOf.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var eq = __webpack_require__("../../node_modules/lodash/eq.js");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "../../node_modules/lodash/_baseAssign.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__("../../node_modules/lodash/_copyObject.js"),
    keys = __webpack_require__("../../node_modules/lodash/keys.js");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ "../../node_modules/lodash/_baseAssignIn.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__("../../node_modules/lodash/_copyObject.js"),
    keysIn = __webpack_require__("../../node_modules/lodash/keysIn.js");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ "../../node_modules/lodash/_baseAssignValue.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var defineProperty = __webpack_require__("../../node_modules/lodash/_defineProperty.js");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "../../node_modules/lodash/_baseClamp.js":
/***/ ((module) => {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),

/***/ "../../node_modules/lodash/_baseClone.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__("../../node_modules/lodash/_Stack.js"),
    arrayEach = __webpack_require__("../../node_modules/lodash/_arrayEach.js"),
    assignValue = __webpack_require__("../../node_modules/lodash/_assignValue.js"),
    baseAssign = __webpack_require__("../../node_modules/lodash/_baseAssign.js"),
    baseAssignIn = __webpack_require__("../../node_modules/lodash/_baseAssignIn.js"),
    cloneBuffer = __webpack_require__("../../node_modules/lodash/_cloneBuffer.js"),
    copyArray = __webpack_require__("../../node_modules/lodash/_copyArray.js"),
    copySymbols = __webpack_require__("../../node_modules/lodash/_copySymbols.js"),
    copySymbolsIn = __webpack_require__("../../node_modules/lodash/_copySymbolsIn.js"),
    getAllKeys = __webpack_require__("../../node_modules/lodash/_getAllKeys.js"),
    getAllKeysIn = __webpack_require__("../../node_modules/lodash/_getAllKeysIn.js"),
    getTag = __webpack_require__("../../node_modules/lodash/_getTag.js"),
    initCloneArray = __webpack_require__("../../node_modules/lodash/_initCloneArray.js"),
    initCloneByTag = __webpack_require__("../../node_modules/lodash/_initCloneByTag.js"),
    initCloneObject = __webpack_require__("../../node_modules/lodash/_initCloneObject.js"),
    isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
    isBuffer = __webpack_require__("../../node_modules/lodash/isBuffer.js"),
    isMap = __webpack_require__("../../node_modules/lodash/isMap.js"),
    isObject = __webpack_require__("../../node_modules/lodash/isObject.js"),
    isSet = __webpack_require__("../../node_modules/lodash/isSet.js"),
    keys = __webpack_require__("../../node_modules/lodash/keys.js"),
    keysIn = __webpack_require__("../../node_modules/lodash/keysIn.js");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ "../../node_modules/lodash/_baseCreate.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isObject = __webpack_require__("../../node_modules/lodash/isObject.js");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "../../node_modules/lodash/_baseDifference.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var SetCache = __webpack_require__("../../node_modules/lodash/_SetCache.js"),
    arrayIncludes = __webpack_require__("../../node_modules/lodash/_arrayIncludes.js"),
    arrayIncludesWith = __webpack_require__("../../node_modules/lodash/_arrayIncludesWith.js"),
    arrayMap = __webpack_require__("../../node_modules/lodash/_arrayMap.js"),
    baseUnary = __webpack_require__("../../node_modules/lodash/_baseUnary.js"),
    cacheHas = __webpack_require__("../../node_modules/lodash/_cacheHas.js");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),

/***/ "../../node_modules/lodash/_baseExtremum.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isSymbol = __webpack_require__("../../node_modules/lodash/isSymbol.js");

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),

/***/ "../../node_modules/lodash/_baseFor.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createBaseFor = __webpack_require__("../../node_modules/lodash/_createBaseFor.js");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "../../node_modules/lodash/_baseGetTag.js":
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "../../node_modules/lodash/_baseIndexOf.js":
/***/ ((module) => {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ "../../node_modules/lodash/_baseLt.js":
/***/ ((module) => {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),

/***/ "../../node_modules/lodash/_baseMerge.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Stack = __webpack_require__("../../node_modules/lodash/_Stack.js"),
    assignMergeValue = __webpack_require__("../../node_modules/lodash/_assignMergeValue.js"),
    baseFor = __webpack_require__("../../node_modules/lodash/_baseFor.js"),
    baseMergeDeep = __webpack_require__("../../node_modules/lodash/_baseMergeDeep.js"),
    isObject = __webpack_require__("../../node_modules/lodash/isObject.js"),
    keysIn = __webpack_require__("../../node_modules/lodash/keysIn.js"),
    safeGet = __webpack_require__("../../node_modules/lodash/_safeGet.js");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "../../node_modules/lodash/_baseMergeDeep.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignMergeValue = __webpack_require__("../../node_modules/lodash/_assignMergeValue.js"),
    cloneBuffer = __webpack_require__("../../node_modules/lodash/_cloneBuffer.js"),
    cloneTypedArray = __webpack_require__("../../node_modules/lodash/_cloneTypedArray.js"),
    copyArray = __webpack_require__("../../node_modules/lodash/_copyArray.js"),
    initCloneObject = __webpack_require__("../../node_modules/lodash/_initCloneObject.js"),
    isArguments = __webpack_require__("../../node_modules/lodash/isArguments.js"),
    isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
    isArrayLikeObject = __webpack_require__("../../node_modules/lodash/isArrayLikeObject.js"),
    isBuffer = __webpack_require__("../../node_modules/lodash/isBuffer.js"),
    isFunction = __webpack_require__("../../node_modules/lodash/isFunction.js"),
    isObject = __webpack_require__("../../node_modules/lodash/isObject.js"),
    isPlainObject = __webpack_require__("../../node_modules/lodash/isPlainObject.js"),
    isTypedArray = __webpack_require__("../../node_modules/lodash/isTypedArray.js"),
    safeGet = __webpack_require__("../../node_modules/lodash/_safeGet.js"),
    toPlainObject = __webpack_require__("../../node_modules/lodash/toPlainObject.js");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "../../node_modules/lodash/_baseProperty.js":
/***/ ((module) => {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ "../../node_modules/lodash/_baseRandom.js":
/***/ ((module) => {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),

/***/ "../../node_modules/lodash/_baseRange.js":
/***/ ((module) => {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ "../../node_modules/lodash/_baseRepeat.js":
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

module.exports = baseRepeat;


/***/ }),

/***/ "../../node_modules/lodash/_baseRest.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var identity = __webpack_require__("../../node_modules/lodash/identity.js"),
    overRest = __webpack_require__("../../node_modules/lodash/_overRest.js"),
    setToString = __webpack_require__("../../node_modules/lodash/_setToString.js");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "../../node_modules/lodash/_baseSet.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignValue = __webpack_require__("../../node_modules/lodash/_assignValue.js"),
    castPath = __webpack_require__("../../node_modules/lodash/_castPath.js"),
    isIndex = __webpack_require__("../../node_modules/lodash/_isIndex.js"),
    isObject = __webpack_require__("../../node_modules/lodash/isObject.js"),
    toKey = __webpack_require__("../../node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),

/***/ "../../node_modules/lodash/_baseSlice.js":
/***/ ((module) => {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ "../../node_modules/lodash/_baseToString.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Symbol = __webpack_require__("../../node_modules/lodash/_Symbol.js"),
    arrayMap = __webpack_require__("../../node_modules/lodash/_arrayMap.js"),
    isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
    isSymbol = __webpack_require__("../../node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ "../../node_modules/lodash/_baseUnary.js":
/***/ ((module) => {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "../../node_modules/lodash/_baseUniq.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var SetCache = __webpack_require__("../../node_modules/lodash/_SetCache.js"),
    arrayIncludes = __webpack_require__("../../node_modules/lodash/_arrayIncludes.js"),
    arrayIncludesWith = __webpack_require__("../../node_modules/lodash/_arrayIncludesWith.js"),
    cacheHas = __webpack_require__("../../node_modules/lodash/_cacheHas.js"),
    createSet = __webpack_require__("../../node_modules/lodash/_createSet.js"),
    setToArray = __webpack_require__("../../node_modules/lodash/_setToArray.js");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ "../../node_modules/lodash/_baseUnset.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var castPath = __webpack_require__("../../node_modules/lodash/_castPath.js"),
    last = __webpack_require__("../../node_modules/lodash/last.js"),
    parent = __webpack_require__("../../node_modules/lodash/_parent.js"),
    toKey = __webpack_require__("../../node_modules/lodash/_toKey.js");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ "../../node_modules/lodash/_cacheHas.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseIndexOf = __webpack_require__("../../node_modules/lodash/_baseIndexOf.js");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ "../../node_modules/lodash/_castPath.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArray = __webpack_require__("../../node_modules/lodash/isArray.js");

/**
 * Casts `value` as an array if it's not one.
 *
 * @static
 * @memberOf _
 * @since 4.4.0
 * @category Lang
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast array.
 * @example
 *
 * _.castArray(1);
 * // => [1]
 *
 * _.castArray({ 'a': 1 });
 * // => [{ 'a': 1 }]
 *
 * _.castArray('abc');
 * // => ['abc']
 *
 * _.castArray(null);
 * // => [null]
 *
 * _.castArray(undefined);
 * // => [undefined]
 *
 * _.castArray();
 * // => []
 *
 * var array = [1, 2, 3];
 * console.log(_.castArray(array) === array);
 * // => true
 */
function castArray() {
  if (!arguments.length) {
    return [];
  }
  var value = arguments[0];
  return isArray(value) ? value : [value];
}

module.exports = castArray;


/***/ }),

/***/ "../../node_modules/lodash/_castSlice.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseSlice = __webpack_require__("../../node_modules/lodash/_baseSlice.js");

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ "../../node_modules/lodash/_cloneArrayBuffer.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Uint8Array = __webpack_require__("../../node_modules/lodash/_Uint8Array.js");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "../../node_modules/lodash/_cloneBuffer.js":
/***/ ((module, exports, __webpack_require__) => {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__("../../node_modules/lodash/_root.js");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ "../../node_modules/lodash/_cloneTypedArray.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var cloneArrayBuffer = __webpack_require__("../../node_modules/lodash/_cloneArrayBuffer.js");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "../../node_modules/lodash/_copyArray.js":
/***/ ((module) => {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "../../node_modules/lodash/_copyObject.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assignValue = __webpack_require__("../../node_modules/lodash/_assignValue.js"),
    baseAssignValue = __webpack_require__("../../node_modules/lodash/_baseAssignValue.js");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "../../node_modules/lodash/_copySymbols.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__("../../node_modules/lodash/_copyObject.js"),
    getSymbols = __webpack_require__("../../node_modules/lodash/_getSymbols.js");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ "../../node_modules/lodash/_copySymbolsIn.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__("../../node_modules/lodash/_copyObject.js"),
    getSymbolsIn = __webpack_require__("../../node_modules/lodash/_getSymbolsIn.js");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ "../../node_modules/lodash/_createAssigner.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseRest = __webpack_require__("../../node_modules/lodash/_baseRest.js"),
    isIterateeCall = __webpack_require__("../../node_modules/lodash/_isIterateeCall.js");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "../../node_modules/lodash/_createBaseFor.js":
/***/ ((module) => {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "../../node_modules/lodash/_createPadding.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseRepeat = __webpack_require__("../../node_modules/lodash/_baseRepeat.js"),
    baseToString = __webpack_require__("../../node_modules/lodash/_baseToString.js"),
    castSlice = __webpack_require__("../../node_modules/lodash/_castSlice.js"),
    hasUnicode = __webpack_require__("../../node_modules/lodash/_hasUnicode.js"),
    stringSize = __webpack_require__("../../node_modules/lodash/_stringSize.js"),
    stringToArray = __webpack_require__("../../node_modules/lodash/_stringToArray.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : baseToString(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
  return hasUnicode(chars)
    ? castSlice(stringToArray(result), 0, length).join('')
    : result.slice(0, length);
}

module.exports = createPadding;


/***/ }),

/***/ "../../node_modules/lodash/_createRange.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseRange = __webpack_require__("../../node_modules/lodash/_baseRange.js"),
    isIterateeCall = __webpack_require__("../../node_modules/lodash/_isIterateeCall.js"),
    toFinite = __webpack_require__("../../node_modules/lodash/toFinite.js");

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ "../../node_modules/lodash/_createSet.js":
/***/ ((module) => {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ "../../node_modules/lodash/_customOmitClone.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isPlainObject = __webpack_require__("../../node_modules/lodash/isPlainObject.js");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),

/***/ "../../node_modules/lodash/_defineProperty.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getNative = __webpack_require__("../../node_modules/lodash/_getNative.js");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "../../node_modules/lodash/_flatRest.js":
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../../node_modules/lodash/_freeGlobal.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ "../../node_modules/lodash/_getAllKeys.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__("../../node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "../../node_modules/lodash/_getAllKeysIn.js":
/***/ ((module) => {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "../../node_modules/lodash/_getNative.js":
/***/ ((module) => {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "../../node_modules/lodash/_getPrototype.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__("../../node_modules/lodash/_overArg.js");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "../../node_modules/lodash/_getSymbols.js":
/***/ ((module) => {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "../../node_modules/lodash/_getSymbolsIn.js":
/***/ ((module) => {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "../../node_modules/lodash/_getTag.js":
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "../../node_modules/lodash/_hasUnicode.js":
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../../node_modules/lodash/_initCloneArray.js":
/***/ ((module) => {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ "../../node_modules/lodash/_initCloneByTag.js":
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../../node_modules/lodash/_initCloneObject.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseCreate = __webpack_require__("../../node_modules/lodash/_baseCreate.js"),
    getPrototype = __webpack_require__("../../node_modules/lodash/_getPrototype.js"),
    isPrototype = __webpack_require__("../../node_modules/lodash/_isPrototype.js");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "../../node_modules/lodash/_isIndex.js":
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "../../node_modules/lodash/_isIterateeCall.js":
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../../node_modules/lodash/_isPrototype.js":
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../../node_modules/lodash/_listCacheClear.js":
/***/ ((module) => {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "../../node_modules/lodash/_listCacheDelete.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__("../../node_modules/lodash/_assocIndexOf.js");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "../../node_modules/lodash/_listCacheGet.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__("../../node_modules/lodash/_assocIndexOf.js");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "../../node_modules/lodash/_listCacheHas.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__("../../node_modules/lodash/_assocIndexOf.js");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "../../node_modules/lodash/_listCacheSet.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var assocIndexOf = __webpack_require__("../../node_modules/lodash/_assocIndexOf.js");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "../../node_modules/lodash/_overArg.js":
/***/ ((module) => {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "../../node_modules/lodash/_overRest.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var apply = __webpack_require__("../../node_modules/lodash/_apply.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "../../node_modules/lodash/_parent.js":
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../../node_modules/lodash/_root.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var freeGlobal = __webpack_require__("../../node_modules/lodash/_freeGlobal.js");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "../../node_modules/lodash/_safeGet.js":
/***/ ((module) => {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "../../node_modules/lodash/_setToArray.js":
/***/ ((module) => {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "../../node_modules/lodash/_setToString.js":
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../../node_modules/lodash/_shuffleSelf.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseRandom = __webpack_require__("../../node_modules/lodash/_baseRandom.js");

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),

/***/ "../../node_modules/lodash/_stringSize.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var asciiSize = __webpack_require__("../../node_modules/lodash/_asciiSize.js"),
    hasUnicode = __webpack_require__("../../node_modules/lodash/_hasUnicode.js"),
    unicodeSize = __webpack_require__("../../node_modules/lodash/_unicodeSize.js");

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),

/***/ "../../node_modules/lodash/_stringToArray.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var asciiToArray = __webpack_require__("../../node_modules/lodash/_asciiToArray.js"),
    hasUnicode = __webpack_require__("../../node_modules/lodash/_hasUnicode.js"),
    unicodeToArray = __webpack_require__("../../node_modules/lodash/_unicodeToArray.js");

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ "../../node_modules/lodash/_toKey.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isSymbol = __webpack_require__("../../node_modules/lodash/isSymbol.js");

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ "../../node_modules/lodash/_unicodeSize.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseProperty = __webpack_require__("../../node_modules/lodash/_baseProperty.js");

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),

/***/ "../../node_modules/lodash/_unicodeToArray.js":
/***/ ((module) => {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ "../../node_modules/lodash/before.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toInteger = __webpack_require__("../../node_modules/lodash/toInteger.js");

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

module.exports = before;


/***/ }),

/***/ "../../node_modules/lodash/cloneDeep.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseClone = __webpack_require__("../../node_modules/lodash/_baseClone.js");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ "../../node_modules/lodash/compact.js":
/***/ ((module) => {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),

/***/ "../../node_modules/lodash/eq.js":
/***/ ((module) => {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "../../node_modules/lodash/identity.js":
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../../node_modules/lodash/isArguments.js":
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../../node_modules/lodash/isArray.js":
/***/ ((module) => {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "../../node_modules/lodash/isArrayLike.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isFunction = __webpack_require__("../../node_modules/lodash/isFunction.js"),
    isLength = __webpack_require__("../../node_modules/lodash/isLength.js");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "../../node_modules/lodash/isArrayLikeObject.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var isArrayLike = __webpack_require__("../../node_modules/lodash/isArrayLike.js"),
    isObjectLike = __webpack_require__("../../node_modules/lodash/isObjectLike.js");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "../../node_modules/lodash/isBuffer.js":
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../../node_modules/lodash/isFunction.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__("../../node_modules/lodash/_baseGetTag.js"),
    isObject = __webpack_require__("../../node_modules/lodash/isObject.js");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "../../node_modules/lodash/isLength.js":
/***/ ((module) => {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "../../node_modules/lodash/isMap.js":
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../../node_modules/lodash/isObject.js":
/***/ ((module) => {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "../../node_modules/lodash/isObjectLike.js":
/***/ ((module) => {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "../../node_modules/lodash/isPlainObject.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__("../../node_modules/lodash/_baseGetTag.js"),
    getPrototype = __webpack_require__("../../node_modules/lodash/_getPrototype.js"),
    isObjectLike = __webpack_require__("../../node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "../../node_modules/lodash/isSet.js":
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../../node_modules/lodash/isString.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseGetTag = __webpack_require__("../../node_modules/lodash/_baseGetTag.js"),
    isArray = __webpack_require__("../../node_modules/lodash/isArray.js"),
    isObjectLike = __webpack_require__("../../node_modules/lodash/isObjectLike.js");

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ "../../node_modules/lodash/isSymbol.js":
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../../node_modules/lodash/isTypedArray.js":
/***/ ((module) => {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "../../node_modules/lodash/keys.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var overArg = __webpack_require__("../../node_modules/lodash/_overArg.js");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "../../node_modules/lodash/keysIn.js":
/***/ ((module) => {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "../../node_modules/lodash/last.js":
/***/ ((module) => {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ "../../node_modules/lodash/merge.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseMerge = __webpack_require__("../../node_modules/lodash/_baseMerge.js"),
    createAssigner = __webpack_require__("../../node_modules/lodash/_createAssigner.js");

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ "../../node_modules/lodash/min.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseExtremum = __webpack_require__("../../node_modules/lodash/_baseExtremum.js"),
    baseLt = __webpack_require__("../../node_modules/lodash/_baseLt.js"),
    identity = __webpack_require__("../../node_modules/lodash/identity.js");

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseLt)
    : undefined;
}

module.exports = min;


/***/ }),

/***/ "../../node_modules/lodash/omit.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayMap = __webpack_require__("../../node_modules/lodash/_arrayMap.js"),
    baseClone = __webpack_require__("../../node_modules/lodash/_baseClone.js"),
    baseUnset = __webpack_require__("../../node_modules/lodash/_baseUnset.js"),
    castPath = __webpack_require__("../../node_modules/lodash/_castPath.js"),
    copyObject = __webpack_require__("../../node_modules/lodash/_copyObject.js"),
    customOmitClone = __webpack_require__("../../node_modules/lodash/_customOmitClone.js"),
    flatRest = __webpack_require__("../../node_modules/lodash/_flatRest.js"),
    getAllKeysIn = __webpack_require__("../../node_modules/lodash/_getAllKeysIn.js");

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),

/***/ "../../node_modules/lodash/once.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var before = __webpack_require__("../../node_modules/lodash/before.js");

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

module.exports = once;


/***/ }),

/***/ "../../node_modules/lodash/padEnd.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createPadding = __webpack_require__("../../node_modules/lodash/_createPadding.js"),
    stringSize = __webpack_require__("../../node_modules/lodash/_stringSize.js"),
    toInteger = __webpack_require__("../../node_modules/lodash/toInteger.js"),
    toString = __webpack_require__("../../node_modules/lodash/toString.js");

/**
 * Pads `string` on the right side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padEnd('abc', 6);
 * // => 'abc   '
 *
 * _.padEnd('abc', 6, '_-');
 * // => 'abc_-_'
 *
 * _.padEnd('abc', 3);
 * // => 'abc'
 */
function padEnd(string, length, chars) {
  string = toString(string);
  length = toInteger(length);

  var strLength = length ? stringSize(string) : 0;
  return (length && strLength < length)
    ? (string + createPadding(length - strLength, chars))
    : string;
}

module.exports = padEnd;


/***/ }),

/***/ "../../node_modules/lodash/random.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseRandom = __webpack_require__("../../node_modules/lodash/_baseRandom.js"),
    isIterateeCall = __webpack_require__("../../node_modules/lodash/_isIterateeCall.js"),
    toFinite = __webpack_require__("../../node_modules/lodash/toFinite.js");

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min,
    nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return baseRandom(lower, upper);
}

module.exports = random;


/***/ }),

/***/ "../../node_modules/lodash/range.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createRange = __webpack_require__("../../node_modules/lodash/_createRange.js");

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ "../../node_modules/lodash/sampleSize.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseClamp = __webpack_require__("../../node_modules/lodash/_baseClamp.js"),
    copyArray = __webpack_require__("../../node_modules/lodash/_copyArray.js"),
    shuffleSelf = __webpack_require__("../../node_modules/lodash/_shuffleSelf.js");

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

module.exports = arraySampleSize;


/***/ }),

/***/ "../../node_modules/lodash/set.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseSet = __webpack_require__("../../node_modules/lodash/_baseSet.js");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),

/***/ "../../node_modules/lodash/shuffle.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyArray = __webpack_require__("../../node_modules/lodash/_copyArray.js"),
    shuffleSelf = __webpack_require__("../../node_modules/lodash/_shuffleSelf.js");

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

module.exports = arrayShuffle;


/***/ }),

/***/ "../../node_modules/lodash/toFinite.js":
/***/ ((module) => {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "../../node_modules/lodash/toInteger.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toFinite = __webpack_require__("../../node_modules/lodash/toFinite.js");

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ "../../node_modules/lodash/toPlainObject.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var copyObject = __webpack_require__("../../node_modules/lodash/_copyObject.js"),
    keysIn = __webpack_require__("../../node_modules/lodash/keysIn.js");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "../../node_modules/lodash/toString.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseToString = __webpack_require__("../../node_modules/lodash/_baseToString.js");

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ "../../node_modules/lodash/uniq.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseUniq = __webpack_require__("../../node_modules/lodash/_baseUniq.js");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ "../../node_modules/lodash/uniqueId.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var toString = __webpack_require__("../../node_modules/lodash/toString.js");

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),

/***/ "../../node_modules/lodash/without.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var baseDifference = __webpack_require__("../../node_modules/lodash/_baseDifference.js"),
    baseRest = __webpack_require__("../../node_modules/lodash/_baseRest.js"),
    isArrayLikeObject = __webpack_require__("../../node_modules/lodash/isArrayLikeObject.js");

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),

/***/ "../../node_modules/map-age-cleaner/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
const p_defer_1 = __importDefault(__webpack_require__("../../node_modules/p-defer/index.js"));
function mapAgeCleaner(map, property = 'maxAge') {
    let processingKey;
    let processingTimer;
    let processingDeferred;
    const cleanup = () => __awaiter(this, void 0, void 0, function* () {
        if (processingKey !== undefined) {
            // If we are already processing an item, we can safely exit
            return;
        }
        const setupTimer = (item) => __awaiter(this, void 0, void 0, function* () {
            processingDeferred = p_defer_1.default();
            const delay = item[1][property] - Date.now();
            if (delay <= 0) {
                // Remove the item immediately if the delay is equal to or below 0
                map.delete(item[0]);
                processingDeferred.resolve();
                return;
            }
            // Keep track of the current processed key
            processingKey = item[0];
            processingTimer = setTimeout(() => {
                // Remove the item when the timeout fires
                map.delete(item[0]);
                if (processingDeferred) {
                    processingDeferred.resolve();
                }
            }, delay);
            // tslint:disable-next-line:strict-type-predicates
            if (typeof processingTimer.unref === 'function') {
                // Don't hold up the process from exiting
                processingTimer.unref();
            }
            return processingDeferred.promise;
        });
        try {
            for (const entry of map) {
                yield setupTimer(entry);
            }
        }
        catch (_a) {
            // Do nothing if an error occurs, this means the timer was cleaned up and we should stop processing
        }
        processingKey = undefined;
    });
    const reset = () => {
        processingKey = undefined;
        if (processingTimer !== undefined) {
            clearTimeout(processingTimer);
            processingTimer = undefined;
        }
        if (processingDeferred !== undefined) { // tslint:disable-line:early-exit
            processingDeferred.reject(undefined);
            processingDeferred = undefined;
        }
    };
    const originalSet = map.set.bind(map);
    map.set = (key, value) => {
        if (map.has(key)) {
            // If the key already exist, remove it so we can add it back at the end of the map.
            map.delete(key);
        }
        // Call the original `map.set`
        const result = originalSet(key, value);
        // If we are already processing a key and the key added is the current processed key, stop processing it
        if (processingKey && processingKey === key) {
            reset();
        }
        // Always run the cleanup method in case it wasn't started yet
        cleanup(); // tslint:disable-line:no-floating-promises
        return result;
    };
    cleanup(); // tslint:disable-line:no-floating-promises
    return map;
}
exports["default"] = mapAgeCleaner;
// Add support for CJS
module.exports = mapAgeCleaner;
module.exports["default"] = mapAgeCleaner;


/***/ }),

/***/ "../../node_modules/md5.js/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var HashBase = __webpack_require__("../../node_modules/hash-base/index.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),

/***/ "../../node_modules/miller-rabin/lib/mr.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var bn = __webpack_require__("../../node_modules/miller-rabin/node_modules/bn.js/lib/bn.js");
var brorand = __webpack_require__("../../node_modules/brorand/index.js");

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),

/***/ "../../node_modules/miller-rabin/node_modules/bn.js/lib/bn.js":
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ "../../node_modules/mimic-fn/index.js":
/***/ ((module) => {

"use strict";


const copyProperty = (to, from, property, ignoreNonConfigurable) => {
	// `Function#length` should reflect the parameters of `to` not `from` since we keep its body.
	// `Function#prototype` is non-writable and non-configurable so can never be modified.
	if (property === 'length' || property === 'prototype') {
		return;
	}

	// `Function#arguments` and `Function#caller` should not be copied. They were reported to be present in `Reflect.ownKeys` for some devices in React Native (#41), so we explicitly ignore them here.
	if (property === 'arguments' || property === 'caller') {
		return;
	}

	const toDescriptor = Object.getOwnPropertyDescriptor(to, property);
	const fromDescriptor = Object.getOwnPropertyDescriptor(from, property);

	if (!canCopyProperty(toDescriptor, fromDescriptor) && ignoreNonConfigurable) {
		return;
	}

	Object.defineProperty(to, property, fromDescriptor);
};

// `Object.defineProperty()` throws if the property exists, is not configurable and either:
//  - one its descriptors is changed
//  - it is non-writable and its value is changed
const canCopyProperty = function (toDescriptor, fromDescriptor) {
	return toDescriptor === undefined || toDescriptor.configurable || (
		toDescriptor.writable === fromDescriptor.writable &&
		toDescriptor.enumerable === fromDescriptor.enumerable &&
		toDescriptor.configurable === fromDescriptor.configurable &&
		(toDescriptor.writable || toDescriptor.value === fromDescriptor.value)
	);
};

const changePrototype = (to, from) => {
	const fromPrototype = Object.getPrototypeOf(from);
	if (fromPrototype === Object.getPrototypeOf(to)) {
		return;
	}

	Object.setPrototypeOf(to, fromPrototype);
};

const wrappedToString = (withName, fromBody) => `/* Wrapped ${withName}*/\n${fromBody}`;

const toStringDescriptor = Object.getOwnPropertyDescriptor(Function.prototype, 'toString');
const toStringName = Object.getOwnPropertyDescriptor(Function.prototype.toString, 'name');

// We call `from.toString()` early (not lazily) to ensure `from` can be garbage collected.
// We use `bind()` instead of a closure for the same reason.
// Calling `from.toString()` early also allows caching it in case `to.toString()` is called several times.
const changeToString = (to, from, name) => {
	const withName = name === '' ? '' : `with ${name.trim()}() `;
	const newToString = wrappedToString.bind(null, withName, from.toString());
	// Ensure `to.toString.toString` is non-enumerable and has the same `same`
	Object.defineProperty(newToString, 'name', toStringName);
	Object.defineProperty(to, 'toString', {...toStringDescriptor, value: newToString});
};

const mimicFn = (to, from, {ignoreNonConfigurable = false} = {}) => {
	const {name} = to;

	for (const property of Reflect.ownKeys(from)) {
		copyProperty(to, from, property, ignoreNonConfigurable);
	}

	changePrototype(to, from);
	changeToString(to, from, name);

	return to;
};

module.exports = mimicFn;


/***/ }),

/***/ "../../node_modules/minimalistic-assert/index.js":
/***/ ((module) => {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),

/***/ "../../node_modules/minimalistic-crypto-utils/lib/utils.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),

/***/ "../../node_modules/p-defer/index.js":
/***/ ((module) => {

"use strict";

module.exports = () => {
	const ret = {};

	ret.promise = new Promise((resolve, reject) => {
		ret.resolve = resolve;
		ret.reject = reject;
	});

	return ret;
};


/***/ }),

/***/ "../../node_modules/p-limit/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const pTry = __webpack_require__("../../node_modules/p-try/index.js");

const pLimit = concurrency => {
	if (!((Number.isInteger(concurrency) || concurrency === Infinity) && concurrency > 0)) {
		return Promise.reject(new TypeError('Expected `concurrency` to be a number from 1 and up'));
	}

	const queue = [];
	let activeCount = 0;

	const next = () => {
		activeCount--;

		if (queue.length > 0) {
			queue.shift()();
		}
	};

	const run = (fn, resolve, ...args) => {
		activeCount++;

		const result = pTry(fn, ...args);

		resolve(result);

		result.then(next, next);
	};

	const enqueue = (fn, resolve, ...args) => {
		if (activeCount < concurrency) {
			run(fn, resolve, ...args);
		} else {
			queue.push(run.bind(null, fn, resolve, ...args));
		}
	};

	const generator = (fn, ...args) => new Promise(resolve => enqueue(fn, resolve, ...args));
	Object.defineProperties(generator, {
		activeCount: {
			get: () => activeCount
		},
		pendingCount: {
			get: () => queue.length
		},
		clearQueue: {
			value: () => {
				queue.length = 0;
			}
		}
	});

	return generator;
};

module.exports = pLimit;
module.exports["default"] = pLimit;


/***/ }),

/***/ "../../node_modules/p-memoize/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const mimicFn = __webpack_require__("../../node_modules/mimic-fn/index.js");
const mapAgeCleaner = __webpack_require__("../../node_modules/map-age-cleaner/dist/index.js");
const pSettle = __webpack_require__("../../node_modules/p-settle/index.js");

const cacheStore = new WeakMap();

const pMemoize = (fn, {cachePromiseRejection = false, ...options} = {}) => {
	const {maxAge, cacheKey} = options;
	const cache = options.cache || new Map();

	if (Number.isSafeInteger(maxAge)) {
		mapAgeCleaner(cache);
	} else if (typeof maxAge !== 'undefined') {
		throw new TypeError('maxAge is not a safe integer.');
	}

	const memoized = async function (...arguments_) {
		const key = cacheKey ? cacheKey(arguments_) : arguments_[0];

		const cacheItem = cache.get(key);
		if (cacheItem) {
			return cacheItem.data;
		}

		const promise = fn.apply(this, arguments_);
		cache.set(key, {
			data: promise,
			// Ref. https://github.com/sindresorhus/p-memoize/issues/39#issuecomment-985301556
			maxAge: (2 ** 31) - 1
		});

		const [{reason}] = await pSettle([promise]);
		if (!cachePromiseRejection && reason) {
			cache.delete(key);
		} else if (maxAge) {
			// Promise fulfilled, so start the timer
			cache.set(key, {
				data: promise,
				maxAge: Date.now() + maxAge
			});
		}

		return promise;
	};

	mimicFn(memoized, fn);
	cacheStore.set(memoized, cache);

	return memoized;
};

module.exports = pMemoize;

module.exports.clear = memoized => {
	if (!cacheStore.has(memoized)) {
		throw new Error('Can\'t clear a function that was not memoized!');
	}

	const cache = cacheStore.get(memoized);

	if (typeof cache.clear !== 'function') {
		throw new TypeError('The cache Map can\'t be cleared!');
	}

	cache.clear();
};


/***/ }),

/***/ "../../node_modules/p-reflect/index.js":
/***/ ((module) => {

"use strict";


const pReflect = async promise => {
	try {
		const value = await promise;
		return {
			isFulfilled: true,
			isRejected: false,
			value
		};
	} catch (error) {
		return {
			isFulfilled: false,
			isRejected: true,
			reason: error
		};
	}
};

module.exports = pReflect;
// TODO: Remove this for the next major release
module.exports["default"] = pReflect;


/***/ }),

/***/ "../../node_modules/p-settle/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const pReflect = __webpack_require__("../../node_modules/p-reflect/index.js");
const pLimit = __webpack_require__("../../node_modules/p-limit/index.js");

module.exports = async (array, options = {}) => {
	const {concurrency = Infinity} = options;
	const limit = pLimit(concurrency);

	return Promise.all(array.map(element => {
		if (element && typeof element.then === 'function') { // eslint-disable-line promise/prefer-await-to-then
			return pReflect(element);
		}

		if (typeof element === 'function') {
			return pReflect(limit(() => element()));
		}

		return pReflect(Promise.resolve(element));
	}));
};


/***/ }),

/***/ "../../node_modules/p-throttle/index.js":
/***/ ((module) => {

"use strict";


class AbortError extends Error {
	constructor() {
		super('Throttled function aborted');
		this.name = 'AbortError';
	}
}

const pThrottle = ({limit, interval, strict}) => {
	if (!Number.isFinite(limit)) {
		throw new TypeError('Expected `limit` to be a finite number');
	}

	if (!Number.isFinite(interval)) {
		throw new TypeError('Expected `interval` to be a finite number');
	}

	const queue = new Map();

	let currentTick = 0;
	let activeCount = 0;

	function windowedDelay() {
		const now = Date.now();

		if ((now - currentTick) > interval) {
			activeCount = 1;
			currentTick = now;
			return 0;
		}

		if (activeCount < limit) {
			activeCount++;
		} else {
			currentTick += interval;
			activeCount = 1;
		}

		return currentTick - now;
	}

	const strictTicks = [];

	function strictDelay() {
		const now = Date.now();

		if (strictTicks.length < limit) {
			strictTicks.push(now);
			return 0;
		}

		const earliestTime = strictTicks.shift() + interval;

		if (now >= earliestTime) {
			strictTicks.push(now);
			return 0;
		}

		strictTicks.push(earliestTime);
		return earliestTime - now;
	}

	const getDelay = strict ? strictDelay : windowedDelay;

	return function_ => {
		const throttled = function (...args) {
			if (!throttled.isEnabled) {
				return (async () => function_.apply(this, args))();
			}

			let timeout;
			return new Promise((resolve, reject) => {
				const execute = () => {
					resolve(function_.apply(this, args));
					queue.delete(timeout);
				};

				timeout = setTimeout(execute, getDelay());

				queue.set(timeout, reject);
			});
		};

		throttled.abort = () => {
			for (const timeout of queue.keys()) {
				clearTimeout(timeout);
				queue.get(timeout)(new AbortError());
			}

			queue.clear();
			strictTicks.splice(0, strictTicks.length);
		};

		throttled.isEnabled = true;

		return throttled;
	};
};

module.exports = pThrottle;
module.exports.AbortError = AbortError;


/***/ }),

/***/ "../../node_modules/p-try/index.js":
/***/ ((module) => {

"use strict";


const pTry = (fn, ...arguments_) => new Promise(resolve => {
	resolve(fn(...arguments_));
});

module.exports = pTry;
// TODO: remove this in the next major version
module.exports["default"] = pTry;


/***/ }),

/***/ "../../node_modules/pako/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Top level file is just a mixin of submodules & constants


var assign    = (__webpack_require__("../../node_modules/pako/lib/utils/common.js").assign);

var deflate   = __webpack_require__("../../node_modules/pako/lib/deflate.js");
var inflate   = __webpack_require__("../../node_modules/pako/lib/inflate.js");
var constants = __webpack_require__("../../node_modules/pako/lib/zlib/constants.js");

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;


/***/ }),

/***/ "../../node_modules/pako/lib/deflate.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";



var zlib_deflate = __webpack_require__("../../node_modules/pako/lib/zlib/deflate.js");
var utils        = __webpack_require__("../../node_modules/pako/lib/utils/common.js");
var strings      = __webpack_require__("../../node_modules/pako/lib/utils/strings.js");
var msg          = __webpack_require__("../../node_modules/pako/lib/zlib/messages.js");
var ZStream      = __webpack_require__("../../node_modules/pako/lib/zlib/zstream.js");

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || msg[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;


/***/ }),

/***/ "../../node_modules/pako/lib/inflate.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";



var zlib_inflate = __webpack_require__("../../node_modules/pako/lib/zlib/inflate.js");
var utils        = __webpack_require__("../../node_modules/pako/lib/utils/common.js");
var strings      = __webpack_require__("../../node_modules/pako/lib/utils/strings.js");
var c            = __webpack_require__("../../node_modules/pako/lib/zlib/constants.js");
var msg          = __webpack_require__("../../node_modules/pako/lib/zlib/messages.js");
var ZStream      = __webpack_require__("../../node_modules/pako/lib/zlib/zstream.js");
var GZheader     = __webpack_require__("../../node_modules/pako/lib/zlib/gzheader.js");

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);

  // Setup dictionary
  if (opt.dictionary) {
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) { //In raw mode we need to set the dictionary early
      status = zlib_inflate.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== c.Z_OK) {
        throw new Error(msg[status]);
      }
    }
  }
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status === c.Z_NEED_DICT && dictionary) {
      status = zlib_inflate.inflateSetDictionary(this.strm, dictionary);
    }

    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 aligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg || msg[inflator.err]; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;


/***/ }),

/***/ "../../node_modules/pako/lib/utils/common.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";



var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);


/***/ }),

/***/ "../../node_modules/pako/lib/utils/strings.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// String encode/decode helpers



var utils = __webpack_require__("../../node_modules/pako/lib/utils/common.js");


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/adler32.js":
/***/ ((module) => {

"use strict";


// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/constants.js":
/***/ ((module) => {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/crc32.js":
/***/ ((module) => {

"use strict";


// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/deflate.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = __webpack_require__("../../node_modules/pako/lib/utils/common.js");
var trees   = __webpack_require__("../../node_modules/pako/lib/zlib/trees.js");
var adler32 = __webpack_require__("../../node_modules/pako/lib/zlib/adler32.js");
var crc32   = __webpack_require__("../../node_modules/pako/lib/zlib/crc32.js");
var msg     = __webpack_require__("../../node_modules/pako/lib/zlib/messages.js");

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/gzheader.js":
/***/ ((module) => {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/inffast.js":
/***/ ((module) => {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/inflate.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = __webpack_require__("../../node_modules/pako/lib/utils/common.js");
var adler32       = __webpack_require__("../../node_modules/pako/lib/zlib/adler32.js");
var crc32         = __webpack_require__("../../node_modules/pako/lib/zlib/crc32.js");
var inflate_fast  = __webpack_require__("../../node_modules/pako/lib/zlib/inffast.js");
var inflate_table = __webpack_require__("../../node_modules/pako/lib/zlib/inftrees.js");

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/inftrees.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = __webpack_require__("../../node_modules/pako/lib/utils/common.js");

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/messages.js":
/***/ ((module) => {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/trees.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

var utils = __webpack_require__("../../node_modules/pako/lib/utils/common.js");

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;


/***/ }),

/***/ "../../node_modules/pako/lib/zlib/zstream.js":
/***/ ((module) => {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;


/***/ }),

/***/ "../../node_modules/parse-asn1/asn1.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__("../../node_modules/asn1.js/lib/asn1.js")

exports.certificate = __webpack_require__("../../node_modules/parse-asn1/certificate.js")

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),

/***/ "../../node_modules/parse-asn1/certificate.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__("../../node_modules/asn1.js/lib/asn1.js")

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),

/***/ "../../node_modules/parse-asn1/fixProc.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m
var evp = __webpack_require__("../../node_modules/evp_bytestokey/index.js")
var ciphers = __webpack_require__("../../node_modules/browserify-aes/browser.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}


/***/ }),

/***/ "../../node_modules/parse-asn1/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var asn1 = __webpack_require__("../../node_modules/parse-asn1/asn1.js")
var aesid = __webpack_require__("../../node_modules/parse-asn1/aesid.json")
var fixProc = __webpack_require__("../../node_modules/parse-asn1/fixProc.js")
var ciphers = __webpack_require__("../../node_modules/browserify-aes/browser.js")
var compat = __webpack_require__("../../node_modules/pbkdf2/browser.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}


/***/ }),

/***/ "../../node_modules/path-browserify/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
  }
}

// Resolves . and .. elements in a path with directory names
function normalizeStringPosix(path, allowAboveRoot) {
  var res = '';
  var lastSegmentLength = 0;
  var lastSlash = -1;
  var dots = 0;
  var code;
  for (var i = 0; i <= path.length; ++i) {
    if (i < path.length)
      code = path.charCodeAt(i);
    else if (code === 47 /*/*/)
      break;
    else
      code = 47 /*/*/;
    if (code === 47 /*/*/) {
      if (lastSlash === i - 1 || dots === 1) {
        // NOOP
      } else if (lastSlash !== i - 1 && dots === 2) {
        if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/ || res.charCodeAt(res.length - 2) !== 46 /*.*/) {
          if (res.length > 2) {
            var lastSlashIndex = res.lastIndexOf('/');
            if (lastSlashIndex !== res.length - 1) {
              if (lastSlashIndex === -1) {
                res = '';
                lastSegmentLength = 0;
              } else {
                res = res.slice(0, lastSlashIndex);
                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
              }
              lastSlash = i;
              dots = 0;
              continue;
            }
          } else if (res.length === 2 || res.length === 1) {
            res = '';
            lastSegmentLength = 0;
            lastSlash = i;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          if (res.length > 0)
            res += '/..';
          else
            res = '..';
          lastSegmentLength = 2;
        }
      } else {
        if (res.length > 0)
          res += '/' + path.slice(lastSlash + 1, i);
        else
          res = path.slice(lastSlash + 1, i);
        lastSegmentLength = i - lastSlash - 1;
      }
      lastSlash = i;
      dots = 0;
    } else if (code === 46 /*.*/ && dots !== -1) {
      ++dots;
    } else {
      dots = -1;
    }
  }
  return res;
}

function _format(sep, pathObject) {
  var dir = pathObject.dir || pathObject.root;
  var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
  if (!dir) {
    return base;
  }
  if (dir === pathObject.root) {
    return dir + base;
  }
  return dir + sep + base;
}

var posix = {
  // path.resolve([from ...], to)
  resolve: function resolve() {
    var resolvedPath = '';
    var resolvedAbsolute = false;
    var cwd;

    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path;
      if (i >= 0)
        path = arguments[i];
      else {
        if (cwd === undefined)
          cwd = process.cwd();
        path = cwd;
      }

      assertPath(path);

      // Skip empty entries
      if (path.length === 0) {
        continue;
      }

      resolvedPath = path + '/' + resolvedPath;
      resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/;
    }

    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)

    // Normalize the path
    resolvedPath = normalizeStringPosix(resolvedPath, !resolvedAbsolute);

    if (resolvedAbsolute) {
      if (resolvedPath.length > 0)
        return '/' + resolvedPath;
      else
        return '/';
    } else if (resolvedPath.length > 0) {
      return resolvedPath;
    } else {
      return '.';
    }
  },

  normalize: function normalize(path) {
    assertPath(path);

    if (path.length === 0) return '.';

    var isAbsolute = path.charCodeAt(0) === 47 /*/*/;
    var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/;

    // Normalize the path
    path = normalizeStringPosix(path, !isAbsolute);

    if (path.length === 0 && !isAbsolute) path = '.';
    if (path.length > 0 && trailingSeparator) path += '/';

    if (isAbsolute) return '/' + path;
    return path;
  },

  isAbsolute: function isAbsolute(path) {
    assertPath(path);
    return path.length > 0 && path.charCodeAt(0) === 47 /*/*/;
  },

  join: function join() {
    if (arguments.length === 0)
      return '.';
    var joined;
    for (var i = 0; i < arguments.length; ++i) {
      var arg = arguments[i];
      assertPath(arg);
      if (arg.length > 0) {
        if (joined === undefined)
          joined = arg;
        else
          joined += '/' + arg;
      }
    }
    if (joined === undefined)
      return '.';
    return posix.normalize(joined);
  },

  relative: function relative(from, to) {
    assertPath(from);
    assertPath(to);

    if (from === to) return '';

    from = posix.resolve(from);
    to = posix.resolve(to);

    if (from === to) return '';

    // Trim any leading backslashes
    var fromStart = 1;
    for (; fromStart < from.length; ++fromStart) {
      if (from.charCodeAt(fromStart) !== 47 /*/*/)
        break;
    }
    var fromEnd = from.length;
    var fromLen = fromEnd - fromStart;

    // Trim any leading backslashes
    var toStart = 1;
    for (; toStart < to.length; ++toStart) {
      if (to.charCodeAt(toStart) !== 47 /*/*/)
        break;
    }
    var toEnd = to.length;
    var toLen = toEnd - toStart;

    // Compare paths to find the longest common path from root
    var length = fromLen < toLen ? fromLen : toLen;
    var lastCommonSep = -1;
    var i = 0;
    for (; i <= length; ++i) {
      if (i === length) {
        if (toLen > length) {
          if (to.charCodeAt(toStart + i) === 47 /*/*/) {
            // We get here if `from` is the exact base path for `to`.
            // For example: from='/foo/bar'; to='/foo/bar/baz'
            return to.slice(toStart + i + 1);
          } else if (i === 0) {
            // We get here if `from` is the root
            // For example: from='/'; to='/foo'
            return to.slice(toStart + i);
          }
        } else if (fromLen > length) {
          if (from.charCodeAt(fromStart + i) === 47 /*/*/) {
            // We get here if `to` is the exact base path for `from`.
            // For example: from='/foo/bar/baz'; to='/foo/bar'
            lastCommonSep = i;
          } else if (i === 0) {
            // We get here if `to` is the root.
            // For example: from='/foo'; to='/'
            lastCommonSep = 0;
          }
        }
        break;
      }
      var fromCode = from.charCodeAt(fromStart + i);
      var toCode = to.charCodeAt(toStart + i);
      if (fromCode !== toCode)
        break;
      else if (fromCode === 47 /*/*/)
        lastCommonSep = i;
    }

    var out = '';
    // Generate the relative path based on the path difference between `to`
    // and `from`
    for (i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i) {
      if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/) {
        if (out.length === 0)
          out += '..';
        else
          out += '/..';
      }
    }

    // Lastly, append the rest of the destination (`to`) path that comes after
    // the common path parts
    if (out.length > 0)
      return out + to.slice(toStart + lastCommonSep);
    else {
      toStart += lastCommonSep;
      if (to.charCodeAt(toStart) === 47 /*/*/)
        ++toStart;
      return to.slice(toStart);
    }
  },

  _makeLong: function _makeLong(path) {
    return path;
  },

  dirname: function dirname(path) {
    assertPath(path);
    if (path.length === 0) return '.';
    var code = path.charCodeAt(0);
    var hasRoot = code === 47 /*/*/;
    var end = -1;
    var matchedSlash = true;
    for (var i = path.length - 1; i >= 1; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          if (!matchedSlash) {
            end = i;
            break;
          }
        } else {
        // We saw the first non-path separator
        matchedSlash = false;
      }
    }

    if (end === -1) return hasRoot ? '/' : '.';
    if (hasRoot && end === 1) return '//';
    return path.slice(0, end);
  },

  basename: function basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    assertPath(path);

    var start = 0;
    var end = -1;
    var matchedSlash = true;
    var i;

    if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
      if (ext.length === path.length && ext === path) return '';
      var extIdx = ext.length - 1;
      var firstNonSlashEnd = -1;
      for (i = path.length - 1; i >= 0; --i) {
        var code = path.charCodeAt(i);
        if (code === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else {
          if (firstNonSlashEnd === -1) {
            // We saw the first non-path separator, remember this index in case
            // we need it if the extension ends up not matching
            matchedSlash = false;
            firstNonSlashEnd = i + 1;
          }
          if (extIdx >= 0) {
            // Try to match the explicit extension
            if (code === ext.charCodeAt(extIdx)) {
              if (--extIdx === -1) {
                // We matched the extension, so mark this as the end of our path
                // component
                end = i;
              }
            } else {
              // Extension does not match, so our result is the entire path
              // component
              extIdx = -1;
              end = firstNonSlashEnd;
            }
          }
        }
      }

      if (start === end) end = firstNonSlashEnd;else if (end === -1) end = path.length;
      return path.slice(start, end);
    } else {
      for (i = path.length - 1; i >= 0; --i) {
        if (path.charCodeAt(i) === 47 /*/*/) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now
            if (!matchedSlash) {
              start = i + 1;
              break;
            }
          } else if (end === -1) {
          // We saw the first non-path separator, mark this as the end of our
          // path component
          matchedSlash = false;
          end = i + 1;
        }
      }

      if (end === -1) return '';
      return path.slice(start, end);
    }
  },

  extname: function extname(path) {
    assertPath(path);
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;
    for (var i = path.length - 1; i >= 0; --i) {
      var code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1)
            startDot = i;
          else if (preDotState !== 1)
            preDotState = 1;
      } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
        // We saw a non-dot character immediately before the dot
        preDotState === 0 ||
        // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return '';
    }
    return path.slice(startDot, end);
  },

  format: function format(pathObject) {
    if (pathObject === null || typeof pathObject !== 'object') {
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
    }
    return _format('/', pathObject);
  },

  parse: function parse(path) {
    assertPath(path);

    var ret = { root: '', dir: '', base: '', ext: '', name: '' };
    if (path.length === 0) return ret;
    var code = path.charCodeAt(0);
    var isAbsolute = code === 47 /*/*/;
    var start;
    if (isAbsolute) {
      ret.root = '/';
      start = 1;
    } else {
      start = 0;
    }
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    var i = path.length - 1;

    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;

    // Get non-dir info
    for (; i >= start; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1) startDot = i;else if (preDotState !== 1) preDotState = 1;
        } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }

    if (startDot === -1 || end === -1 ||
    // We saw a non-dot character immediately before the dot
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly '..'
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      if (end !== -1) {
        if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);else ret.base = ret.name = path.slice(startPart, end);
      }
    } else {
      if (startPart === 0 && isAbsolute) {
        ret.name = path.slice(1, startDot);
        ret.base = path.slice(1, end);
      } else {
        ret.name = path.slice(startPart, startDot);
        ret.base = path.slice(startPart, end);
      }
      ret.ext = path.slice(startDot, end);
    }

    if (startPart > 0) ret.dir = path.slice(0, startPart - 1);else if (isAbsolute) ret.dir = '/';

    return ret;
  },

  sep: '/',
  delimiter: ':',
  win32: null,
  posix: null
};

posix.posix = posix;

module.exports = posix;


/***/ }),

/***/ "../../node_modules/pbkdf2/browser.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

exports.pbkdf2 = __webpack_require__("../../node_modules/pbkdf2/lib/async.js")
exports.pbkdf2Sync = __webpack_require__("../../node_modules/pbkdf2/lib/sync-browser.js")


/***/ }),

/***/ "../../node_modules/pbkdf2/lib/async.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var checkParameters = __webpack_require__("../../node_modules/pbkdf2/lib/precondition.js")
var defaultEncoding = __webpack_require__("../../node_modules/pbkdf2/lib/default-encoding.js")
var sync = __webpack_require__("../../node_modules/pbkdf2/lib/sync-browser.js")
var toBuffer = __webpack_require__("../../node_modules/pbkdf2/lib/to-buffer.js")

var ZERO_BUF
var subtle = __webpack_require__.g.crypto && __webpack_require__.g.crypto.subtle
var toBrowser = {
  sha: 'SHA-1',
  'sha-1': 'SHA-1',
  sha1: 'SHA-1',
  sha256: 'SHA-256',
  'sha-256': 'SHA-256',
  sha384: 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  sha512: 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (__webpack_require__.g.process && !__webpack_require__.g.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}
var nextTick
function getNextTick () {
  if (nextTick) {
    return nextTick
  }
  if (__webpack_require__.g.process && __webpack_require__.g.process.nextTick) {
    nextTick = __webpack_require__.g.process.nextTick
  } else if (__webpack_require__.g.queueMicrotask) {
    nextTick = __webpack_require__.g.queueMicrotask
  } else if (__webpack_require__.g.setImmediate) {
    nextTick = __webpack_require__.g.setImmediate
  } else {
    nextTick = __webpack_require__.g.setTimeout
  }
  return nextTick
}
function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    getNextTick()(function () {
      callback(null, out)
    })
  }, function (e) {
    getNextTick()(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof __webpack_require__.g.Promise !== 'function') {
    getNextTick()(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
    return
  }

  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}


/***/ }),

/***/ "../../node_modules/pbkdf2/lib/default-encoding.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
var defaultEncoding
/* istanbul ignore next */
if (__webpack_require__.g.process && __webpack_require__.g.process.browser) {
  defaultEncoding = 'utf-8'
} else if (__webpack_require__.g.process && __webpack_require__.g.process.version) {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
} else {
  defaultEncoding = 'utf-8'
}
module.exports = defaultEncoding


/***/ }),

/***/ "../../node_modules/pbkdf2/lib/precondition.js":
/***/ ((module) => {

var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

module.exports = function (iterations, keylen) {
  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}


/***/ }),

/***/ "../../node_modules/pbkdf2/lib/sync-browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var md5 = __webpack_require__("../../node_modules/create-hash/md5.js")
var RIPEMD160 = __webpack_require__("../../node_modules/ripemd160/index.js")
var sha = __webpack_require__("../../node_modules/sha.js/index.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var checkParameters = __webpack_require__("../../node_modules/pbkdf2/lib/precondition.js")
var defaultEncoding = __webpack_require__("../../node_modules/pbkdf2/lib/default-encoding.js")
var toBuffer = __webpack_require__("../../node_modules/pbkdf2/lib/to-buffer.js")

var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),

/***/ "../../node_modules/pbkdf2/lib/to-buffer.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

module.exports = function (thing, encoding, name) {
  if (Buffer.isBuffer(thing)) {
    return thing
  } else if (typeof thing === 'string') {
    return Buffer.from(thing, encoding)
  } else if (ArrayBuffer.isView(thing)) {
    return Buffer.from(thing.buffer)
  } else {
    throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
  }
}


/***/ }),

/***/ "../../node_modules/process/browser.js":
/***/ ((module) => {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "../../node_modules/public-encrypt/browser.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

exports.publicEncrypt = __webpack_require__("../../node_modules/public-encrypt/publicEncrypt.js")
exports.privateDecrypt = __webpack_require__("../../node_modules/public-encrypt/privateDecrypt.js")

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),

/***/ "../../node_modules/public-encrypt/mgf.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var createHash = __webpack_require__("../../node_modules/create-hash/browser.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),

/***/ "../../node_modules/public-encrypt/node_modules/bn.js/lib/bn.js":
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer);
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})( false || module, this);


/***/ }),

/***/ "../../node_modules/public-encrypt/privateDecrypt.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var parseKeys = __webpack_require__("../../node_modules/parse-asn1/index.js")
var mgf = __webpack_require__("../../node_modules/public-encrypt/mgf.js")
var xor = __webpack_require__("../../node_modules/public-encrypt/xor.js")
var BN = __webpack_require__("../../node_modules/public-encrypt/node_modules/bn.js/lib/bn.js")
var crt = __webpack_require__("../../node_modules/browserify-rsa/index.js")
var createHash = __webpack_require__("../../node_modules/create-hash/browser.js")
var withPublic = __webpack_require__("../../node_modules/public-encrypt/withPublic.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),

/***/ "../../node_modules/public-encrypt/publicEncrypt.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var parseKeys = __webpack_require__("../../node_modules/parse-asn1/index.js")
var randomBytes = __webpack_require__("../../node_modules/randombytes/browser.js")
var createHash = __webpack_require__("../../node_modules/create-hash/browser.js")
var mgf = __webpack_require__("../../node_modules/public-encrypt/mgf.js")
var xor = __webpack_require__("../../node_modules/public-encrypt/xor.js")
var BN = __webpack_require__("../../node_modules/public-encrypt/node_modules/bn.js/lib/bn.js")
var withPublic = __webpack_require__("../../node_modules/public-encrypt/withPublic.js")
var crt = __webpack_require__("../../node_modules/browserify-rsa/index.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),

/***/ "../../node_modules/public-encrypt/withPublic.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var BN = __webpack_require__("../../node_modules/public-encrypt/node_modules/bn.js/lib/bn.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),

/***/ "../../node_modules/public-encrypt/xor.js":
/***/ ((module) => {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),

/***/ "../../node_modules/quick-format-unescaped/index.js":
/***/ ((module) => {

"use strict";

function tryStringify (o) {
  try { return JSON.stringify(o) } catch(e) { return '"[Circular]"' }
}

module.exports = format

function format(f, args, opts) {
  var ss = (opts && opts.stringify) || tryStringify
  var offset = 1
  if (typeof f === 'object' && f !== null) {
    var len = args.length + offset
    if (len === 1) return f
    var objects = new Array(len)
    objects[0] = ss(f)
    for (var index = 1; index < len; index++) {
      objects[index] = ss(args[index])
    }
    return objects.join(' ')
  }
  if (typeof f !== 'string') {
    return f
  }
  var argLen = args.length
  if (argLen === 0) return f
  var str = ''
  var a = 1 - offset
  var lastPos = -1
  var flen = (f && f.length) || 0
  for (var i = 0; i < flen;) {
    if (f.charCodeAt(i) === 37 && i + 1 < flen) {
      lastPos = lastPos > -1 ? lastPos : 0
      switch (f.charCodeAt(i + 1)) {
        case 100: // 'd'
        case 102: // 'f'
          if (a >= argLen)
            break
          if (args[a] == null)  break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += Number(args[a])
          lastPos = i + 2
          i++
          break
        case 105: // 'i'
          if (a >= argLen)
            break
          if (args[a] == null)  break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += Math.floor(Number(args[a]))
          lastPos = i + 2
          i++
          break
        case 79: // 'O'
        case 111: // 'o'
        case 106: // 'j'
          if (a >= argLen)
            break
          if (args[a] === undefined) break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          var type = typeof args[a]
          if (type === 'string') {
            str += '\'' + args[a] + '\''
            lastPos = i + 2
            i++
            break
          }
          if (type === 'function') {
            str += args[a].name || '<anonymous>'
            lastPos = i + 2
            i++
            break
          }
          str += ss(args[a])
          lastPos = i + 2
          i++
          break
        case 115: // 's'
          if (a >= argLen)
            break
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += String(args[a])
          lastPos = i + 2
          i++
          break
        case 37: // '%'
          if (lastPos < i)
            str += f.slice(lastPos, i)
          str += '%'
          lastPos = i + 2
          i++
          a--
          break
      }
      ++a
    }
    ++i
  }
  if (lastPos === -1)
    return f
  else if (lastPos < flen) {
    str += f.slice(lastPos)
  }

  return str
}


/***/ }),

/***/ "../../node_modules/randombytes/browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");


// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)
var crypto = __webpack_require__.g.crypto || __webpack_require__.g.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}


/***/ }),

/***/ "../../node_modules/randomfill/browser.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");


function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__("../../node_modules/safe-buffer/index.js")
var randombytes = __webpack_require__("../../node_modules/randombytes/browser.js")
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = __webpack_require__.g.crypto || __webpack_require__.g.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof __webpack_require__.g.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof __webpack_require__.g.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/add-abort-signal.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const { AbortError, codes } = __webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js")
const { isNodeStream, isWebStream, kControllerErrorFunction } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/utils.js")
const eos = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/end-of-stream.js")
const { ERR_INVALID_ARG_TYPE } = codes

// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const validateAbortSignal = (signal, name) => {
  if (typeof signal !== 'object' || !('aborted' in signal)) {
    throw new ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal)
  }
}
module.exports.addAbortSignal = function addAbortSignal(signal, stream) {
  validateAbortSignal(signal, 'signal')
  if (!isNodeStream(stream) && !isWebStream(stream)) {
    throw new ERR_INVALID_ARG_TYPE('stream', ['ReadableStream', 'WritableStream', 'Stream'], stream)
  }
  return module.exports.addAbortSignalNoValidate(signal, stream)
}
module.exports.addAbortSignalNoValidate = function (signal, stream) {
  if (typeof signal !== 'object' || !('aborted' in signal)) {
    return stream
  }
  const onAbort = isNodeStream(stream)
    ? () => {
        stream.destroy(
          new AbortError(undefined, {
            cause: signal.reason
          })
        )
      }
    : () => {
        stream[kControllerErrorFunction](
          new AbortError(undefined, {
            cause: signal.reason
          })
        )
      }
  if (signal.aborted) {
    onAbort()
  } else {
    signal.addEventListener('abort', onAbort)
    eos(stream, () => signal.removeEventListener('abort', onAbort))
  }
  return stream
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/buffer_list.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const { StringPrototypeSlice, SymbolIterator, TypedArrayPrototypeSet, Uint8Array } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const { Buffer } = __webpack_require__("../../node_modules/buffer/index.js")
const { inspect } = __webpack_require__("../../node_modules/readable-stream/lib/ours/util.js")
module.exports = class BufferList {
  constructor() {
    this.head = null
    this.tail = null
    this.length = 0
  }
  push(v) {
    const entry = {
      data: v,
      next: null
    }
    if (this.length > 0) this.tail.next = entry
    else this.head = entry
    this.tail = entry
    ++this.length
  }
  unshift(v) {
    const entry = {
      data: v,
      next: this.head
    }
    if (this.length === 0) this.tail = entry
    this.head = entry
    ++this.length
  }
  shift() {
    if (this.length === 0) return
    const ret = this.head.data
    if (this.length === 1) this.head = this.tail = null
    else this.head = this.head.next
    --this.length
    return ret
  }
  clear() {
    this.head = this.tail = null
    this.length = 0
  }
  join(s) {
    if (this.length === 0) return ''
    let p = this.head
    let ret = '' + p.data
    while ((p = p.next) !== null) ret += s + p.data
    return ret
  }
  concat(n) {
    if (this.length === 0) return Buffer.alloc(0)
    const ret = Buffer.allocUnsafe(n >>> 0)
    let p = this.head
    let i = 0
    while (p) {
      TypedArrayPrototypeSet(ret, p.data, i)
      i += p.data.length
      p = p.next
    }
    return ret
  }

  // Consumes a specified amount of bytes or characters from the buffered data.
  consume(n, hasStrings) {
    const data = this.head.data
    if (n < data.length) {
      // `slice` is the same for buffers and strings.
      const slice = data.slice(0, n)
      this.head.data = data.slice(n)
      return slice
    }
    if (n === data.length) {
      // First chunk is a perfect match.
      return this.shift()
    }
    // Result spans more than one buffer.
    return hasStrings ? this._getString(n) : this._getBuffer(n)
  }
  first() {
    return this.head.data
  }
  *[SymbolIterator]() {
    for (let p = this.head; p; p = p.next) {
      yield p.data
    }
  }

  // Consumes a specified amount of characters from the buffered data.
  _getString(n) {
    let ret = ''
    let p = this.head
    let c = 0
    do {
      const str = p.data
      if (n > str.length) {
        ret += str
        n -= str.length
      } else {
        if (n === str.length) {
          ret += str
          ++c
          if (p.next) this.head = p.next
          else this.head = this.tail = null
        } else {
          ret += StringPrototypeSlice(str, 0, n)
          this.head = p
          p.data = StringPrototypeSlice(str, n)
        }
        break
      }
      ++c
    } while ((p = p.next) !== null)
    this.length -= c
    return ret
  }

  // Consumes a specified amount of bytes from the buffered data.
  _getBuffer(n) {
    const ret = Buffer.allocUnsafe(n)
    const retLen = n
    let p = this.head
    let c = 0
    do {
      const buf = p.data
      if (n > buf.length) {
        TypedArrayPrototypeSet(ret, buf, retLen - n)
        n -= buf.length
      } else {
        if (n === buf.length) {
          TypedArrayPrototypeSet(ret, buf, retLen - n)
          ++c
          if (p.next) this.head = p.next
          else this.head = this.tail = null
        } else {
          TypedArrayPrototypeSet(ret, new Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n)
          this.head = p
          p.data = buf.slice(n)
        }
        break
      }
      ++c
    } while ((p = p.next) !== null)
    this.length -= c
    return ret
  }

  // Make sure the linked list only shows the minimal necessary information.
  [Symbol.for('nodejs.util.inspect.custom')](_, options) {
    return inspect(this, {
      ...options,
      // Only inspect one level.
      depth: 0,
      // It should not recurse.
      customInspect: false
    })
  }
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/compose.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const { pipeline } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/pipeline.js")
const Duplex = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/duplex.js")
const { destroyer } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/destroy.js")
const {
  isNodeStream,
  isReadable,
  isWritable,
  isWebStream,
  isTransformStream,
  isWritableStream,
  isReadableStream
} = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/utils.js")
const {
  AbortError,
  codes: { ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS }
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js")
const eos = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/end-of-stream.js")
module.exports = function compose(...streams) {
  if (streams.length === 0) {
    throw new ERR_MISSING_ARGS('streams')
  }
  if (streams.length === 1) {
    return Duplex.from(streams[0])
  }
  const orgStreams = [...streams]
  if (typeof streams[0] === 'function') {
    streams[0] = Duplex.from(streams[0])
  }
  if (typeof streams[streams.length - 1] === 'function') {
    const idx = streams.length - 1
    streams[idx] = Duplex.from(streams[idx])
  }
  for (let n = 0; n < streams.length; ++n) {
    if (!isNodeStream(streams[n]) && !isWebStream(streams[n])) {
      // TODO(ronag): Add checks for non streams.
      continue
    }
    if (
      n < streams.length - 1 &&
      !(isReadable(streams[n]) || isReadableStream(streams[n]) || isTransformStream(streams[n]))
    ) {
      throw new ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be readable')
    }
    if (n > 0 && !(isWritable(streams[n]) || isWritableStream(streams[n]) || isTransformStream(streams[n]))) {
      throw new ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], 'must be writable')
    }
  }
  let ondrain
  let onfinish
  let onreadable
  let onclose
  let d
  function onfinished(err) {
    const cb = onclose
    onclose = null
    if (cb) {
      cb(err)
    } else if (err) {
      d.destroy(err)
    } else if (!readable && !writable) {
      d.destroy()
    }
  }
  const head = streams[0]
  const tail = pipeline(streams, onfinished)
  const writable = !!(isWritable(head) || isWritableStream(head) || isTransformStream(head))
  const readable = !!(isReadable(tail) || isReadableStream(tail) || isTransformStream(tail))

  // TODO(ronag): Avoid double buffering.
  // Implement Writable/Readable/Duplex traits.
  // See, https://github.com/nodejs/node/pull/33515.
  d = new Duplex({
    // TODO (ronag): highWaterMark?
    writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
    readableObjectMode: !!(tail !== null && tail !== undefined && tail.writableObjectMode),
    writable,
    readable
  })
  if (writable) {
    if (isNodeStream(head)) {
      d._write = function (chunk, encoding, callback) {
        if (head.write(chunk, encoding)) {
          callback()
        } else {
          ondrain = callback
        }
      }
      d._final = function (callback) {
        head.end()
        onfinish = callback
      }
      head.on('drain', function () {
        if (ondrain) {
          const cb = ondrain
          ondrain = null
          cb()
        }
      })
    } else if (isWebStream(head)) {
      const writable = isTransformStream(head) ? head.writable : head
      const writer = writable.getWriter()
      d._write = async function (chunk, encoding, callback) {
        try {
          await writer.ready
          writer.write(chunk).catch(() => {})
          callback()
        } catch (err) {
          callback(err)
        }
      }
      d._final = async function (callback) {
        try {
          await writer.ready
          writer.close().catch(() => {})
          onfinish = callback
        } catch (err) {
          callback(err)
        }
      }
    }
    const toRead = isTransformStream(tail) ? tail.readable : tail
    eos(toRead, () => {
      if (onfinish) {
        const cb = onfinish
        onfinish = null
        cb()
      }
    })
  }
  if (readable) {
    if (isNodeStream(tail)) {
      tail.on('readable', function () {
        if (onreadable) {
          const cb = onreadable
          onreadable = null
          cb()
        }
      })
      tail.on('end', function () {
        d.push(null)
      })
      d._read = function () {
        while (true) {
          const buf = tail.read()
          if (buf === null) {
            onreadable = d._read
            return
          }
          if (!d.push(buf)) {
            return
          }
        }
      }
    } else if (isWebStream(tail)) {
      const readable = isTransformStream(tail) ? tail.readable : tail
      const reader = readable.getReader()
      d._read = async function () {
        while (true) {
          try {
            const { value, done } = await reader.read()
            if (!d.push(value)) {
              return
            }
            if (done) {
              d.push(null)
              return
            }
          } catch {
            return
          }
        }
      }
    }
  }
  d._destroy = function (err, callback) {
    if (!err && onclose !== null) {
      err = new AbortError()
    }
    onreadable = null
    ondrain = null
    onfinish = null
    if (onclose === null) {
      callback(err)
    } else {
      onclose = callback
      if (isNodeStream(tail)) {
        destroyer(tail, err)
      }
    }
  }
  return d
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/destroy.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* replacement start */

const process = __webpack_require__("../../node_modules/process/browser.js")

/* replacement end */

const {
  aggregateTwoErrors,
  codes: { ERR_MULTIPLE_CALLBACK },
  AbortError
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js")
const { Symbol } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const { kDestroyed, isDestroyed, isFinished, isServerRequest } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/utils.js")
const kDestroy = Symbol('kDestroy')
const kConstruct = Symbol('kConstruct')
function checkError(err, w, r) {
  if (err) {
    // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
    err.stack // eslint-disable-line no-unused-expressions

    if (w && !w.errored) {
      w.errored = err
    }
    if (r && !r.errored) {
      r.errored = err
    }
  }
}

// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function destroy(err, cb) {
  const r = this._readableState
  const w = this._writableState
  // With duplex streams we use the writable side for state.
  const s = w || r
  if ((w !== null && w !== undefined && w.destroyed) || (r !== null && r !== undefined && r.destroyed)) {
    if (typeof cb === 'function') {
      cb()
    }
    return this
  }

  // We set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks
  checkError(err, w, r)
  if (w) {
    w.destroyed = true
  }
  if (r) {
    r.destroyed = true
  }

  // If still constructing then defer calling _destroy.
  if (!s.constructed) {
    this.once(kDestroy, function (er) {
      _destroy(this, aggregateTwoErrors(er, err), cb)
    })
  } else {
    _destroy(this, err, cb)
  }
  return this
}
function _destroy(self, err, cb) {
  let called = false
  function onDestroy(err) {
    if (called) {
      return
    }
    called = true
    const r = self._readableState
    const w = self._writableState
    checkError(err, w, r)
    if (w) {
      w.closed = true
    }
    if (r) {
      r.closed = true
    }
    if (typeof cb === 'function') {
      cb(err)
    }
    if (err) {
      process.nextTick(emitErrorCloseNT, self, err)
    } else {
      process.nextTick(emitCloseNT, self)
    }
  }
  try {
    self._destroy(err || null, onDestroy)
  } catch (err) {
    onDestroy(err)
  }
}
function emitErrorCloseNT(self, err) {
  emitErrorNT(self, err)
  emitCloseNT(self)
}
function emitCloseNT(self) {
  const r = self._readableState
  const w = self._writableState
  if (w) {
    w.closeEmitted = true
  }
  if (r) {
    r.closeEmitted = true
  }
  if ((w !== null && w !== undefined && w.emitClose) || (r !== null && r !== undefined && r.emitClose)) {
    self.emit('close')
  }
}
function emitErrorNT(self, err) {
  const r = self._readableState
  const w = self._writableState
  if ((w !== null && w !== undefined && w.errorEmitted) || (r !== null && r !== undefined && r.errorEmitted)) {
    return
  }
  if (w) {
    w.errorEmitted = true
  }
  if (r) {
    r.errorEmitted = true
  }
  self.emit('error', err)
}
function undestroy() {
  const r = this._readableState
  const w = this._writableState
  if (r) {
    r.constructed = true
    r.closed = false
    r.closeEmitted = false
    r.destroyed = false
    r.errored = null
    r.errorEmitted = false
    r.reading = false
    r.ended = r.readable === false
    r.endEmitted = r.readable === false
  }
  if (w) {
    w.constructed = true
    w.destroyed = false
    w.closed = false
    w.closeEmitted = false
    w.errored = null
    w.errorEmitted = false
    w.finalCalled = false
    w.prefinished = false
    w.ended = w.writable === false
    w.ending = w.writable === false
    w.finished = w.writable === false
  }
}
function errorOrDestroy(stream, err, sync) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  const r = stream._readableState
  const w = stream._writableState
  if ((w !== null && w !== undefined && w.destroyed) || (r !== null && r !== undefined && r.destroyed)) {
    return this
  }
  if ((r !== null && r !== undefined && r.autoDestroy) || (w !== null && w !== undefined && w.autoDestroy))
    stream.destroy(err)
  else if (err) {
    // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
    err.stack // eslint-disable-line no-unused-expressions

    if (w && !w.errored) {
      w.errored = err
    }
    if (r && !r.errored) {
      r.errored = err
    }
    if (sync) {
      process.nextTick(emitErrorNT, stream, err)
    } else {
      emitErrorNT(stream, err)
    }
  }
}
function construct(stream, cb) {
  if (typeof stream._construct !== 'function') {
    return
  }
  const r = stream._readableState
  const w = stream._writableState
  if (r) {
    r.constructed = false
  }
  if (w) {
    w.constructed = false
  }
  stream.once(kConstruct, cb)
  if (stream.listenerCount(kConstruct) > 1) {
    // Duplex
    return
  }
  process.nextTick(constructNT, stream)
}
function constructNT(stream) {
  let called = false
  function onConstruct(err) {
    if (called) {
      errorOrDestroy(stream, err !== null && err !== undefined ? err : new ERR_MULTIPLE_CALLBACK())
      return
    }
    called = true
    const r = stream._readableState
    const w = stream._writableState
    const s = w || r
    if (r) {
      r.constructed = true
    }
    if (w) {
      w.constructed = true
    }
    if (s.destroyed) {
      stream.emit(kDestroy, err)
    } else if (err) {
      errorOrDestroy(stream, err, true)
    } else {
      process.nextTick(emitConstructNT, stream)
    }
  }
  try {
    stream._construct((err) => {
      process.nextTick(onConstruct, err)
    })
  } catch (err) {
    process.nextTick(onConstruct, err)
  }
}
function emitConstructNT(stream) {
  stream.emit(kConstruct)
}
function isRequest(stream) {
  return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === 'function'
}
function emitCloseLegacy(stream) {
  stream.emit('close')
}
function emitErrorCloseLegacy(stream, err) {
  stream.emit('error', err)
  process.nextTick(emitCloseLegacy, stream)
}

// Normalize destroy for legacy.
function destroyer(stream, err) {
  if (!stream || isDestroyed(stream)) {
    return
  }
  if (!err && !isFinished(stream)) {
    err = new AbortError()
  }

  // TODO: Remove isRequest branches.
  if (isServerRequest(stream)) {
    stream.socket = null
    stream.destroy(err)
  } else if (isRequest(stream)) {
    stream.abort()
  } else if (isRequest(stream.req)) {
    stream.req.abort()
  } else if (typeof stream.destroy === 'function') {
    stream.destroy(err)
  } else if (typeof stream.close === 'function') {
    // TODO: Don't lose err?
    stream.close()
  } else if (err) {
    process.nextTick(emitErrorCloseLegacy, stream, err)
  } else {
    process.nextTick(emitCloseLegacy, stream)
  }
  if (!stream.destroyed) {
    stream[kDestroyed] = true
  }
}
module.exports = {
  construct,
  destroyer,
  destroy,
  undestroy,
  errorOrDestroy
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/duplex.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.



const {
  ObjectDefineProperties,
  ObjectGetOwnPropertyDescriptor,
  ObjectKeys,
  ObjectSetPrototypeOf
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
module.exports = Duplex
const Readable = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/readable.js")
const Writable = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/writable.js")
ObjectSetPrototypeOf(Duplex.prototype, Readable.prototype)
ObjectSetPrototypeOf(Duplex, Readable)
{
  const keys = ObjectKeys(Writable.prototype)
  // Allow the keys array to be GC'ed.
  for (let i = 0; i < keys.length; i++) {
    const method = keys[i]
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method]
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options)
  Readable.call(this, options)
  Writable.call(this, options)
  if (options) {
    this.allowHalfOpen = options.allowHalfOpen !== false
    if (options.readable === false) {
      this._readableState.readable = false
      this._readableState.ended = true
      this._readableState.endEmitted = true
    }
    if (options.writable === false) {
      this._writableState.writable = false
      this._writableState.ending = true
      this._writableState.ended = true
      this._writableState.finished = true
    }
  } else {
    this.allowHalfOpen = true
  }
}
ObjectDefineProperties(Duplex.prototype, {
  writable: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writable')
  },
  writableHighWaterMark: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableHighWaterMark')
  },
  writableObjectMode: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableObjectMode')
  },
  writableBuffer: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableBuffer')
  },
  writableLength: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableLength')
  },
  writableFinished: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableFinished')
  },
  writableCorked: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableCorked')
  },
  writableEnded: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableEnded')
  },
  writableNeedDrain: {
    __proto__: null,
    ...ObjectGetOwnPropertyDescriptor(Writable.prototype, 'writableNeedDrain')
  },
  destroyed: {
    __proto__: null,
    get() {
      if (this._readableState === undefined || this._writableState === undefined) {
        return false
      }
      return this._readableState.destroyed && this._writableState.destroyed
    },
    set(value) {
      // Backward compatibility, the user is explicitly
      // managing destroyed.
      if (this._readableState && this._writableState) {
        this._readableState.destroyed = value
        this._writableState.destroyed = value
      }
    }
  }
})
let webStreamsAdapters

// Lazy to avoid circular references
function lazyWebStreams() {
  if (webStreamsAdapters === undefined) webStreamsAdapters = {}
  return webStreamsAdapters
}
Duplex.fromWeb = function (pair, options) {
  return lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options)
}
Duplex.toWeb = function (duplex) {
  return lazyWebStreams().newReadableWritablePairFromDuplex(duplex)
}
let duplexify
Duplex.from = function (body) {
  if (!duplexify) {
    duplexify = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/duplexify.js")
  }
  return duplexify(body, 'body')
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/duplexify.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* replacement start */

const process = __webpack_require__("../../node_modules/process/browser.js")

/* replacement end */

;('use strict')
const bufferModule = __webpack_require__("../../node_modules/buffer/index.js")
const {
  isReadable,
  isWritable,
  isIterable,
  isNodeStream,
  isReadableNodeStream,
  isWritableNodeStream,
  isDuplexNodeStream
} = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/utils.js")
const eos = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/end-of-stream.js")
const {
  AbortError,
  codes: { ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE }
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js")
const { destroyer } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/destroy.js")
const Duplex = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/duplex.js")
const Readable = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/readable.js")
const { createDeferredPromise } = __webpack_require__("../../node_modules/readable-stream/lib/ours/util.js")
const from = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/from.js")
const Blob = globalThis.Blob || bufferModule.Blob
const isBlob =
  typeof Blob !== 'undefined'
    ? function isBlob(b) {
        return b instanceof Blob
      }
    : function isBlob(b) {
        return false
      }
const AbortController = globalThis.AbortController || (__webpack_require__("../../node_modules/abort-controller/browser.js").AbortController)
const { FunctionPrototypeCall } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")

// This is needed for pre node 17.
class Duplexify extends Duplex {
  constructor(options) {
    super(options)

    // https://github.com/nodejs/node/pull/34385

    if ((options === null || options === undefined ? undefined : options.readable) === false) {
      this._readableState.readable = false
      this._readableState.ended = true
      this._readableState.endEmitted = true
    }
    if ((options === null || options === undefined ? undefined : options.writable) === false) {
      this._writableState.writable = false
      this._writableState.ending = true
      this._writableState.ended = true
      this._writableState.finished = true
    }
  }
}
module.exports = function duplexify(body, name) {
  if (isDuplexNodeStream(body)) {
    return body
  }
  if (isReadableNodeStream(body)) {
    return _duplexify({
      readable: body
    })
  }
  if (isWritableNodeStream(body)) {
    return _duplexify({
      writable: body
    })
  }
  if (isNodeStream(body)) {
    return _duplexify({
      writable: false,
      readable: false
    })
  }

  // TODO: Webstreams
  // if (isReadableStream(body)) {
  //   return _duplexify({ readable: Readable.fromWeb(body) });
  // }

  // TODO: Webstreams
  // if (isWritableStream(body)) {
  //   return _duplexify({ writable: Writable.fromWeb(body) });
  // }

  if (typeof body === 'function') {
    const { value, write, final, destroy } = fromAsyncGen(body)
    if (isIterable(value)) {
      return from(Duplexify, value, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        write,
        final,
        destroy
      })
    }
    const then = value === null || value === undefined ? undefined : value.then
    if (typeof then === 'function') {
      let d
      const promise = FunctionPrototypeCall(
        then,
        value,
        (val) => {
          if (val != null) {
            throw new ERR_INVALID_RETURN_VALUE('nully', 'body', val)
          }
        },
        (err) => {
          destroyer(d, err)
        }
      )
      return (d = new Duplexify({
        // TODO (ronag): highWaterMark?
        objectMode: true,
        readable: false,
        write,
        final(cb) {
          final(async () => {
            try {
              await promise
              process.nextTick(cb, null)
            } catch (err) {
              process.nextTick(cb, err)
            }
          })
        },
        destroy
      }))
    }
    throw new ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or AsyncFunction', name, value)
  }
  if (isBlob(body)) {
    return duplexify(body.arrayBuffer())
  }
  if (isIterable(body)) {
    return from(Duplexify, body, {
      // TODO (ronag): highWaterMark?
      objectMode: true,
      writable: false
    })
  }

  // TODO: Webstreams.
  // if (
  //   isReadableStream(body?.readable) &&
  //   isWritableStream(body?.writable)
  // ) {
  //   return Duplexify.fromWeb(body);
  // }

  if (
    typeof (body === null || body === undefined ? undefined : body.writable) === 'object' ||
    typeof (body === null || body === undefined ? undefined : body.readable) === 'object'
  ) {
    const readable =
      body !== null && body !== undefined && body.readable
        ? isReadableNodeStream(body === null || body === undefined ? undefined : body.readable)
          ? body === null || body === undefined
            ? undefined
            : body.readable
          : duplexify(body.readable)
        : undefined
    const writable =
      body !== null && body !== undefined && body.writable
        ? isWritableNodeStream(body === null || body === undefined ? undefined : body.writable)
          ? body === null || body === undefined
            ? undefined
            : body.writable
          : duplexify(body.writable)
        : undefined
    return _duplexify({
      readable,
      writable
    })
  }
  const then = body === null || body === undefined ? undefined : body.then
  if (typeof then === 'function') {
    let d
    FunctionPrototypeCall(
      then,
      body,
      (val) => {
        if (val != null) {
          d.push(val)
        }
        d.push(null)
      },
      (err) => {
        destroyer(d, err)
      }
    )
    return (d = new Duplexify({
      objectMode: true,
      writable: false,
      read() {}
    }))
  }
  throw new ERR_INVALID_ARG_TYPE(
    name,
    [
      'Blob',
      'ReadableStream',
      'WritableStream',
      'Stream',
      'Iterable',
      'AsyncIterable',
      'Function',
      '{ readable, writable } pair',
      'Promise'
    ],
    body
  )
}
function fromAsyncGen(fn) {
  let { promise, resolve } = createDeferredPromise()
  const ac = new AbortController()
  const signal = ac.signal
  const value = fn(
    (async function* () {
      while (true) {
        const _promise = promise
        promise = null
        const { chunk, done, cb } = await _promise
        process.nextTick(cb)
        if (done) return
        if (signal.aborted)
          throw new AbortError(undefined, {
            cause: signal.reason
          })
        ;({ promise, resolve } = createDeferredPromise())
        yield chunk
      }
    })(),
    {
      signal
    }
  )
  return {
    value,
    write(chunk, encoding, cb) {
      const _resolve = resolve
      resolve = null
      _resolve({
        chunk,
        done: false,
        cb
      })
    },
    final(cb) {
      const _resolve = resolve
      resolve = null
      _resolve({
        done: true,
        cb
      })
    },
    destroy(err, cb) {
      ac.abort()
      cb(err)
    }
  }
}
function _duplexify(pair) {
  const r = pair.readable && typeof pair.readable.read !== 'function' ? Readable.wrap(pair.readable) : pair.readable
  const w = pair.writable
  let readable = !!isReadable(r)
  let writable = !!isWritable(w)
  let ondrain
  let onfinish
  let onreadable
  let onclose
  let d
  function onfinished(err) {
    const cb = onclose
    onclose = null
    if (cb) {
      cb(err)
    } else if (err) {
      d.destroy(err)
    }
  }

  // TODO(ronag): Avoid double buffering.
  // Implement Writable/Readable/Duplex traits.
  // See, https://github.com/nodejs/node/pull/33515.
  d = new Duplexify({
    // TODO (ronag): highWaterMark?
    readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
    writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
    readable,
    writable
  })
  if (writable) {
    eos(w, (err) => {
      writable = false
      if (err) {
        destroyer(r, err)
      }
      onfinished(err)
    })
    d._write = function (chunk, encoding, callback) {
      if (w.write(chunk, encoding)) {
        callback()
      } else {
        ondrain = callback
      }
    }
    d._final = function (callback) {
      w.end()
      onfinish = callback
    }
    w.on('drain', function () {
      if (ondrain) {
        const cb = ondrain
        ondrain = null
        cb()
      }
    })
    w.on('finish', function () {
      if (onfinish) {
        const cb = onfinish
        onfinish = null
        cb()
      }
    })
  }
  if (readable) {
    eos(r, (err) => {
      readable = false
      if (err) {
        destroyer(r, err)
      }
      onfinished(err)
    })
    r.on('readable', function () {
      if (onreadable) {
        const cb = onreadable
        onreadable = null
        cb()
      }
    })
    r.on('end', function () {
      d.push(null)
    })
    d._read = function () {
      while (true) {
        const buf = r.read()
        if (buf === null) {
          onreadable = d._read
          return
        }
        if (!d.push(buf)) {
          return
        }
      }
    }
  }
  d._destroy = function (err, callback) {
    if (!err && onclose !== null) {
      err = new AbortError()
    }
    onreadable = null
    ondrain = null
    onfinish = null
    if (onclose === null) {
      callback(err)
    } else {
      onclose = callback
      destroyer(w, err)
      destroyer(r, err)
    }
  }
  return d
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/end-of-stream.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* replacement start */

const process = __webpack_require__("../../node_modules/process/browser.js")

/* replacement end */
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).

;('use strict')
const { AbortError, codes } = __webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js")
const { ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE } = codes
const { kEmptyObject, once } = __webpack_require__("../../node_modules/readable-stream/lib/ours/util.js")
const { validateAbortSignal, validateFunction, validateObject, validateBoolean } = __webpack_require__("../../node_modules/readable-stream/lib/internal/validators.js")
const { Promise, PromisePrototypeThen } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const {
  isClosed,
  isReadable,
  isReadableNodeStream,
  isReadableStream,
  isReadableFinished,
  isReadableErrored,
  isWritable,
  isWritableNodeStream,
  isWritableStream,
  isWritableFinished,
  isWritableErrored,
  isNodeStream,
  willEmitClose: _willEmitClose,
  kIsClosedPromise
} = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/utils.js")
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function'
}
const nop = () => {}
function eos(stream, options, callback) {
  var _options$readable, _options$writable
  if (arguments.length === 2) {
    callback = options
    options = kEmptyObject
  } else if (options == null) {
    options = kEmptyObject
  } else {
    validateObject(options, 'options')
  }
  validateFunction(callback, 'callback')
  validateAbortSignal(options.signal, 'options.signal')
  callback = once(callback)
  if (isReadableStream(stream) || isWritableStream(stream)) {
    return eosWeb(stream, options, callback)
  }
  if (!isNodeStream(stream)) {
    throw new ERR_INVALID_ARG_TYPE('stream', ['ReadableStream', 'WritableStream', 'Stream'], stream)
  }
  const readable =
    (_options$readable = options.readable) !== null && _options$readable !== undefined
      ? _options$readable
      : isReadableNodeStream(stream)
  const writable =
    (_options$writable = options.writable) !== null && _options$writable !== undefined
      ? _options$writable
      : isWritableNodeStream(stream)
  const wState = stream._writableState
  const rState = stream._readableState
  const onlegacyfinish = () => {
    if (!stream.writable) {
      onfinish()
    }
  }

  // TODO (ronag): Improve soft detection to include core modules and
  // common ecosystem modules that do properly emit 'close' but fail
  // this generic check.
  let willEmitClose =
    _willEmitClose(stream) && isReadableNodeStream(stream) === readable && isWritableNodeStream(stream) === writable
  let writableFinished = isWritableFinished(stream, false)
  const onfinish = () => {
    writableFinished = true
    // Stream should not be destroyed here. If it is that
    // means that user space is doing something differently and
    // we cannot trust willEmitClose.
    if (stream.destroyed) {
      willEmitClose = false
    }
    if (willEmitClose && (!stream.readable || readable)) {
      return
    }
    if (!readable || readableFinished) {
      callback.call(stream)
    }
  }
  let readableFinished = isReadableFinished(stream, false)
  const onend = () => {
    readableFinished = true
    // Stream should not be destroyed here. If it is that
    // means that user space is doing something differently and
    // we cannot trust willEmitClose.
    if (stream.destroyed) {
      willEmitClose = false
    }
    if (willEmitClose && (!stream.writable || writable)) {
      return
    }
    if (!writable || writableFinished) {
      callback.call(stream)
    }
  }
  const onerror = (err) => {
    callback.call(stream, err)
  }
  let closed = isClosed(stream)
  const onclose = () => {
    closed = true
    const errored = isWritableErrored(stream) || isReadableErrored(stream)
    if (errored && typeof errored !== 'boolean') {
      return callback.call(stream, errored)
    }
    if (readable && !readableFinished && isReadableNodeStream(stream, true)) {
      if (!isReadableFinished(stream, false)) return callback.call(stream, new ERR_STREAM_PREMATURE_CLOSE())
    }
    if (writable && !writableFinished) {
      if (!isWritableFinished(stream, false)) return callback.call(stream, new ERR_STREAM_PREMATURE_CLOSE())
    }
    callback.call(stream)
  }
  const onclosed = () => {
    closed = true
    const errored = isWritableErrored(stream) || isReadableErrored(stream)
    if (errored && typeof errored !== 'boolean') {
      return callback.call(stream, errored)
    }
    callback.call(stream)
  }
  const onrequest = () => {
    stream.req.on('finish', onfinish)
  }
  if (isRequest(stream)) {
    stream.on('complete', onfinish)
    if (!willEmitClose) {
      stream.on('abort', onclose)
    }
    if (stream.req) {
      onrequest()
    } else {
      stream.on('request', onrequest)
    }
  } else if (writable && !wState) {
    // legacy streams
    stream.on('end', onlegacyfinish)
    stream.on('close', onlegacyfinish)
  }

  // Not all streams will emit 'close' after 'aborted'.
  if (!willEmitClose && typeof stream.aborted === 'boolean') {
    stream.on('aborted', onclose)
  }
  stream.on('end', onend)
  stream.on('finish', onfinish)
  if (options.error !== false) {
    stream.on('error', onerror)
  }
  stream.on('close', onclose)
  if (closed) {
    process.nextTick(onclose)
  } else if (
    (wState !== null && wState !== undefined && wState.errorEmitted) ||
    (rState !== null && rState !== undefined && rState.errorEmitted)
  ) {
    if (!willEmitClose) {
      process.nextTick(onclosed)
    }
  } else if (
    !readable &&
    (!willEmitClose || isReadable(stream)) &&
    (writableFinished || isWritable(stream) === false)
  ) {
    process.nextTick(onclosed)
  } else if (
    !writable &&
    (!willEmitClose || isWritable(stream)) &&
    (readableFinished || isReadable(stream) === false)
  ) {
    process.nextTick(onclosed)
  } else if (rState && stream.req && stream.aborted) {
    process.nextTick(onclosed)
  }
  const cleanup = () => {
    callback = nop
    stream.removeListener('aborted', onclose)
    stream.removeListener('complete', onfinish)
    stream.removeListener('abort', onclose)
    stream.removeListener('request', onrequest)
    if (stream.req) stream.req.removeListener('finish', onfinish)
    stream.removeListener('end', onlegacyfinish)
    stream.removeListener('close', onlegacyfinish)
    stream.removeListener('finish', onfinish)
    stream.removeListener('end', onend)
    stream.removeListener('error', onerror)
    stream.removeListener('close', onclose)
  }
  if (options.signal && !closed) {
    const abort = () => {
      // Keep it because cleanup removes it.
      const endCallback = callback
      cleanup()
      endCallback.call(
        stream,
        new AbortError(undefined, {
          cause: options.signal.reason
        })
      )
    }
    if (options.signal.aborted) {
      process.nextTick(abort)
    } else {
      const originalCallback = callback
      callback = once((...args) => {
        options.signal.removeEventListener('abort', abort)
        originalCallback.apply(stream, args)
      })
      options.signal.addEventListener('abort', abort)
    }
  }
  return cleanup
}
function eosWeb(stream, options, callback) {
  let isAborted = false
  let abort = nop
  if (options.signal) {
    abort = () => {
      isAborted = true
      callback.call(
        stream,
        new AbortError(undefined, {
          cause: options.signal.reason
        })
      )
    }
    if (options.signal.aborted) {
      process.nextTick(abort)
    } else {
      const originalCallback = callback
      callback = once((...args) => {
        options.signal.removeEventListener('abort', abort)
        originalCallback.apply(stream, args)
      })
      options.signal.addEventListener('abort', abort)
    }
  }
  const resolverFn = (...args) => {
    if (!isAborted) {
      process.nextTick(() => callback.apply(stream, args))
    }
  }
  PromisePrototypeThen(stream[kIsClosedPromise].promise, resolverFn, resolverFn)
  return nop
}
function finished(stream, opts) {
  var _opts
  let autoCleanup = false
  if (opts === null) {
    opts = kEmptyObject
  }
  if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
    validateBoolean(opts.cleanup, 'cleanup')
    autoCleanup = opts.cleanup
  }
  return new Promise((resolve, reject) => {
    const cleanup = eos(stream, opts, (err) => {
      if (autoCleanup) {
        cleanup()
      }
      if (err) {
        reject(err)
      } else {
        resolve()
      }
    })
  })
}
module.exports = eos
module.exports.finished = finished


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/from.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* replacement start */

const process = __webpack_require__("../../node_modules/process/browser.js")

/* replacement end */

const { PromisePrototypeThen, SymbolAsyncIterator, SymbolIterator } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const { Buffer } = __webpack_require__("../../node_modules/buffer/index.js")
const { ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES } = (__webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js").codes)
function from(Readable, iterable, opts) {
  let iterator
  if (typeof iterable === 'string' || iterable instanceof Buffer) {
    return new Readable({
      objectMode: true,
      ...opts,
      read() {
        this.push(iterable)
        this.push(null)
      }
    })
  }
  let isAsync
  if (iterable && iterable[SymbolAsyncIterator]) {
    isAsync = true
    iterator = iterable[SymbolAsyncIterator]()
  } else if (iterable && iterable[SymbolIterator]) {
    isAsync = false
    iterator = iterable[SymbolIterator]()
  } else {
    throw new ERR_INVALID_ARG_TYPE('iterable', ['Iterable'], iterable)
  }
  const readable = new Readable({
    objectMode: true,
    highWaterMark: 1,
    // TODO(ronag): What options should be allowed?
    ...opts
  })

  // Flag to protect against _read
  // being called before last iteration completion.
  let reading = false
  readable._read = function () {
    if (!reading) {
      reading = true
      next()
    }
  }
  readable._destroy = function (error, cb) {
    PromisePrototypeThen(
      close(error),
      () => process.nextTick(cb, error),
      // nextTick is here in case cb throws
      (e) => process.nextTick(cb, e || error)
    )
  }
  async function close(error) {
    const hadError = error !== undefined && error !== null
    const hasThrow = typeof iterator.throw === 'function'
    if (hadError && hasThrow) {
      const { value, done } = await iterator.throw(error)
      await value
      if (done) {
        return
      }
    }
    if (typeof iterator.return === 'function') {
      const { value } = await iterator.return()
      await value
    }
  }
  async function next() {
    for (;;) {
      try {
        const { value, done } = isAsync ? await iterator.next() : iterator.next()
        if (done) {
          readable.push(null)
        } else {
          const res = value && typeof value.then === 'function' ? await value : value
          if (res === null) {
            reading = false
            throw new ERR_STREAM_NULL_VALUES()
          } else if (readable.push(res)) {
            continue
          } else {
            reading = false
          }
        }
      } catch (err) {
        readable.destroy(err)
      }
      break
    }
  }
  return readable
}
module.exports = from


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/legacy.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const { ArrayIsArray, ObjectSetPrototypeOf } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const { EventEmitter: EE } = __webpack_require__("../../node_modules/events/events.js")
function Stream(opts) {
  EE.call(this, opts)
}
ObjectSetPrototypeOf(Stream.prototype, EE.prototype)
ObjectSetPrototypeOf(Stream, EE)
Stream.prototype.pipe = function (dest, options) {
  const source = this
  function ondata(chunk) {
    if (dest.writable && dest.write(chunk) === false && source.pause) {
      source.pause()
    }
  }
  source.on('data', ondata)
  function ondrain() {
    if (source.readable && source.resume) {
      source.resume()
    }
  }
  dest.on('drain', ondrain)

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend)
    source.on('close', onclose)
  }
  let didOnEnd = false
  function onend() {
    if (didOnEnd) return
    didOnEnd = true
    dest.end()
  }
  function onclose() {
    if (didOnEnd) return
    didOnEnd = true
    if (typeof dest.destroy === 'function') dest.destroy()
  }

  // Don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup()
    if (EE.listenerCount(this, 'error') === 0) {
      this.emit('error', er)
    }
  }
  prependListener(source, 'error', onerror)
  prependListener(dest, 'error', onerror)

  // Remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata)
    dest.removeListener('drain', ondrain)
    source.removeListener('end', onend)
    source.removeListener('close', onclose)
    source.removeListener('error', onerror)
    dest.removeListener('error', onerror)
    source.removeListener('end', cleanup)
    source.removeListener('close', cleanup)
    dest.removeListener('close', cleanup)
  }
  source.on('end', cleanup)
  source.on('close', cleanup)
  dest.on('close', cleanup)
  dest.emit('pipe', source)

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest
}
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn)

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn)
  else if (ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn)
  else emitter._events[event] = [fn, emitter._events[event]]
}
module.exports = {
  Stream,
  prependListener
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/operators.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const AbortController = globalThis.AbortController || (__webpack_require__("../../node_modules/abort-controller/browser.js").AbortController)
const {
  codes: { ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS, ERR_OUT_OF_RANGE },
  AbortError
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js")
const { validateAbortSignal, validateInteger, validateObject } = __webpack_require__("../../node_modules/readable-stream/lib/internal/validators.js")
const kWeakHandler = (__webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js").Symbol)('kWeak')
const { finished } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/end-of-stream.js")
const staticCompose = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/compose.js")
const { addAbortSignalNoValidate } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/add-abort-signal.js")
const { isWritable, isNodeStream } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/utils.js")
const {
  ArrayPrototypePush,
  MathFloor,
  Number,
  NumberIsNaN,
  Promise,
  PromiseReject,
  PromisePrototypeThen,
  Symbol
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const kEmpty = Symbol('kEmpty')
const kEof = Symbol('kEof')
function compose(stream, options) {
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  if (isNodeStream(stream) && !isWritable(stream)) {
    throw new ERR_INVALID_ARG_VALUE('stream', stream, 'must be writable')
  }
  const composedStream = staticCompose(this, stream)
  if (options !== null && options !== undefined && options.signal) {
    // Not validating as we already validated before
    addAbortSignalNoValidate(options.signal, composedStream)
  }
  return composedStream
}
function map(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  let concurrency = 1
  if ((options === null || options === undefined ? undefined : options.concurrency) != null) {
    concurrency = MathFloor(options.concurrency)
  }
  validateInteger(concurrency, 'concurrency', 1)
  return async function* map() {
    var _options$signal, _options$signal2
    const ac = new AbortController()
    const stream = this
    const queue = []
    const signal = ac.signal
    const signalOpt = {
      signal
    }
    const abort = () => ac.abort()
    if (
      options !== null &&
      options !== undefined &&
      (_options$signal = options.signal) !== null &&
      _options$signal !== undefined &&
      _options$signal.aborted
    ) {
      abort()
    }
    options === null || options === undefined
      ? undefined
      : (_options$signal2 = options.signal) === null || _options$signal2 === undefined
      ? undefined
      : _options$signal2.addEventListener('abort', abort)
    let next
    let resume
    let done = false
    function onDone() {
      done = true
    }
    async function pump() {
      try {
        for await (let val of stream) {
          var _val
          if (done) {
            return
          }
          if (signal.aborted) {
            throw new AbortError()
          }
          try {
            val = fn(val, signalOpt)
          } catch (err) {
            val = PromiseReject(err)
          }
          if (val === kEmpty) {
            continue
          }
          if (typeof ((_val = val) === null || _val === undefined ? undefined : _val.catch) === 'function') {
            val.catch(onDone)
          }
          queue.push(val)
          if (next) {
            next()
            next = null
          }
          if (!done && queue.length && queue.length >= concurrency) {
            await new Promise((resolve) => {
              resume = resolve
            })
          }
        }
        queue.push(kEof)
      } catch (err) {
        const val = PromiseReject(err)
        PromisePrototypeThen(val, undefined, onDone)
        queue.push(val)
      } finally {
        var _options$signal3
        done = true
        if (next) {
          next()
          next = null
        }
        options === null || options === undefined
          ? undefined
          : (_options$signal3 = options.signal) === null || _options$signal3 === undefined
          ? undefined
          : _options$signal3.removeEventListener('abort', abort)
      }
    }
    pump()
    try {
      while (true) {
        while (queue.length > 0) {
          const val = await queue[0]
          if (val === kEof) {
            return
          }
          if (signal.aborted) {
            throw new AbortError()
          }
          if (val !== kEmpty) {
            yield val
          }
          queue.shift()
          if (resume) {
            resume()
            resume = null
          }
        }
        await new Promise((resolve) => {
          next = resolve
        })
      }
    } finally {
      ac.abort()
      done = true
      if (resume) {
        resume()
        resume = null
      }
    }
  }.call(this)
}
function asIndexedPairs(options = undefined) {
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  return async function* asIndexedPairs() {
    let index = 0
    for await (const val of this) {
      var _options$signal4
      if (
        options !== null &&
        options !== undefined &&
        (_options$signal4 = options.signal) !== null &&
        _options$signal4 !== undefined &&
        _options$signal4.aborted
      ) {
        throw new AbortError({
          cause: options.signal.reason
        })
      }
      yield [index++, val]
    }
  }.call(this)
}
async function some(fn, options = undefined) {
  for await (const unused of filter.call(this, fn, options)) {
    return true
  }
  return false
}
async function every(fn, options = undefined) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }
  // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
  return !(await some.call(
    this,
    async (...args) => {
      return !(await fn(...args))
    },
    options
  ))
}
async function find(fn, options) {
  for await (const result of filter.call(this, fn, options)) {
    return result
  }
  return undefined
}
async function forEach(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }
  async function forEachFn(value, options) {
    await fn(value, options)
    return kEmpty
  }
  // eslint-disable-next-line no-unused-vars
  for await (const unused of map.call(this, forEachFn, options));
}
function filter(fn, options) {
  if (typeof fn !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('fn', ['Function', 'AsyncFunction'], fn)
  }
  async function filterFn(value, options) {
    if (await fn(value, options)) {
      return value
    }
    return kEmpty
  }
  return map.call(this, filterFn, options)
}

// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class ReduceAwareErrMissingArgs extends ERR_MISSING_ARGS {
  constructor() {
    super('reduce')
    this.message = 'Reduce of an empty stream requires an initial value'
  }
}
async function reduce(reducer, initialValue, options) {
  var _options$signal5
  if (typeof reducer !== 'function') {
    throw new ERR_INVALID_ARG_TYPE('reducer', ['Function', 'AsyncFunction'], reducer)
  }
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  let hasInitialValue = arguments.length > 1
  if (
    options !== null &&
    options !== undefined &&
    (_options$signal5 = options.signal) !== null &&
    _options$signal5 !== undefined &&
    _options$signal5.aborted
  ) {
    const err = new AbortError(undefined, {
      cause: options.signal.reason
    })
    this.once('error', () => {}) // The error is already propagated
    await finished(this.destroy(err))
    throw err
  }
  const ac = new AbortController()
  const signal = ac.signal
  if (options !== null && options !== undefined && options.signal) {
    const opts = {
      once: true,
      [kWeakHandler]: this
    }
    options.signal.addEventListener('abort', () => ac.abort(), opts)
  }
  let gotAnyItemFromStream = false
  try {
    for await (const value of this) {
      var _options$signal6
      gotAnyItemFromStream = true
      if (
        options !== null &&
        options !== undefined &&
        (_options$signal6 = options.signal) !== null &&
        _options$signal6 !== undefined &&
        _options$signal6.aborted
      ) {
        throw new AbortError()
      }
      if (!hasInitialValue) {
        initialValue = value
        hasInitialValue = true
      } else {
        initialValue = await reducer(initialValue, value, {
          signal
        })
      }
    }
    if (!gotAnyItemFromStream && !hasInitialValue) {
      throw new ReduceAwareErrMissingArgs()
    }
  } finally {
    ac.abort()
  }
  return initialValue
}
async function toArray(options) {
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  const result = []
  for await (const val of this) {
    var _options$signal7
    if (
      options !== null &&
      options !== undefined &&
      (_options$signal7 = options.signal) !== null &&
      _options$signal7 !== undefined &&
      _options$signal7.aborted
    ) {
      throw new AbortError(undefined, {
        cause: options.signal.reason
      })
    }
    ArrayPrototypePush(result, val)
  }
  return result
}
function flatMap(fn, options) {
  const values = map.call(this, fn, options)
  return async function* flatMap() {
    for await (const val of values) {
      yield* val
    }
  }.call(this)
}
function toIntegerOrInfinity(number) {
  // We coerce here to align with the spec
  // https://github.com/tc39/proposal-iterator-helpers/issues/169
  number = Number(number)
  if (NumberIsNaN(number)) {
    return 0
  }
  if (number < 0) {
    throw new ERR_OUT_OF_RANGE('number', '>= 0', number)
  }
  return number
}
function drop(number, options = undefined) {
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  number = toIntegerOrInfinity(number)
  return async function* drop() {
    var _options$signal8
    if (
      options !== null &&
      options !== undefined &&
      (_options$signal8 = options.signal) !== null &&
      _options$signal8 !== undefined &&
      _options$signal8.aborted
    ) {
      throw new AbortError()
    }
    for await (const val of this) {
      var _options$signal9
      if (
        options !== null &&
        options !== undefined &&
        (_options$signal9 = options.signal) !== null &&
        _options$signal9 !== undefined &&
        _options$signal9.aborted
      ) {
        throw new AbortError()
      }
      if (number-- <= 0) {
        yield val
      }
    }
  }.call(this)
}
function take(number, options = undefined) {
  if (options != null) {
    validateObject(options, 'options')
  }
  if ((options === null || options === undefined ? undefined : options.signal) != null) {
    validateAbortSignal(options.signal, 'options.signal')
  }
  number = toIntegerOrInfinity(number)
  return async function* take() {
    var _options$signal10
    if (
      options !== null &&
      options !== undefined &&
      (_options$signal10 = options.signal) !== null &&
      _options$signal10 !== undefined &&
      _options$signal10.aborted
    ) {
      throw new AbortError()
    }
    for await (const val of this) {
      var _options$signal11
      if (
        options !== null &&
        options !== undefined &&
        (_options$signal11 = options.signal) !== null &&
        _options$signal11 !== undefined &&
        _options$signal11.aborted
      ) {
        throw new AbortError()
      }
      if (number-- > 0) {
        yield val
      } else {
        return
      }
    }
  }.call(this)
}
module.exports.streamReturningOperators = {
  asIndexedPairs,
  drop,
  filter,
  flatMap,
  map,
  take,
  compose
}
module.exports.promiseReturningOperators = {
  every,
  forEach,
  reduce,
  toArray,
  some,
  find
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/passthrough.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



const { ObjectSetPrototypeOf } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
module.exports = PassThrough
const Transform = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/transform.js")
ObjectSetPrototypeOf(PassThrough.prototype, Transform.prototype)
ObjectSetPrototypeOf(PassThrough, Transform)
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options)
  Transform.call(this, options)
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk)
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/pipeline.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* replacement start */

const process = __webpack_require__("../../node_modules/process/browser.js")

/* replacement end */
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).

;('use strict')
const { ArrayIsArray, Promise, SymbolAsyncIterator } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const eos = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/end-of-stream.js")
const { once } = __webpack_require__("../../node_modules/readable-stream/lib/ours/util.js")
const destroyImpl = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/destroy.js")
const Duplex = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/duplex.js")
const {
  aggregateTwoErrors,
  codes: {
    ERR_INVALID_ARG_TYPE,
    ERR_INVALID_RETURN_VALUE,
    ERR_MISSING_ARGS,
    ERR_STREAM_DESTROYED,
    ERR_STREAM_PREMATURE_CLOSE
  },
  AbortError
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js")
const { validateFunction, validateAbortSignal } = __webpack_require__("../../node_modules/readable-stream/lib/internal/validators.js")
const {
  isIterable,
  isReadable,
  isReadableNodeStream,
  isNodeStream,
  isTransformStream,
  isWebStream,
  isReadableStream,
  isReadableEnded
} = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/utils.js")
const AbortController = globalThis.AbortController || (__webpack_require__("../../node_modules/abort-controller/browser.js").AbortController)
let PassThrough
let Readable
function destroyer(stream, reading, writing) {
  let finished = false
  stream.on('close', () => {
    finished = true
  })
  const cleanup = eos(
    stream,
    {
      readable: reading,
      writable: writing
    },
    (err) => {
      finished = !err
    }
  )
  return {
    destroy: (err) => {
      if (finished) return
      finished = true
      destroyImpl.destroyer(stream, err || new ERR_STREAM_DESTROYED('pipe'))
    },
    cleanup
  }
}
function popCallback(streams) {
  // Streams should never be an empty array. It should always contain at least
  // a single stream. Therefore optimize for the average case instead of
  // checking for length === 0 as well.
  validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]')
  return streams.pop()
}
function makeAsyncIterable(val) {
  if (isIterable(val)) {
    return val
  } else if (isReadableNodeStream(val)) {
    // Legacy streams are not Iterable.
    return fromReadable(val)
  }
  throw new ERR_INVALID_ARG_TYPE('val', ['Readable', 'Iterable', 'AsyncIterable'], val)
}
async function* fromReadable(val) {
  if (!Readable) {
    Readable = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/readable.js")
  }
  yield* Readable.prototype[SymbolAsyncIterator].call(val)
}
async function pumpToNode(iterable, writable, finish, { end }) {
  let error
  let onresolve = null
  const resume = (err) => {
    if (err) {
      error = err
    }
    if (onresolve) {
      const callback = onresolve
      onresolve = null
      callback()
    }
  }
  const wait = () =>
    new Promise((resolve, reject) => {
      if (error) {
        reject(error)
      } else {
        onresolve = () => {
          if (error) {
            reject(error)
          } else {
            resolve()
          }
        }
      }
    })
  writable.on('drain', resume)
  const cleanup = eos(
    writable,
    {
      readable: false
    },
    resume
  )
  try {
    if (writable.writableNeedDrain) {
      await wait()
    }
    for await (const chunk of iterable) {
      if (!writable.write(chunk)) {
        await wait()
      }
    }
    if (end) {
      writable.end()
    }
    await wait()
    finish()
  } catch (err) {
    finish(error !== err ? aggregateTwoErrors(error, err) : err)
  } finally {
    cleanup()
    writable.off('drain', resume)
  }
}
async function pumpToWeb(readable, writable, finish, { end }) {
  if (isTransformStream(writable)) {
    writable = writable.writable
  }
  // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
  const writer = writable.getWriter()
  try {
    for await (const chunk of readable) {
      await writer.ready
      writer.write(chunk).catch(() => {})
    }
    await writer.ready
    if (end) {
      await writer.close()
    }
    finish()
  } catch (err) {
    try {
      await writer.abort(err)
      finish(err)
    } catch (err) {
      finish(err)
    }
  }
}
function pipeline(...streams) {
  return pipelineImpl(streams, once(popCallback(streams)))
}
function pipelineImpl(streams, callback, opts) {
  if (streams.length === 1 && ArrayIsArray(streams[0])) {
    streams = streams[0]
  }
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams')
  }
  const ac = new AbortController()
  const signal = ac.signal
  const outerSignal = opts === null || opts === undefined ? undefined : opts.signal

  // Need to cleanup event listeners if last stream is readable
  // https://github.com/nodejs/node/issues/35452
  const lastStreamCleanup = []
  validateAbortSignal(outerSignal, 'options.signal')
  function abort() {
    finishImpl(new AbortError())
  }
  outerSignal === null || outerSignal === undefined ? undefined : outerSignal.addEventListener('abort', abort)
  let error
  let value
  const destroys = []
  let finishCount = 0
  function finish(err) {
    finishImpl(err, --finishCount === 0)
  }
  function finishImpl(err, final) {
    if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) {
      error = err
    }
    if (!error && !final) {
      return
    }
    while (destroys.length) {
      destroys.shift()(error)
    }
    outerSignal === null || outerSignal === undefined ? undefined : outerSignal.removeEventListener('abort', abort)
    ac.abort()
    if (final) {
      if (!error) {
        lastStreamCleanup.forEach((fn) => fn())
      }
      process.nextTick(callback, error, value)
    }
  }
  let ret
  for (let i = 0; i < streams.length; i++) {
    const stream = streams[i]
    const reading = i < streams.length - 1
    const writing = i > 0
    const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false
    const isLastStream = i === streams.length - 1
    if (isNodeStream(stream)) {
      if (end) {
        const { destroy, cleanup } = destroyer(stream, reading, writing)
        destroys.push(destroy)
        if (isReadable(stream) && isLastStream) {
          lastStreamCleanup.push(cleanup)
        }
      }

      // Catch stream errors that occur after pipe/pump has completed.
      function onError(err) {
        if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
          finish(err)
        }
      }
      stream.on('error', onError)
      if (isReadable(stream) && isLastStream) {
        lastStreamCleanup.push(() => {
          stream.removeListener('error', onError)
        })
      }
    }
    if (i === 0) {
      if (typeof stream === 'function') {
        ret = stream({
          signal
        })
        if (!isIterable(ret)) {
          throw new ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret)
        }
      } else if (isIterable(stream) || isReadableNodeStream(stream) || isTransformStream(stream)) {
        ret = stream
      } else {
        ret = Duplex.from(stream)
      }
    } else if (typeof stream === 'function') {
      if (isTransformStream(ret)) {
        var _ret
        ret = makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable)
      } else {
        ret = makeAsyncIterable(ret)
      }
      ret = stream(ret, {
        signal
      })
      if (reading) {
        if (!isIterable(ret, true)) {
          throw new ERR_INVALID_RETURN_VALUE('AsyncIterable', `transform[${i - 1}]`, ret)
        }
      } else {
        var _ret2
        if (!PassThrough) {
          PassThrough = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/passthrough.js")
        }

        // If the last argument to pipeline is not a stream
        // we must create a proxy stream so that pipeline(...)
        // always returns a stream which can be further
        // composed through `.pipe(stream)`.

        const pt = new PassThrough({
          objectMode: true
        })

        // Handle Promises/A+ spec, `then` could be a getter that throws on
        // second use.
        const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then
        if (typeof then === 'function') {
          finishCount++
          then.call(
            ret,
            (val) => {
              value = val
              if (val != null) {
                pt.write(val)
              }
              if (end) {
                pt.end()
              }
              process.nextTick(finish)
            },
            (err) => {
              pt.destroy(err)
              process.nextTick(finish, err)
            }
          )
        } else if (isIterable(ret, true)) {
          finishCount++
          pumpToNode(ret, pt, finish, {
            end
          })
        } else if (isReadableStream(ret) || isTransformStream(ret)) {
          const toRead = ret.readable || ret
          finishCount++
          pumpToNode(toRead, pt, finish, {
            end
          })
        } else {
          throw new ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret)
        }
        ret = pt
        const { destroy, cleanup } = destroyer(ret, false, true)
        destroys.push(destroy)
        if (isLastStream) {
          lastStreamCleanup.push(cleanup)
        }
      }
    } else if (isNodeStream(stream)) {
      if (isReadableNodeStream(ret)) {
        finishCount += 2
        const cleanup = pipe(ret, stream, finish, {
          end
        })
        if (isReadable(stream) && isLastStream) {
          lastStreamCleanup.push(cleanup)
        }
      } else if (isTransformStream(ret) || isReadableStream(ret)) {
        const toRead = ret.readable || ret
        finishCount++
        pumpToNode(toRead, stream, finish, {
          end
        })
      } else if (isIterable(ret)) {
        finishCount++
        pumpToNode(ret, stream, finish, {
          end
        })
      } else {
        throw new ERR_INVALID_ARG_TYPE(
          'val',
          ['Readable', 'Iterable', 'AsyncIterable', 'ReadableStream', 'TransformStream'],
          ret
        )
      }
      ret = stream
    } else if (isWebStream(stream)) {
      if (isReadableNodeStream(ret)) {
        finishCount++
        pumpToWeb(makeAsyncIterable(ret), stream, finish, {
          end
        })
      } else if (isReadableStream(ret) || isIterable(ret)) {
        finishCount++
        pumpToWeb(ret, stream, finish, {
          end
        })
      } else if (isTransformStream(ret)) {
        finishCount++
        pumpToWeb(ret.readable, stream, finish, {
          end
        })
      } else {
        throw new ERR_INVALID_ARG_TYPE(
          'val',
          ['Readable', 'Iterable', 'AsyncIterable', 'ReadableStream', 'TransformStream'],
          ret
        )
      }
      ret = stream
    } else {
      ret = Duplex.from(stream)
    }
  }
  if (
    (signal !== null && signal !== undefined && signal.aborted) ||
    (outerSignal !== null && outerSignal !== undefined && outerSignal.aborted)
  ) {
    process.nextTick(abort)
  }
  return ret
}
function pipe(src, dst, finish, { end }) {
  let ended = false
  dst.on('close', () => {
    if (!ended) {
      // Finish if the destination closes before the source has completed.
      finish(new ERR_STREAM_PREMATURE_CLOSE())
    }
  })
  src.pipe(dst, {
    end: false
  }) // If end is true we already will have a listener to end dst.

  if (end) {
    // Compat. Before node v10.12.0 stdio used to throw an error so
    // pipe() did/does not end() stdio destinations.
    // Now they allow it but "secretly" don't close the underlying fd.

    function endFn() {
      ended = true
      dst.end()
    }
    if (isReadableEnded(src)) {
      // End the destination if the source has already ended.
      process.nextTick(endFn)
    } else {
      src.once('end', endFn)
    }
  } else {
    finish()
  }
  eos(
    src,
    {
      readable: true,
      writable: false
    },
    (err) => {
      const rState = src._readableState
      if (
        err &&
        err.code === 'ERR_STREAM_PREMATURE_CLOSE' &&
        rState &&
        rState.ended &&
        !rState.errored &&
        !rState.errorEmitted
      ) {
        // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once('end', finish).once('error', finish)
      } else {
        finish(err)
      }
    }
  )
  return eos(
    dst,
    {
      readable: false,
      writable: true
    },
    finish
  )
}
module.exports = {
  pipelineImpl,
  pipeline
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/readable.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* replacement start */

const process = __webpack_require__("../../node_modules/process/browser.js")

/* replacement end */
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

;('use strict')
const {
  ArrayPrototypeIndexOf,
  NumberIsInteger,
  NumberIsNaN,
  NumberParseInt,
  ObjectDefineProperties,
  ObjectKeys,
  ObjectSetPrototypeOf,
  Promise,
  SafeSet,
  SymbolAsyncIterator,
  Symbol
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
module.exports = Readable
Readable.ReadableState = ReadableState
const { EventEmitter: EE } = __webpack_require__("../../node_modules/events/events.js")
const { Stream, prependListener } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/legacy.js")
const { Buffer } = __webpack_require__("../../node_modules/buffer/index.js")
const { addAbortSignal } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/add-abort-signal.js")
const eos = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/end-of-stream.js")
let debug = (__webpack_require__("../../node_modules/readable-stream/lib/ours/util.js").debuglog)('stream', (fn) => {
  debug = fn
})
const BufferList = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/buffer_list.js")
const destroyImpl = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/destroy.js")
const { getHighWaterMark, getDefaultHighWaterMark } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/state.js")
const {
  aggregateTwoErrors,
  codes: {
    ERR_INVALID_ARG_TYPE,
    ERR_METHOD_NOT_IMPLEMENTED,
    ERR_OUT_OF_RANGE,
    ERR_STREAM_PUSH_AFTER_EOF,
    ERR_STREAM_UNSHIFT_AFTER_END_EVENT
  }
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js")
const { validateObject } = __webpack_require__("../../node_modules/readable-stream/lib/internal/validators.js")
const kPaused = Symbol('kPaused')
const { StringDecoder } = __webpack_require__("../../node_modules/string_decoder/lib/string_decoder.js")
const from = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/from.js")
ObjectSetPrototypeOf(Readable.prototype, Stream.prototype)
ObjectSetPrototypeOf(Readable, Stream)
const nop = () => {}
const { errorOrDestroy } = destroyImpl
function ReadableState(options, stream, isDuplex) {
  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/duplex.js")

  // Object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away.
  this.objectMode = !!(options && options.objectMode)
  if (isDuplex) this.objectMode = this.objectMode || !!(options && options.readableObjectMode)

  // The point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = options
    ? getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex)
    : getDefaultHighWaterMark(false)

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift().
  this.buffer = new BufferList()
  this.length = 0
  this.pipes = []
  this.flowing = null
  this.ended = false
  this.endEmitted = false
  this.reading = false

  // Stream is still being constructed and cannot be
  // destroyed until construction finished or failed.
  // Async construction is opt in, therefore we start as
  // constructed.
  this.constructed = true

  // A flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true

  // Whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false
  this.emittedReadable = false
  this.readableListening = false
  this.resumeScheduled = false
  this[kPaused] = null

  // True if the error was already emitted and should not be thrown again.
  this.errorEmitted = false

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = !options || options.emitClose !== false

  // Should .destroy() be called after 'end' (and potentially 'finish').
  this.autoDestroy = !options || options.autoDestroy !== false

  // Has it been destroyed.
  this.destroyed = false

  // Indicates whether the stream has errored. When true no further
  // _read calls, 'data' or 'readable' events should occur. This is needed
  // since when autoDestroy is disabled we need a way to tell whether the
  // stream has failed.
  this.errored = null

  // Indicates whether the stream has finished destroying.
  this.closed = false

  // True if close has been emitted or would have been emitted
  // depending on emitClose.
  this.closeEmitted = false

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = (options && options.defaultEncoding) || 'utf8'

  // Ref the piped dest which we need a drain event on it
  // type: null | Writable | Set<Writable>.
  this.awaitDrainWriters = null
  this.multiAwaitDrain = false

  // If true, a maybeReadMore has been scheduled.
  this.readingMore = false
  this.dataEmitted = false
  this.decoder = null
  this.encoding = null
  if (options && options.encoding) {
    this.decoder = new StringDecoder(options.encoding)
    this.encoding = options.encoding
  }
}
function Readable(options) {
  if (!(this instanceof Readable)) return new Readable(options)

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5.
  const isDuplex = this instanceof __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/duplex.js")
  this._readableState = new ReadableState(options, this, isDuplex)
  if (options) {
    if (typeof options.read === 'function') this._read = options.read
    if (typeof options.destroy === 'function') this._destroy = options.destroy
    if (typeof options.construct === 'function') this._construct = options.construct
    if (options.signal && !isDuplex) addAbortSignal(options.signal, this)
  }
  Stream.call(this, options)
  destroyImpl.construct(this, () => {
    if (this._readableState.needReadable) {
      maybeReadMore(this, this._readableState)
    }
  })
}
Readable.prototype.destroy = destroyImpl.destroy
Readable.prototype._undestroy = destroyImpl.undestroy
Readable.prototype._destroy = function (err, cb) {
  cb(err)
}
Readable.prototype[EE.captureRejectionSymbol] = function (err) {
  this.destroy(err)
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  return readableAddChunk(this, chunk, encoding, false)
}

// Unshift should *always* be something directly out of read().
Readable.prototype.unshift = function (chunk, encoding) {
  return readableAddChunk(this, chunk, encoding, true)
}
function readableAddChunk(stream, chunk, encoding, addToFront) {
  debug('readableAddChunk', chunk)
  const state = stream._readableState
  let err
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding
      if (state.encoding !== encoding) {
        if (addToFront && state.encoding) {
          // When unshifting, if state.encoding is set, we have to save
          // the string in the BufferList with the state encoding.
          chunk = Buffer.from(chunk, encoding).toString(state.encoding)
        } else {
          chunk = Buffer.from(chunk, encoding)
          encoding = ''
        }
      }
    } else if (chunk instanceof Buffer) {
      encoding = ''
    } else if (Stream._isUint8Array(chunk)) {
      chunk = Stream._uint8ArrayToBuffer(chunk)
      encoding = ''
    } else if (chunk != null) {
      err = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk)
    }
  }
  if (err) {
    errorOrDestroy(stream, err)
  } else if (chunk === null) {
    state.reading = false
    onEofChunk(stream, state)
  } else if (state.objectMode || (chunk && chunk.length > 0)) {
    if (addToFront) {
      if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT())
      else if (state.destroyed || state.errored) return false
      else addChunk(stream, state, chunk, true)
    } else if (state.ended) {
      errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF())
    } else if (state.destroyed || state.errored) {
      return false
    } else {
      state.reading = false
      if (state.decoder && !encoding) {
        chunk = state.decoder.write(chunk)
        if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false)
        else maybeReadMore(stream, state)
      } else {
        addChunk(stream, state, chunk, false)
      }
    }
  } else if (!addToFront) {
    state.reading = false
    maybeReadMore(stream, state)
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0)
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount('data') > 0) {
    // Use the guard to avoid creating `Set()` repeatedly
    // when we have multiple pipes.
    if (state.multiAwaitDrain) {
      state.awaitDrainWriters.clear()
    } else {
      state.awaitDrainWriters = null
    }
    state.dataEmitted = true
    stream.emit('data', chunk)
  } else {
    // Update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length
    if (addToFront) state.buffer.unshift(chunk)
    else state.buffer.push(chunk)
    if (state.needReadable) emitReadable(stream)
  }
  maybeReadMore(stream, state)
}
Readable.prototype.isPaused = function () {
  const state = this._readableState
  return state[kPaused] === true || state.flowing === false
}

// Backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  const decoder = new StringDecoder(enc)
  this._readableState.decoder = decoder
  // If setEncoding(null), decoder.encoding equals utf8.
  this._readableState.encoding = this._readableState.decoder.encoding
  const buffer = this._readableState.buffer
  // Iterate over current buffer to convert already stored Buffers:
  let content = ''
  for (const data of buffer) {
    content += decoder.write(data)
  }
  buffer.clear()
  if (content !== '') buffer.push(content)
  this._readableState.length = content.length
  return this
}

// Don't raise the hwm > 1GB.
const MAX_HWM = 0x40000000
function computeNewHighWaterMark(n) {
  if (n > MAX_HWM) {
    throw new ERR_OUT_OF_RANGE('size', '<= 1GiB', n)
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts.
    n--
    n |= n >>> 1
    n |= n >>> 2
    n |= n >>> 4
    n |= n >>> 8
    n |= n >>> 16
    n++
  }
  return n
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || (state.length === 0 && state.ended)) return 0
  if (state.objectMode) return 1
  if (NumberIsNaN(n)) {
    // Only flow one buffer at a time.
    if (state.flowing && state.length) return state.buffer.first().length
    return state.length
  }
  if (n <= state.length) return n
  return state.ended ? state.length : 0
}

// You can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n)
  // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
  // in this scenario, so we are doing it manually.
  if (n === undefined) {
    n = NaN
  } else if (!NumberIsInteger(n)) {
    n = NumberParseInt(n, 10)
  }
  const state = this._readableState
  const nOrig = n

  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n)
  if (n !== 0) state.emittedReadable = false

  // If we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (
    n === 0 &&
    state.needReadable &&
    ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)
  ) {
    debug('read: emitReadable', state.length, state.ended)
    if (state.length === 0 && state.ended) endReadable(this)
    else emitReadable(this)
    return null
  }
  n = howMuchToRead(n, state)

  // If we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this)
    return null
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  let doRead = state.needReadable
  debug('need readable', doRead)

  // If we currently have less than the highWaterMark, then also read some.
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true
    debug('length less than watermark', doRead)
  }

  // However, if we've ended, then there's no point, if we're already
  // reading, then it's unnecessary, if we're constructing we have to wait,
  // and if we're destroyed or errored, then it's not allowed,
  if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
    doRead = false
    debug('reading, ended or constructing', doRead)
  } else if (doRead) {
    debug('do read')
    state.reading = true
    state.sync = true
    // If the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true

    // Call internal read method
    try {
      this._read(state.highWaterMark)
    } catch (err) {
      errorOrDestroy(this, err)
    }
    state.sync = false
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state)
  }
  let ret
  if (n > 0) ret = fromList(n, state)
  else ret = null
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark
    n = 0
  } else {
    state.length -= n
    if (state.multiAwaitDrain) {
      state.awaitDrainWriters.clear()
    } else {
      state.awaitDrainWriters = null
    }
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this)
  }
  if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
    state.dataEmitted = true
    this.emit('data', ret)
  }
  return ret
}
function onEofChunk(stream, state) {
  debug('onEofChunk')
  if (state.ended) return
  if (state.decoder) {
    const chunk = state.decoder.end()
    if (chunk && chunk.length) {
      state.buffer.push(chunk)
      state.length += state.objectMode ? 1 : chunk.length
    }
  }
  state.ended = true
  if (state.sync) {
    // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    emitReadable(stream)
  } else {
    // Emit 'readable' now to make sure it gets picked up.
    state.needReadable = false
    state.emittedReadable = true
    // We have to emit readable now that we are EOF. Modules
    // in the ecosystem (e.g. dicer) rely on this event being sync.
    emitReadable_(stream)
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  const state = stream._readableState
  debug('emitReadable', state.needReadable, state.emittedReadable)
  state.needReadable = false
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing)
    state.emittedReadable = true
    process.nextTick(emitReadable_, stream)
  }
}
function emitReadable_(stream) {
  const state = stream._readableState
  debug('emitReadable_', state.destroyed, state.length, state.ended)
  if (!state.destroyed && !state.errored && (state.length || state.ended)) {
    stream.emit('readable')
    state.emittedReadable = false
  }

  // The stream needs another readable event if:
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark
  flow(stream)
}

// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore && state.constructed) {
    state.readingMore = true
    process.nextTick(maybeReadMore_, stream, state)
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (
    !state.reading &&
    !state.ended &&
    (state.length < state.highWaterMark || (state.flowing && state.length === 0))
  ) {
    const len = state.length
    debug('maybeReadMore read 0')
    stream.read(0)
    if (len === state.length)
      // Didn't get any data, stop spinning.
      break
  }
  state.readingMore = false
}

// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  throw new ERR_METHOD_NOT_IMPLEMENTED('_read()')
}
Readable.prototype.pipe = function (dest, pipeOpts) {
  const src = this
  const state = this._readableState
  if (state.pipes.length === 1) {
    if (!state.multiAwaitDrain) {
      state.multiAwaitDrain = true
      state.awaitDrainWriters = new SafeSet(state.awaitDrainWriters ? [state.awaitDrainWriters] : [])
    }
  }
  state.pipes.push(dest)
  debug('pipe count=%d opts=%j', state.pipes.length, pipeOpts)
  const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr
  const endFn = doEnd ? onend : unpipe
  if (state.endEmitted) process.nextTick(endFn)
  else src.once('end', endFn)
  dest.on('unpipe', onunpipe)
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe')
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true
        cleanup()
      }
    }
  }
  function onend() {
    debug('onend')
    dest.end()
  }
  let ondrain
  let cleanedUp = false
  function cleanup() {
    debug('cleanup')
    // Cleanup event handlers once the pipe is broken.
    dest.removeListener('close', onclose)
    dest.removeListener('finish', onfinish)
    if (ondrain) {
      dest.removeListener('drain', ondrain)
    }
    dest.removeListener('error', onerror)
    dest.removeListener('unpipe', onunpipe)
    src.removeListener('end', onend)
    src.removeListener('end', unpipe)
    src.removeListener('data', ondata)
    cleanedUp = true

    // If the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain()
  }
  function pause() {
    // If the user unpiped during `dest.write()`, it is possible
    // to get stuck in a permanently paused state if that write
    // also returned false.
    // => Check whether `dest` is still a piping destination.
    if (!cleanedUp) {
      if (state.pipes.length === 1 && state.pipes[0] === dest) {
        debug('false write response, pause', 0)
        state.awaitDrainWriters = dest
        state.multiAwaitDrain = false
      } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
        debug('false write response, pause', state.awaitDrainWriters.size)
        state.awaitDrainWriters.add(dest)
      }
      src.pause()
    }
    if (!ondrain) {
      // When the dest drains, it reduces the awaitDrain counter
      // on the source.  This would be more elegant with a .once()
      // handler in flow(), but adding and removing repeatedly is
      // too slow.
      ondrain = pipeOnDrain(src, dest)
      dest.on('drain', ondrain)
    }
  }
  src.on('data', ondata)
  function ondata(chunk) {
    debug('ondata')
    const ret = dest.write(chunk)
    debug('dest.write', ret)
    if (ret === false) {
      pause()
    }
  }

  // If the dest has an error, then stop piping into it.
  // However, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er)
    unpipe()
    dest.removeListener('error', onerror)
    if (dest.listenerCount('error') === 0) {
      const s = dest._writableState || dest._readableState
      if (s && !s.errorEmitted) {
        // User incorrectly emitted 'error' directly on the stream.
        errorOrDestroy(dest, er)
      } else {
        dest.emit('error', er)
      }
    }
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror)

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish)
    unpipe()
  }
  dest.once('close', onclose)
  function onfinish() {
    debug('onfinish')
    dest.removeListener('close', onclose)
    unpipe()
  }
  dest.once('finish', onfinish)
  function unpipe() {
    debug('unpipe')
    src.unpipe(dest)
  }

  // Tell the dest that it's being piped to.
  dest.emit('pipe', src)

  // Start the flow if it hasn't been started already.

  if (dest.writableNeedDrain === true) {
    if (state.flowing) {
      pause()
    }
  } else if (!state.flowing) {
    debug('pipe resume')
    src.resume()
  }
  return dest
}
function pipeOnDrain(src, dest) {
  return function pipeOnDrainFunctionResult() {
    const state = src._readableState

    // `ondrain` will call directly,
    // `this` maybe not a reference to dest,
    // so we use the real dest here.
    if (state.awaitDrainWriters === dest) {
      debug('pipeOnDrain', 1)
      state.awaitDrainWriters = null
    } else if (state.multiAwaitDrain) {
      debug('pipeOnDrain', state.awaitDrainWriters.size)
      state.awaitDrainWriters.delete(dest)
    }
    if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount('data')) {
      src.resume()
    }
  }
}
Readable.prototype.unpipe = function (dest) {
  const state = this._readableState
  const unpipeInfo = {
    hasUnpiped: false
  }

  // If we're not piping anywhere, then do nothing.
  if (state.pipes.length === 0) return this
  if (!dest) {
    // remove all.
    const dests = state.pipes
    state.pipes = []
    this.pause()
    for (let i = 0; i < dests.length; i++)
      dests[i].emit('unpipe', this, {
        hasUnpiped: false
      })
    return this
  }

  // Try to find the right one.
  const index = ArrayPrototypeIndexOf(state.pipes, dest)
  if (index === -1) return this
  state.pipes.splice(index, 1)
  if (state.pipes.length === 0) this.pause()
  dest.emit('unpipe', this, unpipeInfo)
  return this
}

// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
Readable.prototype.on = function (ev, fn) {
  const res = Stream.prototype.on.call(this, ev, fn)
  const state = this._readableState
  if (ev === 'data') {
    // Update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0

    // Try start flowing on next tick if stream isn't explicitly paused.
    if (state.flowing !== false) this.resume()
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true
      state.flowing = false
      state.emittedReadable = false
      debug('on readable', state.length, state.reading)
      if (state.length) {
        emitReadable(this)
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this)
      }
    }
  }
  return res
}
Readable.prototype.addListener = Readable.prototype.on
Readable.prototype.removeListener = function (ev, fn) {
  const res = Stream.prototype.removeListener.call(this, ev, fn)
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this)
  }
  return res
}
Readable.prototype.off = Readable.prototype.removeListener
Readable.prototype.removeAllListeners = function (ev) {
  const res = Stream.prototype.removeAllListeners.apply(this, arguments)
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this)
  }
  return res
}
function updateReadableListening(self) {
  const state = self._readableState
  state.readableListening = self.listenerCount('readable') > 0
  if (state.resumeScheduled && state[kPaused] === false) {
    // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true

    // Crude way to check if we should resume.
  } else if (self.listenerCount('data') > 0) {
    self.resume()
  } else if (!state.readableListening) {
    state.flowing = null
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0')
  self.read(0)
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  const state = this._readableState
  if (!state.flowing) {
    debug('resume')
    // We flow only if there is no one listening
    // for readable, but we still have to call
    // resume().
    state.flowing = !state.readableListening
    resume(this, state)
  }
  state[kPaused] = false
  return this
}
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true
    process.nextTick(resume_, stream, state)
  }
}
function resume_(stream, state) {
  debug('resume', state.reading)
  if (!state.reading) {
    stream.read(0)
  }
  state.resumeScheduled = false
  stream.emit('resume')
  flow(stream)
  if (state.flowing && !state.reading) stream.read(0)
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing)
  if (this._readableState.flowing !== false) {
    debug('pause')
    this._readableState.flowing = false
    this.emit('pause')
  }
  this._readableState[kPaused] = true
  return this
}
function flow(stream) {
  const state = stream._readableState
  debug('flow', state.flowing)
  while (state.flowing && stream.read() !== null);
}

// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  let paused = false

  // TODO (ronag): Should this.destroy(err) emit
  // 'error' on the wrapped stream? Would require
  // a static factory method, e.g. Readable.wrap(stream).

  stream.on('data', (chunk) => {
    if (!this.push(chunk) && stream.pause) {
      paused = true
      stream.pause()
    }
  })
  stream.on('end', () => {
    this.push(null)
  })
  stream.on('error', (err) => {
    errorOrDestroy(this, err)
  })
  stream.on('close', () => {
    this.destroy()
  })
  stream.on('destroy', () => {
    this.destroy()
  })
  this._read = () => {
    if (paused && stream.resume) {
      paused = false
      stream.resume()
    }
  }

  // Proxy all the other methods. Important when wrapping filters and duplexes.
  const streamKeys = ObjectKeys(stream)
  for (let j = 1; j < streamKeys.length; j++) {
    const i = streamKeys[j]
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = stream[i].bind(stream)
    }
  }
  return this
}
Readable.prototype[SymbolAsyncIterator] = function () {
  return streamToAsyncIterator(this)
}
Readable.prototype.iterator = function (options) {
  if (options !== undefined) {
    validateObject(options, 'options')
  }
  return streamToAsyncIterator(this, options)
}
function streamToAsyncIterator(stream, options) {
  if (typeof stream.read !== 'function') {
    stream = Readable.wrap(stream, {
      objectMode: true
    })
  }
  const iter = createAsyncIterator(stream, options)
  iter.stream = stream
  return iter
}
async function* createAsyncIterator(stream, options) {
  let callback = nop
  function next(resolve) {
    if (this === stream) {
      callback()
      callback = nop
    } else {
      callback = resolve
    }
  }
  stream.on('readable', next)
  let error
  const cleanup = eos(
    stream,
    {
      writable: false
    },
    (err) => {
      error = err ? aggregateTwoErrors(error, err) : null
      callback()
      callback = nop
    }
  )
  try {
    while (true) {
      const chunk = stream.destroyed ? null : stream.read()
      if (chunk !== null) {
        yield chunk
      } else if (error) {
        throw error
      } else if (error === null) {
        return
      } else {
        await new Promise(next)
      }
    }
  } catch (err) {
    error = aggregateTwoErrors(error, err)
    throw error
  } finally {
    if (
      (error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) &&
      (error === undefined || stream._readableState.autoDestroy)
    ) {
      destroyImpl.destroyer(stream, null)
    } else {
      stream.off('readable', next)
      cleanup()
    }
  }
}

// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
ObjectDefineProperties(Readable.prototype, {
  readable: {
    __proto__: null,
    get() {
      const r = this._readableState
      // r.readable === false means that this is part of a Duplex stream
      // where the readable side was disabled upon construction.
      // Compat. The user might manually disable readable side through
      // deprecated setter.
      return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted
    },
    set(val) {
      // Backwards compat.
      if (this._readableState) {
        this._readableState.readable = !!val
      }
    }
  },
  readableDidRead: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState.dataEmitted
    }
  },
  readableAborted: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return !!(
        this._readableState.readable !== false &&
        (this._readableState.destroyed || this._readableState.errored) &&
        !this._readableState.endEmitted
      )
    }
  },
  readableHighWaterMark: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState.highWaterMark
    }
  },
  readableBuffer: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState && this._readableState.buffer
    }
  },
  readableFlowing: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return this._readableState.flowing
    },
    set: function (state) {
      if (this._readableState) {
        this._readableState.flowing = state
      }
    }
  },
  readableLength: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState.length
    }
  },
  readableObjectMode: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState ? this._readableState.objectMode : false
    }
  },
  readableEncoding: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState ? this._readableState.encoding : null
    }
  },
  errored: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState ? this._readableState.errored : null
    }
  },
  closed: {
    __proto__: null,
    get() {
      return this._readableState ? this._readableState.closed : false
    }
  },
  destroyed: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState ? this._readableState.destroyed : false
    },
    set(value) {
      // We ignore the value if the stream
      // has not been initialized yet.
      if (!this._readableState) {
        return
      }

      // Backward compatibility, the user is explicitly
      // managing destroyed.
      this._readableState.destroyed = value
    }
  },
  readableEnded: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._readableState ? this._readableState.endEmitted : false
    }
  }
})
ObjectDefineProperties(ReadableState.prototype, {
  // Legacy getter for `pipesCount`.
  pipesCount: {
    __proto__: null,
    get() {
      return this.pipes.length
    }
  },
  // Legacy property for `paused`.
  paused: {
    __proto__: null,
    get() {
      return this[kPaused] !== false
    },
    set(value) {
      this[kPaused] = !!value
    }
  }
})

// Exposed for testing purposes only.
Readable._fromList = fromList

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered.
  if (state.length === 0) return null
  let ret
  if (state.objectMode) ret = state.buffer.shift()
  else if (!n || n >= state.length) {
    // Read it all, truncate the list.
    if (state.decoder) ret = state.buffer.join('')
    else if (state.buffer.length === 1) ret = state.buffer.first()
    else ret = state.buffer.concat(state.length)
    state.buffer.clear()
  } else {
    // read part of list.
    ret = state.buffer.consume(n, state.decoder)
  }
  return ret
}
function endReadable(stream) {
  const state = stream._readableState
  debug('endReadable', state.endEmitted)
  if (!state.endEmitted) {
    state.ended = true
    process.nextTick(endReadableNT, state, stream)
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length)

  // Check that we didn't get one last unshift.
  if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
    state.endEmitted = true
    stream.emit('end')
    if (stream.writable && stream.allowHalfOpen === false) {
      process.nextTick(endWritableNT, stream)
    } else if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well.
      const wState = stream._writableState
      const autoDestroy =
        !wState ||
        (wState.autoDestroy &&
          // We don't expect the writable to ever 'finish'
          // if writable is explicitly set to false.
          (wState.finished || wState.writable === false))
      if (autoDestroy) {
        stream.destroy()
      }
    }
  }
}
function endWritableNT(stream) {
  const writable = stream.writable && !stream.writableEnded && !stream.destroyed
  if (writable) {
    stream.end()
  }
}
Readable.from = function (iterable, opts) {
  return from(Readable, iterable, opts)
}
let webStreamsAdapters

// Lazy to avoid circular references
function lazyWebStreams() {
  if (webStreamsAdapters === undefined) webStreamsAdapters = {}
  return webStreamsAdapters
}
Readable.fromWeb = function (readableStream, options) {
  return lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options)
}
Readable.toWeb = function (streamReadable, options) {
  return lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options)
}
Readable.wrap = function (src, options) {
  var _ref, _src$readableObjectMo
  return new Readable({
    objectMode:
      (_ref =
        (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined
          ? _src$readableObjectMo
          : src.objectMode) !== null && _ref !== undefined
        ? _ref
        : true,
    ...options,
    destroy(err, callback) {
      destroyImpl.destroyer(src, err)
      callback(err)
    }
  }).wrap(src)
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/state.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const { MathFloor, NumberIsInteger } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const { ERR_INVALID_ARG_VALUE } = (__webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js").codes)
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null
}
function getDefaultHighWaterMark(objectMode) {
  return objectMode ? 16 : 16 * 1024
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  const hwm = highWaterMarkFrom(options, isDuplex, duplexKey)
  if (hwm != null) {
    if (!NumberIsInteger(hwm) || hwm < 0) {
      const name = isDuplex ? `options.${duplexKey}` : 'options.highWaterMark'
      throw new ERR_INVALID_ARG_VALUE(name, hwm)
    }
    return MathFloor(hwm)
  }

  // Default value
  return getDefaultHighWaterMark(state.objectMode)
}
module.exports = {
  getHighWaterMark,
  getDefaultHighWaterMark
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/transform.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



const { ObjectSetPrototypeOf, Symbol } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
module.exports = Transform
const { ERR_METHOD_NOT_IMPLEMENTED } = (__webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js").codes)
const Duplex = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/duplex.js")
const { getHighWaterMark } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/state.js")
ObjectSetPrototypeOf(Transform.prototype, Duplex.prototype)
ObjectSetPrototypeOf(Transform, Duplex)
const kCallback = Symbol('kCallback')
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options)

  // TODO (ronag): This should preferably always be
  // applied but would be semver-major. Or even better;
  // make Transform a Readable with the Writable interface.
  const readableHighWaterMark = options ? getHighWaterMark(this, options, 'readableHighWaterMark', true) : null
  if (readableHighWaterMark === 0) {
    // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = {
      ...options,
      highWaterMark: null,
      readableHighWaterMark,
      // TODO (ronag): 0 is not optimal since we have
      // a "bug" where we check needDrain before calling _write and not after.
      // Refs: https://github.com/nodejs/node/pull/32887
      // Refs: https://github.com/nodejs/node/pull/35941
      writableHighWaterMark: options.writableHighWaterMark || 0
    }
  }
  Duplex.call(this, options)

  // We have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false
  this[kCallback] = null
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform
    if (typeof options.flush === 'function') this._flush = options.flush
  }

  // When the writable side finishes, then flush out anything remaining.
  // Backwards compat. Some Transform streams incorrectly implement _final
  // instead of or in addition to _flush. By using 'prefinish' instead of
  // implementing _final we continue supporting this unfortunate use case.
  this.on('prefinish', prefinish)
}
function final(cb) {
  if (typeof this._flush === 'function' && !this.destroyed) {
    this._flush((er, data) => {
      if (er) {
        if (cb) {
          cb(er)
        } else {
          this.destroy(er)
        }
        return
      }
      if (data != null) {
        this.push(data)
      }
      this.push(null)
      if (cb) {
        cb()
      }
    })
  } else {
    this.push(null)
    if (cb) {
      cb()
    }
  }
}
function prefinish() {
  if (this._final !== final) {
    final.call(this)
  }
}
Transform.prototype._final = final
Transform.prototype._transform = function (chunk, encoding, callback) {
  throw new ERR_METHOD_NOT_IMPLEMENTED('_transform()')
}
Transform.prototype._write = function (chunk, encoding, callback) {
  const rState = this._readableState
  const wState = this._writableState
  const length = rState.length
  this._transform(chunk, encoding, (err, val) => {
    if (err) {
      callback(err)
      return
    }
    if (val != null) {
      this.push(val)
    }
    if (
      wState.ended ||
      // Backwards compat.
      length === rState.length ||
      // Backwards compat.
      rState.length < rState.highWaterMark
    ) {
      callback()
    } else {
      this[kCallback] = callback
    }
  })
}
Transform.prototype._read = function () {
  if (this[kCallback]) {
    const callback = this[kCallback]
    this[kCallback] = null
    callback()
  }
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/utils.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const { Symbol, SymbolAsyncIterator, SymbolIterator, SymbolFor } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const kDestroyed = Symbol('kDestroyed')
const kIsErrored = Symbol('kIsErrored')
const kIsReadable = Symbol('kIsReadable')
const kIsDisturbed = Symbol('kIsDisturbed')
const kIsClosedPromise = SymbolFor('nodejs.webstream.isClosedPromise')
const kControllerErrorFunction = SymbolFor('nodejs.webstream.controllerErrorFunction')
function isReadableNodeStream(obj, strict = false) {
  var _obj$_readableState
  return !!(
    (
      obj &&
      typeof obj.pipe === 'function' &&
      typeof obj.on === 'function' &&
      (!strict || (typeof obj.pause === 'function' && typeof obj.resume === 'function')) &&
      (!obj._writableState ||
        ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined
          ? undefined
          : _obj$_readableState.readable) !== false) &&
      // Duplex
      (!obj._writableState || obj._readableState)
    ) // Writable has .pipe.
  )
}

function isWritableNodeStream(obj) {
  var _obj$_writableState
  return !!(
    (
      obj &&
      typeof obj.write === 'function' &&
      typeof obj.on === 'function' &&
      (!obj._readableState ||
        ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined
          ? undefined
          : _obj$_writableState.writable) !== false)
    ) // Duplex
  )
}

function isDuplexNodeStream(obj) {
  return !!(
    obj &&
    typeof obj.pipe === 'function' &&
    obj._readableState &&
    typeof obj.on === 'function' &&
    typeof obj.write === 'function'
  )
}
function isNodeStream(obj) {
  return (
    obj &&
    (obj._readableState ||
      obj._writableState ||
      (typeof obj.write === 'function' && typeof obj.on === 'function') ||
      (typeof obj.pipe === 'function' && typeof obj.on === 'function'))
  )
}
function isReadableStream(obj) {
  return !!(
    obj &&
    !isNodeStream(obj) &&
    typeof obj.pipeThrough === 'function' &&
    typeof obj.getReader === 'function' &&
    typeof obj.cancel === 'function'
  )
}
function isWritableStream(obj) {
  return !!(obj && !isNodeStream(obj) && typeof obj.getWriter === 'function' && typeof obj.abort === 'function')
}
function isTransformStream(obj) {
  return !!(obj && !isNodeStream(obj) && typeof obj.readable === 'object' && typeof obj.writable === 'object')
}
function isWebStream(obj) {
  return isReadableStream(obj) || isWritableStream(obj) || isTransformStream(obj)
}
function isIterable(obj, isAsync) {
  if (obj == null) return false
  if (isAsync === true) return typeof obj[SymbolAsyncIterator] === 'function'
  if (isAsync === false) return typeof obj[SymbolIterator] === 'function'
  return typeof obj[SymbolAsyncIterator] === 'function' || typeof obj[SymbolIterator] === 'function'
}
function isDestroyed(stream) {
  if (!isNodeStream(stream)) return null
  const wState = stream._writableState
  const rState = stream._readableState
  const state = wState || rState
  return !!(stream.destroyed || stream[kDestroyed] || (state !== null && state !== undefined && state.destroyed))
}

// Have been end():d.
function isWritableEnded(stream) {
  if (!isWritableNodeStream(stream)) return null
  if (stream.writableEnded === true) return true
  const wState = stream._writableState
  if (wState !== null && wState !== undefined && wState.errored) return false
  if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== 'boolean') return null
  return wState.ended
}

// Have emitted 'finish'.
function isWritableFinished(stream, strict) {
  if (!isWritableNodeStream(stream)) return null
  if (stream.writableFinished === true) return true
  const wState = stream._writableState
  if (wState !== null && wState !== undefined && wState.errored) return false
  if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== 'boolean') return null
  return !!(wState.finished || (strict === false && wState.ended === true && wState.length === 0))
}

// Have been push(null):d.
function isReadableEnded(stream) {
  if (!isReadableNodeStream(stream)) return null
  if (stream.readableEnded === true) return true
  const rState = stream._readableState
  if (!rState || rState.errored) return false
  if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== 'boolean') return null
  return rState.ended
}

// Have emitted 'end'.
function isReadableFinished(stream, strict) {
  if (!isReadableNodeStream(stream)) return null
  const rState = stream._readableState
  if (rState !== null && rState !== undefined && rState.errored) return false
  if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== 'boolean') return null
  return !!(rState.endEmitted || (strict === false && rState.ended === true && rState.length === 0))
}
function isReadable(stream) {
  if (stream && stream[kIsReadable] != null) return stream[kIsReadable]
  if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== 'boolean') return null
  if (isDestroyed(stream)) return false
  return isReadableNodeStream(stream) && stream.readable && !isReadableFinished(stream)
}
function isWritable(stream) {
  if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== 'boolean') return null
  if (isDestroyed(stream)) return false
  return isWritableNodeStream(stream) && stream.writable && !isWritableEnded(stream)
}
function isFinished(stream, opts) {
  if (!isNodeStream(stream)) {
    return null
  }
  if (isDestroyed(stream)) {
    return true
  }
  if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && isReadable(stream)) {
    return false
  }
  if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && isWritable(stream)) {
    return false
  }
  return true
}
function isWritableErrored(stream) {
  var _stream$_writableStat, _stream$_writableStat2
  if (!isNodeStream(stream)) {
    return null
  }
  if (stream.writableErrored) {
    return stream.writableErrored
  }
  return (_stream$_writableStat =
    (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined
      ? undefined
      : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined
    ? _stream$_writableStat
    : null
}
function isReadableErrored(stream) {
  var _stream$_readableStat, _stream$_readableStat2
  if (!isNodeStream(stream)) {
    return null
  }
  if (stream.readableErrored) {
    return stream.readableErrored
  }
  return (_stream$_readableStat =
    (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined
      ? undefined
      : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined
    ? _stream$_readableStat
    : null
}
function isClosed(stream) {
  if (!isNodeStream(stream)) {
    return null
  }
  if (typeof stream.closed === 'boolean') {
    return stream.closed
  }
  const wState = stream._writableState
  const rState = stream._readableState
  if (
    typeof (wState === null || wState === undefined ? undefined : wState.closed) === 'boolean' ||
    typeof (rState === null || rState === undefined ? undefined : rState.closed) === 'boolean'
  ) {
    return (
      (wState === null || wState === undefined ? undefined : wState.closed) ||
      (rState === null || rState === undefined ? undefined : rState.closed)
    )
  }
  if (typeof stream._closed === 'boolean' && isOutgoingMessage(stream)) {
    return stream._closed
  }
  return null
}
function isOutgoingMessage(stream) {
  return (
    typeof stream._closed === 'boolean' &&
    typeof stream._defaultKeepAlive === 'boolean' &&
    typeof stream._removedConnection === 'boolean' &&
    typeof stream._removedContLen === 'boolean'
  )
}
function isServerResponse(stream) {
  return typeof stream._sent100 === 'boolean' && isOutgoingMessage(stream)
}
function isServerRequest(stream) {
  var _stream$req
  return (
    typeof stream._consuming === 'boolean' &&
    typeof stream._dumped === 'boolean' &&
    ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) ===
      undefined
  )
}
function willEmitClose(stream) {
  if (!isNodeStream(stream)) return null
  const wState = stream._writableState
  const rState = stream._readableState
  const state = wState || rState
  return (
    (!state && isServerResponse(stream)) || !!(state && state.autoDestroy && state.emitClose && state.closed === false)
  )
}
function isDisturbed(stream) {
  var _stream$kIsDisturbed
  return !!(
    stream &&
    ((_stream$kIsDisturbed = stream[kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined
      ? _stream$kIsDisturbed
      : stream.readableDidRead || stream.readableAborted)
  )
}
function isErrored(stream) {
  var _ref,
    _ref2,
    _ref3,
    _ref4,
    _ref5,
    _stream$kIsErrored,
    _stream$_readableStat3,
    _stream$_writableStat3,
    _stream$_readableStat4,
    _stream$_writableStat4
  return !!(
    stream &&
    ((_ref =
      (_ref2 =
        (_ref3 =
          (_ref4 =
            (_ref5 =
              (_stream$kIsErrored = stream[kIsErrored]) !== null && _stream$kIsErrored !== undefined
                ? _stream$kIsErrored
                : stream.readableErrored) !== null && _ref5 !== undefined
              ? _ref5
              : stream.writableErrored) !== null && _ref4 !== undefined
            ? _ref4
            : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined
            ? undefined
            : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined
          ? _ref3
          : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined
          ? undefined
          : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined
        ? _ref2
        : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined
        ? undefined
        : _stream$_readableStat4.errored) !== null && _ref !== undefined
      ? _ref
      : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined
      ? undefined
      : _stream$_writableStat4.errored)
  )
}
module.exports = {
  kDestroyed,
  isDisturbed,
  kIsDisturbed,
  isErrored,
  kIsErrored,
  isReadable,
  kIsReadable,
  kIsClosedPromise,
  kControllerErrorFunction,
  isClosed,
  isDestroyed,
  isDuplexNodeStream,
  isFinished,
  isIterable,
  isReadableNodeStream,
  isReadableStream,
  isReadableEnded,
  isReadableFinished,
  isReadableErrored,
  isNodeStream,
  isWebStream,
  isWritable,
  isWritableNodeStream,
  isWritableStream,
  isWritableEnded,
  isWritableFinished,
  isWritableErrored,
  isServerRequest,
  isServerResponse,
  willEmitClose,
  isTransformStream
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/streams/writable.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* replacement start */

const process = __webpack_require__("../../node_modules/process/browser.js")

/* replacement end */
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

;('use strict')
const {
  ArrayPrototypeSlice,
  Error,
  FunctionPrototypeSymbolHasInstance,
  ObjectDefineProperty,
  ObjectDefineProperties,
  ObjectSetPrototypeOf,
  StringPrototypeToLowerCase,
  Symbol,
  SymbolHasInstance
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
module.exports = Writable
Writable.WritableState = WritableState
const { EventEmitter: EE } = __webpack_require__("../../node_modules/events/events.js")
const Stream = (__webpack_require__("../../node_modules/readable-stream/lib/internal/streams/legacy.js").Stream)
const { Buffer } = __webpack_require__("../../node_modules/buffer/index.js")
const destroyImpl = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/destroy.js")
const { addAbortSignal } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/add-abort-signal.js")
const { getHighWaterMark, getDefaultHighWaterMark } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/state.js")
const {
  ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED,
  ERR_STREAM_ALREADY_FINISHED,
  ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING
} = (__webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js").codes)
const { errorOrDestroy } = destroyImpl
ObjectSetPrototypeOf(Writable.prototype, Stream.prototype)
ObjectSetPrototypeOf(Writable, Stream)
function nop() {}
const kOnFinished = Symbol('kOnFinished')
function WritableState(options, stream, isDuplex) {
  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/duplex.js")

  // Object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!(options && options.objectMode)
  if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode)

  // The point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write().
  this.highWaterMark = options
    ? getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex)
    : getDefaultHighWaterMark(false)

  // if _final has been called.
  this.finalCalled = false

  // drain event flag.
  this.needDrain = false
  // At the start of calling end()
  this.ending = false
  // When end() has been called, and returned.
  this.ended = false
  // When 'finish' is emitted.
  this.finished = false

  // Has it been destroyed
  this.destroyed = false

  // Should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  const noDecode = !!(options && options.decodeStrings === false)
  this.decodeStrings = !noDecode

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = (options && options.defaultEncoding) || 'utf8'

  // Not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0

  // A flag to see when we're in the middle of a write.
  this.writing = false

  // When true all writes will be buffered until .uncork() call.
  this.corked = 0

  // A flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true

  // A flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false

  // The callback that's passed to _write(chunk, cb).
  this.onwrite = onwrite.bind(undefined, stream)

  // The callback that the user supplies to write(chunk, encoding, cb).
  this.writecb = null

  // The amount that is being written when _write is called.
  this.writelen = 0

  // Storage for data passed to the afterWrite() callback in case of
  // synchronous _write() completion.
  this.afterWriteTickInfo = null
  resetBuffer(this)

  // Number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted.
  this.pendingcb = 0

  // Stream is still being constructed and cannot be
  // destroyed until construction finished or failed.
  // Async construction is opt in, therefore we start as
  // constructed.
  this.constructed = true

  // Emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams.
  this.prefinished = false

  // True if the error was already emitted and should not be thrown again.
  this.errorEmitted = false

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = !options || options.emitClose !== false

  // Should .destroy() be called after 'finish' (and potentially 'end').
  this.autoDestroy = !options || options.autoDestroy !== false

  // Indicates whether the stream has errored. When true all write() calls
  // should return false. This is needed since when autoDestroy
  // is disabled we need a way to tell whether the stream has failed.
  this.errored = null

  // Indicates whether the stream has finished destroying.
  this.closed = false

  // True if close has been emitted or would have been emitted
  // depending on emitClose.
  this.closeEmitted = false
  this[kOnFinished] = []
}
function resetBuffer(state) {
  state.buffered = []
  state.bufferedIndex = 0
  state.allBuffers = true
  state.allNoop = true
}
WritableState.prototype.getBuffer = function getBuffer() {
  return ArrayPrototypeSlice(this.buffered, this.bufferedIndex)
}
ObjectDefineProperty(WritableState.prototype, 'bufferedRequestCount', {
  __proto__: null,
  get() {
    return this.buffered.length - this.bufferedIndex
  }
})
function Writable(options) {
  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5.
  const isDuplex = this instanceof __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/duplex.js")
  if (!isDuplex && !FunctionPrototypeSymbolHasInstance(Writable, this)) return new Writable(options)
  this._writableState = new WritableState(options, this, isDuplex)
  if (options) {
    if (typeof options.write === 'function') this._write = options.write
    if (typeof options.writev === 'function') this._writev = options.writev
    if (typeof options.destroy === 'function') this._destroy = options.destroy
    if (typeof options.final === 'function') this._final = options.final
    if (typeof options.construct === 'function') this._construct = options.construct
    if (options.signal) addAbortSignal(options.signal, this)
  }
  Stream.call(this, options)
  destroyImpl.construct(this, () => {
    const state = this._writableState
    if (!state.writing) {
      clearBuffer(this, state)
    }
    finishMaybe(this, state)
  })
}
ObjectDefineProperty(Writable, SymbolHasInstance, {
  __proto__: null,
  value: function (object) {
    if (FunctionPrototypeSymbolHasInstance(this, object)) return true
    if (this !== Writable) return false
    return object && object._writableState instanceof WritableState
  }
})

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE())
}
function _write(stream, chunk, encoding, cb) {
  const state = stream._writableState
  if (typeof encoding === 'function') {
    cb = encoding
    encoding = state.defaultEncoding
  } else {
    if (!encoding) encoding = state.defaultEncoding
    else if (encoding !== 'buffer' && !Buffer.isEncoding(encoding)) throw new ERR_UNKNOWN_ENCODING(encoding)
    if (typeof cb !== 'function') cb = nop
  }
  if (chunk === null) {
    throw new ERR_STREAM_NULL_VALUES()
  } else if (!state.objectMode) {
    if (typeof chunk === 'string') {
      if (state.decodeStrings !== false) {
        chunk = Buffer.from(chunk, encoding)
        encoding = 'buffer'
      }
    } else if (chunk instanceof Buffer) {
      encoding = 'buffer'
    } else if (Stream._isUint8Array(chunk)) {
      chunk = Stream._uint8ArrayToBuffer(chunk)
      encoding = 'buffer'
    } else {
      throw new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk)
    }
  }
  let err
  if (state.ending) {
    err = new ERR_STREAM_WRITE_AFTER_END()
  } else if (state.destroyed) {
    err = new ERR_STREAM_DESTROYED('write')
  }
  if (err) {
    process.nextTick(cb, err)
    errorOrDestroy(stream, err, true)
    return err
  }
  state.pendingcb++
  return writeOrBuffer(stream, state, chunk, encoding, cb)
}
Writable.prototype.write = function (chunk, encoding, cb) {
  return _write(this, chunk, encoding, cb) === true
}
Writable.prototype.cork = function () {
  this._writableState.corked++
}
Writable.prototype.uncork = function () {
  const state = this._writableState
  if (state.corked) {
    state.corked--
    if (!state.writing) clearBuffer(this, state)
  }
}
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = StringPrototypeToLowerCase(encoding)
  if (!Buffer.isEncoding(encoding)) throw new ERR_UNKNOWN_ENCODING(encoding)
  this._writableState.defaultEncoding = encoding
  return this
}

// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, callback) {
  const len = state.objectMode ? 1 : chunk.length
  state.length += len

  // stream._write resets state.length
  const ret = state.length < state.highWaterMark
  // We must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true
  if (state.writing || state.corked || state.errored || !state.constructed) {
    state.buffered.push({
      chunk,
      encoding,
      callback
    })
    if (state.allBuffers && encoding !== 'buffer') {
      state.allBuffers = false
    }
    if (state.allNoop && callback !== nop) {
      state.allNoop = false
    }
  } else {
    state.writelen = len
    state.writecb = callback
    state.writing = true
    state.sync = true
    stream._write(chunk, encoding, state.onwrite)
    state.sync = false
  }

  // Return false if errored or destroyed in order to break
  // any synchronous while(stream.write(data)) loops.
  return ret && !state.errored && !state.destroyed
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len
  state.writecb = cb
  state.writing = true
  state.sync = true
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'))
  else if (writev) stream._writev(chunk, state.onwrite)
  else stream._write(chunk, encoding, state.onwrite)
  state.sync = false
}
function onwriteError(stream, state, er, cb) {
  --state.pendingcb
  cb(er)
  // Ensure callbacks are invoked even when autoDestroy is
  // not enabled. Passing `er` here doesn't make sense since
  // it's related to one specific write, not to the buffered
  // writes.
  errorBuffer(state)
  // This can emit error, but error must always follow cb.
  errorOrDestroy(stream, er)
}
function onwrite(stream, er) {
  const state = stream._writableState
  const sync = state.sync
  const cb = state.writecb
  if (typeof cb !== 'function') {
    errorOrDestroy(stream, new ERR_MULTIPLE_CALLBACK())
    return
  }
  state.writing = false
  state.writecb = null
  state.length -= state.writelen
  state.writelen = 0
  if (er) {
    // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
    er.stack // eslint-disable-line no-unused-expressions

    if (!state.errored) {
      state.errored = er
    }

    // In case of duplex streams we need to notify the readable side of the
    // error.
    if (stream._readableState && !stream._readableState.errored) {
      stream._readableState.errored = er
    }
    if (sync) {
      process.nextTick(onwriteError, stream, state, er, cb)
    } else {
      onwriteError(stream, state, er, cb)
    }
  } else {
    if (state.buffered.length > state.bufferedIndex) {
      clearBuffer(stream, state)
    }
    if (sync) {
      // It is a common case that the callback passed to .write() is always
      // the same. In that case, we do not schedule a new nextTick(), but
      // rather just increase a counter, to improve performance and avoid
      // memory allocations.
      if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) {
        state.afterWriteTickInfo.count++
      } else {
        state.afterWriteTickInfo = {
          count: 1,
          cb,
          stream,
          state
        }
        process.nextTick(afterWriteTick, state.afterWriteTickInfo)
      }
    } else {
      afterWrite(stream, state, 1, cb)
    }
  }
}
function afterWriteTick({ stream, state, count, cb }) {
  state.afterWriteTickInfo = null
  return afterWrite(stream, state, count, cb)
}
function afterWrite(stream, state, count, cb) {
  const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain
  if (needDrain) {
    state.needDrain = false
    stream.emit('drain')
  }
  while (count-- > 0) {
    state.pendingcb--
    cb()
  }
  if (state.destroyed) {
    errorBuffer(state)
  }
  finishMaybe(stream, state)
}

// If there's something in the buffer waiting, then invoke callbacks.
function errorBuffer(state) {
  if (state.writing) {
    return
  }
  for (let n = state.bufferedIndex; n < state.buffered.length; ++n) {
    var _state$errored
    const { chunk, callback } = state.buffered[n]
    const len = state.objectMode ? 1 : chunk.length
    state.length -= len
    callback(
      (_state$errored = state.errored) !== null && _state$errored !== undefined
        ? _state$errored
        : new ERR_STREAM_DESTROYED('write')
    )
  }
  const onfinishCallbacks = state[kOnFinished].splice(0)
  for (let i = 0; i < onfinishCallbacks.length; i++) {
    var _state$errored2
    onfinishCallbacks[i](
      (_state$errored2 = state.errored) !== null && _state$errored2 !== undefined
        ? _state$errored2
        : new ERR_STREAM_DESTROYED('end')
    )
  }
  resetBuffer(state)
}

// If there's something in the buffer waiting, then process it.
function clearBuffer(stream, state) {
  if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) {
    return
  }
  const { buffered, bufferedIndex, objectMode } = state
  const bufferedLength = buffered.length - bufferedIndex
  if (!bufferedLength) {
    return
  }
  let i = bufferedIndex
  state.bufferProcessing = true
  if (bufferedLength > 1 && stream._writev) {
    state.pendingcb -= bufferedLength - 1
    const callback = state.allNoop
      ? nop
      : (err) => {
          for (let n = i; n < buffered.length; ++n) {
            buffered[n].callback(err)
          }
        }
    // Make a copy of `buffered` if it's going to be used by `callback` above,
    // since `doWrite` will mutate the array.
    const chunks = state.allNoop && i === 0 ? buffered : ArrayPrototypeSlice(buffered, i)
    chunks.allBuffers = state.allBuffers
    doWrite(stream, state, true, state.length, chunks, '', callback)
    resetBuffer(state)
  } else {
    do {
      const { chunk, encoding, callback } = buffered[i]
      buffered[i++] = null
      const len = objectMode ? 1 : chunk.length
      doWrite(stream, state, false, len, chunk, encoding, callback)
    } while (i < buffered.length && !state.writing)
    if (i === buffered.length) {
      resetBuffer(state)
    } else if (i > 256) {
      buffered.splice(0, i)
      state.bufferedIndex = 0
    } else {
      state.bufferedIndex = i
    }
  }
  state.bufferProcessing = false
}
Writable.prototype._write = function (chunk, encoding, cb) {
  if (this._writev) {
    this._writev(
      [
        {
          chunk,
          encoding
        }
      ],
      cb
    )
  } else {
    throw new ERR_METHOD_NOT_IMPLEMENTED('_write()')
  }
}
Writable.prototype._writev = null
Writable.prototype.end = function (chunk, encoding, cb) {
  const state = this._writableState
  if (typeof chunk === 'function') {
    cb = chunk
    chunk = null
    encoding = null
  } else if (typeof encoding === 'function') {
    cb = encoding
    encoding = null
  }
  let err
  if (chunk !== null && chunk !== undefined) {
    const ret = _write(this, chunk, encoding)
    if (ret instanceof Error) {
      err = ret
    }
  }

  // .end() fully uncorks.
  if (state.corked) {
    state.corked = 1
    this.uncork()
  }
  if (err) {
    // Do nothing...
  } else if (!state.errored && !state.ending) {
    // This is forgiving in terms of unnecessary calls to end() and can hide
    // logic errors. However, usually such errors are harmless and causing a
    // hard error can be disproportionately destructive. It is not always
    // trivial for the user to determine whether end() needs to be called
    // or not.

    state.ending = true
    finishMaybe(this, state, true)
    state.ended = true
  } else if (state.finished) {
    err = new ERR_STREAM_ALREADY_FINISHED('end')
  } else if (state.destroyed) {
    err = new ERR_STREAM_DESTROYED('end')
  }
  if (typeof cb === 'function') {
    if (err || state.finished) {
      process.nextTick(cb, err)
    } else {
      state[kOnFinished].push(cb)
    }
  }
  return this
}
function needFinish(state) {
  return (
    state.ending &&
    !state.destroyed &&
    state.constructed &&
    state.length === 0 &&
    !state.errored &&
    state.buffered.length === 0 &&
    !state.finished &&
    !state.writing &&
    !state.errorEmitted &&
    !state.closeEmitted
  )
}
function callFinal(stream, state) {
  let called = false
  function onFinish(err) {
    if (called) {
      errorOrDestroy(stream, err !== null && err !== undefined ? err : ERR_MULTIPLE_CALLBACK())
      return
    }
    called = true
    state.pendingcb--
    if (err) {
      const onfinishCallbacks = state[kOnFinished].splice(0)
      for (let i = 0; i < onfinishCallbacks.length; i++) {
        onfinishCallbacks[i](err)
      }
      errorOrDestroy(stream, err, state.sync)
    } else if (needFinish(state)) {
      state.prefinished = true
      stream.emit('prefinish')
      // Backwards compat. Don't check state.sync here.
      // Some streams assume 'finish' will be emitted
      // asynchronously relative to _final callback.
      state.pendingcb++
      process.nextTick(finish, stream, state)
    }
  }
  state.sync = true
  state.pendingcb++
  try {
    stream._final(onFinish)
  } catch (err) {
    onFinish(err)
  }
  state.sync = false
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.finalCalled = true
      callFinal(stream, state)
    } else {
      state.prefinished = true
      stream.emit('prefinish')
    }
  }
}
function finishMaybe(stream, state, sync) {
  if (needFinish(state)) {
    prefinish(stream, state)
    if (state.pendingcb === 0) {
      if (sync) {
        state.pendingcb++
        process.nextTick(
          (stream, state) => {
            if (needFinish(state)) {
              finish(stream, state)
            } else {
              state.pendingcb--
            }
          },
          stream,
          state
        )
      } else if (needFinish(state)) {
        state.pendingcb++
        finish(stream, state)
      }
    }
  }
}
function finish(stream, state) {
  state.pendingcb--
  state.finished = true
  const onfinishCallbacks = state[kOnFinished].splice(0)
  for (let i = 0; i < onfinishCallbacks.length; i++) {
    onfinishCallbacks[i]()
  }
  stream.emit('finish')
  if (state.autoDestroy) {
    // In case of duplex streams we need a way to detect
    // if the readable side is ready for autoDestroy as well.
    const rState = stream._readableState
    const autoDestroy =
      !rState ||
      (rState.autoDestroy &&
        // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false))
    if (autoDestroy) {
      stream.destroy()
    }
  }
}
ObjectDefineProperties(Writable.prototype, {
  closed: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.closed : false
    }
  },
  destroyed: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.destroyed : false
    },
    set(value) {
      // Backward compatibility, the user is explicitly managing destroyed.
      if (this._writableState) {
        this._writableState.destroyed = value
      }
    }
  },
  writable: {
    __proto__: null,
    get() {
      const w = this._writableState
      // w.writable === false means that this is part of a Duplex stream
      // where the writable side was disabled upon construction.
      // Compat. The user might manually disable writable side through
      // deprecated setter.
      return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended
    },
    set(val) {
      // Backwards compatible.
      if (this._writableState) {
        this._writableState.writable = !!val
      }
    }
  },
  writableFinished: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.finished : false
    }
  },
  writableObjectMode: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.objectMode : false
    }
  },
  writableBuffer: {
    __proto__: null,
    get() {
      return this._writableState && this._writableState.getBuffer()
    }
  },
  writableEnded: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.ending : false
    }
  },
  writableNeedDrain: {
    __proto__: null,
    get() {
      const wState = this._writableState
      if (!wState) return false
      return !wState.destroyed && !wState.ending && wState.needDrain
    }
  },
  writableHighWaterMark: {
    __proto__: null,
    get() {
      return this._writableState && this._writableState.highWaterMark
    }
  },
  writableCorked: {
    __proto__: null,
    get() {
      return this._writableState ? this._writableState.corked : 0
    }
  },
  writableLength: {
    __proto__: null,
    get() {
      return this._writableState && this._writableState.length
    }
  },
  errored: {
    __proto__: null,
    enumerable: false,
    get() {
      return this._writableState ? this._writableState.errored : null
    }
  },
  writableAborted: {
    __proto__: null,
    enumerable: false,
    get: function () {
      return !!(
        this._writableState.writable !== false &&
        (this._writableState.destroyed || this._writableState.errored) &&
        !this._writableState.finished
      )
    }
  }
})
const destroy = destroyImpl.destroy
Writable.prototype.destroy = function (err, cb) {
  const state = this._writableState

  // Invoke pending callbacks.
  if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[kOnFinished].length)) {
    process.nextTick(errorBuffer, state)
  }
  destroy.call(this, err, cb)
  return this
}
Writable.prototype._undestroy = destroyImpl.undestroy
Writable.prototype._destroy = function (err, cb) {
  cb(err)
}
Writable.prototype[EE.captureRejectionSymbol] = function (err) {
  this.destroy(err)
}
let webStreamsAdapters

// Lazy to avoid circular references
function lazyWebStreams() {
  if (webStreamsAdapters === undefined) webStreamsAdapters = {}
  return webStreamsAdapters
}
Writable.fromWeb = function (writableStream, options) {
  return lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options)
}
Writable.toWeb = function (streamWritable) {
  return lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable)
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/internal/validators.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* eslint jsdoc/require-jsdoc: "error" */



const {
  ArrayIsArray,
  ArrayPrototypeIncludes,
  ArrayPrototypeJoin,
  ArrayPrototypeMap,
  NumberIsInteger,
  NumberIsNaN,
  NumberMAX_SAFE_INTEGER,
  NumberMIN_SAFE_INTEGER,
  NumberParseInt,
  ObjectPrototypeHasOwnProperty,
  RegExpPrototypeExec,
  String,
  StringPrototypeToUpperCase,
  StringPrototypeTrim
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const {
  hideStackFrames,
  codes: { ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL }
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js")
const { normalizeEncoding } = __webpack_require__("../../node_modules/readable-stream/lib/ours/util.js")
const { isAsyncFunction, isArrayBufferView } = (__webpack_require__("../../node_modules/readable-stream/lib/ours/util.js").types)
const signals = {}

/**
 * @param {*} value
 * @returns {boolean}
 */
function isInt32(value) {
  return value === (value | 0)
}

/**
 * @param {*} value
 * @returns {boolean}
 */
function isUint32(value) {
  return value === value >>> 0
}
const octalReg = /^[0-7]+$/
const modeDesc = 'must be a 32-bit unsigned integer or an octal string'

/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 *
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */
function parseFileMode(value, name, def) {
  if (typeof value === 'undefined') {
    value = def
  }
  if (typeof value === 'string') {
    if (RegExpPrototypeExec(octalReg, value) === null) {
      throw new ERR_INVALID_ARG_VALUE(name, value, modeDesc)
    }
    value = NumberParseInt(value, 8)
  }
  validateUint32(value, name)
  return value
}

/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */

/** @type {validateInteger} */
const validateInteger = hideStackFrames((value, name, min = NumberMIN_SAFE_INTEGER, max = NumberMAX_SAFE_INTEGER) => {
  if (typeof value !== 'number') throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  if (!NumberIsInteger(value)) throw new ERR_OUT_OF_RANGE(name, 'an integer', value)
  if (value < min || value > max) throw new ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value)
})

/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */

/** @type {validateInt32} */
const validateInt32 = hideStackFrames((value, name, min = -2147483648, max = 2147483647) => {
  // The defaults for min and max correspond to the limits of 32-bit integers.
  if (typeof value !== 'number') {
    throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
  if (!NumberIsInteger(value)) {
    throw new ERR_OUT_OF_RANGE(name, 'an integer', value)
  }
  if (value < min || value > max) {
    throw new ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value)
  }
})

/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */

/** @type {validateUint32} */
const validateUint32 = hideStackFrames((value, name, positive = false) => {
  if (typeof value !== 'number') {
    throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  }
  if (!NumberIsInteger(value)) {
    throw new ERR_OUT_OF_RANGE(name, 'an integer', value)
  }
  const min = positive ? 1 : 0
  // 2 ** 32 === 4294967296
  const max = 4294967295
  if (value < min || value > max) {
    throw new ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value)
  }
})

/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */

/** @type {validateString} */
function validateString(value, name) {
  if (typeof value !== 'string') throw new ERR_INVALID_ARG_TYPE(name, 'string', value)
}

/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */

/** @type {validateNumber} */
function validateNumber(value, name, min = undefined, max) {
  if (typeof value !== 'number') throw new ERR_INVALID_ARG_TYPE(name, 'number', value)
  if (
    (min != null && value < min) ||
    (max != null && value > max) ||
    ((min != null || max != null) && NumberIsNaN(value))
  ) {
    throw new ERR_OUT_OF_RANGE(
      name,
      `${min != null ? `>= ${min}` : ''}${min != null && max != null ? ' && ' : ''}${max != null ? `<= ${max}` : ''}`,
      value
    )
  }
}

/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */

/** @type {validateOneOf} */
const validateOneOf = hideStackFrames((value, name, oneOf) => {
  if (!ArrayPrototypeIncludes(oneOf, value)) {
    const allowed = ArrayPrototypeJoin(
      ArrayPrototypeMap(oneOf, (v) => (typeof v === 'string' ? `'${v}'` : String(v))),
      ', '
    )
    const reason = 'must be one of: ' + allowed
    throw new ERR_INVALID_ARG_VALUE(name, value, reason)
  }
})

/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */

/** @type {validateBoolean} */
function validateBoolean(value, name) {
  if (typeof value !== 'boolean') throw new ERR_INVALID_ARG_TYPE(name, 'boolean', value)
}

/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */
function getOwnPropertyValueOrDefault(options, key, defaultValue) {
  return options == null || !ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key]
}

/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */

/** @type {validateObject} */
const validateObject = hideStackFrames((value, name, options = null) => {
  const allowArray = getOwnPropertyValueOrDefault(options, 'allowArray', false)
  const allowFunction = getOwnPropertyValueOrDefault(options, 'allowFunction', false)
  const nullable = getOwnPropertyValueOrDefault(options, 'nullable', false)
  if (
    (!nullable && value === null) ||
    (!allowArray && ArrayIsArray(value)) ||
    (typeof value !== 'object' && (!allowFunction || typeof value !== 'function'))
  ) {
    throw new ERR_INVALID_ARG_TYPE(name, 'Object', value)
  }
})

/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */

/** @type {validateDictionary} */
const validateDictionary = hideStackFrames((value, name) => {
  if (value != null && typeof value !== 'object' && typeof value !== 'function') {
    throw new ERR_INVALID_ARG_TYPE(name, 'a dictionary', value)
  }
})

/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */

/** @type {validateArray} */
const validateArray = hideStackFrames((value, name, minLength = 0) => {
  if (!ArrayIsArray(value)) {
    throw new ERR_INVALID_ARG_TYPE(name, 'Array', value)
  }
  if (value.length < minLength) {
    const reason = `must be longer than ${minLength}`
    throw new ERR_INVALID_ARG_VALUE(name, value, reason)
  }
})

/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */

/** @type {validateStringArray} */
function validateStringArray(value, name) {
  validateArray(value, name)
  for (let i = 0; i < value.length; i++) {
    validateString(value[i], `${name}[${i}]`)
  }
}

/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */

/** @type {validateBooleanArray} */
function validateBooleanArray(value, name) {
  validateArray(value, name)
  for (let i = 0; i < value.length; i++) {
    validateBoolean(value[i], `${name}[${i}]`)
  }
}

/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */
function validateSignalName(signal, name = 'signal') {
  validateString(signal, name)
  if (signals[signal] === undefined) {
    if (signals[StringPrototypeToUpperCase(signal)] !== undefined) {
      throw new ERR_UNKNOWN_SIGNAL(signal + ' (signals must use all capital letters)')
    }
    throw new ERR_UNKNOWN_SIGNAL(signal)
  }
}

/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */

/** @type {validateBuffer} */
const validateBuffer = hideStackFrames((buffer, name = 'buffer') => {
  if (!isArrayBufferView(buffer)) {
    throw new ERR_INVALID_ARG_TYPE(name, ['Buffer', 'TypedArray', 'DataView'], buffer)
  }
})

/**
 * @param {string} data
 * @param {string} encoding
 */
function validateEncoding(data, encoding) {
  const normalizedEncoding = normalizeEncoding(encoding)
  const length = data.length
  if (normalizedEncoding === 'hex' && length % 2 !== 0) {
    throw new ERR_INVALID_ARG_VALUE('encoding', encoding, `is invalid for data of length ${length}`)
  }
}

/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */
function validatePort(port, name = 'Port', allowZero = true) {
  if (
    (typeof port !== 'number' && typeof port !== 'string') ||
    (typeof port === 'string' && StringPrototypeTrim(port).length === 0) ||
    +port !== +port >>> 0 ||
    port > 0xffff ||
    (port === 0 && !allowZero)
  ) {
    throw new ERR_SOCKET_BAD_PORT(name, port, allowZero)
  }
  return port | 0
}

/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */

/** @type {validateAbortSignal} */
const validateAbortSignal = hideStackFrames((signal, name) => {
  if (signal !== undefined && (signal === null || typeof signal !== 'object' || !('aborted' in signal))) {
    throw new ERR_INVALID_ARG_TYPE(name, 'AbortSignal', signal)
  }
})

/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */

/** @type {validateFunction} */
const validateFunction = hideStackFrames((value, name) => {
  if (typeof value !== 'function') throw new ERR_INVALID_ARG_TYPE(name, 'Function', value)
})

/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */

/** @type {validatePlainFunction} */
const validatePlainFunction = hideStackFrames((value, name) => {
  if (typeof value !== 'function' || isAsyncFunction(value)) throw new ERR_INVALID_ARG_TYPE(name, 'Function', value)
})

/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */

/** @type {validateUndefined} */
const validateUndefined = hideStackFrames((value, name) => {
  if (value !== undefined) throw new ERR_INVALID_ARG_TYPE(name, 'undefined', value)
})

/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */
function validateUnion(value, name, union) {
  if (!ArrayPrototypeIncludes(union, value)) {
    throw new ERR_INVALID_ARG_TYPE(name, `('${ArrayPrototypeJoin(union, '|')}')`, value)
  }
}

/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/
const linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/

/**
 * @param {any} value
 * @param {string} name
 */
function validateLinkHeaderFormat(value, name) {
  if (typeof value === 'undefined' || !RegExpPrototypeExec(linkValueRegExp, value)) {
    throw new ERR_INVALID_ARG_VALUE(
      name,
      value,
      'must be an array or string of format "</styles.css>; rel=preload; as=style"'
    )
  }
}

/**
 * @param {any} hints
 * @return {string}
 */
function validateLinkHeaderValue(hints) {
  if (typeof hints === 'string') {
    validateLinkHeaderFormat(hints, 'hints')
    return hints
  } else if (ArrayIsArray(hints)) {
    const hintsLength = hints.length
    let result = ''
    if (hintsLength === 0) {
      return result
    }
    for (let i = 0; i < hintsLength; i++) {
      const link = hints[i]
      validateLinkHeaderFormat(link, 'hints')
      result += link
      if (i !== hintsLength - 1) {
        result += ', '
      }
    }
    return result
  }
  throw new ERR_INVALID_ARG_VALUE(
    'hints',
    hints,
    'must be an array or string of format "</styles.css>; rel=preload; as=style"'
  )
}
module.exports = {
  isInt32,
  isUint32,
  parseFileMode,
  validateArray,
  validateStringArray,
  validateBooleanArray,
  validateBoolean,
  validateBuffer,
  validateDictionary,
  validateEncoding,
  validateFunction,
  validateInt32,
  validateInteger,
  validateNumber,
  validateObject,
  validateOneOf,
  validatePlainFunction,
  validatePort,
  validateSignalName,
  validateString,
  validateUint32,
  validateUndefined,
  validateUnion,
  validateAbortSignal,
  validateLinkHeaderValue
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/ours/browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const CustomStream = __webpack_require__("../../node_modules/readable-stream/lib/stream.js")
const promises = __webpack_require__("../../node_modules/readable-stream/lib/stream/promises.js")
const originalDestroy = CustomStream.Readable.destroy
module.exports = CustomStream.Readable

// Explicit export naming is needed for ESM
module.exports._uint8ArrayToBuffer = CustomStream._uint8ArrayToBuffer
module.exports._isUint8Array = CustomStream._isUint8Array
module.exports.isDisturbed = CustomStream.isDisturbed
module.exports.isErrored = CustomStream.isErrored
module.exports.isReadable = CustomStream.isReadable
module.exports.Readable = CustomStream.Readable
module.exports.Writable = CustomStream.Writable
module.exports.Duplex = CustomStream.Duplex
module.exports.Transform = CustomStream.Transform
module.exports.PassThrough = CustomStream.PassThrough
module.exports.addAbortSignal = CustomStream.addAbortSignal
module.exports.finished = CustomStream.finished
module.exports.destroy = CustomStream.destroy
module.exports.destroy = originalDestroy
module.exports.pipeline = CustomStream.pipeline
module.exports.compose = CustomStream.compose
Object.defineProperty(CustomStream, 'promises', {
  configurable: true,
  enumerable: true,
  get() {
    return promises
  }
})
module.exports.Stream = CustomStream.Stream

// Allow default importing
module.exports["default"] = module.exports


/***/ }),

/***/ "../../node_modules/readable-stream/lib/ours/errors.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const { format, inspect, AggregateError: CustomAggregateError } = __webpack_require__("../../node_modules/readable-stream/lib/ours/util.js")

/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/

const AggregateError = globalThis.AggregateError || CustomAggregateError
const kIsNodeError = Symbol('kIsNodeError')
const kTypes = [
  'string',
  'function',
  'number',
  'object',
  // Accept 'Function' and 'Object' as alternative to the lower cased version.
  'Function',
  'Object',
  'boolean',
  'bigint',
  'symbol'
]
const classRegExp = /^([A-Z][a-z0-9]*)+$/
const nodeInternalPrefix = '__node_internal_'
const codes = {}
function assert(value, message) {
  if (!value) {
    throw new codes.ERR_INTERNAL_ASSERTION(message)
  }
}

// Only use this for integers! Decimal numbers do not work with this function.
function addNumericalSeparator(val) {
  let res = ''
  let i = val.length
  const start = val[0] === '-' ? 1 : 0
  for (; i >= start + 4; i -= 3) {
    res = `_${val.slice(i - 3, i)}${res}`
  }
  return `${val.slice(0, i)}${res}`
}
function getMessage(key, msg, args) {
  if (typeof msg === 'function') {
    assert(
      msg.length <= args.length,
      // Default options do not count.
      `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`
    )
    return msg(...args)
  }
  const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length
  assert(
    expectedLength === args.length,
    `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`
  )
  if (args.length === 0) {
    return msg
  }
  return format(msg, ...args)
}
function E(code, message, Base) {
  if (!Base) {
    Base = Error
  }
  class NodeError extends Base {
    constructor(...args) {
      super(getMessage(code, message, args))
    }
    toString() {
      return `${this.name} [${code}]: ${this.message}`
    }
  }
  Object.defineProperties(NodeError.prototype, {
    name: {
      value: Base.name,
      writable: true,
      enumerable: false,
      configurable: true
    },
    toString: {
      value() {
        return `${this.name} [${code}]: ${this.message}`
      },
      writable: true,
      enumerable: false,
      configurable: true
    }
  })
  NodeError.prototype.code = code
  NodeError.prototype[kIsNodeError] = true
  codes[code] = NodeError
}
function hideStackFrames(fn) {
  // We rename the functions that will be hidden to cut off the stacktrace
  // at the outermost one
  const hidden = nodeInternalPrefix + fn.name
  Object.defineProperty(fn, 'name', {
    value: hidden
  })
  return fn
}
function aggregateTwoErrors(innerError, outerError) {
  if (innerError && outerError && innerError !== outerError) {
    if (Array.isArray(outerError.errors)) {
      // If `outerError` is already an `AggregateError`.
      outerError.errors.push(innerError)
      return outerError
    }
    const err = new AggregateError([outerError, innerError], outerError.message)
    err.code = outerError.code
    return err
  }
  return innerError || outerError
}
class AbortError extends Error {
  constructor(message = 'The operation was aborted', options = undefined) {
    if (options !== undefined && typeof options !== 'object') {
      throw new codes.ERR_INVALID_ARG_TYPE('options', 'Object', options)
    }
    super(message, options)
    this.code = 'ABORT_ERR'
    this.name = 'AbortError'
  }
}
E('ERR_ASSERTION', '%s', Error)
E(
  'ERR_INVALID_ARG_TYPE',
  (name, expected, actual) => {
    assert(typeof name === 'string', "'name' must be a string")
    if (!Array.isArray(expected)) {
      expected = [expected]
    }
    let msg = 'The '
    if (name.endsWith(' argument')) {
      // For cases like 'first argument'
      msg += `${name} `
    } else {
      msg += `"${name}" ${name.includes('.') ? 'property' : 'argument'} `
    }
    msg += 'must be '
    const types = []
    const instances = []
    const other = []
    for (const value of expected) {
      assert(typeof value === 'string', 'All expected entries have to be of type string')
      if (kTypes.includes(value)) {
        types.push(value.toLowerCase())
      } else if (classRegExp.test(value)) {
        instances.push(value)
      } else {
        assert(value !== 'object', 'The value "object" should be written as "Object"')
        other.push(value)
      }
    }

    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
      const pos = types.indexOf('object')
      if (pos !== -1) {
        types.splice(types, pos, 1)
        instances.push('Object')
      }
    }
    if (types.length > 0) {
      switch (types.length) {
        case 1:
          msg += `of type ${types[0]}`
          break
        case 2:
          msg += `one of type ${types[0]} or ${types[1]}`
          break
        default: {
          const last = types.pop()
          msg += `one of type ${types.join(', ')}, or ${last}`
        }
      }
      if (instances.length > 0 || other.length > 0) {
        msg += ' or '
      }
    }
    if (instances.length > 0) {
      switch (instances.length) {
        case 1:
          msg += `an instance of ${instances[0]}`
          break
        case 2:
          msg += `an instance of ${instances[0]} or ${instances[1]}`
          break
        default: {
          const last = instances.pop()
          msg += `an instance of ${instances.join(', ')}, or ${last}`
        }
      }
      if (other.length > 0) {
        msg += ' or '
      }
    }
    switch (other.length) {
      case 0:
        break
      case 1:
        if (other[0].toLowerCase() !== other[0]) {
          msg += 'an '
        }
        msg += `${other[0]}`
        break
      case 2:
        msg += `one of ${other[0]} or ${other[1]}`
        break
      default: {
        const last = other.pop()
        msg += `one of ${other.join(', ')}, or ${last}`
      }
    }
    if (actual == null) {
      msg += `. Received ${actual}`
    } else if (typeof actual === 'function' && actual.name) {
      msg += `. Received function ${actual.name}`
    } else if (typeof actual === 'object') {
      var _actual$constructor
      if (
        (_actual$constructor = actual.constructor) !== null &&
        _actual$constructor !== undefined &&
        _actual$constructor.name
      ) {
        msg += `. Received an instance of ${actual.constructor.name}`
      } else {
        const inspected = inspect(actual, {
          depth: -1
        })
        msg += `. Received ${inspected}`
      }
    } else {
      let inspected = inspect(actual, {
        colors: false
      })
      if (inspected.length > 25) {
        inspected = `${inspected.slice(0, 25)}...`
      }
      msg += `. Received type ${typeof actual} (${inspected})`
    }
    return msg
  },
  TypeError
)
E(
  'ERR_INVALID_ARG_VALUE',
  (name, value, reason = 'is invalid') => {
    let inspected = inspect(value)
    if (inspected.length > 128) {
      inspected = inspected.slice(0, 128) + '...'
    }
    const type = name.includes('.') ? 'property' : 'argument'
    return `The ${type} '${name}' ${reason}. Received ${inspected}`
  },
  TypeError
)
E(
  'ERR_INVALID_RETURN_VALUE',
  (input, name, value) => {
    var _value$constructor
    const type =
      value !== null &&
      value !== undefined &&
      (_value$constructor = value.constructor) !== null &&
      _value$constructor !== undefined &&
      _value$constructor.name
        ? `instance of ${value.constructor.name}`
        : `type ${typeof value}`
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`
  },
  TypeError
)
E(
  'ERR_MISSING_ARGS',
  (...args) => {
    assert(args.length > 0, 'At least one arg needs to be specified')
    let msg
    const len = args.length
    args = (Array.isArray(args) ? args : [args]).map((a) => `"${a}"`).join(' or ')
    switch (len) {
      case 1:
        msg += `The ${args[0]} argument`
        break
      case 2:
        msg += `The ${args[0]} and ${args[1]} arguments`
        break
      default:
        {
          const last = args.pop()
          msg += `The ${args.join(', ')}, and ${last} arguments`
        }
        break
    }
    return `${msg} must be specified`
  },
  TypeError
)
E(
  'ERR_OUT_OF_RANGE',
  (str, range, input) => {
    assert(range, 'Missing "range" argument')
    let received
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input))
    } else if (typeof input === 'bigint') {
      received = String(input)
      if (input > 2n ** 32n || input < -(2n ** 32n)) {
        received = addNumericalSeparator(received)
      }
      received += 'n'
    } else {
      received = inspect(input)
    }
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`
  },
  RangeError
)
E('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times', Error)
E('ERR_METHOD_NOT_IMPLEMENTED', 'The %s method is not implemented', Error)
E('ERR_STREAM_ALREADY_FINISHED', 'Cannot call %s after a stream was finished', Error)
E('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable', Error)
E('ERR_STREAM_DESTROYED', 'Cannot call %s after a stream was destroyed', Error)
E('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError)
E('ERR_STREAM_PREMATURE_CLOSE', 'Premature close', Error)
E('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF', Error)
E('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event', Error)
E('ERR_STREAM_WRITE_AFTER_END', 'write after end', Error)
E('ERR_UNKNOWN_ENCODING', 'Unknown encoding: %s', TypeError)
module.exports = {
  AbortError,
  aggregateTwoErrors: hideStackFrames(aggregateTwoErrors),
  hideStackFrames,
  codes
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/ours/primordials.js":
/***/ ((module) => {

"use strict";


/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/
module.exports = {
  ArrayIsArray(self) {
    return Array.isArray(self)
  },
  ArrayPrototypeIncludes(self, el) {
    return self.includes(el)
  },
  ArrayPrototypeIndexOf(self, el) {
    return self.indexOf(el)
  },
  ArrayPrototypeJoin(self, sep) {
    return self.join(sep)
  },
  ArrayPrototypeMap(self, fn) {
    return self.map(fn)
  },
  ArrayPrototypePop(self, el) {
    return self.pop(el)
  },
  ArrayPrototypePush(self, el) {
    return self.push(el)
  },
  ArrayPrototypeSlice(self, start, end) {
    return self.slice(start, end)
  },
  Error,
  FunctionPrototypeCall(fn, thisArgs, ...args) {
    return fn.call(thisArgs, ...args)
  },
  FunctionPrototypeSymbolHasInstance(self, instance) {
    return Function.prototype[Symbol.hasInstance].call(self, instance)
  },
  MathFloor: Math.floor,
  Number,
  NumberIsInteger: Number.isInteger,
  NumberIsNaN: Number.isNaN,
  NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
  NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
  NumberParseInt: Number.parseInt,
  ObjectDefineProperties(self, props) {
    return Object.defineProperties(self, props)
  },
  ObjectDefineProperty(self, name, prop) {
    return Object.defineProperty(self, name, prop)
  },
  ObjectGetOwnPropertyDescriptor(self, name) {
    return Object.getOwnPropertyDescriptor(self, name)
  },
  ObjectKeys(obj) {
    return Object.keys(obj)
  },
  ObjectSetPrototypeOf(target, proto) {
    return Object.setPrototypeOf(target, proto)
  },
  Promise,
  PromisePrototypeCatch(self, fn) {
    return self.catch(fn)
  },
  PromisePrototypeThen(self, thenFn, catchFn) {
    return self.then(thenFn, catchFn)
  },
  PromiseReject(err) {
    return Promise.reject(err)
  },
  ReflectApply: Reflect.apply,
  RegExpPrototypeTest(self, value) {
    return self.test(value)
  },
  SafeSet: Set,
  String,
  StringPrototypeSlice(self, start, end) {
    return self.slice(start, end)
  },
  StringPrototypeToLowerCase(self) {
    return self.toLowerCase()
  },
  StringPrototypeToUpperCase(self) {
    return self.toUpperCase()
  },
  StringPrototypeTrim(self) {
    return self.trim()
  },
  Symbol,
  SymbolFor: Symbol.for,
  SymbolAsyncIterator: Symbol.asyncIterator,
  SymbolHasInstance: Symbol.hasInstance,
  SymbolIterator: Symbol.iterator,
  TypedArrayPrototypeSet(self, buf, len) {
    return self.set(buf, len)
  },
  Uint8Array
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/ours/util.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const bufferModule = __webpack_require__("../../node_modules/buffer/index.js")
const AsyncFunction = Object.getPrototypeOf(async function () {}).constructor
const Blob = globalThis.Blob || bufferModule.Blob
/* eslint-disable indent */
const isBlob =
  typeof Blob !== 'undefined'
    ? function isBlob(b) {
        // eslint-disable-next-line indent
        return b instanceof Blob
      }
    : function isBlob(b) {
        return false
      }
/* eslint-enable indent */

// This is a simplified version of AggregateError
class AggregateError extends Error {
  constructor(errors) {
    if (!Array.isArray(errors)) {
      throw new TypeError(`Expected input to be an Array, got ${typeof errors}`)
    }
    let message = ''
    for (let i = 0; i < errors.length; i++) {
      message += `    ${errors[i].stack}\n`
    }
    super(message)
    this.name = 'AggregateError'
    this.errors = errors
  }
}
module.exports = {
  AggregateError,
  kEmptyObject: Object.freeze({}),
  once(callback) {
    let called = false
    return function (...args) {
      if (called) {
        return
      }
      called = true
      callback.apply(this, args)
    }
  },
  createDeferredPromise: function () {
    let resolve
    let reject

    // eslint-disable-next-line promise/param-names
    const promise = new Promise((res, rej) => {
      resolve = res
      reject = rej
    })
    return {
      promise,
      resolve,
      reject
    }
  },
  promisify(fn) {
    return new Promise((resolve, reject) => {
      fn((err, ...args) => {
        if (err) {
          return reject(err)
        }
        return resolve(...args)
      })
    })
  },
  debuglog() {
    return function () {}
  },
  format(format, ...args) {
    // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
    return format.replace(/%([sdifj])/g, function (...[_unused, type]) {
      const replacement = args.shift()
      if (type === 'f') {
        return replacement.toFixed(6)
      } else if (type === 'j') {
        return JSON.stringify(replacement)
      } else if (type === 's' && typeof replacement === 'object') {
        const ctor = replacement.constructor !== Object ? replacement.constructor.name : ''
        return `${ctor} {}`.trim()
      } else {
        return replacement.toString()
      }
    })
  },
  inspect(value) {
    // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
    switch (typeof value) {
      case 'string':
        if (value.includes("'")) {
          if (!value.includes('"')) {
            return `"${value}"`
          } else if (!value.includes('`') && !value.includes('${')) {
            return `\`${value}\``
          }
        }
        return `'${value}'`
      case 'number':
        if (isNaN(value)) {
          return 'NaN'
        } else if (Object.is(value, -0)) {
          return String(value)
        }
        return value
      case 'bigint':
        return `${String(value)}n`
      case 'boolean':
      case 'undefined':
        return String(value)
      case 'object':
        return '{}'
    }
  },
  types: {
    isAsyncFunction(fn) {
      return fn instanceof AsyncFunction
    },
    isArrayBufferView(arr) {
      return ArrayBuffer.isView(arr)
    }
  },
  isBlob
}
module.exports.promisify.custom = Symbol.for('nodejs.util.promisify.custom')


/***/ }),

/***/ "../../node_modules/readable-stream/lib/stream.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/* replacement start */

const { Buffer } = __webpack_require__("../../node_modules/buffer/index.js")

/* replacement end */
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

;('use strict')
const { ObjectDefineProperty, ObjectKeys, ReflectApply } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const {
  promisify: { custom: customPromisify }
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/util.js")
const { streamReturningOperators, promiseReturningOperators } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/operators.js")
const {
  codes: { ERR_ILLEGAL_CONSTRUCTOR }
} = __webpack_require__("../../node_modules/readable-stream/lib/ours/errors.js")
const compose = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/compose.js")
const { pipeline } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/pipeline.js")
const { destroyer } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/destroy.js")
const eos = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/end-of-stream.js")
const internalBuffer = {}
const promises = __webpack_require__("../../node_modules/readable-stream/lib/stream/promises.js")
const utils = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/utils.js")
const Stream = (module.exports = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/legacy.js").Stream)
Stream.isDisturbed = utils.isDisturbed
Stream.isErrored = utils.isErrored
Stream.isReadable = utils.isReadable
Stream.Readable = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/readable.js")
for (const key of ObjectKeys(streamReturningOperators)) {
  const op = streamReturningOperators[key]
  function fn(...args) {
    if (new.target) {
      throw ERR_ILLEGAL_CONSTRUCTOR()
    }
    return Stream.Readable.from(ReflectApply(op, this, args))
  }
  ObjectDefineProperty(fn, 'name', {
    __proto__: null,
    value: op.name
  })
  ObjectDefineProperty(fn, 'length', {
    __proto__: null,
    value: op.length
  })
  ObjectDefineProperty(Stream.Readable.prototype, key, {
    __proto__: null,
    value: fn,
    enumerable: false,
    configurable: true,
    writable: true
  })
}
for (const key of ObjectKeys(promiseReturningOperators)) {
  const op = promiseReturningOperators[key]
  function fn(...args) {
    if (new.target) {
      throw ERR_ILLEGAL_CONSTRUCTOR()
    }
    return ReflectApply(op, this, args)
  }
  ObjectDefineProperty(fn, 'name', {
    __proto__: null,
    value: op.name
  })
  ObjectDefineProperty(fn, 'length', {
    __proto__: null,
    value: op.length
  })
  ObjectDefineProperty(Stream.Readable.prototype, key, {
    __proto__: null,
    value: fn,
    enumerable: false,
    configurable: true,
    writable: true
  })
}
Stream.Writable = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/writable.js")
Stream.Duplex = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/duplex.js")
Stream.Transform = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/transform.js")
Stream.PassThrough = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/passthrough.js")
Stream.pipeline = pipeline
const { addAbortSignal } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/add-abort-signal.js")
Stream.addAbortSignal = addAbortSignal
Stream.finished = eos
Stream.destroy = destroyer
Stream.compose = compose
ObjectDefineProperty(Stream, 'promises', {
  __proto__: null,
  configurable: true,
  enumerable: true,
  get() {
    return promises
  }
})
ObjectDefineProperty(pipeline, customPromisify, {
  __proto__: null,
  enumerable: true,
  get() {
    return promises.pipeline
  }
})
ObjectDefineProperty(eos, customPromisify, {
  __proto__: null,
  enumerable: true,
  get() {
    return promises.finished
  }
})

// Backwards-compat with node 0.4.x
Stream.Stream = Stream
Stream._isUint8Array = function isUint8Array(value) {
  return value instanceof Uint8Array
}
Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength)
}


/***/ }),

/***/ "../../node_modules/readable-stream/lib/stream/promises.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const { ArrayPrototypePop, Promise } = __webpack_require__("../../node_modules/readable-stream/lib/ours/primordials.js")
const { isIterable, isNodeStream, isWebStream } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/utils.js")
const { pipelineImpl: pl } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/pipeline.js")
const { finished } = __webpack_require__("../../node_modules/readable-stream/lib/internal/streams/end-of-stream.js")
__webpack_require__("../../node_modules/readable-stream/lib/ours/browser.js")
function pipeline(...streams) {
  return new Promise((resolve, reject) => {
    let signal
    let end
    const lastArg = streams[streams.length - 1]
    if (
      lastArg &&
      typeof lastArg === 'object' &&
      !isNodeStream(lastArg) &&
      !isIterable(lastArg) &&
      !isWebStream(lastArg)
    ) {
      const options = ArrayPrototypePop(streams)
      signal = options.signal
      end = options.end
    }
    pl(
      streams,
      (err, value) => {
        if (err) {
          reject(err)
        } else {
          resolve(value)
        }
      },
      {
        signal,
        end
      }
    )
  })
}
module.exports = {
  finished,
  pipeline
}


/***/ }),

/***/ "../../node_modules/reflect-metadata/Reflect.js":
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function (factory) {
        var root = typeof __webpack_require__.g === "object" ? __webpack_require__.g :
            typeof self === "object" ? self :
                typeof this === "object" ? this :
                    Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
        }
        else {
            exporter = makeExporter(root.Reflect, exporter);
        }
        factory(exporter);
        function makeExporter(target, previous) {
            return function (key, value) {
                if (typeof target[key] !== "function") {
                    Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
                }
                if (previous)
                    previous(key, value);
            };
        }
    })(function (exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate
                ? function () { return MakeDictionary(Object.create(null)); }
                : supportsProto
                    ? function () { return MakeDictionary({ __proto__: null }); }
                    : function () { return MakeDictionary({}); },
            has: downLevel
                ? function (map, key) { return hasOwn.call(map, key); }
                : function (map, key) { return key in map; },
            get: downLevel
                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
                : function (map, key) { return map[key]; },
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof process === "object" && process.env && process.env["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */
        function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                    throw new TypeError();
                if (IsNull(attributes))
                    attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            }
            else {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsConstructor(target))
                    throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */
        function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */
        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */
        function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */
        function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            if (!metadataMap.delete(metadataKey))
                return false;
            if (metadataMap.size > 0)
                return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0)
                return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated))
                        throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated))
                        throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create)
                    return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create)
                    return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null)
                return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0)
                return ownKeys;
            if (ownKeys.length <= 0)
                return parentKeys;
            var set = new _Set();
            var keys = [];
            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while (true) {
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                }
                catch (e) {
                    try {
                        IteratorClose(iterator);
                    }
                    finally {
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null)
                return 1 /* Null */;
            switch (typeof x) {
                case "undefined": return 0 /* Undefined */;
                case "boolean": return 2 /* Boolean */;
                case "string": return 3 /* String */;
                case "symbol": return 4 /* Symbol */;
                case "number": return 5 /* Number */;
                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
                default: return 6 /* Object */;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
                case 0 /* Undefined */: return input;
                case 1 /* Null */: return input;
                case 2 /* Boolean */: return input;
                case 3 /* String */: return input;
                case 4 /* Symbol */: return input;
                case 5 /* Number */: return input;
            }
            var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result))
                    throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */);
            if (IsSymbol(key))
                return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray
                ? Array.isArray(argument)
                : argument instanceof Object
                    ? argument instanceof Array
                    : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch (Type(argument)) {
                case 3 /* String */: return true;
                case 4 /* Symbol */: return true;
                default: return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null)
                return undefined;
            if (!IsCallable(func))
                throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method))
                throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator))
                throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f)
                f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype)
                return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype)
                return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype)
                return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function")
                return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O)
                return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ (function () {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function () { return this; };
                MapIterator.prototype[iteratorSymbol] = function () { return this; };
                MapIterator.prototype.next = function () {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        }
                        else {
                            this._index++;
                        }
                        return { value: result, done: false };
                    }
                    return { value: undefined, done: true };
                };
                MapIterator.prototype.throw = function (error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function (value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return { value: value, done: true };
                };
                return MapIterator;
            }());
            return /** @class */ (function () {
                function Map() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map.prototype, "size", {
                    get: function () { return this._keys.length; },
                    enumerable: true,
                    configurable: true
                });
                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
                Map.prototype.get = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map.prototype.set = function (key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map.prototype.delete = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for (var i = index + 1; i < size; i++) {
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map.prototype.clear = function () {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
                Map.prototype["@@iterator"] = function () { return this.entries(); };
                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
                Map.prototype._find = function (key, insert) {
                    if (this._cacheKey !== key) {
                        this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map;
            }());
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [key, value];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return /** @class */ (function () {
                function Set() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set.prototype, "size", {
                    get: function () { return this._map.size; },
                    enumerable: true,
                    configurable: true
                });
                Set.prototype.has = function (value) { return this._map.has(value); };
                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
                Set.prototype.delete = function (value) { return this._map.delete(value); };
                Set.prototype.clear = function () { this._map.clear(); };
                Set.prototype.keys = function () { return this._map.keys(); };
                Set.prototype.values = function () { return this._map.values(); };
                Set.prototype.entries = function () { return this._map.entries(); };
                Set.prototype["@@iterator"] = function () { return this.keys(); };
                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
                return Set;
            }());
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ (function () {
                function WeakMap() {
                    this._key = CreateUniqueKey();
                }
                WeakMap.prototype.has = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap.prototype.get = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap.prototype.set = function (target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap.prototype.delete = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap.prototype.clear = function () {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap;
            }());
            function CreateUniqueKey() {
                var key;
                do
                    key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create)
                        return undefined;
                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for (var i = 0; i < size; ++i)
                    buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined")
                        return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined")
                        return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for (var offset = 0; offset < UUID_SIZE; ++offset) {
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8)
                        result += "-";
                    if (byte < 16)
                        result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})(Reflect || (Reflect = {}));


/***/ }),

/***/ "../../node_modules/ripemd160/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

var Buffer = (__webpack_require__("../../node_modules/buffer/index.js").Buffer)
var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var HashBase = __webpack_require__("../../node_modules/hash-base/index.js")

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),

/***/ "../../node_modules/safe-buffer/index.js":
/***/ ((module, exports, __webpack_require__) => {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("../../node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "../../node_modules/safer-buffer/safer.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
/* eslint-disable node/no-deprecated-api */



var buffer = __webpack_require__("../../node_modules/buffer/index.js")
var Buffer = buffer.Buffer

var safer = {}

var key

for (key in buffer) {
  if (!buffer.hasOwnProperty(key)) continue
  if (key === 'SlowBuffer' || key === 'Buffer') continue
  safer[key] = buffer[key]
}

var Safer = safer.Buffer = {}
for (key in Buffer) {
  if (!Buffer.hasOwnProperty(key)) continue
  if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
  Safer[key] = Buffer[key]
}

safer.Buffer.prototype = Buffer.prototype

if (!Safer.from || Safer.from === Uint8Array.from) {
  Safer.from = function (value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
    }
    if (value && typeof value.length === 'undefined') {
      throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
    }
    return Buffer(value, encodingOrOffset, length)
  }
}

if (!Safer.alloc) {
  Safer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
    }
    if (size < 0 || size >= 2 * (1 << 30)) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"')
    }
    var buf = Buffer(size)
    if (!fill || fill.length === 0) {
      buf.fill(0)
    } else if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
    return buf
  }
}

if (!safer.kStringMaxLength) {
  try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
  } catch (e) {
    // we can't determine kStringMaxLength in environments where process.binding
    // is unsupported, so let's not set it
  }
}

if (!safer.constants) {
  safer.constants = {
    MAX_LENGTH: safer.kMaxLength
  }
  if (safer.kStringMaxLength) {
    safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
  }
}

module.exports = safer


/***/ }),

/***/ "../../node_modules/scrypt-js/scrypt.js":
/***/ (function(module) {

"use strict";


(function(root) {
    const MAX_VALUE = 0x7fffffff;

    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
           0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b,
           0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01,
           0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7,
           0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
           0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152,
           0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
           0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc,
           0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
           0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819,
           0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08,
           0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f,
           0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
           0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
       ]);

        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);

        function blocks(p) {
            let off = 0, len = p.length;
            while (len >= 64) {
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;

                for (i = 0; i < 16; i++) {
                    j = off + i*4;
                    w[i] = ((p[j] & 0xff)<<24) | ((p[j+1] & 0xff)<<16) |
                    ((p[j+2] & 0xff)<<8) | (p[j+3] & 0xff);
                }

                for (i = 16; i < 64; i++) {
                    u = w[i-2];
                    t1 = ((u>>>17) | (u<<(32-17))) ^ ((u>>>19) | (u<<(32-19))) ^ (u>>>10);

                    u = w[i-15];
                    t2 = ((u>>>7) | (u<<(32-7))) ^ ((u>>>18) | (u<<(32-18))) ^ (u>>>3);

                    w[i] = (((t1 + w[i-7]) | 0) + ((t2 + w[i-16]) | 0)) | 0;
                }

                for (i = 0; i < 64; i++) {
                    t1 = ((((((e>>>6) | (e<<(32-6))) ^ ((e>>>11) | (e<<(32-11))) ^
                             ((e>>>25) | (e<<(32-25)))) + ((e & f) ^ (~e & g))) | 0) +
                          ((h + ((K[i] + w[i]) | 0)) | 0)) | 0;

                    t2 = ((((a>>>2) | (a<<(32-2))) ^ ((a>>>13) | (a<<(32-13))) ^
                           ((a>>>22) | (a<<(32-22)))) + ((a & b) ^ (a & c) ^ (b & c))) | 0;

                    h = g;
                    g = f;
                    f = e;
                    e = (d + t1) | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = (t1 + t2) | 0;
                }

                h0 = (h0 + a) | 0;
                h1 = (h1 + b) | 0;
                h2 = (h2 + c) | 0;
                h3 = (h3 + d) | 0;
                h4 = (h4 + e) | 0;
                h5 = (h5 + f) | 0;
                h6 = (h6 + g) | 0;
                h7 = (h7 + h) | 0;

                off += 64;
                len -= 64;
            }
        }

        blocks(m);

        let i, bytesLeft = m.length % 64,
        bitLenHi = (m.length / 0x20000000) | 0,
        bitLenLo = m.length << 3,
        numZeros = (bytesLeft < 56) ? 56 : 120,
        p = m.slice(m.length - bytesLeft, m.length);

        p.push(0x80);
        for (i = bytesLeft + 1; i < numZeros; i++) { p.push(0); }
        p.push((bitLenHi >>> 24) & 0xff);
        p.push((bitLenHi >>> 16) & 0xff);
        p.push((bitLenHi >>> 8)  & 0xff);
        p.push((bitLenHi >>> 0)  & 0xff);
        p.push((bitLenLo >>> 24) & 0xff);
        p.push((bitLenLo >>> 16) & 0xff);
        p.push((bitLenLo >>> 8)  & 0xff);
        p.push((bitLenLo >>> 0)  & 0xff);

        blocks(p);

        return [
            (h0 >>> 24) & 0xff, (h0 >>> 16) & 0xff, (h0 >>> 8) & 0xff, (h0 >>> 0) & 0xff,
            (h1 >>> 24) & 0xff, (h1 >>> 16) & 0xff, (h1 >>> 8) & 0xff, (h1 >>> 0) & 0xff,
            (h2 >>> 24) & 0xff, (h2 >>> 16) & 0xff, (h2 >>> 8) & 0xff, (h2 >>> 0) & 0xff,
            (h3 >>> 24) & 0xff, (h3 >>> 16) & 0xff, (h3 >>> 8) & 0xff, (h3 >>> 0) & 0xff,
            (h4 >>> 24) & 0xff, (h4 >>> 16) & 0xff, (h4 >>> 8) & 0xff, (h4 >>> 0) & 0xff,
            (h5 >>> 24) & 0xff, (h5 >>> 16) & 0xff, (h5 >>> 8) & 0xff, (h5 >>> 0) & 0xff,
            (h6 >>> 24) & 0xff, (h6 >>> 16) & 0xff, (h6 >>> 8) & 0xff, (h6 >>> 0) & 0xff,
            (h7 >>> 24) & 0xff, (h7 >>> 16) & 0xff, (h7 >>> 8) & 0xff, (h7 >>> 0) & 0xff
        ];
    }

    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = (password.length <= 64) ? password : SHA256(password);

        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);

        let i;
        let dk = [];

        // inner = (password ^ ipad) || salt || counter
        for (i = 0; i < 64; i++) { inner[i] = 0x36; }
        for (i = 0; i < password.length; i++) { inner[i] ^= password[i]; }
        for (i = 0; i < salt.length; i++) { inner[64 + i] = salt[i]; }
        for (i = innerLen - 4; i < innerLen; i++) { inner[i] = 0; }

        // outerKey = password ^ opad
        for (i = 0; i < 64; i++) outerKey[i] = 0x5c;
        for (i = 0; i < password.length; i++) outerKey[i] ^= password[i];

        // increments counter inside inner
        function incrementCounter() {
            for (let i = innerLen - 1; i >= innerLen - 4; i--) {
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }

        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while (dkLen >= 32) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }

        return dk;
    }

    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;

        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for (i = 0; i < 2 * r; i++) {
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + (i * 16), 16);
        }

        for (i = 0; i < r; i++) {
            arraycopy(BY, Yi + (i * 2) * 16, BY, (i * 16), 16);
        }

        for (i = 0; i < r; i++) {
            arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
        }
    }

    function R(a, b) {
        return (a << b) | (a >>> (32 - b));
    }

    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);

        for (let i = 8; i > 0; i -= 2) {
            x[ 4] ^= R(x[ 0] + x[12], 7);
            x[ 8] ^= R(x[ 4] + x[ 0], 9);
            x[12] ^= R(x[ 8] + x[ 4], 13);
            x[ 0] ^= R(x[12] + x[ 8], 18);
            x[ 9] ^= R(x[ 5] + x[ 1], 7);
            x[13] ^= R(x[ 9] + x[ 5], 9);
            x[ 1] ^= R(x[13] + x[ 9], 13);
            x[ 5] ^= R(x[ 1] + x[13], 18);
            x[14] ^= R(x[10] + x[ 6], 7);
            x[ 2] ^= R(x[14] + x[10], 9);
            x[ 6] ^= R(x[ 2] + x[14], 13);
            x[10] ^= R(x[ 6] + x[ 2], 18);
            x[ 3] ^= R(x[15] + x[11], 7);
            x[ 7] ^= R(x[ 3] + x[15], 9);
            x[11] ^= R(x[ 7] + x[ 3], 13);
            x[15] ^= R(x[11] + x[ 7], 18);
            x[ 1] ^= R(x[ 0] + x[ 3], 7);
            x[ 2] ^= R(x[ 1] + x[ 0], 9);
            x[ 3] ^= R(x[ 2] + x[ 1], 13);
            x[ 0] ^= R(x[ 3] + x[ 2], 18);
            x[ 6] ^= R(x[ 5] + x[ 4], 7);
            x[ 7] ^= R(x[ 6] + x[ 5], 9);
            x[ 4] ^= R(x[ 7] + x[ 6], 13);
            x[ 5] ^= R(x[ 4] + x[ 7], 18);
            x[11] ^= R(x[10] + x[ 9], 7);
            x[ 8] ^= R(x[11] + x[10], 9);
            x[ 9] ^= R(x[ 8] + x[11], 13);
            x[10] ^= R(x[ 9] + x[ 8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }

        for (let i = 0; i < 16; ++i) {
            B[i] += x[i];
        }
    }

    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for (let i = 0; i < len; i++) {
            D[i] ^= S[Si + i]
        }
    }

    function arraycopy(src, srcPos, dest, destPos, length) {
        while (length--) {
            dest[destPos++] = src[srcPos++];
        }
    }

    function checkBufferish(o) {
        if (!o || typeof(o.length) !== 'number') { return false; }

        for (let i = 0; i < o.length; i++) {
            const v = o[i];
            if (typeof(v) !== 'number' || v % 1 || v < 0 || v >= 256) {
                return false;
            }
        }

        return true;
    }

    function ensureInteger(value, name) {
        if (typeof(value) !== "number" || (value % 1)) { throw new Error('invalid ' + name); }
        return value;
    }

    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {

        N = ensureInteger(N, 'N');
        r = ensureInteger(r, 'r');
        p = ensureInteger(p, 'p');

        dkLen = ensureInteger(dkLen, 'dkLen');

        if (N === 0 || (N & (N - 1)) !== 0) { throw new Error('N must be power of 2'); }

        if (N > MAX_VALUE / 128 / r) { throw new Error('N too large'); }
        if (r > MAX_VALUE / 128 / p) { throw new Error('r too large'); }

        if (!checkBufferish(password)) {
            throw new Error('password must be an array or buffer');
        }
        password = Array.prototype.slice.call(password);

        if (!checkBufferish(salt)) {
            throw new Error('salt must be an array or buffer');
        }
        salt = Array.prototype.slice.call(salt);

        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r)
        for (let i = 0; i < B.length; i++) {
            const j = i * 4;
            B[i] = ((b[j + 3] & 0xff) << 24) |
                   ((b[j + 2] & 0xff) << 16) |
                   ((b[j + 1] & 0xff) << 8) |
                   ((b[j + 0] & 0xff) << 0);
        }

        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);

        const Yi = 32 * r;

        // scratch space
        const x = new Uint32Array(16);       // salsa20_8
        const _X = new Uint32Array(16);      // blockmix_salsa8

        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;

        // Set this to true to abandon the scrypt on the next step
        let stop = false;

        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;

        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r): 0xffffffff;

        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = (typeof(setImmediate) !== 'undefined') ? setImmediate : setTimeout;

        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) {
                return callback(new Error('cancelled'), currentOp / totalOps);
            }

            let steps;

            switch (state) {
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;

                    arraycopy(B, Bi, XY, 0, Yi);                       // ROMix - 1

                    state = 1;                                         // Move to ROMix 2
                    i1 = 0;

                    // Fall through

                case 1:

                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) { steps = limit; }
                    for (let i = 0; i < steps; i++) {                  // ROMix - 2
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi)         // ROMix - 3
                        blockmix_salsa8(XY, Yi, r, x, _X);             // ROMix - 4
                    }

                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;

                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) { break; }
                            lastPercent10 = percent10;
                        }
                    }

                    if (i1 < N) { break; }

                    i1 = 0;                                          // Move to ROMix 6
                    state = 2;

                    // Fall through

                case 2:

                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) { steps = limit; }
                    for (let i = 0; i < steps; i++) {                // ROMix - 6
                        const offset = (2 * r - 1) * 16;             // ROMix - 7
                        const j = XY[offset] & (N - 1);
                        blockxor(V, j * Yi, XY, Yi);                 // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X);           // ROMix - 9 (outer)
                    }

                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;

                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) { break; }
                            lastPercent10 = percent10;
                        }
                    }

                    if (i1 < N) { break; }

                    arraycopy(XY, 0, B, Bi, Yi);                     // ROMix - 10

                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }

                    b = [];
                    for (let i = 0; i < B.length; i++) {
                        b.push((B[i] >>  0) & 0xff);
                        b.push((B[i] >>  8) & 0xff);
                        b.push((B[i] >> 16) & 0xff);
                        b.push((B[i] >> 24) & 0xff);
                    }

                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);

                    // Send the result to the callback
                    if (callback) { callback(null, 1.0, derivedKey); }

                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }

            // Schedule the next steps
            if (callback) { nextTick(incrementalSMix); }
        }

        // Run the smix state machine until completion
        if (!callback) {
            while (true) {
                const derivedKey = incrementalSMix();
                if (derivedKey != undefined) { return derivedKey; }
            }
        }

        // Bootstrap the async incremental smix
        incrementalSMix();
    }

    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) { progressCallback(0); }
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) {
                        reject(error);
                    } else if (key) {
                        if (progressCallback && lastProgress !== 1) {
                            progressCallback(1);
                        }
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };

    // node.js
    if (true) {
       module.exports = lib;

    // RequireJS/AMD
    // http://www.requirejs.org/docs/api.html
    // https://github.com/amdjs/amdjs-api/wiki/AMD
    } else {}

})(this);


/***/ }),

/***/ "../../node_modules/secp256k1/elliptic.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__("../../node_modules/secp256k1/lib/index.js")(__webpack_require__("../../node_modules/secp256k1/lib/elliptic.js"))


/***/ }),

/***/ "../../node_modules/secp256k1/lib/elliptic.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

const EC = (__webpack_require__("../../node_modules/elliptic/lib/elliptic.js").ec)

const ec = new EC('secp256k1')
const ecparams = ec.curve

// Hack, we can not use bn.js@5, while elliptic uses bn.js@4
// See https://github.com/indutny/elliptic/issues/191#issuecomment-569888758
const BN = ecparams.n.constructor

function loadCompressedPublicKey (first, xbuf) {
  let x = new BN(xbuf)

  // overflow
  if (x.cmp(ecparams.p) >= 0) return null
  x = x.toRed(ecparams.red)

  // compute corresponding Y
  let y = x.redSqr().redIMul(x).redIAdd(ecparams.b).redSqrt()
  if ((first === 0x03) !== y.isOdd()) y = y.redNeg()

  return ec.keyPair({ pub: { x: x, y: y } })
}

function loadUncompressedPublicKey (first, xbuf, ybuf) {
  let x = new BN(xbuf)
  let y = new BN(ybuf)

  // overflow
  if (x.cmp(ecparams.p) >= 0 || y.cmp(ecparams.p) >= 0) return null

  x = x.toRed(ecparams.red)
  y = y.toRed(ecparams.red)

  // is odd flag
  if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null

  // x*x*x + b = y*y
  const x3 = x.redSqr().redIMul(x)
  if (!y.redSqr().redISub(x3.redIAdd(ecparams.b)).isZero()) return null

  return ec.keyPair({ pub: { x: x, y: y } })
}

function loadPublicKey (pubkey) {
  // length should be validated in interface
  const first = pubkey[0]
  switch (first) {
    case 0x02:
    case 0x03:
      if (pubkey.length !== 33) return null
      return loadCompressedPublicKey(first, pubkey.subarray(1, 33))
    case 0x04:
    case 0x06:
    case 0x07:
      if (pubkey.length !== 65) return null
      return loadUncompressedPublicKey(first, pubkey.subarray(1, 33), pubkey.subarray(33, 65))
    default:
      return null
  }
}

function savePublicKey (output, point) {
  const pubkey = point.encode(null, output.length === 33)
  // Loop should be faster because we do not need create extra Uint8Array
  // output.set(new Uint8Array(pubkey))
  for (let i = 0; i < output.length; ++i) output[i] = pubkey[i]
}

module.exports = {
  contextRandomize () {
    return 0
  },

  privateKeyVerify (seckey) {
    const bn = new BN(seckey)
    return bn.cmp(ecparams.n) < 0 && !bn.isZero() ? 0 : 1
  },

  privateKeyNegate (seckey) {
    const bn = new BN(seckey)
    const negate = ecparams.n.sub(bn).umod(ecparams.n).toArrayLike(Uint8Array, 'be', 32)
    seckey.set(negate)
    return 0
  },

  privateKeyTweakAdd (seckey, tweak) {
    const bn = new BN(tweak)
    if (bn.cmp(ecparams.n) >= 0) return 1

    bn.iadd(new BN(seckey))
    if (bn.cmp(ecparams.n) >= 0) bn.isub(ecparams.n)
    if (bn.isZero()) return 1

    const tweaked = bn.toArrayLike(Uint8Array, 'be', 32)
    seckey.set(tweaked)

    return 0
  },

  privateKeyTweakMul (seckey, tweak) {
    let bn = new BN(tweak)
    if (bn.cmp(ecparams.n) >= 0 || bn.isZero()) return 1

    bn.imul(new BN(seckey))
    if (bn.cmp(ecparams.n) >= 0) bn = bn.umod(ecparams.n)

    const tweaked = bn.toArrayLike(Uint8Array, 'be', 32)
    seckey.set(tweaked)

    return 0
  },

  publicKeyVerify (pubkey) {
    const pair = loadPublicKey(pubkey)
    return pair === null ? 1 : 0
  },

  publicKeyCreate (output, seckey) {
    const bn = new BN(seckey)
    if (bn.cmp(ecparams.n) >= 0 || bn.isZero()) return 1

    const point = ec.keyFromPrivate(seckey).getPublic()
    savePublicKey(output, point)

    return 0
  },

  publicKeyConvert (output, pubkey) {
    const pair = loadPublicKey(pubkey)
    if (pair === null) return 1

    const point = pair.getPublic()
    savePublicKey(output, point)

    return 0
  },

  publicKeyNegate (output, pubkey) {
    const pair = loadPublicKey(pubkey)
    if (pair === null) return 1

    const point = pair.getPublic()
    point.y = point.y.redNeg()
    savePublicKey(output, point)

    return 0
  },

  publicKeyCombine (output, pubkeys) {
    const pairs = new Array(pubkeys.length)
    for (let i = 0; i < pubkeys.length; ++i) {
      pairs[i] = loadPublicKey(pubkeys[i])
      if (pairs[i] === null) return 1
    }

    let point = pairs[0].getPublic()
    for (let i = 1; i < pairs.length; ++i) point = point.add(pairs[i].pub)
    if (point.isInfinity()) return 2

    savePublicKey(output, point)

    return 0
  },

  publicKeyTweakAdd (output, pubkey, tweak) {
    const pair = loadPublicKey(pubkey)
    if (pair === null) return 1

    tweak = new BN(tweak)
    if (tweak.cmp(ecparams.n) >= 0) return 2

    const point = pair.getPublic().add(ecparams.g.mul(tweak))
    if (point.isInfinity()) return 2

    savePublicKey(output, point)

    return 0
  },

  publicKeyTweakMul (output, pubkey, tweak) {
    const pair = loadPublicKey(pubkey)
    if (pair === null) return 1

    tweak = new BN(tweak)
    if (tweak.cmp(ecparams.n) >= 0 || tweak.isZero()) return 2

    const point = pair.getPublic().mul(tweak)
    savePublicKey(output, point)

    return 0
  },

  signatureNormalize (sig) {
    const r = new BN(sig.subarray(0, 32))
    const s = new BN(sig.subarray(32, 64))
    if (r.cmp(ecparams.n) >= 0 || s.cmp(ecparams.n) >= 0) return 1

    if (s.cmp(ec.nh) === 1) {
      sig.set(ecparams.n.sub(s).toArrayLike(Uint8Array, 'be', 32), 32)
    }

    return 0
  },

  // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
  // Adapted for Uint8Array instead Buffer
  signatureExport (obj, sig) {
    const sigR = sig.subarray(0, 32)
    const sigS = sig.subarray(32, 64)
    if (new BN(sigR).cmp(ecparams.n) >= 0) return 1
    if (new BN(sigS).cmp(ecparams.n) >= 0) return 1

    const { output } = obj

    // Prepare R
    let r = output.subarray(4, 4 + 33)
    r[0] = 0x00
    r.set(sigR, 1)

    let lenR = 33
    let posR = 0
    for (; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);

    r = r.subarray(posR)
    if (r[0] & 0x80) return 1
    if (lenR > 1 && (r[0] === 0x00) && !(r[1] & 0x80)) return 1

    // Prepare S
    let s = output.subarray(6 + 33, 6 + 33 + 33)
    s[0] = 0x00
    s.set(sigS, 1)

    let lenS = 33
    let posS = 0
    for (; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);

    s = s.subarray(posS)
    if (s[0] & 0x80) return 1
    if (lenS > 1 && (s[0] === 0x00) && !(s[1] & 0x80)) return 1

    // Set output length for return
    obj.outputlen = 6 + lenR + lenS

    // Output in specified format
    // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
    output[0] = 0x30
    output[1] = obj.outputlen - 2
    output[2] = 0x02
    output[3] = r.length
    output.set(r, 4)
    output[4 + lenR] = 0x02
    output[5 + lenR] = s.length
    output.set(s, 6 + lenR)

    return 0
  },

  // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
  // Adapted for Uint8Array instead Buffer
  signatureImport (output, sig) {
    if (sig.length < 8) return 1
    if (sig.length > 72) return 1
    if (sig[0] !== 0x30) return 1
    if (sig[1] !== sig.length - 2) return 1
    if (sig[2] !== 0x02) return 1

    const lenR = sig[3]
    if (lenR === 0) return 1
    if (5 + lenR >= sig.length) return 1
    if (sig[4 + lenR] !== 0x02) return 1

    const lenS = sig[5 + lenR]
    if (lenS === 0) return 1
    if ((6 + lenR + lenS) !== sig.length) return 1

    if (sig[4] & 0x80) return 1
    if (lenR > 1 && (sig[4] === 0x00) && !(sig[5] & 0x80)) return 1

    if (sig[lenR + 6] & 0x80) return 1
    if (lenS > 1 && (sig[lenR + 6] === 0x00) && !(sig[lenR + 7] & 0x80)) return 1

    let sigR = sig.subarray(4, 4 + lenR)
    if (sigR.length === 33 && sigR[0] === 0x00) sigR = sigR.subarray(1)
    if (sigR.length > 32) return 1

    let sigS = sig.subarray(6 + lenR)
    if (sigS.length === 33 && sigS[0] === 0x00) sigS = sigS.slice(1)
    if (sigS.length > 32) throw new Error('S length is too long')

    let r = new BN(sigR)
    if (r.cmp(ecparams.n) >= 0) r = new BN(0)

    let s = new BN(sig.subarray(6 + lenR))
    if (s.cmp(ecparams.n) >= 0) s = new BN(0)

    output.set(r.toArrayLike(Uint8Array, 'be', 32), 0)
    output.set(s.toArrayLike(Uint8Array, 'be', 32), 32)

    return 0
  },

  ecdsaSign (obj, message, seckey, data, noncefn) {
    if (noncefn) {
      const _noncefn = noncefn
      noncefn = (counter) => {
        const nonce = _noncefn(message, seckey, null, data, counter)

        const isValid = nonce instanceof Uint8Array && nonce.length === 32
        if (!isValid) throw new Error('This is the way')

        return new BN(nonce)
      }
    }

    const d = new BN(seckey)
    if (d.cmp(ecparams.n) >= 0 || d.isZero()) return 1

    let sig
    try {
      sig = ec.sign(message, seckey, { canonical: true, k: noncefn, pers: data })
    } catch (err) {
      return 1
    }

    obj.signature.set(sig.r.toArrayLike(Uint8Array, 'be', 32), 0)
    obj.signature.set(sig.s.toArrayLike(Uint8Array, 'be', 32), 32)
    obj.recid = sig.recoveryParam

    return 0
  },

  ecdsaVerify (sig, msg32, pubkey) {
    const sigObj = { r: sig.subarray(0, 32), s: sig.subarray(32, 64) }

    const sigr = new BN(sigObj.r)
    const sigs = new BN(sigObj.s)
    if (sigr.cmp(ecparams.n) >= 0 || sigs.cmp(ecparams.n) >= 0) return 1
    if (sigs.cmp(ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return 3

    const pair = loadPublicKey(pubkey)
    if (pair === null) return 2

    const point = pair.getPublic()
    const isValid = ec.verify(msg32, sigObj, point)
    return isValid ? 0 : 3
  },

  ecdsaRecover (output, sig, recid, msg32) {
    const sigObj = { r: sig.slice(0, 32), s: sig.slice(32, 64) }

    const sigr = new BN(sigObj.r)
    const sigs = new BN(sigObj.s)
    if (sigr.cmp(ecparams.n) >= 0 || sigs.cmp(ecparams.n) >= 0) return 1

    if (sigr.isZero() || sigs.isZero()) return 2

    // Can throw `throw new Error('Unable to find sencond key candinate');`
    let point
    try {
      point = ec.recoverPubKey(msg32, sigObj, recid)
    } catch (err) {
      return 2
    }

    savePublicKey(output, point)

    return 0
  },

  ecdh (output, pubkey, seckey, data, hashfn, xbuf, ybuf) {
    const pair = loadPublicKey(pubkey)
    if (pair === null) return 1

    const scalar = new BN(seckey)
    if (scalar.cmp(ecparams.n) >= 0 || scalar.isZero()) return 2

    const point = pair.getPublic().mul(scalar)

    if (hashfn === undefined) {
      const data = point.encode(null, true)
      const sha256 = ec.hash().update(data).digest()
      for (let i = 0; i < 32; ++i) output[i] = sha256[i]
    } else {
      if (!xbuf) xbuf = new Uint8Array(32)
      const x = point.getX().toArray('be', 32)
      for (let i = 0; i < 32; ++i) xbuf[i] = x[i]

      if (!ybuf) ybuf = new Uint8Array(32)
      const y = point.getY().toArray('be', 32)
      for (let i = 0; i < 32; ++i) ybuf[i] = y[i]

      const hash = hashfn(xbuf, ybuf, data)

      const isValid = hash instanceof Uint8Array && hash.length === output.length
      if (!isValid) return 2

      output.set(hash)
    }

    return 0
  }
}


/***/ }),

/***/ "../../node_modules/secp256k1/lib/index.js":
/***/ ((module) => {

const errors = {
  IMPOSSIBLE_CASE: 'Impossible case. Please create issue.',
  TWEAK_ADD:
    'The tweak was out of range or the resulted private key is invalid',
  TWEAK_MUL: 'The tweak was out of range or equal to zero',
  CONTEXT_RANDOMIZE_UNKNOW: 'Unknow error on context randomization',
  SECKEY_INVALID: 'Private Key is invalid',
  PUBKEY_PARSE: 'Public Key could not be parsed',
  PUBKEY_SERIALIZE: 'Public Key serialization error',
  PUBKEY_COMBINE: 'The sum of the public keys is not valid',
  SIG_PARSE: 'Signature could not be parsed',
  SIGN: 'The nonce generation function failed, or the private key was invalid',
  RECOVER: 'Public key could not be recover',
  ECDH: 'Scalar was invalid (zero or overflow)'
}

function assert (cond, msg) {
  if (!cond) throw new Error(msg)
}

function isUint8Array (name, value, length) {
  assert(value instanceof Uint8Array, `Expected ${name} to be an Uint8Array`)

  if (length !== undefined) {
    if (Array.isArray(length)) {
      const numbers = length.join(', ')
      const msg = `Expected ${name} to be an Uint8Array with length [${numbers}]`
      assert(length.includes(value.length), msg)
    } else {
      const msg = `Expected ${name} to be an Uint8Array with length ${length}`
      assert(value.length === length, msg)
    }
  }
}

function isCompressed (value) {
  assert(toTypeString(value) === 'Boolean', 'Expected compressed to be a Boolean')
}

function getAssertedOutput (output = (len) => new Uint8Array(len), length) {
  if (typeof output === 'function') output = output(length)
  isUint8Array('output', output, length)
  return output
}

function toTypeString (value) {
  return Object.prototype.toString.call(value).slice(8, -1)
}

module.exports = (secp256k1) => {
  return {
    contextRandomize (seed) {
      assert(
        seed === null || seed instanceof Uint8Array,
        'Expected seed to be an Uint8Array or null'
      )
      if (seed !== null) isUint8Array('seed', seed, 32)

      switch (secp256k1.contextRandomize(seed)) {
        case 1:
          throw new Error(errors.CONTEXT_RANDOMIZE_UNKNOW)
      }
    },

    privateKeyVerify (seckey) {
      isUint8Array('private key', seckey, 32)

      return secp256k1.privateKeyVerify(seckey) === 0
    },

    privateKeyNegate (seckey) {
      isUint8Array('private key', seckey, 32)

      switch (secp256k1.privateKeyNegate(seckey)) {
        case 0:
          return seckey
        case 1:
          throw new Error(errors.IMPOSSIBLE_CASE)
      }
    },

    privateKeyTweakAdd (seckey, tweak) {
      isUint8Array('private key', seckey, 32)
      isUint8Array('tweak', tweak, 32)

      switch (secp256k1.privateKeyTweakAdd(seckey, tweak)) {
        case 0:
          return seckey
        case 1:
          throw new Error(errors.TWEAK_ADD)
      }
    },

    privateKeyTweakMul (seckey, tweak) {
      isUint8Array('private key', seckey, 32)
      isUint8Array('tweak', tweak, 32)

      switch (secp256k1.privateKeyTweakMul(seckey, tweak)) {
        case 0:
          return seckey
        case 1:
          throw new Error(errors.TWEAK_MUL)
      }
    },

    publicKeyVerify (pubkey) {
      isUint8Array('public key', pubkey, [33, 65])

      return secp256k1.publicKeyVerify(pubkey) === 0
    },

    publicKeyCreate (seckey, compressed = true, output) {
      isUint8Array('private key', seckey, 32)
      isCompressed(compressed)
      output = getAssertedOutput(output, compressed ? 33 : 65)

      switch (secp256k1.publicKeyCreate(output, seckey)) {
        case 0:
          return output
        case 1:
          throw new Error(errors.SECKEY_INVALID)
        case 2:
          throw new Error(errors.PUBKEY_SERIALIZE)
      }
    },

    publicKeyConvert (pubkey, compressed = true, output) {
      isUint8Array('public key', pubkey, [33, 65])
      isCompressed(compressed)
      output = getAssertedOutput(output, compressed ? 33 : 65)

      switch (secp256k1.publicKeyConvert(output, pubkey)) {
        case 0:
          return output
        case 1:
          throw new Error(errors.PUBKEY_PARSE)
        case 2:
          throw new Error(errors.PUBKEY_SERIALIZE)
      }
    },

    publicKeyNegate (pubkey, compressed = true, output) {
      isUint8Array('public key', pubkey, [33, 65])
      isCompressed(compressed)
      output = getAssertedOutput(output, compressed ? 33 : 65)

      switch (secp256k1.publicKeyNegate(output, pubkey)) {
        case 0:
          return output
        case 1:
          throw new Error(errors.PUBKEY_PARSE)
        case 2:
          throw new Error(errors.IMPOSSIBLE_CASE)
        case 3:
          throw new Error(errors.PUBKEY_SERIALIZE)
      }
    },

    publicKeyCombine (pubkeys, compressed = true, output) {
      assert(Array.isArray(pubkeys), 'Expected public keys to be an Array')
      assert(pubkeys.length > 0, 'Expected public keys array will have more than zero items')
      for (const pubkey of pubkeys) {
        isUint8Array('public key', pubkey, [33, 65])
      }
      isCompressed(compressed)
      output = getAssertedOutput(output, compressed ? 33 : 65)

      switch (secp256k1.publicKeyCombine(output, pubkeys)) {
        case 0:
          return output
        case 1:
          throw new Error(errors.PUBKEY_PARSE)
        case 2:
          throw new Error(errors.PUBKEY_COMBINE)
        case 3:
          throw new Error(errors.PUBKEY_SERIALIZE)
      }
    },

    publicKeyTweakAdd (pubkey, tweak, compressed = true, output) {
      isUint8Array('public key', pubkey, [33, 65])
      isUint8Array('tweak', tweak, 32)
      isCompressed(compressed)
      output = getAssertedOutput(output, compressed ? 33 : 65)

      switch (secp256k1.publicKeyTweakAdd(output, pubkey, tweak)) {
        case 0:
          return output
        case 1:
          throw new Error(errors.PUBKEY_PARSE)
        case 2:
          throw new Error(errors.TWEAK_ADD)
      }
    },

    publicKeyTweakMul (pubkey, tweak, compressed = true, output) {
      isUint8Array('public key', pubkey, [33, 65])
      isUint8Array('tweak', tweak, 32)
      isCompressed(compressed)
      output = getAssertedOutput(output, compressed ? 33 : 65)

      switch (secp256k1.publicKeyTweakMul(output, pubkey, tweak)) {
        case 0:
          return output
        case 1:
          throw new Error(errors.PUBKEY_PARSE)
        case 2:
          throw new Error(errors.TWEAK_MUL)
      }
    },

    signatureNormalize (sig) {
      isUint8Array('signature', sig, 64)

      switch (secp256k1.signatureNormalize(sig)) {
        case 0:
          return sig
        case 1:
          throw new Error(errors.SIG_PARSE)
      }
    },

    signatureExport (sig, output) {
      isUint8Array('signature', sig, 64)
      output = getAssertedOutput(output, 72)

      const obj = { output, outputlen: 72 }
      switch (secp256k1.signatureExport(obj, sig)) {
        case 0:
          return output.slice(0, obj.outputlen)
        case 1:
          throw new Error(errors.SIG_PARSE)
        case 2:
          throw new Error(errors.IMPOSSIBLE_CASE)
      }
    },

    signatureImport (sig, output) {
      isUint8Array('signature', sig)
      output = getAssertedOutput(output, 64)

      switch (secp256k1.signatureImport(output, sig)) {
        case 0:
          return output
        case 1:
          throw new Error(errors.SIG_PARSE)
        case 2:
          throw new Error(errors.IMPOSSIBLE_CASE)
      }
    },

    ecdsaSign (msg32, seckey, options = {}, output) {
      isUint8Array('message', msg32, 32)
      isUint8Array('private key', seckey, 32)
      assert(toTypeString(options) === 'Object', 'Expected options to be an Object')
      if (options.data !== undefined) isUint8Array('options.data', options.data)
      if (options.noncefn !== undefined) assert(toTypeString(options.noncefn) === 'Function', 'Expected options.noncefn to be a Function')
      output = getAssertedOutput(output, 64)

      const obj = { signature: output, recid: null }
      switch (secp256k1.ecdsaSign(obj, msg32, seckey, options.data, options.noncefn)) {
        case 0:
          return obj
        case 1:
          throw new Error(errors.SIGN)
        case 2:
          throw new Error(errors.IMPOSSIBLE_CASE)
      }
    },

    ecdsaVerify (sig, msg32, pubkey) {
      isUint8Array('signature', sig, 64)
      isUint8Array('message', msg32, 32)
      isUint8Array('public key', pubkey, [33, 65])

      switch (secp256k1.ecdsaVerify(sig, msg32, pubkey)) {
        case 0:
          return true
        case 3:
          return false
        case 1:
          throw new Error(errors.SIG_PARSE)
        case 2:
          throw new Error(errors.PUBKEY_PARSE)
      }
    },

    ecdsaRecover (sig, recid, msg32, compressed = true, output) {
      isUint8Array('signature', sig, 64)
      assert(
        toTypeString(recid) === 'Number' &&
          recid >= 0 &&
          recid <= 3,
        'Expected recovery id to be a Number within interval [0, 3]'
      )
      isUint8Array('message', msg32, 32)
      isCompressed(compressed)
      output = getAssertedOutput(output, compressed ? 33 : 65)

      switch (secp256k1.ecdsaRecover(output, sig, recid, msg32)) {
        case 0:
          return output
        case 1:
          throw new Error(errors.SIG_PARSE)
        case 2:
          throw new Error(errors.RECOVER)
        case 3:
          throw new Error(errors.IMPOSSIBLE_CASE)
      }
    },

    ecdh (pubkey, seckey, options = {}, output) {
      isUint8Array('public key', pubkey, [33, 65])
      isUint8Array('private key', seckey, 32)
      assert(toTypeString(options) === 'Object', 'Expected options to be an Object')
      if (options.data !== undefined) isUint8Array('options.data', options.data)
      if (options.hashfn !== undefined) {
        assert(toTypeString(options.hashfn) === 'Function', 'Expected options.hashfn to be a Function')
        if (options.xbuf !== undefined) isUint8Array('options.xbuf', options.xbuf, 32)
        if (options.ybuf !== undefined) isUint8Array('options.ybuf', options.ybuf, 32)
        isUint8Array('output', output)
      } else {
        output = getAssertedOutput(output, 32)
      }

      switch (secp256k1.ecdh(output, pubkey, seckey, options.data, options.hashfn, options.xbuf, options.ybuf)) {
        case 0:
          return output
        case 1:
          throw new Error(errors.PUBKEY_PARSE)
        case 2:
          throw new Error(errors.ECDH)
      }
    }
  }
}


/***/ }),

/***/ "../../node_modules/setimmediate/setImmediate.js":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof __webpack_require__.g === "undefined" ? this : __webpack_require__.g : self));


/***/ }),

/***/ "../../node_modules/sha.js/hash.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),

/***/ "../../node_modules/sha.js/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__("../../node_modules/sha.js/sha.js")
exports.sha1 = __webpack_require__("../../node_modules/sha.js/sha1.js")
exports.sha224 = __webpack_require__("../../node_modules/sha.js/sha224.js")
exports.sha256 = __webpack_require__("../../node_modules/sha.js/sha256.js")
exports.sha384 = __webpack_require__("../../node_modules/sha.js/sha384.js")
exports.sha512 = __webpack_require__("../../node_modules/sha.js/sha512.js")


/***/ }),

/***/ "../../node_modules/sha.js/sha.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var Hash = __webpack_require__("../../node_modules/sha.js/hash.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),

/***/ "../../node_modules/sha.js/sha1.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var Hash = __webpack_require__("../../node_modules/sha.js/hash.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),

/***/ "../../node_modules/sha.js/sha224.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var Sha256 = __webpack_require__("../../node_modules/sha.js/sha256.js")
var Hash = __webpack_require__("../../node_modules/sha.js/hash.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),

/***/ "../../node_modules/sha.js/sha256.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var Hash = __webpack_require__("../../node_modules/sha.js/hash.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),

/***/ "../../node_modules/sha.js/sha384.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var SHA512 = __webpack_require__("../../node_modules/sha.js/sha512.js")
var Hash = __webpack_require__("../../node_modules/sha.js/hash.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),

/***/ "../../node_modules/sha.js/sha512.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js")
var Hash = __webpack_require__("../../node_modules/sha.js/hash.js")
var Buffer = (__webpack_require__("../../node_modules/safe-buffer/index.js").Buffer)

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),

/***/ "../../node_modules/sha3/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports["default"]=exports.SHAKE=exports.SHA3Hash=exports.SHA3=exports.Keccak=void 0;var _buffer=__webpack_require__("../../node_modules/buffer/index.js");var _sponge=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/index.js"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj}}var createHash=function createHash(_ref){var allowedSizes=_ref.allowedSizes,defaultSize=_ref.defaultSize,padding=_ref.padding;return function Hash(){var _this=this;var size=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultSize;if(!this||this.constructor!==Hash){return new Hash(size)}if(allowedSizes&&!allowedSizes.includes(size)){throw new Error("Unsupported hash length")}var sponge=new _sponge["default"]({capacity:size});this.update=function(input){var encoding=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"utf8";if(_buffer.Buffer.isBuffer(input)){sponge.absorb(input);return _this}if(typeof input==="string"){return _this.update(_buffer.Buffer.from(input,encoding))}throw new TypeError("Not a string or buffer")};this.digest=function(){var formatOrOptions=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"binary";var options=typeof formatOrOptions==="string"?{format:formatOrOptions}:formatOrOptions;var buffer=sponge.squeeze({buffer:options.buffer,padding:options.padding||padding});if(options.format&&options.format!=="binary"){return buffer.toString(options.format)}return buffer};this.reset=function(){sponge.reset();return _this};return this}};var Keccak=createHash({allowedSizes:[224,256,384,512],defaultSize:512,padding:1});exports.Keccak=Keccak;var SHA3=createHash({allowedSizes:[224,256,384,512],defaultSize:512,padding:6});exports.SHA3=SHA3;var SHAKE=createHash({allowedSizes:[128,256],defaultSize:256,padding:31});exports.SHAKE=SHAKE;var SHA3Hash=Keccak;exports.SHA3Hash=SHA3Hash;SHA3.SHA3Hash=SHA3Hash;var _default=SHA3;exports["default"]=_default;

/***/ }),

/***/ "../../node_modules/sha3/sponge/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports["default"]=void 0;var _buffer=__webpack_require__("../../node_modules/buffer/index.js");var _permute=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/index.js"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj}}var xorWords=function xorWords(I,O){for(var i=0;i<I.length;i+=8){var o=i/4;O[o]^=I[i+7]<<24|I[i+6]<<16|I[i+5]<<8|I[i+4];O[o+1]^=I[i+3]<<24|I[i+2]<<16|I[i+1]<<8|I[i]}return O};var readWords=function readWords(I,O){for(var o=0;o<O.length;o+=8){var i=o/4;O[o]=I[i+1];O[o+1]=I[i+1]>>>8;O[o+2]=I[i+1]>>>16;O[o+3]=I[i+1]>>>24;O[o+4]=I[i];O[o+5]=I[i]>>>8;O[o+6]=I[i]>>>16;O[o+7]=I[i]>>>24}return O};var Sponge=function Sponge(_ref){var _this=this;var capacity=_ref.capacity,padding=_ref.padding;var keccak=(0,_permute["default"])();var stateSize=200;var blockSize=capacity/8;var queueSize=stateSize-capacity/4;var queueOffset=0;var state=new Uint32Array(stateSize/4);var queue=_buffer.Buffer.allocUnsafe(queueSize);this.absorb=function(buffer){for(var i=0;i<buffer.length;i++){queue[queueOffset]=buffer[i];queueOffset+=1;if(queueOffset>=queueSize){xorWords(queue,state);keccak(state);queueOffset=0}}return _this};this.squeeze=function(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var output={buffer:options.buffer||_buffer.Buffer.allocUnsafe(blockSize),padding:options.padding||padding,queue:_buffer.Buffer.allocUnsafe(queue.length),state:new Uint32Array(state.length)};queue.copy(output.queue);for(var i=0;i<state.length;i++){output.state[i]=state[i]}output.queue.fill(0,queueOffset);output.queue[queueOffset]|=output.padding;output.queue[queueSize-1]|=128;xorWords(output.queue,output.state);for(var offset=0;offset<output.buffer.length;offset+=queueSize){keccak(output.state);readWords(output.state,output.buffer.slice(offset,offset+queueSize))}return output.buffer};this.reset=function(){queue.fill(0);state.fill(0);queueOffset=0;return _this};return this};var _default=Sponge;exports["default"]=_default;

/***/ }),

/***/ "../../node_modules/sha3/sponge/permute/chi/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports["default"]=void 0;var _copy=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/copy/index.js"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj}}var chi=function chi(_ref){var A=_ref.A,C=_ref.C;for(var y=0;y<25;y+=5){for(var x=0;x<5;x++){(0,_copy["default"])(A,y+x)(C,x)}for(var _x=0;_x<5;_x++){var xy=(y+_x)*2;var x1=(_x+1)%5*2;var x2=(_x+2)%5*2;A[xy]^=~C[x1]&C[x2];A[xy+1]^=~C[x1+1]&C[x2+1]}}};var _default=chi;exports["default"]=_default;

/***/ }),

/***/ "../../node_modules/sha3/sponge/permute/copy/index.js":
/***/ ((module) => {

"use strict";
var copy=function copy(I,i){return function(O,o){var oi=o*2;var ii=i*2;O[oi]=I[ii];O[oi+1]=I[ii+1]}};module.exports=copy;

/***/ }),

/***/ "../../node_modules/sha3/sponge/permute/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports["default"]=void 0;var _chi=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/chi/index.js"));var _iota=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/iota/index.js"));var _rhoPi=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/rho-pi/index.js"));var _theta=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/theta/index.js"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj}}var permute=function permute(){var C=new Uint32Array(10);var D=new Uint32Array(10);var W=new Uint32Array(2);return function(A){for(var roundIndex=0;roundIndex<24;roundIndex++){(0,_theta["default"])({A:A,C:C,D:D,W:W});(0,_rhoPi["default"])({A:A,C:C,W:W});(0,_chi["default"])({A:A,C:C});(0,_iota["default"])({A:A,roundIndex:roundIndex})}C.fill(0);D.fill(0);W.fill(0)}};var _default=permute;exports["default"]=_default;

/***/ }),

/***/ "../../node_modules/sha3/sponge/permute/iota/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports["default"]=void 0;var _roundConstants=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/iota/round-constants/index.js"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj}}var iota=function iota(_ref){var A=_ref.A,roundIndex=_ref.roundIndex;var i=roundIndex*2;A[0]^=_roundConstants["default"][i];A[1]^=_roundConstants["default"][i+1]};var _default=iota;exports["default"]=_default;

/***/ }),

/***/ "../../node_modules/sha3/sponge/permute/iota/round-constants/index.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports["default"]=void 0;var ROUND_CONSTANTS=new Uint32Array([0,1,0,32898,2147483648,32906,2147483648,2147516416,0,32907,0,2147483649,2147483648,2147516545,2147483648,32777,0,138,0,136,0,2147516425,0,2147483658,0,2147516555,2147483648,139,2147483648,32905,2147483648,32771,2147483648,32770,2147483648,128,0,32778,2147483648,2147483658,2147483648,2147516545,2147483648,32896,0,2147483649,2147483648,2147516424]);var _default=ROUND_CONSTANTS;exports["default"]=_default;

/***/ }),

/***/ "../../node_modules/sha3/sponge/permute/rho-pi/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports["default"]=void 0;var _piShuffles=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/rho-pi/pi-shuffles/index.js"));var _rhoOffsets=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/rho-pi/rho-offsets/index.js"));var _copy=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/copy/index.js"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj}}var rhoPi=function rhoPi(_ref){var A=_ref.A,C=_ref.C,W=_ref.W;(0,_copy["default"])(A,1)(W,0);var H=0;var L=0;var Wi=0;var ri=32;for(var i=0;i<24;i++){var j=_piShuffles["default"][i];var r=_rhoOffsets["default"][i];(0,_copy["default"])(A,j)(C,0);H=W[0];L=W[1];ri=32-r;Wi=r<32?0:1;W[Wi]=H<<r|L>>>ri;W[(Wi+1)%2]=L<<r|H>>>ri;(0,_copy["default"])(W,0)(A,j);(0,_copy["default"])(C,0)(W,0)}};var _default=rhoPi;exports["default"]=_default;

/***/ }),

/***/ "../../node_modules/sha3/sponge/permute/rho-pi/pi-shuffles/index.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports["default"]=void 0;var PI_SHUFFLES=[10,7,11,17,18,3,5,16,8,21,24,4,15,23,19,13,12,2,20,14,22,9,6,1];var _default=PI_SHUFFLES;exports["default"]=_default;

/***/ }),

/***/ "../../node_modules/sha3/sponge/permute/rho-pi/rho-offsets/index.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports["default"]=void 0;var RHO_OFFSETS=[1,3,6,10,15,21,28,36,45,55,2,14,27,41,56,8,25,43,62,18,39,61,20,44];var _default=RHO_OFFSETS;exports["default"]=_default;

/***/ }),

/***/ "../../node_modules/sha3/sponge/permute/theta/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports["default"]=void 0;var _copy=_interopRequireDefault(__webpack_require__("../../node_modules/sha3/sponge/permute/copy/index.js"));function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj}}var theta=function theta(_ref){var A=_ref.A,C=_ref.C,D=_ref.D,W=_ref.W;var H=0;var L=0;for(var x=0;x<5;x++){var x20=x*2;var x21=(x+5)*2;var x22=(x+10)*2;var x23=(x+15)*2;var x24=(x+20)*2;C[x20]=A[x20]^A[x21]^A[x22]^A[x23]^A[x24];C[x20+1]=A[x20+1]^A[x21+1]^A[x22+1]^A[x23+1]^A[x24+1]}for(var _x=0;_x<5;_x++){(0,_copy["default"])(C,(_x+1)%5)(W,0);H=W[0];L=W[1];W[0]=H<<1|L>>>31;W[1]=L<<1|H>>>31;D[_x*2]=C[(_x+4)%5*2]^W[0];D[_x*2+1]=C[(_x+4)%5*2+1]^W[1];for(var y=0;y<25;y+=5){A[(y+_x)*2]^=D[_x*2];A[(y+_x)*2+1]^=D[_x*2+1]}}};var _default=theta;exports["default"]=_default;

/***/ }),

/***/ "../../node_modules/string_decoder/lib/string_decoder.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__("../../node_modules/string_decoder/node_modules/safe-buffer/index.js").Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ "../../node_modules/string_decoder/node_modules/safe-buffer/index.js":
/***/ ((module, exports, __webpack_require__) => {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("../../node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "../../node_modules/tslib/tslib.es6.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   __assign: () => (/* binding */ __assign),
/* harmony export */   __asyncDelegator: () => (/* binding */ __asyncDelegator),
/* harmony export */   __asyncGenerator: () => (/* binding */ __asyncGenerator),
/* harmony export */   __asyncValues: () => (/* binding */ __asyncValues),
/* harmony export */   __await: () => (/* binding */ __await),
/* harmony export */   __awaiter: () => (/* binding */ __awaiter),
/* harmony export */   __classPrivateFieldGet: () => (/* binding */ __classPrivateFieldGet),
/* harmony export */   __classPrivateFieldIn: () => (/* binding */ __classPrivateFieldIn),
/* harmony export */   __classPrivateFieldSet: () => (/* binding */ __classPrivateFieldSet),
/* harmony export */   __createBinding: () => (/* binding */ __createBinding),
/* harmony export */   __decorate: () => (/* binding */ __decorate),
/* harmony export */   __esDecorate: () => (/* binding */ __esDecorate),
/* harmony export */   __exportStar: () => (/* binding */ __exportStar),
/* harmony export */   __extends: () => (/* binding */ __extends),
/* harmony export */   __generator: () => (/* binding */ __generator),
/* harmony export */   __importDefault: () => (/* binding */ __importDefault),
/* harmony export */   __importStar: () => (/* binding */ __importStar),
/* harmony export */   __makeTemplateObject: () => (/* binding */ __makeTemplateObject),
/* harmony export */   __metadata: () => (/* binding */ __metadata),
/* harmony export */   __param: () => (/* binding */ __param),
/* harmony export */   __propKey: () => (/* binding */ __propKey),
/* harmony export */   __read: () => (/* binding */ __read),
/* harmony export */   __rest: () => (/* binding */ __rest),
/* harmony export */   __runInitializers: () => (/* binding */ __runInitializers),
/* harmony export */   __setFunctionName: () => (/* binding */ __setFunctionName),
/* harmony export */   __spread: () => (/* binding */ __spread),
/* harmony export */   __spreadArray: () => (/* binding */ __spreadArray),
/* harmony export */   __spreadArrays: () => (/* binding */ __spreadArrays),
/* harmony export */   __values: () => (/* binding */ __values)
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};

function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};

function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ "../../node_modules/tsyringe/dist/cjs/error-helpers.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatErrorCtor = void 0;
function formatDependency(params, idx) {
    if (params === null) {
        return `at position #${idx}`;
    }
    const argName = params.split(",")[idx].trim();
    return `"${argName}" at position #${idx}`;
}
function composeErrorMessage(msg, e, indent = "    ") {
    return [msg, ...e.message.split("\n").map(l => indent + l)].join("\n");
}
function formatErrorCtor(ctor, paramIdx, error) {
    const [, params = null] = ctor.toString().match(/constructor\(([\w, ]+)\)/) || [];
    const dep = formatDependency(params, paramIdx);
    return composeErrorMessage(`Cannot inject the dependency ${dep} of "${ctor.name}" constructor. Reason:`, error);
}
exports.formatErrorCtor = formatErrorCtor;


/***/ }),

/***/ "../../node_modules/tsyringe/dist/cjs/lazy-helpers.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.delay = exports.DelayedConstructor = void 0;
class DelayedConstructor {
    constructor(wrap) {
        this.wrap = wrap;
        this.reflectMethods = [
            "get",
            "getPrototypeOf",
            "setPrototypeOf",
            "getOwnPropertyDescriptor",
            "defineProperty",
            "has",
            "set",
            "deleteProperty",
            "apply",
            "construct",
            "ownKeys"
        ];
    }
    createProxy(createObject) {
        const target = {};
        let init = false;
        let value;
        const delayedObject = () => {
            if (!init) {
                value = createObject(this.wrap());
                init = true;
            }
            return value;
        };
        return new Proxy(target, this.createHandler(delayedObject));
    }
    createHandler(delayedObject) {
        const handler = {};
        const install = (name) => {
            handler[name] = (...args) => {
                args[0] = delayedObject();
                const method = Reflect[name];
                return method(...args);
            };
        };
        this.reflectMethods.forEach(install);
        return handler;
    }
}
exports.DelayedConstructor = DelayedConstructor;
function delay(wrappedConstructor) {
    if (typeof wrappedConstructor === "undefined") {
        throw new Error("Attempt to `delay` undefined. Constructor must be wrapped in a callback");
    }
    return new DelayedConstructor(wrappedConstructor);
}
exports.delay = delay;


/***/ }),

/***/ "../../node_modules/tsyringe/dist/cjs/providers/injection-token.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isConstructorToken = exports.isTransformDescriptor = exports.isTokenDescriptor = exports.isNormalToken = void 0;
const lazy_helpers_1 = __webpack_require__("../../node_modules/tsyringe/dist/cjs/lazy-helpers.js");
function isNormalToken(token) {
    return typeof token === "string" || typeof token === "symbol";
}
exports.isNormalToken = isNormalToken;
function isTokenDescriptor(descriptor) {
    return (typeof descriptor === "object" &&
        "token" in descriptor &&
        "multiple" in descriptor);
}
exports.isTokenDescriptor = isTokenDescriptor;
function isTransformDescriptor(descriptor) {
    return (typeof descriptor === "object" &&
        "token" in descriptor &&
        "transform" in descriptor);
}
exports.isTransformDescriptor = isTransformDescriptor;
function isConstructorToken(token) {
    return typeof token === "function" || token instanceof lazy_helpers_1.DelayedConstructor;
}
exports.isConstructorToken = isConstructorToken;


/***/ }),

/***/ "../../node_modules/tsyringe/dist/esm5/index.js":
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Lifecycle: () => (/* reexport */ lifecycle),
  autoInjectable: () => (/* reexport */ auto_injectable),
  container: () => (/* reexport */ instance),
  delay: () => (/* reexport */ delay),
  inject: () => (/* reexport */ decorators_inject),
  injectAll: () => (/* reexport */ inject_all),
  injectAllWithTransform: () => (/* reexport */ inject_all_with_transform),
  injectWithTransform: () => (/* reexport */ inject_with_transform),
  injectable: () => (/* reexport */ decorators_injectable),
  instanceCachingFactory: () => (/* reexport */ instanceCachingFactory),
  instancePerContainerCachingFactory: () => (/* reexport */ instancePerContainerCachingFactory),
  isClassProvider: () => (/* reexport */ isClassProvider),
  isFactoryProvider: () => (/* reexport */ isFactoryProvider),
  isNormalToken: () => (/* reexport */ isNormalToken),
  isTokenProvider: () => (/* reexport */ isTokenProvider),
  isValueProvider: () => (/* reexport */ isValueProvider),
  predicateAwareClassFactory: () => (/* reexport */ predicateAwareClassFactory),
  registry: () => (/* reexport */ decorators_registry),
  scoped: () => (/* reexport */ scoped),
  singleton: () => (/* reexport */ decorators_singleton)
});

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/types/lifecycle.js
var Lifecycle;
(function (Lifecycle) {
    Lifecycle[Lifecycle["Transient"] = 0] = "Transient";
    Lifecycle[Lifecycle["Singleton"] = 1] = "Singleton";
    Lifecycle[Lifecycle["ResolutionScoped"] = 2] = "ResolutionScoped";
    Lifecycle[Lifecycle["ContainerScoped"] = 3] = "ContainerScoped";
})(Lifecycle || (Lifecycle = {}));
/* harmony default export */ const lifecycle = (Lifecycle);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/types/index.js


;// CONCATENATED MODULE: ../../node_modules/tsyringe/node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/reflection-helpers.js
var INJECTION_TOKEN_METADATA_KEY = "injectionTokens";
function getParamInfo(target) {
    var params = Reflect.getMetadata("design:paramtypes", target) || [];
    var injectionTokens = Reflect.getOwnMetadata(INJECTION_TOKEN_METADATA_KEY, target) || {};
    Object.keys(injectionTokens).forEach(function (key) {
        params[+key] = injectionTokens[key];
    });
    return params;
}
function defineInjectionTokenMetadata(data, transform) {
    return function (target, _propertyKey, parameterIndex) {
        var descriptors = Reflect.getOwnMetadata(INJECTION_TOKEN_METADATA_KEY, target) || {};
        descriptors[parameterIndex] = transform
            ? {
                token: data,
                transform: transform.transformToken,
                transformArgs: transform.args || []
            }
            : data;
        Reflect.defineMetadata(INJECTION_TOKEN_METADATA_KEY, descriptors, target);
    };
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/providers/class-provider.js
function isClassProvider(provider) {
    return !!provider.useClass;
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/providers/factory-provider.js
function isFactoryProvider(provider) {
    return !!provider.useFactory;
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/lazy-helpers.js

var DelayedConstructor = (function () {
    function DelayedConstructor(wrap) {
        this.wrap = wrap;
        this.reflectMethods = [
            "get",
            "getPrototypeOf",
            "setPrototypeOf",
            "getOwnPropertyDescriptor",
            "defineProperty",
            "has",
            "set",
            "deleteProperty",
            "apply",
            "construct",
            "ownKeys"
        ];
    }
    DelayedConstructor.prototype.createProxy = function (createObject) {
        var _this = this;
        var target = {};
        var init = false;
        var value;
        var delayedObject = function () {
            if (!init) {
                value = createObject(_this.wrap());
                init = true;
            }
            return value;
        };
        return new Proxy(target, this.createHandler(delayedObject));
    };
    DelayedConstructor.prototype.createHandler = function (delayedObject) {
        var handler = {};
        var install = function (name) {
            handler[name] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                args[0] = delayedObject();
                var method = Reflect[name];
                return method.apply(void 0, __spread(args));
            };
        };
        this.reflectMethods.forEach(install);
        return handler;
    };
    return DelayedConstructor;
}());

function delay(wrappedConstructor) {
    if (typeof wrappedConstructor === "undefined") {
        throw new Error("Attempt to `delay` undefined. Constructor must be wrapped in a callback");
    }
    return new DelayedConstructor(wrappedConstructor);
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/providers/injection-token.js

function isNormalToken(token) {
    return typeof token === "string" || typeof token === "symbol";
}
function isTokenDescriptor(descriptor) {
    return (typeof descriptor === "object" &&
        "token" in descriptor &&
        "multiple" in descriptor);
}
function isTransformDescriptor(descriptor) {
    return (typeof descriptor === "object" &&
        "token" in descriptor &&
        "transform" in descriptor);
}
function isConstructorToken(token) {
    return typeof token === "function" || token instanceof DelayedConstructor;
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/providers/token-provider.js
function isTokenProvider(provider) {
    return !!provider.useToken;
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/providers/value-provider.js
function isValueProvider(provider) {
    return provider.useValue != undefined;
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/providers/index.js






;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/providers/provider.js




function isProvider(provider) {
    return (isClassProvider(provider) ||
        isValueProvider(provider) ||
        isTokenProvider(provider) ||
        isFactoryProvider(provider));
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/registry-base.js
var RegistryBase = (function () {
    function RegistryBase() {
        this._registryMap = new Map();
    }
    RegistryBase.prototype.entries = function () {
        return this._registryMap.entries();
    };
    RegistryBase.prototype.getAll = function (key) {
        this.ensure(key);
        return this._registryMap.get(key);
    };
    RegistryBase.prototype.get = function (key) {
        this.ensure(key);
        var value = this._registryMap.get(key);
        return value[value.length - 1] || null;
    };
    RegistryBase.prototype.set = function (key, value) {
        this.ensure(key);
        this._registryMap.get(key).push(value);
    };
    RegistryBase.prototype.setAll = function (key, value) {
        this._registryMap.set(key, value);
    };
    RegistryBase.prototype.has = function (key) {
        this.ensure(key);
        return this._registryMap.get(key).length > 0;
    };
    RegistryBase.prototype.clear = function () {
        this._registryMap.clear();
    };
    RegistryBase.prototype.ensure = function (key) {
        if (!this._registryMap.has(key)) {
            this._registryMap.set(key, []);
        }
    };
    return RegistryBase;
}());
/* harmony default export */ const registry_base = (RegistryBase);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/registry.js


var Registry = (function (_super) {
    __extends(Registry, _super);
    function Registry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Registry;
}(registry_base));
/* harmony default export */ const registry = (Registry);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/resolution-context.js
var ResolutionContext = (function () {
    function ResolutionContext() {
        this.scopedResolutions = new Map();
    }
    return ResolutionContext;
}());
/* harmony default export */ const resolution_context = (ResolutionContext);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/error-helpers.js

function formatDependency(params, idx) {
    if (params === null) {
        return "at position #" + idx;
    }
    var argName = params.split(",")[idx].trim();
    return "\"" + argName + "\" at position #" + idx;
}
function composeErrorMessage(msg, e, indent) {
    if (indent === void 0) { indent = "    "; }
    return __spread([msg], e.message.split("\n").map(function (l) { return indent + l; })).join("\n");
}
function formatErrorCtor(ctor, paramIdx, error) {
    var _a = __read(ctor.toString().match(/constructor\(([\w, ]+)\)/) || [], 2), _b = _a[1], params = _b === void 0 ? null : _b;
    var dep = formatDependency(params, paramIdx);
    return composeErrorMessage("Cannot inject the dependency " + dep + " of \"" + ctor.name + "\" constructor. Reason:", error);
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/types/disposable.js
function isDisposable(value) {
    if (typeof value.dispose !== "function")
        return false;
    var disposeFun = value.dispose;
    if (disposeFun.length > 0) {
        return false;
    }
    return true;
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/interceptors.js


var PreResolutionInterceptors = (function (_super) {
    __extends(PreResolutionInterceptors, _super);
    function PreResolutionInterceptors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PreResolutionInterceptors;
}(registry_base));

var PostResolutionInterceptors = (function (_super) {
    __extends(PostResolutionInterceptors, _super);
    function PostResolutionInterceptors() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PostResolutionInterceptors;
}(registry_base));

var Interceptors = (function () {
    function Interceptors() {
        this.preResolution = new PreResolutionInterceptors();
        this.postResolution = new PostResolutionInterceptors();
    }
    return Interceptors;
}());
/* harmony default export */ const interceptors = (Interceptors);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/dependency-container.js











var typeInfo = new Map();
var InternalDependencyContainer = (function () {
    function InternalDependencyContainer(parent) {
        this.parent = parent;
        this._registry = new registry();
        this.interceptors = new interceptors();
        this.disposed = false;
        this.disposables = new Set();
    }
    InternalDependencyContainer.prototype.register = function (token, providerOrConstructor, options) {
        if (options === void 0) { options = { lifecycle: lifecycle.Transient }; }
        this.ensureNotDisposed();
        var provider;
        if (!isProvider(providerOrConstructor)) {
            provider = { useClass: providerOrConstructor };
        }
        else {
            provider = providerOrConstructor;
        }
        if (isTokenProvider(provider)) {
            var path = [token];
            var tokenProvider = provider;
            while (tokenProvider != null) {
                var currentToken = tokenProvider.useToken;
                if (path.includes(currentToken)) {
                    throw new Error("Token registration cycle detected! " + __spread(path, [currentToken]).join(" -> "));
                }
                path.push(currentToken);
                var registration = this._registry.get(currentToken);
                if (registration && isTokenProvider(registration.provider)) {
                    tokenProvider = registration.provider;
                }
                else {
                    tokenProvider = null;
                }
            }
        }
        if (options.lifecycle === lifecycle.Singleton ||
            options.lifecycle == lifecycle.ContainerScoped ||
            options.lifecycle == lifecycle.ResolutionScoped) {
            if (isValueProvider(provider) || isFactoryProvider(provider)) {
                throw new Error("Cannot use lifecycle \"" + lifecycle[options.lifecycle] + "\" with ValueProviders or FactoryProviders");
            }
        }
        this._registry.set(token, { provider: provider, options: options });
        return this;
    };
    InternalDependencyContainer.prototype.registerType = function (from, to) {
        this.ensureNotDisposed();
        if (isNormalToken(to)) {
            return this.register(from, {
                useToken: to
            });
        }
        return this.register(from, {
            useClass: to
        });
    };
    InternalDependencyContainer.prototype.registerInstance = function (token, instance) {
        this.ensureNotDisposed();
        return this.register(token, {
            useValue: instance
        });
    };
    InternalDependencyContainer.prototype.registerSingleton = function (from, to) {
        this.ensureNotDisposed();
        if (isNormalToken(from)) {
            if (isNormalToken(to)) {
                return this.register(from, {
                    useToken: to
                }, { lifecycle: lifecycle.Singleton });
            }
            else if (to) {
                return this.register(from, {
                    useClass: to
                }, { lifecycle: lifecycle.Singleton });
            }
            throw new Error('Cannot register a type name as a singleton without a "to" token');
        }
        var useClass = from;
        if (to && !isNormalToken(to)) {
            useClass = to;
        }
        return this.register(from, {
            useClass: useClass
        }, { lifecycle: lifecycle.Singleton });
    };
    InternalDependencyContainer.prototype.resolve = function (token, context) {
        if (context === void 0) { context = new resolution_context(); }
        this.ensureNotDisposed();
        var registration = this.getRegistration(token);
        if (!registration && isNormalToken(token)) {
            throw new Error("Attempted to resolve unregistered dependency token: \"" + token.toString() + "\"");
        }
        this.executePreResolutionInterceptor(token, "Single");
        if (registration) {
            var result = this.resolveRegistration(registration, context);
            this.executePostResolutionInterceptor(token, result, "Single");
            return result;
        }
        if (isConstructorToken(token)) {
            var result = this.construct(token, context);
            this.executePostResolutionInterceptor(token, result, "Single");
            return result;
        }
        throw new Error("Attempted to construct an undefined constructor. Could mean a circular dependency problem. Try using `delay` function.");
    };
    InternalDependencyContainer.prototype.executePreResolutionInterceptor = function (token, resolutionType) {
        var e_1, _a;
        if (this.interceptors.preResolution.has(token)) {
            var remainingInterceptors = [];
            try {
                for (var _b = __values(this.interceptors.preResolution.getAll(token)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var interceptor = _c.value;
                    if (interceptor.options.frequency != "Once") {
                        remainingInterceptors.push(interceptor);
                    }
                    interceptor.callback(token, resolutionType);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.interceptors.preResolution.setAll(token, remainingInterceptors);
        }
    };
    InternalDependencyContainer.prototype.executePostResolutionInterceptor = function (token, result, resolutionType) {
        var e_2, _a;
        if (this.interceptors.postResolution.has(token)) {
            var remainingInterceptors = [];
            try {
                for (var _b = __values(this.interceptors.postResolution.getAll(token)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var interceptor = _c.value;
                    if (interceptor.options.frequency != "Once") {
                        remainingInterceptors.push(interceptor);
                    }
                    interceptor.callback(token, result, resolutionType);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            this.interceptors.postResolution.setAll(token, remainingInterceptors);
        }
    };
    InternalDependencyContainer.prototype.resolveRegistration = function (registration, context) {
        this.ensureNotDisposed();
        if (registration.options.lifecycle === lifecycle.ResolutionScoped &&
            context.scopedResolutions.has(registration)) {
            return context.scopedResolutions.get(registration);
        }
        var isSingleton = registration.options.lifecycle === lifecycle.Singleton;
        var isContainerScoped = registration.options.lifecycle === lifecycle.ContainerScoped;
        var returnInstance = isSingleton || isContainerScoped;
        var resolved;
        if (isValueProvider(registration.provider)) {
            resolved = registration.provider.useValue;
        }
        else if (isTokenProvider(registration.provider)) {
            resolved = returnInstance
                ? registration.instance ||
                    (registration.instance = this.resolve(registration.provider.useToken, context))
                : this.resolve(registration.provider.useToken, context);
        }
        else if (isClassProvider(registration.provider)) {
            resolved = returnInstance
                ? registration.instance ||
                    (registration.instance = this.construct(registration.provider.useClass, context))
                : this.construct(registration.provider.useClass, context);
        }
        else if (isFactoryProvider(registration.provider)) {
            resolved = registration.provider.useFactory(this);
        }
        else {
            resolved = this.construct(registration.provider, context);
        }
        if (registration.options.lifecycle === lifecycle.ResolutionScoped) {
            context.scopedResolutions.set(registration, resolved);
        }
        return resolved;
    };
    InternalDependencyContainer.prototype.resolveAll = function (token, context) {
        var _this = this;
        if (context === void 0) { context = new resolution_context(); }
        this.ensureNotDisposed();
        var registrations = this.getAllRegistrations(token);
        if (!registrations && isNormalToken(token)) {
            throw new Error("Attempted to resolve unregistered dependency token: \"" + token.toString() + "\"");
        }
        this.executePreResolutionInterceptor(token, "All");
        if (registrations) {
            var result_1 = registrations.map(function (item) {
                return _this.resolveRegistration(item, context);
            });
            this.executePostResolutionInterceptor(token, result_1, "All");
            return result_1;
        }
        var result = [this.construct(token, context)];
        this.executePostResolutionInterceptor(token, result, "All");
        return result;
    };
    InternalDependencyContainer.prototype.isRegistered = function (token, recursive) {
        if (recursive === void 0) { recursive = false; }
        this.ensureNotDisposed();
        return (this._registry.has(token) ||
            (recursive &&
                (this.parent || false) &&
                this.parent.isRegistered(token, true)));
    };
    InternalDependencyContainer.prototype.reset = function () {
        this.ensureNotDisposed();
        this._registry.clear();
        this.interceptors.preResolution.clear();
        this.interceptors.postResolution.clear();
    };
    InternalDependencyContainer.prototype.clearInstances = function () {
        var e_3, _a;
        this.ensureNotDisposed();
        try {
            for (var _b = __values(this._registry.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), token = _d[0], registrations = _d[1];
                this._registry.setAll(token, registrations
                    .filter(function (registration) { return !isValueProvider(registration.provider); })
                    .map(function (registration) {
                    registration.instance = undefined;
                    return registration;
                }));
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    InternalDependencyContainer.prototype.createChildContainer = function () {
        var e_4, _a;
        this.ensureNotDisposed();
        var childContainer = new InternalDependencyContainer(this);
        try {
            for (var _b = __values(this._registry.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), token = _d[0], registrations = _d[1];
                if (registrations.some(function (_a) {
                    var options = _a.options;
                    return options.lifecycle === lifecycle.ContainerScoped;
                })) {
                    childContainer._registry.setAll(token, registrations.map(function (registration) {
                        if (registration.options.lifecycle === lifecycle.ContainerScoped) {
                            return {
                                provider: registration.provider,
                                options: registration.options
                            };
                        }
                        return registration;
                    }));
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return childContainer;
    };
    InternalDependencyContainer.prototype.beforeResolution = function (token, callback, options) {
        if (options === void 0) { options = { frequency: "Always" }; }
        this.interceptors.preResolution.set(token, {
            callback: callback,
            options: options
        });
    };
    InternalDependencyContainer.prototype.afterResolution = function (token, callback, options) {
        if (options === void 0) { options = { frequency: "Always" }; }
        this.interceptors.postResolution.set(token, {
            callback: callback,
            options: options
        });
    };
    InternalDependencyContainer.prototype.dispose = function () {
        return __awaiter(this, void 0, void 0, function () {
            var promises;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.disposed = true;
                        promises = [];
                        this.disposables.forEach(function (disposable) {
                            var maybePromise = disposable.dispose();
                            if (maybePromise) {
                                promises.push(maybePromise);
                            }
                        });
                        return [4, Promise.all(promises)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    InternalDependencyContainer.prototype.getRegistration = function (token) {
        if (this.isRegistered(token)) {
            return this._registry.get(token);
        }
        if (this.parent) {
            return this.parent.getRegistration(token);
        }
        return null;
    };
    InternalDependencyContainer.prototype.getAllRegistrations = function (token) {
        if (this.isRegistered(token)) {
            return this._registry.getAll(token);
        }
        if (this.parent) {
            return this.parent.getAllRegistrations(token);
        }
        return null;
    };
    InternalDependencyContainer.prototype.construct = function (ctor, context) {
        var _this = this;
        if (ctor instanceof DelayedConstructor) {
            return ctor.createProxy(function (target) {
                return _this.resolve(target, context);
            });
        }
        var instance = (function () {
            var paramInfo = typeInfo.get(ctor);
            if (!paramInfo || paramInfo.length === 0) {
                if (ctor.length === 0) {
                    return new ctor();
                }
                else {
                    throw new Error("TypeInfo not known for \"" + ctor.name + "\"");
                }
            }
            var params = paramInfo.map(_this.resolveParams(context, ctor));
            return new (ctor.bind.apply(ctor, __spread([void 0], params)))();
        })();
        if (isDisposable(instance)) {
            this.disposables.add(instance);
        }
        return instance;
    };
    InternalDependencyContainer.prototype.resolveParams = function (context, ctor) {
        var _this = this;
        return function (param, idx) {
            var _a, _b, _c;
            try {
                if (isTokenDescriptor(param)) {
                    if (isTransformDescriptor(param)) {
                        return param.multiple
                            ? (_a = _this.resolve(param.transform)).transform.apply(_a, __spread([_this.resolveAll(param.token)], param.transformArgs)) : (_b = _this.resolve(param.transform)).transform.apply(_b, __spread([_this.resolve(param.token, context)], param.transformArgs));
                    }
                    else {
                        return param.multiple
                            ? _this.resolveAll(param.token)
                            : _this.resolve(param.token, context);
                    }
                }
                else if (isTransformDescriptor(param)) {
                    return (_c = _this.resolve(param.transform, context)).transform.apply(_c, __spread([_this.resolve(param.token, context)], param.transformArgs));
                }
                return _this.resolve(param, context);
            }
            catch (e) {
                throw new Error(formatErrorCtor(ctor, idx, e));
            }
        };
    };
    InternalDependencyContainer.prototype.ensureNotDisposed = function () {
        if (this.disposed) {
            throw new Error("This container has been disposed, you cannot interact with a disposed container");
        }
    };
    return InternalDependencyContainer;
}());
var instance = new InternalDependencyContainer();
/* harmony default export */ const dependency_container = ((/* unused pure expression or super */ null && (instance)));

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/decorators/auto-injectable.js





function autoInjectable() {
    return function (target) {
        var paramInfo = getParamInfo(target);
        return (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return _super.apply(this, __spread(args.concat(paramInfo.slice(args.length).map(function (type, index) {
                    var _a, _b, _c;
                    try {
                        if (isTokenDescriptor(type)) {
                            if (isTransformDescriptor(type)) {
                                return type.multiple
                                    ? (_a = instance.resolve(type.transform)).transform.apply(_a, __spread([instance.resolveAll(type.token)], type.transformArgs)) : (_b = instance.resolve(type.transform)).transform.apply(_b, __spread([instance.resolve(type.token)], type.transformArgs));
                            }
                            else {
                                return type.multiple
                                    ? instance.resolveAll(type.token)
                                    : instance.resolve(type.token);
                            }
                        }
                        else if (isTransformDescriptor(type)) {
                            return (_c = instance.resolve(type.transform)).transform.apply(_c, __spread([instance.resolve(type.token)], type.transformArgs));
                        }
                        return instance.resolve(type);
                    }
                    catch (e) {
                        var argIndex = index + args.length;
                        throw new Error(formatErrorCtor(target, argIndex, e));
                    }
                })))) || this;
            }
            return class_1;
        }(target));
    };
}
/* harmony default export */ const auto_injectable = (autoInjectable);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/decorators/inject.js

function inject(token) {
    return defineInjectionTokenMetadata(token);
}
/* harmony default export */ const decorators_inject = (inject);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/decorators/injectable.js


function injectable() {
    return function (target) {
        typeInfo.set(target, getParamInfo(target));
    };
}
/* harmony default export */ const decorators_injectable = (injectable);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/decorators/registry.js


function registry_registry(registrations) {
    if (registrations === void 0) { registrations = []; }
    return function (target) {
        registrations.forEach(function (_a) {
            var token = _a.token, options = _a.options, provider = __rest(_a, ["token", "options"]);
            return instance.register(token, provider, options);
        });
        return target;
    };
}
/* harmony default export */ const decorators_registry = (registry_registry);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/decorators/singleton.js


function singleton() {
    return function (target) {
        decorators_injectable()(target);
        instance.registerSingleton(target);
    };
}
/* harmony default export */ const decorators_singleton = (singleton);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/decorators/inject-all.js

function injectAll(token) {
    var data = { token: token, multiple: true };
    return defineInjectionTokenMetadata(data);
}
/* harmony default export */ const inject_all = (injectAll);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/decorators/inject-all-with-transform.js

function injectAllWithTransform(token, transformer) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var data = {
        token: token,
        multiple: true,
        transform: transformer,
        transformArgs: args
    };
    return defineInjectionTokenMetadata(data);
}
/* harmony default export */ const inject_all_with_transform = (injectAllWithTransform);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/decorators/inject-with-transform.js

function injectWithTransform(token, transformer) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return defineInjectionTokenMetadata(token, {
        transformToken: transformer,
        args: args
    });
}
/* harmony default export */ const inject_with_transform = (injectWithTransform);

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/decorators/scoped.js


function scoped(lifecycle, token) {
    return function (target) {
        decorators_injectable()(target);
        instance.register(token || target, target, {
            lifecycle: lifecycle
        });
    };
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/decorators/index.js










;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/factories/instance-caching-factory.js
function instanceCachingFactory(factoryFunc) {
    var instance;
    return function (dependencyContainer) {
        if (instance == undefined) {
            instance = factoryFunc(dependencyContainer);
        }
        return instance;
    };
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/factories/instance-per-container-caching-factory.js
function instancePerContainerCachingFactory(factoryFunc) {
    var cache = new WeakMap();
    return function (dependencyContainer) {
        var instance = cache.get(dependencyContainer);
        if (instance == undefined) {
            instance = factoryFunc(dependencyContainer);
            cache.set(dependencyContainer, instance);
        }
        return instance;
    };
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/factories/predicate-aware-class-factory.js
function predicateAwareClassFactory(predicate, trueConstructor, falseConstructor, useCaching) {
    if (useCaching === void 0) { useCaching = true; }
    var instance;
    var previousPredicate;
    return function (dependencyContainer) {
        var currentPredicate = predicate(dependencyContainer);
        if (!useCaching || previousPredicate !== currentPredicate) {
            if ((previousPredicate = currentPredicate)) {
                instance = dependencyContainer.resolve(trueConstructor);
            }
            else {
                instance = dependencyContainer.resolve(falseConstructor);
            }
        }
        return instance;
    };
}

;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/factories/index.js




;// CONCATENATED MODULE: ../../node_modules/tsyringe/dist/esm5/index.js
if (typeof Reflect === "undefined" || !Reflect.getMetadata) {
    throw new Error("tsyringe requires a reflect polyfill. Please add 'import \"reflect-metadata\"' to the top of your entry point.");
}








/***/ }),

/***/ "../../node_modules/tweetnacl/nacl-fast.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

(function(nacl) {
'use strict';

// Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
// Public domain.
//
// Implementation derived from TweetNaCl version 20140427.
// See for details: http://tweetnacl.cr.yp.to/

var gf = function(init) {
  var i, r = new Float64Array(16);
  if (init) for (i = 0; i < init.length; i++) r[i] = init[i];
  return r;
};

//  Pluggable, initialized in high-level API below.
var randombytes = function(/* x, n */) { throw new Error('no PRNG'); };

var _0 = new Uint8Array(16);
var _9 = new Uint8Array(32); _9[0] = 9;

var gf0 = gf(),
    gf1 = gf([1]),
    _121665 = gf([0xdb41, 1]),
    D = gf([0x78a3, 0x1359, 0x4dca, 0x75eb, 0xd8ab, 0x4141, 0x0a4d, 0x0070, 0xe898, 0x7779, 0x4079, 0x8cc7, 0xfe73, 0x2b6f, 0x6cee, 0x5203]),
    D2 = gf([0xf159, 0x26b2, 0x9b94, 0xebd6, 0xb156, 0x8283, 0x149a, 0x00e0, 0xd130, 0xeef3, 0x80f2, 0x198e, 0xfce7, 0x56df, 0xd9dc, 0x2406]),
    X = gf([0xd51a, 0x8f25, 0x2d60, 0xc956, 0xa7b2, 0x9525, 0xc760, 0x692c, 0xdc5c, 0xfdd6, 0xe231, 0xc0a4, 0x53fe, 0xcd6e, 0x36d3, 0x2169]),
    Y = gf([0x6658, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666]),
    I = gf([0xa0b0, 0x4a0e, 0x1b27, 0xc4ee, 0xe478, 0xad2f, 0x1806, 0x2f43, 0xd7a7, 0x3dfb, 0x0099, 0x2b4d, 0xdf0b, 0x4fc1, 0x2480, 0x2b83]);

function ts64(x, i, h, l) {
  x[i]   = (h >> 24) & 0xff;
  x[i+1] = (h >> 16) & 0xff;
  x[i+2] = (h >>  8) & 0xff;
  x[i+3] = h & 0xff;
  x[i+4] = (l >> 24)  & 0xff;
  x[i+5] = (l >> 16)  & 0xff;
  x[i+6] = (l >>  8)  & 0xff;
  x[i+7] = l & 0xff;
}

function vn(x, xi, y, yi, n) {
  var i,d = 0;
  for (i = 0; i < n; i++) d |= x[xi+i]^y[yi+i];
  return (1 & ((d - 1) >>> 8)) - 1;
}

function crypto_verify_16(x, xi, y, yi) {
  return vn(x,xi,y,yi,16);
}

function crypto_verify_32(x, xi, y, yi) {
  return vn(x,xi,y,yi,32);
}

function core_salsa20(o, p, k, c) {
  var j0  = c[ 0] & 0xff | (c[ 1] & 0xff)<<8 | (c[ 2] & 0xff)<<16 | (c[ 3] & 0xff)<<24,
      j1  = k[ 0] & 0xff | (k[ 1] & 0xff)<<8 | (k[ 2] & 0xff)<<16 | (k[ 3] & 0xff)<<24,
      j2  = k[ 4] & 0xff | (k[ 5] & 0xff)<<8 | (k[ 6] & 0xff)<<16 | (k[ 7] & 0xff)<<24,
      j3  = k[ 8] & 0xff | (k[ 9] & 0xff)<<8 | (k[10] & 0xff)<<16 | (k[11] & 0xff)<<24,
      j4  = k[12] & 0xff | (k[13] & 0xff)<<8 | (k[14] & 0xff)<<16 | (k[15] & 0xff)<<24,
      j5  = c[ 4] & 0xff | (c[ 5] & 0xff)<<8 | (c[ 6] & 0xff)<<16 | (c[ 7] & 0xff)<<24,
      j6  = p[ 0] & 0xff | (p[ 1] & 0xff)<<8 | (p[ 2] & 0xff)<<16 | (p[ 3] & 0xff)<<24,
      j7  = p[ 4] & 0xff | (p[ 5] & 0xff)<<8 | (p[ 6] & 0xff)<<16 | (p[ 7] & 0xff)<<24,
      j8  = p[ 8] & 0xff | (p[ 9] & 0xff)<<8 | (p[10] & 0xff)<<16 | (p[11] & 0xff)<<24,
      j9  = p[12] & 0xff | (p[13] & 0xff)<<8 | (p[14] & 0xff)<<16 | (p[15] & 0xff)<<24,
      j10 = c[ 8] & 0xff | (c[ 9] & 0xff)<<8 | (c[10] & 0xff)<<16 | (c[11] & 0xff)<<24,
      j11 = k[16] & 0xff | (k[17] & 0xff)<<8 | (k[18] & 0xff)<<16 | (k[19] & 0xff)<<24,
      j12 = k[20] & 0xff | (k[21] & 0xff)<<8 | (k[22] & 0xff)<<16 | (k[23] & 0xff)<<24,
      j13 = k[24] & 0xff | (k[25] & 0xff)<<8 | (k[26] & 0xff)<<16 | (k[27] & 0xff)<<24,
      j14 = k[28] & 0xff | (k[29] & 0xff)<<8 | (k[30] & 0xff)<<16 | (k[31] & 0xff)<<24,
      j15 = c[12] & 0xff | (c[13] & 0xff)<<8 | (c[14] & 0xff)<<16 | (c[15] & 0xff)<<24;

  var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7,
      x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14,
      x15 = j15, u;

  for (var i = 0; i < 20; i += 2) {
    u = x0 + x12 | 0;
    x4 ^= u<<7 | u>>>(32-7);
    u = x4 + x0 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x4 | 0;
    x12 ^= u<<13 | u>>>(32-13);
    u = x12 + x8 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x1 | 0;
    x9 ^= u<<7 | u>>>(32-7);
    u = x9 + x5 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x9 | 0;
    x1 ^= u<<13 | u>>>(32-13);
    u = x1 + x13 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x6 | 0;
    x14 ^= u<<7 | u>>>(32-7);
    u = x14 + x10 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x14 | 0;
    x6 ^= u<<13 | u>>>(32-13);
    u = x6 + x2 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x11 | 0;
    x3 ^= u<<7 | u>>>(32-7);
    u = x3 + x15 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x3 | 0;
    x11 ^= u<<13 | u>>>(32-13);
    u = x11 + x7 | 0;
    x15 ^= u<<18 | u>>>(32-18);

    u = x0 + x3 | 0;
    x1 ^= u<<7 | u>>>(32-7);
    u = x1 + x0 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x1 | 0;
    x3 ^= u<<13 | u>>>(32-13);
    u = x3 + x2 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x4 | 0;
    x6 ^= u<<7 | u>>>(32-7);
    u = x6 + x5 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x6 | 0;
    x4 ^= u<<13 | u>>>(32-13);
    u = x4 + x7 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x9 | 0;
    x11 ^= u<<7 | u>>>(32-7);
    u = x11 + x10 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x11 | 0;
    x9 ^= u<<13 | u>>>(32-13);
    u = x9 + x8 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x14 | 0;
    x12 ^= u<<7 | u>>>(32-7);
    u = x12 + x15 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x12 | 0;
    x14 ^= u<<13 | u>>>(32-13);
    u = x14 + x13 | 0;
    x15 ^= u<<18 | u>>>(32-18);
  }
   x0 =  x0 +  j0 | 0;
   x1 =  x1 +  j1 | 0;
   x2 =  x2 +  j2 | 0;
   x3 =  x3 +  j3 | 0;
   x4 =  x4 +  j4 | 0;
   x5 =  x5 +  j5 | 0;
   x6 =  x6 +  j6 | 0;
   x7 =  x7 +  j7 | 0;
   x8 =  x8 +  j8 | 0;
   x9 =  x9 +  j9 | 0;
  x10 = x10 + j10 | 0;
  x11 = x11 + j11 | 0;
  x12 = x12 + j12 | 0;
  x13 = x13 + j13 | 0;
  x14 = x14 + j14 | 0;
  x15 = x15 + j15 | 0;

  o[ 0] = x0 >>>  0 & 0xff;
  o[ 1] = x0 >>>  8 & 0xff;
  o[ 2] = x0 >>> 16 & 0xff;
  o[ 3] = x0 >>> 24 & 0xff;

  o[ 4] = x1 >>>  0 & 0xff;
  o[ 5] = x1 >>>  8 & 0xff;
  o[ 6] = x1 >>> 16 & 0xff;
  o[ 7] = x1 >>> 24 & 0xff;

  o[ 8] = x2 >>>  0 & 0xff;
  o[ 9] = x2 >>>  8 & 0xff;
  o[10] = x2 >>> 16 & 0xff;
  o[11] = x2 >>> 24 & 0xff;

  o[12] = x3 >>>  0 & 0xff;
  o[13] = x3 >>>  8 & 0xff;
  o[14] = x3 >>> 16 & 0xff;
  o[15] = x3 >>> 24 & 0xff;

  o[16] = x4 >>>  0 & 0xff;
  o[17] = x4 >>>  8 & 0xff;
  o[18] = x4 >>> 16 & 0xff;
  o[19] = x4 >>> 24 & 0xff;

  o[20] = x5 >>>  0 & 0xff;
  o[21] = x5 >>>  8 & 0xff;
  o[22] = x5 >>> 16 & 0xff;
  o[23] = x5 >>> 24 & 0xff;

  o[24] = x6 >>>  0 & 0xff;
  o[25] = x6 >>>  8 & 0xff;
  o[26] = x6 >>> 16 & 0xff;
  o[27] = x6 >>> 24 & 0xff;

  o[28] = x7 >>>  0 & 0xff;
  o[29] = x7 >>>  8 & 0xff;
  o[30] = x7 >>> 16 & 0xff;
  o[31] = x7 >>> 24 & 0xff;

  o[32] = x8 >>>  0 & 0xff;
  o[33] = x8 >>>  8 & 0xff;
  o[34] = x8 >>> 16 & 0xff;
  o[35] = x8 >>> 24 & 0xff;

  o[36] = x9 >>>  0 & 0xff;
  o[37] = x9 >>>  8 & 0xff;
  o[38] = x9 >>> 16 & 0xff;
  o[39] = x9 >>> 24 & 0xff;

  o[40] = x10 >>>  0 & 0xff;
  o[41] = x10 >>>  8 & 0xff;
  o[42] = x10 >>> 16 & 0xff;
  o[43] = x10 >>> 24 & 0xff;

  o[44] = x11 >>>  0 & 0xff;
  o[45] = x11 >>>  8 & 0xff;
  o[46] = x11 >>> 16 & 0xff;
  o[47] = x11 >>> 24 & 0xff;

  o[48] = x12 >>>  0 & 0xff;
  o[49] = x12 >>>  8 & 0xff;
  o[50] = x12 >>> 16 & 0xff;
  o[51] = x12 >>> 24 & 0xff;

  o[52] = x13 >>>  0 & 0xff;
  o[53] = x13 >>>  8 & 0xff;
  o[54] = x13 >>> 16 & 0xff;
  o[55] = x13 >>> 24 & 0xff;

  o[56] = x14 >>>  0 & 0xff;
  o[57] = x14 >>>  8 & 0xff;
  o[58] = x14 >>> 16 & 0xff;
  o[59] = x14 >>> 24 & 0xff;

  o[60] = x15 >>>  0 & 0xff;
  o[61] = x15 >>>  8 & 0xff;
  o[62] = x15 >>> 16 & 0xff;
  o[63] = x15 >>> 24 & 0xff;
}

function core_hsalsa20(o,p,k,c) {
  var j0  = c[ 0] & 0xff | (c[ 1] & 0xff)<<8 | (c[ 2] & 0xff)<<16 | (c[ 3] & 0xff)<<24,
      j1  = k[ 0] & 0xff | (k[ 1] & 0xff)<<8 | (k[ 2] & 0xff)<<16 | (k[ 3] & 0xff)<<24,
      j2  = k[ 4] & 0xff | (k[ 5] & 0xff)<<8 | (k[ 6] & 0xff)<<16 | (k[ 7] & 0xff)<<24,
      j3  = k[ 8] & 0xff | (k[ 9] & 0xff)<<8 | (k[10] & 0xff)<<16 | (k[11] & 0xff)<<24,
      j4  = k[12] & 0xff | (k[13] & 0xff)<<8 | (k[14] & 0xff)<<16 | (k[15] & 0xff)<<24,
      j5  = c[ 4] & 0xff | (c[ 5] & 0xff)<<8 | (c[ 6] & 0xff)<<16 | (c[ 7] & 0xff)<<24,
      j6  = p[ 0] & 0xff | (p[ 1] & 0xff)<<8 | (p[ 2] & 0xff)<<16 | (p[ 3] & 0xff)<<24,
      j7  = p[ 4] & 0xff | (p[ 5] & 0xff)<<8 | (p[ 6] & 0xff)<<16 | (p[ 7] & 0xff)<<24,
      j8  = p[ 8] & 0xff | (p[ 9] & 0xff)<<8 | (p[10] & 0xff)<<16 | (p[11] & 0xff)<<24,
      j9  = p[12] & 0xff | (p[13] & 0xff)<<8 | (p[14] & 0xff)<<16 | (p[15] & 0xff)<<24,
      j10 = c[ 8] & 0xff | (c[ 9] & 0xff)<<8 | (c[10] & 0xff)<<16 | (c[11] & 0xff)<<24,
      j11 = k[16] & 0xff | (k[17] & 0xff)<<8 | (k[18] & 0xff)<<16 | (k[19] & 0xff)<<24,
      j12 = k[20] & 0xff | (k[21] & 0xff)<<8 | (k[22] & 0xff)<<16 | (k[23] & 0xff)<<24,
      j13 = k[24] & 0xff | (k[25] & 0xff)<<8 | (k[26] & 0xff)<<16 | (k[27] & 0xff)<<24,
      j14 = k[28] & 0xff | (k[29] & 0xff)<<8 | (k[30] & 0xff)<<16 | (k[31] & 0xff)<<24,
      j15 = c[12] & 0xff | (c[13] & 0xff)<<8 | (c[14] & 0xff)<<16 | (c[15] & 0xff)<<24;

  var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7,
      x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14,
      x15 = j15, u;

  for (var i = 0; i < 20; i += 2) {
    u = x0 + x12 | 0;
    x4 ^= u<<7 | u>>>(32-7);
    u = x4 + x0 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x4 | 0;
    x12 ^= u<<13 | u>>>(32-13);
    u = x12 + x8 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x1 | 0;
    x9 ^= u<<7 | u>>>(32-7);
    u = x9 + x5 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x9 | 0;
    x1 ^= u<<13 | u>>>(32-13);
    u = x1 + x13 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x6 | 0;
    x14 ^= u<<7 | u>>>(32-7);
    u = x14 + x10 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x14 | 0;
    x6 ^= u<<13 | u>>>(32-13);
    u = x6 + x2 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x11 | 0;
    x3 ^= u<<7 | u>>>(32-7);
    u = x3 + x15 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x3 | 0;
    x11 ^= u<<13 | u>>>(32-13);
    u = x11 + x7 | 0;
    x15 ^= u<<18 | u>>>(32-18);

    u = x0 + x3 | 0;
    x1 ^= u<<7 | u>>>(32-7);
    u = x1 + x0 | 0;
    x2 ^= u<<9 | u>>>(32-9);
    u = x2 + x1 | 0;
    x3 ^= u<<13 | u>>>(32-13);
    u = x3 + x2 | 0;
    x0 ^= u<<18 | u>>>(32-18);

    u = x5 + x4 | 0;
    x6 ^= u<<7 | u>>>(32-7);
    u = x6 + x5 | 0;
    x7 ^= u<<9 | u>>>(32-9);
    u = x7 + x6 | 0;
    x4 ^= u<<13 | u>>>(32-13);
    u = x4 + x7 | 0;
    x5 ^= u<<18 | u>>>(32-18);

    u = x10 + x9 | 0;
    x11 ^= u<<7 | u>>>(32-7);
    u = x11 + x10 | 0;
    x8 ^= u<<9 | u>>>(32-9);
    u = x8 + x11 | 0;
    x9 ^= u<<13 | u>>>(32-13);
    u = x9 + x8 | 0;
    x10 ^= u<<18 | u>>>(32-18);

    u = x15 + x14 | 0;
    x12 ^= u<<7 | u>>>(32-7);
    u = x12 + x15 | 0;
    x13 ^= u<<9 | u>>>(32-9);
    u = x13 + x12 | 0;
    x14 ^= u<<13 | u>>>(32-13);
    u = x14 + x13 | 0;
    x15 ^= u<<18 | u>>>(32-18);
  }

  o[ 0] = x0 >>>  0 & 0xff;
  o[ 1] = x0 >>>  8 & 0xff;
  o[ 2] = x0 >>> 16 & 0xff;
  o[ 3] = x0 >>> 24 & 0xff;

  o[ 4] = x5 >>>  0 & 0xff;
  o[ 5] = x5 >>>  8 & 0xff;
  o[ 6] = x5 >>> 16 & 0xff;
  o[ 7] = x5 >>> 24 & 0xff;

  o[ 8] = x10 >>>  0 & 0xff;
  o[ 9] = x10 >>>  8 & 0xff;
  o[10] = x10 >>> 16 & 0xff;
  o[11] = x10 >>> 24 & 0xff;

  o[12] = x15 >>>  0 & 0xff;
  o[13] = x15 >>>  8 & 0xff;
  o[14] = x15 >>> 16 & 0xff;
  o[15] = x15 >>> 24 & 0xff;

  o[16] = x6 >>>  0 & 0xff;
  o[17] = x6 >>>  8 & 0xff;
  o[18] = x6 >>> 16 & 0xff;
  o[19] = x6 >>> 24 & 0xff;

  o[20] = x7 >>>  0 & 0xff;
  o[21] = x7 >>>  8 & 0xff;
  o[22] = x7 >>> 16 & 0xff;
  o[23] = x7 >>> 24 & 0xff;

  o[24] = x8 >>>  0 & 0xff;
  o[25] = x8 >>>  8 & 0xff;
  o[26] = x8 >>> 16 & 0xff;
  o[27] = x8 >>> 24 & 0xff;

  o[28] = x9 >>>  0 & 0xff;
  o[29] = x9 >>>  8 & 0xff;
  o[30] = x9 >>> 16 & 0xff;
  o[31] = x9 >>> 24 & 0xff;
}

function crypto_core_salsa20(out,inp,k,c) {
  core_salsa20(out,inp,k,c);
}

function crypto_core_hsalsa20(out,inp,k,c) {
  core_hsalsa20(out,inp,k,c);
}

var sigma = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
            // "expand 32-byte k"

function crypto_stream_salsa20_xor(c,cpos,m,mpos,b,n,k) {
  var z = new Uint8Array(16), x = new Uint8Array(64);
  var u, i;
  for (i = 0; i < 16; i++) z[i] = 0;
  for (i = 0; i < 8; i++) z[i] = n[i];
  while (b >= 64) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < 64; i++) c[cpos+i] = m[mpos+i] ^ x[i];
    u = 1;
    for (i = 8; i < 16; i++) {
      u = u + (z[i] & 0xff) | 0;
      z[i] = u & 0xff;
      u >>>= 8;
    }
    b -= 64;
    cpos += 64;
    mpos += 64;
  }
  if (b > 0) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < b; i++) c[cpos+i] = m[mpos+i] ^ x[i];
  }
  return 0;
}

function crypto_stream_salsa20(c,cpos,b,n,k) {
  var z = new Uint8Array(16), x = new Uint8Array(64);
  var u, i;
  for (i = 0; i < 16; i++) z[i] = 0;
  for (i = 0; i < 8; i++) z[i] = n[i];
  while (b >= 64) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < 64; i++) c[cpos+i] = x[i];
    u = 1;
    for (i = 8; i < 16; i++) {
      u = u + (z[i] & 0xff) | 0;
      z[i] = u & 0xff;
      u >>>= 8;
    }
    b -= 64;
    cpos += 64;
  }
  if (b > 0) {
    crypto_core_salsa20(x,z,k,sigma);
    for (i = 0; i < b; i++) c[cpos+i] = x[i];
  }
  return 0;
}

function crypto_stream(c,cpos,d,n,k) {
  var s = new Uint8Array(32);
  crypto_core_hsalsa20(s,n,k,sigma);
  var sn = new Uint8Array(8);
  for (var i = 0; i < 8; i++) sn[i] = n[i+16];
  return crypto_stream_salsa20(c,cpos,d,sn,s);
}

function crypto_stream_xor(c,cpos,m,mpos,d,n,k) {
  var s = new Uint8Array(32);
  crypto_core_hsalsa20(s,n,k,sigma);
  var sn = new Uint8Array(8);
  for (var i = 0; i < 8; i++) sn[i] = n[i+16];
  return crypto_stream_salsa20_xor(c,cpos,m,mpos,d,sn,s);
}

/*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/

var poly1305 = function(key) {
  this.buffer = new Uint8Array(16);
  this.r = new Uint16Array(10);
  this.h = new Uint16Array(10);
  this.pad = new Uint16Array(8);
  this.leftover = 0;
  this.fin = 0;

  var t0, t1, t2, t3, t4, t5, t6, t7;

  t0 = key[ 0] & 0xff | (key[ 1] & 0xff) << 8; this.r[0] = ( t0                     ) & 0x1fff;
  t1 = key[ 2] & 0xff | (key[ 3] & 0xff) << 8; this.r[1] = ((t0 >>> 13) | (t1 <<  3)) & 0x1fff;
  t2 = key[ 4] & 0xff | (key[ 5] & 0xff) << 8; this.r[2] = ((t1 >>> 10) | (t2 <<  6)) & 0x1f03;
  t3 = key[ 6] & 0xff | (key[ 7] & 0xff) << 8; this.r[3] = ((t2 >>>  7) | (t3 <<  9)) & 0x1fff;
  t4 = key[ 8] & 0xff | (key[ 9] & 0xff) << 8; this.r[4] = ((t3 >>>  4) | (t4 << 12)) & 0x00ff;
  this.r[5] = ((t4 >>>  1)) & 0x1ffe;
  t5 = key[10] & 0xff | (key[11] & 0xff) << 8; this.r[6] = ((t4 >>> 14) | (t5 <<  2)) & 0x1fff;
  t6 = key[12] & 0xff | (key[13] & 0xff) << 8; this.r[7] = ((t5 >>> 11) | (t6 <<  5)) & 0x1f81;
  t7 = key[14] & 0xff | (key[15] & 0xff) << 8; this.r[8] = ((t6 >>>  8) | (t7 <<  8)) & 0x1fff;
  this.r[9] = ((t7 >>>  5)) & 0x007f;

  this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
  this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
  this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
  this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
  this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
  this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
  this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
  this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
};

poly1305.prototype.blocks = function(m, mpos, bytes) {
  var hibit = this.fin ? 0 : (1 << 11);
  var t0, t1, t2, t3, t4, t5, t6, t7, c;
  var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;

  var h0 = this.h[0],
      h1 = this.h[1],
      h2 = this.h[2],
      h3 = this.h[3],
      h4 = this.h[4],
      h5 = this.h[5],
      h6 = this.h[6],
      h7 = this.h[7],
      h8 = this.h[8],
      h9 = this.h[9];

  var r0 = this.r[0],
      r1 = this.r[1],
      r2 = this.r[2],
      r3 = this.r[3],
      r4 = this.r[4],
      r5 = this.r[5],
      r6 = this.r[6],
      r7 = this.r[7],
      r8 = this.r[8],
      r9 = this.r[9];

  while (bytes >= 16) {
    t0 = m[mpos+ 0] & 0xff | (m[mpos+ 1] & 0xff) << 8; h0 += ( t0                     ) & 0x1fff;
    t1 = m[mpos+ 2] & 0xff | (m[mpos+ 3] & 0xff) << 8; h1 += ((t0 >>> 13) | (t1 <<  3)) & 0x1fff;
    t2 = m[mpos+ 4] & 0xff | (m[mpos+ 5] & 0xff) << 8; h2 += ((t1 >>> 10) | (t2 <<  6)) & 0x1fff;
    t3 = m[mpos+ 6] & 0xff | (m[mpos+ 7] & 0xff) << 8; h3 += ((t2 >>>  7) | (t3 <<  9)) & 0x1fff;
    t4 = m[mpos+ 8] & 0xff | (m[mpos+ 9] & 0xff) << 8; h4 += ((t3 >>>  4) | (t4 << 12)) & 0x1fff;
    h5 += ((t4 >>>  1)) & 0x1fff;
    t5 = m[mpos+10] & 0xff | (m[mpos+11] & 0xff) << 8; h6 += ((t4 >>> 14) | (t5 <<  2)) & 0x1fff;
    t6 = m[mpos+12] & 0xff | (m[mpos+13] & 0xff) << 8; h7 += ((t5 >>> 11) | (t6 <<  5)) & 0x1fff;
    t7 = m[mpos+14] & 0xff | (m[mpos+15] & 0xff) << 8; h8 += ((t6 >>>  8) | (t7 <<  8)) & 0x1fff;
    h9 += ((t7 >>> 5)) | hibit;

    c = 0;

    d0 = c;
    d0 += h0 * r0;
    d0 += h1 * (5 * r9);
    d0 += h2 * (5 * r8);
    d0 += h3 * (5 * r7);
    d0 += h4 * (5 * r6);
    c = (d0 >>> 13); d0 &= 0x1fff;
    d0 += h5 * (5 * r5);
    d0 += h6 * (5 * r4);
    d0 += h7 * (5 * r3);
    d0 += h8 * (5 * r2);
    d0 += h9 * (5 * r1);
    c += (d0 >>> 13); d0 &= 0x1fff;

    d1 = c;
    d1 += h0 * r1;
    d1 += h1 * r0;
    d1 += h2 * (5 * r9);
    d1 += h3 * (5 * r8);
    d1 += h4 * (5 * r7);
    c = (d1 >>> 13); d1 &= 0x1fff;
    d1 += h5 * (5 * r6);
    d1 += h6 * (5 * r5);
    d1 += h7 * (5 * r4);
    d1 += h8 * (5 * r3);
    d1 += h9 * (5 * r2);
    c += (d1 >>> 13); d1 &= 0x1fff;

    d2 = c;
    d2 += h0 * r2;
    d2 += h1 * r1;
    d2 += h2 * r0;
    d2 += h3 * (5 * r9);
    d2 += h4 * (5 * r8);
    c = (d2 >>> 13); d2 &= 0x1fff;
    d2 += h5 * (5 * r7);
    d2 += h6 * (5 * r6);
    d2 += h7 * (5 * r5);
    d2 += h8 * (5 * r4);
    d2 += h9 * (5 * r3);
    c += (d2 >>> 13); d2 &= 0x1fff;

    d3 = c;
    d3 += h0 * r3;
    d3 += h1 * r2;
    d3 += h2 * r1;
    d3 += h3 * r0;
    d3 += h4 * (5 * r9);
    c = (d3 >>> 13); d3 &= 0x1fff;
    d3 += h5 * (5 * r8);
    d3 += h6 * (5 * r7);
    d3 += h7 * (5 * r6);
    d3 += h8 * (5 * r5);
    d3 += h9 * (5 * r4);
    c += (d3 >>> 13); d3 &= 0x1fff;

    d4 = c;
    d4 += h0 * r4;
    d4 += h1 * r3;
    d4 += h2 * r2;
    d4 += h3 * r1;
    d4 += h4 * r0;
    c = (d4 >>> 13); d4 &= 0x1fff;
    d4 += h5 * (5 * r9);
    d4 += h6 * (5 * r8);
    d4 += h7 * (5 * r7);
    d4 += h8 * (5 * r6);
    d4 += h9 * (5 * r5);
    c += (d4 >>> 13); d4 &= 0x1fff;

    d5 = c;
    d5 += h0 * r5;
    d5 += h1 * r4;
    d5 += h2 * r3;
    d5 += h3 * r2;
    d5 += h4 * r1;
    c = (d5 >>> 13); d5 &= 0x1fff;
    d5 += h5 * r0;
    d5 += h6 * (5 * r9);
    d5 += h7 * (5 * r8);
    d5 += h8 * (5 * r7);
    d5 += h9 * (5 * r6);
    c += (d5 >>> 13); d5 &= 0x1fff;

    d6 = c;
    d6 += h0 * r6;
    d6 += h1 * r5;
    d6 += h2 * r4;
    d6 += h3 * r3;
    d6 += h4 * r2;
    c = (d6 >>> 13); d6 &= 0x1fff;
    d6 += h5 * r1;
    d6 += h6 * r0;
    d6 += h7 * (5 * r9);
    d6 += h8 * (5 * r8);
    d6 += h9 * (5 * r7);
    c += (d6 >>> 13); d6 &= 0x1fff;

    d7 = c;
    d7 += h0 * r7;
    d7 += h1 * r6;
    d7 += h2 * r5;
    d7 += h3 * r4;
    d7 += h4 * r3;
    c = (d7 >>> 13); d7 &= 0x1fff;
    d7 += h5 * r2;
    d7 += h6 * r1;
    d7 += h7 * r0;
    d7 += h8 * (5 * r9);
    d7 += h9 * (5 * r8);
    c += (d7 >>> 13); d7 &= 0x1fff;

    d8 = c;
    d8 += h0 * r8;
    d8 += h1 * r7;
    d8 += h2 * r6;
    d8 += h3 * r5;
    d8 += h4 * r4;
    c = (d8 >>> 13); d8 &= 0x1fff;
    d8 += h5 * r3;
    d8 += h6 * r2;
    d8 += h7 * r1;
    d8 += h8 * r0;
    d8 += h9 * (5 * r9);
    c += (d8 >>> 13); d8 &= 0x1fff;

    d9 = c;
    d9 += h0 * r9;
    d9 += h1 * r8;
    d9 += h2 * r7;
    d9 += h3 * r6;
    d9 += h4 * r5;
    c = (d9 >>> 13); d9 &= 0x1fff;
    d9 += h5 * r4;
    d9 += h6 * r3;
    d9 += h7 * r2;
    d9 += h8 * r1;
    d9 += h9 * r0;
    c += (d9 >>> 13); d9 &= 0x1fff;

    c = (((c << 2) + c)) | 0;
    c = (c + d0) | 0;
    d0 = c & 0x1fff;
    c = (c >>> 13);
    d1 += c;

    h0 = d0;
    h1 = d1;
    h2 = d2;
    h3 = d3;
    h4 = d4;
    h5 = d5;
    h6 = d6;
    h7 = d7;
    h8 = d8;
    h9 = d9;

    mpos += 16;
    bytes -= 16;
  }
  this.h[0] = h0;
  this.h[1] = h1;
  this.h[2] = h2;
  this.h[3] = h3;
  this.h[4] = h4;
  this.h[5] = h5;
  this.h[6] = h6;
  this.h[7] = h7;
  this.h[8] = h8;
  this.h[9] = h9;
};

poly1305.prototype.finish = function(mac, macpos) {
  var g = new Uint16Array(10);
  var c, mask, f, i;

  if (this.leftover) {
    i = this.leftover;
    this.buffer[i++] = 1;
    for (; i < 16; i++) this.buffer[i] = 0;
    this.fin = 1;
    this.blocks(this.buffer, 0, 16);
  }

  c = this.h[1] >>> 13;
  this.h[1] &= 0x1fff;
  for (i = 2; i < 10; i++) {
    this.h[i] += c;
    c = this.h[i] >>> 13;
    this.h[i] &= 0x1fff;
  }
  this.h[0] += (c * 5);
  c = this.h[0] >>> 13;
  this.h[0] &= 0x1fff;
  this.h[1] += c;
  c = this.h[1] >>> 13;
  this.h[1] &= 0x1fff;
  this.h[2] += c;

  g[0] = this.h[0] + 5;
  c = g[0] >>> 13;
  g[0] &= 0x1fff;
  for (i = 1; i < 10; i++) {
    g[i] = this.h[i] + c;
    c = g[i] >>> 13;
    g[i] &= 0x1fff;
  }
  g[9] -= (1 << 13);

  mask = (c ^ 1) - 1;
  for (i = 0; i < 10; i++) g[i] &= mask;
  mask = ~mask;
  for (i = 0; i < 10; i++) this.h[i] = (this.h[i] & mask) | g[i];

  this.h[0] = ((this.h[0]       ) | (this.h[1] << 13)                    ) & 0xffff;
  this.h[1] = ((this.h[1] >>>  3) | (this.h[2] << 10)                    ) & 0xffff;
  this.h[2] = ((this.h[2] >>>  6) | (this.h[3] <<  7)                    ) & 0xffff;
  this.h[3] = ((this.h[3] >>>  9) | (this.h[4] <<  4)                    ) & 0xffff;
  this.h[4] = ((this.h[4] >>> 12) | (this.h[5] <<  1) | (this.h[6] << 14)) & 0xffff;
  this.h[5] = ((this.h[6] >>>  2) | (this.h[7] << 11)                    ) & 0xffff;
  this.h[6] = ((this.h[7] >>>  5) | (this.h[8] <<  8)                    ) & 0xffff;
  this.h[7] = ((this.h[8] >>>  8) | (this.h[9] <<  5)                    ) & 0xffff;

  f = this.h[0] + this.pad[0];
  this.h[0] = f & 0xffff;
  for (i = 1; i < 8; i++) {
    f = (((this.h[i] + this.pad[i]) | 0) + (f >>> 16)) | 0;
    this.h[i] = f & 0xffff;
  }

  mac[macpos+ 0] = (this.h[0] >>> 0) & 0xff;
  mac[macpos+ 1] = (this.h[0] >>> 8) & 0xff;
  mac[macpos+ 2] = (this.h[1] >>> 0) & 0xff;
  mac[macpos+ 3] = (this.h[1] >>> 8) & 0xff;
  mac[macpos+ 4] = (this.h[2] >>> 0) & 0xff;
  mac[macpos+ 5] = (this.h[2] >>> 8) & 0xff;
  mac[macpos+ 6] = (this.h[3] >>> 0) & 0xff;
  mac[macpos+ 7] = (this.h[3] >>> 8) & 0xff;
  mac[macpos+ 8] = (this.h[4] >>> 0) & 0xff;
  mac[macpos+ 9] = (this.h[4] >>> 8) & 0xff;
  mac[macpos+10] = (this.h[5] >>> 0) & 0xff;
  mac[macpos+11] = (this.h[5] >>> 8) & 0xff;
  mac[macpos+12] = (this.h[6] >>> 0) & 0xff;
  mac[macpos+13] = (this.h[6] >>> 8) & 0xff;
  mac[macpos+14] = (this.h[7] >>> 0) & 0xff;
  mac[macpos+15] = (this.h[7] >>> 8) & 0xff;
};

poly1305.prototype.update = function(m, mpos, bytes) {
  var i, want;

  if (this.leftover) {
    want = (16 - this.leftover);
    if (want > bytes)
      want = bytes;
    for (i = 0; i < want; i++)
      this.buffer[this.leftover + i] = m[mpos+i];
    bytes -= want;
    mpos += want;
    this.leftover += want;
    if (this.leftover < 16)
      return;
    this.blocks(this.buffer, 0, 16);
    this.leftover = 0;
  }

  if (bytes >= 16) {
    want = bytes - (bytes % 16);
    this.blocks(m, mpos, want);
    mpos += want;
    bytes -= want;
  }

  if (bytes) {
    for (i = 0; i < bytes; i++)
      this.buffer[this.leftover + i] = m[mpos+i];
    this.leftover += bytes;
  }
};

function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
  var s = new poly1305(k);
  s.update(m, mpos, n);
  s.finish(out, outpos);
  return 0;
}

function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
  var x = new Uint8Array(16);
  crypto_onetimeauth(x,0,m,mpos,n,k);
  return crypto_verify_16(h,hpos,x,0);
}

function crypto_secretbox(c,m,d,n,k) {
  var i;
  if (d < 32) return -1;
  crypto_stream_xor(c,0,m,0,d,n,k);
  crypto_onetimeauth(c, 16, c, 32, d - 32, c);
  for (i = 0; i < 16; i++) c[i] = 0;
  return 0;
}

function crypto_secretbox_open(m,c,d,n,k) {
  var i;
  var x = new Uint8Array(32);
  if (d < 32) return -1;
  crypto_stream(x,0,32,n,k);
  if (crypto_onetimeauth_verify(c, 16,c, 32,d - 32,x) !== 0) return -1;
  crypto_stream_xor(m,0,c,0,d,n,k);
  for (i = 0; i < 32; i++) m[i] = 0;
  return 0;
}

function set25519(r, a) {
  var i;
  for (i = 0; i < 16; i++) r[i] = a[i]|0;
}

function car25519(o) {
  var i, v, c = 1;
  for (i = 0; i < 16; i++) {
    v = o[i] + c + 65535;
    c = Math.floor(v / 65536);
    o[i] = v - c * 65536;
  }
  o[0] += c-1 + 37 * (c-1);
}

function sel25519(p, q, b) {
  var t, c = ~(b-1);
  for (var i = 0; i < 16; i++) {
    t = c & (p[i] ^ q[i]);
    p[i] ^= t;
    q[i] ^= t;
  }
}

function pack25519(o, n) {
  var i, j, b;
  var m = gf(), t = gf();
  for (i = 0; i < 16; i++) t[i] = n[i];
  car25519(t);
  car25519(t);
  car25519(t);
  for (j = 0; j < 2; j++) {
    m[0] = t[0] - 0xffed;
    for (i = 1; i < 15; i++) {
      m[i] = t[i] - 0xffff - ((m[i-1]>>16) & 1);
      m[i-1] &= 0xffff;
    }
    m[15] = t[15] - 0x7fff - ((m[14]>>16) & 1);
    b = (m[15]>>16) & 1;
    m[14] &= 0xffff;
    sel25519(t, m, 1-b);
  }
  for (i = 0; i < 16; i++) {
    o[2*i] = t[i] & 0xff;
    o[2*i+1] = t[i]>>8;
  }
}

function neq25519(a, b) {
  var c = new Uint8Array(32), d = new Uint8Array(32);
  pack25519(c, a);
  pack25519(d, b);
  return crypto_verify_32(c, 0, d, 0);
}

function par25519(a) {
  var d = new Uint8Array(32);
  pack25519(d, a);
  return d[0] & 1;
}

function unpack25519(o, n) {
  var i;
  for (i = 0; i < 16; i++) o[i] = n[2*i] + (n[2*i+1] << 8);
  o[15] &= 0x7fff;
}

function A(o, a, b) {
  for (var i = 0; i < 16; i++) o[i] = a[i] + b[i];
}

function Z(o, a, b) {
  for (var i = 0; i < 16; i++) o[i] = a[i] - b[i];
}

function M(o, a, b) {
  var v, c,
     t0 = 0,  t1 = 0,  t2 = 0,  t3 = 0,  t4 = 0,  t5 = 0,  t6 = 0,  t7 = 0,
     t8 = 0,  t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0,
    t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0,
    t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0,
    b0 = b[0],
    b1 = b[1],
    b2 = b[2],
    b3 = b[3],
    b4 = b[4],
    b5 = b[5],
    b6 = b[6],
    b7 = b[7],
    b8 = b[8],
    b9 = b[9],
    b10 = b[10],
    b11 = b[11],
    b12 = b[12],
    b13 = b[13],
    b14 = b[14],
    b15 = b[15];

  v = a[0];
  t0 += v * b0;
  t1 += v * b1;
  t2 += v * b2;
  t3 += v * b3;
  t4 += v * b4;
  t5 += v * b5;
  t6 += v * b6;
  t7 += v * b7;
  t8 += v * b8;
  t9 += v * b9;
  t10 += v * b10;
  t11 += v * b11;
  t12 += v * b12;
  t13 += v * b13;
  t14 += v * b14;
  t15 += v * b15;
  v = a[1];
  t1 += v * b0;
  t2 += v * b1;
  t3 += v * b2;
  t4 += v * b3;
  t5 += v * b4;
  t6 += v * b5;
  t7 += v * b6;
  t8 += v * b7;
  t9 += v * b8;
  t10 += v * b9;
  t11 += v * b10;
  t12 += v * b11;
  t13 += v * b12;
  t14 += v * b13;
  t15 += v * b14;
  t16 += v * b15;
  v = a[2];
  t2 += v * b0;
  t3 += v * b1;
  t4 += v * b2;
  t5 += v * b3;
  t6 += v * b4;
  t7 += v * b5;
  t8 += v * b6;
  t9 += v * b7;
  t10 += v * b8;
  t11 += v * b9;
  t12 += v * b10;
  t13 += v * b11;
  t14 += v * b12;
  t15 += v * b13;
  t16 += v * b14;
  t17 += v * b15;
  v = a[3];
  t3 += v * b0;
  t4 += v * b1;
  t5 += v * b2;
  t6 += v * b3;
  t7 += v * b4;
  t8 += v * b5;
  t9 += v * b6;
  t10 += v * b7;
  t11 += v * b8;
  t12 += v * b9;
  t13 += v * b10;
  t14 += v * b11;
  t15 += v * b12;
  t16 += v * b13;
  t17 += v * b14;
  t18 += v * b15;
  v = a[4];
  t4 += v * b0;
  t5 += v * b1;
  t6 += v * b2;
  t7 += v * b3;
  t8 += v * b4;
  t9 += v * b5;
  t10 += v * b6;
  t11 += v * b7;
  t12 += v * b8;
  t13 += v * b9;
  t14 += v * b10;
  t15 += v * b11;
  t16 += v * b12;
  t17 += v * b13;
  t18 += v * b14;
  t19 += v * b15;
  v = a[5];
  t5 += v * b0;
  t6 += v * b1;
  t7 += v * b2;
  t8 += v * b3;
  t9 += v * b4;
  t10 += v * b5;
  t11 += v * b6;
  t12 += v * b7;
  t13 += v * b8;
  t14 += v * b9;
  t15 += v * b10;
  t16 += v * b11;
  t17 += v * b12;
  t18 += v * b13;
  t19 += v * b14;
  t20 += v * b15;
  v = a[6];
  t6 += v * b0;
  t7 += v * b1;
  t8 += v * b2;
  t9 += v * b3;
  t10 += v * b4;
  t11 += v * b5;
  t12 += v * b6;
  t13 += v * b7;
  t14 += v * b8;
  t15 += v * b9;
  t16 += v * b10;
  t17 += v * b11;
  t18 += v * b12;
  t19 += v * b13;
  t20 += v * b14;
  t21 += v * b15;
  v = a[7];
  t7 += v * b0;
  t8 += v * b1;
  t9 += v * b2;
  t10 += v * b3;
  t11 += v * b4;
  t12 += v * b5;
  t13 += v * b6;
  t14 += v * b7;
  t15 += v * b8;
  t16 += v * b9;
  t17 += v * b10;
  t18 += v * b11;
  t19 += v * b12;
  t20 += v * b13;
  t21 += v * b14;
  t22 += v * b15;
  v = a[8];
  t8 += v * b0;
  t9 += v * b1;
  t10 += v * b2;
  t11 += v * b3;
  t12 += v * b4;
  t13 += v * b5;
  t14 += v * b6;
  t15 += v * b7;
  t16 += v * b8;
  t17 += v * b9;
  t18 += v * b10;
  t19 += v * b11;
  t20 += v * b12;
  t21 += v * b13;
  t22 += v * b14;
  t23 += v * b15;
  v = a[9];
  t9 += v * b0;
  t10 += v * b1;
  t11 += v * b2;
  t12 += v * b3;
  t13 += v * b4;
  t14 += v * b5;
  t15 += v * b6;
  t16 += v * b7;
  t17 += v * b8;
  t18 += v * b9;
  t19 += v * b10;
  t20 += v * b11;
  t21 += v * b12;
  t22 += v * b13;
  t23 += v * b14;
  t24 += v * b15;
  v = a[10];
  t10 += v * b0;
  t11 += v * b1;
  t12 += v * b2;
  t13 += v * b3;
  t14 += v * b4;
  t15 += v * b5;
  t16 += v * b6;
  t17 += v * b7;
  t18 += v * b8;
  t19 += v * b9;
  t20 += v * b10;
  t21 += v * b11;
  t22 += v * b12;
  t23 += v * b13;
  t24 += v * b14;
  t25 += v * b15;
  v = a[11];
  t11 += v * b0;
  t12 += v * b1;
  t13 += v * b2;
  t14 += v * b3;
  t15 += v * b4;
  t16 += v * b5;
  t17 += v * b6;
  t18 += v * b7;
  t19 += v * b8;
  t20 += v * b9;
  t21 += v * b10;
  t22 += v * b11;
  t23 += v * b12;
  t24 += v * b13;
  t25 += v * b14;
  t26 += v * b15;
  v = a[12];
  t12 += v * b0;
  t13 += v * b1;
  t14 += v * b2;
  t15 += v * b3;
  t16 += v * b4;
  t17 += v * b5;
  t18 += v * b6;
  t19 += v * b7;
  t20 += v * b8;
  t21 += v * b9;
  t22 += v * b10;
  t23 += v * b11;
  t24 += v * b12;
  t25 += v * b13;
  t26 += v * b14;
  t27 += v * b15;
  v = a[13];
  t13 += v * b0;
  t14 += v * b1;
  t15 += v * b2;
  t16 += v * b3;
  t17 += v * b4;
  t18 += v * b5;
  t19 += v * b6;
  t20 += v * b7;
  t21 += v * b8;
  t22 += v * b9;
  t23 += v * b10;
  t24 += v * b11;
  t25 += v * b12;
  t26 += v * b13;
  t27 += v * b14;
  t28 += v * b15;
  v = a[14];
  t14 += v * b0;
  t15 += v * b1;
  t16 += v * b2;
  t17 += v * b3;
  t18 += v * b4;
  t19 += v * b5;
  t20 += v * b6;
  t21 += v * b7;
  t22 += v * b8;
  t23 += v * b9;
  t24 += v * b10;
  t25 += v * b11;
  t26 += v * b12;
  t27 += v * b13;
  t28 += v * b14;
  t29 += v * b15;
  v = a[15];
  t15 += v * b0;
  t16 += v * b1;
  t17 += v * b2;
  t18 += v * b3;
  t19 += v * b4;
  t20 += v * b5;
  t21 += v * b6;
  t22 += v * b7;
  t23 += v * b8;
  t24 += v * b9;
  t25 += v * b10;
  t26 += v * b11;
  t27 += v * b12;
  t28 += v * b13;
  t29 += v * b14;
  t30 += v * b15;

  t0  += 38 * t16;
  t1  += 38 * t17;
  t2  += 38 * t18;
  t3  += 38 * t19;
  t4  += 38 * t20;
  t5  += 38 * t21;
  t6  += 38 * t22;
  t7  += 38 * t23;
  t8  += 38 * t24;
  t9  += 38 * t25;
  t10 += 38 * t26;
  t11 += 38 * t27;
  t12 += 38 * t28;
  t13 += 38 * t29;
  t14 += 38 * t30;
  // t15 left as is

  // first car
  c = 1;
  v =  t0 + c + 65535; c = Math.floor(v / 65536);  t0 = v - c * 65536;
  v =  t1 + c + 65535; c = Math.floor(v / 65536);  t1 = v - c * 65536;
  v =  t2 + c + 65535; c = Math.floor(v / 65536);  t2 = v - c * 65536;
  v =  t3 + c + 65535; c = Math.floor(v / 65536);  t3 = v - c * 65536;
  v =  t4 + c + 65535; c = Math.floor(v / 65536);  t4 = v - c * 65536;
  v =  t5 + c + 65535; c = Math.floor(v / 65536);  t5 = v - c * 65536;
  v =  t6 + c + 65535; c = Math.floor(v / 65536);  t6 = v - c * 65536;
  v =  t7 + c + 65535; c = Math.floor(v / 65536);  t7 = v - c * 65536;
  v =  t8 + c + 65535; c = Math.floor(v / 65536);  t8 = v - c * 65536;
  v =  t9 + c + 65535; c = Math.floor(v / 65536);  t9 = v - c * 65536;
  v = t10 + c + 65535; c = Math.floor(v / 65536); t10 = v - c * 65536;
  v = t11 + c + 65535; c = Math.floor(v / 65536); t11 = v - c * 65536;
  v = t12 + c + 65535; c = Math.floor(v / 65536); t12 = v - c * 65536;
  v = t13 + c + 65535; c = Math.floor(v / 65536); t13 = v - c * 65536;
  v = t14 + c + 65535; c = Math.floor(v / 65536); t14 = v - c * 65536;
  v = t15 + c + 65535; c = Math.floor(v / 65536); t15 = v - c * 65536;
  t0 += c-1 + 37 * (c-1);

  // second car
  c = 1;
  v =  t0 + c + 65535; c = Math.floor(v / 65536);  t0 = v - c * 65536;
  v =  t1 + c + 65535; c = Math.floor(v / 65536);  t1 = v - c * 65536;
  v =  t2 + c + 65535; c = Math.floor(v / 65536);  t2 = v - c * 65536;
  v =  t3 + c + 65535; c = Math.floor(v / 65536);  t3 = v - c * 65536;
  v =  t4 + c + 65535; c = Math.floor(v / 65536);  t4 = v - c * 65536;
  v =  t5 + c + 65535; c = Math.floor(v / 65536);  t5 = v - c * 65536;
  v =  t6 + c + 65535; c = Math.floor(v / 65536);  t6 = v - c * 65536;
  v =  t7 + c + 65535; c = Math.floor(v / 65536);  t7 = v - c * 65536;
  v =  t8 + c + 65535; c = Math.floor(v / 65536);  t8 = v - c * 65536;
  v =  t9 + c + 65535; c = Math.floor(v / 65536);  t9 = v - c * 65536;
  v = t10 + c + 65535; c = Math.floor(v / 65536); t10 = v - c * 65536;
  v = t11 + c + 65535; c = Math.floor(v / 65536); t11 = v - c * 65536;
  v = t12 + c + 65535; c = Math.floor(v / 65536); t12 = v - c * 65536;
  v = t13 + c + 65535; c = Math.floor(v / 65536); t13 = v - c * 65536;
  v = t14 + c + 65535; c = Math.floor(v / 65536); t14 = v - c * 65536;
  v = t15 + c + 65535; c = Math.floor(v / 65536); t15 = v - c * 65536;
  t0 += c-1 + 37 * (c-1);

  o[ 0] = t0;
  o[ 1] = t1;
  o[ 2] = t2;
  o[ 3] = t3;
  o[ 4] = t4;
  o[ 5] = t5;
  o[ 6] = t6;
  o[ 7] = t7;
  o[ 8] = t8;
  o[ 9] = t9;
  o[10] = t10;
  o[11] = t11;
  o[12] = t12;
  o[13] = t13;
  o[14] = t14;
  o[15] = t15;
}

function S(o, a) {
  M(o, a, a);
}

function inv25519(o, i) {
  var c = gf();
  var a;
  for (a = 0; a < 16; a++) c[a] = i[a];
  for (a = 253; a >= 0; a--) {
    S(c, c);
    if(a !== 2 && a !== 4) M(c, c, i);
  }
  for (a = 0; a < 16; a++) o[a] = c[a];
}

function pow2523(o, i) {
  var c = gf();
  var a;
  for (a = 0; a < 16; a++) c[a] = i[a];
  for (a = 250; a >= 0; a--) {
      S(c, c);
      if(a !== 1) M(c, c, i);
  }
  for (a = 0; a < 16; a++) o[a] = c[a];
}

function crypto_scalarmult(q, n, p) {
  var z = new Uint8Array(32);
  var x = new Float64Array(80), r, i;
  var a = gf(), b = gf(), c = gf(),
      d = gf(), e = gf(), f = gf();
  for (i = 0; i < 31; i++) z[i] = n[i];
  z[31]=(n[31]&127)|64;
  z[0]&=248;
  unpack25519(x,p);
  for (i = 0; i < 16; i++) {
    b[i]=x[i];
    d[i]=a[i]=c[i]=0;
  }
  a[0]=d[0]=1;
  for (i=254; i>=0; --i) {
    r=(z[i>>>3]>>>(i&7))&1;
    sel25519(a,b,r);
    sel25519(c,d,r);
    A(e,a,c);
    Z(a,a,c);
    A(c,b,d);
    Z(b,b,d);
    S(d,e);
    S(f,a);
    M(a,c,a);
    M(c,b,e);
    A(e,a,c);
    Z(a,a,c);
    S(b,a);
    Z(c,d,f);
    M(a,c,_121665);
    A(a,a,d);
    M(c,c,a);
    M(a,d,f);
    M(d,b,x);
    S(b,e);
    sel25519(a,b,r);
    sel25519(c,d,r);
  }
  for (i = 0; i < 16; i++) {
    x[i+16]=a[i];
    x[i+32]=c[i];
    x[i+48]=b[i];
    x[i+64]=d[i];
  }
  var x32 = x.subarray(32);
  var x16 = x.subarray(16);
  inv25519(x32,x32);
  M(x16,x16,x32);
  pack25519(q,x16);
  return 0;
}

function crypto_scalarmult_base(q, n) {
  return crypto_scalarmult(q, n, _9);
}

function crypto_box_keypair(y, x) {
  randombytes(x, 32);
  return crypto_scalarmult_base(y, x);
}

function crypto_box_beforenm(k, y, x) {
  var s = new Uint8Array(32);
  crypto_scalarmult(s, x, y);
  return crypto_core_hsalsa20(k, _0, s, sigma);
}

var crypto_box_afternm = crypto_secretbox;
var crypto_box_open_afternm = crypto_secretbox_open;

function crypto_box(c, m, d, n, y, x) {
  var k = new Uint8Array(32);
  crypto_box_beforenm(k, y, x);
  return crypto_box_afternm(c, m, d, n, k);
}

function crypto_box_open(m, c, d, n, y, x) {
  var k = new Uint8Array(32);
  crypto_box_beforenm(k, y, x);
  return crypto_box_open_afternm(m, c, d, n, k);
}

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function crypto_hashblocks_hl(hh, hl, m, n) {
  var wh = new Int32Array(16), wl = new Int32Array(16),
      bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7,
      bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7,
      th, tl, i, j, h, l, a, b, c, d;

  var ah0 = hh[0],
      ah1 = hh[1],
      ah2 = hh[2],
      ah3 = hh[3],
      ah4 = hh[4],
      ah5 = hh[5],
      ah6 = hh[6],
      ah7 = hh[7],

      al0 = hl[0],
      al1 = hl[1],
      al2 = hl[2],
      al3 = hl[3],
      al4 = hl[4],
      al5 = hl[5],
      al6 = hl[6],
      al7 = hl[7];

  var pos = 0;
  while (n >= 128) {
    for (i = 0; i < 16; i++) {
      j = 8 * i + pos;
      wh[i] = (m[j+0] << 24) | (m[j+1] << 16) | (m[j+2] << 8) | m[j+3];
      wl[i] = (m[j+4] << 24) | (m[j+5] << 16) | (m[j+6] << 8) | m[j+7];
    }
    for (i = 0; i < 80; i++) {
      bh0 = ah0;
      bh1 = ah1;
      bh2 = ah2;
      bh3 = ah3;
      bh4 = ah4;
      bh5 = ah5;
      bh6 = ah6;
      bh7 = ah7;

      bl0 = al0;
      bl1 = al1;
      bl2 = al2;
      bl3 = al3;
      bl4 = al4;
      bl5 = al5;
      bl6 = al6;
      bl7 = al7;

      // add
      h = ah7;
      l = al7;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      // Sigma1
      h = ((ah4 >>> 14) | (al4 << (32-14))) ^ ((ah4 >>> 18) | (al4 << (32-18))) ^ ((al4 >>> (41-32)) | (ah4 << (32-(41-32))));
      l = ((al4 >>> 14) | (ah4 << (32-14))) ^ ((al4 >>> 18) | (ah4 << (32-18))) ^ ((ah4 >>> (41-32)) | (al4 << (32-(41-32))));

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // Ch
      h = (ah4 & ah5) ^ (~ah4 & ah6);
      l = (al4 & al5) ^ (~al4 & al6);

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // K
      h = K[i*2];
      l = K[i*2+1];

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // w
      h = wh[i%16];
      l = wl[i%16];

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      th = c & 0xffff | d << 16;
      tl = a & 0xffff | b << 16;

      // add
      h = th;
      l = tl;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      // Sigma0
      h = ((ah0 >>> 28) | (al0 << (32-28))) ^ ((al0 >>> (34-32)) | (ah0 << (32-(34-32)))) ^ ((al0 >>> (39-32)) | (ah0 << (32-(39-32))));
      l = ((al0 >>> 28) | (ah0 << (32-28))) ^ ((ah0 >>> (34-32)) | (al0 << (32-(34-32)))) ^ ((ah0 >>> (39-32)) | (al0 << (32-(39-32))));

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      // Maj
      h = (ah0 & ah1) ^ (ah0 & ah2) ^ (ah1 & ah2);
      l = (al0 & al1) ^ (al0 & al2) ^ (al1 & al2);

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      bh7 = (c & 0xffff) | (d << 16);
      bl7 = (a & 0xffff) | (b << 16);

      // add
      h = bh3;
      l = bl3;

      a = l & 0xffff; b = l >>> 16;
      c = h & 0xffff; d = h >>> 16;

      h = th;
      l = tl;

      a += l & 0xffff; b += l >>> 16;
      c += h & 0xffff; d += h >>> 16;

      b += a >>> 16;
      c += b >>> 16;
      d += c >>> 16;

      bh3 = (c & 0xffff) | (d << 16);
      bl3 = (a & 0xffff) | (b << 16);

      ah1 = bh0;
      ah2 = bh1;
      ah3 = bh2;
      ah4 = bh3;
      ah5 = bh4;
      ah6 = bh5;
      ah7 = bh6;
      ah0 = bh7;

      al1 = bl0;
      al2 = bl1;
      al3 = bl2;
      al4 = bl3;
      al5 = bl4;
      al6 = bl5;
      al7 = bl6;
      al0 = bl7;

      if (i%16 === 15) {
        for (j = 0; j < 16; j++) {
          // add
          h = wh[j];
          l = wl[j];

          a = l & 0xffff; b = l >>> 16;
          c = h & 0xffff; d = h >>> 16;

          h = wh[(j+9)%16];
          l = wl[(j+9)%16];

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          // sigma0
          th = wh[(j+1)%16];
          tl = wl[(j+1)%16];
          h = ((th >>> 1) | (tl << (32-1))) ^ ((th >>> 8) | (tl << (32-8))) ^ (th >>> 7);
          l = ((tl >>> 1) | (th << (32-1))) ^ ((tl >>> 8) | (th << (32-8))) ^ ((tl >>> 7) | (th << (32-7)));

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          // sigma1
          th = wh[(j+14)%16];
          tl = wl[(j+14)%16];
          h = ((th >>> 19) | (tl << (32-19))) ^ ((tl >>> (61-32)) | (th << (32-(61-32)))) ^ (th >>> 6);
          l = ((tl >>> 19) | (th << (32-19))) ^ ((th >>> (61-32)) | (tl << (32-(61-32)))) ^ ((tl >>> 6) | (th << (32-6)));

          a += l & 0xffff; b += l >>> 16;
          c += h & 0xffff; d += h >>> 16;

          b += a >>> 16;
          c += b >>> 16;
          d += c >>> 16;

          wh[j] = (c & 0xffff) | (d << 16);
          wl[j] = (a & 0xffff) | (b << 16);
        }
      }
    }

    // add
    h = ah0;
    l = al0;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[0];
    l = hl[0];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[0] = ah0 = (c & 0xffff) | (d << 16);
    hl[0] = al0 = (a & 0xffff) | (b << 16);

    h = ah1;
    l = al1;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[1];
    l = hl[1];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[1] = ah1 = (c & 0xffff) | (d << 16);
    hl[1] = al1 = (a & 0xffff) | (b << 16);

    h = ah2;
    l = al2;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[2];
    l = hl[2];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[2] = ah2 = (c & 0xffff) | (d << 16);
    hl[2] = al2 = (a & 0xffff) | (b << 16);

    h = ah3;
    l = al3;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[3];
    l = hl[3];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[3] = ah3 = (c & 0xffff) | (d << 16);
    hl[3] = al3 = (a & 0xffff) | (b << 16);

    h = ah4;
    l = al4;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[4];
    l = hl[4];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[4] = ah4 = (c & 0xffff) | (d << 16);
    hl[4] = al4 = (a & 0xffff) | (b << 16);

    h = ah5;
    l = al5;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[5];
    l = hl[5];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[5] = ah5 = (c & 0xffff) | (d << 16);
    hl[5] = al5 = (a & 0xffff) | (b << 16);

    h = ah6;
    l = al6;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[6];
    l = hl[6];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[6] = ah6 = (c & 0xffff) | (d << 16);
    hl[6] = al6 = (a & 0xffff) | (b << 16);

    h = ah7;
    l = al7;

    a = l & 0xffff; b = l >>> 16;
    c = h & 0xffff; d = h >>> 16;

    h = hh[7];
    l = hl[7];

    a += l & 0xffff; b += l >>> 16;
    c += h & 0xffff; d += h >>> 16;

    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;

    hh[7] = ah7 = (c & 0xffff) | (d << 16);
    hl[7] = al7 = (a & 0xffff) | (b << 16);

    pos += 128;
    n -= 128;
  }

  return n;
}

function crypto_hash(out, m, n) {
  var hh = new Int32Array(8),
      hl = new Int32Array(8),
      x = new Uint8Array(256),
      i, b = n;

  hh[0] = 0x6a09e667;
  hh[1] = 0xbb67ae85;
  hh[2] = 0x3c6ef372;
  hh[3] = 0xa54ff53a;
  hh[4] = 0x510e527f;
  hh[5] = 0x9b05688c;
  hh[6] = 0x1f83d9ab;
  hh[7] = 0x5be0cd19;

  hl[0] = 0xf3bcc908;
  hl[1] = 0x84caa73b;
  hl[2] = 0xfe94f82b;
  hl[3] = 0x5f1d36f1;
  hl[4] = 0xade682d1;
  hl[5] = 0x2b3e6c1f;
  hl[6] = 0xfb41bd6b;
  hl[7] = 0x137e2179;

  crypto_hashblocks_hl(hh, hl, m, n);
  n %= 128;

  for (i = 0; i < n; i++) x[i] = m[b-n+i];
  x[n] = 128;

  n = 256-128*(n<112?1:0);
  x[n-9] = 0;
  ts64(x, n-8,  (b / 0x20000000) | 0, b << 3);
  crypto_hashblocks_hl(hh, hl, x, n);

  for (i = 0; i < 8; i++) ts64(out, 8*i, hh[i], hl[i]);

  return 0;
}

function add(p, q) {
  var a = gf(), b = gf(), c = gf(),
      d = gf(), e = gf(), f = gf(),
      g = gf(), h = gf(), t = gf();

  Z(a, p[1], p[0]);
  Z(t, q[1], q[0]);
  M(a, a, t);
  A(b, p[0], p[1]);
  A(t, q[0], q[1]);
  M(b, b, t);
  M(c, p[3], q[3]);
  M(c, c, D2);
  M(d, p[2], q[2]);
  A(d, d, d);
  Z(e, b, a);
  Z(f, d, c);
  A(g, d, c);
  A(h, b, a);

  M(p[0], e, f);
  M(p[1], h, g);
  M(p[2], g, f);
  M(p[3], e, h);
}

function cswap(p, q, b) {
  var i;
  for (i = 0; i < 4; i++) {
    sel25519(p[i], q[i], b);
  }
}

function pack(r, p) {
  var tx = gf(), ty = gf(), zi = gf();
  inv25519(zi, p[2]);
  M(tx, p[0], zi);
  M(ty, p[1], zi);
  pack25519(r, ty);
  r[31] ^= par25519(tx) << 7;
}

function scalarmult(p, q, s) {
  var b, i;
  set25519(p[0], gf0);
  set25519(p[1], gf1);
  set25519(p[2], gf1);
  set25519(p[3], gf0);
  for (i = 255; i >= 0; --i) {
    b = (s[(i/8)|0] >> (i&7)) & 1;
    cswap(p, q, b);
    add(q, p);
    add(p, p);
    cswap(p, q, b);
  }
}

function scalarbase(p, s) {
  var q = [gf(), gf(), gf(), gf()];
  set25519(q[0], X);
  set25519(q[1], Y);
  set25519(q[2], gf1);
  M(q[3], X, Y);
  scalarmult(p, q, s);
}

function crypto_sign_keypair(pk, sk, seeded) {
  var d = new Uint8Array(64);
  var p = [gf(), gf(), gf(), gf()];
  var i;

  if (!seeded) randombytes(sk, 32);
  crypto_hash(d, sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;

  scalarbase(p, d);
  pack(pk, p);

  for (i = 0; i < 32; i++) sk[i+32] = pk[i];
  return 0;
}

var L = new Float64Array([0xed, 0xd3, 0xf5, 0x5c, 0x1a, 0x63, 0x12, 0x58, 0xd6, 0x9c, 0xf7, 0xa2, 0xde, 0xf9, 0xde, 0x14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x10]);

function modL(r, x) {
  var carry, i, j, k;
  for (i = 63; i >= 32; --i) {
    carry = 0;
    for (j = i - 32, k = i - 12; j < k; ++j) {
      x[j] += carry - 16 * x[i] * L[j - (i - 32)];
      carry = Math.floor((x[j] + 128) / 256);
      x[j] -= carry * 256;
    }
    x[j] += carry;
    x[i] = 0;
  }
  carry = 0;
  for (j = 0; j < 32; j++) {
    x[j] += carry - (x[31] >> 4) * L[j];
    carry = x[j] >> 8;
    x[j] &= 255;
  }
  for (j = 0; j < 32; j++) x[j] -= carry * L[j];
  for (i = 0; i < 32; i++) {
    x[i+1] += x[i] >> 8;
    r[i] = x[i] & 255;
  }
}

function reduce(r) {
  var x = new Float64Array(64), i;
  for (i = 0; i < 64; i++) x[i] = r[i];
  for (i = 0; i < 64; i++) r[i] = 0;
  modL(r, x);
}

// Note: difference from C - smlen returned, not passed as argument.
function crypto_sign(sm, m, n, sk) {
  var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
  var i, j, x = new Float64Array(64);
  var p = [gf(), gf(), gf(), gf()];

  crypto_hash(d, sk, 32);
  d[0] &= 248;
  d[31] &= 127;
  d[31] |= 64;

  var smlen = n + 64;
  for (i = 0; i < n; i++) sm[64 + i] = m[i];
  for (i = 0; i < 32; i++) sm[32 + i] = d[32 + i];

  crypto_hash(r, sm.subarray(32), n+32);
  reduce(r);
  scalarbase(p, r);
  pack(sm, p);

  for (i = 32; i < 64; i++) sm[i] = sk[i];
  crypto_hash(h, sm, n + 64);
  reduce(h);

  for (i = 0; i < 64; i++) x[i] = 0;
  for (i = 0; i < 32; i++) x[i] = r[i];
  for (i = 0; i < 32; i++) {
    for (j = 0; j < 32; j++) {
      x[i+j] += h[i] * d[j];
    }
  }

  modL(sm.subarray(32), x);
  return smlen;
}

function unpackneg(r, p) {
  var t = gf(), chk = gf(), num = gf(),
      den = gf(), den2 = gf(), den4 = gf(),
      den6 = gf();

  set25519(r[2], gf1);
  unpack25519(r[1], p);
  S(num, r[1]);
  M(den, num, D);
  Z(num, num, r[2]);
  A(den, r[2], den);

  S(den2, den);
  S(den4, den2);
  M(den6, den4, den2);
  M(t, den6, num);
  M(t, t, den);

  pow2523(t, t);
  M(t, t, num);
  M(t, t, den);
  M(t, t, den);
  M(r[0], t, den);

  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) M(r[0], r[0], I);

  S(chk, r[0]);
  M(chk, chk, den);
  if (neq25519(chk, num)) return -1;

  if (par25519(r[0]) === (p[31]>>7)) Z(r[0], gf0, r[0]);

  M(r[3], r[0], r[1]);
  return 0;
}

function crypto_sign_open(m, sm, n, pk) {
  var i;
  var t = new Uint8Array(32), h = new Uint8Array(64);
  var p = [gf(), gf(), gf(), gf()],
      q = [gf(), gf(), gf(), gf()];

  if (n < 64) return -1;

  if (unpackneg(q, pk)) return -1;

  for (i = 0; i < n; i++) m[i] = sm[i];
  for (i = 0; i < 32; i++) m[i+32] = pk[i];
  crypto_hash(h, m, n);
  reduce(h);
  scalarmult(p, q, h);

  scalarbase(q, sm.subarray(32));
  add(p, q);
  pack(t, p);

  n -= 64;
  if (crypto_verify_32(sm, 0, t, 0)) {
    for (i = 0; i < n; i++) m[i] = 0;
    return -1;
  }

  for (i = 0; i < n; i++) m[i] = sm[i + 64];
  return n;
}

var crypto_secretbox_KEYBYTES = 32,
    crypto_secretbox_NONCEBYTES = 24,
    crypto_secretbox_ZEROBYTES = 32,
    crypto_secretbox_BOXZEROBYTES = 16,
    crypto_scalarmult_BYTES = 32,
    crypto_scalarmult_SCALARBYTES = 32,
    crypto_box_PUBLICKEYBYTES = 32,
    crypto_box_SECRETKEYBYTES = 32,
    crypto_box_BEFORENMBYTES = 32,
    crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES,
    crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES,
    crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES,
    crypto_sign_BYTES = 64,
    crypto_sign_PUBLICKEYBYTES = 32,
    crypto_sign_SECRETKEYBYTES = 64,
    crypto_sign_SEEDBYTES = 32,
    crypto_hash_BYTES = 64;

nacl.lowlevel = {
  crypto_core_hsalsa20: crypto_core_hsalsa20,
  crypto_stream_xor: crypto_stream_xor,
  crypto_stream: crypto_stream,
  crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
  crypto_stream_salsa20: crypto_stream_salsa20,
  crypto_onetimeauth: crypto_onetimeauth,
  crypto_onetimeauth_verify: crypto_onetimeauth_verify,
  crypto_verify_16: crypto_verify_16,
  crypto_verify_32: crypto_verify_32,
  crypto_secretbox: crypto_secretbox,
  crypto_secretbox_open: crypto_secretbox_open,
  crypto_scalarmult: crypto_scalarmult,
  crypto_scalarmult_base: crypto_scalarmult_base,
  crypto_box_beforenm: crypto_box_beforenm,
  crypto_box_afternm: crypto_box_afternm,
  crypto_box: crypto_box,
  crypto_box_open: crypto_box_open,
  crypto_box_keypair: crypto_box_keypair,
  crypto_hash: crypto_hash,
  crypto_sign: crypto_sign,
  crypto_sign_keypair: crypto_sign_keypair,
  crypto_sign_open: crypto_sign_open,

  crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
  crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
  crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
  crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
  crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
  crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
  crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
  crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
  crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
  crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
  crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
  crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
  crypto_sign_BYTES: crypto_sign_BYTES,
  crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
  crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
  crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
  crypto_hash_BYTES: crypto_hash_BYTES,

  gf: gf,
  D: D,
  L: L,
  pack25519: pack25519,
  unpack25519: unpack25519,
  M: M,
  A: A,
  S: S,
  Z: Z,
  pow2523: pow2523,
  add: add,
  set25519: set25519,
  modL: modL,
  scalarmult: scalarmult,
  scalarbase: scalarbase,
};

/* High-level API */

function checkLengths(k, n) {
  if (k.length !== crypto_secretbox_KEYBYTES) throw new Error('bad key size');
  if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error('bad nonce size');
}

function checkBoxLengths(pk, sk) {
  if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error('bad public key size');
  if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error('bad secret key size');
}

function checkArrayTypes() {
  for (var i = 0; i < arguments.length; i++) {
    if (!(arguments[i] instanceof Uint8Array))
      throw new TypeError('unexpected type, use Uint8Array');
  }
}

function cleanup(arr) {
  for (var i = 0; i < arr.length; i++) arr[i] = 0;
}

nacl.randomBytes = function(n) {
  var b = new Uint8Array(n);
  randombytes(b, n);
  return b;
};

nacl.secretbox = function(msg, nonce, key) {
  checkArrayTypes(msg, nonce, key);
  checkLengths(key, nonce);
  var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
  var c = new Uint8Array(m.length);
  for (var i = 0; i < msg.length; i++) m[i+crypto_secretbox_ZEROBYTES] = msg[i];
  crypto_secretbox(c, m, m.length, nonce, key);
  return c.subarray(crypto_secretbox_BOXZEROBYTES);
};

nacl.secretbox.open = function(box, nonce, key) {
  checkArrayTypes(box, nonce, key);
  checkLengths(key, nonce);
  var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
  var m = new Uint8Array(c.length);
  for (var i = 0; i < box.length; i++) c[i+crypto_secretbox_BOXZEROBYTES] = box[i];
  if (c.length < 32) return null;
  if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
  return m.subarray(crypto_secretbox_ZEROBYTES);
};

nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;

nacl.scalarMult = function(n, p) {
  checkArrayTypes(n, p);
  if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
  if (p.length !== crypto_scalarmult_BYTES) throw new Error('bad p size');
  var q = new Uint8Array(crypto_scalarmult_BYTES);
  crypto_scalarmult(q, n, p);
  return q;
};

nacl.scalarMult.base = function(n) {
  checkArrayTypes(n);
  if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
  var q = new Uint8Array(crypto_scalarmult_BYTES);
  crypto_scalarmult_base(q, n);
  return q;
};

nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;

nacl.box = function(msg, nonce, publicKey, secretKey) {
  var k = nacl.box.before(publicKey, secretKey);
  return nacl.secretbox(msg, nonce, k);
};

nacl.box.before = function(publicKey, secretKey) {
  checkArrayTypes(publicKey, secretKey);
  checkBoxLengths(publicKey, secretKey);
  var k = new Uint8Array(crypto_box_BEFORENMBYTES);
  crypto_box_beforenm(k, publicKey, secretKey);
  return k;
};

nacl.box.after = nacl.secretbox;

nacl.box.open = function(msg, nonce, publicKey, secretKey) {
  var k = nacl.box.before(publicKey, secretKey);
  return nacl.secretbox.open(msg, nonce, k);
};

nacl.box.open.after = nacl.secretbox.open;

nacl.box.keyPair = function() {
  var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
  crypto_box_keypair(pk, sk);
  return {publicKey: pk, secretKey: sk};
};

nacl.box.keyPair.fromSecretKey = function(secretKey) {
  checkArrayTypes(secretKey);
  if (secretKey.length !== crypto_box_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
  crypto_scalarmult_base(pk, secretKey);
  return {publicKey: pk, secretKey: new Uint8Array(secretKey)};
};

nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
nacl.box.nonceLength = crypto_box_NONCEBYTES;
nacl.box.overheadLength = nacl.secretbox.overheadLength;

nacl.sign = function(msg, secretKey) {
  checkArrayTypes(msg, secretKey);
  if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var signedMsg = new Uint8Array(crypto_sign_BYTES+msg.length);
  crypto_sign(signedMsg, msg, msg.length, secretKey);
  return signedMsg;
};

nacl.sign.open = function(signedMsg, publicKey) {
  checkArrayTypes(signedMsg, publicKey);
  if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
    throw new Error('bad public key size');
  var tmp = new Uint8Array(signedMsg.length);
  var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
  if (mlen < 0) return null;
  var m = new Uint8Array(mlen);
  for (var i = 0; i < m.length; i++) m[i] = tmp[i];
  return m;
};

nacl.sign.detached = function(msg, secretKey) {
  var signedMsg = nacl.sign(msg, secretKey);
  var sig = new Uint8Array(crypto_sign_BYTES);
  for (var i = 0; i < sig.length; i++) sig[i] = signedMsg[i];
  return sig;
};

nacl.sign.detached.verify = function(msg, sig, publicKey) {
  checkArrayTypes(msg, sig, publicKey);
  if (sig.length !== crypto_sign_BYTES)
    throw new Error('bad signature size');
  if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
    throw new Error('bad public key size');
  var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
  var m = new Uint8Array(crypto_sign_BYTES + msg.length);
  var i;
  for (i = 0; i < crypto_sign_BYTES; i++) sm[i] = sig[i];
  for (i = 0; i < msg.length; i++) sm[i+crypto_sign_BYTES] = msg[i];
  return (crypto_sign_open(m, sm, sm.length, publicKey) >= 0);
};

nacl.sign.keyPair = function() {
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
  crypto_sign_keypair(pk, sk);
  return {publicKey: pk, secretKey: sk};
};

nacl.sign.keyPair.fromSecretKey = function(secretKey) {
  checkArrayTypes(secretKey);
  if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
    throw new Error('bad secret key size');
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  for (var i = 0; i < pk.length; i++) pk[i] = secretKey[32+i];
  return {publicKey: pk, secretKey: new Uint8Array(secretKey)};
};

nacl.sign.keyPair.fromSeed = function(seed) {
  checkArrayTypes(seed);
  if (seed.length !== crypto_sign_SEEDBYTES)
    throw new Error('bad seed size');
  var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
  var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
  for (var i = 0; i < 32; i++) sk[i] = seed[i];
  crypto_sign_keypair(pk, sk, true);
  return {publicKey: pk, secretKey: sk};
};

nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
nacl.sign.seedLength = crypto_sign_SEEDBYTES;
nacl.sign.signatureLength = crypto_sign_BYTES;

nacl.hash = function(msg) {
  checkArrayTypes(msg);
  var h = new Uint8Array(crypto_hash_BYTES);
  crypto_hash(h, msg, msg.length);
  return h;
};

nacl.hash.hashLength = crypto_hash_BYTES;

nacl.verify = function(x, y) {
  checkArrayTypes(x, y);
  // Zero length arguments are considered not equal.
  if (x.length === 0 || y.length === 0) return false;
  if (x.length !== y.length) return false;
  return (vn(x, 0, y, 0, x.length) === 0) ? true : false;
};

nacl.setPRNG = function(fn) {
  randombytes = fn;
};

(function() {
  // Initialize PRNG if environment provides CSPRNG.
  // If not, methods calling randombytes will throw.
  var crypto = typeof self !== 'undefined' ? (self.crypto || self.msCrypto) : null;
  if (crypto && crypto.getRandomValues) {
    // Browsers.
    var QUOTA = 65536;
    nacl.setPRNG(function(x, n) {
      var i, v = new Uint8Array(n);
      for (i = 0; i < n; i += QUOTA) {
        crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
      }
      for (i = 0; i < n; i++) x[i] = v[i];
      cleanup(v);
    });
  } else if (true) {
    // Node.js.
    crypto = __webpack_require__("../../node_modules/crypto-browserify/index.js");
    if (crypto && crypto.randomBytes) {
      nacl.setPRNG(function(x, n) {
        var i, v = crypto.randomBytes(n);
        for (i = 0; i < n; i++) x[i] = v[i];
        cleanup(v);
      });
    }
  }
})();

})( true && module.exports ? module.exports : (self.nacl = self.nacl || {}));


/***/ }),

/***/ "../../node_modules/uri-js/dist/es5/uri.all.js":
/***/ (function(__unused_webpack_module, exports) {

/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */
(function (global, factory) {
	 true ? factory(exports) :
	0;
}(this, (function (exports) { 'use strict';

function merge() {
    for (var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++) {
        sets[_key] = arguments[_key];
    }

    if (sets.length > 1) {
        sets[0] = sets[0].slice(0, -1);
        var xl = sets.length - 1;
        for (var x = 1; x < xl; ++x) {
            sets[x] = sets[x].slice(1, -1);
        }
        sets[xl] = sets[xl].slice(1);
        return sets.join('');
    } else {
        return sets[0];
    }
}
function subexp(str) {
    return "(?:" + str + ")";
}
function typeOf(o) {
    return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
}
function toUpperCase(str) {
    return str.toUpperCase();
}
function toArray(obj) {
    return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [obj] : Array.prototype.slice.call(obj) : [];
}
function assign(target, source) {
    var obj = target;
    if (source) {
        for (var key in source) {
            obj[key] = source[key];
        }
    }
    return obj;
}

function buildExps(isIRI) {
    var ALPHA$$ = "[A-Za-z]",
        CR$ = "[\\x0D]",
        DIGIT$$ = "[0-9]",
        DQUOTE$$ = "[\\x22]",
        HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"),
        //case-insensitive
    LF$$ = "[\\x0A]",
        SP$$ = "[\\x20]",
        PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)),
        //expanded
    GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]",
        SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",
        RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$),
        UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]",
        //subset, excludes bidi control characters
    IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]",
        //subset
    UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$),
        SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"),
        USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"),
        DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$),
        DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$),
        //relaxed parsing rules
    IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$),
        H16$ = subexp(HEXDIG$$ + "{1,4}"),
        LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$),
        IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$),
        //                           6( h16 ":" ) ls32
    IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$),
        //                      "::" 5( h16 ":" ) ls32
    IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$),
        //[               h16 ] "::" 4( h16 ":" ) ls32
    IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$),
        //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
    IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$),
        //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
    IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$),
        //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
    IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$),
        //[ *4( h16 ":" ) h16 ] "::"              ls32
    IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$),
        //[ *5( h16 ":" ) h16 ] "::"              h16
    IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"),
        //[ *6( h16 ":" ) h16 ] "::"
    IPV6ADDRESS$ = subexp([IPV6ADDRESS1$, IPV6ADDRESS2$, IPV6ADDRESS3$, IPV6ADDRESS4$, IPV6ADDRESS5$, IPV6ADDRESS6$, IPV6ADDRESS7$, IPV6ADDRESS8$, IPV6ADDRESS9$].join("|")),
        ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"),
        //RFC 6874
    IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$),
        //RFC 6874
    IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$),
        //RFC 6874, with relaxed parsing rules
    IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"),
        IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"),
        //RFC 6874
    REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"),
        HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$),
        PORT$ = subexp(DIGIT$$ + "*"),
        AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"),
        PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")),
        SEGMENT$ = subexp(PCHAR$ + "*"),
        SEGMENT_NZ$ = subexp(PCHAR$ + "+"),
        SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"),
        PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"),
        PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"),
        //simplified
    PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$),
        //simplified
    PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$),
        //simplified
    PATH_EMPTY$ = "(?!" + PCHAR$ + ")",
        PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$),
        QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"),
        FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"),
        HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$),
        URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"),
        RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$),
        RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"),
        URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$),
        ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"),
        GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$",
        RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$",
        ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$",
        SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$",
        AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
    return {
        NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
        NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
        NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
        ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
        UNRESERVED: new RegExp(UNRESERVED$$, "g"),
        OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
        PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
        IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
        IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
    };
}
var URI_PROTOCOL = buildExps(false);

var IRI_PROTOCOL = buildExps(true);

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/** Highest positive signed 32-bit float value */

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1

/** Bootstring parameters */
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'

/** Regular expressions */
var regexPunycode = /^xn--/;
var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators

/** Error messages */
var errors = {
	'overflow': 'Overflow: input needs wider integers to process',
	'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
	'invalid-input': 'Invalid input'
};

/** Convenience shortcuts */
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/*--------------------------------------------------------------------------*/

/**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */
function error$1(type) {
	throw new RangeError(errors[type]);
}

/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */
function map(array, fn) {
	var result = [];
	var length = array.length;
	while (length--) {
		result[length] = fn(array[length]);
	}
	return result;
}

/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */
function mapDomain(string, fn) {
	var parts = string.split('@');
	var result = '';
	if (parts.length > 1) {
		// In email addresses, only the domain name should be punycoded. Leave
		// the local part (i.e. everything up to `@`) intact.
		result = parts[0] + '@';
		string = parts[1];
	}
	// Avoid `split(regex)` for IE8 compatibility. See #17.
	string = string.replace(regexSeparators, '\x2E');
	var labels = string.split('.');
	var encoded = map(labels, fn).join('.');
	return result + encoded;
}

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */
function ucs2decode(string) {
	var output = [];
	var counter = 0;
	var length = string.length;
	while (counter < length) {
		var value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// It's a high surrogate, and there is a next character.
			var extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) {
				// Low surrogate.
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// It's an unmatched surrogate; only append this code unit, in case the
				// next code unit is the high surrogate of a surrogate pair.
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */
var ucs2encode = function ucs2encode(array) {
	return String.fromCodePoint.apply(String, toConsumableArray(array));
};

/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */
var basicToDigit = function basicToDigit(codePoint) {
	if (codePoint - 0x30 < 0x0A) {
		return codePoint - 0x16;
	}
	if (codePoint - 0x41 < 0x1A) {
		return codePoint - 0x41;
	}
	if (codePoint - 0x61 < 0x1A) {
		return codePoint - 0x61;
	}
	return base;
};

/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */
var digitToBasic = function digitToBasic(digit, flag) {
	//  0..25 map to ASCII a..z or A..Z
	// 26..35 map to ASCII 0..9
	return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */
var adapt = function adapt(delta, numPoints, firstTime) {
	var k = 0;
	delta = firstTime ? floor(delta / damp) : delta >> 1;
	delta += floor(delta / numPoints);
	for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
		delta = floor(delta / baseMinusTMin);
	}
	return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */
var decode = function decode(input) {
	// Don't use UCS-2.
	var output = [];
	var inputLength = input.length;
	var i = 0;
	var n = initialN;
	var bias = initialBias;

	// Handle the basic code points: let `basic` be the number of input code
	// points before the last delimiter, or `0` if there is none, then copy
	// the first basic code points to the output.

	var basic = input.lastIndexOf(delimiter);
	if (basic < 0) {
		basic = 0;
	}

	for (var j = 0; j < basic; ++j) {
		// if it's not a basic code point
		if (input.charCodeAt(j) >= 0x80) {
			error$1('not-basic');
		}
		output.push(input.charCodeAt(j));
	}

	// Main decoding loop: start just after the last delimiter if any basic code
	// points were copied; start at the beginning otherwise.

	for (var index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

		// `index` is the index of the next character to be consumed.
		// Decode a generalized variable-length integer into `delta`,
		// which gets added to `i`. The overflow checking is easier
		// if we increase `i` as we go, then subtract off its starting
		// value at the end to obtain `delta`.
		var oldi = i;
		for (var w = 1, k = base;; /* no condition */k += base) {

			if (index >= inputLength) {
				error$1('invalid-input');
			}

			var digit = basicToDigit(input.charCodeAt(index++));

			if (digit >= base || digit > floor((maxInt - i) / w)) {
				error$1('overflow');
			}

			i += digit * w;
			var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

			if (digit < t) {
				break;
			}

			var baseMinusT = base - t;
			if (w > floor(maxInt / baseMinusT)) {
				error$1('overflow');
			}

			w *= baseMinusT;
		}

		var out = output.length + 1;
		bias = adapt(i - oldi, out, oldi == 0);

		// `i` was supposed to wrap around from `out` to `0`,
		// incrementing `n` each time, so we'll fix that now:
		if (floor(i / out) > maxInt - n) {
			error$1('overflow');
		}

		n += floor(i / out);
		i %= out;

		// Insert `n` at position `i` of the output.
		output.splice(i++, 0, n);
	}

	return String.fromCodePoint.apply(String, output);
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */
var encode = function encode(input) {
	var output = [];

	// Convert the input in UCS-2 to an array of Unicode code points.
	input = ucs2decode(input);

	// Cache the length.
	var inputLength = input.length;

	// Initialize the state.
	var n = initialN;
	var delta = 0;
	var bias = initialBias;

	// Handle the basic code points.
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var _currentValue2 = _step.value;

			if (_currentValue2 < 0x80) {
				output.push(stringFromCharCode(_currentValue2));
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	var basicLength = output.length;
	var handledCPCount = basicLength;

	// `handledCPCount` is the number of code points that have been handled;
	// `basicLength` is the number of basic code points.

	// Finish the basic string with a delimiter unless it's empty.
	if (basicLength) {
		output.push(delimiter);
	}

	// Main encoding loop:
	while (handledCPCount < inputLength) {

		// All non-basic code points < n have been handled already. Find the next
		// larger one:
		var m = maxInt;
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var currentValue = _step2.value;

				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow.
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}

		var handledCPCountPlusOne = handledCPCount + 1;
		if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
			error$1('overflow');
		}

		delta += (m - n) * handledCPCountPlusOne;
		n = m;

		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;

		try {
			for (var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var _currentValue = _step3.value;

				if (_currentValue < n && ++delta > maxInt) {
					error$1('overflow');
				}
				if (_currentValue == n) {
					// Represent delta as a generalized variable-length integer.
					var q = delta;
					for (var k = base;; /* no condition */k += base) {
						var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						var qMinusT = q - t;
						var baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3.return) {
					_iterator3.return();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}

		++delta;
		++n;
	}
	return output.join('');
};

/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */
var toUnicode = function toUnicode(input) {
	return mapDomain(input, function (string) {
		return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
	});
};

/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */
var toASCII = function toASCII(input) {
	return mapDomain(input, function (string) {
		return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
	});
};

/*--------------------------------------------------------------------------*/

/** Define the public API */
var punycode = {
	/**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */
	'version': '2.1.0',
	/**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */
	'ucs2': {
		'decode': ucs2decode,
		'encode': ucs2encode
	},
	'decode': decode,
	'encode': encode,
	'toASCII': toASCII,
	'toUnicode': toUnicode
};

/**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */
/**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */
var SCHEMES = {};
function pctEncChar(chr) {
    var c = chr.charCodeAt(0);
    var e = void 0;
    if (c < 16) e = "%0" + c.toString(16).toUpperCase();else if (c < 128) e = "%" + c.toString(16).toUpperCase();else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
    return e;
}
function pctDecChars(str) {
    var newStr = "";
    var i = 0;
    var il = str.length;
    while (i < il) {
        var c = parseInt(str.substr(i + 1, 2), 16);
        if (c < 128) {
            newStr += String.fromCharCode(c);
            i += 3;
        } else if (c >= 194 && c < 224) {
            if (il - i >= 6) {
                var c2 = parseInt(str.substr(i + 4, 2), 16);
                newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
            } else {
                newStr += str.substr(i, 6);
            }
            i += 6;
        } else if (c >= 224) {
            if (il - i >= 9) {
                var _c = parseInt(str.substr(i + 4, 2), 16);
                var c3 = parseInt(str.substr(i + 7, 2), 16);
                newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
            } else {
                newStr += str.substr(i, 9);
            }
            i += 9;
        } else {
            newStr += str.substr(i, 3);
            i += 3;
        }
    }
    return newStr;
}
function _normalizeComponentEncoding(components, protocol) {
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(protocol.UNRESERVED) ? str : decStr;
    }
    if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
    if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
    return components;
}

function _stripLeadingZeros(str) {
    return str.replace(/^0*(.*)/, "$1") || "0";
}
function _normalizeIPv4(host, protocol) {
    var matches = host.match(protocol.IPV4ADDRESS) || [];

    var _matches = slicedToArray(matches, 2),
        address = _matches[1];

    if (address) {
        return address.split(".").map(_stripLeadingZeros).join(".");
    } else {
        return host;
    }
}
function _normalizeIPv6(host, protocol) {
    var matches = host.match(protocol.IPV6ADDRESS) || [];

    var _matches2 = slicedToArray(matches, 3),
        address = _matches2[1],
        zone = _matches2[2];

    if (address) {
        var _address$toLowerCase$ = address.toLowerCase().split('::').reverse(),
            _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2),
            last = _address$toLowerCase$2[0],
            first = _address$toLowerCase$2[1];

        var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
        var lastFields = last.split(":").map(_stripLeadingZeros);
        var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
        var fieldCount = isLastFieldIPv4Address ? 7 : 8;
        var lastFieldsStart = lastFields.length - fieldCount;
        var fields = Array(fieldCount);
        for (var x = 0; x < fieldCount; ++x) {
            fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || '';
        }
        if (isLastFieldIPv4Address) {
            fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
        }
        var allZeroFields = fields.reduce(function (acc, field, index) {
            if (!field || field === "0") {
                var lastLongest = acc[acc.length - 1];
                if (lastLongest && lastLongest.index + lastLongest.length === index) {
                    lastLongest.length++;
                } else {
                    acc.push({ index: index, length: 1 });
                }
            }
            return acc;
        }, []);
        var longestZeroFields = allZeroFields.sort(function (a, b) {
            return b.length - a.length;
        })[0];
        var newHost = void 0;
        if (longestZeroFields && longestZeroFields.length > 1) {
            var newFirst = fields.slice(0, longestZeroFields.index);
            var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
            newHost = newFirst.join(":") + "::" + newLast.join(":");
        } else {
            newHost = fields.join(":");
        }
        if (zone) {
            newHost += "%" + zone;
        }
        return newHost;
    } else {
        return host;
    }
}
var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
function parse(uriString) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var components = {};
    var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
    if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
    var matches = uriString.match(URI_PARSE);
    if (matches) {
        if (NO_MATCH_IS_UNDEFINED) {
            //store each component
            components.scheme = matches[1];
            components.userinfo = matches[3];
            components.host = matches[4];
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = matches[7];
            components.fragment = matches[8];
            //fix port number
            if (isNaN(components.port)) {
                components.port = matches[5];
            }
        } else {
            //IE FIX for improper RegExp matching
            //store each component
            components.scheme = matches[1] || undefined;
            components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
            components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
            components.port = parseInt(matches[5], 10);
            components.path = matches[6] || "";
            components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
            components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
            //fix port number
            if (isNaN(components.port)) {
                components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
        }
        if (components.host) {
            //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
        }
        //determine reference type
        if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) {
            components.reference = "same-document";
        } else if (components.scheme === undefined) {
            components.reference = "relative";
        } else if (components.fragment === undefined) {
            components.reference = "absolute";
        } else {
            components.reference = "uri";
        }
        //check for reference errors
        if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) {
            components.error = components.error || "URI is not a " + options.reference + " reference.";
        }
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //check if scheme can't handle IRIs
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            //if host component is a domain name
            if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) {
                //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
            }
            //convert IRI -> URI
            _normalizeComponentEncoding(components, URI_PROTOCOL);
        } else {
            //normalize encodings
            _normalizeComponentEncoding(components, protocol);
        }
        //perform scheme specific parsing
        if (schemeHandler && schemeHandler.parse) {
            schemeHandler.parse(components, options);
        }
    } else {
        components.error = components.error || "URI can not be parsed.";
    }
    return components;
}

function _recomposeAuthority(components, options) {
    var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
    var uriTokens = [];
    if (components.userinfo !== undefined) {
        uriTokens.push(components.userinfo);
        uriTokens.push("@");
    }
    if (components.host !== undefined) {
        //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function (_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
    }
    if (typeof components.port === "number" || typeof components.port === "string") {
        uriTokens.push(":");
        uriTokens.push(String(components.port));
    }
    return uriTokens.length ? uriTokens.join("") : undefined;
}

var RDS1 = /^\.\.?\//;
var RDS2 = /^\/\.(\/|$)/;
var RDS3 = /^\/\.\.(\/|$)/;
var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
function removeDotSegments(input) {
    var output = [];
    while (input.length) {
        if (input.match(RDS1)) {
            input = input.replace(RDS1, "");
        } else if (input.match(RDS2)) {
            input = input.replace(RDS2, "/");
        } else if (input.match(RDS3)) {
            input = input.replace(RDS3, "/");
            output.pop();
        } else if (input === "." || input === "..") {
            input = "";
        } else {
            var im = input.match(RDS5);
            if (im) {
                var s = im[0];
                input = input.slice(s.length);
                output.push(s);
            } else {
                throw new Error("Unexpected dot segment condition");
            }
        }
    }
    return output.join("");
}

function serialize(components) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
    var uriTokens = [];
    //find scheme handler
    var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
    //perform scheme specific serialization
    if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
    if (components.host) {
        //if host component is an IPv6 address
        if (protocol.IPV6ADDRESS.test(components.host)) {}
        //TODO: normalize IPv6 address as per RFC 5952

        //if host component is a domain name
        else if (options.domainHost || schemeHandler && schemeHandler.domainHost) {
                //convert IDN via punycode
                try {
                    components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                }
            }
    }
    //normalize encoding
    _normalizeComponentEncoding(components, protocol);
    if (options.reference !== "suffix" && components.scheme) {
        uriTokens.push(components.scheme);
        uriTokens.push(":");
    }
    var authority = _recomposeAuthority(components, options);
    if (authority !== undefined) {
        if (options.reference !== "suffix") {
            uriTokens.push("//");
        }
        uriTokens.push(authority);
        if (components.path && components.path.charAt(0) !== "/") {
            uriTokens.push("/");
        }
    }
    if (components.path !== undefined) {
        var s = components.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) {
            s = removeDotSegments(s);
        }
        if (authority === undefined) {
            s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
        }
        uriTokens.push(s);
    }
    if (components.query !== undefined) {
        uriTokens.push("?");
        uriTokens.push(components.query);
    }
    if (components.fragment !== undefined) {
        uriTokens.push("#");
        uriTokens.push(components.fragment);
    }
    return uriTokens.join(""); //merge tokens into a string
}

function resolveComponents(base, relative) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var skipNormalization = arguments[3];

    var target = {};
    if (!skipNormalization) {
        base = parse(serialize(base, options), options); //normalize base components
        relative = parse(serialize(relative, options), options); //normalize relative components
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        //target.authority = relative.authority;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = removeDotSegments(relative.path || "");
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) {
                    target.query = relative.query;
                } else {
                    target.query = base.query;
                }
            } else {
                if (relative.path.charAt(0) === "/") {
                    target.path = removeDotSegments(relative.path);
                } else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) {
                        target.path = "/" + relative.path;
                    } else if (!base.path) {
                        target.path = relative.path;
                    } else {
                        target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                    }
                    target.path = removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            //target.authority = base.authority;
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}

function resolve(baseURI, relativeURI, options) {
    var schemelessOptions = assign({ scheme: 'null' }, options);
    return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
}

function normalize(uri, options) {
    if (typeof uri === "string") {
        uri = serialize(parse(uri, options), options);
    } else if (typeOf(uri) === "object") {
        uri = parse(serialize(uri, options), options);
    }
    return uri;
}

function equal(uriA, uriB, options) {
    if (typeof uriA === "string") {
        uriA = serialize(parse(uriA, options), options);
    } else if (typeOf(uriA) === "object") {
        uriA = serialize(uriA, options);
    }
    if (typeof uriB === "string") {
        uriB = serialize(parse(uriB, options), options);
    } else if (typeOf(uriB) === "object") {
        uriB = serialize(uriB, options);
    }
    return uriA === uriB;
}

function escapeComponent(str, options) {
    return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
}

function unescapeComponent(str, options) {
    return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
}

var handler = {
    scheme: "http",
    domainHost: true,
    parse: function parse(components, options) {
        //report missing host
        if (!components.host) {
            components.error = components.error || "HTTP URIs must have a host.";
        }
        return components;
    },
    serialize: function serialize(components, options) {
        var secure = String(components.scheme).toLowerCase() === "https";
        //normalize the default port
        if (components.port === (secure ? 443 : 80) || components.port === "") {
            components.port = undefined;
        }
        //normalize the empty path
        if (!components.path) {
            components.path = "/";
        }
        //NOTE: We do not parse query strings for HTTP URIs
        //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
        //and not the HTTP spec.
        return components;
    }
};

var handler$1 = {
    scheme: "https",
    domainHost: handler.domainHost,
    parse: handler.parse,
    serialize: handler.serialize
};

function isSecure(wsComponents) {
    return typeof wsComponents.secure === 'boolean' ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
}
//RFC 6455
var handler$2 = {
    scheme: "ws",
    domainHost: true,
    parse: function parse(components, options) {
        var wsComponents = components;
        //indicate if the secure flag is set
        wsComponents.secure = isSecure(wsComponents);
        //construct resouce name
        wsComponents.resourceName = (wsComponents.path || '/') + (wsComponents.query ? '?' + wsComponents.query : '');
        wsComponents.path = undefined;
        wsComponents.query = undefined;
        return wsComponents;
    },
    serialize: function serialize(wsComponents, options) {
        //normalize the default port
        if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") {
            wsComponents.port = undefined;
        }
        //ensure scheme matches secure flag
        if (typeof wsComponents.secure === 'boolean') {
            wsComponents.scheme = wsComponents.secure ? 'wss' : 'ws';
            wsComponents.secure = undefined;
        }
        //reconstruct path from resource name
        if (wsComponents.resourceName) {
            var _wsComponents$resourc = wsComponents.resourceName.split('?'),
                _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2),
                path = _wsComponents$resourc2[0],
                query = _wsComponents$resourc2[1];

            wsComponents.path = path && path !== '/' ? path : undefined;
            wsComponents.query = query;
            wsComponents.resourceName = undefined;
        }
        //forbid fragment component
        wsComponents.fragment = undefined;
        return wsComponents;
    }
};

var handler$3 = {
    scheme: "wss",
    domainHost: handler$2.domainHost,
    parse: handler$2.parse,
    serialize: handler$2.serialize
};

var O = {};
var isIRI = true;
//RFC 3986
var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
//RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
//const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
//const WSP$$ = "[\\x20\\x09]";
//const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
//const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
//const VCHAR$$ = "[\\x21-\\x7E]";
//const WSP$$ = "[\\x20\\x09]";
//const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
//const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
//const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
//const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
var VCHAR$$ = merge(QTEXT$$, "[\\\"\\\\]");
var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
var UNRESERVED = new RegExp(UNRESERVED$$, "g");
var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
var NOT_HFVALUE = NOT_HFNAME;
function decodeUnreserved(str) {
    var decStr = pctDecChars(str);
    return !decStr.match(UNRESERVED) ? str : decStr;
}
var handler$4 = {
    scheme: "mailto",
    parse: function parse$$1(components, options) {
        var mailtoComponents = components;
        var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
        mailtoComponents.path = undefined;
        if (mailtoComponents.query) {
            var unknownHeaders = false;
            var headers = {};
            var hfields = mailtoComponents.query.split("&");
            for (var x = 0, xl = hfields.length; x < xl; ++x) {
                var hfield = hfields[x].split("=");
                switch (hfield[0]) {
                    case "to":
                        var toAddrs = hfield[1].split(",");
                        for (var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x) {
                            to.push(toAddrs[_x]);
                        }
                        break;
                    case "subject":
                        mailtoComponents.subject = unescapeComponent(hfield[1], options);
                        break;
                    case "body":
                        mailtoComponents.body = unescapeComponent(hfield[1], options);
                        break;
                    default:
                        unknownHeaders = true;
                        headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                        break;
                }
            }
            if (unknownHeaders) mailtoComponents.headers = headers;
        }
        mailtoComponents.query = undefined;
        for (var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2) {
            var addr = to[_x2].split("@");
            addr[0] = unescapeComponent(addr[0]);
            if (!options.unicodeSupport) {
                //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
            } else {
                addr[1] = unescapeComponent(addr[1], options).toLowerCase();
            }
            to[_x2] = addr.join("@");
        }
        return mailtoComponents;
    },
    serialize: function serialize$$1(mailtoComponents, options) {
        var components = mailtoComponents;
        var to = toArray(mailtoComponents.to);
        if (to) {
            for (var x = 0, xl = to.length; x < xl; ++x) {
                var toAddr = String(to[x]);
                var atIdx = toAddr.lastIndexOf("@");
                var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                var domain = toAddr.slice(atIdx + 1);
                //convert IDN via punycode
                try {
                    domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                } catch (e) {
                    components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                }
                to[x] = localPart + "@" + domain;
            }
            components.path = to.join(",");
        }
        var headers = mailtoComponents.headers = mailtoComponents.headers || {};
        if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
        if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
        var fields = [];
        for (var name in headers) {
            if (headers[name] !== O[name]) {
                fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            }
        }
        if (fields.length) {
            components.query = fields.join("&");
        }
        return components;
    }
};

var URN_PARSE = /^([^\:]+)\:(.*)/;
//RFC 2141
var handler$5 = {
    scheme: "urn",
    parse: function parse$$1(components, options) {
        var matches = components.path && components.path.match(URN_PARSE);
        var urnComponents = components;
        if (matches) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = matches[1].toLowerCase();
            var nss = matches[2];
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            urnComponents.nid = nid;
            urnComponents.nss = nss;
            urnComponents.path = undefined;
            if (schemeHandler) {
                urnComponents = schemeHandler.parse(urnComponents, options);
            }
        } else {
            urnComponents.error = urnComponents.error || "URN can not be parsed.";
        }
        return urnComponents;
    },
    serialize: function serialize$$1(urnComponents, options) {
        var scheme = options.scheme || urnComponents.scheme || "urn";
        var nid = urnComponents.nid;
        var urnScheme = scheme + ":" + (options.nid || nid);
        var schemeHandler = SCHEMES[urnScheme];
        if (schemeHandler) {
            urnComponents = schemeHandler.serialize(urnComponents, options);
        }
        var uriComponents = urnComponents;
        var nss = urnComponents.nss;
        uriComponents.path = (nid || options.nid) + ":" + nss;
        return uriComponents;
    }
};

var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
//RFC 4122
var handler$6 = {
    scheme: "urn:uuid",
    parse: function parse(urnComponents, options) {
        var uuidComponents = urnComponents;
        uuidComponents.uuid = uuidComponents.nss;
        uuidComponents.nss = undefined;
        if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) {
            uuidComponents.error = uuidComponents.error || "UUID is not valid.";
        }
        return uuidComponents;
    },
    serialize: function serialize(uuidComponents, options) {
        var urnComponents = uuidComponents;
        //normalize UUID
        urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
        return urnComponents;
    }
};

SCHEMES[handler.scheme] = handler;
SCHEMES[handler$1.scheme] = handler$1;
SCHEMES[handler$2.scheme] = handler$2;
SCHEMES[handler$3.scheme] = handler$3;
SCHEMES[handler$4.scheme] = handler$4;
SCHEMES[handler$5.scheme] = handler$5;
SCHEMES[handler$6.scheme] = handler$6;

exports.SCHEMES = SCHEMES;
exports.pctEncChar = pctEncChar;
exports.pctDecChars = pctDecChars;
exports.parse = parse;
exports.removeDotSegments = removeDotSegments;
exports.serialize = serialize;
exports.resolveComponents = resolveComponents;
exports.resolve = resolve;
exports.normalize = normalize;
exports.equal = equal;
exports.escapeComponent = escapeComponent;
exports.unescapeComponent = unescapeComponent;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=uri.all.js.map


/***/ }),

/***/ "../../node_modules/util-deprecate/browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {


/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!__webpack_require__.g.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = __webpack_require__.g.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}


/***/ }),

/***/ "../../node_modules/util/support/isBufferBrowser.js":
/***/ ((module) => {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ "../../node_modules/util/support/types.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9



var isArgumentsObject = __webpack_require__("../../node_modules/is-arguments/index.js");
var isGeneratorFunction = __webpack_require__("../../node_modules/is-generator-function/index.js");
var whichTypedArray = __webpack_require__("../../node_modules/which-typed-array/index.js");
var isTypedArray = __webpack_require__("../../node_modules/is-typed-array/index.js");

function uncurryThis(f) {
  return f.call.bind(f);
}

var BigIntSupported = typeof BigInt !== 'undefined';
var SymbolSupported = typeof Symbol !== 'undefined';

var ObjectToString = uncurryThis(Object.prototype.toString);

var numberValue = uncurryThis(Number.prototype.valueOf);
var stringValue = uncurryThis(String.prototype.valueOf);
var booleanValue = uncurryThis(Boolean.prototype.valueOf);

if (BigIntSupported) {
  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
}

if (SymbolSupported) {
  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
}

function checkBoxedPrimitive(value, prototypeValueOf) {
  if (typeof value !== 'object') {
    return false;
  }
  try {
    prototypeValueOf(value);
    return true;
  } catch(e) {
    return false;
  }
}

exports.isArgumentsObject = isArgumentsObject;
exports.isGeneratorFunction = isGeneratorFunction;
exports.isTypedArray = isTypedArray;

// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function isPromise(input) {
	return (
		(
			typeof Promise !== 'undefined' &&
			input instanceof Promise
		) ||
		(
			input !== null &&
			typeof input === 'object' &&
			typeof input.then === 'function' &&
			typeof input.catch === 'function'
		)
	);
}
exports.isPromise = isPromise;

function isArrayBufferView(value) {
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    return ArrayBuffer.isView(value);
  }

  return (
    isTypedArray(value) ||
    isDataView(value)
  );
}
exports.isArrayBufferView = isArrayBufferView;


function isUint8Array(value) {
  return whichTypedArray(value) === 'Uint8Array';
}
exports.isUint8Array = isUint8Array;

function isUint8ClampedArray(value) {
  return whichTypedArray(value) === 'Uint8ClampedArray';
}
exports.isUint8ClampedArray = isUint8ClampedArray;

function isUint16Array(value) {
  return whichTypedArray(value) === 'Uint16Array';
}
exports.isUint16Array = isUint16Array;

function isUint32Array(value) {
  return whichTypedArray(value) === 'Uint32Array';
}
exports.isUint32Array = isUint32Array;

function isInt8Array(value) {
  return whichTypedArray(value) === 'Int8Array';
}
exports.isInt8Array = isInt8Array;

function isInt16Array(value) {
  return whichTypedArray(value) === 'Int16Array';
}
exports.isInt16Array = isInt16Array;

function isInt32Array(value) {
  return whichTypedArray(value) === 'Int32Array';
}
exports.isInt32Array = isInt32Array;

function isFloat32Array(value) {
  return whichTypedArray(value) === 'Float32Array';
}
exports.isFloat32Array = isFloat32Array;

function isFloat64Array(value) {
  return whichTypedArray(value) === 'Float64Array';
}
exports.isFloat64Array = isFloat64Array;

function isBigInt64Array(value) {
  return whichTypedArray(value) === 'BigInt64Array';
}
exports.isBigInt64Array = isBigInt64Array;

function isBigUint64Array(value) {
  return whichTypedArray(value) === 'BigUint64Array';
}
exports.isBigUint64Array = isBigUint64Array;

function isMapToString(value) {
  return ObjectToString(value) === '[object Map]';
}
isMapToString.working = (
  typeof Map !== 'undefined' &&
  isMapToString(new Map())
);

function isMap(value) {
  if (typeof Map === 'undefined') {
    return false;
  }

  return isMapToString.working
    ? isMapToString(value)
    : value instanceof Map;
}
exports.isMap = isMap;

function isSetToString(value) {
  return ObjectToString(value) === '[object Set]';
}
isSetToString.working = (
  typeof Set !== 'undefined' &&
  isSetToString(new Set())
);
function isSet(value) {
  if (typeof Set === 'undefined') {
    return false;
  }

  return isSetToString.working
    ? isSetToString(value)
    : value instanceof Set;
}
exports.isSet = isSet;

function isWeakMapToString(value) {
  return ObjectToString(value) === '[object WeakMap]';
}
isWeakMapToString.working = (
  typeof WeakMap !== 'undefined' &&
  isWeakMapToString(new WeakMap())
);
function isWeakMap(value) {
  if (typeof WeakMap === 'undefined') {
    return false;
  }

  return isWeakMapToString.working
    ? isWeakMapToString(value)
    : value instanceof WeakMap;
}
exports.isWeakMap = isWeakMap;

function isWeakSetToString(value) {
  return ObjectToString(value) === '[object WeakSet]';
}
isWeakSetToString.working = (
  typeof WeakSet !== 'undefined' &&
  isWeakSetToString(new WeakSet())
);
function isWeakSet(value) {
  return isWeakSetToString(value);
}
exports.isWeakSet = isWeakSet;

function isArrayBufferToString(value) {
  return ObjectToString(value) === '[object ArrayBuffer]';
}
isArrayBufferToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  isArrayBufferToString(new ArrayBuffer())
);
function isArrayBuffer(value) {
  if (typeof ArrayBuffer === 'undefined') {
    return false;
  }

  return isArrayBufferToString.working
    ? isArrayBufferToString(value)
    : value instanceof ArrayBuffer;
}
exports.isArrayBuffer = isArrayBuffer;

function isDataViewToString(value) {
  return ObjectToString(value) === '[object DataView]';
}
isDataViewToString.working = (
  typeof ArrayBuffer !== 'undefined' &&
  typeof DataView !== 'undefined' &&
  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
);
function isDataView(value) {
  if (typeof DataView === 'undefined') {
    return false;
  }

  return isDataViewToString.working
    ? isDataViewToString(value)
    : value instanceof DataView;
}
exports.isDataView = isDataView;

// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function isSharedArrayBufferToString(value) {
  return ObjectToString(value) === '[object SharedArrayBuffer]';
}
function isSharedArrayBuffer(value) {
  if (typeof SharedArrayBufferCopy === 'undefined') {
    return false;
  }

  if (typeof isSharedArrayBufferToString.working === 'undefined') {
    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
  }

  return isSharedArrayBufferToString.working
    ? isSharedArrayBufferToString(value)
    : value instanceof SharedArrayBufferCopy;
}
exports.isSharedArrayBuffer = isSharedArrayBuffer;

function isAsyncFunction(value) {
  return ObjectToString(value) === '[object AsyncFunction]';
}
exports.isAsyncFunction = isAsyncFunction;

function isMapIterator(value) {
  return ObjectToString(value) === '[object Map Iterator]';
}
exports.isMapIterator = isMapIterator;

function isSetIterator(value) {
  return ObjectToString(value) === '[object Set Iterator]';
}
exports.isSetIterator = isSetIterator;

function isGeneratorObject(value) {
  return ObjectToString(value) === '[object Generator]';
}
exports.isGeneratorObject = isGeneratorObject;

function isWebAssemblyCompiledModule(value) {
  return ObjectToString(value) === '[object WebAssembly.Module]';
}
exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;

function isNumberObject(value) {
  return checkBoxedPrimitive(value, numberValue);
}
exports.isNumberObject = isNumberObject;

function isStringObject(value) {
  return checkBoxedPrimitive(value, stringValue);
}
exports.isStringObject = isStringObject;

function isBooleanObject(value) {
  return checkBoxedPrimitive(value, booleanValue);
}
exports.isBooleanObject = isBooleanObject;

function isBigIntObject(value) {
  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
}
exports.isBigIntObject = isBigIntObject;

function isSymbolObject(value) {
  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
}
exports.isSymbolObject = isSymbolObject;

function isBoxedPrimitive(value) {
  return (
    isNumberObject(value) ||
    isStringObject(value) ||
    isBooleanObject(value) ||
    isBigIntObject(value) ||
    isSymbolObject(value)
  );
}
exports.isBoxedPrimitive = isBoxedPrimitive;

function isAnyArrayBuffer(value) {
  return typeof Uint8Array !== 'undefined' && (
    isArrayBuffer(value) ||
    isSharedArrayBuffer(value)
  );
}
exports.isAnyArrayBuffer = isAnyArrayBuffer;

['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
  Object.defineProperty(exports, method, {
    enumerable: false,
    value: function() {
      throw new Error(method + ' is not supported in userland');
    }
  });
});


/***/ }),

/***/ "../../node_modules/util/util.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnvRegex = /^$/;

if (process.env.NODE_DEBUG) {
  var debugEnv = process.env.NODE_DEBUG;
  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
    .replace(/\*/g, '.*')
    .replace(/,/g, '$|^')
    .toUpperCase();
  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
}
exports.debuglog = function(set) {
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (debugEnvRegex.test(set)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').slice(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.slice(1, -1);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
exports.types = __webpack_require__("../../node_modules/util/support/types.js");

function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;
exports.types.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;
exports.types.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;
exports.types.isNativeError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__("../../node_modules/util/support/isBufferBrowser.js");

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__("../../node_modules/inherits/inherits_browser.js");

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;


/***/ }),

/***/ "../../node_modules/websocket/lib/browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _globalThis;
if (typeof globalThis === 'object') {
	_globalThis = globalThis;
} else {
	try {
		_globalThis = __webpack_require__("../../node_modules/es5-ext/global.js");
	} catch (error) {
	} finally {
		if (!_globalThis && typeof window !== 'undefined') { _globalThis = window; }
		if (!_globalThis) { throw new Error('Could not determine global this'); }
	}
}

var NativeWebSocket = _globalThis.WebSocket || _globalThis.MozWebSocket;
var websocket_version = __webpack_require__("../../node_modules/websocket/lib/version.js");


/**
 * Expose a W3C WebSocket class with just one or two arguments.
 */
function W3CWebSocket(uri, protocols) {
	var native_instance;

	if (protocols) {
		native_instance = new NativeWebSocket(uri, protocols);
	}
	else {
		native_instance = new NativeWebSocket(uri);
	}

	/**
	 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
	 * class). Since it is an Object it will be returned as it is when creating an
	 * instance of W3CWebSocket via 'new W3CWebSocket()'.
	 *
	 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
	 */
	return native_instance;
}
if (NativeWebSocket) {
	['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED'].forEach(function(prop) {
		Object.defineProperty(W3CWebSocket, prop, {
			get: function() { return NativeWebSocket[prop]; }
		});
	});
}

/**
 * Module exports.
 */
module.exports = {
    'w3cwebsocket' : NativeWebSocket ? W3CWebSocket : null,
    'version'      : websocket_version
};


/***/ }),

/***/ "../../node_modules/websocket/lib/version.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__("../../node_modules/websocket/package.json").version;


/***/ }),

/***/ "../../node_modules/which-typed-array/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var forEach = __webpack_require__("../../node_modules/for-each/index.js");
var availableTypedArrays = __webpack_require__("../../node_modules/available-typed-arrays/index.js");
var callBound = __webpack_require__("../../node_modules/call-bind/callBound.js");
var gOPD = __webpack_require__("../../node_modules/gopd/index.js");

var $toString = callBound('Object.prototype.toString');
var hasToStringTag = __webpack_require__("../../node_modules/has-tostringtag/shams.js")();

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;
var typedArrays = availableTypedArrays();

var $slice = callBound('String.prototype.slice');
var toStrTags = {};
var getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if (hasToStringTag && gOPD && getPrototypeOf) {
	forEach(typedArrays, function (typedArray) {
		if (typeof g[typedArray] === 'function') {
			var arr = new g[typedArray]();
			if (Symbol.toStringTag in arr) {
				var proto = getPrototypeOf(arr);
				var descriptor = gOPD(proto, Symbol.toStringTag);
				if (!descriptor) {
					var superProto = getPrototypeOf(proto);
					descriptor = gOPD(superProto, Symbol.toStringTag);
				}
				toStrTags[typedArray] = descriptor.get;
			}
		}
	});
}

var tryTypedArrays = function tryAllTypedArrays(value) {
	var foundName = false;
	forEach(toStrTags, function (getter, typedArray) {
		if (!foundName) {
			try {
				var name = getter.call(value);
				if (name === typedArray) {
					foundName = name;
				}
			} catch (e) {}
		}
	});
	return foundName;
};

var isTypedArray = __webpack_require__("../../node_modules/is-typed-array/index.js");

module.exports = function whichTypedArray(value) {
	if (!isTypedArray(value)) { return false; }
	if (!hasToStringTag || !(Symbol.toStringTag in value)) { return $slice($toString(value), 8, -1); }
	return tryTypedArrays(value);
};


/***/ }),

/***/ "../../node_modules/yocto-queue/index.js":
/***/ ((module) => {

class Node {
	/// value;
	/// next;

	constructor(value) {
		this.value = value;

		// TODO: Remove this when targeting Node.js 12.
		this.next = undefined;
	}
}

class Queue {
	// TODO: Use private class fields when targeting Node.js 12.
	// #_head;
	// #_tail;
	// #_size;

	constructor() {
		this.clear();
	}

	enqueue(value) {
		const node = new Node(value);

		if (this._head) {
			this._tail.next = node;
			this._tail = node;
		} else {
			this._head = node;
			this._tail = node;
		}

		this._size++;
	}

	dequeue() {
		const current = this._head;
		if (!current) {
			return;
		}

		this._head = this._head.next;
		this._size--;
		return current.value;
	}

	clear() {
		this._head = undefined;
		this._tail = undefined;
		this._size = 0;
	}

	get size() {
		return this._size;
	}

	* [Symbol.iterator]() {
		let current = this._head;

		while (current) {
			yield current.value;
			current = current.next;
		}
	}
}

module.exports = Queue;


/***/ }),

/***/ "./node_modules/ajv/dist/ajv.js":
/***/ ((module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;
const core_1 = __webpack_require__("./node_modules/ajv/dist/core.js");
const draft7_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/draft7.js");
const discriminator_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/discriminator/index.js");
const draft7MetaSchema = __webpack_require__("./node_modules/ajv/dist/refs/json-schema-draft-07.json");
const META_SUPPORT_DATA = ["/properties"];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends core_1.default {
    _addVocabularies() {
        super._addVocabularies();
        draft7_1.default.forEach((v) => this.addVocabulary(v));
        if (this.opts.discriminator)
            this.addKeyword(discriminator_1.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta)
            return;
        const metaSchema = this.opts.$data
            ? this.$dataMetaSchema(draft7MetaSchema, META_SUPPORT_DATA)
            : draft7MetaSchema;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return (this.opts.defaultMeta =
            super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined));
    }
}
module.exports = exports = Ajv;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = Ajv;
var validate_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/index.js");
Object.defineProperty(exports, "KeywordCxt", ({ enumerable: true, get: function () { return validate_1.KeywordCxt; } }));
var codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
Object.defineProperty(exports, "_", ({ enumerable: true, get: function () { return codegen_1._; } }));
Object.defineProperty(exports, "str", ({ enumerable: true, get: function () { return codegen_1.str; } }));
Object.defineProperty(exports, "stringify", ({ enumerable: true, get: function () { return codegen_1.stringify; } }));
Object.defineProperty(exports, "nil", ({ enumerable: true, get: function () { return codegen_1.nil; } }));
Object.defineProperty(exports, "Name", ({ enumerable: true, get: function () { return codegen_1.Name; } }));
Object.defineProperty(exports, "CodeGen", ({ enumerable: true, get: function () { return codegen_1.CodeGen; } }));
var validation_error_1 = __webpack_require__("./node_modules/ajv/dist/runtime/validation_error.js");
Object.defineProperty(exports, "ValidationError", ({ enumerable: true, get: function () { return validation_error_1.default; } }));
var ref_error_1 = __webpack_require__("./node_modules/ajv/dist/compile/ref_error.js");
Object.defineProperty(exports, "MissingRefError", ({ enumerable: true, get: function () { return ref_error_1.default; } }));
//# sourceMappingURL=ajv.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/codegen/code.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.regexpCode = exports.getEsmExportName = exports.getProperty = exports.safeStringify = exports.stringify = exports.strConcat = exports.addCodeArg = exports.str = exports._ = exports.nil = exports._Code = exports.Name = exports.IDENTIFIER = exports._CodeOrName = void 0;
class _CodeOrName {
}
exports._CodeOrName = _CodeOrName;
exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class Name extends _CodeOrName {
    constructor(s) {
        super();
        if (!exports.IDENTIFIER.test(s))
            throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return { [this.str]: 1 };
    }
}
exports.Name = Name;
class _Code extends _CodeOrName {
    constructor(code) {
        super();
        this._items = typeof code === "string" ? [code] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1)
            return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return ((_a = this._str) !== null && _a !== void 0 ? _a : (this._str = this._items.reduce((s, c) => `${s}${c}`, "")));
    }
    get names() {
        var _a;
        return ((_a = this._names) !== null && _a !== void 0 ? _a : (this._names = this._items.reduce((names, c) => {
            if (c instanceof Name)
                names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {})));
    }
}
exports._Code = _Code;
exports.nil = new _Code("");
function _(strs, ...args) {
    const code = [strs[0]];
    let i = 0;
    while (i < args.length) {
        addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new _Code(code);
}
exports._ = _;
const plus = new _Code("+");
function str(strs, ...args) {
    const expr = [safeStringify(strs[0])];
    let i = 0;
    while (i < args.length) {
        expr.push(plus);
        addCodeArg(expr, args[i]);
        expr.push(plus, safeStringify(strs[++i]));
    }
    optimize(expr);
    return new _Code(expr);
}
exports.str = str;
function addCodeArg(code, arg) {
    if (arg instanceof _Code)
        code.push(...arg._items);
    else if (arg instanceof Name)
        code.push(arg);
    else
        code.push(interpolate(arg));
}
exports.addCodeArg = addCodeArg;
function optimize(expr) {
    let i = 1;
    while (i < expr.length - 1) {
        if (expr[i] === plus) {
            const res = mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function mergeExprItems(a, b) {
    if (b === '""')
        return a;
    if (a === '""')
        return b;
    if (typeof a == "string") {
        if (b instanceof Name || a[a.length - 1] !== '"')
            return;
        if (typeof b != "string")
            return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"')
            return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof Name))
        return `"${a}${b.slice(1)}`;
    return;
}
function strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : str `${c1}${c2}`;
}
exports.strConcat = strConcat;
// TODO do not allow arrays here
function interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null
        ? x
        : safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function stringify(x) {
    return new _Code(safeStringify(x));
}
exports.stringify = stringify;
function safeStringify(x) {
    return JSON.stringify(x)
        .replace(/\u2028/g, "\\u2028")
        .replace(/\u2029/g, "\\u2029");
}
exports.safeStringify = safeStringify;
function getProperty(key) {
    return typeof key == "string" && exports.IDENTIFIER.test(key) ? new _Code(`.${key}`) : _ `[${key}]`;
}
exports.getProperty = getProperty;
//Does best effort to format the name properly
function getEsmExportName(key) {
    if (typeof key == "string" && exports.IDENTIFIER.test(key)) {
        return new _Code(`${key}`);
    }
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
exports.getEsmExportName = getEsmExportName;
function regexpCode(rx) {
    return new _Code(rx.toString());
}
exports.regexpCode = regexpCode;
//# sourceMappingURL=code.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/codegen/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.or = exports.and = exports.not = exports.CodeGen = exports.operators = exports.varKinds = exports.ValueScopeName = exports.ValueScope = exports.Scope = exports.Name = exports.regexpCode = exports.stringify = exports.getProperty = exports.nil = exports.strConcat = exports.str = exports._ = void 0;
const code_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/code.js");
const scope_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/scope.js");
var code_2 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/code.js");
Object.defineProperty(exports, "_", ({ enumerable: true, get: function () { return code_2._; } }));
Object.defineProperty(exports, "str", ({ enumerable: true, get: function () { return code_2.str; } }));
Object.defineProperty(exports, "strConcat", ({ enumerable: true, get: function () { return code_2.strConcat; } }));
Object.defineProperty(exports, "nil", ({ enumerable: true, get: function () { return code_2.nil; } }));
Object.defineProperty(exports, "getProperty", ({ enumerable: true, get: function () { return code_2.getProperty; } }));
Object.defineProperty(exports, "stringify", ({ enumerable: true, get: function () { return code_2.stringify; } }));
Object.defineProperty(exports, "regexpCode", ({ enumerable: true, get: function () { return code_2.regexpCode; } }));
Object.defineProperty(exports, "Name", ({ enumerable: true, get: function () { return code_2.Name; } }));
var scope_2 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/scope.js");
Object.defineProperty(exports, "Scope", ({ enumerable: true, get: function () { return scope_2.Scope; } }));
Object.defineProperty(exports, "ValueScope", ({ enumerable: true, get: function () { return scope_2.ValueScope; } }));
Object.defineProperty(exports, "ValueScopeName", ({ enumerable: true, get: function () { return scope_2.ValueScopeName; } }));
Object.defineProperty(exports, "varKinds", ({ enumerable: true, get: function () { return scope_2.varKinds; } }));
exports.operators = {
    GT: new code_1._Code(">"),
    GTE: new code_1._Code(">="),
    LT: new code_1._Code("<"),
    LTE: new code_1._Code("<="),
    EQ: new code_1._Code("==="),
    NEQ: new code_1._Code("!=="),
    NOT: new code_1._Code("!"),
    OR: new code_1._Code("||"),
    AND: new code_1._Code("&&"),
    ADD: new code_1._Code("+"),
};
class Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class Def extends Node {
    constructor(varKind, name, rhs) {
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5, _n }) {
        const varKind = es5 ? scope_1.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str])
            return;
        if (this.rhs)
            this.rhs = optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof code_1._CodeOrName ? this.rhs.names : {};
    }
}
class Assign extends Node {
    constructor(lhs, rhs, sideEffects) {
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof code_1.Name && !names[this.lhs.str] && !this.sideEffects)
            return;
        this.rhs = optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof code_1.Name ? {} : { ...this.lhs.names };
        return addExprNames(names, this.rhs);
    }
}
class AssignOp extends Assign {
    constructor(lhs, op, rhs, sideEffects) {
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class Label extends Node {
    constructor(label) {
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n }) {
        return `${this.label}:` + _n;
    }
}
class Break extends Node {
    constructor(label) {
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class Throw extends Node {
    constructor(error) {
        super();
        this.error = error;
    }
    render({ _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class AnyCode extends Node {
    constructor(code) {
        super();
        this.code = code;
    }
    render({ _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof code_1._CodeOrName ? this.code.names : {};
    }
}
class ParentNode extends Node {
    constructor(nodes = []) {
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n) => code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes } = this;
        let i = nodes.length;
        while (i--) {
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n))
                nodes.splice(i, 1, ...n);
            else if (n)
                nodes[i] = n;
            else
                nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes } = this;
        let i = nodes.length;
        while (i--) {
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants))
                continue;
            subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n) => addNames(names, n.names), {});
    }
}
class BlockNode extends ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class Root extends ParentNode {
}
class Else extends BlockNode {
}
Else.kind = "else";
class If extends BlockNode {
    constructor(condition, nodes) {
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else)
            code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true)
            return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new Else(ns) : ns;
        }
        if (e) {
            if (cond === false)
                return e instanceof If ? e : e.nodes;
            if (this.nodes.length)
                return this;
            return new If(not(cond), e instanceof If ? [e] : e.nodes);
        }
        if (cond === false || !this.nodes.length)
            return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else))
            return;
        this.condition = optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        addExprNames(names, this.condition);
        if (this.else)
            addNames(names, this.else.names);
        return names;
    }
}
If.kind = "if";
class For extends BlockNode {
}
For.kind = "for";
class ForLoop extends For {
    constructor(iteration) {
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants))
            return;
        this.iteration = optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return addNames(super.names, this.iteration.names);
    }
}
class ForRange extends For {
    constructor(varKind, name, from, to) {
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? scope_1.varKinds.var : this.varKind;
        const { name, from, to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = addExprNames(super.names, this.from);
        return addExprNames(names, this.to);
    }
}
class ForIter extends For {
    constructor(loop, varKind, name, iterable) {
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants))
            return;
        this.iterable = optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return addNames(super.names, this.iterable.names);
    }
}
class Func extends BlockNode {
    constructor(name, args, async) {
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
Func.kind = "func";
class Return extends ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
Return.kind = "return";
class Try extends BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch)
            code += this.catch.render(opts);
        if (this.finally)
            code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 ? void 0 : _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 ? void 0 : _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 ? void 0 : _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch)
            addNames(names, this.catch.names);
        if (this.finally)
            addNames(names, this.finally.names);
        return names;
    }
}
class Catch extends BlockNode {
    constructor(error) {
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
Catch.kind = "catch";
class Finally extends BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
Finally.kind = "finally";
class CodeGen {
    constructor(extScope, opts = {}) {
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = { ...opts, _n: opts.lines ? "\n" : "" };
        this._extScope = extScope;
        this._scope = new scope_1.Scope({ parent: extScope });
        this._nodes = [new Root()];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant)
            this._constants[name.str] = rhs;
        this._leafNode(new Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def(scope_1.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new AssignOp(lhs, exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function")
            c();
        else if (c !== code_1.nil)
            this._leafNode(new AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = ["{"];
        for (const [key, value] of keyValues) {
            if (code.length > 1)
                code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, code_1.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new code_1._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new If(condition));
        if (thenBody && elseBody) {
            this.code(thenBody).else().code(elseBody).endIf();
        }
        else if (thenBody) {
            this.code(thenBody).endIf();
        }
        else if (elseBody) {
            throw new Error('CodeGen: "else" body without "then" body');
        }
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode(If, Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody)
            this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new ForRange(varKind, name, from, to), () => forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = scope_1.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof code_1.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, code_1._) `${arr}.length`, (i) => {
                this.var(name, (0, code_1._) `${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new ForIter("of", varKind, name, iterable), () => forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.const) {
        if (this.opts.ownProperties) {
            return this.forOf(nameOrPrefix, (0, code_1._) `Object.keys(${obj})`, forBody);
        }
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new ForIter("in", varKind, name, obj), () => forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode(For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new Break(label));
    }
    // `return` statement
    return(value) {
        const node = new Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1)
            throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode(Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode)
            throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode(Catch, Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body)
            this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined)
            throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || (nodeCount !== undefined && toClose !== nodeCount)) {
            throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        }
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = code_1.nil, async, funcBody) {
        this._blockNode(new Func(name, args, async));
        if (funcBody)
            this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode(Func);
    }
    optimize(n = 1) {
        while (n-- > 0) {
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || (N2 && n instanceof N2)) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof If)) {
            throw new Error('CodeGen: "else" without "if"');
        }
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
exports.CodeGen = CodeGen;
function addNames(names, from) {
    for (const n in from)
        names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function addExprNames(names, from) {
    return from instanceof code_1._CodeOrName ? addNames(names, from.names) : names;
}
function optimizeExpr(expr, names, constants) {
    if (expr instanceof code_1.Name)
        return replaceName(expr);
    if (!canOptimize(expr))
        return expr;
    return new code_1._Code(expr._items.reduce((items, c) => {
        if (c instanceof code_1.Name)
            c = replaceName(c);
        if (c instanceof code_1._Code)
            items.push(...c._items);
        else
            items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1)
            return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return (e instanceof code_1._Code &&
            e._items.some((c) => c instanceof code_1.Name && names[c.str] === 1 && constants[c.str] !== undefined));
    }
}
function subtractNames(names, from) {
    for (const n in from)
        names[n] = (names[n] || 0) - (from[n] || 0);
}
function not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, code_1._) `!${par(x)}`;
}
exports.not = not;
const andCode = mappend(exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function and(...args) {
    return args.reduce(andCode);
}
exports.and = and;
const orCode = mappend(exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function or(...args) {
    return args.reduce(orCode);
}
exports.or = or;
function mappend(op) {
    return (x, y) => (x === code_1.nil ? y : y === code_1.nil ? x : (0, code_1._) `${par(x)} ${op} ${par(y)}`);
}
function par(x) {
    return x instanceof code_1.Name ? x : (0, code_1._) `(${x})`;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/codegen/scope.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ValueScope = exports.ValueScopeName = exports.Scope = exports.varKinds = exports.UsedValueState = void 0;
const code_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/code.js");
class ValueError extends Error {
    constructor(name) {
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var UsedValueState;
(function (UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})(UsedValueState = exports.UsedValueState || (exports.UsedValueState = {}));
exports.varKinds = {
    const: new code_1.Name("const"),
    let: new code_1.Name("let"),
    var: new code_1.Name("var"),
};
class Scope {
    constructor({ prefixes, parent } = {}) {
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof code_1.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new code_1.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || (this._prefixes && !this._prefixes.has(prefix))) {
            throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        }
        return (this._names[prefix] = { prefix, index: 0 });
    }
}
exports.Scope = Scope;
class ValueScopeName extends code_1.Name {
    constructor(prefix, nameStr) {
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property, itemIndex }) {
        this.value = value;
        this.scopePath = (0, code_1._) `.${new code_1.Name(property)}[${itemIndex}]`;
    }
}
exports.ValueScopeName = ValueScopeName;
const line = (0, code_1._) `\n`;
class ValueScope extends Scope {
    constructor(opts) {
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = { ...opts, _n: opts.lines ? line : code_1.nil };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined)
            throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name)
                return _name;
        }
        else {
            vs = this._values[prefix] = new Map();
        }
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, { property: prefix, itemIndex });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs)
            return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name) => {
            if (name.scopePath === undefined)
                throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, code_1._) `${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name) => {
            if (name.value === undefined)
                throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = code_1.nil;
        for (const prefix in values) {
            const vs = values[prefix];
            if (!vs)
                continue;
            const nameSet = (usedValues[prefix] = usedValues[prefix] || new Map());
            vs.forEach((name) => {
                if (nameSet.has(name))
                    return;
                nameSet.set(name, UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? exports.varKinds.var : exports.varKinds.const;
                    code = (0, code_1._) `${code}${def} ${name} = ${c};${this.opts._n}`;
                }
                else if ((c = getCode === null || getCode === void 0 ? void 0 : getCode(name))) {
                    code = (0, code_1._) `${code}${c}${this.opts._n}`;
                }
                else {
                    throw new ValueError(name);
                }
                nameSet.set(name, UsedValueState.Completed);
            });
        }
        return code;
    }
}
exports.ValueScope = ValueScope;
//# sourceMappingURL=scope.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/errors.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.extendErrors = exports.resetErrorsCount = exports.reportExtraError = exports.reportError = exports.keyword$DataError = exports.keywordError = void 0;
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const names_1 = __webpack_require__("./node_modules/ajv/dist/compile/names.js");
exports.keywordError = {
    message: ({ keyword }) => (0, codegen_1.str) `must pass "${keyword}" keyword validation`,
};
exports.keyword$DataError = {
    message: ({ keyword, schemaType }) => schemaType
        ? (0, codegen_1.str) `"${keyword}" keyword must be ${schemaType} ($data)`
        : (0, codegen_1.str) `"${keyword}" keyword is invalid ($data)`,
};
function reportError(cxt, error = exports.keywordError, errorPaths, overrideAllErrors) {
    const { it } = cxt;
    const { gen, compositeRule, allErrors } = it;
    const errObj = errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : (compositeRule || allErrors)) {
        addError(gen, errObj);
    }
    else {
        returnErrors(it, (0, codegen_1._) `[${errObj}]`);
    }
}
exports.reportError = reportError;
function reportExtraError(cxt, error = exports.keywordError, errorPaths) {
    const { it } = cxt;
    const { gen, compositeRule, allErrors } = it;
    const errObj = errorObjectCode(cxt, error, errorPaths);
    addError(gen, errObj);
    if (!(compositeRule || allErrors)) {
        returnErrors(it, names_1.default.vErrors);
    }
}
exports.reportExtraError = reportExtraError;
function resetErrorsCount(gen, errsCount) {
    gen.assign(names_1.default.errors, errsCount);
    gen.if((0, codegen_1._) `${names_1.default.vErrors} !== null`, () => gen.if(errsCount, () => gen.assign((0, codegen_1._) `${names_1.default.vErrors}.length`, errsCount), () => gen.assign(names_1.default.vErrors, null)));
}
exports.resetErrorsCount = resetErrorsCount;
function extendErrors({ gen, keyword, schemaValue, data, errsCount, it, }) {
    /* istanbul ignore if */
    if (errsCount === undefined)
        throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, names_1.default.errors, (i) => {
        gen.const(err, (0, codegen_1._) `${names_1.default.vErrors}[${i}]`);
        gen.if((0, codegen_1._) `${err}.instancePath === undefined`, () => gen.assign((0, codegen_1._) `${err}.instancePath`, (0, codegen_1.strConcat)(names_1.default.instancePath, it.errorPath)));
        gen.assign((0, codegen_1._) `${err}.schemaPath`, (0, codegen_1.str) `${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, codegen_1._) `${err}.schema`, schemaValue);
            gen.assign((0, codegen_1._) `${err}.data`, data);
        }
    });
}
exports.extendErrors = extendErrors;
function addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, codegen_1._) `${names_1.default.vErrors} === null`, () => gen.assign(names_1.default.vErrors, (0, codegen_1._) `[${err}]`), (0, codegen_1._) `${names_1.default.vErrors}.push(${err})`);
    gen.code((0, codegen_1._) `${names_1.default.errors}++`);
}
function returnErrors(it, errs) {
    const { gen, validateName, schemaEnv } = it;
    if (schemaEnv.$async) {
        gen.throw((0, codegen_1._) `new ${it.ValidationError}(${errs})`);
    }
    else {
        gen.assign((0, codegen_1._) `${validateName}.errors`, errs);
        gen.return(false);
    }
}
const E = {
    keyword: new codegen_1.Name("keyword"),
    schemaPath: new codegen_1.Name("schemaPath"),
    params: new codegen_1.Name("params"),
    propertyName: new codegen_1.Name("propertyName"),
    message: new codegen_1.Name("message"),
    schema: new codegen_1.Name("schema"),
    parentSchema: new codegen_1.Name("parentSchema"),
};
function errorObjectCode(cxt, error, errorPaths) {
    const { createErrors } = cxt.it;
    if (createErrors === false)
        return (0, codegen_1._) `{}`;
    return errorObject(cxt, error, errorPaths);
}
function errorObject(cxt, error, errorPaths = {}) {
    const { gen, it } = cxt;
    const keyValues = [
        errorInstancePath(it, errorPaths),
        errorSchemaPath(cxt, errorPaths),
    ];
    extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function errorInstancePath({ errorPath }, { instancePath }) {
    const instPath = instancePath
        ? (0, codegen_1.str) `${errorPath}${(0, util_1.getErrorPath)(instancePath, util_1.Type.Str)}`
        : errorPath;
    return [names_1.default.instancePath, (0, codegen_1.strConcat)(names_1.default.instancePath, instPath)];
}
function errorSchemaPath({ keyword, it: { errSchemaPath } }, { schemaPath, parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, codegen_1.str) `${errSchemaPath}/${keyword}`;
    if (schemaPath) {
        schPath = (0, codegen_1.str) `${schPath}${(0, util_1.getErrorPath)(schemaPath, util_1.Type.Str)}`;
    }
    return [E.schemaPath, schPath];
}
function extraErrorProps(cxt, { params, message }, keyValues) {
    const { keyword, data, schemaValue, it } = cxt;
    const { opts, propertyName, topSchemaRef, schemaPath } = it;
    keyValues.push([E.keyword, keyword], [E.params, typeof params == "function" ? params(cxt) : params || (0, codegen_1._) `{}`]);
    if (opts.messages) {
        keyValues.push([E.message, typeof message == "function" ? message(cxt) : message]);
    }
    if (opts.verbose) {
        keyValues.push([E.schema, schemaValue], [E.parentSchema, (0, codegen_1._) `${topSchemaRef}${schemaPath}`], [names_1.default.data, data]);
    }
    if (propertyName)
        keyValues.push([E.propertyName, propertyName]);
}
//# sourceMappingURL=errors.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.resolveSchema = exports.getCompilingSchema = exports.resolveRef = exports.compileSchema = exports.SchemaEnv = void 0;
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const validation_error_1 = __webpack_require__("./node_modules/ajv/dist/runtime/validation_error.js");
const names_1 = __webpack_require__("./node_modules/ajv/dist/compile/names.js");
const resolve_1 = __webpack_require__("./node_modules/ajv/dist/compile/resolve.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const validate_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/index.js");
class SchemaEnv {
    constructor(env) {
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object")
            schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, resolve_1.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
exports.SchemaEnv = SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = getCompilingSchema.call(this, sch);
    if (_sch)
        return _sch;
    const rootId = (0, resolve_1.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5, lines } = this.opts.code;
    const { ownProperties } = this.opts;
    const gen = new codegen_1.CodeGen(this.scope, { es5, lines, ownProperties });
    let _ValidationError;
    if (sch.$async) {
        _ValidationError = gen.scopeValue("Error", {
            ref: validation_error_1.default,
            code: (0, codegen_1._) `require("ajv/dist/runtime/validation_error").default`,
        });
    }
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen,
        allErrors: this.opts.allErrors,
        data: names_1.default.data,
        parentData: names_1.default.parentData,
        parentDataProperty: names_1.default.parentDataProperty,
        dataNames: [names_1.default.data],
        dataPathArr: [codegen_1.nil],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true
            ? { ref: sch.schema, code: (0, codegen_1.stringify)(sch.schema) }
            : { ref: sch.schema }),
        validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId,
        baseId: sch.baseId || rootId,
        schemaPath: codegen_1.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, codegen_1._) `""`,
        opts: this.opts,
        self: this,
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, validate_1.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs(names_1.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process)
            sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${names_1.default.self}`, `${names_1.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, { ref: validate });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async)
            validate.$async = true;
        if (this.opts.code.source === true) {
            validate.source = { validateName, validateCode, scopeValues: gen._values };
        }
        if (this.opts.unevaluated) {
            const { props, items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof codegen_1.Name ? undefined : props,
                items: items instanceof codegen_1.Name ? undefined : items,
                dynamicProps: props instanceof codegen_1.Name,
                dynamicItems: items instanceof codegen_1.Name,
            };
            if (validate.source)
                validate.source.evaluated = (0, codegen_1.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    }
    catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode)
            this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    }
    finally {
        this._compilations.delete(sch);
    }
}
exports.compileSchema = compileSchema;
function resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc)
        return schOrFunc;
    let _sch = resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId } = this.opts;
        if (schema)
            _sch = new SchemaEnv({ schema, schemaId, root, baseId });
    }
    if (_sch === undefined)
        return;
    return (root.refs[ref] = inlineOrCompile.call(this, _sch));
}
exports.resolveRef = resolveRef;
function inlineOrCompile(sch) {
    if ((0, resolve_1.inlineRef)(sch.schema, this.opts.inlineRefs))
        return sch.schema;
    return sch.validate ? sch : compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function getCompilingSchema(schEnv) {
    for (const sch of this._compilations) {
        if (sameSchemaEnv(sch, schEnv))
            return sch;
    }
}
exports.getCompilingSchema = getCompilingSchema;
function sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function resolve(root, // information about the root schema for the current schema
ref // reference to resolve
) {
    let sch;
    while (typeof (sch = this.refs[ref]) == "string")
        ref = sch;
    return sch || this.schemas[ref] || resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function resolveSchema(root, // root object with properties schema, refs TODO below SchemaEnv is assigned to it
ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, resolve_1._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, resolve_1.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) {
        return getJsonPointer.call(this, p, root);
    }
    const id = (0, resolve_1.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object")
            return;
        return getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object")
        return;
    if (!schOrRef.validate)
        compileSchema.call(this, schOrRef);
    if (id === (0, resolve_1.normalizeId)(ref)) {
        const { schema } = schOrRef;
        const { schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId)
            baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new SchemaEnv({ schema, schemaId, root, baseId });
    }
    return getJsonPointer.call(this, p, schOrRef);
}
exports.resolveSchema = resolveSchema;
const PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions",
]);
function getJsonPointer(parsedRef, { baseId, schema, root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/")
        return;
    for (const part of parsedRef.fragment.slice(1).split("/")) {
        if (typeof schema === "boolean")
            return;
        const partSchema = schema[(0, util_1.unescapeFragment)(part)];
        if (partSchema === undefined)
            return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!PREVENT_SCOPE_CHANGE.has(part) && schId) {
            baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
        }
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, util_1.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId } = this.opts;
    env = env || new SchemaEnv({ schema, schemaId, root, baseId });
    if (env.schema !== env.root.schema)
        return env;
    return undefined;
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/names.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const names = {
    // validation function arguments
    data: new codegen_1.Name("data"),
    // args passed from referencing schema
    valCxt: new codegen_1.Name("valCxt"),
    instancePath: new codegen_1.Name("instancePath"),
    parentData: new codegen_1.Name("parentData"),
    parentDataProperty: new codegen_1.Name("parentDataProperty"),
    rootData: new codegen_1.Name("rootData"),
    dynamicAnchors: new codegen_1.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new codegen_1.Name("vErrors"),
    errors: new codegen_1.Name("errors"),
    this: new codegen_1.Name("this"),
    // "globals"
    self: new codegen_1.Name("self"),
    scope: new codegen_1.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new codegen_1.Name("json"),
    jsonPos: new codegen_1.Name("jsonPos"),
    jsonLen: new codegen_1.Name("jsonLen"),
    jsonPart: new codegen_1.Name("jsonPart"),
};
exports["default"] = names;
//# sourceMappingURL=names.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/ref_error.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const resolve_1 = __webpack_require__("./node_modules/ajv/dist/compile/resolve.js");
class MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg) {
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, resolve_1.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, resolve_1.normalizeId)((0, resolve_1.getFullPath)(resolver, this.missingRef));
    }
}
exports["default"] = MissingRefError;
//# sourceMappingURL=ref_error.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/resolve.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSchemaRefs = exports.resolveUrl = exports.normalizeId = exports._getFullPath = exports.getFullPath = exports.inlineRef = void 0;
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const equal = __webpack_require__("../../node_modules/fast-deep-equal/index.js");
const traverse = __webpack_require__("./node_modules/json-schema-traverse/index.js");
// TODO refactor to use keyword definitions
const SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const",
]);
function inlineRef(schema, limit = true) {
    if (typeof schema == "boolean")
        return true;
    if (limit === true)
        return !hasRef(schema);
    if (!limit)
        return false;
    return countKeys(schema) <= limit;
}
exports.inlineRef = inlineRef;
const REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor",
]);
function hasRef(schema) {
    for (const key in schema) {
        if (REF_KEYWORDS.has(key))
            return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some(hasRef))
            return true;
        if (typeof sch == "object" && hasRef(sch))
            return true;
    }
    return false;
}
function countKeys(schema) {
    let count = 0;
    for (const key in schema) {
        if (key === "$ref")
            return Infinity;
        count++;
        if (SIMPLE_INLINED.has(key))
            continue;
        if (typeof schema[key] == "object") {
            (0, util_1.eachItem)(schema[key], (sch) => (count += countKeys(sch)));
        }
        if (count === Infinity)
            return Infinity;
    }
    return count;
}
function getFullPath(resolver, id = "", normalize) {
    if (normalize !== false)
        id = normalizeId(id);
    const p = resolver.parse(id);
    return _getFullPath(resolver, p);
}
exports.getFullPath = getFullPath;
function _getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
exports._getFullPath = _getFullPath;
const TRAILING_SLASH_HASH = /#\/?$/;
function normalizeId(id) {
    return id ? id.replace(TRAILING_SLASH_HASH, "") : "";
}
exports.normalizeId = normalizeId;
function resolveUrl(resolver, baseId, id) {
    id = normalizeId(id);
    return resolver.resolve(baseId, id);
}
exports.resolveUrl = resolveUrl;
const ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean")
        return {};
    const { schemaId, uriResolver } = this.opts;
    const schId = normalizeId(schema[schemaId] || baseId);
    const baseIds = { "": schId };
    const pathPrefix = getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    traverse(schema, { allKeys: true }, (sch, jsonPtr, _, parentJsonPtr) => {
        if (parentJsonPtr === undefined)
            return;
        const fullPath = pathPrefix + jsonPtr;
        let baseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string")
            baseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = baseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = normalizeId(baseId ? _resolve(baseId, ref) : ref);
            if (schemaRefs.has(ref))
                throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string")
                schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") {
                checkAmbiguosRef(sch, schOrRef.schema, ref);
            }
            else if (ref !== normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                }
                else {
                    this.refs[ref] = fullPath;
                }
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!ANCHOR.test(anchor))
                    throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !equal(sch1, sch2))
            throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
exports.getSchemaRefs = getSchemaRefs;
//# sourceMappingURL=resolve.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/rules.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRules = exports.isJSONType = void 0;
const _jsonTypes = ["string", "number", "integer", "boolean", "null", "object", "array"];
const jsonTypes = new Set(_jsonTypes);
function isJSONType(x) {
    return typeof x == "string" && jsonTypes.has(x);
}
exports.isJSONType = isJSONType;
function getRules() {
    const groups = {
        number: { type: "number", rules: [] },
        string: { type: "string", rules: [] },
        array: { type: "array", rules: [] },
        object: { type: "object", rules: [] },
    };
    return {
        types: { ...groups, integer: true, boolean: true, null: true },
        rules: [{ rules: [] }, groups.number, groups.string, groups.array, groups.object],
        post: { rules: [] },
        all: {},
        keywords: {},
    };
}
exports.getRules = getRules;
//# sourceMappingURL=rules.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/util.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.checkStrictMode = exports.getErrorPath = exports.Type = exports.useFunc = exports.setEvaluated = exports.evaluatedPropsToName = exports.mergeEvaluated = exports.eachItem = exports.unescapeJsonPointer = exports.escapeJsonPointer = exports.escapeFragment = exports.unescapeFragment = exports.schemaRefOrVal = exports.schemaHasRulesButRef = exports.schemaHasRules = exports.checkUnknownRules = exports.alwaysValidSchema = exports.toHash = void 0;
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const code_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/code.js");
// TODO refactor to use Set
function toHash(arr) {
    const hash = {};
    for (const item of arr)
        hash[item] = true;
    return hash;
}
exports.toHash = toHash;
function alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean")
        return schema;
    if (Object.keys(schema).length === 0)
        return true;
    checkUnknownRules(it, schema);
    return !schemaHasRules(schema, it.self.RULES.all);
}
exports.alwaysValidSchema = alwaysValidSchema;
function checkUnknownRules(it, schema = it.schema) {
    const { opts, self } = it;
    if (!opts.strictSchema)
        return;
    if (typeof schema === "boolean")
        return;
    const rules = self.RULES.keywords;
    for (const key in schema) {
        if (!rules[key])
            checkStrictMode(it, `unknown keyword: "${key}"`);
    }
}
exports.checkUnknownRules = checkUnknownRules;
function schemaHasRules(schema, rules) {
    if (typeof schema == "boolean")
        return !schema;
    for (const key in schema)
        if (rules[key])
            return true;
    return false;
}
exports.schemaHasRules = schemaHasRules;
function schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean")
        return !schema;
    for (const key in schema)
        if (key !== "$ref" && RULES.all[key])
            return true;
    return false;
}
exports.schemaHasRulesButRef = schemaHasRulesButRef;
function schemaRefOrVal({ topSchemaRef, schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean")
            return schema;
        if (typeof schema == "string")
            return (0, codegen_1._) `${schema}`;
    }
    return (0, codegen_1._) `${topSchemaRef}${schemaPath}${(0, codegen_1.getProperty)(keyword)}`;
}
exports.schemaRefOrVal = schemaRefOrVal;
function unescapeFragment(str) {
    return unescapeJsonPointer(decodeURIComponent(str));
}
exports.unescapeFragment = unescapeFragment;
function escapeFragment(str) {
    return encodeURIComponent(escapeJsonPointer(str));
}
exports.escapeFragment = escapeFragment;
function escapeJsonPointer(str) {
    if (typeof str == "number")
        return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
exports.escapeJsonPointer = escapeJsonPointer;
function unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
exports.unescapeJsonPointer = unescapeJsonPointer;
function eachItem(xs, f) {
    if (Array.isArray(xs)) {
        for (const x of xs)
            f(x);
    }
    else {
        f(xs);
    }
}
exports.eachItem = eachItem;
function makeMergeEvaluated({ mergeNames, mergeToName, mergeValues, resultToName, }) {
    return (gen, from, to, toName) => {
        const res = to === undefined
            ? from
            : to instanceof codegen_1.Name
                ? (from instanceof codegen_1.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to)
                : from instanceof codegen_1.Name
                    ? (mergeToName(gen, to, from), from)
                    : mergeValues(from, to);
        return toName === codegen_1.Name && !(res instanceof codegen_1.Name) ? resultToName(gen, res) : res;
    };
}
exports.mergeEvaluated = {
    props: makeMergeEvaluated({
        mergeNames: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true && ${from} !== undefined`, () => {
            gen.if((0, codegen_1._) `${from} === true`, () => gen.assign(to, true), () => gen.assign(to, (0, codegen_1._) `${to} || {}`).code((0, codegen_1._) `Object.assign(${to}, ${from})`));
        }),
        mergeToName: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true`, () => {
            if (from === true) {
                gen.assign(to, true);
            }
            else {
                gen.assign(to, (0, codegen_1._) `${to} || {}`);
                setEvaluated(gen, to, from);
            }
        }),
        mergeValues: (from, to) => (from === true ? true : { ...from, ...to }),
        resultToName: evaluatedPropsToName,
    }),
    items: makeMergeEvaluated({
        mergeNames: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true && ${from} !== undefined`, () => gen.assign(to, (0, codegen_1._) `${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true`, () => gen.assign(to, from === true ? true : (0, codegen_1._) `${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to) => (from === true ? true : Math.max(from, to)),
        resultToName: (gen, items) => gen.var("items", items),
    }),
};
function evaluatedPropsToName(gen, ps) {
    if (ps === true)
        return gen.var("props", true);
    const props = gen.var("props", (0, codegen_1._) `{}`);
    if (ps !== undefined)
        setEvaluated(gen, props, ps);
    return props;
}
exports.evaluatedPropsToName = evaluatedPropsToName;
function setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p) => gen.assign((0, codegen_1._) `${props}${(0, codegen_1.getProperty)(p)}`, true));
}
exports.setEvaluated = setEvaluated;
const snippets = {};
function useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: snippets[f.code] || (snippets[f.code] = new code_1._Code(f.code)),
    });
}
exports.useFunc = useFunc;
var Type;
(function (Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})(Type = exports.Type || (exports.Type = {}));
function getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof codegen_1.Name) {
        const isNumber = dataPropType === Type.Num;
        return jsPropertySyntax
            ? isNumber
                ? (0, codegen_1._) `"[" + ${dataProp} + "]"`
                : (0, codegen_1._) `"['" + ${dataProp} + "']"`
            : isNumber
                ? (0, codegen_1._) `"/" + ${dataProp}`
                : (0, codegen_1._) `"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, codegen_1.getProperty)(dataProp).toString() : "/" + escapeJsonPointer(dataProp);
}
exports.getErrorPath = getErrorPath;
function checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode)
        return;
    msg = `strict mode: ${msg}`;
    if (mode === true)
        throw new Error(msg);
    it.self.logger.warn(msg);
}
exports.checkStrictMode = checkStrictMode;
//# sourceMappingURL=util.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/validate/applicability.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.shouldUseRule = exports.shouldUseGroup = exports.schemaHasRulesForType = void 0;
function schemaHasRulesForType({ schema, self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && shouldUseGroup(schema, group);
}
exports.schemaHasRulesForType = schemaHasRulesForType;
function shouldUseGroup(schema, group) {
    return group.rules.some((rule) => shouldUseRule(schema, rule));
}
exports.shouldUseGroup = shouldUseGroup;
function shouldUseRule(schema, rule) {
    var _a;
    return (schema[rule.keyword] !== undefined ||
        ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd) => schema[kwd] !== undefined)));
}
exports.shouldUseRule = shouldUseRule;
//# sourceMappingURL=applicability.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/validate/boolSchema.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.boolOrEmptySchema = exports.topBoolOrEmptySchema = void 0;
const errors_1 = __webpack_require__("./node_modules/ajv/dist/compile/errors.js");
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const names_1 = __webpack_require__("./node_modules/ajv/dist/compile/names.js");
const boolError = {
    message: "boolean schema is false",
};
function topBoolOrEmptySchema(it) {
    const { gen, schema, validateName } = it;
    if (schema === false) {
        falseSchemaError(it, false);
    }
    else if (typeof schema == "object" && schema.$async === true) {
        gen.return(names_1.default.data);
    }
    else {
        gen.assign((0, codegen_1._) `${validateName}.errors`, null);
        gen.return(true);
    }
}
exports.topBoolOrEmptySchema = topBoolOrEmptySchema;
function boolOrEmptySchema(it, valid) {
    const { gen, schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        falseSchemaError(it);
    }
    else {
        gen.var(valid, true); // TODO var
    }
}
exports.boolOrEmptySchema = boolOrEmptySchema;
function falseSchemaError(it, overrideAllErrors) {
    const { gen, data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen,
        keyword: "false schema",
        data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it,
    };
    (0, errors_1.reportError)(cxt, boolError, undefined, overrideAllErrors);
}
//# sourceMappingURL=boolSchema.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/validate/dataType.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.reportTypeError = exports.checkDataTypes = exports.checkDataType = exports.coerceAndCheckDataType = exports.getJSONTypes = exports.getSchemaTypes = exports.DataType = void 0;
const rules_1 = __webpack_require__("./node_modules/ajv/dist/compile/rules.js");
const applicability_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/applicability.js");
const errors_1 = __webpack_require__("./node_modules/ajv/dist/compile/errors.js");
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
var DataType;
(function (DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})(DataType = exports.DataType || (exports.DataType = {}));
function getSchemaTypes(schema) {
    const types = getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false)
            throw new Error("type: null contradicts nullable: false");
    }
    else {
        if (!types.length && schema.nullable !== undefined) {
            throw new Error('"nullable" cannot be used without "type"');
        }
        if (schema.nullable === true)
            types.push("null");
    }
    return types;
}
exports.getSchemaTypes = getSchemaTypes;
function getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [ts] : [];
    if (types.every(rules_1.isJSONType))
        return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
exports.getJSONTypes = getJSONTypes;
function coerceAndCheckDataType(it, types) {
    const { gen, data, opts } = it;
    const coerceTo = coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 &&
        !(coerceTo.length === 0 && types.length === 1 && (0, applicability_1.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = checkDataTypes(types, data, opts.strictNumbers, DataType.Wrong);
        gen.if(wrongType, () => {
            if (coerceTo.length)
                coerceData(it, types, coerceTo);
            else
                reportTypeError(it);
        });
    }
    return checkTypes;
}
exports.coerceAndCheckDataType = coerceAndCheckDataType;
const COERCIBLE = new Set(["string", "number", "integer", "boolean", "null"]);
function coerceToTypes(types, coerceTypes) {
    return coerceTypes
        ? types.filter((t) => COERCIBLE.has(t) || (coerceTypes === "array" && t === "array"))
        : [];
}
function coerceData(it, types, coerceTo) {
    const { gen, data, opts } = it;
    const dataType = gen.let("dataType", (0, codegen_1._) `typeof ${data}`);
    const coerced = gen.let("coerced", (0, codegen_1._) `undefined`);
    if (opts.coerceTypes === "array") {
        gen.if((0, codegen_1._) `${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, () => gen
            .assign(data, (0, codegen_1._) `${data}[0]`)
            .assign(dataType, (0, codegen_1._) `typeof ${data}`)
            .if(checkDataTypes(types, data, opts.strictNumbers), () => gen.assign(coerced, data)));
    }
    gen.if((0, codegen_1._) `${coerced} !== undefined`);
    for (const t of coerceTo) {
        if (COERCIBLE.has(t) || (t === "array" && opts.coerceTypes === "array")) {
            coerceSpecificType(t);
        }
    }
    gen.else();
    reportTypeError(it);
    gen.endIf();
    gen.if((0, codegen_1._) `${coerced} !== undefined`, () => {
        gen.assign(data, coerced);
        assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch (t) {
            case "string":
                gen
                    .elseIf((0, codegen_1._) `${dataType} == "number" || ${dataType} == "boolean"`)
                    .assign(coerced, (0, codegen_1._) `"" + ${data}`)
                    .elseIf((0, codegen_1._) `${data} === null`)
                    .assign(coerced, (0, codegen_1._) `""`);
                return;
            case "number":
                gen
                    .elseIf((0, codegen_1._) `${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`)
                    .assign(coerced, (0, codegen_1._) `+${data}`);
                return;
            case "integer":
                gen
                    .elseIf((0, codegen_1._) `${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`)
                    .assign(coerced, (0, codegen_1._) `+${data}`);
                return;
            case "boolean":
                gen
                    .elseIf((0, codegen_1._) `${data} === "false" || ${data} === 0 || ${data} === null`)
                    .assign(coerced, false)
                    .elseIf((0, codegen_1._) `${data} === "true" || ${data} === 1`)
                    .assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, codegen_1._) `${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen
                    .elseIf((0, codegen_1._) `${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`)
                    .assign(coerced, (0, codegen_1._) `[${data}]`);
        }
    }
}
function assignParentData({ gen, parentData, parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, codegen_1._) `${parentData} !== undefined`, () => gen.assign((0, codegen_1._) `${parentData}[${parentDataProperty}]`, expr));
}
function checkDataType(dataType, data, strictNums, correct = DataType.Correct) {
    const EQ = correct === DataType.Correct ? codegen_1.operators.EQ : codegen_1.operators.NEQ;
    let cond;
    switch (dataType) {
        case "null":
            return (0, codegen_1._) `${data} ${EQ} null`;
        case "array":
            cond = (0, codegen_1._) `Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, codegen_1._) `${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, codegen_1._) `!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, codegen_1._) `typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === DataType.Correct ? cond : (0, codegen_1.not)(cond);
    function numCond(_cond = codegen_1.nil) {
        return (0, codegen_1.and)((0, codegen_1._) `typeof ${data} == "number"`, _cond, strictNums ? (0, codegen_1._) `isFinite(${data})` : codegen_1.nil);
    }
}
exports.checkDataType = checkDataType;
function checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) {
        return checkDataType(dataTypes[0], data, strictNums, correct);
    }
    let cond;
    const types = (0, util_1.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, codegen_1._) `typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, codegen_1._) `!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    }
    else {
        cond = codegen_1.nil;
    }
    if (types.number)
        delete types.integer;
    for (const t in types)
        cond = (0, codegen_1.and)(cond, checkDataType(t, data, strictNums, correct));
    return cond;
}
exports.checkDataTypes = checkDataTypes;
const typeError = {
    message: ({ schema }) => `must be ${schema}`,
    params: ({ schema, schemaValue }) => typeof schema == "string" ? (0, codegen_1._) `{type: ${schema}}` : (0, codegen_1._) `{type: ${schemaValue}}`,
};
function reportTypeError(it) {
    const cxt = getTypeErrorContext(it);
    (0, errors_1.reportError)(cxt, typeError);
}
exports.reportTypeError = reportTypeError;
function getTypeErrorContext(it) {
    const { gen, data, schema } = it;
    const schemaCode = (0, util_1.schemaRefOrVal)(it, schema, "type");
    return {
        gen,
        keyword: "type",
        data,
        schema: schema.type,
        schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it,
    };
}
//# sourceMappingURL=dataType.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/validate/defaults.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.assignDefaults = void 0;
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
function assignDefaults(it, ty) {
    const { properties, items } = it.schema;
    if (ty === "object" && properties) {
        for (const key in properties) {
            assignDefault(it, key, properties[key].default);
        }
    }
    else if (ty === "array" && Array.isArray(items)) {
        items.forEach((sch, i) => assignDefault(it, i, sch.default));
    }
}
exports.assignDefaults = assignDefaults;
function assignDefault(it, prop, defaultValue) {
    const { gen, compositeRule, data, opts } = it;
    if (defaultValue === undefined)
        return;
    const childData = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(prop)}`;
    if (compositeRule) {
        (0, util_1.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, codegen_1._) `${childData} === undefined`;
    if (opts.useDefaults === "empty") {
        condition = (0, codegen_1._) `${condition} || ${childData} === null || ${childData} === ""`;
    }
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, codegen_1._) `${childData} = ${(0, codegen_1.stringify)(defaultValue)}`);
}
//# sourceMappingURL=defaults.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/validate/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getData = exports.KeywordCxt = exports.validateFunctionCode = void 0;
const boolSchema_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/boolSchema.js");
const dataType_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/dataType.js");
const applicability_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/applicability.js");
const dataType_2 = __webpack_require__("./node_modules/ajv/dist/compile/validate/dataType.js");
const defaults_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/defaults.js");
const keyword_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/keyword.js");
const subschema_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/subschema.js");
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const names_1 = __webpack_require__("./node_modules/ajv/dist/compile/names.js");
const resolve_1 = __webpack_require__("./node_modules/ajv/dist/compile/resolve.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const errors_1 = __webpack_require__("./node_modules/ajv/dist/compile/errors.js");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function validateFunctionCode(it) {
    if (isSchemaObj(it)) {
        checkKeywords(it);
        if (schemaCxtHasRules(it)) {
            topSchemaObjCode(it);
            return;
        }
    }
    validateFunction(it, () => (0, boolSchema_1.topBoolOrEmptySchema)(it));
}
exports.validateFunctionCode = validateFunctionCode;
function validateFunction({ gen, validateName, schema, schemaEnv, opts }, body) {
    if (opts.code.es5) {
        gen.func(validateName, (0, codegen_1._) `${names_1.default.data}, ${names_1.default.valCxt}`, schemaEnv.$async, () => {
            gen.code((0, codegen_1._) `"use strict"; ${funcSourceUrl(schema, opts)}`);
            destructureValCxtES5(gen, opts);
            gen.code(body);
        });
    }
    else {
        gen.func(validateName, (0, codegen_1._) `${names_1.default.data}, ${destructureValCxt(opts)}`, schemaEnv.$async, () => gen.code(funcSourceUrl(schema, opts)).code(body));
    }
}
function destructureValCxt(opts) {
    return (0, codegen_1._) `{${names_1.default.instancePath}="", ${names_1.default.parentData}, ${names_1.default.parentDataProperty}, ${names_1.default.rootData}=${names_1.default.data}${opts.dynamicRef ? (0, codegen_1._) `, ${names_1.default.dynamicAnchors}={}` : codegen_1.nil}}={}`;
}
function destructureValCxtES5(gen, opts) {
    gen.if(names_1.default.valCxt, () => {
        gen.var(names_1.default.instancePath, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.instancePath}`);
        gen.var(names_1.default.parentData, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.parentData}`);
        gen.var(names_1.default.parentDataProperty, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.parentDataProperty}`);
        gen.var(names_1.default.rootData, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.rootData}`);
        if (opts.dynamicRef)
            gen.var(names_1.default.dynamicAnchors, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.dynamicAnchors}`);
    }, () => {
        gen.var(names_1.default.instancePath, (0, codegen_1._) `""`);
        gen.var(names_1.default.parentData, (0, codegen_1._) `undefined`);
        gen.var(names_1.default.parentDataProperty, (0, codegen_1._) `undefined`);
        gen.var(names_1.default.rootData, names_1.default.data);
        if (opts.dynamicRef)
            gen.var(names_1.default.dynamicAnchors, (0, codegen_1._) `{}`);
    });
}
function topSchemaObjCode(it) {
    const { schema, opts, gen } = it;
    validateFunction(it, () => {
        if (opts.$comment && schema.$comment)
            commentKeyword(it);
        checkNoDefault(it);
        gen.let(names_1.default.vErrors, null);
        gen.let(names_1.default.errors, 0);
        if (opts.unevaluated)
            resetEvaluated(it);
        typeAndKeywords(it);
        returnResults(it);
    });
    return;
}
function resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen, validateName } = it;
    it.evaluated = gen.const("evaluated", (0, codegen_1._) `${validateName}.evaluated`);
    gen.if((0, codegen_1._) `${it.evaluated}.dynamicProps`, () => gen.assign((0, codegen_1._) `${it.evaluated}.props`, (0, codegen_1._) `undefined`));
    gen.if((0, codegen_1._) `${it.evaluated}.dynamicItems`, () => gen.assign((0, codegen_1._) `${it.evaluated}.items`, (0, codegen_1._) `undefined`));
}
function funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, codegen_1._) `/*# sourceURL=${schId} */` : codegen_1.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function subschemaCode(it, valid) {
    if (isSchemaObj(it)) {
        checkKeywords(it);
        if (schemaCxtHasRules(it)) {
            subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, boolSchema_1.boolOrEmptySchema)(it, valid);
}
function schemaCxtHasRules({ schema, self }) {
    if (typeof schema == "boolean")
        return !schema;
    for (const key in schema)
        if (self.RULES.all[key])
            return true;
    return false;
}
function isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function subSchemaObjCode(it, valid) {
    const { schema, gen, opts } = it;
    if (opts.$comment && schema.$comment)
        commentKeyword(it);
    updateContext(it);
    checkAsyncSchema(it);
    const errsCount = gen.const("_errs", names_1.default.errors);
    typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, codegen_1._) `${errsCount} === ${names_1.default.errors}`);
}
function checkKeywords(it) {
    (0, util_1.checkUnknownRules)(it);
    checkRefsAndKeywords(it);
}
function typeAndKeywords(it, errsCount) {
    if (it.opts.jtd)
        return schemaKeywords(it, [], false, errsCount);
    const types = (0, dataType_1.getSchemaTypes)(it.schema);
    const checkedTypes = (0, dataType_1.coerceAndCheckDataType)(it, types);
    schemaKeywords(it, types, !checkedTypes, errsCount);
}
function checkRefsAndKeywords(it) {
    const { schema, errSchemaPath, opts, self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, util_1.schemaHasRulesButRef)(schema, self.RULES)) {
        self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
    }
}
function checkNoDefault(it) {
    const { schema, opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) {
        (0, util_1.checkStrictMode)(it, "default is ignored in the schema root");
    }
}
function updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId)
        it.baseId = (0, resolve_1.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async)
        throw new Error("async schema in sync schema");
}
function commentKeyword({ gen, schemaEnv, schema, errSchemaPath, opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) {
        gen.code((0, codegen_1._) `${names_1.default.self}.logger.log(${msg})`);
    }
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, codegen_1.str) `${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", { ref: schemaEnv.root });
        gen.code((0, codegen_1._) `${names_1.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function returnResults(it) {
    const { gen, schemaEnv, validateName, ValidationError, opts } = it;
    if (schemaEnv.$async) {
        // TODO assign unevaluated
        gen.if((0, codegen_1._) `${names_1.default.errors} === 0`, () => gen.return(names_1.default.data), () => gen.throw((0, codegen_1._) `new ${ValidationError}(${names_1.default.vErrors})`));
    }
    else {
        gen.assign((0, codegen_1._) `${validateName}.errors`, names_1.default.vErrors);
        if (opts.unevaluated)
            assignEvaluated(it);
        gen.return((0, codegen_1._) `${names_1.default.errors} === 0`);
    }
}
function assignEvaluated({ gen, evaluated, props, items }) {
    if (props instanceof codegen_1.Name)
        gen.assign((0, codegen_1._) `${evaluated}.props`, props);
    if (items instanceof codegen_1.Name)
        gen.assign((0, codegen_1._) `${evaluated}.items`, items);
}
function schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen, schema, data, allErrors, opts, self } = it;
    const { RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, util_1.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(() => keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd)
        checkStrictTypes(it, types);
    gen.block(() => {
        for (const group of RULES.rules)
            groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, applicability_1.shouldUseGroup)(schema, group))
            return;
        if (group.type) {
            gen.if((0, dataType_2.checkDataType)(group.type, data, opts.strictNumbers));
            iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, dataType_2.reportTypeError)(it);
            }
            gen.endIf();
        }
        else {
            iterateKeywords(it, group);
        }
        // TODO make it "ok" call?
        if (!allErrors)
            gen.if((0, codegen_1._) `${names_1.default.errors} === ${errsCount || 0}`);
    }
}
function iterateKeywords(it, group) {
    const { gen, schema, opts: { useDefaults }, } = it;
    if (useDefaults)
        (0, defaults_1.assignDefaults)(it, group.type);
    gen.block(() => {
        for (const rule of group.rules) {
            if ((0, applicability_1.shouldUseRule)(schema, rule)) {
                keywordCode(it, rule.keyword, rule.definition, group.type);
            }
        }
    });
}
function checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes)
        return;
    checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes)
        checkMultipleTypes(it, types);
    checkKeywordTypes(it, it.dataTypes);
}
function checkContextTypes(it, types) {
    if (!types.length)
        return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t) => {
        if (!includesType(it.dataTypes, t)) {
            strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
        }
    });
    narrowSchemaTypes(it, types);
}
function checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) {
        strictTypesError(it, "use allowUnionTypes to allow union type keyword");
    }
}
function checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for (const keyword in rules) {
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, applicability_1.shouldUseRule)(it.schema, rule)) {
            const { type } = rule.definition;
            if (type.length && !type.some((t) => hasApplicableType(ts, t))) {
                strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
            }
        }
    }
}
function hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || (kwdT === "number" && schTs.includes("integer"));
}
function includesType(ts, t) {
    return ts.includes(t) || (t === "integer" && ts.includes("number"));
}
function narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes) {
        if (includesType(withTypes, t))
            ts.push(t);
        else if (withTypes.includes("integer") && t === "number")
            ts.push("integer");
    }
    it.dataTypes = ts;
}
function strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, util_1.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class KeywordCxt {
    constructor(it, def, keyword) {
        (0, keyword_1.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, util_1.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) {
            this.schemaCode = it.gen.const("vSchema", getData(this.$data, it));
        }
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, keyword_1.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) {
                throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
            }
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) {
            this.errsCount = it.gen.const("_errs", names_1.default.errors);
        }
    }
    result(condition, successAction, failAction) {
        this.failResult((0, codegen_1.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction)
            failAction();
        else
            this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors)
                this.gen.endIf();
        }
        else {
            if (this.allErrors)
                this.gen.endIf();
            else
                this.gen.else();
        }
    }
    pass(condition, failAction) {
        this.failResult((0, codegen_1.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors)
                this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors)
            this.gen.endIf();
        else
            this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data)
            return this.fail(condition);
        const { schemaCode } = this;
        this.fail((0, codegen_1._) `${schemaCode} !== undefined && (${(0, codegen_1.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        ;
        (append ? errors_1.reportExtraError : errors_1.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, errors_1.reportError)(this, this.def.$dataError || errors_1.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined)
            throw new Error('add "trackErrors" to keyword definition');
        (0, errors_1.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors)
            this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign)
            Object.assign(this.params, obj);
        else
            this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = codegen_1.nil) {
        this.gen.block(() => {
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = codegen_1.nil, $dataValid = codegen_1.nil) {
        if (!this.$data)
            return;
        const { gen, schemaCode, schemaType, def } = this;
        gen.if((0, codegen_1.or)((0, codegen_1._) `${schemaCode} === undefined`, $dataValid));
        if (valid !== codegen_1.nil)
            gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== codegen_1.nil)
                gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen, schemaCode, schemaType, def, it } = this;
        return (0, codegen_1.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */
                if (!(schemaCode instanceof codegen_1.Name))
                    throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [schemaType];
                return (0, codegen_1._) `${(0, dataType_2.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, dataType_2.DataType.Wrong)}`;
            }
            return codegen_1.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", { ref: def.validateSchema }); // TODO value.code for standalone
                return (0, codegen_1._) `!${validateSchemaRef}(${schemaCode})`;
            }
            return codegen_1.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, subschema_1.getSubschema)(this.it, appl);
        (0, subschema_1.extendSubschemaData)(subschema, this.it, appl);
        (0, subschema_1.extendSubschemaMode)(subschema, appl);
        const nextContext = { ...this.it, ...subschema, items: undefined, props: undefined };
        subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it, gen } = this;
        if (!it.opts.unevaluated)
            return;
        if (it.props !== true && schemaCxt.props !== undefined) {
            it.props = util_1.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        }
        if (it.items !== true && schemaCxt.items !== undefined) {
            it.items = util_1.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
        }
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it, gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, () => this.mergeEvaluated(schemaCxt, codegen_1.Name));
            return true;
        }
    }
}
exports.KeywordCxt = KeywordCxt;
function keywordCode(it, keyword, def, ruleType) {
    const cxt = new KeywordCxt(it, def, keyword);
    if ("code" in def) {
        def.code(cxt, ruleType);
    }
    else if (cxt.$data && def.validate) {
        (0, keyword_1.funcKeywordCode)(cxt, def);
    }
    else if ("macro" in def) {
        (0, keyword_1.macroKeywordCode)(cxt, def);
    }
    else if (def.compile || def.validate) {
        (0, keyword_1.funcKeywordCode)(cxt, def);
    }
}
const JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function getData($data, { dataLevel, dataNames, dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "")
        return names_1.default.rootData;
    if ($data[0] === "/") {
        if (!JSON_POINTER.test($data))
            throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = names_1.default.rootData;
    }
    else {
        const matches = RELATIVE_JSON_POINTER.exec($data);
        if (!matches)
            throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel)
                throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel)
            throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer)
            return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments) {
        if (segment) {
            data = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)((0, util_1.unescapeJsonPointer)(segment))}`;
            expr = (0, codegen_1._) `${expr} && ${data}`;
        }
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
exports.getData = getData;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/validate/keyword.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateKeywordUsage = exports.validSchemaType = exports.funcKeywordCode = exports.macroKeywordCode = void 0;
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const names_1 = __webpack_require__("./node_modules/ajv/dist/compile/names.js");
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
const errors_1 = __webpack_require__("./node_modules/ajv/dist/compile/errors.js");
function macroKeywordCode(cxt, def) {
    const { gen, keyword, schema, parentSchema, it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false)
        it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: codegen_1.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true,
    }, valid);
    cxt.pass(valid, () => cxt.error(true));
}
exports.macroKeywordCode = macroKeywordCode;
function funcKeywordCode(cxt, def) {
    var _a;
    const { gen, keyword, schema, parentSchema, $data, it } = cxt;
    checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying)
                modifyData(cxt);
            reportErrs(() => cxt.error());
        }
        else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying)
                modifyData(cxt);
            reportErrs(() => addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(() => assignValid((0, codegen_1._) `await `), (e) => gen.assign(valid, false).if((0, codegen_1._) `${e} instanceof ${it.ValidationError}`, () => gen.assign(ruleErrs, (0, codegen_1._) `${e}.errors`), () => gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, codegen_1._) `${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid(codegen_1.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, codegen_1._) `await ` : codegen_1.nil) {
        const passCxt = it.opts.passContext ? names_1.default.this : names_1.default.self;
        const passSchema = !(("compile" in def && !$data) || def.schema === false);
        gen.assign(valid, (0, codegen_1._) `${_await}${(0, code_1.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, codegen_1.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
exports.funcKeywordCode = funcKeywordCode;
function modifyData(cxt) {
    const { gen, data, it } = cxt;
    gen.if(it.parentData, () => gen.assign(data, (0, codegen_1._) `${it.parentData}[${it.parentDataProperty}]`));
}
function addErrs(cxt, errs) {
    const { gen } = cxt;
    gen.if((0, codegen_1._) `Array.isArray(${errs})`, () => {
        gen
            .assign(names_1.default.vErrors, (0, codegen_1._) `${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`)
            .assign(names_1.default.errors, (0, codegen_1._) `${names_1.default.vErrors}.length`);
        (0, errors_1.extendErrors)(cxt);
    }, () => cxt.error());
}
function checkAsyncKeyword({ schemaEnv }, def) {
    if (def.async && !schemaEnv.$async)
        throw new Error("async keyword in sync schema");
}
function useKeyword(gen, keyword, result) {
    if (result === undefined)
        throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? { ref: result } : { ref: result, code: (0, codegen_1.stringify)(result) });
}
function validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return (!schemaType.length ||
        schemaType.some((st) => st === "array"
            ? Array.isArray(schema)
            : st === "object"
                ? schema && typeof schema == "object" && !Array.isArray(schema)
                : typeof schema == st || (allowUndefined && typeof schema == "undefined")));
}
exports.validSchemaType = validSchemaType;
function validateKeywordUsage({ schema, opts, self, errSchemaPath }, def, keyword) {
    /* istanbul ignore if */
    if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) {
        throw new Error("ajv implementation error");
    }
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd) => !Object.prototype.hasOwnProperty.call(schema, kwd))) {
        throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    }
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` +
                self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log")
                self.logger.error(msg);
            else
                throw new Error(msg);
        }
    }
}
exports.validateKeywordUsage = validateKeywordUsage;
//# sourceMappingURL=keyword.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/compile/validate/subschema.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.extendSubschemaMode = exports.extendSubschemaData = exports.getSubschema = void 0;
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
function getSubschema(it, { keyword, schemaProp, schema, schemaPath, errSchemaPath, topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) {
        throw new Error('both "keyword" and "schema" passed, only one allowed');
    }
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined
            ? {
                schema: sch,
                schemaPath: (0, codegen_1._) `${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}`,
                errSchemaPath: `${it.errSchemaPath}/${keyword}`,
            }
            : {
                schema: sch[schemaProp],
                schemaPath: (0, codegen_1._) `${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}${(0, codegen_1.getProperty)(schemaProp)}`,
                errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, util_1.escapeFragment)(schemaProp)}`,
            };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) {
            throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        }
        return {
            schema,
            schemaPath,
            topSchemaRef,
            errSchemaPath,
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
exports.getSubschema = getSubschema;
function extendSubschemaData(subschema, it, { dataProp, dataPropType: dpType, data, dataTypes, propertyName }) {
    if (data !== undefined && dataProp !== undefined) {
        throw new Error('both "data" and "dataProp" passed, only one allowed');
    }
    const { gen } = it;
    if (dataProp !== undefined) {
        const { errorPath, dataPathArr, opts } = it;
        const nextData = gen.let("data", (0, codegen_1._) `${it.data}${(0, codegen_1.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, codegen_1.str) `${errorPath}${(0, util_1.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, codegen_1._) `${dataProp}`;
        subschema.dataPathArr = [...dataPathArr, subschema.parentDataProperty];
    }
    if (data !== undefined) {
        const nextData = data instanceof codegen_1.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined)
            subschema.propertyName = propertyName;
        // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes)
        subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [...it.dataNames, _nextData];
    }
}
exports.extendSubschemaData = extendSubschemaData;
function extendSubschemaMode(subschema, { jtdDiscriminator, jtdMetadata, compositeRule, createErrors, allErrors }) {
    if (compositeRule !== undefined)
        subschema.compositeRule = compositeRule;
    if (createErrors !== undefined)
        subschema.createErrors = createErrors;
    if (allErrors !== undefined)
        subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
exports.extendSubschemaMode = extendSubschemaMode;
//# sourceMappingURL=subschema.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/core.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;
var validate_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/index.js");
Object.defineProperty(exports, "KeywordCxt", ({ enumerable: true, get: function () { return validate_1.KeywordCxt; } }));
var codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
Object.defineProperty(exports, "_", ({ enumerable: true, get: function () { return codegen_1._; } }));
Object.defineProperty(exports, "str", ({ enumerable: true, get: function () { return codegen_1.str; } }));
Object.defineProperty(exports, "stringify", ({ enumerable: true, get: function () { return codegen_1.stringify; } }));
Object.defineProperty(exports, "nil", ({ enumerable: true, get: function () { return codegen_1.nil; } }));
Object.defineProperty(exports, "Name", ({ enumerable: true, get: function () { return codegen_1.Name; } }));
Object.defineProperty(exports, "CodeGen", ({ enumerable: true, get: function () { return codegen_1.CodeGen; } }));
const validation_error_1 = __webpack_require__("./node_modules/ajv/dist/runtime/validation_error.js");
const ref_error_1 = __webpack_require__("./node_modules/ajv/dist/compile/ref_error.js");
const rules_1 = __webpack_require__("./node_modules/ajv/dist/compile/rules.js");
const compile_1 = __webpack_require__("./node_modules/ajv/dist/compile/index.js");
const codegen_2 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const resolve_1 = __webpack_require__("./node_modules/ajv/dist/compile/resolve.js");
const dataType_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/dataType.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const $dataRefSchema = __webpack_require__("./node_modules/ajv/dist/refs/data.json");
const uri_1 = __webpack_require__("./node_modules/ajv/dist/runtime/uri.js");
const defaultRegExp = (str, flags) => new RegExp(str, flags);
defaultRegExp.code = "new RegExp";
const META_IGNORE_OPTIONS = ["removeAdditional", "useDefaults", "coerceTypes"];
const EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error",
]);
const removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now.",
};
const deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.',
};
const MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : uri_1.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? { ...o.code, optimize, regExp } : { optimize, regExp },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver,
    };
}
class Ajv {
    constructor(opts = {}) {
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = { ...opts, ...requiredOptions(opts) };
        const { es5, lines } = this.opts.code;
        this.scope = new codegen_2.ValueScope({ scope: {}, prefixes: EXT_SCOPE_NAMES, es5, lines });
        this.logger = getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, rules_1.getRules)();
        checkOptions.call(this, removedOptions, opts, "NOT SUPPORTED");
        checkOptions.call(this, deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = getMetaSchemaOptions.call(this);
        if (opts.formats)
            addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords)
            addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object")
            this.addMetaSchema(opts.meta);
        addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data, meta, schemaId } = this.opts;
        let _dataRefSchema = $dataRefSchema;
        if (schemaId === "id") {
            _dataRefSchema = { ...$dataRefSchema };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data)
            this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta, schemaId } = this.opts;
        return (this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined);
    }
    validate(schemaKeyRef, // key, ref or schema object
    data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v)
                throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        }
        else {
            v = this.compile(schemaKeyRef);
        }
        const valid = v(data);
        if (!("$async" in v))
            this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return (sch.validate || this._compileSchemaEnv(sch));
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") {
            throw new Error("options.loadSchema should be a function");
        }
        const { loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) {
                await runCompileAsync.call(this, { $ref }, true);
            }
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            }
            catch (e) {
                if (!(e instanceof ref_error_1.default))
                    throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef }) {
            if (this.refs[ref]) {
                throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
            }
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref])
                await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref])
                this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p)
                return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            }
            finally {
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, // If array is passed, `key` will be ignored
    key, // Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
    _meta, // true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
    _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)
                this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") {
                throw new Error(`schema ${schemaId} must be string`);
            }
        }
        key = (0, resolve_1.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, // schema key
    _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean")
            return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") {
            throw new Error("$schema must be a string");
        }
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log")
                this.logger.error(message);
            else
                throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while (typeof (sch = getSchEnv.call(this, keyRef)) == "string")
            keyRef = sch;
        if (sch === undefined) {
            const { schemaId } = this.opts;
            const root = new compile_1.SchemaEnv({ schema: {}, schemaId });
            sch = compile_1.resolveSchema.call(this, root, keyRef);
            if (!sch)
                return;
            this.refs[keyRef] = sch;
        }
        return (sch.validate || this._compileSchemaEnv(sch));
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch (typeof schemaKeyRef) {
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string": {
                const sch = getSchEnv.call(this, schemaKeyRef);
                if (typeof sch == "object")
                    this._cache.delete(sch.schema);
                delete this.schemas[schemaKeyRef];
                delete this.refs[schemaKeyRef];
                return this;
            }
            case "object": {
                const cacheKey = schemaKeyRef;
                this._cache.delete(cacheKey);
                let id = schemaKeyRef[this.opts.schemaId];
                if (id) {
                    id = (0, resolve_1.normalizeId)(id);
                    delete this.schemas[id];
                    delete this.refs[id];
                }
                return this;
            }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)
            this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        }
        else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) {
                throw new Error("addKeywords: keyword must be string or non-empty array");
            }
        }
        else {
            throw new Error("invalid addKeywords parameters");
        }
        checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, util_1.eachItem)(keyword, (kwd) => addRule.call(this, kwd));
            return this;
        }
        keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, dataType_1.getJSONTypes)(def.type),
            schemaType: (0, dataType_1.getJSONTypes)(def.schemaType),
        };
        (0, util_1.eachItem)(keyword, definition.type.length === 0
            ? (k) => addRule.call(this, k, definition)
            : (k) => definition.type.forEach((t) => addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules) {
            const i = group.rules.findIndex((rule) => rule.keyword === keyword);
            if (i >= 0)
                group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string")
            format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, // optional array of validation errors
    { separator = ", ", dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0)
            return "No errors";
        return errors
            .map((e) => `${dataVar}${e.instancePath} ${e.message}`)
            .reduce((text, msg) => text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers) {
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)
                keywords = keywords[seg];
            for (const key in rules) {
                const rule = rules[key];
                if (typeof rule != "object")
                    continue;
                const { $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema)
                    keywords[key] = schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for (const keyRef in schemas) {
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") {
                    delete schemas[keyRef];
                }
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId } = this.opts;
        if (typeof schema == "object") {
            id = schema[schemaId];
        }
        else {
            if (this.opts.jtd)
                throw new Error("schema must be object");
            else if (typeof schema != "boolean")
                throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined)
            return sch;
        baseId = (0, resolve_1.normalizeId)(id || baseId);
        const localRefs = resolve_1.getSchemaRefs.call(this, schema, baseId);
        sch = new compile_1.SchemaEnv({ schema, schemaId, meta, baseId, localRefs });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId)
                this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema)
            this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) {
            throw new Error(`schema with key or id "${id}" already exists`);
        }
    }
    _compileSchemaEnv(sch) {
        if (sch.meta)
            this._compileMetaSchema(sch);
        else
            compile_1.compileSchema.call(this, sch);
        /* istanbul ignore if */
        if (!sch.validate)
            throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            compile_1.compileSchema.call(this, sch);
        }
        finally {
            this.opts = currentOpts;
        }
    }
}
exports["default"] = Ajv;
Ajv.ValidationError = validation_error_1.default;
Ajv.MissingRefError = ref_error_1.default;
function checkOptions(checkOpts, options, msg, log = "error") {
    for (const key in checkOpts) {
        const opt = key;
        if (opt in options)
            this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function getSchEnv(keyRef) {
    keyRef = (0, resolve_1.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas)
        return;
    if (Array.isArray(optsSchemas))
        this.addSchema(optsSchemas);
    else
        for (const key in optsSchemas)
            this.addSchema(optsSchemas[key], key);
}
function addInitialFormats() {
    for (const name in this.opts.formats) {
        const format = this.opts.formats[name];
        if (format)
            this.addFormat(name, format);
    }
}
function addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for (const keyword in defs) {
        const def = defs[keyword];
        if (!def.keyword)
            def.keyword = keyword;
        this.addKeyword(def);
    }
}
function getMetaSchemaOptions() {
    const metaOpts = { ...this.opts };
    for (const opt of META_IGNORE_OPTIONS)
        delete metaOpts[opt];
    return metaOpts;
}
const noLogs = { log() { }, warn() { }, error() { } };
function getLogger(logger) {
    if (logger === false)
        return noLogs;
    if (logger === undefined)
        return console;
    if (logger.log && logger.warn && logger.error)
        return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function checkKeyword(keyword, def) {
    const { RULES } = this;
    (0, util_1.eachItem)(keyword, (kwd) => {
        if (RULES.keywords[kwd])
            throw new Error(`Keyword ${kwd} is already defined`);
        if (!KEYWORD_NAME.test(kwd))
            throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def)
        return;
    if (def.$data && !("code" in def || "validate" in def)) {
        throw new Error('$data keyword must have "code" or "validate" function');
    }
}
function addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post)
        throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t }) => t === dataType);
    if (!ruleGroup) {
        ruleGroup = { type: dataType, rules: [] };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition)
        return;
    const rule = {
        keyword,
        definition: {
            ...definition,
            type: (0, dataType_1.getJSONTypes)(definition.type),
            schemaType: (0, dataType_1.getJSONTypes)(definition.schemaType),
        },
    };
    if (definition.before)
        addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else
        ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 ? void 0 : _a.forEach((kwd) => this.addKeyword(kwd));
}
function addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule) => _rule.keyword === before);
    if (i >= 0) {
        ruleGroup.rules.splice(i, 0, rule);
    }
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function keywordMetaschema(def) {
    let { metaSchema } = def;
    if (metaSchema === undefined)
        return;
    if (def.$data && this.opts.$data)
        metaSchema = schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#",
};
function schemaOrData(schema) {
    return { anyOf: [schema, $dataRef] };
}
//# sourceMappingURL=core.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/runtime/equal.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// https://github.com/ajv-validator/ajv/issues/889
const equal = __webpack_require__("../../node_modules/fast-deep-equal/index.js");
equal.code = 'require("ajv/dist/runtime/equal").default';
exports["default"] = equal;
//# sourceMappingURL=equal.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/runtime/ucs2length.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++; // low surrogate
        }
    }
    return length;
}
exports["default"] = ucs2length;
ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';
//# sourceMappingURL=ucs2length.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/runtime/uri.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const uri = __webpack_require__("../../node_modules/uri-js/dist/es5/uri.all.js");
uri.code = 'require("ajv/dist/runtime/uri").default';
exports["default"] = uri;
//# sourceMappingURL=uri.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/runtime/validation_error.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
class ValidationError extends Error {
    constructor(errors) {
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
exports["default"] = ValidationError;
//# sourceMappingURL=validation_error.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/additionalItems.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateAdditionalItems = void 0;
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const error = {
    message: ({ params: { len } }) => (0, codegen_1.str) `must NOT have more than ${len} items`,
    params: ({ params: { len } }) => (0, codegen_1._) `{limit: ${len}}`,
};
const def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: ["boolean", "object"],
    before: "uniqueItems",
    error,
    code(cxt) {
        const { parentSchema, it } = cxt;
        const { items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, util_1.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        validateAdditionalItems(cxt, items);
    },
};
function validateAdditionalItems(cxt, items) {
    const { gen, schema, data, keyword, it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, codegen_1._) `${data}.length`);
    if (schema === false) {
        cxt.setParams({ len: items.length });
        cxt.pass((0, codegen_1._) `${len} <= ${items.length}`);
    }
    else if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, codegen_1._) `${len} <= ${items.length}`); // TODO var
        gen.if((0, codegen_1.not)(valid), () => validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i) => {
            cxt.subschema({ keyword, dataProp: i, dataPropType: util_1.Type.Num }, valid);
            if (!it.allErrors)
                gen.if((0, codegen_1.not)(valid), () => gen.break());
        });
    }
}
exports.validateAdditionalItems = validateAdditionalItems;
exports["default"] = def;
//# sourceMappingURL=additionalItems.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/additionalProperties.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const names_1 = __webpack_require__("./node_modules/ajv/dist/compile/names.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const error = {
    message: "must NOT have additional properties",
    params: ({ params }) => (0, codegen_1._) `{additionalProperty: ${params.additionalProperty}}`,
};
const def = {
    keyword: "additionalProperties",
    type: ["object"],
    schemaType: ["boolean", "object"],
    allowUndefined: true,
    trackErrors: true,
    error,
    code(cxt) {
        const { gen, schema, parentSchema, data, errsCount, it } = cxt;
        /* istanbul ignore if */
        if (!errsCount)
            throw new Error("ajv implementation error");
        const { allErrors, opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, util_1.alwaysValidSchema)(it, schema))
            return;
        const props = (0, code_1.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, code_1.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, codegen_1._) `${errsCount} === ${names_1.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key) => {
                if (!props.length && !patProps.length)
                    additionalPropertyCode(key);
                else
                    gen.if(isAdditional(key), () => additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, util_1.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, code_1.isOwnProperty)(gen, propsSchema, key);
            }
            else if (props.length) {
                definedProp = (0, codegen_1.or)(...props.map((p) => (0, codegen_1._) `${key} === ${p}`));
            }
            else {
                definedProp = codegen_1.nil;
            }
            if (patProps.length) {
                definedProp = (0, codegen_1.or)(definedProp, ...patProps.map((p) => (0, codegen_1._) `${(0, code_1.usePattern)(cxt, p)}.test(${key})`));
            }
            return (0, codegen_1.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, codegen_1._) `delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || (opts.removeAdditional && schema === false)) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({ additionalProperty: key });
                cxt.error();
                if (!allErrors)
                    gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, codegen_1.not)(valid), () => {
                        cxt.reset();
                        deleteAdditional(key);
                    });
                }
                else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors)
                        gen.if((0, codegen_1.not)(valid), () => gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: util_1.Type.Str,
            };
            if (errors === false) {
                Object.assign(subschema, {
                    compositeRule: true,
                    createErrors: false,
                    allErrors: false,
                });
            }
            cxt.subschema(subschema, valid);
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=additionalProperties.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/allOf.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const def = {
    keyword: "allOf",
    schemaType: "array",
    code(cxt) {
        const { gen, schema, it } = cxt;
        /* istanbul ignore if */
        if (!Array.isArray(schema))
            throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i) => {
            if ((0, util_1.alwaysValidSchema)(it, sch))
                return;
            const schCxt = cxt.subschema({ keyword: "allOf", schemaProp: i }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    },
};
exports["default"] = def;
//# sourceMappingURL=allOf.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/anyOf.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
const def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: code_1.validateUnion,
    error: { message: "must match a schema in anyOf" },
};
exports["default"] = def;
//# sourceMappingURL=anyOf.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/contains.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const error = {
    message: ({ params: { min, max } }) => max === undefined
        ? (0, codegen_1.str) `must contain at least ${min} valid item(s)`
        : (0, codegen_1.str) `must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min, max } }) => max === undefined ? (0, codegen_1._) `{minContains: ${min}}` : (0, codegen_1._) `{minContains: ${min}, maxContains: ${max}}`,
};
const def = {
    keyword: "contains",
    type: "array",
    schemaType: ["object", "boolean"],
    before: "uniqueItems",
    trackErrors: true,
    error,
    code(cxt) {
        const { gen, schema, parentSchema, data, it } = cxt;
        let min;
        let max;
        const { minContains, maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        }
        else {
            min = 1;
        }
        const len = gen.const("len", (0, codegen_1._) `${data}.length`);
        cxt.setParams({ min, max });
        if (max === undefined && min === 0) {
            (0, util_1.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, util_1.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, util_1.alwaysValidSchema)(it, schema)) {
            let cond = (0, codegen_1._) `${len} >= ${min}`;
            if (max !== undefined)
                cond = (0, codegen_1._) `${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) {
            validateItems(valid, () => gen.if(valid, () => gen.break()));
        }
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined)
                gen.if((0, codegen_1._) `${data}.length > 0`, validateItemsWithCount);
        }
        else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, () => cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, () => gen.if(schValid, () => checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i) => {
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: util_1.Type.Num,
                    compositeRule: true,
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, codegen_1._) `${count}++`);
            if (max === undefined) {
                gen.if((0, codegen_1._) `${count} >= ${min}`, () => gen.assign(valid, true).break());
            }
            else {
                gen.if((0, codegen_1._) `${count} > ${max}`, () => gen.assign(valid, false).break());
                if (min === 1)
                    gen.assign(valid, true);
                else
                    gen.if((0, codegen_1._) `${count} >= ${min}`, () => gen.assign(valid, true));
            }
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=contains.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/dependencies.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateSchemaDeps = exports.validatePropertyDeps = exports.error = void 0;
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
exports.error = {
    message: ({ params: { property, depsCount, deps } }) => {
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, codegen_1.str) `must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property, depsCount, deps, missingProperty } }) => (0, codegen_1._) `{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`, // TODO change to reference
};
const def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: exports.error,
    code(cxt) {
        const [propDeps, schDeps] = splitDependencies(cxt);
        validatePropertyDeps(cxt, propDeps);
        validateSchemaDeps(cxt, schDeps);
    },
};
function splitDependencies({ schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for (const key in schema) {
        if (key === "__proto__")
            continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [propertyDeps, schemaDeps];
}
function validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen, data, it } = cxt;
    if (Object.keys(propertyDeps).length === 0)
        return;
    const missing = gen.let("missing");
    for (const prop in propertyDeps) {
        const deps = propertyDeps[prop];
        if (deps.length === 0)
            continue;
        const hasProperty = (0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", "),
        });
        if (it.allErrors) {
            gen.if(hasProperty, () => {
                for (const depProp of deps) {
                    (0, code_1.checkReportMissingProp)(cxt, depProp);
                }
            });
        }
        else {
            gen.if((0, codegen_1._) `${hasProperty} && (${(0, code_1.checkMissingProp)(cxt, deps, missing)})`);
            (0, code_1.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
exports.validatePropertyDeps = validatePropertyDeps;
function validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen, data, keyword, it } = cxt;
    const valid = gen.name("valid");
    for (const prop in schemaDeps) {
        if ((0, util_1.alwaysValidSchema)(it, schemaDeps[prop]))
            continue;
        gen.if((0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties), () => {
            const schCxt = cxt.subschema({ keyword, schemaProp: prop }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, () => gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
exports.validateSchemaDeps = validateSchemaDeps;
exports["default"] = def;
//# sourceMappingURL=dependencies.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/if.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const error = {
    message: ({ params }) => (0, codegen_1.str) `must match "${params.ifClause}" schema`,
    params: ({ params }) => (0, codegen_1._) `{failingKeyword: ${params.ifClause}}`,
};
const def = {
    keyword: "if",
    schemaType: ["object", "boolean"],
    trackErrors: true,
    error,
    code(cxt) {
        const { gen, parentSchema, it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) {
            (0, util_1.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        }
        const hasThen = hasSchema(it, "then");
        const hasElse = hasSchema(it, "else");
        if (!hasThen && !hasElse)
            return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({ ifClause });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        }
        else if (hasThen) {
            gen.if(schValid, validateClause("then"));
        }
        else {
            gen.if((0, codegen_1.not)(schValid), validateClause("else"));
        }
        cxt.pass(valid, () => cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false,
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return () => {
                const schCxt = cxt.subschema({ keyword }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause)
                    gen.assign(ifClause, (0, codegen_1._) `${keyword}`);
                else
                    cxt.setParams({ ifClause: keyword });
            };
        }
    },
};
function hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, util_1.alwaysValidSchema)(it, schema);
}
exports["default"] = def;
//# sourceMappingURL=if.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const additionalItems_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/additionalItems.js");
const prefixItems_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/prefixItems.js");
const items_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/items.js");
const items2020_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/items2020.js");
const contains_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/contains.js");
const dependencies_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/dependencies.js");
const propertyNames_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/propertyNames.js");
const additionalProperties_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/additionalProperties.js");
const properties_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/properties.js");
const patternProperties_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/patternProperties.js");
const not_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/not.js");
const anyOf_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/anyOf.js");
const oneOf_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/oneOf.js");
const allOf_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/allOf.js");
const if_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/if.js");
const thenElse_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/thenElse.js");
function getApplicator(draft2020 = false) {
    const applicator = [
        // any
        not_1.default,
        anyOf_1.default,
        oneOf_1.default,
        allOf_1.default,
        if_1.default,
        thenElse_1.default,
        // object
        propertyNames_1.default,
        additionalProperties_1.default,
        dependencies_1.default,
        properties_1.default,
        patternProperties_1.default,
    ];
    // array
    if (draft2020)
        applicator.push(prefixItems_1.default, items2020_1.default);
    else
        applicator.push(additionalItems_1.default, items_1.default);
    applicator.push(contains_1.default);
    return applicator;
}
exports["default"] = getApplicator;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/items.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateTuple = void 0;
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
const def = {
    keyword: "items",
    type: "array",
    schemaType: ["object", "array", "boolean"],
    before: "uniqueItems",
    code(cxt) {
        const { schema, it } = cxt;
        if (Array.isArray(schema))
            return validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, util_1.alwaysValidSchema)(it, schema))
            return;
        cxt.ok((0, code_1.validateArray)(cxt));
    },
};
function validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen, parentSchema, data, keyword, it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) {
        it.items = util_1.mergeEvaluated.items(gen, schArr.length, it.items);
    }
    const valid = gen.name("valid");
    const len = gen.const("len", (0, codegen_1._) `${data}.length`);
    schArr.forEach((sch, i) => {
        if ((0, util_1.alwaysValidSchema)(it, sch))
            return;
        gen.if((0, codegen_1._) `${len} > ${i}`, () => cxt.subschema({
            keyword,
            schemaProp: i,
            dataProp: i,
        }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts, errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, util_1.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
exports.validateTuple = validateTuple;
exports["default"] = def;
//# sourceMappingURL=items.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/items2020.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
const additionalItems_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/additionalItems.js");
const error = {
    message: ({ params: { len } }) => (0, codegen_1.str) `must NOT have more than ${len} items`,
    params: ({ params: { len } }) => (0, codegen_1._) `{limit: ${len}}`,
};
const def = {
    keyword: "items",
    type: "array",
    schemaType: ["object", "boolean"],
    before: "uniqueItems",
    error,
    code(cxt) {
        const { schema, parentSchema, it } = cxt;
        const { prefixItems } = parentSchema;
        it.items = true;
        if ((0, util_1.alwaysValidSchema)(it, schema))
            return;
        if (prefixItems)
            (0, additionalItems_1.validateAdditionalItems)(cxt, prefixItems);
        else
            cxt.ok((0, code_1.validateArray)(cxt));
    },
};
exports["default"] = def;
//# sourceMappingURL=items2020.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/not.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const def = {
    keyword: "not",
    schemaType: ["object", "boolean"],
    trackErrors: true,
    code(cxt) {
        const { gen, schema, it } = cxt;
        if ((0, util_1.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false,
        }, valid);
        cxt.failResult(valid, () => cxt.reset(), () => cxt.error());
    },
    error: { message: "must NOT be valid" },
};
exports["default"] = def;
//# sourceMappingURL=not.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/oneOf.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params }) => (0, codegen_1._) `{passingSchemas: ${params.passing}}`,
};
const def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error,
    code(cxt) {
        const { gen, schema, parentSchema, it } = cxt;
        /* istanbul ignore if */
        if (!Array.isArray(schema))
            throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator)
            return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({ passing });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, () => cxt.reset(), () => cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i) => {
                let schCxt;
                if ((0, util_1.alwaysValidSchema)(it, sch)) {
                    gen.var(schValid, true);
                }
                else {
                    schCxt = cxt.subschema({
                        keyword: "oneOf",
                        schemaProp: i,
                        compositeRule: true,
                    }, schValid);
                }
                if (i > 0) {
                    gen
                        .if((0, codegen_1._) `${schValid} && ${valid}`)
                        .assign(valid, false)
                        .assign(passing, (0, codegen_1._) `[${passing}, ${i}]`)
                        .else();
                }
                gen.if(schValid, () => {
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt)
                        cxt.mergeEvaluated(schCxt, codegen_1.Name);
                });
            });
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=oneOf.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/patternProperties.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const util_2 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code(cxt) {
        const { gen, schema, data, parentSchema, it } = cxt;
        const { opts } = it;
        const patterns = (0, code_1.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p) => (0, util_1.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 ||
            (alwaysValidPatterns.length === patterns.length &&
                (!it.opts.unevaluated || it.props === true))) {
            return;
        }
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof codegen_1.Name)) {
            it.props = (0, util_2.evaluatedPropsToName)(gen, it.props);
        }
        const { props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns) {
                if (checkProperties)
                    checkMatchingProperties(pat);
                if (it.allErrors) {
                    validateProperties(pat);
                }
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for (const prop in checkProperties) {
                if (new RegExp(pat).test(prop)) {
                    (0, util_1.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
                }
            }
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key) => {
                gen.if((0, codegen_1._) `${(0, code_1.usePattern)(cxt, pat)}.test(${key})`, () => {
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) {
                        cxt.subschema({
                            keyword: "patternProperties",
                            schemaProp: pat,
                            dataProp: key,
                            dataPropType: util_2.Type.Str,
                        }, valid);
                    }
                    if (it.opts.unevaluated && props !== true) {
                        gen.assign((0, codegen_1._) `${props}[${key}]`, true);
                    }
                    else if (!alwaysValid && !it.allErrors) {
                        // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                        // or if all properties were evaluated (props === true)
                        gen.if((0, codegen_1.not)(valid), () => gen.break());
                    }
                });
            });
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=patternProperties.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/prefixItems.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const items_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/items.js");
const def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: ["array"],
    before: "uniqueItems",
    code: (cxt) => (0, items_1.validateTuple)(cxt, "items"),
};
exports["default"] = def;
//# sourceMappingURL=prefixItems.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/properties.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const validate_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/index.js");
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const additionalProperties_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/additionalProperties.js");
const def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code(cxt) {
        const { gen, schema, parentSchema, data, it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) {
            additionalProperties_1.default.code(new validate_1.KeywordCxt(it, additionalProperties_1.default, "additionalProperties"));
        }
        const allProps = (0, code_1.allSchemaProperties)(schema);
        for (const prop of allProps) {
            it.definedProperties.add(prop);
        }
        if (it.opts.unevaluated && allProps.length && it.props !== true) {
            it.props = util_1.mergeEvaluated.props(gen, (0, util_1.toHash)(allProps), it.props);
        }
        const properties = allProps.filter((p) => !(0, util_1.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0)
            return;
        const valid = gen.name("valid");
        for (const prop of properties) {
            if (hasDefault(prop)) {
                applyPropertySchema(prop);
            }
            else {
                gen.if((0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors)
                    gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop,
            }, valid);
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=properties.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/propertyNames.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const error = {
    message: "property name must be valid",
    params: ({ params }) => (0, codegen_1._) `{propertyName: ${params.propertyName}}`,
};
const def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: ["object", "boolean"],
    error,
    code(cxt) {
        const { gen, schema, data, it } = cxt;
        if ((0, util_1.alwaysValidSchema)(it, schema))
            return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key) => {
            cxt.setParams({ propertyName: key });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: ["string"],
                propertyName: key,
                compositeRule: true,
            }, valid);
            gen.if((0, codegen_1.not)(valid), () => {
                cxt.error(true);
                if (!it.allErrors)
                    gen.break();
            });
        });
        cxt.ok(valid);
    },
};
exports["default"] = def;
//# sourceMappingURL=propertyNames.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/applicator/thenElse.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const def = {
    keyword: ["then", "else"],
    schemaType: ["object", "boolean"],
    code({ keyword, parentSchema, it }) {
        if (parentSchema.if === undefined)
            (0, util_1.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    },
};
exports["default"] = def;
//# sourceMappingURL=thenElse.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/code.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.validateUnion = exports.validateArray = exports.usePattern = exports.callValidateCode = exports.schemaProperties = exports.allSchemaProperties = exports.noPropertyInData = exports.propertyInData = exports.isOwnProperty = exports.hasPropFunc = exports.reportMissingProp = exports.checkMissingProp = exports.checkReportMissingProp = void 0;
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const names_1 = __webpack_require__("./node_modules/ajv/dist/compile/names.js");
const util_2 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
function checkReportMissingProp(cxt, prop) {
    const { gen, data, it } = cxt;
    gen.if(noPropertyInData(gen, data, prop, it.opts.ownProperties), () => {
        cxt.setParams({ missingProperty: (0, codegen_1._) `${prop}` }, true);
        cxt.error();
    });
}
exports.checkReportMissingProp = checkReportMissingProp;
function checkMissingProp({ gen, data, it: { opts } }, properties, missing) {
    return (0, codegen_1.or)(...properties.map((prop) => (0, codegen_1.and)(noPropertyInData(gen, data, prop, opts.ownProperties), (0, codegen_1._) `${missing} = ${prop}`)));
}
exports.checkMissingProp = checkMissingProp;
function reportMissingProp(cxt, missing) {
    cxt.setParams({ missingProperty: missing }, true);
    cxt.error();
}
exports.reportMissingProp = reportMissingProp;
function hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, codegen_1._) `Object.prototype.hasOwnProperty`,
    });
}
exports.hasPropFunc = hasPropFunc;
function isOwnProperty(gen, data, property) {
    return (0, codegen_1._) `${hasPropFunc(gen)}.call(${data}, ${property})`;
}
exports.isOwnProperty = isOwnProperty;
function propertyInData(gen, data, property, ownProperties) {
    const cond = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, codegen_1._) `${cond} && ${isOwnProperty(gen, data, property)}` : cond;
}
exports.propertyInData = propertyInData;
function noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(property)} === undefined`;
    return ownProperties ? (0, codegen_1.or)(cond, (0, codegen_1.not)(isOwnProperty(gen, data, property))) : cond;
}
exports.noPropertyInData = noPropertyInData;
function allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p) => p !== "__proto__") : [];
}
exports.allSchemaProperties = allSchemaProperties;
function schemaProperties(it, schemaMap) {
    return allSchemaProperties(schemaMap).filter((p) => !(0, util_1.alwaysValidSchema)(it, schemaMap[p]));
}
exports.schemaProperties = schemaProperties;
function callValidateCode({ schemaCode, data, it: { gen, topSchemaRef, schemaPath, errorPath }, it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, codegen_1._) `${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [names_1.default.instancePath, (0, codegen_1.strConcat)(names_1.default.instancePath, errorPath)],
        [names_1.default.parentData, it.parentData],
        [names_1.default.parentDataProperty, it.parentDataProperty],
        [names_1.default.rootData, names_1.default.rootData],
    ];
    if (it.opts.dynamicRef)
        valCxt.push([names_1.default.dynamicAnchors, names_1.default.dynamicAnchors]);
    const args = (0, codegen_1._) `${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== codegen_1.nil ? (0, codegen_1._) `${func}.call(${context}, ${args})` : (0, codegen_1._) `${func}(${args})`;
}
exports.callValidateCode = callValidateCode;
const newRegExp = (0, codegen_1._) `new RegExp`;
function usePattern({ gen, it: { opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, codegen_1._) `${regExp.code === "new RegExp" ? newRegExp : (0, util_2.useFunc)(gen, regExp)}(${pattern}, ${u})`,
    });
}
exports.usePattern = usePattern;
function validateArray(cxt) {
    const { gen, data, keyword, it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(() => gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(() => gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, codegen_1._) `${data}.length`);
        gen.forRange("i", 0, len, (i) => {
            cxt.subschema({
                keyword,
                dataProp: i,
                dataPropType: util_1.Type.Num,
            }, valid);
            gen.if((0, codegen_1.not)(valid), notValid);
        });
    }
}
exports.validateArray = validateArray;
function validateUnion(cxt) {
    const { gen, schema, keyword, it } = cxt;
    /* istanbul ignore if */
    if (!Array.isArray(schema))
        throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch) => (0, util_1.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated)
        return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(() => schema.forEach((_sch, i) => {
        const schCxt = cxt.subschema({
            keyword,
            schemaProp: i,
            compositeRule: true,
        }, schValid);
        gen.assign(valid, (0, codegen_1._) `${valid} || ${schValid}`);
        const merged = cxt.mergeValidEvaluated(schCxt, schValid);
        // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
        // or if all properties and items were evaluated (it.props === true && it.items === true)
        if (!merged)
            gen.if((0, codegen_1.not)(valid));
    }));
    cxt.result(valid, () => cxt.reset(), () => cxt.error(true));
}
exports.validateUnion = validateUnion;
//# sourceMappingURL=code.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/core/id.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const def = {
    keyword: "id",
    code() {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    },
};
exports["default"] = def;
//# sourceMappingURL=id.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/core/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const id_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/core/id.js");
const ref_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/core/ref.js");
const core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    { keyword: "$comment" },
    "definitions",
    id_1.default,
    ref_1.default,
];
exports["default"] = core;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/core/ref.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.callRef = exports.getValidate = void 0;
const ref_error_1 = __webpack_require__("./node_modules/ajv/dist/compile/ref_error.js");
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const names_1 = __webpack_require__("./node_modules/ajv/dist/compile/names.js");
const compile_1 = __webpack_require__("./node_modules/ajv/dist/compile/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const def = {
    keyword: "$ref",
    schemaType: "string",
    code(cxt) {
        const { gen, schema: $ref, it } = cxt;
        const { baseId, schemaEnv: env, validateName, opts, self } = it;
        const { root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId)
            return callRootRef();
        const schOrEnv = compile_1.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined)
            throw new ref_error_1.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof compile_1.SchemaEnv)
            return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root)
                return callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", { ref: root });
            return callRef(cxt, (0, codegen_1._) `${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = getValidate(cxt, sch);
            callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? { ref: sch, code: (0, codegen_1.stringify)(sch) } : { ref: sch });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: codegen_1.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref,
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    },
};
function getValidate(cxt, sch) {
    const { gen } = cxt;
    return sch.validate
        ? gen.scopeValue("validate", { ref: sch.validate })
        : (0, codegen_1._) `${gen.scopeValue("wrapper", { ref: sch })}.validate`;
}
exports.getValidate = getValidate;
function callRef(cxt, v, sch, $async) {
    const { gen, it } = cxt;
    const { allErrors, schemaEnv: env, opts } = it;
    const passCxt = opts.passContext ? names_1.default.this : codegen_1.nil;
    if ($async)
        callAsyncRef();
    else
        callSyncRef();
    function callAsyncRef() {
        if (!env.$async)
            throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(() => {
            gen.code((0, codegen_1._) `await ${(0, code_1.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors)
                gen.assign(valid, true);
        }, (e) => {
            gen.if((0, codegen_1._) `!(${e} instanceof ${it.ValidationError})`, () => gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors)
                gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, code_1.callValidateCode)(cxt, v, passCxt), () => addEvaluatedFrom(v), () => addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, codegen_1._) `${source}.errors`;
        gen.assign(names_1.default.vErrors, (0, codegen_1._) `${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign(names_1.default.errors, (0, codegen_1._) `${names_1.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated)
            return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) {
                    it.props = util_1.mergeEvaluated.props(gen, schEvaluated.props, it.props);
                }
            }
            else {
                const props = gen.var("props", (0, codegen_1._) `${source}.evaluated.props`);
                it.props = util_1.mergeEvaluated.props(gen, props, it.props, codegen_1.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) {
                    it.items = util_1.mergeEvaluated.items(gen, schEvaluated.items, it.items);
                }
            }
            else {
                const items = gen.var("items", (0, codegen_1._) `${source}.evaluated.items`);
                it.items = util_1.mergeEvaluated.items(gen, items, it.items, codegen_1.Name);
            }
        }
    }
}
exports.callRef = callRef;
exports["default"] = def;
//# sourceMappingURL=ref.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/discriminator/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const types_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/discriminator/types.js");
const compile_1 = __webpack_require__("./node_modules/ajv/dist/compile/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const error = {
    message: ({ params: { discrError, tagName } }) => discrError === types_1.DiscrError.Tag
        ? `tag "${tagName}" must be string`
        : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError, tag, tagName } }) => (0, codegen_1._) `{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`,
};
const def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error,
    code(cxt) {
        const { gen, data, schema, parentSchema, it } = cxt;
        const { oneOf } = parentSchema;
        if (!it.opts.discriminator) {
            throw new Error("discriminator: requires discriminator option");
        }
        const tagName = schema.propertyName;
        if (typeof tagName != "string")
            throw new Error("discriminator: requires propertyName");
        if (schema.mapping)
            throw new Error("discriminator: mapping is not supported");
        if (!oneOf)
            throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(tagName)}`);
        gen.if((0, codegen_1._) `typeof ${tag} == "string"`, () => validateMapping(), () => cxt.error(false, { discrError: types_1.DiscrError.Tag, tag, tagName }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for (const tagValue in mapping) {
                gen.elseIf((0, codegen_1._) `${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, { discrError: types_1.DiscrError.Mapping, tag, tagName });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({ keyword: "oneOf", schemaProp }, _valid);
            cxt.mergeEvaluated(schCxt, codegen_1.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for (let i = 0; i < oneOf.length; i++) {
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, util_1.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    sch = compile_1.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, sch === null || sch === void 0 ? void 0 : sch.$ref);
                    if (sch instanceof compile_1.SchemaEnv)
                        sch = sch.schema;
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") {
                    throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                }
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired)
                throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) {
                    addMapping(sch.const, i);
                }
                else if (sch.enum) {
                    for (const tagValue of sch.enum) {
                        addMapping(tagValue, i);
                    }
                }
                else {
                    throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
                }
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) {
                    throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                }
                oneOfMapping[tagValue] = i;
            }
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/discriminator/types.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.DiscrError = void 0;
var DiscrError;
(function (DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})(DiscrError = exports.DiscrError || (exports.DiscrError = {}));
//# sourceMappingURL=types.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/draft7.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const core_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/core/index.js");
const validation_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/index.js");
const applicator_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/applicator/index.js");
const format_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/format/index.js");
const metadata_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/metadata.js");
const draft7Vocabularies = [
    core_1.default,
    validation_1.default,
    (0, applicator_1.default)(),
    format_1.default,
    metadata_1.metadataVocabulary,
    metadata_1.contentVocabulary,
];
exports["default"] = draft7Vocabularies;
//# sourceMappingURL=draft7.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/format/format.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const error = {
    message: ({ schemaCode }) => (0, codegen_1.str) `must match format "${schemaCode}"`,
    params: ({ schemaCode }) => (0, codegen_1._) `{format: ${schemaCode}}`,
};
const def = {
    keyword: "format",
    type: ["number", "string"],
    schemaType: "string",
    $data: true,
    error,
    code(cxt, ruleType) {
        const { gen, data, $data, schema, schemaCode, it } = cxt;
        const { opts, errSchemaPath, schemaEnv, self } = it;
        if (!opts.validateFormats)
            return;
        if ($data)
            validate$DataFormat();
        else
            validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats,
            });
            const fDef = gen.const("fDef", (0, codegen_1._) `${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, codegen_1._) `typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, () => gen.assign(fType, (0, codegen_1._) `${fDef}.type || "string"`).assign(format, (0, codegen_1._) `${fDef}.validate`), () => gen.assign(fType, (0, codegen_1._) `"string"`).assign(format, fDef));
            cxt.fail$data((0, codegen_1.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false)
                    return codegen_1.nil;
                return (0, codegen_1._) `${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async
                    ? (0, codegen_1._) `(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))`
                    : (0, codegen_1._) `${format}(${data})`;
                const validData = (0, codegen_1._) `(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, codegen_1._) `${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true)
                return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType)
                cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp
                    ? (0, codegen_1.regexpCode)(fmtDef)
                    : opts.code.formats
                        ? (0, codegen_1._) `${opts.code.formats}${(0, codegen_1.getProperty)(schema)}`
                        : undefined;
                const fmt = gen.scopeValue("formats", { key: schema, ref: fmtDef, code });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) {
                    return [fmtDef.type || "string", fmtDef.validate, (0, codegen_1._) `${fmt}.validate`];
                }
                return ["string", fmtDef, fmt];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async)
                        throw new Error("async format in sync schema");
                    return (0, codegen_1._) `await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, codegen_1._) `${fmtRef}(${data})` : (0, codegen_1._) `${fmtRef}.test(${data})`;
            }
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=format.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/format/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const format_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/format/format.js");
const format = [format_1.default];
exports["default"] = format;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/metadata.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.contentVocabulary = exports.metadataVocabulary = void 0;
exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples",
];
exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema",
];
//# sourceMappingURL=metadata.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/const.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const equal_1 = __webpack_require__("./node_modules/ajv/dist/runtime/equal.js");
const error = {
    message: "must be equal to constant",
    params: ({ schemaCode }) => (0, codegen_1._) `{allowedValue: ${schemaCode}}`,
};
const def = {
    keyword: "const",
    $data: true,
    error,
    code(cxt) {
        const { gen, data, $data, schemaCode, schema } = cxt;
        if ($data || (schema && typeof schema == "object")) {
            cxt.fail$data((0, codegen_1._) `!${(0, util_1.useFunc)(gen, equal_1.default)}(${data}, ${schemaCode})`);
        }
        else {
            cxt.fail((0, codegen_1._) `${schema} !== ${data}`);
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=const.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/enum.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const equal_1 = __webpack_require__("./node_modules/ajv/dist/runtime/equal.js");
const error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode }) => (0, codegen_1._) `{allowedValues: ${schemaCode}}`,
};
const def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error,
    code(cxt) {
        const { gen, data, $data, schema, schemaCode, it } = cxt;
        if (!$data && schema.length === 0)
            throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = () => (eql !== null && eql !== void 0 ? eql : (eql = (0, util_1.useFunc)(gen, equal_1.default)));
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        }
        else {
            /* istanbul ignore if */
            if (!Array.isArray(schema))
                throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, codegen_1.or)(...schema.map((_x, i) => equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v) => gen.if((0, codegen_1._) `${getEql()}(${data}, ${v})`, () => gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null
                ? (0, codegen_1._) `${getEql()}(${data}, ${vSchema}[${i}])`
                : (0, codegen_1._) `${data} === ${sch}`;
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=enum.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const limitNumber_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/limitNumber.js");
const multipleOf_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/multipleOf.js");
const limitLength_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/limitLength.js");
const pattern_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/pattern.js");
const limitProperties_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/limitProperties.js");
const required_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/required.js");
const limitItems_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/limitItems.js");
const uniqueItems_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/uniqueItems.js");
const const_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/const.js");
const enum_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/validation/enum.js");
const validation = [
    // number
    limitNumber_1.default,
    multipleOf_1.default,
    // string
    limitLength_1.default,
    pattern_1.default,
    // object
    limitProperties_1.default,
    required_1.default,
    // array
    limitItems_1.default,
    uniqueItems_1.default,
    // any
    { keyword: "type", schemaType: ["string", "array"] },
    { keyword: "nullable", schemaType: "boolean" },
    const_1.default,
    enum_1.default,
];
exports["default"] = validation;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/limitItems.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const error = {
    message({ keyword, schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, codegen_1.str) `must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode }) => (0, codegen_1._) `{limit: ${schemaCode}}`,
};
const def = {
    keyword: ["maxItems", "minItems"],
    type: "array",
    schemaType: "number",
    $data: true,
    error,
    code(cxt) {
        const { keyword, data, schemaCode } = cxt;
        const op = keyword === "maxItems" ? codegen_1.operators.GT : codegen_1.operators.LT;
        cxt.fail$data((0, codegen_1._) `${data}.length ${op} ${schemaCode}`);
    },
};
exports["default"] = def;
//# sourceMappingURL=limitItems.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/limitLength.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const ucs2length_1 = __webpack_require__("./node_modules/ajv/dist/runtime/ucs2length.js");
const error = {
    message({ keyword, schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, codegen_1.str) `must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode }) => (0, codegen_1._) `{limit: ${schemaCode}}`,
};
const def = {
    keyword: ["maxLength", "minLength"],
    type: "string",
    schemaType: "number",
    $data: true,
    error,
    code(cxt) {
        const { keyword, data, schemaCode, it } = cxt;
        const op = keyword === "maxLength" ? codegen_1.operators.GT : codegen_1.operators.LT;
        const len = it.opts.unicode === false ? (0, codegen_1._) `${data}.length` : (0, codegen_1._) `${(0, util_1.useFunc)(cxt.gen, ucs2length_1.default)}(${data})`;
        cxt.fail$data((0, codegen_1._) `${len} ${op} ${schemaCode}`);
    },
};
exports["default"] = def;
//# sourceMappingURL=limitLength.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/limitNumber.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const ops = codegen_1.operators;
const KWDs = {
    maximum: { okStr: "<=", ok: ops.LTE, fail: ops.GT },
    minimum: { okStr: ">=", ok: ops.GTE, fail: ops.LT },
    exclusiveMaximum: { okStr: "<", ok: ops.LT, fail: ops.GTE },
    exclusiveMinimum: { okStr: ">", ok: ops.GT, fail: ops.LTE },
};
const error = {
    message: ({ keyword, schemaCode }) => (0, codegen_1.str) `must be ${KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword, schemaCode }) => (0, codegen_1._) `{comparison: ${KWDs[keyword].okStr}, limit: ${schemaCode}}`,
};
const def = {
    keyword: Object.keys(KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error,
    code(cxt) {
        const { keyword, data, schemaCode } = cxt;
        cxt.fail$data((0, codegen_1._) `${data} ${KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    },
};
exports["default"] = def;
//# sourceMappingURL=limitNumber.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/limitProperties.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const error = {
    message({ keyword, schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, codegen_1.str) `must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode }) => (0, codegen_1._) `{limit: ${schemaCode}}`,
};
const def = {
    keyword: ["maxProperties", "minProperties"],
    type: "object",
    schemaType: "number",
    $data: true,
    error,
    code(cxt) {
        const { keyword, data, schemaCode } = cxt;
        const op = keyword === "maxProperties" ? codegen_1.operators.GT : codegen_1.operators.LT;
        cxt.fail$data((0, codegen_1._) `Object.keys(${data}).length ${op} ${schemaCode}`);
    },
};
exports["default"] = def;
//# sourceMappingURL=limitProperties.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/multipleOf.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const error = {
    message: ({ schemaCode }) => (0, codegen_1.str) `must be multiple of ${schemaCode}`,
    params: ({ schemaCode }) => (0, codegen_1._) `{multipleOf: ${schemaCode}}`,
};
const def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error,
    code(cxt) {
        const { gen, data, schemaCode, it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec
            ? (0, codegen_1._) `Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}`
            : (0, codegen_1._) `${res} !== parseInt(${res})`;
        cxt.fail$data((0, codegen_1._) `(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    },
};
exports["default"] = def;
//# sourceMappingURL=multipleOf.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/pattern.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const error = {
    message: ({ schemaCode }) => (0, codegen_1.str) `must match pattern "${schemaCode}"`,
    params: ({ schemaCode }) => (0, codegen_1._) `{pattern: ${schemaCode}}`,
};
const def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error,
    code(cxt) {
        const { data, $data, schema, schemaCode, it } = cxt;
        // TODO regexp should be wrapped in try/catchs
        const u = it.opts.unicodeRegExp ? "u" : "";
        const regExp = $data ? (0, codegen_1._) `(new RegExp(${schemaCode}, ${u}))` : (0, code_1.usePattern)(cxt, schema);
        cxt.fail$data((0, codegen_1._) `!${regExp}.test(${data})`);
    },
};
exports["default"] = def;
//# sourceMappingURL=pattern.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/required.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const code_1 = __webpack_require__("./node_modules/ajv/dist/vocabularies/code.js");
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const error = {
    message: ({ params: { missingProperty } }) => (0, codegen_1.str) `must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty } }) => (0, codegen_1._) `{missingProperty: ${missingProperty}}`,
};
const def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error,
    code(cxt) {
        const { gen, schema, schemaCode, data, $data, it } = cxt;
        const { opts } = it;
        if (!$data && schema.length === 0)
            return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors)
            allErrorsMode();
        else
            exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties } = cxt.it;
            for (const requiredKey of schema) {
                if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                    const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                    (0, util_1.checkStrictMode)(it, msg, it.opts.strictRequired);
                }
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) {
                cxt.block$data(codegen_1.nil, loopAllRequired);
            }
            else {
                for (const prop of schema) {
                    (0, code_1.checkReportMissingProp)(cxt, prop);
                }
            }
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, () => loopUntilMissing(missing, valid));
                cxt.ok(valid);
            }
            else {
                gen.if((0, code_1.checkMissingProp)(cxt, schema, missing));
                (0, code_1.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop) => {
                cxt.setParams({ missingProperty: prop });
                gen.if((0, code_1.noPropertyInData)(gen, data, prop, opts.ownProperties), () => cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({ missingProperty: missing });
            gen.forOf(missing, schemaCode, () => {
                gen.assign(valid, (0, code_1.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, codegen_1.not)(valid), () => {
                    cxt.error();
                    gen.break();
                });
            }, codegen_1.nil);
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=required.js.map

/***/ }),

/***/ "./node_modules/ajv/dist/vocabularies/validation/uniqueItems.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const dataType_1 = __webpack_require__("./node_modules/ajv/dist/compile/validate/dataType.js");
const codegen_1 = __webpack_require__("./node_modules/ajv/dist/compile/codegen/index.js");
const util_1 = __webpack_require__("./node_modules/ajv/dist/compile/util.js");
const equal_1 = __webpack_require__("./node_modules/ajv/dist/runtime/equal.js");
const error = {
    message: ({ params: { i, j } }) => (0, codegen_1.str) `must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i, j } }) => (0, codegen_1._) `{i: ${i}, j: ${j}}`,
};
const def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error,
    code(cxt) {
        const { gen, data, $data, schema, parentSchema, schemaCode, it } = cxt;
        if (!$data && !schema)
            return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, dataType_1.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, codegen_1._) `${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, codegen_1._) `${data}.length`);
            const j = gen.let("j");
            cxt.setParams({ i, j });
            gen.assign(valid, true);
            gen.if((0, codegen_1._) `${i} > 1`, () => (canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t) => t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, dataType_1.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, dataType_1.DataType.Wrong);
            const indices = gen.const("indices", (0, codegen_1._) `{}`);
            gen.for((0, codegen_1._) `;${i}--;`, () => {
                gen.let(item, (0, codegen_1._) `${data}[${i}]`);
                gen.if(wrongType, (0, codegen_1._) `continue`);
                if (itemTypes.length > 1)
                    gen.if((0, codegen_1._) `typeof ${item} == "string"`, (0, codegen_1._) `${item} += "_"`);
                gen
                    .if((0, codegen_1._) `typeof ${indices}[${item}] == "number"`, () => {
                    gen.assign(j, (0, codegen_1._) `${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                })
                    .code((0, codegen_1._) `${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, util_1.useFunc)(gen, equal_1.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, codegen_1._) `;${i}--;`, () => gen.for((0, codegen_1._) `${j} = ${i}; ${j}--;`, () => gen.if((0, codegen_1._) `${eql}(${data}[${i}], ${data}[${j}])`, () => {
                cxt.error();
                gen.assign(valid, false).break(outer);
            })));
        }
    },
};
exports["default"] = def;
//# sourceMappingURL=uniqueItems.js.map

/***/ }),

/***/ "./node_modules/json-schema-traverse/index.js":
/***/ ((module) => {

"use strict";


var traverse = module.exports = function (schema, opts, cb) {
  // Legacy support for v0.3.1 and earlier.
  if (typeof opts == 'function') {
    cb = opts;
    opts = {};
  }

  cb = opts.cb || cb;
  var pre = (typeof cb == 'function') ? cb : cb.pre || function() {};
  var post = cb.post || function() {};

  _traverse(opts, pre, post, schema, '', schema);
};


traverse.keywords = {
  additionalItems: true,
  items: true,
  contains: true,
  additionalProperties: true,
  propertyNames: true,
  not: true,
  if: true,
  then: true,
  else: true
};

traverse.arrayKeywords = {
  items: true,
  allOf: true,
  anyOf: true,
  oneOf: true
};

traverse.propsKeywords = {
  $defs: true,
  definitions: true,
  properties: true,
  patternProperties: true,
  dependencies: true
};

traverse.skipKeywords = {
  default: true,
  enum: true,
  const: true,
  required: true,
  maximum: true,
  minimum: true,
  exclusiveMaximum: true,
  exclusiveMinimum: true,
  multipleOf: true,
  maxLength: true,
  minLength: true,
  pattern: true,
  format: true,
  maxItems: true,
  minItems: true,
  uniqueItems: true,
  maxProperties: true,
  minProperties: true
};


function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
  if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
    pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    for (var key in schema) {
      var sch = schema[key];
      if (Array.isArray(sch)) {
        if (key in traverse.arrayKeywords) {
          for (var i=0; i<sch.length; i++)
            _traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
        }
      } else if (key in traverse.propsKeywords) {
        if (sch && typeof sch == 'object') {
          for (var prop in sch)
            _traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
        }
      } else if (key in traverse.keywords || (opts.allKeys && !(key in traverse.skipKeywords))) {
        _traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
      }
    }
    post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
  }
}


function escapeJsonPtr(str) {
  return str.replace(/~/g, '~0').replace(/\//g, '~1');
}


/***/ }),

/***/ "./node_modules/p-limit/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

const Queue = __webpack_require__("../../node_modules/yocto-queue/index.js");

const pLimit = concurrency => {
	if (!((Number.isInteger(concurrency) || concurrency === Infinity) && concurrency > 0)) {
		throw new TypeError('Expected `concurrency` to be a number from 1 and up');
	}

	const queue = new Queue();
	let activeCount = 0;

	const next = () => {
		activeCount--;

		if (queue.size > 0) {
			queue.dequeue()();
		}
	};

	const run = async (fn, resolve, ...args) => {
		activeCount++;

		const result = (async () => fn(...args))();

		resolve(result);

		try {
			await result;
		} catch {}

		next();
	};

	const enqueue = (fn, resolve, ...args) => {
		queue.enqueue(run.bind(null, fn, resolve, ...args));

		(async () => {
			// This function needs to wait until the next microtask before comparing
			// `activeCount` to `concurrency`, because `activeCount` is updated asynchronously
			// when the run function is dequeued and called. The comparison in the if-statement
			// needs to happen asynchronously as well to get an up-to-date value for `activeCount`.
			await Promise.resolve();

			if (activeCount < concurrency && queue.size > 0) {
				queue.dequeue()();
			}
		})();
	};

	const generator = (fn, ...args) => new Promise(resolve => {
		enqueue(fn, resolve, ...args);
	});

	Object.defineProperties(generator, {
		activeCount: {
			get: () => activeCount
		},
		pendingCount: {
			get: () => queue.size
		},
		clearQueue: {
			value: () => {
				queue.clear();
			}
		}
	});

	return generator;
};

module.exports = pLimit;


/***/ }),

/***/ "./node_modules/split2/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/*
Copyright (c) 2014-2021, Matteo Collina <hello@matteocollina.com>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/



const { Transform } = __webpack_require__("../../node_modules/readable-stream/lib/ours/browser.js")
const { StringDecoder } = __webpack_require__("../../node_modules/string_decoder/lib/string_decoder.js")
const kLast = Symbol('last')
const kDecoder = Symbol('decoder')

function transform (chunk, enc, cb) {
  let list
  if (this.overflow) { // Line buffer is full. Skip to start of next line.
    const buf = this[kDecoder].write(chunk)
    list = buf.split(this.matcher)

    if (list.length === 1) return cb() // Line ending not found. Discard entire chunk.

    // Line ending found. Discard trailing fragment of previous line and reset overflow state.
    list.shift()
    this.overflow = false
  } else {
    this[kLast] += this[kDecoder].write(chunk)
    list = this[kLast].split(this.matcher)
  }

  this[kLast] = list.pop()

  for (let i = 0; i < list.length; i++) {
    try {
      push(this, this.mapper(list[i]))
    } catch (error) {
      return cb(error)
    }
  }

  this.overflow = this[kLast].length > this.maxLength
  if (this.overflow && !this.skipOverflow) {
    cb(new Error('maximum buffer reached'))
    return
  }

  cb()
}

function flush (cb) {
  // forward any gibberish left in there
  this[kLast] += this[kDecoder].end()

  if (this[kLast]) {
    try {
      push(this, this.mapper(this[kLast]))
    } catch (error) {
      return cb(error)
    }
  }

  cb()
}

function push (self, val) {
  if (val !== undefined) {
    self.push(val)
  }
}

function noop (incoming) {
  return incoming
}

function split (matcher, mapper, options) {
  // Set defaults for any arguments not supplied.
  matcher = matcher || /\r?\n/
  mapper = mapper || noop
  options = options || {}

  // Test arguments explicitly.
  switch (arguments.length) {
    case 1:
      // If mapper is only argument.
      if (typeof matcher === 'function') {
        mapper = matcher
        matcher = /\r?\n/
      // If options is only argument.
      } else if (typeof matcher === 'object' && !(matcher instanceof RegExp) && !matcher[Symbol.split]) {
        options = matcher
        matcher = /\r?\n/
      }
      break

    case 2:
      // If mapper and options are arguments.
      if (typeof matcher === 'function') {
        options = mapper
        mapper = matcher
        matcher = /\r?\n/
      // If matcher and options are arguments.
      } else if (typeof mapper === 'object') {
        options = mapper
        mapper = noop
      }
  }

  options = Object.assign({}, options)
  options.autoDestroy = true
  options.transform = transform
  options.flush = flush
  options.readableObjectMode = true

  const stream = new Transform(options)

  stream[kLast] = ''
  stream[kDecoder] = new StringDecoder('utf8')
  stream.matcher = matcher
  stream.mapper = mapper
  stream.maxLength = options.maxLength
  stream.skipOverflow = options.skipOverflow || false
  stream.overflow = false
  stream._destroy = function (err, cb) {
    // Weird Node v12 bug that we need to work around
    this._writableState.errorEmitted = false
    cb(err)
  }

  return stream
}

module.exports = split


/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "NIL", ({
  enumerable: true,
  get: function get() {
    return _nil.default;
  }
}));
Object.defineProperty(exports, "parse", ({
  enumerable: true,
  get: function get() {
    return _parse.default;
  }
}));
Object.defineProperty(exports, "stringify", ({
  enumerable: true,
  get: function get() {
    return _stringify.default;
  }
}));
Object.defineProperty(exports, "v1", ({
  enumerable: true,
  get: function get() {
    return _v.default;
  }
}));
Object.defineProperty(exports, "v3", ({
  enumerable: true,
  get: function get() {
    return _v2.default;
  }
}));
Object.defineProperty(exports, "v4", ({
  enumerable: true,
  get: function get() {
    return _v3.default;
  }
}));
Object.defineProperty(exports, "v5", ({
  enumerable: true,
  get: function get() {
    return _v4.default;
  }
}));
Object.defineProperty(exports, "validate", ({
  enumerable: true,
  get: function get() {
    return _validate.default;
  }
}));
Object.defineProperty(exports, "version", ({
  enumerable: true,
  get: function get() {
    return _version.default;
  }
}));

var _v = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/v1.js"));

var _v2 = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/v3.js"));

var _v3 = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/v4.js"));

var _v4 = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/v5.js"));

var _nil = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/nil.js"));

var _version = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/version.js"));

var _validate = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/validate.js"));

var _stringify = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/stringify.js"));

var _parse = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/parse.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/md5.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

var _default = md5;
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/native.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _default = {
  randomUUID
};
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/nil.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = '00000000-0000-0000-0000-000000000000';
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/parse.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

var _default = parse;
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/regex.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/rng.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/sha1.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

var _default = sha1;
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/stringify.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.unsafeStringify = unsafeStringify;

var _validate = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

var _default = stringify;
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/v1.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _rng = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/rng.js"));

var _stringify = __webpack_require__("./node_modules/uuid/dist/commonjs-browser/stringify.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || _rng.default)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || (0, _stringify.unsafeStringify)(b);
}

var _default = v1;
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/v3.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/v35.js"));

var _md = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/md5.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v3 = (0, _v.default)('v3', 0x30, _md.default);
var _default = v3;
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/v35.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.URL = exports.DNS = void 0;
exports["default"] = v35;

var _stringify = __webpack_require__("./node_modules/uuid/dist/commonjs-browser/stringify.js");

var _parse = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/parse.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
exports.DNS = DNS;
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
exports.URL = URL;

function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;

    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = (0, _parse.default)(namespace);
    }

    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return (0, _stringify.unsafeStringify)(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/v4.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _native = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/native.js"));

var _rng = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/rng.js"));

var _stringify = __webpack_require__("./node_modules/uuid/dist/commonjs-browser/stringify.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function v4(options, buf, offset) {
  if (_native.default.randomUUID && !buf && !options) {
    return _native.default.randomUUID();
  }

  options = options || {};

  const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0, _stringify.unsafeStringify)(rnds);
}

var _default = v4;
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/v5.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/v35.js"));

var _sha = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/sha1.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v5 = (0, _v.default)('v5', 0x50, _sha.default);
var _default = v5;
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/validate.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _regex = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/regex.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(uuid) {
  return typeof uuid === 'string' && _regex.default.test(uuid);
}

var _default = validate;
exports["default"] = _default;

/***/ }),

/***/ "./node_modules/uuid/dist/commonjs-browser/version.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__("./node_modules/uuid/dist/commonjs-browser/validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function version(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.slice(14, 15), 16);
}

var _default = version;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "NIL", ({
  enumerable: true,
  get: function get() {
    return _nil.default;
  }
}));
Object.defineProperty(exports, "parse", ({
  enumerable: true,
  get: function get() {
    return _parse.default;
  }
}));
Object.defineProperty(exports, "stringify", ({
  enumerable: true,
  get: function get() {
    return _stringify.default;
  }
}));
Object.defineProperty(exports, "v1", ({
  enumerable: true,
  get: function get() {
    return _v.default;
  }
}));
Object.defineProperty(exports, "v3", ({
  enumerable: true,
  get: function get() {
    return _v2.default;
  }
}));
Object.defineProperty(exports, "v4", ({
  enumerable: true,
  get: function get() {
    return _v3.default;
  }
}));
Object.defineProperty(exports, "v5", ({
  enumerable: true,
  get: function get() {
    return _v4.default;
  }
}));
Object.defineProperty(exports, "validate", ({
  enumerable: true,
  get: function get() {
    return _validate.default;
  }
}));
Object.defineProperty(exports, "version", ({
  enumerable: true,
  get: function get() {
    return _version.default;
  }
}));

var _v = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/v1.js"));

var _v2 = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/v3.js"));

var _v3 = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/v4.js"));

var _v4 = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/v5.js"));

var _nil = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/nil.js"));

var _version = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/version.js"));

var _validate = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/validate.js"));

var _stringify = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/stringify.js"));

var _parse = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/parse.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/md5.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (let i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  const output = [];
  const length32 = input.length * 32;
  const hexTab = '0123456789abcdef';

  for (let i = 0; i < length32; i += 8) {
    const x = input[i >> 5] >>> i % 32 & 0xff;
    const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;

  for (let i = 0; i < x.length; i += 16) {
    const olda = a;
    const oldb = b;
    const oldc = c;
    const oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  const length8 = input.length * 8;
  const output = new Uint32Array(getOutputLength(length8));

  for (let i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  const lsw = (x & 0xffff) + (y & 0xffff);
  const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

var _default = md5;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/native.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var _default = {
  randomUUID
};
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/nil.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = '00000000-0000-0000-0000-000000000000';
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/parse.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parse(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  let v;
  const arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

var _default = parse;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/regex.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/rng.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);

function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/sha1.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  const K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  const H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (let i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  const l = bytes.length / 4 + 2;
  const N = Math.ceil(l / 16);
  const M = new Array(N);

  for (let i = 0; i < N; ++i) {
    const arr = new Uint32Array(16);

    for (let j = 0; j < 16; ++j) {
      arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
    }

    M[i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (let i = 0; i < N; ++i) {
    const W = new Uint32Array(80);

    for (let t = 0; t < 16; ++t) {
      W[t] = M[i][t];
    }

    for (let t = 16; t < 80; ++t) {
      W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
    }

    let a = H[0];
    let b = H[1];
    let c = H[2];
    let d = H[3];
    let e = H[4];

    for (let t = 0; t < 80; ++t) {
      const s = Math.floor(t / 20);
      const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

var _default = sha1;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/stringify.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.unsafeStringify = unsafeStringify;

var _validate = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

var _default = stringify;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/v1.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _rng = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/rng.js"));

var _stringify = __webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/stringify.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;

let _clockseq; // Previous uuid creation time


let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  let i = buf && offset || 0;
  const b = buf || new Array(16);
  options = options || {};
  let node = options.node || _nodeId;
  let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || _rng.default)();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (let n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || (0, _stringify.unsafeStringify)(b);
}

var _default = v1;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/v3.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/v35.js"));

var _md = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/md5.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v3 = (0, _v.default)('v3', 0x30, _md.default);
var _default = v3;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/v35.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.URL = exports.DNS = void 0;
exports["default"] = v35;

var _stringify = __webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/stringify.js");

var _parse = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/parse.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  const bytes = [];

  for (let i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
exports.DNS = DNS;
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
exports.URL = URL;

function v35(name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;

    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = (0, _parse.default)(namespace);
    }

    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (let i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return (0, _stringify.unsafeStringify)(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
}

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/v4.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _native = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/native.js"));

var _rng = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/rng.js"));

var _stringify = __webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/stringify.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function v4(options, buf, offset) {
  if (_native.default.randomUUID && !buf && !options) {
    return _native.default.randomUUID();
  }

  options = options || {};

  const rnds = options.random || (options.rng || _rng.default)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return (0, _stringify.unsafeStringify)(rnds);
}

var _default = v4;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/v5.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _v = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/v35.js"));

var _sha = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/sha1.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const v5 = (0, _v.default)('v5', 0x50, _sha.default);
var _default = v5;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/validate.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _regex = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/regex.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(uuid) {
  return typeof uuid === 'string' && _regex.default.test(uuid);
}

var _default = validate;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/uuid/dist/commonjs-browser/version.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _validate = _interopRequireDefault(__webpack_require__("../network/node_modules/uuid/dist/commonjs-browser/validate.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function version(uuid) {
  if (!(0, _validate.default)(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.slice(14, 15), 16);
}

var _default = version;
exports["default"] = _default;

/***/ }),

/***/ "../network/node_modules/yallist/iterator.js":
/***/ ((module) => {

"use strict";

module.exports = function (Yallist) {
  Yallist.prototype[Symbol.iterator] = function* () {
    for (let walker = this.head; walker; walker = walker.next) {
      yield walker.value
    }
  }
}


/***/ }),

/***/ "../network/node_modules/yallist/yallist.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = Yallist

Yallist.Node = Node
Yallist.create = Yallist

function Yallist (list) {
  var self = this
  if (!(self instanceof Yallist)) {
    self = new Yallist()
  }

  self.tail = null
  self.head = null
  self.length = 0

  if (list && typeof list.forEach === 'function') {
    list.forEach(function (item) {
      self.push(item)
    })
  } else if (arguments.length > 0) {
    for (var i = 0, l = arguments.length; i < l; i++) {
      self.push(arguments[i])
    }
  }

  return self
}

Yallist.prototype.removeNode = function (node) {
  if (node.list !== this) {
    throw new Error('removing node which does not belong to this list')
  }

  var next = node.next
  var prev = node.prev

  if (next) {
    next.prev = prev
  }

  if (prev) {
    prev.next = next
  }

  if (node === this.head) {
    this.head = next
  }
  if (node === this.tail) {
    this.tail = prev
  }

  node.list.length--
  node.next = null
  node.prev = null
  node.list = null

  return next
}

Yallist.prototype.unshiftNode = function (node) {
  if (node === this.head) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var head = this.head
  node.list = this
  node.next = head
  if (head) {
    head.prev = node
  }

  this.head = node
  if (!this.tail) {
    this.tail = node
  }
  this.length++
}

Yallist.prototype.pushNode = function (node) {
  if (node === this.tail) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var tail = this.tail
  node.list = this
  node.prev = tail
  if (tail) {
    tail.next = node
  }

  this.tail = node
  if (!this.head) {
    this.head = node
  }
  this.length++
}

Yallist.prototype.push = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    push(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.unshift = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    unshift(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.pop = function () {
  if (!this.tail) {
    return undefined
  }

  var res = this.tail.value
  this.tail = this.tail.prev
  if (this.tail) {
    this.tail.next = null
  } else {
    this.head = null
  }
  this.length--
  return res
}

Yallist.prototype.shift = function () {
  if (!this.head) {
    return undefined
  }

  var res = this.head.value
  this.head = this.head.next
  if (this.head) {
    this.head.prev = null
  } else {
    this.tail = null
  }
  this.length--
  return res
}

Yallist.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.head, i = 0; walker !== null; i++) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.next
  }
}

Yallist.prototype.forEachReverse = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.prev
  }
}

Yallist.prototype.get = function (n) {
  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.next
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.getReverse = function (n) {
  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.prev
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.map = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.head; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.next
  }
  return res
}

Yallist.prototype.mapReverse = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.tail; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.prev
  }
  return res
}

Yallist.prototype.reduce = function (fn, initial) {
  var acc
  var walker = this.head
  if (arguments.length > 1) {
    acc = initial
  } else if (this.head) {
    walker = this.head.next
    acc = this.head.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = 0; walker !== null; i++) {
    acc = fn(acc, walker.value, i)
    walker = walker.next
  }

  return acc
}

Yallist.prototype.reduceReverse = function (fn, initial) {
  var acc
  var walker = this.tail
  if (arguments.length > 1) {
    acc = initial
  } else if (this.tail) {
    walker = this.tail.prev
    acc = this.tail.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = this.length - 1; walker !== null; i--) {
    acc = fn(acc, walker.value, i)
    walker = walker.prev
  }

  return acc
}

Yallist.prototype.toArray = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.head; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.next
  }
  return arr
}

Yallist.prototype.toArrayReverse = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.tail; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.prev
  }
  return arr
}

Yallist.prototype.slice = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
    walker = walker.next
  }
  for (; walker !== null && i < to; i++, walker = walker.next) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.sliceReverse = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
    walker = walker.prev
  }
  for (; walker !== null && i > from; i--, walker = walker.prev) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.splice = function (start, deleteCount, ...nodes) {
  if (start > this.length) {
    start = this.length - 1
  }
  if (start < 0) {
    start = this.length + start;
  }

  for (var i = 0, walker = this.head; walker !== null && i < start; i++) {
    walker = walker.next
  }

  var ret = []
  for (var i = 0; walker && i < deleteCount; i++) {
    ret.push(walker.value)
    walker = this.removeNode(walker)
  }
  if (walker === null) {
    walker = this.tail
  }

  if (walker !== this.head && walker !== this.tail) {
    walker = walker.prev
  }

  for (var i = 0; i < nodes.length; i++) {
    walker = insert(this, walker, nodes[i])
  }
  return ret;
}

Yallist.prototype.reverse = function () {
  var head = this.head
  var tail = this.tail
  for (var walker = head; walker !== null; walker = walker.prev) {
    var p = walker.prev
    walker.prev = walker.next
    walker.next = p
  }
  this.head = tail
  this.tail = head
  return this
}

function insert (self, node, value) {
  var inserted = node === self.head ?
    new Node(value, null, node, self) :
    new Node(value, node, node.next, self)

  if (inserted.next === null) {
    self.tail = inserted
  }
  if (inserted.prev === null) {
    self.head = inserted
  }

  self.length++

  return inserted
}

function push (self, item) {
  self.tail = new Node(item, self.tail, null, self)
  if (!self.head) {
    self.head = self.tail
  }
  self.length++
}

function unshift (self, item) {
  self.head = new Node(item, null, self.head, self)
  if (!self.tail) {
    self.tail = self.head
  }
  self.length++
}

function Node (value, prev, next, list) {
  if (!(this instanceof Node)) {
    return new Node(value, prev, next, list)
  }

  this.list = list
  this.value = value

  if (prev) {
    prev.next = this
    this.prev = prev
  } else {
    this.prev = null
  }

  if (next) {
    next.prev = this
    this.next = next
  } else {
    this.next = null
  }
}

try {
  // add if support for Symbol.iterator is present
  __webpack_require__("../network/node_modules/yallist/iterator.js")(Yallist)
} catch (er) {}


/***/ }),

/***/ "?3436":
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?2209":
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?e6da":
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?ff61":
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?ec48":
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?d5c0":
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?4a48":
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "../../node_modules/@lit-protocol/access-control-conditions/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/access-control-conditions/src/lib/canonicalFormatter.js"), exports);
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/access-control-conditions/src/lib/hashing.js"), exports);
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/access-control-conditions/src/lib/humanizer.js"), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/access-control-conditions/src/lib/canonicalFormatter.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.canonicalResourceIdFormatter = exports.canonicalCosmosConditionFormatter = exports.canonicalEVMContractConditionFormatter = exports.canonicalAccessControlConditionFormatter = exports.canonicalSolRpcConditionFormatter = exports.canonicalUnifiedAccessControlConditionFormatter = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
/** ---------- Local Functions ---------- */
/**
 *
 * Get operator param
 *
 * @param { ConditionItem } cond
 * @returns { AccsOperatorParams }
 */
const getOperatorParam = (cond) => {
    const _cond = cond;
    return {
        operator: _cond.operator,
    };
};
/**
 *
 * Canonical ABI Params
 *
 * @param { Array<ABIParams> } params
 * @returns { Array<ABIParams> }
 */
const canonicalAbiParamss = (params) => {
    return params.map((param) => ({
        name: param.name,
        type: param.type,
    }));
};
/**
 *
 * Canonical Unified Access Control Condition Formatter
 *
 * @param { ConditionItem | Array<ConditionItem> } cond
 * @returns { any[] | AccsOperatorParams | any }
 */
const canonicalUnifiedAccessControlConditionFormatter = (cond) => {
    // -- if it's an array
    if (Array.isArray(cond)) {
        return cond.map((c) => (0, exports.canonicalUnifiedAccessControlConditionFormatter)(c));
    }
    // -- if there's a `operator` key in the object
    if ('operator' in cond) {
        return getOperatorParam(cond);
    }
    // -- otherwise
    if ('returnValueTest' in cond) {
        const _cond = cond;
        const _conditionType = _cond.conditionType;
        switch (_conditionType) {
            case 'solRpc':
                return (0, exports.canonicalSolRpcConditionFormatter)(cond, true);
            case 'evmBasic':
                return (0, exports.canonicalAccessControlConditionFormatter)(cond);
            case 'evmContract':
                return (0, exports.canonicalEVMContractConditionFormatter)(cond);
            case 'cosmos':
                return (0, exports.canonicalCosmosConditionFormatter)(cond);
            default:
                (0, misc_1.throwError)({
                    message: `You passed an invalid access control condition that is missing or has a wrong "conditionType": ${JSON.stringify(cond)}`,
                    errorKind: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.name,
                });
        }
    }
    (0, misc_1.throwError)({
        message: `You passed an invalid access control condition: ${cond}`,
        errorKind: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.kind,
        errorCode: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.name,
    });
};
exports.canonicalUnifiedAccessControlConditionFormatter = canonicalUnifiedAccessControlConditionFormatter;
/**
*
* (SOLANA) Canonical Solana RPC Condition Formatter
*
* need to return in the exact format below:
* but make sure we don't include the optional fields:
 ---
  #[derive(Debug, Serialize, Deserialize, Clone)]
  #[serde(rename_all = "camelCase")]
  pub struct SolRpcCondition {
      pub method: String,
      pub params: Vec<serde_json::Value>,
      pub pda_params: Option<Vec<serde_json::Value>>,
      pub pda_interface: Option<SolPdaInterface>,
      pub chain: String,
      pub return_value_test: JsonReturnValueTestV2,
  }

  #[derive(Debug, Serialize, Deserialize, Clone)]
  #[serde(rename_all = "camelCase")]
  pub struct SolPdaInterface {
      pub offset: u64,
      pub fields: serde_json::Value,
  }
  ---
*
* @param { object } cond
* @param { boolean } requireV2Conditions
*
* @returns { any[] | AccsOperatorParams | AccsRegularParams | AccsSOLV2Params | ILitError | any }
*/
const canonicalSolRpcConditionFormatter = (cond, requireV2Conditions = false) => {
    // -- if is array
    if (Array.isArray(cond)) {
        return cond.map((c) => (0, exports.canonicalSolRpcConditionFormatter)(c, requireV2Conditions));
    }
    // -- if there's a `operator` key in the object
    if ('operator' in cond) {
        return getOperatorParam(cond);
    }
    // -- if it has a return value
    if ('returnValueTest' in cond) {
        const { returnValueTest } = cond;
        const canonicalReturnValueTest = {
            key: returnValueTest.key,
            comparator: returnValueTest.comparator,
            value: returnValueTest.value,
        };
        // -- check if this is a sol v1 or v2 condition
        // -- v1 conditions didn't have any pda params or pda interface or pda key
        // -- SOL version 1:: return V2 must have params
        if ('pdaParams' in cond || requireV2Conditions) {
            const _assumedV2Cond = cond;
            if (!('pdaInterface' in _assumedV2Cond) ||
                !('pdaKey' in _assumedV2Cond) ||
                !('offset' in _assumedV2Cond.pdaInterface) ||
                !('fields' in _assumedV2Cond.pdaInterface)) {
                (0, misc_1.throwError)({
                    message: `Solana RPC Conditions have changed and there are some new fields you must include in your condition.  Check the docs here: https://developer.litprotocol.com/AccessControlConditions/solRpcConditions`,
                    errorKind: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.name,
                });
            }
            // -- else
            const canonicalPdaInterface = {
                offset: _assumedV2Cond.pdaInterface.offset,
                fields: _assumedV2Cond.pdaInterface.fields,
            };
            const _solV2Cond = cond;
            const _requiredParams = {
                method: _solV2Cond.method,
                params: _solV2Cond.params,
                pdaParams: _solV2Cond.pdaParams,
                pdaInterface: canonicalPdaInterface,
                pdaKey: _solV2Cond.pdaKey,
                chain: _solV2Cond.chain,
                returnValueTest: canonicalReturnValueTest,
            };
            return _requiredParams;
            // -- SOL version 2:: return default params
        }
        else {
            const _solV1Cond = cond;
            const _requiredParams = {
                method: _solV1Cond.method,
                params: _solV1Cond.params,
                chain: _solV1Cond.chain,
                returnValueTest: canonicalReturnValueTest,
            };
            return _requiredParams;
        }
    }
    // -- else
    (0, misc_1.throwError)({
        message: `You passed an invalid access control condition: ${cond}`,
        errorKind: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.kind,
        errorCode: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.name,
    });
};
exports.canonicalSolRpcConditionFormatter = canonicalSolRpcConditionFormatter;
/**
*
* (DEFAULT) Canonical Access Control Condition Formatter
*
* need to return in the exact format below:
 ---
  pub struct JsonAccessControlCondition {
    pub contract_address: String,
    pub chain: String,
    pub standard_contract_type: String,
    pub method: String,
    pub parameters: Vec<String>,
    pub return_value_test: JsonReturnValueTest,
  }
  ---
*
* @param { object } cond
*
* @returns { any[] | AccsOperatorParams | AccsDefaultParams | any }
*/
const canonicalAccessControlConditionFormatter = (cond) => {
    // -- if it's an array
    if (Array.isArray(cond)) {
        return cond.map((c) => (0, exports.canonicalAccessControlConditionFormatter)(c));
    }
    // -- if there's a `operator` key in the object
    if ('operator' in cond) {
        return getOperatorParam(cond);
    }
    if ('returnValueTest' in cond) {
        const _cond = cond;
        const _return = {
            contractAddress: _cond.contractAddress,
            chain: _cond.chain,
            standardContractType: _cond.standardContractType,
            method: _cond.method,
            parameters: _cond.parameters,
            returnValueTest: {
                comparator: _cond.returnValueTest.comparator,
                value: _cond.returnValueTest.value,
            },
        };
        return _return;
    }
    (0, misc_1.throwError)({
        message: `You passed an invalid access control condition: ${cond}`,
        errorKind: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.kind,
        errorCode: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.name,
    });
};
exports.canonicalAccessControlConditionFormatter = canonicalAccessControlConditionFormatter;
/**
*
* (EVM) Canonical EVM Contract Condition Formatter
*
*  need to return in the exact format below:
  ---
  pub struct JsonAccessControlCondition {
      pub contract_address: String,
      pub chain: String,
      pub standard_contract_type: String,
      pub method: String,
      pub parameters: Vec<String>,
      pub return_value_test: JsonReturnValueTest,
  }
  ---
*
* @param { ConditionItem } cond
*
* @returns
*/
const canonicalEVMContractConditionFormatter = (cond) => {
    // -- if it's an array
    if (Array.isArray(cond)) {
        return cond.map((c) => (0, exports.canonicalEVMContractConditionFormatter)(c));
    }
    // -- if there's a `operator` key in the object
    if ('operator' in cond) {
        const _cond = cond;
        return {
            operator: _cond.operator,
        };
    }
    if ('returnValueTest' in cond) {
        /* abi needs to match:
          pub name: String,
          /// Function input.
          pub inputs: Vec<Param>,
          /// Function output.
          pub outputs: Vec<Param>,
          #[deprecated(note = "The constant attribute was removed in Solidity 0.5.0 and has been \
              replaced with stateMutability. If parsing a JSON AST created with \
              this version or later this value will always be false, which may be wrong.")]
          /// Constant function.
          #[cfg_attr(feature = "full-serde", serde(default))]
          pub constant: bool,
          /// Whether the function reads or modifies blockchain state
          #[cfg_attr(feature = "full-serde", serde(rename = "stateMutability", default))]
          pub state_mutability: StateMutability,
          */
        const evmCond = cond;
        const { functionAbi, returnValueTest } = evmCond;
        const canonicalAbi = {
            name: functionAbi.name,
            inputs: canonicalAbiParamss(functionAbi.inputs),
            outputs: canonicalAbiParamss(functionAbi.outputs),
            constant: typeof functionAbi.constant === 'undefined'
                ? false
                : functionAbi.constant,
            stateMutability: functionAbi.stateMutability,
        };
        const canonicalReturnValueTest = {
            key: returnValueTest.key,
            comparator: returnValueTest.comparator,
            value: returnValueTest.value,
        };
        const _return = {
            contractAddress: evmCond.contractAddress,
            functionName: evmCond.functionName,
            functionParams: evmCond.functionParams,
            functionAbi: canonicalAbi,
            chain: evmCond.chain,
            returnValueTest: canonicalReturnValueTest,
        };
        return _return;
    }
    (0, misc_1.throwError)({
        message: `You passed an invalid access control condition: ${cond}`,
        errorKind: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.kind,
        errorCode: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.name,
    });
};
exports.canonicalEVMContractConditionFormatter = canonicalEVMContractConditionFormatter;
/**
*
* (COSMOS) Canonical Condition Formmater for Cosmos
*
* need to return in the exact format below:
 ---
  pub struct CosmosCondition {
      pub path: String,
      pub chain: String,
      pub return_value_test: JsonReturnValueTestV2,
  }
 ---
*
*
* @param { ConditionItem } cond
* @returns
*/
const canonicalCosmosConditionFormatter = (cond) => {
    // -- if it's an array
    if (Array.isArray(cond)) {
        return cond.map((c) => (0, exports.canonicalCosmosConditionFormatter)(c));
    }
    // -- if there's a `operator` key in the object
    if ('operator' in cond) {
        const _cond = cond;
        return {
            operator: _cond.operator,
        };
    }
    if ('returnValueTest' in cond) {
        const _cosmosCond = cond;
        const { returnValueTest } = _cosmosCond;
        const canonicalReturnValueTest = {
            key: returnValueTest.key,
            comparator: returnValueTest.comparator,
            value: returnValueTest.value,
        };
        return {
            path: _cosmosCond.path,
            chain: _cosmosCond.chain,
            returnValueTest: canonicalReturnValueTest,
        };
    }
    (0, misc_1.throwError)({
        message: `You passed an invalid access control condition: ${cond}`,
        errorKind: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.kind,
        errorCode: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.name,
    });
};
exports.canonicalCosmosConditionFormatter = canonicalCosmosConditionFormatter;
/**
 *
 * Canonical ResourceId Formatter returning JSON signing resource id
 *
 * @param { JsonSigningResourceId } resId
 *
 * @returns { JsonSigningResourceId }
 *
 */
const canonicalResourceIdFormatter = (resId) => {
    // need to return in the exact format below:
    return {
        baseUrl: resId.baseUrl,
        path: resId.path,
        orgId: resId.orgId,
        role: resId.role,
        extraData: resId.extraData,
    };
};
exports.canonicalResourceIdFormatter = canonicalResourceIdFormatter;
//# sourceMappingURL=canonicalFormatter.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/access-control-conditions/src/lib/hashing.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.hashSolRpcConditions = exports.hashEVMContractConditions = exports.hashAccessControlConditions = exports.hashResourceIdForSigning = exports.hashResourceId = exports.hashUnifiedAccessControlConditions = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const canonicalFormatter_1 = __webpack_require__("../../node_modules/@lit-protocol/access-control-conditions/src/lib/canonicalFormatter.js");
const uint8arrays_1 = __webpack_require__("../../node_modules/@lit-protocol/uint8arrays/src/index.js");
/**
 *
 * Hash the unified access control conditions using SHA-256 in a deterministic way.
 *
 * @param { UnifiedAccessControlConditions } unifiedAccessControlConditions - The unified access control conditions to hash.
 * @returns { Promise<ArrayBuffer> } A promise that resolves to an ArrayBuffer that contains the hash
 */
const hashUnifiedAccessControlConditions = (unifiedAccessControlConditions) => {
    (0, misc_1.log)('unifiedAccessControlConditions:', unifiedAccessControlConditions);
    const conditions = unifiedAccessControlConditions.map((condition) => {
        return (0, canonicalFormatter_1.canonicalUnifiedAccessControlConditionFormatter)(condition);
    });
    (0, misc_1.log)('conditions:', conditions);
    // check if there's any undefined in the conditions
    const hasUndefined = conditions.some((c) => c === undefined);
    if (hasUndefined) {
        (0, misc_1.throwError)({
            message: 'Invalid access control conditions',
            errorKind: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.name,
        });
    }
    if (conditions.length === 0) {
        (0, misc_1.throwError)({
            message: 'No conditions provided',
            errorKind: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_ACCESS_CONTROL_CONDITIONS.name,
        });
    }
    const toHash = JSON.stringify(conditions);
    (0, misc_1.log)('Hashing unified access control conditions: ', toHash);
    const encoder = new TextEncoder();
    const data = encoder.encode(toHash);
    return crypto.subtle.digest('SHA-256', data);
};
exports.hashUnifiedAccessControlConditions = hashUnifiedAccessControlConditions;
/**
 *
 * Hash resource id
 *
 * @param { JsonSigningResourceId } resourceId
 *
 * @returns { Promise<ArrayBuffer> }
 *
 */
const hashResourceId = (resourceId) => {
    const resId = (0, canonicalFormatter_1.canonicalResourceIdFormatter)(resourceId);
    const toHash = JSON.stringify(resId);
    const encoder = new TextEncoder();
    const data = encoder.encode(toHash);
    return crypto.subtle.digest('SHA-256', data);
};
exports.hashResourceId = hashResourceId;
/**
 *
 * Hash resourceId for signing
 *
 * @param { JSONSigningResourceId } resourceId
 *
 * @returns { string } example: "5b36d72f2145af3617e5da2a8a626f9f42e64ed14340622bdfe1a6f0702b9e8d"
 */
const hashResourceIdForSigning = async (resourceId) => {
    const hashed = await (0, exports.hashResourceId)(resourceId);
    return (0, uint8arrays_1.uint8arrayToString)(new Uint8Array(hashed), 'base16');
};
exports.hashResourceIdForSigning = hashResourceIdForSigning;
/**
 *
 * Hash access control conditions
 *
 * @param { AccessControlConditions } accessControlConditions
 *
 * @returns { Promise<ArrayBuffer> } example: {"data": [83, 176, 31, 130, 12, 130, 232, 109, 126, 76, 216, 4, 184, 166, 246, 134, 130, 34, 30, 235, 125, 247, 111, 212, 62, 231, 119, 200, 202, 171, 86, 40], "type": "Buffer"}
 *
 */
const hashAccessControlConditions = (accessControlConditions) => {
    const conds = accessControlConditions.map((c) => (0, canonicalFormatter_1.canonicalAccessControlConditionFormatter)(c));
    const toHash = JSON.stringify(conds);
    (0, misc_1.log)('Hashing access control conditions: ', toHash);
    const encoder = new TextEncoder();
    const data = encoder.encode(toHash);
    return crypto.subtle.digest('SHA-256', data);
};
exports.hashAccessControlConditions = hashAccessControlConditions;
/**
 *
 * Hash EVM access control conditions
 *
 * @param { EvmContractConditions } evmContractConditions
 *
 * @returns { Promise<ArrayBuffer> } {"data": [216, 92, 128, 31, 171, 114, 74, 115, 133, 44, 234, 171, 214, 205, 228, 137, 117, 238, 14, 229, 254, 239, 97, 126, 1, 20, 166, 144, 176, 147, 217, 32], "type": "Buffer"}
 *
 */
const hashEVMContractConditions = (evmContractConditions) => {
    const conds = evmContractConditions.map((c) => (0, canonicalFormatter_1.canonicalEVMContractConditionFormatter)(c));
    const toHash = JSON.stringify(conds);
    (0, misc_1.log)('Hashing evm contract conditions: ', toHash);
    const encoder = new TextEncoder();
    const data = encoder.encode(toHash);
    return crypto.subtle.digest('SHA-256', data);
};
exports.hashEVMContractConditions = hashEVMContractConditions;
/**
 *
 * Hash SOL access control conditions
 *
 * @param { SolRpcConditions } solRpcConditions
 *
 * @returns { Promise<ArrayBuffer> }
 *
 */
const hashSolRpcConditions = (solRpcConditions) => {
    const conds = solRpcConditions.map((c) => (0, canonicalFormatter_1.canonicalSolRpcConditionFormatter)(c));
    const toHash = JSON.stringify(conds);
    (0, misc_1.log)('Hashing sol rpc conditions: ', toHash);
    const encoder = new TextEncoder();
    const data = encoder.encode(toHash);
    return crypto.subtle.digest('SHA-256', data);
};
exports.hashSolRpcConditions = hashSolRpcConditions;
//# sourceMappingURL=hashing.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/access-control-conditions/src/lib/humanizer.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.humanizeAccessControlConditions = exports.humanizeUnifiedAccessControlConditions = exports.humanizeCosmosConditions = exports.humanizeSolRpcConditions = exports.humanizeEvmContractConditions = exports.humanizeEvmBasicAccessControlConditions = exports.humanizeComparator = exports.formatAtom = exports.formatSol = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const utils_1 = __webpack_require__("../../node_modules/ethers/lib/utils.js");
/**
 *
 * Format SOL number using Ether Units
 *
 * @param { number } amount
 *
 * @returns { string } formatted unit
 *
 */
const formatSol = (amount) => {
    return (0, utils_1.formatUnits)(amount, 9);
};
exports.formatSol = formatSol;
/**
 *
 * Format Atom number using Ether Units
 *
 * @param { number } amount
 *
 * @returns { string } formatted unit
 *
 */
const formatAtom = (amount) => {
    return (0, utils_1.formatUnits)(amount, 6);
};
exports.formatAtom = formatAtom;
/**
 *
 * Comparator translator
 *
 * @param { string } comparator
 *
 * @returns { string } humanized version of the comparator
 */
const humanizeComparator = (comparator) => {
    let list = {
        '>': 'more than',
        '>=': 'at least',
        '=': 'exactly',
        '<': 'less than',
        '<=': 'at most',
        contains: 'contains',
    };
    let selected = list[comparator];
    if (!selected) {
        (0, misc_1.log)(`Unregonized comparator ${comparator}`);
        return;
    }
    return selected;
};
exports.humanizeComparator = humanizeComparator;
/**
 *
 * Humanize EVM basic access control conditions
 *
 * @property { Array<AccsRegularParams | AccsDefaultParams | any> } accessControlConditions
 * @property { Array<any | string> } tokenList
 * @property { string } myWalletAddress
 *
 * @returns
 */
const humanizeEvmBasicAccessControlConditions = async ({ accessControlConditions, tokenList, myWalletAddress, }) => {
    (0, misc_1.log)('humanizing evm basic access control conditions');
    (0, misc_1.log)('myWalletAddress', myWalletAddress);
    (0, misc_1.log)('accessControlConditions', accessControlConditions);
    let fixedConditions = accessControlConditions;
    // inject and operator if needed
    // this is done because before we supported operators,
    // we let users specify an entire array of conditions
    // that would be "AND"ed together.  this injects those ANDs
    if (accessControlConditions.length > 1) {
        let containsOperator = false;
        for (let i = 0; i < accessControlConditions.length; i++) {
            if (accessControlConditions[i].operator) {
                containsOperator = true;
            }
        }
        if (!containsOperator) {
            fixedConditions = [];
            // insert ANDs between conditions
            for (let i = 0; i < accessControlConditions.length; i++) {
                fixedConditions.push(accessControlConditions[i]);
                if (i < accessControlConditions.length - 1) {
                    fixedConditions.push({
                        operator: 'and',
                    });
                }
            }
        }
    }
    // -- execute
    const promises = await Promise.all(fixedConditions.map(async (acc) => {
        if (Array.isArray(acc)) {
            // this is a group.  recurse.
            const group = await (0, exports.humanizeEvmBasicAccessControlConditions)({
                accessControlConditions: acc,
                tokenList,
                myWalletAddress,
            });
            return `( ${group} )`;
        }
        if (acc.operator) {
            if (acc.operator.toLowerCase() === 'and') {
                return ' and ';
            }
            else if (acc.operator.toLowerCase() === 'or') {
                return ' or ';
            }
        }
        if (acc.standardContractType === 'timestamp' &&
            acc.method === 'eth_getBlockByNumber') {
            return `Latest mined block must be past the unix timestamp ${acc.returnValueTest.value}`;
        }
        else if (acc.standardContractType === 'MolochDAOv2.1' &&
            acc.method === 'members') {
            // molochDAOv2.1 membership
            return `Is a member of the DAO at ${acc.contractAddress}`;
        }
        else if (acc.standardContractType === 'ERC1155' &&
            acc.method === 'balanceOf') {
            // erc1155 owns an amount of specific tokens
            return `Owns ${(0, exports.humanizeComparator)(acc.returnValueTest.comparator)} ${acc.returnValueTest.value} of ${acc.contractAddress} tokens with token id ${acc.parameters[1]}`;
        }
        else if (acc.standardContractType === 'ERC1155' &&
            acc.method === 'balanceOfBatch') {
            // erc1155 owns an amount of specific tokens from a batch of token ids
            return `Owns ${(0, exports.humanizeComparator)(acc.returnValueTest.comparator)} ${acc.returnValueTest.value} of ${acc.contractAddress} tokens with token id ${acc.parameters[1]
                .split(',')
                .join(' or ')}`;
        }
        else if (acc.standardContractType === 'ERC721' &&
            acc.method === 'ownerOf') {
            // specific erc721
            return `Owner of tokenId ${acc.parameters[0]} from ${acc.contractAddress}`;
        }
        else if (acc.standardContractType === 'ERC721' &&
            acc.method === 'balanceOf' &&
            acc.contractAddress === '0x22C1f6050E56d2876009903609a2cC3fEf83B415' &&
            acc.returnValueTest.comparator === '>' &&
            acc.returnValueTest.value === '0') {
            // for POAP main contract where the user owns at least 1 poap
            return `Owns any POAP`;
        }
        else if (acc.standardContractType === 'POAP' &&
            acc.method === 'tokenURI') {
            // owns a POAP
            return `Owner of a ${acc.returnValueTest.value} POAP on ${acc.chain}`;
        }
        else if (acc.standardContractType === 'POAP' &&
            acc.method === 'eventId') {
            // owns a POAP
            return `Owner of a POAP from event ID ${acc.returnValueTest.value} on ${acc.chain}`;
        }
        else if (acc.standardContractType === 'CASK' &&
            acc.method === 'getActiveSubscriptionCount') {
            // Cask powered subscription
            return `Cask subscriber to provider ${acc.parameters[1]} for plan ${acc.parameters[2]} on ${acc.chain}`;
        }
        else if (acc.standardContractType === 'ERC721' &&
            acc.method === 'balanceOf') {
            // any erc721 in collection
            return `Owns ${(0, exports.humanizeComparator)(acc.returnValueTest.comparator)} ${acc.returnValueTest.value} of ${acc.contractAddress} tokens`;
        }
        else if (acc.standardContractType === 'ERC20' &&
            acc.method === 'balanceOf') {
            let tokenFromList;
            if (tokenList) {
                tokenFromList = tokenList.find((t) => t.address === acc.contractAddress);
            }
            let decimals, name;
            if (tokenFromList) {
                decimals = tokenFromList.decimals;
                name = tokenFromList.symbol;
            }
            else {
                decimals = await (0, misc_1.decimalPlaces)({
                    contractAddress: acc.contractAddress,
                    chain: acc.chain,
                });
            }
            (0, misc_1.log)('decimals', decimals);
            return `Owns ${(0, exports.humanizeComparator)(acc.returnValueTest.comparator)} ${(0, utils_1.formatUnits)(acc.returnValueTest.value, decimals)} of ${name || acc.contractAddress} tokens`;
        }
        else if (acc.standardContractType === '' &&
            acc.method === 'eth_getBalance') {
            return `Owns ${(0, exports.humanizeComparator)(acc.returnValueTest.comparator)} ${(0, utils_1.formatEther)(acc.returnValueTest.value)} ETH`;
        }
        else if (acc.standardContractType === '' && acc.method === '') {
            if (myWalletAddress &&
                acc.returnValueTest.value.toLowerCase() ===
                    myWalletAddress.toLowerCase()) {
                return `Controls your wallet (${myWalletAddress})`;
            }
            else {
                return `Controls wallet with address ${acc.returnValueTest.value}`;
            }
        }
        return 'Oops. something went wrong!';
    }));
    return promises.join('');
};
exports.humanizeEvmBasicAccessControlConditions = humanizeEvmBasicAccessControlConditions;
/**
 *
 * Humanize EVM contract conditions
 *
 * @property { Array<AccsEVMParams> } evmContractConditions
 * @property { Array<any | string> } tokenList
 * @property { string } myWalletAddress
 *
 * @returns { Promise<string> } A promise containing a human readable description of the access control conditions
 *
 */
const humanizeEvmContractConditions = async ({ evmContractConditions, tokenList, myWalletAddress, }) => {
    (0, misc_1.log)('humanizing evm contract conditions');
    (0, misc_1.log)('myWalletAddress', myWalletAddress);
    (0, misc_1.log)('evmContractConditions', evmContractConditions);
    const promises = await Promise.all(evmContractConditions.map(async (acc) => {
        if (Array.isArray(acc)) {
            // this is a group.  recurse.
            const group = await (0, exports.humanizeEvmContractConditions)({
                evmContractConditions: acc,
                tokenList,
                myWalletAddress,
            });
            return `( ${group} )`;
        }
        if (acc.operator) {
            if (acc.operator.toLowerCase() === 'and') {
                return ' and ';
            }
            else if (acc.operator.toLowerCase() === 'or') {
                return ' or ';
            }
        }
        let msg = `${acc.functionName}(${acc.functionParams.join(', ')}) on contract address ${acc.contractAddress} should have a result of ${(0, exports.humanizeComparator)(acc.returnValueTest.comparator)} ${acc.returnValueTest.value}`;
        if (acc.returnValueTest.key !== '') {
            msg += ` for key ${acc.returnValueTest.key}`;
        }
        return msg;
    }));
    return promises.join('');
};
exports.humanizeEvmContractConditions = humanizeEvmContractConditions;
/**
 *
 * Humanize SOL RPC Conditions
 *
 * @property { Array<AccsSOLV2Params> } solRpcConditions
 * @property { Array<any | string> } tokenList
 * @property { string } myWalletAddress
 *
 * @returns { Promise<string> } A promise containing a human readable description of the access control conditions
 *
 */
const humanizeSolRpcConditions = async ({ solRpcConditions, tokenList, myWalletAddress, }) => {
    (0, misc_1.log)('humanizing sol rpc conditions');
    (0, misc_1.log)('myWalletAddress', myWalletAddress);
    (0, misc_1.log)('solRpcConditions', solRpcConditions);
    const promises = await Promise.all(solRpcConditions.map(async (acc) => {
        if (Array.isArray(acc)) {
            // this is a group.  recurse.
            const group = await (0, exports.humanizeSolRpcConditions)({
                solRpcConditions: acc,
                tokenList,
                myWalletAddress,
            });
            return `( ${group} )`;
        }
        if (acc.operator) {
            if (acc.operator.toLowerCase() === 'and') {
                return ' and ';
            }
            else if (acc.operator.toLowerCase() === 'or') {
                return ' or ';
            }
        }
        if (acc.method === 'getBalance') {
            return `Owns ${(0, exports.humanizeComparator)(acc.returnValueTest.comparator)} ${(0, exports.formatSol)(acc.returnValueTest.value)} SOL`;
        }
        else if (acc.method === '') {
            if (myWalletAddress &&
                acc.returnValueTest.value.toLowerCase() ===
                    myWalletAddress.toLowerCase()) {
                return `Controls your wallet (${myWalletAddress})`;
            }
            else {
                return `Controls wallet with address ${acc.returnValueTest.value}`;
            }
        }
        else {
            let msg = `Solana RPC method ${acc.method}(${acc.params.join(', ')}) should have a result of ${(0, exports.humanizeComparator)(acc.returnValueTest.comparator)} ${acc.returnValueTest.value}`;
            if (acc.returnValueTest.key !== '') {
                msg += ` for key ${acc.returnValueTest.key}`;
            }
            return msg;
        }
    }));
    return promises.join('');
};
exports.humanizeSolRpcConditions = humanizeSolRpcConditions;
/**
 *
 * Humanize Cosmos Conditions
 *
 * @property { Array<AccsCOSMOSParams> } cosmosConditions
 * @property { Array<any | string> } tokenList
 * @property { string } myWalletAddress
 *
 * @returns { Promise<string> } A promise containing a human readable description of the access control conditions
 *
 */
const humanizeCosmosConditions = async ({ cosmosConditions, tokenList, myWalletAddress, }) => {
    (0, misc_1.log)('humanizing cosmos conditions');
    (0, misc_1.log)('myWalletAddress', myWalletAddress);
    (0, misc_1.log)('cosmosConditions', cosmosConditions);
    const promises = await Promise.all(cosmosConditions.map(async (acc) => {
        if (Array.isArray(acc)) {
            // this is a group.  recurse.
            const group = await (0, exports.humanizeCosmosConditions)({
                cosmosConditions: acc,
                tokenList,
                myWalletAddress,
            });
            return `( ${group} )`;
        }
        if (acc.operator) {
            if (acc.operator.toLowerCase() === 'and') {
                return ' and ';
            }
            else if (acc.operator.toLowerCase() === 'or') {
                return ' or ';
            }
        }
        if (acc.path === '/cosmos/bank/v1beta1/balances/:userAddress') {
            return `Owns ${(0, exports.humanizeComparator)(acc.returnValueTest.comparator)} ${(0, exports.formatAtom)(acc.returnValueTest.value)} ATOM`;
        }
        else if (acc.path === ':userAddress') {
            if (myWalletAddress &&
                acc.returnValueTest.value.toLowerCase() ===
                    myWalletAddress.toLowerCase()) {
                return `Controls your wallet (${myWalletAddress})`;
            }
            else {
                return `Controls wallet with address ${acc.returnValueTest.value}`;
            }
        }
        else if (acc.chain === 'kyve' &&
            acc.path === '/kyve/registry/v1beta1/funders_list/0') {
            return `Is a current KYVE funder`;
        }
        else {
            let msg = `Cosmos RPC request for ${acc.path} should have a result of ${(0, exports.humanizeComparator)(acc.returnValueTest.comparator)} ${acc.returnValueTest.value}`;
            if (acc.returnValueTest.key !== '') {
                msg += ` for key ${acc.returnValueTest.key}`;
            }
            return msg;
        }
    }));
    return promises.join('');
};
exports.humanizeCosmosConditions = humanizeCosmosConditions;
/**
 *
 * Humanize unified access control conditions
 *
 * @property { Array<AccsRegularParams | AccsDefaultParams | AccsSOLV2Params | AccsEVMParams | AccsCOSMOSParams> } unifiedAccessControlConditions
 * @property { Array<any | string> } tokenList
 * @property { string } myWalletAddress
 *
 * @returns { Promise<string> } A promise containing a human readable description of the access control conditions
 */
const humanizeUnifiedAccessControlConditions = async ({ unifiedAccessControlConditions, tokenList, myWalletAddress, }) => {
    const promises = await Promise.all(unifiedAccessControlConditions.map(async (acc) => {
        if (Array.isArray(acc)) {
            // this is a group.  recurse.
            const group = await (0, exports.humanizeUnifiedAccessControlConditions)({
                unifiedAccessControlConditions: acc,
                tokenList,
                myWalletAddress,
            });
            return `( ${group} )`;
        }
        if (acc.operator) {
            if (acc.operator.toLowerCase() === 'and') {
                return ' and ';
            }
            else if (acc.operator.toLowerCase() === 'or') {
                return ' or ';
            }
        }
        if (acc.conditionType === 'evmBasic') {
            return (0, exports.humanizeEvmBasicAccessControlConditions)({
                accessControlConditions: [acc],
                tokenList,
                myWalletAddress,
            });
        }
        else if (acc.conditionType === 'evmContract') {
            return (0, exports.humanizeEvmContractConditions)({
                evmContractConditions: [acc],
                tokenList,
                myWalletAddress,
            });
        }
        else if (acc.conditionType === 'solRpc') {
            return (0, exports.humanizeSolRpcConditions)({
                solRpcConditions: [acc],
                tokenList,
                myWalletAddress,
            });
        }
        else if (acc.conditionType === 'cosmos') {
            return (0, exports.humanizeCosmosConditions)({
                cosmosConditions: [acc],
                tokenList,
                myWalletAddress,
            });
        }
        else {
            (0, misc_1.throwError)({
                message: `Unrecognized condition type: ${acc.conditionType}`,
                errorKind: constants_1.LIT_ERROR.INVALID_UNIFIED_CONDITION_TYPE.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_UNIFIED_CONDITION_TYPE.name,
            });
        }
    }));
    return promises.join('');
};
exports.humanizeUnifiedAccessControlConditions = humanizeUnifiedAccessControlConditions;
/**
 *
 * The human readable name for an access control condition
 *
 * @param { HumanizedAccsProps } params
 *
 * @returns { Promise<string> } A promise containing a human readable description of the access control conditions
 */
const humanizeAccessControlConditions = async ({ accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions, tokenList, myWalletAddress, }) => {
    // -- check if each condition exists in linear
    if (accessControlConditions) {
        return (0, exports.humanizeEvmBasicAccessControlConditions)({
            accessControlConditions,
            tokenList,
            myWalletAddress,
        });
    }
    else if (evmContractConditions) {
        return (0, exports.humanizeEvmContractConditions)({
            evmContractConditions,
            tokenList,
            myWalletAddress,
        });
    }
    else if (solRpcConditions) {
        return (0, exports.humanizeSolRpcConditions)({
            solRpcConditions,
            tokenList,
            myWalletAddress,
        });
    }
    else if (unifiedAccessControlConditions) {
        return (0, exports.humanizeUnifiedAccessControlConditions)({
            unifiedAccessControlConditions,
            tokenList,
            myWalletAddress,
        });
    }
    // -- undefined
    return;
};
exports.humanizeAccessControlConditions = humanizeAccessControlConditions;
//# sourceMappingURL=humanizer.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/auth-browser/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.disconnectWeb3 = exports.solConnect = exports.cosmosConnect = exports.ethConnect = void 0;
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/lib/auth-browser.js"), exports);
// -- all the chains you can connect to
exports.ethConnect = __webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/lib/chains/eth.js");
exports.cosmosConnect = __webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/lib/chains/cosmos.js");
exports.solConnect = __webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/lib/chains/sol.js");
var eth_1 = __webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/lib/chains/eth.js");
Object.defineProperty(exports, "disconnectWeb3", ({ enumerable: true, get: function () { return eth_1.disconnectWeb3; } }));
// -- session management
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/lib/session.js"), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/auth-browser/src/lib/auth-browser.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.checkAndSignAuthMessage = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const cosmos_1 = __webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/lib/chains/cosmos.js");
const eth_1 = __webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/lib/chains/eth.js");
const sol_1 = __webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/lib/chains/sol.js");
/**
 *
 * Check for an existing cryptographic authentication signature and create one of it does not exist.  This is used to prove ownership of a given crypto wallet address to the Lit nodes.  The result is stored in LocalStorage so the user doesn't have to sign every time they perform an operation.
 *
 * @param { AuthCallbackParams }
 *
 *  @returns { AuthSig } The AuthSig created or retrieved
 */
const checkAndSignAuthMessage = ({ chain, resources, switchChain, expiration, uri, cosmosWalletType, }) => {
    const chainInfo = constants_1.ALL_LIT_CHAINS[chain];
    // -- validate: if chain info not found
    if (!chainInfo) {
        (0, misc_1.throwError)({
            message: `Unsupported chain selected.  Please select one of: ${Object.keys(constants_1.ALL_LIT_CHAINS)}`,
            errorKind: constants_1.LIT_ERROR.UNSUPPORTED_CHAIN_EXCEPTION.kind,
            errorCode: constants_1.LIT_ERROR.UNSUPPORTED_CHAIN_EXCEPTION.name,
        });
    }
    if (!expiration) {
        // set default of 1 week
        expiration = new Date(Date.now() + 1000 * 60 * 60 * 24 * 7).toISOString();
    }
    // -- check and sign auth message based on chain
    if (chainInfo.vmType === constants_1.VMTYPE.EVM) {
        return (0, eth_1.checkAndSignEVMAuthMessage)({
            chain,
            resources,
            switchChain,
            expiration,
            uri,
        });
    }
    else if (chainInfo.vmType === constants_1.VMTYPE.SVM) {
        return (0, sol_1.checkAndSignSolAuthMessage)();
    }
    else if (chainInfo.vmType === constants_1.VMTYPE.CVM) {
        return (0, cosmos_1.checkAndSignCosmosAuthMessage)({
            chain,
            walletType: cosmosWalletType || 'keplr',
        }); // Keplr is defaulted here, being the Cosmos wallet with the highest market share
    }
    else {
        return (0, misc_1.throwError)({
            message: `vmType not found for this chain: ${chain}.  This should not happen.  Unsupported chain selected.  Please select one of: ${Object.keys(constants_1.ALL_LIT_CHAINS)}`,
            errorKind: constants_1.LIT_ERROR.UNSUPPORTED_CHAIN_EXCEPTION.kind,
            errorCode: constants_1.LIT_ERROR.UNSUPPORTED_CHAIN_EXCEPTION.name,
        });
    }
};
exports.checkAndSignAuthMessage = checkAndSignAuthMessage;
//# sourceMappingURL=auth-browser.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/auth-browser/src/lib/chains/cosmos.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.serializeSignDoc = exports.signAndSaveAuthMessage = exports.checkAndSignCosmosAuthMessage = exports.connectCosmosProvider = void 0;
const uint8arrays_1 = __webpack_require__("../../node_modules/@lit-protocol/uint8arrays/src/index.js");
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
/** ---------- Local Helpers ---------- */
/**
 *
 * Get the COSMOS provider from the browser web3 extension
 *
 * @returns { object || never }
 */
const getProvider = (walletType) => {
    // -- validate
    switch (walletType) {
        case 'keplr':
            if ('keplr' in window) {
                return window?.keplr;
            }
            break;
        case 'leap':
            if ('leap' in window) {
                return window?.leap;
            }
    }
    // -- finally
    const message = 'No web3 wallet was found that works with Cosmos.  Install a Cosmos wallet or choose another chain';
    const error = constants_1.LIT_ERROR.NO_WALLET_EXCEPTION;
    (0, misc_1.throwError)({
        message,
        errorKind: error.kind,
        errorCode: error.name,
    });
};
/** ---------- Exports ---------- */
/**
 *
 * Get cosmos provider details
 *
 * @property { string } chain
 */
const connectCosmosProvider = async ({ chain, walletType, }) => {
    const chainId = constants_1.LIT_COSMOS_CHAINS[chain].chainId;
    const wallet = getProvider(walletType);
    // Enabling before using the Cosmos wallet is recommended.
    // This method will ask the user whether to allow access if they haven't visited this website.
    // Also, it will request that the user unlock the wallet if the wallet is locked.
    await wallet.enable(chainId);
    const offlineSigner = wallet.getOfflineSigner(chainId);
    // You can get the address/public keys by `getAccounts` method.
    // It can return the array of address/public key.
    // But, currently, Keplr/Leap extension manages only one address/public key pair.
    // TODO: (Check if this is still the case 7 Sep 2022)
    // This line is needed to set the sender address for SigningCosmosClient.
    const accounts = await offlineSigner.getAccounts();
    return { provider: wallet, account: accounts[0].address, chainId };
};
exports.connectCosmosProvider = connectCosmosProvider;
/**
 *
 * Check if the cosmos signature is in the local storage already,
 * If not, sign and save the authenticated message
 *
 * @property { string } chain
 * @returns { AuthSig }
 */
const checkAndSignCosmosAuthMessage = async ({ chain, walletType, }) => {
    const connectedCosmosProvider = await (0, exports.connectCosmosProvider)({
        chain,
        walletType,
    });
    const storageKey = constants_1.LOCAL_STORAGE_KEYS.AUTH_COSMOS_SIGNATURE;
    let authSig = localStorage.getItem(storageKey);
    // -- if not found in local storage
    if (!authSig) {
        (0, misc_1.log)('signing auth message because sig is not in local storage');
        await (0, exports.signAndSaveAuthMessage)(connectedCosmosProvider);
        authSig = localStorage.getItem(storageKey);
    }
    // -- if found in local storage
    authSig = JSON.parse(authSig);
    // -- validate
    if (connectedCosmosProvider.account != authSig.address) {
        (0, misc_1.log)('signing auth message because account is not the same as the address in the auth sig');
        await (0, exports.signAndSaveAuthMessage)(connectedCosmosProvider);
        authSig = localStorage.getItem(storageKey);
        authSig = JSON.parse(authSig);
    }
    (0, misc_1.log)('authSig', authSig);
    return authSig;
};
exports.checkAndSignCosmosAuthMessage = checkAndSignCosmosAuthMessage;
/**
 *
 * Save and sign the authenticated message
 * @param { CosmosProvider } connectedCosmosProvider
 *
 * @returns { void }
 */
const signAndSaveAuthMessage = async (connectedCosmosProvider) => {
    const { provider, account, chainId } = connectedCosmosProvider;
    const now = new Date().toISOString();
    const body = constants_1.AUTH_SIGNATURE_BODY.replace('{{timestamp}}', now);
    const signed = await provider.signArbitrary(chainId, account, body);
    //Buffer.from(body).toString("base64");
    const data = (0, uint8arrays_1.uint8arrayToString)((0, uint8arrays_1.uint8arrayFromString)(body, 'utf8'), 'base64');
    const signDoc = {
        chain_id: '',
        account_number: '0',
        sequence: '0',
        fee: {
            gas: '0',
            amount: [],
        },
        msgs: [
            {
                type: 'sign/MsgSignData',
                value: {
                    signer: account,
                    data,
                },
            },
        ],
        memo: '',
    };
    const encodedSignedMsg = (0, exports.serializeSignDoc)(signDoc);
    const digest = await crypto.subtle.digest('SHA-256', encodedSignedMsg);
    const digest_hex = (0, uint8arrays_1.uint8arrayToString)(new Uint8Array(digest), 'base16');
    let authSig = {
        sig: signed.signature,
        derivedVia: 'cosmos.signArbitrary',
        signedMessage: digest_hex,
        address: account,
    };
    localStorage.setItem(constants_1.LOCAL_STORAGE_KEYS.AUTH_COSMOS_SIGNATURE, JSON.stringify(authSig));
};
exports.signAndSaveAuthMessage = signAndSaveAuthMessage;
/**
 *
 * Turn sorted signDoc object into uint8array
 *
 * @param { CosmosSignDoc } signDoc
 * @returns { Uint8Array } serialized string in uint8array
 */
const serializeSignDoc = (signDoc) => {
    const sorted = JSON.stringify((0, misc_1.sortedObject)(signDoc));
    return (0, uint8arrays_1.uint8arrayFromString)(sorted, 'utf8');
};
exports.serializeSignDoc = serializeSignDoc;
//# sourceMappingURL=cosmos.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/auth-browser/src/lib/chains/eth.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.signMessageAsync = exports.signMessage = exports.signAndSaveAuthMessage = exports.checkAndSignEVMAuthMessage = exports.disconnectWeb3 = exports.connectWeb3 = exports.decodeCallResult = exports.encodeCallData = exports.getRPCUrls = exports.getMustResign = exports.isSignedMessageExpired = exports.getChainId = exports.chainHexIdToChainName = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const ethers_1 = __webpack_require__("../../node_modules/ethers/lib.esm/index.js");
// import WalletConnectProvider from '@walletconnect/ethereum-provider';
const strings_1 = __webpack_require__("../../node_modules/@ethersproject/strings/lib.esm/index.js");
const bytes_1 = __webpack_require__("../../node_modules/@ethersproject/bytes/lib.esm/index.js");
const wallet_1 = __webpack_require__("../../node_modules/@ethersproject/wallet/lib.esm/index.js");
const ethereum_provider_1 = __webpack_require__("?3436");
// @ts-ignore
const lit_connect_modal_1 = __webpack_require__("../../node_modules/lit-connect-modal/build/index.js");
const providers_1 = __webpack_require__("../../node_modules/@ethersproject/providers/lib.esm/index.js");
const lit_siwe_1 = __webpack_require__("../../node_modules/lit-siwe/dist/siwe.js");
const utils_1 = __webpack_require__("../../node_modules/ethers/lib/utils.js");
// @ts-ignore: If importing 'nacl' directly, the built files will use .default instead
const naclUtil = __webpack_require__("../../node_modules/@lit-protocol/auth-browser/node_modules/tweetnacl-util/nacl-util.js");
// @ts-ignore: If importing 'nacl' directly, the built files will use .default instead
const nacl = __webpack_require__("../../node_modules/tweetnacl/nacl-fast.js");
const buffer_1 = __webpack_require__("../../node_modules/buffer/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const misc_browser_1 = __webpack_require__("../../node_modules/@lit-protocol/misc-browser/src/index.js");
if (typeof __webpack_require__.g.Buffer === 'undefined') {
    __webpack_require__.g.Buffer = buffer_1.Buffer;
}
if ((0, misc_1.isBrowser)()) {
    // @ts-ignore
    globalThis.WalletConnectProviderPkg = ethereum_provider_1.default;
    (0, misc_1.log)('WalletConnectProviderPkg:', ethereum_provider_1.default);
}
var WALLET_ERROR;
(function (WALLET_ERROR) {
    WALLET_ERROR[WALLET_ERROR["REQUESTED_CHAIN_HAS_NOT_BEEN_ADDED"] = 4902] = "REQUESTED_CHAIN_HAS_NOT_BEEN_ADDED";
    WALLET_ERROR[WALLET_ERROR["NO_SUCH_METHOD"] = -32601] = "NO_SUCH_METHOD";
})(WALLET_ERROR || (WALLET_ERROR = {}));
/** ---------- Local Helpers ---------- */
/**
 *
 * Convert chain hex id to chain name
 *
 * @param { string } chainHexId
 * @returns { void | string }
 */
const chainHexIdToChainName = (chainHexId) => {
    // -- setup
    const keys = Object.keys(constants_1.LIT_CHAINS);
    const entries = Object.entries(constants_1.LIT_CHAINS);
    const hexIds = Object.values(constants_1.LIT_CHAINS).map((chain) => '0x' + chain.chainId.toString(16));
    // -- validate:: must begin with 0x
    if (!chainHexId.startsWith('0x')) {
        (0, misc_1.throwError)({
            message: `${chainHexId} should begin with "0x"`,
            errorKind: constants_1.LIT_ERROR.WRONG_PARAM_FORMAT.kind,
            errorCode: constants_1.LIT_ERROR.WRONG_PARAM_FORMAT.name,
        });
    }
    // -- validate:: hex id must be listed in constants
    if (!hexIds.includes(chainHexId)) {
        (0, misc_1.throwError)({
            message: `${chainHexId} cannot be found in LIT_CHAINS`,
            errorKind: constants_1.LIT_ERROR.UNSUPPORTED_CHAIN_EXCEPTION.kind,
            errorCode: constants_1.LIT_ERROR.UNSUPPORTED_CHAIN_EXCEPTION.name,
        });
    }
    // -- search
    const chainName = entries.find((data) => '0x' + data[1].chainId.toString(16) === chainHexId) || null;
    // -- success case
    if (chainName) {
        return chainName[0];
    }
    // -- fail case
    (0, misc_1.throwError)({
        message: `Failed to convert ${chainHexId}`,
        errorKind: constants_1.LIT_ERROR.UNKNOWN_ERROR.kind,
        errorCode: constants_1.LIT_ERROR.UNKNOWN_ERROR.name,
    });
};
exports.chainHexIdToChainName = chainHexIdToChainName;
/**
 * Get chain id of the current network
 * @param { string } chain
 * @param { Web3Provider } web3
 * @returns { Promise<IEither> }
 */
const getChainId = async (chain, web3) => {
    let resultOrError;
    try {
        const resp = await web3.getNetwork();
        resultOrError = (0, constants_1.ERight)(resp.chainId);
    }
    catch (e) {
        // couldn't get chainId.  throw the incorrect network error
        (0, misc_1.log)('getNetwork threw an exception', e);
        resultOrError = (0, constants_1.ELeft)({
            message: `Incorrect network selected.  Please switch to the ${chain} network in your wallet and try again.`,
            errorKind: constants_1.LIT_ERROR.WRONG_NETWORK_EXCEPTION.kind,
            errorCode: constants_1.LIT_ERROR.WRONG_NETWORK_EXCEPTION.name,
        });
    }
    return resultOrError;
};
exports.getChainId = getChainId;
/**
 * Check if the Expiration Time in the signedMessage string is expired.
 * @param { string } signedMessage - The signed message containing the Expiration Time.
 * @returns true if expired, false otherwise.
 */
function isSignedMessageExpired(signedMessage) {
    // Extract the Expiration Time from the signed message.
    const dateStr = signedMessage.split('\n')[9]?.replace('Expiration Time: ', '');
    const expirationTime = new Date(dateStr);
    const currentTime = new Date();
    // Compare the Expiration Time with the current time.
    return currentTime > expirationTime;
}
exports.isSignedMessageExpired = isSignedMessageExpired;
/**
 *
 * Check if the message must resign
 *
 * @param { AuthSig } authSig
 * @param { any } resources
 *
 * @returns { boolean }
 */
const getMustResign = (authSig, resources) => {
    let mustResign;
    // if it's not expired, then we don't need to resign
    if (!isSignedMessageExpired(authSig.signedMessage)) {
        return false;
    }
    try {
        const parsedSiwe = new lit_siwe_1.SiweMessage(authSig.signedMessage);
        (0, misc_1.log)('parsedSiwe.resources', parsedSiwe.resources);
        if (JSON.stringify(parsedSiwe.resources) !== JSON.stringify(resources)) {
            (0, misc_1.log)('signing auth message because resources differ from the resources in the auth sig');
            mustResign = true;
        }
        if (parsedSiwe.address !== (0, utils_1.getAddress)(parsedSiwe.address)) {
            (0, misc_1.log)('signing auth message because parsedSig.address is not equal to the same address but checksummed.  This usually means the user had a non-checksummed address saved and so they need to re-sign.');
            mustResign = true;
        }
    }
    catch (e) {
        (0, misc_1.log)('error parsing siwe sig.  making the user sign again: ', e);
        mustResign = true;
    }
    return mustResign;
};
exports.getMustResign = getMustResign;
/**
 *
 * Get RPC Urls in the correct format
 * need to make it look like this:
   ---
   rpc: {
        1: "https://mainnet.mycustomnode.com",
        3: "https://ropsten.mycustomnode.com",
        100: "https://dai.poa.network",
        // ...
    },
   ---
 *
 * @returns
 */
const getRPCUrls = () => {
    let rpcUrls = {};
    const keys = Object.keys(constants_1.LIT_CHAINS);
    for (let i = 0; i < keys.length; i++) {
        const chainName = keys[i];
        const chainId = constants_1.LIT_CHAINS[chainName].chainId;
        const rpcUrl = constants_1.LIT_CHAINS[chainName].rpcUrls[0];
        rpcUrls[chainId] = rpcUrl;
    }
    return rpcUrls;
};
exports.getRPCUrls = getRPCUrls;
/** ---------- Exports ---------- */
/**
 * @deprecated
 * (ABI) Encode call data
 *
 * @param { IABIEncode }
 * @returns { string }
 */
const encodeCallData = ({ abi, functionName, functionParams, }) => {
    throw new Error('encodeCallData has been removed.');
};
exports.encodeCallData = encodeCallData;
/**
 * @deprecated
 * (ABI) Decode call data
 * TODO: fix "any"
 *
 * @param { IABIDecode }
 * @returns { string }
 */
const decodeCallResult = ({ abi, functionName, data, }) => {
    const _interface = new ethers_1.ethers.utils.Interface(abi);
    const decoded = _interface.decodeFunctionResult(functionName, data);
    return decoded;
};
exports.decodeCallResult = decodeCallResult;
/**
 * @browserOnly
 * Connect to web 3
 *
 * @param { ConnectWeb3 }
 *
 * @return { Promise<ConnectWeb3Result> } web3, account
 */
const connectWeb3 = async ({ chainId = 1, }) => {
    // -- check if it's nodejs
    if ((0, misc_1.isNode)()) {
        (0, misc_1.log)('connectWeb3 is not supported in nodejs.');
        return { web3: null, account: null };
    }
    const rpcUrls = (0, exports.getRPCUrls)();
    const providerOptions = {
        walletconnect: {
            package: ethereum_provider_1.default,
            options: {
                // infuraId: "cd614bfa5c2f4703b7ab0ec0547d9f81",
                rpc: rpcUrls,
                chainId: chainId,
            },
        },
    };
    (0, misc_1.log)('getting provider via lit connect modal');
    const dialog = new lit_connect_modal_1.default({
        providerOptions,
    });
    const provider = await dialog.getWalletProvider();
    (0, misc_1.log)('got provider', provider);
    const web3 = new providers_1.Web3Provider(provider);
    // trigger metamask popup
    try {
        (0, misc_1.log)('@deprecated soon to be removed. - trying to enable provider.  this will trigger the metamask popup.');
        await provider.enable();
    }
    catch (e) {
        (0, misc_1.log)("error enabling provider but swallowed it because it's not important.  most wallets use a different function now to enable the wallet so you can ignore this error, because those other methods will be tried.", e);
    }
    (0, misc_1.log)('listing accounts');
    const accounts = await web3.listAccounts();
    (0, misc_1.log)('accounts', accounts);
    const account = accounts[0].toLowerCase();
    return { web3, account };
};
exports.connectWeb3 = connectWeb3;
/**
 * @browserOnly
 * Delete any saved AuthSigs from local storage. Takes no params and returns
 * nothing. This will also clear out the WalletConnect cache in local storage.
 * We often run this function as a result of the user pressing a "Logout" button.
 *
 * @return { void }
 */
const disconnectWeb3 = () => {
    if ((0, misc_1.isNode)()) {
        (0, misc_1.log)('disconnectWeb3 is not supported in nodejs.');
        return;
    }
    const storage = constants_1.LOCAL_STORAGE_KEYS;
    localStorage.removeItem(storage.WALLET_CONNECT);
    localStorage.removeItem(storage.AUTH_SIGNATURE);
    localStorage.removeItem(storage.AUTH_SOL_SIGNATURE);
    localStorage.removeItem(storage.AUTH_COSMOS_SIGNATURE);
    localStorage.removeItem(storage.WEB3_PROVIDER);
};
exports.disconnectWeb3 = disconnectWeb3;
/**
 * @browserOnly
 * Check and sign EVM auth message
 *
 * @param { CheckAndSignAuthParams }
 * @returns
 */
const checkAndSignEVMAuthMessage = async ({ chain, resources, switchChain, expiration, uri, }) => {
    // -- check if it's nodejs
    if ((0, misc_1.isNode)()) {
        (0, misc_1.log)('checkAndSignEVMAuthMessage is not supported in nodejs.  You can create a SIWE on your own using the SIWE package.');
        return {
            sig: '',
            derivedVia: '',
            signedMessage: '',
            address: '',
        };
    }
    // --- scoped methods ---
    const _throwIncorrectNetworkError = (error) => {
        if (error.code === WALLET_ERROR.NO_SUCH_METHOD) {
            (0, misc_1.throwError)({
                message: `Incorrect network selected.  Please switch to the ${chain} network in your wallet and try again.`,
                errorKind: constants_1.LIT_ERROR.WRONG_NETWORK_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.WRONG_NETWORK_EXCEPTION.name,
            });
        }
        else {
            throw error;
        }
    };
    // -- 1. prepare
    const selectedChain = constants_1.LIT_CHAINS[chain];
    const expirationString = expiration ?? getDefaultExpiration();
    const { web3, account } = await (0, exports.connectWeb3)({
        chainId: selectedChain.chainId,
    });
    (0, misc_1.log)(`got web3 and account: ${account}`);
    // -- 2. prepare all required variables
    const currentChainIdOrError = await (0, exports.getChainId)(chain, web3);
    const selectedChainId = selectedChain.chainId;
    const selectedChainIdHex = (0, misc_1.numberToHex)(selectedChainId);
    const authSigOrError = (0, misc_browser_1.getStorageItem)(constants_1.LOCAL_STORAGE_KEYS.AUTH_SIGNATURE);
    (0, misc_1.log)('currentChainIdOrError:', currentChainIdOrError);
    (0, misc_1.log)('selectedChainId:', selectedChainId);
    (0, misc_1.log)('selectedChainIdHex:', selectedChainIdHex);
    (0, misc_1.log)('authSigOrError:', authSigOrError);
    // -- 3. check all variables before executing business logic
    if (currentChainIdOrError.type === "ERROR" /* EITHER_TYPE.ERROR */) {
        return (0, misc_1.throwError)(currentChainIdOrError.result);
    }
    (0, misc_1.log)('chainId from web3', currentChainIdOrError);
    (0, misc_1.log)(`checkAndSignAuthMessage with chainId ${currentChainIdOrError} and chain set to ${chain} and selectedChain is `, selectedChain);
    // -- 4. case: (current chain id is NOT equal to selected chain) AND is set to switch chain
    if (currentChainIdOrError.result !== selectedChainId && switchChain) {
        // -- validate the provider type
        // if (web3.provider instanceof walletProvider) {
        //   return throwError({
        //     message: `Incorrect network selected.  Please switch to the ${chain} network in your wallet and try again.`,
        //     error: LIT_ERROR.WRONG_NETWORK_EXCEPTION,
        //   });
        // }
        const provider = web3.provider;
        // -- (case) if able to switch chain id
        try {
            (0, misc_1.log)('trying to switch to chainId', selectedChainIdHex);
            await provider.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: selectedChainIdHex }],
            });
            // -- (case) if unable to switch chain
        }
        catch (switchError) {
            (0, misc_1.log)('error switching to chainId', switchError);
            // -- (error case)
            if (switchError.code === WALLET_ERROR.REQUESTED_CHAIN_HAS_NOT_BEEN_ADDED) {
                try {
                    const data = [
                        {
                            chainId: selectedChainIdHex,
                            chainName: selectedChain.name,
                            nativeCurrency: {
                                name: selectedChain.name,
                                symbol: selectedChain.symbol,
                                decimals: selectedChain.decimals,
                            },
                            rpcUrls: selectedChain.rpcUrls,
                            blockExplorerUrls: selectedChain.blockExplorerUrls,
                        },
                    ];
                    await provider.request({
                        method: 'wallet_addEthereumChain',
                        params: data,
                    });
                }
                catch (addError) {
                    _throwIncorrectNetworkError(addError);
                }
            }
            else {
                _throwIncorrectNetworkError(switchError);
            }
        }
        // we may have switched the chain to the selected chain.  set the chainId accordingly
        currentChainIdOrError.result = selectedChain.chainId;
    }
    // -- 5. case: Lit auth signature is NOT in the local storage
    (0, misc_1.log)('checking if sig is in local storage');
    if (authSigOrError.type === "ERROR" /* EITHER_TYPE.ERROR */) {
        (0, misc_1.log)('signing auth message because sig is not in local storage');
        try {
            authSigOrError.result = await _signAndGetAuth({
                web3,
                account,
                chainId: selectedChain.chainId,
                resources,
                expiration: expirationString,
                uri,
            });
        }
        catch (e) {
            (0, misc_1.log)(e);
            return (0, misc_1.throwError)({
                message: e.message,
                errorKind: constants_1.LIT_ERROR.UNKNOWN_ERROR.kind,
                errorCode: constants_1.LIT_ERROR.UNKNOWN_ERROR.name,
            });
        }
        authSigOrError.type = "SUCCESS" /* EITHER_TYPE.SUCCESS */;
        (0, misc_1.log)('5. authSigOrError:', authSigOrError);
    }
    // -- 6. case: Lit auth signature IS in the local storage
    let authSig = authSigOrError.result;
    if (typeof authSig === 'string') {
        authSig = JSON.parse(authSig);
    }
    (0, misc_1.log)('6. authSig:', authSig);
    // -- 7. case: when we are NOT on the right wallet address
    if (account.toLowerCase() !== authSig.address.toLowerCase()) {
        (0, misc_1.log)('signing auth message because account is not the same as the address in the auth sig');
        authSig = await _signAndGetAuth({
            web3,
            account,
            chainId: selectedChain.chainId,
            resources,
            expiration: expirationString,
            uri,
        });
        (0, misc_1.log)('7. authSig:', authSig);
        // -- 8. case: we are on the right wallet, but need to check the resources of the sig and re-sign if they don't match
    }
    else {
        let mustResign = (0, exports.getMustResign)(authSig, resources);
        if (mustResign) {
            authSig = await _signAndGetAuth({
                web3,
                account,
                chainId: selectedChain.chainId,
                resources,
                expiration: expirationString,
                uri,
            });
        }
        (0, misc_1.log)('8. mustResign:', mustResign);
    }
    return authSig;
};
exports.checkAndSignEVMAuthMessage = checkAndSignEVMAuthMessage;
const getDefaultExpiration = () => {
    return new Date(Date.now() + 1000 * 60 * 60 * 24).toISOString();
};
const _signAndGetAuth = async ({ web3, account, chainId, resources, expiration, uri, }) => {
    await (0, exports.signAndSaveAuthMessage)({
        web3,
        account,
        chainId,
        resources,
        expiration,
        uri,
    });
    let authSigOrError = (0, misc_browser_1.getStorageItem)(constants_1.LOCAL_STORAGE_KEYS.AUTH_SIGNATURE);
    if (authSigOrError.type === 'ERROR') {
        (0, misc_1.throwError)({
            message: 'Failed to get authSig from local storage',
            errorKind: constants_1.LIT_ERROR.LOCAL_STORAGE_ITEM_NOT_FOUND_EXCEPTION.kind,
            errorCode: constants_1.LIT_ERROR.LOCAL_STORAGE_ITEM_NOT_FOUND_EXCEPTION.name,
        });
    }
    let authSig = typeof authSigOrError.result === 'string'
        ? JSON.parse(authSigOrError.result)
        : authSigOrError.result;
    return authSig;
};
/**
 * @browserOnly
 * Sign the auth message with the user's wallet, and store it in localStorage.
 * Called by checkAndSignAuthMessage if the user does not have a signature stored.
 *
 * @param { signAndSaveAuthParams }}
 * @returns { AuthSig }
 */
const signAndSaveAuthMessage = async ({ web3, account, chainId, resources, expiration, uri, }) => {
    // check if it's nodejs
    if ((0, misc_1.isNode)()) {
        (0, misc_1.log)('checkAndSignEVMAuthMessage is not supported in nodejs.');
        return {
            sig: '',
            derivedVia: '',
            signedMessage: '',
            address: '',
        };
    }
    // -- 1. prepare 'sign-in with ethereum' message
    const preparedMessage = {
        domain: globalThis.location.host,
        address: (0, utils_1.getAddress)(account),
        version: '1',
        chainId,
        expirationTime: expiration,
    };
    if (resources && resources.length > 0) {
        preparedMessage.resources = resources;
    }
    if (uri) {
        preparedMessage.uri = uri;
    }
    else {
        preparedMessage.uri = globalThis.location.href;
    }
    const message = new lit_siwe_1.SiweMessage(preparedMessage);
    const body = message.prepareMessage();
    // -- 2. sign the message
    let signedResult = await (0, exports.signMessage)({
        body,
        web3,
        account,
    });
    // -- 3. prepare auth message
    let authSig = {
        sig: signedResult.signature,
        derivedVia: 'web3.eth.personal.sign',
        signedMessage: body,
        address: signedResult.address,
    };
    // -- 4. store auth and a keypair in localstorage for communication with sgx
    if ((0, misc_1.isBrowser)()) {
        localStorage.setItem(constants_1.LOCAL_STORAGE_KEYS.AUTH_SIGNATURE, JSON.stringify(authSig));
    }
    const commsKeyPair = nacl.box.keyPair();
    if ((0, misc_1.isBrowser)()) {
        localStorage.setItem(constants_1.LOCAL_STORAGE_KEYS.KEY_PAIR, JSON.stringify({
            publicKey: naclUtil.encodeBase64(commsKeyPair.publicKey),
            secretKey: naclUtil.encodeBase64(commsKeyPair.secretKey),
        }));
    }
    (0, misc_1.log)(`generated and saved ${constants_1.LOCAL_STORAGE_KEYS.KEY_PAIR}`);
    return authSig;
};
exports.signAndSaveAuthMessage = signAndSaveAuthMessage;
/**
 * @browserOnly
 * Sign Messags
 *
 * @param { SignMessageParams }
 *
 * @returns { Promise<SignedMessage> }
 */
const signMessage = async ({ body, web3, account, }) => {
    // check if it's nodejs
    if ((0, misc_1.isNode)()) {
        (0, misc_1.log)('signMessage is not supported in nodejs.');
        return {
            signature: '',
            address: '',
        };
    }
    // -- validate
    if (!web3 || !account) {
        (0, misc_1.log)(`web3: ${web3} OR ${account} not found. Connecting web3..`);
        let res = await (0, exports.connectWeb3)({ chainId: 1 });
        web3 = res.web3;
        account = res.account;
    }
    (0, misc_1.log)('pausing...');
    await new Promise((resolve) => setTimeout(resolve, 500));
    (0, misc_1.log)('signing with ', account);
    const signature = await (0, exports.signMessageAsync)(web3.getSigner(), account, body);
    const address = (0, wallet_1.verifyMessage)(body, signature).toLowerCase();
    (0, misc_1.log)('Signature: ', signature);
    (0, misc_1.log)('recovered address: ', address);
    if (address !== account) {
        const msg = `ruh roh, the user signed with a different address (${address}) then they\'re using with web3 (${account}).  this will lead to confusion.`;
        (0, misc_1.log)(msg);
        alert('something seems to be wrong with your wallets message signing.  maybe restart your browser or your wallet.  your recovered sig address does not match your web3 account address');
        throw new Error(msg);
    }
    return { signature, address };
};
exports.signMessage = signMessage;
/**
 * @browserOnly
 * wrapper around signMessage that tries personal_sign first.  this is to fix a
 * bug with walletconnect where just using signMessage was failing
 *
 * @param { any | JsonRpcProvider} signer
 * @param { string } address
 * @param { string } message
 *
 * @returns { Promise<any | JsonRpcSigner> }
 */
const signMessageAsync = async (signer, address, message) => {
    // check if it's nodejs
    if ((0, misc_1.isNode)()) {
        (0, misc_1.log)('signMessageAsync is not supported in nodejs.');
        return null;
    }
    const messageBytes = (0, strings_1.toUtf8Bytes)(message);
    if (signer instanceof providers_1.JsonRpcSigner) {
        try {
            (0, misc_1.log)('Signing with personal_sign');
            const signature = await signer.provider.send('personal_sign', [
                (0, bytes_1.hexlify)(messageBytes),
                address.toLowerCase(),
            ]);
            return signature;
        }
        catch (e) {
            (0, misc_1.log)('Signing with personal_sign failed, trying signMessage as a fallback');
            if (e.message.includes('personal_sign')) {
                return await signer.signMessage(messageBytes);
            }
            throw e;
        }
    }
    else {
        (0, misc_1.log)('signing with signMessage');
        return await signer.signMessage(messageBytes);
    }
};
exports.signMessageAsync = signMessageAsync;
/**
 *
 * Get the number of decimal places in a token
 *
 * @property { string } contractAddress The token contract address
 * @property { string } chain The chain on which the token is deployed
 *
 * @returns { number } The number of decimal places in the token
 */
// export const decimalPlaces = async ({
//     contractAddress,
//     chain,
// }: {
//     contractAddress: string;
//     chain: Chain;
// }): Promise<number> => {
//     const rpcUrl = LIT_CHAINS[chain].rpcUrls[0] as string;
//     const web3 = new JsonRpcProvider(rpcUrl);
//     const contract = new Contract(
//         contractAddress,
//         (ABI_ERC20 as any).abi,
//         web3
//     );
//     return await contract['decimals']();
// };
//# sourceMappingURL=eth.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/auth-browser/src/lib/chains/sol.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.signAndSaveAuthMessage = exports.checkAndSignSolAuthMessage = exports.connectSolProvider = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const misc_browser_1 = __webpack_require__("../../node_modules/@lit-protocol/misc-browser/src/index.js");
// import { toString as uint8arrayToString } from 'uint8arrays';
const uint8arrays_1 = __webpack_require__("../../node_modules/@lit-protocol/uint8arrays/src/index.js");
/**
 *
 * Get the Solana provider from the browser web3 extension
 *
 * @returns { object || never }
 */
const getProvider = () => {
    let resultOrError;
    // -- validate
    if ('solana' in window) {
        resultOrError = (0, constants_1.ERight)(window?.keplr ?? window?.solana);
    }
    else {
        // -- finally
        const message = 'No web3 wallet was found that works with Solana.  Install a Solana wallet or choose another chain';
        resultOrError = (0, constants_1.ELeft)({
            message,
            errorKind: constants_1.LIT_ERROR.NO_WALLET_EXCEPTION.kind,
            errorCode: constants_1.LIT_ERROR.NO_WALLET_EXCEPTION.name,
        });
    }
    return resultOrError;
};
/**
 *
 * Get Solana provider
 *
 * @returns { Promise<IProvider | undefined }
 */
const connectSolProvider = async () => {
    const providerOrError = getProvider();
    if (providerOrError.type === 'ERROR') {
        (0, misc_1.throwError)(providerOrError.result);
        return;
    }
    let provider = providerOrError.result;
    await provider.connect();
    const account = provider.publicKey.toBase58();
    return { provider, account };
};
exports.connectSolProvider = connectSolProvider;
/**
 *
 * Check and sign solana auth message
 *
 * @returns { AuthSig }
 */
const checkAndSignSolAuthMessage = async () => {
    const res = await (0, exports.connectSolProvider)();
    if (!res) {
        (0, misc_1.log)('Failed to connect sol provider');
    }
    const provider = res?.provider;
    const account = res?.account;
    const key = constants_1.LOCAL_STORAGE_KEYS.AUTH_SOL_SIGNATURE;
    let authSigOrError = (0, misc_browser_1.getStorageItem)(key);
    // let authSig = localStorage.getItem("lit-auth-sol-signature");
    let authSig;
    // -- case: if unable to get auth from local storage
    if (authSigOrError.type === "ERROR" /* EITHER_TYPE.ERROR */) {
        (0, misc_1.log)('signing auth message because sig is not in local storage');
        await (0, exports.signAndSaveAuthMessage)({ provider });
        authSigOrError.type = "SUCCESS" /* EITHER_TYPE.SUCCESS */;
        authSigOrError.result = (0, misc_browser_1.getStorageItem)(key);
    }
    //   @ts-ignore
    window.test = authSigOrError;
    try {
        // when it's not in local storage, it's a string
        authSig = JSON.parse(authSigOrError.result.result);
    }
    catch (e) {
        // when it's in local storage, it's an object
        authSig = JSON.parse(authSigOrError.result);
    }
    // -- if the wallet address isn't the same as the address from local storage
    if (account !== authSig.address) {
        (0, misc_1.log)('signing auth message because account is not the same as the address in the auth sig');
        await (0, exports.signAndSaveAuthMessage)({ provider });
        authSigOrError.type = "SUCCESS" /* EITHER_TYPE.SUCCESS */;
        authSigOrError.result = (0, misc_browser_1.getStorageItem)(key);
        authSig = JSON.parse(authSigOrError.result);
    }
    (0, misc_1.log)('authSig', authSig);
    return authSig;
};
exports.checkAndSignSolAuthMessage = checkAndSignSolAuthMessage;
/**
 *
 * Sign and save auth signature locally (not saved to the nodes)
 *
 * @property { any } provider
 * @return { Promise<AuthSig | undefined> }
 *
 */
const signAndSaveAuthMessage = async ({ provider, }) => {
    const now = new Date().toISOString();
    const body = constants_1.AUTH_SIGNATURE_BODY.replace('{{timestamp}}', now);
    //   turn body into Uint8Array
    const data = (0, uint8arrays_1.uint8arrayFromString)(body, 'utf8');
    //   const data = naclUtil.encode(body);
    const signed = await provider.signMessage(data, 'utf8');
    const hexSig = (0, uint8arrays_1.uint8arrayToString)(signed.signature, 'base16');
    const authSig = {
        sig: hexSig,
        derivedVia: 'solana.signMessage',
        signedMessage: body,
        address: provider.publicKey.toBase58(),
    };
    localStorage.setItem(constants_1.LOCAL_STORAGE_KEYS.AUTH_SOL_SIGNATURE, JSON.stringify(authSig));
    return authSig;
};
exports.signAndSaveAuthMessage = signAndSaveAuthMessage;
//# sourceMappingURL=sol.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/auth-browser/src/lib/session.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parseResource = exports.getSessionKeyUri = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
/**
 *
 * Get Session Key URI eg. lit:session:
 *
 * @returns { string }
 *
 */
const getSessionKeyUri = ({ publicKey, }) => {
    return constants_1.LIT_SESSION_KEY_URI + publicKey;
};
exports.getSessionKeyUri = getSessionKeyUri;
/**
 *
 * Parse resource
 *
 * @property { any } resource
 *
 * @returns { { protocol: string, resourceId: string } }
 *
 */
const parseResource = ({ resource, }) => {
    const [protocol, resourceId] = resource.split('://');
    return { protocol, resourceId };
};
exports.parseResource = parseResource;
//# sourceMappingURL=session.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/bls-sdk/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/bls-sdk/src/lib/bls-sdk.js"), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/bls-sdk/src/lib/bls-sdk.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

// @ts-nocheck
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.derive_key_share = exports.derive_master_key = exports.get_mc_degree = exports.get_poly_degree = exports.generate_poly = exports.decrypt = exports.encrypt = exports.verify = exports.sign_msg = exports.derive_pk_from_sk = exports.get_decryption_shares_byte = exports.set_decryption_shares_byte = exports.get_share_indexes = exports.set_share_indexes = exports.get_signature_share_byte = exports.set_signature_share_byte = exports.get_bivar_pks_byte = exports.set_bivar_pks_byte = exports.get_bivar_sks_byte = exports.set_bivar_sks_byte = exports.get_bivar_commitments_byte = exports.set_bivar_commitments_byte = exports.get_bivar_row_byte = exports.set_bivar_row_byte = exports.get_pkshare_byte = exports.set_pkshare_byte = exports.get_skshare_byte = exports.set_skshare_byte = exports.get_mc_byte = exports.set_mc_byte = exports.get_mpk_byte = exports.set_mpk_byte = exports.get_msk_byte = exports.set_msk_byte = exports.get_poly_byte = exports.set_poly_byte = exports.get_rng_next_count = exports.get_ct_byte = exports.set_ct_byte = exports.get_msg_byte = exports.set_msg_byte = exports.get_sig_byte = exports.set_sig_byte = exports.get_pk_byte = exports.set_pk_byte = exports.get_sk_byte = exports.set_sk_byte = exports.set_rng_value = exports.get_rng_values_size = exports.wasmBlsSdkHelpers = void 0;
exports.initWasmBlsSdk = exports.combine_decryption_shares = exports.create_decryption_share = exports.combine_signature_shares = exports.generate_bivars = void 0;
// Contants
const skLen = 32; // bytes
const pkLen = 48; // bytes
const sigLen = 96; // bytes
const maxMsgLen = 1049600; // bytes
const maxCtLen = 1049600; // bytes
const decryptionShareLen = 48; // bytes
// the number of bytes in a row derived from a BivarPoly
// which varies depending on the threshold.
const row_sizes_by_threshold = [
    40,
    72,
    104,
    136,
    168,
    200,
    232,
    264,
    296,
    328,
    360, // threshold 10
];
// the number of bytes in a commitment derived from a BivarPoly
// which varies depending on the threshold.
const commitment_sizes_by_threshold = [
    56,
    104,
    152,
    200,
    248,
    296,
    344,
    392,
    440,
    488,
    536, // threshold 10
];
// the number of bytes in the master secret key (Poly)
// which varies depending on the threshold.
const poly_sizes_by_threshold = [
    40,
    72,
    104,
    136,
    168,
    200,
    232,
    264,
    296,
    328,
    360, // threshold 10
];
// Encoding conversions
// modified from https://stackoverflow.com/a/11058858
function asciiToUint8Array(a) {
    let b = new Uint8Array(a.length);
    for (let i = 0; i < a.length; i++) {
        b[i] = a.charCodeAt(i);
    }
    return b;
}
// https://stackoverflow.com/a/19102224
// TODO resolve RangeError possibility here, see SO comments
const uint8ArrayToAscii = (a) => {
    return String.fromCharCode.apply(null, a);
};
// https://stackoverflow.com/a/50868276
const hexToUint8Array = (h) => {
    if (h.length == 0) {
        return new Uint8Array();
    }
    return new Uint8Array(h.match(/.{1,2}/g).map((byte) => parseInt(byte, 16)));
};
const uint8ArrayToHex = (a) => {
    return a.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');
};
const uint8ArrayToByteStr = (a) => {
    return '[' + a.join(', ') + ']';
};
const base64abc = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '+',
    '/',
];
const base64codes = [
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 62, 255, 255,
    255, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 255, 255, 255, 0, 255, 255,
    255, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 255, 255, 255, 255, 255, 255, 26, 27, 28, 29, 30, 31, 32,
    33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51,
];
const getBase64Code = (charCode) => {
    if (charCode >= base64codes.length) {
        throw new Error('Unable to parse base64 string.');
    }
    const code = base64codes[charCode];
    if (code === 255) {
        throw new Error('Unable to parse base64 string.');
    }
    return code;
};
const base64ToUint8Array = (str) => {
    if (str.length % 4 !== 0) {
        throw new Error('Unable to parse base64 string.');
    }
    const index = str.indexOf('=');
    if (index !== -1 && index < str.length - 2) {
        throw new Error('Unable to parse base64 string.');
    }
    let missingOctets = str.endsWith('==') ? 2 : str.endsWith('=') ? 1 : 0, n = str.length, result = new Uint8Array(3 * (n / 4)), buffer;
    for (let i = 0, j = 0; i < n; i += 4, j += 3) {
        buffer =
            (getBase64Code(str.charCodeAt(i)) << 18) |
                (getBase64Code(str.charCodeAt(i + 1)) << 12) |
                (getBase64Code(str.charCodeAt(i + 2)) << 6) |
                getBase64Code(str.charCodeAt(i + 3));
        result[j] = buffer >> 16;
        result[j + 1] = (buffer >> 8) & 0xff;
        result[j + 2] = buffer & 0xff;
    }
    return result.subarray(0, result.length - missingOctets);
};
const uint8ArrayToBase64 = (bytes) => {
    let result = '', i, l = bytes.length;
    for (i = 2; i < l; i += 3) {
        result += base64abc[bytes[i - 2] >> 2];
        result += base64abc[((bytes[i - 2] & 0x03) << 4) | (bytes[i - 1] >> 4)];
        result += base64abc[((bytes[i - 1] & 0x0f) << 2) | (bytes[i] >> 6)];
        result += base64abc[bytes[i] & 0x3f];
    }
    if (i === l + 1) {
        // 1 octet yet to write
        result += base64abc[bytes[i - 2] >> 2];
        result += base64abc[(bytes[i - 2] & 0x03) << 4];
        result += '==';
    }
    if (i === l) {
        // 2 octets yet to write
        result += base64abc[bytes[i - 2] >> 2];
        result += base64abc[((bytes[i - 2] & 0x03) << 4) | (bytes[i - 1] >> 4)];
        result += base64abc[(bytes[i - 1] & 0x0f) << 2];
        result += '=';
    }
    return result;
};
const pako = __webpack_require__("../../node_modules/pako/index.js");
const util = Promise.resolve().then(() => __webpack_require__("../../node_modules/util/util.js"));
//https://gist.github.com/enepomnyaschih/72c423f727d395eeaa09697058238727
/*
MIT License
Copyright (c) 2020 Egor Nepomnyaschih
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
// threshold_crypto wasm calls. Since they operate on single bytes at a time
// it's handy to have helpers to do the required looping.
let isWasming = false;
exports.wasmBlsSdkHelpers = new (function () {
    // s is secret key unit8array
    this.sk_bytes_to_pk_bytes = function (s) {
        isWasming = true;
        const pkBytes = [];
        try {
            // set sk bytes
            for (let i = 0; i < s.length; i++) {
                globalThis.wasmExports.set_sk_byte(i, s[i]);
            }
            // convert into pk bytes
            globalThis.wasmExports.derive_pk_from_sk();
            // read pk bytes
            for (let i = 0; i < pkLen; i++) {
                const pkByte = globalThis.wasmExports.get_pk_byte(i);
                pkBytes.push(pkByte);
            }
        }
        catch (e) {
            isWasming = false;
            throw 'Failed to generate';
        }
        isWasming = false;
        return pkBytes;
    };
    // s is secret key uint8array
    // m is message uint8array
    this.sign_msg = function (s, m) {
        isWasming = true;
        const sigBytes = [];
        try {
            // set secret key bytes
            for (let i = 0; i < s.length; i++) {
                globalThis.wasmExports.set_sk_byte(i, s[i]);
            }
            // set message bytes
            for (let i = 0; i < m.length; i++) {
                globalThis.wasmExports.set_msg_byte(i, m[i]);
            }
            // sign message
            globalThis.wasmExports.sign_msg(m.length);
            // get signature bytes
            for (let i = 0; i < sigLen; i++) {
                const sigByte = globalThis.wasmExports.get_sig_byte(i);
                sigBytes.push(sigByte);
            }
        }
        catch (e) {
            console.log('error signing in bls-sdk.js:');
            console.log(e);
            isWasming = false;
        }
        isWasming = false;
        return Uint8Array.from(sigBytes);
    };
    // p is public key uint8array
    // s is signature uint8array
    // m is message uint8array
    this.verify = function (p, s, m) {
        isWasming = true;
        let verified = false;
        try {
            // set public key bytes
            for (let i = 0; i < p.length; i++) {
                globalThis.wasmExports.set_pk_byte(i, p[i]);
            }
            // set signature bytes
            for (let i = 0; i < s.length; i++) {
                globalThis.wasmExports.set_sig_byte(i, s[i]);
            }
            // set message bytes
            for (let i = 0; i < m.length; i++) {
                globalThis.wasmExports.set_msg_byte(i, m[i]);
            }
            verified = globalThis.wasmExports.verify(m.length);
        }
        catch (e) {
            console.log('error verifying sig in bls-sdk.js:');
            console.log(e);
            isWasming = false;
        }
        isWasming = false;
        return verified;
    };
    this.set_rng_values = function () {
        // Warning if no globalThis.crypto available
        if (!globalThis.crypto) {
            const msg = 'Secure randomness not available in this browser, output is insecure.';
            alert(msg);
            console.log(msg);
            return;
        }
        const RNG_VALUES_SIZE = globalThis.wasmExports.get_rng_values_size();
        const rngValues = new Uint32Array(RNG_VALUES_SIZE);
        globalThis.crypto.getRandomValues(rngValues);
        for (let i = 0; i < rngValues.length; i++) {
            globalThis.wasmExports.set_rng_value(i, rngValues[i]);
        }
    };
    // p is public key uint8array
    // m is message uint8array
    this.encrypt = function (p, m) {
        isWasming = true;
        const ctBytes = [];
        try {
            exports.wasmBlsSdkHelpers.set_rng_values();
            // set public key bytes
            for (let i = 0; i < p.length; i++) {
                globalThis.wasmExports.set_pk_byte(i, p[i]);
            }
            // set message bytes
            for (let i = 0; i < m.length; i++) {
                globalThis.wasmExports.set_msg_byte(i, m[i]);
            }
            // generate strong random u64 used by encrypt
            // encrypt the message
            const ctSize = globalThis.wasmExports.encrypt(m.length);
            // get ciphertext bytes
            for (let i = 0; i < ctSize; i++) {
                const ctByte = globalThis.wasmExports.get_ct_byte(i);
                ctBytes.push(ctByte);
            }
        }
        catch (e) {
            console.log('error encrypting in bls-sdk.js:');
            console.log(e);
            isWasming = false;
        }
        isWasming = false;
        return Uint8Array.from(ctBytes);
    };
    // s is secret key uint8array
    // c is message uint8array
    this.decrypt = function (s, c) {
        isWasming = true;
        const msgBytes = [];
        try {
            // set secret key bytes
            for (let i = 0; i < s.length; i++) {
                globalThis.wasmExports.set_sk_byte(i, s[i]);
            }
            // set ciphertext bytes
            for (let i = 0; i < c.length; i++) {
                globalThis.wasmExports.set_ct_byte(i, c[i]);
            }
            const msgSize = globalThis.wasmExports.decrypt(c.length);
            // get message bytes
            for (let i = 0; i < msgSize; i++) {
                const msgByte = globalThis.wasmExports.get_msg_byte(i);
                msgBytes.push(msgByte);
            }
        }
        catch (e) {
            console.log('error decrypting in bls-sdk.js:');
            console.log(e);
            isWasming = false;
        }
        isWasming = false;
        return Uint8Array.from(msgBytes);
    };
    this.generate_poly = function (threshold) {
        exports.wasmBlsSdkHelpers.set_rng_values();
        const polySize = poly_sizes_by_threshold[threshold];
        globalThis.wasmExports.generate_poly(threshold);
        const polyBytes = [];
        for (let i = 0; i < polySize; i++) {
            const polyByte = globalThis.wasmExports.get_poly_byte(i);
            polyBytes.push(polyByte);
        }
        return polyBytes;
    };
    this.get_msk_bytes = function () {
        const mskBytes = [];
        for (let i = 0; i < skLen; i++) {
            const mskByte = globalThis.wasmExports.get_msk_byte(i);
            mskBytes.push(mskByte);
        }
        return mskBytes;
    };
    this.get_mpk_bytes = function () {
        const mpkBytes = [];
        for (let i = 0; i < pkLen; i++) {
            const mpkByte = globalThis.wasmExports.get_mpk_byte(i);
            mpkBytes.push(mpkByte);
        }
        return mpkBytes;
    };
    this.get_mc_bytes = function (threshold) {
        const mcBytes = [];
        const mcSize = commitment_sizes_by_threshold[threshold];
        for (let i = 0; i < mcSize; i++) {
            const mcByte = globalThis.wasmExports.get_mc_byte(i);
            mcBytes.push(mcByte);
        }
        return mcBytes;
    };
    this.set_mc_bytes = function (mcBytes) {
        // set master commitment in wasm
        for (let i = 0; i < mcBytes.length; i++) {
            const v = mcBytes[i];
            globalThis.wasmExports.set_mc_byte(i, v);
        }
    };
    this.get_skshare = function () {
        const skshareBytes = [];
        for (let i = 0; i < skLen; i++) {
            const skshareByte = globalThis.wasmExports.get_skshare_byte(i);
            skshareBytes.push(skshareByte);
        }
        return skshareBytes;
    };
    this.get_pkshare = function () {
        const pkshareBytes = [];
        for (let i = 0; i < pkLen; i++) {
            const pkshareByte = globalThis.wasmExports.get_pkshare_byte(i);
            pkshareBytes.push(pkshareByte);
        }
        return pkshareBytes;
    };
    this.combine_signatures = function (mcBytes, sigshares) {
        // set master commitment in wasm
        exports.wasmBlsSdkHelpers.set_mc_bytes(mcBytes);
        // set the signature shares
        for (let shareIndex = 0; shareIndex < sigshares.length; shareIndex++) {
            const share = sigshares[shareIndex];
            const sigHex = share.shareHex;
            const sigBytes = hexToUint8Array(sigHex);
            const sigIndex = share.shareIndex;
            for (let byteIndex = 0; byteIndex < sigBytes.length; byteIndex++) {
                const sigByte = sigBytes[byteIndex];
                // NB shareIndex is used instead of sigIndex so we can interate
                // over both
                // SHARE_INDEXES[i]
                // and
                // SIGNATURE_SHARE_BYTES[i*96:(i+1)*96]
                globalThis.wasmExports.set_signature_share_byte(byteIndex, shareIndex, sigByte);
                globalThis.wasmExports.set_share_indexes(shareIndex, sigIndex);
            }
        }
        // combine the signatures
        globalThis.wasmExports.combine_signature_shares(sigshares.length, mcBytes.length);
        // read the combined signature
        const sigBytes = [];
        for (let i = 0; i < sigLen; i++) {
            const sigByte = globalThis.wasmExports.get_sig_byte(i);
            sigBytes.push(sigByte);
        }
        return Uint8Array.from(sigBytes);
    };
    // s is secret key share bytes
    // ct is ciphertext bytes
    // uiShareIndex is the index of the share as it appears in the UI
    // derivedShareIndex is the index of the share when derived from the poly
    this.create_decryption_share = function (s, uiShareIndex, derivedShareIndex, ct) {
        // set ct bytes
        for (let i = 0; i < ct.length; i++) {
            globalThis.wasmExports.set_ct_byte(i, ct[i]);
        }
        // set secret key share
        for (let i = 0; i < s.length; i++) {
            globalThis.wasmExports.set_sk_byte(i, s[i]);
        }
        // create decryption share
        const dshareSize = globalThis.wasmExports.create_decryption_share(uiShareIndex, ct.length);
        // set derivedShareIndex
        globalThis.wasmExports.set_share_indexes(uiShareIndex, derivedShareIndex);
        // read decryption share
        const dshareBytes = [];
        for (let i = 0; i < decryptionShareLen; i++) {
            const dshareByte = globalThis.wasmExports.get_decryption_shares_byte(i, uiShareIndex);
            dshareBytes.push(dshareByte);
        }
        return Uint8Array.from(dshareBytes);
    };
    // Assumes master commitment is already set.
    // Assumes create_decryption_share is already called for all shares,
    // Which means ciphertext is already set
    // and decryption shares are already set
    // and share_indexes is already set
    this.combine_decryption_shares = function (totalShares, mcSize, ctSize) {
        // combine decryption shares
        const msgSize = globalThis.wasmExports.combine_decryption_shares(totalShares, mcSize, ctSize);
        // read msg
        const msgBytes = [];
        for (let i = 0; i < msgSize; i++) {
            const msgByte = globalThis.wasmExports.get_msg_byte(i);
            msgBytes.push(msgByte);
        }
        return Uint8Array.from(msgBytes);
    };
})();
let wasm;
let cachedTextDecoder = new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true,
});
cachedTextDecoder.decode();
let cachegetUint8Memory0 = null;
function getUint8Memory0() {
    if (cachegetUint8Memory0 === null ||
        cachegetUint8Memory0.buffer !== wasm.memory.buffer) {
        cachegetUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachegetUint8Memory0;
}
function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}
/**
 * @private
 * @returns {number}
 */
function get_rng_values_size() {
    var ret = wasm.get_rng_values_size();
    return ret >>> 0;
}
exports.get_rng_values_size = get_rng_values_size;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_rng_value(i, v) {
    wasm.set_rng_value(i, v);
}
exports.set_rng_value = set_rng_value;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_sk_byte(i, v) {
    wasm.set_sk_byte(i, v);
}
exports.set_sk_byte = set_sk_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_sk_byte(i) {
    var ret = wasm.get_sk_byte(i);
    return ret;
}
exports.get_sk_byte = get_sk_byte;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_pk_byte(i, v) {
    wasm.set_pk_byte(i, v);
}
exports.set_pk_byte = set_pk_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_pk_byte(i) {
    var ret = wasm.get_pk_byte(i);
    return ret;
}
exports.get_pk_byte = get_pk_byte;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_sig_byte(i, v) {
    wasm.set_sig_byte(i, v);
}
exports.set_sig_byte = set_sig_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_sig_byte(i) {
    var ret = wasm.get_sig_byte(i);
    return ret;
}
exports.get_sig_byte = get_sig_byte;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_msg_byte(i, v) {
    wasm.set_msg_byte(i, v);
}
exports.set_msg_byte = set_msg_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_msg_byte(i) {
    var ret = wasm.get_msg_byte(i);
    return ret;
}
exports.get_msg_byte = get_msg_byte;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_ct_byte(i, v) {
    wasm.set_ct_byte(i, v);
}
exports.set_ct_byte = set_ct_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_ct_byte(i) {
    var ret = wasm.get_ct_byte(i);
    return ret;
}
exports.get_ct_byte = get_ct_byte;
/**
 * @private
 * @returns {number}
 */
function get_rng_next_count() {
    var ret = wasm.get_rng_next_count();
    return ret >>> 0;
}
exports.get_rng_next_count = get_rng_next_count;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_poly_byte(i, v) {
    wasm.set_poly_byte(i, v);
}
exports.set_poly_byte = set_poly_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_poly_byte(i) {
    var ret = wasm.get_poly_byte(i);
    return ret;
}
exports.get_poly_byte = get_poly_byte;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_msk_byte(i, v) {
    wasm.set_msk_byte(i, v);
}
exports.set_msk_byte = set_msk_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_msk_byte(i) {
    var ret = wasm.get_msk_byte(i);
    return ret;
}
exports.get_msk_byte = get_msk_byte;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_mpk_byte(i, v) {
    wasm.set_mpk_byte(i, v);
}
exports.set_mpk_byte = set_mpk_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_mpk_byte(i) {
    var ret = wasm.get_mpk_byte(i);
    return ret;
}
exports.get_mpk_byte = get_mpk_byte;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_mc_byte(i, v) {
    wasm.set_mc_byte(i, v);
}
exports.set_mc_byte = set_mc_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_mc_byte(i) {
    var ret = wasm.get_mc_byte(i);
    return ret;
}
exports.get_mc_byte = get_mc_byte;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_skshare_byte(i, v) {
    wasm.set_skshare_byte(i, v);
}
exports.set_skshare_byte = set_skshare_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_skshare_byte(i) {
    var ret = wasm.get_skshare_byte(i);
    return ret;
}
exports.get_skshare_byte = get_skshare_byte;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_pkshare_byte(i, v) {
    wasm.set_pkshare_byte(i, v);
}
exports.set_pkshare_byte = set_pkshare_byte;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_pkshare_byte(i) {
    var ret = wasm.get_pkshare_byte(i);
    return ret;
}
exports.get_pkshare_byte = get_pkshare_byte;
/**
 * @private
 * @param {number} i
 * @param {number} from_node
 * @param {number} to_node
 * @param {number} v
 */
function set_bivar_row_byte(i, from_node, to_node, v) {
    wasm.set_bivar_row_byte(i, from_node, to_node, v);
}
exports.set_bivar_row_byte = set_bivar_row_byte;
/**
 * @private
 * @param {number} i
 * @param {number} from_node
 * @param {number} to_node
 * @returns {number}
 */
function get_bivar_row_byte(i, from_node, to_node) {
    var ret = wasm.get_bivar_row_byte(i, from_node, to_node);
    return ret;
}
exports.get_bivar_row_byte = get_bivar_row_byte;
/**
 * @private
 * @param {number} i
 * @param {number} from_node
 * @param {number} v
 */
function set_bivar_commitments_byte(i, from_node, v) {
    wasm.set_bivar_commitments_byte(i, from_node, v);
}
exports.set_bivar_commitments_byte = set_bivar_commitments_byte;
/**
 * @private
 * @param {number} i
 * @param {number} from_node
 * @returns {number}
 */
function get_bivar_commitments_byte(i, from_node) {
    var ret = wasm.get_bivar_commitments_byte(i, from_node);
    return ret;
}
exports.get_bivar_commitments_byte = get_bivar_commitments_byte;
/**
 * @private
 * @param {number} i
 * @param {number} node_index
 * @param {number} v
 */
function set_bivar_sks_byte(i, node_index, v) {
    wasm.set_bivar_sks_byte(i, node_index, v);
}
exports.set_bivar_sks_byte = set_bivar_sks_byte;
/**
 * @private
 * @param {number} i
 * @param {number} node_index
 * @returns {number}
 */
function get_bivar_sks_byte(i, node_index) {
    var ret = wasm.get_bivar_sks_byte(i, node_index);
    return ret;
}
exports.get_bivar_sks_byte = get_bivar_sks_byte;
/**
 * @private
 * @param {number} i
 * @param {number} node_index
 * @param {number} v
 */
function set_bivar_pks_byte(i, node_index, v) {
    wasm.set_bivar_pks_byte(i, node_index, v);
}
exports.set_bivar_pks_byte = set_bivar_pks_byte;
/**
 * @private
 * @param {number} i
 * @param {number} node_index
 * @returns {number}
 */
function get_bivar_pks_byte(i, node_index) {
    var ret = wasm.get_bivar_pks_byte(i, node_index);
    return ret;
}
exports.get_bivar_pks_byte = get_bivar_pks_byte;
/**
 * @private
 * @param {number} i
 * @param {number} sig_index
 * @param {number} v
 */
function set_signature_share_byte(i, sig_index, v) {
    wasm.set_signature_share_byte(i, sig_index, v);
}
exports.set_signature_share_byte = set_signature_share_byte;
/**
 * @private
 * @param {number} i
 * @param {number} sig_index
 * @returns {number}
 */
function get_signature_share_byte(i, sig_index) {
    var ret = wasm.get_signature_share_byte(i, sig_index);
    return ret;
}
exports.get_signature_share_byte = get_signature_share_byte;
/**
 * @private
 * @param {number} i
 * @param {number} v
 */
function set_share_indexes(i, v) {
    wasm.set_share_indexes(i, v);
}
exports.set_share_indexes = set_share_indexes;
/**
 * @private
 * @param {number} i
 * @returns {number}
 */
function get_share_indexes(i) {
    var ret = wasm.get_share_indexes(i);
    return ret >>> 0;
}
exports.get_share_indexes = get_share_indexes;
/**
 * @private
 * @param {number} i
 * @param {number} share_index
 * @param {number} v
 */
function set_decryption_shares_byte(i, share_index, v) {
    wasm.set_decryption_shares_byte(i, share_index, v);
}
exports.set_decryption_shares_byte = set_decryption_shares_byte;
/**
 * @private
 * @param {number} i
 * @param {number} share_index
 * @returns {number}
 */
function get_decryption_shares_byte(i, share_index) {
    var ret = wasm.get_decryption_shares_byte(i, share_index);
    return ret;
}
exports.get_decryption_shares_byte = get_decryption_shares_byte;
/**
 * @private
 */
function derive_pk_from_sk() {
    wasm.derive_pk_from_sk();
}
exports.derive_pk_from_sk = derive_pk_from_sk;
/**
 * @private
 * @param {number} msg_size
 */
function sign_msg(msg_size) {
    wasm.sign_msg(msg_size);
}
exports.sign_msg = sign_msg;
/**
 * @private
 * @param {number} msg_size
 * @returns {boolean}
 */
function verify(msg_size) {
    var ret = wasm.verify(msg_size);
    return ret !== 0;
}
exports.verify = verify;
/**
 * @private
 * @param {number} msg_size
 * @returns {number}
 */
function encrypt(msg_size) {
    var ret = wasm.encrypt(msg_size);
    return ret >>> 0;
}
exports.encrypt = encrypt;
/**
 * @private
 * @param {number} ct_size
 * @returns {number}
 */
function decrypt(ct_size) {
    var ret = wasm.decrypt(ct_size);
    return ret >>> 0;
}
exports.decrypt = decrypt;
/**
 * @private
 * @param {number} threshold
 */
function generate_poly(threshold) {
    wasm.generate_poly(threshold);
}
exports.generate_poly = generate_poly;
/**
 * @private
 * @param {number} poly_size
 * @returns {number}
 */
function get_poly_degree(poly_size) {
    var ret = wasm.get_poly_degree(poly_size);
    return ret >>> 0;
}
exports.get_poly_degree = get_poly_degree;
/**
 * @private
 * @param {number} mc_size
 * @returns {number}
 */
function get_mc_degree(mc_size) {
    var ret = wasm.get_mc_degree(mc_size);
    return ret >>> 0;
}
exports.get_mc_degree = get_mc_degree;
/**
 * @private
 * @param {number} poly_size
 */
function derive_master_key(poly_size) {
    wasm.derive_master_key(poly_size);
}
exports.derive_master_key = derive_master_key;
/**
 * @private
 * @param {number} i
 * @param {number} poly_size
 */
function derive_key_share(i, poly_size) {
    wasm.derive_key_share(i, poly_size);
}
exports.derive_key_share = derive_key_share;
/**
 * @private
 * @param {number} threshold
 * @param {number} total_nodes
 */
function generate_bivars(threshold, total_nodes) {
    wasm.generate_bivars(threshold, total_nodes);
}
exports.generate_bivars = generate_bivars;
/**
 * @private
 * @param {number} total_signatures
 * @param {number} commitment_size
 */
function combine_signature_shares(total_signatures, commitment_size) {
    wasm.combine_signature_shares(total_signatures, commitment_size);
}
exports.combine_signature_shares = combine_signature_shares;
/**
 * @private
 * @param {number} share_index
 * @param {number} ct_size
 * @returns {number}
 */
function create_decryption_share(share_index, ct_size) {
    var ret = wasm.create_decryption_share(share_index, ct_size);
    return ret >>> 0;
}
exports.create_decryption_share = create_decryption_share;
/**
 * @private
 * @param {number} total_decryption_shares
 * @param {number} commitment_size
 * @param {number} ct_size
 * @returns {number}
 */
function combine_decryption_shares(total_decryption_shares, commitment_size, ct_size) {
    var ret = wasm.combine_decryption_shares(total_decryption_shares, commitment_size, ct_size);
    return ret >>> 0;
}
exports.combine_decryption_shares = combine_decryption_shares;
async function load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            }
            catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn('`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n', e);
                }
                else {
                    throw e;
                }
            }
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    }
    else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        }
        else {
            return instance;
        }
    }
}
async function init(input) {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_throw = function (arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    const { instance, module } = await load(await input, imports);
    wasm = instance.exports;
    init.__wbindgen_wasm_module = module;
    return wasm;
}
exports["default"] = init;
async function initWasmBlsSdk() {
    var b = '';
    b +=
        'eNrsvQuAVVd1MHzOPs/7mnvnAQzvc29IMmBMgMCAeRAuCRBCIjGJGl8lBCaE4f2Iku+fwKhUSYJ';
    b +=
        '1rNRiy9dOK/1DW6Kj0n70a1onSiut2M6vUamldVSqWGm/UdP+9PvQfOt1ztnn3jsPkhg1XpK5Z+';
    b +=
        '+1H2fvtdZee62z11nHWLNzs2kYhnlYXfmA2rvXeMDai7+QNPc+YELKxAQC4WLvpUJnL1+haM8DB';
    b +=
        'sDdvQLx9oYpqgpFhvFAam/4L64KKX9vVNkJYZm9e/XKXpyMO8Eh7tnDQ9wTwvcgBKrviTp8TK5d';
    b +=
        'PJ09OKTHeGRd0gnPrItn1sUz3oOwPXujSe9B0B7ValrvenB9YfXqdz24Ycu69R1bVu96eMfWdxm';
    b +=
        'GdcH/V18BAg3Dsw3851mWhRg1bMszTLPJNV0H4aZpKgfylmE6BaPFzOTNloxrKNdzlelBqWsaWc';
    b +=
        'O0XFMZ+bRrmgY0U56pLEsp17A8zzUd01YqayosyzuuF0AGurZNw80aruEow5aGUHW6MqBLKHJMw';
    b +=
        '3JdVykzbbqW4Ziu4dquwkE5puPaOZfGm7YM18VxYknOVMowXRfm4hgm9eQaE6AOFrqNpsI2tipg';
    b +=
        'EyhW+ANTgOZpy2um/mBYpm03QvW0BahJ0zjhloAAvJYMZcG9oL3juum0iXWgDG5guePhLinsE0Z';
    b +=
        't2qZrw1CoUSvcFyopqEsAczyUG66lZDr4MwNGi7fHqQBeLU8R8mHOMM6GBmyFpRbgxnZdqWhaiG';
    b +=
        '1Am+tOxmEq+IHBwPSBfIhP26bZwaABbFrcCWT5Xx6pC/cBMvgAgzHRXLEcrzAez0OIDw0t207ja';
    b +=
        'C3bI4YB8irHxyGYljUOqI2IgAy0nIZ8YdDIadgWDVbBsGGAyqIRY384Abg/0MvAQSqFfSqTSqHY';
    b +=
        'tgzbVjgNGL3lQgb+ecCgloXNDQ/+MzzAq01EY4QgAaFF2spafFvoCgaIGYsobhiFgm3ZVs7IAZv';
    b +=
        'YViZD0wFywhzwTgBAzoUJEtco6hX52UJIClcK468IeRMb4RQtJCi0gsVzhRH/ozWl8nb8j2qnJk';
    b +=
        '1s9GhIeC9INDc0NOEf8G0K/iEhbEM5CucDawfXZcbGkSpYnwpXH64RWJqIL8QgsARSEv7GIZJt2';
    b +=
        'yESuDR4pLrjMOltGj5i30ZkO8ohrOdsJDpVDX8BQANGQjtIBkzRLRT/EATZ0yaM2HaKqAb/W6mc';
    b +=
        'D/9wKj4wj+2Z28yPwH8OTHiu+5bMXrPc3d1vZPYa5cGv8LX7q3L9J74el2v3t/jaK+X9Z/ja9zV';
    b +=
        'p/3XJY32vb96fKndzx+atOx5VRvP6jl2rd2xZv/qdazY90rFz9c4N/63D+Cc/t1MHG3/jZhCwc+';
    b +=
        'PqBx/d1WF83c2s17IXuHSbZP+RS8Psv7lZarthPefPutn1ev7fuXzzTsn/E5dH+f/Fva/dxdl/5';
    b +=
        't7D7JDbFM5gS8dugG99ZMsu48s8gW1bNz3K1b7h5tYnAD8I7yqjHAzvKvkfSnk4i29KeZj/EY9q';
    b +=
        '81rOfotHFWafdwuMr50Pr9nRwbBvu4X1lbD/4HrbdNg5rpeA/afbhPUe3PDONTtWw+7E0Pfw3Cu';
    b +=
        'gH3QnxXXXbt28ecOuzR1bdu3k0j90J60fvvQZ/T4wUob+kX6fCPoXet1tIfSP9boR9C/dVuGBLW';
    b +=
        't2PQKz0uZ2zG1dP1zZZ9xGakcQ2J47dnfsNP7WbVxfBRzgWa/rWLvj0W27NmzdwuVy/6d51sOU9';
    b +=
        'ruN6zp2bHhnB/LsQzu2boZJGv/s+zgk5EPjOd99J1R46FHjK77XsYU6Mb7qe9Kf8TUfuGtLx441';
    b +=
        'uzqIxYwzfj5it3Ud63d0dBj/4OeEQwTwdT+86+Y1O3d17Fi9seNR4x/9ggAhx4M0+rAz6Z3wutP';
    b +=
        '4pN8KtAOFpaMSbzuNT/kT1u7owMqV0zU+7U8Mm1WhwtjvFx7ctBMGPWf1hp2rO7Y/smaT8ef+hB';
    b +=
        'C25qGHsF1UdMmS6nNjWH9YfW5V9R9bOSp6aNucuau3bukw/sVvigFRtZ/o1TY/ssn4XRnV5g2bN';
    b +=
        'gGONm3dus34Va+BK23YsmbT6o7d24yTic62rF6/Y+sj2wx/XAykukLEAZOHCS3XbFm3enPHzp1r';
    b +=
        '1nes3r15nfF9cyIV7Vy7ZhMwMDHDg8yMO41ZzTy7NRt2bAB5g6Jy60PGd/zGBHjDlg27jB43SAD';
    b +=
        'XPrxx9ZbVa9avx0VBI5xjfNgbrc5c44PeVTXqAGKqejs4xppzjR6P8YLQjvXAKOuki2/VLphrfN';
    b +=
        'tLzpzlhvEFuykB3tyxY32H8ZTZmoDqmP8rf1KibMead8V3Mz5itiRK1+wk2hknbOaBR7Zs2B5i/';
    b +=
        'f8XHiAYofy0r0GAXLuMXlPGN2fn6l1bhSWNPzSviqCAHkhs2LatY8t64K6da2GRrX04vEe3M2GY';
    b +=
        'msYfhV3P1bvecFUEHLnnd4c9V9U0Pm/GN921YVOHVvRfWquKov/tZKgIpAbICuNWRiRsZjC4bRv';
    b +=
        'nCoEfV3mCP7xm58NYAqTd7zJpSdbFNT8pRHywY8u6DWu2iFSkRWE8abXWWCNUz/i2yoV3Xvtwx9';
    b +=
        'qNxhdkESYkyIYtsGyslsoCuvMBszGEx4g9oCrlELDgNpBaO42DqrWiaCfw2ppNqMd8NmIA4Iqox';
    b +=
        'Qm/OYSu64gr/1kMpinJrf/anBL1v27d6q07Vq/b+siDgHwp/w1tgnq5MSirKSEMceYDdktlAa2y';
    b +=
        '/wpnPleb+d+rSpEazeNz4UKbWz3z/1Ihf+oz/4twinMTM/9LPxeJchrJcSeqp6PiaTUlumEtVPy';
    b +=
        '2P65mufFNjxvCTjN3fvvqBzdtXbtx9bo1u9ZAHdjujA+amSV33gtS+vqFc1bvsMyclrvnHkvldn';
    b +=
        'SsW7t689Ytu1ZDe+O014xyjfI7t8F+2EHgP/OyISXWbulYb/x3T+v1bsvKIhRarQPAPOOIOS5B7';
    b +=
        's41a7c+iCz8P6r2PNgj1z6y450dxlesDE4s7GJ3tGFGNY6bDZt2PrzhoV1RpX1mjvqn0SLg4Yi/';
    b +=
        'YwqcV40712+ZvXrbrkfjip1R9xEBz5jZeEr37LZsPXuPJUKAWdH4sJ/Z+ciD0UB+N14MOAmh2UG';
    b +=
        'RmrgYmFj/U5gkFB6yLj/ia/daPsdym3S5IYzzm34NaTLXeEJFlEFpZ/yWmSPpQGND0v1QjdcWKh';
    b +=
        'bB3kNV91kNmlaCy+cpO0KgqEVbdxjf9iulgF7GXWxes42E3hzjkGzZoMptXdcRAt0K4TjHeL+bi';
    b +=
        '25OSPh8OJG5zGL/wx2XWCgREz3j5yIWBeTvNhp07M21vMpVHXHQJ+1Ir4pgmyLBELPMabOpimV2';
    b +=
        'G8WoccQzezLaojQ+6jfpa1S44LdCLpgbcsFnanHBXOOwX032OcZ/92vtN3ONPjNCFxHz0+Z4TSr';
    b +=
        'pZP59u0HTJpHMP1LRpGNSnvMrRZ5eliTzXON3qsk81/ioq2mYO7fvMJ6VPgmw9tG1m7bu2rp5w1';
    b +=
        'oq+6zIglAdBUVw9e5HZ8/+b7ONXkEQN9u6pfMR0mFeEO4UTRT0np0dxuf0boBRYLfc8MhOHKnxx';
    b +=
        'kJCC0bN+BtKmGpHBxLxEdDkN8FUdxofFfRpurCULEsqTmTrgAL0O970pEIVqloxQT/gXZnU4SKF';
    b +=
        'saLir43W1xzjQ2Pra47x615LUtEM9ROzFnyu8eeila/dCmYOq5JxZ8esYQvnGk9bWcEv0nOX8dd';
    b +=
        '+SB7E9k6wOcAs+rzfsnZXnI8k5paQU+Zy41ORlTFXa/27Tj7qUuj9N7IeANTxyNpNGrwQdyCwj9';
    b +=
        'vjIlii8sdt6XdHBPqW0xKCElW/5WQjnREX+V9F647zv6GuTCqy73pwA5j8GoOJXvo/vWkjVzTOe';
    b +=
        'aVaNSr020+EBkOiltEXMsjcUcbx5+E4hqto/Es4jrkjjeOT4TgStYxPec1A0CoF4hkvqwtt4y+8';
    b +=
        'bFQN83/pRds/Vj9mRvsrZs+ZBZEQ10ew73hJGPbyXU9XEbDWn5ixaoL5H5jNeJ8tq5Ob5NZmvF0';
    b +=
        'ltEtTLzD/flPTlvB+X/QadiTv911Th2CdPzAL6za8E8c5N4L9sVnQNhiG/a3fWAnbbXxNNSGa2N';
    b +=
        'iU215v/JOT05A3d7exvAkXGXNsNJS/8yqheJu/9zI4nOtBum1+cKfxhJV9Z8dapP5DHUBc419lE';
    b +=
        'Ys6+fDardseNb7tFHRgBxqoH1GJig9SxY9bIU0WRjc87zVW0mm38V9uY2XF3cb/dlsFOGf1tk0g';
    b +=
        'xDfEZSetrKYe7ja+5GY1BWy38WVXRwkAPuBktz+yddfqHR2bV8+Zu9DoV5ko3z7POG1lwuWOq/h';
    b +=
        '7XpSFbo1/9QphNhy78f3wyQjsDkRh40IMYZob/xZ3gw9YPqP1CjtevyjRkCUN51dVOszv2mo8FZ';
    b +=
        'ci1xn/LutL8qGF+AmrucpCfGiHcUpMvggsNuJRK9I1NL43/pcXgTXGN4ZiMG8wDP6GmQ/BoVjcp';
    b +=
        'zKhGEb8/cCLsoi/H4b42xbj70dVsIXG8yEGt4U4/Y+4I8Tgs1q/qDN40ZZDGPyclw7zgMGjcSlh';
    b +=
        '8D9DDHJ+9SMbtuy6fi5UYzBnBYPbatYGRtFrt8/TarckaodG+t8KHRLGPdT/bTtZf5PUH5L6myr';
    b +=
        'qf8zORlsXIvgLbpxHDJ92G6N8hOLvVgMXGufdfAQUJH9P6wyxPOBl9d3Y+Ikd786E579yJ1QxnW';
    b +=
        'DzC/LgRMemsOppp3YrwOoRd0IVVqXVH7jVj0BCbA3ardXYknaDdnK9yJ2eqkW/HbC6Jta4izyMn';
    b +=
        'FNd9nDH7jU7127YYPxe9OSzouB9XiE2Q16/dDkacn4laK6V0oyVbbOtdKpPmUbZzPyG+Qn7Cf97';
    b +=
        '/ofg79PuPv+kt/1x/xve19VvOt/zj3jf8//K+7L6EKT/P0h/z/8/9r9Z3/P/BFLHfcw/6b8fft8';
    b +=
        'PZR92v+f/NvwdgPwH/Mf9H0GbfucAlHwTIN+Av2/5XOs34O/X/X3ex+A6CLDf98/6v+fi337vX9';
    b +=
        '3/cP5Ofcn7Z+fv/H92eqwXrG6bW73f+1eo+1XzS97n3C+6f+p92P11/7vQ99+5Z9SXreedf/B+3';
    b +=
        '/t99yn3Y/7nna97B50/hDt/3nmP/xvOe/2z3knv/c5/2M+b3/PP+3/s/6H/IfO91kedP/Lf5/9Y';
    b +=
        'fcS5oL7vdnuPez9xH/degBT+dXufsvGX//ux+5te+sSHpsAY7lXr91p7rjDKQ97GkpphBGab6lZ';
    b +=
        'FI1DlU0ZnYBa+5qnFAWTb1J0rcghevJGgCLnNXhyY5YOqs00ZRRuSPZyEXsoHOOlC8qjqLN2JmS';
    b +=
        'xkjjE8A8k+1TnTMoqdeM/9qpiGzg+ZnaWJUNQLRcoobVhg4S2PAjQXSOYEZBrCzCnINEoGmh2CO';
    b +=
        '90lDXtMAMG1V659cu2Ha3kA5qbKPWZnud8oPO1PChqDTuykgS85vqgg+3SQeXpJ8L59pQ1LrK7S';
    b +=
        'xkWKmp80O4ONS4L9ixRW2rBEURHeoXy8osjsKm1YpHAQ5SNQtCEqgjscwiFl2tVBvGbbFQzZLO9';
    b +=
        'XncXXQ+0hW4ZY+A8LEvsdwlsekcTJAmKGkzORGt1O8bV43ecUr8XrAad4HV57nOJsvB50inPwet';
    b +=
        'gpzsVrr1Och9cjTnE+Xo85xXa8DtnFBXh93i4uxOtFu/g6vF6yizfALfvNzuIkuPY6nUXggnIf5';
    b +=
        'CfjSCHvIxzyU+DaDfkUwr3OYoB5uBZxXm5nsQTXi1A+FUkB8Cvgeh7y07B/yM+A6xnIT8f+IX8l';
    b +=
        'wgEvV2EerlfjfeDahu3huhLvA9e7MQ/3v778L0PPPukWbyz/+6l3f9Qq3lT+1Nf3f8Er3lx+/m/';
    b +=
        'f/Q9ucVE5XVwV2MCQyIluMRekiw2Qb4R8E+SbId8C+XGQHw/5CZBvlba3SF+Lpe+y3GuJlN8q5b';
    b +=
        'dJ+VIpXyblyyV/u5SvkPp3WIuDicEd7cQcdrs6oOBqtMPKgKvbrvbhNd0Oq5OZ5ZIwz0W85trV8';
    b +=
        '3htaFdDeG1sVxfw2tSuzuO1uV2dw2tLuxrE67h2dRav49vVGbxOaFfP4bW1XQ3gdVG7Oo3Xm9vV';
    b +=
        'Kbze1K5O4vXGdloAwS3t6hm8Lm5XJ/BablfH8bqknVZBcGu7OobX29rVUbwubVdH8LqsnZZCsLx';
    b +=
        'dHcbrCmH+24n57+aVyWsSRIcK2gEPwP3BTMADXucDHvA6D/CA17mAB8RHAfCA1zmAB7zOBjzg9T';
    b +=
        'rAA17zgAe8Xgt4wOtrAQ94vQHwgNfXAR7wuhDwgNcFgAcli/D6UEbAcvM6S04wEaQWiwc1E8QMi';
    b +=
        'BhcBwNOZ8mCyj7IKhBBXOF6Sp1yeCUj13r4e8rpLPzQCZxgClZ/bVR9CqWgOytIYcmsqCQVdjSl';
    b +=
        'upPJWPXaqOrkuBMfS14TlfhhJ5OrO5mEVa+Lqk6KO/Gw5JqoxAs7mVTZCWdXxugCeFLKwqq2Oks';
    b +=
        'G1IEuG6IuV1JqAMXcIbuzZFdjuMeOJOKARZ3anYXvWrAxXYldNUZdXRl2ZQfTsSQdlUynFHSUqu';
    b +=
        '5kBlZtiqrOiDuZhiXZqGRa2Ilf3ckVWLU5qnpF3MlULMlEJVPDTrzKTlR50O3kmYYoQ+B5t7PUo';
    b +=
        'qNk0BWmYpQg/g+4ULWENxoX3agUkiqlVypipfFRpWJYydcrBVhpQlQpCCt5caWQvtpgeUAruYiB';
    b +=
        'pXxY6AQudtoaderGPBbzQj68k1vNo23YfnZUtS1uX2OhtFW3vxrbz4mqXh23r7FGrq5ufxW2nxt';
    b +=
        'VvSpuX2N5XFV7eVyfXB5umAWlo0JqEOtUYmv4hVBzDYyN/Wty/tiYvia/v2hWH43JH0fWHIG/qX';
    b +=
        'wE1qbyEbj68RG4+voEVxdirq61HVgaNQuj7AE1xf/YJH9NoT82eV9T1I9dyudHkPJG1XImrrgMo';
    b +=
        'f7LwMtPjsLLT47Cy0+OwstPjsDL+QQvz4x5eRThPHME4fwS5PJLEMkvURoXxiCNC3VpXJuDnxiF';
    b +=
        'g58YhYOfGIWDn6jJwQWdd8EInihmMRi6Jhu0B002aA+bbND2mmzQHjHZoD1qskF7zESDtg0sluK';
    b +=
        'NeD1uFm/C6wmzeDNenzGLi/DabxZvwetJs7gYr6fMYhmvp83iErw+ZxZvxesZs3gbXs+axaV4HT';
    b +=
        'CLy/B6ziwux+t5s3g7Xi+YxRV4HTSLd5ChbRbfQIa2WbyHDG2zeC8Z4mbxPjLoVfGNeN2vim8iw';
    b +=
        '14V30wGvyreL88yIsbF26viW+j2qvhWGp4qvo2Gp4pvp9ur4jvo9qr4KzQ8VVxNw1PFB+j2qriG';
    b +=
        'bq+KD9LwVHEtDU8V19HtrWIH3d4qPkTDs4rraXhW8eGIYJEZh1IF1H6jU2emu8VmYl6ChVh4Dy7';
    b +=
        'myvUBdVJ6eeUigHJfL6/kdCj34vJQAGi8NBENQ6x/v9jbbxZ7+01ib79R7O37xN6+V+zte8Tefo';
    b +=
        'PY23eIvb1C7O3bxd5eLvb2MrG3l4q9fZvY27eKvb1E7O2y2NuLxd6+ReztRWJv3yz29k1ib98o9';
    b +=
        'vYNYm+/TuzthWJvLxB7u13s7flib88je1ukuCwlWEPBw2Jvrxd7+yGxtzvE3l4n9vZasbcfFHt7';
    b +=
        'jdjbD4i9vVrs7V8Re/sdYm+/Xeztt4m9/Vaxt9+i2du/7KrVzDGqVjPrqtVItvBoZvBoFvCLNH5';
    b +=
        'nJlQrt5Zqla+lWrnhTfKvTtUqP2bVKl9XrX6mhm6hbuhqbOyOURq7dWn8c2jounVpXJfGrwZDdx';
    b +=
        'LbuXeInXu72LkrxM5dLnbuMrFzl4qde5vYubeKnbtE7Nyy2LmLxc69RezcG8XOvUns3JvFzl0k9';
    b +=
        'uwEsXfHi707TuzdVrFnm8XebRJ7t1Hs3RaxZ3Ni72bE3s2Kvdsg9qwr9q4h9q4t9m66km/ZDp0p';
    b +=
        'dud8sUPniV3aLnZsQezWOWLHzha7dq7YwXmxe68VO/i1YhdfJ3b068RuXih29AKxq2/Q2SMWKpb';
    b +=
        'OR6ccMXKjvZCN1EpJAXWm6OWV4gDKJ+vllWseyifpRm6NQzf2dtCGuqq8t7O0KmdkAnOmdVShC8';
    b +=
        'ZMq08VN0C107BcFpFVXD4FyZs5eRKSN3HyGUjewskTkFzMyeOQLHPyGCRv5eRRSN7GySOQXMrWN';
    b +=
        'p4iW3JabMmpsCWnwhZb04csOR225HQYl+4BQLnNve2HpMHJfSjnOXkJ7pHl5EVIZjj5PCRznLwA';
    b +=
        'yUZOnodkEyfPQbKZh4YH7LYcpFtyYG7JgbklB+aWHJhbcmBusXhJPvVQ5cMgdtv5BofQrOPkQUj';
    b +=
        'O5+QBSM6V6aCIlulAco5MB0TVdTIdSOZlOpC8lkeLZrzHx93dHh9rD7n8OOCCy48Dzrv8OOCcy4';
    b +=
        '8DBlHWnLHRbeb1ZT9+KvN6Sg2gnD8PpU3BXXrpXZQaxNIzML7Q+yZOnoiTRyF5p964U1xnBnA1P';
    b +=
        'Ofp/jGd4jrTj0UnK4pM9qrBouOJojupa1xceE/youlcYneVOhepHs5gzYNmcKd40HwE+1gou1fh';
    b +=
        'uBcvEyva0toUrfKbCn/tsMsR7hXkXsNo7yXIGSeaFzkrNcvJv1u59HEg5dnhznPc0z168D4kiuY';
    b +=
        'VvmlHEgJF/2zhnbZO3qkSY+WGbfhzTeGHcUNc2CdDrgtCYVN9ywB/ZhR+lLzlGWqpFrMkL9ksyV';
    b +=
        'fYi3Elm50ousnnZxwSD67jy0YxW0YfMWsxeqqUzU5+uBXe5pQZ2OiiRTsNOm7R1tRZyhS+6oEgb';
    b +=
        'w4okQlaghwmcsG4oAETDcH4wMYEju+Q21maEGSQjUJxx9t7D/LvUShtDXJ6KasxvVh6wsW7Nuil';
    b +=
        'rNn10T7r4uBsvdSmVD+WnvfQ/yCtl7IyMwjoXIKeOp//+Ed7vo9LBdhkCbryfOcDH+25XnSGAVI';
    b +=
        'uBnX9C3G1LKcCM8h2ltLlAiulZ1z0CNB4ZiBUO+LGn/ZoIDA8qGcYQZrUEw+TNqgTupHh0gBd0M';
    b +=
        'b0Lu3hR+UGY7p7a3x37d6tetPe8N5NCS3qpd+7TZs5sXU8gJzevi8cQIMO7XeHH4BRXtwJKsYYx';
    b +=
        '7FQH8dsbRzZ8uKNrMFo6wY2VVBuEHHsJYkEhxJSkKYUftcLzLKBD5WzKlPu/nS/UX5NeehTsGd8';
    b +=
        'xzEy5e/2AWB++flPCgCa+9IR+WWWSC/KluxVNjpl2uV92PS9VLNN+TAxtQslFjCbQeuymx6qep0';
    b +=
        'zjMx77lUPs6vnoLh6kkg02MMTJV9grsRuY4dOI3ToRJSJQ6cHSXTovAszOciIQ2cWkuLQuTEwSH';
    b +=
        'nD4e+HhQ9WRujQ2RlLTnG1ZO/OfJhB786m0PvSIIfO10vDbpO9Jnvk2itXcrtcvBFdDGOlpynYi';
    b +=
        'H3k+dLAF5ASTwdZ9uekTWmT5rS5KbkpbdKcNjclNyXZZsoHoagzKoI77Bc/zn3ikteNZEB/zlXI';
    b +=
        'VSSKu0N/zot25MQprp2NsWvnLPHDvFb8MK8T/8vZ4uc5R/w854qf5/Xi5zlf/Dzbxc+T9NVB8eM';
    b +=
        '8J36c520+9rpgo7o/uv+myX6asFeQGl7pxwm71Jj8N2E9kR8o7E01/TjRf3Om+Hnivt0N1zfI3j';
    b +=
        'NPfCZvEp/Jm8VnclHkk5ku3h3YwI8OMCJuJRnQ7W0wQxwwSTzYwzKwf9lgtjhgwnhgrmSKE6XtY';
    b +=
        'umrLH0vkXvdKuW3SflSKV8m5cul/HbJr5DyO6T+StgeJwUrI39OOj9y5PzIk/OjjJwf5eT8KCvn';
    b +=
        'Rw1yfpSX86MmOT9qlvOjFjk/GifnR+Pl/GiCnB+1yvnRxAp/zUVyfnSznB/dJOdHi+X8qCznR0v';
    b +=
        'k/OhWOT+6Tc6PQIE/JOdZB+V8q0fOuw7IOdg+OQcD5n8DLUw5XvJY/6Tjo1lyfNQux0fz5fjoej';
    b +=
        'k+apTjo7lyfDRHjo9my/FRQY6PrpPjo2v5+AgNi9Pi1nlK3DpPiltnv5I1OC/W0EEtL7nBJH0T6';
    b +=
        'MbHdSi2+8mdc17SUXEepU44vJDZuRmFVrivTU16YspjCHxSk056YqbDjqZWdzIl6Yk5Je4klfTE';
    b +=
        'TIWdTKnuZHLSVW5y3ImfdDn1w04mV3bC2TtjdJ1wOpNClixE2PlQ2y/loy7vZHXKYjOt5FRjGE0';
    b +=
        'sEYj9pIF389MZm13smiqedUFXDnskZioeokBH6epOrkx6Yl4ZdzI96Z47PewkVd0J+YS2VDyiok';
    b +=
        '5q+oR283OqRCeR8pF050Tdb1yl5kFMxSg5ER5BXZH01LwiJFVar1RKemqWwkopvVIx6XlZDCv5c';
    b +=
        'aWQvoP6M1Qc0J1cVHke4LJj8MSKxxHEY/mKZ4on+FlXBY/OTLpjzozb11goM6vbtyXdMdvi9jXW';
    b +=
        'SFt1e3IHvb7ikSy1r7E8rq69POYll4cXZu2gUmoQ61Ria/iFUHMNjI39a3L+2Ji+Jr+/aFYfjck';
    b +=
        'rTrGq+LviFKuKtal8BK5+fASunpfg6saYq2ttB/rRQOMoe0BN8T82yV9T6I9N3tcU9WOX8oURpL';
    b +=
        'xdtZyJKy5DqP8y8PKTo/Dyk6Pw8pOj8PKTI/ByIcHLs2JeHkU4zxpBOL8EufwSRPJLlMaNY5DGj';
    b +=
        'XVpXJuDnxiFg58YhYOfGIWDn6jJwY0674INPEmsYrBzxY1zn7hxHhA3zh5x4zwobpyHxI3zsBxf';
    b +=
        '9crx1RE5vjoqx1fH5JirT469tGOwJXIMdqscf90mx19L5fhrmRyPLZfjr9vl+GuFHH/dIcdjK+X';
    b +=
        '46x45/rpXjr/uk+OxN8rx15vk+OvNcvx1vxyPvYWfZHjaKddp8eLsFy/Ok+LFeUq8OM+KF+eAeH';
    b +=
        'E+J16cZ8SL84J4cQ6KF+c58eI8r9iL85JiL84hxV6czyv04qRTsw0RvUIjbhIfqCedOReLxcSc1';
    b +=
        'MPnUG7V6oA6ab28cgn0sLNnVF51EMzOnj3hORcvf42TJskJCjoTkrF9vxjbbxZj+01ibL9RjO37';
    b +=
        'xNi+V4zte8TYXinG9h1ibK8QY/t2MbaXi7G9TIztpWJs3ybG9q1ibC+peDlysRjbt4ixvUiM7Zv';
    b +=
        'F2L5JjO0bxdi+QYzt14mxvVCM7QVibLeLsT2fjG2R4ZFftAo2iLX9sFjb68Xafkis7Q6xtteJtb';
    b +=
        '1WrO0HxdpeI9b2A2JtrxZr+1fE2n6HWNtvF2v7bWJtv1Wztn/ZFatZY1SsZtUVq5Es4dGM4NHs3';
    b +=
        'xdp+s5KKFZeLcWqUEux8sKbFF6dilVhzIpVoa5Y/UzN3Ma6mauxsTdGaezVpfHPoZnr1aVxXRq/';
    b +=
        'GszcSWzlrhQrd4VYuXeIlXu7WLnLxcpdJlbuUrFybxMr91axcpeIlVsWK3exWLk3iZV7s1i5iyq';
    b +=
        'cPVvF2p0g1u54sXYnijXbItZus1i7TWLtjhNrtkGs3axYuzmxdvNizXpi7Tpi7dpi7WYq+ZbN0F';
    b +=
        'lidraLGTpfzNIFYsY2itk6V8zYOWLWXi9mcEHM3uvEDL5WzOLZYkbfIGbz68SMXihm9Y06e8RCJ';
    b +=
        'eHMecIRIzfaC9lIrZQUUGeqXl4pDnq8cFfj8so13+OFWxcbuTWO3MjTQRvp3ejLeTf6chrky7kR';
    b +=
        'r33o01nlqrkodtW8OXbVXBy7apZjV80lnDwcO3Aeihw4ywchuYyN7ZvEh/PW2IezR3w26U3ClfI';
    b +=
        'm4R3yJuEKfpOQXDXt2FXTiV01vdhVMxe7amZjV80GTp6NHTjPRA6c5ecg2cJDy4gPZz724RwQH8';
    b +=
        '7T4sN5Snw4T1pyWG6xdEk882BPzQWxp+as2FOzPfbUvD721GyMPTXFwfMCJGfLbNzI1/Nc5OBJR';
    b +=
        'rzHR93kwnktu2riw4Cz4tJ5Rlw6nxOXzgF6GEPOmqt0f8tVlOq3xdGzeVhHT/Tf7Iz9Nztj/83Q';
    b +=
        'TweSCT/QjeI1E/lrxq4xG8VrJvLX1ItMdqjBoiOJInYsJSfWTnGg2YiunBsXqW7OYM19ZnCXOM9';
    b +=
        '8xCuj35H4VvaH7pyyUKxoU4s8LMmd8xAt2wHNnTNynYzcOdFVqUVO/r3KxY+DYa/M7tCdM3Lo0b';
    b +=
        'wyyZ2TZcSg5s5JTpkDbnKsCafMH8YNT+junK2huKm+pbiU/Sh5yzPxk0NxShsQZ87D4sSJDj/jO';
    b +=
        'YhdcQI6cjqaIyc+2ApvcIIcOfO8y4hHJ6CtlA39NymR1f0385jIBxNiR8795KqZ1R0qeWvvdsXN';
    b +=
        'c2ItV83IzbMhyOul+aSbZ76WIye5eZ4hR84aDqQDlY6c/RWOnKQv9JNiMaDrXjly5MS3T3KdpQz';
    b +=
        '69XniTpqtdDykLuLGn/ZoIJEbYYZUk1rOlN0uDdBLOlP228OPygvGdPekI2d474mVTqR07+ZKJ9';
    b +=
        'KXeG/NkTMjjpzhABoqPUlpAPlK987hBuCgI+eYx7FQH8dsbRw5dOTMVawZceQssIske2JCCWkZL';
    b +=
        'ejIaQSmOFgOooNlPlP+4B+T++bhY6E/58WnycHzxNMC+PS9ajP7YPanJNwmujgW7+YomcU3SPzH';
    b +=
        'e3gR4rkBbpR4boCbIGpquMHh+QFKOXIZxDiKb8ZBmOy/B3shanAUBzHFLjqo6ZEfHeq4gz777w3';
    b +=
        '47L/X77P/HmwG5K/Xm2L/vRMSt7Enxf57sC1Q3MfuFPvvnbfZfw+2GPLfg42I/Pcu2uy/B7s6qm';
    b +=
        'jlE5C/HyUMvYZiFr5oBvfxhUON2slQo/YIoUZBG8b6cO1RRXKJPYBephw+1MEr6D9ZvB5TQE9+p';
    b +=
        '2Ur6N53o6fHW9CPdBtySWtwN6a3L4CdoBWL7gq2YXpiQKCJCHo9gyYwaAKCVjFIAcg6QT6cqpM1';
    b +=
        'q0hTCLYusEjngOugXAfkSq+8gEbzjMWOficsDjCaY4fUrbi1blukziN4G217F6gl7qsAPxPDzzI';
    b +=
        'cNtWti1iF2Upw1GpQvPOgyM+UFP0GUfTzoujPEkX/WlH0rxNFf7Yo+nNF0b9eFP15oujPF0W/XR';
    b +=
        'T9BWJoLBRD43ViaNwghsaNY3DbvJfCcOJrABnQ4B0wMmzNZdOBncouTob8FMhPhfy0V8Bts1Fz2';
    b +=
        'zxus7tmn80a5TGb3TiP2kzFIzZTtddmv8TDNrtrHrLZXfOgze6a+AYlaqAHbNZA9+N1MijFeJ0i';
    b +=
        'bx1NbVeXkJzT2tVFi0+Knrf4pIi4CrR24glQuolNQHU/Z/EJ06C8UHVWlHFil9vkLaWlovkuE81';
    b +=
        '3uWi+t4vme4dw5QriyvuZtZN+m8cdPnHqc1hZPebw+0dHHfbbPOKwv2avw36ahx32zzzksDJ70G';
    b +=
        'G/zx6HNfIDDru57ndYyd3nsJLb7bCSe8lmJfeiLTw9J1bHL/rot5l41+GEBQtPgsGULKgMVQrRz';
    b +=
        's9PeQ55Ygep8hAKc1Rv+XnMXVFNNuyhp2FcNqGP1ur2r49qTYzb1/TWhPYTq9uvimpNiNvXdNSE';
    b +=
        '9hMq23P2zoRfa4VcKne7kaNmU4Wj5kXZXEtONUpPuJFEuUhaKyhdmqNmc8XzootRJNFMxVv30FG';
    b +=
        '6upMrkz6WV8adBEkfyyDsJFXdyYxk0MsZcSc1vT2hE7+yE5gjIbTPTDhqniD3S10X8YWLGCWI/9';
    b +=
        'hRc3LFM6VDfOAdVSJHzSkVD5YO8al3VIkcNadWPF06xEffUimkb5/+VAAHdCcXyfPRhgpHzWkVz';
    b +=
        '0OJx5oq1O5DHDGpgj1nJt2aZ8btayyPmdXt25IezW1x+xrLo626/dVJZ+ar4/Y1lsfVtZfHnOTy';
    b +=
        '0FyDKsUEsU4ltoZfCDXXwNjYvybnj43pa/L7i2b10ZicTqBG4G8qH4G1qXwErn58BK6ek+DqfMz';
    b +=
        'VteS/pVEz/2KE/kuQ9y9B1I9dyjeMIOXtquVMXHEZQv2XgZefHIWXnxyFl58chZefHIGXGxK8rD';
    b +=
        'lqjiKcZ40gnF+CXH4JIvklSuP8GKRxvi6Na3PwE6Nw8BOjcPATo3DwEzU5OK/zLpiSjXiERZblC';
    b +=
        'YstxmcsthhPSiCOUxKY47QE5Biw2GJ8zmKL8YzFFuNZiy3GQYsdOM9ZfHR13uKjqwsWH10NWXx0';
    b +=
        '9bzFR1yXLD7y6rb5CGyfzUdiFy0+Ijtg85FZj81HaAdtPlLbb/MR22Gbj956bT56O2Lzkdwhm10';
    b +=
        'uj9nsctlns8vlcZtdLo/a6HJJ1r/uqbnPYQ/Mi7bE0bTZA7PbYQ/Mgw57YO53JI6mwx6YPQ57YB';
    b +=
        '5x2APzkMMemIcd9MCk73TQk6fjTnEj3d4pbpLvdWym4TnFLRHBIruNXTW7rYSr5kUlVhIzE6zES';
    b +=
        'l/NSeFqTuvllasAylN6eSWrQ7kfl4cSoE//3Aof4qAvIVnY7xAL++1iYb9NLOy3ioW9UizsO8TC';
    b +=
        'XiEW9u1iYS8XC3uZWNhLxcK+TSzsW8XCXiIWdlks7MViYd8iFvYisbBvFgv7JrGwbxQL+waxsF8';
    b +=
        'nFvZCsbAXiIXdLhb2fLGw54mFfb1Y2HPJwhYxLmsJFlGwRSzszWJhbxILe6NY2J1iYW8QC/thsb';
    b +=
        'DXi4X9kFjYHWJhrxMLe61Y2A+Khb1GLOwHxMJerVnYv+y61awx6laz6rrVSMbwaHbwaCbwi7R+Z';
    b +=
        'yV0K6+WbtVQS7fywps0vDp1q4Yx61YNdd3qZ2rp5uuWrsbG3hilsVeXxj+Hlq5Xl8Z1afxqsHQn';
    b +=
        'saG7UgzdFWLo3iGG7u1i6C4XQ3eZGLpLxdC9TQzdW8XQXSKGblkM3cVi6N4khu7NYuguEkP3FjF';
    b +=
        'op4rBO0UM3sli8E4Tg3acGLwtYvA2i8E7Xgzaghi8OTF4s2LwNolBmxGD1xOD1xaD16nkWzZE28';
    b +=
        'XwDD8cOU8M0wViyIYfmJwthux1YtheL4bwLDF882IIN4hhfK0Y0jeI4Rx+eDL8EOWNOnsM46t5y';
    b +=
        'BMjN9oLa/tqQp1WvbxSHED5RL28cs1D+QTdyK1x6sYOAtpQ70VnzXvjwJtbxUlhmxz2OnLY68hh';
    b +=
        'ryOHvY4c9jpy2OvIYa8jh72OHPY6ctjryGGvI4e9jhz2OmxKo8sTHfo6cujryGG3K4fdrhx2u3L';
    b +=
        'Y7cphtyuH3a4cdrty2O3KYbcrh92uHHa7ctjtymG3K4fdrhx2O3LY7bCgSD7AIKv6gs9W9Xmfre';
    b +=
        'pzPlvVgz5b1Wd9tqrP+Hzu/JzP584DPp87n/b53PmUz+fOJ30+d+732ap/xmer/oTPVv1xn636P';
    b +=
        'p9jXZWagnt0D8h7KHXRZbe8UnPwlqjobkrtx1B0b9CbbFtgHU3x9ZBc9+P1DVQDWTUg54/ti1Qv';
    b +=
        'wreTM8eRVOj8AfCeGH4wFTp/ALw7hu+TrvvZH8Qm55ATsXPIMxbFY0LHkDgcJoho9iw8FLpKBW+';
    b +=
        'uDIXJ8ZP7vNB3sjV6J6axeuGRX8zsUO4f93SHlMqwl7w+UfAmwl7CPpEYk1UV9pIb4rJKhr0c8m';
    b +=
        'vdUg97Gd9SD3u5z2avr/32CnsxekSij6nuFbnPjrsbstArssDyXMJbYhgk8YpsDL0i3xSGt5wQF';
    b +=
        'DBRCN4Ye0VimMmWWl6RGGayfBFKx9UKbzmEpfvxUDso6KXyXgdta+j4UMsrsodEYmoYr8i+VIVX';
    b +=
        'JPrq6l6RtDP38hae0rQcJwpv6YhXJHLAUb/CK7I32tyjxjW9IvtS7BiYDMnt0QCtpFfkRXf4UVn';
    b +=
        'BmO6e9IoM7514g2QovHfCK3K/95LvXcMrMhxAIrxlty8DKCScNf3hB+ChV6Q31nHU8IrkcTjoFe';
    b +=
        'lUrI/LCW/5TB95Px7rC90hP/Zx8o/s+8Rw4S1tDm/pYHhLGwbQ/4lEeEtbwluir5+sTPK/5FWNw';
    b +=
        'ZcHdRuEC5yyub3wFTNQrzWGVBl41UjIgVOmxMFn0djnBEbhB3aOBtefwsCZH7pWXbnXJqfN9MaS';
    b +=
        'PcNQi8f2H+7tRqnt7qU2Jf3SzLtzJqYKpVl3w5JpC2Z1lV4TtN2XsyA987Gg7U05OzCvMSaB+mZ';
    b +=
        'eZ7YWYZZB2yJl03ouG0EbSPKn4Lcb/hXuK1mTUR4DIsoqCNNZqFc+ZBaOkY0xcxGGGrBppkYwk5';
    b +=
        'rPHK75Uax53Ex0MGsRvvNvl88o7GAWdTBruA4GsOZZpXeA7vKQPSzZJe/GlrB/WoH59JLZ71sy+';
    b +=
        '/3Ba5bs7Xr0sSWf/a1nz9t7lnT/3hd7j6suvFHJKhd2lQuPFBsRl5wupcrG64k7zMLbsH8M1CzJ';
    b +=
        'AcXJrJmB3EULR5zayO0AnIFeGst778TWUNIoJSWz0BT10xR10xT1EljlF16wtheaIM+ftLfLh1K';
    b +=
        'dZXsHJOwdpcnlXlNMOhdUoZQQ38XaA6rkQ8pfObnklNvugls7wA24u2TtDLEmaOxwWZ4zYcVkmx';
    b +=
        'G2ZzvGqkSMF2GrIX9c00IEdHWWUkEKhlDKwpi6cCUgBDYLek+GHGqN0oTAooImsIKyK4JckFqxA';
    b +=
        '6phjaZgwgqANq3YgeIBWApuYOLFDMbB4lcgwJfTAm+x9+L3FGC5lYAdDqfQpQ57hQu+E1B+TvHN';
    b +=
        'Tbx5im9uYdfmih0gfzJLcyg+rl6Zc+GidmET6KRsYk2YbWfRyeD6Rmwhli5aMCOwQAMH8GSWZ67';
    b +=
        'KNTIdAL1FIQ4mWwjhgB1guF2IFOQLxOdeoKc5uWgxzYA4gcnIQ/KRHzRir2iW9zL+UjKb5TBka8';
    b +=
        'XkkrU0Z8K0Qcgjb7k4gubAZUq52VQGQIAKBykAt34nzAB409pO/WZBZ1hiFNuCcUUz62dgJFb50';
    b +=
        'gsvvOBt31i0wgKkX2DOV8aS9J6gravUhm+/mGUbd/JcCAaej0r8YUuyw5RgEm4G6wTpaWHfFhAz';
    b +=
        '64FOgihvzOYy5R8996xRnlLu+cqzIpJ7IVWeWu6PAANfoRoXIsAlBLSXj381BJyEVHlB+VIIAIq';
    b +=
        '2lS+9+7MiqVOINVh3RWvYScP4ZLQWohJosCpIFS1ivbanSiayj4vsg/LPAdJ3BsQ6Ls7DzfBCM5';
    b +=
        'BzjpololY6ppY1Nmq1FHHF1aBWy8+UWiaO/qeMzmNmLXyC9PcRlanAX8oiEgU6otNHdLojo7NpO';
    b +=
        'HQ2jYROUB+HQecwJdlhSl4pdNqEUJCOPuJTIeZIGjI+fajvBH4GEYeCqNeRXQL3ItgpzHinyNI5';
    b +=
        'LleBPas4heUgCa1TLjXTaltgv7pSoqD2VK32kFejNhgKXGJB7Wk1lRPcy2BzgsuQV2oN/KA13qT';
    b +=
        'CDa44XW40Hq+9TnEiXk+5xUmyQeVkg5rAO30xQGHt4AsmNr7vVizh5D18wQQ1mGIKVygg3gX7yB';
    b +=
        'lRhsPYWYbjfgNbbiS/XRy2G8lvV5Pf0HkaeoPt2txeVqtyoKgFDvRskj1H2+1y3IFxh00HV0Dnq';
    b +=
        'XhndQOP+/bCvbW8dyeAO0sN2uaapxtTCe7r3oqgIXBxfyWB5Af5Fbjb19hf04n9FTf+xBZrJ3bY';
    b +=
        'aQgI70N7rBvtsW68x5qyiRplH+bjFH1AXbYJ1Rw/mIR/RNCZK2jOIyEb2OqykR2hGXr3QZ0Bhh8';
    b +=
        'O1w1Baay4zmu4LlThOp/AdWE4XDdcDq6njg3XLSGugzSuizSiOo+odoKJ+AeodhnV7oiohvWuod';
    b +=
        'qPUe3zcgxR7Q+Dagd2OEC1q6HaZVS7jOpiEtX4cpxTjWpnBFQ7jGoHUe1EqHbGgGp3ZFRPqUK1E';
    b +=
        '6HaqUC1y6gGEUOoboTOg/H4B4imbaqJtqXhES2anyDaiRFN2HAiRDsaojXhgQilBRX4Gqp9RrXP';
    b +=
        'qA5eIlc71VztMFc7o6LaHxnVoHBfssbA1s2Ia59xje8HZoJsuXFZDh/LZjvpcxc3GMgArGo1QKo';
    b +=
        'hVNHzUNVkaVGTDg7TgeyqMdPBYYafHmhGlU9mgi/mVB6lLIwhXW5bmbPgnmlW/JBN4MJ0SjOd0k';
    b +=
        'inGUEO7j4hplMB6FTAu14ZW1GFztJVGpGuFhsKKgZXrgiuAqoAheilfS+4egVAvRoUmpGgULqSQ';
    b +=
        'qOYUV5EH083o9KoaDi4FJJmVEgvGz9ZBfgZD1sM/MXUuVwbyYtJ4wkXC2k8XRY5QfPtaCjdvgPU';
    b +=
        'H16JuOEwEXjB4HyziGlL1EUP1UUntIUAa9lVpIZ5sa44vI7oBd4wOuIwJdlhSobREXnfgqV3GTq';
    b +=
        'hgzqhU6Fik0rooW4XWyyoERb9aJE1IL7wLdcGxlcD4qthJHy1vHrx1YD4SjG+IpOkARHWgAhrIJ';
    b +=
        'MkTyYJYCzPGMsjxvIjYazp1YuxPGIswxiLjI48YiyP0Dw9gcNTzViZx/bZLD/aACsZVy/p9/zID';
    b +=
        'Be4KU9gUCZZofjIjSI+krvrWB+vhIp5hraZVTk8+QIjwSnvhZ6yRVMtJhm9d1nOJCxQ/zhPPDWF';
    b +=
        'nfa1hlF+3TJ6Nhuk0BolRDkINmmjygYpkMArAEcw/M7y7MDCx45ZemQ9hypQJAw8cQqyWIQ6SyM';
    b +=
        'ryLOxnJ+UwOhA8XCzpNI0li987VmxHtOhLfmriRyWQb3G8umopp+wOhsS7RoSZflEWT5Rhnc/i3';
    b +=
        '3+anWfUHYXfQWq8UbThwvs7zY+xuZHsv1pCklAPVyKenAS9zITOVfPlQ+857NGeRIDvpO4ORafm';
    b +=
        '28W9l5hlLtd+ZIUbZvteLpXnteJGQnts5AyPmduoowE8sF3+9uUxME5aVBRi3x2knOtnDvNuSmc';
    b +=
        'G+BcIMF+ODdDogBxrk3CA3HuGvYzx0PJUhpI1v1P/cDz5R+/sLOcLdyLhwAWMpGC7VOHDuFTDmy';
    b +=
        'XgA6STuBUQAdw0w8waFmiroXKNB7DJPqliCqZCmi/icdyfgW020KlMl8Bxa8NFtDKT0B7oN8sGm';
    b +=
        'hJKH1/r1B5NxufamSTUOjRTtQCS6XUiAs4CVUUCCYxV8STl+grwlvh0Z/zXOEVH7f7Mt3xlcB45';
    b +=
        'hXHTuqnckfrMnp1XoE526+Se/gv+h7OK85ZLxc+Xgm8uq/APRpf9D3SP2NZb79KpFL+VSIFGl6m';
    b +=
        'e/g/Y75q+AWSEK8Ef77YXPZnvtu+8nrLK6//vhKr5afDVw0/lV6zv0C9/jzLktzPlSz56WhC9i+';
    b +=
        'Q3vpy4cN5VUqony+d+pVYO9bP3EJ+5Xv9xV2vr7w0/WXkj5drbWdeJdRq+CXkgXqvP2+y95WXkr';
    b +=
        'oVZiRKDfpv+Fzy9KfbxRc/PjPMKdcQvsH1vK2fc1209YOuS7Z+0tXtdGpHXfsc/ahrv6MfdR1w9';
    b +=
        'KOuHkc/6jro6Eddhxz9qOuwkzzqwkOmhqCh+qyrW866GqpOn6rPumbXOurC45901VFXX82jrn46';
    b +=
        '6krXOJKqPurCI7SxHnXhwVqm6qgLj+ayVUddPXTUlXlRR11DdHhWP+r65TjqStePuupHXfWjrvp';
    b +=
        'R1yugSNePun5RcZV7lRx15epHXa/4QdNPZx9I14+6fo75KvcLdLyZ+aXb67L1o676UVf9qOvndu';
    b +=
        '3UH7f+Iq3XbP2o6xfoqCv9KqFWrn7QU+/1F8iazf50j7oSB1h/c5Wayp+bHXA3lrzRIpdxvLJSH';
    b +=
        'K/siihe2QyMV1YKZnQFJYxWVgqueCwoUbQyDlPmBaVFKht45QIG3SpRmLBSGCbMoTBhHoUJw7QP';
    b +=
        '6RYtSJhXPmFqQcK8MEhYnxkHCSsNGyTMqREkzOUgYR6Hl+OIYJ4EQXNrRgTzOMBaGBSMw39Rk8C';
    b +=
        'Jwn959LXTAsCPcmQX7tPeUfLD19U9DIt61MFIAjCK9AoKQlIot62EexSKJvd6xOksNmBWXq/MGf';
    b +=
        'S6ZYkjNsgrrdmyuV3tpXhhS4xiKcCXxMvHnE7swgwa8HVLI8iWfyLvt+LLryV6fZLeBMvOV0SH9';
    b +=
        '+0rAR0Ofv+s1V26YhG/4U5FwRUM3vNYjUpaKd65vBtfT3Xw5XaHYtcCsjJFGTeGBZI+sSfpB3rB';
    b +=
        'Vwrf1QlYSN0FzONhfGB8uZRCCGZzGeG6vfAfB80on/zSs0YnRQVAgoT1V+Wa8dXTpTlrUuA8TcO';
    b +=
        'pjO6EcScAoWbOBCRcgQEsGFMqU/4cvsc4OX6PERkgxhlTEt9kpZYh+tzAxflcQZi5Iih1l2ZoqL';
    b +=
        'sCF4KgLS4UKNx+OHQFDfbiBL6of+iAcEXzzWAogDbll1Jws9TKyaUGjscTvS5u49ujJoavaaCgc';
    b +=
        'RTxSlW/YLpnezFPq5Hm2OcQt1DoHRoA8AfieXzghAEQshS8o7PUqkVBmEgxGhAd2WD8iqA1yGIU';
    b +=
        'BDrVdoOJKwDqrthRxBBvPkd2oCgI+SCHM89JFAR7L6yJnIRAAKLgC7sc+YEYOhtGQHCjCBVOFKH';
    b +=
        'CzcCYolfFXXpTXmhbTrwt7tHb4k4Aiwr/OO7NqpwbLVAUUbjCIdXAwXAcWntO+GqzMxkQGS95jG';
    b +=
        'vBvAHJLKEJX1NmtGUlLs5ywsDkksuvN7tx6JAU3r0hSC0lyWKAyMumM/hu8q5SWl/jLr62jt1LH';
    b +=
        'K1S0FB0sinm0vDNdTcssDDaTBj8qtRVKi2icHp0zJ4PwfQ2upT4w5ZkhynBJNzMYc5xaTFgHC0/';
    b +=
        'CiLnR0HkDpypCCJ3+ExFELljZyqCyD1zpiKI3OkQUPFSdPJF5Sy9Pp/dSAxcGwUwWhm7S8IzcFc';
    b +=
        'F2aJLPAibE2wTwIgpDtrlBWlkPA7nk6KYXakM0Ai4rchbAu8iGJ9L9hPcTRoDW3YHcoBwN9K77b';
    b +=
        'kcxR3J4Sr0KEwm7AvJ7eCMkhKTQnfxLoLrEmNjJms79JkqLsFAX9O02rLnJGsfdXj7LLbCdVDhp';
    b +=
        '9+98n4bP+XO6z5gMZCVDjAeWJFkTNGP97M2GGNxEl4ptDzJouIUmNZ4lNGA9PHFvOgIPkc5oqgD';
    b +=
        '4zkGD6y7ootinKpiCBdZMLROiIuKsEbwJfJgCv7B+gxXyIhLUdYff8AWU+l4JaZxCaajlZjWViK';
    b +=
        'tHgk1oCbBKgQ5CZTF+CRI7uW0QEFCNgUB9J3lhYXLMs29NgeuFr8nHWQ6Sy0cnIck1zi6KZWBfA';
    b +=
        'uaVwQtQRolYxorZYJxKzDaF0hGFAl+ZywgKWRRZ8lnyZji+DAex0txkCNx4+GIW05Q1IMlOTgGn';
    b +=
        '8fgrgAUOigeM5mcmc1nwATKrwClLBdYK0Ejg9yyHEZIyGOUA8htDGMgeEEKla9U0S/7GZi9H0zG';
    b +=
        'v5AamVGoATz5Yqihy0W/mMItLEUhlaoJ0hxMr0mQlmqCjNMIMiFJkJYVwbgEQSYMR5DmyyHItLE';
    b +=
        'QZGkuF+G5iaKXZi2Kv4G74lkUdu9DgQak4hyKN8B2KpiEfxTWiJZXekRKgCxJUsKPKSFxxEJK+M';
    b +=
        'PtUMU0Sqy0Rgk9aFJzMDFJCQk8m6REakRKpJgScfjZDIefHZ0S6ZEpMXVslCCOTzMlQDCSRl8Rw';
    b +=
        'APUhTSpC2Hky7FqBoz2VIx2iXsSoj2loZ3U2wjxaT2qGCI+lYgq1hy0vsJLACOmlFKJqGIeqypV';
    b +=
        'iAfV67iZxHwqwnwqxnwaMe8z5mGbaEL/uzwGdUGhBDCJKhaG9qkKHkU6kis6Up5ijYY6EAxfQvv';
    b +=
        'kYwXpZ6cYaQFFx6ybpFA3SYlugppJFDzKSqomYfAowWUuGI9UwgBnGJXVAhly4UzteDMpPZcw8Q';
    b +=
        'ssXwqM8gJ2VECUNyRNT0C5q6mlHNo1G2E8MjY5lJETz1czPwkcY5ACKg1Tkh2mRNAmAZWIoo6Ed';
    b +=
        'S0kg9cQFdyNtG5qjwo6iIiIqnfgrArcohNSgazZAkfJBXOCOJ0DLBWQDIUM63J9YqCZ6E5JooNM';
    b +=
        'VEfiJXEEI9SAWFyYbID5lKoOrMmW0HKK+EfB70j1RVkBxp2NxDGBKTKgs+YwBJIZWKvwiUygOin';
    b +=
        'm0facYgLqtMfQSZcivoCdBg1I6KAT6A0tiw6PMcjhgsQQSohZKIYbwy2yKM0640BLWSgp2YEdx1';
    b +=
        'jK4SPXjZBBq97mWEoYoIm0DJVRe8tzYMTGJAm5hDpI2VzGAKqck8rl2RlWtbtR2wUtuzHUt+/EY';
    b +=
        'a/akTPpfjjEHJIcd80D/xDGMsKZ5QwCHo6AUTSknBYNycNQtBQNKRnxKHUZEY8en6Xu3+vgo7Tu';
    b +=
        '1MaSOQMNVYO8wfttTtrt6qQkYbmekiRYy6clCdwzIElQJ5+TJBjcZyQ5pV2dlWTQrgYlOaNdnZN';
    b +=
        'kW7s6L8lr2tUFmGB5IX7Io/gWSC3eiKm3QuqUQcC3QXKAk28PjJlqdvEdgIBDDvpqGxgsST4BYq';
    b +=
        'KnOWwbb+fMfgcX49s40+2gD/RbOXOR3MrfQpngHQusIRnLAxTL2MTHWtDxOSP8UIyJCjyIU6N8X';
    b +=
        'oMdo1oXNEgfuXkb5SENdpxqPa9BTpCTtlG+qMGeoVqXNEi/g5HvgUpmDDvp4Hd6jPI+DXbKwQ+w';
    b +=
        'GOX9Guw09XYgghjkrD4uRPAhszPEcK8ZYfioGWIYFzwmEcsXofvxADphxlgeAtgExBtmzkOmNUT';
    b +=
        '5IGQmhig/A5lJIcrRA35yiHJAdb9JH08yy/vcztIUuMFJbfz7ATYV6a/BDgBsGsBOa7AegE1H5t';
    b +=
        'BgBwEWAOw5DXYIYEVkFQ12GGAlgJ3VYL0AuwJggxrsCMBmIDdosKMAuxK5QYMdA9hVyA8a1tHx/';
    b +=
        'uoQ6xdjrHerCOv7VYT1HhVh/Qx01oaUUjHWYemXZoZYPwWZWSHW+yHzmhDrJyBzTYj1PnwYJVin';
    b +=
        'lwPwpQqg+oeexQ8u8GsVip7Fo39ot0txPUHM9HwYK+D3b8In8S69pxDniYi9IJUGkYjnoOVrYbx';
    b +=
        'HVIyQ8y4y4VENcgFqXQuwYxpsiGr1aZDnodZ1ADuuwS5SrRMa5BLUmg2wZzRYt4e1+jXIPq+zNA';
    b +=
        'eZS4Ptp1qnNMgBqDUXWUvFpMP3OK4PSXdGRaQbjEl3PibdUEy6E9DZPCS3Rro+gM0PSXcUMu0h6';
    b +=
        'XohsyAk3SHILAxJh9/kel1Iun4P9y4DX3uJhQHNY58GOQW1bkCe0mCnqdYBDTIAtW5EdtNgz1Gt';
    b +=
        'gxrkDNS6CTlQg52lWoc1yCDUuhnFiAY7B7BFyAsaDL8SdQtygwa7QL0ds2Kc49s3i0Ocn7AinPd';
    b +=
        'bEc5PWRHOB6wI5/ipqDLSydK2AoAtCXGOX5q6NcR5N2RuC3GOX6haGuJ8CDLLouVCwfsNfEsnFg';
    b +=
        'YAW47CQIPhF6JuR3bQYMcAtgKFgQbrA9gdyCsa7DjAVuL2oMFOAOxOZCAN9gzA7sINQoP1A+z1y';
    b +=
        'BO2xhMAW4VcocFOAexu5AoNdhpgb0C+sLUtAjbFe6Itwo63CDveIux4i7DjLQI6uxcpZmtbBMDu';
    b +=
        'i7YIyLwx2iIg86Zoi4DMm6Mtwkd7kLCP7zWlglAy4Zc5ddmTpnexNFlUHgRpcH9wPz7b+eCzFNo';
    b +=
        'wbIs9eYme4hydDvTbclAwE7SeBcrm5GlIZjn5HCRbOHkWklM4eQ6SM7iHC9DDNUHDTAtRh1+8Ar';
    b +=
        'ThB6sAZRm8vB1PHodsFuxGZ+DLx6xMigEpaMFQkYKUxRtDjCzsDJkR9I4gH7UD/SL6iJaJekT0w';
    b +=
        'WAT9YWgKSQ0UmA2DdjqdRZYD6BIhPLmWBhCriVqC1pCMDnKgZoQfSAPP8rQGUyMchgMuzXKoYEw';
    b +=
        'IcqBqhB9D5UQ1O2CcokqOuzxwZSYMSE3NWZJyE2LhRTkpsfiCXJBLJogV4yFEuRKsUCC3BWxKIL';
    b +=
        'cjFgIQe7KWPxA7irJuUy7a5h2r2HazWLazcQLCRnVGbTFqIJcKFxUREXY2CPBAv2HYsXUdmF8vc';
    b +=
        '8PfI29TXpv0adXCUfYcHFz5U93soiB3LVRDjZL/jQwiwvIzY5ysPkFc6IcbHLB3Ig/gDqDQJ1eF';
    b +=
        'byOcbCQcbCAcdDOOJgf4gA/AzovZsMYB+djHAzGOMDHe+HiVhEvczRQO+oGtqvghhixkLsx5kHI';
    b +=
        '3RTzIORujoUx5BbFYhhyt8QcCbllMUdCbmmUg+0kuC3KwY4S3BqvSMgtiXKwnwTlKIeva9pk6Qp';
    b +=
        '3QenymLsgd3vMXZBbESs5kLsjVnAgtzJWbSB3Z6zWQO6uWKGxO4PXx8oM5FbFKxdyd8cqDOTeIL';
    b +=
        'k0U/LNTMk3MSXfyJS8L6QkCOvg3hhddkRJkPGRcmJHlIT9IFJM6HM3REvk0VRC1OocWym2TXrpl';
    b +=
        'hTMqA32MJywxucDRuEg/JRn47NJowi6a9Emm1/hox6rnN1Roq95IlVhhJTeiQ8ONKDFQPyyDEay';
    b +=
        '3lGytUJK7+Qif0eput2OHfSZS5gzvvErj61UYJNryc+B4WziO9L4IEiU+cIRs4Yt26bWRXYs5h7';
    b +=
        'WLNg2tSmyXjG3TbNb29SuyGbF3G7NWm1TXZGlirluMzJSMbvPjOxTzO43NdO0TR2QLJiFwbgy0D';
    b +=
        'Mat24YYv6kGdmEmD1lRuYgZk+bkSWI2QEzMgIx+5wZ2X+YPWNGph9mz5qR1YfZQTMy+DB7zoxsP';
    b +=
        'cyeNyMzD7MXJNtHJtPV0QzIyMKvHBr4qfgeMrOCpIVFTF4e/HUsc7TlYdFh7AgWFuaPKM24alNH';
    b +=
        'VWRZYfaY0oyqNtWnIosKs8eVZky1qRMqsqQw+4zSjCggg4osKKKC0ownoIKKLCeigmTBZgmuj3G';
    b +=
        'BVotFrGFpJguwhhXZK8QalmaqAGtYkZ2C2R5LM1Ha1EErsk8we8jSTJM2ddiK7BLCnhWZJIQ8K7';
    b +=
        'JGCHmWZogA8iSLH2xarBHUJ9MLv3Ue2QDEH1ak/hN/WJHmT/xhRUo/ZoesSN/H7PNWpOpj9qIVa';
    b +=
        'fmYvWRFCj4hz450e0KeHan1hDw70ugJeZJFXdoN7gmngbyVFNROharhVOnTpCuXe39N41Noq3Fp';
    b +=
        'sicS2EbhS7iMzcJ1ICUNlJQkrY1IWlfL3trSWkXSWmmFKimtaxTtANlsoLQ2RFrD4PbiF1L37tx';
    b +=
        'env7OosJHp934NdRAZf5lulJ7p4aPQikwBvVF3oNg+uHFLpxG+T/AYB8VF4YMMqQAtoZAhhjSit';
    b +=
        '8iYwgFzJhpBSADBNLDkDYwdASC31EysGfApPQDEDtwOdPvYsaT1h5mfBkAZVKcQT6zg7RkuMtC3';
    b +=
        'GW3q3U5oHfZq3c5pHfZr3fZz122xl326F0O6l326V12+1qXA3qXA9xlEHfZq3c5pHfZr3fZo3c5';
    b +=
        'qHc5yF22xV326V12e1qXA3qXvXqXQwlc2vQh4X67ZC/58Qs/euHvX3jhvx7fu6fkLPnjr6D33Wd';
    b +=
        'e+LO90gfuw0teeOHvn/j+Cy98ZZo0x+/2Ljly4XN/8sHnjh/6riHTwWPvJZ/5g4OH/37oS39+Tq';
    b +=
        'Bo8zhLvvYPH/+tc//5vQ98QaBgLwD0t774whc+9hcnuycJCmz6KLCNn2aHseKXju2S0xU49z3dh';
    b +=
        'cYvmHt2V4kKeh3gR7gO2LQTnaI2XaV0VynbVXJHmVN3rTkN1ZzToFVzTlatOfVbNeaEyj2srvue';
    b +=
        'xq9uhzPzYEJdGLwEZmjJjIacEi7rM1wnHaRw0g30eW2YdJ4QgIoOlmYDn3ogFPQ5XaVCF6JhptU';
    b +=
        'NVdMYf4Z7wQ9R2/gdK8bh6JjpsWpgprsmZoZqUntQ1cLMgKqBmT6FmEkTZvbrs+4qNRJCLJxLSn';
    b +=
        'CHD84Idzmq0UTsqwh35fPcOh80IM7y1NgWjPS7wBJghHrUy0XGnxdksBdhqm6XaIHaIBYWdOT2M';
    b +=
        '3Kbu0r0+fMei2iCZpngt9e6HPz2qhr47VG18NtdE79DtVeTWQO/YH4Dfhto3od4vA0871ILTZvm';
    b +=
        'khEKXLSEAo1UYxwxHlGgWShwSgkFmmIKDJhMgYtMgVSQRwo0U/dOiDMPaeIFWe7FFQ5OMQWISAN';
    b +=
        'CpBwzA1fJ8TIRIvUIkU7VINIA3Gp8V2lCV6kVqEVUUcRE+Gxd6NSnLodO5EpSSadesxadesxadO';
    b +=
        'quSaehWlIPH5e5iHbkKx5vY1CgYU6imdNcCkLJ/SElW6jGZGJ2hZRsFUqeDyk5jmq0EoaIkhOEk';
    b +=
        'mfMBCUnYI0HmJD7Gb2ZoBkJOZHu7whSB70u+mp1nlnKk0UnS4lo3Zug9ZlatB5M0PpQLVr3Cq3P';
    b +=
        '8GDG67QeZFpP6SpN7SpNE17rM4mn8dmbkLvfvBxyL95YTe3ZtYgd1KJ1oQapK8ks37+R0d0dD64';
    b +=
        '0HQGLccW5SFNkWp5FC9FAFmsvzNCFpchscihkk0kxm3QTm0wTNrmohE0mx2wySGwyVdjkTMgmrT';
    b +=
        'Gb9FuyfYSLbGLEBX0+4jqDLIM8xsRvYj4V/hhK8MfRWvzRl+CP87X4YyjBH0dr8Uef8Mf5Sv6YI';
    b +=
        'gx+3hAGn8Ct7FA+MNs4+JQHi6FdaRpMs5nx7lOrZpq1TLvfx3URTvtirWl3+/q0T9Sadn9i2hdr';
    b +=
        'Tbvb06d9omLaAc58vFDuVIJyoQxUvMKZ/OcT5BdVY8hE+k8RHtqf4CHZc3tMpPLUwGXkMyO6LGu';
    b +=
        'QAaHKbORIB4ULfwoKa4wLpnONcQss9O7wgmlQTJsuYB4QLDuIL2SZGMudgQSC9/tJBLPo9xHTIY';
    b +=
        'JP1ULwACE4EATv95IIbkIc50K+V4I9X8PeoInYawwXjynYy3GVLBHIRDS6wiuHTOGVRq5CilqAW';
    b +=
        'Bwnq3ihLGKXKzQvsAoB7pDjCTOk3bUAokQi+zrDyu4rmCnwDX1Zkp5Gi14fUdQkmDlTiZku+oyU';
    b +=
        '7ApmjWlvw1k3hNuuKTyX1WZdwEmHYqdNOKZB5rzAaqUptcRTSkXK7vlwSrwNsVYmU2Jl7Kgvypg';
    b +=
        'bjdeNxnvRSI6XOMHAcYfjbU0ON73ACvAzazgO6RPuxGO5GI4lT3W5V4Az2BecLrDaym3RV+52L6';
    b +=
        'evtxFSSvhEsvdjz9KYSu59ORW+RQRW2P3ku2uAxP/KH+Gbcf3dfw3jtPnAD0R80Sn79HVT7AwfF';
    b +=
        'Fd3GDh3A+6cx6DNEvT2wuVHbbsekxd3SmZ5NvuAKjb062Z+3cyvm/l1M79u5tfN/LqZXzfz62Z+';
    b +=
        '3cyvm/l1M79u5tfN/LqZ/xLM/IE/eJnN/LjDuplfN/PrZn7dzK+b+XUzv27m1838uplfN/PrZn7';
    b +=
        'dzK+b+XUzv27mv7Jm/qGnXmYzP+6wbubXzfy6mV838+tmft3Mr5v5dTO/bubXzfy6mV838+tmft';
    b +=
        '3Mr5v5r7CZf+zlNvOPvRQz/z0lNUnClDaRmW/xt1UoKCFU6QzjBmC8AwoU4MUFXlzgD1eQ3VGzK';
    b +=
        'w6IHAcP6M1QyPAwvoqF0RRAqclwlA9oyIDuLAW4jgF9WQrpFAMGsxiaNBMDenIUYyEG0FOMwgra';
    b +=
        'TGFYDMH4NyqOM6PiODMqjjOj4jgzKo4zo+I4MyqOM6PiODMqjjOj4jgzKo4zo6oDtE6JArROjQO';
    b +=
        '0TosDtE7nAK0Bb7OJ8Kz8IGU6J0ETC6ZxEh+4TOUkKNrBFEoGAYVlVXEoG1UVllVxOBstKKuqCs';
    b +=
        'oqD1a0kKyqKiSr4vA2WkBWVRWQVZ6maOFYFUe60YKxKg52o4ViVbVDsYaIlECsU+NArNPiQKzT4';
    b +=
        '0CsAdt2iTCs/Mgp4OT5GLGDMWLPxIgdoJCtgto4yo7iKDta8FXFgXa00KuKY+1ogVf5OZIedlVx';
    b +=
        'xB0t6KrioDtayFXFcXe0gKv88EgPt6o4+o4WbFVxAB4t1KriGDyVgVZDnF6McSphVqfFYVanx2F';
    b +=
        'WA9bgE0FW+TGb4BRMuRCn+DxPcAqqS4hTjP2TE5xS3J9CUIiCqzaAiOGoKPQgD3bOxiArcVVNLq';
    b +=
        'NYKxSEWssrLeqP4qg/WlRVVRVVVXHsHy2mqqqKqao4ApAWUVVVRVRVHAdIi6eqquKpKo4GpEVTV';
    b +=
        'VXRVBXHBKqMpRpSRyKpTo0jqU6LI6lOjyOpBqxrJuKo8kNKoQ7o3yF18GmoUAestpA6GD+1NaQO';
    b +=
        'RiJyE/FTVVX8VMXxiLToqaoqeio/gdRjp6qq2KmKYxNpkVNVVeRUfhCsx01VHKRIi5qqOE6RFjN';
    b +=
        'V1Y6ZGuJWIqZOjSOmTosjpk6PI6YGrG8l4qXyA1rBLaipIW7xSbDg9mKMW4yTOjHifB/jbepxUh';
    b +=
        'XHSNKipCoOk6TFSFUcKUmLkMrPw/X4qIrjJWnRURWHTNJioyqOmqRFRuWH4HpcVMWxk7SoqIrDJ';
    b +=
        '2kxURVHUKqMiBpJajuW1HYsqe1YUtuxpKaO4mio/HA6lNQxbgdj3IKCHElq+qTDlDC8XixHPPxS';
    b +=
        'oiYp8vBfQnJQ1KYGaJGVKKhm1BZ7Mmv1BDkjMDRVo9yfg9EXrpOjkUgTyXViaKcwC79UpT+sAoU';
    b +=
        'Yld9aTJ9vRDUNeom1KsUqWhaBWR3o1wKiapZoTt9iMDWlTNGn50KlzBSlTNHHF8oYf4qVMgtDqD';
    b +=
        'fFAAww3Bw0xwAM6dgStMQADG44jiLShX2kIiQgfkgV5DLW/yjJmh8lWeejJGt7lGQ9r7pLDe0aJ';
    b +=
        'qMsll6Hn8SkFBbAKK57OQZBneLdXqY59aVI99cQma4ADKVFkY5wL00MiZOXpjCok+XboLhv9nMf';
    b +=
        'wXiJlmdR8NSM9n3QFH6FR8tr49cGncR+lkPw6TcaZGU90RWGP8skPkWKpgBCx4dB0WjAqagfDlo';
    b +=
        'c5jjGa5gr4Ad6JPZrCEOVwCrP7izpX2tFfUDP48qNm+DK1UtRBuh5XP0O3caO2mAPdq0eWDcZlh';
    b +=
        'lrMGKcE5FwMFGFo3XW7jNQsQmjZip7AZswkMwuYLsFki0L2FiB5JQFbKFAcsYCNktUaIvg00uNk';
    b +=
        'yMDATdRtjbUEc5ekOwxzj4v2eOcvSTZZzi7j3VrdZKzoc5+2gkm8IPwxD1DDRp3F2m4j7OnJXuA';
    b +=
        's89J9iBnz0r2MGfPSfYIZ0Ol9pgb5Pg8JLwpcVCSdyrYpuLjwbEaiRsya1HqHGePSfYCZ49L9nn';
    b +=
        'OPiPZSzI9ye7zeHqi2R3w8EOa8cLC496mSIor1KwYndzsgGRPc/agZJ/j7GHJnuXsEcme42yo8F';
    b +=
        'zwgoma+A5aCNrrMyalzRHOXpDsMc4+L9njnL0k2Wc4u8+WsXI2VAJO+7C+os0AF1I6sZCsiqVoV';
    b +=
        'S7FxCJ0Em3jXLW9X+5uwmcgX52m0ntb8RlIj7mx5OCnWuYru9gILed1zgdtowkjXxqUbObg4phs';
    b +=
        'wWiZnBzHQcYxOR6DRHJyAscbx2QrBpbk5EQKPY6pSZC6iWCTKQg5pgp472tAF4JLG+hBcJkBOhB';
    b +=
        'cAtB/4DKlWMRLK37laL5qwc/HzleF4gy8ZItX4sUvXoXTxi/Gws/srlJ+yQvwL//ewALYY6XgKf';
    b +=
        'z+2QMBfmCwMcjj15O6So1aHTsIALjEfG8XVU61q3VQuRBcFTRy5Satsq9VLjyF3w97GCpPDq4Mm';
    b +=
        'rjyZK1yNijolTPtahNUnhTMCCZz5Ula5UKycrZdbYPKE4MrgklceaJWuSVZOdeudkHl1qAUTOTK';
    b +=
        'rVrl1mTlhna1O8BPm00JWoKpwbhgWjA+mA7iqBi0cuMJfBnPl3F8aeFLM328ulnr/pqgRcu1BeO';
    b +=
        '03IxgvJYLgglaboo+rCg1JUpNjVLTotR0vHvZ3L4RDK/8U9vx+33lvTtL3vYdTGI3aASoF6QQsI';
    b +=
        '4ATQRII+BhAkwmQAYBmwgwiQBZBGwjwEQC5BCwiwCtBGhAwG4CNANg+lMB3fcAPX0MWgA0TUD7G';
    b +=
        'TQOQFMFtI9B4wE0RUDdDJoAoIKAugLFi1FFi1HFi1HFi1HFi1HFi1HFi1HFi1HFi1FFi1FFi1FF';
    b +=
        'i1HxYlS8GBUvRsWLUfFiVLwYFS9GxYtR8WJU4WJUuBjV8Itx9uUsxnmXsxgXXs5ivOlyFuPiy1m';
    b +=
        'Mtw23vvQF+ooutWHlwWUsPE4VR1iCsyuX4LzKJbiwcgneVLkEF1cuwduiFVeUVfL2aMGFa/D+aL';
    b +=
        '2FS/C+aLmFK/DuaLWFC/DOaHGH6+92UHTxEJt/0OHKAuWfNHfKoX4QQWAbm93Jp94hzMAvHD5An';
    b +=
        'zl8rJTHb+sRZB3+2MTvjEQosrnoYfzxk0U+F23Cn2yyKMtF2/CnkCwqcNEu/GlJFrVw0W78aU0W';
    b +=
        'tXJRF/5MSRZN4SIUU8hQibKAy/ZR2Yxk2Qwu209lbcmyNi47QGXXJMuuwacGgDn8emXEZGZggda';
    b +=
        '0HX2UGJ2QBVNj+9NY1Q5FiOATyvywzNfKfC7LhmVZrSzLZYWwrKCVFbisJSxr0cpauKw1LGvVyl';
    b +=
        'q5bEpYNkUrm8JlQVgWaGUBl80Iy2ZoZTO4rC0sa9PKEKt4qMJ468R610C9znbCKWB6NvElYRm/b';
    b +=
        'zUPv9kFkHnMnAkqGHQqg36T83G1IodWld9EH4icj4sX2bSqfPHGkodFi5lXq8pPkskKZbcxx1ZV';
    b +=
        'OEUh7qHsdubbqgqn0bbHsjuZe6sqDJBRD2V3Cw9X1YANtJTFwvuEk6tqwG5bymHh/cLPVTXO0kN';
    b +=
        '5KHy7cHVlDaTU7OEZejbKk5ChaduMiYpHoRFD25VlbszQbmWZFzO0V1nmxwztV5alYoZOVZalY4';
    b +=
        'ZOV5ZlYobOVJZlY4bOVpblYobOVZaBpdMmoARDhziNZSzikFBXLWPpm09S5FcWuYy4ahmLCPSkq';
    b +=
        'FBZ5DPaqmUsoi8lRa2VRWlGWrWMReRlpCioLOKPvtaQsPSZUSlqqywCzEnRNWNgR6MmOxojsKMx';
    b +=
        'AjsaI7CjMQI7GiOwozECOxojsKMxAjsaI7CjMUZ2NJgdHXyIA3b1TyYpS+xqTz6Byo+v2KOfXiE';
    b +=
        'gV3STXiEgr3w3EMigLU71fggZssUn3gsh3aFLeyqE4AsD8hYCf2jFDzN4rOyFGXSvT4WZIarmSp';
    b +=
        'cuVpMMHr+mwkwflfjSG5VIZpAynrSB3pxoEvS2gtwHD2HdsDc8APXDDoaoa+kATwNT7G7PHwwy0';
    b +=
        'Xmy5CecD+0K50P+iJCd9D6kbwgBMOl+yJ87siv8D/njSXaFAyJ9jAmgCSdE/nqTKe59sOeY9ApA';
    b +=
        'aon5vq6SQ99As9EHxwx98H2E9dkluwsdadBraJS59Fs15oLe39VzQZ/lGnMxasyleh74AgIO3oI';
    b +=
        '9zUSnUHzoTW8D4EdkwrcBPJhYkFpyy/596JjkoGdRF8+6x2ZvO3S0MUO/fJe9RcnZ3uGPWyEY+7';
    b +=
        'WA6/0QCe5oBK2FhB6rJkGtmkhQNQmqahAU37kwyQu9wN7z/MFZdsbOiDO9Gb5V4LGHfAPhzEZnK';
    b +=
        'vruXRexQOAxpjwE4osEmSBPDnVm+DoB+WaRrxUhRSEOCWn8lTCs4oQ+cznG4YkIh32IQ3esOOxT';
    b +=
        'NXDYW5ORelQtHHbXxOGQWWtRmITDPlVqZncy/jCbNuNSnjBm4oTTiFb+vBh7SnviDm+Gryx46C6';
    b +=
        'HaGdPZg9JEq4nwv84/t5hFzMtvr+R4y9PMdnEm1Vj3hbyX00R55LXfoj1oyHWxV9yAmNdXPVxha';
    b +=
        'jLwXq/WQPrfWYtrPfWXL49Zi2sd9fCOpmg5KjdCnNmrIuTYpb99EoTscI2RDq7vprxWwpNMdL5L';
    b +=
        'YUWcio0Q4dhT95jaOSPWTOlxkXIx5cTiM/x/Y68uN2a4Rsgudi3FAmF9EFi+DoxaOngKxQFcbo1';
    b +=
        '45csIr9ek99EiOkl7yM47Nod0Usc8nFRmZdDrwGjBr0Wb6xBrtm1qBXUIlahilY0sLtLkwDHyNg';
    b +=
        'tNE6Xcbs/fKGGcDuZihz2FM+zXHDEKTVy4Db5jZs8fztbw3cpg1jOMZZzEc3PJ2guwsdA4vvCNu';
    b +=
        'IrmmW/YuQXk1+KGAecVeDVaumvjQj58M2KmHxHVQ3y9Zk6+eT9Aif0vB7P5BN3c6j+gE49m93Mc';
    b +=
        '+Q9a4ZvQzTKmxvo/NvMBY74Ek8Wt2iTX3dxIyTKGzFJJKIXfB4xlmGMZQBFKHwBdVlypzbLoTe1';
    b +=
        'LrYH6T0Bnxy4zfA9gXGx06/JrxI0R6iTlw2SqMP3EQpAIkbdCbMG6hYj5mzBnLz74ITe5k3sKE6';
    b +=
        'UD8fNYtEtjWf3Xf4sHW/ME2LM4AtdDn/GW8MJLBXARD7cwTKEZFyqGUAG4/986PCuY2OIvLp9oY';
    b +=
        'T4xDcnsIE+8fkIG+ITn8TGbERGkyBDfOIjZDSw5zeJH949cFShvLoYyqvxIq8iXnMFYzz3ZqIdz';
    b +=
        'h0n6vJEm9hjmoXXxdB/O62vNBOp4Qsfidd6PvKZpvd4cZ4NMr2Fydnl2MXbJTKxUzULxW6PNK3z';
    b +=
        'ribPmBsdHho9FUdgAccYqibiY54KGZmwV8CxhhtvW1LTSLFXd0GQIp79DrugE727ZHQ+u5Fz31C';
    b +=
        '1VfDqa77diny7VejbTdSmT7clA7Ir9O1W+EA19O22E77d9P6Ig6u8aJd9+oQbdhb6dic7DGz07b';
    b +=
        'bFt9smzqa2XY/RhzN9/HCm+HbTBwLr9lfd/qrbX3X7q25/1e2vuv1Vt7/q9lfd/qrbX3X769Vsf';
    b +=
        'yVDaL0M9pcWQqtuf9Xtr7r9Vbe/6vZX3f6q2191+6tuf9Xtr7r9Vbe/6vaXZn8de7ntr2Mvxf76';
    b +=
        'fyerhr0K7a9ec2MpO8NQi6v/g9re9pKyOYMBgEpWeeYKmJm11F5cNopW1sJ34dWu8uEvPctvDTU';
    b +=
        'GRtnuLDqBheAuvLV6Z9nEgEbW9qIPtbMrcmYZoxxdgp3G276RZueQh27QuCcAWhUWkackRkFi/1';
    b +=
        'AEo3tlWOIPW5IdpgSTRaAxbD5FxB70rQAhWTMDA20rX3r3Z43CrzpGJvBxYoE/0qigA+lO4cRgT';
    b +=
        'qsCoBHht/BUSS3NYXCnq1cCnQ1CQ2cZX0/mmE9mZ9FCeluQRXL425fm7Ai3q3JmjFs7o+MSEKhh';
    b +=
        '046xaS9eYhQLQAkYtx0jFYHRFJZ0f/Zr11Xglp2dw5IK9A5fmB2+cDgkKw3J70Ukj4ryGuO9LKy';
    b +=
        '7I6G8AChXgGE7yGKsHLNwzC9aIYMDglfZuIKZFuULwNhlRYQIVOGHZtFFnscsrUIgbjGFkSU6ix';
    b +=
        '506cIM7PJeXNseJLDUpkmlluUwMABUs2n8uPjhdsU008KH2aVhBhm1mN7+bcO/lZM3lhx7LzTbT';
    b +=
        'XG7kBXTT5cKS7q79/3E3QOinHGzd3nOpE5hQJkEnm1kmZCJkU6Awh9+4NfMPYxXWNZ7YW6I1qdK';
    b +=
        'DtweX/RTnYhElCMO4KtsZYiUJg08cPBVEHyRWK2YXHQB/07WpIhp0Eq7MaIoSXHCn4XIftqfhAQ';
    b +=
        'SWgTbmdk1UtgxKeyIFPjK1PNICjtBClNI4Qsp0kgDEsEWUQGyDuHfxzdE0styVoR9ZqkU3ijFmE';
    b +=
        'fch5jHiG0bG5RnmBlpkXUz6NOOt0E0WPSOYpBCerz7G59+2g/pAZTfWEqV9yyjoStpiRxSkhcFQ';
    b +=
        'kr843v+5PsqbJYqP7aMGI5GmtLr/XtKp5ct9EoJvWyhlwUrM0ghyZxMMcWDtmjmKCeCVIJyQjU7';
    b +=
        'QTUAWDhc4W/AeBW5+o1qeqVjenkavdLlfV8Genkj0is1Ar1sXDSV9LLxRl4Netm16KUCeyOIygp';
    b +=
        'apDUq4mBkaXlEyr88+n8yIU1soAm1tCIq+lVUPPf1b//AjVt0cQs7apGtavFvn/idr+TiFv8Pt3';
    b +=
        'CiFoWqFs//6IW/aYhb/DfmlJZQEkf13vs73zR0XvGEV2zhFS/ilVYgL/KKnwkFksYrdi1e8Sp5x';
    b +=
        'dV5JV3NK93miLzSkOCVXuSVhtF5ZXhOUSNySi1usX1lGlbE9l5G4xHhISfiIZ2uTgUPZSt46NJz';
    b +=
        'z6va9HVq0/fxT/1kmk5eauBGDVqqGvz4B89dNOIWj3ILL2rRWtXiE6e+/NvaoHZzCz9qMaWqxYX';
    b +=
        'vf+Z3NDZ9F7dIRS2Cqhb7T3y4Nxu3eCe3SEctZlS1+Po3//Q72nJ7hFtkohZtVS0++pMvfjIdt9';
    b +=
        'jFLbJRi2uqWrz39KVT2uLZyS1yUYvZVcvo72x9ETVULKKGaBHNk0WUH/Miauis3hVrLR3FSyetL';
    b +=
        'R1PaWq4WZ6My8dkLcUrn8HlM5n7M3H5pCIthYNhdRZz0F8KVkwax+njG9YEthBUhNnAkvFpj8+x';
    b +=
        'qkK1aC1hSBHIpf8ve28DZNdxnQe++/feffP+7gwGwAADEv0uR9JQBCXYIgYURZG8KPEvlIrcLVa';
    b +=
        'KpVKlVLWuWu2A69UMaIYVD4CRBMlYG7ZHWqwNx7A1iZAAsYFobMM2HDPxKIa90AaJRjEUw2t4Pe';
    b +=
        'uFLMiCs1NryIFlWNzznXP63r5vfjCkaFvxgkO8e/rn9u0+fbr7dPf5Yfs5XVk30iqNtAZGF3ZU+';
    b +=
        'EejivZre7sd0zjT7eca8SgN9rDljm4coP4HqQWxaWN3BEV9cCZTojvWf6DMRQr7mJ2/9IXKkzRF';
    b +=
        'EIsX0b5hGMwkc1ghhilFIBP1B23KZJ4QtmVbA6Zg2bCU8agD6oYqjHc7YAgnsbBEMvcnPHLXqAQ';
    b +=
        '1NMS8EDJnDDQhFGMCINw0Kw38AQMOSxsu7+Za0c117uYmTjhHKh0g1H3Xd989NuzHBwPs0+aCvW';
    b +=
        'mMfZrx7q98uFXJFgm/sHlXGccSqvvOGQ9rA/aKOrpph/gcegmK9zvp+6mfdEQL3ePwVgn4SV19h';
    b +=
        'uAkL09BRDVPQqaKmD7amXw+fhxbXFFqp1SJavkNtdjvF+UgUzdwLf9KJT29JJIXJNR4vuVZ0799';
    b +=
        'pvEC1Z0IqM9adtOcGLGc2/TxGUMuDTqVNnfzUR427LLH7/aV7fuuWZytVJML3i9l4dyAvThM7fH';
    b +=
        '+mzM95akfCLHOZPFGMYzmJU6ZtymlTy/ZT/fJx/v2eJ86xB/c8+jhno/0Wk22b+slWyEM23AsJz';
    b +=
        'P6vJ4GL/U02Hl3/W1u/J1piHoMKfeexNAHmPIX/ILChZox5EKhapp6K3mLRstkTZuycZS1HrLGR';
    b +=
        'zzeq71Rspb6RCuVSpOg4shErxNBK1eyT6r5+jpa3n79Hd2Lmjfc0bgKreSdjJDt5Ip8RiZIL+lQ';
    b +=
        '5Stc+YpMVUISFa18xZ2qKqh5padPK9YWebk/K7fpzwoqXCkPseVFuZVZGwFuecubxOj4bmlSUZn';
    b +=
        '/XzdJO7eW1J2CbYevPvBWw4oMvBLt9gw8FzFeqTnOV7VJlfUOvBKGmC8jXPDgyp6zlXucOehXaP';
    b +=
        'skFeNDrtDpsNjpMGZKmJMskB30MgHfUb/ZbYCUF7zuXqPZI6nLLVQ3EFdO3RAf0K54TpaGMCfOY';
    b +=
        'DXifPPbersS39iEIhfst6uocFjrrKlc3xCn6OBN7lGCnHwvrEW+t63TGyThatLRulXZSUe5itK1';
    b +=
        'eRVNdY2uZW69VL1qfqvzBvt27SLtHdTr6ljb0mved19TKw5zwEOX9tiWjudzXnL9nAE2hRXdDOm';
    b +=
        '2yHJ61Wzpn35BOQY+jkqGaCMF0bCRSuPfbPVrsjObCXlnhg1ZoNyhbtb5tMpuyYJxPj/sBnZLJu';
    b +=
        '3hPTJn3MnHncvz0WZdOJMg6fB5BfZWXEEEOA67s0oeyZbIkFTnzxdbPQkFHA9cgWVMozyR9zF5Y';
    b +=
        'l7CklfCikTU8iQpTr4pXLRsDW0pS56zNwx4rgkKdtu9M5VjTd5pcifWNbuE+p7nNZ4vTuumTxdy';
    b +=
        'nAr6jD7Jacd6n6mz3yeHwhq7+WK4j6kBV+d8TO7cjq5ZnFuxBhe+f7eVgVO3ikxd5TLptQVu8Kx';
    b +=
        'f7AGLjyzYj9TlM3W7sEMsq6eo3ttl+7ZgylGI7HNumBlRXk/TFnqa5ry7/pZp05j8poNSE/MYWR';
    b +=
        'UDFqa0hLBinzPl5X2O7Ovrc8n5pvV5b3FuxdaPmZWLfEM9XGDi9fVwb0PecA8vcs8Vm18bIz1bk';
    b +=
        'U+VD5aI7+lhzAOHF67nK1Kfs2qU+7ZixR10atd+rdymX3sZvJWLciuzNi7W2msIHr5rmrR4p0k8';
    b +=
        '20byohBklQ9EyluOYptRNxHgyGlk7DRSSblUwTDfDL0ZbQ158bXlha+zpVUZes5qPY2Q8xFd4te';
    b +=
        'Ye9baNtq3lRp65h6XILxS05yvhsu3nOtuX0PMF3dx4w4uNFrOhUY5pYarUeqb34m3K9FF2+voTV';
    b +=
        '/PFIUl9G5TYeFxb19bcTnY9Zbvp7y8Xy+s1a9ar3J9vO+8b2u8VHDd+JJv9a1yvThPXbF7167eG';
    b +=
        '+rf27TY7txfT+faljJFf5c1teIwDjwveSz9zLS88w0wvDXhBJO63VjNeD37p5kQ+6df2uoPHqxi';
    b +=
        '/7TwGW9vGtIGyvBGKMxmeJeSHYTQ4NQE1YF2jvdXWDLtpckUl6RFpgM4u5FMAWeqcqaIRb8wr33';
    b +=
        'swk/80T+iXezHL1RpTxuO+qdnvLQPl3qj/ikC6yxHEGTbX4Lk1RkTnDHRGVM9s5+Nbos5zM0n09';
    b +=
        'o+s5mvgZsTpraPZTeHOFbCuBX0Xkpr8EYxMZl5+/iC0HuZdoRVekzSpxsQW2tkhrEU4lPRmT2v/';
    b +=
        'erXf2bjlHxov5rZ5KJQBu37tv/AZOqbvjOUnepDbTjARsDN0B60CxfhsBBu6mdMbmM83OWfmPHw';
    b +=
        'mKXHUN4Oqv+3Oceh/VyGNG2LhfTjqb93DCgiimgIznIMEnXspd0iRU6cyQ2GT8GxDYWtyXBYRod';
    b +=
        'A4NBJvjedZX2NXf7xGa87TGXG7DXAbJk6Se9xwRPjbhdEQH6A5nIXOPVkZG9xugAuUjY7XeC/7i';
    b +=
        '6I8J11dkGdu2CzdAHjfHPeBdukRxT/2yyQm4gfNpuLXtiy7l449Wb1wi7/2B30v270n3jz0H/0D';
    b +=
        'vpfN/pnGf0RzSGMcr8HwUOPAKuYR5f1xZDg/hFQPWXIUe5blI9hOtIlJPm8T//jK2P+kRlxP4b4';
    b +=
        'Mf8wh7zkK0ilpHE+coQUyKz/Ita76RGcZ/rJL7MTXxghJ6ZcQ9dZcILhxRF1Q1Zy3zvzFt7tOM5';
    b +=
        '5r1d6Ymb+tALxHd/GROi/KEuk/+6v/CRhKIA0eLF6QwCG1kPrkXjcQnEONXMoyaHBHBrKoW05ZB';
    b +=
        'SC7FcKRyG8XSDKgpjL4v7xLlEcvq/ieRX1kQzBvSbfLbwIBjaATrNvGk+k8bD1bige+dgpW2T6W';
    b +=
        'GvaTYvXSGP/fOBRaBsAZ9PDZd/JUkmRFPezfg7wySzjsyI94QOp7AxXnMAZjgiz+U9TX6NxMwCa';
    b +=
        '2cPdPiWKbpwFNAd4tB3Z3q2xMNVBfKA2wU5Ygpe7A1SjvnFAbdx9s1g/DaeYWJVheNYGi0IMCuF';
    b +=
        'iAOCk6X/Z1CbSeha9TJMMS0zBQd044Tet7+22UK8nux1mi+ZErOZvqosJl48S3idMC9oaeycm08';
    b +=
        'Fs+0R3Iw+B6ZEXx7nzN5U6X91jS13HWcVOKaAOCmgRBWx8Im0Nu06zkzw7a4SNmw3GyRDfLgM70';
    b +=
        'bYZEkJ/fdwkRYY1CKJJf4OEeJ5xnMHZMJD6ZBDEJmVnleRu45kOC83lYzEUyiLO9rC31iN7tFvL';
    b +=
        'Qr5LwYx2mGcTop4fJBqmEiyp+OhsIIkpxieKAbl4L2WPoIZCImjDy2nf3pxp/9sgjIM06CaIUJk';
    b +=
        'wUlolJiZpBJQIY2AtwqibAUsYfSAM2kOY/ifSeokw2nn2Dg3x9rjpmHqJMNbOUCKMNo9LqMytkz';
    b +=
        'Bqr5MwWisRBq8qM7zWEHDUAscscNwCsxY4YYFTFjjNAO2RsGn6zDb/LlHbgtkMf0TdPhuPL2jou';
    b +=
        '1zZMHlF5Q/gMypMPmvdigYSkTuIC/hPsi+yPAwKk1dDx+0kBNgq2fy35yvjmjPMvTfKGyICt8QS';
    b +=
        'EFKeCFEhPq8CfJ8GReSK1Zh2qsHa+E41JE1+WZGc3sCb8smKyhmcBQo0CkipIgerJ3OmCg2u+Y9';
    b +=
        '9oeK2Yd6K6XGvqks8dq2J/eriX0m7p512V8SDeRpm//bEvx+CY2V2SSiuvAU4aoEZCxyxwGELHL';
    b +=
        'LAtAVueQrctMANCyxZ4LoFrlngqgUWLXDFApctcMkCCxa4aAHxtG7C3A375Mr/pdHwGLWaRnYoR';
    b +=
        '1MY1TS/AFNwKEi4mgZmIzvIQlbVyoaeYFlRSM7eLj/kJlRYGkTQkHaXKRt00bBkFQj4eonJNHp6';
    b +=
        'VIinQrWdXqG/pZQKG5CxVZCQDC4mfI4oeW+1g4GvDlehaklbLD6ZvMJvBqV3+Ya3XNmckH0n/na';
    b +=
        'lcR34FDMfqbBR4xejdIH1TP1VkSoDW9qCV5eP0MWeOukb/nKk8qeddLcsGNXhr5bdS+e/SNdutr';
    b +=
        'HJJ3yWvikQHWezr82Xxrq4lEYR1NPT7ES3PNeJF+Sq+vVyk2hV2QvVkVF/KQSKRv3F6r4JE+yzP';
    b +=
        'k5H/RuacLW6z4SSdFWTbmrStSLpmibd0qTrRdJ1TZqOJGmpSFrSpEOadKNIuqFJhzXpZpF0U5OO';
    b +=
        'aNKtIumWJs1o0nQtT5quSdJRTTpUJB3SpGOadLhIOqxJxzXpSJF0RJPmtcnTRTWmtRrnNelQkXR';
    b +=
        'Iky5o0uEi6bAmXdSkI0XSEU1a0KSZImlGky5p0tEi6agmXdakY0XSMU26oknHi6TjmrSoSbNF0q';
    b +=
        'wmXdWkE0XSCU26pkmniqRTmnRdk04XSafBUcXCUTGx8w0BGMhIyZ6d1XL+aJ/lByURmWmXicxVz';
    b +=
        'Rzlmav7LMu47pJpR8QzvL3GcAYojSGZtaOeUe3OHpFMOovLol/h8xIgu9qtcX9UcdRMXVYVVZSF';
    b +=
        'arfJHV8Fy0y0Ue22mXyq3Q5TWBUKHKP+q1Vszkb9c1X2j1mRcStInasKeaaDQsHpRiHydJOMg3S';
    b +=
        'zDJV0SEZTukUGXLpVxmQ6LMM23SYjO73L6PBPN7jrJm3+7hYviNlrr/3ll35w4gxtYijfWWJOhs';
    b +=
        '9METP68185QJF3n5li54lTcGe5AUdC20/i9EYnGLz9pR/G23cRA81vGs69/WQ6gNwbJDNPOdvgn';
    b +=
        '3n4DL307dc+/01vgjJvt5n7kXlAMvMkNEx7JskMuy4HS5kTZO6XzDwtbYUWDWee/We/+WvVUuYO';
    b +=
        'MieSmSeqLcR0S2YYhymX3EbmjmTmqWsIbpU486Gf/IPPlUtuIXNbMvNkthn+mTgzLMyEpcxNZG5';
    b +=
        'JZp7eNkFljzP/ypf+8+Vy5j5kbkpmnvBg1UUyw0xNUMpcR+Y+ycxTIMysSOY/+dyhhTKe+VSvLp';
    b +=
        'l5UhSXtBQZSOSRmp5LBPkKtlXPJDA8YYwuSn5eHD+DjXUXZB0pPYs0j6Lk723VwHQpC+ujLY/La';
    b +=
        'FuAXY2+EmhyzvcEyvVHPVy/bD00VjUycU1DM1NtnEVWwFPXMGXgisrOHH375BinhlmpPs7yKchY';
    b +=
        '54x102cz1vOM0LvtLbFWlFjbJ861AnCKQ8Vxj9URdWqEOq9So6hUI2RcpUZRqUZFictqVJodA3b';
    b +=
        'OzTOi+N3uWm/dSXcf9pph4eRbwQqbdbFeurl78pCvpjzOG79z0MOeMNmbNsSSB7X+m96z4WPE4U';
    b +=
        'xlcRYnP1fLBvkxniXy3Jv9w4lsPza9FY0iJMHhIE3HzwybygdaYvWAk7phdu6rv40zisfZeEe4F';
    b +=
        'xYTWD0STOm0/3SrsjXbTiDMTzwDRckwAzMcv/zfp5W92EkbHGTszR4Zb6Q4DMjOf+23eauRVkKc';
    b +=
        'qlaT2dpLbEPBC7gByYk4JSaSChYVXNp4P0swpRs/DVoVa36kkg1yMWBYfaaVu17Owglqp5T+5DA';
    b +=
        'ShrvoM4++YCosKAIFxG4Fd5Rey2/gszQIqi8lv1qzLZ1IqbEBVeTbtY+UK0zRDbmAlWrSBv1Z2B';
    b +=
        'Dci3POpydS+prHLDcBKOB4LeWPehCBzM5f4+JTQtyzYCnB1u99dhj6QYhLvhR3q/TSv/N93ApI1';
    b +=
        'zzL26cwmY4xDyT/BJes02yoAsEv+mJiI3iZCCt4KXuVGkCkT51zVpqC03PjvZRCIxvLeUw7LE5D';
    b +=
        'Z08yRTe4ytUxeJDEg+3uycMb4xdw7mrC8eR3q7jJ/XKcBkQL9OEsETpRIvpB2qc8M6xUo6rXB/G';
    b +=
        'bVwbnGVTVystUrWACO8PQIuUDLZokicK0C4Dq2go9QGMjZhqkUQLkhnydLpEgFJzSPJ0K9tFE9E';
    b +=
        'feDY0CzxHjOcfy063IYjliLOd95cFIi9eD4Fp2UZK71eWIpq42NWA6YJse2cF9PAZwQhe8lNI++';
    b +=
        '6vaFiiVCv1WpFwiWahtmMoYe5v1x9zuyg6Y4B9OsP4oZJ2Cl6g7aO7+ckyDoUZfynCivZ1IF5SM';
    b +=
        'Ql6aAPaA6dJXA/2qV/6qZ7/qOV+1jaNv+/rtQLAUMBqZNwxeYty7SKuwfih6ekWcOeSJsVeh+oE';
    b +=
        '8ay55UkWYPGuNLiwtMXlWLHnW5EE1jhtcrKj+4vNq+kXwUu2h9RpovdZD67WC1pcVBsMxKw6Alt';
    b +=
        'fotZnkDu+naQK+UARhmqahszGV0zsh01wd0jO5GZkG3ogx01L1640cZz7PFYQupVcqH0l8Rms/3';
    b +=
        'BVIz22pokQgviCiztYMQPjaMA/vcWP1YsXD1OJL5+pLcQPVibvN7BIyEhwSw3RJPjaechGX8cHL';
    b +=
        'eUu5354ZHmMF+seyBUmgyl4hSGRXko/FJobRhgqVzcMSM8mSLeJxQ/389GQLRE2Z/3mMmT85GZv';
    b +=
        'mk4BST0aOlpz6HwgPwsM21Y3YkmeirNKgKZqLK8qETV1MTbwumz7IRUl9VFLfY9V6lo+SOmFy6/';
    b +=
        'n6E9Tj9qvdev5+IGr5pv6BUNtWfwbS7nnjILLTIKYSabT8Sc+nnb3Z/0AYBClVhCoqeyHUgyM56';
    b +=
        'WFiQJ4eTlvoiTaxxh3pOyGhbqDldCPN3fW5bmw8mMr0pAiPCAajtIaeAjkS9xqzvAzt/KAvsTcN';
    b +=
        'xsTxaobRFtryI1u+b8vHsAmoLPZsThPX3vFx5L8OPE9PT4MWuJbTMaPmXh+q/23cQFyV4G52jpr';
    b +=
        'QI7uGmjRRp0WuE6ArXHtAyG/aBLGcFNMspipqQ4hRmmLFeabFOG09QWsEPUwd/mmB4y/FyeUqH6';
    b +=
        'pihUQMrZBxY9lk5K8yBfkrTUE+piAfuvuxqPA3cWshD0xBTKkgC6w5sboehnfcPuBIeiRSfPLMp';
    b +=
        'P3TrfDFaLQXHD83tMbnijy90sf3gh6o0eN7WedYie9JHfp8fvuEWBCDTbDMe7IVWfYpUgxgkRNz';
    b +=
        'Ks18qdHpXyZ9boa/2qRPbPXLOu+HRDJd9kXPlNiMZDSYnLbsfAepxYpQVUWoijg8XaWECGUmw3s';
    b +=
        'ooRjKsqTY+UjfLU9JVRnajGVmAR1E24LyivSNJzdCWEe7mFeU58fzyyuKyU9rGUCQjRoKQgoVjT';
    b +=
        'AR/kXfyRG+CfRUE3ri5acmHVFjerLfoWnxBur72vax246aC+g41IXRisB5DZx3Uy4jcFEDF91si';
    b +=
        'whc0sAlN9s1BK5o4IqbbQmBqxq46ma7icB1DVx3s03/MQVuaOCGm+0wUm5pAM882yE3ZQYBxCBw';
    b +=
        'xA0cQ+CIBo66gVkEjmrguBs4hcBxDZxwA3MInNDAaTdwDoHTGjjrBuYROKuBV93ABQRe1cACAuc';
    b +=
        '1cN5NuYzARQ1cdLMtInBJA5fcbNcQuKKBK262JQSuauCqm+0mAtc1cN3NNv01IF4DN9xsh5FySw';
    b +=
        'O3/tjJNoOUQ1/TznKzHUPgiKYccbPNInBUA0fdbKcQOK6B4262OQROaOCEm+0cAqc1cNrNNo/AW';
    b +=
        'Q2cdbO96qasvvCVFtZ8sU6x1vDq6SysvDaOQwh8r4qh4lLYXVh9W75l5LqcCQsrb1dWXFjBQwQu';
    b +=
        'O/mBVuU7nUmJtaNt8gh9vfHDW/yqqDPO+nvT6kjF2rlQIw47IapMO7dxVp7selY5sap6h4VdmZJ';
    b +=
        'SoS8aivZGqmxahhNmvFx1sdcqiyqLxqYG+61itEaEm+u7reVVtfTard3G+kRhYabmWpCIHesTVJ';
    b +=
        '7VZqitWhXn3TrXa79Upc4GYmtWKLq2zPoEZM06vTZwPJWvrpVqGDvGQrhSlbXrVJsqNer26LlNE';
    b +=
        '3OVs/W2r7dZaknou69pbsXW37yVi6xJoTWrVAPnBt/9ZCiiDlYTtfjA/HfUrPk32Kz5N6VZaxYp';
    b +=
        'FCQk/UYmjr/dpi23IaVGazrgxaGCKbO082lM0uvrR0iieKKRYhv9nGwIwrzBF9Zq8Opf/84aXZF';
    b +=
        'GysICPTna9C6bYkpDSWu89vRSrtt3NLWUi3Ir853Mmv/VNwlH7bluPxtVYQVMbebjqtaUVqSJhQ';
    b +=
        'KmNjJ2Gmmk350KugZ23oy2VhwFzFhcTr2OlqogG6tcFqNelpeUt5Ovfxp1V83XM9fkX628adPon';
    b +=
        'YZ8FzSExgBUBiuqQhi5E7Wwj5HWrbI6f/XmD6RVSlRdxDfKZUGueNbHjebXN/l3y17E0Baq2zbR';
    b +=
        'CHtDwB1QZzz76EQa7U3rvEmpGgI7qc0QOBkaRYYmwMzrDkIg8aXugMT26V1pyLZWIzYrmray4Fm';
    b +=
        '+kZqa6CYqvFyXK23e2/G5GbZUdRNDSLkfkf1uZLxSZHOy53W1UixSyCaxeA0m0irfZq34TQgXy0';
    b +=
        'Um5Cer/BLqyNV3ax5TDPQTOlKKx7tSWwpsGVHNWzgDbrmR8UqRVPPy61rzmlg0j52ae1zzjhUAw';
    b +=
        'OlWT82r7AnCePYlqOx4E2mLxg/Uk5BzIIOGUDDRreHIciCrSmtgJsfLE9Ma+ioRg+M1+A7o175q';
    b +=
        'sLnbNFLB9QaqO+kEYjfQdAOJGxh0A0NuYJsN6HJVFW8U/dKkmFEglcjzsbC/SJhbfOWNLTXPbZA';
    b +=
        'lvma5QU23QU23QU23QU23QU23QU23Qc3VG6Qk2XqcRk38eKuSV2WNZslwyqovpRvhjqENu8zDfA';
    b +=
        'HQ3UaPcLJ7l9mY3f396abMM/TvmeHu3URIt6TDtxPoT3Q3CwkbpqnukEFXZ8HT3S4PUEAp1aUNE';
    b +=
        '+Z1eiQQ+w+TGd+0R/0hojF6bMO1w6ifUP3oMUjYvbu7lcY/BgqmrJjgVgBEJ6ztC5GGiOWz+ifO';
    b +=
        '7E9HVFnNNxSc2p++hcLpPSfTDfRCa98ElO4ApC1K38vH9VUT7zMbaOzuY5DmQKRA7ihBvPGhoEe';
    b +=
        'zNQe8fV3oC9BE1GJNu25s7sHn7jEjqsP2ySmuw0mKessnT+I0xXuZHWtsf8mMsEAYtXMrhsBWTP';
    b +=
        'Bt08K5cRuHwDE9+JakzdakoahNYMfcRTjaDcGtutlGv8McRG89zqIUbE8dFGfSx935h4d+XzGT8';
    b +=
        'cxRg0vKUmS8UqSdOfpWnvOMENiQ0NaK39NZQ2lsSF7oo+HVHmXibePYfyD5b7cSzJGxRDY5klo3';
    b +=
        '2NO47uM6Plf4WGOlxjVWalzj9o3bLnXdLI1r3L5xm+WFLQhtMXczi7mRxsjdLxJRYjBBskgcVoR';
    b +=
        'EMB2EPDxCap7H1r15xiAYE39i4h7K7itTdl+JsjsYCkTZyT4GaF7vI/pNTIvIubXPdGiK3scgPC';
    b +=
        '1N7BUdJcQ7lN1RylYxmyoe1XVRdtxD2f2g7H5xz2Pb1GBJKPiiqqFzwQcx7WJFn/DF60raeJyd4';
    b +=
        'dyD/sbqEWYHJrpNG0PI2P4DomUn2gvEPbHSVJ8K1xEMuZ8zVLk+2ASfSu95hA9PcX4LGy2SvcPZ';
    b +=
        '+4rsHZgOvwcyf/oG4O49KFF62EcPN7mHw9KXfee7XD3+uO98XIpq2HFKjTD3nATPhKvBtDZJCG8';
    b +=
        '4C3+zzLL4YheBS5+QcemLziXrQ5Xj41XiidSXlVOm9maZfVEMax2aKLNZetcl/Kq+a/uSdY5Z3Z';
    b +=
        'f7uCHekIrurNnB7H6BOgciekSNRPJnFHV108RSCZE2m8adVCCWSJ9VtnxpCxsgqvHQQ0IjtF/gf';
    b +=
        'bGUYaAazEw1xHnUx0/FP5hXNKvkVQ0s5eWqsToNQNLP1MeZbNj1QEFqPAeVcoRrU5dWO9BqN7oe';
    b +=
        'MFmx/Z/ypbVgn++nx6X+7cyA1Z7f4g8Jqz1fVYWyPZXdwUcgqR2NJ+dwervER/cIfjFS4IIFfoH';
    b +=
        'lST3JSW/6R8ESLM3MV3iWmyHc40CJmy9v/G9442Yg4ujiDhObAx+uh/mweN6JO8x+qnz18chxqN';
    b +=
        '6SCOZ7KrvvPZGfrQbJlyNJw+0GZP5hdyV6id2IwH0qymDtykgLjMFB1PIAHKPYT7HvqDEqizUe0';
    b +=
        '6plcW7/x61mhTcwPdANno4YHBAsAOwTPLD9lIVovLtBqYRf4yOwa5Xx5Gogb0h0cj0QfCsyf9aX';
    b +=
        'ojX1VphnpsjkN0TGncabuEe5HIzzFVU6iPuhUASE+u4leOvuYCGQ/kg3Gk2hyLko1wzE535OFFi';
    b +=
        'CtCaeXfKtLmdKTrOc/vdRjwUfaEH+sQUrV0v3PtvCJfqpf/HbqPeo/2Gx1PJQRZxzpWE3oBmxJv';
    b +=
        'NAG5NDm93GuE35w7BEiP+Z5g1e53x2e+yrhUEUlnwjENtReucilfoQRDM/0GJx/xe6UV42vZ38C';
    b +=
        'Ws9sU6ikArYc4N5XnJtSH4zUvqEOvMifWUztrZbCxodEmOp6Zac/fGheJcmOSn58LzKlLv1pKq3';
    b +=
        'hOK6bSuaoaQ2zc1EW5Kv1LDaCwAVR96tD5utU+k2PqObku9vg09Ps9Vswz6dtRKmw7x8PUGGE9e';
    b +=
        'G6SQXGBXPd3mEPCd2iivj2QUardk1+uEM8nnDeZ7Cz/uTc4y2W4HoW9wMRC/jRtAVzaSgG4mpUx';
    b +=
        'M9AY+pT0yK+U9r3HmY5mGCm4wzHJxQK6x5KaCdqubUgXC9yRT4HTIFTtfG5rOtyuvHphx3Aqn7B';
    b +=
        'ZtbCZvDjE0+olgFowXxfNoZY8Q6GR5aQc/Q8oiVC8qDaqlnUN0M0tgZVI/tlTxKvu8T8oW9gxqY';
    b +=
        'ptmf8p9tgas8PHNeBtVjPYMqEl80am8Lrkm72rnJ/1rTuvMsDoBmcTTRs0o8kmkg+UakE8tpYsq';
    b +=
        'Qq5rNbINp4BYcdhMXSPurJ0sooSGafCFHiZyhneLp6tVIhKcFDf69/tkIuJn1dNoJTaWMoTmvjK';
    b +=
        'FznvIWgqEHxyWPYuhhWugEQ1S1J1psafZHFDcP9uBGZLQs44FpuGKZciatj2oN5vMa/EhNaVXOf';
    b +=
        'P+4mjeYItXCValT/yLUKYxvvD8XiS7XA2P+VV/AncDEoi9XHUFxt7NzzL/mcwNHeVr1bQN3SAOb';
    b +=
        'MKT6w9qw0Z6GBbnFMZ05vTKB8pLjr9EbS770Rm9fTPdQ6+Gg1BdGNTu1qiNS1TZs9/lPtGAh9to';
    b +=
        'PaZXNWn2hq6asj7GebNVyg/RD5Tl9G2jmAy146TkVcOFQxMYEHopvVpmfZ1njNCkijnFEnEfogj';
    b +=
        '8T6DoiY+JfcJ8hgiaSqLQY/Z6D0n5dV2OVqNO1M+5ZVdexpkYOQpPykjooS+qgDP8wm6fRT8t0d';
    b +=
        'ux3dElNVlxSI+sYxJMz5CW7VCZXC0YBxJcTsLISVK0vV5WAY5eAm2NEKALGaCq1JVTmxiHgc1Eg';
    b +=
        'bixRkLQglBbQNAgr4CG17dnWJhxvf0VbUFmpBdbWJY6biTMnOuNJDMXyJLZoZzO06atVsM+Osw/';
    b +=
        'N4yuAgfsNnVh0DvQcBpYnw2kbM19V10yspReN0SqXfe7TtEbdpyhbQOD8j9KC9fth5Xb5bhyx+d';
    b +=
        'CoQ3hL/XMu3Ztd+iEbxF7waJ64dpEnfrQoMsrO5m/x2pCddcqsZJdsKk2N+P/Sp9b3jRvONyrZ1';
    b +=
        'R91yzz0Y7bMaz7+v/FJm4pN0dEfW2crfsxFzNkfKxAzT0U6jQiz807iYpAdPazBP9noPXiQVSw6';
    b +=
        'kL72u/20/+JBxNouItV+H9shHO/yecKAmFDp724w4u2VL1TEqAKRmadmFfh6QgwrdHGBI6YV+Bh';
    b +=
        'BjCuwIXkxr9DFkZAYWOjilFRMLGCBVCML3bY4dweIU3UxswDHaGwMAc4Ku4MUeFXiN4rLc4CbCD';
    b +=
        'wr4GYC5wQcIvC0gFvEZzjArQSeEHAYVzoCbiPwuIB3iYtugHcTeFTA7dggf6hr8Hih28Xj+W6Kx';
    b +=
        '3O0z6TH+7sjeDzVfQse7+u+FY/Hum/D4+HuKB4Pdu/F44Hu2/HY2b0Pjx3dHXiMdu/HY6T7DjxM';
    b +=
        '9514bOvuxGOo+z14DHa/F4+k+y48mt0H8Ii7u1imvzvGO/jubjxmvO6DVHUYhXi39CqcwVsrLZ9';
    b +=
        'Vl2/E6b0i1lQpNRTrKA9xZEh/gD7rsYNrtdvhWbsdnrXb4Vm7HZ612+FZux2etdvhWbsdnrXb4V';
    b +=
        'm7HZ612/HusjkNIsnt5sFJc/ekuWvSbJs0w5Nm66TZMmmGJs3mSbNp0mycNIOTJpk0nUnTnjStS';
    b +=
        'dOcNI1J0zdpokkTT5rapKlOpjCQCSuZ+ybMmNk9aXZNmgcmzbsmzfdOmu+ZNDsnzTsnzTsmzf2T';
    b +=
        'ZsekuW/SvH3S3DtpRifN2ybNWyfNWybNyKS5Z9Kkk6Y7aYxb4iQ7/bvObBGbpb1WyUfH1YodHbS';
    b +=
        'V67JmmCcdwzHgI7Mj4EBFx5y9SYhyJOGN4vtYuYUdhHI8hs4t6qcmAhgxwo2x9/cbFI+jzhQDhX';
    b +=
        'hL2blulLqlmxDYLLVLhxDYwhqVVMN0K4LDZR1sOY9ALY96xOQj4qhG0B5/C0cc04jjntnMEcc1Y';
    b +=
        'paZeIqY1YgTHutMjwHgiFMeqzqPAeCI0x6rM48B4Ig52BBCxJxGnIVMKSLOasQ5VrGgiHMa8Sr0';
    b +=
        'QRHxKlujs5RezdV3Qc9Vgp43iv+Y5lq8zBiojfk3EGDsVMf8mwhsUkblFgKDzPlO4xC3wxoahwA';
    b +=
        '2GTwCsI/Bo3zKy3mP+6agFByzbIA/xg0YdDi6C8SWVSQ0sc8aCuDahRJ91NtnAkkIJSGWhGNFQi';
    b +=
        'wJTUk4XiQ0JSGRhNkiIZGEQUk4USQMSsKQJJwqEoYkYZsknC4StkmCkYS5IsFIwogknC0SRiRhV';
    b +=
        'BLOFQmjkrBDEl4tEnbgZpcnyzTmyJgiaU7MHsBhVc3E3H+cIsrEHu15cO0LFbkKrpoCa7HByx5m';
    b +=
        '7RGx6xBySqgpj8FkCTvDDXUMiTKzk+W8mOu2eTDoGr15LpTz3NQBW8pzsZwHg7rVm2ehnIfmgLT';
    b +=
        'dm+dSOQ8mjU5vnsvlPIdx2NKb50o5DyalwZ48wP+Sl9ZoODVyVH9Y5hCk3fBgEGj6xFwt76KKTD';
    b +=
        'hIvUlb0uzj03OzU6XOuC6ptzzaqf/I9MIfHsj7HPdxlDLtp33Zv/qFn/nZiFNE+7yBlEN+2sh+d';
    b +=
        '+6ffktSGvvklpZSDvtpM/utf/nFj0tNmvtE2YpSjvhpK/uduV/7N5LS4pQ2Dz8/bWd/evn3P/OP';
    b +=
        'OKW9Ty/1aQT6aSf7yV8+vijf6XBKwkPQT5Psf/niJ57nhETRVOXRnoYTOoXQ5mJCJ5DQ9E3oBBK';
    b +=
        'aBoGHBGwSeFjAFoFHBGwTOCNgh8CjAiYEHvN5oPtYZCgqntCpKzS1CZ3SiMAneP4ZZKsFv/mvf+';
    b +=
        '/zPJ64kgN8XF83AzxD2vmR/QX6uKmuE+O3QR0JzR/gI/3k4/RNWur4wikMxV/P7BRbK+Q8G0y9d';
    b +=
        '76lMXQAdwoBrNylA6ae/DR4jg0U8dy4KfIN8AYG5eo3ndekdLzoZ9ufMf1dn/P0ix5zmWMtbsMa';
    b +=
        'jc9v8BtiM3v+LXvTgE1mh+JkaGRcvtZUY9hNx2J2U6y6SJ4D2H5JnpDzNAuD2WFhMDtku7c1XHu';
    b +=
        'cHknr0FmjqXMkbbFJhTA3lx3yNWPtzP60k9tzbZ/E7NS21mqrYi67w7ESVnPZVddabYirwBDXhy';
    b +=
        '9Pdmvsp5hGibHCduswl10tWavtiLVaVMN0cmu1cOxrWmdMYs3TBrv8EyP4nR0xnbwVVPvcUG07b';
    b +=
        '1iyorHsEXhqFnTlyCuZCW73mAnu5FZs2eN02oGZYCK8kXHaPFBNjo90B9j6DSpjkpK1YAf/bC04';
    b +=
        'ZGvBwL9TTca0eK2uK759I71S1/5Q/NfXi//1WAu2+G8x/tuCf0Z4O8f/BukORf4GC/RbYMC0i05';
    b +=
        'I1t0Jp96kTtjlH7uD/NeL/BNvGvKP3kH+60F+CDvZQL7P9otDYvV60Nt5hHDK5ye9HdERxD9CBE';
    b +=
        '/pOb5Dx0g2EmjtOIwnLx+0igP2kkvsZoqP0F6EMML0APTCpr86r6aVQ2e5nBtQ93G0fsOmDe3KE';
    b +=
        'XNv8GGcvhIvxenXKvY8llZKjllyYm5yzE0nZnrDuLCPecxhjjnsFQe9bNI1URO91IT7K58fycKX';
    b +=
        'xbxy8mfsmGpgnCj3r2iTm3W6kbSy62c+O02JVZgmyOZGcCdWo+wvimlDWmnr0P5t8RLKTMw4mwd';
    b +=
        'RA8+TRF+w6/wy8UnE0UUvp2xNuaGmnRsT1F2NvWpYGVURs9b0naySPALCmgjth+FJGsZ5TDCeHR';
    b +=
        'lRsx18RuwN5x+ECVqxKC3f9PBNH9/09JveBMuM8MBc4ZtixviEv9Yje5RlGWigEG5C4k2a7OThB';
    b +=
        '4XJyfFEiCaqFLPFWo+DXI/bVsIWwQRFxcy8wWJYtB+kZu0tialvHAextdWvwvy3WFJiKsXbbpjN';
    b +=
        'KM+MyPOoPo/p87g+Z/V5Qp+n9Hkaz/m3QLzixzd5QwdhrbdPTDMdzFhTv0IMuzcBK0kVGA6eTBO';
    b +=
        '1lWECEfNp8fBqQoSjQxskMXHEwo7ybOqT7xwwfCHowlH4acmJR7dFJVTBEsoxekvKbkKSEyW3iB';
    b +=
        'wXoKkaFBK/LTG8nCe0i4R4tYTm5IpFNSEbpN9Gk/TTAZtKfiPNamqzmlRCFZLaedH09ZnaOJtJ7';
    b +=
        '0jxbbUD3A+z0KitaQ7nQs1t1IwIrN8M6Ifk2Ry26THVDtai+zW97aS3YNOrpTa9aNMAs9BoPKz9';
    b +=
        'N7Kl2rgGb0IyayHmLailQ54AG9l0nTAD3ldmxIa8l/yDx8UgSqWb4NZmIYSthSRLMBVUHzfR43y';
    b +=
        'xzqXrb2SqyX/HR0Achi1qmIJCRJC8TWzWUAFscKAoIXTfFhm7pn4vKAgvtB8JbY9iGRHBcUlouQ';
    b +=
        'nxaglEHsuLUuIQ69sNDObHW97WrMon0ditj/ovpLzvfT7lTe5zKe9o35/yJvWplHex76P+xUk0b';
    b +=
        'cNwEk3bNZxEp4N8Eo1jQhyubJLjl81yPDMkxzdb5Hhnqxz/DMvx0DY5PrpLjpfuluOn7XI8ZeT4';
    b +=
        'qiuHW+kqBpLRCLb6gqsz7qsL0fge2k1f+o3LP/mXG7EsNSDgtAeb8m/9x9/+xJWKxJ2jOGzuf/W';
    b +=
        'Hf+Jr/0Xj5igOhwTf/OF/fuIPNe4UxeHA4dWPTX9rL0ft+avXfmR6enr+0J9TltmIiCmkKQpPWr';
    b +=
        'qP4dmiKQzPNk1peNJkcwTPDi3tePbTlh3PAb7obJgNtLEnEjGDtNfHcyNtxPHcRLtwPDeP+dfxH';
    b +=
        'Brzr+G5Zcy/iufWMX8RTxolV/DcNuZfxvOuMf8SnneP+Qt4bh/zL+JpxvwLeHbH/PN4pmP+fMiD';
    b +=
        'YT4cT/6LZyldwOmqOsNwnDewaaL5UE5PGvdSMbv9UMCLBDYFvETgoIBXCNwm4FUCRwS8TuAOAW8';
    b +=
        'Q+ICUe4vKfZhjg+loN0vxEniYwKcEnCHwOQGPEfgCVXKRT5waMAkoiww8YLgntW7YzhvHQPts6H';
    b +=
        'qIV8/s7U8Md3kiaMLKnqlghZ9nSyKNDM78+nA6yJbo/9KzU458PNnTZE0Kf5VcNEHsaeQBzDmf8';
    b +=
        'dypRd0Q5MdRIURZQoH5wjcWuJmywZKGjJQYZ68NGTz1McY1j6c+nLA2ZIg1xxjxPOpaOEdtyEBs';
    b +=
        'j3Ev8NhMcFrakOHaGeMu4RHcj3PRhgxqItIHBH4wJUJ9UOCH00HpLJ4NiGC1Le9LiWjfJ/BTKRH';
    b +=
        'uUwK/PyXifb/Az6VEwM8J/HxKRPy8wC+kRMjo1CPEP/FRkxydfYjmCUgObTFDZrPZZDaaQbOBuP';
    b +=
        'd+Sk4giw//1VD6YQsyhP/VjKl7vJw0wLLygRvO3zTqEEXx6RzO8TSOeF05y8Opn8bdqozLyR/OC';
    b +=
        'DWOuGQ5JwTjqHE3KI5PFXE3pnHEX8sZJE6hNe46xfGJJdXdxhFnLmecuH/QuKuVcTkVxW5A4jDc';
    b +=
        'P0RJf/UaLn0R+WF2mIBFZhbm1hvJ7xAddu1ywzZ7IMtAO4hsqTrOIsO+LD2BUqeIHIvkBLuEiGx';
    b +=
        'C5CbEqyWwl5jeoly+BINuQCyAL1bg1IcHgLwO8heLGSB+kD5DTbWVRIQPsmdoEETP0BBInqFtIH';
    b +=
        'iGDMidoREQO0OjIHWGdoDQGdoJMmfoARA5Qw+CxBl6GATO0GMgb4beB+Jm6CmQNkPvB2Ez9BzIm';
    b +=
        'qHnQdQMvQCSZuhD6C610E8ofCI8CGRQP3h2yjETMiXgFDF5D2ySMU9NHXnUE3NSyXiRyoxLZibF';
    b +=
        'VAltpRqwYAJh6IztjMz0gSH+wwHvvWCI52vs8g8X/d54ca0V4YI2dzgOQ9VGomCV3ctDMEQtoc+';
    b +=
        'yHydcIkhEPrm2+U+yY1buaCHycpGvw/pquD7j/AypH05iLvq1hJ046fXULK/UwterY5bf1ctj31';
    b +=
        '4e+/by2LeXx769PPbt5bFvL499e3ns28tj314ei0sNEW23bh986/bBt24ffOv2wbduH3zr9sG3b';
    b +=
        'h986/bBt24ffOv2wVdpBDaa7SmGWF4mxUwmGCD+2kiIUb4kcv+IKBkXdvsrVJP+eLXIFfJKvkkF';
    b +=
        'H2JWQRODtvYyHpIEilFIEyhOu/flV/KQKlC8QrJAMQvpAsUtJAwUu5AyUPxC0kAxDGkDxTEkDhj';
    b +=
        'LuKqC3IGVBNlVSIKMFZIguwtJkAcLSZB3F5IgDxWSIO8pJEEeLiRB3ltIgjxSSII8ijE573UfU4';
    b +=
        'TFNMsr9VZtiDEP9wx9EpHjtI//irEhRYS99qHDx/IU5OrjMZd/QyPz70Tw35RH5qW0+E+/FY2zd';
    b +=
        '6aVvpbgdjzv2w4vjnirzUskQY2Vl0VTx8b17eY+s8Pcb95h3ml2mu8x32veZR4wuyDpYB407zYP';
    b +=
        'mfeYh817zSPmUfPYKgXdO9ndoJWMaCQ3VUZEa8TOOZhObUwIoTHm2CDSHufxcAckeHBjIpYhgRO';
    b +=
        'gAEhIFGX9NlpGgMxbxRekd2ZFnyaPXQxY7F5TuU4y6ELgvqqh4l2bhz7Upxk+KwdWIkAo9q4lMw';
    b +=
        '6qZJ9d1312XffZdd1nS5k1u9eu85ZX99pwXlaFCWs1epDf+0OVij9H/+pQxbGfpJqxBL2KdogK8';
    b +=
        'D4T28tM1htu2IyDIjCNG/pGnnFQM8LE9jpKrGNDXte9JB/XUVXqtvU1uS4HL1bPX6zpi+F4gab8';
    b +=
        'C+EKX4jH11VigKoE1qnUJrNJ3ilTXmkMat+6A5D7daAIFleK/KdCTM6gC5zVLOwhVV7fTEH0YS/';
    b +=
        'R099GU65aE0M3r5aEPuux8l3ifEzm+8CZ71eqkjsSQltQldvxWc8dhQhixa0WKU3jjtZOkaedU3';
    b +=
        'zhCUMJBTk9djZXciYW2XR8HHYTepzMrZmursRWKT8GGcXWMaKMwIpQoZfPAaJCbzYUTgw99slhM';
    b +=
        '7BbnqgnA4wjrFpCmdYoE1uD/yeDXh8YrOkqXxDLOi4jlA+RUx7NMiHEOiHEOiGoDDPlrNrJIOYJ';
    b +=
        'QicDXJHQ6zWZDKztBP0EHwzLqs6u6cK/hk+akG0i1xjBWjR7h85xVhX1OddeAbuEXilymWUDMWl';
    b +=
        'As/+Tao+491Pesk/5K33KX+lT/hqf8jCzylLBXlbSqswYfdbwP8uLe3q8EJkingXzRcSBeKkiXl';
    b +=
        'g4NsPBfFa95x37i4/2sRstXsewYQuYuWvaaJlM5Be10OgF1mnFIjbDk6hEj/pXWFPyMv9e4t8F/';
    b +=
        'r3Ivxf49zz/zvPvq/x7jn/P8u8c/57m31P8e4J/Z/n3OP8e49+j/DvDv0f49zD/HuLf6dU23qyd';
    b +=
        'NOrfYpGGm/x7g3+X+Pc6/17j36v8u8i/V/j3Mv9e4t8F/r3Ivxf49zz/zvPvq/x7jn/P8u8c/54';
    b +=
        'WUQr+PcG/s/5aNdWZMyx2SE3digD/CAfc0ZKxKTFOiLtribPnkY4ftKKQeXaozkW5XKMt3LOfiM';
    b +=
        'pUqWlF7ELhkNAWLY5CfFsb3tqJDenlm4dAi5C3yu5NZH/GORnSnPZNdVaiG8OK1CAo7QuLBldW+';
    b +=
        '46uj4uB/RWcw2FdpC4EFRHsuwiHFvaDGKCeoizsQZT8ViQrCsvRUaQWDLOXo1eLRofjvTyC3Zv1';
    b +=
        'IL8iflS0BhqLG4EKLqbmPXHwJwY82O2fBS8W4EIBXirAywV4pQAXC/BqAV4rwOsFuFSANwrwZgH';
    b +=
        'eKkDau1nwUAEeLsAjBThTgEcL8FgBHi/A2QI8UYCnCvB0Ac4V4NkCPFeArxbgfAGeL8ALBXixAB';
    b +=
        'cK8FIBXi7AKwW4WIBXC/BaAV4vwKUCvFGANwvwloKy3Mionubzsdy3YmCj1LcizxteEVlc6/Nfu';
    b +=
        'GzeCFeZN1y3f0E+xNiJZ2ne0JVLS54txdgh7RVxK9SnPKzd+vCKp24MGzIL+fopGdM8avEZj4ff';
    b +=
        'jKdBSRVvippqESTuW+w84BWxQeHPkMdlPjMEFllhMdLti3aU+0UEFnbICVd7HJOCZYqcMrwedDo';
    b +=
        'tkhi0eBpaTY3Lg16Dz+BCPoPzH8sOGv8l2tQZbyKtwXoA1QAue/jO1kp6iOGCqvJxVeXjqsrHVf';
    b +=
        'M7W8/ycVVm5pSPg1EwXOAoHxer1RnmrQ5C2mY6eBHO6efZR4jw9bV1f7W2vq9WjHyH+NRYrDXIZ';
    b +=
        '+KyqQyxBu/nnGQpMl4pstkbqVuC8mdTseLJ99IwAMSjriK+3u2Rp2kZjaGBu4f9JfgY2Ra8VoCL';
    b +=
        'BXi5ABcKkKYf5+qRo2iecq8eOY5mNPfqkeNo7nOvHjmOZknn6hFR7tUjMTFi90JGWU04Usf/X37';
    b +=
        '8Eagf9hrTcdtEKxyOtMQfmZx2YbnPI2QikekoKg5gPJaR2cnu4iW2KKzGH9Q1GoXVeJjVNCfzrC';
    b +=
        'HzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzrCHzr';
    b +=
        'CHzrCHzrCHzrOFteNaQedaQedaQedaQedaQedaQedaQedaQedaQedaQedaQedaQedaQedaQedaQ';
    b +=
        'edaQedaQedaQedaQedaQedaQedaQedaQedbwNjyrnOqzbQp7wrjER+eBTnBecTKvmfXg2AnxxKs';
    b +=
        'jh1dNdhylqT0TP96NbXmlW4BY3ymoTBaq2InBMVsgC0JeMaZizxLTTvZTbn3d9Z65ahFh4SMvv+';
    b +=
        '8VNpVzytWC5MxPa9mXtj10rQuYF1Dnv4iXq1U+oXO+4JF5Pspd1TsRi5kGv89YsApyimAYDfN7c';
    b +=
        'CO/Orrwlw+pIrXgbZsa07R8rWd0YNmDXpa8WhJjmBrBHGnRt3dY0zusacGaWjpj//VW2ENGmbi0';
    b +=
        '9/UKikkqjyzJ8tHiJMeSxehwBTGceSdU2wb2NNSOFL80O8hCUtVSedDmMTJwbbBn8PrLBq9bDV7';
    b +=
        'MUDUoq8o0Y+suY5Zt69gxy4NagpLKNS9UXgUv3Abfsq31Itbe67mXGmK7Jx/JEE+RUcx8DcA4n0';
    b +=
        'FtPvyV3tTDfOIsPzbgDx3cCP2UGU+OH71d/g6oEu/yR6FKvMsfgSrxLt9AlXiXvw2qxLv8IagS7';
    b +=
        '/IHoUq8y09wAbjLb+Lyb5cf4+Jvlx/i0m8XX/jJ2WIAw1ih2SH6XZHxXzyTDh+AtPawuf/AlNjL';
    b +=
        '2vYIrA0hZ0zR9x0w2/L475P4JsW/3Y3/iMQnFH+vG/+ixA9S/Ggef9cj/kclfoji33bA3CXxdz8';
    b +=
        'CcV3EQ1bkrQfM3RK//RH/FYk3FP+WA+Ipdio1j/hTEj9C8SMHxK3vVNp9xJ/2JGGUEu45YLqS8I';
    b +=
        '5H/EOasIMS0gPmHZywOzis5w/dUK2tZk3rfXQXNNsIh/vT4ZPsDkwiv4/xa4ZzOfPhRyjISR/hH';
    b +=
        'ignwS/VNiu07jEG3eQmJd/lJCflZFwK3u0kD5aTYeJiu5M8VE4eYiuOkHXHkZ+XxmeYwvjoz0vr';
    b +=
        'HBrlI0Av7ePQCGGsKM4QYovQNrfwHNqWQ3fl0N05tN3K3kfQq6QvfXgCCx42MdHEpOJ0lHAKX90';
    b +=
        'wT8mxocR+RGNjiY0l9kWNbUpsU2I/qrGJxCYS+5LGDkrsoMS+orFDEjsksVPspdsMn0TcNj4S9a';
    b +=
        'DRxcp1lLCdE3ZwRB0Rd3PEKEf0IeIujmD9AVNDxDaOMLwPh144RveIjO63yOh+q4zut8noHpXRf';
    b +=
        'a+M7rfLsL5PhvUOGdb3y7Bm0wDJme62YmjfL0O7Yod2BUP7HXZo31Ua2jvyoXdXaWjf58Y7Q3ub';
    b +=
        'O1Sdof12d6g6Q/ted6g6Q3vUHarO0H5bPlLT0tCmqSDNTfm5Q5vmArXx987y0KbJ4J23H9pQ/Pb';
    b +=
        'PFKO7D7JEAVSJw9WGOM4HHsR9ljta4+V5WLX47tUHPPI8tpe2U/m41WSzrcgAFeO4NPgGl5dyga';
    b +=
        '01dFcf/hU+ibCDv1Ea/M3S4G/p4L+nNPjTN2vwt/emlQni1dsY9/7EpOA7lJFPKSGL01B8KO6ie';
    b +=
        'exTfGTjWd2yKqOf4qs2vqqeGDH+Kb5m42vitZJnAIqPbXwsltF4DqD4uo2vyw3hRex1MBNQms8z';
    b +=
        'AQQuKzoXwDDTlQrOpBtIxnyQNuTFyxzdRDRmBatCeomjW4jG3ABJTj5v42hYg+UZQgRIoSf0px5';
    b +=
        'cW7HjJsB8QwQDKJgZuwlPhd1+nvu6AzzZdTfw7NYd5OmsuxGPbd1NeJjuZjxGukN4jHa34LGju1';
    b +=
        'U2leA1VhPKLFmBcCQYXk6DCVFgZssaVbasEUMCBXY3/ML0hmie+PoWwVA/IUQPT2aEbCMmiyagU';
    b +=
        'NY4OeD7B9tggZZCNaiZzYWs70Rcyp6/eu3PXvvSa6/9xf988EAa7vn5r0DL6zde+7WDyUUwqLPg';
    b +=
        'EolGv/TD33jtta/cLZHMOu45cf03f/nHL5099rWKxE5z7G/8s6PHv7T0H3/9qsbCwlO453d/71/';
    b +=
        '+46t//vUf/Xcay/zqHriy/9y/Pj+9VSIXwDzeG8yGuIq5N4inUphNOsdOR2D9795gLkxDWkOeP0';
    b +=
        'OTUliqebSs5vPYlvbWfAGSdstqvoh96PKaY+/aW3OK6an1nNR6PkhbeM6EMCtyb5BM0exCjO/zZ';
    b +=
        '3BQJW1omCqqPpVWp9hN++WAo0M2Hhisv2mzKzVtJlipadPBik3zV2ga9k/LmzfvS6cE6Ix7g2m2';
    b +=
        'l3FvMDTFNopjbt4xaZ74UaD6N7lBvmCgzlkuSFPrplXCwDkHA3OrYqC2DANzOETrxQCfrC3DwAz';
    b +=
        'H9mJgmmN7MYAzz9oysvQYA3O+dPBSIB1splLsUPq4eYcFA30mkuZ1kHPRc5F02VckNR0kzQQukk';
    b +=
        '5ZJDUkSzSVJnJqmiNp3l8NSdXlIwAHU71ImuPIXiTNcmwvkmY4thdJ0xzbgyTefFH1PCGTxUDG8';
    b +=
        'Ci6uWPa3Lyb0ry2JZN+tmzoovGap2jsOGicDoDGyNJasAIaZ5XWEs5yTvCVWFpTNF72nNHmrZ/W';
    b +=
        'sJQso7XH9q5AajtXojSzEqEly+kM1XqOSKtfieGaJQaeMwidvrhCKdBZUXT2O+hc8ktkGZTx2cc';
    b +=
        '0R1laOT5PrUSWc56Lzwue4lPJsiH4FP1YweeHC3R2dgfzodhxpWTWdrZNipe3aNFHk/psk/wVmj';
    b +=
        'StTWpJ/0uWFlqYN2nWQ5Ma2qRz3gpNegwt6miLLle0RUqJ4e7gQuhU9Jq/vKZLnlvTwz01rTFmP';
    b +=
        'SxZtqanvBVquhMVDbmiUVFD+v4Cvl/T79/0ln9/mgqP4GpA0ODpilJzvm+mWFZQPv9g+ev0icvy';
    b +=
        'iUga4Omy6nwiwRfsmjVa/gC9v8i+OvX9Iff13cG1cAU/daF1uQObW8dOqreh0PFUVDWh2t01nT1';
    b +=
        'f+bmP4e5m+rcr/Ll5HBER4XajLLYe7ELXg125VBM9d4bqD6O5eyCrR9SIM2Wq3n62kNfrzY3KKt';
    b +=
        'zX8VnR5xI/OjgARmkhZ5SwTnjq0IhdCRWLClgUooi4WHyw7EMSulijsFJSn8TFWlrBW7RSFgtxb';
    b +=
        'OrFsh6bvoIZik2jYFsqKDx/cTpwXpxzX1x0X1yUF4eKF2fcF+fdF5fcF5dk0YNZIN6h/E+YGdE9';
    b +=
        'Hy1Yptqeb//qX7z2+emv/5+/4ywYtT2fnPuhfz/9sT8//i5nqrzwrW9e/MU/+fqf/1mltKjScib';
    b +=
        'roM+83mH1idiaEuPoi56wCTftusDjMK1NCVWuUrf5Fes2t1LdZjmyt3JY4frsVGCHYiyzmx3ndX';
    b +=
        'cuwsSIOVFWooadiFvF4q1DXZoF1qhf56V5D7NbvjrJ2lQzfWs3camyUhMXKys0UZav3ibuHM+nM';
    b +=
        'p3e21rDAbsAYM6tu5NNXZaRdIPOp/Vi+WhgYp1KB4VRsqtyAHzFOh/ddJE1pVjC2t4qmKN+xXJs';
    b +=
        'l4aNU+kmxexHeTmw8xZPiLfHk1kJTclyLC3DEH/BpJuhP+cuKm0zwJ8bsstOrWA4mmYwR8JCAAQ';
    b +=
        '2gLGCseuUF9kSenSpLqNnRtGj69HGHD2bLFtd0Z7ZIG9t4F6h9Rj92IfFqWAU+rmPppj0knyBkF';
    b +=
        'UpJTzyQpGyRnCFdqr0Kerppjb/suXdBjnXoDB5WNRsG8+t1MZ5RoNt47GeNnbQFHboViyXNTPkr';
    b +=
        'GjPARH9wHnBcAyg7chR1zWrRYhJnDUrMZslQ7I7gP/qGNgR93GgoZzZtMzRYEH3S4GwCW1309LO';
    b +=
        'm4T21nV9VB6ivAJXUN9EmzukrbXV3R0kuGPkXqkxuqkuscsax0JdU/lH4tI3dgdDstfARQr8AYR';
    b +=
        'qQP8ILF/ACHbIBpJpJ54t/MQ8bfh/wprQnwvl9phtx4vleDain73KCvBiN/9cKIb4z2pxc2G3Kk';
    b +=
        'u6qT7BxvT5Lh1rd6qLYmFTnx0Q5m5Y5ZAAl2FFRdhnAZZwPlbg98UqygWOO5Wr4vOmHwbudWeZW';
    b +=
        '9ifIbZgLjS1kynX77xa2Ge3C2xVhPW19XgDhvXlzIcAvntSx4e3dwIItbPQfiP3WXCHSbjDJNxh';
    b +=
        'Eu4wCXeYhDtMwt8NJuHcT9PafPmn//aZhKIid5iEO0zCHSbhDpNwh0m4wyTcYRK+G5iE6Z+ltXn';
    b +=
        '2Z//2mYSiIn8nmIRPDYglzqWWCKai/GfYRh/kbZ8RTa5s7qvzbAo1yOZbEI0SXZUaLL+y1o6jTT';
    b +=
        'bTEl3sqGQ2dLEJaamITQgVsXPNcb7hK8dON8U5TbUUu9AQh8Tl2NkGlLOrMNXlxC71Qa8l7omd7';
    b +=
        '4N9nZh9cDv1pdjNIins1rcO55W4aSvVtz7OOgul2nJco1zXmC3PlWvKcc1yedXxdEtG5PS1eaj+';
    b +=
        'iBJDuXQY9FSWqIwlGFVpK+fUg5NIfHQuMDNWwks4zlMlmLtye4mMeTlaYlahhB/YBFUupNwiWGf';
    b +=
        'ZoFxST7sCWDCRBXxTuT1s0YXX683l5rCe2VC5IdCK0qG3LJ5/txC1vlJWxl8lZ2vdOdvrztlZd8';
    b +=
        '5k3Tn7151zYN05N6w75+C6c25cd07pW+Ruma3Z4jeE1Od6SN2Sskvklohd8rbk6xK2JVyXpC3Ju';
    b +=
        'sRsidUlY0umLgErgW5agUDLRIuPBjlpcUjjluXi3/a6c3bWnTNZd87+deccWHfODevOObjunBvX';
    b +=
        'nbMgLTfWIausI+YTWRw12/liqiY62PzH/zPPitiYmL3xknMU44tRJ9HRnvmmNd9emjG9Qot7qca';
    b +=
        'GG5JXsrboBZdSSyWXk5iobOWkJaVPy+9OuCZxS1mzWd+8bbPYIbipqhJiXucZaW1e5/Ky7iSuVm';
    b +=
        'ss+rXe5hYvusO9lvfYjFea3PNJY1k8azMXOoS1nnCoJfbGzZfiiMGB2VzRAhfD6kstOSzxRhwDj';
    b +=
        'MyBVaH/HMGYkKhZB6pmHaiadaBq1tAUVDVryPGajqpZd6iEKsTRd1pTRI72ZxrkNh0x27D9pMJm';
    b +=
        'lJ+HRKM/t6oG/cWWRPSYngtym47tkqHBoGT7MWB1S86vNh19y8tpCTuFR8CHbJ3+BtwBiq3BWMD';
    b +=
        'rNu6aBa5aYNECVyxw2QKXLLBggYsWuGABtejoqUVHFuVhfWuwkEFu0VFCuV3BSCJyREYmKvWPa+';
    b +=
        'crKOuxgb9VHThrsytmE7huyBPl20JtG/bMPBk6vVrbvfbx3prb/Sxs40ViZaa2zECeV9gQq9mip';
    b +=
        '6vjvVVczTKvIyQuPohh0qtaNiunY6WmY6WmY6VWMqpXt+OlVjaqVxovZaN69nOBa1DPWr3D3tla';
    b +=
        'p6tOmLq1qDe5vpxUZu4kGt9qss0uRk1uyC8QU359JYN4fXlBYhAvMH1sxo9tpCJTPyTZ8kz9eaZ';
    b +=
        '4/DYlqfG+IbXdV7O23MRyISs0wBuXWI4vNSV0TPLRZgUZ+wqTfFXrVg2T17pKrKEmtcKeWmGkL3';
    b +=
        'InssJSn85VSREsGb9M1rTU115mqU/0KsVa5dr2+t7aY68vtlYB1VbogCV5sdLKEW+O1b5kRat9Y';
    b +=
        'vkSM6tjuy8u2e4Tg328mLWs7b5A7atxn+f292JxfBizOTzuoab1uxexVQ3HUJ94GPVNnGesasZ4';
    b +=
        'fF0lap/bdWs6N0Md6JKo78LiANvt6P2SL5WqOlYhq051ankmVMipc7SszmrOb0iNCPpseM5Xa9i';
    b +=
        'KbLExYjqFjcCg14ggmy4sZQD5r1qCj6/6vUYEfyHx44ObcKOyc28ajbBrEvmTU5jmc3yehCuRlg';
    b +=
        'WTtPGc2JBvslzuBwlumtZ+WsWbL4TycoMPe/HfdorC9P1Obyj13uPFBLfYjQ/N6B9GJRt7pum/5';
    b +=
        'Pk0GCam8KOgwsYe8yn2n5pK4vT0fEXTX5H0pCd9etrTDFOSIV6WwX7hgGQIl2WQb1CSr0ntPY/+';
    b +=
        '0EmarQmte7PkpSz5AXq98lQL2ioHTXgm7Rym9rc+gWPDlmn8/RZsxWobm7tZjJfQw8lNTs5mDxp';
    b +=
        'bVLZQeTGbOxmNZ/8h+R+JMf1y5dkWcBK+RIG531PxW+sziuWfO3se/UTa/BR7h0o3H0gH8LzLwL';
    b +=
        'FW2jGbD0xBENu+0C9uqdK7p8yAVYZrmP4D0DDMc01x42MoWna37PEyMetzDl9/p1cZ35s9OnEmH';
    b +=
        'fgUVePgVHcjPEwY+n4T5bZQfl5u0362KR+gyh5Imyt8ZRMV0TkAhzUINdmDFzvH/lf60a7nH2QS';
    b +=
        '6mCe3HPwk3sePfwpdo2Vbj2Qbof3iQPsYSsdRnutm6u0fSAdQuy2qcLjVsO0pTpDy2uSDk3t8XB';
    b +=
        'VMnD4JI3Gmf9QeVZs8B1679MtNoT1b3/3nU+3/CzOYGVt+ug3rgRPp+EwLdtIkQgTDjcDrOtX8X';
    b +=
        'ZGY4zgazXNd7VCcJ6l/gxFeRnMvPY9PQyjk2GG+X/2R6uan+qAEN7wGlk1A0s1feaPQk2mmnGQ0';
    b +=
        'hvd0GyZ6kLzbeMnujgu9PZm3ng3poiWSQj/U2bTVGr2o4mbkAcGnjzRuP3+bs0O8awfIuWwVkkr';
    b +=
        'qljVeahSMZtED/jFvWlwxlD3J6YxlTb/fquFc+YnWwGf5BKZ9qOEZ4a7wR5PnA1126YFr+cmeIJ';
    b +=
        'GSXtP3wE4SYcx0wbBRMSEbN784SsopOsRVVMKtAw2EpW/gMnJIzYp63+WSqDo/cQ69n+QOKkmtW';
    b +=
        '1w/wFceUwRxVDs8xTTRHrjhclWm78D/8RVLhLEPrW/uwGXE/uJdinX/u7gngr7DkJa2jQDzxMFD';
    b +=
        'U7h21MfxMl55nWDZtJguyoHtZodswE41DoMfLCVUFT/fmpmswvLv/0fhGHPTiPrp7+LX/2C9WRP';
    b +=
        'oet5iPCU3ULokxLilodECPj5/m74ONaCOcqQbclmke+PKV+2eJUi7s9mbITBNJEt/d9aavbqlyn';
    b +=
        '9ruzWl+0L5/8TRezO5q/aiFtfoYixbC6PWEDEtmw2j5j9Cpcxk0f82SXOMX21+CjVNhByeZrIZR';
    b +=
        'OQ3oJXPiKN9gepIegYmo28qW4/dVn7eZpxDuK+pkn9Av/bNCaHpsz2KfhvMm1g/q4pQxPTFozgz';
    b +=
        'Wbrfpq6hvebbfvNEOF1T8XAsUgyRd23cQ80+ZsSGASJEZhuRs+1qNMw4UnP8QvE5npdD8Otj9jN';
    b +=
        'g0rN+GQXU9fgFJED3uUFiyJhFKczRT1Jld5Pldtg2h/kyxEAXU/LFCt6/dkV238ydh6HpfEX+Ns';
    b +=
        'oDNdgzyNqP6hr/wcn4emlucf/YIZ7x017pqZeGG55Yp6x0gwbFgrYZR0MB9AaLTZSYmLt3uNVYD';
    b +=
        'un0W021F0YsWT55/r5Fgt+RPhziX6uvWfwAGXiL7b3vHDAtEof9fOPsrsob6WPNoiD2UmcQQdAB';
    b +=
        'RYGIlzHEmeXDY0nM9T6z/R7Vb5f8VgEA6i4vwKb14vexOOsoHIEuzwqNXsnbqtYj50mKLblUWUD';
    b +=
        'CuyVNry/gmkWLmkD0ZGOaG22SX5v0n6wb5oYuIk18Be07Kf0M4EpgE2+3F8J3UxhBhdb1O5GtpP';
    b +=
        'd3O8UO8YBHzrtFJe6XHwEN3/Om5p6IE/1Vkjdn6f65a9O4eoImTixVG+wk4SfUGY8VvanulmEwT';
    b +=
        'ReoAaXq8sQV1kdcd5yxK2K0ynhKHsqJrgykVQMrolD5uGlcuyqmG8cV62Qt3qFvNUr5K2rQkxdK';
    b +=
        'XvzrmRY1L0JYbxr2dU/0FPN5BWaBoD2qxXr7SLch98P46eyb1KuqjUp5vD1PNzk8FIeTjh8Iw8P';
    b +=
        'cvhmHh7i8K08vI3D07mjDcPhQ3l4hMOH8/AohT2Fd+zDhOkzxbjtQdoDRTt25u0YhdMYbcMo3MZ';
    b +=
        'o/UfhOEbrPgrXMVrvUTiP0TqPwn2M1ncUDmS0rqNwIaP1HIUTGakjPT5UriNOmaJyNR0HI1LVea';
    b +=
        '/A+QWvjPOLXhnnC14Z55e8Ms4ve2WcX/HKOF/swfnVHpxfK+G8cLPitmmGneSU23S0p00zTpuO9';
    b +=
        'bTpeE+bZnvadKKnTad62nS6p01zPW0629Omcz1terW3TZigmJym/4gPwHu8tvKhs2s8VWyUlg4G';
    b +=
        '3TCKSv7IB6/k04TKptPDZabw+aveuGsBnz03cXzkxserxIuhzXI5vAXWQy1ZlKfZeSq8qGc8u/O';
    b +=
        '4D+BCjY2bCpsV0C6GD9tsPdEef5L9uQL0cpCfOLvDvJwFOB78De8JsXPIUxC21OxtfZL4RCwm+F';
    b +=
        '6U0SSEk70q24s4+PfY4mmoa608NBTLoymPRB6D8hiSxzZ5GHmMyGNUHjvksVMeD8jjQXk8LI/H5';
    b +=
        'PE+eTwlj/fL4zl5PC+PF+TxIXl8WB7fJ4+PyONFeXxUHi/J4xV5TMljWrmLQ/o8rM8j+pzR51F9';
    b +=
        'HtPncX3O6vOEPk/p87Q+5/R5Vp/n9Pmq15A7UriWavxfiV8/mOAYY7GiUh+ZkgwjPxDkB4L8QJA';
    b +=
        'fCPIDQX4gyGeDKHs+/e2vfeunfv1XTrD4C1s92fPjf7bwma995re+HknUBYr63Lkvvnru1379V+';
    b +=
        '7jqD1/eu5//+yP/+K3Lj69O5A9FUwwZWac7Vg9tpdt1HZpmxjAHm2UmS4MmX6Y2BrljLzSehrx+';
    b +=
        'qfWY7zSetqT5K6nPUlT4lYC66mTYokZ62mVqHbxK2y69WDyQ3L2B4uZB7NYZoNdRFn0Qyw8/T6I';
    b +=
        'nyEGH8DPIIM78ZMwuAM/TQZH8RMzOIIfNk9k8FOZ4iOEqam0xa6p2+Kgmn8T/hVf4QP8i73+yWJ';
    b +=
        'PP7DMnXZ+DJG73LaHAqZlAXsUgX3JoPXtzWKIU+lGCbMUYufQ/nSThj9+4c9/JqLwZpv/L7908x';
    b +=
        'fp/SFNPzz3tZ8KKH2LhiGf6FN4q81/5he+uPjKFNscgi2hvcS2bDg5gX7eR1xhbq2LaGWAokOz9';
    b +=
        'aS16eWZfo7ZctLa/vJMwjFDJ62NMNo5c8zmk9aWmGfaHLPppLU55pkWx2w8aW2TeabJMYMnxYZZ';
    b +=
        'bOJs+j/NV/Iu90GSfmaeYaGqQOaiQOaiQOaiQOaiQOaiQOaiQOYifjwM7gMzsJ8FE906LAzuZT/';
    b +=
        'bNV/ueLPgabbKjDmbIqYmuryOyHCB8/dIsoGusbuA19mXchtLvh0NHkZDT9L+PMnvTZpCwzQxcB';
    b +=
        'PhoIVGI9909JmGKLPXqQFqEfugvghp1d7q6CJTy9jQcF3ezUeV544q786o+mseVWr5qk/G1daTs';
    b +=
        'LI1pOPLN9WJSczFNKrQdYM6yohMJuB+JqCxBetbiY412lJQPKzobT4J61tNHXG+iSdgcDygcYb5';
    b +=
        'NNZx58MkHzzL02iDVa5QR59v6hSPe6jBk2J0S8agbxoUj5v74ElmYqoPVYYgkPlQZRBWOR+qQBg';
    b +=
        '1fqgCF5rRQxUIytYfqmDL7uFYA0bRh15+qDLMUELQVnFLQ9AWFuxE6maGkLqJIaRuZGPsSN3AEF';
    b +=
        'IHGEJqP77KqR2GkNpmCKktVIZTGwwhtY8hpNZRR06tMYTUKkNIjZizQ2rAEFJ94QIJYkzAm2ZlW';
    b +=
        '+M7WL7f0Hwl4p8jFXaxFrI7XbC9db0mzipPNk4k3ttx7DEXqLsl3Q69kG+Ynsu3VE/lm67H8m3Z';
    b +=
        'g/kejndvO5hlZz6emXvm+HkbwHsD3jDwLoK3Frz34E2HmvrPZS7qLCq0k73ZgdRyRh1mX+viOkX';
    b +=
        'EMXDrWGfRhyNWduCwBQ5ZYNoCup/17EbXsztgz26NPbtn9uxm2tMNN+yCYLNtRV7EK2fHqRwLsa';
    b +=
        'RWcsdNgZBpuyfM5vLr4qaiEL7xS+UtsYV5/aIRrBR5Pfu6+ELq/WjkigTgJAjHQfsmun3sJYht2';
    b +=
        'V3j36v8uyj+j/j3Mv9e4t8F/r3Ivxf49zz/zvPvq/x7jn/P8u8c/57m31P8e4J/Z/n3OP8e498Z';
    b +=
        'L2WTgEe91QQZilrjur+2Sja+BqhaEYdIRJPkKhG3lWFxcVojJsFexU6uL2c1Y39WQyrqcCjA2Vc';
    b +=
        'ouQPeO+dZA2hTlFLjUuqRntRmKXWmJzUppR7tSR10U8VdlCQQz5snTePA6VjPm0Olco/3pG4rpc';
    b +=
        '72pJpS6ome1JFS6qme1NFS6ume1B2l9kRGMIdb7hmwMCxY4hXu8iKhd7eMZT0Xg3kJsxHd6q77L';
    b +=
        'drixNgGs5BbPtocVxA6E9nkqDQ7iWuxsGRH30rLlZ1BtUtOm5DO/qZXFs5VG/YsKsdFFcayox4P';
    b +=
        '7VGPa8E+JfOi1b4jxiKtZiYxWiFjtCxjvL6MMW7mYztulEJhcbvBmXwlT/F3RgnsjjtPOqRJh5H';
    b +=
        'E3rvzpMOadARJ7Ow7TzqiSTNIYt/gedKMJh1FErsSz5OOatIxJLHn8TzpmCYdRxI7Ks+TjmvSLJ';
    b +=
        'LYr3meNKtJJ5DEbtDzpBOadApJcJqep5zSlNNIYXftedLpQP0RVpSMLVVYeYlWIS/B4hw52ajTv';
    b +=
        'nKGeK0MIbqNBo1Od3MB5Cn+IPH6D+oxRB9fjvhZ5wO4Fem2aKTwbYOeWeHU6m3i0E9cpeN8wHs5';
    b +=
        'bXUh/e3zQYGJeWMUq/yMp0P69gKcXo8Apy4I8Ifjenntx31pPx9H6NEYe3Op09v0nXA93hzDkjf';
    b +=
        'HQvAtwnci/Y7Hgn1tlmdXF1RwOcGqGB3IN7JTQ0/4mLAwdB+ytw+4jg6ZcxFH0h6LIVaVs0g0DR';
    b +=
        'wAZAwhbRip37wNnCbyTKGVV9rAoH/QEcdj30T42TcxSa+KyhUkISxw1gJzFjhtgVMWOGGBWQsct';
    b +=
        '8AxCxwVoKPypTb6sAUOWWDaArcCy4hZ4IYFlixw3QLXLHBVgDb9rMIKtGi7wNcos74Ij6bB34RU';
    b +=
        '7MBfrzxskEvEpuFqrFJteIwbDe8baSDjg3j+YdxY+jwK6nKQHQrbKmTXMSFRiB38QvdpKIKtoek';
    b +=
        '4aSp7KfN5H59g5y6piRr7ELTSc571fNsjhVuVF/t6xPlEwpkzMeRJ1435izjZ8e4lhnO3f1Xhiw';
    b +=
        'RfV/gSwTcUvkLwLYWvEnwoFPg6wUcUvkHw0VDKv0XlH9f4aX+3P6vwYYJPKTxD8JzCxwg+FzpDi';
    b +=
        'iVQI0cO0BNJwNARk8vFOSMrJufxOSUE7ohZQKYmIaDI1Mwz0Sy9dkkq+2clTxOVuM1lRMPcdWot';
    b +=
        'f1OW5kTct65dfKIOrJ1FvuZk4pJY/LZH8K9EaVRue1y+UBUBxKaVW40m9pVIzslKTExPZVzio/L';
    b +=
        'bKmdbtDWbP/oFFovtaWpbrlfWbmrbShm6fGFPU0voNg1a6zCDN3ItCrgR8SCj2PVMP5+WyRjJpv';
    b +=
        'ez/LDjQlvdL9Gsu58FNJ3RIMNDxwiPKgSSj/vMGrrjBu/1hDNIjdNey6N1qsUOHXixpV3pK7IrR';
    b +=
        'VXqtio163ovW9wvrv3mfxDVaSQfh4gIunCWSV3F33nxQ6HcuNJbUjTe87Ptz5hW1+c8Lf58D0sg';
    b +=
        'NWsphvh4onGh39sK9mKmb2/aIPbiYBaaCvqhlfkTLT4AamWeGHFXsZEWcwAfSlt4vIA98qj/fMq';
    b +=
        'G2Z9L2TD7+1M2zP5UyobZ35eyYfbHUjbM/nDKhtkfTNkw+wMpG2bfmbJh9h0pG2YfTbfyliYd5n';
    b +=
        '1Pyv4ntqV38Q4qvZu3YOl23qelhjdzaZd3fGnK28L0HtmMjazmZoxa0MguRK6LO6hcZ/NRycUdx';
    b +=
        '52LSi7uOG4uKrm447hTkeviDlGui7tgFpKbLZr28GwTd4tnhxhgPBPikfHsJzYazwHitPHcQMw4';
    b +=
        'noPEr+O5ccy/hV3HpjH/Jp6bx/wbeA6N+Ut4bhnzr+O5dcy/hictQFfx3EbTOZ53jflX8Lx7zL+';
    b +=
        'M5/Yx/xKeZsxfwLM75l/EMx3zL+B5z5h/Hs8R1rEOWSaqgYEG/aAGVLqIZBmcjXkAZzkzdoIdDU';
    b +=
        'GnGgOYQFpJwt1+KOBFApsCXiJwUMArBG4T8CqBIwJeJ3CHgDcIfEDKvRXikA2xwXS0mwXwCDxM4';
    b +=
        'FMCzhD4nIDHCHyBKimu/BqQk8+mv0rVbDnX0Ng/uuGGNDA55j3e8nlIdJuQdlrgm65mloDnrj5u';
    b +=
        'osdFWIxlpOU3MtVk1pcdIluvrSSPQFSKd5DJfSIrRSXwdUlRRFh6vek19M4XXwxE0BIzb9N+ppn';
    b +=
        'fYlNhNI+3bELLTYhXS2hOrlAUL5C6BaHvG2q8txWtj/mgp6mbIbAfVJX2erYN7dK2oXDO3gQ731';
    b +=
        'SFEloa+Eu+XOLgUxDNY+eaUseSC3R2sBkUCUGREK+WAD/qKxTVRIttNZzbfCCadoPSOl9b52vr/';
    b +=
        'Lx1Tds6v7xZCdG6MC8WfQsNAW6VFO+rO892vhEMLL/XRAOJQYQ2bEc/JM9g2KbLTtKXhds2SNN1';
    b +=
        'I6nrpQ7ZXw7skOXgTQzbhZj92Ga5rzQMW6jrg4vN4BZMxjGPhH/wOCQCK9nSEFTFW9nbnxju8sh';
    b +=
        'osixn5f5KBXISPBh8tguAU2+fSP4vUSqURFAUralvxRBoZN4qmWi8vLVRGlsSjV8ZHA03LvkdT0';
    b +=
        'YK6hLSDnHee3E8W8r1MUJVhHCpAazJJHGCED92I+OVIolyyq/rKFEXrdnSAHsrp/nlRazLNDstV';
    b +=
        'oWVJPBqVS5uCLxWlbsdAq9X5fqHwKWq3BAReKMql0gE3tR7Jkx1VdxDMDhdw10Eg4dquI9g8HAN';
    b +=
        'dxIMHqnhXoLBmRruJhg8WsP9BIPHarijYPB4DVMog7M1yHkweKIGWQ8GT9Ug78Hg6RpkPhicq0H';
    b +=
        'ug8GzNch+MHiuBvkPBl+tsQwIIYRFuuMnwoNAEvWHZ8nEMJWw6704eQ+lJuJxspEc9Xh6hIRons';
    b +=
        'qzb2YwXRJt0BanQSjNIHOaBaCEmT5wMpfafiCmvKbDvak3orvH7NjPfYGtgERiDCSEqR/ee2azm';
    b +=
        'kKTj0TCj+IpjazZSDhMnNPI2EbmZr1CE0kMzHqFRJxSEGvp1ySwwIFYA9asV/6iaPTri3Pui4vu';
    b +=
        'i7lZr/zFGffFeffFJfdFVvhls141ay8pKuwleepTpWwwSfQqo7LFJA9mvaIeo0m8c0b5837ah+e';
    b +=
        'Mz+cp1qxXfQqbITHrVZXdu5j88disVzQljjhWqdv8inWbW6lusxzZWzmY9arB9L0cDODTVXV/0O';
    b +=
        'TaarWO+Y7JL+ILPOuqwhOzXjhmyr17iNUkbhbMerWnpOXz7FTAs2a9PDbrFZna2k0U5zW9TWR3r';
    b +=
        'L1NXKis1ET4smDTQZ4169XQGnZQhzmuVZ/i4JjFgTX85bFZL6Ag9y/REstmnpj14qbBrFdTvZ94';
    b +=
        '1qyX2kdTLMGsF7B02fpbCAssLYrxsw2KWfYk4lmzXh6b9botnsxKaEqWY2kZhvgLhjYfLcXSOYs';
    b +=
        'lMW22kRuofadmvfrEthkjYUFtdjX5ZTXr1Sx8RXhi1qtAz+FgBfTMKHquWatnFj0btGfUrFdVzU';
    b +=
        'EBX+yYhc161dg6lVd4ElGHKW3GqJr18mDUy8FjJGa9+FO0IWPfIugga7QrKYgEZr1qeRvPrdTG+';
    b +=
        'VIbj/W0MUFTqorgUxbBGx0EPIf2syk1ud4Vs17WzZI6YoJ9hBbnGFVDWoOSoSVmvUI2pBUz8oiG';
    b +=
        '+tiOmGfNetW0R7lJMOsVQp1BsNvbpCnWtpTGXK6s0GHswcWSzFCPVygx6yW9IlakqC6hdJF1lCS';
    b +=
        'eXPKPxKVv7A6GsqGuz5a2fHHDQbyG+sfws3M/p9p6VVjY8uGCA/uJqhjaqrBPqdde67D3jYp4+m';
    b +=
        'DnG6r5mTveKJfV63gDhBfmjjeEpczMk3rIMM22r76UiO2rxWpuHpN5IT5ZbxdnkD44fTmDZCFKT';
    b +=
        'K98uOPur5p8sOKrS1h2Qevk8K3b3kCO8HHsnugbs9BMtSrELHwQSrh0/xZKbls2v+WWjysDHJZ2';
    b +=
        'tFRcFlAnGvcrvi1F6xfab55l92H+iUhc2r8qwdMaPC/Bsxq8KMFXNXhJguc1eAXBUf9iJBwmgbM';
    b +=
        'EzgV5xeWXLZtwVYCKLWZLjkBUtE+tUYh9tT5rrKAmYEkcu6YHWtrCQik890ZuP6Z61nqazClFbI';
    b +=
        '4KsReCe51+vWoZcCrWnyuRC7hKFwkR9HaRFD3PNy1yAzPotHKDGbR1WGBld45Y4bQ7b6m3vL1sH';
    b +=
        'IltDG7QvHJZNGDcT0kJUYlibQxX4IYnfRpKn96S4EUNHmJvbHy6geARCV7R4FEJXtXgcZ/p4XqY';
    b +=
        '0wOOTZa8ogEsnYKqsO9lp5oNtcnhw1Cahtj1cqN0uBnzX8DOoW375kpa+9go+vbl2PY1x0on2RS';
    b +=
        'LAL0s26gXY5ucSm2EvqdcRzC4egct7xy92dusd3lDTus2m6F8hglh4oUjVjDxoi1c1kYx41KnSm';
    b +=
        '22MwCbNdlk3M/I262CUDXEH35AhnlVOu5hGeUaOl8RitDgRQle1OAlCV7SIJxnUkdfqeZ9PlfFh';
    b +=
        's3nbwrG2QREjjDUra72F3w2SVK3RhOqAq5gqKGeN2q6hAp2MF50LLJrx0pKbqABKdr6YvaXIKZh';
    b +=
        'j2altk1mowHsj9xTWyuV/CUbv0XiuScsgW+0BYpBnaYln6KcgnA84zlTI2KbWuI8q3H5PKq5tCU';
    b +=
        'uLbRzxqql5XGhQ5r1HIEOlnWmrogKj7scHPdKy8EJr7QcnPZKy8FZr7QcvOo5y0GFZyd0Q7+2S2';
    b +=
        'Raqmqoo2hFMZ0ipp7HVfU9rKOYwzsanuNLlpqudquV05fH1WxPcTkNHTMVHpbYJwyt0NdF/zfyO';
    b +=
        'DtBLVbBUPzjjvcIGIrZWL286w1xt/+v3XJS39+o5SQ2MqlrGe5b9GD8FbEKyVdKoYgQYjJrSkQP';
    b +=
        'uyTZZYaUlZLPBFwDk1URCZK1IHTMpojNPhvjWzTfK0asAb5dViKA94mBc4A7ZLkCeL/Y5x5lH9u';
    b +=
        '+Irz7TrGRDnCnLHwAv0dsdgP8XlkdAb5LucEWAg/kGnLdXbnyXHcs16vr7s5V7roP5tp43Xfnin';
    b +=
        'rdh3Idvu57cvW+7sO55l/3vblSYPeRXHew+6joDXYfU3lNUTRs47w/N9AoIZEI5Wv6duk6oMN/R';
    b +=
        'fdZwU+xG9UrNoYc7Rz3rjCZV+oVuXfnMvTTbCWvqpJsjohJlMudVLUWOhMXFMFfUk5BTfC4sbmp';
    b +=
        'vSD/2pKnRs3k3Eki2cyW80ZoJV9hUB5cIMKaL9bUJTbqZWOYUciDPTyIohAf0RdLqoL6YRdJZVm';
    b +=
        '8IhZ2X+O8I8pvoNwoR9V8HuIWisUhjuhhk5UcovG8TfO1nv6N8rEoxQn+duboKzLEbgaYsa2vma';
    b +=
        'duMRdrWi61VCtSoryNms938iWlElZI4btHJaS+nPrXwFW1B0sF/UWrYEgomqnPcg/NgoqVWm1Kx';
    b +=
        '01hWlvLtpq517zd3Gd2mPvNO8w7zU7zPeZ7zbvMA2aXGTO7zYPm3eYh8x7zsHmvecQ8ah5bTWI5';
    b +=
        'XCaxHI3LOGCBvtDewkRiG03TRXysVkqPb5PenFyr/CoLo1j7Sf1SsYh38JFqveoaovdD4bCr/gp';
    b +=
        'BFs0A/g4/pQzx+BolRLghiuy32RImrc1f7Hy3KT2uqe0oSo5sV0UMOQD/yzQdYWkBVpw4PexND0';
    b +=
        'sqizVXuap2R7nqr0O5KmTlKigW0OAoVBZDVqmKHJXFkJWpIkdlMWQ1qshRWQxZgSpyVBZDVp2KH';
    b +=
        'JXFkJWmIkdlMWR1qWi5yqLtchw3wx7+m6u56E3wPSUB4nb3AOuDsIKiirGJkmLaUGptjK+oqWh1';
    b +=
        'DmlE96TXIKtVM31qkS1+qRs2WF6nR+UwtC/zndod5cLvFuXC0FUutEqEW1jpsFAutEqHQ6wsWCg';
    b +=
        'XWmXBNZQLa65yoVVGfIPKhaEoF1ZFuTAqKRfWVlIuDHPlwjBXLgxz5cJqrlxYzZULq7lyYZQrF0';
    b +=
        'a5cmG0TuXCWq5cWMuVC2t/V5QLQ+bRYmYuXOXC30u8GNvshWBvGo+gwdNQACC08DfibMe41DmGJ';
    b +=
        'Q+FHsihB3Po4Rx6bK+FzlfyyAsFeLEAFwrwUgFeLsArBbhYgFdzcE9ld2Do8fO/9OO3Pv25X1r6';
    b +=
        '/QococR7Xjvxa4d/69P/x8d/+iCuYOI9/+8f/3/svX2QXddVJ3r2+bj33K/u01LLaqtl69zjtt1';
    b +=
        'KZNKAbbkGk+h0ETseJy+e91JTmar84Xr1qt5UK4/nloQmb5ClDpGCRAw04AwaxoAgBplgTwQYRo';
    b +=
        'CHtBlPRhQCBCigMHqDZlCCEsSMaiLyNEFEb/3WWnuffe69LXWcQAJMFPc5e+199t0fa3+tvdZv/';
    b +=
        'eqffOT4Xx3/qQO4IErn//T08TN/cObPfuFXD2AzkQryRFqeuLgSlBPZLmqoRt7EUxxoZT9GMz2b';
    b +=
        'MFCw3+jQC7tZKj8HA8NyxyLuOHYAZFZ0tKV/W9K/LenflvRvS/q3Jf3bkv5tSf+2pH9b0vYt6d+';
    b +=
        'W9G9L+rcl/duS/k3LHzAL/RYtHU1M3002cEf3YZ/T77GabxtgxG1M4hheFGY1TRC7PjEcRYwGib';
    b +=
        'BBosWow8i8eU/ugJpltFj03srgI50Rv9mGoTo+Mv5HeQtH2CYSNChmfslsp9cxoGRShnsgZihkY';
    b +=
        'IMKkBO8/W3hyxVlzM99/i//8EO/+rl/NSV8+QM/88N/evLU0c/uELb8lx/7rR/46U/9t9+BwijY';
    b +=
        '8td+7o9+70e/98/Pb/S5kgWPu1jWnjBL4owdloE0x/djzy6v3wcEIZ12WJzGOuQ1LobQGIo1ZoG';
    b +=
        'TfKXjBqY3JyLgtNDr1vDlaHu4R15fodd98voavR40kvh0xAAtqQ6g8bKxt4iy78ckySC4YTm1Bz';
    b +=
        'eMe8qlpeu08OB9b7n0pWgRTpP27tr1IC8RKRS41pA2lrTpWtKmkra7lrRdSZutJW0maSfXknZS0';
    b +=
        'k6tJe2UpN28lrSbiSu2LJTJXt7diX3XV9z3gdpenYh2CwdArQ6El0HYIwTu9ZMgvE8IXRBeAWGf';
    b +=
        'EDIQVkBYMkKZBOU1UA4qZQqUU6AcVspm4abdlp3uC5YNc/VyxV0+Yxk0kvEaybhGMtpIuWWsNaS';
    b +=
        'dsYy1hrSzlrHWkHabZaw1pJ2zjLWGtPdbxlpD2ocsY60h7cPsbKwf6LmBZ/YUmmwzQecnxsLkQA';
    b +=
        'wpwTHDUgLYBbAeQ/5Iz4igAcoEfThHe0LkC1ML84Gc+DP7Ns9zYzRvhP7QgtWzkDAbcGRVeHbBK';
    b +=
        'lFwmFU0MBWzpKE8Iwp6Ts5QnvIJWAxWfMJJG4CE4VrgFPwklnjMqgEK4VLglAWFcNQGAElw1LjK';
    b +=
        'LVevh41f0SWVrPaTUIQa+JN9LOXDGUcYEXI0uEg7dtp4RhBeonU2gQZ5BE2mFOcIioAXtLyhXk7';
    b +=
        'eBxVU8UdXNOfN4YPs5mz+LR9UyKg8pOUZv701erJoejlADYV/k0Eg5IYoHpWL/Eb5PoeVljft4S';
    b +=
        'lFQ7AeDOWXDuYXi+ZkUx0nqjoKO8cLxEWfOATcxz9SKaG87tJ1bMtoe9E57Ak5wW+NdhQtv/nMm';
    b +=
        'pqPuqNqPvigHNV+UDV8ne3XYgZpDTSgyzCuvNfVGrBdubJr37IBv5zidWzbaIvZBhxUWZKWWbBu';
    b +=
        'AcFlHGgDDzeCG7mnaYjOY+amQj7t1S2v84aXEdUTWkpN1VLyPfU9PVA/vziPCMK2WfDKIzyjjgq';
    b +=
        'NVaNif4XaOMFXi1dvnp1fsFt4IfTyBJCvK3NbVL8iaJDRxzvmjeiS+Y3Kbej/ar7w1WjUqhmbtZ';
    b +=
        'rcqlHr/PsVN+pgdn7B1t6oHX/25XAgK1CQJzyjp7zyMTixTvcBvTJmsQtD7dStRayvzlM9C9KBH';
    b +=
        '9h5Ztysx+l7iU7frZlArNK6YpWGW94mHef2Frcv5N3pYopRHvEHSCt7iw15A6DjxTokWQ/9p/U4';
    b +=
        'tC7wGXBvAWh33F2u5y9wlAoXyi3fUYzvLDIiRRyY2EmHgX4jz/DI8jE8xvJJkX0fYGixPRBATeb';
    b +=
        'QC10PmSEDlVEmvZw/XsQeoYkP2jhX0F4hyOPpXfl43uPYbM+uXfm6srlYrNubb9izCPXRvUVbLH';
    b +=
        'TNAmAHmov0TZMOZ3l75yLOOYadXGQ76Njn5ZdxZlTFCfwmZYr88slFeB/RHBuaYwM5NmyO/bbAr';
    b +=
        'DVkkzLGCAf5BE3NVOVxPG5jMyQ2Q6WW7kfA8gYv8Ykkn8qpA0J0wHoGCYBG0W3QPMpwwO1vyjfi';
    b +=
        'sTHvohV63HbUWKnYsnapmuwTbxo18uuzUeozkW8aqE8b9YEJJh+cUZ/2IleF/vSkPnQiL4NHy3A';
    b +=
        'PX3pQvTRg8fHzMeFhryBGC2Kmsx3cuSnjzO8pwB5FxMYwXGtYn7LZkW/91BJTqqbz/WOJ6SgiTK';
    b +=
        'hqn4u8QA1h5BIPv6byAvm9vIWrvWHzrWYV0ayZb42OYPOt4axGloB2uIEg6bG8xoi8xoi8xoi8x';
    b +=
        'oi8xoi8xoi8xoi8xoi8xohMwoi8xoi8xoi8xoi8xoi8xghQqhGgVCNAqUaAUo0ApRoBSjUClGoE';
    b +=
        'KNUIUKoRoFQjggEjQKlGgFKNAKUaAUo1ApRqFCjVKFCqUaBUo0CpRoFSjQKlGgVKNQqUahQo1Sh';
    b +=
        'QqlGgVKNAqUaBUo0CpRoFSjUClApT0HI/jUTeruLmM8kbhZG2D7MHpJ/s3wzKHtqL3B+h9Eco/R';
    b +=
        'FKf4TSH6H0Ryj9EUp/hNIfofRHKP0RSn+E0h+h9Eco/RFKf4TSH6H0Ryj9EUp/hNIfofRHKP0RS';
    b +=
        'n+E0h+h9Eco/RFKf4TSH6H0Ryj9EWp/hNofofZHqP0Ran+E2h+h9keo/RFqf4TaH6H2R6j9EWp/';
    b +=
        'hNofofZHqP1hxEuFkQXNNf+ZcGHQS2HAyGfiClQVUiq/f63Z8EwoyL0XAyQ468ZZgEMQUc55lMt';
    b +=
        'MOe9RrjDlgke5ypSLHuUaUy55lOtMuexRlrh4VzzKQaZc9SiHmXLNozzDlOvV5AbVEFqNr4+Jf4';
    b +=
        'EzoR5XPVRrB3ftcLAdQLZDznaQ2g5r24FwO3RuB9vtsL1xGJSXZ+yLhWh32O0O1N2hvTsYeIcP7';
    b +=
        '4DjHaK8g5r34OifXM3WXYEAGgoKYfK4AsVm+If6jM5XMqOIQ3O/qi847Gxj29TYNjW2TY1tU2Pb';
    b +=
        '1Ng2NbZNjW1TY9vU2DY1tk2NbdO/fsRBxhtcY5uGQ21qRrWpGdWm5qZtqjpjVlHZQ4/w/LwacY0';
    b +=
        'pys1x3hzwoxqqgnZai1l2WOj8WTj0mf2LAjQHkRLlh4X81cEzrDfvV4pu+KxiHA7mqs72kpoyZr';
    b +=
        'BQUzHztb3mFmoJ4sGW9/XOVIPNDIHfxwysE+j7oKpg5ZM3Vn1ZT3dLVay5IMnQz8vfwNPmc76Aq';
    b +=
        '6TGlTV2OtZOPS/21gUBARVVNkt2Dl50SSirtaCsFoGymv3Latovq/m+rCb6sprhy2pqL6s5vawm';
    b +=
        'c/u6XL0+W70erV6fq16PVa/PV68vVK8vVq8nqteXq9eT1esr+ipDcUAxchCUsMYtK2YAcdAqhgY';
    b +=
        '+Paj7/h0cgYw8aHliTnEHJcT5c7fnuJx2r4M5OQa6ol6SvTjD3JpUmveGr0eTOk8UARtB+Z+ZER';
    b +=
        'UJBnLviAorrb4f7JkttPrStLW0EvTp2IqRyJKEjP88Nl2sp59/786iQakBOoADzMSePhwF8UG5f';
    b +=
        '3suSoLhU0VrZzGOI9S4PS4383E+LvdwOE7gSIuPyRkfjtt6OE4FW2gyTxbYxjB7DJB3WZ7uLFI9';
    b +=
        'zuYdnPAyd9hNpumA29bzNG7YE3ss3pX36Ny7N2/SEZr2GHqUzhYxB+8tGKQq0QNeggNespPPwYu';
    b +=
        '76JxyIA859abFghF9mjiycUVwwgeAAN/uNgT6ognT3t5CeezDr0JuAM1MpzwoOFLwsSSwHsAk4m';
    b +=
        'cybeMZQopzYMC+WnwXCoBdRY4yfdq/izfcJgx+9kJViZ2VWCcKf4+dTrBvA6hXTKF/ijuoh/JxO';
    b +=
        'v8cgCIX932/zapbQKAHX6JdI8hxWnmXebH1WP+2fAP8h+2GKoGw1J0QUGyBw1wO5gj2qVuai/0i';
    b +=
        'T9idbpKvf0RwvPP12TSUHgEl0s3vFHehnXwSEozONPH1Bqzvt0Eu1Icx3pYFK8IBe7P8R7j6tul';
    b +=
        'deZ6vq0Q4xd6cODcF5/JlfKqcm4JzU3DuGDj3rpw4liULYxAwCMeOLfRngNbxaP9u9Se1jAPgmD';
    b +=
        'BvB1ZTMwKKsS7vKBdvpLc8tVw8Juf36YV8XT7N3LlRn+m0jU/hKxigSEzv5Bu9eJ+L8zEBe+zmd';
    b +=
        'w1wMEYjcXgv575r5nezTKXJYxe4ZY/qsYlqIM2chxY+K3s+FByLhG8AgIkDLGrKJoZgsd/K2xA2';
    b +=
        '5XSyGFfJDLPBRLnx8T7NReX44/2UHs3H+xPUq+YmvdoU4SD3aRt9OkG7OddxE9MsvtsFXAelZ6C';
    b +=
        'n07sYLBCEKRDGp3eVZg86NUantgTFmXo0Ro/G6NEWevQ29CjrzrYsyvPevLXQX0eTHvXoRr9HW9';
    b +=
        'KjbfToOunRDs0m0qNj0AqJKxhDhrPdgB7bIIiR+oynbTw7ds7b4vSZnmNefK1HW2LoG+e3rdajU';
    b +=
        'zpnUq9u1F5VSVm9V2ll+fVu2DsQ7r9LgUkmKHlJS8dTi0VjJ9WwsbPfZhAfWjp4xch2E/9THwp0';
    b +=
        'KU298QF8uYghssh+J3gG772VIYsa2CMkUOlcp+rlLTkfjGHrJTVMd7+UN1/aV6x/MzfEWF3yxtH';
    b +=
        'rRdsRCdgj6frjuMkCLHID4jS0+zpuGkQACU9/pQKtYfTmBVbrTOArYywff6k/CV+dVOIeu8mYp2';
    b +=
        'W4KvK+xX7XUlQNVTPtQCLae4DynNwPl5Va7g4gj/yYqsyITG8W2d3FiHzDkXjF5kAEury2NfOu9';
    b +=
        'OEYj0YpFK9RA0WCeJg+0izqktL1x5MygC3s+OJO1vcWpQHuYcM9LN4QE+xK2tLVGFZ5h9NLE9lO';
    b +=
        'N7bTu4Od3vNary2tN44d3LjrWWM7vk1rhD0iRjfreGM7XrV6e7bjTSd2vwIbgKrjjdfx43mn6vj';
    b +=
        'u6I4f8zo+qore5Hl0oJXb7Cy+FlOVGZHpzSLR8V7Prdbx4pDLdt44d3xbO571kG/d8ePyrfYltZ';
    b +=
        'frzHyCEawUl8gshge426X+IsKgrky9NjHVYIgYx5HmOpRhPbPwPsfYjCZVS8Esvl4UnOv15C41J';
    b +=
        'Rt5ptqlnb6BJkD1Uw3OSJC9IOZfkI4F4CZ9nbCDSqoAPx7hKkSOF5uKi2oqB2op7FlTFJJxy2iK';
    b +=
        'o21Qo7xz7y4RRXC8An1SozFYJ5JkNomWt8ltG/uO2ZALdE8Xyth9J1rlmEz7GazKcTFFIy7cTes';
    b +=
        'kD0IehrkN8/BTDXlhRVTrUa4k1Seu16WFi6q2fP9S3rDDCuI+sKdgjXLciDHV4FryfQpXKLZjqi';
    b +=
        'HjHMWQ38HBJ9BSNqT1w85HeuZOi4YRe8arf+2mq2N/o6arMZtpWZRiD+Uj5mPsuLX4jhWjY7yG9';
    b +=
        'JHxP0nOxoZqoignYAcGAcMk3DtymnGJycbYFC7UU/RNjMHgSc9ibSvaeJfR3hKZFW8JTBhiyvGA';
    b +=
        'CbtqHdat44xLsUMppgckm41pVKwiOm2QM7xGq4cRpYmkRZwMqHG1C3GCK0Z2YUqsGemrXbeax3F';
    b +=
        'WtVaUzCXWWsXHfJzveV9LquovqBVeQgyDPYDw2FhbQ1fHGlVLIZLDpNZziWsHhudQ1PQKQqQ5YH';
    b +=
        '8fMzhB04WWXIhzgSVuKoQRUBaWsZBFPIBvYOMEQ62CtfC7xSVo+Amu8E34zdK0K2QEiXNgKWkV0';
    b +=
        '3TtoukCL12vlsOImCZsI2XEcHuNWda5WXslAy1VNXNzlVZim1eFZ1BDzMzDe6lAYRDT4lcgbzPq';
    b +=
        'toxgHnkNPtY0ZKXR2bnAgsMAl+rvIlrMW+L/BSvRAuZxRnLFQbaVV4k6LlEK+YaFmW5ZAYeXE9Q';
    b +=
        'drH+YaIcAUyfSJx7otPOPEVnQaXbU0LAJU9EkTdmG0iZMNSF73Lh1jopQbeE+FYdJgSeVSWTDl3';
    b +=
        'crI03e7TRtAj0K1BMwNvZqOYT41dBaccaKsPCTPVU+afxP5ZMh5ZP874ryCYYmK5/kX2PlE0Zsm';
    b +=
        'qaGdconjT2Qgu4uMLOsQfmkjq2qyifDxNWUTy4Eqvthf07PMpHVPqHpbVj7JK0i0pr2yegI1T4Z';
    b +=
        'zEr9Bw8WIdQdK67eeAooPdRZL5D6ga4fyPzApB+Y8gObbUDMvW1BGqye0RxUz0DZijDbIhWxf7M';
    b +=
        'tqq4TSh/9DZRWhHq2tEPKC1I4Rul2ygu0jsoVVYunwhZDDLgYLBEA5lmB2PY1VgN4vnL+jF0uUV';
    b +=
        '7wKKeZ8qJHOcOUEx7lLFNe9ijnmHLSo5xnyise5YIovniUi0x5zaNcYsopj3KZKac9imhonPEoV';
    b +=
        '5ly1qNcY8o5j3KdKec9Cp0w0GYe5SBTLnqUw0y55FGeYcplj7LMlCse5VmmXPUoR5lyzaM8x5Tr';
    b +=
        'iaeSwWvUr3T5IIVLobx2J8TKsinfCR0LB+6EslXuhNLV7oQm7J1QxqtXm9esjq5ZLe9OqIdJje+';
    b +=
        'E2nmLVk17J9Srr0F8J9Rxd0It/05ooroTSu0KN7GGO6HeLe6EWKOuPXAn1Kah8S9exc5pxJ1Qa8';
    b +=
        'HupzDtrnIn1NY7oc7wnZAcfBq6u4eUlYWvhd6aNyGAbfAJA8J22nSy44t8Sora1JNYwMXFQcqCa';
    b +=
        'SzYt9S9dd1b5t4m3duUe9vs3nJ965YtlNVtfWgp7vI91i2uZjpyNZPiQoLeUrmaSZkzUu3ZO7B8';
    b +=
        '38ne6BDcgmBO/d7EDU3Czt1qQvxtVojfye8QxzI9EeP39GqmJVczOS5C7nRXM63hq5kt/tVMfy/';
    b +=
        'tSuhbezXTUgZqLbIM317NFBDkt+RqpuVdzdyV9yDIn1FBPo0m8HlHZdLN/C5R11tHaYWZNtJb3r';
    b +=
        'LM1IN8euTVTGvaxhMzjQHoaJ0K+jd68RgmTjGzx8yEc3GhzNSxzkafh1sSOa724PvEE+83HU8Rn';
    b +=
        '83wXqQrngXTunh/28ClzWEz8tKG9pmUQbs/gQsbnjX8K5tMrmwyXNm06NF8nHZyI65svN7uDl7Z';
    b +=
        'ZP6VTVZd2bT8K5vWKlc2E3plk464sknrVzZpdWWTDl3ZcE+3padT9PQ66ekepZWeHoPAz13ZtOU';
    b +=
        '8tgG3O6OubNr2KOZdNftXNrWebqsWkruzwS4QPZ2iY9vc0222W09X6+mN2tOjLnK20XLwJ2Omww';
    b +=
        'hy4c4ipo8hiBPXjLRedAobvBC8l88/wNyAiF+814yFYcBe89TJQ4pDjEiKGiopaqikqOGcPKRWU';
    b +=
        'tSoe77znTx8rdz33tp9q++KrjzwdpYWN3mkNEWGK8d02qwu+PhCvAcPqz04bzJHEYe02OT2hrra';
    b +=
        'WrFEkLu7u6Um36Oj5fjEzf6plEVENmaEN1hW07BXgBSpjjVhmM48HovzQr77agqPdyvPDTEL+OS';
    b +=
        'msesT01HELjt+aFREHhPWq2Fc8+XDElLa64h9X4ytkX09XL0uVa/XjHu9Ur3SLrDugCjG5nHAAV';
    b +=
        'GMTeeAA6IYm9UBB0QxNrl1B0TqQD6ypzaafrN/zG4qRNGjpU4/KnmRwqE2+LxVUcVHYmqvY/2oK';
    b +=
        '7oL8Kg1f5ls0K6HLnsScOt/6Nb/0K3/oVv/Q7f+h279D936H2P9j5XH6i46WV5b7UHlvNeGAl3b';
    b +=
        'J6ajiHLI9D4fcPWxxAjSibjI4810hJ3da8bbTDPllEd5himnPcoyU854lGeZctajHGXKOY/yHFP';
    b +=
        'Oe5RjTLngUZ5nykWP8gJTLnmUF5ly2aOcYF+a3J2O9jKnuupRTjLlmkd5hSnXPcoKU5Y8rezXmH';
    b +=
        'LQo5xiymGPcpopz3iUM0xZ9ihnmfKsRznHlKMe5TxTnvPO5xDLlGLlmQiWscwcMQ0FQd0LRaGhp';
    b +=
        'zqhNay73gB8YQ8j4GZeo9iOLHuK9580o7q1qyMIrWWY/XToBaN6sFUP5vVgxkGFhzXWZ48RHS3c';
    b +=
        'O7Ann5wJcF6nr2O0UdNXwXL1klkw10AJHd4+4ID2e11r5H1lwMh7blUjb4zrcjZ7Md1UmXWzhvF';
    b +=
        'c9hJoDKlx9PirgSNAs/PST3sE6FUi9KKN7jfYYJpVK+ecwTQinEW1M7nUFKzou4JP1WR6rm4yna';
    b +=
        'zJ5nfON5leHrD5nVWbxOXXYfP7s5/80o0bNz5+45cPsOE04xrUDX+XRxtOouVuaTg55wx/X08ZO';
    b +=
        '7aBtNl8y+knX4/lNCsVu2ZcWaUZV77CZmzxmjxoP70y2n66asab2E8PN+PK67WfftKzn54dtJ+u';
    b +=
        '29bOjTSgnhtlQD13U2PYNRj7ylXF7KCx70rNgnp5zca+XzHP3jw7v2BrMvadu5UF9ZOjLKiHDbf';
    b +=
        'nviqtulxr1ZU1t+rKV7dVV4Zadfl1tGrHn49lfcNFR0MncbGnrltFX2Gr6KVuuOlAF2vKirHeRO';
    b +=
        'bEmQgvZY2aF4A51vjJPSJ3Bv/JG4woruHsi/AcmItjEIpSFyEV4X18wEI16IgFSQEdsvp8hsrpq';
    b +=
        'I+Dluj+TfX5GDfZ50NW1u/xgas/xkeu/jiuRPi8RgUL1e7qPcUEH/qKdXzsK9bzwa/g89rbiw18';
    b +=
        '+KODO45/xUY+ABZ8oHu4uJ0PgXB1ygfBIqspN0wX04KWWd648Ze/852LL+WZnPmi6Zf20YbjZz+';
    b +=
        '5n2j0XmxmLZc7jkNvcU++meZXqOzAkcAmqFVMv5Qjj9/5HspjX34HJ958vBhH4kzS0iFUUPw57Z';
    b +=
        'dufOwvDNJutmnHkHZc0tKpNZ/CLTWnff7yv/vFA7W0PaQdk7R0zM03Ap6f0x77qX/3y41a2i7S9';
    b +=
        'iQtrh9uwyU3p/34Tz37XD3fDtJ2JS0dpPMNuIXntAd/+P/9SD3fNtJ2JC2dvPNJbJ847R9+6l//';
    b +=
        'SFxL20LatqR9OzsPSDXtL/3Ofz1XT5sibUvS0tk+XwfREaf9kd+68ZtRLW2CtKmkfRelnYB4m9N';
    b +=
        '+7iMHz9TbN0LaRNK+m9JuZqxIokVCe48qxDCvfyDcBCWfAFpm/c3ivQivd0DRR17vFF9heN0CZR';
    b +=
        '95zcXJFF77UPiR14LduuHtLnp7mGkz6t4AjqUegKdpXJ7OESuCIaOKmUx5P+u6RZZH99GrMGZMj';
    b +=
        'Hk31+8e/nvvcfqcanTP8aIplVKbyRywh47l7uXEM9p8cZUS7hXuopSO4WY45V2abVKlhB+4AtIg';
    b +=
        'y253ccpiOE/4aOhTSsdsBafsD+f5AqUE0pBjtT6nzIfzhKOHLZTSMVrOKbcM5wkndndSSsdmWzj';
    b +=
        'lncN5wlvEHZTSMdmddsQP5nmSUgJU0rHYHTUW8/KEy4lBNsMlXRPhu3UOWbaGhxFfB4MFG3VfKh';
    b +=
        '5jelFBLdJk/1AA92kF+HTX5BDdnYhEf06UX9wCkLBOy5yoIhnPvojdk7AZnXi8Y3FEwmuAGIJiq';
    b +=
        'v5rNa+1imBOepJ4qkZLrAVnVMjtx1lD1f6UM1XFzZWWsL/Jmav2p53BKo9qKSePaikpj2opK49q';
    b +=
        'KS2Paikvj2opMUY1lZmGNGuCsRcfz7oMvob5wJhoPP+VLujWkdzzbr0P8m72vo4Hyd6DwtzttNJ';
    b +=
        'ME+PdQQy9hQZKnwbgXV6iqV2wl+BfjBhXe9Byjg0W2TTTa9QVll4xa/mlF8WkupUb65WJJVtdKc';
    b +=
        '/Pz1WUlQQr+hVWcrTxXAqrQjdARfZs7RqztWvM1q4xW7vGbO0as7VrzNauMVu7xmztGrO1a8zWr';
    b +=
        'rFoWLJ9a8z2rTHbt8Zs3xqzfWvM9q0x27fGbN8as31rzPatMSxb5fryWbOa+DeRK0e+JPiOfkeR';
    b +=
        '5Vk5MpUKOUWttlV12J13FvP2bif9bNuEYzn0T+G00apgUcIxTZgurClHRZyfEXlqLrevHA9dLoD';
    b +=
        '81UtIDe/pfsVefqpFxvdA5cwjb2VU2zV/FQJKDQcBKKl6jJ/4bsq8zvcnoXgEDaoyPivHw6yM25';
    b +=
        '4ay7FN9cAcUrFtXJlzepyHYLNuU8o3Ij9u/L6NbE+gYHVlMfF4bOPFHUGjFp/eIh5+kFfPn5Xqt';
    b +=
        'INVBafSEtcBqW4IegOODBI3xkT2Wk8gjgxWySECW0WWrSDIpGXmwz0zBu0C8aSyDkY+rEmA1SP7';
    b +=
        'R/xNvw2RhGDb4oRmAXYjmEW0+H6o4SDWGcsWIjfozwNR2yeGo4jRIJGVxYw2Ut6y56hosYDq+4j';
    b +=
        'fw+1X31ghfqIf4L6ElowLwbcEqpRP+1EkBw50O9uFJuBbsxigsDjo0dDaLir32G4V41vDYHuYCp';
    b +=
        'tSOONwxuEXYBbF4SleZw1wNkVX/9ZgpMW6BwNMYNiuFCE+iqlfprC7qD6K3EeRQ32NsW0BYwF2s';
    b +=
        '8maf94XTfdF0/viFW6UGOCbCb5IvC8S90XifSF3GDEgONf4xWuMahwDiHONX5ziy5AYcJxr/OI0';
    b +=
        '33vHAOVc0xdBvk5vKpj9Y8EgF4tcNiBko1zWZ2W7XNavZdNcvqtm69y8x2+boRhWQQbHYp8bO/z';
    b +=
        'l2OEvxw5/OXb4y7HDX44d/nJc4S/HFf5yXOEvxxX+clzhL8cV/nJc4S/HFf5yrKDLzM1PWWaGK9';
    b +=
        'yKlWkT5THyYQ0RG1eoBbFYBLMvYQwUHTCjhko1SKrhsdrAGAGmOrWXHSpr96HnAN0jQ2IN2KtAi';
    b +=
        'ojXiEELYU28Rgxa3NvHa8Sgxa1DvEYMWrjVjdeIQQu9kXiNGLSBeBfI+V7v54xMjH0O/byGCg79';
    b +=
        'gobuwsDgtxmm/6LS7+bQL2noHg79Gw3diyHEb7NM/2Wlb+XQr2joDRz6VQ29EYON37Yx/d8q/T4';
    b +=
        'O/ZqGvoFDH9fQm+D6bsx80wG9UYlxo2JVv3IjywAG83tg+wWBUhOPd8E+GQKlNh5vh4EZBEqszf';
    b +=
        '1tNHVEECiN4fEwbWIjCJQyPO4vJvCYg2PW2XBbsR6PWfhSnQ1nig145HDZia7YiMcUPG2iw2/HI';
    b +=
        '4NYCmw1jUdabBYl8jtEe/nO1XBxelCWYK2PfsoOGg5gR6CIbLirCQUlqNjicIKK3CEFFX2HFVQU';
    b +=
        'Di2ouMvhBRUzDjGouNthBhX3ONSg4l6HG1TMOuSgYqvDDire4NCDijc6/KBim0MQKu5zGELFNzg';
    b +=
        'UoeJNDkeomHNIQsU3Oiyh4pscmlDxzQ5PqLjfIQoVD9waU4ja7k6Z3bXNiP0Z2CBvMsxB3mLQg7';
    b +=
        'zNEAh5hwER8i7DI+Q9BkvIxxg6IR9nIIU8Y1iFfIJBFrB0AFp6PQMw5JMMx5BvYHCG/DaGasg3M';
    b +=
        'nBDPiULxe2ycmySpWRa1pbNstjcIUBu0ByB8xyHFXGyptRgYVZ8pQYLyOIrNVjoFl+pwYK8eEoN';
    b +=
        'IPmaGDRhQ86sdipVwyU+XFIwcAaMBOgCV6mjDodpHojySWVSRfVScyTvVMCYS8FX8Uw4wAxf4Qn';
    b +=
        'xWT0nDubKApemnsHZEZxvFhZ4EvjGEE2MpyjCIwkATe2sE7Cgxuj7oKXanP4J1E+o/ogYGeEWZO';
    b +=
        'D3YpHkaw9Ygp9zIiTtDfjPlT7E7a9qnzwgj/vl8c3y+CZ5fKM85uTxJnl8gzzuk8c2ebxRHm+Qx';
    b +=
        '1Z5zMrjXnncI4+75TEjj7vkUcijL49cHlscwNCQKR930WBjVGn8RjdDfVVn16AuV5GucR0wp+0v';
    b +=
        'Ic5b3HfHruHd0TeoyYfkW78nbDc0RvBPyHaU/hcdkb+IZLBpMfpCWhsPQCOBVk6MYjbL3ZQ3ypV';
    b +=
        'gEdOk6Aw2yrcsOiPtGFrcsMaATi3Od/IM9WnkiT8yIvqoaQLNnj8OBAKHsr1hFtUYaoFe/mHPbP';
    b +=
        'p7D34TKHBloMCVgQJXBgpcGShwZaDAlYECVwYKXBkocGWgwJWBAlcGAlwpZvcsxMVaF5RvYv9o2';
    b +=
        'CoAwB1Ku5AjNNnJHzs9oz40vv++Jvv3s1HhYNTTkBFpZORHpjwZ7hPPgHTqFgWS+4LYTwSGYsP6';
    b +=
        'TjnHZlBzC84aPZQ7UC1WzKzFXxqRsHPsfhdrRsQ+7WJDPzZCsSJOxJGRH8ma7jTrssYp72MMm7a';
    b +=
        'VcG1mFtWZOEuio/IiJhCZ6MsDogVbk2rHu0W2jdPk7l2e5Jv2fBy+7MJdDl9x4YzDV114ksPXXH';
    b +=
        'iKw9ddeDOHrTyedp8cPujCMxw+7MKzFDb6vm33rp5Ui46kXp2cAq3UY87VQ5VrU3l/2JVf1W8ze';
    b +=
        'f82V25V0J2S97e78qoKby7v73LlVCXfWXl/j1dGeyVdLv0XlikOoK8ypJsHuRrqpQKvq4bvM64Y';
    b +=
        'j/Dj6uuc4R2FNmDda5wb+8jlJqCQ/m8q0qN6x4UmwF9C142/dvO4Ece+2bcCE2N/P+6aAcVKBxk';
    b +=
        '5Qk+YSzdCVXiILtrC9XwGlCzZNbxb/bI+RcWPsQZxHu9knA5Iy+D1xizypdZuTV5EqtRmWKmNrf';
    b +=
        'KfNyUPFQGju9o1XSwzK231b0q1vg2WAzg60pvsZpb+itjrzo74GBa9CVbcYDt9q3ZnPXNDh9AoQ';
    b +=
        'GYbPcWEEd0UlRdarBRoc41r3cTU0KVdiW2Isz7BXrXCGveIN15JvsTxq2V9jIWRjYoF4LW3aJfU';
    b +=
        'EAdfhb6+Qwq18eJXXFZw/zvkH2uOXm7xgpNWD1D5b1tLCdt6djYP38F0fDWef3PJY9TX0iTyHRx';
    b +=
        'kd9b4nZS2+hY+mLvK82m58t1Sc8G9HKyhX2e2vXYds8x14FMErPKN5xJcEg58aN2Fe0XpDn1VFQ';
    b +=
        'DWFktHRnXK2ruDDfqHumPJuS233QG1X5THdkSVIhr5XdURnTV+MbrefryYi9Rq/wxqnw7VPh1Z+';
    b +=
        '3So9uIn3NYRt44NduZunK93m8aM8DAudcTA6qzxi6qO4u2ap2Q+yoxKXdWo6Tig1k+OeQeotfzO';
    b +=
        'JHbisQ7L/WnIiE6mPw2F/E86Qj5Xz9C1o1ukwC8O/sP6mXeGthGMq2Bj9YuRPnQ/ZMTcmjujZiI';
    b +=
        'SOjfaiIiGwP5HRbC59XBWfFlkKq/VmPQGVaFlqvR0nO2cSJlpoSVQ0hSvIUrAIeGkKLtm7Kv+9S';
    b +=
        'L1b/VJlfs1M5TfSlsRGXpW7SGZUdPGFTjcbVVuRmADCR+kLpy3qjfrbSTlHdyWd8Q7Xu/RRI6aV';
    b +=
        'MppmLcBhx0av+VJerbE3qA/Llr1/YlyUowd5eCRyMEjkYNHIgePRA4eiRw8Ejl4JHLwSOTgkcjB';
    b +=
        'I5GDRyIHj0QPHokePBI9eCTQGXwbPXwvdlSEmhe7hyjse7Gbo7DvxW5WsntGs13GcxZDO812Mfz';
    b +=
        'z7AJk/gl8LX4s0sjsH8kLbbmQimnlx6KF0mS7+P5WP4KfmJOGfwSvK4Z/H6+nDBcNr2cMlxqZjM';
    b +=
        't1QQKrkVma1Kf2sGdmK/eOndw7Frl3eDSUxNvWkvg5TTy3lsTHNPH9a0n8vCZ+aC2JX9DED68l8';
    b +=
        'YuaeMdaEp/QxN+2lsQvhzTpTdBckkl/vUUY4FIoz8v6vKLPq/q8ps/r+lyKlC/1eVifz+hzWZ/P';
    b +=
        '6vOoPp/T5zF9Pk+7hH4KgJy8xRvpJgNkVCfGBh/sGnJaTWvHxYEo/6w4ELWPbTP5oOjF6EERCro';
    b +=
        's72P/3jG79P4/RQAIh+dC+N/KvJ+ikVHhWao+rcj0vB7SyknPa6HYPF0NAZ48S81H2yh6Xg5hOD';
    b +=
        '9LzVuMVVcA7Gh5lIvotriI7oiL6K64iO6Ji+ixr9xFdNu5iG47F9Ft5yK641xEd5yL6I5zEd11L';
    b +=
        'qK7zkV017mI7jkX0T3nIrrnXESPORfRY85F9JhzEc2NCh/RepTig1TA3Ols2mchEXNQGxpOB8Ld';
    b +=
        'gXA2EJ4cCE8NhB34RgyFiljBN6BZJToTv90NJ8TgZynVs1F5FGeQckZsc1ju9mD4SsyQahKbXTF';
    b +=
        'iVosLJNpuPA7xXM+IQjjukejwTPsY0Qtnz7aCKG++xSioOnZu2ffEzve1XDu12R223D2F4iEbF8';
    b +=
        'on/tVK5YNxx87yBT/80EJ5zA8ftYG5vC02QbAdzH434aswyFCg/g0ZMUSBbKl4tPqerQ9P+OFsw';
    b +=
        'f89tmL0fw8H0QVx7zz7Xlh+4BatzZo5IQstD4jJEuO4Q+n1RCwntlNB5eTyhVgOmjt2OtIxhkBD';
    b +=
        '9dwvwTZne3Q0ljs9fsw8ojXM46qGHe77PgdzrSSb8hyNkRFQWPJUc+2gT5suMEUb7aGaheW7+Qp';
    b +=
        'P7Ci+kh5hpmkJxiPaizN2di15eyHj7qf6ZC825e4x5p+nTpr99sK8oxcKap9Bpfgz+iJUpZozwU';
    b +=
        'L2pUTbrsG+Q622EHuEtG13NJa2eQ6wAIJn9NYebOdQpKIFWOFEfqGPPfcXogW2afq1xgJmS2qJt';
    b +=
        'ux8894jvZBtU/v4+cMs9+B9XTEpNV9iEm/tig1CuqYGdCDdJu3MNlQbt0dXsPd9IYJaon5/jBVM';
    b +=
        '9cujFJjI9RtKvoyWOhUNdMZKtFDvjZPRat1xIsLyRLWhLlA7+Thm9KLsepNahE24eTLgI2P2zcJ';
    b +=
        'D8+Z/7bHLgK0m2G5wDTiFjXcDVbcUACKwYb2jpICcgGm9Upr4aj3V3QYzVh9yQUxW+TobJH6Vt6';
    b +=
        'i8RG26HiGuDB+iXQiWobENEVvj7Qx7R+Dz1pmIGaw8iXMbjY3sLLjkMFVw3LXOEoUyF7pG3034A';
    b +=
        '3A5on7CnDgrw1pa5ySfBa5Q9v8iFkbUeXJ33qFajT3ai7uNjgx+yyNu5FsOcePe8kfFHcK5/GMm';
    b +=
        '+2Uj/aE/McMmN+X7w29B8+Be+DncziW0PdFvsp9rdBPIwmYxjGMMurgbdPCPb34OEkNkH0hwtFr';
    b +=
        'lc53YWY+nNq13eFHITrAIKh1YTxK7nsjIqK8nL0Z2PaHY7L+tYT1ZNv9zPRmxnhyLhtcTTBUD6w';
    b +=
        'mNgNHryeHoda8nh6O/8+vJJxradiPXE2m7w5G0zTPRmtaTz4SynvxYfPP15JoZWk/kkqC2nlwyq';
    b +=
        '64nF3iCCr31ZDn01pPDYX09WcLyczIc6IwT4cB68kK4WnfQMXMN68lhK/qS9eRw9DVeT86F/npy';
    b +=
        'JvTXk1Ph8HqywpJ8luuthLKe8LyM9eSTDV3hq/XkSuivJ5fCgfVkKaR+Cqv15LCd17G2UfY/Uq0';
    b +=
        'nmCcnB9aTY9HAenI0GlhPlqOR6wk4l39M1xMRVOInhteTZyJZEOw3X+Z6MuJzfz2pTeu19STBen';
    b +=
        'K0ZyJG/XGriUhTQ9+XlxOzllDrZOHfGb1gK1j7gK+4tJ7Zp8KvD6ySaACrJOHrhgGskmGixSqJb';
    b +=
        'oJVkoh3tQqrJBrCKomGsEqiIaySaAirJBrCKomGsEqiIaySaAirJBrCKomGsEqiQawSmQFrSCXR';
    b +=
        'EFJJNIRUEg0hlURDSCXREFJJNIRUEg0hlURDSCXREFJJNIRUEtWQSkTO7jiYuNNKk2moPMXC9h8';
    b +=
        'yLp27IrhFuguNVdLZBEuttWV0rLPGgvXWWLDxWxVs3RoLNrnGgt22xoJNrS3d0vQay3fHGsu3ZY';
    b +=
        '3l66+xfDNrLN89t+iIlVm5tR5OUuY6l3kZshLCKulZjaeI9fJGavPfg1Vzz1537mtEycFVgEPCO';
    b +=
        'TEIjXMLrBy5QKOV6fc7YfeAwUnnQqBmrbmBXTT9mdtXZG8O59hq4H6ajpUc55m4BqHI+znyIdpZ';
    b +=
        'amTqRT7EkQ/TLl4ju17kwxy5Y2eRamTmRe7gyNeodVsaO+nFfhvH0o67aGvslBf7No49DWtWjd3';
    b +=
        'sxb6dY2nJLroam3uxT3DsWYrtaeyMFysGvOcodkxjZ73Yd3PseYodV3XpbRx7HO5P3uM369NIrg';
    b +=
        '0d59ysSDhvPrCPo2KJos3kUFQqUV1xRlOL6kpUlqdDUZlETeatoahJiZrK20NRUxK1WdzB1KI2S';
    b +=
        '1QuDnNqUblEzYgTpVrUjETN5mNDUbMStS0fH4raJm6fjXiloNGT/T85ezeZgx+cPaKNeD+jveLU';
    b +=
        'kgCN0pRb1DsMeFOUzDg1jRkX8/Cq3xBXrvLNa8GqH4EfV/nq9OpfnVn9q7Orf3Vu9a/Ou6/q31j';
    b +=
        'VY25AXHuX0s6ANNrJjhDE6NGoCxL1dxS9pFCGArW7+NI+5d5AEAr5UMl8GjttKSSr92H1U857Td';
    b +=
        'mVnV4eCEpDhDaHDhz9hP0FxgwxlFlQn3ViiUttnD/ppBLXtXH+nNOVuMzG+VNOJnGTNs6fcCYlb';
    b +=
        'srG+dPNlMRttnH+ZLNZ4nIb5081ucTN2Dh/opmRuFkb508zs8L8dm4R9E2zuADlXFaxoUn9Zzrm';
    b +=
        'DexEIbKeftSQv1kZ8qeVIX+7MuTvVIb83cqQv1cZ8o9VhvzjlSF/VhnyT1SG/OvEkH+9tURgdZm';
    b +=
        'WhW707YfFul6StQbshMO641foLPYnvwZYpc7+Ph5wkOvrqhtryC+q7qMssWu68OyJVoEjvD+JdV';
    b +=
        'ekfm3mBkyyNeO54XwFYWLbQBtu85zsauZXrJPeOpqA/WvrUZEaq5JEXf6K9eo7aFYu0XMLfuI5Z';
    b +=
        'xjesg0kCpwDBumWKTyjcmkyLslZZpsme7XpMJjhGPDS84l8Xb5+VUABOVfCFdLS0vMnmrsX82i3';
    b +=
        '2nJyfhoJy519u2kuc9Hn/egPLZ354/216At+NGyBklr0RT/6D0/85Bfr0Zf8aFgXNWvRl/3o3z/';
    b +=
        'xy79Wj77iR8Ne6Z/Xoq/60T/8i89dqP02m/aE7Bqq4+hnwOjX/O9+6Dc+8K5artf92H/3bz/1MV';
    b +=
        'NFjzYU871bKM/wSsPuTSoXNpRJc7dzKd+0CT1fN02XMNWE6cKaclSTe3HRObnLW/giFWkIJ6u3j';
    b +=
        'gqfXiQrRcPxvjitrCcAztiqOQxY+y/xzfUfdc0ET9UtCyrGmnPZd7CuHWaADt6h8qra1KkoSVsL';
    b +=
        'MXhIStn3tXplorlqpSkyHDhdCLeGrzW3C46MBE9r8CBLCcOzGnxGguc1+KwEL2oQvhAo58uas+h';
    b +=
        'q4696jQoVkyWxBQlZhIPRHloCDiktBi21fqxCPqc4r2kwDRXycixI22HlgStkcUCoeo4Rq44v1S';
    b +=
        'icCLq5cUWsaQjG+pk0pmRX9ykVsl6h7wDL/SzgHdQzmOQiFPx1P36W3TGg2RrSbOcTKNoS4bISL';
    b +=
        'iaQZBPhqhIusy9vIlxXwtUEEm0iHLTdliwIQNszTbWQmA0vNGiEJhVfNG1RImvx5MokXrbatuqx';
    b +=
        'DUk7NwUVsr1KS1VtFKrUpmopoV4QJV4vtaXwDzzbZDY6qJV7ToLPaPB5CT6rwRcl+JwGX5bg8xp';
    b +=
        '8pcks+GLDtcISvS43q64I2dPZQMdV3TfcNqhSQ/3MUeemNiTsyijfTBjZNlWryKeDXBQqVEpVoC';
    b +=
        'WvNUcXSL670Kh/J7+x1KhXr+I/7Ru1hwhZU73hVari0pF8yxx7Nt3O4PmYAviVufQivzJ/XuZX5';
    b +=
        'syr/Mo8eT11vXEmtTwZezwZLqyhyMOF1QbymzRdEFgnjybp9at0wVbQUrPvCl1xNNNaPzW4tQZp';
    b +=
        'jVJML1g+r+MrrmrRdTzlU9PhYcIqx1DIfNqJdDocYtFOHlVSnRoB02aNcGKQcGGQUMl2pNyQi9L';
    b +=
        'a8htdUzhfAzMKJKKmSHb54M0gm1ckzkxYFs4BiKqm7hs9O8+BPSkbodls5jB/Cyws9O7U1Pg9dH';
    b +=
        '6gx7vp7ECPd9G5gR5P0JmBHm+n8wI93obzAu3haY9Pjx39DXg83L8Nj4f6G/G4vz+Fx1z/djy29';
    b +=
        'TfhMdufxmOmvxmPvH8HQzX072R0h/4WBoTo54wh0e8z7ES/YKQKAI3RHr8/w5AY/bvzGFq8R0N5';
    b +=
        'LuvzsD6X9HnNyPMKnh4QPsyoayj4sKWuQeDDoLqGfw+rah/8HpbVQ5D9Xvu+D4C/gBVDf8CCCy3';
    b +=
        'K7cmtyW3JLcntyK3IbcgtyO3Hrcdtxy3H7catxm3GLcbtxa3FbcUtxe3ErbQKDgD7DoPbroZ1Zr';
    b +=
        'ii+7by2He9ip0bBqGHubSLPYdyoi6DvAArWKzoptXdzq2TdHdVPyXoWVCW9pLwLlI9LbqW7Fj+Z';
    b +=
        '9+VTXsu+vpqz0S9RqR2w2wrWS594FWAhPkbUJbHdG2iHkPl0OLV9Z0ooT1vlaS7q/opbfKGNrkk';
    b +=
        'Ue8SI9uzoewZCZTt11l7Rj5/Nm0lgTd/Ae3ZhkeqaLryBLKr6HhMPMv+ZMTpVDQtSdJbJ+nuqn5';
    b +=
        'KnIY6F1bRMH8G1o69siFUb718b2zdBufVkZb9i+EPvXrn33wy35Dflm+Et8ZRGIf5TH73agB8AX';
    b +=
        'IM2OkKHdq27O1c7pppu5TIMYXtNB32pbcmLzMK/vJnVgJrzunH8gokgpQBuYiNq1JgQAZCEawOI';
    b +=
        'bBCArIvmvnAD+vfwKOLRSaDjH9ailSX3gRsh6x4SHH5r587J9APgFZpCBJfwOAqbfH2GjC8ijrK';
    b +=
        'ChhghfEFx+HSjgIZAhPweEeBdQish0M8CkwisAH+8ihwGwIb4U6PAlMI3A5vexTYhMA0ZHxPFpt';
    b +=
        'rTnHUD1qrPP17r3zf087BUaf84q9+5BeMhrt5r/ylP//Yz8UaJo4o/8VPfe7zoYaJO8qf+PP/+r';
    b +=
        '02njil/JE/+5d/ZMPENeUXvvgT/yHSMHFQef1Dn/7u79QwcVP56at/8qP294izymM/+qN/2dRwk';
    b +=
        'G8ur/3kv3/tn3P4SW1vhjytg2GnQ10h4ag8MbKjBJA1qHVuHcd1RXnGpwZD+TeHJIojMwkUacXh';
    b +=
        'dg9zqkOPre+UBgtOtOwDYT8eGRnyJmmFR0tSN3gbHDuMEu4zLiyKCxZOLpsiYofvTpjFAuRnlRz';
    b +=
        'vzmOJUMn5UY1IXYSKzZ/TiK6LUJn5MY3IXIQKzJ/XiEkXodLyFzRiykWoqPxFjdjsIlROfkIjch';
    b +=
        'ehQvKXNWLGRaiE/KRGzLqIWYl4RSO2uYhtCjwn9DlH19sjxjGPBb4q4EjxjcwXSByZjop8WCO7o';
    b +=
        'yJ37JTIbFQkbpI4dnJU7CkbOzUq9rSN3Twq9oyNzUfFnrWxM6Niz9nY2VGx5zmWOW6bqFqC4WJx';
    b +=
        'Is2Ym8ye2YIF+8wWdsPMPeFjCrD9hobKwMAS/y3HOqZ54O89fElYjsM3onmEtyzq8AxIMWhnxjK';
    b +=
        'qRI+J3sXFgmsa1+PSm8Rh9zwqT/WDZhFRm4JBNlSUBFvQiNak8JEiGigPG3/Eudg5D5Rn1TgpTy';
    b +=
        'wZx7Xd2GB5iFlgnFZGj7BmsRaLaxrJ10nNXXn9V2tx6U3iurtG5zmiRHRUX72F4r/5FlqJpYWSr';
    b +=
        '5sWOpNIiRpfNyW60JASNb9uSnSlKX7HtSgMZiF3DbClfqTw8m0MjvtaXHqTOPYZyOOe2XNkeWQT';
    b +=
        'pHcfACyxWHmdU+0wPhBZbygGd8y5OMIqQvkqzroyvat/LB95SFD5oeDdyJN9XLtYXMI0xWS88a6';
    b +=
        'XsITAJUxi3YNb7zSGvdMYcUKk2SErJDz6oviWKRrv6uH+5H0MW5w32HvOfMDn6ZGl8D5tcpGelo';
    b +=
        'I0qSANLgj7kqkXpqN7wLiqoZaN3YypB4EF/qZvrKsxOSHh5+SzWrH4Dtkrl83jyyuY25vil/hH6';
    b +=
        'pWXPAf6IJCfeT19UJXxy+uEwXJ8Rb3ADka6fuGsrzcpmF/MBlwX+SUL1tBAVelu3Ua3qKfzp7Tm';
    b +=
        'HsWVlrooYiAvL38MnqHxFK6xL89VTDsrds9VR1762Zt05K3K8fr6clSzqcenL7tqX202deV4nWy';
    b +=
        'qnkW0G61XkT/pMNw7LUNOSB/bq96OXvWO+R5GYCzYoWO9CtpxI9kVQs2xY9cqkTA+PfKUT2teKi';
    b +=
        'zyUaJ0FjVdcNA2E9Z5haPbv/UvliL7G6EtFi4t4DfjSmzPyEIXgEh80KtdKFiK1AnQ8BXRlbjF/';
    b +=
        '5xyjMvuQjDkfaPmlMBpvNDaXOVQYaTG7tSf5tY5i18wT+MHlzrqRkXaQi6u21L0QJ3QxriScVKs';
    b +=
        'HzfeDYrgXtlrl3rOMe4cKZ3G69WtXs0YsQNp1m5mBBknYTRM+Vq+8py4OHzNxCKMyiXPuGbLYKd';
    b +=
        'e3Bzuo0dFZXXdJvxtu6KLcleDUTe1uOItO7M80eBrdZu+gthUCXw7H/cVhEbFGB4UwDaSbuFqc7';
    b +=
        'eGjJEkjXaCr0lDrwkbtgihvI5ovcYqrSeFYW63zdD1i+k8XCCm5TN502oyydih6kzYnmOKz32us';
    b +=
        'mA+rWwwxJuBSM1SFYMasY1ZAde9xrsM3zjmFFN845jTTPGNY84wxTeOOcsU3zjmHFN845jzTPGN';
    b +=
        'Yy6Icp9HucgU3zjmElN845jLTPGNY1hrxoWucrxvGHONKb5hzHWm+IYxS4w75RvGHGSKbxhzmCm';
    b +=
        '+YcwzTPENY5aZ4hvGPMsU3zDmKFN8w5jnmFIZxsQ4XdAk/wttCDRwoGf3HAFfQGCb7bbc9i11b1';
    b +=
        '33lrm3Sfc25d42uzdrstWAyVZDkab4TPG1liJ4RdFj+9dYjFArkD0lf23lCLUi8aH0ayxIqBVoq';
    b +=
        'fX1IEmo81Hn60GUUOek3teDLKHOSeNfe2GCYt4pOCq7NmVxgkU+DQeRT0Ho/FBH4E6Xxd9quEMw';
    b +=
        'tWGGCSfM0Ct8MHxP+SZGWo7tqT7xMKoM+++hcjvc4sSDqQpHxD6NiVPjIz++Ebv89wGjX9PEfhp';
    b +=
        'BrWL/XA5tGSBaiT1FFKZWvMD/2NTKZgajnh5dbKPlGS6wQmglLA5grXmHsvyeEXDEpenHX2+QxM';
    b +=
        'ahQZs6cvLfHhRo6+LRq1IdZTkevEDXTXftrjR7LgSscUjMFXZydeNr3DXf/UXsbvYeAvi3XuY9D';
    b +=
        'E7Q+7sdAFbTK7tvK5rulu5tReou5t5etNxd3BOAHdHrt3cVHXfj9u6i6y7Z3lP03L3ak+Kfg97+';
    b +=
        'D3HYQW//VDx40Nt7xaUHvT0lPj7obY84/aC394kXEHrbJ25BoNppxFEIvR404jqEXg8bcSYCZVi';
    b +=
        'DwR+UEW38cf5twyE2n44Y7TaPvavzaR6VMLU0iyLjyP53gYgG10eA5mf3L8DmR1ix+SOLzW8Um9';
    b +=
        '8oNr9RbH6j2PyGx7KqmFDfQUnYYfNzjoPo/PDcFv9tueFSmSWEE53v6Zn4QG7eajE88bvW61bgv';
    b +=
        'G4FzutW4LxuBc7rVuC8bgWV162g8roVVF63gsrrVlB53Qoqr1tB5XUrqLxuBep1i97U61Yg6hnq';
    b +=
        'GysQNQ71jxWIuof6yAoqr1tylzfe8TwBvGxc3Mnq9ZXqdaV6fa16PVW9nq5ez1SvZ6vXc9Xr+er';
    b +=
        '1QvV6sXq9VL1erl5PGEGQAbwCr9fqlg9Lh8G+gmV1HjEcRYwGieJRwPpKzK39Hi7uy1+6fO7ncJ';
    b +=
        '1+wgjp5Yr0spJOVqSTSnqlIr2ipJWKtKKk1yrSa0o6VZFOKel0RTqtpDMV6YySzlaks0o6V5HOK';
    b +=
        'el8RTqvpAsV6YKSLlaki0q6VJEuKelyRbps3KCZF/70kWLBez5SLDjTR4oF3/pIsdzVX4djb3D8';
    b +=
        'iA5XkO2S4UgVfUoGI0KpVGPJcCiT0GEJTenAZQb73Nmf+f1GncEsyWMwS/IYzJI8BrMkj8EsyWM';
    b +=
        'wS/IYzJI8BrMkj8EsyWMwS/IYzJI8BrMkj8EsyWMwS/IYzJKYweCeymcr657KZy3rnspnr2CAvZ';
    b +=
        'Z1Tw4UAYAA38IdijxX9PmaPk/p87Q+z+jzrD7P6fO8Pi/o86I+L+mTaxZ9i/mvrCJv/kFwxnQ+1';
    b +=
        'ArbjNLG7mPLcbhKLVo7C9oK7AQeNPZMwThWry3fAVWu3UBMgC9OQ+t7uENcvPU4VT/EBoF24Iv9';
    b +=
        'cYRo8oTxER2YxjAFjvEerrn7pbzx0r5i4s2sdzfGPmnFDMxGT7DPck6A12Ld8T4u8UJgDHVg99z';
    b +=
        'Jx3neREQndr+ixmKDv4IiRYv9Tt7cWYy91M+gvkoF75XRY/GO+aC/rir5vsV+11L05kLzbrJmKt';
    b +=
        'vV78/X7SvWSfGh3lqL4aK7yPRmkd1dzkC8HonX/jo2lWN/eYA8z7ty/0HVdYXiY+BAkUJsv0KbR';
    b +=
        'aMUWa98Cy1j6sRYuzBGFxq0xGDvpVp/CE9atv4Wnz2PqW2NtS9viYavkSXSRrOldbEeCdajB7Pj';
    b +=
        'fWN7sFGyRW7KPYgI9GDL9WDoZYNfWc89OHG835VubLK+3ohunKh1Y8dStBv1ByK/PyaUyVosRaj';
    b +=
        'FVBzYYjHCTSLRjXRoHI7Ea39ioBu1K5rcja2hbrRF0m7ULLQbmxav1yxqr1El0Q7G9VxiKdp7Ck';
    b +=
        'XA7dpaeEDMkPI23vZVCAHoQS+JJvDs5eWdLdRD3PBpH4pP4ni//RnmAvszpv4zyCDJs85xGrV5l';
    b +=
        '/gwH1vcSf2arz+OQLy4c2Ghs9wKe9VkVHTK9ey5uQ+BfQdGgAntm0PKtT9pm4Eej8Q7XAO0oehv';
    b +=
        'pTQ8q6A0k/vz9cqPqUhoBiLr/NpfjxwWWObLt2htqegtspZPO6zATt+uP56UQUfMKzAlcokZcn/';
    b +=
        '/AnMzTZwdxEzQrEYx7KgzeKl/G/DyUI0HWHM4zpvvfamY3L9PCpayYzRqnsd6AbQliDfot7rMT1';
    b +=
        'q6Fhy77FsQNJJIO4TLqQVtiwSUalZrADYKQZeNagnt8gnlwXwde2Rz7VE08YuCduG3TD2vpMP83';
    b +=
        'kBaxrtYn2+oJdmAHqUxDa/IAKBM3trDmVya4mlOSPVtcGJGwmgpC9DJk9og5/a0DrrkhkA4O1XO';
    b +=
        'jvjZAgLH+jdXFskj0qx32BuuePKL3BT9hkJw5LFOzCU7qbM/ykNBMjRDP1rl1ZEabjhOqy2dkA/';
    b +=
        's7ofCJnHe6WEQN7tRB1WUwb6enaVR+1Ar8igADanov5auDVWXtIUDzIj+cKNgVCIZ9quPhnGpcY';
    b +=
        'bqegwgvW9W7X03MMa42/1eZ3GfTGBam0ZN8kvzrBoj0brFxknh4i5PAHyzJHX+VTfqsXSVzT/wP';
    b +=
        'w6qjzud51ph50CIGSmqtke0AqW0DPWb6kEeJ0LMRREPaVlNVVhCVeoq4F8qgH8t9mAjtkA0Eswe';
    b +=
        'LmWKAbkLkTaqBeiZhoWeiVGLmBJt2dvHDSjbiXeraYmz1pOmGGHga/0U33RqJbWFpP8SV9CepYC';
    b +=
        'b1Oke5dqG6LxdWxkSsPL4m8UIRwELEzd+En6Ou/HDCcctzydVXZiberYSTVeJ2GUVD/xclYvWh9';
    b +=
        'piJ7UiDZxksG5D9arVqRjjWrFh1mI+Jog7wjBSpZsluVUNoHihDNVQbpQvh3uBRvB4rbRtS9FRo';
    b +=
        'H3LLdyUluUbQllbx2U0J64TmjrnVJ1gU+EdNqNSdh0P7WEWir2fif2fkQz8Kux3jT0fuAq0tPBN';
    b +=
        'Nw3HumY2XL/KHNEcBEJq4srfpmkuDMFYeRBITVsRnYZbvJ9svtTpZ7Hvr87OwhmfDVCboZy0RuP';
    b +=
        'HcULQSXg1Xkq8ntEfiRgDuZo/OiPnp1WT1PtD5ieZneJbzk6f7Zj0gKgxWPd6s6HKsektFSk2vX';
    b +=
        'VFhk1vmUiw6W1S5Nf0pt6e6W2zyK4BYSuSa3qbEbk1vc2K1BqobA86SDERxZvFCkuD7RQMi7OfF';
    b +=
        'EmGgzNSgRtTLnmUy0y57FGuMOWKR7nKlKse5RpTrnmU60y57lGWWLthydNuOMiUgz4IKlMO+yCo';
    b +=
        'THnGB0FlyjID9lRV/LunPMKu2K541eS7I4FEOACA3AvBe2ltCsqV5VcDtvt0dvrqpzKBr5kffFW';
    b +=
        '0Sd/LUB816Ac/zI14LGTHREH5PGt+PO/pgrzAlBc8yotMedGjnGDKCY/yMlNe9ignmXLSo7zClF';
    b +=
        'c8ygpTVnw4WKa85sPBMuWUDwfLlNM+HCxTzoReEy4xkKTBs2JDRr88GNWxeA3+1rB4Df7WsHgN/';
    b +=
        'taweA3+1rB4Df7WsHgN/taweA3+1rB4Df7WsHgN/taweA3+1rB42WTD4xe54cazYkdOdtGjXGLK';
    b +=
        'JY9ymSmXPcoVplzxKFeZctWjXGPKNY9ynSnXPcoSO8Ncir3GZ8pBj3KYKYc9yjNMecajLLMygWG';
    b +=
        '9xIaDt8irITDI3qxo5rM7Q1jIzvPY92GItHh6t9ge8Elfy8yFOn/YNuOMcdSw6NeiKso4FIkPgc';
    b +=
        '0oqfAVqb4AGQWICa4cbf4Xey4o1Vsm62lWXkNFixYTQE99zI7lFc42kML0R06wYIUJtcqneez5e';
    b +=
        '6y8Gvo/IjBIK6xNKaq6mX4FpT2YYuuPAJGlK4QBLd3Y8wYqYCmi9efVxNj62SIxEoSj/LgiheMc';
    b +=
        'YYkDKrM+wLhkJzqc9R8JbTOKu1MW3CQDP7rC06tAkVch1od0wQEfr1WDaCYjaqex/OOqXNm2VfN';
    b +=
        'TcAfYFK1RKbj1nJ6tX3TRXO5m71Ivk0A9smHxKYl0TdtYNcqPGwtl4miuDh3+Z5uk8k4Ze0tFpJ';
    b +=
        '5aY2tZDEXehIPGtWTs1HyheK3tanLjR0+wGmlcqcM2iXXHJSPusoQY2TKhONpMvBo17eBK5HXA0';
    b +=
        'y8SNlepRJNjlmwXJcoaqtwsLOxiurbNKlB76vbsoAE72lej67NUz9haLbNf8AZV1GXn8St7U018';
    b +=
        'VsA/xwooeWDB8rkGEmIVXX4d0P7lHlm13wKfK2XCjEU7l32BWGrH/rxzDluGUkdgn+irQ3uuvtM';
    b +=
        'GDCyHBnaqif2NSdW8vvPYmaBzvh2OC3gzHAsILkMqQJuwMVD3FeG2IKWzQfC/4HAx//6lpaW57R';
    b +=
        'HOPBxrWPtBPFyUWxbh2I6VaEqYJ73IhgpHjR+6gNudmKfvdIG2kLGkF+Sj7HpYTBwvROEhfrQXy';
    b +=
        '+ejIyusqKOmMosQ31JIfoItka+FkJExIFcojsKfg28AXCSy65mTfPgIsfwXTUelvRAj5b2IFd25';
    b +=
        'ZpVZMmRfKG1LBUoZhbv87Qtien8Y5gvsY+IUggdxChL4U8G1GxfUU1v+S8HNy/8ou0S5QDEdxuz';
    b +=
        'V390KL4UT26Nz2EFOUcfJWp0t5BNyRdddKCeEli6Uv/pjr6pyA/owRx9GHe62t6DbPPOzC4E0WK';
    b +=
        'rmZ2ahDxUV8W/IX0M9Qj7HvsHrXSp9CXbU4DniZJgBOdsjhtZCohXn8aLScDDq0yhUxxWyQxyq7';
    b +=
        'qk1Vfejw9U1nDUbxlT9f44nvarnL/CkWPU5Wp2xO2IJX2GzBAnk0umnMBrR3doZIRUISE5wgMLX';
    b +=
        'INj6xCwMsVWhSjBIVMjuaFosH5T8DzPnNZxrpCXmz8iG8e0LIQNIhfmYDqVMx9EZDHL/V45SylO';
    b +=
        'IOR+rEyJBEYzVWZFACFKoKhsV/UosX18z28Oz+PoauHQrVUmLlEiTSIGfw7rgQs9CFOOyfoZCHR';
    b +=
        'vialOWBxk002d14rF8sQwezT6JS7nwvuBkXIaPWB2huDT9SByyOPY5xewD/ZGIZUuh4NHjtjaP/';
    b +=
        'kFwjTth/qHDDwc35HX28LcGfyWv6eE3B/8jLD9wjPjyjZrfCQROE8tk/zEOvqJMzttM/mPbtBnz';
    b +=
        'pqXb1nlqhm3lpeUVCDL6jfBAuGPUvzxg91MXkoV+mxaPfpM9Z7bhFgnOo1g2Ul678AmjMMuc73V';
    b +=
        'sAxoPhteMSjHZ32befIRmScjjymP/+ROsbNZv4a6FkiePxAfUwVKS/R5j2i6FtDR28AZqi3V2hI';
    b +=
        '5bieTBcEmKULRYAiiWhe2aIxG23yO+ic4l4jwErlGSheyj4oFKaOyHCmRxpgWXW9lZxoM4xxcaE';
    b +=
        'fu7ytvWLQ57DxEfWI7CX8O7Z1eis9+KaKmcgzepZvmEOJfCT324SSNP3X1yS53WlqJBa1jC5Vqr';
    b +=
        'PBo/0mOrnA+9Jm0VoEynXVud8trqjLFtBWrg2uqM0bYCLBteWVEvN1oCdGvNoww32CnbYOdMrcG';
    b +=
        'm1LNMrcGm8Gdz9omBBmNAZuCDehmH5xOeiAZYBE7U6hU/skJTPkzmTv3Qd3lVXwubBKuziVQ99K';
    b +=
        'rOJ741cks2ilsy/JnM/sCrfKL8Aa82Nea4ZJRFhEG+QIP6vkC+abCHNddeRb3FHipp2Xhrr7NJG';
    b +=
        'ygSR00PWQdqXdx9vYPba+kwWg4HgVMf+vWAi5hWGm/cCqZigG67U7bp38XDlXMo+uI8HA2G5Ud+';
    b +=
        'YAVzCZe2PIPA1e9f0QmJx/CFqDx4ZG1fHlzWL4mp8f+LH1zbd8/a75DuvuBTyT8IHqqS0QC8gvf';
    b +=
        'nq9ypPPLn4iH7C5CAvLysIW4h+fOyS0El2NGRFv0wOvdUoi8yYqXvsj/TESGU2YXst6EKe4yxKT';
    b +=
        '/esgACUO/n6dUCCES5ybri/U6QBHTzEVmZbRFyPJvl1sAFImuqy27MYZ3b2FeZW+8rUix/DbbTT';
    b +=
        'WE4vI+vQlc3GY58k/Ga2a9nMkz5WZPhxmA5QnFj1/S/TblQT0tRUrZebliT4caQNXTD3UQgOxaY';
    b +=
        '1OoWrq1iq5l5N3wz71G1EjPv0CsJWrMqxOurGKyN0EZZV/QJWUcajti8TewTvvl+w0JEoJCmVsj';
    b +=
        'AM0Vv+KborvGFCTzr/Vs11y1zxL34l1dlr554/m2paFTha3w5dcV3NC77wSAcg5dfwzHhiJoOcr';
    b +=
        '7a3r+eKq6a1eurWySq8J2jrTA80N4/jInIdZuHrc3/vb+I+fDyVHY6lpNJHs9/6d/8jxsfW/rsf';
    b +=
        '/r9QKhnmHroxHf/1tL7v/DcNwuR5T3zp774F6d//nOf/cLnNekJBnCPLhiIcrdG6T6GtbjGdch5';
    b +=
        'LrhiinhfHlPZ961SiGOjCxEMF2JEAZalAMcMxLJbozMGfm63Rtm+oinIBzgLS3EStOM+KkZXSnl';
    b +=
        'SyPTVCQNY7ZuXcmlkKa+MKKVIhoZKSpsD+qklw3Ds0YqhIyMVdIr4hTacTS7oOSlRM29JQZtI+c';
    b +=
        'Q+oKpqVV6wVWlLirZU5airyvIaqjI3qib5iIpkI+qBH5krurha5hKdkp9O8w7/YsfO/zB/kUrxs';
    b +=
        'IBuo1epp/xKHbaV6tUqJZ53kXqHX6eYIY/hJRNn4R7jFUpR0uGSPInBaUtybVRJ8n1s0igleUgL';
    b +=
        '0pUELUZZDmXsiVBF+Fp+gfk7Q2FbXIIeFHg0a8ZpDgUHxLoSFWyQfftwTC+nBrFA2E7cYYGc/Oj';
    b +=
        'NkE4wEtCz4/Tj3BwJGqcfl6kChEhmFvuknmEeP/ESNSPmlnlYdqFu/P2+p1kDgKeW3CGEiDPVQA';
    b +=
        'QkIfZ1KjhgOQlLGxyBD9OHHcGi5/1kyzQPsGTvRusd7G052dtP7NmUJSFOzQCamgEbOXGgIW7oo';
    b +=
        'vLex+Vk0WM32lCRm31nLxTvEmpjvm+BVZv3LbDKAX91QKpB9XmsF1uzJggY39kz3bhDB7vZ8vr7';
    b +=
        'f103kYEzdk9YLdA8Pk07nBDn5MBzWBoJofJbGguhcl+aCKHyYtoQQuXMtCmEvPKMKoQZR2gJYdY';
    b +=
        'R2kLY5ggdIcxVPlWFcL8j9ITwkCOMCeFhRxgXgjXBoDEvBGeJEZYTQjlVUdYJ5XRFWS+UMxVlUi';
    b +=
        'hnK8oGoZyrKLcJ5XxF2SiUCxVlSigXK8rtQrlUUTYJ5XJFmRbKlYqyWShXK8odQrlWUe4UyvWKs';
    b +=
        'kUoS6byQiuUgxWlL5TDFaUQyjMV5S6hLFeUGaE8W1HuFsrRinKPUJ6rKPcK5VhFmSUKMbHPxpEf';
    b +=
        'Kn/6u349KO8QwmeYy1mDStSotywWTbacy0OWbI5DPzLUEYehGvZj9USzUMaqZUeblp2F2VtEb2W';
    b +=
        'ZLqcLRPu6xK3hg1bnOhbR66plE3VTFos/xtPClkVRbd+TUxfQOI54Mtu/IGMd1l7YWO0RDz+0DR';
    b +=
        'J1voiTMnwvlCoe05kr0QKpXzr6Tt3OaU3LA35ZXmqZBLK1K8HOIpnBXM2mqgkaJtWpypTvD98Z7';
    b +=
        '6DZtd/Mg23BUlh+/MDbaSahapp+gx7lDSNRNwxFwaryS0r4kiX8lYGSFO3YUeUmfWX4Y9rmNh9h';
    b +=
        'TSX4wcMN33tgbJGzzWUCKQu0tJMSy495rGhMQ7koKV/7/KvEep99lchEmVKJ3wG5ZsnN4xD00mM';
    b +=
        'XdTJTonfEegcDtShK8c6YD1CPSC2ItLAtoPngbT0oafXDjrRAjjSUuJds4q5lLghhnM4O0WiejB';
    b +=
        '6DzCiniQ4M08AtF66xd/YbnGnRstmyyWm/idk34WH9eZ1xz3vvmDaa8oqZiLssmY+3h/cT5YWrr';
    b +=
        '7JFaYIkb2e3ozQ5PcjazglNutCUwlu2AItRvHUXYEmKN1wQva3bZHksxlKLWQZlo96JgcO+f4H1';
    b +=
        'hHEXJgn2DyR4ejDB0wMJ9tUTNMrvBEGakqFIoPklFYtGV13f5yOp8OXP36rC73YVlmrOcjUhUqO';
    b +=
        'fX/mLV4PsgyKpaS50ClE5tF0fua6PFqQWxNEYmhwVSD8SA8Ox4w22Uzqgg+HA2zHw7wtw3cPIDj';
    b +=
        'R8Ud0/No/zxNDYkzd39UOpOTHwTCk/dF8Q0he09jb27OLDDG7frvB4wPrd3bNLbE9oodlTLi1dC';
    b +=
        'RbxDYygKXP6ZhctyktLrwXUuMqelDNv0VmNn52YZ/xKMwYCS/Fj0x3eP0Xc9HxahtKddEIiDX/Z';
    b +=
        '64RBvvyC1zn/n3ZOIp1z/Zbc+E9d5zzpOkc6bMZ1WM4dRhPIf/osi/9jnav5Mt7Y2YC37tlSI+h';
    b +=
        '8sGXuZJC2SGRVzqFi2ynfOb08p7LntPmcop/TAXTqgU5z0CkVOn1DVkPUe+4B14m+/sQJcZTOyV';
    b +=
        'oDF/py+PCgBLTUGxxOQf82B2HQ3+jQDfpTDvigf7vDROhvcnAJ/WmHpNDf7EAW+nc4/IX+nQ6lo';
    b +=
        'b+F8QH6ucq4Q4VPa9bUQNjNF8ePoosGY60yogSwbDylg8RTNTGam5+XqGAMa/HULt9thiwd8OMk';
    b +=
        'bybaP7HvqVCT1sle+etqL+IczSqtDHx0JhRXR4M0/evp/OjfxqokdsbIBBdMBjR0vFYcCOKoJfo';
    b +=
        'wyUB5BlQwJHjFLIxU2cAXFRjDal4pfD8dcd2PDFdAeIYBpuKaC5mmjYfOloELDy8+vUU8O49ZNX';
    b +=
        '/1zCFguG0plwD7JKqjLW1r1NdfXIHiGPUWqL2xwJrj9QQ4+q2aQwJvgYn+NCuh0NHu+1rmQcxDK';
    b +=
        '7GInCzWGHtzFSCyfsuhlPHsJBBm7NhV8M3YsauAn7FjV0FGY8eucrHDjl0FU43N5gRwjR27Chob';
    b +=
        'HLuKvi0C650ibn/SaenSFGNVeGmKsfq9NMVY5V+aYqxmME0xVm2YphirU0xTjFU4pinGaiPTFGN';
    b +=
        'VlWmKCWz1twgaG15zgWrDa19w3PBaCMgbXu8SBDi8zgg8nLh9Cmz17xFgObzeK6hzeJ0VSDq8bl';
    b +=
        'V1YzhZ7r9BtJHx+kZRVcbrNtFjxut9ouSM128QDWi8vknUo/E6J7rTeP1GUazG6zeJ1jVev1nUK';
    b +=
        '/B6v+hr4/UBUeLuPyhG7f3tKjYMVC0sqfxDirKZ51qxIYQBRT114hc5Lyw1X2viwlf0pNUFXp5U';
    b +=
        'jv5ORKIuGK+S7dJNsg00vlImVdeQvus4VsEQTanEd/IX4FLSqFaer4Baz1Ps5bw81dQ0iET1CfY';
    b +=
        'KmA1igeuRhUCch1q7XvVPIsRgF1eE5p/Ai+T33RKVjoza1de5ocJqXomBrSI+d2BNNcqb7SrefB';
    b +=
        '5czYOPQW6GfQLVPP7k9+T35rP51vwN+Rvzbfl9+Tfkb8rn8m/Mvyn/5vz+/IF8+61z3L1LPOnu7';
    b +=
        'fwabvFYAe1CrDDguKm+H/OAqEnQXm1YO4KvyC6xpIee362X9TEY+n46HAFghk0zcF9NtIdoJ9PB';
    b +=
        'C5ZJXMvyEfMhHIxCoNtEeIvpTBpYi0aaLliT+iF7UW0g/Z3bHq3A/fiOnWDkiK+pDe6XQcLVMFP';
    b +=
        'ZWoQNRbL/EGPnTaOLfuFRPjKf4zvH09ijezmHr0XboyeUCQ3kMtlvJLLH0+DnVLFRiNnPJLkSHg';
    b +=
        'yXI/u7UEvLPhXZX+RrIcjNRWjn/xrkkCeMVBMOTRQKTOunI1UrCAWHIhAzeZaA5jqOucbwA0JD5';
    b +=
        'R2sjJfjYj0sz3wPm4Swb2wHCCNtHFZtHElz+A38hBbgjCvAh5oy+Qsx+6VULTSYmH2m4apORKsb';
    b +=
        'YtRSAN//D6y4GJ5TULD7SCJdv/nB8GAkr1Nol6WI11P6TK+KiX0eDA9HXN1sQawXtLqTNFtQdeF';
    b +=
        '75IqtZzZQz1CHpi0cbipf9foFfXsuVk4Y1TdnYmXBgZ6pKiY9czSq9UxqmUCK2oW2I9QUQtZsAX';
    b +=
        'ICa7awfdRAkSPumsiyPzL5cFMr/mHtBFzISz+csi8/11Be+LA6+Mg+3dAKc2IaF/J1LMpZ3Oav0';
    b +=
        'bnuirFaBdJ3rHxw9kNW+eDm6S7adDQJ4P8HnXIDFE+ufsiqHuT071kX5/Jcjqo80eei+PDMitP9';
    b +=
        'olX9mSrHqHzehlSZ4qzN8yNpaA5s3Z8HuCKi7Qs9jxraFdHzKdrC0ONttH2hR077I3qcNLQ5CnD';
    b +=
        'vgy3H1uif0gaJHjtoc0SPKdqGBbjfwiZka3TY0H6Hnk9iI7I1eoh2ZvTIIOLbGr1gaBcV4IYKe5';
    b +=
        'Ot0btpQ0SPOdqz0SPFZIZ7Ntpd0fN9tEWixxPYu2yNZmkzF+A2pluu7OcbCFotDuV3HcpvP5SvP';
    b +=
        '1RQG+atQ3n/UL7xUJ4fKpJ5c+QQLmYO0SKS5hOH8uxQvuVQPn4IdzIcGR6iDVAjX3doPjxSbKIV';
    b +=
        'Zyy/7VC+4VDeo28OFROUKE8op0Pz248U01jjkdvUobw4RB8V6/ImZxMfmn/zkeKe+QOHPnCIWnM';
    b +=
        'aSxdHNKlo81uPFPdSd2w4NH/vkWKzJFpHvzp1aL59pLiDVvXxQ/MPHSlmKf+Nh+bHjxTjkmgjNC';
    b +=
        'UPzU8fKbbSotfMO4fmZ44Ub5DI24mw/tD8uiOw76B6zzeOFOshiDlEv1zcKYk2QL/z0Hx6pOjRz';
    b +=
        '2SH5m8/UmSIok/hTJSaaf5bj0A1mOo9P3mE0VbTQ/ObjxSp5HAbFbQ4NH/fkaKNJVqIE/Tbdx2a';
    b +=
        'j44UHazaQuTlm/OODvWRGHprHAPxyZZD8xuOsNP6Lvrk7vmxI0Uo0bgY6x+af+ORoguuFWI8v+0';
    b +=
        'ITih5V8KYRa78iFwuAYqaqVRZ2tVn+Xr+2TupvYlTNufTHLznUDFNbPQG2kvcwamLO4jlMiBmS3';
    b +=
        'CG+HNTfi8n3nyo2Ezce2c+xsHeoeJOYvGt+SwHiWPuJsa/lzYRm+TbTcCGyBscG1KFaJjM0k9tl';
    b +=
        'diQDxg45ohWwPR2Yml63r49gtJ9E4tmkHe2RzDN7PKlVr5uO40Net6xPYJvpHxqewTEv/b2CPiC';
    b +=
        'tM7CLHQzL39BvnF7BIdJ+cz26El6tLZHAByMt0ewE920PWIYqLu3R4Ayyu/cHgGLamI7H+DS7RE';
    b +=
        'MRyfZvSpNottp5NNzw/boKXrctj0CJGFje5R3vj816YFq+0LnsnLfItycwL2XeRybwMd39Vh2BH';
    b +=
        'vu+DHYdjPeiyh5WKNjoqQsFYZjxQXGfskF96Vkqfrizn6S61KQWxEnG6gueIHQD0QuwJJ8RmsRe';
    b +=
        'DZeB1L64XpunIzxWVKIYlMV3kcLtCttvhW3HTnjnzoRK9zWQX9dpO4WUcmgMqGIJaUmUgvDtcCU';
    b +=
        'lEAKr+UM/BoEfg0Cvwb0CWpgt8fi2oPKVM+Nkxkkk/sHaOWF7B9jW2AkBYocQpjKxFCJHUgT9vZ';
    b +=
        'Zvrcgp3hqDb5VgRiG/zw2XcSoWoMvRxkkIaaz4GLBDlgDD2wIqiRsLk6bEz1D8C4NbjjL5l7IY/';
    b +=
        'fuKt//XQfTxQWu100i05tFdleN7Mu1KO1nWrrs5020SwR8B6hnp3vLG++/3oSDUH4ulO9fit9bZ';
    b +=
        'ntxH0Wjlu0BDDuXxXcQtgBMls5Ce3m3h5aIuJO7j7maCzARmuXGjRtN7e2vWeXr3BKhlDQKb1Um';
    b +=
        '/lhZje/tzTvzqK8cd9NmI95POs/q5ZUFJgaqDUMTJwAYZXCZBFY1fGJgSNHEQooa1uqmFt7FwKF';
    b +=
        '4NfKqOIsMI8quQ6JddCB90yNv5VxijNxIkyS7WJ2+w7fmg8iiZtPfFljRUgw68kRQnKmV9AaSpa';
    b +=
        'EKk2xGoTjHFinZjEJxjisUZ7MainMMRo9tmhqKszR2VxQ/bo2bfABTvOAgfz1hJwcDQMMqDKo7P';
    b +=
        'S08OGJPKCMI3YOk8szFlYCFORTIvshrwX7B7xJE4gqPuEIjrrCIKyTiCoe4QiGuMIgrBOIKf7hC';
    b +=
        'H66wh7/GyMOimhxVTpoZJfixniyDOxl0gz2AJAA6xzDfu9t6T2PUYjgnZdel7NiU3Z6yU1R2mco';
    b +=
        'OVdndKjtjZVet7MiV5zQf2dhh83Y+3RS49GP37CyaM7jUNtknab9AvZg8VZg95Vto0g8P4Ny+kz';
    b +=
        'WAQlH2oZlmL08rosajIYwHKnVzcS8PUlDMHpr8FksoQ1htSobEimS6iZwXi8gp9kROjydyCjyR0';
    b +=
        '9yJnMpO5HR1IqekY+DFwlgwe7MX951d4DM8vdAfKw2KoBjNojEBXwaNfIwdTLx3QXzN456/+0gx';
    b +=
        '6OICKGOMGEZb9UEXF6vGibeEFoMF0W7fxaHe1AaKcc8Liikn6oD3pY4/UwHdY14CEDUR0BnNcvn';
    b +=
        'uBanfzII6CQky3tyu+qDOjMvvpM2eduY/r3VmfKvOZG/ohveeb1ksIESjVi7inUxJ9hbRTtqwIl';
    b +=
        'JcUTTLpZmFv8Euh67cYk490kbPj9d6nPs7liIN9HosvT7u9Xosjtw1dY8B+fJe7sWnt4iHXNjGi';
    b +=
        'y0HDLTXwAEwvm/LHGCdHTD2Aiz/jcAwJKzPE0j22RytguJCwNHKILsTpTt2D4b5ByvDidj6RQjC';
    b +=
        '/XI64aaZe1Q0DRa4V/oROx7E/t13SyApWQKbx7WUvAma/+nP3/jvL3z/D6zQCegF2kvO/+If/OY';
    b +=
        'HP/Vvf+VPfvAAneFA+NiRQ3/6Q+evft8/oYMTwkf+8sSff+DD3/sZCi8jfOPG7/+XL974+CfpkH';
    b +=
        'cY4Y9+Esvof/v4t9O5LlIJP4RT/ynyHHCrCS3ET++wjteyf+I73K4S8QVUefhnXw3Y06RLwenPh';
    b +=
        'NaolXfCsD8/WZmx2tQgz2UfS3uGry3kdZ5NWEXhsJxlO1jR2HOBhxbmRQMTD4Ayw6ySla9QWtkN';
    b +=
        'aJXsL7CBtV4Gc5gXCi7bici3v12qGdw693MRTyO+3YdcbqyuA48eLSJn1xIpc3iu8CJVUI0G7Fo';
    b +=
        'iqL9Gg3Yt0ciyRGs1//CLI1k+tEqWX1b1LgTWvMVWcHZUBesmLgMVlI7pG6+iGD2+ocDrqSTx/G';
    b +=
        '995sanf/fHfnKpR2OAzqLzf/biD3/vz//l1U/cTWMA4T/+we/57eMnP/ujP0+D6hoGyQ9+4T//0';
    b +=
        'Xd/9EdO/wIRrsgoOv7v/+LGjY+Ob48uIfzJj2IU/fGN92yPLkTuVk2HT300gZPsYLEjQ/R8lmoc';
    b +=
        'd6Ju4h3quPwnzlxXMpk3Hap1Ry4QaR56pkmHIFqGfi8FKEz2fFqE2e+kshnGlJT9VNpjeGruGgr';
    b +=
        'faKrTFtE5jrIz9GV5+tInoC74aI+luzhyltGjvbB8jeiqJcnD6lxDTIMX+NCHwQY7ROhUBdlvyo';
    b +=
        'lcT4uxO1QmYIUEGohdqDjTXhTn15c//QnDfyhJuR9ymb3/bBE2yDjpZv+xKeqV/JOKkRDuKM9IM';
    b +=
        'XO9BqpKza8s5uci8x++81uwDjpM9hPN8Q7nIOlOId2p4XR0EpTzmuaummIGbUvdusACF1tro7U2';
    b +=
        'rtZGay1FtLU2t6o1KkslzL2u8Fq/G3WkXlzy0/atU162DfJOaoOlpX1lWqbZR5vlJD+ol+S5s/x';
    b +=
        'niziO0YlPSbRy72QfQMHj0zQL2pbFq2TRDzQT2pvIJxA4UB9ok+G6ir0NpztpNQ7f0QtsHvTBeX';
    b +=
        'rrBzwVsOKtYW3Z7P1pbh6H/ho20kUg3pFQ9+ynmUulETd1Qc/+INyJjtWfszV9B5HwWh6g+jOo+';
    b +=
        'FJI231uvt8Iy6uIuqqf0K5ato095LZpvMPpI9pSldGe8hXqBZpuwgO2P4qQTvLRniJiicFs1WFg';
    b +=
        'eNa5NR2WW/FBnq/7GBFPHnRoTTu/kobpgeb+2kUrz6e9JzDqemy/gP9t+cc9FnpF5bEDuXmTmaJ';
    b +=
        'tyZPQPenNL9H/sncVZrpIyqdwyd6bzz9I+yAiSCRgIzT+fRKfDcQvLRlNsE8SpEMJ7C/slwTxUA';
    b +=
        'L5DYoKXdRbvvs4RKZFsrPM9pTZd5RngveWJ44nC+VvZ/8XVeB3g3ey2Ua8hwK/8imaq99kgn7Tq';
    b +=
        'U6e+JRO32Nix/GBYpyyhvh7/i2HP0g/AJzv/QUgq/MxBMbybP8+lpBr+t7+YoxxhieUAtSd/Uyx';
    b +=
        'ee7jGqT7GI95vMTMY8qTWpgFoDO+ZfGlonf4OFV++bcDDOKkXDn4rWCipFz69T9802M08tKyhdC';
    b +=
        'zf3Y+gtpxP+UYIdCOE4qu0JeEXjRxFL1famq6iwG9uyStx4lkSjjobD82DVXHuITm47HvbWh6Kg';
    b +=
        'NC+ILYrVGyxshL/yXWaCoZBym+02/ME4N8sD8WMkYv98LSEu39s+9gP6jcKUUL+rjjuDnYV0x8g';
    b +=
        'LWIbtwQ9Po81p6DTmze2plHj00XUAZmhFmRFze+HfpK0IKFbkojb78X8nBWimrTtlXu/buP9KDD';
    b +=
        'xZq+gmuSN6iC+PPtfRZolic+TWvZ7eXBP33VauDzyZa1vPPx+fZS3niJKpOPZZ8143a7zmqf0eP';
    b +=
        'T9IsdnJuoq/rr5k0/o6Jl+brDTziHN3ILmqCU2Xx7fz9DnvuL9blUGcVdn1Mva5Fb+gNqF4ntdk';
    b +=
        'tKApwmLkL5+bNU4s3lic9oicsVeitnyouWkIPFyyt/8qreYj6D+H551cXjMPnsn75qDWu8n0m4r';
    b +=
        'uP76pWGAs3zNv2/bIYdPlEIMsW44pZD9o2LCxYStBkNmDrCLMII7AFWAqPkj0FvTFT1eMXNo/e+';
    b +=
        'VEzk6/YD+JZx11k6OiaA3y0G/KbPHvXhnulUPS7zRaOGwjuxP88sBPt4bi82XBQPPv2mjvReh3z';
    b +=
        'uWovjHktm5SdhjX+Ln9TMYuB+a3Kmp7TR65QMQhPLOVVaiUFX2xWyPYMTx4wqaylAluV6J4IlLk';
    b +=
        'DimXj8WlBkbPv7SGV2FeIptJN3BBsX7gA14SiQe6Ar9xNuARqZrQohV37Rgv2P/kXJw6/Qfq4Qi';
    b +=
        'i0guXEN51pxiRWLugYbznC1cGPxtDgFYLHqrlFpJhxIrvM8wNC2jYFuZHRZyrHTn4hH/eaEB5I7';
    b +=
        'kJPWKDueNxxIrtdftb7yQaRVyxO4Uj6MbXMkSO6qSbRLtBqxB5Kb3BIk9y+aYfPAJA77czvhn++';
    b +=
        'BcBu8azwQzvbX4zHTn8QjxwX3A+FmaHM/EE7hwvyBcBJa3A+EGTS4Hwi70N5+IEyhuf1AGENrG4';
    b +=
        'P4DrmPIEq+me12cFyiIdzZjwmjk9/B2P2w4kWTckpcaE/vz7uOHgsdTtg2+fRU6BnRb/fpXaFPE';
    b +=
        'n3K0XtvpoRMnyL6xv3YfIA+9mZKyPTNRL9tP6/Pguo8JfSc6Bv2W7hoYuTNQp8h+uR+O0iIJXKh';
    b +=
        'zxJ9vXq72Ffc+WZKyPRtRKd5606m40o67hsxmErKrk7fMU8W9OfpoiNsHaPp0KJ5xzFy580s/47';
    b +=
        'RViE3mB8FgXjX7iJCbjc/Glu6nhed1aMhOh/zoifr0ZCnj3vRU/VoCNkzL3qzH30c9x8Qvk94Kf';
    b +=
        'J6ikSE8jHUxohBQm5mP0FTZPWUYLZIOcFsPUFLL5WQZFvR5iTb/CQ6bIsQxwRoGC/qTS8PDTvsY';
    b +=
        'gjDZbjEMlxioaZKTYWaCrWr1K5Qu0LNlJoJNRPqpFInhTop1CmlTgl1SqibQaXVFqTNIOSshmjy';
    b +=
        'Nsid46BvY0IKQgthxqGGbDPMmwjPiN0Jwoy0nnfOpaZ3QJEFYG4SMhYJhBQyLRlZa9X9+DT0sFf';
    b +=
        '0FBk7IGduDwfizO3gAJy5/g7EiOvtgJu5vg60mevpAJs3c8iCNTMnOKBm7nYH0jzLIQvQvI1DVz';
    b +=
        'Q0xyHr2ft+Dlmv3qy/4Tx6P8whizckRsvWk/e3cch68X4bh6wH77dzyHrvfoJD1nP3uzhkvXa/m';
    b +=
        '0PWY/d72KFq8CjfiNN5i5YC7FjorMciqQbtWmk78E7evSTq8T4Z7g52AuhuhsbqmTZ4fWYV7c7/';
    b +=
        'z977B+l1nWWC9/d3v1/dV1JLaqnb1v0+NEu7UHb6DyNpHG3Q1Ua2heOJoFxbSVVqy1ub3XJ9ck2';
    b +=
        'lW1rFNSNbnUQBxTFEExtGOxhowCDV4gbBmOCwBtrgBIUYImbEYCA1CNaAGByiYZ2JJnHwnud533';
    b +=
        'PuuV+3LHtnCDvFluz+zj3n3HPPOffce99zzvM+j2VWAiQytYjt1hg7KvyQYCuUfsI15y8jmVoey';
    b +=
        'aqJLT4cqRcGE8f8PdbEGROtJcTgXWpimRwPjgYdleoxb8KWrDWcEIN9AjHsguWTUjWteu4IKoWG';
    b +=
        'O60Ogxo3d5XLShz9KAg7GRzjqc09uta6bfkaN5ustFdCr7CTXEyHMHDkcjECDlfyWY2NTpY9+qm';
    b +=
        'Cpq6H7WAcopncYuoOoKWw+ojpBd6xiYoMwn35EAw6/l2bx/oG25+5hqZA0khDGRxraLZuQ7M1DU';
    b +=
        '0lrtGsbN1m1fm6cvdg1XaPECDTFV+dnUH3z1pRKgbFlUBd2WBTTPLDCG8P2BQb+FmFlwdsik38K';
    b +=
        'MO3AzbFZn7S4dMBm2IrDQL4csCm2EYtqAFWrc1LEN/EbYLBSMvI2BQ5JgXGFN1ubYr2O8yrgDnh';
    b +=
        'mWNsgbaLv13ieyZ+qx+/V+ILE7/Fj98n8cA3bnbxnXdEWpNpE29sgY7Emw/hOyV+1sQbW6DrbJO';
    b +=
        '7Jb408Rt92+RdEr8T+EnfNjks8XMmvnC2ycw7zEuG8btM/OQj5YzaFO+hq9dAecUSNStolM+z7x';
    b +=
        '4e5ueEp5KRt4tllruPYw7Lgkl7xRRrJGFtqG2/3bTIGsk9oDa95KKZXJjkrpc81UyeIgaxTp5uJ';
    b +=
        'k9zih1DFNjcZJpTMdSCsxWxuWLICLdWxDCb8Mopa2uHRp5Xqgu1XajTsBMk1PMsBlZhfoHeH7AZ';
    b +=
        'xFwgZZr5zizg15kLjN2rsc5cYOw+jXXmAmP3a6wzFxj7To115gJj79ZYZy4w9l2Ijcr8nNgLJuY';
    b +=
        'wKKEwF0B8T+0FRGS1ATHHCACSys45sRjo60CLghEl1i+KL4XyhtgJYLOAAVY7llxNXHcSWc0fxs';
    b +=
        'W91iFSXEvtVkGsm281YbdGc8eseK/1NK0TxAnw8VhJyBXhb16FjDKpLE14oFH2WXAHCAN3FweaZ';
    b +=
        'uPNy7TnR7+3pmAPR/VVERVKPnge9YUYriUxVxwLc92qWFuVKBW417JkVHwqVpL2VIIap0fCBW7i';
    b +=
        'vFanegmpYGZZrusKZtZtN9VqZviACL11R6KQh6nmta01Z0Em3qt5Zjt+tbWmGojCDmnonzUMTVN';
    b +=
        'DqSSKVUZvBEM5x8Zea4FMbzyeMYk273FslPXxk5hSE7lRWdmzedCxjCFdv965vDlC8nqE5DDkdW';
    b +=
        'wstUdyWa/X2vVtbcOqOVtnNO2TbqBN1BiY0lRN1JuJVTfeQylATtAcptSOvY6pnYzQ3Buh5tHTG';
    b +=
        '9IGWKy+Ge1G5rZmNm3vjNwdlAqcaWkF7F3FhdjVUd1LSaOXkDuSU9DYT0fuwWmMCDxTJlOOP4Gc';
    b +=
        'qTfeEol7IzGwD7JfwmoHL4lvtMJbqMsQi++Wc6fManfKVu1OmdfulO3anbJTu1N2a3fKXu1O2a/';
    b +=
        'dKSdqd8rJ2p2yUHfKWLxMnTvlxtqdclPtTjlVu1Nurt0pt9TulFtrd8rp2p1yW+1Oub12p5yp3S';
    b +=
        'ln1Y3yFnWgspIwAvEyT8lD6t8FMH7kmPoTOW6oxJgvjKDk1BNLXrM+ui6VY0wNBORgzxFfYB7xC';
    b +=
        'tcEnsrvmWcbsgoPNS4QKue2j9jjnZeiEu9Q6haZ0KmQyqoalIJESxo2m6sQ+FlYSizBt1qV2neU';
    b +=
        'Tpi25XVsyDJQlt8PAp+KFTBlU5bFBd72EJICiWjw9gdlfcu0W1WuQ3Nhq1/9PwknigTlwzOUiMH';
    b +=
        'zAdW76CVEtR8ovUDXnOl8QekJeqNk+IMqgGha8UNLce0PSg/O2fKWxXJmsdy+WG5bLKcXy62L5Z';
    b +=
        'bFcvNiObVYblosNy6WGxbLYrGcXCwnFsv+YtlbLLuLZWexbC+W+WLZWiwzUwdX4iKcN7/Rss6bq';
    b +=
        '23LYDg3Kq4na4mt2UdnH/21gI6aqRDYMfeHW0Simo6L7wUNCfmgzUMievEYvSoUT3Jz0vfPj3yG';
    b +=
        '8zklON+LAi8m9IyLhPxM+HoZS0gssbDF75BV/2IiLpkW7XA1qWnQXhKzxou5xJiX6hjlY7+7jOC';
    b +=
        'v+qBCcZzP6gOWWpqTXGFXxv6YY1dOiC0tY/iqivxBDGdVwEzN+6BLDKo6qxJE/AF2xe7oA7KimH';
    b +=
        'BnSx0ppWdCx6jhuuYB7ZrrQaNvyANn4hqdUxBADF5l7Zw7KTlwWj0xFfbEzCBMkaTikwk53ZMD4';
    b +=
        'Xf3UfQZAj5YHeuNaU8yScWvxHXpqNj5NlIuC74/diz/LybDbE+83IZVIZGZtuRCu25JRTDts+1h';
    b +=
        'eLDfxjt5/sEhBcFi/rln5ggX4gUkxHqZs9lmeEZyvLVITnewn9OFRSjSCbY2R+oc6XyDtbt7ucK';
    b +=
        '6XzTTrNPOOZHdIY6ET32iZlBOqic+UTsSvtFZz9izqutnkFa9gIg/a5x4oV2faNqiPpOfeCMqZl';
    b +=
        'ThZVcFtvJKXL3q6KfZg13tmx/AeHg20QBGCAPmdsOrM1K25sg87vj6f6EVTQqQ8EKoj38po/9+C';
    b +=
        'Zkav19COZ4Ihnq7zahnqMBgZmhqd3RMQtO7o4ckNLs7OiGhcne0FEpw5+7olAbn0I0S3LU7eox0';
    b +=
        'V7o2GKkQ4O0SyrEmGKkQ4D4JFbuFb4vXfqeEprEGGKl38LskVGLtL1IhwPskNIc1v0iFAN8H+YN';
    b +=
        'wRFmPs+Z3UrBg5n3OnV8ygNZYvlDx9L3iTFTdin3Queh8OOBb7+nQWELmdzkccFw/FQ5akD2wmo';
    b +=
        'smnHOvpQNtcC6Ah2bOemTYXVh5eKibYPBtXKDUrmjHixbn0QXoniNgJlfdhSOcMRqL+2jZXhjGR';
    b +=
        'xmEUvrCEVl7XqjC4yappPZNiFxlcHQIv6sqOs7dwbLD2NZRY97lVXhsAE1d85PBXfMj5Ua3A/DR';
    b +=
        'E6zaOTAQfPQc3grhcbKK7DhWbjBz7uOLpvV9LhnyHV+au/Ukbma2OzqLX3MfnyCMZXd0JrQ4NEs';
    b +=
        'kCxeDwvTmHuuFgLRJOZhA/HZ5dqggcr+EE+wwvF/COizNG6e3h8PShKb2cDCa0OweDkET2rlHxl';
    b +=
        '3kBttcNG86JDy+IJ5QPbwketU2Ygk3DviWu50EmKazxu5X6t8vY/017ldm+39B+z4b7/vE9Dpik';
    b +=
        '6PmNr6Z3m6N9bZQbcoX9QKA/1DjPmqq1v3JVpSdLPBA7wfIt+TXK8GXmnrdLfF2KVvEh2d0eMkE';
    b +=
        '3swsj2CjS7Kk41lSQUyFtlApUXxswGtDByZm5zZE4hcXaXFeeup202bxZ98J/J3Gn70MTuHP7Qw';
    b +=
        'W+DPPYA9/dp2QfTXzZ+6E7L4lWFLizpz5U54Y2lU+AnG4hEeEzwlB8Ay5UTgsROye3e32u2JUqP';
    b +=
        'COpuvNtBjVmvCOinrhKkblet5RXq+kxahixzsKHh5urPW5XWjKhTa70BYX2upC0y60Tde9sE+24';
    b +=
        'dwCuTnM5HrbuYXFYXxHQDHUsjiHVaJpxBlrhFKp5STjtiLO2GkUUi0nGLcFcdkdAWVWyz7jNiOu';
    b +=
        'dUdAyBmWqEzcFOJyaEUhrsu4TYhr3xEksv/FuI2IgyoQ56nTx+8IdjBUmNCtDOUmdAv3YJA6wxB';
    b +=
        'StzOE1G3cKUfqVoaQukW8NUxoMxfXkbqJIaRuZAipGwgUQOokQ0idYAipfbgBM7XLEFI7DCG1DY';
    b +=
        'diprYYQmrGEFJTQhqQKtwTSI2E1cmEKElWW95lulgmi2W8WAV3dX82DyfoPdjy1RAxA/pTwpAoQ';
    b +=
        'pmprGDqEb5xXwWJHZkjDJ2Cm0iCUamXkxw4v3gpXH6QpbWGFGCtmnYZh7dFL2d76M7wRTl8RQ9f';
    b +=
        'lsNX9fAVOXxND1+Vw1MtOXwtoojGYy238HrFvEIuAZEUOdWQSKV+Y32N5xLqyVJrpFK/DE3Jkmq';
    b +=
        'kUr8MUeqXoVLWPiOV+mVoTlZMI5X6jdU5bV5Ct+/m5oI4p+2V0L7d3EAQ57T9Enrnbm4SiHPa3R';
    b +=
        'J6125uBIhz2mEJ3bebi/3inPYeCb0PloW3vOqY6eSzJ3+vqVChCGsC0prr8SUKLIQidyHUbQ+pE';
    b +=
        'mvumI4k7gKHgaWWuRDbvFcoKx96co2BEj9Z/pUzieQFb3aMocdAU8XP6lYyIufy7HKKxVZP9u9S';
    b +=
        'Ksqa3Opqy1LVcNKnk8PCZ1Fr3q2hjbvE5rtrdP3Shd3Qld5p0NRx1qQjGGO8Q+rGhygQatUE7QD';
    b +=
        'E0HwiaYzyJ5PGKH8qaYzyp5PGKH8maYzy5xJvlNtnuOPkHendo3cigC+RbfRDKsc84bQgRSi0q0';
    b +=
        'e4N0U9XFow1L+Sh+FJQoDE23h91alxliU6eR2Z2BBGcZJmrbzd6fb6E5PFBmFIeVsQitTfrlEl+';
    b +=
        'mwHoj0RuByf++Hnue8fVb9BNEDEKSeeKSv5Rz1yM0UvTqe9DcK3ksvMet0Cl12Bg5uXV7yV8i6+';
    b +=
        'iQpO2gK/LQ7+0foFnnIFfu5NFDghBSYWV7FOgS8/aQv8zTdRYN8WSC26ZoGhFHjJFfj5N1Fgryt';
    b +=
        'lWEG6H3qegAxX2qqWVp/RvckZT685o3OTM86uOaN9kzNOrTkjv8kZr/zQ+Bmtm5zxxTVnZDc549';
    b +=
        'KaM9KbnPHCmjOSm5xxYc0Z8c16d80Z0U3OWFpzBgAddhxbl5niJ9iD83jtnGqF+UkspN4Wl2W0c';
    b +=
        'mKP+bQJlTWJykXQby56YJjUEdHJatXYbUfApHOPiAyMoOsj27FV/G6u2J1Y4CyCjodhvVSD3aTQ';
    b +=
        'mJWC6fQio/Ui4/FILKLCq4u8mwIXpdfFwjATxrmxy2FlyORXKE6mCgxzmFKywuJTZCpPJHSFJcC';
    b +=
        'Arp+YxVX/vbamjdZQYwzzba/4VFrTQWTHj4zWi4zHI5ut0ZXCNlqTCKnL+PWazUmsoISZ3hefAM';
    b +=
        '9hUhM62GFSixnUKga1fEGtW1ALFnhKBZ5EgadN4IkSeGoEngyBpz/gCQ94igPmQ0+WmrJ9pCuUf';
    b +=
        'pjlYzyRI93ch0MQtEsFNFdlx03zGNq/QI6M6jsWuuwjPVXByrH6Q+OegfeBW1iqOJXF4pfmd2ck';
    b +=
        'ty9102EbGa0XGY9HNm+f8rPAu20Yye3jUt7cG9xBUd3r/jqeQkABc/NQ7YS5QPISYzVYSQ+uzsO';
    b +=
        'cFF0vbnGYQRp5br+0K7gOFQnBBheHy6SRVYjjVpsZ7xLX8rEyY2ZFmbFfZiy92ChTuXKM+YPVZB';
    b +=
        'y17ebtMHJOvsla31/Zg3PRTfdey4mtidzXYQJgAbJt1KqTRXL5vb67JI+uWHI/7+rYu3CJkfPmH';
    b +=
        'fMXtmJP4mjsorT42Iu6wChjqjq3Xyca7G3S2ijdm45gd8sl5BBog8jf+WcUt4u5s/8pzcSeA6pg';
    b +=
        'LLNEyR55JIgCHwNho5ZivR72rmNL6ipRdl9brgXcQeQjMmyUXCOQE+yutKlWILVAWcKcgdL1WE7';
    b +=
        'mpjgaba6dr4nPFZpQwwXMMxJIcWcoahHbHFeykXezl+ojVD3Dn1bd1rxk+1IBKMhGdCCDGxGpqX';
    b +=
        'oqG/bCqCKZI4sTCGQ6Z2MBG6GTbVBcxFDH1rz5lF5uhZN4iAt5hsNB31LGTA971RB6KdxCmTQT3';
    b +=
        '+HEhijow6sfDCuOaqoAGFUf9nSwITpZphAJMJ/V7+Q3FVoBHW4u4ZRUZQIw2HYsEMFqMgyT6o/o';
    b +=
        'EAktgLK7yBMiewJVArpUCYgI1j3EZ79FhYAO+agFHelkAlKVCYhEJqCjMgExPXW68HkoO+BOKv7';
    b +=
        '3yM1L2urveGQijsIAfYTtmvbbgt6IjKfQvYe4haNNawgnpLVwwv67+wlcduH0BcYHyWU+46n0We';
    b +=
        'bkFRKQ6eI0FH2kNJ3c25AG/ZBXHVDWOedHvs3lZWkFTYaIa/jGbKQPc4SOi45MmHoneJmjy1tVz';
    b +=
        'E9IUn1D82g+08A0QRNb3SoxySgCzrSxCX8F4ahbRSb89YCGUwUX0HzGRODqpOQCZ0Q1vwipFXy5';
    b +=
        'AiTnaEpcYoiYZhvDMuiymt1GNVmFLvs4jIPU1rW7Tl0lW5omQRi1vBolXk1jrwUR+b/K1lil56v';
    b +=
        'fg3+dVHsSZCKdQzPw9L5x5cHaRt+wTq0k0fGVJDqqJGHu5CDGsNhwBKv1AFwXd8lHCHayaDZk1a';
    b +=
        'VrzweUbYjFpScWCh5/9MRN2Y3IjYvQHxdBiUcStRz08QgXWGPvTzp1iOqKXumf52HXikLI7rlAG';
    b +=
        'YgL6Xjs2wrx6Fiq7Et0zmKEgyy0ZMGD2QWm4L54a1m4FVjW82iwJXf9V0rC20wAx3VFehYK2CTR';
    b +=
        'bvyV3PJe5boPj7m8pKCUrkfrnYDiUppGpDqP1yMBd99DR8wtcA3HKt5jPnkLoxRZ2IpVgCBkCPi';
    b +=
        'ajlcjx0bOUh0jeTLGRS7AHClq/WqIYoagDllAwjui61RRHZt5sdrZmtL2U6QjNSX3eNI1Tbo18I';
    b +=
        '5+NBSGqQuxcK3dzt3sZ2JrmHO7N7bGOY6ei62BjqPV2BnpOHwhdoY69+1jZ6xzRzp2BjsOL8XOa';
    b +=
        'Mfh5dgZ7jh8KXbGOw6/KIdl4DpM1r3o2N/ybk6kt94yIUW28xymR1obiDiX39yzYaO9T4aNBi/L';
    b +=
        'oW3xU2GjxefDRoufDhstvhA2WvxM2Gjxs2Gjxc+FXouFGc0+X/aOK2u++dAvt8LspPk2Az3ybfI';
    b +=
        'qJwAeW4fD1gw+o2VrpDNn7Ke9TT/aXXJNhlWyUHNMku2heLeQZhT/k2hXxWoUODrR2DJwms9A6H';
    b +=
        'OJthEBx9wydHyboc/EGfpMnKHPxJlZxsE25i9tn0vUK43Z6ILtcYlm4KBs4XsUWr3BvNKpSYcN+';
    b +=
        'aOUsxKPUFUYLMyZ9yS6cJkv9DEJoRzskWGGzzASSryOqvjOGdCEhPgSR3ynu4ITYyFgwldmQkyX';
    b +=
        'YQcVLuLktoISmNY4EItrIKxqADwaW2zQVo1IsKKBFxROKrmxyfSLVcFZO2R5YumEjUaJdxjeOwB';
    b +=
        'AOCsDBwOBRwwCMsKeBJuWKJCF212NRFzRXou1MNbWIWXYQy0xZZ2nY5fpCqItwzuC0q9DUHdaZD';
    b +=
        '/xtuvM98XvOvPBVwYiuUIkXRVpV8VruqolldCWZGNdlcFUXKerrHZUsG7vBNI70nWcd+YCNoOHP';
    b +=
        '8aVqQHcSAX14crWIQdDkbZeV7qhbfpG6Gknu97lpP5yxe5fZ+YJJX5lkNRDEKwgOkwTId7n6USo';
    b +=
        '+KfTGkKWu/pcPoODsg7iKRnEpOskgxd+sFcOsmcz3wbzXoUXB8z2BEydAZC4lCIS2/wKzSA82SO';
    b +=
        'xv3GU1OZ2rOZ2LLY6bPhY7HyY6IuLzvzG4kNXkKlHSPTKzXr1gqfsXQK2UmCk303PQneJRC+R1J';
    b +=
        'dI1rmE0OKUqbyr2FjzwXu32F0IDhMhr5FjoCo9nTuC3zDA+FGdgXwoPu0zA5OWo/eVgKsnw47z7';
    b +=
        '0KF88xrkJeLvEtjjQ9zI11jFKraBJcQutqE4nl4JWaIJH4hdi++2H8lxv4rMfZfiUlzSYedmcor';
    b +=
        '0SuN2biKQ4CEsDC3yuQe7RoQYQD8p09mIE8mHPDWPpnGfBEjNuHzSJ8hhCAzJ9ewT2bSeIkFCtc';
    b +=
        'ETORgX14syZonM268xAjVsW8sSw9Xpncq3bO9XrMkXqNMD01ykSe2z9yah6b7cQBNpx8R9/VcPM';
    b +=
        '42iRd7WxzPpsSZvSP+Z5vFp70rbmhbxLW9J95oW8XDvS9OadPi6D4hvmnbxN99UlzUtovbeyGea';
    b +=
        'jPi/b5BHNZmxQl+o/itAX8QWs/uE8Nbm2CNHeLovRF6K4Is2djAduxwgIxbxO97QzlbblSv8wYm';
    b +=
        '5BaXc1bcwAtQ5KvfegNLMutyzohH+GS53XqyTzYwKDMu53Z1Di+3WV/4iQZ2ZXsNHBE/8X45bT3';
    b +=
        'W+g3My7YabCIu471yq/V56zWwMjUYZSv91oA56ZZbrOOcD4IpyxrDssU5knfKzdb7zsfI7Cxr6M';
    b +=
        'vmc8Agwbu4XU5ZF762l3murBEzU/RAn6OOzibrB5gT5ZN7p+wqpxoQHAujubWG0fjO5iGALGOu5';
    b +=
        'oK5aTqaC9ym6WYucJumk7nAbZou5iG8wspN5yRGfMbb55yT+JyHqslqr3GB3ojbuIfPScS/zIJ4';
    b +=
        'PLd1sL2EJ7fxYaSoq+mMR8RFL3tEvPPkt9TfWf2d1t8p/S30t6e/uf4m+mteFo8MW0RZ8TYILOt';
    b +=
        'No7JOECR1AgSk8rqI5T0RywsiljdDLK+EWN4FsbwEYnn6Y3nsY3neY3nQ8UgPbtU3nIyLTWXrXJ';
    b +=
        'k8uDI09c7gJZrBhTSDf2kG59MMnqkZKCwy8FtkIL/Iyln8uQV/bn2kbDkKKHDS2LF5QprvwF/aE';
    b +=
        'Q4apl3igGPaOQ5Wpt1UE0xJhzlImnadA6xpJzo4m3ZnudEds2Pdg6APBiwERer3yDaershGB7lh';
    b +=
        '/raHSN132lvtsd7qjPVWd6y3emO91R/rrYmx3poc661irLc23LC35J0+yJWdNZWnNH8Hn80N7+A';
    b +=
        'TWbyDz+HkO/j0Tcjrsy/v2568oJXjoyOfgLZ8M1rmI9Ndzc13MgWA81puzAQyyxs75peHuaNvez';
    b +=
        '34yGGYhS6m9RHTbmVOy0+Z+PB7DvyNJJlXXX7gdvNue30Sk0/Tn+FHBphV5vaE66a4YYfcVh0v7';
    b +=
        'ruNDWDuf9k7DOIwM234rQ8aO/cAEM5d86Y8ajrA5i7N/Qq/x/yxVfgusIe1D0QHzJTAzHerz3+w';
    b +=
        'evGDJshpoZzeFRjs28OrMO07e+Ir5hccqi/huL0nvoTf9I7g3+dY5q4imiGDjMLLMDXyA3tPH1g';
    b +=
        'yjcllMzo/0Dp9TtOrj0CdOT9MUrPQRJ7yI7uDaAwno0DVWJn040Mz/JW1U9AjJlANPpuDXOIvsI';
    b +=
        'X+BILR28MzqKT5ML3A+cnuaDWnK9UZgDEuGjN2QKRAffbH3urZSbc6VoEqQtjV0iq4e6ZMHzSBX';
    b +=
        '/1GAMlfZgeNB/8WwPAmx6vN2PqCCIIx78DzuLQUHZoZpsX/CugkSqKpbMy4MySlTarVZiGtMi1a';
    b +=
        'YnZeZNzZ3DqlkBD1TL4nXs1N8n8bXsQeTPqdLAVZ59iMOTSqRc8F+Iz8WLReS4n6u8jcPWlrxG1';
    b +=
        '16Rou4YaMCLX7Trvuu3G39bgsT9dMwTUHbw+fZIdrIUtvppB4vC7s6v/cUo1J/wmMxH9QPfMXlu';
    b +=
        'btrbcQ7XvR1CS1ZC+rcBpF/a5xo+lrWbjtpJI7RDuDap7Ii3nB/c17nCQPlNbIz4TgjVjtOdEdP';
    b +=
        'Xac29FMemRtUqhJD6uCwhx7hUncC8dUIRF3gNC7IiuDRUK9cHTjC0c3vnD0Zi6cycJxo7lYgBzE';
    b +=
        'qIRcXXwcE4eMJxdIXYVUqjCeFGrSm2o7dpYbVTgTNqogVw9sOcGaDhhPetMdEFm6+S/BHSUjN4D';
    b +=
        '4qQTi3ZCIBxu47CI+glx7GtC5agrvVS6HEWsrfi2YjgFla+ZhgNiK88suOs7crg69gNma6VYkqo';
    b +=
        'tmqhVV+9SRN6r2HxE/3giL0+LHS88kK0f9YuDkqC8FTo76cuDkqF+q5ai/WMtRk+0A9rSZzYCAr';
    b +=
        'AMSmVIIJE1f+PqVnK3Gqlw5jIyhb+ZU28wcaKuZsGw2U4tNcMWA4uYNz6LGCvGeM4uVsadLEd8z';
    b +=
        'n4uFxe6/z6LsZH5D9wsVJFFnidabdb9o/W25X8S4tTkpKsyNBn8F7EAZBGC+AJ01BkhEzgwuUMK';
    b +=
        '9go4WD7uJbcXYfc6VY6/z5LjdOXLMOz+OXc6NY855cewUJ44NN6X4kFDfhSZcaLKmEHRzuQTVDh';
    b +=
        'ZWjFm3j+4HxYHp0/sI1i8OFCYUMZSbkCyAJAsrta0pc+1hZx+9GTo8tcUQTs0YwqkpuTZxqjNLS';
    b +=
        '53n7KNzRJenco2Sp3YYwqlwL4DCwUptwZY6OdpHX4seT51kCKdOMIRT+zy1ZU51xm6pM6p9dN3o';
    b +=
        '89RNDOHUjQzh1A08NTWnOru41GnYPnqCTPDUrQzh1C0M4dTNPLVtTnUmdKlzt310LJnkqTMM4dT';
    b +=
        'tDOHUbQyVp8sNJ85hL2xhBKeQWedCscO5UNzqXChu4QZpcarsnip7p8r+qXLiVDl56hx9KH6gFR';
    b +=
        'b4zl1LrA8FsTz2vddwitDN0lyZTnzHCIERYfOxr/4WE77bBHfl+jV0n44X5C3RTdANkmbeNhNOH';
    b +=
        'n6oPoSAQDLTRk+VXimfvIusOvKnWHFKP6rS9UNFz8cOPd/MvRyNxiTeLVLfspzU4H//TKcV/2pI';
    b +=
        'SPsLiTpuyOGLenhK3Dou6+FjcvhFPXxCHUb08Elx+nglcU4fqwm0P7XB1rWhI3vjucLdY1GQNiF';
    b +=
        'x+qOKokPND1trukt8Aq7YbpI9RHEigDNA2/cccJ2J9KLZMei6nnaMI8woXe890eyYJ5sd81TY6J';
    b +=
        'inw0bHPBM2Oga7h2s75oytJLFvurvd8SoU6rCDEs0G11cT2lfdcmPtPDCM1nSTeFl43UQuFKwnr';
    b +=
        'euFgX89P2VJ3UiQUMiV6vHrXEzmMZSsP9E1agK8mglY8VJ0ZJiCwgBboUoq4gTqnTy9E6d30vRO';
    b +=
        'mN7J0jtReidJ7wTpnRy9PIwSeMUGrtrAyzZwxQa+aAMv2cBlG7hkAy/awEUNgBsETBxKF3IDkey';
    b +=
        'DhA0BhFkF4vUWQd+tPoj8g9g/SPyD1D/I/IOWPQDKchhZAYzVUDaFv/F69yidjZXwScCZqpcjO5';
    b +=
        '7VMyQZ5Jxt2BaB8rItZBaYbLQkmC1itwKbHaqIrkwYi4vc5AAwsJrmelFC5UDz0kXB0luAfa+Gk';
    b +=
        'p+6GNg6oWTdPBUqOfYozhAWnzSP6CDs3nCCkioe5uRaozfwkh9Zmxx6yQ+jszQ5GjOZQZGnGccm';
    b +=
        'LJE/YfkmVWRs3jAYcP+WBMrHqnJhsVo6udglbhzvfPPU/btW1BYej0tz1pHf3PyEEFuSBX3aino';
    b +=
        'wcMUG6HdYfD9RjLfFq8mB8LuSR+A8YFkapBByQPQFU9o4NPmK70vqE/rNE6qo+HK6TuaNazKbqO';
    b +=
        'I/YE52cctIDl3agaWlUxAFWPruPfHFHUjcOXIZL+4YFf/WO2+nV+bVadAvsZ0Xt42GsQTPbzd3R';
    b +=
        '4KnZ7Qg/1ofNtdaXvqLoHExzWkvJoeNi52/BTRfUuytgMwyePVWMJJJFXasafTVAXCukjo0T6JW';
    b +=
        '8FvADiaxro2m39gUNiLxU01dtFfXa03dc3PjjZm7UWPYDDagUXWT72YlaxttyXpeXTIby2aygWt';
    b +=
        'btEObcKP2VrEMKNTFjq11e2HHf/le0Bwbmxfq6+FNq8E6h+vUWTV26ht3IEzLbldpa+bwfP8ySM';
    b +=
        'D5fJ/J9fkGac3suMcfccDXAJGsVluyxlB1qPBF3AG4/a9f+WyoXwFhvJmDEtCVAFJA4iIDcXtEU';
    b +=
        'z4MFPHP/v5nwwaZihVdQq1jYQGqQeBXCVQ38cXHYrxUrqZYdv5uVg25M3UEMJbe4YOknDkd6hma';
    b +=
        '4ooFtYqLknKnYZBL8b8dCwEvl9CWT5oZN4iirPCS6Z6n43FSn/OxsvoQllGdTcDpY07++AvC6UP';
    b +=
        'o3dOxJfU5H9ekPhdiy+qD2MDR+lyIldfnguzPD7kZX4bW+egaq21MeJ/W53y8x/QLqFrYTtM0j9';
    b +=
        'fHxAmvD1vseH0+y+WaqyngEbGly3g19cuNXknBWm77ak46rPi5GIJ/cmbiOtdUbLxz0atfS7TTh';
    b +=
        'FHuJ1JpZk8pWiKq55C6JZDzfL8N2LW0NoRbSJh6EpBzkamnugr+KK5BjdHzeCMKJ5KjxjyZf6l9';
    b +=
        'JBGmKb+VCA/RzmCyW3XMv5ctD07Nq8M6kVfn+2saHxO32qpeON2g8nkl3R1djOszMQTJyPOyOzN';
    b +=
        'C1/1Fekcwnu8aDl79fsfcg9FUvfw9NWtPUJ2yrD3XszCxHjxg2QuVZGv/uCcv3WgcyRYMuHIkuT';
    b +=
        '/cIocN4JL3ilBWCT+fWOxAzAGUZCskd1NEW0qHBnXVhGQrBIQ0tERSIR6nUEm2GEsaHTLogGQrr';
    b +=
        'Em2LItaTbIVEhgaeiRbIYGkoUeyFWKwk2QrtCRbqJlHshUktaCjkGxhKueRbIUg2YrwPIYk2Yrw';
    b +=
        'PIYk2YIyVk2yxU4hyVYEXiLH+hRYTzjpGc4VgkbXPKBdcz1o9E0xkrhG5xSkHALJVliTbIV8hQV';
    b +=
        'KsqWNxDj+0/hgv21PJghX4n9N+/ZgH9c9m4+kcoCP1dW6mOyJz+RYbDzY57sZ8l6YMeVSJXBgxR';
    b +=
        'gOJCY/LQRlZnB+HM9YSFSCc1DjMyaia6TAAgwSeZpkVmFNZnX50foJSKoXHrXj+o3PevnRN2Cys';
    b +=
        'rRYrz5a02LF1amP22Q0Qf4848ivzMXO5l32J5r9A4RvKr9VaPmtQstvFSq/VShON2aAPJoJv+Vq';
    b +=
        'KIq4Idz2ZVr3rA08YwMXbOBpGzhvA0/ZwLINPGkDZ23gCRs4YwOP2cBpGzhlA0s28Fpsp7Q28Ko';
    b +=
        'NXLOBV2zgqg28bANXYp2aRcIIIqtfqV0tEaIJWVqBK9NDShYOwF3KlRJhsOTxGFCeubUIOSv16B';
    b +=
        'VbSqaYyvqCKWUHPQMu1XFYwUngYWwjRPSWrBY7JI5MmaWtLmVE5EpCNRkr/B+HN5hvw/+JUzIsz';
    b +=
        '/9v9G5J9QMvakZDcqlkgi+GryXnttFCmR118i0mB/0ckCnnCr3NlLtM0HV8w5ISzIgTkX6UOzMI';
    b +=
        'agkZQt0TsuRhjYhrlGVoizhqBQCT5lViSz7p1RevgaHIB0txoZcpPiqCMyDNUDZJsuMbI/Kjjux';
    b +=
        'xKfGMyJ2+gVTW0nFcx0iqqxHecOb3e9VGojW005pIZW0hzVkDqVTyR35j59Q8mhPrKMUrvXbNvh';
    b +=
        '4J7eFcwzwq98TXImviXIt8Qsh5tY2uRT4h5G8k4kt3LbKUkEJw+FoknLJCqE4T6dUIzIQqj6jEh';
    b +=
        'LyYEETiah9vOU8YRAbFlxPLW7Y7Wo3s1atVk/f3Y3tdwCjFlo2Vr6xxRTDgobll2LysMsFoI83r';
    b +=
        'LhyG7puoFuEZZ0tNCeshvpHlnX0sqzz7iRdCNRNvyHjYddR1pj3Fp3LhDdPIoPih1DXJRNesj6u';
    b +=
        'RrdrvZLVROO/bhK9Gnk14LRKHTfrDShHzu6PrkVqEKKhhEaL6L9nqr7UI59UgxHm0/0xtxSI8Y0';
    b +=
        '3EK5bXEO26mGrg5zIZKMyylNBYlGq+akyDCx534wXH3fiYZ/C9Qb4XbD7zXOC/U9/j0zRefsx+y';
    b +=
        '0rz79WGMfiyTXs8i6bNY0hFF1AQDmjOEAeLzdWMtt2A33fszoWExdPqADgWu3P8LPYAh8XuXJ9k';
    b +=
        'iQDAcg+Wb5zJKjw2LFYUvjor8NUJE2lSdhxfHG5YEeDqrA9HxbSljzwTzLNxRSCrs+OQ1R7y9Jl';
    b +=
        'n08o4WHVWoE1d5Okxz9SKwFQbebBF1UGeLvNsXhGAaiOPqNCYPB3m2bIi0NRGnmnhNzhmMiLP1h';
    b +=
        'UBpXp5zg2nBQfZQrac2fIVgaM2sm0T/CRYEE1eZGutCBC1kW27AlGRLWO2bEUgqI1sM4LXhBzbj';
    b +=
        'uPw7zlmTkHudEXQp17uGn2q0NNEoafDSQs+3aDY08RETlj06UYFnyKyb+GnmxR9isiexZ9OKfwU';
    b +=
        'kV0LQN2s+FNEdiwCNV0oZ88xKrUQVFAVljNgdrMY1BZiti8sWlQupY2SctsCN6sFhboVMdPgiLM';
    b +=
        'w1C2KQkXhiVDZQJ+BHAffS6+p/epq36ZPgjH1vycy6SEA6DCq34TIbNgUmaXL4D0zJCauChGr1+';
    b +=
        'R/NoLYo4jLpiJiHIrQbgYR42RsaSVU8eKsTN9NNNAlq9CLj6OT6wVF/h+2sKiAklolzYr0kIkwP';
    b +=
        '0eoaAfNWHMjId6birTvALv1iM64b5+M3l1xi/ZI9aGl/NBMP7WybAmlj8FCvGME11jU3UzXh+nB';
    b +=
        'fkYhwyHVAY8Mg+oDnAYldJj4Ql61JBxUx0Y4hDZUdRl6tZdVxDcpW0dEsra6hvhrqrQrGkLRPTN';
    b +=
        'IeQkpL7kU0sUyBcw+pgZHjPkj3YsmmsGEnswYOJ9x11F/XgiB97ICyBnZWu6tT0nsKYmUmoouMk';
    b +=
        '8g8EmklBNPnbguRzzHm7URx3BTouViFeobXAzdimu2/Gr+GH1xIUb9yIK5cFcknjMr8SxXjgDFE';
    b +=
        'se1NrdSaGjQgQh+SD3sjK0vvdyqpZczraI4t6xpvf15IZQa5ybC/PZjuNtuxY0PKS4UcyBVD1Un';
    b +=
        'OFJnZLPPDHAIHgTF/yIUWPSysdHbEW+i4SxlTtlu/v5O3r2s+3dXMu7fYeS/LVgN+w3akeQtkY7';
    b +=
        'E46Qj8RrSkdTSf3iEIGGDEETJPRzDfJMWJHGJ5OuwHrWWgyMQSxJ4MBcj9t2qH+VI+ZSog4RKsm';
    b +=
        'XTuCKiAqHEELkT8XuVGKGcaBB7LMXCynElHhdl50YM2TSwea3EGhpnaTZuRBRyJVYilHQNDweil';
    b +=
        'Dlfq5liL10mYJnjEyEPhlwF7CDBOFmIXCGQzGNEHquJVbIgQWDLMmEowUco3B7D9pr4tlyeu/By';
    b +=
        '15K6IloVq1AjvZypTIejFonr62eiD5JIF/n8HXmtVzLG3ZHU1B9Kz2KC9DezY86NP9enKVpjvi3';
    b +=
        'zWCbH29ocXf3p5wM1dBONktw1+0cKJhIz9frejLy8gpSHL9NwU6lC5pDa7Ch2Hn5Nw6myoxB6OD';
    b +=
        'YNN+thQc+m4RY97NG1abhVD0Vlcjith6JHOdyGw2QFzqHA8Xedkqd1+VEfIXUqUi8kdVtSP6fy9';
    b +=
        'KADd0vzAHfKTWXvnK1xh3JacJTowFGiA0eJDhwlOnCU6JTdR2pY0zfDqcFWVtWWq1wFO527UtcK';
    b +=
        'XAZj+ppJU54yEfvKl9jM10hg5mMqm71mjkwsr+JGKp70USrGhDanmjlysck23kjLk0Ka0+Sl7qx';
    b +=
        'R8mxIaNJnSAQ0u+esX9DGcyJc2bZalhs0Irf+SIVGtKzT0qRGZNazaUIjUuv+1NeIxPpI9c558p';
    b +=
        'hB93f187LkCDME60JQUOoRZlAhRfkSBAnFiPUoJTyajMgnynCoL0FsWU4CLFDlltYhUg4CRqxDF';
    b +=
        'GGLldN8Fo5L9rvgci43YiwXRquOW4/pw5W0PFZ+zcRRc16kXhNucu1kncuuadZNLz3GbZHZdnk5';
    b +=
        '1jBlrE8l4l/boygxV7xP0WsI2RoJSG2cCsXxRog2jY1rsHekjlFjvbYFjmvDkXQklnTjhimEWGW';
    b +=
        'KErREKoFy6FpcFeLQjrymVAG2w8SfItLLBh0LhgrteEwYgd5hxWPZHrL6oaHt64Crr9rXFIrp/l';
    b +=
        'IrjPFYXYgJhhQC4+IwJlcU5KMQHwX4KDgnOnSUqKN6HYXtqHlHOTwq5UFED38o4kfxvp34UxI1L';
    b +=
        'LJ2VLyjGB518iihR3W9+A3hUbI/Aqdjy/wnUrWVaNRWIk5biSptJXK0VaCvOr67KlGerURy1nIa';
    b +=
        'ishsJeqylcjKVqInW4mQbCUKspVIx1aiGVuJWGwlKrGVyMNWogtbURCWP/fLz/vl5wH5eVB+PiA';
    b +=
        '/x+TnIfk5IT9L2s5T+ntafx9TuNbpcHTg8c995PKvvvQvvr4Ze2ZxtWSivvTSH37ya//6sx/5Yi';
    b +=
        'Bx14PRgc/8zOc+/IuP/uCff1Xjrpm4X/q5H/6Rrzz6U0/9kcZdNXEfXrqw/NyHlr52hFEHvvH6x';
    b +=
        'wF/OPUfTZb7najeV0MloxYxsa8qtnSIYRtawaunQkEsmvouY4sgvi1K9kRPabC3J3pag1N7omc0';
    b +=
        'OLsnek6DO/dEL2hw157oRQ3evie6HKnI4u7oixIb798TX9Hg3Xviqxo8zFVSBt+zJ76u0EQSFxE';
    b +=
        'i9aerlBZtvOIa6lT6AiBBG9jUQIDFqZQORGDqRVBZ8HF2xd161ySkdcT+sReZrxcJ6ajG6VzMD6';
    b +=
        'udd9UciKbfvw1X7Qqql1tUZ0BHoTOuiM8u+WKSqlw4KCRwwl3K+skbbWSX/GXbAXWsE9I6Ib9RA';
    b +=
        'mWu1halIlRnQltlM4FeSGQBBMyVxoQAN0EibMWXjAn+b0KdnKy+tMptxuLt5KHV5E+G7gW+/G9X';
    b +=
        'AyaHXdsaTRw1dkO057yaJ3XNw0aTGgmmSeHNmqTEi3hh2zEeYozLHAb7MlwCCmWm0Yy4NB4BkvN';
    b +=
        'GxIXxiGX3BQqqYlQ80Ygr+qo+lqgCWeJ3CSX4pF9SaVxL4YIowOIz7U2lBFkq3RZ4+az8WCodt0';
    b +=
        '7SIpVogfDUzSJ+UbiDFlL7hDcqQ/qUwhkL/e3pby7+WWDFWJQo7kzK6550rOgX8wK7y3LaqK6Zy';
    b +=
        'YNdO3jVDMh2zLlSGXc/nQmr2lJWYxnXWx2AxbguaWi0ZoWASTeYyoeYKcpUPrEaoowR4VLLLaoz';
    b +=
        'x3mlpvQME5t0zZtdiz5jorNrJfzy1gM+Zbk1Yy8LNTFl5lpTk3q0pJGV44wU7B7LgSwINBYWMD+';
    b +=
        '+V5cCxHKJm8Sh94qJkTjBUK01GTQTO4dvxmDP+PHY0b+JXd1jrSGJWXNidtWw7vgTd41XGdLUX9';
    b +=
        'XAIEdkT6bzqbZUF3UcaecbHaX1veiVmX+HGv2iz1/qSGS92+Rwslf8BRsU1S71nstd0MWHtrw4N';
    b +=
        'CVgUR1dw2keOc5ZntWxiqG250OtUOhpeoYNPc9wrZ5n6NO3hngdYaGhJd6fF1TPM5SPSSSgEmwh';
    b +=
        'YAKcSDjHVDeXcA+T2p6EC0xfCwlPYaI6JeFpTEmnJTyLyeeshEtsH5QS3on9hZ0SnsMGxJyEd2G';
    b +=
        'HYpeE57GFMS/h27HHcbuE9w4LWGsM7xtugMnG8P7hRthtDL9zuAnGG8N3D6dgwTH8ruFmmHEMHx';
    b +=
        '5ugS3H8H3DrTDoGH4PtoLeI+H3Yb/nfabfvvG6MLGt4wdYlJNrvAozTgzMzbshHGEGtmJINuulp';
    b +=
        'acutJQ0ZEY+U8Y+q2CfnVDeEI1+xUR/fOnSHz2i1CEabSy8ChZequwhGv2qif69Cz/+tVQJRDTa';
    b +=
        '2IgVbMSWsn1o9Gsm+t9c+PSvMHrWRRsrs4KV+U95C130KRP9L37hySsse6eLBsTHmKn38b662Md';
    b +=
        'M7K//8u//rNxiFy1v1a+GTpVELUx5EcHi169vgA9lqLpvyxFxT2phMigWJoNiYTIoFiaDYmEyKB';
    b +=
        'Ymg2JhslyxMImnEguTQbEwGRQLk0GxMEVYxznvwsLEqmK9rBCV/rG2Vi1MUWAxD+JnMlHfXo5I4';
    b +=
        '0DeUC7B9I6ZuAfNBYC9eI9AMA7Lj0pR7pefvfIzb37q+QH5/L25AW6cPy/AbffnBBg03nwAI86f';
    b +=
        'D0TmTpQ9qL7x9QTCPnrel9EgFfK8k6MB+WWrKw8DaNsd5rRG+c4i7sb8rT0VJsp0aLOGUqLPDJi';
    b +=
        'CN1a4zWPLh65vN/hgY3OM8w7PnA+rwzLB9iIdX/hItWITOSo+HHFhJRmT2h07rrAnhpkNWQvgkN';
    b +=
        '2B+wr+v2eGG+iopwCkYQTlMjdIxZFW7cocG3Uwqbj14UXm60X2xiN1bmAhDmYImR7LubkCcuiJs';
    b +=
        'sdubrFjsK6gXdO2SCkuPyCa3dNGJ+h6CI5+FI6TDLqGd/hPMkr/UX2IJ7X9+RNTs9JeKdPvV8vF';
    b +=
        'BObTn2KnkTltbF5/bbH/5RR+pWmybxSUGRhAgGowPTxR0dtyUkZCv6IPphsXy3Rs+cU0nLGPEbw';
    b +=
        '8CSktNjudaqdS7TSqnUK106d26tROm9opUztdaqdK7TSpLQWtBF+xcVdt4GUbuGIDX7SBl2zgsg';
    b +=
        '1csoEXbeCiDbygAXiX8cViJ+EyPfFmsrxffCQa2suyECUueFysS63ulE3zyuAGEBcFmyngn9N5i';
    b +=
        'xajwyAcc1xFDD0k590snFwLzTXGUKSctaTVxqUC2Ye07q/MJy8BHV607Bu5bvCtJZemKDdkCrFL';
    b +=
        'q6U/0Lkk9kVnHKpMppTUxZCHGNu75iIzNjl/42RMLynJJVPLMq2ThQ5Q50+xDtyfTsPpk0IE0CH';
    b +=
        'UJ1Cdc2B1NvDjD3Vz4Hg2CRflFD/mUDQH4meL0GJujYXJEKCfrYN+ucU8S5vN8zNlnqNNg1650b';
    b +=
        'wqNgh8ekBtLJmumS8f2R2njwG4CGrH11oLi9Taq5b+Jl6gEh+oDaT+F/5EvfZaph3bP2hiNn/QT';
    b +=
        'C+rlvmLTaVsYVT2TYcOt+GLcHRhBN8Q01ddc4lbP2gK22QyxlUHf42dNDGcPLpgficXjo7M58O8';
    b +=
        'OnojiliSUDY1zchBSWmaMWma0B5MCDTQTC31dXgSohyF+K+YXGjW5ALYqBTzyJj2SCNtBN4mdZS';
    b +=
        'p2jZUbYJVi4+bqjDXxKiRZxJ5+lJ9k2eoBC/RMb9TUnRKyk5J2SmZeVOlplO2jcrpYY/ym2/cKX';
    b +=
        'nZHm43nWJ+XadMolN6A9Ong2nTK+aVO5g0PYP+g9aM3b4qt45gw86Srm/LCLbtNDXYN49g805xN';
    b +=
        'XhqBFsYezSbyu0j2Mg9EuBtHMF2pjhyuWEEmzohP18xgq0dlIK++Voapeo+GNl9GULNubspoJxd';
    b +=
        'QQ50zT/GUD7wIWNAzO+JA6EoNmZdsECrAUKlCyIqtrfeLiUM8KnICVUtR1bsG3bha9Gwdc70GTi';
    b +=
        'Xkrv69bxtbw0jfNZqbxQXCJJ8NiT/qoM1ykvUw1w+Fw5be+KzWGudVshlQGqjPQz1RlVvt2oeVT';
    b +=
        '/yY8/LIh6bVaJZkbC3fAfaQr5eYbqdF4wnumak3LhvC4QIU05eDfRsXMy0f47tx1UOcH2W0jrXf';
    b +=
        'tztG7sVcEwLIJIpZKbXAlHHMF8UCoIFouXMNbuXvbilUDZCXnErZ5G+4SP95GiH4EvEsyiWi4/P';
    b +=
        'bXGgPWRspj3xaVHmXQ3Fc4N36IK5C5kPyz0d7onPI+U5uv7HsB/R+fDkdUcvAv/dlDCH4e7dQ3i';
    b +=
        '1LFTp8eKHQ7qHR28Lzkak+NKtgEr4jsUtzpxmekf8KrqEzETi9EpIS3xH8CybcGDv6X3Br0pw7v';
    b +=
        'R/F/yyBPPT7wg+HVZf/4nnBciJ0s4/ZQ6eNjedQM4/S8P2SRni8pZOhOZYiaHzQSdGYkduNGy0V';
    b +=
        '8zpCb4PYDY1caRTJS5agDHMH1KowMHHkioHwierzJT9xAIhWkK99ZDgYwKSCvPbmBgjNHAErGR2';
    b +=
        'gQ+fZegTDzcuzh7si69WpllYkLAXi/93BuLeDlFppn9NZCSRkY2MERlLZGwjE0QmEpnYyBSRqUS';
    b +=
        'mNjJDZCaRWdW5q5+JwAKaNYyh1sSldeBA8Hh2zWuy7FaPPnH+UnC0ev0bX//gaIH84oRQIbHdTF';
    b +=
        'yslj704VMP8d2C4SCwYeHeS+4VfafqzH8wd/KUaKODcxjdeGSgfgcjuEKO9eVdJDxmXyaqIkENi';
    b +=
        'EFMvnVzEoSh8WQFh2DyH1rklUI9Gzd8EFDRDZA++i+8G5VC73cxc8JqAYDMVChP7+WLMb2rj11m';
    b +=
        '7Cy6kRNi5HCkDAOrSBE3M4EEDay6npAJR1bIiwt4UviuzeAG7v/lV1QDgzngIagRT6biCbOsb/h';
    b +=
        'vFimDWNB/i7QM1oImP4P4vQtziqIJvI1ta0HHjdl8pHbzQ1bRCfPISC1bTfQKOaNCFeMpKVC+pp';
    b +=
        'inQqcMJbqv4yCF1EMHJHXcetv0rqTVsLmNHVqog3J9eCoh1oRWTxqX70ZGNN4aoJQKVBJEvVXEk';
    b +=
        'G7xS1dCPXjGUQBy8ppjSihr/5n+xjM2nQ4qFBoXLojMS2/4pkRqLj+hrHXXrGeKfChUy7jtK6lg';
    b +=
        'nV5ZZFrib+QrkQx7HuwDx/1aimI4oUvWk7JMMyxq5YbhBh04G1V+2YIVsNC+SYfylDh3DR3wBEq';
    b +=
        '5PgyFAyPzcSt02l0VVxM8F8PNME+EVybCozPcgogXNcI8XcOtiLisEeYBNAZ4ZNllIjyjxgyPLL';
    b +=
        '9MhMd4uJ3erOrQEroxR9a/lo/5GAKI3G6Iu0yWXdVE2Vj2FasxVRYN9IXsgDzMwtvmN5AYIhJUr';
    b +=
        'tjhcahS7AAu1Cd2AjKBqKtZlIYoEGv97E2PPJSHLGPEtTtZG1sEPmiiU0443RTegW65wT5hMoPv';
    b +=
        'GZPYAXJwx1InAuMpxbi75N0f785498S7G9598O5AQOvc4Tj0EgCOaNM6dau6Zde2p2f+OYkYIdP';
    b +=
        '541QWEdfqhD/sqKuWo5Hdyx2miMcllQNL+ajGdaRj7/UQOqqfWNdqmzrSdvbudhws249Fv3g60i';
    b +=
        'JjHTpKJytjrY5cTRnrzEGElhyfkEhZW5+oppR1Xr9DXbxsgtl3pK2GwHEelt/11KwbEtLY6O2Oq';
    b +=
        '1k39K6x0dv35a2x0TtREyetq2ad+teQ9o5pWrf8a6CFoX+NM4lTxBZl61DlokMNkarpm6hsHdac';
    b +=
        'Tx2nXI0b2F2jbN1z9x83rO/Ux69R9brVULY2ZknrpDjC47N2pIwErB9BWwYLpgNB6U7e24+2U9Y';
    b +=
        'Gm9PUvhm2jhgbvaXZsWiQONUDyltQJ5bxuC2HFGkeQRoFpJ7D6Ag+fqX5ifgNGxpbeIHegye/s4';
    b +=
        '81pdh8CKvpBawEm6oh1C5BuQh2H9hgCaUXsGBsjvnubx+zuN78+KIs9DKnuf49IngmpVMkacS0+';
    b +=
        'vTQLQ43zuEcGz0AK1hFd+EVfoTCtmhdJillqKK6qZWVxRTVTRySQ6r/EWH+AQaiYWsEiRh+oG3j';
    b +=
        'W1V4N8Rcbtz4VNdx0HjlojStlXanpgcW7QI3eojYAul8kQ40pWMZOOSJobccPpZbRT0ikRMSdZq';
    b +=
        '71X2A7gQxPBPYTFWp0WZGh7SjW+gfKtOAIBMcVKYdXXQXxkRYj5W6nJOsha1A0P1SKtic1YTu49';
    b +=
        'z4SBURESsiIlZERKyIiFgREWGNiOCalTKR0tkngwXExX9R+QAegt+g9+HPe/DnPvw5jD/vwp+78';
    b +=
        'eed+ENH1334sxd/bifpKqlY6W4r3rkRt/S43adOslOOSoT0reR35SVvhNQbxoRnsJMWdOFHdpAz';
    b +=
        '81w/OKquZfLEqcmo4rnOSoyx4qr6zF5kvl5kb3HsdIwx20V4c2zEuMjM++ZBfmAcewMaoW5O5JP';
    b +=
        'OJdSTvWy0WHXRTQfIPjb6Q1WwTffIHjZ6S3aw0Xmyf42+lN1rdK3sXaOnZecaHS/71rgPsmsdcb';
    b +=
        'dxn4T2y441bprsV+Meym41bqnsVeMOy041brjsU+P+yy41hgPhhxSvAqIdLtcB+x0bdZTJKvnM8';
    b +=
        'pufF2/nupMosBVP6CpKMapTubBRlYRiV4F543Th3QQPcdobL6ZRLOzzS6EASZV9PlvDPp957PMd';
    b +=
        'j30+a7LPZ459PpkZtsA+34ZzVoN9Pj8sDO5r2ec7wj6fkH0+ORCa1317Dft8C+zzLY99Pp0ZtMg';
    b +=
        '+bwK5ss+nM2WCN2Xbss+b1+HbQ2xS5HviD5QxuOcfMEctQiThvv5Pa+J50HIDpsUdUUs8n4kAUU';
    b +=
        '04nx2ewbsFRPRw+TrVTKhCsFjEIC6uSV9uTj0fV3Sdj5V5fifwWG8PS2wmY7jE8DA7zC2UcmRGT';
    b +=
        'UWFS3fSx97sSQQklo6ctJocFQoJLg9yteRS0EhMBLv6Eo+d7z5hmuWe+HBX0J2HFXH8D8P38JNd';
    b +=
        'kgp+TS14NtHJWqxUFqzoaMRp24gb1b5rzRQ6t4cCoDWj+TfWrHg8FqqMGfEMssZHxAOCbcFEINg';
    b +=
        'R1ASCXcFVINgT5AWCfUciA79roDeE/5r4DtnoIQJESLADe+GN2IqU4CZsRoZKgx3YC2Nj8zVLgx';
    b +=
        '3YC2/FpqSlwQ7shbdhW9LSYAf2wjMipI7gLD6v90PaCD+3qp1saTmStcsjzrlOCVWbHgHBmmWIq';
    b +=
        'AxvsD6SiaHYLGReyHfmm04JGRdZxtc3gvGCyX0tQMlI9uNjQdwKpJE72kqCUcZeZOzwkZF8kQIv';
    b +=
        '0eIjI/kurZMEfKTu1TcWLCyEUabTnRI6sn1j3E6aifOG8hb/M0rEY8hP6UYzFZ0yM8wtZj45bWa';
    b +=
        'P28uZcra8df3cRxeVcrz7A5Y+SgYyuyBZ+8nVBqYNrK82bW3kmk+uwkAtJOFspHsWEVYDbfB0HV';
    b +=
        'yqg9dDF7xWB6+OI9sjrPSNIdsjrPWNIdu5eTGGbOemRRPZ3kCyxKskJDNT4//BW50Ii3+MWUgyc';
    b +=
        'ilUOdfwUtvPtdytU1b73hmT3hkbG2dMeWds8c6Y9s6YqcPLt3j5d3j5B17+nV7+/8bLP0fbVq5d';
    b +=
        'lTrVwXw71jxUEkjEXrry14Ff0aWvBF6pX/UOVv+Td3Dl697B0t/45yyF3jkf9g6unPIOlr7XO1j';
    b +=
        '+mH/Ox/1zvs8/54x/zif9c57wz/lBd2DXDD+PnRvzWJQilIP++Flqm8c0VcVf5jdD2Y77/z1NzA';
    b +=
        'PLzqnMvDM+biyj10OdvvGRaFEiIF3gpBkW56IgniCkkB8iNoIbICbPDPK0gLnAm56Jg1Z1kknUm';
    b +=
        'iQTnUjMzIIeIwF2tMXfKZBvQEEQRBiQfhm2+ZsPO/xNht0VoUnqrRw4eUIcGh/m5mrhjj588Xu8';
    b +=
        'o7/5xY/9yXZ39PUvXP/5He7o+hfO/tmsO3r2o4/+q1vc0crPfe7K9AkKgJnX92LZWSzbi2W6WOa';
    b +=
        'LZWuxzEAzv6BDKSlmrQsHRtUyrVJ9bXJMJTKmEhlTiYypRMZUImOKP+sUU2Iwv5CGkxjM85an7J';
    b +=
        'tHmR3ZTROPO0zdFCNLzuWRflk+Llmh9fi9PC4vt4/Bz/0Ye9d6jF01T1byhsRW+pm6GaUXia2TN';
    b +=
        '0+RRajotXAYkD0bmYKjJK9nwqtIIJbXJb2qSdeRRDyvS7quSa8hiZhel/SaJi1FJom4Xpe0pHjV';
    b +=
        'U0gittclndKk00givtclndakx5BEjK9LekyTziCJOF+XdEaTnkASsb4u6QlNOosk4H1dyllNeRI';
    b +=
        'pxPy6pCcj0siZUXw5Fc+NS6mgXhNLKjBUq0r2IJrkDbJun7tI89F6b8PLo+1RP3CTxWL3y3YT2J';
    b +=
        '/WnhzWS6FXe0i0mgwK6mYhC8IK9nN+Hwryf6/vNWJ9GSj/sI4LSNx0AbniiCDmvSrGNucV68khe';
    b +=
        'yuPx1aRSH06lpruHxS2lxQsHqel17BgnYZhjfvx2vfENmbJejSkZezzVaB5jyO22zgrVFcNr0lj';
    b +=
        'Lint2h0lURT0jerVknoFdaYrjbo5b4vE1q3hN5GUXcdc4Zg76lGUCR2E+Hb4pcvFQKLyeGw3mWz';
    b +=
        'FWpLNHubj3iKXUjpVYFkkxrLIFUVzJx48igfFpMYV7Vi10HiXUuJsyuzEkEIeP/58AIDNiWEOAz';
    b +=
        'YrW/etmItm962cIEV+7mjPqjkszNLGe+iuxJWI0rhp8RNS0LB1H8mdH6Iscdl6D3AIBwKHeVhTE';
    b +=
        'e/UnLV6WCqSm4q0WJED4XetjFUGH6m9I2nnq1gvTm6L9wqlc1BFdwT3i6vgJeKJ9x/BadoxS3S+';
    b +=
        'nFdWVNsiwqg0ccQrDWKlggEsORixknJaozHXgmZrbBlvrTl6mlxpXqioE6Kd2IZiqFditmKIWwE';
    b +=
        '8cjhybTTxVHCXm1OFerq9P7ai9gZtH79DFWZYR2dcN10L6tEUaMWEiCQwvUuUPC3eT6VRBOq48L';
    b +=
        'a4BMKlmqOjwlz0wBDMn6GQ5909qu68V3ZFqrD4BDbRabeG1a5Rpcvt8y50uwvtdaF9LrT/iA29E';
    b +=
        'LjIi3XwxTp4qQ5eroMv1cEv1sErdfBlDWKh5c/Q6wfS0/u4GP+nPOrr0cs82qxH/xePbtGjP+HR';
    b +=
        'P9CjP+bR2/SIKwMHvl2P/hxH56r4mDAGawcFsnkRAS8beXjZyOFlI+Jld1OBA3R7byZvInnzN5M';
    b +=
        '3l7y9N5O3J3mLN5O3kLxTbybvlOSdfjN5pyXvrLEFpjEZqfMGLm+geWe7j6ehGbWewvbDw0Q4CR';
    b +=
        '1XjblHlrskESpCx2rTTMolSfhvmkk9SRKmnGZSIUnCqdNMmpIkYd9pJk1LklD2NJNmJamkTnkzq';
    b +=
        'ZSknRQ0bybtlKQ5Kp83k+YkaRcl0ptJoOELTK+BFc5TqrbqZtqVZF4IF1aQVbrzxAnbl6Rm0LTc';
    b +=
        'S8slrWfTel5aT9IKm1Z4aYWkTdm0KS9tStKmbdq0lzYtabM2bdZLm5W00qaVXlopaTtt2k4vbae';
    b +=
        'kzdm0OS9tTrY8pD/PjYTPIlwYmfl792O6fLAcHhlm2OoQV8kUjjdVwA3pCJucvSo8Dt8kkOANc2';
    b +=
        'BAU8BC2/pVCoW31NiQcdlmqAska67bkXcpFVqn7B4huLdsHekO44P4KnDmHVfBdw5J455hBR7re';
    b +=
        'iruCUS7bF1buHoq25Lqx2mSBc4dV8kx2Y/EC+0YyfJkX1KQz/z4kYAdqyTJQZnTgsKOLl68KsiB';
    b +=
        'LJhe9QRZk1Brcmcf64515ratU/i2wPTQwsE+tqQ0/ZG6MMA/pDhj9odHjZlvofdYi5Bz+9zhhm8';
    b +=
        'lOxDdF8o+N7zHAPsnKSvmcS05rN06+OVIJR67OUx328rSkaneRpIWcUrYI68f5umxwHJZbfJHah';
    b +=
        '+EXh/EwjOInlbev0aJnBbZEhvFR0PTc/fITSO3Ox0+JLFi3y9zp+JzaZjqShZhPrhVPazY/NTzQ';
    b +=
        'svMbc27EoUWc977tuD+vqxNs5dNT8rIhF2EAUovQ9FzNO28kys/UOgtfk81HpOuvBaSqvcgjHdS';
    b +=
        'RFJ4Vu3b1AmWFXTP2B0VXcX2mcpIq2hIKMw/qBnRxGsZuiIxk+JqletpcfXsU9jNmeZq3fSoeJY';
    b +=
        'bX+h2M8CUtjtEFHbFqUReBXdRbaqRWZ4q3USL+S1M9otYJT7qvQeJEODCfUtXCWRXHgSELUqQjG';
    b +=
        'SlgHS7QfEXsKZ6xNVWx5SUtEwP9iMtXUNri89kjHvFZ6LzJMWnNywecsCnfwqw9Gr5J60csEZcs';
    b +=
        'BFlAFGkNY03lbtpu1OBoXgVS8WrTldI3qDdgfWED6xiVGAVozCGik9n3HyjBofWeNXW+F86V5Jr';
    b +=
        'WcOVZIyC4FLiZgaSA/4ew8RSKYA85PHYnsstKc4Rc/XQv5Q0ZqKXlO2A5ei5pPlL3aT+qu5gWsE';
    b +=
        'TpYu4ROqEq0E9maTIRHXWTuQzvzZrL1tKveSkS5aUMJGZ6kUsldXZL4b1NcdKESrEi6FXCrdVbE';
    b +=
        'nno0btz0daa552Om5c5jTnvbjYe13W03a14SXZMYCoyjCtG8V8rgvO+wsVrvGnm7P/00rjufYqs';
    b +=
        'V2puBprycXPh6IwdjW2CmNy1WvAvdVlXkjdJbCokLkjDlA5Ra8ojQ9dSwN381XVBipKLVVRupap';
    b +=
        'Tx730UB/LzIspcqwrCu9Qm2U0kqvzHrSK9M3kl6Bk07EeZmvL1ICYqAYTDO189RF5lVc5Frgi4u';
    b +=
        'I8soHrPCKyKycCcdlVk57MSItshSOC6/sF+GV948Lr9zfEF4R8RC8ZSke4oRX3m+FV654wisPWO';
    b +=
        'GV+33hlQdUeOWBdYVXznPoXG3Krty/J16ObePNTBNgVjOAPhNJQDuLekR00LR6RPK93R09EUuQ3';
    b +=
        'PNnhDNj2afEgB7R2Vi91c/EVjUF7PPRvVRCEj0ikgc3tVKsqqKeSE2R/UdEY2Rejy2zPCtxbHe0';
    b +=
        'HNeKKMtWSejyxxo6Kh9bK3bywkdrTaKgetnm+IMk6p/sPkKTFZ9xY9gONpCPfLCR7OWDTeQ6H0y';
    b +=
        'RFn2wmQzqgy0kWx9sJS/7YJoU7oNtZHsHTICM8ApRXHl4OHOu4tGuIb+Dc0NVGSLtfDlsy8DvyL';
    b +=
        'SwKzPJnkw++zJfnZA7MCkdWzT0ts2nu4wWhqB6XOCeP9B25IEsAZguVsoZN83Zfg6rySHZ4yx35';
    b +=
        'LZycqXc7rJss1lyyYLJy3Q5sVJuc1mmbZaeZMEcZmvZXymnXZatNkshWTCV2VL2VsqtLssWm2VK';
    b +=
        'smBGs7nsrpRbXJbNNsu0ZMHEZqrsrJSbXZYpm2VWsszSObO9Uk65LJtsllKyYJqzscxXyk0uy0a';
    b +=
        'bZadkwWxnQ9laKTfWitc2y5xkmaPdkZVWCXt0RNN3Sfqu7p8mUedk5CQI3P7LCl2ImtrZE97sEi';
    b +=
        'rXnLErZeyEN7vUtNxLc7NLTet5aW52qWmFl+Zml5o25dJIrOommJo87SW3dtdzTE2e9ZKVi57TT';
    b +=
        'E0uveT27nqmqck7veTO7nqyqclzXnJ3t/Ak7gJSyEziB5N2qhZWO44J9C48TmL9QFLyYR8pIaJl';
    b +=
        'yJOJh9n7EkkFcRx35HgnhRN2QE2AxyW1CHZA2YDHsxRE2AEJAx5PU/lgB7QKeExRhbIHCW+v6gl';
    b +=
        'ydCXHHLlvMXR2QFaBcbsIQpRGFEONLLhWWdff3FJ+ph2p/yu6G3Ql0E1Ny4HSPWY+Z5h0NJlNkj';
    b +=
        'Fmk2SM2SQZYzZJmswmSZPZJCIQoArL7rFhCmQvSNrnBTucVNcegdHbHmbk2YBJeRhTwMM1mYnQh';
    b +=
        'Qxt1ojnEjs8zOSzZj6SeUUfmlhBM4e5Lwn/sZjM7BX2Q8EqMiEcg44uMFTcqqwQqnaD4lZldU9V';
    b +=
        'GhS3KitzcjtDxa0yVKreguJWGZpTnQbFrTJE3CpDxK0yRNxqoCw5+yRE3CpDxK0yRNwqQ8StMkT';
    b +=
        'cKkPErTJE3CpD7xNuJXCr5LLpNzDjddAvu+zuDB2VkjOOW86destZYGNp2fHJciWy47nahcp/Us';
    b +=
        'e1gbkfyk6kFx2oPwu2iFpefKSVS6Ry9L9PoP9obrVSkUyI9dI2sbA/exWdiWLnfmts8w8TZm5KM';
    b +=
        'Nbl/52ohIVSbgF9nmC5SIDx5hC+wjCMkjLFekmXB3hBSKakryMjqLDSSpGMIKrZFyfiKAhjeqZz';
    b +=
        'MWSB5IzCtDgUrSxYv0HxDsFzFrgIn9EC31y19iR7IsR+kQrPYZWmxmNDiRokEqn47dnIfL3I3uI';
    b +=
        'wahDjKOGiY728aW1vFXQKahv8XdX2osqGsvPLBWhb0ESSGhdCRxIKiaOqkZhXma1wqRWm5hhypw';
    b +=
        'LPY30Lujo5XLtUt0XuHj8yXy/SVjcbw+hZNsu4+891EbMQtYaTsjyUDCNxmZ4VIkmhFGkBlqxEb';
    b +=
        'i01em0erGPA37gfbu9WpNMUMcKDwHrLJgZoEx7EI5NiwaAd19oo0T8MA2CWoygk7CeSb97zAdfW';
    b +=
        'QHESxHgRt6pXv/x8UK2aXsOlIDlR7cf8bzVQR5cyPNiPhVLiO7iFxTNG1vuZDiSIwfKc9aI2841';
    b +=
        'e2rVFs/LPXFMn6JbzcsjrE0JBSZta42FvV+oqg2U2eHZH6zQsCCM5YRhUV6HVUSUVSI3O/HZwaG';
    b +=
        'YQQ4QE/vZB1TnUjyrwPgOFy6SoW0UDNe4d60gGJ6cYyjbMYYZhWr1sGlB8NKUOOXdtwSaA2RTd3';
    b +=
        '+Fyzl3Wk4K5CavOPzGV6Tx4pJpfNA1AGVik5eornVsA0Hn9dbyEkLVTdT4gOekuQyvCnWxOejn4';
    b +=
        'JwMumJpr32myoJCDHGQtrU/dgYEgxjFF75lvvbixoNoF3oM/7n31M6z/8JWvr8FYGLfKeAZ+4fd';
    b +=
        'btM7LOjNMeGTniTmPXtGjnt0a5ZEYH6/qkUhFXdejaR69pkezPFpSOoySR6f0aCePTuvRHI8e06';
    b +=
        'NddO0L7sJdgwD7wHTwgMyUPf45NGM6NXq3kvPSGzle28iGkrsykHmltgYxvbTMK6Ojz3QZw37A/';
    b +=
        'QFbHF1eBrkZCT0SRggvGz3E8BbqI4YVOEwCNUzmHU+Y4KvxPWxZ+i5H9jQ/akS1REoZexguLucH';
    b +=
        'et6nB8v5JcafrI6NTpZdUiJhkbkLVzYc9ih/YWynLpnNoM+cs7n6de2Ja88g78pFYlv1YLyePtu';
    b +=
        'eq1Owbp38jB3pOrzkOsqUQA8ijNFT6td1Jjwy7OwEoUNOHzvczgpeARF5pXLsWaDeWRXfQwt6kI';
    b +=
        'mi4iOAE50cVbA34ntmzN8udodoHFbbwHxhLI4yO1ZFx3mfsFvUIqFuW9zHKn3J00esPsj9g55/U';
    b +=
        'PgHU/7BtH8waw/agFW0TcVykhLZ9fq/1zhYYwPkHxjCm2pgbEEBYdJ9LRDZrHZykjInLqFsU2Hm';
    b +=
        '9oofUT6Uxrwqc32lBcVTkThnZWUuPQwhqbYZOCgNQyU3N6WLIrzTO3g7wN0qiXJMw+27cYVeMph';
    b +=
        '+k+SI0++uTL8jWRjR6XdXJm5dmX5HsiKi0+86LZe0nk3reWk9SStsWuGlFZI2ZdOmXBq1UaYked';
    b +=
        'omT3vJqbx8I1n00Ol3nZzJ2ziSBQ+dftfJqh0n8qJ2+l0n5/K+jmShQ6ffdTLV6eCrh9XCb+csf';
    b +=
        'L3ptzf57txw8t2pJ9/+5Hrn2OS6HJtcz9ppclpPvlNvGs2uY917XsUjbzqPT1DXTr6jevKduMl3';
    b +=
        'VE++I3/y3f3DJGpBYwhYBbgt4WcjQQ2yHjE92ET0A5yX8EMsRAH/JfxsJp4CLkz42ULgBbyY8LO';
    b +=
        'VCI3BBg6+wbQP5Dgx3GblaURrcvu5oZIgbICLixUTqvMk3oreNEdMQp3EreUGK0BUZ84bC3cYP9';
    b +=
        'TdKbeUhRUtqjP3Gkt4GE2UqCk3l5NW6KjOXDQW8zC2ChKsubWmvpd5qrGsh5E2RWa2TWXfCirVm';
    b +=
        'acbC3xYNJom5drGUmWXugI5906Z9Rf8PIRH95wKQkblRqfbY2aikPMpO3bd0UxYzzkhH1FxnDjn';
    b +=
        'hHxE63HynBPyEUXI4pwT8hHdyA3nnJCPqEtuO+eEfILuM25br3TE0mYuUvx5YvUR+XjJhkUuOsE';
    b +=
        '2HmCpeUSRIg40Z/NW8bev4DTsQj79Bd2bEIVjGsZwkTTm5gVVzqO/KeaJxWvmOyxl0TMcJjzVFG';
    b +=
        'UTaFZUf4V0ZcrM3m7jLAgSwvYDeOpT9dWgxUtPbLx+9Szumg74Hk7A8YRdlEREg+FPHKOnaf7G5';
    b +=
        'ADABFU9ksUdHESCs5J/2s3hMZUIuRdQ7RJipEFg/QhMX1TPfIEC6Y/9lgqkV+d/00TMVa+9aBXT';
    b +=
        'g0pAfgNZEOI2uGxAJOLUrL1/RzBb/dEXdDPCtPqxSyb8yot2LwJxxY+nMGrfUh/LHPi30mGgLMA';
    b +=
        '0EljaJzPZJQgU6mBMIenpkHgOZPkZ3iEtwG5ic4UE/XnTcu4i3sGWU6ykuplz0CTGxw4u6lILRA';
    b +=
        '1Dcar4T0mUyag100xqa4z/03FLf9ucN6YcFX+cmj5Pis+2gNNJsGiJPTx8ZMUPRVgyStmzVuK72';
    b +=
        'MpTu2MqN8+NHDFeLlDXYVr8pcxIMSLfFvQGLXWCxbrqSGb5Zq6bysoJkBgVfEU+RK2IkkrbAQzV';
    b +=
        'kxybaZl0yQMcLhSfjIU+cLwJ6X+pJkyPNWFamjB7gyYkol/NVuw/YtpwNanbULg2TDXb0F23LBL';
    b +=
        'm76ZYeURX/dvEe1cbhu9qvicupfV/lcrvlwVEhOvP1s4gWmyMYqWPbVKoSSGTFPADOzmSl8L+I8';
    b +=
        'Q8oGfPm9ES1MHqsYt8Up/6nD6pX0vCjvrzCHPPTgfGiu8IjAEjDuvJnjjHBAdNisXk5k9hVyBop';
    b +=
        '8iLc0oERklogVeH8BvwDRIfqx6CVxe5tRVEo8AgwYeUst5D6M9OXepJlPieuKBA8m8w7+SYe+kD';
    b +=
        'fQ2HtWOhjK56ZcjkS48Nu9X9oyo9Lka1VMy7ftC4fuBfn3c6KTtww5mVl9YcsAPmTHNzD5QfQ9+';
    b +=
        'kZtDJGhYbm+tcKnAO9OwVWaSJCKmKj4HKpYeb/tcBSEJNkHyOGRZpqMbNTST2esFVC76IXYm9Zo';
    b +=
        'mBlpjVJWZaYoAS210pahaTZ9zAnDAsc5b58NT9a85G50a2V8Xzayhb5Pz2yGLVIaEsiZXAAwamK';
    b +=
        'QnLWjPEtekeqetGLiRLu+iDUwbdi0nNWqK0UVTnKb4/VDEhZTERtq16U55rk2MiRrI2uTbSrk2u';
    b +=
        'S9nRVXhBKvxRdN1O/OvSDV/0bTIpzJKm5OKn1bLLnkfLZJEgnMR6e1tfLonOF4fq6iarrEeVYiW';
    b +=
        'pvbvME2LeNFb46pPK2GTq1i3+GVZ2QJcUKXfLWRt4wgbO2MBjNnDaBk7ZwJINqLddbL3tYuttF1';
    b +=
        'tvu9gyIcaWCTG2TIixZUKMLRNibJkQY8uEGFsmxNgyIcaWCTG2TIgxmBBvqE9RO99tOw7iXvKI4';
    b +=
        'Hk9VpULi3YtUQhBPpcIMBEjSfy58CmSYVTjX91QSsaGUtrUaJK7tTbSDqVx0abGUIqFq55DKfWv';
    b +=
        '+1aGUuqGUqp50psMpdRWxg6l1AylRAmvPhlKEB8wHUqJHUqJHUqJHUqJHUqJHUqJHUqJHUqJHUq';
    b +=
        'JHUqJHUqJHUqJHUqJHUqJHUqJHUqJHUqJHUqJHUqJHUqJHUqJHUqJHUqJHUrJf/ZQSnQo/UISJb';
    b +=
        'UTlbyWxImKrAOE7BBduMH87K39YXBQbOASJyij1zpVweK/sVMV7C7MP9SpKlKg10NCArtXz+XIO';
    b +=
        'fu071QVwWUnGneqitariHfqG3sh+ZXpiliftG8fLOHb4gfUqYoMCtZpeyRKf647lkO/c8QhaV4g';
    b +=
        'cpLIk4oenxCGUG9tN12vwjGxbj7wF6IRm+GXPEgazYaPU6Pd5ol9a41mnS5Ezu0qEKt4uRavDsD';
    b +=
        'EwwqJy9MvJU0nf26JfELc/PuhcxvGLpJjEqvcJNKGei5UuNCUC0270KwLlXZNtWrjQyIbhLJVs4';
    b +=
        '4ffUY/+pZsLeIZyNSPvgU/evrXA5GTHwJxWKp+9Bn96IldJy8nEgcp/eizmQHs4YYffXoDP/rs/';
    b +=
        '5t+9Jn1o0+bfvSbfQf4//n/vRt95JXiF/n50PnU/0ES7rSr/CE5W5SHJ6l5eNKahyereXhaNQ9P';
    b +=
        'XvPwtGsenk7Nw9OteXh6NQ9Pv+bhmRACnsnSkpi6rY6mTE08JlsTjsnWgP3iVKhoTKHIqUWIakb';
    b +=
        'PG8WHlMoJZfNkXra0vZyooiBFBpFgP4EVIbQTK39z0d7BRvw8OKB0+b7BFEGqg81EjQy2EAQ52E';
    b +=
        'rkyGAaPw8NthE9MuAO8onBDBEkQku0FA5uIYxkcCu93sPBDmJJBpwonA4HAwJKBkN6t4eDbyGqZ';
    b +=
        'LBTQCU7wehTRuazvaHcaP5uKqfM383lFvN3azlt/m4rt5u/M+Ws+XtLeav5u6Mszd9BOTR/v6Xc';
    b +=
        'eXRxGKgU4dEFLvVna8l8/I9dnXsRnDyPJ9EGuGIqhG52ICDJgYAkB1ybKAZcy8AMH1voA6Iqk0F';
    b +=
        'bMHdWdjQ8Zh5RXT3dfA4yaQGXnUOs7e44vjicWJF1083+guWkLNPlyNZmtvaKrJg2shWyvNdCtp';
    b +=
        'zZ8hVZK21k2yDLghmytZittSKrpI1sG2U5MUW2jNmylfH1UZNtkyxDdpEtZbZ0RVZGG9mmZPmyg';
    b +=
        '2xdZgsBbTtehiuyKOrlrhdFdUXUdMe5hUWsrsqaaIqbOGViunZRNEPMpgXi7WRVtIWYjSYms8ui';
    b +=
        'OWI2mJiWXRdtI6YwMRaUVU4gZtLEtO3KaA8xfRMjehM14O0PEofG0I+V8JrCHScUfYOevmqgn+l';
    b +=
        'gFmnNm61qfbnSbOtKYqL+GnJFY2WVeBlhMHWEBjBfMN/1DvjxsBajL8fifDiI6LhEdzxupBLtYb';
    b +=
        'EeZt7YkiXFsprnm27evYTxI9Rr/FaVUJbG1PmeGVgEXRCA0j2n9yCmAZbTrokFgamN6wntKRsna';
    b +=
        'wjRyGQzn9UaS5EKlkIgKilwFMF2AilSAim63HnvwSJT/vsY/ioxVxHRx+ZJu0elpU3QjBN4m7NG';
    b +=
        'oAHlCl8QBpEgd0LVAMaGbkQ8BELUIA1xCQucCRU4Q9MJd/kg3Yf4HBdmNg+AhCoemL6WrxBCBHZ';
    b +=
        'EcCPEJ8mYXNttyWMns9gyPgRuQPPMm/uAB2I3ifDMzSE9TCEywT+fRKnYz5cC61hT8DuAZQSi4r';
    b +=
        'Hk9esp16m4/qUaHyTPCkZ2zV3G7F5hjZ62DgOU6ij2xPNl65wwbL7zULL/gOxaSx/t5hY5vBiK3';
    b +=
        '20RxsZAKLx/MANbJwAsoi3eRqEtWoNtWOQnZHFovy1bGV6xMlKmxUUm9mRJKx/Q7eQHV80n1vxh';
    b +=
        'ouAAZOGLyyTFs7As99Wr9HsHXJK8XcqYh/YGZ4nZnVi5uHORIBroUoSWCQEaFaz3fXJXaefbXk2';
    b +=
        '9CryFPo1v0qfv7gdv0KeUvJI+NfdV+pTVbbNrH5Y+bXN+07IW9rr9eokwh79vY+bZHzK37KUf+r';
    b +=
        'sbM3UF/qsdM09jG3lszOQjHSrDluv2WLodK0I6njLX69wzWa/XE+n1VHo9ll7PhRakzO+EHXbnI';
    b +=
        'lY/XUe3RUwG+kLDzn190KN33iNvTvZ59gZ93r5xn6fr93n7nEAvtM/b7PPY7/MYXU2nbDugpWpl';
    b +=
        '+wT0mDmO6XRm6mn6vIueP2E+1uzvuNHfUn9y9b6Fmoc3qbk8gTequWjQs+Y6WjryIHbZgIel5l1';
    b +=
        'T8w5rztGybu3/fr5hln7EDLblH/m7e8PUFfiv9g1zWt0wr2TCMY1nPypugw1tl5pgIpJkXfd37C';
    b +=
        '6N3Z0hJJVL3TXJetokWY9Asq7LTsp6II6E/YgTr+hvc9UowqpRZFeNuJDn+FTjmk81rvlU45pPN';
    b +=
        'a75VOOaTzVey6car8OnGq/Dpxqvw6car+VTjcf5VEX4IS5+IXabJ9dDlbPAAqmKOIuYLmnJMGmw';
    b +=
        '6rpyMl3J/0d0fmyMboAV9EZYvLxA5cMGFW1g5TqpxuVF5utFUppzHSbbes1O3nrfCuOfK3hXMrG';
    b +=
        'pX/PxAbIkPTdS93lCW+jrJbCWWDAsg0RcvIjivSP4VogHzItX8M6+eN3Cw3m/7J6niMgtJoQ87M';
    b +=
        'FdJulbR8VfRqC/mDKTWimyGCgN9/So+Az3o6dl3aDgNndMp59C1hPghRoK20QOfBh3NOfIvxEJ0';
    b +=
        '8Mc4B0Y9jdGdoSK7AgF2dEq/s9U2o+m24b3Q9mN3wVQZ2w74Y5gn0WXYPla0CXPfF7RJRa18tTn';
    b +=
        'LWolxqW+dU0X8sF4k6W//HmHXTE9LeAiAXCY/sdElLNZznZTbIna3YWpUbGS4EsAYU3T4d+qN6H';
    b +=
        '4voh73mVbFCGJIMI01d5AvixwAjdYX/08jIygenEciWOGkenFt9LTqBqABN2f1m3aa26b1ty1X0';
    b +=
        'nlwzW3Jy4kNL8nVgRR1RNIR0JCOFko9eAcwBqVNk8q/mchxDhTP1MqhPBcdy9Gxc9waBGEIktUi';
    b +=
        'awaZwqFMHP9u8kdkTZjiZ3gI3CfULXvF4L2fXK0V6pzu1xw3kR+GwdqdfZfrhI8zJH7Lsl8Nz4w';
    b +=
        'AAjHICE5LB3xCiu2cwBfDTaKMIueg14wF7f9zItGHL7fFuQ6+EtzkxIOLjxOV4QryWIRkuhklTI';
    b +=
        '3vFuqAJ4ccs3P5DPdAdAUWKohjkhWXcbATABzFD+YkT+lvAHgiWz3zIMavJLK75dj6fW/SuWXx9';
    b +=
        'R6KpPJbnVmVUf9VfM5eg4H135Vh/2/1sFyIbMMhHSbL34XS0kvxZbOTpQysSvJKJNQ/MeQiwgSV';
    b +=
        '1wGa970iFsH3EcozqbiAkFF7/nRbQG/D4mKiybA/9io62TFg6lvo4z1G0zviT9QPfdTpqK/nw5a';
    b +=
        '1aqG6FsXQ6BpPPdL2Mu9FtkK/isgpkO1ThJuLmmevV6WBCQCrOP1aOQyG+P7WkQeAdsLaOQPiiD';
    b +=
        'G/iN+vr2a7aqfLcEwfBpWoxl5580vcH7Mdr2Rra6uI+1Dvb6BpKek96ORxwep6b/X4t4MQTRCKY';
    b +=
        'gSliLNt1cvUd1el6k30ubBg/ESbsMXsW+O16HmxcN2Fjf/yUxgGG4X5XzGZsTLSMV92R2dyfihR';
    b +=
        'ZUeQ+MukA/jGrZk+flbTi0jhrF+nn301+wuYFhd4G5jPipOx7VuBV67t8UXQtmuDOVNC2nVM6Gc';
    b +=
        'hl58MvQJJyDFq64yN2KbMCco3cTZsKabWA4t3wRia8KJ5VAZJ5bD9Sgn0AHnUYPTpBRZDhvUE2f';
    b +=
        'DPfFS6jUPHBUMLqWj4iuhBCS9WKVbz1IK/yqkXCd9y2Op4JtsmdGpdJjuia8lek1LQKUXOpPa0v';
    b +=
        '+PWDgXzqYAUWXb1eYNJZPjqIgtR8XZj6G7YOxffBzM6+uwVcRcPhTP1LRbs1CAMgPhJx51H0/ut';
    b +=
        'phX8pm0zmYuK2QVT9l8N6CniKtnHrUEFqiW/LnscrBVXW0IOTKuJBpYJpPqsvrdlEeGwTgcs7p+';
    b +=
        'lV9P2IcIViex9PyaRNKhkQdmYLwe4b6zRtEa2F4oJ2thmsKFWwikArQ45GbancNwhqBTAddNj8B';
    b +=
        'klpD4xXw0hVYtXAAzmxmpIrQ79n1P9pvPexUexcIxBaxwn7m520/tlwPmcCKymAf7eCNGd/WFco';
    b +=
        'r8nWrDJrLcbtJa+I7exJJI4VglloTrgJPaAfz2RMWn0y5n4IQrXvi154OqEK3rVz8DL8kXVPvY3';
    b +=
        'MYXVk3EvzNxz8P7MKdhM+tQ0maOgwyijh3uoZfQ+d96Xt2GSPFrXg3fL+K7pquwh5LCj/LUZym4';
    b +=
        'zGteQPip39ZrNsqXwqfrwl/8bVu4OfEyzlnK3kSdTn1hvE6fSG92qede9C51/UW91OvunYhd48Q';
    b +=
        'fpDVW2Bh8sewyO3Artp4/TttpJxYhjGEgxmjCGYXgeJnpdyKk7pJMc5wTWfDoKQsebV4zsbPgKj';
    b +=
        'ETkeJT2TDDH2xZVatwnlV7LxEn1sPG3lsy77e7sacJqyrFtw1bNZf5BYJD4i6+plO8ph8LJd9p/';
    b +=
        'T0VyglLMB+fMO90dY/9AQJNvn1UfZueKzZlHKxrG6ZiZVgAsymr+BBbPM3NoTiiA31qO+VL7JRE';
    b +=
        'OsW8D4HlFw66Zt/2JEcu+zeMmoWjGA2csbzCjQYTRwy6yBh01Tc+R4T9E7anpT8AOoc7quUZjPR';
    b +=
        '5iuR5kjw/k+r8McEQfz9muri0AyInYDTiPl4OESk56a9SDXyZnsByu9SADcpIlYvk8RensJ9KZH';
    b +=
        'Vk3qpaYOObm+HcIOemOTfSubfO7XbuwHNTnvv0buN+XkhfyAxDBplQgbizwlxDhhtLO9UTZh2iS';
    b +=
        '8Mbq8IdVNe3SAcGO2nRO4j8g9g/SPyD1D/I/IOWPVDgkBIxwbkbczTe99C51BYPVAAsWInvRDbq';
    b +=
        '0urEgq4TxceO02OCSY+sTQo16eERJRFVAohJ+OBBFrzE7i4vI4IG3sUJpWheO7ClBGuuPZ70Zq+';
    b +=
        'tYk3Fl0JSVZNq/1GFZs7T878GRHLVa0qLKvS3p79rlAmj5qJZXGU1TTYoUe2y2d/JPTePC/ZB0f';
    b +=
        'Hp2o7XXk+l1xPbf0nd66n0+nhSqEk37fV0nXFW3+6/xQuHDa/xYoCVVx9ZWS2dXOzKa3legU5QB';
    b +=
        'jTTwS/kgPoJC0nxk3lfJqcU+QyK11tcbga1AFHPxSUQdb4oltJd4lYAopHKWJJR9QKMrVAX2czb';
    b +=
        '86WMXGdmtlKMBoGFwr2bU+XPR6I1KHCGhN9UAhuwcpbCvunJazPHDX3GGDf8g2/aI2j58Q8uiEF';
    b +=
        'X/GHLiveYC9IDrLokFSQBqumvur4M0tBmZfmH43s0tPUufqxlLKBLLt9F5Lu4Nh+pXFFvr3SWyb';
    b +=
        'NetKFJVPGpHOoSosFouyDSLohcF0QWzMFa2y6IbtoFUum1NRGqW9wC2+sm4+ciRsTHQTdzrHrOF';
    b +=
        'Ih6nbRFw9mlBEp6QWBK7tr4TopOa5eQClpCUak0C6H8oLLdryRhy7xnhkIGuVTwz6EZEDiR1YmA';
    b +=
        'ir/vfuXCceF1D0SKiQoF2axwXcmEIFcZxXzGuShyOVSmAFyEE/RPrGxQsjhMGCRJ0YiE5PIwwZC';
    b +=
        '6MDwrIbJBiXcIOlSWcdGniS6z7pIQ2aAYIhsUQ2SDYohsUAyRDYohskExRDYohsgGxRDZoBgiGx';
    b +=
        'RDZINiSNigyrymvVCf+VQx9S1jHs4AI6s8DeaV9ok0DE/+vaPMov6QihF8kw0/8YS7IdR/Rp4bq';
    b +=
        'DVQCUkMxWhGHnvw51IFScvS6FdMNBWQ5Do2GutbVD+SOtjoV000lY+kfjb6uomm6pEyr2r0ayaa';
    b +=
        'ikfSLhu9ZGYsVDuSNtvoUyaaSkfSHzb6tImGypF0lY19zMRS4Ui6kdHdr8aydAERRqEMafuUIW2';
    b +=
        'lDGkPQQlHqewGZUgOypBcKENyUobkpAxpC2XINClDlmKPMqQFIhJShrS+SZQh4AoZtEzFcnDada';
    b +=
        '1nWovGnzCvZ5Izc/ulmdsvzdx+aeb2SzO3X5q5/dLMTcozt1/awn5pS3fsIKOuLB35eiwdrTUsH';
    b +=
        'aCOz4t/1GDpuLVsO5aO0+6N07acbjm2rMHS0cIV22TpMEV4p3dUZvDpJMytD1RKFDnckGLlDDZm';
    b +=
        '6V1qVKlnH10qhPSfqlLc6hSXyHnQcNP7wssqqvRWJyss7rU4bmLFM5/OdsREJ9NaJ62GkoRN2qC';
    b +=
        'OXo40J+iYQ+piRbVIE9PdaSGJpsUfp4WwPV1FoCIV1EpcWvEp7Nt/CkcNsSoeSjz2hHMvCy77/7';
    b +=
        'D3/lF2HNW5aFd19zk9c85ILXvAY0uJ+5w4L+N77Yt4z0h6xo+oZyHbQoCde1ksk5Ws5T+SFdYZV';
    b +=
        'h4zUhSvF1sasAIC20EYQwQxWGAFKywJlMSAABNGtrAF2DA2JojESSaOCEowiZIYIoMTv/q+vau6';
    b +=
        'z5kZWeZH4N4bC+Z0V/+qru6uqr33t78vEyEoo2pSM32MvTEq5L6C/DVuevqxWFqQC7JVWynSGuy';
    b +=
        'OBcsei3BUrVhLGlLiRcjcu8BDIOEVqcqU1vc1eqvuWonUeOk1WzVLRIZueOQkzelUHPJV0gsEMK';
    b +=
        'DiwswrsFVm7LCbsdGtKfPG62AUSAZvVjanOg1nfdlyHYjCQNzmPpHL+Cq5z/PUM+D1mmT8XKAn7';
    b +=
        'mj5fb3+vlZ/r9Xfa/T3av29UtATPf2P2Jb1k7BwqZwnAKuX9lpFA3Rf7lN12+DipN67HMpjyH5p';
    b +=
        'ryoyPbSTSF4/LZAhakfTV+PWhpEx3BSaw7jMNyLBOi4IJYg3ovcTM8WK1Dz9vaaTtBOichn2ZOY';
    b +=
        'z2dbyZ+iQduWMCpoO/bOtMPPUvO0ikT6Os9JUCL1zJBfTbSUU3FlYpytHco5d77b34cMCM8k/gm';
    b +=
        'THQ3OHo/L/YkF5m9tU7njYOzRTyTaZj8Vxs2uYnhtmBKXSc1NNIsz2GsoAaCqyv4T9+CKF7emBw';
    b +=
        'zWx9QIVstrFIJ0BDxEzEbvw3iX5LyPGQ5HEVDYBiwEnHDbMIRQhxVDDdZ8Ii0+Cf9AVl7RFp7aA';
    b +=
        'MpVhI4vc2eunuiYRfBD9K/FW5jlZsjrrWpltmXYVbE5t5SuNErPFvUJTArDOX67Zx0qctOhPQlV';
    b +=
        'eXBMcZ1QJwTV/q++a5tmuWZ4PpYRkK4lfPcC7a6YQeZkEyfHk1LSrjgjFRnJR1wgxMQmtqgx0TW';
    b +=
        'zmYTzhv9YnvGf0P+AJ+7GQTxWPeKeR56iPeLU8Pj5ibkK74RFjA7SM/REj8oi5/3I84p3mR/eIr';
    b +=
        '6o94p1m8Z+EMsr/IY/4qvojPqvnGmHgEZ9FBlI28yge8dt0sN9jg/v1P1CJ1fiEXuMTeo1P6DU+';
    b +=
        'odf4hF7jE3qNT+g1PqHX+IRe4xN6jSb0ilkxa7rx0v7dH4O/b9YM+nitF1yNKck63dEx2BnWltV';
    b +=
        'LPUawlv+dyZc3JP7dYsjnfzd8Kri7aw5bmAiFjO4YGd3uC0E2t/vQWvlvnaffnXshPgyImKWeiQ';
    b +=
        'Jc6QJsIrmDKEMo5IkAjhV5HsvsZYT+Cc9MenZbPZozYwVIexlf3G4Drpy4SK/C2MZYEY4k28VF3';
    b +=
        'fiqESt8Zw3Mvl8kkQY36lmiPvUqzqDZMMJzFi8Cb8abimwHyZDgEO4h2WnGCnkL92ew3F1bXHOW';
    b +=
        'qaUbRxLq1jy4f1Y4SPM3NOiHtLzU6upSl8ClxMC0MzMvFF0kZGHv3+8Dw24MLu/ZH4LGZIpD7d3';
    b +=
        'OLYGRZKozz0ky+6Jw3UJoVkREiLCNcfJk4b/zb1wbjwsSNik8EH1UALZ5R8RiyqMHZp3JeMADdE';
    b +=
        'E7UygBLLC8BOgiC5HtdaXQirxUzrFe5bBTkae8DuJbbgbJNUG91mDpv0iNr6FXj2B2Q3DrSYJb/';
    b +=
        'yo2MTVGjAd1sd33N71U0SrCt+C/6aaCU8P8/IGGZn37lOgTkQe5gFFYUsBDAXl4TvkCwZcSS5Ju';
    b +=
        'KdKem/R1kwrvGxORj3mPXx8XLU+/zrsDdw7PWYcK86ps8VAgQje1g0Vn5FqC2vRmTqYqPgYwg0D';
    b +=
        'NEI4zAmMcdbXs4emII4ziAXB25R8kBu21He71Kx0KLl0rM04OCOmWSS4lk2W6lQPEJjiNzMouQY';
    b +=
        '8RwHJFrYHWDbTg6mqdTTyu66kwIeEG8p/1rEiuDW3+SeRxGXnAMVwL7gHfJv7QilwlmG5xzWwLc';
    b +=
        'jwx1YxjVVB5jfChUNRW0+zn6+I9siqCyLSSYirrZqpP3JCiWSb5z9NoCWuqTyw2Go4zEE5m0QxV';
    b +=
        'VivBXDlGtZa4uXZekU4ioW0ixd6K7Kth32pT7LpGtX9VvUr0mPanaiOFvcQ2bYiOcNxvSMYqV8w';
    b +=
        'tB2PJfVitlV2kGqlUIwgM+zv3VeEazVdfCd0ubWeKIbHopK301KnsVikGx3UBYU+U8o9xRbljOT';
    b +=
        'W0Eo4DHqEiNsH8VoDNUYVhpuW0WGF7euBwpSIR+m9RMu4ScajMucBde/lreP61AHjtvoKDgwXzg';
    b +=
        'wW7kv4CqnLfxoV8hFiYiDaX4Z0Swi3J7g0ZieHQaGO6KyzjTRl+G/4ONxdmmk6PBNjtPsoVFrvm';
    b +=
        'iCRQWjGxGI/rHtO7B3E/3OwRZwM++Jlo8DPR4Geiwc9Eg59pFfykIauBbnL/Mfh5KtLz88kWkUw';
    b +=
        'vkfztKo387ynkf9+uYfp5eeACRJ4VMJFwBboHccfhKKRhzKozRZWu8j4tLelm99Slp2dspaxnMb';
    b +=
        'Gr1PUoee1Oe8g9jYmZmTfOzMzsmfk715UdxGB90Pbyz4hYnGuTKxR0R0k9N+WGnh6gC1Nkdpdqo';
    b +=
        'Tb5TZLlIpMT6gUCSnEs1dyXlngaYsoKynGqsxXyjDLAPAZO696ayR/CeVucag3cmSaVLLiDpHal';
    b +=
        'JFwp0Ssli11JEJshHkhAoEQdrJLfESHeliinIdBJnnJUe8p8Kdkd7Eo0epG/oJA45G1i/ryg+rt';
    b +=
        'o4bNuOpO/P+DhPzl/f+Q3oi4T43tQg84uUkepM3oKLQgZL77g4GDB/GABelD2zSxo/UlizvWs+J';
    b +=
        'aOwZuNUoCmouVGKUmkfCBY0c3Ua0gY9rDwjBgEPcBsB3oREZtbhpXlMCXdSo6VFaKb1j0LK2fDp';
    b +=
        'HQro1h5nkiwdZ+PlXNEUrs7hpVzhf7jPJ3qc0B8oy106m898qIbV7Iq4n2v5FT8zrVd5Fyre307';
    b +=
        'hgjXtfTbDxWtYqRYXqwozi6eV5wD3o562MksCDuNcbBYEHZ6fr24CjuN1oursNNZ9eIq7JTXi6u';
    b +=
        'w07J6cRV2ateLq7DTcL24Cjtl9eIQdmrUS6uwU1IVW2Ws/5b3PVlCZ4nuVO1ChhaCcqGV6W+kyo';
    b +=
        'URLA43t4FyodBA9JCxIioQXaPKhRH1LvHajleZVRGn07uMPEmZVX0oltl0pNKFIq8DYmr8oXSh+';
    b +=
        '91lJGcqonZhBBR1mHrPsWRfreQoS/ZUJZoMsN6fHRPz44nMrLUeT3HyIdjN1RAFFPbuNVb6CwqW';
    b +=
        'rHH1oOzGfGDPIsHFbmFekRPtbwpHuEUTwcdwiJKAkeBDFGStbaWwKB73zqbU6+sNaQuu02WwXBW';
    b +=
        'abwM80IOspRICsn5LBcaOy9veEsDT7lnf7ddOxtaK22Em7WNLC/POjJESFnJyixnCrjtq/F2YQI';
    b +=
        'QCYrto9cz5uTEMRlkSGjJ3wl/ppyEr3YsyK1laUEEUc5CSFnqJk7EASqtV0YgVcddZt9pVijI3v';
    b +=
        'idurRzvBLlNMiIrDxsOEC6x1HOaCS3bLzIZ/CTEUADiTuDX8Off1Xd+XJznj8/kvK8aSbyJ7yaE';
    b +=
        'kmMbrjMSI+pQ3xzVt2qeXljV5qGgMjnSak0yZ2oPTTMxZRKI+cSsULwRGn8kXYSe+Af9J+QwZnL';
    b +=
        'ZuLFxkjaa2dBwqz2ybHm+4qyzR5/3/HPGzj1v5aqf+unzi073Zy742f/j58bp9bnpC+61yfI7m0';
    b +=
        'QXfe/zwI/7tb/H2gq/9udYW+7XHuxb+yTWzvJrf9B33Hux1vZrt2FtyK/t6LveU59zay2/9o9YG';
    b +=
        '/Zrj2NtxK8d69v2hb5tn/lc/Xof/ly9Lrd/rl7P38HaMr926qhbe75fe+Jo/Sx/fbRes68drbfZ';
    b +=
        '3NH6HX22b89P9q3dibVz/Nrv9l3hpr61px6o1/OfHqhf728eqNf6qw/Ujzv6QP2pfBRrZ/u1Dz1';
    b +=
        'Qr8vs/fW19z5Qb8Fb+/a8BWupX5vxe7Z2qlk0G9xfIr8mVGjep4vhX9y6QRVWxnEWCJmajOAsEK';
    b +=
        'I1GbtZICRsMmqzQAjaZLxmgZC3yUjNAiF2kzGaBUL6JqMzC4QQjuMy14UrTkbkzdP00pr8ywYRh';
    b +=
        'NZiAGRxVMkNLwFCrjYvCkSuNi+KEE1K7XEUjOzbdhFA8oK6LAQl99VlITD5zOsiO3qAsjhPkOWf';
    b +=
        'mJH6mxAx3iONSl3ynSEgoc+CMurynCjYLs8Q3A36fME7oM8e0rT6XkCeVt8ZSNTq+wSZWn3rRKr';
    b +=
        '22u6y/jAHLbhoXH4K+RmTn1x+MvmJyjAIugYZ8S/xMn2D2+HVbYV3dji8rEPhLc3C69kM72UjvJ';
    b +=
        'BpeBOtfwWTn8x3b+CN6y0JTvZvwmxMYUSJ3GEOhSU385wWVwvDMR0rqm9mCwjrxX+WQPct/2haL';
    b +=
        't9Eh7w4NjkHi91gK1CKjcyKsludbdKcImbKSLyyycCKYiVESxA7VkCqqA6kiupAqqgOpIrqQKqo';
    b +=
        'DqSK6kCqqA6kUorvlFz5UuVW0ZT7klqEHYHX9SqiTdkxEepseLVck5J+nVJwaL8uhb7oAyFHmrv';
    b +=
        'DO9zNYjUVVtI/cHun8rpu7JW5+/mM7tAALBVwBbcCYuPEtRi/A8rTlE8z1awHlHYUmNAI52jd6K';
    b +=
        'OiTZ98LFmVWRXIFuzETMoXiW4VV0uowqfMpLRFmn/aIlHoRAISFCzts2olIO1oFgiA9EK73671C';
    b +=
        'OKIgHJ3gru9fKJoih2nPxRJAfC2CNVKWh5LlLkzxRxMmDvT8rFEidxSOU93uNxrZT7s+oT5se4Q';
    b +=
        '83uSXqfFT8i8wOw6d409BSzu0Br7ZCIcrr019iQmjLiVlvcaJby/BPnbRaYbATu6j8lMC+8uWez';
    b +=
        'uktrdIV1s3B5POjzBvKZDHUs6zCI+aJFSPW4fS+AKLfRGzvP3ofpePKVuCZcu74GPTK55CH53Wb';
    b +=
        'zbejcXp63N4PvKNJGdb0LqHjs+Y/8SnIz9S3DCLvoSzFvtTeQlQNpuCjZfvgR/wpfgqPUvwW5Ta';
    b +=
        '6aDRl6C283Cl2Cv6XsJjtjwEsza8BIcsuElkIxfvgT32NpLsBf+lPI2E16Cg+1FXoJ5Z0oes/IS';
    b +=
        'PGrDSzBH0IzFS6CpzgnvL4HLiC8BNuIlOMJnuPDuksXuLqndnbwER6y8BLNWXoJDVl6CPUZegnu';
    b +=
        'svgS3Gf8S4D7qL4FuCZcu95vwEiDXWV+CvSa8BCCPXvIlcOaOewl+yhgf3SSj7kSUfymWYdttfV';
    b +=
        'rBb3NpJRK0GKyxAjRquCzx8LvFgI2E3yGspUjCRUCOCkqcI5GywPvSCsMo8TRGp5oaSbP9AMiZu';
    b +=
        'iErqw1WaQmMIusBD9+QggNdF1BDarpVd9o+yCLlNPaw15wPJAKRohcFsMjtqFckQMlYwJgakeNZ';
    b +=
        'F5wLZf5cvOO07zRsv3egNJMwm6lCWwFE+Q4AGpv+iPlYS4Z8VQiSjD2+Evfm4aCyaIAoQ+aihr4';
    b +=
        'LmfA5czDq+YzKhJCLoGccFJGggXKd5PVErxxxV/+km1acVz79SZ+faWQXcoXgSpFnSKU/wIhaSs';
    b +=
        'bIWLnvE7PiJynncPxb5Xg5BGlRoEcQbCGZwwGo97KzkjPCNHHSmGTFwlTQK0bk7EHHSIiSc6aWG';
    b +=
        '1WqeRllUaIXm6gtUxShW2UuKpV7QCKAb3TGyj7eh3MLmXAyXMYGchmkM8cX2vZadgzl04fYOrs/';
    b +=
        'URHrSOJO7dZv/pTbeBOAGLd/ilnFRz5V7U2g4pc1Vhk4jwqSQ0+X8VSyvSw4mWRhIth0NxckPu1';
    b +=
        'iJpxlW1TBXnfxeW6U5RjYJaEybMf4k8oZOfkMTOmGu4s0Tv10Vk9X257I1M/y0kDqlDN/Oot3a/';
    b +=
        '4rs0yCd/bw/8Dz4+eiaxLaL0jUtqDMleRvNkzfwPrlgsy4TBiK1gkE4RIBJKzupEJb1BCeV2bbR';
    b +=
        'F7SZo0wBiCRJMpk6aJuYw0T4nGwaw9YFTyfu5loVJbXuTcZRgev2k3WRKuEVKYjZxVWnvFOppRB';
    b +=
        'AoQQKnlA8tWYKaMrWt+MbSx566slILldfGyLi11ZE8UijARiOgBPxpTmUQTUxnr5PUHKDMFeEZJ';
    b +=
        '0M1AQGa9sZ89y8Des7iufdl4R4rVxrNs2xBe93dATxX0nioXXzp1ohp8hvwo5HG8HorQMr29cqS';
    b +=
        'FORAonN4w0fCb9oz6/u22XuICv6anqAvbZL5D6CxwPFzAhff9ISCrnmXL2UQJBZpJ4KmpVoqUFY';
    b +=
        'hBI8jyRuj/UqWoFHBNaCXjolqRpatKT9ELM99ydmDEfTKJtzXzJVRJD6FolnWdQKZEAEUMRXeTp';
    b +=
        'd3IJV0i4aYWENLpNrJwlYQ+JPZ0toZHuEFZGJXwigajnSYiFKr+d50sYRqJS50iopjuClTGhvT9';
    b +=
        'XAEgc5/NUWb74R0NutZgSmQbDeux3Nn0xpe55xXl9+0lICRcDZ3uRgxQelPAghAcdfHFuH487Q0';
    b +=
        'pqxRcjdHow0qJ2vMR1pEgNepE3liK17CXMI0Vq4hdDVZHa+hL1kSI1+oGA90Vq/UsUSIrUDSBkh';
    b +=
        'lKUSKgoqUqsholsVRRrmOje0A3MBPqK7bWv373OOY0+192BMhx0jgxRfsxiLMJqx1lspqMMUGI4';
    b +=
        'CyhURytnTa4uv+qqele5fMqNj8MbVxa2x2zkieXXMG6wHQnCkPdCdx7r7hPJzgVHRNAZx7YZ+yr';
    b +=
        '3N9vZSTfokLxIVTTYFapjQ3XWLqwNzIu++phafdY+h+oQLVy+wVw1IpTh5fFvHY5KGnTuFXZNOJ';
    b +=
        'lvJQm4WykfddvyHcI9gkPskoe05K4kXtR36FdiO6JKOYFTdf0kIIIAiFKq5ig+Wc/niW8iE3bN7';
    b +=
        'lAoXOe+VvdzDB+qL5yIRCJvjAGuNoJfQiEKNGIiOMlVhOf9ftPLz7202xYqz+QKmcJcSc0M6dJH';
    b +=
        '4vUK83Czz38TJOYG6UhHFZHJTwxSofuFTbW7rIgRaWupbjEuB3klH/0bInZQVwQ+GIhLY40LCrA';
    b +=
        '2/xlKp3dE7E8a6eNGCMpiYjfb4lBp4FVaXmT4yYth/KwQ0jaVD4yFz7NYIUvufnJZctVfriFJd1';
    b +=
        'ZvGinlm+cWkk9veav88js5PbsZnOGk0omLZeXt79KQ3hE37dpW1869oZuIuDM1nSGxWyRB8SARb';
    b +=
        'WdKOkOLt39TJpvaFO3t39SWTTnVfWubGiLsTD1nyAAXjbCp+RJJl4VCA/SCi2bYlL3Eqt7vKgoL';
    b +=
        'F1nYNPQSJtRGL6JAwFBNtjZW7er0JV7yz83Hpg5g18R9VhTBTeX+iP7UbVltm86h2tyWeKlc3a5';
    b +=
        '3GTOB1W1v+O1J2K5zrVFuby7crvOvMW7PFm7HTWOtGLr+LqJ23Y7uaa8CvpeT5/nYBzgIWQRg6y';
    b +=
        '84F4VPdFkNNSkfLDGhRbVVTN1Zuv3q5UTEKqQTdqoz+vPrQgn+ouQOI8JysA1+Za0XnsPa69Z6Y';
    b +=
        'TqsbVnrheuwdv1aL2yHtR1GVm+3xODerDNwYG7X2JNG6+Lm/VoDH2uQ/EEppKyRbFacCKCDulUs';
    b +=
        'e3+iONykKZRDVm5ErXUi+CRlicWyl9j2d9BzowDS1B82S8RCRvhh/cxyzHVq6JvCaB2j0Ixy7es';
    b +=
        'E19AMdzhPD8c/YQRl5B2RCwH809uwP+vgBEKHDKwfKDdSPluQCVCe9FrNoMy7Xg5Dnn3+iO2md3';
    b +=
        'Uj+mEVmmby7uKbycSh707ibXUE1iNV8wH+oBvAEasl7i0ZptcJ7IL7adxb9jM+7p2Sb5rOMMS93';
    b +=
        'Zje0gOS6qT1M4Kq77RnTPrOKHNuV9lLI8Iv0ol1Oy+LflcWx3f+P9E7ZTHb+ZLo7aa8cQ+Jwvja';
    b +=
        'lAex8sT7fGLdD3CSp8NJYpC4RmWhwoZY9gEKqwGK98d2yD1yr+Ujvnc3DThQUuvG9WlJ6NNG7oL';
    b +=
        'CTOjWEtGhT7wQ+EhQNGfPppuz2mbVMGfnppvbtc0qRMO+TTfntc2qU86uTTeP1jarMjl7Nt08Vt';
    b +=
        'tMLXL0ZqIIvwpWAiR3gvz86IDgfT4geN8eELzPBgTvEy9438K6OAFgtbZdXZbVKmKwz7Acg652x';
    b +=
        'Eveq5q9G1hgW1bKOvf5bjetaxIA4MTpR5XfsRtf5CnFigfqUgv3JWnQi6oIRKAk/kt8kZsNRG7k';
    b +=
        'n48DnWka6EwbMqdqFoN7Q8x8LpbuD0SlzcBl6ics2OOErfYg0pcVPBb3sbLPxWtj+NakI93tmUw';
    b +=
        'tyEXr+52wuh/NZN3PwtG7l33yGlCYEobMveai2umqqgQs8bwwmdrydt7GicBkanWjpP7Q3JeqzV';
    b +=
        'csphaWKYHHd1u9jFKUytQ0Rw3m6SC8MTbp9gGXhLORXp3w5wZw3UOEq3FD0Xh1iclfY8K8yRW7v';
    b +=
        '7+4ErK7fl+34CY0N6C7iVvtRouooMJuct1ZWNKU/M6wqksMIY9nSLgZ4mK4514/93aNdPCDTuH/';
    b +=
        'vpzepWKEgxFhMz1hcxqaLDFsXDUSc75Zri5A2gBgtpv22+3lCyliDr/vCy9FhBO+gsulgHvHune';
    b +=
        '5mnI+W5zp6cyA/De6yB51q/lvwLdpr5oesRI2ha1D4waN+o3DmhmFtSP1tVck6/1ej4byyPMU9T';
    b +=
        'sO6NFPXmyi1nvVS3sy2Bb1BCWmg8Uy0XcmwYhR2v7BBCUaFvX0Go5j9QQlW6UwST7fuh4n+zCBr';
    b +=
        'u2b8StuNK/Wx3uLzfsLrcpjxkPLab9k/PwlvcjW0ou8ZaMdwwebYryIioXoMazXwLlhzSa5JNlF';
    b +=
        'sWQXuQ0ru6LcFSwFvbt1A7ffn11ka9lFap2g6j+reXtoASPpRXF//tgheTzdBmRRIADnWmuq2yz';
    b +=
        'nf37TCDXMpDIGaXae/yL/P4uMdiQ0I5f3yte7EatxAbVFBnaLkM7GZIUNjJtv7/EizaluCqdAg7';
    b +=
        'n6ZHRq+BxQhUDic+hEPiyMIzvKuxsLjU+LEff+YxjoB7qASxZAAi7Fl0axLCVCteqW0kujVJYal';
    b +=
        '0YNWWpeGjW9GLnolapYRgiog5Zka0fltijiy0wU5RdhgkltJauvtOsreX1ltL4yVl8JEX7JWy2Y';
    b +=
        'iOOq4pq/9dXYLNuuQijCpSw4WY0JZb3AuDOafy4Rgtg2xvuXynIGobf1lJNgludYj/jv1T1PFju';
    b +=
        'ugpUgpRG5wQtEbrDotEWDsCEahBbz08vK6IrOSNXTxgQQZBvYjzZwOTFgMYS3kX0aIQnVFuhC7B';
    b +=
        'YVrjTKrFUkVxEc674oN4wDU+aGlOGiJnIOEG1+Y6KiZu7xi5s3GxEBOuSW3uORrlQcDmtx/oWEx';
    b +=
        'MTlJSTlKJr5YWXPtRtkRja2BDHnEBnWcetL7JBxhyh/TGNH/EroD6bLFPdG7rOXl0+7+pSZ3Fk5';
    b +=
        '+2m3whpiCnnKMpkDHn0LeUILwUK3Os7Vac6yLgqlF9RKx0NpUSu9IJSuqpUWoXSsVroqlI7WSsd';
    b +=
        'CaV4rHQ2l7VppHkqzWmk7lCa10iyUgs/el2L6b7ZwMbrBm/8/gl+6D0o7hctNTZd2c+vhWDgud8';
    b +=
        'U+aQIZ4EntlY6Ffgfa9BwyOnGNfodRY6aIxbLr5QzvpX27ShLRbuOzrei2QmJBLd0q0aLV+UcyU';
    b +=
        'oCfpB2pq5FH+HajSm41YH4F50sVEponPqcrWJVyVP1yjP4J5ozXdZbZH9FT9VqRFpExj/kMIV1s';
    b +=
        'zkhebl9J/grJmqqnmlHEmRtfo2fvq291prDd7x3J0X33Ku0ycK9uCDkG4Pl/LWfdj4ZEAJF2veQ';
    b +=
        'XYkmf3WU0b04c0xdw0iHQrTX8QjjA/4O4FLsxY6Y+42rm3UoqLzML0Vu1Eu4oD/7ebBQmEoxzlP';
    b +=
        'vqRQhwNMs99aLdfuX1qp8EYy/flYXEPFeWHzLe09qs+1ib9C7K6vpJeC/qE/XXr43HOZzy0WyXO';
    b +=
        '6V8B/ttkiomm1Z26Csnvs1Zmgw6AUHjtuSnJB4kGerMoqM2iCp5FJJf3gjp2a7VmmEFII5QOchx';
    b +=
        'SZSaMalV4rAY0zt2o4s+/jF/w7damcqkISHEXXpsrYDDhKv4uT3Mb/3nw/yxPcx3PPvDvBVekOY';
    b +=
        '28Q+k1OvtjFDd100EoAXcWU7l4E5OneHOCqoSI2hI8WLluz9wQ/fsu0TgYFVX5iNdUvSNdkX5tD';
    b +=
        'skE59hmfPIcNxtexJiBLMLO9VFjz9FHJmz0uKpaan0WUX7QHF2cEGfdZfbVZgIuQumkiuK1oHir';
    b +=
        'LDLCr9LJrtgupMXwweKFWGX3O/Sll3g5FheDB0o8rDLcr9LLrvAL7KsyA4Uy8Muy/wuo7ILXCkj';
    b +=
        'RfNAsSzsMuJ3GZNd4PlALH9EB7/epG5fJdtXtW6LbRueKSNyZR0qmRGs5ga2EeZdd5aBdRDrDTp';
    b +=
        'vsBtoAyEE3HDTxIz8rq3LET8HxC2D36VHeXnawkaEyyl6tdzN6ducwjXLcfzfvc25a/LOWRMImS';
    b +=
        'wDax6m/QDv+cyzIr+c/soVjGlcXzTwLpy17fruCnj/0cruSF7ZypWHPeoVJIKuHhni7Rm5jlzhi';
    b +=
        'ru6mmEDw7wcL59+w706UUyKJrKwfu4VSUDRCp5tRKSkTN/ehnvTcWwAfC3czbUpeeD1NlqsuBo0';
    b +=
        '46oC1406tI3oe6ofHunhRdp6JDbZ9v/tOW/dLGgbXiA3fZzquCdLf/EQ3dOv60EjukYc2aU2nLM';
    b +=
        'qe7Sxhy/vJitDTxQLJQIjIQ2iKOvbstNsa0/jxKmcOK22NfEgm0qSpsl7KzR5bzXDd2An2uo+OU';
    b +=
        'lb2GsQ12mqdHcK9ExppO9qlD9Hk4wwrrzbXGEjuHZSiQC+webvthQlROpl7GUJkTZGxClHxBQdX';
    b +=
        'FbOzByJJBvfdKLyMUjgGdlDMrUIzDFx1Gxpuj6plcvYWbf/FlWs3tgtTZPI2KFWad0O34NeQtIq';
    b +=
        'v40zxqTHKxNXjiu0KXhtChFMKC3VSDoakaccyZatCIJHDIJHRHzjs4uwWwKHgi2aolXtThW1Fqk';
    b +=
        '8zMXJZdZEyenqHWqeAHvUrNUwrtXc1u6oXl00nVbWPbLV06epZqtVsjPAc0NRizx/bnj7Y7UlgE';
    b +=
        '0V+DIm0flncCpkEn4PaknzRgWurFeOAskWtSy6aShiHqE7a7dR15fK1sZHjeh98Izu71E3b35Po';
    b +=
        'quq1XU07XUVB8STzaaYd1QnP8S3ffDMB1M5XTj1wbR2am4KiGRnUd+GKx2qdle2iyT/ExPOM14d';
    b +=
        'UZ1EDsv/0NYvlz/aKKoqV5VdtJoSHPJHo5rvIhNjuJ572Q7xcrOmyjV2hx8ya+1BN4dCKm2ikNL';
    b +=
        '9sU0EChGmmDScYEJ1Y/eVzkbwdVwrpBOrBXEVh6i8xNiUe+cR220siLGtxkSKCbLwIUWCL4GhSL';
    b +=
        'Oup84nNRTVUtpzp7fUJiL2c1RfEDRzr6uCwE0eL7RRjeu7DaqkNqg868Zlr5LaUDyBphYbvQJPL';
    b +=
        'ok2RepuwfibKcdDHa8TMSpAqyQQF6rAy0MqOUJYDldtSgarxMEIhHGLLTehnpYw2C7FoTDgthqR';
    b +=
        'BMbb1nIJ4bYXcQnRtheW37tTg22re+W+vW75nvdrrO1bgpRQNkc4j/KXLGR5XKr8zDaf+c8P7UQ';
    b +=
        '/8T8/njsNj1uYHVmJn17I+LhU+ZltPvOfH9qJfuJ/fjx32tqtMyTINnuKKyNzO0zGKuKqeDGKq3';
    b +=
        'gxiiudwdUP5xxcqRbUcacSwRg3ldvJeD1d5XbSJCS6mZXbiRN6JblECk3ZUNJBnjaR2L8k2XkFY';
    b +=
        'mGuarDbx5/YTydTqRX4cYXJCrNaIVBe6be7XtwEGlceX21H8mSNtwrJIhaiyiTwcounPEnXQi6v';
    b +=
        'SlRZC3iwiCpjZKOO46fjCg4sIT0SNjYq+hbNGe32EbaEjVWpEWUysOFLctQFEm8oJLSwShSJxzo';
    b +=
        '05UfFeswlFtGWWEQmsQhRu5Ao20WdZSSx7CwnV6WzKEFVCasQZzyLocbO2eL6GRUQ9PPET/J8oW';
    b +=
        '46h9FnOvg75xbEoq9WJwa1GRJZWifWvaU2Q1uW1outbqnNMCpLV4rlbanNsEqWrhZNCEtthgtk6';
    b +=
        'RrRhLDUZrjI4/w2u4d8LtJ+i3OQ8ls8H+m+xfOQ6luMIs23OBspvsVZSO8tVpDQLEc2b7Hc/Y2L';
    b +=
        'ZZunqRULWOpmUon9sUZk8fiyCzCtMmVjS3d4sjt0AfCQw/xSXEVWkuwelrsb1Fci6icmaCYmaCY';
    b +=
        'maCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaCYmaC';
    b +=
        'YmaCYmaCYmKDmByRg3i5S9ISolZLSxmevRQKJHwkQPTt4yZin7TXAk9m26IWyyg5uud1N3bol1S';
    b +=
        '+LlCgDgEL7XTGXL9a3/NeGC+d4sPpw60LwDd8r6SUbhtvugY6ZA6zlnx8jMtAqkJzL/ND5AiEln';
    b +=
        '7IFgkmQA7/2FcU6ClTJS9/mu9zsb9MsJ+Wy8IJE7lVCfM0zeiTWK7E7Ir0e0SOE+lFOZMzkVQ9T';
    b +=
        's+9ZVp1qHU9G/uV5OZc/kVEc5zaSndi4KN7qdn1K4zWvcHHfEWXb9J1Q376tai505qlQeJUOC0f';
    b +=
        'WkYu2UpaIPcCARRkv+n0TPKbLvlhovocy0Qv+QhNRGH3n/J2uWI/K+DKY/Hni2BeCREvht9wpMA';
    b +=
        'pw0tGllNy/iTULaHxdulxVu81f+S2HASNre5MzRYhgekM5Zsea4FWYL3BMriniym24i6W5j0u0P';
    b +=
        'PvuE+Kn56HW9TlNq59eoJ+4elsTj20VTxypB/XdH3KuJ2f7Iyu5Q/h7AMM8iELoY8SI7tmjD8dH';
    b +=
        '2irgEJhVJ/kHkjWaokvsi3MA42Y2L/CruIsDU17mtVHYid7bcTDZ4/USvn4TrZ3L9pLp+C9dv+f';
    b +=
        'R3f2usRuyq8YM1+YeeJ03e0ibfY59Tk8+aepPL2hk0OfCjbPI/ei5Nfsvpm3wmHmxy3MyiTU7e1';
    b +=
        'nD9M2ly3Jo2+S1o8o/EksG7q6m9Fj499Jx2DYPCc/RUvCf1ndZcrJqy4/ZR4U5XxB2VrHd5OksB';
    b +=
        'wGW9/NOJ7wdw5BX+SNd7WvfUHtszG5VP31HvBx6NF3YEBJAaSjvbCiVn9xpfq3aNqb6qN/rY/PY';
    b +=
        '0XFwU7VhteJb6ru5v5aDx9xK4IOVe8trd7WyiZJ+pZq6ud9sDDemmUD7KifwpFAHkzlPOxj4y6v';
    b +=
        'uk+o1iJkcuMeWVrLYwLNMUcGpfVq0nVraeTzpXvXkgnxLJLQVeKl9rA9HxWC1zPs4/S5B3wgSJm';
    b +=
        'LQraEEhxf1cjAEz91EGOo48pgIqG5IGa0S8/sOkmYBbiGFpTqtTrGc+5S//s0R3dlX+SwO3Q+5P';
    b +=
        'MKY5+ZGqmiWhATz7JporzT+F+D19i6e58cbUs927YGxy3krePt2eLUg1C0BXEz04X9NseEkCbks';
    b +=
        'SsCbUntJvanWIgi7g34qNjQXRXCqbb5uv7yloM9v8a421cS4v3XdRklBIsJy573CUvxefwPil0f';
    b +=
        'nl/X7T+b3ywXu5qRwVbZSIHRuO3/+Fw9F4FDE1FXHKvW4diFWu316t2InbZmZmZu1aBGiBgSnKx';
    b +=
        '3D+Jmca5S65dP44oDJ1ivmuwZLJfxWjrsUNmkuj3OPanmQV8/c2POot16p+3ubvTDr6CQgph8g8';
    b +=
        'HL6XTFJogUIurbfJ2vvb1KpF5fF7q3rJV1M/2TwIrBr+ZDzFGpv3nZZVmrufZzlP7lx3+AIOTmW';
    b +=
        'H+S/5HcCjiIu1NPmyQKbPqCrPPKyYr2B5VYbWyXeQg+tcUmPGYa6JhznzOJO1gykmHJmmKpJO7p';
    b +=
        'eEM/caIbR9VZcd29VdIbDvCpyxm0mO1pDkaA2LsgA71nWSuHWJG7hgMPXRH3WXwwJZDgvkR09ol';
    b +=
        'HhCo9gTGnUR1UVod/PUdLn95QKvrCLTQejPBqE/G4T+bBD6s0HozwahPxuE/mwQ+rNB6M8GoT8r';
    b +=
        'Qn/SEZg8bQWizbuXNKaXtqT7GE7/04b+MdjQH1R6VH1qIsgIRoMNGiwmU0DczxTALoosGLeRS4/';
    b +=
        'torQAbvXXQkay7C6uNxAGYIZY0Dcl4jhKaWCU0iCpLE/rc05lezy4PR6RdPGl62fr9bP99eOLF+';
    b +=
        'pnZULk6leoWK5+VVH4qqLwVUXhq4rCVxWFryoKX1UUvipwE1iPfo1k9qLsEzKcldqV0uFgxeHAn';
    b +=
        '1XV1/WUtUPbzbaCsGRAPYgTSTXWKjiRpuBEMsGJDAlOZFhwIiqOWQOLCFRkws1eDtzQbd+1EDOC';
    b +=
        'WfH2zQeKtuAwZKd+zIid+PePP/XMcsBC2gGtobvVcCMKEZl449HvvDcFQKS+c2EVOzLx2wff/FA';
    b +=
        'EcMjA5n78yMTOg994dwyAyCK7VRiSiaPf/faDtmgsuluFIym//MWP3dF0n0l7SSzJb2MiWVFBlE';
    b +=
        'MQrszdm/Mh1+CbBHMR5edIGFbKO6DYmLm+zLjmRj389HRjb7L8zSmwxTn7Q4ucFTIJJC5gUM58K';
    b +=
        '6JXEGWec5T2+/yW++Y2reRyN5T2yut7+TldS+hF/kjWEeml7UzakY9YZ+wQoIbE0xT2sr6iMfyj';
    b +=
        'fBVJTB1NOotxJRmNXYUmuTmoX+f7CC/3P0d43kgmEUayJvgF9TgZNO7AEZJ4Az+r7ZX0XsEMkwS';
    b +=
        'C2xEX5Gww7nQ50TPHgBznD2c803mA9DTFcTQn/j70VZhD218YiaheMS5iIkiCyD/cxDQVTp4RUX';
    b +=
        'KRISWTvGeODwJmSYWzxgPWjIDEmvK1jkkIO8DH8j5BGGW/D/kWmlRd1aDZsVqLXxB1P7rHSNOIF';
    b +=
        'lXMg0rCRuVF3BQLRDrZhDTJ8hKdpMH6rVfcNVT+MxQRhTtpiNKhWBqWpG1xgFE8tF754VDtIUHn';
    b +=
        'tTwsjoRg6JAlmSeZLJq9tGi21PqRUTVQlsGdR1R4a4fml508U9meKL+/IZQCZMHZZV4H5Z2T24L';
    b +=
        'VGEPCi7m/NTmdeab09gnqHBMJxYWSOnOYEB40nrP52UR1gLqhqg4GfRLXSEw7hd0GP8IGYVlCgg';
    b +=
        'v25XdisPzrBFNsWtmxJKFWLR0aAbyVlAJPR009KX82rCGF/5CpKu9elINGa1/4yn/Xel0d10Jdm';
    b +=
        '4/SGWxIVCjMy4Qg/ol3ToSnsOdP4ZbN/9rAhyy3qtac18w2QTPbBM1sEzSzTdDMNkEz2wTNbBM0';
    b +=
        's03QzDZBM9sEzWwTNLNN0Mw2QTPbBM1sEzSzTdDMNkEz2wTNbBM0s03QzDZBM9t4zWz3lsmzyL9';
    b +=
        'qxFJW/lS3sNMv7PALM35BeFNFzUkWnvQLJ/3CE37hhF84rgvj9to+4WdMsyynWeduLWejqX6yT8';
    b +=
        '2qVQjpp2rPL1G6orh6eEl4eEl4eEl4eEl4eEl4eEl4eEl4eEl4eEl4eEl4eEl4eEl4eEl4eEl4e';
    b +=
        'El4eEl4eEl4eEl4eEl4eEl4eEl4eEl4eEl4eEn/w0v8w0v8w0v8w0v8w0v8w0v8w0v8w0v8w0v8';
    b +=
        'w0v8w0v8w0v8w0u+n4eX6MN7qKIFq2XY/oUGMIRFRsMYk8tsHJkWmTjGZC9JGIxLK2mUbh9x/a1';
    b +=
        'Seo5x8efY8rKQQTV77yyDS27ytpa2wa77ZhmJQvJcudut5DMNkZBrd1LvU2qJGdXuAhY2G718RJ';
    b +=
        'KnqA+I6Si664pWTrOsCMXGePCyld1kUt4yTiubHCSYBtXUo4TmRVnnhOgKF9v+shFT7nOVKi8sH';
    b +=
        '70v0NOhPcLVotKA1I33Oa7tEgX+HdhvbLvIWJWRMSVdk8fvI4HUzUf8aUn8Zi+0F60FuUZLNREj';
    b +=
        'FVDEk2mIPyoRvtbCqFZOu0Xounucx2rfouTO/K/AwW2FB9l2xHAPPgMTfAYm+AxM8BmY4DMwwWd';
    b +=
        'ggs/ABJ+BCT4DE3wGJvgMjHYoXGKHwiV2KFxih8IldihcYofCJXYoXLpScuqMdihcYofCJXYoXG';
    b +=
        'KHwiV0KAGo/z71COdegA7ohPyhlBalXS/g+/ENRbRSiZKEJjDRCVCbgjNWnb6YQ0SynPLrEcgq3';
    b +=
        '1PD+a+EhWOKKONl3fd5vqyPPagva+0KQo/4gRRTRDsSlQe/fj8p554htbCb2+dPN2gR4NXnqYWo';
    b +=
        'KZEULiFydGe4tcFBfRH3Kz2+noORbuxIOlrW71kPF9dz5n3XAIwWS/l4E15EZn9u84YimV56b3U';
    b +=
        'HE2n6GStfHgLDmoaLBm5IDRuwMEYBWcUb2Sjf/s3DtJQbeCSrrMhrMxkX/JnuM5MA9pHaMvRtGP';
    b +=
        'FuTCRr3YvRKJ/kSa5xS//CQH3DLa1zFXytQGG9AKQIXTeCAKSug5SW+dVyag2ZP+oWv61XXKIm/';
    b +=
        'vJzS12eSyBOurrFxbyHV7/BCT8+jAan9vhsGpSKSdnj71NnTlGxyP5UL/9G0sdieIWkhiYk9sSU';
    b +=
        '3o1sS79yVl856zVomQ8JVEUMsWAdMTa50cF1o2QqHRhIlJ90/2dJ8XT0s1VP7UeKwkhCpmD9R4R';
    b +=
        'PDY44yzPVmUdR7GnO1GtCp7qkMyzOPGr4iiG5k1LHkgThHlUb2O9jn+W4tOP+MC5pjzhGTGkmQj';
    b +=
        'aryqP3U40GycXlk1i++bNBjMYzkrtNBw8DV1ve/lllUS3njwgt65GKlpWRjz+3prmd3D4gVkdq9';
    b +=
        'pCyLsfuiV7v7DBvGooYL8ZuAYB1UvKx3tDrDkvmeVJknaE2JxXOYJvuwiaBYQL/HqgSmkW2eapo';
    b +=
        'bkacFvFct5JuhplaDOPiLU6Ass1FMuX+dofgXi2ksMHCxuZu4i5P1odhDY9W4wdAYK8H3Qsujbc';
    b +=
        'n3tQ1K/F0rpgsryuJQ9iKI1YSQYyNvfJ6lmehfLkUb2NxEop5KvgqrRSVZuskjPMov08RI3GIK0';
    b +=
        'IRS8tbf43GdUbSkMwemLHPBF3k0Lj37t/jKXfxDt4hwO5HVAnK9hC7BizadC3yfVpYjrryxRStT';
    b +=
        'e5Ny1wrtp3tOAwR3tiZwQXp8rMi2cQU2WYP4P5YXljidCSpPDDWjyiQbgiEGwNnQ+A7K099+3CU';
    b +=
        'vwnvCvIMuEaCigbuA8kccMqUJOc3sY45vQ5UIiLSb0CgeUs59htwL70S+G73lQLzkgIQlJTPRFP';
    b +=
        'wotLet72WkGu6/qKMrnR3MFSazeT5SL3K8F/+HRNSd37HJ6S6XaZa/2aV0zy4jSV9Uaj66xmMWZ';
    b +=
        'WOmmG7kWlpU8n40v5UxfXO/unPVFyH3MXFExVXK4imSlRc7fkimKc4Vk8IoFunlpgIRsChgMhnY';
    b +=
        'Ho1Yons35ilAroppi3Cs3PGWYv5l6S3wUHjr+tJrmIuJn4z5CoO1XMVG4vlKoo7id0jW1bzrQVy';
    b +=
        '8xyb/1v/2fw/1OY/ZWWcXV1TaBkHXG8chuw47NpxmLnjsHrHYQSPwyYel+d0Gae8nAFzQsz5Mae';
    b +=
        'evBZvTxzQ9FTTq+0ZMNriWQ9BrqXF6J+7Sstp9FFOo41yGl2UH64mCgl8v27NMIBP5NwsZzL+2b';
    b +=
        'gSwJ/J7vAFhCEF5DPCR0H+1y9lYakdlvKwNBqWxsLSqrBU6FJSDsF7f1QFbwXCQaM+1IjsCY3Yk';
    b +=
        '8dK1k4Rr6SeXHRFp61pfsNuuIeuKjKqFRMeV7rFmWDCh5D9N1QvzBYrFEx47XBN5/M5Mm2CnZA/';
    b +=
        'SgdrKol9rgppfhHYryaFM8w183GrMqwynxrbgp4E/EtPN6cgtJNt5SiKj3zr9LTEyYxQYjzrvt7';
    b +=
        'WPJN9vTV6Jvt6e/VM9vUW7Zns623eM9nXW8Vu8jKGtNBq3yjsG+m+q1rPWE0MsD5iXvTy+xuDPL';
    b +=
        'NEWtFJVMSLEc3ebQTacNB0Y8WNHTI1rtnm6bhmExkjmgNcs27q8QomPuvFM3HV16Bdx6xgf0KHP';
    b +=
        'mcHyKiO2kXZqGZtxT4rILJZS0e3Al9cWT7Kj61LIZei4UF5kfQi4l//cAarfklmWdvHLLs/MMsC';
    b +=
        '7X2PZ5Z9t9pLJ73sBulMIGQZ2IcOUcfCFec7YzGiLowPxaLzKNxEkGvsWt8wcooTOEVQtajO8Zb';
    b +=
        'YH/8LTELbbSQpQXYEs8Nx9BsIR5/YpfQO8ynsdPKwzOycjcAqGZdHb1LVUg4Dx1NEHyATNp8SU8';
    b +=
        'xA0YnUFdNzgdKEepxSju/fWUwnUh06Ocgq9pL3g+unNQDYhfF8utbV29/ybnKauvvK/5F6Fqm0t';
    b +=
        'mp2shrlPFae9Jqdi2zb8Va/Dfclf478tj6a90LH02xzBnMnLm1FXROisL/ZW3Z+w6apSRf5L8Yf';
    b +=
        'nPmxiP7Nx1yzpbD3/hm8Ye73HyLm+6KznkmctWvKrlDHQT8c1m/5cyQYk29MVL/dROpOGBO+GL7';
    b +=
        'O5KpEFrKr+EA//j03W/4v5U1PH8awWn7h39zvx+L87VbonFzLuXl0OV6ewM8eW+58yv1+xLod3B';
    b +=
        'cpufjzz2CKPv/Q8OVu5YG3/0avbG6ES+/fWf6+kyz/y8e39MplG6ex4Y59bvmOsY3QdbzJLT7e4';
    b +=
        'v4f/drmXvnRP/+vbieh3rlx3UZWnnhEw9uDVTL9a86+KpubD0zAIJ+LdrihK5Y9amR4SUAYpiC/';
    b +=
        '+CJcaT8u8FFA4awOKJxLAgpnXUDhXBZQOOsDCuelAYVzZUDhvDygcK4OKJxXBRTONcTg0ObaaXo';
    b +=
        'T7/jcjY9+5tjvfu95a7188QTcst995P4bH1O981NRbwLO3I+/9V3f+Fctc/PGCbiAv/3WD+79Ky';
    b +=
        '074crgOL7nDTPfnWTRxL89cxOwhTu+43a5Vhr/lwK17F6LJG8J7rvpDVAIwh0gapGvI/8i4oSuB';
    b +=
        '7iShWZaIpaRkgsgB1Ht0Bi6Mq533crU79bjOqMNHGzoi0br3VAusEz2RKC6ZO5DeeLNR4ym8HOe';
    b +=
        'mkg3hDi59kJjaZGwE3JlceiDxtjvCNAFVHiYbHr0tVEulrG+DihfSyOdIJ71k9BT1r6o4KhFijU';
    b +=
        '/N27nD7BfXC+OS6Ne5NVVJ7RaNYXvvsn3QSdwU+WONwVVYeR6UIqnVgv7Umf2wE/MMH5GbyZxGx';
    b +=
        'FwGyDtPJrK7x82pGrvbHoCNbglAkBORhvkIOMlqmfV/A9PFs2Ni5SWc8cZ2r2uMHVWhhqKbnUnU';
    b +=
        'qBAMDLYHOsEQJBJIOgyAR60BU+3vg9P91LB040Knu7Kzogg75bRpIFsOuJTNEiuhm46EHVn0fCB';
    b +=
        'cDpgdrRYroFyOrB3z6d5BOl0APLGJOEaaDZXcWLUGkStZcSxDRPZ1nZ/R4BXgzCF+7uCmLaziXJ';
    b +=
        '7HnFv5xRjC9BsO5D2Tg7q9T3QUbgPpClg4gQu6Iuj1N0t/dDInCoTAmQaeB3fAqGBm9yfIltZIv';
    b +=
        'UmWwlhQqGvaK9II9D/0RxDRre7/b7S8rYnqFPQtwGyUYjNrsAcDJ1tFq62A1eLBy8AygVzaXSO+';
    b +=
        '7mkV+574rAkUeJrSstzepIx2bjQjq2NYVi7BzmEHzyzFKlbxaXROrc0vDYedz9DcExzf8q3pOTY';
    b +=
        'QJ+Z8rtxb9DbzQhVh3pafSkAGcdYz9cce7g3qnyzCDG45Uukup2mhuJAPtkEG2UqUjtR6xFrU9H';
    b +=
        'SmFMsqLA00rjfRJ/w6p7IMvQzggY5gjqhqc+ZCkIM5HHmjDb/OvH+GXpHmblmQhHFsGfh5sN81O';
    b +=
        'IhlNgG5s4CwUMfBY8oSkQRBENYfjj19MCFEALoZDYSblLvcIRjJKljVKw6GlYXzbsEf/zSjdJZa';
    b +=
        'oRxveaM5p9vkmri8838k0Km6neXaW6+332s7EfQiVjtPB5Gmyb9aXOMlD5tajFScbgX2mhdU7uB';
    b +=
        'MWnZbkxqhYAIkhtBmSKCSO8Fv0x3eC0TEsBkp+dA4pIeeoz8/HqM2/Nq/7Dg/nnQan1IB8E+u85';
    b +=
        'wG9cJYJM6+2saVnzaByG8g2kuhswlgo3yaSX2IleJcs/7Xad+Qb5LKJdRF+rLDySIiBfnE1bCgb';
    b +=
        'vO9qALkz9qqV+Uvr5rtsB5i5c7sfDUQ7gvpM50G2W8lZBUwbHqGhyr7qNuTm0l4o4pDFvcVz3Fy';
    b +=
        'MPW/F+MZHSeCVdAUs6c1eO1TflbPaEWdov/H3wt4dpm4Nrp4LXLn5/qmjLd2gW4S3iVzdaumSIS';
    b +=
        'EG77yalpVCtmVCSSq+a/XEjGUqsqA1ECIQ9no+m+Y00VnccMGJd74cYRw4gNqZm7zdK8khlkaHU';
    b +=
        '3c2nA4fxig3kJnNd46TFnZuFYQVa2Uffzxr87zMAOy9tQL8BcEp8z4KqYG6bEA7v5opumAl2eXD';
    b +=
        'UC9VQ72WEmZFr4vTClDKePeLaSEnVpOcOrJL5KKVizJyGWlvOk7myvGKGPCbBMg2UL336CSbw/l';
    b +=
        '8jdIZBiJ1HjZIMQXfPqeh++Aoj/3vy3rgvtlDtPqCe93H2CBff4AgRTMNHlBS4ok06jJSqUZIcH';
    b +=
        '7O6frW1KL7CaaW/CGiwfOgM3In7gPyNm18cCEIwFrdCNw7ZcPnw3eiSCU+gGECR8t4ojbAhCoWs';
    b +=
        'CQLIlxDXD4lRlF5D6bqGzUdGEI4EvbLCCkJ9YqoJHzdIVnDNLVxBYwOdeQYpaksPGekXJSNQaqX';
    b +=
        'KpmmF/Y00KJGZrSycpi44FgN1LxGH2urWANV3aLeXuG+8V5EZrC9Q2rqKzOuVEWawtcqaJq3WyQ';
    b +=
        'wT6JmVc1S1qV57/ClqVFle8L+Wc//wryF53u7/E87Y686wkq7HMQRnYdJW7ivPyem2egeHYkYg8';
    b +=
        'ZFerU3TRIVzO4Hw6Sark+1L+AaaRHZtwUjGmYOl5gAm7Q3wPtB82KY8rHoD4E0Vp20xR4L4o9wd';
    b +=
        'iOVe58sHa2n1peY9fPaH2hwfdKAvRIkkjfhosDv9noWWo8Ti4Efe62vqSO8qVY0il1AoXFMhQfp';
    b +=
        '0nSVL9mXZOw7GvrK7SpofdYQbXVOfGqPSL1BYceoP3CJ6nHTrx1wpFcg7SuA9ck2W+7gKCOWZtY';
    b +=
        '2ByplTZMd7nSvRMoNVAiIyYUiTMGNJkROlG8RMK5h2n8NhlzPcn5dlsWikOlbHqgDGZnq3qxH72';
    b +=
        'UYiAfe0cDT0HkoAbm1Z2Gx6NTXkAsGhdNQXeAiRObId7UERwko0riTqTGJdC3vK3JgQFd7LAM+g';
    b +=
        '6Ag/tdiZe0FsY6+Uft362BUYnVxuPt9v/uwqvA94OxNJ7WTDGw8qbdyve7i80KLfHKh0FWZSH3O';
    b +=
        '8s2RvpsOwoE4KzrBJOBdApaggAd2w19Th/ZdEu2kQDIPm7OyIfQjM82pb7N1JU68Pu3wjeinrhk';
    b +=
        'PtXX8dbl+Wv9xEAdfmlYU7yDkMUuAQvFlbQNVD+6v56NQetV9SrWbNHUa8m6lUvRL3q60vUS4kj';
    b +=
        '9lilGUgGRDAQ8744ehjzMmdaHDWaDXypK5ICV6/PQX8O82GyNbjSByVHoUulTRqFc2Yz9CfQjXL';
    b +=
        '3WHdP6juWM9zLNZJSQh41EJqM6a6V0yJpviycgQPZ1nazpeqt7iXfNJKK1mSvLNxsATZW/rGU54';
    b +=
        'KcqxtUIrq6QbEnJ+umyHNvM7/OXWn3btW4K6FMwLXfll70tBuLcte7va6eW3sFAT1FuScU9lcqY';
    b +=
        'aUYQcL9OUMuAOY0ylw+E71CWpv2nOSQKvA9PyQWnvoNPUk+wdHuY1MspiQ9cVo7k3vvKcdKTGd/';
    b +=
        'fkrI1ZZz7ayt7hNya5Ly29gaNi9jQbsqGCl98vvCfeYXPcVIKUNy7YgRv88sjyitJNgnwkyEqQr';
    b +=
        'TuuPJwmyUW3Yd28cpMx7xpvVWkYJceE5BmatGkv0P6ufn6GnbnYinbc9NP5mets+eoaftSPC07U';
    b +=
        '7wv+Nn4GkTV9rbMvn9ZrrApfawj6BFHtJpy5mCfzauROcfC0osVpszU3sFOrkkiYh57fwOQonWh';
    b +=
        'cT4ywZNTgE//mFDYgZE9cTSqaX1NJVxEq7Ws1QKwhzqSSoy9x2TLBTqY7U9ONM9yocplpwzcV/C';
    b +=
        'bpB5bKD+Y4JBzCr4AnCBAbEAQGBFe02mYwLkNHgWg2fS8+1GonUfyzDJ19MLof7HffMbB775M/h';
    b +=
        'gBz7x76eX+HF88zuUAa4Iye75LRJNDCB378TBEM9MIv9BBHC9Z4O/hd4iEDIss4mNxQEmAifUmm';
    b +=
        'pIFNyj/BuqJy8VBucJwc4LsP75Aqx/Lhte3s081h9kVYtg/V/e8pfc/rKRRvngJ9znfp+bywct+';
    b +=
        'mjiDQhrIO4B4eqoTJWsBGzqdtS9lmXUt+pGspB5pm9VXjQlJbmxpv4WZ4LjV0KaQTaMVJ8CMZef';
    b +=
        'giEnBqkiLUxFn6dsyonIsffTKC8sFKRF7XDwdLvZQ519j66NLV2WjyoAJtfftv4K+x5gecq+Z/v';
    b +=
        'Z91Kw76XhtKmoN9KstnL6SNn33H0Psu8JZ0aX1NENvVCjxq5nNXLeo7zuQva9FOx7qbDvwVnW3E';
    b +=
        '6Ddzk7AzFokY0cTZbxlLtNV7tEthSGyJeY9GQYiBpCnO5Vj8TRmUrSJ+BB3SZFitnK3cSdDmJlp';
    b +=
        'blyBC0Tb3Fm6thUJxOflVsaKqB03yU5Gf3vgrShuvtWwaw0iqEt054WEQqLaAnXtW5U9DDPHoE4';
    b +=
        'XZiCaiSKA3vj9YmnQJxMcCdNdSKS3cPng6CoJW8zhNZ4m1b9ua3HrLOq4m2F8oq4ns/9f8euG/K';
    b +=
        '3xsizhaaMOdCNJ1A4sq1L9VSqulL2NZ7I3+Q2Pf3M8htv6KaSylwkWoKtO3dAv3ZADqZrJpVOnY';
    b +=
        '5LRrkPFKnqtV7fjVVFFtdKrr+L37Kr0lSva8RKYuJxX1Vdr3WgsAe6ia8oKuPOoBKwkLN19apVN';
    b +=
        'tbKpr6yyekqmw1WNq5XNlq0snDnfsz2p+uoNAv94vicXuu94mKT7zRVsOEYS2ZqJSL4dyqqOfXp';
    b +=
        'GBPf0pU137r6uAt/9rGBwEU+ENjI+qTObE3nTGA/b20q+1H+B2nN/W3Kn5buZee7Z0k8b8sVl0a';
    b +=
        'vlbvMv7OAZM6fTDmiXje4vVKtmNN56Kz1KaNw3+dvbErixkXlLEd9yT6FXmQsTBzET8YEY+Z3pk';
    b +=
        'H0QrSmoAjrhkDJ7839gaQCpzAnckrz3SkMI4HiFXqOtpwj6wIlFB0zJNrhlWBEe+YdnJLpwaGAB';
    b +=
        'ETzvqAlyTDrMA9EpIupOZdI+qbQiGtdKAF0ItJ8YzefZXn+HQTtsJ4/2hRp3ljEriVrtpd/heYR';
    b +=
        'JqMnjPy+k0m9NFBngImoaFdjuo16g2z9NPgGafoHC2V8qR2elEmgYR3ACcziEe+2vQmFFeyqFnd';
    b +=
        'WizPV4ikTFk9WiycWghvmFwE3uGZaAG6YMwvBDUfNILiBnK0gxK1QDMajGBJFMdDLgEjl/A14ed';
    b +=
        'Z5FAPK2a5YALUudTwSj2IwimL4oretQuoePC1JXfTqcgZmkwElKySJfoDk5EGYarUwrvug++pKq';
    b +=
        'Ola4WJSMnXs4g8OGlTXBuXGJL8MHqh1fQJU6yeDhKhI62S9ekG+XPjNtBbn6ZpsG5LzmroOqT+J';
    b +=
        '3+j3jOTI2r1gc/+9mFY5R2Lycv4DlebUHPuIv7WS2brHc96VO8FELNMXnUJcaJO18YzIOtCtN0f';
    b +=
        'ZrEAKxxuegXSYbMv/jEHPo/a8AXpPyQGiNSFmhKfM07ktT4ypVLlX2eJ4AFCn6vM7YjVVhpBCyZ';
    b +=
        '9htZL8Pc0uGSp2n4t8nRebW8+VvJ35Md9xRnynlFwGu+w6F0M7dyGn3tOJaAadSvSGbPmorbHfn';
    b +=
        'UJKqW5qFo38g0lRvxvcy56m4OSOfgDGcbn3AzpB9u18Mg5jmF20nedt1c6ihB7wmGzneSvt7Lbl';
    b +=
        'f24ECfqc23nWaDvfZhZv57tNaOeDpr+dd2s7n2hLOz/elnY+2F6ynefb0s4H29LOj1lp52NWb8g';
    b +=
        '9WDMAPE11E9r59xe288l48XaeDcCE1VQrAcgPRtjEri9Gr+LcNdNEqnLINSR63OsJ0cEOM90MP9';
    b +=
        'tuuMvNPBHBLI9Hv44o55byb791OOq9IIpeTI6ibaS7dltfNyn7DewRu5MCTzbxzOGvvuDVRdaJx';
    b +=
        'M95l7vc30Qv46C7jRNlV4sey5G346+YLHlmihyVw68cPEMysJ8Mz9vrO6zuMaUdtvBOJPxEvgnK';
    b +=
        'nyviyXyrW2Uw7IGa92ogdhBS3QciBwRcauwAniOGAjCF0hd53L70tEEEj8usxx0QCNBXFmlOCw6';
    b +=
        'l6j14bFxXf9VUa4MyHOanGvqiqtNCT6txAJU9q2wj4AUtQzBEjdT67/zN/cGCVQPBgjEJFrRDsE';
    b +=
        'CYSsqTPlhwv7pZZoTxoQK2CuI+nxLWkWIKw9ELEcx3d/8x22EgBikS9BlLANjN1J+B+AW0aSxUa';
    b +=
        'WKq0sQ9SXrfThVYqKltpdtq+SYR9Jlh3PINRpCrpjwuEB+ebwaCi860y7d2hCV4iSuu/ZFcUHC4';
    b +=
        'pnz0W5Xzum+VvA/EGu3DJx3rJ82GpPOyEiKB77JjqnF+9/7DPugLhR8JbeJFiZ+L+ojw1vv5GKb';
    b +=
        '2ojxC+mueuF4RXOE0FYmVNVtVUaRO1GdKv+860T8pdUrk033U2lg6vz1J8JZqMrtkgOe9/FSTM2';
    b +=
        'C39GU1BJKuFZ8oiGciSTkEIAbTjd9Jug0YcMS1TczYGyei/z4ihIyH3NB48H2Br7YBU28hXy0g0';
    b +=
        'ZiMNZxleJla0N0U2B3VRpYzSY3eRdrVQ1aGMZnUc+7tJpsVfSzL87d5F5H0dbs54XvQ+sztuNzF';
    b +=
        'kiNViXv+9h67Nt6ZlLOu3uULBEQUlzvdvP8NC0BEbq6aiLvUt+pBu2SrPhVa9dEfrFX3gSv3h9K';
    b +=
        'q+4y26u+yVfcZ36o0hsDJeyKqN6rr8r7W36b7+FzuMVWb7mHJ3aavTfebtfFuO9CmzlxZtE0P0p';
    b +=
        'C697n0jS+yA30j+bIUe2L7+sZosKtSTz4SkJl4zJFYBTOjhR2VrToqW/WMS1xv7Y/gclZ60VpHG';
    b +=
        'C3VLx73gIrUt+F2acGkm77ATX/LFuEpMlsH/fOHkMl9zM+gk3H7qPU0mqQznrOckiUwqR/Fr3tm';
    b +=
        'c1bUwHia/JaGAP64+0G3+yw23209hU2iKUKe7JnYBDn0r2PuHXy2fVEKISaJQto5Pce8yCF/kXu';
    b +=
        'sMNzg4o01zriQ+h2xgxdN0F/ULosjMI3nfbiuxptwgSSGO7rz+yrjgsTBUWbLt/JJu1grP972rc';
    b +=
        'y5emjlo6Zq5SOmr5VnDQKv0spHjNzFrPGtjGn979RbeQ/mzdi811StzERDP1/2rYxD52Pu/Vxbe';
    b +=
        'Z+/yH7T18qHtH53m8GLJpLYFS7LVj5itJX3mUVa2e3ozl+18kFDo9yKq8oOCapbiKIJKe1k9KEp';
    b +=
        'S1JHwMTMdUsnJB4mP82JGnJYXfPiSMJ88kjiM3/dl1r40VwzhgFW7cY1UGotWZiN2KyTt0X0V/K';
    b +=
        '/6Mbg9AOu4agHywSEcjn3LtcdnkQe2tGmxyLHNRTyoYbgZBJBzQxJsp5EfjrD9DoP05UBpTIgB4';
    b +=
        'a4hkkC2u06xfS2f9G9fq2i/WomF7U8FXProxi1Erqk4ba1BwR1Axnabd2mOl5vcAaPOncxx44gi';
    b +=
        'U5vdeWcztTFS7HzxjbX2MXO68MJrscZwg7ZojsMVTu0qx0a1Q5N3QFjXeUxdr1aPHXA7fiSwGJU';
    b +=
        'uIIi1Ji7c7vPN+X2oYXbJY5NpjHJgZU8JexQNOFtdgcKV37rgwIFhJ8yEaRKFD71brSpywhVWt7';
    b +=
        'dZuY7dVZFK5LOq0m3kH8YMzJRTuphRxE9kQPdIUzXSTXZsvCcg9VRLLbVd2ZJ1Ykfu5HXPtFGUF';
    b +=
        'o0Xptah4FrsxA7iqkDd7Pp0VR3L91GYePq8ZO1W8DN+ES7J9N+Dr9qvtNut+hGYNojbMI4FqcXp';
    b +=
        '2mnW8+ttdPxsTNsp+Njg+1Eh2CqDkE5yC1VR7HYVr3+gnbafe4ZtpPbsb+dbj13iXa6/dxF22nX';
    b +=
        'udJOcDUNtNNXdaJzMiHhkVVyA8SAt/cuT2qjSVKN2UQA+MGkoX4bhsHwABvsxo/RFc+BugHagzk';
    b +=
        'rhzU47P2dlSGEe+tA3agN1A2Z8vm01EIPTvN7dYiWZECcOFlsDMG0iOc+5M/tx+dEOJ2OavWOWK';
    b +=
        'lRdbGGjs9SXF2xsWB4huPywTe6XvRF5Y4bfaC54ZoS/Ztv2Dl7Bg3rh+kzadijRmtupGFnjW9Yj';
    b +=
        'HR/X29YHZsbtbFZG9anClcNe/g5Nuw+f24/JGvDHtLq3W2kRtXFGjokS3F1xcaCEXmJhp3jUPyQ';
    b +=
        'RttmUh81In7mg2LecFVoVk/1hXz+CG62+OLoVDAziL59u2XgRqEz7s9bagXkQH1DVYDA0FOGyBl';
    b +=
        'c5Z1K5mqh2cpq+MhUxoBS/pFUjLSSmdj7MznsPuMrh21IyHaD5ikjCdnks6p8ujhhvqcRfq1cdE';
    b +=
        'aynUUF5GmorSTlN36PcCe54N7b3crx93i8U9+227DtSb/tY8F6rMPB4kyAXYKPz9+X+OQ/Z669P';
    b +=
        'fam0Gql8mIaUHkZ/V8VfOqSboL8L2KrPHeoIKrgg0Pk6kN0ll2JzBIvxSqAr/1N5XIADTV8EycI';
    b +=
        '/Y4k2VMEAqOexrwj5pJTRSKAytw5iNHKNR0y13RI7y4zyv63vkKJrZ8UlNhtHiVGp8remxQjptm';
    b +=
        'ZT/rs8BuVyQ9QW0mllBTZfyUEDStcBEILfjpFkVsoARIZ6lpkly66r+U2XXSf2G5dbK+xt+tiTj';
    b +=
        'kdLo6usf4MY2vcRyiLq9Y4I1cWC36WXLyAXyEXx/lhcvGiNfYeXVzN3oOLl7BD4eI69jFcvGwNQ';
    b +=
        'KVcXO+6cF18qevVdfFK19Hr4svX2Md08Wo31Ojiq9bY47p4zRp7Qhd/aY19ggnhhCkQel7OfB3S';
    b +=
        'iTVELoBA/emnaGGTo4EUkDurUYsZH7VQGHsszAcADOSv8Uh+z4Zg1UvQtxpJUogkXbiOBhMGVE8';
    b +=
        'KJHAP5cbXBE3i3bEEspmDBxyelEjoIigB6+4JNqpypZxSYicDdeivIXZsSO51dUxVDa7JRV1Fi6';
    b +=
        'bmjfDaeiI9yK8yZuEvMYMIResumSchBJsDCkZP9gyAI+eV5wN498wzzU2g8DIl3Xtbf61rJyHlT';
    b +=
        'TazyfIlvRamq6sk4ePIN+43DCxUbAnlIWH166YQutvSbUx5r5OrXL6H/OSgfxd+R5E9xyGY/RA+';
    b +=
        'Q3bISDxKdotAJt3s6ae2lslUj0renOyATsRdYgussa4/I7EzmAMa0u1JVCfDg8BaIv4xjnJjy1v';
    b +=
        'C8hgp48AYLE/ZGYe2voB+0uf1esql6OIok3hWArJuJaNPOhKL7CYhw7cUFmTJ8b0TOb7pSmqkpy';
    b +=
        'vdLK0vBRejsmSQrrBC9AAUuhz+fnHL9B2xgcpnevVYsnfjevauDouSvRuDMJLZu8mFTMNOkL1LK';
    b +=
        'l3N3o2RajkO6BR671gJJsfoPmT2bkkwAuEmPkH3PJJs+wzdOGToti4lf47wWCX04dE19DE/Ox+T';
    b +=
        'F0XCZwShRuUoRQdG3XSZ8ZSVHFYs4zgidCAgjYhSYsIHbDWGaMRCjlfSxo75LkB4VrJwLUUE3A4';
    b +=
        'CYM5Bms4krJTzHMauXGv66qwKb3QXVrFkP+XlKDmui+jylWoRGNFfsH4t4vvr3/tyG8/1m1NuIw';
    b +=
        'ceAqEZ0GTaonCJ8uCxFu9bKEvJtTqqI2ckm1ufBo7L1jJnyjFGkMYEQl2H/pgBkQBTp8HRRLWAS';
    b +=
        'RCazIJabQAEl4c+dFjEyNNXgVTQm/jpNSOGJjyIREUrEzGmS9AF/cFhio/a8mFqilqJZTFkhXsM';
    b +=
        'yCU37n/OyJyyls1Ml0extk/v0eb/rZqC8thwi5GgnfJe3TFSI+IXIJOstEIG89ds0GPDkB0JQUG';
    b +=
        'EjMzKxWuXxZ4914fUTHlkVphejYTU3NP90mGG1NCs5SwUp8h3jTR/ntIgHZ2Uj1Nde2nUdC+agH';
    b +=
        'o7NvSM/Xynyfr86QYDMVSi2cB2N5s9ytEXEo4KpLG89eWO+w/L/MXV4yCW576kku7MQ2qdGauqZ';
    b +=
        'wVd3n/bYz2986i6830P+TtvyluV/4770O/QWblittW4yQLXq2jHBa0O1Z0xBKJq0BaO5KvYA8zk';
    b +=
        'G9layMoYIbdFH6A66kNoR4MIbdE2A5Jav8uoD2od1aHWgsWO+uDcUR+cOxqEc0cDcO5W/pvKzjw';
    b +=
        'mUGzje+d8RQ2AfUstNavB+WIFo1WwFtlXBUvbFATWkCByhWNtMxjWRLx6c5FOU8uBeC7Zh7+bpT';
    b +=
        'ibltN5/Nbm6WlgYwXBJVrWKcxNNz261dlpHVPpdceoiyU7Q+3bXAyYbBcDJltUu/9wUN+5GZkEB';
    b +=
        'Rs6c7sL6dvqp8A7NJ8ytk24CWTqAlS5jLcI8dGvkpnajwsqG4gNT6R94Zmg1wfXqVXwHH+UlBcG';
    b +=
        'IBKs8q8kkktxuv2QbzZnfRbh0vuBzOJbIqp42v2Q2PuZhDosykV9uWemTpQ2OPG0wZG7Z6CerX5';
    b +=
        'YGogC2HfViHgUy2fePDNz3ctH+KTzjzaEbyUKdMRBPTHrejLJ1F1Sv0myfHkOYyvTIqge3NoQ9c';
    b +=
        'iFN4AjE7AZI9okYquYdrEWL+OQVaNUJmWdXHYMcxgSOXpZAl6hoiqHlgQftQhM5L8qw7meYruco';
    b +=
        'jSeh00poaS+/MCWL2Q6fgfyTBmYF7r1crxjJ5LOkN0Wr5/AC3bd5ZhucdYswe2JdW8qsonxN5GH';
    b +=
        'amZm9pnoxh2uYEwL5n/+RreWydrJ82/cgY3ZTqyeWo5NY1h+usmDxt3yv8coXbdzx44dNKnp7in';
    b +=
        'haMw2rhTprKjbgH5tA3ARemLK/W4kzf+0wWlgOilSGyoG5IZhdwcTb8T1f++dOE9z08ru8F3yKQ';
    b +=
        'xPNG5095BA6QeMzK4AO77+Rk9vXgztaL2nep+sHwMXy7Eh++l2QlYe4XQ2cxWU/luyaoqFAK5Im';
    b +=
        'bbYp/9PkWmTf6Hpe+gyar0fsbQfbS94gQR4aDjCOgXbBrrELqWv8l92awdjYvdl0yy6bFLlYNNc';
    b +=
        'WjtqnmnHSAbCppNNnCOWTTNk5oy5YdcwzE+5ToshMbkK5l96jRHC2eQKy+Cak/MvF75Gnp15P3t';
    b +=
        't6wM/+iZSTlNpFtztTqMNIW20Wu8dbcRNM0O+jVbLTdaOGvFttFruiG0kR50lbcRjRtFGcsTzpY';
    b +=
        '24PyaZuvdKaSPu/VNoI9n7fGkj7t3p8bKt/9e0t5fHT4jZC6OjfNKtlM+cDyVedFSPuVXmi9guy';
    b +=
        'bCssOHHEoeFr43j4HnIYglMlci/wXnQ3Z7PP5uYI5O1bpaxFCzLpsNP9yL6fOgDok+IJgjtLfqQ';
    b +=
        'aH7QgOInzI+dX/YSAjTnb4W9JWKa3zJdAwbRxyLNTzvmFx71C3N+4UG/cNQvHPEL6yfl9zJdX6e';
    b +=
        '/l8ivsybrdemj2CKNDOhj3K2unC7t1DT9HKY35Sbb060PWZsEhKUABBMisNnI7mE8et9h9nqpTt';
    b +=
        'voiYADBFA53dhVTTZLk3dUmIXiSofBim846DAgZ0DMZMJWT7iJuGT0f8ScJ6FzGxIdCxICgANA8';
    b +=
        'sJIzZuFzNNACgzDWzFVOh9HDAcQYGeZj5XtMoF6sMH7hWVo2uIjQJamFb9tIKePyv2fFbaZSKxU';
    b +=
        'DcJ+tUay+7+PGEsU/IEEhvezewjVofga69KwkXrsxAdHr25940luPEmX3OGmm3rUR9n/HF45vN5';
    b +=
        'U/zI5maV9Qhom9xL7frDbKM0W9tpE0ALEiaEBSwcmxrcxoH8XIwYWkGWqUTRkRgsYeAIFqky+s0';
    b +=
        'Y5/jq8fQmJ19sEdEAuu8VJo+T/IVvphLO0kV8ndmrCyelox1aSkpZdN72TioRhArykrQNAgc+V2';
    b +=
        'c2qTy7hM/1ycfJWNV1dLfbgD94Yu8xzbI1d5ie1Ob6ywH+w8F9QZM+chZekjWamePFdvz8L7kAo';
    b +=
        'l9PHIq5eyrDf5jbln7fntTPZ9Ym9btezF911xu/alF0f6NvV1Hd9bK/u2oC/5G7Z8c4mVnHk21F';
    b +=
        'w1qIX2euPBE9C+a93wmLBkVz9B6wOYZVEvcew+nys6rc6i4LGouc9eqecF16zdyY1r0Mt3SCWt0';
    b +=
        'ykChZ9y6DOklBJB3h/Lh2Y2GOf9S2Lw1sWCzICb1kc3rJY37LYv2Vx7S2Lw1sW+7csWfiWedXMU';
    b +=
        'Xqew1sW19+yZOm3TLn7/8WYZm32qiA4n75sMCVtahqy+lkafta6ubDTJAFLMG2Vfay6XKhLuqB4';
    b +=
        'mshzTmnHdEaLXLBYQ51xSM42mpxtNDlbp39e7JRMCpqcLZFPTc6OfHL2KT9jlhkbWVunMVsiI+l';
    b +=
        'Np38HkjN5B9pn9gok/hVo/6S+AW+tdDO+r04XbtSfnyrAci8tgcSM03e66Zaf0D73TT7/1vgQNm';
    b +=
        'ZEUf7viS5qQY1fKV9W31TOfg9zJ2EC1lhoIsgKTw7s9nLng3cxRPjFcMS3luhrzgipfGRqDvrZm';
    b +=
        'RRG0/QUuy8vqm2M9OszYmAusmm6E/V/gZy+XSAJIhVl7+4QFiC1XqI+2e09UX6/mAlTkH3XvBzk';
    b +=
        'V/lNZnDTDWGTHdx0fY9W8MVRXN+iCf+JAj9/orTfv21MWleZcY/1VIP0NZGQOAv3CGkSFd2Uf8b';
    b +=
        'ynUe3xuTpkGRuJA5Z9GrMi3X9BoJHBfXqprcgbFDNlw0Sfy56zEtxHxKuYQaUsc2AMrYZUMY2lb';
    b +=
        '42z1TTmnYV7rWEuU0+jJtO10kkZ9ZJPBP39xJ28V4i8b2E/UntJThrpxe1YMZi8BZk3SRQ0sCv+';
    b +=
        '2WxYzqaASG8QcyztmKnbO8pSYYVReyxXj91EUmma8RF9IYuoC0SYFYHowxYcEVXJunh7AnZxJxZ';
    b +=
        'pZHATtDrBlRbOT4lcth/2SxcsFlj7AR8EoRW4jUngcuOKoIo2DP6xW6yIjV+cZQn/Fnh0/3wQns';
    b +=
        'mmDiQXHFEzD8biwpmKjCuCAmpbbud4fU0/+0Ybz0qzbzt0rsNvCMh/7OEWIH8be5b5QuTfyoto1';
    b +=
        'ZVp6Wvz5puCBK7dK+3WwizJOL4XyCo2VbVTmmFG9ltqSSyV34NmrBBLTboyAaF2aA9G1Rpg15tU';
    b +=
        'LINareUue1XlNLUNCSjeTFIyEfUVmx9Ja6vJPWVtL7SqK80/Yrmss37udUsSpfzDcu/as5rvVex';
    b +=
        'Rwd9QA99QhMgWUn2tprkbTXJu+E5z+90HQlhyPTsxZTPa28UGVWlKXf9jtAtEfoLcG+T4F5GCgW';
    b +=
        '5Sb+Vz9uidaBQYb5JhSHqlxGdeTDGg8uPXJzpRvhA01eMCLeygC+tZOffDeCrEkCssQdhZOxHin';
    b +=
        'Mo2oe+/aBV8GHZLvcCngmmv/LuG0Va1uM1ffPsMf3N83hbcrSt5mZbzc0OzbOXzfN4+0yahwhyb';
    b +=
        'Z4n2s/ePCfaVfPMt6V5DrafrXl2G2mevabePHswvbnd1JtnN2kqzZk0z4eqIaZ5AWSysh46hOY4';
    b +=
        'KfUTkUFIsN4msbOoJCQlAS/NYhh+tmaRYazOhK2rCXfjB1KBCy0V9U806p/IO94ohhg4/LOkS7q';
    b +=
        '+pjClfoMXHpMRponlVSSmxrLrAaDwmFzq5hrxBl437+UfZ9ebXBoFD2OTo8fylh4Pz184+tLoov';
    b +=
        'KvvkTcZROD4M1zbvnRL3i0qqoUH/mCttXufmeaho3FGaDwgrHy8Tfe60ziKvgO+JE6qLD5LxfZD';
    b +=
        'HCS9f5QtzYUJkiD9v4+pLc569pd214cAU5mlYyAMxNIeCIFkEgo6yNqscZ7L46GNoj0A8BgI9wR';
    b +=
        'VdoLtBReon74V0u2/v4iW1u4UhldEcz7j2jLFH6iwu4csoVVQDwR1FMakFKJzrzWqD1JAmej84Y';
    b +=
        'iXRansTXujX3YPYX/Vh5/2AOwmRHG2GVPI8TZUhFiVXkWNwaRdyL3W5gJS+5beWoZFZDKo18mR8';
    b +=
        'L+R7wq9ZMP8wW4/ZFw6YBJScq5OcluTwSQkpRH5yS7nZldex/20vODQWKOXB8LtvAeU+lCdJRBU';
    b +=
        'DQZoH8muoJM/peyv08XSdsPEVzVxZCQPBJk5C2imz/OeYZuimmT+xMhn+bXEdFxgzNmKKjnOAAc';
    b +=
        'RLymbgKZUjgTc5ExTf6Xc44KgDHHNy4QCTK9iwgEWAjyzzXzUZJCiaDDBVcx6u71HwraC3o6Br8';
    b +=
        'G9/cCEO+A9sM3UyFvce12s7rnQt52uYvJa9+lEpig/ONe/rFEcouPBpA95x3gTYfppZB27B/5rI';
    b +=
        'AYVBlSmD9Vnc0V5h9N/Lkkz4yXrEFbBXavYQ7OpbQaNyceKM8M6Q0eKf8g8J4VGD5TnPypd3vEd';
    b +=
        '9hrV1zt5s4o++30mPkP9uPIjOJY3FvpMWQyuaKe3TcSVb0GiarqOWNWLCNipPrvAtcguYlwMA4I';
    b +=
        'p1NCupx9yFXjheWTD1VazhVS6/aHqPy85yFVfnaHkpIC0mI7vjgLUbCDX3wWkWntlXk+9soHH9J';
    b +=
        '7xoNdelyJdFyJ/NyJX9s7bF3t3qdPJ2WM4TzpqNqY13jEy335SgFi1tF4AufRnHZtnYEOJ0xQI8';
    b +=
        'wqABb2fcjeL9fUviG0oEG/RIBmtZI20TCpJM6Ly8h75LrKa7ZtqkyukKwrSTzIFALKDFLrSSDlt';
    b +=
        'G5/j1FyA2wcJOa/Bh+k9OtQSj6AvMNVBDRiPeb6mABBMc5yfVSUFN16yvVcmHnceuOA5C2iLlhv';
    b +=
        'HpBER/KHuvXsgGRGRliJuBLdUCO/e66/dyGddLpoTheNaYDQkukinoa3MbpiqvW0QVPcrn5QpNj';
    b +=
        'Lwm1+YZdfuNkv7PQLO/zCjF942ujCKb/wpF846Ree8Asn/MJxvzDvFx7zC8f8wqN+Yc4vPOgXjv';
    b +=
        'qFI8ZHomfNEhK3A8pPbySo2XgeewFdaR4LJrSM0YF7oJOQ4kcokQ62JYQbdTyAm8K0L3Dz04774';
    b +=
        'nePuElrEa/EsfmvuheVDKScprhejZgBDNqFwRWuElZLUl0SzIyOQz+zKueSqFdhVycDjyg2u6qc';
    b +=
        'aKvkgmoNk800kxG0lgw2GlK38/D6tyVx7Fna4NZzF2+D+bEl2mDXuWiDo+c6u+bM2uDWc8+gDcR';
    b +=
        'IWrwNdp/7A7fBzT4jPxZRHyuuMlsjyAU+5W0ZfUDzcc/PUB6L9axukqOlpaTlN0DA4LrGE0wi2Q';
    b +=
        'DHE7gQYpmTPRiLJXMUgYKD5KRysyI3Dm5AA1wcHVS+Ek3h38MseLCjcAiuZcx7EgJfAjqMmNl0m';
    b +=
        'iLPPejbAUbvT4x63S+O/tC67h9agLSPqcssFFitZ4yMAbN2MX7sp+Kl+bEPAvdCePo+5v28J/U0';
    b +=
        'IUqRvd8szpH9R/0c2XQz+dnGoozXcwsYrzlBogKzP/D7YLMWTkbvZS90ENRhkMOCuICI8pBBMBV';
    b +=
        'mFvdYV2ooBeNRKtYvDUFx0Fgd/6wf/3J10FCpWMbI2j7MrZExkjaR9ypx/4VuJe9D+idLT5E/fk';
    b +=
        'zTUTnXGh0kOjbKF8rMx0+l4iiZiYPT6G+NIMc0AJCeCSlx2kdKnGjcC4+5UUGKkx+PY2jWLOIY+';
    b +=
        'q3zcJ+0yWa8pLLoKQtApJajccIMJGnMm0WzNI7B0XGIznAQhH46lbQzKcy/nkq5FJbjnqHObfrj';
    b +=
        'FOYiGC6vSIQJCnYqhLacFZs76x52nzMm0X8SPhLlo62Fx+rrbiv6uxkrsVRrxJTyzlClG/LkQ/X';
    b +=
        'vHBSrElnw37lIDHi2oUTZhuDfB9/Q1SNWCF1JezoKqIy+k48I06urO181OP2VY4jf0pjCjcOJ3c';
    b +=
        'TlarkF31GA+/cl7Cty5PC2a57awa95rPY18yX+rnH2o91Ww8+CACQW8xZhrshuY06NlSRaEIt10';
    b +=
        'zLbqLo1ZaYWY5mVtwecb1pe1xP3fYN4M7qTmL+SdZvAJDcHMcnNPkxysx+T3Kxhkps1THIzYJKb';
    b +=
        'HpOMG7gO1D9X4zlPYFDmiWZ3vjPrZBPWexqKbEfrG6YO0fBS2BpDClkcRrM4jGZxmCqL4znBk5j';
    b +=
        'FYWpZHKfBGQ0Ckb4PLFMrf7vxXpW3Dzr5x3q+T5JO2RLrlxfSUeb3pkpwrx2vQN6jPuhKWtreMp';
    b +=
        'saZpsRI385leeiV44k5YMfd7bKWHnoUGXWzUWS5+Ah+mIcQoZanCqe957Y1lti/3XcEks03bqzl';
    b +=
        '0fd+cpu+YQ/bfn0IQLkd3/CXweDj9u3y1lSnL+p0WqFqU6h/Jh87/dbamEHm7fc+Xf3GyHkw5LY';
    b +=
        'Q64BL42aav7a9eWut94bAVYfT2z/74msFvGEuZ4hFjCKmfKb95H3dc+9XpCOZ9Nu9jTpVzvvraV';
    b +=
        'f7bpX06+qo8uizICOFIt6QpCZRRXhRMZdTHFJ6gLkPi6I/vr7zoHiRQHDvAUv0AL0kianJLbycN';
    b +=
        '3zSGWdJior6aHA4oqMR+yAcSpmqKRKpv6YQBURJqo6IkNqW3S/+04brG5gPMzlMtnYMGI85kRG+';
    b +=
        'b4zCRf4kltNuKkHq5viHLZ124CXsmqPNmLiaUkhgY0rfSrI6Zx9TzxSc/Y9+Yh39iUMpErcVBQX';
    b +=
        'jAxDEnQOrk5GI9XVGSoSL4utjbwXIA6pMRIxtu0qXzgWPr2G+gHo53SmPdvYttzXaVuS1+It/4S';
    b +=
        'W/6KuyHdqq6zWZEQis3XSNtrnAbEmEmgoVQKrDBvrOxJ4qbdfziHG9Se2nLuX/cnckT43ERrjAk';
    b +=
        '3b5JsMyZ9DR2b5Obg3GZBcQzIHeAoNYUjwTKIJy9kjwa8qrROFxCHjk1hJs3Crin9EIcGpHkk0f';
    b +=
        'qJqNDywIGnneP8oM4B6/V9liHkHvjdGzkUd7/Nmeauae0TB1tTs9LZv7khQGpKyLj+r5KeQnwvk';
    b +=
        'Z1x+LpKf1fJzifysk5/L5Ect6ZfKz5Xy83L5uVp+XiU/18jPL8mPSpD9ivy8Vn5eJz+vl58t8nO';
    b +=
        'd/FwvPzNGfnfo7079vdm0dlbjrpI5UNLFNYb/UEV+haEohEQ6SWgeD6x25vzmnnyl8nGIn08/mT';
    b +=
        'bNkehKYWCfLA2+lkhYFOsMuq7Pn713NgoJzuh1D93rSXSTXnnw8KzYKdyP7lb/1Z24t+rToyBhA';
    b +=
        '4i5mmOcJrsuIwoRIg2XqEpMwY/ARwdtlfSXjWgYVbE2UDFRxTbR+0g2noZleKznh4k1NuSI1xIY';
    b +=
        'DJcyTXWoMxBfUGcgLjwDcdHLH/cKpd8fAfHXf9C7/NcfxV1KqKV+m3/zg93mv2iPtssbhHjcTzU';
    b +=
        '1uwQ6D4F0D91ieQRhhj9tBMr9jAypNCyw0x51gAivfjKdv0GkNkQxfF/F9oHZaPQWiw8el4LLNY';
    b +=
        'rWRC8Gh75lENdgnhiFC62frNhBdgAKMB69eI2IPF8azVjxva9bE71BiZt4XP61ZAID74RpiRm7i';
    b +=
        '9bhd/SmZ5LaTZ8KN/3l/puej8pHw10ftHrX76rd9UHr79ptrt+1CA/Am6XxJd72UzH6JFzs6Vhu';
    b +=
        'G41zKu6/bbkShDj8seWTMe97Mtz3yVju+7Vron+K/X27A/O3Ddz3DGm//tjYhjMQhQYk0fRK8j2';
    b +=
        'evwXOG+jXFPDDHwjEg9ff0B2+qxtvLobhX++mU0W8GYcWQyyVdSoYbSFdupmaBi9Ag8q/nBeard';
    b +=
        'Mk123iA2kqiWS4VHrghgG1G54LJ3Gv+/m/MY2QRFoDQMZ9IEhnqxLQWDSo+J0SuZhWSEgw1E9Jc';
    b +=
        't/AdkAaRexKPKoGOwrCJ96yVfwqVnni/abYbSrzKbdVyPLQSwpF7feHYPym3tpJ65PBQOZsckPv';
    b +=
        'sOtgZi2R3yLc0I05XiAZDEPLwT9QPUSVAWMHlArhK4yfhPqvMfomKi6R830jAIAYf7JN9HtYmXi';
    b +=
        'LZQhf7uZLVUimmyiHRiFashJf1z7sWJ96xVgv/56+fUmdMcNnkQlL6T8bL6ybB2djP3VxQv9gIj';
    b +=
        'pvtBJpzJLJVGHSWZ+xa3wojBA5+vMbEBl395936Nlvd5tFA7OvdCSWTOW2wExychPztO20Vc58x';
    b +=
        'Q2PF5b7v+KHx5QgOcF6e8NHJ9r5+6AE+qvqmIlqELas5pHhTOobxufRHGxVXU2//Ef+F5h47VNV';
    b +=
        'ELR72OgKw9b8A9a3N9Y+C9fa0UQ7ow8YafGjCTyn29DRDWHTHB08PB8HoJMNuJvD+bFq8ts53+B';
    b +=
        'P/gkqOg31ZGFumAvar7i9y1nqF02YtGhoz3KwhRv9e/UrBpq2QilcXGdDn03+i5wTX9aTJ0mXRN';
    b +=
        'mU2X68FpP7cu+dIiNsynu4dKVb6mDyJ7xrGCoMpifrBV4LWwBkLSSiMSKUvCZSjc6xtW5enEsSI';
    b +=
        'ukDXDNdKr3mhdHQ2sgLNcPFSWmkCQkX3NVx9ngLHJTCyuJ6qYniTUW0wxkDueYxHjOelA4E3IQe';
    b +=
        'A72ZulVOm2aMauqgexH3rzIPb1ei7fQuUF9bUl9bUF/DBzOx/BpOB6EOILYiuy85YCLZOXiM23U';
    b +=
        'beqB0YsZNgtOJbGeHLy1ea3Jlt/pFBGKQZVNBQOrIGUM/P/a8PsX1PXlX4ZoY50C1rif0OfTj7G';
    b +=
        '/KsJcT183ZSr4v7cYbgoLPhfH4XexeZPLvwSZjPNdYTyAlOFFtoOVp7kq7GkCTjGrNF428vyMLm';
    b +=
        'thq9A+qe40Fr6nfEKusF9idwnsq1r6QbAkqV1HDTGJNaT6rKe8n1DTq73ZL+U0COKIB8Cz7Hzkc';
    b +=
        '8A4T29dKwqpC5iJ4iQWLtTR0oZ8IB/bQhsJMe1KOBRYs2S+8Df+Qoa6eDHJBwcH18tdLQjp8+dd';
    b +=
        '3GwQTF+mrDoAa81UHrufAkVVqjeNwRnCScJ3C/5WIyVKioSJiEgaIQMQ0IdT91l+f3yWuXzuuwc';
    b +=
        'rcIFVouCqkrAIFG/qr0Wo9Dpd+4tFR6tPPd/3/1F0HYBVF+t/2CrwAi6KEJpvISUBKQAREBDZ06';
    b +=
        'QYU1BNC8oCEkEAS2omAEIqKSD0DoqAiTVBUsKIERMUKCipiQ0XFdkZFRUX5z1dmd98moYne/b3j';
    b +=
        'ZWd3dtrOfPPNV34f4VbaR+4sRnEe41VDzCm+E5D4mfYhvhOkOwc4GUIoMVgSFr99RLBt/BpwcJQ';
    b +=
        'fLJ5GyAAAEF3uYIAu8B4rN3R7kbTD1NH+UqfLIpW8CziqD8IrKlzOfcBmkCXTgZg+koLmPZWiUs';
    b +=
        'ke6kR3PT006I6nhwFW2rgdtghH3+K3oYf8WonsLLpuj5C8OveQwgVqbg817CHbJS6TndWwhxr3U';
    b +=
        'HN6qMkeSlut96GHaLBf4jDfK9Ba6yoZ7hXPEboMHIgrfi8WvkbnUBYyoAXufU+iaFCRrAE/szlK';
    b +=
        'ygF8c5MOhyw5dKSRWk/3DI432EBbqcO47VZJg663cvTmeCXGyMX/koTHoDisyOQYsd3b7RyoUHV';
    b +=
        'mzlO9/TugxvTvMI7xIRlVQsaWwP4tNGL7R89sJwoMvq96+3cES/ta9fXvoAr9G3163SN429eJpH';
    b +=
        'hpgozfQjRBUgdBENQYgqCUogex9MglCicmSeUXJRtyCnTlbdWR69COQEye2Om0KXTU19krRuwq5';
    b +=
        'pJQos624TrbhkvvFvJRoRiLoM3eAt4wASxJHAkTdFGc6xmjECQDDnmcl3VEow3S+rmycsrLBh1u';
    b +=
        'Xo54Wy0LcuOhRvWIcE+tY3dwxxbUoI6hXX7ZHXvqv9yx17ljgksJsI0siWPiEoOsTMasiSHyjWk';
    b +=
        'd44oFgbq8rlgBkLV4XLEC7IplWQH0qzkj3kAh0cBgWfBQAWJL9rFAojhOavXCnuB1Ym+qSMNDIT';
    b +=
        'qLIPIY3DN/lSDPLiTzEZl1L2Q9hClxz1wVRJBMcaOltqgCXotyBJkGr6PdGO1nHpYr7pp3q451r';
    b +=
        'JFlTkFzkhQV9GSFa9Ac+vBqV42iowje4PpFBeaTUHVxXFb5PXNiizo9w678f+rZp9Az6fuP2jNF';
    b +=
        'EP8IGTsyNBwhKBNeGBrTeuDg4Im0H6VA0+XDwSnmm0aVE2UDG4nd2gmziTaZ3wROmA0Q3rYakcg';
    b +=
        'CV+4NEQHVhCDyqpJhhQB/pE+2p37xPNsSw2jKRFZCENRvU1ERizo/eASmQyRUDdlKNzB96wFcbQ';
    b +=
        'C8NOJBUAHCkgBqbuyVXJNmT+kpOGVIko846sogaa/nLLoxxV5D1xCPAJU9VUHuwwsyjKsUrTbEb';
    b +=
        'VmyqCfCXQ/aag/gowUDq0Q8ih5LJSEI8PhK5C369GhU81sI/SdkIFQn7fghO3cc6BbnjgPa4txx';
    b +=
        'kFqcOyukYMC5QwFEd3vuTEXbc/Hr3NmIdzZ67hwg+3TPHQjxpcKvuINos2BE4TGQLN9Ekswj2Tj';
    b +=
        'SYDBQoHNsFQnm0/AtyzB5xEMiW1cbZZk86sc3eVTJ5NHxFWFpk4FiDXJtoBTHxUBgW/vr6bi2D0';
    b +=
        'zltX2ijkp7WLejG+P8HQUTWLejpexby+pojH2rfnz71uN0VPpwuB3dFFdORz9kCeMKjc09eecnF';
    b +=
        'z8WmYFWKlGlvZ9bejCe45YaEjSDUf8Jq4p83gLoB50YGEn42BrGIdHdsUe/NhZ76/yBcC5ns9Vi';
    b +=
        'EOtU2PJTxpAK0V6/QpOQrxF7UbmuarKD81R/B8FJz9dB4Nq4g5viYjoIQ0rb7XE7CAFpdHfM/R1';
    b +=
        'Ew0wVI9I4Hfw4TnbQiTjFHZynnkwH3wI9FKF5v06iEfA6iZPuDK8DOWd1504xSyISsxpcRSyIm2';
    b +=
        'JpPXAuk3El+HkjvofWizW8FEh7JExS8wkDSxMNJygQgNsIQrhQLC4x2AfRpNHfwS4pklHVRKoHa';
    b +=
        'b28pQWwNLjIgqZVobemLuG3nmUuToaskmLtRaulWFvGNL0aT7toQskiUJ0YrSSLjr0QujwQG6QK';
    b +=
        '9kKSLoEXizqOjE9wi8hCxaxGgcemUEganQTmOvrBkezf8MTq5EVPMbkJt53cz3erPhc3jy8+ExO';
    b +=
        '/Hz4L39ECXcM2xLPZA3Lo1TgSi9j4HEd7M0J+9dAOZF1NMLXG3ZW97I3yvOwRqM04OYd6ZK7fUN';
    b +=
        'EZsC78nAc/deCnNvzUgp+a8FMDfuLhpzr8nAs/58BPNfg5G37Ogp+q8GPCTxX4qQw/leAnDn4Qk';
    b +=
        'Loi/FRArHr4CcFPEH4CCFcNP/hVNPhR8fvkHf8/kLLWHQc7Hgjzv9fyIt/4rDYsdQPJpFMIIM7+';
    b +=
        'CvwvK8T6X9YqpIMzK3EOQ5YIOVwe+lLM4Ts1F+fIPkYF4NPZ07fD00RE21YJGCpAiOngIKkmqJV';
    b +=
        '4KioOAj95VS5nUa23GQkStz/enl+G02WC6hhBqtL/8jnVsekmAUR8liNrjWc3QkTfSNRZBQTKEg';
    b +=
        'bpwG0lQC6D4INHFEuXimOxrKZRtDZQKo1DeACMYaBwuHlnWSFgMy0rdOnHZaXTstIxA8WHUlysC';
    b +=
        '0EKwTGODA1gbXkMLtixlg+ZbOlFUHWkaoW2AYe9PiaYXIQir5g3GY7qjZHXyfHRQgkxEm7zPYN0';
    b +=
        'B0pKGK0AYbgAGYOATKBDmiPQp/UEgaoVdvADoBQQSBYbwCgQEL1YqQ8GpeGEAQdXnIcb64xMrAC';
    b +=
        'At2RAX4FUaxVIe4h+vl3tYAF8gwoWBu+0BWFHSEkD3KrNOonQCqsCEjcwZrQqwEyyIHhFBbtEfO';
    b +=
        '4KqNoRv2fBF7tUXJlZYPREj81FOKngZumcUKwoKw/lPtSmiKg9ANfmzWqtBLy9sQ7ZgpypLjX+3';
    b +=
        '+nSE8BRoJ0oyt/1MRhCURAVvQ8K7CaNSQg5widgqi3dCfYDFNpBk/Xc1Mq6qftv8hwCG55EzQqR';
    b +=
        'vCBAHKK/Kt6SghQ+jsLWRl6JWfl0QEGdMZwR3iomkmhPscNmKpzJLAr2SFxngBXlCOUPApGCPAp';
    b +=
        'C71WCyxZ4n+syxLOvhtPWiksC8AnIUtGc/YDiUG4ZmjoJSCvHkEa9hBT9wTZdtJr1C0Z/dGudAJ';
    b +=
        'A6YqrJABF7YwJEdII4NKu2KRTAfDdakQGjsQ8CRPSlABEDccen0OZugIjWMQEikn0BIuxDolAzI';
    b +=
        'kW3yRxDTGGJ6gGM+vAWfzIZMAz9sQLkj2XE+GPBiaHEcJQLXxtZ0gj6gOHxxwI+lPyxjmDITOmP';
    b +=
        'dcggL533DHKC2GdQPGELyt0nCGcnAomR/lis0ka53OMy5hcz6cxMlOVZxeG/Ii8zYUiWYh8rK4U';
    b +=
        'lYvHOlSmvUsi3Cj+A5fg+qeYnGkl8Xg5XIpUeMWUGfz4d9TpgSSjjvyThHXN+0HGcCLdCYw0Oxl';
    b +=
        'XDBXnCdFUX5AnTFRhIF9MO5NKLjhrfOh1rMNiAbjYI4yfomE5awVaacgpGYWymNFPn9XFK9l5zp';
    b +=
        'L3XGejKL/oZ6sqsP9eVXcAg/E1o38mov5SB0lQIlIZaacHfrzhajKIeAqAj8HQdWXXKRjG/6PAz';
    b +=
        'fVtMVogwptB+KLJGnvIobBGBnQY6UU9RZxbSOmk/G88hbiB7IoQuGYQ3HTK4/jhkMMWBoJG1aaT';
    b +=
        'C8bwnuLtJifoNLNLuvwE4QqlGiW1GJPKMexRid3qLENK7V6IlSxJGQYwMtGXUxGlIfA34IuI0pM';
    b +=
        'ELuO7jnbWtwtagczg60wFqNPEgSc4t35OLovQzDMvwRCoBLiiEO41AVqrrBy9RYHSefOYxcR59J';
    b +=
        'pbd7EBR4fUy28/gG77THPqpOe3XqP2at/0atx+/LLdfc9qveduvedqvedqve9qvedv/tOqG/NPr';
    b +=
        'OX6KvInAK13ZsgpZF1RJm78FKdg8evg7Kot5eMOj3ZiNNzzqDQWvpmpSlk7q7alalrkUfTbQQ5p';
    b +=
        'ALKQbL0V2t2DCc6AM3r0o5IpkXXY7EQuLxaaze902xQHGg11op/cGGFsWx+SQiTUaBorDSKoqhZ';
    b +=
        'lW0WxqBszvnXDsYO5B7MtdMLIl23UmwCoAnzy02kEbmiMqCUM0zp6oIBCG7nshQkJZ5CEfcxkxR';
    b +=
        '/dWm6xN4gk0z0D8QfMnnUDyghRzxCT1FcZkSwiAiRoiqnvRs2RJKIug4sK+4uIodHqYGpUQijgh';
    b +=
        'U6VfuOBego5vrPf4f9IN//nkG864Vsdt+M9/tuHbVUL0inVkNhhH1kLZLQBwJRgSVghiAiYGOyN';
    b +=
        'oYogyBMwoCE0wGJEVNO8PJYZwbgQdsYlBYpMwYb7KLUu3l62iLUunLUu3F62iLQvXADwl/xQpzk';
    b +=
        'UZIHQv7PFj26I6TjeO+RWZTKHXC9FUsHAqNtjYCg2kXEsr0znduuEB4uVLywy/aVW4tGmVeRzTq';
    b +=
        'nC5plXJp9T6ktNp/fb/ldYvCJxG6x8I/o+0fq9+Gq3/+a8fe1XSfoaANj/VcUenMKKo9X481kcd';
    b +=
        'IRi8PuqMxODdpshHfYUqzzEU8Rn8ApYaTtJ0YRTYfl7PAiGXInM4EZOfkWJ3NvElm5iTozx6DOX';
    b +=
        'RmfKEy6A84bIpT7gcynP0BR/lOfyCh/LA05OgPK+584cN6yg4sIFQyQoF/TSXM7oCO221wLGhkN';
    b +=
        'wYX5qCcGPcFBywlhxMBb1+W8oQK4zPwJFX0C2+pQzIAqnaLWWcFkhZLWX4FkjVaymjukAqiVLvU';
    b +=
        'aqRB0j7gBqL7YQRDY9Q0BsYd7i0p8CIHuVIOLh1QUKw4se0RJXdNFnxrLJZ25SelVR6mQvjJ6r4';
    b +=
        'hh5zYwjZMg09d4kR3NDKg9IiD/AcF2zj9m2infS1Dj8nrot3cIhEwYOAb6/9gbi3TdybIXhBxwj';
    b +=
        '5ARW9eEWbqqAiR0ZiFAMy0tbHiDMOaCfpCep7VCk1AjcNQlJD4F5BMexJmB9RRHobjMVg3zitMJ';
    b +=
        'yNrhYBYtUCsPzBh4A1IPoY1BrTO8APEWMZU5PGmG2R53mV0Bchh98gHzUTGDpTY4t9YFQDWLNBy';
    b +=
        'A4PEANpcExjRzbm+AuX/LtYopyxfSXjZIUl6Irjckt36WwrShvFB1gPl1H2+2zR/yrTqtIiNpVl';
    b +=
        'X+YsVfpjOjf+57CzpYxtpxqLJuAESIKhNLyAcUjM+5KDreF6fHqQBTTp36g4zr9e/8ae5MeI/o2';
    b +=
        'ax79RZb9HGmwjy17zRDHZCdnrn5DuiwxCsOWJGPfFvhL6wlIjq119IkTTS8b5o/uQ0jUUW7LTSC';
    b +=
        'xSuu+RFynd98iDlO55EouULg5DHxcTNr0bMpxo00MxDaVpVpshEgTx+d0AtRx5lIqxBiE0EEwSw';
    b +=
        'wRADENQmGRzBnIlkHglGrwfkMgLDZoxCFRtyHSQNFWWi4ejYzxbNrwzXDcixdYIKg/QEhxyuhY8';
    b +=
        'HvTJIPK4GL7uhkReuvqGyYmhFLBZrzL9hsQwX8HXhJxh+DGsMDl4EdRbcLIVEulJiUHOPOmGxBB';
    b +=
        'nCMID6QaWKChTYMwGkbGdxvQClxFSLF60IqsVmrQapNZjCNUycr+0N1MdC3+xcy1BZz2vzpSs/q';
    b +=
        'o5Ua9gtMC6kWVVBulN9XgEGkcNEeNQIbB7cpa5WUvhEWMod0IVx7MO6pMSHfs91Xmf/fEMQvp3G';
    b +=
        'rtb8zZ26Z9uLJtSuI3ddLzGgllGouOSpDrvO40lPucB2VgpjIeCX4BoL2orPVlaMot7ryA9CEuh';
    b +=
        'RussS3PbjpbIceIF+0Gwt7PIkn3FWnFdskYiXXIA5SRfAGUrNoCyJ+CyN9qyjKe8Q42NJYng5aC';
    b +=
        'UBRxchYEiQDUrQXqLQL8aKg3Sq7pqWsy3APIFywDzBfF0FTkQVaQ/NUY0BxmfZs+FN3VzvorIvB';
    b +=
        '6dLgQnYxTdRAVwilmnq0RW8KhzXHddAlHvDDlr3ST7VBSIgfQelc66A5GsECFoHROdGha2d3B17';
    b +=
        '2CHvZEQJO6dwrwZwdjTPom2qw+6vBaPM5vgdGYtQgoVQ16KOkeRVekDMBIRvWCH+7AYTCIRialq';
    b +=
        '71xezEhEuoNEZEgkIpwYOArUcMEEy7qUlBtfUsxtQceMXcIbPBR7WFJZcyvBiN2GeWPulRFxT/V';
    b +=
        'F3CtD1F1mxD3dF3FPd30lvaHwdE8ovPVqLPgAaeJJ1R1GFTep5P839Nz3gQ2JuQxFn9fCz0D46Q';
    b +=
        '8/yED0hJ9u8NMJftD6oS38tIafFhhg8QwFiiwfETMvstIlEOjEB4RI/JjrUU136P5tCursxCSEa';
    b +=
        'DJgQYmPxKmwFH/4OCGSKYhmJpXDhLyNUdbBv8z8TgdUMwVRzcTYGBRw+FYjUqoMZG6Z4ZynSlBo';
    b +=
        'yTrbJnH3OHE1sh5UwGIryAJJsTwmCI6gksJxiYKIcCbmWELIVdmEWhGIHVnMe2BuVZJ1Z4FNFYn';
    b +=
        '4Wb0sW/QwywhNxoYBsldb8nnkRaeR3FvMyC6JRi1RoUa8PHGFeZUo1o5ivk9RRQlbTaUoy2w5hV';
    b +=
        'ialEWaXyFcMKGl+eqS1YDhrqxGHhGwzUtdnwFaQLBekYMxr0a1KVIdy5GHxHsAshUM0Ymr32RpC';
    b +=
        'imuzPsD6ENhyLWKkG1AgMnoU+MAF4bcrqR3sCO/RwL6sIpxLj224Y5FOVuHA3UsxzAcTF7INry8';
    b +=
        'TMT7sWV4eZkYDprswsvLRHoQtAp/3CX6NAfgHKATJJguOX6FNboMBIQHaHJ6UnqLczTz9CuedHl';
    b +=
        '6ABYjiHp5slEIwocRguIkhE9cuRA+cRLCh8/XflgxOdr/+X802s+UIc5wxEwyji8bDqI2g/zaDU';
    b +=
        'fqAyaCrFSC+PWae2AkJZFGtgFxhMP5XcAjX2chHkm9yGmefcTs3U+j0/zuZySE24Fn8MacrQ6EG';
    b +=
        '62+O1y/4uNR2gRD7o3J0jtEB69vOoKfDIntVRaFHRQpVQKTM1x+kh1YEZBMuEIMMIdt3qWSMTLH';
    b +=
        'fA643DXc1M2dQG+L0ROfAUooqZsL4bRYYhC3BSnRNnMH4DColAfKFkc6cOYPUHlwycbP3AgFHP/';
    b +=
        'Bs3cHZkHjijtBmEIzh4IDQKcKEkNolIwGzAqdFskMOtgLZaniWWKYjJfB2NdSQLevFZgPiCaHLI';
    b +=
        'kW7tgx65bCUPxo0PwAmX2Qx3TEfcrQmxbZIoG983GadzDe37wFNWTzxLOTbB7akesWnVxwsMpsH';
    b +=
        'j5l/yGneQtqRFb7TCDQ+DQhEIOKAipOVEdpZGamun5s4CaLil22ZgDffVg+4MCCWwPEu9XZtVM3';
    b +=
        'P1HJcFdMfTHtxLIhR7qulaTVoiGyoI43znINn1E48/c29HbthA29XSu7oQ95joYO2GqclGlo5ss';
    b +=
        '6Q/Wimh5jULVR6ovnEg5CRziIGngJQTgaiTtb7iQ4CB1gIjqhhQ+BQMBV/SzAh9CRXrVEqNakLP';
    b +=
        'uVOz3hNRpo1TzIHLWz2NNQ59PhWtnkyk54waAn8IPq3ABtwEPAFW2MQ325mzHLOTKzk85G9AgQj';
    b +=
        '807wToCAtq7BfJT5xUohfJQ0ct0pxwoYQUkd1eGpi5Xlf9pTjpyL9itaJO91l5JGHPPPRDpPAkt';
    b +=
        'qYoR3NPmkLS9SkD21ATtL0VHky9p8iXPGxaarIm3Zlhk9A+X5r4QCzckIosj4mIZ1hog81KgiWp';
    b +=
        'q9KrpjR4NvMvBTUFFXOxFFE8TEjUfaNVKGuyraPcs9pb7Q+DCg7dgX8UNF5QAeiWnUICUR9Fngg';
    b +=
        'O2yAcrW0mQgUE9MNWRdSBt0zwx4tFfme1tDGdxq87ZE4Ql5o94BqwNxzZ2AiqRTkBs8e0e8XUpT';
    b +=
        'GGgAFQGOm7XKG8jky6FpDWOwt0jx6FRPb22Hv6vtPXfPlGKC8pOXkOKuUiXx38dFVpo3Y8KgTZK';
    b +=
        'Mr3QiETVSY7FYQspfUnKMh/RKb6o7kCUkJAmnnxVMM8t5NhqPhSUDMgit12Or6HBzi/QqsVOq1i';
    b +=
        'YZmQ5UaGSKXsjYuiSHBFFCx5qbhUbr1peKZxslcat0rhVfCp5JlbRMcUX5ZrQUL1WexvX+az2pt';
    b +=
        '5Pikg6XJmzA4RYcJw33lvnf0M9wRtr/G84mo1H/KdUNPolK1BUWvAZkpyCyM7MTNToIKngeVUvd';
    b +=
        'V69lT6FA1puzgzK+6AkpOCbDoPpOab2TNTdY2pPi2DsSx9TN7g+xf8fziWLVW8oUjsZVY1GWfbk';
    b +=
        'HkWJQfbkx31+g9/e3KuCIQ2LUYaGhYOCPswc/YGgA0bFzLTKTLwGaFeqw9V7dnEN+GyV+XnnCfD';
    b +=
        'q92h8X3GzkGMuloVJhOWSu7xIQkb3RZW4e0zEMAKizUvc7Un8j66m2CqSUqWbDN2GIjc6xmmVDN';
    b +=
        'iMbNhbyJIT471DBDcyW1PFPhRBjGkEn4IJShuWxr56tOGpLiYDBEKOSMmjux9tdC07nYBSYUc/6';
    b +=
        'NX1qbyIkH7RuR1UVyTQ7FyJ0cLDKGIikCSEyH78eQmS5H2+6Hn5vOh5CbpU9vtrPO9bbEyItMvx';
    b +=
        'G0hZ9cOx79fcNr9Y7BsDRXLzWy/PfOfpJz9ZMKWV3lekH7xpxucL3zs8d1ArvZtI3vTbxm+mL77';
    b +=
        '1M5EEsPxjx/Z8/OuxrW+GWumtRXLdm6C5+nZrDqo9kPSI491MQ1LZZMZuETdNuqeCF4A2OYVxe3';
    b +=
        'auxgPvg2GM0KfRY8/B10FtJBeBpRKtUnW9IIrhpJmIPgpeRYhE60lybxAYTGv3xk7FJ6pGMZXel';
    b +=
        '66sVvoQukoGrBi5daPqGkCAiiUyDSKIRW6SjtTSpzgEkmRBL/AsD8c99mUQpy8wkmUjQSskGCCw';
    b +=
        'dyHhA1uMqiBnxrga4jV7ChxgugpeT+sOlsJqF0JaFEd41IDqbkh1nLC+pohjb0xT4GD8tzVlvAS';
    b +=
        'I8wpswOswaXJiAPSbUG9gdaLUhjNAHTCORiXUKqONB9r1SsQMiI+MN+xwguHwlg4QPm4fE8qrd5';
    b +=
        '7611Z8q8/bg2wtUBVEIj+dzKlV0lfHw/brskcK6bDwXACHJNBXA69ExhIylwkHAbKBhrPALSHbo';
    b +=
        '7G21YhHX/0YRjFDi2HQVJsqSY9j0TQ1FysmBjgTAE1DErEZdkG0YgBmliHiwiNxQgRGomEQ4mri';
    b +=
        'vMC4cVZYbCFvBSIcZlrPskKOZxhCP5dqT5K2Q0skjiFyoxOGBkQfYg+My0sMUKgvKyBj0Ot8Q6c';
    b +=
        'bWh6qxgxwYaAHmhN7Xgd3B9/tPJzlBpgMUNx5cG6DHzrM/c1NSC6jCdP+3ibMU8towwa/E201hw';
    b +=
        'klXzGTmFCg+o/jDbDOM8jSUvChgjAkkXudTX4AFBxXkN9V29hIh9l8Kg4K3oWA6YTVyCoIBEs0u';
    b +=
        'cxEZBtRDZqgsxEWq9yO09yStb7mHlpbZnPjy2zukbW+5lJxf7K5C1ig7QBoUrQOQiNGqMpjCmNl';
    b +=
        'agB7aSDspZHl8ckXa8c2xuFXrNKDnHSmgm0YYF+ijsELbFkGEmYWmsq5YJiR+SfZplZ/X5PeZZw';
    b +=
        'Z1T60hQzcglXDSspP7982d9WytX98rVyBTBfefGjhrgd/fve1Wan9IKLmJrFP7+CACAoF1LB87/';
    b +=
        'arhS4aiHdIpccWU8smfJGj4qHYBBaGqpQuzZO7rMK8lcWWdlvIUQpIoSGJ1Fy1ALBv4pLVr46So';
    b +=
        'CZZz8jHjjp9p+LY8JoPeXUFcCQxd6qkLGCVwEw1Uion6wRIPFgUaxD7J9uW5DbtkZNu2iOlmoZ7';
    b +=
        '21y/LuXI6lNQn2hSfUKw36A+wXjSpD4xQX2iofqEwiBDgyKRUiV41Sdz/MvGARWPWcaKf81wBDx';
    b +=
        'xvwfs6uMSFCLCsGIUXjFKuStGc1eM5l0xt5xEa1r9XY0ZV1prh4JlOD7oY/DAhI6LMcyY4TJjxv';
    b +=
        'GYMaNcZmxs+dW251oDBWecBVzqyos42jdIXAQNxcDu8ey5RhgnNnHauC0ZZNGEsCZ/aOj+Y6u90';
    b +=
        'PnUkPHlOXQL+BmVI5IwZOiWMqPZ3OBwp6jgs+tJ3yGLQlRTpBLDfnYpB/SRnknm2+iXFMY4lwZa';
    b +=
        'sbveUFBTI0uRZnaNssynVWwzRkSORqQ44j6ekyCO4NAhLI7QCH1b86gXdRede4ULCU65pMSBn0M';
    b +=
        'S1YI6iSR0ukd43hrIGnQqhcQOWmmlIgo7NJZA3ELYs9pkPKgqrCoGWzmLBtugyAGKeb+RqHFIPM';
    b +=
        'FVQMw2lNMhpsro6SlqYcT7HKO/HQ1NTzBSxGdPmQq4NCnAAcsXIoS5DZKTQKFlFFp6IYyZY8bpn';
    b +=
        'HkRnkkjf+VitbO0usajMAGu4ZFZqmHRv9ZDtIEyu6Sazg5lk3XFT9aVGLIOlIEMOJf5bSJZdmtx';
    b +=
        'dBalFXBI9o6FjGkUT5ZjaAr2VJATEgHbHC8o88YFYn9sReYoRYvE9aaF0ioSIczDyNuVIctFbk2';
    b +=
        'Q6d8DjgXkLa7g5m9EUEEzmF2GzywsUuhEZJwnaTO5+UzmXYu8fGb7vXym+r18jihlevmMdkH4Cb';
    b +=
        'bZXGoATr0RYadW+cF0Oa9I7bdR9bmZQpCSGDdTiGRStptpkcpupo+rrpsp+NWuNBDjklBwNDGfk';
    b +=
        'uWgJxC3hz6jKgp+cSaBTUSXyF0MZsamlGj0jAJFtlWy8NgYZ96hk09wsLQHhNHSE/gQCHTYEeyr';
    b +=
        'ZOKh0l0FtGgj7cBYSgS8RoeeQDRSJ0CBoWBCkRaakC0xWoMM3UkWtqprXovCQZIYN1YqIAQSmdJ';
    b +=
        'WYpvXeHsl2796bWkrqTUj9PS+Mp5GElWxCiIu3NFMXoMlUvnMlMAzh0hK5plDuxVy3nV1THjVjc';
    b +=
        'QO4PePsUwJXwLCmOrkq8ScHAKdYaYZBk02CJmmxkpfvKgWDAUW6mV0YKtUAgbUy7V11UrZuoIBn';
    b +=
        '3mbTnIcgB1cjTDwcNb6TYtxrtPQSpf35f9is9b9bzbr5+M066+aTK+GT2IyrXQn00yfQ6elOpoO';
    b +=
        'c4SdzLANGnlTx8SncULXqKVC11DcGnx0Q+mAN8CW6HCMVYn3TfZuIRvlPgzufAqQatbTdhhp3hW';
    b +=
        'UNu8mBYzCfQP3EHNDiKHOSGmhd3UsrJEnJ7i9BxFB3H5Q0FnVfDlE1kGiyV1ZaLARKKSNUkZNRu';
    b +=
        'umxgB2vQJ4wNwaIPvLvc3ZcxrN2Uoy/a1aOc3ByNk2UsMyTfN/RQuXsMfapUIbpa543kJCW4Akp';
    b +=
        'p64sXdZMcbH0MH0pS3OEAq0AVd1s+jwZmXZR5fFGLbEeQxbqrmIJXgcWxCjtnXkOBT9mEdJ0PRN';
    b +=
        '5Ns1BU2+bQkNUS0RNEqKPftuMdWOwuraQ7yBeBTxhzN3/Enk6vAbCzqq2JNs01PHbdP6Ff+NNm0';
    b +=
        '5bpsOLz+jbZqlKggb68KygDFcouPjZzgyvbBzFedcmc5VNW+oQL5ydeiWEzy2AhABgrihCOHI6L';
    b +=
        '2sRu51xfmlqc9f5MtIV1ZLxaKrei2VenSV1FJJoqtGLZVGDmmaEatzUJiPZ+bdZeohUMY9Didfr';
    b +=
        'kRGkxIZxYwnyQidL8yzI6XyeeUxRSyjI6AaQY67EJyjkaigFkq3K/aqpNrLpoG3k71lmrSVffdG';
    b +=
        'cSPZnjPNCzcO6gSCjEVMIwaZZZf5GHtL2DcCEl6DDuKGJd49AJFgMTDB8Vu2oMbptAzQerlliO8';
    b +=
        'rW+Y1tXRbVlTD27J5NahlB+Ij08GizZ6jkkgeeH66KJQXU+XFUYUvjsiLw/KiRF58LS8OyYuDfJ';
    b +=
        'GkDSnfam2F3/2jGuHlSPW7BP2prCkq4JlQME50yUZLUwJ3J8WQ2DXB2ClCGLJoVuSAsz23jWIUw';
    b +=
        'DJqrJjmcl1hf1fOjOaPZeXynd+YNbIkgoNqvkHgPow75I2MFntGM78IsMes4fXCskQRKyDgEkIN';
    b +=
        'qOYXesTBFLLXLEbDrKLFPAtO2JjXT7Yxh8ptzN2exnx5vMbcgP6ornUPxtWuwpEN+VBSJcvmLyR';
    b +=
        'mr8MrkqyPDzvSe7+ZUiUlPBPiJRK7CTG/EsTpMSEAgokgW+eAVXKhFSiMFKihKdI8J4wDwBitiJ';
    b +=
        'gFkUjB+dgegkKuIQgHrhPYr7gRgxpEaMqgGhW7RjDRAE8bFfGVVRlH1FJHii0pErkdz154bDKxB';
    b +=
        '6YLXI4dJrcI6JOljabNTO9ViY6OyP6VEbNdI8cfwxWZicHe/ZoY7Evs4tccK34I0LlLpKYjQPUu';
    b +=
        '/BbLdvHjW6V4y+MXivJGhErTHeMcTUJKAJfr3GSTCUSNNiegDik5y5ymye3IyYkYbChA9N5E8DQ';
    b +=
        'dcNaktcR4wkUgOAAKqDklyw4BihcBdBkSjAQu4TyqyzC3KFdMYm9jUGHojImn07wGgIuaZJMXxc';
    b +=
        '0+jFEAKT3LIwrCKUnCH9Ur/FHJbZCEPwpFsJsVcKU+ahlSH5WkPjFR7jQnyh16xZDUhyPWRXLBD';
    b +=
        'EIxP9bQA57B8QLARiCBk56HyDskaU7PkWobeVksjRI1ENVEY8ggnCRIVQvDCT9IRC0jTwpXBV0I';
    b +=
        '1qMxRl9NIPq481cNQVgFQRGCcogx0IIVZJoQBANkFTDKgxRe7t0A3IsH29ggh/OWAmeNYjQw7Nn';
    b +=
        'csALqai2GjzNdsGOT/bqY8UjUzS0BEm0RnwKUS6c9USoJVDwB1EUyUZf5f16eLjY/7AOeeMizYh';
    b +=
        'yN5fmVGTm9DFIHZle6tDldYTAEHPOWhPQWdo+UDrtoS5APYrfIE1f3OLaOYrM3xWlIIzG9ld4YN';
    b +=
        'fRGxCPR2VNZSjrBk/OJsIT3wROFIz11MQE83KyLXMq1sYT2BLUVq7K2Z2Jr49i2x6mNJK2FPnNO';
    b +=
        'outx7C5muBFCcXInSL2H4bFVNe8J0IbLmBjskeyG6I7xJiNFCXmTOfaZk7nPHLqMhOSGYxeLcMV';
    b +=
        'wji5BFwEAIFbNS9FLORHPuAxTjG7LpXIRm8YwxTRrIiTSr0eezmDiROahop8vqt3FBNsp5tRIgo';
    b +=
        'VAVI3uADZEYZiyGPgFsLdxXud7cIN5TmMIXXAUhQOALkqzixxUf9DWYgrDEjwuruwk+wDcAKo/0';
    b +=
        'xHnuqjq5hKDvc89M5pmcQIHKjYS6YBl6e1QTi6hEsWZGGAfKLJFHEM1mi/orve5Z86rnjl/3MWn';
    b +=
        'lrX45MJ7Eht7Covvr2rIM/8rDbn9zDZkRllTpOjPThGM8+7MkEUnbsaoWHgCUh6KLfMHHdc3Lns';
    b +=
        '6+CVpHsB/9INMBD1wBJWZU8CBVaXBVCQLyU6nyA5QbRP98rKdKKJCgVk82SlkkcTMZD3Q3hDLq2';
    b +=
        'RAVZZShUlKFcdSKlRz4OlFLG3AYAXffa90bKJfOHbEFY5hzUekcEzWvOdP1iwFYeNiZJXslharT';
    b +=
        'wKTP8VBapCQRLB7AfKcvgFcEVTiRpKy7DBsuxrFlxOjOx+3yGpA1syvAo4AYHop7CIE0iHtrE7B';
    b +=
        'NHTbQvickVAR2qegQbL3IGir+SPRWw1couAxYmeASyxwCgai8ICDEm73dt0xBUBnxwjiWHfMuDz';
    b +=
        'BlmuamORaB/vArB2smf6wTS+D8GOR2f6wDQWPOdDG3lTIXDToLdvYK2XSPihexh8HUwzLAwlQlg';
    b +=
        '3WAiL7aIlWrBXYB5ZtV7Mu1khE5KTEsaWQgkDqkesdtkwiurmgISBpx6Wuy7h7gg1hwCFakzAOc';
    b +=
        'uXrfrlVDCRItVhIEBRknWLdy/+Ldd99Jutu5VBewaPYlmAfXwihbzZeI5avuO1hZZmtmOpa70lJ';
    b +=
        'sj1XTwyYX+P0C9MsjEMI+Lk6Te8goSMbMLGD4m4PdKI14UXzvQDN4QBNXgNMEYj/mBd0dX2Gp+U';
    b +=
        'zS9n4g5OMiwPms/KXIGHSsl+NscxHAC88yxx6qizL/r1Pyef7nnIt+y0P+fz7GaxIVDUA4EpjWC';
    b +=
        'rgVeWlMRk4LPHImp2oTUb8ZxWug5MnJYqLmZNozUmQbM0KTk5RJoEyqj9GD4fMhZME1QwLBlJif';
    b +=
        '6lSI2/QDAFbQ03KEZBDs7LkJKnN1jMqkm46/ukt2VsTbBQxYjk8SSKGNp7+hOlwOD2IR2/kX/8L';
    b +=
        '1Rc61efGbMWqd6MgQYYqTmgkbI+jPSiMSEloyK93sBFoUa0prfO9gDQK4NsaAA9iGc5mHCU7Yj4';
    b +=
        'DGydzBjZO+QwMa0fnYHKgidckKCoLW4CH0uVxBJy5FE3OPmC6yQW7dPw3B6hFczUFJKWnNnsfkt';
    b +=
        'fBmWmHP+Deqbfjep+bJW3EFPdcJ/ZKtxs5nt9tCduUHL8BCG/2IkY0BcfvFhb5VEqXSzNLuoDHk';
    b +=
        'aYMGJmNhlR/5XM4GnXkScFlLQ2UAZfF8FcsZz8e/hWyXpEMlU1rEuFds0RDiC04bSLeuSgFruoR';
    b +=
        'Ne2M6K+d8yTUlGAdUdSM7KUkeBIjS8bhjEZkxw7oJ9exY+pxOlasn6hjB3ToWM4ZXq6iJ6sCaKV';
    b +=
        'KaKO+1TrGa7fo+KCHE42RwP6PtAPjEgPd8WwLweX2Boj8GEyyyBecNzXsLAnYA4RfQYJelDI+oU';
    b +=
        'tt/zifm5i0JkvQQNTaWBkibcySycSMZZWOUdgBJYtRV8tTPUW8uicpOble8QisSF0AMdH4wJVYt';
    b +=
        'iwCBZdPOv6ttuoLmgF6iRjX2H0vb3ODZsx7ZRtpkKe6SmsInhwgpIYAkeuYuKuCw5WLNACL9DBW';
    b +=
        'FKBVGrCLvqb6AvYPCizTAEZWhmUawNDIsEwDGG4VlmkAbSSxBWN4ufDX1fnrzlNzEg36vGJqmK/';
    b +=
        'x59XRpb4rS+lI98TQsDxXVUKuNchtC/Bh4QU31nJYbDtl1ijm0xmo0Cpd32igw3As/DlIhVC1OA';
    b +=
        '2JNGN4QLA5DrggtxskyK0TDw29XDBUGi5NMNF21X/QDvG9IlDhKL+6tnwH8iSfA7lF2Wt7jPvwk';
    b +=
        '6HuFcjYJt1jBYa7eBYOJ8aT4ADsGOvDiWylQQwsf2AsDWJglb6p+29S8CuK4hgRWwlUBS2rR5sM';
    b +=
        'qIlVJ2i45cbDQBTpeLqqBlZw1Tj8L3h2mezNyl6PMpDqyESVLHhFF0faxrhEPOBbSo9aYhpHJiF';
    b +=
        'OFAbxQ5zI8i3dEv0IkRzIrzSSpBfysZRRm+ExahuNp0r3SKBgyI1EgyH7XK2P/K6C5IpjaUrSJM';
    b +=
        'a9xQ9/NfQTkRJSrEk48xCjVgMIW42V2Bad4UfSFJqnujAOgHai+Q0yNb9BpuY3yNRcg0xpiEPWm';
    b +=
        'ITejJt0bKQYhSO495Eww2Gy9or3WV6ZPsOrcJl2V2TmJTYN3fxMkz2MrKJgYqKhc4oZK7pqGBkl';
    b +=
        'Cy8czsjnXaPHOtZschxrdG9G1ll+DD4yVKD7mnz4iXho79uMyrNFm6SynW+slDdGx6gzYGKRtBb';
    b +=
        'XBiz6MYl6GyWEegsv+Y/Pslc8Wqw4Qc0QuvJRGTYpxOYsc0idLyhTQBqdjPedlzXizwDbEN03yY';
    b +=
        'i/M5kyIU4lSFWYmaOTNNjtc4wdYMmlqZ65X+SLlFLf8AfJcdUHfFBnS27dDZ0tdREEYJFomBUJX';
    b +=
        '4Mu0DIPr+apdKWQOS0/080PdcLwF9VdyRG7aWc1SRFFUTk5NBieDDAytqAaJ8uWTfBZESGVqZNl';
    b +=
        'fm54MXDJFoapq0mkrra983n49PTtDsP1im2OqTec9lXGtcXsRmzQn8hAF82GHErUMRYj4Ons3IE';
    b +=
        'aXtSAgRhCTBgC4Pb4d9hh3lo83HterPRYUDpFKvqRuSvDdoDj9N6tx9qNq64zhkce62rzZ0tt/i';
    b +=
        'lUeXdslfecbpW+Mwp8go13FCseUmOv8aYFC7XCmy7yJuCkbM4LS5Six1W6B4rp17BFcHdtQJ5RM';
    b +=
        'mOWuBSXemSlJstKydw8BqpVGnY7AVlJQno/jYNHQoqT5FpkRGAFgNsEBgnDaEcq7tlghqA60Y7g';
    b +=
        'TAcOEwkKm59B3kQJ/R6THUFfxVej02YjwvFPIhT/egkEcVEPOWZnl+1Au3hrDhvhWN4mE/Z+IxJ';
    b +=
        'HJZFwql7ZW3JbsXFQlR2oyrZUZWuusnVslf2pyp4yzoRTZyeqswPV2ZbqbF12nX0FG4DMnGK+Dv';
    b +=
        'x92FwXAmQ6zdwVFiO1EwNGWBpWqNi7IclB5QSVyAOZYRjfSdDsanQh5hZd4CQVxWAEcvEpR2aha';
    b +=
        'vhriC4xdepUlRajx6uXYAvwrS1aJUVyEDQI8TG7wewvfIeBnV/QYYCjsTyoMowLlpXgmNoIfrLA';
    b +=
        '4SXJsGbnkmJ2MSheUqxIgZCULjTiw7sKxwKwRTi0kAF57ArwIXE4LDQHsTikjIpiImjFRkMKhob';
    b +=
        '7lPh/Gt64HCeUtjGopaq50yC5iCZPtyieDTsYKBwzhU6LWcwisYJFnvrIJlolFQ+EoEGcjEMSJw';
    b +=
        'OZFnHb/EmNMZO2k127ZPvgKrJO0iD2Gm6OhPhhuFWhvp5NnlXS6jyuMXNl71S9tYn75mdqjBW0e';
    b +=
        'N1T3WGnuqkG+XUoLuiQB3oIlOchVdONQDCEYq9XgFuJM+9FPsd+ClJVZWolpKrL1K0xqZ82eVOf';
    b +=
        'QcqUqT2QOlumdkCqikhFhnscBBz5A38vXW61pL9TOSYlgiM6JrFiXVNEVoCMQAYjUJBl7nNE3yx';
    b +=
        '2GID4yuQJD8xr98RALYq2EMRoC5axwQpumJwIYQzAiQBUkSKHaoVX2+q4rMSQYFxpGw15ttEsWr';
    b +=
        'mljKKSAfmILKPQ3AkAQHWMrEPGUZh2AY3wfzrG4JFWUh7bqQNs8IOHJHAULBWjErD7ASHZjUY5V';
    b +=
        'ffd2Oi/ccB/Y54RE6ayp1hEYk8hPH0bIrzURC8nVngptg5OtCo70YIbAnyoPiQampKFByO9R62I';
    b +=
        'uC6gwqbqZ6awYT4yEi+h6Hyw7CYzYgAo6Nh6g5ITaIoDJag7yh8J5MxUZJQP7ESNMeWs7Ug2BXE';
    b +=
        'MOZJNYKr3fbmNw5yEgDgSv0DqHF0KOI0s8ghAlziQl5x2bXu/K782rCaJ6j0ztR3+W2tb8/1p1H';
    b +=
        'ZV7NmKt09dbp/xHPVSQhWaHPRSzh2FneJ0uYfK+RBbruKUqzjlqr5yy4yKW6rcUx8dnUZn/Q+nM';
    b +=
        'c/SvP7bJO0yyGKbXZw1txOGs2hkBBKNO2HY854uRjVKlrxCdNm52pmrYYVTwwpfDcN9x7GNjxLz';
    b +=
        'Ih1yT/pbiFehaPS54CvBa295TOyb1BPH5JU8yl3qHsSQaUDIgxwyDWk+pUFtISh3AP9HodXwXcN';
    b +=
        '5ZDBR9/ekePu20+3JgR3buCd8JXpy4NVtSpkj9t6zp13Pbqee3U49c3ZxPRl+tXzMXI799rrv2+';
    b +=
        'vOt9ftI4KEUpgovoJK3uBKro7tDMMUG6fUCyj53/zBPWtxcKyzAAXAwNORToYugBMsOFa2lgF1f';
    b +=
        'SJYmm9IUScB7lutSXyEQ59z8fo2I0GTbofiNHW14Bdcm3LNY1Nul0yWoc+y2aRPHBR/C0gTEzht';
    b +=
        'loCrH53LHMtxTVqOn6FR4SAmMaNyhope+fpfVvTGb0sXfZW/6DM0R6Ttl6OjU+xXVIKJCV6q7gZ';
    b +=
        'zy9li3r+islnKfTpqClM49rzpXIXlFf0RjAMKtfZJyT8kFXMpmINs1M9Uj8oaqWup3BVqjHwr2X';
    b +=
        'xKc634wh71ouZG04yxy4uLtctboXoOOX+VDAatFMzZmhS7/JNVw1pMX8Sx6snjdYZcmo7XmY14Y';
    b +=
        'rvOa/pDQh2N4zCg9YyODggcg/CU41hEslEZwUGruFQp/quso4Gzffj1YjDRLdzj+G1J8006wKNn';
    b +=
        'DdkDgAqaDRerROyde0goLV+81rUjJxlAMh6w6VyhOecPVfpkwCg4N3ErpP0QNji81MwcEujWg63';
    b +=
        'TxRJGdFtF1dhDkrvHLjwUEaaoBiospkiFBekHxMpQW3FAaPahxCgtoGM51RoOxZ1yDYPJDHuKWw';
    b +=
        'f5iJ0AfZcp+vGwdyNobt5RmnmrZE8PBvOAUUmgrqKdGl66clw1QYvEitkj1/jkOMk08+qxD7IK3';
    b +=
        'asGCtMFxWgSrwKv2Ai5mKQsKbOJyyKhHMxCc3ZAimuu9ZV9QDmDhQ+MVWbi7krKLJQASPGkxiuY';
    b +=
        '1D8SyJpMRylsESkRWWtpK5HUWBaEJMg3GeSLFx9jRsESJZIYvE/cmWjk2wb9fTAotRh/vsxPSpU';
    b +=
        '5CLN5o7V59G8KEXEzJlqbq31z4OpUCruGzwVxIX3qNXBoNwhCxw4gReJQk6p9fVZlTVPxjD1RTH';
    b +=
        'MQNtqEuwADjskAzTIvwJKLEjygjM92Jr4ZSrBZzCP9VzUaReCGpLDa0rjDvnIskGXoXV1TJiXSm';
    b +=
        '80BwrJACDcEahMoyXEd68wSUpdaaujtBWJwyD5B1II66isd8x8OYkvBUHlta9KTROyrXxoRVwV1';
    b +=
        'Is1ShmvwQ0cMBI1CZgJwnNilpiYfHYqWIgkHACtbMWcHbQ4igwhuD6lOTJliGcaSLHxWlorpONW';
    b +=
        'AwBpayne79qxY/OPuLwMEgTxtx/5nF9y2d24FgkB+cvPdj+/d+fPOXgiBnPLhb198//Ats59bNQ';
    b +=
        'W+qpby7Yxfv970xJZFkLZE+oF7l+5Z+NyHaxMwIl5KSdGWZz+/9albzkVJTMqn3+385KFlc+f2A';
    b +=
        'VZEkVDuhYaDY3QFj3AHitKssfmZoNioWVDt4Dg0tD6m9yK/dHB2bIBzof2YDRhNFI1lwnbR1m1k';
    b +=
        'cC2LTC6ryGRPkdrxiwyWLtIqq0jLU6R6/CINt8hBrjUsEVrECTM36wg6f0SlTZVkc7Q7KyCxUzl';
    b +=
        'KMojw+AZiiZnXEfa4GNKeyE/YfWGpgMlBxT4GpJdPycJkAJtor6Ukqoa6Z9lgRrGVcwS71xIUOw';
    b +=
        'LXyFmV75UkvmMP2LDQJ8kyYP6dwNkItRRrZGogNRXZClFxcra9b902APA34/gwRVclzhXpj4Ojx';
    b +=
        'UU2IBysF9nNQaQIEw9mP4TpSD9pFlTWBzPcD9a+lzQGcj+Z53up7vfq7SiZzTOhXD45ygJuqE8E';
    b +=
        'ToGyDKI1bzqm3mjK21iJwzB8ZjF5EkOaQhOUzaU6/nFPulxqG6dktiXYwMYquDUKKo/Af35zAJL';
    b +=
        'C++QQ8T6rE9NndBIu0+aEQMVeDcvzSz9Rql2bMBVVbDBaBqFvblj8cYK0O1auHlwO3HdwcxM8cm';
    b +=
        '1GY/RsHqUnTdg/aU44Y/ATx7hlU3gaVnMIkkVtpyh4OmEc8c67goVbCrcR9PmylYoToZtUxY6Fr';
    b +=
        'up0zGANF5vCqWQ+ZSAoWIwOtBrye2LuvBRAb0tbQ6MG8y7djTTOnyM24AtZvnVgMHD400GM5A9w';
    b +=
        '2rjALtnLp41Tbase21bd19YrSDqzUJc0g0KvKa5VCSVRCgO/lCTSUCyTJZgswaQssshbZFFskUW';
    b +=
        'xRRbFFlkUW2SRfsqdNmI7bfg63dehFDqxLMiKUmxAZaSF0OQ6ro3HENASHZjRfF6hgxoyBWjLB3';
    b +=
        'psJdK9FI/kMF1o2ctcplYGlymZLpVM+PpKS7YyzIjZiFgq7wx3GRocw8mrtmN9XX883omsO8gHR';
    b +=
        'SUFP4Q+xCVHHCJyMRgYKxEOV+ajQVqpeHzvZKmxqcjVCls0ciRUgrVRHVgb1YG1UR1YG9WBtVEd';
    b +=
        'WBvVgbVRCdYm4itakeYBSQqjLoirMNOeJCWOloq4MmlyiKtq0phRcUwcldotNVH0tTwUZMxEuL4';
    b +=
        'kplB5EMAGyOjgOLtIuEDJ81JjKin2V89uA/5xx7PbpOwgcrmPmBN42qcax8VieCv26UcfIB1NbM';
    b +=
        'nPSWfLGzyfll3Uu3+uKJZ04Un4Pc3xKO3CHqVOUZqnKO3ERX105oparf+porxj9dGZG/b3TqeoL';
    b +=
        'ix/ijWhppgHuNObb7n20zLygSQsaLkIwQ/KaRGO06m2qFvpITcPnM63K6ugD06nIMthYYhZp/Wd';
    b +=
        'BN73xI10JGgSOFrq5NAGCn/4E0DSBdJ8RQr1WSJFCDFg0wQjq5fZ2qf1M9TtZ0+noC4K98miLQm';
    b +=
        'M6Sdy87mnZJ7juc+CNoUCUoLgULSHoEXFaZsGwygfj0XiDMXgsSgUNDrSA00IAX9m6g4FwM5VUs';
    b +=
        'SqUjMLmCQaoYyK8bUJ/AxVteg44jXL7hb7SZkJJhZRIw6YsEhi/Bs37XEiG+1h/0eQ6AG6v7k5S';
    b +=
        'BJZDJmNAMhWKyD0xJECn0jYGZMdrjQe/lyq1Il09oeJsw+8CYYe9opF28AyrYZEhBTXw0lg+xY2';
    b +=
        'BG6kyrhuVyhyi9OUGPQf3OI0Z4vTnC1Oc7Y4rZrf1B73oY4KSkt1V24VJuP8GLlVvE9uZXo5+Eg';
    b +=
        'nbK8GJ+XTFn55PhdJ4yQQns4GcSZBLxqkf6xN+keyGYgn1FDWhXf3nUaqsWDTiaGx7EsZBeMHGQ';
    b +=
        'UjNgQGYB1ASS3lIZPkzsQ4iYHbGGcXVbIPiUGuJeHCaf2TVKm81w7E2ztr2EU1ynmtNwkMGGHZb';
    b +=
        '1oP9l8eI/sIswpoKy8dS8wPEAyVDPUv858UzZ8CBCiBRIFmD51zkVLUxAOmPA32UEoZk3lC2YGM';
    b +=
        '5y4ZaA5gRP+jV3Gf7PMmNqiRtlL/IbjMDqI55ksg2Lo9eFLn6D5lNEQRLXHrftdb3TSRsOfsRGX';
    b +=
        'Kphe9yhR4emcgYmNjRP2PBWQ8OUrA6otDsYO9czPIKFQUO0yFvRCvDtBVpO2fEPFGLvJyfeTA63';
    b +=
        '4CV1bJ6qIIzpIURmmMw8WdxQcynBDiJ4tPIEnEGxqMj6Yx7VVgbUTa+TYM1V5TLOhORfPOoIOaQ';
    b +=
        'YCUm8R98yWtpmjFYodt78InXdfY0j3cCiItT64yYrkqo9BteW6b55QbaQuYIpMozCIFr7hQZxse';
    b +=
        'ji+sUmhWErmY/0KPDFjXt6uRS+DDqQ5EnFSnhdmIVSElu/dMLWXGMP/sjZ8+j/WCuX1ojNHBPBq';
    b +=
        '01Xyv6gXVhuTbJPZ1sSd0hZepWtsc14GUgnTGASN3sUdNGgN7YpdEtRZLHmDACixIKpFkReKgIZ';
    b +=
        'wWxMcNjhRHv5C4DIkTYg/xGhIAcUetZbY41RcuiSST8aA4w2JEdTUGqxw9EFyscsQoHxljQqugn';
    b +=
        'QN8QD5BzHlum7tgCBxPPlrmPMJvHCbRk/OpnZ2eRFprDJjpMfSHDC0c/bXKFlmwEmcEHRmUctqw';
    b +=
        '/h0cqq+wHZeUA83ZTfbUCtlTi0W/ext/RYg/uJudK9v7MWXbKPHkX1eNlghYK8/BrSPOsdJmlPW';
    b +=
        'jYmDKb4A06HYacPB7TwNeWc/4wK1glCpmi49mH9KyLZAN2yuWaBS+RFzYm2ZJABJR5rwdYFYgpm';
    b +=
        'ukRSlCv5YoAYdIc9LeYKWlX1rne2ld6ZcuhoVkeha+6S58hYVGMR8a0pFGvJcpnd3YBUjpVGb7q';
    b +=
        'pB61tyvR2S7QH0dEg0L2RquBF4V5m8wq0PidnKWeYEVYrX0xW68CXrJKPslEPakiL/kVdSSWag4';
    b +=
        'O268wzGFMcGMlIEJ5q8UTHhfC3lfC3lfC3lfC/leC3tfC3tfC3tfC/teM72vmd7XTO9r5nhJ780';
    b +=
        '7QuBLhMCvKOs7EM9ntnuBVd6kZUlhJEDOatI5U1+j0etL+PWP4+j1jXH8+kp4faXqfX2F6rxepE';
    b +=
        'YuPtFM3uGfyeLoQOSPoClsuWsIImwHC6iahgQeAuZmXWoBC3SRK2JnwRFHBWTBPYctZOdxkmg1c';
    b +=
        'XgRFah8HNgqC2LaRomjgJIKnh/C4Dz7qji8NVccHaP5fgh9RM0PQuxXYxaGSRJlzjb4YpYRaR67';
    b +=
        '1ZJWeVpIwitrimuIIrfX49eyM1hGLY1jXOJOxETVJzUMC90cxCwx0iAIFlkIKyvS1NED0zpSy1h';
    b +=
        'HtoIrD9X9zU5mtYoXUpyl2oTf8BolKdI4igdrNbAiB3CNtip/ZJopZNT+KIvxzWlyeG40IvUVdr';
    b +=
        'aZqbEyx3wjbB4LkVrH4kgwaqSF9D/GFse49bZRwo5E19I7t1EqSElcEzfMgMcYiZ1G2AwLHUZKv';
    b +=
        'F3eHWuHtVP1ZkePj93Y5calNTy426IVMCOGznd2zAsVyquQYaNd+LRgfSPmO0E6x4m8u3VkSlnD';
    b +=
        '40b3AO/oSoqPLxJDJRgjHCWx/2EoYlhLpao5LFhru0LZ1TT3ykyB7VWYYQ63oiEFg3wSvQIKqhI';
    b +=
        'f8b2iSEfgBkqY1coNFBP0zXgV30qPj5zUqL7ujqq/AweArSlnnBrKtWSDX2aereUxNcqyyZkC+V';
    b +=
        'dEImqKQWMMpnElDYjElTSw93oo3Jq1z6vEWkaakA0JZS9milis2Yc92Yv2xGZP5tIP6JT9gG4vm';
    b +=
        'u1m3/emk70p2fNw/uIQFx+yN3nyP/7OCYs/7Mm+4iMnezLTHAh8BTGsCWoKbGcfoaQ0j70TzWM1';
    b +=
        'FKppHdxwVDIEoQbHHKBL5WVIyj5BhoAsIaGcDOIowDnaSThRlE85iKKqvWcteyuhBOg5SFWWqcc';
    b +=
        'hVQk8mRqXzcY6SL4uG7s9SENkxxGHhJx1nOSQZHQCad5JEgh6oRq9AAwSXjPYmFh5JhsMEukR9B';
    b +=
        'pfIJ4/ET2exA6ZyPYDGnv8qGTXh1u1CpNCiqJATnUipVW5Qx6XfYIhX6HJHEC1bR3wKUhKNtVwc';
    b +=
        'NjiHdWZPEkJPrkILc0E6StvNR30rybgFxqVs5YKZ/vWkpO5jKm+0r+SIHPj8tbRDv86Ol7RhTf5';
    b +=
        'VhFkrh9jaio+VyvcqpFh8Z6Emvh3Abb2RcnknEfBUggPabaKaPPIY3u3SMYtcHiHWYbDREQuLHO';
    b +=
        'HsUPENRx9hD1FzU1iQjdkcQlGlhT8IHu/rVRddSri8oiJ1uBk4ziI3RnnIotPUhzBiauPxKuIY7';
    b +=
        'mwAQEf16eok+Di8kSlFvblUY0qPdCGB72NvaPQHXQJrkjCB6gUTGUgY0V77+yYfEcOPC/zXeD22';
    b +=
        'HH18/QVfsStSFKpbMvV0vmWq5HzFDccgVwtJIArh8IRdZEmvtger9oFMX90i32E0APoc9GPf8R0';
    b +=
        '72AZ3YMYB/VjkUJIFISyw0TF/MUg6iGmX11HFFF27xPc5+V0m2taoXlrkgEM/6OS7K3eCVr0iOZ';
    b +=
        'tkWqRdgHls2SJRBqLmwIKt8jWy9+rz2dfZMOePEYeL1QnO3988cYGpFkmxVGMx17GKBZqFUbwgG';
    b +=
        '/RYFv2Xs+cK7p5O2jlYbukwHCUKdk+7Mn0uJvpApy/Cs9fxV40w812yM3WECXs4qNyMNPZADPvy';
    b +=
        'brzltisRTfJrHBl7/VmXThN9VZ+iCnnIcGFeCuftUP1dsTp7aKZbqbdN8dmcnq7yZOpxM2EFRYZ';
    b +=
        '3DLD3uvJtuKWcio87Mn0+G3lVLjIs0PsczPVEbMrxqTWa2EKzVEJSt4GylW42imDztLkDBE5n5e';
    b +=
        '6tKGPM/vHTHmRjvxD5tHlXlzoWRc2yDALVSeXSzQK/YS0EJhuCIYBkEFivqa0n5WoT7L0GeJyyg';
    b +=
        'AieueJrotGI4Y+KWhRYAhi1KpViWy6w3fQPzthG0qMGbzCGb652ViOr2dmrvTPTMiUVMa83OGfl';
    b +=
        '05G36w86J+VTrWeOVk40zcnneY7PVzpn5Gle7jDPx+dqjyz8aB/NpauqnCWby6WrmqlfyZCFitW';
    b +=
        'Ba+NtNTuDinbG4gcP8MekaE2U9wyZ995TPyscqYdNHD33bz/IhaePfUejyRVsB9DxGqwp35Bh0G';
    b +=
        'QxduFlOhcJYL3UUloq9iQUpMPp14d5TgPax/vYdzxHgou5Bwm5Bppl+MgCogYEtYIsF0iSlccF4';
    b +=
        'q6CkUjYMG+6gSvYF1ENT7i6QUs9YG9lgbZLt4Hqtda4OwESlitluCyLsUdxk4Wn+MdlRS0HxcrT';
    b +=
        'mgtVIOfI3d3iRsnMhfg9GAUJnFALRHDHjDHE14CJAxzfKRm6c5j11UlchaVyVp16rcSA6QWY74X';
    b +=
        'qUO0S5RG8zjGzhArQgkIGDICD8mqBrNxzCNHAxGyws4j+ib4VtmP5G2rglXRV2BMXXXKr6tO+XX';
    b +=
        'VKb+uOpGq9DVLfUr/IFE6Eu8fb5XsCpAbAd1u2DmPobUdDr9YB/gETmeY71BcefnwiZNvZ43y8u';
    b +=
        'ETJ19RufmKZL4aTCbMREAUVAPSOjmCXZIeXSg2hZkJbPk5CktNFQKHV+yGXWpFzlVc4RZB0IHQU';
    b +=
        'Mw2MeY1ELRhpPit6+QsxSnVJrmZvfsLMYcr+xDxapTHOzmvfTZtu1gHvteqK37EWqqrOq9l/31u';
    b +=
        'GlhKoDkFGUvgUMDtUuuzhnd9kswYahYlmQrxjFMgDrw6ckykksvgzlC5IofAsAVG5GzOlOVpE93';
    b +=
        'jGHUqnWOqIbko5t/utUA6gQvbO5vNlnjLnmrhj8glDtSlc7XhxjTQwmx0wnOaK+4wstQAoRdT2F';
    b +=
        'VaY9YkzTlqIJWqgmNckIgHy5F5+GqKQhgsm1ZxFCQ5ULw8YbArO2dlRPGoTDBuMmlKwyINjchTY';
    b +=
        '9+Pc2+o0oneGVTvF+V7qvfeOYqHk4ohwU4AK+euU6ZnXVSTggv/PKCbGlq8RyooLEaWV8uC1GTv';
    b +=
        'PKzsFTtlRbxiqix8SB3MMt8MyCSNx3BvMi42GTZrxD6t4XbDCehYGSif6gCVGiCxkn1AbgI+bVX';
    b +=
        'i5DwNNpFYeG64TdYLvB0wRApfL/a/bmk8p+SE8iv7nUEx1wDKOAWSNmxtjKAtUIK31eP5sTjmjr';
    b +=
        'GNcU7KGmMHxjlrkb5InPMtzXbexHk0hWnvxg27Cq0I2MMx7VnTv6ve1B+qW1BYsFNxHl6L80lWy';
    b +=
        'vTOTnO9/8ZBVdaKMxUKi82w2f/G5/IGz21zlixC5sj1pSe5aZzLE9wSMb3caQNOkzinDXw2iemG';
    b +=
        'vFHV8wZGCo1URBe6Ajuch0PgatrjXDlPTTk6pPzggROPHgx3lgkLE1zEVA3fqkhUxlLGRCI8L/Q';
    b +=
        'xzht4hncmIUyQLM9suh9mEydr6h0E60jJizWpD3K+n7kr6JmHIj1fxWQD3claUWYdGAmBREbwV3';
    b +=
        'FOVe9rRM823SNGpRqsLffZWt2TeC0sEva7N22HYRHsfkUWzk3J4go2mLt0Kmv2/aKsUGxZs0NuO';
    b +=
        '/7pXnZzLy/EdhM7qpofqThsZFysurkucC+T3cvW7mV9KobWiDnXU8xcTzEp7u1Fntuj8bZtIQdM';
    b +=
        'nVn48jZQA8V05i2Vu2/YE8Y4l6q8jIu5HCdZwRWkhhLbz1viRq2qiqJ4yvxY9SQe1zyJLZrb2Od';
    b +=
        '19/oBz/3Fnn7uD0hCPl2NhOmqprw11bk1CmaDat4XoL8rnbdedK72OJmHyou+8tlKZ7soUuXVAi';
    b +=
        'e/LS8ayGeznWfXyVsLnVtN5UV3eVFJZrrZKf1X6iOt5xyZ8TL5eJrToG9oKImUfE+3U5CB4Heul';
    b +=
        'jlv1HBJCLaI/47Ev4JnoL8TYHLLuDe0eu5V6W8RvWpu5fSN/Pd5vn8H/12rRYLwdzAl7wlGAiDF';
    b +=
        'Fb/mXqDQHphe0WoXlhcevf5A0Y4l0x/+uXAKpOb+9O1779z8/I4HpoiicJ3AX5jo8HeTGBUouiQ';
    b +=
        'eijk094/D+/c/tq8SJO564Y5dP27+cntSRFdU/Bf59me1sRhJwapFNl/QNG9sfkF60/SL01s2S0';
    b +=
        '5Ly0hOS27WPO2S5s1bR9OHtr4oPb3ZJdFWrZo1a5Z2cfNmLZKbZmcOzUvLm9g0LTs7N71pfp54N';
    b +=
        'Tc7O5pekJmbk990aEFeNNo0J21c5vC0gmiTvHwxz01lsPg9pipKU0Vx0u01RblS/P1L6s/NgLrT';
    b +=
        '8vOjeXDfGpaWmR3NaGNFM4ZHm4yIZg4fUWBddpmVH80eJpONrWbKVNG2a0Sbpoi2VRB/SxeQmTH';
    b +=
        'Bamt1tPvaHbv3HyTzTy83f1kVYus8tSpOvct1KkemexmKcq4nfTOnS9cjxqFJdjQnqQHUkpFfQA';
    b +=
        'n53ktBRQmIv+li0KIZ1pA+o+HlNm3G5ozPSxud1GCIJYpKs4b0zs2JDrHGpWWPjcLAiqGmL1hdM';
    b +=
        '5WK4u/PGn1Dmf7Fl75cofbLdF9feoD4V9mTvtr3fLDveYbveabveY7veb7v+QTf8xt8z2f6nt/i';
    b +=
        'ez7P93yx7/lS3/Plvucrfc/X+p4/4Hv+iO/5477nT/ue7/A9f8WX3uNL7/elP/KlD/nS3/rSP/n';
    b +=
        'Sv/vShhqbruhLV1Fj23+O73ltX/oCX7qBCkE83XQjkY73pLv58vfw5R8g0jU86SEi3cSTHibSyZ';
    b +=
        '70LN/z20S6uSe9wFf/Ml/9y331rxLpDp70OpGu60mv97Vvs0i39M4Hka7pST/rK+81kU7xpN/xP';
    b +=
        'f/A9/wjX31f+tLf+PKX+Pr7m698oPGXe9KaoA91POkKvnRTke7iSTfXYvt7qUhX8qQvE+m2nnQH';
    b +=
        'kb7Uk+6sxdbfTYttbx8ttn9XiHQL7/zQYsd3kC99jUh38qSv89G/dF96rEhf4klP8bVvlq/+W3z';
    b +=
        't+7cWO5+W+MZrhRY7/vdosfNzpS//Gl99z4l0qie9y9e+d33lfyTSjTzpT7m98J8K31/898c1fx';
    b +=
        'zTVj6dGth3d4Xwvksu6nbDnQ1SV3+Tr3K+MP89hb1IZr0imj82u8CfNcca0jkvj7NSOwz+J5qn6';
    b +=
        'J72wb0AX8O/IOylVsHY0dlRK3eYlZ/5r6ilVDDFrqlg/+L4nQhfV8L8nTLzR2enTbQyR4n3RkVz';
    b +=
        'CtJwK86LFozNyxHtFC2K5uXl5lljc6ITRgvOJJqRPfHPszn5BXmZOcNxQx4u2tgD9ssKRE/l2Gb';
    b +=
        'miEHIzKChaGM1smT9ltgbxDtV4JuKvxFPXsEoDC8YYSlHfM8re8atyl/Fp3n4xKSKxBcuEv/qiX';
    b +=
        '8yDXtg/VObL6Nzsyfm5I7KTMu2MqLDRUVWQW6uNUIwXE1H5I6KNk0fkZcpmpCdX1BALYMXoA3fi';
    b +=
        'DrPg31ATBzgy2R6uEZtkOlXfc9f4+cnsw7k/Dc98xROg2eJf2djP0enpWcWTLRyx0XzhmXnjgc+';
    b +=
        'JGJinj//DcZFxV8xJwYPy8sdNTizIJo3OCeaL2YIzqv1op7rFKKpZ53Z+qITCqI5UEvtOFPpL8p';
    b +=
        'uxetJjkfvsaOGRvOs3LEF+ZkZuBxH52WOilrDMqPZGU2uxLnquWNFae01WSXKAxpdjcuC8TwH2l';
    b +=
        '72p3Z42n3iPdiLpoh/HT3pqZxO6Zk6OLV718Hib7PmF7Vu1rX54IG9OrVJ7WY3bn5xy8GpqVcNG';
    b +=
        'HxFn8G9B/Qc7Lx7p0L7m0xXVmPTi9XYum5XiR7LdEPm/+G/PyBsBtCwbrry62OFA3/ss+Xrb/vM';
    b +=
        'WZIbeG79oIfqxZ9onnWKpudNxLWSOiIt79Ro6Lk+mlndM1dhP+2Cpw6xqqz0vKhYv1ZeWk5G7ih';
    b +=
        'rSF+xkIa0sVpUBvlbud9ALjfl2sq0fs4TFSUcr9yUzHFpeVg4TAxe1G2sOeJ94M+eFH+B1svyWj';
    b +=
        'DfcCbGsaZnLGoBj+pJwzfLiIqzmCA1Yu/IsIZOLIjmWxm5OfULrGhOujjoCdI0PC937Gg5X71D0';
    b +=
        'iQ9LW94btO86PBMQdwn4tgMzywYMXZok/TcUY2bRdPTWza/5JKMoZdE01s3v6jp0EwssnGzJhc1';
    b +=
        'uQhzZ0TF22m4eHOrmMpAWEe8rkSJY9MLLBg0a7wo1GommyDmWxVaM+f51gy/0zF31KjMAsjqezP';
    b +=
        'OpO9KO6bMnTl6hDiNigVOuS+SufOVFiJ/fU9bxg7NzkzvEZ2YGi0o1aYMkTdRIX5Yjq/l2adiVr';
    b +=
        '3YbEfniYHnvfev2JtGpY1uKsrPg5m6Q7RtCMxPPg+I9ZKWlydYADEZef9scQr7U3fuEvIbbfBPv';
    b +=
        'jVKdEF0ssDKhOxj8VlSMqyFBkp+VRO/6dSqNEb3iL9y3nYU7+WOUvC+XKPni3+p0TFjxRSM9hLP';
    b +=
        'u6WNi/bEdqaKYntmiq/byZ22ds7E3rkFqWNHj84VnzGDW9c/bXhnmG6C58D9WJb9D/GPs3QUhEX';
    b +=
        'm4VspubnZzmvKBZ736rvvDSgY1trJlOTJ0wDy5Ao66Ll34RnZh/LSxg8We5H4lv3zMonE5Is1mD';
    b +=
        'MSrtKsbLEQxeYj996Ss0zs80rxt6f4ez+f6wyHh7V3rCpWIvOanmiX6XQ2UfZVzEXJdHU1Np2n0';
    b +=
        'e4vObk/QyZGp2UCp9g4uUmzlk2SY9uzTNQHUpg05nBPYdaOys0Ymz0238rMFxQNqHOeVTBCrISx';
    b +=
        'LVu0adPLHljOUGTmFOQKbkNU36eaiVT+LObwTkR5G3k48MaesemE5L9/bm43wdF1EqQoM120pjO';
    b +=
        'sVTGPO+fkjh0+Ave8/P4jonKzEK2WTKA1LBeaHrXSc6PDhmWmZwKtgnkwVGTLyYhOQEJOSxBW+8';
    b +=
        'ei3bBrp2YOz0kTPL6gfFi6eF/QH1yuGbIVGVSCknyOiTNXNEhsBNAiscxjX1cyRJ5a7qooQ9gIR';
    b +=
        'VltSWqYhxt3fpO0/MF50WFJDUjC92fmCWyug9Nz86JiplzcpBnmHyoWzEigeOfQbrKKJTwyvZcp';
    b +=
        'tEy/5UsX80r/8+0akSb+L1rWvElzekMwhjSHrz3XVAaJv/O5rvvX4Sx64tix1If+OHb/efV+2vj';
    b +=
        'TijeSh289a8YPhT3GZ7y9vkfHR1fX6rH0symXfFlVrXkKc/5/6psMrB77TWR6cxkc75ke893VY8';
    b +=
        'f8/+sYLouPHUOZ/jvGsFqN0x7DP8U1Clos2nNRk1aerWD8iDTxX3vlftGmfjAWKnGNMt1bxYinT';
    b +=
        'nqALz2I84vTUf/BKXanwakd7Z72FZjs22Nw99TB3Xt36d67e/9BeOvKzld07zJocBe7e09M2127';
    b +=
        'XjG4/6C+nQf36p7ay+7fsRu92ad77/6De/fpL94e3PWKPgP6+m736T2444ArruzsVNu5d8c+nbr';
    b +=
        '37oo3Ugd07Ng5NfUUxtXZ0Zt4OGGQ4IEUuJnnXnMSWeXk5ALvmT42Lz9zXFRw1mnpY8ZmCpI+aq';
    b +=
        'xggOGdWnzyOU2OJb8gg4Q9E/Objk/LH9W0SZOmY3PyJW/WFOsR3+/aWsSRVlfK0zzlWO0us5L/f';
    b +=
        'Dty0puOGp2P4qdo2iiYyQdF3SA1vJUlF2Voo6Jia8xokpk/OEeMdZJg6+Q708p9Z3RBnpUgWuzm';
    b +=
        'vV1xT8Py3nK+J9Pryy2vIVIXwQOPjYp1IYZwVDRvcFpGRibkEmQmvyCalp3fZHi0IKkBDpVT5o9';
    b +=
        'MC2TaUqkOmf4Xz32Zvt6Xns3p0m0S84aqcvLO8b27kusSXFM0LyctmySJbQQPIdJiUo/NEV9BEJ';
    b +=
        'ih2cC+ZETle5tZMwCHBHnvOTV2rJ7n9BknJqLMI3WILvwWIAnrRaBd4fUDEo6LPRw9SPgzMvPTx';
    b +=
        'BcQZ/rM/NycztBJlAjJPK0VkpzLdBuWSsk0aAEu86zPdmWOd1JDwZ9lN2iCa92djmduUcDPYJpj';
    b +=
        'efm/nGcqV4FWoNw5mdQwRxyTPe3JF18Cloci3x3M7/4V32hZ3dhv1J75NRjDDp796GRERLbnlJ5';
    b +=
        'yRuidQ2eAOUaJRk+L5i2cVxK4PnlvMEs5ZHoIp/uPyMQTSpo1Mid3fI41dOxwOFADt38FHLDzC8';
    b +=
        'QmnZaXYXEDmlip4nAwoqBgdH6bpp5Rxf40zk7LGY5XTTPz88dG85tedMlFLVvsFXVmeOr+TSlvv';
    b +=
        'RMNlvniVKIrIMXJyRffEgQZl7WzoqNGF0wEbXWCic9l/hYif9JxaFtpCua+e7lT18nREfne1Sqt';
    b +=
        '3aFpGVYOS2SHWSJjTk40O9/Kjg4rsGonmigFk+8UqHSmk+kb1BPTeJn3XqZJMr2dNawy/fpJ0FK';
    b +=
        'Z981y8zbMzc4Aw4hka9IkJ9G4maeej7nNQD/lvRJf277zpb/n9Kmsm44emtXpvyDZ2H0+STYKz4';
    b +=
        '+VbJzsPDmDpDMXFnmLeiZaibTXaY3LdEudNI0yPcb3fLovXWSQpEimF/rStxpUXmo0JwN3m1NgE';
    b +=
        'v/+sYErotl9/0E0ewxr5GR6LO8TMj3N93wmS+pkGjQRDctcG8PHCnLYZOhYQU8y/xUFSkLLJCkj';
    b +=
        'mpaRnZnj2aesCy6wEsbnjowOHjt6cNowUB6NTxP8VM7wBrKeejyfZLo30zCnndwOmS5SSRYk04s';
    b +=
        '5v+K5t9pX5poT9IX244wo/hWcnocNdcpYq5bHN1MZgtVPj4q092X57jpfe55W2SqroABIOaov0r';
    b +=
        'LTx2aDBgN2nrzoqDQ48+aR0DvNysgcJ9geJK3/iublesp6RiUtg0xvVV3ty1+pNe/soUtgMZAv1';
    b +=
        'on4rlSqKDN/hDj4FIxIK6gv9tZs0DlMtED8DhlqJ5m4ts7c/OcKxRLom0TaQuCNzi2Hp8LNMCOt';
    b +=
        'II22wpgPLt8fxHv0ya5l+V6WQhYOMj2MeVOZfobbJdPrmVcZO3p4XhqOYNpw8e2VaxuQdl3me9n';
    b +=
        '33lGWi8r0ET6DynQNnmOa594lvv3ntGQxgiX9C/njfC9/XKMh8bjTyuWXyueP5bv3K65mT5z5G6';
    b +=
        'd279q4R+dBXTv3bpxq9+zfmOx+I7uNEwmXRy37/od5Xyx58fxrF8x6+ZvsC2+7pH/ev6vtCVQ9N';
    b +=
        'mj5O+90C50bl/r7vFmPXPvjsXFLhh+tPmHb3ZdWe2Fxn3O6fr77h1ezHijpcPjdhFdyXvtm7G+R';
    b +=
        'u+zx6lljEj+Pe3Ph+ifn/h4/sWZ64pzX/hG66uzBg95f1K9D3wYD1/crHqRsaD+nduWse8J9j7b';
    b +=
        'bEvn9GHzKCuM0JW5HRDn81ZMDX0i9qqjb4M5XXTE6deBr40d9feU9t9cMXbvw4NRfn73up3NOtT';
    b +=
        '1tZsf/0DD7imOjtUtbH1x204IBu9cuvzX/7Zsabut07zU/vHRW9dQe/x5X61jb5E7jv/jmjU6VT';
    b +=
        '7U9ZsVF2j23ff9jzX9vmnXBbz8+MvXThu02L1xz9xcPtK1555JFRSNbpsenPzY89+0tfTsumH9j';
    b +=
        'IPjT+XeNLV5737NDXt1y53Mr1gUnzPw4fvJDlw5/xJ7xyqM1a3Wdcc73lb95dPsP3wzJr9BwQdX';
    b +=
        'Le3YfcqRifs+rl7W8ru6vkwZdnV5xXfaMzz4f3L1Szhebv33qnn98WzJ27Z7Qp/unTp77+3Tlnx';
    b +=
        'szPlxwtHjDe2nVLqxYf138iq8OXpq1fsPMNvde9mLva7tP/Oaltiv7Dqz++fe1Pki/e/uFpzz+Y';
    b +=
        'mLtFxOrRP2rO5523aPLQz/eMuq+9DqpHwaaPvfiglU9W/S6fMrgF8fPuGPxrDUtZl17RYc/unbc';
    b +=
        'HDn25DXVbqjR+9el1ii9Xdz5d7WfeXifGiys+MqTLS+YfqAwt2vDlt82/uqLjyovj/YxMla/dPe';
    b +=
        'b3fq8WfnUOw4m95GMU5Wy/37s6LHTqOtjUdc2rUv1FrVb1P3w8HfG6xVWfTau4puPLu6Z3fXTW4';
    b +=
        'un37lw7eyvhjdeXGPzjHYTl6775KUFn95WVLWo6c0p8zu1GrPrt+LN9727+Ytrtl95yXdVvxu0c';
    b +=
        'lr7BW9eV/v+onWhfeo10896Zkazes/eEDeg4J/P5P3x0AdTVwffu6Pguzu2bcu84+DMrs98+/yd';
    b +=
        '26q8cndcvdxGXzReV1hw+XtrN167f/Yv467o165o1PPN1uysr298YcqgrT9EDjzfdf7qN/ulvxQ';
    b +=
        'c3qBBtRkVH6vfOqFWk6OjGvU6u1Lr1P75FaNPVcwa1+TF7TfOaJS34O5DW+/pMazmmtG39Nh+b7';
    b +=
        '/sF2ocWvB6veCSt2ZcXPnw6BVZ5rnbVtYIZ7c6r+f4bvU3b9nY4pG42pdcvm5f7z4vLbvmh9wmI';
    b +=
        '/4z7baC3PT7JlSbsLMwrL0w59djz8z7Krvvyp/v/eWZ7yeMeb5b846N+1zZ+YrU7ld3btwpFejg';
    b +=
        '7oNAB6v/cAxUaPXXVVRaHG2uvJI6ZWrFkf/64raub9d78rNnJu95qOn9E7Zemv/i3MkfTL+sX+e';
    b +=
        '3KowpGTPz4Iv6q2/c92rdLon3/3NxrRl7HkwZPfCul59Un6n86Nw3+u6ennPDL7o9K71/1CqJ77';
    b +=
        'fux6WV10WbPntu4XmNe3aZ+XGzpx+b/+m1j0/q/f3m+bU/qn9x/NGR+3NaJc2oE/r02QH9z7laq';
    b +=
        'Rj9bsCSm9t+sWvB649Ei+wdP7Sr8s2eB1J2LLjshyb/bnvPoj5vv9v6YOI5L07of8GW9cZ7x0CZ';
    b +=
        'nT27jjIv+VZldJVnkwZ+U73e8PEdqr/X8Yvz19+ZcM7Zy2q1H9D30KMVn2k6Zk6o7uCEPS+N2dx';
    b +=
        'xe+PRtb8dsumViHl7nz6zGxdc2Pre1s3bNXp39m2vtb+7fZWDx+5ZUPTgPfnKgbsT/xiTueS33M';
    b +=
        'YF1zzSbu3SHc8t+eDsIV3njPk04Z5n67ebNXvfFVcf3Jz30sjWN9tpHaYFa5+tPPjDo/G95nz8x';
    b +=
        '8LbE36t8UCNKV2+m5HU3njk2Pctvnzv/P5K8bE3Bl7z+uFnrIrWM2dXuOXpd69tPeOmm9YNe+eF';
    b +=
        'tgcntm1z/quHF350+zkbzh/W67xvW828flqlN/7T+OGqGwpnLXnu+gqhHsMi3doMTLnv+RGfXlC';
    b +=
        'cOeboqs37ejf79p5rPi/R+hXP73/NRKXhDaOX5HxYb8CQt887pzBk1/95dFJC7+4JySufbvrpHf';
    b +=
        'df1vOTRROv+vGCIU9/2/DQH3caN13RN2nC+/ujX9VUv2y2d2Hlzr1Wv9Vj/H/mzXhoq31z7f3/y';
    b +=
        'jj8j0dSb6pZ5dqpB2sl1Otp3vavL2vsuWT+uT9dmDp3Q+XvKzx2QcvDHy98f9TTb79y99JG3e57';
    b +=
        '+vD0+PTOzau9Wzz551cWVWyyvNuVlbs1TtrY4KaWm17eejj+98YdUl8see78L/q8NjDzWMd/pX9';
    b +=
        '4X+PLKl3SqMrbv3xUdO2Hu29/OO++zKJ9x/449I+mLxwbf9aqNcEq3UsOT7zx9+SpaxYdmWFm3P';
    b +=
        'JQ/+T9Z0UrzQ5Ep9z38XfKwSHfF6x4Kml3wk8Thz4Wjmx8c8KTnfM+G5sRX3fpk1cWbrr0kc9+2';
    b +=
        'jp7wsszq9z7xIxzPv7PHwO+fW/ZqsD6+z5c+v6SzyqExvy49apnP630sFlz5AObKlW89dVHHhn+';
    b +=
        '1JUf93n4zt5XXbn35on2730Hz+9ojE2/5YOfe8yp8EKDd26YnLbxs7H5qSl7W+X8cVe3f529/4M';
    b +=
        'H63w1aVz7Da9/e3DXR1WmDNvX7/La0+ps7fFhn8D1426N9m34bt6bj1x1z6/zt97c9f6MVtPfyv';
    b +=
        'ziqwpmw2qj7S5Nn0l+d53a56F/jumQOyPrgfjOv2z8ffyKoU+sOHv/t1UK1q7q9Nxb7eZc2Wtbu';
    b +=
        '7NvmXf9s+03nTtvUIMX20SWDa66YWH2uqj6zrbgfZcurX9+VvXoooov7VpwrGRAq4cub3DpwgdG';
    b +=
        '9629f1TVztbXPRckd/7mte9u/Oat6ReFj369vNOq7TOKSi4av+eV/hdenrKt9azfl++v/vuvjzS';
    b +=
        'vv/q3FWeN6PFpyz4tj318fmBY220NqtglE6ZVfaX7J78ZzZveljhrb99+Hywt/MeeFz/cfs6yty';
    b +=
        '5c2/Hg9faWThMa1Y7rFDpc2E876/rAy1kPRKcMrGt16Nf8207Vuu8ffdbni3/5LSWrY96Q4P5XH';
    b +=
        'h4ZX6XPvHDBOcU/fZPe9omzrRrVXk2cOf+3Te+/1C4lo+flF/z2c/0G538V2X5ZmyM/9folefYP';
    b +=
        'U9+ut/ebB756atGbjTu8Eryt/cP9qo6ru/eRGld1jNZb2/yJRs/PPtTycMbB56/6+e61oz+8see';
    b +=
        'ga26996LM4LBNrfKm5Mb9vHPchIJw28ySqbt+icx4MbHetr5P7B8zb+75D15f+62hW246f9Kb+/';
    b +=
        'd9PHJL4t3V1s3KnF/993PPXtbx2Ce1Vn84ZmybetElN77649AGP/38Qu2Wi35Yuu755ofrb/8o/';
    b +=
        'j/bn2rxVLPnnmxkxoW2rr/+xWrjlhQvmP9EXvqRtGfbX1zt6OI51zTtPqthdvDCl6rOytx6zW3V';
    b +=
        'zz104HDJ2++tOmt43vSPf5hy5YXDVw984qq7etXJz3/a+PI27bUP92RHKt7b7JWFF2ROWxV//Q2';
    b +=
        'm3nBvp1BypfbdU+4bPGD7kglHCroJ6vzHzUNuv+2WISX/3Nn9wkDz1geqrXzzhsWrLkgfPaCzvf';
    b +=
        '2dDbdWbPPTtQ0XpLxz9g3nXZDzyUWTL741fGXhpHsCu0r6Pvl5nacV5YO6c5qmvrB7eqDB1lt+i';
    b +=
        'Px89lNPP7h18e9XXRuq3v+6VYPuTRoVafnTptemX5I6avIvPy3/6MGfL6zRt/NtXcTsveXOg68+';
    b +=
        'Gmnf7+ZjLwyNDPr9tZfyPunZo5my5vFFrzX/duTgy8YsXlH44aj5CUUbe772Zcats2tF2ybM1N/';
    b +=
        'fUqtqs4rN7pt2U7X9PxZffvcXb5zf/8VlG35ZfbBd0uLinHWh+bWbaHWv2bWw+uxvrv7wd7XvO6';
    b +=
        'vf3ph3X7RGm67Tb2x87cdP3zDr5c+/Orp9401Lx2XveTjw2105h2r9+6wn637w4bYGtb4K1Xt1x';
    b +=
        '895iw8snN934rh5C3q33NzvwRGTu2TOqNLix0sWrblhZUavg9Omzv/18MSrMz+798I3K/YfXKl3';
    b +=
        'YYNq8y96eGS/e/u13z0sJ7XDlZMHXjatxeq1974x89dWA775bsObldcuzL8uq/myZdVqLjir7cZ';
    b +=
        'nLuxS/fL6FX/9cel733zV8tDTcwcs7fJAn5rfHbkrY+h7bS+MfqTc+PL++duHPj00/oJG39300u';
    b +=
        'MvBvqsf2JtlXMXqY1+nTji6ssysu78qMvs968ZVm3rT+0fTK1U56lPh9708LMfvXBW9XY3R+Ztv';
    b +=
        'W7zDnVBza/Hv/fH4V41vzTfDdXtNajmjn++/lul+amXX/R918WtV44ZeG7RcluzjnYOKQ+eu+nH';
    b +=
        '3avOu7PdlXOvCLYZV73duEnfPnXXOSVzO6tnP/Xvuil/dJn+Rr1Plk27vnGlc7q81XrzyAoL20y';
    b +=
        'rs7jGBQ1zV/bpN+jLR4bd1rTCz0arz9J//PWd73tmn90jr/vW3bt2Dco0uqR2yOlxa8GXt72pNV';
    b +=
        'oW+mL+oDtGLYp2D9r/+eipN75rNnxFrfb3Dv/49iOhwZUTalRoUN28vW/RDdtWNZzV8MqMs85Nf';
    b +=
        'eU/Wt8fj/3rkwdDrUf8X3PfAdZE1rY9LZXQpEmTqKiAlAQCCYgKigougopYEQgkYAQSTKFYg2Av';
    b +=
        '2HtB7Ih17Ypd7F3XhmvDtYtddyn5z5mZKMv6vvvm/b79rj9cFzP3mXOeU+fU57nn0JO8Wbp+G85';
    b +=
        'PvWvns+/EPhvXXVcmZVm5tH/SY3lg5svkXqlWU5Nqmo8dsnxyyYg/7rW2qTtZNaKTWpFgvgcZ8L';
    b +=
        'Hvu9k51S0WTePW7guMjw0dLrW+fXe+Bk9S3ZEnPD4ZnfR+YNvK1Q33e3fKYfVvvbYqYHinhoxRX';
    b +=
        '2o2Wy5jZH/M2v28fZf0a6sHHS11F3vxrow8NNS61+QnvvKeqbs/Ot3au2NaAxG+rKF/6fpj6MTV';
    b +=
        'ug41X0e978w6k6MNmjYlKcZveoZvpDuTbd3wy4EHp6dGCHPGHd02qOJwx2k3RuPWlW/SS31nnxI';
    b +=
        'iey4kuagOu26vn7j/caz5tTWlzw8V990SumTzxuFLfzu/vXaeT+qBuV2JZ6d2van5rKyMP6C+N+';
    b +=
        'WY+yLXRY7vrq7ZPuK8I6e27Gislce6LrfR+1EW19X+uZyQTM7Hms1JL60PLnnrMWAyd22Vf7RGY';
    b +=
        'ade7Vb7M1P+YkTKnhMz1RcXx69Pu/56d3SS7HoBb0j1tCEW7xaHC/KfbZ9fLbtjqA5Y2tAp8Fyl';
    b +=
        'u6zMvXbFCrm2NXdYwIy3TG10JywvwHztNe2rOVt2jl0oKl9ZtjP8+KScWSum4L8NeVmRsP787cP';
    b +=
        '43D8yNgZ6RvffVf9oRMDxDxa+5Z+jrrs9HysYGbgvoeLGE71NhuPa6SG5rS/HOKhX1V/evCVnvW';
    b +=
        'XivkzD6Fe8NTdamTtOqJ8w50G7L6OmOAg2xC+v2jIvj1FxK0r39dasjlLHIgduFIgq8XndihOd3';
    b +=
        '28xpBPOSZLRw1fkHMVdjrwwn3swf9fj160Hn5L268ZrnbBiPF95Ic4rt4XlzPGGUc2i1tcMt+Ye';
    b +=
        'jWh32MrFqp9weAhjxrsD2Oe2b1d8eFUS16dqQdRypO4au+IGB0P2hd7k9ahOWtH8auKAVZn9Ksb';
    b +=
        'GO7NdFw0eU93y7PXdbXbvGHCeP6EVsX/Vtg/jrI4VTtEs+qVgef6Ju/dsAqMKg31XCjktE7ZVeM';
    b +=
        '9fgc+VfSndmLs/Pl3Grrz/mKj31eaN8S2cX2uRuPV8zLHfLR6sir6dUR75+uvm9XiLwiThPc9Eq';
    b +=
        'Vdg3BKpQ4s5iTFHRB491PLA683a9Bqqm50sWsc1db5tqn8wsa8DE3vB8W46ME83n3Jj7QT/uFYf';
    b +=
        'vLzHLhWksSf3dreaPHa6s3npsFl3H8W+rbYNmSCz65z1xBYJ31YPw3Xpa4MjSMiTCdjXXy15bLT';
    b +=
        'ic9jjuysmP0WZwrZ9xH3MNkWcchiw6Bcsvd+L/Oc7+c2Q8FkNUNORUAx8VWcwnLieXz/k6psPq1';
    b +=
        '3TDSqbkwEbxlXw+l0IsG07yHtYUfsky26RAXPmH0aGPmAlxP8O1osvJ/1hKL7zxKCSXw251m2u9';
    b +=
        'rLlxxw5M/W3Prev6Z+Hd3Ty/NWcaBgTnWbH3lIGxBs+da039Hj93rDHX7H8eWlUyDPWyAP+hcIP';
    b +=
        'G14pjnwsaTHDtoaJGTq1/ZlLvFz0ySOhGJXb32711oHAfjulKPSw0fj/orLrsXPma58Ut5Jj6jd';
    b +=
        'eXk+qDQVFtc0WsVdK97aY8FLbhug/p1n+89K7M1c95WycX53+ZW+3gg6lPvezDlsIPcRDL9kf/R';
    b +=
        'iUEnHI+gF7wss+e8eWaecuSv5Q38/Ft9L+aaXfuNPrG1a41W5xRxMmRjxLPfR1x+APYwfnjtvJ5';
    b +=
        'n6ZXljR3qba0Tu3sFxxE+3me0z7/JeOGwwztuU+PT7z4Oqhl3yJY4FHDvdmj3vuGcwytSKubrsF';
    b +=
        'CnTKxg9/7Flz72mPDhcb7redmt7bMNJxw5J0j+gdAy+zBxxqMXVWmnv7cej+I5Y7ln8FLetFqzV';
    b +=
        'cyYj7/qeVynW7OobNc1bu18xbHxd6WCfieocr1l7reCW2Spt4N6GZqf5BQxx/FKwwMVMX+VeWJK';
    b +=
        'wdOtCvU2HB0YkdW87r4i9OmXY6wkPSvJOVY73X5jn73o4uj43Jdz2dOH5M3ZwbZncsVw8uXX9p1';
    b +=
        'Oixc7yO/upQ9e5QTMatGWy/9de1dybxz15xPXhxQdqgUp+rk+oPvB7b3uKf9p+S+MDl1IjPPToF';
    b +=
        'M5uxBtxjlo6o/+B1QT865XLmihd4AfFZfPl0uX23k+Ev+Jz4Yr2Nqf5BwU4ABXsEvTwiOj4+/kn';
    b +=
        'S6rLhre8ZOk9q/rtyh2P3jOHdoiaxiyYfa3ly03Rs/YUgj4rB9eutAk5xj48YBPzzuFvKVrhZIb';
    b +=
        'y7C/PzXef51W53UYbXdGEtuPaxP+PYozBkT4fggifSvOW2zyTrysrK3m/tE79r9hvDyq7TR4tv8';
    b +=
        '1YH7ipd05XoEvFw1qP47gXX0pznJW5uiJu8OJXxus2pES6nysJmPi4aGR/PcTy+KbyYy3C4tV01';
    b +=
        '7vT1CbJbgy5P+Jq/U6m4iun9tU4zHZHwt5OOwi2zhZtswKsd4tbJsNpVWjfkPXuHo+TcAPHZ5q+';
    b +=
        'mq4LayTpN2TY/+fSohXjfjcGdty//TPjGQ/W4nAg+Etl1CbK3atA0Zc+Lz8eqKodsPLJHgG/f06';
    b +=
        '9Fbd32MOnDnWbjOIcK8DHxt4D8ybr7BjOlzPAh/OzwLuVXn23/8nX3Xf8LTtqf3Qb6RO77dOf5X';
    b +=
        'qF2/4O4cfaHcusqij7fWvDoclqHj9WCXfV9F4gNk3s2f0g8++NV63MDNr5cvXnF46uWx2+cFCYy';
    b +=
        'TrNN9Q/6zKlkDTJ3zgZVzz1cL8mZdjU+q9ebwfykmb+PX36juZPrqNKRpRNnzr26Y8dxbJyeY9b';
    b +=
        'FZgxP6xIHavD3mxvK7kR+MVxq2f3Q0syJV5YM7nO1JdayNDvyndfqI4qfzXtu7W/wPHF+OyaeWQ';
    b +=
        '5qkPGof3z+MBZSVXdPbDfVCV3AU4alvkvdyHT5rWDD+OiP5ujLYr1l226xDgkf0v1WVWSvabOzX';
    b +=
        'cAjScORGelvK99fvnbGd9HgIXPPxLvI0rVvHx353K7frDIPZeJoayRcPx1kJPn+4Jw/DIYUVFdb';
    b +=
        'iES+GFVsHfR8UKtQ5/43dKc3Hl350Do5Jwip6zTibB/rO+EdSypxU/2DApsB4inBTmId6g2GbUP';
    b +=
        '3178c2PqTzU0n+14bpKx1iT1PrItZrfM+sNT6aMtBmkru59ryCpvbjy1OGqBi0PY0AfJK9hSxPc';
    b +=
        'e8sla1K7HT+o2chhKbM0VTbMZtzqvlPrTuWzy7k8XyLozfyk6AltIr7pIhPdrBsDDOtY3ZpJea9';
    b +=
        '4ftOJP6jhj//s5xnxVn9y8LCY4c8OaPu9pDtvLrjj/3nc9m2RRyd81JUlQWt3K4cj702cI3nlU7';
    b +=
        'zm4ZsrrXxbKhL+Y+dnmZVrvNstV7dvdfnkRvHv55x6vRUXUZJV0Gzru2uM31+ZGXLj/bELZ/mfP';
    b +=
        'RKb+WPDlnI/HdOq5o8p0aC+uQ/TPynYNqX3kPnjh77z3k6Mw77Vu/Kz5i0bLH2XeVoUdvEAmjDv';
    b +=
        'fwatVjUJLLk6J3VigS/qAYVsg/3YeCV3cWjMfU3cBnsqkgP+8EXoMvjt10b++HL7l2lSFnN9gvx';
    b +=
        'eq1X/2GH1O6ZCen7QkKSpY6u29a48wAs5I5IJ5ZJg8ipk5/TM2IqbORgfGg3Rq+XKo3rJz6yZD0';
    b +=
        'ib990i7W/InBtfM9lrVL2N/6QNpQpx0d7w28KjKc61PMvozRlmn1e+oMjMhR67nbutpYbdOkzfo';
    b +=
        'jJG5dzN2nSPiRhaBgCi3/J4pgWoUy3ycDuEozfPx9BbRCMqUPduQnSvFZglKmqEbcC6UUJf56OP';
    b +=
        'eNVYQf2vE734gxXF9a+caIoWIPvxGGiiYujfARlFJQMOLTtAmg0chjvJ66TqWuevIPXKfpvymek';
    b +=
        'XcFtDuH9jeVDj+ZvnKo59DYhbxOo/E0WtlnCh0Op68YfaWj0XPpGzq83hgf7UFvTAebdqdN3XKk';
    b +=
        'aoUUmrVl97IiFTMok7lvzsjkXpRJl1Keq83P/v6kpBd1UKxTKr5J2Qvc4CpBrtRlnQf38JA+S5q';
    b +=
        'N3AL3OHlYT5l6VQPMbiSTSguCfKTTQB0QUyfBvBhKJh0PqQTAj6HM+qEVI2XghiAi2o2yPgcjMs';
    b +=
        'AseOg8TKqWpkIjoOTkgTGUyXhqDGWWlpapkkKtEH62SqHU8pO1MZRJvfE5PISHSklQaW8ecOM0e';
    b +=
        'paiUmXKoXYCuN/W5Nn/slFUSqZG6J8UIBH6kepTefxUlUotUyih2oZHqsCziYPQ83wMZR79nEEp';
    b +=
        'iRvxiyaYwaTMfI2YSWP4M3W9Z5RhSytt/tP0CdGNFEF6/Z+WOYKE9abNz2nlLyPujVMKqvD3T5/';
    b +=
        'Lm1o/xjTmYlT9mDqQ/YPGSybVe0yTeqd6M0Txj9U/pf+HhPWlaB4G06aeRpxEG2IYcfp/aez1Xy';
    b +=
        'hOCaAhR0AcZVIeBq7h59eBsZjDp4sIA7Mw6DAXt6L5RUw9rjY1E6bORkxthGnf7O7TFJmZ/Nxho';
    b +=
        'A/mp+jS0uRqxKMfZaXY5n9Bw0uh8oOkKaQ9VO9+FIdJO1rz1ojjUIpv5XuactUK0AE3TtTBfpQG';
    b +=
        'MtSMg7VV3Y+qrLfgGl63sUllzSoDDs8wY2X9nebP32kOmVq4plbeP13ZpitymKrEcWvz/83aYdF';
    b +=
        'WGI+p6TM1XSA/22A8pqbP9HJ7tv3of7Wze3oHDGd6vjb8DMOZ2t6Q8Mk7YTjT6+sZGc70NS/8XL';
    b +=
        'WZwPTy3LAbri3R//8W8c/2kAn7p1fxptfQhn1kwjIru7znHm8rzm7YfaXsqNfoUtuf9teywko8b';
    b +=
        'UVp/qP71GS0uhoj3z8fufdl4vlX2Y+xztUHzT+F3hpfjC6/H9epoLTgoTx07dm3lfMbes/oe6mN';
    b +=
        'LmNq/sferyf0rHjzNbO+xNXB9Cb3bD+ZMFOrxtSq/y/eoYNkwkytGlOr3vRO4VkFSNgSO1OrxtS';
    b +=
        'q/5/MD9PSwNSwCUVFZJIVEktTrUCF6L6NjP7ijAa6/6CR9sEkykj7NE0VF6PSRim7Q+4ZhFS6Nq';
    b +=
        'YFGqXpNBRtnFYWEqIdBpXiQ0JSdWq1XAktshQaPrQWzlZpNAqoVk4aTJD2AJTfdhp+pioVcpRJt';
    b +=
        'VL+MKmGnyKXK/kyOciHKl8uazp5okIZ582lyRRxCKT8a/2n6VK6XClXwyUrWNqP0Blj40dFhPBT';
    b +=
        'FFpNtjRVzpfnDZPqIO0XchnIgYaXRnlWBDUdM2J7gja2oJX+U1RqtSoXBCStaDIUShmlnG+k1IN';
    b +=
        '7OVlyjUaaLifdjWsKWKY/Ad+xGqheT4UxliWc+w9pRPaRADX+/gPjmBIpRSjyCqXWBsa9I1JJ/r';
    b +=
        'thqQlT/x+YYSeBZpSlUtLFn6RQpqlg7PYpViRdjT1t7No4P0Ob4MQf5CdbqlSkZlCEftkp1HS2O';
    b +=
        '0aRaRhxD4yiaGpcNkm0bGO5JtNkLkY6uRS41mniBxorymk3o9FmmomGa+mN5A2D7f+7UTppStE4';
    b +=
        'v5Cm10hL1NgdGlNkwLIgw0O6lHSVGvJmxYK3Qh2r08am9ZJnqdT58d+IE7up0qKgiYZalw1QuDp';
    b +=
        'dB+mfosG73k+lilZ94x3qDlq/UpoFWWF6SZX50QplhqarGrx6ck2EPEeRCi9SGSSB6JYnT9Vpoa';
    b +=
        'EHDNNFp8kH2Vfp1KnkPXSDkqHVHLwHDUArz+qjU2ml3fJS5SCzMsiVJJdnQAlxWpUaNPTuuszMA';
    b +=
        'XCRMliuVvVTZIEM6bR0wiLAy03fRimzddo4rTRTHiPX5oKXB0YQCfqjzEZRRatU2X1BUmOVmfnf';
    b +=
        'XSMUalAcKorgBpqLRmnCG7t9BwNUukxZF5jRcOqN7ZYHCkvTRa3KkCt7K7KNcUeocpXhMpkaBs4';
    b +=
        'BfQfMDsRRyniNHDh2VSmVZA3QN+DNCU8hq5sWEP/dYiZSpdE2gt9DgJKVaxvDNNBlynrL1VkK0C';
    b +=
        'mqlBFypYIs0O4qnVLWV56aQ76wqmzYgcGtSo0uFVSdJg00T8j8B/vTb6yboOWqoGUv6GezM6XaN';
    b +=
        'JU6C+4Zyq3Ipep/SqgA5cL3+QEI50cbl5B7jiqlLEeq5kMDNzLeb0EQhJ9G0af9p3HQsshOKwKE';
    b +=
        '9W9E3PB3nBKT0yhCCVMJIraBcIJG8fx9z5YtVWfI1X7k8KEge9i3QEYAbdDUtqnhMvQOzam1ckS';
    b +=
        'UbkXGY/TvR8f73QtpQZxO2ll9p0RFZCCcW6Nw3oiR/KBRPFR4hRIEhfKWpVN9ozFMGm04ZcRamp';
    b +=
        'Cocb+T1Sj/PzKc/RHlJm8YRbn5lo6PSe/vSSF7VJZUS+5va9WwdfwdD+xfo07LgrZtSAaIozlNO';
    b +=
        '+xC05k3plxVNsoDNBLMpg1Bf0QzL88EkwhoD22MDRLgkJEpdVl+MkV+ErkrT7bB28OocTOabhtG';
    b +=
        'HENjlCYHg+PGMxyMLWBwLZmIImFdLBH9gkUI8vATAzm7BLIzk7SbcK50mQXPDxAkzBxH9EVg1PI';
    b +=
        'Rosixl2bIvEBQnEdV7ye2JvNWUFM+YUh4ls8bMKmffg1MUW1Qt+GHZa8lytcL19/5+Hvn53gsmF';
    b +=
        'Zvg4/aop3m+3IW38frJXaWftXa1q8+XbrGriJO3Nl24aDjuIB1eFu35zEYEv4V+l7DRUf7Lhoy6';
    b +=
        'doh9crbtyb52TWr7P1rRray5yXLW/NvKEfsaLstrXKze5Cd6+BrXUIt+hlSj2jizzvU/C5/73Ew';
    b +=
        '/supKn3Va+XHizVVSV/iGMgPizEtU+svk5NcKHDwyveTge5fpfzhpwZkvllS0Hw78QVIxHCqb9H';
    b +=
        'Rc8ofelYodRrSN/LNf86/8Z+dSXk3+s39d7JBQnxTh8lTM+QySIHiQQX3bGxhZ5ST95/K0ehSPO';
    b +=
        'hkNxZklJP/L+VAU2PqHBE0117hA0mW1YioHlH94hrlfSQd3oiP0m3TiH9HqPm4Ef9B991GjNJEB';
    b +=
        'kYMqegbyzNrgnlNsHkTbNEE/0RTtxuxHP1z/CNQqs/8Vpfon9NbSKcP/u53c+qIX3L67Wjt+QaI';
    b +=
        'z1YuOeXQkL2pqvY6iWOrDh6q255r+FxbRWLeLxnhNbP7H7KuqyZxaN24WZvdLs/wrntF4sIl8UK';
    b +=
        'PhD7Xutd9JPGuM+s2F5ePWC6tqyPxuWlvWue2WvZiVB1hgDgrLi9sdtT5LQvqeCQecHH30Pxmoe';
    b +=
        'O319mSWNy/tlfQPKtj5+pcSBy7KFKierFg1m917iQ+FTK+zbkJ2ptIvTeJPy48vPDCpYklzvUiE';
    b +=
        'j8p93JYxBXVBNaHknjmjkCv2nTJjt71ESTu0Lny6v3rp4sy6qNJvP/CNad2EfdOTqjvR+IFZ9oc';
    b +=
        'uLgyY25JfQKJi9amjHHPLL+7v15G4s93kswHpm1afaM+k8Rt3x3/de7XRx9q6rUk3qs3lG3YvGs';
    b +=
        'Xt2E0iaf1HJ3JSEqZ1KahiMRxgqOiZMPBM50bppM4vu3+2dMnxCwY3DCPxBVjPbPdc3+/r21YRu';
    b +=
        'LivU/2rqy4v664YQ2J543RTr6UtPHrxoZyEl9auqF4bnbEvhMNO0mcYWd5+Otb9tT7DQdJvFsol';
    b +=
        'Me32Xbh94YTJC4fN+py5aPOi20N50nM7NDe64RVQrWv4TqJr83RKBa7u5dFGapIbHEWKXy/a1J9';
    b +=
        'qqGaxC+drOfI2E8OjjW8IvH5yb1VnPMHpy82fCSxt9zx0UCHPVd+NtQZkPB1v4LOkhG27KIBdME';
    b +=
        '7IbjZ3mrt9WfPyJMv+EspP/kybzNO9u2gtDnzvuYFdy5oQVPf/mzHOjPq4sIjEtJwH4xKCS9GXf';
    b +=
        'QfWxxHjt9gdaB/vmmN5OqNLJL4B0G6tVri0LZd7MrJJGkPWKnVnrguLE19XUoSYCDIhs2np0vkv';
    b +=
        '26rIMcjBLkr3+Q0k32q8Bb5viDIEtcRXX53HXriPbkuBCvMp87rvBW95pijMhK/mJHtJHuD3mmH';
    b +=
        'ZpK4Z27NksWrs0q7oFoST8gYs3NUHud9AjqaxLnN7+Wvqu63MxctIvGxk0uHzJk4ZOIcdDqJOw5';
    b +=
        'dcPpkXODpcnQeld+ShX8k7PSafwpdRuLHSSWLK1Z2//UhuobEbaYH3xUdW7q2Di0nccLKRavVSy';
    b +=
        'o/22M7SXzx0PN+cYer9gixgyR+FN7qvcOHusnR2AkSr81LuLb0Iv98Gnae6g3iWo76MNh+UQF2n';
    b +=
        'cQhAreFVbtKHi3Fqki84OfHCXFXbm/YjVWTODRi/Zrbo5fWXsZeUcTiEWvWR0fnHHiJfSSx07Kw';
    b +=
        '3TUzN01j4nUk9i4asM6qxu0yHyeNpBFP4eznT9ZYLe2A80i8nLdsVe1Sq6fxuC31/GOHlNt8j/J';
    b +=
        's3IXEEy6tH5n4U4R+Gu5OYp975XhYdcvDa3FvEhcbIhL9lqXPPIKLSBy+d/qy5Q4B1+/goSTe6P';
    b +=
        'x455y7jis+4REkvp17f7/y8IKXlkQ0if+zkTddrdDoyNnMkREUCfQYmrbLiDfSI4gRlzXBm5rg8';
    b +=
        'iZ4cxO85W9GRn5747AcyvcQ8kND+UFCz0bhtzaRZ2akyflOGwF5IWRySD5K00IY/VrQpv5G7EB/';
    b +=
        'mMOIuzZ53pN+/te0toTDLxiuSdIhj8bpe4D+Tf4aZcsY5iH65zw9aoLbYVQejdgL+3M6k5vgIwD';
    b +=
        '3aIRvAvxTI/yYfv5v2wi9Q1atsSJ3xg7+u5nIEMFQMItKSWgnSIA7SMYwFf8yDFiDaDXf5y+i72';
    b +=
        'EO0WEEvr4+8CRboFCmxUhj/mYClCXNA/dGGeNo4nJfkNkTWupQswu549ZLpzV1M4uezRlXFHBGN';
    b +=
        'llrRX8oAjJwqnRauH+ZAhffmhByaxKkBW5cgjRqSUx5BC4I4q6jVqIR4NqMlm1cnYxsgkeRGkpa';
    b +=
        'MFfUtOzYseNfyyDZg6SS4qvhV7A8k7l8kloKuCd7cylHeB8C45sL4oMUHOV0vId0lObSWR2l/ZT';
    b +=
        '8b/y81VGaQ1CQMe+2OVS55jXaVRtN9x9jId0f+P2lfYEVm1+KTpEpk6vhRnFEDk3zSK+OjVhAr0';
    b +=
        'b5o7jeXG8+fxTf15c7xhv8548hAbiM8eB6eHv+ubzG/ahNwzhBu4ZteW8OdQgvp1dcgjyBQCAU+';
    b +=
        'AsCBCJBoCBIIBZIBMFCgVAo9BcGCEXCQGGQUCyUCIP9Bf5Cf3//AH+Rf6B/kL/YX+IfHCAIEAb4';
    b +=
        'BwQEiAICA4ICxAGSgGCRQCQU+YsCRCJRoChIJBZJRMGBgkBhoH9gQKAoMDAwKFAcKAkMDhIECYP';
    b +=
        '8gwKCREGBQUFB4iBJULBYIBaK/cUBYpE4UBwkFosl4mCJQCKU+EsCJCJJoCRIIpZIJMHBIInBIP';
    b +=
        'pgIDoYBAsGTn8uB6h0UkBThPywPOh3+3QuVR4CJrVDKvgf/ozyvJgU1bRWrZOnSTM1sLyNzyayq';
    b +=
        'biMeAab2v39Szo1mYpUuV+WPCt1GNzzyc6j2sYQun9Qw50QuK2h1tKvl/FFpJ5AdmpSRCN2+ZI8';
    b +=
        'ql3vyKMI4CmfciVNN82vzqM07IzPqfDUMzImDV+qpd5qEIgECJFvRabfKZ/SRKTHIeoQgQ5KitF';
    b +=
        'lQxfQUSmydFkULbYkn6L8oTZOaX90WkG/JlPJqcMPsg8gjzSgihe5o/cnr5n5FOVdQT5Fl702h3';
    b +=
        'pfh/j6+g4l1RDpEgI90J96K3gHXvwz+ZTm4XU6L8b3PUWerlBCPVVYRB7wxpOfO0xORQ93bkBYY';
    b +=
        'iSlFdlsJKVRaT+SKkOjDOMBjhRuXqmpeEE9d+DDLR8NSBj5nRK+B/XNB08yRcb0RAJZcPWnHElp';
    b +=
        'ZOaAK7OR7L+2Ga3a2LbXjKTa1yf6AxN/8atTKki6sWy1QkluZNMUzSOpnU8u/ZEKI3aiKTcRFGc';
    b +=
        'wmEyMxWSzONZcFzNHnpO5lYW5JWGFN2tmw7FHHYjmqCPuxHJGXTA3ez7eHvcx80UFuBDzR9djG7';
    b +=
        'EyYhP7D6yWUY814AbO5rz8aTNKBQMGTps+y+WeheVP0bV1vn6dE4YmPSqaMXP2nI3b9x84WXnm7';
    b +=
        'K/VTwwIYd3MUygSh3ToGNVzaNFM8HDn/gOVZy9eqn6CEOYW5NOQDt26R/VMlMmLZi9dfubiJXNr';
    b +=
        'T+AUNWBIQmKSTD5j9kYQ5OSZ+9VP3ppbd4uSyfVFOw4eOnzj5tt3hROmrVl36PDJUxcv3bkbuaj';
    b +=
        'iQuXFS1ExsQMGJSZNmVm8ffeew0crT920tncYkvD5S4NBnzXi1/sWbkqVi2vSmLFbto47cNDeoY';
    b +=
        'Vb9x4xsQMHJySOHbfr5PUbVW/ffVJrirW6BW19/dZv3XP41KWb95eELVwkKHa7ev2iISZ28BAW2';
    b +=
        '9Kqnd+bGqVK3LFzl26zZsel606fuXzl1u2nDQaEn9Rq/H1ifATbmWBaF5Rb6Dcx3DgFzrgjGyX8';
    b +=
        'CBHBwlEWk2XN7W3ZjBXPwgkXLgdn4ywcw3GcRzBwMyZqYceIYTmzBrAwpr15b6Ir7oOjhDXTkhd';
    b +=
        'CuLZJ4mcRw9voTzPGb8OdmOPr8UEse05zji3PljecyWU6MQex2jO6c70JHoHiQjNvwolphuvLwS';
    b +=
        'M/YS9cv4YdilvioSwJuz1jvMG6OdvP2gdvadnSUj+dGL/Q0cxu8jyGH6MDC7NoztEfaqXl6X9x4';
    b +=
        'jH0Bob+Pu/9clzMKUiw1e9l688xuM074FymhN2dzWNqzVrgg4lBHH1hcxeuPSea0E9lblrDcyCE';
    b +=
        'q4iCO21ZPAZDv86q4BML5XsxwdMZhP4Q7oxbmiNMFAWZwxgsFsZmczAuwwyzIKxQa6wZw8baFrX';
    b +=
        'DHDBHcxeGK9sdHU5kYFvxg9gl7Ap2nXeD8wt2E7uDPmA8xJ4Sz7A3/LfEVww0VJTXrkOnmNjiFS';
    b +=
        'tWjpo2d0Hpjv0TtzNZnKCOnfp/uHyFsG0eJO4/YFzZlq0VgQ+aTZoyc8W3lggbYkysTJ6we4+zC';
    b +=
        '4vNNbN1CAoO2bDx1m2OeNbsDSxuh05piuI5qqTDb2oGp3ysMyxZ6uvXziN+ecmq1WvWb9i8/+AJ';
    b +=
        'phnPzjWkc7c+69afv1DCcnRq1aZT56evagwnKwl+6zZtPQIkIZE9o3vHxfeHjS45VZ6WockbM27';
    b +=
        'qmrKt245c3rJVqZqb2GoUAyd88DQc9fPVj3fFhZYuhDunBaM9I4Kw8NKXMd0Jd8KDLTKL6Vog5t';
    b +=
        'hz2c07dAvGU9kcgT2jJe7MQMMkxE8MP4LL4rDC+O0IHicID2E4sQgeq3eUOMA8gOXL5ha07Rvjw';
    b +=
        'fayd2rrYuvAiQERRJg7srjMSHY7js6sc7gXswODy+zDRBlWOEM/LaVFJJurX5fYqpsZl2luE8Lk';
    b +=
        'BnkTDvp9obI4XiSH272bcyQ7zjyqgNWd64r3iBLjFmwuM5jFLQhy1O9BLf3NC5em6cz0J6ZGp5o';
    b +=
        'X+RVfGd9j1b7xwSwvIoHZltud68GwGb9tiPwnIphlHQbbwMKv7KJfvDilTwsCfHBrgl0wfQqRwT';
    b +=
        'DHOSyrOck9ONpQ/Weuhp1t112/xJY3gOOon1TQA5/QxdKuqLeb/mF7/Q0f3InACsLcrEMYaNED/';
    b +=
        'RfPaIJLYIXWEdEd9cdCmSgRz3AWYQUW3oSM15+r3yJxNfcmOKDdM/VLCm+BTJvjWt4gFniLLHmE';
    b +=
        'BGTGg90qpqAfzw5n4CyOK27GYHK5TDboVfXn2nCLmP+yw6avSSRXHdlnF+itSLpDuMbxaISNdHd';
    b +=
        'G3JemOP7huidFkU5PE5EqPfUBJPghSfTHlLQq6gT/B6s8RbpCCxevIsFfH6rgCS3cb45TZcnhGo';
    b +=
        'NcjJAfcoE35PkmZIXUqsgjjyQwwDee1xUilPJlIcFHZjOSkaE2JUgzB74bj5/sVuNd0t5LwPdWr';
    b +=
        'XvgjW1I9mlRm+yLNPCDVhiSg+rRh0Eot6XY3fyheJOFNNiv+apggcvDHh9atIx+O/xhbKyqZe/l';
    b +=
        'B1f1Ri5J+8ivrOqD3GnZF3nwME7wUBq/5dGq/pefPezPR5QD3qKGAUg2wkJ8UBTFwB8aaSaws0L';
    b +=
        'loGPFMJRojbZwHmIWwuGgzQmUA/ohRns8lO3VHOWLQQCCDTpQFhdzRUNgcIINvHAxJxTDgkGHRW';
    b +=
        'Cgw0ZbYDhqBjEDeEBtMXvQnYXAuIBvFs7FWqAdQFgeCOkBxAOpoPGgBAszI6XCJIFIMYhdsGDse';
    b +=
        'yyuaCRKoEA4ykb7oBiLx05BMY4ZsyfmjMKf2AIFMTLMUHcOmkagTJAozBEjcCvCHNwyUUsUlDvu';
    b +=
        'irUAf2EYymKjmBkHBcMIqsNaoTk4gXFQJn4XFAJILQtKxNhMLoYK3ISEAGAG6sHhYXyQSRSXoGR';
    b +=
        'C8BA2hi3CUXOUBSPEscowBD3eEsFnoMl8hKnAEALl8rHeGAI7dNQRY6ALMadm5mhbtqOZLy5AYZ';
    b +=
        'G1Q7uCkscwHsiXHxoApGIYA+TbC2Ojb2CxoaABW1nBpRr6CJ3PQHCQS8IDJ9C1QD6CLTYTEqPQI';
    b +=
        'EtPkEsuLgQSWWhH3J2BsjuhPEzEAW84moTDgmSiJSjOtiNLFUXtUQsWzjjOhhlxgCXKhJUEK+Al';
    b +=
        'SBcTXJ2xeDZ0GY6SgVE5DiqUgXBQ7BOoD9Aa0FkgNgLlcz2YZC0xMdwXFDbCAoWB9rUHCQFSRjJ';
    b +=
        'xKBWUYCSMCgX5AGMpgnYm+sB7X8wBAXkmGGw2xmpBzMMRMeHPRi1QewZqCSRZk1IYoMWiHQmElc';
    b +=
        'VCkvVvkdRMlQZ+QEahzFFlgIl641NjsGr4pjpkpOiEhqjHEDMQ+xOUk61WyXSpYP2KsSGvtU6aL';
    b +=
        'scISIqN4F3BOowHnsOzdrnMJyWfYJCa3m2EvkECX4GPEi7IQRwe3zS/+WBd6e8j8PcRijwZqVBe';
    b +=
        'f6HIF/jle/yATDszM4f65wMiGS5P1fLBQlOSKhP5pwZIAuViYUpQgDxQJhXLRcH+YCmZmpYWJBU';
    b +=
        'Hy8QpnsxckBedhinwFQb7CnjwyNsnBSwK0uXKZlB/Syzie/iLU8VSkUwQ5Im0stRC1Q1tUpqc/N';
    b += 'aOBm1vmUWpe/ikZ6pSwJru/wGcYyJi';
    var input = pako.inflate(base64ToUint8Array(b));
    return init(input);
}
exports.initWasmBlsSdk = initWasmBlsSdk;
//# sourceMappingURL=bls-sdk.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/crypto/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/crypto/src/lib/crypto.js"), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/crypto/src/lib/crypto.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

// @ts-nocheck
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.generateSessionKeyPair = exports.combineBlsDecryptionShares = exports.combineEcdsaShares = exports.combineBlsShares = exports.decryptWithSymmetricKey = exports.importSymmetricKey = exports.encryptWithSymmetricKey = exports.generateSymmetricKey = void 0;
const bls_sdk_1 = __webpack_require__("../../node_modules/@lit-protocol/bls-sdk/src/index.js");
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const wasmECDSA = __webpack_require__("../../node_modules/@lit-protocol/ecdsa-sdk/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const uint8arrays_1 = __webpack_require__("../../node_modules/@lit-protocol/uint8arrays/src/index.js");
// import nacl from 'tweetnacl';
const nacl_1 = __webpack_require__("../../node_modules/@lit-protocol/nacl/src/index.js");
// if 'wasmExports' is not available, we need to initialize the BLS SDK
if (!globalThis.wasmExports) {
    (0, bls_sdk_1.initWasmBlsSdk)().then((exports) => {
        globalThis.wasmExports = exports;
        if (!globalThis.jestTesting) {
            (0, misc_1.log)(`✅ [BLS SDK] wasmExports loaded. ${Object.keys(exports).length} functions available. Run 'wasmExports' in the console to see them.`);
        }
    });
}
if (!globalThis.wasmECDSA) {
    let init;
    let env;
    if ((0, misc_1.isBrowser)()) {
        init = wasmECDSA.initWasmEcdsaSdkBrowser;
        env = 'Browser';
    }
    else {
        init = wasmECDSA.initWasmEcdsaSdkNodejs;
        env = 'NodeJS';
    }
    init().then((sdk) => {
        globalThis.wasmECDSA = sdk;
        if (!globalThis.jestTesting) {
            (0, misc_1.log)(`✅ [ECDSA SDK ${env}] wasmECDSA loaded. ${Object.keys(wasmECDSA).length} functions available. Run 'wasmECDSA' in the console to see them.`);
        }
    });
}
/** ---------- Exports ---------- */
/**
 *
 * Generate a new random symmetric key using WebCrypto subtle API.  You should only use this if you're handling your own key generation and management with Lit.  Typically, Lit handles this internally for you.
 *
 * @returns { Promise<CryptoKey> } A promise that resolves to the generated key
 */
const generateSymmetricKey = async () => {
    const symmKey = await crypto.subtle.generateKey(constants_1.SYMM_KEY_ALGO_PARAMS, true, [
        'encrypt',
        'decrypt',
    ]);
    return symmKey;
};
exports.generateSymmetricKey = generateSymmetricKey;
/**
 *
 * Encrypt a blob with a symmetric key
 *
 * @param { CryptoKey } symmKey The symmetric key
 * @param { BufferSource | Uint8Array } data The blob to encrypt
 *
 * @returns { Promise<Blob> } The encrypted blob
 */
const encryptWithSymmetricKey = async (symmKey, data) => {
    // encrypt the zip with symmetric key
    const iv = crypto.getRandomValues(new Uint8Array(16));
    const encryptedZipData = await crypto.subtle.encrypt({
        name: 'AES-CBC',
        iv,
    }, symmKey, data);
    const encryptedZipBlob = new Blob([iv, new Uint8Array(encryptedZipData)], {
        type: 'application/octet-stream',
    });
    return encryptedZipBlob;
};
exports.encryptWithSymmetricKey = encryptWithSymmetricKey;
/**
 *
 * Import a symmetric key from a Uint8Array to a webcrypto key.  You should only use this if you're handling your own key generation and management with Lit.  Typically, Lit handles this internally for you.
 *
 * @param { Uint8Array } symmKey The symmetric key to import
 *
 * @returns { Promise<CryptoKey> } A promise that resolves to the imported key
 */
const importSymmetricKey = async (symmKey) => {
    const importedSymmKey = await crypto.subtle.importKey('raw', symmKey, constants_1.SYMM_KEY_ALGO_PARAMS, true, ['encrypt', 'decrypt']);
    return importedSymmKey;
};
exports.importSymmetricKey = importSymmetricKey;
/**
 *
 * Decrypt an encrypted blob with a symmetric key.  Uses AES-CBC via SubtleCrypto
 *
 * @param { Blob } encryptedBlob The encrypted blob that should be decrypted
 * @param { CryptoKey } symmKey The symmetric key
 *
 * @returns { Uint8Array } The decrypted blob
 */
const decryptWithSymmetricKey = async (encryptedBlob, symmKey) => {
    const recoveredIv = await encryptedBlob.slice(0, 16).arrayBuffer();
    const encryptedZipArrayBuffer = await encryptedBlob.slice(16).arrayBuffer();
    const decryptedZip = await crypto.subtle.decrypt({
        name: 'AES-CBC',
        iv: recoveredIv,
    }, symmKey, encryptedZipArrayBuffer);
    return decryptedZip;
};
exports.decryptWithSymmetricKey = decryptWithSymmetricKey;
/**
 *
 * Combine BLS Shares
 *
 * @param { Array<SigShare> } sigSharesWithEverything
 * @param { string } networkPubKeySet
 *
 * @returns { any }
 *
 */
const combineBlsShares = (sigSharesWithEverything, networkPubKeySet) => {
    const pkSetAsBytes = (0, uint8arrays_1.uint8arrayFromString)(networkPubKeySet, 'base16');
    (0, misc_1.log)('pkSetAsBytes', pkSetAsBytes);
    const sigShares = sigSharesWithEverything.map((s) => ({
        shareHex: s.shareHex,
        shareIndex: s.shareIndex,
    }));
    const combinedSignatures = bls_sdk_1.wasmBlsSdkHelpers.combine_signatures(pkSetAsBytes, sigShares);
    const signature = (0, uint8arrays_1.uint8arrayToString)(combinedSignatures, 'base16');
    (0, misc_1.log)('signature is ', signature);
    return { signature };
};
exports.combineBlsShares = combineBlsShares;
/**
 *
 * Combine ECDSA Shares
 *
 * @param { SigShares | Array<SigShare> } sigShares
 *
 * @returns { any }
 *
 */
const combineEcdsaShares = (sigShares) => {
    (0, misc_1.log)('sigShares:', sigShares);
    // the public key can come from any node - it obviously will be identical from each node
    // const publicKey = sigShares[0].publicKey;
    // const dataSigned = '0x' + sigShares[0].dataSigned;
    // filter out empty shares
    const validShares = sigShares.reduce((acc, val) => {
        if (val.shareHex !== '') {
            acc.push(val);
        }
        return acc;
    }, []);
    (0, misc_1.log)('Valid Shares:', validShares);
    // if there are no valid shares, throw an error
    if (validShares.length === 0) {
        return (0, misc_1.throwError)({
            message: 'No valid shares to combine',
            errorKind: constants_1.LIT_ERROR.NO_VALID_SHARES.kind,
            errorCode: constants_1.LIT_ERROR.NO_VALID_SHARES.name,
        });
    }
    // R_x & R_y values can come from any node (they will be different per node), and will generate a valid signature
    const R_x = validShares[0].localX;
    const R_y = validShares[0].localY;
    (0, misc_1.log)('R_x:', R_x);
    (0, misc_1.log)('R_y:', R_y);
    const shareHexes = validShares.map((s) => s.shareHex);
    (0, misc_1.log)('shareHexes:', shareHexes);
    const shares = JSON.stringify(shareHexes);
    (0, misc_1.log)('shares is', shares);
    let sig = '';
    try {
        sig = JSON.parse(wasmECDSA.combine_signature(R_x, R_y, shares));
    }
    catch (e) {
        (0, misc_1.log)('Failed to combine signatures:', e);
    }
    (0, misc_1.log)('signature', sig);
    return sig;
};
exports.combineEcdsaShares = combineEcdsaShares;
/**
 * //TODO: Fix 'any' types
 * Combine BLS Decryption Shares
 *
 * @param { Array<any> } decryptionShares
 * @param { string } networkPubKeySet
 * @param { string } toDecrypt
 * @param { any } provider
 *
 * @returns { any }
 *
 */
const combineBlsDecryptionShares = (decryptionShares, networkPubKeySet, toDecrypt) => {
    // -- sort the decryption shares by share index.  this is important when combining the shares.
    decryptionShares.sort((a, b) => a.shareIndex - b.shareIndex);
    // set decryption shares bytes in wasm
    decryptionShares.forEach((s, idx) => {
        wasmExports.set_share_indexes(idx, s.shareIndex);
        const shareAsBytes = (0, uint8arrays_1.uint8arrayFromString)(s.decryptionShare, 'base16');
        for (let i = 0; i < shareAsBytes.length; i++) {
            wasmExports.set_decryption_shares_byte(i, idx, shareAsBytes[i]);
        }
    });
    // -- set the public key set bytes in wasm
    const pkSetAsBytes = (0, uint8arrays_1.uint8arrayFromString)(networkPubKeySet, 'base16');
    bls_sdk_1.wasmBlsSdkHelpers.set_mc_bytes(pkSetAsBytes);
    // -- set the ciphertext bytes
    const ciphertextAsBytes = (0, uint8arrays_1.uint8arrayFromString)(toDecrypt, 'base16');
    for (let i = 0; i < ciphertextAsBytes.length; i++) {
        wasmExports.set_ct_byte(i, ciphertextAsBytes[i]);
    }
    // ========== Result ==========
    const decrypted = bls_sdk_1.wasmBlsSdkHelpers.combine_decryption_shares(decryptionShares.length, pkSetAsBytes.length, ciphertextAsBytes.length);
    return decrypted;
};
exports.combineBlsDecryptionShares = combineBlsDecryptionShares;
/**
 *
 * Generate a session key pair
 *
 * @returns { SessionKeyPair } sessionKeyPair
 */
const generateSessionKeyPair = () => {
    const keyPair = nacl_1.nacl.sign.keyPair();
    const sessionKeyPair = {
        publicKey: (0, uint8arrays_1.uint8arrayToString)(keyPair.publicKey, 'base16'),
        secretKey: (0, uint8arrays_1.uint8arrayToString)(keyPair.secretKey, 'base16'),
    };
    return sessionKeyPair;
};
exports.generateSessionKeyPair = generateSessionKeyPair;
//# sourceMappingURL=crypto.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/ecdsa-sdk/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/ecdsa-sdk/src/lib/ecdsa-sdk.js"), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/ecdsa-sdk/src/lib/ecdsa-sdk.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.initWasmEcdsaSdkNodejs = exports.initWasmEcdsaSdkBrowser = exports.combine_signature = void 0;
// @ts-nocheck
const base64codes = [
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 62, 255, 255,
    255, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 255, 255, 255, 0, 255, 255,
    255, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 255, 255, 255, 255, 255, 255, 26, 27, 28, 29, 30, 31, 32,
    33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51,
];
const getBase64Code = (charCode) => {
    if (charCode >= base64codes.length) {
        throw new Error('Unable to parse base64 string.');
    }
    const code = base64codes[charCode];
    if (code === 255) {
        throw new Error('Unable to parse base64 string.');
    }
    return code;
};
const base64ToUint8Array = (str) => {
    if (str.length % 4 !== 0) {
        throw new Error('Unable to parse base64 string.');
    }
    const index = str.indexOf('=');
    if (index !== -1 && index < str.length - 2) {
        throw new Error('Unable to parse base64 string.');
    }
    let missingOctets = str.endsWith('==') ? 2 : str.endsWith('=') ? 1 : 0, n = str.length, result = new Uint8Array(3 * (n / 4)), buffer;
    for (let i = 0, j = 0; i < n; i += 4, j += 3) {
        buffer =
            (getBase64Code(str.charCodeAt(i)) << 18) |
                (getBase64Code(str.charCodeAt(i + 1)) << 12) |
                (getBase64Code(str.charCodeAt(i + 2)) << 6) |
                getBase64Code(str.charCodeAt(i + 3));
        result[j] = buffer >> 16;
        result[j + 1] = (buffer >> 8) & 0xff;
        result[j + 2] = buffer & 0xff;
    }
    return result.subarray(0, result.length - missingOctets);
};
const pako = __webpack_require__("../../node_modules/pako/index.js");
//https://gist.github.com/enepomnyaschih/72c423f727d395eeaa09697058238727
/*
MIT License
Copyright (c) 2020 Egor Nepomnyaschih
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
let wasm;
const heap = new Array(32).fill(undefined);
heap.push(undefined, null, true, false);
function getObject(idx) {
    return heap[idx];
}
let heap_next = heap.length;
function dropObject(idx) {
    if (idx < 36)
        return;
    heap[idx] = heap_next;
    heap_next = idx;
}
function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}
function addHeapObject(obj) {
    if (heap_next === heap.length)
        heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];
    heap[idx] = obj;
    return idx;
}
let cachedTextDecoder = new TextDecoder('utf-8', {
    ignoreBOM: true,
    fatal: true,
});
cachedTextDecoder.decode();
let cachegetUint8Memory0 = null;
function getUint8Memory0() {
    if (cachegetUint8Memory0 === null ||
        cachegetUint8Memory0.buffer !== wasm.memory.buffer) {
        cachegetUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachegetUint8Memory0;
}
function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}
let WASM_VECTOR_LEN = 0;
let cachedTextEncoder = new TextEncoder('utf-8');
const encodeString = typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
        return cachedTextEncoder.encodeInto(arg, view);
    }
    : function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length,
        };
    };
function passStringToWasm0(arg, malloc, realloc) {
    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length);
        getUint8Memory0()
            .subarray(ptr, ptr + buf.length)
            .set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }
    let len = arg.length;
    let ptr = malloc(len);
    const mem = getUint8Memory0();
    let offset = 0;
    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7f)
            break;
        mem[ptr + offset] = code;
    }
    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, (len = offset + arg.length * 3));
        const view = getUint8Memory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);
        offset += ret.written;
    }
    WASM_VECTOR_LEN = offset;
    return ptr;
}
let cachegetInt32Memory0 = null;
function getInt32Memory0() {
    if (cachegetInt32Memory0 === null ||
        cachegetInt32Memory0.buffer !== wasm.memory.buffer) {
        cachegetInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachegetInt32Memory0;
}
/**
 * @private
 * @param {string} R_x
 * @param {string} R_y
 * @param {string} shares
 * @returns {string}
 */
function combine_signature(R_x, R_y, shares) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        var ptr0 = passStringToWasm0(R_x, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = passStringToWasm0(R_y, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        var ptr2 = passStringToWasm0(shares, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        wasm.combine_signature(retptr, ptr0, len0, ptr1, len1, ptr2, len2);
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getInt32Memory0()[retptr / 4 + 1];
        return getStringFromWasm0(r0, r1);
    }
    finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
        wasm.__wbindgen_free(r0, r1);
    }
}
exports.combine_signature = combine_signature;
function handleError(f, args) {
    try {
        return f.apply(this, args);
    }
    catch (e) {
        wasm.__wbindgen_exn_store(addHeapObject(e));
    }
}
function getArrayU8FromWasm0(ptr, len) {
    return getUint8Memory0().subarray(ptr / 1, ptr / 1 + len);
}
async function load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);
            }
            catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn('`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n', e);
                }
                else {
                    throw e;
                }
            }
        }
        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);
    }
    else {
        const instance = await WebAssembly.instantiate(module, imports);
        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };
        }
        else {
            return instance;
        }
    }
}
async function initNodejs(input) {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_is_object = function (arg0) {
        const val = getObject(arg0);
        var ret = typeof val === 'object' && val !== null;
        return ret;
    };
    imports.wbg.__wbindgen_object_drop_ref = function (arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbg_process_5729605ce9d34ea8 = function (arg0) {
        var ret = getObject(arg0).process;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_versions_531e16e1a776ee97 = function (arg0) {
        var ret = getObject(arg0).versions;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_node_18b58a160b60d170 = function (arg0) {
        var ret = getObject(arg0).node;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_is_string = function (arg0) {
        var ret = typeof getObject(arg0) === 'string';
        return ret;
    };
    imports.wbg.__wbg_require_edfaedd93e302925 = function () {
        // console.warn('[ECDSA-SDK NodeJS] __wbg_require_edfaedd93e302925');
        return handleError(function (arg0, arg1, arg2) {
            // const uint8Memory = getUint8Memory0().subarray(arg1, arg1 + arg2);
            // console.log("uint8Memory:", uint8Memory);
            // const decodedText = (new TextDecoder()).decode(uint8Memory);
            // console.log("decodedText:", decodedText)
            // the decoded string is "crypto"
            // const moduleSpecifier = getStringFromWasm0(arg1, arg2);
            // var ret = require(getStringFromWasm0(arg1, arg2));
            // var ret = require('crypto');
            let _crypto;
            try {
                _crypto = __webpack_require__("../../node_modules/crypto-browserify/index.js");
                // console.warn("ENV A X:", _crypto);
            }
            catch (e) {
                _crypto = globalThis.crypto;
                // console.warn("ENV B X:", globalThis.crypto);
            }
            return addHeapObject(_crypto);
        }, arguments);
    };
    imports.wbg.__wbg_crypto_2bc4d5b05161de5b = function (arg0) {
        var ret = getObject(arg0).crypto;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_msCrypto_d003eebe62c636a9 = function (arg0) {
        var ret = getObject(arg0).msCrypto;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_getRandomValues_99bbe8a65f4aef87 = function () {
        return handleError(function (arg0, arg1) {
            getObject(arg0).getRandomValues(getObject(arg1));
        }, arguments);
    };
    imports.wbg.__wbg_static_accessor_NODE_MODULE_bdc5ca9096c68aeb = function () {
        var ret = module;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_randomFillSync_378e02b85af41ab6 = function () {
        return handleError(function (arg0, arg1, arg2) {
            getObject(arg0).randomFillSync(getArrayU8FromWasm0(arg1, arg2));
        }, arguments);
    };
    imports.wbg.__wbg_new_693216e109162396 = function () {
        var ret = new Error();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_stack_0ddaca5d1abfb52f = function (arg0, arg1) {
        var ret = getObject(arg1).stack;
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_error_09919627ac0992f5 = function (arg0, arg1) {
        try {
            console.error(getStringFromWasm0(arg0, arg1));
        }
        finally {
            wasm.__wbindgen_free(arg0, arg1);
        }
    };
    imports.wbg.__wbg_newnoargs_f579424187aa1717 = function (arg0, arg1) {
        var ret = new Function(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_self_e23d74ae45fb17d1 = function () {
        return handleError(function () {
            var ret = self.self;
            return addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_window_b4be7f48b24ac56e = function () {
        return handleError(function () {
            var ret = window.window;
            return addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_globalThis_d61b1f48a57191ae = function () {
        return handleError(function () {
            var ret = globalThis.globalThis;
            return addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_global_e7669da72fd7f239 = function () {
        return handleError(function () {
            var ret = __webpack_require__.g.global;
            return addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbindgen_is_undefined = function (arg0) {
        var ret = getObject(arg0) === undefined;
        return ret;
    };
    imports.wbg.__wbg_call_89558c3e96703ca1 = function () {
        return handleError(function (arg0, arg1) {
            var ret = getObject(arg0).call(getObject(arg1));
            return addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_buffer_5e74a88a1424a2e0 = function (arg0) {
        var ret = getObject(arg0).buffer;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_e3b800e570795b3c = function (arg0) {
        var ret = new Uint8Array(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithlength_5f4ce114a24dfe1e = function (arg0) {
        var ret = new Uint8Array(arg0 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_subarray_a68f835ca2af506f = function (arg0, arg1, arg2) {
        var ret = getObject(arg0).subarray(arg1 >>> 0, arg2 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_length_30803400a8f15c59 = function (arg0) {
        var ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_set_5b8081e9d002f0df = function (arg0, arg1, arg2) {
        getObject(arg0).set(getObject(arg1), arg2 >>> 0);
    };
    imports.wbg.__wbindgen_object_clone_ref = function (arg0) {
        var ret = getObject(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_throw = function (arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_memory = function () {
        var ret = wasm.memory;
        return addHeapObject(ret);
    };
    const { instance, module } = await load(await input, imports);
    wasm = instance.exports;
    initNodejs.__wbindgen_wasm_module = module;
    return wasm;
}
async function initBrowser(input) {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_is_object = function (arg0) {
        const val = getObject(arg0);
        var ret = typeof val === 'object' && val !== null;
        return ret;
    };
    imports.wbg.__wbindgen_object_drop_ref = function (arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbg_process_5729605ce9d34ea8 = function (arg0) {
        var ret = getObject(arg0).process;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_versions_531e16e1a776ee97 = function (arg0) {
        var ret = getObject(arg0).versions;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_node_18b58a160b60d170 = function (arg0) {
        var ret = getObject(arg0).node;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_is_string = function (arg0) {
        var ret = typeof getObject(arg0) === 'string';
        return ret;
    };
    imports.wbg.__wbg_require_edfaedd93e302925 = function () {
        console.warn('[ECDSA-SDK Browser] __wbg_require_edfaedd93e302925');
        // return handleError(function (arg0, arg1, arg2) {
        //   var ret = require(getStringFromWasm0(arg1, arg2));
        // Note: This function can probably be removed for browser
        // try{
        //     // this function probably not run on browser
        //     console.warn("[ECDSA-SDK] REPORT THIS ERROR TO DEVELOPER");
        //     ret = getStringFromWasm0(arg1, arg2);
        // }catch(e){
        //     ret = require(getStringFromWasm0(arg1, arg2));
        // }
        // console.warn("[ECDSA-SDK] ret:", ret);
        //   return addHeapObject(ret);
        // return null;
        // }, arguments);
        return null;
    };
    imports.wbg.__wbg_crypto_2bc4d5b05161de5b = function (arg0) {
        var ret = getObject(arg0).crypto;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_msCrypto_d003eebe62c636a9 = function (arg0) {
        var ret = getObject(arg0).msCrypto;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_getRandomValues_99bbe8a65f4aef87 = function () {
        return handleError(function (arg0, arg1) {
            getObject(arg0).getRandomValues(getObject(arg1));
        }, arguments);
    };
    imports.wbg.__wbg_static_accessor_NODE_MODULE_bdc5ca9096c68aeb = function () {
        var ret = module;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_randomFillSync_378e02b85af41ab6 = function () {
        return handleError(function (arg0, arg1, arg2) {
            getObject(arg0).randomFillSync(getArrayU8FromWasm0(arg1, arg2));
        }, arguments);
    };
    imports.wbg.__wbg_new_693216e109162396 = function () {
        var ret = new Error();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_stack_0ddaca5d1abfb52f = function (arg0, arg1) {
        var ret = getObject(arg1).stack;
        var ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbg_error_09919627ac0992f5 = function (arg0, arg1) {
        try {
            console.error(getStringFromWasm0(arg0, arg1));
        }
        finally {
            wasm.__wbindgen_free(arg0, arg1);
        }
    };
    imports.wbg.__wbg_newnoargs_f579424187aa1717 = function (arg0, arg1) {
        var ret = new Function(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_self_e23d74ae45fb17d1 = function () {
        return handleError(function () {
            var ret = self.self;
            return addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_window_b4be7f48b24ac56e = function () {
        return handleError(function () {
            var ret = window.window;
            return addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_globalThis_d61b1f48a57191ae = function () {
        return handleError(function () {
            var ret = globalThis.globalThis;
            return addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_global_e7669da72fd7f239 = function () {
        return handleError(function () {
            var ret = __webpack_require__.g.global;
            return addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbindgen_is_undefined = function (arg0) {
        var ret = getObject(arg0) === undefined;
        return ret;
    };
    imports.wbg.__wbg_call_89558c3e96703ca1 = function () {
        return handleError(function (arg0, arg1) {
            var ret = getObject(arg0).call(getObject(arg1));
            return addHeapObject(ret);
        }, arguments);
    };
    imports.wbg.__wbg_buffer_5e74a88a1424a2e0 = function (arg0) {
        var ret = getObject(arg0).buffer;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_e3b800e570795b3c = function (arg0) {
        var ret = new Uint8Array(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithlength_5f4ce114a24dfe1e = function (arg0) {
        var ret = new Uint8Array(arg0 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_subarray_a68f835ca2af506f = function (arg0, arg1, arg2) {
        var ret = getObject(arg0).subarray(arg1 >>> 0, arg2 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_length_30803400a8f15c59 = function (arg0) {
        var ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_set_5b8081e9d002f0df = function (arg0, arg1, arg2) {
        getObject(arg0).set(getObject(arg1), arg2 >>> 0);
    };
    imports.wbg.__wbindgen_object_clone_ref = function (arg0) {
        var ret = getObject(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_throw = function (arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_memory = function () {
        var ret = wasm.memory;
        return addHeapObject(ret);
    };
    const { instance, module } = await load(await input, imports);
    wasm = instance.exports;
    initBrowser.__wbindgen_wasm_module = module;
    return wasm;
}
async function initWasmEcdsaSdkBrowser() {
    var b = '';
    b +=
        'eNrsvQ2cXEd1J3qr6n513+6eO5JsZI+wbrdkPAZ7PbKtGcl4wXcWySjCsbPx8rz89q3QxwjcY2S';
    b +=
        'PNMgmjGbGWAhBnEQGJ1GCQ5Tg38/KYgeROEYQbxgTv31KIogJTlCCAYU4xEnYjQImEWDwO/9z6n';
    b +=
        '50T48kA5vs7u8ZNF23Pk+dUx+nTp1zytm8623KcRx17O7ZWWfZmx3nzY6aebOacegfB9T0m/UMf';
    b +=
        'dIf+jYzCOMvfbgz/MU/9OnNyLf8UoQ/Y2NsgKKCmSwuC1FkRULT09NS2bTUMS117bF1TgkUnGeP';
    b +=
        'tDuV/wC0af5RU2pK/8l+6s1yc+eWtyzZtOnOLbfu2PaWsR2bbt216fYt7bGtk45B0oWlJInftG3';
    b +=
        'n7Xds2jm23dHIcBEyvGXTHTtv3zq2a9em1SNXrh0eWr11bO22q64e27xGalkumXaP7dx16+07KN';
    b +=
        'dVq8ZWDY+t2jwyMjw2tnZEcg1Irh23bxvbtGrNltVrNq8aHtoyPLRt1ciQ5OgCdNfkzlt3vEWSL';
    b +=
        'Bw7xybefuvOsU1j27ZvHtu2be1VY1cNXbn2ytVOiEwvl0xbd77jjsnbN125ZevV21ZvGVq9anjV';
    b +=
        'trHVWzpgfduufye5tg0NXTU2tmVs+Mqtw1cNb14ruV4hud4yNvnvN+/Ydvvb3rj5treP7dq0du2';
    b +=
        'WLWNrNg+v3n715rHta0YcD5mvlMy7JjdP3rp10+atwNTtOzf9+I2vW7fphhtf9x/esG7Tlm1bV2';
    b +=
        '/dvHZo7fDW4TWbx7Y4CgUvtp3iJtbfetttP/mOHVs3XTWyZmzoyi1rVm/efvWqzVuGnSCnFGFv7';
    b +=
        'M5Nw2uvuhLoHVq7avjKq9YOS2XLcii2jm8a2rZt89bNq7dR+e1bVl+5XQC1WcZ27iTwhtauXbV2';
    b +=
        '+MqRzVspdOX21ZIlyZvZcfvmnW/ZtWn76pG1V1959ao1I5s3rxpZNeL4JVruGrtt+6axK6/aNkL';
    b +=
        '4uHr19i2rRratEnAsLe4kct5+56YtV28ZG9l+9ZotV169eevq4THJ07RYvu32LZtvu/mtRPJtw6';
    b +=
        'u2rKJ8m1ePrFq7avNYR12Sb9PYyPDw2m2bR67cvm1kO/Vf8rysc+y8fce2se237hjb1jH2tm6+7';
    b +=
        'bZNa9auXr1m61Vja4dHhq7aunmV9Mi2seXt27eP7dy0eox6tIZGKHV985VjQ6XZIjQYu2rLmqGh';
    b +=
        'sdUjQyNrV2+5aqtkWJlnuPPWybfeNrbjLZNv3USDZevYqlVUz9Xbto+tGusYh7vevmXzzp2b37F';
    b +=
        'p8/Ca7WuuokFy5ebtq4eGt3eMaFvTVUNrhq66emho85rtq1ZvXb22A6pdY5ObVhNQa1bR5Bwaun';
    b +=
        'L70LbtMnQG5k/yrbfdvmOMZzlXEZdyTL515+13ymDoL0W/bextt+98B+H6yLtpXflNrxL5pl6JA';
    b +=
        'r/iGx1Efhhe0Kj6OrwgrPhRJayEfsXp86Kgr+L3B34Q1YKK7y3uCwIVeH2e78c17Q0EgaG0iu+H';
    b +=
        'iy/Uvu97Vfob6YqvAt83gecFgd/nLzJ+6HuBFywOKlHFo8oij5K8Cv0X0KcXen5ovCDyFgeLfYr';
    b +=
        'zfR2EoReEvh8E1cD3CFovrAQBwUMtBkGlrgNNhagqLzqf4qk6yqupYkqlOgkUz9f0H0VTmPrlU1';
    b +=
        'mNBILD8zTlI6iCShhSJYCAKgyMrlJNnk8ffp2+KWsUVQxDWQ+peoSoLIHvG4NkBgfd1NQbChHeP';
    b +=
        'Z9Tq54fRQyFzyAY5PICrT0ChDBWITC0RxCGOtIEagV1ECjR+VFEUISeooiGX/WqEf6r1aLz8Lsk';
    b +=
        '8qpVdK1S0egY9QvdNBEjwXiaYjT/53M/0E10ueobUMCg99QbbZDLMHAoC7iocWCcQNWmgv6ZKmE';
    b +=
        'nNMZDFaFvpGL8RdXAOOWiZPtfwCCEPgoRBY39z+dslKKUcQjH+G/ANUYZ47qOodhalSo3ru76z+';
    b +=
        'F/Dgfc98zSqFV3qJ+m/3n38IfT77+XAzMqnZ2dc6LgIBiAwJehrp3+rbe/jYb/2KZdt75lx+bJt';
    b +=
        '+8cc/ar5aU5sXnbtk20hciSe8ftt+6YHNvpfM7tmDa04ty+1fmeXlSK3Dkmsb9n+kqx23eOjTm/';
    b +=
        '6JY3wbG7dlDtt1PDv+lW3v8uhjpV0fvUb3n36t/2Pqs/5v2SetT7vvs73vfc39CPed9Uh9XHvQP';
    b +=
        'ez3k/633C+5D5pPeYe9T7FfO73k+be7x3eY97X3J/z/uCftbMeXvNp7xf8b7iPunOvEd/2vu22e';
    b +=
        'c96f2+9x7zNfMVc9I8Zf7MPG3+yPyx+az5E3PcfN78gflD8xnzOfMl9afmC+ZJ8xn3veZj7r/5e';
    b +=
        'e+/ubPqmPcH3u+4Uz+nv2qecv8f82V958PmAffj7n+e1X/kPaSPut9Xc+qv3O+pD+tn3RfUP5tf';
    b +=
        'MPear7rvM4/q31e37deH9a736u+qF9Vfmg97D3q/ZfaqI+pL+hPu77lfVW847j6rftV90D2ljnt';
    b +=
        'HvNPu8M+q9+k/du9Vd+vq3973HixIP7tKv2LGnV7hpHPV8Za70tHXnev/EnWpcVqvvKnuIBS2Xn';
    b +=
        'VTXSEUty67qa6TVyaXTbUuT155c91Q+FV7kle+se4mJu3fUPcSdZlzYZN+rlBLmypxk1e+RruJm';
    b +=
        '4bt1EleOZrsf4j+0iibjW9u+QPD2qE0leokC9coX3pQxS+4F1LhV71GP0yVpIdVW2p4FdfwqoVq';
    b +=
        'OJxl7qzmstfopzWlPKVtNZdxNZctVM1TWeaOatLTRoqnD9iY0btRfsScNol6ZHRo3+jQe5LLR2e';
    b +=
        'm3rFn9NO//MRz7vTo7K995tCjegrNtfw0nkzjtzcDQbF8tcLUeT3h2U1UfMmFAn0WJAg4WFORbd';
    b +=
        '1JwnEpR9ER1xOkMz+G8pQW2LSWiptFVc2iqmZRVeKnL75oJiiKIga106xQ/MFKO3V3UsDd2aqmh';
    b +=
        '1T8HUZfZVgfrORjo4L8T+lWRKFo40Crlg5urNPgSmp1J3WatZobJbVUTTTr+Lm+riiyQf/6ahoJ';
    b +=
        'g4kbf8N1EJyeaMY5VZq+BYCCeREDPE21W2ESEoytfoJ6qk0hxDSojXZrEShHgxPJixOf0xpJmPR';
    b +=
        'vSBYl4YadlBM5GsniDRTb2LCz2aBKuDnFTSVx0pfqdqvv+roTEUqT+jpGJ4GChMkWjSa33fK57p';
    b +=
        'af4RKR3JhKGrYNlfhoQ6GNiMFDTbX0ko31wFZYowpRMlUoQOhpN2uE/6QGDAOvp02rL6kl9I8wq';
    b +=
        '9JLb+SiwJC7s7nEDm4KnsdEap5PndCTTaWvMzymiAIzNBDUQNMHtqVRJbgF0SkYMkYJxTOC09B2';
    b +=
        '7HoC3d8w0PLXWTz4iYeBWQEQFdCdyVuhjZPiZto0fDCACEhF/U/NRNPnUW1urDujTvOVyflNVYu';
    b +=
        'iJExfoIzBRDPMYkHURK3Wzmh1OnnlVItWCAIZSG4kjSyaZkyeEi6YUlsgBUFqjOYYKBzyEKo7BE';
    b +=
        '5E84WQENQWRel33/WEky5LD97zhBMf106UHqZQ+vL0WB5x4h7O8XwesXcvRQynj+/NIo4jYiTd+';
    b +=
        '+4s4n4KpZenT2YRGPHpvb9JX/+g6EsV47+SB4FswvqCeKEu2A75hPiWDwIlr3yopdYxfWh8YaGt';
    b +=
        '2LGV8NiqoJuVSGavg6F1WLX6QUsaLEk/07IfU7X/XGh5HtHSzKPlef+atDQRo7CE2/4fDUL7LUJ';
    b +=
        '5+ezvQGo/kNoPpPbzXhNl+IxkBcbOAZxG54LTJT1xuuRfG6f9HTiNfiicUpkMqxGwardV+ihjNQ';
    b +=
        'JWI2A1AgKxbB3y7EaETY82I1VsRn3D+pBns9Dm2HyZLJu8xB3zuVgptz+sj2UpmnIvLeU+FfTIf';
    b +=
        'SqwKYZyX3AOrBI2z1aMn1NB60LaTS7M98Ribxso9rZlOSPRfLntBgUvsjBScLkFgIIJM07NZr41';
    b +=
        'N1sW/hX4PeQ1V+L3mN+8mKbzK4g2r2hewpvMGbYEqttuCee+HVDtPABSfWOd+cikRvGpos2Ut/o';
    b +=
        'KNmvEpmo973nY2hHHWRJqrCnjutdmns7sOtN+zsk/3JZe4S2953Z+Qb6Vcztn3s2V3audNGzSyt';
    b +=
        '6MiZ1KH6DJkl4ocwYrvh0XcXIx/vFgoFXCORtZiPovmSxCkg1UeUx8l4leIl2W/y9Ml6UvhS46o';
    b +=
        'wutJTRJok5OcyEK1ZKV+EcUqgiFKmemEE3VH4JCNWKdTNZpRn8FFKpZClWEQpVOCl30r02h2sIU';
    b +=
        'etlLplBFKKTbQqHKwhSio8UK/CPaxKCNSeIz08Yyty+RNgV1KjyXMW0z6sTl+RMLdWJQp5ZT5+X';
    b +=
        '/0tSpnfv8yVByzhTyQaG4vB9fkpj19Uqik0uwYw+1r3EIA5aTrFOonh1RvOQSFHnFgoeRmhCJz6';
    b +=
        'PnTKQaEylpJaWTaMznpNieQAcpNEhARNhtfSZnxIxthGNuBAJemp0kkSZEjEBEELaR0PBJlvFp8';
    b +=
        '1/kpFnpIt+lP9qTJrNYoa0w6jhpdrBYBzG5IvzLCBj+zzpG0oilQ6SWs6ROeC5XZXtkQmHSUWzB';
    b +=
        'LYfglhvMLWfHRcpM7DMmaeN/naNk9MOdMWKQqoYB3cEJxyBTnE/EOtBVY3TVGV11oKt+BnSddwZ';
    b +=
        '0nfe/L7rqQFfDriD1DpTVgbI6UFbnI9kgcNZgnA0yzgaBs8Ez4GzJGXC25H9fnA0CZ1a8Rh9lnA';
    b +=
        '0CZ4PA2SDLOunMUpxbbpB5W8gpaO7+eD1mfokCLCZl8SSmu7IyKx9LUraaNM62mvwgm7WcPfp5V';
    b +=
        '0ITOnlFm7bhGarlEmmKqplZTwd3P+W6dVY3YaYBtF7uOOla2gAiSsJCimFAeEW04r3tEqK+bm+o';
    b +=
        '9xMJ6Ng2lPiQ8taoTZ2uogzUl0uAWU35KfUSpIJGrwBEDi3hQ6hF5Eu0IxKb8woUpuT02XdnB+r';
    b +=
        '4DExPSTgUdQR7C5AMVfx0j4oRLJWoFwn1joTBImFwoTYI+J5wSLdxxqUev1qF9POKYe3SjxZR+l';
    b +=
        'y1vdLpK1fwgUv1RTMG9xFP+eMt78z3EXIDsSK/gViZ30BcjBuIFcnFU8kK3D+sSFbuSVbg/sHeO';
    b +=
        'HjJitdoGqqQ1LOsfwXL+ld0yvq9XNYfUnhJSczvpUdUp5jfy8T8R1Qh5l/xg4n5AVYu05emFpbp';
    b +=
        'e9KBTKxvxfdcqiy+9wb1EdWsUMJhEZtIvWUZvgfe+7CXGD7Gm7S6gSX2FZ7uzIgrIbLUQdOxhrz';
    b +=
        'EFiuZwxj3PKtlRnUIt3wW9ms716WKJGzzAkWr6AoA7affl3XVp2UktAk8Z11wWESjfUlIS9zeFh';
    b +=
        'Hq/r9/xsy2LuZlDqSWmOk9yKR6ZCplaa6gKu/Cyuin07IkWu4rEsE+M3lKGuS6bE2v0TzE72wTN';
    b +=
        '1m5gQYbYfWwhwVtQ91OCWXlYHaEgsNKj88+4bR5uULleRmRmCvegBQkggvhrg7cEXoeAeBotQt5';
    b +=
        'F9OKmX4eC8VAaaGoF9gMpQjTjAsUSL24QOrFyYrZ1kpB6MV07F1RRmaRaJOaFy+IRPS7hMaL81q';
    b +=
        'oDkYho4AzZhMZUSFtfMS+0g7Rl90W9TFy+oCcPiABJ097WxQxq6ORkA/MPnDt/dm0po7LSLWXRV';
    b +=
        'yii4WvlVn4aEEWPiIU1jpZ+EhY+IjY66iLhe8H+0Fky1j4eF0+4us9WHiZ7iUOPprPwUdyVFnHW';
    b +=
        'wjfFUl9fR0cfB+2FVpPPQhAaSb34TSRVAijvtwSZZMeSyCQRKEYm+Yk5M48iX27EfsDzRDYtQsJ';
    b +=
        'dklpkYIRI61J/EQSoQuR3ZOvJ6SEtBmHmVQjlHNzIxvrDcaDQ+spLogapXGO/ZgmFfFbIZ+3rQB';
    b +=
        '8RRITP8CdtyxXlMUaXD75luFZMdVagbHpA7H1pJ5FM/tkU8IFU2oLpCBIjflguXwCgYZN1HlBVM';
    b +=
        '0viJ5/d9cF0d59XRdE9+/ruiB6cF/XBdGj+8qbfD6my7uuXyQ0SqtNEgoL2BsjBLztSghGJ2MbV';
    b +=
        'zwkC1JDpO48DBsZD+jzMRW9bGA8NYhmNACbNbv1yH6Fo57dubBvBYlrdyHaz2nVGU8MjYZ6XeVz';
    b +=
        '1UtP8C1l0rnpnNA2BbL6JXavwsSYdbtzE1yzrk2BrP68Um67s3XmpmmQ7dbN820zFHyZrYOCS4t';
    b +=
        'l4oJ87bjQRkLCP8CrU3NRsYkOEsjNZfiddZsvt+vZRdTL5QV3QuRY3qx2cSyLRIhYBWKX0xdmHo';
    b +=
        '3mMC9CFFF2evGsauLyx8X0w5Ia0RJ0Ef7RlE5QlZskZ569dsqGQt5znrzUlSam7400MBICCaSnp';
    b +=
        'mgJblLSImoqEUFJgiUXwpNFnOUCaulCmZw8XaSNxXxeyURMcvPfbvVjiNlVsI+h4OSaLK39WFop';
    b +=
        'M9+BJ30bKLZGCyExBiBPmC25DSCRFu1srW2uyxgoILflt2Wbs4eGgcQvC7uIz7AtELLRgo8WBD7';
    b +=
        'q8zzeu54QT0SHSDC1Hr7W0zlAJ1Vw+vQ1nh0FvCSh+ZKGhMOkuQhEezn+EdEaQrTGmYk26/5ARC';
    b +=
        'tW3EXNRi3Ad0MklTWW/zRblnYNoV0DtEty2i39l6Zd0kW71hlpd965044FlbJoJU1scs0aRSwq1';
    b +=
        's6kCFaJcir+Jp98aNmat7gudDHQSJbhXzYRnbNNRFp3fjiaNpqJ3A0kGU2TMk17z8eX/WvPxzPT';
    b +=
        'dMlLoanOJhbRlM7NTeA1WZhONLwq+EcU4lVX2+X2XBidl0ahgkY02+WGYFFGo0UZjRbz6s80WpT';
    b +=
        'Nu8Wc5fyeNOrvSaO+Eo0anTTq30C8XplGjYXn3WLQaPF8Gi3uQaMMMedMJw90WiR0om2uiTlmIH';
    b +=
        'TBSklxcknANHFlU2QuH5ij2IInhDy6VWOeMGP6+ETFMrjaS2AIa0ltAYZwgZTaAim9GcLoB2LAc';
    b +=
        'vZrEdgvv5gjBfu1COhblGNzecInClaf80Wy8+S+jDFcdIaJUFr4FnVwk41OaU0XryIXniWlLtOp';
    b +=
        '1BXmPLsvslHLs2M2RWUR6YpCOOkViOEDKOXMogs0s3h0gZTaAikWv93KKloUgApGuVNW2gVOUxU';
    b +=
        'kzmWlKzp1qGQ69NajYmb2iD3M4ipH8fLDZ31VEnhCVJLVpOScGp77hQnEOmoC52CPpQbET9Tqhk';
    b +=
        'X+1KjBSge5JsssJ+oGeSrzRHd2PCiIB/cV8rq6yOt0UqeRB7lEomXFxC65njuh+MyPDKGgKQKrS';
    b +=
        'oFCdkpbKZ9vC7FpHeXH6eMGXPSIbBRyDuaYdJSuYvl6jQWnEKOmQ9RInZdLDlpxat0WieQIMgsO';
    b +=
        'nk4fQXYOeQNBWAcKFPFbihtm0T9fiRS7OwUh0irF5ALKeklA6aVP+e2VTvSxZboxoyGUPKTGW7q';
    b +=
        '3UJK6E0y0zLq6TU0cUM7N5pDLc8jFHDKQCT0ImRANQTp/Oxh5hrpQTC1PRGY0tQIq62VTqx9Ty8';
    b +=
        '+mlocYogwtBKtxLzSd9E+1+jGWjZUvZNE8TWxKuGBKbYEUBJv9lCEGmB6mlmenlksjyWRTK5Cp1';
    b +=
        'RscKmnrCTBmAp5a/Q8xwqgaPoEiYKeVsbrW7aYL4rjDcioOaXtxS5hVJcwi4zljMgYhOjAZ56CP';
    b +=
        'zn76C1dMJ/FUK+5CZpbCuIm78NkrsbZwIoJE/G6sGsFqabYujOMegFJVtuISmuOXiuaY0GwIqR7';
    b +=
        'NOwx6mnIsl2HEB8LqBMJThenzNJJTzbhPgvhG2Sfw1TKUiRpqunKErWITMSDCDC4/qhRAqsf9cd';
    b +=
        'fXcaynbF52O2Jw/PUF/xF1jBe/fLoF6Azm6F1oyH+kFY/Ozu79vj/NqJGRJ9nWc7YpZMMQlHRC0';
    b +=
        'zd+5mfVdIkahKW6TnXToAMCA37LtAjSi3kPYMSlppllpIgkQAMV+p/ZMNCsJAQxrTpI1+1uenbU';
    b +=
        'mFFXMBhmwguHNWEiXliSCblSymhRKS8xhB/Qw8gmU0lfAD1cqc0QPViNxpFBbIQeRIgQAlFzHS/';
    b +=
        'czYA+DHMvhkYhaGFyIsig8tCS14MA+jqCajAJxlvVpJpC0aJqlZTAE0+2USPxkCDP3V/57UfCaR';
    b +=
        'Y25+Sppvp6Hkwa4jQtwg4CgQnlWUJ98V2/8/d6ulTGSBmTlwnnlfkflU7SekRat+mdibQrQNqQ5';
    b +=
        'mzigbpe07N5Q0YMtmkhMjY4EDmyBHY7CWy6SFopSBrlJJ1zzkzToIOm995NNA3ORtOqpWn1R0ZT';
    b +=
        'OgQwTUOmqZxzOulVAQmFzFXhtYXWv3f4u9E089A53cJuulV70O3Zv/irf/SnS2VcKePmZWrzyvz';
    b +=
        '3j37oT+vlMp6U8fIy8bwyz3/zxT9olMv4UsbPyyyZV+aeD/2lM39UBWceVQlGVTVdakdVmI+q6l';
    b +=
        'lGVfADjKpZ1TWqos5R1SiNqig9jFHVKEZVZcFRVfmRjCr8b/7Immk3jFbCfnaS2wAlpeFVK4bXC';
    b +=
        '08/r+cNrzLZTW+yv/e3vn/RQlQ3van+vX98+rRTLhNImSAvs3RemY8e+/wHdblMKGXCvMyyeWW+';
    b +=
        '/vef+lDHKK5ImUpeJplXZv/RDxyqlctUpUw1L7NyXpm/+MvHvhaVy0RSJsrLDM4r80vf/8zHquU';
    b +=
        'yNSlTy8tcNn+2HH/hWMcMq0uZel5maF6Zz7rd84vGbBPHHFxxp7dgntCA2zhAMFItauFpd4FMu6';
    b +=
        'vttOtbcNrlO7addo0zT7uo1/48qzHtwIWWpl49H/928g2UJl89PYnJN1BMvkbONgV28mGLbtBcc';
    b +=
        '0VXpS5sGysbuZBNwYCSJlyQhOvZspLPr55kZl0+NwnEaA/zqVWlOQpdUAgQfJ6G0Ti1FWAaNvtY';
    b +=
        'mYT+bRjAKbWWVB5pxjhfpCenm4ERTeigzZwULQN88CR2yvJSQTp7zxO4uhTGv+PcoOWqOT3+ric';
    b +=
        'c8AV0+NuZ9GUQt3Bbqmwle++RM1F3FcxlM5OshT3ENMK1JfUUVLNoxmmCqDDAjBf1ZYBQKWf2uj';
    b +=
        'CiwrUtA9dmcMlqkgb9D8RvJFUeTt3jqER9ryOByVYvxkKDOWdNEXRgTJzocKLjGYUjYzzeUivzM';
    b +=
        '2H6LUWjID7sNTVWUjpo6zSM3+emS/iHTrPyO56efvGd7fTOiXRPu4UxJfHUi/GWm9Aw20hDB2dp';
    b +=
        'AMJJqHBQH38sXcfX4x61pmlgUmvpcmbkcdThs33qo9Hdb2k547tTNUFVqMnx9DWEWswyPd40Flr';
    b +=
        'w5+mJo1Z5weGdJfHi580kBhDvBS4PDSf+DS/+a5cWdT4a0A8WeFZ4CqmTmBchzw8Oy0Bf0hYBBw';
    b +=
        '3fBKPi5btTd4L6L21dP4CEASazwh2ZU8/PP0nQdFhHrK4xlml6JN5k/CHX9n8CkFJD8TH3rd0dM';
    b +=
        'GCPoA2dQRwk+kZqSWMmmA0TLX8AswbXlwMANv7vpoWWExfiZ+xeg/rEJ9KWIx01kBSM38iK61Qh';
    b +=
        'ouP3eQS0G+9mDBpLtw2sA6XjP+TK428ZTpuVgxRFTKI/JjW76VhrJtOnHiOQhQxo8dhjKS7IE3e';
    b +=
        'y5fL+bnAd6cKuBBJYd+cwsiSmyZMygKzQxU8NdcuPizt3hTMejbl2/EWQIL7Xw7lQQf4iUohslL';
    b +=
        '2znTi0xsqw6hRzZPAQzgAu/Z/OQRPCczBubqgTn4ohyMQA0oMetHAF/3a0Eb6AaDnbOnkSaIIub';
    b +=
        'GgFTA30CvTJydID7SWU00pBqRTdgfmMhC4kCS76EBYo95F68hNp0836SetpEk62IHjQEMaFzZBv';
    b +=
        'YXgyz+zC/DGYoYZok554LBtqtETxog/VSkS23PU8XlyQwwVVQiFfkE4n+s4JpiDIg5qIPEwdWsg';
    b +=
        'CbiqFmG75RMtgmIOGkxPAKO0p1Gwwv1nqq202WM/K/0HHKKDlRHpHbZty28CSILOF5dlMMhF4uG';
    b +=
        'Zo08JfEtr80kjN0KbLQ4QODYk/2fKLIetLn+k8lQ9ZFmRrDFkfPzVaYYz8+KxywEIJqhqoGgYEG';
    b +=
        'WZ8pHlJaGvymyG0UNFDqt+i2Zef0NYUZDUZrqnnfKiraL5sL+s85b2xzsh7RhYBiFNUeoyQQFg7';
    b +=
        'TCNxnEaFLORdCzrUCmZnXQrGX9WiXGR4oTa1SpShD3ySAc6zQcytQWGG4WYgsM4jhlFBrRZjpRJ';
    b +=
        'Z4mH02j7m+MOgI0LmVJYihDMFwngyJJ6jfPTttvx2i5p4DuUR/3XMF1k3Nw4M47PAy7OfSMH7nP';
    b +=
        'rEE05TRFNO/Ec02jXYnhDTFDIt5Nz7yVSWZsqyoY6xTVn/xsXSGD/nJsy9O7bK+FFDi7W0zuUSL';
    b +=
        'obW6RPrMw4n0miuOwE+C0cSVTQNIWVHI+tZG4XbKFVgMjYtcVldlXqAEI5DtibsNNj3KYVmnBC3';
    b +=
        'VRlPb203GS8yfEKOT8Jxwh/L2Sz1cVkIjFdpbFZAIbAArUhW2Jqtrlm32XF/i/6ixj6psW+8FWN';
    b +=
        'a9g0D8hTqZ36bmJdaUm+3k7g9jus4GpS4AiQGa1i7aKCW1bskq9c2ECMf1ZfEVEc9qY2321SE0D';
    b +=
        '07O6uG9SyhGID+IUVdqk8Rqvr5sI6v059IRwhP1aSffjAFh/ULDBFNtuez2XWKA9Vh5AZhUhedx';
    b +=
        'tB4yIOA3TR536MtZyN21xBUAyPgjltsYoS+z4ufMLzOykaJuEkMWYd3nmL5cTo2JiyWky3Dqw6o';
    b +=
        'x+xgyu3ZtcIBB+jIWpEvyU5pZQ6Y7g5vHSwi5ZpoPWkz8KCLTHMwC/jy5YurS5xxsJYyETGdZe+';
    b +=
        'hBY5HBa1v7XEslHYUJuCK7QKAMHr5uFv3ZIthHsX234l3y+WyQ+cuUR3MFvxwPbNdvN75vN51Lf';
    b +=
        'MBoSxf6WnvbjchBw54KNY8u8w+m813DCTNS8AzvHI4MqS457wppczO0DrFOdJs1rayzYPrAjZtw';
    b +=
        'c5Vh5duwzOZecEScm1FGRB+O/5LGMCXtgG7DFr4Tgh8WNkscAYmC9Q5GTs6Hzs6nixl4R1Mn2EI';
    b +=
        '6cmWLoaQzoaQzoeQzoeQ7hpCvJvZpsChpi8uH9b7P5mecbIwHITNxxA+weFnHyviT3D4JIe/Xsp';
    b +=
        'zksPPcfj5Up7nOHyKwy+U8pzi8GkO7/14kec0x89+HOF7P17kmeXwfo6//+NFnv0cPsDhB0p5Dp';
    b +=
        'TiD3L4IIcfLIUPcfgQhx8uhQ9z+DCHHy2Fj3D4CIcfL4WPcvgoh58shec4PMfh46XwMQ4f4/DTp';
    b +=
        'fBTHH6Kw89w+ASHny3Fn+DwSQ5/vZTnJIef4/DzpTzPCW45/EIpzynBLYf3Hi3ynBbcHmX8Hy3y';
    b +=
        'zHJ4P8fff7TIs5/DBzj8QCnPAQ4f5PCDpTwHOXyIww+X8hzi8GEOP1rKc5jDRzj8eCnPEQ4f5fC';
    b +=
        'TpTxHOTzH4eOlPHMcPsbhp0t5jpXinzqaYrNyZQ3NNtdmmG1WXrEbyqpLK2yrinXGyXZDrB4Q6C';
    b +=
        'Qh7YbVdrYwYfkudsPuBvysARxADXZDMKFQYp23G2L3NyW+7wYs2T/EEsiXbJAUmOjwMh3J5fJTZ';
    b +=
        'rzlr8QOgW3D41NPyIsZn3r4jmmg+zwmx0z0fYC2xKaImO7WN7IW6ZxpJyEriqjddJJ55qNzTvz/';
    b +=
        '4v79OJ1ZrGyIzjRPGkjFBvUcrDno95hp1mxptO6lX88Kcl5t87o2b53yrmknFZY2tRpt8WWi4t9';
    b +=
        'TshcdNKKxdC0NYRtcA0bmgCEuJCQWpkIsSCOG0sUB044/BgCH6AQKq4D0BTR9j0GhIfy5Gn8OwA';
    b +=
        'ES/R40xBW9E0rRkt2k0xPpvUfyEoP4cxm1IrkcgQWt4BQSf0RLZVIVZM28T5QAYR38IgvXkmSgP';
    b +=
        'VA0lODPynlZgUF0j2qOfxzqEIQ1AHCIXXswvqw+16WE2BFzyNhChA8GJSsElBxZoNARw0zGJzW0';
    b +=
        'QhpGu0aLjkGTr3DBkuMMDn0nC/jxAqesYMKbFiucxO+gklMia+NrTdE9rolt3XOODCfaN3eAyB4';
    b +=
        'z5d7GAdoxjwMZXwScpygXVfpW/LktPoSokxQV0P94CI+3IHKlUm0KUHXpMyj6KeSbVVz0zfizTY';
    b +=
        'qesG1W0q8j27uYfpLtFvz5T5LtKScbqy/kgBySbDfhz82S7ZiDZQL/o6x8CSGA8DRL7/1YBsgRK';
    b +=
        'fp6/HmDFJ2zLYTpAx/LAJmTbNfhz+ssIGx2xTgAnPEnMQ9PciTDgzISeYo/JT91PP5lRM5CS9Tm';
    b +=
        'P5JFHtBFnVRJ/E3unW5nqOA6v1mMEdyHo2IKXmqcESODxTyleLDwCEOuUBruyjVLuebsLJEapUT';
    b +=
        '8f+HUBdC6CpyUakOBuCvxSFbboXm10Zd0geMoPf4zxrN0VtCiuV9GIrqqPlW0e2Be4oEztpu3+L';
    b +=
        'Ti8oTarvJ3LICEjQzMrJ6HNZ0DMzcPmLmXBMyheeUPLVR+I+g8H4mhRHeTX9ta8vJCgvhWkFXbm';
    b +=
        'lMTf0XgODKvhiO9apizNZzKa9BZDXPzapjLapgt1XCAawgFiu7BxQXECcflznGDjeV6vkUQGKie';
    b +=
        '+G63VjIlo2z3mpahhdBRrC0FkPpsaxS43HGgF0a1X+F8xrza+a+mWFszCEpLLENwhM1Z4r0elth';
    b +=
        'rnMdZcBLWFdQww7qXXUCUuhW/y+XlWGu+RqCirC1Xmp8yCcstzRk7P4uuPVfaLUw575Fst0DeEE';
    b +=
        '1Z8u/TOL2WenSGdg5l7Uj+eMzWZ4q6fFtX/PusL4WefYk1CqEDa7eTx4t9MMafJfhziL8P898j/';
    b +=
        'Peoia2V51n24QVLlxmEpVnrDxetL8WfZR278E9k8H8p69SXbMvoh47OjfYdEw90OaTmoSoqZ5M5';
    b +=
        'kA1wWqppkHbM3KdVPunyQrwczGXQzNpFumOVMeXZ8IImjq+YDSg2L/cRU+sUaGbTqGGUcYgaps4';
    b +=
        'O5ky9Exez80bNrOmBC5r0BS7CYtiYqCNLaYbmSEF8NkmUdl7amM0Xm15j1hRjVsbbS5l1AOscZ1';
    b +=
        '3RoirmRlQsrTntby3IWd5+OxZGqnlW9o9TPAxbumOv67XynuSqi20fxvD9xWJtWotGqGDRFV5pu';
    b +=
        '/dJzT0KE1tw0bx2vNSbjD+myntMPlyJMZs/PLtK+7a0lDvQUXrhFb+rkpPObQvDwEju3jJ71RJY';
    b +=
        'UOa6QemcHA2aGDIgceAtVon4N4rxZOn96yaSJUqs9nJEH8mGmRjyZgTpZ2Rj3ep/iNa9d5aXpGL';
    b +=
        '4PGXYK0J6/CNzTvqq9GGwm9Djv69fhzPn46Q41OWqWRwh1G5iFS12hVDPw3GrIeFa0phqNZLazf';
    b +=
        'arvgdeZN/IX+yWuVxhY/RF+9/yN4rj4SvU0paCjrSb9AHNUAV/cxsG25nTBA9mxndQ9ykq2UcnG';
    b +=
        'IqQRDgKt+l3SXrclU4HbZthSjKE8zJkLUxLBndeBmmDkrRNikdf+56H2GDFy5we+/Cw4Cbu6AxU';
    b +=
        'Rvv3E0L67hkxkIc33liH9Nb2sYY+upCwc3INyTo9NJNkVdGR47b0yENeO/1s/LaWSj/niI6/O0k';
    b +=
        'fz+17wuH5KHjsu6dVpyr6R197T6t/X6s2muxvLZpuLcbvEmBrf+u8ZNH0VHJeUssK1KZbnHD+VP';
    b +=
        'NlyWIbC1n9NHSIk6ziKe5+CK8SzaWjiu/EVHoK7V+hnPZ4+tqJR1qNfa0LRmemmoupfF+SQdA33';
    b +=
        'eov1Vs0zA0QKNOtWo9WLqSkvukmjR18DWQ6Gir9hm0Uqvx2GJ2XxEk8OvPu0dfut40um269nFqj';
    b +=
        'H2j4tC7q7vNyxCbQBeru8fL5sLSaU6NqqrU8abBLjQOfdTbwbji3999u4AkJBekNRLcwreALThw';
    b +=
        '20BhpBpwiETRSWIOP96ZnUUNKB1wcdwOb91mHwlm2VKVVSqxuoE/6rWxkfcHUTfF16Gd8W4ZgwZ';
    b +=
        'eUUlHqpziCzz7yVddmIBj5k3NEycuSpSD08mTxPU1c1bKxRBNGP0SwqWRgKrlwqjWwB93tR54+G';
    b +=
        'GewIp63o1kpSYJY+Rb2H60qHZqH2q0I7G4/ZaRD923jLf+RhIYDYXWqFb+xHqOp62ngK/F0YyBF';
    b +=
        '2TjQ9EcV+0qo46qoidIKV3rxaHW6WefqiWpVGiBAPStyoRVrHNKPFHioXkwkvUUcQ8y0xTKFovf';
    b +=
        'QYL/gTazRtDx52R4a50l9qrkUN1F7WosTKtFPg+KCm9m2lg5DM+1mhetMLiCo9zQpLVm8p0moor';
    b +=
        'qai0ZZS4qXtAumqGOLb4ZRFS12VHtt6k1sh+fXFkNVFbpLAul5WAz7MzAWv6m+mJq/YE+TYCD0I';
    b +=
        '6HuUBmxsrr3A7n5PX09kH+pwn7E9tyjccFOVqo7aHSIttWp9z/hpBekJ96fWfsffD97fz72/sLa';
    b +=
        '/3NOevi+QkGc9p2luDyExMElVjc+fYb49MkX59jhwGyXe+n97+/yL3D6vi4PBM/d1+Wj4MR93W6';
    b +=
        'u8wjr5+DofQXU0DSz7jtY16c/iUFAj0dY402ED9C31UeDllaNPlqBWhck8S00MwnbN9eVbElxsm';
    b +=
        'QqOX+Kxj9RZVGybA+tgxftSZI9SXMPrVgXJbQaNKeSl081+0YdmicYujQKlo7qZAAOBvGxiAdAH';
    b +=
        'aYQPHKcZGnSNwXKYgBwkWZM44B53Sq7XpZ5AQhgpUm5YbuPcYcCMaJjgIlFk/aGPbTe0TLzpjp0';
    b +=
        'xBCAeRLXyixBPhDsNLwQ3XTEIw7qonlyITpM8XuozQv3vKkujiRH9c2cpX90auoWvm8GkR0xZuE';
    b +=
        'QX5D5Jaskhxn9VyvWgao161mbS5M62mSbwjqmQi1ZijYpHm0uLdpcMp3U38i54tFbpqnr5ZaLEK';
    b +=
        'tHqF4tYywOwTLqoZquzqjpzMuxGL16UDCUCD6eUBRUxfhKUrFTxSr9ihqiYgFlJH4l2J98FQZ+r';
    b +=
        'hhNmaTCVmV0SGhVWGePvloR++JMIlqQUF485HN1hI4qEFaDuSqME5PquIDDNokEz95ftbMsZU1E';
    b +=
        'NiZMvPWtygArTVK9A0mNvSDigp0ahepWBnZYAjvoAjs8O9gby2AHnWCHnWCH44yyM4MdnA3spNr';
    b +=
        '0xUk/LjbCja1ogNZHV1zr4LaEvq2pXiS+nvws1TDYST3+tivjyU3q4y3a7OA60kywhyg2s7L2VH';
    b +=
        '1Q5YG0wE2nJpq1LMZcN4pt2LRXOc4+DuoiqPIgfpO+vfQfFbMGszVY7NRoFfYj4D+0eK+IbiNhv';
    b +=
        'wLnPdCWddkOLBuDiT9OZcH0VZgesFHclbhtyHurNu88ClWZQlUZWFUotTN1KrbRkCjEKq/QIKYC';
    b +=
        '3rjAwxax1OX7M/LgBiF9sJtYkHeH61tVEKsCvQgmVgV6DxHbYHf1Lyj3r3Gu/QvO3r+NZ+hfgP4';
    b +=
        '1BNzgR9w/mG2LZo3L486DCvc4WxaEmUdWDJnCKysNsZp1oNU9yDidBlnlRzDIKhhkFXFmyNqHpY';
    b +=
        'ycS8lQnOGhCH1DGeXQMcg9H+ZB/shcSeSxfMe/RpbSIayt1ziNhLqDA4aTXtvmxZZCV7ezVbbWT';
    b +=
        'u/WtMzKgovIPtRYgUJszTrXWgBU2dmsd0ZeX2aIunVC9QxU7bphUdLgtW02/esAYtAaoTvpynYS';
    b +=
        'SijJU5flYC9ts/0Ja/RC4wchYlDq+YbRN0LcwuORqszQyfWkGm+Z4uiaaKhXuYXRLLTRWMOQrUh';
    b +=
        'osD1Dp99Uxb9r+LUF2k40sWDyZs2vgzc7RkGJgOFJfL+SL5agSHIh7zEQVxxTI+awYixDuPO0ir';
    b +=
        '/sWkTbbA6yHVYENkjt0LGfc+P47/GWiJazGDfKXZjpTnlWXpALcNH4CV0qSOCtwQEaWt0JO9RLT';
    b +=
        '+KsP8teM/23tIL417iLTht3wPwxqG9qaeSn0Ou5COFqID2Vl4MOEm5PDa6lNA4RlJ/vYlnN8s2C';
    b +=
        'hKERcwuU29t01HE4EeS8QxIHR8xbmZ/SfJl8rMDmCacbm7eMEEIlE+SyJj3IuXNc5ig/iFyPMrH';
    b +=
        'WcH2sAqnzPGtG8IiTwYg8jBVMEyPT4iXDpEcVMCaEjV9kVHKkgKXKTa0ZMUdVPiwoD83CP88A/I';
    b +=
        'BmuICiQX0UPqPo93HFBhLLJ2C0ZNhoka9bp8RgVYlvxeUTbFmnoTRche6RK75NaT3bneCCH0qxU';
    b +=
        '9CqcpNokvhMzEDN9Gqz+ToOHk0oi07zMYuocyP37bQj3UiLPrx1xNxFKUnbDpB09reIuk9ryY2y';
    b +=
        'CXySIrASZg3x+3Ux6KNO1N/Fg708TUKZI/sle7VE4G6S7VdCTzsEuUz8D7D+opYPETON34MKSm5';
    b +=
        'YBRhYLz0gwPJWxTmW4s+y+JgSrwWsB40VgocTFTiEAn/KuIrxZwn+UNtVzOd3su1HVveRIivTsM';
    b +=
        'YvYv0EJ8vwe47RyWXzvuynvrxVugJRG5FBtO0xrGhCRvNzH4avkmyIlROPKjve9+f4lKH1X3RSj';
    b +=
        'P5Wx5A8qIo5IqiEgFn1miIYNVH6OJa8Rnocc/pjhn240vr7FGZwZVgfxy9eLFF2gAsAn2B9NGku';
    b +=
        'W8MIWkKRIwg8WO4ML9bdHQTygCCB8UvsqeAk7Fmij1ZUMGOdHLxY2ciuHb3dhSqKtXBidbnMctC';
    b +=
        'qVouJN0XSBDDpJRvFT0vdZT3IVpAOQijg8WQSlwtTyO7ix81KzTATATtoeN/i04nLJrTE7AhX1m';
    b +=
        'maE9rNSafsOGIjNGM0ayTzW23SWSMRcR4hOsvs5lUiPIlYmkf4ErEsjwgkIskjQolYmUdUJGIwj';
    b +=
        '6hKxGV5RCQRQ3lETSKuziPqErEmj2hIxLV5RJ9EzDl5TCwxTxYx/RJzrIhZJDHHi5jFEvNUEbNE';
    b +=
        'Yp4uYs6TmBNFzPkS80wR8zKJOVnELJWYZ4uYCyTmuSLmQon5ehEzIDGniphlEvN8EfNyiTldxFw';
    b +=
        'kMS8UMcslBsoONiaRmL1FTFNi9hcxLYm5t4hZITEHipiVEnN/EXOxxBwsYl4hMQ8UMZdIzKEiZh';
    b +=
        'CnwsFu27PiK33sN1keUzj1YW11TbOEZyVtXz7PPuHj+iJ7/razDpy3qLlZzw/MXsHf9nhL7WYrI';
    b +=
        'M5+iThr7uEfIhSv3AsCKNwc2I1AjiWAqWmZG4c9zxq2ZZxuy5yH8jc8NDIrA15P7d4puGD9o0CA';
    b +=
        '53Os2MUISC1mgujgMSmsWmj7m86UofnbivLAbp5y+KZE9Loz3dwenlvuZju5Wc1mc85lzqxOPwX';
    b +=
        'vyrRl0WpEES8qG/F9G/H9LOJ7qskOr9QGdgwBYSpOB8THLBGVYDzU4rGQTg4vLrSA8zSP0v6YDl';
    b +=
        'RN36YsE7uVpZB9bmx5dRYybqwLT2SsHTUYEYdjYE6IzWQ923EBUe3L6OB33evxDpFp8pMq1OkEp';
    b +=
        'qJS4EbrnZzpr2FfyApkWCU3wCEXVLrW8zDwcMeOVXpc8AK+J0Ttn5p5Q2YJyl0yaF+MfIlmupxl';
    b +=
        '2mYJiizTXVn2zM+ypyvLVEcWinhnGwhjS16W3IvfHaBK7PLgq4jV+ClHVhGbGlGCW2xbbLtF6S0';
    b +=
        'lzrT15Y5KXzvRtMMXVymbxOkTjVNnp3AO2HuIlRkm7gsSRRaYUTKV1VR2J1vxqPSOGwWHaW1yJ+';
    b +=
        'uP57kMclHCIjgwOuVM7CTub3b2SWe9PK+ibcXQXVd8GyHhGGGaNQjPuhsGmjyWaFwPCqfVHtaXs';
    b +=
        'VwOW5gnExdr6XccCT9bCmMXoFzftZ9Y3l+Q8Kg3oq+mqKO/BtXcIQo9Sb9vYIEzlRpmvg6y52H9';
    b +=
        'Vg7FbZwqEBqk0C0cWkmhmziUUOj1AtVJqjH+J83Cwx6wfKcEy5M2LH1xBTBXAHvy0FkBe3MOmIB';
    b +=
        'Ty8EJC3CePZSBA2Lj2syNfxncFrMmiTfAiLUgmAVBteFRI9Cd/tWzQndLDt1NOdosTAdymAzDA1';
    b +=
        'FCeuAXn8A18POH8pVfLh4svB8O6WRt7RENrbMTdCSiVY8XDWZrmF1LDC2E4iiG5XeeGIGz1y3m2';
    b +=
        '4x1kcRrBHv5Y6kLuwBzZPwaSF3CLIadqNlJ+mNtXlFKH7r8YfIPHskujknFAxaZT6NSbdbhF2Ur';
    b +=
        'eTHCZOW55a2zm9TURL5M/Bg7UePDhY96lNSDSJ1HahuJEah3QxOXfa7BQAlnwXW8K80p/rNhoCW';
    b +=
        'I4h1Mbtgo+IKaaMEjBUzCUosXn/Y3FtfSsZFN4DL7HAUD0YDOh6m/e2d697v2hhO5xU7vNHfhtI';
    b +=
        'USdJv+awor26KzqvDKflKBYZqBRZVhc+/0xbtfCCZgB47fdnr3rHtbGu9O2DGkJ37lxNlGE6sWu';
    b +=
        '8+i/Tfzo8U7hgJGjN3q7fBgFKjMkxYsGnUJBYGFOOiBgt5p7sJpCyWUUdDM3M5buaN1fIXHGabE';
    b +=
        'd8IZqmmKPT3XMWPrOAvy+qLMh38f0ED40ZanmMlnUCgomhL0YLyFYCHs/HDKM8cpzxynPHPCArS';
    b +=
        'pHDSZOaXaOJtCNhY5aM4WRocqKgI/dECxNwKqg87TTvxBbGVQnaYD6xr8uTb9xjN0+KzEFxfyOH';
    b +=
        '5eA/w+RCeQYHzJgTS5iTtj4p8R6yLfrOL98stOJnm2R71eBgt6XcbHJK41z8KGXQUjpfMNuyKfI';
    b +=
        'BbLr8N06WS69O2tCjZrw45lpjsSquB7iCfE3i1m2pRlT0eWKMvSNyE8bUDoBMDBBLbniHdwIRik';
    b +=
        'Ubuucf5v+n2RHSl6cDVFmaqSyX5Vsi/OBkWgvCSoztI78eZPP6/DtSntBuBNQt71rxenijY3/f5';
    b +=
        'neDuZYW4ttBzAdBOCKeEA9qRTXBIcADuywLAlfkG8jXn8xrdOT5+Yc2Q7Y9Ix3e4VYoUF3Qzoth';
    b +=
        '+XUUI/OUs874ij1/VM+DmWPrpsiU+Lf/zvgLTuaEXRPMZp07sukisMGT3X8UMQg/p1tJRUiNWUj';
    b +=
        'UPsO3T69S8TmJ9TWearbeYhEOSmNguMqhvqXPOglHhBSiDXIP5cln4XIzaM/5zXb80upXCrwM2w';
    b +=
        'rUaY3vuVjmZW2maSec2EbO5HxxOhtcpsH5Tom2IlfQB1/ZYqJs5S/FkWv4ufCcK7M/R5M88O1pC';
    b +=
        'FDcXD3WVi/FnSXSbg1jEjDPtA5Rma36wK7DXa3l1x0elanl9xoRLbn9XiWgtFDKijNCDSofS5E1';
    b +=
        'aZzG6wNfH1zgZJT4nszClEQrTRX6qdEXNTYmGPv8FDxm0y/vj2Jl2SuvFDrnUMABv7uLDhDyGps';
    b +=
        'bJNjQMPBt8B9pGi+6L4Dz0u/XVic56oKH+GOvwzXpPNbWH4qmCeqjNePf6aK+aYjt2CnPgPXGH2';
    b +=
        'wTDAhOunYSEmprSYVpogpRUZbsd0ynceYjQPUf0Ths6MbLhPBce5Et5A44dpL9SFObwzznbwfVH';
    b +=
        'JY8c8Q1w339P45ORlBqFeD38LJUNcWQHjT7rC0AhYZV12bY3K1mf+NaRjMD3rsobF5px3L/4WOs';
    b +=
        'eZOkx6JZPYxanMLM1Wa8eSBt4Fo9aBiXRZZ13WeZe17bIWhSO3OGCfocsWvKQgU0GZmhj8W78F1';
    b +=
        'usBG+vDHp3OrQp+c3h0nN1njtPpMweLsrNxYJ04JmGfBYodNogFoMpsAjPHC+z5zBppw+bP46VO';
    b +=
        'wbab6r6BiSxcMvEVE2IbCJcCqodLAZW7FFA9XAow3yguCux4FAynanf8iGctkKnxDZmTBeZhCIu';
    b +=
        'P4kpMsadh1CVl0R7yywXBePwRrsFKZqWicbFttOPbjFs/D9zPZoaeptg3slMD8VAEW0fdYXTJV0';
    b +=
        'rt8XljCnjVGRaXZDacFq8+w/4+D4prGC49PA+w1AL3UnvGrxd6PSMAUuINiEhnOCMzXBieiuucl';
    b +=
        'E7B0HqGbcMpBLdB8Z4L+yJhzjpMvlXZ5NuUTb5VyeTb5CbfCmApWcS02HrzyK2JekwY3V3R4Yya';
    b +=
        'WgFBbMctZ36zyTedib41FVfK8c+Zo010tYprzeh1Ex9+R+XGD1Sv+/AHW9HrHP7vVLo1ycKOs50';
    b +=
        'BNEn0EfGJRgiPv61xeQRdJsc+QZYr7PDlZKLfQhmWs2QlTdLloKN3h11wvHifyi41fw6eR9KL2o';
    b +=
        'm3Iz6NnXRmF5+fiJciBizxJhERiuuSivVFhhsyLZqI8BOewP2cZe+4zr/SkXUJQqymwbjUsEU01';
    b +=
        'kdgADO8tnB3ddn9WrYs2FcsJXKY0ePEY1ZY4jmZqJ18PkzamKC4lEs8OwaScIKatEtnIgffYHdT';
    b +=
        'gTfh0u5ukZp4uF2ACaDsgMTDEWtd4c3w0Adoo1ybPv7Lc8VzDwkR6Wj8gHcGwnjyuupHrFsm9qd';
    b +=
        'LWAM35g1wzpN0QvqHdNsAkMsXYPYGG7el8SEWa9bE620oz8YwTnGBltqjfMzvzQGww+wbF6pTHm';
    b +=
        '4kNTu8ErvGHTT19W3jhAcasR73DhfCYvDHdVCoUr57ikfMUHbfSHxZFReEIUd03X4lnJF4LsJ/g';
    b +=
        'NZxGBdXr+VsQyMmrumoNA6wte3AliFwiQu5xGXCFCi/N0N5FvFwFsFwi8EOhKmCWhZfngG154BA';
    b +=
        'LVe67BUH03BHy0urFkY7MjLcuTnuwoVxJwrFwJ97Zvx5aQWN2zv2ML/+KuNPCAqgVAYUJkUzp2u';
    b +=
        'OFgSIH1/pRH8U0hIUTPd6JhEWAUm9rNavsC8Y6LSLcr+o89dL6vwK6vyISvYldWjU1zvV+fEAHK';
    b +=
        'fHXemZOj/OqpwhnJcha2FaMrjzMlh1/jrU+W1Stzp/Lx18neng5+rofknQP18xvw++6TMV9TqUy';
    b +=
        'mPoxSf7RS+/AWeEUE3OFflFL38qyXXnqYYFdfKnWvX0ui6V/JZipfx4/0OtINNZDzKd9aBDZz0o';
    b +=
        '6ayHvXXWg5LOepDprIc9dNYDq7MeQGc9zHTWg1xnPeypsx4UOuthl876qErifXh7BifVxB8ve+S';
    b +=
        'v5C+D+W9g/cFF0P7tv6eJd18hUGpWoVlWPBdWgV4bnguDBhM/nw4+J4B2uy9iexiQ+1BhbwaigO';
    b +=
        '7bl0RqSIUpN6uolzWx/UwT2y9rYj94fyFJxXqBBcwlAldnobpMQ3lR/GN9UbdGvMcOcEG55mJRj';
    b +=
        'meN48X7bxK3VaKl5QmkddGTb4giPHebQe5LYlaXB9hZCxDYCSQJa9vhCZ2kDhAyneunPpApYZ+k';
    b +=
        'ULoy3Xt/b9Xx9GGkN9P783RsMI/en1+Nl1oJuKuNqY4+46L+ySz7L1WUmhFrI33mh1hLa41DW3l';
    b +=
        'jkaO0cT0/CCvVqFZv9MX9/KIuJaprHGKfcP/Numd6VI/oZRRx9K/nWLtd05zG9RgWO8jIB8VFZh';
    b +=
        'vHSuz6S9vxP6qmww/u8qmLrb56VvlAXuXnzqnK+KVU+SfnVGVfVuWrjLO2d5WzeZWfP6cqG1KlK';
    b +=
        'ztLzypPPptV+fQ5VVnPquTDfmeVSqo8nld5/rnUWIukEquG8fWvovRgUd3jtrpymegsZQ73KFM9';
    b +=
        'S5n7e5SpnKXMbI8y4VnKPPdX88sEZylzokcZ/yxljvco452lzFyPMu5Zyjzco4w5G657lNFnKfP';
    b +=
        'CV+eXYdGrHeCZXCU+bZossxoS97qPBywtGtRx5qy2UESiU1amZYanYiP5ZY0rcJ2Z51mfvS8GxE';
    b +=
        'yxGNgZFDBYv4fSiRnvDx12FpZlg6S9xZfjcsQwl7Fcma+ojcgKlTgxf7Po9ulS1B0SZSQqMXJZD';
    b +=
        'PmxkTtn3BMjLLfDbNJf3BDb+2EjXp5DXISb8cS6Qc5fKgr54h7NATIjV9omfbM4BbqDXfMW7Yal';
    b +=
        'dsOsXdOz3dx4O8jvM/DBTnDFjXEzlLt5JSw6sSI4KiZBSSoZMhYNX+InZqCpZWsdkAeDrWyvBw3';
    b +=
        '6okwk0vTs0S62Sg/xpRksurho0aWbzPIlTCIycuhpTvDdJ8fw9YnJr1xM+TLGlC9jTOdljPV2zy';
    b +=
        '+2+eVrzFJtnE2xNkt+jcmWF+ENFm8UHG8FGYcKkcvlTsK+8c36AeqH9WLBRiKBgB+kandTnO4j5';
    b +=
        'EdZGxZpIkVmbR9Cp0iirCLdOj4lh3AhFPf7DvNEqg/WB8ZeRqy352iNPEC+uCiVB/MSfr7BT/wN';
    b +=
        'fUWjndVxQ5JhQWKa6FSg+mbENbZZCfMgN9MFX0oHsBZRaJlMUaq4FVDV9rJIFUR2IKKsJPI6Ab9';
    b +=
        'lYn2AVq3dQBVTQMvkrIrfd3aQJG9BVa2eB7FlkG/08VjZtJFfV6ap0dhJzFsV87eK3A2+9MnUOx';
    b +=
        'qcmedzg7JDvQOZTVdmmU99JS2Pej6Lq/wcDrizOq4S422F/SZLVBuu0oq9M7Ci6+VOrc0io4gfH';
    b +=
        'uSrr1BuBEJReAlF4YUlOWE259zsIW4WYHC+KOFXwxiBUX7P5oLxQ0FUP84eoZj03DLhiEUScQaf';
    b +=
        '2+q3F1cY7rrZRwTU6TOZKUdfw3Vd5bAxCfDdlxoWETXS7znNXPeKsvmBa6iXAZ1DKBHlsdYaCn8';
    b +=
        'LJDWsbJNq+v6uNR6DPmc8QBFoPolTPQn/5enQThrsMaa6g+QYvaFRKUOStrqoB5gZqJ4yjncmUB';
    b +=
        'lQz6VZGJSAcbsANaVOaBHp9nfBPJR+gS0kGeo+vJ5HxzG5fe8Je93UxDIIqtT1XBVII5yrAtXtR';
    b +=
        'SD2WSIodoYoqY0n1Ta/uli5nr17oBbxug4RGYRZfDWI4VNezzvHkinGEsaIzseIKo8RqAq0GF52';
    b +=
        'Pi5O7dy+rCllm/qbUHszPlwXnApFI0/9V6tToRK1mXvGw7KSCSiCe1rVTBQQ7qV4tW/0+5JER+7';
    b +=
        'K6NV0jnqxDw7bW3QQvYdOjEa2B3jLJqy7lMcWP/2iQ8f2m1rBQFIvxf3EAKOQYqs3DeAVEhd+H5';
    b +=
        'iSnvh8+MydoE7toVTtanp05msQhFkFSULN7kvy7/AnWuFAMxol1gZmOo2sWPpHd6bH76QofloUs';
    b +=
        'sfw1eo5eBhojJiT9EuskDmB72jEPIVf7xrn78LM/z7MJ1l1MLCqFnav++bPPyEJ1E3nJ+EnvzL6';
    b +=
        '2v0PidSaE5+nP1kiRlGXW2tWzaPVFp7e6NjNdis0yo3oZ5lhfRCWft/+eXY8iaB+tToQygXPk9a';
    b +=
        '//FzICkwHwP8fg3GkhxWoKP1PL7U0TavJFBemIjrwUuf1A3Tip8CnvudsZAsgyg6f6vw3hk2Auz';
    b +=
        's9D/4GcY1HswHXTbOzesNAy4svp2SuyTIO7qA+ELI6yFxnLcQ4xQnrZiIl5egDYUl8R4Beag6EI';
    b +=
        '2YuZGbl36hjIZ61egPXhvyD3J9B9I69AHN5N/4PvfpMyym6jIDYFWL0Z0jCIitmtFC8tZj8Vo7J';
    b +=
        'hTEIpt5ND4W51q7zavUA495WcupcKjEdwCTMM/zwtdKa+AIG5cXpg7+QyTJeeg/Rv+OhvOiSWDL';
    b +=
        'G13E1p0IsPF70dJBbKsAY+VWyVVjlKcXvO7AUybLhnjhZ4EtllV7eFHf7kCBO5MpN2UMOfA2aGO';
    b +=
        'I5fZmHhrOIAix4zorNWfCcPu07Kledq2Yx7LZB5ZylKvOcqsxzqjLP6WdPlFbBc1aZ56xkr86qj';
    b +=
        'mwsAcNTrda20ed9JspPSDy+wOkxKx7/jhaX6UvZPLOLXysfrnK/02BgWdSThhN1l1UCfbCyFdhI';
    b +=
        'CxPrwyTTMrGG19WuJt0Fm2TevGKvbcDkKn5hFaEwd7WQsbsVYXd9YXerVvED2lsYunjtpzKP3WX';
    b +=
        'XIDm72xMJg3pZzgbhQ9pZ2nREadKI0JO9b4WiBJzB1dkiw9LkM224QbrE8OJQM8QX8IQs2r0YOV';
    b +=
        'D/ScoQOWXUmmx7m4/g7JRgFkCb+RGjzemJKUcwpWydeDdMTh9JZX1d2VdyuW5VrtuOVVxxM2NaE';
    b +=
        'yREfC8MQWz0yzjul7QiKqLkreN/39I4ofRF0Axg3UPWVDmrdoCa/6KO2jiAV2FVGvPZrvQUisme';
    b +=
        'QnFFPwXXWQp6Eh70U/z55gSil+KxMXbi5zocOvFzZQs6OcafdOGWVV6h8fg1tQ112Ea74zhN882';
    b +=
        '2S+m7samiPV7oEOvzIdIlKDdIO+N0iqBzgW+1AJRc0vrjsK9gtRZYUyxvc2r8UQ9PF9DKF/8XDx';
    b +=
        'fSPntPbsF4wcfLE3e0YZbpxg9B10KxN+NELK4IMZNt+mQDrEKFwEsCeLwvvReBFxugHMbvFLGf9';
    b +=
        '+IdCRz7Ycgg70jUWMfPHW95+bMtLqs2A7MceBBqul728zp+CkzUWQRnN/QugDpd0UcQ5/HPZH7X';
    b +=
        'n7WaJqI4kyFeVIq4mF88vsFX5A8aqyztiWwKbVEhX96csU3i+1t0LI9/l98q87KnRnxRbdHiXkj';
    b +=
        'Wzwo742USiW5yBVoEFX7x5Ax++1mOVLwnZDvtFRCE2c/rBFCAjvehcUEYt0BrlYhdHoZTelc6xW';
    b +=
        'N1AFa0TJL4Oy4/0vCqxIjkmkU0yiZdiJQIiltc7EL6e68X/bWvDA7zCd8SsFyY8j1gb+Evd+L6A';
    b +=
        'lcHSOyn8fZ+Yr3DQCkVqkrVET2rD1Gc51GczzKFFpYPk14hErBnaAFiwWIdYmdpMv5FLeJglbbi';
    b +=
        'v8MhjgW9ijJnn7x1XJF9BfyccPbl46uWfWG+pdXsC09sp/Xsi1fSSvbFYLCi3n0q69UVKqyXDNy';
    b +=
        'vUFXq5OxpM0HjcfaI4Qd50tmjhjXU0sXdfWBRs8Wh4M9nTFFPrsdVf8+0b1Gal6Xdp9BqXPczAB';
    b +=
        'ahZRgH4uINoIhAcPapLKo6CZCO2c+dfIsHoI+YXRR+nBia2QOPz2xgImT7Jm7OXku1qZ3XOIv5a';
    b +=
        '9Hu9BS+WP8v9XfnyYs4olZE9NMZywqUF+h/d2yAYTB75FMzu3JQWK0wzrTUlO1TvKELtrzxkz1h';
    b +=
        '66dzo9AxMZScWgl0uYb+rMwc10D8Mft+sth+1M3GTA+wXTbHrmWdPb87XfeMVVxqiUi8E5F4f98';
    b +=
        'Xi7aTTqbBjdbpD9/ZOFZfFJdX9tuqbiLFh1WZSg/8IwvbRdJ4ufNuPBXniArU3GMpeA2I5SlYky';
    b +=
        'dynnyM1cCA5ifx5MU64flCUTcWboWP+GCs9TXOGjmbSo2P0/LF53joxcRzRlgQ9xrn2kScL8APB';
    b +=
        'WtHs74GOmIsuMdED1UVLh0VqzCMmNdb7nxNOz1OnZG88b9lna3LnWtTfvuHQ0bUqufkXSzNmkPE';
    b +=
        '79BvP79GiY+Wiz9e5m5CrJDD+Am+HKnR4e0Jl9dRW5/zQ9QHRWhbZWaU0AtJfJNMWK1E4ickzMh';
    b +=
        'gRJsTZBAzFREUOqwkxYXYMUb8uBZONLfFZe3v9MDX5uQLBH4DRT5+GhGvFzsAweI/sREna9ARVM';
    b +=
        'Y+SpOFoT7OD4KsYQZrDWyW0v0UkypLsQPfmHPSWfoTvzrKc1/GuS/7wYgt+tslEG8CLZKUn1LjX';
    b +=
        'KxQI70VFXs2eD5h+6qlr6dOZX39Av1em8N/C4eG2DZLsYZ3AeUsjS4xxFKwYl7pRH/vZWZWOtPJ';
    b +=
        'xBwQ6wd+I8bqQ9GhSExOnv4lfofbCHPMrrH6InsEDLL9ge2eIBkq7YtBGm6wdpBs0AXu32Edkbv';
    b +=
        'EZQ+vJnibyIEfHT6SVPnmgd38wMQcojpIvVswN6/Z2wnYfFVx1cNZ+AqBctJcrspdkI3UiNQSqb';
    b +=
        'NIg0gjkSaLdBHpSqSbRXqI9CTSyyJ9RPoS6UPd0RP5IrrUqmzkCyYxZCGQMbIjODWK0vfdf/gpZ';
    b +=
        '1f64ve+e2d7gsXmSKwisdqZSJvW3e/ae9cEjmvQ0nKSyg3WbCzgwyoQFv+jOOQRu324OWKVf3lq';
    b +=
        'tWpByJGo+PVhILEtcmQgFXJ7XC+AZYalDR5hEsmAL0yZmL/wO7we5jIn3QCGn9lpv5C6855BPDf';
    b +=
        'rs/g3MrSeqHJq3OvoJpdluT9vd7A0yyS3YHqdrsGVWe+JeQB2aWZeCKSsTSOfTb6XGRfzIDljMb';
    b +=
        'enbf3/zc/EtbPq/xfXqrtEWnuHCGvfKrLaN4uo9qfmSWoxloKFJbWhldQGvSS1EIMG0UuQ0g7mQ';
    b +=
        'tqVIrNLRHB2szx7WBjh3sICVlMq9k/nXoxN/xNIRfGSh5v2tdP+eGUmU014ueMXOMrpy0Wgaq1K';
    b +=
        '3A51SJan0up9UyTy0Jvwhxq/Qt3CwtMkk512wcTFb8GvKypquawyKWz9hqzyCssqLxNR5WAuqVy';
    b +=
        '5UE/FPaGVSQ7mIskF86NzzzglaSTsY0QaOatEGnnEU+FMydpcjfMDkqKKwFqn4r9Bp31sI5BRSC';
    b +=
        '6o2VIXxvdh9vAtyrHurLG+HVzeb7BiWJ1aP7EeE3zc4Y63KjAI9sb5RUj6CdhGHkqsqTyQF0BJA';
    b +=
        'Na4ZpKG2dIJscyFjSusJbkQYg37yOF25cYbmmKTImagc4d4blBcxvoQxLWT1K7oZKvYAYQqimce';
    b +=
        'cjrL6CjzI2Hx4YrdPAXHgQvTZkcEYs4Aq0M2MXThtlsedRAnaHBYAdQIJvDWixlvcbcqbXvXrMT';
    b +=
        '7jCChkqrXs+olIcEXJASCBFeQ4JeRgCaBaL3bilkIE7b/9gVu18oU5PlJrh2PFisuWPS8Ozc0ON';
    b +=
        'iAlLaqCssMNXg9l/VWuJ/K9tPK8kr9ZHRXgCOW34VJgAFGJcabntzKy7vhMmiKemYYhqx5J/qCp';
    b +=
        '82MN209tbHrjPQ4+4qQKQWm6nG0fHovuKqjCEbDelI8XtzBs+MU7N2PIQUellYn88re/+7usnqB';
    b +=
        'snLjHLZ8mdmJ+OPH86g457QCdtINDz3sT2opR4Z5JDulSjiyIu68zaVUWXXELEXIaWKureHCtqY';
    b +=
        '1XCjMP6hBW5JW/DX0Q2WvY8dp7Px58Lb0Fn6nWR5ZwvH4Fsa7eB5DDYMsOEHQxnrxt0F11MCMWb';
    b +=
        'ZmrmnHf5z1+8+ACnZyZyM+rQU3Eh3/pP39C9em5wEuCZ9dulzSZoFNzcdVBl/RSgYuARJ/2lgHw';
    b +=
        '/x1H6+5S5p8lIl5aoUZEPe5rBQipxy+y8p9fF3P1JJKM3ipf7/ulhBhMQNLWfscJ/v5QWwL6Cmj';
    b +=
        'z8PZ/KZypw9mAUCJruGPslFK/Ofj7HqEhhorsz7iiQPCOFdmlZdujfistZcRmJyJ6byPEK+5KrN';
    b +=
        '7Y5m8HAwxMrHc127DqtOhf7O0GbJkiO1KTGk/v0I5DePozGOOx7Za6ROiBM6iArlaSE988AkYEi';
    b +=
        'VOxt9RoyzCug7i6znHrpe45zLZrdVrxTUXiuYsHzSvOAbqWBm7aLg6L8paYWsuJQbDIQOFP2FRQ';
    b +=
        'GUqBNQBzQJ74VNxygTTUn47QPrIVxLypVtQRofOAjTOHdZ5H2BPvXz4cGB8q1mBHR6iOIk1PxzR';
    b +=
        'lnJgaiR8P7jkpMpKSchD7LmXeeBmOVw1W9+Jb8ej5Faaky17VvccNhUObCrSoZ3UC+byRSw3Lcs';
    b +=
        'kzhDs9cBFVjrv3CE5eeFlL0p5YXZmskMk5QTBeuxKXA3b7LJSnkBW4FJoCZYV3mFobb1ebAFdkf';
    b +=
        'xhzY2+7Im4JxlveWAlMJT0TrmuceB8+IxK2EHDVY72NI8O9k+j5Q4Ul9PsNhgLcgUbP/GhNTEjI';
    b +=
        'Lxo0ekJcMoc1Ac+meLMCGs7Cops4P5Ppq1QHqVOgvg9Cu9bUBy6GYpfBcUSiQCaV75Isqkwxx7A';
    b +=
        'q8L8HHziWy8M2OnWD4jjNwfSOY8fr6UfMC7DusZqhhU+TF3uxOvqFYEWg7PFjkJtuxUrCanI4oP';
    b +=
        '0+FfYuh/dIuJSuSh9FDIKmlOuKMd7uSs3z4pIlibeKDvN89JD35xj/WqPVzwRBnh8Zr7GQboRO0';
    b +=
        'DPPhIT93tO8Wiwx1f8DhegYcThEOj12GcBg47DpuQPBYgAuAnB2lZgew7hWgCt2J/C23lMPekkL';
    b +=
        'w/czYD7WMGZwp4eE1n60JuUsJmeQuDk83CbSEsODbO/+RuK+DLNs+co7rM0ccx18ahFrnARfL0T';
    b +=
        'su0RDbqHCQ3xP8O24Pe/xs+RPP7NzCiLicB8aSd8GXSWCBYr9uYTIQL1864KZtj2gp8TZDGHJoZ';
    b +=
        'jPA0mcALYwG99jFs9TsOH68zXthiaG7CRxCoRMsdxNhVF2OrlPEtpF7qeGbuZNjgh9qMdwvExO7';
    b +=
        'kGBbozTvfMuGd+xj09M07NzzjVM+M752d8Z8+MPzU/40/1zPgOQkRXxneUM/IdUwWWWkHuroste';
    b +=
        'EIpwt5PbsO6iakvl/u4tryrLYIJMH93sTK2uwvzbBdVZgUycMxlEzwkeF3CmHX2KGI21o0Yr1nf';
    b +=
        'WVZY5vNmGsibzX6mzQxdV3TIy3xjByUX+IHY2QQYEyLO8TmIPeAXPVW1BitmJXvnayfKenu8xhl';
    b +=
        'MjJz+Xdg4GMhTE6y64vt2qfzEnZ6JPTa8twrj68SlAG7kNbghdr3dZgEumB7aYXA2EPURcWLDtt';
    b +=
        'd4HZT5CrbtXGmZCtd68DMit+cCrPXH4qumCPT5xl3Uu3mvz4zvRRSfepPs7kVgeC1AgFWr6LI4X';
    b +=
        'bA4nbA4ZViM+JtiidYyeSBvkLkgtggZTd4LhMERpigOcOdxu587+mDdEMZSw9DGw/oHZpKtuALa';
    b +=
        '+WiPq8EVw/fY2UmNOSuqyJKWvZougSMRvgehHZBXiU6dk6xenNFYh6DCRqxZnRVbZ4A6+dWOAHc';
    b +=
        'eBkoESyk3EqkkdbDAOZUGwnWG6ZDfdm35MuocfogeYv0NcqRi3LFc30VN4JgG2NEr85EldFJmQO';
    b +=
        'GI7Shf3tzrmWBGT7NtePF2U2JgU5zoo79u7YgPvfbXP9iqlwyM6/MMjOsf4SkM8opdAhjydAaaB';
    b +=
        'bAzrpeMYcWxc/ZoCAQuIV4ywivuh0wmu3Ht0Uocw/AJC6JAmvZ3tNhGfyA9eJAW/M/jGHFZW0Y/';
    b +=
        '5R4kItDPSjg8JsTw+VSLAxY2UaWxfhvLJjCp5S3ZsnX1/oPZJsKHjSD+Cy2NVyAijZ/pbENJG9U';
    b +=
        'kfARemDM1i/xMWE1YxoC/GwfSB37BwiuGylxRVSrypCIfP0sxPXHoxwEUiua6LauZOMKw8iqGr0';
    b +=
        'tuFY+YJJGm46PaPoXRJ10hpP8FN70UtMFEYSZETzaDUadZM4URhdiue+vYuyDLbjRw5jPOtBVly';
    b +=
        'AkRtdkTWJC5c2RFEcCo4nfK9aVeTQBG03jYp/YaZsGmeAUXf2v8WFONzYb3eUp3LJN8gb3PnMWy';
    b +=
        'z1zuMMclluqAAYfr+MvK2rNUiFtuQdzvppevxxtb6dfg0pB+/4cD+0w3fd6BbaSbfhEX+PT7Xfq';
    b +=
        'FoWiHCx4DmYC4Kg3b8c9rYpXZ0pmXSRX/JU+1kBUBBu2hX+6NMntsgYs1V/4KjDb07NMquCmuBP';
    b +=
        'G/iXhcssUfdXmFabnxI0bKgTv8jzzbraeClaW8FgwnA2Nd3YvEcN9lb5OcB75e30XD3I0/pfAOO';
    b +=
        'HW97kt3fo13G7ww1gmLVyp7CGVNqaxXKjur5xd2S4U/3F3YLRUO5iOBbcej+fHsIPvc8KvEynSQ';
    b +=
        '8xHrbFJvXn18vo/3e6IkPiRnnFOubNdxl30pX6cJC5kZ/hje+opDuPgTUpnTHWHFs62OOQXxC9+';
    b +=
        'SBw6gYleYxVi1RVrx8fw5+zKoir29iq8REaw1XvG7JQH2vAo1vXQIOnSsw8dKelrcUmuW9VOrzN';
    b +=
        'r641DTY/thNtZ2Zc2qEbvVWyjA8kCWMgIiTzqYKZx6qYYFeSsqnaYje5r2RXyNFyCqmTl4JKdpP';
    b +=
        '+JzJkuHrdyQdkJXrJGyV8PEIgkPdMNFXNP6SIVdy0TDpbO8w/qFLvseYH9caje7exP9QjfKHgzP';
    b +=
        'pCBWCZCFpez8HpsD3iArVP/slZpmpCsb5LO9cIcuc4BYczfIHYRtorOWiOvnPHy1J8qDcDxlBfr';
    b +=
        '5qdqL/toVXaU5p/sBRQO/xC15+wa0fFX8Mwq8H/rI76Bk/o03ivdcayGhxNMkm0couQ0UV/9cAX';
    b +=
        'UZMo7DtNmly9NjBzN/7sp6Jj9xMHPShlGI5wE80QDA404idaJcX3EEFog0WYT3Z3ZXH5TtaClNS';
    b +=
        'dNTvwqLtfU1Y2V6tF5/0OUdi7cTFu4RP/Aa1hqAmzyfFuOWly3HeLP2V2dkdb5wA8weKeJTRQQ4';
    b +=
        'YAS/QkyYD+mUn25oy0s52Gh5741/lXgn64JGZ/JDCwcWTt6hQ8j1M+80+g57jQNpOY2Jo0pkOHn';
    b +=
        'ELyqrH+EwjwokDI3Yl1NYbJjt1mjnb40A9hvYYzEkLAvyXM6CcHfF8lE0UO3rK1lx195+eXBnk8';
    b +=
        'nehc/h/dnmZ+sB1hV40FO+Fd448w3nM9GK00O0oqxoRUG0oqxoxapzaitaYaM2NV+0guHGnmzhk';
    b +=
        'w4afale39IDrPHDYwEqDi19uePyckprGOsCQnnHIGxYu4yYBVeeWOqloMJ3pNTRyx0FfTN5pgW+';
    b +=
        'kwwLccy6OhZ+fT300rJ1O3tTBasjpwXiNmYBBRgXkDG9HZbN5b3PZB9atgbFsg+nS+LBzv/PLvT';
    b +=
        'oesEmV5BxRu2TCaIgIz43uVLWj4FkB9IfcauXzqLaV0mbDyM8923bZkf9mWgpr/y5b2eVA9hvZ6';
    b +=
        'omZ4Pp0He6YEoPf8cKZ87c3vF/LrV372nb3idcvWhGTYsbpEDGTY2FKbjqhMFkiBQWCOPfxoFWD';
    b +=
        'Q+T1dl1Ihx5YIHv46W4GbPSTvMCebmKCjQSf6DVj4eFk3DjQLu5iIINSOuSxsYBSsP0WZx7Oepr';
    b +=
        'LcH7XH3i5sxhLyHoQ03eVk8uICj78JLT/lF1z00scVrSbp6XLIY1pq2jwe9EJBFSGsmiZn9Sb56';
    b +=
        'fVJvnZZo2lKefL1H7gB0fq3M9Ss7HtGngAUOT9AOq/uR8/JxPTTbazZcl58HZ6dLkPMz78/iFLK';
    b +=
        'p+afIyil7PCv7JkoRYGKmU+Nm42WBFVFwMJwhBWrj/hL2HQFPpwfxrceJBSbyPmpL3Mc9Do/1QO';
    b +=
        'AAIDUDSSM6HOKS/3GA4Thmw4dhmXUL6krbENfuwNTWo1ee+kLUD9HIb6ek8LkMEv2noNRuIaQBm';
    b +=
        'xftyn7gHpPV6CdgZhQwOMjjRP7vKnbGO3P7PdtA43z2jjv6lXTNeL6t9p1/Evn8NX40qJ1Ikfo8';
    b +=
        'zfMP93r+Ei70vuapmjwx8LcLvFLrteJ+8FcMXlDO7IHJA/XKThfdYMSar4rIUbCydw9PSM8W8NF';
    b +=
        'RBg7rcNdTgW9XgSTjN78qyKQB9Z8ZYIjFzkZI+/97C0y6P8zr4qEb69Mk5VgVr1ZlJDVF9H3jDO';
    b +=
        'KndwCbctXX2JW5W56+JP1cckGxD170+u9mLrZfkJp7rxbGqXXfF8zh/lLS7pDQVqI3Hj/Lxzsa4';
    b +=
        'EoOdwhV9kVikFtKPUB7aTZ/NetODn6yLqr4Kw1CHxrc3mHWrrF+pVHBLcN/75rB81yEK8OgHWut';
    b +=
        'h+nMciwvHn5aQG6XvlRAxyO+REJ0w3i0hGhY/wyGA30g1usLWes/83RN3m2GAT9F9E+mTFsnXOB';
    b +=
        '5HubtLUS6e9kx97jWoSyMgBolqSR9b/0XpU/tp0x5Mn36vZQV/wRXG7aSTiUaubWenTJEj87t5N';
    b +=
        'OegW62vpnnl7bazjxhccTJnFZ6s47jy4XkInnTZVZtki5+3fvUH22xcM9SOfx7MMBZx4vM/rfLa';
    b +=
        'Wm7pfbBBqSZhGWT8EVdyiYAS8or4Izp7kYtrxC2+vLjFDhYwawb1Mn457OFSYXl8Sx4Tm7NKW2W';
    b +=
        '3dDeNmOtkVcFjM/JmAPeTMscfcEVVo4ZrVnllAJ4a4SlfjQtHCXd9/JCa+DjkdUvOeViR17FEB6';
    b +=
        'jx4hOaz1bC+IV4IsbbKfz8lNwguCKvDXZbHQqcb468Z87qd5ZIMDfvwbrrgDxLpvgxLZ4iN4hsf';
    b +=
        'Eg6RXRzd8ZfZFGFKP9+0hVPWEfobBzAY0V6DHoFvw3x4Rp+xSZ+TLa8YFCvYbUqMSMOoJBsmw+S';
    b +=
        '4FJ9LUTpgbz7R8fSOOUrPo5JT6HOg9A9Ou7kGjcBtGaupbj9++ZY/TqAfOxBherwgBA0mwOuZFg';
    b +=
        'fEnji1dICa3JwC4O2hYP7pIXuuo+cue7BrroPKNu5pSXsons4ix5QUlhyDHbnoMFrq5KKJDMjLF';
    b +=
        '4LqzfaY+IvIIeDlwClkCOFMqgOlCuI36v4lZyA36SD4jOh+UElXlA9uYsW3ZOAlUU4QI39iZbfP';
    b +=
        '8fvEVEZkYvMa9Hb9EN7mbmXvjyDj5Pvzrh7joz/3IUUdoHMc/ts5m8Z7RKbLZtWSehg5VNsjQtF';
    b +=
        'LBbXpVW2/LyWJV2F1bojO2YNxoaUtKS4XfLl+tW3TlRZ71j8FeH4tJQz89IRsdo9X0ON4z5OsXt';
    b +=
        'JNPYZ9huCuwB5vYkSdd4I1W9y54lS3h8XjWoARA3z05RQ0kER2pGCtn07mo/6Hid/RuHIGIrmPi';
    b +=
        '4iWuFDLDhwrxfn7kvacPbiwJepBdwv3sFOwhEJoXIGmW3RZB/jVgN+/QbX19k50M3PgcdPWUKkh';
    b +=
        '/C5Ir3373IX6LgR1aWuGahMGnkDK0eOaPrUejZsBLPMzvBBPGRJCy0ZX8jJDhXqTvmmsjpsE7zc';
    b +=
        'JKyzToMcphTx7WI1hO+mT2X5JYdZ1RaWWpxKM4kdkd3Sns2eRfyHaI/om4AD0w0DiQcPg5DWjMY';
    b +=
        '3cyPTsOfijPxEKWU7pJCPdsy2yFGmcenoj87qmyFiGw33w3viOr4MYX+r7SYfM+9WN1phV/otGD';
    b +=
        'jgrggGE3CNHV8pUL004EfOEfaR/+mgszwBn9ZOoBTWVqfXiY4a5c1069sk4S08D8M9CCmO8vckv';
    b +=
        'sT6o2ofJdDfNzFHB77NplCJlhTKX3zv6xXAA108Z41cg6v8eV331aqUAXqt8sQ6MdORtb5mWwbr';
    b +=
        'BClChpq8E1xvRvy2MRaOtXy0rEOtgpguxCjGLpXGI7JyPo7AmAyxI8z4BffCTCwKRwirxPuRSld';
    b +=
        'RqXSoiYdFoVTFQSXljC0XiXPQzFeom7npeANbNmkcgytJlVtnL1N8G8HzjzW9iiCLrrXM1zMgxu';
    b +=
        'b+khHp71DunBvGk7WWa+8aLFdniytrSweJG1wPq24HKgplvQZVyuIq4d1dy7L3ehDYi/d6zdyPc';
    b +=
        'HYmE85Es7FenHkN7mA6BS7cu2QPpyb84Kidy9S7fVpeKv59I7DqKG+lR0VFKz1A6G5F7HT0FU79';
    b +=
        '1U6dMNOHUn1tq0DsdNXiSC2iEE/dBXzXODUYDP8owfqiEu/I6Hl2oRT9jVFBcZ2Uynt3LAt100u';
    b +=
        'oQXuRE7c89iiWiGJSereOt/FJGWIeP2sbF6d8jVFog7itzEcav1bVxIuXTShSFo+zOw03oOEQRC';
    b +=
        'IXZ8ssPzVNBYdSJs/kV9ihVAU6jj4cShlxKKXgUIpO4HzhkLqUhhbEoRRuq0zmUCoYoDRezUO+X';
    b +=
        'GaHUoZXT5O5m4OC3gD0K3Ax6NkbF83OsLphB9zWZ9fCcAvkJZ9dFjrTBbku9aoMLjtiCUo+uxYG';
    b +=
        'k5V+jPAQl3Bk0+S3OCZ62mhfttakdIOt4g/q0k21PAcot9JD12evp0BfF+oaNwr/gicOO9+AsU6';
    b +=
        'y9KgTv0+Jg2U3vVGSxetE2hBnp+x7+xc0X3nJogNekI/crFjsZ+35EJ2ypsZN7UdGX/z/2HsTOK';
    b +=
        '/m/X/8bJ9l5jNTpwwNM3HmIwxappqtkM60l5SkRGSappqlqWZJuWkmQvcKRQghWbKUrksJoQhdu';
    b +=
        'tdOyBU3ewjZU//3a3m/zzmfmamQ7/f3e/x/HqbzeZ/zPu/tvJfX+nzpF2clcfAUU54eKJSKqsbE';
    b +=
        '6aALs0acAPmSoEHozhXC4I0cyNJJKrrhwY82wd+hcFz6ksPQjCsE3nXidvIsx8LqZ2YlIfOrY1h';
    b +=
        'emww+klzdXq1LiDc7laO4m8eb6d1MWucYsV6iICC/lCb6G2MqmxSoZBlg8ZAQc+sfr2sbjVcMV7';
    b +=
        'RYvg+busW7c6gdxfuUrpI+W7EwhWyqL0fkBfDRolDdYQwohyQk0ud6Oak9SQct8my7X1B97xgUz';
    b +=
        'S0MEiFQPaGYSNzcSy3mvmtBGUrY3UlVsBceFg7eIWjiHWHbeLGH6DLI5R40OgZpPkWKB2dBUnPa';
    b +=
        'SEjbfzfgZRtvgBAgnE1qb/s0tPSEzoVl3GQnJA1TMK4q7JKPGKwlI9mJXY7vJhYaRZpe1OYVGt1';
    b +=
        'XoQZqZkK07y40jeR6YxYytBjsWUUsosixYRrzCAM1JmH4kiiFjwAbWECqQ9yWUF+0ErSQTCFgJl';
    b +=
        'wnKcjxC2pFR5GZIE/cbPgbkAHeFi2clBVZLYu0LBt3yYjIblL8BKR+WiCanei5jQYyM51kMJNpO';
    b +=
        'Wtm3AYjGRvMYmxpJMP+MATPKEijmeXxFKjQEjftZYA1Q+7V9TWOYC8C0W8FYWWBYT5H0AXJB8f9';
    b +=
        'ChMijx6Inas7MYBcSQJV9oAMsSOkUsx4GCBXRlcMYcspEKLOIkwYiRi0Ea1gEbDHV0qMI88nxV5';
    b +=
        'pROwo1oP5Ts2d9+h6xPIRlEwmylXEDMxEsYGYqBYYcVgEqE7xtiE7r2rc4ZBfRN8hg7QdKLvUSc';
    b +=
        '9ngZ6M8GqBKzLZScfwEAtMEh/giStv8WmfzvJsMciLwM8fsqKbP+3pKcA3wspZJx6uKHIuLTLmF';
    b +=
        'Kgt6FgjpYBayZwavoEO/CbxeZ7ZnvLfxw7hIa/1kWcDuvGT/z7sidJ/nzAwkedDvwIAy1EaVg1G';
    b +=
        'UGeO25SWYaYv3ne2p9kzCQbZZG1juhSopZO20X3zW8GwHu3esZO1lveahmA9ZikjQtLqy3CgCNM';
    b +=
        'iuKPFK0T2Z2GnyyR7R7Z3kwZpOrn0EKdKsU7d5fDOc2yqHaLsXDwUjKvVsxiwvwTDbbCoi5NpXt';
    b +=
        'yowCDCOti54Nu4F8Rx5uJrIOwrUnhQFCRPh5UIi/JCJ2lmPKkHDk99eZbpLUcU9CUVOZdRcBaex';
    b +=
        'ElDJewe4CftMIvqycAvhSqPEkAXDAjiQYDwF5Y+VeEvNJm9ju2z2MA2uUgbloq7pdix0BOElOro';
    b +=
        'pEiaLRmG0SRCZa0YOTfX3bFCGneQOWDselh/gRjTQD4wfA8GdMbpascJ5pSjI+kIZGUikBXGhtk';
    b +=
        'XkJXZGMhKzAJwNMUgVTqqxANoVhqjWcW9EkX37HicwsBiADYVwRLQmqais6XOqCgodK6YCtkM2W';
    b +=
        'oTw7Whhzo5lkMbYGMCF/MKpMNZFSg+CWAUAUvFl97KLwCfEs4UOMaSZAVeY7QtNXhW+WD8rAh/Z';
    b +=
        'Ej4I+SHKuIa/6aCCatoHiJZIWSRFnuIN8b5ugQsykZXODRUmCIoP6vAnEhxhcDow4AI9SBBN2C6';
    b +=
        'm2wD7hCYkonGo8puFJ5MoXE0cCqLAlMohOhmEuObVB5K9PmQNcSeZ04sMM8Uj1gsvBliK0Kzbue';
    b +=
        'U/Tq0DyNJgizzY504kqHivHEonLfYSh203BJ03Js6bcNcdjqVjZsvoGjcZMkqYGEC0Iz9EM4bf4';
    b +=
        'POBD93yv8a1+1XCMhG92e/K1/Jn1DJUQS+sT/UJY8I3V4+G0xzEf+FqMS1s9cxNLyqqZB7m81Xj';
    b +=
        'BYYu4uZO/KHQkM3Dn4GVBg42EQJkI+Ie8igzjtxVgNdfUa54NUNsmMDvCdgRuBskmSi4h8IxSNK';
    b +=
        'PkdJzBzEI+ilJvIyPRti+p9wJGHzicY80pbtz+hcSaKWRiFQktghpSLSUz6i+jHaF60Xoj6OJJ7';
    b +=
        'ELEAY/YAj4MV8RB2ESmuYXoO8nzYQogf1r8lA9GTcqr3hiLjACGjofUw/AUEqyY0MAmmT6FAl+B';
    b +=
        'lHyMgYPWkSS++vSpdsiOlE7Wv0FN1Lh+2HdOl6FFtt6np9QqBXtCxzOw9AdsQaINHzGeQ1Qu7RI';
    b +=
        'SQcgHWEzRfMr0xywUOBkE430+mSAiQ3+WY55eTdbZAXV2Y5R0KHRBrjACCl+w0682vAooICfAjC';
    b +=
        '3kFYMRB+q8I1LBwAA6BwAgywZIOoNq8iVTbI1NHSFEsXxQ5Opdh2YvvUB6OhVKScDHVlFQ5XATy';
    b +=
        'WyIjaLZB+q5Y4qvGZqvHAa3OElx9lhBd37rV4Y/m18sZauBF3t8obVGc7h5xqoZUWzH/lUQPcW2';
    b +=
        'wery+2CUe9phXUa3qCKUWtKcGUksxIjSbsFXjUkncETHhBm3i6zSd0WWI87FNtRqV5MdAXpMcEw';
    b +=
        'zvpKwgFoN7yakNJksIJEbZspaOU1upk+rjuH6AHMAjKjzWRSUjLwVmPOlGNrHLRCjNM0cCBE7O3';
    b +=
        'IKoSwU+IdkRrnXA1fZuZGMcMjebAT3EaW+zLwTIDzgOeATUNp+ClPPWjbu8xlShr+Z8tqQSHq9Q';
    b +=
        'DKI4j0tvwt8pQrUoxmhWJHkhZKMlBrT9JDuoJHHFb56hr+LVuNMlXF6yKtXaabSPMqnjrPtNv0u';
    b +=
        '6oIJzt8o0T7VaYKx1yEWyqQRbTQGCeWG7PsWTUTgNyt8bctsydRrntZnIflEXHLueOknt7ii83I';
    b +=
        'TtaGflGe4SNRbSUfmBTrAGHYlUD4d6HiVTY6tqTLsL3nB+ciGBwup2G0VZkBXAUfvKIII1jdst8';
    b +=
        'I9d1aExAyQzzIxcMGMVJ/w+DrPItOUjk2Qbb1IleWyEnXnPhSpxd4BYw6DFQQ4jPTnWjIa6jx1a';
    b +=
        'aRoRkhX5G2GSGz1I+/CijI1gSsB4iPC5EVo4CDxGhY1mcx9tfJvMS5HnVYctHaGgA+ltY4ByD5C';
    b +=
        'zMgp9ZjpiEwJXgihnvq94m3rhV4xfIggODAYhPs1zUar+IKJ3AXIH9BhBtXhmwsnJxx2tMhLAzY';
    b +=
        'x9mgFWhm/yFsvVHoFCOTQmhO8XWDJ4PxC2pNZ7MjLapylzLZZqgAkz2laUVaYHXfNwxCIgWv8xW';
    b +=
        'ifeanok+kefRclaY2pt0uRWSeFf8SELq1wCSzCQExWsNQlKmIQCiwtt/xAvJYhNtTxI4y31Xij8';
    b +=
        's9FyL7L0Y8C/AXqAYFl4CfmklY3JS8xCVk1ciCUilLJRisXbQWiF70EFrTV424qTde62ImwjWTC';
    b +=
        'SLBkH0uxB7A/xS99Vt2bKLmWGwWd6I98UiZngN0jLyHh5stc73fFJdKJXs3B8wySxmh4ZmMQBbD';
    b +=
        'bZ6EagepwP4dUaAVLN9GOKw+wN0F0pQ71wElE26y2CYEfd23w3091zMNyKgxI2AUWAmAQAQJF5h';
    b +=
        'OdB5DWTPgvB/8jewXOKRSZYuVoExGqxobliPCFIR92cEA4xgEfnGRPxlK5OXKMICSsOaQipOkAL';
    b +=
        'fU7Odcgo+oIRZET5JQh55JLYRPklUWyxq2WsiNVuXpinNtF+2eNuivbUYkKiG/oa2L2m0vDBa6i';
    b +=
        'bdj8pr0wxthYsCrJgdireLk0yhk+qxhPmm+5ZZa/cdnKQIx5mO0Ye6a+lI9u9BZA7DbZNQcEJps';
    b +=
        'MZocSFz9ndeZsRagkRPn2rP12UFoKxOx7LoPLd9tnfIrCLdBfLvy3WAqs6RWj2HwmNTO8Du602L';
    b +=
        'UVvbZVkEtglRx8DN0eDbiqV1ZCWq1XIpmeTkIz7u3ReJje1k1mYhCKpYj3NDid31FtU3hlhUcDd';
    b +=
        'by4wLxr4WRgCU5bsiU6vh9zS3Ybc5FXj+adXVXEK2lr4/eS3Km7Y/eaOU196fvCmUN2V/8tqUN7';
    b +=
        'o/edMor7U/edMpL8R5SAfLQy+vrvLqnDcTQ5vP1uO6vVxMIOJavVXROKAlqGtNLRB5EeRyur0MB';
    b +=
        'cYW0maulq0t/6FnPuvFXe1Y7Y4fehZgUvxeTL+NooUQ3NYoQJMiDuGYjbuAQaKQduXu6yQVKTIL';
    b +=
        'BOFluIt2cNw89w3Y/zDoIq1tA2WlsJJkIEYKppdNwfRw6wb/dZMWDoiH1lMooA4ameec6A/1CJW';
    b +=
        '99qms7E20wIY+OzWAhmzUxjV318/r2KQxEx/t2iXT6aoNhaqFUX9ryMCG8QhkpHqxJH+wsqS83n';
    b +=
        'uG8laL3PyyvEPHAWcfGPntlhb7zhBcK6AI+GQNoDCpxaAe+M3Ft2d7GDx52CYGomxkpYBgWAxDX';
    b +=
        'PxOJTZJA20KwcsmAWZFKqiBQO/kRCmUEsZ8BQdLcbEGob1KcjnLmw3aRihEM1gTJEuT8GQnxhg/';
    b +=
        'EaAiGpUK9smpgtL61kIbHICzQksXtO4DYAYMF4Fhc3XqLrpVgkGPFFdpuEbc9Lp4qosSn2RS1Iq';
    b +=
        'qgdpMdfdoYixqIasOxD34koIrlw5iCh1eATtIHW3nsbUgD3fnX78eMF8WLZWyBJFlauwhpYeABc';
    b +=
        'PyOFoqFmFEhxBpkCCHCJ4HA6qA2C4K8bjfBfur98Q/okAUrmVQ/OIMQS8mOtzSKyhsivqicniF3';
    b +=
        'U3GXP6HIKZCjQBMHvaejdDJ4723Gd4zE2skUJ4kcqZFBNc24pJb7q5F0oFEPuKfNiRlAvCKdCB/';
    b +=
        'jzXSwbZXXIFSFhc7C4N5ddCc7loh/BLTGRZNCLDkssUlGY4kgtkBq3KprLbzUxnwiTqGaVDSpJf';
    b +=
        'LLhG4To77DvVc/M7leJXhGCmSwQ42DCbwIblsYitMBSmFAOL21SG7IRRHkg2qNexbQ3A0pge0Fo';
    b +=
        'JBfcrqw6J7k7Nk4qNMeIRKBvFrt0kxB0zbghyCLrVDwBcCbbrblHmowN0mx+Z0514tTsfZQMy5u';
    b +=
        'xYIbjFsh2HxIOeMVH+qlCaImskZDglwaR5u2bcg+Syr0Ypmw+YK/9SzRpBrBHeZiCgkCwOB2lHo';
    b +=
        'iQEnDCodqARgay02B+VeQ9ANikSHd0HaA53WuaYdDVyTaoGFdYH5Lg9JCNsl0m6DYV8TUuZpBnV';
    b +=
        'HMVT8SgxRrwUdsA3pAAo+sx/nn8Y75v7QAZpFefeHDkCEdzSb2o+8KZR3f+gAzaa8+0MHaGl8Gu';
    b +=
        'xP3nTKC+DoIq/my6upvBrnzYy9YZqG2MpCM73z/vG4WeTMXSY2RYhBjzY/RdrpOM/37HlyTwR3f';
    b +=
        'Y70nmW6s6ejplLk3QOg8wqxJQvfG4YiFKB7JVLynj3axXBfkzgvTwIxsvR2UBNDPeJM5SdDey19';
    b +=
        'PG6pmhwLmiUOgBfORzcp94MnjgKLA4T+uWX9jXvMctCFO+acJ1XRS+IocuL01pOXLo2HbnscJ92';
    b +=
        'Ui5+Mh8UDp7TfwT+cvDQOJuNp0xyj/OF4dEk8CUQeTtJtS2Afuc0J3eYrRuu55Pa4huEANXgvsp';
    b +=
        'RrufXZ6S8l3fj0yUt7r5x+Zdtnpm46ecnS3tbP199www1viZ8MWa717j2sx3utv35K5PuP+cJ14';
    b +=
        '/o+B/lGXRNf2G7AK/DzmjPgvw/FzyXi/7jmtRJas6S3tvSrjrtCH58kHi9B016MN6jdpsb+9tg/';
    b +=
        'TcOo12e5OeILGRLNICgUbZEdDfN/uhkOG+Em/rPgn5A4ucHUDZHm+6aGwY1pJ5i3ies3bLz3JZn';
    b +=
        'CgZ1wgzUV8BLjZLcqbqDHm3sM8QBklgghE0jdOh73VlevnuAa09xIzQr8OC9pc7IAb92TXZC3XQ';
    b +=
        'NFfhE/okNQ//jcMnECHOfedDfAOOruO/eI62rTHpPKws+7xcntZrs/wmWJICTvFNeVhj2mjzRl+';
    b +=
        'eriQgKN3L0HKIRbdiQT2v9WTG79FyefW1BX7kao8pc+qC13p9JbDfPF760TONEgEjfXcmJ3v3L3';
    b +=
        'hTuGDyAL/710EOAQ0eOUTXgttUeGQFB0KVAbuqQ2lDwcAz2z/G6AMudjhCa7nNQQ6QShuvwGccz';
    b +=
        'cisA16STqz8wKkzCM8+9g9BfwjgqjtYMnE/sI3B7Fr9w4vpoTjxCqB4kM0e0K7BrjoXJybcqG8H';
    b +=
        'KhIgwhaiJeHUDsRsDaIYTWDtGZ8SiYIkiwM9AfRBD5QzQuCoYJUVYjRKn9a6H9O1hSF0UrO/tqy';
    b +=
        '4kuIw0H2HpsgixfYwaNtBo/AuyEbp+m1BGA1NykoBs48JUGD7my5EV1CtpkEGO6wxD0g8gUq6VI';
    b +=
        'W64j1pZDa8uUKBo67CBx0Iu7O+9fj4yBeAGsLilUlY4hfBg1Bi2bYqSHMzFYFJth8BMV7+sIQt0';
    b +=
        'wakWNT4cYMvsIivH9o6zmYIAhIbdOBuEg0/AQ6MiR4PW1CbbhqRx5WhSy0ysEkAZqytnltwKRHp';
    b +=
        '4O4T9k3IJYTS6qimAMEelIPN65cj3KhRFndBB+cbDcigOkJnhX41agT22JIV3ctSukIZhonbtFp';
    b +=
        'aB77iaZ/NnQo/XBec9sDuPWZRMgCCr8xTdvn2/k0q9ssA/NYbgMhNkFeqOQ5ji6Bd5gsY8gGDMg';
    b +=
        'ulk7cDmbhsARW/8mJtMjplooZD3ExqIhUWkFMng7OBvzPCaZFcHCYUMf8QCk52FwbcWP5kSHoN8';
    b +=
        'DmMoBhxRC5C6DoA7BVisZABbYcNCSIBvgjw645PMvX6fGiT0s7ZssabQqqA76arhGxExn4BDNvo';
    b +=
        't1NfazIbpuN/0PcHqjHDrsNsgqLg8KyoLm5NuALUqRNuVgTkbx77wQ9NIIBBlod7cGlKaBZuaC2';
    b +=
        'ESNiZ/zNojz3nn9euK8UYAF38uS7PNJUheDknBmjVNaWVrR5ds+vvabNVe9uaZ+mL/KPX+8ylSy';
    b +=
        'zEnJIhEzSCg2sLWGSKWoFIRXYhGEySIIA4WVadQcWwk4zIBUY+1e6iaDb2JdzNjFpoox9pv0oQm';
    b +=
        'q0D/gstG0BpEVKuBgUuq5YwAncKlBmF5P8zkcxX2hyRJEnZ+YSk8ZcLlFJSXqHblM9Ds37NkWhe';
    b +=
        'Y2aJvGrsN95XBBA2Eq8SQ7YEjVfPNdgVKW6P46lYH2F4b0aNub9WHD/WRJmGB9qMwOI36zw/n3k';
    b +=
        '6liotlh1G9suMP0DBEj0hCRAcfxaN6bIaIdNERMl4aIUb8hIiLn6YGjuUlDRO9oNthWHGyOluEZ';
    b +=
        '49kLmvtjL/ja/Wwv6C4Rv9wsd8P9HiIiapU/MGjOB9HRgLDCoxTN1WALarCHoH2zruKVpWJKxit';
    b +=
        'LcY0s5kFoZ5JiNlo5pr2M+DACYTelug7JCDHoZJPupz79VbXElAz8liIrlo9b4A1f4LdU15KWhH';
    b +=
        'rjXFubLCQV/EsIzAPbTfF90BbDrHD0IdQNMcHv0gnH0oyp5hNqHEHwI4QI66/Ak8TVYp8ZPt9cU';
    b +=
        'odoaM3rDTT9stWvxmMQCYyBldj8cOIYhHAMzOAYhANj0KgQIJVJAeF7JxT4zpZrqKGFlI4BJBjp';
    b +=
        'VMOZLEaiP+tPBd+IzrgGKHal7I6MpCVSiqIklZG0GQxyZiYEOTOVhbQgbQsMD85c1NUvtt7gWCh';
    b +=
        'edA8zGN3DougeBLcC7Baix5mJ0T1giopZ7IvuYVXEMV5HlB1NgWYujydxdI8oRfdI8kX3SGoiuo';
    b +=
        'fVXHQPq6noHqaM7hEl87WkvUb3MKmtEYrukQToSqSWZ/qd4nuYifE9gj3VYu8YysMNXGSU2zEgH';
    b +=
        'kal7YKOKIcy9m7g+AtL8issHY2SUfoac5OQZ8MRRsW/36cII674vYo0J+aGIdosQuYi6J34AYaN';
    b +=
        'JgbGwpBfqg5ynUKfcs4t7SWSkAlGHPxAu5xq90MK8SlNDC0wOUTruRY4uOJcvtbAkAusQguzptx';
    b +=
        '7YTgxlkleTBhEnzbBDyqZ/aDMFAJNR4ftVwzJZpKliGDY2SqlaP6/tbNwTiJazjFE+rtJ5TDLwA';
    b +=
        'YMhA+QqSEehcusC5eJiYaBBrZpVWDgWOv+cINgDzpp2gkIvTIL/XvE08oKypeQg4EutKI969/sN';
    b +=
        'AKYQnGAhAiwURw4otL/onk3NQIcpMXihvuAZSfrDTVbPoeeQKDIYBmhhJxEMWCGes6QU47OP7D1';
    b +=
        'ANKlK0sod48RC9HuguQSI3x+xWcYuMBT0EoN2BIIQ2hmU6g98IsRlOTD4vS7yaQgSWgLPBGFCOJ';
    b +=
        'RA1gRJaNhCvCpKXHNZgQyg1ZAO5A3DyU57inw/SnYX7qMGviNSfkyQd7bkzKcSLfSKeKfTVEGwd';
    b +=
        'BFRywW9FiQ5jDQiL9BIwxK7iD7bYOeKEIKAxJmQ5QwnUisHRqXyLbThj/jFIxv6Guh9EixW1Bb3';
    b +=
        'rPwxGtHcFYoQmnguCZbxGC5BdySHWsAmWINYxxs8A34vjEH8owg5gBa4YM5GLBuYOq/R2N0AQ0c';
    b +=
        'TC10MLXILZzoI3F/EExU15oGhFsqsmainXHytteDzvYmGDeAaafpQQU0U2fBn1Tlfrn432Fqe8d';
    b +=
        'CbkKcCB1pkQ5qYisUjkSTkmMpqS1a2q1aH5R28CFt0OMLtZ18uto/mi1J4SnG/1yEznp7i/iS6f';
    b +=
        'RAd5+EVIZM3Qmpw2RqHqQOlakGSKXI1BfviNRBMvV2IPVcIPUIpFrI1H2B1GJItZSpKwPPGgKpL';
    b +=
        '972l/nq2/52XgupHjI1G1JpMvXuWyLVTqZefMtf5tq3/GUugVSmTM19i0cptipAIDNB/NtIt99H';
    b +=
        'vpq/nXxNJN2aItEl6ZaCpJtUn5pM9JqK6NWY6DURdk0SvVqM6DEtgejVHIkayjTv0yDGI/xxid/';
    b +=
        'mHoE8DuBwkuw2jDYTEwQ3Bc7aqFGvcHugsA4VcDYZmmYic+VuXgNYb+AEdE/IL2oH4LdNq10QKw';
    b +=
        'HwW3iqJBoB69zeaYIWWrwCrkNoOhoiVyjUeAuSaxMEu3U89NB0tqqpxb0C+NO201xrKqIChhHcj';
    b +=
        'ky29Vpg3LAOVTg64Yhk3CAWyCLDBsLIJqs1i1wK0IAnHaVBmvJSTkfrb8oMr8ZWGoZZb87ywfnD';
    b +=
        '+UO4V8gUa+gbFA9RkBLR0XL7E8WrasSrhiow7romKCdmTkNoYlHOYO8QqFMMN6v70boAo5iiG2s';
    b +=
        'IPdoiPQgQthw1+hYBMCO7GQHHVnTtIG7XiSinOXCdEdvhDrNIJ4T9FKo/yrGnRIkYRkSQO0iDJV';
    b +=
        'GVVJm/+CRxQe3UiFSKZIbHfnSZOKPeuoawdq5nrvZpEh4Dg68rvMjrRWuJ40hDP7W08jgBymZwq';
    b +=
        'C2QM5vkJ7coBCCO4pW4Kb4jfDCg8u5hAEe0RAHxRQa6zhrESIjFI4u02PiVxJR2Fsp9NA52g/67';
    b +=
        'eh9PfpeppjUuOYfMRF3bTSPaQOubQdg/jsnRAmRKIzDFTQimCCUBmKJItWTX2HSqwI5bRPpbIB7';
    b +=
        'Dt9NjMoYGPwN8IYuCDpg4JWN/N8hMiXc8Oju9851cy7GFqF2P+fZEtr0k2YHGYdI12BNBNg6j59';
    b +=
        '/OtMB2piVuZxTN3NFor+Lo6Vpgc9MCm5smP5F/49UCG6+WuPFqiRsvA2enQLCCTlkSlwnNvhS2B';
    b +=
        '5h76B7fGXvWUEjMihxyaeRamTKOihfKOZWUIKhgMAkp00eZ3WkQ4rHFJli4GYNp6hXgMQXFZqDI';
    b +=
        'KL3c/hmVgRqhriNHRgoq8D3B7UtDkyyYfvAVDPxnQEZct59Bo1mDHGgg9Ix9B1eboqqNxiMkZMW';
    b +=
        'anAjaKCL4lm7fapDeQiOw9zCV8QuyOvYzIXfdfLEwn2WXwU/A5mLzAglrxlndudAfksA6JIC9yz';
    b +=
        'AMsvghBzzPxT/EdutzVpIoL8SI/WHCVkAQAZSREyCCRX7xjkk+xCEwQjARkABEdyxGZGAGEt2Zu';
    b +=
        'LeRPAdkeiswkgbJ7ygwi+A+TdwTUY4XmcUivChsUVHp08+SPDhOme8Lu3yURIdCKX0wJHSU9zoW';
    b +=
        'As4s9wR4VF5KIM7WQtFr9yh37Ur20N5sUGgNtrHBFYqACQhdLRU4LUySLusKtFlXoM06gTbr7mu';
    b +=
        'M9gzchLvlZwUSDfjdBhn5kLhcMPAGSqFwRUNT6XT3H8OJONtQQgdNJ+tWvQZ1LPIOLrPuZMvhQ7';
    b +=
        'nWFcr19p/VhMFYN3sJZK+A2qVZS8tgr9MTYtOnqNj00PEISarRGd6bgY2kz+48n8e7ilCDIVPQ9';
    b +=
        'QsmFzqViMkWnH54Gpt0Gmt0Gpveaazx9NPoNIbpJ2Ze2DuNTQjtgDOPJk3YdxpLqS/ONycMcydM';
    b +=
        'kmMnrE5iCF6Ix3AkcAybUrUIVUSoCircXxzgijU6fWP38Qxs4oxoTn48AJkmdRT8RsrW9EuWxQK';
    b +=
        'XYuWFpidW9gmTyQOKvUISSenmyeI/RrKjEwNRxQ9ZPvnv84aeWk8r5MdH3Dhi07l7jsg35j7qQl';
    b +=
        'h0d8cj6zXWdvO+HSdCiUNQE+2NrsaEVW3R9ufq0+wVKCS17I+B9gg7YXteKB4hD/ZIRXk8IkjTr';
    b +=
        'Kh9dyieRF70yezon6XQAFKciL3WImC5cgx7EYJgR7FyJ6W8opwj4jE4M8S0h4CA0xjQOYgWHZPt';
    b +=
        'E9uyvTxERdq1CvwZgLRDBKQt8ZdDIJY0yGxdKutNgO9DyGYxSvjPoAwcLMeI3c8TD/zqEZTJflx';
    b +=
        'nrsV+1SLNs0EheiX6RxANxG4SCiRKIKziy70IxUEMXJN+NlAIW8avxUz8HB/drssINoD0ejpfX7';
    b +=
        'f4Mf7YIe9spR8aqcezIfCvtOsnIN3scg6EY0hkJLhle9b/CO+L/ANZsbifsGu7SVIiGAMeCPJov';
    b +=
        'yOwUP/fCm16hf6/UdqfUVoHohBXs+dbsFmJCzEx9f3Ez2pOpgeTacEkmHfOGsA3yEbWre8LDwW7';
    b +=
        'ZU2VD+BAYgPPjx557PW/wBuiMb4c9Co+HNTc62Dz+di6pT9f0Nzr+LDZ18EMdN7j/9zdbO34sNH';
    b +=
        'rBPe37qK3Zl/Y6FlsPjD0+ixf5BykW3TPqUkPYEhQFBKSBSFOCuHE6KTYUYZLSRTOAk4OXWG7JQ';
    b +=
        '2CcGAripJnxeEgX+YiLEMYxPcW63tMf5iZuMHW+E0UFFKx4DEoMems6ZUYyxdNMqcDKgxFjgZ1i';
    b +=
        '3+xvTg9AoqN07HbeOW9pDzFCht7ihWSp1g36SkW5TDIfk+xE/fuKdbdjVM4l5UW2kAL/n6FKbFQ';
    b +=
        'THuUtPbDqsjvihxOyL8Kj1v7bZ1dXPGaQraY6P1yYsAFU3o/Rj3vR7AYSyGiFyX1a9hhi5RJ4Ks';
    b +=
        'Fvj46LT7p//gSWsTd4LeIMNqx1o/thCy2ScwiFza0v3M16WljRpWzTBrxYjbFGuTjz2BwLMs7EQ';
    b +=
        'VxSOBYyKe5Gz9cR9nskw4jq46Qz7LPjBZQS9MJbAZzKN1kikSjOhY5NSS9QeccRugtVOMuszAYE';
    b +=
        'fwETxsYHoCSMSgwqTJT0dzXvl+n+aBXDSJD7zT8eBKejELUQkonUM/YCw2yP7M4wGYmGWemK+NM';
    b +=
        '+xKTzMoiCpoQnZyJ/ySaB/seFaTPJ2QeGU+C0pJAq4gyUAxRb1+H+kH8Le5facWTUg37+VBKKCb';
    b +=
        '+dSKEziGzQgTsGGmKgMdKUliGHozXpsfIS8rD8ForMbzEkG9Yy/yaOxt5aQqAR8MUpQJwmOayhZ';
    b +=
        '/tM2wiYLcjpmZZbr1j1EI8ixDFywg7BP93lQlw345RZf9oSCNRjBMbcbeTpavriKdkiyfGA63jC';
    b +=
        'HAPKL4GkM0d6m65gWVzKqJmkpNMPpsRdxc8vBuFtUgDJknhBYrXwCnewDDeoan2fyGumzUNRQ06';
    b +=
        'x8TySywNzmRAJoMNWzn4RBIsGIT2WmmgwXZAVuM6gg4WE5GQqYAsFVwY+l3YRDKmEQqLKzjXOat';
    b +=
        'dYHxh7xI/SToVEeQqhyA51ty4yo1bRfWnwYbsWEX6zAK4JX6Bjb4Mbr3hUx4TFzdMLEmxq4Zi0g';
    b +=
        '3iVQ13+afr2INPrPCHPpVMulmE61RwlmKh+4sicYpgLKBn22XYeonRTstVMsSqEskQG8AQG5Ihn';
    b +=
        's/CwK3S+VoGZXzZIBj7dgBJcyL9duIGeQKnY1gAlScTdKe96Xc6hFXsiZ7EGNFA5kkDW9Lh9NsG';
    b +=
        '7f1QiiiAyFvIA4fsfuIWkNd3Arj+Ovmj0LtB5sdNxwPoiT7L/OJNFhXl39AwIwZuiHA935iI82+';
    b +=
        'y7/VW3o7pxJK+zYhxeNMctIJ+CGObkQsybprvGXGTQvkx9aU+47pL1oHK9UqZQdxaj7fAMNF/9y';
    b +=
        'lx1w3ZL+l8K528k+O6Pc8KVkIPxSwdaj9HYS3I7hyEiappNjnyq4ZZ5NGsimGjRyIoWPqpuTcm9';
    b +=
        'E++ETSgnKekJ3ZC5MO94eKKA6tjXzSdfkbrixhMYJehx4rI3Y+sV7IiYuckuUiRSF4YjxTpo1K1';
    b +=
        'IiMrjMFsHiV3E/yv/hIZ7BvNNASpOhxPEtooLBStqtM6kK+K82mN84H4HayYQCwYlpDpxKRFChi';
    b +=
        '7Fk42DjYsJsqlQSkdaIAlWYPUFWFC6MhOGOyxzBgL5FKGAl2mYiCrIShSwpIwAFwC3ju4iff8LA';
    b +=
        'OC4OvBe3S0UmOg2GjcoKYkMYpWsg/+QSf4B38VaCWQWDG7xRLJY2/VpSTO0WI/603oExKVBpLRO';
    b +=
        'hAclk/Buf8a0QPGMuUjPc2age+9vhOEdKDThuIuqdOG7DRQpl6FGJZWdRpSCZ2WFrvUaYOB7H2d';
    b +=
        '5ndUpwk+y5elJaa8TidUotrg7zRbToFZtjgPnjWzDD5xHSP2bfCb///jY/+qewhN1Ot0wWcUMaV';
    b +=
        'tC/pY/oZjin/jRYI52+co3AqnHE9RCS7BWCCWPw1nlx98QiPQL4S6uI2Zr9kQn0Bmj2tF/tLiui';
    b +=
        '8pmhqmZAgja8AvC8MtkpwsLGsq0gjjwkAcNB9Oy27dY+VwspN836RDz6QI8SYAX9oorpJKfDRzc';
    b +=
        '8iO3D4LSfVUdhUxKDQaRpTCW2kSX1eM1f0EU4RiQzSlcrMrAQ7UkJaRYiNux24pkBF3v3SiDCF+';
    b +=
        '1dJG8BhkjP4KzWP7LYMhyAHWQ4FuUPhXIL+JbOBAUKL/X+qKyjaCWMhRtK9gMKhBFALZRY0ruXh';
    b +=
        'ZiNyus/Yp6pIzORA+RC5Y+exkQLhxEpdYg08ryOMTdAQkixCSM4gvQuW01SNYJeG9b3+VA8UlMS';
    b +=
        'K4DHPsWrWAzxgm/xc3NV+BLcEAbpGISRya8DOl94x9pCsodR88/jUUsjzLooDlIbT1l6HBwIkpJ';
    b +=
        'P3eNBkkDLV19r0W+b+1i1vEroUrMAMMDvFrqEsD+90wfXALp5AMb0/AeQjUN5Uc6Ou5f2SYCbk5';
    b +=
        'jBcCLl8MQp2LDM+ZQ7mkSTcP5p726EDVzPQsYs1HiVFU0xdiHR9RFw8LAqAmHnZXGbCpRZSfaDG';
    b +=
        'Gqa8fiIGJHzIQxa/3ko2fX/Ltpvfrb2dkzDDEM5z7uPhIx5tkSoGvoAj9dqRnKALM0rgseEd9MT';
    b +=
        'yWqT1jIaxAyG3JnRD08nUG44M2vovukLRFIMBx5EbHyOiGyPuSi5TR+2If6EaIzFA4EoJOAIlZp';
    b +=
        'LYmeEJjBU1cOSQoJAFxFYqbIk4YvYbBPXGOYBWjDfHkHl6stSQAJp114TIFbGiXN+vLYtPqfIB5';
    b +=
        'UktFaifgw3hUUWMW45MVSOPdFHYyAZXLcuRONy9nTmwbT2YHCVcKTYyGfYAMilHQWcUOAZJrxao';
    b +=
        '1KeA6rGzQl+Ev0JOZUx2zL6H/mwhIL0V9MqaBhQpnEMhYbMdtxyhGaDrIGhCnDJaKfZPuheVCPZ';
    b +=
        'DhQRfDHsdMf0hGwVLeLRaJlUIkCDBljGqcysrDifE0XBkgGRFu8+EXsbIdtEWPun0ofvJijP9Mw';
    b +=
        'd+R9xWPQD8jhnTxoy5FlyA4ELFCB1HkU2ASED81jWBIbSjo71hP/SnIHSOkbiQfbpJ+aY14anCV';
    b +=
        'DwlGO0JqfzC4CHGYAFTVRAjEAuChxAMuNysSwzIBDlkkwSAbWmIJRoI2L/tBcVi96u1Z/JlJRSo';
    b +=
        '+cqV7RLkbmkaooRadVhj5XEwo25vZLLcNpVL0QNhRRXsAqxO5lRBMmRCBbVqE6/k2cLjgh3SeeF';
    b +=
        'IxDVGBG0X3VnkpCjgJ5fywntgUhvXEkOFrDKmMfVcP4AqhcCxhUzN48eQ4DDTVYOJV7M2jvdgzO';
    b +=
        'amaD9wKAxTGmyhEnP72bUZcZ0uAuE60AMl/86XsjguidxXqW24C6lvg+EXK5U1QOdhLLEVXfKor';
    b +=
        'PsqD6nOXXI5s8WJT2cVCzN/+FHGHvAEFL7IdckXJlXAnOF2edxgbCdkbDOq0BsBFxCSDWBtaYpN';
    b +=
        'HYRoVlUlFbYCiUklQ8xAVRQ9ehgd0KrpbAnWoZtwJWVIoC79LMhl7M8EjMav0ja6MTZvxQLRnW4';
    b +=
        '2QV5t0OQzDhZB3lLOhYeq/07MP3SLYSxEJ1fcTAkOZPjdErBMzeFCmdHOdEQioxKeL6nPIRzax/';
    b +=
        '3EYgIgcRA5CKi6KPs9Q1ocGxd0NU9xdU2GIghg9wuFVpDtRmMFuUP6u2RsNwtJm8yECsyXLVnSR';
    b +=
        'AsmtmarZ60NKCiKWrdFTwp/CLowwS1JcL2YroR1HFKpAOHCC/r4+bv8DfXxhP/v4/AHqozhBwQg';
    b +=
        'O55TnKIv+EcAGqTvoBgHMUKIzbTwk4YVhqaP7HXFH+JLkTqDIeIR/04XiGhYQMAP/sohhoWiL/I';
    b +=
        'tL44J+VxmxNwNEPnu+wX4+DTxC3flzxeJ+2CT1EKL5R4E2Qvtoii9uuks4D3kauFoWbz5higUWU';
    b +=
        'TwRerVbYBaKTJATHkKWcOzVDlowCEkZT2J/LkFWUbQ0nWyCoHik6sWr7rq5kpA3pFgcqNK/y9v7';
    b +=
        '6Ni8a0W+R/fescWc53+2Y2uvbbJjy+Xt9z3KjmlXjV2uWCKJ0tQwHtgS2SNs17GMhLyIQ+6uRYT';
    b +=
        'tYRHLwpgdddJrG7LMY/gMPQifYSKK/2IPOMMi62ANeSPG6gJiVpwrOtQb84HMIUHQhOO5ihSNZN';
    b +=
        '0rXheZ8wS4O0PCsHpvZ9JqVOk0WosqneJ3a3c5HAdpcElq0aQ0Iz1BmkFaPE1p8UyVkBIMtsoji';
    b +=
        'g7smFjvCV+ZDsPYi3zq5zRDkBPdhtFxBD1uUADGAD0esr8yAvFaDCScxNDMNzz3cL61mIltm4jt';
    b +=
        'NNTxh4jYNhOJbcwh3kQZgP0PK2Cm1QTtjVTaUz4qTVkWgur3aW6Xgb9lMN40NBukjubshR7Mwdm';
    b +=
        'eU05E4RIdr2xRpV50El90Ai/a/KKNvheG/Y7FSOfQNEhZTIq94JFiTX8Uj0MKIVwzfRHEeAZfeR';
    b +=
        '8vZDAvFGCEQHrJd9PR1kD/E5mh/73OLD7wnVnndcZkRxEDvQcH8C6AbDL0Bb34HUP0RSxOWKBgC';
    b +=
        'W1whHTZF5NQlcleXfXFpL6g2Qhx4Y/oTFPIQO1Ih7OeHTwpUPvImx5tRhzA09u+Wsbs7wzsgenf';
    b +=
        'xJBJEp+iqR6YDATRdA9MIr8tpuBVD1BYbBKCKPTAUD0wuAeGvweGrwfMHfh7QCgj/h68oHtA1Ur';
    b +=
        'q3ZMMMQo9vYcMsONufx3dUR0ZmKbanmsS2+TDQHH8GCisxaWqkSwCR1f0YignMNVnRMZ2GF4Ilb';
    b +=
        'qL32WlLtYoAVwdBeAalQCuoEXdDrXvYBzHf+nKJE6xIu7Z5e45bBCKpydpzOGcak9HGtlG4LnhA';
    b +=
        'grsTwZ8d1am46Rl9Nkcifgg7esNcgE1gKH2+2Mqw3qp9PexLIpJYSZTVHo3wFEd4W66UQbKYi7j';
    b +=
        'OY/x95hI+3LmAVMkfyVtaKAz9nM0/SmsQRSPa91vKKOz6agSxsvPAvY27dCtA4WdOOySJbZf0Nl';
    b +=
        '6BUGaPK3/5gcTtP4vPejT+jc8zFr/VTpH/NpfgANy+ZdhjhtBGlgAUmCUS7y4/oRAqE91Z180J1';
    b +=
        'qJhhghGY7GjzJgIcpAk/ACjevSYk+K6TQLjnh0iheE/ZO/3rUb7qDVudmDNoWib59aPdvCu9ZMB';
    b +=
        'wAS8RnOm6INT757SQifRX3Povjshmc33EvvpfieAWC0uCWYcHnT6EFehSIBT9LwTprvTjreSSeF';
    b +=
        'aSbeXiY+YKboQGPLEfTmwmmAcQ0NhVqEMbgCcwW0HvBRlrlGX2liZiYgh2sSS99ehkCixRDjnOa';
    b +=
        'fIqi4eEInkZg6tJJlDqxLluPJFjbw7pSjtDOo8cDtTEFQuxFSsGQygpNJk9F05/6HJqPpPos7DA';
    b +=
        'HZ0WlgwgRH7c2DrB9GE6ZnmUTNZMhps8igsja/K8t6jsvSsIRgkdlekTKKA21LkpPWUYJp+BCBk';
    b +=
        'fyidIicQNPd7eCjHcFmKPhdPOMoyKOGkMGU9SPIGm4iK1RDcStbSrf7luXkZG8iIC+smQ8Q55dg';
    b +=
        'dKG0DyFN9mayKJSBoUON1JOu1lUInmYt+3S1K1n7sOzTG1v2NbFhNWvZZzW27PMb3pk+w7vVOhq';
    b +=
        'y+rU/DsaXVcBP5EWMW6LO9n8K68+SWIGqwjBZWrXnTRRuwMSASeiL+yTWxAiEmHKshKBHOmvppO';
    b +=
        'RfhQdP0OXc451qoMmRIdmsQKReiulGRCDvb0RQEXwJeMykIJ6IUd5eTKCe/cEJEkCeyD+XcgFKK';
    b +=
        '+UyMdeT9QMxxJqCDrnRRLk0xeWy0MzNKPfJU14LiD2bc7GSrlEgAYcojfUsTycnUZSpw31Y5eKn';
    b +=
        'lKyDj7AYt4dWs+8Gv8IAzITEQ0IlilPKcHeIuiNJHi22d6O1hu99x9cd3/PxtboJSZhjDmVJfSC';
    b +=
        'mtcWaURkvx5TwMggpBOh+waDarMxSajf5o8HTbJFvN0aUtSQ+TGPdGCKFJujAHtMVrLUkhzi2D2';
    b +=
        'qHmGAntZeuvHXobASNDtBIV1rxSKoOAjdd0PZmDMV++NC+0fIZgkaUIWimMgRd+x7bfcoNeflWu';
    b +=
        'YmCTeBW5bgnmQMfgR27DYgfai/ZeEK8aMTSCQXGlgBbAFpHweTEo/6w5U4UTLUg3A6YagFYYhMQ';
    b +=
        'Oi39yapAajg45nn4PAzACJ/hpkQdhr3HUooMw6+DIEOHHBk3MwcWcF8ZeVJsQkvpzAO2Fa9cjkN';
    b +=
        'np/24wYoPeHaXxdJ3ym3zNYevEtP8jkTWHeEP5Yqx2CTSFTtVlb1Fl3x33Nwr5w0U+4nMEUKNv5';
    b +=
        'A0omken6QApPNhIElpYPujdH6/DzaMBL0ASph1pE60/sSVRfuQlFnMBXAmSAWxrokwglKwTPimK';
    b +=
        'VZMYm+RtJjEzzpQLywvFl9pGbCkjYTGVkBorMcCcLto3f6P36HpUFoOQ9PpLIU8IdJ3GDHaQaSi';
    b +=
        'wedS0SgcnE+D0az2ItZYU3G9HoC9OTBINohnK4Fl2G1egcXsDWTGhyRz3X42rOB/uF23+yyCCJj';
    b +=
        'JKWcJoaA75C+kbTgBlyjy/uKuY19lxaUkVBCE7pIG9hHOLnc3we85s6WPMCEq0VsyGizmW6iCwV';
    b +=
        'IgSvcO9pjT2WznxsYzUUd9PxOJOqv14wTxgTHX4yFUYoOsB3X9lvLnIRcJsdV9yKywISOXWfZHL';
    b +=
        'PcFKh9VPOT0gLIDFdlHbtw44xbxxuOdOqZf6GQy0KZmP2YAMRtFEsSkeGUmhfyisiCErEE2JOIx';
    b +=
        'BiRh806/IhpF6m5y4mtkYJWSpUA6BeG6WBGAts/8R/PFVTEQBdD0oQCazaMAKjtlhQJoBFEAjQQ';
    b +=
        'UQKMRCqDpQwG8zuN19oPbB17/Z2PvJDOTyvcGmPf2Ccx7NlE/mYp5Jztpd81DfDzf1Fio4p9ryj';
    b +=
        'ySDUm8+WbZHxtEZACEjZEqjV/EGHyiJpoZs58L8XQy8dmn/hmn4S0UZzU52a5v9pP+L3/NKxTrb';
    b +=
        'TfHejNtYFFIBYbdWRY3iULS+6aysGuXGKMFITyRJGetexYJ8FIPlJZBQT2QjMWXpI0nyP9i8w5c';
    b +=
        'c/4jmnPmb2zNf4KtWRqYUhLcxQNIkqLTFuLQpHisSKpnafKYxjAjvG4tknURzhN5EjE2kunO/WE';
    b +=
        'dnMo3EDlwk6CVCSJbC+Ta+X0TueZ5lAlgRutT46b7Xw0MIQ1UoAHxTlQKAiu5r1y0jqEBpc+cuA';
    b +=
        '9ggyaDDepTE7IRUjkGrHAsIgsRDgIi71jMX8ETID1mYWMYSYkpBJOCDxsI6kQ2aTqC7Tpk3mb2R';
    b +=
        'HUmQlmYZNWmk6QYSAia9EAfM5aHhOaFGM0Ax6tz/AjR8thfWRLpW2Qu7jQSAcadJ6NbktIK917s';
    b +=
        'IfANJm8anqdXyFvDLcEGCohqlKO6yX3j4Qzsik+GSpGeQkB0X9bIcMiBw+RF3UdO32BI2aXNodd';
    b +=
        'zCCTZi76+wJB4+B20HAZ8BTI9B8TeKFnebUi8HIq+7nDUdRk/dY6uR+qlYjPLINcHUzo2amRIqr';
    b +=
        'FzGjzTFeSElB9bCIeF8dqBs4ljnHExOPYeFssRODMFURY8FmDuR7M0sjfEfTB2MVgwsNaHzXYZq';
    b +=
        'oN0OiBWNcklELY7Nr+gCE5iEqApmHt+edxw2wxKRQVDrXsNB+pwJM6qZDsxcJLOHrOgYy13IjBl';
    b +=
        'G3SenlLjIYclHqpwzCEoiggpa0K0YMPAnSlE/UicKdHEwZ6XDeoWKQanRUJ1pFIwhDkwaKAu0Lg';
    b +=
        'csT4sz0aQTe0AeBOYNsGqPqGTsITiZMejPpHGkRSoHGEryTQEeFkwAIwCTRFiu03Nj1OpgRIYJT';
    b +=
        'cc2/2CxnOSrEgcT7blsLgr3buVHRR/wV4cZUN1mG4368ww2leabCMvKMUJ4PtpKEuzOQnHMx1ta';
    b +=
        'C2toURQcxdLRyjY+sRYRpFOjqL3FMogXRTw+aghNpxeYATy0cvyVpZ34lliAGQjSE0sRVQWiahQ';
    b +=
        'lR1ScqmAZIplTiGWTLHMCW2JUNXMMiddyZxCLHNil6UZICeA/fs50vGJP9R5IqitjKUXjaNWgyB';
    b +=
        'qSOmGc4mCWiGZAfnJEdZg4z/6JfFxySib1wFIYmIX+v1kPAcpNiDKLA+aD6WVBw0iUso9gZ8oWs';
    b +=
        'n82B4EIY9Beis5CNNtWY5xl8SHAfZhpvSwZhtDYDRlPAK/HXI85NlBxsMk0g8vAy2PfZfBdoTkn';
    b +=
        'LDFYFhsyy+4QIdSMrW71JCWDrN9uzCuOAcphpAESPHZ0Iqa2rM0PQRRFiiIawgE65niznKMHQcA';
    b +=
        'fxAXIRejvuWgYjCEiw+cM/2R4CDUG9KlfwmOPpOluscCgWFlkMcB7V4CjwO3EngcnUMo7oXH+Z1';
    b +=
        '1b29c9xe/ue5LYMET2JXOeoM+UgGWZYBZClUrLUx1pTAATDj3W2KB9YDCQEHGSQ1AwmM2dAGBHx';
    b +=
        'IyWr/Y+X4OVBoUkQzUXbhKEAMrTebA2LgoHuLIqfkSJBPpAbms0Y6H4NAMUkCyfJMSUdn9mX7uU';
    b +=
        'gZeERPYdonWt0mzJ361EqeG+/NsgGsFKzdYRfMukrw3h0nJLPcFlTDSyFgPkCHs06VhsEk4ODjt';
    b +=
        'pzf+7ui4L/4Z4H3oJiJIaBw+QsWZaCLckATrXyKGn2xa3jUTJpzjk+VZAQlWlIZUgQ1YElPMUgJ';
    b +=
        'ZsP1xd11NkgSLZLKWe8dClMmioYc4MHdds472b3eXeGDvFGNVrfjSMG1zYqq/tlaMZo69FUNxsl';
    b +=
        'GQNEWzW8XAqJ70y+GAcDAM1oloEB6mh+KU+xrOtjCarMNrqPK42Ed8axxHBrkBdjGVgyxWy+XIE';
    b +=
        'OiKn0M9jiHfwdysG1DpOBUBjNzl+PE0j5WDRBolJiljLlNur0oJ1NRXDip9FupyjtkBrZGpdlSS';
    b +=
        '40ktz2/o8qI/1OVFe+nyTDpLNQDkMgiQyxCni/23EPBeHBE139gC+Fmw1W97xCWDS4igDIBd9FK';
    b +=
        'WKQG7LAnYhV4RohxEmQD9UXk5il3FiQYHQsOjbqzGbxDIUYXgpampCseSiFrAr/OrcQBsPaDGWX';
    b +=
        'Pdej6HCGHEPkmZFdpTA+iN9aYuDlF9ZmBRe6jVHIxdO95EUwrXRPGjE+pmEgAsiBPQSoruA6YBS';
    b +=
        'pHlfcO7L6W09+tZcit3tFiZ335I9dKkXjI8is1UWUBTGm1O7BOl8cVeZ+myp3qsMlEqB4/6KcAR';
    b +=
        'IEs1D24M65JpWRGnRUWa3K7sq6TPZvIJtK3iPlmu9kkiDgwiDnTap+Awt2+3YCal0y5r0/5vKSu';
    b +=
        'lKNHY7AYFToeuAUa9DIOJ1AXtjFV+p10pjLIvCZFAXky+S5VhDwC3IFvD/AuetpdYMhYIBP7yGM';
    b +=
        'RbdGWbCyb18mAuS+iZRT3DJnO/skwCI8EmW/4+BnZo2cEobvvgZRjsWIXYD1zCyMTJTAwPMY9F2';
    b +=
        'mnQj2VkAeMD5TLs+QzKxRGx6DBlpCPpUA+QF1FRijNXnPyCoI1N9BviSa/IzyUbr5wj2Y6jibPL';
    b +=
        'lr6Suv2SQSCc6OiJmEI+rd6fURHxogkVVQeFqazWcXjHyFQRxdsrOzWy9DDcu29ezzrgDWSXpoz';
    b +=
        'PZERxjMslDaTcNSI/EqS/v8rtv7HKXX+8ys2Lf1uVc2WVkxMscvSAKE3ZzXhVKhOahuvXs/Z3Q1';
    b +=
        'PmONl4gyK2E4mE9Y0LOFIl7JC6t0M23hw1/+ao8eaoe5ujz4cpWImmKtEo7JasZH93YK3JHfh3j';
    b +=
        'JxJI7fplt8zcjP2QlCI3Padf4iMuGIvZMREddao7d+i7Z/Dd9tEF/HAhXgsTW8sQwjARWMZcu94';
    b +=
        'eB2Z8slfwKPaZ2sHvKK1j8mK+JesqEpVRPKd/3xKFkZqrf2mCQKyU3ftx+so9pT8BQv7R0Fznw1';
    b +=
        '7f5DJufvbdUGRdaPqzMbVmb7qxByCSmCWyF84TxrXlTAtqSKjcUVNAZJiRfMWreeK+JfIv7BhPf';
    b +=
        'arJKFf6SSwDQKdpvurClQN9ZCrNEqGZom/V4kwljiqYucv/ROOGGX/rWqphRDkmlQcSWwYNkoEA';
    b +=
        '4aGKFEcBPUFFEcmXdIhtHlURYpI8c53EAC1jEnArTu+kYBbWBQQHyXBWchm4tZv3p9w1v34Ic+6';
    b +=
        '4C51QOvY+j9Qx8am6/hf+UCT/OcxeaS/tMolEVumP8AoHMELv1uXcASLS/uEk7i9ssR2134nDab';
    b +=
        'YoPGADuO6m9Y3NYzn+k1XifgkYnkBngMpNHw6B3Yl2Q1YV8yEVZUq49j3YdV1fblUJZA16Z9dfK';
    b +=
        'liKXWfaya6cpqeUYf0CmNoGY0QZKSk1ghgG/uxj9kt7H+oFiAfiCsmdTvoEyn4Bum1MtiHBKwj7';
    b +=
        'b+bCkYt6v54HwQjc5c/KObPvSCHegAthUz0maZNTzVDbYex8xJn1++eWq990OQKPXAVNLPNHLgK';
    b +=
        'fvyzK2hm9Y3zSDhS8aUqD0dcE+SF4uhVpPVz9MoKV+tXrmBlPWZTGrGJ7Wv+arTB27mKt68GXUu';
    b +=
        'M2NVB01pEOGIXGiptv1q8Y8tIU1sCqU2B1GOQaiVTK672R6+6CVKtVayuqzmSltgFQvUKEAHJzD';
    b +=
        '6e/NogEGYUIZMRB8HwULyMEDO4oPm2fwFtIapaSdoCJHE0FjsnQU9DjP9LOsC4+rVeAE4o9V06g';
    b +=
        'TLYz8tcAdWX7hl7xEYFJoHymPqtHAN+/MuM4PRKCHNLk8D0OYwhNQs+owZHoybqBgh2+zbEipIa';
    b +=
        'd8LnZeEKoyGVBAzLKainO+dvEjaRHfPR5dfuQ4a2HbQoacuVfAba4X+L1LUqeOTIgJ5ACUZ8jkr';
    b +=
        'yC0TjbEdPzkgWSZSlLgD1tfY3Eq8tVqwsEjicSBRJtfkP06GqIV6yrIDuagTgn8IQuQYxPSnl9h';
    b +=
        'UGAQTiT3V47PfwX2L+vuEf1RgjRLOX87ekvdtT6DWFjEIeMzBiQKn6Zk6TJX/+f3bJ5zSnTWVtq';
    b +=
        'Qd1tVdt6S1zPG3ppjlKWzoygYGjtWnfo/ssRRLlf5p84gfaMljzz4pQmN7y1KQJYBHUABg5YLAZ';
    b +=
        'NGdF86mQMiDggGQUeYewdHDD0mBpoMHP2QlYhMjFPGZIo+MoHQQOOh8mu3hJylDw5VY5h0VKdFP';
    b +=
        'HeTc6MXCANBzRWY9F6G1sBPA5l0nhd70w2BL7DfEOPIS1s0TDZSQvMjCT1iIUwUvnwFI2bsLrLQ';
    b +=
        'pfXU9bCm3+SMcBX0cmj4gILDLGRgTitxj2klDcJCbctA+Bnyn4sw0tMbGY51gKE8JewaoAvGfxl';
    b +=
        'XeoAMMoJuZlIYnOZZCejTcLKOcWQ7kAkyEZcr3I8BKvu/MRca5+J6bcsCY1lfbfDcdkR2SjGb/Q';
    b +=
        'OJ/ZBmhiMxCQkGbbGUF0Vg8TlVFRycaWcVGbwFo1mHJAu1hd2sWOSBSho/USuWLqap/T/GtZ87z';
    b +=
        '4wN5Wd5Tsx4OWPIOMgtgKpelwjYYM12g0Fa4RSpexGtHmw1UL2faQMXBV2Ul0ON9nSjj0qKKVYA';
    b +=
        '0QtMUtIXZo85FGfJ54g2CpcsVkImd2Wawli1UedhYXa/LmrrT1bJ0yCFxI2SzPWIFhkiyzXhqdL';
    b +=
        'ENPE/AndcxZjjUzbvVAmyayxKM4SWBISf4mw7wBPVCj+ScUObTxTgtRip9JsMkDc3xQRruab9Pt';
    b +=
        'wtCk9qemdzCcHjAWNZsF2SMd+ycmu9OpHVuuML8+fTBs23DrOVN6PHmmQiaaCoEXSAiBElmhjlZ';
    b +=
        '4gNAYh3jTJOQlAnNwQrhVJJtkBHJTOl2hgsf+J8dh0AlbLBqAEsO2DcSIJVmmMpcyiSKHXiP0dD';
    b +=
        '8UWCCuTCAWRp9UeZaEKmBCmqJhepP4OPZSXeKnpcTZEwx3YMYQiCoMAakCA3uUAWh4IocJqtRxp';
    b +=
        'AxT2oDjNk7ABHqsJRuwRMk61WCTTmjiKY0+KcI/PaHEc0jlp9By4kiPxPyTRaBj+CxC/qxmeXvL';
    b +=
        'wVm63F2kTQs5F4J3az+mC4DfyJCArKJZp3oWUirAt00BvqMyCHfUD6gA9+wdOgAqoEjzOPy+0p9';
    b +=
        'rBLrQN2G4niCsV6wi0qp9pD0l0aZSUh+VYvvYcDyuJcJxwwaA6kazZlB9AEXiDyCJgTMx9CgECW';
    b +=
        '0Zo0wGkuw+eyHfOMppx67lCbQgLECJZmr6KSzlNt7utxV28YEsbOWBLOyBfReG4h10DfcJd2S4Q';
    b +=
        'pL4SLA8zAEfAoynke/BdAxgssUnwi1EknUGsy1DyNxS4qnj5AbiDf1GfRa9FunGxVcdAHTdAKbn';
    b +=
        'RCv95FvK/pNv6TzVBjRlPIUbf3QwoTGAHyTZQF2ts4mcvGWIW8qprX+jgSeJYQITIt5eYNHhpUI';
    b +=
        'KbNT96NeuQrGm+NfWYJSniA3U/oZDu4if35L7CXCu7FWOJzrS6Xvp1JDETi1p3KklXqcGq06hKN';
    b +=
        'S1KNSMQZB+yg3GICmy7uGT6NKWTgeKkplXN4H4JIg9+2hJZ2aW+85HI62Az337baXh+L0lvKNKG';
    b +=
        'Mx7C+4s4oSpEXMjdbBPhAVeQoY7dz5FLcIP89JVnEik02J9g6j02Jh7yPObiALkum+VfnSNjn8e';
    b +=
        '5iKNEJMGKN9PT0aWgkbnFZL3Mdn0UCyye0CEeqRjocDsABQxwLMapcEgqpUB1JZZTKmL33db7Al';
    b +=
        'FwI5GglWoPGbUtPGF8BXvPBNy5zxKYW0pSuljIrH4MWkFCVntzCxNgjv8voY932TDDlxJ/RNmYp';
    b +=
        'ryMCfLL5s8zBkYJJOUl6gbFycq83GoOBmQQJqmKZUMRXly5yxaz/rcnwlElUoiPzvCWNWxpP5Bw';
    b +=
        'kqM3857UQq62KSXQMEzB764hayoO/c+Rl+V6Kk83j1+9w6E208/XGLIey1T0Jhpcq8wyQDbJONs';
    b +=
        'k7g2Q8o8fRR0rGeCEpgxswwC1EKTXWXNSCFmTLbY5LV+MhNhUTe7sglPF0LGtOcY5Lygu2cSh5N';
    b +=
        'dTu4ssZN/w5riBUWB1OWaDLBvEmdP491YMHIXmdIZAfHL/HQ3s2r7LOLifRbhJkTOaFohL82Bv4';
    b +=
        'VC3zUDjMlAGEedPYpYY4lL486QxuFVRLHiA+8y4gH8NTFODz3sjzeGjZGBG/fHRkwP2IgBY9PDf';
    b +=
        'yRhMJj5hiQrtD4KbU4RmSAwX2/F/GfQH22AnoB84vLWLz77kwwWC7MxpD4HDknoQDWgH38Oixy8';
    b +=
        'kCvD4ecgcFFfEDgPeFF8i22B2G+xkw29Xp9J0PNgpg8mpZpEzbGJUtLJyZ/kZHZnhJ0wkS8qiJ3';
    b +=
        'g/xIUxJqwj1AWr3vmTXAC7zaylBRbEIN99nVCyMDneEIkBD5XB8OJiccvEDF+htv0S0kTDt1uoI';
    b +=
        'wXe960nmhVxfp0NINpaJg5FeFV40YGOQLgW7UOJDWcAU1/wgWJn7CJ6KOxAtyWcOMUlAaYkErFA';
    b +=
        'xVJSiQpxiDHSHivexMLWaIwm3IPMIN7APe1mVf1/Xg1+JUJn4UYAoyqwDBOmv2g5RPi8VdutsXP';
    b +=
        '//4W7/vV5j/Pwv35PCc0IeUm87J9i0ma7fALv7/D+37V9RssiO3uxpD7EOAE/RXBIu0bQvZcjrV';
    b +=
        'KIT81366g2zeLrSIftoJZACqXPStuLssyXHLkAbC3ZQCQ9BwQQXoiEVRAI80oQyiWM9CF4GuiDZ';
    b +=
        'QjDW/FkkH5I+81EtE06bOCTnqGt9QDMpQOEKBI/GM/im7TuNS+MgM47P6vQmhifMhoNJVgN1xqo';
    b +=
        'timOVsFj3zR2H5Txr3ZtZt8AzTyDdDc5XukghAwiPawSc3JCZShjvHi4AOkeaD4r6EBa4ryOCCc';
    b +=
        'KPtL8X4XYn5xqlfjDMd/U/BfG/9Nw3/T8d/M6j6xApwHibNfzN83EIo46tsoHdMnKMj3JDYc9Y3';
    b +=
        'MmFIFOx5C13M4q/qgrIZkXXhCNVvdE3uvLq+JJdpYg01rfr3+BxvZCdXz7sxBpP4HmAmSkLsXDg';
    b +=
        'Dh3zIG9wKJ5MIQbJhiJSEOge5RwVoCFYx2W2Dpohd4OAVQF/KOEE7UJELVwVB+Yj7WokwQPeeqW';
    b +=
        'T9nxPIITobsw3Qu0YdKLWdcQO0Z65LIKJCWCvVGPy6QViXT/SxBByaFWX4gKJ2vJflvKlgAU67T';
    b +=
        '35Y7V1OkuRjyJy1CibPXWfyN/mXx11jLkFj2Y7qYAkAEgQ4D9iozgPbRV25YiQoQfIspFZ96UYV';
    b +=
        'RRMUhng7SGwNjLv+uBuYHKRwHwxRKcIE5bwiCpoCIm7s3i99z32TiJqcJ6TjCBUh9hCg9xy8u+l';
    b +=
        '2N69zUAtryMcTfQG6RI2r4qmnyjU3fBt5YqQcbxr5Sw9h0xt24er1m30+eofYVIfufBFUHxJ+9y';
    b +=
        'zpM/BQzB5eGRnZm8petfkX5F9D9Y2PH+0565OnRhidUixMDh4Wt8iZUxDo1p3a41g/BsFaCgjSf';
    b +=
        '/4595fcgX/BkudaPY79WMVWd0BaUqUB7s58ANP3Un1ToNNueO/3teXLf7bnT354nzQA5jDNJV0i';
    b +=
        'gTQElknUfatdJix7r4J/prAD2I0oqvax9u+nP7e+HfYm/F4+rXjSTe9W++kym9yY5Qhnkd6eTIT';
    b +=
        '4ZO9jfm7TzgP+cA9a18J9VIIkrnxMYH82Z5MwTyyGnZbJtC0Kc0r4RkuikzGd1kJEEnkQoUliaO';
    b +=
        'vZiualWpFqjzedWC9mfu2NzlNQ3vOF6ZBQ0pRPhgTcgzgF8K7PW3XLjOo2PTlw+sw13270c8+G4';
    b +=
        'xlE3lTk+yQtGyPnTESklEhJobAkIaFBEaJMtHM1o0HNh9gAb72MW0TTKlUQ5It8cI0X5glN19Gr';
    b +=
        'XqOaOlcflfbgTOzZhLmrkVGYxVWivVsLofeV8WOU8Tu0yGukZEDYFNrxfTcIrAnGQSMRi2b4NST';
    b +=
        'wbJDlojvyHkhs49vZZuyc0ZxB6k3kYNZDMilv2NzqQNnCuddB2rUJMUpiF4ics34bVbpZB4KTiZ';
    b +=
        '4L4OktjK8MVwM7VLC/SZyJfF9cysBWTY0c1sbbBJolXBbfxGNVtS9rXGLVKLYPWUahtOcqH/6og';
    b +=
        'mjTCTmFbOstfWlTB1uOkYQhMs0IM6Cs6Draf+yf9a9BXxL7ebKJ5mgdPj3OPtEa+zjaii+iAuyt';
    b +=
        '0mBY72qMhyESBvjNu4ODNO4jUXUcnyiZY3CmxRkUf/iU+QbsmNAiX4eKyF+lybeEcMBEEiekpXt';
    b +=
        '4+mWTsSDhG7zQJ1wjCpGs0XsvszUaRRsrk/Spo/2oD1aBGUCUJk/Mnqw/qYvFz436jdPkkd2XCm';
    b +=
        'jX4+5dLKrKQDieDO0KC1QUNgXS3oB72r6j2WhNx+fq09ELy0XLBYH0wqmhIaLmzpnL3aauhiD1y';
    b +=
        '5HWf0KmpGJixeHAhAcQzYloAr8mr6GjJX/iBDDSCBHJCFL9PfMQjEAD+WBOskI2iky+LmzMd8xL';
    b +=
        'xs/4MXLJZgS9DEnwUjttPW/Rd4t56YClJhaMPkZ/QvtoEZ4UmP6/3bdvtrbHY1CTt/9JMyQcs03';
    b +=
        '5Vl/5/6zi12c+S9jHdrhXTrfk5+7ZJ822fE/JwJmiaIQyOYhgqYsPuuA+DHrLR/yJIpYDRv9Pop';
    b +=
        'JBHtjjBFoojoq10AeCHgrN3MbiQZuuxWLz54cDBiGj7k0U2goHL/O2gc+rIQF8WL14PfelEXYGE';
    b +=
        'ZXeKHRZoqCiKacYNeixLU6Is0uA00tI09/IzIAFspv06meN477rKPHUFwfaJwfOYHE+NZZ8mBm+';
    b +=
        'lEWvbzNjrNPCJk0gfzKUvMvf29Ibg04SSbxQlZ/qNg1M95EdgcGIHawp12yTvDvsTPZahOZpfDy';
    b +=
        'e9mux/67FD+A2SbqghzYDGfGYyaRykyvHZ5808IzZRh2NqOcR1dd8SdWW0CgnGqzV4UB0K58i0C';
    b +=
        'vHvEX0zuPZGJ9Rh3sjTAKEg0H5cfLxMxmBad52YOS2CHE3sUE3aXBkJ5lTytS/vh9mX8NrBifPH';
    b +=
        '/kV8BnU3sGYa5/1133n3UcK7ooR0OVE33Udgx6iSFbPwUGRUZNROtnuBCOvc20bzcyN8VCZI/eR';
    b +=
        'oc+1po0ljwCC13UbzpJn7cz9D9oB9Ozd8z85RohPpwWde72xsXblbD1pJvWJq7CBNoqoSlQIbSD';
    b +=
        'rNL/fmOQkOMk1lPohnINLnXbMsMLI7SGIuMY1pzzZjB3sUjqNhhI8O4ukhWpPTuhXVwOvE3mY0l';
    b +=
        '7GpFrVmbA0l3c5ouuH+e8yBNJXvN9TcTNY0OXGI8oOggRZuHYE1Zz8rOLWWGH6xNk5hhqohl+6D';
    b +=
        'e4bMYvduRTxlXLOfDYHZqyn67J/k9n/EPGtFFYpMc0DNc4mBH1+OCXhtqIZhFWAnADt0K1/DxNe';
    b +=
        '/woq1oL3yCcSU7ROz+Yvbfw2JNWK09G5cYdINXGj1NYIZt+db2CeFXSm2R1tLmMlN3siWIA6GnS';
    b +=
        'EaSuBNDRhJQ0f2lcr1aeZsjaBVVDH+ngDYorUfVbdQM6/cvsb0WiKa8ZDlek3jMnMSK/mBhos+c';
    b +=
        '8VhLkyUxrp1GCCwijWmis1ZdYSZiBjTDq4pnvaLparhs7Oxft3xzwUqSiysqa41TaWcqW5oWixF';
    b +=
        'Ts7rQi0xAXopMUZ9/YVuNFWKupjq6/OhCc9aaPI0x7mSTPPU0abGYtwlU8yQFB+xFfPZqVvlMnW';
    b +=
        'YWQ8MZyp5EiCnM9lr7ioz2Ip8TAmehjNCXUeCkfGR2CLd/Xy29MuEMtSEx4RcIph4HBL3U4/djf';
    b +=
        'CWY0+gR6/AS28ZVODGi9aBB4AssMkyAolkWiNfWGqgAZ1S3l9hf6oHS0qi/G01ziF6Odj35gcmd';
    b +=
        'pISlb7fNZgfZsf0qeqnLn+mBH5Ok636zJLV2J97P7d4Pz/1fn5rqp/bdfXzC+/nl97P77zXvvd+';
    b +=
        '7vR+fuX93OH9/JJ+0vnayde5AfgbB2OF4Q3MJO9noZfjPh0GESbEK5b8tRl/aUW6vYaG3r41JP7';
    b +=
        'nIdHsrTAn3NdWrYdH/4VP6K6hxMdmLAIgk1pFLEq7Ckxjdws9/ZA+GBRxGNWl2UsNzAkaDPEqHq';
    b +=
        't8rcCr2HvpOr08FoZsUxIuEc1Opsa528AB658GPNHsdHFByhvehrmCd4/HpPiufI0mXOl+B82m7';
    b +=
        'CViihddvu3ja79Zc9Wba+pjFqjp+B/7cF8yRSt6864nf3j4nWeethPeMcWRD3+W5kbgn6h8zW3q';
    b +=
        'H11U7DY0WFDirjc+mfPze088XRwDmOQD/X/sg1WzGzRDQ2jZ2MOrdF3TNPlniD/Tl7bEX0lxZWX';
    b +=
        'pOOe8YaU1dZW13bvXVZ1fXTwl+9jznMlVTnGVc16f6urznGnFlXWlWojfgb+w+KupLulUUlc9rV';
    b +=
        'NpZWXZlNoySpXWdKopLZnSJS9/TEXnjtU1mjZa7KxHi/yXib9czUvPE3954q+6uGrc5Ene/fvF3';
    b +=
        '1Hib3z15EljxpZNGFNWVbsn+N/uR+/f8tHK/ktOePKVc+e9lO+6xePGnU61VnQ+XXSquLpvcRn0';
    b +=
        'rKzKqSmtHlfqq7ed6HwncS2uFE/qSusqKzUtwqGaYFyi4i/Jl06GvKKUqXWlVSWlOTk5nXO65HT';
    b +=
        'Nyc3Jy8nPKcgpzOnWOadz585dOnftnNs5r3N+54LOhZ27dcnp0rlLly5du+R2yeuS36WgS2GXbl';
    b +=
        '1zunbu2qVr1665XfO65nct6FrYtVtuTm7n3C65XXNzc/Ny83MLcgtzu+Xl5HXO65LXNS83Ly8vP';
    b +=
        '68grzCvW35Ofuf8Lvld83Pz8/Lz8wvyC/O7FeQUdC7oUtC1ILcgryC/oKCgsKBbYU5h58IuhV0L';
    b +=
        'cwvzCvMLCwoLC7t1E03sJqrvJoruJl7rJm5d+Jf23X/L19e0lIS5k+qbDy3EX+VkUd6Y6U53J1m';
    b +=
        'rNGwct2niqqtnM8QzTZub8AzmUWXZWJwrd/CzCeLPhrlRU11aUjZOa+n7HnC/lfhrrXn5+4u/br';
    b +=
        '70APHXUfwNGzMdqhQT38b5K+uU+QZpNBeGjZmB+bKbyXe6+MuCvGeIOVPTqWRidVlNp44lxdUTJ';
    b +=
        'neqLp1QVlNbPaMTdGRCWe3EurEdSyZP6tC5tKQkv0u3buPGdistKezStVNV3aQOYj6L6dwhp2OX';
    b +=
        'jl3wheLKCZOrxUuTamAAhor6x0C/xWI9GOqrrqupLenUNWd818L8nMKCvHyYK8VjCwuLu3Ut6Va';
    b +=
        'YW9IlP69Lt5zirp3zCnPGwjhWF4umlEyuLsXiayrLSko7TZo8DodXWyfKHyyuzxigFQ6mO/jSGx';
    b +=
        'OeQ/p4cRVtL62uKq50SqurJ1d3d0ohLaZQXVV1aXHJxOKxlaVOyeRxpX9onHDBjimvmVzVoXPHn';
    b +=
        'I5du1FPSqupD9MtWxsF4dXCNAdkOjcKkRi8dA+RLhDX+Oja0dWjq0aPHz129OjR8QM6pAeFguPp';
    b +=
        'T3fwpTcmPJfj2QeGsa6qomry+VVjYOAgj29dpfnGHJ+PK60pqYbddnLVwbxXQb5DxN/kmjH4Vdr';
    b +=
        '43k8Xf6eK1zqW1zju0AFOSfWMKbWTO9KW27essvL0GVUlTlmN+IDF08SOCR9Q5qe8juhonfiqwT';
    b +=
        'xQgNhw66pLuzsjpo+cXF1R4ww7tZ8vc9XkWrH5ltWWFVeWXVA6bmTpWH8DJpTWDsM2jIDNpSahd';
    b +=
        'Mjci2qHd4IPh/Ue5p7au7soXEymuhIYCayspm7KlMnVtaXjZIbxdAJMEltb2RTRqNqySaU13Z1e';
    b +=
        'Q88QJdbUlTqVZRWllTOG1Vb2K62i1nR3RpaJ6/k1Ts2MmtrSSc74uiqqAQoTvRV9ppy9Jk+ZUTS';
    b +=
        'jFgosG3K6g2NRVjvDGV9dPKn0fDEe8g3xSaomd3fGlY3DVlaX1tZVi83VmTK5RgzOtFLaXsV4VH';
    b +=
        'MLaieK/taKFVNaK8dRdU07RnzPo3kv7KLRHOvEe1NbTsv/OsNZJ/5yxN/dEVu7KGLj/aHieqT42';
    b +=
        'xm2tVfF32rx99ewrd47U/zOFX+W+CsproIGFJeUlNbUiFYPnyjW+TjnFNjOndNrJ1cXT+AeOOPE';
    b +=
        'AFRNcCZXO8XjxYR1xEyV3+f3Lrma2nG44mqx1k54iNAecGnU1oaI651ikz5MXA/1nQ+QzgDaBme';
    b +=
        'QpmXCWkiyteHnlxZXDKmrHTJefMIJpQOqRLvLxg2omlJXe0pp1YTaiXxnsOhqsXo+rLRk8rTS6h';
    b +=
        'kDxvEN8anFRxxUOoPTQ+vGig3BS59eNqGqWHxkWMpaca2YRVNqHTGTx5VNKxtX6oyd4VxQWj2Z2';
    b +=
        '+t7LvpWUldZXCsm6sRSMU8mFYupKMbxfLFTipGH12vE4E4ej+8X14j9UM3M0nHdnUlihp14kqBT';
    b +=
        'Ksd3rCytyj4Wyi+ZKDYXsZTpM04sFvNNkDJiQcpyIFOyTWfbAT5r2ifTXpdjEj0l03Kv9Kc7+NI';
    b +=
        'bE57LvfIAta+slg+STaL8U0W514eI3vyzz/b2MTrbR/EcPfD1iRt14o6obLGoa7SoY7ZGYynT65';
    b +=
        'huk+mnuC3DYcoVjyubLrbLmlpnbClOO0E8d+nYsWPXfJX/PaaNZfoDXnsyHdaJPtN993aJRKEv/';
    b +=
        'atIH+dL79aDZVwqvne2L30Zf3+Z/qtB61uml4SDfbyD6QKZvi9M9KJMfx6m81Kmv054/m3C+8Ac';
    b +=
        'pPjSLUU6pDX/34KM115M86WvrXmqP4y5Zj85G8q5fvE7dbGE/EBjas/feAKM7fGTLp9H/Mdth8L';
    b +=
        '5nmXfmgNXbf33I+E6+6anFkV970/tU5cO/EvD2gvbwfUv4/vlIT/Tc9ApcG1bdVYFPn9/+UK4Tr';
    b +=
        'j46+eJ3xkXAz7utIFXtIBrz/vLWsN1wII2bcLY3kcy4XpD/9oj8fndNcfD1T3ho9ywr/71J/58C';
    b +=
        'j7ffNBouB66asGkMPcXrv/c+sUifN7j/Afh+vKGx16m99vtxPpe/TgM47kk5/kIXB87/ukojm/l';
    b +=
        'a0lw/XX5nmS4bn2ibwpcv7r0vlQa/5yWcP26+xs2XJ0xS1rD9b/3zk/D57X3HALXo7K/SIfreYP';
    b +=
        'PzYDr9RftaYvPG1514HpDm3ePxPrzjjgGrrH3Fx+Hz08c1RGug+eM7IL1H3RTPlxPLj7mBP/3d2';
    b +=
        '/L7oP1p905EK5d+84Yis973zMCrnXdup2D9Vd3GAfXj8/6WwXVP7wGrp9eNf8vWP9ZvebA9exXp';
    b +=
        'l6Bz1OyYGvSbj55xG1Y/8ZDlsP1qmMmPkz1D306xPMH6y/7eQtcL/5142f4PK3vT3B9YE6mCbSg';
    b +=
        'fV8RXrPal+NVs6/B6/vnPk7Psz7F69fnHmLh86w+eH15ch1e7eHL8Dr7jbfpuWaHMP1WX7zalfV';
    b +=
        '4fXndI3jV3v8Or1+/3jWMz++pwev7JavCVP9PeM16uEcEn5dcitcH2r6EV+3rjChcW31chlc7+V';
    b +=
        'G8uuNSkqj+Yryu//hhvNpHt0qG64JnKvGqvfw8XjuffnwMn4+8Eq+3ffxtjOofnQLX4neexat9R';
    b +=
        'm4qXKfOvQOv2uw2LSxeH/h8R6glXPVZs1tavu+vXzTbxud2uBXmX31FK3o/vTWWN/MuvNqrCg7C';
    b +=
        '+go2HUT1j0vD9gzag1f7h5sPxvYe0fMQav+HeF1w6FVt8Hn4xHTs7+3b0y3eH3A8skcdhs+POzg';
    b +=
        'Dx+ug1zNo/BZl4ni+fF5bfP50+8NxvF/ddTjV//IR+D0uu8fB5wMuzcLvVTwhTt/vlCPxe76W3w';
    b +=
        '6fn3LUUfi9z0g/mr//MZg+KyUbn9emHov5zz7oOJo/hx+P5b3SoT0+n13UAevrProj1f+XThbvb';
    b +=
        '/h80MbO2N6Xvu+Czx84Lhf7s6skD58/tTQf+3vQxwVUf+duOB6LGrrj8y9fPwHHy+58Ej5vdXUP';
    b +=
        'HE/tp5Px+VelLo73l5uLqP5hvfF7jHu5Dz7/dUQ//F6ff9Afn7t1A/F7tmxxCj6fuGIwfv9zTh/';
    b +=
        'C3/80TJc8OAyfL5o0HPM/0HGExfs1lvfWM6Pweeris7G+qhnnUP3njsH2WAOL8fmYk0qwvV0KS/';
    b +=
        'H5gu4TsD9X9i7D5z1GVGB//zF5EtW/YDKOR7dHp+Lz6s9rcLyeaDcNn3cePx3H8z8rL8Dn7+gX4';
    b +=
        'nh3H11v8f6M32PKcXPw+dRbLsXv1S7jr/j8tiWX4/f8qeOV+Lz3s/Pxey8cfw1//+ssPo/w+cxZ';
    b +=
        'N2H+1b1uwefFrW/D8q767HZ8PmrTXVjfyw/fQ/WvWI7tOXb5SnzeddU/sL29Nq7C51M/XIP9eTl';
    b +=
        'lLT6/oMeT2N+LLniK6l//DI5HUut/4vPVkzZZvB/i89P6vIrjOWn9G/j8sv5v43ivevtdqn/6+/';
    b +=
        'g9Vjgf4vM7X/sEv1eLhdvxuT5mB37PhXk78fnWNj/i994V2uVf/5IuiCQTHza0uLqmtKhswoCqW';
    b +=
        'mTvKwQd39bHkx8OZx7xCr0FBVfbRzAAM/aDnpfSuiHI/SdK65zzTp1cVSqldX82LfvjwUTL9mZZ';
    b +=
        'sNaYn2nE78h3JP0r0xckpP/C6V7EtNTUjRW8cYkgSh2QCIueji0tKa6rEUUDf1wJnHK14JmKxSB';
    b +=
        '0lGVcrhGNJtO3J9RxB6cbD3vxmIllHctqxkA3ZiATJd+5O6HM+xLSD7IcVKYfSkj/SyNeVHyN6h';
    b +=
        'kOMJXjKyefL/lmFlOUlRRDc7J8772e0PYvuByZztWDz/MS0r11kinJdJ+E9NCE9Bid6GuZHpuQn';
    b +=
        'inS7X3pCxPSsxLSsxPSFyWkL05Iv62T7LZ0OgxHWa0zpbiqrMR7/rVOPIjueycmeIIjfOm2BslD';
    b +=
        'ZLq7QbIwNQYG8SAyPcgIjsEpCWklj/0Tebahh9I+0j1CdZcUTykuAZmSnCri3lqRp9Uf4IXFFjK';
    b +=
        '5BOudViquU0pLxqCaBZjiMVWlNbWlxLxvFvWcq5E8tfUBq49EA/0Ps7VTgLyOkHzqQPP1dxxGfP';
    b +=
        '3SEH0zbX/2pwM4oKXTa0urWAZybIatDddIDg084BE+ma3Dcru472w4kmV2Ms9RLO9L4TTI/4A3P';
    b +=
        'hZ1Ur3LaqZUFs9wyiZNqSydVFpVi3sHyxjFUSG2RJQIO3VVYjGVloivWznjj/dUTHaxY2EHD8q0';
    b +=
        'UYfyQBLtdcf55HDAsycnn15bXFLRPVn894fWTnlNh5oZNWLddO2Yl9/JrzLCvYPFqiA71eaJNp0';
    b +=
        'BOptDqB3/p8owB7YNyjA7JMgwO/rmRacDsgari88fI6apqH54dZmYH2IV1IivUVUBv4rlUSr3nf';
    b +=
        'TDbZyLm9rSer2X992Sysk1ddWlTlnVtMkVopRqkH3XlE0rrZwBI4djNnkGTL9K6PIMb/XtOJmu7';
    b +=
        'XrSdRRde15F17lP07X8R7w2zOnowvWl1iV4nfPm9Xgt/de/XGL3jSJx/WRa/wK4Ll142CRx7fnh';
    b +=
        '4pyl4jr/8A1r3xDX3KO/q0jppTVsLZjxtNtLW7L5kpG503ppG0+dMGn9fb20kxact+3M93v1nLd';
    b +=
        'qetuVB/ce+tUHb2w7bFDvq18fHH5xR0Pv7we+/5zRYVXvh25+a0av6Z/1XmBktz/ucqdPntnl4Z';
    b +=
        '0rhvcx5uzeNvWtv/aZ3fqITh8fs65P1psf/by1884+n81b0m1Uj2P7tvt7dO5XV4zp26YqtGrVm';
    b +=
        'mv6Lv5n3/h/79rY15y5+bObXtrd96LBz1UXF3Xt919nxos/tZ7YL6NsZK81bW7p98Bthxz36r9f';
    b +=
        '6dd24OKdl10U6X/n6Ke/PrbkpP4fH3pYwc/nVPcvXrJ1w/Tv7uo/Y2P692/8Y0v/Uy58cdSzX7U';
    b +=
        'acMvoXjserug74Nmuw7ffGZ45YPSShx48Zs4DA2o23rak84cfDriq+/PRWedmDLxx3KxnWmScNn';
    b +=
        'Ddr+9Oe6X4koE5F16b1u/RRwf2qHq3svKhHQP//c+0uZe9326Qu+vQ8k8PPWvQPScN/aDz0PmDD';
    b +=
        'hq87awe4zYMGnnezV8PvvCnQZPWWFW3bel0Su9vn9q27dOSUw7++7dtz9226JSMxVPurGv74ikL';
    b +=
        'isdfVlZtDv7up5M/NYcUDq7+8ar/bhhbNbjfL91aPPbr0sGHXrDx5WMff3PwrYu6961dnnrquFu';
    b +=
        '33bfx8qJTT3ru3Tce7Xj+qSndrp1X9vPyU5f1eveH2ZkfnLpg4Wt1S28/ZMiqRwYcdPkppwxpld';
    b +=
        'Zi+xsrZw855IZWyzZlrB5y9p7XX3py6edDbnjykg8e7pM1tL7TMe8cdf0ZQ8f8suO0r3b9bWjGz';
    b +=
        'fnXHPyfdUPH9rZ+vPHg74b+5YzQav3s406bdMbTrd6fft5pG4/LHXHo9QtPuyBv/X3vrf3naZXr';
    b +=
        'z3whdog27LmvOz5xZUbusG73PzqpOl427LlRxya1rLh1WNvNj5R+uvTVYe1OzX7y9sujp68o/ub';
    b +=
        '+eff3OD3lwpFftOlQc/qQ0Ss+OefHZaeXPLh5bN33755++JTnzkl6tPXwo07pturyif2Gd7z1sq';
    b +=
        'X3F104/MKnFx61YsA/ho/e+VNV+paPhtdMXfO3w6/JPOOTvg8e8u07p52xNP28LV8Nu/SM5w+f/';
    b +=
        'up9Hz92xskHHT/uhSlfn9Fic95JuzcdNaL1qRdvOqnn2SNesF+59ejoghG7Fz7bL2fgMyNO6r5m';
    b +=
        '1NrFP48Y3+6gNd/dljOy4Ys2R9c8P27k1k9u/qrlrzeMnPfAU98d2+OlkV+d07XmocHWmRV52vy';
    b +=
        's4m5nPlOk7Sx7ZPKZjx3bUPjBq7efeVzukmff3rj5zDy3//RWv7QYtT67w+efje416uvqH+88Kn';
    b +=
        'f6qBVXTWvZyb1/1KZD7y17/JMPRp28JG3D9qVtzhqy8dDvll0++KwubXN+6n/+RWfNajezIOPgh';
    b +=
        '8+6pcPZobFvbz/rol1n9rowGj/79hM6LVz8txFnz0s+4ZFeHeadff1HG04fuHj92Sc5qz8ZbX5/';
    b +=
        '9uC7/xvPnXP86JwB/752SZfi0TPfcR/rX3/t6LOHtf7ssPeeHz2jZtArU17Qzhk59D/hwbtzz5m';
    b +=
        '07dr+W08qP2fD/ed0WD5+yTl1h60qHNnw2jmtiz8IT1qSdO59Mwe36231PPeNd87rcEao9txNrR';
    b +=
        '+Zfm/4nnPrR358yBn93zt35XVDO+ZdcdCYs9dum3HRlP5jqj8/J/32ebPGHPNg968+bPPgmK/HJ';
    b +=
        'FW89+7HY754+IU+I19ve97OYbdePuLOYec9cMxlHZefeplYHdndR8YfP8+4ftScaXnfnPf0rslH';
    b +=
        'vfbU0cU7f3mh419rRhdPv/Dkx/M2Lih+Y/RV7Xt1f7Y4JffBH17d+EvxZdpLF8w5p/PYe7Q5N3z';
    b +=
        '4UOnY17QP9xwev2nsHOerMad/99LYOz/5rODuLqGSF5d+2GdYffeS9ZesrLjmqiklXSbc1Hf6g3';
    b +=
        'eU7O5ZdOaIrW+V3Drx2B/y2tvjnn3q29peBb3HTX8wZ1hanxnjRmxdO37UdSvH5afkb/3h8f+O6';
    b +=
        '3VVr811K9JL02qGn/rq5lNLtz+3057T7+LST37qfHDpoWtKi6fPOuuJI74sPSl21Y9vvBofn/Lv';
    b +=
        'f6zeNHfk+Ktmj9m2p/yK8T/9/bEv3xv71PjCm8s/u/6X78df2jv04YWPtp/w2sAjV165s3jCX9t';
    b +=
        'uP+sfU6+b8Hm7ZV8f3mLThIPOj458da4+8c2Fz7ePfp43MbX7rwXPl1ZM7N9799hbjrht4lmvP/';
    b +=
        '7LJRNen/jAwBUXTFifXLby1OXLt67p+f9x9x7wcRTXA7B291TdCdU00W1wmd2dbbJsbGMbG9zAN';
    b +=
        'k7AcJ5qHZZ0Qie5YIxlY3ovoffQMS0hhFATOgk1ISEQgoFASEICJBBCAra/N7N70qlLxvy/fJ/8';
    b +=
        'O9/N7s7slDevvzeZo+nrr+/8YVPmH1UvDtpYeUfmt1Ourzl7/juZgUc9N/nuzPbHn7/0xF/vsn7';
    b +=
        'G8bmS702v/GDN8WU3BaPxJz86vuLcU0Pjoz8fP/PTW077+X57LkVHjfj88uXzlj681LHXLDhj6R';
    b +=
        '0laza9ffxjSw/k2eN+aX621Bs/wD/5yQNq1w0878lj7z+29tVnwysfuuCi2mf+88zEv+Bna4MHv';
    b +=
        '7xgH3NT7T65q6qO2sup+2jO5OfvvF3W/emPFz284/yr6xpeGuedd/+rdQOfOOuJ+/YqqT+/cbS7';
    b +=
        'xx3j6q9Y8vXGIw87oX7N2q8u+/Dqm+s3kv+u3iv1+/pRqx/5+JL3hmaXXb30wKpdp2YvOaXkx2X';
    b +=
        '0xOz47fY9Yerqe7Mv7Fj34qVXv59ds+i5lkee3KXh5Wj1KwuGz2045Iyrp3xUub5h/h1P7rD/yJ';
    b +=
        '82/OUSfFU290nDsD8U/Xy/2/Y54ajtJ9ljL/ruCUu/d+Gmhx4474Q/vn7i29h58oS3zt1lxyc2/';
    b +=
        '/uEef+47qrGzaMbX/vikBtKH6eNZ35+yZnP11/WeKf9349WHfZi44D0SblzZ5u5F5cd8wp6z8+t';
    b +=
        'nd+YevTK2twrTc/u/cA7N+RSR66884/f/W3utFsWXrrbJwOatn/uiz+c0DypaecTmxa89Kvmpms';
    b +=
        'vf/Wvaw+9s4ltecK5b+C7TdWP59b8Yc4OzQPumbvxtR8c1ryk7qIB4paW5p+VLZ+9+eX7m//xi+';
    b +=
        '3f22T9tfm3m2fedfLkymXnTLj+u3vMm79s7OznPv5gyZnLHiYnHr/x548v22H1OTce9MZny46+e';
    b +=
        'uzZy14esbzhlK9Gz7fSy/d3Hr16e3rx8ntP/tuTV1Q9t3zRtR/iiTM2L//PE0P3eu7vzooHP5s/';
    b +=
        'sur2JStuRnf86IyLr1mx5LjDGryTfrXC+GLRC5N3LV25zm1a8533qlfa1982duagxpXjn7to3HU';
    b +=
        'X3LJy1onLK57Fb61s2HCW/Pr6YSees3B0y7jyaSdm7woXn3X2qhNF7T4n+cF9J645dNSuqVM/OP';
    b +=
        'G47/17r6l/Gr7q95dVeR+9PHfVr8afaf7JOnXVtHMPOmXjlIdWzQy/um/A0k9XpUtOvPalU/c96';
    b +=
        'YvTd542+dbvnfTf+S8vPbPsgpPCA5985s6Kp0569vPcg0cN+s9JX/7jArlh7tjV4y4b/rOlF7HV';
    b +=
        'FeP3urdk+eWrZ54zctFzl7y0+t5/XxFt2s06+ermojOq3w9Oti4uuuPwP9Sd/N4xEw+bc8eNJ7/';
    b +=
        'Z+Mpuf5z/+skXnJ96f9cDB6156I119UdUTV4z8oJ9fvHBc8vWuE0bqvdctWHN9c99dOpnL7y75l';
    b +=
        'vw21E8oGZ40YihRUcDo3aWEfu15Mv3JPqHfPkxI/ZZyJfvN2J5J19+0Ij9CPPlA8xYTjJ6+Ys56';
    b +=
        '6372/qa/3d/W/r5lxwJVFpWnlyoGDBw0OAh3Vfo7f7/y3/TC+Rk5f932P+QnDzuoPZy8jfXeTQ1';
    b +=
        'jm1Q2ozGevWCyw+KZck/Fsd7q7C8V0H5kw73P0nuH95Bbu+sF9V66EwuzWpIY5pmm+s59GdEvVi';
    b +=
        'erhX1I/Pj25SK9Rz59hugvJOWz7WMCO3VZuoyTZViBROCC9424ZWiniunlBqxolLkQAZVHlGZWi';
    b +=
        'WOq1cSeKYx13YpW1dHarP1orIW0Iu6AiJpY3aJcp/J1Bc0slSsbHVpIJXxirBsPUiotW3tVo5Y1';
    b +=
        'Izgb7T6sqeNrJRqfJXLa2DolQ0EOg4vyNfOxKp7gJWMcsjT7o6VDdlMfVN9cx2FxrLNTWogjcrJ';
    b +=
        'KP9wfCtfirvWOvK43daiVkW0ljJc+VjmS4tXLVYy9uJjFrddGhVfWt350rEFl6oWT50zrdOQ9Lu';
    b +=
        '6uhH3qYs79ZVZejy02VWlWqATlaQJvmFhYGJqm+vqK7UNZMQofbGqclRyuapy5CljhmrbwZnwrf';
    b +=
        'RdF46JfW2vGhP73uZnq2llg67YOhalB4Vn1D76BXwP6PRsfXNtbfvn/wzP7f5N9bdd0zeNOdQeH';
    b +=
        'Dp2aNEx8I4fGrGNJ19+INGb5MuPdrj/jBHr9fLlXyT07v9a31OGYn3PI2Pb63uQ7bjY84MwIpRx';
    b +=
        'IZuTPwoALxubO/3FGs2t+1v0/wE6O7NAL6f805SuWeG6WFUIW6oxQ+qbiopq7RhGm5qV92nr5aL';
    b +=
        '1cF3hSMCdClxb71wN15WfOyCW1lbuh2uKpglAIM/Bb/XOOtJQ9Br8VrEc+aiEd+x4D+XbjPtSVP';
    b +=
        'Rp0ofYZhhv9zInbjN5j3bu382J9x5dCQiUNDaSlbDuybUYFVQWTYFyqfYpzKPNxYvnO/H+Szvxn';
    b +=
        'pW1WaCt8LRGiJWLG+D60IL7ypdZwdxi+H0BXCsvuEezWUDm9frehg73ji6Y82MSODm2w3Vlr1C2';
    b +=
        'msUdrhPVtuq3jvnQKslKmoVdu1zwbWx21e/N01Hez/gaUaD3lx3GsKRDuUbZwbVCO/Ygz2mHzlw';
    b +=
        'Tr6qKFc1VVUBwG4F0jBiZ9yJuyOZyGeWgH+u2lZdp/OwBuUqtlq7kpIlU1pAcEEtR36bI7UaVnX';
    b +=
        'f0nIpj3HqzGdsvEr9rQDFLRL1oVCQZQA3gNHld5YwpVZU005QDtCMAS9eQZmV3KmqCdpSdJN+ec';
    b +=
        'pIZVlBWzi4Haj+B2Fe5qrKoY88y2bG0WUoVkjBW0ZvljcoqlKvJ1EFPN0I7o7WcEOPX5noGfVNW';
    b +=
        '7RMV+6HmMQuT0pj8jKl4najLNq7szKZIGGNzfatjdrZBDVTBkfbWb2xugIuAXpsVtxnTxaZsFqa';
    b +=
        '5jX9QLdSTOqGu15H6lYpALs2xRlil0VwsyzChryhC3qgf5DB3sE5LxQpgppp0qIVqo5I251Y2il';
    b +=
        'y2uZHFBX1Vv04heFVKvNlPaM7CAud5r5wQSxUYwjDgV2t79UAkEqOIXiE9h9pGphzouWJv8kNQ8';
    b +=
        'JL/nVF+1IoXUENSrBqB9upFU+wLr3pUQ+p5bWF3arPZBjW8TD3PAIPY1MYejhBjloypzK2s0zOg';
    b +=
        'nhupIGd0tr52ZWVBC1A531foWqa5Lm4IVkxDvLbhZ3Laezq5ri1BbcW2dVueba7llVRPcH2TMrv';
    b +=
        'mcYVYAcuXo41ZuFHZkGkQ+VHx7PJ6wnmjMivpdvMhCvmLwInCzlS3gOWs1/CT/FBvJFSDTr61gh';
    b +=
        'CamizAS0G5oBK0K5ralSW8gsMw6jI5zWADvwi0PhmDenfMzI7I5hIhZ2TBHioPY/y9fZjEaXXeU';
    b +=
        'PAzk1UbHcEzyg/gLTOWIZJ93gDUQaN82PBFi+AZJcu/BXtNxRvm63yZ+IBDYwA/QAcKZLXj4bNU';
    b +=
        'vVu1mW2s01JN3Neie8OYJiqbZ2GdOkXrVMxLF33OraxnY7NAFKHT70N95Ssx24jlrkIc2qB8feB';
    b +=
        'T+IzdtewDAqNIA/imAYs1izFqfQGv7l85b/6k+VPTsybNO7xy/PjKIxfMnj1j9qFz4NU6OoWoHw';
    b +=
        'qdNjTCfs425wB4NWYF4ghMJKC8oqZoqMZpZkE/tiR8V7480IzjJOfqWhrfKygFmGoG3NLqR5JRw';
    b +=
        'ADLDnJHE4g8IDN0nhgQ30BwUsZMoZ/Q+HsT9EHpT27Nx/F1Xy1G4OlMvczGNkxcNVTjUuVP7ap1';
    b +=
        '0eiyUrOg8b4CXFmpuIpcMpsVRQ1QR9nlT60a2uX7dGVo/ia4r3w2puXtjrEdF8hORq7U5Es7hlT';
    b +=
        'WZLNL865B+spSDY26qy9AG7iLd7Q+B+8pGxfP8+rEtz1fnpb4lOTLh5ox395YAIe5BKbydFvxd8';
    b +=
        '1JjKIqL4PP8g7PrICPMoq24Z5csyblsrkWdjYH1q9yOQEs2D70p+he6Mfwrtdn7HKSqxs7ZszYA';
    b +=
        'pKkTM1LQdSJW4Rxvgb1lR/+TkXt5rPQfEvYCc2AGmPw2a16qPZR6N/72uBqCtT3C97XO1wB9Vgq';
    b +=
        'GsdqtiGjQKDoHGjDTfwe9tf8I4wnB/hYkVX1eLw3i16B59R78s97yXvbHlHSPgjZvJ2Op6ho/FC';
    b +=
        '9xvl6ThJb2u49cX2FzOtVe+H4GB7ydWoTH5l8+cTEz2NwAgdqbyh4H5D8HpT8/k5y/9v85ONk8+';
    b +=
        'XvJOVBSf92SGB5QPJbfYYk976TzHmYxHjslDxbnsRED02u7ZI8PyiJVyxL4q9+4A0tuhg+q+FTA';
    b +=
        '59j4XMofKrgMxY+u8HnP8G3+/kzfH4Ln2fg8wB8fgCfC+GzHj7L4EPgswA+h8HHg08lfIbBx4LP';
    b +=
        'p/7Qol/A5yL4rIQPhc9R8JkFn0Pg48JnN/hY8PkXjOXP8HkNPi/A5z749CSPd+XbdfnBsW/XSQf';
    b +=
        'H8FVixv6FnekRkPdaYOQmjK9EnRSDICiO5ZmVaS2J6X347sFxfNfMZO3y5dlFbX50FYm88mdLeX';
    b +=
        'UXFV1/mlE0cfKQopZLL9d+/Co2xUzW9znlkwGCYCU0MHGQVdSyHrDiaNsoeuKjAUWXeDCUn2f/e';
    b +=
        'do+mr9Y+8mGU4+ZVDf64wKHWWPP4x/nfw/r/37ZrW9+rv0Cdu6sb5/w/THlV2y0NoU7DBn7ftM+';
    b +=
        'f/vXy78ueyv11Jv3vvjILmvcW6z99/zLbLMPevuTxlx+zOm/fqzxujd+d/rYHbZ7Zu7bSxvqD3t';
    b +=
        '5yO++/5v6E364/73ymbv29XfY/ehfT64ePH8L+1luwQs7ffIf8c8Rjyz497Nvtbz19/rPX/rkrf';
    b +=
        'S/5xUXdTnVsrbJ4ULrY5UwsXIsB240q3SynZeNj6lTtHlCJSqaOWmo9ulpLupujeHhTH1zTj9d1';
    b +=
        'Pr8sh6eb6iNH88/u7yntqEjY1iNAGaXp4GdGRFXH6k0vLlsnVCOr/l2VvS1nVwzHZF0u7ChfDsr';
    b +=
        'u20HZLZY1lYgPWvSd9PzZhyanjLj0Bnz5xWM/cSkfr788wR+8+X/JjgoX64w2j8/oEN5YIfyoA7';
    b +=
        'lwR3Kwmjf/glGWyzuxqnDx1svD//Tz796YbMO5Xrmymd32txw51tfvabLc9565LGv71u+5Yuv3t';
    b +=
        'Llgb9dOumTC496bNjX7+ty9ddrLrhrz1fOHfX133T5lCsX2CMWHfHraV9/rss/fv6Wu87fcMI15';
    b +=
        'OuvdfmXZ3+8z/K9r/7rqq9TW1S5bt6KiRfOeOHuS78eqMsLX3rg2JXbVa+77+vtdTk46qtZ/iVD';
    b +=
        'n/jl17vp8pzLp4fZv156wZ++3leXn61at98vT216vWjTKF3+/LLHL3vx5dOu33UT1uUPNhy40+U';
    b +=
        'V+BNvU7Uun/dD78CvloQ/nLtpii6PO/iZX2187bn1SzfN1OWHXvz18AOm/OHpUzfN1+VLn9/v4Z';
    b +=
        'euW3rx9ZsW6fL6m+nqfWs3/P6hTVyXv3gzPei78s4f/GZTrS7v/48n3774y/c++2RTky4/2LLlj';
    b +=
        'tvu+vGPKzafpMtnH3ZSbXGanr7f5vW6PA/9HC/e8sjzB28+R5cX7P/QheecOvvSozdfosuPnjyy';
    b +=
        'Yd/l/9nYtPlqXT7/wQ8evO7Rjbecv/kmXb5kddMZL6dv//L2zRt0+eWrbjv/4oYpP31q8/26vHS';
    b +=
        'HIY9/+WnZWRs3P6LLD9i2WLDfvS/+Z/NTurxhzapXnnnv4Cu23/KCLpeMO+jAp4Yuen/Mltd0+d';
    b +=
        'cX5TJX7LvvHTO2vKXLg39RdMo/f3z6JrblfV3+aPiwi3jZB4+cvOVvuvzCGXOz5S88cs4VWz7X5';
    b +=
        'VFil/e+u9NPXv3Rlq+3tGG3iVe/tKUNsar4hT9vGZiU6IanP1pxl1UURyKuL7/kyxXRwWv30JSl';
    b +=
        'qOhHO5Q+v+qly34Wao0v8EmL/rrqJefk8+dpb8qiopqWv9x5U/ir39Rp7rmoaOreV+60/wFzrju';
    b +=
        'jqFqXD/jqqdfsG9nfb9QRAEVFt9313DmhePveRzWVKSr6vbhz+Hllz57yO+39WlR05e4nTP7P7s';
    b +=
        'c+9c9Ew/vdD3e9ZVRm1kWDDK7Lfz23YTj/2HjzAKNWlw9b/smVV/yg7sbJRpMun7p09f2rVpT/c';
    b +=
        '5Fxki4v3/kPK294f/79y431uvzE01cdc9Fpx5x2kXGOLo8/9tLnnp7nPbfBuCQe7/WX/XfR/Qd+';
    b +=
        '/1njal3+Y/r6Kx69btrb7xo36fJ+50S/x09cdfPXxoZYD33d5T9ovPKZL3Y079fllx77y/x5j7/';
    b +=
        '1E9t8RJffm7T3P3f67OszZppP6fLNKxb9+qqXKl+Q5gsxPpi316rPjt7x8rXma7GuCu152Vs/vv';
    b +=
        '69q8y3dPnSH/1x0bxX37jtAfN9Xa6ecutNb5x01VevmH+L13LKTbfOnLns4Y/Mz3V5+NUTH/jkv';
    b +=
        'DvPLrG+1uVR6xfeMvSTPV+ptFLaND3SvvAvH9w09Kpx1kBdvmbg1Td8ddXQDxdY28f3Px9H36gc';
    b +=
        'saHB2k2XT3351hOPO3xKy9nWvro8+g8brInv7/X4zdYoXT5/y5Tjxl695LyfWViXJz14ztXX7OS';
    b +=
        '+9qZVrcu37/rH+y/6/S7X/suaostvLN/4UP3jl340JDVTl/tGK5c0ZnLNmkdZMX2o9nddnfCg+f';
    b +=
        'LtCc7Pl+/oUL6zQ3lDh/JdHcp390LLKg/KE9LqyhF2ZXV1pW+PLKh/T4f2FE0Z1sf4l3ydwYk8m';
    b +=
        'y8fkpQ792kvRRjbxaLk67xj9DKOgu7n67xrtO/7ex3Kyo9iWEH5QLN9Pxeb7eW4Ltc2UQrPP2yo';
    b +=
        '1gU/0hPNPwYdC/wKXXQAWqTku3ydR7utA9JXU66NU8BtdR5L6qAxY0YfhDL1cjaZ3QufUUdWwO+';
    b +=
        'C964xY/o+csyYIu/wWH81WdsJZjXHkVwqIcOKvH1X28BzVVoRAQ0pLTu8oEmX4wfhyuzDYxm6Hr';
    b +=
        '63K7AH9MGYUPXUwbGO7uHDY91c/ntdgY3hFC3jKl2GcmNoqjzggFGVnybP/ePw2EaUb2ddge5rv';
    b +=
        'bYjNQHnlttr/Pjxnadq8YhaIZsqKxszS2qaRi6uqKxUZbi+eFRFfFH91jmTDpg5VMuAE2fGYzxy';
    b +=
        'ZmxfOm5m/P7FPTyzfmbcV9VQvp+3zYznfl2BnuVUlRcgySFWqf5WVYyqGAVflWPGVKweBf9XrtY';
    b +=
        'F+FqNVvz/JUlXuzU7Q9nKlf+UgvNv+NfU2CykToCmlCJKw9HYlEBtO/+FSqlU7Cq+Rl2q1WlSdN';
    b +=
        'zK7HgdXfjeuyuckMTkqBYVPqiZHetZcLJP48aVLSV+6eWzYzthvr388zOS5+MuxM/qzuYUtOv9B';
    b +=
        'o3oQtFzUEfpV96eHdtX820syrcRW0jippKhACrgWRGr7/V+0FavTH2il2v36MA5sd5yL/hWPjL4';
    b +=
        '8PY68+58c/icuB/DS2Lali9P71CekZS7bC/Gq8eMGTPmWG2jTdYKUEw7dKR+qf322pxYr79xTjw';
    b +=
        'n+X12/5xYH780kZ2oWJKpV/ZOtRQj1I+RlctrRDx0pUaFxirnxnraMXNj+7MzN16rjm1mk3nOl1';
    b +=
        'cnMS15+yPRDjeVed+hcZUZneAoU59TdLJyRKwlHqmHkO//+rlxzr475sb27R/OjX1GOr57TfLuT';
    b +=
        'nOXeOmM1VYKZUuJ9dafzo113kqf6mtkahUXl5SYpSVlpeXDKnYbsMvA4YOGDh40JDXU2m6775Tv';
    b +=
        'aOyU2tnYxRpeuquxm7nnjpXWQdboAWMMZNmmY9xq3m7ekbqz7L/mV8WbzM3WlvK7Vqw8+9wb0cL';
    b +=
        'vnn3OBbv9YfCQw2d+9fWYsQcvOjb93vpzz7vwotvve+jhp595/hdvv//BlqLUsO1G2jioGjd+xm';
    b +=
        'HHrj8Pbt7/0MPP/OKll9//oCg1aLC+WzVu6rQZhx3HxfoLr7rm+ZdeHjRsJFyasfCYRceluTj3w';
    b +=
        'tuhytPPb3z/g08HDZs6g4uW9T985LHHf/P6p/845dSzb7rlsceffvall9/8/fTLH33xmZdenjF7';
    b +=
        'zsLvHZc+87zz73vgJ4///JlnXx+2407HLPri35u3tNSd8PbGwXvWZ3fbPb365LvvWfPwIzvutMe';
    b +=
        'e0w6dPee7Ry867uQ1P376td+89ek//tWYO7+p+dL9x4y99Z6fPP7sy69vvHLiZZej8/f81WsvbZ';
    b +=
        'k95+hjSsuGDD1g7Mef1GeD8QdPnnrBhfOWND/3/Cuv/u6NDzdvKapM771uY2rdlLJdUyXD1m4Y3';
    b +=
        'HJn8Z7la3e1dikzUmNTOFVqGaUlpcMq5g7ZrnRBqZXaraLcKrNKLdOyrIGpYmtAiTF4h+LZpbuW';
    b +=
        'Liw1S3YcNDd1iDXaMlLDSoYMrErtvl+6si51/H4tzxWvu9caXrJuk/W90h3Ldy7ffuD2A48vqSg';
    b +=
        'ZXvK90oOKp1WMSg1MGZY9YFRqeMkAq2UD3Bprz7JabiqrtoZY1aVh2UHF67YM27ls7LDR1l5D9h';
    b +=
        'rSck5q3WW7DNjhjEuKxxaPKzUH71ze8tjeTQNbfjt8YHHLluKWjQP/eY0VlK9dtH3Lg2Utvyyu2';
    b +=
        'HmcVVESlk0rG1jSNGAP6+jU98pbTtl5t4ody2emWs4qufOmgTul7BtSa9/cv3RgcXHLLUPX/qvU';
    b +=
        'qDywBO6em2p5zNrVGjKoqMQwYHBmcWmpWVZWblYUDzAHp4Yaw8ztir8zbHtjB3Mnc5dBuxXvXra';
    b +=
        'vcXxqqXmP9Yj5svmq+drA35T/1nzdfNN4p/hd88PUn82PKz9NfWkCoBoDDxg3Yfac86+99rpVZ1';
    b +=
        '986Y0/fOi0+0pKy/3xE4767JVXU9vv7AdHLVxzx933POq9s93pZ553bSskKkCcPYeLRQ/8ZNfdS';
    b +=
        'ssqBmy/kx9V3Xb7794oDy648LbSinETZOb8i7Lpxz/+5Gj6+ddbrrxqzNgDRiy45vobfnDTrbfd';
    b +=
        '9dAjT5UMGLjD7lUHTz3illtfePH60l2G773fhIM//NsnW55+JlW5z377j3DDqumHzZw7b8FRCug';
    b +=
        'WMyGX5lasXnPWTXfcc+/PXrn7nvrsxcftvarYSo22pGWMHdOybnfLHrJbat/yPYoPKp6SGnxgyx';
    b +=
        '0l+6b2TY0owwNmH7I2KN+xomzncVMji5WVox2L97J2LTYmhqnDi8emKkrLSydWHpAaWO5bVcXDS';
    b +=
        '1MDS+fOCNxBbumYsoq1+x85e0TZgTsO33+37Xcqnw0vmDJol9KKkullB5Q3Dzh40oEl44orSo4o';
    b +=
        'MYqHWsUtZ9M9ppdVtNxy3N5TB1SUDPpOVUmFPyq1U8tPq/m8gdPLK6ZN3XV62bxBM9aWTqvY3Tp';
    b +=
        '0RmANLqsoiUor1vq7tPzEGOIMOuUq2Tyg5amzZrJB68ee/+q6Q2/46bqo9MDUopL9K6ZVjCj+zr';
    b +=
        'p7jxGHp6LSYRMVDFz2Zdn63x5YfuOHa93R1rBU2dpzzkwtLR5klZcOvWjxoeVN1S1fVOTKGnaY1';
    b +=
        'nLl9gMXlu/ScvraQ61TJw/ZYf3cPVvePajlN6Ot4Slz7cQ9h1UVG+vfafn3yJmpipR5yrApM8e3';
    b +=
        'PFFdYqQWFO+KzbWDR6X4wKMqWu4Odx80KlUOcF/ScuUpv4NBD7KaBn6vFHbRkIGpEAYzomzv2Wv';
    b +=
        'nD9zBKrZKy3e3BhSXVFSUlAFWbfnlfhXrS7pF0Ml3WvkUxDj6wqOGarvv4Yn9N19emNhR8uUjVa';
    b +=
        '7H7uQSmlkCX7rBv8Hzyn63IfEE78z01mdjv6AupCqVqEEJhRh1vhl7jUyoRFpI0El2T0lVFl1Yv';
    b +=
        'Ljo2O9cX7TdTpV7DqxcvOcno64/6EBUOSp7yzujzNsWj97jq8VjijZX+tduWexvMt71jYq9gn0H';
    b +=
        'vRvcOZhEY3e+IUK7vXvoZ3vsNfPT49+dMye719xrHrlhbtHL5Ajx6g1HFL2515FF77w7D71LFtz';
    b +=
        '93g1HvfLnd4+qLKpf+KmxZWFRQ1Fp0WjDMEz4Z0wfgHYYaghAkqZppPYx9tj1mAFV5eXGzimjHH';
    b +=
        'BK8UFWddmBOxuVAVRIlQEyLK0wdzeqVPVUGTxSYQ43TDMC5JMyAfkae5iWMUCVi+EBY3tzR0BNV';
    b +=
        'epd8HSpVWHuYYyDugOh5ghoHloFQDBSpeYA3arqErzUVOXdzMhse8vuxnQjZUDjRplxhGGWDiyj';
    b +=
        'hlk+oOQwc1ftvR8MNuCNxQOMfcsNmTJKoFPmLmbKGpoaBD9LjCEGzLu1u7kH/JtoGqVlhjmg3AC';
    b +=
        'SYDSbexvLrJRZbpRYv4dJgN6WqhbNspIK00B72ikE5WJjRPlAsxIGaVihoTtiVZWZ5uWWMcgoVS';
    b +=
        '+0zGcmFhlP7lVknWssriwqyZhFKaOi0pxrFinkbOxiFhuXmcO3G2TsX7bLgDEWMtSUHWAcAjNvm';
    b +=
        'gNhXGMNF1o1zWIY94FmmfGxmjYDgHHoUCXyGO8Z3y8usmCUqRFWyrgZ2i8yrxhgp1YZ/pCRMMoK';
    b +=
        'y4YWS43x1r7FRtkEY6CJy2G3GmlLTWSJcb1hle2gZ9UwdjQGl1rFT5apgeykZrRELZJagI+gXyX';
    b +=
        'wvau5oExdOd7QlQ1hwYIWF5Ub5r9gPQAajAvgbSmjsmJEiV6lEtMaA5NdVAqTYRy5I3QEWjmxxF';
    b +=
        'KtwgxOV68yYBxAF4uMg1NHqN9jzJ2KYMyp4rIys3SP1CVWUZByyozBxo7FxhBoaZhupRgg1hifK';
    b +=
        'iqtKy1a3PJpUZx8fMDOZndhGLeddkpLUUp5RRnXqJ8vFhd5yiadpsAYLxEgWafTy5Pf6UwuHfss';
    b +=
        'V1XVEBHKgHGHIN93XBwY47qtFtdJ88ZsQ7pRSKgMkhoPPU8G2EWC0dA8si1vZ1WmrqGq6tDaLCW';
    b +=
        '1VVUNjVll0Y/bW5JOimkvcEBG9JiIuIsFCaHNCL48j8A/P7IFcqwFHducm29rmdAu9K2t5stpz7';
    b +=
        'WF7QubBIEvRBRAs4xLQZDjCe5jIrFMze7Y7FGtrdUD3s23qX6n7ZB6IbF9RH3E7QBBe47DsO2EE';
    b +=
        'Q9sLl1HFvc43bHLqKomEGNE2gzmHVHPKzmqYzdUttlZOmtsVVWj0O4H+b4kxbTgkgjOI1e4yIkc';
    b +=
        'D9q1Q9+lgtggUXMuXFk6t7uViLOA5puMS2mHMsw9ipQigAuPQouuVNK+h7EPcrgjnLIF3bVYl0u';
    b +=
        '3b7QuFyerTXOEXCGo8B3muz6JFLwhW3Lm+h6I+kwKv3xpx2YnA8EBinJI0iTcTsf301oN1LraHV';
    b +=
        'LmpqOIUhES35OYCBmqRfcDSuwwCAIYmoxoUFHTabbnTJmanjVnyoKZU+FKfaYp37rycciwdJwkI';
    b +=
        'duYLngwTTnzGIlQ5DM/JELNFon8yAmIS30W+pSFA2RX65ofUzIemamtTSvvrNYFbpeGOO0GIWwA';
    b +=
        'GnoAsDahPrxHcIoEDYXkLsHSowPnKb+MbK2IUx2nte4rrTyAqqo09QVoFstbgVksT/uR66i9Aas';
    b +=
        'KGz5SjXJbMI6VvoUgT1I5aGGvjeZ0Fou2uWJL04hzwojHoaeSeo7CD6GLCYXZdxxuM8bCwXO7bz';
    b +=
        'hOoJ20GN9GUWRHPkwrg1+OVHCOcBiKwI8YcxFHzB9y5PGwu1YCUExLMhPrAcO2TZPGJbmCgddn1';
    b +=
        'YW09IIIOxigghA7sBWUUO5Sz6cODICHJCJDWb7NJQmEKxiMf7cizkMLbinf6Na5gN9p4bg8ACjE';
    b +=
        'MJt2wG21cA6FtwQkIJFHQ+kMW9LPlyzXiZjzr4lLaYqpCCQOqYMJ83yhEJ1gAXJCSagdCYzc7Rr';
    b +=
        '6+aLklkod0rrV9KX5cCXNfZva8EbiBTbAi3qjF7DIxxRhP2Q+peg7S7bqje1floZV9iNOAkfyQA';
    b +=
        'KgwoswCbgnhE0D5HsOFduHPeHc5nouZKYeGFJAj64DWNGnPqGCA5zvcGhnsFGqaNSKF6GQDiPPC';
    b +=
        '5krIj9ALiNqGUMBPwgJcBAFOPLwjgvyDS0UdBJwwnW0dmVV1Szt9ldVFTtf5xuNS2lPAGyEQE8A';
    b +=
        'DgkQBNVs5MK2JJK4IqTIZztNyze7IFPfFE5SAQiddrJwaYiQ8AIUAEy5TIOy9IFKwRtsxuHWzou';
    b +=
        '6aSet0tmmY01eQZvqanwxDWiUCduGHmIgnbZaaEAbPLIDQHk8cKhv7zK3q9ZzzZTEv5IdkZTTxA';
    b +=
        '9l6ALmhIF6yFcIglPB/AigmIlAMM8dPrOrFtt3M+mfi0LkYoRIKG2PeQo+nFCEHlB+ikMn8pi9a';
    b +=
        '5ezmBNtSB6AD3YjCm1gQBByJOKqVzZGwsXcDZ0gEJ7wdqvujSdiKvQuzxRF2PY4Ch3bga3iy93t';
    b +=
        'bms31TSqLV0jgXogQMmw+oCZKdnD6bZKXQJZNVISL4wcwFkMiUg4e05Xch4sbjNQnMT6pPB0bFq';
    b +=
        'sqor9cOCW9ihO52qUk2JOsYCYM+JKBijDU27wqHJqv1oSK4jmJCPsU2C3Qo4lIYCu95rct2bqmm';
    b +=
        'vTDdnlttoHLoA0oDTb9QiBxYz2ruK1ddpfrKrg15TkV/WkCVA9uVgTOggzB0VC+MIJuLNPCG9Ox';
    b +=
        '/nFYCfGacWqqtry9qm6zFVvpcABRwA2kS88xux9D++559pM22km09kGNQ0OjgLKIy90ie/DXt4v';
    b +=
        'iBuD6sAGx1rwqqp5TY3zBGlkNSJPoWt8JjnxWcSjkDm2zfYf12v/eWYZAF2d4j/cSEZRwF3gRhF';
    b +=
        'z6QFhwRBimR84q8wS11mBUeucOwp7M9vxBaA0wHbEY2iEXdBfrfBPqLGS7tONaohBRAGZAiPNPU';
    b +=
        '6AwI90C6poL2zoWjatf+n42Jwani04RkGgQ+eASz0QtYUPtlL/OrI0eZ2q4ToBMBIwLTwQPJQHh';
    b +=
        'b0Cg2wUQoNi5BPPi3CIYAM77ii3y6kEDlXn+E4rXrtGYl9RUcawSx03DEdP7w8U6F2QgACiEuDJ';
    b +=
        'E7aHQolxMGZqtR4rdBs+C9piZ0iuMn6HrIN6SVT2hKRYA1MsYFGRHYbMo5E/dlTBw9PygQEKqBS';
    b +=
        'JAzbdlwjYDM8F8igEsquhrx1fIWjzktYX2MAy2IhiYFYcQHnCnlzwqPaXTL7SipcXLFOnD91QHs';
    b +=
        'qtuz4AjMFCDexIAg53vG47mdbBbo2K0tfYwI4rqQK+meMz2x2UTjdygC+hFxPbhcARx2+psFoAD';
    b +=
        'h0qrCYZwMkB6LMpixzkBd5IHe2Vyao14uorrW0cisp4PLRhSXDgIRtwkz+vuqCTtDlTy4WC0bmE';
    b +=
        'T+KkQUVbtJ+2hSrkB6ZNh/6kNZjXeAiBRMGAEHLsAs4OpvZ98gqQr6QMmETY8NSB6RB+6MAzDZl';
    b +=
        'a4BNUx5oySiCtU3sc/qvLLlNDByYS2OwAoMLjvpKTI+DfcyStiIbagHVALKCb+XMX0vkDU9Ss2T';
    b +=
        'YC8dN1XQd2PWJVE7pernik+egT7YnepHYxsC1UAFsJBBYBwUTjsJ71WIhRMSZVVXP0/5qBytTXq';
    b +=
        '8ZqHFhsYA+Rx1ng+RxXj00QhkIvemSsplF/N+ofIK1jgWByASixZzty/D4F3dR9UysgUQA4GwaC';
    b +=
        'EWWITKjucpfrfI7xPo+1lmmqaysxigHOpLYNGyA8eGohyKmNOkXAlfi4lsbqI2H5G4RYmk7iu9I';
    b +=
        '6shqIJ2Az7jgewb6NbduZWN09/HeeTuJ4wvEiYNcUzRRo0vyuxwCYW7EwCizVfRX2r+rPbq6bkA';
    b +=
        'wQgDIepEIFHrA/LvOAwRReFOHJ+7YLhFQ++5rewMZFLnHsUMnJ7JCJXRGq+cuzC8nKQlq1oilNt';
    b +=
        'fAHW9CHEatAaJB5AzeYMqlXBM0Bx2VhG+tzODSqxAEwl04YwVqHTjj14MJVyKk35hGs3vhcD1Ql';
    b +=
        'LBD1egYRExKQDkUei5T0P633GYyHmW3Iqdtwa15NbXWzOgNkAnQwV6O2iUMQdnzpBL60Hex6h6I';
    b +=
        'ed5hCaLYfObCX/cABdpTx6TOrO+KjeTrWa6YKVYJetN5tj1xgqhRw+p4EXkpKH9sqnn3GoQVQpQ';
    b +=
        'lStcrd0Qm1a/eEZh+3ongBzbh+GAB3EBAQFg777lYStSRYdmW6UZmrFXUiisQ6HNGIesRHh8/qO';
    b +=
        'PH5eZ/RadqJYmBgQprpBC0vaFVNqAgBSBjQT0nQTKdaW8d7ol+ABUNgDJATgFRmYzFrUu9bWBOR';
    b +=
        'JOpa4bOAAcvn+/BOl2Mvml3dK9MF/dUrrzrtMIQBbDkQP4fbcs7UXrmuGAXFv/Po0aXcBtZVAqe';
    b +=
        'CQhAD5s6o3r9r4OkBcOIpAQLnkRAHgBJJQEV4RNiX8Sg+EDsgZQNHh8MA5D3mHIl6Y7hBFsduEH';
    b +=
        'gYeb4PUvK824zqdtukuXEZcHbJYYhxWanv2o5DhGG1P6RQja8vTeQR4NRD4nrVuXw7usn4PKIJC';
    b +=
        'W5UDGHEotAFmdgVHOS6YP7kPkIKsGog2WkuAsYIFFdw6fGAe463IOxqKyUkJqb5CavggpBmO1FI';
    b +=
        'I8lhhtFRB/e6KMnFdIyOlFhrcxGAUGS7mPkL+7/XJnEOgyKcx8ICD4AJAJTNeMid7+I+KGxqBA0';
    b +=
        'COwJqxSkFMMHfm1fdmUkDueZIFdKu4LTTTXWndWbjqZEOB+6N2bD9fccO3KMXVXdcmXnihDiyH5';
    b +=
        'altd0OtyYkhEnE6YxAsI/VPthxQLp1HEm464jgmEQWa412hBnR1st0bLps3ZEggQoEhMUmNpGSi';
    b +=
        '0Wiev862H69QE2H7hXeVbSvrQgdPEG9xqN+5Ht2hIOA2RE91iuA45yGbBhk8q2UFdRVWxV4beC6';
    b +=
        'MUjJGCoF4ripbbQmEZ60mrYX+ULC3vWFz5HLQpB5UNqJH04sz8pok/gIwcZTIS2KMcOhcKRKt0I';
    b +=
        'iDEh3cVWXnLTG0/N0zg24lxG1ajUQsK2ORC4WvgvijEfsjjry1nI6VsXXIGCKQ0GRC3wrhxrU72';
    b +=
        'GCtDo9niHkusA2IuCNgyhgII5Vd8VVE7UxajMUXl+bXeLk/6/xQEjwbaXHl8ImIH8maF0RJMWlN';
    b +=
        'tVkea6VBMNFmNKYPYFNDwNXGa8V0mESZF47UEYuikHaqa/evx+8SRuR7JGjmdBGQm1MZRhIL4xA';
    b +=
        'ppeBPLTDeha6FChSTxpqYLsk+bnV6LNLmxsUfHEHWGLhKNuDK1y8ZFJnnKx7B1OhsHJh9xKES4A';
    b +=
        'fo7B2COAkYDKqObK6YOslXzpuWold8HsG/OxNHobdKB1Jg9ChhAdR5vit4Tg6rUFBpba5VGY0AD';
    b +=
        '7bjWxgbSN6/Lg+0dFGsUxBX4S5ZB5ziEtJSIOlh1UnNDNvB5wXp5DpScqMga1GKeWoZ3NMODBHm';
    b +=
        'NSO7VijQ4WAAysRSU8ZN2xhe3V2DwIla9CqROBzQTADsVJlNvJlfV/5qESsVdyDENIRknoCoM/l';
    b +=
        'fnZsR4ZVb3AopoE91YYsDm90cRTZxOEYNdjdm4aS/5n0QFCT2AkIZsLHJ/SLKXadNr2HEA7IlyE';
    b +=
        'VbuA51G6cWd2FLkqj0ENUMrOewTJ0fJcI6UrOQ19GKNfbCknJCMGCAoYhwN9HTdN6FZtg0RSV0v';
    b +=
        'lLWmUnCjyvC0QTRNAokAFtruoVRtMqtlEjSN/BYegCSg184Drpst770Fyvko906oMA2uWFgggHd';
    b +=
        'gxfjrtk2zvuZGCgYK4CEHmJMjmuCNsJqDr5TlWVTkgPfFz1fLUp9P6tiRwWUu5IPwy50rOvHN8X';
    b +=
        'JW/MdSvMHoGsSUInYsC5hyE58bBEfZGPvM93Igm9VyRJx94rLBVfiGPeFboF7IYYc0PPC9xIolW';
    b +=
        '9s9rJ5DscQJk5CKMAYTd0ThoXcxcL+4QQgHeLUMhtlYoNNuvqw3tduUZgiwhs1+Z6lRoFeI8ldY';
    b +=
        'n0DJws4FKEuB/4BFD+ybf+77HwMc/qUIcArDEPxBPfx/6abYhTW4xt2Nhao7oHHkXzUel8kLsil';
    b +=
        'JRSIqLIk7ZPADjXGUcUiBWFCE0zzPlZmwZkFvpYiNoSLZBClAEIpWpfc9dDgkanGNucfdXviQIS';
    b +=
        'eFFAQwrLgghdb9TEjGgBf60d6vPYXCc8akwo/lyysjZLCpTgCWswObtilljQAG9sUtYAmlUqLaJ';
    b +=
        'GREFADpkIQ1ueavjJiiU5BEC6IMuPEqx6/qhJWo2j0vppBYgfOqFNgbTZoYP4aUZ1d7YAmmlanl';
    b +=
        'FULRbhtFHA5bBBWRCBgI99QcnpxkHtUNX85Ds24QSKqNkgLyDHAzrFzjCGddIVnWnUFG6PdH6Rk';
    b +=
        '4nXKq95+YnW61v4eOthukeqY+An6OfjRxVGAv6a+tLxbYocZPtnGRP7SMjjdJyxPGYT3/EdB7AL';
    b +=
        'kuJsY1yvTQDzmMgz2Pa5HwGGAt5RRmFwjtEfzAYTKZn0A6xddkR0ruEVQH4yS00KFOOIl3RCE0B';
    b +=
        'Coy5DHrC/iEvunWf0RoERZioiSrmRBAhGeb4xpivsk8yOVo4ggTiRsEtB7uH+BcblRqFNR/Ut12';
    b +=
        'ElO8yVXsoEZjW8amCd0H5j6atHZXKZpmwj3OywIZMbUGWZ+pVMukQw09IlBDjViDL/QuPYrgRzp';
    b +=
        'WrvVTQHhk4JCDViRZuhBfseshHmnHHsuQRfZDT2W8U6OdM0qZ73LP6oqYCHidYuUgEkUgigbyAy';
    b +=
        'ssi72OhdYyN9HB/e1Kpdx54tpATeLHB9isUlxqS+mlRbOQafRwRTh0qsuA6Hf9+Y0CPiWdKYXZ4';
    b +=
        'mddnGJpVFT7EcYRQyrBhNGA6l/qVG0BFHqrymCYrUbhkJv+vbnuMDPqEhA14niC4zpnVv4AAco5';
    b +=
        'W1XSExkJw9Kh3PpQAeyBGXG6M7TqZuQxMXvaFszO1QYKQcK3x5hTG1ukBU70nF0E4/y0HyBRYzA';
    b +=
        'D5TYkKiK42lPUlf31Bkc5EMHAawAqTPpQJfZYzpuFIyU5/J1aSXxF4XDqbKE5ECBy2EF/hX91bB';
    b +=
        'U0Ys7lFA7o5wPO8ag3TJtbQNBGQaIPXQWehptnu+YIJm8ZVnIJAQJCICM8cVLsfsWsNtZyuLUcw';
    b +=
        'x84/VfJ3yeFUrTAMsgaklgWtTlZX2uj7VEpGE1wGuV7GXhPjXG/XV/VdQTOJ92NgxE4cCkN5hlT';
    b +=
        'wWMN8NyA2KYejbBM5vXKl4np7nsKlxZTqv8WUhFy6wJSG2OUX4xv7uW6BAYURt6gXIFcBy/sC40';
    b +=
        'ui7GiSe8J6fz/Ny2ts3q+lDj9MIokxWJ6fRJmAKGJ8FQciIDYLUTf0dnoSJgXF5tgcwENj05v42';
    b +=
        'EDlA4bEkwI0xoNjsFmN2jw2oRI2NynzNs+nkt84gGDOFqke264fMxb7rUUGxc6sxsS8NKqtquqE';
    b +=
        '5pziBkAfYDyQWPvZgUOI2Y1q3kn2PmAuoBSMOinAUeCCqebcb47vjGlsNr+lkY8WKZw6CLXE9H3';
    b +=
        'MZEf8Og1Z3ov0wCtWJwusF5+UBXENhqv4Nz87QiK7wdg0hriuJ4/tB6NhY2HcaPal6tNtbjaNc5';
    b +=
        'pBtu1I6AD9sg4F7kFYaBW9W6KMGmMEwxEjyyMWKmt5lTO9KYq8lJwLTNBP+h008Q+nSteyulLmt';
    b +=
        'TGrgeQrX0FDYjgTO/G5jTo9rVMD/6Gu6vXYmeNd1gNkmPgkDBkyKd49xWF+U0hqz12tXFp1xN6N';
    b +=
        '9KzziId91XW4jJ6SuuNdg21SmWaKXgdiMUOIj5GOXyNC9zziy77rM7ozWgFsjpbnFAA4oCMUPjd';
    b +=
        'rexFrdng6dViQKvqoLruuYdLXp4Cv/rgmtj4No5NoRlgiF8C6guT9KRKOCiVImi4SZCYCmMccWQ';
    b +=
        'Kc8zh3/fuPwfprg2knNjAhbIkCBkWJ7gx/3VRz0bNuJXOV5JJgLGP4BY1ofu6FSFRcYjiOPcYox';
    b +=
        'iDpCZTNwfmLc9C2RB+CdZ8GUNjTXxkH4faAT2h1RgwnImhLbysdFhoL5Hn3QmNA9E9kV80hA7A1';
    b +=
        'BsMUgZinj/E9745KIytkgXRdYx8jjEXpoa7i+rpiKDlxfTAhthyPXRYGPiGRMOg+32/xda4VnZp';
    b +=
        'eLxulihZ7KTIFimAhBgSGSLKQydDB5pA+NLWho6K4xx0NYcIARaUc+f9S4+39PuaZcwfN8fU2II';
    b +=
        'oEjJITkgbLwPWaM63FXJVltlT+FdulzsOMG1PE5trHnPG4c3Fd3DB5b2JVLINCmUIVPeBGzf2ZU';
    b +=
        '9UV9ECujwsDlwM1KQWF7OxT93GjoTHK7JrgdT/yNSa9iN2fAxdn6Wp4Etz6rPb19W4LMHfohhRf';
    b +=
        'LJ/o1Xy5xcBRJkLKk47hMPGl8r7q9b0c7147EMzEZQy+TEQSccpA2KRB76kbBU1tPr2FPIeFGvi';
    b +=
        'cAiqkTPr31TREQ5x3sKVsuTFlkP2Mc0ifSumpVcsTq6tVKH+EyTBiNHIAW6nrus8YBmaYsAdSQB';
    b +=
        'FvEzktKKgLKSqWHQqrCNkT4nNG7tYDVNaQToamG2SBNBQFCgRAuctHzxqQeFCvaRyqjUHQ6K9N5';
    b +=
        'KskJdyJCsIMlFxGivzBWbAsk0KW2sIM60CbEdoAXBkkIWAIsfwnSVgw3MfySGKK0iaQBxBDSUD1';
    b +=
        'j1LQC8Iofy+MSVSJNijebkfxS2yGrTfuY+gBnggSOCLEXOS8YU/q495fXQLs6r77mTkPpiQAWVR';
    b +=
        'IeUf9FY1brjsifY6B/xecY6CXX4N9YvbDQgy7N4m5FKPQCRu1Q2qENIudLRh9iApprXR0U4TDsR';
    b +=
        'Gr9XcBn3sv/i9hbK601V6L2vHIR8iXQeT8KQfJ4xTiuupMz5SEgICgHvuqFyUp3CUgACoWwlF6q';
    b +=
        'dKE1xAMwYsBMSJ9hP7JfbcOw35i/1LJ9Zx6TSw94RhvkTJ/Djke/MnBXYhRMohaK8hphJtxQBBg';
    b +=
        'TEXIUReTXBo7f25gcOxIfPwJ1p07I5xzTvL+MgtAnUcBtHNrotf5w5QnjMqu5tlpxARM0JGmPae';
    b +=
        'HZIKM5IDchyuhvjDHt+xK/PvFAUtsWSZAaVR4u7AnfJ7/tF1UJEPc8F6lwQBdIafR6v2oLJICfB';
    b +=
        'nRHAhewlfidMa6volQcR0p87MhIBDBkz3mjlVXssFocALxeEwSXMd8mEaMhwth90zjpm+6xREfe';
    b +=
        'm+Y8tl9FRDBkY4cGSFDP/z2Iolul/2rlRqUXiAABwmcgExCK3jKcbvVw2oSu1NTUsyOHSwJYBtv';
    b +=
        'Ux38wDm4f/tWqBEvIoN5T6qxxNw3ckbbaEC8IAptp84uUbxuJx1KDGqcO2FdUtRawbLey9gTN0C';
    b +=
        'iNAqZh5DIVX7xxKzbAlMyy/AbgGeUNE7hRSBAPYJEDiqjzzlZ2zqYe4HMReQjELUbQu0Z1H/wmM';
    b +=
        'ir+okG7u6t4BeHYtlBLg98zDutW2J3BV0zoWT9EGMbItcOQUmlT9kdjfEd6N1eRt8bZiWGtg8pC';
    b +=
        'qfUZ9QlRziOI+O8bTvX+83vxmoiAhklfOTv7EWee/KCd7qaj1aqVi/FBBAyYUuAAf48D/Kdu2YA';
    b +=
        'TMzBRR2caqieNmtyJDej82AyAZf3ohLz9E3shEtzXwf5M+vRD4+pvSSg+JN4SorFP4nA2RnwAQh';
    b +=
        'IJpJwKkU8EZn/+9qYC9o9SRtmBHWGfseAvxrw+4pbW3R7TRB8X+DEHJOIodBXedG1PhH81DuzMk';
    b +=
        'ebj50IJjCtADBYS9p/0P+rpYRzigDMMYoMLU8S8vxmT22GuhCInAYH1PGZwVTBuYWCgTwIWYIQk';
    b +=
        '5cqt5O/GxO4biRvIQocKYwuRLX1pB0CJHZDpPfGxMaX7JrQduMuehETjQs8Wnm8DbvzE8Du5/sZ';
    b +=
        'SRpwnMJ13cPUCrhyGOUdMUizlp8aUwoieSckRVrnefGsjgDHJ3IC5EZNY/iNPCLoJtIo3OHF8z/';
    b +=
        'cYFtgPuG//05jdPfXINsS2jvw+V+Ovy+R00kY9EVojSB3X4WHEQQwRPPhsG9GFzw27Z0dqbR9wm';
    b +=
        'RMAefcCB2S94F99qMOF9JiUQeAQNQHhF32oIzwJ7D32HATYNPLZv/tQR4LkyF3pur6vrA3syz7U';
    b +=
        'cUAwAbZaybDIIYL8x7h/mwgE3ei+vmHLbQqyEBOf+NrO4ym3w//2hAWA2WaK5baJyvSKg6+M6QX';
    b +=
        '9k625EqbVF0T5qbC/VauWxdkk1dlyWkxHTLlQwxbwoijCMvy6b8qceCc4Lg8JBWznuNjxkb2pP5';
    b +=
        'UpDYCPItym1A0cHG3uT2VJaBT5IfNA7KMRCbYY03qKcFQXlAVKXWivpqDUtiOYSKFiJjjCLWZs9';
    b +=
        '88zLICUgf1P62Li85qoyoFdAuSHVHANsPKeWGv2o/8+cJ2R5wQS9k/g+e46s6onsqOSHQEuSjQG';
    b +=
        'MnBshIVtUwGDR8Ep36TyenN6L8ZdDVQKCwH+hP8n5As1rheCFIO9SIIk54T8VHNW94bfPrQnAJ1';
    b +=
        'LPyQuIGMmGTnNHNc9W9uqC08GW+MGIRYOZ4xF1AGm7XRzTHf+RYnfg6BI2FDBZoES5s7orYIDe5';
    b +=
        'SHwsaEY86EPLO3ChQqyBCEW4QiOwyis3qrEIUAy1JGngTG0XHo2WbdNtcFKek9XZMoI0Sgcmo4S';
    b +=
        'jMPJDU6x5xauIJ9NsSCyBzZLnEQbIZIOtG55jqjup1eN5Elp6ivVptqz/CgCoc2k0bex+drAkZA';
    b +=
        'GnYiR0WPMxycZ7KtVa3EQnM77Uo+PkaEyoGU+mGofI1oeH5/9j2gGOoDlOLAp5Tz8AKzZ3t+chp';
    b +=
        'qWz4RoRwmIkQDrvJ1hfJC0+9DKK4CLcAzDvaoyiJOXRRdZH4Ltm5JEQk9BzBzIBHA/cXmEd8UCm';
    b +=
        'pC5MO2CCnwXCA5M3lJf6cMxD/OAx5i4DKxEPz75oS+xZDnya2gwOICuaU0RDwK8aVm1Lu3ZVLXp';
    b +=
        'iAMA5ONMQgz0NBlZk+iAMibtg3r5ML/oSMuN/ukEAt95YAmQCKQIWIRucL8X5HnarR6kBIWSO4C';
    b +=
        'rQ+DQFJ2pfmtabgFA+rh2FyKyA1dGl1l9p4vQIckKpdTkHLS6gx2HZsfcJcEIRUgxkmErjZR52X';
    b +=
        'TFaGOyEqtH3JBJlHpflSYXiSuMe282lUzJZMamba1aH4+FxvIPZUKB/kc2CciBcbXmn5XuZAUoG';
    b +=
        'tJAqa0Id7NIvAoBbaYMpC+SHCdOaarikmlOIGFTZinzE3StQN6vRn1Slvzqgnp20BPmQDQAi6Ro';
    b +=
        'huAR+qDt7ESVyMbU0pcWI6IIWTf2H7nFNIXpaBckc7bZrSXsqOSbYQEM8DlDvmB2Q8zIwXxRAYI';
    b +=
        'OTYwWREhN5mH9D+BYY3SMQfCC2COI4d78mbz4P7lC6wJ3YDazEaKzQ0IZ7eYE3qPUNP8UjrWSwM';
    b +=
        '75CHsA8PmEgYQfWt/ZiEUhFHbYSoOx/UZu83cdrZLagOptW0PBVEAO9u/3ZzZR81Jl5K4jVyi7E';
    b +=
        'AsDEEe5fgOc2uUvIWpClxA1sLxJPKU54eN7vw2CB5nhAc0UgEc0gkdZ4Oa4a306tY0p2ADcMH80';
    b +=
        'HYC5euPCbbvMnuMEVTQWMMATH1fsMCOAHk5/t1mv73zuAxIgCICSImoAIF7vol0ca/p5pFgZ+VI';
    b +=
        'q8JPpRQhDicOE6EUjrzvm7zyh+aB3WYNrEEUmEMcIexwlUtV/Mic0V+3Ntaca4qDZ31Hqw0jH7g';
    b +=
        'eFpL7zaO7V9v0vuv0rj6mOTxWQVkNQC0T0KzjBRiEB/5j85C+ZGyK221oFDJOMRM4QCiI9OyIMh';
    b +=
        'mKB0zcy8RqragdBCr4LsKEcgJyy0+2rtqDW1ftp1tX7SHz8C6tICoWp1sjYKv9T8L0eI7kPhM0t';
    b +=
        'In9sDm+74yDTtYQStcD+AVSEXqB80gfqD93AwJiM1EBU46M+KNmrl+h51sXs0EClSszkhHBnmtz';
    b +=
        '8Zg5va8qb4Vi5jQqXBVjGxVS57kRsRnIkABlj5ukF8/EtsbaK4o1hoxNzwo3FNiWI+UZgW0peOQ';
    b +=
        'jG9s/M7NbE5/fD/d3GdlIeF7kCxEA/UQ/Nxf0K91TJj7FPqNYiDn1im5m67X3v0Bc6YuAwAklJj';
    b +=
        '9h9i2NVKs344z4R+JhLmuzsUmAKy9SIrVB3LXxk99Os0+ZTufgknzKsjQHYVMrPGxBbR66NkAXw';
    b +=
        'uHT5viet3KhZ3Zcn7pOJIHsRcKN3GfMsFvVOvAPmaY0yLmxcRXIFsgYUeQBVKvsrM/mZacequrg';
    b +=
        'SBf5RFKPBK7kQfhcK8FKvvIZcGMNoGpEKz4DxEjgSxpgH7DQ82afQ6NVMi5bSsDuGNAEdn6xVS/';
    b +=
        '85VbVesEc2bV5RbtnM8IIUBwfRPeAyBdNuxtTDI9ZNz3nfigjJ4woB/rt4pfMw9qBnjauxiJF7z';
    b +=
        'ok240cYPShm8KOgKi//C0gE9fBvpAgiAPmdXFIXjHd7uURQNxNJK4VeSIKkWAwmYjJV82TurH86';
    b +=
        '360Rhh281AeTxwppLIdLoSnJtFMfGSZjpsE6h3bjAjNaG8FR5LIQS71KcUe+hUg7O4Y2d50KU5E';
    b +=
        'hAviXIgDhD38675tEuypjEyRy4mwMXKd18zZfelBO4+iGYXrYLvA4jvAM/kgMdt+8BtAsf1scFZ';
    b +=
        'zU0GbCRIAMqoy7SOEiVQJbH5rztoa16BWroAjl4PUJXwXhYCb2Otmj2EG7cMLqgv731PUNHeErd';
    b +=
        'LFwxuUDZr8zhzdtUNOwqHbkjpSIKq8JADXsjdAVuqBy+8DXPjEhb3nOTikhEZMvNlLD0BKk66DY';
    b +=
        'PlUdoMI/d5c2NVGLPTC7goiNMzH0JaHDOAlJPEAPjC0zzz7rX725A/m0r4Fgsxraux/fLsIuZAS';
    b +=
        'pCvk+gAV8m3z8M7pRDunN4kRph6tLMj652EZRD6PQHRhykCw0fR6UPfVkQalkdRivYiAfjixk65';
    b +=
        'H3+k79fE8DoJdGAY8YCA1Be9uHTfVVbRnN+mObEKxABEcSAojxPbeA+zV5gakxbR5K3NNok69qe';
    b +=
        '3GpNjhTUtc+Ux2QsWbS8chAgXIZ8Efe4ENSj3OQTIAllz5B5P3zZO+kQZg//mj2kO5FsBmxCqTz';
    b +=
        'rqBENA2BcmWRSpGjZEPABl1RbTbpri7sROdSJW7hBAXQE/5aQFC+hMwelvdXlqd7qst5iTiHo5s';
    b +=
        'X/k9BjKSH5qdIkdipmKJssUoehQGoc0pUBGihoj+vI3H9ZdvZ1x/7QVaPBbZgUqNwCUO/dD7CLq';
    b +=
        'x1aqcNi0Okn4gbOLbvs8DwunftvFs/f3bma2PzWE63j3Gnc316iSLT/L4KWkRcFpWkd2ZyXdynk';
    b +=
        'ANCglIl4QEEVcKY/bptmYX/vEtsQv/NGu7MUzokwNgng7R34p0bY37PRCpENA9cZH0XMY+M7ci5';
    b +=
        'Ep5LvcSchXzLogrt2pbmYUoQYJ/buadsuPT4pQ1Z3n15CSmPZ1dHp/B4SmNtcBR4HvYj4j3r9Zq';
    b +=
        'reiAkQbCMk0rC0P9bBiTG/iOiLgtMUJfmKO7ER8SW7qNpO24vmNzlbfC/7fZU1LFTE5DqhoVksC';
    b +=
        'PyQAjArSYkS/Nzq7mCblL5/upFWEkEEB+XAFcBZLyPyZqv2nEClajRIt0a95UlRWOOQGVhIcqPO';
    b +=
        'e/ZtQ1/mj3rthBmzgwtNCLqB35buT5XwHf2N8op/bhTV0FNnGJJGa+7/pcuQ7ZX/d/UJvMYYWnV';
    b +=
        'ujHNptjuxeKMjr7geNSO/B4IIC4eYJsMWU3+0Zn2jtSLNvKHeNj5HARBRgQs3Q4a7GCPmjllmur';
    b +=
        'MchLJKBAewPHs8O1ltNTGss4n6jnREjZyMKQwiZlcp21rdhaD2EHM0SQD4Iyks4p1nH9bjlGYR0';
    b +=
        'bT1CZ7yAK0O3C1COfOmS9hbpwVW4ncDuR8t5RCSyYMm/jU62+oXdOcADSCmM+Fm4k/dOsiX2zp7';
    b +=
        'eZVyOY3IADqmFRQF3mnN57byW3faki9aMwoIjzM6yebOPx2Q06qUrk+Oo4dBH4OHTJmdYhfUoi1';
    b +=
        'jGFNZWujymwBl7geeysvswulcCl25EHcpqLvbOtWdVdcelxZtw+ZGmRWJ2ARZCnEuKL8BxrTnWB';
    b +=
        'y1tDNqNnf67+1s11tuN16KGwIwaoPkDKWx+hc63t4tMdYnYvZg3Os+we8HKcxlV6ANwiogDX1Ec';
    b +=
        'RPt/yetb60Ux8SgGWvq2izT0hXZtEF1j9NlZ5Uag4bOCHMIh/nriw/02o1QE+HcShMBS+519kfc';
    b +=
        'MMGS5FNjAVANdeKGF7XWz934od2FUnPQrhMRTywL6k/1OitAqE+whxAHvXdr//TacERdRXGZp5y';
    b +=
        'CiQQ/tSq65nU1n3QF1wGzCfQo6z1FfsKDZipJ6QGpehALgsZFMZBIyFl1kzOmWQVKcjAAFg+txG';
    b +=
        'zevqDGnqzI90wb0aFvAIhG075CBqg+RzuTW+D0kMlKuG1KH9IK6GgYdJAPwrEQ67op/1JbAsEeI';
    b +=
        'RQLiQnu9faY3p4egffe6PDxQsgo3N1WE57lVWNyfSJAcaEYWjkO0zn+LA5Vdb3ZwNEydNziXhZD';
    b +=
        'WYUu4wJ3K59HmE3Wus/iR6LQzBh12njnvDOKIhooxfa22rlLHXWd9Q8qCCc+DaYTfAfAJjcL3ld';
    b +=
        '4naYu8RlV6GklwspsWHBYTIYz6syA3Wgv7b9rrIHkIcEAA5p8ChBG6Egxutab2MUIsuieQyobVY';
    b +=
        '42DXR9AMcSXQFeb8wBrXo2azvdu0L3wQaz1PiXceQM1NVtBVlNchcf5ZlWAko7Ka6vObgP0WoQf';
    b +=
        '/HMFscrO1cKuta0cDiYIhJaIBwZJhm2IV94oi4d/yrbV8q3WW0S3+yi9iLP/P0d/VXbIqHRnSI+';
    b +=
        'uXzMs2NzIxqps0bjFyA+HCUX5fEmQoBpT3tm8K5K4IMcPAYEnpA7tEbv/WJu4Oa1zfQ2VqkCtsI';
    b +=
        'O0hddX5ZT6706rqeOCetqco/WwtUQh8BRPJvAOcCdf2Iy9kgFYoCjdYs7vMdd2jtrYQSwXAfnKY';
    b +=
        'HRIqD9eI3WV1EzbLaoV2CWA280VIAKX6IiKC3219czV94CNbug4DcsAwu8ca1ZUUkZjKalwHpA7';
    b +=
        'hS8aY9JHP77XGdt1jgMskNakTAtdAmesixTfL+6wxPSKFmijyo9DB2OXq6B3i/zAv13RH2PuTn2';
    b +=
        'mCFpxYaAP7YLNAZZQXP7Iq2vIw3m95XWGdeXHmZJWRvFadAFDDCIlsikgQUNg7hP3Y6k45kRwa5';
    b +=
        'gnhAz8okSc8wLcPWAd1mYkxOTfEiwR3JZBHkKNArvnJtpbtQg+4ZJcFLgo9ACT0oPVtBCn+9Nvu';
    b +=
        '9kPbXOZVixoI7ktgHFhkPwy08JhJx3YyC2tnFa24nUsaVZ6TqSdU6xhQcUKzTosfMeBzA8/3AGc';
    b +=
        'IAJBHLLvjRo0BNN3K6dbAngojhzrqXB0Ou+DRrajzmJK4WrUvyaF6j29FQz+zJnXcXTE8J8c8Jv';
    b +=
        'oz7XgEW0ebghBIktSRLiJqt/vuz63JvZBwdWxjnPq0IU/NXY86gFqQ58Lm4oHzhFVf/a2ak0Lq+';
    b +=
        '74kmKtkt9iNnrQW9GLh7RulkjbI9QKBxMaoiDB6yuprdD9OoNFBkthYBnbAJLDF6OmtIjgF5kEZ';
    b +=
        'OurIK2K7gGVdLJ+xgu6N9e1SLYOsRXyPYn1KMeLOsxbqFvEnECWUh7JPPRfbwAcw+7mt3Usuhjm';
    b +=
        'MbD+kgK0jyp63+psmASkdsscR57AWdkB+0e8WnAADLgahBGCTwSz8sv8tRFHgAmpxA8wD5NAX+t';
    b +=
        '0CcMiOQzmzHR56gcte7HcLoW07sMMd5V8jWOi+1P8WQgDrSIVdQCdIaL/c7xaUcg6kz4DhkHMnD';
    b +=
        'F/pfwuBjZVmhSHbpRSzV7eiBS/03VAKzBmmAftV/1sgNvAQkjhuxAC0gl/3uwUWRiD/04i5KhTA';
    b +=
        'c1/rdwvc4xgxTx3AEfrcdn/T7xYE7GSf2sILQEz2qfht/1uQkjqRAAEMMdcJ0Ov9bkEiO1KnmVA';
    b +=
        'R+II40e96xyyYKfdQZosAAUfOxBt9RmNuKCRgESZAEID/vDe3FidxjD2PKZ8Zj/IoJL/vldRp+q';
    b +=
        'Z1WK2kjskoor5SJwUowGH4ljWjHeUp8HM7HOazZ183wI8M2CKMoEFANX/4xqJBEAIzxx3qhhgjG';
    b +=
        'Ofb1hH9k1DzPvNz9EFyWtDkPvEFQth2ImC9Xbaxz+DiJOASMV9F5BIqQUogAX6n3y1wEE6JS5gH';
    b +=
        'zCqFht61XjF6ljASgbmQzLZng7tU/08oTPxPsyuULXRydkU1X1lfWdisXt+D4mbrkrNm5ol63vH';
    b +=
        'SynrWxmvHr2jN0wBYUIqQEdehQtiEvmfhaprN1vaWWAYDPULIdQMURohEf7SqujIowB5qygAY5z';
    b +=
        '1/4lS2IMv4HvAlDlNWfizft47bVp5s8QuYxwWjYcCQi13Xph/0p3euytOKGCJ2RCgJ0Z/6DCd2A';
    b +=
        'ifKlR37HmM6txrzPuzP6z3bc5TvncoprDIU/9latXVc7KScOkCkT7xsmuSS40k9hCmR0mU2UjKq';
    b +=
        '/Ms3RgZYMFtSlzIeugEP7b9aftdYuqOuOQBJkDpM57dyHYE/6mtFOwDqxGGzcxY5gUv+9o3H4HJ';
    b +=
        'huwHzfE6A6lP779bErnD2fJBJErxdK2RTXTanQjIycTAoSAhcBVrDNlNpnD62JvTNAJ1kDKrBQO';
    b +=
        'lhQMRmCj4w/sTaKm+5rlw2OoFEEobiOxLg0OWeF2IZ+p9a9V3YfgpxW/uxsGxtrTZ8qpMM8sPRq';
    b +=
        'C0OL0pkaFi3xIcghPcIW7DAoyx0uPsPqxsvB11JI8ZW/ZzwmYMRAa6Cg8CB8D/7UZcGJHAdrCxC';
    b +=
        'LrAj/mdWmdbrZLN1n1sHd7XSanlzNRnZpC1VTUoWzSswJbVDD/YPCF7MBxTyL2tOL/RdJ0FoI+8';
    b +=
        'qFaiWbvMHprHI9TgJXUBo0qcu+cJKEhPBUADycxmmJ7teKR2Xkdp0TsTTDmAbUSkkCQRlfhSif1';
    b +=
        'vTE3rLhDJ9T9a+N7Oa++AQ75KIEea4rlCHlnPypdVjcqJYGeX7jCseBaTk0GYI/8eaUJgYqQ92Z';
    b +=
        'pA6AsGwB2OIZCj/ax3TCyPRQas9YuSo9rj7sNxRKqBWsxQ2EtAzEEVCR6lc8FfW5G5b77oVfT5F';
    b +=
        '6PgOpQA+gHWY/bV1bP94na6CePXxDnEnXUIdGlHHc2RAkfQ2bYtObt4WjWzpYaRdOHf1hnNqCHJ';
    b +=
        'cJ2RKiyYxdllLyulywuYXphsAkdYGLloxFDwSjK9NzeyTk303hig3gEl2qaM8oCNKnHWpbRaPdk';
    b +=
        'rK7hohNTU21yf+lOo8PUC0wGAKlX6Nrk9txTq5nHiI+cJxONDOAJ2aGts+7LWGqLRlGg/GGj3lZ';
    b +=
        'qoOo49C6gLOEKelpnbtQSVgLhQaVxGo+Z/VM9r8nNQpLSCNEN/xlLvB6Sm72+OeW/P/qaRfMuJY';
    b +=
        'BgBbYXBGX1YdE8QwYEPGmXRh757Zl0rUBpZQHdEM3A30j5yVGtsVYia1wAml9aG2EWAv1+dURWw';
    b +=
        'DN8fOTs3pv3srFwUOszKQBGAbJF5AaZzRc1KTOmVMKUCmMRMcH6cdZwLQ6e6wEyJHBIKHKjvPud';
    b +=
        'u8V+elBideCIka+PzUAQVoquBnjTK2E8E8z+OwICS6ILUv8JNNytGCApguTWIVHMQEAa5YHR/tB';
    b +=
        'xG+MHV4n8KGRKOQiijA14TWogoH9CKKQPb1gaOK+EWpqh5T/LYz5AmlxrNdGXKYAx7gi1NH9rcr';
    b +=
        'QDHzvcmrImApXKTOKPV85vPwkm2+Jt8HxNaly2zfpixQ+BE2pycd5hEqLt3mHbwsNaTAfqAYmMu';
    b +=
        '3+Tuu2CZrRXEkXEFJpI7ZJu6V27ybV30j6CYC9gnscJCVHOkFwdWpqX3zEuwgogvPJ8KnXEUkqZ';
    b +=
        'Cua1Jb73fk+OpQCs/1EcgDVNJrU6g7tjidONRJZeC0PXW+giMJia5L9SFfre9KgFPbU4efg+wtr';
    b +=
        '0/xPmWf7OTn2S3d0ayGMjfCRg0iKkCs4v4NqeP6zVd2m/xygtY1eeosPMdBni0FRTemart9wTdN';
    b +=
        '26itM5yrY7SpLQHRRvQHqTk9JJ+drxZa8CM1Do9dPmdnD8kKnZEwMb67KnsTZ37oEJXaUdyU6tX';
    b +=
        'J1KWuOjgxAoopfBS6N6cO6Z0/bNVtqWhTbWMHGMNBAJKni7Ak3i2pWf3hwFqVrlrjqj3mIuCDgO';
    b +=
        'ggWyj25tbUwATSdR9uS32nsJg4mt6eOrg6T8YOqckC4ejKI2p2VqGW+qzWhwEOsF0ifeD1AOzpH';
    b +=
        'alxfcgSnGeCiNJKAqxgEoVCSPfO7mor9xJYQPi/gO1SZ6DQIASmCEeA2sSG1KT/p7nrirHrqqIJ';
    b +=
        '3BOCCD+IL34IHxiIZHN6GdkJTpEV4cQhTviBaHTqjKVpsT2AP5BM772F3hJ6eu+9J/Tee+8tdNj';
    b +=
        '73DfjN+N57903mUgoVjwa+dx33737nL3WPvus1bW0sHSUZNokIaQGVC9oAOipLmyOW0vDqXUEU/';
    b +=
        'g9USGawcSGZHpR88S+pT+/aA74H9zAxc3W0dJMflm1wrCMinBRGa+D1vKSRq4evjuf28ZrX3M9R';
    b +=
        'YoJBB5Wp6KikJd2WWeAwqps8ead4hCwlzV661mDWhXO6m9UqGfL0SfZw+oszeUDBlbzxrP7TBoT';
    b +=
        'DxRmJ9dWW+Cd7IpxMEswAPaAH2UuDPB4d2UzhvCSTyHHLIQTWTnF2FWjp7IH3hKZzswFx7nIV3d';
    b +=
        '5phFpanYo36vRw/OaZhwnXyAewBwcTHmTEuXp2qZs9NnZtr4KUYs2dgU9IrQK+rpGDqnPxKUdFw';
    b +=
        'NZz0nI8oxbNAy8vpkYNgzbrg5t16CjCEUVD0kZdZze0Ighg5dGWQNTgtLEUYHTinJj47op6+LtS';
    b +=
        'kalQCHnIIDc5Zu6vEFAxDzllBUHRsi8v7mxw7pvZ9ATqyerpwRlQgF1BfIOr9HdMnzoIjpg9YYC';
    b +=
        'T6UcmIyOvBgVxK3L7KMHsm5rxJpkt7aStOSoKiCVrEqgrrhsnVK3N885fGNuxUbMinyx9XknntP';
    b +=
        'r7dl+zlLywLZ5B6uhMxbth/gdzanrcH3v6Z8JlWF6ZCYjUzrpO5tnrrnCLoalsy2Ze1gGcQZSEz';
    b +=
        'xPd23gp9/d7Gi3k/o0peoxlZxGTXPlbPAqhEjRfVvcMwgK+mVDOUhLWaM9ojOBOevvbdSQ8J+d9';
    b +=
        'RAdVT8bUpFWmI4UcPDk72vOGL+U2v6wVEuVImbtIdOG7HB74f61Z+Jy115rBJF5tIKhxiFFXCof';
    b +=
        'GGMmRsWMS9FbVBLJxj/YrKMVp7+v3JiUs3OKFiUTd+GzzZaVxY/2vFGfRDo3WOCMeIzClmw/14w';
    b +=
        'l20fREApQlE5SUvf5dd1+v9AA4KQAuQVWJYHFti80T+4DDz6lyarDg7WDhfmq6fPF5hG3eGkfWZ';
    b +=
        '1S0wUtfYArFyPwkJP+0hKcWpODrOGyVDlcCjEwT4Pm3qbw5eZZo7DwMgxYtG051FEKSNgreFYQq';
    b +=
        'OIrzakDLzFC/LQ6Gysto0YBHsvsV5sL/v+cqc6ti7gtDOIDzRRUdvxrzYs7P7cNkL+f1jQ7yiA0';
    b +=
        'PZcAqdPXm/OO3NoXMRjky5I6fb/vw7X9e/d952srwe+zWoPf9sKvdzRuZFwCsbPRoBNqRL2c8I2';
    b +=
        'HH1Pf3MCY+tYGXuvbzZNWsLKe1n0L+b7TgYoCGvGsoF9DRMvp73ZF6XjQVkc8BKgCsN/wvSEF+L';
    b +=
        'VbN6rSFcx9yHkmCICLkn+/OW4lftk/jc7Yvfbu5AvA5gSRHwyL9AdNVxs8P3dgcq7nFTRdlMMmq';
    b +=
        'mi0ipQG+sPRD0k7jeL0gPSSgrjKPxoLryttneZBs+isiFL9eKzRWqdA0XOhSB5skT9p+LDM3hPX';
    b +=
        'FI4DzYuaJmsZZT8dityXwTcQNWEKvNekBDpE/KxxQ1M+gErkYHuruZmwSuQSjC8WXWZ+PmIs1tb';
    b +=
        'KjJ/aV3fusgPkKAH5aK8s+0XTcdu2oCEXMNMobALsY385Du4PPCYTOTryCGrZr5ptK2ubvfbtvn';
    b +=
        'k1MbF3/7K8ONrIUYxemwMQRvHrRoweP02FKgb7q3gyArL7b5qjYf5O4Qb6b8e4eYgpLgqaWxfAK';
    b +=
        'yX+bpyxBRtXIBojBYYX2e/HeWjoIq+BWpukvMziD0sZv6uBUO1gdypbDlMZUDst8Y/NCeOYIdUS';
    b +=
        'DAojc9RXzqxk+admW3cnpLZxKGgAVY4WG7KRf+4ab9wmmWhgykK4ep//0nUg0CKULJTJQs4UnP2';
    b +=
        '1c4QbyO5YMc8MdSPUQ43AAuAI5sFLLhCcSdiIr0n/bfQaB8+UI+OQkUYIDfb35qhWnvgf7Q8LB/';
    b +=
        '7ZPAZ+mJ1/Qf5X/RWwiH8DVz5rteBujxwtX1laF2KMElAijd7l/3QaBBzClRgzjS5kof/brPPwD';
    b +=
        'NN9NSnGYkySe2BLhjEtD5JtqxrWgIohaz6p/g1TAY2rcpXqrQoaJqjAjHSOekhG8iXkjMN2l3dj';
    b +=
        'r1pccYp/2B4GFr0BAgfnnRdAVV5Kth3W57Dr5FMmT9t18tk7T5mYmHzu9p24BQH/qD2nLJyzOkY';
    b +=
        'lpKaAyF5G9GEHFE/fMbl719lnnnRK/0AVvPZJKoOmJTGKl5NxhXhPz1O1tjhVa4taJVSs1BINOe';
    b +=
        'MryIA9fMwZswtV3QUoDbYjGKsluifxVxK+xPOnerqYO3buOnHV940AfnyhXheNxbNXkc1rFQdgt';
    b +=
        'Ziq3ciFZwBLtLic4fGG9GoyWvZilaR9CSxxhv5XArVs7WvI4/oUF15L3LDcOrO4D7h1acvBTujs';
    b +=
        'AEAkA6uHzfZ1ZFhpbBbzct9gVQBMFRMkl7CcxNeTYUkdqGHVGJ/GLrgks/NUJzwK+QaihwyrxdR';
    b +=
        '2oDRFKBmLl5aiF84bCR2QJ9ocgSAgpxg5YFMnfeEsvImYAUNOww3GmlnarUavgkgsMw+5AV6UeT';
    b +=
        'NZvzcWj3gSsEBAJucTfQuRQ2cU2ljWDbWEBrWUQj41nKq3kqesjkZYDIJwMhQDaIdmLd9G1jR+Q';
    b +=
        'N/3euBqOQqTNA5wtubO+eBoejtRa52JbV9GTVOLe2th0wmaguIQLxGF9t9B1oGyi5A0AwykKPgP';
    b +=
        'E/Wd5PFt/Paqhu9aOyL6ejRRMrteSChOjUHOZ6PQ540cuFCVhKYpmu8BRhI5aclpeTc5fkXluS1';
    b +=
        'U75kr870O5lPrj7N53z4/1Tv2zoDuMAqTpiSe30NO6HKBuu/ck+WP3FpdhIY78Jar95LtXa4Q/Z';
    b +=
        'KMWnW6ArSpOMQI5Tyo+D7SzMxP8fcT1s+ZgG1MTGyfw2yMhqSTe6pQW8oMDyJQQH4yafYB0nEbR';
    b +=
        'ZdkEi8wRgkfovgg6UjQtGNasYKNqUGLqD9EnrYy5A6ZE4kCIZlDgJcKIRE+3PUj4HUwEWCe8ZAp';
    b +=
        'ROpHun6pDK8T2BSHzMWz4OWjHZ4gzT4mB6lXGFhDRTq/wxh41sYoB58hDQx2F5BN7U7J3nncG4N';
    b +=
        'RYb46WkadUAsHEDWn8KDjx8gTerS6BbE1Oj5Otg5bOTOsRgvYyDxdd9Gn4YEqKxmKuHE0XP8Esc';
    b +=
        'MW+zx7aKlPQO69RPX/mBgr6pPEjJhoyx2wqmCkALCFecaT/RQZW7dzb65+PtMuocJHQNG2UOCbf';
    b +=
        'JrsHPdStTkXOHi7wkPOVtZzbFT11n+G7FjP5arDBnyxDP9RgDxWyQvJ7nGvhNN6b8bK+/L9BcD0';
    b +=
        'gIE5TdzKEvxF5Mx1KZ76/bk9tltbOyDAbfCy2ipLky4e/xkuwAo42eP1VBjqk4G1N0abXb6kwxz';
    b +=
        'IhTk8WsFxO09Idik5eWAKGSRgUY+QRYWOB5nlAM8nXTbkMgO86OrhpOAZPAcPk9JLl8LlpFstbL';
    b +=
        'Umea3RYeUzApWMnCmf/BXkwSOH98A8gqXJjaipIojWTqWgM4pN6ivJvkeqF+ZQ4XQa1sUQrC+GF';
    b +=
        'UCVIV21ga/kavLsIe1Cc/vmZ5ZUkHp71a1JJ/y/FjvRoAWb8jVXVrN8zRICXeNqreYHLOQWrUAK';
    b +=
        'yyVnVcS1Q4Ys9oYwZiPkWFkcD1Lq6wgbOGRTK/U+nSzDIxAOSG32sFpcT3YOP942WD6uFtNNkcF';
    b +=
        '4CxAdvZTYDUNewaYhpxfrMTVdJMBezSUsj4KzG8m6dedZzMxKmXVWTFjLbiLPX49MyKpTaZuWGp';
    b +=
        'hcMkx67wGuQ3oU4uYOD14IEZymCgigioanW4gYPKYVYcKJpZ1JmRaULAUwZW7tClSYT6Xu36L+C';
    b +=
        'Lyi28i2Ee1vh85r1K+oqOVC+CioU5br2zvdLqMR+yRdQmmCENkdDy+6pHAZGAAsKQBEjIp3dv32';
    b +=
        'NgQmRYqwIkUG6Puu9YcS0I9EEZZEaj3Q6Lu73kMSaCZnAcFxEVT294z5BnxS6PgUjDaomiXuJTs';
    b +=
        'GvwGsyg+kUYxxZgHxAhSCPOjFfV2/gilaOMjB1AgbC4/3kz3Db6GD7dRa21bHVwbuabC42R0inv';
    b +=
        'Z4gMwP/qwBosnzC3uqaHL9e+sgEcOlT4xe2uRjRBsXmqQ+4qGDBw8e8ViA2GkxwgUfdfSMn5taB';
    b +=
        'BRzZHMmIOojjumh75w2hwOPJoiy41PZFs230M1ze6am988cOPbpqEtsAd2ZYwHG8s1UwZ9nHPVC';
    b += 'PwP//Ci6hbkt9BhMfpt7dAZ+x7cY9z9z2wK4';
    var input = pako.inflate(base64ToUint8Array(b));
    return initBrowser(input);
}
exports.initWasmEcdsaSdkBrowser = initWasmEcdsaSdkBrowser;
async function initWasmEcdsaSdkNodejs() {
    var b = '';
    b +=
        'eNrsvQ2cXEd1J3qr6n513+6eO5JsZI+wbrdkPAZ7PbKtGcl4wXcWySjCsbPx8rz89q3QxwjcY2S';
    b +=
        'PNMgmjGbGWAhBnEQGJ1GCQ5Tg38/KYgeROEYQbxgTv31KIogJTlCCAYU4xEnYjQImEWDwO/9z6n';
    b +=
        '50T48kA5vs7u8ZNF23Pk+dUx+nTp1zytm8623KcRx17O7ZWWfZmx3nzY6aebOacegfB9T0m/UMf';
    b +=
        'dIf+jYzCOMvfbgz/MU/9OnNyLf8UoQ/Y2NsgKKCmSwuC1FkRULT09NS2bTUMS117bF1TgkUnGeP';
    b +=
        'tDuV/wC0af5RU2pK/8l+6s1yc+eWtyzZtOnOLbfu2PaWsR2bbt216fYt7bGtk45B0oWlJInftG3';
    b +=
        'n7Xds2jm23dHIcBEyvGXTHTtv3zq2a9em1SNXrh0eWr11bO22q64e27xGalkumXaP7dx16+07KN';
    b +=
        'dVq8ZWDY+t2jwyMjw2tnZEcg1Irh23bxvbtGrNltVrNq8aHtoyPLRt1ciQ5OgCdNfkzlt3vEWSL';
    b +=
        'Bw7xybefuvOsU1j27ZvHtu2be1VY1cNXbn2ytVOiEwvl0xbd77jjsnbN125ZevV21ZvGVq9anjV';
    b +=
        'trHVWzpgfduufye5tg0NXTU2tmVs+Mqtw1cNb14ruV4hud4yNvnvN+/Ydvvb3rj5treP7dq0du2';
    b +=
        'WLWNrNg+v3n715rHta0YcD5mvlMy7JjdP3rp10+atwNTtOzf9+I2vW7fphhtf9x/esG7Tlm1bV2';
    b +=
        '/dvHZo7fDW4TWbx7Y4CgUvtp3iJtbfetttP/mOHVs3XTWyZmzoyi1rVm/efvWqzVuGnSCnFGFv7';
    b +=
        'M5Nw2uvuhLoHVq7avjKq9YOS2XLcii2jm8a2rZt89bNq7dR+e1bVl+5XQC1WcZ27iTwhtauXbV2';
    b +=
        '+MqRzVspdOX21ZIlyZvZcfvmnW/ZtWn76pG1V1959ao1I5s3rxpZNeL4JVruGrtt+6axK6/aNkL';
    b +=
        '4uHr19i2rRratEnAsLe4kct5+56YtV28ZG9l+9ZotV169eevq4THJ07RYvu32LZtvu/mtRPJtw6';
    b +=
        'u2rKJ8m1ePrFq7avNYR12Sb9PYyPDw2m2bR67cvm1kO/Vf8rysc+y8fce2se237hjb1jH2tm6+7';
    b +=
        'bZNa9auXr1m61Vja4dHhq7aunmV9Mi2seXt27eP7dy0eox6tIZGKHV985VjQ6XZIjQYu2rLmqGh';
    b +=
        'sdUjQyNrV2+5aqtkWJlnuPPWybfeNrbjLZNv3USDZevYqlVUz9Xbto+tGusYh7vevmXzzp2b37F';
    b +=
        'p8/Ca7WuuokFy5ebtq4eGt3eMaFvTVUNrhq66emho85rtq1ZvXb22A6pdY5ObVhNQa1bR5Bwaun';
    b +=
        'L70LbtMnQG5k/yrbfdvmOMZzlXEZdyTL515+13ymDoL0W/bextt+98B+H6yLtpXflNrxL5pl6JA';
    b +=
        'r/iGx1Efhhe0Kj6OrwgrPhRJayEfsXp86Kgr+L3B34Q1YKK7y3uCwIVeH2e78c17Q0EgaG0iu+H';
    b +=
        'iy/Uvu97Vfob6YqvAt83gecFgd/nLzJ+6HuBFywOKlHFo8oij5K8Cv0X0KcXen5ovCDyFgeLfYr';
    b +=
        'zfR2EoReEvh8E1cD3CFovrAQBwUMtBkGlrgNNhagqLzqf4qk6yqupYkqlOgkUz9f0H0VTmPrlU1';
    b +=
        'mNBILD8zTlI6iCShhSJYCAKgyMrlJNnk8ffp2+KWsUVQxDWQ+peoSoLIHvG4NkBgfd1NQbChHeP';
    b +=
        'Z9Tq54fRQyFzyAY5PICrT0ChDBWITC0RxCGOtIEagV1ECjR+VFEUISeooiGX/WqEf6r1aLz8Lsk';
    b +=
        '8qpVdK1S0egY9QvdNBEjwXiaYjT/53M/0E10ueobUMCg99QbbZDLMHAoC7iocWCcQNWmgv6ZKmE';
    b +=
        'nNMZDFaFvpGL8RdXAOOWiZPtfwCCEPgoRBY39z+dslKKUcQjH+G/ANUYZ47qOodhalSo3ru76z+';
    b +=
        'F/Dgfc98zSqFV3qJ+m/3n38IfT77+XAzMqnZ2dc6LgIBiAwJehrp3+rbe/jYb/2KZdt75lx+bJt';
    b +=
        '+8cc/ar5aU5sXnbtk20hciSe8ftt+6YHNvpfM7tmDa04ty+1fmeXlSK3Dkmsb9n+kqx23eOjTm/';
    b +=
        '6JY3wbG7dlDtt1PDv+lW3v8uhjpV0fvUb3n36t/2Pqs/5v2SetT7vvs73vfc39CPed9Uh9XHvQP';
    b +=
        'ez3k/633C+5D5pPeYe9T7FfO73k+be7x3eY97X3J/z/uCftbMeXvNp7xf8b7iPunOvEd/2vu22e';
    b +=
        'c96f2+9x7zNfMVc9I8Zf7MPG3+yPyx+az5E3PcfN78gflD8xnzOfMl9afmC+ZJ8xn3veZj7r/5e';
    b +=
        'e+/ubPqmPcH3u+4Uz+nv2qecv8f82V958PmAffj7n+e1X/kPaSPut9Xc+qv3O+pD+tn3RfUP5tf';
    b +=
        'MPear7rvM4/q31e37deH9a736u+qF9Vfmg97D3q/ZfaqI+pL+hPu77lfVW847j6rftV90D2ljnt';
    b +=
        'HvNPu8M+q9+k/du9Vd+vq3973HixIP7tKv2LGnV7hpHPV8Za70tHXnev/EnWpcVqvvKnuIBS2Xn';
    b +=
        'VTXSEUty67qa6TVyaXTbUuT155c91Q+FV7kle+se4mJu3fUPcSdZlzYZN+rlBLmypxk1e+RruJm';
    b +=
        '4bt1EleOZrsf4j+0iibjW9u+QPD2qE0leokC9coX3pQxS+4F1LhV71GP0yVpIdVW2p4FdfwqoVq';
    b +=
        'OJxl7qzmstfopzWlPKVtNZdxNZctVM1TWeaOatLTRoqnD9iY0btRfsScNol6ZHRo3+jQe5LLR2e';
    b +=
        'm3rFn9NO//MRz7vTo7K995tCjegrNtfw0nkzjtzcDQbF8tcLUeT3h2U1UfMmFAn0WJAg4WFORbd';
    b +=
        '1JwnEpR9ER1xOkMz+G8pQW2LSWiptFVc2iqmZRVeKnL75oJiiKIga106xQ/MFKO3V3UsDd2aqmh';
    b +=
        '1T8HUZfZVgfrORjo4L8T+lWRKFo40Crlg5urNPgSmp1J3WatZobJbVUTTTr+Lm+riiyQf/6ahoJ';
    b +=
        'g4kbf8N1EJyeaMY5VZq+BYCCeREDPE21W2ESEoytfoJ6qk0hxDSojXZrEShHgxPJixOf0xpJmPR';
    b +=
        'vSBYl4YadlBM5GsniDRTb2LCz2aBKuDnFTSVx0pfqdqvv+roTEUqT+jpGJ4GChMkWjSa33fK57p';
    b +=
        'af4RKR3JhKGrYNlfhoQ6GNiMFDTbX0ko31wFZYowpRMlUoQOhpN2uE/6QGDAOvp02rL6kl9I8wq';
    b +=
        '9JLb+SiwJC7s7nEDm4KnsdEap5PndCTTaWvMzymiAIzNBDUQNMHtqVRJbgF0SkYMkYJxTOC09B2';
    b +=
        '7HoC3d8w0PLXWTz4iYeBWQEQFdCdyVuhjZPiZto0fDCACEhF/U/NRNPnUW1urDujTvOVyflNVYu';
    b +=
        'iJExfoIzBRDPMYkHURK3Wzmh1OnnlVItWCAIZSG4kjSyaZkyeEi6YUlsgBUFqjOYYKBzyEKo7BE';
    b +=
        '5E84WQENQWRel33/WEky5LD97zhBMf106UHqZQ+vL0WB5x4h7O8XwesXcvRQynj+/NIo4jYiTd+';
    b +=
        '+4s4n4KpZenT2YRGPHpvb9JX/+g6EsV47+SB4FswvqCeKEu2A75hPiWDwIlr3yopdYxfWh8YaGt';
    b +=
        '2LGV8NiqoJuVSGavg6F1WLX6QUsaLEk/07IfU7X/XGh5HtHSzKPlef+atDQRo7CE2/4fDUL7LUJ';
    b +=
        '5+ezvQGo/kNoPpPbzXhNl+IxkBcbOAZxG54LTJT1xuuRfG6f9HTiNfiicUpkMqxGwardV+ihjNQ';
    b +=
        'JWI2A1AgKxbB3y7EaETY82I1VsRn3D+pBns9Dm2HyZLJu8xB3zuVgptz+sj2UpmnIvLeU+FfTIf';
    b +=
        'SqwKYZyX3AOrBI2z1aMn1NB60LaTS7M98Ribxso9rZlOSPRfLntBgUvsjBScLkFgIIJM07NZr41';
    b +=
        'N1sW/hX4PeQ1V+L3mN+8mKbzK4g2r2hewpvMGbYEqttuCee+HVDtPABSfWOd+cikRvGpos2Ut/o';
    b +=
        'KNmvEpmo973nY2hHHWRJqrCnjutdmns7sOtN+zsk/3JZe4S2953Z+Qb6Vcztn3s2V3audNGzSyt';
    b +=
        '6MiZ1KH6DJkl4ocwYrvh0XcXIx/vFgoFXCORtZiPovmSxCkg1UeUx8l4leIl2W/y9Ml6UvhS46o';
    b +=
        'wutJTRJok5OcyEK1ZKV+EcUqgiFKmemEE3VH4JCNWKdTNZpRn8FFKpZClWEQpVOCl30r02h2sIU';
    b +=
        'etlLplBFKKTbQqHKwhSio8UK/CPaxKCNSeIz08Yyty+RNgV1KjyXMW0z6sTl+RMLdWJQp5ZT5+X';
    b +=
        '/0tSpnfv8yVByzhTyQaG4vB9fkpj19Uqik0uwYw+1r3EIA5aTrFOonh1RvOQSFHnFgoeRmhCJz6';
    b +=
        'PnTKQaEylpJaWTaMznpNieQAcpNEhARNhtfSZnxIxthGNuBAJemp0kkSZEjEBEELaR0PBJlvFp8';
    b +=
        '1/kpFnpIt+lP9qTJrNYoa0w6jhpdrBYBzG5IvzLCBj+zzpG0oilQ6SWs6ROeC5XZXtkQmHSUWzB';
    b +=
        'LYfglhvMLWfHRcpM7DMmaeN/naNk9MOdMWKQqoYB3cEJxyBTnE/EOtBVY3TVGV11oKt+BnSddwZ';
    b +=
        '0nfe/L7rqQFfDriD1DpTVgbI6UFbnI9kgcNZgnA0yzgaBs8Ez4GzJGXC25H9fnA0CZ1a8Rh9lnA';
    b +=
        '0CZ4PA2SDLOunMUpxbbpB5W8gpaO7+eD1mfokCLCZl8SSmu7IyKx9LUraaNM62mvwgm7WcPfp5V';
    b +=
        '0ITOnlFm7bhGarlEmmKqplZTwd3P+W6dVY3YaYBtF7uOOla2gAiSsJCimFAeEW04r3tEqK+bm+o';
    b +=
        '9xMJ6Ng2lPiQ8taoTZ2uogzUl0uAWU35KfUSpIJGrwBEDi3hQ6hF5Eu0IxKb8woUpuT02XdnB+r';
    b +=
        '4DExPSTgUdQR7C5AMVfx0j4oRLJWoFwn1joTBImFwoTYI+J5wSLdxxqUev1qF9POKYe3SjxZR+l';
    b +=
        'y1vdLpK1fwgUv1RTMG9xFP+eMt78z3EXIDsSK/gViZ30BcjBuIFcnFU8kK3D+sSFbuSVbg/sHeO';
    b +=
        'HjJitdoGqqQ1LOsfwXL+ld0yvq9XNYfUnhJSczvpUdUp5jfy8T8R1Qh5l/xg4n5AVYu05emFpbp';
    b +=
        'e9KBTKxvxfdcqiy+9wb1EdWsUMJhEZtIvWUZvgfe+7CXGD7Gm7S6gSX2FZ7uzIgrIbLUQdOxhrz';
    b +=
        'EFiuZwxj3PKtlRnUIt3wW9ms716WKJGzzAkWr6AoA7affl3XVp2UktAk8Z11wWESjfUlIS9zeFh';
    b +=
        'Hq/r9/xsy2LuZlDqSWmOk9yKR6ZCplaa6gKu/Cyuin07IkWu4rEsE+M3lKGuS6bE2v0TzE72wTN';
    b +=
        '1m5gQYbYfWwhwVtQ91OCWXlYHaEgsNKj88+4bR5uULleRmRmCvegBQkggvhrg7cEXoeAeBotQt5';
    b +=
        'F9OKmX4eC8VAaaGoF9gMpQjTjAsUSL24QOrFyYrZ1kpB6MV07F1RRmaRaJOaFy+IRPS7hMaL81q';
    b +=
        'oDkYho4AzZhMZUSFtfMS+0g7Rl90W9TFy+oCcPiABJ097WxQxq6ORkA/MPnDt/dm0po7LSLWXRV';
    b +=
        'yii4WvlVn4aEEWPiIU1jpZ+EhY+IjY66iLhe8H+0Fky1j4eF0+4us9WHiZ7iUOPprPwUdyVFnHW';
    b +=
        'wjfFUl9fR0cfB+2FVpPPQhAaSb34TSRVAijvtwSZZMeSyCQRKEYm+Yk5M48iX27EfsDzRDYtQsJ';
    b +=
        'dklpkYIRI61J/EQSoQuR3ZOvJ6SEtBmHmVQjlHNzIxvrDcaDQ+spLogapXGO/ZgmFfFbIZ+3rQB';
    b +=
        '8RRITP8CdtyxXlMUaXD75luFZMdVagbHpA7H1pJ5FM/tkU8IFU2oLpCBIjflguXwCgYZN1HlBVM';
    b +=
        '0viJ5/d9cF0d59XRdE9+/ruiB6cF/XBdGj+8qbfD6my7uuXyQ0SqtNEgoL2BsjBLztSghGJ2MbV';
    b +=
        'zwkC1JDpO48DBsZD+jzMRW9bGA8NYhmNACbNbv1yH6Fo57dubBvBYlrdyHaz2nVGU8MjYZ6XeVz';
    b +=
        '1UtP8C1l0rnpnNA2BbL6JXavwsSYdbtzE1yzrk2BrP68Um67s3XmpmmQ7dbN820zFHyZrYOCS4t';
    b +=
        'l4oJ87bjQRkLCP8CrU3NRsYkOEsjNZfiddZsvt+vZRdTL5QV3QuRY3qx2cSyLRIhYBWKX0xdmHo';
    b +=
        '3mMC9CFFF2evGsauLyx8X0w5Ia0RJ0Ef7RlE5QlZskZ569dsqGQt5znrzUlSam7400MBICCaSnp';
    b +=
        'mgJblLSImoqEUFJgiUXwpNFnOUCaulCmZw8XaSNxXxeyURMcvPfbvVjiNlVsI+h4OSaLK39WFop';
    b +=
        'M9+BJ30bKLZGCyExBiBPmC25DSCRFu1srW2uyxgoILflt2Wbs4eGgcQvC7uIz7AtELLRgo8WBD7';
    b +=
        'q8zzeu54QT0SHSDC1Hr7W0zlAJ1Vw+vQ1nh0FvCSh+ZKGhMOkuQhEezn+EdEaQrTGmYk26/5ARC';
    b +=
        'tW3EXNRi3Ad0MklTWW/zRblnYNoV0DtEty2i39l6Zd0kW71hlpd965044FlbJoJU1scs0aRSwq1';
    b +=
        's6kCFaJcir+Jp98aNmat7gudDHQSJbhXzYRnbNNRFp3fjiaNpqJ3A0kGU2TMk17z8eX/WvPxzPT';
    b +=
        'dMlLoanOJhbRlM7NTeA1WZhONLwq+EcU4lVX2+X2XBidl0ahgkY02+WGYFFGo0UZjRbz6s80WpT';
    b +=
        'Nu8Wc5fyeNOrvSaO+Eo0anTTq30C8XplGjYXn3WLQaPF8Gi3uQaMMMedMJw90WiR0om2uiTlmIH';
    b +=
        'TBSklxcknANHFlU2QuH5ij2IInhDy6VWOeMGP6+ETFMrjaS2AIa0ltAYZwgZTaAim9GcLoB2LAc';
    b +=
        'vZrEdgvv5gjBfu1COhblGNzecInClaf80Wy8+S+jDFcdIaJUFr4FnVwk41OaU0XryIXniWlLtOp';
    b +=
        '1BXmPLsvslHLs2M2RWUR6YpCOOkViOEDKOXMogs0s3h0gZTaAikWv93KKloUgApGuVNW2gVOUxU';
    b +=
        'kzmWlKzp1qGQ69NajYmb2iD3M4ipH8fLDZ31VEnhCVJLVpOScGp77hQnEOmoC52CPpQbET9Tqhk';
    b +=
        'X+1KjBSge5JsssJ+oGeSrzRHd2PCiIB/cV8rq6yOt0UqeRB7lEomXFxC65njuh+MyPDKGgKQKrS';
    b +=
        'oFCdkpbKZ9vC7FpHeXH6eMGXPSIbBRyDuaYdJSuYvl6jQWnEKOmQ9RInZdLDlpxat0WieQIMgsO';
    b +=
        'nk4fQXYOeQNBWAcKFPFbihtm0T9fiRS7OwUh0irF5ALKeklA6aVP+e2VTvSxZboxoyGUPKTGW7q';
    b +=
        '3UJK6E0y0zLq6TU0cUM7N5pDLc8jFHDKQCT0ImRANQTp/Oxh5hrpQTC1PRGY0tQIq62VTqx9Ty8';
    b +=
        '+mlocYogwtBKtxLzSd9E+1+jGWjZUvZNE8TWxKuGBKbYEUBJv9lCEGmB6mlmenlksjyWRTK5Cp1';
    b +=
        'RscKmnrCTBmAp5a/Q8xwqgaPoEiYKeVsbrW7aYL4rjDcioOaXtxS5hVJcwi4zljMgYhOjAZ56CP';
    b +=
        'zn76C1dMJ/FUK+5CZpbCuIm78NkrsbZwIoJE/G6sGsFqabYujOMegFJVtuISmuOXiuaY0GwIqR7';
    b +=
        'NOwx6mnIsl2HEB8LqBMJThenzNJJTzbhPgvhG2Sfw1TKUiRpqunKErWITMSDCDC4/qhRAqsf9cd';
    b +=
        'fXcaynbF52O2Jw/PUF/xF1jBe/fLoF6Azm6F1oyH+kFY/Ozu79vj/NqJGRJ9nWc7YpZMMQlHRC0';
    b +=
        'zd+5mfVdIkahKW6TnXToAMCA37LtAjSi3kPYMSlppllpIgkQAMV+p/ZMNCsJAQxrTpI1+1uenbU';
    b +=
        'mFFXMBhmwguHNWEiXliSCblSymhRKS8xhB/Qw8gmU0lfAD1cqc0QPViNxpFBbIQeRIgQAlFzHS/';
    b +=
        'czYA+DHMvhkYhaGFyIsig8tCS14MA+jqCajAJxlvVpJpC0aJqlZTAE0+2USPxkCDP3V/57UfCaR';
    b +=
        'Y25+Sppvp6Hkwa4jQtwg4CgQnlWUJ98V2/8/d6ulTGSBmTlwnnlfkflU7SekRat+mdibQrQNqQ5';
    b +=
        'mzigbpe07N5Q0YMtmkhMjY4EDmyBHY7CWy6SFopSBrlJJ1zzkzToIOm995NNA3ORtOqpWn1R0ZT';
    b +=
        'OgQwTUOmqZxzOulVAQmFzFXhtYXWv3f4u9E089A53cJuulV70O3Zv/irf/SnS2VcKePmZWrzyvz';
    b +=
        '3j37oT+vlMp6U8fIy8bwyz3/zxT9olMv4UsbPyyyZV+aeD/2lM39UBWceVQlGVTVdakdVmI+q6l';
    b +=
        'lGVfADjKpZ1TWqos5R1SiNqig9jFHVKEZVZcFRVfmRjCr8b/7Immk3jFbCfnaS2wAlpeFVK4bXC';
    b +=
        '08/r+cNrzLZTW+yv/e3vn/RQlQ3van+vX98+rRTLhNImSAvs3RemY8e+/wHdblMKGXCvMyyeWW+';
    b +=
        '/vef+lDHKK5ImUpeJplXZv/RDxyqlctUpUw1L7NyXpm/+MvHvhaVy0RSJsrLDM4r80vf/8zHquU';
    b +=
        'yNSlTy8tcNn+2HH/hWMcMq0uZel5maF6Zz7rd84vGbBPHHFxxp7dgntCA2zhAMFItauFpd4FMu6';
    b +=
        'vttOtbcNrlO7addo0zT7uo1/48qzHtwIWWpl49H/928g2UJl89PYnJN1BMvkbONgV28mGLbtBcc';
    b +=
        '0VXpS5sGysbuZBNwYCSJlyQhOvZspLPr55kZl0+NwnEaA/zqVWlOQpdUAgQfJ6G0Ti1FWAaNvtY';
    b +=
        'mYT+bRjAKbWWVB5pxjhfpCenm4ERTeigzZwULQN88CR2yvJSQTp7zxO4uhTGv+PcoOWqOT3+ric';
    b +=
        'c8AV0+NuZ9GUQt3Bbqmwle++RM1F3FcxlM5OshT3ENMK1JfUUVLNoxmmCqDDAjBf1ZYBQKWf2uj';
    b +=
        'CiwrUtA9dmcMlqkgb9D8RvJFUeTt3jqER9ryOByVYvxkKDOWdNEXRgTJzocKLjGYUjYzzeUivzM';
    b +=
        '2H6LUWjID7sNTVWUjpo6zSM3+emS/iHTrPyO56efvGd7fTOiXRPu4UxJfHUi/GWm9Aw20hDB2dp';
    b +=
        'AMJJqHBQH38sXcfX4x61pmlgUmvpcmbkcdThs33qo9Hdb2k547tTNUFVqMnx9DWEWswyPd40Flr';
    b +=
        'w5+mJo1Z5weGdJfHi580kBhDvBS4PDSf+DS/+a5cWdT4a0A8WeFZ4CqmTmBchzw8Oy0Bf0hYBBw';
    b +=
        '3fBKPi5btTd4L6L21dP4CEASazwh2ZU8/PP0nQdFhHrK4xlml6JN5k/CHX9n8CkFJD8TH3rd0dM';
    b +=
        'GCPoA2dQRwk+kZqSWMmmA0TLX8AswbXlwMANv7vpoWWExfiZ+xeg/rEJ9KWIx01kBSM38iK61Qh';
    b +=
        'ouP3eQS0G+9mDBpLtw2sA6XjP+TK428ZTpuVgxRFTKI/JjW76VhrJtOnHiOQhQxo8dhjKS7IE3e';
    b +=
        'y5fL+bnAd6cKuBBJYd+cwsiSmyZMygKzQxU8NdcuPizt3hTMejbl2/EWQIL7Xw7lQQf4iUohslL';
    b +=
        '2znTi0xsqw6hRzZPAQzgAu/Z/OQRPCczBubqgTn4ohyMQA0oMetHAF/3a0Eb6AaDnbOnkSaIIub';
    b +=
        'GgFTA30CvTJydID7SWU00pBqRTdgfmMhC4kCS76EBYo95F68hNp0836SetpEk62IHjQEMaFzZBv';
    b +=
        'YXgyz+zC/DGYoYZok554LBtqtETxog/VSkS23PU8XlyQwwVVQiFfkE4n+s4JpiDIg5qIPEwdWsg';
    b +=
        'CbiqFmG75RMtgmIOGkxPAKO0p1Gwwv1nqq202WM/K/0HHKKDlRHpHbZty28CSILOF5dlMMhF4uG';
    b +=
        'Zo08JfEtr80kjN0KbLQ4QODYk/2fKLIetLn+k8lQ9ZFmRrDFkfPzVaYYz8+KxywEIJqhqoGgYEG';
    b +=
        'WZ8pHlJaGvymyG0UNFDqt+i2Zef0NYUZDUZrqnnfKiraL5sL+s85b2xzsh7RhYBiFNUeoyQQFg7';
    b +=
        'TCNxnEaFLORdCzrUCmZnXQrGX9WiXGR4oTa1SpShD3ySAc6zQcytQWGG4WYgsM4jhlFBrRZjpRJ';
    b +=
        'Z4mH02j7m+MOgI0LmVJYihDMFwngyJJ6jfPTttvx2i5p4DuUR/3XMF1k3Nw4M47PAy7OfSMH7nP';
    b +=
        'rEE05TRFNO/Ec02jXYnhDTFDIt5Nz7yVSWZsqyoY6xTVn/xsXSGD/nJsy9O7bK+FFDi7W0zuUSL';
    b +=
        'obW6RPrMw4n0miuOwE+C0cSVTQNIWVHI+tZG4XbKFVgMjYtcVldlXqAEI5DtibsNNj3KYVmnBC3';
    b +=
        'VRlPb203GS8yfEKOT8Jxwh/L2Sz1cVkIjFdpbFZAIbAArUhW2Jqtrlm32XF/i/6ixj6psW+8FWN';
    b +=
        'a9g0D8hTqZ36bmJdaUm+3k7g9jus4GpS4AiQGa1i7aKCW1bskq9c2ECMf1ZfEVEc9qY2321SE0D';
    b +=
        '07O6uG9SyhGID+IUVdqk8Rqvr5sI6v059IRwhP1aSffjAFh/ULDBFNtuez2XWKA9Vh5AZhUhedx';
    b +=
        'tB4yIOA3TR536MtZyN21xBUAyPgjltsYoS+z4ufMLzOykaJuEkMWYd3nmL5cTo2JiyWky3Dqw6o';
    b +=
        'x+xgyu3ZtcIBB+jIWpEvyU5pZQ6Y7g5vHSwi5ZpoPWkz8KCLTHMwC/jy5YurS5xxsJYyETGdZe+';
    b +=
        'hBY5HBa1v7XEslHYUJuCK7QKAMHr5uFv3ZIthHsX234l3y+WyQ+cuUR3MFvxwPbNdvN75vN51Lf';
    b +=
        'MBoSxf6WnvbjchBw54KNY8u8w+m813DCTNS8AzvHI4MqS457wppczO0DrFOdJs1rayzYPrAjZtw';
    b +=
        'c5Vh5duwzOZecEScm1FGRB+O/5LGMCXtgG7DFr4Tgh8WNkscAYmC9Q5GTs6Hzs6nixl4R1Mn2EI';
    b +=
        '6cmWLoaQzoaQzoeQzoeQ7hpCvJvZpsChpi8uH9b7P5mecbIwHITNxxA+weFnHyviT3D4JIe/Xsp';
    b +=
        'zksPPcfj5Up7nOHyKwy+U8pzi8GkO7/14kec0x89+HOF7P17kmeXwfo6//+NFnv0cPsDhB0p5Dp';
    b +=
        'TiD3L4IIcfLIUPcfgQhx8uhQ9z+DCHHy2Fj3D4CIcfL4WPcvgoh58shec4PMfh46XwMQ4f4/DTp';
    b +=
        'fBTHH6Kw89w+ASHny3Fn+DwSQ5/vZTnJIef4/DzpTzPCW45/EIpzynBLYf3Hi3ynBbcHmX8Hy3y';
    b +=
        'zHJ4P8fff7TIs5/DBzj8QCnPAQ4f5PCDpTwHOXyIww+X8hzi8GEOP1rKc5jDRzj8eCnPEQ4f5fC';
    b +=
        'TpTxHOTzH4eOlPHMcPsbhp0t5jpXinzqaYrNyZQ3NNtdmmG1WXrEbyqpLK2yrinXGyXZDrB4Q6C';
    b +=
        'Qh7YbVdrYwYfkudsPuBvysARxADXZDMKFQYp23G2L3NyW+7wYs2T/EEsiXbJAUmOjwMh3J5fJTZ';
    b +=
        'rzlr8QOgW3D41NPyIsZn3r4jmmg+zwmx0z0fYC2xKaImO7WN7IW6ZxpJyEriqjddJJ55qNzTvz/';
    b +=
        '4v79OJ1ZrGyIzjRPGkjFBvUcrDno95hp1mxptO6lX88Kcl5t87o2b53yrmknFZY2tRpt8WWi4t9';
    b +=
        'TshcdNKKxdC0NYRtcA0bmgCEuJCQWpkIsSCOG0sUB044/BgCH6AQKq4D0BTR9j0GhIfy5Gn8OwA';
    b +=
        'ES/R40xBW9E0rRkt2k0xPpvUfyEoP4cxm1IrkcgQWt4BQSf0RLZVIVZM28T5QAYR38IgvXkmSgP';
    b +=
        'VA0lODPynlZgUF0j2qOfxzqEIQ1AHCIXXswvqw+16WE2BFzyNhChA8GJSsElBxZoNARw0zGJzW0';
    b +=
        'QhpGu0aLjkGTr3DBkuMMDn0nC/jxAqesYMKbFiucxO+gklMia+NrTdE9rolt3XOODCfaN3eAyB4';
    b +=
        'z5d7GAdoxjwMZXwScpygXVfpW/LktPoSokxQV0P94CI+3IHKlUm0KUHXpMyj6KeSbVVz0zfizTY';
    b +=
        'qesG1W0q8j27uYfpLtFvz5T5LtKScbqy/kgBySbDfhz82S7ZiDZQL/o6x8CSGA8DRL7/1YBsgRK';
    b +=
        'fp6/HmDFJ2zLYTpAx/LAJmTbNfhz+ssIGx2xTgAnPEnMQ9PciTDgzISeYo/JT91PP5lRM5CS9Tm';
    b +=
        'P5JFHtBFnVRJ/E3unW5nqOA6v1mMEdyHo2IKXmqcESODxTyleLDwCEOuUBruyjVLuebsLJEapUT';
    b +=
        '8f+HUBdC6CpyUakOBuCvxSFbboXm10Zd0geMoPf4zxrN0VtCiuV9GIrqqPlW0e2Be4oEztpu3+L';
    b +=
        'Ti8oTarvJ3LICEjQzMrJ6HNZ0DMzcPmLmXBMyheeUPLVR+I+g8H4mhRHeTX9ta8vJCgvhWkFXbm';
    b +=
        'lMTf0XgODKvhiO9apizNZzKa9BZDXPzapjLapgt1XCAawgFiu7BxQXECcflznGDjeV6vkUQGKie';
    b +=
        '+G63VjIlo2z3mpahhdBRrC0FkPpsaxS43HGgF0a1X+F8xrza+a+mWFszCEpLLENwhM1Z4r0elth';
    b +=
        'rnMdZcBLWFdQww7qXXUCUuhW/y+XlWGu+RqCirC1Xmp8yCcstzRk7P4uuPVfaLUw575Fst0DeEE';
    b +=
        '1Z8u/TOL2WenSGdg5l7Uj+eMzWZ4q6fFtX/PusL4WefYk1CqEDa7eTx4t9MMafJfhziL8P898j/';
    b +=
        'Peoia2V51n24QVLlxmEpVnrDxetL8WfZR278E9k8H8p69SXbMvoh47OjfYdEw90OaTmoSoqZ5M5';
    b +=
        'kA1wWqppkHbM3KdVPunyQrwczGXQzNpFumOVMeXZ8IImjq+YDSg2L/cRU+sUaGbTqGGUcYgaps4';
    b +=
        'O5ky9Exez80bNrOmBC5r0BS7CYtiYqCNLaYbmSEF8NkmUdl7amM0Xm15j1hRjVsbbS5l1AOscZ1';
    b +=
        '3RoirmRlQsrTntby3IWd5+OxZGqnlW9o9TPAxbumOv67XynuSqi20fxvD9xWJtWotGqGDRFV5pu';
    b +=
        '/dJzT0KE1tw0bx2vNSbjD+myntMPlyJMZs/PLtK+7a0lDvQUXrhFb+rkpPObQvDwEju3jJ71RJY';
    b +=
        'UOa6QemcHA2aGDIgceAtVon4N4rxZOn96yaSJUqs9nJEH8mGmRjyZgTpZ2Rj3ep/iNa9d5aXpGL';
    b +=
        '4PGXYK0J6/CNzTvqq9GGwm9Djv69fhzPn46Q41OWqWRwh1G5iFS12hVDPw3GrIeFa0phqNZLazf';
    b +=
        'arvgdeZN/IX+yWuVxhY/RF+9/yN4rj4SvU0paCjrSb9AHNUAV/cxsG25nTBA9mxndQ9ykq2UcnG';
    b +=
        'IqQRDgKt+l3SXrclU4HbZthSjKE8zJkLUxLBndeBmmDkrRNikdf+56H2GDFy5we+/Cw4Cbu6AxU';
    b +=
        'Rvv3E0L67hkxkIc33liH9Nb2sYY+upCwc3INyTo9NJNkVdGR47b0yENeO/1s/LaWSj/niI6/O0k';
    b +=
        'fz+17wuH5KHjsu6dVpyr6R197T6t/X6s2muxvLZpuLcbvEmBrf+u8ZNH0VHJeUssK1KZbnHD+VP';
    b +=
        'NlyWIbC1n9NHSIk6ziKe5+CK8SzaWjiu/EVHoK7V+hnPZ4+tqJR1qNfa0LRmemmoupfF+SQdA33';
    b +=
        'eov1Vs0zA0QKNOtWo9WLqSkvukmjR18DWQ6Gir9hm0Uqvx2GJ2XxEk8OvPu0dfut40um269nFqj';
    b +=
        'H2j4tC7q7vNyxCbQBeru8fL5sLSaU6NqqrU8abBLjQOfdTbwbji3999u4AkJBekNRLcwreALThw';
    b +=
        '20BhpBpwiETRSWIOP96ZnUUNKB1wcdwOb91mHwlm2VKVVSqxuoE/6rWxkfcHUTfF16Gd8W4ZgwZ';
    b +=
        'eUUlHqpziCzz7yVddmIBj5k3NEycuSpSD08mTxPU1c1bKxRBNGP0SwqWRgKrlwqjWwB93tR54+G';
    b +=
        'GewIp63o1kpSYJY+Rb2H60qHZqH2q0I7G4/ZaRD923jLf+RhIYDYXWqFb+xHqOp62ngK/F0YyBF';
    b +=
        '2TjQ9EcV+0qo46qoidIKV3rxaHW6WefqiWpVGiBAPStyoRVrHNKPFHioXkwkvUUcQ8y0xTKFovf';
    b +=
        'QYL/gTazRtDx52R4a50l9qrkUN1F7WosTKtFPg+KCm9m2lg5DM+1mhetMLiCo9zQpLVm8p0moor';
    b +=
        'qai0ZZS4qXtAumqGOLb4ZRFS12VHtt6k1sh+fXFkNVFbpLAul5WAz7MzAWv6m+mJq/YE+TYCD0I';
    b +=
        '6HuUBmxsrr3A7n5PX09kH+pwn7E9tyjccFOVqo7aHSIttWp9z/hpBekJ96fWfsffD97fz72/sLa';
    b +=
        '/3NOevi+QkGc9p2luDyExMElVjc+fYb49MkX59jhwGyXe+n97+/yL3D6vi4PBM/d1+Wj4MR93W6';
    b +=
        'u8wjr5+DofQXU0DSz7jtY16c/iUFAj0dY402ED9C31UeDllaNPlqBWhck8S00MwnbN9eVbElxsm';
    b +=
        'QqOX+Kxj9RZVGybA+tgxftSZI9SXMPrVgXJbQaNKeSl081+0YdmicYujQKlo7qZAAOBvGxiAdAH';
    b +=
        'aYQPHKcZGnSNwXKYgBwkWZM44B53Sq7XpZ5AQhgpUm5YbuPcYcCMaJjgIlFk/aGPbTe0TLzpjp0';
    b +=
        'xBCAeRLXyixBPhDsNLwQ3XTEIw7qonlyITpM8XuozQv3vKkujiRH9c2cpX90auoWvm8GkR0xZuE';
    b +=
        'QX5D5Jaskhxn9VyvWgao161mbS5M62mSbwjqmQi1ZijYpHm0uLdpcMp3U38i54tFbpqnr5ZaLEK';
    b +=
        'tHqF4tYywOwTLqoZquzqjpzMuxGL16UDCUCD6eUBRUxfhKUrFTxSr9ihqiYgFlJH4l2J98FQZ+r';
    b +=
        'hhNmaTCVmV0SGhVWGePvloR++JMIlqQUF485HN1hI4qEFaDuSqME5PquIDDNokEz95ftbMsZU1E';
    b +=
        'NiZMvPWtygArTVK9A0mNvSDigp0ahepWBnZYAjvoAjs8O9gby2AHnWCHnWCH44yyM4MdnA3spNr';
    b +=
        '0xUk/LjbCja1ogNZHV1zr4LaEvq2pXiS+nvws1TDYST3+tivjyU3q4y3a7OA60kywhyg2s7L2VH';
    b +=
        '1Q5YG0wE2nJpq1LMZcN4pt2LRXOc4+DuoiqPIgfpO+vfQfFbMGszVY7NRoFfYj4D+0eK+IbiNhv';
    b +=
        'wLnPdCWddkOLBuDiT9OZcH0VZgesFHclbhtyHurNu88ClWZQlUZWFUotTN1KrbRkCjEKq/QIKYC';
    b +=
        '3rjAwxax1OX7M/LgBiF9sJtYkHeH61tVEKsCvQgmVgV6DxHbYHf1Lyj3r3Gu/QvO3r+NZ+hfgP4';
    b +=
        '1BNzgR9w/mG2LZo3L486DCvc4WxaEmUdWDJnCKysNsZp1oNU9yDidBlnlRzDIKhhkFXFmyNqHpY';
    b +=
        'ycS8lQnOGhCH1DGeXQMcg9H+ZB/shcSeSxfMe/RpbSIayt1ziNhLqDA4aTXtvmxZZCV7ezVbbWT';
    b +=
        'u/WtMzKgovIPtRYgUJszTrXWgBU2dmsd0ZeX2aIunVC9QxU7bphUdLgtW02/esAYtAaoTvpynYS';
    b +=
        'SijJU5flYC9ts/0Ja/RC4wchYlDq+YbRN0LcwuORqszQyfWkGm+Z4uiaaKhXuYXRLLTRWMOQrUh';
    b +=
        'osD1Dp99Uxb9r+LUF2k40sWDyZs2vgzc7RkGJgOFJfL+SL5agSHIh7zEQVxxTI+awYixDuPO0ir';
    b +=
        '/sWkTbbA6yHVYENkjt0LGfc+P47/GWiJazGDfKXZjpTnlWXpALcNH4CV0qSOCtwQEaWt0JO9RLT';
    b +=
        '+KsP8teM/23tIL417iLTht3wPwxqG9qaeSn0Ou5COFqID2Vl4MOEm5PDa6lNA4RlJ/vYlnN8s2C';
    b +=
        'hKERcwuU29t01HE4EeS8QxIHR8xbmZ/SfJl8rMDmCacbm7eMEEIlE+SyJj3IuXNc5ig/iFyPMrH';
    b +=
        'WcH2sAqnzPGtG8IiTwYg8jBVMEyPT4iXDpEcVMCaEjV9kVHKkgKXKTa0ZMUdVPiwoD83CP88A/I';
    b +=
        'BmuICiQX0UPqPo93HFBhLLJ2C0ZNhoka9bp8RgVYlvxeUTbFmnoTRche6RK75NaT3bneCCH0qxU';
    b +=
        '9CqcpNokvhMzEDN9Gqz+ToOHk0oi07zMYuocyP37bQj3UiLPrx1xNxFKUnbDpB09reIuk9ryY2y';
    b +=
        'CXySIrASZg3x+3Ux6KNO1N/Fg708TUKZI/sle7VE4G6S7VdCTzsEuUz8D7D+opYPETON34MKSm5';
    b +=
        'YBRhYLz0gwPJWxTmW4s+y+JgSrwWsB40VgocTFTiEAn/KuIrxZwn+UNtVzOd3su1HVveRIivTsM';
    b +=
        'YvYv0EJ8vwe47RyWXzvuynvrxVugJRG5FBtO0xrGhCRvNzH4avkmyIlROPKjve9+f4lKH1X3RSj';
    b +=
        'P5Wx5A8qIo5IqiEgFn1miIYNVH6OJa8Rnocc/pjhn240vr7FGZwZVgfxy9eLFF2gAsAn2B9NGku';
    b +=
        'W8MIWkKRIwg8WO4ML9bdHQTygCCB8UvsqeAk7Fmij1ZUMGOdHLxY2ciuHb3dhSqKtXBidbnMctC';
    b +=
        'qVouJN0XSBDDpJRvFT0vdZT3IVpAOQijg8WQSlwtTyO7ix81KzTATATtoeN/i04nLJrTE7AhX1m';
    b +=
        'maE9rNSafsOGIjNGM0ayTzW23SWSMRcR4hOsvs5lUiPIlYmkf4ErEsjwgkIskjQolYmUdUJGIwj';
    b +=
        '6hKxGV5RCQRQ3lETSKuziPqErEmj2hIxLV5RJ9EzDl5TCwxTxYx/RJzrIhZJDHHi5jFEvNUEbNE';
    b +=
        'Yp4uYs6TmBNFzPkS80wR8zKJOVnELJWYZ4uYCyTmuSLmQon5ehEzIDGniphlEvN8EfNyiTldxFw';
    b +=
        'kMS8UMcslBsoONiaRmL1FTFNi9hcxLYm5t4hZITEHipiVEnN/EXOxxBwsYl4hMQ8UMZdIzKEiZh';
    b +=
        'CnwsFu27PiK33sN1keUzj1YW11TbOEZyVtXz7PPuHj+iJ7/razDpy3qLlZzw/MXsHf9nhL7WYrI';
    b +=
        'M5+iThr7uEfIhSv3AsCKNwc2I1AjiWAqWmZG4c9zxq2ZZxuy5yH8jc8NDIrA15P7d4puGD9o0CA';
    b +=
        '53Os2MUISC1mgujgMSmsWmj7m86UofnbivLAbp5y+KZE9Loz3dwenlvuZju5Wc1mc85lzqxOPwX';
    b +=
        'vyrRl0WpEES8qG/F9G/H9LOJ7qskOr9QGdgwBYSpOB8THLBGVYDzU4rGQTg4vLrSA8zSP0v6YDl';
    b +=
        'RN36YsE7uVpZB9bmx5dRYybqwLT2SsHTUYEYdjYE6IzWQ923EBUe3L6OB33evxDpFp8pMq1OkEp';
    b +=
        'qJS4EbrnZzpr2FfyApkWCU3wCEXVLrW8zDwcMeOVXpc8AK+J0Ttn5p5Q2YJyl0yaF+MfIlmupxl';
    b +=
        '2mYJiizTXVn2zM+ypyvLVEcWinhnGwhjS16W3IvfHaBK7PLgq4jV+ClHVhGbGlGCW2xbbLtF6S0';
    b +=
        'lzrT15Y5KXzvRtMMXVymbxOkTjVNnp3AO2HuIlRkm7gsSRRaYUTKV1VR2J1vxqPSOGwWHaW1yJ+';
    b +=
        'uP57kMclHCIjgwOuVM7CTub3b2SWe9PK+ibcXQXVd8GyHhGGGaNQjPuhsGmjyWaFwPCqfVHtaXs';
    b +=
        'VwOW5gnExdr6XccCT9bCmMXoFzftZ9Y3l+Q8Kg3oq+mqKO/BtXcIQo9Sb9vYIEzlRpmvg6y52H9';
    b +=
        'Vg7FbZwqEBqk0C0cWkmhmziUUOj1AtVJqjH+J83Cwx6wfKcEy5M2LH1xBTBXAHvy0FkBe3MOmIB';
    b +=
        'Ty8EJC3CePZSBA2Lj2syNfxncFrMmiTfAiLUgmAVBteFRI9Cd/tWzQndLDt1NOdosTAdymAzDA1';
    b +=
        'FCeuAXn8A18POH8pVfLh4svB8O6WRt7RENrbMTdCSiVY8XDWZrmF1LDC2E4iiG5XeeGIGz1y3m2';
    b +=
        '4x1kcRrBHv5Y6kLuwBzZPwaSF3CLIadqNlJ+mNtXlFKH7r8YfIPHskujknFAxaZT6NSbdbhF2Ur';
    b +=
        'eTHCZOW55a2zm9TURL5M/Bg7UePDhY96lNSDSJ1HahuJEah3QxOXfa7BQAlnwXW8K80p/rNhoCW';
    b +=
        'I4h1Mbtgo+IKaaMEjBUzCUosXn/Y3FtfSsZFN4DL7HAUD0YDOh6m/e2d697v2hhO5xU7vNHfhtI';
    b +=
        'USdJv+awor26KzqvDKflKBYZqBRZVhc+/0xbtfCCZgB47fdnr3rHtbGu9O2DGkJ37lxNlGE6sWu';
    b +=
        '8+i/Tfzo8U7hgJGjN3q7fBgFKjMkxYsGnUJBYGFOOiBgt5p7sJpCyWUUdDM3M5buaN1fIXHGabE';
    b +=
        'd8IZqmmKPT3XMWPrOAvy+qLMh38f0ED40ZanmMlnUCgomhL0YLyFYCHs/HDKM8cpzxynPHPCArS';
    b +=
        'pHDSZOaXaOJtCNhY5aM4WRocqKgI/dECxNwKqg87TTvxBbGVQnaYD6xr8uTb9xjN0+KzEFxfyOH';
    b +=
        '5eA/w+RCeQYHzJgTS5iTtj4p8R6yLfrOL98stOJnm2R71eBgt6XcbHJK41z8KGXQUjpfMNuyKfI';
    b +=
        'BbLr8N06WS69O2tCjZrw45lpjsSquB7iCfE3i1m2pRlT0eWKMvSNyE8bUDoBMDBBLbniHdwIRik';
    b +=
        'Ubuucf5v+n2RHSl6cDVFmaqSyX5Vsi/OBkWgvCSoztI78eZPP6/DtSntBuBNQt71rxenijY3/f5';
    b +=
        'neDuZYW4ttBzAdBOCKeEA9qRTXBIcADuywLAlfkG8jXn8xrdOT5+Yc2Q7Y9Ix3e4VYoUF3Qzoth';
    b +=
        '+XUUI/OUs874ij1/VM+DmWPrpsiU+Lf/zvgLTuaEXRPMZp07sukisMGT3X8UMQg/p1tJRUiNWUj';
    b +=
        'UPsO3T69S8TmJ9TWearbeYhEOSmNguMqhvqXPOglHhBSiDXIP5cln4XIzaM/5zXb80upXCrwM2w';
    b +=
        'rUaY3vuVjmZW2maSec2EbO5HxxOhtcpsH5Tom2IlfQB1/ZYqJs5S/FkWv4ufCcK7M/R5M88O1pC';
    b +=
        'FDcXD3WVi/FnSXSbg1jEjDPtA5Rma36wK7DXa3l1x0elanl9xoRLbn9XiWgtFDKijNCDSofS5E1';
    b +=
        'aZzG6wNfH1zgZJT4nszClEQrTRX6qdEXNTYmGPv8FDxm0y/vj2Jl2SuvFDrnUMABv7uLDhDyGps';
    b +=
        'bJNjQMPBt8B9pGi+6L4Dz0u/XVic56oKH+GOvwzXpPNbWH4qmCeqjNePf6aK+aYjt2CnPgPXGH2';
    b +=
        'wTDAhOunYSEmprSYVpogpRUZbsd0ynceYjQPUf0Ths6MbLhPBce5Et5A44dpL9SFObwzznbwfVH';
    b +=
        'JY8c8Q1w339P45ORlBqFeD38LJUNcWQHjT7rC0AhYZV12bY3K1mf+NaRjMD3rsobF5px3L/4WOs';
    b +=
        'eZOkx6JZPYxanMLM1Wa8eSBt4Fo9aBiXRZZ13WeZe17bIWhSO3OGCfocsWvKQgU0GZmhj8W78F1';
    b +=
        'usBG+vDHp3OrQp+c3h0nN1njtPpMweLsrNxYJ04JmGfBYodNogFoMpsAjPHC+z5zBppw+bP46VO';
    b +=
        'wbab6r6BiSxcMvEVE2IbCJcCqodLAZW7FFA9XAow3yguCux4FAynanf8iGctkKnxDZmTBeZhCIu';
    b +=
        'P4kpMsadh1CVl0R7yywXBePwRrsFKZqWicbFttOPbjFs/D9zPZoaeptg3slMD8VAEW0fdYXTJV0';
    b +=
        'rt8XljCnjVGRaXZDacFq8+w/4+D4prGC49PA+w1AL3UnvGrxd6PSMAUuINiEhnOCMzXBieiuucl';
    b +=
        'E7B0HqGbcMpBLdB8Z4L+yJhzjpMvlXZ5NuUTb5VyeTb5CbfCmApWcS02HrzyK2JekwY3V3R4Yya';
    b +=
        'WgFBbMctZ36zyTedib41FVfK8c+Zo010tYprzeh1Ex9+R+XGD1Sv+/AHW9HrHP7vVLo1ycKOs50';
    b +=
        'BNEn0EfGJRgiPv61xeQRdJsc+QZYr7PDlZKLfQhmWs2QlTdLloKN3h11wvHifyi41fw6eR9KL2o';
    b +=
        'm3Iz6NnXRmF5+fiJciBizxJhERiuuSivVFhhsyLZqI8BOewP2cZe+4zr/SkXUJQqymwbjUsEU01';
    b +=
        'kdgADO8tnB3ddn9WrYs2FcsJXKY0ePEY1ZY4jmZqJ18PkzamKC4lEs8OwaScIKatEtnIgffYHdT';
    b +=
        'gTfh0u5ukZp4uF2ACaDsgMTDEWtd4c3w0Adoo1ybPv7Lc8VzDwkR6Wj8gHcGwnjyuupHrFsm9qd';
    b +=
        'LWAM35g1wzpN0QvqHdNsAkMsXYPYGG7el8SEWa9bE620oz8YwTnGBltqjfMzvzQGww+wbF6pTHm';
    b +=
        '4kNTu8ErvGHTT19W3jhAcasR73DhfCYvDHdVCoUr57ikfMUHbfSHxZFReEIUd03X4lnJF4LsJ/g';
    b +=
        'NZxGBdXr+VsQyMmrumoNA6wte3AliFwiQu5xGXCFCi/N0N5FvFwFsFwi8EOhKmCWhZfngG154BA';
    b +=
        'LVe67BUH03BHy0urFkY7MjLcuTnuwoVxJwrFwJ97Zvx5aQWN2zv2ML/+KuNPCAqgVAYUJkUzp2u';
    b +=
        'OFgSIH1/pRH8U0hIUTPd6JhEWAUm9rNavsC8Y6LSLcr+o89dL6vwK6vyISvYldWjU1zvV+fEAHK';
    b +=
        'fHXemZOj/OqpwhnJcha2FaMrjzMlh1/jrU+W1Stzp/Lx18neng5+rofknQP18xvw++6TMV9TqUy';
    b +=
        'mPoxSf7RS+/AWeEUE3OFflFL38qyXXnqYYFdfKnWvX0ui6V/JZipfx4/0OtINNZDzKd9aBDZz0o';
    b +=
        '6ayHvXXWg5LOepDprIc9dNYDq7MeQGc9zHTWg1xnPeypsx4UOuthl876qErifXh7BifVxB8ve+S';
    b +=
        'v5C+D+W9g/cFF0P7tv6eJd18hUGpWoVlWPBdWgV4bnguDBhM/nw4+J4B2uy9iexiQ+1BhbwaigO';
    b +=
        '7bl0RqSIUpN6uolzWx/UwT2y9rYj94fyFJxXqBBcwlAldnobpMQ3lR/GN9UbdGvMcOcEG55mJRj';
    b +=
        'meN48X7bxK3VaKl5QmkddGTb4giPHebQe5LYlaXB9hZCxDYCSQJa9vhCZ2kDhAyneunPpApYZ+k';
    b +=
        'ULoy3Xt/b9Xx9GGkN9P783RsMI/en1+Nl1oJuKuNqY4+46L+ySz7L1WUmhFrI33mh1hLa41DW3l';
    b +=
        'jkaO0cT0/CCvVqFZv9MX9/KIuJaprHGKfcP/Numd6VI/oZRRx9K/nWLtd05zG9RgWO8jIB8VFZh';
    b +=
        'vHSuz6S9vxP6qmww/u8qmLrb56VvlAXuXnzqnK+KVU+SfnVGVfVuWrjLO2d5WzeZWfP6cqG1KlK';
    b +=
        'ztLzypPPptV+fQ5VVnPquTDfmeVSqo8nld5/rnUWIukEquG8fWvovRgUd3jtrpymegsZQ73KFM9';
    b +=
        'S5n7e5SpnKXMbI8y4VnKPPdX88sEZylzokcZ/yxljvco452lzFyPMu5Zyjzco4w5G657lNFnKfP';
    b +=
        'CV+eXYdGrHeCZXCU+bZossxoS97qPBywtGtRx5qy2UESiU1amZYanYiP5ZY0rcJ2Z51mfvS8GxE';
    b +=
        'yxGNgZFDBYv4fSiRnvDx12FpZlg6S9xZfjcsQwl7Fcma+ojcgKlTgxf7Po9ulS1B0SZSQqMXJZD';
    b +=
        'PmxkTtn3BMjLLfDbNJf3BDb+2EjXp5DXISb8cS6Qc5fKgr54h7NATIjV9omfbM4BbqDXfMW7Yal';
    b +=
        'dsOsXdOz3dx4O8jvM/DBTnDFjXEzlLt5JSw6sSI4KiZBSSoZMhYNX+InZqCpZWsdkAeDrWyvBw3';
    b +=
        '6okwk0vTs0S62Sg/xpRksurho0aWbzPIlTCIycuhpTvDdJ8fw9YnJr1xM+TLGlC9jTOdljPV2zy';
    b +=
        '+2+eVrzFJtnE2xNkt+jcmWF+ENFm8UHG8FGYcKkcvlTsK+8c36AeqH9WLBRiKBgB+kandTnO4j5';
    b +=
        'EdZGxZpIkVmbR9Cp0iirCLdOj4lh3AhFPf7DvNEqg/WB8ZeRqy352iNPEC+uCiVB/MSfr7BT/wN';
    b +=
        'fUWjndVxQ5JhQWKa6FSg+mbENbZZCfMgN9MFX0oHsBZRaJlMUaq4FVDV9rJIFUR2IKKsJPI6Ab9';
    b +=
        'lYn2AVq3dQBVTQMvkrIrfd3aQJG9BVa2eB7FlkG/08VjZtJFfV6ap0dhJzFsV87eK3A2+9MnUOx';
    b +=
        'qcmedzg7JDvQOZTVdmmU99JS2Pej6Lq/wcDrizOq4S422F/SZLVBuu0oq9M7Ci6+VOrc0io4gfH';
    b +=
        'uSrr1BuBEJReAlF4YUlOWE259zsIW4WYHC+KOFXwxiBUX7P5oLxQ0FUP84eoZj03DLhiEUScQaf';
    b +=
        '2+q3F1cY7rrZRwTU6TOZKUdfw3Vd5bAxCfDdlxoWETXS7znNXPeKsvmBa6iXAZ1DKBHlsdYaCn8';
    b +=
        'LJDWsbJNq+v6uNR6DPmc8QBFoPolTPQn/5enQThrsMaa6g+QYvaFRKUOStrqoB5gZqJ4yjncmUB';
    b +=
        'lQz6VZGJSAcbsANaVOaBHp9nfBPJR+gS0kGeo+vJ5HxzG5fe8Je93UxDIIqtT1XBVII5yrAtXtR';
    b +=
        'SD2WSIodoYoqY0n1Ta/uli5nr17oBbxug4RGYRZfDWI4VNezzvHkinGEsaIzseIKo8RqAq0GF52';
    b +=
        'Pi5O7dy+rCllm/qbUHszPlwXnApFI0/9V6tToRK1mXvGw7KSCSiCe1rVTBQQ7qV4tW/0+5JER+7';
    b +=
        'K6NV0jnqxDw7bW3QQvYdOjEa2B3jLJqy7lMcWP/2iQ8f2m1rBQFIvxf3EAKOQYqs3DeAVEhd+H5';
    b +=
        'iSnvh8+MydoE7toVTtanp05msQhFkFSULN7kvy7/AnWuFAMxol1gZmOo2sWPpHd6bH76QofloUs';
    b +=
        'sfw1eo5eBhojJiT9EuskDmB72jEPIVf7xrn78LM/z7MJ1l1MLCqFnav++bPPyEJ1E3nJ+EnvzL6';
    b +=
        '2v0PidSaE5+nP1kiRlGXW2tWzaPVFp7e6NjNdis0yo3oZ5lhfRCWft/+eXY8iaB+tToQygXPk9a';
    b +=
        '//FzICkwHwP8fg3GkhxWoKP1PL7U0TavJFBemIjrwUuf1A3Tip8CnvudsZAsgyg6f6vw3hk2Auz';
    b +=
        's9D/4GcY1HswHXTbOzesNAy4svp2SuyTIO7qA+ELI6yFxnLcQ4xQnrZiIl5egDYUl8R4Beag6EI';
    b +=
        '2YuZGbl36hjIZ61egPXhvyD3J9B9I69AHN5N/4PvfpMyym6jIDYFWL0Z0jCIitmtFC8tZj8Vo7J';
    b +=
        'hTEIpt5ND4W51q7zavUA495WcupcKjEdwCTMM/zwtdKa+AIG5cXpg7+QyTJeeg/Rv+OhvOiSWDL';
    b +=
        'G13E1p0IsPF70dJBbKsAY+VWyVVjlKcXvO7AUybLhnjhZ4EtllV7eFHf7kCBO5MpN2UMOfA2aGO';
    b +=
        'I5fZmHhrOIAix4zorNWfCcPu07Kledq2Yx7LZB5ZylKvOcqsxzqjLP6WdPlFbBc1aZ56xkr86qj';
    b +=
        'mwsAcNTrda20ed9JspPSDy+wOkxKx7/jhaX6UvZPLOLXysfrnK/02BgWdSThhN1l1UCfbCyFdhI';
    b +=
        'CxPrwyTTMrGG19WuJt0Fm2TevGKvbcDkKn5hFaEwd7WQsbsVYXd9YXerVvED2lsYunjtpzKP3WX';
    b +=
        'XIDm72xMJg3pZzgbhQ9pZ2nREadKI0JO9b4WiBJzB1dkiw9LkM224QbrE8OJQM8QX8IQs2r0YOV';
    b +=
        'D/ScoQOWXUmmx7m4/g7JRgFkCb+RGjzemJKUcwpWydeDdMTh9JZX1d2VdyuW5VrtuOVVxxM2NaE';
    b +=
        'yREfC8MQWz0yzjul7QiKqLkreN/39I4ofRF0Axg3UPWVDmrdoCa/6KO2jiAV2FVGvPZrvQUisme';
    b +=
        'QnFFPwXXWQp6Eh70U/z55gSil+KxMXbi5zocOvFzZQs6OcafdOGWVV6h8fg1tQ112Ea74zhN882';
    b +=
        '2S+m7samiPV7oEOvzIdIlKDdIO+N0iqBzgW+1AJRc0vrjsK9gtRZYUyxvc2r8UQ9PF9DKF/8XDx';
    b +=
        'fSPntPbsF4wcfLE3e0YZbpxg9B10KxN+NELK4IMZNt+mQDrEKFwEsCeLwvvReBFxugHMbvFLGf9';
    b +=
        '+IdCRz7Ycgg70jUWMfPHW95+bMtLqs2A7MceBBqul728zp+CkzUWQRnN/QugDpd0UcQ5/HPZH7X';
    b +=
        'n7WaJqI4kyFeVIq4mF88vsFX5A8aqyztiWwKbVEhX96csU3i+1t0LI9/l98q87KnRnxRbdHiXkj';
    b +=
        'Wzwo742USiW5yBVoEFX7x5Ax++1mOVLwnZDvtFRCE2c/rBFCAjvehcUEYt0BrlYhdHoZTelc6xW';
    b +=
        'N1AFa0TJL4Oy4/0vCqxIjkmkU0yiZdiJQIiltc7EL6e68X/bWvDA7zCd8SsFyY8j1gb+Evd+L6A';
    b +=
        'lcHSOyn8fZ+Yr3DQCkVqkrVET2rD1Gc51GczzKFFpYPk14hErBnaAFiwWIdYmdpMv5FLeJglbbi';
    b +=
        'v8MhjgW9ijJnn7x1XJF9BfyccPbl46uWfWG+pdXsC09sp/Xsi1fSSvbFYLCi3n0q69UVKqyXDNy';
    b +=
        'vUFXq5OxpM0HjcfaI4Qd50tmjhjXU0sXdfWBRs8Wh4M9nTFFPrsdVf8+0b1Gal6Xdp9BqXPczAB';
    b +=
        'ahZRgH4uINoIhAcPapLKo6CZCO2c+dfIsHoI+YXRR+nBia2QOPz2xgImT7Jm7OXku1qZ3XOIv5a';
    b +=
        '9Hu9BS+WP8v9XfnyYs4olZE9NMZywqUF+h/d2yAYTB75FMzu3JQWK0wzrTUlO1TvKELtrzxkz1h';
    b +=
        '66dzo9AxMZScWgl0uYb+rMwc10D8Mft+sth+1M3GTA+wXTbHrmWdPb87XfeMVVxqiUi8E5F4f98';
    b +=
        'Xi7aTTqbBjdbpD9/ZOFZfFJdX9tuqbiLFh1WZSg/8IwvbRdJ4ufNuPBXniArU3GMpeA2I5SlYky';
    b +=
        'dynnyM1cCA5ifx5MU64flCUTcWboWP+GCs9TXOGjmbSo2P0/LF53joxcRzRlgQ9xrn2kScL8APB';
    b +=
        'WtHs74GOmIsuMdED1UVLh0VqzCMmNdb7nxNOz1OnZG88b9lna3LnWtTfvuHQ0bUqufkXSzNmkPE';
    b +=
        '79BvP79GiY+Wiz9e5m5CrJDD+Am+HKnR4e0Jl9dRW5/zQ9QHRWhbZWaU0AtJfJNMWK1E4ickzMh';
    b +=
        'gRJsTZBAzFREUOqwkxYXYMUb8uBZONLfFZe3v9MDX5uQLBH4DRT5+GhGvFzsAweI/sREna9ARVM';
    b +=
        'Y+SpOFoT7OD4KsYQZrDWyW0v0UkypLsQPfmHPSWfoTvzrKc1/GuS/7wYgt+tslEG8CLZKUn1LjX';
    b +=
        'KxQI70VFXs2eD5h+6qlr6dOZX39Av1em8N/C4eG2DZLsYZ3AeUsjS4xxFKwYl7pRH/vZWZWOtPJ';
    b +=
        'xBwQ6wd+I8bqQ9GhSExOnv4lfofbCHPMrrH6InsEDLL9ge2eIBkq7YtBGm6wdpBs0AXu32Edkbv';
    b +=
        'EZQ+vJnibyIEfHT6SVPnmgd38wMQcojpIvVswN6/Z2wnYfFVx1cNZ+AqBctJcrspdkI3UiNQSqb';
    b +=
        'NIg0gjkSaLdBHpSqSbRXqI9CTSyyJ9RPoS6UPd0RP5IrrUqmzkCyYxZCGQMbIjODWK0vfdf/gpZ';
    b +=
        '1f64ve+e2d7gsXmSKwisdqZSJvW3e/ae9cEjmvQ0nKSyg3WbCzgwyoQFv+jOOQRu324OWKVf3lq';
    b +=
        'tWpByJGo+PVhILEtcmQgFXJ7XC+AZYalDR5hEsmAL0yZmL/wO7we5jIn3QCGn9lpv5C6855BPDf';
    b +=
        'rs/g3MrSeqHJq3OvoJpdluT9vd7A0yyS3YHqdrsGVWe+JeQB2aWZeCKSsTSOfTb6XGRfzIDljMb';
    b +=
        'enbf3/zc/EtbPq/xfXqrtEWnuHCGvfKrLaN4uo9qfmSWoxloKFJbWhldQGvSS1EIMG0UuQ0g7mQ';
    b +=
        'tqVIrNLRHB2szx7WBjh3sICVlMq9k/nXoxN/xNIRfGSh5v2tdP+eGUmU014ueMXOMrpy0Wgaq1K';
    b +=
        '3A51SJan0up9UyTy0Jvwhxq/Qt3CwtMkk512wcTFb8GvKypquawyKWz9hqzyCssqLxNR5WAuqVy';
    b +=
        '5UE/FPaGVSQ7mIskF86NzzzglaSTsY0QaOatEGnnEU+FMydpcjfMDkqKKwFqn4r9Bp31sI5BRSC';
    b +=
        '6o2VIXxvdh9vAtyrHurLG+HVzeb7BiWJ1aP7EeE3zc4Y63KjAI9sb5RUj6CdhGHkqsqTyQF0BJA';
    b +=
        'Na4ZpKG2dIJscyFjSusJbkQYg37yOF25cYbmmKTImagc4d4blBcxvoQxLWT1K7oZKvYAYQqimce';
    b +=
        'cjrL6CjzI2Hx4YrdPAXHgQvTZkcEYs4Aq0M2MXThtlsedRAnaHBYAdQIJvDWixlvcbcqbXvXrMT';
    b +=
        '7jCChkqrXs+olIcEXJASCBFeQ4JeRgCaBaL3bilkIE7b/9gVu18oU5PlJrh2PFisuWPS8Ozc0ON';
    b +=
        'iAlLaqCssMNXg9l/VWuJ/K9tPK8kr9ZHRXgCOW34VJgAFGJcabntzKy7vhMmiKemYYhqx5J/qCp';
    b +=
        '82MN209tbHrjPQ4+4qQKQWm6nG0fHovuKqjCEbDelI8XtzBs+MU7N2PIQUellYn88re/+7usnqB';
    b +=
        'snLjHLZ8mdmJ+OPH86g457QCdtINDz3sT2opR4Z5JDulSjiyIu68zaVUWXXELEXIaWKureHCtqY';
    b +=
        '1XCjMP6hBW5JW/DX0Q2WvY8dp7Px58Lb0Fn6nWR5ZwvH4Fsa7eB5DDYMsOEHQxnrxt0F11MCMWb';
    b +=
        'ZmrmnHf5z1+8+ACnZyZyM+rQU3Eh3/pP39C9em5wEuCZ9dulzSZoFNzcdVBl/RSgYuARJ/2lgHw';
    b +=
        '/x1H6+5S5p8lIl5aoUZEPe5rBQipxy+y8p9fF3P1JJKM3ipf7/ulhBhMQNLWfscJ/v5QWwL6Cmj';
    b +=
        'z8PZ/KZypw9mAUCJruGPslFK/Ofj7HqEhhorsz7iiQPCOFdmlZdujfistZcRmJyJ6byPEK+5KrN';
    b +=
        '7Y5m8HAwxMrHc127DqtOhf7O0GbJkiO1KTGk/v0I5DePozGOOx7Za6ROiBM6iArlaSE988AkYEi';
    b +=
        'VOxt9RoyzCug7i6znHrpe45zLZrdVrxTUXiuYsHzSvOAbqWBm7aLg6L8paYWsuJQbDIQOFP2FRQ';
    b +=
        'GUqBNQBzQJ74VNxygTTUn47QPrIVxLypVtQRofOAjTOHdZ5H2BPvXz4cGB8q1mBHR6iOIk1PxzR';
    b +=
        'lnJgaiR8P7jkpMpKSchD7LmXeeBmOVw1W9+Jb8ej5Faaky17VvccNhUObCrSoZ3UC+byRSw3Lcs';
    b +=
        'kzhDs9cBFVjrv3CE5eeFlL0p5YXZmskMk5QTBeuxKXA3b7LJSnkBW4FJoCZYV3mFobb1ebAFdkf';
    b +=
        'xhzY2+7Im4JxlveWAlMJT0TrmuceB8+IxK2EHDVY72NI8O9k+j5Q4Ul9PsNhgLcgUbP/GhNTEjI';
    b +=
        'Lxo0ekJcMoc1Ac+meLMCGs7Cops4P5Ppq1QHqVOgvg9Cu9bUBy6GYpfBcUSiQCaV75Isqkwxx7A';
    b +=
        'q8L8HHziWy8M2OnWD4jjNwfSOY8fr6UfMC7DusZqhhU+TF3uxOvqFYEWg7PFjkJtuxUrCanI4oP';
    b +=
        '0+FfYuh/dIuJSuSh9FDIKmlOuKMd7uSs3z4pIlibeKDvN89JD35xj/WqPVzwRBnh8Zr7GQboRO0';
    b +=
        'DPPhIT93tO8Wiwx1f8DhegYcThEOj12GcBg47DpuQPBYgAuAnB2lZgew7hWgCt2J/C23lMPekkL';
    b +=
        'w/czYD7WMGZwp4eE1n60JuUsJmeQuDk83CbSEsODbO/+RuK+DLNs+co7rM0ccx18ahFrnARfL0T';
    b +=
        'su0RDbqHCQ3xP8O24Pe/xs+RPP7NzCiLicB8aSd8GXSWCBYr9uYTIQL1864KZtj2gp8TZDGHJoZ';
    b +=
        'jPA0mcALYwG99jFs9TsOH68zXthiaG7CRxCoRMsdxNhVF2OrlPEtpF7qeGbuZNjgh9qMdwvExO7';
    b +=
        'kGBbozTvfMuGd+xj09M07NzzjVM+M752d8Z8+MPzU/40/1zPgOQkRXxneUM/IdUwWWWkHuroste';
    b +=
        'EIpwt5PbsO6iakvl/u4tryrLYIJMH93sTK2uwvzbBdVZgUycMxlEzwkeF3CmHX2KGI21o0Yr1nf';
    b +=
        'WVZY5vNmGsibzX6mzQxdV3TIy3xjByUX+IHY2QQYEyLO8TmIPeAXPVW1BitmJXvnayfKenu8xhl';
    b +=
        'MjJz+Xdg4GMhTE6y64vt2qfzEnZ6JPTa8twrj68SlAG7kNbghdr3dZgEumB7aYXA2EPURcWLDtt';
    b +=
        'd4HZT5CrbtXGmZCtd68DMit+cCrPXH4qumCPT5xl3Uu3mvz4zvRRSfepPs7kVgeC1AgFWr6LI4X';
    b +=
        'bA4nbA4ZViM+JtiidYyeSBvkLkgtggZTd4LhMERpigOcOdxu587+mDdEMZSw9DGw/oHZpKtuALa';
    b +=
        '+WiPq8EVw/fY2UmNOSuqyJKWvZougSMRvgehHZBXiU6dk6xenNFYh6DCRqxZnRVbZ4A6+dWOAHc';
    b +=
        'eBkoESyk3EqkkdbDAOZUGwnWG6ZDfdm35MuocfogeYv0NcqRi3LFc30VN4JgG2NEr85EldFJmQO';
    b +=
        'GI7Shf3tzrmWBGT7NtePF2U2JgU5zoo79u7YgPvfbXP9iqlwyM6/MMjOsf4SkM8opdAhjydAaaB';
    b +=
        'bAzrpeMYcWxc/ZoCAQuIV4ywivuh0wmu3Ht0Uocw/AJC6JAmvZ3tNhGfyA9eJAW/M/jGHFZW0Y/';
    b +=
        '5R4kItDPSjg8JsTw+VSLAxY2UaWxfhvLJjCp5S3ZsnX1/oPZJsKHjSD+Cy2NVyAijZ/pbENJG9U';
    b +=
        'kfARemDM1i/xMWE1YxoC/GwfSB37BwiuGylxRVSrypCIfP0sxPXHoxwEUiua6LauZOMKw8iqGr0';
    b +=
        'tuFY+YJJGm46PaPoXRJ10hpP8FN70UtMFEYSZETzaDUadZM4URhdiue+vYuyDLbjRw5jPOtBVly';
    b +=
        'AkRtdkTWJC5c2RFEcCo4nfK9aVeTQBG03jYp/YaZsGmeAUXf2v8WFONzYb3eUp3LJN8gb3PnMWy';
    b +=
        'z1zuMMclluqAAYfr+MvK2rNUiFtuQdzvppevxxtb6dfg0pB+/4cD+0w3fd6BbaSbfhEX+PT7Xfq';
    b +=
        'FoWiHCx4DmYC4Kg3b8c9rYpXZ0pmXSRX/JU+1kBUBBu2hX+6NMntsgYs1V/4KjDb07NMquCmuBP';
    b +=
        'G/iXhcssUfdXmFabnxI0bKgTv8jzzbraeClaW8FgwnA2Nd3YvEcN9lb5OcB75e30XD3I0/pfAOO';
    b +=
        'HW97kt3fo13G7ww1gmLVyp7CGVNqaxXKjur5xd2S4U/3F3YLRUO5iOBbcej+fHsIPvc8KvEynSQ';
    b +=
        '8xHrbFJvXn18vo/3e6IkPiRnnFOubNdxl30pX6cJC5kZ/hje+opDuPgTUpnTHWHFs62OOQXxC9+';
    b +=
        'SBw6gYleYxVi1RVrx8fw5+zKoir29iq8REaw1XvG7JQH2vAo1vXQIOnSsw8dKelrcUmuW9VOrzN';
    b +=
        'r641DTY/thNtZ2Zc2qEbvVWyjA8kCWMgIiTzqYKZx6qYYFeSsqnaYje5r2RXyNFyCqmTl4JKdpP';
    b +=
        '+JzJkuHrdyQdkJXrJGyV8PEIgkPdMNFXNP6SIVdy0TDpbO8w/qFLvseYH9caje7exP9QjfKHgzP';
    b +=
        'pCBWCZCFpez8HpsD3iArVP/slZpmpCsb5LO9cIcuc4BYczfIHYRtorOWiOvnPHy1J8qDcDxlBfr';
    b +=
        '5qdqL/toVXaU5p/sBRQO/xC15+wa0fFX8Mwq8H/rI76Bk/o03ivdcayGhxNMkm0couQ0UV/9cAX';
    b +=
        'UZMo7DtNmly9NjBzN/7sp6Jj9xMHPShlGI5wE80QDA404idaJcX3EEFog0WYT3Z3ZXH5TtaClNS';
    b +=
        'dNTvwqLtfU1Y2V6tF5/0OUdi7cTFu4RP/Aa1hqAmzyfFuOWly3HeLP2V2dkdb5wA8weKeJTRQQ4';
    b +=
        'YAS/QkyYD+mUn25oy0s52Gh5741/lXgn64JGZ/JDCwcWTt6hQ8j1M+80+g57jQNpOY2Jo0pkOHn';
    b +=
        'ELyqrH+EwjwokDI3Yl1NYbJjt1mjnb40A9hvYYzEkLAvyXM6CcHfF8lE0UO3rK1lx195+eXBnk8';
    b +=
        'nehc/h/dnmZ+sB1hV40FO+Fd448w3nM9GK00O0oqxoRUG0oqxoxapzaitaYaM2NV+0guHGnmzhk';
    b +=
        'w4afale39IDrPHDYwEqDi19uePyckprGOsCQnnHIGxYu4yYBVeeWOqloMJ3pNTRyx0FfTN5pgW+';
    b +=
        'kwwLccy6OhZ+fT300rJ1O3tTBasjpwXiNmYBBRgXkDG9HZbN5b3PZB9atgbFsg+nS+LBzv/PLvT';
    b +=
        'oesEmV5BxRu2TCaIgIz43uVLWj4FkB9IfcauXzqLaV0mbDyM8923bZkf9mWgpr/y5b2eVA9hvZ6';
    b +=
        'omZ4Pp0He6YEoPf8cKZ87c3vF/LrV372nb3idcvWhGTYsbpEDGTY2FKbjqhMFkiBQWCOPfxoFWD';
    b +=
        'Q+T1dl1Ihx5YIHv46W4GbPSTvMCebmKCjQSf6DVj4eFk3DjQLu5iIINSOuSxsYBSsP0WZx7Oepr';
    b +=
        'LcH7XH3i5sxhLyHoQ03eVk8uICj78JLT/lF1z00scVrSbp6XLIY1pq2jwe9EJBFSGsmiZn9Sb56';
    b +=
        'fVJvnZZo2lKefL1H7gB0fq3M9Ss7HtGngAUOT9AOq/uR8/JxPTTbazZcl58HZ6dLkPMz78/iFLK';
    b +=
        'p+afIyil7PCv7JkoRYGKmU+Nm42WBFVFwMJwhBWrj/hL2HQFPpwfxrceJBSbyPmpL3Mc9Do/1QO';
    b +=
        'AAIDUDSSM6HOKS/3GA4Thmw4dhmXUL6krbENfuwNTWo1ee+kLUD9HIb6ek8LkMEv2noNRuIaQBm';
    b +=
        'xftyn7gHpPV6CdgZhQwOMjjRP7vKnbGO3P7PdtA43z2jjv6lXTNeL6t9p1/Evn8NX40qJ1Ikfo8';
    b +=
        'zfMP93r+Ei70vuapmjwx8LcLvFLrteJ+8FcMXlDO7IHJA/XKThfdYMSar4rIUbCydw9PSM8W8NF';
    b +=
        'RBg7rcNdTgW9XgSTjN78qyKQB9Z8ZYIjFzkZI+/97C0y6P8zr4qEb69Mk5VgVr1ZlJDVF9H3jDO';
    b +=
        'KndwCbctXX2JW5W56+JP1cckGxD170+u9mLrZfkJp7rxbGqXXfF8zh/lLS7pDQVqI3Hj/Lxzsa4';
    b +=
        'EoOdwhV9kVikFtKPUB7aTZ/NetODn6yLqr4Kw1CHxrc3mHWrrF+pVHBLcN/75rB81yEK8OgHWut';
    b +=
        'h+nMciwvHn5aQG6XvlRAxyO+REJ0w3i0hGhY/wyGA30g1usLWes/83RN3m2GAT9F9E+mTFsnXOB';
    b +=
        '5HubtLUS6e9kx97jWoSyMgBolqSR9b/0XpU/tp0x5Mn36vZQV/wRXG7aSTiUaubWenTJEj87t5N';
    b +=
        'OegW62vpnnl7bazjxhccTJnFZ6s47jy4XkInnTZVZtki5+3fvUH22xcM9SOfx7MMBZx4vM/rfLa';
    b +=
        'Wm7pfbBBqSZhGWT8EVdyiYAS8or4Izp7kYtrxC2+vLjFDhYwawb1Mn457OFSYXl8Sx4Tm7NKW2W';
    b +=
        '3dDeNmOtkVcFjM/JmAPeTMscfcEVVo4ZrVnllAJ4a4SlfjQtHCXd9/JCa+DjkdUvOeViR17FEB6';
    b +=
        'jx4hOaz1bC+IV4IsbbKfz8lNwguCKvDXZbHQqcb468Z87qd5ZIMDfvwbrrgDxLpvgxLZ4iN4hsf';
    b +=
        'Eg6RXRzd8ZfZFGFKP9+0hVPWEfobBzAY0V6DHoFvw3x4Rp+xSZ+TLa8YFCvYbUqMSMOoJBsmw+S';
    b +=
        '4FJ9LUTpgbz7R8fSOOUrPo5JT6HOg9A9Ou7kGjcBtGaupbj9++ZY/TqAfOxBherwgBA0mwOuZFg';
    b +=
        'fEnji1dICa3JwC4O2hYP7pIXuuo+cue7BrroPKNu5pSXsons4ix5QUlhyDHbnoMFrq5KKJDMjLF';
    b +=
        '4LqzfaY+IvIIeDlwClkCOFMqgOlCuI36v4lZyA36SD4jOh+UElXlA9uYsW3ZOAlUU4QI39iZbfP';
    b +=
        '8fvEVEZkYvMa9Hb9EN7mbmXvjyDj5Pvzrh7joz/3IUUdoHMc/ts5m8Z7RKbLZtWSehg5VNsjQtF';
    b +=
        'LBbXpVW2/LyWJV2F1bojO2YNxoaUtKS4XfLl+tW3TlRZ71j8FeH4tJQz89IRsdo9X0ON4z5OsXt';
    b +=
        'JNPYZ9huCuwB5vYkSdd4I1W9y54lS3h8XjWoARA3z05RQ0kER2pGCtn07mo/6Hid/RuHIGIrmPi';
    b +=
        '4iWuFDLDhwrxfn7kvacPbiwJepBdwv3sFOwhEJoXIGmW3RZB/jVgN+/QbX19k50M3PgcdPWUKkh';
    b +=
        '/C5Ir3373IX6LgR1aWuGahMGnkDK0eOaPrUejZsBLPMzvBBPGRJCy0ZX8jJDhXqTvmmsjpsE7zc';
    b +=
        'JKyzToMcphTx7WI1hO+mT2X5JYdZ1RaWWpxKM4kdkd3Sns2eRfyHaI/om4AD0w0DiQcPg5DWjMY';
    b +=
        '3cyPTsOfijPxEKWU7pJCPdsy2yFGmcenoj87qmyFiGw33w3viOr4MYX+r7SYfM+9WN1phV/otGD';
    b +=
        'jgrggGE3CNHV8pUL004EfOEfaR/+mgszwBn9ZOoBTWVqfXiY4a5c1069sk4S08D8M9CCmO8vckv';
    b +=
        'sT6o2ofJdDfNzFHB77NplCJlhTKX3zv6xXAA108Z41cg6v8eV331aqUAXqt8sQ6MdORtb5mWwbr';
    b +=
        'BClChpq8E1xvRvy2MRaOtXy0rEOtgpguxCjGLpXGI7JyPo7AmAyxI8z4BffCTCwKRwirxPuRSld';
    b +=
        'RqXSoiYdFoVTFQSXljC0XiXPQzFeom7npeANbNmkcgytJlVtnL1N8G8HzjzW9iiCLrrXM1zMgxu';
    b +=
        'b+khHp71DunBvGk7WWa+8aLFdniytrSweJG1wPq24HKgplvQZVyuIq4d1dy7L3ehDYi/d6zdyPc';
    b +=
        'HYmE85Es7FenHkN7mA6BS7cu2QPpyb84Kidy9S7fVpeKv59I7DqKG+lR0VFKz1A6G5F7HT0FU79';
    b +=
        '1U6dMNOHUn1tq0DsdNXiSC2iEE/dBXzXODUYDP8owfqiEu/I6Hl2oRT9jVFBcZ2Uynt3LAt100u';
    b +=
        'oQXuRE7c89iiWiGJSereOt/FJGWIeP2sbF6d8jVFog7itzEcav1bVxIuXTShSFo+zOw03oOEQRC';
    b +=
        'IXZ8ssPzVNBYdSJs/kV9ihVAU6jj4cShlxKKXgUIpO4HzhkLqUhhbEoRRuq0zmUCoYoDRezUO+X';
    b +=
        'GaHUoZXT5O5m4OC3gD0K3Ax6NkbF83OsLphB9zWZ9fCcAvkJZ9dFjrTBbku9aoMLjtiCUo+uxYG';
    b +=
        'k5V+jPAQl3Bk0+S3OCZ62mhfttakdIOt4g/q0k21PAcot9JD12evp0BfF+oaNwr/gicOO9+AsU6';
    b +=
        'y9KgTv0+Jg2U3vVGSxetE2hBnp+x7+xc0X3nJogNekI/crFjsZ+35EJ2ypsZN7UdGX/z/2HsTOK';
    b +=
        '/m/X/8bJ9l5jNTpwwNM3HmIwxappqtkM60l5SkRGSappqlqWZJuWkmQvcKRQghWbKUrksJoQhdu';
    b +=
        'tdOyBU3ewjZU//3a3m/zzmfmamQ7/f3e/x/HqbzeZ/zPu/tvJfX+nzpF2clcfAUU54eKJSKqsbE';
    b +=
        '6aALs0acAPmSoEHozhXC4I0cyNJJKrrhwY82wd+hcFz6ksPQjCsE3nXidvIsx8LqZ2YlIfOrY1h';
    b +=
        'emww+klzdXq1LiDc7laO4m8eb6d1MWucYsV6iICC/lCb6G2MqmxSoZBlg8ZAQc+sfr2sbjVcMV7';
    b +=
        'RYvg+busW7c6gdxfuUrpI+W7EwhWyqL0fkBfDRolDdYQwohyQk0ud6Oak9SQct8my7X1B97xgUz';
    b +=
        'S0MEiFQPaGYSNzcSy3mvmtBGUrY3UlVsBceFg7eIWjiHWHbeLGH6DLI5R40OgZpPkWKB2dBUnPa';
    b +=
        'SEjbfzfgZRtvgBAgnE1qb/s0tPSEzoVl3GQnJA1TMK4q7JKPGKwlI9mJXY7vJhYaRZpe1OYVGt1';
    b +=
        'XoQZqZkK07y40jeR6YxYytBjsWUUsosixYRrzCAM1JmH4kiiFjwAbWECqQ9yWUF+0ErSQTCFgJl';
    b +=
        'wnKcjxC2pFR5GZIE/cbPgbkAHeFi2clBVZLYu0LBt3yYjIblL8BKR+WiCanei5jQYyM51kMJNpO';
    b +=
        'Wtm3AYjGRvMYmxpJMP+MATPKEijmeXxFKjQEjftZYA1Q+7V9TWOYC8C0W8FYWWBYT5H0AXJB8f9';
    b +=
        'ChMijx6Inas7MYBcSQJV9oAMsSOkUsx4GCBXRlcMYcspEKLOIkwYiRi0Ea1gEbDHV0qMI88nxV5';
    b +=
        'pROwo1oP5Ts2d9+h6xPIRlEwmylXEDMxEsYGYqBYYcVgEqE7xtiE7r2rc4ZBfRN8hg7QdKLvUSc';
    b +=
        '9ngZ6M8GqBKzLZScfwEAtMEh/giStv8WmfzvJsMciLwM8fsqKbP+3pKcA3wspZJx6uKHIuLTLmF';
    b +=
        'Kgt6FgjpYBayZwavoEO/CbxeZ7ZnvLfxw7hIa/1kWcDuvGT/z7sidJ/nzAwkedDvwIAy1EaVg1G';
    b +=
        'UGeO25SWYaYv3ne2p9kzCQbZZG1juhSopZO20X3zW8GwHu3esZO1lveahmA9ZikjQtLqy3CgCNM';
    b +=
        'iuKPFK0T2Z2GnyyR7R7Z3kwZpOrn0EKdKsU7d5fDOc2yqHaLsXDwUjKvVsxiwvwTDbbCoi5NpXt';
    b +=
        'yowCDCOti54Nu4F8Rx5uJrIOwrUnhQFCRPh5UIi/JCJ2lmPKkHDk99eZbpLUcU9CUVOZdRcBaex';
    b +=
        'ElDJewe4CftMIvqycAvhSqPEkAXDAjiQYDwF5Y+VeEvNJm9ju2z2MA2uUgbloq7pdix0BOElOro';
    b +=
        'pEiaLRmG0SRCZa0YOTfX3bFCGneQOWDselh/gRjTQD4wfA8GdMbpascJ5pSjI+kIZGUikBXGhtk';
    b +=
        'XkJXZGMhKzAJwNMUgVTqqxANoVhqjWcW9EkX37HicwsBiADYVwRLQmqais6XOqCgodK6YCtkM2W';
    b +=
        'oTw7Whhzo5lkMbYGMCF/MKpMNZFSg+CWAUAUvFl97KLwCfEs4UOMaSZAVeY7QtNXhW+WD8rAh/Z';
    b +=
        'Ej4I+SHKuIa/6aCCatoHiJZIWSRFnuIN8b5ugQsykZXODRUmCIoP6vAnEhxhcDow4AI9SBBN2C6';
    b +=
        'm2wD7hCYkonGo8puFJ5MoXE0cCqLAlMohOhmEuObVB5K9PmQNcSeZ04sMM8Uj1gsvBliK0Kzbue';
    b +=
        'U/Tq0DyNJgizzY504kqHivHEonLfYSh203BJ03Js6bcNcdjqVjZsvoGjcZMkqYGEC0Iz9EM4bf4';
    b +=
        'POBD93yv8a1+1XCMhG92e/K1/Jn1DJUQS+sT/UJY8I3V4+G0xzEf+FqMS1s9cxNLyqqZB7m81Xj';
    b +=
        'BYYu4uZO/KHQkM3Dn4GVBg42EQJkI+Ie8igzjtxVgNdfUa54NUNsmMDvCdgRuBskmSi4h8IxSNK';
    b +=
        'PkdJzBzEI+ilJvIyPRti+p9wJGHzicY80pbtz+hcSaKWRiFQktghpSLSUz6i+jHaF60Xoj6OJJ7';
    b +=
        'ELEAY/YAj4MV8RB2ESmuYXoO8nzYQogf1r8lA9GTcqr3hiLjACGjofUw/AUEqyY0MAmmT6FAl+B';
    b +=
        'lHyMgYPWkSS++vSpdsiOlE7Wv0FN1Lh+2HdOl6FFtt6np9QqBXtCxzOw9AdsQaINHzGeQ1Qu7RI';
    b +=
        'SQcgHWEzRfMr0xywUOBkE430+mSAiQ3+WY55eTdbZAXV2Y5R0KHRBrjACCl+w0682vAooICfAjC';
    b +=
        '3kFYMRB+q8I1LBwAA6BwAgywZIOoNq8iVTbI1NHSFEsXxQ5Opdh2YvvUB6OhVKScDHVlFQ5XATy';
    b +=
        'WyIjaLZB+q5Y4qvGZqvHAa3OElx9lhBd37rV4Y/m18sZauBF3t8obVGc7h5xqoZUWzH/lUQPcW2';
    b +=
        'wery+2CUe9phXUa3qCKUWtKcGUksxIjSbsFXjUkncETHhBm3i6zSd0WWI87FNtRqV5MdAXpMcEw';
    b +=
        'zvpKwgFoN7yakNJksIJEbZspaOU1upk+rjuH6AHMAjKjzWRSUjLwVmPOlGNrHLRCjNM0cCBE7O3';
    b +=
        'IKoSwU+IdkRrnXA1fZuZGMcMjebAT3EaW+zLwTIDzgOeATUNp+ClPPWjbu8xlShr+Z8tqQSHq9Q';
    b +=
        'DKI4j0tvwt8pQrUoxmhWJHkhZKMlBrT9JDuoJHHFb56hr+LVuNMlXF6yKtXaabSPMqnjrPtNv0u';
    b +=
        '6oIJzt8o0T7VaYKx1yEWyqQRbTQGCeWG7PsWTUTgNyt8bctsydRrntZnIflEXHLueOknt7ii83I';
    b +=
        'TtaGflGe4SNRbSUfmBTrAGHYlUD4d6HiVTY6tqTLsL3nB+ciGBwup2G0VZkBXAUfvKIII1jdst8';
    b +=
        'I9d1aExAyQzzIxcMGMVJ/w+DrPItOUjk2Qbb1IleWyEnXnPhSpxd4BYw6DFQQ4jPTnWjIa6jx1a';
    b +=
        'aRoRkhX5G2GSGz1I+/CijI1gSsB4iPC5EVo4CDxGhY1mcx9tfJvMS5HnVYctHaGgA+ltY4ByD5C';
    b +=
        'zMgp9ZjpiEwJXgihnvq94m3rhV4xfIggODAYhPs1zUar+IKJ3AXIH9BhBtXhmwsnJxx2tMhLAzY';
    b +=
        'x9mgFWhm/yFsvVHoFCOTQmhO8XWDJ4PxC2pNZ7MjLapylzLZZqgAkz2laUVaYHXfNwxCIgWv8xW';
    b +=
        'ifeanok+kefRclaY2pt0uRWSeFf8SELq1wCSzCQExWsNQlKmIQCiwtt/xAvJYhNtTxI4y31Xij8';
    b +=
        's9FyL7L0Y8C/AXqAYFl4CfmklY3JS8xCVk1ciCUilLJRisXbQWiF70EFrTV424qTde62ImwjWTC';
    b +=
        'SLBkH0uxB7A/xS99Vt2bKLmWGwWd6I98UiZngN0jLyHh5stc73fFJdKJXs3B8wySxmh4ZmMQBbD';
    b +=
        'bZ6EagepwP4dUaAVLN9GOKw+wN0F0pQ71wElE26y2CYEfd23w3091zMNyKgxI2AUWAmAQAQJF5h';
    b +=
        'OdB5DWTPgvB/8jewXOKRSZYuVoExGqxobliPCFIR92cEA4xgEfnGRPxlK5OXKMICSsOaQipOkAL';
    b +=
        'fU7Odcgo+oIRZET5JQh55JLYRPklUWyxq2WsiNVuXpinNtF+2eNuivbUYkKiG/oa2L2m0vDBa6i';
    b +=
        'bdj8pr0wxthYsCrJgdireLk0yhk+qxhPmm+5ZZa/cdnKQIx5mO0Ye6a+lI9u9BZA7DbZNQcEJps';
    b +=
        'MZocSFz9ndeZsRagkRPn2rP12UFoKxOx7LoPLd9tnfIrCLdBfLvy3WAqs6RWj2HwmNTO8Du602L';
    b +=
        'UVvbZVkEtglRx8DN0eDbiqV1ZCWq1XIpmeTkIz7u3ReJje1k1mYhCKpYj3NDid31FtU3hlhUcDd';
    b +=
        'by4wLxr4WRgCU5bsiU6vh9zS3Ybc5FXj+adXVXEK2lr4/eS3Km7Y/eaOU196fvCmUN2V/8tqUN7';
    b +=
        'o/edMor7U/edMpL8R5SAfLQy+vrvLqnDcTQ5vP1uO6vVxMIOJavVXROKAlqGtNLRB5EeRyur0MB';
    b +=
        'cYW0maulq0t/6FnPuvFXe1Y7Y4fehZgUvxeTL+NooUQ3NYoQJMiDuGYjbuAQaKQduXu6yQVKTIL';
    b +=
        'BOFluIt2cNw89w3Y/zDoIq1tA2WlsJJkIEYKppdNwfRw6wb/dZMWDoiH1lMooA4ameec6A/1CJW';
    b +=
        '99qms7E20wIY+OzWAhmzUxjV318/r2KQxEx/t2iXT6aoNhaqFUX9ryMCG8QhkpHqxJH+wsqS83n';
    b +=
        'uG8laL3PyyvEPHAWcfGPntlhb7zhBcK6AI+GQNoDCpxaAe+M3Ft2d7GDx52CYGomxkpYBgWAxDX';
    b +=
        'PxOJTZJA20KwcsmAWZFKqiBQO/kRCmUEsZ8BQdLcbEGob1KcjnLmw3aRihEM1gTJEuT8GQnxhg/';
    b +=
        'EaAiGpUK9smpgtL61kIbHICzQksXtO4DYAYMF4Fhc3XqLrpVgkGPFFdpuEbc9Lp4qosSn2RS1Iq';
    b +=
        'qgdpMdfdoYixqIasOxD34koIrlw5iCh1eATtIHW3nsbUgD3fnX78eMF8WLZWyBJFlauwhpYeABc';
    b +=
        'PyOFoqFmFEhxBpkCCHCJ4HA6qA2C4K8bjfBfur98Q/okAUrmVQ/OIMQS8mOtzSKyhsivqicniF3';
    b +=
        'U3GXP6HIKZCjQBMHvaejdDJ4723Gd4zE2skUJ4kcqZFBNc24pJb7q5F0oFEPuKfNiRlAvCKdCB/';
    b +=
        'jzXSwbZXXIFSFhc7C4N5ddCc7loh/BLTGRZNCLDkssUlGY4kgtkBq3KprLbzUxnwiTqGaVDSpJf';
    b +=
        'LLhG4To77DvVc/M7leJXhGCmSwQ42DCbwIblsYitMBSmFAOL21SG7IRRHkg2qNexbQ3A0pge0Fo';
    b +=
        'JBfcrqw6J7k7Nk4qNMeIRKBvFrt0kxB0zbghyCLrVDwBcCbbrblHmowN0mx+Z0514tTsfZQMy5u';
    b +=
        'xYIbjFsh2HxIOeMVH+qlCaImskZDglwaR5u2bcg+Syr0Ypmw+YK/9SzRpBrBHeZiCgkCwOB2lHo';
    b +=
        'iQEnDCodqARgay02B+VeQ9ANikSHd0HaA53WuaYdDVyTaoGFdYH5Lg9JCNsl0m6DYV8TUuZpBnV';
    b +=
        'HMVT8SgxRrwUdsA3pAAo+sx/nn8Y75v7QAZpFefeHDkCEdzSb2o+8KZR3f+gAzaa8+0MHaGl8Gu';
    b +=
        'xP3nTKC+DoIq/my6upvBrnzYy9YZqG2MpCM73z/vG4WeTMXSY2RYhBjzY/RdrpOM/37HlyTwR3f';
    b +=
        'Y70nmW6s6ejplLk3QOg8wqxJQvfG4YiFKB7JVLynj3axXBfkzgvTwIxsvR2UBNDPeJM5SdDey19';
    b +=
        'PG6pmhwLmiUOgBfORzcp94MnjgKLA4T+uWX9jXvMctCFO+acJ1XRS+IocuL01pOXLo2HbnscJ92';
    b +=
        'Ui5+Mh8UDp7TfwT+cvDQOJuNp0xyj/OF4dEk8CUQeTtJtS2Afuc0J3eYrRuu55Pa4huEANXgvsp';
    b +=
        'RrufXZ6S8l3fj0yUt7r5x+Zdtnpm46ecnS3tbP199www1viZ8MWa717j2sx3utv35K5PuP+cJ14';
    b +=
        '/o+B/lGXRNf2G7AK/DzmjPgvw/FzyXi/7jmtRJas6S3tvSrjrtCH58kHi9B016MN6jdpsb+9tg/';
    b +=
        'TcOo12e5OeILGRLNICgUbZEdDfN/uhkOG+Em/rPgn5A4ucHUDZHm+6aGwY1pJ5i3ies3bLz3JZn';
    b +=
        'CgZ1wgzUV8BLjZLcqbqDHm3sM8QBklgghE0jdOh73VlevnuAa09xIzQr8OC9pc7IAb92TXZC3XQ';
    b +=
        'NFfhE/okNQ//jcMnECHOfedDfAOOruO/eI62rTHpPKws+7xcntZrs/wmWJICTvFNeVhj2mjzRl+';
    b +=
        'eriQgKN3L0HKIRbdiQT2v9WTG79FyefW1BX7kao8pc+qC13p9JbDfPF760TONEgEjfXcmJ3v3L3';
    b +=
        'hTuGDyAL/710EOAQ0eOUTXgttUeGQFB0KVAbuqQ2lDwcAz2z/G6AMudjhCa7nNQQ6QShuvwGccz';
    b +=
        'cisA16STqz8wKkzCM8+9g9BfwjgqjtYMnE/sI3B7Fr9w4vpoTjxCqB4kM0e0K7BrjoXJybcqG8H';
    b +=
        'KhIgwhaiJeHUDsRsDaIYTWDtGZ8SiYIkiwM9AfRBD5QzQuCoYJUVYjRKn9a6H9O1hSF0UrO/tqy';
    b +=
        '4kuIw0H2HpsgixfYwaNtBo/AuyEbp+m1BGA1NykoBs48JUGD7my5EV1CtpkEGO6wxD0g8gUq6VI';
    b +=
        'W64j1pZDa8uUKBo67CBx0Iu7O+9fj4yBeAGsLilUlY4hfBg1Bi2bYqSHMzFYFJth8BMV7+sIQt0';
    b +=
        'wakWNT4cYMvsIivH9o6zmYIAhIbdOBuEg0/AQ6MiR4PW1CbbhqRx5WhSy0ysEkAZqytnltwKRHp';
    b +=
        '4O4T9k3IJYTS6qimAMEelIPN65cj3KhRFndBB+cbDcigOkJnhX41agT22JIV3ctSukIZhonbtFp';
    b +=
        'aB77iaZ/NnQo/XBec9sDuPWZRMgCCr8xTdvn2/k0q9ssA/NYbgMhNkFeqOQ5ji6Bd5gsY8gGDMg';
    b +=
        'ulk7cDmbhsARW/8mJtMjplooZD3ExqIhUWkFMng7OBvzPCaZFcHCYUMf8QCk52FwbcWP5kSHoN8';
    b +=
        'DmMoBhxRC5C6DoA7BVisZABbYcNCSIBvgjw645PMvX6fGiT0s7ZssabQqqA76arhGxExn4BDNvo';
    b +=
        't1NfazIbpuN/0PcHqjHDrsNsgqLg8KyoLm5NuALUqRNuVgTkbx77wQ9NIIBBlod7cGlKaBZuaC2';
    b +=
        'ESNiZ/zNojz3nn9euK8UYAF38uS7PNJUheDknBmjVNaWVrR5ds+vvabNVe9uaZ+mL/KPX+8ylSy';
    b +=
        'zEnJIhEzSCg2sLWGSKWoFIRXYhGEySIIA4WVadQcWwk4zIBUY+1e6iaDb2JdzNjFpoox9pv0oQm';
    b +=
        'q0D/gstG0BpEVKuBgUuq5YwAncKlBmF5P8zkcxX2hyRJEnZ+YSk8ZcLlFJSXqHblM9Ds37NkWhe';
    b +=
        'Y2aJvGrsN95XBBA2Eq8SQ7YEjVfPNdgVKW6P46lYH2F4b0aNub9WHD/WRJmGB9qMwOI36zw/n3k';
    b +=
        '6liotlh1G9suMP0DBEj0hCRAcfxaN6bIaIdNERMl4aIUb8hIiLn6YGjuUlDRO9oNthWHGyOluEZ';
    b +=
        '49kLmvtjL/ja/Wwv6C4Rv9wsd8P9HiIiapU/MGjOB9HRgLDCoxTN1WALarCHoH2zruKVpWJKxit';
    b +=
        'LcY0s5kFoZ5JiNlo5pr2M+DACYTelug7JCDHoZJPupz79VbXElAz8liIrlo9b4A1f4LdU15KWhH';
    b +=
        'rjXFubLCQV/EsIzAPbTfF90BbDrHD0IdQNMcHv0gnH0oyp5hNqHEHwI4QI66/Ak8TVYp8ZPt9cU';
    b +=
        'odoaM3rDTT9stWvxmMQCYyBldj8cOIYhHAMzOAYhANj0KgQIJVJAeF7JxT4zpZrqKGFlI4BJBjp';
    b +=
        'VMOZLEaiP+tPBd+IzrgGKHal7I6MpCVSiqIklZG0GQxyZiYEOTOVhbQgbQsMD85c1NUvtt7gWCh';
    b +=
        'edA8zGN3DougeBLcC7Baix5mJ0T1giopZ7IvuYVXEMV5HlB1NgWYujydxdI8oRfdI8kX3SGoiuo';
    b +=
        'fVXHQPq6noHqaM7hEl87WkvUb3MKmtEYrukQToSqSWZ/qd4nuYifE9gj3VYu8YysMNXGSU2zEgH';
    b +=
        'kal7YKOKIcy9m7g+AtL8issHY2SUfoac5OQZ8MRRsW/36cII674vYo0J+aGIdosQuYi6J34AYaN';
    b +=
        'JgbGwpBfqg5ynUKfcs4t7SWSkAlGHPxAu5xq90MK8SlNDC0wOUTruRY4uOJcvtbAkAusQguzptx';
    b +=
        '7YTgxlkleTBhEnzbBDyqZ/aDMFAJNR4ftVwzJZpKliGDY2SqlaP6/tbNwTiJazjFE+rtJ5TDLwA';
    b +=
        'YMhA+QqSEehcusC5eJiYaBBrZpVWDgWOv+cINgDzpp2gkIvTIL/XvE08oKypeQg4EutKI969/sN';
    b +=
        'AKYQnGAhAiwURw4otL/onk3NQIcpMXihvuAZSfrDTVbPoeeQKDIYBmhhJxEMWCGes6QU47OP7D1';
    b +=
        'ANKlK0sod48RC9HuguQSI3x+xWcYuMBT0EoN2BIIQ2hmU6g98IsRlOTD4vS7yaQgSWgLPBGFCOJ';
    b +=
        'RA1gRJaNhCvCpKXHNZgQyg1ZAO5A3DyU57inw/SnYX7qMGviNSfkyQd7bkzKcSLfSKeKfTVEGwd';
    b +=
        'BFRywW9FiQ5jDQiL9BIwxK7iD7bYOeKEIKAxJmQ5QwnUisHRqXyLbThj/jFIxv6Guh9EixW1Bb3';
    b +=
        'rPwxGtHcFYoQmnguCZbxGC5BdySHWsAmWINYxxs8A34vjEH8owg5gBa4YM5GLBuYOq/R2N0AQ0c';
    b +=
        'TC10MLXILZzoI3F/EExU15oGhFsqsmainXHytteDzvYmGDeAaafpQQU0U2fBn1Tlfrn432Fqe8d';
    b +=
        'CbkKcCB1pkQ5qYisUjkSTkmMpqS1a2q1aH5R28CFt0OMLtZ18uto/mi1J4SnG/1yEznp7i/iS6f';
    b +=
        'RAd5+EVIZM3Qmpw2RqHqQOlakGSKXI1BfviNRBMvV2IPVcIPUIpFrI1H2B1GJItZSpKwPPGgKpL';
    b +=
        '972l/nq2/52XgupHjI1G1JpMvXuWyLVTqZefMtf5tq3/GUugVSmTM19i0cptipAIDNB/NtIt99H';
    b +=
        'vpq/nXxNJN2aItEl6ZaCpJtUn5pM9JqK6NWY6DURdk0SvVqM6DEtgejVHIkayjTv0yDGI/xxid/';
    b +=
        'mHoE8DuBwkuw2jDYTEwQ3Bc7aqFGvcHugsA4VcDYZmmYic+VuXgNYb+AEdE/IL2oH4LdNq10QKw';
    b +=
        'HwW3iqJBoB69zeaYIWWrwCrkNoOhoiVyjUeAuSaxMEu3U89NB0tqqpxb0C+NO201xrKqIChhHcj';
    b +=
        'ky29Vpg3LAOVTg64Yhk3CAWyCLDBsLIJqs1i1wK0IAnHaVBmvJSTkfrb8oMr8ZWGoZZb87ywfnD';
    b +=
        '+UO4V8gUa+gbFA9RkBLR0XL7E8WrasSrhiow7romKCdmTkNoYlHOYO8QqFMMN6v70boAo5iiG2s';
    b +=
        'IPdoiPQgQthw1+hYBMCO7GQHHVnTtIG7XiSinOXCdEdvhDrNIJ4T9FKo/yrGnRIkYRkSQO0iDJV';
    b +=
        'GVVJm/+CRxQe3UiFSKZIbHfnSZOKPeuoawdq5nrvZpEh4Dg68rvMjrRWuJ40hDP7W08jgBymZwq';
    b +=
        'C2QM5vkJ7coBCCO4pW4Kb4jfDCg8u5hAEe0RAHxRQa6zhrESIjFI4u02PiVxJR2Fsp9NA52g/67';
    b +=
        'eh9PfpeppjUuOYfMRF3bTSPaQOubQdg/jsnRAmRKIzDFTQimCCUBmKJItWTX2HSqwI5bRPpbIB7';
    b +=
        'Dt9NjMoYGPwN8IYuCDpg4JWN/N8hMiXc8Oju9851cy7GFqF2P+fZEtr0k2YHGYdI12BNBNg6j59';
    b +=
        '/OtMB2piVuZxTN3NFor+Lo6Vpgc9MCm5smP5F/49UCG6+WuPFqiRsvA2enQLCCTlkSlwnNvhS2B';
    b +=
        '5h76B7fGXvWUEjMihxyaeRamTKOihfKOZWUIKhgMAkp00eZ3WkQ4rHFJli4GYNp6hXgMQXFZqDI';
    b +=
        'KL3c/hmVgRqhriNHRgoq8D3B7UtDkyyYfvAVDPxnQEZct59Bo1mDHGgg9Ix9B1eboqqNxiMkZMW';
    b +=
        'anAjaKCL4lm7fapDeQiOw9zCV8QuyOvYzIXfdfLEwn2WXwU/A5mLzAglrxlndudAfksA6JIC9yz';
    b +=
        'AMsvghBzzPxT/EdutzVpIoL8SI/WHCVkAQAZSREyCCRX7xjkk+xCEwQjARkABEdyxGZGAGEt2Zu';
    b +=
        'LeRPAdkeiswkgbJ7ygwi+A+TdwTUY4XmcUivChsUVHp08+SPDhOme8Lu3yURIdCKX0wJHSU9zoW';
    b +=
        'As4s9wR4VF5KIM7WQtFr9yh37Ur20N5sUGgNtrHBFYqACQhdLRU4LUySLusKtFlXoM06gTbr7mu';
    b +=
        'M9gzchLvlZwUSDfjdBhn5kLhcMPAGSqFwRUNT6XT3H8OJONtQQgdNJ+tWvQZ1LPIOLrPuZMvhQ7';
    b +=
        'nWFcr19p/VhMFYN3sJZK+A2qVZS8tgr9MTYtOnqNj00PEISarRGd6bgY2kz+48n8e7ilCDIVPQ9';
    b +=
        'QsmFzqViMkWnH54Gpt0Gmt0Gpveaazx9NPoNIbpJ2Ze2DuNTQjtgDOPJk3YdxpLqS/ONycMcydM';
    b +=
        'kmMnrE5iCF6Ix3AkcAybUrUIVUSoCircXxzgijU6fWP38Qxs4oxoTn48AJkmdRT8RsrW9EuWxQK';
    b +=
        'XYuWFpidW9gmTyQOKvUISSenmyeI/RrKjEwNRxQ9ZPvnv84aeWk8r5MdH3Dhi07l7jsg35j7qQl';
    b +=
        'h0d8cj6zXWdvO+HSdCiUNQE+2NrsaEVW3R9ufq0+wVKCS17I+B9gg7YXteKB4hD/ZIRXk8IkjTr';
    b +=
        'Kh9dyieRF70yezon6XQAFKciL3WImC5cgx7EYJgR7FyJ6W8opwj4jE4M8S0h4CA0xjQOYgWHZPt';
    b +=
        'E9uyvTxERdq1CvwZgLRDBKQt8ZdDIJY0yGxdKutNgO9DyGYxSvjPoAwcLMeI3c8TD/zqEZTJflx';
    b +=
        'nrsV+1SLNs0EheiX6RxANxG4SCiRKIKziy70IxUEMXJN+NlAIW8avxUz8HB/drssINoD0ejpfX7';
    b +=
        'f4Mf7YIe9spR8aqcezIfCvtOsnIN3scg6EY0hkJLhle9b/CO+L/ANZsbifsGu7SVIiGAMeCPJov';
    b +=
        'yOwUP/fCm16hf6/UdqfUVoHohBXs+dbsFmJCzEx9f3Ez2pOpgeTacEkmHfOGsA3yEbWre8LDwW7';
    b +=
        'ZU2VD+BAYgPPjx557PW/wBuiMb4c9Co+HNTc62Dz+di6pT9f0Nzr+LDZ18EMdN7j/9zdbO34sNH';
    b +=
        'rBPe37qK3Zl/Y6FlsPjD0+ixf5BykW3TPqUkPYEhQFBKSBSFOCuHE6KTYUYZLSRTOAk4OXWG7JQ';
    b +=
        '2CcGAripJnxeEgX+YiLEMYxPcW63tMf5iZuMHW+E0UFFKx4DEoMems6ZUYyxdNMqcDKgxFjgZ1i';
    b +=
        '3+xvTg9AoqN07HbeOW9pDzFCht7ihWSp1g36SkW5TDIfk+xE/fuKdbdjVM4l5UW2kAL/n6FKbFQ';
    b +=
        'THuUtPbDqsjvihxOyL8Kj1v7bZ1dXPGaQraY6P1yYsAFU3o/Rj3vR7AYSyGiFyX1a9hhi5RJ4Ks';
    b +=
        'Fvj46LT7p//gSWsTd4LeIMNqx1o/thCy2ScwiFza0v3M16WljRpWzTBrxYjbFGuTjz2BwLMs7EQ';
    b +=
        'VxSOBYyKe5Gz9cR9nskw4jq46Qz7LPjBZQS9MJbAZzKN1kikSjOhY5NSS9QeccRugtVOMuszAYE';
    b +=
        'fwETxsYHoCSMSgwqTJT0dzXvl+n+aBXDSJD7zT8eBKejELUQkonUM/YCw2yP7M4wGYmGWemK+NM';
    b +=
        '+xKTzMoiCpoQnZyJ/ySaB/seFaTPJ2QeGU+C0pJAq4gyUAxRb1+H+kH8Le5facWTUg37+VBKKCb';
    b +=
        '+dSKEziGzQgTsGGmKgMdKUliGHozXpsfIS8rD8ForMbzEkG9Yy/yaOxt5aQqAR8MUpQJwmOayhZ';
    b +=
        '/tM2wiYLcjpmZZbr1j1EI8ixDFywg7BP93lQlw345RZf9oSCNRjBMbcbeTpavriKdkiyfGA63jC';
    b +=
        'HAPKL4GkM0d6m65gWVzKqJmkpNMPpsRdxc8vBuFtUgDJknhBYrXwCnewDDeoan2fyGumzUNRQ06';
    b +=
        'x8TySywNzmRAJoMNWzn4RBIsGIT2WmmgwXZAVuM6gg4WE5GQqYAsFVwY+l3YRDKmEQqLKzjXOat';
    b +=
        'dYHxh7xI/SToVEeQqhyA51ty4yo1bRfWnwYbsWEX6zAK4JX6Bjb4Mbr3hUx4TFzdMLEmxq4Zi0g';
    b +=
        '3iVQ13+afr2INPrPCHPpVMulmE61RwlmKh+4sicYpgLKBn22XYeonRTstVMsSqEskQG8AQG5Ihn';
    b +=
        's/CwK3S+VoGZXzZIBj7dgBJcyL9duIGeQKnY1gAlScTdKe96Xc6hFXsiZ7EGNFA5kkDW9Lh9NsG';
    b +=
        '7f1QiiiAyFvIA4fsfuIWkNd3Arj+Ovmj0LtB5sdNxwPoiT7L/OJNFhXl39AwIwZuiHA935iI82+';
    b +=
        'y7/VW3o7pxJK+zYhxeNMctIJ+CGObkQsybprvGXGTQvkx9aU+47pL1oHK9UqZQdxaj7fAMNF/9y';
    b +=
        'lx1w3ZL+l8K528k+O6Pc8KVkIPxSwdaj9HYS3I7hyEiappNjnyq4ZZ5NGsimGjRyIoWPqpuTcm9';
    b +=
        'E++ETSgnKekJ3ZC5MO94eKKA6tjXzSdfkbrixhMYJehx4rI3Y+sV7IiYuckuUiRSF4YjxTpo1K1';
    b +=
        'IiMrjMFsHiV3E/yv/hIZ7BvNNASpOhxPEtooLBStqtM6kK+K82mN84H4HayYQCwYlpDpxKRFChi';
    b +=
        '7Fk42DjYsJsqlQSkdaIAlWYPUFWFC6MhOGOyxzBgL5FKGAl2mYiCrIShSwpIwAFwC3ju4iff8LA';
    b +=
        'OC4OvBe3S0UmOg2GjcoKYkMYpWsg/+QSf4B38VaCWQWDG7xRLJY2/VpSTO0WI/603oExKVBpLRO';
    b +=
        'hAclk/Buf8a0QPGMuUjPc2age+9vhOEdKDThuIuqdOG7DRQpl6FGJZWdRpSCZ2WFrvUaYOB7H2d';
    b +=
        '5ndUpwk+y5elJaa8TidUotrg7zRbToFZtjgPnjWzDD5xHSP2bfCb///jY/+qewhN1Ot0wWcUMaV';
    b +=
        'tC/pY/oZjin/jRYI52+co3AqnHE9RCS7BWCCWPw1nlx98QiPQL4S6uI2Zr9kQn0Bmj2tF/tLiui';
    b +=
        '8pmhqmZAgja8AvC8MtkpwsLGsq0gjjwkAcNB9Oy27dY+VwspN836RDz6QI8SYAX9oorpJKfDRzc';
    b +=
        '8iO3D4LSfVUdhUxKDQaRpTCW2kSX1eM1f0EU4RiQzSlcrMrAQ7UkJaRYiNux24pkBF3v3SiDCF+';
    b +=
        '1dJG8BhkjP4KzWP7LYMhyAHWQ4FuUPhXIL+JbOBAUKL/X+qKyjaCWMhRtK9gMKhBFALZRY0ruXh';
    b +=
        'ZiNyus/Yp6pIzORA+RC5Y+exkQLhxEpdYg08ryOMTdAQkixCSM4gvQuW01SNYJeG9b3+VA8UlMS';
    b +=
        'K4DHPsWrWAzxgm/xc3NV+BLcEAbpGISRya8DOl94x9pCsodR88/jUUsjzLooDlIbT1l6HBwIkpJ';
    b +=
        'P3eNBkkDLV19r0W+b+1i1vEroUrMAMMDvFrqEsD+90wfXALp5AMb0/AeQjUN5Uc6Ou5f2SYCbk5';
    b +=
        'jBcCLl8MQp2LDM+ZQ7mkSTcP5p726EDVzPQsYs1HiVFU0xdiHR9RFw8LAqAmHnZXGbCpRZSfaDG';
    b +=
        'Gqa8fiIGJHzIQxa/3ko2fX/Ltpvfrb2dkzDDEM5z7uPhIx5tkSoGvoAj9dqRnKALM0rgseEd9MT';
    b +=
        'yWqT1jIaxAyG3JnRD08nUG44M2vovukLRFIMBx5EbHyOiGyPuSi5TR+2If6EaIzFA4EoJOAIlZp';
    b +=
        'LYmeEJjBU1cOSQoJAFxFYqbIk4YvYbBPXGOYBWjDfHkHl6stSQAJp114TIFbGiXN+vLYtPqfIB5';
    b +=
        'UktFaifgw3hUUWMW45MVSOPdFHYyAZXLcuRONy9nTmwbT2YHCVcKTYyGfYAMilHQWcUOAZJrxao';
    b +=
        '1KeA6rGzQl+Ev0JOZUx2zL6H/mwhIL0V9MqaBhQpnEMhYbMdtxyhGaDrIGhCnDJaKfZPuheVCPZ';
    b +=
        'DhQRfDHsdMf0hGwVLeLRaJlUIkCDBljGqcysrDifE0XBkgGRFu8+EXsbIdtEWPun0ofvJijP9Mw';
    b +=
        'd+R9xWPQD8jhnTxoy5FlyA4ELFCB1HkU2ASED81jWBIbSjo71hP/SnIHSOkbiQfbpJ+aY14anCV';
    b +=
        'DwlGO0JqfzC4CHGYAFTVRAjEAuChxAMuNysSwzIBDlkkwSAbWmIJRoI2L/tBcVi96u1Z/JlJRSo';
    b +=
        '+cqV7RLkbmkaooRadVhj5XEwo25vZLLcNpVL0QNhRRXsAqxO5lRBMmRCBbVqE6/k2cLjgh3SeeF';
    b +=
        'IxDVGBG0X3VnkpCjgJ5fywntgUhvXEkOFrDKmMfVcP4AqhcCxhUzN48eQ4DDTVYOJV7M2jvdgzO';
    b +=
        'amaD9wKAxTGmyhEnP72bUZcZ0uAuE60AMl/86XsjguidxXqW24C6lvg+EXK5U1QOdhLLEVXfKor';
    b +=
        'PsqD6nOXXI5s8WJT2cVCzN/+FHGHvAEFL7IdckXJlXAnOF2edxgbCdkbDOq0BsBFxCSDWBtaYpN';
    b +=
        'HYRoVlUlFbYCiUklQ8xAVRQ9ehgd0KrpbAnWoZtwJWVIoC79LMhl7M8EjMav0ja6MTZvxQLRnW4';
    b +=
        '2QV5t0OQzDhZB3lLOhYeq/07MP3SLYSxEJ1fcTAkOZPjdErBMzeFCmdHOdEQioxKeL6nPIRzax/';
    b +=
        '3EYgIgcRA5CKi6KPs9Q1ocGxd0NU9xdU2GIghg9wuFVpDtRmMFuUP6u2RsNwtJm8yECsyXLVnSR';
    b +=
        'AsmtmarZ60NKCiKWrdFTwp/CLowwS1JcL2YroR1HFKpAOHCC/r4+bv8DfXxhP/v4/AHqozhBwQg';
    b +=
        'O55TnKIv+EcAGqTvoBgHMUKIzbTwk4YVhqaP7HXFH+JLkTqDIeIR/04XiGhYQMAP/sohhoWiL/I';
    b +=
        'tL44J+VxmxNwNEPnu+wX4+DTxC3flzxeJ+2CT1EKL5R4E2Qvtoii9uuks4D3kauFoWbz5higUWU';
    b +=
        'TwRerVbYBaKTJATHkKWcOzVDlowCEkZT2J/LkFWUbQ0nWyCoHik6sWr7rq5kpA3pFgcqNK/y9v7';
    b +=
        '6Ni8a0W+R/fescWc53+2Y2uvbbJjy+Xt9z3KjmlXjV2uWCKJ0tQwHtgS2SNs17GMhLyIQ+6uRYT';
    b +=
        'tYRHLwpgdddJrG7LMY/gMPQifYSKK/2IPOMMi62ANeSPG6gJiVpwrOtQb84HMIUHQhOO5ihSNZN';
    b +=
        '0rXheZ8wS4O0PCsHpvZ9JqVOk0WosqneJ3a3c5HAdpcElq0aQ0Iz1BmkFaPE1p8UyVkBIMtsoji';
    b +=
        'g7smFjvCV+ZDsPYi3zq5zRDkBPdhtFxBD1uUADGAD0esr8yAvFaDCScxNDMNzz3cL61mIltm4jt';
    b +=
        'NNTxh4jYNhOJbcwh3kQZgP0PK2Cm1QTtjVTaUz4qTVkWgur3aW6Xgb9lMN40NBukjubshR7Mwdm';
    b +=
        'eU05E4RIdr2xRpV50El90Ai/a/KKNvheG/Y7FSOfQNEhZTIq94JFiTX8Uj0MKIVwzfRHEeAZfeR';
    b +=
        '8vZDAvFGCEQHrJd9PR1kD/E5mh/73OLD7wnVnndcZkRxEDvQcH8C6AbDL0Bb34HUP0RSxOWKBgC';
    b +=
        'W1whHTZF5NQlcleXfXFpL6g2Qhx4Y/oTFPIQO1Ih7OeHTwpUPvImx5tRhzA09u+Wsbs7wzsgenf';
    b +=
        'xJBJEp+iqR6YDATRdA9MIr8tpuBVD1BYbBKCKPTAUD0wuAeGvweGrwfMHfh7QCgj/h68oHtA1Ur';
    b +=
        'q3ZMMMQo9vYcMsONufx3dUR0ZmKbanmsS2+TDQHH8GCisxaWqkSwCR1f0YignMNVnRMZ2GF4Ilb';
    b +=
        'qL32WlLtYoAVwdBeAalQCuoEXdDrXvYBzHf+nKJE6xIu7Z5e45bBCKpydpzOGcak9HGtlG4LnhA';
    b +=
        'grsTwZ8d1am46Rl9Nkcifgg7esNcgE1gKH2+2Mqw3qp9PexLIpJYSZTVHo3wFEd4W66UQbKYi7j';
    b +=
        'OY/x95hI+3LmAVMkfyVtaKAz9nM0/SmsQRSPa91vKKOz6agSxsvPAvY27dCtA4WdOOySJbZf0Nl';
    b +=
        '6BUGaPK3/5gcTtP4vPejT+jc8zFr/VTpH/NpfgANy+ZdhjhtBGlgAUmCUS7y4/oRAqE91Z180J1';
    b +=
        'qJhhghGY7GjzJgIcpAk/ACjevSYk+K6TQLjnh0iheE/ZO/3rUb7qDVudmDNoWib59aPdvCu9ZMB';
    b +=
        'wAS8RnOm6INT757SQifRX3Povjshmc33EvvpfieAWC0uCWYcHnT6EFehSIBT9LwTprvTjreSSeF';
    b +=
        'aSbeXiY+YKboQGPLEfTmwmmAcQ0NhVqEMbgCcwW0HvBRlrlGX2liZiYgh2sSS99ehkCixRDjnOa';
    b +=
        'fIqi4eEInkZg6tJJlDqxLluPJFjbw7pSjtDOo8cDtTEFQuxFSsGQygpNJk9F05/6HJqPpPos7DA';
    b +=
        'HZ0WlgwgRH7c2DrB9GE6ZnmUTNZMhps8igsja/K8t6jsvSsIRgkdlekTKKA21LkpPWUYJp+BCBk';
    b +=
        'fyidIicQNPd7eCjHcFmKPhdPOMoyKOGkMGU9SPIGm4iK1RDcStbSrf7luXkZG8iIC+smQ8Q55dg';
    b +=
        'dKG0DyFN9mayKJSBoUON1JOu1lUInmYt+3S1K1n7sOzTG1v2NbFhNWvZZzW27PMb3pk+w7vVOhq';
    b +=
        'y+rU/DsaXVcBP5EWMW6LO9n8K68+SWIGqwjBZWrXnTRRuwMSASeiL+yTWxAiEmHKshKBHOmvppO';
    b +=
        'RfhQdP0OXc451qoMmRIdmsQKReiulGRCDvb0RQEXwJeMykIJ6IUd5eTKCe/cEJEkCeyD+XcgFKK';
    b +=
        '+UyMdeT9QMxxJqCDrnRRLk0xeWy0MzNKPfJU14LiD2bc7GSrlEgAYcojfUsTycnUZSpw31Y5eKn';
    b +=
        'lKyDj7AYt4dWs+8Gv8IAzITEQ0IlilPKcHeIuiNJHi22d6O1hu99x9cd3/PxtboJSZhjDmVJfSC';
    b +=
        'mtcWaURkvx5TwMggpBOh+waDarMxSajf5o8HTbJFvN0aUtSQ+TGPdGCKFJujAHtMVrLUkhzi2D2';
    b +=
        'qHmGAntZeuvHXobASNDtBIV1rxSKoOAjdd0PZmDMV++NC+0fIZgkaUIWimMgRd+x7bfcoNeflWu';
    b +=
        'YmCTeBW5bgnmQMfgR27DYgfai/ZeEK8aMTSCQXGlgBbAFpHweTEo/6w5U4UTLUg3A6YagFYYhMQ';
    b +=
        'Oi39yapAajg45nn4PAzACJ/hpkQdhr3HUooMw6+DIEOHHBk3MwcWcF8ZeVJsQkvpzAO2Fa9cjkN';
    b +=
        'np/24wYoPeHaXxdJ3ym3zNYevEtP8jkTWHeEP5Yqx2CTSFTtVlb1Fl3x33Nwr5w0U+4nMEUKNv5';
    b +=
        'A0omken6QApPNhIElpYPujdH6/DzaMBL0ASph1pE60/sSVRfuQlFnMBXAmSAWxrokwglKwTPimK';
    b +=
        'VZMYm+RtJjEzzpQLywvFl9pGbCkjYTGVkBorMcCcLto3f6P36HpUFoOQ9PpLIU8IdJ3GDHaQaSi';
    b +=
        'wedS0SgcnE+D0az2ItZYU3G9HoC9OTBINohnK4Fl2G1egcXsDWTGhyRz3X42rOB/uF23+yyCCJj';
    b +=
        'JKWcJoaA75C+kbTgBlyjy/uKuY19lxaUkVBCE7pIG9hHOLnc3we85s6WPMCEq0VsyGizmW6iCwV';
    b +=
        'IgSvcO9pjT2WznxsYzUUd9PxOJOqv14wTxgTHX4yFUYoOsB3X9lvLnIRcJsdV9yKywISOXWfZHL';
    b +=
        'PcFKh9VPOT0gLIDFdlHbtw44xbxxuOdOqZf6GQy0KZmP2YAMRtFEsSkeGUmhfyisiCErEE2JOIx';
    b +=
        'BiRh806/IhpF6m5y4mtkYJWSpUA6BeG6WBGAts/8R/PFVTEQBdD0oQCazaMAKjtlhQJoBFEAjQQ';
    b +=
        'UQKMRCqDpQwG8zuN19oPbB17/Z2PvJDOTyvcGmPf2Ccx7NlE/mYp5Jztpd81DfDzf1Fio4p9ryj';
    b +=
        'ySDUm8+WbZHxtEZACEjZEqjV/EGHyiJpoZs58L8XQy8dmn/hmn4S0UZzU52a5v9pP+L3/NKxTrb';
    b +=
        'TfHejNtYFFIBYbdWRY3iULS+6aysGuXGKMFITyRJGetexYJ8FIPlJZBQT2QjMWXpI0nyP9i8w5c';
    b +=
        'c/4jmnPmb2zNf4KtWRqYUhLcxQNIkqLTFuLQpHisSKpnafKYxjAjvG4tknURzhN5EjE2kunO/WE';
    b +=
        'dnMo3EDlwk6CVCSJbC+Ta+X0TueZ5lAlgRutT46b7Xw0MIQ1UoAHxTlQKAiu5r1y0jqEBpc+cuA';
    b +=
        '9ggyaDDepTE7IRUjkGrHAsIgsRDgIi71jMX8ETID1mYWMYSYkpBJOCDxsI6kQ2aTqC7Tpk3mb2R';
    b +=
        'HUmQlmYZNWmk6QYSAia9EAfM5aHhOaFGM0Ax6tz/AjR8thfWRLpW2Qu7jQSAcadJ6NbktIK917s';
    b +=
        'IfANJm8anqdXyFvDLcEGCohqlKO6yX3j4Qzsik+GSpGeQkB0X9bIcMiBw+RF3UdO32BI2aXNodd';
    b +=
        'zCCTZi76+wJB4+B20HAZ8BTI9B8TeKFnebUi8HIq+7nDUdRk/dY6uR+qlYjPLINcHUzo2amRIqr';
    b +=
        'FzGjzTFeSElB9bCIeF8dqBs4ljnHExOPYeFssRODMFURY8FmDuR7M0sjfEfTB2MVgwsNaHzXYZq';
    b +=
        'oN0OiBWNcklELY7Nr+gCE5iEqApmHt+edxw2wxKRQVDrXsNB+pwJM6qZDsxcJLOHrOgYy13IjBl';
    b +=
        'G3SenlLjIYclHqpwzCEoiggpa0K0YMPAnSlE/UicKdHEwZ6XDeoWKQanRUJ1pFIwhDkwaKAu0Lg';
    b +=
        'csT4sz0aQTe0AeBOYNsGqPqGTsITiZMejPpHGkRSoHGEryTQEeFkwAIwCTRFiu03Nj1OpgRIYJT';
    b +=
        'cc2/2CxnOSrEgcT7blsLgr3buVHRR/wV4cZUN1mG4368ww2leabCMvKMUJ4PtpKEuzOQnHMx1ta';
    b +=
        'C2toURQcxdLRyjY+sRYRpFOjqL3FMogXRTw+aghNpxeYATy0cvyVpZ34lliAGQjSE0sRVQWiahQ';
    b +=
        'lR1ScqmAZIplTiGWTLHMCW2JUNXMMiddyZxCLHNil6UZICeA/fs50vGJP9R5IqitjKUXjaNWgyB';
    b +=
        'qSOmGc4mCWiGZAfnJEdZg4z/6JfFxySib1wFIYmIX+v1kPAcpNiDKLA+aD6WVBw0iUso9gZ8oWs';
    b +=
        'n82B4EIY9Beis5CNNtWY5xl8SHAfZhpvSwZhtDYDRlPAK/HXI85NlBxsMk0g8vAy2PfZfBdoTkn';
    b +=
        'LDFYFhsyy+4QIdSMrW71JCWDrN9uzCuOAcphpAESPHZ0Iqa2rM0PQRRFiiIawgE65niznKMHQcA';
    b +=
        'fxAXIRejvuWgYjCEiw+cM/2R4CDUG9KlfwmOPpOluscCgWFlkMcB7V4CjwO3EngcnUMo7oXH+Z1';
    b +=
        '1b29c9xe/ue5LYMET2JXOeoM+UgGWZYBZClUrLUx1pTAATDj3W2KB9YDCQEHGSQ1AwmM2dAGBHx';
    b +=
        'IyWr/Y+X4OVBoUkQzUXbhKEAMrTebA2LgoHuLIqfkSJBPpAbms0Y6H4NAMUkCyfJMSUdn9mX7uU';
    b +=
        'gZeERPYdonWt0mzJ361EqeG+/NsgGsFKzdYRfMukrw3h0nJLPcFlTDSyFgPkCHs06VhsEk4ODjt';
    b +=
        'pzf+7ui4L/4Z4H3oJiJIaBw+QsWZaCLckATrXyKGn2xa3jUTJpzjk+VZAQlWlIZUgQ1YElPMUgJ';
    b +=
        'ZsP1xd11NkgSLZLKWe8dClMmioYc4MHdds472b3eXeGDvFGNVrfjSMG1zYqq/tlaMZo69FUNxsl';
    b +=
        'GQNEWzW8XAqJ70y+GAcDAM1oloEB6mh+KU+xrOtjCarMNrqPK42Ed8axxHBrkBdjGVgyxWy+XIE';
    b +=
        'OiKn0M9jiHfwdysG1DpOBUBjNzl+PE0j5WDRBolJiljLlNur0oJ1NRXDip9FupyjtkBrZGpdlSS';
    b +=
        '40ktz2/o8qI/1OVFe+nyTDpLNQDkMgiQyxCni/23EPBeHBE139gC+Fmw1W97xCWDS4igDIBd9FK';
    b +=
        'WKQG7LAnYhV4RohxEmQD9UXk5il3FiQYHQsOjbqzGbxDIUYXgpampCseSiFrAr/OrcQBsPaDGWX';
    b +=
        'Pdej6HCGHEPkmZFdpTA+iN9aYuDlF9ZmBRe6jVHIxdO95EUwrXRPGjE+pmEgAsiBPQSoruA6YBS';
    b +=
        'pHlfcO7L6W09+tZcit3tFiZ335I9dKkXjI8is1UWUBTGm1O7BOl8cVeZ+myp3qsMlEqB4/6KcAR';
    b +=
        'IEs1D24M65JpWRGnRUWa3K7sq6TPZvIJtK3iPlmu9kkiDgwiDnTap+Awt2+3YCal0y5r0/5vKSu';
    b +=
        'lKNHY7AYFToeuAUa9DIOJ1AXtjFV+p10pjLIvCZFAXky+S5VhDwC3IFvD/AuetpdYMhYIBP7yGM';
    b +=
        'RbdGWbCyb18mAuS+iZRT3DJnO/skwCI8EmW/4+BnZo2cEobvvgZRjsWIXYD1zCyMTJTAwPMY9F2';
    b +=
        'mnQj2VkAeMD5TLs+QzKxRGx6DBlpCPpUA+QF1FRijNXnPyCoI1N9BviSa/IzyUbr5wj2Y6jibPL';
    b +=
        'lr6Suv2SQSCc6OiJmEI+rd6fURHxogkVVQeFqazWcXjHyFQRxdsrOzWy9DDcu29ezzrgDWSXpoz';
    b +=
        'PZERxjMslDaTcNSI/EqS/v8rtv7HKXX+8ys2Lf1uVc2WVkxMscvSAKE3ZzXhVKhOahuvXs/Z3Q1';
    b +=
        'PmONl4gyK2E4mE9Y0LOFIl7JC6t0M23hw1/+ao8eaoe5ujz4cpWImmKtEo7JasZH93YK3JHfh3j';
    b +=
        'JxJI7fplt8zcjP2QlCI3Padf4iMuGIvZMREddao7d+i7Z/Dd9tEF/HAhXgsTW8sQwjARWMZcu94';
    b +=
        'eB2Z8slfwKPaZ2sHvKK1j8mK+JesqEpVRPKd/3xKFkZqrf2mCQKyU3ftx+so9pT8BQv7R0Fznw1';
    b +=
        '7f5DJufvbdUGRdaPqzMbVmb7qxByCSmCWyF84TxrXlTAtqSKjcUVNAZJiRfMWreeK+JfIv7BhPf';
    b +=
        'arJKFf6SSwDQKdpvurClQN9ZCrNEqGZom/V4kwljiqYucv/ROOGGX/rWqphRDkmlQcSWwYNkoEA';
    b +=
        '4aGKFEcBPUFFEcmXdIhtHlURYpI8c53EAC1jEnArTu+kYBbWBQQHyXBWchm4tZv3p9w1v34Ic+6';
    b +=
        '4C51QOvY+j9Qx8am6/hf+UCT/OcxeaS/tMolEVumP8AoHMELv1uXcASLS/uEk7i9ssR2134nDab';
    b +=
        'YoPGADuO6m9Y3NYzn+k1XifgkYnkBngMpNHw6B3Yl2Q1YV8yEVZUq49j3YdV1fblUJZA16Z9dfK';
    b +=
        'liKXWfaya6cpqeUYf0CmNoGY0QZKSk1ghgG/uxj9kt7H+oFiAfiCsmdTvoEyn4Bum1MtiHBKwj7';
    b +=
        'b+bCkYt6v54HwQjc5c/KObPvSCHegAthUz0maZNTzVDbYex8xJn1++eWq990OQKPXAVNLPNHLgK';
    b +=
        'fvyzK2hm9Y3zSDhS8aUqD0dcE+SF4uhVpPVz9MoKV+tXrmBlPWZTGrGJ7Wv+arTB27mKt68GXUu';
    b +=
        'M2NVB01pEOGIXGiptv1q8Y8tIU1sCqU2B1GOQaiVTK672R6+6CVKtVayuqzmSltgFQvUKEAHJzD';
    b +=
        '6e/NogEGYUIZMRB8HwULyMEDO4oPm2fwFtIapaSdoCJHE0FjsnQU9DjP9LOsC4+rVeAE4o9V06g';
    b +=
        'TLYz8tcAdWX7hl7xEYFJoHymPqtHAN+/MuM4PRKCHNLk8D0OYwhNQs+owZHoybqBgh2+zbEipIa';
    b +=
        'd8LnZeEKoyGVBAzLKainO+dvEjaRHfPR5dfuQ4a2HbQoacuVfAba4X+L1LUqeOTIgJ5ACUZ8jkr';
    b +=
        'yC0TjbEdPzkgWSZSlLgD1tfY3Eq8tVqwsEjicSBRJtfkP06GqIV6yrIDuagTgn8IQuQYxPSnl9h';
    b +=
        'UGAQTiT3V47PfwX2L+vuEf1RgjRLOX87ekvdtT6DWFjEIeMzBiQKn6Zk6TJX/+f3bJ5zSnTWVtq';
    b +=
        'Qd1tVdt6S1zPG3ppjlKWzoygYGjtWnfo/ssRRLlf5p84gfaMljzz4pQmN7y1KQJYBHUABg5YLAZ';
    b +=
        'NGdF86mQMiDggGQUeYewdHDD0mBpoMHP2QlYhMjFPGZIo+MoHQQOOh8mu3hJylDw5VY5h0VKdFP';
    b +=
        'HeTc6MXCANBzRWY9F6G1sBPA5l0nhd70w2BL7DfEOPIS1s0TDZSQvMjCT1iIUwUvnwFI2bsLrLQ';
    b +=
        'pfXU9bCm3+SMcBX0cmj4gILDLGRgTitxj2klDcJCbctA+Bnyn4sw0tMbGY51gKE8JewaoAvGfxl';
    b +=
        'XeoAMMoJuZlIYnOZZCejTcLKOcWQ7kAkyEZcr3I8BKvu/MRca5+J6bcsCY1lfbfDcdkR2SjGb/Q';
    b +=
        'OJ/ZBmhiMxCQkGbbGUF0Vg8TlVFRycaWcVGbwFo1mHJAu1hd2sWOSBSho/USuWLqap/T/GtZ87z';
    b +=
        '4wN5Wd5Tsx4OWPIOMgtgKpelwjYYM12g0Fa4RSpexGtHmw1UL2faQMXBV2Ul0ON9nSjj0qKKVYA';
    b +=
        '0QtMUtIXZo85FGfJ54g2CpcsVkImd2Wawli1UedhYXa/LmrrT1bJ0yCFxI2SzPWIFhkiyzXhqdL';
    b +=
        'ENPE/AndcxZjjUzbvVAmyayxKM4SWBISf4mw7wBPVCj+ScUObTxTgtRip9JsMkDc3xQRruab9Pt';
    b +=
        'wtCk9qemdzCcHjAWNZsF2SMd+ycmu9OpHVuuML8+fTBs23DrOVN6PHmmQiaaCoEXSAiBElmhjlZ';
    b +=
        '4gNAYh3jTJOQlAnNwQrhVJJtkBHJTOl2hgsf+J8dh0AlbLBqAEsO2DcSIJVmmMpcyiSKHXiP0dD';
    b +=
        '8UWCCuTCAWRp9UeZaEKmBCmqJhepP4OPZSXeKnpcTZEwx3YMYQiCoMAakCA3uUAWh4IocJqtRxp';
    b +=
        'AxT2oDjNk7ABHqsJRuwRMk61WCTTmjiKY0+KcI/PaHEc0jlp9By4kiPxPyTRaBj+CxC/qxmeXvL';
    b +=
        'wVm63F2kTQs5F4J3az+mC4DfyJCArKJZp3oWUirAt00BvqMyCHfUD6gA9+wdOgAqoEjzOPy+0p9';
    b +=
        'rBLrQN2G4niCsV6wi0qp9pD0l0aZSUh+VYvvYcDyuJcJxwwaA6kazZlB9AEXiDyCJgTMx9CgECW';
    b +=
        '0Zo0wGkuw+eyHfOMppx67lCbQgLECJZmr6KSzlNt7utxV28YEsbOWBLOyBfReG4h10DfcJd2S4Q';
    b +=
        'pL4SLA8zAEfAoynke/BdAxgssUnwi1EknUGsy1DyNxS4qnj5AbiDf1GfRa9FunGxVcdAHTdAKbn';
    b +=
        'RCv95FvK/pNv6TzVBjRlPIUbf3QwoTGAHyTZQF2ts4mcvGWIW8qprX+jgSeJYQITIt5eYNHhpUI';
    b +=
        'KbNT96NeuQrGm+NfWYJSniA3U/oZDu4if35L7CXCu7FWOJzrS6Xvp1JDETi1p3KklXqcGq06hKN';
    b +=
        'S1KNSMQZB+yg3GICmy7uGT6NKWTgeKkplXN4H4JIg9+2hJZ2aW+85HI62Az337baXh+L0lvKNKG';
    b +=
        'Mx7C+4s4oSpEXMjdbBPhAVeQoY7dz5FLcIP89JVnEik02J9g6j02Jh7yPObiALkum+VfnSNjn8e';
    b +=
        '5iKNEJMGKN9PT0aWgkbnFZL3Mdn0UCyye0CEeqRjocDsABQxwLMapcEgqpUB1JZZTKmL33db7Al';
    b +=
        'FwI5GglWoPGbUtPGF8BXvPBNy5zxKYW0pSuljIrH4MWkFCVntzCxNgjv8voY932TDDlxJ/RNmYp';
    b +=
        'ryMCfLL5s8zBkYJJOUl6gbFycq83GoOBmQQJqmKZUMRXly5yxaz/rcnwlElUoiPzvCWNWxpP5Bw';
    b +=
        'kqM3857UQq62KSXQMEzB764hayoO/c+Rl+V6Kk83j1+9w6E208/XGLIey1T0Jhpcq8wyQDbJONs';
    b +=
        'k7g2Q8o8fRR0rGeCEpgxswwC1EKTXWXNSCFmTLbY5LV+MhNhUTe7sglPF0LGtOcY5Lygu2cSh5N';
    b +=
        'dTu4ssZN/w5riBUWB1OWaDLBvEmdP491YMHIXmdIZAfHL/HQ3s2r7LOLifRbhJkTOaFohL82Bv4';
    b +=
        'VC3zUDjMlAGEedPYpYY4lL486QxuFVRLHiA+8y4gH8NTFODz3sjzeGjZGBG/fHRkwP2IgBY9PDf';
    b +=
        'yRhMJj5hiQrtD4KbU4RmSAwX2/F/GfQH22AnoB84vLWLz77kwwWC7MxpD4HDknoQDWgH38Oixy8';
    b +=
        'kCvD4ecgcFFfEDgPeFF8i22B2G+xkw29Xp9J0PNgpg8mpZpEzbGJUtLJyZ/kZHZnhJ0wkS8qiJ3';
    b +=
        'g/xIUxJqwj1AWr3vmTXAC7zaylBRbEIN99nVCyMDneEIkBD5XB8OJiccvEDF+htv0S0kTDt1uoI';
    b +=
        'wXe960nmhVxfp0NINpaJg5FeFV40YGOQLgW7UOJDWcAU1/wgWJn7CJ6KOxAtyWcOMUlAaYkErFA';
    b +=
        'xVJSiQpxiDHSHivexMLWaIwm3IPMIN7APe1mVf1/Xg1+JUJn4UYAoyqwDBOmv2g5RPi8VdutsXP';
    b +=
        '//4W7/vV5j/Pwv35PCc0IeUm87J9i0ma7fALv7/D+37V9RssiO3uxpD7EOAE/RXBIu0bQvZcjrV';
    b +=
        'KIT81366g2zeLrSIftoJZACqXPStuLssyXHLkAbC3ZQCQ9BwQQXoiEVRAI80oQyiWM9CF4GuiDZ';
    b +=
        'QjDW/FkkH5I+81EtE06bOCTnqGt9QDMpQOEKBI/GM/im7TuNS+MgM47P6vQmhifMhoNJVgN1xqo';
    b +=
        'timOVsFj3zR2H5Txr3ZtZt8AzTyDdDc5XukghAwiPawSc3JCZShjvHi4AOkeaD4r6EBa4ryOCCc';
    b +=
        'KPtL8X4XYn5xqlfjDMd/U/BfG/9Nw3/T8d/M6j6xApwHibNfzN83EIo46tsoHdMnKMj3JDYc9Y3';
    b +=
        'MmFIFOx5C13M4q/qgrIZkXXhCNVvdE3uvLq+JJdpYg01rfr3+BxvZCdXz7sxBpP4HmAmSkLsXDg';
    b +=
        'Dh3zIG9wKJ5MIQbJhiJSEOge5RwVoCFYx2W2Dpohd4OAVQF/KOEE7UJELVwVB+Yj7WokwQPeeqW';
    b +=
        'T9nxPIITobsw3Qu0YdKLWdcQO0Z65LIKJCWCvVGPy6QViXT/SxBByaFWX4gKJ2vJflvKlgAU67T';
    b +=
        '35Y7V1OkuRjyJy1CibPXWfyN/mXx11jLkFj2Y7qYAkAEgQ4D9iozgPbRV25YiQoQfIspFZ96UYV';
    b +=
        'RRMUhng7SGwNjLv+uBuYHKRwHwxRKcIE5bwiCpoCIm7s3i99z32TiJqcJ6TjCBUh9hCg9xy8u+l';
    b +=
        '2N69zUAtryMcTfQG6RI2r4qmnyjU3fBt5YqQcbxr5Sw9h0xt24er1m30+eofYVIfufBFUHxJ+9y';
    b +=
        'zpM/BQzB5eGRnZm8petfkX5F9D9Y2PH+0565OnRhidUixMDh4Wt8iZUxDo1p3a41g/BsFaCgjSf';
    b +=
        '/4595fcgX/BkudaPY79WMVWd0BaUqUB7s58ANP3Un1ToNNueO/3teXLf7bnT354nzQA5jDNJV0i';
    b +=
        'gTQElknUfatdJix7r4J/prAD2I0oqvax9u+nP7e+HfYm/F4+rXjSTe9W++kym9yY5Qhnkd6eTIT';
    b +=
        '4ZO9jfm7TzgP+cA9a18J9VIIkrnxMYH82Z5MwTyyGnZbJtC0Kc0r4RkuikzGd1kJEEnkQoUliaO';
    b +=
        'vZiualWpFqjzedWC9mfu2NzlNQ3vOF6ZBQ0pRPhgTcgzgF8K7PW3XLjOo2PTlw+sw13270c8+G4';
    b +=
        'xlE3lTk+yQtGyPnTESklEhJobAkIaFBEaJMtHM1o0HNh9gAb72MW0TTKlUQ5It8cI0X5glN19Gr';
    b +=
        'XqOaOlcflfbgTOzZhLmrkVGYxVWivVsLofeV8WOU8Tu0yGukZEDYFNrxfTcIrAnGQSMRi2b4NST';
    b +=
        'wbJDlojvyHkhs49vZZuyc0ZxB6k3kYNZDMilv2NzqQNnCuddB2rUJMUpiF4ics34bVbpZB4KTiZ';
    b +=
        '4L4OktjK8MVwM7VLC/SZyJfF9cysBWTY0c1sbbBJolXBbfxGNVtS9rXGLVKLYPWUahtOcqH/6og';
    b +=
        'mjTCTmFbOstfWlTB1uOkYQhMs0IM6Cs6Draf+yf9a9BXxL7ebKJ5mgdPj3OPtEa+zjaii+iAuyt';
    b +=
        '0mBY72qMhyESBvjNu4ODNO4jUXUcnyiZY3CmxRkUf/iU+QbsmNAiX4eKyF+lybeEcMBEEiekpXt';
    b +=
        '4+mWTsSDhG7zQJ1wjCpGs0XsvszUaRRsrk/Spo/2oD1aBGUCUJk/Mnqw/qYvFz436jdPkkd2XCm';
    b +=
        'jX4+5dLKrKQDieDO0KC1QUNgXS3oB72r6j2WhNx+fq09ELy0XLBYH0wqmhIaLmzpnL3aauhiD1y';
    b +=
        '5HWf0KmpGJixeHAhAcQzYloAr8mr6GjJX/iBDDSCBHJCFL9PfMQjEAD+WBOskI2iky+LmzMd8xL';
    b +=
        'xs/4MXLJZgS9DEnwUjttPW/Rd4t56YClJhaMPkZ/QvtoEZ4UmP6/3bdvtrbHY1CTt/9JMyQcs03';
    b +=
        '5Vl/5/6zi12c+S9jHdrhXTrfk5+7ZJ822fE/JwJmiaIQyOYhgqYsPuuA+DHrLR/yJIpYDRv9Pop';
    b +=
        'JBHtjjBFoojoq10AeCHgrN3MbiQZuuxWLz54cDBiGj7k0U2goHL/O2gc+rIQF8WL14PfelEXYGE';
    b +=
        'ZXeKHRZoqCiKacYNeixLU6Is0uA00tI09/IzIAFspv06meN477rKPHUFwfaJwfOYHE+NZZ8mBm+';
    b +=
        'lEWvbzNjrNPCJk0gfzKUvMvf29Ibg04SSbxQlZ/qNg1M95EdgcGIHawp12yTvDvsTPZahOZpfDy';
    b +=
        'e9mux/67FD+A2SbqghzYDGfGYyaRykyvHZ5808IzZRh2NqOcR1dd8SdWW0CgnGqzV4UB0K58i0C';
    b +=
        'vHvEX0zuPZGJ9Rh3sjTAKEg0H5cfLxMxmBad52YOS2CHE3sUE3aXBkJ5lTytS/vh9mX8NrBifPH';
    b +=
        '/kV8BnU3sGYa5/1133n3UcK7ooR0OVE33Udgx6iSFbPwUGRUZNROtnuBCOvc20bzcyN8VCZI/eR';
    b +=
        'oc+1po0ljwCC13UbzpJn7cz9D9oB9Ozd8z85RohPpwWde72xsXblbD1pJvWJq7CBNoqoSlQIbSD';
    b +=
        'rNL/fmOQkOMk1lPohnINLnXbMsMLI7SGIuMY1pzzZjB3sUjqNhhI8O4ukhWpPTuhXVwOvE3mY0l';
    b +=
        '7GpFrVmbA0l3c5ouuH+e8yBNJXvN9TcTNY0OXGI8oOggRZuHYE1Zz8rOLWWGH6xNk5hhqohl+6D';
    b +=
        'e4bMYvduRTxlXLOfDYHZqyn67J/k9n/EPGtFFYpMc0DNc4mBH1+OCXhtqIZhFWAnADt0K1/DxNe';
    b +=
        '/woq1oL3yCcSU7ROz+Yvbfw2JNWK09G5cYdINXGj1NYIZt+db2CeFXSm2R1tLmMlN3siWIA6GnS';
    b +=
        'EaSuBNDRhJQ0f2lcr1aeZsjaBVVDH+ngDYorUfVbdQM6/cvsb0WiKa8ZDlek3jMnMSK/mBhos+c';
    b +=
        '8VhLkyUxrp1GCCwijWmis1ZdYSZiBjTDq4pnvaLparhs7Oxft3xzwUqSiysqa41TaWcqW5oWixF';
    b +=
        'Ts7rQi0xAXopMUZ9/YVuNFWKupjq6/OhCc9aaPI0x7mSTPPU0abGYtwlU8yQFB+xFfPZqVvlMnW';
    b +=
        'YWQ8MZyp5EiCnM9lr7ioz2Ip8TAmehjNCXUeCkfGR2CLd/Xy29MuEMtSEx4RcIph4HBL3U4/djf';
    b +=
        'CWY0+gR6/AS28ZVODGi9aBB4AssMkyAolkWiNfWGqgAZ1S3l9hf6oHS0qi/G01ziF6Odj35gcmd';
    b +=
        'pISlb7fNZgfZsf0qeqnLn+mBH5Ok636zJLV2J97P7d4Pz/1fn5rqp/bdfXzC+/nl97P77zXvvd+';
    b +=
        '7vR+fuX93OH9/JJ+0vnayde5AfgbB2OF4Q3MJO9noZfjPh0GESbEK5b8tRl/aUW6vYaG3r41JP7';
    b +=
        'nIdHsrTAn3NdWrYdH/4VP6K6hxMdmLAIgk1pFLEq7Ckxjdws9/ZA+GBRxGNWl2UsNzAkaDPEqHq';
    b +=
        't8rcCr2HvpOr08FoZsUxIuEc1Opsa528AB658GPNHsdHFByhvehrmCd4/HpPiufI0mXOl+B82m7';
    b +=
        'CViihddvu3ja79Zc9Wba+pjFqjp+B/7cF8yRSt6864nf3j4nWeethPeMcWRD3+W5kbgn6h8zW3q';
    b +=
        'H11U7DY0WFDirjc+mfPze088XRwDmOQD/X/sg1WzGzRDQ2jZ2MOrdF3TNPlniD/Tl7bEX0lxZWX';
    b +=
        'pOOe8YaU1dZW13bvXVZ1fXTwl+9jznMlVTnGVc16f6urznGnFlXWlWojfgb+w+KupLulUUlc9rV';
    b +=
        'NpZWXZlNoySpXWdKopLZnSJS9/TEXnjtU1mjZa7KxHi/yXib9czUvPE3954q+6uGrc5Ene/fvF3';
    b +=
        '1Hib3z15EljxpZNGFNWVbsn+N/uR+/f8tHK/ktOePKVc+e9lO+6xePGnU61VnQ+XXSquLpvcRn0';
    b +=
        'rKzKqSmtHlfqq7ed6HwncS2uFE/qSusqKzUtwqGaYFyi4i/Jl06GvKKUqXWlVSWlOTk5nXO65HT';
    b +=
        'Nyc3Jy8nPKcgpzOnWOadz585dOnftnNs5r3N+54LOhZ27dcnp0rlLly5du+R2yeuS36WgS2GXbl';
    b +=
        '1zunbu2qVr1665XfO65nct6FrYtVtuTm7n3C65XXNzc/Ny83MLcgtzu+Xl5HXO65LXNS83Ly8vP';
    b +=
        '68grzCvW35Ofuf8Lvld83Pz8/Lz8wvyC/O7FeQUdC7oUtC1ILcgryC/oKCgsKBbYU5h58IuhV0L';
    b +=
        'cwvzCvMLCwoLC7t1E03sJqrvJoruJl7rJm5d+Jf23X/L19e0lIS5k+qbDy3EX+VkUd6Y6U53J1m';
    b +=
        'rNGwct2niqqtnM8QzTZub8AzmUWXZWJwrd/CzCeLPhrlRU11aUjZOa+n7HnC/lfhrrXn5+4u/br';
    b +=
        '70APHXUfwNGzMdqhQT38b5K+uU+QZpNBeGjZmB+bKbyXe6+MuCvGeIOVPTqWRidVlNp44lxdUTJ';
    b +=
        'neqLp1QVlNbPaMTdGRCWe3EurEdSyZP6tC5tKQkv0u3buPGdistKezStVNV3aQOYj6L6dwhp2OX';
    b +=
        'jl3wheLKCZOrxUuTamAAhor6x0C/xWI9GOqrrqupLenUNWd818L8nMKCvHyYK8VjCwuLu3Ut6Va';
    b +=
        'YW9IlP69Lt5zirp3zCnPGwjhWF4umlEyuLsXiayrLSko7TZo8DodXWyfKHyyuzxigFQ6mO/jSGx';
    b +=
        'OeQ/p4cRVtL62uKq50SqurJ1d3d0ohLaZQXVV1aXHJxOKxlaVOyeRxpX9onHDBjimvmVzVoXPHn';
    b +=
        'I5du1FPSqupD9MtWxsF4dXCNAdkOjcKkRi8dA+RLhDX+Oja0dWjq0aPHz129OjR8QM6pAeFguPp';
    b +=
        'T3fwpTcmPJfj2QeGsa6qomry+VVjYOAgj29dpfnGHJ+PK60pqYbddnLVwbxXQb5DxN/kmjH4Vdr';
    b +=
        '43k8Xf6eK1zqW1zju0AFOSfWMKbWTO9KW27essvL0GVUlTlmN+IDF08SOCR9Q5qe8juhonfiqwT';
    b +=
        'xQgNhw66pLuzsjpo+cXF1R4ww7tZ8vc9XkWrH5ltWWFVeWXVA6bmTpWH8DJpTWDsM2jIDNpSahd';
    b +=
        'Mjci2qHd4IPh/Ue5p7au7soXEymuhIYCayspm7KlMnVtaXjZIbxdAJMEltb2RTRqNqySaU13Z1e';
    b +=
        'Q88QJdbUlTqVZRWllTOG1Vb2K62i1nR3RpaJ6/k1Ts2MmtrSSc74uiqqAQoTvRV9ppy9Jk+ZUTS';
    b +=
        'jFgosG3K6g2NRVjvDGV9dPKn0fDEe8g3xSaomd3fGlY3DVlaX1tZVi83VmTK5RgzOtFLaXsV4VH';
    b +=
        'MLaieK/taKFVNaK8dRdU07RnzPo3kv7KLRHOvEe1NbTsv/OsNZJ/5yxN/dEVu7KGLj/aHieqT42';
    b +=
        'xm2tVfF32rx99ewrd47U/zOFX+W+CsproIGFJeUlNbUiFYPnyjW+TjnFNjOndNrJ1cXT+AeOOPE';
    b +=
        'AFRNcCZXO8XjxYR1xEyV3+f3Lrma2nG44mqx1k54iNAecGnU1oaI651ikz5MXA/1nQ+QzgDaBme';
    b +=
        'QpmXCWkiyteHnlxZXDKmrHTJefMIJpQOqRLvLxg2omlJXe0pp1YTaiXxnsOhqsXo+rLRk8rTS6h';
    b +=
        'kDxvEN8anFRxxUOoPTQ+vGig3BS59eNqGqWHxkWMpaca2YRVNqHTGTx5VNKxtX6oyd4VxQWj2Z2';
    b +=
        '+t7LvpWUldZXCsm6sRSMU8mFYupKMbxfLFTipGH12vE4E4ej+8X14j9UM3M0nHdnUlihp14kqBT';
    b +=
        'Ksd3rCytyj4Wyi+ZKDYXsZTpM04sFvNNkDJiQcpyIFOyTWfbAT5r2ifTXpdjEj0l03Kv9Kc7+NI';
    b +=
        'bE57LvfIAta+slg+STaL8U0W514eI3vyzz/b2MTrbR/EcPfD1iRt14o6obLGoa7SoY7ZGYynT65';
    b +=
        'huk+mnuC3DYcoVjyubLrbLmlpnbClOO0E8d+nYsWPXfJX/PaaNZfoDXnsyHdaJPtN993aJRKEv/';
    b +=
        'atIH+dL79aDZVwqvne2L30Zf3+Z/qtB61uml4SDfbyD6QKZvi9M9KJMfx6m81Kmv054/m3C+8Ac';
    b +=
        'pPjSLUU6pDX/34KM115M86WvrXmqP4y5Zj85G8q5fvE7dbGE/EBjas/feAKM7fGTLp9H/Mdth8L';
    b +=
        '5nmXfmgNXbf33I+E6+6anFkV970/tU5cO/EvD2gvbwfUv4/vlIT/Tc9ApcG1bdVYFPn9/+UK4Tr';
    b +=
        'j46+eJ3xkXAz7utIFXtIBrz/vLWsN1wII2bcLY3kcy4XpD/9oj8fndNcfD1T3ho9ywr/71J/58C';
    b +=
        'j7ffNBouB66asGkMPcXrv/c+sUifN7j/Afh+vKGx16m99vtxPpe/TgM47kk5/kIXB87/ukojm/l';
    b +=
        'a0lw/XX5nmS4bn2ibwpcv7r0vlQa/5yWcP26+xs2XJ0xS1rD9b/3zk/D57X3HALXo7K/SIfreYP';
    b +=
        'PzYDr9RftaYvPG1514HpDm3ePxPrzjjgGrrH3Fx+Hz08c1RGug+eM7IL1H3RTPlxPLj7mBP/3d2';
    b +=
        '/L7oP1p905EK5d+84Yis973zMCrnXdup2D9Vd3GAfXj8/6WwXVP7wGrp9eNf8vWP9ZvebA9exXp';
    b +=
        'l6Bz1OyYGvSbj55xG1Y/8ZDlsP1qmMmPkz1D306xPMH6y/7eQtcL/5142f4PK3vT3B9YE6mCbSg';
    b +=
        'fV8RXrPal+NVs6/B6/vnPk7Psz7F69fnHmLh86w+eH15ch1e7eHL8Dr7jbfpuWaHMP1WX7zalfV';
    b +=
        '4fXndI3jV3v8Or1+/3jWMz++pwev7JavCVP9PeM16uEcEn5dcitcH2r6EV+3rjChcW31chlc7+V';
    b +=
        'G8uuNSkqj+Yryu//hhvNpHt0qG64JnKvGqvfw8XjuffnwMn4+8Eq+3ffxtjOofnQLX4neexat9R';
    b +=
        'm4qXKfOvQOv2uw2LSxeH/h8R6glXPVZs1tavu+vXzTbxud2uBXmX31FK3o/vTWWN/MuvNqrCg7C';
    b +=
        '+go2HUT1j0vD9gzag1f7h5sPxvYe0fMQav+HeF1w6FVt8Hn4xHTs7+3b0y3eH3A8skcdhs+POzg';
    b +=
        'Dx+ug1zNo/BZl4ni+fF5bfP50+8NxvF/ddTjV//IR+D0uu8fB5wMuzcLvVTwhTt/vlCPxe76W3w';
    b +=
        '6fn3LUUfi9z0g/mr//MZg+KyUbn9emHov5zz7oOJo/hx+P5b3SoT0+n13UAevrProj1f+XThbvb';
    b +=
        '/h80MbO2N6Xvu+Czx84Lhf7s6skD58/tTQf+3vQxwVUf+duOB6LGrrj8y9fPwHHy+58Ej5vdXUP';
    b +=
        'HE/tp5Px+VelLo73l5uLqP5hvfF7jHu5Dz7/dUQ//F6ff9Afn7t1A/F7tmxxCj6fuGIwfv9zTh/';
    b +=
        'C3/80TJc8OAyfL5o0HPM/0HGExfs1lvfWM6Pweeris7G+qhnnUP3njsH2WAOL8fmYk0qwvV0KS/';
    b +=
        'H5gu4TsD9X9i7D5z1GVGB//zF5EtW/YDKOR7dHp+Lz6s9rcLyeaDcNn3cePx3H8z8rL8Dn7+gX4';
    b +=
        'nh3H11v8f6M32PKcXPw+dRbLsXv1S7jr/j8tiWX4/f8qeOV+Lz3s/Pxey8cfw1//+ssPo/w+cxZ';
    b +=
        'N2H+1b1uwefFrW/D8q767HZ8PmrTXVjfyw/fQ/WvWI7tOXb5SnzeddU/sL29Nq7C51M/XIP9eTl';
    b +=
        'lLT6/oMeT2N+LLniK6l//DI5HUut/4vPVkzZZvB/i89P6vIrjOWn9G/j8sv5v43ivevtdqn/6+/';
    b +=
        'g9Vjgf4vM7X/sEv1eLhdvxuT5mB37PhXk78fnWNj/i994V2uVf/5IuiCQTHza0uLqmtKhswoCqW';
    b +=
        'mTvKwQd39bHkx8OZx7xCr0FBVfbRzAAM/aDnpfSuiHI/SdK65zzTp1cVSqldX82LfvjwUTL9mZZ';
    b +=
        'sNaYn2nE78h3JP0r0xckpP/C6V7EtNTUjRW8cYkgSh2QCIueji0tKa6rEUUDf1wJnHK14JmKxSB';
    b +=
        '0lGVcrhGNJtO3J9RxB6cbD3vxmIllHctqxkA3ZiATJd+5O6HM+xLSD7IcVKYfSkj/SyNeVHyN6h';
    b +=
        'kOMJXjKyefL/lmFlOUlRRDc7J8772e0PYvuByZztWDz/MS0r11kinJdJ+E9NCE9Bid6GuZHpuQn';
    b +=
        'inS7X3pCxPSsxLSsxPSFyWkL05Iv62T7LZ0OgxHWa0zpbiqrMR7/rVOPIjueycmeIIjfOm2BslD';
    b +=
        'ZLq7QbIwNQYG8SAyPcgIjsEpCWklj/0Tebahh9I+0j1CdZcUTykuAZmSnCri3lqRp9Uf4IXFFjK';
    b +=
        '5BOudViquU0pLxqCaBZjiMVWlNbWlxLxvFvWcq5E8tfUBq49EA/0Ps7VTgLyOkHzqQPP1dxxGfP';
    b +=
        '3SEH0zbX/2pwM4oKXTa0urWAZybIatDddIDg084BE+ma3Dcru472w4kmV2Ms9RLO9L4TTI/4A3P';
    b +=
        'hZ1Ur3LaqZUFs9wyiZNqSydVFpVi3sHyxjFUSG2RJQIO3VVYjGVloivWznjj/dUTHaxY2EHD8q0';
    b +=
        'UYfyQBLtdcf55HDAsycnn15bXFLRPVn894fWTnlNh5oZNWLddO2Yl9/JrzLCvYPFqiA71eaJNp0';
    b +=
        'BOptDqB3/p8owB7YNyjA7JMgwO/rmRacDsgari88fI6apqH54dZmYH2IV1IivUVUBv4rlUSr3nf';
    b +=
        'TDbZyLm9rSer2X992Sysk1ddWlTlnVtMkVopRqkH3XlE0rrZwBI4djNnkGTL9K6PIMb/XtOJmu7';
    b +=
        'XrSdRRde15F17lP07X8R7w2zOnowvWl1iV4nfPm9Xgt/de/XGL3jSJx/WRa/wK4Ll142CRx7fnh';
    b +=
        '4pyl4jr/8A1r3xDX3KO/q0jppTVsLZjxtNtLW7L5kpG503ppG0+dMGn9fb20kxact+3M93v1nLd';
    b +=
        'qetuVB/ce+tUHb2w7bFDvq18fHH5xR0Pv7we+/5zRYVXvh25+a0av6Z/1XmBktz/ucqdPntnl4Z';
    b +=
        '0rhvcx5uzeNvWtv/aZ3fqITh8fs65P1psf/by1884+n81b0m1Uj2P7tvt7dO5XV4zp26YqtGrVm';
    b +=
        'mv6Lv5n3/h/79rY15y5+bObXtrd96LBz1UXF3Xt919nxos/tZ7YL6NsZK81bW7p98Bthxz36r9f';
    b +=
        '6dd24OKdl10U6X/n6Ke/PrbkpP4fH3pYwc/nVPcvXrJ1w/Tv7uo/Y2P692/8Y0v/Uy58cdSzX7U';
    b +=
        'acMvoXjserug74Nmuw7ffGZ45YPSShx48Zs4DA2o23rak84cfDriq+/PRWedmDLxx3KxnWmScNn';
    b +=
        'Ddr+9Oe6X4koE5F16b1u/RRwf2qHq3svKhHQP//c+0uZe9326Qu+vQ8k8PPWvQPScN/aDz0PmDD';
    b +=
        'hq87awe4zYMGnnezV8PvvCnQZPWWFW3bel0Su9vn9q27dOSUw7++7dtz9226JSMxVPurGv74ikL';
    b +=
        'isdfVlZtDv7up5M/NYcUDq7+8ar/bhhbNbjfL91aPPbr0sGHXrDx5WMff3PwrYu6961dnnrquFu';
    b +=
        '33bfx8qJTT3ru3Tce7Xj+qSndrp1X9vPyU5f1eveH2ZkfnLpg4Wt1S28/ZMiqRwYcdPkppwxpld';
    b +=
        'Zi+xsrZw855IZWyzZlrB5y9p7XX3py6edDbnjykg8e7pM1tL7TMe8cdf0ZQ8f8suO0r3b9bWjGz';
    b +=
        'fnXHPyfdUPH9rZ+vPHg74b+5YzQav3s406bdMbTrd6fft5pG4/LHXHo9QtPuyBv/X3vrf3naZXr';
    b +=
        'z3whdog27LmvOz5xZUbusG73PzqpOl427LlRxya1rLh1WNvNj5R+uvTVYe1OzX7y9sujp68o/ub';
    b +=
        '+eff3OD3lwpFftOlQc/qQ0Ss+OefHZaeXPLh5bN33755++JTnzkl6tPXwo07pturyif2Gd7z1sq';
    b +=
        'X3F104/MKnFx61YsA/ho/e+VNV+paPhtdMXfO3w6/JPOOTvg8e8u07p52xNP28LV8Nu/SM5w+f/';
    b +=
        'up9Hz92xskHHT/uhSlfn9Fic95JuzcdNaL1qRdvOqnn2SNesF+59ejoghG7Fz7bL2fgMyNO6r5m';
    b +=
        '1NrFP48Y3+6gNd/dljOy4Ys2R9c8P27k1k9u/qrlrzeMnPfAU98d2+OlkV+d07XmocHWmRV52vy';
    b +=
        's4m5nPlOk7Sx7ZPKZjx3bUPjBq7efeVzukmff3rj5zDy3//RWv7QYtT67w+efje416uvqH+88Kn';
    b +=
        'f6qBVXTWvZyb1/1KZD7y17/JMPRp28JG3D9qVtzhqy8dDvll0++KwubXN+6n/+RWfNajezIOPgh';
    b +=
        '8+6pcPZobFvbz/rol1n9rowGj/79hM6LVz8txFnz0s+4ZFeHeadff1HG04fuHj92Sc5qz8ZbX5/';
    b +=
        '9uC7/xvPnXP86JwB/752SZfi0TPfcR/rX3/t6LOHtf7ssPeeHz2jZtArU17Qzhk59D/hwbtzz5m';
    b +=
        '07dr+W08qP2fD/ed0WD5+yTl1h60qHNnw2jmtiz8IT1qSdO59Mwe36231PPeNd87rcEao9txNrR';
    b +=
        '+Zfm/4nnPrR358yBn93zt35XVDO+ZdcdCYs9dum3HRlP5jqj8/J/32ebPGHPNg968+bPPgmK/HJ';
    b +=
        'FW89+7HY754+IU+I19ve97OYbdePuLOYec9cMxlHZefeplYHdndR8YfP8+4ftScaXnfnPf0rslH';
    b +=
        'vfbU0cU7f3mh419rRhdPv/Dkx/M2Lih+Y/RV7Xt1f7Y4JffBH17d+EvxZdpLF8w5p/PYe7Q5N3z';
    b +=
        '4UOnY17QP9xwev2nsHOerMad/99LYOz/5rODuLqGSF5d+2GdYffeS9ZesrLjmqiklXSbc1Hf6g3';
    b +=
        'eU7O5ZdOaIrW+V3Drx2B/y2tvjnn3q29peBb3HTX8wZ1hanxnjRmxdO37UdSvH5afkb/3h8f+O6';
    b +=
        '3VVr811K9JL02qGn/rq5lNLtz+3057T7+LST37qfHDpoWtKi6fPOuuJI74sPSl21Y9vvBofn/Lv';
    b +=
        'f6zeNHfk+Ktmj9m2p/yK8T/9/bEv3xv71PjCm8s/u/6X78df2jv04YWPtp/w2sAjV165s3jCX9t';
    b +=
        'uP+sfU6+b8Hm7ZV8f3mLThIPOj458da4+8c2Fz7ePfp43MbX7rwXPl1ZM7N9799hbjrht4lmvP/';
    b +=
        '7LJRNen/jAwBUXTFifXLby1OXLt67p+f9x9x7wcRTXA7B291TdCdU00W1wmd2dbbJsbGMbG9zAN';
    b +=
        'k7AcJ5qHZZ0Qie5YIxlY3ovoffQMS0hhFATOgk1ISEQgoFASEICJBBCAra/N7N70qlLxvy/fJ/8';
    b +=
        'O9/N7s7slDevvzeZo+nrr+/8YVPmH1UvDtpYeUfmt1Ourzl7/juZgUc9N/nuzPbHn7/0xF/vsn7';
    b +=
        'G8bmS702v/GDN8WU3BaPxJz86vuLcU0Pjoz8fP/PTW077+X57LkVHjfj88uXzlj681LHXLDhj6R';
    b +=
        '0laza9ffxjSw/k2eN+aX621Bs/wD/5yQNq1w0878lj7z+29tVnwysfuuCi2mf+88zEv+Bna4MHv';
    b +=
        '7xgH3NT7T65q6qO2sup+2jO5OfvvF3W/emPFz284/yr6xpeGuedd/+rdQOfOOuJ+/YqqT+/cbS7';
    b +=
        'xx3j6q9Y8vXGIw87oX7N2q8u+/Dqm+s3kv+u3iv1+/pRqx/5+JL3hmaXXb30wKpdp2YvOaXkx2X';
    b +=
        '0xOz47fY9Yerqe7Mv7Fj34qVXv59ds+i5lkee3KXh5Wj1KwuGz2045Iyrp3xUub5h/h1P7rD/yJ';
    b +=
        '82/OUSfFU290nDsD8U/Xy/2/Y54ajtJ9ljL/ruCUu/d+Gmhx4474Q/vn7i29h58oS3zt1lxyc2/';
    b +=
        '/uEef+47qrGzaMbX/vikBtKH6eNZ35+yZnP11/WeKf9349WHfZi44D0SblzZ5u5F5cd8wp6z8+t';
    b +=
        'nd+YevTK2twrTc/u/cA7N+RSR66884/f/W3utFsWXrrbJwOatn/uiz+c0DypaecTmxa89Kvmpms';
    b +=
        'vf/Wvaw+9s4ltecK5b+C7TdWP59b8Yc4OzQPumbvxtR8c1ryk7qIB4paW5p+VLZ+9+eX7m//xi+';
    b +=
        '3f22T9tfm3m2fedfLkymXnTLj+u3vMm79s7OznPv5gyZnLHiYnHr/x548v22H1OTce9MZny46+e';
    b +=
        'uzZy14esbzhlK9Gz7fSy/d3Hr16e3rx8ntP/tuTV1Q9t3zRtR/iiTM2L//PE0P3eu7vzooHP5s/';
    b +=
        'sur2JStuRnf86IyLr1mx5LjDGryTfrXC+GLRC5N3LV25zm1a8533qlfa1982duagxpXjn7to3HU';
    b +=
        'X3LJy1onLK57Fb61s2HCW/Pr6YSees3B0y7jyaSdm7woXn3X2qhNF7T4n+cF9J645dNSuqVM/OP';
    b +=
        'G47/17r6l/Gr7q95dVeR+9PHfVr8afaf7JOnXVtHMPOmXjlIdWzQy/um/A0k9XpUtOvPalU/c96';
    b +=
        'YvTd542+dbvnfTf+S8vPbPsgpPCA5985s6Kp0569vPcg0cN+s9JX/7jArlh7tjV4y4b/rOlF7HV';
    b +=
        'FeP3urdk+eWrZ54zctFzl7y0+t5/XxFt2s06+ermojOq3w9Oti4uuuPwP9Sd/N4xEw+bc8eNJ7/';
    b +=
        'Z+Mpuf5z/+skXnJ96f9cDB6156I119UdUTV4z8oJ9fvHBc8vWuE0bqvdctWHN9c99dOpnL7y75l';
    b +=
        'vw21E8oGZ40YihRUcDo3aWEfu15Mv3JPqHfPkxI/ZZyJfvN2J5J19+0Ij9CPPlA8xYTjJ6+Ys56';
    b +=
        '6372/qa/3d/W/r5lxwJVFpWnlyoGDBw0OAh3Vfo7f7/y3/TC+Rk5f932P+QnDzuoPZy8jfXeTQ1';
    b +=
        'jm1Q2ozGevWCyw+KZck/Fsd7q7C8V0H5kw73P0nuH95Bbu+sF9V66EwuzWpIY5pmm+s59GdEvVi';
    b +=
        'erhX1I/Pj25SK9Rz59hugvJOWz7WMCO3VZuoyTZViBROCC9424ZWiniunlBqxolLkQAZVHlGZWi';
    b +=
        'WOq1cSeKYx13YpW1dHarP1orIW0Iu6AiJpY3aJcp/J1Bc0slSsbHVpIJXxirBsPUiotW3tVo5Y1';
    b +=
        'Izgb7T6sqeNrJRqfJXLa2DolQ0EOg4vyNfOxKp7gJWMcsjT7o6VDdlMfVN9cx2FxrLNTWogjcrJ';
    b +=
        'KP9wfCtfirvWOvK43daiVkW0ljJc+VjmS4tXLVYy9uJjFrddGhVfWt350rEFl6oWT50zrdOQ9Lu';
    b +=
        '6uhH3qYs79ZVZejy02VWlWqATlaQJvmFhYGJqm+vqK7UNZMQofbGqclRyuapy5CljhmrbwZnwrf';
    b +=
        'RdF46JfW2vGhP73uZnq2llg67YOhalB4Vn1D76BXwP6PRsfXNtbfvn/wzP7f5N9bdd0zeNOdQeH';
    b +=
        'Dp2aNEx8I4fGrGNJ19+INGb5MuPdrj/jBHr9fLlXyT07v9a31OGYn3PI2Pb63uQ7bjY84MwIpRx';
    b +=
        'IZuTPwoALxubO/3FGs2t+1v0/wE6O7NAL6f805SuWeG6WFUIW6oxQ+qbiopq7RhGm5qV92nr5aL';
    b +=
        '1cF3hSMCdClxb71wN15WfOyCW1lbuh2uKpglAIM/Bb/XOOtJQ9Br8VrEc+aiEd+x4D+XbjPtSVP';
    b +=
        'Rp0ofYZhhv9zInbjN5j3bu382J9x5dCQiUNDaSlbDuybUYFVQWTYFyqfYpzKPNxYvnO/H+Szvxn';
    b +=
        'pW1WaCt8LRGiJWLG+D60IL7ypdZwdxi+H0BXCsvuEezWUDm9frehg73ji6Y82MSODm2w3Vlr1C2';
    b +=
        'msUdrhPVtuq3jvnQKslKmoVdu1zwbWx21e/N01Hez/gaUaD3lx3GsKRDuUbZwbVCO/Ygz2mHzlw';
    b +=
        'Tr6qKFc1VVUBwG4F0jBiZ9yJuyOZyGeWgH+u2lZdp/OwBuUqtlq7kpIlU1pAcEEtR36bI7UaVnX';
    b +=
        'f0nIpj3HqzGdsvEr9rQDFLRL1oVCQZQA3gNHld5YwpVZU005QDtCMAS9eQZmV3KmqCdpSdJN+ec';
    b +=
        'pIZVlBWzi4Haj+B2Fe5qrKoY88y2bG0WUoVkjBW0ZvljcoqlKvJ1EFPN0I7o7WcEOPX5noGfVNW';
    b +=
        '7RMV+6HmMQuT0pj8jKl4najLNq7szKZIGGNzfatjdrZBDVTBkfbWb2xugIuAXpsVtxnTxaZsFqa';
    b +=
        '5jX9QLdSTOqGu15H6lYpALs2xRlil0VwsyzChryhC3qgf5DB3sE5LxQpgppp0qIVqo5I251Y2il';
    b +=
        'y2uZHFBX1Vv04heFVKvNlPaM7CAud5r5wQSxUYwjDgV2t79UAkEqOIXiE9h9pGphzouWJv8kNQ8';
    b +=
        'JL/nVF+1IoXUENSrBqB9upFU+wLr3pUQ+p5bWF3arPZBjW8TD3PAIPY1MYejhBjloypzK2s0zOg';
    b +=
        'nhupIGd0tr52ZWVBC1A531foWqa5Lm4IVkxDvLbhZ3Laezq5ri1BbcW2dVueba7llVRPcH2TMrv';
    b +=
        'mcYVYAcuXo41ZuFHZkGkQ+VHx7PJ6wnmjMivpdvMhCvmLwInCzlS3gOWs1/CT/FBvJFSDTr61gh';
    b +=
        'CamizAS0G5oBK0K5ralSW8gsMw6jI5zWADvwi0PhmDenfMzI7I5hIhZ2TBHioPY/y9fZjEaXXeU';
    b +=
        'PAzk1UbHcEzyg/gLTOWIZJ93gDUQaN82PBFi+AZJcu/BXtNxRvm63yZ+IBDYwA/QAcKZLXj4bNU';
    b +=
        'vVu1mW2s01JN3Neie8OYJiqbZ2GdOkXrVMxLF33OraxnY7NAFKHT70N95Ssx24jlrkIc2qB8feB';
    b +=
        'T+IzdtewDAqNIA/imAYs1izFqfQGv7l85b/6k+VPTsybNO7xy/PjKIxfMnj1j9qFz4NU6OoWoHw';
    b +=
        'qdNjTCfs425wB4NWYF4ghMJKC8oqZoqMZpZkE/tiR8V7480IzjJOfqWhrfKygFmGoG3NLqR5JRw';
    b +=
        'ADLDnJHE4g8IDN0nhgQ30BwUsZMoZ/Q+HsT9EHpT27Nx/F1Xy1G4OlMvczGNkxcNVTjUuVP7ap1';
    b +=
        '0eiyUrOg8b4CXFmpuIpcMpsVRQ1QR9nlT60a2uX7dGVo/ia4r3w2puXtjrEdF8hORq7U5Es7hlT';
    b +=
        'WZLNL865B+spSDY26qy9AG7iLd7Q+B+8pGxfP8+rEtz1fnpb4lOTLh5ox395YAIe5BKbydFvxd8';
    b +=
        '1JjKIqL4PP8g7PrICPMoq24Z5csyblsrkWdjYH1q9yOQEs2D70p+he6Mfwrtdn7HKSqxs7ZszYA';
    b +=
        'pKkTM1LQdSJW4Rxvgb1lR/+TkXt5rPQfEvYCc2AGmPw2a16qPZR6N/72uBqCtT3C97XO1wB9Vgq';
    b +=
        'GsdqtiGjQKDoHGjDTfwe9tf8I4wnB/hYkVX1eLw3i16B59R78s97yXvbHlHSPgjZvJ2Op6ho/FC';
    b +=
        '9xvl6ThJb2u49cX2FzOtVe+H4GB7ydWoTH5l8+cTEz2NwAgdqbyh4H5D8HpT8/k5y/9v85ONk8+';
    b +=
        'XvJOVBSf92SGB5QPJbfYYk976TzHmYxHjslDxbnsRED02u7ZI8PyiJVyxL4q9+4A0tuhg+q+FTA';
    b +=
        '59j4XMofKrgMxY+u8HnP8G3+/kzfH4Ln2fg8wB8fgCfC+GzHj7L4EPgswA+h8HHg08lfIbBx4LP';
    b +=
        'p/7Qol/A5yL4rIQPhc9R8JkFn0Pg48JnN/hY8PkXjOXP8HkNPi/A5z749CSPd+XbdfnBsW/XSQf';
    b +=
        'H8FVixv6FnekRkPdaYOQmjK9EnRSDICiO5ZmVaS2J6X347sFxfNfMZO3y5dlFbX50FYm88mdLeX';
    b +=
        'UXFV1/mlE0cfKQopZLL9d+/Co2xUzW9znlkwGCYCU0MHGQVdSyHrDiaNsoeuKjAUWXeDCUn2f/e';
    b +=
        'do+mr9Y+8mGU4+ZVDf64wKHWWPP4x/nfw/r/37ZrW9+rv0Cdu6sb5/w/THlV2y0NoU7DBn7ftM+';
    b +=
        'f/vXy78ueyv11Jv3vvjILmvcW6z99/zLbLMPevuTxlx+zOm/fqzxujd+d/rYHbZ7Zu7bSxvqD3t';
    b +=
        '5yO++/5v6E364/73ymbv29XfY/ehfT64ePH8L+1luwQs7ffIf8c8Rjyz497Nvtbz19/rPX/rkrf';
    b +=
        'S/5xUXdTnVsrbJ4ULrY5UwsXIsB240q3SynZeNj6lTtHlCJSqaOWmo9ulpLupujeHhTH1zTj9d1';
    b +=
        'Pr8sh6eb6iNH88/u7yntqEjY1iNAGaXp4GdGRFXH6k0vLlsnVCOr/l2VvS1nVwzHZF0u7ChfDsr';
    b +=
        'u20HZLZY1lYgPWvSd9PzZhyanjLj0Bnz5xWM/cSkfr788wR+8+X/JjgoX64w2j8/oEN5YIfyoA7';
    b +=
        'lwR3Kwmjf/glGWyzuxqnDx1svD//Tz796YbMO5Xrmymd32txw51tfvabLc9565LGv71u+5Yuv3t';
    b +=
        'Llgb9dOumTC496bNjX7+ty9ddrLrhrz1fOHfX133T5lCsX2CMWHfHraV9/rss/fv6Wu87fcMI15';
    b +=
        'OuvdfmXZ3+8z/K9r/7rqq9TW1S5bt6KiRfOeOHuS78eqMsLX3rg2JXbVa+77+vtdTk46qtZ/iVD';
    b +=
        'n/jl17vp8pzLp4fZv156wZ++3leXn61at98vT216vWjTKF3+/LLHL3vx5dOu33UT1uUPNhy40+U';
    b +=
        'V+BNvU7Uun/dD78CvloQ/nLtpii6PO/iZX2187bn1SzfN1OWHXvz18AOm/OHpUzfN1+VLn9/v4Z';
    b +=
        'euW3rx9ZsW6fL6m+nqfWs3/P6hTVyXv3gzPei78s4f/GZTrS7v/48n3774y/c++2RTky4/2LLlj';
    b +=
        'tvu+vGPKzafpMtnH3ZSbXGanr7f5vW6PA/9HC/e8sjzB28+R5cX7P/QheecOvvSozdfosuPnjyy';
    b +=
        'Yd/l/9nYtPlqXT7/wQ8evO7Rjbecv/kmXb5kddMZL6dv//L2zRt0+eWrbjv/4oYpP31q8/26vHS';
    b +=
        'HIY9/+WnZWRs3P6LLD9i2WLDfvS/+Z/NTurxhzapXnnnv4Cu23/KCLpeMO+jAp4Yuen/Mltd0+d';
    b +=
        'cX5TJX7LvvHTO2vKXLg39RdMo/f3z6JrblfV3+aPiwi3jZB4+cvOVvuvzCGXOz5S88cs4VWz7X5';
    b +=
        'VFil/e+u9NPXv3Rlq+3tGG3iVe/tKUNsar4hT9vGZiU6IanP1pxl1UURyKuL7/kyxXRwWv30JSl';
    b +=
        'qOhHO5Q+v+qly34Wao0v8EmL/rrqJefk8+dpb8qiopqWv9x5U/ir39Rp7rmoaOreV+60/wFzrju';
    b +=
        'jqFqXD/jqqdfsG9nfb9QRAEVFt9313DmhePveRzWVKSr6vbhz+Hllz57yO+39WlR05e4nTP7P7s';
    b +=
        'c+9c9Ew/vdD3e9ZVRm1kWDDK7Lfz23YTj/2HjzAKNWlw9b/smVV/yg7sbJRpMun7p09f2rVpT/c';
    b +=
        '5Fxki4v3/kPK294f/79y431uvzE01cdc9Fpx5x2kXGOLo8/9tLnnp7nPbfBuCQe7/WX/XfR/Qd+';
    b +=
        '/1njal3+Y/r6Kx69btrb7xo36fJ+50S/x09cdfPXxoZYD33d5T9ovPKZL3Y079fllx77y/x5j7/';
    b +=
        '1E9t8RJffm7T3P3f67OszZppP6fLNKxb9+qqXKl+Q5gsxPpi316rPjt7x8rXma7GuCu152Vs/vv';
    b +=
        '69q8y3dPnSH/1x0bxX37jtAfN9Xa6ecutNb5x01VevmH+L13LKTbfOnLns4Y/Mz3V5+NUTH/jkv';
    b +=
        'DvPLrG+1uVR6xfeMvSTPV+ptFLaND3SvvAvH9w09Kpx1kBdvmbg1Td8ddXQDxdY28f3Px9H36gc';
    b +=
        'saHB2k2XT3351hOPO3xKy9nWvro8+g8brInv7/X4zdYoXT5/y5Tjxl695LyfWViXJz14ztXX7OS';
    b +=
        '+9qZVrcu37/rH+y/6/S7X/suaostvLN/4UP3jl340JDVTl/tGK5c0ZnLNmkdZMX2o9nddnfCg+f';
    b +=
        'LtCc7Pl+/oUL6zQ3lDh/JdHcp390LLKg/KE9LqyhF2ZXV1pW+PLKh/T4f2FE0Z1sf4l3ydwYk8m';
    b +=
        'y8fkpQ792kvRRjbxaLk67xj9DKOgu7n67xrtO/7ex3Kyo9iWEH5QLN9Pxeb7eW4Ltc2UQrPP2yo';
    b +=
        '1gU/0hPNPwYdC/wKXXQAWqTku3ydR7utA9JXU66NU8BtdR5L6qAxY0YfhDL1cjaZ3QufUUdWwO+';
    b +=
        'C964xY/o+csyYIu/wWH81WdsJZjXHkVwqIcOKvH1X28BzVVoRAQ0pLTu8oEmX4wfhyuzDYxm6Hr';
    b +=
        '63K7AH9MGYUPXUwbGO7uHDY91c/ntdgY3hFC3jKl2GcmNoqjzggFGVnybP/ePw2EaUb2ddge5rv';
    b +=
        'bYjNQHnlttr/Pjxnadq8YhaIZsqKxszS2qaRi6uqKxUZbi+eFRFfFH91jmTDpg5VMuAE2fGYzxy';
    b +=
        'ZmxfOm5m/P7FPTyzfmbcV9VQvp+3zYznfl2BnuVUlRcgySFWqf5WVYyqGAVflWPGVKweBf9XrtY';
    b +=
        'F+FqNVvz/JUlXuzU7Q9nKlf+UgvNv+NfU2CykToCmlCJKw9HYlEBtO/+FSqlU7Cq+Rl2q1WlSdN';
    b +=
        'zK7HgdXfjeuyuckMTkqBYVPqiZHetZcLJP48aVLSV+6eWzYzthvr388zOS5+MuxM/qzuYUtOv9B';
    b +=
        'o3oQtFzUEfpV96eHdtX820syrcRW0jippKhACrgWRGr7/V+0FavTH2il2v36MA5sd5yL/hWPjL4';
    b +=
        '8PY68+58c/icuB/DS2Lali9P71CekZS7bC/Gq8eMGTPmWG2jTdYKUEw7dKR+qf322pxYr79xTjw';
    b +=
        'n+X12/5xYH780kZ2oWJKpV/ZOtRQj1I+RlctrRDx0pUaFxirnxnraMXNj+7MzN16rjm1mk3nOl1';
    b +=
        'cnMS15+yPRDjeVed+hcZUZneAoU59TdLJyRKwlHqmHkO//+rlxzr475sb27R/OjX1GOr57TfLuT';
    b +=
        'nOXeOmM1VYKZUuJ9dafzo113kqf6mtkahUXl5SYpSVlpeXDKnYbsMvA4YOGDh40JDXU2m6775Tv';
    b +=
        'aOyU2tnYxRpeuquxm7nnjpXWQdboAWMMZNmmY9xq3m7ekbqz7L/mV8WbzM3WlvK7Vqw8+9wb0cL';
    b +=
        'vnn3OBbv9YfCQw2d+9fWYsQcvOjb93vpzz7vwotvve+jhp595/hdvv//BlqLUsO1G2jioGjd+xm';
    b +=
        'HHrj8Pbt7/0MPP/OKll9//oCg1aLC+WzVu6rQZhx3HxfoLr7rm+ZdeHjRsJFyasfCYRceluTj3w';
    b +=
        'tuhytPPb3z/g08HDZs6g4uW9T985LHHf/P6p/845dSzb7rlsceffvall9/8/fTLH33xmZdenjF7';
    b +=
        'zsLvHZc+87zz73vgJ4///JlnXx+2407HLPri35u3tNSd8PbGwXvWZ3fbPb365LvvWfPwIzvutMe';
    b +=
        'e0w6dPee7Ry867uQ1P376td+89ek//tWYO7+p+dL9x4y99Z6fPP7sy69vvHLiZZej8/f81WsvbZ';
    b +=
        'k95+hjSsuGDD1g7Mef1GeD8QdPnnrBhfOWND/3/Cuv/u6NDzdvKapM771uY2rdlLJdUyXD1m4Y3';
    b +=
        'HJn8Z7la3e1dikzUmNTOFVqGaUlpcMq5g7ZrnRBqZXaraLcKrNKLdOyrIGpYmtAiTF4h+LZpbuW';
    b +=
        'Liw1S3YcNDd1iDXaMlLDSoYMrErtvl+6si51/H4tzxWvu9caXrJuk/W90h3Ldy7ffuD2A48vqSg';
    b +=
        'ZXvK90oOKp1WMSg1MGZY9YFRqeMkAq2UD3Bprz7JabiqrtoZY1aVh2UHF67YM27ls7LDR1l5D9h';
    b +=
        'rSck5q3WW7DNjhjEuKxxaPKzUH71ze8tjeTQNbfjt8YHHLluKWjQP/eY0VlK9dtH3Lg2Utvyyu2';
    b +=
        'HmcVVESlk0rG1jSNGAP6+jU98pbTtl5t4ody2emWs4qufOmgTul7BtSa9/cv3RgcXHLLUPX/qvU';
    b +=
        'qDywBO6em2p5zNrVGjKoqMQwYHBmcWmpWVZWblYUDzAHp4Yaw8ztir8zbHtjB3Mnc5dBuxXvXra';
    b +=
        'vcXxqqXmP9Yj5svmq+drA35T/1nzdfNN4p/hd88PUn82PKz9NfWkCoBoDDxg3Yfac86+99rpVZ1';
    b +=
        '986Y0/fOi0+0pKy/3xE4767JVXU9vv7AdHLVxzx933POq9s93pZ553bSskKkCcPYeLRQ/8ZNfdS';
    b +=
        'ssqBmy/kx9V3Xb7794oDy648LbSinETZOb8i7Lpxz/+5Gj6+ddbrrxqzNgDRiy45vobfnDTrbfd';
    b +=
        '9dAjT5UMGLjD7lUHTz3illtfePH60l2G773fhIM//NsnW55+JlW5z377j3DDqumHzZw7b8FRCug';
    b +=
        'WMyGX5lasXnPWTXfcc+/PXrn7nvrsxcftvarYSo22pGWMHdOybnfLHrJbat/yPYoPKp6SGnxgyx';
    b +=
        '0l+6b2TY0owwNmH7I2KN+xomzncVMji5WVox2L97J2LTYmhqnDi8emKkrLSydWHpAaWO5bVcXDS';
    b +=
        '1MDS+fOCNxBbumYsoq1+x85e0TZgTsO33+37Xcqnw0vmDJol9KKkullB5Q3Dzh40oEl44orSo4o';
    b +=
        'MYqHWsUtZ9M9ppdVtNxy3N5TB1SUDPpOVUmFPyq1U8tPq/m8gdPLK6ZN3XV62bxBM9aWTqvY3Tp';
    b +=
        '0RmANLqsoiUor1vq7tPzEGOIMOuUq2Tyg5amzZrJB68ee/+q6Q2/46bqo9MDUopL9K6ZVjCj+zr';
    b +=
        'p7jxGHp6LSYRMVDFz2Zdn63x5YfuOHa93R1rBU2dpzzkwtLR5klZcOvWjxoeVN1S1fVOTKGnaY1';
    b +=
        'nLl9gMXlu/ScvraQ61TJw/ZYf3cPVvePajlN6Ot4Slz7cQ9h1UVG+vfafn3yJmpipR5yrApM8e3';
    b +=
        'PFFdYqQWFO+KzbWDR6X4wKMqWu4Odx80KlUOcF/ScuUpv4NBD7KaBn6vFHbRkIGpEAYzomzv2Wv';
    b +=
        'nD9zBKrZKy3e3BhSXVFSUlAFWbfnlfhXrS7pF0Ml3WvkUxDj6wqOGarvv4Yn9N19emNhR8uUjVa';
    b +=
        '7H7uQSmlkCX7rBv8Hzyn63IfEE78z01mdjv6AupCqVqEEJhRh1vhl7jUyoRFpI0El2T0lVFl1Yv';
    b +=
        'Ljo2O9cX7TdTpV7DqxcvOcno64/6EBUOSp7yzujzNsWj97jq8VjijZX+tduWexvMt71jYq9gn0H';
    b +=
        'vRvcOZhEY3e+IUK7vXvoZ3vsNfPT49+dMye719xrHrlhbtHL5Ajx6g1HFL2515FF77w7D71LFtz';
    b +=
        '93g1HvfLnd4+qLKpf+KmxZWFRQ1Fp0WjDMEz4Z0wfgHYYaghAkqZppPYx9tj1mAFV5eXGzimjHH';
    b +=
        'BK8UFWddmBOxuVAVRIlQEyLK0wdzeqVPVUGTxSYQ43TDMC5JMyAfkae5iWMUCVi+EBY3tzR0BNV';
    b +=
        'epd8HSpVWHuYYyDugOh5ghoHloFQDBSpeYA3arqErzUVOXdzMhse8vuxnQjZUDjRplxhGGWDiyj';
    b +=
        'hlk+oOQwc1ftvR8MNuCNxQOMfcsNmTJKoFPmLmbKGpoaBD9LjCEGzLu1u7kH/JtoGqVlhjmg3AC';
    b +=
        'SYDSbexvLrJRZbpRYv4dJgN6WqhbNspIK00B72ikE5WJjRPlAsxIGaVihoTtiVZWZ5uWWMcgoVS';
    b +=
        '+0zGcmFhlP7lVknWssriwqyZhFKaOi0pxrFinkbOxiFhuXmcO3G2TsX7bLgDEWMtSUHWAcAjNvm';
    b +=
        'gNhXGMNF1o1zWIY94FmmfGxmjYDgHHoUCXyGO8Z3y8usmCUqRFWyrgZ2i8yrxhgp1YZ/pCRMMoK';
    b +=
        'y4YWS43x1r7FRtkEY6CJy2G3GmlLTWSJcb1hle2gZ9UwdjQGl1rFT5apgeykZrRELZJagI+gXyX';
    b +=
        'wvau5oExdOd7QlQ1hwYIWF5Ub5r9gPQAajAvgbSmjsmJEiV6lEtMaA5NdVAqTYRy5I3QEWjmxxF';
    b +=
        'KtwgxOV68yYBxAF4uMg1NHqN9jzJ2KYMyp4rIys3SP1CVWUZByyozBxo7FxhBoaZhupRgg1hifK';
    b +=
        'iqtKy1a3PJpUZx8fMDOZndhGLeddkpLUUp5RRnXqJ8vFhd5yiadpsAYLxEgWafTy5Pf6UwuHfss';
    b +=
        'V1XVEBHKgHGHIN93XBwY47qtFtdJ88ZsQ7pRSKgMkhoPPU8G2EWC0dA8si1vZ1WmrqGq6tDaLCW';
    b +=
        '1VVUNjVll0Y/bW5JOimkvcEBG9JiIuIsFCaHNCL48j8A/P7IFcqwFHducm29rmdAu9K2t5stpz7';
    b +=
        'WF7QubBIEvRBRAs4xLQZDjCe5jIrFMze7Y7FGtrdUD3s23qX6n7ZB6IbF9RH3E7QBBe47DsO2EE';
    b +=
        'Q9sLl1HFvc43bHLqKomEGNE2gzmHVHPKzmqYzdUttlZOmtsVVWj0O4H+b4kxbTgkgjOI1e4yIkc';
    b +=
        'D9q1Q9+lgtggUXMuXFk6t7uViLOA5puMS2mHMsw9ipQigAuPQouuVNK+h7EPcrgjnLIF3bVYl0u';
    b +=
        '3b7QuFyerTXOEXCGo8B3muz6JFLwhW3Lm+h6I+kwKv3xpx2YnA8EBinJI0iTcTsf301oN1LraHV';
    b +=
        'LmpqOIUhES35OYCBmqRfcDSuwwCAIYmoxoUFHTabbnTJmanjVnyoKZU+FKfaYp37rycciwdJwkI';
    b +=
        'duYLngwTTnzGIlQ5DM/JELNFon8yAmIS30W+pSFA2RX65ofUzIemamtTSvvrNYFbpeGOO0GIWwA';
    b +=
        'GnoAsDahPrxHcIoEDYXkLsHSowPnKb+MbK2IUx2nte4rrTyAqqo09QVoFstbgVksT/uR66i9Aas';
    b +=
        'KGz5SjXJbMI6VvoUgT1I5aGGvjeZ0Fou2uWJL04hzwojHoaeSeo7CD6GLCYXZdxxuM8bCwXO7bz';
    b +=
        'hOoJ20GN9GUWRHPkwrg1+OVHCOcBiKwI8YcxFHzB9y5PGwu1YCUExLMhPrAcO2TZPGJbmCgddn1';
    b +=
        'YW09IIIOxigghA7sBWUUO5Sz6cODICHJCJDWb7NJQmEKxiMf7cizkMLbinf6Na5gN9p4bg8ACjE';
    b +=
        'MJt2wG21cA6FtwQkIJFHQ+kMW9LPlyzXiZjzr4lLaYqpCCQOqYMJ83yhEJ1gAXJCSagdCYzc7Rr';
    b +=
        '6+aLklkod0rrV9KX5cCXNfZva8EbiBTbAi3qjF7DIxxRhP2Q+peg7S7bqje1floZV9iNOAkfyQA';
    b +=
        'KgwoswCbgnhE0D5HsOFduHPeHc5nouZKYeGFJAj64DWNGnPqGCA5zvcGhnsFGqaNSKF6GQDiPPC';
    b +=
        '5krIj9ALiNqGUMBPwgJcBAFOPLwjgvyDS0UdBJwwnW0dmVV1Szt9ldVFTtf5xuNS2lPAGyEQE8A';
    b +=
        'DgkQBNVs5MK2JJK4IqTIZztNyze7IFPfFE5SAQiddrJwaYiQ8AIUAEy5TIOy9IFKwRtsxuHWzou';
    b +=
        '6aSet0tmmY01eQZvqanwxDWiUCduGHmIgnbZaaEAbPLIDQHk8cKhv7zK3q9ZzzZTEv5IdkZTTxA';
    b +=
        '9l6ALmhIF6yFcIglPB/AigmIlAMM8dPrOrFtt3M+mfi0LkYoRIKG2PeQo+nFCEHlB+ikMn8pi9a';
    b +=
        '5ezmBNtSB6AD3YjCm1gQBByJOKqVzZGwsXcDZ0gEJ7wdqvujSdiKvQuzxRF2PY4Ch3bga3iy93t';
    b +=
        'bms31TSqLV0jgXogQMmw+oCZKdnD6bZKXQJZNVISL4wcwFkMiUg4e05Xch4sbjNQnMT6pPB0bFq';
    b +=
        'sqor9cOCW9ihO52qUk2JOsYCYM+JKBijDU27wqHJqv1oSK4jmJCPsU2C3Qo4lIYCu95rct2bqmm';
    b +=
        'vTDdnlttoHLoA0oDTb9QiBxYz2ruK1ddpfrKrg15TkV/WkCVA9uVgTOggzB0VC+MIJuLNPCG9Ox';
    b +=
        '/nFYCfGacWqqtry9qm6zFVvpcABRwA2kS88xux9D++559pM22km09kGNQ0OjgLKIy90ie/DXt4v';
    b +=
        'iBuD6sAGx1rwqqp5TY3zBGlkNSJPoWt8JjnxWcSjkDm2zfYf12v/eWYZAF2d4j/cSEZRwF3gRhF';
    b +=
        'z6QFhwRBimR84q8wS11mBUeucOwp7M9vxBaA0wHbEY2iEXdBfrfBPqLGS7tONaohBRAGZAiPNPU';
    b +=
        '6AwI90C6poL2zoWjatf+n42Jwani04RkGgQ+eASz0QtYUPtlL/OrI0eZ2q4ToBMBIwLTwQPJQHh';
    b +=
        'b0Cg2wUQoNi5BPPi3CIYAM77ii3y6kEDlXn+E4rXrtGYl9RUcawSx03DEdP7w8U6F2QgACiEuDJ';
    b +=
        'E7aHQolxMGZqtR4rdBs+C9piZ0iuMn6HrIN6SVT2hKRYA1MsYFGRHYbMo5E/dlTBw9PygQEKqBS';
    b +=
        'JAzbdlwjYDM8F8igEsquhrx1fIWjzktYX2MAy2IhiYFYcQHnCnlzwqPaXTL7SipcXLFOnD91QHs';
    b +=
        'qtuz4AjMFCDexIAg53vG47mdbBbo2K0tfYwI4rqQK+meMz2x2UTjdygC+hFxPbhcARx2+psFoAD';
    b +=
        'h0qrCYZwMkB6LMpixzkBd5IHe2Vyao14uorrW0cisp4PLRhSXDgIRtwkz+vuqCTtDlTy4WC0bmE';
    b +=
        'T+KkQUVbtJ+2hSrkB6ZNh/6kNZjXeAiBRMGAEHLsAs4OpvZ98gqQr6QMmETY8NSB6RB+6MAzDZl';
    b +=
        'a4BNUx5oySiCtU3sc/qvLLlNDByYS2OwAoMLjvpKTI+DfcyStiIbagHVALKCb+XMX0vkDU9Ss2T';
    b +=
        'YC8dN1XQd2PWJVE7pernik+egT7YnepHYxsC1UAFsJBBYBwUTjsJ71WIhRMSZVVXP0/5qBytTXq';
    b +=
        '8ZqHFhsYA+Rx1ng+RxXj00QhkIvemSsplF/N+ofIK1jgWByASixZzty/D4F3dR9UysgUQA4GwaC';
    b +=
        'EWWITKjucpfrfI7xPo+1lmmqaysxigHOpLYNGyA8eGohyKmNOkXAlfi4lsbqI2H5G4RYmk7iu9I';
    b +=
        '6shqIJ2Az7jgewb6NbduZWN09/HeeTuJ4wvEiYNcUzRRo0vyuxwCYW7EwCizVfRX2r+rPbq6bkA';
    b +=
        'wQgDIepEIFHrA/LvOAwRReFOHJ+7YLhFQ++5rewMZFLnHsUMnJ7JCJXRGq+cuzC8nKQlq1oilNt';
    b +=
        'fAHW9CHEatAaJB5AzeYMqlXBM0Bx2VhG+tzODSqxAEwl04YwVqHTjj14MJVyKk35hGs3vhcD1Ql';
    b +=
        'LBD1egYRExKQDkUei5T0P633GYyHmW3Iqdtwa15NbXWzOgNkAnQwV6O2iUMQdnzpBL60Hex6h6I';
    b +=
        'ed5hCaLYfObCX/cABdpTx6TOrO+KjeTrWa6YKVYJetN5tj1xgqhRw+p4EXkpKH9sqnn3GoQVQpQ';
    b +=
        'lStcrd0Qm1a/eEZh+3ongBzbh+GAB3EBAQFg777lYStSRYdmW6UZmrFXUiisQ6HNGIesRHh8/qO';
    b +=
        'PH5eZ/RadqJYmBgQprpBC0vaFVNqAgBSBjQT0nQTKdaW8d7ol+ABUNgDJATgFRmYzFrUu9bWBOR';
    b +=
        'JOpa4bOAAcvn+/BOl2Mvml3dK9MF/dUrrzrtMIQBbDkQP4fbcs7UXrmuGAXFv/Po0aXcBtZVAqe';
    b +=
        'CQhAD5s6o3r9r4OkBcOIpAQLnkRAHgBJJQEV4RNiX8Sg+EDsgZQNHh8MA5D3mHIl6Y7hBFsduEH';
    b +=
        'gYeb4PUvK824zqdtukuXEZcHbJYYhxWanv2o5DhGG1P6RQja8vTeQR4NRD4nrVuXw7usn4PKIJC';
    b +=
        'W5UDGHEotAFmdgVHOS6YP7kPkIKsGog2WkuAsYIFFdw6fGAe463IOxqKyUkJqb5CavggpBmO1FI';
    b +=
        'I8lhhtFRB/e6KMnFdIyOlFhrcxGAUGS7mPkL+7/XJnEOgyKcx8ICD4AJAJTNeMid7+I+KGxqBA0';
    b +=
        'COwJqxSkFMMHfm1fdmUkDueZIFdKu4LTTTXWndWbjqZEOB+6N2bD9fccO3KMXVXdcmXnihDiyH5';
    b +=
        'altd0OtyYkhEnE6YxAsI/VPthxQLp1HEm464jgmEQWa412hBnR1st0bLps3ZEggQoEhMUmNpGSi';
    b +=
        '0Wiev862H69QE2H7hXeVbSvrQgdPEG9xqN+5Ht2hIOA2RE91iuA45yGbBhk8q2UFdRVWxV4beC6';
    b +=
        'MUjJGCoF4ripbbQmEZ60mrYX+ULC3vWFz5HLQpB5UNqJH04sz8pok/gIwcZTIS2KMcOhcKRKt0I';
    b +=
        'iDEh3cVWXnLTG0/N0zg24lxG1ajUQsK2ORC4WvgvijEfsjjry1nI6VsXXIGCKQ0GRC3wrhxrU72';
    b +=
        'GCtDo9niHkusA2IuCNgyhgII5Vd8VVE7UxajMUXl+bXeLk/6/xQEjwbaXHl8ImIH8maF0RJMWlN';
    b +=
        'tVkea6VBMNFmNKYPYFNDwNXGa8V0mESZF47UEYuikHaqa/evx+8SRuR7JGjmdBGQm1MZRhIL4xA';
    b +=
        'ppeBPLTDeha6FChSTxpqYLsk+bnV6LNLmxsUfHEHWGLhKNuDK1y8ZFJnnKx7B1OhsHJh9xKES4A';
    b +=
        'fo7B2COAkYDKqObK6YOslXzpuWold8HsG/OxNHobdKB1Jg9ChhAdR5vit4Tg6rUFBpba5VGY0AD';
    b +=
        '7bjWxgbSN6/Lg+0dFGsUxBX4S5ZB5ziEtJSIOlh1UnNDNvB5wXp5DpScqMga1GKeWoZ3NMODBHm';
    b +=
        'NSO7VijQ4WAAysRSU8ZN2xhe3V2DwIla9CqROBzQTADsVJlNvJlfV/5qESsVdyDENIRknoCoM/l';
    b +=
        'fnZsR4ZVb3AopoE91YYsDm90cRTZxOEYNdjdm4aS/5n0QFCT2AkIZsLHJ/SLKXadNr2HEA7IlyE';
    b +=
        'VbuA51G6cWd2FLkqj0ENUMrOewTJ0fJcI6UrOQ19GKNfbCknJCMGCAoYhwN9HTdN6FZtg0RSV0v';
    b +=
        'lLWmUnCjyvC0QTRNAokAFtruoVRtMqtlEjSN/BYegCSg184Drpst770Fyvko906oMA2uWFgggHd';
    b +=
        'gxfjrtk2zvuZGCgYK4CEHmJMjmuCNsJqDr5TlWVTkgPfFz1fLUp9P6tiRwWUu5IPwy50rOvHN8X';
    b +=
        'JW/MdSvMHoGsSUInYsC5hyE58bBEfZGPvM93Igm9VyRJx94rLBVfiGPeFboF7IYYc0PPC9xIolW';
    b +=
        '9s9rJ5DscQJk5CKMAYTd0ThoXcxcL+4QQgHeLUMhtlYoNNuvqw3tduUZgiwhs1+Z6lRoFeI8ldY';
    b +=
        'n0DJws4FKEuB/4BFD+ybf+77HwMc/qUIcArDEPxBPfx/6abYhTW4xt2Nhao7oHHkXzUel8kLsil';
    b +=
        'JRSIqLIk7ZPADjXGUcUiBWFCE0zzPlZmwZkFvpYiNoSLZBClAEIpWpfc9dDgkanGNucfdXviQIS';
    b +=
        'eFFAQwrLgghdb9TEjGgBf60d6vPYXCc8akwo/lyysjZLCpTgCWswObtilljQAG9sUtYAmlUqLaJ';
    b +=
        'GREFADpkIQ1ueavjJiiU5BEC6IMuPEqx6/qhJWo2j0vppBYgfOqFNgbTZoYP4aUZ1d7YAmmlanl';
    b +=
        'FULRbhtFHA5bBBWRCBgI99QcnpxkHtUNX85Ds24QSKqNkgLyDHAzrFzjCGddIVnWnUFG6PdH6Rk';
    b +=
        '4nXKq95+YnW61v4eOthukeqY+An6OfjRxVGAv6a+tLxbYocZPtnGRP7SMjjdJyxPGYT3/EdB7AL';
    b +=
        'kuJsY1yvTQDzmMgz2Pa5HwGGAt5RRmFwjtEfzAYTKZn0A6xddkR0ruEVQH4yS00KFOOIl3RCE0B';
    b +=
        'Coy5DHrC/iEvunWf0RoERZioiSrmRBAhGeb4xpivsk8yOVo4ggTiRsEtB7uH+BcblRqFNR/Ut12';
    b +=
        'ElO8yVXsoEZjW8amCd0H5j6atHZXKZpmwj3OywIZMbUGWZ+pVMukQw09IlBDjViDL/QuPYrgRzp';
    b +=
        'WrvVTQHhk4JCDViRZuhBfseshHmnHHsuQRfZDT2W8U6OdM0qZ73LP6oqYCHidYuUgEkUgigbyAy';
    b +=
        'ssi72OhdYyN9HB/e1Kpdx54tpATeLHB9isUlxqS+mlRbOQafRwRTh0qsuA6Hf9+Y0CPiWdKYXZ4';
    b +=
        'mddnGJpVFT7EcYRQyrBhNGA6l/qVG0BFHqrymCYrUbhkJv+vbnuMDPqEhA14niC4zpnVv4AAco5';
    b +=
        'W1XSExkJw9Kh3PpQAeyBGXG6M7TqZuQxMXvaFszO1QYKQcK3x5hTG1ukBU70nF0E4/y0HyBRYzA';
    b +=
        'D5TYkKiK42lPUlf31Bkc5EMHAawAqTPpQJfZYzpuFIyU5/J1aSXxF4XDqbKE5ECBy2EF/hX91bB';
    b +=
        'U0Ys7lFA7o5wPO8ag3TJtbQNBGQaIPXQWehptnu+YIJm8ZVnIJAQJCICM8cVLsfsWsNtZyuLUcw';
    b +=
        'x84/VfJ3yeFUrTAMsgaklgWtTlZX2uj7VEpGE1wGuV7GXhPjXG/XV/VdQTOJ92NgxE4cCkN5hlT';
    b +=
        'wWMN8NyA2KYejbBM5vXKl4np7nsKlxZTqv8WUhFy6wJSG2OUX4xv7uW6BAYURt6gXIFcBy/sC40';
    b +=
        'ui7GiSe8J6fz/Ny2ts3q+lDj9MIokxWJ6fRJmAKGJ8FQciIDYLUTf0dnoSJgXF5tgcwENj05v42';
    b +=
        'EDlA4bEkwI0xoNjsFmN2jw2oRI2NynzNs+nkt84gGDOFqke264fMxb7rUUGxc6sxsS8NKqtquqE';
    b +=
        '5pziBkAfYDyQWPvZgUOI2Y1q3kn2PmAuoBSMOinAUeCCqebcb47vjGlsNr+lkY8WKZw6CLXE9H3';
    b +=
        'MZEf8Og1Z3ov0wCtWJwusF5+UBXENhqv4Nz87QiK7wdg0hriuJ4/tB6NhY2HcaPal6tNtbjaNc5';
    b +=
        'pBtu1I6AD9sg4F7kFYaBW9W6KMGmMEwxEjyyMWKmt5lTO9KYq8lJwLTNBP+h008Q+nSteyulLmt';
    b +=
        'TGrgeQrX0FDYjgTO/G5jTo9rVMD/6Gu6vXYmeNd1gNkmPgkDBkyKd49xWF+U0hqz12tXFp1xN6N';
    b +=
        '9KzziId91XW4jJ6SuuNdg21SmWaKXgdiMUOIj5GOXyNC9zziy77rM7ozWgFsjpbnFAA4oCMUPjd';
    b +=
        'rexFrdng6dViQKvqoLruuYdLXp4Cv/rgmtj4No5NoRlgiF8C6guT9KRKOCiVImi4SZCYCmMccWQ';
    b +=
        'Kc8zh3/fuPwfprg2knNjAhbIkCBkWJ7gx/3VRz0bNuJXOV5JJgLGP4BY1ofu6FSFRcYjiOPcYox';
    b +=
        'iDpCZTNwfmLc9C2RB+CdZ8GUNjTXxkH4faAT2h1RgwnImhLbysdFhoL5Hn3QmNA9E9kV80hA7A1';
    b +=
        'BsMUgZinj/E9745KIytkgXRdYx8jjEXpoa7i+rpiKDlxfTAhthyPXRYGPiGRMOg+32/xda4VnZp';
    b +=
        'eLxulihZ7KTIFimAhBgSGSLKQydDB5pA+NLWho6K4xx0NYcIARaUc+f9S4+39PuaZcwfN8fU2II';
    b +=
        'oEjJITkgbLwPWaM63FXJVltlT+FdulzsOMG1PE5trHnPG4c3Fd3DB5b2JVLINCmUIVPeBGzf2ZU';
    b +=
        '9UV9ECujwsDlwM1KQWF7OxT93GjoTHK7JrgdT/yNSa9iN2fAxdn6Wp4Etz6rPb19W4LMHfohhRf';
    b +=
        'LJ/o1Xy5xcBRJkLKk47hMPGl8r7q9b0c7147EMzEZQy+TEQSccpA2KRB76kbBU1tPr2FPIeFGvi';
    b +=
        'cAiqkTPr31TREQ5x3sKVsuTFlkP2Mc0ifSumpVcsTq6tVKH+EyTBiNHIAW6nrus8YBmaYsAdSQB';
    b +=
        'FvEzktKKgLKSqWHQqrCNkT4nNG7tYDVNaQToamG2SBNBQFCgRAuctHzxqQeFCvaRyqjUHQ6K9N5';
    b +=
        'KskJdyJCsIMlFxGivzBWbAsk0KW2sIM60CbEdoAXBkkIWAIsfwnSVgw3MfySGKK0iaQBxBDSUD1';
    b +=
        'j1LQC8Iofy+MSVSJNijebkfxS2yGrTfuY+gBnggSOCLEXOS8YU/q495fXQLs6r77mTkPpiQAWVR';
    b +=
        'IeUf9FY1brjsifY6B/xecY6CXX4N9YvbDQgy7N4m5FKPQCRu1Q2qENIudLRh9iApprXR0U4TDsR';
    b +=
        'Gr9XcBn3sv/i9hbK601V6L2vHIR8iXQeT8KQfJ4xTiuupMz5SEgICgHvuqFyUp3CUgACoWwlF6q';
    b +=
        'dKE1xAMwYsBMSJ9hP7JfbcOw35i/1LJ9Zx6TSw94RhvkTJ/Djke/MnBXYhRMohaK8hphJtxQBBg';
    b +=
        'TEXIUReTXBo7f25gcOxIfPwJ1p07I5xzTvL+MgtAnUcBtHNrotf5w5QnjMqu5tlpxARM0JGmPae';
    b +=
        'HZIKM5IDchyuhvjDHt+xK/PvFAUtsWSZAaVR4u7AnfJ7/tF1UJEPc8F6lwQBdIafR6v2oLJICfB';
    b +=
        'nRHAhewlfidMa6volQcR0p87MhIBDBkz3mjlVXssFocALxeEwSXMd8mEaMhwth90zjpm+6xREfe';
    b +=
        'm+Y8tl9FRDBkY4cGSFDP/z2Iolul/2rlRqUXiAABwmcgExCK3jKcbvVw2oSu1NTUsyOHSwJYBtv';
    b +=
        'Ux38wDm4f/tWqBEvIoN5T6qxxNw3ckbbaEC8IAptp84uUbxuJx1KDGqcO2FdUtRawbLey9gTN0C';
    b +=
        'iNAqZh5DIVX7xxKzbAlMyy/AbgGeUNE7hRSBAPYJEDiqjzzlZ2zqYe4HMReQjELUbQu0Z1H/wmM';
    b +=
        'ir+okG7u6t4BeHYtlBLg98zDutW2J3BV0zoWT9EGMbItcOQUmlT9kdjfEd6N1eRt8bZiWGtg8pC';
    b +=
        'qfUZ9QlRziOI+O8bTvX+83vxmoiAhklfOTv7EWee/KCd7qaj1aqVi/FBBAyYUuAAf48D/Kdu2YA';
    b +=
        'TMzBRR2caqieNmtyJDej82AyAZf3ohLz9E3shEtzXwf5M+vRD4+pvSSg+JN4SorFP4nA2RnwAQh';
    b +=
        'IJpJwKkU8EZn/+9qYC9o9SRtmBHWGfseAvxrw+4pbW3R7TRB8X+DEHJOIodBXedG1PhH81DuzMk';
    b +=
        'ebj50IJjCtADBYS9p/0P+rpYRzigDMMYoMLU8S8vxmT22GuhCInAYH1PGZwVTBuYWCgTwIWYIQk';
    b +=
        '5cqt5O/GxO4biRvIQocKYwuRLX1pB0CJHZDpPfGxMaX7JrQduMuehETjQs8Wnm8DbvzE8Du5/sZ';
    b +=
        'SRpwnMJ13cPUCrhyGOUdMUizlp8aUwoieSckRVrnefGsjgDHJ3IC5EZNY/iNPCLoJtIo3OHF8z/';
    b +=
        'cYFtgPuG//05jdPfXINsS2jvw+V+Ovy+R00kY9EVojSB3X4WHEQQwRPPhsG9GFzw27Z0dqbR9wm';
    b +=
        'RMAefcCB2S94F99qMOF9JiUQeAQNQHhF32oIzwJ7D32HATYNPLZv/tQR4LkyF3pur6vrA3syz7U';
    b +=
        'cUAwAbZaybDIIYL8x7h/mwgE3ei+vmHLbQqyEBOf+NrO4ym3w//2hAWA2WaK5baJyvSKg6+M6QX';
    b +=
        '9k625EqbVF0T5qbC/VauWxdkk1dlyWkxHTLlQwxbwoijCMvy6b8qceCc4Lg8JBWznuNjxkb2pP5';
    b +=
        'UpDYCPItym1A0cHG3uT2VJaBT5IfNA7KMRCbYY03qKcFQXlAVKXWivpqDUtiOYSKFiJjjCLWZs9';
    b +=
        '88zLICUgf1P62Li85qoyoFdAuSHVHANsPKeWGv2o/8+cJ2R5wQS9k/g+e46s6onsqOSHQEuSjQG';
    b +=
        'MnBshIVtUwGDR8Ep36TyenN6L8ZdDVQKCwH+hP8n5As1rheCFIO9SIIk54T8VHNW94bfPrQnAJ1';
    b +=
        'LPyQuIGMmGTnNHNc9W9uqC08GW+MGIRYOZ4xF1AGm7XRzTHf+RYnfg6BI2FDBZoES5s7orYIDe5';
    b +=
        'SHwsaEY86EPLO3ChQqyBCEW4QiOwyis3qrEIUAy1JGngTG0XHo2WbdNtcFKek9XZMoI0Sgcmo4S';
    b +=
        'jMPJDU6x5xauIJ9NsSCyBzZLnEQbIZIOtG55jqjup1eN5Elp6ivVptqz/CgCoc2k0bex+drAkZA';
    b +=
        'GnYiR0WPMxycZ7KtVa3EQnM77Uo+PkaEyoGU+mGofI1oeH5/9j2gGOoDlOLAp5Tz8AKzZ3t+chp';
    b +=
        'qWz4RoRwmIkQDrvJ1hfJC0+9DKK4CLcAzDvaoyiJOXRRdZH4Ltm5JEQk9BzBzIBHA/cXmEd8UCm';
    b +=
        'pC5MO2CCnwXCA5M3lJf6cMxD/OAx5i4DKxEPz75oS+xZDnya2gwOICuaU0RDwK8aVm1Lu3ZVLXp';
    b +=
        'iAMA5ONMQgz0NBlZk+iAMibtg3r5ML/oSMuN/ukEAt95YAmQCKQIWIRucL8X5HnarR6kBIWSO4C';
    b +=
        'rQ+DQFJ2pfmtabgFA+rh2FyKyA1dGl1l9p4vQIckKpdTkHLS6gx2HZsfcJcEIRUgxkmErjZR52X';
    b +=
        'TFaGOyEqtH3JBJlHpflSYXiSuMe282lUzJZMamba1aH4+FxvIPZUKB/kc2CciBcbXmn5XuZAUoG';
    b +=
        'tJAqa0Id7NIvAoBbaYMpC+SHCdOaarikmlOIGFTZinzE3StQN6vRn1Slvzqgnp20BPmQDQAi6Ro';
    b +=
        'huAR+qDt7ESVyMbU0pcWI6IIWTf2H7nFNIXpaBckc7bZrSXsqOSbYQEM8DlDvmB2Q8zIwXxRAYI';
    b +=
        'OTYwWREhN5mH9D+BYY3SMQfCC2COI4d78mbz4P7lC6wJ3YDazEaKzQ0IZ7eYE3qPUNP8UjrWSwM';
    b +=
        '75CHsA8PmEgYQfWt/ZiEUhFHbYSoOx/UZu83cdrZLagOptW0PBVEAO9u/3ZzZR81Jl5K4jVyi7E';
    b +=
        'AsDEEe5fgOc2uUvIWpClxA1sLxJPKU54eN7vw2CB5nhAc0UgEc0gkdZ4Oa4a306tY0p2ADcMH80';
    b +=
        'HYC5euPCbbvMnuMEVTQWMMATH1fsMCOAHk5/t1mv73zuAxIgCICSImoAIF7vol0ca/p5pFgZ+VI';
    b +=
        'q8JPpRQhDicOE6EUjrzvm7zyh+aB3WYNrEEUmEMcIexwlUtV/Mic0V+3Ntaca4qDZ31Hqw0jH7g';
    b +=
        'eFpL7zaO7V9v0vuv0rj6mOTxWQVkNQC0T0KzjBRiEB/5j85C+ZGyK221oFDJOMRM4QCiI9OyIMh';
    b +=
        'mKB0zcy8RqragdBCr4LsKEcgJyy0+2rtqDW1ftp1tX7SHz8C6tICoWp1sjYKv9T8L0eI7kPhM0t';
    b +=
        'In9sDm+74yDTtYQStcD+AVSEXqB80gfqD93AwJiM1EBU46M+KNmrl+h51sXs0EClSszkhHBnmtz';
    b +=
        '8Zg5va8qb4Vi5jQqXBVjGxVS57kRsRnIkABlj5ukF8/EtsbaK4o1hoxNzwo3FNiWI+UZgW0peOQ';
    b +=
        'jG9s/M7NbE5/fD/d3GdlIeF7kCxEA/UQ/Nxf0K91TJj7FPqNYiDn1im5m67X3v0Bc6YuAwAklJj';
    b +=
        '9h9i2NVKs344z4R+JhLmuzsUmAKy9SIrVB3LXxk99Os0+ZTufgknzKsjQHYVMrPGxBbR66NkAXw';
    b +=
        'uHT5viet3KhZ3Zcn7pOJIHsRcKN3GfMsFvVOvAPmaY0yLmxcRXIFsgYUeQBVKvsrM/mZacequrg';
    b +=
        'SBf5RFKPBK7kQfhcK8FKvvIZcGMNoGpEKz4DxEjgSxpgH7DQ82afQ6NVMi5bSsDuGNAEdn6xVS/';
    b +=
        '85VbVesEc2bV5RbtnM8IIUBwfRPeAyBdNuxtTDI9ZNz3nfigjJ4woB/rt4pfMw9qBnjauxiJF7z';
    b +=
        'ok240cYPShm8KOgKi//C0gE9fBvpAgiAPmdXFIXjHd7uURQNxNJK4VeSIKkWAwmYjJV82TurH86';
    b +=
        '360Rhh281AeTxwppLIdLoSnJtFMfGSZjpsE6h3bjAjNaG8FR5LIQS71KcUe+hUg7O4Y2d50KU5E';
    b +=
        'hAviXIgDhD38675tEuypjEyRy4mwMXKd18zZfelBO4+iGYXrYLvA4jvAM/kgMdt+8BtAsf1scFZ';
    b +=
        'zU0GbCRIAMqoy7SOEiVQJbH5rztoa16BWroAjl4PUJXwXhYCb2Otmj2EG7cMLqgv731PUNHeErd';
    b +=
        'LFwxuUDZr8zhzdtUNOwqHbkjpSIKq8JADXsjdAVuqBy+8DXPjEhb3nOTikhEZMvNlLD0BKk66DY';
    b +=
        'PlUdoMI/d5c2NVGLPTC7goiNMzH0JaHDOAlJPEAPjC0zzz7rX725A/m0r4Fgsxraux/fLsIuZAS';
    b +=
        'pCvk+gAV8m3z8M7pRDunN4kRph6tLMj652EZRD6PQHRhykCw0fR6UPfVkQalkdRivYiAfjixk65';
    b +=
        'H3+k79fE8DoJdGAY8YCA1Be9uHTfVVbRnN+mObEKxABEcSAojxPbeA+zV5gakxbR5K3NNok69qe';
    b +=
        '3GpNjhTUtc+Ux2QsWbS8chAgXIZ8Efe4ENSj3OQTIAllz5B5P3zZO+kQZg//mj2kO5FsBmxCqTz';
    b +=
        'rqBENA2BcmWRSpGjZEPABl1RbTbpri7sROdSJW7hBAXQE/5aQFC+hMwelvdXlqd7qst5iTiHo5s';
    b +=
        'X/k9BjKSH5qdIkdipmKJssUoehQGoc0pUBGihoj+vI3H9ZdvZ1x/7QVaPBbZgUqNwCUO/dD7CLq';
    b +=
        'x1aqcNi0Okn4gbOLbvs8DwunftvFs/f3bma2PzWE63j3Gnc316iSLT/L4KWkRcFpWkd2ZyXdynk';
    b +=
        'ANCglIl4QEEVcKY/bptmYX/vEtsQv/NGu7MUzokwNgng7R34p0bY37PRCpENA9cZH0XMY+M7ci5';
    b +=
        'Ep5LvcSchXzLogrt2pbmYUoQYJ/buadsuPT4pQ1Z3n15CSmPZ1dHp/B4SmNtcBR4HvYj4j3r9Zq';
    b +=
        'reiAkQbCMk0rC0P9bBiTG/iOiLgtMUJfmKO7ER8SW7qNpO24vmNzlbfC/7fZU1LFTE5DqhoVksC';
    b +=
        'PyQAjArSYkS/Nzq7mCblL5/upFWEkEEB+XAFcBZLyPyZqv2nEClajRIt0a95UlRWOOQGVhIcqPO';
    b +=
        'e/ZtQ1/mj3rthBmzgwtNCLqB35buT5XwHf2N8op/bhTV0FNnGJJGa+7/pcuQ7ZX/d/UJvMYYWnV';
    b +=
        'ujHNptjuxeKMjr7geNSO/B4IIC4eYJsMWU3+0Zn2jtSLNvKHeNj5HARBRgQs3Q4a7GCPmjllmur';
    b +=
        'MchLJKBAewPHs8O1ltNTGss4n6jnREjZyMKQwiZlcp21rdhaD2EHM0SQD4Iyks4p1nH9bjlGYR0';
    b +=
        'bT1CZ7yAK0O3C1COfOmS9hbpwVW4ncDuR8t5RCSyYMm/jU62+oXdOcADSCmM+Fm4k/dOsiX2zp7';
    b +=
        'eZVyOY3IADqmFRQF3mnN57byW3faki9aMwoIjzM6yebOPx2Q06qUrk+Oo4dBH4OHTJmdYhfUoi1';
    b +=
        'jGFNZWujymwBl7geeysvswulcCl25EHcpqLvbOtWdVdcelxZtw+ZGmRWJ2ARZCnEuKL8BxrTnWB';
    b +=
        'y1tDNqNnf67+1s11tuN16KGwIwaoPkDKWx+hc63t4tMdYnYvZg3Os+we8HKcxlV6ANwiogDX1Ec';
    b +=
        'RPt/yetb60Ux8SgGWvq2izT0hXZtEF1j9NlZ5Uag4bOCHMIh/nriw/02o1QE+HcShMBS+519kfc';
    b +=
        'MMGS5FNjAVANdeKGF7XWz934od2FUnPQrhMRTywL6k/1OitAqE+whxAHvXdr//TacERdRXGZp5y';
    b +=
        'CiQQ/tSq65nU1n3QF1wGzCfQo6z1FfsKDZipJ6QGpehALgsZFMZBIyFl1kzOmWQVKcjAAFg+txG';
    b +=
        'zevqDGnqzI90wb0aFvAIhG075CBqg+RzuTW+D0kMlKuG1KH9IK6GgYdJAPwrEQ67op/1JbAsEeI';
    b +=
        'RQLiQnu9faY3p4egffe6PDxQsgo3N1WE57lVWNyfSJAcaEYWjkO0zn+LA5Vdb3ZwNEydNziXhZD';
    b +=
        'WYUu4wJ3K59HmE3Wus/iR6LQzBh12njnvDOKIhooxfa22rlLHXWd9Q8qCCc+DaYTfAfAJjcL3ld';
    b +=
        '4naYu8RlV6GklwspsWHBYTIYz6syA3Wgv7b9rrIHkIcEAA5p8ChBG6Egxutab2MUIsuieQyobVY';
    b +=
        '42DXR9AMcSXQFeb8wBrXo2azvdu0L3wQaz1PiXceQM1NVtBVlNchcf5ZlWAko7Ka6vObgP0WoQf';
    b +=
        '/HMFscrO1cKuta0cDiYIhJaIBwZJhm2IV94oi4d/yrbV8q3WW0S3+yi9iLP/P0d/VXbIqHRnSI+';
    b +=
        'uXzMs2NzIxqps0bjFyA+HCUX5fEmQoBpT3tm8K5K4IMcPAYEnpA7tEbv/WJu4Oa1zfQ2VqkCtsI';
    b +=
        'O0hddX5ZT6706rqeOCetqco/WwtUQh8BRPJvAOcCdf2Iy9kgFYoCjdYs7vMdd2jtrYQSwXAfnKY';
    b +=
        'HRIqD9eI3WV1EzbLaoV2CWA280VIAKX6IiKC3219czV94CNbug4DcsAwu8ca1ZUUkZjKalwHpA7';
    b +=
        'hS8aY9JHP77XGdt1jgMskNakTAtdAmesixTfL+6wxPSKFmijyo9DB2OXq6B3i/zAv13RH2PuTn2';
    b +=
        'mCFpxYaAP7YLNAZZQXP7Iq2vIw3m95XWGdeXHmZJWRvFadAFDDCIlsikgQUNg7hP3Y6k45kRwa5';
    b +=
        'gnhAz8okSc8wLcPWAd1mYkxOTfEiwR3JZBHkKNArvnJtpbtQg+4ZJcFLgo9ACT0oPVtBCn+9Nvu';
    b +=
        '9kPbXOZVixoI7ktgHFhkPwy08JhJx3YyC2tnFa24nUsaVZ6TqSdU6xhQcUKzTosfMeBzA8/3AGc';
    b +=
        'IAJBHLLvjRo0BNN3K6dbAngojhzrqXB0Ou+DRrajzmJK4WrUvyaF6j29FQz+zJnXcXTE8J8c8Jv';
    b +=
        'oz7XgEW0ebghBIktSRLiJqt/vuz63JvZBwdWxjnPq0IU/NXY86gFqQ58Lm4oHzhFVf/a2ak0Lq+';
    b +=
        '74kmKtkt9iNnrQW9GLh7RulkjbI9QKBxMaoiDB6yuprdD9OoNFBkthYBnbAJLDF6OmtIjgF5kEZ';
    b +=
        'OurIK2K7gGVdLJ+xgu6N9e1SLYOsRXyPYn1KMeLOsxbqFvEnECWUh7JPPRfbwAcw+7mt3Usuhjm';
    b +=
        'MbD+kgK0jyp63+psmASkdsscR57AWdkB+0e8WnAADLgahBGCTwSz8sv8tRFHgAmpxA8wD5NAX+t';
    b +=
        '0CcMiOQzmzHR56gcte7HcLoW07sMMd5V8jWOi+1P8WQgDrSIVdQCdIaL/c7xaUcg6kz4DhkHMnD';
    b +=
        'F/pfwuBjZVmhSHbpRSzV7eiBS/03VAKzBmmAftV/1sgNvAQkjhuxAC0gl/3uwUWRiD/04i5KhTA';
    b +=
        'c1/rdwvc4xgxTx3AEfrcdn/T7xYE7GSf2sILQEz2qfht/1uQkjqRAAEMMdcJ0Ov9bkEiO1KnmVA';
    b +=
        'R+II40e96xyyYKfdQZosAAUfOxBt9RmNuKCRgESZAEID/vDe3FidxjD2PKZ8Zj/IoJL/vldRp+q';
    b +=
        'Z1WK2kjskoor5SJwUowGH4ljWjHeUp8HM7HOazZ183wI8M2CKMoEFANX/4xqJBEAIzxx3qhhgjG';
    b +=
        'Ofb1hH9k1DzPvNz9EFyWtDkPvEFQth2ImC9Xbaxz+DiJOASMV9F5BIqQUogAX6n3y1wEE6JS5gH';
    b +=
        'zCqFht61XjF6ljASgbmQzLZng7tU/08oTPxPsyuULXRydkU1X1lfWdisXt+D4mbrkrNm5ol63vH';
    b +=
        'SynrWxmvHr2jN0wBYUIqQEdehQtiEvmfhaprN1vaWWAYDPULIdQMURohEf7SqujIowB5qygAY5z';
    b +=
        '1/4lS2IMv4HvAlDlNWfizft47bVp5s8QuYxwWjYcCQi13Xph/0p3euytOKGCJ2RCgJ0Z/6DCd2A';
    b +=
        'ifKlR37HmM6txrzPuzP6z3bc5TvncoprDIU/9latXVc7KScOkCkT7xsmuSS40k9hCmR0mU2UjKq';
    b +=
        '/Ms3RgZYMFtSlzIeugEP7b9aftdYuqOuOQBJkDpM57dyHYE/6mtFOwDqxGGzcxY5gUv+9o3H4HJ';
    b +=
        'huwHzfE6A6lP779bErnD2fJBJErxdK2RTXTanQjIycTAoSAhcBVrDNlNpnD62JvTNAJ1kDKrBQO';
    b +=
        'lhQMRmCj4w/sTaKm+5rlw2OoFEEobiOxLg0OWeF2IZ+p9a9V3YfgpxW/uxsGxtrTZ8qpMM8sPRq';
    b +=
        'C0OL0pkaFi3xIcghPcIW7DAoyx0uPsPqxsvB11JI8ZW/ZzwmYMRAa6Cg8CB8D/7UZcGJHAdrCxC';
    b +=
        'LrAj/mdWmdbrZLN1n1sHd7XSanlzNRnZpC1VTUoWzSswJbVDD/YPCF7MBxTyL2tOL/RdJ0FoI+8';
    b +=
        'qFaiWbvMHprHI9TgJXUBo0qcu+cJKEhPBUADycxmmJ7teKR2Xkdp0TsTTDmAbUSkkCQRlfhSif1';
    b +=
        'vTE3rLhDJ9T9a+N7Oa++AQ75KIEea4rlCHlnPypdVjcqJYGeX7jCseBaTk0GYI/8eaUJgYqQ92Z';
    b +=
        'pA6AsGwB2OIZCj/ax3TCyPRQas9YuSo9rj7sNxRKqBWsxQ2EtAzEEVCR6lc8FfW5G5b77oVfT5F';
    b +=
        '6PgOpQA+gHWY/bV1bP94na6CePXxDnEnXUIdGlHHc2RAkfQ2bYtObt4WjWzpYaRdOHf1hnNqCHJ';
    b +=
        'cJ2RKiyYxdllLyulywuYXphsAkdYGLloxFDwSjK9NzeyTk303hig3gEl2qaM8oCNKnHWpbRaPdk';
    b +=
        'rK7hohNTU21yf+lOo8PUC0wGAKlX6Nrk9txTq5nHiI+cJxONDOAJ2aGts+7LWGqLRlGg/GGj3lZ';
    b +=
        'qoOo49C6gLOEKelpnbtQSVgLhQaVxGo+Z/VM9r8nNQpLSCNEN/xlLvB6Sm72+OeW/P/qaRfMuJY';
    b +=
        'BgBbYXBGX1YdE8QwYEPGmXRh757Zl0rUBpZQHdEM3A30j5yVGtsVYia1wAml9aG2EWAv1+dURWw';
    b +=
        'DN8fOTs3pv3srFwUOszKQBGAbJF5AaZzRc1KTOmVMKUCmMRMcH6cdZwLQ6e6wEyJHBIKHKjvPud';
    b +=
        'u8V+elBideCIka+PzUAQVoquBnjTK2E8E8z+OwICS6ILUv8JNNytGCApguTWIVHMQEAa5YHR/tB';
    b +=
        'xG+MHV4n8KGRKOQiijA14TWogoH9CKKQPb1gaOK+EWpqh5T/LYz5AmlxrNdGXKYAx7gi1NH9rcr';
    b +=
        'QDHzvcmrImApXKTOKPV85vPwkm2+Jt8HxNaly2zfpixQ+BE2pycd5hEqLt3mHbwsNaTAfqAYmMu';
    b +=
        '3+Tuu2CZrRXEkXEFJpI7ZJu6V27ybV30j6CYC9gnscJCVHOkFwdWpqX3zEuwgogvPJ8KnXEUkqZ';
    b +=
        'Cua1Jb73fk+OpQCs/1EcgDVNJrU6g7tjidONRJZeC0PXW+giMJia5L9SFfre9KgFPbU4efg+wtr';
    b +=
        '0/xPmWf7OTn2S3d0ayGMjfCRg0iKkCs4v4NqeP6zVd2m/xygtY1eeosPMdBni0FRTemart9wTdN';
    b +=
        '26itM5yrY7SpLQHRRvQHqTk9JJ+drxZa8CM1Do9dPmdnD8kKnZEwMb67KnsTZ37oEJXaUdyU6tX';
    b +=
        'J1KWuOjgxAoopfBS6N6cO6Z0/bNVtqWhTbWMHGMNBAJKni7Ak3i2pWf3hwFqVrlrjqj3mIuCDgO';
    b +=
        'ggWyj25tbUwATSdR9uS32nsJg4mt6eOrg6T8YOqckC4ejKI2p2VqGW+qzWhwEOsF0ifeD1AOzpH';
    b +=
        'alxfcgSnGeCiNJKAqxgEoVCSPfO7mor9xJYQPi/gO1SZ6DQIASmCEeA2sSG1KT/p7nrirHrqqIJ';
    b +=
        '3BOCCD+IL34IHxiIZHN6GdkJTpEV4cQhTviBaHTqjKVpsT2AP5BM772F3hJ6eu+9J/Tee+8tdNj';
    b +=
        '73DfjN+N57903mUgoVjwa+dx33737nL3WPvus1bW0sHSUZNokIaQGVC9oAOipLmyOW0vDqXUEU/';
    b +=
        'g9USGawcSGZHpR88S+pT+/aA74H9zAxc3W0dJMflm1wrCMinBRGa+D1vKSRq4evjuf28ZrX3M9R';
    b +=
        'YoJBB5Wp6KikJd2WWeAwqps8ead4hCwlzV661mDWhXO6m9UqGfL0SfZw+oszeUDBlbzxrP7TBoT';
    b +=
        'DxRmJ9dWW+Cd7IpxMEswAPaAH2UuDPB4d2UzhvCSTyHHLIQTWTnF2FWjp7IH3hKZzswFx7nIV3d';
    b +=
        '5phFpanYo36vRw/OaZhwnXyAewBwcTHmTEuXp2qZs9NnZtr4KUYs2dgU9IrQK+rpGDqnPxKUdFw';
    b +=
        'NZz0nI8oxbNAy8vpkYNgzbrg5t16CjCEUVD0kZdZze0Ighg5dGWQNTgtLEUYHTinJj47op6+LtS';
    b +=
        'kalQCHnIIDc5Zu6vEFAxDzllBUHRsi8v7mxw7pvZ9ATqyerpwRlQgF1BfIOr9HdMnzoIjpg9YYC';
    b +=
        'T6UcmIyOvBgVxK3L7KMHsm5rxJpkt7aStOSoKiCVrEqgrrhsnVK3N885fGNuxUbMinyx9XknntP';
    b +=
        'r7dl+zlLywLZ5B6uhMxbth/gdzanrcH3v6Z8JlWF6ZCYjUzrpO5tnrrnCLoalsy2Ze1gGcQZSEz';
    b +=
        'xPd23gp9/d7Gi3k/o0peoxlZxGTXPlbPAqhEjRfVvcMwgK+mVDOUhLWaM9ojOBOevvbdSQ8J+d9';
    b +=
        'RAdVT8bUpFWmI4UcPDk72vOGL+U2v6wVEuVImbtIdOG7HB74f61Z+Jy115rBJF5tIKhxiFFXCof';
    b +=
        'GGMmRsWMS9FbVBLJxj/YrKMVp7+v3JiUs3OKFiUTd+GzzZaVxY/2vFGfRDo3WOCMeIzClmw/14w';
    b +=
        'l20fREApQlE5SUvf5dd1+v9AA4KQAuQVWJYHFti80T+4DDz6lyarDg7WDhfmq6fPF5hG3eGkfWZ';
    b +=
        '1S0wUtfYArFyPwkJP+0hKcWpODrOGyVDlcCjEwT4Pm3qbw5eZZo7DwMgxYtG051FEKSNgreFYQq';
    b +=
        'OIrzakDLzFC/LQ6Gysto0YBHsvsV5sL/v+cqc6ti7gtDOIDzRRUdvxrzYs7P7cNkL+f1jQ7yiA0';
    b +=
        'PZcAqdPXm/OO3NoXMRjky5I6fb/vw7X9e/d952srwe+zWoPf9sKvdzRuZFwCsbPRoBNqRL2c8I2';
    b +=
        'HH1Pf3MCY+tYGXuvbzZNWsLKe1n0L+b7TgYoCGvGsoF9DRMvp73ZF6XjQVkc8BKgCsN/wvSEF+L';
    b +=
        'VbN6rSFcx9yHkmCICLkn+/OW4lftk/jc7Yvfbu5AvA5gSRHwyL9AdNVxs8P3dgcq7nFTRdlMMmq';
    b +=
        'mi0ipQG+sPRD0k7jeL0gPSSgrjKPxoLryttneZBs+isiFL9eKzRWqdA0XOhSB5skT9p+LDM3hPX';
    b +=
        'FI4DzYuaJmsZZT8dityXwTcQNWEKvNekBDpE/KxxQ1M+gErkYHuruZmwSuQSjC8WXWZ+PmIs1tb';
    b +=
        'KjJ/aV3fusgPkKAH5aK8s+0XTcdu2oCEXMNMobALsY385Du4PPCYTOTryCGrZr5ptK2ubvfbtvn';
    b +=
        'k1MbF3/7K8ONrIUYxemwMQRvHrRoweP02FKgb7q3gyArL7b5qjYf5O4Qb6b8e4eYgpLgqaWxfAK';
    b +=
        'yX+bpyxBRtXIBojBYYX2e/HeWjoIq+BWpukvMziD0sZv6uBUO1gdypbDlMZUDst8Y/NCeOYIdUS';
    b +=
        'DAojc9RXzqxk+admW3cnpLZxKGgAVY4WG7KRf+4ab9wmmWhgykK4ep//0nUg0CKULJTJQs4UnP2';
    b +=
        '1c4QbyO5YMc8MdSPUQ43AAuAI5sFLLhCcSdiIr0n/bfQaB8+UI+OQkUYIDfb35qhWnvgf7Q8LB/';
    b +=
        '7ZPAZ+mJ1/Qf5X/RWwiH8DVz5rteBujxwtX1laF2KMElAijd7l/3QaBBzClRgzjS5kof/brPPwD';
    b +=
        'NN9NSnGYkySe2BLhjEtD5JtqxrWgIohaz6p/g1TAY2rcpXqrQoaJqjAjHSOekhG8iXkjMN2l3dj';
    b +=
        'r1pccYp/2B4GFr0BAgfnnRdAVV5Kth3W57Dr5FMmT9t18tk7T5mYmHzu9p24BQH/qD2nLJyzOkY';
    b +=
        'lpKaAyF5G9GEHFE/fMbl719lnnnRK/0AVvPZJKoOmJTGKl5NxhXhPz1O1tjhVa4taJVSs1BINOe';
    b +=
        'MryIA9fMwZswtV3QUoDbYjGKsluifxVxK+xPOnerqYO3buOnHV940AfnyhXheNxbNXkc1rFQdgt';
    b +=
        'Ziq3ciFZwBLtLic4fGG9GoyWvZilaR9CSxxhv5XArVs7WvI4/oUF15L3LDcOrO4D7h1acvBTujs';
    b +=
        'AEAkA6uHzfZ1ZFhpbBbzct9gVQBMFRMkl7CcxNeTYUkdqGHVGJ/GLrgks/NUJzwK+QaihwyrxdR';
    b +=
        '2oDRFKBmLl5aiF84bCR2QJ9ocgSAgpxg5YFMnfeEsvImYAUNOww3GmlnarUavgkgsMw+5AV6UeT';
    b +=
        'NZvzcWj3gSsEBAJucTfQuRQ2cU2ljWDbWEBrWUQj41nKq3kqesjkZYDIJwMhQDaIdmLd9G1jR+Q';
    b +=
        'N/3euBqOQqTNA5wtubO+eBoejtRa52JbV9GTVOLe2th0wmaguIQLxGF9t9B1oGyi5A0AwykKPgP';
    b +=
        'E/Wd5PFt/Paqhu9aOyL6ejRRMrteSChOjUHOZ6PQ540cuFCVhKYpmu8BRhI5aclpeTc5fkXluS1';
    b +=
        'U75kr870O5lPrj7N53z4/1Tv2zoDuMAqTpiSe30NO6HKBuu/ck+WP3FpdhIY78Jar95LtXa4Q/Z';
    b +=
        'KMWnW6ArSpOMQI5Tyo+D7SzMxP8fcT1s+ZgG1MTGyfw2yMhqSTe6pQW8oMDyJQQH4yafYB0nEbR';
    b +=
        'ZdkEi8wRgkfovgg6UjQtGNasYKNqUGLqD9EnrYy5A6ZE4kCIZlDgJcKIRE+3PUj4HUwEWCe8ZAp';
    b +=
        'ROpHun6pDK8T2BSHzMWz4OWjHZ4gzT4mB6lXGFhDRTq/wxh41sYoB58hDQx2F5BN7U7J3nncG4N';
    b +=
        'RYb46WkadUAsHEDWn8KDjx8gTerS6BbE1Oj5Otg5bOTOsRgvYyDxdd9Gn4YEqKxmKuHE0XP8Esc';
    b +=
        'MW+zx7aKlPQO69RPX/mBgr6pPEjJhoyx2wqmCkALCFecaT/RQZW7dzb65+PtMuocJHQNG2UOCbf';
    b +=
        'JrsHPdStTkXOHi7wkPOVtZzbFT11n+G7FjP5arDBnyxDP9RgDxWyQvJ7nGvhNN6b8bK+/L9BcD0';
    b +=
        'gIE5TdzKEvxF5Mx1KZ76/bk9tltbOyDAbfCy2ipLky4e/xkuwAo42eP1VBjqk4G1N0abXb6kwxz';
    b +=
        'IhTk8WsFxO09Idik5eWAKGSRgUY+QRYWOB5nlAM8nXTbkMgO86OrhpOAZPAcPk9JLl8LlpFstbL';
    b +=
        'Umea3RYeUzApWMnCmf/BXkwSOH98A8gqXJjaipIojWTqWgM4pN6ivJvkeqF+ZQ4XQa1sUQrC+GF';
    b +=
        'UCVIV21ga/kavLsIe1Cc/vmZ5ZUkHp71a1JJ/y/FjvRoAWb8jVXVrN8zRICXeNqreYHLOQWrUAK';
    b +=
        'yyVnVcS1Q4Ys9oYwZiPkWFkcD1Lq6wgbOGRTK/U+nSzDIxAOSG32sFpcT3YOP942WD6uFtNNkcF';
    b +=
        '4CxAdvZTYDUNewaYhpxfrMTVdJMBezSUsj4KzG8m6dedZzMxKmXVWTFjLbiLPX49MyKpTaZuWGp';
    b +=
        'hcMkx67wGuQ3oU4uYOD14IEZymCgigioanW4gYPKYVYcKJpZ1JmRaULAUwZW7tClSYT6Xu36L+C';
    b +=
        'Lyi28i2Ee1vh85r1K+oqOVC+CioU5br2zvdLqMR+yRdQmmCENkdDy+6pHAZGAAsKQBEjIp3dv32';
    b +=
        'NgQmRYqwIkUG6Puu9YcS0I9EEZZEaj3Q6Lu73kMSaCZnAcFxEVT294z5BnxS6PgUjDaomiXuJTs';
    b +=
        'GvwGsyg+kUYxxZgHxAhSCPOjFfV2/gilaOMjB1AgbC4/3kz3Db6GD7dRa21bHVwbuabC42R0inv';
    b +=
        'Z4gMwP/qwBosnzC3uqaHL9e+sgEcOlT4xe2uRjRBsXmqQ+4qGDBw8e8ViA2GkxwgUfdfSMn5taB';
    b +=
        'BRzZHMmIOojjumh75w2hwOPJoiy41PZFs230M1ze6am988cOPbpqEtsAd2ZYwHG8s1UwZ9nHPVC';
    b += 'PwP//Ci6hbkt9BhMfpt7dAZ+x7cY9z9z2wK4';
    var input = pako.inflate(base64ToUint8Array(b));
    return initNodejs(input);
}
exports.initWasmEcdsaSdkNodejs = initWasmEcdsaSdkNodejs;
//# sourceMappingURL=ecdsa-sdk.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/encryption/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/encryption/src/lib/encryption.js"), exports);
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/encryption/src/lib/params-validators.js"), exports);
// ----- autogen:polyfills:start  -----
// This field will be automatically injected into the ./dist/packages/<package-name>/index.js file
// between the autogen:polyfills:start/end comments

try {
  globalThis.crypto = (__webpack_require__("../../node_modules/crypto-browserify/index.js").webcrypto);
} catch (e) {
  // swallow
}

// ----- autogen:polyfills:end  -----
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/encryption/src/lib/encryption.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.verifyJwt = exports.decryptFile = exports.encryptFile = exports.decryptZipFileWithMetadata = exports.encryptFileAndZipWithMetadata = exports.encryptZip = exports.decryptZip = exports.zipAndEncryptFiles = exports.zipAndEncryptString = exports.decryptString = exports.encryptString = exports.decryptFromIpfs = exports.encryptToIpfs = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const bls_sdk_1 = __webpack_require__("../../node_modules/@lit-protocol/bls-sdk/src/index.js");
// @ts-ignore
const JSZip = __webpack_require__("?e6da");
const uint8arrays_1 = __webpack_require__("../../node_modules/@lit-protocol/uint8arrays/src/index.js");
const crypto_1 = __webpack_require__("../../node_modules/@lit-protocol/crypto/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const params_validators_1 = __webpack_require__("../../node_modules/@lit-protocol/encryption/src/lib/params-validators.js");
// The following line is automatically modified by encryption/postbuild.mjs
  let ipfsClient = null;
  try{
    ipfsClient = __webpack_require__("?2209");
  }catch(e){
    console.log("ipfs-http-client is not supported in this environment!");
  }
  // The above line is automatically modified by encryption/postbuild.mjs
// ---------- Local Helpers ----------
/**
 *
 * Get all the metadata needed to decrypt something in the future.  If you're encrypting files with Lit and storing them in IPFS or Arweave, then this function will provide you with a properly formatted metadata object that you should save alongside the files.
 *
 * @param { MetadataForFile }
 *
 * @return { MetadataForFile }
 *
 */
const metadataForFile = ({ name, type, size, accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions, chain, encryptedSymmetricKey, }) => {
    return {
        name,
        type,
        size,
        accessControlConditions,
        evmContractConditions,
        solRpcConditions,
        unifiedAccessControlConditions,
        chain,
        encryptedSymmetricKey: (0, uint8arrays_1.uint8arrayToString)(encryptedSymmetricKey, 'base16'),
    };
};
/**
 *
 * Encrypt a string or file, save the key to the Lit network, and upload all the metadata required to decrypt i.e. accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions & chain to IPFS using the ipfs-client-http SDK & returns the IPFS CID.
 *
 * @param { EncryptToIpfsProps }
 *
 * @returns { Promise<string> }
 *
 */
const encryptToIpfs = async ({ authSig, sessionSigs, accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions, chain, string, file, litNodeClient, infuraId, infuraSecretKey, }) => {
    // -- validate
    const paramsIsSafe = (0, params_validators_1.safeParams)({
        functionName: 'encryptToIpfs',
        params: {
            authSig,
            sessionSigs,
            accessControlConditions,
            evmContractConditions,
            solRpcConditions,
            unifiedAccessControlConditions,
            chain,
            string,
            file,
            litNodeClient,
        },
    });
    if (!paramsIsSafe)
        return (0, misc_1.throwError)({
            message: `authSig, sessionSigs, accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions, chain, litNodeClient, string or file must be provided`,
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    if (string === undefined && file === undefined)
        return (0, misc_1.throwError)({
            message: `Either string or file must be provided`,
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    if (!infuraId || !infuraSecretKey) {
        return (0, misc_1.throwError)({
            message: 'Please provide your Infura Project Id and Infura API Key Secret to add the encrypted metadata on IPFS',
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    }
    let encryptedData;
    let symmetricKey;
    if (string !== undefined && file !== undefined) {
        return (0, misc_1.throwError)({
            message: 'Provide only either a string or file to encrypt',
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    }
    else if (string !== undefined) {
        const encryptedString = await (0, exports.encryptString)(string);
        encryptedData = encryptedString.encryptedString;
        symmetricKey = encryptedString.symmetricKey;
    }
    else {
        const encryptedFile = await (0, exports.encryptFile)({ file: file });
        encryptedData = encryptedFile.encryptedFile;
        symmetricKey = encryptedFile.symmetricKey;
    }
    const encryptedSymmetricKey = await litNodeClient.saveEncryptionKey({
        accessControlConditions,
        evmContractConditions,
        solRpcConditions,
        unifiedAccessControlConditions,
        symmetricKey,
        authSig,
        sessionSigs,
        chain,
    });
    (0, misc_1.log)('encrypted key saved to Lit', encryptedSymmetricKey);
    const encryptedSymmetricKeyString = (0, uint8arrays_1.uint8arrayToString)(encryptedSymmetricKey, 'base16');
    const authorization = 'Basic ' + Buffer.from(`${infuraId}:${infuraSecretKey}`).toString('base64');
    const ipfs = ipfsClient.create({
        url: 'https://ipfs.infura.io:5001/api/v0',
        headers: {
            authorization,
        },
    });
    const encryptedDataJson = Buffer.from(await encryptedData.arrayBuffer()).toJSON();
    try {
        const res = await ipfs.add(JSON.stringify({
            [string !== undefined ? 'encryptedString' : 'encryptedFile']: encryptedDataJson,
            encryptedSymmetricKeyString,
            accessControlConditions,
            evmContractConditions,
            solRpcConditions,
            unifiedAccessControlConditions,
            chain,
        }));
        return res.path;
    }
    catch (e) {
        return (0, misc_1.throwError)({
            message: "Provided INFURA_ID or INFURA_SECRET_KEY in invalid hence can't upload to IPFS",
            errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
        });
    }
};
exports.encryptToIpfs = encryptToIpfs;
/**
 *
 * Decrypt & return the string or file (in Uint8Array format) using its metadata stored on IPFS with the given ipfsCid.
 *
 * @param { DecryptFromIpfsProps }
 *
 * @returns { Promise<string | Uint8Array> }
 *
 */
const decryptFromIpfs = async ({ authSig, sessionSigs, ipfsCid, litNodeClient, }) => {
    // -- validate
    const paramsIsSafe = (0, params_validators_1.safeParams)({
        functionName: 'decryptFromIpfs',
        params: {
            authSig,
            sessionSigs,
            ipfsCid,
            litNodeClient,
        },
    });
    if (!paramsIsSafe)
        return (0, misc_1.throwError)({
            message: `authSig, sessionSigs, ipfsCid, litNodeClient must be provided`,
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    try {
        const metadata = await (await fetch(`https://gateway.pinata.cloud/ipfs/${ipfsCid}`)).json();
        const symmetricKey = await litNodeClient.getEncryptionKey({
            accessControlConditions: metadata.accessControlConditions,
            evmContractConditions: metadata.evmContractConditions,
            solRpcConditions: metadata.solRpcConditions,
            unifiedAccessControlConditions: metadata.unifiedAccessControlConditions,
            toDecrypt: metadata.encryptedSymmetricKeyString,
            chain: metadata.chain,
            authSig,
            sessionSigs,
        });
        if (metadata.encryptedString !== undefined) {
            const encryptedStringBlob = new Blob([Buffer.from(metadata.encryptedString)], { type: 'application/octet-stream' });
            return await (0, exports.decryptString)(encryptedStringBlob, symmetricKey);
        }
        const encryptedFileBlob = new Blob([Buffer.from(metadata.encryptedFile)], {
            type: 'application/octet-stream',
        });
        return await (0, exports.decryptFile)({ file: encryptedFileBlob, symmetricKey });
    }
    catch (e) {
        return (0, misc_1.throwError)({
            message: 'Invalid ipfsCid',
            errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
        });
    }
};
exports.decryptFromIpfs = decryptFromIpfs;
// ---------- Local Helpers ----------
/**
 *
 * Encrypt a string.  This is used to encrypt any string that is to be locked via the Lit Protocol.
 *
 * @param { string } str The string to encrypt
 * @returns { Promise<Object> } A promise containing the encryptedString as a Blob and the symmetricKey used to encrypt it, as a Uint8Array.
 */
const encryptString = async (str) => {
    // -- validate
    if (!(0, misc_1.checkType)({
        value: str,
        allowedTypes: ['String'],
        paramName: 'str',
        functionName: 'encryptString',
    })) {
        return (0, misc_1.throwError)({
            message: `{${str}} must be a string`,
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    }
    // -- prepare
    const encodedString = (0, uint8arrays_1.uint8arrayFromString)(str, 'utf8');
    const symmKey = await (0, crypto_1.generateSymmetricKey)();
    const encryptedString = await (0, crypto_1.encryptWithSymmetricKey)(symmKey, encodedString.buffer);
    const exportedSymmKey = new Uint8Array(await crypto.subtle.exportKey('raw', symmKey));
    return {
        symmetricKey: exportedSymmKey,
        encryptedString,
        encryptedData: encryptedString,
    };
};
exports.encryptString = encryptString;
/**
 *
 * Decrypt a string that was encrypted with the encryptString function.
 *
 * @param { AcceptedFileType } encryptedStringBlob The encrypted string as a Blob
 * @param { Uint8Array } symmKey The symmetric key used that will be used to decrypt this.
 *
 * @returns { Promise<string> } A promise containing the decrypted string
 */
const decryptString = async (encryptedStringBlob, symmKey) => {
    // -- validate
    const paramsIsSafe = (0, params_validators_1.safeParams)({
        functionName: 'decryptString',
        params: [encryptedStringBlob, symmKey],
    });
    if (!paramsIsSafe) {
        (0, misc_1.throwError)({
            message: 'Invalid params',
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    }
    // -- import the decrypted symm key
    const importedSymmKey = await (0, crypto_1.importSymmetricKey)(symmKey);
    const decryptedStringArrayBuffer = await (0, crypto_1.decryptWithSymmetricKey)(encryptedStringBlob, importedSymmKey);
    return (0, uint8arrays_1.uint8arrayToString)(new Uint8Array(decryptedStringArrayBuffer), 'utf8');
};
exports.decryptString = decryptString;
/**
 *
 * Zip and encrypt a string.  This is used to encrypt any string that is to be locked via the Lit Protocol.
 *
 * @param { string } string The string to zip and encrypt
 *
 * @returns { Promise<Object> } A promise containing the encryptedZip as a Blob and the symmetricKey used to encrypt it, as a Uint8Array.  The encrypted zip will contain a single file called "string.txt"
 */
const zipAndEncryptString = async (string) => {
    // -- validate
    if (!(0, misc_1.checkType)({
        value: string,
        allowedTypes: ['String'],
        paramName: 'string',
        functionName: 'zipAndEncryptString',
    }))
        (0, misc_1.throwError)({
            message: 'Invalid string',
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    let zip;
    try {
        zip = new JSZip.default();
    }
    catch (e) {
        zip = new JSZip();
    }
    zip.file('string.txt', string);
    return (0, exports.encryptZip)(zip);
};
exports.zipAndEncryptString = zipAndEncryptString;
/**
 *
 * Zip and encrypt multiple files.
 *
 * @param { Array<File> } files An array of the files you wish to zip and encrypt
 *
 * @returns {Promise<Object>} A promise containing the encryptedZip as a Blob and the symmetricKey used to encrypt it, as a Uint8Array.  The encrypted zip will contain a folder "encryptedAssets" and all of the files will be inside it.
 
*/
const zipAndEncryptFiles = async (files) => {
    // let's zip em
    let zip;
    try {
        zip = new JSZip.default();
    }
    catch (e) {
        zip = new JSZip();
    }
    // -- zip each file
    for (let i = 0; i < files.length; i++) {
        // -- validate
        if (!(0, misc_1.checkType)({
            value: files[i],
            allowedTypes: ['File'],
            paramName: `files[${i}]`,
            functionName: 'zipAndEncryptFiles',
        }))
            (0, misc_1.throwError)({
                message: 'Invalid file type',
                errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
            });
        const folder = zip.folder('encryptedAssets');
        if (!folder) {
            (0, misc_1.log)("Failed to get 'encryptedAssets' from zip.folder() ");
            return (0, misc_1.throwError)({
                message: "Failed to get 'encryptedAssets' from zip.folder() ",
                errorKind: constants_1.LIT_ERROR.UNKNOWN_ERROR.kind,
                errorCode: constants_1.LIT_ERROR.UNKNOWN_ERROR.name,
            });
        }
        folder.file(files[i].name, files[i]);
    }
    return (0, exports.encryptZip)(zip);
};
exports.zipAndEncryptFiles = zipAndEncryptFiles;
/**
 *
 * Decrypt and unzip a zip that was created using encryptZip, zipAndEncryptString, or zipAndEncryptFiles.
 *
 * @param { AcceptedFileType } encryptedZipBlob The encrypted zip as a Blob
 * @param { SymmetricKey } symmKey The symmetric key used that will be used to decrypt this zip.
 *
 * @returns { Promise<Object> } A promise containing a JSZip object indexed by the filenames of the zipped files.  For example, if you have a file called "meow.jpg" in the root of your zip, you could get it from the JSZip object by doing this: const imageBlob = await decryptedZip['meow.jpg'].async('blob')
 */
const decryptZip = async (encryptedZipBlob, symmKey) => {
    // -- validate
    const paramsIsSafe = (0, params_validators_1.safeParams)({
        functionName: 'decryptZip',
        params: {
            encryptedZipBlob,
            symmKey,
        },
    });
    if (!paramsIsSafe) {
        (0, misc_1.throwError)({
            message: `encryptedZipBlob must be a Blob or File. symmKey must be a Uint8Array`,
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    }
    // import the decrypted symm key
    const importedSymmKey = await (0, crypto_1.importSymmetricKey)(symmKey);
    const decryptedZipArrayBuffer = await (0, crypto_1.decryptWithSymmetricKey)(encryptedZipBlob, importedSymmKey);
    // unpack the zip
    let zip;
    try {
        zip = new JSZip.default();
    }
    catch (e) {
        zip = new JSZip();
    }
    const unzipped = await zip.loadAsync(decryptedZipArrayBuffer);
    return unzipped.files;
};
exports.decryptZip = decryptZip;
/**
 *
 * Encrypt a zip file created with JSZip using a new random symmetric key via WebCrypto.
 *
 * @param { JSZip } zip The JSZip instance to encrypt
 *
 * @returns { Promise<Object> } A promise containing the encryptedZip as a Blob and the symmetricKey used to encrypt it, as a Uint8Array string.
 */
const encryptZip = async (zip) => {
    let zipBlob;
    let zipBlobArrayBuffer;
    if ((0, misc_1.isBrowser)()) {
        zipBlob = await zip.generateAsync({ type: 'blob' });
        zipBlobArrayBuffer = await zipBlob.arrayBuffer();
    }
    else {
        zipBlobArrayBuffer = await zip.generateAsync({ type: 'nodebuffer' });
    }
    const symmKey = await (0, crypto_1.generateSymmetricKey)();
    const encryptedZipBlob = await (0, crypto_1.encryptWithSymmetricKey)(symmKey, zipBlobArrayBuffer);
    // to download the encrypted zip file for testing, uncomment this
    // saveAs(encryptedZipBlob, 'encrypted.bin')
    const exportedSymmKey = new Uint8Array(await crypto.subtle.exportKey('raw', symmKey));
    const encryptedZip = {
        symmetricKey: exportedSymmKey,
        encryptedZip: encryptedZipBlob,
    };
    return encryptedZip;
};
exports.encryptZip = encryptZip;
/**
 *
 * Encrypt a single file, save the key to the Lit network, and then zip it up with the metadata.
 *
 * @param { EncryptFileAndZipWithMetadataProps }
 *
 * @returns { Promise<ThreeKeys> }
 *
 */
const encryptFileAndZipWithMetadata = async ({ authSig, sessionSigs, accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions, chain, file, litNodeClient, readme, }) => {
    // -- validate
    const paramsIsSafe = (0, params_validators_1.safeParams)({
        functionName: 'encryptFileAndZipWithMetadata',
        params: {
            authSig,
            sessionSigs,
            accessControlConditions,
            evmContractConditions,
            solRpcConditions,
            unifiedAccessControlConditions,
            chain,
            file,
            litNodeClient,
            readme,
        },
    });
    if (!paramsIsSafe)
        return (0, misc_1.throwError)({
            message: `authSig, sessionSigs, accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions, chain, file, litNodeClient, and readme must be provided`,
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    // -- validate
    const symmetricKey = await (0, crypto_1.generateSymmetricKey)();
    const exportedSymmKey = new Uint8Array(await crypto.subtle.exportKey('raw', symmetricKey));
    // log('exportedSymmKey in hex', uint8arrayToString(exportedSymmKey, 'base16'))
    const encryptedSymmetricKey = await litNodeClient.saveEncryptionKey({
        accessControlConditions,
        evmContractConditions,
        solRpcConditions,
        unifiedAccessControlConditions,
        symmetricKey: exportedSymmKey,
        authSig,
        sessionSigs,
        chain,
    });
    (0, misc_1.log)('encrypted key saved to Lit', encryptedSymmetricKey);
    // encrypt the file
    var fileAsArrayBuffer = await file.arrayBuffer();
    const encryptedZipBlob = await (0, crypto_1.encryptWithSymmetricKey)(symmetricKey, fileAsArrayBuffer);
    let zip;
    try {
        zip = new JSZip.default();
    }
    catch (e) {
        zip = new JSZip();
    }
    const metadata = metadataForFile({
        name: file.name,
        type: file.type,
        size: file.size,
        encryptedSymmetricKey,
        accessControlConditions,
        evmContractConditions,
        solRpcConditions,
        unifiedAccessControlConditions,
        chain,
    });
    zip.file('lit_protocol_metadata.json', JSON.stringify(metadata));
    if (readme) {
        zip.file('readme.txt', readme);
    }
    const folder = zip.folder('encryptedAssets');
    if (!folder) {
        (0, misc_1.log)("Failed to get 'encryptedAssets' from zip.folder() ");
        return (0, misc_1.throwError)({
            message: `Failed to get 'encryptedAssets' from zip.folder()`,
            errorKind: constants_1.LIT_ERROR.UNKNOWN_ERROR.kind,
            errorCode: constants_1.LIT_ERROR.UNKNOWN_ERROR.name,
        });
    }
    folder.file(file.name, encryptedZipBlob);
    const zipBlob = await zip.generateAsync({ type: 'blob' });
    const threeKeys = {
        zipBlob,
        encryptedSymmetricKey,
        symmetricKey: exportedSymmKey,
    };
    return threeKeys;
};
exports.encryptFileAndZipWithMetadata = encryptFileAndZipWithMetadata;
/**
 *
 * Given a zip file with metadata inside it, unzip, load the metadata, and return the decrypted file and the metadata.  This zip file would have been created with the encryptFileAndZipWithMetadata function.
 *
 * @param { DecryptZipFileWithMetadataProps }
 *
 * @returns { Promise<DecryptZipFileWithMetadata> } A promise containing an object that contains decryptedFile and metadata properties.  The decryptedFile is an ArrayBuffer that is ready to use, and metadata is an object that contains all the properties of the file like it's name and size and type.
 */
const decryptZipFileWithMetadata = async ({ authSig, sessionSigs, file, litNodeClient, additionalAccessControlConditions, }) => {
    // -- validate
    const paramsIsSafe = (0, params_validators_1.safeParams)({
        functionName: 'decryptZipFileWithMetadata',
        params: {
            authSig,
            sessionSigs,
            file,
            litNodeClient,
            additionalAccessControlConditions,
        },
    });
    if (!paramsIsSafe)
        return;
    // -- execute
    const zip = await JSZip.loadAsync(file);
    const jsonFile = zip.file('lit_protocol_metadata.json');
    if (!jsonFile) {
        (0, misc_1.log)(`Failed to read lit_protocol_metadata.json while zip.file()`);
        return;
    }
    const metadata = JSON.parse(await jsonFile.async('string'));
    (0, misc_1.log)('zip metadata', metadata);
    let symmKey;
    try {
        symmKey = await litNodeClient.getEncryptionKey({
            accessControlConditions: metadata.accessControlConditions,
            evmContractConditions: metadata.evmContractConditions,
            solRpcConditions: metadata.solRpcConditions,
            unifiedAccessControlConditions: metadata.unifiedAccessControlConditions,
            toDecrypt: metadata.encryptedSymmetricKey,
            chain: metadata.chain,
            authSig,
            sessionSigs,
        });
    }
    catch (e) {
        if (e.errorCode === 'NodeNotAuthorized' ||
            e.errorCode === 'not_authorized') {
            // try more additionalAccessControlConditions
            if (!additionalAccessControlConditions) {
                throw e;
            }
            (0, misc_1.log)('trying additionalAccessControlConditions');
            // -- loop start
            for (let i = 0; i < additionalAccessControlConditions.length; i++) {
                const accessControlConditions = additionalAccessControlConditions[i].accessControlConditions;
                (0, misc_1.log)('trying additional condition', accessControlConditions);
                try {
                    symmKey = await litNodeClient.getEncryptionKey({
                        accessControlConditions: accessControlConditions,
                        toDecrypt: additionalAccessControlConditions[i].encryptedSymmetricKey,
                        chain: metadata.chain,
                        authSig,
                        sessionSigs,
                    });
                    // okay we got the additional symmkey, now we need to decrypt the symmkey and then use it to decrypt the original symmkey
                    // const importedAdditionalSymmKey = await importSymmetricKey(symmKey)
                    // symmKey = await decryptWithSymmetricKey(additionalAccessControlConditions[i].encryptedSymmetricKey, importedAdditionalSymmKey)
                    break; // it worked, we can leave the loop and stop checking additional access control conditions
                }
                catch (e) {
                    // swallow not_authorized because we are gonna try some more accessControlConditions
                    if (e.errorCode === 'NodeNotAuthorized' ||
                        e.errorCode === 'not_authorized') {
                        throw e;
                    }
                }
            }
            // -- loop ends
            if (!symmKey) {
                // we tried all the access control conditions and none worked
                throw e;
            }
        }
        else {
            throw e;
        }
    }
    if (!symmKey) {
        return;
    }
    const importedSymmKey = await (0, crypto_1.importSymmetricKey)(symmKey);
    const folder = zip.folder('encryptedAssets');
    if (!folder) {
        (0, misc_1.log)("Failed to get 'encryptedAssets' from zip.folder() ");
        return;
    }
    const _file = folder.file(metadata.name);
    if (!_file) {
        (0, misc_1.log)("Failed to get 'metadata.name' while zip.folder().file()");
        return;
    }
    const encryptedFile = await _file.async('blob');
    const decryptedFile = await (0, crypto_1.decryptWithSymmetricKey)(encryptedFile, importedSymmKey);
    const data = { decryptedFile, metadata };
    return data;
};
exports.decryptZipFileWithMetadata = decryptZipFileWithMetadata;
/**
 *
 * Encrypt a file without doing any zipping or packing.  This is useful for large files.  A 1gb file can be encrypted in only 2 seconds, for example.  A new random symmetric key will be created and returned along with the encrypted file.
 *
 * @param { Object } params
 * @param { AcceptedFileType } params.file The file you wish to encrypt
 *
 * @returns { Promise<Object> } A promise containing an object with keys encryptedFile and symmetricKey.  encryptedFile is a Blob, and symmetricKey is a Uint8Array that can be used to decrypt the file.
 */
const encryptFile = async ({ file, }) => {
    // -- validate
    if (!(0, misc_1.checkType)({
        value: file,
        allowedTypes: ['Blob', 'File'],
        paramName: 'file',
        functionName: 'encryptFile',
    })) {
        return (0, misc_1.throwError)({
            message: 'file must be a Blob or File',
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    }
    // generate a random symmetric key
    const symmetricKey = await (0, crypto_1.generateSymmetricKey)();
    const exportedSymmKey = new Uint8Array(await crypto.subtle.exportKey('raw', symmetricKey));
    // encrypt the file
    var fileAsArrayBuffer = await file.arrayBuffer();
    const encryptedFile = await (0, crypto_1.encryptWithSymmetricKey)(symmetricKey, fileAsArrayBuffer);
    const _encryptedFile = {
        encryptedFile,
        symmetricKey: exportedSymmKey,
    };
    return _encryptedFile;
};
exports.encryptFile = encryptFile;
/**
 *
 * Decrypt a file that was encrypted with the encryptFile function, without doing any unzipping or unpacking.  This is useful for large files.  A 1gb file can be decrypted in only 1 second, for example.
 *
 * @property { Object } params
 * @property { AcceptedFileType } params.file The file you wish to decrypt
 * @property { Uint8Array } params.symmetricKey The symmetric key used that will be used to decrypt this.
 *
 * @returns { Promise<Object> } A promise containing the decrypted file.  The file is an ArrayBuffer.
 */
const decryptFile = async ({ file, symmetricKey, }) => {
    // -- validate
    const paramsIsSafe = (0, params_validators_1.safeParams)({
        functionName: 'decryptFile',
        params: {
            file,
            symmetricKey,
        },
    });
    if (!paramsIsSafe) {
        return (0, misc_1.throwError)({
            message: `file type must be Blob or File, and symmetricKey type must be Uint8Array | string | CryptoKey | BufferSource`,
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    }
    // -- execute
    const importedSymmKey = await (0, crypto_1.importSymmetricKey)(symmetricKey);
    // decrypt the file
    const decryptedFile = await (0, crypto_1.decryptWithSymmetricKey)(file, importedSymmKey);
    return decryptedFile;
};
exports.decryptFile = decryptFile;
/**
 * // TODO check for expiration
 *
 * Verify a JWT from the LIT network.  Use this for auth on your server.  For some background, users can define resources (URLs) for authorization via on-chain conditions using the saveSigningCondition function.  Other users can then request a signed JWT proving that their ETH account meets those on-chain conditions using the getSignedToken function.  Then, servers can verify that JWT using this function.  A successful verification proves that the user meets the on-chain conditions defined in the saveSigningCondition step.  For example, the on-chain condition could be posession of a specific NFT.
 *
 * @param { VerifyJWTProps } jwt
 *
 * @returns { IJWT } An object with 4 keys: "verified": A boolean that represents whether or not the token verifies successfully.  A true result indicates that the token was successfully verified.  "header": the JWT header.  "payload": the JWT payload which includes the resource being authorized, etc.  "signature": A uint8array that represents the raw  signature of the JWT.
 */
const verifyJwt = ({ jwt }) => {
    // -- validate
    if (!(0, misc_1.checkType)({
        value: jwt,
        allowedTypes: ['String'],
        paramName: 'jwt',
        functionName: 'verifyJwt',
    }))
        return (0, misc_1.throwError)({
            message: 'jwt must be a string',
            errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
            errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
        });
    (0, misc_1.log)('verifyJwt', jwt);
    // verify that the wasm was loaded
    if (!globalThis.wasmExports) {
        (0, misc_1.log)('wasmExports is not loaded.');
    }
    const pubKey = (0, uint8arrays_1.uint8arrayFromString)(constants_1.NETWORK_PUB_KEY, 'base16');
    // log("pubkey is ", pubKey);
    const jwtParts = jwt.split('.');
    const sig = (0, uint8arrays_1.uint8arrayFromString)(jwtParts[2], 'base64url');
    // log("sig is ", uint8arrayToString(sig, "base16"));
    const unsignedJwt = `${jwtParts[0]}.${jwtParts[1]}`;
    // log("unsignedJwt is ", unsignedJwt);
    const message = (0, uint8arrays_1.uint8arrayFromString)(unsignedJwt);
    // log("message is ", message);
    // p is public key uint8array
    // s is signature uint8array
    // m is message uint8array
    // function is: function (p, s, m)
    const verified = Boolean(bls_sdk_1.wasmBlsSdkHelpers.verify(pubKey, sig, message));
    const _jwt = {
        verified,
        header: JSON.parse((0, uint8arrays_1.uint8arrayToString)((0, uint8arrays_1.uint8arrayFromString)(jwtParts[0], 'base64url'))),
        payload: JSON.parse((0, uint8arrays_1.uint8arrayToString)((0, uint8arrays_1.uint8arrayFromString)(jwtParts[1], 'base64url'))),
        signature: sig,
    };
    return _jwt;
};
exports.verifyJwt = verifyJwt;
//# sourceMappingURL=encryption.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/encryption/src/lib/params-validators.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

/**
 * Param Validators is an abstraction of validating params of a function, each validator
 * returns a boolean value indicating whether the validation is passed or not.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.paramsValidators = exports.safeParams = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const safeParams = ({ functionName, params, }) => {
    const validators = exports.paramsValidators;
    const validator = validators[functionName](params);
    if (!validator) {
        (0, misc_1.log)(`This function ${functionName} is skipping params safe guarding.`);
        return true;
    }
    return validator;
};
exports.safeParams = safeParams;
exports.paramsValidators = {
    executeJs: (params) => {
        // -- prepare params
        const { code, ipfsId, authSig, jsParams, debug, sessionSigs, authMethods = [], } = params;
        // -- validate: either 'code' or 'ipfsId' must exists
        if (!code && !ipfsId) {
            const message = 'You must pass either code or ipfsId';
            (0, misc_1.throwError)({
                message,
                errorKind: constants_1.LIT_ERROR.PARAMS_MISSING_ERROR.kind,
                errorCode: constants_1.LIT_ERROR.PARAMS_MISSING_ERROR.name,
            });
            return false;
        }
        // -- validate: 'code' and 'ipfsId' can't exists at the same time
        if (code && ipfsId) {
            const message = "You cannot have both 'code' and 'ipfs' at the same time";
            (0, misc_1.throwError)({
                message,
                errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
            });
            return false;
        }
        // -- validate: authSig and its type is correct
        if (authSig &&
            !(0, misc_1.checkType)({
                value: authSig,
                allowedTypes: ['Object'],
                paramName: 'authSig',
                functionName: 'executeJs',
            }))
            return false;
        // -- validate: sessionSigs and its type is correct
        if (sessionSigs && !(0, misc_1.is)(sessionSigs, 'Object', 'sessionSigs', 'executeJs'))
            return false;
        // -- validate: authMethods and its type is correct
        if (authMethods &&
            authMethods.length > 0 &&
            !(0, misc_1.checkType)({
                value: authMethods,
                allowedTypes: ['Array'],
                paramName: 'authMethods',
                functionName: 'executeJs',
            }))
            return false;
        // -- validate: if sessionSig or authSig exists
        if (!sessionSigs && !authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass either authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- validate: if sessionSig and authSig exists
        if (sessionSigs && authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass only one authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        return true;
    },
    saveEncryptionKey: (params) => {
        // -- prepare params
        const { accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions, authSig, chain, symmetricKey, encryptedSymmetricKey, permanant, permanent, sessionSigs, } = params;
        if (accessControlConditions &&
            !(0, misc_1.is)(accessControlConditions, 'Array', 'accessControlConditions', 'saveEncryptionKey'))
            return false;
        if (evmContractConditions &&
            !(0, misc_1.is)(evmContractConditions, 'Array', 'evmContractConditions', 'saveEncryptionKey'))
            return false;
        if (solRpcConditions &&
            !(0, misc_1.is)(solRpcConditions, 'Array', 'solRpcConditions', 'saveEncryptionKey'))
            return false;
        if (unifiedAccessControlConditions &&
            !(0, misc_1.is)(unifiedAccessControlConditions, 'Array', 'unifiedAccessControlConditions', 'saveEncryptionKey'))
            return false;
        // log('authSig:', authSig);
        if (authSig && !(0, misc_1.is)(authSig, 'Object', 'authSig', 'saveEncryptionKey'))
            return false;
        if (authSig &&
            !(0, misc_1.checkIfAuthSigRequiresChainParam)(authSig, chain, 'saveEncryptionKey'))
            return false;
        if (sessionSigs &&
            !(0, misc_1.is)(sessionSigs, 'Object', 'sessionSigs', 'saveEncryptionKey'))
            return false;
        if (!sessionSigs && !authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass either authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        if (symmetricKey &&
            !(0, misc_1.is)(symmetricKey, 'Uint8Array', 'symmetricKey', 'saveEncryptionKey'))
            return false;
        if (encryptedSymmetricKey &&
            !(0, misc_1.is)(encryptedSymmetricKey, 'Uint8Array', 'encryptedSymmetricKey', 'saveEncryptionKey'))
            return false;
        // to fix spelling mistake
        if (typeof params.permanant !== 'undefined') {
            params.permanent = params.permanant;
        }
        if ((!symmetricKey || symmetricKey == '') &&
            (!encryptedSymmetricKey || encryptedSymmetricKey == '')) {
            throw new Error('symmetricKey and encryptedSymmetricKey are blank.  You must pass one or the other');
        }
        if (!accessControlConditions &&
            !evmContractConditions &&
            !solRpcConditions &&
            !unifiedAccessControlConditions) {
            throw new Error('accessControlConditions and evmContractConditions and solRpcConditions and unifiedAccessControlConditions are blank');
        }
        // -- validate: if sessionSig and authSig exists
        if (sessionSigs && authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass only one authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        //   -- case: success
        return true;
    },
    getEncryptionKey: (params) => {
        const { accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions, toDecrypt, authSig, chain, sessionSigs, } = params;
        // -- validate
        if (accessControlConditions &&
            !(0, misc_1.is)(accessControlConditions, 'Array', 'accessControlConditions', 'getEncryptionKey'))
            return false;
        if (evmContractConditions &&
            !(0, misc_1.is)(evmContractConditions, 'Array', 'evmContractConditions', 'getEncryptionKey'))
            return false;
        if (solRpcConditions &&
            !(0, misc_1.is)(solRpcConditions, 'Array', 'solRpcConditions', 'getEncryptionKey'))
            return false;
        if (unifiedAccessControlConditions &&
            !(0, misc_1.is)(unifiedAccessControlConditions, 'Array', 'unifiedAccessControlConditions', 'getEncryptionKey'))
            return false;
        (0, misc_1.log)('TYPEOF toDecrypt in getEncryptionKey():', typeof toDecrypt);
        if (!(0, misc_1.is)(toDecrypt, 'String', 'toDecrypt', 'getEncryptionKey'))
            return false;
        if (authSig && !(0, misc_1.is)(authSig, 'Object', 'authSig', 'getEncryptionKey'))
            return false;
        if (sessionSigs &&
            !(0, misc_1.is)(sessionSigs, 'Object', 'sessionSigs', 'getEncryptionKey'))
            return false;
        // -- validate: if sessionSig or authSig exists
        if (!sessionSigs && !authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass either authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- validate: if sessionSig and authSig exists
        if (sessionSigs && authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass only one authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- validate if 'chain' is null
        if (!chain) {
            return false;
        }
        if (authSig &&
            !(0, misc_1.checkIfAuthSigRequiresChainParam)(authSig, chain, 'getEncryptionKey'))
            return false;
        return true;
    },
    decryptString: (params) => {
        const encryptedStringBlob = params[0];
        const symmKey = params[1];
        // -- validate
        if (!(0, misc_1.checkType)({
            value: encryptedStringBlob,
            allowedTypes: ['Blob', 'File'],
            paramName: 'encryptedStringBlob',
            functionName: 'decryptString',
        }))
            return false;
        if (!(0, misc_1.checkType)({
            value: symmKey,
            allowedTypes: ['Uint8Array'],
            paramName: 'symmKey',
            functionName: 'decryptString',
        }))
            return false;
        // -- success
        return true;
    },
    decryptFile: (params) => {
        // -- validate
        if (!(0, misc_1.checkType)({
            value: params.file,
            allowedTypes: ['Blob', 'File'],
            paramName: 'file',
            functionName: 'decryptFile',
        }))
            return false;
        // -- validate
        if (!(0, misc_1.checkType)({
            value: params.symmetricKey,
            allowedTypes: ['Uint8Array'],
            paramName: 'symmetricKey',
            functionName: 'decryptFile',
        }))
            return false;
        return true;
    },
    decryptZipFileWithMetadata: (params) => {
        // -- validate
        if (params.authSig &&
            !(0, misc_1.checkType)({
                value: params.authSig,
                allowedTypes: ['Object'],
                paramName: 'authSig',
                functionName: 'decryptZipFileWithMetadata',
            }))
            return false;
        // -- validate: sessionSigs and its type is correct
        if (params.sessionSigs &&
            !(0, misc_1.is)(params.sessionSigs, 'Object', 'sessionSigs', 'decryptZipFileWithMetadata'))
            return false;
        // -- validate: if sessionSig or authSig exists
        if (!params.sessionSigs && !params.authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass either authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- validate: if sessionSig and authSig exists
        if (params.sessionSigs && params.authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass only one authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- validate
        if (!(0, misc_1.checkType)({
            value: params.file,
            allowedTypes: ['Blob', 'File'],
            paramName: 'file',
            functionName: 'decryptZipFileWithMetadata',
        }))
            return false;
        // -- success case
        return true;
    },
    decryptZip: (params) => {
        const { encryptedZipBlob, symmKey } = params;
        (0, misc_1.log)('encryptedZipBlob:', encryptedZipBlob);
        // -- validate
        if (!(0, misc_1.checkType)({
            value: encryptedZipBlob,
            allowedTypes: ['Blob', 'File'],
            paramName: 'encryptedZipBlob',
            functionName: 'decryptZip',
        }))
            return false;
        // -- validate
        if (!(0, misc_1.checkType)({
            value: symmKey,
            allowedTypes: ['Uint8Array'],
            paramName: 'symmKey',
            functionName: 'decryptZip',
        }))
            return false;
        return true;
    },
    encryptToIpfs: (params) => {
        // -- validate
        (0, misc_1.log)('params:', params);
        if (params.authSig &&
            !(0, misc_1.checkType)({
                value: params.authSig,
                allowedTypes: ['Object'],
                paramName: 'authSig',
                functionName: 'encryptToIpfs',
            }))
            return false;
        // -- validate
        if (params.accessControlConditions &&
            !(0, misc_1.checkType)({
                value: params.accessControlConditions,
                allowedTypes: ['Array'],
                paramName: 'accessControlConditions',
                functionName: 'encryptToIpfs',
            }))
            return false;
        // -- validate
        if (params.evmContractConditions &&
            !(0, misc_1.checkType)({
                value: params.evmContractConditions,
                allowedTypes: ['Array'],
                paramName: 'evmContractConditions',
                functionName: 'encryptToIpfs',
            }))
            return false;
        // -- validate
        if (params.solRpcConditions &&
            !(0, misc_1.checkType)({
                value: params.solRpcConditions,
                allowedTypes: ['Array'],
                paramName: 'solRpcConditions',
                functionName: 'encryptToIpfs',
            }))
            return false;
        // -- validate
        if (params.unifiedAccessControlConditions &&
            !(0, misc_1.checkType)({
                value: params.unifiedAccessControlConditions,
                allowedTypes: ['Array'],
                paramName: 'unifiedAccessControlConditions',
                functionName: 'encryptToIpfs',
            }))
            return false;
        // -- validate
        if (params.authSig &&
            !(0, misc_1.checkIfAuthSigRequiresChainParam)(params.authSig, params.chain, 'encryptToIpfs'))
            return false;
        // -- validate: sessionSigs and its type is correct
        if (params.sessionSigs &&
            !(0, misc_1.is)(params.sessionSigs, 'Object', 'sessionSigs', 'encryptToIpfs'))
            return false;
        // -- validate: if sessionSig or authSig exists
        if (!params.sessionSigs && !params.authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass either authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- validate: if sessionSig and authSig exists
        if (params.sessionSigs && params.authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass only one authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- validate
        if (params.string !== undefined &&
            !(0, misc_1.checkType)({
                value: params.string,
                allowedTypes: ['String'],
                paramName: 'string',
                functionName: 'encryptToIpfs',
            }))
            return false;
        // -- validate
        if (params.file !== undefined &&
            !(0, misc_1.checkType)({
                value: params.file,
                allowedTypes: ['Blob', 'File'],
                paramName: 'file',
                functionName: 'encryptToIpfs',
            }))
            return false;
        // -- success case
        return true;
    },
    decryptFromIpfs: (params) => {
        // -- validate
        (0, misc_1.log)('params:', params);
        if (params.authSig &&
            !(0, misc_1.checkType)({
                value: params.authSig,
                allowedTypes: ['Object'],
                paramName: 'authSig',
                functionName: 'decryptFromIpfs',
            }))
            return false;
        // -- validate: sessionSigs and its type is correct
        if (params.sessionSigs &&
            !(0, misc_1.is)(params.sessionSigs, 'Object', 'sessionSigs', 'decryptFromIpfs'))
            return false;
        // -- validate: if sessionSig or authSig exists
        if (!params.sessionSigs && !params.authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass either authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- validate: if sessionSig and authSig exists
        if (params.sessionSigs && params.authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass only one authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- success case
        return true;
    },
    encryptFileAndZipWithMetadata: (params) => {
        // -- validate
        (0, misc_1.log)('params:', params);
        if (params.authSig &&
            !(0, misc_1.checkType)({
                value: params.authSig,
                allowedTypes: ['Object'],
                paramName: 'authSig',
                functionName: 'encryptFileAndZipWithMetadata',
            }))
            return false;
        // -- validate
        if (params.accessControlConditions &&
            !(0, misc_1.checkType)({
                value: params.accessControlConditions,
                allowedTypes: ['Array'],
                paramName: 'accessControlConditions',
                functionName: 'encryptFileAndZipWithMetadata',
            }))
            return false;
        // -- validate
        if (params.evmContractConditions &&
            !(0, misc_1.checkType)({
                value: params.evmContractConditions,
                allowedTypes: ['Array'],
                paramName: 'evmContractConditions',
                functionName: 'encryptFileAndZipWithMetadata',
            }))
            return false;
        // -- validate
        if (params.solRpcConditions &&
            !(0, misc_1.checkType)({
                value: params.solRpcConditions,
                allowedTypes: ['Array'],
                paramName: 'solRpcConditions',
                functionName: 'encryptFileAndZipWithMetadata',
            }))
            return false;
        // -- validate
        if (params.unifiedAccessControlConditions &&
            !(0, misc_1.checkType)({
                value: params.unifiedAccessControlConditions,
                allowedTypes: ['Array'],
                paramName: 'unifiedAccessControlConditions',
                functionName: 'encryptFileAndZipWithMetadata',
            }))
            return false;
        // -- validate
        if (params.authSig &&
            !(0, misc_1.checkIfAuthSigRequiresChainParam)(params.authSig, params.chain, 'encryptFileAndZipWithMetadata'))
            return false;
        // -- validate: sessionSigs and its type is correct
        if (params.sessionSigs &&
            !(0, misc_1.is)(params.sessionSigs, 'Object', 'sessionSigs', 'encryptFileAndZipWithMetadata'))
            return false;
        // -- validate: if sessionSig or authSig exists
        if (!params.sessionSigs && !params.authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass either authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- validate: if sessionSig and authSig exists
        if (params.sessionSigs && params.authSig) {
            (0, misc_1.throwError)({
                message: 'You must pass only one authSig or sessionSigs',
                errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
            });
            return false;
        }
        // -- validate
        if (!(0, misc_1.checkType)({
            value: params.file,
            allowedTypes: ['File'],
            paramName: 'file',
            functionName: 'encryptFileAndZipWithMetadata',
        }))
            return false;
        // -- validate
        if (params.readme &&
            !(0, misc_1.checkType)({
                value: params.readme,
                allowedTypes: ['String'],
                paramName: 'readme',
                functionName: 'encryptFileAndZipWithMetadata',
            }))
            return false;
        // -- success case
        return true;
    },
};
//# sourceMappingURL=params-validators.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/lit-node-client-nodejs/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uint8arrayToString = exports.uint8arrayFromString = exports.blobToBase64String = exports.base64StringToBlob = exports.humanizeAccessControlConditions = exports.hashResourceIdForSigning = exports.zipAndEncryptString = exports.zipAndEncryptFiles = exports.verifyJwt = exports.encryptZip = exports.encryptToIpfs = exports.encryptString = exports.encryptFileAndZipWithMetadata = exports.encryptFile = exports.decryptFromIpfs = exports.decryptZipFileWithMetadata = exports.decryptZip = exports.decryptString = exports.decryptFile = void 0;
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const _LitNodeClientNodeJs = __webpack_require__("../../node_modules/@lit-protocol/lit-node-client-nodejs/src/lib/lit-node-client-nodejs.js");
// ==================== Environment ====================
if ((0, misc_1.isNode)()) {
    (0, misc_1.log)('Oh hey you are running in Node.js!');
    const fetch = __webpack_require__("./src/shim/node-fetch.ts");
    globalThis.fetch = fetch;
}
const LitNodeClientNodeJs = _LitNodeClientNodeJs.LitNodeClientNodeJs;
if (!globalThis.LitNodeClientNodeJs) {
    globalThis.LitNodeClientNodeJs = LitNodeClientNodeJs;
}
// ==================== Exports ====================
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/lit-node-client-nodejs/src/lib/lit-node-client-nodejs.js"), exports);
var encryption_1 = __webpack_require__("../../node_modules/@lit-protocol/encryption/src/index.js");
Object.defineProperty(exports, "decryptFile", ({ enumerable: true, get: function () { return encryption_1.decryptFile; } }));
Object.defineProperty(exports, "decryptString", ({ enumerable: true, get: function () { return encryption_1.decryptString; } }));
Object.defineProperty(exports, "decryptZip", ({ enumerable: true, get: function () { return encryption_1.decryptZip; } }));
Object.defineProperty(exports, "decryptZipFileWithMetadata", ({ enumerable: true, get: function () { return encryption_1.decryptZipFileWithMetadata; } }));
Object.defineProperty(exports, "decryptFromIpfs", ({ enumerable: true, get: function () { return encryption_1.decryptFromIpfs; } }));
Object.defineProperty(exports, "encryptFile", ({ enumerable: true, get: function () { return encryption_1.encryptFile; } }));
Object.defineProperty(exports, "encryptFileAndZipWithMetadata", ({ enumerable: true, get: function () { return encryption_1.encryptFileAndZipWithMetadata; } }));
Object.defineProperty(exports, "encryptString", ({ enumerable: true, get: function () { return encryption_1.encryptString; } }));
Object.defineProperty(exports, "encryptToIpfs", ({ enumerable: true, get: function () { return encryption_1.encryptToIpfs; } }));
Object.defineProperty(exports, "encryptZip", ({ enumerable: true, get: function () { return encryption_1.encryptZip; } }));
Object.defineProperty(exports, "verifyJwt", ({ enumerable: true, get: function () { return encryption_1.verifyJwt; } }));
Object.defineProperty(exports, "zipAndEncryptFiles", ({ enumerable: true, get: function () { return encryption_1.zipAndEncryptFiles; } }));
Object.defineProperty(exports, "zipAndEncryptString", ({ enumerable: true, get: function () { return encryption_1.zipAndEncryptString; } }));
var access_control_conditions_1 = __webpack_require__("../../node_modules/@lit-protocol/access-control-conditions/src/index.js");
Object.defineProperty(exports, "hashResourceIdForSigning", ({ enumerable: true, get: function () { return access_control_conditions_1.hashResourceIdForSigning; } }));
Object.defineProperty(exports, "humanizeAccessControlConditions", ({ enumerable: true, get: function () { return access_control_conditions_1.humanizeAccessControlConditions; } }));
var misc_browser_1 = __webpack_require__("../../node_modules/@lit-protocol/misc-browser/src/index.js");
Object.defineProperty(exports, "base64StringToBlob", ({ enumerable: true, get: function () { return misc_browser_1.base64StringToBlob; } }));
Object.defineProperty(exports, "blobToBase64String", ({ enumerable: true, get: function () { return misc_browser_1.blobToBase64String; } }));
var uint8arrays_1 = __webpack_require__("../../node_modules/@lit-protocol/uint8arrays/src/index.js");
Object.defineProperty(exports, "uint8arrayFromString", ({ enumerable: true, get: function () { return uint8arrays_1.uint8arrayFromString; } }));
Object.defineProperty(exports, "uint8arrayToString", ({ enumerable: true, get: function () { return uint8arrays_1.uint8arrayToString; } }));
// ----- autogen:polyfills:start  -----
// This field will be automatically injected into the ./dist/packages/<package-name>/index.js file
// between the autogen:polyfills:start/end comments

try {
  globalThis.crypto = (__webpack_require__("../../node_modules/crypto-browserify/index.js").webcrypto);
} catch (e) {
  // swallow
}

// ----- autogen:polyfills:end  -----
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/lit-node-client-nodejs/src/lib/lit-node-client-nodejs.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__("../../node_modules/buffer/index.js")["Buffer"];

var _LitNodeClientNodeJs_isSuccessNodePromises;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LitNodeClientNodeJs = void 0;
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
const access_control_conditions_1 = __webpack_require__("../../node_modules/@lit-protocol/access-control-conditions/src/index.js");
const bls_sdk_1 = __webpack_require__("../../node_modules/@lit-protocol/bls-sdk/src/index.js");
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const crypto_1 = __webpack_require__("../../node_modules/@lit-protocol/crypto/src/index.js");
const encryption_1 = __webpack_require__("../../node_modules/@lit-protocol/encryption/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const uint8arrays_1 = __webpack_require__("../../node_modules/@lit-protocol/uint8arrays/src/index.js");
const transactions_1 = __webpack_require__("../../node_modules/@ethersproject/transactions/lib.esm/index.js");
const lit_siwe_1 = __webpack_require__("../../node_modules/lit-siwe/dist/siwe.js");
const utils_1 = __webpack_require__("../../node_modules/ethers/lib/utils.js");
const lit_third_party_libs_1 = __webpack_require__("../../node_modules/@lit-protocol/lit-third-party-libs/src/index.js");
const nacl_1 = __webpack_require__("../../node_modules/@lit-protocol/nacl/src/index.js");
const misc_browser_1 = __webpack_require__("../../node_modules/@lit-protocol/misc-browser/src/index.js");
const ethers_1 = __webpack_require__("../../node_modules/ethers/lib.esm/index.js");
// import { checkAndSignAuthMessage } from '@lit-protocol/auth-browser';
/** ---------- Main Export Class ---------- */
class LitNodeClientNodeJs {
    // ========== Constructor ==========
    constructor(args) {
        // ========== Scoped Class Helpers ==========
        /**
         *
         * Set bootstrapUrls to match the network litNetwork unless it's set to custom
         *
         * @returns { void }
         *
         */
        this.setCustomBootstrapUrls = () => {
            // -- validate
            if (this.config.litNetwork === 'custom')
                return;
            // -- execute
            const hasNetwork = this.config.litNetwork in constants_1.LIT_NETWORKS;
            if (!hasNetwork) {
                // network not found, report error
                (0, misc_1.throwError)({
                    message: 'the litNetwork specified in the LitNodeClient config not found in LIT_NETWORKS',
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_BAD_CONFIG_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_BAD_CONFIG_ERROR.name,
                });
                return;
            }
            this.config.bootstrapUrls = constants_1.LIT_NETWORKS[this.config.litNetwork];
        };
        /**
         *
         * Get either auth sig or session auth sig
         *
         */
        this.getAuthSigOrSessionAuthSig = ({ authSig, sessionSigs, url, }) => {
            // -- if there's session
            let sigToPassToNode = authSig;
            if (sessionSigs) {
                sigToPassToNode = sessionSigs[url];
                if (!sigToPassToNode) {
                    (0, misc_1.throwError)({
                        message: `You passed sessionSigs but we could not find session sig for node ${url}`,
                        errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                        errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
                    });
                }
            }
            return sigToPassToNode;
        };
        /**
         *
         * Get the request body of the lit action
         *
         * @param { ExecuteJsProps } params
         *
         * @returns { JsonExecutionRequest }
         *
         */
        this.getLitActionRequestBody = (params) => {
            const reqBody = {
                authSig: params.authSig,
                jsParams: (0, misc_1.convertLitActionsParams)(params.jsParams),
                // singleNode: params.singleNode ?? false,
                targetNodeRange: params.targetNodeRange ?? 0,
            };
            if (params.code) {
                const _uint8Array = (0, uint8arrays_1.uint8arrayFromString)(params.code, 'utf8');
                const encodedJs = (0, uint8arrays_1.uint8arrayToString)(_uint8Array, 'base64');
                reqBody.code = encodedJs;
            }
            if (params.ipfsId) {
                reqBody.ipfsId = params.ipfsId;
            }
            if (params.authMethods && params.authMethods.length > 0) {
                reqBody.authMethods = params.authMethods;
            }
            return reqBody;
        };
        /**
         *
         * we need to send jwt params iat (issued at) and exp (expiration) because the nodes may have different wall clock times, the nodes will verify that these params are withing a grace period
         *
         */
        this.getJWTParams = () => {
            const now = Date.now();
            const iat = Math.floor(now / 1000);
            const exp = iat + 12 * 60 * 60; // 12 hours in seconds
            return { iat, exp };
        };
        /**
         *
         * Parse the response string to JSON
         *
         * @param { string } responseString
         *
         * @returns { any } JSON object
         *
         */
        this.parseResponses = (responseString) => {
            let response;
            try {
                response = JSON.parse(responseString);
            }
            catch (e) {
                (0, misc_1.log)('Error parsing response as json.  Swallowing and returning as string.', responseString);
            }
            return response;
        };
        // ==================== SESSIONS ====================
        /**
         * Try to get the session key in the local storage,
         * if not, generates one.
         *
         * @param {string} [serializedSessionKeyPair] - Serialized session key pair
         * @return {SessionKeyPair} - Session key pair
         */
        this.getSessionKey = (serializedSessionKeyPair) => {
            // If a session key pair is provided, parse it and return it
            if (serializedSessionKeyPair) {
                try {
                    const keyPair = JSON.parse(serializedSessionKeyPair);
                    if (this.isSessionKeyPair(keyPair)) {
                        return keyPair;
                    }
                    else {
                        return (0, misc_1.throwError)({
                            message: 'Invalid session key pair provided',
                            error: constants_1.LIT_ERROR.PARAMS_MISSING_ERROR,
                        });
                    }
                }
                catch (err) {
                    (0, misc_1.log)(`Error when parsing provided session keypair ${serializedSessionKeyPair}: ${err}`);
                    throw err;
                }
            }
            // If no session key pair is provided, try to get it from the local storage
            const storageKey = constants_1.LOCAL_STORAGE_KEYS.SESSION_KEY;
            const storedSessionKeyOrError = (0, misc_browser_1.getStorageItem)(storageKey);
            // Check for errors
            if (storedSessionKeyOrError.type === 'ERROR') {
                console.warn(`Storage key "${storageKey}" is missing. Not a problem. Continue...`);
            }
            else {
                // If no errors, get the stored session key
                const storedSessionKey = storedSessionKeyOrError.result;
                if (storedSessionKey) {
                    try {
                        const keyPair = JSON.parse(storedSessionKey);
                        if (this.isSessionKeyPair(keyPair)) {
                            return keyPair;
                        }
                        else {
                            throw new Error('Invalid session key pair stored');
                        }
                    }
                    catch (err) {
                        (0, misc_1.log)(`Error when parsing stored session keypair ${storedSessionKey}. Continuing to generate a new one...`);
                    }
                }
            }
            // If no session key is stored, generate one
            let sessionKey;
            try {
                sessionKey = (0, crypto_1.generateSessionKeyPair)();
            }
            catch (err) {
                (0, misc_1.log)(`Error when generating session keypair: ${err}`);
                throw err;
            }
            // Store session key in local storage
            try {
                localStorage.setItem(storageKey, JSON.stringify(sessionKey));
            }
            catch (e) {
                console.warn(`Local storage not available. Not a problem. Continue...`);
            }
            return sessionKey;
        };
        /**
         *
         * Get session capabilities from user, it not, generates one
         * @param { Array<any> } capabilities
         * @param { Array<any> } resources
         * @return { Array<any> }
         */
        this.getSessionCapabilities = (capabilities, resources) => {
            if (!capabilities || capabilities.length == 0) {
                capabilities = resources.map((resource) => {
                    const { protocol, resourceId } = this.parseResource({ resource });
                    return `${protocol}Capability://*`;
                });
            }
            return capabilities;
        };
        /**
         *
         * Get expiration for session
         *
         */
        this.getExpiration = () => {
            return new Date(Date.now() + 1000 * 60 * 60 * 24).toISOString();
        };
        /**
         *
         * Get the signature from local storage, if not, generates one
         *
         */
        this.getWalletSig = async ({ authNeededCallback, chain, capabilities, switchChain, expiration, sessionKeyUri, }) => {
            let walletSig;
            const storageKey = constants_1.LOCAL_STORAGE_KEYS.WALLET_SIGNATURE;
            const storedWalletSigOrError = (0, misc_browser_1.getStorageItem)(storageKey);
            // -- (TRY) to get it in the local storage
            if (storedWalletSigOrError.type === 'ERROR') {
                console.warn(`Storage key "${storageKey}" is missing. Not a problem. Contiune...`);
            }
            else {
                walletSig = storedWalletSigOrError.result;
            }
            // -- IF NOT: Generates one
            if (!storedWalletSigOrError.result || storedWalletSigOrError.result == '') {
                if (authNeededCallback) {
                    walletSig = await authNeededCallback({
                        chain,
                        resources: capabilities,
                        switchChain,
                        expiration,
                        uri: sessionKeyUri,
                    });
                }
                else {
                    if (!this.defaultAuthCallback) {
                        return (0, misc_1.throwError)({
                            message: 'No default auth callback provided',
                            errorKind: constants_1.LIT_ERROR.PARAMS_MISSING_ERROR.kind,
                            errorCode: constants_1.LIT_ERROR.PARAMS_MISSING_ERROR.name,
                        });
                    }
                    walletSig = await this.defaultAuthCallback({
                        chain,
                        resources: capabilities,
                        switchChain,
                        expiration,
                        uri: sessionKeyUri,
                    });
                }
            }
            else {
                try {
                    walletSig = JSON.parse(storedWalletSigOrError.result);
                }
                catch (e) {
                    console.warn('Error parsing walletSig', e);
                }
            }
            return walletSig;
        };
        /**
         *
         * Check if a session key needs to be resigned
         *
         */
        this.checkNeedToResignSessionKey = async ({ siweMessage, walletSignature, sessionKeyUri, resources, sessionCapabilities, }) => {
            let needToResign = false;
            try {
                // @ts-ignore
                await siweMessage.verify({ signature: walletSignature });
            }
            catch (e) {
                needToResign = true;
            }
            // make sure the sig is for the correct session key
            if (siweMessage.uri !== sessionKeyUri) {
                needToResign = true;
            }
            // make sure the sig has the session capabilities required to fulfill the resources requested
            for (let i = 0; i < resources.length; i++) {
                const resource = resources[i];
                const { protocol, resourceId } = this.parseResource({ resource });
                // check if we have blanket permissions or if we authed the specific resource for the protocol
                const permissionsFound = sessionCapabilities.some((capability) => {
                    const capabilityParts = this.parseResource({ resource: capability });
                    return (capabilityParts.protocol === protocol &&
                        (capabilityParts.resourceId === '*' ||
                            capabilityParts.resourceId === resourceId));
                });
                if (!permissionsFound) {
                    needToResign = true;
                }
            }
            return needToResign;
        };
        // ==================== SENDING COMMAND ====================
        /**
         *
         * Send a command to nodes
         *
         * @param { SendNodeCommand }
         *
         * @returns { Promise<any> }
         *
         */
        this.sendCommandToNode = async ({ url, data, requestId, }) => {
            (0, misc_1.log)(`sendCommandToNode with url ${url} and data`, data);
            const req = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Lit-SDK-Version': constants_1.version,
                    'X-Lit-SDK-Type': 'Typescript',
                    'X-Request-Id': 'lit_' + requestId,
                },
                body: JSON.stringify(data),
            };
            return fetch(url, req)
                .then(async (response) => {
                const isJson = response.headers
                    .get('content-type')
                    ?.includes('application/json');
                const data = isJson ? await response.json() : null;
                if (!response.ok) {
                    // get error message from body or default to response status
                    const error = data || response.status;
                    return Promise.reject(error);
                }
                return data;
            })
                .catch((error) => {
                return Promise.reject(error);
            });
        };
        // ==================== API Calls to Nodes ====================
        /**
         *
         * Get JS Execution Shares from Nodes
         *
         * @param { JsonExecutionRequest } params
         *
         * @returns { Promise<any> }
         */
        this.getJsExecutionShares = async (url, params, requestId) => {
            const { code, ipfsId, authSig, jsParams, sessionSigs } = params;
            (0, misc_1.log)('getJsExecutionShares');
            // -- execute
            const urlWithPath = `${url}/web/execute`;
            const data = {
                code,
                ipfsId,
                authSig,
                jsParams,
            };
            return await this.sendCommandToNode({ url: urlWithPath, data, requestId });
        };
        /**
         *
         * Get Chain Data Signing Shares
         *
         * @param { string } url
         * @param { JsonSignChainDataRequest } params
         *
         * @returns { Promise<any> }
         *
         */
        this.getChainDataSigningShare = async (url, params, requestId) => {
            const { callRequests, chain, iat, exp } = params;
            (0, misc_1.log)('getChainDataSigningShare');
            const urlWithPath = `${url}/web/signing/sign_chain_data`;
            const data = {
                callRequests,
                chain,
                iat,
                exp,
            };
            return await this.sendCommandToNode({ url: urlWithPath, data, requestId });
        };
        /**
         *
         * Get Signing Shares from Nodes
         *
         * @param { string } url
         * @param { JsonSigningRetrieveRequest } params
         *
         * @returns { Promise<any>}
         *
         */
        this.getSigningShare = async (url, params, requestId) => {
            (0, misc_1.log)('getSigningShare');
            const urlWithPath = `${url}/web/signing/retrieve`;
            return await this.sendCommandToNode({
                url: urlWithPath,
                data: params,
                requestId,
            });
        };
        /**
         *
         * Ger Decryption Shares from Nodes
         *
         * @param { string } url
         * @param { JsonEncryptionRetrieveRequest } params
         *
         * @returns { Promise<any> }
         *
         */
        this.getDecryptionShare = async (url, params, requestId) => {
            (0, misc_1.log)('getDecryptionShare');
            const urlWithPath = `${url}/web/encryption/retrieve`;
            return await this.sendCommandToNode({
                url: urlWithPath,
                data: params,
                requestId,
            });
        };
        /**
         *
         * Store signing conditions to nodes
         *
         * @param { string } url
         * @param { JsonSigningStoreRequest } params
         *
         * @returns { Promise<NodeCommandResponse> }
         *
         */
        this.storeSigningConditionWithNode = async (url, params, requestId) => {
            (0, misc_1.log)('storeSigningConditionWithNode');
            const urlWithPath = `${url}/web/signing/store`;
            return await this.sendCommandToNode({
                url: urlWithPath,
                data: {
                    key: params.key,
                    val: params.val,
                    authSig: params.authSig,
                    chain: params.chain,
                    permanant: params.permanent,
                },
                requestId,
            });
        };
        /**
         *
         * Store encryption conditions to nodes
         *
         * @param { string } urk
         * @param { JsonEncryptionStoreRequest } params
         *
         * @returns { Promise<NodeCommandResponse> }
         *
         */
        this.storeEncryptionConditionWithNode = async (url, params, requestId) => {
            (0, misc_1.log)('storeEncryptionConditionWithNode');
            const urlWithPath = `${url}/web/encryption/store`;
            const data = {
                key: params.key,
                val: params.val,
                authSig: params.authSig,
                chain: params.chain,
                permanant: params.permanent,
            };
            return await this.sendCommandToNode({ url: urlWithPath, data, requestId });
        };
        /**
         *
         * Sign Condition ECDSA
         *
         * @param { string } url
         * @param { SignConditionECDSA } params
         *
         * @returns { Promise<NodeCommandResponse> }
         *
         */
        this.signConditionEcdsa = async (url, params, requestId) => {
            (0, misc_1.log)('signConditionEcdsa');
            const urlWithPath = `${url}/web/signing/signConditionEcdsa`;
            const data = {
                access_control_conditions: params.accessControlConditions,
                evmContractConditions: params.evmContractConditions,
                solRpcConditions: params.solRpcConditions,
                auth_sig: params.auth_sig,
                chain: params.chain,
                iat: params.iat,
                exp: params.exp,
            };
            return await this.sendCommandToNode({
                url: urlWithPath,
                data,
                requestId,
            });
        };
        /**
         *
         * Handshake with SGX
         *
         * @param { HandshakeWithSgx } params
         *
         * @returns { Promise<NodeCommandServerKeysResponse> }
         *
         */
        this.handshakeWithSgx = async (params, requestId) => {
            // -- get properties from params
            const { url } = params;
            // -- create url with path
            const urlWithPath = `${url}/web/handshake`;
            (0, misc_1.log)(`handshakeWithSgx ${urlWithPath}`);
            const data = {
                clientPublicKey: 'test',
            };
            return this.sendCommandToNode({
                url: urlWithPath,
                data,
                requestId,
            });
        };
        /**
         *
         * Combine Shares from network public key set and signature shares
         *
         * @param { string } networkPubKeySet
         * @param { any } signatureShares
         *
         * @returns { string } final JWT (convert the sig to base64 and append to the jwt)
         *
         */
        this.combineSharesAndGetJWT = (networkPubKeySet, signatureShares) => {
            // ========== Shares Validations ==========
            // -- sanity check
            if (!signatureShares.every((val, i, arr) => val.unsignedJwt === arr[0].unsignedJwt)) {
                const msg = 'Unsigned JWT is not the same from all the nodes.  This means the combined signature will be bad because the nodes signed the wrong things';
                (0, misc_1.log)(msg);
            }
            // ========== Sorting ==========
            // -- sort the sig shares by share index.  this is important when combining the shares.
            signatureShares.sort((a, b) => a.shareIndex - b.shareIndex);
            // ========== Combine Shares ==========
            const pkSetAsBytes = (0, uint8arrays_1.uint8arrayFromString)(networkPubKeySet, 'base16');
            (0, misc_1.log)('pkSetAsBytes', pkSetAsBytes);
            const sigShares = signatureShares.map((s) => ({
                shareHex: s.signatureShare,
                shareIndex: s.shareIndex,
            }));
            const signature = bls_sdk_1.wasmBlsSdkHelpers.combine_signatures(pkSetAsBytes, sigShares);
            (0, misc_1.log)('raw sig', signature);
            (0, misc_1.log)('signature is ', (0, uint8arrays_1.uint8arrayToString)(signature, 'base16'));
            const unsignedJwt = (0, misc_1.mostCommonString)(signatureShares.map((s) => s.unsignedJwt));
            // ========== Result ==========
            // convert the sig to base64 and append to the jwt
            const finalJwt = `${unsignedJwt}.${(0, uint8arrays_1.uint8arrayToString)(signature, 'base64url')}`;
            return finalJwt;
        };
        /**
         *
         * Get different formats of access control conditions, eg. evm, sol, unified etc.
         *
         * @param { SupportedJsonRequests } params
         *
         * @returns { FormattedMultipleAccs }
         *
         */
        this.getFormattedAccessControlConditions = (params) => {
            // -- prepare params
            const { accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions, } = params;
            // -- execute
            let formattedAccessControlConditions;
            let formattedEVMContractConditions;
            let formattedSolRpcConditions;
            let formattedUnifiedAccessControlConditions;
            let error = false;
            if (accessControlConditions) {
                formattedAccessControlConditions = accessControlConditions.map((c) => (0, access_control_conditions_1.canonicalAccessControlConditionFormatter)(c));
                (0, misc_1.log)('formattedAccessControlConditions', JSON.stringify(formattedAccessControlConditions));
            }
            else if (evmContractConditions) {
                formattedEVMContractConditions = evmContractConditions.map((c) => (0, access_control_conditions_1.canonicalEVMContractConditionFormatter)(c));
                (0, misc_1.log)('formattedEVMContractConditions', JSON.stringify(formattedEVMContractConditions));
            }
            else if (solRpcConditions) {
                formattedSolRpcConditions = solRpcConditions.map((c) => (0, access_control_conditions_1.canonicalSolRpcConditionFormatter)(c));
                (0, misc_1.log)('formattedSolRpcConditions', JSON.stringify(formattedSolRpcConditions));
            }
            else if (unifiedAccessControlConditions) {
                formattedUnifiedAccessControlConditions =
                    unifiedAccessControlConditions.map((c) => (0, access_control_conditions_1.canonicalUnifiedAccessControlConditionFormatter)(c));
                (0, misc_1.log)('formattedUnifiedAccessControlConditions', JSON.stringify(formattedUnifiedAccessControlConditions));
            }
            else {
                error = true;
            }
            return {
                error,
                formattedAccessControlConditions,
                formattedEVMContractConditions,
                formattedSolRpcConditions,
                formattedUnifiedAccessControlConditions,
            };
        };
        /**
         *
         * Get hash of access control conditions
         *
         * @param { JsonStoreSigningRequest } params
         *
         * @returns { Promise<ArrayBuffer | undefined> }
         *
         */
        this.getHashedAccessControlConditions = async (params) => {
            let hashOfConditions;
            // ========== Prepare Params ==========
            const { accessControlConditions, evmContractConditions, solRpcConditions, unifiedAccessControlConditions, } = params;
            // ========== Hash ==========
            if (accessControlConditions) {
                hashOfConditions = await (0, access_control_conditions_1.hashAccessControlConditions)(accessControlConditions);
            }
            else if (evmContractConditions) {
                hashOfConditions = await (0, access_control_conditions_1.hashEVMContractConditions)(evmContractConditions);
            }
            else if (solRpcConditions) {
                hashOfConditions = await (0, access_control_conditions_1.hashSolRpcConditions)(solRpcConditions);
            }
            else if (unifiedAccessControlConditions) {
                hashOfConditions = await (0, access_control_conditions_1.hashUnifiedAccessControlConditions)(unifiedAccessControlConditions);
            }
            else {
                return;
            }
            // ========== Result ==========
            return hashOfConditions;
        };
        // ========== Promise Handlers ==========
        /**
         *
         * Get and gather node promises
         *
         * @param { any } callback
         *
         * @returns { Array<Promise<any>> }
         *
         */
        this.getNodePromises = (callback) => {
            const nodePromises = [];
            for (const url of this.connectedNodes) {
                nodePromises.push(callback(url));
            }
            return nodePromises;
        };
        /**
         * Handle node promises
         *
         * @param { Array<Promise<any>> } nodePromises
         *
         * @returns { Promise<SuccessNodePromises | RejectedNodePromises> }
         *
         */
        this.handleNodePromises = async (nodePromises, minNodeCount) => {
            // -- prepare
            const responses = await Promise.allSettled(nodePromises);
            const minNodes = minNodeCount ?? this.config.minNodeCount;
            // -- get fulfilled responses
            const successes = responses.filter((r) => r.status === 'fulfilled');
            // -- case: success (when success responses are more than minNodeCount)
            if (successes.length >= minNodes) {
                const successPromises = {
                    success: true,
                    values: successes.map((r) => r.value),
                };
                return successPromises;
            }
            // -- case: if we're here, then we did not succeed.  time to handle and report errors.
            // -- get "rejected" responses
            const rejected = responses.filter((r) => r.status === 'rejected');
            const mostCommonError = JSON.parse((0, misc_1.mostCommonString)(rejected.map((r) => JSON.stringify(r.reason))));
            (0, misc_1.log)(`most common error: ${JSON.stringify(mostCommonError)}`);
            const rejectedPromises = {
                success: false,
                error: mostCommonError,
            };
            return rejectedPromises;
        };
        /**
         * Run lit action on a single deterministicly selected node. It's important that the nodes use the same deterministic selection algorithm.
         *
         * @param { ExecuteJsProps } params
         *
         * @returns { Promise<SuccessNodePromises | RejectedNodePromises> }
         *
         */
        this.runOnTargetedNodes = async (params) => {
            const { code, authSig, jsParams, debug, sessionSigs, targetNodeRange } = params;
            (0, misc_1.log)('running runOnTargetedNodes:', targetNodeRange);
            if (!targetNodeRange) {
                return (0, misc_1.throwError)({
                    message: 'targetNodeRange is required',
                    errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
                });
            }
            // determine which node to run on
            let ipfsId;
            if (params.code) {
                // hash the code to get IPFS id
                const blockstore = new lit_third_party_libs_1.IPFSBundledSDK.MemoryBlockstore();
                let content = params.code;
                if (typeof content === 'string') {
                    content = new TextEncoder().encode(content);
                }
                else {
                    (0, misc_1.throwError)({
                        message: 'Invalid code content type for single node execution.  Your code param must be a string',
                        errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
                        errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
                    });
                }
                let lastCid;
                for await (const { cid } of lit_third_party_libs_1.IPFSBundledSDK.importer([{ content }], blockstore, {
                    onlyHash: true,
                })) {
                    lastCid = cid;
                }
                ipfsId = lastCid;
            }
            else {
                ipfsId = params.ipfsId;
            }
            if (!ipfsId) {
                return (0, misc_1.throwError)({
                    message: 'ipfsId is required',
                    error: constants_1.LIT_ERROR.INVALID_PARAM_TYPE,
                });
            }
            // select targetNodeRange number of random index of the bootstrapUrls.length
            const randomSelectedNodeIndexes = [];
            let nodeCounter = 0;
            while (randomSelectedNodeIndexes.length < targetNodeRange) {
                const str = `${nodeCounter}:${ipfsId.toString()}`;
                const cidBuffer = Buffer.from(str);
                const hash = (0, utils_1.sha256)(cidBuffer);
                const hashAsNumber = ethers_1.BigNumber.from(hash);
                const nodeIndex = hashAsNumber
                    .mod(this.config.bootstrapUrls.length)
                    .toNumber();
                (0, misc_1.log)('nodeIndex:', nodeIndex);
                // must be unique & less than bootstrapUrls.length
                if (!randomSelectedNodeIndexes.includes(nodeIndex) &&
                    nodeIndex < this.config.bootstrapUrls.length) {
                    randomSelectedNodeIndexes.push(nodeIndex);
                }
                nodeCounter++;
            }
            (0, misc_1.log)('Final Selected Indexes:', randomSelectedNodeIndexes);
            const requestId = this.getRequestId();
            const nodePromises = [];
            for (let i = 0; i < randomSelectedNodeIndexes.length; i++) {
                // should we mix in the jsParams?  to do this, we need a canonical way to serialize the jsParams object that will be identical in rust.
                // const jsParams = params.jsParams || {};
                // const jsParamsString = JSON.stringify(jsParams);
                const nodeIndex = randomSelectedNodeIndexes[i];
                // FIXME: we are using this.config.bootstrapUrls to pick the selected node, but we
                // should be using something like the list of nodes from the staking contract
                // because the staking nodes can change, and the rust code will use the same list
                const url = this.config.bootstrapUrls[nodeIndex];
                (0, misc_1.log)(`running on node ${nodeIndex} at ${url}`);
                const reqBody = this.getLitActionRequestBody(params);
                // -- choose the right signature
                let sigToPassToNode = this.getAuthSigOrSessionAuthSig({
                    authSig,
                    sessionSigs,
                    url,
                });
                reqBody.authSig = sigToPassToNode;
                // this return { url: string, data: JsonRequest }
                let singleNodePromise = this.getJsExecutionShares(url, reqBody, requestId);
                nodePromises.push(singleNodePromise);
            }
            const handledPromise = await this.handleNodePromises(nodePromises, targetNodeRange);
            // -- handle response
            return handledPromise;
        };
        /**
         *
         * Throw node error
         *
         * @param { RejectedNodePromises } res
         *
         * @returns { void }
         *
         */
        this._throwNodeError = (res) => {
            if (res.error && res.error.errorCode) {
                if ((res.error.errorCode === constants_1.LIT_ERROR_CODE.NODE_NOT_AUTHORIZED ||
                    res.error.errorCode === 'not_authorized') &&
                    this.config.alertWhenUnauthorized) {
                    (0, misc_1.log)('[Alert originally] You are not authorized to access to this content');
                }
                (0, misc_1.throwError)({
                    ...res.error,
                    message: res.error.message ||
                        'You are not authorized to access to this content',
                    errorCode: res.error.errorCode,
                });
            }
            else {
                (0, misc_1.throwError)({
                    message: `There was an error getting the signing shares from the nodes`,
                    error: constants_1.LIT_ERROR.UNKNOWN_ERROR,
                });
            }
        };
        // ========== Shares Resolvers ==========
        /**
         *
         * Get signatures from signed data
         *
         * @param { Array<any> } signedData
         *
         * @returns { any }
         *
         */
        this.getSessionSignatures = (signedData) => {
            // -- prepare
            let signatures = {};
            // TOOD: get keys of signedData
            const keys = Object.keys(signedData[0]);
            // -- execute
            keys.forEach((key) => {
                const shares = signedData.map((r) => r[key]);
                shares.sort((a, b) => a.shareIndex - b.shareIndex);
                const sigShares = shares.map((s) => ({
                    sigType: s.sigType,
                    shareHex: s.signatureShare,
                    shareIndex: s.shareIndex,
                    localX: s.localX,
                    localY: s.localY,
                    publicKey: s.publicKey,
                    dataSigned: s.dataSigned,
                    siweMessage: s.siweMessage,
                }));
                (0, misc_1.log)('sigShares', sigShares);
                const sigType = (0, misc_1.mostCommonString)(sigShares.map((s) => s.sigType));
                // -- validate if this.networkPubKeySet is null
                if (this.networkPubKeySet === null) {
                    (0, misc_1.throwError)({
                        message: 'networkPubKeySet cannot be null',
                        errorKind: constants_1.LIT_ERROR.PARAM_NULL_ERROR.kind,
                        errorCode: constants_1.LIT_ERROR.PARAM_NULL_ERROR.name,
                    });
                    return;
                }
                // -- validate if signature type is BLS or ECDSA
                if (sigType !== 'BLS' && sigType !== 'ECDSA') {
                    (0, misc_1.throwError)({
                        message: 'signature type is not BLS or ECDSA',
                        errorKind: constants_1.LIT_ERROR.UNKNOWN_SIGNATURE_TYPE.kind,
                        errorCode: constants_1.LIT_ERROR.UNKNOWN_SIGNATURE_TYPE.name,
                    });
                    return;
                }
                let signature;
                if (sigType === constants_1.SIGTYPE.BLS) {
                    signature = (0, crypto_1.combineBlsShares)(sigShares, this.networkPubKeySet);
                }
                else if (sigType === constants_1.SIGTYPE.ECDSA) {
                    signature = (0, crypto_1.combineEcdsaShares)(sigShares);
                }
                const encodedSig = (0, utils_1.joinSignature)({
                    r: '0x' + signature.r,
                    s: '0x' + signature.s,
                    v: signature.recid,
                });
                signatures[key] = {
                    ...signature,
                    signature: encodedSig,
                    publicKey: (0, misc_1.mostCommonString)(sigShares.map((s) => s.publicKey)),
                    dataSigned: (0, misc_1.mostCommonString)(sigShares.map((s) => s.dataSigned)),
                    siweMessage: (0, misc_1.mostCommonString)(sigShares.map((s) => s.siweMessage)),
                };
            });
            return signatures;
        };
        /**
         *
         * Get signatures from signed data
         *
         * @param { Array<any> } signedData
         *
         * @returns { any }
         *
         */
        this.getSignatures = (signedData) => {
            // -- prepare
            let signatures = {};
            // TOOD: get keys of signedData
            const keys = Object.keys(signedData[0]);
            // -- execute
            keys.forEach((key) => {
                const shares = signedData.map((r) => r[key]);
                shares.sort((a, b) => a.shareIndex - b.shareIndex);
                const sigShares = shares.map((s) => ({
                    sigType: s.sigType,
                    shareHex: s.signatureShare,
                    shareIndex: s.shareIndex,
                    localX: s.localX,
                    localY: s.localY,
                    publicKey: s.publicKey,
                    dataSigned: s.dataSigned,
                }));
                (0, misc_1.log)('sigShares', sigShares);
                const sigType = (0, misc_1.mostCommonString)(sigShares.map((s) => s.sigType));
                // -- validate if this.networkPubKeySet is null
                if (this.networkPubKeySet === null) {
                    (0, misc_1.throwError)({
                        message: 'networkPubKeySet cannot be null',
                        errorKind: constants_1.LIT_ERROR.PARAM_NULL_ERROR.kind,
                        errorCode: constants_1.LIT_ERROR.PARAM_NULL_ERROR.name,
                    });
                    return;
                }
                // -- validate if signature type is BLS or ECDSA
                if (sigType !== 'BLS' && sigType !== 'ECDSA') {
                    (0, misc_1.throwError)({
                        message: 'signature type is not BLS or ECDSA',
                        errorKind: constants_1.LIT_ERROR.UNKNOWN_SIGNATURE_TYPE.kind,
                        errorCode: constants_1.LIT_ERROR.UNKNOWN_SIGNATURE_TYPE.name,
                    });
                    return;
                }
                let signature;
                if (sigType === constants_1.SIGTYPE.BLS) {
                    signature = (0, crypto_1.combineBlsShares)(sigShares, this.networkPubKeySet);
                }
                else if (sigType === constants_1.SIGTYPE.ECDSA) {
                    signature = (0, crypto_1.combineEcdsaShares)(sigShares);
                }
                const encodedSig = (0, utils_1.joinSignature)({
                    r: '0x' + signature.r,
                    s: '0x' + signature.s,
                    v: signature.recid,
                });
                signatures[key] = {
                    ...signature,
                    signature: encodedSig,
                    publicKey: (0, misc_1.mostCommonString)(sigShares.map((s) => s.publicKey)),
                    dataSigned: (0, misc_1.mostCommonString)(sigShares.map((s) => s.dataSigned)),
                };
            });
            return signatures;
        };
        /**
         *
         * Get the decryptions from the decrypted data list
         *
         * @param { Array<any> } decryptedData
         *
         * @returns { Promise<Array<any>> }
         *
         */
        this.getDecryptions = async (decryptedData) => {
            // -- prepare params
            let decryptions;
            Object.keys(decryptedData[0]).forEach(async (key) => {
                // -- prepare
                const shares = decryptedData.map((r) => r[key]);
                const decShares = shares.map((s) => ({
                    algorithmType: s.algorithmType,
                    decryptionShare: s.decryptionShare,
                    shareIndex: s.shareIndex,
                    publicKey: s.publicKey,
                    ciphertext: s.ciphertext,
                }));
                const algorithmType = (0, misc_1.mostCommonString)(decShares.map((s) => s.algorithmType));
                const ciphertext = (0, misc_1.mostCommonString)(decShares.map((s) => s.ciphertext));
                // -- validate if this.networkPubKeySet is null
                if (this.networkPubKeySet === null) {
                    (0, misc_1.throwError)({
                        message: 'networkPubKeySet cannot be null',
                        errorKind: constants_1.LIT_ERROR.PARAM_NULL_ERROR.kind,
                        errorCode: constants_1.LIT_ERROR.PARAM_NULL_ERROR.name,
                    });
                    return;
                }
                let decrypted;
                if (algorithmType === 'BLS') {
                    decrypted = await (0, crypto_1.combineBlsDecryptionShares)(decShares, this.networkPubKeySet, ciphertext);
                }
                else {
                    (0, misc_1.throwError)({
                        message: 'Unknown decryption algorithm type',
                        errorKind: constants_1.LIT_ERROR.UNKNOWN_DECRYPTION_ALGORITHM_TYPE_ERROR.kind,
                        errorCode: constants_1.LIT_ERROR.UNKNOWN_DECRYPTION_ALGORITHM_TYPE_ERROR.name,
                    });
                }
                decryptions[key] = {
                    decrypted: (0, uint8arrays_1.uint8arrayToString)(decrypted, 'base16'),
                    publicKey: (0, misc_1.mostCommonString)(decShares.map((s) => s.publicKey)),
                    ciphertext: (0, misc_1.mostCommonString)(decShares.map((s) => s.ciphertext)),
                };
            });
            return decryptions;
        };
        /**
         *
         * Get a single signature
         *
         * @param { Array<any> } shareData from all node promises
         *
         * @returns { string } signature
         *
         */
        this.getSignature = async (shareData) => {
            // R_x & R_y values can come from any node (they will be different per node), and will generate a valid signature
            const R_x = shareData[0].local_x;
            const R_y = shareData[0].local_y;
            // the public key can come from any node - it obviously will be identical from each node
            const public_key = shareData[0].public_key;
            const valid_shares = shareData.map((s) => s.signature_share);
            const shares = JSON.stringify(valid_shares);
            await wasmECDSA.initWasmEcdsaSdk(); // init WASM
            const signature = wasmECDSA.combine_signature(R_x, R_y, shares);
            (0, misc_1.log)('raw ecdsa sig', signature);
            return signature;
        };
        // ========== Scoped Business Logics ==========
        /**
         *
         * Execute JS on the nodes and combine and return any resulting signatures
         *
         * @param { ExecuteJsRequest } params
         *
         * @returns { ExecuteJsResponse }
         *
         */
        this.executeJs = async (params) => {
            // ========== Prepare Params ==========
            const { code, ipfsId, authSig, jsParams, debug, sessionSigs, targetNodeRange, } = params;
            // ========== Validate Params ==========
            // -- validate: If it's NOT ready
            if (!this.ready) {
                const message = '1 LitNodeClient is not ready.  Please call await litNodeClient.connect() first.';
                (0, misc_1.throwError)({
                    message,
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            const paramsIsSafe = (0, encryption_1.safeParams)({
                functionName: 'executeJs',
                params: params,
            });
            if (!paramsIsSafe) {
                return (0, misc_1.throwError)({
                    message: 'executeJs params are not valid',
                    errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
                });
            }
            let res;
            // -- only run on a single node
            if (targetNodeRange) {
                res = await this.runOnTargetedNodes(params);
            }
            else {
                // ========== Prepare Variables ==========
                // -- prepare request body
                const reqBody = this.getLitActionRequestBody(params);
                // ========== Get Node Promises ==========
                // -- fetch shares from nodes
                const requestId = this.getRequestId();
                const nodePromises = this.getNodePromises((url) => {
                    // -- choose the right signature
                    let sigToPassToNode = this.getAuthSigOrSessionAuthSig({
                        authSig,
                        sessionSigs,
                        url,
                    });
                    reqBody.authSig = sigToPassToNode;
                    return this.getJsExecutionShares(url, reqBody, requestId);
                });
                // -- resolve promises
                res = await this.handleNodePromises(nodePromises);
            }
            // -- case: promises rejected
            if (res.success === false) {
                this._throwNodeError(res);
            }
            // -- case: promises success (TODO: check the keys of "values")
            const responseData = res.values;
            (0, misc_1.log)('responseData', JSON.stringify(responseData, null, 2));
            // ========== Extract shares from response data ==========
            // -- 1. combine signed data as a list, and get the signatures from it
            const signedDataList = responseData.map((r) => r.signedData);
            const signatures = this.getSignatures(signedDataList);
            // -- 2. combine decrypted data a list, and get the decryptions from it
            const decryptedDataList = responseData.map((r) => r.decryptedData);
            const decryptions = await this.getDecryptions(decryptedDataList);
            // -- 3. combine responses as a string, and get parse it as JSON
            let response = (0, misc_1.mostCommonString)(responseData.map((r) => r.response));
            response = this.parseResponses(response);
            // -- 4. combine logs
            const mostCommonLogs = (0, misc_1.mostCommonString)(responseData.map((r) => r.logs));
            // ========== Result ==========
            let returnVal = {
                signatures,
                decryptions,
                response,
                logs: mostCommonLogs,
            };
            // -- case: debug mode
            if (debug) {
                const allNodeResponses = responseData.map((r) => r.response);
                const allNodeLogs = responseData.map((r) => r.logs);
                returnVal.debug = {
                    allNodeResponses,
                    allNodeLogs,
                    rawNodeHTTPResponses: responseData,
                };
            }
            return returnVal;
        };
        /**
         *
         * Request a signed JWT of any solidity function call from the LIT network.  There are no prerequisites for this function.  You should use this function if you need to transmit information across chains, or from a blockchain to a centralized DB or server.  The signature of the returned JWT verifies that the response is genuine.
         *
         * @param { SignedChainDataToken } params
         *
         * @returns { Promise<string>}
         */
        this.getSignedChainDataToken = async (params) => {
            // ========== Prepare Params ==========
            const { callRequests, chain } = params;
            // ========== Pre-Validations ==========
            // -- validate if it's ready
            if (!this.ready) {
                const message = '2 LitNodeClient is not ready.  Please call await litNodeClient.connect() first.';
                return (0, misc_1.throwError)({
                    message,
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            // -- validate if this.networkPubKeySet is null
            if (this.networkPubKeySet === null) {
                return (0, misc_1.throwError)({
                    message: 'networkPubKeySet cannot be null',
                    errorKind: constants_1.LIT_ERROR.PARAM_NULL_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.PARAM_NULL_ERROR.name,
                });
            }
            // ========== Prepare ==========
            // we need to send jwt params iat (issued at) and exp (expiration)
            // because the nodes may have different wall clock times
            // the nodes will verify that these params are withing a grace period
            const { iat, exp } = this.getJWTParams();
            // ========== Get Node Promises ==========
            // -- fetch shares from nodes
            const requestId = this.getRequestId();
            const nodePromises = this.getNodePromises((url) => {
                return this.getChainDataSigningShare(url, {
                    callRequests,
                    chain,
                    iat,
                    exp,
                }, requestId);
            });
            // -- resolve promises
            const signatureShares = await Promise.all(nodePromises);
            (0, misc_1.log)('signatureShares', signatureShares);
            // -- total of good shares
            const goodShares = signatureShares.filter((d) => d.signatureShare !== '');
            // ========== Shares Validations ==========
            // -- validate if we have enough good shares
            if (goodShares.length < this.config.minNodeCount) {
                (0, misc_1.log)(`majority of shares are bad. goodShares is ${JSON.stringify(goodShares)}`);
                if (this.config.alertWhenUnauthorized) {
                    alert('You are not authorized to receive a signature to grant access to this content');
                }
                (0, misc_1.throwError)({
                    message: `You are not authorized to recieve a signature on this item`,
                    errorKind: constants_1.LIT_ERROR.UNAUTHROZIED_EXCEPTION.kind,
                    errorCode: constants_1.LIT_ERROR.UNAUTHROZIED_EXCEPTION.name,
                });
            }
            // ========== Result ==========
            const finalJwt = this.combineSharesAndGetJWT(this.networkPubKeySet, signatureShares);
            return finalJwt;
        };
        /**
         *
         * Request a signed JWT from the LIT network. Before calling this function, you must either create or know of a resource id and access control conditions for the item you wish to gain authorization for. You can create an access control condition using the saveSigningCondition function.
         *
         * @param { JsonSigningRetrieveRequest } params
         *
         * @returns { Promise<string> } final JWT
         *
         */
        this.getSignedToken = async (params) => {
            // ========== Prepare Params ==========
            const { 
            // accessControlConditions,
            // evmContractConditions,
            // solRpcConditions,
            // unifiedAccessControlConditions,
            chain, authSig, resourceId, sessionSigs, } = params;
            // ========== Pre-Validations ==========
            // -- validate if it's ready
            if (!this.ready) {
                const message = '3 LitNodeClient is not ready.  Please call await litNodeClient.connect() first.';
                (0, misc_1.throwError)({
                    message,
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            // -- validate if this.networkPubKeySet is null
            if (this.networkPubKeySet === null) {
                return (0, misc_1.throwError)({
                    message: 'networkPubKeySet cannot be null',
                    errorKind: constants_1.LIT_ERROR.PARAM_NULL_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.PARAM_NULL_ERROR.name,
                });
            }
            // ========== Prepare ==========
            // we need to send jwt params iat (issued at) and exp (expiration)
            // because the nodes may have different wall clock times
            // the nodes will verify that these params are withing a grace period
            const { iat, exp } = this.getJWTParams();
            // ========== Formatting Access Control Conditions =========
            const { error, formattedAccessControlConditions, formattedEVMContractConditions, formattedSolRpcConditions, formattedUnifiedAccessControlConditions, } = this.getFormattedAccessControlConditions(params);
            if (error) {
                return (0, misc_1.throwError)({
                    message: `You must provide either accessControlConditions or evmContractConditions or solRpcConditions or unifiedAccessControlConditions`,
                    errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
                });
            }
            if (!resourceId) {
                return (0, misc_1.throwError)({
                    message: `You must provide a resourceId`,
                    errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
                });
            }
            const formattedResourceId = (0, access_control_conditions_1.canonicalResourceIdFormatter)(resourceId);
            // ========== Get Node Promises ==========
            const requestId = this.getRequestId();
            const nodePromises = this.getNodePromises((url) => {
                // -- if session key is available, use it
                let authSigToSend = sessionSigs ? sessionSigs[url] : authSig;
                return this.getSigningShare(url, {
                    accessControlConditions: formattedAccessControlConditions,
                    evmContractConditions: formattedEVMContractConditions,
                    solRpcConditions: formattedSolRpcConditions,
                    unifiedAccessControlConditions: formattedUnifiedAccessControlConditions,
                    chain,
                    authSig: authSigToSend,
                    resourceId: formattedResourceId,
                    iat,
                    exp,
                }, requestId);
            });
            // -- resolve promises
            const res = await this.handleNodePromises(nodePromises);
            // -- case: promises rejected
            if (res.success === false) {
                this._throwNodeError(res);
            }
            const signatureShares = res
                .values;
            (0, misc_1.log)('signatureShares', signatureShares);
            // ========== Result ==========
            const finalJwt = this.combineSharesAndGetJWT(this.networkPubKeySet, signatureShares);
            return finalJwt;
        };
        /**
         *
         * Associated access control conditions with a resource on the web.  After calling this function, users may use the getSignedToken function to request a signed JWT from the LIT network.  This JWT proves that the user meets the access control conditions, and is authorized to access the resource you specified in the resourceId parameter of the saveSigningCondition function.
         *
         * @param { JsonStoreSigningRequest } params
         *
         * @returns { Promise<boolean> }
         *
         */
        this.saveSigningCondition = async (params) => {
            // -- validate if it's ready
            if (!this.ready) {
                const message = '4 LitNodeClient is not ready.  Please call await litNodeClient.connect() first.';
                (0, misc_1.throwError)({
                    message,
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            // this is to fix my spelling mistake that we must now maintain forever lol
            if (typeof params.permanant !== 'undefined') {
                params.permanent = params.permanant;
            }
            // ========== Prepare Params ==========
            const { 
            // accessControlConditions,
            // evmContractConditions,
            // solRpcConditions,
            // unifiedAccessControlConditions,
            chain, authSig, resourceId, 
            // permanant,
            permanent, sessionSigs, } = params;
            // ----- validate params -----
            // validate if resourceId is null
            if (!resourceId) {
                return (0, misc_1.throwError)({
                    message: 'resourceId cannot be null',
                    errorKind: constants_1.LIT_ERROR.PARAM_NULL_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.PARAM_NULL_ERROR.name,
                });
            }
            // ========== Hashing Resource ID & Conditions ==========
            // hash the resource id
            const hashOfResourceId = await (0, access_control_conditions_1.hashResourceId)(resourceId);
            const hashOfResourceIdStr = (0, uint8arrays_1.uint8arrayToString)(new Uint8Array(hashOfResourceId), 'base16');
            let hashOfConditions = await this.getHashedAccessControlConditions(params);
            if (!hashOfConditions) {
                return (0, misc_1.throwError)({
                    message: `You must provide either accessControlConditions or evmContractConditions or solRpcConditions or unifiedAccessControlConditions`,
                    errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
                });
            }
            const hashOfConditionsStr = (0, uint8arrays_1.uint8arrayToString)(new Uint8Array(hashOfConditions), 'base16');
            // ========== Get Node Promises ==========
            const requestId = this.getRequestId();
            const nodePromises = this.getNodePromises((url) => {
                // -- if session key is available, use it
                let authSigToSend = sessionSigs ? sessionSigs[url] : authSig;
                return this.storeSigningConditionWithNode(url, {
                    key: hashOfResourceIdStr,
                    val: hashOfConditionsStr,
                    authSig: authSigToSend,
                    chain,
                    permanent: permanent ? 1 : 0,
                }, requestId);
            });
            // -- resolve promises
            const res = await this.handleNodePromises(nodePromises);
            // -- case: promises rejected
            if (res.success === false) {
                this._throwNodeError(res);
            }
            return true;
        };
        /**
         *
         * Retrieve the symmetric encryption key from the LIT nodes.  Note that this will only work if the current user meets the access control conditions specified when the data was encrypted.  That access control condition is typically that the user is a holder of the NFT that corresponds to this encrypted data.  This NFT token address and ID was specified when this LIT was created.
         *
         */
        this.getEncryptionKey = async (params) => {
            // -- validate if it's ready
            if (!this.ready) {
                const message = '5 LitNodeClient is not ready.  Please call await litNodeClient.connect() first.';
                (0, misc_1.throwError)({
                    message,
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            // -- validate if this.networkPubKeySet is null
            if (!this.networkPubKeySet) {
                const message = 'networkPubKeySet cannot be null';
                (0, misc_1.throwError)({
                    message,
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            // ========== Prepare Params ==========
            const { chain, authSig, resourceId, toDecrypt } = params;
            // ========== Validate Params ==========
            const paramsIsSafe = (0, encryption_1.safeParams)({
                functionName: 'getEncryptionKey',
                params: params,
            });
            if (!paramsIsSafe) {
                (0, misc_1.throwError)({
                    message: `You must provide either accessControlConditions or evmContractConditions or solRpcConditions or unifiedAccessControlConditions`,
                    errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
                });
            }
            // ========== Formatting Access Control Conditions =========
            const { error, formattedAccessControlConditions, formattedEVMContractConditions, formattedSolRpcConditions, formattedUnifiedAccessControlConditions, } = this.getFormattedAccessControlConditions(params);
            if (error) {
                (0, misc_1.throwError)({
                    message: `You must provide either accessControlConditions or evmContractConditions or solRpcConditions or unifiedAccessControlConditions`,
                    errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
                });
            }
            // ========== Node Promises ==========
            const requestId = this.getRequestId();
            const nodePromises = this.getNodePromises((url) => {
                // -- choose the right signature
                let sigToPassToNode = this.getAuthSigOrSessionAuthSig({
                    authSig: params.authSig,
                    sessionSigs: params.sessionSigs,
                    url,
                });
                return this.getDecryptionShare(url, {
                    accessControlConditions: formattedAccessControlConditions,
                    evmContractConditions: formattedEVMContractConditions,
                    solRpcConditions: formattedSolRpcConditions,
                    unifiedAccessControlConditions: formattedUnifiedAccessControlConditions,
                    toDecrypt,
                    authSig: sigToPassToNode,
                    chain,
                }, requestId);
            });
            // -- resolve promises
            const res = await this.handleNodePromises(nodePromises);
            // -- case: promises rejected
            if (res.success === false) {
                this._throwNodeError(res);
            }
            const decryptionShares = res
                .values;
            (0, misc_1.log)('decryptionShares', decryptionShares);
            if (!this.networkPubKeySet) {
                return (0, misc_1.throwError)({
                    message: 'networkPubKeySet cannot be null',
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            // ========== Combine Shares ==========
            const decrypted = (0, crypto_1.combineBlsDecryptionShares)(decryptionShares, this.networkPubKeySet, toDecrypt);
            return decrypted;
        };
        /**
         *
         * Securely save the association between access control conditions and something that you wish to decrypt
         *
         * @param { JsonSaveEncryptionKeyRequest } params
         *
         * @returns { Promise<Uint8Array> }
         *
         */
        this.saveEncryptionKey = async (params) => {
            // ========= Prepare Params ==========
            const { encryptedSymmetricKey, symmetricKey, authSig, chain, permanent } = params;
            // ========== Validate Params ==========
            // -- validate if it's ready
            if (!this.ready) {
                const message = '6 LitNodeClient is not ready.  Please call await litNodeClient.connect() first.';
                (0, misc_1.throwError)({
                    message,
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            // -- validate if this.subnetPubKey is null
            if (!this.subnetPubKey) {
                const message = 'subnetPubKey cannot be null';
                return (0, misc_1.throwError)({
                    message,
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            const paramsIsSafe = (0, encryption_1.safeParams)({
                functionName: 'saveEncryptionKey',
                params,
            });
            if (!paramsIsSafe) {
                return (0, misc_1.throwError)({
                    message: `You must provide either accessControlConditions or evmContractConditions or solRpcConditions or unifiedAccessControlConditions`,
                    errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
                });
            }
            // ========== Encryption ==========
            // -- encrypt with network pubkey
            let encryptedKey;
            if (encryptedSymmetricKey) {
                encryptedKey = encryptedSymmetricKey;
            }
            else {
                encryptedKey = bls_sdk_1.wasmBlsSdkHelpers.encrypt((0, uint8arrays_1.uint8arrayFromString)(this.subnetPubKey, 'base16'), symmetricKey);
                (0, misc_1.log)('symmetric key encrypted with LIT network key: ', (0, uint8arrays_1.uint8arrayToString)(encryptedKey, 'base16'));
            }
            // ========== Hashing ==========
            // -- hash the encrypted pubkey
            const hashOfKey = await crypto.subtle.digest('SHA-256', encryptedKey);
            const hashOfKeyStr = (0, uint8arrays_1.uint8arrayToString)(new Uint8Array(hashOfKey), 'base16');
            // hash the access control conditions
            let hashOfConditions = await this.getHashedAccessControlConditions(params);
            if (!hashOfConditions) {
                return (0, misc_1.throwError)({
                    message: `You must provide either accessControlConditions or evmContractConditions or solRpcConditions or unifiedAccessControlConditions`,
                    errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
                });
            }
            const hashOfConditionsStr = (0, uint8arrays_1.uint8arrayToString)(new Uint8Array(hashOfConditions), 'base16');
            // ========== Node Promises ==========
            const requestId = this.getRequestId();
            const nodePromises = this.getNodePromises((url) => {
                // -- choose the right signature
                let sigToPassToNode = this.getAuthSigOrSessionAuthSig({
                    authSig: params.authSig,
                    sessionSigs: params.sessionSigs,
                    url,
                });
                return this.storeEncryptionConditionWithNode(url, {
                    key: hashOfKeyStr,
                    val: hashOfConditionsStr,
                    authSig: sigToPassToNode,
                    chain,
                    permanent: permanent ? 1 : 0,
                }, requestId);
            });
            // -- resolve promises
            const res = await this.handleNodePromises(nodePromises);
            // -- case: promises rejected
            if (res.success === false) {
                this._throwNodeError(res);
            }
            return encryptedKey;
        };
        /**
         *
         * Validates a condition, and then signs the condition if the validation returns true.
         * Before calling this function, you must know the on chain conditions that you wish to validate.
         *
         * @param { ValidateAndSignECDSA } params
         *
         * @returns { Promise<string> }
         */
        this.validateAndSignEcdsa = async (params) => {
            // ========== Validate Params ==========
            // -- validate if it's ready
            if (!this.ready) {
                const message = '7 LitNodeClient is not ready.  Please call await litNodeClient.connect() first.';
                (0, misc_1.throwError)({
                    message,
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            // ========== Prepare Params ==========
            const { accessControlConditions, chain, auth_sig } = params;
            // ========== Prepare JWT Params ==========
            // we need to send jwt params iat (issued at) and exp (expiration)
            // because the nodes may have different wall clock times
            // the nodes will verify that these params are withing a grace period
            const { iat, exp } = this.getJWTParams();
            // -- validate
            if (!accessControlConditions) {
                return (0, misc_1.throwError)({
                    message: `You must provide either accessControlConditions or evmContractConditions or solRpcConditions`,
                    errorKind: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.kind,
                    errorCode: constants_1.LIT_ERROR.INVALID_ARGUMENT_EXCEPTION.name,
                });
            }
            // -- formatted access control conditions
            let formattedAccessControlConditions;
            formattedAccessControlConditions = accessControlConditions.map((c) => (0, access_control_conditions_1.canonicalAccessControlConditionFormatter)(c));
            (0, misc_1.log)('formattedAccessControlConditions', JSON.stringify(formattedAccessControlConditions));
            // ========== Node Promises ==========
            const requestId = this.getRequestId();
            const nodePromises = this.getNodePromises((url) => {
                return this.signConditionEcdsa(url, {
                    accessControlConditions: formattedAccessControlConditions,
                    evmContractConditions: undefined,
                    solRpcConditions: undefined,
                    auth_sig,
                    chain,
                    iat,
                    exp,
                }, requestId);
            });
            // ----- Resolve Promises -----
            try {
                const shareData = await Promise.all(nodePromises);
                if (shareData[0].result == 'failure')
                    return 'Condition Failed';
                const signature = this.getSignature(shareData);
                return signature;
            }
            catch (e) {
                (0, misc_1.log)('Error - signed_ecdsa_messages - ', e);
                const signed_ecdsa_message = nodePromises[0];
                return signed_ecdsa_message;
            }
        };
        /**
         *
         * Connect to the LIT nodes
         *
         * @returns { Promise } A promise that resolves when the nodes are connected.
         *
         */
        this.connect = () => {
            // -- handshake with each node
            const requestId = this.getRequestId();
            for (const url of this.config.bootstrapUrls) {
                this.handshakeWithSgx({ url }, requestId)
                    .then((resp) => {
                    this.connectedNodes.add(url);
                    let keys = {
                        serverPubKey: resp.serverPublicKey,
                        subnetPubKey: resp.subnetPublicKey,
                        networkPubKey: resp.networkPublicKey,
                        networkPubKeySet: resp.networkPublicKeySet,
                    };
                    this.serverKeys[url] = keys;
                })
                    .catch((e) => {
                    (0, misc_1.log)('Error connecting to node ', url, e);
                });
            }
            // -- get promise
            const promise = new Promise((resolve, reject) => {
                const startTime = Date.now();
                const interval = setInterval(() => {
                    if (Object.keys(this.serverKeys).length >= this.config.minNodeCount) {
                        clearInterval(interval);
                        // pick the most common public keys for the subnet and network from the bunch, in case some evil node returned a bad key
                        this.subnetPubKey = (0, misc_1.mostCommonString)(Object.values(this.serverKeys).map((keysFromSingleNode) => keysFromSingleNode.subnetPubKey));
                        this.networkPubKey = (0, misc_1.mostCommonString)(Object.values(this.serverKeys).map((keysFromSingleNode) => keysFromSingleNode.networkPubKey));
                        this.networkPubKeySet = (0, misc_1.mostCommonString)(Object.values(this.serverKeys).map((keysFromSingleNode) => keysFromSingleNode.networkPubKeySet));
                        this.ready = true;
                        (0, misc_1.log)(`🔥 lit is ready. "litNodeClient" variable is ready to use globally.`);
                        // @ts-ignore
                        globalThis.litNodeClient = this;
                        // browser only
                        if ((0, misc_1.isBrowser)()) {
                            document.dispatchEvent(new Event('lit-ready'));
                        }
                        // @ts-ignore: Expected 1 arguments, but got 0. Did you forget to include 'void' in your type argument to 'Promise'?ts(2794)
                        resolve();
                    }
                    else {
                        const now = Date.now();
                        if (now - startTime > this.config.connectTimeout) {
                            clearInterval(interval);
                            const msg = `Error: Could not connect to enough nodes after timeout of ${this.config.connectTimeout}ms.  Could only connect to ${Object.keys(this.serverKeys).length} of ${this.config.minNodeCount} required nodes.  Please check your network connection and try again.  Note that you can control this timeout with the connectTimeout config option which takes milliseconds.`;
                            (0, misc_1.log)(msg);
                            reject(msg);
                        }
                    }
                }, 500);
            });
            return promise;
        };
        /** ============================== SESSION ============================== */
        /**
         * Sign a session public key using a PKP, which generates an authSig.
         * @returns {Object} An object containing the resulting signature.
         */
        this.signSessionKey = async (params) => {
            // ========== Validate Params ==========
            // -- validate: If it's NOT ready
            if (!this.ready) {
                const message = '8 LitNodeClient is not ready.  Please call await litNodeClient.connect() first.';
                (0, misc_1.throwError)({
                    message,
                    errorKind: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.LIT_NODE_CLIENT_NOT_READY_ERROR.name,
                });
            }
            // -- construct SIWE message that will be signed by node to generate an authSig.
            const _expiration = params.expiration ||
                new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString();
            // Try to get it from local storage, if not generates one~
            let sessionKey = this.getSessionKey(params.sessionKey);
            let sessionKeyUri = constants_1.LIT_SESSION_KEY_URI + sessionKey.publicKey;
            // Compute the address from the public key if it's provided. Otherwise, the node will compute it.
            const pkpEthAddress = (function () {
                if (params.pkpPublicKey)
                    return (0, transactions_1.computeAddress)(params.pkpPublicKey);
                // This will be populated by the node, using dummy value for now.
                return '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2';
            })();
            let siweMessage = new lit_siwe_1.SiweMessage({
                domain: params?.domain || globalThis.location?.host || 'litprotocol.com',
                address: pkpEthAddress,
                statement: 'Lit Protocol PKP session signature',
                uri: sessionKeyUri,
                version: '1',
                chainId: params.chainId ?? 1,
                expirationTime: _expiration,
                resources: params.resources,
            });
            let siweMessageStr = siweMessage.prepareMessage();
            // ========== Get Node Promises ==========
            // -- fetch shares from nodes
            const requestId = this.getRequestId();
            const nodePromises = this.getNodePromises((url) => {
                return this.getSignSessionKeyShares(url, {
                    body: {
                        sessionKey: sessionKeyUri,
                        authMethods: params.authMethods,
                        pkpPublicKey: params.pkpPublicKey,
                        authSig: params.authSig,
                        siweMessage: siweMessageStr,
                    },
                }, requestId);
            });
            // -- resolve promises
            const res = await this.handleNodePromises(nodePromises);
            // -- case: promises rejected
            if (!tslib_1.__classPrivateFieldGet(this, _LitNodeClientNodeJs_isSuccessNodePromises, "f").call(this, res)) {
                this._throwNodeError(res);
                return {};
            }
            const responseData = res.values;
            (0, misc_1.log)('responseData', JSON.stringify(responseData, null, 2));
            // ========== Extract shares from response data ==========
            // -- 1. combine signed data as a list, and get the signatures from it
            const signedDataList = responseData.map((r) => r.signedData);
            const signatures = this.getSessionSignatures(signedDataList);
            const { sessionSig } = signatures;
            return {
                authSig: {
                    sig: sessionSig.signature,
                    derivedVia: 'web3.eth.personal.sign via Lit PKP',
                    signedMessage: sessionSig.siweMessage,
                    address: (0, transactions_1.computeAddress)('0x' + sessionSig.publicKey),
                },
                pkpPublicKey: sessionSig.publicKey,
            };
        };
        _LitNodeClientNodeJs_isSuccessNodePromises.set(this, (res) => {
            return res.success === true;
        });
        this.getSignSessionKeyShares = async (url, params, requestId) => {
            (0, misc_1.log)('getSignSessionKeyShares');
            const urlWithPath = `${url}/web/sign_session_key`;
            return await this.sendCommandToNode({
                url: urlWithPath,
                data: params.body,
                requestId,
            });
        };
        this.generateAuthMethodForWebAuthn = (params) => ({
            authMethodType: constants_1.AUTH_METHOD_TYPE_IDS.WEBAUTHN,
            accessToken: JSON.stringify(params),
        });
        this.generateAuthMethodForDiscord = (access_token) => ({
            authMethodType: constants_1.AUTH_METHOD_TYPE_IDS.DISCORD,
            accessToken: access_token,
        });
        this.generateAuthMethodForGoogle = (access_token) => ({
            authMethodType: constants_1.AUTH_METHOD_TYPE_IDS.GOOGLE,
            accessToken: access_token,
        });
        this.generateAuthMethodForGoogleJWT = (access_token) => ({
            authMethodType: constants_1.AUTH_METHOD_TYPE_IDS.GOOGLE_JWT,
            accessToken: access_token,
        });
        this.parseResource = ({ resource, }) => {
            const [protocol, resourceId] = resource.split('://');
            return { protocol, resourceId };
        };
        /**
         * Get session signatures for a set of resources
         *
         * High level, how this works:
         * 1. Generate or retrieve session key
         * 2. Generate or retrieve the wallet signature of the session key
         * 3. Sign the specific resources with the session key
         *
         * @param { GetSessionSigsProps } params
         */
        this.getSessionSigs = async (params) => {
            // -- prepare
            // Try to get it from local storage, if not generates one~
            let sessionKey = this.getSessionKey(params.sessionKey);
            let sessionKeyUri = constants_1.LIT_SESSION_KEY_URI + sessionKey.publicKey;
            let capabilities = this.getSessionCapabilities(params.sessionCapabilities, params.resources);
            let expiration = params.expiration || this.getExpiration();
            // -- (TRY) to get the wallet signature
            let walletSig = await this.getWalletSig({
                authNeededCallback: params.authNeededCallback,
                chain: params.chain,
                capabilities: capabilities,
                switchChain: params.switchChain,
                expiration: expiration,
                sessionKeyUri: sessionKeyUri,
            });
            let siweMessage = new lit_siwe_1.SiweMessage(walletSig?.signedMessage);
            let needToResignSessionKey = await this.checkNeedToResignSessionKey({
                siweMessage,
                walletSignature: walletSig?.sig,
                sessionKeyUri,
                resources: params.resources,
                sessionCapabilities: capabilities,
            });
            // -- (CHECK) if we need to resign the session key
            if (needToResignSessionKey) {
                (0, misc_1.log)('need to re-sign session key.  Signing...');
                if (params.authNeededCallback) {
                    walletSig = await params.authNeededCallback({
                        chain: params.chain,
                        resources: capabilities,
                        expiration,
                        uri: sessionKeyUri,
                    });
                }
                else {
                    if (!this.defaultAuthCallback) {
                        return (0, misc_1.throwError)({
                            message: 'No default auth callback provided',
                            errorKind: constants_1.LIT_ERROR.PARAMS_MISSING_ERROR.kind,
                            errorCode: constants_1.LIT_ERROR.PARAMS_MISSING_ERROR.name,
                        });
                    }
                    walletSig = await this.defaultAuthCallback({
                        chain: params.chain,
                        resources: capabilities,
                        switchChain: params.switchChain,
                        expiration,
                        uri: sessionKeyUri,
                    });
                }
            }
            if (walletSig.address === '' ||
                walletSig.derivedVia === '' ||
                walletSig.sig === '' ||
                walletSig.signedMessage === '') {
                (0, misc_1.throwError)({
                    message: 'No wallet signature found',
                    errorKind: constants_1.LIT_ERROR.WALLET_SIGNATURE_NOT_FOUND_ERROR.kind,
                    errorCode: constants_1.LIT_ERROR.WALLET_SIGNATURE_NOT_FOUND_ERROR.name,
                });
                return;
            }
            // ===== AFTER we have Valid Signed Session Key =====
            // - Let's sign the resources with the session key
            // - 5 minutes is the default expiration for a session signature
            // - Because we can generate a new session sig every time the user wants to access a resource without prompting them to sign with their wallet
            let sessionExpiration = new Date(Date.now() + 1000 * 60 * 5);
            const signingTemplate = {
                sessionKey: sessionKey.publicKey,
                resources: params.resources,
                capabilities: [walletSig],
                issuedAt: new Date().toISOString(),
                expiration: sessionExpiration.toISOString(),
            };
            const signatures = {};
            this.connectedNodes.forEach((nodeAddress) => {
                const toSign = {
                    ...signingTemplate,
                    nodeAddress,
                };
                let signedMessage = JSON.stringify(toSign);
                const uint8arrayKey = (0, uint8arrays_1.uint8arrayFromString)(sessionKey.secretKey, 'base16');
                const uint8arrayMessage = (0, uint8arrays_1.uint8arrayFromString)(signedMessage, 'utf8');
                let signature = nacl_1.nacl.sign.detached(uint8arrayMessage, uint8arrayKey);
                // log("signature", signature);
                signatures[nodeAddress] = {
                    sig: (0, uint8arrays_1.uint8arrayToString)(signature, 'base16'),
                    derivedVia: 'litSessionSignViaNacl',
                    signedMessage,
                    address: sessionKey.publicKey,
                    algo: 'ed25519',
                };
            });
            (0, misc_1.log)('signatures:', signatures);
            return signatures;
        };
        let customConfig = args;
        // -- initialize default config
        this.config = constants_1.defaultLitnodeClientConfig;
        // -- initialize default auth callback
        this.defaultAuthCallback = args?.defaultAuthCallback;
        // -- if config params are specified, replace it
        if (customConfig) {
            this.config = { ...this.config, ...customConfig };
            // this.config = override(this.config, customConfig);
        }
        // -- init default properties
        this.connectedNodes = new Set();
        this.serverKeys = {};
        this.ready = false;
        this.subnetPubKey = null;
        this.networkPubKey = null;
        this.networkPubKeySet = null;
        // -- set bootstrapUrls to match the network litNetwork unless it's set to custom
        this.setCustomBootstrapUrls();
        // -- set global variables
        globalThis.litConfig = this.config;
    }
    /**
     * Check if a given object is of type SessionKeyPair.
     *
     * @param obj - The object to check.
     * @returns True if the object is of type SessionKeyPair.
     */
    isSessionKeyPair(obj) {
        return (typeof obj === 'object' &&
            'publicKey' in obj &&
            'secretKey' in obj &&
            typeof obj.publicKey === 'string' &&
            typeof obj.secretKey === 'string');
    }
    /**
     *
     * Get a random request ID
     *   *
     * @returns { string }
     *
     */
    getRequestId() {
        return Math.random().toString(16).slice(2);
    }
}
exports.LitNodeClientNodeJs = LitNodeClientNodeJs;
_LitNodeClientNodeJs_isSuccessNodePromises = new WeakMap();
//# sourceMappingURL=lit-node-client-nodejs.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/lit-node-client/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.disconnectWeb3 = exports.ethConnect = exports.parseResource = exports.getSessionKeyUri = exports.checkAndSignAuthMessage = void 0;
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const _LitNodeClient = __webpack_require__("../../node_modules/@lit-protocol/lit-node-client/src/lib/lit-node-client.js");
// ==================== Environment ====================
if ((0, misc_1.isNode)()) {
    (0, misc_1.log)('Oh hey you are running in Node.js!');
    const fetch = __webpack_require__("./src/shim/node-fetch.ts");
    globalThis.fetch = fetch;
}
const LitNodeClient = _LitNodeClient.LitNodeClient;
if (!globalThis.LitNodeClient) {
    globalThis.LitNodeClient = LitNodeClient;
}
// ==================== Exports ====================
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/lit-node-client/src/lib/lit-node-client.js"), exports);
var auth_browser_1 = __webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/index.js");
Object.defineProperty(exports, "checkAndSignAuthMessage", ({ enumerable: true, get: function () { return auth_browser_1.checkAndSignAuthMessage; } }));
Object.defineProperty(exports, "getSessionKeyUri", ({ enumerable: true, get: function () { return auth_browser_1.getSessionKeyUri; } }));
Object.defineProperty(exports, "parseResource", ({ enumerable: true, get: function () { return auth_browser_1.parseResource; } }));
Object.defineProperty(exports, "ethConnect", ({ enumerable: true, get: function () { return auth_browser_1.ethConnect; } }));
Object.defineProperty(exports, "disconnectWeb3", ({ enumerable: true, get: function () { return auth_browser_1.disconnectWeb3; } }));
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/lit-node-client-nodejs/src/index.js"), exports);
// ----- autogen:polyfills:start  -----
// This field will be automatically injected into the ./dist/packages/<package-name>/index.js file
// between the autogen:polyfills:start/end comments

try {
  globalThis.crypto = (__webpack_require__("../../node_modules/crypto-browserify/index.js").webcrypto);
} catch (e) {
  // swallow
}

// ----- autogen:polyfills:end  -----
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/lit-node-client/src/lib/lit-node-client.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LitNodeClient = void 0;
const lit_node_client_nodejs_1 = __webpack_require__("../../node_modules/@lit-protocol/lit-node-client-nodejs/src/index.js");
const auth_browser_1 = __webpack_require__("../../node_modules/@lit-protocol/auth-browser/src/index.js");
const misc_1 = __webpack_require__("../../node_modules/@lit-protocol/misc/src/index.js");
const misc_browser_1 = __webpack_require__("../../node_modules/@lit-protocol/misc-browser/src/index.js");
class LitNodeClient extends lit_node_client_nodejs_1.LitNodeClientNodeJs {
    constructor(args) {
        super({
            ...args,
            defaultAuthCallback: auth_browser_1.checkAndSignAuthMessage,
        });
        /**
         *
         * (Browser Only) Get the config from browser local storage and override default config
         *
         * @returns { void }
         *
         */
        this.overrideConfigsFromLocalStorage = () => {
            if ((0, misc_1.isNode)())
                return;
            const storageKey = 'LitNodeClientConfig';
            const storageConfigOrError = (0, misc_browser_1.getStorageItem)(storageKey);
            // -- validate
            if (storageConfigOrError.type === 'ERROR') {
                (0, misc_1.log)(`Storage key "${storageKey}" is missing. `);
                return;
            }
            // -- execute
            const storageConfig = JSON.parse(storageConfigOrError.result);
            // this.config = override(this.config, storageConfig);
            this.config = { ...this.config, ...storageConfig };
        };
        // -- override configs
        this.overrideConfigsFromLocalStorage();
    }
}
exports.LitNodeClient = LitNodeClient;
//# sourceMappingURL=lit-node-client.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/lit-third-party-libs/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IPFSBundledSDK = void 0;
var ipfs_bundled_sdk_1 = __webpack_require__("../../node_modules/@lit-protocol/lit-third-party-libs/src/lib/ipfs-bundled-sdk.js");
Object.defineProperty(exports, "IPFSBundledSDK", ({ enumerable: true, get: function () { return ipfs_bundled_sdk_1.IPFSBundledSDK; } }));
// export { CosmosBundledSDK } from './lib/cosmos-bundled-sdk';
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/lit-third-party-libs/src/lib/ipfs-bundled-sdk.js":
/***/ ((module, exports, __webpack_require__) => {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
// @ts-nocheck
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.IPFSBundledSDK = void 0;
exports.IPFSBundledSDK = (() => {
    var __create = Object.create;
    var __defProp = Object.defineProperty;
    var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames = Object.getOwnPropertyNames;
    var __getProtoOf = Object.getPrototypeOf;
    var __hasOwnProp = Object.prototype.hasOwnProperty;
    var __commonJS = (cb, mod2) => function __require() {
        return (mod2 ||
            (0, cb[__getOwnPropNames(cb)[0]])((mod2 = { exports: {} }).exports, mod2),
            mod2.exports);
    };
    var __export = (target, all2) => {
        for (var name4 in all2)
            __defProp(target, name4, { get: all2[name4], enumerable: true });
    };
    var __copyProps = (to, from3, except, desc) => {
        if ((from3 && typeof from3 === 'object') || typeof from3 === 'function') {
            for (let key of __getOwnPropNames(from3))
                if (!__hasOwnProp.call(to, key) && key !== except)
                    __defProp(to, key, {
                        get: () => from3[key],
                        enumerable: !(desc = __getOwnPropDesc(from3, key)) || desc.enumerable,
                    });
        }
        return to;
    };
    var __toESM = (mod2, isNodeMode, target) => ((target = mod2 != null ? __create(__getProtoOf(mod2)) : {}),
        __copyProps(
        // If the importer is in node compatibility mode or this is not an ESM
        // file that has been converted to a CommonJS file using a Babel-
        // compatible transform (i.e. "__esModule" has not been set), then set
        // "default" to the CommonJS "module.exports" for node compatibility.
        isNodeMode || !mod2 || !mod2.__esModule
            ? __defProp(target, 'default', { value: mod2, enumerable: true })
            : target, mod2));
    var __toCommonJS = (mod2) => __copyProps(__defProp({}, '__esModule', { value: true }), mod2);
    // node_modules/is-plain-obj/index.js
    var require_is_plain_obj = __commonJS({
        'node_modules/is-plain-obj/index.js'(exports2, module2) {
            'use strict';
            module2.exports = (value) => {
                if (Object.prototype.toString.call(value) !== '[object Object]') {
                    return false;
                }
                const prototype = Object.getPrototypeOf(value);
                return prototype === null || prototype === Object.prototype;
            };
        },
    });
    // node_modules/merge-options/index.js
    var require_merge_options = __commonJS({
        'node_modules/merge-options/index.js'(exports2, module2) {
            'use strict';
            var isOptionObject = require_is_plain_obj();
            var { hasOwnProperty } = Object.prototype;
            var { propertyIsEnumerable } = Object;
            var defineProperty = (object, name4, value) => Object.defineProperty(object, name4, {
                value,
                writable: true,
                enumerable: true,
                configurable: true,
            });
            var globalThis2 = exports2;
            var defaultMergeOptions = {
                concatArrays: false,
                ignoreUndefined: false,
            };
            var getEnumerableOwnPropertyKeys = (value) => {
                const keys = [];
                for (const key in value) {
                    if (hasOwnProperty.call(value, key)) {
                        keys.push(key);
                    }
                }
                if (Object.getOwnPropertySymbols) {
                    const symbols = Object.getOwnPropertySymbols(value);
                    for (const symbol2 of symbols) {
                        if (propertyIsEnumerable.call(value, symbol2)) {
                            keys.push(symbol2);
                        }
                    }
                }
                return keys;
            };
            function clone(value) {
                if (Array.isArray(value)) {
                    return cloneArray(value);
                }
                if (isOptionObject(value)) {
                    return cloneOptionObject(value);
                }
                return value;
            }
            function cloneArray(array) {
                const result = array.slice(0, 0);
                getEnumerableOwnPropertyKeys(array).forEach((key) => {
                    defineProperty(result, key, clone(array[key]));
                });
                return result;
            }
            function cloneOptionObject(object) {
                const result = Object.getPrototypeOf(object) === null
                    ? /* @__PURE__ */ Object.create(null)
                    : {};
                getEnumerableOwnPropertyKeys(object).forEach((key) => {
                    defineProperty(result, key, clone(object[key]));
                });
                return result;
            }
            var mergeKeys = (merged, source, keys, config) => {
                keys.forEach((key) => {
                    if (typeof source[key] === 'undefined' && config.ignoreUndefined) {
                        return;
                    }
                    if (key in merged && merged[key] !== Object.getPrototypeOf(merged)) {
                        defineProperty(merged, key, merge(merged[key], source[key], config));
                    }
                    else {
                        defineProperty(merged, key, clone(source[key]));
                    }
                });
                return merged;
            };
            var concatArrays = (merged, source, config) => {
                let result = merged.slice(0, 0);
                let resultIndex = 0;
                [merged, source].forEach((array) => {
                    const indices = [];
                    for (let k = 0; k < array.length; k++) {
                        if (!hasOwnProperty.call(array, k)) {
                            continue;
                        }
                        indices.push(String(k));
                        if (array === merged) {
                            defineProperty(result, resultIndex++, array[k]);
                        }
                        else {
                            defineProperty(result, resultIndex++, clone(array[k]));
                        }
                    }
                    result = mergeKeys(result, array, getEnumerableOwnPropertyKeys(array).filter((key) => !indices.includes(key)), config);
                });
                return result;
            };
            function merge(merged, source, config) {
                if (config.concatArrays &&
                    Array.isArray(merged) &&
                    Array.isArray(source)) {
                    return concatArrays(merged, source, config);
                }
                if (!isOptionObject(source) || !isOptionObject(merged)) {
                    return clone(source);
                }
                return mergeKeys(merged, source, getEnumerableOwnPropertyKeys(source), config);
            }
            module2.exports = function (...options) {
                const config = merge(clone(defaultMergeOptions), (this !== globalThis2 && this) || {}, defaultMergeOptions);
                let merged = { _: {} };
                for (const option of options) {
                    if (option === void 0) {
                        continue;
                    }
                    if (!isOptionObject(option)) {
                        throw new TypeError('`' + option + '` is not an Option Object');
                    }
                    merged = merge(merged, { _: option }, config);
                }
                return merged._;
            };
        },
    });
    // node_modules/murmurhash3js-revisited/lib/murmurHash3js.js
    var require_murmurHash3js = __commonJS({
        'node_modules/murmurhash3js-revisited/lib/murmurHash3js.js'(exports2, module2) {
            (function (root, undefined2) {
                'use strict';
                var library = {
                    version: '3.0.0',
                    x86: {},
                    x64: {},
                    inputValidation: true,
                };
                function _validBytes(bytes) {
                    if (!Array.isArray(bytes) && !ArrayBuffer.isView(bytes)) {
                        return false;
                    }
                    for (var i = 0; i < bytes.length; i++) {
                        if (!Number.isInteger(bytes[i]) || bytes[i] < 0 || bytes[i] > 255) {
                            return false;
                        }
                    }
                    return true;
                }
                function _x86Multiply(m, n) {
                    return (m & 65535) * n + ((((m >>> 16) * n) & 65535) << 16);
                }
                function _x86Rotl(m, n) {
                    return (m << n) | (m >>> (32 - n));
                }
                function _x86Fmix(h) {
                    h ^= h >>> 16;
                    h = _x86Multiply(h, 2246822507);
                    h ^= h >>> 13;
                    h = _x86Multiply(h, 3266489909);
                    h ^= h >>> 16;
                    return h;
                }
                function _x64Add(m, n) {
                    m = [m[0] >>> 16, m[0] & 65535, m[1] >>> 16, m[1] & 65535];
                    n = [n[0] >>> 16, n[0] & 65535, n[1] >>> 16, n[1] & 65535];
                    var o = [0, 0, 0, 0];
                    o[3] += m[3] + n[3];
                    o[2] += o[3] >>> 16;
                    o[3] &= 65535;
                    o[2] += m[2] + n[2];
                    o[1] += o[2] >>> 16;
                    o[2] &= 65535;
                    o[1] += m[1] + n[1];
                    o[0] += o[1] >>> 16;
                    o[1] &= 65535;
                    o[0] += m[0] + n[0];
                    o[0] &= 65535;
                    return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]];
                }
                function _x64Multiply(m, n) {
                    m = [m[0] >>> 16, m[0] & 65535, m[1] >>> 16, m[1] & 65535];
                    n = [n[0] >>> 16, n[0] & 65535, n[1] >>> 16, n[1] & 65535];
                    var o = [0, 0, 0, 0];
                    o[3] += m[3] * n[3];
                    o[2] += o[3] >>> 16;
                    o[3] &= 65535;
                    o[2] += m[2] * n[3];
                    o[1] += o[2] >>> 16;
                    o[2] &= 65535;
                    o[2] += m[3] * n[2];
                    o[1] += o[2] >>> 16;
                    o[2] &= 65535;
                    o[1] += m[1] * n[3];
                    o[0] += o[1] >>> 16;
                    o[1] &= 65535;
                    o[1] += m[2] * n[2];
                    o[0] += o[1] >>> 16;
                    o[1] &= 65535;
                    o[1] += m[3] * n[1];
                    o[0] += o[1] >>> 16;
                    o[1] &= 65535;
                    o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
                    o[0] &= 65535;
                    return [(o[0] << 16) | o[1], (o[2] << 16) | o[3]];
                }
                function _x64Rotl(m, n) {
                    n %= 64;
                    if (n === 32) {
                        return [m[1], m[0]];
                    }
                    else if (n < 32) {
                        return [
                            (m[0] << n) | (m[1] >>> (32 - n)),
                            (m[1] << n) | (m[0] >>> (32 - n)),
                        ];
                    }
                    else {
                        n -= 32;
                        return [
                            (m[1] << n) | (m[0] >>> (32 - n)),
                            (m[0] << n) | (m[1] >>> (32 - n)),
                        ];
                    }
                }
                function _x64LeftShift(m, n) {
                    n %= 64;
                    if (n === 0) {
                        return m;
                    }
                    else if (n < 32) {
                        return [(m[0] << n) | (m[1] >>> (32 - n)), m[1] << n];
                    }
                    else {
                        return [m[1] << (n - 32), 0];
                    }
                }
                function _x64Xor(m, n) {
                    return [m[0] ^ n[0], m[1] ^ n[1]];
                }
                function _x64Fmix(h) {
                    h = _x64Xor(h, [0, h[0] >>> 1]);
                    h = _x64Multiply(h, [4283543511, 3981806797]);
                    h = _x64Xor(h, [0, h[0] >>> 1]);
                    h = _x64Multiply(h, [3301882366, 444984403]);
                    h = _x64Xor(h, [0, h[0] >>> 1]);
                    return h;
                }
                library.x86.hash32 = function (bytes, seed) {
                    if (library.inputValidation && !_validBytes(bytes)) {
                        return undefined2;
                    }
                    seed = seed || 0;
                    var remainder = bytes.length % 4;
                    var blocks = bytes.length - remainder;
                    var h1 = seed;
                    var k1 = 0;
                    var c1 = 3432918353;
                    var c2 = 461845907;
                    for (var i = 0; i < blocks; i = i + 4) {
                        k1 =
                            bytes[i] |
                                (bytes[i + 1] << 8) |
                                (bytes[i + 2] << 16) |
                                (bytes[i + 3] << 24);
                        k1 = _x86Multiply(k1, c1);
                        k1 = _x86Rotl(k1, 15);
                        k1 = _x86Multiply(k1, c2);
                        h1 ^= k1;
                        h1 = _x86Rotl(h1, 13);
                        h1 = _x86Multiply(h1, 5) + 3864292196;
                    }
                    k1 = 0;
                    switch (remainder) {
                        case 3:
                            k1 ^= bytes[i + 2] << 16;
                        case 2:
                            k1 ^= bytes[i + 1] << 8;
                        case 1:
                            k1 ^= bytes[i];
                            k1 = _x86Multiply(k1, c1);
                            k1 = _x86Rotl(k1, 15);
                            k1 = _x86Multiply(k1, c2);
                            h1 ^= k1;
                    }
                    h1 ^= bytes.length;
                    h1 = _x86Fmix(h1);
                    return h1 >>> 0;
                };
                library.x86.hash128 = function (bytes, seed) {
                    if (library.inputValidation && !_validBytes(bytes)) {
                        return undefined2;
                    }
                    seed = seed || 0;
                    var remainder = bytes.length % 16;
                    var blocks = bytes.length - remainder;
                    var h1 = seed;
                    var h2 = seed;
                    var h3 = seed;
                    var h4 = seed;
                    var k1 = 0;
                    var k2 = 0;
                    var k3 = 0;
                    var k4 = 0;
                    var c1 = 597399067;
                    var c2 = 2869860233;
                    var c3 = 951274213;
                    var c4 = 2716044179;
                    for (var i = 0; i < blocks; i = i + 16) {
                        k1 =
                            bytes[i] |
                                (bytes[i + 1] << 8) |
                                (bytes[i + 2] << 16) |
                                (bytes[i + 3] << 24);
                        k2 =
                            bytes[i + 4] |
                                (bytes[i + 5] << 8) |
                                (bytes[i + 6] << 16) |
                                (bytes[i + 7] << 24);
                        k3 =
                            bytes[i + 8] |
                                (bytes[i + 9] << 8) |
                                (bytes[i + 10] << 16) |
                                (bytes[i + 11] << 24);
                        k4 =
                            bytes[i + 12] |
                                (bytes[i + 13] << 8) |
                                (bytes[i + 14] << 16) |
                                (bytes[i + 15] << 24);
                        k1 = _x86Multiply(k1, c1);
                        k1 = _x86Rotl(k1, 15);
                        k1 = _x86Multiply(k1, c2);
                        h1 ^= k1;
                        h1 = _x86Rotl(h1, 19);
                        h1 += h2;
                        h1 = _x86Multiply(h1, 5) + 1444728091;
                        k2 = _x86Multiply(k2, c2);
                        k2 = _x86Rotl(k2, 16);
                        k2 = _x86Multiply(k2, c3);
                        h2 ^= k2;
                        h2 = _x86Rotl(h2, 17);
                        h2 += h3;
                        h2 = _x86Multiply(h2, 5) + 197830471;
                        k3 = _x86Multiply(k3, c3);
                        k3 = _x86Rotl(k3, 17);
                        k3 = _x86Multiply(k3, c4);
                        h3 ^= k3;
                        h3 = _x86Rotl(h3, 15);
                        h3 += h4;
                        h3 = _x86Multiply(h3, 5) + 2530024501;
                        k4 = _x86Multiply(k4, c4);
                        k4 = _x86Rotl(k4, 18);
                        k4 = _x86Multiply(k4, c1);
                        h4 ^= k4;
                        h4 = _x86Rotl(h4, 13);
                        h4 += h1;
                        h4 = _x86Multiply(h4, 5) + 850148119;
                    }
                    k1 = 0;
                    k2 = 0;
                    k3 = 0;
                    k4 = 0;
                    switch (remainder) {
                        case 15:
                            k4 ^= bytes[i + 14] << 16;
                        case 14:
                            k4 ^= bytes[i + 13] << 8;
                        case 13:
                            k4 ^= bytes[i + 12];
                            k4 = _x86Multiply(k4, c4);
                            k4 = _x86Rotl(k4, 18);
                            k4 = _x86Multiply(k4, c1);
                            h4 ^= k4;
                        case 12:
                            k3 ^= bytes[i + 11] << 24;
                        case 11:
                            k3 ^= bytes[i + 10] << 16;
                        case 10:
                            k3 ^= bytes[i + 9] << 8;
                        case 9:
                            k3 ^= bytes[i + 8];
                            k3 = _x86Multiply(k3, c3);
                            k3 = _x86Rotl(k3, 17);
                            k3 = _x86Multiply(k3, c4);
                            h3 ^= k3;
                        case 8:
                            k2 ^= bytes[i + 7] << 24;
                        case 7:
                            k2 ^= bytes[i + 6] << 16;
                        case 6:
                            k2 ^= bytes[i + 5] << 8;
                        case 5:
                            k2 ^= bytes[i + 4];
                            k2 = _x86Multiply(k2, c2);
                            k2 = _x86Rotl(k2, 16);
                            k2 = _x86Multiply(k2, c3);
                            h2 ^= k2;
                        case 4:
                            k1 ^= bytes[i + 3] << 24;
                        case 3:
                            k1 ^= bytes[i + 2] << 16;
                        case 2:
                            k1 ^= bytes[i + 1] << 8;
                        case 1:
                            k1 ^= bytes[i];
                            k1 = _x86Multiply(k1, c1);
                            k1 = _x86Rotl(k1, 15);
                            k1 = _x86Multiply(k1, c2);
                            h1 ^= k1;
                    }
                    h1 ^= bytes.length;
                    h2 ^= bytes.length;
                    h3 ^= bytes.length;
                    h4 ^= bytes.length;
                    h1 += h2;
                    h1 += h3;
                    h1 += h4;
                    h2 += h1;
                    h3 += h1;
                    h4 += h1;
                    h1 = _x86Fmix(h1);
                    h2 = _x86Fmix(h2);
                    h3 = _x86Fmix(h3);
                    h4 = _x86Fmix(h4);
                    h1 += h2;
                    h1 += h3;
                    h1 += h4;
                    h2 += h1;
                    h3 += h1;
                    h4 += h1;
                    return (('00000000' + (h1 >>> 0).toString(16)).slice(-8) +
                        ('00000000' + (h2 >>> 0).toString(16)).slice(-8) +
                        ('00000000' + (h3 >>> 0).toString(16)).slice(-8) +
                        ('00000000' + (h4 >>> 0).toString(16)).slice(-8));
                };
                library.x64.hash128 = function (bytes, seed) {
                    if (library.inputValidation && !_validBytes(bytes)) {
                        return undefined2;
                    }
                    seed = seed || 0;
                    var remainder = bytes.length % 16;
                    var blocks = bytes.length - remainder;
                    var h1 = [0, seed];
                    var h2 = [0, seed];
                    var k1 = [0, 0];
                    var k2 = [0, 0];
                    var c1 = [2277735313, 289559509];
                    var c2 = [1291169091, 658871167];
                    for (var i = 0; i < blocks; i = i + 16) {
                        k1 = [
                            bytes[i + 4] |
                                (bytes[i + 5] << 8) |
                                (bytes[i + 6] << 16) |
                                (bytes[i + 7] << 24),
                            bytes[i] |
                                (bytes[i + 1] << 8) |
                                (bytes[i + 2] << 16) |
                                (bytes[i + 3] << 24),
                        ];
                        k2 = [
                            bytes[i + 12] |
                                (bytes[i + 13] << 8) |
                                (bytes[i + 14] << 16) |
                                (bytes[i + 15] << 24),
                            bytes[i + 8] |
                                (bytes[i + 9] << 8) |
                                (bytes[i + 10] << 16) |
                                (bytes[i + 11] << 24),
                        ];
                        k1 = _x64Multiply(k1, c1);
                        k1 = _x64Rotl(k1, 31);
                        k1 = _x64Multiply(k1, c2);
                        h1 = _x64Xor(h1, k1);
                        h1 = _x64Rotl(h1, 27);
                        h1 = _x64Add(h1, h2);
                        h1 = _x64Add(_x64Multiply(h1, [0, 5]), [0, 1390208809]);
                        k2 = _x64Multiply(k2, c2);
                        k2 = _x64Rotl(k2, 33);
                        k2 = _x64Multiply(k2, c1);
                        h2 = _x64Xor(h2, k2);
                        h2 = _x64Rotl(h2, 31);
                        h2 = _x64Add(h2, h1);
                        h2 = _x64Add(_x64Multiply(h2, [0, 5]), [0, 944331445]);
                    }
                    k1 = [0, 0];
                    k2 = [0, 0];
                    switch (remainder) {
                        case 15:
                            k2 = _x64Xor(k2, _x64LeftShift([0, bytes[i + 14]], 48));
                        case 14:
                            k2 = _x64Xor(k2, _x64LeftShift([0, bytes[i + 13]], 40));
                        case 13:
                            k2 = _x64Xor(k2, _x64LeftShift([0, bytes[i + 12]], 32));
                        case 12:
                            k2 = _x64Xor(k2, _x64LeftShift([0, bytes[i + 11]], 24));
                        case 11:
                            k2 = _x64Xor(k2, _x64LeftShift([0, bytes[i + 10]], 16));
                        case 10:
                            k2 = _x64Xor(k2, _x64LeftShift([0, bytes[i + 9]], 8));
                        case 9:
                            k2 = _x64Xor(k2, [0, bytes[i + 8]]);
                            k2 = _x64Multiply(k2, c2);
                            k2 = _x64Rotl(k2, 33);
                            k2 = _x64Multiply(k2, c1);
                            h2 = _x64Xor(h2, k2);
                        case 8:
                            k1 = _x64Xor(k1, _x64LeftShift([0, bytes[i + 7]], 56));
                        case 7:
                            k1 = _x64Xor(k1, _x64LeftShift([0, bytes[i + 6]], 48));
                        case 6:
                            k1 = _x64Xor(k1, _x64LeftShift([0, bytes[i + 5]], 40));
                        case 5:
                            k1 = _x64Xor(k1, _x64LeftShift([0, bytes[i + 4]], 32));
                        case 4:
                            k1 = _x64Xor(k1, _x64LeftShift([0, bytes[i + 3]], 24));
                        case 3:
                            k1 = _x64Xor(k1, _x64LeftShift([0, bytes[i + 2]], 16));
                        case 2:
                            k1 = _x64Xor(k1, _x64LeftShift([0, bytes[i + 1]], 8));
                        case 1:
                            k1 = _x64Xor(k1, [0, bytes[i]]);
                            k1 = _x64Multiply(k1, c1);
                            k1 = _x64Rotl(k1, 31);
                            k1 = _x64Multiply(k1, c2);
                            h1 = _x64Xor(h1, k1);
                    }
                    h1 = _x64Xor(h1, [0, bytes.length]);
                    h2 = _x64Xor(h2, [0, bytes.length]);
                    h1 = _x64Add(h1, h2);
                    h2 = _x64Add(h2, h1);
                    h1 = _x64Fmix(h1);
                    h2 = _x64Fmix(h2);
                    h1 = _x64Add(h1, h2);
                    h2 = _x64Add(h2, h1);
                    return (('00000000' + (h1[0] >>> 0).toString(16)).slice(-8) +
                        ('00000000' + (h1[1] >>> 0).toString(16)).slice(-8) +
                        ('00000000' + (h2[0] >>> 0).toString(16)).slice(-8) +
                        ('00000000' + (h2[1] >>> 0).toString(16)).slice(-8));
                };
                if (typeof exports2 !== 'undefined') {
                    if (typeof module2 !== 'undefined' && module2.exports) {
                        exports2 = module2.exports = library;
                    }
                    exports2.murmurHash3 = library;
                }
                else if (true) {
                    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                        return library;
                    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                }
                else {}
            })(exports2);
        },
    });
    // node_modules/murmurhash3js-revisited/index.js
    var require_murmurhash3js_revisited = __commonJS({
        'node_modules/murmurhash3js-revisited/index.js'(exports2, module2) {
            module2.exports = require_murmurHash3js();
        },
    });
    // node_modules/err-code/index.js
    var require_err_code = __commonJS({
        'node_modules/err-code/index.js'(exports2, module2) {
            'use strict';
            function assign(obj, props) {
                for (const key in props) {
                    Object.defineProperty(obj, key, {
                        value: props[key],
                        enumerable: true,
                        configurable: true,
                    });
                }
                return obj;
            }
            function createError(err, code4, props) {
                if (!err || typeof err === 'string') {
                    throw new TypeError('Please pass an Error to err-code');
                }
                if (!props) {
                    props = {};
                }
                if (typeof code4 === 'object') {
                    props = code4;
                    code4 = '';
                }
                if (code4) {
                    props.code = code4;
                }
                try {
                    return assign(err, props);
                }
                catch (_) {
                    props.message = err.message;
                    props.stack = err.stack;
                    const ErrClass = function () { };
                    ErrClass.prototype = Object.create(Object.getPrototypeOf(err));
                    const output = assign(new ErrClass(), props);
                    return output;
                }
            }
            module2.exports = createError;
        },
    });
    // node_modules/@protobufjs/aspromise/index.js
    var require_aspromise = __commonJS({
        'node_modules/@protobufjs/aspromise/index.js'(exports2, module2) {
            'use strict';
            module2.exports = asPromise;
            function asPromise(fn, ctx) {
                var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
                while (index < arguments.length)
                    params[offset++] = arguments[index++];
                return new Promise(function executor(resolve, reject) {
                    params[offset] = function callback(err) {
                        if (pending) {
                            pending = false;
                            if (err)
                                reject(err);
                            else {
                                var params2 = new Array(arguments.length - 1), offset2 = 0;
                                while (offset2 < params2.length)
                                    params2[offset2++] = arguments[offset2];
                                resolve.apply(null, params2);
                            }
                        }
                    };
                    try {
                        fn.apply(ctx || null, params);
                    }
                    catch (err) {
                        if (pending) {
                            pending = false;
                            reject(err);
                        }
                    }
                });
            }
        },
    });
    // node_modules/@protobufjs/base64/index.js
    var require_base64 = __commonJS({
        'node_modules/@protobufjs/base64/index.js'(exports2) {
            'use strict';
            var base642 = exports2;
            base642.length = function length2(string2) {
                var p = string2.length;
                if (!p)
                    return 0;
                var n = 0;
                while (--p % 4 > 1 && string2.charAt(p) === '=')
                    ++n;
                return Math.ceil(string2.length * 3) / 4 - n;
            };
            var b64 = new Array(64);
            var s64 = new Array(123);
            for (i = 0; i < 64;)
                s64[(b64[i] =
                    i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : (i - 59) | 43)] = i++;
            var i;
            base642.encode = function encode7(buffer, start, end) {
                var parts = null, chunk = [];
                var i2 = 0, j = 0, t;
                while (start < end) {
                    var b = buffer[start++];
                    switch (j) {
                        case 0:
                            chunk[i2++] = b64[b >> 2];
                            t = (b & 3) << 4;
                            j = 1;
                            break;
                        case 1:
                            chunk[i2++] = b64[t | (b >> 4)];
                            t = (b & 15) << 2;
                            j = 2;
                            break;
                        case 2:
                            chunk[i2++] = b64[t | (b >> 6)];
                            chunk[i2++] = b64[b & 63];
                            j = 0;
                            break;
                    }
                    if (i2 > 8191) {
                        (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
                        i2 = 0;
                    }
                }
                if (j) {
                    chunk[i2++] = b64[t];
                    chunk[i2++] = 61;
                    if (j === 1)
                        chunk[i2++] = 61;
                }
                if (parts) {
                    if (i2)
                        parts.push(String.fromCharCode.apply(String, chunk.slice(0, i2)));
                    return parts.join('');
                }
                return String.fromCharCode.apply(String, chunk.slice(0, i2));
            };
            var invalidEncoding = 'invalid encoding';
            base642.decode = function decode8(string2, buffer, offset) {
                var start = offset;
                var j = 0, t;
                for (var i2 = 0; i2 < string2.length;) {
                    var c = string2.charCodeAt(i2++);
                    if (c === 61 && j > 1)
                        break;
                    if ((c = s64[c]) === void 0)
                        throw Error(invalidEncoding);
                    switch (j) {
                        case 0:
                            t = c;
                            j = 1;
                            break;
                        case 1:
                            buffer[offset++] = (t << 2) | ((c & 48) >> 4);
                            t = c;
                            j = 2;
                            break;
                        case 2:
                            buffer[offset++] = ((t & 15) << 4) | ((c & 60) >> 2);
                            t = c;
                            j = 3;
                            break;
                        case 3:
                            buffer[offset++] = ((t & 3) << 6) | c;
                            j = 0;
                            break;
                    }
                }
                if (j === 1)
                    throw Error(invalidEncoding);
                return offset - start;
            };
            base642.test = function test(string2) {
                return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string2);
            };
        },
    });
    // node_modules/@protobufjs/eventemitter/index.js
    var require_eventemitter = __commonJS({
        'node_modules/@protobufjs/eventemitter/index.js'(exports2, module2) {
            'use strict';
            module2.exports = EventEmitter;
            function EventEmitter() {
                this._listeners = {};
            }
            EventEmitter.prototype.on = function on(evt, fn, ctx) {
                (this._listeners[evt] || (this._listeners[evt] = [])).push({
                    fn,
                    ctx: ctx || this,
                });
                return this;
            };
            EventEmitter.prototype.off = function off(evt, fn) {
                if (evt === void 0)
                    this._listeners = {};
                else {
                    if (fn === void 0)
                        this._listeners[evt] = [];
                    else {
                        var listeners = this._listeners[evt];
                        for (var i = 0; i < listeners.length;)
                            if (listeners[i].fn === fn)
                                listeners.splice(i, 1);
                            else
                                ++i;
                    }
                }
                return this;
            };
            EventEmitter.prototype.emit = function emit(evt) {
                var listeners = this._listeners[evt];
                if (listeners) {
                    var args = [], i = 1;
                    for (; i < arguments.length;)
                        args.push(arguments[i++]);
                    for (i = 0; i < listeners.length;)
                        listeners[i].fn.apply(listeners[i++].ctx, args);
                }
                return this;
            };
        },
    });
    // node_modules/@protobufjs/float/index.js
    var require_float = __commonJS({
        'node_modules/@protobufjs/float/index.js'(exports2, module2) {
            'use strict';
            module2.exports = factory(factory);
            function factory(exports3) {
                if (typeof Float32Array !== 'undefined')
                    (function () {
                        var f32 = new Float32Array([-0]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
                        function writeFloat_f32_cpy(val, buf, pos) {
                            f32[0] = val;
                            buf[pos] = f8b[0];
                            buf[pos + 1] = f8b[1];
                            buf[pos + 2] = f8b[2];
                            buf[pos + 3] = f8b[3];
                        }
                        function writeFloat_f32_rev(val, buf, pos) {
                            f32[0] = val;
                            buf[pos] = f8b[3];
                            buf[pos + 1] = f8b[2];
                            buf[pos + 2] = f8b[1];
                            buf[pos + 3] = f8b[0];
                        }
                        exports3.writeFloatLE = le
                            ? writeFloat_f32_cpy
                            : writeFloat_f32_rev;
                        exports3.writeFloatBE = le
                            ? writeFloat_f32_rev
                            : writeFloat_f32_cpy;
                        function readFloat_f32_cpy(buf, pos) {
                            f8b[0] = buf[pos];
                            f8b[1] = buf[pos + 1];
                            f8b[2] = buf[pos + 2];
                            f8b[3] = buf[pos + 3];
                            return f32[0];
                        }
                        function readFloat_f32_rev(buf, pos) {
                            f8b[3] = buf[pos];
                            f8b[2] = buf[pos + 1];
                            f8b[1] = buf[pos + 2];
                            f8b[0] = buf[pos + 3];
                            return f32[0];
                        }
                        exports3.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
                        exports3.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
                    })();
                else
                    (function () {
                        function writeFloat_ieee754(writeUint, val, buf, pos) {
                            var sign = val < 0 ? 1 : 0;
                            if (sign)
                                val = -val;
                            if (val === 0)
                                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
                            else if (isNaN(val))
                                writeUint(2143289344, buf, pos);
                            else if (val > 34028234663852886e22)
                                writeUint(((sign << 31) | 2139095040) >>> 0, buf, pos);
                            else if (val < 11754943508222875e-54)
                                writeUint(((sign << 31) | Math.round(val / 1401298464324817e-60)) >>> 0, buf, pos);
                            else {
                                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) &
                                    8388607;
                                writeUint(((sign << 31) | ((exponent + 127) << 23) | mantissa) >>> 0, buf, pos);
                            }
                        }
                        exports3.writeFloatLE = writeFloat_ieee754.bind(null, writeUintLE);
                        exports3.writeFloatBE = writeFloat_ieee754.bind(null, writeUintBE);
                        function readFloat_ieee754(readUint, buf, pos) {
                            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = (uint >>> 23) & 255, mantissa = uint & 8388607;
                            return exponent === 255
                                ? mantissa
                                    ? NaN
                                    : sign * Infinity
                                : exponent === 0
                                    ? sign * 1401298464324817e-60 * mantissa
                                    : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
                        }
                        exports3.readFloatLE = readFloat_ieee754.bind(null, readUintLE);
                        exports3.readFloatBE = readFloat_ieee754.bind(null, readUintBE);
                    })();
                if (typeof Float64Array !== 'undefined')
                    (function () {
                        var f64 = new Float64Array([-0]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
                        function writeDouble_f64_cpy(val, buf, pos) {
                            f64[0] = val;
                            buf[pos] = f8b[0];
                            buf[pos + 1] = f8b[1];
                            buf[pos + 2] = f8b[2];
                            buf[pos + 3] = f8b[3];
                            buf[pos + 4] = f8b[4];
                            buf[pos + 5] = f8b[5];
                            buf[pos + 6] = f8b[6];
                            buf[pos + 7] = f8b[7];
                        }
                        function writeDouble_f64_rev(val, buf, pos) {
                            f64[0] = val;
                            buf[pos] = f8b[7];
                            buf[pos + 1] = f8b[6];
                            buf[pos + 2] = f8b[5];
                            buf[pos + 3] = f8b[4];
                            buf[pos + 4] = f8b[3];
                            buf[pos + 5] = f8b[2];
                            buf[pos + 6] = f8b[1];
                            buf[pos + 7] = f8b[0];
                        }
                        exports3.writeDoubleLE = le
                            ? writeDouble_f64_cpy
                            : writeDouble_f64_rev;
                        exports3.writeDoubleBE = le
                            ? writeDouble_f64_rev
                            : writeDouble_f64_cpy;
                        function readDouble_f64_cpy(buf, pos) {
                            f8b[0] = buf[pos];
                            f8b[1] = buf[pos + 1];
                            f8b[2] = buf[pos + 2];
                            f8b[3] = buf[pos + 3];
                            f8b[4] = buf[pos + 4];
                            f8b[5] = buf[pos + 5];
                            f8b[6] = buf[pos + 6];
                            f8b[7] = buf[pos + 7];
                            return f64[0];
                        }
                        function readDouble_f64_rev(buf, pos) {
                            f8b[7] = buf[pos];
                            f8b[6] = buf[pos + 1];
                            f8b[5] = buf[pos + 2];
                            f8b[4] = buf[pos + 3];
                            f8b[3] = buf[pos + 4];
                            f8b[2] = buf[pos + 5];
                            f8b[1] = buf[pos + 6];
                            f8b[0] = buf[pos + 7];
                            return f64[0];
                        }
                        exports3.readDoubleLE = le
                            ? readDouble_f64_cpy
                            : readDouble_f64_rev;
                        exports3.readDoubleBE = le
                            ? readDouble_f64_rev
                            : readDouble_f64_cpy;
                    })();
                else
                    (function () {
                        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
                            var sign = val < 0 ? 1 : 0;
                            if (sign)
                                val = -val;
                            if (val === 0) {
                                writeUint(0, buf, pos + off0);
                                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
                            }
                            else if (isNaN(val)) {
                                writeUint(0, buf, pos + off0);
                                writeUint(2146959360, buf, pos + off1);
                            }
                            else if (val > 17976931348623157e292) {
                                writeUint(0, buf, pos + off0);
                                writeUint(((sign << 31) | 2146435072) >>> 0, buf, pos + off1);
                            }
                            else {
                                var mantissa;
                                if (val < 22250738585072014e-324) {
                                    mantissa = val / 5e-324;
                                    writeUint(mantissa >>> 0, buf, pos + off0);
                                    writeUint(((sign << 31) | (mantissa / 4294967296)) >>> 0, buf, pos + off1);
                                }
                                else {
                                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                                    if (exponent === 1024)
                                        exponent = 1023;
                                    mantissa = val * Math.pow(2, -exponent);
                                    writeUint((mantissa * 4503599627370496) >>> 0, buf, pos + off0);
                                    writeUint(((sign << 31) |
                                        ((exponent + 1023) << 20) |
                                        ((mantissa * 1048576) & 1048575)) >>>
                                        0, buf, pos + off1);
                                }
                            }
                        }
                        exports3.writeDoubleLE = writeDouble_ieee754.bind(null, writeUintLE, 0, 4);
                        exports3.writeDoubleBE = writeDouble_ieee754.bind(null, writeUintBE, 4, 0);
                        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
                            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
                            var sign = (hi >> 31) * 2 + 1, exponent = (hi >>> 20) & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
                            return exponent === 2047
                                ? mantissa
                                    ? NaN
                                    : sign * Infinity
                                : exponent === 0
                                    ? sign * 5e-324 * mantissa
                                    : sign *
                                        Math.pow(2, exponent - 1075) *
                                        (mantissa + 4503599627370496);
                        }
                        exports3.readDoubleLE = readDouble_ieee754.bind(null, readUintLE, 0, 4);
                        exports3.readDoubleBE = readDouble_ieee754.bind(null, readUintBE, 4, 0);
                    })();
                return exports3;
            }
            function writeUintLE(val, buf, pos) {
                buf[pos] = val & 255;
                buf[pos + 1] = (val >>> 8) & 255;
                buf[pos + 2] = (val >>> 16) & 255;
                buf[pos + 3] = val >>> 24;
            }
            function writeUintBE(val, buf, pos) {
                buf[pos] = val >>> 24;
                buf[pos + 1] = (val >>> 16) & 255;
                buf[pos + 2] = (val >>> 8) & 255;
                buf[pos + 3] = val & 255;
            }
            function readUintLE(buf, pos) {
                return ((buf[pos] |
                    (buf[pos + 1] << 8) |
                    (buf[pos + 2] << 16) |
                    (buf[pos + 3] << 24)) >>>
                    0);
            }
            function readUintBE(buf, pos) {
                return (((buf[pos] << 24) |
                    (buf[pos + 1] << 16) |
                    (buf[pos + 2] << 8) |
                    buf[pos + 3]) >>>
                    0);
            }
        },
    });
    // node_modules/@protobufjs/inquire/index.js
    var require_inquire = __commonJS({
        'node_modules/@protobufjs/inquire/index.js'(exports, module) {
            'use strict';
            module.exports = inquire;
            function inquire(moduleName) {
                try {
                    var mod = eval('quire'.replace(/^/, 're'))(moduleName);
                    if (mod && (mod.length || Object.keys(mod).length))
                        return mod;
                }
                catch (e) { }
                return null;
            }
        },
    });
    // node_modules/@protobufjs/utf8/index.js
    var require_utf8 = __commonJS({
        'node_modules/@protobufjs/utf8/index.js'(exports2) {
            'use strict';
            var utf8 = exports2;
            utf8.length = function utf8_length(string2) {
                var len = 0, c = 0;
                for (var i = 0; i < string2.length; ++i) {
                    c = string2.charCodeAt(i);
                    if (c < 128)
                        len += 1;
                    else if (c < 2048)
                        len += 2;
                    else if ((c & 64512) === 55296 &&
                        (string2.charCodeAt(i + 1) & 64512) === 56320) {
                        ++i;
                        len += 4;
                    }
                    else
                        len += 3;
                }
                return len;
            };
            utf8.read = function utf8_read(buffer, start, end) {
                var len = end - start;
                if (len < 1)
                    return '';
                var parts = null, chunk = [], i = 0, t;
                while (start < end) {
                    t = buffer[start++];
                    if (t < 128)
                        chunk[i++] = t;
                    else if (t > 191 && t < 224)
                        chunk[i++] = ((t & 31) << 6) | (buffer[start++] & 63);
                    else if (t > 239 && t < 365) {
                        t =
                            (((t & 7) << 18) |
                                ((buffer[start++] & 63) << 12) |
                                ((buffer[start++] & 63) << 6) |
                                (buffer[start++] & 63)) -
                                65536;
                        chunk[i++] = 55296 + (t >> 10);
                        chunk[i++] = 56320 + (t & 1023);
                    }
                    else
                        chunk[i++] =
                            ((t & 15) << 12) |
                                ((buffer[start++] & 63) << 6) |
                                (buffer[start++] & 63);
                    if (i > 8191) {
                        (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
                        i = 0;
                    }
                }
                if (parts) {
                    if (i)
                        parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
                    return parts.join('');
                }
                return String.fromCharCode.apply(String, chunk.slice(0, i));
            };
            utf8.write = function utf8_write(string2, buffer, offset) {
                var start = offset, c1, c2;
                for (var i = 0; i < string2.length; ++i) {
                    c1 = string2.charCodeAt(i);
                    if (c1 < 128) {
                        buffer[offset++] = c1;
                    }
                    else if (c1 < 2048) {
                        buffer[offset++] = (c1 >> 6) | 192;
                        buffer[offset++] = (c1 & 63) | 128;
                    }
                    else if ((c1 & 64512) === 55296 &&
                        ((c2 = string2.charCodeAt(i + 1)) & 64512) === 56320) {
                        c1 = 65536 + ((c1 & 1023) << 10) + (c2 & 1023);
                        ++i;
                        buffer[offset++] = (c1 >> 18) | 240;
                        buffer[offset++] = ((c1 >> 12) & 63) | 128;
                        buffer[offset++] = ((c1 >> 6) & 63) | 128;
                        buffer[offset++] = (c1 & 63) | 128;
                    }
                    else {
                        buffer[offset++] = (c1 >> 12) | 224;
                        buffer[offset++] = ((c1 >> 6) & 63) | 128;
                        buffer[offset++] = (c1 & 63) | 128;
                    }
                }
                return offset - start;
            };
        },
    });
    // node_modules/@protobufjs/pool/index.js
    var require_pool = __commonJS({
        'node_modules/@protobufjs/pool/index.js'(exports2, module2) {
            'use strict';
            module2.exports = pool;
            function pool(alloc2, slice, size) {
                var SIZE = size || 8192;
                var MAX = SIZE >>> 1;
                var slab = null;
                var offset = SIZE;
                return function pool_alloc(size2) {
                    if (size2 < 1 || size2 > MAX)
                        return alloc2(size2);
                    if (offset + size2 > SIZE) {
                        slab = alloc2(SIZE);
                        offset = 0;
                    }
                    var buf = slice.call(slab, offset, (offset += size2));
                    if (offset & 7)
                        offset = (offset | 7) + 1;
                    return buf;
                };
            }
        },
    });
    // node_modules/protobufjs/src/util/longbits.js
    var require_longbits = __commonJS({
        'node_modules/protobufjs/src/util/longbits.js'(exports2, module2) {
            'use strict';
            module2.exports = LongBits;
            var util = require_minimal();
            function LongBits(lo, hi) {
                this.lo = lo >>> 0;
                this.hi = hi >>> 0;
            }
            var zero = (LongBits.zero = new LongBits(0, 0));
            zero.toNumber = function () {
                return 0;
            };
            zero.zzEncode = zero.zzDecode = function () {
                return this;
            };
            zero.length = function () {
                return 1;
            };
            var zeroHash = (LongBits.zeroHash = '\0\0\0\0\0\0\0\0');
            LongBits.fromNumber = function fromNumber(value) {
                if (value === 0)
                    return zero;
                var sign = value < 0;
                if (sign)
                    value = -value;
                var lo = value >>> 0, hi = ((value - lo) / 4294967296) >>> 0;
                if (sign) {
                    hi = ~hi >>> 0;
                    lo = ~lo >>> 0;
                    if (++lo > 4294967295) {
                        lo = 0;
                        if (++hi > 4294967295)
                            hi = 0;
                    }
                }
                return new LongBits(lo, hi);
            };
            LongBits.from = function from3(value) {
                if (typeof value === 'number')
                    return LongBits.fromNumber(value);
                if (util.isString(value)) {
                    if (util.Long)
                        value = util.Long.fromString(value);
                    else
                        return LongBits.fromNumber(parseInt(value, 10));
                }
                return value.low || value.high
                    ? new LongBits(value.low >>> 0, value.high >>> 0)
                    : zero;
            };
            LongBits.prototype.toNumber = function toNumber(unsigned) {
                if (!unsigned && this.hi >>> 31) {
                    var lo = (~this.lo + 1) >>> 0, hi = ~this.hi >>> 0;
                    if (!lo)
                        hi = (hi + 1) >>> 0;
                    return -(lo + hi * 4294967296);
                }
                return this.lo + this.hi * 4294967296;
            };
            LongBits.prototype.toLong = function toLong(unsigned) {
                return util.Long
                    ? new util.Long(this.lo | 0, this.hi | 0, Boolean(unsigned))
                    : {
                        low: this.lo | 0,
                        high: this.hi | 0,
                        unsigned: Boolean(unsigned),
                    };
            };
            var charCodeAt = String.prototype.charCodeAt;
            LongBits.fromHash = function fromHash(hash) {
                if (hash === zeroHash)
                    return zero;
                return new LongBits((charCodeAt.call(hash, 0) |
                    (charCodeAt.call(hash, 1) << 8) |
                    (charCodeAt.call(hash, 2) << 16) |
                    (charCodeAt.call(hash, 3) << 24)) >>>
                    0, (charCodeAt.call(hash, 4) |
                    (charCodeAt.call(hash, 5) << 8) |
                    (charCodeAt.call(hash, 6) << 16) |
                    (charCodeAt.call(hash, 7) << 24)) >>>
                    0);
            };
            LongBits.prototype.toHash = function toHash() {
                return String.fromCharCode(this.lo & 255, (this.lo >>> 8) & 255, (this.lo >>> 16) & 255, this.lo >>> 24, this.hi & 255, (this.hi >>> 8) & 255, (this.hi >>> 16) & 255, this.hi >>> 24);
            };
            LongBits.prototype.zzEncode = function zzEncode() {
                var mask = this.hi >> 31;
                this.hi = (((this.hi << 1) | (this.lo >>> 31)) ^ mask) >>> 0;
                this.lo = ((this.lo << 1) ^ mask) >>> 0;
                return this;
            };
            LongBits.prototype.zzDecode = function zzDecode() {
                var mask = -(this.lo & 1);
                this.lo = (((this.lo >>> 1) | (this.hi << 31)) ^ mask) >>> 0;
                this.hi = ((this.hi >>> 1) ^ mask) >>> 0;
                return this;
            };
            LongBits.prototype.length = function length2() {
                var part0 = this.lo, part1 = ((this.lo >>> 28) | (this.hi << 4)) >>> 0, part2 = this.hi >>> 24;
                return part2 === 0
                    ? part1 === 0
                        ? part0 < 16384
                            ? part0 < 128
                                ? 1
                                : 2
                            : part0 < 2097152
                                ? 3
                                : 4
                        : part1 < 16384
                            ? part1 < 128
                                ? 5
                                : 6
                            : part1 < 2097152
                                ? 7
                                : 8
                    : part2 < 128
                        ? 9
                        : 10;
            };
        },
    });
    // node_modules/protobufjs/src/util/minimal.js
    var require_minimal = __commonJS({
        'node_modules/protobufjs/src/util/minimal.js'(exports2) {
            'use strict';
            var util = exports2;
            util.asPromise = require_aspromise();
            util.base64 = require_base64();
            util.EventEmitter = require_eventemitter();
            util.float = require_float();
            util.inquire = require_inquire();
            util.utf8 = require_utf8();
            util.pool = require_pool();
            util.LongBits = require_longbits();
            util.isNode = Boolean(typeof __webpack_require__.g !== 'undefined' &&
                __webpack_require__.g &&
                __webpack_require__.g.process &&
                __webpack_require__.g.process.versions &&
                __webpack_require__.g.process.versions.node);
            util.global =
                (util.isNode && __webpack_require__.g) ||
                    (typeof window !== 'undefined' && window) ||
                    (typeof self !== 'undefined' && self) ||
                    exports2;
            util.emptyArray = Object.freeze
                ? Object.freeze([])
                : /* istanbul ignore next */
                    [];
            util.emptyObject = Object.freeze
                ? Object.freeze({})
                : /* istanbul ignore next */
                    {};
            util.isInteger =
                Number.isInteger /* istanbul ignore next */ ||
                    function isInteger(value) {
                        return (typeof value === 'number' &&
                            isFinite(value) &&
                            Math.floor(value) === value);
                    };
            util.isString = function isString(value) {
                return typeof value === 'string' || value instanceof String;
            };
            util.isObject = function isObject(value) {
                return value && typeof value === 'object';
            };
            util.isset =
                /**
                 * Checks if a property on a message is considered to be present.
                 * @param {Object} obj Plain object or message instance
                 * @param {string} prop Property name
                 * @returns {boolean} `true` if considered to be present, otherwise `false`
                 */
                util.isSet = function isSet(obj, prop) {
                    var value = obj[prop];
                    if (value != null && obj.hasOwnProperty(prop))
                        return (typeof value !== 'object' ||
                            (Array.isArray(value)
                                ? value.length
                                : Object.keys(value).length) > 0);
                    return false;
                };
            util.Buffer = (function () {
                try {
                    var Buffer2 = util.inquire('buffer').Buffer;
                    return Buffer2.prototype.utf8Write
                        ? Buffer2
                        : /* istanbul ignore next */
                            null;
                }
                catch (e) {
                    return null;
                }
            })();
            util._Buffer_from = null;
            util._Buffer_allocUnsafe = null;
            util.newBuffer = function newBuffer(sizeOrArray) {
                return typeof sizeOrArray === 'number'
                    ? util.Buffer
                        ? util._Buffer_allocUnsafe(sizeOrArray)
                        : new util.Array(sizeOrArray)
                    : util.Buffer
                        ? util._Buffer_from(sizeOrArray)
                        : typeof Uint8Array === 'undefined'
                            ? sizeOrArray
                            : new Uint8Array(sizeOrArray);
            };
            util.Array = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
            util.Long =
                /* istanbul ignore next */
                (util.global.dcodeIO /* istanbul ignore next */ &&
                    util.global.dcodeIO.Long) /* istanbul ignore next */ ||
                    util.global.Long ||
                    util.inquire('long');
            util.key2Re = /^true|false|0|1$/;
            util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
            util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
            util.longToHash = function longToHash(value) {
                return value
                    ? util.LongBits.from(value).toHash()
                    : util.LongBits.zeroHash;
            };
            util.longFromHash = function longFromHash(hash, unsigned) {
                var bits = util.LongBits.fromHash(hash);
                if (util.Long)
                    return util.Long.fromBits(bits.lo, bits.hi, unsigned);
                return bits.toNumber(Boolean(unsigned));
            };
            function merge(dst, src2, ifNotSet) {
                for (var keys = Object.keys(src2), i = 0; i < keys.length; ++i)
                    if (dst[keys[i]] === void 0 || !ifNotSet)
                        dst[keys[i]] = src2[keys[i]];
                return dst;
            }
            util.merge = merge;
            util.lcFirst = function lcFirst(str) {
                return str.charAt(0).toLowerCase() + str.substring(1);
            };
            function newError(name4) {
                function CustomError(message, properties) {
                    if (!(this instanceof CustomError))
                        return new CustomError(message, properties);
                    Object.defineProperty(this, 'message', {
                        get: function () {
                            return message;
                        },
                    });
                    if (Error.captureStackTrace)
                        Error.captureStackTrace(this, CustomError);
                    else
                        Object.defineProperty(this, 'stack', {
                            value: new Error().stack || '',
                        });
                    if (properties)
                        merge(this, properties);
                }
                CustomError.prototype = Object.create(Error.prototype, {
                    constructor: {
                        value: CustomError,
                        writable: true,
                        enumerable: false,
                        configurable: true,
                    },
                    name: {
                        get() {
                            return name4;
                        },
                        set: void 0,
                        enumerable: false,
                        // configurable: false would accurately preserve the behavior of
                        // the original, but I'm guessing that was not intentional.
                        // For an actual error subclass, this property would
                        // be configurable.
                        configurable: true,
                    },
                    toString: {
                        value() {
                            return this.name + ': ' + this.message;
                        },
                        writable: true,
                        enumerable: false,
                        configurable: true,
                    },
                });
                return CustomError;
            }
            util.newError = newError;
            util.ProtocolError = newError('ProtocolError');
            util.oneOfGetter = function getOneOf(fieldNames) {
                var fieldMap = {};
                for (var i = 0; i < fieldNames.length; ++i)
                    fieldMap[fieldNames[i]] = 1;
                return function () {
                    for (var keys = Object.keys(this), i2 = keys.length - 1; i2 > -1; --i2)
                        if (fieldMap[keys[i2]] === 1 &&
                            this[keys[i2]] !== void 0 &&
                            this[keys[i2]] !== null)
                            return keys[i2];
                };
            };
            util.oneOfSetter = function setOneOf(fieldNames) {
                return function (name4) {
                    for (var i = 0; i < fieldNames.length; ++i)
                        if (fieldNames[i] !== name4)
                            delete this[fieldNames[i]];
                };
            };
            util.toJSONOptions = {
                longs: String,
                enums: String,
                bytes: String,
                json: true,
            };
            util._configure = function () {
                var Buffer2 = util.Buffer;
                if (!Buffer2) {
                    util._Buffer_from = util._Buffer_allocUnsafe = null;
                    return;
                }
                util._Buffer_from =
                    (Buffer2.from !== Uint8Array.from &&
                        Buffer2.from) /* istanbul ignore next */ ||
                        function Buffer_from(value, encoding) {
                            return new Buffer2(value, encoding);
                        };
                util._Buffer_allocUnsafe =
                    Buffer2.allocUnsafe /* istanbul ignore next */ ||
                        function Buffer_allocUnsafe(size) {
                            return new Buffer2(size);
                        };
            };
        },
    });
    // node_modules/protobufjs/src/writer.js
    var require_writer = __commonJS({
        'node_modules/protobufjs/src/writer.js'(exports2, module2) {
            'use strict';
            module2.exports = Writer;
            var util = require_minimal();
            var BufferWriter;
            var LongBits = util.LongBits;
            var base642 = util.base64;
            var utf8 = util.utf8;
            function Op(fn, len, val) {
                this.fn = fn;
                this.len = len;
                this.next = void 0;
                this.val = val;
            }
            function noop() { }
            function State(writer) {
                this.head = writer.head;
                this.tail = writer.tail;
                this.len = writer.len;
                this.next = writer.states;
            }
            function Writer() {
                this.len = 0;
                this.head = new Op(noop, 0, 0);
                this.tail = this.head;
                this.states = null;
            }
            var create3 = function create4() {
                return util.Buffer
                    ? function create_buffer_setup() {
                        return (Writer.create = function create_buffer() {
                            return new BufferWriter();
                        })();
                    }
                    : function create_array() {
                        return new Writer();
                    };
            };
            Writer.create = create3();
            Writer.alloc = function alloc2(size) {
                return new util.Array(size);
            };
            if (util.Array !== Array)
                Writer.alloc = util.pool(Writer.alloc, util.Array.prototype.subarray);
            Writer.prototype._push = function push(fn, len, val) {
                this.tail = this.tail.next = new Op(fn, len, val);
                this.len += len;
                return this;
            };
            function writeByte(val, buf, pos) {
                buf[pos] = val & 255;
            }
            function writeVarint32(val, buf, pos) {
                while (val > 127) {
                    buf[pos++] = (val & 127) | 128;
                    val >>>= 7;
                }
                buf[pos] = val;
            }
            function VarintOp(len, val) {
                this.len = len;
                this.next = void 0;
                this.val = val;
            }
            VarintOp.prototype = Object.create(Op.prototype);
            VarintOp.prototype.fn = writeVarint32;
            Writer.prototype.uint32 = function write_uint32(value) {
                this.len += (this.tail = this.tail.next =
                    new VarintOp((value = value >>> 0) < 128
                        ? 1
                        : value < 16384
                            ? 2
                            : value < 2097152
                                ? 3
                                : value < 268435456
                                    ? 4
                                    : 5, value)).len;
                return this;
            };
            Writer.prototype.int32 = function write_int32(value) {
                return value < 0
                    ? this._push(writeVarint64, 10, LongBits.fromNumber(value))
                    : this.uint32(value);
            };
            Writer.prototype.sint32 = function write_sint32(value) {
                return this.uint32(((value << 1) ^ (value >> 31)) >>> 0);
            };
            function writeVarint64(val, buf, pos) {
                while (val.hi) {
                    buf[pos++] = (val.lo & 127) | 128;
                    val.lo = ((val.lo >>> 7) | (val.hi << 25)) >>> 0;
                    val.hi >>>= 7;
                }
                while (val.lo > 127) {
                    buf[pos++] = (val.lo & 127) | 128;
                    val.lo = val.lo >>> 7;
                }
                buf[pos++] = val.lo;
            }
            Writer.prototype.uint64 = function write_uint64(value) {
                var bits = LongBits.from(value);
                return this._push(writeVarint64, bits.length(), bits);
            };
            Writer.prototype.int64 = Writer.prototype.uint64;
            Writer.prototype.sint64 = function write_sint64(value) {
                var bits = LongBits.from(value).zzEncode();
                return this._push(writeVarint64, bits.length(), bits);
            };
            Writer.prototype.bool = function write_bool(value) {
                return this._push(writeByte, 1, value ? 1 : 0);
            };
            function writeFixed32(val, buf, pos) {
                buf[pos] = val & 255;
                buf[pos + 1] = (val >>> 8) & 255;
                buf[pos + 2] = (val >>> 16) & 255;
                buf[pos + 3] = val >>> 24;
            }
            Writer.prototype.fixed32 = function write_fixed32(value) {
                return this._push(writeFixed32, 4, value >>> 0);
            };
            Writer.prototype.sfixed32 = Writer.prototype.fixed32;
            Writer.prototype.fixed64 = function write_fixed64(value) {
                var bits = LongBits.from(value);
                return this._push(writeFixed32, 4, bits.lo)._push(writeFixed32, 4, bits.hi);
            };
            Writer.prototype.sfixed64 = Writer.prototype.fixed64;
            Writer.prototype.float = function write_float(value) {
                return this._push(util.float.writeFloatLE, 4, value);
            };
            Writer.prototype.double = function write_double(value) {
                return this._push(util.float.writeDoubleLE, 8, value);
            };
            var writeBytes = util.Array.prototype.set
                ? function writeBytes_set(val, buf, pos) {
                    buf.set(val, pos);
                }
                : function writeBytes_for(val, buf, pos) {
                    for (var i = 0; i < val.length; ++i)
                        buf[pos + i] = val[i];
                };
            Writer.prototype.bytes = function write_bytes(value) {
                var len = value.length >>> 0;
                if (!len)
                    return this._push(writeByte, 1, 0);
                if (util.isString(value)) {
                    var buf = Writer.alloc((len = base642.length(value)));
                    base642.decode(value, buf, 0);
                    value = buf;
                }
                return this.uint32(len)._push(writeBytes, len, value);
            };
            Writer.prototype.string = function write_string(value) {
                var len = utf8.length(value);
                return len
                    ? this.uint32(len)._push(utf8.write, len, value)
                    : this._push(writeByte, 1, 0);
            };
            Writer.prototype.fork = function fork() {
                this.states = new State(this);
                this.head = this.tail = new Op(noop, 0, 0);
                this.len = 0;
                return this;
            };
            Writer.prototype.reset = function reset() {
                if (this.states) {
                    this.head = this.states.head;
                    this.tail = this.states.tail;
                    this.len = this.states.len;
                    this.states = this.states.next;
                }
                else {
                    this.head = this.tail = new Op(noop, 0, 0);
                    this.len = 0;
                }
                return this;
            };
            Writer.prototype.ldelim = function ldelim() {
                var head = this.head, tail = this.tail, len = this.len;
                this.reset().uint32(len);
                if (len) {
                    this.tail.next = head.next;
                    this.tail = tail;
                    this.len += len;
                }
                return this;
            };
            Writer.prototype.finish = function finish() {
                var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
                while (head) {
                    head.fn(head.val, buf, pos);
                    pos += head.len;
                    head = head.next;
                }
                return buf;
            };
            Writer._configure = function (BufferWriter_) {
                BufferWriter = BufferWriter_;
                Writer.create = create3();
                BufferWriter._configure();
            };
        },
    });
    // node_modules/protobufjs/src/writer_buffer.js
    var require_writer_buffer = __commonJS({
        'node_modules/protobufjs/src/writer_buffer.js'(exports2, module2) {
            'use strict';
            module2.exports = BufferWriter;
            var Writer = require_writer();
            (BufferWriter.prototype = Object.create(Writer.prototype)).constructor =
                BufferWriter;
            var util = require_minimal();
            function BufferWriter() {
                Writer.call(this);
            }
            BufferWriter._configure = function () {
                BufferWriter.alloc = util._Buffer_allocUnsafe;
                BufferWriter.writeBytesBuffer =
                    util.Buffer &&
                        util.Buffer.prototype instanceof Uint8Array &&
                        util.Buffer.prototype.set.name === 'set'
                        ? function writeBytesBuffer_set(val, buf, pos) {
                            buf.set(val, pos);
                        }
                        : function writeBytesBuffer_copy(val, buf, pos) {
                            if (val.copy)
                                val.copy(buf, pos, 0, val.length);
                            else
                                for (var i = 0; i < val.length;)
                                    buf[pos++] = val[i++];
                        };
            };
            BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
                if (util.isString(value))
                    value = util._Buffer_from(value, 'base64');
                var len = value.length >>> 0;
                this.uint32(len);
                if (len)
                    this._push(BufferWriter.writeBytesBuffer, len, value);
                return this;
            };
            function writeStringBuffer(val, buf, pos) {
                if (val.length < 40)
                    util.utf8.write(val, buf, pos);
                else if (buf.utf8Write)
                    buf.utf8Write(val, pos);
                else
                    buf.write(val, pos);
            }
            BufferWriter.prototype.string = function write_string_buffer(value) {
                var len = util.Buffer.byteLength(value);
                this.uint32(len);
                if (len)
                    this._push(writeStringBuffer, len, value);
                return this;
            };
            BufferWriter._configure();
        },
    });
    // node_modules/protobufjs/src/reader.js
    var require_reader = __commonJS({
        'node_modules/protobufjs/src/reader.js'(exports2, module2) {
            'use strict';
            module2.exports = Reader;
            var util = require_minimal();
            var BufferReader;
            var LongBits = util.LongBits;
            var utf8 = util.utf8;
            function indexOutOfRange(reader, writeLength) {
                return RangeError('index out of range: ' +
                    reader.pos +
                    ' + ' +
                    (writeLength || 1) +
                    ' > ' +
                    reader.len);
            }
            function Reader(buffer) {
                this.buf = buffer;
                this.pos = 0;
                this.len = buffer.length;
            }
            var create_array = typeof Uint8Array !== 'undefined'
                ? function create_typed_array(buffer) {
                    if (buffer instanceof Uint8Array || Array.isArray(buffer))
                        return new Reader(buffer);
                    throw Error('illegal buffer');
                }
                : function create_array2(buffer) {
                    if (Array.isArray(buffer))
                        return new Reader(buffer);
                    throw Error('illegal buffer');
                };
            var create3 = function create4() {
                return util.Buffer
                    ? function create_buffer_setup(buffer) {
                        return (Reader.create = function create_buffer(buffer2) {
                            return util.Buffer.isBuffer(buffer2)
                                ? new BufferReader(buffer2)
                                : create_array(buffer2);
                        })(buffer);
                    }
                    : create_array;
            };
            Reader.create = create3();
            Reader.prototype._slice =
                util.Array.prototype.subarray /* istanbul ignore next */ ||
                    util.Array.prototype.slice;
            Reader.prototype.uint32 = (function read_uint32_setup() {
                var value = 4294967295;
                return function read_uint32() {
                    value = (this.buf[this.pos] & 127) >>> 0;
                    if (this.buf[this.pos++] < 128)
                        return value;
                    value = (value | ((this.buf[this.pos] & 127) << 7)) >>> 0;
                    if (this.buf[this.pos++] < 128)
                        return value;
                    value = (value | ((this.buf[this.pos] & 127) << 14)) >>> 0;
                    if (this.buf[this.pos++] < 128)
                        return value;
                    value = (value | ((this.buf[this.pos] & 127) << 21)) >>> 0;
                    if (this.buf[this.pos++] < 128)
                        return value;
                    value = (value | ((this.buf[this.pos] & 15) << 28)) >>> 0;
                    if (this.buf[this.pos++] < 128)
                        return value;
                    if ((this.pos += 5) > this.len) {
                        this.pos = this.len;
                        throw indexOutOfRange(this, 10);
                    }
                    return value;
                };
            })();
            Reader.prototype.int32 = function read_int32() {
                return this.uint32() | 0;
            };
            Reader.prototype.sint32 = function read_sint32() {
                var value = this.uint32();
                return ((value >>> 1) ^ -(value & 1)) | 0;
            };
            function readLongVarint() {
                var bits = new LongBits(0, 0);
                var i = 0;
                if (this.len - this.pos > 4) {
                    for (; i < 4; ++i) {
                        bits.lo = (bits.lo | ((this.buf[this.pos] & 127) << (i * 7))) >>> 0;
                        if (this.buf[this.pos++] < 128)
                            return bits;
                    }
                    bits.lo = (bits.lo | ((this.buf[this.pos] & 127) << 28)) >>> 0;
                    bits.hi = (bits.hi | ((this.buf[this.pos] & 127) >> 4)) >>> 0;
                    if (this.buf[this.pos++] < 128)
                        return bits;
                    i = 0;
                }
                else {
                    for (; i < 3; ++i) {
                        if (this.pos >= this.len)
                            throw indexOutOfRange(this);
                        bits.lo = (bits.lo | ((this.buf[this.pos] & 127) << (i * 7))) >>> 0;
                        if (this.buf[this.pos++] < 128)
                            return bits;
                    }
                    bits.lo = (bits.lo | ((this.buf[this.pos++] & 127) << (i * 7))) >>> 0;
                    return bits;
                }
                if (this.len - this.pos > 4) {
                    for (; i < 5; ++i) {
                        bits.hi =
                            (bits.hi | ((this.buf[this.pos] & 127) << (i * 7 + 3))) >>> 0;
                        if (this.buf[this.pos++] < 128)
                            return bits;
                    }
                }
                else {
                    for (; i < 5; ++i) {
                        if (this.pos >= this.len)
                            throw indexOutOfRange(this);
                        bits.hi =
                            (bits.hi | ((this.buf[this.pos] & 127) << (i * 7 + 3))) >>> 0;
                        if (this.buf[this.pos++] < 128)
                            return bits;
                    }
                }
                throw Error('invalid varint encoding');
            }
            Reader.prototype.bool = function read_bool() {
                return this.uint32() !== 0;
            };
            function readFixed32_end(buf, end) {
                return ((buf[end - 4] |
                    (buf[end - 3] << 8) |
                    (buf[end - 2] << 16) |
                    (buf[end - 1] << 24)) >>>
                    0);
            }
            Reader.prototype.fixed32 = function read_fixed32() {
                if (this.pos + 4 > this.len)
                    throw indexOutOfRange(this, 4);
                return readFixed32_end(this.buf, (this.pos += 4));
            };
            Reader.prototype.sfixed32 = function read_sfixed32() {
                if (this.pos + 4 > this.len)
                    throw indexOutOfRange(this, 4);
                return readFixed32_end(this.buf, (this.pos += 4)) | 0;
            };
            function readFixed64() {
                if (this.pos + 8 > this.len)
                    throw indexOutOfRange(this, 8);
                return new LongBits(readFixed32_end(this.buf, (this.pos += 4)), readFixed32_end(this.buf, (this.pos += 4)));
            }
            Reader.prototype.float = function read_float() {
                if (this.pos + 4 > this.len)
                    throw indexOutOfRange(this, 4);
                var value = util.float.readFloatLE(this.buf, this.pos);
                this.pos += 4;
                return value;
            };
            Reader.prototype.double = function read_double() {
                if (this.pos + 8 > this.len)
                    throw indexOutOfRange(this, 4);
                var value = util.float.readDoubleLE(this.buf, this.pos);
                this.pos += 8;
                return value;
            };
            Reader.prototype.bytes = function read_bytes() {
                var length2 = this.uint32(), start = this.pos, end = this.pos + length2;
                if (end > this.len)
                    throw indexOutOfRange(this, length2);
                this.pos += length2;
                if (Array.isArray(this.buf))
                    return this.buf.slice(start, end);
                return start === end
                    ? new this.buf.constructor(0)
                    : this._slice.call(this.buf, start, end);
            };
            Reader.prototype.string = function read_string() {
                var bytes = this.bytes();
                return utf8.read(bytes, 0, bytes.length);
            };
            Reader.prototype.skip = function skip(length2) {
                if (typeof length2 === 'number') {
                    if (this.pos + length2 > this.len)
                        throw indexOutOfRange(this, length2);
                    this.pos += length2;
                }
                else {
                    do {
                        if (this.pos >= this.len)
                            throw indexOutOfRange(this);
                    } while (this.buf[this.pos++] & 128);
                }
                return this;
            };
            Reader.prototype.skipType = function (wireType) {
                switch (wireType) {
                    case 0:
                        this.skip();
                        break;
                    case 1:
                        this.skip(8);
                        break;
                    case 2:
                        this.skip(this.uint32());
                        break;
                    case 3:
                        while ((wireType = this.uint32() & 7) !== 4) {
                            this.skipType(wireType);
                        }
                        break;
                    case 5:
                        this.skip(4);
                        break;
                    default:
                        throw Error('invalid wire type ' + wireType + ' at offset ' + this.pos);
                }
                return this;
            };
            Reader._configure = function (BufferReader_) {
                BufferReader = BufferReader_;
                Reader.create = create3();
                BufferReader._configure();
                var fn = util.Long ? 'toLong' : /* istanbul ignore next */ 'toNumber';
                util.merge(Reader.prototype, {
                    int64: function read_int64() {
                        return readLongVarint.call(this)[fn](false);
                    },
                    uint64: function read_uint64() {
                        return readLongVarint.call(this)[fn](true);
                    },
                    sint64: function read_sint64() {
                        return readLongVarint.call(this).zzDecode()[fn](false);
                    },
                    fixed64: function read_fixed64() {
                        return readFixed64.call(this)[fn](true);
                    },
                    sfixed64: function read_sfixed64() {
                        return readFixed64.call(this)[fn](false);
                    },
                });
            };
        },
    });
    // node_modules/protobufjs/src/reader_buffer.js
    var require_reader_buffer = __commonJS({
        'node_modules/protobufjs/src/reader_buffer.js'(exports2, module2) {
            'use strict';
            module2.exports = BufferReader;
            var Reader = require_reader();
            (BufferReader.prototype = Object.create(Reader.prototype)).constructor =
                BufferReader;
            var util = require_minimal();
            function BufferReader(buffer) {
                Reader.call(this, buffer);
            }
            BufferReader._configure = function () {
                if (util.Buffer)
                    BufferReader.prototype._slice = util.Buffer.prototype.slice;
            };
            BufferReader.prototype.string = function read_string_buffer() {
                var len = this.uint32();
                return this.buf.utf8Slice
                    ? this.buf.utf8Slice(this.pos, (this.pos = Math.min(this.pos + len, this.len)))
                    : this.buf.toString('utf-8', this.pos, (this.pos = Math.min(this.pos + len, this.len)));
            };
            BufferReader._configure();
        },
    });
    // node_modules/protobufjs/src/rpc/service.js
    var require_service = __commonJS({
        'node_modules/protobufjs/src/rpc/service.js'(exports2, module2) {
            'use strict';
            module2.exports = Service;
            var util = require_minimal();
            (Service.prototype = Object.create(util.EventEmitter.prototype)).constructor = Service;
            function Service(rpcImpl, requestDelimited, responseDelimited) {
                if (typeof rpcImpl !== 'function')
                    throw TypeError('rpcImpl must be a function');
                util.EventEmitter.call(this);
                this.rpcImpl = rpcImpl;
                this.requestDelimited = Boolean(requestDelimited);
                this.responseDelimited = Boolean(responseDelimited);
            }
            Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
                if (!request)
                    throw TypeError('request must be specified');
                var self2 = this;
                if (!callback)
                    return util.asPromise(rpcCall, self2, method, requestCtor, responseCtor, request);
                if (!self2.rpcImpl) {
                    setTimeout(function () {
                        callback(Error('already ended'));
                    }, 0);
                    return void 0;
                }
                try {
                    return self2.rpcImpl(method, requestCtor[self2.requestDelimited ? 'encodeDelimited' : 'encode'](request).finish(), function rpcCallback(err, response) {
                        if (err) {
                            self2.emit('error', err, method);
                            return callback(err);
                        }
                        if (response === null) {
                            self2.end(
                            /* endedByRPC */
                            true);
                            return void 0;
                        }
                        if (!(response instanceof responseCtor)) {
                            try {
                                response =
                                    responseCtor[self2.responseDelimited ? 'decodeDelimited' : 'decode'](response);
                            }
                            catch (err2) {
                                self2.emit('error', err2, method);
                                return callback(err2);
                            }
                        }
                        self2.emit('data', response, method);
                        return callback(null, response);
                    });
                }
                catch (err) {
                    self2.emit('error', err, method);
                    setTimeout(function () {
                        callback(err);
                    }, 0);
                    return void 0;
                }
            };
            Service.prototype.end = function end(endedByRPC) {
                if (this.rpcImpl) {
                    if (!endedByRPC)
                        this.rpcImpl(null, null, null);
                    this.rpcImpl = null;
                    this.emit('end').off();
                }
                return this;
            };
        },
    });
    // node_modules/protobufjs/src/rpc.js
    var require_rpc = __commonJS({
        'node_modules/protobufjs/src/rpc.js'(exports2) {
            'use strict';
            var rpc = exports2;
            rpc.Service = require_service();
        },
    });
    // node_modules/protobufjs/src/roots.js
    var require_roots = __commonJS({
        'node_modules/protobufjs/src/roots.js'(exports2, module2) {
            'use strict';
            module2.exports = {};
        },
    });
    // node_modules/protobufjs/src/index-minimal.js
    var require_index_minimal = __commonJS({
        'node_modules/protobufjs/src/index-minimal.js'(exports2) {
            'use strict';
            var protobuf = exports2;
            protobuf.build = 'minimal';
            protobuf.Writer = require_writer();
            protobuf.BufferWriter = require_writer_buffer();
            protobuf.Reader = require_reader();
            protobuf.BufferReader = require_reader_buffer();
            protobuf.util = require_minimal();
            protobuf.rpc = require_rpc();
            protobuf.roots = require_roots();
            protobuf.configure = configure;
            function configure() {
                protobuf.util._configure();
                protobuf.Writer._configure(protobuf.BufferWriter);
                protobuf.Reader._configure(protobuf.BufferReader);
            }
            configure();
        },
    });
    // node_modules/protobufjs/minimal.js
    var require_minimal2 = __commonJS({
        'node_modules/protobufjs/minimal.js'(exports2, module2) {
            'use strict';
            module2.exports = require_index_minimal();
        },
    });
    // node_modules/rabin-wasm/src/rabin.js
    var require_rabin = __commonJS({
        'node_modules/rabin-wasm/src/rabin.js'(exports2, module2) {
            var Rabin = class {
                /**
                 * Creates an instance of Rabin.
                 * @param { import("./../dist/rabin-wasm") } asModule
                 * @param {number} [bits=12]
                 * @param {number} [min=8 * 1024]
                 * @param {number} [max=32 * 1024]
                 * @param {number} polynomial
                 * @memberof Rabin
                 */
                constructor(asModule, bits = 12, min = 8 * 1024, max = 32 * 1024, windowSize = 64, polynomial) {
                    this.bits = bits;
                    this.min = min;
                    this.max = max;
                    this.asModule = asModule;
                    this.rabin = new asModule.Rabin(bits, min, max, windowSize, polynomial);
                    this.polynomial = polynomial;
                }
                /**
                 * Fingerprints the buffer
                 *
                 * @param {Uint8Array} buf
                 * @returns {Array<number>}
                 * @memberof Rabin
                 */
                fingerprint(buf) {
                    const { __retain, __release, __allocArray, __getInt32Array, Int32Array_ID, Uint8Array_ID, } = this.asModule;
                    const lengths = new Int32Array(Math.ceil(buf.length / this.min));
                    const lengthsPtr = __retain(__allocArray(Int32Array_ID, lengths));
                    const pointer = __retain(__allocArray(Uint8Array_ID, buf));
                    const out = this.rabin.fingerprint(pointer, lengthsPtr);
                    const processed = __getInt32Array(out);
                    __release(pointer);
                    __release(lengthsPtr);
                    const end = processed.indexOf(0);
                    return end >= 0 ? processed.subarray(0, end) : processed;
                }
            };
            module2.exports = Rabin;
        },
    });
    // node_modules/@assemblyscript/loader/index.js
    var require_loader = __commonJS({
        'node_modules/@assemblyscript/loader/index.js'(exports2) {
            'use strict';
            var ID_OFFSET = -8;
            var SIZE_OFFSET = -4;
            var ARRAYBUFFER_ID = 0;
            var STRING_ID = 1;
            var ARRAYBUFFERVIEW = 1 << 0;
            var ARRAY = 1 << 1;
            var SET = 1 << 2;
            var MAP = 1 << 3;
            var VAL_ALIGN_OFFSET = 5;
            var VAL_ALIGN = 1 << VAL_ALIGN_OFFSET;
            var VAL_SIGNED = 1 << 10;
            var VAL_FLOAT = 1 << 11;
            var VAL_NULLABLE = 1 << 12;
            var VAL_MANAGED = 1 << 13;
            var KEY_ALIGN_OFFSET = 14;
            var KEY_ALIGN = 1 << KEY_ALIGN_OFFSET;
            var KEY_SIGNED = 1 << 19;
            var KEY_FLOAT = 1 << 20;
            var KEY_NULLABLE = 1 << 21;
            var KEY_MANAGED = 1 << 22;
            var ARRAYBUFFERVIEW_BUFFER_OFFSET = 0;
            var ARRAYBUFFERVIEW_DATASTART_OFFSET = 4;
            var ARRAYBUFFERVIEW_DATALENGTH_OFFSET = 8;
            var ARRAYBUFFERVIEW_SIZE = 12;
            var ARRAY_LENGTH_OFFSET = 12;
            var ARRAY_SIZE = 16;
            var BIGINT = typeof BigUint64Array !== 'undefined';
            var THIS = Symbol();
            var CHUNKSIZE = 1024;
            function getStringImpl(buffer, ptr) {
                const U32 = new Uint32Array(buffer);
                const U16 = new Uint16Array(buffer);
                var length2 = U32[(ptr + SIZE_OFFSET) >>> 2] >>> 1;
                var offset = ptr >>> 1;
                if (length2 <= CHUNKSIZE)
                    return String.fromCharCode.apply(String, U16.subarray(offset, offset + length2));
                const parts = [];
                do {
                    const last = U16[offset + CHUNKSIZE - 1];
                    const size = last >= 55296 && last < 56320 ? CHUNKSIZE - 1 : CHUNKSIZE;
                    parts.push(String.fromCharCode.apply(String, U16.subarray(offset, (offset += size))));
                    length2 -= size;
                } while (length2 > CHUNKSIZE);
                return (parts.join('') +
                    String.fromCharCode.apply(String, U16.subarray(offset, offset + length2)));
            }
            function preInstantiate(imports) {
                const baseModule = {};
                function getString(memory, ptr) {
                    if (!memory)
                        return '<yet unknown>';
                    return getStringImpl(memory.buffer, ptr);
                }
                const env = (imports.env = imports.env || {});
                env.abort =
                    env.abort ||
                        function abort(mesg, file, line, colm) {
                            const memory = baseModule.memory || env.memory;
                            throw Error('abort: ' +
                                getString(memory, mesg) +
                                ' at ' +
                                getString(memory, file) +
                                ':' +
                                line +
                                ':' +
                                colm);
                        };
                env.trace =
                    env.trace ||
                        function trace(mesg, n) {
                            const memory = baseModule.memory || env.memory;
                            console.log('trace: ' +
                                getString(memory, mesg) +
                                (n ? ' ' : '') +
                                Array.prototype.slice.call(arguments, 2, 2 + n).join(', '));
                        };
                imports.Math = imports.Math || Math;
                imports.Date = imports.Date || Date;
                return baseModule;
            }
            function postInstantiate(baseModule, instance) {
                const rawExports = instance.exports;
                const memory = rawExports.memory;
                const table = rawExports.table;
                const alloc2 = rawExports['__alloc'];
                const retain = rawExports['__retain'];
                const rttiBase = rawExports['__rtti_base'] || ~0;
                function getInfo(id) {
                    const U32 = new Uint32Array(memory.buffer);
                    const count = U32[rttiBase >>> 2];
                    if ((id >>>= 0) >= count)
                        throw Error('invalid id: ' + id);
                    return U32[((rttiBase + 4) >>> 2) + id * 2];
                }
                function getBase(id) {
                    const U32 = new Uint32Array(memory.buffer);
                    const count = U32[rttiBase >>> 2];
                    if ((id >>>= 0) >= count)
                        throw Error('invalid id: ' + id);
                    return U32[((rttiBase + 4) >>> 2) + id * 2 + 1];
                }
                function getValueAlign(info) {
                    return 31 - Math.clz32((info >>> VAL_ALIGN_OFFSET) & 31);
                }
                function getKeyAlign(info) {
                    return 31 - Math.clz32((info >>> KEY_ALIGN_OFFSET) & 31);
                }
                function __allocString(str) {
                    const length2 = str.length;
                    const ptr = alloc2(length2 << 1, STRING_ID);
                    const U16 = new Uint16Array(memory.buffer);
                    for (var i = 0, p = ptr >>> 1; i < length2; ++i)
                        U16[p + i] = str.charCodeAt(i);
                    return ptr;
                }
                baseModule.__allocString = __allocString;
                function __getString(ptr) {
                    const buffer = memory.buffer;
                    const id = new Uint32Array(buffer)[(ptr + ID_OFFSET) >>> 2];
                    if (id !== STRING_ID)
                        throw Error('not a string: ' + ptr);
                    return getStringImpl(buffer, ptr);
                }
                baseModule.__getString = __getString;
                function getView(alignLog2, signed, float) {
                    const buffer = memory.buffer;
                    if (float) {
                        switch (alignLog2) {
                            case 2:
                                return new Float32Array(buffer);
                            case 3:
                                return new Float64Array(buffer);
                        }
                    }
                    else {
                        switch (alignLog2) {
                            case 0:
                                return new (signed ? Int8Array : Uint8Array)(buffer);
                            case 1:
                                return new (signed ? Int16Array : Uint16Array)(buffer);
                            case 2:
                                return new (signed ? Int32Array : Uint32Array)(buffer);
                            case 3:
                                return new (signed ? BigInt64Array : BigUint64Array)(buffer);
                        }
                    }
                    throw Error('unsupported align: ' + alignLog2);
                }
                function __allocArray(id, values) {
                    const info = getInfo(id);
                    if (!(info & (ARRAYBUFFERVIEW | ARRAY)))
                        throw Error('not an array: ' + id + ' @ ' + info);
                    const align = getValueAlign(info);
                    const length2 = values.length;
                    const buf = alloc2(length2 << align, ARRAYBUFFER_ID);
                    const arr = alloc2(info & ARRAY ? ARRAY_SIZE : ARRAYBUFFERVIEW_SIZE, id);
                    const U32 = new Uint32Array(memory.buffer);
                    U32[(arr + ARRAYBUFFERVIEW_BUFFER_OFFSET) >>> 2] = retain(buf);
                    U32[(arr + ARRAYBUFFERVIEW_DATASTART_OFFSET) >>> 2] = buf;
                    U32[(arr + ARRAYBUFFERVIEW_DATALENGTH_OFFSET) >>> 2] =
                        length2 << align;
                    if (info & ARRAY)
                        U32[(arr + ARRAY_LENGTH_OFFSET) >>> 2] = length2;
                    const view = getView(align, info & VAL_SIGNED, info & VAL_FLOAT);
                    if (info & VAL_MANAGED) {
                        for (let i = 0; i < length2; ++i)
                            view[(buf >>> align) + i] = retain(values[i]);
                    }
                    else {
                        view.set(values, buf >>> align);
                    }
                    return arr;
                }
                baseModule.__allocArray = __allocArray;
                function __getArrayView(arr) {
                    const U32 = new Uint32Array(memory.buffer);
                    const id = U32[(arr + ID_OFFSET) >>> 2];
                    const info = getInfo(id);
                    if (!(info & ARRAYBUFFERVIEW))
                        throw Error('not an array: ' + id);
                    const align = getValueAlign(info);
                    var buf = U32[(arr + ARRAYBUFFERVIEW_DATASTART_OFFSET) >>> 2];
                    const length2 = info & ARRAY
                        ? U32[(arr + ARRAY_LENGTH_OFFSET) >>> 2]
                        : U32[(buf + SIZE_OFFSET) >>> 2] >>> align;
                    return getView(align, info & VAL_SIGNED, info & VAL_FLOAT).subarray((buf >>>= align), buf + length2);
                }
                baseModule.__getArrayView = __getArrayView;
                function __getArray(arr) {
                    const input = __getArrayView(arr);
                    const len = input.length;
                    const out = new Array(len);
                    for (let i = 0; i < len; i++)
                        out[i] = input[i];
                    return out;
                }
                baseModule.__getArray = __getArray;
                function __getArrayBuffer(ptr) {
                    const buffer = memory.buffer;
                    const length2 = new Uint32Array(buffer)[(ptr + SIZE_OFFSET) >>> 2];
                    return buffer.slice(ptr, ptr + length2);
                }
                baseModule.__getArrayBuffer = __getArrayBuffer;
                function getTypedArray(Type, alignLog2, ptr) {
                    return new Type(getTypedArrayView(Type, alignLog2, ptr));
                }
                function getTypedArrayView(Type, alignLog2, ptr) {
                    const buffer = memory.buffer;
                    const U32 = new Uint32Array(buffer);
                    const bufPtr = U32[(ptr + ARRAYBUFFERVIEW_DATASTART_OFFSET) >>> 2];
                    return new Type(buffer, bufPtr, U32[(bufPtr + SIZE_OFFSET) >>> 2] >>> alignLog2);
                }
                baseModule.__getInt8Array = getTypedArray.bind(null, Int8Array, 0);
                baseModule.__getInt8ArrayView = getTypedArrayView.bind(null, Int8Array, 0);
                baseModule.__getUint8Array = getTypedArray.bind(null, Uint8Array, 0);
                baseModule.__getUint8ArrayView = getTypedArrayView.bind(null, Uint8Array, 0);
                baseModule.__getUint8ClampedArray = getTypedArray.bind(null, Uint8ClampedArray, 0);
                baseModule.__getUint8ClampedArrayView = getTypedArrayView.bind(null, Uint8ClampedArray, 0);
                baseModule.__getInt16Array = getTypedArray.bind(null, Int16Array, 1);
                baseModule.__getInt16ArrayView = getTypedArrayView.bind(null, Int16Array, 1);
                baseModule.__getUint16Array = getTypedArray.bind(null, Uint16Array, 1);
                baseModule.__getUint16ArrayView = getTypedArrayView.bind(null, Uint16Array, 1);
                baseModule.__getInt32Array = getTypedArray.bind(null, Int32Array, 2);
                baseModule.__getInt32ArrayView = getTypedArrayView.bind(null, Int32Array, 2);
                baseModule.__getUint32Array = getTypedArray.bind(null, Uint32Array, 2);
                baseModule.__getUint32ArrayView = getTypedArrayView.bind(null, Uint32Array, 2);
                if (BIGINT) {
                    baseModule.__getInt64Array = getTypedArray.bind(null, BigInt64Array, 3);
                    baseModule.__getInt64ArrayView = getTypedArrayView.bind(null, BigInt64Array, 3);
                    baseModule.__getUint64Array = getTypedArray.bind(null, BigUint64Array, 3);
                    baseModule.__getUint64ArrayView = getTypedArrayView.bind(null, BigUint64Array, 3);
                }
                baseModule.__getFloat32Array = getTypedArray.bind(null, Float32Array, 2);
                baseModule.__getFloat32ArrayView = getTypedArrayView.bind(null, Float32Array, 2);
                baseModule.__getFloat64Array = getTypedArray.bind(null, Float64Array, 3);
                baseModule.__getFloat64ArrayView = getTypedArrayView.bind(null, Float64Array, 3);
                function __instanceof(ptr, baseId) {
                    const U32 = new Uint32Array(memory.buffer);
                    var id = U32[(ptr + ID_OFFSET) >>> 2];
                    if (id <= U32[rttiBase >>> 2]) {
                        do
                            if (id == baseId)
                                return true;
                        while ((id = getBase(id)));
                    }
                    return false;
                }
                baseModule.__instanceof = __instanceof;
                baseModule.memory = baseModule.memory || memory;
                baseModule.table = baseModule.table || table;
                return demangle(rawExports, baseModule);
            }
            function isResponse(o) {
                return typeof Response !== 'undefined' && o instanceof Response;
            }
            async function instantiate(source, imports) {
                if (isResponse((source = await source)))
                    return instantiateStreaming(source, imports);
                return postInstantiate(preInstantiate(imports || (imports = {})), await WebAssembly.instantiate(source instanceof WebAssembly.Module
                    ? source
                    : await WebAssembly.compile(source), imports));
            }
            exports2.instantiate = instantiate;
            function instantiateSync(source, imports) {
                return postInstantiate(preInstantiate(imports || (imports = {})), new WebAssembly.Instance(source instanceof WebAssembly.Module
                    ? source
                    : new WebAssembly.Module(source), imports));
            }
            exports2.instantiateSync = instantiateSync;
            async function instantiateStreaming(source, imports) {
                if (!WebAssembly.instantiateStreaming) {
                    return instantiate(isResponse((source = await source)) ? source.arrayBuffer() : source, imports);
                }
                return postInstantiate(preInstantiate(imports || (imports = {})), (await WebAssembly.instantiateStreaming(source, imports)).instance);
            }
            exports2.instantiateStreaming = instantiateStreaming;
            function demangle(exports3, baseModule) {
                var module3 = baseModule ? Object.create(baseModule) : {};
                var setArgumentsLength = exports3['__argumentsLength']
                    ? function (length2) {
                        exports3['__argumentsLength'].value = length2;
                    }
                    : exports3['__setArgumentsLength'] ||
                        exports3['__setargc'] ||
                        function () { };
                for (let internalName in exports3) {
                    if (!Object.prototype.hasOwnProperty.call(exports3, internalName))
                        continue;
                    const elem = exports3[internalName];
                    let parts = internalName.split('.');
                    let curr = module3;
                    while (parts.length > 1) {
                        let part = parts.shift();
                        if (!Object.prototype.hasOwnProperty.call(curr, part))
                            curr[part] = {};
                        curr = curr[part];
                    }
                    let name4 = parts[0];
                    let hash = name4.indexOf('#');
                    if (hash >= 0) {
                        let className = name4.substring(0, hash);
                        let classElem = curr[className];
                        if (typeof classElem === 'undefined' || !classElem.prototype) {
                            let ctor = function (...args) {
                                return ctor.wrap(ctor.prototype.constructor(0, ...args));
                            };
                            ctor.prototype = {
                                valueOf: function valueOf() {
                                    return this[THIS];
                                },
                            };
                            ctor.wrap = function (thisValue) {
                                return Object.create(ctor.prototype, {
                                    [THIS]: { value: thisValue, writable: false },
                                });
                            };
                            if (classElem)
                                Object.getOwnPropertyNames(classElem).forEach((name5) => Object.defineProperty(ctor, name5, Object.getOwnPropertyDescriptor(classElem, name5)));
                            curr[className] = ctor;
                        }
                        name4 = name4.substring(hash + 1);
                        curr = curr[className].prototype;
                        if (/^(get|set):/.test(name4)) {
                            if (!Object.prototype.hasOwnProperty.call(curr, (name4 = name4.substring(4)))) {
                                let getter = exports3[internalName.replace('set:', 'get:')];
                                let setter = exports3[internalName.replace('get:', 'set:')];
                                Object.defineProperty(curr, name4, {
                                    get: function () {
                                        return getter(this[THIS]);
                                    },
                                    set: function (value) {
                                        setter(this[THIS], value);
                                    },
                                    enumerable: true,
                                });
                            }
                        }
                        else {
                            if (name4 === 'constructor') {
                                (curr[name4] = (...args) => {
                                    setArgumentsLength(args.length);
                                    return elem(...args);
                                }).original = elem;
                            }
                            else {
                                (curr[name4] = function (...args) {
                                    setArgumentsLength(args.length);
                                    return elem(this[THIS], ...args);
                                }).original = elem;
                            }
                        }
                    }
                    else {
                        if (/^(get|set):/.test(name4)) {
                            if (!Object.prototype.hasOwnProperty.call(curr, (name4 = name4.substring(4)))) {
                                Object.defineProperty(curr, name4, {
                                    get: exports3[internalName.replace('set:', 'get:')],
                                    set: exports3[internalName.replace('get:', 'set:')],
                                    enumerable: true,
                                });
                            }
                        }
                        else if (typeof elem === 'function' &&
                            elem !== setArgumentsLength) {
                            (curr[name4] = (...args) => {
                                setArgumentsLength(args.length);
                                return elem(...args);
                            }).original = elem;
                        }
                        else {
                            curr[name4] = elem;
                        }
                    }
                }
                return module3;
            }
            exports2.demangle = demangle;
        },
    });
    // node_modules/rabin-wasm/dist/rabin-wasm.js
    var require_rabin_wasm = __commonJS({
        'node_modules/rabin-wasm/dist/rabin-wasm.js'(exports2, module2) {
            var { instantiate } = require_loader();
            loadWebAssembly.supported = typeof WebAssembly !== 'undefined';
            function loadWebAssembly(imp = {}) {
                if (!loadWebAssembly.supported)
                    return null;
                var wasm = new Uint8Array([
                    0, 97, 115, 109, 1, 0, 0, 0, 1, 78, 14, 96, 2, 127, 126, 0, 96, 1,
                    127, 1, 126, 96, 2, 127, 127, 0, 96, 1, 127, 1, 127, 96, 1, 127, 0,
                    96, 2, 127, 127, 1, 127, 96, 3, 127, 127, 127, 1, 127, 96, 0, 0, 96,
                    3, 127, 127, 127, 0, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 0, 96,
                    5, 127, 127, 127, 127, 127, 1, 127, 96, 1, 126, 1, 127, 96, 2, 126,
                    126, 1, 126, 2, 13, 1, 3, 101, 110, 118, 5, 97, 98, 111, 114, 116, 0,
                    10, 3, 54, 53, 2, 2, 8, 9, 3, 5, 2, 8, 6, 5, 3, 4, 2, 6, 9, 12, 13, 2,
                    5, 11, 3, 2, 3, 2, 3, 2, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1,
                    0, 1, 0, 1, 0, 1, 0, 6, 7, 7, 4, 4, 5, 3, 1, 0, 1, 6, 47, 9, 127, 1,
                    65, 0, 11, 127, 1, 65, 0, 11, 127, 0, 65, 3, 11, 127, 0, 65, 4, 11,
                    127, 1, 65, 0, 11, 127, 1, 65, 0, 11, 127, 1, 65, 0, 11, 127, 0, 65,
                    240, 2, 11, 127, 0, 65, 6, 11, 7, 240, 5, 41, 6, 109, 101, 109, 111,
                    114, 121, 2, 0, 7, 95, 95, 97, 108, 108, 111, 99, 0, 10, 8, 95, 95,
                    114, 101, 116, 97, 105, 110, 0, 11, 9, 95, 95, 114, 101, 108, 101, 97,
                    115, 101, 0, 12, 9, 95, 95, 99, 111, 108, 108, 101, 99, 116, 0, 51,
                    11, 95, 95, 114, 116, 116, 105, 95, 98, 97, 115, 101, 3, 7, 13, 73,
                    110, 116, 51, 50, 65, 114, 114, 97, 121, 95, 73, 68, 3, 2, 13, 85,
                    105, 110, 116, 56, 65, 114, 114, 97, 121, 95, 73, 68, 3, 3, 6, 100,
                    101, 103, 114, 101, 101, 0, 16, 3, 109, 111, 100, 0, 17, 5, 82, 97,
                    98, 105, 110, 3, 8, 16, 82, 97, 98, 105, 110, 35, 103, 101, 116, 58,
                    119, 105, 110, 100, 111, 119, 0, 21, 16, 82, 97, 98, 105, 110, 35,
                    115, 101, 116, 58, 119, 105, 110, 100, 111, 119, 0, 22, 21, 82, 97,
                    98, 105, 110, 35, 103, 101, 116, 58, 119, 105, 110, 100, 111, 119, 95,
                    115, 105, 122, 101, 0, 23, 21, 82, 97, 98, 105, 110, 35, 115, 101,
                    116, 58, 119, 105, 110, 100, 111, 119, 95, 115, 105, 122, 101, 0, 24,
                    14, 82, 97, 98, 105, 110, 35, 103, 101, 116, 58, 119, 112, 111, 115,
                    0, 25, 14, 82, 97, 98, 105, 110, 35, 115, 101, 116, 58, 119, 112, 111,
                    115, 0, 26, 15, 82, 97, 98, 105, 110, 35, 103, 101, 116, 58, 99, 111,
                    117, 110, 116, 0, 27, 15, 82, 97, 98, 105, 110, 35, 115, 101, 116, 58,
                    99, 111, 117, 110, 116, 0, 28, 13, 82, 97, 98, 105, 110, 35, 103, 101,
                    116, 58, 112, 111, 115, 0, 29, 13, 82, 97, 98, 105, 110, 35, 115, 101,
                    116, 58, 112, 111, 115, 0, 30, 15, 82, 97, 98, 105, 110, 35, 103, 101,
                    116, 58, 115, 116, 97, 114, 116, 0, 31, 15, 82, 97, 98, 105, 110, 35,
                    115, 101, 116, 58, 115, 116, 97, 114, 116, 0, 32, 16, 82, 97, 98, 105,
                    110, 35, 103, 101, 116, 58, 100, 105, 103, 101, 115, 116, 0, 33, 16,
                    82, 97, 98, 105, 110, 35, 115, 101, 116, 58, 100, 105, 103, 101, 115,
                    116, 0, 34, 21, 82, 97, 98, 105, 110, 35, 103, 101, 116, 58, 99, 104,
                    117, 110, 107, 95, 115, 116, 97, 114, 116, 0, 35, 21, 82, 97, 98, 105,
                    110, 35, 115, 101, 116, 58, 99, 104, 117, 110, 107, 95, 115, 116, 97,
                    114, 116, 0, 36, 22, 82, 97, 98, 105, 110, 35, 103, 101, 116, 58, 99,
                    104, 117, 110, 107, 95, 108, 101, 110, 103, 116, 104, 0, 37, 22, 82,
                    97, 98, 105, 110, 35, 115, 101, 116, 58, 99, 104, 117, 110, 107, 95,
                    108, 101, 110, 103, 116, 104, 0, 38, 31, 82, 97, 98, 105, 110, 35,
                    103, 101, 116, 58, 99, 104, 117, 110, 107, 95, 99, 117, 116, 95, 102,
                    105, 110, 103, 101, 114, 112, 114, 105, 110, 116, 0, 39, 31, 82, 97,
                    98, 105, 110, 35, 115, 101, 116, 58, 99, 104, 117, 110, 107, 95, 99,
                    117, 116, 95, 102, 105, 110, 103, 101, 114, 112, 114, 105, 110, 116,
                    0, 40, 20, 82, 97, 98, 105, 110, 35, 103, 101, 116, 58, 112, 111, 108,
                    121, 110, 111, 109, 105, 97, 108, 0, 41, 20, 82, 97, 98, 105, 110, 35,
                    115, 101, 116, 58, 112, 111, 108, 121, 110, 111, 109, 105, 97, 108, 0,
                    42, 17, 82, 97, 98, 105, 110, 35, 103, 101, 116, 58, 109, 105, 110,
                    115, 105, 122, 101, 0, 43, 17, 82, 97, 98, 105, 110, 35, 115, 101,
                    116, 58, 109, 105, 110, 115, 105, 122, 101, 0, 44, 17, 82, 97, 98,
                    105, 110, 35, 103, 101, 116, 58, 109, 97, 120, 115, 105, 122, 101, 0,
                    45, 17, 82, 97, 98, 105, 110, 35, 115, 101, 116, 58, 109, 97, 120,
                    115, 105, 122, 101, 0, 46, 14, 82, 97, 98, 105, 110, 35, 103, 101,
                    116, 58, 109, 97, 115, 107, 0, 47, 14, 82, 97, 98, 105, 110, 35, 115,
                    101, 116, 58, 109, 97, 115, 107, 0, 48, 17, 82, 97, 98, 105, 110, 35,
                    99, 111, 110, 115, 116, 114, 117, 99, 116, 111, 114, 0, 20, 17, 82,
                    97, 98, 105, 110, 35, 102, 105, 110, 103, 101, 114, 112, 114, 105,
                    110, 116, 0, 49, 8, 1, 50, 10, 165, 31, 53, 199, 1, 1, 4, 127, 32, 1,
                    40, 2, 0, 65, 124, 113, 34, 2, 65, 128, 2, 73, 4, 127, 32, 2, 65, 4,
                    118, 33, 4, 65, 0, 5, 32, 2, 65, 31, 32, 2, 103, 107, 34, 3, 65, 4,
                    107, 118, 65, 16, 115, 33, 4, 32, 3, 65, 7, 107, 11, 33, 3, 32, 1, 40,
                    2, 20, 33, 2, 32, 1, 40, 2, 16, 34, 5, 4, 64, 32, 5, 32, 2, 54, 2, 20,
                    11, 32, 2, 4, 64, 32, 2, 32, 5, 54, 2, 16, 11, 32, 1, 32, 0, 32, 4,
                    32, 3, 65, 4, 116, 106, 65, 2, 116, 106, 40, 2, 96, 70, 4, 64, 32, 0,
                    32, 4, 32, 3, 65, 4, 116, 106, 65, 2, 116, 106, 32, 2, 54, 2, 96, 32,
                    2, 69, 4, 64, 32, 0, 32, 3, 65, 2, 116, 106, 32, 0, 32, 3, 65, 2, 116,
                    106, 40, 2, 4, 65, 1, 32, 4, 116, 65, 127, 115, 113, 34, 1, 54, 2, 4,
                    32, 1, 69, 4, 64, 32, 0, 32, 0, 40, 2, 0, 65, 1, 32, 3, 116, 65, 127,
                    115, 113, 54, 2, 0, 11, 11, 11, 11, 226, 2, 1, 6, 127, 32, 1, 40, 2,
                    0, 33, 3, 32, 1, 65, 16, 106, 32, 1, 40, 2, 0, 65, 124, 113, 106, 34,
                    4, 40, 2, 0, 34, 5, 65, 1, 113, 4, 64, 32, 3, 65, 124, 113, 65, 16,
                    106, 32, 5, 65, 124, 113, 106, 34, 2, 65, 240, 255, 255, 255, 3, 73,
                    4, 64, 32, 0, 32, 4, 16, 1, 32, 1, 32, 2, 32, 3, 65, 3, 113, 114, 34,
                    3, 54, 2, 0, 32, 1, 65, 16, 106, 32, 1, 40, 2, 0, 65, 124, 113, 106,
                    34, 4, 40, 2, 0, 33, 5, 11, 11, 32, 3, 65, 2, 113, 4, 64, 32, 1, 65,
                    4, 107, 40, 2, 0, 34, 2, 40, 2, 0, 34, 6, 65, 124, 113, 65, 16, 106,
                    32, 3, 65, 124, 113, 106, 34, 7, 65, 240, 255, 255, 255, 3, 73, 4, 64,
                    32, 0, 32, 2, 16, 1, 32, 2, 32, 7, 32, 6, 65, 3, 113, 114, 34, 3, 54,
                    2, 0, 32, 2, 33, 1, 11, 11, 32, 4, 32, 5, 65, 2, 114, 54, 2, 0, 32, 4,
                    65, 4, 107, 32, 1, 54, 2, 0, 32, 0, 32, 3, 65, 124, 113, 34, 2, 65,
                    128, 2, 73, 4, 127, 32, 2, 65, 4, 118, 33, 4, 65, 0, 5, 32, 2, 65, 31,
                    32, 2, 103, 107, 34, 2, 65, 4, 107, 118, 65, 16, 115, 33, 4, 32, 2,
                    65, 7, 107, 11, 34, 3, 65, 4, 116, 32, 4, 106, 65, 2, 116, 106, 40, 2,
                    96, 33, 2, 32, 1, 65, 0, 54, 2, 16, 32, 1, 32, 2, 54, 2, 20, 32, 2, 4,
                    64, 32, 2, 32, 1, 54, 2, 16, 11, 32, 0, 32, 4, 32, 3, 65, 4, 116, 106,
                    65, 2, 116, 106, 32, 1, 54, 2, 96, 32, 0, 32, 0, 40, 2, 0, 65, 1, 32,
                    3, 116, 114, 54, 2, 0, 32, 0, 32, 3, 65, 2, 116, 106, 32, 0, 32, 3,
                    65, 2, 116, 106, 40, 2, 4, 65, 1, 32, 4, 116, 114, 54, 2, 4, 11, 119,
                    1, 1, 127, 32, 2, 2, 127, 32, 0, 40, 2, 160, 12, 34, 2, 4, 64, 32, 2,
                    32, 1, 65, 16, 107, 70, 4, 64, 32, 2, 40, 2, 0, 33, 3, 32, 1, 65, 16,
                    107, 33, 1, 11, 11, 32, 1, 11, 107, 34, 2, 65, 48, 73, 4, 64, 15, 11,
                    32, 1, 32, 3, 65, 2, 113, 32, 2, 65, 32, 107, 65, 1, 114, 114, 54, 2,
                    0, 32, 1, 65, 0, 54, 2, 16, 32, 1, 65, 0, 54, 2, 20, 32, 1, 32, 2,
                    106, 65, 16, 107, 34, 2, 65, 2, 54, 2, 0, 32, 0, 32, 2, 54, 2, 160,
                    12, 32, 0, 32, 1, 16, 2, 11, 155, 1, 1, 3, 127, 35, 0, 34, 0, 69, 4,
                    64, 65, 1, 63, 0, 34, 0, 74, 4, 127, 65, 1, 32, 0, 107, 64, 0, 65, 0,
                    72, 5, 65, 0, 11, 4, 64, 0, 11, 65, 176, 3, 34, 0, 65, 0, 54, 2, 0,
                    65, 208, 15, 65, 0, 54, 2, 0, 3, 64, 32, 1, 65, 23, 73, 4, 64, 32, 1,
                    65, 2, 116, 65, 176, 3, 106, 65, 0, 54, 2, 4, 65, 0, 33, 2, 3, 64, 32,
                    2, 65, 16, 73, 4, 64, 32, 1, 65, 4, 116, 32, 2, 106, 65, 2, 116, 65,
                    176, 3, 106, 65, 0, 54, 2, 96, 32, 2, 65, 1, 106, 33, 2, 12, 1, 11,
                    11, 32, 1, 65, 1, 106, 33, 1, 12, 1, 11, 11, 65, 176, 3, 65, 224, 15,
                    63, 0, 65, 16, 116, 16, 3, 65, 176, 3, 36, 0, 11, 32, 0, 11, 45, 0,
                    32, 0, 65, 240, 255, 255, 255, 3, 79, 4, 64, 65, 32, 65, 224, 0, 65,
                    201, 3, 65, 29, 16, 0, 0, 11, 32, 0, 65, 15, 106, 65, 112, 113, 34, 0,
                    65, 16, 32, 0, 65, 16, 75, 27, 11, 169, 1, 1, 1, 127, 32, 0, 32, 1,
                    65, 128, 2, 73, 4, 127, 32, 1, 65, 4, 118, 33, 1, 65, 0, 5, 32, 1, 65,
                    248, 255, 255, 255, 1, 73, 4, 64, 32, 1, 65, 1, 65, 27, 32, 1, 103,
                    107, 116, 106, 65, 1, 107, 33, 1, 11, 32, 1, 65, 31, 32, 1, 103, 107,
                    34, 2, 65, 4, 107, 118, 65, 16, 115, 33, 1, 32, 2, 65, 7, 107, 11, 34,
                    2, 65, 2, 116, 106, 40, 2, 4, 65, 127, 32, 1, 116, 113, 34, 1, 4, 127,
                    32, 0, 32, 1, 104, 32, 2, 65, 4, 116, 106, 65, 2, 116, 106, 40, 2, 96,
                    5, 32, 0, 40, 2, 0, 65, 127, 32, 2, 65, 1, 106, 116, 113, 34, 1, 4,
                    127, 32, 0, 32, 0, 32, 1, 104, 34, 0, 65, 2, 116, 106, 40, 2, 4, 104,
                    32, 0, 65, 4, 116, 106, 65, 2, 116, 106, 40, 2, 96, 5, 65, 0, 11, 11,
                    11, 111, 1, 1, 127, 63, 0, 34, 2, 32, 1, 65, 248, 255, 255, 255, 1,
                    73, 4, 127, 32, 1, 65, 1, 65, 27, 32, 1, 103, 107, 116, 65, 1, 107,
                    106, 5, 32, 1, 11, 65, 16, 32, 0, 40, 2, 160, 12, 32, 2, 65, 16, 116,
                    65, 16, 107, 71, 116, 106, 65, 255, 255, 3, 106, 65, 128, 128, 124,
                    113, 65, 16, 118, 34, 1, 32, 2, 32, 1, 74, 27, 64, 0, 65, 0, 72, 4,
                    64, 32, 1, 64, 0, 65, 0, 72, 4, 64, 0, 11, 11, 32, 0, 32, 2, 65, 16,
                    116, 63, 0, 65, 16, 116, 16, 3, 11, 113, 1, 2, 127, 32, 1, 40, 2, 0,
                    34, 3, 65, 124, 113, 32, 2, 107, 34, 4, 65, 32, 79, 4, 64, 32, 1, 32,
                    2, 32, 3, 65, 2, 113, 114, 54, 2, 0, 32, 2, 32, 1, 65, 16, 106, 106,
                    34, 1, 32, 4, 65, 16, 107, 65, 1, 114, 54, 2, 0, 32, 0, 32, 1, 16, 2,
                    5, 32, 1, 32, 3, 65, 126, 113, 54, 2, 0, 32, 1, 65, 16, 106, 32, 1,
                    40, 2, 0, 65, 124, 113, 106, 32, 1, 65, 16, 106, 32, 1, 40, 2, 0, 65,
                    124, 113, 106, 40, 2, 0, 65, 125, 113, 54, 2, 0, 11, 11, 91, 1, 2,
                    127, 32, 0, 32, 1, 16, 5, 34, 4, 16, 6, 34, 3, 69, 4, 64, 65, 1, 36,
                    1, 65, 0, 36, 1, 32, 0, 32, 4, 16, 6, 34, 3, 69, 4, 64, 32, 0, 32, 4,
                    16, 7, 32, 0, 32, 4, 16, 6, 33, 3, 11, 11, 32, 3, 65, 0, 54, 2, 4, 32,
                    3, 32, 2, 54, 2, 8, 32, 3, 32, 1, 54, 2, 12, 32, 0, 32, 3, 16, 1, 32,
                    0, 32, 3, 32, 4, 16, 8, 32, 3, 11, 13, 0, 16, 4, 32, 0, 32, 1, 16, 9,
                    65, 16, 106, 11, 33, 1, 1, 127, 32, 0, 65, 172, 3, 75, 4, 64, 32, 0,
                    65, 16, 107, 34, 1, 32, 1, 40, 2, 4, 65, 1, 106, 54, 2, 4, 11, 32, 0,
                    11, 18, 0, 32, 0, 65, 172, 3, 75, 4, 64, 32, 0, 65, 16, 107, 16, 52,
                    11, 11, 140, 3, 1, 1, 127, 2, 64, 32, 1, 69, 13, 0, 32, 0, 65, 0, 58,
                    0, 0, 32, 0, 32, 1, 106, 65, 1, 107, 65, 0, 58, 0, 0, 32, 1, 65, 2,
                    77, 13, 0, 32, 0, 65, 1, 106, 65, 0, 58, 0, 0, 32, 0, 65, 2, 106, 65,
                    0, 58, 0, 0, 32, 0, 32, 1, 106, 34, 2, 65, 2, 107, 65, 0, 58, 0, 0,
                    32, 2, 65, 3, 107, 65, 0, 58, 0, 0, 32, 1, 65, 6, 77, 13, 0, 32, 0,
                    65, 3, 106, 65, 0, 58, 0, 0, 32, 0, 32, 1, 106, 65, 4, 107, 65, 0, 58,
                    0, 0, 32, 1, 65, 8, 77, 13, 0, 32, 1, 65, 0, 32, 0, 107, 65, 3, 113,
                    34, 1, 107, 33, 2, 32, 0, 32, 1, 106, 34, 0, 65, 0, 54, 2, 0, 32, 0,
                    32, 2, 65, 124, 113, 34, 1, 106, 65, 4, 107, 65, 0, 54, 2, 0, 32, 1,
                    65, 8, 77, 13, 0, 32, 0, 65, 4, 106, 65, 0, 54, 2, 0, 32, 0, 65, 8,
                    106, 65, 0, 54, 2, 0, 32, 0, 32, 1, 106, 34, 2, 65, 12, 107, 65, 0,
                    54, 2, 0, 32, 2, 65, 8, 107, 65, 0, 54, 2, 0, 32, 1, 65, 24, 77, 13,
                    0, 32, 0, 65, 12, 106, 65, 0, 54, 2, 0, 32, 0, 65, 16, 106, 65, 0, 54,
                    2, 0, 32, 0, 65, 20, 106, 65, 0, 54, 2, 0, 32, 0, 65, 24, 106, 65, 0,
                    54, 2, 0, 32, 0, 32, 1, 106, 34, 2, 65, 28, 107, 65, 0, 54, 2, 0, 32,
                    2, 65, 24, 107, 65, 0, 54, 2, 0, 32, 2, 65, 20, 107, 65, 0, 54, 2, 0,
                    32, 2, 65, 16, 107, 65, 0, 54, 2, 0, 32, 0, 32, 0, 65, 4, 113, 65, 24,
                    106, 34, 2, 106, 33, 0, 32, 1, 32, 2, 107, 33, 1, 3, 64, 32, 1, 65,
                    32, 79, 4, 64, 32, 0, 66, 0, 55, 3, 0, 32, 0, 65, 8, 106, 66, 0, 55,
                    3, 0, 32, 0, 65, 16, 106, 66, 0, 55, 3, 0, 32, 0, 65, 24, 106, 66, 0,
                    55, 3, 0, 32, 1, 65, 32, 107, 33, 1, 32, 0, 65, 32, 106, 33, 0, 12, 1,
                    11, 11, 11, 11, 178, 1, 1, 3, 127, 32, 1, 65, 240, 255, 255, 255, 3,
                    32, 2, 118, 75, 4, 64, 65, 144, 1, 65, 192, 1, 65, 23, 65, 56, 16, 0,
                    0, 11, 32, 1, 32, 2, 116, 34, 3, 65, 0, 16, 10, 34, 2, 32, 3, 16, 13,
                    32, 0, 69, 4, 64, 65, 12, 65, 2, 16, 10, 34, 0, 65, 172, 3, 75, 4, 64,
                    32, 0, 65, 16, 107, 34, 1, 32, 1, 40, 2, 4, 65, 1, 106, 54, 2, 4, 11,
                    11, 32, 0, 65, 0, 54, 2, 0, 32, 0, 65, 0, 54, 2, 4, 32, 0, 65, 0, 54,
                    2, 8, 32, 2, 34, 1, 32, 0, 40, 2, 0, 34, 4, 71, 4, 64, 32, 1, 65, 172,
                    3, 75, 4, 64, 32, 1, 65, 16, 107, 34, 5, 32, 5, 40, 2, 4, 65, 1, 106,
                    54, 2, 4, 11, 32, 4, 16, 12, 11, 32, 0, 32, 1, 54, 2, 0, 32, 0, 32, 2,
                    54, 2, 4, 32, 0, 32, 3, 54, 2, 8, 32, 0, 11, 46, 1, 2, 127, 65, 12,
                    65, 5, 16, 10, 34, 0, 65, 172, 3, 75, 4, 64, 32, 0, 65, 16, 107, 34,
                    1, 32, 1, 40, 2, 4, 65, 1, 106, 54, 2, 4, 11, 32, 0, 65, 128, 2, 65,
                    3, 16, 14, 11, 9, 0, 65, 63, 32, 0, 121, 167, 107, 11, 49, 1, 2, 127,
                    65, 63, 32, 1, 121, 167, 107, 33, 2, 3, 64, 65, 63, 32, 0, 121, 167,
                    107, 32, 2, 107, 34, 3, 65, 0, 78, 4, 64, 32, 0, 32, 1, 32, 3, 172,
                    134, 133, 33, 0, 12, 1, 11, 11, 32, 0, 11, 40, 0, 32, 1, 32, 0, 40, 2,
                    8, 79, 4, 64, 65, 128, 2, 65, 192, 2, 65, 163, 1, 65, 44, 16, 0, 0,
                    11, 32, 1, 32, 0, 40, 2, 4, 106, 65, 0, 58, 0, 0, 11, 38, 0, 32, 1,
                    32, 0, 40, 2, 8, 79, 4, 64, 65, 128, 2, 65, 192, 2, 65, 152, 1, 65,
                    44, 16, 0, 0, 11, 32, 1, 32, 0, 40, 2, 4, 106, 45, 0, 0, 11, 254, 5,
                    2, 1, 127, 4, 126, 32, 0, 69, 4, 64, 65, 232, 0, 65, 6, 16, 10, 34, 0,
                    65, 172, 3, 75, 4, 64, 32, 0, 65, 16, 107, 34, 5, 32, 5, 40, 2, 4, 65,
                    1, 106, 54, 2, 4, 11, 11, 32, 0, 65, 0, 54, 2, 0, 32, 0, 65, 0, 54, 2,
                    4, 32, 0, 65, 0, 54, 2, 8, 32, 0, 66, 0, 55, 3, 16, 32, 0, 66, 0, 55,
                    3, 24, 32, 0, 66, 0, 55, 3, 32, 32, 0, 66, 0, 55, 3, 40, 32, 0, 66, 0,
                    55, 3, 48, 32, 0, 66, 0, 55, 3, 56, 32, 0, 66, 0, 55, 3, 64, 32, 0,
                    66, 0, 55, 3, 72, 32, 0, 66, 0, 55, 3, 80, 32, 0, 66, 0, 55, 3, 88,
                    32, 0, 66, 0, 55, 3, 96, 32, 0, 32, 2, 173, 55, 3, 80, 32, 0, 32, 3,
                    173, 55, 3, 88, 65, 12, 65, 4, 16, 10, 34, 2, 65, 172, 3, 75, 4, 64,
                    32, 2, 65, 16, 107, 34, 3, 32, 3, 40, 2, 4, 65, 1, 106, 54, 2, 4, 11,
                    32, 2, 32, 4, 65, 0, 16, 14, 33, 2, 32, 0, 40, 2, 0, 16, 12, 32, 0,
                    32, 2, 54, 2, 0, 32, 0, 32, 4, 54, 2, 4, 32, 0, 66, 1, 32, 1, 173,
                    134, 66, 1, 125, 55, 3, 96, 32, 0, 66, 243, 130, 183, 218, 216, 230,
                    232, 30, 55, 3, 72, 35, 4, 69, 4, 64, 65, 0, 33, 2, 3, 64, 32, 2, 65,
                    128, 2, 72, 4, 64, 32, 2, 65, 255, 1, 113, 173, 33, 6, 32, 0, 41, 3,
                    72, 34, 7, 33, 8, 65, 63, 32, 7, 121, 167, 107, 33, 1, 3, 64, 65, 63,
                    32, 6, 121, 167, 107, 32, 1, 107, 34, 3, 65, 0, 78, 4, 64, 32, 6, 32,
                    8, 32, 3, 172, 134, 133, 33, 6, 12, 1, 11, 11, 65, 0, 33, 4, 3, 64,
                    32, 4, 32, 0, 40, 2, 4, 65, 1, 107, 72, 4, 64, 32, 6, 66, 8, 134, 33,
                    6, 32, 0, 41, 3, 72, 34, 7, 33, 8, 65, 63, 32, 7, 121, 167, 107, 33,
                    1, 3, 64, 65, 63, 32, 6, 121, 167, 107, 32, 1, 107, 34, 3, 65, 0, 78,
                    4, 64, 32, 6, 32, 8, 32, 3, 172, 134, 133, 33, 6, 12, 1, 11, 11, 32,
                    4, 65, 1, 106, 33, 4, 12, 1, 11, 11, 35, 6, 40, 2, 4, 32, 2, 65, 3,
                    116, 106, 32, 6, 55, 3, 0, 32, 2, 65, 1, 106, 33, 2, 12, 1, 11, 11,
                    65, 63, 32, 0, 41, 3, 72, 121, 167, 107, 172, 33, 7, 65, 0, 33, 2, 3,
                    64, 32, 2, 65, 128, 2, 72, 4, 64, 35, 5, 33, 1, 32, 2, 172, 32, 7,
                    134, 34, 8, 33, 6, 65, 63, 32, 0, 41, 3, 72, 34, 9, 121, 167, 107, 33,
                    3, 3, 64, 65, 63, 32, 6, 121, 167, 107, 32, 3, 107, 34, 4, 65, 0, 78,
                    4, 64, 32, 6, 32, 9, 32, 4, 172, 134, 133, 33, 6, 12, 1, 11, 11, 32,
                    1, 40, 2, 4, 32, 2, 65, 3, 116, 106, 32, 6, 32, 8, 132, 55, 3, 0, 32,
                    2, 65, 1, 106, 33, 2, 12, 1, 11, 11, 65, 1, 36, 4, 11, 32, 0, 66, 0,
                    55, 3, 24, 32, 0, 66, 0, 55, 3, 32, 65, 0, 33, 2, 3, 64, 32, 2, 32, 0,
                    40, 2, 4, 72, 4, 64, 32, 0, 40, 2, 0, 32, 2, 16, 18, 32, 2, 65, 1,
                    106, 33, 2, 12, 1, 11, 11, 32, 0, 66, 0, 55, 3, 40, 32, 0, 65, 0, 54,
                    2, 8, 32, 0, 66, 0, 55, 3, 16, 32, 0, 66, 0, 55, 3, 40, 32, 0, 40, 2,
                    0, 32, 0, 40, 2, 8, 16, 19, 33, 1, 32, 0, 40, 2, 8, 32, 0, 40, 2, 0,
                    40, 2, 4, 106, 65, 1, 58, 0, 0, 32, 0, 32, 0, 41, 3, 40, 35, 6, 40, 2,
                    4, 32, 1, 65, 3, 116, 106, 41, 3, 0, 133, 55, 3, 40, 32, 0, 32, 0, 40,
                    2, 8, 65, 1, 106, 32, 0, 40, 2, 4, 111, 54, 2, 8, 32, 0, 35, 5, 40, 2,
                    4, 32, 0, 41, 3, 40, 34, 6, 66, 45, 136, 167, 65, 3, 116, 106, 41, 3,
                    0, 32, 6, 66, 8, 134, 66, 1, 132, 133, 55, 3, 40, 32, 0, 11, 38, 1, 1,
                    127, 32, 0, 40, 2, 0, 34, 0, 65, 172, 3, 75, 4, 64, 32, 0, 65, 16,
                    107, 34, 1, 32, 1, 40, 2, 4, 65, 1, 106, 54, 2, 4, 11, 32, 0, 11, 55,
                    1, 2, 127, 32, 1, 32, 0, 40, 2, 0, 34, 2, 71, 4, 64, 32, 1, 65, 172,
                    3, 75, 4, 64, 32, 1, 65, 16, 107, 34, 3, 32, 3, 40, 2, 4, 65, 1, 106,
                    54, 2, 4, 11, 32, 2, 16, 12, 11, 32, 0, 32, 1, 54, 2, 0, 11, 7, 0, 32,
                    0, 40, 2, 4, 11, 9, 0, 32, 0, 32, 1, 54, 2, 4, 11, 7, 0, 32, 0, 40, 2,
                    8, 11, 9, 0, 32, 0, 32, 1, 54, 2, 8, 11, 7, 0, 32, 0, 41, 3, 16, 11,
                    9, 0, 32, 0, 32, 1, 55, 3, 16, 11, 7, 0, 32, 0, 41, 3, 24, 11, 9, 0,
                    32, 0, 32, 1, 55, 3, 24, 11, 7, 0, 32, 0, 41, 3, 32, 11, 9, 0, 32, 0,
                    32, 1, 55, 3, 32, 11, 7, 0, 32, 0, 41, 3, 40, 11, 9, 0, 32, 0, 32, 1,
                    55, 3, 40, 11, 7, 0, 32, 0, 41, 3, 48, 11, 9, 0, 32, 0, 32, 1, 55, 3,
                    48, 11, 7, 0, 32, 0, 41, 3, 56, 11, 9, 0, 32, 0, 32, 1, 55, 3, 56, 11,
                    7, 0, 32, 0, 41, 3, 64, 11, 9, 0, 32, 0, 32, 1, 55, 3, 64, 11, 7, 0,
                    32, 0, 41, 3, 72, 11, 9, 0, 32, 0, 32, 1, 55, 3, 72, 11, 7, 0, 32, 0,
                    41, 3, 80, 11, 9, 0, 32, 0, 32, 1, 55, 3, 80, 11, 7, 0, 32, 0, 41, 3,
                    88, 11, 9, 0, 32, 0, 32, 1, 55, 3, 88, 11, 7, 0, 32, 0, 41, 3, 96, 11,
                    9, 0, 32, 0, 32, 1, 55, 3, 96, 11, 172, 4, 2, 5, 127, 1, 126, 32, 2,
                    65, 172, 3, 75, 4, 64, 32, 2, 65, 16, 107, 34, 4, 32, 4, 40, 2, 4, 65,
                    1, 106, 54, 2, 4, 11, 32, 2, 33, 4, 65, 0, 33, 2, 32, 1, 40, 2, 8, 33,
                    5, 32, 1, 40, 2, 4, 33, 6, 3, 64, 2, 127, 65, 0, 33, 3, 3, 64, 32, 3,
                    32, 5, 72, 4, 64, 32, 3, 32, 6, 106, 45, 0, 0, 33, 1, 32, 0, 40, 2, 0,
                    32, 0, 40, 2, 8, 16, 19, 33, 7, 32, 0, 40, 2, 8, 32, 0, 40, 2, 0, 40,
                    2, 4, 106, 32, 1, 58, 0, 0, 32, 0, 32, 0, 41, 3, 40, 35, 6, 40, 2, 4,
                    32, 7, 65, 3, 116, 106, 41, 3, 0, 133, 55, 3, 40, 32, 0, 32, 0, 40, 2,
                    8, 65, 1, 106, 32, 0, 40, 2, 4, 111, 54, 2, 8, 32, 0, 35, 5, 40, 2, 4,
                    32, 0, 41, 3, 40, 34, 8, 66, 45, 136, 167, 65, 3, 116, 106, 41, 3, 0,
                    32, 1, 173, 32, 8, 66, 8, 134, 132, 133, 55, 3, 40, 32, 0, 32, 0, 41,
                    3, 16, 66, 1, 124, 55, 3, 16, 32, 0, 32, 0, 41, 3, 24, 66, 1, 124, 55,
                    3, 24, 32, 0, 41, 3, 16, 32, 0, 41, 3, 80, 90, 4, 127, 32, 0, 41, 3,
                    40, 32, 0, 41, 3, 96, 131, 80, 5, 65, 0, 11, 4, 127, 65, 1, 5, 32, 0,
                    41, 3, 16, 32, 0, 41, 3, 88, 90, 11, 4, 64, 32, 0, 32, 0, 41, 3, 32,
                    55, 3, 48, 32, 0, 32, 0, 41, 3, 16, 55, 3, 56, 32, 0, 32, 0, 41, 3,
                    40, 55, 3, 64, 65, 0, 33, 1, 3, 64, 32, 1, 32, 0, 40, 2, 4, 72, 4, 64,
                    32, 0, 40, 2, 0, 32, 1, 16, 18, 32, 1, 65, 1, 106, 33, 1, 12, 1, 11,
                    11, 32, 0, 66, 0, 55, 3, 40, 32, 0, 65, 0, 54, 2, 8, 32, 0, 66, 0, 55,
                    3, 16, 32, 0, 66, 0, 55, 3, 40, 32, 0, 40, 2, 0, 32, 0, 40, 2, 8, 16,
                    19, 33, 1, 32, 0, 40, 2, 8, 32, 0, 40, 2, 0, 40, 2, 4, 106, 65, 1, 58,
                    0, 0, 32, 0, 32, 0, 41, 3, 40, 35, 6, 40, 2, 4, 32, 1, 65, 3, 116,
                    106, 41, 3, 0, 133, 55, 3, 40, 32, 0, 32, 0, 40, 2, 8, 65, 1, 106, 32,
                    0, 40, 2, 4, 111, 54, 2, 8, 32, 0, 35, 5, 40, 2, 4, 32, 0, 41, 3, 40,
                    34, 8, 66, 45, 136, 167, 65, 3, 116, 106, 41, 3, 0, 32, 8, 66, 8, 134,
                    66, 1, 132, 133, 55, 3, 40, 32, 3, 65, 1, 106, 12, 3, 11, 32, 3, 65,
                    1, 106, 33, 3, 12, 1, 11, 11, 65, 127, 11, 34, 1, 65, 0, 78, 4, 64,
                    32, 5, 32, 1, 107, 33, 5, 32, 1, 32, 6, 106, 33, 6, 32, 2, 34, 1, 65,
                    1, 106, 33, 2, 32, 4, 40, 2, 4, 32, 1, 65, 2, 116, 106, 32, 0, 41, 3,
                    56, 62, 2, 0, 12, 1, 11, 11, 32, 4, 11, 10, 0, 16, 15, 36, 5, 16, 15,
                    36, 6, 11, 3, 0, 1, 11, 73, 1, 2, 127, 32, 0, 40, 2, 4, 34, 1, 65,
                    255, 255, 255, 255, 0, 113, 34, 2, 65, 1, 70, 4, 64, 32, 0, 65, 16,
                    106, 16, 53, 32, 0, 32, 0, 40, 2, 0, 65, 1, 114, 54, 2, 0, 35, 0, 32,
                    0, 16, 2, 5, 32, 0, 32, 2, 65, 1, 107, 32, 1, 65, 128, 128, 128, 128,
                    127, 113, 114, 54, 2, 4, 11, 11, 58, 0, 2, 64, 2, 64, 2, 64, 32, 0,
                    65, 8, 107, 40, 2, 0, 14, 7, 0, 0, 1, 1, 1, 1, 1, 2, 11, 15, 11, 32,
                    0, 40, 2, 0, 34, 0, 4, 64, 32, 0, 65, 172, 3, 79, 4, 64, 32, 0, 65,
                    16, 107, 16, 52, 11, 11, 15, 11, 0, 11, 11, 137, 3, 7, 0, 65, 16, 11,
                    55, 40, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 40, 0, 0, 0, 97, 0, 108, 0,
                    108, 0, 111, 0, 99, 0, 97, 0, 116, 0, 105, 0, 111, 0, 110, 0, 32, 0,
                    116, 0, 111, 0, 111, 0, 32, 0, 108, 0, 97, 0, 114, 0, 103, 0, 101, 0,
                    65, 208, 0, 11, 45, 30, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 30, 0, 0, 0,
                    126, 0, 108, 0, 105, 0, 98, 0, 47, 0, 114, 0, 116, 0, 47, 0, 116, 0,
                    108, 0, 115, 0, 102, 0, 46, 0, 116, 0, 115, 0, 65, 128, 1, 11, 43, 28,
                    0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 28, 0, 0, 0, 73, 0, 110, 0, 118, 0,
                    97, 0, 108, 0, 105, 0, 100, 0, 32, 0, 108, 0, 101, 0, 110, 0, 103, 0,
                    116, 0, 104, 0, 65, 176, 1, 11, 53, 38, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0,
                    0, 38, 0, 0, 0, 126, 0, 108, 0, 105, 0, 98, 0, 47, 0, 97, 0, 114, 0,
                    114, 0, 97, 0, 121, 0, 98, 0, 117, 0, 102, 0, 102, 0, 101, 0, 114, 0,
                    46, 0, 116, 0, 115, 0, 65, 240, 1, 11, 51, 36, 0, 0, 0, 1, 0, 0, 0, 1,
                    0, 0, 0, 36, 0, 0, 0, 73, 0, 110, 0, 100, 0, 101, 0, 120, 0, 32, 0,
                    111, 0, 117, 0, 116, 0, 32, 0, 111, 0, 102, 0, 32, 0, 114, 0, 97, 0,
                    110, 0, 103, 0, 101, 0, 65, 176, 2, 11, 51, 36, 0, 0, 0, 1, 0, 0, 0,
                    1, 0, 0, 0, 36, 0, 0, 0, 126, 0, 108, 0, 105, 0, 98, 0, 47, 0, 116, 0,
                    121, 0, 112, 0, 101, 0, 100, 0, 97, 0, 114, 0, 114, 0, 97, 0, 121, 0,
                    46, 0, 116, 0, 115, 0, 65, 240, 2, 11, 53, 7, 0, 0, 0, 16, 0, 0, 0, 0,
                    0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 0, 145, 4, 0,
                    0, 2, 0, 0, 0, 49, 0, 0, 0, 2, 0, 0, 0, 17, 1, 0, 0, 2, 0, 0, 0, 16,
                    0, 34, 16, 115, 111, 117, 114, 99, 101, 77, 97, 112, 112, 105, 110,
                    103, 85, 82, 76, 16, 46, 47, 114, 97, 98, 105, 110, 46, 119, 97, 115,
                    109, 46, 109, 97, 112,
                ]);
                return instantiate(new Response(new Blob([wasm], { type: 'application/wasm' })), imp);
            }
            module2.exports = loadWebAssembly;
        },
    });
    // node_modules/rabin-wasm/src/index.js
    var require_src = __commonJS({
        'node_modules/rabin-wasm/src/index.js'(exports2, module2) {
            var Rabin = require_rabin();
            var getRabin = require_rabin_wasm();
            var create3 = async (avg, min, max, windowSize, polynomial) => {
                const compiled = await getRabin();
                return new Rabin(compiled, avg, min, max, windowSize, polynomial);
            };
            module2.exports = {
                Rabin,
                create: create3,
            };
        },
    });
    // node_modules/sparse-array/index.js
    var require_sparse_array = __commonJS({
        'node_modules/sparse-array/index.js'(exports2, module2) {
            'use strict';
            var BITS_PER_BYTE = 7;
            module2.exports = class SparseArray {
                constructor() {
                    this._bitArrays = [];
                    this._data = [];
                    this._length = 0;
                    this._changedLength = false;
                    this._changedData = false;
                }
                set(index, value) {
                    let pos = this._internalPositionFor(index, false);
                    if (value === void 0) {
                        if (pos !== -1) {
                            this._unsetInternalPos(pos);
                            this._unsetBit(index);
                            this._changedLength = true;
                            this._changedData = true;
                        }
                    }
                    else {
                        let needsSort = false;
                        if (pos === -1) {
                            pos = this._data.length;
                            this._setBit(index);
                            this._changedData = true;
                        }
                        else {
                            needsSort = true;
                        }
                        this._setInternalPos(pos, index, value, needsSort);
                        this._changedLength = true;
                    }
                }
                unset(index) {
                    this.set(index, void 0);
                }
                get(index) {
                    this._sortData();
                    const pos = this._internalPositionFor(index, true);
                    if (pos === -1) {
                        return void 0;
                    }
                    return this._data[pos][1];
                }
                push(value) {
                    this.set(this.length, value);
                    return this.length;
                }
                get length() {
                    this._sortData();
                    if (this._changedLength) {
                        const last = this._data[this._data.length - 1];
                        this._length = last ? last[0] + 1 : 0;
                        this._changedLength = false;
                    }
                    return this._length;
                }
                forEach(iterator) {
                    let i = 0;
                    while (i < this.length) {
                        iterator(this.get(i), i, this);
                        i++;
                    }
                }
                map(iterator) {
                    let i = 0;
                    let mapped = new Array(this.length);
                    while (i < this.length) {
                        mapped[i] = iterator(this.get(i), i, this);
                        i++;
                    }
                    return mapped;
                }
                reduce(reducer, initialValue) {
                    let i = 0;
                    let acc = initialValue;
                    while (i < this.length) {
                        const value = this.get(i);
                        acc = reducer(acc, value, i);
                        i++;
                    }
                    return acc;
                }
                find(finder) {
                    let i = 0, found, last;
                    while (i < this.length && !found) {
                        last = this.get(i);
                        found = finder(last);
                        i++;
                    }
                    return found ? last : void 0;
                }
                _internalPositionFor(index, noCreate) {
                    const bytePos = this._bytePosFor(index, noCreate);
                    if (bytePos >= this._bitArrays.length) {
                        return -1;
                    }
                    const byte = this._bitArrays[bytePos];
                    const bitPos = index - bytePos * BITS_PER_BYTE;
                    const exists2 = (byte & (1 << bitPos)) > 0;
                    if (!exists2) {
                        return -1;
                    }
                    const previousPopCount = this._bitArrays
                        .slice(0, bytePos)
                        .reduce(popCountReduce, 0);
                    const mask = ~(4294967295 << (bitPos + 1));
                    const bytePopCount = popCount(byte & mask);
                    const arrayPos = previousPopCount + bytePopCount - 1;
                    return arrayPos;
                }
                _bytePosFor(index, noCreate) {
                    const bytePos = Math.floor(index / BITS_PER_BYTE);
                    const targetLength = bytePos + 1;
                    while (!noCreate && this._bitArrays.length < targetLength) {
                        this._bitArrays.push(0);
                    }
                    return bytePos;
                }
                _setBit(index) {
                    const bytePos = this._bytePosFor(index, false);
                    this._bitArrays[bytePos] |= 1 << (index - bytePos * BITS_PER_BYTE);
                }
                _unsetBit(index) {
                    const bytePos = this._bytePosFor(index, false);
                    this._bitArrays[bytePos] &= ~(1 << (index - bytePos * BITS_PER_BYTE));
                }
                _setInternalPos(pos, index, value, needsSort) {
                    const data = this._data;
                    const elem = [index, value];
                    if (needsSort) {
                        this._sortData();
                        data[pos] = elem;
                    }
                    else {
                        if (data.length) {
                            if (data[data.length - 1][0] >= index) {
                                data.push(elem);
                            }
                            else if (data[0][0] <= index) {
                                data.unshift(elem);
                            }
                            else {
                                const randomIndex = Math.round(data.length / 2);
                                this._data = data
                                    .slice(0, randomIndex)
                                    .concat(elem)
                                    .concat(data.slice(randomIndex));
                            }
                        }
                        else {
                            this._data.push(elem);
                        }
                        this._changedData = true;
                        this._changedLength = true;
                    }
                }
                _unsetInternalPos(pos) {
                    this._data.splice(pos, 1);
                }
                _sortData() {
                    if (this._changedData) {
                        this._data.sort(sortInternal);
                    }
                    this._changedData = false;
                }
                bitField() {
                    const bytes = [];
                    let pendingBitsForResultingByte = 8;
                    let pendingBitsForNewByte = 0;
                    let resultingByte = 0;
                    let newByte;
                    const pending = this._bitArrays.slice();
                    while (pending.length || pendingBitsForNewByte) {
                        if (pendingBitsForNewByte === 0) {
                            newByte = pending.shift();
                            pendingBitsForNewByte = 7;
                        }
                        const usingBits = Math.min(pendingBitsForNewByte, pendingBitsForResultingByte);
                        const mask = ~(255 << usingBits);
                        const masked = newByte & mask;
                        resultingByte |= masked << (8 - pendingBitsForResultingByte);
                        newByte = newByte >>> usingBits;
                        pendingBitsForNewByte -= usingBits;
                        pendingBitsForResultingByte -= usingBits;
                        if (!pendingBitsForResultingByte ||
                            (!pendingBitsForNewByte && !pending.length)) {
                            bytes.push(resultingByte);
                            resultingByte = 0;
                            pendingBitsForResultingByte = 8;
                        }
                    }
                    for (var i = bytes.length - 1; i > 0; i--) {
                        const value = bytes[i];
                        if (value === 0) {
                            bytes.pop();
                        }
                        else {
                            break;
                        }
                    }
                    return bytes;
                }
                compactArray() {
                    this._sortData();
                    return this._data.map(valueOnly);
                }
            };
            function popCountReduce(count, byte) {
                return count + popCount(byte);
            }
            function popCount(_v) {
                let v = _v;
                v = v - ((v >> 1) & 1431655765);
                v = (v & 858993459) + ((v >> 2) & 858993459);
                return (((v + (v >> 4)) & 252645135) * 16843009) >> 24;
            }
            function sortInternal(a, b) {
                return a[0] - b[0];
            }
            function valueOnly(elem) {
                return elem[1];
            }
        },
    });
    // index.js
    var es_bundler_exports = {};
    __export(es_bundler_exports, {
        MemoryBlockstore: () => MemoryBlockstore,
        importer: () => importer,
    });
    // node_modules/it-batch/dist/src/index.js
    async function* batch(source, size = 1) {
        let things = [];
        if (size < 1) {
            size = 1;
        }
        for await (const thing of source) {
            things.push(thing);
            while (things.length >= size) {
                yield things.slice(0, size);
                things = things.slice(size);
            }
        }
        while (things.length > 0) {
            yield things.slice(0, size);
            things = things.slice(size);
        }
    }
    // node_modules/it-parallel-batch/dist/src/index.js
    async function* parallelBatch(source, size = 1) {
        for await (const tasks of batch(source, size)) {
            const things = tasks.map(async (p) => {
                return await p().then((value) => ({ ok: true, value }), (err) => ({ ok: false, err }));
            });
            for (let i = 0; i < things.length; i++) {
                const result = await things[i];
                if (result.ok) {
                    yield result.value;
                }
                else {
                    throw result.err;
                }
            }
        }
    }
    // node_modules/merge-options/index.mjs
    var import_index = __toESM(require_merge_options(), 1);
    var merge_options_default = import_index.default;
    // node_modules/multiformats/src/hashes/sha2-browser.js
    var sha2_browser_exports = {};
    __export(sha2_browser_exports, {
        sha256: () => sha256,
        sha512: () => sha512,
    });
    // node_modules/multiformats/src/bytes.js
    var bytes_exports = {};
    __export(bytes_exports, {
        coerce: () => coerce,
        empty: () => empty,
        equals: () => equals,
        fromHex: () => fromHex,
        fromString: () => fromString,
        isBinary: () => isBinary,
        toHex: () => toHex,
        toString: () => toString,
    });
    var empty = new Uint8Array(0);
    var toHex = (d) => d.reduce((hex, byte) => hex + byte.toString(16).padStart(2, '0'), '');
    var fromHex = (hex) => {
        const hexes = hex.match(/../g);
        return hexes ? new Uint8Array(hexes.map((b) => parseInt(b, 16))) : empty;
    };
    var equals = (aa, bb) => {
        if (aa === bb)
            return true;
        if (aa.byteLength !== bb.byteLength) {
            return false;
        }
        for (let ii = 0; ii < aa.byteLength; ii++) {
            if (aa[ii] !== bb[ii]) {
                return false;
            }
        }
        return true;
    };
    var coerce = (o) => {
        if (o instanceof Uint8Array && o.constructor.name === 'Uint8Array')
            return o;
        if (o instanceof ArrayBuffer)
            return new Uint8Array(o);
        if (ArrayBuffer.isView(o)) {
            return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
        }
        throw new Error('Unknown type, must be binary type');
    };
    var isBinary = (o) => o instanceof ArrayBuffer || ArrayBuffer.isView(o);
    var fromString = (str) => new TextEncoder().encode(str);
    var toString = (b) => new TextDecoder().decode(b);
    // node_modules/multiformats/vendor/varint.js
    var encode_1 = encode;
    var MSB = 128;
    var REST = 127;
    var MSBALL = ~REST;
    var INT = Math.pow(2, 31);
    function encode(num, out, offset) {
        out = out || [];
        offset = offset || 0;
        var oldOffset = offset;
        while (num >= INT) {
            out[offset++] = (num & 255) | MSB;
            num /= 128;
        }
        while (num & MSBALL) {
            out[offset++] = (num & 255) | MSB;
            num >>>= 7;
        }
        out[offset] = num | 0;
        encode.bytes = offset - oldOffset + 1;
        return out;
    }
    var decode = read;
    var MSB$1 = 128;
    var REST$1 = 127;
    function read(buf, offset) {
        var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
        do {
            if (counter >= l) {
                read.bytes = 0;
                throw new RangeError('Could not decode varint');
            }
            b = buf[counter++];
            res +=
                shift < 28 ? (b & REST$1) << shift : (b & REST$1) * Math.pow(2, shift);
            shift += 7;
        } while (b >= MSB$1);
        read.bytes = counter - offset;
        return res;
    }
    var N1 = Math.pow(2, 7);
    var N2 = Math.pow(2, 14);
    var N3 = Math.pow(2, 21);
    var N4 = Math.pow(2, 28);
    var N5 = Math.pow(2, 35);
    var N6 = Math.pow(2, 42);
    var N7 = Math.pow(2, 49);
    var N8 = Math.pow(2, 56);
    var N9 = Math.pow(2, 63);
    var length = function (value) {
        return value < N1
            ? 1
            : value < N2
                ? 2
                : value < N3
                    ? 3
                    : value < N4
                        ? 4
                        : value < N5
                            ? 5
                            : value < N6
                                ? 6
                                : value < N7
                                    ? 7
                                    : value < N8
                                        ? 8
                                        : value < N9
                                            ? 9
                                            : 10;
    };
    var varint = {
        encode: encode_1,
        decode,
        encodingLength: length,
    };
    var _brrp_varint = varint;
    var varint_default = _brrp_varint;
    // node_modules/multiformats/src/varint.js
    var decode2 = (data, offset = 0) => {
        const code4 = varint_default.decode(data, offset);
        return [code4, varint_default.decode.bytes];
    };
    var encodeTo = (int, target, offset = 0) => {
        varint_default.encode(int, target, offset);
        return target;
    };
    var encodingLength = (int) => {
        return varint_default.encodingLength(int);
    };
    // node_modules/multiformats/src/hashes/digest.js
    var create = (code4, digest2) => {
        const size = digest2.byteLength;
        const sizeOffset = encodingLength(code4);
        const digestOffset = sizeOffset + encodingLength(size);
        const bytes = new Uint8Array(digestOffset + size);
        encodeTo(code4, bytes, 0);
        encodeTo(size, bytes, sizeOffset);
        bytes.set(digest2, digestOffset);
        return new Digest(code4, size, digest2, bytes);
    };
    var decode3 = (multihash) => {
        const bytes = coerce(multihash);
        const [code4, sizeOffset] = decode2(bytes);
        const [size, digestOffset] = decode2(bytes.subarray(sizeOffset));
        const digest2 = bytes.subarray(sizeOffset + digestOffset);
        if (digest2.byteLength !== size) {
            throw new Error('Incorrect length');
        }
        return new Digest(code4, size, digest2, bytes);
    };
    var equals2 = (a, b) => {
        if (a === b) {
            return true;
        }
        else {
            const data = 
            /** @type {{code?:unknown, size?:unknown, bytes?:unknown}} */
            b;
            return (a.code === data.code &&
                a.size === data.size &&
                data.bytes instanceof Uint8Array &&
                equals(a.bytes, data.bytes));
        }
    };
    var Digest = class {
        /**
         * Creates a multihash digest.
         *
         * @param {Code} code
         * @param {Size} size
         * @param {Uint8Array} digest
         * @param {Uint8Array} bytes
         */
        constructor(code4, size, digest2, bytes) {
            this.code = code4;
            this.size = size;
            this.digest = digest2;
            this.bytes = bytes;
        }
    };
    // node_modules/multiformats/src/hashes/hasher.js
    var from = ({ name: name4, code: code4, encode: encode7 }) => new Hasher(name4, code4, encode7);
    var Hasher = class {
        /**
         *
         * @param {Name} name
         * @param {Code} code
         * @param {(input: Uint8Array) => Await<Uint8Array>} encode
         */
        constructor(name4, code4, encode7) {
            this.name = name4;
            this.code = code4;
            this.encode = encode7;
        }
        /**
         * @param {Uint8Array} input
         * @returns {Await<Digest.Digest<Code, number>>}
         */
        digest(input) {
            if (input instanceof Uint8Array) {
                const result = this.encode(input);
                return result instanceof Uint8Array
                    ? create(this.code, result)
                    : result.then((digest2) => create(this.code, digest2));
            }
            else {
                throw Error('Unknown type, must be binary type');
            }
        }
    };
    // node_modules/multiformats/src/hashes/sha2-browser.js
    var sha = (name4) => 
    /**
     * @param {Uint8Array} data
     */
    async (data) => new Uint8Array(await crypto.subtle.digest(name4, data));
    var sha256 = from({
        name: 'sha2-256',
        code: 18,
        encode: sha('SHA-256'),
    });
    var sha512 = from({
        name: 'sha2-512',
        code: 19,
        encode: sha('SHA-512'),
    });
    // node_modules/multiformats/src/bases/base58.js
    var base58_exports = {};
    __export(base58_exports, {
        base58btc: () => base58btc,
        base58flickr: () => base58flickr,
    });
    // node_modules/multiformats/vendor/base-x.js
    function base(ALPHABET, name4) {
        if (ALPHABET.length >= 255) {
            throw new TypeError('Alphabet too long');
        }
        var BASE_MAP = new Uint8Array(256);
        for (var j = 0; j < BASE_MAP.length; j++) {
            BASE_MAP[j] = 255;
        }
        for (var i = 0; i < ALPHABET.length; i++) {
            var x = ALPHABET.charAt(i);
            var xc = x.charCodeAt(0);
            if (BASE_MAP[xc] !== 255) {
                throw new TypeError(x + ' is ambiguous');
            }
            BASE_MAP[xc] = i;
        }
        var BASE = ALPHABET.length;
        var LEADER = ALPHABET.charAt(0);
        var FACTOR = Math.log(BASE) / Math.log(256);
        var iFACTOR = Math.log(256) / Math.log(BASE);
        function encode7(source) {
            if (source instanceof Uint8Array)
                ;
            else if (ArrayBuffer.isView(source)) {
                source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
            }
            else if (Array.isArray(source)) {
                source = Uint8Array.from(source);
            }
            if (!(source instanceof Uint8Array)) {
                throw new TypeError('Expected Uint8Array');
            }
            if (source.length === 0) {
                return '';
            }
            var zeroes = 0;
            var length2 = 0;
            var pbegin = 0;
            var pend = source.length;
            while (pbegin !== pend && source[pbegin] === 0) {
                pbegin++;
                zeroes++;
            }
            var size = ((pend - pbegin) * iFACTOR + 1) >>> 0;
            var b58 = new Uint8Array(size);
            while (pbegin !== pend) {
                var carry = source[pbegin];
                var i2 = 0;
                for (var it1 = size - 1; (carry !== 0 || i2 < length2) && it1 !== -1; it1--, i2++) {
                    carry += (256 * b58[it1]) >>> 0;
                    b58[it1] = carry % BASE >>> 0;
                    carry = (carry / BASE) >>> 0;
                }
                if (carry !== 0) {
                    throw new Error('Non-zero carry');
                }
                length2 = i2;
                pbegin++;
            }
            var it2 = size - length2;
            while (it2 !== size && b58[it2] === 0) {
                it2++;
            }
            var str = LEADER.repeat(zeroes);
            for (; it2 < size; ++it2) {
                str += ALPHABET.charAt(b58[it2]);
            }
            return str;
        }
        function decodeUnsafe(source) {
            if (typeof source !== 'string') {
                throw new TypeError('Expected String');
            }
            if (source.length === 0) {
                return new Uint8Array();
            }
            var psz = 0;
            if (source[psz] === ' ') {
                return;
            }
            var zeroes = 0;
            var length2 = 0;
            while (source[psz] === LEADER) {
                zeroes++;
                psz++;
            }
            var size = ((source.length - psz) * FACTOR + 1) >>> 0;
            var b256 = new Uint8Array(size);
            while (source[psz]) {
                var carry = BASE_MAP[source.charCodeAt(psz)];
                if (carry === 255) {
                    return;
                }
                var i2 = 0;
                for (var it3 = size - 1; (carry !== 0 || i2 < length2) && it3 !== -1; it3--, i2++) {
                    carry += (BASE * b256[it3]) >>> 0;
                    b256[it3] = carry % 256 >>> 0;
                    carry = (carry / 256) >>> 0;
                }
                if (carry !== 0) {
                    throw new Error('Non-zero carry');
                }
                length2 = i2;
                psz++;
            }
            if (source[psz] === ' ') {
                return;
            }
            var it4 = size - length2;
            while (it4 !== size && b256[it4] === 0) {
                it4++;
            }
            var vch = new Uint8Array(zeroes + (size - it4));
            var j2 = zeroes;
            while (it4 !== size) {
                vch[j2++] = b256[it4++];
            }
            return vch;
        }
        function decode8(string2) {
            var buffer = decodeUnsafe(string2);
            if (buffer) {
                return buffer;
            }
            throw new Error(`Non-${name4} character`);
        }
        return {
            encode: encode7,
            decodeUnsafe,
            decode: decode8,
        };
    }
    var src = base;
    var _brrp__multiformats_scope_baseX = src;
    var base_x_default = _brrp__multiformats_scope_baseX;
    // node_modules/multiformats/src/bases/base.js
    var Encoder = class {
        /**
         * @param {Base} name
         * @param {Prefix} prefix
         * @param {(bytes:Uint8Array) => string} baseEncode
         */
        constructor(name4, prefix, baseEncode) {
            this.name = name4;
            this.prefix = prefix;
            this.baseEncode = baseEncode;
        }
        /**
         * @param {Uint8Array} bytes
         * @returns {API.Multibase<Prefix>}
         */
        encode(bytes) {
            if (bytes instanceof Uint8Array) {
                return `${this.prefix}${this.baseEncode(bytes)}`;
            }
            else {
                throw Error('Unknown type, must be binary type');
            }
        }
    };
    var Decoder = class {
        /**
         * @param {Base} name
         * @param {Prefix} prefix
         * @param {(text:string) => Uint8Array} baseDecode
         */
        constructor(name4, prefix, baseDecode) {
            this.name = name4;
            this.prefix = prefix;
            if (prefix.codePointAt(0) === void 0) {
                throw new Error('Invalid prefix character');
            }
            this.prefixCodePoint = /** @type {number} */ prefix.codePointAt(0);
            this.baseDecode = baseDecode;
        }
        /**
         * @param {string} text
         */
        decode(text) {
            if (typeof text === 'string') {
                if (text.codePointAt(0) !== this.prefixCodePoint) {
                    throw Error(`Unable to decode multibase string ${JSON.stringify(text)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);
                }
                return this.baseDecode(text.slice(this.prefix.length));
            }
            else {
                throw Error('Can only multibase decode strings');
            }
        }
        /**
         * @template {string} OtherPrefix
         * @param {API.UnibaseDecoder<OtherPrefix>|ComposedDecoder<OtherPrefix>} decoder
         * @returns {ComposedDecoder<Prefix|OtherPrefix>}
         */
        or(decoder) {
            return or(this, decoder);
        }
    };
    var ComposedDecoder = class {
        /**
         * @param {Decoders<Prefix>} decoders
         */
        constructor(decoders) {
            this.decoders = decoders;
        }
        /**
         * @template {string} OtherPrefix
         * @param {API.UnibaseDecoder<OtherPrefix>|ComposedDecoder<OtherPrefix>} decoder
         * @returns {ComposedDecoder<Prefix|OtherPrefix>}
         */
        or(decoder) {
            return or(this, decoder);
        }
        /**
         * @param {string} input
         * @returns {Uint8Array}
         */
        decode(input) {
            const prefix = 
            /** @type {Prefix} */
            input[0];
            const decoder = this.decoders[prefix];
            if (decoder) {
                return decoder.decode(input);
            }
            else {
                throw RangeError(`Unable to decode multibase string ${JSON.stringify(input)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`);
            }
        }
    };
    var or = (left, right) => new ComposedDecoder(
    /** @type {Decoders<L|R>} */
    {
        ...(left.decoders || {
            [left.prefix]: left,
        }),
        ...(right.decoders || {
            [right.prefix]: right,
        }),
    });
    var Codec = class {
        /**
         * @param {Base} name
         * @param {Prefix} prefix
         * @param {(bytes:Uint8Array) => string} baseEncode
         * @param {(text:string) => Uint8Array} baseDecode
         */
        constructor(name4, prefix, baseEncode, baseDecode) {
            this.name = name4;
            this.prefix = prefix;
            this.baseEncode = baseEncode;
            this.baseDecode = baseDecode;
            this.encoder = new Encoder(name4, prefix, baseEncode);
            this.decoder = new Decoder(name4, prefix, baseDecode);
        }
        /**
         * @param {Uint8Array} input
         */
        encode(input) {
            return this.encoder.encode(input);
        }
        /**
         * @param {string} input
         */
        decode(input) {
            return this.decoder.decode(input);
        }
    };
    var from2 = ({ name: name4, prefix, encode: encode7, decode: decode8 }) => new Codec(name4, prefix, encode7, decode8);
    var baseX = ({ prefix, name: name4, alphabet: alphabet2 }) => {
        const { encode: encode7, decode: decode8 } = base_x_default(alphabet2, name4);
        return from2({
            prefix,
            name: name4,
            encode: encode7,
            /**
             * @param {string} text
             */
            decode: (text) => coerce(decode8(text)),
        });
    };
    var decode4 = (string2, alphabet2, bitsPerChar, name4) => {
        const codes = {};
        for (let i = 0; i < alphabet2.length; ++i) {
            codes[alphabet2[i]] = i;
        }
        let end = string2.length;
        while (string2[end - 1] === '=') {
            --end;
        }
        const out = new Uint8Array(((end * bitsPerChar) / 8) | 0);
        let bits = 0;
        let buffer = 0;
        let written = 0;
        for (let i = 0; i < end; ++i) {
            const value = codes[string2[i]];
            if (value === void 0) {
                throw new SyntaxError(`Non-${name4} character`);
            }
            buffer = (buffer << bitsPerChar) | value;
            bits += bitsPerChar;
            if (bits >= 8) {
                bits -= 8;
                out[written++] = 255 & (buffer >> bits);
            }
        }
        if (bits >= bitsPerChar || 255 & (buffer << (8 - bits))) {
            throw new SyntaxError('Unexpected end of data');
        }
        return out;
    };
    var encode2 = (data, alphabet2, bitsPerChar) => {
        const pad = alphabet2[alphabet2.length - 1] === '=';
        const mask = (1 << bitsPerChar) - 1;
        let out = '';
        let bits = 0;
        let buffer = 0;
        for (let i = 0; i < data.length; ++i) {
            buffer = (buffer << 8) | data[i];
            bits += 8;
            while (bits > bitsPerChar) {
                bits -= bitsPerChar;
                out += alphabet2[mask & (buffer >> bits)];
            }
        }
        if (bits) {
            out += alphabet2[mask & (buffer << (bitsPerChar - bits))];
        }
        if (pad) {
            while ((out.length * bitsPerChar) & 7) {
                out += '=';
            }
        }
        return out;
    };
    var rfc4648 = ({ name: name4, prefix, bitsPerChar, alphabet: alphabet2 }) => {
        return from2({
            prefix,
            name: name4,
            encode(input) {
                return encode2(input, alphabet2, bitsPerChar);
            },
            decode(input) {
                return decode4(input, alphabet2, bitsPerChar, name4);
            },
        });
    };
    // node_modules/multiformats/src/bases/base58.js
    var base58btc = baseX({
        name: 'base58btc',
        prefix: 'z',
        alphabet: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz',
    });
    var base58flickr = baseX({
        name: 'base58flickr',
        prefix: 'Z',
        alphabet: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ',
    });
    // node_modules/multiformats/src/bases/base32.js
    var base32_exports = {};
    __export(base32_exports, {
        base32: () => base32,
        base32hex: () => base32hex,
        base32hexpad: () => base32hexpad,
        base32hexpadupper: () => base32hexpadupper,
        base32hexupper: () => base32hexupper,
        base32pad: () => base32pad,
        base32padupper: () => base32padupper,
        base32upper: () => base32upper,
        base32z: () => base32z,
    });
    var base32 = rfc4648({
        prefix: 'b',
        name: 'base32',
        alphabet: 'abcdefghijklmnopqrstuvwxyz234567',
        bitsPerChar: 5,
    });
    var base32upper = rfc4648({
        prefix: 'B',
        name: 'base32upper',
        alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567',
        bitsPerChar: 5,
    });
    var base32pad = rfc4648({
        prefix: 'c',
        name: 'base32pad',
        alphabet: 'abcdefghijklmnopqrstuvwxyz234567=',
        bitsPerChar: 5,
    });
    var base32padupper = rfc4648({
        prefix: 'C',
        name: 'base32padupper',
        alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=',
        bitsPerChar: 5,
    });
    var base32hex = rfc4648({
        prefix: 'v',
        name: 'base32hex',
        alphabet: '0123456789abcdefghijklmnopqrstuv',
        bitsPerChar: 5,
    });
    var base32hexupper = rfc4648({
        prefix: 'V',
        name: 'base32hexupper',
        alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV',
        bitsPerChar: 5,
    });
    var base32hexpad = rfc4648({
        prefix: 't',
        name: 'base32hexpad',
        alphabet: '0123456789abcdefghijklmnopqrstuv=',
        bitsPerChar: 5,
    });
    var base32hexpadupper = rfc4648({
        prefix: 'T',
        name: 'base32hexpadupper',
        alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV=',
        bitsPerChar: 5,
    });
    var base32z = rfc4648({
        prefix: 'h',
        name: 'base32z',
        alphabet: 'ybndrfg8ejkmcpqxot1uwisza345h769',
        bitsPerChar: 5,
    });
    // node_modules/multiformats/src/cid.js
    var format = (link, base3) => {
        const { bytes, version } = link;
        switch (version) {
            case 0:
                return toStringV0(bytes, baseCache(link), 
                /** @type {API.MultibaseEncoder<"z">} */
                base3 || base58btc.encoder);
            default:
                return toStringV1(bytes, baseCache(link), 
                /** @type {API.MultibaseEncoder<Prefix>} */
                base3 || base32.encoder);
        }
    };
    var cache = /* @__PURE__ */ new WeakMap();
    var baseCache = (cid) => {
        const baseCache2 = cache.get(cid);
        if (baseCache2 == null) {
            const baseCache3 = /* @__PURE__ */ new Map();
            cache.set(cid, baseCache3);
            return baseCache3;
        }
        return baseCache2;
    };
    var CID = class {
        /**
         * @param {Version} version - Version of the CID
         * @param {Format} code - Code of the codec content is encoded in, see https://github.com/multiformats/multicodec/blob/master/table.csv
         * @param {API.MultihashDigest<Alg>} multihash - (Multi)hash of the of the content.
         * @param {Uint8Array} bytes
         *
         */
        constructor(version, code4, multihash, bytes) {
            this.code = code4;
            this.version = version;
            this.multihash = multihash;
            this.bytes = bytes;
            this['/'] = bytes;
        }
        /**
         * Signalling `cid.asCID === cid` has been replaced with `cid['/'] === cid.bytes`
         * please either use `CID.asCID(cid)` or switch to new signalling mechanism
         *
         * @deprecated
         */
        get asCID() {
            return this;
        }
        // ArrayBufferView
        get byteOffset() {
            return this.bytes.byteOffset;
        }
        // ArrayBufferView
        get byteLength() {
            return this.bytes.byteLength;
        }
        /**
         * @returns {CID<Data, API.DAG_PB, API.SHA_256, 0>}
         */
        toV0() {
            switch (this.version) {
                case 0: {
                    return (
                    /** @type {CID<Data, API.DAG_PB, API.SHA_256, 0>} */
                    this);
                }
                case 1: {
                    const { code: code4, multihash } = this;
                    if (code4 !== DAG_PB_CODE) {
                        throw new Error('Cannot convert a non dag-pb CID to CIDv0');
                    }
                    if (multihash.code !== SHA_256_CODE) {
                        throw new Error('Cannot convert non sha2-256 multihash CID to CIDv0');
                    }
                    return (
                    /** @type {CID<Data, API.DAG_PB, API.SHA_256, 0>} */
                    CID.createV0(
                    /** @type {API.MultihashDigest<API.SHA_256>} */
                    multihash));
                }
                default: {
                    throw Error(`Can not convert CID version ${this.version} to version 0. This is a bug please report`);
                }
            }
        }
        /**
         * @returns {CID<Data, Format, Alg, 1>}
         */
        toV1() {
            switch (this.version) {
                case 0: {
                    const { code: code4, digest: digest2 } = this.multihash;
                    const multihash = create(code4, digest2);
                    return (
                    /** @type {CID<Data, Format, Alg, 1>} */
                    CID.createV1(this.code, multihash));
                }
                case 1: {
                    return (
                    /** @type {CID<Data, Format, Alg, 1>} */
                    this);
                }
                default: {
                    throw Error(`Can not convert CID version ${this.version} to version 1. This is a bug please report`);
                }
            }
        }
        /**
         * @param {unknown} other
         * @returns {other is CID<Data, Format, Alg, Version>}
         */
        equals(other) {
            return CID.equals(this, other);
        }
        /**
         * @template {unknown} Data
         * @template {number} Format
         * @template {number} Alg
         * @template {API.Version} Version
         * @param {API.Link<Data, Format, Alg, Version>} self
         * @param {unknown} other
         * @returns {other is CID}
         */
        static equals(self2, other) {
            const unknown = 
            /** @type {{code?:unknown, version?:unknown, multihash?:unknown}} */
            other;
            return (unknown &&
                self2.code === unknown.code &&
                self2.version === unknown.version &&
                equals2(self2.multihash, unknown.multihash));
        }
        /**
         * @param {API.MultibaseEncoder<string>} [base]
         * @returns {string}
         */
        toString(base3) {
            return format(this, base3);
        }
        toJSON() {
            return { '/': format(this) };
        }
        link() {
            return this;
        }
        get [Symbol.toStringTag]() {
            return 'CID';
        }
        // Legacy
        [Symbol.for('nodejs.util.inspect.custom')]() {
            return `CID(${this.toString()})`;
        }
        /**
         * Takes any input `value` and returns a `CID` instance if it was
         * a `CID` otherwise returns `null`. If `value` is instanceof `CID`
         * it will return value back. If `value` is not instance of this CID
         * class, but is compatible CID it will return new instance of this
         * `CID` class. Otherwise returns null.
         *
         * This allows two different incompatible versions of CID library to
         * co-exist and interop as long as binary interface is compatible.
         *
         * @template {unknown} Data
         * @template {number} Format
         * @template {number} Alg
         * @template {API.Version} Version
         * @template {unknown} U
         * @param {API.Link<Data, Format, Alg, Version>|U} input
         * @returns {CID<Data, Format, Alg, Version>|null}
         */
        static asCID(input) {
            if (input == null) {
                return null;
            }
            const value = 
            /** @type {any} */
            input;
            if (value instanceof CID) {
                return value;
            }
            else if ((value['/'] != null && value['/'] === value.bytes) ||
                value.asCID === value) {
                const { version, code: code4, multihash, bytes } = value;
                return new CID(version, code4, 
                /** @type {API.MultihashDigest<Alg>} */
                multihash, bytes || encodeCID(version, code4, multihash.bytes));
            }
            else if (value[cidSymbol] === true) {
                const { version, multihash, code: code4 } = value;
                const digest2 = 
                /** @type {API.MultihashDigest<Alg>} */
                decode3(multihash);
                return CID.create(version, code4, digest2);
            }
            else {
                return null;
            }
        }
        /**
         *
         * @template {unknown} Data
         * @template {number} Format
         * @template {number} Alg
         * @template {API.Version} Version
         * @param {Version} version - Version of the CID
         * @param {Format} code - Code of the codec content is encoded in, see https://github.com/multiformats/multicodec/blob/master/table.csv
         * @param {API.MultihashDigest<Alg>} digest - (Multi)hash of the of the content.
         * @returns {CID<Data, Format, Alg, Version>}
         */
        static create(version, code4, digest2) {
            if (typeof code4 !== 'number') {
                throw new Error('String codecs are no longer supported');
            }
            if (!(digest2.bytes instanceof Uint8Array)) {
                throw new Error('Invalid digest');
            }
            switch (version) {
                case 0: {
                    if (code4 !== DAG_PB_CODE) {
                        throw new Error(`Version 0 CID must use dag-pb (code: ${DAG_PB_CODE}) block encoding`);
                    }
                    else {
                        return new CID(version, code4, digest2, digest2.bytes);
                    }
                }
                case 1: {
                    const bytes = encodeCID(version, code4, digest2.bytes);
                    return new CID(version, code4, digest2, bytes);
                }
                default: {
                    throw new Error('Invalid version');
                }
            }
        }
        /**
         * Simplified version of `create` for CIDv0.
         *
         * @template {unknown} [T=unknown]
         * @param {API.MultihashDigest<typeof SHA_256_CODE>} digest - Multihash.
         * @returns {CID<T, typeof DAG_PB_CODE, typeof SHA_256_CODE, 0>}
         */
        static createV0(digest2) {
            return CID.create(0, DAG_PB_CODE, digest2);
        }
        /**
         * Simplified version of `create` for CIDv1.
         *
         * @template {unknown} Data
         * @template {number} Code
         * @template {number} Alg
         * @param {Code} code - Content encoding format code.
         * @param {API.MultihashDigest<Alg>} digest - Miltihash of the content.
         * @returns {CID<Data, Code, Alg, 1>}
         */
        static createV1(code4, digest2) {
            return CID.create(1, code4, digest2);
        }
        /**
         * Decoded a CID from its binary representation. The byte array must contain
         * only the CID with no additional bytes.
         *
         * An error will be thrown if the bytes provided do not contain a valid
         * binary representation of a CID.
         *
         * @template {unknown} Data
         * @template {number} Code
         * @template {number} Alg
         * @template {API.Version} Ver
         * @param {API.ByteView<API.Link<Data, Code, Alg, Ver>>} bytes
         * @returns {CID<Data, Code, Alg, Ver>}
         */
        static decode(bytes) {
            const [cid, remainder] = CID.decodeFirst(bytes);
            if (remainder.length) {
                throw new Error('Incorrect length');
            }
            return cid;
        }
        /**
         * Decoded a CID from its binary representation at the beginning of a byte
         * array.
         *
         * Returns an array with the first element containing the CID and the second
         * element containing the remainder of the original byte array. The remainder
         * will be a zero-length byte array if the provided bytes only contained a
         * binary CID representation.
         *
         * @template {unknown} T
         * @template {number} C
         * @template {number} A
         * @template {API.Version} V
         * @param {API.ByteView<API.Link<T, C, A, V>>} bytes
         * @returns {[CID<T, C, A, V>, Uint8Array]}
         */
        static decodeFirst(bytes) {
            const specs = CID.inspectBytes(bytes);
            const prefixSize = specs.size - specs.multihashSize;
            const multihashBytes = coerce(bytes.subarray(prefixSize, prefixSize + specs.multihashSize));
            if (multihashBytes.byteLength !== specs.multihashSize) {
                throw new Error('Incorrect length');
            }
            const digestBytes = multihashBytes.subarray(specs.multihashSize - specs.digestSize);
            const digest2 = new Digest(specs.multihashCode, specs.digestSize, digestBytes, multihashBytes);
            const cid = specs.version === 0
                ? CID.createV0(
                /** @type {API.MultihashDigest<API.SHA_256>} */
                digest2)
                : CID.createV1(specs.codec, digest2);
            return [
                /** @type {CID<T, C, A, V>} */
                cid,
                bytes.subarray(specs.size),
            ];
        }
        /**
         * Inspect the initial bytes of a CID to determine its properties.
         *
         * Involves decoding up to 4 varints. Typically this will require only 4 to 6
         * bytes but for larger multicodec code values and larger multihash digest
         * lengths these varints can be quite large. It is recommended that at least
         * 10 bytes be made available in the `initialBytes` argument for a complete
         * inspection.
         *
         * @template {unknown} T
         * @template {number} C
         * @template {number} A
         * @template {API.Version} V
         * @param {API.ByteView<API.Link<T, C, A, V>>} initialBytes
         * @returns {{ version:V, codec:C, multihashCode:A, digestSize:number, multihashSize:number, size:number }}
         */
        static inspectBytes(initialBytes) {
            let offset = 0;
            const next = () => {
                const [i, length2] = decode2(initialBytes.subarray(offset));
                offset += length2;
                return i;
            };
            let version = 
            /** @type {V} */
            next();
            let codec = 
            /** @type {C} */
            DAG_PB_CODE;
            if (
            /** @type {number} */
            version === 18) {
                version = /** @type {V} */ 0;
                offset = 0;
            }
            else {
                codec = /** @type {C} */ next();
            }
            if (version !== 0 && version !== 1) {
                throw new RangeError(`Invalid CID version ${version}`);
            }
            const prefixSize = offset;
            const multihashCode = 
            /** @type {A} */
            next();
            const digestSize = next();
            const size = offset + digestSize;
            const multihashSize = size - prefixSize;
            return { version, codec, multihashCode, digestSize, multihashSize, size };
        }
        /**
         * Takes cid in a string representation and creates an instance. If `base`
         * decoder is not provided will use a default from the configuration. It will
         * throw an error if encoding of the CID is not compatible with supplied (or
         * a default decoder).
         *
         * @template {string} Prefix
         * @template {unknown} Data
         * @template {number} Code
         * @template {number} Alg
         * @template {API.Version} Ver
         * @param {API.ToString<API.Link<Data, Code, Alg, Ver>, Prefix>} source
         * @param {API.MultibaseDecoder<Prefix>} [base]
         * @returns {CID<Data, Code, Alg, Ver>}
         */
        static parse(source, base3) {
            const [prefix, bytes] = parseCIDtoBytes(source, base3);
            const cid = CID.decode(bytes);
            if (cid.version === 0 && source[0] !== 'Q') {
                throw Error('Version 0 CID string must not include multibase prefix');
            }
            baseCache(cid).set(prefix, source);
            return cid;
        }
    };
    var parseCIDtoBytes = (source, base3) => {
        switch (source[0]) {
            case 'Q': {
                const decoder = base3 || base58btc;
                return [
                    /** @type {Prefix} */
                    base58btc.prefix,
                    decoder.decode(`${base58btc.prefix}${source}`),
                ];
            }
            case base58btc.prefix: {
                const decoder = base3 || base58btc;
                return [
                    /** @type {Prefix} */
                    base58btc.prefix,
                    decoder.decode(source),
                ];
            }
            case base32.prefix: {
                const decoder = base3 || base32;
                return [
                    /** @type {Prefix} */
                    base32.prefix,
                    decoder.decode(source),
                ];
            }
            default: {
                if (base3 == null) {
                    throw Error('To parse non base32 or base58btc encoded CID multibase decoder must be provided');
                }
                return [
                    /** @type {Prefix} */
                    source[0],
                    base3.decode(source),
                ];
            }
        }
    };
    var toStringV0 = (bytes, cache2, base3) => {
        const { prefix } = base3;
        if (prefix !== base58btc.prefix) {
            throw Error(`Cannot string encode V0 in ${base3.name} encoding`);
        }
        const cid = cache2.get(prefix);
        if (cid == null) {
            const cid2 = base3.encode(bytes).slice(1);
            cache2.set(prefix, cid2);
            return cid2;
        }
        else {
            return cid;
        }
    };
    var toStringV1 = (bytes, cache2, base3) => {
        const { prefix } = base3;
        const cid = cache2.get(prefix);
        if (cid == null) {
            const cid2 = base3.encode(bytes);
            cache2.set(prefix, cid2);
            return cid2;
        }
        else {
            return cid;
        }
    };
    var DAG_PB_CODE = 112;
    var SHA_256_CODE = 18;
    var encodeCID = (version, code4, multihash) => {
        const codeOffset = encodingLength(version);
        const hashOffset = codeOffset + encodingLength(code4);
        const bytes = new Uint8Array(hashOffset + multihash.byteLength);
        encodeTo(version, bytes, 0);
        encodeTo(code4, bytes, codeOffset);
        bytes.set(multihash, hashOffset);
        return bytes;
    };
    var cidSymbol = Symbol.for('@ipld/js-cid/CID');
    // node_modules/@multiformats/murmur3/src/index.js
    var import_murmurhash3js_revisited = __toESM(require_murmurhash3js_revisited(), 1);
    function fromNumberTo32BitBuf(number) {
        const bytes = new Array(4);
        for (let i = 0; i < 4; i++) {
            bytes[i] = number & 255;
            number = number >> 8;
        }
        return new Uint8Array(bytes);
    }
    var murmur332 = from({
        name: 'murmur3-32',
        code: 35,
        encode: (input) => fromNumberTo32BitBuf(import_murmurhash3js_revisited.default.x86.hash32(input)),
    });
    var murmur3128 = from({
        name: 'murmur3-128',
        code: 34,
        encode: (input) => bytes_exports.fromHex(import_murmurhash3js_revisited.default.x64.hash128(input)),
    });
    var murmur364 = from({
        name: 'murmur3-x64-64',
        code: 34,
        encode: (input) => bytes_exports
            .fromHex(import_murmurhash3js_revisited.default.x64.hash128(input))
            .subarray(0, 8),
    });
    // node_modules/ipfs-unixfs-importer/src/options.js
    async function hamtHashFn(buf) {
        return (await murmur3128.encode(buf)).slice(0, 8).reverse();
    }
    var defaultOptions = {
        chunker: 'fixed',
        strategy: 'balanced',
        // 'flat', 'trickle'
        rawLeaves: false,
        onlyHash: false,
        reduceSingleLeafToSelf: true,
        hasher: sha256,
        leafType: 'file',
        // 'raw'
        cidVersion: 0,
        progress: () => () => { },
        shardSplitThreshold: 1e3,
        fileImportConcurrency: 50,
        blockWriteConcurrency: 10,
        minChunkSize: 262144,
        maxChunkSize: 262144,
        avgChunkSize: 262144,
        window: 16,
        // FIXME: This number is too big for JavaScript
        // https://github.com/ipfs/go-ipfs-chunker/blob/d0125832512163708c0804a3cda060e21acddae4/rabin.go#L11
        polynomial: 17437180132763652,
        // eslint-disable-line no-loss-of-precision
        maxChildrenPerNode: 174,
        layerRepeat: 4,
        wrapWithDirectory: false,
        recursive: false,
        hidden: false,
        timeout: void 0,
        hamtHashFn,
        hamtHashCode: 34,
        hamtBucketBits: 8,
    };
    var options_default = (options = {}) => {
        const defaults = merge_options_default.bind({ ignoreUndefined: true });
        return defaults(defaultOptions, options);
    };
    // node_modules/ipfs-unixfs/src/index.js
    var import_err_code = __toESM(require_err_code(), 1);
    // node_modules/ipfs-unixfs/src/unixfs.js
    var import_minimal = __toESM(require_minimal2(), 1);
    var $Reader = import_minimal.default.Reader;
    var $Writer = import_minimal.default.Writer;
    var $util = import_minimal.default.util;
    var $root = import_minimal.default.roots['ipfs-unixfs'] ||
        (import_minimal.default.roots['ipfs-unixfs'] = {});
    var Data = ($root.Data = (() => {
        function Data2(p) {
            this.blocksizes = [];
            if (p) {
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
            }
        }
        Data2.prototype.Type = 0;
        Data2.prototype.Data = $util.newBuffer([]);
        Data2.prototype.filesize = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Data2.prototype.blocksizes = $util.emptyArray;
        Data2.prototype.hashType = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Data2.prototype.fanout = $util.Long ? $util.Long.fromBits(0, 0, true) : 0;
        Data2.prototype.mode = 0;
        Data2.prototype.mtime = null;
        Data2.encode = function encode7(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).int32(m.Type);
            if (m.Data != null && Object.hasOwnProperty.call(m, 'Data'))
                w.uint32(18).bytes(m.Data);
            if (m.filesize != null && Object.hasOwnProperty.call(m, 'filesize'))
                w.uint32(24).uint64(m.filesize);
            if (m.blocksizes != null && m.blocksizes.length) {
                for (var i = 0; i < m.blocksizes.length; ++i)
                    w.uint32(32).uint64(m.blocksizes[i]);
            }
            if (m.hashType != null && Object.hasOwnProperty.call(m, 'hashType'))
                w.uint32(40).uint64(m.hashType);
            if (m.fanout != null && Object.hasOwnProperty.call(m, 'fanout'))
                w.uint32(48).uint64(m.fanout);
            if (m.mode != null && Object.hasOwnProperty.call(m, 'mode'))
                w.uint32(56).uint32(m.mode);
            if (m.mtime != null && Object.hasOwnProperty.call(m, 'mtime'))
                $root.UnixTime.encode(m.mtime, w.uint32(66).fork()).ldelim();
            return w;
        };
        Data2.decode = function decode8(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === void 0 ? r.len : r.pos + l, m = new $root.Data();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                    case 1:
                        m.Type = r.int32();
                        break;
                    case 2:
                        m.Data = r.bytes();
                        break;
                    case 3:
                        m.filesize = r.uint64();
                        break;
                    case 4:
                        if (!(m.blocksizes && m.blocksizes.length))
                            m.blocksizes = [];
                        if ((t & 7) === 2) {
                            var c2 = r.uint32() + r.pos;
                            while (r.pos < c2)
                                m.blocksizes.push(r.uint64());
                        }
                        else
                            m.blocksizes.push(r.uint64());
                        break;
                    case 5:
                        m.hashType = r.uint64();
                        break;
                    case 6:
                        m.fanout = r.uint64();
                        break;
                    case 7:
                        m.mode = r.uint32();
                        break;
                    case 8:
                        m.mtime = $root.UnixTime.decode(r, r.uint32());
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            if (!m.hasOwnProperty('Type'))
                throw $util.ProtocolError("missing required 'Type'", { instance: m });
            return m;
        };
        Data2.fromObject = function fromObject(d) {
            if (d instanceof $root.Data)
                return d;
            var m = new $root.Data();
            switch (d.Type) {
                case 'Raw':
                case 0:
                    m.Type = 0;
                    break;
                case 'Directory':
                case 1:
                    m.Type = 1;
                    break;
                case 'File':
                case 2:
                    m.Type = 2;
                    break;
                case 'Metadata':
                case 3:
                    m.Type = 3;
                    break;
                case 'Symlink':
                case 4:
                    m.Type = 4;
                    break;
                case 'HAMTShard':
                case 5:
                    m.Type = 5;
                    break;
            }
            if (d.Data != null) {
                if (typeof d.Data === 'string')
                    $util.base64.decode(d.Data, (m.Data = $util.newBuffer($util.base64.length(d.Data))), 0);
                else if (d.Data.length)
                    m.Data = d.Data;
            }
            if (d.filesize != null) {
                if ($util.Long)
                    (m.filesize = $util.Long.fromValue(d.filesize)).unsigned = true;
                else if (typeof d.filesize === 'string')
                    m.filesize = parseInt(d.filesize, 10);
                else if (typeof d.filesize === 'number')
                    m.filesize = d.filesize;
                else if (typeof d.filesize === 'object')
                    m.filesize = new $util.LongBits(d.filesize.low >>> 0, d.filesize.high >>> 0).toNumber(true);
            }
            if (d.blocksizes) {
                if (!Array.isArray(d.blocksizes))
                    throw TypeError('.Data.blocksizes: array expected');
                m.blocksizes = [];
                for (var i = 0; i < d.blocksizes.length; ++i) {
                    if ($util.Long)
                        (m.blocksizes[i] = $util.Long.fromValue(d.blocksizes[i])).unsigned =
                            true;
                    else if (typeof d.blocksizes[i] === 'string')
                        m.blocksizes[i] = parseInt(d.blocksizes[i], 10);
                    else if (typeof d.blocksizes[i] === 'number')
                        m.blocksizes[i] = d.blocksizes[i];
                    else if (typeof d.blocksizes[i] === 'object')
                        m.blocksizes[i] = new $util.LongBits(d.blocksizes[i].low >>> 0, d.blocksizes[i].high >>> 0).toNumber(true);
                }
            }
            if (d.hashType != null) {
                if ($util.Long)
                    (m.hashType = $util.Long.fromValue(d.hashType)).unsigned = true;
                else if (typeof d.hashType === 'string')
                    m.hashType = parseInt(d.hashType, 10);
                else if (typeof d.hashType === 'number')
                    m.hashType = d.hashType;
                else if (typeof d.hashType === 'object')
                    m.hashType = new $util.LongBits(d.hashType.low >>> 0, d.hashType.high >>> 0).toNumber(true);
            }
            if (d.fanout != null) {
                if ($util.Long)
                    (m.fanout = $util.Long.fromValue(d.fanout)).unsigned = true;
                else if (typeof d.fanout === 'string')
                    m.fanout = parseInt(d.fanout, 10);
                else if (typeof d.fanout === 'number')
                    m.fanout = d.fanout;
                else if (typeof d.fanout === 'object')
                    m.fanout = new $util.LongBits(d.fanout.low >>> 0, d.fanout.high >>> 0).toNumber(true);
            }
            if (d.mode != null) {
                m.mode = d.mode >>> 0;
            }
            if (d.mtime != null) {
                if (typeof d.mtime !== 'object')
                    throw TypeError('.Data.mtime: object expected');
                m.mtime = $root.UnixTime.fromObject(d.mtime);
            }
            return m;
        };
        Data2.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.blocksizes = [];
            }
            if (o.defaults) {
                d.Type = o.enums === String ? 'Raw' : 0;
                if (o.bytes === String)
                    d.Data = '';
                else {
                    d.Data = [];
                    if (o.bytes !== Array)
                        d.Data = $util.newBuffer(d.Data);
                }
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.filesize =
                        o.longs === String
                            ? n.toString()
                            : o.longs === Number
                                ? n.toNumber()
                                : n;
                }
                else
                    d.filesize = o.longs === String ? '0' : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.hashType =
                        o.longs === String
                            ? n.toString()
                            : o.longs === Number
                                ? n.toNumber()
                                : n;
                }
                else
                    d.hashType = o.longs === String ? '0' : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.fanout =
                        o.longs === String
                            ? n.toString()
                            : o.longs === Number
                                ? n.toNumber()
                                : n;
                }
                else
                    d.fanout = o.longs === String ? '0' : 0;
                d.mode = 0;
                d.mtime = null;
            }
            if (m.Type != null && m.hasOwnProperty('Type')) {
                d.Type = o.enums === String ? $root.Data.DataType[m.Type] : m.Type;
            }
            if (m.Data != null && m.hasOwnProperty('Data')) {
                d.Data =
                    o.bytes === String
                        ? $util.base64.encode(m.Data, 0, m.Data.length)
                        : o.bytes === Array
                            ? Array.prototype.slice.call(m.Data)
                            : m.Data;
            }
            if (m.filesize != null && m.hasOwnProperty('filesize')) {
                if (typeof m.filesize === 'number')
                    d.filesize = o.longs === String ? String(m.filesize) : m.filesize;
                else
                    d.filesize =
                        o.longs === String
                            ? $util.Long.prototype.toString.call(m.filesize)
                            : o.longs === Number
                                ? new $util.LongBits(m.filesize.low >>> 0, m.filesize.high >>> 0).toNumber(true)
                                : m.filesize;
            }
            if (m.blocksizes && m.blocksizes.length) {
                d.blocksizes = [];
                for (var j = 0; j < m.blocksizes.length; ++j) {
                    if (typeof m.blocksizes[j] === 'number')
                        d.blocksizes[j] =
                            o.longs === String ? String(m.blocksizes[j]) : m.blocksizes[j];
                    else
                        d.blocksizes[j] =
                            o.longs === String
                                ? $util.Long.prototype.toString.call(m.blocksizes[j])
                                : o.longs === Number
                                    ? new $util.LongBits(m.blocksizes[j].low >>> 0, m.blocksizes[j].high >>> 0).toNumber(true)
                                    : m.blocksizes[j];
                }
            }
            if (m.hashType != null && m.hasOwnProperty('hashType')) {
                if (typeof m.hashType === 'number')
                    d.hashType = o.longs === String ? String(m.hashType) : m.hashType;
                else
                    d.hashType =
                        o.longs === String
                            ? $util.Long.prototype.toString.call(m.hashType)
                            : o.longs === Number
                                ? new $util.LongBits(m.hashType.low >>> 0, m.hashType.high >>> 0).toNumber(true)
                                : m.hashType;
            }
            if (m.fanout != null && m.hasOwnProperty('fanout')) {
                if (typeof m.fanout === 'number')
                    d.fanout = o.longs === String ? String(m.fanout) : m.fanout;
                else
                    d.fanout =
                        o.longs === String
                            ? $util.Long.prototype.toString.call(m.fanout)
                            : o.longs === Number
                                ? new $util.LongBits(m.fanout.low >>> 0, m.fanout.high >>> 0).toNumber(true)
                                : m.fanout;
            }
            if (m.mode != null && m.hasOwnProperty('mode')) {
                d.mode = m.mode;
            }
            if (m.mtime != null && m.hasOwnProperty('mtime')) {
                d.mtime = $root.UnixTime.toObject(m.mtime, o);
            }
            return d;
        };
        Data2.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, import_minimal.default.util.toJSONOptions);
        };
        Data2.DataType = (function () {
            const valuesById = {}, values = Object.create(valuesById);
            values[(valuesById[0] = 'Raw')] = 0;
            values[(valuesById[1] = 'Directory')] = 1;
            values[(valuesById[2] = 'File')] = 2;
            values[(valuesById[3] = 'Metadata')] = 3;
            values[(valuesById[4] = 'Symlink')] = 4;
            values[(valuesById[5] = 'HAMTShard')] = 5;
            return values;
        })();
        return Data2;
    })());
    var UnixTime = ($root.UnixTime = (() => {
        function UnixTime2(p) {
            if (p) {
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
            }
        }
        UnixTime2.prototype.Seconds = $util.Long
            ? $util.Long.fromBits(0, 0, false)
            : 0;
        UnixTime2.prototype.FractionalNanoseconds = 0;
        UnixTime2.encode = function encode7(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).int64(m.Seconds);
            if (m.FractionalNanoseconds != null &&
                Object.hasOwnProperty.call(m, 'FractionalNanoseconds'))
                w.uint32(21).fixed32(m.FractionalNanoseconds);
            return w;
        };
        UnixTime2.decode = function decode8(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === void 0 ? r.len : r.pos + l, m = new $root.UnixTime();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                    case 1:
                        m.Seconds = r.int64();
                        break;
                    case 2:
                        m.FractionalNanoseconds = r.fixed32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            if (!m.hasOwnProperty('Seconds'))
                throw $util.ProtocolError("missing required 'Seconds'", {
                    instance: m,
                });
            return m;
        };
        UnixTime2.fromObject = function fromObject(d) {
            if (d instanceof $root.UnixTime)
                return d;
            var m = new $root.UnixTime();
            if (d.Seconds != null) {
                if ($util.Long)
                    (m.Seconds = $util.Long.fromValue(d.Seconds)).unsigned = false;
                else if (typeof d.Seconds === 'string')
                    m.Seconds = parseInt(d.Seconds, 10);
                else if (typeof d.Seconds === 'number')
                    m.Seconds = d.Seconds;
                else if (typeof d.Seconds === 'object')
                    m.Seconds = new $util.LongBits(d.Seconds.low >>> 0, d.Seconds.high >>> 0).toNumber();
            }
            if (d.FractionalNanoseconds != null) {
                m.FractionalNanoseconds = d.FractionalNanoseconds >>> 0;
            }
            return m;
        };
        UnixTime2.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, false);
                    d.Seconds =
                        o.longs === String
                            ? n.toString()
                            : o.longs === Number
                                ? n.toNumber()
                                : n;
                }
                else
                    d.Seconds = o.longs === String ? '0' : 0;
                d.FractionalNanoseconds = 0;
            }
            if (m.Seconds != null && m.hasOwnProperty('Seconds')) {
                if (typeof m.Seconds === 'number')
                    d.Seconds = o.longs === String ? String(m.Seconds) : m.Seconds;
                else
                    d.Seconds =
                        o.longs === String
                            ? $util.Long.prototype.toString.call(m.Seconds)
                            : o.longs === Number
                                ? new $util.LongBits(m.Seconds.low >>> 0, m.Seconds.high >>> 0).toNumber()
                                : m.Seconds;
            }
            if (m.FractionalNanoseconds != null &&
                m.hasOwnProperty('FractionalNanoseconds')) {
                d.FractionalNanoseconds = m.FractionalNanoseconds;
            }
            return d;
        };
        UnixTime2.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, import_minimal.default.util.toJSONOptions);
        };
        return UnixTime2;
    })());
    var Metadata = ($root.Metadata = (() => {
        function Metadata2(p) {
            if (p) {
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
            }
        }
        Metadata2.prototype.MimeType = '';
        Metadata2.encode = function encode7(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.MimeType != null && Object.hasOwnProperty.call(m, 'MimeType'))
                w.uint32(10).string(m.MimeType);
            return w;
        };
        Metadata2.decode = function decode8(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === void 0 ? r.len : r.pos + l, m = new $root.Metadata();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                    case 1:
                        m.MimeType = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                }
            }
            return m;
        };
        Metadata2.fromObject = function fromObject(d) {
            if (d instanceof $root.Metadata)
                return d;
            var m = new $root.Metadata();
            if (d.MimeType != null) {
                m.MimeType = String(d.MimeType);
            }
            return m;
        };
        Metadata2.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.MimeType = '';
            }
            if (m.MimeType != null && m.hasOwnProperty('MimeType')) {
                d.MimeType = m.MimeType;
            }
            return d;
        };
        Metadata2.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, import_minimal.default.util.toJSONOptions);
        };
        return Metadata2;
    })());
    // node_modules/ipfs-unixfs/src/index.js
    var PBData = Data;
    var types = [
        'raw',
        'directory',
        'file',
        'metadata',
        'symlink',
        'hamt-sharded-directory',
    ];
    var dirTypes = ['directory', 'hamt-sharded-directory'];
    var DEFAULT_FILE_MODE = parseInt('0644', 8);
    var DEFAULT_DIRECTORY_MODE = parseInt('0755', 8);
    function parseMode(mode) {
        if (mode == null) {
            return void 0;
        }
        if (typeof mode === 'number') {
            return mode & 4095;
        }
        mode = mode.toString();
        if (mode.substring(0, 1) === '0') {
            return parseInt(mode, 8) & 4095;
        }
        return parseInt(mode, 10) & 4095;
    }
    function parseMtime(input) {
        if (input == null) {
            return void 0;
        }
        let mtime;
        if (input.secs != null) {
            mtime = {
                secs: input.secs,
                nsecs: input.nsecs,
            };
        }
        if (input.Seconds != null) {
            mtime = {
                secs: input.Seconds,
                nsecs: input.FractionalNanoseconds,
            };
        }
        if (Array.isArray(input)) {
            mtime = {
                secs: input[0],
                nsecs: input[1],
            };
        }
        if (input instanceof Date) {
            const ms = input.getTime();
            const secs = Math.floor(ms / 1e3);
            mtime = {
                secs,
                nsecs: (ms - secs * 1e3) * 1e3,
            };
        }
        if (!Object.prototype.hasOwnProperty.call(mtime, 'secs')) {
            return void 0;
        }
        if (mtime != null &&
            mtime.nsecs != null &&
            (mtime.nsecs < 0 || mtime.nsecs > 999999999)) {
            throw (0, import_err_code.default)(new Error('mtime-nsecs must be within the range [0,999999999]'), 'ERR_INVALID_MTIME_NSECS');
        }
        return mtime;
    }
    var UnixFS = class {
        /**
         * Decode from protobuf https://github.com/ipfs/specs/blob/master/UNIXFS.md
         *
         * @param {Uint8Array} marshaled
         */
        static unmarshal(marshaled) {
            const message = PBData.decode(marshaled);
            const decoded = PBData.toObject(message, {
                defaults: false,
                arrays: true,
                longs: Number,
                objects: false,
            });
            const data = new UnixFS({
                type: types[decoded.Type],
                data: decoded.Data,
                blockSizes: decoded.blocksizes,
                mode: decoded.mode,
                mtime: decoded.mtime
                    ? {
                        secs: decoded.mtime.Seconds,
                        nsecs: decoded.mtime.FractionalNanoseconds,
                    }
                    : void 0,
            });
            data._originalMode = decoded.mode || 0;
            return data;
        }
        /**
         * @param {object} [options]
         * @param {string} [options.type='file']
         * @param {Uint8Array} [options.data]
         * @param {number[]} [options.blockSizes]
         * @param {number} [options.hashType]
         * @param {number} [options.fanout]
         * @param {MtimeLike | null} [options.mtime]
         * @param {number | string} [options.mode]
         */
        constructor(options = {
            type: 'file',
        }) {
            const { type, data, blockSizes, hashType, fanout, mtime, mode } = options;
            if (type && !types.includes(type)) {
                throw (0, import_err_code.default)(new Error('Type: ' + type + ' is not valid'), 'ERR_INVALID_TYPE');
            }
            this.type = type || 'file';
            this.data = data;
            this.hashType = hashType;
            this.fanout = fanout;
            this.blockSizes = blockSizes || [];
            this._originalMode = 0;
            this.mode = parseMode(mode);
            if (mtime) {
                this.mtime = parseMtime(mtime);
                if (this.mtime && !this.mtime.nsecs) {
                    this.mtime.nsecs = 0;
                }
            }
        }
        /**
         * @param {number | undefined} mode
         */
        set mode(mode) {
            this._mode = this.isDirectory()
                ? DEFAULT_DIRECTORY_MODE
                : DEFAULT_FILE_MODE;
            const parsedMode = parseMode(mode);
            if (parsedMode !== void 0) {
                this._mode = parsedMode;
            }
        }
        /**
         * @returns {number | undefined}
         */
        get mode() {
            return this._mode;
        }
        isDirectory() {
            return Boolean(this.type && dirTypes.includes(this.type));
        }
        /**
         * @param {number} size
         */
        addBlockSize(size) {
            this.blockSizes.push(size);
        }
        /**
         * @param {number} index
         */
        removeBlockSize(index) {
            this.blockSizes.splice(index, 1);
        }
        /**
         * Returns `0` for directories or `data.length + sum(blockSizes)` for everything else
         */
        fileSize() {
            if (this.isDirectory()) {
                return 0;
            }
            let sum = 0;
            this.blockSizes.forEach((size) => {
                sum += size;
            });
            if (this.data) {
                sum += this.data.length;
            }
            return sum;
        }
        /**
         * encode to protobuf Uint8Array
         */
        marshal() {
            let type;
            switch (this.type) {
                case 'raw':
                    type = PBData.DataType.Raw;
                    break;
                case 'directory':
                    type = PBData.DataType.Directory;
                    break;
                case 'file':
                    type = PBData.DataType.File;
                    break;
                case 'metadata':
                    type = PBData.DataType.Metadata;
                    break;
                case 'symlink':
                    type = PBData.DataType.Symlink;
                    break;
                case 'hamt-sharded-directory':
                    type = PBData.DataType.HAMTShard;
                    break;
                default:
                    throw (0, import_err_code.default)(new Error('Type: ' + type + ' is not valid'), 'ERR_INVALID_TYPE');
            }
            let data = this.data;
            if (!this.data || !this.data.length) {
                data = void 0;
            }
            let mode;
            if (this.mode != null) {
                mode = (this._originalMode & 4294963200) | (parseMode(this.mode) || 0);
                if (mode === DEFAULT_FILE_MODE && !this.isDirectory()) {
                    mode = void 0;
                }
                if (mode === DEFAULT_DIRECTORY_MODE && this.isDirectory()) {
                    mode = void 0;
                }
            }
            let mtime;
            if (this.mtime != null) {
                const parsed = parseMtime(this.mtime);
                if (parsed) {
                    mtime = {
                        Seconds: parsed.secs,
                        FractionalNanoseconds: parsed.nsecs,
                    };
                    if (mtime.FractionalNanoseconds === 0) {
                        delete mtime.FractionalNanoseconds;
                    }
                }
            }
            const pbData = {
                Type: type,
                Data: data,
                filesize: this.isDirectory() ? void 0 : this.fileSize(),
                blocksizes: this.blockSizes,
                hashType: this.hashType,
                fanout: this.fanout,
                mode,
                mtime,
            };
            return PBData.encode(pbData).finish();
        }
    };
    // node_modules/@ipld/dag-pb/src/index.js
    var src_exports = {};
    __export(src_exports, {
        code: () => code,
        createLink: () => createLink,
        createNode: () => createNode,
        decode: () => decode5,
        encode: () => encode3,
        name: () => name,
        prepare: () => prepare,
        validate: () => validate,
    });
    // node_modules/@ipld/dag-pb/src/pb-decode.js
    var textDecoder = new TextDecoder();
    function decodeVarint(bytes, offset) {
        let v = 0;
        for (let shift = 0;; shift += 7) {
            if (shift >= 64) {
                throw new Error('protobuf: varint overflow');
            }
            if (offset >= bytes.length) {
                throw new Error('protobuf: unexpected end of data');
            }
            const b = bytes[offset++];
            v += shift < 28 ? (b & 127) << shift : (b & 127) * 2 ** shift;
            if (b < 128) {
                break;
            }
        }
        return [v, offset];
    }
    function decodeBytes(bytes, offset) {
        let byteLen;
        [byteLen, offset] = decodeVarint(bytes, offset);
        const postOffset = offset + byteLen;
        if (byteLen < 0 || postOffset < 0) {
            throw new Error('protobuf: invalid length');
        }
        if (postOffset > bytes.length) {
            throw new Error('protobuf: unexpected end of data');
        }
        return [bytes.subarray(offset, postOffset), postOffset];
    }
    function decodeKey(bytes, index) {
        let wire;
        [wire, index] = decodeVarint(bytes, index);
        return [wire & 7, wire >> 3, index];
    }
    function decodeLink(bytes) {
        const link = {};
        const l = bytes.length;
        let index = 0;
        while (index < l) {
            let wireType, fieldNum;
            [wireType, fieldNum, index] = decodeKey(bytes, index);
            if (fieldNum === 1) {
                if (link.Hash) {
                    throw new Error('protobuf: (PBLink) duplicate Hash section');
                }
                if (wireType !== 2) {
                    throw new Error(`protobuf: (PBLink) wrong wireType (${wireType}) for Hash`);
                }
                if (link.Name !== void 0) {
                    throw new Error('protobuf: (PBLink) invalid order, found Name before Hash');
                }
                if (link.Tsize !== void 0) {
                    throw new Error('protobuf: (PBLink) invalid order, found Tsize before Hash');
                }
                [link.Hash, index] = decodeBytes(bytes, index);
            }
            else if (fieldNum === 2) {
                if (link.Name !== void 0) {
                    throw new Error('protobuf: (PBLink) duplicate Name section');
                }
                if (wireType !== 2) {
                    throw new Error(`protobuf: (PBLink) wrong wireType (${wireType}) for Name`);
                }
                if (link.Tsize !== void 0) {
                    throw new Error('protobuf: (PBLink) invalid order, found Tsize before Name');
                }
                let byts;
                [byts, index] = decodeBytes(bytes, index);
                link.Name = textDecoder.decode(byts);
            }
            else if (fieldNum === 3) {
                if (link.Tsize !== void 0) {
                    throw new Error('protobuf: (PBLink) duplicate Tsize section');
                }
                if (wireType !== 0) {
                    throw new Error(`protobuf: (PBLink) wrong wireType (${wireType}) for Tsize`);
                }
                [link.Tsize, index] = decodeVarint(bytes, index);
            }
            else {
                throw new Error(`protobuf: (PBLink) invalid fieldNumber, expected 1, 2 or 3, got ${fieldNum}`);
            }
        }
        if (index > l) {
            throw new Error('protobuf: (PBLink) unexpected end of data');
        }
        return link;
    }
    function decodeNode(bytes) {
        const l = bytes.length;
        let index = 0;
        let links;
        let linksBeforeData = false;
        let data;
        while (index < l) {
            let wireType, fieldNum;
            [wireType, fieldNum, index] = decodeKey(bytes, index);
            if (wireType !== 2) {
                throw new Error(`protobuf: (PBNode) invalid wireType, expected 2, got ${wireType}`);
            }
            if (fieldNum === 1) {
                if (data) {
                    throw new Error('protobuf: (PBNode) duplicate Data section');
                }
                [data, index] = decodeBytes(bytes, index);
                if (links) {
                    linksBeforeData = true;
                }
            }
            else if (fieldNum === 2) {
                if (linksBeforeData) {
                    throw new Error('protobuf: (PBNode) duplicate Links section');
                }
                else if (!links) {
                    links = [];
                }
                let byts;
                [byts, index] = decodeBytes(bytes, index);
                links.push(decodeLink(byts));
            }
            else {
                throw new Error(`protobuf: (PBNode) invalid fieldNumber, expected 1 or 2, got ${fieldNum}`);
            }
        }
        if (index > l) {
            throw new Error('protobuf: (PBNode) unexpected end of data');
        }
        const node = {};
        if (data) {
            node.Data = data;
        }
        node.Links = links || [];
        return node;
    }
    // node_modules/@ipld/dag-pb/src/pb-encode.js
    var textEncoder = new TextEncoder();
    var maxInt32 = 2 ** 32;
    var maxUInt32 = 2 ** 31;
    function encodeLink(link, bytes) {
        let i = bytes.length;
        if (typeof link.Tsize === 'number') {
            if (link.Tsize < 0) {
                throw new Error('Tsize cannot be negative');
            }
            if (!Number.isSafeInteger(link.Tsize)) {
                throw new Error('Tsize too large for encoding');
            }
            i = encodeVarint(bytes, i, link.Tsize) - 1;
            bytes[i] = 24;
        }
        if (typeof link.Name === 'string') {
            const nameBytes = textEncoder.encode(link.Name);
            i -= nameBytes.length;
            bytes.set(nameBytes, i);
            i = encodeVarint(bytes, i, nameBytes.length) - 1;
            bytes[i] = 18;
        }
        if (link.Hash) {
            i -= link.Hash.length;
            bytes.set(link.Hash, i);
            i = encodeVarint(bytes, i, link.Hash.length) - 1;
            bytes[i] = 10;
        }
        return bytes.length - i;
    }
    function encodeNode(node) {
        const size = sizeNode(node);
        const bytes = new Uint8Array(size);
        let i = size;
        if (node.Data) {
            i -= node.Data.length;
            bytes.set(node.Data, i);
            i = encodeVarint(bytes, i, node.Data.length) - 1;
            bytes[i] = 10;
        }
        if (node.Links) {
            for (let index = node.Links.length - 1; index >= 0; index--) {
                const size2 = encodeLink(node.Links[index], bytes.subarray(0, i));
                i -= size2;
                i = encodeVarint(bytes, i, size2) - 1;
                bytes[i] = 18;
            }
        }
        return bytes;
    }
    function sizeLink(link) {
        let n = 0;
        if (link.Hash) {
            const l = link.Hash.length;
            n += 1 + l + sov(l);
        }
        if (typeof link.Name === 'string') {
            const l = textEncoder.encode(link.Name).length;
            n += 1 + l + sov(l);
        }
        if (typeof link.Tsize === 'number') {
            n += 1 + sov(link.Tsize);
        }
        return n;
    }
    function sizeNode(node) {
        let n = 0;
        if (node.Data) {
            const l = node.Data.length;
            n += 1 + l + sov(l);
        }
        if (node.Links) {
            for (const link of node.Links) {
                const l = sizeLink(link);
                n += 1 + l + sov(l);
            }
        }
        return n;
    }
    function encodeVarint(bytes, offset, v) {
        offset -= sov(v);
        const base3 = offset;
        while (v >= maxUInt32) {
            bytes[offset++] = (v & 127) | 128;
            v /= 128;
        }
        while (v >= 128) {
            bytes[offset++] = (v & 127) | 128;
            v >>>= 7;
        }
        bytes[offset] = v;
        return base3;
    }
    function sov(x) {
        if (x % 2 === 0) {
            x++;
        }
        return Math.floor((len64(x) + 6) / 7);
    }
    function len64(x) {
        let n = 0;
        if (x >= maxInt32) {
            x = Math.floor(x / maxInt32);
            n = 32;
        }
        if (x >= 1 << 16) {
            x >>>= 16;
            n += 16;
        }
        if (x >= 1 << 8) {
            x >>>= 8;
            n += 8;
        }
        return n + len8tab[x];
    }
    var len8tab = [
        0, 1, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5,
        5, 5, 5, 5, 5, 5, 5, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6,
        6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
        7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
        7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,
        7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
        8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
        8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
        8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
        8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,
        8, 8, 8, 8, 8, 8,
    ];
    // node_modules/@ipld/dag-pb/src/util.js
    var pbNodeProperties = ['Data', 'Links'];
    var pbLinkProperties = ['Hash', 'Name', 'Tsize'];
    var textEncoder2 = new TextEncoder();
    function linkComparator(a, b) {
        if (a === b) {
            return 0;
        }
        const abuf = a.Name ? textEncoder2.encode(a.Name) : [];
        const bbuf = b.Name ? textEncoder2.encode(b.Name) : [];
        let x = abuf.length;
        let y = bbuf.length;
        for (let i = 0, len = Math.min(x, y); i < len; ++i) {
            if (abuf[i] !== bbuf[i]) {
                x = abuf[i];
                y = bbuf[i];
                break;
            }
        }
        return x < y ? -1 : y < x ? 1 : 0;
    }
    function hasOnlyProperties(node, properties) {
        return !Object.keys(node).some((p) => !properties.includes(p));
    }
    function asLink(link) {
        if (typeof link.asCID === 'object') {
            const Hash = CID.asCID(link);
            if (!Hash) {
                throw new TypeError('Invalid DAG-PB form');
            }
            return { Hash };
        }
        if (typeof link !== 'object' || Array.isArray(link)) {
            throw new TypeError('Invalid DAG-PB form');
        }
        const pbl = {};
        if (link.Hash) {
            let cid = CID.asCID(link.Hash);
            try {
                if (!cid) {
                    if (typeof link.Hash === 'string') {
                        cid = CID.parse(link.Hash);
                    }
                    else if (link.Hash instanceof Uint8Array) {
                        cid = CID.decode(link.Hash);
                    }
                }
            }
            catch (e) {
                throw new TypeError(`Invalid DAG-PB form: ${e.message}`);
            }
            if (cid) {
                pbl.Hash = cid;
            }
        }
        if (!pbl.Hash) {
            throw new TypeError('Invalid DAG-PB form');
        }
        if (typeof link.Name === 'string') {
            pbl.Name = link.Name;
        }
        if (typeof link.Tsize === 'number') {
            pbl.Tsize = link.Tsize;
        }
        return pbl;
    }
    function prepare(node) {
        if (node instanceof Uint8Array || typeof node === 'string') {
            node = { Data: node };
        }
        if (typeof node !== 'object' || Array.isArray(node)) {
            throw new TypeError('Invalid DAG-PB form');
        }
        const pbn = {};
        if (node.Data !== void 0) {
            if (typeof node.Data === 'string') {
                pbn.Data = textEncoder2.encode(node.Data);
            }
            else if (node.Data instanceof Uint8Array) {
                pbn.Data = node.Data;
            }
            else {
                throw new TypeError('Invalid DAG-PB form');
            }
        }
        if (node.Links !== void 0) {
            if (Array.isArray(node.Links)) {
                pbn.Links = node.Links.map(asLink);
                pbn.Links.sort(linkComparator);
            }
            else {
                throw new TypeError('Invalid DAG-PB form');
            }
        }
        else {
            pbn.Links = [];
        }
        return pbn;
    }
    function validate(node) {
        if (!node ||
            typeof node !== 'object' ||
            Array.isArray(node) ||
            node instanceof Uint8Array ||
            (node['/'] && node['/'] === node.bytes)) {
            throw new TypeError('Invalid DAG-PB form');
        }
        if (!hasOnlyProperties(node, pbNodeProperties)) {
            throw new TypeError('Invalid DAG-PB form (extraneous properties)');
        }
        if (node.Data !== void 0 && !(node.Data instanceof Uint8Array)) {
            throw new TypeError('Invalid DAG-PB form (Data must be bytes)');
        }
        if (!Array.isArray(node.Links)) {
            throw new TypeError('Invalid DAG-PB form (Links must be a list)');
        }
        for (let i = 0; i < node.Links.length; i++) {
            const link = node.Links[i];
            if (!link ||
                typeof link !== 'object' ||
                Array.isArray(link) ||
                link instanceof Uint8Array ||
                (link['/'] && link['/'] === link.bytes)) {
                throw new TypeError('Invalid DAG-PB form (bad link)');
            }
            if (!hasOnlyProperties(link, pbLinkProperties)) {
                throw new TypeError('Invalid DAG-PB form (extraneous properties on link)');
            }
            if (link.Hash === void 0) {
                throw new TypeError('Invalid DAG-PB form (link must have a Hash)');
            }
            if (link.Hash == null ||
                !link.Hash['/'] ||
                link.Hash['/'] !== link.Hash.bytes) {
                throw new TypeError('Invalid DAG-PB form (link Hash must be a CID)');
            }
            if (link.Name !== void 0 && typeof link.Name !== 'string') {
                throw new TypeError('Invalid DAG-PB form (link Name must be a string)');
            }
            if (link.Tsize !== void 0) {
                if (typeof link.Tsize !== 'number' || link.Tsize % 1 !== 0) {
                    throw new TypeError('Invalid DAG-PB form (link Tsize must be an integer)');
                }
                if (link.Tsize < 0) {
                    throw new TypeError('Invalid DAG-PB form (link Tsize cannot be negative)');
                }
            }
            if (i > 0 && linkComparator(link, node.Links[i - 1]) === -1) {
                throw new TypeError('Invalid DAG-PB form (links must be sorted by Name bytes)');
            }
        }
    }
    function createNode(data, links = []) {
        return prepare({ Data: data, Links: links });
    }
    function createLink(name4, size, cid) {
        return asLink({ Hash: cid, Name: name4, Tsize: size });
    }
    // node_modules/@ipld/dag-pb/src/index.js
    var name = 'dag-pb';
    var code = 112;
    function encode3(node) {
        validate(node);
        const pbn = {};
        if (node.Links) {
            pbn.Links = node.Links.map((l) => {
                const link = {};
                if (l.Hash) {
                    link.Hash = l.Hash.bytes;
                }
                if (l.Name !== void 0) {
                    link.Name = l.Name;
                }
                if (l.Tsize !== void 0) {
                    link.Tsize = l.Tsize;
                }
                return link;
            });
        }
        if (node.Data) {
            pbn.Data = node.Data;
        }
        return encodeNode(pbn);
    }
    function decode5(bytes) {
        const pbn = decodeNode(bytes);
        const node = {};
        if (pbn.Data) {
            node.Data = pbn.Data;
        }
        if (pbn.Links) {
            node.Links = pbn.Links.map((l) => {
                const link = {};
                try {
                    link.Hash = CID.decode(l.Hash);
                }
                catch (e) { }
                if (!link.Hash) {
                    throw new Error('Invalid Hash field found in link, expected CID');
                }
                if (l.Name !== void 0) {
                    link.Name = l.Name;
                }
                if (l.Tsize !== void 0) {
                    link.Tsize = l.Tsize;
                }
                return link;
            });
        }
        return node;
    }
    // node_modules/ipfs-unixfs-importer/src/utils/persist.js
    var persist = async (buffer, blockstore, options) => {
        if (!options.codec) {
            options.codec = src_exports;
        }
        if (!options.hasher) {
            options.hasher = sha256;
        }
        if (options.cidVersion === void 0) {
            options.cidVersion = 1;
        }
        if (options.codec === src_exports && options.hasher !== sha256) {
            options.cidVersion = 1;
        }
        const multihash = await options.hasher.digest(buffer);
        const cid = CID.create(options.cidVersion, options.codec.code, multihash);
        if (!options.onlyHash) {
            await blockstore.put(cid, buffer, {
                signal: options.signal,
            });
        }
        return cid;
    };
    var persist_default = persist;
    // node_modules/ipfs-unixfs-importer/src/dag-builder/dir.js
    var dirBuilder = async (item, blockstore, options) => {
        const unixfs = new UnixFS({
            type: 'directory',
            mtime: item.mtime,
            mode: item.mode,
        });
        const buffer = encode3(prepare({ Data: unixfs.marshal() }));
        const cid = await persist_default(buffer, blockstore, options);
        const path = item.path;
        return {
            cid,
            path,
            unixfs,
            size: buffer.length,
        };
    };
    var dir_default = dirBuilder;
    // node_modules/ipfs-unixfs-importer/src/dag-builder/file/index.js
    var import_err_code2 = __toESM(require_err_code(), 1);
    // node_modules/multiformats/src/codecs/raw.js
    var raw_exports = {};
    __export(raw_exports, {
        code: () => code2,
        decode: () => decode6,
        encode: () => encode4,
        name: () => name2,
    });
    var name2 = 'raw';
    var code2 = 85;
    var encode4 = (node) => coerce(node);
    var decode6 = (data) => coerce(data);
    // node_modules/it-all/dist/src/index.js
    async function all(source) {
        const arr = [];
        for await (const entry of source) {
            arr.push(entry);
        }
        return arr;
    }
    // node_modules/ipfs-unixfs-importer/src/dag-builder/file/flat.js
    async function flat(source, reduce2) {
        return reduce2(await all(source));
    }
    var flat_default = flat;
    // node_modules/ipfs-unixfs-importer/src/dag-builder/file/balanced.js
    function balanced(source, reduce2, options) {
        return reduceToParents(source, reduce2, options);
    }
    async function reduceToParents(source, reduce2, options) {
        const roots = [];
        for await (const chunked of batch(source, options.maxChildrenPerNode)) {
            roots.push(await reduce2(chunked));
        }
        if (roots.length > 1) {
            return reduceToParents(roots, reduce2, options);
        }
        return roots[0];
    }
    var balanced_default = balanced;
    // node_modules/ipfs-unixfs-importer/src/dag-builder/file/trickle.js
    async function trickleStream(source, reduce2, options) {
        const root = new Root(options.layerRepeat);
        let iteration = 0;
        let maxDepth = 1;
        let subTree = root;
        for await (const layer of batch(source, options.maxChildrenPerNode)) {
            if (subTree.isFull()) {
                if (subTree !== root) {
                    root.addChild(await subTree.reduce(reduce2));
                }
                if (iteration && iteration % options.layerRepeat === 0) {
                    maxDepth++;
                }
                subTree = new SubTree(maxDepth, options.layerRepeat, iteration);
                iteration++;
            }
            subTree.append(layer);
        }
        if (subTree && subTree !== root) {
            root.addChild(await subTree.reduce(reduce2));
        }
        return root.reduce(reduce2);
    }
    var trickle_default = trickleStream;
    var SubTree = class {
        /**
         * @param {number} maxDepth
         * @param {number} layerRepeat
         * @param {number} [iteration=0]
         */
        constructor(maxDepth, layerRepeat, iteration = 0) {
            this.maxDepth = maxDepth;
            this.layerRepeat = layerRepeat;
            this.currentDepth = 1;
            this.iteration = iteration;
            this.root =
                this.node =
                    this.parent =
                        {
                            children: [],
                            depth: this.currentDepth,
                            maxDepth,
                            maxChildren: (this.maxDepth - this.currentDepth) * this.layerRepeat,
                        };
        }
        isFull() {
            if (!this.root.data) {
                return false;
            }
            if (this.currentDepth < this.maxDepth && this.node.maxChildren) {
                this._addNextNodeToParent(this.node);
                return false;
            }
            const distantRelative = this._findParent(this.node, this.currentDepth);
            if (distantRelative) {
                this._addNextNodeToParent(distantRelative);
                return false;
            }
            return true;
        }
        /**
         * @param {TrickleDagNode} parent
         */
        _addNextNodeToParent(parent) {
            this.parent = parent;
            const nextNode = {
                children: [],
                depth: parent.depth + 1,
                parent,
                maxDepth: this.maxDepth,
                maxChildren: Math.floor(parent.children.length / this.layerRepeat) *
                    this.layerRepeat,
            };
            parent.children.push(nextNode);
            this.currentDepth = nextNode.depth;
            this.node = nextNode;
        }
        /**
         *
         * @param {InProgressImportResult[]} layer
         */
        append(layer) {
            this.node.data = layer;
        }
        /**
         * @param {Reducer} reduce
         */
        reduce(reduce2) {
            return this._reduce(this.root, reduce2);
        }
        /**
         * @param {TrickleDagNode} node
         * @param {Reducer} reduce
         * @returns {Promise<InProgressImportResult>}
         */
        async _reduce(node, reduce2) {
            let children = [];
            if (node.children.length) {
                children = await Promise.all(node.children
                    .filter((child) => child.data)
                    .map((child) => this._reduce(child, reduce2)));
            }
            return reduce2((node.data || []).concat(children));
        }
        /**
         * @param {TrickleDagNode} node
         * @param {number} depth
         * @returns {TrickleDagNode | undefined}
         */
        _findParent(node, depth) {
            const parent = node.parent;
            if (!parent || parent.depth === 0) {
                return;
            }
            if (parent.children.length === parent.maxChildren ||
                !parent.maxChildren) {
                return this._findParent(parent, depth);
            }
            return parent;
        }
    };
    var Root = class extends SubTree {
        /**
         * @param {number} layerRepeat
         */
        constructor(layerRepeat) {
            super(0, layerRepeat);
            this.root.depth = 0;
            this.currentDepth = 1;
        }
        /**
         * @param {InProgressImportResult} child
         */
        addChild(child) {
            this.root.children.push(child);
        }
        /**
         * @param {Reducer} reduce
         */
        reduce(reduce2) {
            return reduce2((this.root.data || []).concat(this.root.children));
        }
    };
    // node_modules/ipfs-unixfs-importer/src/dag-builder/file/buffer-importer.js
    async function* bufferImporter(file, block, options) {
        for await (let buffer of file.content) {
            yield async () => {
                options.progress(buffer.length, file.path);
                let unixfs;
                const opts = {
                    codec: src_exports,
                    cidVersion: options.cidVersion,
                    hasher: options.hasher,
                    onlyHash: options.onlyHash,
                };
                if (options.rawLeaves) {
                    opts.codec = raw_exports;
                    opts.cidVersion = 1;
                }
                else {
                    unixfs = new UnixFS({
                        type: options.leafType,
                        data: buffer,
                    });
                    buffer = encode3({
                        Data: unixfs.marshal(),
                        Links: [],
                    });
                }
                return {
                    cid: await persist_default(buffer, block, opts),
                    unixfs,
                    size: buffer.length,
                };
            };
        }
    }
    var buffer_importer_default = bufferImporter;
    // node_modules/ipfs-unixfs-importer/src/dag-builder/file/index.js
    var dagBuilders = {
        flat: flat_default,
        balanced: balanced_default,
        trickle: trickle_default,
    };
    async function* buildFileBatch(file, blockstore, options) {
        let count = -1;
        let previous;
        let bufferImporter2;
        if (typeof options.bufferImporter === 'function') {
            bufferImporter2 = options.bufferImporter;
        }
        else {
            bufferImporter2 = buffer_importer_default;
        }
        for await (const entry of parallelBatch(bufferImporter2(file, blockstore, options), options.blockWriteConcurrency)) {
            count++;
            if (count === 0) {
                previous = entry;
                continue;
            }
            else if (count === 1 && previous) {
                yield previous;
                previous = null;
            }
            yield entry;
        }
        if (previous) {
            previous.single = true;
            yield previous;
        }
    }
    var reduce = (file, blockstore, options) => {
        async function reducer(leaves) {
            if (leaves.length === 1 &&
                leaves[0].single &&
                options.reduceSingleLeafToSelf) {
                const leaf = leaves[0];
                if (file.mtime !== void 0 || file.mode !== void 0) {
                    let buffer2 = await blockstore.get(leaf.cid);
                    leaf.unixfs = new UnixFS({
                        type: 'file',
                        mtime: file.mtime,
                        mode: file.mode,
                        data: buffer2,
                    });
                    buffer2 = encode3(prepare({ Data: leaf.unixfs.marshal() }));
                    leaf.cid = await persist_default(buffer2, blockstore, {
                        ...options,
                        codec: src_exports,
                        hasher: options.hasher,
                        cidVersion: options.cidVersion,
                    });
                    leaf.size = buffer2.length;
                }
                return {
                    cid: leaf.cid,
                    path: file.path,
                    unixfs: leaf.unixfs,
                    size: leaf.size,
                };
            }
            const f = new UnixFS({
                type: 'file',
                mtime: file.mtime,
                mode: file.mode,
            });
            const links = leaves
                .filter((leaf) => {
                if (leaf.cid.code === code2 && leaf.size) {
                    return true;
                }
                if (leaf.unixfs && !leaf.unixfs.data && leaf.unixfs.fileSize()) {
                    return true;
                }
                return Boolean(leaf.unixfs && leaf.unixfs.data && leaf.unixfs.data.length);
            })
                .map((leaf) => {
                if (leaf.cid.code === code2) {
                    f.addBlockSize(leaf.size);
                    return {
                        Name: '',
                        Tsize: leaf.size,
                        Hash: leaf.cid,
                    };
                }
                if (!leaf.unixfs || !leaf.unixfs.data) {
                    f.addBlockSize((leaf.unixfs && leaf.unixfs.fileSize()) || 0);
                }
                else {
                    f.addBlockSize(leaf.unixfs.data.length);
                }
                return {
                    Name: '',
                    Tsize: leaf.size,
                    Hash: leaf.cid,
                };
            });
            const node = {
                Data: f.marshal(),
                Links: links,
            };
            const buffer = encode3(prepare(node));
            const cid = await persist_default(buffer, blockstore, options);
            return {
                cid,
                path: file.path,
                unixfs: f,
                size: buffer.length + node.Links.reduce((acc, curr) => acc + curr.Tsize, 0),
            };
        }
        return reducer;
    };
    function fileBuilder(file, block, options) {
        const dagBuilder2 = dagBuilders[options.strategy];
        if (!dagBuilder2) {
            throw (0, import_err_code2.default)(new Error(`Unknown importer build strategy name: ${options.strategy}`), 'ERR_BAD_STRATEGY');
        }
        return dagBuilder2(buildFileBatch(file, block, options), reduce(file, block, options), options);
    }
    var file_default = fileBuilder;
    // node_modules/ipfs-unixfs-importer/src/dag-builder/index.js
    var import_err_code5 = __toESM(require_err_code(), 1);
    // node_modules/uint8arrays/dist/src/util/as-uint8array.js
    function asUint8Array(buf) {
        if (globalThis.Buffer != null) {
            return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
        }
        return buf;
    }
    // node_modules/uint8arrays/dist/src/alloc.js
    function alloc(size = 0) {
        if (globalThis.Buffer?.alloc != null) {
            return asUint8Array(globalThis.Buffer.alloc(size));
        }
        return new Uint8Array(size);
    }
    function allocUnsafe(size = 0) {
        if (globalThis.Buffer?.allocUnsafe != null) {
            return asUint8Array(globalThis.Buffer.allocUnsafe(size));
        }
        return new Uint8Array(size);
    }
    // node_modules/uint8arrays/dist/src/concat.js
    function concat(arrays, length2) {
        if (length2 == null) {
            length2 = arrays.reduce((acc, curr) => acc + curr.length, 0);
        }
        const output = allocUnsafe(length2);
        let offset = 0;
        for (const arr of arrays) {
            output.set(arr, offset);
            offset += arr.length;
        }
        return asUint8Array(output);
    }
    // node_modules/uint8arrays/dist/src/equals.js
    function equals3(a, b) {
        if (a === b) {
            return true;
        }
        if (a.byteLength !== b.byteLength) {
            return false;
        }
        for (let i = 0; i < a.byteLength; i++) {
            if (a[i] !== b[i]) {
                return false;
            }
        }
        return true;
    }
    // node_modules/uint8arraylist/dist/src/index.js
    var symbol = Symbol.for('@achingbrain/uint8arraylist');
    function findBufAndOffset(bufs, index) {
        if (index == null || index < 0) {
            throw new RangeError('index is out of bounds');
        }
        let offset = 0;
        for (const buf of bufs) {
            const bufEnd = offset + buf.byteLength;
            if (index < bufEnd) {
                return {
                    buf,
                    index: index - offset,
                };
            }
            offset = bufEnd;
        }
        throw new RangeError('index is out of bounds');
    }
    function isUint8ArrayList(value) {
        return Boolean(value?.[symbol]);
    }
    var Uint8ArrayList = class {
        constructor(...data) {
            Object.defineProperty(this, symbol, { value: true });
            this.bufs = [];
            this.length = 0;
            if (data.length > 0) {
                this.appendAll(data);
            }
        }
        *[Symbol.iterator]() {
            yield* this.bufs;
        }
        get byteLength() {
            return this.length;
        }
        /**
         * Add one or more `bufs` to the end of this Uint8ArrayList
         */
        append(...bufs) {
            this.appendAll(bufs);
        }
        /**
         * Add all `bufs` to the end of this Uint8ArrayList
         */
        appendAll(bufs) {
            let length2 = 0;
            for (const buf of bufs) {
                if (buf instanceof Uint8Array) {
                    length2 += buf.byteLength;
                    this.bufs.push(buf);
                }
                else if (isUint8ArrayList(buf)) {
                    length2 += buf.byteLength;
                    this.bufs.push(...buf.bufs);
                }
                else {
                    throw new Error('Could not append value, must be an Uint8Array or a Uint8ArrayList');
                }
            }
            this.length += length2;
        }
        /**
         * Add one or more `bufs` to the start of this Uint8ArrayList
         */
        prepend(...bufs) {
            this.prependAll(bufs);
        }
        /**
         * Add all `bufs` to the start of this Uint8ArrayList
         */
        prependAll(bufs) {
            let length2 = 0;
            for (const buf of bufs.reverse()) {
                if (buf instanceof Uint8Array) {
                    length2 += buf.byteLength;
                    this.bufs.unshift(buf);
                }
                else if (isUint8ArrayList(buf)) {
                    length2 += buf.byteLength;
                    this.bufs.unshift(...buf.bufs);
                }
                else {
                    throw new Error('Could not prepend value, must be an Uint8Array or a Uint8ArrayList');
                }
            }
            this.length += length2;
        }
        /**
         * Read the value at `index`
         */
        get(index) {
            const res = findBufAndOffset(this.bufs, index);
            return res.buf[res.index];
        }
        /**
         * Set the value at `index` to `value`
         */
        set(index, value) {
            const res = findBufAndOffset(this.bufs, index);
            res.buf[res.index] = value;
        }
        /**
         * Copy bytes from `buf` to the index specified by `offset`
         */
        write(buf, offset = 0) {
            if (buf instanceof Uint8Array) {
                for (let i = 0; i < buf.length; i++) {
                    this.set(offset + i, buf[i]);
                }
            }
            else if (isUint8ArrayList(buf)) {
                for (let i = 0; i < buf.length; i++) {
                    this.set(offset + i, buf.get(i));
                }
            }
            else {
                throw new Error('Could not write value, must be an Uint8Array or a Uint8ArrayList');
            }
        }
        /**
         * Remove bytes from the front of the pool
         */
        consume(bytes) {
            bytes = Math.trunc(bytes);
            if (Number.isNaN(bytes) || bytes <= 0) {
                return;
            }
            if (bytes === this.byteLength) {
                this.bufs = [];
                this.length = 0;
                return;
            }
            while (this.bufs.length > 0) {
                if (bytes >= this.bufs[0].byteLength) {
                    bytes -= this.bufs[0].byteLength;
                    this.length -= this.bufs[0].byteLength;
                    this.bufs.shift();
                }
                else {
                    this.bufs[0] = this.bufs[0].subarray(bytes);
                    this.length -= bytes;
                    break;
                }
            }
        }
        /**
         * Extracts a section of an array and returns a new array.
         *
         * This is a copy operation as it is with Uint8Arrays and Arrays
         * - note this is different to the behaviour of Node Buffers.
         */
        slice(beginInclusive, endExclusive) {
            const { bufs, length: length2 } = this._subList(beginInclusive, endExclusive);
            return concat(bufs, length2);
        }
        /**
         * Returns a alloc from the given start and end element index.
         *
         * In the best case where the data extracted comes from a single Uint8Array
         * internally this is a no-copy operation otherwise it is a copy operation.
         */
        subarray(beginInclusive, endExclusive) {
            const { bufs, length: length2 } = this._subList(beginInclusive, endExclusive);
            if (bufs.length === 1) {
                return bufs[0];
            }
            return concat(bufs, length2);
        }
        /**
         * Returns a allocList from the given start and end element index.
         *
         * This is a no-copy operation.
         */
        sublist(beginInclusive, endExclusive) {
            const { bufs, length: length2 } = this._subList(beginInclusive, endExclusive);
            const list = new Uint8ArrayList();
            list.length = length2;
            list.bufs = bufs;
            return list;
        }
        _subList(beginInclusive, endExclusive) {
            beginInclusive = beginInclusive ?? 0;
            endExclusive = endExclusive ?? this.length;
            if (beginInclusive < 0) {
                beginInclusive = this.length + beginInclusive;
            }
            if (endExclusive < 0) {
                endExclusive = this.length + endExclusive;
            }
            if (beginInclusive < 0 || endExclusive > this.length) {
                throw new RangeError('index is out of bounds');
            }
            if (beginInclusive === endExclusive) {
                return { bufs: [], length: 0 };
            }
            if (beginInclusive === 0 && endExclusive === this.length) {
                return { bufs: [...this.bufs], length: this.length };
            }
            const bufs = [];
            let offset = 0;
            for (let i = 0; i < this.bufs.length; i++) {
                const buf = this.bufs[i];
                const bufStart = offset;
                const bufEnd = bufStart + buf.byteLength;
                offset = bufEnd;
                if (beginInclusive >= bufEnd) {
                    continue;
                }
                const sliceStartInBuf = beginInclusive >= bufStart && beginInclusive < bufEnd;
                const sliceEndsInBuf = endExclusive > bufStart && endExclusive <= bufEnd;
                if (sliceStartInBuf && sliceEndsInBuf) {
                    if (beginInclusive === bufStart && endExclusive === bufEnd) {
                        bufs.push(buf);
                        break;
                    }
                    const start = beginInclusive - bufStart;
                    bufs.push(buf.subarray(start, start + (endExclusive - beginInclusive)));
                    break;
                }
                if (sliceStartInBuf) {
                    if (beginInclusive === 0) {
                        bufs.push(buf);
                        continue;
                    }
                    bufs.push(buf.subarray(beginInclusive - bufStart));
                    continue;
                }
                if (sliceEndsInBuf) {
                    if (endExclusive === bufEnd) {
                        bufs.push(buf);
                        break;
                    }
                    bufs.push(buf.subarray(0, endExclusive - bufStart));
                    break;
                }
                bufs.push(buf);
            }
            return { bufs, length: endExclusive - beginInclusive };
        }
        indexOf(search, offset = 0) {
            if (!isUint8ArrayList(search) && !(search instanceof Uint8Array)) {
                throw new TypeError('The "value" argument must be a Uint8ArrayList or Uint8Array');
            }
            const needle = search instanceof Uint8Array ? search : search.subarray();
            offset = Number(offset ?? 0);
            if (isNaN(offset)) {
                offset = 0;
            }
            if (offset < 0) {
                offset = this.length + offset;
            }
            if (offset < 0) {
                offset = 0;
            }
            if (search.length === 0) {
                return offset > this.length ? this.length : offset;
            }
            const M = needle.byteLength;
            if (M === 0) {
                throw new TypeError('search must be at least 1 byte long');
            }
            const radix = 256;
            const rightmostPositions = new Int32Array(radix);
            for (let c = 0; c < radix; c++) {
                rightmostPositions[c] = -1;
            }
            for (let j = 0; j < M; j++) {
                rightmostPositions[needle[j]] = j;
            }
            const right = rightmostPositions;
            const lastIndex = this.byteLength - needle.byteLength;
            const lastPatIndex = needle.byteLength - 1;
            let skip;
            for (let i = offset; i <= lastIndex; i += skip) {
                skip = 0;
                for (let j = lastPatIndex; j >= 0; j--) {
                    const char = this.get(i + j);
                    if (needle[j] !== char) {
                        skip = Math.max(1, j - right[char]);
                        break;
                    }
                }
                if (skip === 0) {
                    return i;
                }
            }
            return -1;
        }
        getInt8(byteOffset) {
            const buf = this.subarray(byteOffset, byteOffset + 1);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            return view.getInt8(0);
        }
        setInt8(byteOffset, value) {
            const buf = allocUnsafe(1);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            view.setInt8(0, value);
            this.write(buf, byteOffset);
        }
        getInt16(byteOffset, littleEndian) {
            const buf = this.subarray(byteOffset, byteOffset + 2);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            return view.getInt16(0, littleEndian);
        }
        setInt16(byteOffset, value, littleEndian) {
            const buf = alloc(2);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            view.setInt16(0, value, littleEndian);
            this.write(buf, byteOffset);
        }
        getInt32(byteOffset, littleEndian) {
            const buf = this.subarray(byteOffset, byteOffset + 4);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            return view.getInt32(0, littleEndian);
        }
        setInt32(byteOffset, value, littleEndian) {
            const buf = alloc(4);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            view.setInt32(0, value, littleEndian);
            this.write(buf, byteOffset);
        }
        getBigInt64(byteOffset, littleEndian) {
            const buf = this.subarray(byteOffset, byteOffset + 8);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            return view.getBigInt64(0, littleEndian);
        }
        setBigInt64(byteOffset, value, littleEndian) {
            const buf = alloc(8);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            view.setBigInt64(0, value, littleEndian);
            this.write(buf, byteOffset);
        }
        getUint8(byteOffset) {
            const buf = this.subarray(byteOffset, byteOffset + 1);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            return view.getUint8(0);
        }
        setUint8(byteOffset, value) {
            const buf = allocUnsafe(1);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            view.setUint8(0, value);
            this.write(buf, byteOffset);
        }
        getUint16(byteOffset, littleEndian) {
            const buf = this.subarray(byteOffset, byteOffset + 2);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            return view.getUint16(0, littleEndian);
        }
        setUint16(byteOffset, value, littleEndian) {
            const buf = alloc(2);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            view.setUint16(0, value, littleEndian);
            this.write(buf, byteOffset);
        }
        getUint32(byteOffset, littleEndian) {
            const buf = this.subarray(byteOffset, byteOffset + 4);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            return view.getUint32(0, littleEndian);
        }
        setUint32(byteOffset, value, littleEndian) {
            const buf = alloc(4);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            view.setUint32(0, value, littleEndian);
            this.write(buf, byteOffset);
        }
        getBigUint64(byteOffset, littleEndian) {
            const buf = this.subarray(byteOffset, byteOffset + 8);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            return view.getBigUint64(0, littleEndian);
        }
        setBigUint64(byteOffset, value, littleEndian) {
            const buf = alloc(8);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            view.setBigUint64(0, value, littleEndian);
            this.write(buf, byteOffset);
        }
        getFloat32(byteOffset, littleEndian) {
            const buf = this.subarray(byteOffset, byteOffset + 4);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            return view.getFloat32(0, littleEndian);
        }
        setFloat32(byteOffset, value, littleEndian) {
            const buf = alloc(4);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            view.setFloat32(0, value, littleEndian);
            this.write(buf, byteOffset);
        }
        getFloat64(byteOffset, littleEndian) {
            const buf = this.subarray(byteOffset, byteOffset + 8);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            return view.getFloat64(0, littleEndian);
        }
        setFloat64(byteOffset, value, littleEndian) {
            const buf = alloc(8);
            const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
            view.setFloat64(0, value, littleEndian);
            this.write(buf, byteOffset);
        }
        equals(other) {
            if (other == null) {
                return false;
            }
            if (!(other instanceof Uint8ArrayList)) {
                return false;
            }
            if (other.bufs.length !== this.bufs.length) {
                return false;
            }
            for (let i = 0; i < this.bufs.length; i++) {
                if (!equals3(this.bufs[i], other.bufs[i])) {
                    return false;
                }
            }
            return true;
        }
        /**
         * Create a Uint8ArrayList from a pre-existing list of Uint8Arrays.  Use this
         * method if you know the total size of all the Uint8Arrays ahead of time.
         */
        static fromUint8Arrays(bufs, length2) {
            const list = new Uint8ArrayList();
            list.bufs = bufs;
            if (length2 == null) {
                length2 = bufs.reduce((acc, curr) => acc + curr.byteLength, 0);
            }
            list.length = length2;
            return list;
        }
    };
    // node_modules/ipfs-unixfs-importer/src/chunker/rabin.js
    var import_rabin_wasm = __toESM(require_src(), 1);
    var import_err_code3 = __toESM(require_err_code(), 1);
    async function* rabinChunker(source, options) {
        let min, max, avg;
        if (options.minChunkSize && options.maxChunkSize && options.avgChunkSize) {
            avg = options.avgChunkSize;
            min = options.minChunkSize;
            max = options.maxChunkSize;
        }
        else if (!options.avgChunkSize) {
            throw (0, import_err_code3.default)(new Error('please specify an average chunk size'), 'ERR_INVALID_AVG_CHUNK_SIZE');
        }
        else {
            avg = options.avgChunkSize;
            min = avg / 3;
            max = avg + avg / 2;
        }
        if (min < 16) {
            throw (0, import_err_code3.default)(new Error('rabin min must be greater than 16'), 'ERR_INVALID_MIN_CHUNK_SIZE');
        }
        if (max < min) {
            max = min;
        }
        if (avg < min) {
            avg = min;
        }
        const sizepow = Math.floor(Math.log2(avg));
        for await (const chunk of rabin(source, {
            min,
            max,
            bits: sizepow,
            window: options.window,
            polynomial: options.polynomial,
        })) {
            yield chunk;
        }
    }
    var rabin_default = rabinChunker;
    async function* rabin(source, options) {
        const r = await (0, import_rabin_wasm.create)(options.bits, options.min, options.max, options.window);
        const buffers = new Uint8ArrayList();
        for await (const chunk of source) {
            buffers.append(chunk);
            const sizes = r.fingerprint(chunk);
            for (let i = 0; i < sizes.length; i++) {
                const size = sizes[i];
                const buf = buffers.slice(0, size);
                buffers.consume(size);
                yield buf;
            }
        }
        if (buffers.length) {
            yield buffers.subarray(0);
        }
    }
    // node_modules/ipfs-unixfs-importer/src/chunker/fixed-size.js
    async function* fixedSizeChunker(source, options) {
        let list = new Uint8ArrayList();
        let currentLength = 0;
        let emitted = false;
        const maxChunkSize = options.maxChunkSize;
        for await (const buffer of source) {
            list.append(buffer);
            currentLength += buffer.length;
            while (currentLength >= maxChunkSize) {
                yield list.slice(0, maxChunkSize);
                emitted = true;
                if (maxChunkSize === list.length) {
                    list = new Uint8ArrayList();
                    currentLength = 0;
                }
                else {
                    const newBl = new Uint8ArrayList();
                    newBl.append(list.sublist(maxChunkSize));
                    list = newBl;
                    currentLength -= maxChunkSize;
                }
            }
        }
        if (!emitted || currentLength) {
            yield list.subarray(0, currentLength);
        }
    }
    var fixed_size_default = fixedSizeChunker;
    // node_modules/ipfs-unixfs-importer/src/dag-builder/validate-chunks.js
    var import_err_code4 = __toESM(require_err_code(), 1);
    // node_modules/multiformats/src/bases/identity.js
    var identity_exports = {};
    __export(identity_exports, {
        identity: () => identity,
    });
    var identity = from2({
        prefix: '\0',
        name: 'identity',
        encode: (buf) => toString(buf),
        decode: (str) => fromString(str),
    });
    // node_modules/multiformats/src/bases/base2.js
    var base2_exports = {};
    __export(base2_exports, {
        base2: () => base2,
    });
    var base2 = rfc4648({
        prefix: '0',
        name: 'base2',
        alphabet: '01',
        bitsPerChar: 1,
    });
    // node_modules/multiformats/src/bases/base8.js
    var base8_exports = {};
    __export(base8_exports, {
        base8: () => base8,
    });
    var base8 = rfc4648({
        prefix: '7',
        name: 'base8',
        alphabet: '01234567',
        bitsPerChar: 3,
    });
    // node_modules/multiformats/src/bases/base10.js
    var base10_exports = {};
    __export(base10_exports, {
        base10: () => base10,
    });
    var base10 = baseX({
        prefix: '9',
        name: 'base10',
        alphabet: '0123456789',
    });
    // node_modules/multiformats/src/bases/base16.js
    var base16_exports = {};
    __export(base16_exports, {
        base16: () => base16,
        base16upper: () => base16upper,
    });
    var base16 = rfc4648({
        prefix: 'f',
        name: 'base16',
        alphabet: '0123456789abcdef',
        bitsPerChar: 4,
    });
    var base16upper = rfc4648({
        prefix: 'F',
        name: 'base16upper',
        alphabet: '0123456789ABCDEF',
        bitsPerChar: 4,
    });
    // node_modules/multiformats/src/bases/base36.js
    var base36_exports = {};
    __export(base36_exports, {
        base36: () => base36,
        base36upper: () => base36upper,
    });
    var base36 = baseX({
        prefix: 'k',
        name: 'base36',
        alphabet: '0123456789abcdefghijklmnopqrstuvwxyz',
    });
    var base36upper = baseX({
        prefix: 'K',
        name: 'base36upper',
        alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ',
    });
    // node_modules/multiformats/src/bases/base64.js
    var base64_exports = {};
    __export(base64_exports, {
        base64: () => base64,
        base64pad: () => base64pad,
        base64url: () => base64url,
        base64urlpad: () => base64urlpad,
    });
    var base64 = rfc4648({
        prefix: 'm',
        name: 'base64',
        alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
        bitsPerChar: 6,
    });
    var base64pad = rfc4648({
        prefix: 'M',
        name: 'base64pad',
        alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
        bitsPerChar: 6,
    });
    var base64url = rfc4648({
        prefix: 'u',
        name: 'base64url',
        alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
        bitsPerChar: 6,
    });
    var base64urlpad = rfc4648({
        prefix: 'U',
        name: 'base64urlpad',
        alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=',
        bitsPerChar: 6,
    });
    // node_modules/multiformats/src/bases/base256emoji.js
    var base256emoji_exports = {};
    __export(base256emoji_exports, {
        base256emoji: () => base256emoji,
    });
    var alphabet = Array.from('\u{1F680}\u{1FA90}\u2604\u{1F6F0}\u{1F30C}\u{1F311}\u{1F312}\u{1F313}\u{1F314}\u{1F315}\u{1F316}\u{1F317}\u{1F318}\u{1F30D}\u{1F30F}\u{1F30E}\u{1F409}\u2600\u{1F4BB}\u{1F5A5}\u{1F4BE}\u{1F4BF}\u{1F602}\u2764\u{1F60D}\u{1F923}\u{1F60A}\u{1F64F}\u{1F495}\u{1F62D}\u{1F618}\u{1F44D}\u{1F605}\u{1F44F}\u{1F601}\u{1F525}\u{1F970}\u{1F494}\u{1F496}\u{1F499}\u{1F622}\u{1F914}\u{1F606}\u{1F644}\u{1F4AA}\u{1F609}\u263A\u{1F44C}\u{1F917}\u{1F49C}\u{1F614}\u{1F60E}\u{1F607}\u{1F339}\u{1F926}\u{1F389}\u{1F49E}\u270C\u2728\u{1F937}\u{1F631}\u{1F60C}\u{1F338}\u{1F64C}\u{1F60B}\u{1F497}\u{1F49A}\u{1F60F}\u{1F49B}\u{1F642}\u{1F493}\u{1F929}\u{1F604}\u{1F600}\u{1F5A4}\u{1F603}\u{1F4AF}\u{1F648}\u{1F447}\u{1F3B6}\u{1F612}\u{1F92D}\u2763\u{1F61C}\u{1F48B}\u{1F440}\u{1F62A}\u{1F611}\u{1F4A5}\u{1F64B}\u{1F61E}\u{1F629}\u{1F621}\u{1F92A}\u{1F44A}\u{1F973}\u{1F625}\u{1F924}\u{1F449}\u{1F483}\u{1F633}\u270B\u{1F61A}\u{1F61D}\u{1F634}\u{1F31F}\u{1F62C}\u{1F643}\u{1F340}\u{1F337}\u{1F63B}\u{1F613}\u2B50\u2705\u{1F97A}\u{1F308}\u{1F608}\u{1F918}\u{1F4A6}\u2714\u{1F623}\u{1F3C3}\u{1F490}\u2639\u{1F38A}\u{1F498}\u{1F620}\u261D\u{1F615}\u{1F33A}\u{1F382}\u{1F33B}\u{1F610}\u{1F595}\u{1F49D}\u{1F64A}\u{1F639}\u{1F5E3}\u{1F4AB}\u{1F480}\u{1F451}\u{1F3B5}\u{1F91E}\u{1F61B}\u{1F534}\u{1F624}\u{1F33C}\u{1F62B}\u26BD\u{1F919}\u2615\u{1F3C6}\u{1F92B}\u{1F448}\u{1F62E}\u{1F646}\u{1F37B}\u{1F343}\u{1F436}\u{1F481}\u{1F632}\u{1F33F}\u{1F9E1}\u{1F381}\u26A1\u{1F31E}\u{1F388}\u274C\u270A\u{1F44B}\u{1F630}\u{1F928}\u{1F636}\u{1F91D}\u{1F6B6}\u{1F4B0}\u{1F353}\u{1F4A2}\u{1F91F}\u{1F641}\u{1F6A8}\u{1F4A8}\u{1F92C}\u2708\u{1F380}\u{1F37A}\u{1F913}\u{1F619}\u{1F49F}\u{1F331}\u{1F616}\u{1F476}\u{1F974}\u25B6\u27A1\u2753\u{1F48E}\u{1F4B8}\u2B07\u{1F628}\u{1F31A}\u{1F98B}\u{1F637}\u{1F57A}\u26A0\u{1F645}\u{1F61F}\u{1F635}\u{1F44E}\u{1F932}\u{1F920}\u{1F927}\u{1F4CC}\u{1F535}\u{1F485}\u{1F9D0}\u{1F43E}\u{1F352}\u{1F617}\u{1F911}\u{1F30A}\u{1F92F}\u{1F437}\u260E\u{1F4A7}\u{1F62F}\u{1F486}\u{1F446}\u{1F3A4}\u{1F647}\u{1F351}\u2744\u{1F334}\u{1F4A3}\u{1F438}\u{1F48C}\u{1F4CD}\u{1F940}\u{1F922}\u{1F445}\u{1F4A1}\u{1F4A9}\u{1F450}\u{1F4F8}\u{1F47B}\u{1F910}\u{1F92E}\u{1F3BC}\u{1F975}\u{1F6A9}\u{1F34E}\u{1F34A}\u{1F47C}\u{1F48D}\u{1F4E3}\u{1F942}');
    var alphabetBytesToChars = 
    /** @type {string[]} */
    alphabet.reduce((p, c, i) => {
        p[i] = c;
        return p;
    }, 
    /** @type {string[]} */
    []);
    var alphabetCharsToBytes = 
    /** @type {number[]} */
    alphabet.reduce((p, c, i) => {
        p[
        /** @type {number} */
        c.codePointAt(0)] = i;
        return p;
    }, 
    /** @type {number[]} */
    []);
    function encode5(data) {
        return data.reduce((p, c) => {
            p += alphabetBytesToChars[c];
            return p;
        }, '');
    }
    function decode7(str) {
        const byts = [];
        for (const char of str) {
            const byt = alphabetCharsToBytes[
            /** @type {number} */
            char.codePointAt(0)];
            if (byt === void 0) {
                throw new Error(`Non-base256emoji character: ${char}`);
            }
            byts.push(byt);
        }
        return new Uint8Array(byts);
    }
    var base256emoji = from2({
        prefix: '\u{1F680}',
        name: 'base256emoji',
        encode: encode5,
        decode: decode7,
    });
    // node_modules/multiformats/src/hashes/identity.js
    var identity_exports2 = {};
    __export(identity_exports2, {
        identity: () => identity2,
    });
    var code3 = 0;
    var name3 = 'identity';
    var encode6 = coerce;
    var digest = (input) => create(code3, encode6(input));
    var identity2 = { code: code3, name: name3, encode: encode6, digest };
    // node_modules/multiformats/src/codecs/json.js
    var textEncoder3 = new TextEncoder();
    var textDecoder2 = new TextDecoder();
    // node_modules/multiformats/src/basics.js
    var bases = {
        ...identity_exports,
        ...base2_exports,
        ...base8_exports,
        ...base10_exports,
        ...base16_exports,
        ...base32_exports,
        ...base36_exports,
        ...base58_exports,
        ...base64_exports,
        ...base256emoji_exports,
    };
    var hashes = { ...sha2_browser_exports, ...identity_exports2 };
    // node_modules/uint8arrays/dist/src/util/bases.js
    function createCodec(name4, prefix, encode7, decode8) {
        return {
            name: name4,
            prefix,
            encoder: {
                name: name4,
                prefix,
                encode: encode7,
            },
            decoder: {
                decode: decode8,
            },
        };
    }
    var string = createCodec('utf8', 'u', (buf) => {
        const decoder = new TextDecoder('utf8');
        return 'u' + decoder.decode(buf);
    }, (str) => {
        const encoder = new TextEncoder();
        return encoder.encode(str.substring(1));
    });
    var ascii = createCodec('ascii', 'a', (buf) => {
        let string2 = 'a';
        for (let i = 0; i < buf.length; i++) {
            string2 += String.fromCharCode(buf[i]);
        }
        return string2;
    }, (str) => {
        str = str.substring(1);
        const buf = allocUnsafe(str.length);
        for (let i = 0; i < str.length; i++) {
            buf[i] = str.charCodeAt(i);
        }
        return buf;
    });
    var BASES = {
        utf8: string,
        'utf-8': string,
        hex: bases.base16,
        latin1: ascii,
        ascii,
        binary: ascii,
        ...bases,
    };
    var bases_default = BASES;
    // node_modules/uint8arrays/dist/src/from-string.js
    function fromString2(string2, encoding = 'utf8') {
        const base3 = bases_default[encoding];
        if (base3 == null) {
            throw new Error(`Unsupported encoding "${encoding}"`);
        }
        if ((encoding === 'utf8' || encoding === 'utf-8') &&
            globalThis.Buffer != null &&
            globalThis.Buffer.from != null) {
            return asUint8Array(globalThis.Buffer.from(string2, 'utf-8'));
        }
        return base3.decoder.decode(`${base3.prefix}${string2}`);
    }
    // node_modules/ipfs-unixfs-importer/src/dag-builder/validate-chunks.js
    async function* validateChunks(source) {
        for await (const content of source) {
            if (content.length === void 0) {
                throw (0, import_err_code4.default)(new Error('Content was invalid'), 'ERR_INVALID_CONTENT');
            }
            if (typeof content === 'string' || content instanceof String) {
                yield fromString2(content.toString());
            }
            else if (Array.isArray(content)) {
                yield Uint8Array.from(content);
            }
            else if (content instanceof Uint8Array) {
                yield content;
            }
            else {
                throw (0, import_err_code4.default)(new Error('Content was invalid'), 'ERR_INVALID_CONTENT');
            }
        }
    }
    var validate_chunks_default = validateChunks;
    // node_modules/ipfs-unixfs-importer/src/dag-builder/index.js
    function isIterable(thing) {
        return Symbol.iterator in thing;
    }
    function isAsyncIterable(thing) {
        return Symbol.asyncIterator in thing;
    }
    function contentAsAsyncIterable(content) {
        try {
            if (content instanceof Uint8Array) {
                return (async function* () {
                    yield content;
                })();
            }
            else if (isIterable(content)) {
                return (async function* () {
                    yield* content;
                })();
            }
            else if (isAsyncIterable(content)) {
                return content;
            }
        }
        catch {
            throw (0, import_err_code5.default)(new Error('Content was invalid'), 'ERR_INVALID_CONTENT');
        }
        throw (0, import_err_code5.default)(new Error('Content was invalid'), 'ERR_INVALID_CONTENT');
    }
    async function* dagBuilder(source, blockstore, options) {
        for await (const entry of source) {
            if (entry.path) {
                if (entry.path.substring(0, 2) === './') {
                    options.wrapWithDirectory = true;
                }
                entry.path = entry.path
                    .split('/')
                    .filter((path) => path && path !== '.')
                    .join('/');
            }
            if (entry.content) {
                let chunker;
                if (typeof options.chunker === 'function') {
                    chunker = options.chunker;
                }
                else if (options.chunker === 'rabin') {
                    chunker = rabin_default;
                }
                else {
                    chunker = fixed_size_default;
                }
                let chunkValidator;
                if (typeof options.chunkValidator === 'function') {
                    chunkValidator = options.chunkValidator;
                }
                else {
                    chunkValidator = validate_chunks_default;
                }
                const file = {
                    path: entry.path,
                    mtime: entry.mtime,
                    mode: entry.mode,
                    content: chunker(chunkValidator(contentAsAsyncIterable(entry.content), options), options),
                };
                yield () => file_default(file, blockstore, options);
            }
            else if (entry.path) {
                const dir = {
                    path: entry.path,
                    mtime: entry.mtime,
                    mode: entry.mode,
                };
                yield () => dir_default(dir, blockstore, options);
            }
            else {
                throw new Error('Import candidate must have content or path or both');
            }
        }
    }
    var dag_builder_default = dagBuilder;
    // node_modules/ipfs-unixfs-importer/src/dir.js
    var Dir = class {
        /**
         * @param {DirProps} props
         * @param {ImporterOptions} options
         */
        constructor(props, options) {
            this.options = options || {};
            this.root = props.root;
            this.dir = props.dir;
            this.path = props.path;
            this.dirty = props.dirty;
            this.flat = props.flat;
            this.parent = props.parent;
            this.parentKey = props.parentKey;
            this.unixfs = props.unixfs;
            this.mode = props.mode;
            this.mtime = props.mtime;
            this.cid = void 0;
            this.size = void 0;
        }
        /**
         * @param {string} name
         * @param {InProgressImportResult | Dir} value
         */
        async put(name4, value) { }
        /**
         * @param {string} name
         * @returns {Promise<InProgressImportResult | Dir | undefined>}
         */
        get(name4) {
            return Promise.resolve(this);
        }
        /**
         * @returns {AsyncIterable<{ key: string, child: InProgressImportResult | Dir}>}
         */
        async *eachChildSeries() { }
        /**
         * @param {Blockstore} blockstore
         * @returns {AsyncIterable<ImportResult>}
         */
        async *flush(blockstore) { }
    };
    var dir_default2 = Dir;
    // node_modules/ipfs-unixfs-importer/src/dir-flat.js
    var DirFlat = class extends dir_default2 {
        /**
         * @param {DirProps} props
         * @param {ImporterOptions} options
         */
        constructor(props, options) {
            super(props, options);
            this._children = {};
        }
        /**
         * @param {string} name
         * @param {InProgressImportResult | Dir} value
         */
        async put(name4, value) {
            this.cid = void 0;
            this.size = void 0;
            this._children[name4] = value;
        }
        /**
         * @param {string} name
         */
        get(name4) {
            return Promise.resolve(this._children[name4]);
        }
        childCount() {
            return Object.keys(this._children).length;
        }
        directChildrenCount() {
            return this.childCount();
        }
        onlyChild() {
            return this._children[Object.keys(this._children)[0]];
        }
        async *eachChildSeries() {
            const keys = Object.keys(this._children);
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                yield {
                    key,
                    child: this._children[key],
                };
            }
        }
        /**
         * @param {Blockstore} block
         * @returns {AsyncIterable<ImportResult>}
         */
        async *flush(block) {
            const children = Object.keys(this._children);
            const links = [];
            for (let i = 0; i < children.length; i++) {
                let child = this._children[children[i]];
                if (child instanceof dir_default2) {
                    for await (const entry of child.flush(block)) {
                        child = entry;
                        yield child;
                    }
                }
                if (child.size != null && child.cid) {
                    links.push({
                        Name: children[i],
                        Tsize: child.size,
                        Hash: child.cid,
                    });
                }
            }
            const unixfs = new UnixFS({
                type: 'directory',
                mtime: this.mtime,
                mode: this.mode,
            });
            const node = { Data: unixfs.marshal(), Links: links };
            const buffer = encode3(prepare(node));
            const cid = await persist_default(buffer, block, this.options);
            const size = buffer.length +
                node.Links.reduce(
                /**
                 * @param {number} acc
                 * @param {PBLink} curr
                 */
                (acc, curr) => acc + (curr.Tsize == null ? 0 : curr.Tsize), 0);
            this.cid = cid;
            this.size = size;
            yield {
                cid,
                unixfs,
                path: this.path,
                size,
            };
        }
    };
    var dir_flat_default = DirFlat;
    // node_modules/hamt-sharding/dist/src/bucket.js
    var import_sparse_array = __toESM(require_sparse_array(), 1);
    var Bucket = class {
        constructor(options, parent, posAtParent = 0) {
            this._options = options;
            this._popCount = 0;
            this._parent = parent;
            this._posAtParent = posAtParent;
            this._children = new import_sparse_array.default();
            this.key = null;
        }
        async put(key, value) {
            const place = await this._findNewBucketAndPos(key);
            await place.bucket._putAt(place, key, value);
        }
        async get(key) {
            const child = await this._findChild(key);
            if (child != null) {
                return child.value;
            }
        }
        async del(key) {
            const place = await this._findPlace(key);
            const child = place.bucket._at(place.pos);
            if (child != null && child.key === key) {
                place.bucket._delAt(place.pos);
            }
        }
        leafCount() {
            const children = this._children.compactArray();
            return children.reduce((acc, child) => {
                if (child instanceof Bucket) {
                    return acc + child.leafCount();
                }
                return acc + 1;
            }, 0);
        }
        childrenCount() {
            return this._children.length;
        }
        onlyChild() {
            return this._children.get(0);
        }
        *eachLeafSeries() {
            const children = this._children.compactArray();
            for (const child of children) {
                if (child instanceof Bucket) {
                    yield* child.eachLeafSeries();
                }
                else {
                    yield child;
                }
            }
        }
        serialize(map, reduce2) {
            const acc = [];
            return reduce2(this._children.reduce((acc2, child, index) => {
                if (child != null) {
                    if (child instanceof Bucket) {
                        acc2.push(child.serialize(map, reduce2));
                    }
                    else {
                        acc2.push(map(child, index));
                    }
                }
                return acc2;
            }, acc));
        }
        async asyncTransform(asyncMap, asyncReduce) {
            return await asyncTransformBucket(this, asyncMap, asyncReduce);
        }
        toJSON() {
            return this.serialize(mapNode, reduceNodes);
        }
        prettyPrint() {
            return JSON.stringify(this.toJSON(), null, '  ');
        }
        tableSize() {
            return Math.pow(2, this._options.bits);
        }
        async _findChild(key) {
            const result = await this._findPlace(key);
            const child = result.bucket._at(result.pos);
            if (child instanceof Bucket) {
                return void 0;
            }
            if (child != null && child.key === key) {
                return child;
            }
        }
        async _findPlace(key) {
            const hashValue = this._options.hash(typeof key === 'string' ? fromString2(key) : key);
            const index = await hashValue.take(this._options.bits);
            const child = this._children.get(index);
            if (child instanceof Bucket) {
                return await child._findPlace(hashValue);
            }
            return {
                bucket: this,
                pos: index,
                hash: hashValue,
                existingChild: child,
            };
        }
        async _findNewBucketAndPos(key) {
            const place = await this._findPlace(key);
            if (place.existingChild != null && place.existingChild.key !== key) {
                const bucket = new Bucket(this._options, place.bucket, place.pos);
                place.bucket._putObjectAt(place.pos, bucket);
                const newPlace = await bucket._findPlace(place.existingChild.hash);
                newPlace.bucket._putAt(newPlace, place.existingChild.key, place.existingChild.value);
                return await bucket._findNewBucketAndPos(place.hash);
            }
            return place;
        }
        _putAt(place, key, value) {
            this._putObjectAt(place.pos, {
                key,
                value,
                hash: place.hash,
            });
        }
        _putObjectAt(pos, object) {
            if (this._children.get(pos) == null) {
                this._popCount++;
            }
            this._children.set(pos, object);
        }
        _delAt(pos) {
            if (pos === -1) {
                throw new Error('Invalid position');
            }
            if (this._children.get(pos) != null) {
                this._popCount--;
            }
            this._children.unset(pos);
            this._level();
        }
        _level() {
            if (this._parent != null && this._popCount <= 1) {
                if (this._popCount === 1) {
                    const onlyChild = this._children.find(exists);
                    if (onlyChild != null && !(onlyChild instanceof Bucket)) {
                        const hash = onlyChild.hash;
                        hash.untake(this._options.bits);
                        const place = {
                            pos: this._posAtParent,
                            hash,
                            bucket: this._parent,
                        };
                        this._parent._putAt(place, onlyChild.key, onlyChild.value);
                    }
                }
                else {
                    this._parent._delAt(this._posAtParent);
                }
            }
        }
        _at(index) {
            return this._children.get(index);
        }
    };
    function exists(o) {
        return Boolean(o);
    }
    function mapNode(node, _) {
        return node.key;
    }
    function reduceNodes(nodes) {
        return nodes;
    }
    async function asyncTransformBucket(bucket, asyncMap, asyncReduce) {
        const output = [];
        for (const child of bucket._children.compactArray()) {
            if (child instanceof Bucket) {
                await asyncTransformBucket(child, asyncMap, asyncReduce);
            }
            else {
                const mappedChildren = await asyncMap(child);
                output.push({
                    bitField: bucket._children.bitField(),
                    children: mappedChildren,
                });
            }
        }
        return await asyncReduce(output);
    }
    // node_modules/hamt-sharding/dist/src/consumable-buffer.js
    var START_MASKS = [255, 254, 252, 248, 240, 224, 192, 128];
    var STOP_MASKS = [1, 3, 7, 15, 31, 63, 127, 255];
    var ConsumableBuffer = class {
        constructor(value) {
            this._value = value;
            this._currentBytePos = value.length - 1;
            this._currentBitPos = 7;
        }
        availableBits() {
            return this._currentBitPos + 1 + this._currentBytePos * 8;
        }
        totalBits() {
            return this._value.length * 8;
        }
        take(bits) {
            let pendingBits = bits;
            let result = 0;
            while (pendingBits > 0 && this._haveBits()) {
                const byte = this._value[this._currentBytePos];
                const availableBits = this._currentBitPos + 1;
                const taking = Math.min(availableBits, pendingBits);
                const value = byteBitsToInt(byte, availableBits - taking, taking);
                result = (result << taking) + value;
                pendingBits -= taking;
                this._currentBitPos -= taking;
                if (this._currentBitPos < 0) {
                    this._currentBitPos = 7;
                    this._currentBytePos--;
                }
            }
            return result;
        }
        untake(bits) {
            this._currentBitPos += bits;
            while (this._currentBitPos > 7) {
                this._currentBitPos -= 8;
                this._currentBytePos += 1;
            }
        }
        _haveBits() {
            return this._currentBytePos >= 0;
        }
    };
    function byteBitsToInt(byte, start, length2) {
        const mask = maskFor(start, length2);
        return (byte & mask) >>> start;
    }
    function maskFor(start, length2) {
        return START_MASKS[start] & STOP_MASKS[Math.min(length2 + start - 1, 7)];
    }
    // node_modules/hamt-sharding/dist/src/consumable-hash.js
    function wrapHash(hashFn) {
        function hashing(value) {
            if (value instanceof InfiniteHash) {
                return value;
            }
            else {
                return new InfiniteHash(value, hashFn);
            }
        }
        return hashing;
    }
    var InfiniteHash = class {
        constructor(value, hashFn) {
            if (!(value instanceof Uint8Array)) {
                throw new Error('can only hash Uint8Arrays');
            }
            this._value = value;
            this._hashFn = hashFn;
            this._depth = -1;
            this._availableBits = 0;
            this._currentBufferIndex = 0;
            this._buffers = [];
        }
        async take(bits) {
            let pendingBits = bits;
            while (this._availableBits < pendingBits) {
                await this._produceMoreBits();
            }
            let result = 0;
            while (pendingBits > 0) {
                const hash = this._buffers[this._currentBufferIndex];
                const available = Math.min(hash.availableBits(), pendingBits);
                const took = hash.take(available);
                result = (result << available) + took;
                pendingBits -= available;
                this._availableBits -= available;
                if (hash.availableBits() === 0) {
                    this._currentBufferIndex++;
                }
            }
            return result;
        }
        untake(bits) {
            let pendingBits = bits;
            while (pendingBits > 0) {
                const hash = this._buffers[this._currentBufferIndex];
                const availableForUntake = Math.min(hash.totalBits() - hash.availableBits(), pendingBits);
                hash.untake(availableForUntake);
                pendingBits -= availableForUntake;
                this._availableBits += availableForUntake;
                if (this._currentBufferIndex > 0 &&
                    hash.totalBits() === hash.availableBits()) {
                    this._depth--;
                    this._currentBufferIndex--;
                }
            }
        }
        async _produceMoreBits() {
            this._depth++;
            const value = this._depth > 0
                ? concat([this._value, Uint8Array.from([this._depth])])
                : this._value;
            const hashValue = await this._hashFn(value);
            const buffer = new ConsumableBuffer(hashValue);
            this._buffers.push(buffer);
            this._availableBits += buffer.availableBits();
        }
    };
    // node_modules/hamt-sharding/dist/src/index.js
    function createHAMT(options) {
        if (options == null || options.hashFn == null) {
            throw new Error('please define an options.hashFn');
        }
        const bucketOptions = {
            bits: options.bits ?? 8,
            hash: wrapHash(options.hashFn),
        };
        return new Bucket(bucketOptions);
    }
    // node_modules/ipfs-unixfs-importer/src/dir-sharded.js
    var DirSharded = class extends dir_default2 {
        /**
         * @param {DirProps} props
         * @param {ImporterOptions} options
         */
        constructor(props, options) {
            super(props, options);
            this._bucket = createHAMT({
                hashFn: options.hamtHashFn,
                bits: options.hamtBucketBits,
            });
        }
        /**
         * @param {string} name
         * @param {InProgressImportResult | Dir} value
         */
        async put(name4, value) {
            await this._bucket.put(name4, value);
        }
        /**
         * @param {string} name
         */
        get(name4) {
            return this._bucket.get(name4);
        }
        childCount() {
            return this._bucket.leafCount();
        }
        directChildrenCount() {
            return this._bucket.childrenCount();
        }
        onlyChild() {
            return this._bucket.onlyChild();
        }
        async *eachChildSeries() {
            for await (const { key, value } of this._bucket.eachLeafSeries()) {
                yield {
                    key,
                    child: value,
                };
            }
        }
        /**
         * @param {Blockstore} blockstore
         * @returns {AsyncIterable<ImportResult>}
         */
        async *flush(blockstore) {
            for await (const entry of flush(this._bucket, blockstore, this, this.options)) {
                yield {
                    ...entry,
                    path: this.path,
                };
            }
        }
    };
    var dir_sharded_default = DirSharded;
    async function* flush(bucket, blockstore, shardRoot, options) {
        const children = bucket._children;
        const links = [];
        let childrenSize = 0;
        for (let i = 0; i < children.length; i++) {
            const child = children.get(i);
            if (!child) {
                continue;
            }
            const labelPrefix = i.toString(16).toUpperCase().padStart(2, '0');
            if (child instanceof Bucket) {
                let shard;
                for await (const subShard of await flush(child, blockstore, null, options)) {
                    shard = subShard;
                }
                if (!shard) {
                    throw new Error('Could not flush sharded directory, no subshard found');
                }
                links.push({
                    Name: labelPrefix,
                    Tsize: shard.size,
                    Hash: shard.cid,
                });
                childrenSize += shard.size;
            }
            else if (typeof child.value.flush === 'function') {
                const dir2 = child.value;
                let flushedDir;
                for await (const entry of dir2.flush(blockstore)) {
                    flushedDir = entry;
                    yield flushedDir;
                }
                const label = labelPrefix + child.key;
                links.push({
                    Name: label,
                    Tsize: flushedDir.size,
                    Hash: flushedDir.cid,
                });
                childrenSize += flushedDir.size;
            }
            else {
                const value = child.value;
                if (!value.cid) {
                    continue;
                }
                const label = labelPrefix + child.key;
                const size2 = value.size;
                links.push({
                    Name: label,
                    Tsize: size2,
                    Hash: value.cid,
                });
                childrenSize += size2;
            }
        }
        const data = Uint8Array.from(children.bitField().reverse());
        const dir = new UnixFS({
            type: 'hamt-sharded-directory',
            data,
            fanout: bucket.tableSize(),
            hashType: options.hamtHashCode,
            mtime: shardRoot && shardRoot.mtime,
            mode: shardRoot && shardRoot.mode,
        });
        const node = {
            Data: dir.marshal(),
            Links: links,
        };
        const buffer = encode3(prepare(node));
        const cid = await persist_default(buffer, blockstore, options);
        const size = buffer.length + childrenSize;
        yield {
            cid,
            unixfs: dir,
            size,
        };
    }
    // node_modules/ipfs-unixfs-importer/src/flat-to-shard.js
    async function flatToShard(child, dir, threshold, options) {
        let newDir = dir;
        if (dir instanceof dir_flat_default &&
            dir.directChildrenCount() >= threshold) {
            newDir = await convertToShard(dir, options);
        }
        const parent = newDir.parent;
        if (parent) {
            if (newDir !== dir) {
                if (child) {
                    child.parent = newDir;
                }
                if (!newDir.parentKey) {
                    throw new Error('No parent key found');
                }
                await parent.put(newDir.parentKey, newDir);
            }
            return flatToShard(newDir, parent, threshold, options);
        }
        return newDir;
    }
    async function convertToShard(oldDir, options) {
        const newDir = new dir_sharded_default({
            root: oldDir.root,
            dir: true,
            parent: oldDir.parent,
            parentKey: oldDir.parentKey,
            path: oldDir.path,
            dirty: oldDir.dirty,
            flat: false,
            mtime: oldDir.mtime,
            mode: oldDir.mode,
        }, options);
        for await (const { key, child } of oldDir.eachChildSeries()) {
            await newDir.put(key, child);
        }
        return newDir;
    }
    var flat_to_shard_default = flatToShard;
    // node_modules/ipfs-unixfs-importer/src/utils/to-path-components.js
    var toPathComponents = (path = '') => {
        return (path.trim().match(/([^\\/]|\\\/)+/g) || []).filter(Boolean);
    };
    var to_path_components_default = toPathComponents;
    // node_modules/ipfs-unixfs-importer/src/tree-builder.js
    async function addToTree(elem, tree, options) {
        const pathElems = to_path_components_default(elem.path || '');
        const lastIndex = pathElems.length - 1;
        let parent = tree;
        let currentPath = '';
        for (let i = 0; i < pathElems.length; i++) {
            const pathElem = pathElems[i];
            currentPath += `${currentPath ? '/' : ''}${pathElem}`;
            const last = i === lastIndex;
            parent.dirty = true;
            parent.cid = void 0;
            parent.size = void 0;
            if (last) {
                await parent.put(pathElem, elem);
                tree = await flat_to_shard_default(null, parent, options.shardSplitThreshold, options);
            }
            else {
                let dir = await parent.get(pathElem);
                if (!dir || !(dir instanceof dir_default2)) {
                    dir = new dir_flat_default({
                        root: false,
                        dir: true,
                        parent,
                        parentKey: pathElem,
                        path: currentPath,
                        dirty: true,
                        flat: true,
                        mtime: dir && dir.unixfs && dir.unixfs.mtime,
                        mode: dir && dir.unixfs && dir.unixfs.mode,
                    }, options);
                }
                await parent.put(pathElem, dir);
                parent = dir;
            }
        }
        return tree;
    }
    async function* flushAndYield(tree, blockstore) {
        if (!(tree instanceof dir_default2)) {
            if (tree && tree.unixfs && tree.unixfs.isDirectory()) {
                yield tree;
            }
            return;
        }
        yield* tree.flush(blockstore);
    }
    async function* treeBuilder(source, block, options) {
        let tree = new dir_flat_default({
            root: true,
            dir: true,
            path: '',
            dirty: true,
            flat: true,
        }, options);
        for await (const entry of source) {
            if (!entry) {
                continue;
            }
            tree = await addToTree(entry, tree, options);
            if (!entry.unixfs || !entry.unixfs.isDirectory()) {
                yield entry;
            }
        }
        if (options.wrapWithDirectory) {
            yield* flushAndYield(tree, block);
        }
        else {
            for await (const unwrapped of tree.eachChildSeries()) {
                if (!unwrapped) {
                    continue;
                }
                yield* flushAndYield(unwrapped.child, block);
            }
        }
    }
    var tree_builder_default = treeBuilder;
    // node_modules/ipfs-unixfs-importer/src/index.js
    async function* importer(source, blockstore, options = {}) {
        const opts = options_default(options);
        let dagBuilder2;
        if (typeof options.dagBuilder === 'function') {
            dagBuilder2 = options.dagBuilder;
        }
        else {
            dagBuilder2 = dag_builder_default;
        }
        let treeBuilder2;
        if (typeof options.treeBuilder === 'function') {
            treeBuilder2 = options.treeBuilder;
        }
        else {
            treeBuilder2 = tree_builder_default;
        }
        let candidates;
        if (Symbol.asyncIterator in source || Symbol.iterator in source) {
            candidates = source;
        }
        else {
            candidates = [source];
        }
        for await (const entry of treeBuilder2(parallelBatch(dagBuilder2(candidates, blockstore, opts), opts.fileImportConcurrency), blockstore, opts)) {
            yield {
                cid: entry.cid,
                path: entry.path,
                unixfs: entry.unixfs,
                size: entry.size,
            };
        }
    }
    // node_modules/it-drain/dist/src/index.js
    async function drain(source) {
        for await (const _ of source) {
        }
    }
    // node_modules/it-filter/dist/src/index.js
    async function* filter(source, fn) {
        for await (const entry of source) {
            if (await fn(entry)) {
                yield entry;
            }
        }
    }
    // node_modules/it-take/dist/src/index.js
    async function* take(source, limit) {
        let items = 0;
        if (limit < 1) {
            return;
        }
        for await (const entry of source) {
            yield entry;
            items++;
            if (items === limit) {
                return;
            }
        }
    }
    // node_modules/blockstore-core/src/base.js
    var sortAll = (iterable, sorter) => {
        return (async function* () {
            const values = await all(iterable);
            yield* values.sort(sorter);
        })();
    };
    var BaseBlockstore = class {
        /**
         * @returns {Promise<void>}
         */
        open() {
            return Promise.reject(new Error('.open is not implemented'));
        }
        /**
         * @returns {Promise<void>}
         */
        close() {
            return Promise.reject(new Error('.close is not implemented'));
        }
        /**
         * @param {CID} key
         * @param {Uint8Array} val
         * @param {Options} [options]
         * @returns {Promise<void>}
         */
        put(key, val, options) {
            return Promise.reject(new Error('.put is not implemented'));
        }
        /**
         * @param {CID} key
         * @param {Options} [options]
         * @returns {Promise<Uint8Array>}
         */
        get(key, options) {
            return Promise.reject(new Error('.get is not implemented'));
        }
        /**
         * @param {CID} key
         * @param {Options} [options]
         * @returns {Promise<boolean>}
         */
        has(key, options) {
            return Promise.reject(new Error('.has is not implemented'));
        }
        /**
         * @param {CID} key
         * @param {Options} [options]
         * @returns {Promise<void>}
         */
        delete(key, options) {
            return Promise.reject(new Error('.delete is not implemented'));
        }
        /**
         * @param {AwaitIterable<Pair>} source
         * @param {Options} [options]
         * @returns {AsyncIterable<Pair>}
         */
        async *putMany(source, options = {}) {
            for await (const { key, value } of source) {
                await this.put(key, value, options);
                yield { key, value };
            }
        }
        /**
         * @param {AwaitIterable<CID>} source
         * @param {Options} [options]
         * @returns {AsyncIterable<Uint8Array>}
         */
        async *getMany(source, options = {}) {
            for await (const key of source) {
                yield this.get(key, options);
            }
        }
        /**
         * @param {AwaitIterable<CID>} source
         * @param {Options} [options]
         * @returns {AsyncIterable<CID>}
         */
        async *deleteMany(source, options = {}) {
            for await (const key of source) {
                await this.delete(key, options);
                yield key;
            }
        }
        /**
         * @returns {Batch}
         */
        batch() {
            let puts = [];
            let dels = [];
            return {
                put(key, value) {
                    puts.push({ key, value });
                },
                delete(key) {
                    dels.push(key);
                },
                commit: async (options) => {
                    await drain(this.putMany(puts, options));
                    puts = [];
                    await drain(this.deleteMany(dels, options));
                    dels = [];
                },
            };
        }
        /**
         * Extending classes should override `query` or implement this method
         *
         * @param {Query} q
         * @param {Options} [options]
         * @returns {AsyncIterable<Pair>}
         */
        // eslint-disable-next-line require-yield
        async *_all(q, options) {
            throw new Error('._all is not implemented');
        }
        /**
         * Extending classes should override `queryKeys` or implement this method
         *
         * @param {KeyQuery} q
         * @param {Options} [options]
         * @returns {AsyncIterable<CID>}
         */
        // eslint-disable-next-line require-yield
        async *_allKeys(q, options) {
            throw new Error('._allKeys is not implemented');
        }
        /**
         * @param {Query} q
         * @param {Options} [options]
         */
        query(q, options) {
            let it = this._all(q, options);
            if (q.prefix != null) {
                it = filter(it, (e) => e.key.toString().startsWith(q.prefix || ''));
            }
            if (Array.isArray(q.filters)) {
                it = q.filters.reduce((it2, f) => filter(it2, f), it);
            }
            if (Array.isArray(q.orders)) {
                it = q.orders.reduce((it2, f) => sortAll(it2, f), it);
            }
            if (q.offset != null) {
                let i = 0;
                it = filter(it, () => i++ >= (q.offset || 0));
            }
            if (q.limit != null) {
                it = take(it, q.limit);
            }
            return it;
        }
        /**
         * @param {KeyQuery} q
         * @param {Options} [options]
         */
        queryKeys(q, options) {
            let it = this._allKeys(q, options);
            if (q.prefix != null) {
                it = filter(it, (cid) => cid.toString().startsWith(q.prefix || ''));
            }
            if (Array.isArray(q.filters)) {
                it = q.filters.reduce((it2, f) => filter(it2, f), it);
            }
            if (Array.isArray(q.orders)) {
                it = q.orders.reduce((it2, f) => sortAll(it2, f), it);
            }
            if (q.offset != null) {
                let i = 0;
                it = filter(it, () => i++ >= /** @type {number} */ q.offset);
            }
            if (q.limit != null) {
                it = take(it, q.limit);
            }
            return it;
        }
    };
    // node_modules/blockstore-core/src/errors.js
    var import_err_code6 = __toESM(require_err_code(), 1);
    function notFoundError(err) {
        err = err || new Error('Not Found');
        return (0, import_err_code6.default)(err, 'ERR_NOT_FOUND');
    }
    // node_modules/blockstore-core/src/memory.js
    var MemoryBlockstore = class extends BaseBlockstore {
        constructor() {
            super();
            this.data = {};
        }
        open() {
            return Promise.resolve();
        }
        close() {
            return Promise.resolve();
        }
        /**
         * @param {CID} key
         * @param {Uint8Array} val
         */
        async put(key, val) {
            this.data[base32.encode(key.multihash.bytes)] = val;
        }
        /**
         * @param {CID} key
         */
        async get(key) {
            const exists2 = await this.has(key);
            if (!exists2)
                throw notFoundError();
            return this.data[base32.encode(key.multihash.bytes)];
        }
        /**
         * @param {CID} key
         */
        async has(key) {
            return this.data[base32.encode(key.multihash.bytes)] !== void 0;
        }
        /**
         * @param {CID} key
         */
        async delete(key) {
            delete this.data[base32.encode(key.multihash.bytes)];
        }
        async *_all() {
            yield* Object.entries(this.data).map(([key, value]) => ({
                key: CID.createV1(code2, decode3(base32.decode(key))),
                value,
            }));
        }
        async *_allKeys() {
            yield* Object.entries(this.data).map(([key]) => CID.createV1(code2, decode3(base32.decode(key))));
        }
    };
    return __toCommonJS(es_bundler_exports);
})();
//# sourceMappingURL=ipfs-bundled-sdk.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/misc-browser/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/misc-browser/src/lib/misc-browser.js"), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/misc-browser/src/lib/misc-browser.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.injectViewerIFrame = exports.downloadFile = exports.fileToDataUrl = exports.base64StringToBlob = exports.blobToBase64String = exports.getStorageItem = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const uint8arrays_1 = __webpack_require__("../../node_modules/@lit-protocol/uint8arrays/src/index.js");
/**
 *
 * Get the local storage item by key
 *
 * @param { string } key
 */
const getStorageItem = (key) => {
    let item;
    try {
        item = localStorage.getItem(key);
    }
    catch (e) {
        // swallowing
    }
    let keyOrError;
    if (!item) {
        keyOrError = (0, constants_1.ELeft)({
            message: `Failed to get ${key} from local storage`,
            errorKind: constants_1.LIT_ERROR.LOCAL_STORAGE_ITEM_NOT_FOUND_EXCEPTION.kind,
            errorCode: constants_1.LIT_ERROR.LOCAL_STORAGE_ITEM_NOT_FOUND_EXCEPTION.name,
        });
    }
    else {
        keyOrError = (0, constants_1.ERight)(item);
    }
    return keyOrError;
};
exports.getStorageItem = getStorageItem;
/**
 * Convert a Blob to a base64urlpad string.  Note: This function returns a promise.
 *
 * @param { Blob | File } blob The Blob or File to turn into a base64 string
 * @returns { Promise<string> } A promise that resolves to the base64 string
 */
const blobToBase64String = async (blob) => {
    const arrayBuffer = await blob.arrayBuffer();
    const uint8array = new Uint8Array(arrayBuffer);
    return (0, uint8arrays_1.uint8arrayToString)(uint8array, 'base64urlpad');
};
exports.blobToBase64String = blobToBase64String;
/**
 *
 * Convert a base64urlpad string to a Blob.
 * Note: This function DOES NOT return a promise
 *
 * @param { string } base64String The base64 string that to turn into a Blob
 * @returns { Blob }  A blob that contains the decoded base64 data
 */
const base64StringToBlob = (base64String) => {
    return new Blob([(0, uint8arrays_1.uint8arrayFromString)(base64String, 'base64urlpad')]);
};
exports.base64StringToBlob = base64StringToBlob;
/**
 *
 * Convert a file to a data URL, which could then be embedded in a LIT.
 * A data URL is a string representation of a file.
 *
 * @param { File } file The file to turn into a data url
 * @returns { string } The data URL.  This is a string representation that can be used anywhere the original file would be used.
 */
const fileToDataUrl = (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            resolve(reader.result);
        };
        reader.readAsDataURL(file);
    });
};
exports.fileToDataUrl = fileToDataUrl;
/**
 *
 * // TEST: downloadFile
 * Download a file in memory to the user's computer
 *
 * @param { Object } params
 * @property { string } filename The name of the file
 * @property { Uint8Array } data The actual file itself as a Uint8Array
 * @property { string } mimetype The mime type of the file
 *
 * @returns { void } The data URL.  This is a string representation that can be used anywhere the original file would be used.
 *
 */
const downloadFile = ({ fileName, data, mimeType, }) => {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:' + mimeType + ';base64,' + (0, uint8arrays_1.uint8arrayToString)(data, 'base64'));
    element.setAttribute('download', fileName);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
};
exports.downloadFile = downloadFile;
/**
 *
 * // TEST: injectViewerIFrame
 * Inject an iFrame into the current page that will display a LIT.
 * This function safely sandboxes the content in the iFrame so that the LIT cannot see cookies or localStorage of the parent website.
 *
 * @param { Object } params
 * @property { string } destinationId The DOM ID of the element to inject the iFrame into
 * @property { string } title The title of the content being displayed
 * @property { string } fileUrl The URL of the content that will be shown in the iFrame
 * @property { string } className An optional DOM class name to add to the iFrame for styling
 *
 * @returns { void }
 */
const injectViewerIFrame = ({ destinationId, title, fileUrl, className, }) => {
    if (fileUrl.includes('data:')) {
        // data urls are not safe, refuse to do this
        throw new Error('You can not inject an iFrame with a data url.  Try a regular https URL.');
    }
    const url = new URL(fileUrl);
    if (url.host.toLowerCase() === window.location.host.toLowerCase()) {
        throw new Error('You cannot host a LIT on the same domain as the parent webpage.  This is because iFrames with the same origin have access to localstorage and cookies in the parent webpage which is unsafe');
    }
    const iframe = Object.assign(document.createElement('iframe'), {
        src: fileUrl,
        title: title,
        sandbox: 'allow-forms allow-scripts allow-popups  allow-modals allow-popups-to-escape-sandbox allow-same-origin',
        loading: 'lazy',
        allow: 'accelerometer; ambient-light-sensor; autoplay; battery; camera; display-capture; encrypted-media; fullscreen; geolocation; gyroscope; layout-animations; legacy-image-formats; magnetometer; microphone; midi; payment; picture-in-picture; publickey-credentials-get; sync-xhr; usb; vr; screen-wake-lock; web-share; xr-spatial-tracking',
    });
    if (className) {
        iframe.className = className;
    }
    document.getElementById(destinationId)?.appendChild(iframe);
};
exports.injectViewerIFrame = injectViewerIFrame;
//# sourceMappingURL=misc-browser.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/misc/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/misc/src/lib/misc.js"), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/misc/src/lib/misc.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.genRandomPath = exports.decimalPlaces = exports.isBrowser = exports.isNode = exports.convertLitActionsParams = exports.is = exports.numberToHex = exports.sortedObject = exports.checkIfAuthSigRequiresChainParam = exports.checkType = exports.getVarType = exports.log = exports.throwRemovedFunctionError = exports.isNodeErrorV0 = exports.isNodeErrorV1 = exports.isNodeClientErrorV0 = exports.isNodeClientErrorV1 = exports.throwGenericError = exports.throwErrorV1 = exports.throwErrorV0 = exports.throwError = exports.mostCommonString = exports.printError = void 0;
const constants_1 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const providers_1 = __webpack_require__("../../node_modules/@ethersproject/providers/lib.esm/index.js");
const contracts_1 = __webpack_require__("../../node_modules/@ethersproject/contracts/lib.esm/index.js");
const constants_2 = __webpack_require__("../../node_modules/@lit-protocol/constants/src/index.js");
const logBuffer = [];
/**
 *
 * Print error message based on Error interface
 *
 * @param { Error } e
 * @returns { void }
 */
const printError = (e) => {
    console.log('Error Stack', e.stack);
    console.log('Error Name', e.name);
    console.log('Error Message', e.message);
};
exports.printError = printError;
/**
 *
 * Find the element that occurs the most in an array
 *
 * @param { Array<any> } arr
 * @returns { any } the element that appeared the most
 */
const mostCommonString = (arr) => {
    return arr
        .sort((a, b) => arr.filter((v) => v === a).length -
        arr.filter((v) => v === b).length)
        .pop();
};
exports.mostCommonString = mostCommonString;
const throwError = (e) => {
    if ((0, exports.isNodeClientErrorV1)(e)) {
        return (0, exports.throwErrorV1)(e);
    }
    else if ((0, exports.isNodeClientErrorV0)(e)) {
        return (0, exports.throwErrorV0)(e);
    }
    return (0, exports.throwGenericError)(e);
};
exports.throwError = throwError;
/**
 *
 * Standardized way to throw error in Lit Protocol projects
 *
 * @deprecated use throwErrorV1
 * @param { ILitError }
 * @property { string } message
 * @property { string } name
 * @property { string } errorCode
 */
const throwErrorV0 = ({ message, name, errorCode, error, }) => {
    const errConstructorFunc = function (message, name, errorCode) {
        this.message = message;
        this.name = name;
        // Map old error codes to new ones if possible.
        this.errorCode = oldErrorToNewErrorMap[errorCode] ?? errorCode;
    };
    throw new errConstructorFunc(message, (name = error?.name ?? name), (errorCode = error?.code ?? errorCode));
};
exports.throwErrorV0 = throwErrorV0;
// Map for old error codes to new ones
const oldErrorToNewErrorMap = {
    not_authorized: 'NodeNotAuthorized',
    storage_error: 'NodeStorageError',
};
/**
 *
 * Standardized way to throw error in Lit Protocol projects
 *
 */
const throwErrorV1 = ({ errorKind, details, status, message, errorCode, }) => {
    const errConstructorFunc = function (errorKind, status, details, message, errorCode) {
        this.message = message;
        this.errorCode = errorCode;
        this.errorKind = errorKind;
        this.status = status;
        this.details = details;
    };
    throw new errConstructorFunc(errorKind, status, details, message, errorCode);
};
exports.throwErrorV1 = throwErrorV1;
const throwGenericError = (e) => {
    const errConstructorFunc = function (message) {
        this.message = message;
        this.errorKind = constants_1.LIT_ERROR.UNKNOWN_ERROR.name;
        this.errorCode = constants_1.LIT_ERROR.UNKNOWN_ERROR.code;
    };
    throw new errConstructorFunc(e.message ?? 'Generic Error');
};
exports.throwGenericError = throwGenericError;
const isNodeClientErrorV1 = (nodeError) => {
    return (nodeError.hasOwnProperty('errorCode') &&
        nodeError.hasOwnProperty('errorKind'));
};
exports.isNodeClientErrorV1 = isNodeClientErrorV1;
const isNodeClientErrorV0 = (nodeError) => {
    return nodeError.hasOwnProperty('errorCode');
};
exports.isNodeClientErrorV0 = isNodeClientErrorV0;
const isNodeErrorV1 = (nodeError) => {
    return (nodeError.hasOwnProperty('errorCode') &&
        nodeError.hasOwnProperty('errorKind'));
};
exports.isNodeErrorV1 = isNodeErrorV1;
const isNodeErrorV0 = (nodeError) => {
    return nodeError.hasOwnProperty('errorCode');
};
exports.isNodeErrorV0 = isNodeErrorV0;
const throwRemovedFunctionError = (functionName) => {
    (0, exports.throwError)({
        message: `This function "${functionName}" has been removed. Please use the old SDK.`,
        errorKind: constants_1.LIT_ERROR.REMOVED_FUNCTION_ERROR.kind,
        errorCode: constants_1.LIT_ERROR.REMOVED_FUNCTION_ERROR.name,
    });
};
exports.throwRemovedFunctionError = throwRemovedFunctionError;
/**
 *
 * console.log but prepend [Lit-JS-SDK] before the message
 *
 * @param { any } args
 *
 * @returns { void }
 */
const log = (...args) => {
    // append the prefix
    args.unshift(`[Lit-JS-SDK v${constants_2.version}]`);
    if (!globalThis) {
        // there is no globalThis, just print the log
        console.log(...args);
        return;
    }
    // check if config is loaded yet
    if (!globalThis?.litConfig) {
        // config isn't loaded yet, push into buffer
        logBuffer.push(args);
        return;
    }
    if (globalThis?.litConfig?.debug !== true) {
        return;
    }
    // config is loaded, and debug is true
    // if there are there are logs in buffer, print them first and empty the buffer.
    while (logBuffer.length > 0) {
        const log = logBuffer.shift() ?? '';
        console.log(...log);
    }
    console.log(...args);
};
exports.log = log;
/**
 *
 * Get the type of a variable, could be an object instance type.
 * eg Uint8Array instance should return 'Uint8Array` as string
 * or simply a `string` or `int` type
 *
 * @param { any } value
 * @returns { string } type
 */
const getVarType = (value) => {
    return Object.prototype.toString.call(value).slice(8, -1);
};
exports.getVarType = getVarType;
/**
 *
 *  Check if the given value is the given type
 *  If not, throw `invalidParamType` error
 *
 * @property { any } value
 * @property { Array<String> } allowedTypes
 * @property { string } paramName
 * @property { string } functionName
 * @property { boolean } throwOnError
 *
 * @returns { Boolean } true/false
 *
 */
const checkType = ({ value, allowedTypes, paramName, functionName, throwOnError = true, }) => {
    // -- validate
    if (!allowedTypes.includes((0, exports.getVarType)(value))) {
        const message = `Expecting ${allowedTypes.join(' or ')} type for parameter named ${paramName} in Lit-JS-SDK function ${functionName}(), but received "${(0, exports.getVarType)(value)}" type instead. value: ${value instanceof Object ? JSON.stringify(value) : value}`;
        if (throwOnError) {
            (0, exports.throwError)({
                message,
                errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
            });
        }
        return false;
    }
    // -- else
    return true;
};
exports.checkType = checkType;
/**
 *
 * @param { AuthSig } authSig
 * @param { string } chain
 * @param { string } functionName
 *
 * @returns { boolean }
 */
const checkIfAuthSigRequiresChainParam = (authSig, chain, functionName) => {
    (0, exports.log)('checkIfAuthSigRequiresChainParam');
    for (const key of constants_1.LIT_AUTH_SIG_CHAIN_KEYS) {
        if (key in authSig) {
            return true;
        }
    }
    // if we're here, then we need the chain param
    if (!(0, exports.checkType)({
        value: chain,
        allowedTypes: ['String'],
        paramName: 'chain',
        functionName,
    })) {
        return false;
    }
    return true;
};
exports.checkIfAuthSigRequiresChainParam = checkIfAuthSigRequiresChainParam;
/**
 * TODO: Fix "any"
 * Sort object
 *
 * @param { any } obj
 * @returns { any }
 */
const sortedObject = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map(exports.sortedObject);
    }
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key) => {
        result[key] = (0, exports.sortedObject)(obj[key]);
    });
    return result;
};
exports.sortedObject = sortedObject;
/**
 *
 * Convert number to hex
 * @param { number } v
 * @return { string } hex value prexied with 0x
 */
const numberToHex = (v) => {
    return '0x' + v.toString(16);
};
exports.numberToHex = numberToHex;
/**
 *
 *  Check if the given value is the given type
 *  If not, throw `invalidParamType` error
 *
 * @param { any } value
 * @param { string } type
 * @param { string } paramName
 * @param { string } functionName
 * @returns { Boolean } true/false
 */
const is = (value, type, paramName, functionName, throwOnError = true) => {
    if ((0, exports.getVarType)(value) !== type) {
        let message = `Expecting "${type}" type for parameter named ${paramName} in Lit-JS-SDK function ${functionName}(), but received "${(0, exports.getVarType)(value)}" type instead. value: ${value instanceof Object ? JSON.stringify(value) : value}`;
        if (throwOnError) {
            (0, exports.throwError)({
                message,
                errorKind: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.kind,
                errorCode: constants_1.LIT_ERROR.INVALID_PARAM_TYPE.name,
            });
        }
        return false;
    }
    return true;
};
exports.is = is;
/**
 * Convert types before sending to Lit Actions as jsParams, some JS types don't serialize well, so we will convert them before sending to the nodes
 *
 * @param { object } params.jsParams The jsParams you are sending
 * @returns { object } The jsParams object, but with any incompatible types automatically converted
 */
const convertLitActionsParams = (jsParams) => {
    // -- property
    const convertedParams = {};
    // -- execute
    for (const [key, value] of Object.entries(jsParams)) {
        const _key = key;
        const _value = value;
        // -- get value type
        const varType = (0, exports.getVarType)(_value);
        // -- case: Unit8Array
        if (varType === 'Uint8Array') {
            convertedParams[_key] = Array.from(_value);
            // -- case: Object, recurse over any objects
        }
        else if (varType === 'Object') {
            convertedParams[_key] = (0, exports.convertLitActionsParams)(_value);
        }
        // -- default
        else {
            convertedParams[_key] = _value;
        }
    }
    return convertedParams;
};
exports.convertLitActionsParams = convertLitActionsParams;
const isNode = () => {
    var isNode = false;
    // @ts-ignore
    if (typeof process === 'object') {
        // @ts-ignore
        if (typeof process.versions === 'object') {
            // @ts-ignore
            if (typeof process.versions.node !== 'undefined') {
                isNode = true;
            }
        }
    }
    return isNode;
};
exports.isNode = isNode;
const isBrowser = () => {
    return (0, exports.isNode)() === false;
};
exports.isBrowser = isBrowser;
/**
 *
 * Get the number of decimal places in a token
 *
 * @property { string } contractAddress The token contract address
 * @property { string } chain The chain on which the token is deployed
 *
 * @returns { number } The number of decimal places in the token
 */
const decimalPlaces = async ({ contractAddress, chain, }) => {
    const rpcUrl = constants_1.LIT_CHAINS[chain].rpcUrls[0];
    const web3 = new providers_1.JsonRpcProvider(rpcUrl);
    const contract = new contracts_1.Contract(contractAddress, constants_1.ABI_ERC20.abi, web3);
    return await contract['decimals']();
};
exports.decimalPlaces = decimalPlaces;
/**
 *
 * Generate a random path (for testing)
 *
 * @returns { string } The random path
 */
const genRandomPath = () => {
    return ('/' +
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15));
};
exports.genRandomPath = genRandomPath;
//# sourceMappingURL=misc.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/nacl/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__("../../node_modules/tslib/tslib.es6.js");
tslib_1.__exportStar(__webpack_require__("../../node_modules/@lit-protocol/nacl/src/lib/nacl.js"), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/nacl/src/lib/nacl.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/* provided dependency */ var process = __webpack_require__("../../node_modules/process/browser.js");

// @ts-nocheck
// Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
// Public domain.
//
// Implementation derived from TweetNaCl version 20140427.
// See for details: http://tweet_nacl.cr.yp.to/
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.nacl = void 0;
var u64 = function (h, l) {
    this.hi = h | (0 >>> 0);
    this.lo = l | (0 >>> 0);
};
var gf = function (init) {
    var i, r = new Float64Array(16);
    if (init)
        for (i = 0; i < init.length; i++)
            r[i] = init[i];
    return r;
};
//  Pluggable, initialized in high-level API below.
var randombytes = function ( /* x, n */) {
    throw new Error('no PRNG');
};
var _0 = new Uint8Array(16);
var _9 = new Uint8Array(32);
_9[0] = 9;
var gf0 = gf(), gf1 = gf([1]), _121665 = gf([0xdb41, 1]), D = gf([
    0x78a3, 0x1359, 0x4dca, 0x75eb, 0xd8ab, 0x4141, 0x0a4d, 0x0070, 0xe898,
    0x7779, 0x4079, 0x8cc7, 0xfe73, 0x2b6f, 0x6cee, 0x5203,
]), D2 = gf([
    0xf159, 0x26b2, 0x9b94, 0xebd6, 0xb156, 0x8283, 0x149a, 0x00e0, 0xd130,
    0xeef3, 0x80f2, 0x198e, 0xfce7, 0x56df, 0xd9dc, 0x2406,
]), X = gf([
    0xd51a, 0x8f25, 0x2d60, 0xc956, 0xa7b2, 0x9525, 0xc760, 0x692c, 0xdc5c,
    0xfdd6, 0xe231, 0xc0a4, 0x53fe, 0xcd6e, 0x36d3, 0x2169,
]), Y = gf([
    0x6658, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666,
    0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666, 0x6666,
]), I = gf([
    0xa0b0, 0x4a0e, 0x1b27, 0xc4ee, 0xe478, 0xad2f, 0x1806, 0x2f43, 0xd7a7,
    0x3dfb, 0x0099, 0x2b4d, 0xdf0b, 0x4fc1, 0x2480, 0x2b83,
]);
function L32(x, c) {
    return (x << c) | (x >>> (32 - c));
}
function ld32(x, i) {
    var u = x[i + 3] & 0xff;
    u = (u << 8) | (x[i + 2] & 0xff);
    u = (u << 8) | (x[i + 1] & 0xff);
    return (u << 8) | (x[i + 0] & 0xff);
}
function dl64(x, i) {
    var h = (x[i] << 24) | (x[i + 1] << 16) | (x[i + 2] << 8) | x[i + 3];
    var l = (x[i + 4] << 24) | (x[i + 5] << 16) | (x[i + 6] << 8) | x[i + 7];
    return new u64(h, l);
}
function st32(x, j, u) {
    var i;
    for (i = 0; i < 4; i++) {
        x[j + i] = u & 255;
        u >>>= 8;
    }
}
function ts64(x, i, u) {
    x[i] = (u.hi >> 24) & 0xff;
    x[i + 1] = (u.hi >> 16) & 0xff;
    x[i + 2] = (u.hi >> 8) & 0xff;
    x[i + 3] = u.hi & 0xff;
    x[i + 4] = (u.lo >> 24) & 0xff;
    x[i + 5] = (u.lo >> 16) & 0xff;
    x[i + 6] = (u.lo >> 8) & 0xff;
    x[i + 7] = u.lo & 0xff;
}
function vn(x, xi, y, yi, n) {
    var i, d = 0;
    for (i = 0; i < n; i++)
        d |= x[xi + i] ^ y[yi + i];
    return (1 & ((d - 1) >>> 8)) - 1;
}
function crypto_verify_16(x, xi, y, yi) {
    return vn(x, xi, y, yi, 16);
}
function crypto_verify_32(x, xi, y, yi) {
    return vn(x, xi, y, yi, 32);
}
function core(out, inp, k, c, h) {
    var w = new Uint32Array(16), x = new Uint32Array(16), y = new Uint32Array(16), t = new Uint32Array(4);
    var i, j, m;
    for (i = 0; i < 4; i++) {
        x[5 * i] = ld32(c, 4 * i);
        x[1 + i] = ld32(k, 4 * i);
        x[6 + i] = ld32(inp, 4 * i);
        x[11 + i] = ld32(k, 16 + 4 * i);
    }
    for (i = 0; i < 16; i++)
        y[i] = x[i];
    for (i = 0; i < 20; i++) {
        for (j = 0; j < 4; j++) {
            for (m = 0; m < 4; m++)
                t[m] = x[(5 * j + 4 * m) % 16];
            t[1] ^= L32((t[0] + t[3]) | 0, 7);
            t[2] ^= L32((t[1] + t[0]) | 0, 9);
            t[3] ^= L32((t[2] + t[1]) | 0, 13);
            t[0] ^= L32((t[3] + t[2]) | 0, 18);
            for (m = 0; m < 4; m++)
                w[4 * j + ((j + m) % 4)] = t[m];
        }
        for (m = 0; m < 16; m++)
            x[m] = w[m];
    }
    if (h) {
        for (i = 0; i < 16; i++)
            x[i] = (x[i] + y[i]) | 0;
        for (i = 0; i < 4; i++) {
            x[5 * i] = (x[5 * i] - ld32(c, 4 * i)) | 0;
            x[6 + i] = (x[6 + i] - ld32(inp, 4 * i)) | 0;
        }
        for (i = 0; i < 4; i++) {
            st32(out, 4 * i, x[5 * i]);
            st32(out, 16 + 4 * i, x[6 + i]);
        }
    }
    else {
        for (i = 0; i < 16; i++)
            st32(out, 4 * i, (x[i] + y[i]) | 0);
    }
}
function crypto_core_salsa20(out, inp, k, c) {
    core(out, inp, k, c, false);
    return 0;
}
function crypto_core_hsalsa20(out, inp, k, c) {
    core(out, inp, k, c, true);
    return 0;
}
var sigma = new Uint8Array([
    101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107,
]);
// "expand 32-byte k"
function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
    var z = new Uint8Array(16), x = new Uint8Array(64);
    var u, i;
    if (!b)
        return 0;
    for (i = 0; i < 16; i++)
        z[i] = 0;
    for (i = 0; i < 8; i++)
        z[i] = n[i];
    while (b >= 64) {
        crypto_core_salsa20(x, z, k, sigma);
        for (i = 0; i < 64; i++)
            c[cpos + i] = (m ? m[mpos + i] : 0) ^ x[i];
        u = 1;
        for (i = 8; i < 16; i++) {
            u = (u + (z[i] & 0xff)) | 0;
            z[i] = u & 0xff;
            u >>>= 8;
        }
        b -= 64;
        cpos += 64;
        if (m)
            mpos += 64;
    }
    if (b > 0) {
        crypto_core_salsa20(x, z, k, sigma);
        for (i = 0; i < b; i++)
            c[cpos + i] = (m ? m[mpos + i] : 0) ^ x[i];
    }
    return 0;
}
function crypto_stream_salsa20(c, cpos, d, n, k) {
    return crypto_stream_salsa20_xor(c, cpos, null, 0, d, n, k);
}
function crypto_stream(c, cpos, d, n, k) {
    var s = new Uint8Array(32);
    crypto_core_hsalsa20(s, n, k, sigma);
    return crypto_stream_salsa20(c, cpos, d, n.subarray(16), s);
}
function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
    var s = new Uint8Array(32);
    crypto_core_hsalsa20(s, n, k, sigma);
    return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, n.subarray(16), s);
}
function add1305(h, c) {
    var j, u = 0;
    for (j = 0; j < 17; j++) {
        u = (u + ((h[j] + c[j]) | 0)) | 0;
        h[j] = u & 255;
        u >>>= 8;
    }
}
var minusp = new Uint32Array([
    5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 252,
]);
function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
    var s, i, j, u;
    var x = new Uint32Array(17), r = new Uint32Array(17), h = new Uint32Array(17), c = new Uint32Array(17), g = new Uint32Array(17);
    for (j = 0; j < 17; j++)
        r[j] = h[j] = 0;
    for (j = 0; j < 16; j++)
        r[j] = k[j];
    r[3] &= 15;
    r[4] &= 252;
    r[7] &= 15;
    r[8] &= 252;
    r[11] &= 15;
    r[12] &= 252;
    r[15] &= 15;
    while (n > 0) {
        for (j = 0; j < 17; j++)
            c[j] = 0;
        for (j = 0; j < 16 && j < n; ++j)
            c[j] = m[mpos + j];
        c[j] = 1;
        mpos += j;
        n -= j;
        add1305(h, c);
        for (i = 0; i < 17; i++) {
            x[i] = 0;
            for (j = 0; j < 17; j++)
                x[i] =
                    (x[i] + h[j] * (j <= i ? r[i - j] : (320 * r[i + 17 - j]) | 0)) |
                        0 |
                        0;
        }
        for (i = 0; i < 17; i++)
            h[i] = x[i];
        u = 0;
        for (j = 0; j < 16; j++) {
            u = (u + h[j]) | 0;
            h[j] = u & 255;
            u >>>= 8;
        }
        u = (u + h[16]) | 0;
        h[16] = u & 3;
        u = (5 * (u >>> 2)) | 0;
        for (j = 0; j < 16; j++) {
            u = (u + h[j]) | 0;
            h[j] = u & 255;
            u >>>= 8;
        }
        u = (u + h[16]) | 0;
        h[16] = u;
    }
    for (j = 0; j < 17; j++)
        g[j] = h[j];
    add1305(h, minusp);
    s = -(h[16] >>> 7) | 0;
    for (j = 0; j < 17; j++)
        h[j] ^= s & (g[j] ^ h[j]);
    for (j = 0; j < 16; j++)
        c[j] = k[j + 16];
    c[16] = 0;
    add1305(h, c);
    for (j = 0; j < 16; j++)
        out[outpos + j] = h[j];
    return 0;
}
function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
    var x = new Uint8Array(16);
    crypto_onetimeauth(x, 0, m, mpos, n, k);
    return crypto_verify_16(h, hpos, x, 0);
}
function crypto_secretbox(c, m, d, n, k) {
    var i;
    if (d < 32)
        return -1;
    crypto_stream_xor(c, 0, m, 0, d, n, k);
    crypto_onetimeauth(c, 16, c, 32, d - 32, c);
    for (i = 0; i < 16; i++)
        c[i] = 0;
    return 0;
}
function crypto_secretbox_open(m, c, d, n, k) {
    var i;
    var x = new Uint8Array(32);
    if (d < 32)
        return -1;
    crypto_stream(x, 0, 32, n, k);
    if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0)
        return -1;
    crypto_stream_xor(m, 0, c, 0, d, n, k);
    for (i = 0; i < 32; i++)
        m[i] = 0;
    return 0;
}
function set25519(r, a) {
    var i;
    for (i = 0; i < 16; i++)
        r[i] = a[i] | 0;
}
function car25519(o) {
    var c;
    var i;
    for (i = 0; i < 16; i++) {
        o[i] += 65536;
        c = Math.floor(o[i] / 65536);
        o[(i + 1) * (i < 15 ? 1 : 0)] += c - 1 + 37 * (c - 1) * (i === 15 ? 1 : 0);
        o[i] -= c * 65536;
    }
}
function sel25519(p, q, b) {
    var t, c = ~(b - 1);
    for (var i = 0; i < 16; i++) {
        t = c & (p[i] ^ q[i]);
        p[i] ^= t;
        q[i] ^= t;
    }
}
function pack25519(o, n) {
    var i, j, b;
    var m = gf(), t = gf();
    for (i = 0; i < 16; i++)
        t[i] = n[i];
    car25519(t);
    car25519(t);
    car25519(t);
    for (j = 0; j < 2; j++) {
        m[0] = t[0] - 0xffed;
        for (i = 1; i < 15; i++) {
            m[i] = t[i] - 0xffff - ((m[i - 1] >> 16) & 1);
            m[i - 1] &= 0xffff;
        }
        m[15] = t[15] - 0x7fff - ((m[14] >> 16) & 1);
        b = (m[15] >> 16) & 1;
        m[14] &= 0xffff;
        sel25519(t, m, 1 - b);
    }
    for (i = 0; i < 16; i++) {
        o[2 * i] = t[i] & 0xff;
        o[2 * i + 1] = t[i] >> 8;
    }
}
function neq25519(a, b) {
    var c = new Uint8Array(32), d = new Uint8Array(32);
    pack25519(c, a);
    pack25519(d, b);
    return crypto_verify_32(c, 0, d, 0);
}
function par25519(a) {
    var d = new Uint8Array(32);
    pack25519(d, a);
    return d[0] & 1;
}
function unpack25519(o, n) {
    var i;
    for (i = 0; i < 16; i++)
        o[i] = n[2 * i] + (n[2 * i + 1] << 8);
    o[15] &= 0x7fff;
}
function A(o, a, b) {
    var i;
    for (i = 0; i < 16; i++)
        o[i] = (a[i] + b[i]) | 0;
}
function Z(o, a, b) {
    var i;
    for (i = 0; i < 16; i++)
        o[i] = (a[i] - b[i]) | 0;
}
function M(o, a, b) {
    var i, j, t = new Float64Array(31);
    for (i = 0; i < 31; i++)
        t[i] = 0;
    for (i = 0; i < 16; i++) {
        for (j = 0; j < 16; j++) {
            t[i + j] += a[i] * b[j];
        }
    }
    for (i = 0; i < 15; i++) {
        t[i] += 38 * t[i + 16];
    }
    for (i = 0; i < 16; i++)
        o[i] = t[i];
    car25519(o);
    car25519(o);
}
function S(o, a) {
    M(o, a, a);
}
function inv25519(o, i) {
    var c = gf();
    var a;
    for (a = 0; a < 16; a++)
        c[a] = i[a];
    for (a = 253; a >= 0; a--) {
        S(c, c);
        if (a !== 2 && a !== 4)
            M(c, c, i);
    }
    for (a = 0; a < 16; a++)
        o[a] = c[a];
}
function pow2523(o, i) {
    var c = gf();
    var a;
    for (a = 0; a < 16; a++)
        c[a] = i[a];
    for (a = 250; a >= 0; a--) {
        S(c, c);
        if (a !== 1)
            M(c, c, i);
    }
    for (a = 0; a < 16; a++)
        o[a] = c[a];
}
function crypto_scalarmult(q, n, p) {
    var z = new Uint8Array(32);
    var x = new Float64Array(80), r, i;
    var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
    for (i = 0; i < 31; i++)
        z[i] = n[i];
    z[31] = (n[31] & 127) | 64;
    z[0] &= 248;
    unpack25519(x, p);
    for (i = 0; i < 16; i++) {
        b[i] = x[i];
        d[i] = a[i] = c[i] = 0;
    }
    a[0] = d[0] = 1;
    for (i = 254; i >= 0; --i) {
        r = (z[i >>> 3] >>> (i & 7)) & 1;
        sel25519(a, b, r);
        sel25519(c, d, r);
        A(e, a, c);
        Z(a, a, c);
        A(c, b, d);
        Z(b, b, d);
        S(d, e);
        S(f, a);
        M(a, c, a);
        M(c, b, e);
        A(e, a, c);
        Z(a, a, c);
        S(b, a);
        Z(c, d, f);
        M(a, c, _121665);
        A(a, a, d);
        M(c, c, a);
        M(a, d, f);
        M(d, b, x);
        S(b, e);
        sel25519(a, b, r);
        sel25519(c, d, r);
    }
    for (i = 0; i < 16; i++) {
        x[i + 16] = a[i];
        x[i + 32] = c[i];
        x[i + 48] = b[i];
        x[i + 64] = d[i];
    }
    var x32 = x.subarray(32);
    var x16 = x.subarray(16);
    inv25519(x32, x32);
    M(x16, x16, x32);
    pack25519(q, x16);
    return 0;
}
function crypto_scalarmult_base(q, n) {
    return crypto_scalarmult(q, n, _9);
}
function crypto_box_keypair(y, x) {
    randombytes(x, 32);
    return crypto_scalarmult_base(y, x);
}
function crypto_box_beforenm(k, y, x) {
    var s = new Uint8Array(32);
    crypto_scalarmult(s, x, y);
    return crypto_core_hsalsa20(k, _0, s, sigma);
}
var crypto_box_afternm = crypto_secretbox;
var crypto_box_open_afternm = crypto_secretbox_open;
function crypto_box(c, m, d, n, y, x) {
    var k = new Uint8Array(32);
    crypto_box_beforenm(k, y, x);
    return crypto_box_afternm(c, m, d, n, k);
}
function crypto_box_open(m, c, d, n, y, x) {
    var k = new Uint8Array(32);
    crypto_box_beforenm(k, y, x);
    return crypto_box_open_afternm(m, c, d, n, k);
}
function add64() {
    var a = 0, b = 0, c = 0, d = 0, m16 = 65535, l, h, i;
    for (i = 0; i < arguments.length; i++) {
        l = arguments[i].lo;
        h = arguments[i].hi;
        a += l & m16;
        b += l >>> 16;
        c += h & m16;
        d += h >>> 16;
    }
    b += a >>> 16;
    c += b >>> 16;
    d += c >>> 16;
    return new u64((c & m16) | (d << 16), (a & m16) | (b << 16));
}
function shr64(x, c) {
    return new u64(x.hi >>> c, (x.lo >>> c) | (x.hi << (32 - c)));
}
function xor64() {
    var l = 0, h = 0, i;
    for (i = 0; i < arguments.length; i++) {
        l ^= arguments[i].lo;
        h ^= arguments[i].hi;
    }
    return new u64(h, l);
}
function R(x, c) {
    var h, l, c1 = 32 - c;
    if (c < 32) {
        h = (x.hi >>> c) | (x.lo << c1);
        l = (x.lo >>> c) | (x.hi << c1);
    }
    else if (c < 64) {
        h = (x.lo >>> c) | (x.hi << c1);
        l = (x.hi >>> c) | (x.lo << c1);
    }
    return new u64(h, l);
}
function Ch(x, y, z) {
    var h = (x.hi & y.hi) ^ (~x.hi & z.hi), l = (x.lo & y.lo) ^ (~x.lo & z.lo);
    return new u64(h, l);
}
function Maj(x, y, z) {
    var h = (x.hi & y.hi) ^ (x.hi & z.hi) ^ (y.hi & z.hi), l = (x.lo & y.lo) ^ (x.lo & z.lo) ^ (y.lo & z.lo);
    return new u64(h, l);
}
function Sigma0(x) {
    return xor64(R(x, 28), R(x, 34), R(x, 39));
}
function Sigma1(x) {
    return xor64(R(x, 14), R(x, 18), R(x, 41));
}
function sigma0(x) {
    return xor64(R(x, 1), R(x, 8), shr64(x, 7));
}
function sigma1(x) {
    return xor64(R(x, 19), R(x, 61), shr64(x, 6));
}
var K = [
    new u64(0x428a2f98, 0xd728ae22),
    new u64(0x71374491, 0x23ef65cd),
    new u64(0xb5c0fbcf, 0xec4d3b2f),
    new u64(0xe9b5dba5, 0x8189dbbc),
    new u64(0x3956c25b, 0xf348b538),
    new u64(0x59f111f1, 0xb605d019),
    new u64(0x923f82a4, 0xaf194f9b),
    new u64(0xab1c5ed5, 0xda6d8118),
    new u64(0xd807aa98, 0xa3030242),
    new u64(0x12835b01, 0x45706fbe),
    new u64(0x243185be, 0x4ee4b28c),
    new u64(0x550c7dc3, 0xd5ffb4e2),
    new u64(0x72be5d74, 0xf27b896f),
    new u64(0x80deb1fe, 0x3b1696b1),
    new u64(0x9bdc06a7, 0x25c71235),
    new u64(0xc19bf174, 0xcf692694),
    new u64(0xe49b69c1, 0x9ef14ad2),
    new u64(0xefbe4786, 0x384f25e3),
    new u64(0x0fc19dc6, 0x8b8cd5b5),
    new u64(0x240ca1cc, 0x77ac9c65),
    new u64(0x2de92c6f, 0x592b0275),
    new u64(0x4a7484aa, 0x6ea6e483),
    new u64(0x5cb0a9dc, 0xbd41fbd4),
    new u64(0x76f988da, 0x831153b5),
    new u64(0x983e5152, 0xee66dfab),
    new u64(0xa831c66d, 0x2db43210),
    new u64(0xb00327c8, 0x98fb213f),
    new u64(0xbf597fc7, 0xbeef0ee4),
    new u64(0xc6e00bf3, 0x3da88fc2),
    new u64(0xd5a79147, 0x930aa725),
    new u64(0x06ca6351, 0xe003826f),
    new u64(0x14292967, 0x0a0e6e70),
    new u64(0x27b70a85, 0x46d22ffc),
    new u64(0x2e1b2138, 0x5c26c926),
    new u64(0x4d2c6dfc, 0x5ac42aed),
    new u64(0x53380d13, 0x9d95b3df),
    new u64(0x650a7354, 0x8baf63de),
    new u64(0x766a0abb, 0x3c77b2a8),
    new u64(0x81c2c92e, 0x47edaee6),
    new u64(0x92722c85, 0x1482353b),
    new u64(0xa2bfe8a1, 0x4cf10364),
    new u64(0xa81a664b, 0xbc423001),
    new u64(0xc24b8b70, 0xd0f89791),
    new u64(0xc76c51a3, 0x0654be30),
    new u64(0xd192e819, 0xd6ef5218),
    new u64(0xd6990624, 0x5565a910),
    new u64(0xf40e3585, 0x5771202a),
    new u64(0x106aa070, 0x32bbd1b8),
    new u64(0x19a4c116, 0xb8d2d0c8),
    new u64(0x1e376c08, 0x5141ab53),
    new u64(0x2748774c, 0xdf8eeb99),
    new u64(0x34b0bcb5, 0xe19b48a8),
    new u64(0x391c0cb3, 0xc5c95a63),
    new u64(0x4ed8aa4a, 0xe3418acb),
    new u64(0x5b9cca4f, 0x7763e373),
    new u64(0x682e6ff3, 0xd6b2b8a3),
    new u64(0x748f82ee, 0x5defb2fc),
    new u64(0x78a5636f, 0x43172f60),
    new u64(0x84c87814, 0xa1f0ab72),
    new u64(0x8cc70208, 0x1a6439ec),
    new u64(0x90befffa, 0x23631e28),
    new u64(0xa4506ceb, 0xde82bde9),
    new u64(0xbef9a3f7, 0xb2c67915),
    new u64(0xc67178f2, 0xe372532b),
    new u64(0xca273ece, 0xea26619c),
    new u64(0xd186b8c7, 0x21c0c207),
    new u64(0xeada7dd6, 0xcde0eb1e),
    new u64(0xf57d4f7f, 0xee6ed178),
    new u64(0x06f067aa, 0x72176fba),
    new u64(0x0a637dc5, 0xa2c898a6),
    new u64(0x113f9804, 0xbef90dae),
    new u64(0x1b710b35, 0x131c471b),
    new u64(0x28db77f5, 0x23047d84),
    new u64(0x32caab7b, 0x40c72493),
    new u64(0x3c9ebe0a, 0x15c9bebc),
    new u64(0x431d67c4, 0x9c100d4c),
    new u64(0x4cc5d4be, 0xcb3e42b6),
    new u64(0x597f299c, 0xfc657e2a),
    new u64(0x5fcb6fab, 0x3ad6faec),
    new u64(0x6c44198c, 0x4a475817),
];
function crypto_hashblocks(x, m, n) {
    var z = [], b = [], a = [], w = [], t, i, j;
    for (i = 0; i < 8; i++)
        z[i] = a[i] = dl64(x, 8 * i);
    var pos = 0;
    while (n >= 128) {
        for (i = 0; i < 16; i++)
            w[i] = dl64(m, 8 * i + pos);
        for (i = 0; i < 80; i++) {
            for (j = 0; j < 8; j++)
                b[j] = a[j];
            t = add64(a[7], Sigma1(a[4]), Ch(a[4], a[5], a[6]), K[i], w[i % 16]);
            b[7] = add64(t, Sigma0(a[0]), Maj(a[0], a[1], a[2]));
            b[3] = add64(b[3], t);
            for (j = 0; j < 8; j++)
                a[(j + 1) % 8] = b[j];
            if (i % 16 === 15) {
                for (j = 0; j < 16; j++) {
                    w[j] = add64(w[j], w[(j + 9) % 16], sigma0(w[(j + 1) % 16]), sigma1(w[(j + 14) % 16]));
                }
            }
        }
        for (i = 0; i < 8; i++) {
            a[i] = add64(a[i], z[i]);
            z[i] = a[i];
        }
        pos += 128;
        n -= 128;
    }
    for (i = 0; i < 8; i++)
        ts64(x, 8 * i, z[i]);
    return n;
}
var iv = new Uint8Array([
    0x6a, 0x09, 0xe6, 0x67, 0xf3, 0xbc, 0xc9, 0x08, 0xbb, 0x67, 0xae, 0x85, 0x84,
    0xca, 0xa7, 0x3b, 0x3c, 0x6e, 0xf3, 0x72, 0xfe, 0x94, 0xf8, 0x2b, 0xa5, 0x4f,
    0xf5, 0x3a, 0x5f, 0x1d, 0x36, 0xf1, 0x51, 0x0e, 0x52, 0x7f, 0xad, 0xe6, 0x82,
    0xd1, 0x9b, 0x05, 0x68, 0x8c, 0x2b, 0x3e, 0x6c, 0x1f, 0x1f, 0x83, 0xd9, 0xab,
    0xfb, 0x41, 0xbd, 0x6b, 0x5b, 0xe0, 0xcd, 0x19, 0x13, 0x7e, 0x21, 0x79,
]);
function crypto_hash(out, m, n) {
    var h = new Uint8Array(64), x = new Uint8Array(256);
    var i, b = n;
    for (i = 0; i < 64; i++)
        h[i] = iv[i];
    crypto_hashblocks(h, m, n);
    n %= 128;
    for (i = 0; i < 256; i++)
        x[i] = 0;
    for (i = 0; i < n; i++)
        x[i] = m[b - n + i];
    x[n] = 128;
    n = 256 - 128 * (n < 112 ? 1 : 0);
    x[n - 9] = 0;
    ts64(x, n - 8, new u64((b / 0x20000000) | 0, b << 3));
    crypto_hashblocks(h, x, n);
    for (i = 0; i < 64; i++)
        out[i] = h[i];
    return 0;
}
function add(p, q) {
    var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
    Z(a, p[1], p[0]);
    Z(t, q[1], q[0]);
    M(a, a, t);
    A(b, p[0], p[1]);
    A(t, q[0], q[1]);
    M(b, b, t);
    M(c, p[3], q[3]);
    M(c, c, D2);
    M(d, p[2], q[2]);
    A(d, d, d);
    Z(e, b, a);
    Z(f, d, c);
    A(g, d, c);
    A(h, b, a);
    M(p[0], e, f);
    M(p[1], h, g);
    M(p[2], g, f);
    M(p[3], e, h);
}
function cswap(p, q, b) {
    var i;
    for (i = 0; i < 4; i++) {
        sel25519(p[i], q[i], b);
    }
}
function pack(r, p) {
    var tx = gf(), ty = gf(), zi = gf();
    inv25519(zi, p[2]);
    M(tx, p[0], zi);
    M(ty, p[1], zi);
    pack25519(r, ty);
    r[31] ^= par25519(tx) << 7;
}
function scalarmult(p, q, s) {
    var b, i;
    set25519(p[0], gf0);
    set25519(p[1], gf1);
    set25519(p[2], gf1);
    set25519(p[3], gf0);
    for (i = 255; i >= 0; --i) {
        b = (s[(i / 8) | 0] >> (i & 7)) & 1;
        cswap(p, q, b);
        add(q, p);
        add(p, p);
        cswap(p, q, b);
    }
}
function scalarbase(p, s) {
    var q = [gf(), gf(), gf(), gf()];
    set25519(q[0], X);
    set25519(q[1], Y);
    set25519(q[2], gf1);
    M(q[3], X, Y);
    scalarmult(p, q, s);
}
function crypto_sign_keypair(pk, sk, seeded) {
    var d = new Uint8Array(64);
    var p = [gf(), gf(), gf(), gf()];
    var i;
    if (!seeded)
        randombytes(sk, 32);
    crypto_hash(d, sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    scalarbase(p, d);
    pack(pk, p);
    for (i = 0; i < 32; i++)
        sk[i + 32] = pk[i];
    return 0;
}
var L = new Float64Array([
    0xed, 0xd3, 0xf5, 0x5c, 0x1a, 0x63, 0x12, 0x58, 0xd6, 0x9c, 0xf7, 0xa2, 0xde,
    0xf9, 0xde, 0x14, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x10,
]);
function modL(r, x) {
    var carry, i, j, k;
    for (i = 63; i >= 32; --i) {
        carry = 0;
        for (j = i - 32, k = i - 12; j < k; ++j) {
            x[j] += carry - 16 * x[i] * L[j - (i - 32)];
            carry = Math.floor((x[j] + 128) / 256);
            x[j] -= carry * 256;
        }
        x[j] += carry;
        x[i] = 0;
    }
    carry = 0;
    for (j = 0; j < 32; j++) {
        x[j] += carry - (x[31] >> 4) * L[j];
        carry = x[j] >> 8;
        x[j] &= 255;
    }
    for (j = 0; j < 32; j++)
        x[j] -= carry * L[j];
    for (i = 0; i < 32; i++) {
        x[i + 1] += x[i] >> 8;
        r[i] = x[i] & 255;
    }
}
function reduce(r) {
    var x = new Float64Array(64), i;
    for (i = 0; i < 64; i++)
        x[i] = r[i];
    for (i = 0; i < 64; i++)
        r[i] = 0;
    modL(r, x);
}
// Note: difference from C - smlen returned, not passed as argument.
function crypto_sign(sm, m, n, sk) {
    var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
    var i, j, x = new Float64Array(64);
    var p = [gf(), gf(), gf(), gf()];
    crypto_hash(d, sk, 32);
    d[0] &= 248;
    d[31] &= 127;
    d[31] |= 64;
    var smlen = n + 64;
    for (i = 0; i < n; i++)
        sm[64 + i] = m[i];
    for (i = 0; i < 32; i++)
        sm[32 + i] = d[32 + i];
    crypto_hash(r, sm.subarray(32), n + 32);
    reduce(r);
    scalarbase(p, r);
    pack(sm, p);
    for (i = 32; i < 64; i++)
        sm[i] = sk[i];
    crypto_hash(h, sm, n + 64);
    reduce(h);
    for (i = 0; i < 64; i++)
        x[i] = 0;
    for (i = 0; i < 32; i++)
        x[i] = r[i];
    for (i = 0; i < 32; i++) {
        for (j = 0; j < 32; j++) {
            x[i + j] += h[i] * d[j];
        }
    }
    modL(sm.subarray(32), x);
    return smlen;
}
function unpackneg(r, p) {
    var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
    set25519(r[2], gf1);
    unpack25519(r[1], p);
    S(num, r[1]);
    M(den, num, D);
    Z(num, num, r[2]);
    A(den, r[2], den);
    S(den2, den);
    S(den4, den2);
    M(den6, den4, den2);
    M(t, den6, num);
    M(t, t, den);
    pow2523(t, t);
    M(t, t, num);
    M(t, t, den);
    M(t, t, den);
    M(r[0], t, den);
    S(chk, r[0]);
    M(chk, chk, den);
    if (neq25519(chk, num))
        M(r[0], r[0], I);
    S(chk, r[0]);
    M(chk, chk, den);
    if (neq25519(chk, num))
        return -1;
    if (par25519(r[0]) === p[31] >> 7)
        Z(r[0], gf0, r[0]);
    M(r[3], r[0], r[1]);
    return 0;
}
function crypto_sign_open(m, sm, n, pk) {
    var i;
    var t = new Uint8Array(32), h = new Uint8Array(64);
    var p = [gf(), gf(), gf(), gf()], q = [gf(), gf(), gf(), gf()];
    if (n < 64)
        return -1;
    if (unpackneg(q, pk))
        return -1;
    for (i = 0; i < n; i++)
        m[i] = sm[i];
    for (i = 0; i < 32; i++)
        m[i + 32] = pk[i];
    crypto_hash(h, m, n);
    reduce(h);
    scalarmult(p, q, h);
    scalarbase(q, sm.subarray(32));
    add(p, q);
    pack(t, p);
    n -= 64;
    if (crypto_verify_32(sm, 0, t, 0)) {
        for (i = 0; i < n; i++)
            m[i] = 0;
        return -1;
    }
    for (i = 0; i < n; i++)
        m[i] = sm[i + 64];
    return n;
}
var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
var _nacl = {
    lowlevel: {},
};
_nacl.lowlevel = {
    crypto_core_hsalsa20: crypto_core_hsalsa20,
    crypto_stream_xor: crypto_stream_xor,
    crypto_stream: crypto_stream,
    crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
    crypto_stream_salsa20: crypto_stream_salsa20,
    crypto_onetimeauth: crypto_onetimeauth,
    crypto_onetimeauth_verify: crypto_onetimeauth_verify,
    crypto_verify_16: crypto_verify_16,
    crypto_verify_32: crypto_verify_32,
    crypto_secretbox: crypto_secretbox,
    crypto_secretbox_open: crypto_secretbox_open,
    crypto_scalarmult: crypto_scalarmult,
    crypto_scalarmult_base: crypto_scalarmult_base,
    crypto_box_beforenm: crypto_box_beforenm,
    crypto_box_afternm: crypto_box_afternm,
    crypto_box: crypto_box,
    crypto_box_open: crypto_box_open,
    crypto_box_keypair: crypto_box_keypair,
    crypto_hash: crypto_hash,
    crypto_sign: crypto_sign,
    crypto_sign_keypair: crypto_sign_keypair,
    crypto_sign_open: crypto_sign_open,
    crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
    crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
    crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
    crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
    crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
    crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
    crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
    crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
    crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
    crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
    crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
    crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
    crypto_sign_BYTES: crypto_sign_BYTES,
    crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
    crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
    crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
    crypto_hash_BYTES: crypto_hash_BYTES,
    gf: gf,
    D: D,
    L: L,
    pack25519: pack25519,
    unpack25519: unpack25519,
    M: M,
    A: A,
    S: S,
    Z: Z,
    pow2523: pow2523,
    add: add,
    set25519: set25519,
    modL: modL,
    scalarmult: scalarmult,
    scalarbase: scalarbase,
};
/* High-level API */
function checkLengths(k, n) {
    if (k.length !== crypto_secretbox_KEYBYTES)
        throw new Error('bad key size');
    if (n.length !== crypto_secretbox_NONCEBYTES)
        throw new Error('bad nonce size');
}
function checkBoxLengths(pk, sk) {
    if (pk.length !== crypto_box_PUBLICKEYBYTES)
        throw new Error('bad public key size');
    if (sk.length !== crypto_box_SECRETKEYBYTES)
        throw new Error('bad secret key size');
}
function checkArrayTypes() {
    for (var i = 0; i < arguments.length; i++) {
        if (!(arguments[i] instanceof Uint8Array))
            throw new TypeError('unexpected type, use Uint8Array');
    }
}
function cleanup(arr) {
    for (var i = 0; i < arr.length; i++)
        arr[i] = 0;
}
_nacl.randomBytes = function (n) {
    var b = new Uint8Array(n);
    randombytes(b, n);
    return b;
};
_nacl.secretbox = function (msg, nonce, key) {
    checkArrayTypes(msg, nonce, key);
    checkLengths(key, nonce);
    var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
    var c = new Uint8Array(m.length);
    for (var i = 0; i < msg.length; i++)
        m[i + crypto_secretbox_ZEROBYTES] = msg[i];
    crypto_secretbox(c, m, m.length, nonce, key);
    return c.subarray(crypto_secretbox_BOXZEROBYTES);
};
_nacl.secretbox.open = function (box, nonce, key) {
    checkArrayTypes(box, nonce, key);
    checkLengths(key, nonce);
    var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
    var m = new Uint8Array(c.length);
    for (var i = 0; i < box.length; i++)
        c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
    if (c.length < 32)
        return null;
    if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0)
        return null;
    return m.subarray(crypto_secretbox_ZEROBYTES);
};
_nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
_nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
_nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
_nacl.scalarMult = function (n, p) {
    checkArrayTypes(n, p);
    if (n.length !== crypto_scalarmult_SCALARBYTES)
        throw new Error('bad n size');
    if (p.length !== crypto_scalarmult_BYTES)
        throw new Error('bad p size');
    var q = new Uint8Array(crypto_scalarmult_BYTES);
    crypto_scalarmult(q, n, p);
    return q;
};
_nacl.scalarMult.base = function (n) {
    checkArrayTypes(n);
    if (n.length !== crypto_scalarmult_SCALARBYTES)
        throw new Error('bad n size');
    var q = new Uint8Array(crypto_scalarmult_BYTES);
    crypto_scalarmult_base(q, n);
    return q;
};
_nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
_nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
_nacl.box = function (msg, nonce, publicKey, secretKey) {
    var k = _nacl.box.before(publicKey, secretKey);
    return _nacl.secretbox(msg, nonce, k);
};
_nacl.box.before = function (publicKey, secretKey) {
    checkArrayTypes(publicKey, secretKey);
    checkBoxLengths(publicKey, secretKey);
    var k = new Uint8Array(crypto_box_BEFORENMBYTES);
    crypto_box_beforenm(k, publicKey, secretKey);
    return k;
};
_nacl.box.after = _nacl.secretbox;
_nacl.box.open = function (msg, nonce, publicKey, secretKey) {
    var k = _nacl.box.before(publicKey, secretKey);
    return _nacl.secretbox.open(msg, nonce, k);
};
_nacl.box.open.after = _nacl.secretbox.open;
_nacl.box.keyPair = function () {
    var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
    var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
    crypto_box_keypair(pk, sk);
    return { publicKey: pk, secretKey: sk };
};
_nacl.box.keyPair.fromSecretKey = function (secretKey) {
    checkArrayTypes(secretKey);
    if (secretKey.length !== crypto_box_SECRETKEYBYTES)
        throw new Error('bad secret key size');
    var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
    crypto_scalarmult_base(pk, secretKey);
    return { publicKey: pk, secretKey: new Uint8Array(secretKey) };
};
_nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
_nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
_nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
_nacl.box.nonceLength = crypto_box_NONCEBYTES;
_nacl.box.overheadLength = _nacl.secretbox.overheadLength;
_nacl.sign = function (msg, secretKey) {
    checkArrayTypes(msg, secretKey);
    if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
        throw new Error('bad secret key size');
    var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
    crypto_sign(signedMsg, msg, msg.length, secretKey);
    return signedMsg;
};
_nacl.sign.open = function (signedMsg, publicKey) {
    checkArrayTypes(signedMsg, publicKey);
    if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
        throw new Error('bad public key size');
    var tmp = new Uint8Array(signedMsg.length);
    var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
    if (mlen < 0)
        return null;
    var m = new Uint8Array(mlen);
    for (var i = 0; i < m.length; i++)
        m[i] = tmp[i];
    return m;
};
_nacl.sign.detached = function (msg, secretKey) {
    var signedMsg = _nacl.sign(msg, secretKey);
    var sig = new Uint8Array(crypto_sign_BYTES);
    for (var i = 0; i < sig.length; i++)
        sig[i] = signedMsg[i];
    return sig;
};
_nacl.sign.detached.verify = function (msg, sig, publicKey) {
    checkArrayTypes(msg, sig, publicKey);
    if (sig.length !== crypto_sign_BYTES)
        throw new Error('bad signature size');
    if (publicKey.length !== crypto_sign_PUBLICKEYBYTES)
        throw new Error('bad public key size');
    var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
    var m = new Uint8Array(crypto_sign_BYTES + msg.length);
    var i;
    for (i = 0; i < crypto_sign_BYTES; i++)
        sm[i] = sig[i];
    for (i = 0; i < msg.length; i++)
        sm[i + crypto_sign_BYTES] = msg[i];
    return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
};
_nacl.sign.keyPair = function () {
    var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
    var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
    crypto_sign_keypair(pk, sk);
    return { publicKey: pk, secretKey: sk };
};
_nacl.sign.keyPair.fromSecretKey = function (secretKey) {
    checkArrayTypes(secretKey);
    if (secretKey.length !== crypto_sign_SECRETKEYBYTES)
        throw new Error('bad secret key size');
    var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
    for (var i = 0; i < pk.length; i++)
        pk[i] = secretKey[32 + i];
    return { publicKey: pk, secretKey: new Uint8Array(secretKey) };
};
_nacl.sign.keyPair.fromSeed = function (seed) {
    checkArrayTypes(seed);
    if (seed.length !== crypto_sign_SEEDBYTES)
        throw new Error('bad seed size');
    var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
    var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
    for (var i = 0; i < 32; i++)
        sk[i] = seed[i];
    crypto_sign_keypair(pk, sk, true);
    return { publicKey: pk, secretKey: sk };
};
_nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
_nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
_nacl.sign.seedLength = crypto_sign_SEEDBYTES;
_nacl.sign.signatureLength = crypto_sign_BYTES;
_nacl.hash = function (msg) {
    checkArrayTypes(msg);
    var h = new Uint8Array(crypto_hash_BYTES);
    crypto_hash(h, msg, msg.length);
    return h;
};
_nacl.hash.hashLength = crypto_hash_BYTES;
_nacl.verify = function (x, y) {
    checkArrayTypes(x, y);
    // Zero length arguments are considered not equal.
    if (x.length === 0 || y.length === 0)
        return false;
    if (x.length !== y.length)
        return false;
    return vn(x, 0, y, 0, x.length) === 0 ? true : false;
};
_nacl.setPRNG = function (fn) {
    randombytes = fn;
};
(function () {
    // Initialize PRNG if environment provides CSPRNG.
    // If not, methods calling randombytes will throw.
    var crypto = typeof self !== 'undefined' ? self.crypto || self.msCrypto : null;
    if (crypto && crypto.getRandomValues) {
        // Browsers.
        var QUOTA = 65536;
        _nacl.setPRNG(function (x, n) {
            var i, v = new Uint8Array(n);
            for (i = 0; i < n; i += QUOTA) {
                crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
            }
            for (i = 0; i < n; i++)
                x[i] = v[i];
            cleanup(v);
        });
    }
    else if (true) {
        // Node.js.
        // this nodeRequire hack was added by Chris Cassano
        // because webpack was complaining that "you might try to require crypto and that's not bundled" by webpack automatically anymore.
        // but this code path will only run on nodejs so it's a non-issue.
        // thus we have this hack to make webpack happy.
        const nodeVer = typeof process !== 'undefined' && process.versions?.node;
        const nodeRequire = nodeVer
            ?  true
                ? require
                : 0
            : undefined;
        crypto = nodeRequire('crypto');
        if (crypto && crypto.randomBytes) {
            _nacl.setPRNG(function (x, n) {
                var i, v = crypto.randomBytes(n);
                for (i = 0; i < n; i++)
                    x[i] = v[i];
                cleanup(v);
            });
        }
    }
})();
exports.nacl = _nacl.default || _nacl;
//# sourceMappingURL=nacl.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/uint8arrays/src/index.js":
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

// ----- autogen:polyfills:start  -----
// This field will be automatically injected into the ./dist/packages/<package-name>/index.js file
// between the autogen:polyfills:start/end comments

try {
  globalThis.crypto = (__webpack_require__("../../node_modules/crypto-browserify/index.js").webcrypto);
} catch (e) {
  // swallow
}

// ----- autogen:polyfills:end  -----
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uint8arrayToString = exports.uint8arrayFromString = void 0;
const uint8arrays_1 = __webpack_require__("../../node_modules/@lit-protocol/uint8arrays/src/lib/uint8arrays.js");
Object.defineProperty(exports, "uint8arrayFromString", ({ enumerable: true, get: function () { return uint8arrays_1.uint8arrayFromString; } }));
Object.defineProperty(exports, "uint8arrayToString", ({ enumerable: true, get: function () { return uint8arrays_1.uint8arrayToString; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "../../node_modules/@lit-protocol/uint8arrays/src/lib/uint8arrays.js":
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uint8arrayToString = exports.uint8arrayFromString = exports.uint8ArrayToBase64 = exports.base64ToUint8Array = exports.utf8Decode = void 0;
// /**
// utf8Encode - Encodes a given string into a UTF-8 encoded Uint8Array.
// @param {string} str - The input string to be encoded.
// @returns {Uint8Array} utf8Array - The UTF-8 encoded Uint8Array of the input string.
// */
function utf8Encode(str) {
    // Initialize an empty array to store the UTF-8 encoded dat
    let utf8Array = [];
    // Iterate through the characters of the input string
    for (let i = 0; i < str.length; i++) {
        // Get the Unicode character code of the current character
        let charCode = str.charCodeAt(i);
        // If the character code is less than 128 (ASCII range)
        if (charCode < 128) {
            // Directly push the character code into the UTF-8 array
            utf8Array.push(charCode);
            // If the character code is between 128 and 2047 (2-byte sequence)
        }
        else if (charCode < 2048) {
            // Push the two-byte sequence of the character code into the UTF-8 array
            utf8Array.push(192 | (charCode >> 6), 128 | (charCode & 63));
        }
        else if (
        // Check if the character is a high surrogate (UTF-16)
        (charCode & 0xfc00) === 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Combine the high and low surrogate pair into a single UTF-32 code point
            charCode =
                0x10000 + ((charCode & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            // Push the four-byte sequence of the character code into the UTF-8 array
            utf8Array.push(240 | (charCode >> 18), 128 | ((charCode >> 12) & 63), 128 | ((charCode >> 6) & 63), 128 | (charCode & 63));
        }
        else {
            // If the character code is between 2048 and 65535 (3-byte sequence)
            // Push the three-byte sequence of the character code into the UTF-8 array
            utf8Array.push(224 | (charCode >> 12), 128 | ((charCode >> 6) & 63), 128 | (charCode & 63));
        }
    }
    return new Uint8Array(utf8Array);
}
// /**
// utf8Decode - Decodes a given UTF-8 encoded Uint8Array into a string.
// @param {Uint8Array} utf8Array - The input UTF-8 encoded Uint8Array to be decoded.
// @returns {string} str - The decoded string from the input UTF-8 encoded Uint8Array.
// */
function utf8Decode(utf8Array) {
    let str = '';
    let i = 0;
    while (i < utf8Array.length) {
        let charCode = utf8Array[i++];
        if (charCode < 128) {
            str += String.fromCharCode(charCode);
        }
        else if (charCode > 191 && charCode < 224) {
            str += String.fromCharCode(((charCode & 31) << 6) | (utf8Array[i++] & 63));
        }
        else if (charCode > 239 && charCode < 365) {
            charCode =
                ((charCode & 7) << 18) |
                    ((utf8Array[i++] & 63) << 12) |
                    ((utf8Array[i++] & 63) << 6) |
                    (utf8Array[i++] & 63);
            charCode -= 0x10000;
            str += String.fromCharCode(0xd800 + (charCode >> 10), 0xdc00 + (charCode & 0x3ff));
        }
        else {
            str += String.fromCharCode(((charCode & 15) << 12) |
                ((utf8Array[i++] & 63) << 6) |
                (utf8Array[i++] & 63));
        }
    }
    return str;
}
exports.utf8Decode = utf8Decode;
function base64ToUint8Array(base64Str) {
    const binaryStr = atob(base64Str);
    const len = binaryStr.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binaryStr.charCodeAt(i);
    }
    return bytes;
}
exports.base64ToUint8Array = base64ToUint8Array;
function uint8ArrayToBase64(uint8Array) {
    const binaryStr = String.fromCharCode(...uint8Array);
    return btoa(binaryStr);
}
exports.uint8ArrayToBase64 = uint8ArrayToBase64;
function base64UrlPadToBase64(base64UrlPadStr) {
    return (base64UrlPadStr.replace('-', '+').replace('_', '/') +
        '='.repeat((4 - (base64UrlPadStr.length % 4)) % 4));
}
function base64ToBase64UrlPad(base64Str) {
    return base64Str.replace('+', '-').replace('/', '_').replace(/=+$/, '');
}
function uint8arrayFromString(str, encoding = 'utf8') {
    switch (encoding) {
        case 'utf8':
            return utf8Encode(str);
        case 'base16':
            const arr = [];
            for (let i = 0; i < str.length; i += 2) {
                arr.push(parseInt(str.slice(i, i + 2), 16));
            }
            return new Uint8Array(arr);
        case 'base64':
            return base64ToUint8Array(str);
        case 'base64urlpad':
            return base64ToUint8Array(base64UrlPadToBase64(str));
        default:
            throw new Error(`Unsupported encoding "${encoding}"`);
    }
}
exports.uint8arrayFromString = uint8arrayFromString;
function uint8arrayToString(uint8array, encoding = 'utf8') {
    let _uint8array = new Uint8Array(uint8array);
    switch (encoding) {
        case 'utf8':
            return utf8Decode(_uint8array);
        case 'base16':
            return Array.from(_uint8array)
                .map((byte) => byte.toString(16).padStart(2, '0'))
                .join('');
        case 'base64':
            return uint8ArrayToBase64(_uint8array);
        case 'base64urlpad':
            return base64ToBase64UrlPad(uint8ArrayToBase64(_uint8array));
        default:
            throw new Error(`Unsupported encoding "${encoding}"`);
    }
}
exports.uint8arrayToString = uint8arrayToString;
//# sourceMappingURL=uint8arrays.js.map

/***/ }),

/***/ "../../node_modules/available-typed-arrays/index.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var possibleNames = [
	'BigInt64Array',
	'BigUint64Array',
	'Float32Array',
	'Float64Array',
	'Int16Array',
	'Int32Array',
	'Int8Array',
	'Uint16Array',
	'Uint32Array',
	'Uint8Array',
	'Uint8ClampedArray'
];

var g = typeof globalThis === 'undefined' ? __webpack_require__.g : globalThis;

module.exports = function availableTypedArrays() {
	var out = [];
	for (var i = 0; i < possibleNames.length; i++) {
		if (typeof g[possibleNames[i]] === 'function') {
			out[out.length] = possibleNames[i];
		}
	}
	return out;
};


/***/ }),

/***/ "../../node_modules/pino/browser.js":
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


const format = __webpack_require__("../../node_modules/quick-format-unescaped/index.js")

module.exports = pino

const _console = pfGlobalThisOrFallback().console || {}
const stdSerializers = {
  mapHttpRequest: mock,
  mapHttpResponse: mock,
  wrapRequestSerializer: passthrough,
  wrapResponseSerializer: passthrough,
  wrapErrorSerializer: passthrough,
  req: mock,
  res: mock,
  err: asErrValue,
  errWithCause: asErrValue
}

function shouldSerialize (serialize, serializers) {
  if (Array.isArray(serialize)) {
    const hasToFilter = serialize.filter(function (k) {
      return k !== '!stdSerializers.err'
    })
    return hasToFilter
  } else if (serialize === true) {
    return Object.keys(serializers)
  }

  return false
}

function pino (opts) {
  opts = opts || {}
  opts.browser = opts.browser || {}

  const transmit = opts.browser.transmit
  if (transmit && typeof transmit.send !== 'function') { throw Error('pino: transmit option must have a send function') }

  const proto = opts.browser.write || _console
  if (opts.browser.write) opts.browser.asObject = true
  const serializers = opts.serializers || {}
  const serialize = shouldSerialize(opts.browser.serialize, serializers)
  let stdErrSerialize = opts.browser.serialize

  if (
    Array.isArray(opts.browser.serialize) &&
    opts.browser.serialize.indexOf('!stdSerializers.err') > -1
  ) stdErrSerialize = false

  const customLevels = Object.keys(opts.customLevels || {})
  const levels = ['error', 'fatal', 'warn', 'info', 'debug', 'trace'].concat(customLevels)

  if (typeof proto === 'function') {
    levels.forEach(function (level) {
      proto[level] = proto
    })
  }
  if (opts.enabled === false || opts.browser.disabled) opts.level = 'silent'
  const level = opts.level || 'info'
  const logger = Object.create(proto)
  if (!logger.log) logger.log = noop

  Object.defineProperty(logger, 'levelVal', {
    get: getLevelVal
  })
  Object.defineProperty(logger, 'level', {
    get: getLevel,
    set: setLevel
  })

  const setOpts = {
    transmit,
    serialize,
    asObject: opts.browser.asObject,
    levels,
    timestamp: getTimeFunction(opts)
  }
  logger.levels = getLevels(opts)
  logger.level = level

  logger.setMaxListeners = logger.getMaxListeners =
  logger.emit = logger.addListener = logger.on =
  logger.prependListener = logger.once =
  logger.prependOnceListener = logger.removeListener =
  logger.removeAllListeners = logger.listeners =
  logger.listenerCount = logger.eventNames =
  logger.write = logger.flush = noop
  logger.serializers = serializers
  logger._serialize = serialize
  logger._stdErrSerialize = stdErrSerialize
  logger.child = child

  if (transmit) logger._logEvent = createLogEventShape()

  function getLevelVal () {
    return this.level === 'silent'
      ? Infinity
      : this.levels.values[this.level]
  }

  function getLevel () {
    return this._level
  }
  function setLevel (level) {
    if (level !== 'silent' && !this.levels.values[level]) {
      throw Error('unknown level ' + level)
    }
    this._level = level

    set(setOpts, logger, 'error', 'log') // <-- must stay first
    set(setOpts, logger, 'fatal', 'error')
    set(setOpts, logger, 'warn', 'error')
    set(setOpts, logger, 'info', 'log')
    set(setOpts, logger, 'debug', 'log')
    set(setOpts, logger, 'trace', 'log')

    customLevels.forEach(function (level) {
      set(setOpts, logger, level, 'log')
    })
  }

  function child (bindings, childOptions) {
    if (!bindings) {
      throw new Error('missing bindings for child Pino')
    }
    childOptions = childOptions || {}
    if (serialize && bindings.serializers) {
      childOptions.serializers = bindings.serializers
    }
    const childOptionsSerializers = childOptions.serializers
    if (serialize && childOptionsSerializers) {
      var childSerializers = Object.assign({}, serializers, childOptionsSerializers)
      var childSerialize = opts.browser.serialize === true
        ? Object.keys(childSerializers)
        : serialize
      delete bindings.serializers
      applySerializers([bindings], childSerialize, childSerializers, this._stdErrSerialize)
    }
    function Child (parent) {
      this._childLevel = (parent._childLevel | 0) + 1
      this.error = bind(parent, bindings, 'error')
      this.fatal = bind(parent, bindings, 'fatal')
      this.warn = bind(parent, bindings, 'warn')
      this.info = bind(parent, bindings, 'info')
      this.debug = bind(parent, bindings, 'debug')
      this.trace = bind(parent, bindings, 'trace')
      if (childSerializers) {
        this.serializers = childSerializers
        this._serialize = childSerialize
      }
      if (transmit) {
        this._logEvent = createLogEventShape(
          [].concat(parent._logEvent.bindings, bindings)
        )
      }
    }
    Child.prototype = this
    return new Child(this)
  }
  return logger
}

function getLevels (opts) {
  const customLevels = opts.customLevels || {}

  const values = Object.assign({}, pino.levels.values, customLevels)
  const labels = Object.assign({}, pino.levels.labels, invertObject(customLevels))

  return {
    values,
    labels
  }
}

function invertObject (obj) {
  const inverted = {}
  Object.keys(obj).forEach(function (key) {
    inverted[obj[key]] = key
  })
  return inverted
}

pino.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: 'trace',
    20: 'debug',
    30: 'info',
    40: 'warn',
    50: 'error',
    60: 'fatal'
  }
}

pino.stdSerializers = stdSerializers
pino.stdTimeFunctions = Object.assign({}, { nullTime, epochTime, unixTime, isoTime })

function set (opts, logger, level, fallback) {
  const proto = Object.getPrototypeOf(logger)
  logger[level] = logger.levelVal > logger.levels.values[level]
    ? noop
    : (proto[level] ? proto[level] : (_console[level] || _console[fallback] || noop))

  wrap(opts, logger, level)
}

function wrap (opts, logger, level) {
  if (!opts.transmit && logger[level] === noop) return

  logger[level] = (function (write) {
    return function LOG () {
      const ts = opts.timestamp()
      const args = new Array(arguments.length)
      const proto = (Object.getPrototypeOf && Object.getPrototypeOf(this) === _console) ? _console : this
      for (var i = 0; i < args.length; i++) args[i] = arguments[i]

      if (opts.serialize && !opts.asObject) {
        applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize)
      }
      if (opts.asObject) write.call(proto, asObject(this, level, args, ts))
      else write.apply(proto, args)

      if (opts.transmit) {
        const transmitLevel = opts.transmit.level || logger.level
        const transmitValue = logger.levels.values[transmitLevel]
        const methodValue = logger.levels.values[level]
        if (methodValue < transmitValue) return
        transmit(this, {
          ts,
          methodLevel: level,
          methodValue,
          transmitLevel,
          transmitValue: logger.levels.values[opts.transmit.level || logger.level],
          send: opts.transmit.send,
          val: logger.levelVal
        }, args)
      }
    }
  })(logger[level])
}

function asObject (logger, level, args, ts) {
  if (logger._serialize) applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize)
  const argsCloned = args.slice()
  let msg = argsCloned[0]
  const o = {}
  if (ts) {
    o.time = ts
  }
  o.level = logger.levels.values[level]
  let lvl = (logger._childLevel | 0) + 1
  if (lvl < 1) lvl = 1
  // deliberate, catching objects, arrays
  if (msg !== null && typeof msg === 'object') {
    while (lvl-- && typeof argsCloned[0] === 'object') {
      Object.assign(o, argsCloned.shift())
    }
    msg = argsCloned.length ? format(argsCloned.shift(), argsCloned) : undefined
  } else if (typeof msg === 'string') msg = format(argsCloned.shift(), argsCloned)
  if (msg !== undefined) o.msg = msg
  return o
}

function applySerializers (args, serialize, serializers, stdErrSerialize) {
  for (const i in args) {
    if (stdErrSerialize && args[i] instanceof Error) {
      args[i] = pino.stdSerializers.err(args[i])
    } else if (typeof args[i] === 'object' && !Array.isArray(args[i])) {
      for (const k in args[i]) {
        if (serialize && serialize.indexOf(k) > -1 && k in serializers) {
          args[i][k] = serializers[k](args[i][k])
        }
      }
    }
  }
}

function bind (parent, bindings, level) {
  return function () {
    const args = new Array(1 + arguments.length)
    args[0] = bindings
    for (var i = 1; i < args.length; i++) {
      args[i] = arguments[i - 1]
    }
    return parent[level].apply(this, args)
  }
}

function transmit (logger, opts, args) {
  const send = opts.send
  const ts = opts.ts
  const methodLevel = opts.methodLevel
  const methodValue = opts.methodValue
  const val = opts.val
  const bindings = logger._logEvent.bindings

  applySerializers(
    args,
    logger._serialize || Object.keys(logger.serializers),
    logger.serializers,
    logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize
  )
  logger._logEvent.ts = ts
  logger._logEvent.messages = args.filter(function (arg) {
    // bindings can only be objects, so reference equality check via indexOf is fine
    return bindings.indexOf(arg) === -1
  })

  logger._logEvent.level.label = methodLevel
  logger._logEvent.level.value = methodValue

  send(methodLevel, logger._logEvent, val)

  logger._logEvent = createLogEventShape(bindings)
}

function createLogEventShape (bindings) {
  return {
    ts: 0,
    messages: [],
    bindings: bindings || [],
    level: { label: '', value: 0 }
  }
}

function asErrValue (err) {
  const obj = {
    type: err.constructor.name,
    msg: err.message,
    stack: err.stack
  }
  for (const key in err) {
    if (obj[key] === undefined) {
      obj[key] = err[key]
    }
  }
  return obj
}

function getTimeFunction (opts) {
  if (typeof opts.timestamp === 'function') {
    return opts.timestamp
  }
  if (opts.timestamp === false) {
    return nullTime
  }
  return epochTime
}

function mock () { return {} }
function passthrough (a) { return a }
function noop () {}

function nullTime () { return false }
function epochTime () { return Date.now() }
function unixTime () { return Math.round(Date.now() / 1000.0) }
function isoTime () { return new Date(Date.now()).toISOString() } // using Date.now() for testability

/* eslint-disable */
/* istanbul ignore next */
function pfGlobalThisOrFallback () {
  function defd (o) { return typeof o !== 'undefined' && o }
  try {
    if (typeof globalThis !== 'undefined') return globalThis
    Object.defineProperty(Object.prototype, 'globalThis', {
      get: function () {
        delete Object.prototype.globalThis
        return (this.globalThis = this)
      },
      configurable: true
    })
    return globalThis
  } catch (e) {
    return defd(self) || defd(window) || defd(this) || {}
  }
}
/* eslint-enable */


/***/ }),

/***/ "../../node_modules/idb/build/index.js":
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  deleteDB: () => (/* binding */ deleteDB),
  openDB: () => (/* binding */ openDB),
  unwrap: () => (/* reexport */ unwrap),
  wrap: () => (/* reexport */ wrap)
});

;// CONCATENATED MODULE: ../../node_modules/idb/build/wrap-idb-value.js
const instanceOfAny = (object, constructors) => constructors.some((c) => object instanceof c);

let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return (idbProxyableTypes ||
        (idbProxyableTypes = [
            IDBDatabase,
            IDBObjectStore,
            IDBIndex,
            IDBCursor,
            IDBTransaction,
        ]));
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return (cursorAdvanceMethods ||
        (cursorAdvanceMethods = [
            IDBCursor.prototype.advance,
            IDBCursor.prototype.continue,
            IDBCursor.prototype.continuePrimaryKey,
        ]));
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject) => {
        const unlisten = () => {
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = () => {
            resolve(wrap(request.result));
            unlisten();
        };
        const error = () => {
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise
        .then((value) => {
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) {
            cursorRequestMap.set(value, request);
        }
        // Catching to avoid "Uncaught Promise exceptions"
    })
        .catch(() => { });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx))
        return;
    const done = new Promise((resolve, reject) => {
        const unlisten = () => {
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = () => {
            resolve();
            unlisten();
        };
        const error = () => {
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get(target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done')
                return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') {
                return target.objectStoreNames || transactionStoreNamesMap.get(target);
            }
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') {
                return receiver.objectStoreNames[1]
                    ? undefined
                    : receiver.objectStore(receiver.objectStoreNames[0]);
            }
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set(target, prop, value) {
        target[prop] = value;
        return true;
    },
    has(target, prop) {
        if (target instanceof IDBTransaction &&
            (prop === 'done' || prop === 'store')) {
            return true;
        }
        return prop in target;
    },
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction &&
        !('objectStoreNames' in IDBTransaction.prototype)) {
        return function (storeNames, ...args) {
            const tx = func.call(unwrap(this), storeNames, ...args);
            transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [storeNames]);
            return wrap(tx);
        };
    }
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) {
        return function (...args) {
            // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
            // the original object.
            func.apply(unwrap(this), args);
            return wrap(cursorRequestMap.get(this));
        };
    }
    return function (...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function')
        return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction)
        cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes()))
        return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest)
        return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value))
        return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value) => reverseTransformCache.get(value);



;// CONCATENATED MODULE: ../../node_modules/idb/build/index.js



/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */
function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = wrap(request);
    if (upgrade) {
        request.addEventListener('upgradeneeded', (event) => {
            upgrade(wrap(request.result), event.oldVersion, event.newVersion, wrap(request.transaction), event);
        });
    }
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    }
    openPromise
        .then((db) => {
        if (terminated)
            db.addEventListener('close', () => terminated());
        if (blocking) {
            db.addEventListener('versionchange', (event) => blocking(event.oldVersion, event.newVersion, event));
        }
    })
        .catch(() => { });
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */
function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) {
        request.addEventListener('blocked', (event) => blocked(
        // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    }
    return wrap(request).then(() => undefined);
}

const readMethods = ['get', 'getKey', 'getAll', 'getAllKeys', 'count'];
const writeMethods = ['put', 'add', 'delete', 'clear'];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase &&
        !(prop in target) &&
        typeof prop === 'string')) {
        return;
    }
    if (cachedMethods.get(prop))
        return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) ||
        !(isWrite || readMethods.includes(targetFuncName))) {
        return;
    }
    const method = async function (storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex)
            target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done,
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
replaceTraps((oldTraps) => ({
    ...oldTraps,
    get: (target, prop, receiver) => getMethod(target, prop) || oldTraps.get(target, prop, receiver),
    has: (target, prop) => !!getMethod(target, prop) || oldTraps.has(target, prop),
}));




/***/ }),

/***/ "../../node_modules/@lit-protocol/constants/src/lib/abis/ERC20.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"abi":[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}]}');

/***/ }),

/***/ "../../node_modules/@lit-protocol/constants/src/lib/abis/LIT.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"contractName":"LIT","abi":[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"userAddress","type":"address"},{"indexed":false,"internalType":"address payable","name":"relayerAddress","type":"address"},{"indexed":false,"internalType":"bytes","name":"functionSignature","type":"bytes"}],"name":"MetaTransactionExecuted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256[]","name":"ids","type":"uint256[]"},{"indexed":false,"internalType":"uint256[]","name":"values","type":"uint256[]"}],"name":"TransferBatch","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"TransferSingle","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"value","type":"string"},{"indexed":true,"internalType":"uint256","name":"id","type":"uint256"}],"name":"URI","type":"event"},{"inputs":[],"name":"ERC712_VERSION","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"address[]","name":"accounts","type":"address[]"},{"internalType":"uint256[]","name":"ids","type":"uint256[]"}],"name":"balanceOfBatch","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"address","name":"userAddress","type":"address"},{"internalType":"bytes","name":"functionSignature","type":"bytes"},{"internalType":"bytes32","name":"sigR","type":"bytes32"},{"internalType":"bytes32","name":"sigS","type":"bytes32"},{"internalType":"uint8","name":"sigV","type":"uint8"}],"name":"executeMetaTransaction","outputs":[{"internalType":"bytes","name":"","type":"bytes"}],"stateMutability":"payable","type":"function","payable":true},{"inputs":[],"name":"getChainId","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"pure","type":"function","constant":true},{"inputs":[],"name":"getDomainSeperator","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"address","name":"user","type":"address"}],"name":"getNonce","outputs":[{"internalType":"uint256","name":"nonce","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256[]","name":"ids","type":"uint256[]"},{"internalType":"uint256[]","name":"amounts","type":"uint256[]"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeBatchTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"id","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"tokenIds","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"uri","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"quantity","type":"uint256"}],"name":"mint","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"},{"internalType":"address","name":"_operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"isOperator","type":"bool"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"bool","name":"enabled","type":"bool"}],"name":"setOpenseaProxyEnabled","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newAdmin","type":"address"}],"name":"changeAdmin","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"uri","type":"string"}],"name":"setURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getAdmin","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true}]}');

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/refs/data.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON AnySchema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

/***/ }),

/***/ "../../node_modules/ajv-formats/node_modules/ajv/dist/refs/json-schema-draft-07.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

/***/ }),

/***/ "../../node_modules/browserify-aes/modes/list.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

/***/ }),

/***/ "../../node_modules/browserify-sign/browser/algorithms.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

/***/ }),

/***/ "../../node_modules/browserify-sign/browser/curves.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

/***/ }),

/***/ "../../node_modules/diffie-hellman/lib/primes.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"}}');

/***/ }),

/***/ "../../node_modules/elliptic/package.json":
/***/ ((module) => {

"use strict";
module.exports = {"i8":"6.5.4"};

/***/ }),

/***/ "../../node_modules/parse-asn1/aesid.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

/***/ }),

/***/ "../../node_modules/websocket/package.json":
/***/ ((module) => {

"use strict";
module.exports = {"version":"1.0.34"};

/***/ }),

/***/ "./node_modules/ajv/dist/refs/data.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON AnySchema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

/***/ }),

/***/ "./node_modules/ajv/dist/refs/json-schema-draft-07.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

/***/ }),

/***/ "./src/config.schema.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"$id":"config.schema.json","$schema":"http://json-schema.org/draft-07/schema#","description":"Client configuration format","type":"object","additionalProperties":false,"properties":{"id":{"type":"string"},"logLevel":{"type":"string","enum":["silent","fatal","error","warn","info","debug","trace"],"default":"info"},"auth":{"type":"object","additionalProperties":false,"properties":{"privateKey":{"type":"string","format":"ethereum-private-key"},"address":{"type":"string","format":"ethereum-address"},"ethereum":{"type":"object"}}},"orderMessages":{"type":"boolean","default":true},"gapFill":{"type":"boolean","default":true},"maxGapRequests":{"type":"number","default":5},"retryResendAfter":{"type":"number","default":5000},"gapFillTimeout":{"type":"number","default":5000},"network":{"type":"object","additionalProperties":false,"required":[],"properties":{"id":{"type":"string"},"acceptProxyConnections":{"type":"boolean","default":false},"trackers":{"anyOf":[{"type":"array","items":{"type":"object","additionalProperties":false,"required":["id","http","ws"],"properties":{"id":{"type":"string","format":"ethereum-address"},"http":{"type":"string","format":"uri"},"ws":{"type":"string","format":"uri"}}}},{"type":"object","required":["contractAddress"],"additionalProperties":false,"properties":{"contractAddress":{"type":"string","format":"ethereum-address"}}}],"default":{"contractAddress":"0xab9BEb0e8B106078c953CcAB4D6bF9142BeF854d"}},"trackerPingInterval":{"type":"number","default":60000},"trackerConnectionMaintenanceInterval":{"type":"number","default":5000},"webrtcDisallowPrivateAddresses":{"type":"boolean","default":true},"newWebrtcConnectionTimeout":{"type":"number","default":15000},"webrtcDatachannelBufferThresholdLow":{"type":"number","default":32768},"webrtcDatachannelBufferThresholdHigh":{"type":"number","default":131072},"webrtcSendBufferMaxMessageCount":{"type":"number","default":500},"webrtcMaxMessageSize":{"type":"number","default":1048576},"webrtcPortRange":{"type":"object","additionalProperties":false,"required":["min","max"],"properties":{"min":{"type":"number"},"max":{"type":"number"}},"default":{"min":6000,"max":65535}},"disconnectionWaitTime":{"type":"number","default":200},"peerPingInterval":{"type":"number","default":30000},"rttUpdateTimeout":{"type":"number","default":15000},"externalIp":{"type":"string","format":"ipv4"},"iceServers":{"type":"array","items":{"type":"object","required":["url","port"],"additionalProperties":false,"properties":{"url":{"type":"string"},"port":{"type":"number"},"username":{"type":"string"},"password":{"type":"string"},"tcp":{"type":"boolean"}}},"default":[{"url":"stun:stun.streamr.network","port":5349},{"url":"turn:turn.streamr.network","port":5349,"username":"BrubeckTurn1","password":"MIlbgtMw4nhpmbgqRrht1Q=="},{"url":"turn:turn.streamr.network","port":5349,"username":"BrubeckTurn1","password":"MIlbgtMw4nhpmbgqRrht1Q==","tcp":true}]},"location":{"type":"object","additionalProperties":false,"properties":{"latitude":{"type":"number"},"longitude":{"type":"number"},"country":{"type":"string"},"city":{"type":"string"}}}},"default":{}},"contracts":{"type":"object","additionalProperties":false,"properties":{"streamRegistryChainAddress":{"type":"string","format":"ethereum-address","default":"0x0D483E10612F327FC11965Fc82E90dC19b141641"},"streamStorageRegistryChainAddress":{"type":"string","format":"ethereum-address","default":"0xe8e2660CeDf2a59C917a5ED05B72df4146b58399"},"storageNodeRegistryChainAddress":{"type":"string","format":"ethereum-address","default":"0x080F34fec2bc33928999Ea9e39ADc798bEF3E0d6"},"mainChainRPCs":{"anyOf":[{"$ref":"#/definitions/chainConnectionInfoList"},{"type":"string","format":"uri"}],"default":{"name":"ethereum","chainId":1,"rpcs":[{"url":"https://eth-rpc.gateway.pokt.network","timeout":120000},{"url":"https://ethereum.publicnode.com","timeout":120000},{"url":"https://rpc.ankr.com/eth","timeout":120000}]}},"streamRegistryChainRPCs":{"$ref":"#/definitions/chainConnectionInfoList","default":{"name":"polygon","chainId":137,"rpcs":[{"url":"https://polygon-rpc.com","timeout":120000},{"url":"https://poly-rpc.gateway.pokt.network/","timeout":120000}]}},"ethereumNetworks":{"type":"object","default":{"polygon":{"chainId":137,"highGasPriceStrategy":true}}},"theGraphUrl":{"type":"string","format":"uri","default":"https://api.thegraph.com/subgraphs/name/streamr-dev/streams"},"maxConcurrentCalls":{"type":"number","default":10},"pollInterval":{"type":"number"}},"default":{}},"encryption":{"type":"object","additionalProperties":false,"properties":{"litProtocolEnabled":{"type":"boolean","default":false},"litProtocolLogging":{"type":"boolean","default":false},"keyRequestTimeout":{"type":"number","default":30000},"maxKeyRequestsPerSecond":{"type":"number","default":20}},"default":{}},"metrics":{"anyOf":[{"type":"boolean"},{"type":"object","additionalProperties":false,"properties":{"periods":{"type":"array","items":{"type":"object","required":["streamId","duration"],"properties":{"id":{"type":"string"},"duration":{"type":"number"}}}},"maxPublishDelay":{"type":"number"}}}]},"cache":{"type":"object","additionalProperties":false,"properties":{"maxSize":{"type":"number","default":10000},"maxAge":{"type":"number","default":86400000}},"default":{}},"_timeouts":{"type":"object","additionalProperties":false,"properties":{"theGraph":{"type":"object","additionalProperties":false,"properties":{"timeout":{"type":"number","default":60000},"retryInterval":{"type":"number","default":1000}},"default":{}},"storageNode":{"type":"object","additionalProperties":false,"properties":{"timeout":{"type":"number","default":30000},"retryInterval":{"type":"number","default":1000}},"default":{}},"ensStreamCreation":{"type":"object","additionalProperties":false,"properties":{"timeout":{"type":"number","default":180000},"retryInterval":{"type":"number","default":1000}},"default":{}},"httpFetchTimeout":{"type":"number","default":30000}},"default":{}}},"definitions":{"rpcProviderConfig":{"type":"object","required":["url"],"properties":{"url":{"type":"string","format":"uri"},"user":{"type":"string"},"password":{"type":"string"},"allowInsecureAuthentication":{"type":"boolean"},"timeout":{"type":"number","default":120000},"headers":{"type":"object"}}},"chainConnectionInfoList":{"type":"object","additionalProperties":false,"required":["rpcs","chainId"],"properties":{"chainId":{"type":"number"},"name":{"type":"string"},"rpcs":{"type":"array","items":{"type":"object","$ref":"#/definitions/rpcProviderConfig"},"minItems":1}}}}}');

/***/ }),

/***/ "./src/ethereumArtifacts/NodeRegistryAbi.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('[{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"previousAdmin","type":"address"},{"indexed":false,"internalType":"address","name":"newAdmin","type":"address"}],"name":"AdminChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"beacon","type":"address"}],"name":"BeaconUpgraded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"nodeAddress","type":"address"}],"name":"NodeRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"nodeAddress","type":"address"},{"indexed":false,"internalType":"string","name":"metadata","type":"string"},{"indexed":true,"internalType":"uint256","name":"isNew","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lastSeen","type":"uint256"}],"name":"NodeUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"nodeAddress","type":"address"}],"name":"NodeWhitelistApproved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"nodeAddress","type":"address"}],"name":"NodeWhitelistRejected","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bool","name":"value","type":"bool"}],"name":"RequiresWhitelistChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"implementation","type":"address"}],"name":"Upgraded","type":"event"},{"inputs":[{"internalType":"address","name":"node","type":"address"},{"internalType":"string","name":"metadata_","type":"string"}],"name":"createOrUpdateNode","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"metadata_","type":"string"}],"name":"createOrUpdateNodeSelf","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"getNode","outputs":[{"components":[{"internalType":"address","name":"nodeAddress","type":"address"},{"internalType":"string","name":"metadata","type":"string"},{"internalType":"uint256","name":"lastSeen","type":"uint256"}],"internalType":"struct NodeRegistry.Node","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"i","type":"uint256"}],"name":"getNodeByNumber","outputs":[{"components":[{"internalType":"address","name":"nodeAddress","type":"address"},{"internalType":"string","name":"metadata","type":"string"},{"internalType":"uint256","name":"lastSeen","type":"uint256"}],"internalType":"struct NodeRegistry.Node","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNodes","outputs":[{"components":[{"internalType":"address","name":"nodeAddress","type":"address"},{"internalType":"string","name":"metadata","type":"string"},{"internalType":"uint256","name":"lastSeen","type":"uint256"}],"internalType":"struct NodeRegistry.Node[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"headNode","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"bool","name":"requiresWhitelist_","type":"bool"},{"internalType":"address[]","name":"initialNodes","type":"address[]"},{"internalType":"string[]","name":"initialMetadata","type":"string[]"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"kickOut","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"nodeCount","outputs":[{"internalType":"uint64","name":"","type":"uint64"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nodes","outputs":[{"components":[{"internalType":"address","name":"nodeAddress","type":"address"},{"internalType":"string","name":"metadata","type":"string"},{"internalType":"uint256","name":"lastSeen","type":"uint256"}],"internalType":"struct NodeRegistry.Node","name":"node","type":"tuple"},{"internalType":"address","name":"next","type":"address"},{"internalType":"address","name":"prev","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"removeNode","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"removeNodeSelf","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"requiresWhitelist","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bool","name":"value","type":"bool"}],"name":"setRequiresWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"tailNode","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"}],"name":"upgradeTo","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"upgradeToAndCall","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"whitelist","outputs":[{"internalType":"enum NodeRegistry.WhitelistState","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"whitelistApproveNode","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"whitelistRejectNode","outputs":[],"stateMutability":"nonpayable","type":"function"}]');

/***/ }),

/***/ "./src/ethereumArtifacts/StreamRegistryV4Abi.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('[{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"previousAdmin","type":"address"},{"indexed":false,"internalType":"address","name":"newAdmin","type":"address"}],"name":"AdminChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"beacon","type":"address"}],"name":"BeaconUpgraded","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"streamId","type":"string"},{"indexed":false,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"bool","name":"canEdit","type":"bool"},{"indexed":false,"internalType":"bool","name":"canDelete","type":"bool"},{"indexed":false,"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"indexed":false,"internalType":"bool","name":"canGrant","type":"bool"}],"name":"PermissionUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"bytes32","name":"previousAdminRole","type":"bytes32"},{"indexed":true,"internalType":"bytes32","name":"newAdminRole","type":"bytes32"}],"name":"RoleAdminChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"sender","type":"address"}],"name":"RoleGranted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bytes32","name":"role","type":"bytes32"},{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":true,"internalType":"address","name":"sender","type":"address"}],"name":"RoleRevoked","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"id","type":"string"},{"indexed":false,"internalType":"string","name":"metadata","type":"string"}],"name":"StreamCreated","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"id","type":"string"}],"name":"StreamDeleted","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"id","type":"string"},{"indexed":false,"internalType":"string","name":"metadata","type":"string"}],"name":"StreamUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"implementation","type":"address"}],"name":"Upgraded","type":"event"},{"inputs":[],"name":"DEFAULT_ADMIN_ROLE","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"ownerAddress","type":"address"},{"internalType":"string","name":"ensName","type":"string"},{"internalType":"string","name":"streamIdPath","type":"string"},{"internalType":"string","name":"metadataJsonString","type":"string"}],"name":"ENScreateStreamCallback","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"MAX_INT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"TRUSTED_ROLE","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"addressToString","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"string[]","name":"streamIdPaths","type":"string[]"},{"internalType":"string[]","name":"metadataJsonStrings","type":"string[]"},{"internalType":"address[][]","name":"users","type":"address[][]"},{"components":[{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"canDelete","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"internalType":"struct StreamRegistryV4.Permission[][]","name":"permissions","type":"tuple[][]"}],"name":"createMultipleStreamsWithPermissions","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamIdPath","type":"string"},{"internalType":"string","name":"metadataJsonString","type":"string"}],"name":"createStream","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"ensName","type":"string"},{"internalType":"string","name":"streamIdPath","type":"string"},{"internalType":"string","name":"metadataJsonString","type":"string"}],"name":"createStreamWithENS","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamIdPath","type":"string"},{"internalType":"string","name":"metadataJsonString","type":"string"},{"internalType":"address[]","name":"users","type":"address[]"},{"components":[{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"canDelete","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"internalType":"struct StreamRegistryV4.Permission[]","name":"permissions","type":"tuple[]"}],"name":"createStreamWithPermissions","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"}],"name":"deleteStream","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"}],"name":"exists","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"}],"name":"getAddressKey","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"}],"name":"getDirectPermissionsForUser","outputs":[{"components":[{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"canDelete","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"internalType":"struct StreamRegistryV4.Permission","name":"permission","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"}],"name":"getPermissionsForUser","outputs":[{"components":[{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"canDelete","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"internalType":"struct StreamRegistryV4.Permission","name":"permission","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"}],"name":"getRoleAdmin","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"}],"name":"getStreamMetadata","outputs":[{"internalType":"string","name":"des","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getTrustedRole","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"},{"internalType":"enum StreamRegistryV4.PermissionType","name":"permissionType","type":"uint8"}],"name":"grantPermission","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"enum StreamRegistryV4.PermissionType","name":"permissionType","type":"uint8"}],"name":"grantPublicPermission","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"grantRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"},{"internalType":"enum StreamRegistryV4.PermissionType","name":"permissionType","type":"uint8"}],"name":"hasDirectPermission","outputs":[{"internalType":"bool","name":"userHasPermission","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"},{"internalType":"enum StreamRegistryV4.PermissionType","name":"permissionType","type":"uint8"}],"name":"hasPermission","outputs":[{"internalType":"bool","name":"userHasPermission","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"enum StreamRegistryV4.PermissionType","name":"permissionType","type":"uint8"}],"name":"hasPublicPermission","outputs":[{"internalType":"bool","name":"userHasPermission","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"hasRole","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"ensCacheAddr","type":"address"},{"internalType":"address","name":"trustedForwarderAddress","type":"address"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"forwarder","type":"address"}],"name":"isTrustedForwarder","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"renounceRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"}],"name":"revokeAllPermissionsForUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"},{"internalType":"enum StreamRegistryV4.PermissionType","name":"permissionType","type":"uint8"}],"name":"revokePermission","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"enum StreamRegistryV4.PermissionType","name":"permissionType","type":"uint8"}],"name":"revokePublicPermission","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"role","type":"bytes32"},{"internalType":"address","name":"account","type":"address"}],"name":"revokeRole","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"ensCacheAddr","type":"address"}],"name":"setEnsCache","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"},{"internalType":"enum StreamRegistryV4.PermissionType","name":"permissionType","type":"uint8"},{"internalType":"uint256","name":"expirationTime","type":"uint256"}],"name":"setExpirationTime","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address[]","name":"users","type":"address[]"},{"components":[{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"canDelete","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"internalType":"struct StreamRegistryV4.Permission[]","name":"permissions","type":"tuple[]"}],"name":"setPermissions","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"},{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"deletePerm","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"name":"setPermissionsForUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string[]","name":"streamIds","type":"string[]"},{"internalType":"address[][]","name":"users","type":"address[][]"},{"components":[{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"canDelete","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"internalType":"struct StreamRegistryV4.Permission[][]","name":"permissions","type":"tuple[][]"}],"name":"setPermissionsMultipleStreams","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string[]","name":"streamIds","type":"string[]"},{"internalType":"address[][]","name":"users","type":"address[][]"},{"components":[{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"canDelete","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"internalType":"struct StreamRegistryV4.Permission[][]","name":"permissions","type":"tuple[][]"}],"name":"setPermissionsMultipleStreans","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"}],"name":"setPublicPermission","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"forwarder","type":"address"}],"name":"setTrustedForwarder","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"","type":"string"}],"name":"streamIdToMetadata","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"","type":"string"},{"internalType":"bytes32","name":"","type":"bytes32"}],"name":"streamIdToPermissions","outputs":[{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"canDelete","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"recipient","type":"address"}],"name":"transferAllPermissionsToUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"enum StreamRegistryV4.PermissionType","name":"permissionType","type":"uint8"}],"name":"transferPermissionToUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string[]","name":"streamIds","type":"string[]"},{"internalType":"string[]","name":"metadatas","type":"string[]"}],"name":"trustedCreateStreams","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string[]","name":"streamids","type":"string[]"},{"internalType":"address[]","name":"users","type":"address[]"},{"components":[{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"canDelete","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"internalType":"struct StreamRegistryV4.Permission[]","name":"permissions","type":"tuple[]"}],"name":"trustedSetPermissions","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"user","type":"address"},{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"deletePerm","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"name":"trustedSetPermissionsForUser","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"string","name":"metadata","type":"string"}],"name":"trustedSetStreamMetadata","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"string","name":"metadata","type":"string"},{"internalType":"address","name":"user","type":"address"},{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"deletePerm","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"name":"trustedSetStreamWithPermission","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string[]","name":"streamids","type":"string[]"},{"internalType":"address[]","name":"users","type":"address[]"},{"internalType":"string[]","name":"metadatas","type":"string[]"},{"components":[{"internalType":"bool","name":"canEdit","type":"bool"},{"internalType":"bool","name":"canDelete","type":"bool"},{"internalType":"uint256","name":"publishExpiration","type":"uint256"},{"internalType":"uint256","name":"subscribeExpiration","type":"uint256"},{"internalType":"bool","name":"canGrant","type":"bool"}],"internalType":"struct StreamRegistryV4.Permission[]","name":"permissions","type":"tuple[]"}],"name":"trustedSetStreams","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"string","name":"metadata","type":"string"}],"name":"updateStreamMetadata","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"}],"name":"upgradeTo","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"upgradeToAndCall","outputs":[],"stateMutability":"payable","type":"function"}]');

/***/ }),

/***/ "./src/ethereumArtifacts/StreamStorageRegistryV2Abi.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('[{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"streamId","type":"string"},{"indexed":true,"internalType":"address","name":"nodeAddress","type":"address"}],"name":"Added","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"previousAdmin","type":"address"},{"indexed":false,"internalType":"address","name":"newAdmin","type":"address"}],"name":"AdminChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"beacon","type":"address"}],"name":"BeaconUpgraded","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"streamId","type":"string"},{"indexed":true,"internalType":"address","name":"nodeAddress","type":"address"}],"name":"Removed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"implementation","type":"address"}],"name":"Upgraded","type":"event"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address[]","name":"addNodes","type":"address[]"},{"internalType":"address[]","name":"removeNodes","type":"address[]"}],"name":"addAndRemoveStorageNodes","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"addStorageNode","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"streamRegistryAddress","type":"address"},{"internalType":"address","name":"nodeRegistryAddress","type":"address"},{"internalType":"address","name":"trustedForwarderAddress","type":"address"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"isStorageNodeOf","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"forwarder","type":"address"}],"name":"isTrustedForwarder","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"nodeRegistry","outputs":[{"internalType":"contract NodeRegistry","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"","type":"string"},{"internalType":"address","name":"","type":"address"}],"name":"pairs","outputs":[{"internalType":"uint256","name":"dateCreated","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"removeStorageNode","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"forwarder","type":"address"}],"name":"setTrustedForwarder","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"streamRegistry","outputs":[{"internalType":"contract StreamRegistryV4","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"}],"name":"upgradeTo","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newImplementation","type":"address"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"upgradeToAndCall","outputs":[],"stateMutability":"payable","type":"function"}]');

/***/ }),

/***/ "./src/ethereumArtifacts/TrackerRegistry.json":
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"contractName":"SimpleTrackerRegistry","abi":[{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"bool","name":"requiresWhitelist_","type":"bool"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"nodeAddress","type":"address"}],"name":"NodeRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"nodeAddress","type":"address"},{"indexed":true,"internalType":"string","name":"url","type":"string"},{"indexed":true,"internalType":"uint256","name":"isNew","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lastSeen","type":"uint256"}],"name":"NodeUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"nodeAddress","type":"address"}],"name":"NodeWhitelistApproved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"nodeAddress","type":"address"}],"name":"NodeWhitelistRejected","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"bool","name":"value","type":"bool"}],"name":"RequiresWhitelistChanged","type":"event"},{"inputs":[],"name":"claimOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"node","type":"address"},{"internalType":"string","name":"url_","type":"string"}],"name":"createOrUpdateNode","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"url_","type":"string"}],"name":"createOrUpdateNodeSelf","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"getNode","outputs":[{"components":[{"internalType":"address","name":"nodeAddress","type":"address"},{"internalType":"string","name":"url","type":"string"},{"internalType":"uint256","name":"lastSeen","type":"uint256"}],"internalType":"struct NodeRegistry.Node","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"i","type":"uint256"}],"name":"getNodeByNumber","outputs":[{"components":[{"internalType":"address","name":"nodeAddress","type":"address"},{"internalType":"string","name":"url","type":"string"},{"internalType":"uint256","name":"lastSeen","type":"uint256"}],"internalType":"struct NodeRegistry.Node","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNodes","outputs":[{"components":[{"internalType":"address","name":"nodeAddress","type":"address"},{"internalType":"string","name":"url","type":"string"},{"internalType":"uint256","name":"lastSeen","type":"uint256"}],"internalType":"struct NodeRegistry.Node[]","name":"","type":"tuple[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"headNode","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"kickOut","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"nodeCount","outputs":[{"internalType":"uint64","name":"","type":"uint64"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pendingOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"removeNode","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"removeNodeSelf","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bool","name":"value","type":"bool"}],"name":"setRequiresWhitelist","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"tailNode","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"whitelistApproveNode","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"nodeAddress","type":"address"}],"name":"whitelistRejectNode","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"streamId","type":"string"},{"internalType":"uint256","name":"partition","type":"uint256"}],"name":"getTrackers","outputs":[{"internalType":"string[]","name":"","type":"string[]"}],"stateMutability":"view","type":"function"}],"metadata":"{\\"compiler\\":{\\"version\\":\\"0.6.6+commit.6c089d02\\"},\\"language\\":\\"Solidity\\",\\"output\\":{\\"abi\\":[{\\"inputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"owner\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"bool\\",\\"name\\":\\"requiresWhitelist_\\",\\"type\\":\\"bool\\"}],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"constructor\\"},{\\"anonymous\\":false,\\"inputs\\":[{\\"indexed\\":true,\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"}],\\"name\\":\\"NodeRemoved\\",\\"type\\":\\"event\\"},{\\"anonymous\\":false,\\"inputs\\":[{\\"indexed\\":true,\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"},{\\"indexed\\":true,\\"internalType\\":\\"string\\",\\"name\\":\\"url\\",\\"type\\":\\"string\\"},{\\"indexed\\":true,\\"internalType\\":\\"uint256\\",\\"name\\":\\"isNew\\",\\"type\\":\\"uint256\\"},{\\"indexed\\":false,\\"internalType\\":\\"uint256\\",\\"name\\":\\"lastSeen\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"NodeUpdated\\",\\"type\\":\\"event\\"},{\\"anonymous\\":false,\\"inputs\\":[{\\"indexed\\":true,\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"}],\\"name\\":\\"NodeWhitelistApproved\\",\\"type\\":\\"event\\"},{\\"anonymous\\":false,\\"inputs\\":[{\\"indexed\\":true,\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"}],\\"name\\":\\"NodeWhitelistRejected\\",\\"type\\":\\"event\\"},{\\"anonymous\\":false,\\"inputs\\":[{\\"indexed\\":true,\\"internalType\\":\\"address\\",\\"name\\":\\"previousOwner\\",\\"type\\":\\"address\\"},{\\"indexed\\":true,\\"internalType\\":\\"address\\",\\"name\\":\\"newOwner\\",\\"type\\":\\"address\\"}],\\"name\\":\\"OwnershipTransferred\\",\\"type\\":\\"event\\"},{\\"anonymous\\":false,\\"inputs\\":[{\\"indexed\\":true,\\"internalType\\":\\"bool\\",\\"name\\":\\"value\\",\\"type\\":\\"bool\\"}],\\"name\\":\\"RequiresWhitelistChanged\\",\\"type\\":\\"event\\"},{\\"inputs\\":[],\\"name\\":\\"claimOwnership\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"node\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"url_\\",\\"type\\":\\"string\\"}],\\"name\\":\\"createOrUpdateNode\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"string\\",\\"name\\":\\"url_\\",\\"type\\":\\"string\\"}],\\"name\\":\\"createOrUpdateNodeSelf\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"}],\\"name\\":\\"getNode\\",\\"outputs\\":[{\\"components\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"url\\",\\"type\\":\\"string\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"lastSeen\\",\\"type\\":\\"uint256\\"}],\\"internalType\\":\\"struct NodeRegistry.Node\\",\\"name\\":\\"\\",\\"type\\":\\"tuple\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"uint256\\",\\"name\\":\\"i\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"getNodeByNumber\\",\\"outputs\\":[{\\"components\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"url\\",\\"type\\":\\"string\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"lastSeen\\",\\"type\\":\\"uint256\\"}],\\"internalType\\":\\"struct NodeRegistry.Node\\",\\"name\\":\\"\\",\\"type\\":\\"tuple\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"getNodes\\",\\"outputs\\":[{\\"components\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"},{\\"internalType\\":\\"string\\",\\"name\\":\\"url\\",\\"type\\":\\"string\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"lastSeen\\",\\"type\\":\\"uint256\\"}],\\"internalType\\":\\"struct NodeRegistry.Node[]\\",\\"name\\":\\"\\",\\"type\\":\\"tuple[]\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"string\\",\\"name\\":\\"streamId\\",\\"type\\":\\"string\\"},{\\"internalType\\":\\"uint256\\",\\"name\\":\\"partition\\",\\"type\\":\\"uint256\\"}],\\"name\\":\\"getTrackers\\",\\"outputs\\":[{\\"internalType\\":\\"string[]\\",\\"name\\":\\"\\",\\"type\\":\\"string[]\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"headNode\\",\\"outputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"}],\\"name\\":\\"kickOut\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"nodeCount\\",\\"outputs\\":[{\\"internalType\\":\\"uint64\\",\\"name\\":\\"\\",\\"type\\":\\"uint64\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"owner\\",\\"outputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"pendingOwner\\",\\"outputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"}],\\"name\\":\\"removeNode\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"removeNodeSelf\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"bool\\",\\"name\\":\\"value\\",\\"type\\":\\"bool\\"}],\\"name\\":\\"setRequiresWhitelist\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[],\\"name\\":\\"tailNode\\",\\"outputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"\\",\\"type\\":\\"address\\"}],\\"stateMutability\\":\\"view\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"newOwner\\",\\"type\\":\\"address\\"}],\\"name\\":\\"transferOwnership\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"}],\\"name\\":\\"whitelistApproveNode\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"},{\\"inputs\\":[{\\"internalType\\":\\"address\\",\\"name\\":\\"nodeAddress\\",\\"type\\":\\"address\\"}],\\"name\\":\\"whitelistRejectNode\\",\\"outputs\\":[],\\"stateMutability\\":\\"nonpayable\\",\\"type\\":\\"function\\"}],\\"devdoc\\":{\\"methods\\":{\\"claimOwnership()\\":{\\"details\\":\\"Allows the pendingOwner address to finalize the transfer.\\"},\\"transferOwnership(address)\\":{\\"details\\":\\"Allows the current owner to set the pendingOwner address.\\",\\"params\\":{\\"newOwner\\":\\"The address to transfer ownership to.\\"}}}},\\"userdoc\\":{\\"methods\\":{}}},\\"settings\\":{\\"compilationTarget\\":{\\"/home/heynow/streamr/network-contracts/contracts/SimpleTrackerRegistry.sol\\":\\"SimpleTrackerRegistry\\"},\\"evmVersion\\":\\"istanbul\\",\\"libraries\\":{},\\"metadata\\":{\\"bytecodeHash\\":\\"ipfs\\"},\\"optimizer\\":{\\"enabled\\":true,\\"runs\\":200},\\"remappings\\":[]},\\"sources\\":{\\"/home/heynow/streamr/network-contracts/contracts/NodeRegistry.sol\\":{\\"keccak256\\":\\"0xa2d60ab354f7a6a833b27d3e76522462b2a61c172591987c59a71dceee5e08d2\\",\\"urls\\":[\\"bzz-raw://2be64d7ab211535789b8089409272c039d4d9b4ca09547d767bbc2d313c4cd01\\",\\"dweb:/ipfs/QmTnJ13eoFwvV7xLKEFMrYCmnstEKEiAp5k28TkMDdjigY\\"]},\\"/home/heynow/streamr/network-contracts/contracts/Ownable.sol\\":{\\"keccak256\\":\\"0x8e5368ad3ec610556637ae08dd70ad0fb552b94d411a599ca6623bf66fb6fc52\\",\\"urls\\":[\\"bzz-raw://d1e510ab06e5a8cac23269350011bab848235bb9fefe327d7004ee3852eef35c\\",\\"dweb:/ipfs/QmYQjNk6DMqMZMYdjocb7fUcseEW1jBQTwA6v6qjC7YmDP\\"]},\\"/home/heynow/streamr/network-contracts/contracts/SimpleTrackerRegistry.sol\\":{\\"keccak256\\":\\"0x96844ee4595348477ee19fb997bf56ebc022b4f77b4c07c9ae7efd8184fa1fd8\\",\\"urls\\":[\\"bzz-raw://5627f8728e06365ad64a5e5f0c8853bca7fd74bcb25f97f41b11a8722833fb34\\",\\"dweb:/ipfs/QmRsDECrBH6iDTFyU4dK3b5tWKaAg1zBMaPCGCuYgpnNyj\\"]},\\"/home/heynow/streamr/network-contracts/contracts/TrackerRegistry.sol\\":{\\"keccak256\\":\\"0x135f790f889da86b0e8db0eef72f58625e86a724ead56a2d466a338e57c59273\\",\\"urls\\":[\\"bzz-raw://27dbc27b2580f61796172a8d2d1a3ad443692031654048d8845efb98a9210de2\\",\\"dweb:/ipfs/QmXW9hiV3cNCKAjbk4xuu7kjY2CuYWi6xigPPhFT6CkQmz\\"]}},\\"version\\":1}","bytecode":"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","deployedBytecode":"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","immutableReferences":{},"sourceMap":"120:540:6:-:0;;;190:101;5:9:-1;2:2;;;27:1;24;17:12;2:2;190:101:6;;;;;;;;;;;;;;;;;;;;;578:5:5;:14;;-1:-1:-1;;;;;578:14:5;;;-1:-1:-1;;;;;;578:14:5;;;;;;;;;;1574:17:4::1;:38:::0;;;::::1;;-1:-1:-1::0;;;1574:38:4::1;-1:-1:-1::0;;;;1574:38:4;;::::1;::::0;;;::::1;::::0;;120:540:6;;281:393:-1;;;410:2;398:9;389:7;385:23;381:32;378:2;;;-1:-1;;416:12;378:2;83:13;;-1:-1;;;;;933:54;;1058:35;;1048:2;;-1:-1;;1097:12;1048:2;579;626:22;;221:13;468:74;;-1:-1;845:13;;838:21;1179:32;;1169:2;;-1:-1;;1215:12;1169:2;587:71;;;;372:302;;;;;;;120:540:6;;;;;;","deployedSourceMap":"120:540:6:-:0;;;;5:9:-1;2:2;;;27:1;24;17:12;2:2;120:540:6;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;12:1:-1;9;2:12;4504:147:4;;;;;;;;;:::i;:::-;;4170:181;;;;;;;;;:::i;1332:23::-;;;:::i;:::-;;;;;;;;;;;;;;;;1124:226:5;;;:::i;4361:137:4:-;;;;;;;;;:::i;3978:182::-;;;;;;;;;:::i;1794:127::-;;;;;;;;;:::i;1274:23::-;;;:::i;:::-;;;;;;;;237:20:5;;;:::i;1927:125:4:-;;;;;;;;;:::i;1625:162::-;;;;;;;;;:::i;:::-;;;;;;;;297:361:6;;;;;;;;;:::i;:::-;;;;;;;;4775:437:4;;;;;;;;;:::i;2954:99::-;;;;;;;;;:::i;1303:23::-;;;:::i;5218:418::-;;;:::i;:::-;;;;;;;;263:27:5;;;:::i;3058:73:4:-;;;:::i;930:102:5:-;;;;;;;;;:::i;4504:147:4:-;740:5:5;;-1:-1:-1;;;;;740:5:5;726:10;:19;718:41;;;;-1:-1:-1;;;718:41:5;;;;;;;;;;;;;;;;;4573:17:4::1;:25:::0;;-1:-1:-1;;;;4573:25:4::1;-1:-1:-1::0;;;4573:25:4;::::1;;::::0;;::::1;::::0;;;::::1;::::0;;;4613:31:::1;::::0;::::1;::::0;-1:-1:-1;;4613:31:4::1;4504:147:::0;:::o;4170:181::-;740:5:5;;-1:-1:-1;;;;;740:5:5;726:10;:19;718:41;;;;-1:-1:-1;;;718:41:5;;;;;;;;;-1:-1:-1;;;;;4247:22:4;::::1;;::::0;;;:9:::1;:22;::::0;;;;;:48;;-1:-1:-1;;4247:48:4::1;4272:23;4247:48;::::0;;4310:34;::::1;::::0;4247:22;4310:34:::1;4170:181:::0;:::o;1332:23::-;;;-1:-1:-1;;;;;1332:23:4;;:::o;1124:226:5:-;1189:12;;-1:-1:-1;;;;;1189:12:5;1175:10;:26;1167:55;;;;-1:-1:-1;;;1167:55:5;;;;;;;;;1265:12;;;1258:5;;1237:41;;-1:-1:-1;;;;;1265:12:5;;;;1258:5;;;;1237:41;;;1296:12;;;;1288:20;;-1:-1:-1;;;;;;1288:20:5;;;-1:-1:-1;;;;;1296:12:5;;1288:20;;;;1318:25;;;1124:226::o;4361:137:4:-;740:5:5;;-1:-1:-1;;;;;740:5:5;726:10;:19;718:41;;;;-1:-1:-1;;;718:41:5;;;;;;;;;4426:32:4::1;4446:11;4426:19;:32::i;:::-;4468:23;4479:11;4468:10;:23::i;:::-;4361:137:::0;:::o;3978:182::-;740:5:5;;-1:-1:-1;;;;;740:5:5;726:10;:19;718:41;;;;-1:-1:-1;;;718:41:5;;;;;;;;;-1:-1:-1;;;;;4056:22:4;::::1;;::::0;;;:9:::1;:22;::::0;;;;;:48;;-1:-1:-1;;4056:48:4::1;4081:23;4056:48;::::0;;4119:34;::::1;::::0;4056:22;4119:34:::1;3978:182:::0;:::o;1794:127::-;740:5:5;;-1:-1:-1;;;;;740:5:5;726:10;:19;718:41;;;;-1:-1:-1;;;718:41:5;;;;;;;;;1883:31:4::1;1903:4;1909;1883:19;:31::i;:::-;1794:127:::0;;:::o;1274:23::-;;;-1:-1:-1;;;1274:23:4;;;;;:::o;237:20:5:-;;;-1:-1:-1;;;;;237:20:5;;:::o;1927:125:4:-;1165:17;;-1:-1:-1;;;1165:17:4;;;;1164:18;;:70;;-1:-1:-1;1211:23:4;1196:10;1186:21;;;;:9;:21;;;;;;;;:48;;;;;;;;;1164:70;1156:94;;;;-1:-1:-1;;;1156:94:4;;;;;;;;;2008:37:::1;2028:10;2040:4;2008:19;:37::i;1625:162::-:0;1684:11;;:::i;:::-;-1:-1:-1;;;;;1738:18:4;;;1707:28;1738:18;;;:5;:18;;;;;;;;;1766:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;1766:14:4;;;;;;;;;;;;;;;;;;;;;;;;;;1738:18;;1766:14;1738:18;;1766:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1625:162;;;:::o;297:361:6:-;388:15;415:12;451:8;461:9;440:31;;;;;;;;;;;;;;26:21:-1;;;-1:-1;;22:32;6:49;;440:31:6;;;430:42;;49:4:-1;430:42:6;;;;513:9;;430:42;;-1:-1:-1;482:12:6;;-1:-1:-1;;;513:9:6;;;;430:42;513:9;497:25;;;;559:15;;;572:1;559:15;;;;;;;;;497:25;;;;;-1:-1:-1;532:24:6;;559:15;;;;;;;;;;;;;;;;;;;;;532:42;;598:24;614:7;598:15;:24::i;:::-;:28;;;584:8;593:1;584:11;;;;;;;;;;;;;;;;;:42;643:8;297:361;-1:-1:-1;;;;;297:361:6:o;4775:437:4:-;4829:11;;:::i;:::-;4864:9;;-1:-1:-1;;;4864:9:4;;;;4860:13;;4852:67;;;;-1:-1:-1;;;4852:67:4;;;;;;;;;4958:8;;-1:-1:-1;;;;;4958:8:4;4929:26;5007:25;;;:5;:25;;;;;4958:8;5042:141;5075:1;5064:7;:12;5042:141;;5123:6;;;;;-1:-1:-1;;;;;5123:6:4;;5147:25;;;:5;:25;;;;;5123:6;;-1:-1:-1;5147:25:4;5123:6;5078:9;5042:141;;;-1:-1:-1;5192:13:4;;;;;;;;;;-1:-1:-1;;;;;5192:13:4;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;5192:13:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4775:437;;;:::o;2954:99::-;740:5:5;;-1:-1:-1;;;;;740:5:5;726:10;:19;718:41;;;;-1:-1:-1;;;718:41:5;;;;;;;;;3022:24:4::1;3034:11;3022;:24::i;1303:23::-:0;;;-1:-1:-1;;;;;1303:23:4;;:::o;5218:418::-;5321:9;;5259:13;;;;5321:9;-1:-1:-1;;;5321:9:4;;;;;;5310:21;;2:2:-1;;;;27:1;24;17:12;2:2;5310:21:4;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;-1:-1:-1;5370:8:4;;5284:47;;-1:-1:-1;;;;;;5370:8:4;5341:26;5388:216;5420:9;;-1:-1:-1;;;5420:9:4;;;;5410:19;;5388:216;;;-1:-1:-1;;;;;5486:25:4;;;5455:28;5486:25;;;:5;:25;;;;;;;;;5525:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;;5525:27:4;;;;;;;;;;;;;;;;;;;;;;;;;;5486:25;;5525:27;5486:25;;5525:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:9;5535:7;5525:18;;;;;;;;;;;;;;;;;:27;5587:6;;;-1:-1:-1;;;;;5587:6:4;;-1:-1:-1;5587:6:4;5431:9;5388:216;;;-1:-1:-1;5620:9:4;;-1:-1:-1;;5218:418:4;;:::o;263:27:5:-;;;-1:-1:-1;;;;;263:27:5;;:::o;3058:73:4:-;3101:23;3113:10;3101:11;:23::i;:::-;3058:73::o;930:102:5:-;740:5;;-1:-1:-1;;;;;740:5:5;726:10;:19;718:41;;;;-1:-1:-1;;;718:41:5;;;;;;;;;1002:12:::1;:23:::0;;-1:-1:-1;;;;;;1002:23:5::1;-1:-1:-1::0;;;;;1002:23:5;;;::::1;::::0;;;::::1;::::0;;930:102::o;2058:890:4:-;-1:-1:-1;;;;;2178:18:4;;2147:28;2178:18;;;:5;:18;;;;;2233:15;;;;2178:18;;2147:28;2230:637;;-1:-1:-1;2312:132:4;;;2338:70;;;;;-1:-1:-1;;;;;2338:70:4;;;2312:132;;;2338:70;;;;;;;;;2391:15;2338:70;;;;2312:132;;-1:-1:-1;2338:70:4;2312:132;;;;;;2416:8;;;;2312:132;;;;2291:18;;;:5;:18;;;;;;:153;;;;;;-1:-1:-1;;;;;;2291:153:4;;;;;;;;;;;;;;;-1:-1:-1;;2291:18:4;;:153;:18;;:153;;;;;;;;;;;;:::i;:::-;-1:-1:-1;2291:153:4;;;;;;;;;;;;;;;;;;;-1:-1:-1;;;;;2291:153:4;;;-1:-1:-1;;;;;;2291:153:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2458:11;;;-1:-1:-1;;;2458:11:4;;;;;;;;;;;-1:-1:-1;;;;2458:11:4;;;;;;2486:8;;:22;2483:157;;2571:8;;-1:-1:-1;;;;;2571:8:4;;;2527:35;2565:15;;;:5;:15;;;;;2598:13;;:27;;-1:-1:-1;;;;;;2598:27:4;;;;;;;;;;2483:157;2656:8;;-1:-1:-1;;;;;2656:8:4;2653:65;;2696:8;:22;;-1:-1:-1;;;;;;2696:22:4;-1:-1:-1;;;;;2696:22:4;;;;;2653:65;2732:8;:22;;-1:-1:-1;;;;;;2732:22:4;-1:-1:-1;;;;;2732:22:4;;;;;2230:637;;;2792:17;;;;:10;;;;:17;;;;;:::i;:::-;-1:-1:-1;2841:15:4;2823;;;:33;2230:637;2881:60;;2918:5;;2881:60;;2906:10;;;;2881:60;;;;;;;;;;2893:11;-1:-1:-1;;;;;2881:60:4;;2925:1;:6;;:15;;;2881:60;;;;;;;;;;;;;;;2058:890;;;;:::o;3136:836::-;-1:-1:-1;;;;;3228:18:4;;3197:28;3228:18;;;:5;:18;;;;;3264:15;;;;3256:41;;;;-1:-1:-1;;;3256:41:4;;;;;;;;;3310:6;;;;-1:-1:-1;;;;;3310:6:4;:20;3307:136;;3383:5;3389:6;;;;-1:-1:-1;;;;;3389:6:4;;;3345:35;3383:13;;;;;;;;;;;;3426:6;;;;;3410:13;;:22;;-1:-1:-1;;;;;;3410:22:4;3426:6;;;;3410:22;;;3307:136;3455:6;;;;-1:-1:-1;;;;;3455:6:4;:20;3452:136;;3534:6;;;;-1:-1:-1;;;;;3534:6:4;;;3490:35;3528:13;;;:5;:13;;;;;;;;3571:6;;;;3555:13;;:22;;-1:-1:-1;;;;;;3555:22:4;3571:6;;;;3555:22;;;3452:136;3597:9;:11;;-1:-1:-1;;3597:11:4;-1:-1:-1;;;3597:11:4;;;;;;;;;;;-1:-1:-1;;;;3597:11:4;;;;;;3636:8;;-1:-1:-1;;;;;3621:23:4;;;3636:8;;3621:23;3618:132;;;3698:8;;;-1:-1:-1;;;;;3698:8:4;;;3660:29;3692:15;;;:5;:15;;;;;;;;3732:7;;;-1:-1:-1;;;;;;3721:18:4;;;;;;3618:132;3777:8;;-1:-1:-1;;;;;3762:23:4;;;3777:8;;3762:23;3759:132;;;3839:8;;;-1:-1:-1;;;;;3839:8:4;;;3801:29;3833:15;;;:5;:15;;;;;3873:7;;;;-1:-1:-1;;;;;;3862:18:4;;;;;;3759:132;-1:-1:-1;;;;;3908:18:4;;;;;;:5;:18;;;;;3901:25;;-1:-1:-1;;;;;;3901:25:4;;;3908:18;;;3901:25;;;;3908:18;3901:25;:::i;:::-;-1:-1:-1;3901:25:4;;;;;;;;;;;;;;-1:-1:-1;;;;;;3901:25:4;;;;;;;;;;;;;;;;;;-1:-1:-1;3941:24:4;;-1:-1:-1;;;;;3941:24:4;;;;;;3136:836;;:::o;120:540:6:-;;;;;;;;;;-1:-1:-1;;;;;120:540:6;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;120:540:6;;;-1:-1:-1;120:540:6;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;274:442:-1;;376:3;369:4;361:6;357:17;353:27;343:2;;-1:-1;;384:12;343:2;431:6;418:20;15867:18;;15859:6;15856:30;15853:2;;;-1:-1;;15889:12;15853:2;15522;15516:9;15962;15943:17;;-1:-1;;15939:33;15548:17;;16030:4;15548:17;15608:34;;;15644:22;;;15605:62;15602:2;;;-1:-1;;15670:12;15602:2;15522;15689:22;524:21;;;444:74;-1:-1;444:74;624:16;;;16030:4;624:16;621:25;-1:-1;618:2;;;659:1;;649:12;618:2;18748:6;16030:4;566:6;562:17;16030:4;600:5;596:16;18725:30;18804:1;16030:4;18795:6;600:5;18786:16;;18779:27;;;;336:380;;;;;861:241;;965:2;953:9;944:7;940:23;936:32;933:2;;;-1:-1;;971:12;933:2;72:20;;-1:-1;;;;;18418:54;;19261:35;;19251:2;;-1:-1;;19300:12;19251:2;1023:63;927:175;-1:-1;;;927:175;1109:472;;;1240:2;1228:9;1219:7;1215:23;1211:32;1208:2;;;-1:-1;;1246:12;1208:2;72:20;;-1:-1;;;;;18418:54;;19261:35;;19251:2;;-1:-1;;19300:12;19251:2;1298:63;-1:-1;1426:2;1411:18;;1398:32;1450:18;1439:30;;1436:2;;;-1:-1;;1472:12;1436:2;1502:63;1557:7;1548:6;1537:9;1533:22;1502:63;;;1492:73;;;1202:379;;;;;;1588:235;;1689:2;1677:9;1668:7;1664:23;1660:32;1657:2;;;-1:-1;;1695:12;1657:2;219:6;206:20;19407:5;18330:13;18323:21;19385:5;19382:32;19372:2;;-1:-1;;19418:12;1830:347;;1944:2;1932:9;1923:7;1919:23;1915:32;1912:2;;;-1:-1;;1950:12;1912:2;2008:17;1995:31;2046:18;2038:6;2035:30;2032:2;;;-1:-1;;2068:12;2032:2;2098:63;2153:7;2144:6;2133:9;2129:22;2098:63;;;2088:73;1906:271;-1:-1;;;;1906:271;2184:472;;;2315:2;2303:9;2294:7;2290:23;2286:32;2283:2;;;-1:-1;;2321:12;2283:2;2379:17;2366:31;2417:18;2409:6;2406:30;2403:2;;;-1:-1;;2439:12;2403:2;2469:63;2524:7;2515:6;2504:9;2500:22;2469:63;;;2459:73;2569:2;2608:22;;;;791:20;;-1:-1;;;;2277:379;2663:241;;2767:2;2755:9;2746:7;2742:23;2738:32;2735:2;;;-1:-1;;2773:12;2735:2;-1:-1;791:20;;2729:175;-1:-1;2729:175;5643:327;;5778:5;16677:12;17414:6;17409:3;17402:19;-1:-1;18893:101;18907:6;18904:1;18901:13;18893:101;;;17451:4;18974:11;;;;;18968:18;18955:11;;;;;18948:39;18922:10;18893:101;;;19009:6;19006:1;19003:13;19000:2;;;-1:-1;17451:4;19065:6;17446:3;19056:16;;19049:27;19000:2;-1:-1;15962:9;19165:14;-1:-1;;19161:28;5926:39;;;;17451:4;5926:39;;5725:245;-1:-1;;5725:245;8972:717;;15867:18;;18429:42;;;9184:16;9178:23;18418:54;3427:3;3420:37;9348:4;9341:5;9337:16;9331:23;9105:4;9348;9378:3;9374:14;9367:38;9420:73;9105:4;9100:3;9096:14;9474:12;9420:73;;;9582:4;9575:5;9571:16;9565:23;9582:4;9646:3;9642:14;10550:37;9673:11;;;;;9078:611;;;;;10836:260;;-1:-1;6493:5;6487:12;6527:1;;6516:9;6512:17;6540:1;6535:268;;;;6814:1;6809:425;;;;6505:729;;6535:268;-1:-1;;6740:25;;6728:38;;6609:1;6594:17;;6613:4;6590:28;6780:16;;;-1:-1;6535:268;;6809:425;6878:1;6867:9;6863:17;16504:3;-1:-1;16494:14;16536:4;;-1:-1;16523:18;-1:-1;7067:130;7081:6;7078:1;7075:13;7067:130;;;7140:14;;7127:11;;;7120:35;7174:15;;;;7096:12;;7067:130;;;-1:-1;;;7211:16;;;-1:-1;6505:729;-1:-1;11081:10;;10960:136;-1:-1;;;;;10960:136;11103:213;-1:-1;;;;;18418:54;;;;3420:37;;11221:2;11206:18;;11192:124;11323:401;;11511:2;;11500:9;11496:18;11511:2;11532:17;11525:47;11586:128;3841:5;16677:12;17414:6;17409:3;17402:19;17442:14;11500:9;17442:14;3853:103;;17442:14;11511:2;4013:6;4009:17;11500:9;4000:27;;3988:39;;11511:2;4108:5;16177:14;-1:-1;4147:360;4172:6;4169:1;4166:13;4147:360;;;4224:20;;11500:9;4228:4;4224:20;;4219:3;4212:33;3033:66;3095:3;4279:6;4273:13;3033:66;;;4293:92;-1:-1;4486:14;;;;17111;;;;4194:1;4187:9;4147:360;;;-1:-1;11578:136;;11482:242;-1:-1;;;;;;;11482:242;11731:445;;11941:2;;11930:9;11926:18;11941:2;11962:17;11955:47;12016:150;4875:5;16677:12;17414:6;17409:3;17402:19;17442:14;11930:9;17442:14;4887:114;;17442:14;11941:2;5058:6;5054:17;11930:9;5045:27;;5033:39;;11941:2;5164:5;16177:14;-1:-1;5203:393;5228:6;5225:1;5222:13;5203:393;;;4224:20;;11930:9;5284:4;5280:20;;5275:3;5268:33;3257:88;3341:3;5335:6;5329:13;3257:88;;;5349:114;-1:-1;5575:14;;;;17111;;;;5250:1;5243:9;5203:393;;12183:412;;12349:2;12370:17;12363:47;12424:78;12349:2;12338:9;12334:18;12488:6;12424:78;;;12416:86;;10580:5;12581:2;12570:9;12566:18;10550:37;12320:275;;;;;;12602:407;12793:2;12807:47;;;7473:2;12778:18;;;17402:19;-1:-1;;;17442:14;;;7489:34;7542:12;;;12764:245;13016:407;13207:2;13221:47;;;7793:2;13192:18;;;17402:19;7829:34;17442:14;;;7809:55;-1:-1;;;7884:12;;;7877:33;7929:12;;;13178:245;13430:407;13621:2;13635:47;;;8180:1;13606:18;;;17402:19;-1:-1;;;17442:14;;;8195:31;8245:12;;;13592:245;13844:407;14035:2;14049:47;;;8496:2;14020:18;;;17402:19;-1:-1;;;17442:14;;;8512:39;8570:12;;;14006:245;14258:407;14449:2;14463:47;;;8821:1;14434:18;;;17402:19;-1:-1;;;17442:14;;;8836:32;8887:12;;;14420:245;14672:345;;14832:2;14853:17;14846:47;14907:100;14832:2;14821:9;14817:18;14993:6;14907:100;;15024:213;10550:37;;;15142:2;15127:18;;15113:124;15244:209;18635:18;18624:30;;;;10788:36;;15360:2;15345:18;;15331:122","source":"pragma solidity ^0.6.0;\\npragma experimental ABIEncoderV2;\\nimport \\"./TrackerRegistry.sol\\";\\nimport \\"./NodeRegistry.sol\\";\\n\\ncontract SimpleTrackerRegistry is TrackerRegistry, NodeRegistry{\\n\\n    constructor(address owner, bool requiresWhitelist_) NodeRegistry(owner, requiresWhitelist_) public {}\\n\\n    function getTrackers(string memory streamId, uint partition) public override view returns (string[] memory) {\\n        bytes32 hash = keccak256(abi.encode(streamId, partition));\\n        uint nodeNum = uint256(hash) % nodeCount;\\n        string[] memory trackers = new string[](1);\\n        trackers[0] = getNodeByNumber(nodeNum).url;\\n        return trackers;\\n    }\\n}\\n","sourcePath":"/home/heynow/streamr/network-contracts/contracts/SimpleTrackerRegistry.sol","ast":{"absolutePath":"/home/heynow/streamr/network-contracts/contracts/SimpleTrackerRegistry.sol","exportedSymbols":{"SimpleTrackerRegistry":[897]},"id":898,"nodeType":"SourceUnit","nodes":[{"id":824,"literals":["solidity","^","0.6",".0"],"nodeType":"PragmaDirective","src":"0:23:6"},{"id":825,"literals":["experimental","ABIEncoderV2"],"nodeType":"PragmaDirective","src":"24:33:6"},{"absolutePath":"/home/heynow/streamr/network-contracts/contracts/TrackerRegistry.sol","file":"./TrackerRegistry.sol","id":826,"nodeType":"ImportDirective","scope":898,"sourceUnit":947,"src":"58:31:6","symbolAliases":[],"unitAlias":""},{"absolutePath":"/home/heynow/streamr/network-contracts/contracts/NodeRegistry.sol","file":"./NodeRegistry.sol","id":827,"nodeType":"ImportDirective","scope":898,"sourceUnit":743,"src":"90:28:6","symbolAliases":[],"unitAlias":""},{"abstract":false,"baseContracts":[{"arguments":null,"baseName":{"contractScope":null,"id":828,"name":"TrackerRegistry","nodeType":"UserDefinedTypeName","referencedDeclaration":946,"src":"154:15:6","typeDescriptions":{"typeIdentifier":"t_contract$_TrackerRegistry_$946","typeString":"contract TrackerRegistry"}},"id":829,"nodeType":"InheritanceSpecifier","src":"154:15:6"},{"arguments":null,"baseName":{"contractScope":null,"id":830,"name":"NodeRegistry","nodeType":"UserDefinedTypeName","referencedDeclaration":742,"src":"171:12:6","typeDescriptions":{"typeIdentifier":"t_contract$_NodeRegistry_$742","typeString":"contract NodeRegistry"}},"id":831,"nodeType":"InheritanceSpecifier","src":"171:12:6"}],"contractDependencies":[742,822,946],"contractKind":"contract","documentation":null,"fullyImplemented":true,"id":897,"linearizedBaseContracts":[897,742,822,946],"name":"SimpleTrackerRegistry","nodeType":"ContractDefinition","nodes":[{"body":{"id":842,"nodeType":"Block","src":"289:2:6","statements":[]},"documentation":null,"id":843,"implemented":true,"kind":"constructor","modifiers":[{"arguments":[{"argumentTypes":null,"id":838,"name":"owner","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":833,"src":"255:5:6","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"}},{"argumentTypes":null,"id":839,"name":"requiresWhitelist_","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":835,"src":"262:18:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}}],"id":840,"modifierName":{"argumentTypes":null,"id":837,"name":"NodeRegistry","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":742,"src":"242:12:6","typeDescriptions":{"typeIdentifier":"t_type$_t_contract$_NodeRegistry_$742_$","typeString":"type(contract NodeRegistry)"}},"nodeType":"ModifierInvocation","src":"242:39:6"}],"name":"","nodeType":"FunctionDefinition","overrides":null,"parameters":{"id":836,"nodeType":"ParameterList","parameters":[{"constant":false,"id":833,"mutability":"mutable","name":"owner","nodeType":"VariableDeclaration","overrides":null,"scope":843,"src":"202:13:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"},"typeName":{"id":832,"name":"address","nodeType":"ElementaryTypeName","src":"202:7:6","stateMutability":"nonpayable","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"}},"value":null,"visibility":"internal"},{"constant":false,"id":835,"mutability":"mutable","name":"requiresWhitelist_","nodeType":"VariableDeclaration","overrides":null,"scope":843,"src":"217:23:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"typeName":{"id":834,"name":"bool","nodeType":"ElementaryTypeName","src":"217:4:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"value":null,"visibility":"internal"}],"src":"201:40:6"},"returnParameters":{"id":841,"nodeType":"ParameterList","parameters":[],"src":"289:0:6"},"scope":897,"src":"190:101:6","stateMutability":"nonpayable","virtual":false,"visibility":"public"},{"baseFunctions":[945],"body":{"id":895,"nodeType":"Block","src":"405:253:6","statements":[{"assignments":[855],"declarations":[{"constant":false,"id":855,"mutability":"mutable","name":"hash","nodeType":"VariableDeclaration","overrides":null,"scope":895,"src":"415:12:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_bytes32","typeString":"bytes32"},"typeName":{"id":854,"name":"bytes32","nodeType":"ElementaryTypeName","src":"415:7:6","typeDescriptions":{"typeIdentifier":"t_bytes32","typeString":"bytes32"}},"value":null,"visibility":"internal"}],"id":863,"initialValue":{"argumentTypes":null,"arguments":[{"argumentTypes":null,"arguments":[{"argumentTypes":null,"id":859,"name":"streamId","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":845,"src":"451:8:6","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string memory"}},{"argumentTypes":null,"id":860,"name":"partition","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":847,"src":"461:9:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_string_memory_ptr","typeString":"string memory"},{"typeIdentifier":"t_uint256","typeString":"uint256"}],"expression":{"argumentTypes":null,"id":857,"name":"abi","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":-1,"src":"440:3:6","typeDescriptions":{"typeIdentifier":"t_magic_abi","typeString":"abi"}},"id":858,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"memberName":"encode","nodeType":"MemberAccess","referencedDeclaration":null,"src":"440:10:6","typeDescriptions":{"typeIdentifier":"t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$","typeString":"function () pure returns (bytes memory)"}},"id":861,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"440:31:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_bytes_memory_ptr","typeString":"bytes memory"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bytes_memory_ptr","typeString":"bytes memory"}],"id":856,"name":"keccak256","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":-8,"src":"430:9:6","typeDescriptions":{"typeIdentifier":"t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$","typeString":"function (bytes memory) pure returns (bytes32)"}},"id":862,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"430:42:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_bytes32","typeString":"bytes32"}},"nodeType":"VariableDeclarationStatement","src":"415:57:6"},{"assignments":[865],"declarations":[{"constant":false,"id":865,"mutability":"mutable","name":"nodeNum","nodeType":"VariableDeclaration","overrides":null,"scope":895,"src":"482:12:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":864,"name":"uint","nodeType":"ElementaryTypeName","src":"482:4:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"value":null,"visibility":"internal"}],"id":872,"initialValue":{"argumentTypes":null,"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":871,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"argumentTypes":null,"arguments":[{"argumentTypes":null,"id":868,"name":"hash","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":855,"src":"505:4:6","typeDescriptions":{"typeIdentifier":"t_bytes32","typeString":"bytes32"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bytes32","typeString":"bytes32"}],"id":867,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"nodeType":"ElementaryTypeNameExpression","src":"497:7:6","typeDescriptions":{"typeIdentifier":"t_type$_t_uint256_$","typeString":"type(uint256)"},"typeName":{"id":866,"name":"uint256","nodeType":"ElementaryTypeName","src":"497:7:6","typeDescriptions":{"typeIdentifier":null,"typeString":null}}},"id":869,"isConstant":false,"isLValue":false,"isPure":false,"kind":"typeConversion","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"497:13:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":"%","rightExpression":{"argumentTypes":null,"id":870,"name":"nodeCount","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":245,"src":"513:9:6","typeDescriptions":{"typeIdentifier":"t_uint64","typeString":"uint64"}},"src":"497:25:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"VariableDeclarationStatement","src":"482:40:6"},{"assignments":[877],"declarations":[{"constant":false,"id":877,"mutability":"mutable","name":"trackers","nodeType":"VariableDeclaration","overrides":null,"scope":895,"src":"532:24:6","stateVariable":false,"storageLocation":"memory","typeDescriptions":{"typeIdentifier":"t_array$_t_string_memory_ptr_$dyn_memory_ptr","typeString":"string[]"},"typeName":{"baseType":{"id":875,"name":"string","nodeType":"ElementaryTypeName","src":"532:6:6","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"id":876,"length":null,"nodeType":"ArrayTypeName","src":"532:8:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_storage_$dyn_storage_ptr","typeString":"string[]"}},"value":null,"visibility":"internal"}],"id":883,"initialValue":{"argumentTypes":null,"arguments":[{"argumentTypes":null,"hexValue":"31","id":881,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"572:1:6","subdenomination":null,"typeDescriptions":{"typeIdentifier":"t_rational_1_by_1","typeString":"int_const 1"},"value":"1"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_rational_1_by_1","typeString":"int_const 1"}],"id":880,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"nodeType":"NewExpression","src":"559:12:6","typeDescriptions":{"typeIdentifier":"t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$","typeString":"function (uint256) pure returns (string memory[] memory)"},"typeName":{"baseType":{"id":878,"name":"string","nodeType":"ElementaryTypeName","src":"563:6:6","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"id":879,"length":null,"nodeType":"ArrayTypeName","src":"563:8:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_storage_$dyn_storage_ptr","typeString":"string[]"}}},"id":882,"isConstant":false,"isLValue":false,"isPure":true,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"559:15:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_array$_t_string_memory_ptr_$dyn_memory_ptr","typeString":"string memory[] memory"}},"nodeType":"VariableDeclarationStatement","src":"532:42:6"},{"expression":{"argumentTypes":null,"id":891,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftHandSide":{"argumentTypes":null,"baseExpression":{"argumentTypes":null,"id":884,"name":"trackers","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":877,"src":"584:8:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_memory_ptr_$dyn_memory_ptr","typeString":"string memory[] memory"}},"id":886,"indexExpression":{"argumentTypes":null,"hexValue":"30","id":885,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"593:1:6","subdenomination":null,"typeDescriptions":{"typeIdentifier":"t_rational_0_by_1","typeString":"int_const 0"},"value":"0"},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":true,"nodeType":"IndexAccess","src":"584:11:6","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string memory"}},"nodeType":"Assignment","operator":"=","rightHandSide":{"argumentTypes":null,"expression":{"argumentTypes":null,"arguments":[{"argumentTypes":null,"id":888,"name":"nodeNum","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":865,"src":"614:7:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_uint256","typeString":"uint256"}],"id":887,"name":"getNodeByNumber","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":688,"src":"598:15:6","typeDescriptions":{"typeIdentifier":"t_function_internal_view$_t_uint256_$returns$_t_struct$_Node_$218_memory_ptr_$","typeString":"function (uint256) view returns (struct NodeRegistry.Node memory)"}},"id":889,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"598:24:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_struct$_Node_$218_memory_ptr","typeString":"struct NodeRegistry.Node memory"}},"id":890,"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"memberName":"url","nodeType":"MemberAccess","referencedDeclaration":215,"src":"598:28:6","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string memory"}},"src":"584:42:6","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string memory"}},"id":892,"nodeType":"ExpressionStatement","src":"584:42:6"},{"expression":{"argumentTypes":null,"id":893,"name":"trackers","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":877,"src":"643:8:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_memory_ptr_$dyn_memory_ptr","typeString":"string memory[] memory"}},"functionReturnParameters":853,"id":894,"nodeType":"Return","src":"636:15:6"}]},"documentation":null,"functionSelector":"aacf5415","id":896,"implemented":true,"kind":"function","modifiers":[],"name":"getTrackers","nodeType":"FunctionDefinition","overrides":{"id":849,"nodeType":"OverrideSpecifier","overrides":[],"src":"365:8:6"},"parameters":{"id":848,"nodeType":"ParameterList","parameters":[{"constant":false,"id":845,"mutability":"mutable","name":"streamId","nodeType":"VariableDeclaration","overrides":null,"scope":896,"src":"318:22:6","stateVariable":false,"storageLocation":"memory","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string"},"typeName":{"id":844,"name":"string","nodeType":"ElementaryTypeName","src":"318:6:6","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"value":null,"visibility":"internal"},{"constant":false,"id":847,"mutability":"mutable","name":"partition","nodeType":"VariableDeclaration","overrides":null,"scope":896,"src":"342:14:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":846,"name":"uint","nodeType":"ElementaryTypeName","src":"342:4:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"value":null,"visibility":"internal"}],"src":"317:40:6"},"returnParameters":{"id":853,"nodeType":"ParameterList","parameters":[{"constant":false,"id":852,"mutability":"mutable","name":"","nodeType":"VariableDeclaration","overrides":null,"scope":896,"src":"388:15:6","stateVariable":false,"storageLocation":"memory","typeDescriptions":{"typeIdentifier":"t_array$_t_string_memory_ptr_$dyn_memory_ptr","typeString":"string[]"},"typeName":{"baseType":{"id":850,"name":"string","nodeType":"ElementaryTypeName","src":"388:6:6","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"id":851,"length":null,"nodeType":"ArrayTypeName","src":"388:8:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_storage_$dyn_storage_ptr","typeString":"string[]"}},"value":null,"visibility":"internal"}],"src":"387:17:6"},"scope":897,"src":"297:361:6","stateMutability":"view","virtual":false,"visibility":"public"}],"scope":898,"src":"120:540:6"}],"src":"0:661:6"},"legacyAST":{"absolutePath":"/home/heynow/streamr/network-contracts/contracts/SimpleTrackerRegistry.sol","exportedSymbols":{"SimpleTrackerRegistry":[897]},"id":898,"nodeType":"SourceUnit","nodes":[{"id":824,"literals":["solidity","^","0.6",".0"],"nodeType":"PragmaDirective","src":"0:23:6"},{"id":825,"literals":["experimental","ABIEncoderV2"],"nodeType":"PragmaDirective","src":"24:33:6"},{"absolutePath":"/home/heynow/streamr/network-contracts/contracts/TrackerRegistry.sol","file":"./TrackerRegistry.sol","id":826,"nodeType":"ImportDirective","scope":898,"sourceUnit":947,"src":"58:31:6","symbolAliases":[],"unitAlias":""},{"absolutePath":"/home/heynow/streamr/network-contracts/contracts/NodeRegistry.sol","file":"./NodeRegistry.sol","id":827,"nodeType":"ImportDirective","scope":898,"sourceUnit":743,"src":"90:28:6","symbolAliases":[],"unitAlias":""},{"abstract":false,"baseContracts":[{"arguments":null,"baseName":{"contractScope":null,"id":828,"name":"TrackerRegistry","nodeType":"UserDefinedTypeName","referencedDeclaration":946,"src":"154:15:6","typeDescriptions":{"typeIdentifier":"t_contract$_TrackerRegistry_$946","typeString":"contract TrackerRegistry"}},"id":829,"nodeType":"InheritanceSpecifier","src":"154:15:6"},{"arguments":null,"baseName":{"contractScope":null,"id":830,"name":"NodeRegistry","nodeType":"UserDefinedTypeName","referencedDeclaration":742,"src":"171:12:6","typeDescriptions":{"typeIdentifier":"t_contract$_NodeRegistry_$742","typeString":"contract NodeRegistry"}},"id":831,"nodeType":"InheritanceSpecifier","src":"171:12:6"}],"contractDependencies":[742,822,946],"contractKind":"contract","documentation":null,"fullyImplemented":true,"id":897,"linearizedBaseContracts":[897,742,822,946],"name":"SimpleTrackerRegistry","nodeType":"ContractDefinition","nodes":[{"body":{"id":842,"nodeType":"Block","src":"289:2:6","statements":[]},"documentation":null,"id":843,"implemented":true,"kind":"constructor","modifiers":[{"arguments":[{"argumentTypes":null,"id":838,"name":"owner","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":833,"src":"255:5:6","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"}},{"argumentTypes":null,"id":839,"name":"requiresWhitelist_","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":835,"src":"262:18:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}}],"id":840,"modifierName":{"argumentTypes":null,"id":837,"name":"NodeRegistry","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":742,"src":"242:12:6","typeDescriptions":{"typeIdentifier":"t_type$_t_contract$_NodeRegistry_$742_$","typeString":"type(contract NodeRegistry)"}},"nodeType":"ModifierInvocation","src":"242:39:6"}],"name":"","nodeType":"FunctionDefinition","overrides":null,"parameters":{"id":836,"nodeType":"ParameterList","parameters":[{"constant":false,"id":833,"mutability":"mutable","name":"owner","nodeType":"VariableDeclaration","overrides":null,"scope":843,"src":"202:13:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"},"typeName":{"id":832,"name":"address","nodeType":"ElementaryTypeName","src":"202:7:6","stateMutability":"nonpayable","typeDescriptions":{"typeIdentifier":"t_address","typeString":"address"}},"value":null,"visibility":"internal"},{"constant":false,"id":835,"mutability":"mutable","name":"requiresWhitelist_","nodeType":"VariableDeclaration","overrides":null,"scope":843,"src":"217:23:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"},"typeName":{"id":834,"name":"bool","nodeType":"ElementaryTypeName","src":"217:4:6","typeDescriptions":{"typeIdentifier":"t_bool","typeString":"bool"}},"value":null,"visibility":"internal"}],"src":"201:40:6"},"returnParameters":{"id":841,"nodeType":"ParameterList","parameters":[],"src":"289:0:6"},"scope":897,"src":"190:101:6","stateMutability":"nonpayable","virtual":false,"visibility":"public"},{"baseFunctions":[945],"body":{"id":895,"nodeType":"Block","src":"405:253:6","statements":[{"assignments":[855],"declarations":[{"constant":false,"id":855,"mutability":"mutable","name":"hash","nodeType":"VariableDeclaration","overrides":null,"scope":895,"src":"415:12:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_bytes32","typeString":"bytes32"},"typeName":{"id":854,"name":"bytes32","nodeType":"ElementaryTypeName","src":"415:7:6","typeDescriptions":{"typeIdentifier":"t_bytes32","typeString":"bytes32"}},"value":null,"visibility":"internal"}],"id":863,"initialValue":{"argumentTypes":null,"arguments":[{"argumentTypes":null,"arguments":[{"argumentTypes":null,"id":859,"name":"streamId","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":845,"src":"451:8:6","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string memory"}},{"argumentTypes":null,"id":860,"name":"partition","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":847,"src":"461:9:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_string_memory_ptr","typeString":"string memory"},{"typeIdentifier":"t_uint256","typeString":"uint256"}],"expression":{"argumentTypes":null,"id":857,"name":"abi","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":-1,"src":"440:3:6","typeDescriptions":{"typeIdentifier":"t_magic_abi","typeString":"abi"}},"id":858,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"memberName":"encode","nodeType":"MemberAccess","referencedDeclaration":null,"src":"440:10:6","typeDescriptions":{"typeIdentifier":"t_function_abiencode_pure$__$returns$_t_bytes_memory_ptr_$","typeString":"function () pure returns (bytes memory)"}},"id":861,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"440:31:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_bytes_memory_ptr","typeString":"bytes memory"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bytes_memory_ptr","typeString":"bytes memory"}],"id":856,"name":"keccak256","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":-8,"src":"430:9:6","typeDescriptions":{"typeIdentifier":"t_function_keccak256_pure$_t_bytes_memory_ptr_$returns$_t_bytes32_$","typeString":"function (bytes memory) pure returns (bytes32)"}},"id":862,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"430:42:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_bytes32","typeString":"bytes32"}},"nodeType":"VariableDeclarationStatement","src":"415:57:6"},{"assignments":[865],"declarations":[{"constant":false,"id":865,"mutability":"mutable","name":"nodeNum","nodeType":"VariableDeclaration","overrides":null,"scope":895,"src":"482:12:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":864,"name":"uint","nodeType":"ElementaryTypeName","src":"482:4:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"value":null,"visibility":"internal"}],"id":872,"initialValue":{"argumentTypes":null,"commonType":{"typeIdentifier":"t_uint256","typeString":"uint256"},"id":871,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftExpression":{"argumentTypes":null,"arguments":[{"argumentTypes":null,"id":868,"name":"hash","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":855,"src":"505:4:6","typeDescriptions":{"typeIdentifier":"t_bytes32","typeString":"bytes32"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_bytes32","typeString":"bytes32"}],"id":867,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"nodeType":"ElementaryTypeNameExpression","src":"497:7:6","typeDescriptions":{"typeIdentifier":"t_type$_t_uint256_$","typeString":"type(uint256)"},"typeName":{"id":866,"name":"uint256","nodeType":"ElementaryTypeName","src":"497:7:6","typeDescriptions":{"typeIdentifier":null,"typeString":null}}},"id":869,"isConstant":false,"isLValue":false,"isPure":false,"kind":"typeConversion","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"497:13:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"BinaryOperation","operator":"%","rightExpression":{"argumentTypes":null,"id":870,"name":"nodeCount","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":245,"src":"513:9:6","typeDescriptions":{"typeIdentifier":"t_uint64","typeString":"uint64"}},"src":"497:25:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"nodeType":"VariableDeclarationStatement","src":"482:40:6"},{"assignments":[877],"declarations":[{"constant":false,"id":877,"mutability":"mutable","name":"trackers","nodeType":"VariableDeclaration","overrides":null,"scope":895,"src":"532:24:6","stateVariable":false,"storageLocation":"memory","typeDescriptions":{"typeIdentifier":"t_array$_t_string_memory_ptr_$dyn_memory_ptr","typeString":"string[]"},"typeName":{"baseType":{"id":875,"name":"string","nodeType":"ElementaryTypeName","src":"532:6:6","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"id":876,"length":null,"nodeType":"ArrayTypeName","src":"532:8:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_storage_$dyn_storage_ptr","typeString":"string[]"}},"value":null,"visibility":"internal"}],"id":883,"initialValue":{"argumentTypes":null,"arguments":[{"argumentTypes":null,"hexValue":"31","id":881,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"572:1:6","subdenomination":null,"typeDescriptions":{"typeIdentifier":"t_rational_1_by_1","typeString":"int_const 1"},"value":"1"}],"expression":{"argumentTypes":[{"typeIdentifier":"t_rational_1_by_1","typeString":"int_const 1"}],"id":880,"isConstant":false,"isLValue":false,"isPure":true,"lValueRequested":false,"nodeType":"NewExpression","src":"559:12:6","typeDescriptions":{"typeIdentifier":"t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_string_memory_ptr_$dyn_memory_ptr_$","typeString":"function (uint256) pure returns (string memory[] memory)"},"typeName":{"baseType":{"id":878,"name":"string","nodeType":"ElementaryTypeName","src":"563:6:6","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"id":879,"length":null,"nodeType":"ArrayTypeName","src":"563:8:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_storage_$dyn_storage_ptr","typeString":"string[]"}}},"id":882,"isConstant":false,"isLValue":false,"isPure":true,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"559:15:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_array$_t_string_memory_ptr_$dyn_memory_ptr","typeString":"string memory[] memory"}},"nodeType":"VariableDeclarationStatement","src":"532:42:6"},{"expression":{"argumentTypes":null,"id":891,"isConstant":false,"isLValue":false,"isPure":false,"lValueRequested":false,"leftHandSide":{"argumentTypes":null,"baseExpression":{"argumentTypes":null,"id":884,"name":"trackers","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":877,"src":"584:8:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_memory_ptr_$dyn_memory_ptr","typeString":"string memory[] memory"}},"id":886,"indexExpression":{"argumentTypes":null,"hexValue":"30","id":885,"isConstant":false,"isLValue":false,"isPure":true,"kind":"number","lValueRequested":false,"nodeType":"Literal","src":"593:1:6","subdenomination":null,"typeDescriptions":{"typeIdentifier":"t_rational_0_by_1","typeString":"int_const 0"},"value":"0"},"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":true,"nodeType":"IndexAccess","src":"584:11:6","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string memory"}},"nodeType":"Assignment","operator":"=","rightHandSide":{"argumentTypes":null,"expression":{"argumentTypes":null,"arguments":[{"argumentTypes":null,"id":888,"name":"nodeNum","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":865,"src":"614:7:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}}],"expression":{"argumentTypes":[{"typeIdentifier":"t_uint256","typeString":"uint256"}],"id":887,"name":"getNodeByNumber","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":688,"src":"598:15:6","typeDescriptions":{"typeIdentifier":"t_function_internal_view$_t_uint256_$returns$_t_struct$_Node_$218_memory_ptr_$","typeString":"function (uint256) view returns (struct NodeRegistry.Node memory)"}},"id":889,"isConstant":false,"isLValue":false,"isPure":false,"kind":"functionCall","lValueRequested":false,"names":[],"nodeType":"FunctionCall","src":"598:24:6","tryCall":false,"typeDescriptions":{"typeIdentifier":"t_struct$_Node_$218_memory_ptr","typeString":"struct NodeRegistry.Node memory"}},"id":890,"isConstant":false,"isLValue":true,"isPure":false,"lValueRequested":false,"memberName":"url","nodeType":"MemberAccess","referencedDeclaration":215,"src":"598:28:6","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string memory"}},"src":"584:42:6","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string memory"}},"id":892,"nodeType":"ExpressionStatement","src":"584:42:6"},{"expression":{"argumentTypes":null,"id":893,"name":"trackers","nodeType":"Identifier","overloadedDeclarations":[],"referencedDeclaration":877,"src":"643:8:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_memory_ptr_$dyn_memory_ptr","typeString":"string memory[] memory"}},"functionReturnParameters":853,"id":894,"nodeType":"Return","src":"636:15:6"}]},"documentation":null,"functionSelector":"aacf5415","id":896,"implemented":true,"kind":"function","modifiers":[],"name":"getTrackers","nodeType":"FunctionDefinition","overrides":{"id":849,"nodeType":"OverrideSpecifier","overrides":[],"src":"365:8:6"},"parameters":{"id":848,"nodeType":"ParameterList","parameters":[{"constant":false,"id":845,"mutability":"mutable","name":"streamId","nodeType":"VariableDeclaration","overrides":null,"scope":896,"src":"318:22:6","stateVariable":false,"storageLocation":"memory","typeDescriptions":{"typeIdentifier":"t_string_memory_ptr","typeString":"string"},"typeName":{"id":844,"name":"string","nodeType":"ElementaryTypeName","src":"318:6:6","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"value":null,"visibility":"internal"},{"constant":false,"id":847,"mutability":"mutable","name":"partition","nodeType":"VariableDeclaration","overrides":null,"scope":896,"src":"342:14:6","stateVariable":false,"storageLocation":"default","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"},"typeName":{"id":846,"name":"uint","nodeType":"ElementaryTypeName","src":"342:4:6","typeDescriptions":{"typeIdentifier":"t_uint256","typeString":"uint256"}},"value":null,"visibility":"internal"}],"src":"317:40:6"},"returnParameters":{"id":853,"nodeType":"ParameterList","parameters":[{"constant":false,"id":852,"mutability":"mutable","name":"","nodeType":"VariableDeclaration","overrides":null,"scope":896,"src":"388:15:6","stateVariable":false,"storageLocation":"memory","typeDescriptions":{"typeIdentifier":"t_array$_t_string_memory_ptr_$dyn_memory_ptr","typeString":"string[]"},"typeName":{"baseType":{"id":850,"name":"string","nodeType":"ElementaryTypeName","src":"388:6:6","typeDescriptions":{"typeIdentifier":"t_string_storage_ptr","typeString":"string"}},"id":851,"length":null,"nodeType":"ArrayTypeName","src":"388:8:6","typeDescriptions":{"typeIdentifier":"t_array$_t_string_storage_$dyn_storage_ptr","typeString":"string[]"}},"value":null,"visibility":"internal"}],"src":"387:17:6"},"scope":897,"src":"297:361:6","stateMutability":"view","virtual":false,"visibility":"public"}],"scope":898,"src":"120:540:6"}],"src":"0:661:6"},"compiler":{"name":"solc","version":"0.6.6+commit.6c089d02.Emscripten.clang"},"networks":{},"schemaVersion":"3.1.0","updatedAt":"2020-04-28T10:04:14.295Z","devdoc":{"methods":{"claimOwnership()":{"details":"Allows the pendingOwner address to finalize the transfer."},"transferOwnership(address)":{"details":"Allows the current owner to set the pendingOwner address.","params":{"newOwner":"The address to transfer ownership to."}}}},"userdoc":{"methods":{}}}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd options */
/******/ 	(() => {
/******/ 		__webpack_require__.amdO = {};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/exports-browser.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=streamr-client.web.js.map